
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired699"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired699"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cVAsd", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $969715edf756f01a$export$ffb0004e005737fa; }, function (v) { return $969715edf756f01a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $969715edf756f01a$export$34b9dba7ce09269b; }, function (v) { return $969715edf756f01a$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $969715edf756f01a$export$25062201e9e25d76; }, function (v) { return $969715edf756f01a$export$25062201e9e25d76 = v; });
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $969715edf756f01a$export$ffb0004e005737fa;
var $969715edf756f01a$export$34b9dba7ce09269b;
var $969715edf756f01a$export$25062201e9e25d76;
'use strict';

var $a5EUy = parcelRequire("a5EUy");
var $969715edf756f01a$var$g = 60103;
$969715edf756f01a$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $969715edf756f01a$var$h = Symbol.for;
    $969715edf756f01a$var$g = $969715edf756f01a$var$h("react.element");
    $969715edf756f01a$export$ffb0004e005737fa = $969715edf756f01a$var$h("react.fragment");
}
var $969715edf756f01a$var$m = $a5EUy.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $969715edf756f01a$var$n = Object.prototype.hasOwnProperty, $969715edf756f01a$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $969715edf756f01a$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$969715edf756f01a$var$n.call(a, b) && !$969715edf756f01a$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $969715edf756f01a$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $969715edf756f01a$var$m.current
    };
}
$969715edf756f01a$export$34b9dba7ce09269b = $969715edf756f01a$var$q;
$969715edf756f01a$export$25062201e9e25d76 = $969715edf756f01a$var$q;

});
parcelRegister("a5EUy", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ejcGu"));

});
parcelRegister("ejcGu", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $a6acaddf6f112772$export$dca3b0875bd9a954; }, function (v) { return $a6acaddf6f112772$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $a6acaddf6f112772$export$16fa2f45be04daa8; }, function (v) { return $a6acaddf6f112772$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $a6acaddf6f112772$export$ffb0004e005737fa; }, function (v) { return $a6acaddf6f112772$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $a6acaddf6f112772$export$e2c29f18771995cb; }, function (v) { return $a6acaddf6f112772$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $a6acaddf6f112772$export$221d75b3f55bb0bd; }, function (v) { return $a6acaddf6f112772$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $a6acaddf6f112772$export$5f8d39834fd61797; }, function (v) { return $a6acaddf6f112772$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $a6acaddf6f112772$export$74bf444e3cd11ea5; }, function (v) { return $a6acaddf6f112772$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $a6acaddf6f112772$export$ae55be85d98224ed; }, function (v) { return $a6acaddf6f112772$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $a6acaddf6f112772$export$e530037191fcd5d7; }, function (v) { return $a6acaddf6f112772$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $a6acaddf6f112772$export$fd42f52fd3ae1109; }, function (v) { return $a6acaddf6f112772$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $a6acaddf6f112772$export$c8a8987d4410bf2d; }, function (v) { return $a6acaddf6f112772$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $a6acaddf6f112772$export$d38cd72104c1f0e9; }, function (v) { return $a6acaddf6f112772$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $a6acaddf6f112772$export$7d1e3a5e95ceca43; }, function (v) { return $a6acaddf6f112772$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $a6acaddf6f112772$export$257a8862b851cb5b; }, function (v) { return $a6acaddf6f112772$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $a6acaddf6f112772$export$a8257692ac88316c; }, function (v) { return $a6acaddf6f112772$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $a6acaddf6f112772$export$488013bae63b21da; }, function (v) { return $a6acaddf6f112772$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $a6acaddf6f112772$export$7c73462e0d25e514; }, function (v) { return $a6acaddf6f112772$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $a6acaddf6f112772$export$35808ee640e87ca7; }, function (v) { return $a6acaddf6f112772$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $a6acaddf6f112772$export$fae74005e78b1a27; }, function (v) { return $a6acaddf6f112772$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $a6acaddf6f112772$export$dc8fbce3eb94dc1e; }, function (v) { return $a6acaddf6f112772$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $a6acaddf6f112772$export$6d9c69b0de29b591; }, function (v) { return $a6acaddf6f112772$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $a6acaddf6f112772$export$d5a552a76deda3c2; }, function (v) { return $a6acaddf6f112772$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $a6acaddf6f112772$export$e5c5a5f917a5871c; }, function (v) { return $a6acaddf6f112772$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $a6acaddf6f112772$export$1538c33de8887b59; }, function (v) { return $a6acaddf6f112772$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $a6acaddf6f112772$export$13e3392192263954; }, function (v) { return $a6acaddf6f112772$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $a6acaddf6f112772$export$b8f5890fc79d6aca; }, function (v) { return $a6acaddf6f112772$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $a6acaddf6f112772$export$60241385465d0a34; }, function (v) { return $a6acaddf6f112772$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $a6acaddf6f112772$export$83d89fbfd8236492; }, function (v) { return $a6acaddf6f112772$export$83d89fbfd8236492 = v; });
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a6acaddf6f112772$export$dca3b0875bd9a954;
var $a6acaddf6f112772$export$16fa2f45be04daa8;
var $a6acaddf6f112772$export$ffb0004e005737fa;
var $a6acaddf6f112772$export$e2c29f18771995cb;
var $a6acaddf6f112772$export$221d75b3f55bb0bd;
var $a6acaddf6f112772$export$5f8d39834fd61797;
var $a6acaddf6f112772$export$74bf444e3cd11ea5;
var $a6acaddf6f112772$export$ae55be85d98224ed;
var $a6acaddf6f112772$export$e530037191fcd5d7;
var $a6acaddf6f112772$export$fd42f52fd3ae1109;
var $a6acaddf6f112772$export$c8a8987d4410bf2d;
var $a6acaddf6f112772$export$d38cd72104c1f0e9;
var $a6acaddf6f112772$export$7d1e3a5e95ceca43;
var $a6acaddf6f112772$export$257a8862b851cb5b;
var $a6acaddf6f112772$export$a8257692ac88316c;
var $a6acaddf6f112772$export$488013bae63b21da;
var $a6acaddf6f112772$export$7c73462e0d25e514;
var $a6acaddf6f112772$export$35808ee640e87ca7;
var $a6acaddf6f112772$export$fae74005e78b1a27;
var $a6acaddf6f112772$export$dc8fbce3eb94dc1e;
var $a6acaddf6f112772$export$6d9c69b0de29b591;
var $a6acaddf6f112772$export$d5a552a76deda3c2;
var $a6acaddf6f112772$export$e5c5a5f917a5871c;
var $a6acaddf6f112772$export$1538c33de8887b59;
var $a6acaddf6f112772$export$13e3392192263954;
var $a6acaddf6f112772$export$b8f5890fc79d6aca;
var $a6acaddf6f112772$export$60241385465d0a34;
var $a6acaddf6f112772$export$83d89fbfd8236492;
'use strict';

var $9mzVh = parcelRequire("9mzVh");
var $a6acaddf6f112772$var$n = "function" === typeof Symbol && Symbol.for, $a6acaddf6f112772$var$p = $a6acaddf6f112772$var$n ? Symbol.for("react.element") : 60103, $a6acaddf6f112772$var$q = $a6acaddf6f112772$var$n ? Symbol.for("react.portal") : 60106, $a6acaddf6f112772$var$r = $a6acaddf6f112772$var$n ? Symbol.for("react.fragment") : 60107, $a6acaddf6f112772$var$t = $a6acaddf6f112772$var$n ? Symbol.for("react.strict_mode") : 60108, $a6acaddf6f112772$var$u = $a6acaddf6f112772$var$n ? Symbol.for("react.profiler") : 60114, $a6acaddf6f112772$var$v = $a6acaddf6f112772$var$n ? Symbol.for("react.provider") : 60109, $a6acaddf6f112772$var$w = $a6acaddf6f112772$var$n ? Symbol.for("react.context") : 60110, $a6acaddf6f112772$var$x = $a6acaddf6f112772$var$n ? Symbol.for("react.forward_ref") : 60112, $a6acaddf6f112772$var$y = $a6acaddf6f112772$var$n ? Symbol.for("react.suspense") : 60113, $a6acaddf6f112772$var$z = $a6acaddf6f112772$var$n ? Symbol.for("react.memo") : 60115, $a6acaddf6f112772$var$A = $a6acaddf6f112772$var$n ? Symbol.for("react.lazy") : 60116, $a6acaddf6f112772$var$B = "function" === typeof Symbol && Symbol.iterator;
function $a6acaddf6f112772$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $a6acaddf6f112772$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $a6acaddf6f112772$var$E = {};
function $a6acaddf6f112772$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $a6acaddf6f112772$var$E;
    this.updater = c || $a6acaddf6f112772$var$D;
}
$a6acaddf6f112772$var$F.prototype.isReactComponent = {};
$a6acaddf6f112772$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($a6acaddf6f112772$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$a6acaddf6f112772$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $a6acaddf6f112772$var$G() {}
$a6acaddf6f112772$var$G.prototype = $a6acaddf6f112772$var$F.prototype;
function $a6acaddf6f112772$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $a6acaddf6f112772$var$E;
    this.updater = c || $a6acaddf6f112772$var$D;
}
var $a6acaddf6f112772$var$I = $a6acaddf6f112772$var$H.prototype = new $a6acaddf6f112772$var$G;
$a6acaddf6f112772$var$I.constructor = $a6acaddf6f112772$var$H;
$9mzVh($a6acaddf6f112772$var$I, $a6acaddf6f112772$var$F.prototype);
$a6acaddf6f112772$var$I.isPureReactComponent = !0;
var $a6acaddf6f112772$var$J = {
    current: null
}, $a6acaddf6f112772$var$K = Object.prototype.hasOwnProperty, $a6acaddf6f112772$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $a6acaddf6f112772$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$a6acaddf6f112772$var$K.call(b, e) && !$a6acaddf6f112772$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $a6acaddf6f112772$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $a6acaddf6f112772$var$J.current
    };
}
function $a6acaddf6f112772$var$N(a, b) {
    return {
        $$typeof: $a6acaddf6f112772$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $a6acaddf6f112772$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a6acaddf6f112772$var$p;
}
function $a6acaddf6f112772$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $a6acaddf6f112772$var$P = /\/+/g, $a6acaddf6f112772$var$Q = [];
function $a6acaddf6f112772$var$R(a, b, c, e) {
    if ($a6acaddf6f112772$var$Q.length) {
        var d = $a6acaddf6f112772$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $a6acaddf6f112772$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $a6acaddf6f112772$var$Q.length && $a6acaddf6f112772$var$Q.push(a);
}
function $a6acaddf6f112772$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $a6acaddf6f112772$var$p:
                case $a6acaddf6f112772$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $a6acaddf6f112772$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $a6acaddf6f112772$var$U(d, k);
        g += $a6acaddf6f112772$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $a6acaddf6f112772$var$B && a[$a6acaddf6f112772$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $a6acaddf6f112772$var$U(d, k++), g += $a6acaddf6f112772$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($a6acaddf6f112772$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $a6acaddf6f112772$var$V(a, b, c) {
    return null == a ? 0 : $a6acaddf6f112772$var$T(a, "", b, c);
}
function $a6acaddf6f112772$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $a6acaddf6f112772$var$escape(a.key) : b.toString(36);
}
function $a6acaddf6f112772$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $a6acaddf6f112772$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $a6acaddf6f112772$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($a6acaddf6f112772$var$O(a) && (a = $a6acaddf6f112772$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($a6acaddf6f112772$var$P, "$&/") + "/") + c)), e.push(a));
}
function $a6acaddf6f112772$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($a6acaddf6f112772$var$P, "$&/") + "/");
    b = $a6acaddf6f112772$var$R(b, g, e, d);
    $a6acaddf6f112772$var$V(a, $a6acaddf6f112772$var$aa, b);
    $a6acaddf6f112772$var$S(b);
}
var $a6acaddf6f112772$var$Y = {
    current: null
};
function $a6acaddf6f112772$var$Z() {
    var a = $a6acaddf6f112772$var$Y.current;
    if (null === a) throw Error($a6acaddf6f112772$var$C(321));
    return a;
}
var $a6acaddf6f112772$var$ba = {
    ReactCurrentDispatcher: $a6acaddf6f112772$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $a6acaddf6f112772$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $9mzVh
};
$a6acaddf6f112772$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $a6acaddf6f112772$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $a6acaddf6f112772$var$R(null, null, b, c);
        $a6acaddf6f112772$var$V(a, $a6acaddf6f112772$var$W, b);
        $a6acaddf6f112772$var$S(b);
    },
    count: function(a) {
        return $a6acaddf6f112772$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $a6acaddf6f112772$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$a6acaddf6f112772$var$O(a)) throw Error($a6acaddf6f112772$var$C(143));
        return a;
    }
};
$a6acaddf6f112772$export$16fa2f45be04daa8 = $a6acaddf6f112772$var$F;
$a6acaddf6f112772$export$ffb0004e005737fa = $a6acaddf6f112772$var$r;
$a6acaddf6f112772$export$e2c29f18771995cb = $a6acaddf6f112772$var$u;
$a6acaddf6f112772$export$221d75b3f55bb0bd = $a6acaddf6f112772$var$H;
$a6acaddf6f112772$export$5f8d39834fd61797 = $a6acaddf6f112772$var$t;
$a6acaddf6f112772$export$74bf444e3cd11ea5 = $a6acaddf6f112772$var$y;
$a6acaddf6f112772$export$ae55be85d98224ed = $a6acaddf6f112772$var$ba;
$a6acaddf6f112772$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($a6acaddf6f112772$var$C(267, a));
    var e = $9mzVh({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $a6acaddf6f112772$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$a6acaddf6f112772$var$K.call(b, h) && !$a6acaddf6f112772$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $a6acaddf6f112772$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$a6acaddf6f112772$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $a6acaddf6f112772$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $a6acaddf6f112772$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$a6acaddf6f112772$export$c8a8987d4410bf2d = $a6acaddf6f112772$var$M;
$a6acaddf6f112772$export$d38cd72104c1f0e9 = function(a) {
    var b = $a6acaddf6f112772$var$M.bind(null, a);
    b.type = a;
    return b;
};
$a6acaddf6f112772$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$a6acaddf6f112772$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $a6acaddf6f112772$var$x,
        render: a
    };
};
$a6acaddf6f112772$export$a8257692ac88316c = $a6acaddf6f112772$var$O;
$a6acaddf6f112772$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $a6acaddf6f112772$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$a6acaddf6f112772$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $a6acaddf6f112772$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$a6acaddf6f112772$export$35808ee640e87ca7 = function(a, b) {
    return $a6acaddf6f112772$var$Z().useCallback(a, b);
};
$a6acaddf6f112772$export$fae74005e78b1a27 = function(a, b) {
    return $a6acaddf6f112772$var$Z().useContext(a, b);
};
$a6acaddf6f112772$export$dc8fbce3eb94dc1e = function() {};
$a6acaddf6f112772$export$6d9c69b0de29b591 = function(a, b) {
    return $a6acaddf6f112772$var$Z().useEffect(a, b);
};
$a6acaddf6f112772$export$d5a552a76deda3c2 = function(a, b, c) {
    return $a6acaddf6f112772$var$Z().useImperativeHandle(a, b, c);
};
$a6acaddf6f112772$export$e5c5a5f917a5871c = function(a, b) {
    return $a6acaddf6f112772$var$Z().useLayoutEffect(a, b);
};
$a6acaddf6f112772$export$1538c33de8887b59 = function(a, b) {
    return $a6acaddf6f112772$var$Z().useMemo(a, b);
};
$a6acaddf6f112772$export$13e3392192263954 = function(a, b, c) {
    return $a6acaddf6f112772$var$Z().useReducer(a, b, c);
};
$a6acaddf6f112772$export$b8f5890fc79d6aca = function(a) {
    return $a6acaddf6f112772$var$Z().useRef(a);
};
$a6acaddf6f112772$export$60241385465d0a34 = function(a) {
    return $a6acaddf6f112772$var$Z().useState(a);
};
$a6acaddf6f112772$export$83d89fbfd8236492 = "16.14.0";

});
parcelRegister("9mzVh", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $6d1208a8a8cc94a0$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $6d1208a8a8cc94a0$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $6d1208a8a8cc94a0$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $6d1208a8a8cc94a0$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $6d1208a8a8cc94a0$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $6d1208a8a8cc94a0$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $6d1208a8a8cc94a0$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($6d1208a8a8cc94a0$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($6d1208a8a8cc94a0$var$getOwnPropertySymbols) {
            symbols = $6d1208a8a8cc94a0$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($6d1208a8a8cc94a0$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});




parcelRegister("7XZW9", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $5cce167ad88d170e$export$2b8d127b894957b9; }, function (v) { return $5cce167ad88d170e$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $5cce167ad88d170e$export$cea3a54a6425200c; }, function (v) { return $5cce167ad88d170e$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $5cce167ad88d170e$export$a7c73072b1a182ae; }, function (v) { return $5cce167ad88d170e$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $5cce167ad88d170e$export$9f27bc3417b4524d; }, function (v) { return $5cce167ad88d170e$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $5cce167ad88d170e$export$db77ccec0bb4ccac; }, function (v) { return $5cce167ad88d170e$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $5cce167ad88d170e$export$8392c0c9d3dcbd35; }, function (v) { return $5cce167ad88d170e$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $5cce167ad88d170e$export$ffb0004e005737fa; }, function (v) { return $5cce167ad88d170e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $5cce167ad88d170e$export$b624eff549462981; }, function (v) { return $5cce167ad88d170e$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $5cce167ad88d170e$export$7897aa7841a5380c; }, function (v) { return $5cce167ad88d170e$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $5cce167ad88d170e$export$602eac185826482c; }, function (v) { return $5cce167ad88d170e$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $5cce167ad88d170e$export$e2c29f18771995cb; }, function (v) { return $5cce167ad88d170e$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $5cce167ad88d170e$export$5f8d39834fd61797; }, function (v) { return $5cce167ad88d170e$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $5cce167ad88d170e$export$74bf444e3cd11ea5; }, function (v) { return $5cce167ad88d170e$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $5cce167ad88d170e$export$92387174baf9b227; }, function (v) { return $5cce167ad88d170e$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $5cce167ad88d170e$export$ec112efeb987d9c6; }, function (v) { return $5cce167ad88d170e$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $5cce167ad88d170e$export$b706b080d889d2c9; }, function (v) { return $5cce167ad88d170e$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $5cce167ad88d170e$export$5be5a87408f70ddc; }, function (v) { return $5cce167ad88d170e$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $5cce167ad88d170e$export$45a5e7f76e0caa8d; }, function (v) { return $5cce167ad88d170e$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $5cce167ad88d170e$export$455c2e768291efa6; }, function (v) { return $5cce167ad88d170e$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $5cce167ad88d170e$export$9522e17588c12572; }, function (v) { return $5cce167ad88d170e$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $5cce167ad88d170e$export$2110ac352bb060b9; }, function (v) { return $5cce167ad88d170e$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $5cce167ad88d170e$export$56885ab8b9c456ab; }, function (v) { return $5cce167ad88d170e$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $5cce167ad88d170e$export$d927fcb6adf8f9de; }, function (v) { return $5cce167ad88d170e$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $5cce167ad88d170e$export$b82d16f27459e05a; }, function (v) { return $5cce167ad88d170e$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $5cce167ad88d170e$export$522c17b4f5e123e8; }, function (v) { return $5cce167ad88d170e$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $5cce167ad88d170e$export$1aabd8a0274ecfd6; }, function (v) { return $5cce167ad88d170e$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $5cce167ad88d170e$export$9b621391a187a31a; }, function (v) { return $5cce167ad88d170e$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $5cce167ad88d170e$export$f5bbd400c2f4426f; }, function (v) { return $5cce167ad88d170e$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5cce167ad88d170e$export$2b8d127b894957b9;
var $5cce167ad88d170e$export$cea3a54a6425200c;
var $5cce167ad88d170e$export$a7c73072b1a182ae;
var $5cce167ad88d170e$export$9f27bc3417b4524d;
var $5cce167ad88d170e$export$db77ccec0bb4ccac;
var $5cce167ad88d170e$export$8392c0c9d3dcbd35;
var $5cce167ad88d170e$export$ffb0004e005737fa;
var $5cce167ad88d170e$export$b624eff549462981;
var $5cce167ad88d170e$export$7897aa7841a5380c;
var $5cce167ad88d170e$export$602eac185826482c;
var $5cce167ad88d170e$export$e2c29f18771995cb;
var $5cce167ad88d170e$export$5f8d39834fd61797;
var $5cce167ad88d170e$export$74bf444e3cd11ea5;
var $5cce167ad88d170e$export$92387174baf9b227;
var $5cce167ad88d170e$export$ec112efeb987d9c6;
var $5cce167ad88d170e$export$b706b080d889d2c9;
var $5cce167ad88d170e$export$5be5a87408f70ddc;
var $5cce167ad88d170e$export$45a5e7f76e0caa8d;
var $5cce167ad88d170e$export$455c2e768291efa6;
var $5cce167ad88d170e$export$9522e17588c12572;
var $5cce167ad88d170e$export$2110ac352bb060b9;
var $5cce167ad88d170e$export$56885ab8b9c456ab;
var $5cce167ad88d170e$export$d927fcb6adf8f9de;
var $5cce167ad88d170e$export$b82d16f27459e05a;
var $5cce167ad88d170e$export$522c17b4f5e123e8;
var $5cce167ad88d170e$export$1aabd8a0274ecfd6;
var $5cce167ad88d170e$export$9b621391a187a31a;
var $5cce167ad88d170e$export$f5bbd400c2f4426f;
'use strict';
var $5cce167ad88d170e$var$b = "function" === typeof Symbol && Symbol.for, $5cce167ad88d170e$var$c = $5cce167ad88d170e$var$b ? Symbol.for("react.element") : 60103, $5cce167ad88d170e$var$d = $5cce167ad88d170e$var$b ? Symbol.for("react.portal") : 60106, $5cce167ad88d170e$var$e = $5cce167ad88d170e$var$b ? Symbol.for("react.fragment") : 60107, $5cce167ad88d170e$var$f = $5cce167ad88d170e$var$b ? Symbol.for("react.strict_mode") : 60108, $5cce167ad88d170e$var$g = $5cce167ad88d170e$var$b ? Symbol.for("react.profiler") : 60114, $5cce167ad88d170e$var$h = $5cce167ad88d170e$var$b ? Symbol.for("react.provider") : 60109, $5cce167ad88d170e$var$k = $5cce167ad88d170e$var$b ? Symbol.for("react.context") : 60110, $5cce167ad88d170e$var$l = $5cce167ad88d170e$var$b ? Symbol.for("react.async_mode") : 60111, $5cce167ad88d170e$var$m = $5cce167ad88d170e$var$b ? Symbol.for("react.concurrent_mode") : 60111, $5cce167ad88d170e$var$n = $5cce167ad88d170e$var$b ? Symbol.for("react.forward_ref") : 60112, $5cce167ad88d170e$var$p = $5cce167ad88d170e$var$b ? Symbol.for("react.suspense") : 60113, $5cce167ad88d170e$var$q = $5cce167ad88d170e$var$b ? Symbol.for("react.suspense_list") : 60120, $5cce167ad88d170e$var$r = $5cce167ad88d170e$var$b ? Symbol.for("react.memo") : 60115, $5cce167ad88d170e$var$t = $5cce167ad88d170e$var$b ? Symbol.for("react.lazy") : 60116, $5cce167ad88d170e$var$v = $5cce167ad88d170e$var$b ? Symbol.for("react.block") : 60121, $5cce167ad88d170e$var$w = $5cce167ad88d170e$var$b ? Symbol.for("react.fundamental") : 60117, $5cce167ad88d170e$var$x = $5cce167ad88d170e$var$b ? Symbol.for("react.responder") : 60118, $5cce167ad88d170e$var$y = $5cce167ad88d170e$var$b ? Symbol.for("react.scope") : 60119;
function $5cce167ad88d170e$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $5cce167ad88d170e$var$c:
                switch(a = a.type, a){
                    case $5cce167ad88d170e$var$l:
                    case $5cce167ad88d170e$var$m:
                    case $5cce167ad88d170e$var$e:
                    case $5cce167ad88d170e$var$g:
                    case $5cce167ad88d170e$var$f:
                    case $5cce167ad88d170e$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $5cce167ad88d170e$var$k:
                            case $5cce167ad88d170e$var$n:
                            case $5cce167ad88d170e$var$t:
                            case $5cce167ad88d170e$var$r:
                            case $5cce167ad88d170e$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $5cce167ad88d170e$var$d:
                return u;
        }
    }
}
function $5cce167ad88d170e$var$A(a) {
    return $5cce167ad88d170e$var$z(a) === $5cce167ad88d170e$var$m;
}
$5cce167ad88d170e$export$2b8d127b894957b9 = $5cce167ad88d170e$var$l;
$5cce167ad88d170e$export$cea3a54a6425200c = $5cce167ad88d170e$var$m;
$5cce167ad88d170e$export$a7c73072b1a182ae = $5cce167ad88d170e$var$k;
$5cce167ad88d170e$export$9f27bc3417b4524d = $5cce167ad88d170e$var$h;
$5cce167ad88d170e$export$db77ccec0bb4ccac = $5cce167ad88d170e$var$c;
$5cce167ad88d170e$export$8392c0c9d3dcbd35 = $5cce167ad88d170e$var$n;
$5cce167ad88d170e$export$ffb0004e005737fa = $5cce167ad88d170e$var$e;
$5cce167ad88d170e$export$b624eff549462981 = $5cce167ad88d170e$var$t;
$5cce167ad88d170e$export$7897aa7841a5380c = $5cce167ad88d170e$var$r;
$5cce167ad88d170e$export$602eac185826482c = $5cce167ad88d170e$var$d;
$5cce167ad88d170e$export$e2c29f18771995cb = $5cce167ad88d170e$var$g;
$5cce167ad88d170e$export$5f8d39834fd61797 = $5cce167ad88d170e$var$f;
$5cce167ad88d170e$export$74bf444e3cd11ea5 = $5cce167ad88d170e$var$p;
$5cce167ad88d170e$export$92387174baf9b227 = function(a) {
    return $5cce167ad88d170e$var$A(a) || $5cce167ad88d170e$var$z(a) === $5cce167ad88d170e$var$l;
};
$5cce167ad88d170e$export$ec112efeb987d9c6 = $5cce167ad88d170e$var$A;
$5cce167ad88d170e$export$b706b080d889d2c9 = function(a) {
    return $5cce167ad88d170e$var$z(a) === $5cce167ad88d170e$var$k;
};
$5cce167ad88d170e$export$5be5a87408f70ddc = function(a) {
    return $5cce167ad88d170e$var$z(a) === $5cce167ad88d170e$var$h;
};
$5cce167ad88d170e$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $5cce167ad88d170e$var$c;
};
$5cce167ad88d170e$export$455c2e768291efa6 = function(a) {
    return $5cce167ad88d170e$var$z(a) === $5cce167ad88d170e$var$n;
};
$5cce167ad88d170e$export$9522e17588c12572 = function(a) {
    return $5cce167ad88d170e$var$z(a) === $5cce167ad88d170e$var$e;
};
$5cce167ad88d170e$export$2110ac352bb060b9 = function(a) {
    return $5cce167ad88d170e$var$z(a) === $5cce167ad88d170e$var$t;
};
$5cce167ad88d170e$export$56885ab8b9c456ab = function(a) {
    return $5cce167ad88d170e$var$z(a) === $5cce167ad88d170e$var$r;
};
$5cce167ad88d170e$export$d927fcb6adf8f9de = function(a) {
    return $5cce167ad88d170e$var$z(a) === $5cce167ad88d170e$var$d;
};
$5cce167ad88d170e$export$b82d16f27459e05a = function(a) {
    return $5cce167ad88d170e$var$z(a) === $5cce167ad88d170e$var$g;
};
$5cce167ad88d170e$export$522c17b4f5e123e8 = function(a) {
    return $5cce167ad88d170e$var$z(a) === $5cce167ad88d170e$var$f;
};
$5cce167ad88d170e$export$1aabd8a0274ecfd6 = function(a) {
    return $5cce167ad88d170e$var$z(a) === $5cce167ad88d170e$var$p;
};
$5cce167ad88d170e$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $5cce167ad88d170e$var$e || a === $5cce167ad88d170e$var$m || a === $5cce167ad88d170e$var$g || a === $5cce167ad88d170e$var$f || a === $5cce167ad88d170e$var$p || a === $5cce167ad88d170e$var$q || "object" === typeof a && null !== a && (a.$$typeof === $5cce167ad88d170e$var$t || a.$$typeof === $5cce167ad88d170e$var$r || a.$$typeof === $5cce167ad88d170e$var$h || a.$$typeof === $5cce167ad88d170e$var$k || a.$$typeof === $5cce167ad88d170e$var$n || a.$$typeof === $5cce167ad88d170e$var$w || a.$$typeof === $5cce167ad88d170e$var$x || a.$$typeof === $5cce167ad88d170e$var$y || a.$$typeof === $5cce167ad88d170e$var$v);
};
$5cce167ad88d170e$export$f5bbd400c2f4426f = $5cce167ad88d170e$var$z;

});

parcelRegister("1XnXK", function(module, exports) {
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $a5EUy = parcelRequire("a5EUy");

var $9mzVh = parcelRequire("9mzVh");

var $3O0bL = parcelRequire("3O0bL");
function u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$a5EUy) throw Error(u(227));
function ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var da = !1, ea = null, fa = !1, ha = null, ia = {
    onError: function(a) {
        da = !0;
        ea = a;
    }
};
function ja(a, b, c, d, e, f, g, h, k) {
    da = !1;
    ea = null;
    ba.apply(ia, arguments);
}
function ka(a, b, c, d, e, f, g, h, k) {
    ja.apply(this, arguments);
    if (da) {
        if (da) {
            var l = ea;
            da = !1;
            ea = null;
        } else throw Error(u(198));
        fa || (fa = !0, ha = l);
    }
}
var la = null, ma = null, na = null;
function oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = na(c);
    ka(d, b, void 0, a);
    a.currentTarget = null;
}
var pa = null, qa = {};
function ra() {
    if (pa) for(var a in qa){
        var b = qa[a], c = pa.indexOf(a);
        if (!(-1 < c)) throw Error(u(96, a));
        if (!sa[c]) {
            if (!b.extractEvents) throw Error(u(97, a));
            sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if (ta.hasOwnProperty(h)) throw Error(u(99, h));
                ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error(u(98, d, a));
            }
        }
    }
}
function ua(a, b, c) {
    if (va[a]) throw Error(u(100, a));
    va[a] = b;
    wa[a] = b.eventTypes[c].dependencies;
}
var sa = [], ta = {}, va = {}, wa = {};
function xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!qa.hasOwnProperty(c) || qa[c] !== d) {
            if (qa[c]) throw Error(u(102, c));
            qa[c] = d;
            b = !0;
        }
    }
    b && ra();
}
var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), za = null, Aa = null, Ba = null;
function Ca(a) {
    if (a = ma(a)) {
        if ("function" !== typeof za) throw Error(u(280));
        var b = a.stateNode;
        b && (b = la(b), za(a.stateNode, a.type, b));
    }
}
function Da(a) {
    Aa ? Ba ? Ba.push(a) : Ba = [
        a
    ] : Aa = a;
}
function Ea() {
    if (Aa) {
        var a = Aa, b = Ba;
        Ba = Aa = null;
        Ca(a);
        if (b) for(a = 0; a < b.length; a++)Ca(b[a]);
    }
}
function Fa(a, b) {
    return a(b);
}
function Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ha() {}
var Ia = Fa, Ja = !1, Ka = !1;
function La() {
    if (null !== Aa || null !== Ba) Ha(), Ea();
}
function Ma(a, b, c) {
    if (Ka) return a(b, c);
    Ka = !0;
    try {
        return Ia(a, b, c);
    } finally{
        Ka = !1, La();
    }
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Oa = Object.prototype.hasOwnProperty, Pa = {}, Qa = {};
function Ra(a) {
    if (Oa.call(Qa, a)) return !0;
    if (Oa.call(Pa, a)) return !1;
    if (Na.test(a)) return Qa[a] = !0;
    Pa[a] = !0;
    return !1;
}
function Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    C[a] = new v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    C[b] = new v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    C[a] = new v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    C[a] = new v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    C[a] = new v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    C[a] = new v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    C[a] = new v(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !1);
});
C.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = $a5EUy.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
    current: null
});
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function Xa(a, b, c, d) {
    var e = C.hasOwnProperty(b) ? C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var Ya = /^(.*)[\\\/]/, E = "function" === typeof Symbol && Symbol.for, Za = E ? Symbol.for("react.element") : 60103, $a = E ? Symbol.for("react.portal") : 60106, ab = E ? Symbol.for("react.fragment") : 60107, bb = E ? Symbol.for("react.strict_mode") : 60108, cb = E ? Symbol.for("react.profiler") : 60114, db = E ? Symbol.for("react.provider") : 60109, eb = E ? Symbol.for("react.context") : 60110, fb = E ? Symbol.for("react.concurrent_mode") : 60111, gb = E ? Symbol.for("react.forward_ref") : 60112, hb = E ? Symbol.for("react.suspense") : 60113, ib = E ? Symbol.for("react.suspense_list") : 60120, jb = E ? Symbol.for("react.memo") : 60115, kb = E ? Symbol.for("react.lazy") : 60116, lb = E ? Symbol.for("react.block") : 60121, mb = "function" === typeof Symbol && Symbol.iterator;
function nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = mb && a[mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ab:
            return "Fragment";
        case $a:
            return "Portal";
        case cb:
            return "Profiler";
        case bb:
            return "StrictMode";
        case hb:
            return "Suspense";
        case ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case eb:
            return "Context.Consumer";
        case db:
            return "Context.Provider";
        case gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case jb:
            return pb(a.type);
        case lb:
            return pb(a.render);
        case kb:
            if (a = 1 === a._status ? a._result : null) return pb(a);
    }
    return null;
}
function qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = pb(a.type);
                c = null;
                d && (c = pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function tb(a) {
    var b = sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function xb(a) {
    a._valueTracker || (a._valueTracker = tb(a));
}
function yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function zb(a, b) {
    var c = b.checked;
    return $9mzVh({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function Bb(a, b) {
    b = b.checked;
    null != b && Xa(a, "checked", b, !1);
}
function Cb(a, b) {
    Bb(a, b);
    var c = rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Fb(a) {
    var b = "";
    $a5EUy.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function Gb(a, b) {
    a = $9mzVh({
        children: void 0
    }, b);
    if (b = Fb(b.children)) a.children = b;
    return a;
}
function Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(u(91));
    return $9mzVh({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: rb(c)
    };
}
function Kb(a, b) {
    var c = rb(b.value), d = rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Pb, Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        Pb = Pb || document.createElement("div");
        Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Tb = {
    animationend: Sb("Animation", "AnimationEnd"),
    animationiteration: Sb("Animation", "AnimationIteration"),
    animationstart: Sb("Animation", "AnimationStart"),
    transitionend: Sb("Transition", "TransitionEnd")
}, Ub = {}, Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
function Wb(a) {
    if (Ub[a]) return Ub[a];
    if (!Tb[a]) return a;
    var b = Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
    return a;
}
var Xb = Wb("animationend"), Yb = Wb("animationiteration"), Zb = Wb("animationstart"), $b = Wb("transitionend"), ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function cc(a) {
    var b = bc.get(a);
    void 0 === b && (b = new Map, bc.set(a, b));
    return b;
}
function dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function fc(a) {
    if (dc(a) !== a) throw Error(u(188));
}
function gc(a) {
    var b = a.alternate;
    if (!b) {
        b = dc(a);
        if (null === b) throw Error(u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return fc(e), a;
                if (f === d) return fc(e), b;
                f = f.sibling;
            }
            throw Error(u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(u(189));
            }
        }
        if (c.alternate !== d) throw Error(u(190));
    }
    if (3 !== c.tag) throw Error(u(188));
    return c.stateNode.current === c ? a : b;
}
function hc(a) {
    a = gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function ic(a, b) {
    if (null == b) throw Error(u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var kc = null;
function lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)oa(a, b[d], c[d]);
        else b && oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function mc(a) {
    null !== a && (kc = ic(kc, a));
    a = kc;
    kc = null;
    if (a) {
        jc(a, lc);
        if (kc) throw Error(u(95));
        if (fa) throw a = ha, fa = !1, ha = null, a;
    }
}
function nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function oc(a) {
    if (!ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var pc = [];
function qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > pc.length && pc.push(a);
}
function rc(a, b, c, d) {
    if (pc.length) {
        var e = pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < sa.length; k++){
            var l = sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = ic(h, l));
        }
        mc(h);
    }
}
function uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                vc(b, "focus", !0);
                vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                oc(a) && vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === ac.indexOf(a) && F(a, b);
        }
        c.set(a, null);
    }
}
var wc, xc, yc, zc = !1, Ac = [], Bc = null, Cc = null, Dc = null, Ec = new Map, Fc = new Map, Gc = [], Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a, b) {
    var c = cc(b);
    Hc.forEach(function(a) {
        uc(a, b, c);
    });
    Ic.forEach(function(a) {
        uc(a, b, c);
    });
}
function Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            Ec.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Fc.delete(b.pointerId);
    }
}
function Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = Kc(b, c, d, e, f), null !== b && (b = Nc(b), null !== b && xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return Bc = Mc(Bc, a, b, c, d, e), !0;
        case "dragenter":
            return Cc = Mc(Cc, a, b, c, d, e), !0;
        case "mouseover":
            return Dc = Mc(Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Ec.set(f, Mc(Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Fc.set(f, Mc(Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Pc(a) {
    var b = tc(a.target);
    if (null !== b) {
        var c = dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = ec(c), null !== b) {
                    a.blockedOn = b;
                    $3O0bL.unstable_runWithPriority(a.priority, function() {
                        yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = Nc(b);
        null !== c && xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function Sc(a, b, c) {
    Qc(a) && c.delete(b);
}
function Tc() {
    for(zc = !1; 0 < Ac.length;){
        var a = Ac[0];
        if (null !== a.blockedOn) {
            a = Nc(a.blockedOn);
            null !== a && wc(a);
            break;
        }
        var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : Ac.shift();
    }
    null !== Bc && Qc(Bc) && (Bc = null);
    null !== Cc && Qc(Cc) && (Cc = null);
    null !== Dc && Qc(Dc) && (Dc = null);
    Ec.forEach(Sc);
    Fc.forEach(Sc);
}
function Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, zc || (zc = !0, $3O0bL.unstable_scheduleCallback($3O0bL.unstable_NormalPriority, Tc)));
}
function Vc(a) {
    function b(b) {
        return Uc(b, a);
    }
    if (0 < Ac.length) {
        Uc(Ac[0], a);
        for(var c = 1; c < Ac.length; c++){
            var d = Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Bc && Uc(Bc, a);
    null !== Cc && Uc(Cc, a);
    null !== Dc && Uc(Dc, a);
    Ec.forEach(b);
    Fc.forEach(b);
    for(c = 0; c < Gc.length; c++)d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Gc.length && (c = Gc[0], null === c.blockedOn);)Pc(c), null === c.blockedOn && Gc.shift();
}
var Wc = {}, Yc = new Map, Zc = new Map, $c = [
    "abort",
    "abort",
    Xb,
    "animationEnd",
    Yb,
    "animationIteration",
    Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        Zc.set(d, b);
        Yc.set(d, f);
        Wc[e] = f;
    }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
ad($c, 2);
for(var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++)Zc.set(bd[cd], 0);
var dd = $3O0bL.unstable_UserBlockingPriority, ed = $3O0bL.unstable_runWithPriority, fd = !0;
function F(a, b) {
    vc(b, a, !1);
}
function vc(a, b, c) {
    var d = Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = gd.bind(null, b, 1, a);
            break;
        case 1:
            d = hd.bind(null, b, 1, a);
            break;
        default:
            d = id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function gd(a, b, c, d) {
    Ja || Ha();
    var e = id, f = Ja;
    Ja = !0;
    try {
        Ga(e, a, b, c, d);
    } finally{
        (Ja = f) || La();
    }
}
function hd(a, b, c, d) {
    ed(dd, id.bind(null, a, b, c, d));
}
function id(a, b, c, d) {
    if (fd) {
        if (0 < Ac.length && -1 < Hc.indexOf(a)) a = Kc(null, a, b, c, d), Ac.push(a);
        else {
            var e = Rc(a, b, c, d);
            if (null === e) Lc(a, d);
            else if (-1 < Hc.indexOf(a)) a = Kc(e, a, b, c, d), Ac.push(a);
            else if (!Oc(e, a, b, c, d)) {
                Lc(a, d);
                a = rc(a, d, null, b);
                try {
                    Ma(sc, a);
                } finally{
                    qc(a);
                }
            }
        }
    }
}
function Rc(a, b, c, d) {
    c = nc(d);
    c = tc(c);
    if (null !== c) {
        var e = dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = rc(a, d, c, b);
    try {
        Ma(sc, a);
    } finally{
        qc(a);
    }
    return null;
}
var jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(jd).forEach(function(a) {
    kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        jd[b] = jd[a];
    });
});
function ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
}
function md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var nd = $9mzVh({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function od(a, b) {
    if (b) {
        if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(u(62, ""));
    }
}
function pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var qd = Mb.html;
function rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = cc(a);
    b = wa[b];
    for(var d = 0; d < b.length; d++)uc(b[d], a, c);
}
function sd() {}
function td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function vd(a, b) {
    var c = ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = ud(c);
    }
}
function wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function xd() {
    for(var a = window, b = td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = td(a.document);
    }
    return b;
}
function yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var zd = "$", Ad = "/$", Bd = "$?", Cd = "$!", Dd = null, Ed = null;
function Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Hd = "function" === typeof setTimeout ? setTimeout : void 0, Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === zd || c === Cd || c === Bd) {
                if (0 === b) return a;
                b--;
            } else c === Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Ld = Math.random().toString(36).slice(2), Md = "__reactInternalInstance$" + Ld, Nd = "__reactEventHandlers$" + Ld, Od = "__reactContainere$" + Ld;
function tc(a) {
    var b = a[Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[Od] || c[Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Kd(a); null !== a;){
                if (c = a[Md]) return c;
                a = Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Nc(a) {
    a = a[Md] || a[Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(u(33));
}
function Qd(a) {
    return a[Nd] || null;
}
function Rd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(u(231, b, typeof c));
    return c;
}
function Td(a, b, c) {
    if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
}
function Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = Rd(b);
        for(b = c.length; 0 < b--;)Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)Td(c[b], "bubbled", a);
    }
}
function Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
}
function Wd(a) {
    a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
}
function Xd(a) {
    jc(a, Ud);
}
var Yd = null, Zd = null, $d = null;
function ae() {
    if ($d) return $d;
    var a, b = Zd, c = b.length, d, e = "value" in Yd ? Yd.value : Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function be() {
    return !0;
}
function ce() {
    return !1;
}
function G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce;
    this.isPropagationStopped = ce;
    return this;
}
$9mzVh(G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = be);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = be);
    },
    persist: function() {
        this.isPersistent = be;
    },
    isPersistent: ce,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $9mzVh(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $9mzVh({}, d.Interface, a);
    c.extend = d.extend;
    de(c);
    return c;
};
de(G);
function ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function fe(a) {
    if (!(a instanceof this)) throw Error(u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function de(a) {
    a.eventPool = [];
    a.getPooled = ee;
    a.release = fe;
}
var ge = G.extend({
    data: null
}), he = G.extend({
    data: null
}), ie = [
    9,
    13,
    27,
    32
], je = ya && "CompositionEvent" in window, ke = null;
ya && "documentMode" in document && (ke = document.documentMode);
var le = ya && "TextEvent" in window && !ke, me = ya && (!je || ke && 8 < ke && 11 >= ke), ne = String.fromCharCode(32), oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, pe = !1;
function qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function re(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var se = !1;
function te(a, b) {
    switch(a){
        case "compositionend":
            return re(b);
        case "keypress":
            if (32 !== b.which) return null;
            pe = !0;
            return ne;
        case "textInput":
            return a = b.data, a === ne && pe ? null : a;
        default:
            return null;
    }
}
function ue(a, b) {
    if (se) return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var ve = {
    eventTypes: oe,
    extractEvents: function(a, b, c, d) {
        var e;
        if (je) b: {
            switch(a){
                case "compositionstart":
                    var f = oe.compositionStart;
                    break b;
                case "compositionend":
                    f = oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else se ? qe(a, c) && (f = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe.compositionStart);
        f ? (me && "ko" !== c.locale && (se || f !== oe.compositionStart ? f === oe.compositionEnd && se && (e = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;
        (a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
}
var ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function ze(a, b, c) {
    a = G.getPooled(ye.change, a, b, c);
    a.type = "change";
    Da(c);
    Xd(a);
    return a;
}
var Ae = null, Be = null;
function Ce(a) {
    mc(a);
}
function De(a) {
    var b = Pd(a);
    if (yb(b)) return a;
}
function Ee(a, b) {
    if ("change" === a) return b;
}
var Fe = !1;
ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
    Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}
function He(a) {
    if ("value" === a.propertyName && De(Be)) {
        if (a = ze(Be, a, nc(a)), Ja) mc(a);
        else {
            Ja = !0;
            try {
                Fa(Ce, a);
            } finally{
                Ja = !1, La();
            }
        }
    }
}
function Ie(a, b, c) {
    "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
}
function Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
}
function Ke(a, b) {
    if ("click" === a) return De(b);
}
function Le(a, b) {
    if ("input" === a || "change" === a) return De(b);
}
var Me = {
    eventTypes: ye,
    _isInputEventSupported: Fe,
    extractEvents: function(a, b, c, d) {
        var e = b ? Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = Ee;
        else if (xe(e)) {
            if (Fe) g = Le;
            else {
                g = Je;
                var h = Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);
        if (g && (g = g(a, b))) return ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
    }
}, Ne = G.extend({
    view: null,
    detail: null
}), Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
}
function Qe() {
    return Pe;
}
var Re = 0, Se = 0, Te = !1, Ue = !1, Ve = Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Qe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = Re;
        Re = a.screenX;
        return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = Se;
        Se = a.screenY;
        return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
    }
}), We = Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, Ye = {
    eventTypes: Xe,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
                var h = dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = Ve;
            var l = Xe.mouseLeave;
            var m = Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";
        a = null == g ? f : Pd(g);
        f = null == b ? f : Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = Rd(a))g++;
            a = 0;
            for(b = m; b; b = Rd(b))a++;
            for(; 0 < g - a;)k = Rd(k), g--;
            for(; 0 < a - g;)m = Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = Rd(k);
                m = Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = Rd(p);
        }
        for(p = 0; p < k.length; p++)Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e = "function" === typeof Object.is ? Object.is : Ze, af = Object.prototype.hasOwnProperty;
function bf(a, b) {
    if ($e(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode, df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, ef = null, ff = null, gf = null, hf = !1;
function jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if (hf || null == ef || ef !== td(c)) return null;
    c = ef;
    "selectionStart" in c && yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
}
var kf = {
    eventTypes: df,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = cc(e);
                f = wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? Pd(b) : window;
        switch(a){
            case "focus":
                if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;
                break;
            case "blur":
                gf = ff = ef = null;
                break;
            case "mousedown":
                hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return hf = !1, jf(c, d);
            case "selectionchange":
                if (cf) break;
            case "keydown":
            case "keyup":
                return jf(c, d);
        }
        return null;
    }
}, lf = G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), mf = G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), nf = Ne.extend({
    relatedTarget: null
});
function of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, rf = Ne.extend({
    key: function(a) {
        if (a.key) {
            var b = pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Qe,
    charCode: function(a) {
        return "keypress" === a.type ? of(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), sf = Ve.extend({
    dataTransfer: null
}), tf = Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Qe
}), uf = G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), vf = Ve.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), wf = {
    eventTypes: Wc,
    extractEvents: function(a, b, c, d) {
        var e = Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === of(c)) return null;
            case "keydown":
            case "keyup":
                a = rf;
                break;
            case "blur":
            case "focus":
                a = nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = tf;
                break;
            case Xb:
            case Yb:
            case Zb:
                a = lf;
                break;
            case $b:
                a = uf;
                break;
            case "scroll":
                a = Ne;
                break;
            case "wheel":
                a = vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = We;
                break;
            default:
                a = G;
        }
        b = a.getPooled(e, b, c, d);
        Xd(b);
        return b;
    }
};
if (pa) throw Error(u(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var xf = Nc;
la = Qd;
ma = xf;
na = Pd;
xa({
    SimpleEventPlugin: wf,
    EnterLeaveEventPlugin: Ye,
    ChangeEventPlugin: Me,
    SelectEventPlugin: kf,
    BeforeInputEventPlugin: ve
});
var yf = [], zf = -1;
function H(a) {
    0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
}
function I(a, b) {
    zf++;
    yf[zf] = a.current;
    a.current = b;
}
var Af = {}, J = {
    current: Af
}, K = {
    current: !1
}, Bf = Af;
function Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Df() {
    H(K);
    H(J);
}
function Ef(a, b, c) {
    if (J.current !== Af) throw Error(u(168));
    I(J, b);
    I(K, c);
}
function Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(u(108, pb(b) || "Unknown", e));
    return $9mzVh({}, c, {}, d);
}
function Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;
    Bf = J.current;
    I(J, a);
    I(K, K.current);
    return !0;
}
function Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(u(169));
    c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);
    I(K, c);
}
var If = $3O0bL.unstable_runWithPriority, Jf = $3O0bL.unstable_scheduleCallback, Kf = $3O0bL.unstable_cancelCallback, Lf = $3O0bL.unstable_requestPaint, Mf = $3O0bL.unstable_now, Nf = $3O0bL.unstable_getCurrentPriorityLevel, Of = $3O0bL.unstable_ImmediatePriority, Pf = $3O0bL.unstable_UserBlockingPriority, Qf = $3O0bL.unstable_NormalPriority, Rf = $3O0bL.unstable_LowPriority, Sf = $3O0bL.unstable_IdlePriority, Tf = {}, Uf = $3O0bL.unstable_shouldYield, Vf = void 0 !== Lf ? Lf : function() {}, Wf = null, Xf = null, Yf = !1, Zf = Mf(), $f = 1E4 > Zf ? Mf : function() {
    return Mf() - Zf;
};
function ag() {
    switch(Nf()){
        case Of:
            return 99;
        case Pf:
            return 98;
        case Qf:
            return 97;
        case Rf:
            return 96;
        case Sf:
            return 95;
        default:
            throw Error(u(332));
    }
}
function bg(a) {
    switch(a){
        case 99:
            return Of;
        case 98:
            return Pf;
        case 97:
            return Qf;
        case 96:
            return Rf;
        case 95:
            return Sf;
        default:
            throw Error(u(332));
    }
}
function cg(a, b) {
    a = bg(a);
    return If(a, b);
}
function dg(a, b, c) {
    a = bg(a);
    return Jf(a, b, c);
}
function eg(a) {
    null === Wf ? (Wf = [
        a
    ], Xf = Jf(Of, fg)) : Wf.push(a);
    return Tf;
}
function gg() {
    if (null !== Xf) {
        var a = Xf;
        Xf = null;
        Kf(a);
    }
    fg();
}
function fg() {
    if (!Yf && null !== Wf) {
        Yf = !0;
        var a = 0;
        try {
            var b = Wf;
            cg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            Wf = null;
        } catch (c) {
            throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
        } finally{
            Yf = !1;
        }
    }
}
function hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function ig(a, b) {
    if (a && a.defaultProps) {
        b = $9mzVh({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var jg = {
    current: null
}, kg = null, lg = null, mg = null;
function ng() {
    mg = lg = kg = null;
}
function og(a) {
    var b = jg.current;
    H(jg);
    a.type._context._currentValue = b;
}
function pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function qg(a, b) {
    kg = a;
    mg = lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = !0), a.firstContext = null);
}
function sg(a, b) {
    if (mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === lg) {
            if (null === kg) throw Error(u(308));
            lg = b;
            kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else lg = lg.next = b;
    }
    return a._currentValue;
}
var tg = !1;
function ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function yg(a, b) {
    var c = a.alternate;
    null !== c && vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function zg(a, b, c, d) {
    var e = a.updateQueue;
    tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = $9mzVh({}, k, g);
                                break a;
                            case 2:
                                tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error(u(191, d));
            d.call(e);
        }
    }
}
var Dg = Wa.ReactCurrentBatchConfig, Eg = (new $a5EUy.Component).refs;
function Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $9mzVh({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var Jg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? dc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = Gg(), d = Dg.suspense;
        c = Hg(c, a, d);
        d = wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        xg(a, d);
        Ig(a, c);
    }
};
function Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e, f) : !0;
}
function Lg(a, b, c) {
    var d = !1, e = Af;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = sg(f) : (e = L(b) ? Bf : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Cf(a, e) : Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
}
function Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Eg;
    ug(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = sg(f) : (f = L(b) ? Bf : J.current, e.context = Cf(a, f));
    zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jg.enqueueReplaceState(e, e.state, null), zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var Og = Array.isArray;
function Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Eg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(u(284));
        if (!c._owner) throw Error(u(290, a));
    }
    return a;
}
function Qg(a, b) {
    if ("textarea" !== a.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Pg(a, b, c), d.return = a, d;
        d = Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Pg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Vg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Wg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Tg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case Za:
                    return c = Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = Pg(a, null, b), c.return = a, c;
                case $a:
                    return b = Vg(b, a.mode, c), b.return = a, b;
            }
            if (Og(b) || nb(b)) return b = Wg(b, a.mode, c, null), b.return = a, b;
            Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case Za:
                    return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Og(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);
            Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Og(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = nb(h);
        if ("function" !== typeof k) throw Error(u(150));
        h = k.call(h);
        if (null == h) throw Error(u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Pg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ab ? (d = Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = Pg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Vg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Tg(f, a.mode, h), d.return = a, a = d), g(a);
        if (Og(f)) return ca(a, d, f, h);
        if (nb(f)) return D(a, d, f, h);
        l && Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error(u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var Xg = Rg(!0), Yg = Rg(!1), Zg = {}, $g = {
    current: Zg
}, ah = {
    current: Zg
}, bh = {
    current: Zg
};
function ch(a) {
    if (a === Zg) throw Error(u(174));
    return a;
}
function dh(a, b) {
    I(bh, b);
    I(ah, a);
    I($g, Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);
    }
    H($g);
    I($g, b);
}
function eh() {
    H($g);
    H(ah);
    H(bh);
}
function fh(a) {
    ch(bh.current);
    var b = ch($g.current);
    var c = Ob(b, a.type);
    b !== c && (I(ah, a), I($g, c));
}
function gh(a) {
    ah.current === a && (H($g), H(ah));
}
var M = {
    current: 0
};
function hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var jh = Wa.ReactCurrentDispatcher, kh = Wa.ReactCurrentBatchConfig, lh = 0, N = null, O = null, P = null, mh = !1;
function Q() {
    throw Error(u(321));
}
function nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e(a[c], b[c])) return !1;
    return !0;
}
function oh(a, b, c, d, e, f) {
    lh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    jh.current = null === a || null === a.memoizedState ? ph : qh;
    a = c(d, e);
    if (b.expirationTime === lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error(u(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            jh.current = rh;
            a = c(d, e);
        }while (b.expirationTime === lh);
    }
    jh.current = sh;
    b = null !== O && null !== O.next;
    lh = 0;
    P = O = N = null;
    mh = !1;
    if (b) throw Error(u(300));
    return a;
}
function th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function uh() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(u(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function wh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > N.expirationTime && (N.expirationTime = l, Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $e(d, b.memoizedState) || (rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function xh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e(f, b.memoizedState) || (rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function yh(a) {
    var b = th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: vh,
        lastRenderedState: a
    };
    a = a.dispatch = zh.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Bh() {
    return uh().memoizedState;
}
function Ch(a, b, c, d) {
    var e = th();
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function Dh(a, b, c, d) {
    var e = uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && nh(d, g.deps)) {
            Ah(b, c, f, d);
            return;
        }
    }
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, f, d);
}
function Eh(a, b) {
    return Ch(516, 4, a, b);
}
function Fh(a, b) {
    return Dh(516, 4, a, b);
}
function Gh(a, b) {
    return Dh(4, 2, a, b);
}
function Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Dh(4, 2, Hh.bind(null, b, a), c);
}
function Jh() {}
function Kh(a, b) {
    th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function Lh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Mh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Nh(a, b, c) {
    var d = ag();
    cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    cg(97 < d ? 97 : d, function() {
        var d = kh.suspense;
        kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            kh.suspense = d;
        }
    });
}
function zh(a, b, c) {
    var d = Gg(), e = Dg.suspense;
    d = Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === N || null !== f && f === N) mh = !0, e.expirationTime = lh, N.expirationTime = lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($e(h, g)) return;
        } catch (k) {} finally{}
        Ig(a, d);
    }
}
var sh = {
    readContext: sg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useResponder: Q,
    useDeferredValue: Q,
    useTransition: Q
}, ph = {
    readContext: sg,
    useCallback: Kh,
    useContext: sg,
    useEffect: Eh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Ch(4, 2, Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Ch(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = zh.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: yh,
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = yh(a), d = c[0], e = c[1];
        Eh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = yh(!1), c = b[0];
        b = b[1];
        return [
            Kh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, qh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: wh,
    useRef: Bh,
    useState: function() {
        return wh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = wh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = wh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, rh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: xh,
    useRef: Bh,
    useState: function() {
        return xh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = xh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = xh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, Oh = null, Ph = null, Qh = !1;
function Rh(a, b) {
    var c = Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function Uh(a) {
    if (Qh) {
        var b = Ph;
        if (b) {
            var c = b;
            if (!Th(a, b)) {
                b = Jd(c.nextSibling);
                if (!b || !Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    Qh = !1;
                    Oh = a;
                    return;
                }
                Rh(Oh, c);
            }
            Oh = a;
            Ph = Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
    }
}
function Vh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    Oh = a;
}
function Wh(a) {
    if (a !== Oh) return !1;
    if (!Qh) return Vh(a), Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps)) for(b = Ph; b;)Rh(a, b), b = Jd(b.nextSibling);
    Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === Ad) {
                        if (0 === b) {
                            Ph = Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== zd && c !== Cd && c !== Bd || b++;
                }
                a = a.nextSibling;
            }
            Ph = null;
        }
    } else Ph = Oh ? Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function Xh() {
    Ph = Oh = null;
    Qh = !1;
}
var Yh = Wa.ReactCurrentOwner, rg = !1;
function R(a, b, c, d) {
    b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
}
function Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    qg(b, e);
    d = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, d, e);
    return b.child;
}
function ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ci(a, b, g, d, e, f);
        a = Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e, d) && a.ref === b.ref)) return $h(a, b, f);
    b.effectTag |= 1;
    a = Sg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ci(a, b, c, d, e, f) {
    return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $h(a, b, f)) : di(a, b, c, d, f);
}
function ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function di(a, b, c, d, e) {
    var f = L(c) ? Bf : J.current;
    f = Cf(b, f);
    qg(b, e);
    c = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, c, e);
    return b.child;
}
function fi(a, b, c, d, e) {
    if (L(c)) {
        var f = !0;
        Gf(b);
    } else f = !1;
    qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);
        tg = !1;
        var x = b.memoizedState;
        g.state = x;
        zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = !1, k = b.memoizedState, g.state = k, zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return gi(a, b, c, d, f, e);
}
function gi(a, b, c, d, e, f) {
    ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && Hf(b, c, !1), $h(a, b, f);
    d = b.stateNode;
    Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = Xg(b, a.child, null, f), b.child = Xg(b, null, h, f)) : R(a, b, h, f);
    b.memoizedState = d.state;
    e && Hf(b, c, !0);
    return b.child;
}
function hi(a) {
    var b = a.stateNode;
    b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, !1);
    dh(a, b.containerInfo);
}
var ii = {
    dehydrated: null,
    retryTime: 0
};
function ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    I(M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && Uh(b);
        if (g) {
            g = e.fallback;
            e = Wg(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = Wg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = Sg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = ii;
            b.child = c;
            return d;
        }
        c = Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = Wg(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = Wg(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = Xg(b, a, e.children, c);
}
function ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    pg(a.return, b);
}
function li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    R(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && ki(a, c);
            else if (19 === a.tag) ki(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error(u(153));
    if (null !== b.child) {
        a = b.child;
        c = Sg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var ni, oi, pi, qi;
ni = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
oi = function() {};
pi = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        ch($g.current);
        a = null;
        switch(c){
            case "input":
                f = zb(g, f);
                d = zb(g, d);
                a = [];
                break;
            case "option":
                f = Gb(g, f);
                d = Gb(g, d);
                a = [];
                break;
            case "select":
                f = $9mzVh({}, f, {
                    value: void 0
                });
                d = $9mzVh({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = Ib(g, f);
                d = Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = sd);
        }
        od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
qi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return L(b.type) && Df(), null;
        case 3:
            return eh(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;
        case 5:
            gh(b);
            c = ch(bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(u(166));
                    return null;
                }
                a = ch($g.current);
                if (Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[Md] = b;
                    d[Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < ac.length; a++)F(ac[a], d);
                            break;
                        case "source":
                            F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", d);
                            F("load", d);
                            break;
                        case "form":
                            F("reset", d);
                            F("submit", d);
                            break;
                        case "details":
                            F("toggle", d);
                            break;
                        case "input":
                            Ab(d, f);
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(d, f), F("invalid", d), rd(c, "onChange");
                    }
                    od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : va.hasOwnProperty(g) && null != h && rd(c, g);
                    }
                    switch(e){
                        case "input":
                            xb(d);
                            Eb(d, f, !0);
                            break;
                        case "textarea":
                            xb(d);
                            Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === qd && (a = Nb(e));
                    a === qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[Md] = b;
                    a[Nd] = d;
                    ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < ac.length; h++)F(ac[h], a);
                            h = d;
                            break;
                        case "source":
                            F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", a);
                            F("load", a);
                            h = d;
                            break;
                        case "form":
                            F("reset", a);
                            F("submit", a);
                            h = d;
                            break;
                        case "details":
                            F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            Ab(a, d);
                            h = zb(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "option":
                            h = Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $9mzVh({}, d, {
                                value: void 0
                            });
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(a, d);
                            h = Ib(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && rd(c, f) : null != l && Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            xb(a);
                            Eb(a, d, !1);
                            break;
                        case "textarea":
                            xb(a);
                            Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = sd);
                    }
                    Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(u(166));
                c = ch(bh.current);
                ch($g.current);
                Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            H(M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) S === ti && (S = ui);
                else {
                    if (S === ti || S === ui) S = vi;
                    0 !== wi && null !== T && (xi(T, U), yi(T, wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return eh(), oi(b), null;
        case 10:
            return og(b), null;
        case 17:
            return L(b.type) && Df(), null;
        case 19:
            H(M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) ri(d, !1);
                else {
                    if (S !== ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            I(M, M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M.current, I(M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error(u(156, b.tag));
}
function zi(a) {
    switch(a.tag){
        case 1:
            L(a.type) && Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            eh();
            H(K);
            H(J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error(u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return gh(a), null;
        case 13:
            return H(M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return H(M), null;
        case 4:
            return eh(), null;
        case 10:
            return og(a), null;
        default:
            return null;
    }
}
function Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: qb(b)
    };
}
var Bi = "function" === typeof WeakSet ? WeakSet : Set;
function Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = qb(c));
    null !== c && pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        Ei(a, c);
    }
}
function Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Ei(a, c);
        }
        else b.current = null;
    }
}
function Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(u(163));
}
function Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error(u(163));
}
function Ki(a, b, c) {
    "function" === typeof Li && Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                cg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                Ei(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && Di(b, c);
            break;
        case 5:
            Fi(b);
            break;
        case 4:
            Mi(a, b, c);
    }
}
function Ni(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && Ni(b);
}
function Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Pi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (Oi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error(u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(u(161));
    }
    c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || Oi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? Qi(a, c, b) : Ri(a, c, b);
}
function Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));
    else if (4 !== d && (a = a.child, null !== a)) for(Qi(a, b, c), a = a.sibling; null !== a;)Qi(a, b, c), a = a.sibling;
}
function Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Ri(a, b, c), a = a.sibling; null !== a;)Ri(a, b, c), a = a.sibling;
}
function Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error(u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if (Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if (Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && Bb(c, d);
                    pd(a, e);
                    b = pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            Cb(c, d);
                            break;
                        case "textarea":
                            Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, !0) : Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, Ti = $f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            Ui(b);
            return;
        case 19:
            Ui(b);
            return;
        case 17:
            return;
    }
    throw Error(u(163));
}
function Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Bi);
        b.forEach(function(b) {
            var d = Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var Wi = "function" === typeof WeakMap ? WeakMap : Map;
function Xi(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Yi || (Yi = !0, Zi = d);
        Ci(a, b);
    };
    return c;
}
function $i(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === aj ? aj = new Set([
            this
        ]) : aj.add(this), Ci(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var bj = Math.ceil, cj = Wa.ReactCurrentDispatcher, dj = Wa.ReactCurrentOwner, V = 0, ej = 8, fj = 16, gj = 32, ti = 0, hj = 1, ij = 2, ui = 3, vi = 4, jj = 5, W = V, T = null, X = null, U = 0, S = ti, kj = null, lj = 1073741823, mj = 1073741823, nj = null, wi = 0, oj = !1, Ti = 0, pj = 500, Y = null, Yi = !1, Zi = null, aj = null, qj = !1, rj = null, sj = 90, tj = null, uj = 0, vj = null, wj = 0;
function Gg() {
    return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
}
function Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if ((W & fj) !== V) return U;
    if (null !== c) a = hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error(u(326));
    }
    null !== T && a === U && --a;
    return a;
}
function Ig(a, b) {
    if (50 < uj) throw uj = 0, vj = null, Error(u(185));
    a = xj(a, b);
    if (null !== a) {
        var c = ag();
        1073741823 === b ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a);
        (W & 4) === V || 98 !== c && 99 !== c || (null === tj ? tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
    }
}
function xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && (T === e && (Bg(b), S === vi && xi(e, U)), yi(e, b));
    return e;
}
function zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));
    else {
        var b = zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== Tf && Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $f()
            });
            a.callbackNode = b;
        }
    }
}
function Bj(a, b) {
    wj = 0;
    if (b) return b = Gg(), Cj(a, b), Z(a), null;
    var c = zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if ((W & (fj | gj)) !== V) throw Error(u(327));
        Dj();
        a === T && c === U || Ej(a, c);
        if (null !== X) {
            var d = W;
            W |= fj;
            var e = Fj();
            for(;;)try {
                Gj();
                break;
            } catch (h) {
                Hj(a, h);
            }
            ng();
            W = d;
            cj.current = e;
            if (S === hj) throw b = kj, Ej(a, c), xi(a, c), Z(a), b;
            if (null === X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d){
                case ti:
                case hj:
                    throw Error(u(345));
                case ij:
                    Cj(a, 2 < c ? 2 : c);
                    break;
                case ui:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (1073741823 === lj && (e = Ti + pj - $f(), 10 < e)) {
                        if (oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                Ej(a, c);
                                break;
                            }
                        }
                        f = zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = Hd(Jj.bind(null, a), e);
                        break;
                    }
                    Jj(a);
                    break;
                case vi:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        Ej(a, c);
                        break;
                    }
                    e = zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5E3, e = $f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = Hd(Jj.bind(null, a), d);
                        break;
                    }
                    Jj(a);
                    break;
                case jj:
                    if (1073741823 !== lj && null !== nj) {
                        f = lj;
                        var g = nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            xi(a, c);
                            a.timeoutHandle = Hd(Jj.bind(null, a), d);
                            break;
                        }
                    }
                    Jj(a);
                    break;
                default:
                    throw Error(u(329));
            }
            Z(a);
            if (a.callbackNode === b) return Bj.bind(null, a);
        }
    }
    return null;
}
function yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    Dj();
    a === T && b === U || Ej(a, b);
    if (null !== X) {
        var c = W;
        W |= fj;
        var d = Fj();
        for(;;)try {
            Kj();
            break;
        } catch (e) {
            Hj(a, e);
        }
        ng();
        W = c;
        cj.current = d;
        if (S === hj) throw c = kj, Ej(a, b), xi(a, b), Z(a), c;
        if (null !== X) throw Error(u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        T = null;
        Jj(a);
        Z(a);
    }
    return null;
}
function Lj() {
    if (null !== tj) {
        var a = tj;
        tj = null;
        a.forEach(function(a, c) {
            Cj(c, a);
            Z(c);
        });
        gg();
    }
}
function Mj(a, b) {
    var c = W;
    W |= 1;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Nj(a, b) {
    var c = W;
    W &= -2;
    W |= ej;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Id(c));
    if (null !== X) for(c = X.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Df();
                break;
            case 3:
                eh();
                H(K);
                H(J);
                break;
            case 5:
                gh(d);
                break;
            case 4:
                eh();
                break;
            case 13:
                H(M);
                break;
            case 19:
                H(M);
                break;
            case 10:
                og(d);
        }
        c = c.return;
    }
    T = a;
    X = Sg(a.current, null);
    U = b;
    S = ti;
    kj = null;
    mj = lj = 1073741823;
    nj = null;
    wi = 0;
    oj = !1;
}
function Hj(a, b) {
    do {
        try {
            ng();
            jh.current = sh;
            if (mh) for(var c = N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            lh = 0;
            P = O = N = null;
            mh = !1;
            if (null === X || null === X.return) return S = hj, kj = b, X = null;
            a: {
                var e = a, f = X.return, g = X, h = b;
                b = U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== (M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = wg(1073741823, null);
                                        y.tag = 2;
                                        xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
                }
                S !== jj && (S = ij);
                h = Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = Xi(p, k, b);
                            yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $i(p, k, b);
                                yg(p, vb);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            X = Pj(X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function Fj() {
    var a = cj.current;
    cj.current = sh;
    return null === a ? sh : a;
}
function Ag(a, b) {
    a < lj && 2 < a && (lj = a);
    null !== b && a < mj && 2 < a && (mj = a, nj = b);
}
function Bg(a) {
    a > wi && (wi = a);
}
function Kj() {
    for(; null !== X;)X = Qj(X);
}
function Gj() {
    for(; null !== X && !Uf();)X = Qj(X);
}
function Qj(a) {
    var b = Rj(a.alternate, a, U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = Pj(a));
    dj.current = null;
    return b;
}
function Pj(a) {
    X = a;
    do {
        var b = X.alternate;
        a = X.return;
        if (0 === (X.effectTag & 2048)) {
            b = si(b, X, U);
            if (1 === U || 1 !== X.childExpirationTime) {
                for(var c = 0, d = X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
        } else {
            b = zi(X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = X.sibling;
        if (null !== b) return b;
        X = a;
    }while (null !== X);
    S === ti && (S = jj);
    return null;
}
function Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function Jj(a) {
    var b = ag();
    cg(99, Sj.bind(null, a, b));
    return null;
}
function Sj(a, b) {
    do Dj();
    while (null !== rj);
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error(u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === T && (X = T = null, U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = W;
        W |= gj;
        dj.current = null;
        Dd = fd;
        var g = xd();
        if (yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Y = e;
        do try {
            Tj();
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = e;
        do try {
            for(g = a, h = b; null !== Y;){
                var q = Y.effectTag;
                q & 16 && Rb(Y.stateNode, "");
                if (q & 128) {
                    var B = Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        Pi(Y);
                        Y.effectTag &= -3;
                        break;
                    case 6:
                        Pi(Y);
                        Y.effectTag &= -3;
                        Si(Y.alternate, Y);
                        break;
                    case 1024:
                        Y.effectTag &= -1025;
                        break;
                    case 1028:
                        Y.effectTag &= -1025;
                        Si(Y.alternate, Y);
                        break;
                    case 4:
                        Si(Y.alternate, Y);
                        break;
                    case 8:
                        l = Y, Mi(g, l, h), Ni(l);
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        w = Ed;
        B = xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
            null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        fd = !!Dd;
        Ed = Dd = null;
        a.current = c;
        Y = e;
        do try {
            for(q = a; null !== Y;){
                var ub = Y.effectTag;
                ub & 36 && Ji(q, Y.alternate, Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = Y.ref;
                    if (null !== vb) {
                        var Xc = Y.stateNode;
                        switch(Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = null;
        Vf();
        W = f;
    } else a.current = c;
    if (qj) qj = !1, rj = a, sj = b;
    else for(Y = e; null !== Y;)b = Y.nextEffect, Y.nextEffect = null, Y = b;
    b = a.firstPendingTime;
    0 === b && (aj = null);
    1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;
    "function" === typeof Uj && Uj(c.stateNode, d);
    Z(a);
    if (Yi) throw Yi = !1, a = Zi, Zi = null, a;
    if ((W & ej) !== V) return null;
    gg();
    return null;
}
function Tj() {
    for(; null !== Y;){
        var a = Y.effectTag;
        0 !== (a & 256) && Gi(Y.alternate, Y);
        0 === (a & 512) || qj || (qj = !0, dg(97, function() {
            Dj();
            return null;
        }));
        Y = Y.nextEffect;
    }
}
function Dj() {
    if (90 !== sj) {
        var a = 97 < sj ? 97 : sj;
        sj = 90;
        return cg(a, Vj);
    }
}
function Vj() {
    if (null === rj) return !1;
    var a = rj;
    rj = null;
    if ((W & (fj | gj)) !== V) throw Error(u(331));
    var b = W;
    W |= gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    Hi(5, c), Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error(u(330));
            Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    W = b;
    gg();
    return !0;
}
function Wj(a, b, c) {
    b = Ai(c, b);
    b = Xi(a, b, 1073741823);
    xg(a, b);
    a = xj(a, 1073741823);
    null !== a && Z(a);
}
function Ei(a, b) {
    if (3 === a.tag) Wj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
                a = Ai(b, a);
                a = $i(c, a, 1073741823);
                xg(c, a);
                c = xj(c, 1073741823);
                null !== c && Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    T === a && U === c ? S === vi || S === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U) : oj = !0 : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
}
function Vi(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = Gg(), b = Hg(b, a, null));
    a = xj(a, b);
    null !== a && Z(a);
}
var Rj;
Rj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || K.current) rg = !0;
        else {
            if (d < c) {
                rg = !1;
                switch(b.tag){
                    case 3:
                        hi(b);
                        Xh();
                        break;
                    case 5:
                        fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        L(b.type) && Gf(b);
                        break;
                    case 4:
                        dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        I(jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return ji(a, b, c);
                            I(M, M.current & 1);
                            b = $h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        I(M, M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        I(M, M.current);
                        if (!d) return null;
                }
                return $h(a, b, c);
            }
            rg = !1;
        }
    } else rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = Cf(b, J.current);
            qg(b, c);
            e = oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (L(d)) {
                    var f = !0;
                    Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Fg(b, d, g, a);
                e.updater = Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                Ng(b, d, a, c);
                b = gi(null, b, d, !0, f, c);
            } else b.tag = 0, R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = Xj(e);
                a = ig(e, a);
                switch(f){
                    case 0:
                        b = di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ai(null, b, e, ig(e.type, a), d, c);
                        break a;
                }
                throw Error(u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), fi(a, b, d, e, c);
        case 3:
            hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            vg(a, b);
            zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) Xh(), b = $h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e = Qh = !0;
                if (e) for(c = Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else R(a, b, d, c), Xh();
                b = b.child;
            }
            return b;
        case 5:
            return fh(b), null === a && Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Gd(d, e) ? g = null : null !== f && Gd(d, f) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && Uh(b), null;
        case 13:
            return ji(a, b, c);
        case 4:
            return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), Zh(a, b, d, e, c);
        case 7:
            return R(a, b, b.pendingProps, c), b.child;
        case 8:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !K.current) {
                            b = $h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    pg(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, qg(b, c), e = sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = ig(e, b.pendingProps), f = ig(e.type, f), ai(a, b, e, f, d, c);
        case 15:
            return ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Gf(b)) : a = !1, qg(b, c), Lg(b, d, e), Ng(b, d, e, c), gi(null, b, d, !0, a, c);
        case 19:
            return mi(a, b, c);
    }
    throw Error(u(156, b.tag));
};
var Uj = null, Li = null;
function Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        Uj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        Li = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function Sh(a, b, c, d) {
    return new Zj(a, b, c, d);
}
function bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Xj(a) {
    if ("function" === typeof a) return bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === gb) return 11;
        if (a === jb) return 14;
    }
    return 2;
}
function Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ab:
            return Wg(c.children, e, f, b);
        case fb:
            g = 8;
            e |= 7;
            break;
        case bb:
            g = 8;
            e |= 1;
            break;
        case cb:
            return a = Sh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;
        case hb:
            return a = Sh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;
        case ib:
            return a = Sh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case db:
                    g = 10;
                    break a;
                case eb:
                    g = 9;
                    break a;
                case gb:
                    g = 11;
                    break a;
                case jb:
                    g = 14;
                    break a;
                case kb:
                    g = 16;
                    d = null;
                    break a;
                case lb:
                    g = 22;
                    break a;
            }
            throw Error(u(130, null == a ? a : typeof a, ""));
    }
    b = Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function Wg(a, b, c, d) {
    a = Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function Tg(a, b, c) {
    a = Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function Vg(a, b, c) {
    b = Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function bk(a, b, c, d) {
    var e = b.current, f = Gg(), g = Dg.suspense;
    f = Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if (dc(c) !== c || 1 !== c.tag) throw Error(u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (L(k)) {
                c = Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    xg(e, b);
    Ig(e, f);
    return f;
}
function ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function ek(a, b) {
    dk(a, b);
    (a = a.alternate) && dk(a, b);
}
function fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new ak(a, b, c), e = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    ug(e);
    a[Od] = d.current;
    c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
fk.prototype.render = function(a) {
    bk(a, this._internalRoot, null, null);
};
fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    bk(null, a, null, function() {
        b[Od] = null;
    });
};
function gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = ck(g);
                h.call(a);
            };
        }
        bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = ck(g);
                k.call(a);
            };
        }
        Nj(function() {
            bk(b, g, a, e);
        });
    }
    return ck(g);
}
function jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
wc = function(a) {
    if (13 === a.tag) {
        var b = hg(Gg(), 150, 100);
        Ig(a, b);
        ek(a, b);
    }
};
xc = function(a) {
    13 === a.tag && (Ig(a, 3), ek(a, 3));
};
yc = function(a) {
    if (13 === a.tag) {
        var b = Gg();
        b = Hg(b, a, null);
        Ig(a, b);
        ek(a, b);
    }
};
za = function(a, b, c) {
    switch(b){
        case "input":
            Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Qd(d);
                        if (!e) throw Error(u(90));
                        yb(d);
                        Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && Hb(a, !!c.multiple, b, !1);
    }
};
Fa = Mj;
Ga = function(a, b, c, d, e) {
    var f = W;
    W |= 4;
    try {
        return cg(98, a.bind(null, b, c, d, e));
    } finally{
        W = f, W === V && gg();
    }
};
Ha = function() {
    (W & (1 | fj | gj)) === V && (Lj(), Dj());
};
Ia = function(a, b) {
    var c = W;
    W |= 2;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
};
function kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!gk(b)) throw Error(u(200));
    return jk(a, b, null, c);
}
var lk = {
    Events: [
        Nc,
        Pd,
        Qd,
        xa,
        ta,
        Xd,
        function(a) {
            jc(a, Wd);
        },
        Da,
        Ea,
        id,
        mc,
        Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return Yj($9mzVh({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: tc,
    bundleType: 0,
    version: "16.14.0",
    rendererPackageName: "react-dom"
});
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;
exports.createPortal = kk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(u(188));
        throw Error(u(268, Object.keys(a)));
    }
    a = hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    if ((W & (fj | gj)) !== V) throw Error(u(187));
    var c = W;
    W |= 1;
    try {
        return cg(99, a.bind(null, b));
    } finally{
        W = c, gg();
    }
};
exports.hydrate = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!gk(a)) throw Error(u(40));
    return a._reactRootContainer ? (Nj(function() {
        ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[Od] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Mj;
exports.unstable_createPortal = function(a, b) {
    return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!gk(c)) throw Error(u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error(u(38));
    return ik(a, b, c, !1, d);
};
exports.version = "16.14.0";

});
parcelRegister("3O0bL", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bgcob"));

});
parcelRegister("bgcob", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $832acc902188351a$export$c4744153514ff05d; }, function (v) { return $832acc902188351a$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $832acc902188351a$export$d66a1c1c77bd778b; }, function (v) { return $832acc902188351a$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $832acc902188351a$export$3e506c1ccc9cc1a7; }, function (v) { return $832acc902188351a$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $832acc902188351a$export$e26fe2ed2fa76875; }, function (v) { return $832acc902188351a$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $832acc902188351a$export$502329bbf4b505b1; }, function (v) { return $832acc902188351a$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $832acc902188351a$export$6e3807111c4874c4; }, function (v) { return $832acc902188351a$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $832acc902188351a$export$c27134553091fb3a; }, function (v) { return $832acc902188351a$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $832acc902188351a$export$33ee1acdc04fd2a2; }, function (v) { return $832acc902188351a$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $832acc902188351a$export$b00a404bbd5edef2; }, function (v) { return $832acc902188351a$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $832acc902188351a$export$8352ce38b91d0c62; }, function (v) { return $832acc902188351a$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $832acc902188351a$export$d3dfb8e4810cb555; }, function (v) { return $832acc902188351a$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $832acc902188351a$export$839f9183b0465a69; }, function (v) { return $832acc902188351a$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $832acc902188351a$export$72fdf0e06517287b; }, function (v) { return $832acc902188351a$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $832acc902188351a$export$4b844e58a3e414b4; }, function (v) { return $832acc902188351a$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $832acc902188351a$export$816d2913ae6b83b1; }, function (v) { return $832acc902188351a$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $832acc902188351a$export$61bcfe829111a1d0; }, function (v) { return $832acc902188351a$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $832acc902188351a$export$7ee8c9beb337bc3f; }, function (v) { return $832acc902188351a$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $832acc902188351a$export$b5836b71941fa3ed; }, function (v) { return $832acc902188351a$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $832acc902188351a$export$cf845f2c119da08a; }, function (v) { return $832acc902188351a$export$cf845f2c119da08a = v; });
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $832acc902188351a$export$c4744153514ff05d;
var $832acc902188351a$export$d66a1c1c77bd778b;
var $832acc902188351a$export$3e506c1ccc9cc1a7;
var $832acc902188351a$export$e26fe2ed2fa76875;
var $832acc902188351a$export$502329bbf4b505b1;
var $832acc902188351a$export$6e3807111c4874c4;
var $832acc902188351a$export$c27134553091fb3a;
var $832acc902188351a$export$33ee1acdc04fd2a2;
var $832acc902188351a$export$b00a404bbd5edef2;
var $832acc902188351a$export$8352ce38b91d0c62;
var $832acc902188351a$export$d3dfb8e4810cb555;
var $832acc902188351a$export$839f9183b0465a69;
var $832acc902188351a$export$72fdf0e06517287b;
var $832acc902188351a$export$4b844e58a3e414b4;
var $832acc902188351a$export$816d2913ae6b83b1;
var $832acc902188351a$export$61bcfe829111a1d0;
var $832acc902188351a$export$7ee8c9beb337bc3f;
var $832acc902188351a$export$b5836b71941fa3ed;
var $832acc902188351a$export$cf845f2c119da08a;
'use strict';
var $832acc902188351a$var$f, $832acc902188351a$var$g, $832acc902188351a$var$h, $832acc902188351a$var$k, $832acc902188351a$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $832acc902188351a$var$p = null, $832acc902188351a$var$q = null, $832acc902188351a$var$t = function() {
        if (null !== $832acc902188351a$var$p) try {
            var a = $832acc902188351a$export$c4744153514ff05d();
            $832acc902188351a$var$p(!0, a);
            $832acc902188351a$var$p = null;
        } catch (b) {
            throw setTimeout($832acc902188351a$var$t, 0), b;
        }
    }, $832acc902188351a$var$u = Date.now();
    $832acc902188351a$export$c4744153514ff05d = function() {
        return Date.now() - $832acc902188351a$var$u;
    };
    $832acc902188351a$var$f = function(a) {
        null !== $832acc902188351a$var$p ? setTimeout($832acc902188351a$var$f, 0, a) : ($832acc902188351a$var$p = a, setTimeout($832acc902188351a$var$t, 0));
    };
    $832acc902188351a$var$g = function(a, b) {
        $832acc902188351a$var$q = setTimeout(a, b);
    };
    $832acc902188351a$var$h = function() {
        clearTimeout($832acc902188351a$var$q);
    };
    $832acc902188351a$var$k = function() {
        return !1;
    };
    $832acc902188351a$var$l = $832acc902188351a$export$d66a1c1c77bd778b = function() {};
} else {
    var $832acc902188351a$var$w = window.performance, $832acc902188351a$var$x = window.Date, $832acc902188351a$var$y = window.setTimeout, $832acc902188351a$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $832acc902188351a$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $832acc902188351a$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $832acc902188351a$var$w && "function" === typeof $832acc902188351a$var$w.now) $832acc902188351a$export$c4744153514ff05d = function() {
        return $832acc902188351a$var$w.now();
    };
    else {
        var $832acc902188351a$var$B = $832acc902188351a$var$x.now();
        $832acc902188351a$export$c4744153514ff05d = function() {
            return $832acc902188351a$var$x.now() - $832acc902188351a$var$B;
        };
    }
    var $832acc902188351a$var$C = !1, $832acc902188351a$var$D = null, $832acc902188351a$var$E = -1, $832acc902188351a$var$F = 5, $832acc902188351a$var$G = 0;
    $832acc902188351a$var$k = function() {
        return $832acc902188351a$export$c4744153514ff05d() >= $832acc902188351a$var$G;
    };
    $832acc902188351a$var$l = function() {};
    $832acc902188351a$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $832acc902188351a$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $832acc902188351a$var$H = new MessageChannel, $832acc902188351a$var$I = $832acc902188351a$var$H.port2;
    $832acc902188351a$var$H.port1.onmessage = function() {
        if (null !== $832acc902188351a$var$D) {
            var a = $832acc902188351a$export$c4744153514ff05d();
            $832acc902188351a$var$G = a + $832acc902188351a$var$F;
            try {
                $832acc902188351a$var$D(!0, a) ? $832acc902188351a$var$I.postMessage(null) : ($832acc902188351a$var$C = !1, $832acc902188351a$var$D = null);
            } catch (b) {
                throw $832acc902188351a$var$I.postMessage(null), b;
            }
        } else $832acc902188351a$var$C = !1;
    };
    $832acc902188351a$var$f = function(a) {
        $832acc902188351a$var$D = a;
        $832acc902188351a$var$C || ($832acc902188351a$var$C = !0, $832acc902188351a$var$I.postMessage(null));
    };
    $832acc902188351a$var$g = function(a, b) {
        $832acc902188351a$var$E = $832acc902188351a$var$y(function() {
            a($832acc902188351a$export$c4744153514ff05d());
        }, b);
    };
    $832acc902188351a$var$h = function() {
        $832acc902188351a$var$z($832acc902188351a$var$E);
        $832acc902188351a$var$E = -1;
    };
}
function $832acc902188351a$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $832acc902188351a$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $832acc902188351a$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $832acc902188351a$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $832acc902188351a$var$K(n, c)) void 0 !== r && 0 > $832acc902188351a$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $832acc902188351a$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $832acc902188351a$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $832acc902188351a$var$N = [], $832acc902188351a$var$O = [], $832acc902188351a$var$P = 1, $832acc902188351a$var$Q = null, $832acc902188351a$var$R = 3, $832acc902188351a$var$S = !1, $832acc902188351a$var$T = !1, $832acc902188351a$var$U = !1;
function $832acc902188351a$var$V(a) {
    for(var b = $832acc902188351a$var$L($832acc902188351a$var$O); null !== b;){
        if (null === b.callback) $832acc902188351a$var$M($832acc902188351a$var$O);
        else if (b.startTime <= a) $832acc902188351a$var$M($832acc902188351a$var$O), b.sortIndex = b.expirationTime, $832acc902188351a$var$J($832acc902188351a$var$N, b);
        else break;
        b = $832acc902188351a$var$L($832acc902188351a$var$O);
    }
}
function $832acc902188351a$var$W(a) {
    $832acc902188351a$var$U = !1;
    $832acc902188351a$var$V(a);
    if (!$832acc902188351a$var$T) {
        if (null !== $832acc902188351a$var$L($832acc902188351a$var$N)) $832acc902188351a$var$T = !0, $832acc902188351a$var$f($832acc902188351a$var$X);
        else {
            var b = $832acc902188351a$var$L($832acc902188351a$var$O);
            null !== b && $832acc902188351a$var$g($832acc902188351a$var$W, b.startTime - a);
        }
    }
}
function $832acc902188351a$var$X(a, b) {
    $832acc902188351a$var$T = !1;
    $832acc902188351a$var$U && ($832acc902188351a$var$U = !1, $832acc902188351a$var$h());
    $832acc902188351a$var$S = !0;
    var c = $832acc902188351a$var$R;
    try {
        $832acc902188351a$var$V(b);
        for($832acc902188351a$var$Q = $832acc902188351a$var$L($832acc902188351a$var$N); null !== $832acc902188351a$var$Q && (!($832acc902188351a$var$Q.expirationTime > b) || a && !$832acc902188351a$var$k());){
            var d = $832acc902188351a$var$Q.callback;
            if (null !== d) {
                $832acc902188351a$var$Q.callback = null;
                $832acc902188351a$var$R = $832acc902188351a$var$Q.priorityLevel;
                var e = d($832acc902188351a$var$Q.expirationTime <= b);
                b = $832acc902188351a$export$c4744153514ff05d();
                "function" === typeof e ? $832acc902188351a$var$Q.callback = e : $832acc902188351a$var$Q === $832acc902188351a$var$L($832acc902188351a$var$N) && $832acc902188351a$var$M($832acc902188351a$var$N);
                $832acc902188351a$var$V(b);
            } else $832acc902188351a$var$M($832acc902188351a$var$N);
            $832acc902188351a$var$Q = $832acc902188351a$var$L($832acc902188351a$var$N);
        }
        if (null !== $832acc902188351a$var$Q) var m = !0;
        else {
            var n = $832acc902188351a$var$L($832acc902188351a$var$O);
            null !== n && $832acc902188351a$var$g($832acc902188351a$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $832acc902188351a$var$Q = null, $832acc902188351a$var$R = c, $832acc902188351a$var$S = !1;
    }
}
function $832acc902188351a$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $832acc902188351a$var$Z = $832acc902188351a$var$l;
$832acc902188351a$export$3e506c1ccc9cc1a7 = 5;
$832acc902188351a$export$e26fe2ed2fa76875 = 1;
$832acc902188351a$export$502329bbf4b505b1 = 4;
$832acc902188351a$export$6e3807111c4874c4 = 3;
$832acc902188351a$export$c27134553091fb3a = null;
$832acc902188351a$export$33ee1acdc04fd2a2 = 2;
$832acc902188351a$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$832acc902188351a$export$8352ce38b91d0c62 = function() {
    $832acc902188351a$var$T || $832acc902188351a$var$S || ($832acc902188351a$var$T = !0, $832acc902188351a$var$f($832acc902188351a$var$X));
};
$832acc902188351a$export$d3dfb8e4810cb555 = function() {
    return $832acc902188351a$var$R;
};
$832acc902188351a$export$839f9183b0465a69 = function() {
    return $832acc902188351a$var$L($832acc902188351a$var$N);
};
$832acc902188351a$export$72fdf0e06517287b = function(a) {
    switch($832acc902188351a$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $832acc902188351a$var$R;
    }
    var c = $832acc902188351a$var$R;
    $832acc902188351a$var$R = b;
    try {
        return a();
    } finally{
        $832acc902188351a$var$R = c;
    }
};
$832acc902188351a$export$4b844e58a3e414b4 = function() {};
$832acc902188351a$export$816d2913ae6b83b1 = $832acc902188351a$var$Z;
$832acc902188351a$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $832acc902188351a$var$R;
    $832acc902188351a$var$R = a;
    try {
        return b();
    } finally{
        $832acc902188351a$var$R = c;
    }
};
$832acc902188351a$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $832acc902188351a$export$c4744153514ff05d();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $832acc902188351a$var$Y(a);
    } else c = $832acc902188351a$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $832acc902188351a$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $832acc902188351a$var$J($832acc902188351a$var$O, a), null === $832acc902188351a$var$L($832acc902188351a$var$N) && a === $832acc902188351a$var$L($832acc902188351a$var$O) && ($832acc902188351a$var$U ? $832acc902188351a$var$h() : $832acc902188351a$var$U = !0, $832acc902188351a$var$g($832acc902188351a$var$W, e - d))) : (a.sortIndex = c, $832acc902188351a$var$J($832acc902188351a$var$N, a), $832acc902188351a$var$T || $832acc902188351a$var$S || ($832acc902188351a$var$T = !0, $832acc902188351a$var$f($832acc902188351a$var$X)));
    return a;
};
$832acc902188351a$export$b5836b71941fa3ed = function() {
    var a = $832acc902188351a$export$c4744153514ff05d();
    $832acc902188351a$var$V(a);
    var b = $832acc902188351a$var$L($832acc902188351a$var$N);
    return b !== $832acc902188351a$var$Q && null !== $832acc902188351a$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $832acc902188351a$var$Q.expirationTime || $832acc902188351a$var$k();
};
$832acc902188351a$export$cf845f2c119da08a = function(a) {
    var b = $832acc902188351a$var$R;
    return function() {
        var c = $832acc902188351a$var$R;
        $832acc902188351a$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $832acc902188351a$var$R = c;
        }
    };
};

});



parcelRegister("ebCRU", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $iAJ47 = parcelRequire("iAJ47");
function $a5403e3bef6fe398$var$emptyFunction() {}
function $a5403e3bef6fe398$var$emptyFunctionWithReset() {}
$a5403e3bef6fe398$var$emptyFunctionWithReset.resetWarningCache = $a5403e3bef6fe398$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $iAJ47) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $a5403e3bef6fe398$var$emptyFunctionWithReset,
        resetWarningCache: $a5403e3bef6fe398$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("iAJ47", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $d88e8bd587f9fd0c$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $d88e8bd587f9fd0c$var$ReactPropTypesSecret;

});


parcelRegister("k6CB6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fH1jI = parcelRequire("fH1jI");

var $dOn3g = parcelRequire("dOn3g");

var $Q3fdz = parcelRequire("Q3fdz");

var $jkcsT = parcelRequire("jkcsT");
var $ea324eda473f9ed9$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new $Q3fdz.RawSha256();
        if (secret) {
            this.outer = new $Q3fdz.RawSha256();
            var inner = $ea324eda473f9ed9$var$bufferFromSecret(secret);
            var outer = new Uint8Array($dOn3g.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $dOn3g.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ($ea324eda473f9ed9$var$isEmptyData(toHash) || this.error) return;
        try {
            this.hash.update($ea324eda473f9ed9$var$convertToBuffer(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return $fH1jI.__awaiter(this, void 0, void 0, function() {
            return $fH1jI.__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $ea324eda473f9ed9$var$Sha256;
function $ea324eda473f9ed9$var$bufferFromSecret(secret) {
    var input = $ea324eda473f9ed9$var$convertToBuffer(secret);
    if (input.byteLength > $dOn3g.BLOCK_SIZE) {
        var bufferHash = new $Q3fdz.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($dOn3g.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}
function $ea324eda473f9ed9$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
function $ea324eda473f9ed9$var$convertToBuffer(data) {
    if (typeof data === "string") return $jkcsT.fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

});
parcelRegister("fH1jI", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $b6cbe4ada0aec14b$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $b6cbe4ada0aec14b$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $b6cbe4ada0aec14b$export$3c9a16f847548506; });
$parcel$export(module.exports, "__awaiter", function () { return $b6cbe4ada0aec14b$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $b6cbe4ada0aec14b$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__exportStar", function () { return $b6cbe4ada0aec14b$export$f33643c0debef087; });
$parcel$export(module.exports, "__values", function () { return $b6cbe4ada0aec14b$export$19a8beecd37a4c45; });
$parcel$export(module.exports, "__read", function () { return $b6cbe4ada0aec14b$export$8d051b38c9118094; });
$parcel$export(module.exports, "__spread", function () { return $b6cbe4ada0aec14b$export$afc72e2116322959; });
$parcel$export(module.exports, "__spreadArrays", function () { return $b6cbe4ada0aec14b$export$6388937ca91ccae8; });
$parcel$export(module.exports, "__await", function () { return $b6cbe4ada0aec14b$export$10c90e4f7922046c; });
$parcel$export(module.exports, "__asyncGenerator", function () { return $b6cbe4ada0aec14b$export$e427f37a30a4de9b; });
$parcel$export(module.exports, "__asyncValues", function () { return $b6cbe4ada0aec14b$export$e3b29a3d6162315f; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $b6cbe4ada0aec14b$var$extendStatics = function(d, b) {
    $b6cbe4ada0aec14b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $b6cbe4ada0aec14b$var$extendStatics(d, b);
};
function $b6cbe4ada0aec14b$export$a8ba968b8961cb8a(d, b) {
    $b6cbe4ada0aec14b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b6cbe4ada0aec14b$export$18ce0697a983be9b = function() {
    $b6cbe4ada0aec14b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b6cbe4ada0aec14b$export$18ce0697a983be9b.apply(this, arguments);
};
function $b6cbe4ada0aec14b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b6cbe4ada0aec14b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b6cbe4ada0aec14b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b6cbe4ada0aec14b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b6cbe4ada0aec14b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b6cbe4ada0aec14b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $b6cbe4ada0aec14b$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $b6cbe4ada0aec14b$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $b6cbe4ada0aec14b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b6cbe4ada0aec14b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b6cbe4ada0aec14b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b6cbe4ada0aec14b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b6cbe4ada0aec14b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b6cbe4ada0aec14b$export$10c90e4f7922046c(v) {
    return this instanceof $b6cbe4ada0aec14b$export$10c90e4f7922046c ? (this.v = v, this) : new $b6cbe4ada0aec14b$export$10c90e4f7922046c(v);
}
function $b6cbe4ada0aec14b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b6cbe4ada0aec14b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b6cbe4ada0aec14b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b6cbe4ada0aec14b$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $b6cbe4ada0aec14b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b6cbe4ada0aec14b$export$19a8beecd37a4c45 === "function" ? $b6cbe4ada0aec14b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b6cbe4ada0aec14b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $b6cbe4ada0aec14b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $b6cbe4ada0aec14b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b6cbe4ada0aec14b$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $b6cbe4ada0aec14b$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("dOn3g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRegister("Q3fdz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dOn3g = parcelRequire("dOn3g");
/**
 * @internal
 */ var $09c75fb940a6b5ff$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($dOn3g.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $dOn3g.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $dOn3g.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $dOn3g.BLOCK_SIZE >= $dOn3g.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $dOn3g.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $dOn3g.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($dOn3g.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($dOn3g.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($dOn3g.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $dOn3g.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($dOn3g.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $09c75fb940a6b5ff$var$RawSha256;

});

parcelRegister("jkcsT", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $e1198de31a467cc1$export$c7c5cef950a4d2fc; });

var $9xNvR = parcelRequire("9xNvR");

var $3F3j7 = parcelRequire("3F3j7");
var $e1198de31a467cc1$export$c7c5cef950a4d2fc = function(input) {
    return typeof TextEncoder === "function" ? (0, $3F3j7.fromUtf8)(input) : (0, $9xNvR.fromUtf8)(input);
};
var $e1198de31a467cc1$export$b4b216764bb846eb = function(input) {
    return typeof TextDecoder === "function" ? (0, $3F3j7.toUtf8)(input) : (0, $9xNvR.toUtf8)(input);
};

});
parcelRegister("9xNvR", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $6f2d9a59bee70863$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $6f2d9a59bee70863$export$b4b216764bb846eb; });
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var $6f2d9a59bee70863$export$c7c5cef950a4d2fc = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var $6f2d9a59bee70863$export$b4b216764bb846eb = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRegister("3F3j7", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $2aa7c438abcb9727$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $2aa7c438abcb9727$export$b4b216764bb846eb; });
function $2aa7c438abcb9727$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $2aa7c438abcb9727$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});



parcelRegister("2qlBa", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ 'use strict';

var $3Z1AC = parcelRequire("3Z1AC");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};

var $amiiN = parcelRequire("amiiN");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === 'object' && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== 'string') throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $amiiN.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf('@', hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || '';
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $3Z1AC.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $amiiN.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === 'string') obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) query = $amiiN.stringify(this.query, {
        arrayFormat: 'repeat',
        addQueryPrefix: false
    });
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === 'string') {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = '/';
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (srcPath.length > 0) result.pathname = srcPath.join('/');
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("3Z1AC", function(module, exports) {
/*! https://mths.be/punycode v1.4.1 by @mathias */ (function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.4.1',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("amiiN", function(module, exports) {
'use strict';

var $97t8x = parcelRequire("97t8x");

var $iU4ge = parcelRequire("iU4ge");

var $aRIWH = parcelRequire("aRIWH");
module.exports = {
    formats: $aRIWH,
    parse: $iU4ge,
    stringify: $97t8x
};

});
parcelRegister("97t8x", function(module, exports) {
'use strict';

var $fQlJQ = parcelRequire("fQlJQ");

var $6bVvS = parcelRequire("6bVvS");

var $aRIWH = parcelRequire("aRIWH");
var $6a3b5e770f1e71cc$var$has = Object.prototype.hasOwnProperty;
var $6a3b5e770f1e71cc$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $6a3b5e770f1e71cc$var$isArray = Array.isArray;
var $6a3b5e770f1e71cc$var$push = Array.prototype.push;
var $6a3b5e770f1e71cc$var$pushToArray = function(arr, valueOrArray) {
    $6a3b5e770f1e71cc$var$push.apply(arr, $6a3b5e770f1e71cc$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $6a3b5e770f1e71cc$var$toISO = Date.prototype.toISOString;
var $6a3b5e770f1e71cc$var$defaultFormat = $aRIWH.default;
var $6a3b5e770f1e71cc$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $6bVvS.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $6a3b5e770f1e71cc$var$defaultFormat,
    formatter: $aRIWH.formatters[$6a3b5e770f1e71cc$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $6a3b5e770f1e71cc$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $6a3b5e770f1e71cc$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $6a3b5e770f1e71cc$var$sentinel = {};
var $6a3b5e770f1e71cc$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($6a3b5e770f1e71cc$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($6a3b5e770f1e71cc$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $6a3b5e770f1e71cc$var$isArray(obj)) obj = $6bVvS.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return formatter(encoder && !encodeValuesOnly ? encoder(prefix, $6a3b5e770f1e71cc$var$defaults.encoder, charset, 'key', format) : prefix);
        obj = '';
    }
    if ($6a3b5e770f1e71cc$var$isNonNullishPrimitive(obj) || $6bVvS.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $6a3b5e770f1e71cc$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $6a3b5e770f1e71cc$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $6a3b5e770f1e71cc$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $6bVvS.maybeMap(obj, function(v) {
            return v == null ? v : encoder(v);
        });
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($6a3b5e770f1e71cc$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $6a3b5e770f1e71cc$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $6a3b5e770f1e71cc$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $6a3b5e770f1e71cc$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $fQlJQ();
        valueSideChannel.set($6a3b5e770f1e71cc$var$sentinel, sideChannel);
        $6a3b5e770f1e71cc$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $6a3b5e770f1e71cc$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $6a3b5e770f1e71cc$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $6a3b5e770f1e71cc$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $6a3b5e770f1e71cc$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $aRIWH.default;
    if (typeof opts.format !== 'undefined') {
        if (!$6a3b5e770f1e71cc$var$has.call($aRIWH.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $aRIWH.formatters[format];
    var filter = $6a3b5e770f1e71cc$var$defaults.filter;
    if (typeof opts.filter === 'function' || $6a3b5e770f1e71cc$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $6a3b5e770f1e71cc$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $6a3b5e770f1e71cc$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $6a3b5e770f1e71cc$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $6a3b5e770f1e71cc$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $6a3b5e770f1e71cc$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $6a3b5e770f1e71cc$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $6a3b5e770f1e71cc$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $6a3b5e770f1e71cc$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $6a3b5e770f1e71cc$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $6a3b5e770f1e71cc$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $6a3b5e770f1e71cc$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $6a3b5e770f1e71cc$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $6a3b5e770f1e71cc$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $6a3b5e770f1e71cc$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $6a3b5e770f1e71cc$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($6a3b5e770f1e71cc$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $6a3b5e770f1e71cc$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $fQlJQ();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (typeof key === 'undefined' || key === null) continue;
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $6a3b5e770f1e71cc$var$pushToArray(keys, $6a3b5e770f1e71cc$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B' + options.delimiter;
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93' + options.delimiter;
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("fQlJQ", function(module, exports) {
'use strict';

var $20Zn0 = parcelRequire("20Zn0");

var $iQpYf = parcelRequire("iQpYf");

var $86Wlf = parcelRequire("86Wlf");

var $hP77y = parcelRequire("hP77y");

var $cYq8y = parcelRequire("cYq8y");
var $b88c93286bc52728$var$makeChannel = $cYq8y || $hP77y || $86Wlf;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) {
                var keyDesc = key && Object(key) === key ? 'the given object key' : $iQpYf(key);
                throw new $20Zn0('Side channel does not contain ' + keyDesc);
            }
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $b88c93286bc52728$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    return channel;
};

});
parcelRegister("20Zn0", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("iQpYf", function(module, exports) {
var $db813a9803de1914$var$hasMap = typeof Map === 'function' && Map.prototype;
var $db813a9803de1914$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $db813a9803de1914$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $db813a9803de1914$var$mapSize = $db813a9803de1914$var$hasMap && $db813a9803de1914$var$mapSizeDescriptor && typeof $db813a9803de1914$var$mapSizeDescriptor.get === 'function' ? $db813a9803de1914$var$mapSizeDescriptor.get : null;
var $db813a9803de1914$var$mapForEach = $db813a9803de1914$var$hasMap && Map.prototype.forEach;
var $db813a9803de1914$var$hasSet = typeof Set === 'function' && Set.prototype;
var $db813a9803de1914$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $db813a9803de1914$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $db813a9803de1914$var$setSize = $db813a9803de1914$var$hasSet && $db813a9803de1914$var$setSizeDescriptor && typeof $db813a9803de1914$var$setSizeDescriptor.get === 'function' ? $db813a9803de1914$var$setSizeDescriptor.get : null;
var $db813a9803de1914$var$setForEach = $db813a9803de1914$var$hasSet && Set.prototype.forEach;
var $db813a9803de1914$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $db813a9803de1914$var$weakMapHas = $db813a9803de1914$var$hasWeakMap ? WeakMap.prototype.has : null;
var $db813a9803de1914$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $db813a9803de1914$var$weakSetHas = $db813a9803de1914$var$hasWeakSet ? WeakSet.prototype.has : null;
var $db813a9803de1914$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $db813a9803de1914$var$weakRefDeref = $db813a9803de1914$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $db813a9803de1914$var$booleanValueOf = Boolean.prototype.valueOf;
var $db813a9803de1914$var$objectToString = Object.prototype.toString;
var $db813a9803de1914$var$functionToString = Function.prototype.toString;
var $db813a9803de1914$var$$match = String.prototype.match;
var $db813a9803de1914$var$$slice = String.prototype.slice;
var $db813a9803de1914$var$$replace = String.prototype.replace;
var $db813a9803de1914$var$$toUpperCase = String.prototype.toUpperCase;
var $db813a9803de1914$var$$toLowerCase = String.prototype.toLowerCase;
var $db813a9803de1914$var$$test = RegExp.prototype.test;
var $db813a9803de1914$var$$concat = Array.prototype.concat;
var $db813a9803de1914$var$$join = Array.prototype.join;
var $db813a9803de1914$var$$arrSlice = Array.prototype.slice;
var $db813a9803de1914$var$$floor = Math.floor;
var $db813a9803de1914$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $db813a9803de1914$var$gOPS = Object.getOwnPropertySymbols;
var $db813a9803de1914$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $db813a9803de1914$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $db813a9803de1914$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $db813a9803de1914$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $db813a9803de1914$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $db813a9803de1914$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $db813a9803de1914$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $db813a9803de1914$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$db813a9803de1914$var$$floor(-num) : $db813a9803de1914$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $db813a9803de1914$var$$slice.call(str, intStr.length + 1);
            return $db813a9803de1914$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $db813a9803de1914$var$$replace.call($db813a9803de1914$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $db813a9803de1914$var$$replace.call(str, sepRegex, '$&_');
}

var $6N7cq = parcelRequire("6N7cq");
var $db813a9803de1914$var$inspectCustom = $6N7cq.custom;
var $db813a9803de1914$var$inspectSymbol = $db813a9803de1914$var$isSymbol($db813a9803de1914$var$inspectCustom) ? $db813a9803de1914$var$inspectCustom : null;
var $db813a9803de1914$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $db813a9803de1914$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($db813a9803de1914$var$has(opts, 'quoteStyle') && !$db813a9803de1914$var$has($db813a9803de1914$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($db813a9803de1914$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $db813a9803de1914$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($db813a9803de1914$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($db813a9803de1914$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $db813a9803de1914$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $db813a9803de1914$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $db813a9803de1914$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $db813a9803de1914$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $db813a9803de1914$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($db813a9803de1914$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $db813a9803de1914$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($db813a9803de1914$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$db813a9803de1914$var$isRegExp(obj)) {
        var name = $db813a9803de1914$var$nameOf(obj);
        var keys = $db813a9803de1914$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $db813a9803de1914$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($db813a9803de1914$var$isSymbol(obj)) {
        var symString = $db813a9803de1914$var$hasShammedSymbols ? $db813a9803de1914$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $db813a9803de1914$var$symToString.call(obj);
        return typeof obj === 'object' && !$db813a9803de1914$var$hasShammedSymbols ? $db813a9803de1914$var$markBoxed(symString) : symString;
    }
    if ($db813a9803de1914$var$isElement(obj)) {
        var s = '<' + $db813a9803de1914$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $db813a9803de1914$var$wrapQuotes($db813a9803de1914$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $db813a9803de1914$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($db813a9803de1914$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $db813a9803de1914$var$arrObjKeys(obj, inspect);
        if (indent && !$db813a9803de1914$var$singleLineValues(xs)) return '[' + $db813a9803de1914$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $db813a9803de1914$var$$join.call(xs, ', ') + ' ]';
    }
    if ($db813a9803de1914$var$isError(obj)) {
        var parts = $db813a9803de1914$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$db813a9803de1914$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $db813a9803de1914$var$$join.call($db813a9803de1914$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $db813a9803de1914$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($db813a9803de1914$var$inspectSymbol && typeof obj[$db813a9803de1914$var$inspectSymbol] === 'function' && $6N7cq) return $6N7cq(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($db813a9803de1914$var$isMap(obj)) {
        var mapParts = [];
        if ($db813a9803de1914$var$mapForEach) $db813a9803de1914$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $db813a9803de1914$var$collectionOf('Map', $db813a9803de1914$var$mapSize.call(obj), mapParts, indent);
    }
    if ($db813a9803de1914$var$isSet(obj)) {
        var setParts = [];
        if ($db813a9803de1914$var$setForEach) $db813a9803de1914$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $db813a9803de1914$var$collectionOf('Set', $db813a9803de1914$var$setSize.call(obj), setParts, indent);
    }
    if ($db813a9803de1914$var$isWeakMap(obj)) return $db813a9803de1914$var$weakCollectionOf('WeakMap');
    if ($db813a9803de1914$var$isWeakSet(obj)) return $db813a9803de1914$var$weakCollectionOf('WeakSet');
    if ($db813a9803de1914$var$isWeakRef(obj)) return $db813a9803de1914$var$weakCollectionOf('WeakRef');
    if ($db813a9803de1914$var$isNumber(obj)) return $db813a9803de1914$var$markBoxed(inspect(Number(obj)));
    if ($db813a9803de1914$var$isBigInt(obj)) return $db813a9803de1914$var$markBoxed(inspect($db813a9803de1914$var$bigIntValueOf.call(obj)));
    if ($db813a9803de1914$var$isBoolean(obj)) return $db813a9803de1914$var$markBoxed($db813a9803de1914$var$booleanValueOf.call(obj));
    if ($db813a9803de1914$var$isString(obj)) return $db813a9803de1914$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$db813a9803de1914$var$isDate(obj) && !$db813a9803de1914$var$isRegExp(obj)) {
        var ys = $db813a9803de1914$var$arrObjKeys(obj, inspect);
        var isPlainObject = $db813a9803de1914$var$gPO ? $db813a9803de1914$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $db813a9803de1914$var$toStringTag && Object(obj) === obj && $db813a9803de1914$var$toStringTag in obj ? $db813a9803de1914$var$$slice.call($db813a9803de1914$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $db813a9803de1914$var$$join.call($db813a9803de1914$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $db813a9803de1914$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $db813a9803de1914$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $db813a9803de1914$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $db813a9803de1914$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $db813a9803de1914$var$quote(s) {
    return $db813a9803de1914$var$$replace.call(String(s), /"/g, '&quot;');
}
function $db813a9803de1914$var$canTrustToString(obj) {
    return !$db813a9803de1914$var$toStringTag || !(typeof obj === 'object' && ($db813a9803de1914$var$toStringTag in obj || typeof obj[$db813a9803de1914$var$toStringTag] !== 'undefined'));
}
function $db813a9803de1914$var$isArray(obj) {
    return $db813a9803de1914$var$toStr(obj) === '[object Array]' && $db813a9803de1914$var$canTrustToString(obj);
}
function $db813a9803de1914$var$isDate(obj) {
    return $db813a9803de1914$var$toStr(obj) === '[object Date]' && $db813a9803de1914$var$canTrustToString(obj);
}
function $db813a9803de1914$var$isRegExp(obj) {
    return $db813a9803de1914$var$toStr(obj) === '[object RegExp]' && $db813a9803de1914$var$canTrustToString(obj);
}
function $db813a9803de1914$var$isError(obj) {
    return $db813a9803de1914$var$toStr(obj) === '[object Error]' && $db813a9803de1914$var$canTrustToString(obj);
}
function $db813a9803de1914$var$isString(obj) {
    return $db813a9803de1914$var$toStr(obj) === '[object String]' && $db813a9803de1914$var$canTrustToString(obj);
}
function $db813a9803de1914$var$isNumber(obj) {
    return $db813a9803de1914$var$toStr(obj) === '[object Number]' && $db813a9803de1914$var$canTrustToString(obj);
}
function $db813a9803de1914$var$isBoolean(obj) {
    return $db813a9803de1914$var$toStr(obj) === '[object Boolean]' && $db813a9803de1914$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $db813a9803de1914$var$isSymbol(obj) {
    if ($db813a9803de1914$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$db813a9803de1914$var$symToString) return false;
    try {
        $db813a9803de1914$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $db813a9803de1914$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$db813a9803de1914$var$bigIntValueOf) return false;
    try {
        $db813a9803de1914$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $db813a9803de1914$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $db813a9803de1914$var$has(obj, key) {
    return $db813a9803de1914$var$hasOwn.call(obj, key);
}
function $db813a9803de1914$var$toStr(obj) {
    return $db813a9803de1914$var$objectToString.call(obj);
}
function $db813a9803de1914$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $db813a9803de1914$var$$match.call($db813a9803de1914$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $db813a9803de1914$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $db813a9803de1914$var$isMap(x) {
    if (!$db813a9803de1914$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $db813a9803de1914$var$mapSize.call(x);
        try {
            $db813a9803de1914$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $db813a9803de1914$var$isWeakMap(x) {
    if (!$db813a9803de1914$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $db813a9803de1914$var$weakMapHas.call(x, $db813a9803de1914$var$weakMapHas);
        try {
            $db813a9803de1914$var$weakSetHas.call(x, $db813a9803de1914$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $db813a9803de1914$var$isWeakRef(x) {
    if (!$db813a9803de1914$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $db813a9803de1914$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $db813a9803de1914$var$isSet(x) {
    if (!$db813a9803de1914$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $db813a9803de1914$var$setSize.call(x);
        try {
            $db813a9803de1914$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $db813a9803de1914$var$isWeakSet(x) {
    if (!$db813a9803de1914$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $db813a9803de1914$var$weakSetHas.call(x, $db813a9803de1914$var$weakSetHas);
        try {
            $db813a9803de1914$var$weakMapHas.call(x, $db813a9803de1914$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $db813a9803de1914$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $db813a9803de1914$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $db813a9803de1914$var$inspectString($db813a9803de1914$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $db813a9803de1914$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $db813a9803de1914$var$$replace.call($db813a9803de1914$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $db813a9803de1914$var$lowbyte);
    return $db813a9803de1914$var$wrapQuotes(s, 'single', opts);
}
function $db813a9803de1914$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $db813a9803de1914$var$$toUpperCase.call(n.toString(16));
}
function $db813a9803de1914$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $db813a9803de1914$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $db813a9803de1914$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $db813a9803de1914$var$indentedJoin(entries, indent) : $db813a9803de1914$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $db813a9803de1914$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($db813a9803de1914$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $db813a9803de1914$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $db813a9803de1914$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $db813a9803de1914$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $db813a9803de1914$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $db813a9803de1914$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $db813a9803de1914$var$arrObjKeys(obj, inspect) {
    var isArr = $db813a9803de1914$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $db813a9803de1914$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $db813a9803de1914$var$gOPS === 'function' ? $db813a9803de1914$var$gOPS(obj) : [];
    var symMap;
    if ($db813a9803de1914$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$db813a9803de1914$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($db813a9803de1914$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($db813a9803de1914$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $db813a9803de1914$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($db813a9803de1914$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("6N7cq", function(module, exports) {
"use strict";

});


parcelRegister("86Wlf", function(module, exports) {
'use strict';

var $iQpYf = parcelRequire("iQpYf");

var $20Zn0 = parcelRequire("20Zn0");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $5e7c23b2decd5299$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $5e7c23b2decd5299$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $5e7c23b2decd5299$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $5e7c23b2decd5299$var$listSet = function(objects, key, value) {
    var node = $5e7c23b2decd5299$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $5e7c23b2decd5299$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$5e7c23b2decd5299$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $5e7c23b2decd5299$var$listDelete = function(objects, key) {
    if (objects) return $5e7c23b2decd5299$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $20Zn0('Side channel does not contain ' + $iQpYf(key));
        },
        'delete': function(key) {
            var deletedNode = $5e7c23b2decd5299$var$listDelete($o, key);
            if (deletedNode && $o && !$o.next) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $5e7c23b2decd5299$var$listGet($o, key);
        },
        has: function(key) {
            return $5e7c23b2decd5299$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $5e7c23b2decd5299$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    return channel;
};

});

parcelRegister("hP77y", function(module, exports) {
'use strict';

var $7Aezy = parcelRequire("7Aezy");

var $6QSoo = parcelRequire("6QSoo");

var $iQpYf = parcelRequire("iQpYf");

var $20Zn0 = parcelRequire("20Zn0");
var $cf9cb92072f66b39$var$$Map = $7Aezy('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $cf9cb92072f66b39$var$$mapGet = $6QSoo('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $cf9cb92072f66b39$var$$mapSet = $6QSoo('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $cf9cb92072f66b39$var$$mapHas = $6QSoo('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $cf9cb92072f66b39$var$$mapDelete = $6QSoo('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $cf9cb92072f66b39$var$$mapSize = $6QSoo('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$cf9cb92072f66b39$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $20Zn0('Side channel does not contain ' + $iQpYf(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $cf9cb92072f66b39$var$$mapDelete($m, key);
                if ($cf9cb92072f66b39$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $cf9cb92072f66b39$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $cf9cb92072f66b39$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $cf9cb92072f66b39$var$$Map();
            $cf9cb92072f66b39$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("7Aezy", function(module, exports) {
'use strict';
var $585732f9664f97cd$var$undefined1;

var $hk0ZX = parcelRequire("hk0ZX");

var $2qKql = parcelRequire("2qKql");

var $cAsgQ = parcelRequire("cAsgQ");

var $fu0ky = parcelRequire("fu0ky");

var $78G6K = parcelRequire("78G6K");

var $10xMb = parcelRequire("10xMb");

var $20Zn0 = parcelRequire("20Zn0");

var $aMV53 = parcelRequire("aMV53");

var $iLBOF = parcelRequire("iLBOF");

var $9yUDQ = parcelRequire("9yUDQ");

var $3DuMp = parcelRequire("3DuMp");

var $bKHUa = parcelRequire("bKHUa");

var $gxrZd = parcelRequire("gxrZd");

var $i0duY = parcelRequire("i0duY");

var $iSWmy = parcelRequire("iSWmy");
var $585732f9664f97cd$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $585732f9664f97cd$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $585732f9664f97cd$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $h6xkJ = parcelRequire("h6xkJ");

var $caycu = parcelRequire("caycu");
var $585732f9664f97cd$var$throwTypeError = function() {
    throw new $20Zn0();
};
var $585732f9664f97cd$var$ThrowTypeError = $h6xkJ ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $585732f9664f97cd$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $h6xkJ(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $585732f9664f97cd$var$throwTypeError;
        }
    }
}() : $585732f9664f97cd$var$throwTypeError;

var $585732f9664f97cd$var$hasSymbols = (parcelRequire("bdcGK"))();

var $gXVYa = parcelRequire("gXVYa");

var $az7B4 = parcelRequire("az7B4");

var $9Cm6z = parcelRequire("9Cm6z");

var $gqs1G = parcelRequire("gqs1G");

var $9RRss = parcelRequire("9RRss");
var $585732f9664f97cd$var$needsEval = {};
var $585732f9664f97cd$var$TypedArray = typeof Uint8Array === 'undefined' || !$gXVYa ? undefined : $gXVYa(Uint8Array);
var $585732f9664f97cd$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $585732f9664f97cd$var$hasSymbols && $gXVYa ? $gXVYa([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $585732f9664f97cd$var$needsEval,
    '%AsyncGenerator%': $585732f9664f97cd$var$needsEval,
    '%AsyncGeneratorFunction%': $585732f9664f97cd$var$needsEval,
    '%AsyncIteratorPrototype%': $585732f9664f97cd$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $2qKql,
    '%eval%': eval,
    '%EvalError%': $cAsgQ,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $585732f9664f97cd$var$$Function,
    '%GeneratorFunction%': $585732f9664f97cd$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $585732f9664f97cd$var$hasSymbols && $gXVYa ? $gXVYa($gXVYa([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$585732f9664f97cd$var$hasSymbols || !$gXVYa ? undefined : $gXVYa(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $hk0ZX,
    '%Object.getOwnPropertyDescriptor%': $h6xkJ,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $fu0ky,
    '%ReferenceError%': $78G6K,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$585732f9664f97cd$var$hasSymbols || !$gXVYa ? undefined : $gXVYa(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $585732f9664f97cd$var$hasSymbols && $gXVYa ? $gXVYa(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $585732f9664f97cd$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $10xMb,
    '%ThrowTypeError%': $585732f9664f97cd$var$ThrowTypeError,
    '%TypedArray%': $585732f9664f97cd$var$TypedArray,
    '%TypeError%': $20Zn0,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $aMV53,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9RRss,
    '%Function.prototype.apply%': $gqs1G,
    '%Object.defineProperty%': $caycu,
    '%Object.getPrototypeOf%': $az7B4,
    '%Math.abs%': $iLBOF,
    '%Math.floor%': $9yUDQ,
    '%Math.max%': $3DuMp,
    '%Math.min%': $bKHUa,
    '%Math.pow%': $gxrZd,
    '%Math.round%': $i0duY,
    '%Math.sign%': $iSWmy,
    '%Reflect.getPrototypeOf%': $9Cm6z
};
if ($gXVYa) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $585732f9664f97cd$var$errorProto = $gXVYa($gXVYa(e));
    $585732f9664f97cd$var$INTRINSICS['%Error.prototype%'] = $585732f9664f97cd$var$errorProto;
}
var $585732f9664f97cd$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $585732f9664f97cd$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $585732f9664f97cd$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $585732f9664f97cd$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $gXVYa) value = $gXVYa(gen.prototype);
    }
    $585732f9664f97cd$var$INTRINSICS[name] = value;
    return value;
};
var $585732f9664f97cd$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $kgO2R = parcelRequire("kgO2R");

var $fA0g4 = parcelRequire("fA0g4");
var $585732f9664f97cd$var$$concat = $kgO2R.call($9RRss, Array.prototype.concat);
var $585732f9664f97cd$var$$spliceApply = $kgO2R.call($gqs1G, Array.prototype.splice);
var $585732f9664f97cd$var$$replace = $kgO2R.call($9RRss, String.prototype.replace);
var $585732f9664f97cd$var$$strSlice = $kgO2R.call($9RRss, String.prototype.slice);
var $585732f9664f97cd$var$$exec = $kgO2R.call($9RRss, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $585732f9664f97cd$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $585732f9664f97cd$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $585732f9664f97cd$var$stringToPath = function stringToPath(string) {
    var first = $585732f9664f97cd$var$$strSlice(string, 0, 1);
    var last = $585732f9664f97cd$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $10xMb('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $10xMb('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $585732f9664f97cd$var$$replace(string, $585732f9664f97cd$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $585732f9664f97cd$var$$replace(subString, $585732f9664f97cd$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $585732f9664f97cd$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($fA0g4($585732f9664f97cd$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $585732f9664f97cd$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($fA0g4($585732f9664f97cd$var$INTRINSICS, intrinsicName)) {
        var value = $585732f9664f97cd$var$INTRINSICS[intrinsicName];
        if (value === $585732f9664f97cd$var$needsEval) value = $585732f9664f97cd$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $20Zn0('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $10xMb('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $20Zn0('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $20Zn0('"allowMissing" argument must be a boolean');
    if ($585732f9664f97cd$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $10xMb('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $585732f9664f97cd$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $585732f9664f97cd$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $585732f9664f97cd$var$$spliceApply(parts, $585732f9664f97cd$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $585732f9664f97cd$var$$strSlice(part, 0, 1);
        var last = $585732f9664f97cd$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $10xMb('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($fA0g4($585732f9664f97cd$var$INTRINSICS, intrinsicRealName)) value = $585732f9664f97cd$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $20Zn0('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($h6xkJ && i + 1 >= parts.length) {
                var desc = $h6xkJ(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $fA0g4(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $585732f9664f97cd$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("hk0ZX", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("2qKql", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("cAsgQ", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("fu0ky", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("78G6K", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("10xMb", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("aMV53", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("iLBOF", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("9yUDQ", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("3DuMp", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("bKHUa", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("gxrZd", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("i0duY", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("iSWmy", function(module, exports) {
'use strict';

var $lWPZP = parcelRequire("lWPZP");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($lWPZP(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("lWPZP", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("h6xkJ", function(module, exports) {
'use strict';

var $0QBUn = parcelRequire("0QBUn");
var $c73cda8595910a94$require$$gOPD = $0QBUn;
if ($c73cda8595910a94$require$$gOPD) try {
    $c73cda8595910a94$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $c73cda8595910a94$require$$gOPD = null;
}
module.exports = $c73cda8595910a94$require$$gOPD;

});
parcelRegister("0QBUn", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("caycu", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $8dc0f2b815407044$var$$defineProperty = Object.defineProperty || false;
if ($8dc0f2b815407044$var$$defineProperty) try {
    $8dc0f2b815407044$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $8dc0f2b815407044$var$$defineProperty = false;
}
module.exports = $8dc0f2b815407044$var$$defineProperty;

});

parcelRegister("bdcGK", function(module, exports) {
'use strict';
var $829ac04505f736a1$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $7kBTt = parcelRequire("7kBTt");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $829ac04505f736a1$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $829ac04505f736a1$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $7kBTt();
};

});
parcelRegister("7kBTt", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("gXVYa", function(module, exports) {
'use strict';

var $9Cm6z = parcelRequire("9Cm6z");

var $az7B4 = parcelRequire("az7B4");

var $1i8Qz = parcelRequire("1i8Qz");
/** @type {import('.')} */ module.exports = $9Cm6z ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $9Cm6z(O);
} : $az7B4 ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $az7B4(O);
} : $1i8Qz ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $1i8Qz(O);
} : null;

});
parcelRegister("9Cm6z", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("az7B4", function(module, exports) {
'use strict';

var $hk0ZX = parcelRequire("hk0ZX");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $hk0ZX.getPrototypeOf || null;

});

parcelRegister("1i8Qz", function(module, exports) {
'use strict';

var $3IkIN = parcelRequire("3IkIN");

var $h6xkJ = parcelRequire("h6xkJ");
var $0f0e55ad6b904081$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $0f0e55ad6b904081$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $0f0e55ad6b904081$var$desc = !!$0f0e55ad6b904081$var$hasProtoAccessor && $h6xkJ && $h6xkJ(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $0f0e55ad6b904081$var$$Object = Object;
var $0f0e55ad6b904081$var$$getPrototypeOf = $0f0e55ad6b904081$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $0f0e55ad6b904081$var$desc && typeof $0f0e55ad6b904081$var$desc.get === 'function' ? $3IkIN([
    $0f0e55ad6b904081$var$desc.get
]) : typeof $0f0e55ad6b904081$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $0f0e55ad6b904081$var$$getPrototypeOf(value == null ? value : $0f0e55ad6b904081$var$$Object(value));
} : false;

});
parcelRegister("3IkIN", function(module, exports) {
'use strict';

var $kgO2R = parcelRequire("kgO2R");

var $20Zn0 = parcelRequire("20Zn0");

var $9RRss = parcelRequire("9RRss");

var $34Gsx = parcelRequire("34Gsx");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $20Zn0('a function is required');
    return $34Gsx($kgO2R, $9RRss, args);
};

});
parcelRegister("kgO2R", function(module, exports) {
'use strict';

var $5C0R0 = parcelRequire("5C0R0");
module.exports = Function.prototype.bind || $5C0R0;

});
parcelRegister("5C0R0", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $416129f1b83576fc$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $416129f1b83576fc$var$toStr = Object.prototype.toString;
var $416129f1b83576fc$var$max = Math.max;
var $416129f1b83576fc$var$funcType = '[object Function]';
var $416129f1b83576fc$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $416129f1b83576fc$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $416129f1b83576fc$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $416129f1b83576fc$var$toStr.apply(target) !== $416129f1b83576fc$var$funcType) throw new TypeError($416129f1b83576fc$var$ERROR_MESSAGE + target);
    var args = $416129f1b83576fc$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $416129f1b83576fc$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $416129f1b83576fc$var$concatty(args, arguments));
    };
    var boundLength = $416129f1b83576fc$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $416129f1b83576fc$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("9RRss", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("34Gsx", function(module, exports) {
'use strict';

var $kgO2R = parcelRequire("kgO2R");

var $gqs1G = parcelRequire("gqs1G");

var $9RRss = parcelRequire("9RRss");

var $gFVmH = parcelRequire("gFVmH");
/** @type {import('./actualApply')} */ module.exports = $gFVmH || $kgO2R.call($9RRss, $gqs1G);

});
parcelRegister("gqs1G", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("gFVmH", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("fA0g4", function(module, exports) {
'use strict';
var $b57a6b15394bedd5$var$call = Function.prototype.call;
var $b57a6b15394bedd5$var$$hasOwn = Object.prototype.hasOwnProperty;

var $kgO2R = parcelRequire("kgO2R");
/** @type {import('.')} */ module.exports = $kgO2R.call($b57a6b15394bedd5$var$call, $b57a6b15394bedd5$var$$hasOwn);

});


parcelRegister("6QSoo", function(module, exports) {
'use strict';

var $7Aezy = parcelRequire("7Aezy");

var $3IkIN = parcelRequire("3IkIN");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $4fd1ca9c4c6e623d$var$$indexOf = $3IkIN([
    $7Aezy('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $7Aezy(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $4fd1ca9c4c6e623d$var$$indexOf(name, '.prototype.') > -1) return $3IkIN(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});


parcelRegister("cYq8y", function(module, exports) {
'use strict';

var $7Aezy = parcelRequire("7Aezy");

var $6QSoo = parcelRequire("6QSoo");

var $iQpYf = parcelRequire("iQpYf");

var $hP77y = parcelRequire("hP77y");

var $20Zn0 = parcelRequire("20Zn0");
var $971f5ce6ffc77ec3$var$$WeakMap = $7Aezy('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $971f5ce6ffc77ec3$var$$weakMapGet = $6QSoo('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $971f5ce6ffc77ec3$var$$weakMapSet = $6QSoo('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $971f5ce6ffc77ec3$var$$weakMapHas = $6QSoo('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $971f5ce6ffc77ec3$var$$weakMapDelete = $6QSoo('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $971f5ce6ffc77ec3$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $20Zn0('Side channel does not contain ' + $iQpYf(key));
        },
        'delete': function(key) {
            if ($971f5ce6ffc77ec3$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $971f5ce6ffc77ec3$var$$weakMapDelete($wm, key);
            } else if ($hP77y) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($971f5ce6ffc77ec3$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $971f5ce6ffc77ec3$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($971f5ce6ffc77ec3$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $971f5ce6ffc77ec3$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($971f5ce6ffc77ec3$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $971f5ce6ffc77ec3$var$$WeakMap();
                $971f5ce6ffc77ec3$var$$weakMapSet($wm, key, value);
            } else if ($hP77y) {
                if (!$m) $m = $hP77y();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $hP77y;

});


parcelRegister("6bVvS", function(module, exports) {
'use strict';

var $aRIWH = parcelRequire("aRIWH");

var $fQlJQ = parcelRequire("fQlJQ");

var $caycu = parcelRequire("caycu");
var $48206214ea5ff871$var$has = Object.prototype.hasOwnProperty;
var $48206214ea5ff871$var$isArray = Array.isArray;
// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var $48206214ea5ff871$var$overflowChannel = $fQlJQ();
var $48206214ea5ff871$var$markOverflow = function markOverflow(obj, maxIndex) {
    $48206214ea5ff871$var$overflowChannel.set(obj, maxIndex);
    return obj;
};
var $48206214ea5ff871$var$isOverflow = function isOverflow(obj) {
    return $48206214ea5ff871$var$overflowChannel.has(obj);
};
var $48206214ea5ff871$var$getMaxIndex = function getMaxIndex(obj) {
    return $48206214ea5ff871$var$overflowChannel.get(obj);
};
var $48206214ea5ff871$var$setMaxIndex = function setMaxIndex(obj, maxIndex) {
    $48206214ea5ff871$var$overflowChannel.set(obj, maxIndex);
};
var $48206214ea5ff871$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    return array;
}();
var $48206214ea5ff871$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($48206214ea5ff871$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted[compacted.length] = obj[j];
            item.obj[item.prop] = compacted;
        }
    }
};
var $48206214ea5ff871$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $48206214ea5ff871$var$setProperty = function setProperty(obj, key, value) {
    if (key === '__proto__' && $caycu) $caycu(obj, key, {
        configurable: true,
        enumerable: true,
        value: value,
        writable: true
    });
    else obj[key] = value;
};
var $48206214ea5ff871$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($48206214ea5ff871$var$isArray(target)) {
            var nextIndex = target.length;
            if (options && typeof options.arrayLimit === 'number' && nextIndex >= options.arrayLimit) {
                if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                return $48206214ea5ff871$var$markOverflow($48206214ea5ff871$var$arrayToObject(target.concat(source), options), nextIndex);
            }
            target[nextIndex] = source;
        } else if (target && typeof target === 'object') {
            if ($48206214ea5ff871$var$isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = $48206214ea5ff871$var$getMaxIndex(target) + 1;
                target[newIndex] = source;
                $48206214ea5ff871$var$setMaxIndex(target, newIndex);
            } else if (options && options.strictMerge) return [
                target,
                source
            ];
            else if (options && (options.plainObjects || options.allowPrototypes) || !$48206214ea5ff871$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') {
        if ($48206214ea5ff871$var$isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects ? {
                __proto__: null,
                0: target
            } : {
                0: target
            };
            for(var m = 0; m < sourceKeys.length; m++){
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return $48206214ea5ff871$var$markOverflow(result, $48206214ea5ff871$var$getMaxIndex(source) + 1);
        }
        var combined = [
            target
        ].concat(source);
        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            return $48206214ea5ff871$var$markOverflow($48206214ea5ff871$var$arrayToObject(combined, options), combined.length - 1);
        }
        return combined;
    }
    var mergeTarget = target;
    if ($48206214ea5ff871$var$isArray(target) && !$48206214ea5ff871$var$isArray(source)) mergeTarget = $48206214ea5ff871$var$arrayToObject(target, options);
    if ($48206214ea5ff871$var$isArray(target) && $48206214ea5ff871$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($48206214ea5ff871$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target[target.length] = item;
            } else target[i] = item;
        });
        if (options && typeof options.arrayLimit === 'number' && target.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            return $48206214ea5ff871$var$markOverflow($48206214ea5ff871$var$arrayToObject(target, options), target.length - 1);
        }
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($48206214ea5ff871$var$has.call(acc, key)) $48206214ea5ff871$var$setProperty(acc, key, merge(acc[key], value, options));
        else $48206214ea5ff871$var$setProperty(acc, key, value);
        if ($48206214ea5ff871$var$isOverflow(source) && !$48206214ea5ff871$var$isOverflow(acc)) $48206214ea5ff871$var$markOverflow(acc, $48206214ea5ff871$var$getMaxIndex(source));
        if ($48206214ea5ff871$var$isOverflow(acc)) {
            var keyNum = parseInt(key, 10);
            if (String(keyNum) === key && keyNum >= 0 && keyNum > $48206214ea5ff871$var$getMaxIndex(acc)) $48206214ea5ff871$var$setMaxIndex(acc, keyNum);
        }
        return acc;
    }, mergeTarget);
};
var $48206214ea5ff871$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        $48206214ea5ff871$var$setProperty(acc, key, source[key]);
        return acc;
    }, target);
};
var $48206214ea5ff871$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $48206214ea5ff871$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $48206214ea5ff871$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $48206214ea5ff871$var$limit){
        var segment = string.length >= $48206214ea5ff871$var$limit ? string.slice(j, j + $48206214ea5ff871$var$limit) : string;
        if (j + $48206214ea5ff871$var$limit < string.length) {
            var last = segment.charCodeAt(segment.length - 1);
            if (last >= 0xD800 && last <= 0xDBFF) {
                segment = segment.slice(0, -1);
                j -= 1;
            }
        }
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $aRIWH.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $48206214ea5ff871$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $48206214ea5ff871$var$hexTable[0xC0 | c >> 6] + $48206214ea5ff871$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $48206214ea5ff871$var$hexTable[0xE0 | c >> 12] + $48206214ea5ff871$var$hexTable[0x80 | c >> 6 & 0x3F] + $48206214ea5ff871$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $48206214ea5ff871$var$hexTable[0xF0 | c >> 18] + $48206214ea5ff871$var$hexTable[0x80 | c >> 12 & 0x3F] + $48206214ea5ff871$var$hexTable[0x80 | c >> 6 & 0x3F] + $48206214ea5ff871$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $48206214ea5ff871$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = $fQlJQ();
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && !refs.has(val)) {
                queue[queue.length] = {
                    obj: obj,
                    prop: key
                };
                refs.set(val, true);
            }
        }
    }
    $48206214ea5ff871$var$compactQueue(queue);
    return value;
};
var $48206214ea5ff871$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $48206214ea5ff871$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $48206214ea5ff871$var$combine = function combine(a, b, arrayLimit, plainObjects, throwOnLimitExceeded) {
    // If 'a' is already an overflow object, add to it
    if ($48206214ea5ff871$var$isOverflow(a)) {
        if (throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + arrayLimit + ' element' + (arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        var newIndex = $48206214ea5ff871$var$getMaxIndex(a) + 1;
        a[newIndex] = b;
        $48206214ea5ff871$var$setMaxIndex(a, newIndex);
        return a;
    }
    var result = [].concat(a, b);
    if (result.length > arrayLimit) {
        if (throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + arrayLimit + ' element' + (arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        return $48206214ea5ff871$var$markOverflow($48206214ea5ff871$var$arrayToObject(result, {
            plainObjects: plainObjects
        }), result.length - 1);
    }
    return result;
};
var $48206214ea5ff871$var$maybeMap = function maybeMap(val, fn) {
    if ($48206214ea5ff871$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped[mapped.length] = fn(val[i]);
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $48206214ea5ff871$var$arrayToObject,
    assign: $48206214ea5ff871$var$assign,
    combine: $48206214ea5ff871$var$combine,
    compact: $48206214ea5ff871$var$compact,
    decode: $48206214ea5ff871$var$decode,
    encode: $48206214ea5ff871$var$encode,
    isBuffer: $48206214ea5ff871$var$isBuffer,
    isOverflow: $48206214ea5ff871$var$isOverflow,
    isRegExp: $48206214ea5ff871$var$isRegExp,
    markOverflow: $48206214ea5ff871$var$markOverflow,
    maybeMap: $48206214ea5ff871$var$maybeMap,
    merge: $48206214ea5ff871$var$merge
};

});
parcelRegister("aRIWH", function(module, exports) {
'use strict';
var $7e91b7eeca582e67$var$replace = String.prototype.replace;
var $7e91b7eeca582e67$var$percentTwenties = /%20/g;
var $7e91b7eeca582e67$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $7e91b7eeca582e67$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $7e91b7eeca582e67$var$replace.call(value, $7e91b7eeca582e67$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $7e91b7eeca582e67$var$Format.RFC1738,
    RFC3986: $7e91b7eeca582e67$var$Format.RFC3986
};

});



parcelRegister("iU4ge", function(module, exports) {
'use strict';

var $6bVvS = parcelRequire("6bVvS");
var $dc30c312d939e483$var$has = Object.prototype.hasOwnProperty;
var $dc30c312d939e483$var$isArray = Array.isArray;
var $dc30c312d939e483$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $6bVvS.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictMerge: true,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $dc30c312d939e483$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $dc30c312d939e483$var$parseArrayValue = function(val, options, currentArrayLength, isFlatArrayValue) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        if (isFlatArrayValue && options.throwOnLimitExceeded) {
            var commaCount = 0;
            var commaIndex = val.indexOf(',');
            while(commaIndex > -1){
                commaCount += 1;
                if (commaCount >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                commaIndex = val.indexOf(',', commaIndex + 1);
            }
        }
        return val.split(',');
    }
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $dc30c312d939e483$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $dc30c312d939e483$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $dc30c312d939e483$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded && typeof limit !== 'undefined' ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && typeof limit !== 'undefined' && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $dc30c312d939e483$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $dc30c312d939e483$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $dc30c312d939e483$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $dc30c312d939e483$var$defaults.decoder, charset, 'key');
            if (key !== null) val = $6bVvS.maybeMap($dc30c312d939e483$var$parseArrayValue(part.slice(pos + 1), options, $dc30c312d939e483$var$isArray(obj[key]) ? obj[key].length : 0, part.indexOf('[]=') === -1), function(encodedVal) {
                return options.decoder(encodedVal, $dc30c312d939e483$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $dc30c312d939e483$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $dc30c312d939e483$var$isArray(val) ? [
            val
        ] : val;
        if (options.comma && $dc30c312d939e483$var$isArray(val) && val.length > options.arrayLimit) val = $6bVvS.combine([], val, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
        if (key !== null) {
            var existing = $dc30c312d939e483$var$has.call(obj, key);
            if (existing && (options.duplicates === 'combine' || part.indexOf('[]=') > -1)) obj[key] = $6bVvS.combine(obj[key], val, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
            else if (!existing || options.duplicates === 'last') obj[key] = val;
        }
    }
    return obj;
};
var $dc30c312d939e483$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $dc30c312d939e483$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) {
            if ($6bVvS.isOverflow(leaf)) // leaf is already an overflow object, preserve it
            obj = leaf;
            else obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $6bVvS.combine([], leaf, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
        } else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            var isValidArrayIndex = !isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays;
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (isValidArrayIndex && index < options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (isValidArrayIndex && options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            else if (isValidArrayIndex) {
                obj[index] = leaf;
                $6bVvS.markOverflow(obj, index);
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
// Split a key like "a[b][c[]]" into ['a', '[b]', '[c[]]'] while preserving
// qs parse semantics for depth/prototype guards.
var $dc30c312d939e483$var$splitKeyIntoSegments = function splitKeyIntoSegments(originalKey, options) {
    var key = options.allowDots ? originalKey.replace(/\.([^.[]+)/g, '[$1]') : originalKey;
    // depth <= 0 keeps the whole key as one segment
    if (options.depth <= 0) {
        if (!options.plainObjects && $dc30c312d939e483$var$has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) return;
        }
        return [
            key
        ];
    }
    var segments = [];
    // parent before the first '[' (may be empty if key starts with '[')
    var first = key.indexOf('[');
    var parent = first >= 0 ? key.slice(0, first) : key;
    if (parent) {
        if (!options.plainObjects && $dc30c312d939e483$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        segments[segments.length] = parent;
    }
    var n = key.length;
    var open = first;
    var collected = 0;
    while(open >= 0 && collected < options.depth){
        var level = 1;
        var i = open + 1;
        var close = -1;
        // balance nested '[' and ']' inside this bracket group using a nesting level counter
        while(i < n && close < 0){
            var cu = key.charCodeAt(i);
            if (cu === 0x5B) level += 1;
            else if (cu === 0x5D) {
                level -= 1;
                if (level === 0) close = i; // found matching close; loop will exit by condition
            }
            i += 1;
        }
        if (close < 0) {
            // Unterminated group: wrap the raw remainder in one bracket pair so it stays
            // a single literal segment (e.g. "[[]b" -> "[[]b]"); we do not infer missing ']'.
            segments[segments.length] = '[' + key.slice(open) + ']';
            return segments;
        }
        var seg = key.slice(open, close + 1);
        // prototype guard for the content of this group
        var content = seg.slice(1, -1);
        if (!options.plainObjects && $dc30c312d939e483$var$has.call(Object.prototype, content) && !options.allowPrototypes) return;
        segments[segments.length] = seg;
        collected += 1;
        // find the next '[' after this balanced group
        open = key.indexOf('[', close + 1);
    }
    if (open >= 0) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        segments[segments.length] = '[' + key.slice(open) + ']';
    }
    return segments;
};
var $dc30c312d939e483$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    var keys = $dc30c312d939e483$var$splitKeyIntoSegments(givenKey, options);
    if (!keys) return;
    return $dc30c312d939e483$var$parseObject(keys, val, options, valuesParsed);
};
var $dc30c312d939e483$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $dc30c312d939e483$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $dc30c312d939e483$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $dc30c312d939e483$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $dc30c312d939e483$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $dc30c312d939e483$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $dc30c312d939e483$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $dc30c312d939e483$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $dc30c312d939e483$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $dc30c312d939e483$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $dc30c312d939e483$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $dc30c312d939e483$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $dc30c312d939e483$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $6bVvS.isRegExp(opts.delimiter) ? opts.delimiter : $dc30c312d939e483$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $dc30c312d939e483$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $dc30c312d939e483$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $dc30c312d939e483$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $dc30c312d939e483$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $dc30c312d939e483$var$defaults.strictDepth,
        strictMerge: typeof opts.strictMerge === 'boolean' ? !!opts.strictMerge : $dc30c312d939e483$var$defaults.strictMerge,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $dc30c312d939e483$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
module.exports = function(str, opts) {
    var options = $dc30c312d939e483$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $dc30c312d939e483$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $dc30c312d939e483$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $6bVvS.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $6bVvS.compact(obj);
};

});



parcelRegister("ahb1S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $7UTi7 = parcelRequire("7UTi7");

var $68gnH = parcelRequire("68gnH");

var $d9eec = parcelRequire("d9eec");

var $cI4X4 = parcelRequire("cI4X4");

var $frFzw = parcelRequire("frFzw");

var $jO8Ye = parcelRequire("jO8Ye");
var $77b40c19dc4663db$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, $cI4X4.supportsWebCrypto)((0, $jO8Ye.locateWindow)())) this.hash = new $68gnH.Sha256(secret);
        else if ((0, $frFzw.isMsWindow)((0, $jO8Ye.locateWindow)())) this.hash = new $7UTi7.Sha256(secret);
        else this.hash = new $d9eec.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update(data, encoding);
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    return Sha256;
}();
module.exports.Sha256 = $77b40c19dc4663db$var$Sha256;

});
parcelRegister("7UTi7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $7sua2 = parcelRequire("7sua2");

var $5alAd = parcelRequire("5alAd");

var $12JSh = parcelRequire("12JSh");

var $jO8Ye = parcelRequire("jO8Ye");
var $5c38a710450a724e$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if (secret) {
            this.operation = $5c38a710450a724e$var$getKeyPromise(secret).then(function(keyData) {
                return (0, $jO8Ye.locateWindow)().msCrypto.subtle.sign($5alAd.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, $jO8Ye.locateWindow)().msCrypto.subtle.digest("SHA-256"));
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if ((0, $7sua2.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process($5c38a710450a724e$var$toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $5c38a710450a724e$var$Sha256;
function $5c38a710450a724e$var$getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, $jO8Ye.locateWindow)().msCrypto.subtle.importKey("raw", $5c38a710450a724e$var$toArrayBufferView(secret), $5alAd.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function $5c38a710450a724e$var$toArrayBufferView(data) {
    if (typeof data === "string") return (0, $12JSh.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

});
parcelRegister("7sua2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $56e28b40d9b35cd3$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $56e28b40d9b35cd3$var$isEmptyData;

});

parcelRegister("5alAd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EMPTY_DATA_SHA_256 = module.exports.SHA_256_HMAC_ALGO = module.exports.SHA_256_HASH = void 0;
module.exports.SHA_256_HASH = {
    name: "SHA-256"
};
module.exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: module.exports.SHA_256_HASH
};
module.exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

});

parcelRegister("12JSh", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $0c29900e9da05f1a$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $0c29900e9da05f1a$export$b4b216764bb846eb; });

var $1DJza = parcelRequire("1DJza");

var $7OMhF = parcelRequire("7OMhF");
var $0c29900e9da05f1a$export$c7c5cef950a4d2fc = function(input) {
    return typeof TextEncoder === "function" ? (0, $7OMhF.fromUtf8)(input) : (0, $1DJza.fromUtf8)(input);
};
var $0c29900e9da05f1a$export$b4b216764bb846eb = function(input) {
    return typeof TextDecoder === "function" ? (0, $7OMhF.toUtf8)(input) : (0, $1DJza.toUtf8)(input);
};

});
parcelRegister("1DJza", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $131cc7739e8f86d5$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $131cc7739e8f86d5$export$b4b216764bb846eb; });
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var $131cc7739e8f86d5$export$c7c5cef950a4d2fc = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var $131cc7739e8f86d5$export$b4b216764bb846eb = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRegister("7OMhF", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $5b12a8190c78b044$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $5b12a8190c78b044$export$b4b216764bb846eb; });
function $5b12a8190c78b044$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $5b12a8190c78b044$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});


parcelRegister("jO8Ye", function(module, exports) {

$parcel$export(module.exports, "locateWindow", function () { return $e6b9a5327f8c2b1c$export$2a77db4d0e0dd1ff; });
const $e6b9a5327f8c2b1c$var$fallbackWindow = {};
function $e6b9a5327f8c2b1c$export$2a77db4d0e0dd1ff() {
    if (typeof window !== "undefined") return window;
    else if (typeof self !== "undefined") return self;
    return $e6b9a5327f8c2b1c$var$fallbackWindow;
}

});


parcelRegister("68gnH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $iUHWq = parcelRequire("iUHWq");

var $5alAd = parcelRequire("5alAd");

var $jO8Ye = parcelRequire("jO8Ye");
var $47703269273f6de6$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, $jO8Ye.locateWindow)().crypto.subtle.importKey("raw", (0, $iUHWq.convertToBuffer)(secret), $5alAd.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    }
    Sha256.prototype.update = function(data) {
        if ((0, $iUHWq.isEmptyData)(data)) return;
        var update = (0, $iUHWq.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, $jO8Ye.locateWindow)().crypto.subtle.sign($5alAd.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, $iUHWq.isEmptyData)(this.toHash)) return Promise.resolve($5alAd.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return (0, $jO8Ye.locateWindow)().crypto.subtle.digest($5alAd.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $47703269273f6de6$var$Sha256;

});
parcelRegister("iUHWq", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = module.exports.numToUint8 = module.exports.isEmptyData = module.exports.convertToBuffer = void 0;

var $3lzHy = parcelRequire("3lzHy");
Object.defineProperty(module.exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return $3lzHy.convertToBuffer;
    }
});

var $1hXHq = parcelRequire("1hXHq");
Object.defineProperty(module.exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return $1hXHq.isEmptyData;
    }
});

var $lN6Cr = parcelRequire("lN6Cr");
Object.defineProperty(module.exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return $lN6Cr.numToUint8;
    }
});

var $04Ul5 = parcelRequire("04Ul5");
Object.defineProperty(module.exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return $04Ul5.uint32ArrayFrom;
    }
});

});
parcelRegister("3lzHy", function(module, exports) {

var $81U8s = parcelRequire("81U8s");
var $26ff06d7f6ca7a8d$require$Buffer = $81U8s.Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertToBuffer = void 0;

var $9QrsR = parcelRequire("9QrsR");
// Quick polyfill
var $26ff06d7f6ca7a8d$var$fromUtf8 = typeof $26ff06d7f6ca7a8d$require$Buffer !== "undefined" && $26ff06d7f6ca7a8d$require$Buffer.from ? function(input) {
    return $26ff06d7f6ca7a8d$require$Buffer.from(input, "utf8");
} : $9QrsR.fromUtf8;
function $26ff06d7f6ca7a8d$var$convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $26ff06d7f6ca7a8d$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
module.exports.convertToBuffer = $26ff06d7f6ca7a8d$var$convertToBuffer;

});
parcelRegister("81U8s", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $5d89f611356da7ff$export$a143d493d941bafc; }, function (v) { return $5d89f611356da7ff$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $5d89f611356da7ff$export$e4cf37d7f6fb9e0a; }, function (v) { return $5d89f611356da7ff$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $5d89f611356da7ff$export$f99ded8fe4b79145; }, function (v) { return $5d89f611356da7ff$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $5d89f611356da7ff$export$599f31c3813fae4d; }, function (v) { return $5d89f611356da7ff$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $5d89f611356da7ff$export$a143d493d941bafc;
var $5d89f611356da7ff$export$e4cf37d7f6fb9e0a;
var $5d89f611356da7ff$export$f99ded8fe4b79145;
var $5d89f611356da7ff$export$599f31c3813fae4d;
'use strict';

var $9lqm0 = parcelRequire("9lqm0");

var $4WZRW = parcelRequire("4WZRW");
const $5d89f611356da7ff$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$5d89f611356da7ff$export$a143d493d941bafc = $5d89f611356da7ff$var$Buffer;
$5d89f611356da7ff$export$e4cf37d7f6fb9e0a = $5d89f611356da7ff$var$SlowBuffer;
$5d89f611356da7ff$export$f99ded8fe4b79145 = 50;
const $5d89f611356da7ff$var$K_MAX_LENGTH = 0x7fffffff;
$5d89f611356da7ff$export$599f31c3813fae4d = $5d89f611356da7ff$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $5d89f611356da7ff$var$Buffer.TYPED_ARRAY_SUPPORT = $5d89f611356da7ff$var$typedArraySupport();
if (!$5d89f611356da7ff$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $5d89f611356da7ff$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($5d89f611356da7ff$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$5d89f611356da7ff$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($5d89f611356da7ff$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$5d89f611356da7ff$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $5d89f611356da7ff$var$createBuffer(length) {
    if (length > $5d89f611356da7ff$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $5d89f611356da7ff$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $5d89f611356da7ff$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $5d89f611356da7ff$var$allocUnsafe(arg);
    }
    return $5d89f611356da7ff$var$from(arg, encodingOrOffset, length);
}
$5d89f611356da7ff$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $5d89f611356da7ff$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $5d89f611356da7ff$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $5d89f611356da7ff$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($5d89f611356da7ff$var$isInstance(value, ArrayBuffer) || value && $5d89f611356da7ff$var$isInstance(value.buffer, ArrayBuffer)) return $5d89f611356da7ff$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($5d89f611356da7ff$var$isInstance(value, SharedArrayBuffer) || value && $5d89f611356da7ff$var$isInstance(value.buffer, SharedArrayBuffer))) return $5d89f611356da7ff$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $5d89f611356da7ff$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $5d89f611356da7ff$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $5d89f611356da7ff$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $5d89f611356da7ff$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $5d89f611356da7ff$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($5d89f611356da7ff$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($5d89f611356da7ff$var$Buffer, Uint8Array);
function $5d89f611356da7ff$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $5d89f611356da7ff$var$alloc(size, fill, encoding) {
    $5d89f611356da7ff$var$assertSize(size);
    if (size <= 0) return $5d89f611356da7ff$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $5d89f611356da7ff$var$createBuffer(size).fill(fill, encoding) : $5d89f611356da7ff$var$createBuffer(size).fill(fill);
    return $5d89f611356da7ff$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $5d89f611356da7ff$var$Buffer.alloc = function(size, fill, encoding) {
    return $5d89f611356da7ff$var$alloc(size, fill, encoding);
};
function $5d89f611356da7ff$var$allocUnsafe(size) {
    $5d89f611356da7ff$var$assertSize(size);
    return $5d89f611356da7ff$var$createBuffer(size < 0 ? 0 : $5d89f611356da7ff$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $5d89f611356da7ff$var$Buffer.allocUnsafe = function(size) {
    return $5d89f611356da7ff$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $5d89f611356da7ff$var$Buffer.allocUnsafeSlow = function(size) {
    return $5d89f611356da7ff$var$allocUnsafe(size);
};
function $5d89f611356da7ff$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$5d89f611356da7ff$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $5d89f611356da7ff$var$byteLength(string, encoding) | 0;
    let buf = $5d89f611356da7ff$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $5d89f611356da7ff$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $5d89f611356da7ff$var$checked(array.length) | 0;
    const buf = $5d89f611356da7ff$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $5d89f611356da7ff$var$fromArrayView(arrayView) {
    if ($5d89f611356da7ff$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $5d89f611356da7ff$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $5d89f611356da7ff$var$fromArrayLike(arrayView);
}
function $5d89f611356da7ff$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $5d89f611356da7ff$var$Buffer.prototype);
    return buf;
}
function $5d89f611356da7ff$var$fromObject(obj) {
    if ($5d89f611356da7ff$var$Buffer.isBuffer(obj)) {
        const len = $5d89f611356da7ff$var$checked(obj.length) | 0;
        const buf = $5d89f611356da7ff$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $5d89f611356da7ff$var$numberIsNaN(obj.length)) return $5d89f611356da7ff$var$createBuffer(0);
        return $5d89f611356da7ff$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $5d89f611356da7ff$var$fromArrayLike(obj.data);
}
function $5d89f611356da7ff$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $5d89f611356da7ff$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $5d89f611356da7ff$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $5d89f611356da7ff$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $5d89f611356da7ff$var$Buffer.alloc(+length);
}
$5d89f611356da7ff$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $5d89f611356da7ff$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$5d89f611356da7ff$var$Buffer.compare = function compare(a, b) {
    if ($5d89f611356da7ff$var$isInstance(a, Uint8Array)) a = $5d89f611356da7ff$var$Buffer.from(a, a.offset, a.byteLength);
    if ($5d89f611356da7ff$var$isInstance(b, Uint8Array)) b = $5d89f611356da7ff$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$5d89f611356da7ff$var$Buffer.isBuffer(a) || !$5d89f611356da7ff$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$5d89f611356da7ff$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$5d89f611356da7ff$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $5d89f611356da7ff$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $5d89f611356da7ff$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($5d89f611356da7ff$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$5d89f611356da7ff$var$Buffer.isBuffer(buf)) buf = $5d89f611356da7ff$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$5d89f611356da7ff$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $5d89f611356da7ff$var$byteLength(string, encoding) {
    if ($5d89f611356da7ff$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $5d89f611356da7ff$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $5d89f611356da7ff$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $5d89f611356da7ff$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $5d89f611356da7ff$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$5d89f611356da7ff$var$Buffer.byteLength = $5d89f611356da7ff$var$byteLength;
function $5d89f611356da7ff$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $5d89f611356da7ff$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $5d89f611356da7ff$var$utf8Slice(this, start, end);
        case 'ascii':
            return $5d89f611356da7ff$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $5d89f611356da7ff$var$latin1Slice(this, start, end);
        case 'base64':
            return $5d89f611356da7ff$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $5d89f611356da7ff$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$5d89f611356da7ff$var$Buffer.prototype._isBuffer = true;
function $5d89f611356da7ff$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$5d89f611356da7ff$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$5d89f611356da7ff$var$swap(this, i, i + 1);
    return this;
};
$5d89f611356da7ff$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $5d89f611356da7ff$var$swap(this, i, i + 3);
        $5d89f611356da7ff$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$5d89f611356da7ff$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $5d89f611356da7ff$var$swap(this, i, i + 7);
        $5d89f611356da7ff$var$swap(this, i + 1, i + 6);
        $5d89f611356da7ff$var$swap(this, i + 2, i + 5);
        $5d89f611356da7ff$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$5d89f611356da7ff$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $5d89f611356da7ff$var$utf8Slice(this, 0, length);
    return $5d89f611356da7ff$var$slowToString.apply(this, arguments);
};
$5d89f611356da7ff$var$Buffer.prototype.toLocaleString = $5d89f611356da7ff$var$Buffer.prototype.toString;
$5d89f611356da7ff$var$Buffer.prototype.equals = function equals(b) {
    if (!$5d89f611356da7ff$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $5d89f611356da7ff$var$Buffer.compare(this, b) === 0;
};
$5d89f611356da7ff$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $5d89f611356da7ff$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($5d89f611356da7ff$var$customInspectSymbol) $5d89f611356da7ff$var$Buffer.prototype[$5d89f611356da7ff$var$customInspectSymbol] = $5d89f611356da7ff$var$Buffer.prototype.inspect;
$5d89f611356da7ff$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($5d89f611356da7ff$var$isInstance(target, Uint8Array)) target = $5d89f611356da7ff$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$5d89f611356da7ff$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $5d89f611356da7ff$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($5d89f611356da7ff$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $5d89f611356da7ff$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($5d89f611356da7ff$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $5d89f611356da7ff$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $5d89f611356da7ff$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $5d89f611356da7ff$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$5d89f611356da7ff$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$5d89f611356da7ff$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $5d89f611356da7ff$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$5d89f611356da7ff$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $5d89f611356da7ff$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $5d89f611356da7ff$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($5d89f611356da7ff$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $5d89f611356da7ff$var$utf8Write(buf, string, offset, length) {
    return $5d89f611356da7ff$var$blitBuffer($5d89f611356da7ff$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $5d89f611356da7ff$var$asciiWrite(buf, string, offset, length) {
    return $5d89f611356da7ff$var$blitBuffer($5d89f611356da7ff$var$asciiToBytes(string), buf, offset, length);
}
function $5d89f611356da7ff$var$base64Write(buf, string, offset, length) {
    return $5d89f611356da7ff$var$blitBuffer($5d89f611356da7ff$var$base64ToBytes(string), buf, offset, length);
}
function $5d89f611356da7ff$var$ucs2Write(buf, string, offset, length) {
    return $5d89f611356da7ff$var$blitBuffer($5d89f611356da7ff$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$5d89f611356da7ff$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $5d89f611356da7ff$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $5d89f611356da7ff$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $5d89f611356da7ff$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $5d89f611356da7ff$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $5d89f611356da7ff$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$5d89f611356da7ff$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $5d89f611356da7ff$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $9lqm0.fromByteArray(buf);
    else return $9lqm0.fromByteArray(buf.slice(start, end));
}
function $5d89f611356da7ff$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $5d89f611356da7ff$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $5d89f611356da7ff$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $5d89f611356da7ff$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $5d89f611356da7ff$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $5d89f611356da7ff$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $5d89f611356da7ff$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $5d89f611356da7ff$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $5d89f611356da7ff$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $5d89f611356da7ff$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $5d89f611356da7ff$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$5d89f611356da7ff$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $5d89f611356da7ff$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $5d89f611356da7ff$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$5d89f611356da7ff$var$Buffer.prototype.readUintLE = $5d89f611356da7ff$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$5d89f611356da7ff$var$Buffer.prototype.readUintBE = $5d89f611356da7ff$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$5d89f611356da7ff$var$Buffer.prototype.readUint8 = $5d89f611356da7ff$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$5d89f611356da7ff$var$Buffer.prototype.readUint16LE = $5d89f611356da7ff$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$5d89f611356da7ff$var$Buffer.prototype.readUint16BE = $5d89f611356da7ff$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$5d89f611356da7ff$var$Buffer.prototype.readUint32LE = $5d89f611356da7ff$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$5d89f611356da7ff$var$Buffer.prototype.readUint32BE = $5d89f611356da7ff$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$5d89f611356da7ff$var$Buffer.prototype.readBigUInt64LE = $5d89f611356da7ff$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $5d89f611356da7ff$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5d89f611356da7ff$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$5d89f611356da7ff$var$Buffer.prototype.readBigUInt64BE = $5d89f611356da7ff$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $5d89f611356da7ff$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5d89f611356da7ff$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$5d89f611356da7ff$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5d89f611356da7ff$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5d89f611356da7ff$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$5d89f611356da7ff$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5d89f611356da7ff$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5d89f611356da7ff$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$5d89f611356da7ff$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$5d89f611356da7ff$var$Buffer.prototype.readBigInt64LE = $5d89f611356da7ff$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $5d89f611356da7ff$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5d89f611356da7ff$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$5d89f611356da7ff$var$Buffer.prototype.readBigInt64BE = $5d89f611356da7ff$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $5d89f611356da7ff$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5d89f611356da7ff$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$5d89f611356da7ff$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkOffset(offset, 4, this.length);
    return $4WZRW.read(this, offset, true, 23, 4);
};
$5d89f611356da7ff$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkOffset(offset, 4, this.length);
    return $4WZRW.read(this, offset, false, 23, 4);
};
$5d89f611356da7ff$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkOffset(offset, 8, this.length);
    return $4WZRW.read(this, offset, true, 52, 8);
};
$5d89f611356da7ff$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkOffset(offset, 8, this.length);
    return $4WZRW.read(this, offset, false, 52, 8);
};
function $5d89f611356da7ff$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$5d89f611356da7ff$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$5d89f611356da7ff$var$Buffer.prototype.writeUintLE = $5d89f611356da7ff$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5d89f611356da7ff$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5d89f611356da7ff$var$Buffer.prototype.writeUintBE = $5d89f611356da7ff$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5d89f611356da7ff$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5d89f611356da7ff$var$Buffer.prototype.writeUint8 = $5d89f611356da7ff$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$5d89f611356da7ff$var$Buffer.prototype.writeUint16LE = $5d89f611356da7ff$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5d89f611356da7ff$var$Buffer.prototype.writeUint16BE = $5d89f611356da7ff$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5d89f611356da7ff$var$Buffer.prototype.writeUint32LE = $5d89f611356da7ff$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$5d89f611356da7ff$var$Buffer.prototype.writeUint32BE = $5d89f611356da7ff$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $5d89f611356da7ff$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $5d89f611356da7ff$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $5d89f611356da7ff$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $5d89f611356da7ff$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$5d89f611356da7ff$var$Buffer.prototype.writeBigUInt64LE = $5d89f611356da7ff$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $5d89f611356da7ff$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$5d89f611356da7ff$var$Buffer.prototype.writeBigUInt64BE = $5d89f611356da7ff$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $5d89f611356da7ff$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$5d89f611356da7ff$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $5d89f611356da7ff$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5d89f611356da7ff$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $5d89f611356da7ff$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5d89f611356da7ff$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$5d89f611356da7ff$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5d89f611356da7ff$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5d89f611356da7ff$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$5d89f611356da7ff$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$5d89f611356da7ff$var$Buffer.prototype.writeBigInt64LE = $5d89f611356da7ff$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $5d89f611356da7ff$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$5d89f611356da7ff$var$Buffer.prototype.writeBigInt64BE = $5d89f611356da7ff$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $5d89f611356da7ff$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $5d89f611356da7ff$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $5d89f611356da7ff$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $4WZRW.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$5d89f611356da7ff$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $5d89f611356da7ff$var$writeFloat(this, value, offset, true, noAssert);
};
$5d89f611356da7ff$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $5d89f611356da7ff$var$writeFloat(this, value, offset, false, noAssert);
};
function $5d89f611356da7ff$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5d89f611356da7ff$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $4WZRW.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$5d89f611356da7ff$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $5d89f611356da7ff$var$writeDouble(this, value, offset, true, noAssert);
};
$5d89f611356da7ff$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $5d89f611356da7ff$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$5d89f611356da7ff$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$5d89f611356da7ff$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$5d89f611356da7ff$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$5d89f611356da7ff$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $5d89f611356da7ff$var$Buffer.isBuffer(val) ? val : $5d89f611356da7ff$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $5d89f611356da7ff$var$errors = {};
function $5d89f611356da7ff$var$E(sym, getMessage, Base) {
    $5d89f611356da7ff$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$5d89f611356da7ff$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$5d89f611356da7ff$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$5d89f611356da7ff$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $5d89f611356da7ff$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $5d89f611356da7ff$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $5d89f611356da7ff$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $5d89f611356da7ff$var$checkBounds(buf, offset, byteLength) {
    $5d89f611356da7ff$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $5d89f611356da7ff$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $5d89f611356da7ff$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $5d89f611356da7ff$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $5d89f611356da7ff$var$checkBounds(buf, offset, byteLength);
}
function $5d89f611356da7ff$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $5d89f611356da7ff$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $5d89f611356da7ff$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $5d89f611356da7ff$var$validateNumber(value, type);
        throw new $5d89f611356da7ff$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $5d89f611356da7ff$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $5d89f611356da7ff$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $5d89f611356da7ff$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $5d89f611356da7ff$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($5d89f611356da7ff$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $5d89f611356da7ff$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $5d89f611356da7ff$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $5d89f611356da7ff$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $5d89f611356da7ff$var$base64ToBytes(str) {
    return $9lqm0.toByteArray($5d89f611356da7ff$var$base64clean(str));
}
function $5d89f611356da7ff$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $5d89f611356da7ff$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $5d89f611356da7ff$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $5d89f611356da7ff$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $5d89f611356da7ff$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $5d89f611356da7ff$var$BufferBigIntNotDefined : fn;
}
function $5d89f611356da7ff$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("9lqm0", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $6cda84967992c8e8$export$d622b2ad8d90c771; }, function (v) { return $6cda84967992c8e8$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $6cda84967992c8e8$export$6100ba28696e12de; }, function (v) { return $6cda84967992c8e8$export$6100ba28696e12de = v; });
var $6cda84967992c8e8$export$a48f0734ac7c2329;
var $6cda84967992c8e8$export$d622b2ad8d90c771;
var $6cda84967992c8e8$export$6100ba28696e12de;
'use strict';
$6cda84967992c8e8$export$a48f0734ac7c2329 = $6cda84967992c8e8$var$byteLength;
$6cda84967992c8e8$export$d622b2ad8d90c771 = $6cda84967992c8e8$var$toByteArray;
$6cda84967992c8e8$export$6100ba28696e12de = $6cda84967992c8e8$var$fromByteArray;
var $6cda84967992c8e8$var$lookup = [];
var $6cda84967992c8e8$var$revLookup = [];
var $6cda84967992c8e8$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $6cda84967992c8e8$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $6cda84967992c8e8$var$i = 0, $6cda84967992c8e8$var$len = $6cda84967992c8e8$var$code.length; $6cda84967992c8e8$var$i < $6cda84967992c8e8$var$len; ++$6cda84967992c8e8$var$i){
    $6cda84967992c8e8$var$lookup[$6cda84967992c8e8$var$i] = $6cda84967992c8e8$var$code[$6cda84967992c8e8$var$i];
    $6cda84967992c8e8$var$revLookup[$6cda84967992c8e8$var$code.charCodeAt($6cda84967992c8e8$var$i)] = $6cda84967992c8e8$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$6cda84967992c8e8$var$revLookup['-'.charCodeAt(0)] = 62;
$6cda84967992c8e8$var$revLookup['_'.charCodeAt(0)] = 63;
function $6cda84967992c8e8$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $6cda84967992c8e8$var$byteLength(b64) {
    var lens = $6cda84967992c8e8$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $6cda84967992c8e8$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $6cda84967992c8e8$var$toByteArray(b64) {
    var tmp;
    var lens = $6cda84967992c8e8$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $6cda84967992c8e8$var$Arr($6cda84967992c8e8$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $6cda84967992c8e8$var$revLookup[b64.charCodeAt(i)] << 18 | $6cda84967992c8e8$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $6cda84967992c8e8$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $6cda84967992c8e8$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $6cda84967992c8e8$var$revLookup[b64.charCodeAt(i)] << 2 | $6cda84967992c8e8$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $6cda84967992c8e8$var$revLookup[b64.charCodeAt(i)] << 10 | $6cda84967992c8e8$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $6cda84967992c8e8$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $6cda84967992c8e8$var$tripletToBase64(num) {
    return $6cda84967992c8e8$var$lookup[num >> 18 & 0x3F] + $6cda84967992c8e8$var$lookup[num >> 12 & 0x3F] + $6cda84967992c8e8$var$lookup[num >> 6 & 0x3F] + $6cda84967992c8e8$var$lookup[num & 0x3F];
}
function $6cda84967992c8e8$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($6cda84967992c8e8$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $6cda84967992c8e8$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($6cda84967992c8e8$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($6cda84967992c8e8$var$lookup[tmp >> 2] + $6cda84967992c8e8$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($6cda84967992c8e8$var$lookup[tmp >> 10] + $6cda84967992c8e8$var$lookup[tmp >> 4 & 0x3F] + $6cda84967992c8e8$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("4WZRW", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $39ac9214c71ebeb1$export$aafa59e2e03f2942; }, function (v) { return $39ac9214c71ebeb1$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $39ac9214c71ebeb1$export$68d8715fc104d294; }, function (v) { return $39ac9214c71ebeb1$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $39ac9214c71ebeb1$export$aafa59e2e03f2942;
var $39ac9214c71ebeb1$export$68d8715fc104d294;
$39ac9214c71ebeb1$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$39ac9214c71ebeb1$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("9QrsR", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $01d985430ccc83ee$export$c7c5cef950a4d2fc; });

var $hzaFS = parcelRequire("hzaFS");

var $cKL1v = parcelRequire("cKL1v");
const $01d985430ccc83ee$export$c7c5cef950a4d2fc = (input)=>typeof TextEncoder === "function" ? (0, $cKL1v.fromUtf8)(input) : (0, $hzaFS.fromUtf8)(input);
const $01d985430ccc83ee$export$b4b216764bb846eb = (input)=>typeof TextDecoder === "function" ? (0, $cKL1v.toUtf8)(input) : (0, $hzaFS.toUtf8)(input);

});
parcelRegister("hzaFS", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $034cdee843d8c4be$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $034cdee843d8c4be$export$b4b216764bb846eb; });
const $034cdee843d8c4be$export$c7c5cef950a4d2fc = (input)=>{
    const bytes = [];
    for(let i = 0, len = input.length; i < len; i++){
        const value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            const surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
const $034cdee843d8c4be$export$b4b216764bb846eb = (input)=>{
    let decoded = "";
    for(let i = 0, len = input.length; i < len; i++){
        const byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            const nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            const surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            const encoded = "%" + surrogatePair.map((byteValue)=>byteValue.toString(16)).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRegister("cKL1v", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $948e41c3c0a3a60d$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $948e41c3c0a3a60d$export$b4b216764bb846eb; });
function $948e41c3c0a3a60d$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $948e41c3c0a3a60d$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});



parcelRegister("1hXHq", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $0f05b009894c2996$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $0f05b009894c2996$var$isEmptyData;

});

parcelRegister("lN6Cr", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numToUint8 = void 0;
function $fdd34efad3bfdd59$var$numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
module.exports.numToUint8 = $fdd34efad3bfdd59$var$numToUint8;

});

parcelRegister("04Ul5", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function $00ec13973d62403b$var$uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
module.exports.uint32ArrayFrom = $00ec13973d62403b$var$uint32ArrayFrom;

});



parcelRegister("d9eec", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fH1jI = parcelRequire("fH1jI");

(0, $fH1jI.__exportStar)((parcelRequire("WSvAh")), module.exports);

});
parcelRegister("WSvAh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $fH1jI = parcelRequire("fH1jI");

var $gbh9X = parcelRequire("gbh9X");

var $4v4bu = parcelRequire("4v4bu");

var $iUHWq = parcelRequire("iUHWq");
var $0b0fb321c0fd4093$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new $4v4bu.RawSha256();
        if (secret) {
            this.outer = new $4v4bu.RawSha256();
            var inner = $0b0fb321c0fd4093$var$bufferFromSecret(secret);
            var outer = new Uint8Array($gbh9X.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $gbh9X.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $iUHWq.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $iUHWq.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
            return (0, $fH1jI.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $0b0fb321c0fd4093$var$Sha256;
function $0b0fb321c0fd4093$var$bufferFromSecret(secret) {
    var input = (0, $iUHWq.convertToBuffer)(secret);
    if (input.byteLength > $gbh9X.BLOCK_SIZE) {
        var bufferHash = new $4v4bu.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($gbh9X.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

});
parcelRegister("gbh9X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_HASHABLE_LENGTH = module.exports.INIT = module.exports.KEY = module.exports.DIGEST_LENGTH = module.exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRegister("4v4bu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawSha256 = void 0;

var $gbh9X = parcelRequire("gbh9X");
/**
 * @internal
 */ var $346d4d956af551ac$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($gbh9X.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $gbh9X.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $gbh9X.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $gbh9X.BLOCK_SIZE >= $gbh9X.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $gbh9X.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $gbh9X.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($gbh9X.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($gbh9X.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($gbh9X.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $gbh9X.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($gbh9X.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $346d4d956af551ac$var$RawSha256;

});



parcelRegister("cI4X4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fH1jI = parcelRequire("fH1jI");

$fH1jI.__exportStar((parcelRequire("8tnD9")), module.exports);

});
parcelRegister("8tnD9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.supportsZeroByteGCM = module.exports.supportsSubtleCrypto = module.exports.supportsSecureRandom = module.exports.supportsWebCrypto = void 0;

var $fH1jI = parcelRequire("fH1jI");
var $62b35caa9448fc4a$var$subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function $62b35caa9448fc4a$var$supportsWebCrypto(window) {
    if ($62b35caa9448fc4a$var$supportsSecureRandom(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return $62b35caa9448fc4a$var$supportsSubtleCrypto(subtle);
    }
    return false;
}
module.exports.supportsWebCrypto = $62b35caa9448fc4a$var$supportsWebCrypto;
function $62b35caa9448fc4a$var$supportsSecureRandom(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
module.exports.supportsSecureRandom = $62b35caa9448fc4a$var$supportsSecureRandom;
function $62b35caa9448fc4a$var$supportsSubtleCrypto(subtle) {
    return subtle && $62b35caa9448fc4a$var$subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
module.exports.supportsSubtleCrypto = $62b35caa9448fc4a$var$supportsSubtleCrypto;
function $62b35caa9448fc4a$var$supportsZeroByteGCM(subtle) {
    return $fH1jI.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return $fH1jI.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!$62b35caa9448fc4a$var$supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.supportsZeroByteGCM = $62b35caa9448fc4a$var$supportsZeroByteGCM;

});


parcelRegister("frFzw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fH1jI = parcelRequire("fH1jI");

$fH1jI.__exportStar((parcelRequire("PGpLv")), module.exports);

$fH1jI.__exportStar((parcelRequire("bfbRY")), module.exports);

$fH1jI.__exportStar((parcelRequire("bOEKj")), module.exports);

$fH1jI.__exportStar((parcelRequire("ixl7W")), module.exports);

$fH1jI.__exportStar((parcelRequire("eTOdf")), module.exports);

});
parcelRegister("PGpLv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bfbRY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bOEKj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ixl7W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eTOdf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMsWindow = void 0;
var $ad8d26ea2e36ec4b$var$msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function $ad8d26ea2e36ec4b$var$quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function $ad8d26ea2e36ec4b$var$isMsWindow(window) {
    if ($ad8d26ea2e36ec4b$var$quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return $ad8d26ea2e36ec4b$var$msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
module.exports.isMsWindow = $ad8d26ea2e36ec4b$var$isMsWindow;

});



parcelRegister("jI3yt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $e594e25b25353604$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e594e25b25353604$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e594e25b25353604$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e594e25b25353604$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e594e25b25353604$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $e594e25b25353604$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $e594e25b25353604$var$hasSymbol = function(name) {
    return $e594e25b25353604$var$hasSymbols() && Boolean(Symbol[name]);
};
var $e594e25b25353604$var$getSymbol = function(name) {
    return $e594e25b25353604$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($e594e25b25353604$var$hasSymbols() && !$e594e25b25353604$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $e594e25b25353604$var$SymbolIterator = $e594e25b25353604$var$getSymbol('iterator');
var $e594e25b25353604$var$SymbolObservable = $e594e25b25353604$var$getSymbol('observable');
var $e594e25b25353604$var$SymbolSpecies = $e594e25b25353604$var$getSymbol('species'); // === Abstract Operations ===
function $e594e25b25353604$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $e594e25b25353604$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$e594e25b25353604$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $e594e25b25353604$var$Observable;
}
function $e594e25b25353604$var$isObservable(x) {
    return x instanceof $e594e25b25353604$var$Observable; // SPEC: Brand check
}
function $e594e25b25353604$var$hostReportError(e) {
    if ($e594e25b25353604$var$hostReportError.log) $e594e25b25353604$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $e594e25b25353604$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $e594e25b25353604$var$hostReportError(e);
        }
    });
}
function $e594e25b25353604$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $e594e25b25353604$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $e594e25b25353604$var$hostReportError(e);
    }
}
function $e594e25b25353604$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $e594e25b25353604$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $e594e25b25353604$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $e594e25b25353604$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $e594e25b25353604$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $e594e25b25353604$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $e594e25b25353604$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $e594e25b25353604$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $e594e25b25353604$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $e594e25b25353604$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $e594e25b25353604$var$enqueue(function() {
            return $e594e25b25353604$var$flushSubscription(subscription);
        });
        return;
    }
    $e594e25b25353604$var$notifySubscription(subscription, type, value);
}
var $e594e25b25353604$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $e594e25b25353604$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $e594e25b25353604$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $e594e25b25353604$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $e594e25b25353604$var$closeSubscription(this);
                    $e594e25b25353604$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $e594e25b25353604$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $e594e25b25353604$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $e594e25b25353604$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $e594e25b25353604$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $e594e25b25353604$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $e594e25b25353604$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $e594e25b25353604$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $e594e25b25353604$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $e594e25b25353604$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $e594e25b25353604$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e594e25b25353604$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e594e25b25353604$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e594e25b25353604$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $e594e25b25353604$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e594e25b25353604$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $e594e25b25353604$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $e594e25b25353604$var$getMethod(x, $e594e25b25353604$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($e594e25b25353604$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($e594e25b25353604$var$hasSymbol('iterator')) {
                    method = $e594e25b25353604$var$getMethod(x, $e594e25b25353604$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $e594e25b25353604$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $e594e25b25353604$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $e594e25b25353604$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $e594e25b25353604$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $e594e25b25353604$var$Observable;
if ($e594e25b25353604$var$hasSymbols()) Object.defineProperty($e594e25b25353604$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $e594e25b25353604$var$SymbolObservable,
        hostReportError: $e594e25b25353604$var$hostReportError
    },
    configurable: true
});

});

parcelRegister("9LFT6", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== 'undefined' && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== 'undefined' && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== 'undefined' && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== 'undefined' && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== 'undefined' && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("6N7cq"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === 'function') try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === 'function') try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error('Native crypto module could not be used to get secure random number.');
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty('init') || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty('toString')) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join('');
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join('');
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error('Malformed UTF-8 data');
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == 'string') data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});

parcelRegister("Fuwoa", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("9LFT6")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != 'function') return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

parcelRegister("1HHSs", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("9LFT6")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("2qAwF", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("9LFT6")), (parcelRequire("1HHSs")), (parcelRequire("8FZsy")));
})(this, function(CryptoJS) {
    return CryptoJS.HmacSHA256;
});

});
parcelRegister("8FZsy", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("9LFT6")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == 'string') key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});


parcelRegister("1J3fK", function(module, exports) {

$parcel$export(module.exports, "randomBytes", function () { return $141c846611506129$export$5f828d93ff035aa8; }, function (v) { return $141c846611506129$export$5f828d93ff035aa8 = v; });
$parcel$export(module.exports, "rng", function () { return $141c846611506129$export$cd94982b18c6332c; }, function (v) { return $141c846611506129$export$cd94982b18c6332c = v; });
$parcel$export(module.exports, "pseudoRandomBytes", function () { return $141c846611506129$export$1d518568e4f529b0; }, function (v) { return $141c846611506129$export$1d518568e4f529b0 = v; });
$parcel$export(module.exports, "prng", function () { return $141c846611506129$export$5285b6d41c912b41; }, function (v) { return $141c846611506129$export$5285b6d41c912b41 = v; });
$parcel$export(module.exports, "createHash", function () { return $141c846611506129$export$2fb37efbf6ae0c0e; }, function (v) { return $141c846611506129$export$2fb37efbf6ae0c0e = v; });
$parcel$export(module.exports, "Hash", function () { return $141c846611506129$export$ab85ecd77ce6a5cd; }, function (v) { return $141c846611506129$export$ab85ecd77ce6a5cd = v; });
$parcel$export(module.exports, "createHmac", function () { return $141c846611506129$export$da39cf97e1eb7c91; }, function (v) { return $141c846611506129$export$da39cf97e1eb7c91 = v; });
$parcel$export(module.exports, "Hmac", function () { return $141c846611506129$export$52a9039d7177394f; }, function (v) { return $141c846611506129$export$52a9039d7177394f = v; });
$parcel$export(module.exports, "getHashes", function () { return $141c846611506129$export$f7201db400317331; }, function (v) { return $141c846611506129$export$f7201db400317331 = v; });
$parcel$export(module.exports, "pbkdf2", function () { return $141c846611506129$export$448fa22aedc9dbca; }, function (v) { return $141c846611506129$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $141c846611506129$export$b80c7ba289c8fa56; }, function (v) { return $141c846611506129$export$b80c7ba289c8fa56 = v; });
$parcel$export(module.exports, "Cipher", function () { return $141c846611506129$export$26e5786e8ac8e530; }, function (v) { return $141c846611506129$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipher", function () { return $141c846611506129$export$bdd223f16383713e; }, function (v) { return $141c846611506129$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $141c846611506129$export$20533d26f07f1ee0; }, function (v) { return $141c846611506129$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $141c846611506129$export$2f64596b8cbf08b4; }, function (v) { return $141c846611506129$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Decipher", function () { return $141c846611506129$export$2ce6d8d0e8b04e1a; }, function (v) { return $141c846611506129$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipher", function () { return $141c846611506129$export$12ada9414fbc594c; }, function (v) { return $141c846611506129$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $141c846611506129$export$f5e7e39d57cd9700; }, function (v) { return $141c846611506129$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $141c846611506129$export$36b6d6ef312eab39; }, function (v) { return $141c846611506129$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $141c846611506129$export$58a258485f1e49f6; }, function (v) { return $141c846611506129$export$58a258485f1e49f6 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $141c846611506129$export$dedd8dc3dc62b370; }, function (v) { return $141c846611506129$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $141c846611506129$export$971862a2fcb1bb40; }, function (v) { return $141c846611506129$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $141c846611506129$export$c6ff6a88acbeaf40; }, function (v) { return $141c846611506129$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $141c846611506129$export$fdc27893e98845cc; }, function (v) { return $141c846611506129$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $141c846611506129$export$6671fb9a1323bed; }, function (v) { return $141c846611506129$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $141c846611506129$export$d74daf141a551db; }, function (v) { return $141c846611506129$export$d74daf141a551db = v; });
$parcel$export(module.exports, "createSign", function () { return $141c846611506129$export$45df7cae684751af; }, function (v) { return $141c846611506129$export$45df7cae684751af = v; });
$parcel$export(module.exports, "Sign", function () { return $141c846611506129$export$1db683ad541682f6; }, function (v) { return $141c846611506129$export$1db683ad541682f6 = v; });
$parcel$export(module.exports, "createVerify", function () { return $141c846611506129$export$6f65485f87568e37; }, function (v) { return $141c846611506129$export$6f65485f87568e37 = v; });
$parcel$export(module.exports, "Verify", function () { return $141c846611506129$export$91a8e56769aeb334; }, function (v) { return $141c846611506129$export$91a8e56769aeb334 = v; });
$parcel$export(module.exports, "createECDH", function () { return $141c846611506129$export$2d4117e99c2179e4; }, function (v) { return $141c846611506129$export$2d4117e99c2179e4 = v; });
$parcel$export(module.exports, "publicEncrypt", function () { return $141c846611506129$export$512823e338ddb1b7; }, function (v) { return $141c846611506129$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $141c846611506129$export$9d0e0c0c4a8d30f3; }, function (v) { return $141c846611506129$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $141c846611506129$export$b9d55ff329113abd; }, function (v) { return $141c846611506129$export$b9d55ff329113abd = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $141c846611506129$export$7efb24e2fddf99b9; }, function (v) { return $141c846611506129$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "randomFill", function () { return $141c846611506129$export$bb1abf2ce84fc7e8; }, function (v) { return $141c846611506129$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $141c846611506129$export$2f7171e78e524d5e; }, function (v) { return $141c846611506129$export$2f7171e78e524d5e = v; });
$parcel$export(module.exports, "createCredentials", function () { return $141c846611506129$export$e1d879b482f37d98; }, function (v) { return $141c846611506129$export$e1d879b482f37d98 = v; });
$parcel$export(module.exports, "constants", function () { return $141c846611506129$export$1a988e7317c65621; }, function (v) { return $141c846611506129$export$1a988e7317c65621 = v; });
// eslint-disable-next-line no-multi-assign
var $141c846611506129$export$5f828d93ff035aa8;
var $141c846611506129$export$cd94982b18c6332c;
var $141c846611506129$export$1d518568e4f529b0;
var $141c846611506129$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $141c846611506129$export$2fb37efbf6ae0c0e;
var $141c846611506129$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $141c846611506129$export$da39cf97e1eb7c91;
var $141c846611506129$export$52a9039d7177394f;
var $141c846611506129$export$f7201db400317331;
var $141c846611506129$export$448fa22aedc9dbca;
var $141c846611506129$export$b80c7ba289c8fa56;
var $141c846611506129$export$26e5786e8ac8e530;
var $141c846611506129$export$bdd223f16383713e;
var $141c846611506129$export$20533d26f07f1ee0;
var $141c846611506129$export$2f64596b8cbf08b4;
var $141c846611506129$export$2ce6d8d0e8b04e1a;
var $141c846611506129$export$12ada9414fbc594c;
var $141c846611506129$export$f5e7e39d57cd9700;
var $141c846611506129$export$36b6d6ef312eab39;
var $141c846611506129$export$58a258485f1e49f6;
var $141c846611506129$export$dedd8dc3dc62b370;
var $141c846611506129$export$971862a2fcb1bb40;
var $141c846611506129$export$c6ff6a88acbeaf40;
var $141c846611506129$export$fdc27893e98845cc;
var $141c846611506129$export$6671fb9a1323bed;
var $141c846611506129$export$d74daf141a551db;
var $141c846611506129$export$45df7cae684751af;
var $141c846611506129$export$1db683ad541682f6;
var $141c846611506129$export$6f65485f87568e37;
var $141c846611506129$export$91a8e56769aeb334;
var $141c846611506129$export$2d4117e99c2179e4;
var $141c846611506129$export$512823e338ddb1b7;
var $141c846611506129$export$9d0e0c0c4a8d30f3;
var $141c846611506129$export$b9d55ff329113abd;
var $141c846611506129$export$7efb24e2fddf99b9;
var $141c846611506129$export$bb1abf2ce84fc7e8;
var $141c846611506129$export$2f7171e78e524d5e;
var $141c846611506129$export$e1d879b482f37d98;
var $141c846611506129$export$1a988e7317c65621;
'use strict';

$141c846611506129$export$5f828d93ff035aa8 = $141c846611506129$export$cd94982b18c6332c = $141c846611506129$export$1d518568e4f529b0 = $141c846611506129$export$5285b6d41c912b41 = (parcelRequire("hw9Ml"));

$141c846611506129$export$2fb37efbf6ae0c0e = $141c846611506129$export$ab85ecd77ce6a5cd = (parcelRequire("5RHXY"));

$141c846611506129$export$da39cf97e1eb7c91 = $141c846611506129$export$52a9039d7177394f = (parcelRequire("kYdR4"));

var $e7jUh = parcelRequire("e7jUh");
var $141c846611506129$var$algoKeys = Object.keys($e7jUh);
var $141c846611506129$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($141c846611506129$var$algoKeys);
$141c846611506129$export$f7201db400317331 = function() {
    return $141c846611506129$var$hashes;
};

var $kUWqc = parcelRequire("kUWqc");
$141c846611506129$export$448fa22aedc9dbca = $kUWqc.pbkdf2;
$141c846611506129$export$b80c7ba289c8fa56 = $kUWqc.pbkdf2Sync;

var $aRc70 = parcelRequire("aRc70");
$141c846611506129$export$26e5786e8ac8e530 = $aRc70.Cipher;
$141c846611506129$export$bdd223f16383713e = $aRc70.createCipher;
$141c846611506129$export$20533d26f07f1ee0 = $aRc70.Cipheriv;
$141c846611506129$export$2f64596b8cbf08b4 = $aRc70.createCipheriv;
$141c846611506129$export$2ce6d8d0e8b04e1a = $aRc70.Decipher;
$141c846611506129$export$12ada9414fbc594c = $aRc70.createDecipher;
$141c846611506129$export$f5e7e39d57cd9700 = $aRc70.Decipheriv;
$141c846611506129$export$36b6d6ef312eab39 = $aRc70.createDecipheriv;
$141c846611506129$export$58a258485f1e49f6 = $aRc70.getCiphers;
$141c846611506129$export$dedd8dc3dc62b370 = $aRc70.listCiphers;

var $87HM8 = parcelRequire("87HM8");
$141c846611506129$export$971862a2fcb1bb40 = $87HM8.DiffieHellmanGroup;
$141c846611506129$export$c6ff6a88acbeaf40 = $87HM8.createDiffieHellmanGroup;
$141c846611506129$export$fdc27893e98845cc = $87HM8.getDiffieHellman;
$141c846611506129$export$6671fb9a1323bed = $87HM8.createDiffieHellman;
$141c846611506129$export$d74daf141a551db = $87HM8.DiffieHellman;

var $441cL = parcelRequire("441cL");
$141c846611506129$export$45df7cae684751af = $441cL.createSign;
$141c846611506129$export$1db683ad541682f6 = $441cL.Sign;
$141c846611506129$export$6f65485f87568e37 = $441cL.createVerify;
$141c846611506129$export$91a8e56769aeb334 = $441cL.Verify;

$141c846611506129$export$2d4117e99c2179e4 = (parcelRequire("iujvJ"));

var $d8Y98 = parcelRequire("d8Y98");
$141c846611506129$export$512823e338ddb1b7 = $d8Y98.publicEncrypt;
$141c846611506129$export$9d0e0c0c4a8d30f3 = $d8Y98.privateEncrypt;
$141c846611506129$export$b9d55ff329113abd = $d8Y98.publicDecrypt;
$141c846611506129$export$7efb24e2fddf99b9 = $d8Y98.privateDecrypt;

var $awW5H = parcelRequire("awW5H");
$141c846611506129$export$bb1abf2ce84fc7e8 = $awW5H.randomFill;
$141c846611506129$export$2f7171e78e524d5e = $awW5H.randomFillSync;
$141c846611506129$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$141c846611506129$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};

});
parcelRegister("hw9Ml", function(module, exports) {

var $4LBMV = parcelRequire("4LBMV");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $cc0d02b0bf57af0c$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $cc0d02b0bf57af0c$var$MAX_UINT32 = 4294967295;
function $cc0d02b0bf57af0c$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $2tQhI = parcelRequire("2tQhI");
var $cc0d02b0bf57af0c$require$Buffer = $2tQhI.Buffer;
var $cc0d02b0bf57af0c$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($cc0d02b0bf57af0c$var$crypto && $cc0d02b0bf57af0c$var$crypto.getRandomValues) module.exports = $cc0d02b0bf57af0c$var$randomBytes;
else module.exports = $cc0d02b0bf57af0c$var$oldBrowser;
function $cc0d02b0bf57af0c$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $cc0d02b0bf57af0c$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $cc0d02b0bf57af0c$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $cc0d02b0bf57af0c$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $cc0d02b0bf57af0c$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $cc0d02b0bf57af0c$var$crypto.getRandomValues(bytes.slice(generated, generated + $cc0d02b0bf57af0c$var$MAX_BYTES));
        else $cc0d02b0bf57af0c$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $4LBMV.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("4LBMV", function(module, exports) {
// shim for using process in browser
var $3788dd25b6693063$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $3788dd25b6693063$var$cachedSetTimeout;
var $3788dd25b6693063$var$cachedClearTimeout;
function $3788dd25b6693063$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $3788dd25b6693063$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $3788dd25b6693063$var$cachedSetTimeout = setTimeout;
        else $3788dd25b6693063$var$cachedSetTimeout = $3788dd25b6693063$var$defaultSetTimout;
    } catch (e) {
        $3788dd25b6693063$var$cachedSetTimeout = $3788dd25b6693063$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $3788dd25b6693063$var$cachedClearTimeout = clearTimeout;
        else $3788dd25b6693063$var$cachedClearTimeout = $3788dd25b6693063$var$defaultClearTimeout;
    } catch (e) {
        $3788dd25b6693063$var$cachedClearTimeout = $3788dd25b6693063$var$defaultClearTimeout;
    }
})();
function $3788dd25b6693063$var$runTimeout(fun) {
    if ($3788dd25b6693063$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3788dd25b6693063$var$cachedSetTimeout === $3788dd25b6693063$var$defaultSetTimout || !$3788dd25b6693063$var$cachedSetTimeout) && setTimeout) {
        $3788dd25b6693063$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3788dd25b6693063$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3788dd25b6693063$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3788dd25b6693063$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3788dd25b6693063$var$runClearTimeout(marker) {
    if ($3788dd25b6693063$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3788dd25b6693063$var$cachedClearTimeout === $3788dd25b6693063$var$defaultClearTimeout || !$3788dd25b6693063$var$cachedClearTimeout) && clearTimeout) {
        $3788dd25b6693063$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3788dd25b6693063$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3788dd25b6693063$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3788dd25b6693063$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3788dd25b6693063$var$queue = [];
var $3788dd25b6693063$var$draining = false;
var $3788dd25b6693063$var$currentQueue;
var $3788dd25b6693063$var$queueIndex = -1;
function $3788dd25b6693063$var$cleanUpNextTick() {
    if (!$3788dd25b6693063$var$draining || !$3788dd25b6693063$var$currentQueue) return;
    $3788dd25b6693063$var$draining = false;
    if ($3788dd25b6693063$var$currentQueue.length) $3788dd25b6693063$var$queue = $3788dd25b6693063$var$currentQueue.concat($3788dd25b6693063$var$queue);
    else $3788dd25b6693063$var$queueIndex = -1;
    if ($3788dd25b6693063$var$queue.length) $3788dd25b6693063$var$drainQueue();
}
function $3788dd25b6693063$var$drainQueue() {
    if ($3788dd25b6693063$var$draining) return;
    var timeout = $3788dd25b6693063$var$runTimeout($3788dd25b6693063$var$cleanUpNextTick);
    $3788dd25b6693063$var$draining = true;
    var len = $3788dd25b6693063$var$queue.length;
    while(len){
        $3788dd25b6693063$var$currentQueue = $3788dd25b6693063$var$queue;
        $3788dd25b6693063$var$queue = [];
        while(++$3788dd25b6693063$var$queueIndex < len)if ($3788dd25b6693063$var$currentQueue) $3788dd25b6693063$var$currentQueue[$3788dd25b6693063$var$queueIndex].run();
        $3788dd25b6693063$var$queueIndex = -1;
        len = $3788dd25b6693063$var$queue.length;
    }
    $3788dd25b6693063$var$currentQueue = null;
    $3788dd25b6693063$var$draining = false;
    $3788dd25b6693063$var$runClearTimeout(timeout);
}
$3788dd25b6693063$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3788dd25b6693063$var$queue.push(new $3788dd25b6693063$var$Item(fun, args));
    if ($3788dd25b6693063$var$queue.length === 1 && !$3788dd25b6693063$var$draining) $3788dd25b6693063$var$runTimeout($3788dd25b6693063$var$drainQueue);
};
// v8 likes predictible objects
function $3788dd25b6693063$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3788dd25b6693063$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$3788dd25b6693063$var$process.title = 'browser';
$3788dd25b6693063$var$process.browser = true;
$3788dd25b6693063$var$process.env = {};
$3788dd25b6693063$var$process.argv = [];
$3788dd25b6693063$var$process.version = ''; // empty string to avoid regexp issues
$3788dd25b6693063$var$process.versions = {};
function $3788dd25b6693063$var$noop() {}
$3788dd25b6693063$var$process.on = $3788dd25b6693063$var$noop;
$3788dd25b6693063$var$process.addListener = $3788dd25b6693063$var$noop;
$3788dd25b6693063$var$process.once = $3788dd25b6693063$var$noop;
$3788dd25b6693063$var$process.off = $3788dd25b6693063$var$noop;
$3788dd25b6693063$var$process.removeListener = $3788dd25b6693063$var$noop;
$3788dd25b6693063$var$process.removeAllListeners = $3788dd25b6693063$var$noop;
$3788dd25b6693063$var$process.emit = $3788dd25b6693063$var$noop;
$3788dd25b6693063$var$process.prependListener = $3788dd25b6693063$var$noop;
$3788dd25b6693063$var$process.prependOnceListener = $3788dd25b6693063$var$noop;
$3788dd25b6693063$var$process.listeners = function(name) {
    return [];
};
$3788dd25b6693063$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$3788dd25b6693063$var$process.cwd = function() {
    return '/';
};
$3788dd25b6693063$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$3788dd25b6693063$var$process.umask = function() {
    return 0;
};

});

parcelRegister("2tQhI", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $81U8s = parcelRequire("81U8s");
var $1ce6d8dd5e0e6422$var$Buffer = $81U8s.Buffer;
// alternative to using Object.keys for old browsers
function $1ce6d8dd5e0e6422$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1ce6d8dd5e0e6422$var$Buffer.from && $1ce6d8dd5e0e6422$var$Buffer.alloc && $1ce6d8dd5e0e6422$var$Buffer.allocUnsafe && $1ce6d8dd5e0e6422$var$Buffer.allocUnsafeSlow) module.exports = $81U8s;
else {
    // Copy properties from require('buffer')
    $1ce6d8dd5e0e6422$var$copyProps($81U8s, module.exports);
    module.exports.Buffer = $1ce6d8dd5e0e6422$var$SafeBuffer;
}
function $1ce6d8dd5e0e6422$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1ce6d8dd5e0e6422$var$Buffer(arg, encodingOrOffset, length);
}
$1ce6d8dd5e0e6422$var$SafeBuffer.prototype = Object.create($1ce6d8dd5e0e6422$var$Buffer.prototype);
// Copy static methods from Buffer
$1ce6d8dd5e0e6422$var$copyProps($1ce6d8dd5e0e6422$var$Buffer, $1ce6d8dd5e0e6422$var$SafeBuffer);
$1ce6d8dd5e0e6422$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $1ce6d8dd5e0e6422$var$Buffer(arg, encodingOrOffset, length);
};
$1ce6d8dd5e0e6422$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $1ce6d8dd5e0e6422$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1ce6d8dd5e0e6422$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $1ce6d8dd5e0e6422$var$Buffer(size);
};
$1ce6d8dd5e0e6422$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $81U8s.SlowBuffer(size);
};

});


parcelRegister("5RHXY", function(module, exports) {
'use strict';

var $27YCQ = parcelRequire("27YCQ");

var $jQriO = parcelRequire("jQriO");

var $9hqA7 = parcelRequire("9hqA7");

var $eaAYH = parcelRequire("eaAYH");

var $bjKi2 = parcelRequire("bjKi2");
function $445401c37fb6ed71$var$Hash(hash) {
    $bjKi2.call(this, 'digest');
    this._hash = hash;
}
$27YCQ($445401c37fb6ed71$var$Hash, $bjKi2);
$445401c37fb6ed71$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$445401c37fb6ed71$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $jQriO();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $9hqA7();
    return new $445401c37fb6ed71$var$Hash($eaAYH(alg));
};

});
parcelRegister("27YCQ", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("jQriO", function(module, exports) {
'use strict';

var $27YCQ = parcelRequire("27YCQ");

var $lEcHu = parcelRequire("lEcHu");

var $2tQhI = parcelRequire("2tQhI");
var $e7280d599bfedd86$require$Buffer = $2tQhI.Buffer;
var $e7280d599bfedd86$var$ARRAY16 = new Array(16);
function $e7280d599bfedd86$var$MD5() {
    $lEcHu.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$27YCQ($e7280d599bfedd86$var$MD5, $lEcHu);
$e7280d599bfedd86$var$MD5.prototype._update = function() {
    var M = $e7280d599bfedd86$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $e7280d599bfedd86$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $e7280d599bfedd86$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $e7280d599bfedd86$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $e7280d599bfedd86$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $e7280d599bfedd86$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $e7280d599bfedd86$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $e7280d599bfedd86$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $e7280d599bfedd86$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $e7280d599bfedd86$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $e7280d599bfedd86$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $e7280d599bfedd86$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $e7280d599bfedd86$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $e7280d599bfedd86$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $e7280d599bfedd86$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $e7280d599bfedd86$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $e7280d599bfedd86$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $e7280d599bfedd86$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $e7280d599bfedd86$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $e7280d599bfedd86$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $e7280d599bfedd86$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $e7280d599bfedd86$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $e7280d599bfedd86$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $e7280d599bfedd86$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $e7280d599bfedd86$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $e7280d599bfedd86$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $e7280d599bfedd86$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $e7280d599bfedd86$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $e7280d599bfedd86$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $e7280d599bfedd86$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $e7280d599bfedd86$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $e7280d599bfedd86$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $e7280d599bfedd86$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $e7280d599bfedd86$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $e7280d599bfedd86$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $e7280d599bfedd86$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $e7280d599bfedd86$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $e7280d599bfedd86$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $e7280d599bfedd86$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $e7280d599bfedd86$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $e7280d599bfedd86$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $e7280d599bfedd86$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $e7280d599bfedd86$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $e7280d599bfedd86$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $e7280d599bfedd86$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $e7280d599bfedd86$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $e7280d599bfedd86$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $e7280d599bfedd86$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $e7280d599bfedd86$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $e7280d599bfedd86$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $e7280d599bfedd86$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $e7280d599bfedd86$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $e7280d599bfedd86$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $e7280d599bfedd86$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $e7280d599bfedd86$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $e7280d599bfedd86$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $e7280d599bfedd86$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $e7280d599bfedd86$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $e7280d599bfedd86$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $e7280d599bfedd86$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $e7280d599bfedd86$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $e7280d599bfedd86$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $e7280d599bfedd86$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $e7280d599bfedd86$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $e7280d599bfedd86$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$e7280d599bfedd86$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $e7280d599bfedd86$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $e7280d599bfedd86$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $e7280d599bfedd86$var$fnF(a, b, c, d, m, k, s) {
    return $e7280d599bfedd86$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $e7280d599bfedd86$var$fnG(a, b, c, d, m, k, s) {
    return $e7280d599bfedd86$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $e7280d599bfedd86$var$fnH(a, b, c, d, m, k, s) {
    return $e7280d599bfedd86$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $e7280d599bfedd86$var$fnI(a, b, c, d, m, k, s) {
    return $e7280d599bfedd86$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $e7280d599bfedd86$var$MD5;

});
parcelRegister("lEcHu", function(module, exports) {
'use strict';

var $2tQhI = parcelRequire("2tQhI");
var $fc272f787754f06e$require$Buffer = $2tQhI.Buffer;

var $6j9Yl = parcelRequire("6j9Yl");

var $fHsVX = parcelRequire("fHsVX");
var $fc272f787754f06e$require$Transform = $fHsVX.Transform;

var $27YCQ = parcelRequire("27YCQ");
function $fc272f787754f06e$var$HashBase(blockSize) {
    $fc272f787754f06e$require$Transform.call(this);
    this._block = $fc272f787754f06e$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$27YCQ($fc272f787754f06e$var$HashBase, $fc272f787754f06e$require$Transform);
$fc272f787754f06e$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$fc272f787754f06e$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$fc272f787754f06e$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    var dataBuffer = $6j9Yl(data, encoding); // asserts correct input type
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + dataBuffer.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;){
            block[i] = dataBuffer[offset];
            i += 1;
            offset += 1;
        }
        this._update();
        this._blockOffset = 0;
    }
    while(offset < dataBuffer.length){
        block[this._blockOffset] = dataBuffer[offset];
        this._blockOffset += 1;
        offset += 1;
    }
    // update length
    for(var j = 0, carry = dataBuffer.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$fc272f787754f06e$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$fc272f787754f06e$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$fc272f787754f06e$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $fc272f787754f06e$var$HashBase;

});
parcelRegister("6j9Yl", function(module, exports) {
'use strict';

var $2tQhI = parcelRequire("2tQhI");
var $497c40b4786ee9ec$require$Buffer = $2tQhI.Buffer;

var $5A7ql = parcelRequire("5A7ql");
var $497c40b4786ee9ec$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $497c40b4786ee9ec$var$useArrayBuffer = $497c40b4786ee9ec$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $497c40b4786ee9ec$var$isView = $497c40b4786ee9ec$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding) {
    if (typeof thing === 'string' || $497c40b4786ee9ec$require$Buffer.isBuffer(thing) || $497c40b4786ee9ec$var$useUint8Array && thing instanceof Uint8Array || $497c40b4786ee9ec$var$isView && $497c40b4786ee9ec$var$isView(thing)) return $5A7ql(thing, encoding);
    throw new TypeError('The "data" argument must be a string, a Buffer, a Uint8Array, or a DataView');
};

});
parcelRegister("5A7ql", function(module, exports) {
'use strict';

var $2tQhI = parcelRequire("2tQhI");
var $410612c20c9713e3$require$Buffer = $2tQhI.Buffer;

var $3Qg3D = parcelRequire("3Qg3D");

var $2mI3d = parcelRequire("2mI3d");
var $410612c20c9713e3$var$isView = ArrayBuffer.isView || function isView(obj) {
    try {
        $2mI3d(obj);
        return true;
    } catch (e) {
        return false;
    }
};
var $410612c20c9713e3$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $410612c20c9713e3$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
var $410612c20c9713e3$var$useFromArrayBuffer = $410612c20c9713e3$var$useArrayBuffer && ($410612c20c9713e3$require$Buffer.prototype instanceof Uint8Array || $410612c20c9713e3$require$Buffer.TYPED_ARRAY_SUPPORT);
module.exports = function toBuffer(data, encoding) {
    if ($410612c20c9713e3$require$Buffer.isBuffer(data)) {
        if (data.constructor && !('isBuffer' in data)) // probably a SlowBuffer
        return $410612c20c9713e3$require$Buffer.from(data);
        return data;
    }
    if (typeof data === 'string') return $410612c20c9713e3$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($410612c20c9713e3$var$useArrayBuffer && $410612c20c9713e3$var$isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $410612c20c9713e3$require$Buffer.alloc(0);
        // When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
        if ($410612c20c9713e3$var$useFromArrayBuffer) {
            var res = $410612c20c9713e3$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            /*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */ if (res.byteLength === data.byteLength) return res;
        }
        // Convert to Uint8Array bytes and then to Buffer
        var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        var result = $410612c20c9713e3$require$Buffer.from(uint8);
        /*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */ if (result.length === data.byteLength) return result;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($410612c20c9713e3$var$useUint8Array && data instanceof Uint8Array) return $410612c20c9713e3$require$Buffer.from(data);
    var isArr = $3Qg3D(data);
    if (isArr) for(var i = 0; i < data.length; i += 1){
        var x = data[i];
        if (typeof x !== 'number' || x < 0 || x > 255 || ~~x !== x // NaN and integer check
        ) throw new RangeError('Array items must be numbers in the range 0-255.');
    }
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if (isArr || $410612c20c9713e3$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $410612c20c9713e3$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

});
parcelRegister("3Qg3D", function(module, exports) {
var $2cc2af232ec32e8b$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $2cc2af232ec32e8b$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("2mI3d", function(module, exports) {
'use strict';

var $20Zn0 = parcelRequire("20Zn0");

var $6QSoo = parcelRequire("6QSoo");
/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $1b8fce7321c85a44$var$$typedArrayBuffer = $6QSoo('TypedArray.prototype.buffer', true);

var $8DhTK = parcelRequire("8DhTK");
/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $1b8fce7321c85a44$var$$typedArrayBuffer || function typedArrayBuffer(x) {
    if (!$8DhTK(x)) throw new $20Zn0('Not a Typed Array');
    return x.buffer;
};

});
parcelRegister("8DhTK", function(module, exports) {
'use strict';

var $7yEH3 = parcelRequire("7yEH3");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$7yEH3(value);
};

});
parcelRegister("7yEH3", function(module, exports) {
'use strict';

var $5mIoX = parcelRequire("5mIoX");

var $kDWUM = parcelRequire("kDWUM");

var $5cC6w = parcelRequire("5cC6w");

var $6QSoo = parcelRequire("6QSoo");

var $h6xkJ = parcelRequire("h6xkJ");

var $gXVYa = parcelRequire("gXVYa");
var $580b46442452d364$var$$toString = $6QSoo('Object.prototype.toString');

var $580b46442452d364$var$hasToStringTag = (parcelRequire("idBkZ"))();
var $580b46442452d364$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $580b46442452d364$var$typedArrays = $kDWUM();
var $580b46442452d364$var$$slice = $6QSoo('String.prototype.slice');
/** @import { BoundSet, BoundSlice, Cache, Getter } from './types' */ /** @import { TypedArrayName } from '.' */ /** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $580b46442452d364$var$$indexOf = $6QSoo('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @type {Cache} */ var $580b46442452d364$var$cache = {
    __proto__: null
};
if ($580b46442452d364$var$hasToStringTag && $h6xkJ && $gXVYa) $5mIoX($580b46442452d364$var$typedArrays, function(typedArray) {
    var arr = new $580b46442452d364$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $gXVYa) {
        var proto = $gXVYa(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $h6xkJ(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $gXVYa(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $h6xkJ(superProto, Symbol.toStringTag);
        }
        if (descriptor && descriptor.get) {
            var bound = $5cC6w(descriptor.get);
            $580b46442452d364$var$cache[/** @type {`$${TypedArrayName}`} */ '$' + typedArray] = bound;
        }
    }
});
else $5mIoX($580b46442452d364$var$typedArrays, function(typedArray) {
    var arr = new $580b46442452d364$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) {
        var bound = /** @type {BoundSlice | BoundSet} */ // @ts-expect-error TODO FIXME
        $5cC6w(fn);
        $580b46442452d364$var$cache[/** @type {`$${TypedArrayName}`} */ '$' + typedArray] = bound;
    }
});
/** @type {(value: object) => false | TypedArrayName} */ function $580b46442452d364$var$tryTypedArrays(value) {
    /** @type {ReturnType<typeof tryTypedArrays>} */ var found = false;
    $5mIoX(/** @type {Record<`$${TypedArrayName}`, Getter>} */ $580b46442452d364$var$cache, /** @param {Getter} getter @param {`$${TypedArrayName}`} typedArray */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {TypedArrayName} */ $580b46442452d364$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
}
/** @type {(value: object) => false | TypedArrayName} */ function $580b46442452d364$var$trySlices(value) {
    /** @type {ReturnType<typeof trySlices>} */ var found = false;
    $5mIoX(/** @type {Record<`$${TypedArrayName}`, Getter>} */ $580b46442452d364$var$cache, /** @param {Getter} getter @param {`$${TypedArrayName}`} name */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {TypedArrayName} */ $580b46442452d364$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
}
/** @type {(tag: unknown) => tag is typeof typedArrays[number]} */ function $580b46442452d364$var$isTATag(tag) {
    return $580b46442452d364$var$$indexOf($580b46442452d364$var$typedArrays, tag) > -1;
}
/**
 * @type {import('.')}
 * @param {unknown} value
 */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$580b46442452d364$var$hasToStringTag) {
        var tag = $580b46442452d364$var$$slice($580b46442452d364$var$$toString(value), 8, -1);
        if ($580b46442452d364$var$isTATag(tag)) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $580b46442452d364$var$trySlices(value);
    }
    if (!$h6xkJ) return null;
     // unknown engine
    return $580b46442452d364$var$tryTypedArrays(value);
};

});
parcelRegister("5mIoX", function(module, exports) {
'use strict';

var $j7hfz = parcelRequire("j7hfz");
var $3e81730f699e9209$var$toStr = Object.prototype.toString;
var $3e81730f699e9209$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $3e81730f699e9209$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($3e81730f699e9209$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $3e81730f699e9209$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $3e81730f699e9209$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($3e81730f699e9209$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $3e81730f699e9209$var$isArray(x) {
    return $3e81730f699e9209$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$j7hfz(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($3e81730f699e9209$var$isArray(list)) $3e81730f699e9209$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $3e81730f699e9209$var$forEachString(list, iterator, receiver);
    else $3e81730f699e9209$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("j7hfz", function(module, exports) {
'use strict';
var $deac0d493774fa12$var$fnToStr = Function.prototype.toString;
var $deac0d493774fa12$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $deac0d493774fa12$var$badArrayLike;
var $deac0d493774fa12$var$isCallableMarker;
if (typeof $deac0d493774fa12$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $deac0d493774fa12$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $deac0d493774fa12$var$isCallableMarker;
        }
    });
    $deac0d493774fa12$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $deac0d493774fa12$var$reflectApply(function() {
        throw 42;
    }, null, $deac0d493774fa12$var$badArrayLike);
} catch (_) {
    if (_ !== $deac0d493774fa12$var$isCallableMarker) $deac0d493774fa12$var$reflectApply = null;
}
else $deac0d493774fa12$var$reflectApply = null;
var $deac0d493774fa12$var$constructorRegex = /^\s*class\b/;
var $deac0d493774fa12$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $deac0d493774fa12$var$fnToStr.call(value);
        return $deac0d493774fa12$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $deac0d493774fa12$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($deac0d493774fa12$var$isES6ClassFn(value)) return false;
        $deac0d493774fa12$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $deac0d493774fa12$var$toStr = Object.prototype.toString;
var $deac0d493774fa12$var$objectClass = '[object Object]';
var $deac0d493774fa12$var$fnClass = '[object Function]';
var $deac0d493774fa12$var$genClass = '[object GeneratorFunction]';
var $deac0d493774fa12$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $deac0d493774fa12$var$ddaClass2 = '[object HTML document.all class]';
var $deac0d493774fa12$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $deac0d493774fa12$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $deac0d493774fa12$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $deac0d493774fa12$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $deac0d493774fa12$var$all = document.all;
    if ($deac0d493774fa12$var$toStr.call($deac0d493774fa12$var$all) === $deac0d493774fa12$var$toStr.call(document.all)) $deac0d493774fa12$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($deac0d493774fa12$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $deac0d493774fa12$var$toStr.call(value);
            return (str === $deac0d493774fa12$var$ddaClass || str === $deac0d493774fa12$var$ddaClass2 || str === $deac0d493774fa12$var$ddaClass3 // opera 12.16
             || str === $deac0d493774fa12$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $deac0d493774fa12$var$reflectApply ? function isCallable(value) {
    if ($deac0d493774fa12$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $deac0d493774fa12$var$reflectApply(value, null, $deac0d493774fa12$var$badArrayLike);
    } catch (e) {
        if (e !== $deac0d493774fa12$var$isCallableMarker) return false;
    }
    return !$deac0d493774fa12$var$isES6ClassFn(value) && $deac0d493774fa12$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($deac0d493774fa12$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($deac0d493774fa12$var$hasToStringTag) return $deac0d493774fa12$var$tryFunctionObject(value);
    if ($deac0d493774fa12$var$isES6ClassFn(value)) return false;
    var strClass = $deac0d493774fa12$var$toStr.call(value);
    if (strClass !== $deac0d493774fa12$var$fnClass && strClass !== $deac0d493774fa12$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $deac0d493774fa12$var$tryFunctionObject(value);
};

});


parcelRegister("kDWUM", function(module, exports) {
'use strict';

var $lgMqJ = parcelRequire("lgMqJ");
var $f075266af53d3ad1$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $lgMqJ.length; i++)if (typeof $f075266af53d3ad1$var$g[$lgMqJ[i]] === 'function') // @ts-expect-error
    out[out.length] = $lgMqJ[i];
    return out;
};

});
parcelRegister("lgMqJ", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("5cC6w", function(module, exports) {
'use strict';

var $5PgcE = parcelRequire("5PgcE");

var $caycu = parcelRequire("caycu");

var $3IkIN = parcelRequire("3IkIN");

var $le42f = parcelRequire("le42f");
module.exports = function callBind(originalFunction) {
    var func = $3IkIN(arguments);
    var adjustedLength = 1 + originalFunction.length - (arguments.length - 1);
    return $5PgcE(func, adjustedLength > 0 ? adjustedLength : 0, true);
};
if ($caycu) $caycu(module.exports, 'apply', {
    value: $le42f
});
else module.exports.apply = $le42f;

});
parcelRegister("5PgcE", function(module, exports) {
'use strict';

var $7Aezy = parcelRequire("7Aezy");

var $jRvzJ = parcelRequire("jRvzJ");

var $43de48bd5a57d956$var$hasDescriptors = (parcelRequire("9NKDn"))();

var $h6xkJ = parcelRequire("h6xkJ");

var $20Zn0 = parcelRequire("20Zn0");
var $43de48bd5a57d956$var$$floor = $7Aezy('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $20Zn0('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $43de48bd5a57d956$var$$floor(length) !== length) throw new $20Zn0('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $h6xkJ) {
        var desc = $h6xkJ(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($43de48bd5a57d956$var$hasDescriptors) $jRvzJ(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $jRvzJ(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("jRvzJ", function(module, exports) {
'use strict';

var $caycu = parcelRequire("caycu");

var $10xMb = parcelRequire("10xMb");

var $20Zn0 = parcelRequire("20Zn0");

var $h6xkJ = parcelRequire("h6xkJ");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $20Zn0('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $20Zn0('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $20Zn0('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $20Zn0('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $20Zn0('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $20Zn0('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$h6xkJ && $h6xkJ(obj, property);
    if ($caycu) $caycu(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $10xMb('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("9NKDn", function(module, exports) {
'use strict';

var $caycu = parcelRequire("caycu");
var $722cdd39ceb155a3$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$caycu;
};
$722cdd39ceb155a3$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$caycu) return null;
    try {
        return $caycu([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $722cdd39ceb155a3$var$hasPropertyDescriptors;

});


parcelRegister("le42f", function(module, exports) {
'use strict';

var $kgO2R = parcelRequire("kgO2R");

var $gqs1G = parcelRequire("gqs1G");

var $34Gsx = parcelRequire("34Gsx");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $34Gsx($kgO2R, $gqs1G, arguments);
};

});


parcelRegister("idBkZ", function(module, exports) {
'use strict';

var $7kBTt = parcelRequire("7kBTt");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $7kBTt() && !!Symbol.toStringTag;
};

});






parcelRegister("fHsVX", function(module, exports) {

exports = module.exports = (parcelRequire("ae4XR"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("9BO66"));

exports.Duplex = (parcelRequire("jQV5B"));

exports.Transform = (parcelRequire("2Wyf3"));

exports.PassThrough = (parcelRequire("cOmDO"));

});
parcelRegister("ae4XR", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4LBMV = parcelRequire("4LBMV");
'use strict';

var $9Jtu4 = parcelRequire("9Jtu4");
/*</replacement>*/ module.exports = $771f10089f565019$var$Readable;

var $eQjx2 = parcelRequire("eQjx2");
/*</replacement>*/ /*<replacement>*/ var $771f10089f565019$var$Duplex;
/*</replacement>*/ $771f10089f565019$var$Readable.ReadableState = $771f10089f565019$var$ReadableState;

var $9A2Mr = parcelRequire("9A2Mr");
var $771f10089f565019$require$EE = $9A2Mr.EventEmitter;
var $771f10089f565019$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $ed29d = parcelRequire("ed29d");

var $2nXbT = parcelRequire("2nXbT");
var $771f10089f565019$require$Buffer = $2nXbT.Buffer;
var $771f10089f565019$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $771f10089f565019$var$_uint8ArrayToBuffer(chunk) {
    return $771f10089f565019$require$Buffer.from(chunk);
}
function $771f10089f565019$var$_isUint8Array(obj) {
    return $771f10089f565019$require$Buffer.isBuffer(obj) || obj instanceof $771f10089f565019$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $771f10089f565019$var$util = Object.create((parcelRequire("c2p8y")));

$771f10089f565019$var$util.inherits = (parcelRequire("27YCQ"));

var $6N7cq = parcelRequire("6N7cq");
var $771f10089f565019$var$debug = void 0;
if ($6N7cq && $6N7cq.debuglog) $771f10089f565019$var$debug = $6N7cq.debuglog('stream');
else $771f10089f565019$var$debug = function() {};

var $5IF8G = parcelRequire("5IF8G");

var $hGK5X = parcelRequire("hGK5X");
var $771f10089f565019$var$StringDecoder;
$771f10089f565019$var$util.inherits($771f10089f565019$var$Readable, $ed29d);
var $771f10089f565019$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $771f10089f565019$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($eQjx2(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $771f10089f565019$var$ReadableState(options, stream) {
    $771f10089f565019$var$Duplex = $771f10089f565019$var$Duplex || (parcelRequire("jQV5B"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $771f10089f565019$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $5IF8G();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$771f10089f565019$var$StringDecoder) $771f10089f565019$var$StringDecoder = (parcelRequire("ckoy0")).StringDecoder;
        this.decoder = new $771f10089f565019$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $771f10089f565019$var$Readable(options) {
    $771f10089f565019$var$Duplex = $771f10089f565019$var$Duplex || (parcelRequire("jQV5B"));
    if (!(this instanceof $771f10089f565019$var$Readable)) return new $771f10089f565019$var$Readable(options);
    this._readableState = new $771f10089f565019$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $ed29d.call(this);
}
Object.defineProperty($771f10089f565019$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$771f10089f565019$var$Readable.prototype.destroy = $hGK5X.destroy;
$771f10089f565019$var$Readable.prototype._undestroy = $hGK5X.undestroy;
$771f10089f565019$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$771f10089f565019$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $771f10089f565019$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $771f10089f565019$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$771f10089f565019$var$Readable.prototype.unshift = function(chunk) {
    return $771f10089f565019$var$readableAddChunk(this, chunk, null, true, false);
};
function $771f10089f565019$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $771f10089f565019$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $771f10089f565019$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $771f10089f565019$require$Buffer.prototype) chunk = $771f10089f565019$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $771f10089f565019$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $771f10089f565019$var$addChunk(stream, state, chunk, false);
                    else $771f10089f565019$var$maybeReadMore(stream, state);
                } else $771f10089f565019$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $771f10089f565019$var$needMoreData(state);
}
function $771f10089f565019$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $771f10089f565019$var$emitReadable(stream);
    }
    $771f10089f565019$var$maybeReadMore(stream, state);
}
function $771f10089f565019$var$chunkInvalid(state, chunk) {
    var er;
    if (!$771f10089f565019$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $771f10089f565019$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$771f10089f565019$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$771f10089f565019$var$Readable.prototype.setEncoding = function(enc) {
    if (!$771f10089f565019$var$StringDecoder) $771f10089f565019$var$StringDecoder = (parcelRequire("ckoy0")).StringDecoder;
    this._readableState.decoder = new $771f10089f565019$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $771f10089f565019$var$MAX_HWM = 0x800000;
function $771f10089f565019$var$computeNewHighWaterMark(n) {
    if (n >= $771f10089f565019$var$MAX_HWM) n = $771f10089f565019$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $771f10089f565019$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $771f10089f565019$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$771f10089f565019$var$Readable.prototype.read = function(n) {
    $771f10089f565019$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $771f10089f565019$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $771f10089f565019$var$endReadable(this);
        else $771f10089f565019$var$emitReadable(this);
        return null;
    }
    n = $771f10089f565019$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $771f10089f565019$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $771f10089f565019$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $771f10089f565019$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $771f10089f565019$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $771f10089f565019$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $771f10089f565019$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $771f10089f565019$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $771f10089f565019$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $771f10089f565019$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $771f10089f565019$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $771f10089f565019$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $771f10089f565019$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $9Jtu4.nextTick($771f10089f565019$var$emitReadable_, stream);
        else $771f10089f565019$var$emitReadable_(stream);
    }
}
function $771f10089f565019$var$emitReadable_(stream) {
    $771f10089f565019$var$debug('emit readable');
    stream.emit('readable');
    $771f10089f565019$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $771f10089f565019$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $9Jtu4.nextTick($771f10089f565019$var$maybeReadMore_, stream, state);
    }
}
function $771f10089f565019$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $771f10089f565019$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$771f10089f565019$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$771f10089f565019$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $771f10089f565019$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4LBMV.stdout && dest !== $4LBMV.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $9Jtu4.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $771f10089f565019$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $771f10089f565019$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $771f10089f565019$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $771f10089f565019$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $771f10089f565019$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $771f10089f565019$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $771f10089f565019$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $771f10089f565019$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($771f10089f565019$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $771f10089f565019$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $771f10089f565019$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $771f10089f565019$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $771f10089f565019$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $771f10089f565019$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $771f10089f565019$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $771f10089f565019$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $771f10089f565019$var$flow(src);
        }
    };
}
$771f10089f565019$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $771f10089f565019$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$771f10089f565019$var$Readable.prototype.on = function(ev, fn) {
    var res = $ed29d.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $9Jtu4.nextTick($771f10089f565019$var$nReadingNextTick, this);
            else if (state.length) $771f10089f565019$var$emitReadable(this);
        }
    }
    return res;
};
$771f10089f565019$var$Readable.prototype.addListener = $771f10089f565019$var$Readable.prototype.on;
function $771f10089f565019$var$nReadingNextTick(self1) {
    $771f10089f565019$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$771f10089f565019$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $771f10089f565019$var$debug('resume');
        state.flowing = true;
        $771f10089f565019$var$resume(this, state);
    }
    return this;
};
function $771f10089f565019$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $9Jtu4.nextTick($771f10089f565019$var$resume_, stream, state);
    }
}
function $771f10089f565019$var$resume_(stream, state) {
    if (!state.reading) {
        $771f10089f565019$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $771f10089f565019$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$771f10089f565019$var$Readable.prototype.pause = function() {
    $771f10089f565019$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $771f10089f565019$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $771f10089f565019$var$flow(stream) {
    var state = stream._readableState;
    $771f10089f565019$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$771f10089f565019$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $771f10089f565019$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $771f10089f565019$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $771f10089f565019$var$kProxyEvents.length; n++)stream.on($771f10089f565019$var$kProxyEvents[n], this.emit.bind(this, $771f10089f565019$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $771f10089f565019$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($771f10089f565019$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$771f10089f565019$var$Readable._fromList = $771f10089f565019$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $771f10089f565019$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $771f10089f565019$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $771f10089f565019$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $771f10089f565019$var$copyFromBufferString(n, list) : $771f10089f565019$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $771f10089f565019$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $771f10089f565019$var$copyFromBuffer(n, list) {
    var ret = $771f10089f565019$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $771f10089f565019$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $9Jtu4.nextTick($771f10089f565019$var$endReadableNT, state, stream);
    }
}
function $771f10089f565019$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $771f10089f565019$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("9Jtu4", function(module, exports) {

var $4LBMV = parcelRequire("4LBMV");
'use strict';
module.exports = {
    nextTick: $715f2ff4b65a7359$var$nextTick
};
function $715f2ff4b65a7359$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $4LBMV.nextTick(fn);
        case 2:
            return $4LBMV.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $4LBMV.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $4LBMV.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $4LBMV.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("eQjx2", function(module, exports) {
var $ace512a25e40ec8a$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $ace512a25e40ec8a$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("9A2Mr", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $6f99a1f32349e3f2$var$R = typeof Reflect === 'object' ? Reflect : null;
var $6f99a1f32349e3f2$var$ReflectApply = $6f99a1f32349e3f2$var$R && typeof $6f99a1f32349e3f2$var$R.apply === 'function' ? $6f99a1f32349e3f2$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $6f99a1f32349e3f2$var$ReflectOwnKeys;
if ($6f99a1f32349e3f2$var$R && typeof $6f99a1f32349e3f2$var$R.ownKeys === 'function') $6f99a1f32349e3f2$var$ReflectOwnKeys = $6f99a1f32349e3f2$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $6f99a1f32349e3f2$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $6f99a1f32349e3f2$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $6f99a1f32349e3f2$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $6f99a1f32349e3f2$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $6f99a1f32349e3f2$var$EventEmitter() {
    $6f99a1f32349e3f2$var$EventEmitter.init.call(this);
}
module.exports = $6f99a1f32349e3f2$var$EventEmitter;
module.exports.once = $6f99a1f32349e3f2$var$once;
// Backwards-compat with node 0.10.x
$6f99a1f32349e3f2$var$EventEmitter.EventEmitter = $6f99a1f32349e3f2$var$EventEmitter;
$6f99a1f32349e3f2$var$EventEmitter.prototype._events = undefined;
$6f99a1f32349e3f2$var$EventEmitter.prototype._eventsCount = 0;
$6f99a1f32349e3f2$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $6f99a1f32349e3f2$var$defaultMaxListeners = 10;
function $6f99a1f32349e3f2$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($6f99a1f32349e3f2$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $6f99a1f32349e3f2$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $6f99a1f32349e3f2$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $6f99a1f32349e3f2$var$defaultMaxListeners = arg;
    }
});
$6f99a1f32349e3f2$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$6f99a1f32349e3f2$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $6f99a1f32349e3f2$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $6f99a1f32349e3f2$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $6f99a1f32349e3f2$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$6f99a1f32349e3f2$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $6f99a1f32349e3f2$var$_getMaxListeners(this);
};
$6f99a1f32349e3f2$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $6f99a1f32349e3f2$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $6f99a1f32349e3f2$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$6f99a1f32349e3f2$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $6f99a1f32349e3f2$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $6f99a1f32349e3f2$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $6f99a1f32349e3f2$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $6f99a1f32349e3f2$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$6f99a1f32349e3f2$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $6f99a1f32349e3f2$var$_addListener(this, type, listener, false);
};
$6f99a1f32349e3f2$var$EventEmitter.prototype.on = $6f99a1f32349e3f2$var$EventEmitter.prototype.addListener;
$6f99a1f32349e3f2$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $6f99a1f32349e3f2$var$_addListener(this, type, listener, true);
};
function $6f99a1f32349e3f2$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $6f99a1f32349e3f2$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $6f99a1f32349e3f2$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$6f99a1f32349e3f2$var$EventEmitter.prototype.once = function once(type, listener) {
    $6f99a1f32349e3f2$var$checkListener(listener);
    this.on(type, $6f99a1f32349e3f2$var$_onceWrap(this, type, listener));
    return this;
};
$6f99a1f32349e3f2$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $6f99a1f32349e3f2$var$checkListener(listener);
    this.prependListener(type, $6f99a1f32349e3f2$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$6f99a1f32349e3f2$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $6f99a1f32349e3f2$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $6f99a1f32349e3f2$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$6f99a1f32349e3f2$var$EventEmitter.prototype.off = $6f99a1f32349e3f2$var$EventEmitter.prototype.removeListener;
$6f99a1f32349e3f2$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $6f99a1f32349e3f2$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $6f99a1f32349e3f2$var$unwrapListeners(evlistener) : $6f99a1f32349e3f2$var$arrayClone(evlistener, evlistener.length);
}
$6f99a1f32349e3f2$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $6f99a1f32349e3f2$var$_listeners(this, type, true);
};
$6f99a1f32349e3f2$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $6f99a1f32349e3f2$var$_listeners(this, type, false);
};
$6f99a1f32349e3f2$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $6f99a1f32349e3f2$var$listenerCount.call(emitter, type);
};
$6f99a1f32349e3f2$var$EventEmitter.prototype.listenerCount = $6f99a1f32349e3f2$var$listenerCount;
function $6f99a1f32349e3f2$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$6f99a1f32349e3f2$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $6f99a1f32349e3f2$var$ReflectOwnKeys(this._events) : [];
};
function $6f99a1f32349e3f2$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $6f99a1f32349e3f2$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $6f99a1f32349e3f2$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $6f99a1f32349e3f2$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $6f99a1f32349e3f2$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $6f99a1f32349e3f2$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $6f99a1f32349e3f2$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $6f99a1f32349e3f2$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $6f99a1f32349e3f2$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("ed29d", function(module, exports) {

module.exports = (parcelRequire("9A2Mr")).EventEmitter;

});

parcelRegister("2nXbT", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $81U8s = parcelRequire("81U8s");
var $1bcba4d6cc190ae7$var$Buffer = $81U8s.Buffer;
// alternative to using Object.keys for old browsers
function $1bcba4d6cc190ae7$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1bcba4d6cc190ae7$var$Buffer.from && $1bcba4d6cc190ae7$var$Buffer.alloc && $1bcba4d6cc190ae7$var$Buffer.allocUnsafe && $1bcba4d6cc190ae7$var$Buffer.allocUnsafeSlow) module.exports = $81U8s;
else {
    // Copy properties from require('buffer')
    $1bcba4d6cc190ae7$var$copyProps($81U8s, module.exports);
    module.exports.Buffer = $1bcba4d6cc190ae7$var$SafeBuffer;
}
function $1bcba4d6cc190ae7$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1bcba4d6cc190ae7$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$1bcba4d6cc190ae7$var$copyProps($1bcba4d6cc190ae7$var$Buffer, $1bcba4d6cc190ae7$var$SafeBuffer);
$1bcba4d6cc190ae7$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $1bcba4d6cc190ae7$var$Buffer(arg, encodingOrOffset, length);
};
$1bcba4d6cc190ae7$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $1bcba4d6cc190ae7$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1bcba4d6cc190ae7$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $1bcba4d6cc190ae7$var$Buffer(size);
};
$1bcba4d6cc190ae7$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $81U8s.SlowBuffer(size);
};

});

parcelRegister("c2p8y", function(module, exports) {

$parcel$export(module.exports, "isArray", function () { return $8c392b9b371d9c90$export$43bee75e5e14138e; }, function (v) { return $8c392b9b371d9c90$export$43bee75e5e14138e = v; });
$parcel$export(module.exports, "isBoolean", function () { return $8c392b9b371d9c90$export$f9ce7b637dfbe238; }, function (v) { return $8c392b9b371d9c90$export$f9ce7b637dfbe238 = v; });
$parcel$export(module.exports, "isNull", function () { return $8c392b9b371d9c90$export$630801d484da15df; }, function (v) { return $8c392b9b371d9c90$export$630801d484da15df = v; });
$parcel$export(module.exports, "isNullOrUndefined", function () { return $8c392b9b371d9c90$export$bedb7023a7733221; }, function (v) { return $8c392b9b371d9c90$export$bedb7023a7733221 = v; });
$parcel$export(module.exports, "isNumber", function () { return $8c392b9b371d9c90$export$7e4aa119212bc614; }, function (v) { return $8c392b9b371d9c90$export$7e4aa119212bc614 = v; });
$parcel$export(module.exports, "isString", function () { return $8c392b9b371d9c90$export$844ec244b1367d54; }, function (v) { return $8c392b9b371d9c90$export$844ec244b1367d54 = v; });
$parcel$export(module.exports, "isSymbol", function () { return $8c392b9b371d9c90$export$a244864fd9645c7f; }, function (v) { return $8c392b9b371d9c90$export$a244864fd9645c7f = v; });
$parcel$export(module.exports, "isUndefined", function () { return $8c392b9b371d9c90$export$fce6876652108ab; }, function (v) { return $8c392b9b371d9c90$export$fce6876652108ab = v; });
$parcel$export(module.exports, "isRegExp", function () { return $8c392b9b371d9c90$export$49841c62b9eff15; }, function (v) { return $8c392b9b371d9c90$export$49841c62b9eff15 = v; });
$parcel$export(module.exports, "isObject", function () { return $8c392b9b371d9c90$export$a6cdc56e425d0d0a; }, function (v) { return $8c392b9b371d9c90$export$a6cdc56e425d0d0a = v; });
$parcel$export(module.exports, "isDate", function () { return $8c392b9b371d9c90$export$871608497c498473; }, function (v) { return $8c392b9b371d9c90$export$871608497c498473 = v; });
$parcel$export(module.exports, "isError", function () { return $8c392b9b371d9c90$export$e6127cc7fe7395c3; }, function (v) { return $8c392b9b371d9c90$export$e6127cc7fe7395c3 = v; });
$parcel$export(module.exports, "isFunction", function () { return $8c392b9b371d9c90$export$f6e2535fb5126e54; }, function (v) { return $8c392b9b371d9c90$export$f6e2535fb5126e54 = v; });
$parcel$export(module.exports, "isPrimitive", function () { return $8c392b9b371d9c90$export$c3825b437cbdea5c; }, function (v) { return $8c392b9b371d9c90$export$c3825b437cbdea5c = v; });
$parcel$export(module.exports, "isBuffer", function () { return $8c392b9b371d9c90$export$a7884ebc965f8f54; }, function (v) { return $8c392b9b371d9c90$export$a7884ebc965f8f54 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $8c392b9b371d9c90$export$43bee75e5e14138e;
var $8c392b9b371d9c90$export$f9ce7b637dfbe238;
var $8c392b9b371d9c90$export$630801d484da15df;
var $8c392b9b371d9c90$export$bedb7023a7733221;
var $8c392b9b371d9c90$export$7e4aa119212bc614;
var $8c392b9b371d9c90$export$844ec244b1367d54;
var $8c392b9b371d9c90$export$a244864fd9645c7f;
var $8c392b9b371d9c90$export$fce6876652108ab;
var $8c392b9b371d9c90$export$49841c62b9eff15;
var $8c392b9b371d9c90$export$a6cdc56e425d0d0a;
var $8c392b9b371d9c90$export$871608497c498473;
var $8c392b9b371d9c90$export$e6127cc7fe7395c3;
var $8c392b9b371d9c90$export$f6e2535fb5126e54;
var $8c392b9b371d9c90$export$c3825b437cbdea5c;
var $8c392b9b371d9c90$export$a7884ebc965f8f54;
function $8c392b9b371d9c90$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $8c392b9b371d9c90$var$objectToString(arg) === '[object Array]';
}
$8c392b9b371d9c90$export$43bee75e5e14138e = $8c392b9b371d9c90$var$isArray;
function $8c392b9b371d9c90$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$8c392b9b371d9c90$export$f9ce7b637dfbe238 = $8c392b9b371d9c90$var$isBoolean;
function $8c392b9b371d9c90$var$isNull(arg) {
    return arg === null;
}
$8c392b9b371d9c90$export$630801d484da15df = $8c392b9b371d9c90$var$isNull;
function $8c392b9b371d9c90$var$isNullOrUndefined(arg) {
    return arg == null;
}
$8c392b9b371d9c90$export$bedb7023a7733221 = $8c392b9b371d9c90$var$isNullOrUndefined;
function $8c392b9b371d9c90$var$isNumber(arg) {
    return typeof arg === 'number';
}
$8c392b9b371d9c90$export$7e4aa119212bc614 = $8c392b9b371d9c90$var$isNumber;
function $8c392b9b371d9c90$var$isString(arg) {
    return typeof arg === 'string';
}
$8c392b9b371d9c90$export$844ec244b1367d54 = $8c392b9b371d9c90$var$isString;
function $8c392b9b371d9c90$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$8c392b9b371d9c90$export$a244864fd9645c7f = $8c392b9b371d9c90$var$isSymbol;
function $8c392b9b371d9c90$var$isUndefined(arg) {
    return arg === void 0;
}
$8c392b9b371d9c90$export$fce6876652108ab = $8c392b9b371d9c90$var$isUndefined;
function $8c392b9b371d9c90$var$isRegExp(re) {
    return $8c392b9b371d9c90$var$objectToString(re) === '[object RegExp]';
}
$8c392b9b371d9c90$export$49841c62b9eff15 = $8c392b9b371d9c90$var$isRegExp;
function $8c392b9b371d9c90$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$8c392b9b371d9c90$export$a6cdc56e425d0d0a = $8c392b9b371d9c90$var$isObject;
function $8c392b9b371d9c90$var$isDate(d) {
    return $8c392b9b371d9c90$var$objectToString(d) === '[object Date]';
}
$8c392b9b371d9c90$export$871608497c498473 = $8c392b9b371d9c90$var$isDate;
function $8c392b9b371d9c90$var$isError(e) {
    return $8c392b9b371d9c90$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$8c392b9b371d9c90$export$e6127cc7fe7395c3 = $8c392b9b371d9c90$var$isError;
function $8c392b9b371d9c90$var$isFunction(arg) {
    return typeof arg === 'function';
}
$8c392b9b371d9c90$export$f6e2535fb5126e54 = $8c392b9b371d9c90$var$isFunction;
function $8c392b9b371d9c90$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$8c392b9b371d9c90$export$c3825b437cbdea5c = $8c392b9b371d9c90$var$isPrimitive;

$8c392b9b371d9c90$export$a7884ebc965f8f54 = (parcelRequire("81U8s")).Buffer.isBuffer;
function $8c392b9b371d9c90$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("5IF8G", function(module, exports) {
'use strict';
function $42a0f927dfb3199b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $2nXbT = parcelRequire("2nXbT");
var $42a0f927dfb3199b$require$Buffer = $2nXbT.Buffer;

var $6N7cq = parcelRequire("6N7cq");
function $42a0f927dfb3199b$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $42a0f927dfb3199b$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $42a0f927dfb3199b$require$Buffer.alloc(0);
        var ret = $42a0f927dfb3199b$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $42a0f927dfb3199b$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($6N7cq && $6N7cq.inspect && $6N7cq.inspect.custom) module.exports.prototype[$6N7cq.inspect.custom] = function() {
    var obj = $6N7cq.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("hGK5X", function(module, exports) {
'use strict';

var $9Jtu4 = parcelRequire("9Jtu4");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $ce0a1d6e187ea978$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $9Jtu4.nextTick($ce0a1d6e187ea978$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $9Jtu4.nextTick($ce0a1d6e187ea978$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $9Jtu4.nextTick($ce0a1d6e187ea978$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $9Jtu4.nextTick($ce0a1d6e187ea978$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $ce0a1d6e187ea978$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $ce0a1d6e187ea978$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $ce0a1d6e187ea978$var$destroy,
    undestroy: $ce0a1d6e187ea978$var$undestroy
};

});

parcelRegister("jQV5B", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $9Jtu4 = parcelRequire("9Jtu4");
/*</replacement>*/ /*<replacement>*/ var $e73f286d108798d0$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $e73f286d108798d0$var$Duplex;

/*<replacement>*/ var $e73f286d108798d0$var$util = Object.create((parcelRequire("c2p8y")));

$e73f286d108798d0$var$util.inherits = (parcelRequire("27YCQ"));

var $ae4XR = parcelRequire("ae4XR");

var $9BO66 = parcelRequire("9BO66");
$e73f286d108798d0$var$util.inherits($e73f286d108798d0$var$Duplex, $ae4XR);
// avoid scope creep, the keys array can then be collected
var $e73f286d108798d0$var$keys = $e73f286d108798d0$var$objectKeys($9BO66.prototype);
for(var $e73f286d108798d0$var$v = 0; $e73f286d108798d0$var$v < $e73f286d108798d0$var$keys.length; $e73f286d108798d0$var$v++){
    var $e73f286d108798d0$var$method = $e73f286d108798d0$var$keys[$e73f286d108798d0$var$v];
    if (!$e73f286d108798d0$var$Duplex.prototype[$e73f286d108798d0$var$method]) $e73f286d108798d0$var$Duplex.prototype[$e73f286d108798d0$var$method] = $9BO66.prototype[$e73f286d108798d0$var$method];
}
function $e73f286d108798d0$var$Duplex(options) {
    if (!(this instanceof $e73f286d108798d0$var$Duplex)) return new $e73f286d108798d0$var$Duplex(options);
    $ae4XR.call(this, options);
    $9BO66.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $e73f286d108798d0$var$onend);
}
Object.defineProperty($e73f286d108798d0$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $e73f286d108798d0$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $9Jtu4.nextTick($e73f286d108798d0$var$onEndNT, this);
}
function $e73f286d108798d0$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($e73f286d108798d0$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$e73f286d108798d0$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $9Jtu4.nextTick(cb, err);
};

});
parcelRegister("9BO66", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $9Jtu4 = parcelRequire("9Jtu4");
/*</replacement>*/ module.exports = $6fee6e0f1bc98c10$var$Writable;
/* <replacement> */ function $6fee6e0f1bc98c10$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $6fee6e0f1bc98c10$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $6fee6e0f1bc98c10$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $6fee6e0f1bc98c10$var$asyncWrite = (0, $9Jtu4.nextTick);
/*</replacement>*/ /*<replacement>*/ var $6fee6e0f1bc98c10$var$Duplex;
/*</replacement>*/ $6fee6e0f1bc98c10$var$Writable.WritableState = $6fee6e0f1bc98c10$var$WritableState;

/*<replacement>*/ var $6fee6e0f1bc98c10$var$util = Object.create((parcelRequire("c2p8y")));

$6fee6e0f1bc98c10$var$util.inherits = (parcelRequire("27YCQ"));

/*</replacement>*/ /*<replacement>*/ var $6fee6e0f1bc98c10$var$internalUtil = {
    deprecate: (parcelRequire("5NQdo"))
};

var $ed29d = parcelRequire("ed29d");

var $2nXbT = parcelRequire("2nXbT");
var $6fee6e0f1bc98c10$require$Buffer = $2nXbT.Buffer;
var $6fee6e0f1bc98c10$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $6fee6e0f1bc98c10$var$_uint8ArrayToBuffer(chunk) {
    return $6fee6e0f1bc98c10$require$Buffer.from(chunk);
}
function $6fee6e0f1bc98c10$var$_isUint8Array(obj) {
    return $6fee6e0f1bc98c10$require$Buffer.isBuffer(obj) || obj instanceof $6fee6e0f1bc98c10$var$OurUint8Array;
}

var $hGK5X = parcelRequire("hGK5X");
$6fee6e0f1bc98c10$var$util.inherits($6fee6e0f1bc98c10$var$Writable, $ed29d);
function $6fee6e0f1bc98c10$var$nop() {}

function $6fee6e0f1bc98c10$var$WritableState(options, stream) {
    $6fee6e0f1bc98c10$var$Duplex = $6fee6e0f1bc98c10$var$Duplex || (parcelRequire("jQV5B"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $6fee6e0f1bc98c10$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $6fee6e0f1bc98c10$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $6fee6e0f1bc98c10$var$CorkedRequest(this);
}
$6fee6e0f1bc98c10$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($6fee6e0f1bc98c10$var$WritableState.prototype, 'buffer', {
            get: $6fee6e0f1bc98c10$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $6fee6e0f1bc98c10$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $6fee6e0f1bc98c10$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($6fee6e0f1bc98c10$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($6fee6e0f1bc98c10$var$realHasInstance.call(this, object)) return true;
            if (this !== $6fee6e0f1bc98c10$var$Writable) return false;
            return object && object._writableState instanceof $6fee6e0f1bc98c10$var$WritableState;
        }
    });
} else $6fee6e0f1bc98c10$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $6fee6e0f1bc98c10$var$Writable(options) {
    $6fee6e0f1bc98c10$var$Duplex = $6fee6e0f1bc98c10$var$Duplex || (parcelRequire("jQV5B"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$6fee6e0f1bc98c10$var$realHasInstance.call($6fee6e0f1bc98c10$var$Writable, this) && !(this instanceof $6fee6e0f1bc98c10$var$Duplex)) return new $6fee6e0f1bc98c10$var$Writable(options);
    this._writableState = new $6fee6e0f1bc98c10$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $ed29d.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$6fee6e0f1bc98c10$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $6fee6e0f1bc98c10$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $9Jtu4.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $6fee6e0f1bc98c10$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $9Jtu4.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$6fee6e0f1bc98c10$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $6fee6e0f1bc98c10$var$_isUint8Array(chunk);
    if (isBuf && !$6fee6e0f1bc98c10$require$Buffer.isBuffer(chunk)) chunk = $6fee6e0f1bc98c10$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $6fee6e0f1bc98c10$var$nop;
    if (state.ended) $6fee6e0f1bc98c10$var$writeAfterEnd(this, cb);
    else if (isBuf || $6fee6e0f1bc98c10$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $6fee6e0f1bc98c10$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$6fee6e0f1bc98c10$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$6fee6e0f1bc98c10$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $6fee6e0f1bc98c10$var$clearBuffer(this, state);
    }
};
$6fee6e0f1bc98c10$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $6fee6e0f1bc98c10$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $6fee6e0f1bc98c10$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($6fee6e0f1bc98c10$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $6fee6e0f1bc98c10$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $6fee6e0f1bc98c10$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $6fee6e0f1bc98c10$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $6fee6e0f1bc98c10$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $6fee6e0f1bc98c10$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $9Jtu4.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $9Jtu4.nextTick($6fee6e0f1bc98c10$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $6fee6e0f1bc98c10$var$finishMaybe(stream, state);
    }
}
function $6fee6e0f1bc98c10$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $6fee6e0f1bc98c10$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $6fee6e0f1bc98c10$var$onwriteStateUpdate(state);
    if (er) $6fee6e0f1bc98c10$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $6fee6e0f1bc98c10$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $6fee6e0f1bc98c10$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $6fee6e0f1bc98c10$var$asyncWrite($6fee6e0f1bc98c10$var$afterWrite, stream, state, finished, cb);
        else $6fee6e0f1bc98c10$var$afterWrite(stream, state, finished, cb);
    }
}
function $6fee6e0f1bc98c10$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $6fee6e0f1bc98c10$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $6fee6e0f1bc98c10$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $6fee6e0f1bc98c10$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $6fee6e0f1bc98c10$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $6fee6e0f1bc98c10$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $6fee6e0f1bc98c10$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $6fee6e0f1bc98c10$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$6fee6e0f1bc98c10$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$6fee6e0f1bc98c10$var$Writable.prototype._writev = null;
$6fee6e0f1bc98c10$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $6fee6e0f1bc98c10$var$endWritable(this, state, cb);
};
function $6fee6e0f1bc98c10$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $6fee6e0f1bc98c10$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $6fee6e0f1bc98c10$var$finishMaybe(stream, state);
    });
}
function $6fee6e0f1bc98c10$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $9Jtu4.nextTick($6fee6e0f1bc98c10$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $6fee6e0f1bc98c10$var$finishMaybe(stream, state) {
    var need = $6fee6e0f1bc98c10$var$needFinish(state);
    if (need) {
        $6fee6e0f1bc98c10$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $6fee6e0f1bc98c10$var$endWritable(stream, state, cb) {
    state.ending = true;
    $6fee6e0f1bc98c10$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $9Jtu4.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $6fee6e0f1bc98c10$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($6fee6e0f1bc98c10$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$6fee6e0f1bc98c10$var$Writable.prototype.destroy = $hGK5X.destroy;
$6fee6e0f1bc98c10$var$Writable.prototype._undestroy = $hGK5X.undestroy;
$6fee6e0f1bc98c10$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});
parcelRegister("5NQdo", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $439a082f5d5ae77f$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $439a082f5d5ae77f$var$deprecate(fn, msg) {
    if ($439a082f5d5ae77f$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($439a082f5d5ae77f$var$config('throwDeprecation')) throw new Error(msg);
            else if ($439a082f5d5ae77f$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $439a082f5d5ae77f$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("ckoy0", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $8f9a64efbc740540$export$63a7aa211a91ed69; }, function (v) { return $8f9a64efbc740540$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $8f9a64efbc740540$export$63a7aa211a91ed69;
'use strict';

var $2nXbT = parcelRequire("2nXbT");
var $8f9a64efbc740540$require$Buffer = $2nXbT.Buffer;
/*</replacement>*/ var $8f9a64efbc740540$var$isEncoding = $8f9a64efbc740540$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $8f9a64efbc740540$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $8f9a64efbc740540$var$normalizeEncoding(enc) {
    var nenc = $8f9a64efbc740540$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($8f9a64efbc740540$require$Buffer.isEncoding === $8f9a64efbc740540$var$isEncoding || !$8f9a64efbc740540$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$8f9a64efbc740540$export$63a7aa211a91ed69 = $8f9a64efbc740540$var$StringDecoder;
function $8f9a64efbc740540$var$StringDecoder(encoding) {
    this.encoding = $8f9a64efbc740540$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $8f9a64efbc740540$var$utf16Text;
            this.end = $8f9a64efbc740540$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $8f9a64efbc740540$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $8f9a64efbc740540$var$base64Text;
            this.end = $8f9a64efbc740540$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $8f9a64efbc740540$var$simpleWrite;
            this.end = $8f9a64efbc740540$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $8f9a64efbc740540$require$Buffer.allocUnsafe(nb);
}
$8f9a64efbc740540$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$8f9a64efbc740540$var$StringDecoder.prototype.end = $8f9a64efbc740540$var$utf8End;
// Returns only complete characters in a Buffer
$8f9a64efbc740540$var$StringDecoder.prototype.text = $8f9a64efbc740540$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$8f9a64efbc740540$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $8f9a64efbc740540$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $8f9a64efbc740540$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $8f9a64efbc740540$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $8f9a64efbc740540$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $8f9a64efbc740540$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $8f9a64efbc740540$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $8f9a64efbc740540$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $8f9a64efbc740540$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $8f9a64efbc740540$var$utf8Text(buf, i) {
    var total = $8f9a64efbc740540$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $8f9a64efbc740540$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $8f9a64efbc740540$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $8f9a64efbc740540$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $8f9a64efbc740540$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $8f9a64efbc740540$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $8f9a64efbc740540$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $8f9a64efbc740540$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});


parcelRegister("2Wyf3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $224b8f3e3c266c9e$var$Transform;

var $jQV5B = parcelRequire("jQV5B");

/*<replacement>*/ var $224b8f3e3c266c9e$var$util = Object.create((parcelRequire("c2p8y")));

$224b8f3e3c266c9e$var$util.inherits = (parcelRequire("27YCQ"));
/*</replacement>*/ $224b8f3e3c266c9e$var$util.inherits($224b8f3e3c266c9e$var$Transform, $jQV5B);
function $224b8f3e3c266c9e$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $224b8f3e3c266c9e$var$Transform(options) {
    if (!(this instanceof $224b8f3e3c266c9e$var$Transform)) return new $224b8f3e3c266c9e$var$Transform(options);
    $jQV5B.call(this, options);
    this._transformState = {
        afterTransform: $224b8f3e3c266c9e$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $224b8f3e3c266c9e$var$prefinish);
}
function $224b8f3e3c266c9e$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $224b8f3e3c266c9e$var$done(_this, er, data);
    });
    else $224b8f3e3c266c9e$var$done(this, null, null);
}
$224b8f3e3c266c9e$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $jQV5B.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$224b8f3e3c266c9e$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$224b8f3e3c266c9e$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$224b8f3e3c266c9e$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$224b8f3e3c266c9e$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $jQV5B.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $224b8f3e3c266c9e$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("cOmDO", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $953bb7992d9fde36$var$PassThrough;

var $2Wyf3 = parcelRequire("2Wyf3");

/*<replacement>*/ var $953bb7992d9fde36$var$util = Object.create((parcelRequire("c2p8y")));

$953bb7992d9fde36$var$util.inherits = (parcelRequire("27YCQ"));
/*</replacement>*/ $953bb7992d9fde36$var$util.inherits($953bb7992d9fde36$var$PassThrough, $2Wyf3);
function $953bb7992d9fde36$var$PassThrough(options) {
    if (!(this instanceof $953bb7992d9fde36$var$PassThrough)) return new $953bb7992d9fde36$var$PassThrough(options);
    $2Wyf3.call(this, options);
}
$953bb7992d9fde36$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});




parcelRegister("9hqA7", function(module, exports) {
'use strict';

var $81U8s = parcelRequire("81U8s");
var $6c1a5224bf8f4b60$require$Buffer = $81U8s.Buffer;

var $27YCQ = parcelRequire("27YCQ");

var $lEcHu = parcelRequire("lEcHu");
var $6c1a5224bf8f4b60$var$ARRAY16 = new Array(16);
var $6c1a5224bf8f4b60$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $6c1a5224bf8f4b60$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $6c1a5224bf8f4b60$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $6c1a5224bf8f4b60$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $6c1a5224bf8f4b60$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $6c1a5224bf8f4b60$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $6c1a5224bf8f4b60$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $6c1a5224bf8f4b60$var$fn1(a, b, c, d, e, m, k, s) {
    return $6c1a5224bf8f4b60$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $6c1a5224bf8f4b60$var$fn2(a, b, c, d, e, m, k, s) {
    return $6c1a5224bf8f4b60$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $6c1a5224bf8f4b60$var$fn3(a, b, c, d, e, m, k, s) {
    return $6c1a5224bf8f4b60$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $6c1a5224bf8f4b60$var$fn4(a, b, c, d, e, m, k, s) {
    return $6c1a5224bf8f4b60$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $6c1a5224bf8f4b60$var$fn5(a, b, c, d, e, m, k, s) {
    return $6c1a5224bf8f4b60$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
function $6c1a5224bf8f4b60$var$RIPEMD160() {
    $lEcHu.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$27YCQ($6c1a5224bf8f4b60$var$RIPEMD160, $lEcHu);
$6c1a5224bf8f4b60$var$RIPEMD160.prototype._update = function() {
    var words = $6c1a5224bf8f4b60$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $6c1a5224bf8f4b60$var$fn1(al, bl, cl, dl, el, words[$6c1a5224bf8f4b60$var$zl[i]], $6c1a5224bf8f4b60$var$hl[0], $6c1a5224bf8f4b60$var$sl[i]);
            tr = $6c1a5224bf8f4b60$var$fn5(ar, br, cr, dr, er, words[$6c1a5224bf8f4b60$var$zr[i]], $6c1a5224bf8f4b60$var$hr[0], $6c1a5224bf8f4b60$var$sr[i]);
        } else if (i < 32) {
            tl = $6c1a5224bf8f4b60$var$fn2(al, bl, cl, dl, el, words[$6c1a5224bf8f4b60$var$zl[i]], $6c1a5224bf8f4b60$var$hl[1], $6c1a5224bf8f4b60$var$sl[i]);
            tr = $6c1a5224bf8f4b60$var$fn4(ar, br, cr, dr, er, words[$6c1a5224bf8f4b60$var$zr[i]], $6c1a5224bf8f4b60$var$hr[1], $6c1a5224bf8f4b60$var$sr[i]);
        } else if (i < 48) {
            tl = $6c1a5224bf8f4b60$var$fn3(al, bl, cl, dl, el, words[$6c1a5224bf8f4b60$var$zl[i]], $6c1a5224bf8f4b60$var$hl[2], $6c1a5224bf8f4b60$var$sl[i]);
            tr = $6c1a5224bf8f4b60$var$fn3(ar, br, cr, dr, er, words[$6c1a5224bf8f4b60$var$zr[i]], $6c1a5224bf8f4b60$var$hr[2], $6c1a5224bf8f4b60$var$sr[i]);
        } else if (i < 64) {
            tl = $6c1a5224bf8f4b60$var$fn4(al, bl, cl, dl, el, words[$6c1a5224bf8f4b60$var$zl[i]], $6c1a5224bf8f4b60$var$hl[3], $6c1a5224bf8f4b60$var$sl[i]);
            tr = $6c1a5224bf8f4b60$var$fn2(ar, br, cr, dr, er, words[$6c1a5224bf8f4b60$var$zr[i]], $6c1a5224bf8f4b60$var$hr[3], $6c1a5224bf8f4b60$var$sr[i]);
        } else {
            tl = $6c1a5224bf8f4b60$var$fn5(al, bl, cl, dl, el, words[$6c1a5224bf8f4b60$var$zl[i]], $6c1a5224bf8f4b60$var$hl[4], $6c1a5224bf8f4b60$var$sl[i]);
            tr = $6c1a5224bf8f4b60$var$fn1(ar, br, cr, dr, er, words[$6c1a5224bf8f4b60$var$zr[i]], $6c1a5224bf8f4b60$var$hr[4], $6c1a5224bf8f4b60$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $6c1a5224bf8f4b60$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $6c1a5224bf8f4b60$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$6c1a5224bf8f4b60$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset] = 0x80;
    this._blockOffset += 1;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $6c1a5224bf8f4b60$require$Buffer.alloc ? $6c1a5224bf8f4b60$require$Buffer.alloc(20) : new $6c1a5224bf8f4b60$require$Buffer(20); // eslint-disable-line no-buffer-constructor
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
module.exports = $6c1a5224bf8f4b60$var$RIPEMD160;

});

parcelRegister("eaAYH", function(module, exports) {
'use strict';
module.exports = function SHA(algorithm) {
    var alg = algorithm.toLowerCase();
    var Algorithm = module.exports[alg];
    if (!Algorithm) throw new Error(alg + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

module.exports.sha = (parcelRequire("kvasG"));

module.exports.sha1 = (parcelRequire("6a5RN"));

module.exports.sha224 = (parcelRequire("huQMO"));

module.exports.sha256 = (parcelRequire("gaHBy"));

module.exports.sha384 = (parcelRequire("irLT4"));

module.exports.sha512 = (parcelRequire("7Uphc"));

});
parcelRegister("kvasG", function(module, exports) {
'use strict';

var $27YCQ = parcelRequire("27YCQ");

var $3GFDs = parcelRequire("3GFDs");

var $2tQhI = parcelRequire("2tQhI");
var $eeced15df752c9ba$require$Buffer = $2tQhI.Buffer;
var $eeced15df752c9ba$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $eeced15df752c9ba$var$W = new Array(80);
function $eeced15df752c9ba$var$Sha() {
    this.init();
    this._w = $eeced15df752c9ba$var$W;
    $3GFDs.call(this, 64, 56);
}
$27YCQ($eeced15df752c9ba$var$Sha, $3GFDs);
$eeced15df752c9ba$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $eeced15df752c9ba$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $eeced15df752c9ba$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $eeced15df752c9ba$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$eeced15df752c9ba$var$Sha.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $eeced15df752c9ba$var$rotl5(a) + $eeced15df752c9ba$var$ft(s, b, c, d) + e + w[j] + $eeced15df752c9ba$var$K[s] | 0;
        e = d;
        d = c;
        c = $eeced15df752c9ba$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$eeced15df752c9ba$var$Sha.prototype._hash = function() {
    var H = $eeced15df752c9ba$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $eeced15df752c9ba$var$Sha;

});
parcelRegister("3GFDs", function(module, exports) {
'use strict';

var $2tQhI = parcelRequire("2tQhI");
var $2af597459d806658$require$Buffer = $2tQhI.Buffer;

var $5A7ql = parcelRequire("5A7ql");
// prototype class for hash functions
function $2af597459d806658$var$Hash(blockSize, finalSize) {
    this._block = $2af597459d806658$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$2af597459d806658$var$Hash.prototype.update = function(data, enc) {
    /* eslint no-param-reassign: 0 */ data = $5A7ql(data, enc || 'utf8');
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$2af597459d806658$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    /*
	 * zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	 * non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	 */ this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$2af597459d806658$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $2af597459d806658$var$Hash;

});


parcelRegister("6a5RN", function(module, exports) {
'use strict';

var $27YCQ = parcelRequire("27YCQ");

var $3GFDs = parcelRequire("3GFDs");

var $2tQhI = parcelRequire("2tQhI");
var $47c83a4208cd1961$require$Buffer = $2tQhI.Buffer;
var $47c83a4208cd1961$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $47c83a4208cd1961$var$W = new Array(80);
function $47c83a4208cd1961$var$Sha1() {
    this.init();
    this._w = $47c83a4208cd1961$var$W;
    $3GFDs.call(this, 64, 56);
}
$27YCQ($47c83a4208cd1961$var$Sha1, $3GFDs);
$47c83a4208cd1961$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $47c83a4208cd1961$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $47c83a4208cd1961$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $47c83a4208cd1961$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $47c83a4208cd1961$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$47c83a4208cd1961$var$Sha1.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = $47c83a4208cd1961$var$rotl1(w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $47c83a4208cd1961$var$rotl5(a) + $47c83a4208cd1961$var$ft(s, b, c, d) + e + w[j] + $47c83a4208cd1961$var$K[s] | 0;
        e = d;
        d = c;
        c = $47c83a4208cd1961$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$47c83a4208cd1961$var$Sha1.prototype._hash = function() {
    var H = $47c83a4208cd1961$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $47c83a4208cd1961$var$Sha1;

});

parcelRegister("huQMO", function(module, exports) {
'use strict';

var $27YCQ = parcelRequire("27YCQ");

var $gaHBy = parcelRequire("gaHBy");

var $3GFDs = parcelRequire("3GFDs");

var $2tQhI = parcelRequire("2tQhI");
var $cbce2f4831681d54$require$Buffer = $2tQhI.Buffer;
var $cbce2f4831681d54$var$W = new Array(64);
function $cbce2f4831681d54$var$Sha224() {
    this.init();
    this._w = $cbce2f4831681d54$var$W; // new Array(64)
    $3GFDs.call(this, 64, 56);
}
$27YCQ($cbce2f4831681d54$var$Sha224, $gaHBy);
$cbce2f4831681d54$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$cbce2f4831681d54$var$Sha224.prototype._hash = function() {
    var H = $cbce2f4831681d54$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $cbce2f4831681d54$var$Sha224;

});
parcelRegister("gaHBy", function(module, exports) {
'use strict';

var $27YCQ = parcelRequire("27YCQ");

var $3GFDs = parcelRequire("3GFDs");

var $2tQhI = parcelRequire("2tQhI");
var $bc5f677e6a36ff27$require$Buffer = $2tQhI.Buffer;
var $bc5f677e6a36ff27$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $bc5f677e6a36ff27$var$W = new Array(64);
function $bc5f677e6a36ff27$var$Sha256() {
    this.init();
    this._w = $bc5f677e6a36ff27$var$W; // new Array(64)
    $3GFDs.call(this, 64, 56);
}
$27YCQ($bc5f677e6a36ff27$var$Sha256, $3GFDs);
$bc5f677e6a36ff27$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $bc5f677e6a36ff27$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $bc5f677e6a36ff27$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $bc5f677e6a36ff27$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $bc5f677e6a36ff27$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $bc5f677e6a36ff27$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $bc5f677e6a36ff27$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$bc5f677e6a36ff27$var$Sha256.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)w[i] = $bc5f677e6a36ff27$var$gamma1(w[i - 2]) + w[i - 7] + $bc5f677e6a36ff27$var$gamma0(w[i - 15]) + w[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $bc5f677e6a36ff27$var$sigma1(e) + $bc5f677e6a36ff27$var$ch(e, f, g) + $bc5f677e6a36ff27$var$K[j] + w[j] | 0;
        var T2 = $bc5f677e6a36ff27$var$sigma0(a) + $bc5f677e6a36ff27$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$bc5f677e6a36ff27$var$Sha256.prototype._hash = function() {
    var H = $bc5f677e6a36ff27$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $bc5f677e6a36ff27$var$Sha256;

});


parcelRegister("irLT4", function(module, exports) {
'use strict';

var $27YCQ = parcelRequire("27YCQ");

var $7Uphc = parcelRequire("7Uphc");

var $3GFDs = parcelRequire("3GFDs");

var $2tQhI = parcelRequire("2tQhI");
var $d6dfe50b1b1b3a01$require$Buffer = $2tQhI.Buffer;
var $d6dfe50b1b1b3a01$var$W = new Array(160);
function $d6dfe50b1b1b3a01$var$Sha384() {
    this.init();
    this._w = $d6dfe50b1b1b3a01$var$W;
    $3GFDs.call(this, 128, 112);
}
$27YCQ($d6dfe50b1b1b3a01$var$Sha384, $7Uphc);
$d6dfe50b1b1b3a01$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$d6dfe50b1b1b3a01$var$Sha384.prototype._hash = function() {
    var H = $d6dfe50b1b1b3a01$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $d6dfe50b1b1b3a01$var$Sha384;

});
parcelRegister("7Uphc", function(module, exports) {
'use strict';

var $27YCQ = parcelRequire("27YCQ");

var $3GFDs = parcelRequire("3GFDs");

var $2tQhI = parcelRequire("2tQhI");
var $5c215ebd86d009a7$require$Buffer = $2tQhI.Buffer;
var $5c215ebd86d009a7$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $5c215ebd86d009a7$var$W = new Array(160);
function $5c215ebd86d009a7$var$Sha512() {
    this.init();
    this._w = $5c215ebd86d009a7$var$W;
    $3GFDs.call(this, 128, 112);
}
$27YCQ($5c215ebd86d009a7$var$Sha512, $3GFDs);
$5c215ebd86d009a7$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $5c215ebd86d009a7$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $5c215ebd86d009a7$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $5c215ebd86d009a7$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $5c215ebd86d009a7$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $5c215ebd86d009a7$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $5c215ebd86d009a7$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $5c215ebd86d009a7$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $5c215ebd86d009a7$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $5c215ebd86d009a7$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$5c215ebd86d009a7$var$Sha512.prototype._update = function(M) {
    var w = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        w[i] = M.readInt32BE(i * 4);
        w[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = w[i - 30];
        var xl = w[i - 30 + 1];
        var gamma0 = $5c215ebd86d009a7$var$Gamma0(xh, xl);
        var gamma0l = $5c215ebd86d009a7$var$Gamma0l(xl, xh);
        xh = w[i - 4];
        xl = w[i - 4 + 1];
        var gamma1 = $5c215ebd86d009a7$var$Gamma1(xh, xl);
        var gamma1l = $5c215ebd86d009a7$var$Gamma1l(xl, xh);
        // w[i] = gamma0 + w[i - 7] + gamma1 + w[i - 16]
        var Wi7h = w[i - 14];
        var Wi7l = w[i - 14 + 1];
        var Wi16h = w[i - 32];
        var Wi16l = w[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $5c215ebd86d009a7$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $5c215ebd86d009a7$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $5c215ebd86d009a7$var$getCarry(Wil, Wi16l) | 0;
        w[i] = Wih;
        w[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = w[j];
        Wil = w[j + 1];
        var majh = $5c215ebd86d009a7$var$maj(ah, bh, ch);
        var majl = $5c215ebd86d009a7$var$maj(al, bl, cl);
        var sigma0h = $5c215ebd86d009a7$var$sigma0(ah, al);
        var sigma0l = $5c215ebd86d009a7$var$sigma0(al, ah);
        var sigma1h = $5c215ebd86d009a7$var$sigma1(eh, el);
        var sigma1l = $5c215ebd86d009a7$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + w[j]
        var Kih = $5c215ebd86d009a7$var$K[j];
        var Kil = $5c215ebd86d009a7$var$K[j + 1];
        var chh = $5c215ebd86d009a7$var$Ch(eh, fh, gh);
        var chl = $5c215ebd86d009a7$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $5c215ebd86d009a7$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $5c215ebd86d009a7$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $5c215ebd86d009a7$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $5c215ebd86d009a7$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $5c215ebd86d009a7$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $5c215ebd86d009a7$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $5c215ebd86d009a7$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $5c215ebd86d009a7$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $5c215ebd86d009a7$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $5c215ebd86d009a7$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $5c215ebd86d009a7$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $5c215ebd86d009a7$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $5c215ebd86d009a7$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $5c215ebd86d009a7$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $5c215ebd86d009a7$var$getCarry(this._hl, hl) | 0;
};
$5c215ebd86d009a7$var$Sha512.prototype._hash = function() {
    var H = $5c215ebd86d009a7$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $5c215ebd86d009a7$var$Sha512;

});



parcelRegister("bjKi2", function(module, exports) {
'use strict';

var $2tQhI = parcelRequire("2tQhI");
var $83d560401a87da0d$require$Buffer = $2tQhI.Buffer;

var $fQAHy = parcelRequire("fQAHy");
var $83d560401a87da0d$require$Transform = $fQAHy.Transform;

var $1cUnt = parcelRequire("1cUnt");
var $83d560401a87da0d$require$StringDecoder = $1cUnt.StringDecoder;

var $27YCQ = parcelRequire("27YCQ");

var $5A7ql = parcelRequire("5A7ql");
function $83d560401a87da0d$var$CipherBase(hashMode) {
    $83d560401a87da0d$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$27YCQ($83d560401a87da0d$var$CipherBase, $83d560401a87da0d$require$Transform);
$83d560401a87da0d$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = $5A7ql(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$83d560401a87da0d$var$CipherBase.prototype.setAutoPadding = function() {};
$83d560401a87da0d$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$83d560401a87da0d$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$83d560401a87da0d$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$83d560401a87da0d$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$83d560401a87da0d$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$83d560401a87da0d$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $83d560401a87da0d$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$83d560401a87da0d$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $83d560401a87da0d$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $83d560401a87da0d$var$CipherBase;

});
parcelRegister("fQAHy", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $b8982e78823c5c74$var$Stream;

var $9A2Mr = parcelRequire("9A2Mr");
var $b8982e78823c5c74$require$EE = $9A2Mr.EventEmitter;

var $27YCQ = parcelRequire("27YCQ");
$27YCQ($b8982e78823c5c74$var$Stream, $b8982e78823c5c74$require$EE);

$b8982e78823c5c74$var$Stream.Readable = (parcelRequire("bmoeA"));

$b8982e78823c5c74$var$Stream.Writable = (parcelRequire("9yHis"));

$b8982e78823c5c74$var$Stream.Duplex = (parcelRequire("9sFIQ"));

$b8982e78823c5c74$var$Stream.Transform = (parcelRequire("j4IvW"));

$b8982e78823c5c74$var$Stream.PassThrough = (parcelRequire("ipEDp"));

$b8982e78823c5c74$var$Stream.finished = (parcelRequire("3xyi3"));

$b8982e78823c5c74$var$Stream.pipeline = (parcelRequire("lJnzs"));
// Backwards-compat with node 0.4.x
$b8982e78823c5c74$var$Stream.Stream = $b8982e78823c5c74$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $b8982e78823c5c74$var$Stream() {
    $b8982e78823c5c74$require$EE.call(this);
}
$b8982e78823c5c74$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($b8982e78823c5c74$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("bmoeA", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4LBMV = parcelRequire("4LBMV");
'use strict';
module.exports = $84548c342e4c859d$var$Readable;
/*<replacement>*/ var $84548c342e4c859d$var$Duplex;
/*</replacement>*/ $84548c342e4c859d$var$Readable.ReadableState = $84548c342e4c859d$var$ReadableState;

var $9A2Mr = parcelRequire("9A2Mr");
var $84548c342e4c859d$require$EE = $9A2Mr.EventEmitter;
var $84548c342e4c859d$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $g9Ogy = parcelRequire("g9Ogy");

var $81U8s = parcelRequire("81U8s");
var $84548c342e4c859d$require$Buffer = $81U8s.Buffer;
var $84548c342e4c859d$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $84548c342e4c859d$var$_uint8ArrayToBuffer(chunk) {
    return $84548c342e4c859d$require$Buffer.from(chunk);
}
function $84548c342e4c859d$var$_isUint8Array(obj) {
    return $84548c342e4c859d$require$Buffer.isBuffer(obj) || obj instanceof $84548c342e4c859d$var$OurUint8Array;
}

var $6N7cq = parcelRequire("6N7cq");
var $84548c342e4c859d$var$debug;
if ($6N7cq && $6N7cq.debuglog) $84548c342e4c859d$var$debug = $6N7cq.debuglog('stream');
else $84548c342e4c859d$var$debug = function debug() {};

var $f1YfE = parcelRequire("f1YfE");

var $7VpM3 = parcelRequire("7VpM3");

var $clP3Q = parcelRequire("clP3Q");
var $84548c342e4c859d$var$getHighWaterMark = $clP3Q.getHighWaterMark;

var $6trHK = parcelRequire("6trHK");
var $84548c342e4c859d$require$_require$codes = $6trHK.codes;
var $84548c342e4c859d$var$ERR_INVALID_ARG_TYPE = $84548c342e4c859d$require$_require$codes.ERR_INVALID_ARG_TYPE, $84548c342e4c859d$var$ERR_STREAM_PUSH_AFTER_EOF = $84548c342e4c859d$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $84548c342e4c859d$var$ERR_METHOD_NOT_IMPLEMENTED = $84548c342e4c859d$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $84548c342e4c859d$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $84548c342e4c859d$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $84548c342e4c859d$var$StringDecoder;
var $84548c342e4c859d$var$createReadableStreamAsyncIterator;
var $84548c342e4c859d$var$from;

(parcelRequire("27YCQ"))($84548c342e4c859d$var$Readable, $g9Ogy);
var $84548c342e4c859d$var$errorOrDestroy = $7VpM3.errorOrDestroy;
var $84548c342e4c859d$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $84548c342e4c859d$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $84548c342e4c859d$var$ReadableState(options, stream, isDuplex) {
    $84548c342e4c859d$var$Duplex = $84548c342e4c859d$var$Duplex || (parcelRequire("9sFIQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $84548c342e4c859d$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $84548c342e4c859d$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $f1YfE();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$84548c342e4c859d$var$StringDecoder) $84548c342e4c859d$var$StringDecoder = (parcelRequire("1cUnt")).StringDecoder;
        this.decoder = new $84548c342e4c859d$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $84548c342e4c859d$var$Readable(options) {
    $84548c342e4c859d$var$Duplex = $84548c342e4c859d$var$Duplex || (parcelRequire("9sFIQ"));
    if (!(this instanceof $84548c342e4c859d$var$Readable)) return new $84548c342e4c859d$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $84548c342e4c859d$var$Duplex;
    this._readableState = new $84548c342e4c859d$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $g9Ogy.call(this);
}
Object.defineProperty($84548c342e4c859d$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$84548c342e4c859d$var$Readable.prototype.destroy = $7VpM3.destroy;
$84548c342e4c859d$var$Readable.prototype._undestroy = $7VpM3.undestroy;
$84548c342e4c859d$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$84548c342e4c859d$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $84548c342e4c859d$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $84548c342e4c859d$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$84548c342e4c859d$var$Readable.prototype.unshift = function(chunk) {
    return $84548c342e4c859d$var$readableAddChunk(this, chunk, null, true, false);
};
function $84548c342e4c859d$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $84548c342e4c859d$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $84548c342e4c859d$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $84548c342e4c859d$var$chunkInvalid(state, chunk);
        if (er) $84548c342e4c859d$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $84548c342e4c859d$require$Buffer.prototype) chunk = $84548c342e4c859d$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $84548c342e4c859d$var$errorOrDestroy(stream, new $84548c342e4c859d$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $84548c342e4c859d$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $84548c342e4c859d$var$errorOrDestroy(stream, new $84548c342e4c859d$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $84548c342e4c859d$var$addChunk(stream, state, chunk, false);
                    else $84548c342e4c859d$var$maybeReadMore(stream, state);
                } else $84548c342e4c859d$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $84548c342e4c859d$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $84548c342e4c859d$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $84548c342e4c859d$var$emitReadable(stream);
    }
    $84548c342e4c859d$var$maybeReadMore(stream, state);
}
function $84548c342e4c859d$var$chunkInvalid(state, chunk) {
    var er;
    if (!$84548c342e4c859d$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $84548c342e4c859d$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$84548c342e4c859d$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$84548c342e4c859d$var$Readable.prototype.setEncoding = function(enc) {
    if (!$84548c342e4c859d$var$StringDecoder) $84548c342e4c859d$var$StringDecoder = (parcelRequire("1cUnt")).StringDecoder;
    var decoder = new $84548c342e4c859d$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $84548c342e4c859d$var$MAX_HWM = 0x40000000;
function $84548c342e4c859d$var$computeNewHighWaterMark(n) {
    if (n >= $84548c342e4c859d$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $84548c342e4c859d$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $84548c342e4c859d$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $84548c342e4c859d$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$84548c342e4c859d$var$Readable.prototype.read = function(n) {
    $84548c342e4c859d$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $84548c342e4c859d$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $84548c342e4c859d$var$endReadable(this);
        else $84548c342e4c859d$var$emitReadable(this);
        return null;
    }
    n = $84548c342e4c859d$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $84548c342e4c859d$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $84548c342e4c859d$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $84548c342e4c859d$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $84548c342e4c859d$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $84548c342e4c859d$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $84548c342e4c859d$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $84548c342e4c859d$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $84548c342e4c859d$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $84548c342e4c859d$var$onEofChunk(stream, state) {
    $84548c342e4c859d$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $84548c342e4c859d$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $84548c342e4c859d$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $84548c342e4c859d$var$emitReadable(stream) {
    var state = stream._readableState;
    $84548c342e4c859d$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $84548c342e4c859d$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $4LBMV.nextTick($84548c342e4c859d$var$emitReadable_, stream);
    }
}
function $84548c342e4c859d$var$emitReadable_(stream) {
    var state = stream._readableState;
    $84548c342e4c859d$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $84548c342e4c859d$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $84548c342e4c859d$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $4LBMV.nextTick($84548c342e4c859d$var$maybeReadMore_, stream, state);
    }
}
function $84548c342e4c859d$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $84548c342e4c859d$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$84548c342e4c859d$var$Readable.prototype._read = function(n) {
    $84548c342e4c859d$var$errorOrDestroy(this, new $84548c342e4c859d$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$84548c342e4c859d$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $84548c342e4c859d$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4LBMV.stdout && dest !== $4LBMV.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $4LBMV.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $84548c342e4c859d$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $84548c342e4c859d$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $84548c342e4c859d$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $84548c342e4c859d$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $84548c342e4c859d$var$debug('ondata');
        var ret = dest.write(chunk);
        $84548c342e4c859d$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $84548c342e4c859d$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $84548c342e4c859d$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $84548c342e4c859d$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($84548c342e4c859d$var$EElistenerCount(dest, 'error') === 0) $84548c342e4c859d$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $84548c342e4c859d$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $84548c342e4c859d$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $84548c342e4c859d$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $84548c342e4c859d$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $84548c342e4c859d$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $84548c342e4c859d$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $84548c342e4c859d$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $84548c342e4c859d$var$flow(src);
        }
    };
}
$84548c342e4c859d$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $84548c342e4c859d$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$84548c342e4c859d$var$Readable.prototype.on = function(ev, fn) {
    var res = $g9Ogy.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $84548c342e4c859d$var$debug('on readable', state.length, state.reading);
            if (state.length) $84548c342e4c859d$var$emitReadable(this);
            else if (!state.reading) $4LBMV.nextTick($84548c342e4c859d$var$nReadingNextTick, this);
        }
    }
    return res;
};
$84548c342e4c859d$var$Readable.prototype.addListener = $84548c342e4c859d$var$Readable.prototype.on;
$84548c342e4c859d$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $g9Ogy.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4LBMV.nextTick($84548c342e4c859d$var$updateReadableListening, this);
    return res;
};
$84548c342e4c859d$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $g9Ogy.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4LBMV.nextTick($84548c342e4c859d$var$updateReadableListening, this);
    return res;
};
function $84548c342e4c859d$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $84548c342e4c859d$var$nReadingNextTick(self1) {
    $84548c342e4c859d$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$84548c342e4c859d$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $84548c342e4c859d$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $84548c342e4c859d$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $84548c342e4c859d$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $4LBMV.nextTick($84548c342e4c859d$var$resume_, stream, state);
    }
}
function $84548c342e4c859d$var$resume_(stream, state) {
    $84548c342e4c859d$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $84548c342e4c859d$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$84548c342e4c859d$var$Readable.prototype.pause = function() {
    $84548c342e4c859d$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $84548c342e4c859d$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $84548c342e4c859d$var$flow(stream) {
    var state = stream._readableState;
    $84548c342e4c859d$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$84548c342e4c859d$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $84548c342e4c859d$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $84548c342e4c859d$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $84548c342e4c859d$var$kProxyEvents.length; n++)stream.on($84548c342e4c859d$var$kProxyEvents[n], this.emit.bind(this, $84548c342e4c859d$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $84548c342e4c859d$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $84548c342e4c859d$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($84548c342e4c859d$var$createReadableStreamAsyncIterator === undefined) $84548c342e4c859d$var$createReadableStreamAsyncIterator = (parcelRequire("etbee"));
    return $84548c342e4c859d$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($84548c342e4c859d$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($84548c342e4c859d$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($84548c342e4c859d$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$84548c342e4c859d$var$Readable._fromList = $84548c342e4c859d$var$fromList;
Object.defineProperty($84548c342e4c859d$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $84548c342e4c859d$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $84548c342e4c859d$var$endReadable(stream) {
    var state = stream._readableState;
    $84548c342e4c859d$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $4LBMV.nextTick($84548c342e4c859d$var$endReadableNT, state, stream);
    }
}
function $84548c342e4c859d$var$endReadableNT(state, stream) {
    $84548c342e4c859d$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $84548c342e4c859d$var$Readable.from = function(iterable, opts) {
    if ($84548c342e4c859d$var$from === undefined) $84548c342e4c859d$var$from = (parcelRequire("cw9DY"));
    return $84548c342e4c859d$var$from($84548c342e4c859d$var$Readable, iterable, opts);
};
function $84548c342e4c859d$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("g9Ogy", function(module, exports) {

module.exports = (parcelRequire("9A2Mr")).EventEmitter;

});

parcelRegister("f1YfE", function(module, exports) {
'use strict';
function $af15afb606d55f63$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $af15afb606d55f63$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $af15afb606d55f63$var$ownKeys(Object(source), !0).forEach(function(key) {
            $af15afb606d55f63$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $af15afb606d55f63$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $af15afb606d55f63$var$_defineProperty(obj, key, value) {
    key = $af15afb606d55f63$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $af15afb606d55f63$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $af15afb606d55f63$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $af15afb606d55f63$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $af15afb606d55f63$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $af15afb606d55f63$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $af15afb606d55f63$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $af15afb606d55f63$var$_toPropertyKey(arg) {
    var key = $af15afb606d55f63$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $af15afb606d55f63$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $81U8s = parcelRequire("81U8s");
var $af15afb606d55f63$var$Buffer = $81U8s.Buffer;

var $6N7cq = parcelRequire("6N7cq");
var $af15afb606d55f63$var$inspect = $6N7cq.inspect;
var $af15afb606d55f63$var$custom = $af15afb606d55f63$var$inspect && $af15afb606d55f63$var$inspect.custom || 'inspect';
function $af15afb606d55f63$var$copyBuffer(src, target, offset) {
    $af15afb606d55f63$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $af15afb606d55f63$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $af15afb606d55f63$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $af15afb606d55f63$var$Buffer.alloc(0);
                var ret = $af15afb606d55f63$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $af15afb606d55f63$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $af15afb606d55f63$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $af15afb606d55f63$var$custom,
            value: function value(_, options) {
                return $af15afb606d55f63$var$inspect(this, $af15afb606d55f63$var$_objectSpread($af15afb606d55f63$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("7VpM3", function(module, exports) {

var $4LBMV = parcelRequire("4LBMV");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $5c51d975f906b667$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $4LBMV.nextTick($5c51d975f906b667$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $4LBMV.nextTick($5c51d975f906b667$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $4LBMV.nextTick($5c51d975f906b667$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $4LBMV.nextTick($5c51d975f906b667$var$emitErrorAndCloseNT, _this, err);
            } else $4LBMV.nextTick($5c51d975f906b667$var$emitCloseNT, _this);
        } else if (cb) {
            $4LBMV.nextTick($5c51d975f906b667$var$emitCloseNT, _this);
            cb(err);
        } else $4LBMV.nextTick($5c51d975f906b667$var$emitCloseNT, _this);
    });
    return this;
}
function $5c51d975f906b667$var$emitErrorAndCloseNT(self, err) {
    $5c51d975f906b667$var$emitErrorNT(self, err);
    $5c51d975f906b667$var$emitCloseNT(self);
}
function $5c51d975f906b667$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $5c51d975f906b667$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $5c51d975f906b667$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $5c51d975f906b667$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $5c51d975f906b667$var$destroy,
    undestroy: $5c51d975f906b667$var$undestroy,
    errorOrDestroy: $5c51d975f906b667$var$errorOrDestroy
};

});

parcelRegister("clP3Q", function(module, exports) {
'use strict';

var $8fdf0dd5cad11008$var$ERR_INVALID_OPT_VALUE = (parcelRequire("6trHK")).codes.ERR_INVALID_OPT_VALUE;
function $8fdf0dd5cad11008$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $8fdf0dd5cad11008$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $8fdf0dd5cad11008$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $8fdf0dd5cad11008$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $8fdf0dd5cad11008$var$getHighWaterMark
};

});
parcelRegister("6trHK", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $4b6af1144fb6f020$export$e45cb6485273080e; }, function (v) { return $4b6af1144fb6f020$export$e45cb6485273080e = v; });
var $4b6af1144fb6f020$export$e45cb6485273080e;
'use strict';
function $4b6af1144fb6f020$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $4b6af1144fb6f020$var$codes = {};
function $4b6af1144fb6f020$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $4b6af1144fb6f020$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $4b6af1144fb6f020$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $4b6af1144fb6f020$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $4b6af1144fb6f020$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $4b6af1144fb6f020$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $4b6af1144fb6f020$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$4b6af1144fb6f020$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$4b6af1144fb6f020$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $4b6af1144fb6f020$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($4b6af1144fb6f020$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($4b6af1144fb6f020$var$oneOf(expected, 'type'));
    else {
        var type = $4b6af1144fb6f020$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($4b6af1144fb6f020$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$4b6af1144fb6f020$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$4b6af1144fb6f020$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$4b6af1144fb6f020$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$4b6af1144fb6f020$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$4b6af1144fb6f020$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$4b6af1144fb6f020$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$4b6af1144fb6f020$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$4b6af1144fb6f020$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$4b6af1144fb6f020$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$4b6af1144fb6f020$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$4b6af1144fb6f020$export$e45cb6485273080e = $4b6af1144fb6f020$var$codes;

});


parcelRegister("9sFIQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $4LBMV = parcelRequire("4LBMV");
'use strict';
/*<replacement>*/ var $6e3717be47da41b2$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $6e3717be47da41b2$var$Duplex;

var $bmoeA = parcelRequire("bmoeA");

var $9yHis = parcelRequire("9yHis");

(parcelRequire("27YCQ"))($6e3717be47da41b2$var$Duplex, $bmoeA);
// Allow the keys array to be GC'ed.
var $6e3717be47da41b2$var$keys = $6e3717be47da41b2$var$objectKeys($9yHis.prototype);
for(var $6e3717be47da41b2$var$v = 0; $6e3717be47da41b2$var$v < $6e3717be47da41b2$var$keys.length; $6e3717be47da41b2$var$v++){
    var $6e3717be47da41b2$var$method = $6e3717be47da41b2$var$keys[$6e3717be47da41b2$var$v];
    if (!$6e3717be47da41b2$var$Duplex.prototype[$6e3717be47da41b2$var$method]) $6e3717be47da41b2$var$Duplex.prototype[$6e3717be47da41b2$var$method] = $9yHis.prototype[$6e3717be47da41b2$var$method];
}
function $6e3717be47da41b2$var$Duplex(options) {
    if (!(this instanceof $6e3717be47da41b2$var$Duplex)) return new $6e3717be47da41b2$var$Duplex(options);
    $bmoeA.call(this, options);
    $9yHis.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $6e3717be47da41b2$var$onend);
        }
    }
}
Object.defineProperty($6e3717be47da41b2$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($6e3717be47da41b2$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($6e3717be47da41b2$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $6e3717be47da41b2$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $4LBMV.nextTick($6e3717be47da41b2$var$onEndNT, this);
}
function $6e3717be47da41b2$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($6e3717be47da41b2$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("9yHis", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $4LBMV = parcelRequire("4LBMV");
'use strict';
module.exports = $6f58dfdaf63ac96e$var$Writable;
/* <replacement> */ function $6f58dfdaf63ac96e$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $6f58dfdaf63ac96e$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $6f58dfdaf63ac96e$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $6f58dfdaf63ac96e$var$Duplex;
/*</replacement>*/ $6f58dfdaf63ac96e$var$Writable.WritableState = $6f58dfdaf63ac96e$var$WritableState;

/*<replacement>*/ var $6f58dfdaf63ac96e$var$internalUtil = {
    deprecate: (parcelRequire("5NQdo"))
};

var $g9Ogy = parcelRequire("g9Ogy");

var $81U8s = parcelRequire("81U8s");
var $6f58dfdaf63ac96e$require$Buffer = $81U8s.Buffer;
var $6f58dfdaf63ac96e$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $6f58dfdaf63ac96e$var$_uint8ArrayToBuffer(chunk) {
    return $6f58dfdaf63ac96e$require$Buffer.from(chunk);
}
function $6f58dfdaf63ac96e$var$_isUint8Array(obj) {
    return $6f58dfdaf63ac96e$require$Buffer.isBuffer(obj) || obj instanceof $6f58dfdaf63ac96e$var$OurUint8Array;
}

var $7VpM3 = parcelRequire("7VpM3");

var $clP3Q = parcelRequire("clP3Q");
var $6f58dfdaf63ac96e$var$getHighWaterMark = $clP3Q.getHighWaterMark;

var $6trHK = parcelRequire("6trHK");
var $6f58dfdaf63ac96e$require$_require$codes = $6trHK.codes;
var $6f58dfdaf63ac96e$var$ERR_INVALID_ARG_TYPE = $6f58dfdaf63ac96e$require$_require$codes.ERR_INVALID_ARG_TYPE, $6f58dfdaf63ac96e$var$ERR_METHOD_NOT_IMPLEMENTED = $6f58dfdaf63ac96e$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $6f58dfdaf63ac96e$var$ERR_MULTIPLE_CALLBACK = $6f58dfdaf63ac96e$require$_require$codes.ERR_MULTIPLE_CALLBACK, $6f58dfdaf63ac96e$var$ERR_STREAM_CANNOT_PIPE = $6f58dfdaf63ac96e$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $6f58dfdaf63ac96e$var$ERR_STREAM_DESTROYED = $6f58dfdaf63ac96e$require$_require$codes.ERR_STREAM_DESTROYED, $6f58dfdaf63ac96e$var$ERR_STREAM_NULL_VALUES = $6f58dfdaf63ac96e$require$_require$codes.ERR_STREAM_NULL_VALUES, $6f58dfdaf63ac96e$var$ERR_STREAM_WRITE_AFTER_END = $6f58dfdaf63ac96e$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $6f58dfdaf63ac96e$var$ERR_UNKNOWN_ENCODING = $6f58dfdaf63ac96e$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $6f58dfdaf63ac96e$var$errorOrDestroy = $7VpM3.errorOrDestroy;

(parcelRequire("27YCQ"))($6f58dfdaf63ac96e$var$Writable, $g9Ogy);
function $6f58dfdaf63ac96e$var$nop() {}

function $6f58dfdaf63ac96e$var$WritableState(options, stream, isDuplex) {
    $6f58dfdaf63ac96e$var$Duplex = $6f58dfdaf63ac96e$var$Duplex || (parcelRequire("9sFIQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $6f58dfdaf63ac96e$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $6f58dfdaf63ac96e$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $6f58dfdaf63ac96e$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $6f58dfdaf63ac96e$var$CorkedRequest(this);
}
$6f58dfdaf63ac96e$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($6f58dfdaf63ac96e$var$WritableState.prototype, 'buffer', {
            get: $6f58dfdaf63ac96e$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $6f58dfdaf63ac96e$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $6f58dfdaf63ac96e$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($6f58dfdaf63ac96e$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($6f58dfdaf63ac96e$var$realHasInstance.call(this, object)) return true;
            if (this !== $6f58dfdaf63ac96e$var$Writable) return false;
            return object && object._writableState instanceof $6f58dfdaf63ac96e$var$WritableState;
        }
    });
} else $6f58dfdaf63ac96e$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $6f58dfdaf63ac96e$var$Writable(options) {
    $6f58dfdaf63ac96e$var$Duplex = $6f58dfdaf63ac96e$var$Duplex || (parcelRequire("9sFIQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $6f58dfdaf63ac96e$var$Duplex;
    if (!isDuplex && !$6f58dfdaf63ac96e$var$realHasInstance.call($6f58dfdaf63ac96e$var$Writable, this)) return new $6f58dfdaf63ac96e$var$Writable(options);
    this._writableState = new $6f58dfdaf63ac96e$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $g9Ogy.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$6f58dfdaf63ac96e$var$Writable.prototype.pipe = function() {
    $6f58dfdaf63ac96e$var$errorOrDestroy(this, new $6f58dfdaf63ac96e$var$ERR_STREAM_CANNOT_PIPE());
};
function $6f58dfdaf63ac96e$var$writeAfterEnd(stream, cb) {
    var er = new $6f58dfdaf63ac96e$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $6f58dfdaf63ac96e$var$errorOrDestroy(stream, er);
    $4LBMV.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $6f58dfdaf63ac96e$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $6f58dfdaf63ac96e$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $6f58dfdaf63ac96e$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $6f58dfdaf63ac96e$var$errorOrDestroy(stream, er);
        $4LBMV.nextTick(cb, er);
        return false;
    }
    return true;
}
$6f58dfdaf63ac96e$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $6f58dfdaf63ac96e$var$_isUint8Array(chunk);
    if (isBuf && !$6f58dfdaf63ac96e$require$Buffer.isBuffer(chunk)) chunk = $6f58dfdaf63ac96e$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $6f58dfdaf63ac96e$var$nop;
    if (state.ending) $6f58dfdaf63ac96e$var$writeAfterEnd(this, cb);
    else if (isBuf || $6f58dfdaf63ac96e$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $6f58dfdaf63ac96e$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$6f58dfdaf63ac96e$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$6f58dfdaf63ac96e$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $6f58dfdaf63ac96e$var$clearBuffer(this, state);
    }
};
$6f58dfdaf63ac96e$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $6f58dfdaf63ac96e$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($6f58dfdaf63ac96e$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $6f58dfdaf63ac96e$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $6f58dfdaf63ac96e$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($6f58dfdaf63ac96e$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $6f58dfdaf63ac96e$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $6f58dfdaf63ac96e$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $6f58dfdaf63ac96e$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $6f58dfdaf63ac96e$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $6f58dfdaf63ac96e$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $6f58dfdaf63ac96e$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $4LBMV.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $4LBMV.nextTick($6f58dfdaf63ac96e$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $6f58dfdaf63ac96e$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $6f58dfdaf63ac96e$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $6f58dfdaf63ac96e$var$finishMaybe(stream, state);
    }
}
function $6f58dfdaf63ac96e$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $6f58dfdaf63ac96e$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $6f58dfdaf63ac96e$var$ERR_MULTIPLE_CALLBACK();
    $6f58dfdaf63ac96e$var$onwriteStateUpdate(state);
    if (er) $6f58dfdaf63ac96e$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $6f58dfdaf63ac96e$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $6f58dfdaf63ac96e$var$clearBuffer(stream, state);
        if (sync) $4LBMV.nextTick($6f58dfdaf63ac96e$var$afterWrite, stream, state, finished, cb);
        else $6f58dfdaf63ac96e$var$afterWrite(stream, state, finished, cb);
    }
}
function $6f58dfdaf63ac96e$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $6f58dfdaf63ac96e$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $6f58dfdaf63ac96e$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $6f58dfdaf63ac96e$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $6f58dfdaf63ac96e$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $6f58dfdaf63ac96e$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $6f58dfdaf63ac96e$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $6f58dfdaf63ac96e$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$6f58dfdaf63ac96e$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $6f58dfdaf63ac96e$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$6f58dfdaf63ac96e$var$Writable.prototype._writev = null;
$6f58dfdaf63ac96e$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $6f58dfdaf63ac96e$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($6f58dfdaf63ac96e$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $6f58dfdaf63ac96e$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $6f58dfdaf63ac96e$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $6f58dfdaf63ac96e$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $6f58dfdaf63ac96e$var$finishMaybe(stream, state);
    });
}
function $6f58dfdaf63ac96e$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $4LBMV.nextTick($6f58dfdaf63ac96e$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $6f58dfdaf63ac96e$var$finishMaybe(stream, state) {
    var need = $6f58dfdaf63ac96e$var$needFinish(state);
    if (need) {
        $6f58dfdaf63ac96e$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $6f58dfdaf63ac96e$var$endWritable(stream, state, cb) {
    state.ending = true;
    $6f58dfdaf63ac96e$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $4LBMV.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $6f58dfdaf63ac96e$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($6f58dfdaf63ac96e$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$6f58dfdaf63ac96e$var$Writable.prototype.destroy = $7VpM3.destroy;
$6f58dfdaf63ac96e$var$Writable.prototype._undestroy = $7VpM3.undestroy;
$6f58dfdaf63ac96e$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});


parcelRegister("1cUnt", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $0e12a4dfab2629a1$export$63a7aa211a91ed69; }, function (v) { return $0e12a4dfab2629a1$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $0e12a4dfab2629a1$export$63a7aa211a91ed69;
'use strict';

var $2tQhI = parcelRequire("2tQhI");
var $0e12a4dfab2629a1$require$Buffer = $2tQhI.Buffer;
/*</replacement>*/ var $0e12a4dfab2629a1$var$isEncoding = $0e12a4dfab2629a1$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $0e12a4dfab2629a1$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $0e12a4dfab2629a1$var$normalizeEncoding(enc) {
    var nenc = $0e12a4dfab2629a1$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($0e12a4dfab2629a1$require$Buffer.isEncoding === $0e12a4dfab2629a1$var$isEncoding || !$0e12a4dfab2629a1$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$0e12a4dfab2629a1$export$63a7aa211a91ed69 = $0e12a4dfab2629a1$var$StringDecoder;
function $0e12a4dfab2629a1$var$StringDecoder(encoding) {
    this.encoding = $0e12a4dfab2629a1$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $0e12a4dfab2629a1$var$utf16Text;
            this.end = $0e12a4dfab2629a1$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $0e12a4dfab2629a1$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $0e12a4dfab2629a1$var$base64Text;
            this.end = $0e12a4dfab2629a1$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $0e12a4dfab2629a1$var$simpleWrite;
            this.end = $0e12a4dfab2629a1$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $0e12a4dfab2629a1$require$Buffer.allocUnsafe(nb);
}
$0e12a4dfab2629a1$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$0e12a4dfab2629a1$var$StringDecoder.prototype.end = $0e12a4dfab2629a1$var$utf8End;
// Returns only complete characters in a Buffer
$0e12a4dfab2629a1$var$StringDecoder.prototype.text = $0e12a4dfab2629a1$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$0e12a4dfab2629a1$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $0e12a4dfab2629a1$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $0e12a4dfab2629a1$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $0e12a4dfab2629a1$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $0e12a4dfab2629a1$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $0e12a4dfab2629a1$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $0e12a4dfab2629a1$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $0e12a4dfab2629a1$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $0e12a4dfab2629a1$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $0e12a4dfab2629a1$var$utf8Text(buf, i) {
    var total = $0e12a4dfab2629a1$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $0e12a4dfab2629a1$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $0e12a4dfab2629a1$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $0e12a4dfab2629a1$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $0e12a4dfab2629a1$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $0e12a4dfab2629a1$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $0e12a4dfab2629a1$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $0e12a4dfab2629a1$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("etbee", function(module, exports) {

var $4LBMV = parcelRequire("4LBMV");
'use strict';
var $a88c7bdcc30ff8dc$var$_Object$setPrototypeO;
function $a88c7bdcc30ff8dc$var$_defineProperty(obj, key, value) {
    key = $a88c7bdcc30ff8dc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a88c7bdcc30ff8dc$var$_toPropertyKey(arg) {
    var key = $a88c7bdcc30ff8dc$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $a88c7bdcc30ff8dc$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $3xyi3 = parcelRequire("3xyi3");
var $a88c7bdcc30ff8dc$var$kLastResolve = Symbol('lastResolve');
var $a88c7bdcc30ff8dc$var$kLastReject = Symbol('lastReject');
var $a88c7bdcc30ff8dc$var$kError = Symbol('error');
var $a88c7bdcc30ff8dc$var$kEnded = Symbol('ended');
var $a88c7bdcc30ff8dc$var$kLastPromise = Symbol('lastPromise');
var $a88c7bdcc30ff8dc$var$kHandlePromise = Symbol('handlePromise');
var $a88c7bdcc30ff8dc$var$kStream = Symbol('stream');
function $a88c7bdcc30ff8dc$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $a88c7bdcc30ff8dc$var$readAndResolve(iter) {
    var resolve = iter[$a88c7bdcc30ff8dc$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$a88c7bdcc30ff8dc$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$a88c7bdcc30ff8dc$var$kLastPromise] = null;
            iter[$a88c7bdcc30ff8dc$var$kLastResolve] = null;
            iter[$a88c7bdcc30ff8dc$var$kLastReject] = null;
            resolve($a88c7bdcc30ff8dc$var$createIterResult(data, false));
        }
    }
}
function $a88c7bdcc30ff8dc$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $4LBMV.nextTick($a88c7bdcc30ff8dc$var$readAndResolve, iter);
}
function $a88c7bdcc30ff8dc$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$a88c7bdcc30ff8dc$var$kEnded]) {
                resolve($a88c7bdcc30ff8dc$var$createIterResult(undefined, true));
                return;
            }
            iter[$a88c7bdcc30ff8dc$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $a88c7bdcc30ff8dc$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $a88c7bdcc30ff8dc$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($a88c7bdcc30ff8dc$var$_Object$setPrototypeO = {
    get stream () {
        return this[$a88c7bdcc30ff8dc$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$a88c7bdcc30ff8dc$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$a88c7bdcc30ff8dc$var$kEnded]) return Promise.resolve($a88c7bdcc30ff8dc$var$createIterResult(undefined, true));
        if (this[$a88c7bdcc30ff8dc$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $4LBMV.nextTick(function() {
                if (_this[$a88c7bdcc30ff8dc$var$kError]) reject(_this[$a88c7bdcc30ff8dc$var$kError]);
                else resolve($a88c7bdcc30ff8dc$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$a88c7bdcc30ff8dc$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($a88c7bdcc30ff8dc$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$a88c7bdcc30ff8dc$var$kStream].read();
            if (data !== null) return Promise.resolve($a88c7bdcc30ff8dc$var$createIterResult(data, false));
            promise = new Promise(this[$a88c7bdcc30ff8dc$var$kHandlePromise]);
        }
        this[$a88c7bdcc30ff8dc$var$kLastPromise] = promise;
        return promise;
    }
}, $a88c7bdcc30ff8dc$var$_defineProperty($a88c7bdcc30ff8dc$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $a88c7bdcc30ff8dc$var$_defineProperty($a88c7bdcc30ff8dc$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$a88c7bdcc30ff8dc$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($a88c7bdcc30ff8dc$var$createIterResult(undefined, true));
        });
    });
}), $a88c7bdcc30ff8dc$var$_Object$setPrototypeO), $a88c7bdcc30ff8dc$var$AsyncIteratorPrototype);
var $a88c7bdcc30ff8dc$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($a88c7bdcc30ff8dc$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $a88c7bdcc30ff8dc$var$_defineProperty(_Object$create, $a88c7bdcc30ff8dc$var$kStream, {
        value: stream,
        writable: true
    }), $a88c7bdcc30ff8dc$var$_defineProperty(_Object$create, $a88c7bdcc30ff8dc$var$kLastResolve, {
        value: null,
        writable: true
    }), $a88c7bdcc30ff8dc$var$_defineProperty(_Object$create, $a88c7bdcc30ff8dc$var$kLastReject, {
        value: null,
        writable: true
    }), $a88c7bdcc30ff8dc$var$_defineProperty(_Object$create, $a88c7bdcc30ff8dc$var$kError, {
        value: null,
        writable: true
    }), $a88c7bdcc30ff8dc$var$_defineProperty(_Object$create, $a88c7bdcc30ff8dc$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $a88c7bdcc30ff8dc$var$_defineProperty(_Object$create, $a88c7bdcc30ff8dc$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$a88c7bdcc30ff8dc$var$kStream].read();
            if (data) {
                iterator[$a88c7bdcc30ff8dc$var$kLastPromise] = null;
                iterator[$a88c7bdcc30ff8dc$var$kLastResolve] = null;
                iterator[$a88c7bdcc30ff8dc$var$kLastReject] = null;
                resolve($a88c7bdcc30ff8dc$var$createIterResult(data, false));
            } else {
                iterator[$a88c7bdcc30ff8dc$var$kLastResolve] = resolve;
                iterator[$a88c7bdcc30ff8dc$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$a88c7bdcc30ff8dc$var$kLastPromise] = null;
    $3xyi3(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$a88c7bdcc30ff8dc$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$a88c7bdcc30ff8dc$var$kLastPromise] = null;
                iterator[$a88c7bdcc30ff8dc$var$kLastResolve] = null;
                iterator[$a88c7bdcc30ff8dc$var$kLastReject] = null;
                reject(err);
            }
            iterator[$a88c7bdcc30ff8dc$var$kError] = err;
            return;
        }
        var resolve = iterator[$a88c7bdcc30ff8dc$var$kLastResolve];
        if (resolve !== null) {
            iterator[$a88c7bdcc30ff8dc$var$kLastPromise] = null;
            iterator[$a88c7bdcc30ff8dc$var$kLastResolve] = null;
            iterator[$a88c7bdcc30ff8dc$var$kLastReject] = null;
            resolve($a88c7bdcc30ff8dc$var$createIterResult(undefined, true));
        }
        iterator[$a88c7bdcc30ff8dc$var$kEnded] = true;
    });
    stream.on('readable', $a88c7bdcc30ff8dc$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $a88c7bdcc30ff8dc$var$createReadableStreamAsyncIterator;

});
parcelRegister("3xyi3", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $293f0d7eac960c26$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("6trHK")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $293f0d7eac960c26$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $293f0d7eac960c26$var$noop() {}
function $293f0d7eac960c26$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $293f0d7eac960c26$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $293f0d7eac960c26$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $293f0d7eac960c26$var$once(callback || $293f0d7eac960c26$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $293f0d7eac960c26$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $293f0d7eac960c26$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($293f0d7eac960c26$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $293f0d7eac960c26$var$eos;

});


parcelRegister("cw9DY", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("j4IvW", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $de30eba79d3c7b15$var$Transform;

var $6trHK = parcelRequire("6trHK");
var $de30eba79d3c7b15$require$_require$codes = $6trHK.codes;
var $de30eba79d3c7b15$var$ERR_METHOD_NOT_IMPLEMENTED = $de30eba79d3c7b15$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $de30eba79d3c7b15$var$ERR_MULTIPLE_CALLBACK = $de30eba79d3c7b15$require$_require$codes.ERR_MULTIPLE_CALLBACK, $de30eba79d3c7b15$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $de30eba79d3c7b15$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $de30eba79d3c7b15$var$ERR_TRANSFORM_WITH_LENGTH_0 = $de30eba79d3c7b15$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $9sFIQ = parcelRequire("9sFIQ");

(parcelRequire("27YCQ"))($de30eba79d3c7b15$var$Transform, $9sFIQ);
function $de30eba79d3c7b15$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $de30eba79d3c7b15$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $de30eba79d3c7b15$var$Transform(options) {
    if (!(this instanceof $de30eba79d3c7b15$var$Transform)) return new $de30eba79d3c7b15$var$Transform(options);
    $9sFIQ.call(this, options);
    this._transformState = {
        afterTransform: $de30eba79d3c7b15$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $de30eba79d3c7b15$var$prefinish);
}
function $de30eba79d3c7b15$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $de30eba79d3c7b15$var$done(_this, er, data);
    });
    else $de30eba79d3c7b15$var$done(this, null, null);
}
$de30eba79d3c7b15$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $9sFIQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$de30eba79d3c7b15$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $de30eba79d3c7b15$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$de30eba79d3c7b15$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$de30eba79d3c7b15$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$de30eba79d3c7b15$var$Transform.prototype._destroy = function(err, cb) {
    $9sFIQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $de30eba79d3c7b15$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $de30eba79d3c7b15$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $de30eba79d3c7b15$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("ipEDp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $d67a1502a5522f14$var$PassThrough;

var $j4IvW = parcelRequire("j4IvW");

(parcelRequire("27YCQ"))($d67a1502a5522f14$var$PassThrough, $j4IvW);
function $d67a1502a5522f14$var$PassThrough(options) {
    if (!(this instanceof $d67a1502a5522f14$var$PassThrough)) return new $d67a1502a5522f14$var$PassThrough(options);
    $j4IvW.call(this, options);
}
$d67a1502a5522f14$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("lJnzs", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $fd20159ed78295c5$var$eos;
function $fd20159ed78295c5$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $6trHK = parcelRequire("6trHK");
var $fd20159ed78295c5$require$_require$codes = $6trHK.codes;
var $fd20159ed78295c5$var$ERR_MISSING_ARGS = $fd20159ed78295c5$require$_require$codes.ERR_MISSING_ARGS, $fd20159ed78295c5$var$ERR_STREAM_DESTROYED = $fd20159ed78295c5$require$_require$codes.ERR_STREAM_DESTROYED;
function $fd20159ed78295c5$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $fd20159ed78295c5$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $fd20159ed78295c5$var$destroyer(stream, reading, writing, callback) {
    callback = $fd20159ed78295c5$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($fd20159ed78295c5$var$eos === undefined) $fd20159ed78295c5$var$eos = (parcelRequire("3xyi3"));
    $fd20159ed78295c5$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($fd20159ed78295c5$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $fd20159ed78295c5$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $fd20159ed78295c5$var$call(fn) {
    fn();
}
function $fd20159ed78295c5$var$pipe(from, to) {
    return from.pipe(to);
}
function $fd20159ed78295c5$var$popCallback(streams) {
    if (!streams.length) return $fd20159ed78295c5$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $fd20159ed78295c5$var$noop;
    return streams.pop();
}
function $fd20159ed78295c5$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $fd20159ed78295c5$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $fd20159ed78295c5$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $fd20159ed78295c5$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($fd20159ed78295c5$var$call);
            if (reading) return;
            destroys.forEach($fd20159ed78295c5$var$call);
            callback(error);
        });
    });
    return streams.reduce($fd20159ed78295c5$var$pipe);
}
module.exports = $fd20159ed78295c5$var$pipeline;

});




parcelRegister("kYdR4", function(module, exports) {
'use strict';

var $27YCQ = parcelRequire("27YCQ");

var $6pV6X = parcelRequire("6pV6X");

var $bjKi2 = parcelRequire("bjKi2");

var $2tQhI = parcelRequire("2tQhI");
var $f444288c9d6d1cf2$require$Buffer = $2tQhI.Buffer;

var $8QbLz = parcelRequire("8QbLz");

var $9hqA7 = parcelRequire("9hqA7");

var $eaAYH = parcelRequire("eaAYH");
var $f444288c9d6d1cf2$var$ZEROS = $f444288c9d6d1cf2$require$Buffer.alloc(128);
function $f444288c9d6d1cf2$var$Hmac(alg, key) {
    $bjKi2.call(this, 'digest');
    if (typeof key === 'string') key = $f444288c9d6d1cf2$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $9hqA7() : $eaAYH(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $f444288c9d6d1cf2$require$Buffer.concat([
        key,
        $f444288c9d6d1cf2$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $f444288c9d6d1cf2$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $f444288c9d6d1cf2$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $9hqA7() : $eaAYH(alg);
    this._hash.update(ipad);
}
$27YCQ($f444288c9d6d1cf2$var$Hmac, $bjKi2);
$f444288c9d6d1cf2$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$f444288c9d6d1cf2$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $9hqA7() : $eaAYH(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $f444288c9d6d1cf2$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $6pV6X($8QbLz, key);
    return new $f444288c9d6d1cf2$var$Hmac(alg, key);
};

});
parcelRegister("6pV6X", function(module, exports) {
'use strict';

var $27YCQ = parcelRequire("27YCQ");

var $2tQhI = parcelRequire("2tQhI");
var $4ac160fc41663eb6$require$Buffer = $2tQhI.Buffer;

var $bjKi2 = parcelRequire("bjKi2");
var $4ac160fc41663eb6$var$ZEROS = $4ac160fc41663eb6$require$Buffer.alloc(128);
var $4ac160fc41663eb6$var$blocksize = 64;
function $4ac160fc41663eb6$var$Hmac(alg, key) {
    $bjKi2.call(this, 'digest');
    if (typeof key === 'string') key = $4ac160fc41663eb6$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $4ac160fc41663eb6$var$blocksize) key = alg(key);
    else if (key.length < $4ac160fc41663eb6$var$blocksize) key = $4ac160fc41663eb6$require$Buffer.concat([
        key,
        $4ac160fc41663eb6$var$ZEROS
    ], $4ac160fc41663eb6$var$blocksize);
    var ipad = this._ipad = $4ac160fc41663eb6$require$Buffer.allocUnsafe($4ac160fc41663eb6$var$blocksize);
    var opad = this._opad = $4ac160fc41663eb6$require$Buffer.allocUnsafe($4ac160fc41663eb6$var$blocksize);
    for(var i = 0; i < $4ac160fc41663eb6$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$27YCQ($4ac160fc41663eb6$var$Hmac, $bjKi2);
$4ac160fc41663eb6$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$4ac160fc41663eb6$var$Hmac.prototype._final = function() {
    var h = this._alg($4ac160fc41663eb6$require$Buffer.concat(this._hash));
    return this._alg($4ac160fc41663eb6$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $4ac160fc41663eb6$var$Hmac;

});

parcelRegister("8QbLz", function(module, exports) {

var $jQriO = parcelRequire("jQriO");
module.exports = function(buffer) {
    return new $jQriO().update(buffer).digest();
};

});


parcelRegister("e7jUh", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ltWeA"));

});
parcelRegister("ltWeA", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});


parcelRegister("kUWqc", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $f3a65aebdf613efa$export$448fa22aedc9dbca; }, function (v) { return $f3a65aebdf613efa$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $f3a65aebdf613efa$export$b80c7ba289c8fa56; }, function (v) { return $f3a65aebdf613efa$export$b80c7ba289c8fa56 = v; });
var $f3a65aebdf613efa$export$448fa22aedc9dbca;
var $f3a65aebdf613efa$export$b80c7ba289c8fa56;
'use strict';

$f3a65aebdf613efa$export$448fa22aedc9dbca = (parcelRequire("e6Fee"));

$f3a65aebdf613efa$export$b80c7ba289c8fa56 = (parcelRequire("g5i97"));

});
parcelRegister("e6Fee", function(module, exports) {
'use strict';

var $2tQhI = parcelRequire("2tQhI");
var $02a67a3f52ddb457$require$Buffer = $2tQhI.Buffer;

var $6T4yH = parcelRequire("6T4yH");

var $7Fz1n = parcelRequire("7Fz1n");

var $g5i97 = parcelRequire("g5i97");

var $d0idl = parcelRequire("d0idl");
var $02a67a3f52ddb457$var$ZERO_BUF;
var $02a67a3f52ddb457$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $02a67a3f52ddb457$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $02a67a3f52ddb457$var$checks = [];
var $02a67a3f52ddb457$var$nextTick;
function $02a67a3f52ddb457$var$getNextTick() {
    if ($02a67a3f52ddb457$var$nextTick) return $02a67a3f52ddb457$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $02a67a3f52ddb457$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $02a67a3f52ddb457$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $02a67a3f52ddb457$var$nextTick = $parcel$global.setImmediate;
    else $02a67a3f52ddb457$var$nextTick = $parcel$global.setTimeout;
    return $02a67a3f52ddb457$var$nextTick;
}
function $02a67a3f52ddb457$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $02a67a3f52ddb457$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $02a67a3f52ddb457$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $02a67a3f52ddb457$require$Buffer.from(res);
    });
}
function $02a67a3f52ddb457$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$02a67a3f52ddb457$var$subtle || !$02a67a3f52ddb457$var$subtle.importKey || !$02a67a3f52ddb457$var$subtle.deriveBits) return Promise.resolve(false);
    if ($02a67a3f52ddb457$var$checks[algo] !== undefined) return $02a67a3f52ddb457$var$checks[algo];
    $02a67a3f52ddb457$var$ZERO_BUF = $02a67a3f52ddb457$var$ZERO_BUF || $02a67a3f52ddb457$require$Buffer.alloc(8);
    var prom = $02a67a3f52ddb457$var$browserPbkdf2($02a67a3f52ddb457$var$ZERO_BUF, $02a67a3f52ddb457$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }, function() {
        return false;
    });
    $02a67a3f52ddb457$var$checks[algo] = prom;
    return prom;
}
function $02a67a3f52ddb457$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $02a67a3f52ddb457$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $02a67a3f52ddb457$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    keylen = $6T4yH(iterations, keylen);
    password = $d0idl(password, $7Fz1n, 'Password');
    salt = $d0idl(salt, $7Fz1n, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    digest = digest || 'sha1';
    var algo = $02a67a3f52ddb457$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $02a67a3f52ddb457$var$getNextTick()(function() {
            var out;
            try {
                out = $g5i97(password, salt, iterations, keylen, digest);
            } catch (e) {
                callback(e);
                return;
            }
            callback(null, out);
        });
        return;
    }
    $02a67a3f52ddb457$var$resolvePromise($02a67a3f52ddb457$var$checkNative(algo).then(function(resp) {
        if (resp) return $02a67a3f52ddb457$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $g5i97(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("6T4yH", function(module, exports) {
'use strict';
var $503b6a645e7fddaf$var$$isFinite = isFinite;
var $503b6a645e7fddaf$var$MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0 || !$503b6a645e7fddaf$var$$isFinite(iterations)) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $503b6a645e7fddaf$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
    // `-0` passes the `keylen < 0` guard above (since `-0 < 0` is `false`), but
    // the native binding requires a true Int32; `-0` is held as a double and
    // aborts the process (SIGABRT) on Node.js 15+. Coerce it to `+0`.
    return keylen + 0;
};

});

parcelRegister("7Fz1n", function(module, exports) {

var $4LBMV = parcelRequire("4LBMV");
'use strict';
var $5957873a1d0c1953$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $5957873a1d0c1953$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $5957873a1d0c1953$var$pVersionMajor = parseInt($4LBMV.version.split('.')[0].slice(1), 10);
    $5957873a1d0c1953$var$defaultEncoding = $5957873a1d0c1953$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $5957873a1d0c1953$var$defaultEncoding = 'utf-8';
module.exports = $5957873a1d0c1953$var$defaultEncoding;

});

parcelRegister("g5i97", function(module, exports) {
'use strict';

var $8QbLz = parcelRequire("8QbLz");

var $9hqA7 = parcelRequire("9hqA7");

var $eaAYH = parcelRequire("eaAYH");

var $2tQhI = parcelRequire("2tQhI");
var $bb5b3064c2f59a7d$require$Buffer = $2tQhI.Buffer;

var $6T4yH = parcelRequire("6T4yH");

var $7Fz1n = parcelRequire("7Fz1n");

var $d0idl = parcelRequire("d0idl");
var $bb5b3064c2f59a7d$var$ZEROS = $bb5b3064c2f59a7d$require$Buffer.alloc(128);
var $bb5b3064c2f59a7d$var$sizes = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    'sha512-256': 32,
    ripemd160: 20,
    rmd160: 20
};
var $bb5b3064c2f59a7d$var$mapping = {
    __proto__: null,
    'sha-1': 'sha1',
    'sha-224': 'sha224',
    'sha-256': 'sha256',
    'sha-384': 'sha384',
    'sha-512': 'sha512',
    'ripemd-160': 'ripemd160'
};
function $bb5b3064c2f59a7d$var$rmd160Func(data) {
    return new $9hqA7().update(data).digest();
}
function $bb5b3064c2f59a7d$var$getDigest(alg) {
    function shaFunc(data) {
        return $eaAYH(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return $bb5b3064c2f59a7d$var$rmd160Func;
    if (alg === 'md5') return $8QbLz;
    return shaFunc;
}
function $bb5b3064c2f59a7d$var$Hmac(alg, key, saltLen) {
    var hash = $bb5b3064c2f59a7d$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $bb5b3064c2f59a7d$require$Buffer.concat([
        key,
        $bb5b3064c2f59a7d$var$ZEROS
    ], blocksize);
    var ipad = $bb5b3064c2f59a7d$require$Buffer.allocUnsafe(blocksize + $bb5b3064c2f59a7d$var$sizes[alg]);
    var opad = $bb5b3064c2f59a7d$require$Buffer.allocUnsafe(blocksize + $bb5b3064c2f59a7d$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $bb5b3064c2f59a7d$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $bb5b3064c2f59a7d$var$sizes[alg];
}
$bb5b3064c2f59a7d$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $bb5b3064c2f59a7d$var$pbkdf2(password, salt, iterations, keylen, digest) {
    keylen = $6T4yH(iterations, keylen);
    password = $d0idl(password, $7Fz1n, 'Password');
    salt = $d0idl(salt, $7Fz1n, 'Salt');
    var lowerDigest = (digest || 'sha1').toLowerCase();
    var mappedDigest = $bb5b3064c2f59a7d$var$mapping[lowerDigest] || lowerDigest;
    var size = $bb5b3064c2f59a7d$var$sizes[mappedDigest];
    if (typeof size !== 'number' || !size) throw new TypeError('Digest algorithm not supported: ' + digest);
    var hmac = new $bb5b3064c2f59a7d$var$Hmac(mappedDigest, password, salt.length);
    var DK = $bb5b3064c2f59a7d$require$Buffer.allocUnsafe(keylen);
    var block1 = $bb5b3064c2f59a7d$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = size;
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $bb5b3064c2f59a7d$var$pbkdf2;

});
parcelRegister("d0idl", function(module, exports) {
'use strict';

var $2tQhI = parcelRequire("2tQhI");
var $977967674d82c2f7$require$Buffer = $2tQhI.Buffer;

var $5A7ql = parcelRequire("5A7ql");
var $977967674d82c2f7$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $977967674d82c2f7$var$useArrayBuffer = $977967674d82c2f7$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $977967674d82c2f7$var$isView = $977967674d82c2f7$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding, name) {
    if (typeof thing === 'string' || $977967674d82c2f7$require$Buffer.isBuffer(thing) || $977967674d82c2f7$var$useUint8Array && thing instanceof Uint8Array || $977967674d82c2f7$var$isView && $977967674d82c2f7$var$isView(thing)) return $5A7ql(thing, encoding);
    throw new TypeError(name + ' must be a string, a Buffer, a Uint8Array, or a DataView');
};

});




parcelRegister("aRc70", function(module, exports) {

$parcel$export(module.exports, "createCipher", function () { return $7e783fd509196f67$export$bdd223f16383713e; }, function (v) { return $7e783fd509196f67$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipher", function () { return $7e783fd509196f67$export$26e5786e8ac8e530; }, function (v) { return $7e783fd509196f67$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $7e783fd509196f67$export$2f64596b8cbf08b4; }, function (v) { return $7e783fd509196f67$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $7e783fd509196f67$export$20533d26f07f1ee0; }, function (v) { return $7e783fd509196f67$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createDecipher", function () { return $7e783fd509196f67$export$12ada9414fbc594c; }, function (v) { return $7e783fd509196f67$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipher", function () { return $7e783fd509196f67$export$2ce6d8d0e8b04e1a; }, function (v) { return $7e783fd509196f67$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $7e783fd509196f67$export$36b6d6ef312eab39; }, function (v) { return $7e783fd509196f67$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $7e783fd509196f67$export$f5e7e39d57cd9700; }, function (v) { return $7e783fd509196f67$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $7e783fd509196f67$export$dedd8dc3dc62b370; }, function (v) { return $7e783fd509196f67$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $7e783fd509196f67$export$58a258485f1e49f6; }, function (v) { return $7e783fd509196f67$export$58a258485f1e49f6 = v; });
var $7e783fd509196f67$export$bdd223f16383713e;
var $7e783fd509196f67$export$26e5786e8ac8e530;
var $7e783fd509196f67$export$2f64596b8cbf08b4;
var $7e783fd509196f67$export$20533d26f07f1ee0;
var $7e783fd509196f67$export$12ada9414fbc594c;
var $7e783fd509196f67$export$2ce6d8d0e8b04e1a;
var $7e783fd509196f67$export$36b6d6ef312eab39;
var $7e783fd509196f67$export$f5e7e39d57cd9700;
var $7e783fd509196f67$export$dedd8dc3dc62b370;
var $7e783fd509196f67$export$58a258485f1e49f6;

var $9QqZp = parcelRequire("9QqZp");

var $eGE1b = parcelRequire("eGE1b");

var $ivHbd = parcelRequire("ivHbd");

var $9xOSi = parcelRequire("9xOSi");

var $fZX14 = parcelRequire("fZX14");
function $7e783fd509196f67$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($ivHbd[suite]) {
        keyLen = $ivHbd[suite].key;
        ivLen = $ivHbd[suite].iv;
    } else if ($9xOSi[suite]) {
        keyLen = $9xOSi[suite].key * 8;
        ivLen = $9xOSi[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $fZX14(password, false, keyLen, ivLen);
    return $7e783fd509196f67$var$createCipheriv(suite, keys.key, keys.iv);
}
function $7e783fd509196f67$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($ivHbd[suite]) {
        keyLen = $ivHbd[suite].key;
        ivLen = $ivHbd[suite].iv;
    } else if ($9xOSi[suite]) {
        keyLen = $9xOSi[suite].key * 8;
        ivLen = $9xOSi[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $fZX14(password, false, keyLen, ivLen);
    return $7e783fd509196f67$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $7e783fd509196f67$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($ivHbd[suite]) return $eGE1b.createCipheriv(suite, key, iv);
    if ($9xOSi[suite]) return new $9QqZp({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $7e783fd509196f67$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($ivHbd[suite]) return $eGE1b.createDecipheriv(suite, key, iv);
    if ($9xOSi[suite]) return new $9QqZp({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $7e783fd509196f67$var$getCiphers() {
    return Object.keys($9xOSi).concat($eGE1b.getCiphers());
}
$7e783fd509196f67$export$bdd223f16383713e = $7e783fd509196f67$export$26e5786e8ac8e530 = $7e783fd509196f67$var$createCipher;
$7e783fd509196f67$export$2f64596b8cbf08b4 = $7e783fd509196f67$export$20533d26f07f1ee0 = $7e783fd509196f67$var$createCipheriv;
$7e783fd509196f67$export$12ada9414fbc594c = $7e783fd509196f67$export$2ce6d8d0e8b04e1a = $7e783fd509196f67$var$createDecipher;
$7e783fd509196f67$export$36b6d6ef312eab39 = $7e783fd509196f67$export$f5e7e39d57cd9700 = $7e783fd509196f67$var$createDecipheriv;
$7e783fd509196f67$export$dedd8dc3dc62b370 = $7e783fd509196f67$export$58a258485f1e49f6 = $7e783fd509196f67$var$getCiphers;

});
parcelRegister("9QqZp", function(module, exports) {

var $bjKi2 = parcelRequire("bjKi2");

var $dKmxX = parcelRequire("dKmxX");

var $27YCQ = parcelRequire("27YCQ");

var $2tQhI = parcelRequire("2tQhI");
var $72ade7ededd650d4$require$Buffer = $2tQhI.Buffer;
var $72ade7ededd650d4$var$modes = {
    'des-ede3-cbc': $dKmxX.CBC.instantiate($dKmxX.EDE),
    'des-ede3': $dKmxX.EDE,
    'des-ede-cbc': $dKmxX.CBC.instantiate($dKmxX.EDE),
    'des-ede': $dKmxX.EDE,
    'des-cbc': $dKmxX.CBC.instantiate($dKmxX.DES),
    'des-ecb': $dKmxX.DES
};
$72ade7ededd650d4$var$modes.des = $72ade7ededd650d4$var$modes['des-cbc'];
$72ade7ededd650d4$var$modes.des3 = $72ade7ededd650d4$var$modes['des-ede3-cbc'];
module.exports = $72ade7ededd650d4$var$DES;
$27YCQ($72ade7ededd650d4$var$DES, $bjKi2);
function $72ade7ededd650d4$var$DES(opts) {
    $bjKi2.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $72ade7ededd650d4$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!$72ade7ededd650d4$require$Buffer.isBuffer(key)) key = $72ade7ededd650d4$require$Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $72ade7ededd650d4$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$72ade7ededd650d4$require$Buffer.isBuffer(iv)) iv = $72ade7ededd650d4$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$72ade7ededd650d4$var$DES.prototype._update = function(data) {
    return $72ade7ededd650d4$require$Buffer.from(this._des.update(data));
};
$72ade7ededd650d4$var$DES.prototype._final = function() {
    return $72ade7ededd650d4$require$Buffer.from(this._des.final());
};

});
parcelRegister("dKmxX", function(module, exports) {

$parcel$export(module.exports, "DES", function () { return $a0210f8a823dae3c$export$cc8859615686b300; }, function (v) { return $a0210f8a823dae3c$export$cc8859615686b300 = v; });
$parcel$export(module.exports, "CBC", function () { return $a0210f8a823dae3c$export$8ad3f227af08fcc5; }, function (v) { return $a0210f8a823dae3c$export$8ad3f227af08fcc5 = v; });
$parcel$export(module.exports, "EDE", function () { return $a0210f8a823dae3c$export$947646e34766044f; }, function (v) { return $a0210f8a823dae3c$export$947646e34766044f = v; });
var $a0210f8a823dae3c$export$eab97d15b1788b8d;
var $a0210f8a823dae3c$export$26e5786e8ac8e530;
var $a0210f8a823dae3c$export$cc8859615686b300;
var $a0210f8a823dae3c$export$8ad3f227af08fcc5;
var $a0210f8a823dae3c$export$947646e34766044f;
'use strict';

$a0210f8a823dae3c$export$eab97d15b1788b8d = (parcelRequire("bNFRc"));

$a0210f8a823dae3c$export$26e5786e8ac8e530 = (parcelRequire("eEBP2"));

$a0210f8a823dae3c$export$cc8859615686b300 = (parcelRequire("2NKs5"));

$a0210f8a823dae3c$export$8ad3f227af08fcc5 = (parcelRequire("8GfqC"));

$a0210f8a823dae3c$export$947646e34766044f = (parcelRequire("aDbaA"));

});
parcelRegister("bNFRc", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", function () { return $8974bd426dee645c$export$cfaef8ed399428b0; }, function (v) { return $8974bd426dee645c$export$cfaef8ed399428b0 = v; });
$parcel$export(module.exports, "writeUInt32BE", function () { return $8974bd426dee645c$export$a80c7deaea7cbd80; }, function (v) { return $8974bd426dee645c$export$a80c7deaea7cbd80 = v; });
$parcel$export(module.exports, "ip", function () { return $8974bd426dee645c$export$ed7577ae6e1cd0ef; }, function (v) { return $8974bd426dee645c$export$ed7577ae6e1cd0ef = v; });
$parcel$export(module.exports, "rip", function () { return $8974bd426dee645c$export$5dcbef3aa594f567; }, function (v) { return $8974bd426dee645c$export$5dcbef3aa594f567 = v; });
$parcel$export(module.exports, "pc1", function () { return $8974bd426dee645c$export$5bc8001ca71ed9c5; }, function (v) { return $8974bd426dee645c$export$5bc8001ca71ed9c5 = v; });
$parcel$export(module.exports, "r28shl", function () { return $8974bd426dee645c$export$3e714e2c5d5d8cb2; }, function (v) { return $8974bd426dee645c$export$3e714e2c5d5d8cb2 = v; });
$parcel$export(module.exports, "pc2", function () { return $8974bd426dee645c$export$94c3e544fd062b7f; }, function (v) { return $8974bd426dee645c$export$94c3e544fd062b7f = v; });
$parcel$export(module.exports, "expand", function () { return $8974bd426dee645c$export$9f77e0932fb78f72; }, function (v) { return $8974bd426dee645c$export$9f77e0932fb78f72 = v; });
$parcel$export(module.exports, "substitute", function () { return $8974bd426dee645c$export$d865ce2836f5927f; }, function (v) { return $8974bd426dee645c$export$d865ce2836f5927f = v; });
$parcel$export(module.exports, "permute", function () { return $8974bd426dee645c$export$95e62ad65da8b7d2; }, function (v) { return $8974bd426dee645c$export$95e62ad65da8b7d2 = v; });
$parcel$export(module.exports, "padSplit", function () { return $8974bd426dee645c$export$209139ff098c441a; }, function (v) { return $8974bd426dee645c$export$209139ff098c441a = v; });
var $8974bd426dee645c$export$cfaef8ed399428b0;
var $8974bd426dee645c$export$a80c7deaea7cbd80;
var $8974bd426dee645c$export$ed7577ae6e1cd0ef;
var $8974bd426dee645c$export$5dcbef3aa594f567;
var $8974bd426dee645c$export$5bc8001ca71ed9c5;
var $8974bd426dee645c$export$3e714e2c5d5d8cb2;
var $8974bd426dee645c$export$94c3e544fd062b7f;
var $8974bd426dee645c$export$9f77e0932fb78f72;
var $8974bd426dee645c$export$d865ce2836f5927f;
var $8974bd426dee645c$export$95e62ad65da8b7d2;
var $8974bd426dee645c$export$209139ff098c441a;
'use strict';
$8974bd426dee645c$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$8974bd426dee645c$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$8974bd426dee645c$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$8974bd426dee645c$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$8974bd426dee645c$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$8974bd426dee645c$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $8974bd426dee645c$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$8974bd426dee645c$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $8974bd426dee645c$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $8974bd426dee645c$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $8974bd426dee645c$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $8974bd426dee645c$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$8974bd426dee645c$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $8974bd426dee645c$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$8974bd426dee645c$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $8974bd426dee645c$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $8974bd426dee645c$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $8974bd426dee645c$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$8974bd426dee645c$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $8974bd426dee645c$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $8974bd426dee645c$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$8974bd426dee645c$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("eEBP2", function(module, exports) {
'use strict';

var $47cfW = parcelRequire("47cfW");
function $aab223cc8550e94c$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $aab223cc8550e94c$var$Cipher;
$aab223cc8550e94c$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$aab223cc8550e94c$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$aab223cc8550e94c$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$aab223cc8550e94c$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$aab223cc8550e94c$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$aab223cc8550e94c$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$aab223cc8550e94c$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$aab223cc8550e94c$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$aab223cc8550e94c$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$aab223cc8550e94c$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$aab223cc8550e94c$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $47cfW.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("47cfW", function(module, exports) {
module.exports = $2ff152ad91b64e6c$var$assert;
function $2ff152ad91b64e6c$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$2ff152ad91b64e6c$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("2NKs5", function(module, exports) {
'use strict';

var $47cfW = parcelRequire("47cfW");

var $27YCQ = parcelRequire("27YCQ");

var $bNFRc = parcelRequire("bNFRc");

var $eEBP2 = parcelRequire("eEBP2");
function $20a430c57eb61ead$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $20a430c57eb61ead$var$DES(options) {
    $eEBP2.call(this, options);
    var state = new $20a430c57eb61ead$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$27YCQ($20a430c57eb61ead$var$DES, $eEBP2);
module.exports = $20a430c57eb61ead$var$DES;
$20a430c57eb61ead$var$DES.create = function create(options) {
    return new $20a430c57eb61ead$var$DES(options);
};
var $20a430c57eb61ead$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$20a430c57eb61ead$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $47cfW.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $bNFRc.readUInt32BE(key, 0);
    var kR = $bNFRc.readUInt32BE(key, 4);
    $bNFRc.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $20a430c57eb61ead$var$shiftTable[i >>> 1];
        kL = $bNFRc.r28shl(kL, shift);
        kR = $bNFRc.r28shl(kR, shift);
        $bNFRc.pc2(kL, kR, state.keys, i);
    }
};
$20a430c57eb61ead$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $bNFRc.readUInt32BE(inp, inOff);
    var r = $bNFRc.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $bNFRc.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $bNFRc.writeUInt32BE(out, l, outOff);
    $bNFRc.writeUInt32BE(out, r, outOff + 4);
};
$20a430c57eb61ead$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$20a430c57eb61ead$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$47cfW.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$20a430c57eb61ead$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $bNFRc.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $bNFRc.substitute(keyL, keyR);
        var f = $bNFRc.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $bNFRc.rip(r, l, out, off);
};
$20a430c57eb61ead$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $bNFRc.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $bNFRc.substitute(keyL, keyR);
        var f = $bNFRc.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $bNFRc.rip(l, r, out, off);
};

});

parcelRegister("8GfqC", function(module, exports) {

$parcel$export(module.exports, "instantiate", function () { return $651e36be23c19e22$export$f9bb8d20ccc7477a; }, function (v) { return $651e36be23c19e22$export$f9bb8d20ccc7477a = v; });
var $651e36be23c19e22$export$f9bb8d20ccc7477a;
'use strict';

var $47cfW = parcelRequire("47cfW");

var $27YCQ = parcelRequire("27YCQ");
var $651e36be23c19e22$var$proto = {};
function $651e36be23c19e22$var$CBCState(iv) {
    $47cfW.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $651e36be23c19e22$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $27YCQ(CBC, Base);
    var keys = Object.keys($651e36be23c19e22$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $651e36be23c19e22$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$651e36be23c19e22$export$f9bb8d20ccc7477a = $651e36be23c19e22$var$instantiate;
$651e36be23c19e22$var$proto._cbcInit = function _cbcInit() {
    var state = new $651e36be23c19e22$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$651e36be23c19e22$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("aDbaA", function(module, exports) {
'use strict';

var $47cfW = parcelRequire("47cfW");

var $27YCQ = parcelRequire("27YCQ");

var $eEBP2 = parcelRequire("eEBP2");

var $2NKs5 = parcelRequire("2NKs5");
function $7bd635fc8049d8f0$var$EDEState(type, key) {
    $47cfW.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $2NKs5.create({
            type: 'encrypt',
            key: k1
        }),
        $2NKs5.create({
            type: 'decrypt',
            key: k2
        }),
        $2NKs5.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $2NKs5.create({
            type: 'decrypt',
            key: k3
        }),
        $2NKs5.create({
            type: 'encrypt',
            key: k2
        }),
        $2NKs5.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $7bd635fc8049d8f0$var$EDE(options) {
    $eEBP2.call(this, options);
    var state = new $7bd635fc8049d8f0$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$27YCQ($7bd635fc8049d8f0$var$EDE, $eEBP2);
module.exports = $7bd635fc8049d8f0$var$EDE;
$7bd635fc8049d8f0$var$EDE.create = function create(options) {
    return new $7bd635fc8049d8f0$var$EDE(options);
};
$7bd635fc8049d8f0$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$7bd635fc8049d8f0$var$EDE.prototype._pad = $2NKs5.prototype._pad;
$7bd635fc8049d8f0$var$EDE.prototype._unpad = $2NKs5.prototype._unpad;

});



parcelRegister("eGE1b", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $ab1407b152cdbd21$export$2f64596b8cbf08b4; }, function (v) { return $ab1407b152cdbd21$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $ab1407b152cdbd21$export$36b6d6ef312eab39; }, function (v) { return $ab1407b152cdbd21$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $ab1407b152cdbd21$export$58a258485f1e49f6; }, function (v) { return $ab1407b152cdbd21$export$58a258485f1e49f6 = v; });
var $ab1407b152cdbd21$export$bdd223f16383713e;
var $ab1407b152cdbd21$export$26e5786e8ac8e530;
var $ab1407b152cdbd21$export$2f64596b8cbf08b4;
var $ab1407b152cdbd21$export$20533d26f07f1ee0;
var $ab1407b152cdbd21$export$12ada9414fbc594c;
var $ab1407b152cdbd21$export$2ce6d8d0e8b04e1a;
var $ab1407b152cdbd21$export$36b6d6ef312eab39;
var $ab1407b152cdbd21$export$f5e7e39d57cd9700;
var $ab1407b152cdbd21$export$dedd8dc3dc62b370;
var $ab1407b152cdbd21$export$58a258485f1e49f6;

var $dZUD8 = parcelRequire("dZUD8");

var $fKhhQ = parcelRequire("fKhhQ");

var $eciIX = parcelRequire("eciIX");
function $ab1407b152cdbd21$var$getCiphers() {
    return Object.keys($eciIX);
}
$ab1407b152cdbd21$export$bdd223f16383713e = $ab1407b152cdbd21$export$26e5786e8ac8e530 = $dZUD8.createCipher;
$ab1407b152cdbd21$export$2f64596b8cbf08b4 = $ab1407b152cdbd21$export$20533d26f07f1ee0 = $dZUD8.createCipheriv;
$ab1407b152cdbd21$export$12ada9414fbc594c = $ab1407b152cdbd21$export$2ce6d8d0e8b04e1a = $fKhhQ.createDecipher;
$ab1407b152cdbd21$export$36b6d6ef312eab39 = $ab1407b152cdbd21$export$f5e7e39d57cd9700 = $fKhhQ.createDecipheriv;
$ab1407b152cdbd21$export$dedd8dc3dc62b370 = $ab1407b152cdbd21$export$58a258485f1e49f6 = $ab1407b152cdbd21$var$getCiphers;

});
parcelRegister("dZUD8", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $a30ce676bb025345$export$2f64596b8cbf08b4; }, function (v) { return $a30ce676bb025345$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createCipher", function () { return $a30ce676bb025345$export$bdd223f16383713e; }, function (v) { return $a30ce676bb025345$export$bdd223f16383713e = v; });
var $a30ce676bb025345$export$2f64596b8cbf08b4;
var $a30ce676bb025345$export$bdd223f16383713e;

var $ivHbd = parcelRequire("ivHbd");

var $gR2I7 = parcelRequire("gR2I7");

var $2tQhI = parcelRequire("2tQhI");
var $a30ce676bb025345$require$Buffer = $2tQhI.Buffer;

var $kDhMj = parcelRequire("kDhMj");

var $bjKi2 = parcelRequire("bjKi2");

var $kwcq2 = parcelRequire("kwcq2");

var $fZX14 = parcelRequire("fZX14");

var $27YCQ = parcelRequire("27YCQ");
function $a30ce676bb025345$var$Cipher(mode, key, iv) {
    $bjKi2.call(this);
    this._cache = new $a30ce676bb025345$var$Splitter();
    this._cipher = new $kwcq2.AES(key);
    this._prev = $a30ce676bb025345$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$27YCQ($a30ce676bb025345$var$Cipher, $bjKi2);
$a30ce676bb025345$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $a30ce676bb025345$require$Buffer.concat(out);
};
var $a30ce676bb025345$var$PADDING = $a30ce676bb025345$require$Buffer.alloc(16, 0x10);
$a30ce676bb025345$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($a30ce676bb025345$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$a30ce676bb025345$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $a30ce676bb025345$var$Splitter() {
    this.cache = $a30ce676bb025345$require$Buffer.allocUnsafe(0);
}
$a30ce676bb025345$var$Splitter.prototype.add = function(data) {
    this.cache = $a30ce676bb025345$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$a30ce676bb025345$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$a30ce676bb025345$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $a30ce676bb025345$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $a30ce676bb025345$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $a30ce676bb025345$var$createCipheriv(suite, password, iv) {
    var config = $ivHbd[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $a30ce676bb025345$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $a30ce676bb025345$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $kDhMj(config.module, password, iv);
    else if (config.type === 'auth') return new $gR2I7(config.module, password, iv);
    return new $a30ce676bb025345$var$Cipher(config.module, password, iv);
}
function $a30ce676bb025345$var$createCipher(suite, password) {
    var config = $ivHbd[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $fZX14(password, false, config.key, config.iv);
    return $a30ce676bb025345$var$createCipheriv(suite, keys.key, keys.iv);
}
$a30ce676bb025345$export$2f64596b8cbf08b4 = $a30ce676bb025345$var$createCipheriv;
$a30ce676bb025345$export$bdd223f16383713e = $a30ce676bb025345$var$createCipher;

});
parcelRegister("ivHbd", function(module, exports) {








var $d79c9de56bb88712$var$modeModules = {
    ECB: (parcelRequire("jMGXZ")),
    CBC: (parcelRequire("7BDWF")),
    CFB: (parcelRequire("8j6oH")),
    CFB8: (parcelRequire("f40VL")),
    CFB1: (parcelRequire("pAYAf")),
    OFB: (parcelRequire("jGoNt")),
    CTR: (parcelRequire("c5FFg")),
    GCM: (parcelRequire("c5FFg"))
};

var $eciIX = parcelRequire("eciIX");
for(var $d79c9de56bb88712$var$key in $eciIX)$eciIX[$d79c9de56bb88712$var$key].module = $d79c9de56bb88712$var$modeModules[$eciIX[$d79c9de56bb88712$var$key].mode];
module.exports = $eciIX;

});
parcelRegister("jMGXZ", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $e673d44241f8ab2c$export$5b0f6292f11d1d18; }, function (v) { return $e673d44241f8ab2c$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $e673d44241f8ab2c$export$e85a0c9a1067c5d3; }, function (v) { return $e673d44241f8ab2c$export$e85a0c9a1067c5d3 = v; });
var $e673d44241f8ab2c$export$5b0f6292f11d1d18;
var $e673d44241f8ab2c$export$e85a0c9a1067c5d3;
$e673d44241f8ab2c$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$e673d44241f8ab2c$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("7BDWF", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $589af964ecee3c32$export$5b0f6292f11d1d18; }, function (v) { return $589af964ecee3c32$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $589af964ecee3c32$export$e85a0c9a1067c5d3; }, function (v) { return $589af964ecee3c32$export$e85a0c9a1067c5d3 = v; });
var $589af964ecee3c32$export$5b0f6292f11d1d18;
var $589af964ecee3c32$export$e85a0c9a1067c5d3;

var $2tTZC = parcelRequire("2tTZC");
$589af964ecee3c32$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $2tTZC(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$589af964ecee3c32$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $2tTZC(out, pad);
};

});
parcelRegister("2tTZC", function(module, exports) {

var $81U8s = parcelRequire("81U8s");
var $1ce9b93c3cdfee4e$require$Buffer = $81U8s.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $1ce9b93c3cdfee4e$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("8j6oH", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $60c50f7c67546e7a$export$5b0f6292f11d1d18; }, function (v) { return $60c50f7c67546e7a$export$5b0f6292f11d1d18 = v; });
var $60c50f7c67546e7a$export$5b0f6292f11d1d18;

var $2tQhI = parcelRequire("2tQhI");
var $60c50f7c67546e7a$require$Buffer = $2tQhI.Buffer;

var $2tTZC = parcelRequire("2tTZC");
function $60c50f7c67546e7a$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $2tTZC(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $60c50f7c67546e7a$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$60c50f7c67546e7a$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $60c50f7c67546e7a$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $60c50f7c67546e7a$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $60c50f7c67546e7a$require$Buffer.concat([
                out,
                $60c50f7c67546e7a$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $60c50f7c67546e7a$require$Buffer.concat([
                out,
                $60c50f7c67546e7a$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("f40VL", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $af77f3912a8b12ae$export$5b0f6292f11d1d18; }, function (v) { return $af77f3912a8b12ae$export$5b0f6292f11d1d18 = v; });
var $af77f3912a8b12ae$export$5b0f6292f11d1d18;

var $2tQhI = parcelRequire("2tQhI");
var $af77f3912a8b12ae$require$Buffer = $2tQhI.Buffer;
function $af77f3912a8b12ae$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $af77f3912a8b12ae$require$Buffer.concat([
        self._prev.slice(1),
        $af77f3912a8b12ae$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$af77f3912a8b12ae$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $af77f3912a8b12ae$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $af77f3912a8b12ae$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("pAYAf", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $04cf049bd954378f$export$5b0f6292f11d1d18; }, function (v) { return $04cf049bd954378f$export$5b0f6292f11d1d18 = v; });
var $04cf049bd954378f$export$5b0f6292f11d1d18;

var $2tQhI = parcelRequire("2tQhI");
var $04cf049bd954378f$require$Buffer = $2tQhI.Buffer;
function $04cf049bd954378f$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $04cf049bd954378f$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $04cf049bd954378f$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $04cf049bd954378f$require$Buffer.allocUnsafe(buffer.length);
    buffer = $04cf049bd954378f$require$Buffer.concat([
        buffer,
        $04cf049bd954378f$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$04cf049bd954378f$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $04cf049bd954378f$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $04cf049bd954378f$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("jGoNt", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $e5452cb8678ff85c$export$5b0f6292f11d1d18; }, function (v) { return $e5452cb8678ff85c$export$5b0f6292f11d1d18 = v; });
var $e5452cb8678ff85c$export$5b0f6292f11d1d18;

var $81U8s = parcelRequire("81U8s");
var $e5452cb8678ff85c$require$Buffer = $81U8s.Buffer;

var $2tTZC = parcelRequire("2tTZC");
function $e5452cb8678ff85c$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$e5452cb8678ff85c$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $e5452cb8678ff85c$require$Buffer.concat([
        self._cache,
        $e5452cb8678ff85c$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $2tTZC(chunk, pad);
};

});

parcelRegister("c5FFg", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $8cd64560c75edc6f$export$5b0f6292f11d1d18; }, function (v) { return $8cd64560c75edc6f$export$5b0f6292f11d1d18 = v; });
var $8cd64560c75edc6f$export$5b0f6292f11d1d18;

var $2tTZC = parcelRequire("2tTZC");

var $2tQhI = parcelRequire("2tQhI");
var $8cd64560c75edc6f$require$Buffer = $2tQhI.Buffer;

var $5C1Ud = parcelRequire("5C1Ud");
function $8cd64560c75edc6f$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $5C1Ud(self._prev);
    return out;
}
var $8cd64560c75edc6f$var$blockSize = 16;
$8cd64560c75edc6f$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $8cd64560c75edc6f$var$blockSize);
    var start = self._cache.length;
    self._cache = $8cd64560c75edc6f$require$Buffer.concat([
        self._cache,
        $8cd64560c75edc6f$require$Buffer.allocUnsafe(chunkNum * $8cd64560c75edc6f$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $8cd64560c75edc6f$var$getBlock(self);
        var offset = start + i * $8cd64560c75edc6f$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $2tTZC(chunk, pad);
};

});
parcelRegister("5C1Ud", function(module, exports) {
function $4161fad141aea92a$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $4161fad141aea92a$var$incr32;

});


parcelRegister("eciIX", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("gR2I7", function(module, exports) {

var $kwcq2 = parcelRequire("kwcq2");

var $2tQhI = parcelRequire("2tQhI");
var $c453b2db2485110e$require$Buffer = $2tQhI.Buffer;

var $bjKi2 = parcelRequire("bjKi2");

var $27YCQ = parcelRequire("27YCQ");

var $kQxh8 = parcelRequire("kQxh8");

var $2tTZC = parcelRequire("2tTZC");

var $5C1Ud = parcelRequire("5C1Ud");
function $c453b2db2485110e$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $c453b2db2485110e$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $c453b2db2485110e$require$Buffer.concat([
            iv,
            $c453b2db2485110e$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $c453b2db2485110e$require$Buffer.concat([
            iv,
            $c453b2db2485110e$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $kQxh8(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($c453b2db2485110e$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($c453b2db2485110e$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $c453b2db2485110e$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $c453b2db2485110e$require$Buffer.from(self._finID);
    $5C1Ud(out);
    return out;
}
function $c453b2db2485110e$var$StreamCipher(mode, key, iv, decrypt) {
    $bjKi2.call(this);
    var h = $c453b2db2485110e$require$Buffer.alloc(4, 0);
    this._cipher = new $kwcq2.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $kQxh8(ck);
    iv = $c453b2db2485110e$var$calcIv(this, iv, ck);
    this._prev = $c453b2db2485110e$require$Buffer.from(iv);
    this._cache = $c453b2db2485110e$require$Buffer.allocUnsafe(0);
    this._secCache = $c453b2db2485110e$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$27YCQ($c453b2db2485110e$var$StreamCipher, $bjKi2);
$c453b2db2485110e$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $c453b2db2485110e$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$c453b2db2485110e$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $2tTZC(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $c453b2db2485110e$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$c453b2db2485110e$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$c453b2db2485110e$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$c453b2db2485110e$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$c453b2db2485110e$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $c453b2db2485110e$var$StreamCipher;

});
parcelRegister("kwcq2", function(module, exports) {

$parcel$export(module.exports, "AES", function () { return $ef006df61f04a9cd$export$b80fbe1c3a2b92b5; }, function (v) { return $ef006df61f04a9cd$export$b80fbe1c3a2b92b5 = v; });
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $ef006df61f04a9cd$export$b80fbe1c3a2b92b5;

var $2tQhI = parcelRequire("2tQhI");
var $ef006df61f04a9cd$require$Buffer = $2tQhI.Buffer;
function $ef006df61f04a9cd$var$asUInt32Array(buf) {
    if (!$ef006df61f04a9cd$require$Buffer.isBuffer(buf)) buf = $ef006df61f04a9cd$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $ef006df61f04a9cd$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $ef006df61f04a9cd$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $ef006df61f04a9cd$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $ef006df61f04a9cd$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $ef006df61f04a9cd$var$AES(key) {
    this._key = $ef006df61f04a9cd$var$asUInt32Array(key);
    this._reset();
}
$ef006df61f04a9cd$var$AES.blockSize = 16;
$ef006df61f04a9cd$var$AES.keySize = 32;
$ef006df61f04a9cd$var$AES.prototype.blockSize = $ef006df61f04a9cd$var$AES.blockSize;
$ef006df61f04a9cd$var$AES.prototype.keySize = $ef006df61f04a9cd$var$AES.keySize;
$ef006df61f04a9cd$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $ef006df61f04a9cd$var$G.SBOX[t >>> 24] << 24 | $ef006df61f04a9cd$var$G.SBOX[t >>> 16 & 0xff] << 16 | $ef006df61f04a9cd$var$G.SBOX[t >>> 8 & 0xff] << 8 | $ef006df61f04a9cd$var$G.SBOX[t & 0xff];
            t ^= $ef006df61f04a9cd$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $ef006df61f04a9cd$var$G.SBOX[t >>> 24] << 24 | $ef006df61f04a9cd$var$G.SBOX[t >>> 16 & 0xff] << 16 | $ef006df61f04a9cd$var$G.SBOX[t >>> 8 & 0xff] << 8 | $ef006df61f04a9cd$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $ef006df61f04a9cd$var$G.INV_SUB_MIX[0][$ef006df61f04a9cd$var$G.SBOX[tt >>> 24]] ^ $ef006df61f04a9cd$var$G.INV_SUB_MIX[1][$ef006df61f04a9cd$var$G.SBOX[tt >>> 16 & 0xff]] ^ $ef006df61f04a9cd$var$G.INV_SUB_MIX[2][$ef006df61f04a9cd$var$G.SBOX[tt >>> 8 & 0xff]] ^ $ef006df61f04a9cd$var$G.INV_SUB_MIX[3][$ef006df61f04a9cd$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$ef006df61f04a9cd$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $ef006df61f04a9cd$var$asUInt32Array(M);
    return $ef006df61f04a9cd$var$cryptBlock(M, this._keySchedule, $ef006df61f04a9cd$var$G.SUB_MIX, $ef006df61f04a9cd$var$G.SBOX, this._nRounds);
};
$ef006df61f04a9cd$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $ef006df61f04a9cd$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$ef006df61f04a9cd$var$AES.prototype.decryptBlock = function(M) {
    M = $ef006df61f04a9cd$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $ef006df61f04a9cd$var$cryptBlock(M, this._invKeySchedule, $ef006df61f04a9cd$var$G.INV_SUB_MIX, $ef006df61f04a9cd$var$G.INV_SBOX, this._nRounds);
    var buf = $ef006df61f04a9cd$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$ef006df61f04a9cd$var$AES.prototype.scrub = function() {
    $ef006df61f04a9cd$var$scrubVec(this._keySchedule);
    $ef006df61f04a9cd$var$scrubVec(this._invKeySchedule);
    $ef006df61f04a9cd$var$scrubVec(this._key);
};
$ef006df61f04a9cd$export$b80fbe1c3a2b92b5 = $ef006df61f04a9cd$var$AES;

});

parcelRegister("kQxh8", function(module, exports) {

var $2tQhI = parcelRequire("2tQhI");
var $f2d279c641e82248$require$Buffer = $2tQhI.Buffer;
var $f2d279c641e82248$var$ZEROES = $f2d279c641e82248$require$Buffer.alloc(16, 0);
function $f2d279c641e82248$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $f2d279c641e82248$var$fromArray(out) {
    var buf = $f2d279c641e82248$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $f2d279c641e82248$var$GHASH(key) {
    this.h = key;
    this.state = $f2d279c641e82248$require$Buffer.alloc(16, 0);
    this.cache = $f2d279c641e82248$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$f2d279c641e82248$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$f2d279c641e82248$var$GHASH.prototype._multiply = function() {
    var Vi = $f2d279c641e82248$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $f2d279c641e82248$var$fromArray(Zi);
};
$f2d279c641e82248$var$GHASH.prototype.update = function(buf) {
    this.cache = $f2d279c641e82248$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$f2d279c641e82248$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($f2d279c641e82248$require$Buffer.concat([
        this.cache,
        $f2d279c641e82248$var$ZEROES
    ], 16));
    this.ghash($f2d279c641e82248$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $f2d279c641e82248$var$GHASH;

});


parcelRegister("kDhMj", function(module, exports) {

var $kwcq2 = parcelRequire("kwcq2");

var $2tQhI = parcelRequire("2tQhI");
var $f0553d8d1c0217e6$require$Buffer = $2tQhI.Buffer;

var $bjKi2 = parcelRequire("bjKi2");

var $27YCQ = parcelRequire("27YCQ");
function $f0553d8d1c0217e6$var$StreamCipher(mode, key, iv, decrypt) {
    $bjKi2.call(this);
    this._cipher = new $kwcq2.AES(key);
    this._prev = $f0553d8d1c0217e6$require$Buffer.from(iv);
    this._cache = $f0553d8d1c0217e6$require$Buffer.allocUnsafe(0);
    this._secCache = $f0553d8d1c0217e6$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$27YCQ($f0553d8d1c0217e6$var$StreamCipher, $bjKi2);
$f0553d8d1c0217e6$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$f0553d8d1c0217e6$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $f0553d8d1c0217e6$var$StreamCipher;

});

parcelRegister("fZX14", function(module, exports) {

var $2tQhI = parcelRequire("2tQhI");
var $ba5a54ee67405c43$require$Buffer = $2tQhI.Buffer;

var $jQriO = parcelRequire("jQriO");
/* eslint-disable camelcase */ function $ba5a54ee67405c43$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$ba5a54ee67405c43$require$Buffer.isBuffer(password)) password = $ba5a54ee67405c43$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$ba5a54ee67405c43$require$Buffer.isBuffer(salt)) salt = $ba5a54ee67405c43$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $ba5a54ee67405c43$require$Buffer.alloc(keyLen);
    var iv = $ba5a54ee67405c43$require$Buffer.alloc(ivLen || 0);
    var tmp = $ba5a54ee67405c43$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $jQriO();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $ba5a54ee67405c43$var$EVP_BytesToKey;

});


parcelRegister("fKhhQ", function(module, exports) {

$parcel$export(module.exports, "createDecipher", function () { return $b7688facd45352b8$export$12ada9414fbc594c; }, function (v) { return $b7688facd45352b8$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $b7688facd45352b8$export$36b6d6ef312eab39; }, function (v) { return $b7688facd45352b8$export$36b6d6ef312eab39 = v; });
var $b7688facd45352b8$export$12ada9414fbc594c;
var $b7688facd45352b8$export$36b6d6ef312eab39;

var $gR2I7 = parcelRequire("gR2I7");

var $2tQhI = parcelRequire("2tQhI");
var $b7688facd45352b8$require$Buffer = $2tQhI.Buffer;

var $ivHbd = parcelRequire("ivHbd");

var $kDhMj = parcelRequire("kDhMj");

var $bjKi2 = parcelRequire("bjKi2");

var $kwcq2 = parcelRequire("kwcq2");

var $fZX14 = parcelRequire("fZX14");

var $27YCQ = parcelRequire("27YCQ");
function $b7688facd45352b8$var$Decipher(mode, key, iv) {
    $bjKi2.call(this);
    this._cache = new $b7688facd45352b8$var$Splitter();
    this._last = void 0;
    this._cipher = new $kwcq2.AES(key);
    this._prev = $b7688facd45352b8$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$27YCQ($b7688facd45352b8$var$Decipher, $bjKi2);
$b7688facd45352b8$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $b7688facd45352b8$require$Buffer.concat(out);
};
$b7688facd45352b8$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $b7688facd45352b8$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$b7688facd45352b8$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $b7688facd45352b8$var$Splitter() {
    this.cache = $b7688facd45352b8$require$Buffer.allocUnsafe(0);
}
$b7688facd45352b8$var$Splitter.prototype.add = function(data) {
    this.cache = $b7688facd45352b8$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$b7688facd45352b8$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$b7688facd45352b8$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $b7688facd45352b8$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $b7688facd45352b8$var$createDecipheriv(suite, password, iv) {
    var config = $ivHbd[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $b7688facd45352b8$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $b7688facd45352b8$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $kDhMj(config.module, password, iv, true);
    else if (config.type === 'auth') return new $gR2I7(config.module, password, iv, true);
    return new $b7688facd45352b8$var$Decipher(config.module, password, iv);
}
function $b7688facd45352b8$var$createDecipher(suite, password) {
    var config = $ivHbd[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $fZX14(password, false, config.key, config.iv);
    return $b7688facd45352b8$var$createDecipheriv(suite, keys.key, keys.iv);
}
$b7688facd45352b8$export$12ada9414fbc594c = $b7688facd45352b8$var$createDecipher;
$b7688facd45352b8$export$36b6d6ef312eab39 = $b7688facd45352b8$var$createDecipheriv;

});


parcelRegister("9xOSi", function(module, exports) {

$parcel$export(module.exports, "des-ecb", function () { return $6f2ea8c84f752623$export$116f8a5cee447347; }, function (v) { return $6f2ea8c84f752623$export$116f8a5cee447347 = v; });
$parcel$export(module.exports, "des-cbc", function () { return $6f2ea8c84f752623$export$7483c4066bfb7ae9; }, function (v) { return $6f2ea8c84f752623$export$7483c4066bfb7ae9 = v; });
$parcel$export(module.exports, "des", function () { return $6f2ea8c84f752623$export$e7a565d2e588bb06; }, function (v) { return $6f2ea8c84f752623$export$e7a565d2e588bb06 = v; });
$parcel$export(module.exports, "des-ede3-cbc", function () { return $6f2ea8c84f752623$export$aaa2f54a426f3eb8; }, function (v) { return $6f2ea8c84f752623$export$aaa2f54a426f3eb8 = v; });
$parcel$export(module.exports, "des3", function () { return $6f2ea8c84f752623$export$eba20568dde4ada; }, function (v) { return $6f2ea8c84f752623$export$eba20568dde4ada = v; });
$parcel$export(module.exports, "des-ede3", function () { return $6f2ea8c84f752623$export$d3b5e5996938f5ae; }, function (v) { return $6f2ea8c84f752623$export$d3b5e5996938f5ae = v; });
$parcel$export(module.exports, "des-ede-cbc", function () { return $6f2ea8c84f752623$export$57c08356130bc99b; }, function (v) { return $6f2ea8c84f752623$export$57c08356130bc99b = v; });
$parcel$export(module.exports, "des-ede", function () { return $6f2ea8c84f752623$export$c7169791d5c1e65d; }, function (v) { return $6f2ea8c84f752623$export$c7169791d5c1e65d = v; });
var $6f2ea8c84f752623$export$116f8a5cee447347;
var $6f2ea8c84f752623$export$7483c4066bfb7ae9;
var $6f2ea8c84f752623$export$e7a565d2e588bb06;
var $6f2ea8c84f752623$export$aaa2f54a426f3eb8;
var $6f2ea8c84f752623$export$eba20568dde4ada;
var $6f2ea8c84f752623$export$d3b5e5996938f5ae;
var $6f2ea8c84f752623$export$57c08356130bc99b;
var $6f2ea8c84f752623$export$c7169791d5c1e65d;
$6f2ea8c84f752623$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$6f2ea8c84f752623$export$7483c4066bfb7ae9 = $6f2ea8c84f752623$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$6f2ea8c84f752623$export$aaa2f54a426f3eb8 = $6f2ea8c84f752623$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$6f2ea8c84f752623$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$6f2ea8c84f752623$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$6f2ea8c84f752623$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("87HM8", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $5ea0ef1272f2494c$export$971862a2fcb1bb40; }, function (v) { return $5ea0ef1272f2494c$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $5ea0ef1272f2494c$export$c6ff6a88acbeaf40; }, function (v) { return $5ea0ef1272f2494c$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $5ea0ef1272f2494c$export$fdc27893e98845cc; }, function (v) { return $5ea0ef1272f2494c$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $5ea0ef1272f2494c$export$6671fb9a1323bed; }, function (v) { return $5ea0ef1272f2494c$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $5ea0ef1272f2494c$export$d74daf141a551db; }, function (v) { return $5ea0ef1272f2494c$export$d74daf141a551db = v; });
var $5ea0ef1272f2494c$export$971862a2fcb1bb40;
var $5ea0ef1272f2494c$export$c6ff6a88acbeaf40;
var $5ea0ef1272f2494c$export$fdc27893e98845cc;
var $5ea0ef1272f2494c$export$6671fb9a1323bed;
var $5ea0ef1272f2494c$export$d74daf141a551db;

var $81U8s = parcelRequire("81U8s");
var $5ea0ef1272f2494c$require$Buffer = $81U8s.Buffer;

var $8ku1i = parcelRequire("8ku1i");

var $jF0NN = parcelRequire("jF0NN");

var $fU8Os = parcelRequire("fU8Os");
function $5ea0ef1272f2494c$var$getDiffieHellman(mod) {
    var prime = new $5ea0ef1272f2494c$require$Buffer($jF0NN[mod].prime, 'hex');
    var gen = new $5ea0ef1272f2494c$require$Buffer($jF0NN[mod].gen, 'hex');
    return new $fU8Os(prime, gen);
}
var $5ea0ef1272f2494c$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $5ea0ef1272f2494c$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($5ea0ef1272f2494c$require$Buffer.isBuffer(enc) || $5ea0ef1272f2494c$var$ENCODINGS[enc] === undefined) return $5ea0ef1272f2494c$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $5ea0ef1272f2494c$require$Buffer([
        2
    ]);
    if (!$5ea0ef1272f2494c$require$Buffer.isBuffer(generator)) generator = new $5ea0ef1272f2494c$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $fU8Os($8ku1i(prime, generator), generator, true);
    if (!$5ea0ef1272f2494c$require$Buffer.isBuffer(prime)) prime = new $5ea0ef1272f2494c$require$Buffer(prime, enc);
    return new $fU8Os(prime, generator, true);
}
$5ea0ef1272f2494c$export$971862a2fcb1bb40 = $5ea0ef1272f2494c$export$c6ff6a88acbeaf40 = $5ea0ef1272f2494c$export$fdc27893e98845cc = $5ea0ef1272f2494c$var$getDiffieHellman;
$5ea0ef1272f2494c$export$6671fb9a1323bed = $5ea0ef1272f2494c$export$d74daf141a551db = $5ea0ef1272f2494c$var$createDiffieHellman;

});
parcelRegister("8ku1i", function(module, exports) {

var $hw9Ml = parcelRequire("hw9Ml");
module.exports = $61077a52a922a05a$var$findPrime;
$61077a52a922a05a$var$findPrime.simpleSieve = $61077a52a922a05a$var$simpleSieve;
$61077a52a922a05a$var$findPrime.fermatTest = $61077a52a922a05a$var$fermatTest;

var $4lSpl = parcelRequire("4lSpl");
var $61077a52a922a05a$var$TWENTYFOUR = new $4lSpl(24);

var $8GBwm = parcelRequire("8GBwm");
var $61077a52a922a05a$var$millerRabin = new $8GBwm();
var $61077a52a922a05a$var$ONE = new $4lSpl(1);
var $61077a52a922a05a$var$TWO = new $4lSpl(2);
var $61077a52a922a05a$var$FIVE = new $4lSpl(5);
var $61077a52a922a05a$var$SIXTEEN = new $4lSpl(16);
var $61077a52a922a05a$var$EIGHT = new $4lSpl(8);
var $61077a52a922a05a$var$TEN = new $4lSpl(10);
var $61077a52a922a05a$var$THREE = new $4lSpl(3);
var $61077a52a922a05a$var$SEVEN = new $4lSpl(7);
var $61077a52a922a05a$var$ELEVEN = new $4lSpl(11);
var $61077a52a922a05a$var$FOUR = new $4lSpl(4);
var $61077a52a922a05a$var$TWELVE = new $4lSpl(12);
var $61077a52a922a05a$var$primes = null;
function $61077a52a922a05a$var$_getPrimes() {
    if ($61077a52a922a05a$var$primes !== null) return $61077a52a922a05a$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $61077a52a922a05a$var$primes = res;
    return res;
}
function $61077a52a922a05a$var$simpleSieve(p) {
    var primes = $61077a52a922a05a$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $61077a52a922a05a$var$fermatTest(p) {
    var red = $4lSpl.mont(p);
    return $61077a52a922a05a$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $61077a52a922a05a$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $4lSpl([
            0x8c,
            0x7b
        ]);
        else return new $4lSpl([
            0x8c,
            0x27
        ]);
    }
    gen = new $4lSpl(gen);
    var num, n2;
    while(true){
        num = new $4lSpl($hw9Ml(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($61077a52a922a05a$var$ONE);
        if (!num.testn(1)) num.iadd($61077a52a922a05a$var$TWO);
        if (!gen.cmp($61077a52a922a05a$var$TWO)) while(num.mod($61077a52a922a05a$var$TWENTYFOUR).cmp($61077a52a922a05a$var$ELEVEN))num.iadd($61077a52a922a05a$var$FOUR);
        else if (!gen.cmp($61077a52a922a05a$var$FIVE)) while(num.mod($61077a52a922a05a$var$TEN).cmp($61077a52a922a05a$var$THREE))num.iadd($61077a52a922a05a$var$FOUR);
        n2 = num.shrn(1);
        if ($61077a52a922a05a$var$simpleSieve(n2) && $61077a52a922a05a$var$simpleSieve(num) && $61077a52a922a05a$var$fermatTest(n2) && $61077a52a922a05a$var$fermatTest(num) && $61077a52a922a05a$var$millerRabin.test(n2) && $61077a52a922a05a$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("4lSpl", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("6N7cq")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) {
            this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            i++;
        }
        // Clear words above the requested width so the result stays below 2 ** width
        for(; i < this.length; i++)this.words[i] = 0;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        if (num === 0) {
            this.length = 1;
            this._normSign();
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.mod.abs();
        var half = num.abs().iushrn(1);
        var r2 = num.words[0] & 1;
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up, away from zero
        var up = new BN(1);
        up.negative = this.negative ^ num.negative;
        return dm.div.iadd(up);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("8GBwm", function(module, exports) {

var $4lSpl = parcelRequire("4lSpl");

var $axlTq = parcelRequire("axlTq");
function $652f59d91c1b29e7$var$MillerRabin(rand) {
    this.rand = rand || new $axlTq.Rand();
}
module.exports = $652f59d91c1b29e7$var$MillerRabin;
$652f59d91c1b29e7$var$MillerRabin.create = function create(rand) {
    return new $652f59d91c1b29e7$var$MillerRabin(rand);
};
$652f59d91c1b29e7$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $4lSpl(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$652f59d91c1b29e7$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$652f59d91c1b29e7$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $4lSpl.mont(n);
    var rone = new $4lSpl(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $4lSpl(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$652f59d91c1b29e7$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $4lSpl.mont(n);
    var rone = new $4lSpl(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $4lSpl(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("axlTq", function(module, exports) {
var $7abdf7f446e50ff4$var$r;
module.exports = function rand(len) {
    if (!$7abdf7f446e50ff4$var$r) $7abdf7f446e50ff4$var$r = new $7abdf7f446e50ff4$var$Rand(null);
    return $7abdf7f446e50ff4$var$r.generate(len);
};
function $7abdf7f446e50ff4$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $7abdf7f446e50ff4$var$Rand;
$7abdf7f446e50ff4$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$7abdf7f446e50ff4$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $7abdf7f446e50ff4$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $7abdf7f446e50ff4$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $7abdf7f446e50ff4$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $7abdf7f446e50ff4$var$crypto = (parcelRequire("6N7cq"));
    if (typeof $7abdf7f446e50ff4$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $7abdf7f446e50ff4$var$Rand.prototype._rand = function _rand(n) {
        return $7abdf7f446e50ff4$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("jF0NN", function(module, exports) {
module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

});

parcelRegister("fU8Os", function(module, exports) {

var $81U8s = parcelRequire("81U8s");
var $b942ec076e9686ff$require$Buffer = $81U8s.Buffer;

var $4lSpl = parcelRequire("4lSpl");

var $8GBwm = parcelRequire("8GBwm");
var $b942ec076e9686ff$var$millerRabin = new $8GBwm();
var $b942ec076e9686ff$var$TWENTYFOUR = new $4lSpl(24);
var $b942ec076e9686ff$var$ELEVEN = new $4lSpl(11);
var $b942ec076e9686ff$var$TEN = new $4lSpl(10);
var $b942ec076e9686ff$var$THREE = new $4lSpl(3);
var $b942ec076e9686ff$var$SEVEN = new $4lSpl(7);

var $8ku1i = parcelRequire("8ku1i");

var $hw9Ml = parcelRequire("hw9Ml");
module.exports = $b942ec076e9686ff$var$DH;
function $b942ec076e9686ff$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$b942ec076e9686ff$require$Buffer.isBuffer(pub)) pub = new $b942ec076e9686ff$require$Buffer(pub, enc);
    this._pub = new $4lSpl(pub);
    return this;
}
function $b942ec076e9686ff$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$b942ec076e9686ff$require$Buffer.isBuffer(priv)) priv = new $b942ec076e9686ff$require$Buffer(priv, enc);
    this._priv = new $4lSpl(priv);
    return this;
}
var $b942ec076e9686ff$var$primeCache = {};
function $b942ec076e9686ff$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $b942ec076e9686ff$var$primeCache) return $b942ec076e9686ff$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$8ku1i.simpleSieve || !$8ku1i.fermatTest(prime) || !$b942ec076e9686ff$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $b942ec076e9686ff$var$primeCache[hex] = error;
        return error;
    }
    if (!$b942ec076e9686ff$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($b942ec076e9686ff$var$TWENTYFOUR).cmp($b942ec076e9686ff$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($b942ec076e9686ff$var$TEN);
            if (rem.cmp($b942ec076e9686ff$var$THREE) && rem.cmp($b942ec076e9686ff$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $b942ec076e9686ff$var$primeCache[hex] = error;
    return error;
}
function $b942ec076e9686ff$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $4lSpl(prime);
    this._prime = $4lSpl.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $b942ec076e9686ff$var$setPublicKey;
        this.setPrivateKey = $b942ec076e9686ff$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($b942ec076e9686ff$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $b942ec076e9686ff$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$b942ec076e9686ff$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $4lSpl($hw9Ml(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$b942ec076e9686ff$var$DH.prototype.computeSecret = function(other) {
    other = new $4lSpl(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $b942ec076e9686ff$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $b942ec076e9686ff$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $b942ec076e9686ff$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$b942ec076e9686ff$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $b942ec076e9686ff$var$formatReturnValue(this._pub, enc);
};
$b942ec076e9686ff$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $b942ec076e9686ff$var$formatReturnValue(this._priv, enc);
};
$b942ec076e9686ff$var$DH.prototype.getPrime = function(enc) {
    return $b942ec076e9686ff$var$formatReturnValue(this.__prime, enc);
};
$b942ec076e9686ff$var$DH.prototype.getGenerator = function(enc) {
    return $b942ec076e9686ff$var$formatReturnValue(this._gen, enc);
};
$b942ec076e9686ff$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$b942ec076e9686ff$require$Buffer.isBuffer(gen)) gen = new $b942ec076e9686ff$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $4lSpl(gen);
    return this;
};
function $b942ec076e9686ff$var$formatReturnValue(bn, enc) {
    var buf = new $b942ec076e9686ff$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("441cL", function(module, exports) {
'use strict';

var $2tQhI = parcelRequire("2tQhI");
var $2f587863d89e0e92$require$Buffer = $2tQhI.Buffer;

var $5RHXY = parcelRequire("5RHXY");

var $fHsVX = parcelRequire("fHsVX");

var $27YCQ = parcelRequire("27YCQ");

var $ft4Xb = parcelRequire("ft4Xb");

var $emsvv = parcelRequire("emsvv");

var $ltWeA = parcelRequire("ltWeA");
Object.keys($ltWeA).forEach(function(key) {
    $ltWeA[key].id = $2f587863d89e0e92$require$Buffer.from($ltWeA[key].id, 'hex');
    $ltWeA[key.toLowerCase()] = $ltWeA[key];
});
function $2f587863d89e0e92$var$Sign(algorithm) {
    $fHsVX.Writable.call(this);
    var data = $ltWeA[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $5RHXY(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$27YCQ($2f587863d89e0e92$var$Sign, $fHsVX.Writable);
$2f587863d89e0e92$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$2f587863d89e0e92$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $2f587863d89e0e92$require$Buffer.from(data, enc) : data);
    return this;
};
$2f587863d89e0e92$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $ft4Xb(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $2f587863d89e0e92$var$Verify(algorithm) {
    $fHsVX.Writable.call(this);
    var data = $ltWeA[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $5RHXY(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$27YCQ($2f587863d89e0e92$var$Verify, $fHsVX.Writable);
$2f587863d89e0e92$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$2f587863d89e0e92$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $2f587863d89e0e92$require$Buffer.from(data, enc) : data);
    return this;
};
$2f587863d89e0e92$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $2f587863d89e0e92$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $emsvv(sigBuffer, hash, key, this._signType, this._tag);
};
function $2f587863d89e0e92$var$createSign(algorithm) {
    return new $2f587863d89e0e92$var$Sign(algorithm);
}
function $2f587863d89e0e92$var$createVerify(algorithm) {
    return new $2f587863d89e0e92$var$Verify(algorithm);
}
module.exports = {
    Sign: $2f587863d89e0e92$var$createSign,
    Verify: $2f587863d89e0e92$var$createVerify,
    createSign: $2f587863d89e0e92$var$createSign,
    createVerify: $2f587863d89e0e92$var$createVerify
};

});
parcelRegister("ft4Xb", function(module, exports) {
'use strict';

var $2tQhI = parcelRequire("2tQhI");
var $b42d681bc92b0a1e$require$Buffer = $2tQhI.Buffer;

var $kYdR4 = parcelRequire("kYdR4");

var $eWJZx = parcelRequire("eWJZx");

var $8wxnI = parcelRequire("8wxnI");
var $b42d681bc92b0a1e$require$EC = $8wxnI.ec;

var $dJNni = parcelRequire("dJNni");

var $7ab4s = parcelRequire("7ab4s");

var $5evOG = parcelRequire("5evOG");
var $b42d681bc92b0a1e$var$RSA_PKCS1_PADDING = 1;
function $b42d681bc92b0a1e$var$sign(hash, key, hashType, signType, tag) {
    var priv = $7ab4s(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $b42d681bc92b0a1e$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $b42d681bc92b0a1e$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $b42d681bc92b0a1e$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $b42d681bc92b0a1e$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $eWJZx(pad, priv);
    return out;
}
function $b42d681bc92b0a1e$var$ecSign(hash, priv) {
    var curveId = $5evOG[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $b42d681bc92b0a1e$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $b42d681bc92b0a1e$require$Buffer.from(out.toDER());
}
function $b42d681bc92b0a1e$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $dJNni(0);
    var k;
    var H = $b42d681bc92b0a1e$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $b42d681bc92b0a1e$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $b42d681bc92b0a1e$var$makeKey(q, kv, algo);
        r = $b42d681bc92b0a1e$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $dJNni(0);
        }
    }
    return $b42d681bc92b0a1e$var$toDER(r, s);
}
function $b42d681bc92b0a1e$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $b42d681bc92b0a1e$require$Buffer.from(res);
}
function $b42d681bc92b0a1e$var$getKey(x, q, hash, algo) {
    x = $b42d681bc92b0a1e$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $b42d681bc92b0a1e$require$Buffer.alloc(q.byteLength() - x.length);
        x = $b42d681bc92b0a1e$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $b42d681bc92b0a1e$var$bits2octets(hash, q);
    var v = $b42d681bc92b0a1e$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $b42d681bc92b0a1e$require$Buffer.alloc(hlen);
    k = $kYdR4(algo, k).update(v).update($b42d681bc92b0a1e$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $kYdR4(algo, k).update(v).digest();
    k = $kYdR4(algo, k).update(v).update($b42d681bc92b0a1e$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $kYdR4(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $b42d681bc92b0a1e$var$bits2int(obits, q) {
    var bits = new $dJNni(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $b42d681bc92b0a1e$var$bits2octets(bits, q) {
    bits = $b42d681bc92b0a1e$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $b42d681bc92b0a1e$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $b42d681bc92b0a1e$require$Buffer.alloc(q.byteLength() - out.length);
        out = $b42d681bc92b0a1e$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $b42d681bc92b0a1e$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $b42d681bc92b0a1e$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $kYdR4(algo, kv.k).update(kv.v).digest();
            t = $b42d681bc92b0a1e$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $b42d681bc92b0a1e$var$bits2int(t, q);
        kv.k = $kYdR4(algo, kv.k).update(kv.v).update($b42d681bc92b0a1e$require$Buffer.from([
            0
        ])).digest();
        kv.v = $kYdR4(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $b42d681bc92b0a1e$var$makeR(g, k, p, q) {
    return g.toRed($dJNni.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $b42d681bc92b0a1e$var$sign;
module.exports.getKey = $b42d681bc92b0a1e$var$getKey;
module.exports.makeKey = $b42d681bc92b0a1e$var$makeKey;

});
parcelRegister("eWJZx", function(module, exports) {
'use strict';

var $793FZ = parcelRequire("793FZ");

var $hw9Ml = parcelRequire("hw9Ml");

var $2tQhI = parcelRequire("2tQhI");
var $ae1a28736a9fe3f1$require$Buffer = $2tQhI.Buffer;
function $ae1a28736a9fe3f1$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $793FZ($hw9Ml(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $ae1a28736a9fe3f1$var$blind(priv) {
    var r = $ae1a28736a9fe3f1$var$getr(priv);
    var blinder = r.toRed($793FZ.mont(priv.modulus)).redPow(new $793FZ(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $ae1a28736a9fe3f1$var$crt(msg, priv) {
    var blinds = $ae1a28736a9fe3f1$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $793FZ(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($793FZ.mont(priv.prime1));
    var c2 = blinded.toRed($793FZ.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($ae1a28736a9fe3f1$require$Buffer, 'be', len);
}
$ae1a28736a9fe3f1$var$crt.getr = $ae1a28736a9fe3f1$var$getr;
module.exports = $ae1a28736a9fe3f1$var$crt;

});
parcelRegister("793FZ", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("6N7cq")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) {
            this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            i++;
        }
        // Clear words above the requested width so the result stays below 2 ** width
        for(; i < this.length; i++)this.words[i] = 0;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        if (num === 0) {
            this.length = 1;
            this._normSign();
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.mod.abs();
        var half = num.abs().iushrn(1);
        var r2 = num.words[0] & 1;
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up, away from zero
        var up = new BN(1);
        up.negative = this.negative ^ num.negative;
        return dm.div.iadd(up);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("8wxnI", function(module, exports) {
'use strict';
var $634b34c2e0998d90$var$elliptic = module.exports;

$634b34c2e0998d90$var$elliptic.version = (parcelRequire("5Fbtz")).version;

$634b34c2e0998d90$var$elliptic.utils = (parcelRequire("bPM6h"));

$634b34c2e0998d90$var$elliptic.rand = (parcelRequire("axlTq"));

$634b34c2e0998d90$var$elliptic.curve = (parcelRequire("4mF3e"));

$634b34c2e0998d90$var$elliptic.curves = (parcelRequire("9o3qY"));

// Protocols
$634b34c2e0998d90$var$elliptic.ec = (parcelRequire("7YdFI"));

$634b34c2e0998d90$var$elliptic.eddsa = (parcelRequire("2UigA"));

});
parcelRegister("5Fbtz", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("bPM6h", function(module, exports) {
'use strict';
var $89d9c4d98a8c0b15$var$utils = module.exports;

var $4lSpl = parcelRequire("4lSpl");

var $47cfW = parcelRequire("47cfW");

var $ilJXn = parcelRequire("ilJXn");
$89d9c4d98a8c0b15$var$utils.assert = $47cfW;
$89d9c4d98a8c0b15$var$utils.toArray = $ilJXn.toArray;
$89d9c4d98a8c0b15$var$utils.zero2 = $ilJXn.zero2;
$89d9c4d98a8c0b15$var$utils.toHex = $ilJXn.toHex;
$89d9c4d98a8c0b15$var$utils.encode = $ilJXn.encode;
// Represent num in a w-NAF form
function $89d9c4d98a8c0b15$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$89d9c4d98a8c0b15$var$utils.getNAF = $89d9c4d98a8c0b15$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $89d9c4d98a8c0b15$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$89d9c4d98a8c0b15$var$utils.getJSF = $89d9c4d98a8c0b15$var$getJSF;
function $89d9c4d98a8c0b15$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$89d9c4d98a8c0b15$var$utils.cachedProperty = $89d9c4d98a8c0b15$var$cachedProperty;
function $89d9c4d98a8c0b15$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $89d9c4d98a8c0b15$var$utils.toArray(bytes, 'hex') : bytes;
}
$89d9c4d98a8c0b15$var$utils.parseBytes = $89d9c4d98a8c0b15$var$parseBytes;
function $89d9c4d98a8c0b15$var$intFromLE(bytes) {
    return new $4lSpl(bytes, 'hex', 'le');
}
$89d9c4d98a8c0b15$var$utils.intFromLE = $89d9c4d98a8c0b15$var$intFromLE;

});
parcelRegister("ilJXn", function(module, exports) {
'use strict';
var $d5bdd6333db3d9c6$var$utils = module.exports;
function $d5bdd6333db3d9c6$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$d5bdd6333db3d9c6$var$utils.toArray = $d5bdd6333db3d9c6$var$toArray;
function $d5bdd6333db3d9c6$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$d5bdd6333db3d9c6$var$utils.zero2 = $d5bdd6333db3d9c6$var$zero2;
function $d5bdd6333db3d9c6$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $d5bdd6333db3d9c6$var$zero2(msg[i].toString(16));
    return res;
}
$d5bdd6333db3d9c6$var$utils.toHex = $d5bdd6333db3d9c6$var$toHex;
$d5bdd6333db3d9c6$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $d5bdd6333db3d9c6$var$toHex(arr);
    else return arr;
};

});


parcelRegister("4mF3e", function(module, exports) {
'use strict';
var $32d90f6c0f8027ec$var$curve = module.exports;

$32d90f6c0f8027ec$var$curve.base = (parcelRequire("kNydx"));

$32d90f6c0f8027ec$var$curve.short = (parcelRequire("bccZP"));

$32d90f6c0f8027ec$var$curve.mont = (parcelRequire("lkhQY"));

$32d90f6c0f8027ec$var$curve.edwards = (parcelRequire("1nsY2"));

});
parcelRegister("kNydx", function(module, exports) {
'use strict';

var $4lSpl = parcelRequire("4lSpl");

var $bPM6h = parcelRequire("bPM6h");
var $f242ed165722b494$var$getNAF = $bPM6h.getNAF;
var $f242ed165722b494$var$getJSF = $bPM6h.getJSF;
var $f242ed165722b494$var$assert = $bPM6h.assert;
function $f242ed165722b494$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $4lSpl(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $4lSpl.red(conf.prime) : $4lSpl.mont(this.p);
    // Useful for many curves
    this.zero = new $4lSpl(0).toRed(this.red);
    this.one = new $4lSpl(1).toRed(this.red);
    this.two = new $4lSpl(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $4lSpl(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $f242ed165722b494$var$BaseCurve;
$f242ed165722b494$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$f242ed165722b494$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$f242ed165722b494$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $f242ed165722b494$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $f242ed165722b494$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$f242ed165722b494$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $f242ed165722b494$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $f242ed165722b494$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$f242ed165722b494$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $f242ed165722b494$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $f242ed165722b494$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $f242ed165722b494$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $f242ed165722b494$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$f242ed165722b494$var$BaseCurve.BasePoint = $f242ed165722b494$var$BasePoint;
$f242ed165722b494$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$f242ed165722b494$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$f242ed165722b494$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $bPM6h.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $f242ed165722b494$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $f242ed165722b494$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$f242ed165722b494$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$f242ed165722b494$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$f242ed165722b494$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $bPM6h.encode(this._encode(compact), enc);
};
$f242ed165722b494$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$f242ed165722b494$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$f242ed165722b494$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$f242ed165722b494$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$f242ed165722b494$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$f242ed165722b494$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("bccZP", function(module, exports) {
'use strict';

var $bPM6h = parcelRequire("bPM6h");

var $4lSpl = parcelRequire("4lSpl");

var $27YCQ = parcelRequire("27YCQ");

var $kNydx = parcelRequire("kNydx");
var $826ae58060fd89de$var$assert = $bPM6h.assert;
function $826ae58060fd89de$var$ShortCurve(conf) {
    $kNydx.call(this, 'short', conf);
    this.a = new $4lSpl(conf.a, 16).toRed(this.red);
    this.b = new $4lSpl(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$27YCQ($826ae58060fd89de$var$ShortCurve, $kNydx);
module.exports = $826ae58060fd89de$var$ShortCurve;
$826ae58060fd89de$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $4lSpl(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $4lSpl(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $826ae58060fd89de$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $4lSpl(vec.a, 16),
            b: new $4lSpl(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$826ae58060fd89de$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $4lSpl.mont(num);
    var tinv = new $4lSpl(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $4lSpl(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$826ae58060fd89de$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $4lSpl(1);
    var y1 = new $4lSpl(0);
    var x2 = new $4lSpl(0);
    var y2 = new $4lSpl(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$826ae58060fd89de$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$826ae58060fd89de$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $4lSpl(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$826ae58060fd89de$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$826ae58060fd89de$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $826ae58060fd89de$var$Point(curve, x, y, isRed) {
    $kNydx.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $4lSpl(x, 16);
        this.y = new $4lSpl(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$27YCQ($826ae58060fd89de$var$Point, $kNydx.BasePoint);
$826ae58060fd89de$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $826ae58060fd89de$var$Point(this, x, y, isRed);
};
$826ae58060fd89de$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $826ae58060fd89de$var$Point.fromJSON(this, obj, red);
};
$826ae58060fd89de$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$826ae58060fd89de$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$826ae58060fd89de$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$826ae58060fd89de$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$826ae58060fd89de$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$826ae58060fd89de$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$826ae58060fd89de$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$826ae58060fd89de$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$826ae58060fd89de$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$826ae58060fd89de$var$Point.prototype.mul = function mul(k) {
    k = new $4lSpl(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$826ae58060fd89de$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$826ae58060fd89de$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$826ae58060fd89de$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$826ae58060fd89de$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$826ae58060fd89de$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $826ae58060fd89de$var$JPoint(curve, x, y, z) {
    $kNydx.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $4lSpl(0);
    } else {
        this.x = new $4lSpl(x, 16);
        this.y = new $4lSpl(y, 16);
        this.z = new $4lSpl(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$27YCQ($826ae58060fd89de$var$JPoint, $kNydx.BasePoint);
$826ae58060fd89de$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $826ae58060fd89de$var$JPoint(this, x, y, z);
};
$826ae58060fd89de$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$826ae58060fd89de$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$826ae58060fd89de$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$826ae58060fd89de$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$826ae58060fd89de$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$826ae58060fd89de$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$826ae58060fd89de$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$826ae58060fd89de$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$826ae58060fd89de$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$826ae58060fd89de$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$826ae58060fd89de$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $4lSpl(k, kbase);
    return this.curve._wnafMul(this, k);
};
$826ae58060fd89de$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$826ae58060fd89de$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$826ae58060fd89de$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$826ae58060fd89de$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("lkhQY", function(module, exports) {
'use strict';

var $4lSpl = parcelRequire("4lSpl");

var $27YCQ = parcelRequire("27YCQ");

var $kNydx = parcelRequire("kNydx");

var $bPM6h = parcelRequire("bPM6h");
function $f869509136930a84$var$MontCurve(conf) {
    $kNydx.call(this, 'mont', conf);
    this.a = new $4lSpl(conf.a, 16).toRed(this.red);
    this.b = new $4lSpl(conf.b, 16).toRed(this.red);
    this.i4 = new $4lSpl(4).toRed(this.red).redInvm();
    this.two = new $4lSpl(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$27YCQ($f869509136930a84$var$MontCurve, $kNydx);
module.exports = $f869509136930a84$var$MontCurve;
$f869509136930a84$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $f869509136930a84$var$Point(curve, x, z) {
    $kNydx.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $4lSpl(x, 16);
        this.z = new $4lSpl(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$27YCQ($f869509136930a84$var$Point, $kNydx.BasePoint);
$f869509136930a84$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($bPM6h.toArray(bytes, enc), 1);
};
$f869509136930a84$var$MontCurve.prototype.point = function point(x, z) {
    return new $f869509136930a84$var$Point(this, x, z);
};
$f869509136930a84$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $f869509136930a84$var$Point.fromJSON(this, obj);
};
$f869509136930a84$var$Point.prototype.precompute = function precompute() {
// No-op
};
$f869509136930a84$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$f869509136930a84$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $f869509136930a84$var$Point(curve, obj[0], obj[1] || curve.one);
};
$f869509136930a84$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$f869509136930a84$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$f869509136930a84$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$f869509136930a84$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$f869509136930a84$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$f869509136930a84$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$f869509136930a84$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$f869509136930a84$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$f869509136930a84$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$f869509136930a84$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$f869509136930a84$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("1nsY2", function(module, exports) {
'use strict';

var $bPM6h = parcelRequire("bPM6h");

var $4lSpl = parcelRequire("4lSpl");

var $27YCQ = parcelRequire("27YCQ");

var $kNydx = parcelRequire("kNydx");
var $100e68c37fea99e4$var$assert = $bPM6h.assert;
function $100e68c37fea99e4$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $kNydx.call(this, 'edwards', conf);
    this.a = new $4lSpl(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $4lSpl(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $4lSpl(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $100e68c37fea99e4$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$27YCQ($100e68c37fea99e4$var$EdwardsCurve, $kNydx);
module.exports = $100e68c37fea99e4$var$EdwardsCurve;
$100e68c37fea99e4$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$100e68c37fea99e4$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$100e68c37fea99e4$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$100e68c37fea99e4$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $4lSpl(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$100e68c37fea99e4$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $4lSpl(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$100e68c37fea99e4$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $100e68c37fea99e4$var$Point(curve, x, y, z, t) {
    $kNydx.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $4lSpl(x, 16);
        this.y = new $4lSpl(y, 16);
        this.z = z ? new $4lSpl(z, 16) : this.curve.one;
        this.t = t && new $4lSpl(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$27YCQ($100e68c37fea99e4$var$Point, $kNydx.BasePoint);
$100e68c37fea99e4$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $100e68c37fea99e4$var$Point.fromJSON(this, obj);
};
$100e68c37fea99e4$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $100e68c37fea99e4$var$Point(this, x, y, z, t);
};
$100e68c37fea99e4$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $100e68c37fea99e4$var$Point(curve, obj[0], obj[1], obj[2]);
};
$100e68c37fea99e4$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$100e68c37fea99e4$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$100e68c37fea99e4$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$100e68c37fea99e4$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$100e68c37fea99e4$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$100e68c37fea99e4$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$100e68c37fea99e4$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$100e68c37fea99e4$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$100e68c37fea99e4$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$100e68c37fea99e4$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$100e68c37fea99e4$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$100e68c37fea99e4$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$100e68c37fea99e4$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$100e68c37fea99e4$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$100e68c37fea99e4$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$100e68c37fea99e4$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$100e68c37fea99e4$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$100e68c37fea99e4$var$Point.prototype.toP = $100e68c37fea99e4$var$Point.prototype.normalize;
$100e68c37fea99e4$var$Point.prototype.mixedAdd = $100e68c37fea99e4$var$Point.prototype.add;

});


parcelRegister("9o3qY", function(module, exports) {
'use strict';
var $6d5904def1bb52f3$var$curves = module.exports;

var $7jptm = parcelRequire("7jptm");

var $4mF3e = parcelRequire("4mF3e");

var $bPM6h = parcelRequire("bPM6h");
var $6d5904def1bb52f3$var$assert = $bPM6h.assert;
function $6d5904def1bb52f3$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $4mF3e.short(options);
    else if (options.type === 'edwards') this.curve = new $4mF3e.edwards(options);
    else this.curve = new $4mF3e.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $6d5904def1bb52f3$var$assert(this.g.validate(), 'Invalid curve');
    $6d5904def1bb52f3$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$6d5904def1bb52f3$var$curves.PresetCurve = $6d5904def1bb52f3$var$PresetCurve;
function $6d5904def1bb52f3$var$defineCurve(name, options) {
    Object.defineProperty($6d5904def1bb52f3$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $6d5904def1bb52f3$var$PresetCurve(options);
            Object.defineProperty($6d5904def1bb52f3$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$6d5904def1bb52f3$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $7jptm.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$6d5904def1bb52f3$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $7jptm.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$6d5904def1bb52f3$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $7jptm.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$6d5904def1bb52f3$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $7jptm.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$6d5904def1bb52f3$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $7jptm.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$6d5904def1bb52f3$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $7jptm.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$6d5904def1bb52f3$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $7jptm.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $6d5904def1bb52f3$var$pre;

try {
    $6d5904def1bb52f3$var$pre = (parcelRequire("aFnEd"));
} catch (e) {
    $6d5904def1bb52f3$var$pre = undefined;
}
$6d5904def1bb52f3$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $7jptm.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $6d5904def1bb52f3$var$pre
    ]
});

});
parcelRegister("7jptm", function(module, exports) {
var $552e11137ebd9080$var$hash = module.exports;

$552e11137ebd9080$var$hash.utils = (parcelRequire("2OBCS"));

$552e11137ebd9080$var$hash.common = (parcelRequire("eZDXD"));

$552e11137ebd9080$var$hash.sha = (parcelRequire("8zuAb"));

$552e11137ebd9080$var$hash.ripemd = (parcelRequire("3EeKH"));

$552e11137ebd9080$var$hash.hmac = (parcelRequire("8FUPt"));
// Proxy hash functions to the main object
$552e11137ebd9080$var$hash.sha1 = $552e11137ebd9080$var$hash.sha.sha1;
$552e11137ebd9080$var$hash.sha256 = $552e11137ebd9080$var$hash.sha.sha256;
$552e11137ebd9080$var$hash.sha224 = $552e11137ebd9080$var$hash.sha.sha224;
$552e11137ebd9080$var$hash.sha384 = $552e11137ebd9080$var$hash.sha.sha384;
$552e11137ebd9080$var$hash.sha512 = $552e11137ebd9080$var$hash.sha.sha512;
$552e11137ebd9080$var$hash.ripemd160 = $552e11137ebd9080$var$hash.ripemd.ripemd160;

});
parcelRegister("2OBCS", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $20cd70023a500685$export$69f1b2dcda23c5f8; }, function (v) { return $20cd70023a500685$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $20cd70023a500685$export$45b10814cc054894; }, function (v) { return $20cd70023a500685$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $20cd70023a500685$export$7ea66e3774a60b67; }, function (v) { return $20cd70023a500685$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $20cd70023a500685$export$34a52f00f601f6f1; }, function (v) { return $20cd70023a500685$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $20cd70023a500685$export$812b0cbd5e8a72ab; }, function (v) { return $20cd70023a500685$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $20cd70023a500685$export$f24f9e11d63bb314; }, function (v) { return $20cd70023a500685$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $20cd70023a500685$export$b71357c7e07ca1f1; }, function (v) { return $20cd70023a500685$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $20cd70023a500685$export$2e58a4b541fdcbe8; }, function (v) { return $20cd70023a500685$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $20cd70023a500685$export$183b950bde9faab8; }, function (v) { return $20cd70023a500685$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $20cd70023a500685$export$4785c77169fea59e; }, function (v) { return $20cd70023a500685$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $20cd70023a500685$export$242a185dfcffac5b; }, function (v) { return $20cd70023a500685$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $20cd70023a500685$export$58c04ae0ae31877d; }, function (v) { return $20cd70023a500685$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $20cd70023a500685$export$d058ca695f8c6f11; }, function (v) { return $20cd70023a500685$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $20cd70023a500685$export$a1efd7fc3e986367; }, function (v) { return $20cd70023a500685$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $20cd70023a500685$export$bbfea4a2b5abaab4; }, function (v) { return $20cd70023a500685$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $20cd70023a500685$export$97ad4afc7de86152; }, function (v) { return $20cd70023a500685$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $20cd70023a500685$export$ce4673d9a79f6a4b; }, function (v) { return $20cd70023a500685$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $20cd70023a500685$export$786cc99fc6eedc0b; }, function (v) { return $20cd70023a500685$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $20cd70023a500685$export$45c59b9a1848dd0; }, function (v) { return $20cd70023a500685$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $20cd70023a500685$export$50d8f613e76d3034; }, function (v) { return $20cd70023a500685$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $20cd70023a500685$export$b8e83683c60ee162; }, function (v) { return $20cd70023a500685$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $20cd70023a500685$export$aeeb51790d1bcc4a; }, function (v) { return $20cd70023a500685$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $20cd70023a500685$export$bb7c616f719ad9c; }, function (v) { return $20cd70023a500685$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $20cd70023a500685$export$4d63290824f9d7df; }, function (v) { return $20cd70023a500685$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $20cd70023a500685$export$2f64ceb90ef28ea1; }, function (v) { return $20cd70023a500685$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $20cd70023a500685$export$8d2089d465f6d10d; }, function (v) { return $20cd70023a500685$export$8d2089d465f6d10d = v; });
var $20cd70023a500685$export$69f1b2dcda23c5f8;
var $20cd70023a500685$export$45b10814cc054894;
var $20cd70023a500685$export$7ea66e3774a60b67;
var $20cd70023a500685$export$34a52f00f601f6f1;
var $20cd70023a500685$export$812b0cbd5e8a72ab;
var $20cd70023a500685$export$f24f9e11d63bb314;
var $20cd70023a500685$export$b71357c7e07ca1f1;
var $20cd70023a500685$export$2e58a4b541fdcbe8;
var $20cd70023a500685$export$183b950bde9faab8;
var $20cd70023a500685$export$4785c77169fea59e;
var $20cd70023a500685$export$242a185dfcffac5b;
var $20cd70023a500685$export$58c04ae0ae31877d;
var $20cd70023a500685$export$d058ca695f8c6f11;
var $20cd70023a500685$export$a1efd7fc3e986367;
var $20cd70023a500685$export$bbfea4a2b5abaab4;
var $20cd70023a500685$export$97ad4afc7de86152;
var $20cd70023a500685$export$ce4673d9a79f6a4b;
var $20cd70023a500685$export$786cc99fc6eedc0b;
var $20cd70023a500685$export$45c59b9a1848dd0;
var $20cd70023a500685$export$50d8f613e76d3034;
var $20cd70023a500685$export$b8e83683c60ee162;
var $20cd70023a500685$export$aeeb51790d1bcc4a;
var $20cd70023a500685$export$bb7c616f719ad9c;
var $20cd70023a500685$export$4d63290824f9d7df;
var $20cd70023a500685$export$2f64ceb90ef28ea1;
var $20cd70023a500685$export$8d2089d465f6d10d;
'use strict';

var $47cfW = parcelRequire("47cfW");

var $27YCQ = parcelRequire("27YCQ");
$20cd70023a500685$export$69f1b2dcda23c5f8 = $27YCQ;
function $20cd70023a500685$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $20cd70023a500685$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($20cd70023a500685$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$20cd70023a500685$export$45b10814cc054894 = $20cd70023a500685$var$toArray;
function $20cd70023a500685$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $20cd70023a500685$var$zero2(msg[i].toString(16));
    return res;
}
$20cd70023a500685$export$7ea66e3774a60b67 = $20cd70023a500685$var$toHex;
function $20cd70023a500685$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$20cd70023a500685$export$34a52f00f601f6f1 = $20cd70023a500685$var$htonl;
function $20cd70023a500685$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $20cd70023a500685$var$htonl(w);
        res += $20cd70023a500685$var$zero8(w.toString(16));
    }
    return res;
}
$20cd70023a500685$export$812b0cbd5e8a72ab = $20cd70023a500685$var$toHex32;
function $20cd70023a500685$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$20cd70023a500685$export$f24f9e11d63bb314 = $20cd70023a500685$var$zero2;
function $20cd70023a500685$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$20cd70023a500685$export$b71357c7e07ca1f1 = $20cd70023a500685$var$zero8;
function $20cd70023a500685$var$join32(msg, start, end, endian) {
    var len = end - start;
    $47cfW(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$20cd70023a500685$export$2e58a4b541fdcbe8 = $20cd70023a500685$var$join32;
function $20cd70023a500685$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$20cd70023a500685$export$183b950bde9faab8 = $20cd70023a500685$var$split32;
function $20cd70023a500685$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$20cd70023a500685$export$4785c77169fea59e = $20cd70023a500685$var$rotr32;
function $20cd70023a500685$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$20cd70023a500685$export$242a185dfcffac5b = $20cd70023a500685$var$rotl32;
function $20cd70023a500685$var$sum32(a, b) {
    return a + b >>> 0;
}
$20cd70023a500685$export$58c04ae0ae31877d = $20cd70023a500685$var$sum32;
function $20cd70023a500685$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$20cd70023a500685$export$d058ca695f8c6f11 = $20cd70023a500685$var$sum32_3;
function $20cd70023a500685$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$20cd70023a500685$export$a1efd7fc3e986367 = $20cd70023a500685$var$sum32_4;
function $20cd70023a500685$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$20cd70023a500685$export$bbfea4a2b5abaab4 = $20cd70023a500685$var$sum32_5;
function $20cd70023a500685$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$20cd70023a500685$export$97ad4afc7de86152 = $20cd70023a500685$var$sum64;
function $20cd70023a500685$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$20cd70023a500685$export$ce4673d9a79f6a4b = $20cd70023a500685$var$sum64_hi;
function $20cd70023a500685$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$20cd70023a500685$export$786cc99fc6eedc0b = $20cd70023a500685$var$sum64_lo;
function $20cd70023a500685$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$20cd70023a500685$export$45c59b9a1848dd0 = $20cd70023a500685$var$sum64_4_hi;
function $20cd70023a500685$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$20cd70023a500685$export$50d8f613e76d3034 = $20cd70023a500685$var$sum64_4_lo;
function $20cd70023a500685$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$20cd70023a500685$export$b8e83683c60ee162 = $20cd70023a500685$var$sum64_5_hi;
function $20cd70023a500685$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$20cd70023a500685$export$aeeb51790d1bcc4a = $20cd70023a500685$var$sum64_5_lo;
function $20cd70023a500685$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$20cd70023a500685$export$bb7c616f719ad9c = $20cd70023a500685$var$rotr64_hi;
function $20cd70023a500685$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$20cd70023a500685$export$4d63290824f9d7df = $20cd70023a500685$var$rotr64_lo;
function $20cd70023a500685$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$20cd70023a500685$export$2f64ceb90ef28ea1 = $20cd70023a500685$var$shr64_hi;
function $20cd70023a500685$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$20cd70023a500685$export$8d2089d465f6d10d = $20cd70023a500685$var$shr64_lo;

});

parcelRegister("eZDXD", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $aea5c291ce22ff6f$export$8687658379b577e6; }, function (v) { return $aea5c291ce22ff6f$export$8687658379b577e6 = v; });
var $aea5c291ce22ff6f$export$8687658379b577e6;
'use strict';

var $2OBCS = parcelRequire("2OBCS");

var $47cfW = parcelRequire("47cfW");
function $aea5c291ce22ff6f$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$aea5c291ce22ff6f$export$8687658379b577e6 = $aea5c291ce22ff6f$var$BlockHash;
$aea5c291ce22ff6f$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $2OBCS.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $2OBCS.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$aea5c291ce22ff6f$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $47cfW(this.pending === null);
    return this._digest(enc);
};
$aea5c291ce22ff6f$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("8zuAb", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $63d950ab429481b7$export$5091bdda49ba90f5; }, function (v) { return $63d950ab429481b7$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $63d950ab429481b7$export$97b70509d4e397ea; }, function (v) { return $63d950ab429481b7$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $63d950ab429481b7$export$bced8d2aada2d1c9; }, function (v) { return $63d950ab429481b7$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $63d950ab429481b7$export$612d47d55dedde45; }, function (v) { return $63d950ab429481b7$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $63d950ab429481b7$export$a888d2532e6dc7bb; }, function (v) { return $63d950ab429481b7$export$a888d2532e6dc7bb = v; });
var $63d950ab429481b7$export$5091bdda49ba90f5;
var $63d950ab429481b7$export$97b70509d4e397ea;
var $63d950ab429481b7$export$bced8d2aada2d1c9;
var $63d950ab429481b7$export$612d47d55dedde45;
var $63d950ab429481b7$export$a888d2532e6dc7bb;
'use strict';

$63d950ab429481b7$export$5091bdda49ba90f5 = (parcelRequire("iVgpx"));

$63d950ab429481b7$export$97b70509d4e397ea = (parcelRequire("1KwWS"));

$63d950ab429481b7$export$bced8d2aada2d1c9 = (parcelRequire("3JoUH"));

$63d950ab429481b7$export$612d47d55dedde45 = (parcelRequire("3zXJW"));

$63d950ab429481b7$export$a888d2532e6dc7bb = (parcelRequire("gUWkw"));

});
parcelRegister("iVgpx", function(module, exports) {
'use strict';

var $2OBCS = parcelRequire("2OBCS");

var $eZDXD = parcelRequire("eZDXD");

var $8gg6Y = parcelRequire("8gg6Y");
var $dc6a47bca9400e3d$var$rotl32 = $2OBCS.rotl32;
var $dc6a47bca9400e3d$var$sum32 = $2OBCS.sum32;
var $dc6a47bca9400e3d$var$sum32_5 = $2OBCS.sum32_5;
var $dc6a47bca9400e3d$var$ft_1 = $8gg6Y.ft_1;
var $dc6a47bca9400e3d$var$BlockHash = $eZDXD.BlockHash;
var $dc6a47bca9400e3d$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $dc6a47bca9400e3d$var$SHA1() {
    if (!(this instanceof $dc6a47bca9400e3d$var$SHA1)) return new $dc6a47bca9400e3d$var$SHA1();
    $dc6a47bca9400e3d$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$2OBCS.inherits($dc6a47bca9400e3d$var$SHA1, $dc6a47bca9400e3d$var$BlockHash);
module.exports = $dc6a47bca9400e3d$var$SHA1;
$dc6a47bca9400e3d$var$SHA1.blockSize = 512;
$dc6a47bca9400e3d$var$SHA1.outSize = 160;
$dc6a47bca9400e3d$var$SHA1.hmacStrength = 80;
$dc6a47bca9400e3d$var$SHA1.padLength = 64;
$dc6a47bca9400e3d$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $dc6a47bca9400e3d$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $dc6a47bca9400e3d$var$sum32_5($dc6a47bca9400e3d$var$rotl32(a, 5), $dc6a47bca9400e3d$var$ft_1(s, b, c, d), e, W[i], $dc6a47bca9400e3d$var$sha1_K[s]);
        e = d;
        d = c;
        c = $dc6a47bca9400e3d$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $dc6a47bca9400e3d$var$sum32(this.h[0], a);
    this.h[1] = $dc6a47bca9400e3d$var$sum32(this.h[1], b);
    this.h[2] = $dc6a47bca9400e3d$var$sum32(this.h[2], c);
    this.h[3] = $dc6a47bca9400e3d$var$sum32(this.h[3], d);
    this.h[4] = $dc6a47bca9400e3d$var$sum32(this.h[4], e);
};
$dc6a47bca9400e3d$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $2OBCS.toHex32(this.h, 'big');
    else return $2OBCS.split32(this.h, 'big');
};

});
parcelRegister("8gg6Y", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $603c50c6a543eb1a$export$5a92649d7ddb9f63; }, function (v) { return $603c50c6a543eb1a$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $603c50c6a543eb1a$export$c6d0d020c3a6269; }, function (v) { return $603c50c6a543eb1a$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $603c50c6a543eb1a$export$eb90c27fca05f956; }, function (v) { return $603c50c6a543eb1a$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $603c50c6a543eb1a$export$14a4a98e063b1999; }, function (v) { return $603c50c6a543eb1a$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $603c50c6a543eb1a$export$d20cecfa1564c686; }, function (v) { return $603c50c6a543eb1a$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $603c50c6a543eb1a$export$44fd472a12fc6db; }, function (v) { return $603c50c6a543eb1a$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $603c50c6a543eb1a$export$1ed238bb6ea1dd47; }, function (v) { return $603c50c6a543eb1a$export$1ed238bb6ea1dd47 = v; });
var $603c50c6a543eb1a$export$5a92649d7ddb9f63;
var $603c50c6a543eb1a$export$c6d0d020c3a6269;
var $603c50c6a543eb1a$export$eb90c27fca05f956;
var $603c50c6a543eb1a$export$cc992891a14496a1;
var $603c50c6a543eb1a$export$14a4a98e063b1999;
var $603c50c6a543eb1a$export$d20cecfa1564c686;
var $603c50c6a543eb1a$export$44fd472a12fc6db;
var $603c50c6a543eb1a$export$1ed238bb6ea1dd47;
'use strict';

var $2OBCS = parcelRequire("2OBCS");
var $603c50c6a543eb1a$var$rotr32 = $2OBCS.rotr32;
function $603c50c6a543eb1a$var$ft_1(s, x, y, z) {
    if (s === 0) return $603c50c6a543eb1a$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $603c50c6a543eb1a$var$p32(x, y, z);
    if (s === 2) return $603c50c6a543eb1a$var$maj32(x, y, z);
}
$603c50c6a543eb1a$export$5a92649d7ddb9f63 = $603c50c6a543eb1a$var$ft_1;
function $603c50c6a543eb1a$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$603c50c6a543eb1a$export$c6d0d020c3a6269 = $603c50c6a543eb1a$var$ch32;
function $603c50c6a543eb1a$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$603c50c6a543eb1a$export$eb90c27fca05f956 = $603c50c6a543eb1a$var$maj32;
function $603c50c6a543eb1a$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$603c50c6a543eb1a$export$cc992891a14496a1 = $603c50c6a543eb1a$var$p32;
function $603c50c6a543eb1a$var$s0_256(x) {
    return $603c50c6a543eb1a$var$rotr32(x, 2) ^ $603c50c6a543eb1a$var$rotr32(x, 13) ^ $603c50c6a543eb1a$var$rotr32(x, 22);
}
$603c50c6a543eb1a$export$14a4a98e063b1999 = $603c50c6a543eb1a$var$s0_256;
function $603c50c6a543eb1a$var$s1_256(x) {
    return $603c50c6a543eb1a$var$rotr32(x, 6) ^ $603c50c6a543eb1a$var$rotr32(x, 11) ^ $603c50c6a543eb1a$var$rotr32(x, 25);
}
$603c50c6a543eb1a$export$d20cecfa1564c686 = $603c50c6a543eb1a$var$s1_256;
function $603c50c6a543eb1a$var$g0_256(x) {
    return $603c50c6a543eb1a$var$rotr32(x, 7) ^ $603c50c6a543eb1a$var$rotr32(x, 18) ^ x >>> 3;
}
$603c50c6a543eb1a$export$44fd472a12fc6db = $603c50c6a543eb1a$var$g0_256;
function $603c50c6a543eb1a$var$g1_256(x) {
    return $603c50c6a543eb1a$var$rotr32(x, 17) ^ $603c50c6a543eb1a$var$rotr32(x, 19) ^ x >>> 10;
}
$603c50c6a543eb1a$export$1ed238bb6ea1dd47 = $603c50c6a543eb1a$var$g1_256;

});


parcelRegister("1KwWS", function(module, exports) {
'use strict';

var $2OBCS = parcelRequire("2OBCS");

var $3JoUH = parcelRequire("3JoUH");
function $1463a53c89555b4d$var$SHA224() {
    if (!(this instanceof $1463a53c89555b4d$var$SHA224)) return new $1463a53c89555b4d$var$SHA224();
    $3JoUH.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$2OBCS.inherits($1463a53c89555b4d$var$SHA224, $3JoUH);
module.exports = $1463a53c89555b4d$var$SHA224;
$1463a53c89555b4d$var$SHA224.blockSize = 512;
$1463a53c89555b4d$var$SHA224.outSize = 224;
$1463a53c89555b4d$var$SHA224.hmacStrength = 192;
$1463a53c89555b4d$var$SHA224.padLength = 64;
$1463a53c89555b4d$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $2OBCS.toHex32(this.h.slice(0, 7), 'big');
    else return $2OBCS.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("3JoUH", function(module, exports) {
'use strict';

var $2OBCS = parcelRequire("2OBCS");

var $eZDXD = parcelRequire("eZDXD");

var $8gg6Y = parcelRequire("8gg6Y");

var $47cfW = parcelRequire("47cfW");
var $2b78e663e4feaf8c$var$sum32 = $2OBCS.sum32;
var $2b78e663e4feaf8c$var$sum32_4 = $2OBCS.sum32_4;
var $2b78e663e4feaf8c$var$sum32_5 = $2OBCS.sum32_5;
var $2b78e663e4feaf8c$var$ch32 = $8gg6Y.ch32;
var $2b78e663e4feaf8c$var$maj32 = $8gg6Y.maj32;
var $2b78e663e4feaf8c$var$s0_256 = $8gg6Y.s0_256;
var $2b78e663e4feaf8c$var$s1_256 = $8gg6Y.s1_256;
var $2b78e663e4feaf8c$var$g0_256 = $8gg6Y.g0_256;
var $2b78e663e4feaf8c$var$g1_256 = $8gg6Y.g1_256;
var $2b78e663e4feaf8c$var$BlockHash = $eZDXD.BlockHash;
var $2b78e663e4feaf8c$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $2b78e663e4feaf8c$var$SHA256() {
    if (!(this instanceof $2b78e663e4feaf8c$var$SHA256)) return new $2b78e663e4feaf8c$var$SHA256();
    $2b78e663e4feaf8c$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $2b78e663e4feaf8c$var$sha256_K;
    this.W = new Array(64);
}
$2OBCS.inherits($2b78e663e4feaf8c$var$SHA256, $2b78e663e4feaf8c$var$BlockHash);
module.exports = $2b78e663e4feaf8c$var$SHA256;
$2b78e663e4feaf8c$var$SHA256.blockSize = 512;
$2b78e663e4feaf8c$var$SHA256.outSize = 256;
$2b78e663e4feaf8c$var$SHA256.hmacStrength = 192;
$2b78e663e4feaf8c$var$SHA256.padLength = 64;
$2b78e663e4feaf8c$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $2b78e663e4feaf8c$var$sum32_4($2b78e663e4feaf8c$var$g1_256(W[i - 2]), W[i - 7], $2b78e663e4feaf8c$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $47cfW(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $2b78e663e4feaf8c$var$sum32_5(h, $2b78e663e4feaf8c$var$s1_256(e), $2b78e663e4feaf8c$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $2b78e663e4feaf8c$var$sum32($2b78e663e4feaf8c$var$s0_256(a), $2b78e663e4feaf8c$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $2b78e663e4feaf8c$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $2b78e663e4feaf8c$var$sum32(T1, T2);
    }
    this.h[0] = $2b78e663e4feaf8c$var$sum32(this.h[0], a);
    this.h[1] = $2b78e663e4feaf8c$var$sum32(this.h[1], b);
    this.h[2] = $2b78e663e4feaf8c$var$sum32(this.h[2], c);
    this.h[3] = $2b78e663e4feaf8c$var$sum32(this.h[3], d);
    this.h[4] = $2b78e663e4feaf8c$var$sum32(this.h[4], e);
    this.h[5] = $2b78e663e4feaf8c$var$sum32(this.h[5], f);
    this.h[6] = $2b78e663e4feaf8c$var$sum32(this.h[6], g);
    this.h[7] = $2b78e663e4feaf8c$var$sum32(this.h[7], h);
};
$2b78e663e4feaf8c$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $2OBCS.toHex32(this.h, 'big');
    else return $2OBCS.split32(this.h, 'big');
};

});


parcelRegister("3zXJW", function(module, exports) {
'use strict';

var $2OBCS = parcelRequire("2OBCS");

var $gUWkw = parcelRequire("gUWkw");
function $29b2fb1d2346a808$var$SHA384() {
    if (!(this instanceof $29b2fb1d2346a808$var$SHA384)) return new $29b2fb1d2346a808$var$SHA384();
    $gUWkw.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$2OBCS.inherits($29b2fb1d2346a808$var$SHA384, $gUWkw);
module.exports = $29b2fb1d2346a808$var$SHA384;
$29b2fb1d2346a808$var$SHA384.blockSize = 1024;
$29b2fb1d2346a808$var$SHA384.outSize = 384;
$29b2fb1d2346a808$var$SHA384.hmacStrength = 192;
$29b2fb1d2346a808$var$SHA384.padLength = 128;
$29b2fb1d2346a808$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $2OBCS.toHex32(this.h.slice(0, 12), 'big');
    else return $2OBCS.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("gUWkw", function(module, exports) {
'use strict';

var $2OBCS = parcelRequire("2OBCS");

var $eZDXD = parcelRequire("eZDXD");

var $47cfW = parcelRequire("47cfW");
var $c50f1f6852eebad3$var$rotr64_hi = $2OBCS.rotr64_hi;
var $c50f1f6852eebad3$var$rotr64_lo = $2OBCS.rotr64_lo;
var $c50f1f6852eebad3$var$shr64_hi = $2OBCS.shr64_hi;
var $c50f1f6852eebad3$var$shr64_lo = $2OBCS.shr64_lo;
var $c50f1f6852eebad3$var$sum64 = $2OBCS.sum64;
var $c50f1f6852eebad3$var$sum64_hi = $2OBCS.sum64_hi;
var $c50f1f6852eebad3$var$sum64_lo = $2OBCS.sum64_lo;
var $c50f1f6852eebad3$var$sum64_4_hi = $2OBCS.sum64_4_hi;
var $c50f1f6852eebad3$var$sum64_4_lo = $2OBCS.sum64_4_lo;
var $c50f1f6852eebad3$var$sum64_5_hi = $2OBCS.sum64_5_hi;
var $c50f1f6852eebad3$var$sum64_5_lo = $2OBCS.sum64_5_lo;
var $c50f1f6852eebad3$var$BlockHash = $eZDXD.BlockHash;
var $c50f1f6852eebad3$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $c50f1f6852eebad3$var$SHA512() {
    if (!(this instanceof $c50f1f6852eebad3$var$SHA512)) return new $c50f1f6852eebad3$var$SHA512();
    $c50f1f6852eebad3$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $c50f1f6852eebad3$var$sha512_K;
    this.W = new Array(160);
}
$2OBCS.inherits($c50f1f6852eebad3$var$SHA512, $c50f1f6852eebad3$var$BlockHash);
module.exports = $c50f1f6852eebad3$var$SHA512;
$c50f1f6852eebad3$var$SHA512.blockSize = 1024;
$c50f1f6852eebad3$var$SHA512.outSize = 512;
$c50f1f6852eebad3$var$SHA512.hmacStrength = 192;
$c50f1f6852eebad3$var$SHA512.padLength = 128;
$c50f1f6852eebad3$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $c50f1f6852eebad3$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $c50f1f6852eebad3$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $c50f1f6852eebad3$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $c50f1f6852eebad3$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $c50f1f6852eebad3$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $c50f1f6852eebad3$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$c50f1f6852eebad3$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $47cfW(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $c50f1f6852eebad3$var$s1_512_hi(eh, el);
        var c1_lo = $c50f1f6852eebad3$var$s1_512_lo(eh, el);
        var c2_hi = $c50f1f6852eebad3$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $c50f1f6852eebad3$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $c50f1f6852eebad3$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $c50f1f6852eebad3$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $c50f1f6852eebad3$var$s0_512_hi(ah, al);
        c0_lo = $c50f1f6852eebad3$var$s0_512_lo(ah, al);
        c1_hi = $c50f1f6852eebad3$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $c50f1f6852eebad3$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $c50f1f6852eebad3$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $c50f1f6852eebad3$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $c50f1f6852eebad3$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $c50f1f6852eebad3$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $c50f1f6852eebad3$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $c50f1f6852eebad3$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $c50f1f6852eebad3$var$sum64(this.h, 0, ah, al);
    $c50f1f6852eebad3$var$sum64(this.h, 2, bh, bl);
    $c50f1f6852eebad3$var$sum64(this.h, 4, ch, cl);
    $c50f1f6852eebad3$var$sum64(this.h, 6, dh, dl);
    $c50f1f6852eebad3$var$sum64(this.h, 8, eh, el);
    $c50f1f6852eebad3$var$sum64(this.h, 10, fh, fl);
    $c50f1f6852eebad3$var$sum64(this.h, 12, gh, gl);
    $c50f1f6852eebad3$var$sum64(this.h, 14, hh, hl);
};
$c50f1f6852eebad3$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $2OBCS.toHex32(this.h, 'big');
    else return $2OBCS.split32(this.h, 'big');
};
function $c50f1f6852eebad3$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $c50f1f6852eebad3$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $c50f1f6852eebad3$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $c50f1f6852eebad3$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $c50f1f6852eebad3$var$s0_512_hi(xh, xl) {
    var c0_hi = $c50f1f6852eebad3$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $c50f1f6852eebad3$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $c50f1f6852eebad3$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $c50f1f6852eebad3$var$s0_512_lo(xh, xl) {
    var c0_lo = $c50f1f6852eebad3$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $c50f1f6852eebad3$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $c50f1f6852eebad3$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $c50f1f6852eebad3$var$s1_512_hi(xh, xl) {
    var c0_hi = $c50f1f6852eebad3$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $c50f1f6852eebad3$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $c50f1f6852eebad3$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $c50f1f6852eebad3$var$s1_512_lo(xh, xl) {
    var c0_lo = $c50f1f6852eebad3$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $c50f1f6852eebad3$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $c50f1f6852eebad3$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $c50f1f6852eebad3$var$g0_512_hi(xh, xl) {
    var c0_hi = $c50f1f6852eebad3$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $c50f1f6852eebad3$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $c50f1f6852eebad3$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $c50f1f6852eebad3$var$g0_512_lo(xh, xl) {
    var c0_lo = $c50f1f6852eebad3$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $c50f1f6852eebad3$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $c50f1f6852eebad3$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $c50f1f6852eebad3$var$g1_512_hi(xh, xl) {
    var c0_hi = $c50f1f6852eebad3$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $c50f1f6852eebad3$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $c50f1f6852eebad3$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $c50f1f6852eebad3$var$g1_512_lo(xh, xl) {
    var c0_lo = $c50f1f6852eebad3$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $c50f1f6852eebad3$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $c50f1f6852eebad3$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("3EeKH", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $2a808d021865a0a8$export$d1cea0ee4e3f0d3e; }, function (v) { return $2a808d021865a0a8$export$d1cea0ee4e3f0d3e = v; });
var $2a808d021865a0a8$export$d1cea0ee4e3f0d3e;
'use strict';

var $2OBCS = parcelRequire("2OBCS");

var $eZDXD = parcelRequire("eZDXD");
var $2a808d021865a0a8$var$rotl32 = $2OBCS.rotl32;
var $2a808d021865a0a8$var$sum32 = $2OBCS.sum32;
var $2a808d021865a0a8$var$sum32_3 = $2OBCS.sum32_3;
var $2a808d021865a0a8$var$sum32_4 = $2OBCS.sum32_4;
var $2a808d021865a0a8$var$BlockHash = $eZDXD.BlockHash;
function $2a808d021865a0a8$var$RIPEMD160() {
    if (!(this instanceof $2a808d021865a0a8$var$RIPEMD160)) return new $2a808d021865a0a8$var$RIPEMD160();
    $2a808d021865a0a8$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$2OBCS.inherits($2a808d021865a0a8$var$RIPEMD160, $2a808d021865a0a8$var$BlockHash);
$2a808d021865a0a8$export$d1cea0ee4e3f0d3e = $2a808d021865a0a8$var$RIPEMD160;
$2a808d021865a0a8$var$RIPEMD160.blockSize = 512;
$2a808d021865a0a8$var$RIPEMD160.outSize = 160;
$2a808d021865a0a8$var$RIPEMD160.hmacStrength = 192;
$2a808d021865a0a8$var$RIPEMD160.padLength = 64;
$2a808d021865a0a8$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $2a808d021865a0a8$var$sum32($2a808d021865a0a8$var$rotl32($2a808d021865a0a8$var$sum32_4(A, $2a808d021865a0a8$var$f(j, B, C, D), msg[$2a808d021865a0a8$var$r[j] + start], $2a808d021865a0a8$var$K(j)), $2a808d021865a0a8$var$s[j]), E);
        A = E;
        E = D;
        D = $2a808d021865a0a8$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $2a808d021865a0a8$var$sum32($2a808d021865a0a8$var$rotl32($2a808d021865a0a8$var$sum32_4(Ah, $2a808d021865a0a8$var$f(79 - j, Bh, Ch, Dh), msg[$2a808d021865a0a8$var$rh[j] + start], $2a808d021865a0a8$var$Kh(j)), $2a808d021865a0a8$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $2a808d021865a0a8$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $2a808d021865a0a8$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $2a808d021865a0a8$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $2a808d021865a0a8$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $2a808d021865a0a8$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $2a808d021865a0a8$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$2a808d021865a0a8$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $2OBCS.toHex32(this.h, 'little');
    else return $2OBCS.split32(this.h, 'little');
};
function $2a808d021865a0a8$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $2a808d021865a0a8$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $2a808d021865a0a8$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $2a808d021865a0a8$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $2a808d021865a0a8$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $2a808d021865a0a8$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $2a808d021865a0a8$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("8FUPt", function(module, exports) {
'use strict';

var $2OBCS = parcelRequire("2OBCS");

var $47cfW = parcelRequire("47cfW");
function $650e3c3058b5133d$var$Hmac(hash, key, enc) {
    if (!(this instanceof $650e3c3058b5133d$var$Hmac)) return new $650e3c3058b5133d$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($2OBCS.toArray(key, enc));
}
module.exports = $650e3c3058b5133d$var$Hmac;
$650e3c3058b5133d$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $47cfW(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$650e3c3058b5133d$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$650e3c3058b5133d$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("aFnEd", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("7YdFI", function(module, exports) {
'use strict';

var $4lSpl = parcelRequire("4lSpl");

var $360gR = parcelRequire("360gR");

var $bPM6h = parcelRequire("bPM6h");

var $9o3qY = parcelRequire("9o3qY");

var $axlTq = parcelRequire("axlTq");
var $5cd8bdf0c8884164$var$assert = $bPM6h.assert;

var $hQXWz = parcelRequire("hQXWz");

var $hYQc0 = parcelRequire("hYQc0");
function $5cd8bdf0c8884164$var$EC(options) {
    if (!(this instanceof $5cd8bdf0c8884164$var$EC)) return new $5cd8bdf0c8884164$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $5cd8bdf0c8884164$var$assert(Object.prototype.hasOwnProperty.call($9o3qY, options), 'Unknown curve ' + options);
        options = $9o3qY[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $9o3qY.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $5cd8bdf0c8884164$var$EC;
$5cd8bdf0c8884164$var$EC.prototype.keyPair = function keyPair(options) {
    return new $hQXWz(this, options);
};
$5cd8bdf0c8884164$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $hQXWz.fromPrivate(this, priv, enc);
};
$5cd8bdf0c8884164$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $hQXWz.fromPublic(this, pub, enc);
};
$5cd8bdf0c8884164$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $360gR({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $axlTq(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $4lSpl(2));
    for(;;){
        var priv = new $4lSpl(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$5cd8bdf0c8884164$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($4lSpl.isBN(msg) || typeof msg === 'number') {
        msg = new $4lSpl(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $4lSpl(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $4lSpl(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$5cd8bdf0c8884164$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$4lSpl.isBN(msg)) {
        $5cd8bdf0c8884164$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $5cd8bdf0c8884164$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$5cd8bdf0c8884164$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $5cd8bdf0c8884164$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $5cd8bdf0c8884164$var$assert(new $4lSpl(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $360gR({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $4lSpl(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $4lSpl(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $hYQc0({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$5cd8bdf0c8884164$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $hYQc0(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$5cd8bdf0c8884164$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $5cd8bdf0c8884164$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $hYQc0(signature, enc);
    var n = this.n;
    var e = new $4lSpl(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$5cd8bdf0c8884164$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $hYQc0(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("360gR", function(module, exports) {
'use strict';

var $7jptm = parcelRequire("7jptm");

var $ilJXn = parcelRequire("ilJXn");

var $47cfW = parcelRequire("47cfW");
function $241224720f85a5ff$var$HmacDRBG(options) {
    if (!(this instanceof $241224720f85a5ff$var$HmacDRBG)) return new $241224720f85a5ff$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $ilJXn.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $ilJXn.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $ilJXn.toArray(options.pers, options.persEnc || 'hex');
    $47cfW(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $241224720f85a5ff$var$HmacDRBG;
$241224720f85a5ff$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$241224720f85a5ff$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $7jptm.hmac(this.hash, this.K);
};
$241224720f85a5ff$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$241224720f85a5ff$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $ilJXn.toArray(entropy, entropyEnc);
    add = $ilJXn.toArray(add, addEnc);
    $47cfW(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$241224720f85a5ff$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $ilJXn.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $ilJXn.encode(res, enc);
};

});

parcelRegister("hQXWz", function(module, exports) {
'use strict';

var $4lSpl = parcelRequire("4lSpl");

var $bPM6h = parcelRequire("bPM6h");
var $cff5ca907e919e5f$var$assert = $bPM6h.assert;
function $cff5ca907e919e5f$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $cff5ca907e919e5f$var$KeyPair;
$cff5ca907e919e5f$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $cff5ca907e919e5f$var$KeyPair) return pub;
    return new $cff5ca907e919e5f$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$cff5ca907e919e5f$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $cff5ca907e919e5f$var$KeyPair) return priv;
    return new $cff5ca907e919e5f$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$cff5ca907e919e5f$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$cff5ca907e919e5f$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$cff5ca907e919e5f$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$cff5ca907e919e5f$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $4lSpl(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$cff5ca907e919e5f$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $cff5ca907e919e5f$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $cff5ca907e919e5f$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$cff5ca907e919e5f$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $cff5ca907e919e5f$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$cff5ca907e919e5f$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$cff5ca907e919e5f$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$cff5ca907e919e5f$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("hYQc0", function(module, exports) {
'use strict';

var $4lSpl = parcelRequire("4lSpl");

var $bPM6h = parcelRequire("bPM6h");
var $d17086a4a760b553$var$assert = $bPM6h.assert;
function $d17086a4a760b553$var$Signature(options, enc) {
    if (options instanceof $d17086a4a760b553$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $d17086a4a760b553$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $4lSpl(options.r, 16);
    this.s = new $4lSpl(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $d17086a4a760b553$var$Signature;
function $d17086a4a760b553$var$Position() {
    this.place = 0;
}
function $d17086a4a760b553$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $d17086a4a760b553$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$d17086a4a760b553$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $bPM6h.toArray(data, enc);
    var p = new $d17086a4a760b553$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $d17086a4a760b553$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $d17086a4a760b553$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $d17086a4a760b553$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $4lSpl(r);
    this.s = new $4lSpl(s);
    this.recoveryParam = null;
    return true;
};
function $d17086a4a760b553$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$d17086a4a760b553$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $d17086a4a760b553$var$rmPadding(r);
    s = $d17086a4a760b553$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $d17086a4a760b553$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $d17086a4a760b553$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $d17086a4a760b553$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $bPM6h.encode(res, enc);
};

});


parcelRegister("2UigA", function(module, exports) {
'use strict';

var $7jptm = parcelRequire("7jptm");

var $9o3qY = parcelRequire("9o3qY");

var $bPM6h = parcelRequire("bPM6h");
var $21defb16122b7d87$var$assert = $bPM6h.assert;
var $21defb16122b7d87$var$parseBytes = $bPM6h.parseBytes;

var $lrJNN = parcelRequire("lrJNN");

var $1AvPe = parcelRequire("1AvPe");
function $21defb16122b7d87$var$EDDSA(curve) {
    $21defb16122b7d87$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $21defb16122b7d87$var$EDDSA)) return new $21defb16122b7d87$var$EDDSA(curve);
    curve = $9o3qY[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $7jptm.sha512;
}
module.exports = $21defb16122b7d87$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $21defb16122b7d87$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $21defb16122b7d87$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $21defb16122b7d87$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $21defb16122b7d87$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$21defb16122b7d87$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $bPM6h.intFromLE(hash.digest()).umod(this.curve.n);
};
$21defb16122b7d87$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $lrJNN.fromPublic(this, pub);
};
$21defb16122b7d87$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $lrJNN.fromSecret(this, secret);
};
$21defb16122b7d87$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $1AvPe) return sig;
    return new $1AvPe(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $21defb16122b7d87$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$21defb16122b7d87$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $bPM6h.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $bPM6h.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$21defb16122b7d87$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$21defb16122b7d87$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $bPM6h.intFromLE(bytes);
};
$21defb16122b7d87$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("lrJNN", function(module, exports) {
'use strict';

var $bPM6h = parcelRequire("bPM6h");
var $f9cfa5f8d2627e9e$var$assert = $bPM6h.assert;
var $f9cfa5f8d2627e9e$var$parseBytes = $bPM6h.parseBytes;
var $f9cfa5f8d2627e9e$var$cachedProperty = $bPM6h.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $f9cfa5f8d2627e9e$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $f9cfa5f8d2627e9e$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $f9cfa5f8d2627e9e$var$parseBytes(params.pub);
}
$f9cfa5f8d2627e9e$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $f9cfa5f8d2627e9e$var$KeyPair) return pub;
    return new $f9cfa5f8d2627e9e$var$KeyPair(eddsa, {
        pub: pub
    });
};
$f9cfa5f8d2627e9e$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $f9cfa5f8d2627e9e$var$KeyPair) return secret;
    return new $f9cfa5f8d2627e9e$var$KeyPair(eddsa, {
        secret: secret
    });
};
$f9cfa5f8d2627e9e$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$f9cfa5f8d2627e9e$var$cachedProperty($f9cfa5f8d2627e9e$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$f9cfa5f8d2627e9e$var$cachedProperty($f9cfa5f8d2627e9e$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$f9cfa5f8d2627e9e$var$cachedProperty($f9cfa5f8d2627e9e$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$f9cfa5f8d2627e9e$var$cachedProperty($f9cfa5f8d2627e9e$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$f9cfa5f8d2627e9e$var$cachedProperty($f9cfa5f8d2627e9e$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$f9cfa5f8d2627e9e$var$cachedProperty($f9cfa5f8d2627e9e$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$f9cfa5f8d2627e9e$var$KeyPair.prototype.sign = function sign(message) {
    $f9cfa5f8d2627e9e$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$f9cfa5f8d2627e9e$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$f9cfa5f8d2627e9e$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $f9cfa5f8d2627e9e$var$assert(this._secret, 'KeyPair is public only');
    return $bPM6h.encode(this.secret(), enc);
};
$f9cfa5f8d2627e9e$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $bPM6h.encode(this.pubBytes(), enc);
};
module.exports = $f9cfa5f8d2627e9e$var$KeyPair;

});

parcelRegister("1AvPe", function(module, exports) {
'use strict';

var $4lSpl = parcelRequire("4lSpl");

var $bPM6h = parcelRequire("bPM6h");
var $1281d71bb816500b$var$assert = $bPM6h.assert;
var $1281d71bb816500b$var$cachedProperty = $bPM6h.cachedProperty;
var $1281d71bb816500b$var$parseBytes = $bPM6h.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $1281d71bb816500b$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $1281d71bb816500b$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $1281d71bb816500b$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $1281d71bb816500b$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $4lSpl) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$1281d71bb816500b$var$cachedProperty($1281d71bb816500b$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$1281d71bb816500b$var$cachedProperty($1281d71bb816500b$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$1281d71bb816500b$var$cachedProperty($1281d71bb816500b$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$1281d71bb816500b$var$cachedProperty($1281d71bb816500b$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$1281d71bb816500b$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$1281d71bb816500b$var$Signature.prototype.toHex = function toHex() {
    return $bPM6h.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $1281d71bb816500b$var$Signature;

});



parcelRegister("dJNni", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("6N7cq")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) {
            this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            i++;
        }
        // Clear words above the requested width so the result stays below 2 ** width
        for(; i < this.length; i++)this.words[i] = 0;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        if (num === 0) {
            this.length = 1;
            this._normSign();
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.mod.abs();
        var half = num.abs().iushrn(1);
        var r2 = num.words[0] & 1;
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up, away from zero
        var up = new BN(1);
        up.negative = this.negative ^ num.negative;
        return dm.div.iadd(up);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7ab4s", function(module, exports) {
'use strict';

var $lGQcL = parcelRequire("lGQcL");

var $kjIwg = parcelRequire("kjIwg");

var $9be2P = parcelRequire("9be2P");

var $eGE1b = parcelRequire("eGE1b");

var $kUWqc = parcelRequire("kUWqc");
var $53720e0991682182$require$pbkdf2Sync = $kUWqc.pbkdf2Sync;

var $2tQhI = parcelRequire("2tQhI");
var $53720e0991682182$require$Buffer = $2tQhI.Buffer;
function $53720e0991682182$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $kjIwg[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $53720e0991682182$require$pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $eGE1b.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $53720e0991682182$require$Buffer.concat(out);
}
function $53720e0991682182$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$53720e0991682182$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $53720e0991682182$require$Buffer.from(buffer);
    var stripped = $9be2P(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $lGQcL.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $lGQcL.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $lGQcL.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $lGQcL.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $lGQcL.EncryptedPrivateKey.decode(data, 'der');
            data = $53720e0991682182$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $lGQcL.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $lGQcL.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $lGQcL.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $lGQcL.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $lGQcL.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $lGQcL.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $lGQcL.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $lGQcL.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$53720e0991682182$var$parseKeys.signature = $lGQcL.signature;
module.exports = $53720e0991682182$var$parseKeys;

});
parcelRegister("lGQcL", function(module, exports) {

$parcel$export(module.exports, "certificate", function () { return $fca6040888a97d3d$export$c98397a6eb8d0678; }, function (v) { return $fca6040888a97d3d$export$c98397a6eb8d0678 = v; });
$parcel$export(module.exports, "RSAPrivateKey", function () { return $fca6040888a97d3d$export$f4aab6816f64fa6b; }, function (v) { return $fca6040888a97d3d$export$f4aab6816f64fa6b = v; });
$parcel$export(module.exports, "RSAPublicKey", function () { return $fca6040888a97d3d$export$4471f5c65d097c11; }, function (v) { return $fca6040888a97d3d$export$4471f5c65d097c11 = v; });
$parcel$export(module.exports, "PublicKey", function () { return $fca6040888a97d3d$export$ca8b6604d6ce14de; }, function (v) { return $fca6040888a97d3d$export$ca8b6604d6ce14de = v; });
$parcel$export(module.exports, "PrivateKey", function () { return $fca6040888a97d3d$export$8f54525b330fd87b; }, function (v) { return $fca6040888a97d3d$export$8f54525b330fd87b = v; });
$parcel$export(module.exports, "EncryptedPrivateKey", function () { return $fca6040888a97d3d$export$23cd2842b44ca3e7; }, function (v) { return $fca6040888a97d3d$export$23cd2842b44ca3e7 = v; });
$parcel$export(module.exports, "DSAPrivateKey", function () { return $fca6040888a97d3d$export$245c9aaa9f5ce4ce; }, function (v) { return $fca6040888a97d3d$export$245c9aaa9f5ce4ce = v; });
$parcel$export(module.exports, "DSAparam", function () { return $fca6040888a97d3d$export$8ad762e3e6399afe; }, function (v) { return $fca6040888a97d3d$export$8ad762e3e6399afe = v; });
$parcel$export(module.exports, "ECPrivateKey", function () { return $fca6040888a97d3d$export$32ef6f92e22c6ab0; }, function (v) { return $fca6040888a97d3d$export$32ef6f92e22c6ab0 = v; });
$parcel$export(module.exports, "signature", function () { return $fca6040888a97d3d$export$c9cd164b539ebb63; }, function (v) { return $fca6040888a97d3d$export$c9cd164b539ebb63 = v; });
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $fca6040888a97d3d$export$c98397a6eb8d0678;
var $fca6040888a97d3d$export$f4aab6816f64fa6b;
var $fca6040888a97d3d$export$4471f5c65d097c11;
var $fca6040888a97d3d$export$ca8b6604d6ce14de;
var $fca6040888a97d3d$export$8f54525b330fd87b;
var $fca6040888a97d3d$export$23cd2842b44ca3e7;
var $fca6040888a97d3d$export$245c9aaa9f5ce4ce;
var $fca6040888a97d3d$export$8ad762e3e6399afe;
var $fca6040888a97d3d$export$32ef6f92e22c6ab0;
var $fca6040888a97d3d$export$c9cd164b539ebb63;
'use strict';

var $31Vzh = parcelRequire("31Vzh");

$fca6040888a97d3d$export$c98397a6eb8d0678 = (parcelRequire("9vJWs"));
var $fca6040888a97d3d$var$RSAPrivateKey = $31Vzh.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$fca6040888a97d3d$export$f4aab6816f64fa6b = $fca6040888a97d3d$var$RSAPrivateKey;
var $fca6040888a97d3d$var$RSAPublicKey = $31Vzh.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$fca6040888a97d3d$export$4471f5c65d097c11 = $fca6040888a97d3d$var$RSAPublicKey;
var $fca6040888a97d3d$var$AlgorithmIdentifier = $31Vzh.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $fca6040888a97d3d$var$PublicKey = $31Vzh.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($fca6040888a97d3d$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$fca6040888a97d3d$export$ca8b6604d6ce14de = $fca6040888a97d3d$var$PublicKey;
var $fca6040888a97d3d$var$PrivateKeyInfo = $31Vzh.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($fca6040888a97d3d$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$fca6040888a97d3d$export$8f54525b330fd87b = $fca6040888a97d3d$var$PrivateKeyInfo;
var $fca6040888a97d3d$var$EncryptedPrivateKeyInfo = $31Vzh.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$fca6040888a97d3d$export$23cd2842b44ca3e7 = $fca6040888a97d3d$var$EncryptedPrivateKeyInfo;
var $fca6040888a97d3d$var$DSAPrivateKey = $31Vzh.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$fca6040888a97d3d$export$245c9aaa9f5ce4ce = $fca6040888a97d3d$var$DSAPrivateKey;
$fca6040888a97d3d$export$8ad762e3e6399afe = $31Vzh.define('DSAparam', function() {
    this['int']();
});
var $fca6040888a97d3d$var$ECParameters = $31Vzh.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $fca6040888a97d3d$var$ECPrivateKey = $31Vzh.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($fca6040888a97d3d$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$fca6040888a97d3d$export$32ef6f92e22c6ab0 = $fca6040888a97d3d$var$ECPrivateKey;
$fca6040888a97d3d$export$c9cd164b539ebb63 = $31Vzh.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});
parcelRegister("31Vzh", function(module, exports) {
var $234e1ee5c4720c72$var$asn1 = module.exports;

$234e1ee5c4720c72$var$asn1.bignum = (parcelRequire("4lSpl"));

$234e1ee5c4720c72$var$asn1.define = (parcelRequire("gjXaa")).define;

$234e1ee5c4720c72$var$asn1.base = (parcelRequire("9ObLt"));

$234e1ee5c4720c72$var$asn1.constants = (parcelRequire("1fSpL"));

$234e1ee5c4720c72$var$asn1.decoders = (parcelRequire("64pz4"));

$234e1ee5c4720c72$var$asn1.encoders = (parcelRequire("ftFth"));

});
parcelRegister("gjXaa", function(module, exports) {

var $31Vzh = parcelRequire("31Vzh");

var $27YCQ = parcelRequire("27YCQ");
var $be1c5039549b22dd$var$api = module.exports;
$be1c5039549b22dd$var$api.define = function define(name, body) {
    return new $be1c5039549b22dd$var$Entity(name, body);
};
function $be1c5039549b22dd$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$be1c5039549b22dd$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("assAx")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $27YCQ(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$be1c5039549b22dd$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($31Vzh.decoders[enc]);
    return this.decoders[enc];
};
$be1c5039549b22dd$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$be1c5039549b22dd$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($31Vzh.encoders[enc]);
    return this.encoders[enc];
};
$be1c5039549b22dd$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("assAx", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("9ObLt", function(module, exports) {
var $7241e8cf90feafca$var$base = module.exports;

$7241e8cf90feafca$var$base.Reporter = (parcelRequire("eymvd")).Reporter;

$7241e8cf90feafca$var$base.DecoderBuffer = (parcelRequire("eyY1P")).DecoderBuffer;

$7241e8cf90feafca$var$base.EncoderBuffer = (parcelRequire("eyY1P")).EncoderBuffer;

$7241e8cf90feafca$var$base.Node = (parcelRequire("hCF4o"));

});
parcelRegister("eymvd", function(module, exports) {

$parcel$export(module.exports, "Reporter", function () { return $a985b22fb1d39c72$export$957313a2f485e5ed; }, function (v) { return $a985b22fb1d39c72$export$957313a2f485e5ed = v; });
var $a985b22fb1d39c72$export$957313a2f485e5ed;

var $27YCQ = parcelRequire("27YCQ");
function $a985b22fb1d39c72$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$a985b22fb1d39c72$export$957313a2f485e5ed = $a985b22fb1d39c72$var$Reporter;
$a985b22fb1d39c72$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $a985b22fb1d39c72$var$ReporterError;
};
$a985b22fb1d39c72$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$a985b22fb1d39c72$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$a985b22fb1d39c72$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$a985b22fb1d39c72$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$a985b22fb1d39c72$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$a985b22fb1d39c72$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$a985b22fb1d39c72$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$a985b22fb1d39c72$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$a985b22fb1d39c72$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $a985b22fb1d39c72$var$ReporterError;
    if (inherited) err = msg;
    else err = new $a985b22fb1d39c72$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$a985b22fb1d39c72$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $a985b22fb1d39c72$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$27YCQ($a985b22fb1d39c72$var$ReporterError, Error);
$a985b22fb1d39c72$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $a985b22fb1d39c72$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("eyY1P", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", function () { return $a9a2ce16010f6a7f$export$bf9f79cdc4a49163; }, function (v) { return $a9a2ce16010f6a7f$export$bf9f79cdc4a49163 = v; });
$parcel$export(module.exports, "EncoderBuffer", function () { return $a9a2ce16010f6a7f$export$8ff24f7760c7a78e; }, function (v) { return $a9a2ce16010f6a7f$export$8ff24f7760c7a78e = v; });
var $a9a2ce16010f6a7f$export$bf9f79cdc4a49163;
var $a9a2ce16010f6a7f$export$8ff24f7760c7a78e;

var $27YCQ = parcelRequire("27YCQ");

var $9ObLt = parcelRequire("9ObLt");
var $a9a2ce16010f6a7f$require$Reporter = $9ObLt.Reporter;

var $81U8s = parcelRequire("81U8s");
var $a9a2ce16010f6a7f$require$Buffer = $81U8s.Buffer;
function $a9a2ce16010f6a7f$var$DecoderBuffer(base, options) {
    $a9a2ce16010f6a7f$require$Reporter.call(this, options);
    if (!$a9a2ce16010f6a7f$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$27YCQ($a9a2ce16010f6a7f$var$DecoderBuffer, $a9a2ce16010f6a7f$require$Reporter);
$a9a2ce16010f6a7f$export$bf9f79cdc4a49163 = $a9a2ce16010f6a7f$var$DecoderBuffer;
$a9a2ce16010f6a7f$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $a9a2ce16010f6a7f$require$Reporter.prototype.save.call(this)
    };
};
$a9a2ce16010f6a7f$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $a9a2ce16010f6a7f$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $a9a2ce16010f6a7f$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$a9a2ce16010f6a7f$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$a9a2ce16010f6a7f$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$a9a2ce16010f6a7f$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $a9a2ce16010f6a7f$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$a9a2ce16010f6a7f$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $a9a2ce16010f6a7f$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $a9a2ce16010f6a7f$var$EncoderBuffer)) item = new $a9a2ce16010f6a7f$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $a9a2ce16010f6a7f$require$Buffer.byteLength(value);
    } else if ($a9a2ce16010f6a7f$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$a9a2ce16010f6a7f$export$8ff24f7760c7a78e = $a9a2ce16010f6a7f$var$EncoderBuffer;
$a9a2ce16010f6a7f$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $a9a2ce16010f6a7f$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($a9a2ce16010f6a7f$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("hCF4o", function(module, exports) {

var $9ObLt = parcelRequire("9ObLt");
var $cd45d7e18ca30622$require$Reporter = $9ObLt.Reporter;

var $9ObLt = parcelRequire("9ObLt");
var $cd45d7e18ca30622$require$EncoderBuffer = $9ObLt.EncoderBuffer;

var $9ObLt = parcelRequire("9ObLt");
var $cd45d7e18ca30622$require$DecoderBuffer = $9ObLt.DecoderBuffer;

var $47cfW = parcelRequire("47cfW");
// Supported tags
var $cd45d7e18ca30622$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $cd45d7e18ca30622$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($cd45d7e18ca30622$var$tags);
// Overrided methods list
var $cd45d7e18ca30622$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $cd45d7e18ca30622$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $cd45d7e18ca30622$var$Node;
var $cd45d7e18ca30622$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$cd45d7e18ca30622$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $cd45d7e18ca30622$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$cd45d7e18ca30622$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $cd45d7e18ca30622$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$cd45d7e18ca30622$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $47cfW(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $47cfW.equal(state.children.length, 1, 'Root node can have only one child');
};
$cd45d7e18ca30622$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $47cfW(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $47cfW(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$cd45d7e18ca30622$var$overrided.forEach(function(method) {
    $cd45d7e18ca30622$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$cd45d7e18ca30622$var$tags.forEach(function(tag) {
    $cd45d7e18ca30622$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $47cfW(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$cd45d7e18ca30622$var$Node.prototype.use = function use(item) {
    $47cfW(item);
    var state = this._baseState;
    $47cfW(state.use === null);
    state.use = item;
    return this;
};
$cd45d7e18ca30622$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$cd45d7e18ca30622$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $47cfW(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$cd45d7e18ca30622$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $47cfW(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$cd45d7e18ca30622$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $47cfW(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$cd45d7e18ca30622$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$cd45d7e18ca30622$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $47cfW(state.key === null);
    state.key = newKey;
    return this;
};
$cd45d7e18ca30622$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$cd45d7e18ca30622$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $47cfW(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$cd45d7e18ca30622$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $47cfW(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$cd45d7e18ca30622$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $cd45d7e18ca30622$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$cd45d7e18ca30622$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$cd45d7e18ca30622$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $47cfW(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$cd45d7e18ca30622$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$cd45d7e18ca30622$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $cd45d7e18ca30622$require$EncoderBuffer(data, this.reporter);
};
$cd45d7e18ca30622$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$cd45d7e18ca30622$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $cd45d7e18ca30622$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$cd45d7e18ca30622$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $47cfW(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$cd45d7e18ca30622$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$cd45d7e18ca30622$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$cd45d7e18ca30622$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("1fSpL", function(module, exports) {
var $0ea166c08c343210$var$constants = module.exports;
// Helper
$0ea166c08c343210$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$0ea166c08c343210$var$constants.der = (parcelRequire("k41nd"));

});
parcelRegister("k41nd", function(module, exports) {

$parcel$export(module.exports, "tagClass", function () { return $e9b53f17d404fa99$export$3584c46ed60baee8; }, function (v) { return $e9b53f17d404fa99$export$3584c46ed60baee8 = v; });
$parcel$export(module.exports, "tagClassByName", function () { return $e9b53f17d404fa99$export$f18596ef8d632e49; }, function (v) { return $e9b53f17d404fa99$export$f18596ef8d632e49 = v; });
$parcel$export(module.exports, "tag", function () { return $e9b53f17d404fa99$export$2b067c6666111485; }, function (v) { return $e9b53f17d404fa99$export$2b067c6666111485 = v; });
$parcel$export(module.exports, "tagByName", function () { return $e9b53f17d404fa99$export$f17df38a421ab9e3; }, function (v) { return $e9b53f17d404fa99$export$f17df38a421ab9e3 = v; });
var $e9b53f17d404fa99$export$3584c46ed60baee8;
var $e9b53f17d404fa99$export$f18596ef8d632e49;
var $e9b53f17d404fa99$export$2b067c6666111485;
var $e9b53f17d404fa99$export$f17df38a421ab9e3;

var $1fSpL = parcelRequire("1fSpL");
$e9b53f17d404fa99$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$e9b53f17d404fa99$export$f18596ef8d632e49 = $1fSpL._reverse($e9b53f17d404fa99$export$3584c46ed60baee8);
$e9b53f17d404fa99$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$e9b53f17d404fa99$export$f17df38a421ab9e3 = $1fSpL._reverse($e9b53f17d404fa99$export$2b067c6666111485);

});


parcelRegister("64pz4", function(module, exports) {
var $46b6f261e95340fe$var$decoders = module.exports;

$46b6f261e95340fe$var$decoders.der = (parcelRequire("8DBRV"));

$46b6f261e95340fe$var$decoders.pem = (parcelRequire("j8J5i"));

});
parcelRegister("8DBRV", function(module, exports) {

var $27YCQ = parcelRequire("27YCQ");

var $31Vzh = parcelRequire("31Vzh");
var $649f5737629c887e$var$base = $31Vzh.base;
var $649f5737629c887e$var$bignum = $31Vzh.bignum;
// Import DER constants
var $649f5737629c887e$var$der = $31Vzh.constants.der;
function $649f5737629c887e$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $649f5737629c887e$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $649f5737629c887e$var$DERDecoder;
$649f5737629c887e$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $649f5737629c887e$var$base.DecoderBuffer)) data = new $649f5737629c887e$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $649f5737629c887e$var$DERNode(parent) {
    $649f5737629c887e$var$base.Node.call(this, 'der', parent);
}
$27YCQ($649f5737629c887e$var$DERNode, $649f5737629c887e$var$base.Node);
$649f5737629c887e$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $649f5737629c887e$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$649f5737629c887e$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $649f5737629c887e$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $649f5737629c887e$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$649f5737629c887e$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $649f5737629c887e$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $649f5737629c887e$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$649f5737629c887e$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$649f5737629c887e$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$649f5737629c887e$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$649f5737629c887e$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$649f5737629c887e$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$649f5737629c887e$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$649f5737629c887e$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $649f5737629c887e$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$649f5737629c887e$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $649f5737629c887e$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $649f5737629c887e$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $649f5737629c887e$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $649f5737629c887e$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("j8J5i", function(module, exports) {

var $27YCQ = parcelRequire("27YCQ");

var $81U8s = parcelRequire("81U8s");
var $def1bc83d817961e$require$Buffer = $81U8s.Buffer;

var $8DBRV = parcelRequire("8DBRV");
function $def1bc83d817961e$var$PEMDecoder(entity) {
    $8DBRV.call(this, entity);
    this.enc = 'pem';
}
$27YCQ($def1bc83d817961e$var$PEMDecoder, $8DBRV);
module.exports = $def1bc83d817961e$var$PEMDecoder;
$def1bc83d817961e$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $def1bc83d817961e$require$Buffer(base64, 'base64');
    return $8DBRV.prototype.decode.call(this, input, options);
};

});


parcelRegister("ftFth", function(module, exports) {
var $b449bbc5f2488d1d$var$encoders = module.exports;

$b449bbc5f2488d1d$var$encoders.der = (parcelRequire("1d2ud"));

$b449bbc5f2488d1d$var$encoders.pem = (parcelRequire("aQihL"));

});
parcelRegister("1d2ud", function(module, exports) {

var $27YCQ = parcelRequire("27YCQ");

var $81U8s = parcelRequire("81U8s");
var $0e18ef18b2a70556$require$Buffer = $81U8s.Buffer;

var $31Vzh = parcelRequire("31Vzh");
var $0e18ef18b2a70556$var$base = $31Vzh.base;
// Import DER constants
var $0e18ef18b2a70556$var$der = $31Vzh.constants.der;
function $0e18ef18b2a70556$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $0e18ef18b2a70556$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $0e18ef18b2a70556$var$DEREncoder;
$0e18ef18b2a70556$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $0e18ef18b2a70556$var$DERNode(parent) {
    $0e18ef18b2a70556$var$base.Node.call(this, 'der', parent);
}
$27YCQ($0e18ef18b2a70556$var$DERNode, $0e18ef18b2a70556$var$base.Node);
$0e18ef18b2a70556$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $0e18ef18b2a70556$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $0e18ef18b2a70556$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $0e18ef18b2a70556$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$0e18ef18b2a70556$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $0e18ef18b2a70556$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$0e18ef18b2a70556$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $0e18ef18b2a70556$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $0e18ef18b2a70556$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$0e18ef18b2a70556$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $0e18ef18b2a70556$var$two(date.getFullYear()),
        $0e18ef18b2a70556$var$two(date.getUTCMonth() + 1),
        $0e18ef18b2a70556$var$two(date.getUTCDate()),
        $0e18ef18b2a70556$var$two(date.getUTCHours()),
        $0e18ef18b2a70556$var$two(date.getUTCMinutes()),
        $0e18ef18b2a70556$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $0e18ef18b2a70556$var$two(date.getFullYear() % 100),
        $0e18ef18b2a70556$var$two(date.getUTCMonth() + 1),
        $0e18ef18b2a70556$var$two(date.getUTCDate()),
        $0e18ef18b2a70556$var$two(date.getUTCHours()),
        $0e18ef18b2a70556$var$two(date.getUTCMinutes()),
        $0e18ef18b2a70556$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$0e18ef18b2a70556$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$0e18ef18b2a70556$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$0e18ef18b2a70556$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $0e18ef18b2a70556$require$Buffer(numArray);
    }
    if ($0e18ef18b2a70556$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $0e18ef18b2a70556$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $0e18ef18b2a70556$require$Buffer(out));
};
$0e18ef18b2a70556$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$0e18ef18b2a70556$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$0e18ef18b2a70556$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $0e18ef18b2a70556$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($0e18ef18b2a70556$var$der.tagByName.hasOwnProperty(tag)) res = $0e18ef18b2a70556$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $0e18ef18b2a70556$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("aQihL", function(module, exports) {

var $27YCQ = parcelRequire("27YCQ");

var $1d2ud = parcelRequire("1d2ud");
function $7e4cf1d4b9662f33$var$PEMEncoder(entity) {
    $1d2ud.call(this, entity);
    this.enc = 'pem';
}
$27YCQ($7e4cf1d4b9662f33$var$PEMEncoder, $1d2ud);
module.exports = $7e4cf1d4b9662f33$var$PEMEncoder;
$7e4cf1d4b9662f33$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $1d2ud.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("9vJWs", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $31Vzh = parcelRequire("31Vzh");
var $6ecaa56a7bc9b6f6$var$Time = $31Vzh.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $6ecaa56a7bc9b6f6$var$AttributeTypeValue = $31Vzh.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $6ecaa56a7bc9b6f6$var$AlgorithmIdentifier = $31Vzh.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $6ecaa56a7bc9b6f6$var$SubjectPublicKeyInfo = $31Vzh.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($6ecaa56a7bc9b6f6$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $6ecaa56a7bc9b6f6$var$RelativeDistinguishedName = $31Vzh.define('RelativeDistinguishedName', function() {
    this.setof($6ecaa56a7bc9b6f6$var$AttributeTypeValue);
});
var $6ecaa56a7bc9b6f6$var$RDNSequence = $31Vzh.define('RDNSequence', function() {
    this.seqof($6ecaa56a7bc9b6f6$var$RelativeDistinguishedName);
});
var $6ecaa56a7bc9b6f6$var$Name = $31Vzh.define('Name', function() {
    this.choice({
        rdnSequence: this.use($6ecaa56a7bc9b6f6$var$RDNSequence)
    });
});
var $6ecaa56a7bc9b6f6$var$Validity = $31Vzh.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($6ecaa56a7bc9b6f6$var$Time), this.key('notAfter').use($6ecaa56a7bc9b6f6$var$Time));
});
var $6ecaa56a7bc9b6f6$var$Extension = $31Vzh.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $6ecaa56a7bc9b6f6$var$TBSCertificate = $31Vzh.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($6ecaa56a7bc9b6f6$var$AlgorithmIdentifier), this.key('issuer').use($6ecaa56a7bc9b6f6$var$Name), this.key('validity').use($6ecaa56a7bc9b6f6$var$Validity), this.key('subject').use($6ecaa56a7bc9b6f6$var$Name), this.key('subjectPublicKeyInfo').use($6ecaa56a7bc9b6f6$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($6ecaa56a7bc9b6f6$var$Extension).optional());
});
var $6ecaa56a7bc9b6f6$var$X509Certificate = $31Vzh.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($6ecaa56a7bc9b6f6$var$TBSCertificate), this.key('signatureAlgorithm').use($6ecaa56a7bc9b6f6$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $6ecaa56a7bc9b6f6$var$X509Certificate;

});


parcelRegister("kjIwg", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("9be2P", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $6af0091c74f4ba6c$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $6af0091c74f4ba6c$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $6af0091c74f4ba6c$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $fZX14 = parcelRequire("fZX14");

var $eGE1b = parcelRequire("eGE1b");

var $2tQhI = parcelRequire("2tQhI");
var $6af0091c74f4ba6c$require$Buffer = $2tQhI.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($6af0091c74f4ba6c$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($6af0091c74f4ba6c$var$fullRegex);
        decrypted = $6af0091c74f4ba6c$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $6af0091c74f4ba6c$require$Buffer.from(match[2], 'hex');
        var cipherText = $6af0091c74f4ba6c$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $fZX14(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $eGE1b.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $6af0091c74f4ba6c$require$Buffer.concat(out);
    }
    var tag = key.match($6af0091c74f4ba6c$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("5evOG", function(module, exports) {
module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

});


parcelRegister("emsvv", function(module, exports) {
'use strict';

var $2tQhI = parcelRequire("2tQhI");
var $a7493bad17da19bd$require$Buffer = $2tQhI.Buffer;

var $dJNni = parcelRequire("dJNni");

var $8wxnI = parcelRequire("8wxnI");
var $a7493bad17da19bd$require$EC = $8wxnI.ec;

var $7ab4s = parcelRequire("7ab4s");

var $5evOG = parcelRequire("5evOG");
function $a7493bad17da19bd$var$verify(sig, hash, key, signType, tag) {
    var pub = $7ab4s(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $a7493bad17da19bd$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $a7493bad17da19bd$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $a7493bad17da19bd$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $a7493bad17da19bd$require$Buffer.from(pad);
    var red = $dJNni.mont(pub.modulus);
    sig = new $dJNni(sig).toRed(red);
    sig = sig.redPow(new $dJNni(pub.publicExponent));
    sig = $a7493bad17da19bd$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $a7493bad17da19bd$var$ecVerify(sig, hash, pub) {
    var curveId = $5evOG[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $a7493bad17da19bd$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $a7493bad17da19bd$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $7ab4s.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $a7493bad17da19bd$var$checkValue(s, q);
    $a7493bad17da19bd$var$checkValue(r, q);
    var montp = $dJNni.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $dJNni(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $a7493bad17da19bd$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
module.exports = $a7493bad17da19bd$var$verify;

});


parcelRegister("iujvJ", function(module, exports) {

var $81U8s = parcelRequire("81U8s");
var $d75a29c4eb559227$require$Buffer = $81U8s.Buffer;

var $8wxnI = parcelRequire("8wxnI");

var $4lSpl = parcelRequire("4lSpl");
module.exports = function createECDH(curve) {
    return new $d75a29c4eb559227$var$ECDH(curve);
};
var $d75a29c4eb559227$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$d75a29c4eb559227$var$aliases.p224 = $d75a29c4eb559227$var$aliases.secp224r1;
$d75a29c4eb559227$var$aliases.p256 = $d75a29c4eb559227$var$aliases.secp256r1 = $d75a29c4eb559227$var$aliases.prime256v1;
$d75a29c4eb559227$var$aliases.p192 = $d75a29c4eb559227$var$aliases.secp192r1 = $d75a29c4eb559227$var$aliases.prime192v1;
$d75a29c4eb559227$var$aliases.p384 = $d75a29c4eb559227$var$aliases.secp384r1;
$d75a29c4eb559227$var$aliases.p521 = $d75a29c4eb559227$var$aliases.secp521r1;
function $d75a29c4eb559227$var$ECDH(curve) {
    this.curveType = $d75a29c4eb559227$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $8wxnI.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$d75a29c4eb559227$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$d75a29c4eb559227$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$d75a29c4eb559227$require$Buffer.isBuffer(other)) other = new $d75a29c4eb559227$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $d75a29c4eb559227$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$d75a29c4eb559227$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $d75a29c4eb559227$var$formatReturnValue(key, enc);
};
$d75a29c4eb559227$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $d75a29c4eb559227$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$d75a29c4eb559227$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$d75a29c4eb559227$require$Buffer.isBuffer(pub)) pub = new $d75a29c4eb559227$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$d75a29c4eb559227$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$d75a29c4eb559227$require$Buffer.isBuffer(priv)) priv = new $d75a29c4eb559227$require$Buffer(priv, enc);
    var _priv = new $4lSpl(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $d75a29c4eb559227$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $d75a29c4eb559227$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $d75a29c4eb559227$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $d75a29c4eb559227$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});

parcelRegister("d8Y98", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", function () { return $991aad842ac08921$export$512823e338ddb1b7; }, function (v) { return $991aad842ac08921$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $991aad842ac08921$export$7efb24e2fddf99b9; }, function (v) { return $991aad842ac08921$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $991aad842ac08921$export$9d0e0c0c4a8d30f3; }, function (v) { return $991aad842ac08921$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $991aad842ac08921$export$b9d55ff329113abd; }, function (v) { return $991aad842ac08921$export$b9d55ff329113abd = v; });
var $991aad842ac08921$export$512823e338ddb1b7;
var $991aad842ac08921$export$7efb24e2fddf99b9;
var $991aad842ac08921$export$9d0e0c0c4a8d30f3;
var $991aad842ac08921$export$b9d55ff329113abd;

$991aad842ac08921$export$512823e338ddb1b7 = (parcelRequire("3Ihg9"));

$991aad842ac08921$export$7efb24e2fddf99b9 = (parcelRequire("jH28N"));
$991aad842ac08921$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $991aad842ac08921$export$512823e338ddb1b7(key, buf, true);
};
$991aad842ac08921$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $991aad842ac08921$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("3Ihg9", function(module, exports) {

var $7ab4s = parcelRequire("7ab4s");

var $hw9Ml = parcelRequire("hw9Ml");

var $5RHXY = parcelRequire("5RHXY");

var $fAUfl = parcelRequire("fAUfl");

var $elSDe = parcelRequire("elSDe");

var $4lSpl = parcelRequire("4lSpl");

var $8pz9P = parcelRequire("8pz9P");

var $eWJZx = parcelRequire("eWJZx");

var $2tQhI = parcelRequire("2tQhI");
var $2b42de8a61efed6e$require$Buffer = $2tQhI.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $7ab4s(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $2b42de8a61efed6e$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $2b42de8a61efed6e$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $4lSpl(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $eWJZx(paddedMsg, key);
    else return $8pz9P(paddedMsg, key);
};
function $2b42de8a61efed6e$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $5RHXY('sha1').update($2b42de8a61efed6e$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $2b42de8a61efed6e$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $hw9Ml(hLen);
    var maskedDb = $elSDe($2b42de8a61efed6e$require$Buffer.concat([
        iHash,
        ps,
        $2b42de8a61efed6e$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $fAUfl(seed, dblen));
    var maskedSeed = $elSDe(seed, $fAUfl(maskedDb, hLen));
    return new $4lSpl($2b42de8a61efed6e$require$Buffer.concat([
        $2b42de8a61efed6e$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $2b42de8a61efed6e$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $2b42de8a61efed6e$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $2b42de8a61efed6e$var$nonZero(k - mLen - 3);
    return new $4lSpl($2b42de8a61efed6e$require$Buffer.concat([
        $2b42de8a61efed6e$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $2b42de8a61efed6e$require$Buffer.alloc(1),
        msg
    ], k));
}
function $2b42de8a61efed6e$var$nonZero(len) {
    var out = $2b42de8a61efed6e$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $hw9Ml(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $hw9Ml(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("fAUfl", function(module, exports) {

var $5RHXY = parcelRequire("5RHXY");

var $2tQhI = parcelRequire("2tQhI");
var $b5a5d92f671710a1$require$Buffer = $2tQhI.Buffer;
module.exports = function(seed, len) {
    var t = $b5a5d92f671710a1$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $b5a5d92f671710a1$var$i2ops(i++);
        t = $b5a5d92f671710a1$require$Buffer.concat([
            t,
            $5RHXY('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $b5a5d92f671710a1$var$i2ops(c) {
    var out = $b5a5d92f671710a1$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("elSDe", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("8pz9P", function(module, exports) {

var $4lSpl = parcelRequire("4lSpl");

var $2tQhI = parcelRequire("2tQhI");
var $61fbee194ac471a6$require$Buffer = $2tQhI.Buffer;
function $61fbee194ac471a6$var$withPublic(paddedMsg, key) {
    return $61fbee194ac471a6$require$Buffer.from(paddedMsg.toRed($4lSpl.mont(key.modulus)).redPow(new $4lSpl(key.publicExponent)).fromRed().toArray());
}
module.exports = $61fbee194ac471a6$var$withPublic;

});


parcelRegister("jH28N", function(module, exports) {

var $7ab4s = parcelRequire("7ab4s");

var $fAUfl = parcelRequire("fAUfl");

var $elSDe = parcelRequire("elSDe");

var $4lSpl = parcelRequire("4lSpl");

var $eWJZx = parcelRequire("eWJZx");

var $5RHXY = parcelRequire("5RHXY");

var $8pz9P = parcelRequire("8pz9P");

var $2tQhI = parcelRequire("2tQhI");
var $e563b19cbcec00e3$require$Buffer = $2tQhI.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $7ab4s(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $4lSpl(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $8pz9P(new $4lSpl(enc), key);
    else msg = $eWJZx(enc, key);
    var zBuffer = $e563b19cbcec00e3$require$Buffer.alloc(k - msg.length);
    msg = $e563b19cbcec00e3$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $e563b19cbcec00e3$var$oaep(key, msg);
    else if (padding === 1) return $e563b19cbcec00e3$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $e563b19cbcec00e3$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $5RHXY('sha1').update($e563b19cbcec00e3$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $elSDe(maskedSeed, $fAUfl(maskedDb, hLen));
    var db = $elSDe(maskedDb, $fAUfl(seed, k - hLen - 1));
    if ($e563b19cbcec00e3$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $e563b19cbcec00e3$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $e563b19cbcec00e3$var$compare(a, b) {
    a = $e563b19cbcec00e3$require$Buffer.from(a);
    b = $e563b19cbcec00e3$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("awW5H", function(module, exports) {

$parcel$export(module.exports, "randomFill", function () { return $7aa9f42bea0e258c$export$bb1abf2ce84fc7e8; }, function (v) { return $7aa9f42bea0e258c$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $7aa9f42bea0e258c$export$2f7171e78e524d5e; }, function (v) { return $7aa9f42bea0e258c$export$2f7171e78e524d5e = v; });
var $7aa9f42bea0e258c$export$bb1abf2ce84fc7e8;
var $7aa9f42bea0e258c$export$2f7171e78e524d5e;

var $4LBMV = parcelRequire("4LBMV");
'use strict';
function $7aa9f42bea0e258c$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $2tQhI = parcelRequire("2tQhI");

var $hw9Ml = parcelRequire("hw9Ml");
var $7aa9f42bea0e258c$var$Buffer = $2tQhI.Buffer;
var $7aa9f42bea0e258c$var$kBufferMaxLength = $2tQhI.kMaxLength;
var $7aa9f42bea0e258c$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $7aa9f42bea0e258c$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $7aa9f42bea0e258c$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $7aa9f42bea0e258c$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $7aa9f42bea0e258c$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $7aa9f42bea0e258c$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $7aa9f42bea0e258c$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $7aa9f42bea0e258c$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($7aa9f42bea0e258c$var$crypto && $7aa9f42bea0e258c$var$crypto.getRandomValues || false) {
    $7aa9f42bea0e258c$export$bb1abf2ce84fc7e8 = $7aa9f42bea0e258c$var$randomFill;
    $7aa9f42bea0e258c$export$2f7171e78e524d5e = $7aa9f42bea0e258c$var$randomFillSync;
} else {
    $7aa9f42bea0e258c$export$bb1abf2ce84fc7e8 = $7aa9f42bea0e258c$var$oldBrowser;
    $7aa9f42bea0e258c$export$2f7171e78e524d5e = $7aa9f42bea0e258c$var$oldBrowser;
}
function $7aa9f42bea0e258c$var$randomFill(buf, offset, size, cb) {
    if (!$7aa9f42bea0e258c$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $7aa9f42bea0e258c$var$assertOffset(offset, buf.length);
    $7aa9f42bea0e258c$var$assertSize(size, offset, buf.length);
    return $7aa9f42bea0e258c$var$actualFill(buf, offset, size, cb);
}
function $7aa9f42bea0e258c$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $7aa9f42bea0e258c$var$crypto.getRandomValues(uint);
    if (cb) {
        $4LBMV.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $hw9Ml(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $hw9Ml(size);
    bytes.copy(buf, offset);
    return buf;
}
function $7aa9f42bea0e258c$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$7aa9f42bea0e258c$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $7aa9f42bea0e258c$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $7aa9f42bea0e258c$var$assertSize(size, offset, buf.length);
    return $7aa9f42bea0e258c$var$actualFill(buf, offset, size);
}

});


parcelRegister("cWvYf", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("9LFT6")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join('');
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("5DZ9Z", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $41c009671ac80ef8$export$2e2bcd8739ae039; });
function $41c009671ac80ef8$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});

parcelRegister("4GZYp", function(module, exports) {

$parcel$export(module.exports, "convert2nimn", function () { return $36ab284eb4b1b616$export$fa981bbccf843781; }, function (v) { return $36ab284eb4b1b616$export$fa981bbccf843781 = v; });
var $36ab284eb4b1b616$export$fa981bbccf843781;
'use strict';
const $36ab284eb4b1b616$var$char = function(a) {
    return String.fromCharCode(a);
};
const $36ab284eb4b1b616$var$chars = {
    nilChar: $36ab284eb4b1b616$var$char(176),
    missingChar: $36ab284eb4b1b616$var$char(201),
    nilPremitive: $36ab284eb4b1b616$var$char(175),
    missingPremitive: $36ab284eb4b1b616$var$char(200),
    emptyChar: $36ab284eb4b1b616$var$char(178),
    emptyValue: $36ab284eb4b1b616$var$char(177),
    boundryChar: $36ab284eb4b1b616$var$char(179),
    objStart: $36ab284eb4b1b616$var$char(198),
    arrStart: $36ab284eb4b1b616$var$char(204),
    arrayEnd: $36ab284eb4b1b616$var$char(185)
};
const $36ab284eb4b1b616$var$charsArr = [
    $36ab284eb4b1b616$var$chars.nilChar,
    $36ab284eb4b1b616$var$chars.nilPremitive,
    $36ab284eb4b1b616$var$chars.missingChar,
    $36ab284eb4b1b616$var$chars.missingPremitive,
    $36ab284eb4b1b616$var$chars.boundryChar,
    $36ab284eb4b1b616$var$chars.emptyChar,
    $36ab284eb4b1b616$var$chars.emptyValue,
    $36ab284eb4b1b616$var$chars.arrayEnd,
    $36ab284eb4b1b616$var$chars.objStart,
    $36ab284eb4b1b616$var$chars.arrStart
];
const $36ab284eb4b1b616$var$_e = function(node, e_schema, options) {
    if (typeof e_schema === 'string') {
        //premitive
        if (node && node[0] && node[0].val !== undefined) return $36ab284eb4b1b616$var$getValue(node[0].val, e_schema);
        else return $36ab284eb4b1b616$var$getValue(node, e_schema);
    } else {
        const hasValidData = $36ab284eb4b1b616$var$hasData(node);
        if (hasValidData === true) {
            let str = '';
            if (Array.isArray(e_schema)) {
                //attributes can't be repeated. hence check in children tags only
                str += $36ab284eb4b1b616$var$chars.arrStart;
                const itemSchema = e_schema[0];
                //const itemSchemaType = itemSchema;
                const arr_len = node.length;
                if (typeof itemSchema === 'string') for(let arr_i = 0; arr_i < arr_len; arr_i++){
                    const r = $36ab284eb4b1b616$var$getValue(node[arr_i].val, itemSchema);
                    str = $36ab284eb4b1b616$var$processValue(str, r);
                }
                else for(let arr_i = 0; arr_i < arr_len; arr_i++){
                    const r = $36ab284eb4b1b616$var$_e(node[arr_i], itemSchema, options);
                    str = $36ab284eb4b1b616$var$processValue(str, r);
                }
                str += $36ab284eb4b1b616$var$chars.arrayEnd; //indicates that next item is not array item
            } else {
                //object
                str += $36ab284eb4b1b616$var$chars.objStart;
                const keys = Object.keys(e_schema);
                if (Array.isArray(node)) node = node[0];
                for(let i in keys){
                    const key = keys[i];
                    //a property defined in schema can be present either in attrsMap or children tags
                    //options.textNodeName will not present in both maps, take it's value from val
                    //options.attrNodeName will be present in attrsMap
                    let r;
                    if (!options.ignoreAttributes && node.attrsMap && node.attrsMap[key]) r = $36ab284eb4b1b616$var$_e(node.attrsMap[key], e_schema[key], options);
                    else if (key === options.textNodeName) r = $36ab284eb4b1b616$var$_e(node.val, e_schema[key], options);
                    else r = $36ab284eb4b1b616$var$_e(node.child[key], e_schema[key], options);
                    str = $36ab284eb4b1b616$var$processValue(str, r);
                }
            }
            return str;
        } else return hasValidData;
    }
};
const $36ab284eb4b1b616$var$getValue = function(a /*, type*/ ) {
    switch(a){
        case undefined:
            return $36ab284eb4b1b616$var$chars.missingPremitive;
        case null:
            return $36ab284eb4b1b616$var$chars.nilPremitive;
        case '':
            return $36ab284eb4b1b616$var$chars.emptyValue;
        default:
            return a;
    }
};
const $36ab284eb4b1b616$var$processValue = function(str, r) {
    if (!$36ab284eb4b1b616$var$isAppChar(r[0]) && !$36ab284eb4b1b616$var$isAppChar(str[str.length - 1])) str += $36ab284eb4b1b616$var$chars.boundryChar;
    return str + r;
};
const $36ab284eb4b1b616$var$isAppChar = function(ch) {
    return $36ab284eb4b1b616$var$charsArr.indexOf(ch) !== -1;
};
function $36ab284eb4b1b616$var$hasData(jObj) {
    if (jObj === undefined) return $36ab284eb4b1b616$var$chars.missingChar;
    else if (jObj === null) return $36ab284eb4b1b616$var$chars.nilChar;
    else if (jObj.child && Object.keys(jObj.child).length === 0 && (!jObj.attrsMap || Object.keys(jObj.attrsMap).length === 0)) return $36ab284eb4b1b616$var$chars.emptyChar;
    else return true;
}

var $5SpIl = parcelRequire("5SpIl");

var $eUZ0B = parcelRequire("eUZ0B");
var $36ab284eb4b1b616$require$buildOptions = $eUZ0B.buildOptions;
const $36ab284eb4b1b616$var$convert2nimn = function(node, e_schema, options) {
    options = $36ab284eb4b1b616$require$buildOptions(options, $5SpIl.defaultOptions, $5SpIl.props);
    return $36ab284eb4b1b616$var$_e(node, e_schema, options);
};
$36ab284eb4b1b616$export$fa981bbccf843781 = $36ab284eb4b1b616$var$convert2nimn;

});
parcelRegister("5SpIl", function(module, exports) {

$parcel$export(module.exports, "defaultOptions", function () { return $4475f135053d8b07$export$ba43bf67f3d48107; }, function (v) { return $4475f135053d8b07$export$ba43bf67f3d48107 = v; });
$parcel$export(module.exports, "props", function () { return $4475f135053d8b07$export$8128bb6492cf3de7; }, function (v) { return $4475f135053d8b07$export$8128bb6492cf3de7 = v; });
$parcel$export(module.exports, "getTraversalObj", function () { return $4475f135053d8b07$export$2ca3eb0a2f8a693a; }, function (v) { return $4475f135053d8b07$export$2ca3eb0a2f8a693a = v; });
var $4475f135053d8b07$export$ba43bf67f3d48107;
var $4475f135053d8b07$export$8128bb6492cf3de7;
var $4475f135053d8b07$export$2ca3eb0a2f8a693a;
'use strict';

var $eUZ0B = parcelRequire("eUZ0B");

var $eUZ0B = parcelRequire("eUZ0B");
var $4475f135053d8b07$require$buildOptions = $eUZ0B.buildOptions;

var $2fhoO = parcelRequire("2fhoO");

var $1V9L7 = parcelRequire("1V9L7");
const $4475f135053d8b07$var$regx = '<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)'.replace(/NAME/g, $eUZ0B.nameRegexp);
//const tagsRegx = new RegExp("<(\\/?[\\w:\\-\._]+)([^>]*)>(\\s*"+cdataRegx+")*([^<]+)?","g");
//const tagsRegx = new RegExp("<(\\/?)((\\w*:)?([\\w:\\-\._]+))([^>]*)>([^<]*)("+cdataRegx+"([^<]*))*([^<]+)?","g");
//polyfill
if (!Number.parseInt && window.parseInt) Number.parseInt = window.parseInt;
if (!Number.parseFloat && window.parseFloat) Number.parseFloat = window.parseFloat;
const $4475f135053d8b07$var$defaultOptions = {
    attributeNamePrefix: '@_',
    attrNodeName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    ignoreNameSpace: false,
    allowBooleanAttributes: false,
    //ignoreRootElement : false,
    parseNodeValue: true,
    parseAttributeValue: false,
    arrayMode: false,
    trimValues: true,
    cdataTagName: false,
    cdataPositionChar: '\\c',
    numParseOptions: {
        hex: true,
        leadingZeros: true
    },
    tagValueProcessor: function(a, tagName) {
        return a;
    },
    attrValueProcessor: function(a, attrName) {
        return a;
    },
    stopNodes: [],
    alwaysCreateTextNode: false
};
$4475f135053d8b07$export$ba43bf67f3d48107 = $4475f135053d8b07$var$defaultOptions;
const $4475f135053d8b07$var$props = [
    'attributeNamePrefix',
    'attrNodeName',
    'textNodeName',
    'ignoreAttributes',
    'ignoreNameSpace',
    'allowBooleanAttributes',
    'parseNodeValue',
    'parseAttributeValue',
    'arrayMode',
    'trimValues',
    'cdataTagName',
    'cdataPositionChar',
    'tagValueProcessor',
    'attrValueProcessor',
    'parseTrueNumberOnly',
    'numParseOptions',
    'stopNodes',
    'alwaysCreateTextNode'
];
$4475f135053d8b07$export$8128bb6492cf3de7 = $4475f135053d8b07$var$props;
/**
 * Trim -> valueProcessor -> parse value
 * @param {string} tagName
 * @param {string} val
 * @param {object} options
 */ function $4475f135053d8b07$var$processTagValue(tagName, val, options) {
    if (val) {
        if (options.trimValues) val = val.trim();
        val = options.tagValueProcessor(val, tagName);
        val = $4475f135053d8b07$var$parseValue(val, options.parseNodeValue, options.numParseOptions);
    }
    return val;
}
function $4475f135053d8b07$var$resolveNameSpace(tagname, options) {
    if (options.ignoreNameSpace) {
        const tags = tagname.split(':');
        const prefix = tagname.charAt(0) === '/' ? '/' : '';
        if (tags[0] === 'xmlns') return '';
        if (tags.length === 2) tagname = prefix + tags[1];
    }
    return tagname;
}
function $4475f135053d8b07$var$parseValue(val, shouldParse, options) {
    if (shouldParse && typeof val === 'string') {
        //console.log(options)
        const newval = val.trim();
        if (newval === 'true') return true;
        else if (newval === 'false') return false;
        else return $1V9L7(val, options);
    } else {
        if ($eUZ0B.isExist(val)) return val;
        else return '';
    }
}
//TODO: change regex to capture NS
//const attrsRegx = new RegExp("([\\w\\-\\.\\:]+)\\s*=\\s*(['\"])((.|\n)*?)\\2","gm");
const $4475f135053d8b07$var$attrsRegx = new RegExp('([^\\s=]+)\\s*(=\\s*([\'"])(.*?)\\3)?', 'g');
function $4475f135053d8b07$var$buildAttributesMap(attrStr, options) {
    if (!options.ignoreAttributes && typeof attrStr === 'string') {
        attrStr = attrStr.replace(/\r?\n/g, ' ');
        //attrStr = attrStr || attrStr.trim();
        const matches = $eUZ0B.getAllMatches(attrStr, $4475f135053d8b07$var$attrsRegx);
        const len = matches.length; //don't make it inline
        const attrs = {};
        for(let i = 0; i < len; i++){
            const attrName = $4475f135053d8b07$var$resolveNameSpace(matches[i][1], options);
            if (attrName.length) {
                if (matches[i][4] !== undefined) {
                    if (options.trimValues) matches[i][4] = matches[i][4].trim();
                    matches[i][4] = options.attrValueProcessor(matches[i][4], attrName);
                    attrs[options.attributeNamePrefix + attrName] = $4475f135053d8b07$var$parseValue(matches[i][4], options.parseAttributeValue, options.numParseOptions);
                } else if (options.allowBooleanAttributes) attrs[options.attributeNamePrefix + attrName] = true;
            }
        }
        if (!Object.keys(attrs).length) return;
        if (options.attrNodeName) {
            const attrCollection = {};
            attrCollection[options.attrNodeName] = attrs;
            return attrCollection;
        }
        return attrs;
    }
}
const $4475f135053d8b07$var$getTraversalObj = function(xmlData, options) {
    xmlData = xmlData.replace(/\r\n?/g, "\n");
    options = $4475f135053d8b07$require$buildOptions(options, $4475f135053d8b07$var$defaultOptions, $4475f135053d8b07$var$props);
    const xmlObj = new $2fhoO('!xml');
    let currentNode = xmlObj;
    let textData = "";
    //function match(xmlData){
    for(let i = 0; i < xmlData.length; i++){
        const ch = xmlData[i];
        if (ch === '<') {
            if (xmlData[i + 1] === '/') {
                const closeIndex = $4475f135053d8b07$var$findClosingIndex(xmlData, ">", i, "Closing Tag is not closed.");
                let tagName = xmlData.substring(i + 2, closeIndex).trim();
                if (options.ignoreNameSpace) {
                    const colonIndex = tagName.indexOf(":");
                    if (colonIndex !== -1) tagName = tagName.substr(colonIndex + 1);
                }
                /* if (currentNode.parent) {
          currentNode.parent.val = util.getValue(currentNode.parent.val) + '' + processTagValue2(tagName, textData , options);
        } */ if (currentNode) {
                    if (currentNode.val) currentNode.val = $eUZ0B.getValue(currentNode.val) + '' + $4475f135053d8b07$var$processTagValue(tagName, textData, options);
                    else currentNode.val = $4475f135053d8b07$var$processTagValue(tagName, textData, options);
                }
                if (options.stopNodes.length && options.stopNodes.includes(currentNode.tagname)) {
                    currentNode.child = [];
                    if (currentNode.attrsMap == undefined) currentNode.attrsMap = {};
                    currentNode.val = xmlData.substr(currentNode.startIndex + 1, i - currentNode.startIndex - 1);
                }
                currentNode = currentNode.parent;
                textData = "";
                i = closeIndex;
            } else if (xmlData[i + 1] === '?') i = $4475f135053d8b07$var$findClosingIndex(xmlData, "?>", i, "Pi Tag is not closed.");
            else if (xmlData.substr(i + 1, 3) === '!--') i = $4475f135053d8b07$var$findClosingIndex(xmlData, "-->", i, "Comment is not closed.");
            else if (xmlData.substr(i + 1, 2) === '!D') {
                const closeIndex = $4475f135053d8b07$var$findClosingIndex(xmlData, ">", i, "DOCTYPE is not closed.");
                const tagExp = xmlData.substring(i, closeIndex);
                if (tagExp.indexOf("[") >= 0) i = xmlData.indexOf("]>", i) + 1;
                else i = closeIndex;
            } else if (xmlData.substr(i + 1, 2) === '![') {
                const closeIndex = $4475f135053d8b07$var$findClosingIndex(xmlData, "]]>", i, "CDATA is not closed.") - 2;
                const tagExp = xmlData.substring(i + 9, closeIndex);
                //considerations
                //1. CDATA will always have parent node
                //2. A tag with CDATA is not a leaf node so it's value would be string type.
                if (textData) {
                    currentNode.val = $eUZ0B.getValue(currentNode.val) + '' + $4475f135053d8b07$var$processTagValue(currentNode.tagname, textData, options);
                    textData = "";
                }
                if (options.cdataTagName) {
                    //add cdata node
                    const childNode = new $2fhoO(options.cdataTagName, currentNode, tagExp);
                    currentNode.addChild(childNode);
                    //for backtracking
                    currentNode.val = $eUZ0B.getValue(currentNode.val) + options.cdataPositionChar;
                    //add rest value to parent node
                    if (tagExp) childNode.val = tagExp;
                } else currentNode.val = (currentNode.val || '') + (tagExp || '');
                i = closeIndex + 2;
            } else {
                const result = $4475f135053d8b07$var$closingIndexForOpeningTag(xmlData, i + 1);
                let tagExp = result.data;
                const closeIndex = result.index;
                const separatorIndex = tagExp.indexOf(" ");
                let tagName = tagExp;
                let shouldBuildAttributesMap = true;
                if (separatorIndex !== -1) {
                    tagName = tagExp.substr(0, separatorIndex).replace(/\s\s*$/, '');
                    tagExp = tagExp.substr(separatorIndex + 1);
                }
                if (options.ignoreNameSpace) {
                    const colonIndex = tagName.indexOf(":");
                    if (colonIndex !== -1) {
                        tagName = tagName.substr(colonIndex + 1);
                        shouldBuildAttributesMap = tagName !== result.data.substr(colonIndex + 1);
                    }
                }
                //save text to parent node
                if (currentNode && textData) {
                    if (currentNode.tagname !== '!xml') currentNode.val = $eUZ0B.getValue(currentNode.val) + '' + $4475f135053d8b07$var$processTagValue(currentNode.tagname, textData, options);
                }
                if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
                    if (tagName[tagName.length - 1] === "/") {
                        tagName = tagName.substr(0, tagName.length - 1);
                        tagExp = tagName;
                    } else tagExp = tagExp.substr(0, tagExp.length - 1);
                    const childNode = new $2fhoO(tagName, currentNode, '');
                    if (tagName !== tagExp) childNode.attrsMap = $4475f135053d8b07$var$buildAttributesMap(tagExp, options);
                    currentNode.addChild(childNode);
                } else {
                    const childNode = new $2fhoO(tagName, currentNode);
                    if (options.stopNodes.length && options.stopNodes.includes(childNode.tagname)) childNode.startIndex = closeIndex;
                    if (tagName !== tagExp && shouldBuildAttributesMap) childNode.attrsMap = $4475f135053d8b07$var$buildAttributesMap(tagExp, options);
                    currentNode.addChild(childNode);
                    currentNode = childNode;
                }
                textData = "";
                i = closeIndex;
            }
        } else textData += xmlData[i];
    }
    return xmlObj;
};
function $4475f135053d8b07$var$closingIndexForOpeningTag(data, i) {
    let attrBoundary;
    let tagExp = "";
    for(let index = i; index < data.length; index++){
        let ch = data[index];
        if (attrBoundary) {
            if (ch === attrBoundary) attrBoundary = ""; //reset
        } else if (ch === '"' || ch === "'") attrBoundary = ch;
        else if (ch === '>') return {
            data: tagExp,
            index: index
        };
        else if (ch === '\t') ch = " ";
        tagExp += ch;
    }
}
function $4475f135053d8b07$var$findClosingIndex(xmlData, str, i, errMsg) {
    const closingIndex = xmlData.indexOf(str, i);
    if (closingIndex === -1) throw new Error(errMsg);
    else return closingIndex + str.length - 1;
}
$4475f135053d8b07$export$2ca3eb0a2f8a693a = $4475f135053d8b07$var$getTraversalObj;

});
parcelRegister("eUZ0B", function(module, exports) {

$parcel$export(module.exports, "isExist", function () { return $adc59eb1d8243b0d$export$a5edf3f35b6dd392; }, function (v) { return $adc59eb1d8243b0d$export$a5edf3f35b6dd392 = v; });
$parcel$export(module.exports, "isEmptyObject", function () { return $adc59eb1d8243b0d$export$83b788b1a3698c03; }, function (v) { return $adc59eb1d8243b0d$export$83b788b1a3698c03 = v; });
$parcel$export(module.exports, "merge", function () { return $adc59eb1d8243b0d$export$4950aa0f605343fb; }, function (v) { return $adc59eb1d8243b0d$export$4950aa0f605343fb = v; });
$parcel$export(module.exports, "getValue", function () { return $adc59eb1d8243b0d$export$bf7199a9ebcb84a9; }, function (v) { return $adc59eb1d8243b0d$export$bf7199a9ebcb84a9 = v; });
$parcel$export(module.exports, "buildOptions", function () { return $adc59eb1d8243b0d$export$ecbd7d678ac4909b; }, function (v) { return $adc59eb1d8243b0d$export$ecbd7d678ac4909b = v; });
$parcel$export(module.exports, "isTagNameInArrayMode", function () { return $adc59eb1d8243b0d$export$fd3b6180ca5b0284; }, function (v) { return $adc59eb1d8243b0d$export$fd3b6180ca5b0284 = v; });
$parcel$export(module.exports, "isName", function () { return $adc59eb1d8243b0d$export$998d7ff9801e90bb; }, function (v) { return $adc59eb1d8243b0d$export$998d7ff9801e90bb = v; });
$parcel$export(module.exports, "getAllMatches", function () { return $adc59eb1d8243b0d$export$aaa9734c55cb7a19; }, function (v) { return $adc59eb1d8243b0d$export$aaa9734c55cb7a19 = v; });
$parcel$export(module.exports, "nameRegexp", function () { return $adc59eb1d8243b0d$export$e8f2644f7085b4b1; }, function (v) { return $adc59eb1d8243b0d$export$e8f2644f7085b4b1 = v; });
var $adc59eb1d8243b0d$export$a5edf3f35b6dd392;
var $adc59eb1d8243b0d$export$83b788b1a3698c03;
/**
 * Copy all the properties of a into b.
 * @param {*} target
 * @param {*} a
 */ var $adc59eb1d8243b0d$export$4950aa0f605343fb;
/* exports.merge =function (b,a){
  return Object.assign(b,a);
} */ var $adc59eb1d8243b0d$export$bf7199a9ebcb84a9;
// const fakeCall = function(a) {return a;};
// const fakeCallNoReturn = function() {};
var $adc59eb1d8243b0d$export$ecbd7d678ac4909b;
/**
 * Check if a tag name should be treated as array
 *
 * @param tagName the node tagname
 * @param arrayMode the array mode option
 * @param parentTagName the parent tag name
 * @returns {boolean} true if node should be parsed as array
 */ var $adc59eb1d8243b0d$export$fd3b6180ca5b0284;
var $adc59eb1d8243b0d$export$998d7ff9801e90bb;
var $adc59eb1d8243b0d$export$aaa9734c55cb7a19;
var $adc59eb1d8243b0d$export$e8f2644f7085b4b1;
'use strict';
const $adc59eb1d8243b0d$var$nameStartChar = ':A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
const $adc59eb1d8243b0d$var$nameChar = $adc59eb1d8243b0d$var$nameStartChar + '\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
const $adc59eb1d8243b0d$var$nameRegexp = '[' + $adc59eb1d8243b0d$var$nameStartChar + '][' + $adc59eb1d8243b0d$var$nameChar + ']*';
const $adc59eb1d8243b0d$var$regexName = new RegExp('^' + $adc59eb1d8243b0d$var$nameRegexp + '$');
const $adc59eb1d8243b0d$var$getAllMatches = function(string, regex) {
    const matches = [];
    let match = regex.exec(string);
    while(match){
        const allmatches = [];
        allmatches.startIndex = regex.lastIndex - match[0].length;
        const len = match.length;
        for(let index = 0; index < len; index++)allmatches.push(match[index]);
        matches.push(allmatches);
        match = regex.exec(string);
    }
    return matches;
};
const $adc59eb1d8243b0d$var$isName = function(string) {
    const match = $adc59eb1d8243b0d$var$regexName.exec(string);
    return !(match === null || typeof match === 'undefined');
};
$adc59eb1d8243b0d$export$a5edf3f35b6dd392 = function(v) {
    return typeof v !== 'undefined';
};
$adc59eb1d8243b0d$export$83b788b1a3698c03 = function(obj) {
    return Object.keys(obj).length === 0;
};
$adc59eb1d8243b0d$export$4950aa0f605343fb = function(target, a, arrayMode) {
    if (a) {
        const keys = Object.keys(a); // will return an array of own properties
        const len = keys.length; //don't make it inline
        for(let i = 0; i < len; i++)if (arrayMode === 'strict') target[keys[i]] = [
            a[keys[i]]
        ];
        else target[keys[i]] = a[keys[i]];
    }
};
$adc59eb1d8243b0d$export$bf7199a9ebcb84a9 = function(v) {
    if ($adc59eb1d8243b0d$export$a5edf3f35b6dd392(v)) return v;
    else return '';
};
$adc59eb1d8243b0d$export$ecbd7d678ac4909b = function(options, defaultOptions, props) {
    let newOptions = {};
    if (!options) return defaultOptions; //if there are not options
    for(let i = 0; i < props.length; i++)if (options[props[i]] !== undefined) newOptions[props[i]] = options[props[i]];
    else newOptions[props[i]] = defaultOptions[props[i]];
    return newOptions;
};
$adc59eb1d8243b0d$export$fd3b6180ca5b0284 = function(tagName, arrayMode, parentTagName) {
    if (arrayMode === false) return false;
    else if (arrayMode instanceof RegExp) return arrayMode.test(tagName);
    else if (typeof arrayMode === 'function') return !!arrayMode(tagName, parentTagName);
    return arrayMode === "strict";
};
$adc59eb1d8243b0d$export$998d7ff9801e90bb = $adc59eb1d8243b0d$var$isName;
$adc59eb1d8243b0d$export$aaa9734c55cb7a19 = $adc59eb1d8243b0d$var$getAllMatches;
$adc59eb1d8243b0d$export$e8f2644f7085b4b1 = $adc59eb1d8243b0d$var$nameRegexp;

});

parcelRegister("2fhoO", function(module, exports) {
'use strict';
module.exports = function(tagname, parent, val) {
    this.tagname = tagname;
    this.parent = parent;
    this.child = {}; //child tags
    this.attrsMap = {}; //attributes map
    this.val = val; //text only
    this.addChild = function(child) {
        if (Array.isArray(this.child[child.tagname])) //already presents
        this.child[child.tagname].push(child);
        else this.child[child.tagname] = [
            child
        ];
    };
};

});

parcelRegister("1V9L7", function(module, exports) {
const $1662af4326959fcf$var$hexRegex = /^[-+]?0x[a-fA-F0-9]+$/;
const $1662af4326959fcf$var$numRegex = /^([\-\+])?(0*)([0-9]*(\.[0-9]*)?)$/;
// const octRegex = /^0x[a-z0-9]+/;
// const binRegex = /0x[a-z0-9]+/;
const $1662af4326959fcf$var$consider = {
    hex: true,
    // oct: false,
    leadingZeros: true,
    decimalPoint: "\.",
    eNotation: true
};
function $1662af4326959fcf$var$toNumber(str, options = {}) {
    options = Object.assign({}, $1662af4326959fcf$var$consider, options);
    if (!str || typeof str !== "string") return str;
    let trimmedStr = str.trim();
    if (options.skipLike !== undefined && options.skipLike.test(trimmedStr)) return str;
    else if (str === "0") return 0;
    else if (options.hex && $1662af4326959fcf$var$hexRegex.test(trimmedStr)) return $1662af4326959fcf$var$parse_int(trimmedStr, 16);
    else if (trimmedStr.search(/[eE]/) !== -1) {
        const notation = trimmedStr.match(/^([-\+])?(0*)([0-9]*(\.[0-9]*)?[eE][-\+]?[0-9]+)$/);
        // +00.123 => [ , '+', '00', '.123', ..
        if (notation) {
            // console.log(notation)
            if (options.leadingZeros) trimmedStr = (notation[1] || "") + notation[3];
            else {
                if (notation[2] === "0" && notation[3][0] === ".") ;
                else return str;
            }
            return options.eNotation ? Number(trimmedStr) : str;
        } else return str;
    // }else if (options.parseBin && binRegex.test(str)) {
    //     return Number.parseInt(val, 2);
    } else {
        //separate negative sign, leading zeros, and rest number
        const match = $1662af4326959fcf$var$numRegex.exec(trimmedStr);
        // +00.123 => [ , '+', '00', '.123', ..
        if (match) {
            const sign = match[1];
            const leadingZeros = match[2];
            let numTrimmedByZeros = $1662af4326959fcf$var$trimZeros(match[3]); //complete num without leading zeros
            //trim ending zeros for floating number
            if (!options.leadingZeros && leadingZeros.length > 0 && sign && trimmedStr[2] !== ".") return str; //-0123
            else if (!options.leadingZeros && leadingZeros.length > 0 && !sign && trimmedStr[1] !== ".") return str; //0123
            else if (options.leadingZeros && leadingZeros === str) return 0; //00
            else {
                const num = Number(trimmedStr);
                const numStr = "" + num;
                if (numStr.search(/[eE]/) !== -1) {
                    if (options.eNotation) return num;
                    else return str;
                } else if (trimmedStr.indexOf(".") !== -1) {
                    if (numStr === "0" && numTrimmedByZeros === "") return num; //0.0
                    else if (numStr === numTrimmedByZeros) return num; //0.456. 0.79000
                    else if (sign && numStr === "-" + numTrimmedByZeros) return num;
                    else return str;
                }
                if (leadingZeros) return numTrimmedByZeros === numStr || sign + numTrimmedByZeros === numStr ? num : str;
                else return trimmedStr === numStr || trimmedStr === sign + numStr ? num : str;
            }
        } else return str;
    }
}
/**
 * 
 * @param {string} numStr without leading zeros
 * @returns 
 */ function $1662af4326959fcf$var$trimZeros(numStr) {
    if (numStr && numStr.indexOf(".") !== -1) {
        numStr = numStr.replace(/0+$/, ""); //remove ending zeros
        if (numStr === ".") numStr = "0";
        else if (numStr[0] === ".") numStr = "0" + numStr;
        else if (numStr[numStr.length - 1] === ".") numStr = numStr.substr(0, numStr.length - 1);
        return numStr;
    }
    return numStr;
}
function $1662af4326959fcf$var$parse_int(numStr, base) {
    //polyfill
    if (parseInt) return parseInt(numStr, base);
    else if (Number.parseInt) return Number.parseInt(numStr, base);
    else if (window && window.parseInt) return window.parseInt(numStr, base);
    else throw new Error("parseInt, Number.parseInt, window.parseInt are not supported");
}
module.exports = $1662af4326959fcf$var$toNumber;

});



parcelRegister("4FAO3", function(module, exports) {

$parcel$export(module.exports, "convertToJsonString", function () { return $36678aba8844d465$export$54ffaacfc0931fb0; }, function (v) { return $36678aba8844d465$export$54ffaacfc0931fb0 = v; });
var $36678aba8844d465$export$54ffaacfc0931fb0;
'use strict';

var $eUZ0B = parcelRequire("eUZ0B");

var $eUZ0B = parcelRequire("eUZ0B");
var $36678aba8844d465$require$buildOptions = $eUZ0B.buildOptions;

var $5SpIl = parcelRequire("5SpIl");
//TODO: do it later
const $36678aba8844d465$var$convertToJsonString = function(node, options) {
    options = $36678aba8844d465$require$buildOptions(options, $5SpIl.defaultOptions, $5SpIl.props);
    options.indentBy = options.indentBy || '';
    return $36678aba8844d465$var$_cToJsonStr(node, options, 0);
};
const $36678aba8844d465$var$_cToJsonStr = function(node, options, level) {
    let jObj = '{';
    //traver through all the children
    const keys = Object.keys(node.child);
    for(let index = 0; index < keys.length; index++){
        const tagname = keys[index];
        if (node.child[tagname] && node.child[tagname].length > 1) {
            jObj += '"' + tagname + '" : [ ';
            for(let tag in node.child[tagname])jObj += $36678aba8844d465$var$_cToJsonStr(node.child[tagname][tag], options) + ' , ';
            jObj = jObj.substr(0, jObj.length - 1) + ' ] '; //remove extra comma in last
        } else jObj += '"' + tagname + '" : ' + $36678aba8844d465$var$_cToJsonStr(node.child[tagname][0], options) + ' ,';
    }
    $eUZ0B.merge(jObj, node.attrsMap);
    //add attrsMap as new children
    if ($eUZ0B.isEmptyObject(jObj)) return $eUZ0B.isExist(node.val) ? node.val : '';
    else {
        if ($eUZ0B.isExist(node.val)) {
            if (!(typeof node.val === 'string' && (node.val === '' || node.val === options.cdataPositionChar))) jObj += '"' + options.textNodeName + '" : ' + $36678aba8844d465$var$stringval(node.val);
        }
    }
    //add value
    if (jObj[jObj.length - 1] === ',') jObj = jObj.substr(0, jObj.length - 2);
    return jObj + '}';
};
function $36678aba8844d465$var$stringval(v) {
    if (v === true || v === false || !isNaN(v)) return v;
    else return '"' + v + '"';
}
function $36678aba8844d465$var$indentate(options, level) {
    return options.indentBy.repeat(level);
}
$36678aba8844d465$export$54ffaacfc0931fb0 = $36678aba8844d465$var$convertToJsonString;

});

parcelRegister("132i0", function(module, exports) {
'use strict';

var $eUZ0B = parcelRequire("eUZ0B");
var $0c37d8e883c80c7c$require$buildOptions = $eUZ0B.buildOptions;
const $0c37d8e883c80c7c$var$defaultOptions = {
    attributeNamePrefix: '@_',
    attrNodeName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    cdataTagName: false,
    cdataPositionChar: '\\c',
    format: false,
    indentBy: '  ',
    supressEmptyNode: false,
    tagValueProcessor: function(a) {
        return a;
    },
    attrValueProcessor: function(a) {
        return a;
    }
};
const $0c37d8e883c80c7c$var$props = [
    'attributeNamePrefix',
    'attrNodeName',
    'textNodeName',
    'ignoreAttributes',
    'cdataTagName',
    'cdataPositionChar',
    'format',
    'indentBy',
    'supressEmptyNode',
    'tagValueProcessor',
    'attrValueProcessor',
    'rootNodeName'
];
function $0c37d8e883c80c7c$var$Parser(options) {
    this.options = $0c37d8e883c80c7c$require$buildOptions(options, $0c37d8e883c80c7c$var$defaultOptions, $0c37d8e883c80c7c$var$props);
    if (this.options.ignoreAttributes || this.options.attrNodeName) this.isAttribute = function() {
        return false;
    };
    else {
        this.attrPrefixLen = this.options.attributeNamePrefix.length;
        this.isAttribute = $0c37d8e883c80c7c$var$isAttribute;
    }
    if (this.options.cdataTagName) this.isCDATA = $0c37d8e883c80c7c$var$isCDATA;
    else this.isCDATA = function() {
        return false;
    };
    this.replaceCDATAstr = $0c37d8e883c80c7c$var$replaceCDATAstr;
    this.replaceCDATAarr = $0c37d8e883c80c7c$var$replaceCDATAarr;
    this.processTextOrObjNode = $0c37d8e883c80c7c$var$processTextOrObjNode;
    if (this.options.format) {
        this.indentate = $0c37d8e883c80c7c$var$indentate;
        this.tagEndChar = '>\n';
        this.newLine = '\n';
    } else {
        this.indentate = function() {
            return '';
        };
        this.tagEndChar = '>';
        this.newLine = '';
    }
    if (this.options.supressEmptyNode) {
        this.buildTextNode = $0c37d8e883c80c7c$var$buildEmptyTextNode;
        this.buildObjNode = $0c37d8e883c80c7c$var$buildEmptyObjNode;
    } else {
        this.buildTextNode = $0c37d8e883c80c7c$var$buildTextValNode;
        this.buildObjNode = $0c37d8e883c80c7c$var$buildObjectNode;
    }
    this.buildTextValNode = $0c37d8e883c80c7c$var$buildTextValNode;
    this.buildObjectNode = $0c37d8e883c80c7c$var$buildObjectNode;
}
$0c37d8e883c80c7c$var$Parser.prototype.parse = function(jObj) {
    if (Array.isArray(jObj) && this.options.rootNodeName && this.options.rootNodeName.length > 1) jObj = {
        [this.options.rootNodeName]: jObj
    };
    return this.j2x(jObj, 0).val;
};
$0c37d8e883c80c7c$var$Parser.prototype.j2x = function(jObj, level) {
    let attrStr = '';
    let val = '';
    for(let key in jObj){
        if (typeof jObj[key] === 'undefined') ;
        else if (jObj[key] === null) val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
        else if (jObj[key] instanceof Date) val += this.buildTextNode(jObj[key], key, '', level);
        else if (typeof jObj[key] !== 'object') {
            //premitive type
            const attr = this.isAttribute(key);
            if (attr) attrStr += ' ' + attr + '="' + this.options.attrValueProcessor('' + jObj[key]) + '"';
            else if (this.isCDATA(key)) {
                if (jObj[this.options.textNodeName]) val += this.replaceCDATAstr(jObj[this.options.textNodeName], jObj[key]);
                else val += this.replaceCDATAstr('', jObj[key]);
            } else //tag value
            if (key === this.options.textNodeName) {
                if (jObj[this.options.cdataTagName]) ;
                else val += this.options.tagValueProcessor('' + jObj[key]);
            } else val += this.buildTextNode(jObj[key], key, '', level);
        } else if (Array.isArray(jObj[key])) {
            //repeated nodes
            if (this.isCDATA(key)) {
                val += this.indentate(level);
                if (jObj[this.options.textNodeName]) val += this.replaceCDATAarr(jObj[this.options.textNodeName], jObj[key]);
                else val += this.replaceCDATAarr('', jObj[key]);
            } else {
                //nested nodes
                const arrLen = jObj[key].length;
                for(let j = 0; j < arrLen; j++){
                    const item = jObj[key][j];
                    if (typeof item === 'undefined') ;
                    else if (item === null) val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
                    else if (typeof item === 'object') val += this.processTextOrObjNode(item, key, level);
                    else val += this.buildTextNode(item, key, '', level);
                }
            }
        } else //nested node
        if (this.options.attrNodeName && key === this.options.attrNodeName) {
            const Ks = Object.keys(jObj[key]);
            const L = Ks.length;
            for(let j = 0; j < L; j++)attrStr += ' ' + Ks[j] + '="' + this.options.attrValueProcessor('' + jObj[key][Ks[j]]) + '"';
        } else val += this.processTextOrObjNode(jObj[key], key, level);
    }
    return {
        attrStr: attrStr,
        val: val
    };
};
function $0c37d8e883c80c7c$var$processTextOrObjNode(object, key, level) {
    const result = this.j2x(object, level + 1);
    if (object[this.options.textNodeName] !== undefined && Object.keys(object).length === 1) return this.buildTextNode(result.val, key, result.attrStr, level);
    else return this.buildObjNode(result.val, key, result.attrStr, level);
}
function $0c37d8e883c80c7c$var$replaceCDATAstr(str, cdata) {
    str = this.options.tagValueProcessor('' + str);
    if (this.options.cdataPositionChar === '' || str === '') return str + '<![CDATA[' + cdata + ']]' + this.tagEndChar;
    else return str.replace(this.options.cdataPositionChar, '<![CDATA[' + cdata + ']]' + this.tagEndChar);
}
function $0c37d8e883c80c7c$var$replaceCDATAarr(str, cdata) {
    str = this.options.tagValueProcessor('' + str);
    if (this.options.cdataPositionChar === '' || str === '') return str + '<![CDATA[' + cdata.join(']]><![CDATA[') + ']]' + this.tagEndChar;
    else {
        for(let v in cdata)str = str.replace(this.options.cdataPositionChar, '<![CDATA[' + cdata[v] + ']]>');
        return str + this.newLine;
    }
}
function $0c37d8e883c80c7c$var$buildObjectNode(val, key, attrStr, level) {
    if (attrStr && val.indexOf('<') === -1) return this.indentate(level) + '<' + key + attrStr + '>' + val + //+ this.newLine
    // + this.indentate(level)
    '</' + key + this.tagEndChar;
    else return this.indentate(level) + '<' + key + attrStr + this.tagEndChar + val + //+ this.newLine
    this.indentate(level) + '</' + key + this.tagEndChar;
}
function $0c37d8e883c80c7c$var$buildEmptyObjNode(val, key, attrStr, level) {
    if (val !== '') return this.buildObjectNode(val, key, attrStr, level);
    else return this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar;
}
function $0c37d8e883c80c7c$var$buildTextValNode(val, key, attrStr, level) {
    return this.indentate(level) + '<' + key + attrStr + '>' + this.options.tagValueProcessor(val) + '</' + key + this.tagEndChar;
}
function $0c37d8e883c80c7c$var$buildEmptyTextNode(val, key, attrStr, level) {
    if (val !== '') return this.buildTextValNode(val, key, attrStr, level);
    else return this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar;
}
function $0c37d8e883c80c7c$var$indentate(level) {
    return this.options.indentBy.repeat(level);
}
function $0c37d8e883c80c7c$var$isAttribute(name /*, options*/ ) {
    if (name.startsWith(this.options.attributeNamePrefix)) return name.substr(this.attrPrefixLen);
    else return false;
}
function $0c37d8e883c80c7c$var$isCDATA(name) {
    return name === this.options.cdataTagName;
}
//formatting
//indentation
//\n after each closing or self closing tag
module.exports = $0c37d8e883c80c7c$var$Parser;

});

parcelRegister("9mpS6", function(module, exports) {
'use strict';

var $7WOwA = parcelRequire("7WOwA");

var $1TqXI = parcelRequire("1TqXI");

var $7k0Fa = parcelRequire("7k0Fa");

var $8NLMI = parcelRequire("8NLMI");

var $eKnYK = parcelRequire("eKnYK");

var $1vywv = parcelRequire("1vywv");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $6d0a3caf4546d3ea$var$createInstance(defaultConfig) {
    var context = new $7k0Fa(defaultConfig);
    var instance = $1TqXI($7k0Fa.prototype.request, context);
    // Copy axios.prototype to instance
    $7WOwA.extend(instance, $7k0Fa.prototype, context);
    // Copy context to instance
    $7WOwA.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $6d0a3caf4546d3ea$var$createInstance($8NLMI(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $6d0a3caf4546d3ea$var$axios = $6d0a3caf4546d3ea$var$createInstance($eKnYK);
// Expose Axios class to allow class inheritance
$6d0a3caf4546d3ea$var$axios.Axios = $7k0Fa;

// Expose Cancel & CancelToken
$6d0a3caf4546d3ea$var$axios.CanceledError = (parcelRequire("kcm8N"));

$6d0a3caf4546d3ea$var$axios.CancelToken = (parcelRequire("7MnMt"));

$6d0a3caf4546d3ea$var$axios.isCancel = (parcelRequire("9FAn0"));

$6d0a3caf4546d3ea$var$axios.VERSION = (parcelRequire("YMTDM")).version;

$6d0a3caf4546d3ea$var$axios.toFormData = (parcelRequire("g9yb2"));

// Expose AxiosError class
$6d0a3caf4546d3ea$var$axios.AxiosError = (parcelRequire("fwRKE"));
// alias for CanceledError for backward compatibility
$6d0a3caf4546d3ea$var$axios.Cancel = $6d0a3caf4546d3ea$var$axios.CanceledError;
// Expose all/spread
$6d0a3caf4546d3ea$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$6d0a3caf4546d3ea$var$axios.spread = (parcelRequire("6zD4n"));

// Expose isAxiosError
$6d0a3caf4546d3ea$var$axios.isAxiosError = (parcelRequire("hRQFR"));
$6d0a3caf4546d3ea$var$axios.formToJSON = function(thing) {
    return $1vywv($7WOwA.isHTMLForm(thing) ? new FormData(thing) : thing);
};
module.exports = $6d0a3caf4546d3ea$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $6d0a3caf4546d3ea$var$axios;

});
parcelRegister("7WOwA", function(module, exports) {
'use strict';

var $1TqXI = parcelRequire("1TqXI");
// utils is a library of generic helper functions non-specific to axios
var $5c95244cf61d9f4d$var$toString = Object.prototype.toString;
// eslint-disable-next-line func-names
var $5c95244cf61d9f4d$var$kindOf = function(cache) {
    // eslint-disable-next-line func-names
    return function(thing) {
        var str = $5c95244cf61d9f4d$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
function $5c95244cf61d9f4d$var$kindOfTest(type) {
    type = type.toLowerCase();
    return function isKindOf(thing) {
        return $5c95244cf61d9f4d$var$kindOf(thing) === type;
    };
}
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $5c95244cf61d9f4d$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $5c95244cf61d9f4d$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $5c95244cf61d9f4d$var$isBuffer(val) {
    return val !== null && !$5c95244cf61d9f4d$var$isUndefined(val) && val.constructor !== null && !$5c95244cf61d9f4d$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $5c95244cf61d9f4d$var$isArrayBuffer = $5c95244cf61d9f4d$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $5c95244cf61d9f4d$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $5c95244cf61d9f4d$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $5c95244cf61d9f4d$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $5c95244cf61d9f4d$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $5c95244cf61d9f4d$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $5c95244cf61d9f4d$var$isPlainObject(val) {
    if ($5c95244cf61d9f4d$var$kindOf(val) !== 'object') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a empty Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a empty Object, otherwise false
 */ function $5c95244cf61d9f4d$var$isEmptyObject(val) {
    if (!$5c95244cf61d9f4d$var$isPlainObject(val)) return false;
    for(var key in val){
        if (Object.prototype.hasOwnProperty.call(val, key)) return false;
    }
    return true;
}
/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $5c95244cf61d9f4d$var$isDate = $5c95244cf61d9f4d$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $5c95244cf61d9f4d$var$isFile = $5c95244cf61d9f4d$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $5c95244cf61d9f4d$var$isBlob = $5c95244cf61d9f4d$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $5c95244cf61d9f4d$var$isFileList = $5c95244cf61d9f4d$var$kindOfTest('FileList');
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $5c95244cf61d9f4d$var$isFunction(val) {
    return $5c95244cf61d9f4d$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $5c95244cf61d9f4d$var$isStream(val) {
    return $5c95244cf61d9f4d$var$isObject(val) && $5c95244cf61d9f4d$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $5c95244cf61d9f4d$var$isFormData(thing) {
    var pattern = '[object FormData]';
    if (!thing) return false;
    if (typeof FormData === 'function' && thing instanceof FormData) return true;
    // Reject non-objects (strings, numbers, booleans) up front — Object.getPrototypeOf
    // throws a TypeError on primitives in ES5 environments.
    if (!$5c95244cf61d9f4d$var$isObject(thing)) return false;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    var proto = Object.getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$5c95244cf61d9f4d$var$isFunction(thing.append)) return false;
    return $5c95244cf61d9f4d$var$toString.call(thing) === pattern || $5c95244cf61d9f4d$var$isFunction(thing.toString) && thing.toString() === pattern;
}
/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $5c95244cf61d9f4d$var$isURLSearchParams = $5c95244cf61d9f4d$var$kindOfTest('URLSearchParams');
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $5c95244cf61d9f4d$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $5c95244cf61d9f4d$var$isStandardBrowserEnv() {
    var product;
    if (typeof navigator !== 'undefined' && ((product = navigator.product) === 'ReactNative' || product === 'NativeScript' || product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $5c95244cf61d9f4d$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($5c95244cf61d9f4d$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $5c95244cf61d9f4d$var$merge() {
    var result = Object.create(null);
    function assignValue(val, key) {
        var target;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        target = Object.prototype.hasOwnProperty.call(result, key) ? result[key] : undefined;
        if ($5c95244cf61d9f4d$var$isPlainObject(target) && $5c95244cf61d9f4d$var$isPlainObject(val)) result[key] = $5c95244cf61d9f4d$var$merge(target, val);
        else if ($5c95244cf61d9f4d$var$isPlainObject(val)) result[key] = $5c95244cf61d9f4d$var$merge({}, val);
        else if ($5c95244cf61d9f4d$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$5c95244cf61d9f4d$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $5c95244cf61d9f4d$var$extend(a, b, thisArg) {
    $5c95244cf61d9f4d$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $1TqXI(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $5c95244cf61d9f4d$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
}
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */ function $5c95244cf61d9f4d$var$inherits(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    props && Object.assign(constructor.prototype, props);
}
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 * @returns {Object}
 */ function $5c95244cf61d9f4d$var$toFlatObject(sourceObj, destObj, filter, propFilter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && Object.getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
}
/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */ function $5c95244cf61d9f4d$var$endsWith(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
}
/**
 * Returns new array from array like object or null if failed
 * @param {*} [thing]
 * @returns {?Array}
 */ function $5c95244cf61d9f4d$var$toArray(thing) {
    if (!thing) return null;
    if ($5c95244cf61d9f4d$var$isArray(thing)) return thing;
    var i = thing.length;
    if (!$5c95244cf61d9f4d$var$isNumber(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
}
// eslint-disable-next-line func-names
var $5c95244cf61d9f4d$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));
function $5c95244cf61d9f4d$var$forEachEntry(obj, fn) {
    var generator = obj && obj[Symbol.iterator];
    var iterator = generator.call(obj);
    var result;
    while((result = iterator.next()) && !result.done){
        var pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
}
function $5c95244cf61d9f4d$var$matchAll(regExp, str) {
    var matches;
    var arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
}
var $5c95244cf61d9f4d$var$isHTMLForm = $5c95244cf61d9f4d$var$kindOfTest('HTMLFormElement');
var $5c95244cf61d9f4d$var$hasOwnProperty = function resolver(_hasOwnProperty) {
    return function(obj, prop) {
        return _hasOwnProperty.call(obj, prop);
    };
}(Object.prototype.hasOwnProperty);
module.exports = {
    isArray: $5c95244cf61d9f4d$var$isArray,
    isArrayBuffer: $5c95244cf61d9f4d$var$isArrayBuffer,
    isBuffer: $5c95244cf61d9f4d$var$isBuffer,
    isFormData: $5c95244cf61d9f4d$var$isFormData,
    isArrayBufferView: $5c95244cf61d9f4d$var$isArrayBufferView,
    isString: $5c95244cf61d9f4d$var$isString,
    isNumber: $5c95244cf61d9f4d$var$isNumber,
    isObject: $5c95244cf61d9f4d$var$isObject,
    isPlainObject: $5c95244cf61d9f4d$var$isPlainObject,
    isEmptyObject: $5c95244cf61d9f4d$var$isEmptyObject,
    isUndefined: $5c95244cf61d9f4d$var$isUndefined,
    isDate: $5c95244cf61d9f4d$var$isDate,
    isFile: $5c95244cf61d9f4d$var$isFile,
    isBlob: $5c95244cf61d9f4d$var$isBlob,
    isFunction: $5c95244cf61d9f4d$var$isFunction,
    isStream: $5c95244cf61d9f4d$var$isStream,
    isURLSearchParams: $5c95244cf61d9f4d$var$isURLSearchParams,
    isStandardBrowserEnv: $5c95244cf61d9f4d$var$isStandardBrowserEnv,
    forEach: $5c95244cf61d9f4d$var$forEach,
    merge: $5c95244cf61d9f4d$var$merge,
    extend: $5c95244cf61d9f4d$var$extend,
    trim: $5c95244cf61d9f4d$var$trim,
    stripBOM: $5c95244cf61d9f4d$var$stripBOM,
    inherits: $5c95244cf61d9f4d$var$inherits,
    toFlatObject: $5c95244cf61d9f4d$var$toFlatObject,
    kindOf: $5c95244cf61d9f4d$var$kindOf,
    kindOfTest: $5c95244cf61d9f4d$var$kindOfTest,
    endsWith: $5c95244cf61d9f4d$var$endsWith,
    toArray: $5c95244cf61d9f4d$var$toArray,
    isTypedArray: $5c95244cf61d9f4d$var$isTypedArray,
    isFileList: $5c95244cf61d9f4d$var$isFileList,
    forEachEntry: $5c95244cf61d9f4d$var$forEachEntry,
    matchAll: $5c95244cf61d9f4d$var$matchAll,
    isHTMLForm: $5c95244cf61d9f4d$var$isHTMLForm,
    hasOwnProperty: $5c95244cf61d9f4d$var$hasOwnProperty
};

});
parcelRegister("1TqXI", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
};

});


parcelRegister("7k0Fa", function(module, exports) {
'use strict';

var $7WOwA = parcelRequire("7WOwA");

var $el83V = parcelRequire("el83V");

var $7mRzL = parcelRequire("7mRzL");

var $01Fve = parcelRequire("01Fve");

var $8NLMI = parcelRequire("8NLMI");

var $gei7O = parcelRequire("gei7O");

var $j45SE = parcelRequire("j45SE");
var $554aea4ee06c60a4$var$validators = $j45SE.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $554aea4ee06c60a4$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $7mRzL(),
        response: new $7mRzL()
    };
}
/**
 * Dispatch a request
 *
 * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
 * @param {?Object} config
 */ $554aea4ee06c60a4$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $8NLMI(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    var transitional = config.transitional;
    if (transitional !== undefined) $j45SE.assertOptions(transitional, {
        silentJSONParsing: $554aea4ee06c60a4$var$validators.transitional($554aea4ee06c60a4$var$validators.boolean),
        forcedJSONParsing: $554aea4ee06c60a4$var$validators.transitional($554aea4ee06c60a4$var$validators.boolean),
        clarifyTimeoutError: $554aea4ee06c60a4$var$validators.transitional($554aea4ee06c60a4$var$validators.boolean)
    }, false);
    var paramsSerializer = config.paramsSerializer;
    if (paramsSerializer != null) {
        if ($7WOwA.isFunction(paramsSerializer)) config.paramsSerializer = {
            serialize: paramsSerializer
        };
        else $j45SE.assertOptions(paramsSerializer, {
            encode: $554aea4ee06c60a4$var$validators.function,
            serialize: $554aea4ee06c60a4$var$validators.function
        }, true);
    }
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $01Fve,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $01Fve(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$554aea4ee06c60a4$var$Axios.prototype.getUri = function getUri(config) {
    config = $8NLMI(this.defaults, config);
    var fullPath = $gei7O(config.baseURL, config.url, config.allowAbsoluteUrls);
    return $el83V(fullPath, config.params, config.paramsSerializer);
};
// Provide aliases for supported request methods
$7WOwA.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $554aea4ee06c60a4$var$Axios.prototype[method] = function(url, config) {
        var requestConfig = config || {};
        return this.request($8NLMI(requestConfig, {
            method: method,
            url: url,
            data: $7WOwA.hasOwnProperty(requestConfig, 'data') ? requestConfig.data : undefined
        }));
    };
});
$7WOwA.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request($8NLMI(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $554aea4ee06c60a4$var$Axios.prototype[method] = generateHTTPMethod();
    $554aea4ee06c60a4$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
module.exports = $554aea4ee06c60a4$var$Axios;

});
parcelRegister("el83V", function(module, exports) {
'use strict';

var $7WOwA = parcelRequire("7WOwA");

var $cVH5j = parcelRequire("cVH5j");
function $a70947ddfb01423b$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
    var _encode = $a70947ddfb01423b$var$encode;
    var serializeFn;
    if (options) {
        if ($7WOwA.isFunction(options)) serializeFn = options;
        else {
            _encode = $7WOwA.hasOwnProperty(options, 'encode') && options.encode || $a70947ddfb01423b$var$encode;
            serializeFn = $7WOwA.hasOwnProperty(options, 'serialize') ? options.serialize : undefined;
        }
    }
    var serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = $7WOwA.isURLSearchParams(params) ? params.toString() : new $cVH5j(params, options).toString(_encode);
    if (serializedParams) url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    return url;
};

});
parcelRegister("cVH5j", function(module, exports) {
'use strict';

var $g9yb2 = parcelRequire("g9yb2");
function $969c3a9ac233c17f$var$encode(str) {
    // Do not map `%00` back to a raw null byte: that reversed
    // the safe percent-encoding from encodeURIComponent and enabled null byte injection.
    var charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'\(\)~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
function $969c3a9ac233c17f$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && $g9yb2(params, this, options);
}
var $969c3a9ac233c17f$var$prototype = $969c3a9ac233c17f$var$AxiosURLSearchParams.prototype;
$969c3a9ac233c17f$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$969c3a9ac233c17f$var$prototype.toString = function toString(encoder) {
    var _encode = encoder ? function(value) {
        return encoder.call(this, value, $969c3a9ac233c17f$var$encode);
    } : $969c3a9ac233c17f$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
module.exports = $969c3a9ac233c17f$var$AxiosURLSearchParams;

});
parcelRegister("g9yb2", function(module, exports) {

var $81U8s = parcelRequire("81U8s");
var $bc27ff709dc257e4$require$Buffer = $81U8s.Buffer;
'use strict';

var $7WOwA = parcelRequire("7WOwA");

var $fwRKE = parcelRequire("fwRKE");

var $1fehh = parcelRequire("1fehh");
function $bc27ff709dc257e4$var$isVisitable(thing) {
    return $7WOwA.isPlainObject(thing) || $7WOwA.isArray(thing);
}
function $bc27ff709dc257e4$var$removeBrackets(key) {
    return $7WOwA.endsWith(key, '[]') ? key.slice(0, -2) : key;
}
function $bc27ff709dc257e4$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $bc27ff709dc257e4$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
function $bc27ff709dc257e4$var$isFlatArray(arr) {
    return $7WOwA.isArray(arr) && !arr.some($bc27ff709dc257e4$var$isVisitable);
}
var $bc27ff709dc257e4$var$predicates = $7WOwA.toFlatObject($7WOwA, {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
function $bc27ff709dc257e4$var$isSpecCompliant(thing) {
    return thing && $7WOwA.isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator];
}
/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 * @returns {Object}
 **/ function $bc27ff709dc257e4$var$toFormData(obj, formData, options) {
    if (!$7WOwA.isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ($1fehh || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = $7WOwA.toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !$7WOwA.isUndefined(source[option]);
    });
    var metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    var visitor = options.visitor || defaultVisitor;
    var dots = options.dots;
    var indexes = options.indexes;
    var _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    var maxDepth = options.maxDepth === undefined ? 100 : options.maxDepth;
    var useBlob = _Blob && $bc27ff709dc257e4$var$isSpecCompliant(formData);
    if (!$7WOwA.isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ($7WOwA.isDate(value)) return value.toISOString();
        if (!useBlob && $7WOwA.isBlob(value)) throw new $fwRKE('Blob is not supported. Use a Buffer instead.');
        if ($7WOwA.isArrayBuffer(value) || $7WOwA.isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $bc27ff709dc257e4$require$Buffer.from(value);
        return value;
    }
    var stack = [];
    function assertValueDepth(value, depth) {
        if (depth > maxDepth) throw new $fwRKE('Maximum object depth of ' + maxDepth + ' exceeded (got ' + depth + ' levels)', $fwRKE.ERR_FORM_DATA_DEPTH_EXCEEDED);
        if (!$7WOwA.isObject(value) || stack.indexOf(value) !== -1) return;
        stack.push(value);
        $7WOwA.forEach(value, function each(el) {
            assertValueDepth(el, depth + 1);
        });
        stack.pop();
    }
    /**
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        var arr = value;
        if (value && !path && typeof value === 'object') {
            if ($7WOwA.endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                assertValueDepth(value, 1);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ($7WOwA.isArray(value) && $bc27ff709dc257e4$var$isFlatArray(value) || $7WOwA.isFileList(value) || $7WOwA.endsWith(key, '[]') && (arr = $7WOwA.toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $bc27ff709dc257e4$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !($7WOwA.isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $bc27ff709dc257e4$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($bc27ff709dc257e4$var$isVisitable(value)) return true;
        formData.append($bc27ff709dc257e4$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    var exposedHelpers = Object.assign($bc27ff709dc257e4$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $bc27ff709dc257e4$var$isVisitable
    });
    function build(value, path, depth) {
        if ($7WOwA.isUndefined(value)) return;
        // eslint-disable-next-line no-param-reassign
        depth = depth || 0;
        if (depth > maxDepth) throw new $fwRKE('Maximum object depth of ' + maxDepth + ' exceeded (got ' + depth + ' levels)', $fwRKE.ERR_FORM_DATA_DEPTH_EXCEEDED);
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        $7WOwA.forEach(value, function each(el, key) {
            var result = !($7WOwA.isUndefined(el) || el === null) && visitor.call(formData, el, $7WOwA.isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!$7WOwA.isObject(obj)) throw new TypeError('data must be an object');
    build(obj, null, 0);
    return formData;
}
module.exports = $bc27ff709dc257e4$var$toFormData;

});
parcelRegister("fwRKE", function(module, exports) {
'use strict';

var $7WOwA = parcelRequire("7WOwA");

var $9fIwj = parcelRequire("9fIwj");
var $b4e38a17078766d1$var$REDACTED_VALUE = '[REDACTED ****]';
function $b4e38a17078766d1$var$makeValueDescriptor(value) {
    var descriptor = Object.create(null);
    descriptor.value = value;
    return descriptor;
}
function $b4e38a17078766d1$var$getRedactKeys(config) {
    // An empty array is treated as "no override" so an upstream `redact: []` cannot
    // silently disable redaction. To opt out, pass non-string values or unset keys.
    var override = config && $7WOwA.isArray(config.redact) && config.redact.length ? config.redact : null;
    var redact = override || $9fIwj;
    var keys = {};
    $7WOwA.forEach(redact, function eachRedactKey(key) {
        if (typeof key === 'string') keys[key.toLowerCase()] = true;
    });
    return keys;
}
function $b4e38a17078766d1$var$shouldRedact(key, keys) {
    return typeof key === 'string' && keys[key.toLowerCase()];
}
var $b4e38a17078766d1$var$CIRCULAR_VALUE = '[Circular]';
function $b4e38a17078766d1$var$serializeConfigValue(value, keys, key, seen) {
    var result;
    if ($b4e38a17078766d1$var$shouldRedact(key, keys)) return $b4e38a17078766d1$var$REDACTED_VALUE;
    if ($7WOwA.isArray(value)) {
        if (seen.indexOf(value) !== -1) return $b4e38a17078766d1$var$CIRCULAR_VALUE;
        seen.push(value);
        result = [];
        $7WOwA.forEach(value, function eachArrayValue(item, index) {
            result[index] = $b4e38a17078766d1$var$serializeConfigValue(item, keys, index, seen);
        });
        seen.pop();
        return result;
    }
    if ($7WOwA.isPlainObject(value)) {
        if (seen.indexOf(value) !== -1) return $b4e38a17078766d1$var$CIRCULAR_VALUE;
        seen.push(value);
        result = {};
        $7WOwA.forEach(value, function eachObjectValue(item, itemKey) {
            result[itemKey] = $b4e38a17078766d1$var$serializeConfigValue(item, keys, itemKey, seen);
        });
        seen.pop();
        return result;
    }
    return value;
}
function $b4e38a17078766d1$var$serializeConfig(config) {
    if (!config) return config;
    return $b4e38a17078766d1$var$serializeConfigValue(config, $b4e38a17078766d1$var$getRedactKeys(config), undefined, []);
}
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ function $b4e38a17078766d1$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
$7WOwA.inherits($b4e38a17078766d1$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: $b4e38a17078766d1$var$serializeConfig(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
var $b4e38a17078766d1$var$prototype = $b4e38a17078766d1$var$AxiosError.prototype;
var $b4e38a17078766d1$var$descriptors = Object.create(null);
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL',
    'ERR_FORM_DATA_DEPTH_EXCEEDED'
].forEach(function(code) {
    $b4e38a17078766d1$var$descriptors[code] = $b4e38a17078766d1$var$makeValueDescriptor(code);
});
Object.defineProperties($b4e38a17078766d1$var$AxiosError, $b4e38a17078766d1$var$descriptors);
Object.defineProperty($b4e38a17078766d1$var$prototype, 'isAxiosError', $b4e38a17078766d1$var$makeValueDescriptor(true));
// eslint-disable-next-line func-names
$b4e38a17078766d1$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($b4e38a17078766d1$var$prototype);
    $7WOwA.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    });
    $b4e38a17078766d1$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
module.exports = $b4e38a17078766d1$var$AxiosError;

});
parcelRegister("9fIwj", function(module, exports) {
'use strict';
module.exports = [
    'authorization',
    'proxy-authorization',
    'cookie',
    'set-cookie',
    'x-api-key',
    'password'
];

});


parcelRegister("1fehh", function(module, exports) {
// eslint-disable-next-line strict

module.exports = (parcelRequire("7i5zJ"));

});
parcelRegister("7i5zJ", function(module, exports) {
'use strict';
/* eslint-env browser */ module.exports = typeof self === 'object' ? self.FormData : window.FormData;

});





parcelRegister("7mRzL", function(module, exports) {
'use strict';

var $7WOwA = parcelRequire("7WOwA");
function $55d4258791e9b9bf$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $55d4258791e9b9bf$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $55d4258791e9b9bf$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Clear all interceptors from the stack
 */ $55d4258791e9b9bf$var$InterceptorManager.prototype.clear = function clear() {
    if (this.handlers) this.handlers = [];
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $55d4258791e9b9bf$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $7WOwA.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $55d4258791e9b9bf$var$InterceptorManager;

});

parcelRegister("01Fve", function(module, exports) {
'use strict';

var $7WOwA = parcelRequire("7WOwA");

var $hDFGk = parcelRequire("hDFGk");

var $9FAn0 = parcelRequire("9FAn0");

var $eKnYK = parcelRequire("eKnYK");

var $kcm8N = parcelRequire("kcm8N");

var $h2HpT = parcelRequire("h2HpT");

var $dYm2k = parcelRequire("dYm2k");
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ function $005049b52620345b$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $kcm8N();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $005049b52620345b$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $hDFGk.call(config, config.data, config.headers, null, config.transformRequest);
    $h2HpT(config.headers, 'Accept');
    $h2HpT(config.headers, 'Content-Type');
    // Flatten headers
    var commonHeaders = $7WOwA.hasOwnProperty(config.headers, 'common') && config.headers.common ? config.headers.common : {};
    var methodHeaders = config.method && $7WOwA.hasOwnProperty(config.headers, config.method) && config.headers[config.method] ? config.headers[config.method] : {};
    config.headers = $7WOwA.merge(commonHeaders, methodHeaders, config.headers);
    $7WOwA.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    $7WOwA.forEach(config.headers, function sanitizeHeaderConfigValue(value, header) {
        config.headers[header] = $dYm2k(value);
    });
    var adapter = config.adapter || $eKnYK.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $005049b52620345b$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $hDFGk.call(config, response.data, response.headers, response.status, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$9FAn0(reason)) {
            $005049b52620345b$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $hDFGk.call(config, reason.response.data, reason.response.headers, reason.response.status, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("hDFGk", function(module, exports) {
'use strict';

var $7WOwA = parcelRequire("7WOwA");

var $eKnYK = parcelRequire("eKnYK");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Number} status HTTP status code
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, status, fns) {
    var context = this || $eKnYK;
    /*eslint no-param-reassign:0*/ $7WOwA.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers, status);
    });
    return data;
};

});
parcelRegister("eKnYK", function(module, exports) {
'use strict';

var $7WOwA = parcelRequire("7WOwA");

var $h2HpT = parcelRequire("h2HpT");

var $fwRKE = parcelRequire("fwRKE");

var $enQx1 = parcelRequire("enQx1");

var $g9yb2 = parcelRequire("g9yb2");

var $9jMiC = parcelRequire("9jMiC");

var $cfBet = parcelRequire("cfBet");

var $1vywv = parcelRequire("1vywv");

var $9fIwj = parcelRequire("9fIwj");
var $abc7f63f99745fe5$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $abc7f63f99745fe5$var$setContentTypeIfUnset(headers, value) {
    if (!$7WOwA.isUndefined(headers) && $7WOwA.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $abc7f63f99745fe5$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("ca0OW"));
    return adapter;
}
function $abc7f63f99745fe5$var$stringifySafely(rawValue, parser, encoder) {
    if ($7WOwA.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $7WOwA.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $abc7f63f99745fe5$var$defaults = {
    transitional: $enQx1,
    adapter: $abc7f63f99745fe5$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $h2HpT(headers, 'Accept');
            $h2HpT(headers, 'Content-Type');
            var contentType = headers && headers['Content-Type'] || '';
            var hasJSONContentType = contentType.indexOf('application/json') > -1;
            var isObjectPayload = $7WOwA.isObject(data);
            if (isObjectPayload && $7WOwA.isHTMLForm(data)) data = new FormData(data);
            var isFormData = $7WOwA.isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify($1vywv(data)) : data;
            if ($7WOwA.isArrayBuffer(data) || $7WOwA.isBuffer(data) || $7WOwA.isStream(data) || $7WOwA.isFile(data) || $7WOwA.isBlob(data)) return data;
            if ($7WOwA.isArrayBufferView(data)) return data.buffer;
            if ($7WOwA.isURLSearchParams(data)) {
                $abc7f63f99745fe5$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            var isFileList;
            if (isObjectPayload) {
                var formSerializer = $7WOwA.hasOwnProperty(this, 'formSerializer') ? this.formSerializer : undefined;
                var envOption = $7WOwA.hasOwnProperty(this, 'env') ? this.env : undefined;
                if (contentType.indexOf('application/x-www-form-urlencoded') !== -1) return $9jMiC(data, formSerializer).toString();
                if ((isFileList = $7WOwA.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    var _FormData = envOption && envOption.FormData;
                    return $g9yb2(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                $abc7f63f99745fe5$var$setContentTypeIfUnset(headers, 'application/json');
                return $abc7f63f99745fe5$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $abc7f63f99745fe5$var$defaults.transitional;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var JSONRequested = this.responseType === 'json';
            if (data && $7WOwA.isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                var silentJSONParsing = transitional && transitional.silentJSONParsing;
                var strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw $fwRKE.from(e, $fwRKE.ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    redact: $9fIwj.slice(),
    env: {
        FormData: $cfBet.classes.FormData,
        Blob: $cfBet.classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*'
        }
    }
};
$7WOwA.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $abc7f63f99745fe5$var$defaults.headers[method] = {};
});
$7WOwA.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $abc7f63f99745fe5$var$defaults.headers[method] = $7WOwA.merge($abc7f63f99745fe5$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $abc7f63f99745fe5$var$defaults;

});
parcelRegister("h2HpT", function(module, exports) {
'use strict';

var $7WOwA = parcelRequire("7WOwA");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $7WOwA.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("enQx1", function(module, exports) {
'use strict';
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("9jMiC", function(module, exports) {
'use strict';

var $7WOwA = parcelRequire("7WOwA");

var $g9yb2 = parcelRequire("g9yb2");

var $cfBet = parcelRequire("cfBet");
module.exports = function toURLEncodedForm(data, options) {
    return $g9yb2(data, new $cfBet.classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ($cfBet.isNode && $7WOwA.isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
};

});
parcelRegister("cfBet", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3dxYu"));

});
parcelRegister("3dxYu", function(module, exports) {
'use strict';


module.exports = {
    isBrowser: true,
    classes: {
        URLSearchParams: (parcelRequire("h6GOF")),
        FormData: (parcelRequire("9VDep")),
        Blob: Blob
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("h6GOF", function(module, exports) {
'use strict';

var $cVH5j = parcelRequire("cVH5j");
module.exports = typeof URLSearchParams !== 'undefined' ? URLSearchParams : $cVH5j;

});

parcelRegister("9VDep", function(module, exports) {
'use strict';
module.exports = FormData;

});




parcelRegister("1vywv", function(module, exports) {
'use strict';

var $7WOwA = parcelRequire("7WOwA");

var $fwRKE = parcelRequire("fwRKE");
var $11937748a52c7616$var$MAX_FORM_DATA_TO_JSON_DEPTH = 100;
function $11937748a52c7616$var$assertPathDepth(path) {
    var depth = path.length - 1;
    if (depth > $11937748a52c7616$var$MAX_FORM_DATA_TO_JSON_DEPTH) throw new $fwRKE('Maximum object depth of ' + $11937748a52c7616$var$MAX_FORM_DATA_TO_JSON_DEPTH + ' exceeded (got ' + depth + ' levels)', $fwRKE.ERR_FORM_DATA_DEPTH_EXCEEDED);
}
function $11937748a52c7616$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return $7WOwA.matchAll(/\w+|\[(\w*)]/g, name).map(function(match) {
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
function $11937748a52c7616$var$arrayToObject(arr) {
    var obj = {};
    var keys = Object.keys(arr);
    var i;
    var len = keys.length;
    var key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
function $11937748a52c7616$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        var name = path[index++];
        if (name === '__proto__') return true;
        var isNumericKey = Number.isFinite(+name);
        var isLast = index >= path.length;
        name = !name && $7WOwA.isArray(target) ? target.length : name;
        if (isLast) {
            if ($7WOwA.hasOwnProperty(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !$7WOwA.isObject(target[name])) target[name] = [];
        var result = buildPath(path, value, target[name], index);
        if (result && $7WOwA.isArray(target[name])) target[name] = $11937748a52c7616$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ($7WOwA.isFormData(formData) && $7WOwA.isFunction(formData.entries)) {
        var obj = {};
        $7WOwA.forEachEntry(formData, function(name, value) {
            var path = $11937748a52c7616$var$parsePropPath(name);
            $11937748a52c7616$var$assertPathDepth(path);
            buildPath(path, value, obj, 0);
        });
        return obj;
    }
    return null;
}
module.exports = $11937748a52c7616$var$formDataToJSON;

});

parcelRegister("ca0OW", function(module, exports) {
'use strict';

var $7WOwA = parcelRequire("7WOwA");

var $gWRTP = parcelRequire("gWRTP");

var $a97Un = parcelRequire("a97Un");

var $el83V = parcelRequire("el83V");

var $gei7O = parcelRequire("gei7O");

var $Ad0HN = parcelRequire("Ad0HN");

var $dKxsf = parcelRequire("dKxsf");

var $enQx1 = parcelRequire("enQx1");

var $fwRKE = parcelRequire("fwRKE");

var $kcm8N = parcelRequire("kcm8N");

var $7OkjX = parcelRequire("7OkjX");

var $cfBet = parcelRequire("cfBet");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        // Guard against prototype pollution: only honor own properties.
        var withXSRFToken = $7WOwA.hasOwnProperty(config, 'withXSRFToken') ? config.withXSRFToken : undefined;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener('abort', onCanceled);
        }
        if ($7WOwA.isFormData(requestData) && $7WOwA.isStandardBrowserEnv()) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        var configAuth = $7WOwA.hasOwnProperty(config, 'auth') ? config.auth : undefined;
        if (configAuth) {
            var username = $7WOwA.hasOwnProperty(configAuth, 'username') ? configAuth.username || '' : '';
            var password = $7WOwA.hasOwnProperty(configAuth, 'password') && configAuth.password ? unescape(encodeURIComponent(configAuth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $gei7O(config.baseURL, config.url, config.allowAbsoluteUrls);
        request.open(config.method.toUpperCase(), $el83V(fullPath, config.params, $7WOwA.hasOwnProperty(config, 'paramsSerializer') ? config.paramsSerializer : undefined), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $Ad0HN(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $gWRTP(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new $fwRKE('Request aborted', $fwRKE.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new $fwRKE('Network Error', $fwRKE.ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = config.transitional || $enQx1;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new $fwRKE(timeoutErrorMessage, transitional.clarifyTimeoutError ? $fwRKE.ETIMEDOUT : $fwRKE.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($7WOwA.isStandardBrowserEnv()) {
            // Add xsrf header
            if ($7WOwA.isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(config);
            // Strict boolean check: only `true` short-circuits the same-origin guard.
            if (withXSRFToken === true || withXSRFToken !== false && $dKxsf(fullPath)) {
                // Add xsrf header
                var xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && $a97Un.read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
            }
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $7WOwA.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$7WOwA.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel.type ? new $kcm8N(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
        }
        // false, 0 (zero number), and '' (empty string) are valid JSON values
        if (!requestData && requestData !== false && requestData !== 0 && requestData !== '') requestData = null;
        var protocol = $7OkjX(fullPath);
        if (protocol && $cfBet.protocols.indexOf(protocol) === -1) {
            reject(new $fwRKE('Unsupported protocol ' + protocol + ':', $fwRKE.ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("gWRTP", function(module, exports) {
'use strict';

var $fwRKE = parcelRequire("fwRKE");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new $fwRKE('Request failed with status code ' + response.status, [
        $fwRKE.ERR_BAD_REQUEST,
        $fwRKE.ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
};

});

parcelRegister("a97Un", function(module, exports) {
'use strict';

var $7WOwA = parcelRequire("7WOwA");
module.exports = $7WOwA.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($7WOwA.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($7WOwA.isString(path)) cookie.push('path=' + path);
            if ($7WOwA.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var nameEQ = name + '=';
            var cookies = document.cookie.split(';');
            var cookie;
            for(var i = 0; i < cookies.length; i++){
                cookie = cookies[i];
                while(cookie.charAt(0) === ' ')cookie = cookie.substring(1);
                if (cookie.indexOf(nameEQ) === 0) return decodeURIComponent(cookie.substring(nameEQ.length));
            }
            return null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("gei7O", function(module, exports) {
'use strict';

var $l8LiS = parcelRequire("l8LiS");

var $80MpC = parcelRequire("80MpC");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @param {boolean} allowAbsoluteUrls Set to true to allow absolute URLs
 *
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls) {
    var isRelativeURL = !$l8LiS(requestedURL);
    if (baseURL && (isRelativeURL || allowAbsoluteUrls === false)) return $80MpC(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("l8LiS", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("80MpC", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("Ad0HN", function(module, exports) {
'use strict';

var $7WOwA = parcelRequire("7WOwA");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $06cd747f4f9ed805$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $7WOwA.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $7WOwA.trim(line.slice(0, i)).toLowerCase();
        val = $7WOwA.trim(line.slice(i + 1));
        if (key) {
            if (parsed[key] && $06cd747f4f9ed805$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("dKxsf", function(module, exports) {
'use strict';

var $7WOwA = parcelRequire("7WOwA");
module.exports = $7WOwA.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
      * Parse a URL to discover it's components
      *
      * @param {String} url The URL to be parsed
      * @returns {Object}
      */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
      * Determine if a URL shares the same origin as the current location
      *
      * @param {String} requestURL The URL to test
      * @returns {boolean} True if URL shares the same origin, otherwise false
      */ return function isURLSameOrigin(requestURL) {
        var parsed = $7WOwA.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("kcm8N", function(module, exports) {
'use strict';

var $fwRKE = parcelRequire("fwRKE");

var $7WOwA = parcelRequire("7WOwA");
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 */ function $eb461a54a5ca29a6$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    $fwRKE.call(this, message == null ? 'canceled' : message, $fwRKE.ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
$7WOwA.inherits($eb461a54a5ca29a6$var$CanceledError, $fwRKE, {
    __CANCEL__: true
});
module.exports = $eb461a54a5ca29a6$var$CanceledError;

});

parcelRegister("7OkjX", function(module, exports) {
'use strict';
module.exports = function parseProtocol(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
};

});




parcelRegister("9FAn0", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("dYm2k", function(module, exports) {
'use strict';

var $7WOwA = parcelRequire("7WOwA");
var $a2c1f8f2d78b16b6$var$INVALID_HEADER_VALUE_RE = /[^\x09\x20-\x7E\x80-\xFF]/g;
var $a2c1f8f2d78b16b6$var$BOUNDARY_WHITESPACE_RE = /^[\x09\x20]+|[\x09\x20]+$/g;
function $a2c1f8f2d78b16b6$var$sanitizeHeaderValue(value) {
    if (value === false || value == null) return value;
    if ($7WOwA.isArray(value)) return value.map($a2c1f8f2d78b16b6$var$sanitizeHeaderValue);
    return String(value).replace($a2c1f8f2d78b16b6$var$INVALID_HEADER_VALUE_RE, '').replace($a2c1f8f2d78b16b6$var$BOUNDARY_WHITESPACE_RE, '');
}
module.exports = $a2c1f8f2d78b16b6$var$sanitizeHeaderValue;

});


parcelRegister("8NLMI", function(module, exports) {
'use strict';

var $7WOwA = parcelRequire("7WOwA");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    // Use a null-prototype object so a polluted Object.prototype cannot leak
    // values (e.g. transport, adapter) into the returned config via inheritance.
    var config = Object.create(null);
    function getOwn(source, prop) {
        return $7WOwA.hasOwnProperty(source, prop) ? source[prop] : undefined;
    }
    function hasOwn(source, prop) {
        return $7WOwA.hasOwnProperty(source, prop);
    }
    function getMergedValue(target, source) {
        if ($7WOwA.isPlainObject(target) && $7WOwA.isPlainObject(source)) return $7WOwA.merge(target, source);
        else if ($7WOwA.isEmptyObject(source)) return $7WOwA.merge({}, target);
        else if ($7WOwA.isPlainObject(source)) return $7WOwA.merge({}, source);
        else if ($7WOwA.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (hasOwn(config2, prop) && !$7WOwA.isUndefined(config2[prop])) return getMergedValue(getOwn(config1, prop), config2[prop]);
        else if (hasOwn(config1, prop) && !$7WOwA.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (hasOwn(config2, prop) && !$7WOwA.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (hasOwn(config2, prop) && !$7WOwA.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (hasOwn(config1, prop) && !$7WOwA.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (hasOwn(config2, prop)) return getMergedValue(getOwn(config1, prop), config2[prop]);
        else if (hasOwn(config1, prop)) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        'url': valueFromConfig2,
        'method': valueFromConfig2,
        'data': valueFromConfig2,
        'baseURL': defaultToConfig2,
        'transformRequest': defaultToConfig2,
        'transformResponse': defaultToConfig2,
        'paramsSerializer': defaultToConfig2,
        'timeout': defaultToConfig2,
        'timeoutMessage': defaultToConfig2,
        'withCredentials': defaultToConfig2,
        'withXSRFToken': defaultToConfig2,
        'adapter': defaultToConfig2,
        'responseType': defaultToConfig2,
        'xsrfCookieName': defaultToConfig2,
        'xsrfHeaderName': defaultToConfig2,
        'onUploadProgress': defaultToConfig2,
        'onDownloadProgress': defaultToConfig2,
        'decompress': defaultToConfig2,
        'maxContentLength': defaultToConfig2,
        'maxBodyLength': defaultToConfig2,
        'beforeRedirect': defaultToConfig2,
        'transport': defaultToConfig2,
        'httpAgent': defaultToConfig2,
        'httpsAgent': defaultToConfig2,
        'cancelToken': defaultToConfig2,
        'socketPath': defaultToConfig2,
        'allowedSocketPaths': defaultToConfig2,
        'responseEncoding': defaultToConfig2,
        'validateStatus': mergeDirectKeys
    };
    $7WOwA.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        var merge = $7WOwA.hasOwnProperty(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        var configValue = merge(prop);
        $7WOwA.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("j45SE", function(module, exports) {
'use strict';

var $YMTDM = parcelRequire("YMTDM");
var $de12f3cdd1e2c423$require$VERSION = $YMTDM.version;

var $fwRKE = parcelRequire("fwRKE");
var $de12f3cdd1e2c423$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $de12f3cdd1e2c423$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $de12f3cdd1e2c423$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $de12f3cdd1e2c423$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + $de12f3cdd1e2c423$require$VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new $fwRKE(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), $fwRKE.ERR_DEPRECATED);
        if (version && !$de12f3cdd1e2c423$var$deprecatedWarnings[opt]) {
            $de12f3cdd1e2c423$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $de12f3cdd1e2c423$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new $fwRKE('options must be an object', $fwRKE.ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new $fwRKE('option ' + opt + ' must be ' + result, $fwRKE.ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new $fwRKE('Unknown option ' + opt, $fwRKE.ERR_BAD_OPTION);
    }
}
module.exports = {
    assertOptions: $de12f3cdd1e2c423$var$assertOptions,
    validators: $de12f3cdd1e2c423$var$validators
};

});
parcelRegister("YMTDM", function(module, exports) {
module.exports = {
    "version": "0.33.0"
};

});



parcelRegister("7MnMt", function(module, exports) {
'use strict';

var $kcm8N = parcelRequire("kcm8N");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $5a9f767e3b8029e6$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i = token._listeners.length;
        while(i-- > 0)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message, config, request) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $kcm8N(message, config, request);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ $5a9f767e3b8029e6$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $5a9f767e3b8029e6$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $5a9f767e3b8029e6$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $5a9f767e3b8029e6$var$CancelToken.source = function source() {
    var cancel;
    var token = new $5a9f767e3b8029e6$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $5a9f767e3b8029e6$var$CancelToken;

});

parcelRegister("6zD4n", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("hRQFR", function(module, exports) {
'use strict';

var $7WOwA = parcelRequire("7WOwA");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $7WOwA.isObject(payload) && payload.isAxiosError === true;
};

});


parcelRegister("jxqB8", function(module, exports) {
/* global window */ 
var $gzD11 = parcelRequire("gzD11");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $gzD11.default)(root);
var $e395bb342320e70a$export$2e2bcd8739ae039 = result;

});
parcelRegister("gzD11", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c10e2dde3a9db136$export$2e2bcd8739ae039; });
function $c10e2dde3a9db136$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = Symbol.for('https://github.com/benlesh/symbol-observable');
            try {
                Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = '@@observable';
    return result;
}

});


parcelRegister("clJna", function(module, exports) {
(function(root, factory) {
    'use strict';
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === 'function' && define.amd) define('stackframe', [], factory);
    else module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    function StackFrame(functionName, args, fileName, lineNumber, columnNumber, source) {
        if (functionName !== undefined) this.setFunctionName(functionName);
        if (args !== undefined) this.setArgs(args);
        if (fileName !== undefined) this.setFileName(fileName);
        if (lineNumber !== undefined) this.setLineNumber(lineNumber);
        if (columnNumber !== undefined) this.setColumnNumber(columnNumber);
        if (source !== undefined) this.setSource(source);
    }
    StackFrame.prototype = {
        getFunctionName: function() {
            return this.functionName;
        },
        setFunctionName: function(v) {
            this.functionName = String(v);
        },
        getArgs: function() {
            return this.args;
        },
        setArgs: function(v) {
            if (Object.prototype.toString.call(v) !== '[object Array]') throw new TypeError('Args must be an Array');
            this.args = v;
        },
        // NOTE: Property name may be misleading as it includes the path,
        // but it somewhat mirrors V8's JavaScriptStackTraceApi
        // https://code.google.com/p/v8/wiki/JavaScriptStackTraceApi and Gecko's
        // http://mxr.mozilla.org/mozilla-central/source/xpcom/base/nsIException.idl#14
        getFileName: function() {
            return this.fileName;
        },
        setFileName: function(v) {
            this.fileName = String(v);
        },
        getLineNumber: function() {
            return this.lineNumber;
        },
        setLineNumber: function(v) {
            if (!_isNumber(v)) throw new TypeError('Line Number must be a Number');
            this.lineNumber = Number(v);
        },
        getColumnNumber: function() {
            return this.columnNumber;
        },
        setColumnNumber: function(v) {
            if (!_isNumber(v)) throw new TypeError('Column Number must be a Number');
            this.columnNumber = Number(v);
        },
        getSource: function() {
            return this.source;
        },
        setSource: function(v) {
            this.source = String(v);
        },
        toString: function() {
            var functionName = this.getFunctionName() || '{anonymous}';
            var args = '(' + (this.getArgs() || []).join(',') + ')';
            var fileName = this.getFileName() ? '@' + this.getFileName() : '';
            var lineNumber = _isNumber(this.getLineNumber()) ? ':' + this.getLineNumber() : '';
            var columnNumber = _isNumber(this.getColumnNumber()) ? ':' + this.getColumnNumber() : '';
            return functionName + args + fileName + lineNumber + columnNumber;
        }
    };
    return StackFrame;
});

});

parcelRegister("8tgyX", function(module, exports) {

$parcel$export(module.exports, "ApolloLink", function () { return ApolloLink; });

var $iWkR3 = parcelRequire("iWkR3");

var $71YrH = parcelRequire("71YrH");
var passthrough = function(op, forward) {
    return forward ? forward(op) : (0, $iWkR3.default).of();
};
var toLink = function(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
};
var empty = function() {
    return new ApolloLink(function(op, forward) {
        return (0, $iWkR3.default).of();
    });
};
var from = function(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
};
var split = function(test, left, right) {
    if (right === void 0) right = new ApolloLink(passthrough);
    var leftLink = toLink(left);
    var rightLink = toLink(right);
    if ((0, $71YrH.isTerminating)(leftLink) && (0, $71YrH.isTerminating)(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $iWkR3.default).of() : rightLink.request(operation) || (0, $iWkR3.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $iWkR3.default).of() : rightLink.request(operation, forward) || (0, $iWkR3.default).of();
    });
};
var concat = function(first, second) {
    var firstLink = toLink(first);
    if ((0, $71YrH.isTerminating)(firstLink)) {
        console.warn(new (0, $71YrH.LinkError)("You are calling concat on a terminating link, which will have no effect", firstLink));
        return firstLink;
    }
    var nextLink = toLink(second);
    if ((0, $71YrH.isTerminating)(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $iWkR3.default).of();
        }) || (0, $iWkR3.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $iWkR3.default).of();
        }) || (0, $iWkR3.default).of();
    });
};
var ApolloLink = /** @class */ function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        if (right === void 0) right = new ApolloLink(passthrough);
        return this.concat(split(test, left, right));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new Error('request is not implemented');
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request((0, $71YrH.createOperation)(operation.context, (0, $71YrH.transformOperation)((0, $71YrH.validateOperation)(operation)))) || (0, $iWkR3.default).of();
}

});
parcelRegister("iWkR3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc9dd21b6603bfc3$export$2e2bcd8739ae039; });

var $9uTW6 = parcelRequire("9uTW6");
var $dc9dd21b6603bfc3$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6)));
var $dc9dd21b6603bfc3$export$2e2bcd8739ae039 = $dc9dd21b6603bfc3$export$77cea355fa80b5f4;

});
parcelRegister("9uTW6", function(module, exports) {

module.exports = (parcelRequire("jI3yt")).Observable;

});


parcelRegister("71YrH", function(module, exports) {

$parcel$export(module.exports, "validateOperation", function () { return $51e783a7bf7d23d0$export$a92a48117d546c9; });
$parcel$export(module.exports, "LinkError", function () { return $51e783a7bf7d23d0$export$d0a452ab7a9d9f73; });
$parcel$export(module.exports, "isTerminating", function () { return $51e783a7bf7d23d0$export$771cfaaa079a7759; });
$parcel$export(module.exports, "transformOperation", function () { return $51e783a7bf7d23d0$export$4f3f7df1b558c729; });
$parcel$export(module.exports, "createOperation", function () { return $51e783a7bf7d23d0$export$f29bedd62f56fcb2; });

var $9AImr = parcelRequire("9AImr");

var $iWkR3 = parcelRequire("iWkR3");

var $6am30 = parcelRequire("6am30");
var $51e783a7bf7d23d0$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $51e783a7bf7d23d0$var$__assign = undefined && undefined.__assign || function() {
    $51e783a7bf7d23d0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $51e783a7bf7d23d0$var$__assign.apply(this, arguments);
};
function $51e783a7bf7d23d0$export$a92a48117d546c9(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new Error("illegal argument: " + key);
    }
    return operation;
}
var $51e783a7bf7d23d0$export$d0a452ab7a9d9f73 = /** @class */ function(_super) {
    $51e783a7bf7d23d0$var$__extends(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function $51e783a7bf7d23d0$export$771cfaaa079a7759(link) {
    return link.request.length <= 1;
}
function $51e783a7bf7d23d0$export$4dbaaf6c79705e6c(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) console.warn("Promise Wrapper does not support multiple results from Observable");
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var $51e783a7bf7d23d0$export$1625492ec82002b9 = $51e783a7bf7d23d0$export$4dbaaf6c79705e6c;
function $51e783a7bf7d23d0$export$60f45028237c39d1(promise) {
    return new (0, $iWkR3.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function $51e783a7bf7d23d0$export$4fd972edbe7450d3(errorValue) {
    return new (0, $iWkR3.default)(function(observer) {
        observer.error(errorValue);
    });
}
function $51e783a7bf7d23d0$export$4f3f7df1b558c729(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    // best guess at an operation name
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $9AImr.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function $51e783a7bf7d23d0$export$f29bedd62f56fcb2(starting, operation) {
    var context = $51e783a7bf7d23d0$var$__assign({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = $51e783a7bf7d23d0$var$__assign({}, context, next(context));
        else context = $51e783a7bf7d23d0$var$__assign({}, context, next);
    };
    var getContext = function() {
        return $51e783a7bf7d23d0$var$__assign({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return $51e783a7bf7d23d0$export$a47fb462a08de82f(operation);
        }
    });
    return operation;
}
function $51e783a7bf7d23d0$export$a47fb462a08de82f(operation) {
    // XXX we're assuming here that variables will be serialized in the same order.
    // that might not always be true
    return (0, $6am30.print)(operation.query) + "|" + JSON.stringify(operation.variables) + "|" + operation.operationName;
}

});
parcelRegister("9AImr", function(module, exports) {

$parcel$export(module.exports, "getOperationName", function () { return $6fb9e2fc5b9232eb$export$41bca9dc6871dd4e; });

var $6hznq = parcelRequire("6hznq");

var $5TDOW = parcelRequire("5TDOW");

var $fH1jI = parcelRequire("fH1jI");

var $dxLgR = parcelRequire("dxLgR");

var $bOR6e = parcelRequire("bOR6e");
function $6fb9e2fc5b9232eb$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $6fb9e2fc5b9232eb$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $6fb9e2fc5b9232eb$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $6fb9e2fc5b9232eb$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $6fb9e2fc5b9232eb$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $6fb9e2fc5b9232eb$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $6fb9e2fc5b9232eb$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $6fb9e2fc5b9232eb$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $6fb9e2fc5b9232eb$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $6fb9e2fc5b9232eb$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $6fb9e2fc5b9232eb$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $6fb9e2fc5b9232eb$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($6fb9e2fc5b9232eb$var$isIntValue(value) || $6fb9e2fc5b9232eb$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($6fb9e2fc5b9232eb$var$isBooleanValue(value) || $6fb9e2fc5b9232eb$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($6fb9e2fc5b9232eb$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $6fb9e2fc5b9232eb$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($6fb9e2fc5b9232eb$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($6fb9e2fc5b9232eb$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $6fb9e2fc5b9232eb$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($6fb9e2fc5b9232eb$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($6fb9e2fc5b9232eb$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $5TDOW.InvariantError)(17);
}
function $6fb9e2fc5b9232eb$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $6fb9e2fc5b9232eb$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $6fb9e2fc5b9232eb$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $6fb9e2fc5b9232eb$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $6fb9e2fc5b9232eb$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $6fb9e2fc5b9232eb$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($dxLgR)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($6fb9e2fc5b9232eb$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $6fb9e2fc5b9232eb$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $6fb9e2fc5b9232eb$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $6fb9e2fc5b9232eb$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $6fb9e2fc5b9232eb$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $6fb9e2fc5b9232eb$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $6fb9e2fc5b9232eb$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $6fb9e2fc5b9232eb$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $fH1jI.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $6fb9e2fc5b9232eb$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $6fb9e2fc5b9232eb$var$defaultValueFromVariable(node) {
    throw new (0, $5TDOW.InvariantError)(18);
}
function $6fb9e2fc5b9232eb$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $6fb9e2fc5b9232eb$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $6fb9e2fc5b9232eb$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $6fb9e2fc5b9232eb$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $6fb9e2fc5b9232eb$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $6fb9e2fc5b9232eb$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $6fb9e2fc5b9232eb$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $6fb9e2fc5b9232eb$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $5TDOW.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $6fb9e2fc5b9232eb$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $6hznq.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $6fb9e2fc5b9232eb$export$2dafb573e282fe8d(names, doc) {
    return $6fb9e2fc5b9232eb$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $6fb9e2fc5b9232eb$export$8d1e9e5bbfa5d09a(document) {
    return document && $6fb9e2fc5b9232eb$export$2dafb573e282fe8d([
        'client'
    ], document) && $6fb9e2fc5b9232eb$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $6fb9e2fc5b9232eb$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $6fb9e2fc5b9232eb$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($6fb9e2fc5b9232eb$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $5TDOW.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $5TDOW.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $5TDOW.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $6fb9e2fc5b9232eb$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $5TDOW.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $5TDOW.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, document), {
        definitions: (0, $fH1jI.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $6fb9e2fc5b9232eb$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $6fb9e2fc5b9232eb$export$a92e7a440b22bdf0(doc) {
    $6fb9e2fc5b9232eb$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $5TDOW.invariant)(mutationDef, 1);
    return mutationDef;
}
function $6fb9e2fc5b9232eb$export$a7d0d8111d2386df(doc) {
    (0, $5TDOW.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $5TDOW.InvariantError)(3);
        return definition;
    });
    (0, $5TDOW.invariant)(operations.length <= 1, 4);
    return doc;
}
function $6fb9e2fc5b9232eb$export$7a5b1fa979d2c158(doc) {
    $6fb9e2fc5b9232eb$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $6fb9e2fc5b9232eb$export$78a8e95d8d43ad7f(document) {
    var def = $6fb9e2fc5b9232eb$export$7a5b1fa979d2c158(document);
    (0, $5TDOW.invariant)(def, 5);
    return def;
}
function $6fb9e2fc5b9232eb$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $6fb9e2fc5b9232eb$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $6fb9e2fc5b9232eb$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $6fb9e2fc5b9232eb$export$7a5b1fa979d2c158(doc);
    (0, $5TDOW.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $6fb9e2fc5b9232eb$export$772111caef41b3f5(doc) {
    (0, $5TDOW.invariant)(doc.kind === 'Document', 7);
    (0, $5TDOW.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $5TDOW.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $6fb9e2fc5b9232eb$export$f431198736b7f96d(queryDoc) {
    $6fb9e2fc5b9232eb$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $5TDOW.InvariantError)(10);
}
function $6fb9e2fc5b9232eb$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $6fb9e2fc5b9232eb$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $6fb9e2fc5b9232eb$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $6fb9e2fc5b9232eb$export$e6e34fd1f2686227.apply(void 0, (0, $fH1jI.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $6fb9e2fc5b9232eb$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $6fb9e2fc5b9232eb$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $6fb9e2fc5b9232eb$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $6fb9e2fc5b9232eb$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $6fb9e2fc5b9232eb$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $6fb9e2fc5b9232eb$var$nullIfDocIsEmpty(doc) {
    return $6fb9e2fc5b9232eb$var$isEmpty($6fb9e2fc5b9232eb$export$7a5b1fa979d2c158(doc) || $6fb9e2fc5b9232eb$export$772111caef41b3f5(doc), $6fb9e2fc5b9232eb$export$193789b4c8246dd4($6fb9e2fc5b9232eb$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $6fb9e2fc5b9232eb$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $6fb9e2fc5b9232eb$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $6fb9e2fc5b9232eb$var$nullIfDocIsEmpty((0, $6hznq.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($6fb9e2fc5b9232eb$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $6fb9e2fc5b9232eb$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($6fb9e2fc5b9232eb$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $6fb9e2fc5b9232eb$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $6fb9e2fc5b9232eb$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $6fb9e2fc5b9232eb$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $6fb9e2fc5b9232eb$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $6fb9e2fc5b9232eb$export$43b332f87950a467(doc) {
    return (0, $6hznq.visit)($6fb9e2fc5b9232eb$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $6fb9e2fc5b9232eb$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($6fb9e2fc5b9232eb$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, node), {
                    selections: (0, $fH1jI.__spreadArrays)(selections, [
                        $6fb9e2fc5b9232eb$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $6fb9e2fc5b9232eb$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $6fb9e2fc5b9232eb$export$74985f3324559867(doc) {
    return $6fb9e2fc5b9232eb$export$e5ae0530da5fe96c([
        $6fb9e2fc5b9232eb$var$connectionRemoveConfig
    ], $6fb9e2fc5b9232eb$export$a7d0d8111d2386df(doc));
}
function $6fb9e2fc5b9232eb$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $6fb9e2fc5b9232eb$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $6fb9e2fc5b9232eb$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$6fb9e2fc5b9232eb$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($6fb9e2fc5b9232eb$var$getDirectiveMatcher(directives)) || nestedCheck && $6fb9e2fc5b9232eb$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $6fb9e2fc5b9232eb$export$deed3420cb5d2e1d(directives, doc) {
    $6fb9e2fc5b9232eb$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $6fb9e2fc5b9232eb$var$nullIfDocIsEmpty((0, $6hznq.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $6fb9e2fc5b9232eb$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($6fb9e2fc5b9232eb$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $6fb9e2fc5b9232eb$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $6fb9e2fc5b9232eb$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $6fb9e2fc5b9232eb$var$getArgumentMatcher(config);
    return $6fb9e2fc5b9232eb$var$nullIfDocIsEmpty((0, $6hznq.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $6fb9e2fc5b9232eb$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $6fb9e2fc5b9232eb$var$nullIfDocIsEmpty((0, $6hznq.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $6fb9e2fc5b9232eb$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($6fb9e2fc5b9232eb$export$fb56ad75dd311c12(selection) || $6fb9e2fc5b9232eb$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $6fb9e2fc5b9232eb$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $6fb9e2fc5b9232eb$export$57c368c23873f32b(document) {
    var definition = $6fb9e2fc5b9232eb$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $6hznq.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $6fb9e2fc5b9232eb$export$8eae69e876ee321e(document) {
    $6fb9e2fc5b9232eb$export$a7d0d8111d2386df(document);
    var modifiedDoc = $6fb9e2fc5b9232eb$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $6hznq.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $6fb9e2fc5b9232eb$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $6fb9e2fc5b9232eb$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $6fb9e2fc5b9232eb$var$toString = Object.prototype.toString;
function $6fb9e2fc5b9232eb$export$629a2bd3f5a49ecc(value) {
    return $6fb9e2fc5b9232eb$var$cloneDeepHelper(value, new Map());
}
function $6fb9e2fc5b9232eb$var$cloneDeepHelper(val, seen) {
    switch($6fb9e2fc5b9232eb$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $6fb9e2fc5b9232eb$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $6fb9e2fc5b9232eb$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $6fb9e2fc5b9232eb$export$4bd44a2aa29d3d6e() {
    return 'development';
}
function $6fb9e2fc5b9232eb$export$f0cb0fda19c18b37(env) {
    return $6fb9e2fc5b9232eb$export$4bd44a2aa29d3d6e() === env;
}
function $6fb9e2fc5b9232eb$export$f15d00aa73aafac4() {
    return $6fb9e2fc5b9232eb$export$f0cb0fda19c18b37('production') === true;
}
function $6fb9e2fc5b9232eb$export$df77466336fe5355() {
    return $6fb9e2fc5b9232eb$export$f0cb0fda19c18b37('development') === true;
}
function $6fb9e2fc5b9232eb$export$410cbc2864fa25b5() {
    return $6fb9e2fc5b9232eb$export$f0cb0fda19c18b37('test') === true;
}
function $6fb9e2fc5b9232eb$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $6fb9e2fc5b9232eb$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $6fb9e2fc5b9232eb$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $6fb9e2fc5b9232eb$var$deepFreeze(o[prop]);
    });
    return o;
}
function $6fb9e2fc5b9232eb$export$7f9c177735b71f18(obj) {
    if ($6fb9e2fc5b9232eb$export$df77466336fe5355() || $6fb9e2fc5b9232eb$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $6fb9e2fc5b9232eb$var$deepFreeze(obj);
    }
    return obj;
}
var $6fb9e2fc5b9232eb$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $6fb9e2fc5b9232eb$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $6fb9e2fc5b9232eb$export$160070228be94b08(sources);
}
function $6fb9e2fc5b9232eb$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $6fb9e2fc5b9232eb$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $6fb9e2fc5b9232eb$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $6fb9e2fc5b9232eb$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $6fb9e2fc5b9232eb$var$mergeHelper(target, source, pastCopies) {
    if ($6fb9e2fc5b9232eb$var$isObject(source) && $6fb9e2fc5b9232eb$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $6fb9e2fc5b9232eb$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($6fb9e2fc5b9232eb$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $6fb9e2fc5b9232eb$var$mergeHelper($6fb9e2fc5b9232eb$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $6fb9e2fc5b9232eb$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $fH1jI.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $6fb9e2fc5b9232eb$var$haveWarned = Object.create({});
function $6fb9e2fc5b9232eb$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$6fb9e2fc5b9232eb$export$f15d00aa73aafac4() && !$6fb9e2fc5b9232eb$var$haveWarned[msg]) {
        if (!$6fb9e2fc5b9232eb$export$410cbc2864fa25b5()) $6fb9e2fc5b9232eb$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $6fb9e2fc5b9232eb$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("6hznq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.visit = $492fc5bbc69682aa$var$visit;
module.exports.visitInParallel = $492fc5bbc69682aa$var$visitInParallel;
module.exports.getVisitFn = $492fc5bbc69682aa$var$getVisitFn;
module.exports.BREAK = module.exports.QueryDocumentKeys = void 0;

var $492fc5bbc69682aa$var$_inspect = $492fc5bbc69682aa$var$_interopRequireDefault((parcelRequire("5wcli")));

var $d0QZI = parcelRequire("d0QZI");
function $492fc5bbc69682aa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $492fc5bbc69682aa$var$QueryDocumentKeys = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
module.exports.QueryDocumentKeys = $492fc5bbc69682aa$var$QueryDocumentKeys;
var $492fc5bbc69682aa$var$BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */ module.exports.BREAK = $492fc5bbc69682aa$var$BREAK;
function $492fc5bbc69682aa$var$visit(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $492fc5bbc69682aa$var$QueryDocumentKeys;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $d0QZI.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $492fc5bbc69682aa$var$_inspect.default)(node), "."));
            var visitFn = $492fc5bbc69682aa$var$getVisitFn(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $492fc5bbc69682aa$var$BREAK) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $d0QZI.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */ function $492fc5bbc69682aa$var$visitInParallel(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $492fc5bbc69682aa$var$getVisitFn(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $492fc5bbc69682aa$var$BREAK) skipping[i] = $492fc5bbc69682aa$var$BREAK;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $492fc5bbc69682aa$var$getVisitFn(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $492fc5bbc69682aa$var$BREAK) skipping[i] = $492fc5bbc69682aa$var$BREAK;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */ function $492fc5bbc69682aa$var$getVisitFn(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("5wcli", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $404983e54f0d2ba1$var$inspect;

var $404983e54f0d2ba1$var$_nodejsCustomInspectSymbol = $404983e54f0d2ba1$var$_interopRequireDefault((parcelRequire("k6VIH")));
function $404983e54f0d2ba1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $404983e54f0d2ba1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $404983e54f0d2ba1$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $404983e54f0d2ba1$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $404983e54f0d2ba1$var$_typeof(obj);
}
var $404983e54f0d2ba1$var$MAX_ARRAY_LENGTH = 10;
var $404983e54f0d2ba1$var$MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */ function $404983e54f0d2ba1$var$inspect(value) {
    return $404983e54f0d2ba1$var$formatValue(value, []);
}
function $404983e54f0d2ba1$var$formatValue(value, seenValues) {
    switch($404983e54f0d2ba1$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $404983e54f0d2ba1$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $404983e54f0d2ba1$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $404983e54f0d2ba1$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $404983e54f0d2ba1$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $404983e54f0d2ba1$var$formatArray(value, seenValues);
    return $404983e54f0d2ba1$var$formatObject(value, seenValues);
}
function $404983e54f0d2ba1$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $404983e54f0d2ba1$var$MAX_RECURSIVE_DEPTH) return '[' + $404983e54f0d2ba1$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $404983e54f0d2ba1$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $404983e54f0d2ba1$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $404983e54f0d2ba1$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($404983e54f0d2ba1$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($404983e54f0d2ba1$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $404983e54f0d2ba1$var$getCustomFn(object) {
    var customInspectFn = object[String($404983e54f0d2ba1$var$_nodejsCustomInspectSymbol.default)];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $404983e54f0d2ba1$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("k6VIH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $ea4124304f727f3e$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $ea4124304f727f3e$var$_default = $ea4124304f727f3e$var$nodejsCustomInspectSymbol;
module.exports.default = $ea4124304f727f3e$var$_default;

});


parcelRegister("d0QZI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isNode = $9794620c75682ade$var$isNode;
module.exports.Token = module.exports.Location = void 0;

var $9794620c75682ade$var$_defineInspect = $9794620c75682ade$var$_interopRequireDefault((parcelRequire("bayOA")));
function $9794620c75682ade$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ var $9794620c75682ade$var$Location = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
module.exports.Location = $9794620c75682ade$var$Location;
(0, $9794620c75682ade$var$_defineInspect.default)($9794620c75682ade$var$Location);
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */ var $9794620c75682ade$var$Token = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
module.exports.Token = $9794620c75682ade$var$Token;
(0, $9794620c75682ade$var$_defineInspect.default)($9794620c75682ade$var$Token);
/**
 * @internal
 */ function $9794620c75682ade$var$isNode(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("bayOA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $821ba25fd9b02d58$var$defineInspect;

var $821ba25fd9b02d58$var$_invariant = $821ba25fd9b02d58$var$_interopRequireDefault((parcelRequire("d56yi")));

var $821ba25fd9b02d58$var$_nodejsCustomInspectSymbol = $821ba25fd9b02d58$var$_interopRequireDefault((parcelRequire("k6VIH")));
function $821ba25fd9b02d58$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * The `defineInspect()` function defines `inspect()` prototype method as alias of `toJSON`
 */ function $821ba25fd9b02d58$var$defineInspect(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $821ba25fd9b02d58$var$_invariant.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if ($821ba25fd9b02d58$var$_nodejsCustomInspectSymbol.default) classObject.prototype[$821ba25fd9b02d58$var$_nodejsCustomInspectSymbol.default] = fn;
}

});
parcelRegister("d56yi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9860d3238c2390c5$var$invariant;
function $9860d3238c2390c5$var$invariant(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});




parcelRegister("5TDOW", function(module, exports) {

$parcel$export(module.exports, "InvariantError", function () { return $44b0fa5cc6d7ec6c$export$cea12affaee22fe8; });
$parcel$export(module.exports, "invariant", function () { return $44b0fa5cc6d7ec6c$export$f5708dca728d7177; });

var $fH1jI = parcelRequire("fH1jI");
var $44b0fa5cc6d7ec6c$var$genericMessage = "Invariant Violation";
var $44b0fa5cc6d7ec6c$var$_a = Object.setPrototypeOf, $44b0fa5cc6d7ec6c$var$setPrototypeOf = $44b0fa5cc6d7ec6c$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $44b0fa5cc6d7ec6c$var$_a;
var $44b0fa5cc6d7ec6c$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $fH1jI.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $44b0fa5cc6d7ec6c$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $44b0fa5cc6d7ec6c$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $44b0fa5cc6d7ec6c$var$genericMessage;
        $44b0fa5cc6d7ec6c$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $44b0fa5cc6d7ec6c$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $44b0fa5cc6d7ec6c$export$cea12affaee22fe8(message);
}
function $44b0fa5cc6d7ec6c$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $44b0fa5cc6d7ec6c$var$wrapConsoleMethod("warn");
    invariant.error = $44b0fa5cc6d7ec6c$var$wrapConsoleMethod("error");
})($44b0fa5cc6d7ec6c$export$f5708dca728d7177 || ($44b0fa5cc6d7ec6c$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $44b0fa5cc6d7ec6c$export$e54fe5b0f43758f7 = {
    env: {}
};
try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($44b0fa5cc6d7ec6c$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $44b0fa5cc6d7ec6c$var$invariant$1 = $44b0fa5cc6d7ec6c$export$f5708dca728d7177;
var $44b0fa5cc6d7ec6c$export$2e2bcd8739ae039 = $44b0fa5cc6d7ec6c$var$invariant$1;

});

parcelRegister("dxLgR", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("bOR6e", function(module, exports) {
var $89ad8dacc08b3a5d$var$_a = Object.prototype, $89ad8dacc08b3a5d$var$toString = $89ad8dacc08b3a5d$var$_a.toString, $89ad8dacc08b3a5d$var$hasOwnProperty = $89ad8dacc08b3a5d$var$_a.hasOwnProperty;
var $89ad8dacc08b3a5d$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $89ad8dacc08b3a5d$export$411ce8e5a71e3069(a, b) {
    try {
        return $89ad8dacc08b3a5d$var$check(a, b);
    } finally{
        $89ad8dacc08b3a5d$var$previousComparisons.clear();
    }
}
function $89ad8dacc08b3a5d$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $89ad8dacc08b3a5d$var$toString.call(a);
    var bTag = $89ad8dacc08b3a5d$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($89ad8dacc08b3a5d$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$89ad8dacc08b3a5d$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$89ad8dacc08b3a5d$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($89ad8dacc08b3a5d$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$89ad8dacc08b3a5d$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $89ad8dacc08b3a5d$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $89ad8dacc08b3a5d$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $89ad8dacc08b3a5d$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $89ad8dacc08b3a5d$export$2e2bcd8739ae039 = $89ad8dacc08b3a5d$export$411ce8e5a71e3069;

});


parcelRegister("6am30", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.print = $47d4c76e763ca723$var$print;

var $6hznq = parcelRequire("6hznq");

var $dX5oI = parcelRequire("dX5oI");
/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */ function $47d4c76e763ca723$var$print(ast) {
    return (0, $6hznq.visit)(ast, {
        leave: $47d4c76e763ca723$var$printDocASTReducer
    });
}
var $47d4c76e763ca723$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $47d4c76e763ca723$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $47d4c76e763ca723$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $47d4c76e763ca723$var$wrap('(', $47d4c76e763ca723$var$join(node.variableDefinitions, ', '), ')');
        var directives = $47d4c76e763ca723$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $47d4c76e763ca723$var$join([
            op,
            $47d4c76e763ca723$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $47d4c76e763ca723$var$wrap(' = ', defaultValue) + $47d4c76e763ca723$var$wrap(' ', $47d4c76e763ca723$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $47d4c76e763ca723$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $47d4c76e763ca723$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $47d4c76e763ca723$var$wrap('(', $47d4c76e763ca723$var$join(args, ', '), ')');
        if (argsLine.length > $47d4c76e763ca723$var$MAX_LINE_LENGTH) argsLine = prefix + $47d4c76e763ca723$var$wrap('(\n', $47d4c76e763ca723$var$indent($47d4c76e763ca723$var$join(args, '\n')), '\n)');
        return $47d4c76e763ca723$var$join([
            argsLine,
            $47d4c76e763ca723$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $47d4c76e763ca723$var$wrap(' ', $47d4c76e763ca723$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $47d4c76e763ca723$var$join([
            '...',
            $47d4c76e763ca723$var$wrap('on ', typeCondition),
            $47d4c76e763ca723$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($47d4c76e763ca723$var$wrap('(', $47d4c76e763ca723$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($47d4c76e763ca723$var$wrap('', $47d4c76e763ca723$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $dX5oI.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $47d4c76e763ca723$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $47d4c76e763ca723$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $47d4c76e763ca723$var$wrap('(', $47d4c76e763ca723$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $47d4c76e763ca723$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $47d4c76e763ca723$var$join([
            'schema',
            $47d4c76e763ca723$var$join(directives, ' '),
            $47d4c76e763ca723$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $47d4c76e763ca723$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $47d4c76e763ca723$var$join([
            'scalar',
            name,
            $47d4c76e763ca723$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $47d4c76e763ca723$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $47d4c76e763ca723$var$join([
            'type',
            name,
            $47d4c76e763ca723$var$wrap('implements ', $47d4c76e763ca723$var$join(interfaces, ' & ')),
            $47d4c76e763ca723$var$join(directives, ' '),
            $47d4c76e763ca723$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $47d4c76e763ca723$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($47d4c76e763ca723$var$hasMultilineItems(args) ? $47d4c76e763ca723$var$wrap('(\n', $47d4c76e763ca723$var$indent($47d4c76e763ca723$var$join(args, '\n')), '\n)') : $47d4c76e763ca723$var$wrap('(', $47d4c76e763ca723$var$join(args, ', '), ')')) + ': ' + type + $47d4c76e763ca723$var$wrap(' ', $47d4c76e763ca723$var$join(directives, ' '));
    }),
    InputValueDefinition: $47d4c76e763ca723$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $47d4c76e763ca723$var$join([
            name + ': ' + type,
            $47d4c76e763ca723$var$wrap('= ', defaultValue),
            $47d4c76e763ca723$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $47d4c76e763ca723$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $47d4c76e763ca723$var$join([
            'interface',
            name,
            $47d4c76e763ca723$var$wrap('implements ', $47d4c76e763ca723$var$join(interfaces, ' & ')),
            $47d4c76e763ca723$var$join(directives, ' '),
            $47d4c76e763ca723$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $47d4c76e763ca723$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $47d4c76e763ca723$var$join([
            'union',
            name,
            $47d4c76e763ca723$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $47d4c76e763ca723$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $47d4c76e763ca723$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $47d4c76e763ca723$var$join([
            'enum',
            name,
            $47d4c76e763ca723$var$join(directives, ' '),
            $47d4c76e763ca723$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $47d4c76e763ca723$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $47d4c76e763ca723$var$join([
            name,
            $47d4c76e763ca723$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $47d4c76e763ca723$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $47d4c76e763ca723$var$join([
            'input',
            name,
            $47d4c76e763ca723$var$join(directives, ' '),
            $47d4c76e763ca723$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $47d4c76e763ca723$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($47d4c76e763ca723$var$hasMultilineItems(args) ? $47d4c76e763ca723$var$wrap('(\n', $47d4c76e763ca723$var$indent($47d4c76e763ca723$var$join(args, '\n')), '\n)') : $47d4c76e763ca723$var$wrap('(', $47d4c76e763ca723$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $47d4c76e763ca723$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $47d4c76e763ca723$var$join([
            'extend schema',
            $47d4c76e763ca723$var$join(directives, ' '),
            $47d4c76e763ca723$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $47d4c76e763ca723$var$join([
            'extend scalar',
            name,
            $47d4c76e763ca723$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $47d4c76e763ca723$var$join([
            'extend type',
            name,
            $47d4c76e763ca723$var$wrap('implements ', $47d4c76e763ca723$var$join(interfaces, ' & ')),
            $47d4c76e763ca723$var$join(directives, ' '),
            $47d4c76e763ca723$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $47d4c76e763ca723$var$join([
            'extend interface',
            name,
            $47d4c76e763ca723$var$wrap('implements ', $47d4c76e763ca723$var$join(interfaces, ' & ')),
            $47d4c76e763ca723$var$join(directives, ' '),
            $47d4c76e763ca723$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $47d4c76e763ca723$var$join([
            'extend union',
            name,
            $47d4c76e763ca723$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $47d4c76e763ca723$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $47d4c76e763ca723$var$join([
            'extend enum',
            name,
            $47d4c76e763ca723$var$join(directives, ' '),
            $47d4c76e763ca723$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $47d4c76e763ca723$var$join([
            'extend input',
            name,
            $47d4c76e763ca723$var$join(directives, ' '),
            $47d4c76e763ca723$var$block(fields)
        ], ' ');
    }
};
function $47d4c76e763ca723$var$addDescription(cb) {
    return function(node) {
        return $47d4c76e763ca723$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $47d4c76e763ca723$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $47d4c76e763ca723$var$block(array) {
    return $47d4c76e763ca723$var$wrap('{\n', $47d4c76e763ca723$var$indent($47d4c76e763ca723$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $47d4c76e763ca723$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $47d4c76e763ca723$var$indent(str) {
    return $47d4c76e763ca723$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $47d4c76e763ca723$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $47d4c76e763ca723$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($47d4c76e763ca723$var$isMultiline);
}

});
parcelRegister("dX5oI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dedentBlockStringValue = $a284f8e2be055dc8$var$dedentBlockStringValue;
module.exports.getBlockStringIndentation = $a284f8e2be055dc8$var$getBlockStringIndentation;
module.exports.printBlockString = $a284f8e2be055dc8$var$printBlockString;
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $a284f8e2be055dc8$var$dedentBlockStringValue(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $a284f8e2be055dc8$var$getBlockStringIndentation(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $a284f8e2be055dc8$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $a284f8e2be055dc8$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $a284f8e2be055dc8$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
/**
 * @internal
 */ function $a284f8e2be055dc8$var$getBlockStringIndentation(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */ function $a284f8e2be055dc8$var$printBlockString(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});




parcelRegister("3Akwr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/*
Copyright 2017 - 2021 Amazon.com, Inc. or its affiliates. All Rights Reserved.
Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with the License. A copy of the License is located at
    http://aws.amazon.com/apache2.0/
or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and limitations under the License.
*/ $parcel$global.Buffer = $parcel$global.Buffer || (parcelRequire("81U8s")).Buffer; // Required for aws sigv4 signing

var $2qlBa = parcelRequire("2qlBa");

var $d9eec = parcelRequire("d9eec");
var $29c4a7327934d900$require$Sha256 = $d9eec.Sha256;
parcelRequire("3igcq");
var $cxblV = parcelRequire("cxblV");
var $29c4a7327934d900$require$toHex = $cxblV.toHex;
var $29c4a7327934d900$var$encrypt = function(key, src, encoding) {
    if (encoding === void 0) encoding = '';
    var hash = new $29c4a7327934d900$require$Sha256(key);
    hash.update(src);
    var result = hash.digestSync();
    if (encoding === 'hex') return $29c4a7327934d900$require$toHex(result);
    return result;
};
var $29c4a7327934d900$var$hash = function(src) {
    var arg = src || '';
    var hash = new $29c4a7327934d900$require$Sha256();
    hash.update(arg);
    return $29c4a7327934d900$require$toHex(hash.digestSync());
};
/**
* @private
* Create canonical headers
*
<pre>
CanonicalHeaders =
    CanonicalHeadersEntry0 + CanonicalHeadersEntry1 + ... + CanonicalHeadersEntryN
CanonicalHeadersEntry =
    Lowercase(HeaderName) + ':' + Trimall(HeaderValue) + '\n'
</pre>
*/ var $29c4a7327934d900$var$canonical_headers = function(headers) {
    if (!headers || Object.keys(headers).length === 0) return '';
    return Object.keys(headers).map(function(key) {
        return {
            key: key.toLowerCase(),
            value: headers[key] ? headers[key].trim().replace(/\s+/g, ' ') : ''
        };
    }).sort(function(a, b) {
        return a.key < b.key ? -1 : 1;
    }).map(function(item) {
        return item.key + ':' + item.value;
    }).join('\n') + '\n';
};
/**
* List of header keys included in the canonical headers.
* @access private
*/ var $29c4a7327934d900$var$signed_headers = function(headers) {
    return Object.keys(headers).map(function(key) {
        return key.toLowerCase();
    }).sort().join(';');
};
/**
* @private
* Create canonical request
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-canonical-request.html|Create a Canonical Request}
*
<pre>
CanonicalRequest =
    HTTPRequestMethod + '\n' +
    CanonicalURI + '\n' +
    CanonicalQueryString + '\n' +
    CanonicalHeaders + '\n' +
    SignedHeaders + '\n' +
    HexEncode(Hash(RequestPayload))
</pre>
*/ var $29c4a7327934d900$var$canonical_request = function(request) {
    var url_info = $2qlBa.parse(request.url);
    return [
        request.method || '/',
        url_info.path,
        url_info.query,
        $29c4a7327934d900$var$canonical_headers(request.headers),
        $29c4a7327934d900$var$signed_headers(request.headers),
        $29c4a7327934d900$var$hash(request.body)
    ].join('\n');
};
var $29c4a7327934d900$var$parse_service_info = function(request) {
    var url_info = $2qlBa.parse(request.url), host = url_info.host;
    var matched = host.match(/([^.]+)\.(?:([^.]*)\.)?amazonaws\.com$/), parsed = (matched || []).slice(1, 3);
    if (parsed[1] === 'es') parsed = parsed.reverse();
    return {
        service: request.service || parsed[0],
        region: request.region || parsed[1]
    };
};
var $29c4a7327934d900$var$credential_scope = function(d_str, region, service) {
    return [
        d_str,
        region,
        service,
        'aws4_request'
    ].join('/');
};
/**
* @private
* Create a string to sign
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-string-to-sign.html|Create String to Sign}
*
<pre>
StringToSign =
    Algorithm + \n +
    RequestDateTime + \n +
    CredentialScope + \n +
    HashedCanonicalRequest
</pre>
*/ var $29c4a7327934d900$var$string_to_sign = function(algorithm, canonical_request, dt_str, scope) {
    return [
        algorithm,
        dt_str,
        scope,
        $29c4a7327934d900$var$hash(canonical_request)
    ].join('\n');
};
/**
* @private
* Create signing key
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-calculate-signature.html|Calculate Signature}
*
<pre>
kSecret = your secret access key
kDate = HMAC("AWS4" + kSecret, Date)
kRegion = HMAC(kDate, Region)
kService = HMAC(kRegion, Service)
kSigning = HMAC(kService, "aws4_request")
</pre>
*/ var $29c4a7327934d900$var$get_signing_key = function(secret_key, d_str, service_info) {
    if (secret_key === void 0) secret_key = '';
    var k = 'AWS4' + secret_key, k_date = $29c4a7327934d900$var$encrypt(k, d_str), k_region = $29c4a7327934d900$var$encrypt(k_date, service_info.region), k_service = $29c4a7327934d900$var$encrypt(k_region, service_info.service), k_signing = $29c4a7327934d900$var$encrypt(k_service, 'aws4_request');
    return k_signing;
};
var $29c4a7327934d900$var$get_signature = function(signing_key, str_to_sign) {
    return $29c4a7327934d900$var$encrypt(signing_key, str_to_sign, 'hex');
};
/**
* @private
* Create authorization header
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html|Add the Signing Information}
*/ var $29c4a7327934d900$var$get_authorization_header = function(algorithm, access_key, scope, signed_headers, signature) {
    if (access_key === void 0) access_key = '';
    return [
        algorithm + ' ' + 'Credential=' + access_key + '/' + scope,
        'SignedHeaders=' + signed_headers,
        'Signature=' + signature
    ].join(', ');
};
/**
* Sign a HTTP request, add 'Authorization' header to request param
* @method sign
* @memberof Signer
* @static
*
* @param {object} request - HTTP request object
<pre>
request: {
    method: GET | POST | PUT ...
    url: ...,
    headers: {
        header1: ...
    },
    body: data
}
</pre>
* @param {object} access_info - AWS access credential info
<pre>
access_info: {
    access_key: ...,
    secret_key: ...,
    session_token: ...
}
</pre>
* @param {object} [service_info] - AWS service type and region, optional,
*                                  if not provided then parse out from url
<pre>
service_info: {
    service: ...,
    region: ...
}
</pre>
*
* @returns {object} Signed HTTP request
*/ var $29c4a7327934d900$var$sign = function(request, access_info, service_info) {
    if (service_info === void 0) service_info = null;
    request.headers = request.headers || {};
    // datetime string and date string
    var dt = new Date(), dt_str = dt.toISOString().replace(/[:-]|\.\d{3}/g, ''), d_str = dt_str.substr(0, 8), algorithm = 'AWS4-HMAC-SHA256';
    var url_info = $2qlBa.parse(request.url);
    request.headers['host'] = url_info.host;
    request.headers['x-amz-date'] = dt_str;
    if (access_info.session_token) request.headers['X-Amz-Security-Token'] = access_info.session_token;
    // Task 1: Create a Canonical Request
    var request_str = $29c4a7327934d900$var$canonical_request(request);
    // Task 2: Create a String to Sign
    service_info = service_info || $29c4a7327934d900$var$parse_service_info(request);
    var scope = $29c4a7327934d900$var$credential_scope(d_str, service_info.region, service_info.service);
    var str_to_sign = $29c4a7327934d900$var$string_to_sign(algorithm, request_str, dt_str, scope);
    // Task 3: Calculate the Signature
    var signing_key = $29c4a7327934d900$var$get_signing_key(access_info.secret_key, d_str, service_info), signature = $29c4a7327934d900$var$get_signature(signing_key, str_to_sign);
    // Task 4: Adding the Signing information to the Request
    var authorization_header = $29c4a7327934d900$var$get_authorization_header(algorithm, access_info.access_key, scope, $29c4a7327934d900$var$signed_headers(request.headers), signature);
    request.headers['Authorization'] = authorization_header;
    return request;
};
/**
* AWS request signer.
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4_signing.html|Signature Version 4}
*
* @class Signer
*/ var $29c4a7327934d900$var$Signer = /** @class */ function() {
    function Signer() {}
    Signer.sign = $29c4a7327934d900$var$sign;
    return Signer;
}();
module.exports.Signer = $29c4a7327934d900$var$Signer;
module.exports.default = $29c4a7327934d900$var$Signer;

});
parcelRegister("3igcq", function(module, exports) {
$parcel$export(module.exports, "toHex", function () { return (parcelRequire("cxblV")).toHex; });
parcelRequire("cxblV");

});
parcelRegister("cxblV", function(module, exports) {

$parcel$export(module.exports, "toHex", function () { return $92015f7f826f97d4$export$7ea66e3774a60b67; });
const $92015f7f826f97d4$var$SHORT_TO_HEX = {};
const $92015f7f826f97d4$var$HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $92015f7f826f97d4$var$SHORT_TO_HEX[i] = encodedByte;
    $92015f7f826f97d4$var$HEX_TO_SHORT[encodedByte] = i;
}
function $92015f7f826f97d4$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in $92015f7f826f97d4$var$HEX_TO_SHORT) out[i / 2] = $92015f7f826f97d4$var$HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function $92015f7f826f97d4$export$7ea66e3774a60b67(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += $92015f7f826f97d4$var$SHORT_TO_HEX[bytes[i]];
    return out;
}

});



parcelRegister("i6Sec", function(module, exports) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */ 
exports = module.exports = (parcelRequire("id2ZD"));
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();
/**
 * Colors.
 */ exports.colors = [
    'lightseagreen',
    'forestgreen',
    'goldenrod',
    'dodgerblue',
    'darkorchid',
    'crimson'
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') return true;
    // is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ exports.formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (err) {
        return '[UnexpectedJSONParseError]: ' + err.message;
    }
};
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    var useColors = this.useColors;
    args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);
    if (!useColors) return;
    var c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');
    // the final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function(match) {
        if ('%%' === match) return;
        index++;
        if ('%c' === match) // we only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */ function log() {
    // this hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'
    return 'object' === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (null == namespaces) exports.storage.removeItem('debug');
        else exports.storage.debug = namespaces;
    } catch (e) {}
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    var r;
    try {
        r = exports.storage.debug;
    } catch (e) {}
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    r;
    return r;
}
/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */ exports.enable(load());
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        return window.localStorage;
    } catch (e) {}
}

});
parcelRegister("id2ZD", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */ exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;

exports.humanize = (parcelRequire("e8SRt"));
/**
 * The currently active debug mode names, and names to skip.
 */ exports.names = [];
exports.skips = [];
/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */ exports.formatters = {};
/**
 * Previous log timestamp.
 */ var prevTime;
/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */ function selectColor(namespace) {
    var hash = 0, i;
    for(i in namespace){
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return exports.colors[Math.abs(hash) % exports.colors.length];
}
/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */ function createDebug(namespace) {
    function debug() {
        // disabled?
        if (!debug.enabled) return;
        var self = debug;
        // set `diff` timestamp
        var curr = +new Date();
        var ms = curr - (prevTime || curr);
        self.diff = ms;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;
        // turn the `arguments` into a proper Array
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        args[0] = exports.coerce(args[0]);
        if ('string' !== typeof args[0]) // anything else let's inspect with %O
        args.unshift('%O');
        // apply any `formatters` transformations
        var index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
            // if we encounter an escaped % then don't increase the array index
            if (match === '%%') return match;
            index++;
            var formatter = exports.formatters[format];
            if ('function' === typeof formatter) {
                var val = args[index];
                match = formatter.call(self, val);
                // now we need to remove `args[index]` since it's inlined in the `format`
                args.splice(index, 1);
                index--;
            }
            return match;
        });
        // apply env-specific formatting (colors, etc.)
        exports.formatArgs.call(self, args);
        var logFn = debug.log || exports.log || console.log.bind(console);
        logFn.apply(self, args);
    }
    debug.namespace = namespace;
    debug.enabled = exports.enabled(namespace);
    debug.useColors = exports.useColors();
    debug.color = selectColor(namespace);
    // env-specific initialization logic for debug instances
    if ('function' === typeof exports.init) exports.init(debug);
    return debug;
}
/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */ function enable(namespaces) {
    exports.save(namespaces);
    exports.names = [];
    exports.skips = [];
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;
    for(var i = 0; i < len; i++){
        if (!split[i]) continue; // ignore empty strings
        namespaces = split[i].replace(/\*/g, '.*?');
        if (namespaces[0] === '-') exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
        else exports.names.push(new RegExp('^' + namespaces + '$'));
    }
}
/**
 * Disable debug output.
 *
 * @api public
 */ function disable() {
    exports.enable('');
}
/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */ function enabled(name) {
    var i, len;
    for(i = 0, len = exports.skips.length; i < len; i++){
        if (exports.skips[i].test(name)) return false;
    }
    for(i = 0, len = exports.names.length; i < len; i++){
        if (exports.names[i].test(name)) return true;
    }
    return false;
}
/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */ function coerce(val) {
    if (val instanceof Error) return val.stack || val.message;
    return val;
}

});
parcelRegister("e8SRt", function(module, exports) {
/**
 * Helpers.
 */ var $a4bc5e68642376b1$var$s = 1000;
var $a4bc5e68642376b1$var$m = $a4bc5e68642376b1$var$s * 60;
var $a4bc5e68642376b1$var$h = $a4bc5e68642376b1$var$m * 60;
var $a4bc5e68642376b1$var$d = $a4bc5e68642376b1$var$h * 24;
var $a4bc5e68642376b1$var$y = $a4bc5e68642376b1$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $a4bc5e68642376b1$var$parse(val);
    else if (type === 'number' && isNaN(val) === false) return options.long ? $a4bc5e68642376b1$var$fmtLong(val) : $a4bc5e68642376b1$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $a4bc5e68642376b1$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $a4bc5e68642376b1$var$y;
        case 'days':
        case 'day':
        case 'd':
            return n * $a4bc5e68642376b1$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $a4bc5e68642376b1$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $a4bc5e68642376b1$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $a4bc5e68642376b1$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $a4bc5e68642376b1$var$fmtShort(ms) {
    if (ms >= $a4bc5e68642376b1$var$d) return Math.round(ms / $a4bc5e68642376b1$var$d) + 'd';
    if (ms >= $a4bc5e68642376b1$var$h) return Math.round(ms / $a4bc5e68642376b1$var$h) + 'h';
    if (ms >= $a4bc5e68642376b1$var$m) return Math.round(ms / $a4bc5e68642376b1$var$m) + 'm';
    if (ms >= $a4bc5e68642376b1$var$s) return Math.round(ms / $a4bc5e68642376b1$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $a4bc5e68642376b1$var$fmtLong(ms) {
    return $a4bc5e68642376b1$var$plural(ms, $a4bc5e68642376b1$var$d, 'day') || $a4bc5e68642376b1$var$plural(ms, $a4bc5e68642376b1$var$h, 'hour') || $a4bc5e68642376b1$var$plural(ms, $a4bc5e68642376b1$var$m, 'minute') || $a4bc5e68642376b1$var$plural(ms, $a4bc5e68642376b1$var$s, 'second') || ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $a4bc5e68642376b1$var$plural(ms, n, name) {
    if (ms < n) return;
    if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
    return Math.ceil(ms / n) + ' ' + name + 's';
}

});



parcelRegister("2fyRj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Signer = void 0;

/*
Copyright 2017 - 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with the License. A copy of the License is located at
    http://aws.amazon.com/apache2.0/
or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and limitations under the License.
*/ $parcel$global.Buffer = $parcel$global.Buffer || (parcelRequire("81U8s")).Buffer; // Required for aws sigv4 signing

var $2qlBa = parcelRequire("2qlBa");

var $d9eec = parcelRequire("d9eec");
var $1a3805c173e64ba5$require$Sha256 = $d9eec.Sha256;
parcelRequire("8fgUR");
var $cxblV = parcelRequire("cxblV");
var $1a3805c173e64ba5$require$toHex = $cxblV.toHex;
var $1a3805c173e64ba5$var$encrypt = function(key, src, encoding) {
    if (encoding === void 0) encoding = '';
    var hash = new $1a3805c173e64ba5$require$Sha256(key);
    hash.update(src);
    var result = hash.digestSync();
    if (encoding === 'hex') return $1a3805c173e64ba5$require$toHex(result);
    return result;
};
var $1a3805c173e64ba5$var$hash = function(src) {
    var arg = src || '';
    var hash = new $1a3805c173e64ba5$require$Sha256();
    hash.update(arg);
    return $1a3805c173e64ba5$require$toHex(hash.digestSync());
};
/**
* @private
* Create canonical headers
*
<pre>
CanonicalHeaders =
    CanonicalHeadersEntry0 + CanonicalHeadersEntry1 + ... + CanonicalHeadersEntryN
CanonicalHeadersEntry =
    Lowercase(HeaderName) + ':' + Trimall(HeaderValue) + '\n'
</pre>
*/ var $1a3805c173e64ba5$var$canonical_headers = function(headers) {
    if (!headers || Object.keys(headers).length === 0) return '';
    return Object.keys(headers).map(function(key) {
        return {
            key: key.toLowerCase(),
            value: headers[key] ? headers[key].trim().replace(/\s+/g, ' ') : ''
        };
    }).sort(function(a, b) {
        return a.key < b.key ? -1 : 1;
    }).map(function(item) {
        return item.key + ':' + item.value;
    }).join('\n') + '\n';
};
/**
* List of header keys included in the canonical headers.
* @access private
*/ var $1a3805c173e64ba5$var$signed_headers = function(headers) {
    return Object.keys(headers).map(function(key) {
        return key.toLowerCase();
    }).sort().join(';');
};
/**
* @private
* Create canonical request
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-canonical-request.html|Create a Canonical Request}
*
<pre>
CanonicalRequest =
    HTTPRequestMethod + '\n' +
    CanonicalURI + '\n' +
    CanonicalQueryString + '\n' +
    CanonicalHeaders + '\n' +
    SignedHeaders + '\n' +
    HexEncode(Hash(RequestPayload))
</pre>
*/ var $1a3805c173e64ba5$var$canonical_request = function(request) {
    var url_info = $2qlBa.parse(request.url);
    return [
        request.method || '/',
        url_info.path,
        url_info.query,
        $1a3805c173e64ba5$var$canonical_headers(request.headers),
        $1a3805c173e64ba5$var$signed_headers(request.headers),
        $1a3805c173e64ba5$var$hash(request.body)
    ].join('\n');
};
var $1a3805c173e64ba5$var$parse_service_info = function(request) {
    var url_info = $2qlBa.parse(request.url), host = url_info.host;
    var matched = host.match(/([^.]+)\.(?:([^.]*)\.)?amazonaws\.com$/), parsed = (matched || []).slice(1, 3);
    if (parsed[1] === 'es') parsed = parsed.reverse();
    return {
        service: request.service || parsed[0],
        region: request.region || parsed[1]
    };
};
var $1a3805c173e64ba5$var$credential_scope = function(d_str, region, service) {
    return [
        d_str,
        region,
        service,
        'aws4_request'
    ].join('/');
};
/**
* @private
* Create a string to sign
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-string-to-sign.html|Create String to Sign}
*
<pre>
StringToSign =
    Algorithm + \n +
    RequestDateTime + \n +
    CredentialScope + \n +
    HashedCanonicalRequest
</pre>
*/ var $1a3805c173e64ba5$var$string_to_sign = function(algorithm, canonical_request, dt_str, scope) {
    return [
        algorithm,
        dt_str,
        scope,
        $1a3805c173e64ba5$var$hash(canonical_request)
    ].join('\n');
};
/**
* @private
* Create signing key
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-calculate-signature.html|Calculate Signature}
*
<pre>
kSecret = your secret access key
kDate = HMAC("AWS4" + kSecret, Date)
kRegion = HMAC(kDate, Region)
kService = HMAC(kRegion, Service)
kSigning = HMAC(kService, "aws4_request")
</pre>
*/ var $1a3805c173e64ba5$var$get_signing_key = function(secret_key, d_str, service_info) {
    if (secret_key === void 0) secret_key = '';
    var k = 'AWS4' + secret_key, k_date = $1a3805c173e64ba5$var$encrypt(k, d_str), k_region = $1a3805c173e64ba5$var$encrypt(k_date, service_info.region), k_service = $1a3805c173e64ba5$var$encrypt(k_region, service_info.service), k_signing = $1a3805c173e64ba5$var$encrypt(k_service, 'aws4_request');
    return k_signing;
};
var $1a3805c173e64ba5$var$get_signature = function(signing_key, str_to_sign) {
    return $1a3805c173e64ba5$var$encrypt(signing_key, str_to_sign, 'hex');
};
/**
* @private
* Create authorization header
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html|Add the Signing Information}
*/ var $1a3805c173e64ba5$var$get_authorization_header = function(algorithm, access_key, scope, signed_headers, signature) {
    if (access_key === void 0) access_key = '';
    return [
        algorithm + ' ' + 'Credential=' + access_key + '/' + scope,
        'SignedHeaders=' + signed_headers,
        'Signature=' + signature
    ].join(', ');
};
/**
* Sign a HTTP request, add 'Authorization' header to request param
* @method sign
* @memberof Signer
* @static
*
* @param {object} request - HTTP request object
<pre>
request: {
    method: GET | POST | PUT ...
    url: ...,
    headers: {
        header1: ...
    },
    body: data
}
</pre>
* @param {object} access_info - AWS access credential info
<pre>
access_info: {
    access_key: ...,
    secret_key: ...,
    session_token: ...
}
</pre>
* @param {object} [service_info] - AWS service type and region, optional,
*                                  if not provided then parse out from url
<pre>
service_info: {
    service: ...,
    region: ...
}
</pre>
*
* @returns {object} Signed HTTP request
*/ var $1a3805c173e64ba5$var$sign = function(request, access_info, service_info) {
    if (service_info === void 0) service_info = null;
    request.headers = request.headers || {};
    // datetime string and date string
    var dt = new Date(), dt_str = dt.toISOString().replace(/[:-]|\.\d{3}/g, ''), d_str = dt_str.substr(0, 8), algorithm = 'AWS4-HMAC-SHA256';
    var url_info = $2qlBa.parse(request.url);
    request.headers['host'] = url_info.host;
    request.headers['x-amz-date'] = dt_str;
    if (access_info.session_token) request.headers['X-Amz-Security-Token'] = access_info.session_token;
    // Task 1: Create a Canonical Request
    var request_str = $1a3805c173e64ba5$var$canonical_request(request);
    // Task 2: Create a String to Sign
    service_info = service_info || $1a3805c173e64ba5$var$parse_service_info(request);
    var scope = $1a3805c173e64ba5$var$credential_scope(d_str, service_info.region, service_info.service);
    var str_to_sign = $1a3805c173e64ba5$var$string_to_sign(algorithm, request_str, dt_str, scope);
    // Task 3: Calculate the Signature
    var signing_key = $1a3805c173e64ba5$var$get_signing_key(access_info.secret_key, d_str, service_info), signature = $1a3805c173e64ba5$var$get_signature(signing_key, str_to_sign);
    // Task 4: Adding the Signing information to the Request
    var authorization_header = $1a3805c173e64ba5$var$get_authorization_header(algorithm, access_info.access_key, scope, $1a3805c173e64ba5$var$signed_headers(request.headers), signature);
    request.headers['Authorization'] = authorization_header;
    return request;
};
/**
* AWS request signer.
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4_signing.html|Signature Version 4}
*
* @class Signer
*/ var $1a3805c173e64ba5$var$Signer = /** @class */ function() {
    function Signer() {}
    Signer.sign = $1a3805c173e64ba5$var$sign;
    return Signer;
}();
module.exports.Signer = $1a3805c173e64ba5$var$Signer;
module.exports.default = $1a3805c173e64ba5$var$Signer;

});
parcelRegister("8fgUR", function(module, exports) {
$parcel$export(module.exports, "toHex", function () { return (parcelRequire("cxblV")).toHex; });
parcelRequire("cxblV");

});


parcelRegister("vGg9x", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $05f3ad3a4ae8ae69$export$dca3b0875bd9a954; }, function (v) { return $05f3ad3a4ae8ae69$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $05f3ad3a4ae8ae69$export$16fa2f45be04daa8; }, function (v) { return $05f3ad3a4ae8ae69$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $05f3ad3a4ae8ae69$export$ffb0004e005737fa; }, function (v) { return $05f3ad3a4ae8ae69$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $05f3ad3a4ae8ae69$export$e2c29f18771995cb; }, function (v) { return $05f3ad3a4ae8ae69$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $05f3ad3a4ae8ae69$export$221d75b3f55bb0bd; }, function (v) { return $05f3ad3a4ae8ae69$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $05f3ad3a4ae8ae69$export$5f8d39834fd61797; }, function (v) { return $05f3ad3a4ae8ae69$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $05f3ad3a4ae8ae69$export$74bf444e3cd11ea5; }, function (v) { return $05f3ad3a4ae8ae69$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $05f3ad3a4ae8ae69$export$ae55be85d98224ed; }, function (v) { return $05f3ad3a4ae8ae69$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $05f3ad3a4ae8ae69$export$e530037191fcd5d7; }, function (v) { return $05f3ad3a4ae8ae69$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $05f3ad3a4ae8ae69$export$fd42f52fd3ae1109; }, function (v) { return $05f3ad3a4ae8ae69$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $05f3ad3a4ae8ae69$export$c8a8987d4410bf2d; }, function (v) { return $05f3ad3a4ae8ae69$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $05f3ad3a4ae8ae69$export$d38cd72104c1f0e9; }, function (v) { return $05f3ad3a4ae8ae69$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $05f3ad3a4ae8ae69$export$7d1e3a5e95ceca43; }, function (v) { return $05f3ad3a4ae8ae69$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $05f3ad3a4ae8ae69$export$257a8862b851cb5b; }, function (v) { return $05f3ad3a4ae8ae69$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $05f3ad3a4ae8ae69$export$a8257692ac88316c; }, function (v) { return $05f3ad3a4ae8ae69$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $05f3ad3a4ae8ae69$export$488013bae63b21da; }, function (v) { return $05f3ad3a4ae8ae69$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $05f3ad3a4ae8ae69$export$7c73462e0d25e514; }, function (v) { return $05f3ad3a4ae8ae69$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $05f3ad3a4ae8ae69$export$35808ee640e87ca7; }, function (v) { return $05f3ad3a4ae8ae69$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $05f3ad3a4ae8ae69$export$fae74005e78b1a27; }, function (v) { return $05f3ad3a4ae8ae69$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $05f3ad3a4ae8ae69$export$dc8fbce3eb94dc1e; }, function (v) { return $05f3ad3a4ae8ae69$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $05f3ad3a4ae8ae69$export$6d9c69b0de29b591; }, function (v) { return $05f3ad3a4ae8ae69$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $05f3ad3a4ae8ae69$export$d5a552a76deda3c2; }, function (v) { return $05f3ad3a4ae8ae69$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $05f3ad3a4ae8ae69$export$e5c5a5f917a5871c; }, function (v) { return $05f3ad3a4ae8ae69$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $05f3ad3a4ae8ae69$export$1538c33de8887b59; }, function (v) { return $05f3ad3a4ae8ae69$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $05f3ad3a4ae8ae69$export$13e3392192263954; }, function (v) { return $05f3ad3a4ae8ae69$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $05f3ad3a4ae8ae69$export$b8f5890fc79d6aca; }, function (v) { return $05f3ad3a4ae8ae69$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $05f3ad3a4ae8ae69$export$60241385465d0a34; }, function (v) { return $05f3ad3a4ae8ae69$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $05f3ad3a4ae8ae69$export$83d89fbfd8236492; }, function (v) { return $05f3ad3a4ae8ae69$export$83d89fbfd8236492 = v; });
/** @license React v16.13.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $05f3ad3a4ae8ae69$export$dca3b0875bd9a954;
var $05f3ad3a4ae8ae69$export$16fa2f45be04daa8;
var $05f3ad3a4ae8ae69$export$ffb0004e005737fa;
var $05f3ad3a4ae8ae69$export$e2c29f18771995cb;
var $05f3ad3a4ae8ae69$export$221d75b3f55bb0bd;
var $05f3ad3a4ae8ae69$export$5f8d39834fd61797;
var $05f3ad3a4ae8ae69$export$74bf444e3cd11ea5;
var $05f3ad3a4ae8ae69$export$ae55be85d98224ed;
var $05f3ad3a4ae8ae69$export$e530037191fcd5d7;
var $05f3ad3a4ae8ae69$export$fd42f52fd3ae1109;
var $05f3ad3a4ae8ae69$export$c8a8987d4410bf2d;
var $05f3ad3a4ae8ae69$export$d38cd72104c1f0e9;
var $05f3ad3a4ae8ae69$export$7d1e3a5e95ceca43;
var $05f3ad3a4ae8ae69$export$257a8862b851cb5b;
var $05f3ad3a4ae8ae69$export$a8257692ac88316c;
var $05f3ad3a4ae8ae69$export$488013bae63b21da;
var $05f3ad3a4ae8ae69$export$7c73462e0d25e514;
var $05f3ad3a4ae8ae69$export$35808ee640e87ca7;
var $05f3ad3a4ae8ae69$export$fae74005e78b1a27;
var $05f3ad3a4ae8ae69$export$dc8fbce3eb94dc1e;
var $05f3ad3a4ae8ae69$export$6d9c69b0de29b591;
var $05f3ad3a4ae8ae69$export$d5a552a76deda3c2;
var $05f3ad3a4ae8ae69$export$e5c5a5f917a5871c;
var $05f3ad3a4ae8ae69$export$1538c33de8887b59;
var $05f3ad3a4ae8ae69$export$13e3392192263954;
var $05f3ad3a4ae8ae69$export$b8f5890fc79d6aca;
var $05f3ad3a4ae8ae69$export$60241385465d0a34;
var $05f3ad3a4ae8ae69$export$83d89fbfd8236492;
'use strict';

var $9mzVh = parcelRequire("9mzVh");
var $05f3ad3a4ae8ae69$var$n = "function" === typeof Symbol && Symbol.for, $05f3ad3a4ae8ae69$var$p = $05f3ad3a4ae8ae69$var$n ? Symbol.for("react.element") : 60103, $05f3ad3a4ae8ae69$var$q = $05f3ad3a4ae8ae69$var$n ? Symbol.for("react.portal") : 60106, $05f3ad3a4ae8ae69$var$r = $05f3ad3a4ae8ae69$var$n ? Symbol.for("react.fragment") : 60107, $05f3ad3a4ae8ae69$var$t = $05f3ad3a4ae8ae69$var$n ? Symbol.for("react.strict_mode") : 60108, $05f3ad3a4ae8ae69$var$u = $05f3ad3a4ae8ae69$var$n ? Symbol.for("react.profiler") : 60114, $05f3ad3a4ae8ae69$var$v = $05f3ad3a4ae8ae69$var$n ? Symbol.for("react.provider") : 60109, $05f3ad3a4ae8ae69$var$w = $05f3ad3a4ae8ae69$var$n ? Symbol.for("react.context") : 60110, $05f3ad3a4ae8ae69$var$x = $05f3ad3a4ae8ae69$var$n ? Symbol.for("react.forward_ref") : 60112, $05f3ad3a4ae8ae69$var$y = $05f3ad3a4ae8ae69$var$n ? Symbol.for("react.suspense") : 60113, $05f3ad3a4ae8ae69$var$z = $05f3ad3a4ae8ae69$var$n ? Symbol.for("react.memo") : 60115, $05f3ad3a4ae8ae69$var$A = $05f3ad3a4ae8ae69$var$n ? Symbol.for("react.lazy") : 60116, $05f3ad3a4ae8ae69$var$B = "function" === typeof Symbol && Symbol.iterator;
function $05f3ad3a4ae8ae69$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $05f3ad3a4ae8ae69$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $05f3ad3a4ae8ae69$var$E = {};
function $05f3ad3a4ae8ae69$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $05f3ad3a4ae8ae69$var$E;
    this.updater = c || $05f3ad3a4ae8ae69$var$D;
}
$05f3ad3a4ae8ae69$var$F.prototype.isReactComponent = {};
$05f3ad3a4ae8ae69$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($05f3ad3a4ae8ae69$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$05f3ad3a4ae8ae69$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $05f3ad3a4ae8ae69$var$G() {}
$05f3ad3a4ae8ae69$var$G.prototype = $05f3ad3a4ae8ae69$var$F.prototype;
function $05f3ad3a4ae8ae69$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $05f3ad3a4ae8ae69$var$E;
    this.updater = c || $05f3ad3a4ae8ae69$var$D;
}
var $05f3ad3a4ae8ae69$var$I = $05f3ad3a4ae8ae69$var$H.prototype = new $05f3ad3a4ae8ae69$var$G;
$05f3ad3a4ae8ae69$var$I.constructor = $05f3ad3a4ae8ae69$var$H;
$9mzVh($05f3ad3a4ae8ae69$var$I, $05f3ad3a4ae8ae69$var$F.prototype);
$05f3ad3a4ae8ae69$var$I.isPureReactComponent = !0;
var $05f3ad3a4ae8ae69$var$J = {
    current: null
}, $05f3ad3a4ae8ae69$var$K = Object.prototype.hasOwnProperty, $05f3ad3a4ae8ae69$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $05f3ad3a4ae8ae69$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$05f3ad3a4ae8ae69$var$K.call(b, e) && !$05f3ad3a4ae8ae69$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $05f3ad3a4ae8ae69$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $05f3ad3a4ae8ae69$var$J.current
    };
}
function $05f3ad3a4ae8ae69$var$N(a, b) {
    return {
        $$typeof: $05f3ad3a4ae8ae69$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $05f3ad3a4ae8ae69$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $05f3ad3a4ae8ae69$var$p;
}
function $05f3ad3a4ae8ae69$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $05f3ad3a4ae8ae69$var$P = /\/+/g, $05f3ad3a4ae8ae69$var$Q = [];
function $05f3ad3a4ae8ae69$var$R(a, b, c, e) {
    if ($05f3ad3a4ae8ae69$var$Q.length) {
        var d = $05f3ad3a4ae8ae69$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $05f3ad3a4ae8ae69$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $05f3ad3a4ae8ae69$var$Q.length && $05f3ad3a4ae8ae69$var$Q.push(a);
}
function $05f3ad3a4ae8ae69$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $05f3ad3a4ae8ae69$var$p:
                case $05f3ad3a4ae8ae69$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $05f3ad3a4ae8ae69$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $05f3ad3a4ae8ae69$var$U(d, k);
        g += $05f3ad3a4ae8ae69$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $05f3ad3a4ae8ae69$var$B && a[$05f3ad3a4ae8ae69$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $05f3ad3a4ae8ae69$var$U(d, k++), g += $05f3ad3a4ae8ae69$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($05f3ad3a4ae8ae69$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $05f3ad3a4ae8ae69$var$V(a, b, c) {
    return null == a ? 0 : $05f3ad3a4ae8ae69$var$T(a, "", b, c);
}
function $05f3ad3a4ae8ae69$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $05f3ad3a4ae8ae69$var$escape(a.key) : b.toString(36);
}
function $05f3ad3a4ae8ae69$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $05f3ad3a4ae8ae69$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $05f3ad3a4ae8ae69$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($05f3ad3a4ae8ae69$var$O(a) && (a = $05f3ad3a4ae8ae69$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($05f3ad3a4ae8ae69$var$P, "$&/") + "/") + c)), e.push(a));
}
function $05f3ad3a4ae8ae69$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($05f3ad3a4ae8ae69$var$P, "$&/") + "/");
    b = $05f3ad3a4ae8ae69$var$R(b, g, e, d);
    $05f3ad3a4ae8ae69$var$V(a, $05f3ad3a4ae8ae69$var$aa, b);
    $05f3ad3a4ae8ae69$var$S(b);
}
var $05f3ad3a4ae8ae69$var$Y = {
    current: null
};
function $05f3ad3a4ae8ae69$var$Z() {
    var a = $05f3ad3a4ae8ae69$var$Y.current;
    if (null === a) throw Error($05f3ad3a4ae8ae69$var$C(321));
    return a;
}
var $05f3ad3a4ae8ae69$var$ba = {
    ReactCurrentDispatcher: $05f3ad3a4ae8ae69$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $05f3ad3a4ae8ae69$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $9mzVh
};
$05f3ad3a4ae8ae69$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $05f3ad3a4ae8ae69$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $05f3ad3a4ae8ae69$var$R(null, null, b, c);
        $05f3ad3a4ae8ae69$var$V(a, $05f3ad3a4ae8ae69$var$W, b);
        $05f3ad3a4ae8ae69$var$S(b);
    },
    count: function(a) {
        return $05f3ad3a4ae8ae69$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $05f3ad3a4ae8ae69$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$05f3ad3a4ae8ae69$var$O(a)) throw Error($05f3ad3a4ae8ae69$var$C(143));
        return a;
    }
};
$05f3ad3a4ae8ae69$export$16fa2f45be04daa8 = $05f3ad3a4ae8ae69$var$F;
$05f3ad3a4ae8ae69$export$ffb0004e005737fa = $05f3ad3a4ae8ae69$var$r;
$05f3ad3a4ae8ae69$export$e2c29f18771995cb = $05f3ad3a4ae8ae69$var$u;
$05f3ad3a4ae8ae69$export$221d75b3f55bb0bd = $05f3ad3a4ae8ae69$var$H;
$05f3ad3a4ae8ae69$export$5f8d39834fd61797 = $05f3ad3a4ae8ae69$var$t;
$05f3ad3a4ae8ae69$export$74bf444e3cd11ea5 = $05f3ad3a4ae8ae69$var$y;
$05f3ad3a4ae8ae69$export$ae55be85d98224ed = $05f3ad3a4ae8ae69$var$ba;
$05f3ad3a4ae8ae69$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($05f3ad3a4ae8ae69$var$C(267, a));
    var e = $9mzVh({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $05f3ad3a4ae8ae69$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$05f3ad3a4ae8ae69$var$K.call(b, h) && !$05f3ad3a4ae8ae69$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $05f3ad3a4ae8ae69$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$05f3ad3a4ae8ae69$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $05f3ad3a4ae8ae69$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $05f3ad3a4ae8ae69$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$05f3ad3a4ae8ae69$export$c8a8987d4410bf2d = $05f3ad3a4ae8ae69$var$M;
$05f3ad3a4ae8ae69$export$d38cd72104c1f0e9 = function(a) {
    var b = $05f3ad3a4ae8ae69$var$M.bind(null, a);
    b.type = a;
    return b;
};
$05f3ad3a4ae8ae69$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$05f3ad3a4ae8ae69$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $05f3ad3a4ae8ae69$var$x,
        render: a
    };
};
$05f3ad3a4ae8ae69$export$a8257692ac88316c = $05f3ad3a4ae8ae69$var$O;
$05f3ad3a4ae8ae69$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $05f3ad3a4ae8ae69$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$05f3ad3a4ae8ae69$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $05f3ad3a4ae8ae69$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$05f3ad3a4ae8ae69$export$35808ee640e87ca7 = function(a, b) {
    return $05f3ad3a4ae8ae69$var$Z().useCallback(a, b);
};
$05f3ad3a4ae8ae69$export$fae74005e78b1a27 = function(a, b) {
    return $05f3ad3a4ae8ae69$var$Z().useContext(a, b);
};
$05f3ad3a4ae8ae69$export$dc8fbce3eb94dc1e = function() {};
$05f3ad3a4ae8ae69$export$6d9c69b0de29b591 = function(a, b) {
    return $05f3ad3a4ae8ae69$var$Z().useEffect(a, b);
};
$05f3ad3a4ae8ae69$export$d5a552a76deda3c2 = function(a, b, c) {
    return $05f3ad3a4ae8ae69$var$Z().useImperativeHandle(a, b, c);
};
$05f3ad3a4ae8ae69$export$e5c5a5f917a5871c = function(a, b) {
    return $05f3ad3a4ae8ae69$var$Z().useLayoutEffect(a, b);
};
$05f3ad3a4ae8ae69$export$1538c33de8887b59 = function(a, b) {
    return $05f3ad3a4ae8ae69$var$Z().useMemo(a, b);
};
$05f3ad3a4ae8ae69$export$13e3392192263954 = function(a, b, c) {
    return $05f3ad3a4ae8ae69$var$Z().useReducer(a, b, c);
};
$05f3ad3a4ae8ae69$export$b8f5890fc79d6aca = function(a) {
    return $05f3ad3a4ae8ae69$var$Z().useRef(a);
};
$05f3ad3a4ae8ae69$export$60241385465d0a34 = function(a) {
    return $05f3ad3a4ae8ae69$var$Z().useState(a);
};
$05f3ad3a4ae8ae69$export$83d89fbfd8236492 = "16.13.1";

});

parcelRegister("bPyzV", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HIDE_TIMEOUT = undefined;
var $89cf47aed495d20f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $89cf47aed495d20f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
module.exports.OverlayComponent = $89cf47aed495d20f$var$OverlayComponent;
module.exports.defaultFormat = $89cf47aed495d20f$var$defaultFormat;
module.exports.defaultParse = $89cf47aed495d20f$var$defaultParse;

var $a5EUy = parcelRequire("a5EUy");
var $89cf47aed495d20f$var$_react2 = $89cf47aed495d20f$var$_interopRequireDefault($a5EUy);

var $3yJBl = parcelRequire("3yJBl");
var $89cf47aed495d20f$var$_propTypes2 = $89cf47aed495d20f$var$_interopRequireDefault($3yJBl);

var $eDkDO = parcelRequire("eDkDO");
var $89cf47aed495d20f$var$_DayPicker2 = $89cf47aed495d20f$var$_interopRequireDefault($eDkDO);

var $3y50U = parcelRequire("3y50U");

var $1wsvb = parcelRequire("1wsvb");

var $btFUU = parcelRequire("btFUU");
function $89cf47aed495d20f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $89cf47aed495d20f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $89cf47aed495d20f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $89cf47aed495d20f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $89cf47aed495d20f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $89cf47aed495d20f$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
// When clicking on a day cell, overlay will be hidden after this timeout
var $89cf47aed495d20f$var$HIDE_TIMEOUT = module.exports.HIDE_TIMEOUT = 100;
/**
 * The default component used as Overlay.
 *
 * @param {Object} props
 */ function $89cf47aed495d20f$var$OverlayComponent(_ref) {
    var input = _ref.input, selectedDay = _ref.selectedDay, month = _ref.month, children = _ref.children, classNames = _ref.classNames, props = $89cf47aed495d20f$var$_objectWithoutProperties(_ref, [
        'input',
        'selectedDay',
        'month',
        'children',
        'classNames'
    ]);
    return $89cf47aed495d20f$var$_react2.default.createElement('div', $89cf47aed495d20f$var$_extends({
        className: classNames.overlayWrapper
    }, props), $89cf47aed495d20f$var$_react2.default.createElement('div', {
        className: classNames.overlay
    }, children));
}
$89cf47aed495d20f$var$OverlayComponent.propTypes = {
    input: $89cf47aed495d20f$var$_propTypes2.default.any,
    selectedDay: $89cf47aed495d20f$var$_propTypes2.default.any,
    month: $89cf47aed495d20f$var$_propTypes2.default.instanceOf(Date),
    children: $89cf47aed495d20f$var$_propTypes2.default.node,
    classNames: $89cf47aed495d20f$var$_propTypes2.default.object
};
/**
 * The default function used to format a Date to String, passed to the `format`
 * prop.
 * @param {Date} d
 * @return {String}
 */ function $89cf47aed495d20f$var$defaultFormat(d) {
    if ((0, $3y50U.isDate)(d)) {
        var year = d.getFullYear();
        var month = '' + (d.getMonth() + 1);
        var day = '' + d.getDate();
        return year + '-' + month + '-' + day;
    }
    return '';
}
/**
 * The default function used to parse a String as Date, passed to the `parse`
 * prop.
 * @param {String} str
 * @return {Date}
 */ function $89cf47aed495d20f$var$defaultParse(str) {
    if (typeof str !== 'string') return undefined;
    var split = str.split('-');
    if (split.length !== 3) return undefined;
    var year = parseInt(split[0], 10);
    var month = parseInt(split[1], 10) - 1;
    var day = parseInt(split[2], 10);
    if (isNaN(year) || String(year).length > 4 || isNaN(month) || isNaN(day) || day <= 0 || day > 31 || month < 0 || month >= 12) return undefined;
    return new Date(year, month, day, 12, 0, 0, 0); // always set noon to avoid time zone issues
}
var $89cf47aed495d20f$var$DayPickerInput = function(_React$Component) {
    $89cf47aed495d20f$var$_inherits(DayPickerInput, _React$Component);
    function DayPickerInput(props) {
        $89cf47aed495d20f$var$_classCallCheck(this, DayPickerInput);
        var _this = $89cf47aed495d20f$var$_possibleConstructorReturn(this, (DayPickerInput.__proto__ || Object.getPrototypeOf(DayPickerInput)).call(this, props));
        _this.input = null;
        _this.daypicker = null;
        _this.clickTimeout = null;
        _this.hideTimeout = null;
        _this.inputBlurTimeout = null;
        _this.inputFocusTimeout = null;
        _this.state = _this.getInitialStateFromProps(props);
        _this.state.showOverlay = props.showOverlay;
        _this.hideAfterDayClick = _this.hideAfterDayClick.bind(_this);
        _this.handleInputClick = _this.handleInputClick.bind(_this);
        _this.handleInputFocus = _this.handleInputFocus.bind(_this);
        _this.handleInputBlur = _this.handleInputBlur.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        _this.handleInputKeyDown = _this.handleInputKeyDown.bind(_this);
        _this.handleInputKeyUp = _this.handleInputKeyUp.bind(_this);
        _this.handleDayClick = _this.handleDayClick.bind(_this);
        _this.handleMonthChange = _this.handleMonthChange.bind(_this);
        _this.handleOverlayFocus = _this.handleOverlayFocus.bind(_this);
        _this.handleOverlayBlur = _this.handleOverlayBlur.bind(_this);
        return _this;
    }
    $89cf47aed495d20f$var$_createClass(DayPickerInput, [
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                var newState = {};
                // Current props
                var _props = this.props, value = _props.value, formatDate = _props.formatDate, format = _props.format, dayPickerProps = _props.dayPickerProps;
                // Update the input value if `value`, `dayPickerProps.locale` or `format`
                // props have changed
                if (value !== prevProps.value || dayPickerProps.locale !== prevProps.dayPickerProps.locale || format !== prevProps.format) {
                    if ((0, $3y50U.isDate)(value)) newState.value = formatDate(value, format, dayPickerProps.locale);
                    else newState.value = value;
                }
                // Update the month if the months from props changed
                var prevMonth = prevProps.dayPickerProps.month;
                if (dayPickerProps.month && dayPickerProps.month !== prevMonth && !(0, $3y50U.isSameMonth)(dayPickerProps.month, prevMonth)) newState.month = dayPickerProps.month;
                // Updated the selected days from props if they changed
                if (prevProps.dayPickerProps.selectedDays !== dayPickerProps.selectedDays) newState.selectedDays = dayPickerProps.selectedDays;
                if (Object.keys(newState).length > 0) // eslint-disable-next-line react/no-did-update-set-state
                this.setState(newState);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                clearTimeout(this.clickTimeout);
                clearTimeout(this.hideTimeout);
                clearTimeout(this.inputFocusTimeout);
                clearTimeout(this.inputBlurTimeout);
                clearTimeout(this.overlayBlurTimeout);
            }
        },
        {
            key: 'getInitialMonthFromProps',
            value: function getInitialMonthFromProps(props) {
                var dayPickerProps = props.dayPickerProps, format = props.format;
                var day = void 0;
                if (props.value) {
                    if ((0, $3y50U.isDate)(props.value)) day = props.value;
                    else day = props.parseDate(props.value, format, dayPickerProps.locale);
                }
                return dayPickerProps.initialMonth || dayPickerProps.month || day || new Date();
            }
        },
        {
            key: 'getInitialStateFromProps',
            value: function getInitialStateFromProps(props) {
                var dayPickerProps = props.dayPickerProps, formatDate = props.formatDate, format = props.format, typedValue = props.typedValue;
                var value = props.value;
                if (props.value && (0, $3y50U.isDate)(props.value)) value = formatDate(props.value, format, dayPickerProps.locale);
                return {
                    value: value,
                    typedValue: typedValue,
                    month: this.getInitialMonthFromProps(props),
                    selectedDays: dayPickerProps.selectedDays
                };
            }
        },
        {
            key: 'getInput',
            value: function getInput() {
                return this.input;
            }
        },
        {
            key: 'getDayPicker',
            value: function getDayPicker() {
                return this.daypicker;
            }
        },
        {
            key: 'updateState',
            value: function updateState(day, value, callback) {
                var _this2 = this;
                var _props2 = this.props, dayPickerProps = _props2.dayPickerProps, onDayChange = _props2.onDayChange;
                this.setState({
                    month: day,
                    value: value,
                    typedValue: ''
                }, function() {
                    if (callback) callback();
                    if (!onDayChange) return;
                    var modifiersObj = $89cf47aed495d20f$var$_extends({
                        disabled: dayPickerProps.disabledDays,
                        selected: dayPickerProps.selectedDays
                    }, dayPickerProps.modifiers);
                    var modifiers = (0, $1wsvb.getModifiersForDay)(day, modifiersObj).reduce(function(obj, modifier) {
                        return $89cf47aed495d20f$var$_extends({}, obj, $89cf47aed495d20f$var$_defineProperty({}, modifier, true));
                    }, {});
                    onDayChange(day, modifiers, _this2);
                });
            }
        },
        {
            key: 'showDayPicker',
            value: function showDayPicker() {
                var _this3 = this;
                var _props3 = this.props, parseDate = _props3.parseDate, format = _props3.format, dayPickerProps = _props3.dayPickerProps;
                var _state = this.state, value = _state.value, showOverlay = _state.showOverlay;
                if (showOverlay) return;
                // Reset the current displayed month when showing the overlay
                var month = value ? parseDate(value, format, dayPickerProps.locale) // Use the month in the input field
                 : this.getInitialMonthFromProps(this.props); // Restore the month from the props
                this.setState(function(state) {
                    return {
                        showOverlay: true,
                        month: month || state.month
                    };
                }, function() {
                    if (_this3.props.onDayPickerShow) _this3.props.onDayPickerShow();
                });
            }
        },
        {
            key: 'hideDayPicker',
            value: function hideDayPicker() {
                var _this4 = this;
                if (this.state.showOverlay === false) return;
                this.setState({
                    showOverlay: false
                }, function() {
                    if (_this4.props.onDayPickerHide) _this4.props.onDayPickerHide();
                });
            }
        },
        {
            key: 'hideAfterDayClick',
            value: function hideAfterDayClick() {
                var _this5 = this;
                if (!this.props.hideOnDayClick) return;
                this.hideTimeout = setTimeout(function() {
                    _this5.overlayHasFocus = false;
                    _this5.hideDayPicker();
                }, $89cf47aed495d20f$var$HIDE_TIMEOUT);
            }
        },
        {
            key: 'handleInputClick',
            value: function handleInputClick(e) {
                this.showDayPicker();
                if (this.props.inputProps.onClick) {
                    e.persist();
                    this.props.inputProps.onClick(e);
                }
            }
        },
        {
            key: 'handleInputFocus',
            value: function handleInputFocus(e) {
                var _this6 = this;
                this.showDayPicker();
                // Set `overlayHasFocus` after a timeout so the overlay can be hidden when
                // the input is blurred
                this.inputFocusTimeout = setTimeout(function() {
                    _this6.overlayHasFocus = false;
                }, 2);
                if (this.props.inputProps.onFocus) {
                    e.persist();
                    this.props.inputProps.onFocus(e);
                }
            }
        },
        {
            key: 'handleInputBlur',
            value: function handleInputBlur(e) {
                var _this7 = this;
                this.inputBlurTimeout = setTimeout(function() {
                    if (!_this7.overlayHasFocus) _this7.hideDayPicker();
                }, 1);
                if (this.props.inputProps.onBlur) {
                    e.persist();
                    this.props.inputProps.onBlur(e);
                }
            }
        },
        {
            key: 'handleOverlayFocus',
            value: function handleOverlayFocus(e) {
                e.preventDefault();
                this.overlayHasFocus = true;
                if (!this.props.keepFocus || !this.input || typeof this.input.focus !== 'function') return;
                this.input.focus();
            }
        },
        {
            key: 'handleOverlayBlur',
            value: function handleOverlayBlur() {
                var _this8 = this;
                // We need to set a timeout otherwise IE11 will hide the overlay when
                // focusing it
                this.overlayBlurTimeout = setTimeout(function() {
                    _this8.overlayHasFocus = false;
                }, 3);
            }
        },
        {
            key: 'handleInputChange',
            value: function handleInputChange(e) {
                var _props4 = this.props, dayPickerProps = _props4.dayPickerProps, format = _props4.format, inputProps = _props4.inputProps, onDayChange = _props4.onDayChange, parseDate = _props4.parseDate;
                if (inputProps.onChange) {
                    e.persist();
                    inputProps.onChange(e);
                }
                var value = e.target.value;
                if (value.trim() === '') {
                    this.setState({
                        value: value,
                        typedValue: ''
                    });
                    if (onDayChange) onDayChange(undefined, {}, this);
                    return;
                }
                var day = parseDate(value, format, dayPickerProps.locale);
                if (!day) {
                    // Day is invalid: we save the value in the typedValue state
                    this.setState({
                        value: value,
                        typedValue: value
                    });
                    if (onDayChange) onDayChange(undefined, {}, this);
                    return;
                }
                this.updateState(day, value);
            }
        },
        {
            key: 'handleInputKeyDown',
            value: function handleInputKeyDown(e) {
                if (e.keyCode === $btFUU.TAB) this.hideDayPicker();
                else this.showDayPicker();
                if (this.props.inputProps.onKeyDown) {
                    e.persist();
                    this.props.inputProps.onKeyDown(e);
                }
            }
        },
        {
            key: 'handleInputKeyUp',
            value: function handleInputKeyUp(e) {
                if (e.keyCode === $btFUU.ESC) this.hideDayPicker();
                else this.showDayPicker();
                if (this.props.inputProps.onKeyUp) {
                    e.persist();
                    this.props.inputProps.onKeyUp(e);
                }
            }
        },
        {
            key: 'handleMonthChange',
            value: function handleMonthChange(month) {
                var _this9 = this;
                this.setState({
                    month: month
                }, function() {
                    if (_this9.props.dayPickerProps && _this9.props.dayPickerProps.onMonthChange) _this9.props.dayPickerProps.onMonthChange(month);
                });
            }
        },
        {
            key: 'handleDayClick',
            value: function handleDayClick(day, modifiers, e) {
                var _this10 = this;
                var _props5 = this.props, clickUnselectsDay = _props5.clickUnselectsDay, dayPickerProps = _props5.dayPickerProps, onDayChange = _props5.onDayChange, formatDate = _props5.formatDate, format = _props5.format;
                if (dayPickerProps.onDayClick) dayPickerProps.onDayClick(day, modifiers, e);
                // Do nothing if the day is disabled
                if (modifiers.disabled || dayPickerProps && dayPickerProps.classNames && modifiers[dayPickerProps.classNames.disabled]) return;
                // If the clicked day is already selected, remove the clicked day
                // from the selected days and empty the field value
                if (modifiers.selected && clickUnselectsDay) {
                    var selectedDays = this.state.selectedDays;
                    if (Array.isArray(selectedDays)) {
                        selectedDays = selectedDays.slice(0);
                        var selectedDayIdx = selectedDays.indexOf(day);
                        selectedDays.splice(selectedDayIdx, 1);
                    } else if (selectedDays) selectedDays = null;
                    this.setState({
                        value: '',
                        typedValue: '',
                        selectedDays: selectedDays
                    }, this.hideAfterDayClick);
                    if (onDayChange) onDayChange(undefined, modifiers, this);
                    return;
                }
                var value = formatDate(day, format, dayPickerProps.locale);
                this.setState({
                    value: value,
                    typedValue: '',
                    month: day
                }, function() {
                    if (onDayChange) onDayChange(day, modifiers, _this10);
                    _this10.hideAfterDayClick();
                });
            }
        },
        {
            key: 'renderOverlay',
            value: function renderOverlay() {
                var _this11 = this;
                var _props6 = this.props, classNames = _props6.classNames, dayPickerProps = _props6.dayPickerProps, parseDate = _props6.parseDate, formatDate = _props6.formatDate, format = _props6.format;
                var _state2 = this.state, selectedDays = _state2.selectedDays, value = _state2.value;
                var selectedDay = void 0;
                if (!selectedDays && value) {
                    var day = parseDate(value, format, dayPickerProps.locale);
                    if (day) selectedDay = day;
                } else if (selectedDays) selectedDay = selectedDays;
                var onTodayButtonClick = void 0;
                if (dayPickerProps.todayButton) // Set the current day when clicking the today button
                onTodayButtonClick = function onTodayButtonClick() {
                    return _this11.updateState(new Date(), formatDate(new Date(), format, dayPickerProps.locale), _this11.hideAfterDayClick);
                };
                var Overlay = this.props.overlayComponent;
                return $89cf47aed495d20f$var$_react2.default.createElement(Overlay, {
                    classNames: classNames,
                    month: this.state.month,
                    selectedDay: selectedDay,
                    input: this.input,
                    tabIndex: 0 // tabIndex is necessary to catch focus/blur events on Safari
                    ,
                    onFocus: this.handleOverlayFocus,
                    onBlur: this.handleOverlayBlur
                }, $89cf47aed495d20f$var$_react2.default.createElement($89cf47aed495d20f$var$_DayPicker2.default, $89cf47aed495d20f$var$_extends({
                    ref: function ref(el) {
                        return _this11.daypicker = el;
                    },
                    onTodayButtonClick: onTodayButtonClick
                }, dayPickerProps, {
                    month: this.state.month,
                    selectedDays: selectedDay,
                    onDayClick: this.handleDayClick,
                    onMonthChange: this.handleMonthChange
                })));
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this12 = this;
                var Input = this.props.component;
                var inputProps = this.props.inputProps;
                return $89cf47aed495d20f$var$_react2.default.createElement('div', {
                    className: this.props.classNames.container,
                    style: this.props.style
                }, $89cf47aed495d20f$var$_react2.default.createElement(Input, $89cf47aed495d20f$var$_extends({
                    ref: function ref(el) {
                        return _this12.input = el;
                    },
                    placeholder: this.props.placeholder
                }, inputProps, {
                    value: this.state.value || this.state.typedValue,
                    onChange: this.handleInputChange,
                    onFocus: this.handleInputFocus,
                    onBlur: this.handleInputBlur,
                    onKeyDown: this.handleInputKeyDown,
                    onKeyUp: this.handleInputKeyUp,
                    onClick: !inputProps.disabled ? this.handleInputClick : undefined
                })), this.state.showOverlay && this.renderOverlay());
            }
        }
    ]);
    return DayPickerInput;
}($89cf47aed495d20f$var$_react2.default.Component);
$89cf47aed495d20f$var$DayPickerInput.propTypes = {
    value: $89cf47aed495d20f$var$_propTypes2.default.oneOfType([
        $89cf47aed495d20f$var$_propTypes2.default.string,
        $89cf47aed495d20f$var$_propTypes2.default.instanceOf(Date)
    ]),
    inputProps: $89cf47aed495d20f$var$_propTypes2.default.object,
    placeholder: $89cf47aed495d20f$var$_propTypes2.default.string,
    format: $89cf47aed495d20f$var$_propTypes2.default.oneOfType([
        $89cf47aed495d20f$var$_propTypes2.default.string,
        $89cf47aed495d20f$var$_propTypes2.default.arrayOf($89cf47aed495d20f$var$_propTypes2.default.string)
    ]),
    formatDate: $89cf47aed495d20f$var$_propTypes2.default.func,
    parseDate: $89cf47aed495d20f$var$_propTypes2.default.func,
    typedValue: $89cf47aed495d20f$var$_propTypes2.default.string,
    showOverlay: $89cf47aed495d20f$var$_propTypes2.default.bool,
    dayPickerProps: $89cf47aed495d20f$var$_propTypes2.default.object,
    hideOnDayClick: $89cf47aed495d20f$var$_propTypes2.default.bool,
    clickUnselectsDay: $89cf47aed495d20f$var$_propTypes2.default.bool,
    keepFocus: $89cf47aed495d20f$var$_propTypes2.default.bool,
    component: $89cf47aed495d20f$var$_propTypes2.default.any,
    overlayComponent: $89cf47aed495d20f$var$_propTypes2.default.any,
    style: $89cf47aed495d20f$var$_propTypes2.default.object,
    classNames: $89cf47aed495d20f$var$_propTypes2.default.shape({
        container: $89cf47aed495d20f$var$_propTypes2.default.string,
        overlayWrapper: $89cf47aed495d20f$var$_propTypes2.default.string,
        overlay: $89cf47aed495d20f$var$_propTypes2.default.string.isRequired
    }),
    onDayChange: $89cf47aed495d20f$var$_propTypes2.default.func,
    onDayPickerHide: $89cf47aed495d20f$var$_propTypes2.default.func,
    onDayPickerShow: $89cf47aed495d20f$var$_propTypes2.default.func,
    onChange: $89cf47aed495d20f$var$_propTypes2.default.func,
    onClick: $89cf47aed495d20f$var$_propTypes2.default.func,
    onFocus: $89cf47aed495d20f$var$_propTypes2.default.func,
    onBlur: $89cf47aed495d20f$var$_propTypes2.default.func,
    onKeyUp: $89cf47aed495d20f$var$_propTypes2.default.func
};
$89cf47aed495d20f$var$DayPickerInput.defaultProps = {
    dayPickerProps: {},
    value: '',
    typedValue: '',
    placeholder: 'YYYY-M-D',
    format: 'L',
    formatDate: $89cf47aed495d20f$var$defaultFormat,
    parseDate: $89cf47aed495d20f$var$defaultParse,
    showOverlay: false,
    hideOnDayClick: true,
    clickUnselectsDay: false,
    keepFocus: true,
    component: 'input',
    inputProps: {},
    overlayComponent: $89cf47aed495d20f$var$OverlayComponent,
    classNames: {
        container: 'DayPickerInput',
        overlayWrapper: 'DayPickerInput-OverlayWrapper',
        overlay: 'DayPickerInput-Overlay'
    }
};
module.exports.default = $89cf47aed495d20f$var$DayPickerInput;

});
parcelRegister("3yJBl", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2977eb88fa516bcd$var$ReactIs, $2977eb88fa516bcd$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("ebCRU"))();

});

parcelRegister("eDkDO", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModifiersUtils = module.exports.LocaleUtils = module.exports.DateUtils = module.exports.DayPicker = undefined;
var $aa74b8181d7eb80c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $aa74b8181d7eb80c$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $a5EUy = parcelRequire("a5EUy");
var $aa74b8181d7eb80c$var$_react2 = $aa74b8181d7eb80c$var$_interopRequireDefault($a5EUy);

var $3yJBl = parcelRequire("3yJBl");
var $aa74b8181d7eb80c$var$_propTypes2 = $aa74b8181d7eb80c$var$_interopRequireDefault($3yJBl);

var $k4kU5 = parcelRequire("k4kU5");
var $aa74b8181d7eb80c$var$_Caption2 = $aa74b8181d7eb80c$var$_interopRequireDefault($k4kU5);

var $7BIxT = parcelRequire("7BIxT");
var $aa74b8181d7eb80c$var$_Navbar2 = $aa74b8181d7eb80c$var$_interopRequireDefault($7BIxT);

var $ifH4s = parcelRequire("ifH4s");
var $aa74b8181d7eb80c$var$_Month2 = $aa74b8181d7eb80c$var$_interopRequireDefault($ifH4s);

var $fu2qw = parcelRequire("fu2qw");
var $aa74b8181d7eb80c$var$_Weekday2 = $aa74b8181d7eb80c$var$_interopRequireDefault($fu2qw);

var $hbaX6 = parcelRequire("hbaX6");
var $aa74b8181d7eb80c$var$Helpers = $aa74b8181d7eb80c$var$_interopRequireWildcard($hbaX6);

var $3y50U = parcelRequire("3y50U");
var $aa74b8181d7eb80c$var$DateUtils = $aa74b8181d7eb80c$var$_interopRequireWildcard($3y50U);

var $9FVG1 = parcelRequire("9FVG1");
var $aa74b8181d7eb80c$var$LocaleUtils = $aa74b8181d7eb80c$var$_interopRequireWildcard($9FVG1);

var $1wsvb = parcelRequire("1wsvb");
var $aa74b8181d7eb80c$var$ModifiersUtils = $aa74b8181d7eb80c$var$_interopRequireWildcard($1wsvb);

var $2vFPn = parcelRequire("2vFPn");
var $aa74b8181d7eb80c$var$_classNames2 = $aa74b8181d7eb80c$var$_interopRequireDefault($2vFPn);

var $btFUU = parcelRequire("btFUU");
function $aa74b8181d7eb80c$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $aa74b8181d7eb80c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aa74b8181d7eb80c$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $aa74b8181d7eb80c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $aa74b8181d7eb80c$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $aa74b8181d7eb80c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $aa74b8181d7eb80c$var$DayPicker = module.exports.DayPicker = function(_Component) {
    $aa74b8181d7eb80c$var$_inherits(DayPicker, _Component);
    function DayPicker(props) {
        $aa74b8181d7eb80c$var$_classCallCheck(this, DayPicker);
        var _this = $aa74b8181d7eb80c$var$_possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));
        _this.dayPicker = null;
        _this.showNextMonth = function(callback) {
            if (!_this.allowNextMonth()) return;
            var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
            var nextMonth = $aa74b8181d7eb80c$var$DateUtils.addMonths(_this.state.currentMonth, deltaMonths);
            _this.showMonth(nextMonth, callback);
        };
        _this.showPreviousMonth = function(callback) {
            if (!_this.allowPreviousMonth()) return;
            var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
            var previousMonth = $aa74b8181d7eb80c$var$DateUtils.addMonths(_this.state.currentMonth, -deltaMonths);
            _this.showMonth(previousMonth, callback);
        };
        _this.handleKeyDown = function(e) {
            e.persist();
            switch(e.keyCode){
                case $btFUU.LEFT:
                    if (_this.props.dir === 'rtl') _this.showNextMonth();
                    else _this.showPreviousMonth();
                    $aa74b8181d7eb80c$var$Helpers.cancelEvent(e);
                    break;
                case $btFUU.RIGHT:
                    if (_this.props.dir === 'rtl') _this.showPreviousMonth();
                    else _this.showNextMonth();
                    $aa74b8181d7eb80c$var$Helpers.cancelEvent(e);
                    break;
                case $btFUU.UP:
                    _this.showPreviousYear();
                    $aa74b8181d7eb80c$var$Helpers.cancelEvent(e);
                    break;
                case $btFUU.DOWN:
                    _this.showNextYear();
                    $aa74b8181d7eb80c$var$Helpers.cancelEvent(e);
                    break;
                default:
                    break;
            }
            if (_this.props.onKeyDown) _this.props.onKeyDown(e);
        };
        _this.handleDayKeyDown = function(day, modifiers, e) {
            e.persist();
            switch(e.keyCode){
                case $btFUU.LEFT:
                    $aa74b8181d7eb80c$var$Helpers.cancelEvent(e);
                    if (_this.props.dir === 'rtl') _this.focusNextDay(e.target);
                    else _this.focusPreviousDay(e.target);
                    break;
                case $btFUU.RIGHT:
                    $aa74b8181d7eb80c$var$Helpers.cancelEvent(e);
                    if (_this.props.dir === 'rtl') _this.focusPreviousDay(e.target);
                    else _this.focusNextDay(e.target);
                    break;
                case $btFUU.UP:
                    $aa74b8181d7eb80c$var$Helpers.cancelEvent(e);
                    _this.focusPreviousWeek(e.target);
                    break;
                case $btFUU.DOWN:
                    $aa74b8181d7eb80c$var$Helpers.cancelEvent(e);
                    _this.focusNextWeek(e.target);
                    break;
                case $btFUU.ENTER:
                case $btFUU.SPACE:
                    $aa74b8181d7eb80c$var$Helpers.cancelEvent(e);
                    if (_this.props.onDayClick) _this.handleDayClick(day, modifiers, e);
                    break;
                default:
                    break;
            }
            if (_this.props.onDayKeyDown) _this.props.onDayKeyDown(day, modifiers, e);
        };
        _this.handleDayClick = function(day, modifiers, e) {
            e.persist();
            if (modifiers[_this.props.classNames.outside] && _this.props.enableOutsideDaysClick) _this.handleOutsideDayClick(day);
            if (_this.props.onDayClick) _this.props.onDayClick(day, modifiers, e);
        };
        _this.handleTodayButtonClick = function(e) {
            var today = new Date();
            var month = new Date(today.getFullYear(), today.getMonth());
            _this.showMonth(month);
            e.target.blur();
            if (_this.props.onTodayButtonClick) {
                e.persist();
                _this.props.onTodayButtonClick(new Date(today.getFullYear(), today.getMonth(), today.getDate()), $aa74b8181d7eb80c$var$ModifiersUtils.getModifiersForDay(today, _this.props.modifiers), e);
            }
        };
        var currentMonth = _this.getCurrentMonthFromProps(props);
        _this.state = {
            currentMonth: currentMonth
        };
        return _this;
    }
    $aa74b8181d7eb80c$var$_createClass(DayPicker, [
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                // Changing the `month` props means changing the current displayed month
                if (prevProps.month !== this.props.month && !$aa74b8181d7eb80c$var$DateUtils.isSameMonth(prevProps.month, this.props.month)) {
                    var currentMonth = this.getCurrentMonthFromProps(this.props);
                    // eslint-disable-next-line react/no-did-update-set-state
                    this.setState({
                        currentMonth: currentMonth
                    });
                }
            }
        },
        {
            key: 'getCurrentMonthFromProps',
            /**
     * Return the month to be shown in the calendar based on the component props.
     *
     * @param {Object} props
     * @returns Date
     * @memberof DayPicker
     * @private
     */ value: function getCurrentMonthFromProps(props) {
                var initialMonth = $aa74b8181d7eb80c$var$Helpers.startOfMonth(props.month || props.initialMonth || new Date());
                var currentMonth = initialMonth;
                if (props.pagedNavigation && props.numberOfMonths > 1 && props.fromMonth) {
                    var fromMonth = $aa74b8181d7eb80c$var$Helpers.startOfMonth(props.fromMonth);
                    var diffInMonths = $aa74b8181d7eb80c$var$Helpers.getMonthsDiff(fromMonth, currentMonth);
                    currentMonth = $aa74b8181d7eb80c$var$DateUtils.addMonths(fromMonth, Math.floor(diffInMonths / props.numberOfMonths) * props.numberOfMonths);
                } else if (props.toMonth && props.numberOfMonths > 1 && $aa74b8181d7eb80c$var$Helpers.getMonthsDiff(currentMonth, props.toMonth) <= 0) currentMonth = $aa74b8181d7eb80c$var$DateUtils.addMonths($aa74b8181d7eb80c$var$Helpers.startOfMonth(props.toMonth), 1 - this.props.numberOfMonths);
                return currentMonth;
            }
        },
        {
            key: 'getNextNavigableMonth',
            value: function getNextNavigableMonth() {
                return $aa74b8181d7eb80c$var$DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
            }
        },
        {
            key: 'getPreviousNavigableMonth',
            value: function getPreviousNavigableMonth() {
                return $aa74b8181d7eb80c$var$DateUtils.addMonths(this.state.currentMonth, -1);
            }
        },
        {
            key: 'allowPreviousMonth',
            value: function allowPreviousMonth() {
                var previousMonth = $aa74b8181d7eb80c$var$DateUtils.addMonths(this.state.currentMonth, -1);
                return this.allowMonth(previousMonth);
            }
        },
        {
            key: 'allowNextMonth',
            value: function allowNextMonth() {
                var nextMonth = $aa74b8181d7eb80c$var$DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
                return this.allowMonth(nextMonth);
            }
        },
        {
            key: 'allowMonth',
            value: function allowMonth(d) {
                var _props = this.props, fromMonth = _props.fromMonth, toMonth = _props.toMonth, canChangeMonth = _props.canChangeMonth;
                if (!canChangeMonth || fromMonth && $aa74b8181d7eb80c$var$Helpers.getMonthsDiff(fromMonth, d) < 0 || toMonth && $aa74b8181d7eb80c$var$Helpers.getMonthsDiff(toMonth, d) > 0) return false;
                return true;
            }
        },
        {
            key: 'allowYearChange',
            value: function allowYearChange() {
                return this.props.canChangeMonth;
            }
        },
        {
            key: 'showMonth',
            value: function showMonth(d, callback) {
                var _this2 = this;
                if (!this.allowMonth(d)) return;
                this.setState({
                    currentMonth: $aa74b8181d7eb80c$var$Helpers.startOfMonth(d)
                }, function() {
                    if (callback) callback();
                    if (_this2.props.onMonthChange) _this2.props.onMonthChange(_this2.state.currentMonth);
                });
            }
        },
        {
            key: 'showNextYear',
            value: function showNextYear() {
                if (!this.allowYearChange()) return;
                var nextMonth = $aa74b8181d7eb80c$var$DateUtils.addMonths(this.state.currentMonth, 12);
                this.showMonth(nextMonth);
            }
        },
        {
            key: 'showPreviousYear',
            value: function showPreviousYear() {
                if (!this.allowYearChange()) return;
                var nextMonth = $aa74b8181d7eb80c$var$DateUtils.addMonths(this.state.currentMonth, -12);
                this.showMonth(nextMonth);
            }
        },
        {
            key: 'focus',
            value: function focus() {
                this.wrapper.focus();
            }
        },
        {
            key: 'focusFirstDayOfMonth',
            value: function focusFirstDayOfMonth() {
                $aa74b8181d7eb80c$var$Helpers.getDayNodes(this.dayPicker, this.props.classNames)[0].focus();
            }
        },
        {
            key: 'focusLastDayOfMonth',
            value: function focusLastDayOfMonth() {
                var dayNodes = $aa74b8181d7eb80c$var$Helpers.getDayNodes(this.dayPicker, this.props.classNames);
                dayNodes[dayNodes.length - 1].focus();
            }
        },
        {
            key: 'focusPreviousDay',
            value: function focusPreviousDay(dayNode) {
                var _this3 = this;
                var dayNodes = $aa74b8181d7eb80c$var$Helpers.getDayNodes(this.dayPicker, this.props.classNames);
                var dayNodeIndex = $aa74b8181d7eb80c$var$Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
                if (dayNodeIndex === -1) return;
                if (dayNodeIndex === 0) this.showPreviousMonth(function() {
                    return _this3.focusLastDayOfMonth();
                });
                else dayNodes[dayNodeIndex - 1].focus();
            }
        },
        {
            key: 'focusNextDay',
            value: function focusNextDay(dayNode) {
                var _this4 = this;
                var dayNodes = $aa74b8181d7eb80c$var$Helpers.getDayNodes(this.dayPicker, this.props.classNames);
                var dayNodeIndex = $aa74b8181d7eb80c$var$Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
                if (dayNodeIndex === -1) return;
                if (dayNodeIndex === dayNodes.length - 1) this.showNextMonth(function() {
                    return _this4.focusFirstDayOfMonth();
                });
                else dayNodes[dayNodeIndex + 1].focus();
            }
        },
        {
            key: 'focusNextWeek',
            value: function focusNextWeek(dayNode) {
                var _this5 = this;
                var dayNodes = $aa74b8181d7eb80c$var$Helpers.getDayNodes(this.dayPicker, this.props.classNames);
                var dayNodeIndex = $aa74b8181d7eb80c$var$Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
                var isInLastWeekOfMonth = dayNodeIndex > dayNodes.length - 8;
                if (isInLastWeekOfMonth) this.showNextMonth(function() {
                    var daysAfterIndex = dayNodes.length - dayNodeIndex;
                    var nextMonthDayNodeIndex = 7 - daysAfterIndex;
                    $aa74b8181d7eb80c$var$Helpers.getDayNodes(_this5.dayPicker, _this5.props.classNames)[nextMonthDayNodeIndex].focus();
                });
                else dayNodes[dayNodeIndex + 7].focus();
            }
        },
        {
            key: 'focusPreviousWeek',
            value: function focusPreviousWeek(dayNode) {
                var _this6 = this;
                var dayNodes = $aa74b8181d7eb80c$var$Helpers.getDayNodes(this.dayPicker, this.props.classNames);
                var dayNodeIndex = $aa74b8181d7eb80c$var$Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
                var isInFirstWeekOfMonth = dayNodeIndex <= 6;
                if (isInFirstWeekOfMonth) this.showPreviousMonth(function() {
                    var previousMonthDayNodes = $aa74b8181d7eb80c$var$Helpers.getDayNodes(_this6.dayPicker, _this6.props.classNames);
                    var startOfLastWeekOfMonth = previousMonthDayNodes.length - 7;
                    var previousMonthDayNodeIndex = startOfLastWeekOfMonth + dayNodeIndex;
                    previousMonthDayNodes[previousMonthDayNodeIndex].focus();
                });
                else dayNodes[dayNodeIndex - 7].focus();
            }
        },
        {
            key: 'handleOutsideDayClick',
            value: function handleOutsideDayClick(day) {
                var currentMonth = this.state.currentMonth;
                var numberOfMonths = this.props.numberOfMonths;
                var diffInMonths = $aa74b8181d7eb80c$var$Helpers.getMonthsDiff(currentMonth, day);
                if (diffInMonths > 0 && diffInMonths >= numberOfMonths) this.showNextMonth();
                else if (diffInMonths < 0) this.showPreviousMonth();
            }
        },
        {
            key: 'renderNavbar',
            value: function renderNavbar() {
                var _props2 = this.props, labels = _props2.labels, locale = _props2.locale, localeUtils = _props2.localeUtils, canChangeMonth = _props2.canChangeMonth, navbarElement = _props2.navbarElement, attributes = $aa74b8181d7eb80c$var$_objectWithoutProperties(_props2, [
                    'labels',
                    'locale',
                    'localeUtils',
                    'canChangeMonth',
                    'navbarElement'
                ]);
                if (!canChangeMonth) return null;
                var props = {
                    month: this.state.currentMonth,
                    classNames: this.props.classNames,
                    className: this.props.classNames.navBar,
                    nextMonth: this.getNextNavigableMonth(),
                    previousMonth: this.getPreviousNavigableMonth(),
                    showPreviousButton: this.allowPreviousMonth(),
                    showNextButton: this.allowNextMonth(),
                    onNextClick: this.showNextMonth,
                    onPreviousClick: this.showPreviousMonth,
                    dir: attributes.dir,
                    labels: labels,
                    locale: locale,
                    localeUtils: localeUtils
                };
                return $aa74b8181d7eb80c$var$_react2.default.isValidElement(navbarElement) ? $aa74b8181d7eb80c$var$_react2.default.cloneElement(navbarElement, props) : $aa74b8181d7eb80c$var$_react2.default.createElement(navbarElement, props);
            }
        },
        {
            key: 'renderMonths',
            value: function renderMonths() {
                var months = [];
                var firstDayOfWeek = $aa74b8181d7eb80c$var$Helpers.getFirstDayOfWeekFromProps(this.props);
                for(var i = 0; i < this.props.numberOfMonths; i += 1){
                    var month = $aa74b8181d7eb80c$var$DateUtils.addMonths(this.state.currentMonth, i);
                    months.push($aa74b8181d7eb80c$var$_react2.default.createElement($aa74b8181d7eb80c$var$_Month2.default, $aa74b8181d7eb80c$var$_extends({
                        key: i
                    }, this.props, {
                        month: month,
                        firstDayOfWeek: firstDayOfWeek,
                        onDayKeyDown: this.handleDayKeyDown,
                        onDayClick: this.handleDayClick
                    })));
                }
                if (this.props.reverseMonths) months.reverse();
                return months;
            }
        },
        {
            key: 'renderFooter',
            value: function renderFooter() {
                if (this.props.todayButton) return $aa74b8181d7eb80c$var$_react2.default.createElement('div', {
                    className: this.props.classNames.footer
                }, this.renderTodayButton());
                return null;
            }
        },
        {
            key: 'renderTodayButton',
            value: function renderTodayButton() {
                return $aa74b8181d7eb80c$var$_react2.default.createElement('button', {
                    type: 'button',
                    tabIndex: 0,
                    className: this.props.classNames.todayButton,
                    'aria-label': this.props.todayButton,
                    onClick: this.handleTodayButtonClick
                }, this.props.todayButton);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this7 = this;
                var className = this.props.classNames.container;
                if (!this.props.onDayClick) className = className + ' ' + this.props.classNames.interactionDisabled;
                if (this.props.className) className = className + ' ' + this.props.className;
                return $aa74b8181d7eb80c$var$_react2.default.createElement('div', $aa74b8181d7eb80c$var$_extends({}, this.props.containerProps, {
                    className: className,
                    ref: function ref(el) {
                        return _this7.dayPicker = el;
                    },
                    lang: this.props.locale
                }), $aa74b8181d7eb80c$var$_react2.default.createElement('div', {
                    className: this.props.classNames.wrapper,
                    ref: function ref(el) {
                        return _this7.wrapper = el;
                    },
                    tabIndex: this.props.canChangeMonth && typeof this.props.tabIndex !== 'undefined' ? this.props.tabIndex : -1,
                    onKeyDown: this.handleKeyDown,
                    onFocus: this.props.onFocus,
                    onBlur: this.props.onBlur
                }, this.renderNavbar(), $aa74b8181d7eb80c$var$_react2.default.createElement('div', {
                    className: this.props.classNames.months
                }, this.renderMonths()), this.renderFooter()));
            }
        }
    ]);
    return DayPicker;
}($a5EUy.Component);
$aa74b8181d7eb80c$var$DayPicker.propTypes = {
    // Rendering months
    initialMonth: $aa74b8181d7eb80c$var$_propTypes2.default.instanceOf(Date),
    month: $aa74b8181d7eb80c$var$_propTypes2.default.instanceOf(Date),
    numberOfMonths: $aa74b8181d7eb80c$var$_propTypes2.default.number,
    fromMonth: $aa74b8181d7eb80c$var$_propTypes2.default.instanceOf(Date),
    toMonth: $aa74b8181d7eb80c$var$_propTypes2.default.instanceOf(Date),
    canChangeMonth: $aa74b8181d7eb80c$var$_propTypes2.default.bool,
    reverseMonths: $aa74b8181d7eb80c$var$_propTypes2.default.bool,
    pagedNavigation: $aa74b8181d7eb80c$var$_propTypes2.default.bool,
    todayButton: $aa74b8181d7eb80c$var$_propTypes2.default.string,
    showWeekNumbers: $aa74b8181d7eb80c$var$_propTypes2.default.bool,
    showWeekDays: $aa74b8181d7eb80c$var$_propTypes2.default.bool,
    // Modifiers
    selectedDays: $aa74b8181d7eb80c$var$_propTypes2.default.oneOfType([
        $aa74b8181d7eb80c$var$_propTypes2.default.object,
        $aa74b8181d7eb80c$var$_propTypes2.default.func,
        $aa74b8181d7eb80c$var$_propTypes2.default.array
    ]),
    disabledDays: $aa74b8181d7eb80c$var$_propTypes2.default.oneOfType([
        $aa74b8181d7eb80c$var$_propTypes2.default.object,
        $aa74b8181d7eb80c$var$_propTypes2.default.func,
        $aa74b8181d7eb80c$var$_propTypes2.default.array
    ]),
    modifiers: $aa74b8181d7eb80c$var$_propTypes2.default.object,
    modifiersStyles: $aa74b8181d7eb80c$var$_propTypes2.default.object,
    // Localization
    dir: $aa74b8181d7eb80c$var$_propTypes2.default.string,
    firstDayOfWeek: $aa74b8181d7eb80c$var$_propTypes2.default.oneOf([
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ]),
    labels: $aa74b8181d7eb80c$var$_propTypes2.default.shape({
        nextMonth: $aa74b8181d7eb80c$var$_propTypes2.default.string.isRequired,
        previousMonth: $aa74b8181d7eb80c$var$_propTypes2.default.string.isRequired
    }),
    locale: $aa74b8181d7eb80c$var$_propTypes2.default.string,
    localeUtils: $aa74b8181d7eb80c$var$_propTypes2.default.shape({
        formatMonthTitle: $aa74b8181d7eb80c$var$_propTypes2.default.func,
        formatWeekdayShort: $aa74b8181d7eb80c$var$_propTypes2.default.func,
        formatWeekdayLong: $aa74b8181d7eb80c$var$_propTypes2.default.func,
        getFirstDayOfWeek: $aa74b8181d7eb80c$var$_propTypes2.default.func
    }),
    months: $aa74b8181d7eb80c$var$_propTypes2.default.arrayOf($aa74b8181d7eb80c$var$_propTypes2.default.string),
    weekdaysLong: $aa74b8181d7eb80c$var$_propTypes2.default.arrayOf($aa74b8181d7eb80c$var$_propTypes2.default.string),
    weekdaysShort: $aa74b8181d7eb80c$var$_propTypes2.default.arrayOf($aa74b8181d7eb80c$var$_propTypes2.default.string),
    // Customization
    showOutsideDays: $aa74b8181d7eb80c$var$_propTypes2.default.bool,
    enableOutsideDaysClick: $aa74b8181d7eb80c$var$_propTypes2.default.bool,
    fixedWeeks: $aa74b8181d7eb80c$var$_propTypes2.default.bool,
    // CSS and HTML
    classNames: $aa74b8181d7eb80c$var$_propTypes2.default.shape({
        body: $aa74b8181d7eb80c$var$_propTypes2.default.string,
        container: $aa74b8181d7eb80c$var$_propTypes2.default.string,
        day: $aa74b8181d7eb80c$var$_propTypes2.default.string.isRequired,
        disabled: $aa74b8181d7eb80c$var$_propTypes2.default.string.isRequired,
        footer: $aa74b8181d7eb80c$var$_propTypes2.default.string,
        interactionDisabled: $aa74b8181d7eb80c$var$_propTypes2.default.string,
        months: $aa74b8181d7eb80c$var$_propTypes2.default.string,
        month: $aa74b8181d7eb80c$var$_propTypes2.default.string,
        navBar: $aa74b8181d7eb80c$var$_propTypes2.default.string,
        outside: $aa74b8181d7eb80c$var$_propTypes2.default.string.isRequired,
        selected: $aa74b8181d7eb80c$var$_propTypes2.default.string.isRequired,
        today: $aa74b8181d7eb80c$var$_propTypes2.default.string.isRequired,
        todayButton: $aa74b8181d7eb80c$var$_propTypes2.default.string,
        week: $aa74b8181d7eb80c$var$_propTypes2.default.string,
        wrapper: $aa74b8181d7eb80c$var$_propTypes2.default.string
    }),
    className: $aa74b8181d7eb80c$var$_propTypes2.default.string,
    containerProps: $aa74b8181d7eb80c$var$_propTypes2.default.object,
    tabIndex: $aa74b8181d7eb80c$var$_propTypes2.default.number,
    // Custom elements
    renderDay: $aa74b8181d7eb80c$var$_propTypes2.default.func,
    renderWeek: $aa74b8181d7eb80c$var$_propTypes2.default.func,
    weekdayElement: $aa74b8181d7eb80c$var$_propTypes2.default.oneOfType([
        $aa74b8181d7eb80c$var$_propTypes2.default.element,
        $aa74b8181d7eb80c$var$_propTypes2.default.func,
        $aa74b8181d7eb80c$var$_propTypes2.default.instanceOf($a5EUy.Component)
    ]),
    navbarElement: $aa74b8181d7eb80c$var$_propTypes2.default.oneOfType([
        $aa74b8181d7eb80c$var$_propTypes2.default.element,
        $aa74b8181d7eb80c$var$_propTypes2.default.func,
        $aa74b8181d7eb80c$var$_propTypes2.default.instanceOf($a5EUy.Component)
    ]),
    captionElement: $aa74b8181d7eb80c$var$_propTypes2.default.oneOfType([
        $aa74b8181d7eb80c$var$_propTypes2.default.element,
        $aa74b8181d7eb80c$var$_propTypes2.default.func,
        $aa74b8181d7eb80c$var$_propTypes2.default.instanceOf($a5EUy.Component)
    ]),
    // Events
    onBlur: $aa74b8181d7eb80c$var$_propTypes2.default.func,
    onFocus: $aa74b8181d7eb80c$var$_propTypes2.default.func,
    onKeyDown: $aa74b8181d7eb80c$var$_propTypes2.default.func,
    onDayClick: $aa74b8181d7eb80c$var$_propTypes2.default.func,
    onDayKeyDown: $aa74b8181d7eb80c$var$_propTypes2.default.func,
    onDayMouseEnter: $aa74b8181d7eb80c$var$_propTypes2.default.func,
    onDayMouseLeave: $aa74b8181d7eb80c$var$_propTypes2.default.func,
    onDayMouseDown: $aa74b8181d7eb80c$var$_propTypes2.default.func,
    onDayMouseUp: $aa74b8181d7eb80c$var$_propTypes2.default.func,
    onDayTouchStart: $aa74b8181d7eb80c$var$_propTypes2.default.func,
    onDayTouchEnd: $aa74b8181d7eb80c$var$_propTypes2.default.func,
    onDayFocus: $aa74b8181d7eb80c$var$_propTypes2.default.func,
    onMonthChange: $aa74b8181d7eb80c$var$_propTypes2.default.func,
    onCaptionClick: $aa74b8181d7eb80c$var$_propTypes2.default.func,
    onWeekClick: $aa74b8181d7eb80c$var$_propTypes2.default.func,
    onTodayButtonClick: $aa74b8181d7eb80c$var$_propTypes2.default.func
};
$aa74b8181d7eb80c$var$DayPicker.defaultProps = {
    classNames: $aa74b8181d7eb80c$var$_classNames2.default,
    tabIndex: 0,
    numberOfMonths: 1,
    labels: {
        previousMonth: 'Previous Month',
        nextMonth: 'Next Month'
    },
    locale: 'en',
    localeUtils: $aa74b8181d7eb80c$var$LocaleUtils,
    showOutsideDays: false,
    enableOutsideDaysClick: true,
    fixedWeeks: false,
    canChangeMonth: true,
    reverseMonths: false,
    pagedNavigation: false,
    showWeekNumbers: false,
    showWeekDays: true,
    renderDay: function renderDay(day) {
        return day.getDate();
    },
    renderWeek: function renderWeek(weekNumber) {
        return weekNumber;
    },
    weekdayElement: $aa74b8181d7eb80c$var$_react2.default.createElement($aa74b8181d7eb80c$var$_Weekday2.default, null),
    navbarElement: $aa74b8181d7eb80c$var$_react2.default.createElement($aa74b8181d7eb80c$var$_Navbar2.default, {
        classNames: $aa74b8181d7eb80c$var$_classNames2.default
    }),
    captionElement: $aa74b8181d7eb80c$var$_react2.default.createElement($aa74b8181d7eb80c$var$_Caption2.default, {
        classNames: $aa74b8181d7eb80c$var$_classNames2.default
    })
};
$aa74b8181d7eb80c$var$DayPicker.VERSION = '7.4.8';
$aa74b8181d7eb80c$var$DayPicker.DateUtils = $aa74b8181d7eb80c$var$DateUtils;
$aa74b8181d7eb80c$var$DayPicker.LocaleUtils = $aa74b8181d7eb80c$var$LocaleUtils;
$aa74b8181d7eb80c$var$DayPicker.ModifiersUtils = $aa74b8181d7eb80c$var$ModifiersUtils;
module.exports.DateUtils = $aa74b8181d7eb80c$var$DateUtils;
module.exports.LocaleUtils = $aa74b8181d7eb80c$var$LocaleUtils;
module.exports.ModifiersUtils = $aa74b8181d7eb80c$var$ModifiersUtils;
module.exports.default = $aa74b8181d7eb80c$var$DayPicker;

});
parcelRegister("k4kU5", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e9c46568ab5ac53b$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $a5EUy = parcelRequire("a5EUy");
var $e9c46568ab5ac53b$var$_react2 = $e9c46568ab5ac53b$var$_interopRequireDefault($a5EUy);

var $3yJBl = parcelRequire("3yJBl");
var $e9c46568ab5ac53b$var$_propTypes2 = $e9c46568ab5ac53b$var$_interopRequireDefault($3yJBl);

var $9FVG1 = parcelRequire("9FVG1");
var $e9c46568ab5ac53b$var$_LocaleUtils2 = $e9c46568ab5ac53b$var$_interopRequireDefault($9FVG1);

var $btFUU = parcelRequire("btFUU");
function $e9c46568ab5ac53b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e9c46568ab5ac53b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e9c46568ab5ac53b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e9c46568ab5ac53b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $e9c46568ab5ac53b$var$Caption = function(_Component) {
    $e9c46568ab5ac53b$var$_inherits(Caption, _Component);
    function Caption(props) {
        $e9c46568ab5ac53b$var$_classCallCheck(this, Caption);
        var _this = $e9c46568ab5ac53b$var$_possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).call(this, props));
        _this.handleKeyUp = _this.handleKeyUp.bind(_this);
        return _this;
    }
    $e9c46568ab5ac53b$var$_createClass(Caption, [
        {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate(nextProps) {
                return nextProps.locale !== this.props.locale || nextProps.classNames !== this.props.classNames || nextProps.date.getMonth() !== this.props.date.getMonth() || nextProps.date.getFullYear() !== this.props.date.getFullYear();
            }
        },
        {
            key: 'handleKeyUp',
            value: function handleKeyUp(e) {
                if (e.keyCode === $btFUU.ENTER) this.props.onClick(e);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, classNames = _props.classNames, date = _props.date, months = _props.months, locale = _props.locale, localeUtils = _props.localeUtils, onClick = _props.onClick;
                return $e9c46568ab5ac53b$var$_react2.default.createElement('div', {
                    className: classNames.caption,
                    role: 'heading'
                }, $e9c46568ab5ac53b$var$_react2.default.createElement('div', {
                    onClick: onClick,
                    onKeyUp: this.handleKeyUp
                }, months ? months[date.getMonth()] + ' ' + date.getFullYear() : localeUtils.formatMonthTitle(date, locale)));
            }
        }
    ]);
    return Caption;
}($a5EUy.Component);
$e9c46568ab5ac53b$var$Caption.propTypes = {
    date: $e9c46568ab5ac53b$var$_propTypes2.default.instanceOf(Date),
    months: $e9c46568ab5ac53b$var$_propTypes2.default.arrayOf($e9c46568ab5ac53b$var$_propTypes2.default.string),
    locale: $e9c46568ab5ac53b$var$_propTypes2.default.string,
    localeUtils: $e9c46568ab5ac53b$var$_propTypes2.default.object,
    onClick: $e9c46568ab5ac53b$var$_propTypes2.default.func,
    classNames: $e9c46568ab5ac53b$var$_propTypes2.default.shape({
        caption: $e9c46568ab5ac53b$var$_propTypes2.default.string.isRequired
    }).isRequired
};
$e9c46568ab5ac53b$var$Caption.defaultProps = {
    localeUtils: $e9c46568ab5ac53b$var$_LocaleUtils2.default
};
module.exports.default = $e9c46568ab5ac53b$var$Caption;

});
parcelRegister("9FVG1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatDay = $70b4aece8c9a0cd7$var$formatDay;
module.exports.formatMonthTitle = $70b4aece8c9a0cd7$var$formatMonthTitle;
module.exports.formatWeekdayShort = $70b4aece8c9a0cd7$var$formatWeekdayShort;
module.exports.formatWeekdayLong = $70b4aece8c9a0cd7$var$formatWeekdayLong;
module.exports.getFirstDayOfWeek = $70b4aece8c9a0cd7$var$getFirstDayOfWeek;
module.exports.getMonths = $70b4aece8c9a0cd7$var$getMonths;
var $70b4aece8c9a0cd7$var$WEEKDAYS_LONG = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
];
var $70b4aece8c9a0cd7$var$WEEKDAYS_SHORT = [
    'Su',
    'Mo',
    'Tu',
    'We',
    'Th',
    'Fr',
    'Sa'
];
var $70b4aece8c9a0cd7$var$MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
function $70b4aece8c9a0cd7$var$formatDay(day) {
    return day.toDateString();
}
function $70b4aece8c9a0cd7$var$formatMonthTitle(d) {
    return $70b4aece8c9a0cd7$var$MONTHS[d.getMonth()] + ' ' + d.getFullYear();
}
function $70b4aece8c9a0cd7$var$formatWeekdayShort(i) {
    return $70b4aece8c9a0cd7$var$WEEKDAYS_SHORT[i];
}
function $70b4aece8c9a0cd7$var$formatWeekdayLong(i) {
    return $70b4aece8c9a0cd7$var$WEEKDAYS_LONG[i];
}
function $70b4aece8c9a0cd7$var$getFirstDayOfWeek() {
    return 0;
}
function $70b4aece8c9a0cd7$var$getMonths() {
    return $70b4aece8c9a0cd7$var$MONTHS;
}
module.exports.default = {
    formatDay: $70b4aece8c9a0cd7$var$formatDay,
    formatMonthTitle: $70b4aece8c9a0cd7$var$formatMonthTitle,
    formatWeekdayShort: $70b4aece8c9a0cd7$var$formatWeekdayShort,
    formatWeekdayLong: $70b4aece8c9a0cd7$var$formatWeekdayLong,
    getFirstDayOfWeek: $70b4aece8c9a0cd7$var$getFirstDayOfWeek,
    getMonths: $70b4aece8c9a0cd7$var$getMonths
};

});

parcelRegister("btFUU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $85b2eaf8aa28c8f0$var$LEFT = module.exports.LEFT = 37;
var $85b2eaf8aa28c8f0$var$UP = module.exports.UP = 38;
var $85b2eaf8aa28c8f0$var$RIGHT = module.exports.RIGHT = 39;
var $85b2eaf8aa28c8f0$var$DOWN = module.exports.DOWN = 40;
var $85b2eaf8aa28c8f0$var$ENTER = module.exports.ENTER = 13;
var $85b2eaf8aa28c8f0$var$SPACE = module.exports.SPACE = 32;
var $85b2eaf8aa28c8f0$var$ESC = module.exports.ESC = 27;
var $85b2eaf8aa28c8f0$var$TAB = module.exports.TAB = 9;

});


parcelRegister("7BIxT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $589e8af25d1a6a58$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $a5EUy = parcelRequire("a5EUy");
var $589e8af25d1a6a58$var$_react2 = $589e8af25d1a6a58$var$_interopRequireDefault($a5EUy);

var $3yJBl = parcelRequire("3yJBl");
var $589e8af25d1a6a58$var$_propTypes2 = $589e8af25d1a6a58$var$_interopRequireDefault($3yJBl);

var $2vFPn = parcelRequire("2vFPn");
var $589e8af25d1a6a58$var$_classNames2 = $589e8af25d1a6a58$var$_interopRequireDefault($2vFPn);

var $btFUU = parcelRequire("btFUU");
function $589e8af25d1a6a58$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $589e8af25d1a6a58$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $589e8af25d1a6a58$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $589e8af25d1a6a58$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $589e8af25d1a6a58$var$Navbar = function(_Component) {
    $589e8af25d1a6a58$var$_inherits(Navbar, _Component);
    function Navbar() {
        var _ref;
        var _temp, _this, _ret;
        $589e8af25d1a6a58$var$_classCallCheck(this, Navbar);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $589e8af25d1a6a58$var$_possibleConstructorReturn(this, (_ref = Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.handleNextClick = function() {
            if (_this.props.onNextClick) _this.props.onNextClick();
        }, _this.handlePreviousClick = function() {
            if (_this.props.onPreviousClick) _this.props.onPreviousClick();
        }, _this.handleNextKeyDown = function(e) {
            if (e.keyCode !== $btFUU.ENTER && e.keyCode !== $btFUU.SPACE) return;
            e.preventDefault();
            _this.handleNextClick();
        }, _this.handlePreviousKeyDown = function(e) {
            if (e.keyCode !== $btFUU.ENTER && e.keyCode !== $btFUU.SPACE) return;
            e.preventDefault();
            _this.handlePreviousClick();
        }, _temp), $589e8af25d1a6a58$var$_possibleConstructorReturn(_this, _ret);
    }
    $589e8af25d1a6a58$var$_createClass(Navbar, [
        {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate(nextProps) {
                return nextProps.labels !== this.props.labels || nextProps.dir !== this.props.dir || this.props.showPreviousButton !== nextProps.showPreviousButton || this.props.showNextButton !== nextProps.showNextButton;
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, classNames = _props.classNames, className = _props.className, showPreviousButton = _props.showPreviousButton, showNextButton = _props.showNextButton, labels = _props.labels, dir = _props.dir;
                var previousClickHandler = void 0;
                var nextClickHandler = void 0;
                var previousKeyDownHandler = void 0;
                var nextKeyDownHandler = void 0;
                var shouldShowPrevious = void 0;
                var shouldShowNext = void 0;
                if (dir === 'rtl') {
                    previousClickHandler = this.handleNextClick;
                    nextClickHandler = this.handlePreviousClick;
                    previousKeyDownHandler = this.handleNextKeyDown;
                    nextKeyDownHandler = this.handlePreviousKeyDown;
                    shouldShowNext = showPreviousButton;
                    shouldShowPrevious = showNextButton;
                } else {
                    previousClickHandler = this.handlePreviousClick;
                    nextClickHandler = this.handleNextClick;
                    previousKeyDownHandler = this.handlePreviousKeyDown;
                    nextKeyDownHandler = this.handleNextKeyDown;
                    shouldShowNext = showNextButton;
                    shouldShowPrevious = showPreviousButton;
                }
                var previousClassName = shouldShowPrevious ? classNames.navButtonPrev : classNames.navButtonPrev + ' ' + classNames.navButtonInteractionDisabled;
                var nextClassName = shouldShowNext ? classNames.navButtonNext : classNames.navButtonNext + ' ' + classNames.navButtonInteractionDisabled;
                var previousButton = $589e8af25d1a6a58$var$_react2.default.createElement('span', {
                    tabIndex: '0',
                    role: 'button',
                    'aria-label': labels.previousMonth,
                    key: 'previous',
                    className: previousClassName,
                    onKeyDown: shouldShowPrevious ? previousKeyDownHandler : undefined,
                    onClick: shouldShowPrevious ? previousClickHandler : undefined
                });
                var nextButton = $589e8af25d1a6a58$var$_react2.default.createElement('span', {
                    tabIndex: '0',
                    role: 'button',
                    'aria-label': labels.nextMonth,
                    key: 'right',
                    className: nextClassName,
                    onKeyDown: shouldShowNext ? nextKeyDownHandler : undefined,
                    onClick: shouldShowNext ? nextClickHandler : undefined
                });
                return $589e8af25d1a6a58$var$_react2.default.createElement('div', {
                    className: className || classNames.navBar
                }, dir === 'rtl' ? [
                    nextButton,
                    previousButton
                ] : [
                    previousButton,
                    nextButton
                ]);
            }
        }
    ]);
    return Navbar;
}($a5EUy.Component);
$589e8af25d1a6a58$var$Navbar.propTypes = {
    classNames: $589e8af25d1a6a58$var$_propTypes2.default.shape({
        navBar: $589e8af25d1a6a58$var$_propTypes2.default.string.isRequired,
        navButtonPrev: $589e8af25d1a6a58$var$_propTypes2.default.string.isRequired,
        navButtonNext: $589e8af25d1a6a58$var$_propTypes2.default.string.isRequired,
        navButtonInteractionDisabled: $589e8af25d1a6a58$var$_propTypes2.default.string.isRequired
    }),
    className: $589e8af25d1a6a58$var$_propTypes2.default.string,
    showPreviousButton: $589e8af25d1a6a58$var$_propTypes2.default.bool,
    showNextButton: $589e8af25d1a6a58$var$_propTypes2.default.bool,
    onPreviousClick: $589e8af25d1a6a58$var$_propTypes2.default.func,
    onNextClick: $589e8af25d1a6a58$var$_propTypes2.default.func,
    dir: $589e8af25d1a6a58$var$_propTypes2.default.string,
    labels: $589e8af25d1a6a58$var$_propTypes2.default.shape({
        previousMonth: $589e8af25d1a6a58$var$_propTypes2.default.string.isRequired,
        nextMonth: $589e8af25d1a6a58$var$_propTypes2.default.string.isRequired
    })
};
$589e8af25d1a6a58$var$Navbar.defaultProps = {
    classNames: $589e8af25d1a6a58$var$_classNames2.default,
    dir: 'ltr',
    labels: {
        previousMonth: 'Previous Month',
        nextMonth: 'Next Month'
    },
    showPreviousButton: true,
    showNextButton: true
};
module.exports.default = $589e8af25d1a6a58$var$Navbar;

});
parcelRegister("2vFPn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// Proxy object to map classnames when css modules are not used
module.exports.default = {
    container: 'DayPicker',
    wrapper: 'DayPicker-wrapper',
    interactionDisabled: 'DayPicker--interactionDisabled',
    months: 'DayPicker-Months',
    month: 'DayPicker-Month',
    navBar: 'DayPicker-NavBar',
    navButtonPrev: 'DayPicker-NavButton DayPicker-NavButton--prev',
    navButtonNext: 'DayPicker-NavButton DayPicker-NavButton--next',
    navButtonInteractionDisabled: 'DayPicker-NavButton--interactionDisabled',
    caption: 'DayPicker-Caption',
    weekdays: 'DayPicker-Weekdays',
    weekdaysRow: 'DayPicker-WeekdaysRow',
    weekday: 'DayPicker-Weekday',
    body: 'DayPicker-Body',
    week: 'DayPicker-Week',
    weekNumber: 'DayPicker-WeekNumber',
    day: 'DayPicker-Day',
    footer: 'DayPicker-Footer',
    todayButton: 'DayPicker-TodayButton',
    // default modifiers
    today: 'today',
    selected: 'selected',
    disabled: 'disabled',
    outside: 'outside'
};

});


parcelRegister("ifH4s", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d49b09ab406c78ed$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $a5EUy = parcelRequire("a5EUy");
var $d49b09ab406c78ed$var$_react2 = $d49b09ab406c78ed$var$_interopRequireDefault($a5EUy);

var $3yJBl = parcelRequire("3yJBl");
var $d49b09ab406c78ed$var$_propTypes2 = $d49b09ab406c78ed$var$_interopRequireDefault($3yJBl);

var $esmtz = parcelRequire("esmtz");
var $d49b09ab406c78ed$var$_Weekdays2 = $d49b09ab406c78ed$var$_interopRequireDefault($esmtz);

var $euByX = parcelRequire("euByX");
var $d49b09ab406c78ed$var$_Day2 = $d49b09ab406c78ed$var$_interopRequireDefault($euByX);

var $btFUU = parcelRequire("btFUU");

var $1wsvb = parcelRequire("1wsvb");
var $d49b09ab406c78ed$var$ModifiersUtils = $d49b09ab406c78ed$var$_interopRequireWildcard($1wsvb);

var $hbaX6 = parcelRequire("hbaX6");
var $d49b09ab406c78ed$var$Helpers = $d49b09ab406c78ed$var$_interopRequireWildcard($hbaX6);

var $3y50U = parcelRequire("3y50U");
var $d49b09ab406c78ed$var$DateUtils = $d49b09ab406c78ed$var$_interopRequireWildcard($3y50U);
function $d49b09ab406c78ed$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $d49b09ab406c78ed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d49b09ab406c78ed$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d49b09ab406c78ed$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d49b09ab406c78ed$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $d49b09ab406c78ed$var$Month = function(_Component) {
    $d49b09ab406c78ed$var$_inherits(Month, _Component);
    function Month() {
        var _ref;
        var _temp, _this, _ret;
        $d49b09ab406c78ed$var$_classCallCheck(this, Month);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $d49b09ab406c78ed$var$_possibleConstructorReturn(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.renderDay = function(day) {
            var monthNumber = _this.props.month.getMonth();
            var propModifiers = $d49b09ab406c78ed$var$Helpers.getModifiersFromProps(_this.props);
            var dayModifiers = $d49b09ab406c78ed$var$ModifiersUtils.getModifiersForDay(day, propModifiers);
            if ($d49b09ab406c78ed$var$DateUtils.isSameDay(day, new Date()) && !Object.prototype.hasOwnProperty.call(propModifiers, _this.props.classNames.today)) dayModifiers.push(_this.props.classNames.today);
            if (day.getMonth() !== monthNumber) dayModifiers.push(_this.props.classNames.outside);
            var isOutside = day.getMonth() !== monthNumber;
            var tabIndex = -1;
            // Focus on the first day of the month
            if (_this.props.onDayClick && !isOutside && day.getDate() === 1) tabIndex = _this.props.tabIndex; // eslint-disable-line prefer-destructuring
            var key = '' + day.getFullYear() + day.getMonth() + day.getDate();
            var modifiers = {};
            dayModifiers.forEach(function(modifier) {
                modifiers[modifier] = true;
            });
            return $d49b09ab406c78ed$var$_react2.default.createElement($d49b09ab406c78ed$var$_Day2.default, {
                key: '' + (isOutside ? 'outside-' : '') + key,
                classNames: _this.props.classNames,
                day: day,
                modifiers: modifiers,
                modifiersStyles: _this.props.modifiersStyles,
                empty: isOutside && !_this.props.showOutsideDays && !_this.props.fixedWeeks,
                tabIndex: tabIndex,
                ariaLabel: _this.props.localeUtils.formatDay(day, _this.props.locale),
                ariaDisabled: isOutside || dayModifiers.indexOf(_this.props.classNames.disabled) > -1,
                ariaSelected: dayModifiers.indexOf(_this.props.classNames.selected) > -1,
                onClick: _this.props.onDayClick,
                onFocus: _this.props.onDayFocus,
                onKeyDown: _this.props.onDayKeyDown,
                onMouseEnter: _this.props.onDayMouseEnter,
                onMouseLeave: _this.props.onDayMouseLeave,
                onMouseDown: _this.props.onDayMouseDown,
                onMouseUp: _this.props.onDayMouseUp,
                onTouchEnd: _this.props.onDayTouchEnd,
                onTouchStart: _this.props.onDayTouchStart
            }, _this.props.renderDay(day, modifiers));
        }, _temp), $d49b09ab406c78ed$var$_possibleConstructorReturn(_this, _ret);
    }
    $d49b09ab406c78ed$var$_createClass(Month, [
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _props = this.props, classNames = _props.classNames, month = _props.month, months = _props.months, fixedWeeks = _props.fixedWeeks, captionElement = _props.captionElement, weekdayElement = _props.weekdayElement, locale = _props.locale, localeUtils = _props.localeUtils, weekdaysLong = _props.weekdaysLong, weekdaysShort = _props.weekdaysShort, firstDayOfWeek = _props.firstDayOfWeek, onCaptionClick = _props.onCaptionClick, showWeekNumbers = _props.showWeekNumbers, showWeekDays = _props.showWeekDays, onWeekClick = _props.onWeekClick;
                var captionProps = {
                    date: month,
                    classNames: classNames,
                    months: months,
                    localeUtils: localeUtils,
                    locale: locale,
                    onClick: onCaptionClick ? function(e) {
                        return onCaptionClick(month, e);
                    } : undefined
                };
                var caption = $d49b09ab406c78ed$var$_react2.default.isValidElement(captionElement) ? $d49b09ab406c78ed$var$_react2.default.cloneElement(captionElement, captionProps) : $d49b09ab406c78ed$var$_react2.default.createElement(captionElement, captionProps);
                var weeks = $d49b09ab406c78ed$var$Helpers.getWeekArray(month, firstDayOfWeek, fixedWeeks);
                return $d49b09ab406c78ed$var$_react2.default.createElement('div', {
                    className: classNames.month,
                    role: 'grid'
                }, caption, showWeekDays && $d49b09ab406c78ed$var$_react2.default.createElement($d49b09ab406c78ed$var$_Weekdays2.default, {
                    classNames: classNames,
                    weekdaysShort: weekdaysShort,
                    weekdaysLong: weekdaysLong,
                    firstDayOfWeek: firstDayOfWeek,
                    showWeekNumbers: showWeekNumbers,
                    locale: locale,
                    localeUtils: localeUtils,
                    weekdayElement: weekdayElement
                }), $d49b09ab406c78ed$var$_react2.default.createElement('div', {
                    className: classNames.body,
                    role: 'rowgroup'
                }, weeks.map(function(week) {
                    var weekNumber = void 0;
                    if (showWeekNumbers) weekNumber = $d49b09ab406c78ed$var$DateUtils.getWeekNumber(week[6]);
                    return $d49b09ab406c78ed$var$_react2.default.createElement('div', {
                        key: week[0].getTime(),
                        className: classNames.week,
                        role: 'row'
                    }, showWeekNumbers && $d49b09ab406c78ed$var$_react2.default.createElement('div', {
                        className: classNames.weekNumber,
                        tabIndex: onWeekClick ? 0 : -1,
                        role: 'gridcell',
                        onClick: onWeekClick ? function(e) {
                            return onWeekClick(weekNumber, week, e);
                        } : undefined,
                        onKeyUp: onWeekClick ? function(e) {
                            return e.keyCode === $btFUU.ENTER && onWeekClick(weekNumber, week, e);
                        } : undefined
                    }, _this2.props.renderWeek(weekNumber, week, month)), week.map(_this2.renderDay));
                })));
            }
        }
    ]);
    return Month;
}($a5EUy.Component);
$d49b09ab406c78ed$var$Month.propTypes = {
    classNames: $d49b09ab406c78ed$var$_propTypes2.default.shape({
        body: $d49b09ab406c78ed$var$_propTypes2.default.string.isRequired,
        month: $d49b09ab406c78ed$var$_propTypes2.default.string.isRequired,
        outside: $d49b09ab406c78ed$var$_propTypes2.default.string.isRequired,
        today: $d49b09ab406c78ed$var$_propTypes2.default.string.isRequired,
        week: $d49b09ab406c78ed$var$_propTypes2.default.string.isRequired,
        weekNumber: $d49b09ab406c78ed$var$_propTypes2.default.string.isRequired,
        disabled: $d49b09ab406c78ed$var$_propTypes2.default.string.isRequired,
        selected: $d49b09ab406c78ed$var$_propTypes2.default.string.isRequired
    }).isRequired,
    tabIndex: $d49b09ab406c78ed$var$_propTypes2.default.number,
    month: $d49b09ab406c78ed$var$_propTypes2.default.instanceOf(Date).isRequired,
    months: $d49b09ab406c78ed$var$_propTypes2.default.arrayOf($d49b09ab406c78ed$var$_propTypes2.default.string),
    modifiersStyles: $d49b09ab406c78ed$var$_propTypes2.default.object,
    showWeekDays: $d49b09ab406c78ed$var$_propTypes2.default.bool,
    showOutsideDays: $d49b09ab406c78ed$var$_propTypes2.default.bool,
    renderDay: $d49b09ab406c78ed$var$_propTypes2.default.func.isRequired,
    renderWeek: $d49b09ab406c78ed$var$_propTypes2.default.func.isRequired,
    captionElement: $d49b09ab406c78ed$var$_propTypes2.default.oneOfType([
        $d49b09ab406c78ed$var$_propTypes2.default.element,
        $d49b09ab406c78ed$var$_propTypes2.default.func,
        $d49b09ab406c78ed$var$_propTypes2.default.instanceOf($d49b09ab406c78ed$var$_react2.default.Component)
    ]).isRequired,
    weekdayElement: $d49b09ab406c78ed$var$_propTypes2.default.oneOfType([
        $d49b09ab406c78ed$var$_propTypes2.default.element,
        $d49b09ab406c78ed$var$_propTypes2.default.func,
        $d49b09ab406c78ed$var$_propTypes2.default.instanceOf($d49b09ab406c78ed$var$_react2.default.Component)
    ]),
    fixedWeeks: $d49b09ab406c78ed$var$_propTypes2.default.bool,
    showWeekNumbers: $d49b09ab406c78ed$var$_propTypes2.default.bool,
    locale: $d49b09ab406c78ed$var$_propTypes2.default.string.isRequired,
    localeUtils: $d49b09ab406c78ed$var$_propTypes2.default.object.isRequired,
    weekdaysLong: $d49b09ab406c78ed$var$_propTypes2.default.arrayOf($d49b09ab406c78ed$var$_propTypes2.default.string),
    weekdaysShort: $d49b09ab406c78ed$var$_propTypes2.default.arrayOf($d49b09ab406c78ed$var$_propTypes2.default.string),
    firstDayOfWeek: $d49b09ab406c78ed$var$_propTypes2.default.number.isRequired,
    onCaptionClick: $d49b09ab406c78ed$var$_propTypes2.default.func,
    onDayClick: $d49b09ab406c78ed$var$_propTypes2.default.func,
    onDayFocus: $d49b09ab406c78ed$var$_propTypes2.default.func,
    onDayKeyDown: $d49b09ab406c78ed$var$_propTypes2.default.func,
    onDayMouseEnter: $d49b09ab406c78ed$var$_propTypes2.default.func,
    onDayMouseLeave: $d49b09ab406c78ed$var$_propTypes2.default.func,
    onDayMouseDown: $d49b09ab406c78ed$var$_propTypes2.default.func,
    onDayMouseUp: $d49b09ab406c78ed$var$_propTypes2.default.func,
    onDayTouchEnd: $d49b09ab406c78ed$var$_propTypes2.default.func,
    onDayTouchStart: $d49b09ab406c78ed$var$_propTypes2.default.func,
    onWeekClick: $d49b09ab406c78ed$var$_propTypes2.default.func
};
module.exports.default = $d49b09ab406c78ed$var$Month;

});
parcelRegister("esmtz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a8651d7191d8f3a7$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $a5EUy = parcelRequire("a5EUy");
var $a8651d7191d8f3a7$var$_react2 = $a8651d7191d8f3a7$var$_interopRequireDefault($a5EUy);

var $3yJBl = parcelRequire("3yJBl");
var $a8651d7191d8f3a7$var$_propTypes2 = $a8651d7191d8f3a7$var$_interopRequireDefault($3yJBl);
function $a8651d7191d8f3a7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a8651d7191d8f3a7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a8651d7191d8f3a7$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a8651d7191d8f3a7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a8651d7191d8f3a7$var$Weekdays = function(_Component) {
    $a8651d7191d8f3a7$var$_inherits(Weekdays, _Component);
    function Weekdays() {
        $a8651d7191d8f3a7$var$_classCallCheck(this, Weekdays);
        return $a8651d7191d8f3a7$var$_possibleConstructorReturn(this, (Weekdays.__proto__ || Object.getPrototypeOf(Weekdays)).apply(this, arguments));
    }
    $a8651d7191d8f3a7$var$_createClass(Weekdays, [
        {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate(nextProps) {
                return this.props !== nextProps;
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, classNames = _props.classNames, firstDayOfWeek = _props.firstDayOfWeek, showWeekNumbers = _props.showWeekNumbers, weekdaysLong = _props.weekdaysLong, weekdaysShort = _props.weekdaysShort, locale = _props.locale, localeUtils = _props.localeUtils, weekdayElement = _props.weekdayElement;
                var days = [];
                for(var i = 0; i < 7; i += 1){
                    var weekday = (i + firstDayOfWeek) % 7;
                    var elementProps = {
                        key: i,
                        className: classNames.weekday,
                        weekday: weekday,
                        weekdaysLong: weekdaysLong,
                        weekdaysShort: weekdaysShort,
                        localeUtils: localeUtils,
                        locale: locale
                    };
                    var element = $a8651d7191d8f3a7$var$_react2.default.isValidElement(weekdayElement) ? $a8651d7191d8f3a7$var$_react2.default.cloneElement(weekdayElement, elementProps) : $a8651d7191d8f3a7$var$_react2.default.createElement(weekdayElement, elementProps);
                    days.push(element);
                }
                return $a8651d7191d8f3a7$var$_react2.default.createElement('div', {
                    className: classNames.weekdays,
                    role: 'rowgroup'
                }, $a8651d7191d8f3a7$var$_react2.default.createElement('div', {
                    className: classNames.weekdaysRow,
                    role: 'row'
                }, showWeekNumbers && $a8651d7191d8f3a7$var$_react2.default.createElement('div', {
                    className: classNames.weekday
                }), days));
            }
        }
    ]);
    return Weekdays;
}($a5EUy.Component);
$a8651d7191d8f3a7$var$Weekdays.propTypes = {
    classNames: $a8651d7191d8f3a7$var$_propTypes2.default.shape({
        weekday: $a8651d7191d8f3a7$var$_propTypes2.default.string.isRequired,
        weekdays: $a8651d7191d8f3a7$var$_propTypes2.default.string.isRequired,
        weekdaysRow: $a8651d7191d8f3a7$var$_propTypes2.default.string.isRequired
    }).isRequired,
    firstDayOfWeek: $a8651d7191d8f3a7$var$_propTypes2.default.number.isRequired,
    weekdaysLong: $a8651d7191d8f3a7$var$_propTypes2.default.arrayOf($a8651d7191d8f3a7$var$_propTypes2.default.string),
    weekdaysShort: $a8651d7191d8f3a7$var$_propTypes2.default.arrayOf($a8651d7191d8f3a7$var$_propTypes2.default.string),
    showWeekNumbers: $a8651d7191d8f3a7$var$_propTypes2.default.bool,
    locale: $a8651d7191d8f3a7$var$_propTypes2.default.string.isRequired,
    localeUtils: $a8651d7191d8f3a7$var$_propTypes2.default.object.isRequired,
    weekdayElement: $a8651d7191d8f3a7$var$_propTypes2.default.oneOfType([
        $a8651d7191d8f3a7$var$_propTypes2.default.element,
        $a8651d7191d8f3a7$var$_propTypes2.default.func,
        $a8651d7191d8f3a7$var$_propTypes2.default.instanceOf($a8651d7191d8f3a7$var$_react2.default.Component)
    ])
};
module.exports.default = $a8651d7191d8f3a7$var$Weekdays;

});

parcelRegister("euByX", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a8d1013be36476cb$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $a8d1013be36476cb$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $a5EUy = parcelRequire("a5EUy");
var $a8d1013be36476cb$var$_react2 = $a8d1013be36476cb$var$_interopRequireDefault($a5EUy);

var $3yJBl = parcelRequire("3yJBl");
var $a8d1013be36476cb$var$_propTypes2 = $a8d1013be36476cb$var$_interopRequireDefault($3yJBl);

var $3y50U = parcelRequire("3y50U");

var $hbaX6 = parcelRequire("hbaX6");

var $2vFPn = parcelRequire("2vFPn");
var $a8d1013be36476cb$var$_classNames2 = $a8d1013be36476cb$var$_interopRequireDefault($2vFPn);
function $a8d1013be36476cb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a8d1013be36476cb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a8d1013be36476cb$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a8d1013be36476cb$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint-disable jsx-a11y/no-static-element-interactions, react/forbid-prop-types */ 
function $a8d1013be36476cb$var$handleEvent(handler, day, modifiers) {
    if (!handler) return undefined;
    return function(e) {
        e.persist();
        handler(day, modifiers, e);
    };
}
var $a8d1013be36476cb$var$Day = function(_Component) {
    $a8d1013be36476cb$var$_inherits(Day, _Component);
    function Day() {
        $a8d1013be36476cb$var$_classCallCheck(this, Day);
        return $a8d1013be36476cb$var$_possibleConstructorReturn(this, (Day.__proto__ || Object.getPrototypeOf(Day)).apply(this, arguments));
    }
    $a8d1013be36476cb$var$_createClass(Day, [
        {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate(nextProps) {
                var _this2 = this;
                var propNames = Object.keys(this.props);
                var nextPropNames = Object.keys(nextProps);
                if (propNames.length !== nextPropNames.length) return true;
                return propNames.some(function(name) {
                    if (name === 'modifiers' || name === 'modifiersStyles' || name === 'classNames') {
                        var prop = _this2.props[name];
                        var nextProp = nextProps[name];
                        var modifiers = Object.keys(prop);
                        var nextModifiers = Object.keys(nextProp);
                        if (modifiers.length !== nextModifiers.length) return true;
                        return modifiers.some(function(mod) {
                            return !(0, $hbaX6.hasOwnProp)(nextProp, mod) || prop[mod] !== nextProp[mod];
                        });
                    }
                    if (name === 'day') return !(0, $3y50U.isSameDay)(_this2.props[name], nextProps[name]);
                    return !(0, $hbaX6.hasOwnProp)(nextProps, name) || _this2.props[name] !== nextProps[name];
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, classNames = _props.classNames, modifiersStyles = _props.modifiersStyles, day = _props.day, tabIndex = _props.tabIndex, empty = _props.empty, modifiers = _props.modifiers, onMouseEnter = _props.onMouseEnter, onMouseLeave = _props.onMouseLeave, onMouseUp = _props.onMouseUp, onMouseDown = _props.onMouseDown, onClick = _props.onClick, onKeyDown = _props.onKeyDown, onTouchStart = _props.onTouchStart, onTouchEnd = _props.onTouchEnd, onFocus = _props.onFocus, ariaLabel = _props.ariaLabel, ariaDisabled = _props.ariaDisabled, ariaSelected = _props.ariaSelected, children = _props.children;
                var className = classNames.day;
                if (classNames !== $a8d1013be36476cb$var$_classNames2.default) // When using CSS modules prefix the modifier as required by the BEM syntax
                className += ' ' + Object.keys(modifiers).join(' ');
                else className += Object.keys(modifiers).map(function(modifier) {
                    return ' ' + className + '--' + modifier;
                }).join('');
                var style = void 0;
                if (modifiersStyles) Object.keys(modifiers).filter(function(modifier) {
                    return !!modifiersStyles[modifier];
                }).forEach(function(modifier) {
                    style = $a8d1013be36476cb$var$_extends({}, style, modifiersStyles[modifier]);
                });
                if (empty) return $a8d1013be36476cb$var$_react2.default.createElement('div', {
                    'aria-disabled': true,
                    className: className,
                    style: style
                });
                return $a8d1013be36476cb$var$_react2.default.createElement('div', {
                    className: className,
                    tabIndex: tabIndex,
                    style: style,
                    role: 'gridcell',
                    'aria-label': ariaLabel,
                    'aria-disabled': ariaDisabled,
                    'aria-selected': ariaSelected,
                    onClick: $a8d1013be36476cb$var$handleEvent(onClick, day, modifiers),
                    onKeyDown: $a8d1013be36476cb$var$handleEvent(onKeyDown, day, modifiers),
                    onMouseEnter: $a8d1013be36476cb$var$handleEvent(onMouseEnter, day, modifiers),
                    onMouseLeave: $a8d1013be36476cb$var$handleEvent(onMouseLeave, day, modifiers),
                    onMouseUp: $a8d1013be36476cb$var$handleEvent(onMouseUp, day, modifiers),
                    onMouseDown: $a8d1013be36476cb$var$handleEvent(onMouseDown, day, modifiers),
                    onTouchEnd: $a8d1013be36476cb$var$handleEvent(onTouchEnd, day, modifiers),
                    onTouchStart: $a8d1013be36476cb$var$handleEvent(onTouchStart, day, modifiers),
                    onFocus: $a8d1013be36476cb$var$handleEvent(onFocus, day, modifiers)
                }, children);
            }
        }
    ]);
    return Day;
}($a5EUy.Component);
$a8d1013be36476cb$var$Day.propTypes = {
    classNames: $a8d1013be36476cb$var$_propTypes2.default.shape({
        day: $a8d1013be36476cb$var$_propTypes2.default.string.isRequired
    }).isRequired,
    day: $a8d1013be36476cb$var$_propTypes2.default.instanceOf(Date).isRequired,
    children: $a8d1013be36476cb$var$_propTypes2.default.node.isRequired,
    ariaDisabled: $a8d1013be36476cb$var$_propTypes2.default.bool,
    ariaLabel: $a8d1013be36476cb$var$_propTypes2.default.string,
    ariaSelected: $a8d1013be36476cb$var$_propTypes2.default.bool,
    empty: $a8d1013be36476cb$var$_propTypes2.default.bool,
    modifiers: $a8d1013be36476cb$var$_propTypes2.default.object,
    modifiersStyles: $a8d1013be36476cb$var$_propTypes2.default.object,
    onClick: $a8d1013be36476cb$var$_propTypes2.default.func,
    onKeyDown: $a8d1013be36476cb$var$_propTypes2.default.func,
    onMouseEnter: $a8d1013be36476cb$var$_propTypes2.default.func,
    onMouseLeave: $a8d1013be36476cb$var$_propTypes2.default.func,
    onMouseDown: $a8d1013be36476cb$var$_propTypes2.default.func,
    onMouseUp: $a8d1013be36476cb$var$_propTypes2.default.func,
    onTouchEnd: $a8d1013be36476cb$var$_propTypes2.default.func,
    onTouchStart: $a8d1013be36476cb$var$_propTypes2.default.func,
    onFocus: $a8d1013be36476cb$var$_propTypes2.default.func,
    tabIndex: $a8d1013be36476cb$var$_propTypes2.default.number
};
$a8d1013be36476cb$var$Day.defaultProps = {
    tabIndex: -1
};
$a8d1013be36476cb$var$Day.defaultProps = {
    modifiers: {},
    modifiersStyles: {},
    empty: false
};
module.exports.default = $a8d1013be36476cb$var$Day;

});
parcelRegister("3y50U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clone = $29586fad7f4b4d10$var$clone;
module.exports.isDate = $29586fad7f4b4d10$var$isDate;
module.exports.addMonths = $29586fad7f4b4d10$var$addMonths;
module.exports.isSameDay = $29586fad7f4b4d10$var$isSameDay;
module.exports.isSameMonth = $29586fad7f4b4d10$var$isSameMonth;
module.exports.isDayBefore = $29586fad7f4b4d10$var$isDayBefore;
module.exports.isDayAfter = $29586fad7f4b4d10$var$isDayAfter;
module.exports.isPastDay = $29586fad7f4b4d10$var$isPastDay;
module.exports.isFutureDay = $29586fad7f4b4d10$var$isFutureDay;
module.exports.isDayBetween = $29586fad7f4b4d10$var$isDayBetween;
module.exports.addDayToRange = $29586fad7f4b4d10$var$addDayToRange;
module.exports.isDayInRange = $29586fad7f4b4d10$var$isDayInRange;
module.exports.getWeekNumber = $29586fad7f4b4d10$var$getWeekNumber;
/**
 * Clone a date object.
 *
 * @export
 * @param  {Date} d The date to clone
 * @return {Date} The cloned date
 */ function $29586fad7f4b4d10$var$clone(d) {
    return new Date(d.getTime());
}
/**
 * Return `true` if the passed value is a valid JavaScript Date object.
 *
 * @export
 * @param {any} value
 * @returns {Boolean}
 */ function $29586fad7f4b4d10$var$isDate(value) {
    return value instanceof Date && !isNaN(value.valueOf());
}
/**
 * Return `d` as a new date with `n` months added.
 *
 * @export
 * @param {Date} d
 * @param {number} n
 */ function $29586fad7f4b4d10$var$addMonths(d, n) {
    var newDate = $29586fad7f4b4d10$var$clone(d);
    newDate.setMonth(d.getMonth() + n);
    return newDate;
}
/**
 * Return `true` if two dates are the same day, ignoring the time.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */ function $29586fad7f4b4d10$var$isSameDay(d1, d2) {
    if (!d1 || !d2) return false;
    return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}
/**
 * Return `true` if two dates fall in the same month.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */ function $29586fad7f4b4d10$var$isSameMonth(d1, d2) {
    if (!d1 || !d2) return false;
    return d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}
/**
 * Returns `true` if the first day is before the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */ function $29586fad7f4b4d10$var$isDayBefore(d1, d2) {
    var day1 = $29586fad7f4b4d10$var$clone(d1).setHours(0, 0, 0, 0);
    var day2 = $29586fad7f4b4d10$var$clone(d2).setHours(0, 0, 0, 0);
    return day1 < day2;
}
/**
 * Returns `true` if the first day is after the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */ function $29586fad7f4b4d10$var$isDayAfter(d1, d2) {
    var day1 = $29586fad7f4b4d10$var$clone(d1).setHours(0, 0, 0, 0);
    var day2 = $29586fad7f4b4d10$var$clone(d2).setHours(0, 0, 0, 0);
    return day1 > day2;
}
/**
 * Return `true` if a day is in the past, e.g. yesterday or any day
 * before yesterday.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */ function $29586fad7f4b4d10$var$isPastDay(d) {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    return $29586fad7f4b4d10$var$isDayBefore(d, today);
}
/**
 * Return `true` if a day is in the future, e.g. tomorrow or any day
 * after tomorrow.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */ function $29586fad7f4b4d10$var$isFutureDay(d) {
    var tomorrow = new Date(new Date().getTime() + 86400000);
    tomorrow.setHours(0, 0, 0, 0);
    return d >= tomorrow;
}
/**
 * Return `true` if day `d` is between days `d1` and `d2`,
 * without including them.
 *
 * @export
 * @param  {Date}  d
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */ function $29586fad7f4b4d10$var$isDayBetween(d, d1, d2) {
    var date = $29586fad7f4b4d10$var$clone(d);
    date.setHours(0, 0, 0, 0);
    return $29586fad7f4b4d10$var$isDayAfter(date, d1) && $29586fad7f4b4d10$var$isDayBefore(date, d2) || $29586fad7f4b4d10$var$isDayAfter(date, d2) && $29586fad7f4b4d10$var$isDayBefore(date, d1);
}
/**
 * Add a day to a range and return a new range. A range is an object with
 * `from` and `to` days.
 *
 * @export
 * @param {Date} day
 * @param {Object} range
 * @return {Object} Returns a new range object
 */ function $29586fad7f4b4d10$var$addDayToRange(day) {
    var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        from: null,
        to: null
    };
    var from = range.from, to = range.to;
    if (!from) from = day;
    else if (from && to && $29586fad7f4b4d10$var$isSameDay(from, to) && $29586fad7f4b4d10$var$isSameDay(day, from)) {
        from = null;
        to = null;
    } else if (to && $29586fad7f4b4d10$var$isDayBefore(day, from)) from = day;
    else if (to && $29586fad7f4b4d10$var$isSameDay(day, to)) {
        from = day;
        to = day;
    } else {
        to = day;
        if ($29586fad7f4b4d10$var$isDayBefore(to, from)) {
            to = from;
            from = day;
        }
    }
    return {
        from: from,
        to: to
    };
}
/**
 * Return `true` if a day is included in a range of days.
 *
 * @export
 * @param  {Date}  day
 * @param  {Object}  range
 * @return {Boolean}
 */ function $29586fad7f4b4d10$var$isDayInRange(day, range) {
    var from = range.from, to = range.to;
    return from && $29586fad7f4b4d10$var$isSameDay(day, from) || to && $29586fad7f4b4d10$var$isSameDay(day, to) || from && to && $29586fad7f4b4d10$var$isDayBetween(day, from, to);
}
/**
 * Return the year's week number (as per ISO, i.e. with the week starting from monday)
 * for the given day.
 *
 * @export
 * @param {Date} day
 * @returns {Number}
 */ function $29586fad7f4b4d10$var$getWeekNumber(day) {
    var date = $29586fad7f4b4d10$var$clone(day);
    date.setHours(0, 0, 0);
    date.setDate(date.getDate() + 4 - (date.getDay() || 7));
    return Math.ceil(((date - new Date(date.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
}
module.exports.default = {
    addDayToRange: $29586fad7f4b4d10$var$addDayToRange,
    addMonths: $29586fad7f4b4d10$var$addMonths,
    clone: $29586fad7f4b4d10$var$clone,
    getWeekNumber: $29586fad7f4b4d10$var$getWeekNumber,
    isDate: $29586fad7f4b4d10$var$isDate,
    isDayAfter: $29586fad7f4b4d10$var$isDayAfter,
    isDayBefore: $29586fad7f4b4d10$var$isDayBefore,
    isDayBetween: $29586fad7f4b4d10$var$isDayBetween,
    isDayInRange: $29586fad7f4b4d10$var$isDayInRange,
    isFutureDay: $29586fad7f4b4d10$var$isFutureDay,
    isPastDay: $29586fad7f4b4d10$var$isPastDay,
    isSameDay: $29586fad7f4b4d10$var$isSameDay,
    isSameMonth: $29586fad7f4b4d10$var$isSameMonth
};

});

parcelRegister("hbaX6", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c81bf5a41af2ba1f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
module.exports.cancelEvent = $c81bf5a41af2ba1f$var$cancelEvent;
module.exports.getFirstDayOfMonth = $c81bf5a41af2ba1f$var$getFirstDayOfMonth;
module.exports.getDaysInMonth = $c81bf5a41af2ba1f$var$getDaysInMonth;
module.exports.getModifiersFromProps = $c81bf5a41af2ba1f$var$getModifiersFromProps;
module.exports.getFirstDayOfWeekFromProps = $c81bf5a41af2ba1f$var$getFirstDayOfWeekFromProps;
module.exports.isRangeOfDates = $c81bf5a41af2ba1f$var$isRangeOfDates;
module.exports.getMonthsDiff = $c81bf5a41af2ba1f$var$getMonthsDiff;
module.exports.getWeekArray = $c81bf5a41af2ba1f$var$getWeekArray;
module.exports.startOfMonth = $c81bf5a41af2ba1f$var$startOfMonth;
module.exports.getDayNodes = $c81bf5a41af2ba1f$var$getDayNodes;
module.exports.nodeListToArray = $c81bf5a41af2ba1f$var$nodeListToArray;
module.exports.hasOwnProp = $c81bf5a41af2ba1f$var$hasOwnProp;

var $3y50U = parcelRequire("3y50U");

var $9FVG1 = parcelRequire("9FVG1");

var $2vFPn = parcelRequire("2vFPn");
var $c81bf5a41af2ba1f$var$_classNames2 = $c81bf5a41af2ba1f$var$_interopRequireDefault($2vFPn);
function $c81bf5a41af2ba1f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c81bf5a41af2ba1f$var$cancelEvent(e) {
    e.preventDefault();
    e.stopPropagation();
}
function $c81bf5a41af2ba1f$var$getFirstDayOfMonth(d) {
    return new Date(d.getFullYear(), d.getMonth(), 1, 12);
}
function $c81bf5a41af2ba1f$var$getDaysInMonth(d) {
    var resultDate = $c81bf5a41af2ba1f$var$getFirstDayOfMonth(d);
    resultDate.setMonth(resultDate.getMonth() + 1);
    resultDate.setDate(resultDate.getDate() - 1);
    return resultDate.getDate();
}
function $c81bf5a41af2ba1f$var$getModifiersFromProps(props) {
    var modifiers = $c81bf5a41af2ba1f$var$_extends({}, props.modifiers);
    if (props.selectedDays) modifiers[props.classNames.selected] = props.selectedDays;
    if (props.disabledDays) modifiers[props.classNames.disabled] = props.disabledDays;
    return modifiers;
}
function $c81bf5a41af2ba1f$var$getFirstDayOfWeekFromProps(props) {
    var firstDayOfWeek = props.firstDayOfWeek, _props$locale = props.locale, locale = _props$locale === undefined ? 'en' : _props$locale, _props$localeUtils = props.localeUtils, localeUtils = _props$localeUtils === undefined ? {} : _props$localeUtils;
    if (!isNaN(firstDayOfWeek)) return firstDayOfWeek;
    if (localeUtils.getFirstDayOfWeek) return localeUtils.getFirstDayOfWeek(locale);
    return 0;
}
function $c81bf5a41af2ba1f$var$isRangeOfDates(value) {
    return !!(value && value.from && value.to);
}
function $c81bf5a41af2ba1f$var$getMonthsDiff(d1, d2) {
    return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
}
function $c81bf5a41af2ba1f$var$getWeekArray(d) {
    var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $9FVG1.getFirstDayOfWeek)();
    var fixedWeeks = arguments[2];
    var daysInMonth = $c81bf5a41af2ba1f$var$getDaysInMonth(d);
    var dayArray = [];
    var week = [];
    var weekArray = [];
    for(var i = 1; i <= daysInMonth; i += 1)dayArray.push(new Date(d.getFullYear(), d.getMonth(), i, 12));
    dayArray.forEach(function(day) {
        if (week.length > 0 && day.getDay() === firstDayOfWeek) {
            weekArray.push(week);
            week = [];
        }
        week.push(day);
        if (dayArray.indexOf(day) === dayArray.length - 1) weekArray.push(week);
    });
    // unshift days to start the first week
    var firstWeek = weekArray[0];
    for(var _i = 7 - firstWeek.length; _i > 0; _i -= 1){
        var outsideDate = (0, $3y50U.clone)(firstWeek[0]);
        outsideDate.setDate(firstWeek[0].getDate() - 1);
        firstWeek.unshift(outsideDate);
    }
    // push days until the end of the last week
    var lastWeek = weekArray[weekArray.length - 1];
    for(var _i2 = lastWeek.length; _i2 < 7; _i2 += 1){
        var _outsideDate = (0, $3y50U.clone)(lastWeek[lastWeek.length - 1]);
        _outsideDate.setDate(lastWeek[lastWeek.length - 1].getDate() + 1);
        lastWeek.push(_outsideDate);
    }
    // add extra weeks to reach 6 weeks
    if (fixedWeeks && weekArray.length < 6) {
        var lastExtraWeek = void 0;
        for(var _i3 = weekArray.length; _i3 < 6; _i3 += 1){
            lastExtraWeek = weekArray[weekArray.length - 1];
            var lastDay = lastExtraWeek[lastExtraWeek.length - 1];
            var extraWeek = [];
            for(var j = 0; j < 7; j += 1){
                var _outsideDate2 = (0, $3y50U.clone)(lastDay);
                _outsideDate2.setDate(lastDay.getDate() + j + 1);
                extraWeek.push(_outsideDate2);
            }
            weekArray.push(extraWeek);
        }
    }
    return weekArray;
}
function $c81bf5a41af2ba1f$var$startOfMonth(d) {
    var newDate = (0, $3y50U.clone)(d);
    newDate.setDate(1);
    newDate.setHours(12, 0, 0, 0); // always set noon to avoid time zone issues
    return newDate;
}
function $c81bf5a41af2ba1f$var$getDayNodes(node, classNames) {
    var outsideClassName = void 0;
    if (classNames === $c81bf5a41af2ba1f$var$_classNames2.default) // When using CSS modules prefix the modifier as required by the BEM syntax
    outsideClassName = classNames.day + '--' + classNames.outside;
    else outsideClassName = '' + classNames.outside;
    var dayQuery = classNames.day.replace(/ /g, '.');
    var outsideDayQuery = outsideClassName.replace(/ /g, '.');
    var selector = '.' + dayQuery + ':not(.' + outsideDayQuery + ')';
    return node.querySelectorAll(selector);
}
function $c81bf5a41af2ba1f$var$nodeListToArray(nodeList) {
    return Array.prototype.slice.call(nodeList, 0);
}
function $c81bf5a41af2ba1f$var$hasOwnProp(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

});


parcelRegister("1wsvb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dayMatchesModifier = $11bee3812c09c882$var$dayMatchesModifier;
module.exports.getModifiersForDay = $11bee3812c09c882$var$getModifiersForDay;

var $3y50U = parcelRequire("3y50U");

var $hbaX6 = parcelRequire("hbaX6");
/**
 * Return `true` if a date matches the specified modifier.
 *
 * @export
 * @param {Date} day
 * @param {Any} modifier
 * @return {Boolean}
 */ function $11bee3812c09c882$var$dayMatchesModifier(day, modifier) {
    if (!modifier) return false;
    var arr = Array.isArray(modifier) ? modifier : [
        modifier
    ];
    return arr.some(function(mod) {
        if (!mod) return false;
        if (mod instanceof Date) return (0, $3y50U.isSameDay)(day, mod);
        if ((0, $hbaX6.isRangeOfDates)(mod)) return (0, $3y50U.isDayInRange)(day, mod);
        if (mod.after && mod.before && (0, $3y50U.isDayAfter)(mod.before, mod.after)) return (0, $3y50U.isDayAfter)(day, mod.after) && (0, $3y50U.isDayBefore)(day, mod.before);
        if (mod.after && mod.before && ((0, $3y50U.isDayAfter)(mod.after, mod.before) || (0, $3y50U.isSameDay)(mod.after, mod.before))) return (0, $3y50U.isDayAfter)(day, mod.after) || (0, $3y50U.isDayBefore)(day, mod.before);
        if (mod.after) return (0, $3y50U.isDayAfter)(day, mod.after);
        if (mod.before) return (0, $3y50U.isDayBefore)(day, mod.before);
        if (mod.daysOfWeek) return mod.daysOfWeek.some(function(dayOfWeek) {
            return day.getDay() === dayOfWeek;
        });
        if (typeof mod === 'function') return mod(day);
        return false;
    });
}
/**
 * Return the modifiers matching the given day for the given
 * object of modifiers.
 *
 * @export
 * @param {Date} day
 * @param {Object} [modifiersObj={}]
 * @return {Array}
 */ function $11bee3812c09c882$var$getModifiersForDay(day) {
    var modifiersObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(modifiersObj).reduce(function(modifiers, modifierName) {
        var value = modifiersObj[modifierName];
        if ($11bee3812c09c882$var$dayMatchesModifier(day, value)) modifiers.push(modifierName);
        return modifiers;
    }, []);
}
module.exports.default = {
    dayMatchesModifier: $11bee3812c09c882$var$dayMatchesModifier,
    getModifiersForDay: $11bee3812c09c882$var$getModifiersForDay
};

});


parcelRegister("fu2qw", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b45b8a47bf0ae771$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $a5EUy = parcelRequire("a5EUy");
var $b45b8a47bf0ae771$var$_react2 = $b45b8a47bf0ae771$var$_interopRequireDefault($a5EUy);

var $3yJBl = parcelRequire("3yJBl");
var $b45b8a47bf0ae771$var$_propTypes2 = $b45b8a47bf0ae771$var$_interopRequireDefault($3yJBl);
function $b45b8a47bf0ae771$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b45b8a47bf0ae771$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b45b8a47bf0ae771$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b45b8a47bf0ae771$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $b45b8a47bf0ae771$var$Weekday = function(_Component) {
    $b45b8a47bf0ae771$var$_inherits(Weekday, _Component);
    function Weekday() {
        $b45b8a47bf0ae771$var$_classCallCheck(this, Weekday);
        return $b45b8a47bf0ae771$var$_possibleConstructorReturn(this, (Weekday.__proto__ || Object.getPrototypeOf(Weekday)).apply(this, arguments));
    }
    $b45b8a47bf0ae771$var$_createClass(Weekday, [
        {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate(nextProps) {
                return this.props !== nextProps;
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, weekday = _props.weekday, className = _props.className, weekdaysLong = _props.weekdaysLong, weekdaysShort = _props.weekdaysShort, localeUtils = _props.localeUtils, locale = _props.locale;
                var title = void 0;
                if (weekdaysLong) title = weekdaysLong[weekday];
                else title = localeUtils.formatWeekdayLong(weekday, locale);
                var content = void 0;
                if (weekdaysShort) content = weekdaysShort[weekday];
                else content = localeUtils.formatWeekdayShort(weekday, locale);
                return $b45b8a47bf0ae771$var$_react2.default.createElement('div', {
                    className: className,
                    role: 'columnheader'
                }, $b45b8a47bf0ae771$var$_react2.default.createElement('abbr', {
                    title: title
                }, content));
            }
        }
    ]);
    return Weekday;
}($a5EUy.Component);
$b45b8a47bf0ae771$var$Weekday.propTypes = {
    weekday: $b45b8a47bf0ae771$var$_propTypes2.default.number,
    className: $b45b8a47bf0ae771$var$_propTypes2.default.string,
    locale: $b45b8a47bf0ae771$var$_propTypes2.default.string,
    localeUtils: $b45b8a47bf0ae771$var$_propTypes2.default.object,
    weekdaysLong: $b45b8a47bf0ae771$var$_propTypes2.default.arrayOf($b45b8a47bf0ae771$var$_propTypes2.default.string),
    weekdaysShort: $b45b8a47bf0ae771$var$_propTypes2.default.arrayOf($b45b8a47bf0ae771$var$_propTypes2.default.string)
};
module.exports.default = $b45b8a47bf0ae771$var$Weekday;

});



parcelRegister("hvPZl", function(module, exports) {

!function(e, t) {
    t(module.exports, (parcelRequire("a5EUy")));
}(module.exports, function(e, t) {
    "use strict";
    function n(e, t, n, o, r, i, u) {
        try {
            var l = e[i](u), s = l.value;
        } catch (e) {
            return void n(e);
        }
        l.done ? t(s) : Promise.resolve(s).then(o, r);
    }
    function o(e) {
        return function() {
            var t = this, o = arguments;
            return new Promise(function(r, i) {
                var u = e.apply(t, o);
                function l(e) {
                    n(u, r, i, l, s, "next", e);
                }
                function s(e) {
                    n(u, r, i, l, s, "throw", e);
                }
                l(void 0);
            });
        };
    }
    function r() {
        return (r = Object.assign || function(e) {
            for(var t = 1; t < arguments.length; t++){
                var n = arguments[t];
                for(var o in n)Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
        }).apply(this, arguments);
    }
    function i(e, t) {
        if (null == e) return {};
        var n, o, r = {}, i = Object.keys(e);
        for(o = 0; o < i.length; o++)n = i[o], t.indexOf(n) >= 0 || (r[n] = e[n]);
        return r;
    }
    function u(e) {
        var t = function(e, t) {
            if ("object" != typeof e || null === e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
                var o = n.call(e, t || "default");
                if ("object" != typeof o) return o;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : String(t);
    }
    t = t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
    var l = {
        init: "init"
    }, s = function(e) {
        var t = e.value;
        return void 0 === t ? "" : t;
    }, a = function() {
        return t.createElement(t.Fragment, null, "\xa0");
    }, c = {
        Cell: s,
        width: 150,
        minWidth: 0,
        maxWidth: Number.MAX_SAFE_INTEGER
    };
    function d() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        return t.reduce(function(e, t) {
            var n = t.style, o = t.className;
            return e = r({}, e, {}, i(t, [
                "style",
                "className"
            ])), n && (e.style = e.style ? r({}, e.style || {}, {}, n || {}) : n), o && (e.className = e.className ? e.className + " " + o : o), "" === e.className && delete e.className, e;
        }, {});
    }
    var f = function(e, t) {
        return void 0 === t && (t = {}), function(n) {
            return void 0 === n && (n = {}), [].concat(e, [
                n
            ]).reduce(function(e, o) {
                return function e(t, n, o) {
                    return "function" == typeof n ? e({}, n(t, o)) : Array.isArray(n) ? d.apply(void 0, [
                        t
                    ].concat(n)) : d(t, n);
                }(e, o, r({}, t, {
                    userProps: n
                }));
            }, {});
        };
    }, p = function(e, t, n, o) {
        return void 0 === n && (n = {}), e.reduce(function(e, t) {
            return t(e, n);
        }, t);
    }, g = function(e, t, n) {
        return void 0 === n && (n = {}), e.forEach(function(e) {
            e(t, n);
        });
    };
    function v(e, t, n, o) {
        e.findIndex(function(e) {
            return e.pluginName === n;
        });
        t.forEach(function(t) {
            e.findIndex(function(e) {
                return e.pluginName === t;
            });
        });
    }
    function m(e, t) {
        return "function" == typeof e ? e(t) : e;
    }
    function h(e) {
        var n = t.useRef();
        return n.current = e, t.useCallback(function() {
            return n.current;
        }, []);
    }
    var y = "undefined" != typeof document ? t.useLayoutEffect : t.useEffect;
    function w(e, n) {
        var o = t.useRef(!1);
        y(function() {
            o.current && e(), o.current = !0;
        }, n);
    }
    function R(e, t, n) {
        return void 0 === n && (n = {}), function(o, i) {
            void 0 === i && (i = {});
            var u = "string" == typeof o ? t[o] : o;
            if (void 0 === u) throw console.info(t), new Error("Renderer Error \u261D\uFE0F");
            return b(u, r({}, e, {
                column: t
            }, n, {}, i));
        };
    }
    function b(e, n) {
        var o;
        return function(e) {
            var t;
            return "function" == typeof e && (t = Object.getPrototypeOf(e)).prototype && t.prototype.isReactComponent;
        }(o = e) || "function" == typeof o || function(e) {
            return "object" == typeof e && "symbol" == typeof e.$$typeof && [
                "react.memo",
                "react.forward_ref"
            ].includes(e.$$typeof.description);
        }(o) ? t.createElement(e, n) : e;
    }
    function S(e, t, n) {
        return void 0 === n && (n = 0), e.map(function(e) {
            return x(e = r({}, e, {
                parent: t,
                depth: n
            })), e.columns && (e.columns = S(e.columns, e, n + 1)), e;
        });
    }
    function C(e) {
        return G(e, "columns");
    }
    function x(e) {
        var t = e.id, n = e.accessor, o = e.Header;
        if ("string" == typeof n) {
            t = t || n;
            var r = n.split(".");
            n = function(e) {
                return function(e, t, n) {
                    if (!t) return e;
                    var o, r = "function" == typeof t ? t : JSON.stringify(t), i = E.get(r) || function() {
                        var e = function(e) {
                            return (function e(t, n) {
                                void 0 === n && (n = []);
                                if (Array.isArray(t)) for(var o = 0; o < t.length; o += 1)e(t[o], n);
                                else n.push(t);
                                return n;
                            })(e).map(function(e) {
                                return String(e).replace(".", "_");
                            }).join(".").replace(W, ".").replace(O, "").split(".");
                        }(t);
                        return E.set(r, e), e;
                    }();
                    try {
                        o = i.reduce(function(e, t) {
                            return e[t];
                        }, e);
                    } catch (e) {}
                    return void 0 !== o ? o : n;
                }(e, r);
            };
        }
        if (!t && "string" == typeof o && o && (t = o), !t && e.columns) throw console.error(e), new Error('A column ID (or unique "Header" value) is required!');
        if (!t) throw console.error(e), new Error("A column ID (or string accessor) is required!");
        return Object.assign(e, {
            id: t,
            accessor: n
        }), e;
    }
    function P(e, t) {
        if (!t) throw new Error;
        return Object.assign(e, r({
            Header: a,
            Footer: a
        }, c, {}, t, {}, e)), Object.assign(e, {
            originalWidth: e.width
        }), e;
    }
    function B(e, t, n) {
        void 0 === n && (n = function() {
            return {};
        });
        for(var o = [], i = e, u = 0, l = function() {
            return u++;
        }, s = function() {
            var e = {
                headers: []
            }, u = [], s = i.some(function(e) {
                return e.parent;
            });
            i.forEach(function(o) {
                var i, a = [].concat(u).reverse()[0];
                if (s) {
                    if (o.parent) i = r({}, o.parent, {
                        originalId: o.parent.id,
                        id: o.parent.id + "_" + l(),
                        headers: [
                            o
                        ]
                    }, n(o));
                    else i = P(r({
                        originalId: o.id + "_placeholder",
                        id: o.id + "_placeholder_" + l(),
                        placeholderOf: o,
                        headers: [
                            o
                        ]
                    }, n(o)), t);
                    a && a.originalId === i.originalId ? a.headers.push(o) : u.push(i);
                }
                e.headers.push(o);
            }), o.push(e), i = u;
        }; i.length;)s();
        return o.reverse();
    }
    var E = new Map;
    function I() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        for(var o = 0; o < t.length; o += 1)if (void 0 !== t[o]) return t[o];
    }
    function F(e) {
        if ("function" == typeof e) return e;
    }
    function G(e, t) {
        var n = [];
        return function e(o) {
            o.forEach(function(o) {
                o[t] ? e(o[t]) : n.push(o);
            });
        }(e), n;
    }
    function A(e, t) {
        var n = t.manualExpandedKey, o = t.expanded, r = t.expandSubRows, i = void 0 === r || r, u = [];
        return e.forEach(function(e) {
            return function e(t, r) {
                void 0 === r && (r = !0), t.isExpanded = t.original && t.original[n] || o[t.id], t.canExpand = t.subRows && !!t.subRows.length, r && u.push(t), t.subRows && t.subRows.length && t.isExpanded && t.subRows.forEach(function(t) {
                    return e(t, i);
                });
            }(e);
        }), u;
    }
    function k(e, t, n) {
        return F(e) || t[e] || n[e] || n.text;
    }
    function H(e, t, n) {
        return e ? e(t, n) : void 0 === t;
    }
    function T() {
        throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.");
    }
    var z = null;
    var W = /\[/g, O = /\]/g;
    var M = function(e) {
        return r({
            role: "table"
        }, e);
    }, j = function(e) {
        return r({
            role: "rowgroup"
        }, e);
    }, N = function(e, t) {
        var n = t.column;
        return r({
            key: "header_" + n.id,
            colSpan: n.totalVisibleHeaderCount,
            role: "columnheader"
        }, e);
    }, D = function(e, t) {
        var n = t.column;
        return r({
            key: "footer_" + n.id,
            colSpan: n.totalVisibleHeaderCount
        }, e);
    }, L = function(e, t) {
        return r({
            key: "headerGroup_" + t.index,
            role: "row"
        }, e);
    }, V = function(e, t) {
        return r({
            key: "footerGroup_" + t.index
        }, e);
    }, _ = function(e, t) {
        return r({
            key: "row_" + t.row.id,
            role: "row"
        }, e);
    }, X = function(e, t) {
        var n = t.cell;
        return r({
            key: "cell_" + n.row.id + "_" + n.column.id,
            role: "cell"
        }, e);
    };
    function q() {
        return {
            useOptions: [],
            stateReducers: [],
            useControlledState: [],
            columns: [],
            columnsDeps: [],
            allColumns: [],
            allColumnsDeps: [],
            accessValue: [],
            materializedColumns: [],
            materializedColumnsDeps: [],
            useInstanceAfterData: [],
            visibleColumns: [],
            visibleColumnsDeps: [],
            headerGroups: [],
            headerGroupsDeps: [],
            useInstanceBeforeDimensions: [],
            useInstance: [],
            prepareRow: [],
            getTableProps: [
                M
            ],
            getTableBodyProps: [
                j
            ],
            getHeaderGroupProps: [
                L
            ],
            getFooterGroupProps: [
                V
            ],
            getHeaderProps: [
                N
            ],
            getFooterProps: [
                D
            ],
            getRowProps: [
                _
            ],
            getCellProps: [
                X
            ],
            useFinalInstance: []
        };
    }
    l.resetHiddenColumns = "resetHiddenColumns", l.toggleHideColumn = "toggleHideColumn", l.setHiddenColumns = "setHiddenColumns", l.toggleHideAllColumns = "toggleHideAllColumns";
    var K = function(e) {
        e.getToggleHiddenProps = [
            U
        ], e.getToggleHideAllColumnsProps = [
            $
        ], e.stateReducers.push(J), e.useInstanceBeforeDimensions.push(Y), e.headerGroupsDeps.push(function(e, t) {
            var n = t.instance;
            return [].concat(e, [
                n.state.hiddenColumns
            ]);
        }), e.useInstance.push(Q);
    };
    K.pluginName = "useColumnVisibility";
    var U = function(e, t) {
        var n = t.column;
        return [
            e,
            {
                onChange: function(e) {
                    n.toggleHidden(!e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: n.isVisible,
                title: "Toggle Column Visible"
            }
        ];
    }, $ = function(e, t) {
        var n = t.instance;
        return [
            e,
            {
                onChange: function(e) {
                    n.toggleHideAllColumns(!e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: !n.allColumnsHidden && !n.state.hiddenColumns.length,
                title: "Toggle All Columns Hidden",
                indeterminate: !n.allColumnsHidden && n.state.hiddenColumns.length
            }
        ];
    };
    function J(e, t, n, o) {
        if (t.type === l.init) return r({
            hiddenColumns: []
        }, e);
        if (t.type === l.resetHiddenColumns) return r({}, e, {
            hiddenColumns: o.initialState.hiddenColumns || []
        });
        if (t.type === l.toggleHideColumn) {
            var i = (void 0 !== t.value ? t.value : !e.hiddenColumns.includes(t.columnId)) ? [].concat(e.hiddenColumns, [
                t.columnId
            ]) : e.hiddenColumns.filter(function(e) {
                return e !== t.columnId;
            });
            return r({}, e, {
                hiddenColumns: i
            });
        }
        return t.type === l.setHiddenColumns ? r({}, e, {
            hiddenColumns: m(t.value, e.hiddenColumns)
        }) : t.type === l.toggleHideAllColumns ? r({}, e, {
            hiddenColumns: (void 0 !== t.value ? t.value : !e.hiddenColumns.length) ? o.allColumns.map(function(e) {
                return e.id;
            }) : []
        }) : void 0;
    }
    function Y(e) {
        var n = e.headers, o = e.state.hiddenColumns;
        t.useRef(!1).current;
        var r = 0;
        n.forEach(function(e) {
            return r += function e(t, n) {
                t.isVisible = n && !o.includes(t.id);
                var r = 0;
                return t.headers && t.headers.length ? t.headers.forEach(function(n) {
                    return r += e(n, t.isVisible);
                }) : r = t.isVisible ? 1 : 0, t.totalVisibleHeaderCount = r, r;
            }(e, !0);
        });
    }
    function Q(e) {
        var n = e.columns, o = e.flatHeaders, r = e.dispatch, i = e.allColumns, u = e.getHooks, s = e.state.hiddenColumns, a = e.autoResetHiddenColumns, c = void 0 === a || a, d = h(e), p = i.length === s.length, g = t.useCallback(function(e, t) {
            return r({
                type: l.toggleHideColumn,
                columnId: e,
                value: t
            });
        }, [
            r
        ]), v = t.useCallback(function(e) {
            return r({
                type: l.setHiddenColumns,
                value: e
            });
        }, [
            r
        ]), m = t.useCallback(function(e) {
            return r({
                type: l.toggleHideAllColumns,
                value: e
            });
        }, [
            r
        ]), y = f(u().getToggleHideAllColumnsProps, {
            instance: d()
        });
        o.forEach(function(e) {
            e.toggleHidden = function(t) {
                r({
                    type: l.toggleHideColumn,
                    columnId: e.id,
                    value: t
                });
            }, e.getToggleHiddenProps = f(u().getToggleHiddenProps, {
                instance: d(),
                column: e
            });
        });
        var R = h(c);
        w(function() {
            R() && r({
                type: l.resetHiddenColumns
            });
        }, [
            r,
            n
        ]), Object.assign(e, {
            allColumnsHidden: p,
            toggleHideColumn: g,
            setHiddenColumns: v,
            toggleHideAllColumns: m,
            getToggleHideAllColumnsProps: y
        });
    }
    var Z = {}, ee = {}, te = function(e, t, n) {
        return e;
    }, ne = function(e, t) {
        return e.subRows || [];
    }, oe = function(e, t, n) {
        return "" + (n ? [
            n.id,
            t
        ].join(".") : t);
    }, re = function(e) {
        return e;
    };
    function ie(e) {
        var t = e.initialState, n = void 0 === t ? Z : t, o = e.defaultColumn, u = void 0 === o ? ee : o, l = e.getSubRows, s = void 0 === l ? ne : l, a = e.getRowId, c = void 0 === a ? oe : a, d = e.stateReducer, f = void 0 === d ? te : d, p = e.useControlledState, g = void 0 === p ? re : p;
        return r({}, i(e, [
            "initialState",
            "defaultColumn",
            "getSubRows",
            "getRowId",
            "stateReducer",
            "useControlledState"
        ]), {
            initialState: n,
            defaultColumn: u,
            getSubRows: s,
            getRowId: c,
            stateReducer: f,
            useControlledState: g
        });
    }
    function ue(e, t) {
        void 0 === t && (t = 0);
        var n = 0, o = 0, r = 0, i = 0;
        return e.forEach(function(e) {
            var u = e.headers;
            if (e.totalLeft = t, u && u.length) {
                var l = ue(u, t), s = l[0], a = l[1], c = l[2], d = l[3];
                e.totalMinWidth = s, e.totalWidth = a, e.totalMaxWidth = c, e.totalFlexWidth = d;
            } else e.totalMinWidth = e.minWidth, e.totalWidth = Math.min(Math.max(e.minWidth, e.width), e.maxWidth), e.totalMaxWidth = e.maxWidth, e.totalFlexWidth = e.canResize ? e.totalWidth : 0;
            e.isVisible && (t += e.totalWidth, n += e.totalMinWidth, o += e.totalWidth, r += e.totalMaxWidth, i += e.totalFlexWidth);
        }), [
            n,
            o,
            r,
            i
        ];
    }
    function le(e) {
        var t = e.data, n = e.rows, o = e.flatRows, r = e.rowsById, i = e.column, u = e.getRowId, l = e.getSubRows, s = e.accessValueHooks, a = e.getInstance;
        t.forEach(function(e, c) {
            return function e(n, c, d, f, g) {
                void 0 === d && (d = 0);
                var v = n, m = u(n, c, f), h = r[m];
                if (h) h.subRows && h.originalSubRows.forEach(function(t, n) {
                    return e(t, n, d + 1, h);
                });
                else if ((h = {
                    id: m,
                    original: v,
                    index: c,
                    depth: d,
                    cells: [
                        {}
                    ]
                }).cells.map = T, h.cells.filter = T, h.cells.forEach = T, h.cells[0].getCellProps = T, h.values = {}, g.push(h), o.push(h), r[m] = h, h.originalSubRows = l(n, c), h.originalSubRows) {
                    var y = [];
                    h.originalSubRows.forEach(function(t, n) {
                        return e(t, n, d + 1, h, y);
                    }), h.subRows = y;
                }
                i.accessor && (h.values[i.id] = i.accessor(n, c, h, g, t)), h.values[i.id] = p(s, h.values[i.id], {
                    row: h,
                    column: i,
                    instance: a()
                });
            }(e, c, 0, void 0, n);
        });
    }
    l.resetExpanded = "resetExpanded", l.toggleRowExpanded = "toggleRowExpanded", l.toggleAllRowsExpanded = "toggleAllRowsExpanded";
    var se = function(e) {
        e.getToggleAllRowsExpandedProps = [
            ae
        ], e.getToggleRowExpandedProps = [
            ce
        ], e.stateReducers.push(de), e.useInstance.push(fe), e.prepareRow.push(pe);
    };
    se.pluginName = "useExpanded";
    var ae = function(e, t) {
        var n = t.instance;
        return [
            e,
            {
                onClick: function(e) {
                    n.toggleAllRowsExpanded();
                },
                style: {
                    cursor: "pointer"
                },
                title: "Toggle All Rows Expanded"
            }
        ];
    }, ce = function(e, t) {
        var n = t.row;
        return [
            e,
            {
                onClick: function() {
                    n.toggleRowExpanded();
                },
                style: {
                    cursor: "pointer"
                },
                title: "Toggle Row Expanded"
            }
        ];
    };
    function de(e, t, n, o) {
        if (t.type === l.init) return r({
            expanded: {}
        }, e);
        if (t.type === l.resetExpanded) return r({}, e, {
            expanded: o.initialState.expanded || {}
        });
        if (t.type === l.toggleAllRowsExpanded) {
            var s = t.value, a = o.isAllRowsExpanded, c = o.rowsById;
            if (void 0 !== s ? s : !a) {
                var d = {};
                return Object.keys(c).forEach(function(e) {
                    d[e] = !0;
                }), r({}, e, {
                    expanded: d
                });
            }
            return r({}, e, {
                expanded: {}
            });
        }
        if (t.type === l.toggleRowExpanded) {
            var f, p = t.id, g = t.value, v = e.expanded[p], m = void 0 !== g ? g : !v;
            if (!v && m) return r({}, e, {
                expanded: r({}, e.expanded, (f = {}, f[p] = !0, f))
            });
            if (v && !m) {
                var h = e.expanded;
                h[p];
                return r({}, e, {
                    expanded: i(h, [
                        p
                    ].map(u))
                });
            }
            return e;
        }
    }
    function fe(e) {
        var n = e.data, o = e.rows, r = e.rowsById, i = e.manualExpandedKey, u = void 0 === i ? "expanded" : i, s = e.paginateExpandedRows, a = void 0 === s || s, c = e.expandSubRows, d = void 0 === c || c, p = e.autoResetExpanded, g = void 0 === p || p, m = e.getHooks, y = e.plugins, R = e.state.expanded, b = e.dispatch;
        v(y, [
            "useSortBy",
            "useGroupBy",
            "usePivotColumns",
            "useGlobalFilter"
        ], "useExpanded");
        var S = h(g), C = Boolean(Object.keys(r).length && Object.keys(R).length);
        C && Object.keys(r).some(function(e) {
            return !R[e];
        }) && (C = !1), w(function() {
            S() && b({
                type: l.resetExpanded
            });
        }, [
            b,
            n
        ]);
        var x = t.useCallback(function(e, t) {
            b({
                type: l.toggleRowExpanded,
                id: e,
                value: t
            });
        }, [
            b
        ]), P = t.useCallback(function(e) {
            return b({
                type: l.toggleAllRowsExpanded,
                value: e
            });
        }, [
            b
        ]), B = t.useMemo(function() {
            return a ? A(o, {
                manualExpandedKey: u,
                expanded: R,
                expandSubRows: d
            }) : o;
        }, [
            a,
            o,
            u,
            R,
            d
        ]), E = t.useMemo(function() {
            return function(e) {
                var t = 0;
                return Object.keys(e).forEach(function(e) {
                    var n = e.split(".");
                    t = Math.max(t, n.length);
                }), t;
            }(R);
        }, [
            R
        ]), I = h(e), F = f(m().getToggleAllRowsExpandedProps, {
            instance: I()
        });
        Object.assign(e, {
            preExpandedRows: o,
            expandedRows: B,
            rows: B,
            expandedDepth: E,
            isAllRowsExpanded: C,
            toggleRowExpanded: x,
            toggleAllRowsExpanded: P,
            getToggleAllRowsExpandedProps: F
        });
    }
    function pe(e, t) {
        var n = t.instance.getHooks, o = t.instance;
        e.toggleRowExpanded = function(t) {
            return o.toggleRowExpanded(e.id, t);
        }, e.getToggleRowExpandedProps = f(n().getToggleRowExpandedProps, {
            instance: o,
            row: e
        });
    }
    var ge = function(e, t, n) {
        return e = e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return String(o).toLowerCase().includes(String(n).toLowerCase());
            });
        });
    };
    ge.autoRemove = function(e) {
        return !e;
    };
    var ve = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return void 0 === o || String(o).toLowerCase() === String(n).toLowerCase();
            });
        });
    };
    ve.autoRemove = function(e) {
        return !e;
    };
    var me = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return void 0 === o || String(o) === String(n);
            });
        });
    };
    me.autoRemove = function(e) {
        return !e;
    };
    var he = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                return e.values[t].includes(n);
            });
        });
    };
    he.autoRemove = function(e) {
        return !e || !e.length;
    };
    var ye = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return o && o.length && n.every(function(e) {
                    return o.includes(e);
                });
            });
        });
    };
    ye.autoRemove = function(e) {
        return !e || !e.length;
    };
    var we = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return o && o.length && n.some(function(e) {
                    return o.includes(e);
                });
            });
        });
    };
    we.autoRemove = function(e) {
        return !e || !e.length;
    };
    var Re = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return n.includes(o);
            });
        });
    };
    Re.autoRemove = function(e) {
        return !e || !e.length;
    };
    var be = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                return e.values[t] === n;
            });
        });
    };
    be.autoRemove = function(e) {
        return void 0 === e;
    };
    var Se = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                return e.values[t] == n;
            });
        });
    };
    Se.autoRemove = function(e) {
        return null == e;
    };
    var Ce = function(e, t, n) {
        var o = n || [], r = o[0], i = o[1];
        if ((r = "number" == typeof r ? r : -1 / 0) > (i = "number" == typeof i ? i : 1 / 0)) {
            var u = r;
            r = i, i = u;
        }
        return e.filter(function(e) {
            return t.some(function(t) {
                var n = e.values[t];
                return n >= r && n <= i;
            });
        });
    };
    Ce.autoRemove = function(e) {
        return !e || "number" != typeof e[0] && "number" != typeof e[1];
    };
    var xe = Object.freeze({
        __proto__: null,
        text: ge,
        exactText: ve,
        exactTextCase: me,
        includes: he,
        includesAll: ye,
        includesSome: we,
        includesValue: Re,
        exact: be,
        equals: Se,
        between: Ce
    });
    l.resetFilters = "resetFilters", l.setFilter = "setFilter", l.setAllFilters = "setAllFilters";
    var Pe = function(e) {
        e.stateReducers.push(Be), e.useInstance.push(Ee);
    };
    function Be(e, t, n, o) {
        if (t.type === l.init) return r({
            filters: []
        }, e);
        if (t.type === l.resetFilters) return r({}, e, {
            filters: o.initialState.filters || []
        });
        if (t.type === l.setFilter) {
            var i = t.columnId, u = t.filterValue, s = o.allColumns, a = o.filterTypes, c = s.find(function(e) {
                return e.id === i;
            });
            if (!c) throw new Error("React-Table: Could not find a column with id: " + i);
            var d = k(c.filter, a || {}, xe), f = e.filters.find(function(e) {
                return e.id === i;
            }), p = m(u, f && f.value);
            return H(d.autoRemove, p, c) ? r({}, e, {
                filters: e.filters.filter(function(e) {
                    return e.id !== i;
                })
            }) : r({}, e, f ? {
                filters: e.filters.map(function(e) {
                    return e.id === i ? {
                        id: i,
                        value: p
                    } : e;
                })
            } : {
                filters: [].concat(e.filters, [
                    {
                        id: i,
                        value: p
                    }
                ])
            });
        }
        if (t.type === l.setAllFilters) {
            var g = t.filters, v = o.allColumns, h = o.filterTypes;
            return r({}, e, {
                filters: m(g, e.filters).filter(function(e) {
                    var t = v.find(function(t) {
                        return t.id === e.id;
                    });
                    return !H(k(t.filter, h || {}, xe).autoRemove, e.value, t);
                })
            });
        }
    }
    function Ee(e) {
        var n = e.data, o = e.rows, r = e.flatRows, i = e.rowsById, u = e.allColumns, s = e.filterTypes, a = e.manualFilters, c = e.defaultCanFilter, d = void 0 !== c && c, f = e.disableFilters, p = e.state.filters, g = e.dispatch, v = e.autoResetFilters, m = void 0 === v || v, y = t.useCallback(function(e, t) {
            g({
                type: l.setFilter,
                columnId: e,
                filterValue: t
            });
        }, [
            g
        ]), R = t.useCallback(function(e) {
            g({
                type: l.setAllFilters,
                filters: e
            });
        }, [
            g
        ]);
        u.forEach(function(e) {
            var t = e.id, n = e.accessor, o = e.defaultCanFilter, r = e.disableFilters;
            e.canFilter = n ? I(!0 !== r && void 0, !0 !== f && void 0, !0) : I(o, d, !1), e.setFilter = function(t) {
                return y(e.id, t);
            };
            var i = p.find(function(e) {
                return e.id === t;
            });
            e.filterValue = i && i.value;
        });
        var b = t.useMemo(function() {
            if (a || !p.length) return [
                o,
                r,
                i
            ];
            var e = [], t = {};
            return [
                function n(o, r) {
                    void 0 === r && (r = 0);
                    var i = o;
                    return (i = p.reduce(function(e, t) {
                        var n = t.id, o = t.value, i = u.find(function(e) {
                            return e.id === n;
                        });
                        if (!i) return e;
                        0 === r && (i.preFilteredRows = e);
                        var l = k(i.filter, s || {}, xe);
                        return l ? (i.filteredRows = l(e, [
                            n
                        ], o), i.filteredRows) : (console.warn("Could not find a valid 'column.filter' for column with the ID: " + i.id + "."), e);
                    }, o)).forEach(function(o) {
                        e.push(o), t[o.id] = o, o.subRows && (o.subRows = o.subRows && o.subRows.length > 0 ? n(o.subRows, r + 1) : o.subRows);
                    }), i;
                }(o),
                e,
                t
            ];
        }, [
            a,
            p,
            o,
            r,
            i,
            u,
            s
        ]), S = b[0], C = b[1], x = b[2];
        t.useMemo(function() {
            u.filter(function(e) {
                return !p.find(function(t) {
                    return t.id === e.id;
                });
            }).forEach(function(e) {
                e.preFilteredRows = S, e.filteredRows = S;
            });
        }, [
            S,
            p,
            u
        ]);
        var P = h(m);
        w(function() {
            P() && g({
                type: l.resetFilters
            });
        }, [
            g,
            a ? null : n
        ]), Object.assign(e, {
            preFilteredRows: o,
            preFilteredFlatRows: r,
            preFilteredRowsById: i,
            filteredRows: S,
            filteredFlatRows: C,
            filteredRowsById: x,
            rows: S,
            flatRows: C,
            rowsById: x,
            setFilter: y,
            setAllFilters: R
        });
    }
    Pe.pluginName = "useFilters", l.resetGlobalFilter = "resetGlobalFilter", l.setGlobalFilter = "setGlobalFilter";
    var Ie = function(e) {
        e.stateReducers.push(Fe), e.useInstance.push(Ge);
    };
    function Fe(e, t, n, o) {
        if (t.type === l.resetGlobalFilter) return r({}, e, {
            globalFilter: o.initialState.globalFilter || void 0
        });
        if (t.type === l.setGlobalFilter) {
            var u = t.filterValue, s = o.userFilterTypes, a = k(o.globalFilter, s || {}, xe), c = m(u, e.globalFilter);
            if (H(a.autoRemove, c)) {
                e.globalFilter;
                return i(e, [
                    "globalFilter"
                ]);
            }
            return r({}, e, {
                globalFilter: c
            });
        }
    }
    function Ge(e) {
        var n = e.data, o = e.rows, r = e.flatRows, i = e.rowsById, u = e.allColumns, s = e.filterTypes, a = e.globalFilter, c = e.manualGlobalFilter, d = e.state.globalFilter, f = e.dispatch, p = e.autoResetGlobalFilter, g = void 0 === p || p, v = e.disableGlobalFilter, m = t.useCallback(function(e) {
            f({
                type: l.setGlobalFilter,
                filterValue: e
            });
        }, [
            f
        ]), y = t.useMemo(function() {
            if (c || void 0 === d) return [
                o,
                r,
                i
            ];
            var e = [], t = {}, n = k(a, s || {}, xe);
            if (!n) return console.warn("Could not find a valid 'globalFilter' option."), o;
            u.forEach(function(e) {
                var t = e.disableGlobalFilter;
                e.canFilter = I(!0 !== t && void 0, !0 !== v && void 0, !0);
            });
            var l = u.filter(function(e) {
                return !0 === e.canFilter;
            });
            return [
                function o(r) {
                    return (r = n(r, l.map(function(e) {
                        return e.id;
                    }), d)).forEach(function(n) {
                        e.push(n), t[n.id] = n, n.subRows = n.subRows && n.subRows.length ? o(n.subRows) : n.subRows;
                    }), r;
                }(o),
                e,
                t
            ];
        }, [
            c,
            d,
            a,
            s,
            u,
            o,
            r,
            i,
            v
        ]), R = y[0], b = y[1], S = y[2], C = h(g);
        w(function() {
            C() && f({
                type: l.resetGlobalFilter
            });
        }, [
            f,
            c ? null : n
        ]), Object.assign(e, {
            preGlobalFilteredRows: o,
            preGlobalFilteredFlatRows: r,
            preGlobalFilteredRowsById: i,
            globalFilteredRows: R,
            globalFilteredFlatRows: b,
            globalFilteredRowsById: S,
            rows: R,
            flatRows: b,
            rowsById: S,
            setGlobalFilter: m,
            disableGlobalFilter: v
        });
    }
    function Ae(e, t) {
        return t.reduce(function(e, t) {
            return e + ("number" == typeof t ? t : 0);
        }, 0);
    }
    Ie.pluginName = "useGlobalFilter";
    var ke = Object.freeze({
        __proto__: null,
        sum: Ae,
        min: function(e) {
            var t = e[0] || 0;
            return e.forEach(function(e) {
                "number" == typeof e && (t = Math.min(t, e));
            }), t;
        },
        max: function(e) {
            var t = e[0] || 0;
            return e.forEach(function(e) {
                "number" == typeof e && (t = Math.max(t, e));
            }), t;
        },
        minMax: function(e) {
            var t = e[0] || 0, n = e[0] || 0;
            return e.forEach(function(e) {
                "number" == typeof e && (t = Math.min(t, e), n = Math.max(n, e));
            }), t + ".." + n;
        },
        average: function(e) {
            return Ae(0, e) / e.length;
        },
        median: function(e) {
            if (!e.length) return null;
            var t = Math.floor(e.length / 2), n = [].concat(e).sort(function(e, t) {
                return e - t;
            });
            return e.length % 2 != 0 ? n[t] : (n[t - 1] + n[t]) / 2;
        },
        unique: function(e) {
            return Array.from(new Set(e).values());
        },
        uniqueCount: function(e) {
            return new Set(e).size;
        },
        count: function(e) {
            return e.length;
        }
    }), He = [], Te = {};
    l.resetGroupBy = "resetGroupBy", l.setGroupBy = "setGroupBy", l.toggleGroupBy = "toggleGroupBy";
    var ze = function(e) {
        e.getGroupByToggleProps = [
            We
        ], e.stateReducers.push(Oe), e.visibleColumnsDeps.push(function(e, t) {
            var n = t.instance;
            return [].concat(e, [
                n.state.groupBy
            ]);
        }), e.visibleColumns.push(Me), e.useInstance.push(Ne), e.prepareRow.push(De);
    };
    ze.pluginName = "useGroupBy";
    var We = function(e, t) {
        var n = t.header;
        return [
            e,
            {
                onClick: n.canGroupBy ? function(e) {
                    e.persist(), n.toggleGroupBy();
                } : void 0,
                style: {
                    cursor: n.canGroupBy ? "pointer" : void 0
                },
                title: "Toggle GroupBy"
            }
        ];
    };
    function Oe(e, t, n, o) {
        if (t.type === l.init) return r({
            groupBy: []
        }, e);
        if (t.type === l.resetGroupBy) return r({}, e, {
            groupBy: o.initialState.groupBy || []
        });
        if (t.type === l.setGroupBy) return r({}, e, {
            groupBy: t.value
        });
        if (t.type === l.toggleGroupBy) {
            var i = t.columnId, u = t.value, s = void 0 !== u ? u : !e.groupBy.includes(i);
            return r({}, e, s ? {
                groupBy: [].concat(e.groupBy, [
                    i
                ])
            } : {
                groupBy: e.groupBy.filter(function(e) {
                    return e !== i;
                })
            });
        }
    }
    function Me(e, t) {
        var n = t.instance.state.groupBy, o = n.map(function(t) {
            return e.find(function(e) {
                return e.id === t;
            });
        }).filter(Boolean), r = e.filter(function(e) {
            return !n.includes(e.id);
        });
        return (e = [].concat(o, r)).forEach(function(e) {
            e.isGrouped = n.includes(e.id), e.groupedIndex = n.indexOf(e.id);
        }), e;
    }
    var je = {};
    function Ne(e) {
        var n = e.data, o = e.rows, r = e.flatRows, i = e.rowsById, u = e.allColumns, s = e.flatHeaders, a = e.groupByFn, c = void 0 === a ? Le : a, d = e.manualGroupBy, p = e.aggregations, g = void 0 === p ? je : p, m = e.plugins, y = e.state.groupBy, R = e.dispatch, b = e.autoResetGroupBy, S = void 0 === b || b, C = e.disableGroupBy, x = e.defaultCanGroupBy, P = e.getHooks;
        v(m, [
            "useColumnOrder",
            "useFilters"
        ], "useGroupBy");
        var B = h(e);
        u.forEach(function(t) {
            var n = t.accessor, o = t.defaultGroupBy, r = t.disableGroupBy;
            t.canGroupBy = n ? I(t.canGroupBy, !0 !== r && void 0, !0 !== C && void 0, !0) : I(t.canGroupBy, o, x, !1), t.canGroupBy && (t.toggleGroupBy = function() {
                return e.toggleGroupBy(t.id);
            }), t.Aggregated = t.Aggregated || t.Cell;
        });
        var E = t.useCallback(function(e, t) {
            R({
                type: l.toggleGroupBy,
                columnId: e,
                value: t
            });
        }, [
            R
        ]), F = t.useCallback(function(e) {
            R({
                type: l.setGroupBy,
                value: e
            });
        }, [
            R
        ]);
        s.forEach(function(e) {
            e.getGroupByToggleProps = f(P().getGroupByToggleProps, {
                instance: B(),
                header: e
            });
        });
        var A = t.useMemo(function() {
            if (d || !y.length) return [
                o,
                r,
                i,
                He,
                Te,
                r,
                i
            ];
            var e = y.filter(function(e) {
                return u.find(function(t) {
                    return t.id === e;
                });
            }), t = [], n = {}, l = [], s = {}, a = [], f = {}, p = function o(r, i, d) {
                if (void 0 === i && (i = 0), i === e.length) return r;
                var p = e[i], v = c(r, p);
                return Object.entries(v).map(function(r, c) {
                    var v = r[0], m = r[1], h = p + ":" + v, y = o(m, i + 1, h = d ? d + ">" + h : h), w = i ? G(m, "leafRows") : m, R = function(t, n, o) {
                        var r = {};
                        return u.forEach(function(i) {
                            if (e.includes(i.id)) r[i.id] = n[0] ? n[0].values[i.id] : null;
                            else {
                                var u = "function" == typeof i.aggregate ? i.aggregate : g[i.aggregate] || ke[i.aggregate];
                                if (u) {
                                    var l = n.map(function(e) {
                                        return e.values[i.id];
                                    }), s = t.map(function(e) {
                                        var t = e.values[i.id];
                                        if (!o && i.aggregateValue) {
                                            var n = "function" == typeof i.aggregateValue ? i.aggregateValue : g[i.aggregateValue] || ke[i.aggregateValue];
                                            if (!n) throw console.info({
                                                column: i
                                            }), new Error("React Table: Invalid column.aggregateValue option for column listed above");
                                            t = n(t, e, i);
                                        }
                                        return t;
                                    });
                                    r[i.id] = u(s, l);
                                } else {
                                    if (i.aggregate) throw console.info({
                                        column: i
                                    }), new Error("React Table: Invalid column.aggregate option for column listed above");
                                    r[i.id] = null;
                                }
                            }
                        }), r;
                    }(w, m, i), b = {
                        id: h,
                        isGrouped: !0,
                        groupByID: p,
                        groupByVal: v,
                        values: R,
                        subRows: y,
                        leafRows: w,
                        depth: i,
                        index: c
                    };
                    return y.forEach(function(e) {
                        t.push(e), n[e.id] = e, e.isGrouped ? (l.push(e), s[e.id] = e) : (a.push(e), f[e.id] = e);
                    }), b;
                });
            }(o);
            return p.forEach(function(e) {
                t.push(e), n[e.id] = e, e.isGrouped ? (l.push(e), s[e.id] = e) : (a.push(e), f[e.id] = e);
            }), [
                p,
                t,
                n,
                l,
                s,
                a,
                f
            ];
        }, [
            d,
            y,
            o,
            r,
            i,
            u,
            g,
            c
        ]), k = A[0], H = A[1], T = A[2], z = A[3], W = A[4], O = A[5], M = A[6], j = h(S);
        w(function() {
            j() && R({
                type: l.resetGroupBy
            });
        }, [
            R,
            d ? null : n
        ]), Object.assign(e, {
            preGroupedRows: o,
            preGroupedFlatRow: r,
            preGroupedRowsById: i,
            groupedRows: k,
            groupedFlatRows: H,
            groupedRowsById: T,
            onlyGroupedFlatRows: z,
            onlyGroupedRowsById: W,
            nonGroupedFlatRows: O,
            nonGroupedRowsById: M,
            rows: k,
            flatRows: H,
            rowsById: T,
            toggleGroupBy: E,
            setGroupBy: F
        });
    }
    function De(e) {
        e.allCells.forEach(function(t) {
            var n;
            t.isGrouped = t.column.isGrouped && t.column.id === e.groupByID, t.isPlaceholder = !t.isGrouped && t.column.isGrouped, t.isAggregated = !t.isGrouped && !t.isPlaceholder && (null == (n = e.subRows) ? void 0 : n.length);
        });
    }
    function Le(e, t) {
        return e.reduce(function(e, n, o) {
            var r = "" + n.values[t];
            return e[r] = Array.isArray(e[r]) ? e[r] : [], e[r].push(n), e;
        }, {});
    }
    var Ve = /([0-9]+)/gm;
    function _e(e, t) {
        return e === t ? 0 : e > t ? 1 : -1;
    }
    function Xe(e, t) {
        return e.values[t];
    }
    function qe(e) {
        return "number" == typeof e ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : "string" == typeof e ? e : "";
    }
    var Ke = Object.freeze({
        __proto__: null,
        alphanumeric: function(e, t, n) {
            var o = Xe(e, n), r = Xe(t, n);
            for(o = qe(o), r = qe(r), o = o.split(Ve).filter(Boolean), r = r.split(Ve).filter(Boolean); o.length && r.length;){
                var i = o.shift(), u = r.shift(), l = parseInt(i, 10), s = parseInt(u, 10), a = [
                    l,
                    s
                ].sort();
                if (isNaN(a[0])) {
                    if (i > u) return 1;
                    if (u > i) return -1;
                } else {
                    if (isNaN(a[1])) return isNaN(l) ? -1 : 1;
                    if (l > s) return 1;
                    if (s > l) return -1;
                }
            }
            return o.length - r.length;
        },
        datetime: function(e, t, n) {
            var o = Xe(e, n), r = Xe(t, n);
            return _e(o = o.getTime(), r = r.getTime());
        },
        basic: function(e, t, n) {
            return _e(Xe(e, n), Xe(t, n));
        }
    });
    l.resetSortBy = "resetSortBy", l.setSortBy = "setSortBy", l.toggleSortBy = "toggleSortBy", l.clearSortBy = "clearSortBy", c.sortType = "alphanumeric", c.sortDescFirst = !1;
    var Ue = function(e) {
        e.getSortByToggleProps = [
            $e
        ], e.stateReducers.push(Je), e.useInstance.push(Ye);
    };
    Ue.pluginName = "useSortBy";
    var $e = function(e, t) {
        var n = t.instance, o = t.column, r = n.isMultiSortEvent, i = void 0 === r ? function(e) {
            return e.shiftKey;
        } : r;
        return [
            e,
            {
                onClick: o.canSort ? function(e) {
                    e.persist(), o.toggleSortBy(void 0, !n.disableMultiSort && i(e));
                } : void 0,
                style: {
                    cursor: o.canSort ? "pointer" : void 0
                },
                title: o.canSort ? "Toggle SortBy" : void 0
            }
        ];
    };
    function Je(e, t, n, o) {
        if (t.type === l.init) return r({
            sortBy: []
        }, e);
        if (t.type === l.resetSortBy) return r({}, e, {
            sortBy: o.initialState.sortBy || []
        });
        if (t.type === l.clearSortBy) return r({}, e, {
            sortBy: e.sortBy.filter(function(e) {
                return e.id !== t.columnId;
            })
        });
        if (t.type === l.setSortBy) return r({}, e, {
            sortBy: t.sortBy
        });
        if (t.type === l.toggleSortBy) {
            var i, u = t.columnId, s = t.desc, a = t.multi, c = o.allColumns, d = o.disableMultiSort, f = o.disableSortRemove, p = o.disableMultiRemove, g = o.maxMultiSortColCount, v = void 0 === g ? Number.MAX_SAFE_INTEGER : g, m = e.sortBy, h = c.find(function(e) {
                return e.id === u;
            }).sortDescFirst, y = m.find(function(e) {
                return e.id === u;
            }), w = m.findIndex(function(e) {
                return e.id === u;
            }), R = null != s, b = [];
            return "toggle" !== (i = !d && a ? y ? "toggle" : "add" : w !== m.length - 1 || 1 !== m.length ? "replace" : y ? "toggle" : "replace") || f || R || a && p || !(y && y.desc && !h || !y.desc && h) || (i = "remove"), "replace" === i ? b = [
                {
                    id: u,
                    desc: R ? s : h
                }
            ] : "add" === i ? (b = [].concat(m, [
                {
                    id: u,
                    desc: R ? s : h
                }
            ])).splice(0, b.length - v) : "toggle" === i ? b = m.map(function(e) {
                return e.id === u ? r({}, e, {
                    desc: R ? s : !y.desc
                }) : e;
            }) : "remove" === i && (b = m.filter(function(e) {
                return e.id !== u;
            })), r({}, e, {
                sortBy: b
            });
        }
    }
    function Ye(e) {
        var n = e.data, o = e.rows, r = e.flatRows, i = e.allColumns, u = e.orderByFn, s = void 0 === u ? Qe : u, a = e.sortTypes, c = e.manualSortBy, d = e.defaultCanSort, p = e.disableSortBy, g = e.flatHeaders, m = e.state.sortBy, y = e.dispatch, R = e.plugins, b = e.getHooks, S = e.autoResetSortBy, C = void 0 === S || S;
        v(R, [
            "useFilters",
            "useGlobalFilter",
            "useGroupBy",
            "usePivotColumns"
        ], "useSortBy");
        var x = t.useCallback(function(e) {
            y({
                type: l.setSortBy,
                sortBy: e
            });
        }, [
            y
        ]), P = t.useCallback(function(e, t, n) {
            y({
                type: l.toggleSortBy,
                columnId: e,
                desc: t,
                multi: n
            });
        }, [
            y
        ]), B = h(e);
        g.forEach(function(e) {
            var t = e.accessor, n = e.canSort, o = e.disableSortBy, r = e.id, i = t ? I(!0 !== o && void 0, !0 !== p && void 0, !0) : I(d, n, !1);
            e.canSort = i, e.canSort && (e.toggleSortBy = function(t, n) {
                return P(e.id, t, n);
            }, e.clearSortBy = function() {
                y({
                    type: l.clearSortBy,
                    columnId: e.id
                });
            }), e.getSortByToggleProps = f(b().getSortByToggleProps, {
                instance: B(),
                column: e
            });
            var u = m.find(function(e) {
                return e.id === r;
            });
            e.isSorted = !!u, e.sortedIndex = m.findIndex(function(e) {
                return e.id === r;
            }), e.isSortedDesc = e.isSorted ? u.desc : void 0;
        });
        var E = t.useMemo(function() {
            if (c || !m.length) return [
                o,
                r
            ];
            var e = [], t = m.filter(function(e) {
                return i.find(function(t) {
                    return t.id === e.id;
                });
            });
            return [
                function n(o) {
                    var r = s(o, t.map(function(e) {
                        var t = i.find(function(t) {
                            return t.id === e.id;
                        });
                        if (!t) throw new Error("React-Table: Could not find a column with id: " + e.id + " while sorting");
                        var n = t.sortType, o = F(n) || (a || {})[n] || Ke[n];
                        if (!o) throw new Error("React-Table: Could not find a valid sortType of '" + n + "' for column '" + e.id + "'.");
                        return function(t, n) {
                            return o(t, n, e.id, e.desc);
                        };
                    }), t.map(function(e) {
                        var t = i.find(function(t) {
                            return t.id === e.id;
                        });
                        return t && t.sortInverted ? e.desc : !e.desc;
                    }));
                    return r.forEach(function(t) {
                        e.push(t), t.subRows && 0 !== t.subRows.length && (t.subRows = n(t.subRows));
                    }), r;
                }(o),
                e
            ];
        }, [
            c,
            m,
            o,
            r,
            i,
            s,
            a
        ]), G = E[0], A = E[1], k = h(C);
        w(function() {
            k() && y({
                type: l.resetSortBy
            });
        }, [
            c ? null : n
        ]), Object.assign(e, {
            preSortedRows: o,
            preSortedFlatRows: r,
            sortedRows: G,
            sortedFlatRows: A,
            rows: G,
            flatRows: A,
            setSortBy: x,
            toggleSortBy: P
        });
    }
    function Qe(e, t, n) {
        return [].concat(e).sort(function(e, o) {
            for(var r = 0; r < t.length; r += 1){
                var i = t[r], u = !1 === n[r] || "desc" === n[r], l = i(e, o);
                if (0 !== l) return u ? -l : l;
            }
            return n[0] ? e.index - o.index : o.index - e.index;
        });
    }
    l.resetPage = "resetPage", l.gotoPage = "gotoPage", l.setPageSize = "setPageSize";
    var Ze = function(e) {
        e.stateReducers.push(et), e.useInstance.push(tt);
    };
    function et(e, t, n, o) {
        if (t.type === l.init) return r({
            pageSize: 10,
            pageIndex: 0
        }, e);
        if (t.type === l.resetPage) return r({}, e, {
            pageIndex: o.initialState.pageIndex || 0
        });
        if (t.type === l.gotoPage) {
            var i = o.pageCount, u = o.page, s = m(t.pageIndex, e.pageIndex), a = !1;
            return s > e.pageIndex ? a = -1 === i ? u.length >= e.pageSize : s < i : s < e.pageIndex && (a = s > -1), a ? r({}, e, {
                pageIndex: s
            }) : e;
        }
        if (t.type === l.setPageSize) {
            var c = t.pageSize, d = e.pageSize * e.pageIndex;
            return r({}, e, {
                pageIndex: Math.floor(d / c),
                pageSize: c
            });
        }
    }
    function tt(e) {
        var n = e.rows, o = e.autoResetPage, r = void 0 === o || o, i = e.manualExpandedKey, u = void 0 === i ? "expanded" : i, s = e.plugins, a = e.pageCount, c = e.paginateExpandedRows, d = void 0 === c || c, f = e.expandSubRows, p = void 0 === f || f, g = e.state, m = g.pageSize, y = g.pageIndex, R = g.expanded, b = g.globalFilter, S = g.filters, C = g.groupBy, x = g.sortBy, P = e.dispatch, B = e.data, E = e.manualPagination;
        v(s, [
            "useGlobalFilter",
            "useFilters",
            "useGroupBy",
            "useSortBy",
            "useExpanded"
        ], "usePagination");
        var I = h(r);
        w(function() {
            I() && P({
                type: l.resetPage
            });
        }, [
            P,
            E ? null : B,
            b,
            S,
            C,
            x
        ]);
        var F = E ? a : Math.ceil(n.length / m), G = t.useMemo(function() {
            return F > 0 ? [].concat(new Array(F)).fill(null).map(function(e, t) {
                return t;
            }) : [];
        }, [
            F
        ]), k = t.useMemo(function() {
            var e;
            if (E) e = n;
            else {
                var t = m * y, o = t + m;
                e = n.slice(t, o);
            }
            return d ? e : A(e, {
                manualExpandedKey: u,
                expanded: R,
                expandSubRows: p
            });
        }, [
            p,
            R,
            u,
            E,
            y,
            m,
            d,
            n
        ]), H = y > 0, T = -1 === F ? k.length >= m : y < F - 1, z = t.useCallback(function(e) {
            P({
                type: l.gotoPage,
                pageIndex: e
            });
        }, [
            P
        ]), W = t.useCallback(function() {
            return z(function(e) {
                return e - 1;
            });
        }, [
            z
        ]), O = t.useCallback(function() {
            return z(function(e) {
                return e + 1;
            });
        }, [
            z
        ]), M = t.useCallback(function(e) {
            P({
                type: l.setPageSize,
                pageSize: e
            });
        }, [
            P
        ]);
        Object.assign(e, {
            pageOptions: G,
            pageCount: F,
            page: k,
            canPreviousPage: H,
            canNextPage: T,
            gotoPage: z,
            previousPage: W,
            nextPage: O,
            setPageSize: M
        });
    }
    Ze.pluginName = "usePagination", l.resetPivot = "resetPivot", l.togglePivot = "togglePivot";
    var nt = function(e) {
        e.getPivotToggleProps = [
            rt
        ], e.stateReducers.push(it), e.useInstanceAfterData.push(ut), e.allColumns.push(lt), e.accessValue.push(st), e.materializedColumns.push(at), e.materializedColumnsDeps.push(ct), e.visibleColumns.push(dt), e.visibleColumnsDeps.push(ft), e.useInstance.push(pt), e.prepareRow.push(gt);
    };
    nt.pluginName = "usePivotColumns";
    var ot = [], rt = function(e, t) {
        var n = t.header;
        return [
            e,
            {
                onClick: n.canPivot ? function(e) {
                    e.persist(), n.togglePivot();
                } : void 0,
                style: {
                    cursor: n.canPivot ? "pointer" : void 0
                },
                title: "Toggle Pivot"
            }
        ];
    };
    function it(e, t, n, o) {
        if (t.type === l.init) return r({
            pivotColumns: ot
        }, e);
        if (t.type === l.resetPivot) return r({}, e, {
            pivotColumns: o.initialState.pivotColumns || ot
        });
        if (t.type === l.togglePivot) {
            var i = t.columnId, u = t.value, s = void 0 !== u ? u : !e.pivotColumns.includes(i);
            return r({}, e, s ? {
                pivotColumns: [].concat(e.pivotColumns, [
                    i
                ])
            } : {
                pivotColumns: e.pivotColumns.filter(function(e) {
                    return e !== i;
                })
            });
        }
    }
    function ut(e) {
        e.allColumns.forEach(function(t) {
            t.isPivotSource = e.state.pivotColumns.includes(t.id);
        });
    }
    function lt(e, t) {
        var n = t.instance;
        return e.forEach(function(e) {
            e.isPivotSource = n.state.pivotColumns.includes(e.id), e.uniqueValues = new Set;
        }), e;
    }
    function st(e, t) {
        var n = t.column;
        return n.uniqueValues && void 0 !== e && n.uniqueValues.add(e), e;
    }
    function at(e, t) {
        var n = t.instance, o = n.allColumns, i = n.state;
        if (!i.pivotColumns.length || !i.groupBy || !i.groupBy.length) return e;
        var u = i.pivotColumns.map(function(e) {
            return o.find(function(t) {
                return t.id === e;
            });
        }).filter(Boolean), l = o.filter(function(e) {
            return !e.isPivotSource && !i.groupBy.includes(e.id) && !i.pivotColumns.includes(e.id);
        }), s = C(function e(t, n, o) {
            void 0 === t && (t = 0), void 0 === o && (o = []);
            var i = u[t];
            return i ? Array.from(i.uniqueValues).sort().map(function(u) {
                var l = r({}, i, {
                    Header: i.PivotHeader || "string" == typeof i.header ? i.Header + ": " + u : u,
                    isPivotGroup: !0,
                    parent: n,
                    depth: t,
                    id: n ? n.id + "." + i.id + "." + u : i.id + "." + u,
                    pivotValue: u
                });
                return l.columns = e(t + 1, l, [].concat(o, [
                    function(e) {
                        return e.values[i.id] === u;
                    }
                ])), l;
            }) : l.map(function(e) {
                return r({}, e, {
                    canPivot: !1,
                    isPivoted: !0,
                    parent: n,
                    depth: t,
                    id: "" + (n ? n.id + "." + e.id : e.id),
                    accessor: function(t, n, r) {
                        if (o.every(function(e) {
                            return e(r);
                        })) return r.values[e.id];
                    }
                });
            });
        }());
        return [].concat(e, s);
    }
    function ct(e, t) {
        var n = t.instance.state, o = n.pivotColumns, r = n.groupBy;
        return [].concat(e, [
            o,
            r
        ]);
    }
    function dt(e, t) {
        var n = t.instance.state;
        return e = e.filter(function(e) {
            return !e.isPivotSource;
        }), n.pivotColumns.length && n.groupBy && n.groupBy.length && (e = e.filter(function(e) {
            return e.isGrouped || e.isPivoted;
        })), e;
    }
    function ft(e, t) {
        var n = t.instance;
        return [].concat(e, [
            n.state.pivotColumns,
            n.state.groupBy
        ]);
    }
    function pt(e) {
        var t = e.columns, n = e.allColumns, o = e.flatHeaders, r = e.getHooks, i = e.plugins, u = e.dispatch, s = e.autoResetPivot, a = void 0 === s || s, c = e.manaulPivot, d = e.disablePivot, p = e.defaultCanPivot;
        v(i, [
            "useGroupBy"
        ], "usePivotColumns");
        var g = h(e);
        n.forEach(function(t) {
            var n = t.accessor, o = t.defaultPivot, r = t.disablePivot;
            t.canPivot = n ? I(t.canPivot, !0 !== r && void 0, !0 !== d && void 0, !0) : I(t.canPivot, o, p, !1), t.canPivot && (t.togglePivot = function() {
                return e.togglePivot(t.id);
            }), t.Aggregated = t.Aggregated || t.Cell;
        });
        o.forEach(function(e) {
            e.getPivotToggleProps = f(r().getPivotToggleProps, {
                instance: g(),
                header: e
            });
        });
        var m = h(a);
        w(function() {
            m() && u({
                type: l.resetPivot
            });
        }, [
            u,
            c ? null : t
        ]), Object.assign(e, {
            togglePivot: function(e, t) {
                u({
                    type: l.togglePivot,
                    columnId: e,
                    value: t
                });
            }
        });
    }
    function gt(e) {
        e.allCells.forEach(function(e) {
            e.isPivoted = e.column.isPivoted;
        });
    }
    l.resetSelectedRows = "resetSelectedRows", l.toggleAllRowsSelected = "toggleAllRowsSelected", l.toggleRowSelected = "toggleRowSelected", l.toggleAllPageRowsSelected = "toggleAllPageRowsSelected";
    var vt = function(e) {
        e.getToggleRowSelectedProps = [
            mt
        ], e.getToggleAllRowsSelectedProps = [
            ht
        ], e.getToggleAllPageRowsSelectedProps = [
            yt
        ], e.stateReducers.push(wt), e.useInstance.push(Rt), e.prepareRow.push(bt);
    };
    vt.pluginName = "useRowSelect";
    var mt = function(e, t) {
        var n = t.instance, o = t.row, r = n.manualRowSelectedKey, i = void 0 === r ? "isSelected" : r;
        return [
            e,
            {
                onChange: function(e) {
                    o.toggleRowSelected(e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: !(!o.original || !o.original[i]) || o.isSelected,
                title: "Toggle Row Selected",
                indeterminate: o.isSomeSelected
            }
        ];
    }, ht = function(e, t) {
        var n = t.instance;
        return [
            e,
            {
                onChange: function(e) {
                    n.toggleAllRowsSelected(e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: n.isAllRowsSelected,
                title: "Toggle All Rows Selected",
                indeterminate: Boolean(!n.isAllRowsSelected && Object.keys(n.state.selectedRowIds).length)
            }
        ];
    }, yt = function(e, t) {
        var n = t.instance;
        return [
            e,
            {
                onChange: function(e) {
                    n.toggleAllPageRowsSelected(e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: n.isAllPageRowsSelected,
                title: "Toggle All Current Page Rows Selected",
                indeterminate: Boolean(!n.isAllPageRowsSelected && n.page.some(function(e) {
                    var t = e.id;
                    return n.state.selectedRowIds[t];
                }))
            }
        ];
    };
    function wt(e, t, n, o) {
        if (t.type === l.init) return r({
            selectedRowIds: {}
        }, e);
        if (t.type === l.resetSelectedRows) return r({}, e, {
            selectedRowIds: o.initialState.selectedRowIds || {}
        });
        if (t.type === l.toggleAllRowsSelected) {
            var i = t.value, u = o.isAllRowsSelected, s = o.rowsById, a = o.nonGroupedRowsById, c = void 0 === a ? s : a, d = void 0 !== i ? i : !u, f = Object.assign({}, e.selectedRowIds);
            return d ? Object.keys(c).forEach(function(e) {
                f[e] = !0;
            }) : Object.keys(c).forEach(function(e) {
                delete f[e];
            }), r({}, e, {
                selectedRowIds: f
            });
        }
        if (t.type === l.toggleRowSelected) {
            var p = t.id, g = t.value, v = o.rowsById, m = o.selectSubRows, h = void 0 === m || m, y = o.getSubRows, w = e.selectedRowIds[p], R = void 0 !== g ? g : !w;
            if (w === R) return e;
            var b = r({}, e.selectedRowIds);
            return function e(t) {
                var n = v[t];
                if (n.isGrouped || (R ? b[t] = !0 : delete b[t]), h && y(n)) return y(n).forEach(function(t) {
                    return e(t.id);
                });
            }(p), r({}, e, {
                selectedRowIds: b
            });
        }
        if (t.type === l.toggleAllPageRowsSelected) {
            var S = t.value, C = o.page, x = o.rowsById, P = o.selectSubRows, B = void 0 === P || P, E = o.isAllPageRowsSelected, I = o.getSubRows, F = void 0 !== S ? S : !E, G = r({}, e.selectedRowIds);
            return C.forEach(function(e) {
                return function e(t) {
                    var n = x[t];
                    if (n.isGrouped || (F ? G[t] = !0 : delete G[t]), B && I(n)) return I(n).forEach(function(t) {
                        return e(t.id);
                    });
                }(e.id);
            }), r({}, e, {
                selectedRowIds: G
            });
        }
        return e;
    }
    function Rt(e) {
        var n = e.data, o = e.rows, r = e.getHooks, i = e.plugins, u = e.rowsById, s = e.nonGroupedRowsById, a = void 0 === s ? u : s, c = e.autoResetSelectedRows, d = void 0 === c || c, p = e.state.selectedRowIds, g = e.selectSubRows, m = void 0 === g || g, y = e.dispatch, R = e.page, b = e.getSubRows;
        v(i, [
            "useFilters",
            "useGroupBy",
            "useSortBy",
            "useExpanded",
            "usePagination"
        ], "useRowSelect");
        var S = t.useMemo(function() {
            var e = [];
            return o.forEach(function(t) {
                var n = m ? function e(t, n, o) {
                    if (n[t.id]) return !0;
                    var r = o(t);
                    if (r && r.length) {
                        var i = !0, u = !1;
                        return r.forEach(function(t) {
                            u && !i || (e(t, n, o) ? u = !0 : i = !1);
                        }), !!i || !!u && null;
                    }
                    return !1;
                }(t, p, b) : !!p[t.id];
                t.isSelected = !!n, t.isSomeSelected = null === n, n && e.push(t);
            }), e;
        }, [
            o,
            m,
            p,
            b
        ]), C = Boolean(Object.keys(a).length && Object.keys(p).length), x = C;
        C && Object.keys(a).some(function(e) {
            return !p[e];
        }) && (C = !1), C || R && R.length && R.some(function(e) {
            var t = e.id;
            return !p[t];
        }) && (x = !1);
        var P = h(d);
        w(function() {
            P() && y({
                type: l.resetSelectedRows
            });
        }, [
            y,
            n
        ]);
        var B = t.useCallback(function(e) {
            return y({
                type: l.toggleAllRowsSelected,
                value: e
            });
        }, [
            y
        ]), E = t.useCallback(function(e) {
            return y({
                type: l.toggleAllPageRowsSelected,
                value: e
            });
        }, [
            y
        ]), I = t.useCallback(function(e, t) {
            return y({
                type: l.toggleRowSelected,
                id: e,
                value: t
            });
        }, [
            y
        ]), F = h(e), G = f(r().getToggleAllRowsSelectedProps, {
            instance: F()
        }), A = f(r().getToggleAllPageRowsSelectedProps, {
            instance: F()
        });
        Object.assign(e, {
            selectedFlatRows: S,
            isAllRowsSelected: C,
            isAllPageRowsSelected: x,
            toggleRowSelected: I,
            toggleAllRowsSelected: B,
            getToggleAllRowsSelectedProps: G,
            getToggleAllPageRowsSelectedProps: A,
            toggleAllPageRowsSelected: E
        });
    }
    function bt(e, t) {
        var n = t.instance;
        e.toggleRowSelected = function(t) {
            return n.toggleRowSelected(e.id, t);
        }, e.getToggleRowSelectedProps = f(n.getHooks().getToggleRowSelectedProps, {
            instance: n,
            row: e
        });
    }
    var St = function(e) {
        return {};
    }, Ct = function(e) {
        return {};
    };
    l.setRowState = "setRowState", l.setCellState = "setCellState", l.resetRowState = "resetRowState";
    var xt = function(e) {
        e.stateReducers.push(Pt), e.useInstance.push(Bt), e.prepareRow.push(Et);
    };
    function Pt(e, t, n, o) {
        var i = o.initialRowStateAccessor, u = void 0 === i ? St : i, s = o.initialCellStateAccessor, a = void 0 === s ? Ct : s, c = o.rowsById;
        if (t.type === l.init) return r({
            rowState: {}
        }, e);
        if (t.type === l.resetRowState) return r({}, e, {
            rowState: o.initialState.rowState || {}
        });
        if (t.type === l.setRowState) {
            var d, f = t.rowId, p = t.value, g = void 0 !== e.rowState[f] ? e.rowState[f] : u(c[f]);
            return r({}, e, {
                rowState: r({}, e.rowState, (d = {}, d[f] = m(p, g), d))
            });
        }
        if (t.type === l.setCellState) {
            var v, h, y, w, R, b = t.rowId, S = t.columnId, C = t.value, x = void 0 !== e.rowState[b] ? e.rowState[b] : u(c[b]), P = void 0 !== (null == x ? void 0 : null == (v = x.cellState) ? void 0 : v[S]) ? x.cellState[S] : a(null == (h = c[b]) ? void 0 : null == (y = h.cells) ? void 0 : y.find(function(e) {
                return e.column.id === S;
            }));
            return r({}, e, {
                rowState: r({}, e.rowState, (R = {}, R[b] = r({}, x, {
                    cellState: r({}, x.cellState || {}, (w = {}, w[S] = m(C, P), w))
                }), R))
            });
        }
    }
    function Bt(e) {
        var n = e.autoResetRowState, o = void 0 === n || n, r = e.data, i = e.dispatch, u = t.useCallback(function(e, t) {
            return i({
                type: l.setRowState,
                rowId: e,
                value: t
            });
        }, [
            i
        ]), s = t.useCallback(function(e, t, n) {
            return i({
                type: l.setCellState,
                rowId: e,
                columnId: t,
                value: n
            });
        }, [
            i
        ]), a = h(o);
        w(function() {
            a() && i({
                type: l.resetRowState
            });
        }, [
            r
        ]), Object.assign(e, {
            setRowState: u,
            setCellState: s
        });
    }
    function Et(e, t) {
        var n = t.instance, o = n.initialRowStateAccessor, r = void 0 === o ? St : o, i = n.initialCellStateAccessor, u = void 0 === i ? Ct : i, l = n.state.rowState;
        e && (e.state = void 0 !== l[e.id] ? l[e.id] : r(e), e.setState = function(t) {
            return n.setRowState(e.id, t);
        }, e.cells.forEach(function(t) {
            e.state.cellState || (e.state.cellState = {}), t.state = void 0 !== e.state.cellState[t.column.id] ? e.state.cellState[t.column.id] : u(t), t.setState = function(o) {
                return n.setCellState(e.id, t.column.id, o);
            };
        }));
    }
    xt.pluginName = "useRowState", l.resetColumnOrder = "resetColumnOrder", l.setColumnOrder = "setColumnOrder";
    var It = function(e) {
        e.stateReducers.push(Ft), e.visibleColumnsDeps.push(function(e, t) {
            var n = t.instance;
            return [].concat(e, [
                n.state.columnOrder
            ]);
        }), e.visibleColumns.push(Gt), e.useInstance.push(At);
    };
    function Ft(e, t, n, o) {
        return t.type === l.init ? r({
            columnOrder: []
        }, e) : t.type === l.resetColumnOrder ? r({}, e, {
            columnOrder: o.initialState.columnOrder || []
        }) : t.type === l.setColumnOrder ? r({}, e, {
            columnOrder: m(t.columnOrder, e.columnOrder)
        }) : void 0;
    }
    function Gt(e, t) {
        var n = t.instance.state.columnOrder;
        if (!n || !n.length) return e;
        for(var o = [].concat(n), r = [].concat(e), i = [], u = function() {
            var e = o.shift(), t = r.findIndex(function(t) {
                return t.id === e;
            });
            t > -1 && i.push(r.splice(t, 1)[0]);
        }; r.length && o.length;)u();
        return [].concat(i, r);
    }
    function At(e) {
        var n = e.dispatch;
        e.setColumnOrder = t.useCallback(function(e) {
            return n({
                type: l.setColumnOrder,
                columnOrder: e
            });
        }, [
            n
        ]);
    }
    It.pluginName = "useColumnOrder", c.canResize = !0, l.columnStartResizing = "columnStartResizing", l.columnResizing = "columnResizing", l.columnDoneResizing = "columnDoneResizing", l.resetResize = "resetResize";
    var kt = function(e) {
        e.getResizerProps = [
            Ht
        ], e.getHeaderProps.push({
            style: {
                position: "relative"
            }
        }), e.stateReducers.push(Tt), e.useInstance.push(Wt), e.useInstanceBeforeDimensions.push(zt);
    }, Ht = function(e, t) {
        var n = t.instance, o = t.header, r = n.dispatch, i = function(e, t) {
            var n = !1;
            if ("touchstart" === e.type) {
                if (e.touches && e.touches.length > 1) return;
                n = !0;
            }
            var o = (function(e) {
                var t = [];
                return function e(n) {
                    n.columns && n.columns.length && n.columns.map(e);
                    t.push(n);
                }(e), t;
            })(t).map(function(e) {
                return [
                    e.id,
                    e.totalWidth
                ];
            }), i = n ? Math.round(e.touches[0].clientX) : e.clientX, u = function(e) {
                r({
                    type: l.columnResizing,
                    clientX: e
                });
            }, s = function() {
                return r({
                    type: l.columnDoneResizing
                });
            }, a = {
                mouse: {
                    moveEvent: "mousemove",
                    moveHandler: function(e) {
                        return u(e.clientX);
                    },
                    upEvent: "mouseup",
                    upHandler: function(e) {
                        document.removeEventListener("mousemove", a.mouse.moveHandler), document.removeEventListener("mouseup", a.mouse.upHandler), s();
                    }
                },
                touch: {
                    moveEvent: "touchmove",
                    moveHandler: function(e) {
                        return e.cancelable && (e.preventDefault(), e.stopPropagation()), u(e.touches[0].clientX), !1;
                    },
                    upEvent: "touchend",
                    upHandler: function(e) {
                        document.removeEventListener(a.touch.moveEvent, a.touch.moveHandler), document.removeEventListener(a.touch.upEvent, a.touch.moveHandler), s();
                    }
                }
            }, c = n ? a.touch : a.mouse, d = !!function() {
                if ("boolean" == typeof z) return z;
                var e = !1;
                try {
                    var t = {
                        get passive () {
                            return e = !0, !1;
                        }
                    };
                    window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
                } catch (t) {
                    e = !1;
                }
                return z = e;
            }() && {
                passive: !1
            };
            document.addEventListener(c.moveEvent, c.moveHandler, d), document.addEventListener(c.upEvent, c.upHandler, d), r({
                type: l.columnStartResizing,
                columnId: t.id,
                columnWidth: t.totalWidth,
                headerIdWidths: o,
                clientX: i
            });
        };
        return [
            e,
            {
                onMouseDown: function(e) {
                    return e.persist() || i(e, o);
                },
                onTouchStart: function(e) {
                    return e.persist() || i(e, o);
                },
                style: {
                    cursor: "col-resize"
                },
                draggable: !1,
                role: "separator"
            }
        ];
    };
    function Tt(e, t) {
        if (t.type === l.init) return r({
            columnResizing: {
                columnWidths: {}
            }
        }, e);
        if (t.type === l.resetResize) return r({}, e, {
            columnResizing: {
                columnWidths: {}
            }
        });
        if (t.type === l.columnStartResizing) {
            var n = t.clientX, o = t.columnId, i = t.columnWidth, u = t.headerIdWidths;
            return r({}, e, {
                columnResizing: r({}, e.columnResizing, {
                    startX: n,
                    headerIdWidths: u,
                    columnWidth: i,
                    isResizingColumn: o
                })
            });
        }
        if (t.type === l.columnResizing) {
            var s = t.clientX, a = e.columnResizing, c = a.startX, d = a.columnWidth, f = a.headerIdWidths, p = (s - c) / d, g = {};
            return (void 0 === f ? [] : f).forEach(function(e) {
                var t = e[0], n = e[1];
                g[t] = Math.max(n + n * p, 0);
            }), r({}, e, {
                columnResizing: r({}, e.columnResizing, {
                    columnWidths: r({}, e.columnResizing.columnWidths, {}, g)
                })
            });
        }
        return t.type === l.columnDoneResizing ? r({}, e, {
            columnResizing: r({}, e.columnResizing, {
                startX: null,
                isResizingColumn: null
            })
        }) : void 0;
    }
    kt.pluginName = "useResizeColumns";
    var zt = function(e) {
        var t = e.flatHeaders, n = e.disableResizing, o = e.getHooks, r = e.state.columnResizing, i = h(e);
        t.forEach(function(e) {
            var t = I(!0 !== e.disableResizing && void 0, !0 !== n && void 0, !0);
            e.canResize = t, e.width = r.columnWidths[e.id] || e.originalWidth || e.width, e.isResizing = r.isResizingColumn === e.id, t && (e.getResizerProps = f(o().getResizerProps, {
                instance: i(),
                header: e
            }));
        });
    };
    function Wt(e) {
        var n = e.plugins, o = e.dispatch, r = e.autoResetResize, i = void 0 === r || r, u = e.columns;
        v(n, [
            "useAbsoluteLayout"
        ], "useResizeColumns");
        var s = h(i);
        w(function() {
            s() && o({
                type: l.resetResize
            });
        }, [
            u
        ]);
        var a = t.useCallback(function() {
            return o({
                type: l.resetResize
            });
        }, [
            o
        ]);
        Object.assign(e, {
            resetResizing: a
        });
    }
    var Ot = {
        position: "absolute",
        top: 0
    }, Mt = function(e) {
        e.getTableBodyProps.push(jt), e.getRowProps.push(jt), e.getHeaderGroupProps.push(jt), e.getFooterGroupProps.push(jt), e.getHeaderProps.push(function(e, t) {
            var n = t.column;
            return [
                e,
                {
                    style: r({}, Ot, {
                        left: n.totalLeft + "px",
                        width: n.totalWidth + "px"
                    })
                }
            ];
        }), e.getCellProps.push(function(e, t) {
            var n = t.cell;
            return [
                e,
                {
                    style: r({}, Ot, {
                        left: n.column.totalLeft + "px",
                        width: n.column.totalWidth + "px"
                    })
                }
            ];
        }), e.getFooterProps.push(function(e, t) {
            var n = t.column;
            return [
                e,
                {
                    style: r({}, Ot, {
                        left: n.totalLeft + "px",
                        width: n.totalWidth + "px"
                    })
                }
            ];
        });
    };
    Mt.pluginName = "useAbsoluteLayout";
    var jt = function(e, t) {
        return [
            e,
            {
                style: {
                    position: "relative",
                    width: t.instance.totalColumnsWidth + "px"
                }
            }
        ];
    }, Nt = {
        display: "inline-block",
        boxSizing: "border-box"
    }, Dt = function(e, t) {
        return [
            e,
            {
                style: {
                    display: "flex",
                    width: t.instance.totalColumnsWidth + "px"
                }
            }
        ];
    }, Lt = function(e) {
        e.getRowProps.push(Dt), e.getHeaderGroupProps.push(Dt), e.getFooterGroupProps.push(Dt), e.getHeaderProps.push(function(e, t) {
            var n = t.column;
            return [
                e,
                {
                    style: r({}, Nt, {
                        width: n.totalWidth + "px"
                    })
                }
            ];
        }), e.getCellProps.push(function(e, t) {
            var n = t.cell;
            return [
                e,
                {
                    style: r({}, Nt, {
                        width: n.column.totalWidth + "px"
                    })
                }
            ];
        }), e.getFooterProps.push(function(e, t) {
            var n = t.column;
            return [
                e,
                {
                    style: r({}, Nt, {
                        width: n.totalWidth + "px"
                    })
                }
            ];
        });
    };
    function Vt(e) {
        e.getTableProps.push(_t), e.getRowProps.push(Xt), e.getHeaderGroupProps.push(Xt), e.getFooterGroupProps.push(Xt), e.getHeaderProps.push(qt), e.getCellProps.push(Kt), e.getFooterProps.push(Ut);
    }
    Lt.pluginName = "useBlockLayout", Vt.pluginName = "useFlexLayout";
    var _t = function(e, t) {
        return [
            e,
            {
                style: {
                    minWidth: t.instance.totalColumnsMinWidth + "px"
                }
            }
        ];
    }, Xt = function(e, t) {
        return [
            e,
            {
                style: {
                    display: "flex",
                    flex: "1 0 auto",
                    minWidth: t.instance.totalColumnsMinWidth + "px"
                }
            }
        ];
    }, qt = function(e, t) {
        var n = t.column;
        return [
            e,
            {
                style: {
                    boxSizing: "border-box",
                    flex: n.totalFlexWidth ? n.totalFlexWidth + " 0 auto" : void 0,
                    minWidth: n.totalMinWidth + "px",
                    width: n.totalWidth + "px"
                }
            }
        ];
    }, Kt = function(e, t) {
        var n = t.cell;
        return [
            e,
            {
                style: {
                    boxSizing: "border-box",
                    flex: n.column.totalFlexWidth + " 0 auto",
                    minWidth: n.column.totalMinWidth + "px",
                    width: n.column.totalWidth + "px"
                }
            }
        ];
    }, Ut = function(e, t) {
        var n = t.column;
        return [
            e,
            {
                style: {
                    boxSizing: "border-box",
                    flex: n.totalFlexWidth ? n.totalFlexWidth + " 0 auto" : void 0,
                    minWidth: n.totalMinWidth + "px",
                    width: n.totalWidth + "px"
                }
            }
        ];
    };
    function $t(e) {
        e.stateReducers.push(Qt), e.getTableProps.push(Jt), e.getHeaderProps.push(Yt);
    }
    $t.pluginName = "useGridLayout";
    var Jt = function(e, t) {
        return [
            e,
            {
                style: {
                    display: "grid",
                    gridTemplateColumns: t.instance.state.gridLayout.columnWidths.map(function(e) {
                        return e;
                    }).join(" ")
                }
            }
        ];
    }, Yt = function(e, t) {
        return [
            e,
            {
                id: "header-cell-" + t.column.id,
                style: {
                    position: "sticky"
                }
            }
        ];
    };
    function Qt(e, t, n, o) {
        if ("init" === t.type) return r({
            gridLayout: {
                columnWidths: o.columns.map(function() {
                    return "auto";
                })
            }
        }, e);
        if ("columnStartResizing" === t.type) {
            var i = t.columnId, u = o.visibleColumns.findIndex(function(e) {
                return e.id === i;
            }), l = function(e) {
                var t, n = null == (t = document.getElementById("header-cell-" + e)) ? void 0 : t.offsetWidth;
                if (void 0 !== n) return n;
            }(i);
            return void 0 !== l ? r({}, e, {
                gridLayout: r({}, e.gridLayout, {
                    columnId: i,
                    columnIndex: u,
                    startingWidth: l
                })
            }) : e;
        }
        if ("columnResizing" === t.type) {
            var s = e.gridLayout, a = s.columnIndex, c = s.startingWidth, d = s.columnWidths, f = c - (e.columnResizing.startX - t.clientX), p = [].concat(d);
            return p[a] = f + "px", r({}, e, {
                gridLayout: r({}, e.gridLayout, {
                    columnWidths: p
                })
            });
        }
    }
    e._UNSTABLE_usePivotColumns = nt, e.actions = l, e.defaultColumn = c, e.defaultGroupByFn = Le, e.defaultOrderByFn = Qe, e.defaultRenderer = s, e.emptyRenderer = a, e.ensurePluginOrder = v, e.flexRender = b, e.functionalUpdate = m, e.loopHooks = g, e.makePropGetter = f, e.makeRenderer = R, e.reduceHooks = p, e.safeUseLayoutEffect = y, e.useAbsoluteLayout = Mt, e.useAsyncDebounce = function(e, n) {
        void 0 === n && (n = 0);
        var r = t.useRef({}), i = h(e), u = h(n);
        return t.useCallback(function() {
            var e = o(regeneratorRuntime.mark(function e() {
                var t, n, l, s = arguments;
                return regeneratorRuntime.wrap(function(e) {
                    for(;;)switch(e.prev = e.next){
                        case 0:
                            for(t = s.length, n = new Array(t), l = 0; l < t; l++)n[l] = s[l];
                            return r.current.promise || (r.current.promise = new Promise(function(e, t) {
                                r.current.resolve = e, r.current.reject = t;
                            })), r.current.timeout && clearTimeout(r.current.timeout), r.current.timeout = setTimeout(o(regeneratorRuntime.mark(function e() {
                                return regeneratorRuntime.wrap(function(e) {
                                    for(;;)switch(e.prev = e.next){
                                        case 0:
                                            return delete r.current.timeout, e.prev = 1, e.t0 = r.current, e.next = 5, i().apply(void 0, n);
                                        case 5:
                                            e.t1 = e.sent, e.t0.resolve.call(e.t0, e.t1), e.next = 12;
                                            break;
                                        case 9:
                                            e.prev = 9, e.t2 = e.catch(1), r.current.reject(e.t2);
                                        case 12:
                                            return e.prev = 12, delete r.current.promise, e.finish(12);
                                        case 15:
                                        case "end":
                                            return e.stop();
                                    }
                                }, e, null, [
                                    [
                                        1,
                                        9,
                                        12,
                                        15
                                    ]
                                ]);
                            })), u()), e.abrupt("return", r.current.promise);
                        case 5:
                        case "end":
                            return e.stop();
                    }
                }, e);
            }));
            return function() {
                return e.apply(this, arguments);
            };
        }(), [
            i,
            u
        ]);
    }, e.useBlockLayout = Lt, e.useColumnOrder = It, e.useExpanded = se, e.useFilters = Pe, e.useFlexLayout = Vt, e.useGetLatest = h, e.useGlobalFilter = Ie, e.useGridLayout = $t, e.useGroupBy = ze, e.useMountedLayoutEffect = w, e.usePagination = Ze, e.useResizeColumns = kt, e.useRowSelect = vt, e.useRowState = xt, e.useSortBy = Ue, e.useTable = function(e) {
        for(var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)o[i - 1] = arguments[i];
        e = ie(e), o = [
            K
        ].concat(o);
        var u = t.useRef({}), s = h(u.current);
        Object.assign(s(), r({}, e, {
            plugins: o,
            hooks: q()
        })), o.filter(Boolean).forEach(function(e) {
            e(s().hooks);
        });
        var a = h(s().hooks);
        s().getHooks = a, delete s().hooks, Object.assign(s(), p(a().useOptions, ie(e)));
        var c = s(), d = c.data, v = c.columns, m = c.initialState, y = c.defaultColumn, w = c.getSubRows, b = c.getRowId, E = c.stateReducer, I = c.useControlledState, F = h(E), G = t.useCallback(function(e, t) {
            if (!t.type) throw console.info({
                action: t
            }), new Error("Unknown Action \uD83D\uDC46");
            return [].concat(a().stateReducers, Array.isArray(F()) ? F() : [
                F()
            ]).reduce(function(n, o) {
                return o(n, t, e, s()) || n;
            }, e);
        }, [
            a,
            F,
            s
        ]), A = t.useReducer(G, void 0, function() {
            return G(m, {
                type: l.init
            });
        }), k = A[0], H = A[1], T = p([].concat(a().useControlledState, [
            I
        ]), k, {
            instance: s()
        });
        Object.assign(s(), {
            state: T,
            dispatch: H
        });
        var z = t.useMemo(function() {
            return S(p(a().columns, v, {
                instance: s()
            }));
        }, [
            a,
            s,
            v
        ].concat(p(a().columnsDeps, [], {
            instance: s()
        })));
        s().columns = z;
        var W = t.useMemo(function() {
            return p(a().allColumns, C(z), {
                instance: s()
            }).map(x);
        }, [
            z,
            a,
            s
        ].concat(p(a().allColumnsDeps, [], {
            instance: s()
        })));
        s().allColumns = W;
        var O = t.useMemo(function() {
            for(var e = [], t = [], n = {}, o = [].concat(W); o.length;){
                var r = o.shift();
                le({
                    data: d,
                    rows: e,
                    flatRows: t,
                    rowsById: n,
                    column: r,
                    getRowId: b,
                    getSubRows: w,
                    accessValueHooks: a().accessValue,
                    getInstance: s
                });
            }
            return [
                e,
                t,
                n
            ];
        }, [
            W,
            d,
            b,
            w,
            a,
            s
        ]), M = O[0], j = O[1], N = O[2];
        Object.assign(s(), {
            rows: M,
            initialRows: [].concat(M),
            flatRows: j,
            rowsById: N
        }), g(a().useInstanceAfterData, s());
        var D = t.useMemo(function() {
            return p(a().visibleColumns, W, {
                instance: s()
            }).map(function(e) {
                return P(e, y);
            });
        }, [
            a,
            W,
            s,
            y
        ].concat(p(a().visibleColumnsDeps, [], {
            instance: s()
        })));
        W = t.useMemo(function() {
            var e = [].concat(D);
            return W.forEach(function(t) {
                e.find(function(e) {
                    return e.id === t.id;
                }) || e.push(t);
            }), e;
        }, [
            W,
            D
        ]), s().allColumns = W;
        var L = t.useMemo(function() {
            return p(a().headerGroups, B(D, y), s());
        }, [
            a,
            D,
            y,
            s
        ].concat(p(a().headerGroupsDeps, [], {
            instance: s()
        })));
        s().headerGroups = L;
        var V = t.useMemo(function() {
            return L.length ? L[0].headers : [];
        }, [
            L
        ]);
        s().headers = V, s().flatHeaders = L.reduce(function(e, t) {
            return [].concat(e, t.headers);
        }, []), g(a().useInstanceBeforeDimensions, s());
        var _ = D.filter(function(e) {
            return e.isVisible;
        }).map(function(e) {
            return e.id;
        }).sort().join("_");
        D = t.useMemo(function() {
            return D.filter(function(e) {
                return e.isVisible;
            });
        }, [
            D,
            _
        ]), s().visibleColumns = D;
        var X = ue(V), U = X[0], $ = X[1], J = X[2];
        return s().totalColumnsMinWidth = U, s().totalColumnsWidth = $, s().totalColumnsMaxWidth = J, g(a().useInstance, s()), [].concat(s().flatHeaders, s().allColumns).forEach(function(e) {
            e.render = R(s(), e), e.getHeaderProps = f(a().getHeaderProps, {
                instance: s(),
                column: e
            }), e.getFooterProps = f(a().getFooterProps, {
                instance: s(),
                column: e
            });
        }), s().headerGroups = t.useMemo(function() {
            return L.filter(function(e, t) {
                return e.headers = e.headers.filter(function(e) {
                    return e.headers ? function e(t) {
                        return t.filter(function(t) {
                            return t.headers ? e(t.headers) : t.isVisible;
                        }).length;
                    }(e.headers) : e.isVisible;
                }), !!e.headers.length && (e.getHeaderGroupProps = f(a().getHeaderGroupProps, {
                    instance: s(),
                    headerGroup: e,
                    index: t
                }), e.getFooterGroupProps = f(a().getFooterGroupProps, {
                    instance: s(),
                    headerGroup: e,
                    index: t
                }), !0);
            });
        }, [
            L,
            s,
            a
        ]), s().footerGroups = [].concat(s().headerGroups).reverse(), s().prepareRow = t.useCallback(function(e) {
            e.getRowProps = f(a().getRowProps, {
                instance: s(),
                row: e
            }), e.allCells = W.map(function(t) {
                var n = e.values[t.id], o = {
                    column: t,
                    row: e,
                    value: n
                };
                return o.getCellProps = f(a().getCellProps, {
                    instance: s(),
                    cell: o
                }), o.render = R(s(), t, {
                    row: e,
                    cell: o,
                    value: n
                }), o;
            }), e.cells = D.map(function(t) {
                return e.allCells.find(function(e) {
                    return e.column.id === t.id;
                });
            }), g(a().prepareRow, e, {
                instance: s()
            });
        }, [
            a,
            s,
            W,
            D
        ]), s().getTableProps = f(a().getTableProps, {
            instance: s()
        }), s().getTableBodyProps = f(a().getTableBodyProps, {
            instance: s()
        }), g(a().useFinalInstance, s()), s();
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

});

parcelRegister("1zQD3", function(module, exports) {

$parcel$export(module.exports, "Reset", function () { return $1261e25051565fce$export$fcc683c36751f67a; });

var $df8fE = parcelRequire("df8fE");

var $a5EUy = parcelRequire("a5EUy");

var $glEgb = parcelRequire("glEgb");
parcelRequire("2UBc8");
var $byqzn = parcelRequire("byqzn");

var $cPiPb = parcelRequire("cPiPb");

var $302dL = parcelRequire("302dL");

var $oMBXq = parcelRequire("oMBXq");

var $dSPjH = parcelRequire("dSPjH");
const $1261e25051565fce$export$fcc683c36751f67a = ()=>{
    const { year: year } = (0, $glEgb.useParams)();
    const { staticUserVariables: staticUserVariables, handleSelectedCustomerUpdate: handleSelectedCustomerUpdate } = (0, $dSPjH.useUser)();
    const [resetData, { error: resetError }] = (0, $byqzn.useMutation)((0, $oMBXq.RESET), {
        onCompleted: handleResetDataResponse
    });
    function handleResetDataResponse(response) {
        if (response.reset) handleSelectedCustomerUpdate({
            id: null
        });
    }
    (0, $a5EUy.useEffect)(()=>{
        async function initiateReset() {
            try {
                await resetData({
                    variables: staticUserVariables({
                        year: year
                    })
                });
            } catch (error) {
                console.error(error);
            }
        }
        initiateReset();
    }, [
        year,
        resetData,
        staticUserVariables
    ]);
    if (resetError) return /*#__PURE__*/ (0, $df8fE.jsx)("div", {
        children: "Error: Reset failed!"
    });
    return /*#__PURE__*/ (0, $df8fE.jsx)((0, $cPiPb.OverlayPortal), {
        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $302dL.Spinner), {})
    });
};

});
parcelRegister("df8fE", function(module, exports) {

$parcel$export(module.exports, "jsx", function () { return $9a4313a106b95007$export$34b9dba7ce09269b; });
$parcel$export(module.exports, "jsxs", function () { return $9a4313a106b95007$export$25062201e9e25d76; });

var $huuga = parcelRequire("huuga");

var $b5eff = parcelRequire("b5eff");
parcelRequire("a5EUy");
parcelRequire("eXbSj");
parcelRequire("jLDbU");
parcelRequire("4lqHf");

parcelRequire("jxrUX");
parcelRequire("kvAyz");
parcelRequire("f72sm");
parcelRequire("1ersq");
var $9a4313a106b95007$export$ffb0004e005737fa = $huuga.Fragment;
function $9a4313a106b95007$export$34b9dba7ce09269b(type, props, key) {
    if (!(0, $b5eff.h).call(props, 'css')) return $huuga.jsx(type, props, key);
    return $huuga.jsx((0, $b5eff.E), (0, $b5eff.c)(type, props), key);
}
function $9a4313a106b95007$export$25062201e9e25d76(type, props, key) {
    if (!(0, $b5eff.h).call(props, 'css')) return $huuga.jsxs(type, props, key);
    return $huuga.jsxs((0, $b5eff.E), (0, $b5eff.c)(type, props), key);
}

});
parcelRegister("huuga", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cVAsd"));

});

parcelRegister("b5eff", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $811b361698c1ca5c$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $811b361698c1ca5c$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "w", function () { return $811b361698c1ca5c$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $811b361698c1ca5c$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $811b361698c1ca5c$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $811b361698c1ca5c$export$a9c23c6ac3fc3eca; });

var $a5EUy = parcelRequire("a5EUy");

var $eXbSj = parcelRequire("eXbSj");

var $cCvyD = parcelRequire("cCvyD");

var $4lqHf = parcelRequire("4lqHf");

var $hkAPM = parcelRequire("hkAPM");

var $kvAyz = parcelRequire("kvAyz");

var $f72sm = parcelRequire("f72sm");

var $1ersq = parcelRequire("1ersq");
var $811b361698c1ca5c$export$23f2a1d2818174ef = true;
var $811b361698c1ca5c$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $811b361698c1ca5c$var$EmotionCacheContext = /* #__PURE__ */ $a5EUy.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $eXbSj.default)({
    key: 'css'
}) : null);
var $811b361698c1ca5c$export$e7094788287c5e9b = $811b361698c1ca5c$var$EmotionCacheContext.Provider;
var $811b361698c1ca5c$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $a5EUy.useContext)($811b361698c1ca5c$var$EmotionCacheContext);
};
var $811b361698c1ca5c$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $a5EUy.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $a5EUy.useContext)($811b361698c1ca5c$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$811b361698c1ca5c$export$23f2a1d2818174ef) $811b361698c1ca5c$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $a5EUy.useContext)($811b361698c1ca5c$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $eXbSj.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $a5EUy.createElement($811b361698c1ca5c$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $811b361698c1ca5c$export$971d5caa766a69d7 = /* #__PURE__ */ $a5EUy.createContext({});
var $811b361698c1ca5c$export$3b14a55fb2447963 = function useTheme() {
    return $a5EUy.useContext($811b361698c1ca5c$export$971d5caa766a69d7);
};
var $811b361698c1ca5c$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $cCvyD.default)({}, outerTheme, theme);
};
var $811b361698c1ca5c$var$createCacheWithTheme = /* #__PURE__ */ (0, $4lqHf.default)(function(outerTheme) {
    return (0, $4lqHf.default)(function(theme) {
        return $811b361698c1ca5c$var$getTheme(outerTheme, theme);
    });
});
var $811b361698c1ca5c$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $a5EUy.useContext($811b361698c1ca5c$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $811b361698c1ca5c$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $a5EUy.createElement($811b361698c1ca5c$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $811b361698c1ca5c$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = $a5EUy.useContext($811b361698c1ca5c$export$971d5caa766a69d7);
        return /*#__PURE__*/ $a5EUy.createElement(Component, (0, $cCvyD.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $a5EUy.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $hkAPM.default)(WithTheme, Component);
}
var $811b361698c1ca5c$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var $811b361698c1ca5c$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $811b361698c1ca5c$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $811b361698c1ca5c$var$getLastPart(match[1]);
    return undefined;
};
var $811b361698c1ca5c$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $811b361698c1ca5c$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $811b361698c1ca5c$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $811b361698c1ca5c$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($811b361698c1ca5c$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $811b361698c1ca5c$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $811b361698c1ca5c$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $811b361698c1ca5c$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $811b361698c1ca5c$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($811b361698c1ca5c$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$811b361698c1ca5c$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $811b361698c1ca5c$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $kvAyz.registerStyles)(cache, serialized, isStringTag);
    (0, $1ersq.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $kvAyz.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $811b361698c1ca5c$var$Emotion = /* #__PURE__ */ $811b361698c1ca5c$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$811b361698c1ca5c$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $kvAyz.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $f72sm.serializeStyles)(registeredStyles, undefined, $a5EUy.useContext($811b361698c1ca5c$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($811b361698c1ca5c$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $811b361698c1ca5c$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $a5EUy.createElement($a5EUy.Fragment, null, /*#__PURE__*/ $a5EUy.createElement($811b361698c1ca5c$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $a5EUy.createElement(WrappedComponent, newProps));
});
var $811b361698c1ca5c$export$a9c23c6ac3fc3eca = $811b361698c1ca5c$var$Emotion;

});
parcelRegister("eXbSj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae2fc98474a14e40$export$2e2bcd8739ae039; });

var $cJNh8 = parcelRequire("cJNh8");

var $i1AVe = parcelRequire("i1AVe");

var $cotJq = parcelRequire("cotJq");

var $7rw64 = parcelRequire("7rw64");
var $ae2fc98474a14e40$var$isBrowser = typeof document !== 'undefined';
var $ae2fc98474a14e40$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $i1AVe.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $i1AVe.token)(character)) break;
        (0, $i1AVe.next)();
    }
    return (0, $i1AVe.slice)(begin, (0, $i1AVe.position));
};
var $ae2fc98474a14e40$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $i1AVe.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $i1AVe.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $ae2fc98474a14e40$var$identifierWithPointTracking((0, $i1AVe.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $i1AVe.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $i1AVe.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $i1AVe.from)(character);
    }
    while (character = (0, $i1AVe.next)());
    return parsed;
};
var $ae2fc98474a14e40$var$getRules = function getRules(value, points) {
    return (0, $i1AVe.dealloc)($ae2fc98474a14e40$var$toRules((0, $i1AVe.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $ae2fc98474a14e40$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $ae2fc98474a14e40$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$ae2fc98474a14e40$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $ae2fc98474a14e40$var$fixedElements.set(element, true);
    var points = [];
    var rules = $ae2fc98474a14e40$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $ae2fc98474a14e40$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $ae2fc98474a14e40$var$prefix(value, length) {
    switch((0, $i1AVe.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $i1AVe.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $i1AVe.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $i1AVe.WEBKIT) + value + (0, $i1AVe.MOZ) + value + (0, $i1AVe.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $i1AVe.WEBKIT) + value + (0, $i1AVe.MS) + value + value;
        // order
        case 6165:
            return (0, $i1AVe.WEBKIT) + value + (0, $i1AVe.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $i1AVe.WEBKIT) + value + (0, $i1AVe.replace)(value, /(\w+).+(:[^]+)/, (0, $i1AVe.WEBKIT) + 'box-$1$2' + (0, $i1AVe.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $i1AVe.WEBKIT) + value + (0, $i1AVe.MS) + 'flex-item-' + (0, $i1AVe.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $i1AVe.WEBKIT) + value + (0, $i1AVe.MS) + 'flex-line-pack' + (0, $i1AVe.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $i1AVe.WEBKIT) + value + (0, $i1AVe.MS) + (0, $i1AVe.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $i1AVe.WEBKIT) + value + (0, $i1AVe.MS) + (0, $i1AVe.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $i1AVe.WEBKIT) + 'box-' + (0, $i1AVe.replace)(value, '-grow', '') + (0, $i1AVe.WEBKIT) + value + (0, $i1AVe.MS) + (0, $i1AVe.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $i1AVe.WEBKIT) + (0, $i1AVe.replace)(value, /([^-])(transform)/g, '$1' + (0, $i1AVe.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $i1AVe.replace)((0, $i1AVe.replace)((0, $i1AVe.replace)(value, /(zoom-|grab)/, (0, $i1AVe.WEBKIT) + '$1'), /(image-set)/, (0, $i1AVe.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $i1AVe.replace)(value, /(image-set\([^]*)/, (0, $i1AVe.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $i1AVe.replace)((0, $i1AVe.replace)(value, /(.+:)(flex-)?(.*)/, (0, $i1AVe.WEBKIT) + 'box-pack:$3' + (0, $i1AVe.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $i1AVe.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $i1AVe.replace)(value, /(.+)-inline(.+)/, (0, $i1AVe.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $i1AVe.strlen)(value) - 1 - length > 6) switch((0, $i1AVe.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $i1AVe.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $i1AVe.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $i1AVe.WEBKIT) + '$2-$3' + '$1' + (0, $i1AVe.MOZ) + ((0, $i1AVe.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $i1AVe.indexof)(value, 'stretch') ? $ae2fc98474a14e40$var$prefix((0, $i1AVe.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $i1AVe.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $i1AVe.charat)(value, (0, $i1AVe.strlen)(value) - 3 - (~(0, $i1AVe.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $i1AVe.replace)(value, ':', ':' + (0, $i1AVe.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $i1AVe.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $i1AVe.WEBKIT) + ((0, $i1AVe.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $i1AVe.WEBKIT) + '$2$3' + '$1' + (0, $i1AVe.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $i1AVe.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $i1AVe.WEBKIT) + value + (0, $i1AVe.MS) + (0, $i1AVe.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $i1AVe.WEBKIT) + value + (0, $i1AVe.MS) + (0, $i1AVe.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $i1AVe.WEBKIT) + value + (0, $i1AVe.MS) + (0, $i1AVe.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $i1AVe.WEBKIT) + value + (0, $i1AVe.MS) + value + value;
    }
    return value;
}
var $ae2fc98474a14e40$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $i1AVe.DECLARATION:
                element["return"] = $ae2fc98474a14e40$var$prefix(element.value, element.length);
                break;
            case 0, $i1AVe.KEYFRAMES:
                return (0, $i1AVe.serialize)([
                    (0, $i1AVe.copy)(element, {
                        value: (0, $i1AVe.replace)(element.value, '@', '@' + (0, $i1AVe.WEBKIT))
                    })
                ], callback);
            case 0, $i1AVe.RULESET:
                if (element.length) return (0, $i1AVe.combine)(element.props, function(value) {
                    switch((0, $i1AVe.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $i1AVe.serialize)([
                                (0, $i1AVe.copy)(element, {
                                    props: [
                                        (0, $i1AVe.replace)(value, /:(read-\w+)/, ':' + (0, $i1AVe.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $i1AVe.serialize)([
                                (0, $i1AVe.copy)(element, {
                                    props: [
                                        (0, $i1AVe.replace)(value, /:(plac\w+)/, ':' + (0, $i1AVe.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $i1AVe.copy)(element, {
                                    props: [
                                        (0, $i1AVe.replace)(value, /:(plac\w+)/, ':' + (0, $i1AVe.MOZ) + '$1')
                                    ]
                                }),
                                (0, $i1AVe.copy)(element, {
                                    props: [
                                        (0, $i1AVe.replace)(value, /:(plac\w+)/, (0, $i1AVe.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $ae2fc98474a14e40$var$getServerStylisCache = $ae2fc98474a14e40$var$isBrowser ? undefined : (0, $cotJq.default)(function() {
    return (0, $7rw64.default)(function() {
        return {};
    });
});
var $ae2fc98474a14e40$var$defaultStylisPlugins = [
    $ae2fc98474a14e40$var$prefixer
];
var $ae2fc98474a14e40$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($ae2fc98474a14e40$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $ae2fc98474a14e40$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($ae2fc98474a14e40$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $ae2fc98474a14e40$var$compat,
        $ae2fc98474a14e40$var$removeLabel
    ];
    if (!$ae2fc98474a14e40$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $i1AVe.stringify),
            (0, $i1AVe.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $i1AVe.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $i1AVe.serialize)((0, $i1AVe.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $i1AVe.stringify)
        ];
        var _serializer = (0, $i1AVe.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $i1AVe.serialize)((0, $i1AVe.compile)(styles), _serializer);
        };
        var serverStylisCache = $ae2fc98474a14e40$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $cJNh8.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("cJNh8", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $945fe90df18589f1$export$9d753cd7ae895cce; });
var $945fe90df18589f1$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $945fe90df18589f1$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $945fe90df18589f1$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $945fe90df18589f1$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$945fe90df18589f1$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($945fe90df18589f1$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $945fe90df18589f1$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("i1AVe", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $f8d5d993d929e2a5$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $f8d5d993d929e2a5$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $f8d5d993d929e2a5$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $f8d5d993d929e2a5$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $f8d5d993d929e2a5$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $f8d5d993d929e2a5$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $f8d5d993d929e2a5$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $f8d5d993d929e2a5$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $f8d5d993d929e2a5$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $f8d5d993d929e2a5$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $f8d5d993d929e2a5$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $f8d5d993d929e2a5$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $f8d5d993d929e2a5$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $f8d5d993d929e2a5$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $f8d5d993d929e2a5$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $f8d5d993d929e2a5$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $f8d5d993d929e2a5$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $f8d5d993d929e2a5$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $f8d5d993d929e2a5$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $f8d5d993d929e2a5$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $f8d5d993d929e2a5$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $f8d5d993d929e2a5$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $f8d5d993d929e2a5$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $f8d5d993d929e2a5$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $f8d5d993d929e2a5$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $f8d5d993d929e2a5$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $f8d5d993d929e2a5$export$38bcb760f1d4871c; });
var $f8d5d993d929e2a5$export$71ad59f2e432cfe8 = "-ms-";
var $f8d5d993d929e2a5$export$2c0f367103c8d01c = "-moz-";
var $f8d5d993d929e2a5$export$39dfd62a25e0fe93 = "-webkit-";
var $f8d5d993d929e2a5$export$a29989082612d0d9 = "comm";
var $f8d5d993d929e2a5$export$aa3a2e812ca8570d = "rule";
var $f8d5d993d929e2a5$export$527d108ccf083c2b = "decl";
var $f8d5d993d929e2a5$export$d3d35020fa5b54f0 = "@page";
var $f8d5d993d929e2a5$export$500415a86c544f73 = "@media";
var $f8d5d993d929e2a5$export$a763edbf796b780a = "@import";
var $f8d5d993d929e2a5$export$2790aeb8b4e5c826 = "@charset";
var $f8d5d993d929e2a5$export$1cc683e23b84b133 = "@viewport";
var $f8d5d993d929e2a5$export$9447a5efea57e862 = "@supports";
var $f8d5d993d929e2a5$export$ef011b4e114b1fba = "@document";
var $f8d5d993d929e2a5$export$6aad947bda0f3f46 = "@namespace";
var $f8d5d993d929e2a5$export$b44a8529a35fcb60 = "@keyframes";
var $f8d5d993d929e2a5$export$2c16de31893252e6 = "@font-face";
var $f8d5d993d929e2a5$export$3d846dd52e150c6f = "@counter-style";
var $f8d5d993d929e2a5$export$22314bfbb57653fe = "@font-feature-values";
var $f8d5d993d929e2a5$export$d773506282b3cfe6 = "@layer";
var $f8d5d993d929e2a5$export$2335f513bbd82c6d = Math.abs;
var $f8d5d993d929e2a5$export$6788812c4e6611e6 = String.fromCharCode;
var $f8d5d993d929e2a5$export$e6e34fd1f2686227 = Object.assign;
function $f8d5d993d929e2a5$export$d6af199866bfb566(e, r) {
    return $f8d5d993d929e2a5$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $f8d5d993d929e2a5$export$a9db5e087081082d(e, 0)) << 2 ^ $f8d5d993d929e2a5$export$a9db5e087081082d(e, 1)) << 2 ^ $f8d5d993d929e2a5$export$a9db5e087081082d(e, 2)) << 2 ^ $f8d5d993d929e2a5$export$a9db5e087081082d(e, 3) : 0;
}
function $f8d5d993d929e2a5$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $f8d5d993d929e2a5$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $f8d5d993d929e2a5$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $f8d5d993d929e2a5$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $f8d5d993d929e2a5$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $f8d5d993d929e2a5$export$36776f635604f274(e) {
    return e.length;
}
function $f8d5d993d929e2a5$export$f9084667e487ed46(e) {
    return e.length;
}
function $f8d5d993d929e2a5$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $f8d5d993d929e2a5$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $f8d5d993d929e2a5$export$53f1d5ea8de3d7c = 1;
var $f8d5d993d929e2a5$export$4e0c71f277ca26b3 = 1;
var $f8d5d993d929e2a5$export$f24224f1c91d8156 = 0;
var $f8d5d993d929e2a5$export$5880b8b5730aff45 = 0;
var $f8d5d993d929e2a5$export$c0306caf338ac095 = 0;
var $f8d5d993d929e2a5$export$30a86d91af8ff6e6 = "";
function $f8d5d993d929e2a5$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $f8d5d993d929e2a5$export$53f1d5ea8de3d7c,
        column: $f8d5d993d929e2a5$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $f8d5d993d929e2a5$export$784d13d8ee351f07(e, r) {
    return $f8d5d993d929e2a5$export$e6e34fd1f2686227($f8d5d993d929e2a5$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $f8d5d993d929e2a5$export$eba6f6f03b0a92e7() {
    return $f8d5d993d929e2a5$export$c0306caf338ac095;
}
function $f8d5d993d929e2a5$export$232faf9add678146() {
    $f8d5d993d929e2a5$export$c0306caf338ac095 = $f8d5d993d929e2a5$export$5880b8b5730aff45 > 0 ? $f8d5d993d929e2a5$export$a9db5e087081082d($f8d5d993d929e2a5$export$30a86d91af8ff6e6, --$f8d5d993d929e2a5$export$5880b8b5730aff45) : 0;
    if ($f8d5d993d929e2a5$export$4e0c71f277ca26b3--, $f8d5d993d929e2a5$export$c0306caf338ac095 === 10) $f8d5d993d929e2a5$export$4e0c71f277ca26b3 = 1, $f8d5d993d929e2a5$export$53f1d5ea8de3d7c--;
    return $f8d5d993d929e2a5$export$c0306caf338ac095;
}
function $f8d5d993d929e2a5$export$48cfd1e771a65c4f() {
    $f8d5d993d929e2a5$export$c0306caf338ac095 = $f8d5d993d929e2a5$export$5880b8b5730aff45 < $f8d5d993d929e2a5$export$f24224f1c91d8156 ? $f8d5d993d929e2a5$export$a9db5e087081082d($f8d5d993d929e2a5$export$30a86d91af8ff6e6, $f8d5d993d929e2a5$export$5880b8b5730aff45++) : 0;
    if ($f8d5d993d929e2a5$export$4e0c71f277ca26b3++, $f8d5d993d929e2a5$export$c0306caf338ac095 === 10) $f8d5d993d929e2a5$export$4e0c71f277ca26b3 = 1, $f8d5d993d929e2a5$export$53f1d5ea8de3d7c++;
    return $f8d5d993d929e2a5$export$c0306caf338ac095;
}
function $f8d5d993d929e2a5$export$4d3fb11e950abb9e() {
    return $f8d5d993d929e2a5$export$a9db5e087081082d($f8d5d993d929e2a5$export$30a86d91af8ff6e6, $f8d5d993d929e2a5$export$5880b8b5730aff45);
}
function $f8d5d993d929e2a5$export$e88cb2efb12ae807() {
    return $f8d5d993d929e2a5$export$5880b8b5730aff45;
}
function $f8d5d993d929e2a5$export$58adb3bec8346d0f(e, r) {
    return $f8d5d993d929e2a5$export$2f35ab04d2335697($f8d5d993d929e2a5$export$30a86d91af8ff6e6, e, r);
}
function $f8d5d993d929e2a5$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $f8d5d993d929e2a5$export$2de70f21292aac9e(e) {
    return $f8d5d993d929e2a5$export$53f1d5ea8de3d7c = $f8d5d993d929e2a5$export$4e0c71f277ca26b3 = 1, $f8d5d993d929e2a5$export$f24224f1c91d8156 = $f8d5d993d929e2a5$export$36776f635604f274($f8d5d993d929e2a5$export$30a86d91af8ff6e6 = e), $f8d5d993d929e2a5$export$5880b8b5730aff45 = 0, [];
}
function $f8d5d993d929e2a5$export$45918ac1574455b1(e) {
    return $f8d5d993d929e2a5$export$30a86d91af8ff6e6 = "", e;
}
function $f8d5d993d929e2a5$export$410ac95b9ec204b8(e) {
    return $f8d5d993d929e2a5$export$87c2784dc9fc4ab($f8d5d993d929e2a5$export$58adb3bec8346d0f($f8d5d993d929e2a5$export$5880b8b5730aff45 - 1, $f8d5d993d929e2a5$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $f8d5d993d929e2a5$export$660b2ee2d4fb4eff(e) {
    return $f8d5d993d929e2a5$export$45918ac1574455b1($f8d5d993d929e2a5$export$5f8c09e3ae6f64e1($f8d5d993d929e2a5$export$2de70f21292aac9e(e)));
}
function $f8d5d993d929e2a5$export$7af1228ff777d175(e) {
    while($f8d5d993d929e2a5$export$c0306caf338ac095 = $f8d5d993d929e2a5$export$4d3fb11e950abb9e())if ($f8d5d993d929e2a5$export$c0306caf338ac095 < 33) $f8d5d993d929e2a5$export$48cfd1e771a65c4f();
    else break;
    return $f8d5d993d929e2a5$export$9e1725a4cfeada27(e) > 2 || $f8d5d993d929e2a5$export$9e1725a4cfeada27($f8d5d993d929e2a5$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $f8d5d993d929e2a5$export$5f8c09e3ae6f64e1(e) {
    while($f8d5d993d929e2a5$export$48cfd1e771a65c4f())switch($f8d5d993d929e2a5$export$9e1725a4cfeada27($f8d5d993d929e2a5$export$c0306caf338ac095)){
        case 0:
            $f8d5d993d929e2a5$export$10d8903dec122b9d($f8d5d993d929e2a5$export$c2ab62c7bf24634($f8d5d993d929e2a5$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $f8d5d993d929e2a5$export$10d8903dec122b9d($f8d5d993d929e2a5$export$410ac95b9ec204b8($f8d5d993d929e2a5$export$c0306caf338ac095), e);
            break;
        default:
            $f8d5d993d929e2a5$export$10d8903dec122b9d($f8d5d993d929e2a5$export$6788812c4e6611e6($f8d5d993d929e2a5$export$c0306caf338ac095), e);
    }
    return e;
}
function $f8d5d993d929e2a5$export$955ba06d119e085e(e, r) {
    while(--r && $f8d5d993d929e2a5$export$48cfd1e771a65c4f())if ($f8d5d993d929e2a5$export$c0306caf338ac095 < 48 || $f8d5d993d929e2a5$export$c0306caf338ac095 > 102 || $f8d5d993d929e2a5$export$c0306caf338ac095 > 57 && $f8d5d993d929e2a5$export$c0306caf338ac095 < 65 || $f8d5d993d929e2a5$export$c0306caf338ac095 > 70 && $f8d5d993d929e2a5$export$c0306caf338ac095 < 97) break;
    return $f8d5d993d929e2a5$export$58adb3bec8346d0f(e, $f8d5d993d929e2a5$export$e88cb2efb12ae807() + (r < 6 && $f8d5d993d929e2a5$export$4d3fb11e950abb9e() == 32 && $f8d5d993d929e2a5$export$48cfd1e771a65c4f() == 32));
}
function $f8d5d993d929e2a5$export$c889f2fcc19dbf12(e) {
    while($f8d5d993d929e2a5$export$48cfd1e771a65c4f())switch($f8d5d993d929e2a5$export$c0306caf338ac095){
        case e:
            return $f8d5d993d929e2a5$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $f8d5d993d929e2a5$export$c889f2fcc19dbf12($f8d5d993d929e2a5$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $f8d5d993d929e2a5$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $f8d5d993d929e2a5$export$48cfd1e771a65c4f();
            break;
    }
    return $f8d5d993d929e2a5$export$5880b8b5730aff45;
}
function $f8d5d993d929e2a5$export$4254d4e2b3745c4c(e, r) {
    while($f8d5d993d929e2a5$export$48cfd1e771a65c4f())if (e + $f8d5d993d929e2a5$export$c0306caf338ac095 === 57) break;
    else if (e + $f8d5d993d929e2a5$export$c0306caf338ac095 === 84 && $f8d5d993d929e2a5$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $f8d5d993d929e2a5$export$58adb3bec8346d0f(r, $f8d5d993d929e2a5$export$5880b8b5730aff45 - 1) + "*" + $f8d5d993d929e2a5$export$6788812c4e6611e6(e === 47 ? e : $f8d5d993d929e2a5$export$48cfd1e771a65c4f());
}
function $f8d5d993d929e2a5$export$c2ab62c7bf24634(e) {
    while(!$f8d5d993d929e2a5$export$9e1725a4cfeada27($f8d5d993d929e2a5$export$4d3fb11e950abb9e()))$f8d5d993d929e2a5$export$48cfd1e771a65c4f();
    return $f8d5d993d929e2a5$export$58adb3bec8346d0f(e, $f8d5d993d929e2a5$export$5880b8b5730aff45);
}
function $f8d5d993d929e2a5$export$ef7acd7185315e22(e) {
    return $f8d5d993d929e2a5$export$45918ac1574455b1($f8d5d993d929e2a5$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $f8d5d993d929e2a5$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $f8d5d993d929e2a5$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $f8d5d993d929e2a5$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $f8d5d993d929e2a5$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($f8d5d993d929e2a5$export$f8e21b1e77979a08(j += $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed($f8d5d993d929e2a5$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $f8d5d993d929e2a5$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $f8d5d993d929e2a5$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $f8d5d993d929e2a5$export$955ba06d119e085e($f8d5d993d929e2a5$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($f8d5d993d929e2a5$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $f8d5d993d929e2a5$export$10d8903dec122b9d($f8d5d993d929e2a5$export$4a34f930e789283c($f8d5d993d929e2a5$export$4254d4e2b3745c4c($f8d5d993d929e2a5$export$48cfd1e771a65c4f(), $f8d5d993d929e2a5$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $f8d5d993d929e2a5$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $f8d5d993d929e2a5$export$36776f635604f274(j) - l) $f8d5d993d929e2a5$export$10d8903dec122b9d(p > 32 ? $f8d5d993d929e2a5$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $f8d5d993d929e2a5$export$f8483753829ec8f3($f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $f8d5d993d929e2a5$export$10d8903dec122b9d(y = $f8d5d993d929e2a5$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $f8d5d993d929e2a5$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $f8d5d993d929e2a5$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $f8d5d993d929e2a5$export$98e6a39c04603d36(e, y, y, n && $f8d5d993d929e2a5$export$10d8903dec122b9d($f8d5d993d929e2a5$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $f8d5d993d929e2a5$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $f8d5d993d929e2a5$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $f8d5d993d929e2a5$export$232faf9add678146() == 125) continue;
            }
            switch(j += $f8d5d993d929e2a5$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($f8d5d993d929e2a5$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($f8d5d993d929e2a5$export$4d3fb11e950abb9e() === 45) j += $f8d5d993d929e2a5$export$410ac95b9ec204b8($f8d5d993d929e2a5$export$48cfd1e771a65c4f());
                    v = $f8d5d993d929e2a5$export$4d3fb11e950abb9e(), o = l = $f8d5d993d929e2a5$export$36776f635604f274(g = j += $f8d5d993d929e2a5$export$c2ab62c7bf24634($f8d5d993d929e2a5$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $f8d5d993d929e2a5$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $f8d5d993d929e2a5$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $f8d5d993d929e2a5$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $f8d5d993d929e2a5$export$2f35ab04d2335697(e, v + 1, v = $f8d5d993d929e2a5$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $f8d5d993d929e2a5$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $f8d5d993d929e2a5$export$35059013cd4a06db(e, r, a, s === 0 ? $f8d5d993d929e2a5$export$aa3a2e812ca8570d : i, f, o, l);
}
function $f8d5d993d929e2a5$export$4a34f930e789283c(e, r, a) {
    return $f8d5d993d929e2a5$export$35059013cd4a06db(e, r, a, $f8d5d993d929e2a5$export$a29989082612d0d9, $f8d5d993d929e2a5$export$6788812c4e6611e6($f8d5d993d929e2a5$export$eba6f6f03b0a92e7()), $f8d5d993d929e2a5$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $f8d5d993d929e2a5$export$f8483753829ec8f3(e, r, a, n) {
    return $f8d5d993d929e2a5$export$35059013cd4a06db(e, r, a, $f8d5d993d929e2a5$export$527d108ccf083c2b, $f8d5d993d929e2a5$export$2f35ab04d2335697(e, 0, n), $f8d5d993d929e2a5$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $f8d5d993d929e2a5$export$82e9f45cca5ba907(n, c, s) {
    switch($f8d5d993d929e2a5$export$d6af199866bfb566(n, c)){
        case 5103:
            return $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $f8d5d993d929e2a5$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + n + $f8d5d993d929e2a5$export$2c0f367103c8d01c + n + $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($f8d5d993d929e2a5$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + n + $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + n + $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + n + $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + n + $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + n + $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + n + $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + "box-$1$2" + $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + n + $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + "flex-item-" + $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$f8d5d993d929e2a5$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + "grid-row-" + $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + n + $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + "flex-line-pack" + $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + n + $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + n + $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + "box-" + $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, "-grow", "") + $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + n + $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed($f8d5d993d929e2a5$export$77ad94ebf1c2b9ed($f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed($f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + "box-pack:$3" + $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$f8d5d993d929e2a5$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + "grid-column-align" + $f8d5d993d929e2a5$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $f8d5d993d929e2a5$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$f8d5d993d929e2a5$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$f8d5d993d929e2a5$export$f8e21b1e77979a08(s, "span") ? $f8d5d993d929e2a5$export$4659b591c19bdf3d(s, /\d+/) : +$f8d5d993d929e2a5$export$4659b591c19bdf3d(s, /\d+/) - +$f8d5d993d929e2a5$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $f8d5d993d929e2a5$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed($f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($f8d5d993d929e2a5$export$36776f635604f274(n) - 1 - c > 6) switch($f8d5d993d929e2a5$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($f8d5d993d929e2a5$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $f8d5d993d929e2a5$export$2c0f367103c8d01c + ($f8d5d993d929e2a5$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$f8d5d993d929e2a5$export$f8e21b1e77979a08(n, "stretch") ? $f8d5d993d929e2a5$export$82e9f45cca5ba907($f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($f8d5d993d929e2a5$export$a9db5e087081082d(n, c + 6) === 121) return $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, ":", ":" + $f8d5d993d929e2a5$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($f8d5d993d929e2a5$export$a9db5e087081082d(n, $f8d5d993d929e2a5$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + ($f8d5d993d929e2a5$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, ":", ":" + $f8d5d993d929e2a5$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $f8d5d993d929e2a5$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $f8d5d993d929e2a5$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $f8d5d993d929e2a5$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $f8d5d993d929e2a5$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $f8d5d993d929e2a5$export$a763edbf796b780a:
        case $f8d5d993d929e2a5$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $f8d5d993d929e2a5$export$a29989082612d0d9:
            return "";
        case $f8d5d993d929e2a5$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $f8d5d993d929e2a5$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $f8d5d993d929e2a5$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $f8d5d993d929e2a5$export$36776f635604f274(a = $f8d5d993d929e2a5$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $f8d5d993d929e2a5$export$5a7767152ae0305f(e) {
    var r = $f8d5d993d929e2a5$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $f8d5d993d929e2a5$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $f8d5d993d929e2a5$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $f8d5d993d929e2a5$export$527d108ccf083c2b:
                n.return = $f8d5d993d929e2a5$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $f8d5d993d929e2a5$export$b44a8529a35fcb60:
                return $f8d5d993d929e2a5$export$dfdc1655ccc5b9cb([
                    $f8d5d993d929e2a5$export$784d13d8ee351f07(n, {
                        value: $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $f8d5d993d929e2a5$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $f8d5d993d929e2a5$export$aa3a2e812ca8570d:
                if (n.length) return $f8d5d993d929e2a5$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($f8d5d993d929e2a5$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $f8d5d993d929e2a5$export$dfdc1655ccc5b9cb([
                                $f8d5d993d929e2a5$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $f8d5d993d929e2a5$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $f8d5d993d929e2a5$export$dfdc1655ccc5b9cb([
                                $f8d5d993d929e2a5$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $f8d5d993d929e2a5$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $f8d5d993d929e2a5$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $f8d5d993d929e2a5$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $f8d5d993d929e2a5$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f8d5d993d929e2a5$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $f8d5d993d929e2a5$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $f8d5d993d929e2a5$export$76a88f7de6507443(e) {
    switch(e.type){
        case $f8d5d993d929e2a5$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $f8d5d993d929e2a5$export$1be1fc439b849fdf($f8d5d993d929e2a5$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($f8d5d993d929e2a5$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $f8d5d993d929e2a5$export$2f35ab04d2335697(r, 1, $f8d5d993d929e2a5$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $f8d5d993d929e2a5$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $f8d5d993d929e2a5$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $f8d5d993d929e2a5$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("cotJq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $905eca01f82e4c84$export$2e2bcd8739ae039; });
var $905eca01f82e4c84$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("7rw64", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56b3f3d1c0d39317$export$2e2bcd8739ae039; });
function $56b3f3d1c0d39317$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("cCvyD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $930183590814beb7$export$2e2bcd8739ae039; });
function $930183590814beb7$export$2e2bcd8739ae039() {
    return $930183590814beb7$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $930183590814beb7$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("4lqHf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $329dd4f124a117c2$export$2e2bcd8739ae039; });
var $329dd4f124a117c2$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("hkAPM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9e0e070494e162e$export$2e2bcd8739ae039; });

var $jxrUX = parcelRequire("jxrUX");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $c9e0e070494e162e$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jxrUX)))(targetComponent, sourceComponent);
};

});
parcelRegister("jxrUX", function(module, exports) {
'use strict';

var $k0lIH = parcelRequire("k0lIH");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $e396c147daead956$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $e396c147daead956$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $e396c147daead956$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $e396c147daead956$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $e396c147daead956$var$TYPE_STATICS = {};
$e396c147daead956$var$TYPE_STATICS[$k0lIH.ForwardRef] = $e396c147daead956$var$FORWARD_REF_STATICS;
$e396c147daead956$var$TYPE_STATICS[$k0lIH.Memo] = $e396c147daead956$var$MEMO_STATICS;
function $e396c147daead956$var$getStatics(component) {
    // React v16.11 and below
    if ($k0lIH.isMemo(component)) return $e396c147daead956$var$MEMO_STATICS;
     // React v16.12 and above
    return $e396c147daead956$var$TYPE_STATICS[component['$$typeof']] || $e396c147daead956$var$REACT_STATICS;
}
var $e396c147daead956$var$defineProperty = Object.defineProperty;
var $e396c147daead956$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $e396c147daead956$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $e396c147daead956$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $e396c147daead956$var$getPrototypeOf = Object.getPrototypeOf;
var $e396c147daead956$var$objectPrototype = Object.prototype;
function $e396c147daead956$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($e396c147daead956$var$objectPrototype) {
            var inheritedComponent = $e396c147daead956$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $e396c147daead956$var$objectPrototype) $e396c147daead956$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $e396c147daead956$var$getOwnPropertyNames(sourceComponent);
        if ($e396c147daead956$var$getOwnPropertySymbols) keys = keys.concat($e396c147daead956$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $e396c147daead956$var$getStatics(targetComponent);
        var sourceStatics = $e396c147daead956$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$e396c147daead956$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $e396c147daead956$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $e396c147daead956$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $e396c147daead956$var$hoistNonReactStatics;

});
parcelRegister("k0lIH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7XZW9"));

});



parcelRegister("kvAyz", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $eee30f43fcfa33a7$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $eee30f43fcfa33a7$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $eee30f43fcfa33a7$export$6f077d94b33a01aa; });
var $eee30f43fcfa33a7$var$isBrowser = typeof document !== 'undefined';
function $eee30f43fcfa33a7$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $eee30f43fcfa33a7$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $eee30f43fcfa33a7$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $eee30f43fcfa33a7$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $eee30f43fcfa33a7$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$eee30f43fcfa33a7$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$eee30f43fcfa33a7$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("f72sm", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $b0096a41e17c1632$export$6321afa313b251b5; });

var $6JqTD = parcelRequire("6JqTD");

var $6bk8J = parcelRequire("6bk8J");

var $7rw64 = parcelRequire("7rw64");
var $b0096a41e17c1632$var$isDevelopment = false;
var $b0096a41e17c1632$var$hyphenateRegex = /[A-Z]|^ms/g;
var $b0096a41e17c1632$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $b0096a41e17c1632$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $b0096a41e17c1632$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $b0096a41e17c1632$var$processStyleName = /* #__PURE__ */ (0, $7rw64.default)(function(styleName) {
    return $b0096a41e17c1632$var$isCustomProperty(styleName) ? styleName : styleName.replace($b0096a41e17c1632$var$hyphenateRegex, '-$&').toLowerCase();
});
var $b0096a41e17c1632$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($b0096a41e17c1632$var$animationRegex, function(match, p1, p2) {
                $b0096a41e17c1632$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $b0096a41e17c1632$var$cursor
                };
                return p1;
            });
    }
    if ((0, $6bk8J.default)[key] !== 1 && !$b0096a41e17c1632$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $b0096a41e17c1632$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $b0096a41e17c1632$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $b0096a41e17c1632$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $b0096a41e17c1632$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $b0096a41e17c1632$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $b0096a41e17c1632$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $b0096a41e17c1632$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $b0096a41e17c1632$var$cursor;
                var result = interpolation(mergedProps);
                $b0096a41e17c1632$var$cursor = previousCursor;
                return $b0096a41e17c1632$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $b0096a41e17c1632$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $b0096a41e17c1632$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($b0096a41e17c1632$var$isProcessableValue(asString)) string += $b0096a41e17c1632$var$processStyleName(key) + ":" + $b0096a41e17c1632$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $b0096a41e17c1632$var$isDevelopment) throw new Error($b0096a41e17c1632$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($b0096a41e17c1632$var$isProcessableValue(value[_i])) string += $b0096a41e17c1632$var$processStyleName(key) + ":" + $b0096a41e17c1632$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $b0096a41e17c1632$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $b0096a41e17c1632$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $b0096a41e17c1632$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $b0096a41e17c1632$var$cursor;
function $b0096a41e17c1632$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $b0096a41e17c1632$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $b0096a41e17c1632$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $b0096a41e17c1632$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $b0096a41e17c1632$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $b0096a41e17c1632$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $6JqTD.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $b0096a41e17c1632$var$cursor
    };
}

});
parcelRegister("6JqTD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e6bcf1d4486d203$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $4e6bcf1d4486d203$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("6bk8J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01295854949055c2$export$2e2bcd8739ae039; });
var $01295854949055c2$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("1ersq", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $0e5c65b97a829cef$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $0e5c65b97a829cef$export$811a713a7276cb9d; });

var $a5EUy = parcelRequire("a5EUy");
var $0e5c65b97a829cef$var$isBrowser = typeof document !== 'undefined';
var $0e5c65b97a829cef$var$syncFallback = function syncFallback(create) {
    return create();
};
var $0e5c65b97a829cef$var$useInsertionEffect = $a5EUy.useInsertionEffect ? $a5EUy.useInsertionEffect : false;
var $0e5c65b97a829cef$export$db21c7ffa21794e7 = !$0e5c65b97a829cef$var$isBrowser ? $0e5c65b97a829cef$var$syncFallback : $0e5c65b97a829cef$var$useInsertionEffect || $0e5c65b97a829cef$var$syncFallback;
var $0e5c65b97a829cef$export$811a713a7276cb9d = $0e5c65b97a829cef$var$useInsertionEffect || $a5EUy.useLayoutEffect;

});


parcelRegister("jLDbU", function(module, exports) {
function $e640cea3d65c1d19$var$_extends() {
    return module.exports = $e640cea3d65c1d19$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $e640cea3d65c1d19$var$_extends.apply(null, arguments);
}
module.exports = $e640cea3d65c1d19$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("glEgb", function(module, exports) {

$parcel$export(module.exports, "__RouterContext", function () { return $be6dd64f9eb71e43$export$63baa8ccbe60bb07; });
$parcel$export(module.exports, "Router", function () { return $be6dd64f9eb71e43$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Redirect", function () { return $be6dd64f9eb71e43$export$2d8d895a0a0f636e; });
$parcel$export(module.exports, "matchPath", function () { return $be6dd64f9eb71e43$export$81336c211d5ff295; });
$parcel$export(module.exports, "Route", function () { return $be6dd64f9eb71e43$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Switch", function () { return $be6dd64f9eb71e43$export$b5d5cf8927ab7262; });
$parcel$export(module.exports, "useHistory", function () { return $be6dd64f9eb71e43$export$3420e1dc2c4a518c; });
$parcel$export(module.exports, "useLocation", function () { return $be6dd64f9eb71e43$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useParams", function () { return $be6dd64f9eb71e43$export$99eaa27ddbbb95ef; });

var $6FBZf = parcelRequire("6FBZf");

var $a5EUy = parcelRequire("a5EUy");


var $b72c6 = parcelRequire("b72c6");


var $g4Zw0 = parcelRequire("g4Zw0");

var $1ytAC = parcelRequire("1ytAC");

var $cCvyD = parcelRequire("cCvyD");

var $aMAEr = parcelRequire("aMAEr");
parcelRequire("k0lIH");

var $fhwFU = parcelRequire("fhwFU");

var $jxrUX = parcelRequire("jxrUX");
// TODO: Replace with React.createContext once we can assume React 16+
var $be6dd64f9eb71e43$var$createNamedContext = function createNamedContext(name) {
    var context = (0, $g4Zw0.default)();
    context.displayName = name;
    return context;
};
var $be6dd64f9eb71e43$export$c213558b66925821 = /*#__PURE__*/ $be6dd64f9eb71e43$var$createNamedContext("Router-History");
// TODO: Replace with React.createContext once we can assume React 16+
var $be6dd64f9eb71e43$var$createNamedContext$1 = function createNamedContext(name) {
    var context = (0, $g4Zw0.default)();
    context.displayName = name;
    return context;
};
var $be6dd64f9eb71e43$export$63baa8ccbe60bb07 = /*#__PURE__*/ $be6dd64f9eb71e43$var$createNamedContext$1("Router");
/**
 * The public API for putting history on context.
 */ var $be6dd64f9eb71e43$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $6FBZf.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            if (_this._isMounted) _this.setState({
                location: location
            });
            else _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) this.unlisten();
    };
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement($be6dd64f9eb71e43$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement($be6dd64f9eb71e43$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $be6dd64f9eb71e43$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $6FBZf.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $b72c6.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement($be6dd64f9eb71e43$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).Component);
var $be6dd64f9eb71e43$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $6FBZf.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $be6dd64f9eb71e43$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement($be6dd64f9eb71e43$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $1ytAC.default)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement($be6dd64f9eb71e43$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $be6dd64f9eb71e43$var$messageType;
var $be6dd64f9eb71e43$var$cache = {};
var $be6dd64f9eb71e43$var$cacheLimit = 10000;
var $be6dd64f9eb71e43$var$cacheCount = 0;
function $be6dd64f9eb71e43$var$compilePath(path) {
    if ($be6dd64f9eb71e43$var$cache[path]) return $be6dd64f9eb71e43$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($aMAEr))).compile(path);
    if ($be6dd64f9eb71e43$var$cacheCount < $be6dd64f9eb71e43$var$cacheLimit) {
        $be6dd64f9eb71e43$var$cache[path] = generator;
        $be6dd64f9eb71e43$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $be6dd64f9eb71e43$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $be6dd64f9eb71e43$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $be6dd64f9eb71e43$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement($be6dd64f9eb71e43$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $1ytAC.default)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $b72c6.createLocation)(computedMatch ? typeof to === "string" ? $be6dd64f9eb71e43$export$82476f982757e71e(to, computedMatch.params) : (0, $cCvyD.default)({}, to, {
            pathname: $be6dd64f9eb71e43$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement($be6dd64f9eb71e43$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $b72c6.createLocation)(prevProps.to);
                if (!(0, $b72c6.locationsAreEqual)(prevLocation, (0, $cCvyD.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $be6dd64f9eb71e43$var$cache$1 = {};
var $be6dd64f9eb71e43$var$cacheLimit$1 = 10000;
var $be6dd64f9eb71e43$var$cacheCount$1 = 0;
function $be6dd64f9eb71e43$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $be6dd64f9eb71e43$var$cache$1[cacheKey] || ($be6dd64f9eb71e43$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($aMAEr)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($be6dd64f9eb71e43$var$cacheCount$1 < $be6dd64f9eb71e43$var$cacheLimit$1) {
        pathCache[path] = result;
        $be6dd64f9eb71e43$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $be6dd64f9eb71e43$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $be6dd64f9eb71e43$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $be6dd64f9eb71e43$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).Children.count(children) === 0;
}
function $be6dd64f9eb71e43$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $be6dd64f9eb71e43$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $6FBZf.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement($be6dd64f9eb71e43$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $1ytAC.default)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $be6dd64f9eb71e43$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $cCvyD.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && children.length === 0) children = null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement($be6dd64f9eb71e43$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).Component);
function $be6dd64f9eb71e43$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $be6dd64f9eb71e43$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $cCvyD.default)({}, location, {
        pathname: $be6dd64f9eb71e43$var$addLeadingSlash(basename) + location.pathname
    });
}
function $be6dd64f9eb71e43$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $be6dd64f9eb71e43$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $cCvyD.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $be6dd64f9eb71e43$var$createURL(location) {
    return typeof location === "string" ? location : (0, $b72c6.createPath)(location);
}
function $be6dd64f9eb71e43$var$staticHandler(methodName) {
    return function() {
        (0, $1ytAC.default)(false);
    };
}
function $be6dd64f9eb71e43$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $be6dd64f9eb71e43$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $6FBZf.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $be6dd64f9eb71e43$var$noop;
        };
        _this.handleBlock = function() {
            return $be6dd64f9eb71e43$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $be6dd64f9eb71e43$var$addBasename(basename, (0, $b72c6.createLocation)(location));
        context.url = $be6dd64f9eb71e43$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $fhwFU.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $be6dd64f9eb71e43$var$addLeadingSlash(basename + $be6dd64f9eb71e43$var$createURL(path));
            },
            action: "POP",
            location: $be6dd64f9eb71e43$var$stripBasename(basename, (0, $b72c6.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $be6dd64f9eb71e43$var$staticHandler("go"),
            goBack: $be6dd64f9eb71e43$var$staticHandler("goBack"),
            goForward: $be6dd64f9eb71e43$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement($be6dd64f9eb71e43$export$55185c17a0fcbe46, (0, $cCvyD.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $be6dd64f9eb71e43$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $6FBZf.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement($be6dd64f9eb71e43$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $1ytAC.default)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).Children.forEach(_this.props.children, function(child) {
                if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $be6dd64f9eb71e43$export$81336c211d5ff295(location.pathname, (0, $cCvyD.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $be6dd64f9eb71e43$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $fhwFU.default)(props, [
            "wrappedComponentRef"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement($be6dd64f9eb71e43$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $1ytAC.default)(false);
            return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement(Component, (0, $cCvyD.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($jxrUX)))(C, Component);
}
var $be6dd64f9eb71e43$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).useContext;
function $be6dd64f9eb71e43$export$3420e1dc2c4a518c() {
    return $be6dd64f9eb71e43$var$useContext($be6dd64f9eb71e43$export$c213558b66925821);
}
function $be6dd64f9eb71e43$export$45d76561a5302f2b() {
    return $be6dd64f9eb71e43$var$useContext($be6dd64f9eb71e43$export$63baa8ccbe60bb07).location;
}
function $be6dd64f9eb71e43$export$99eaa27ddbbb95ef() {
    var match = $be6dd64f9eb71e43$var$useContext($be6dd64f9eb71e43$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $be6dd64f9eb71e43$export$632be4bb944c1bc7(path) {
    var location = $be6dd64f9eb71e43$export$45d76561a5302f2b();
    var match = $be6dd64f9eb71e43$var$useContext($be6dd64f9eb71e43$export$63baa8ccbe60bb07).match;
    return path ? $be6dd64f9eb71e43$export$81336c211d5ff295(location.pathname, path) : match;
}
var $be6dd64f9eb71e43$var$global, $be6dd64f9eb71e43$var$key, $be6dd64f9eb71e43$var$buildNames, $be6dd64f9eb71e43$var$initialBuildName, $be6dd64f9eb71e43$var$secondaryBuildName;

});
parcelRegister("6FBZf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0140d6de33a89c46$export$2e2bcd8739ae039; });

var $aE5G8 = parcelRequire("aE5G8");
function $0140d6de33a89c46$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $aE5G8.default)(t, o);
}

});
parcelRegister("aE5G8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c020b76885c1b6a$export$2e2bcd8739ae039; });
function $7c020b76885c1b6a$export$2e2bcd8739ae039(t, e) {
    return $7c020b76885c1b6a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $7c020b76885c1b6a$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("b72c6", function(module, exports) {

$parcel$export(module.exports, "createPath", function () { return $81720ce0155306f0$export$fe53371bee54353d; });
$parcel$export(module.exports, "createLocation", function () { return $81720ce0155306f0$export$90c043f1c57770b8; });
$parcel$export(module.exports, "locationsAreEqual", function () { return $81720ce0155306f0$export$c3e8bb440bd55b18; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $81720ce0155306f0$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $81720ce0155306f0$export$b71fdd3798280242; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $81720ce0155306f0$export$2b76ad033c6e6d08; });

var $cCvyD = parcelRequire("cCvyD");

var $ezys4 = parcelRequire("ezys4");

var $gplcg = parcelRequire("gplcg");


var $1ytAC = parcelRequire("1ytAC");
function $81720ce0155306f0$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $81720ce0155306f0$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $81720ce0155306f0$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $81720ce0155306f0$var$stripBasename(path, prefix) {
    return $81720ce0155306f0$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $81720ce0155306f0$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $81720ce0155306f0$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $81720ce0155306f0$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $81720ce0155306f0$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $81720ce0155306f0$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $cCvyD.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $ezys4.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $81720ce0155306f0$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $gplcg.default)(a.state, b.state);
}
function $81720ce0155306f0$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $81720ce0155306f0$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $81720ce0155306f0$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $81720ce0155306f0$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $81720ce0155306f0$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $81720ce0155306f0$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $81720ce0155306f0$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $81720ce0155306f0$var$PopStateEvent = 'popstate';
var $81720ce0155306f0$var$HashChangeEvent = 'hashchange';
function $81720ce0155306f0$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $81720ce0155306f0$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$81720ce0155306f0$var$canUseDOM && (0, $1ytAC.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $81720ce0155306f0$var$supportsHistory();
    var needsHashChangeListener = !$81720ce0155306f0$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $81720ce0155306f0$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $81720ce0155306f0$var$stripTrailingSlash($81720ce0155306f0$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $81720ce0155306f0$var$stripBasename(path, basename);
        return $81720ce0155306f0$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $81720ce0155306f0$var$createTransitionManager();
    function setState(nextState) {
        (0, $cCvyD.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($81720ce0155306f0$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($81720ce0155306f0$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($81720ce0155306f0$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $81720ce0155306f0$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $81720ce0155306f0$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $81720ce0155306f0$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($81720ce0155306f0$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($81720ce0155306f0$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($81720ce0155306f0$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($81720ce0155306f0$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $81720ce0155306f0$var$HashChangeEvent$1 = 'hashchange';
var $81720ce0155306f0$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $81720ce0155306f0$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $81720ce0155306f0$var$stripLeadingSlash,
        decodePath: $81720ce0155306f0$var$addLeadingSlash
    },
    slash: {
        encodePath: $81720ce0155306f0$var$addLeadingSlash,
        decodePath: $81720ce0155306f0$var$addLeadingSlash
    }
};
function $81720ce0155306f0$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $81720ce0155306f0$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $81720ce0155306f0$var$pushHashPath(path) {
    window.location.hash = path;
}
function $81720ce0155306f0$var$replaceHashPath(path) {
    window.location.replace($81720ce0155306f0$var$stripHash(window.location.href) + '#' + path);
}
function $81720ce0155306f0$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$81720ce0155306f0$var$canUseDOM && (0, $1ytAC.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $81720ce0155306f0$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $81720ce0155306f0$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $81720ce0155306f0$var$stripTrailingSlash($81720ce0155306f0$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $81720ce0155306f0$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($81720ce0155306f0$var$getHashPath());
        if (basename) path = $81720ce0155306f0$var$stripBasename(path, basename);
        return $81720ce0155306f0$export$90c043f1c57770b8(path);
    }
    var transitionManager = $81720ce0155306f0$var$createTransitionManager();
    function setState(nextState) {
        (0, $cCvyD.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $81720ce0155306f0$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $81720ce0155306f0$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $81720ce0155306f0$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($81720ce0155306f0$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($81720ce0155306f0$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $81720ce0155306f0$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $81720ce0155306f0$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $81720ce0155306f0$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $81720ce0155306f0$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $81720ce0155306f0$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $81720ce0155306f0$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $81720ce0155306f0$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $81720ce0155306f0$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $81720ce0155306f0$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($81720ce0155306f0$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $81720ce0155306f0$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $81720ce0155306f0$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $81720ce0155306f0$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $81720ce0155306f0$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($81720ce0155306f0$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($81720ce0155306f0$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($81720ce0155306f0$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $81720ce0155306f0$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $81720ce0155306f0$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $81720ce0155306f0$var$createTransitionManager();
    function setState(nextState) {
        (0, $cCvyD.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $81720ce0155306f0$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $81720ce0155306f0$export$90c043f1c57770b8(entry, undefined, createKey()) : $81720ce0155306f0$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $81720ce0155306f0$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $81720ce0155306f0$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $81720ce0155306f0$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $81720ce0155306f0$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

});
parcelRegister("ezys4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9bf0ef563eb60f5$export$2e2bcd8739ae039; });
function $a9bf0ef563eb60f5$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $a9bf0ef563eb60f5$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $a9bf0ef563eb60f5$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $a9bf0ef563eb60f5$var$isAbsolute(to);
    var isFromAbs = from && $a9bf0ef563eb60f5$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $a9bf0ef563eb60f5$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $a9bf0ef563eb60f5$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $a9bf0ef563eb60f5$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $a9bf0ef563eb60f5$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$a9bf0ef563eb60f5$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $a9bf0ef563eb60f5$export$2e2bcd8739ae039 = $a9bf0ef563eb60f5$var$resolvePathname;

});

parcelRegister("gplcg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf1f6c637e75226e$export$2e2bcd8739ae039; });
function $bf1f6c637e75226e$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $bf1f6c637e75226e$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $bf1f6c637e75226e$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $bf1f6c637e75226e$var$valueOf(a);
        var bValue = $bf1f6c637e75226e$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $bf1f6c637e75226e$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $bf1f6c637e75226e$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $bf1f6c637e75226e$export$2e2bcd8739ae039 = $bf1f6c637e75226e$var$valueEqual;

});

parcelRegister("1ytAC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $121feb4f3fd06009$export$2e2bcd8739ae039; });
var $121feb4f3fd06009$var$isProduction = true;
var $121feb4f3fd06009$var$prefix = 'Invariant failed';
function $121feb4f3fd06009$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($121feb4f3fd06009$var$isProduction) throw new Error($121feb4f3fd06009$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($121feb4f3fd06009$var$prefix, ": ").concat(provided) : $121feb4f3fd06009$var$prefix;
    throw new Error(value);
}

});


parcelRegister("g4Zw0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03055de1cbc76e33$export$2e2bcd8739ae039; });

var $a5EUy = parcelRequire("a5EUy");

var $6FBZf = parcelRequire("6FBZf");

var $3yJBl = parcelRequire("3yJBl");

var $03055de1cbc76e33$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $03055de1cbc76e33$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : {};
function $03055de1cbc76e33$var$getUniqueId() {
    var key = '__global_unique_id__';
    return $03055de1cbc76e33$var$commonjsGlobal[key] = ($03055de1cbc76e33$var$commonjsGlobal[key] || 0) + 1;
}
function $03055de1cbc76e33$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $03055de1cbc76e33$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $03055de1cbc76e33$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $03055de1cbc76e33$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = '__create-react-context-' + $03055de1cbc76e33$var$getUniqueId() + '__';
    var Provider = /*#__PURE__*/ function(_Component) {
        (0, $6FBZf.default)(Provider, _Component);
        function Provider() {
            var _this;
            _this = _Component.apply(this, arguments) || this;
            _this.emitter = $03055de1cbc76e33$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($03055de1cbc76e33$var$objectIs(oldValue, newValue)) changedBits = 0;
                else {
                    changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : $03055de1cbc76e33$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, $a5EUy.Component));
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_Component2) {
        (0, $6FBZf.default)(Consumer, _Component2);
        function Consumer() {
            var _this2;
            _this2 = _Component2.apply(this, arguments) || this;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $03055de1cbc76e33$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $03055de1cbc76e33$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $03055de1cbc76e33$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, $a5EUy.Component));
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
var $03055de1cbc76e33$var$index = (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createContext || $03055de1cbc76e33$var$createReactContext;
var $03055de1cbc76e33$export$2e2bcd8739ae039 = $03055de1cbc76e33$var$index;

});

parcelRegister("aMAEr", function(module, exports) {

var $dyshX = parcelRequire("dyshX");
/**
 * Expose `pathToRegexp`.
 */ module.exports = $7d9ad13e7c9a508d$var$pathToRegexp;
module.exports.parse = $7d9ad13e7c9a508d$var$parse;
module.exports.compile = $7d9ad13e7c9a508d$var$compile;
module.exports.tokensToFunction = $7d9ad13e7c9a508d$var$tokensToFunction;
module.exports.tokensToRegExp = $7d9ad13e7c9a508d$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $7d9ad13e7c9a508d$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $7d9ad13e7c9a508d$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $7d9ad13e7c9a508d$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $7d9ad13e7c9a508d$var$escapeGroup(pattern) : asterisk ? '.*' : $7d9ad13e7c9a508d$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $7d9ad13e7c9a508d$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $7d9ad13e7c9a508d$var$escapeString(delimiter) + ']+?';
    return $7d9ad13e7c9a508d$var$escapeString(prevText) + '|(?:(?!' + $7d9ad13e7c9a508d$var$escapeString(prevText) + ')[^' + $7d9ad13e7c9a508d$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $7d9ad13e7c9a508d$var$compile(str, options) {
    return $7d9ad13e7c9a508d$var$tokensToFunction($7d9ad13e7c9a508d$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $7d9ad13e7c9a508d$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $7d9ad13e7c9a508d$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $7d9ad13e7c9a508d$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $7d9ad13e7c9a508d$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $7d9ad13e7c9a508d$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($dyshX(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $7d9ad13e7c9a508d$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $7d9ad13e7c9a508d$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $7d9ad13e7c9a508d$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $7d9ad13e7c9a508d$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $7d9ad13e7c9a508d$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $7d9ad13e7c9a508d$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $7d9ad13e7c9a508d$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $7d9ad13e7c9a508d$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($7d9ad13e7c9a508d$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $7d9ad13e7c9a508d$var$flags(options));
    return $7d9ad13e7c9a508d$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $7d9ad13e7c9a508d$var$stringToRegexp(path, keys, options) {
    return $7d9ad13e7c9a508d$var$tokensToRegExp($7d9ad13e7c9a508d$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $7d9ad13e7c9a508d$var$tokensToRegExp(tokens, keys, options) {
    if (!$dyshX(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $7d9ad13e7c9a508d$var$escapeString(token);
        else {
            var prefix = $7d9ad13e7c9a508d$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $7d9ad13e7c9a508d$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $7d9ad13e7c9a508d$var$attachKeys(new RegExp('^' + route, $7d9ad13e7c9a508d$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $7d9ad13e7c9a508d$var$pathToRegexp(path, keys, options) {
    if (!$dyshX(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $7d9ad13e7c9a508d$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($dyshX(path)) return $7d9ad13e7c9a508d$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $7d9ad13e7c9a508d$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});
parcelRegister("dyshX", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

});


parcelRegister("fhwFU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b201ca20aca8c5e6$export$2e2bcd8739ae039; });
function $b201ca20aca8c5e6$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("2UBc8", function(module, exports) {

var $aJi19 = parcelRequire("aJi19");

var $33zXx = parcelRequire("33zXx");
$parcel$exportWildcard(module.exports, $aJi19);
$parcel$exportWildcard(module.exports, $33zXx);

});
parcelRegister("aJi19", function(module, exports) {
$parcel$export(module.exports, "ApolloLink", function () { return (parcelRequire("8MgJN")).ApolloLink; });
$parcel$export(module.exports, "ApolloProvider", function () { return (parcelRequire("1vWK5")).ApolloProvider; });
$parcel$export(module.exports, "HttpLink", function () { return (parcelRequire("1vWK5")).HttpLink; });
$parcel$export(module.exports, "useApolloClient", function () { return (parcelRequire("1vWK5")).useApolloClient; });
$parcel$export(module.exports, "useMutation", function () { return (parcelRequire("1vWK5")).useMutation; });
$parcel$export(module.exports, "useQuery", function () { return (parcelRequire("1vWK5")).useQuery; });
$parcel$export(module.exports, "HttpLink", function () { return (parcelRequire("laC1A")).HttpLink; });

$parcel$export(module.exports, "ApolloClient", function () { return (parcelRequire("fbze5")).ApolloClient; });
$parcel$export(module.exports, "NetworkStatus", function () { return (parcelRequire("9c62d")).NetworkStatus; });
$parcel$export(module.exports, "ApolloError", function () { return (parcelRequire("jWiaX")).ApolloError; });
$parcel$export(module.exports, "InMemoryCache", function () { return (parcelRequire("coVSr")).InMemoryCache; });
$parcel$export(module.exports, "Observable", function () { return (/*@__PURE__*/$parcel$interopDefault((parcelRequire("9uTW6")))); });
$parcel$export(module.exports, "gql", function () { return (parcelRequire("3EDHG")).default; });

var $fbze5 = parcelRequire("fbze5");

var $6AhEr = parcelRequire("6AhEr");

var $9c62d = parcelRequire("9c62d");

var $iWkOU = parcelRequire("iWkOU");

var $jWiaX = parcelRequire("jWiaX");
parcelRequire("zWgQZ");
var $coVSr = parcelRequire("coVSr");

var $90Jyl = parcelRequire("90Jyl");
parcelRequire("kYdsw");
parcelRequire("2EHH1");
parcelRequire("dfrKo");
var $87ZGg = parcelRequire("87ZGg");
var $19RQK = parcelRequire("19RQK");
var $4HInX = parcelRequire("4HInX");
var $fsJcd = parcelRequire("fsJcd");
parcelRequire("jDiDD");
var $9uTW6 = parcelRequire("9uTW6");

var $3EDHG = parcelRequire("3EDHG");
var $7cfc153fd8ffd072$export$657554ef4dc7ac2d = (0, $3EDHG.default).resetCaches, $7cfc153fd8ffd072$export$e4294e638636c6ab = (0, $3EDHG.default).disableFragmentWarnings, $7cfc153fd8ffd072$export$78cf889af350c840 = (0, $3EDHG.default).enableExperimentalFragmentVariables, $7cfc153fd8ffd072$export$5290df9bbbd3cfa = (0, $3EDHG.default).disableExperimentalFragmentVariables;
$parcel$exportWildcard(module.exports, $iWkOU);
$parcel$exportWildcard(module.exports, $90Jyl);

});
parcelRegister("fbze5", function(module, exports) {

$parcel$export(module.exports, "ApolloClient", function () { return $02da5fd3b0530a87$export$13f5a5f0f1dbab88; });

var $fH1jI = parcelRequire("fH1jI");

var $5TDOW = parcelRequire("5TDOW");
parcelRequire("kYdsw");
var $8MgJN = parcelRequire("8MgJN");
var $cdPve = parcelRequire("cdPve");
parcelRequire("jDiDD");
var $bP5sr = parcelRequire("bP5sr");

var $e4WQN = parcelRequire("e4WQN");
parcelRequire("2EHH1");
var $laC1A = parcelRequire("laC1A");

var $1UeZA = parcelRequire("1UeZA");

var $1AXPB = parcelRequire("1AXPB");
var $02da5fd3b0530a87$var$hasSuggestedDevtools = false;
var $02da5fd3b0530a87$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link) link = uri ? new (0, $laC1A.HttpLink)({
            uri: uri,
            credentials: credentials,
            headers: headers
        }) : (0, $8MgJN.ApolloLink).empty();
        if (!cache) throw new (0, $5TDOW.InvariantError)(9);
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        $02da5fd3b0530a87$var$hasSuggestedDevtools;
        this.version = (0, $e4WQN.version);
        this.localState = new (0, $1AXPB.LocalState)({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new (0, $1UeZA.QueryManager)({
            cache: this.cache,
            link: this.link,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.getQueryStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $bP5sr.compact)(this.defaultOptions.watchQuery, options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $bP5sr.compact)(this.defaultOptions.query, options);
        (0, $5TDOW.invariant)(options.fetchPolicy !== 'cache-and-network', 10);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $bP5sr.compact)(this.defaultOptions.mutate, options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
    };
    ApolloClient.prototype.writeFragment = function(options) {
        this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $cdPve.execute)(this.link, payload);
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    ApolloClient.prototype.setLink = function(newLink) {
        this.link = this.queryManager.link = newLink;
    };
    return ApolloClient;
}();

});
parcelRegister("kYdsw", function(module, exports) {

$parcel$export(module.exports, "execute", function () { return (parcelRequire("cdPve")).execute; });
$parcel$export(module.exports, "ApolloLink", function () { return (parcelRequire("8MgJN")).ApolloLink; });

var $59UaS = parcelRequire("59UaS");

var $dDEQX = parcelRequire("dDEQX");

var $jw8MR = parcelRequire("jw8MR");

var $3eCh6 = parcelRequire("3eCh6");

var $cdPve = parcelRequire("cdPve");

var $8MgJN = parcelRequire("8MgJN");

var $1vWK5 = parcelRequire("1vWK5");
$parcel$exportWildcard(module.exports, $1vWK5);

});
parcelRegister("59UaS", function(module, exports) {

var $8MgJN = parcelRequire("8MgJN");
var $3c195e173a662088$export$6e22c362a0406a2c = (0, $8MgJN.ApolloLink).empty;

});
parcelRegister("8MgJN", function(module, exports) {

$parcel$export(module.exports, "ApolloLink", function () { return $663fca2cef218105$export$2fed3d61f740bc7f; });

var $fH1jI = parcelRequire("fH1jI");

var $5TDOW = parcelRequire("5TDOW");
parcelRequire("jDiDD");
var $9uTW6 = parcelRequire("9uTW6");
parcelRequire("dfrKo");
var $2FHbR = parcelRequire("2FHbR");
var $6iBQz = parcelRequire("6iBQz");
var $jiphy = parcelRequire("jiphy");
function $663fca2cef218105$var$passthrough(op, forward) {
    return forward ? forward(op) : (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6))).of();
}
function $663fca2cef218105$var$toLink(handler) {
    return typeof handler === 'function' ? new $663fca2cef218105$export$2fed3d61f740bc7f(handler) : handler;
}
function $663fca2cef218105$var$isTerminating(link) {
    return link.request.length <= 1;
}
var $663fca2cef218105$var$LinkError = function(_super) {
    (0, $fH1jI.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
var $663fca2cef218105$export$2fed3d61f740bc7f = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.empty = function() {
        return new ApolloLink(function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6))).of();
        });
    };
    ApolloLink.from = function(links) {
        if (links.length === 0) return ApolloLink.empty();
        return links.map($663fca2cef218105$var$toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    };
    ApolloLink.split = function(test, left, right) {
        var leftLink = $663fca2cef218105$var$toLink(left);
        var rightLink = $663fca2cef218105$var$toLink(right || new ApolloLink($663fca2cef218105$var$passthrough));
        if ($663fca2cef218105$var$isTerminating(leftLink) && $663fca2cef218105$var$isTerminating(rightLink)) return new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6))).of() : rightLink.request(operation) || (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6))).of();
        });
        else return new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6))).of() : rightLink.request(operation, forward) || (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6))).of();
        });
    };
    ApolloLink.execute = function(link, operation) {
        return link.request((0, $2FHbR.createOperation)(operation.context, (0, $6iBQz.transformOperation)((0, $jiphy.validateOperation)(operation)))) || (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6))).of();
    };
    ApolloLink.concat = function(first, second) {
        var firstLink = $663fca2cef218105$var$toLink(first);
        if ($663fca2cef218105$var$isTerminating(firstLink)) return firstLink;
        var nextLink = $663fca2cef218105$var$toLink(second);
        if ($663fca2cef218105$var$isTerminating(nextLink)) return new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6))).of();
            }) || (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6))).of();
        });
        else return new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6))).of();
            }) || (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6))).of();
        });
    };
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink($663fca2cef218105$var$passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $5TDOW.InvariantError)(21);
    };
    ApolloLink.prototype.onError = function(reason) {
        throw reason;
    };
    ApolloLink.prototype.setOnError = function(fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}();

});
parcelRegister("jDiDD", function(module, exports) {
$parcel$export(module.exports, "DeepMerger", function () { return (parcelRequire("l33xE")).DeepMerger; });
$parcel$export(module.exports, "mergeDeep", function () { return (parcelRequire("l33xE")).mergeDeep; });
$parcel$export(module.exports, "mergeDeepArray", function () { return (parcelRequire("l33xE")).mergeDeepArray; });
$parcel$export(module.exports, "cloneDeep", function () { return (parcelRequire("UOoOK")).cloneDeep; });
$parcel$export(module.exports, "maybeDeepFreeze", function () { return (parcelRequire("ezqAI")).maybeDeepFreeze; });
$parcel$export(module.exports, "iterateObserversSafely", function () { return (parcelRequire("2eqyc")).iterateObserversSafely; });
$parcel$export(module.exports, "asyncMap", function () { return (parcelRequire("jbN44")).asyncMap; });
$parcel$export(module.exports, "Concast", function () { return (parcelRequire("90NN7")).Concast; });
$parcel$export(module.exports, "isNonEmptyArray", function () { return (parcelRequire("h6MUv")).isNonEmptyArray; });
$parcel$export(module.exports, "graphQLResultHasError", function () { return (parcelRequire("6dw5K")).graphQLResultHasError; });
$parcel$export(module.exports, "canUseWeakMap", function () { return (parcelRequire("7hgpT")).canUseWeakMap; });
$parcel$export(module.exports, "compact", function () { return (parcelRequire("bP5sr")).compact; });

$parcel$export(module.exports, "shouldInclude", function () { return (parcelRequire("fNOO0")).shouldInclude; });
$parcel$export(module.exports, "hasDirectives", function () { return (parcelRequire("fNOO0")).hasDirectives; });
$parcel$export(module.exports, "hasClientExports", function () { return (parcelRequire("fNOO0")).hasClientExports; });
$parcel$export(module.exports, "createFragmentMap", function () { return (parcelRequire("7iEy8")).createFragmentMap; });
$parcel$export(module.exports, "getFragmentQueryDocument", function () { return (parcelRequire("7iEy8")).getFragmentQueryDocument; });
$parcel$export(module.exports, "getFragmentFromSelection", function () { return (parcelRequire("7iEy8")).getFragmentFromSelection; });
$parcel$export(module.exports, "getOperationDefinition", function () { return (parcelRequire("8gQB0")).getOperationDefinition; });
$parcel$export(module.exports, "getOperationName", function () { return (parcelRequire("8gQB0")).getOperationName; });
$parcel$export(module.exports, "getFragmentDefinitions", function () { return (parcelRequire("8gQB0")).getFragmentDefinitions; });
$parcel$export(module.exports, "getQueryDefinition", function () { return (parcelRequire("8gQB0")).getQueryDefinition; });
$parcel$export(module.exports, "getMainDefinition", function () { return (parcelRequire("8gQB0")).getMainDefinition; });
$parcel$export(module.exports, "getDefaultValues", function () { return (parcelRequire("8gQB0")).getDefaultValues; });
$parcel$export(module.exports, "makeReference", function () { return (parcelRequire("29k5C")).makeReference; });
$parcel$export(module.exports, "isReference", function () { return (parcelRequire("29k5C")).isReference; });
$parcel$export(module.exports, "isField", function () { return (parcelRequire("29k5C")).isField; });
$parcel$export(module.exports, "isInlineFragment", function () { return (parcelRequire("29k5C")).isInlineFragment; });
$parcel$export(module.exports, "storeKeyNameFromField", function () { return (parcelRequire("29k5C")).storeKeyNameFromField; });
$parcel$export(module.exports, "argumentsObjectFromField", function () { return (parcelRequire("29k5C")).argumentsObjectFromField; });
$parcel$export(module.exports, "resultKeyNameFromField", function () { return (parcelRequire("29k5C")).resultKeyNameFromField; });
$parcel$export(module.exports, "getStoreKeyName", function () { return (parcelRequire("29k5C")).getStoreKeyName; });
$parcel$export(module.exports, "getTypenameFromResult", function () { return (parcelRequire("29k5C")).getTypenameFromResult; });
$parcel$export(module.exports, "addTypenameToDocument", function () { return (parcelRequire("h5QgY")).addTypenameToDocument; });
$parcel$export(module.exports, "buildQueryFromSelectionSet", function () { return (parcelRequire("h5QgY")).buildQueryFromSelectionSet; });
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", function () { return (parcelRequire("h5QgY")).removeConnectionDirectiveFromDocument; });
$parcel$export(module.exports, "removeClientSetsFromDocument", function () { return (parcelRequire("h5QgY")).removeClientSetsFromDocument; });
$parcel$export(module.exports, "Observable", function () { return (/*@__PURE__*/$parcel$interopDefault((parcelRequire("9uTW6")))); });

var $fNOO0 = parcelRequire("fNOO0");

var $7iEy8 = parcelRequire("7iEy8");

var $8gQB0 = parcelRequire("8gQB0");

var $29k5C = parcelRequire("29k5C");

var $h5QgY = parcelRequire("h5QgY");

var $9HIU4 = parcelRequire("9HIU4");
parcelRequire("adCFy");
var $9uTW6 = parcelRequire("9uTW6");
parcelRequire("l33xE");
parcelRequire("UOoOK");
parcelRequire("ezqAI");
parcelRequire("2eqyc");
parcelRequire("jbN44");
parcelRequire("90NN7");
parcelRequire("h6MUv");
parcelRequire("6dw5K");
parcelRequire("7hgpT");
parcelRequire("bP5sr");

});
parcelRegister("fNOO0", function(module, exports) {

$parcel$export(module.exports, "shouldInclude", function () { return $b812d78613d28640$export$3dc388a5f013b4a5; });
$parcel$export(module.exports, "hasDirectives", function () { return $b812d78613d28640$export$2dafb573e282fe8d; });
$parcel$export(module.exports, "hasClientExports", function () { return $b812d78613d28640$export$8d1e9e5bbfa5d09a; });

var $aQEPU = parcelRequire("aQEPU");

var $5TDOW = parcelRequire("5TDOW");
function $b812d78613d28640$export$3dc388a5f013b4a5(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) return true;
    return $b812d78613d28640$export$b7bdffb7e6f1ef53(directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables && variables[ifArgument.value.name.value];
            (0, $5TDOW.invariant)(evaledValue !== void 0, 38);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $b812d78613d28640$export$1b217de6ce18b9a(root) {
    var names = [];
    (0, $aQEPU.visit)(root, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $b812d78613d28640$export$2dafb573e282fe8d(names, root) {
    return $b812d78613d28640$export$1b217de6ce18b9a(root).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $b812d78613d28640$export$8d1e9e5bbfa5d09a(document) {
    return document && $b812d78613d28640$export$2dafb573e282fe8d([
        'client'
    ], document) && $b812d78613d28640$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $b812d78613d28640$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $b812d78613d28640$export$b7bdffb7e6f1ef53(directives) {
    var result = [];
    if (directives && directives.length) directives.forEach(function(directive) {
        if (!$b812d78613d28640$var$isInclusionDirective(directive)) return;
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $5TDOW.invariant)(directiveArguments && directiveArguments.length === 1, 39);
        var ifArgument = directiveArguments[0];
        (0, $5TDOW.invariant)(ifArgument.name && ifArgument.name.value === 'if', 40);
        var ifValue = ifArgument.value;
        (0, $5TDOW.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 41);
        result.push({
            directive: directive,
            ifArgument: ifArgument
        });
    });
    return result;
}

});
parcelRegister("aQEPU", function(module, exports) {

$parcel$export(module.exports, "BREAK", function () { return $45efb7134a129429$export$a89c95c098ac2a58; });
$parcel$export(module.exports, "visit", function () { return $45efb7134a129429$export$bf638b60ea8b89b7; });

var $gLOVM = parcelRequire("gLOVM");

var $6JaJ0 = parcelRequire("6JaJ0");
var $45efb7134a129429$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $45efb7134a129429$export$a89c95c098ac2a58 = Object.freeze({});
function $45efb7134a129429$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $45efb7134a129429$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $6JaJ0.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $gLOVM.default)(node), "."));
            var visitFn = $45efb7134a129429$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $45efb7134a129429$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $6JaJ0.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $45efb7134a129429$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $45efb7134a129429$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $45efb7134a129429$export$a89c95c098ac2a58) skipping[i] = $45efb7134a129429$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $45efb7134a129429$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $45efb7134a129429$export$a89c95c098ac2a58) skipping[i] = $45efb7134a129429$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $45efb7134a129429$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("gLOVM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $774d54b4935969db$export$2e2bcd8739ae039; });

var $5KUdb = parcelRequire("5KUdb");
function $774d54b4935969db$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $774d54b4935969db$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $774d54b4935969db$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $774d54b4935969db$var$_typeof(obj);
}
var $774d54b4935969db$var$MAX_ARRAY_LENGTH = 10;
var $774d54b4935969db$var$MAX_RECURSIVE_DEPTH = 2;
function $774d54b4935969db$export$2e2bcd8739ae039(value) {
    return $774d54b4935969db$var$formatValue(value, []);
}
function $774d54b4935969db$var$formatValue(value, seenValues) {
    switch($774d54b4935969db$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $774d54b4935969db$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $774d54b4935969db$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $774d54b4935969db$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $774d54b4935969db$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $774d54b4935969db$var$formatArray(value, seenValues);
    return $774d54b4935969db$var$formatObject(value, seenValues);
}
function $774d54b4935969db$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $774d54b4935969db$var$MAX_RECURSIVE_DEPTH) return '[' + $774d54b4935969db$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $774d54b4935969db$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $774d54b4935969db$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $774d54b4935969db$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($774d54b4935969db$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($774d54b4935969db$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $774d54b4935969db$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $5KUdb.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $774d54b4935969db$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("5KUdb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4374f6731c63107$export$2e2bcd8739ae039; });
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $d4374f6731c63107$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $d4374f6731c63107$export$2e2bcd8739ae039 = $d4374f6731c63107$var$nodejsCustomInspectSymbol;

});


parcelRegister("6JaJ0", function(module, exports) {

$parcel$export(module.exports, "Location", function () { return $4c8063716df5455d$export$18a2be9195644f38; });
$parcel$export(module.exports, "Token", function () { return $4c8063716df5455d$export$50792b0e93539fde; });
$parcel$export(module.exports, "isNode", function () { return $4c8063716df5455d$export$8ee0fc9ee280b4ee; });

var $8iQ8F = parcelRequire("8iQ8F");
var $4c8063716df5455d$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $8iQ8F.default)($4c8063716df5455d$export$18a2be9195644f38);
var $4c8063716df5455d$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $8iQ8F.default)($4c8063716df5455d$export$50792b0e93539fde);
function $4c8063716df5455d$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("8iQ8F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $446ca584b085e508$export$2e2bcd8739ae039; });

var $5OEiy = parcelRequire("5OEiy");

var $5KUdb = parcelRequire("5KUdb");
function $446ca584b085e508$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $5OEiy.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $5KUdb.default) classObject.prototype[0, $5KUdb.default] = fn;
}

});
parcelRegister("5OEiy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75c76b7c6e61e3f3$export$2e2bcd8739ae039; });
function $75c76b7c6e61e3f3$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});





parcelRegister("7iEy8", function(module, exports) {

$parcel$export(module.exports, "getFragmentQueryDocument", function () { return $5509ab28a550cef1$export$abbf37c7cf644e41; });
$parcel$export(module.exports, "createFragmentMap", function () { return $5509ab28a550cef1$export$193789b4c8246dd4; });
$parcel$export(module.exports, "getFragmentFromSelection", function () { return $5509ab28a550cef1$export$f80bdb85f299186; });

var $fH1jI = parcelRequire("fH1jI");

var $5TDOW = parcelRequire("5TDOW");
function $5509ab28a550cef1$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $5TDOW.InvariantError)(42);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $5TDOW.invariant)(fragments.length === 1, 43);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, document), {
        definitions: (0, $fH1jI.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $5509ab28a550cef1$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $5509ab28a550cef1$export$f80bdb85f299186(selection, fragmentMap) {
    switch(selection.kind){
        case 'InlineFragment':
            return selection;
        case 'FragmentSpread':
            var fragment = fragmentMap && fragmentMap[selection.name.value];
            (0, $5TDOW.invariant)(fragment, 44);
            return fragment;
        default:
            return null;
    }
}

});

parcelRegister("8gQB0", function(module, exports) {

$parcel$export(module.exports, "checkDocument", function () { return $60589dcc9ab80ea3$export$a7d0d8111d2386df; });
$parcel$export(module.exports, "getOperationDefinition", function () { return $60589dcc9ab80ea3$export$7a5b1fa979d2c158; });
$parcel$export(module.exports, "getOperationName", function () { return $60589dcc9ab80ea3$export$41bca9dc6871dd4e; });
$parcel$export(module.exports, "getFragmentDefinitions", function () { return $60589dcc9ab80ea3$export$5320a7ba9466a3df; });
$parcel$export(module.exports, "getQueryDefinition", function () { return $60589dcc9ab80ea3$export$d96b2213c1b9d3a9; });
$parcel$export(module.exports, "getFragmentDefinition", function () { return $60589dcc9ab80ea3$export$772111caef41b3f5; });
$parcel$export(module.exports, "getMainDefinition", function () { return $60589dcc9ab80ea3$export$f431198736b7f96d; });
$parcel$export(module.exports, "getDefaultValues", function () { return $60589dcc9ab80ea3$export$84c19026e616569e; });

var $5TDOW = parcelRequire("5TDOW");

var $29k5C = parcelRequire("29k5C");
function $60589dcc9ab80ea3$export$a7d0d8111d2386df(doc) {
    (0, $5TDOW.invariant)(doc && doc.kind === 'Document', 45);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $5TDOW.InvariantError)(46);
        return definition;
    });
    (0, $5TDOW.invariant)(operations.length <= 1, 47);
    return doc;
}
function $60589dcc9ab80ea3$export$7a5b1fa979d2c158(doc) {
    $60589dcc9ab80ea3$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $60589dcc9ab80ea3$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $60589dcc9ab80ea3$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $60589dcc9ab80ea3$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $60589dcc9ab80ea3$export$7a5b1fa979d2c158(doc);
    (0, $5TDOW.invariant)(queryDef && queryDef.operation === 'query', 48);
    return queryDef;
}
function $60589dcc9ab80ea3$export$772111caef41b3f5(doc) {
    (0, $5TDOW.invariant)(doc.kind === 'Document', 49);
    (0, $5TDOW.invariant)(doc.definitions.length <= 1, 50);
    var fragmentDef = doc.definitions[0];
    (0, $5TDOW.invariant)(fragmentDef.kind === 'FragmentDefinition', 51);
    return fragmentDef;
}
function $60589dcc9ab80ea3$export$f431198736b7f96d(queryDoc) {
    $60589dcc9ab80ea3$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $5TDOW.InvariantError)(52);
}
function $60589dcc9ab80ea3$export$84c19026e616569e(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) defs.forEach(function(def) {
        if (def.defaultValue) (0, $29k5C.valueToObjectRepresentation)(defaultValues, def.variable.name, def.defaultValue);
    });
    return defaultValues;
}

});
parcelRegister("29k5C", function(module, exports) {

$parcel$export(module.exports, "makeReference", function () { return $190c016c820a8ec1$export$634ae0e932e9be99; });
$parcel$export(module.exports, "isReference", function () { return $190c016c820a8ec1$export$fa99cac1c0883c47; });
$parcel$export(module.exports, "valueToObjectRepresentation", function () { return $190c016c820a8ec1$export$a1dab82d368d6525; });
$parcel$export(module.exports, "storeKeyNameFromField", function () { return $190c016c820a8ec1$export$54be8689c65f3b56; });
$parcel$export(module.exports, "getStoreKeyName", function () { return $190c016c820a8ec1$export$3cdb6c178b88cabe; });
$parcel$export(module.exports, "argumentsObjectFromField", function () { return $190c016c820a8ec1$export$3f5a60fb6a781b4f; });
$parcel$export(module.exports, "resultKeyNameFromField", function () { return $190c016c820a8ec1$export$7d1ad22471852218; });
$parcel$export(module.exports, "getTypenameFromResult", function () { return $190c016c820a8ec1$export$cf7bf7e4f289cc26; });
$parcel$export(module.exports, "isField", function () { return $190c016c820a8ec1$export$fb56ad75dd311c12; });
$parcel$export(module.exports, "isInlineFragment", function () { return $190c016c820a8ec1$export$22a1cdafaf27bcff; });

var $dxLgR = parcelRequire("dxLgR");

var $5TDOW = parcelRequire("5TDOW");

var $7iEy8 = parcelRequire("7iEy8");
function $190c016c820a8ec1$export$634ae0e932e9be99(id) {
    return {
        __ref: String(id)
    };
}
function $190c016c820a8ec1$export$fa99cac1c0883c47(obj) {
    return Boolean(obj && typeof obj === 'object' && typeof obj.__ref === 'string');
}
function $190c016c820a8ec1$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $190c016c820a8ec1$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $190c016c820a8ec1$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $190c016c820a8ec1$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $190c016c820a8ec1$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $190c016c820a8ec1$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $190c016c820a8ec1$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $190c016c820a8ec1$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $190c016c820a8ec1$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $190c016c820a8ec1$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($190c016c820a8ec1$var$isIntValue(value) || $190c016c820a8ec1$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($190c016c820a8ec1$var$isBooleanValue(value) || $190c016c820a8ec1$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($190c016c820a8ec1$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $190c016c820a8ec1$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($190c016c820a8ec1$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($190c016c820a8ec1$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $190c016c820a8ec1$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($190c016c820a8ec1$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($190c016c820a8ec1$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $5TDOW.InvariantError)(53);
}
function $190c016c820a8ec1$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $190c016c820a8ec1$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $190c016c820a8ec1$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $190c016c820a8ec1$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $190c016c820a8ec1$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $190c016c820a8ec1$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (args && directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = args[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($dxLgR)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($190c016c820a8ec1$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $190c016c820a8ec1$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $190c016c820a8ec1$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $190c016c820a8ec1$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $190c016c820a8ec1$export$cf7bf7e4f289cc26(result, selectionSet, fragmentMap) {
    if (typeof result.__typename === 'string') return result.__typename;
    for(var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++){
        var selection = _a[_i];
        if ($190c016c820a8ec1$export$fb56ad75dd311c12(selection)) {
            if (selection.name.value === '__typename') return result[$190c016c820a8ec1$export$7d1ad22471852218(selection)];
        } else {
            var typename = $190c016c820a8ec1$export$cf7bf7e4f289cc26(result, (0, $7iEy8.getFragmentFromSelection)(selection, fragmentMap).selectionSet, fragmentMap);
            if (typeof typename === 'string') return typename;
        }
    }
}
function $190c016c820a8ec1$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $190c016c820a8ec1$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}

});


parcelRegister("h5QgY", function(module, exports) {

$parcel$export(module.exports, "addTypenameToDocument", function () { return $c71b738e5f43544b$export$43b332f87950a467; });
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", function () { return $c71b738e5f43544b$export$74985f3324559867; });
$parcel$export(module.exports, "buildQueryFromSelectionSet", function () { return $c71b738e5f43544b$export$57c368c23873f32b; });
$parcel$export(module.exports, "removeClientSetsFromDocument", function () { return $c71b738e5f43544b$export$8eae69e876ee321e; });

var $fH1jI = parcelRequire("fH1jI");

var $aQEPU = parcelRequire("aQEPU");
parcelRequire("5TDOW");

var $8gQB0 = parcelRequire("8gQB0");

var $1hOcI = parcelRequire("1hOcI");

var $29k5C = parcelRequire("29k5C");

var $7iEy8 = parcelRequire("7iEy8");
var $c71b738e5f43544b$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $c71b738e5f43544b$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $c71b738e5f43544b$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $c71b738e5f43544b$var$nullIfDocIsEmpty(doc) {
    return $c71b738e5f43544b$var$isEmpty((0, $8gQB0.getOperationDefinition)(doc) || (0, $8gQB0.getFragmentDefinition)(doc), (0, $7iEy8.createFragmentMap)((0, $8gQB0.getFragmentDefinitions)(doc))) ? null : doc;
}
function $c71b738e5f43544b$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $c71b738e5f43544b$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $c71b738e5f43544b$var$nullIfDocIsEmpty((0, $aQEPU.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($c71b738e5f43544b$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $c71b738e5f43544b$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($c71b738e5f43544b$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && (0, $1hOcI.filterInPlace)(variablesToRemove, function(v) {
        return !!v.name && !variablesInUse[v.name];
    }).length) modifiedDoc = $c71b738e5f43544b$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && (0, $1hOcI.filterInPlace)(fragmentSpreadsToRemove, function(fs) {
        return !!fs.name && !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $c71b738e5f43544b$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $c71b738e5f43544b$export$43b332f87950a467(doc) {
    return (0, $aQEPU.visit)((0, $8gQB0.checkDocument)(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return (0, $29k5C.isField)(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ((0, $29k5C.isField)(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, node), {
                    selections: (0, $fH1jI.__spreadArrays)(selections, [
                        $c71b738e5f43544b$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
$c71b738e5f43544b$export$43b332f87950a467.added = function(field) {
    return field === $c71b738e5f43544b$var$TYPENAME_FIELD;
};
var $c71b738e5f43544b$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $c71b738e5f43544b$export$74985f3324559867(doc) {
    return $c71b738e5f43544b$export$e5ae0530da5fe96c([
        $c71b738e5f43544b$var$connectionRemoveConfig
    ], (0, $8gQB0.checkDocument)(doc));
}
function $c71b738e5f43544b$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return !!selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $c71b738e5f43544b$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $c71b738e5f43544b$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!(0, $29k5C.isField)(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($c71b738e5f43544b$var$getDirectiveMatcher(directives)) || nestedCheck && $c71b738e5f43544b$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $c71b738e5f43544b$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $c71b738e5f43544b$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $c71b738e5f43544b$var$getArgumentMatcher(config);
    return $c71b738e5f43544b$var$nullIfDocIsEmpty((0, $aQEPU.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    }) : []
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $c71b738e5f43544b$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $c71b738e5f43544b$var$nullIfDocIsEmpty((0, $aQEPU.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $c71b738e5f43544b$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (((0, $29k5C.isField)(selection) || (0, $29k5C.isInlineFragment)(selection)) && selection.selectionSet) $c71b738e5f43544b$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $c71b738e5f43544b$export$57c368c23873f32b(document) {
    var definition = (0, $8gQB0.getMainDefinition)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $aQEPU.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $c71b738e5f43544b$export$8eae69e876ee321e(document) {
    (0, $8gQB0.checkDocument)(document);
    var modifiedDoc = $c71b738e5f43544b$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $aQEPU.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return (0, $29k5C.isField)(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}

});
parcelRegister("1hOcI", function(module, exports) {

$parcel$export(module.exports, "filterInPlace", function () { return $0efe52733d518e03$export$21c5d5745f10f2e; });
function $0efe52733d518e03$export$21c5d5745f10f2e(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}

});


parcelRegister("9HIU4", function(module, exports) {

var $fH1jI = parcelRequire("fH1jI");
function $710af61816a04f65$export$e243c4ad6f76d660(keyArgs) {
    if (keyArgs === void 0) keyArgs = false;
    return {
        keyArgs: keyArgs,
        merge: function(existing, incoming) {
            return existing ? (0, $fH1jI.__spreadArrays)(existing, incoming) : incoming;
        }
    };
}
function $710af61816a04f65$export$8888432c2a216040(keyArgs) {
    if (keyArgs === void 0) keyArgs = false;
    return {
        keyArgs: keyArgs,
        merge: function(existing, incoming, _a) {
            var args = _a.args;
            var merged = existing ? existing.slice(0) : [];
            if (args) {
                var _b = args.offset, offset = _b === void 0 ? 0 : _b;
                for(var i = 0; i < incoming.length; ++i)merged[offset + i] = incoming[i];
            } else merged.push.apply(merged, incoming);
            return merged;
        }
    };
}
function $710af61816a04f65$export$e16db2cef93d81f6(keyArgs) {
    if (keyArgs === void 0) keyArgs = false;
    return {
        keyArgs: keyArgs,
        read: function(existing, _a) {
            var canRead = _a.canRead, readField = _a.readField;
            if (!existing) return;
            var edges = [];
            var startCursor = "";
            var endCursor = "";
            existing.edges.forEach(function(edge) {
                if (canRead(readField("node", edge))) {
                    edges.push(edge);
                    if (edge.cursor) {
                        startCursor = startCursor || edge.cursor;
                        endCursor = edge.cursor;
                    }
                }
            });
            return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, $710af61816a04f65$var$getExtras(existing)), {
                edges: edges,
                pageInfo: (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, existing.pageInfo), {
                    startCursor: startCursor,
                    endCursor: endCursor
                })
            });
        },
        merge: function(existing, incoming, _a) {
            if (existing === void 0) existing = $710af61816a04f65$var$makeEmptyData();
            var args = _a.args, isReference = _a.isReference, readField = _a.readField;
            var incomingEdges = incoming.edges ? incoming.edges.map(function(edge) {
                if (isReference(edge = (0, $fH1jI.__assign)({}, edge))) edge.cursor = readField("cursor", edge);
                return edge;
            }) : [];
            if (incoming.pageInfo) {
                var _b = incoming.pageInfo, startCursor = _b.startCursor, endCursor = _b.endCursor;
                var firstEdge_1 = incomingEdges[0];
                if (firstEdge_1 && startCursor) firstEdge_1.cursor = startCursor;
                var lastEdge_1 = incomingEdges[incomingEdges.length - 1];
                if (lastEdge_1 && endCursor) lastEdge_1.cursor = endCursor;
            }
            var prefix = existing.edges;
            var suffix = [];
            if (args && args.after) {
                var index = prefix.findIndex(function(edge) {
                    return edge.cursor === args.after;
                });
                if (index >= 0) prefix = prefix.slice(0, index + 1);
            } else if (args && args.before) {
                var index = prefix.findIndex(function(edge) {
                    return edge.cursor === args.before;
                });
                suffix = index < 0 ? prefix : prefix.slice(index);
                prefix = [];
            } else if (incoming.edges) prefix = [];
            var edges = (0, $fH1jI.__spreadArrays)(prefix, incomingEdges, suffix);
            var firstEdge = edges[0];
            var lastEdge = edges[edges.length - 1];
            var pageInfo = (0, $fH1jI.__assign)((0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, incoming.pageInfo), existing.pageInfo), {
                startCursor: firstEdge && firstEdge.cursor || "",
                endCursor: lastEdge && lastEdge.cursor || ""
            });
            if (incoming.pageInfo) {
                var _c = incoming.pageInfo, hasPreviousPage = _c.hasPreviousPage, hasNextPage = _c.hasNextPage;
                if (!prefix.length && hasPreviousPage !== void 0) pageInfo.hasPreviousPage = hasPreviousPage;
                if (!suffix.length && hasNextPage !== void 0) pageInfo.hasNextPage = hasNextPage;
            }
            return (0, $fH1jI.__assign)((0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, $710af61816a04f65$var$getExtras(existing)), $710af61816a04f65$var$getExtras(incoming)), {
                edges: edges,
                pageInfo: pageInfo
            });
        }
    };
}
var $710af61816a04f65$var$getExtras = function(obj) {
    return (0, $fH1jI.__rest)(obj, $710af61816a04f65$var$notExtras);
};
var $710af61816a04f65$var$notExtras = [
    "edges",
    "pageInfo"
];
function $710af61816a04f65$var$makeEmptyData() {
    return {
        edges: [],
        pageInfo: {
            hasPreviousPage: false,
            hasNextPage: true,
            startCursor: "",
            endCursor: ""
        }
    };
}

});

parcelRegister("adCFy", function(module, exports) {

$parcel$export(module.exports, "Observable", function () { return (/*@__PURE__*/$parcel$interopDefault((parcelRequire("9uTW6")))); });

var $9uTW6 = parcelRequire("9uTW6");
parcelRequire("jxqB8");
(0, (/*@__PURE__*/$parcel$interopDefault($9uTW6))).prototype['@@observable'] = function() {
    return this;
};

});

parcelRegister("l33xE", function(module, exports) {

$parcel$export(module.exports, "mergeDeep", function () { return $f52ca0173c2c8b08$export$dd702b3c8240390c; });
$parcel$export(module.exports, "mergeDeepArray", function () { return $f52ca0173c2c8b08$export$160070228be94b08; });
$parcel$export(module.exports, "DeepMerger", function () { return $f52ca0173c2c8b08$export$509e11c221f576c0; });

var $fH1jI = parcelRequire("fH1jI");
var $f52ca0173c2c8b08$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $f52ca0173c2c8b08$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $f52ca0173c2c8b08$export$160070228be94b08(sources);
}
function $f52ca0173c2c8b08$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new $f52ca0173c2c8b08$export$509e11c221f576c0();
        for(var i = 1; i < count; ++i)target = merger.merge(target, sources[i]);
    }
    return target;
}
function $f52ca0173c2c8b08$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
var $f52ca0173c2c8b08$var$defaultReconciler = function(target, source, property) {
    return this.merge(target[property], source[property]);
};
var $f52ca0173c2c8b08$export$509e11c221f576c0 = function() {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) reconciler = $f52ca0173c2c8b08$var$defaultReconciler;
        this.reconciler = reconciler;
        this.isObject = $f52ca0173c2c8b08$var$isObject;
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function(target, source) {
        var _this = this;
        var context = [];
        for(var _i = 2; _i < arguments.length; _i++)context[_i - 2] = arguments[_i];
        if ($f52ca0173c2c8b08$var$isObject(source) && $f52ca0173c2c8b08$var$isObject(target)) {
            Object.keys(source).forEach(function(sourceKey) {
                if ($f52ca0173c2c8b08$var$hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0, $fH1jI.__spreadArrays)([
                            target,
                            source,
                            sourceKey
                        ], context));
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                } else {
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function(value) {
        if ($f52ca0173c2c8b08$var$isObject(value) && !this.pastCopies.has(value)) {
            if (Array.isArray(value)) value = value.slice(0);
            else value = (0, $fH1jI.__assign)({
                __proto__: Object.getPrototypeOf(value)
            }, value);
            this.pastCopies.add(value);
        }
        return value;
    };
    return DeepMerger;
}();

});

parcelRegister("UOoOK", function(module, exports) {

$parcel$export(module.exports, "cloneDeep", function () { return $0aac53534beecdc9$export$629a2bd3f5a49ecc; });
var $0aac53534beecdc9$var$toString = Object.prototype.toString;
function $0aac53534beecdc9$export$629a2bd3f5a49ecc(value) {
    return $0aac53534beecdc9$var$cloneDeepHelper(value);
}
function $0aac53534beecdc9$var$cloneDeepHelper(val, seen) {
    switch($0aac53534beecdc9$var$toString.call(val)){
        case "[object Array]":
            seen = seen || new Map;
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $0aac53534beecdc9$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            seen = seen || new Map;
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $0aac53534beecdc9$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}

});

parcelRegister("ezqAI", function(module, exports) {

$parcel$export(module.exports, "maybeDeepFreeze", function () { return $a9b8f601e4950982$export$7f9c177735b71f18; });
parcelRequire("guMED");
function $a9b8f601e4950982$var$isObject(value) {
    return value !== null && typeof value === "object";
}
function $a9b8f601e4950982$var$deepFreeze(value) {
    var workSet = new Set([
        value
    ]);
    workSet.forEach(function(obj) {
        if ($a9b8f601e4950982$var$isObject(obj)) {
            if (!Object.isFrozen(obj)) Object.freeze(obj);
            Object.getOwnPropertyNames(obj).forEach(function(name) {
                if ($a9b8f601e4950982$var$isObject(obj[name])) workSet.add(obj[name]);
            });
        }
    });
    return value;
}
function $a9b8f601e4950982$export$7f9c177735b71f18(obj) {
    return obj;
}

});
parcelRegister("guMED", function(module, exports) {
function $c0253071e0f4d2fd$export$4bd44a2aa29d3d6e() {
    return 'development';
}
function $c0253071e0f4d2fd$export$f0cb0fda19c18b37(env) {
    return $c0253071e0f4d2fd$export$4bd44a2aa29d3d6e() === env;
}
function $c0253071e0f4d2fd$export$df77466336fe5355() {
    return $c0253071e0f4d2fd$export$f0cb0fda19c18b37('development') === true;
}
function $c0253071e0f4d2fd$export$410cbc2864fa25b5() {
    return $c0253071e0f4d2fd$export$f0cb0fda19c18b37('test') === true;
}

});


parcelRegister("2eqyc", function(module, exports) {

$parcel$export(module.exports, "iterateObserversSafely", function () { return $1a017bf33f26927e$export$9f6c99ae166dbeca; });
function $1a017bf33f26927e$export$9f6c99ae166dbeca(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}

});

parcelRegister("jbN44", function(module, exports) {

$parcel$export(module.exports, "asyncMap", function () { return $039aebc8c5b288ed$export$707ee4c4c95d39e3; });
parcelRequire("adCFy");
var $9uTW6 = parcelRequire("9uTW6");
function $039aebc8c5b288ed$export$707ee4c4c95d39e3(observable, mapFn, catchFn) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6)))(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeCallbackCount = 0;
        var completed = false;
        function makeCallback(examiner, delegate) {
            if (examiner) return function(arg) {
                ++activeCallbackCount;
                new Promise(function(resolve) {
                    return resolve(examiner(arg));
                }).then(function(result) {
                    --activeCallbackCount;
                    next && next.call(observer, result);
                    if (completed) handler.complete();
                }, function(e) {
                    --activeCallbackCount;
                    error && error.call(observer, e);
                });
            };
            else return function(arg) {
                return delegate && delegate.call(observer, arg);
            };
        }
        var handler = {
            next: makeCallback(mapFn, next),
            error: makeCallback(catchFn, error),
            complete: function() {
                completed = true;
                if (!activeCallbackCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}

});

parcelRegister("90NN7", function(module, exports) {

$parcel$export(module.exports, "Concast", function () { return $68fabca0630dfe1e$export$ae0cf2ec7a6fa78e; });

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("adCFy");
var $9uTW6 = parcelRequire("9uTW6");

var $2eqyc = parcelRequire("2eqyc");
function $68fabca0630dfe1e$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
var $68fabca0630dfe1e$export$ae0cf2ec7a6fa78e = function(_super) {
    (0, $fH1jI.__extends)(Concast, _super);
    function Concast(sources) {
        var _this = _super.call(this, function(observer) {
            _this.addObserver(observer);
            return function() {
                return _this.removeObserver(observer);
            };
        }) || this;
        _this.observers = new Set();
        _this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        _this.handlers = {
            next: function(result) {
                if (_this.sub !== null) {
                    _this.latest = [
                        "next",
                        result
                    ];
                    (0, $2eqyc.iterateObserversSafely)(_this.observers, "next", result);
                }
            },
            error: function(error) {
                if (_this.sub !== null) {
                    if (_this.sub) _this.sub.unsubscribe();
                    _this.sub = null;
                    _this.latest = [
                        "error",
                        error
                    ];
                    _this.reject(error);
                    (0, $2eqyc.iterateObserversSafely)(_this.observers, "error", error);
                }
            },
            complete: function() {
                if (_this.sub !== null) {
                    var value = _this.sources.shift();
                    if (!value) {
                        _this.sub = null;
                        if (_this.latest && _this.latest[0] === "next") _this.resolve(_this.latest[1]);
                        else _this.resolve();
                        (0, $2eqyc.iterateObserversSafely)(_this.observers, "complete");
                    } else if ($68fabca0630dfe1e$var$isPromiseLike(value)) value.then(function(obs) {
                        return _this.sub = obs.subscribe(_this.handlers);
                    });
                    else _this.sub = value.subscribe(_this.handlers);
                }
            }
        };
        _this.cancel = function(reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.complete();
        };
        _this.promise.catch(function(_) {});
        if ($68fabca0630dfe1e$var$isPromiseLike(sources)) sources.then(function(iterable) {
            return _this.start(iterable);
        }, _this.handlers.error);
        else _this.start(sources);
        return _this;
    }
    Concast.prototype.start = function(sources) {
        if (this.sub !== void 0) return;
        this.sources = Array.from(sources);
        this.handlers.complete();
    };
    Concast.prototype.addObserver = function(observer) {
        if (!this.observers.has(observer)) {
            if (this.latest) {
                var nextOrError = this.latest[0];
                var method = observer[nextOrError];
                if (method) method.call(observer, this.latest[1]);
                if (this.sub === null && nextOrError === "next" && observer.complete) observer.complete();
            }
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function(observer, quietly) {
        if (this.observers.delete(observer) && this.observers.size < 1) {
            if (quietly) return;
            if (this.sub) {
                this.sub.unsubscribe();
                this.reject(new Error("Observable cancelled prematurely"));
            }
            this.sub = null;
        }
    };
    Concast.prototype.cleanup = function(callback) {
        var _this = this;
        var called = false;
        var once = function() {
            if (!called) {
                called = true;
                _this.observers.delete(observer);
                callback();
            }
        };
        var observer = {
            next: once,
            error: once,
            complete: once
        };
        this.addObserver(observer);
    };
    return Concast;
}((0, (/*@__PURE__*/$parcel$interopDefault($9uTW6))));
if (typeof Symbol === "function" && Symbol.species) Object.defineProperty($68fabca0630dfe1e$export$ae0cf2ec7a6fa78e, Symbol.species, {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6)))
});

});

parcelRegister("h6MUv", function(module, exports) {

$parcel$export(module.exports, "isNonEmptyArray", function () { return $c748efd07a805078$export$d307f5934e447d0e; });
function $c748efd07a805078$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}

});

parcelRegister("6dw5K", function(module, exports) {

$parcel$export(module.exports, "graphQLResultHasError", function () { return $486cd9b391a2fcd3$export$b4df399e879e53ab; });
function $486cd9b391a2fcd3$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length > 0 || false;
}

});

parcelRegister("7hgpT", function(module, exports) {

$parcel$export(module.exports, "canUseWeakMap", function () { return $54c6daed322fe563$export$772fbc04a0ad4ce9; });
var $54c6daed322fe563$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');

});

parcelRegister("bP5sr", function(module, exports) {

$parcel$export(module.exports, "compact", function () { return $89b8b0eeffacd538$export$8e16b83750b44988; });
function $89b8b0eeffacd538$export$8e16b83750b44988() {
    var objects = [];
    for(var _i = 0; _i < arguments.length; _i++)objects[_i] = arguments[_i];
    var result = Object.create(null);
    objects.forEach(function(obj) {
        if (!obj) return;
        Object.keys(obj).forEach(function(key) {
            var value = obj[key];
            if (value !== void 0) result[key] = value;
        });
    });
    return result;
}

});


parcelRegister("dfrKo", function(module, exports) {

$parcel$export(module.exports, "fromError", function () { return (parcelRequire("87ZGg")).fromError; });
$parcel$export(module.exports, "throwServerError", function () { return (parcelRequire("fsJcd")).throwServerError; });
$parcel$export(module.exports, "validateOperation", function () { return (parcelRequire("jiphy")).validateOperation; });
$parcel$export(module.exports, "createOperation", function () { return (parcelRequire("2FHbR")).createOperation; });
$parcel$export(module.exports, "transformOperation", function () { return (parcelRequire("6iBQz")).transformOperation; });

var $87ZGg = parcelRequire("87ZGg");

var $19RQK = parcelRequire("19RQK");

var $4HInX = parcelRequire("4HInX");

var $fsJcd = parcelRequire("fsJcd");

var $jiphy = parcelRequire("jiphy");

var $2FHbR = parcelRequire("2FHbR");

var $6iBQz = parcelRequire("6iBQz");

});
parcelRegister("87ZGg", function(module, exports) {

$parcel$export(module.exports, "fromError", function () { return $5eaed2ad513f1ff5$export$4fd972edbe7450d3; });
parcelRequire("jDiDD");
var $9uTW6 = parcelRequire("9uTW6");
function $5eaed2ad513f1ff5$export$4fd972edbe7450d3(errorValue) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6)))(function(observer) {
        observer.error(errorValue);
    });
}

});

parcelRegister("19RQK", function(module, exports) {
parcelRequire("5TDOW");
function $0d80672ad6eb21b4$export$4dbaaf6c79705e6c(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}

});

parcelRegister("4HInX", function(module, exports) {
parcelRequire("jDiDD");
var $9uTW6 = parcelRequire("9uTW6");
function $36cd9b9a72c55b9b$export$60f45028237c39d1(promise) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6)))(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}

});

parcelRegister("fsJcd", function(module, exports) {

$parcel$export(module.exports, "throwServerError", function () { return $b41c8785da60db20$export$c33ef9219f27efd7; });
var $b41c8785da60db20$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};

});

parcelRegister("jiphy", function(module, exports) {

$parcel$export(module.exports, "validateOperation", function () { return $e0c34f460bbd3248$export$a92a48117d546c9; });

var $5TDOW = parcelRequire("5TDOW");
function $e0c34f460bbd3248$export$a92a48117d546c9(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $5TDOW.InvariantError)(26);
    }
    return operation;
}

});

parcelRegister("2FHbR", function(module, exports) {

$parcel$export(module.exports, "createOperation", function () { return $1f20e9cb728d6fd6$export$f29bedd62f56fcb2; });

var $fH1jI = parcelRequire("fH1jI");
function $1f20e9cb728d6fd6$export$f29bedd62f56fcb2(starting, operation) {
    var context = (0, $fH1jI.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, context), next(context));
        else context = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, context), next);
    };
    var getContext = function() {
        return (0, $fH1jI.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    return operation;
}

});

parcelRegister("6iBQz", function(module, exports) {

$parcel$export(module.exports, "transformOperation", function () { return $4961c82546b16b31$export$4f3f7df1b558c729; });
parcelRequire("jDiDD");
var $8gQB0 = parcelRequire("8gQB0");
function $4961c82546b16b31$export$4f3f7df1b558c729(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $8gQB0.getOperationName)(transformedOperation.query) || undefined : '';
    return transformedOperation;
}

});




parcelRegister("dDEQX", function(module, exports) {

var $8MgJN = parcelRequire("8MgJN");
var $9ede9b7ddf1dce0c$export$6788812c4e6611e6 = (0, $8MgJN.ApolloLink).from;

});

parcelRegister("jw8MR", function(module, exports) {

var $8MgJN = parcelRequire("8MgJN");
var $e357d26919ead3ec$export$65980d18b75784e2 = (0, $8MgJN.ApolloLink).split;

});

parcelRegister("3eCh6", function(module, exports) {

var $8MgJN = parcelRequire("8MgJN");
var $25b05e7fc5da7ec3$export$ee1b3e54f0441b22 = (0, $8MgJN.ApolloLink).concat;

});

parcelRegister("cdPve", function(module, exports) {

$parcel$export(module.exports, "execute", function () { return $8e5ea64dba2caa52$export$51396ec711da548b; });

var $8MgJN = parcelRequire("8MgJN");
var $8e5ea64dba2caa52$export$51396ec711da548b = (0, $8MgJN.ApolloLink).execute;

});

parcelRegister("1vWK5", function(module, exports) {

});


parcelRegister("e4WQN", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $a3ff16e5e5821edd$export$83d89fbfd8236492; });
var $a3ff16e5e5821edd$export$83d89fbfd8236492 = 'local';

});

parcelRegister("2EHH1", function(module, exports) {

$parcel$export(module.exports, "createHttpLink", function () { return (parcelRequire("epBGJ")).createHttpLink; });
$parcel$export(module.exports, "HttpLink", function () { return (parcelRequire("laC1A")).HttpLink; });

var $hOnL2 = parcelRequire("hOnL2");

var $k2l47 = parcelRequire("k2l47");

var $bQLyy = parcelRequire("bQLyy");

var $f834I = parcelRequire("f834I");

var $gY1Cc = parcelRequire("gY1Cc");

var $32GkQ = parcelRequire("32GkQ");

var $epBGJ = parcelRequire("epBGJ");

var $laC1A = parcelRequire("laC1A");

var $hTavZ = parcelRequire("hTavZ");

});
parcelRegister("hOnL2", function(module, exports) {

$parcel$export(module.exports, "parseAndCheckHttpResponse", function () { return $cf7988f2c384fc6b$export$d4051215bea0639f; });
parcelRequire("dfrKo");
var $fsJcd = parcelRequire("fsJcd");
var $cf7988f2c384fc6b$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $cf7988f2c384fc6b$export$d4051215bea0639f(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                throw parseError;
            }
        }).then(function(result) {
            if (response.status >= 300) (0, $fsJcd.throwServerError)(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !$cf7988f2c384fc6b$var$hasOwnProperty.call(result, 'data') && !$cf7988f2c384fc6b$var$hasOwnProperty.call(result, 'errors')) (0, $fsJcd.throwServerError)(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
}

});

parcelRegister("k2l47", function(module, exports) {

$parcel$export(module.exports, "serializeFetchParameter", function () { return $e96455ba218d5b11$export$5f8e80ac52052e28; });

var $5TDOW = parcelRequire("5TDOW");
var $e96455ba218d5b11$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $5TDOW.InvariantError)(23);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};

});

parcelRegister("bQLyy", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", function () { return $8a0970c1ac1097e4$export$dd86f00dc866e75d; });
$parcel$export(module.exports, "selectHttpOptionsAndBody", function () { return $8a0970c1ac1097e4$export$a00ebfd5f1eebfb1; });

var $fH1jI = parcelRequire("fH1jI");

var $ivpV0 = parcelRequire("ivpV0");
var $8a0970c1ac1097e4$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $8a0970c1ac1097e4$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $8a0970c1ac1097e4$var$defaultOptions = {
    method: 'POST'
};
var $8a0970c1ac1097e4$export$dd86f00dc866e75d = {
    http: $8a0970c1ac1097e4$var$defaultHttpOptions,
    headers: $8a0970c1ac1097e4$var$defaultHeaders,
    options: $8a0970c1ac1097e4$var$defaultOptions
};
var $8a0970c1ac1097e4$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, fallbackConfig.options), {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http || {};
    configs.forEach(function(config) {
        options = (0, $fH1jI.__assign)((0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, options), config.options), {
            headers: (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, options.headers), config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, http), config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $ivpV0.print)(query);
    return {
        options: options,
        body: body
    };
};

});
parcelRegister("ivpV0", function(module, exports) {

$parcel$export(module.exports, "print", function () { return $982a6ce6a133f292$export$c2d084dc44961371; });

var $aQEPU = parcelRequire("aQEPU");

var $a2ftb = parcelRequire("a2ftb");
function $982a6ce6a133f292$export$c2d084dc44961371(ast) {
    return (0, $aQEPU.visit)(ast, {
        leave: $982a6ce6a133f292$var$printDocASTReducer
    });
}
var $982a6ce6a133f292$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $982a6ce6a133f292$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $982a6ce6a133f292$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $982a6ce6a133f292$var$wrap('(', $982a6ce6a133f292$var$join(node.variableDefinitions, ', '), ')');
        var directives = $982a6ce6a133f292$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $982a6ce6a133f292$var$join([
            op,
            $982a6ce6a133f292$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $982a6ce6a133f292$var$wrap(' = ', defaultValue) + $982a6ce6a133f292$var$wrap(' ', $982a6ce6a133f292$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $982a6ce6a133f292$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $982a6ce6a133f292$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $982a6ce6a133f292$var$wrap('(', $982a6ce6a133f292$var$join(args, ', '), ')');
        if (argsLine.length > $982a6ce6a133f292$var$MAX_LINE_LENGTH) argsLine = prefix + $982a6ce6a133f292$var$wrap('(\n', $982a6ce6a133f292$var$indent($982a6ce6a133f292$var$join(args, '\n')), '\n)');
        return $982a6ce6a133f292$var$join([
            argsLine,
            $982a6ce6a133f292$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $982a6ce6a133f292$var$wrap(' ', $982a6ce6a133f292$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $982a6ce6a133f292$var$join([
            '...',
            $982a6ce6a133f292$var$wrap('on ', typeCondition),
            $982a6ce6a133f292$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($982a6ce6a133f292$var$wrap('(', $982a6ce6a133f292$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($982a6ce6a133f292$var$wrap('', $982a6ce6a133f292$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $a2ftb.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $982a6ce6a133f292$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $982a6ce6a133f292$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $982a6ce6a133f292$var$wrap('(', $982a6ce6a133f292$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $982a6ce6a133f292$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $982a6ce6a133f292$var$join([
            'schema',
            $982a6ce6a133f292$var$join(directives, ' '),
            $982a6ce6a133f292$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $982a6ce6a133f292$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $982a6ce6a133f292$var$join([
            'scalar',
            name,
            $982a6ce6a133f292$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $982a6ce6a133f292$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $982a6ce6a133f292$var$join([
            'type',
            name,
            $982a6ce6a133f292$var$wrap('implements ', $982a6ce6a133f292$var$join(interfaces, ' & ')),
            $982a6ce6a133f292$var$join(directives, ' '),
            $982a6ce6a133f292$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $982a6ce6a133f292$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($982a6ce6a133f292$var$hasMultilineItems(args) ? $982a6ce6a133f292$var$wrap('(\n', $982a6ce6a133f292$var$indent($982a6ce6a133f292$var$join(args, '\n')), '\n)') : $982a6ce6a133f292$var$wrap('(', $982a6ce6a133f292$var$join(args, ', '), ')')) + ': ' + type + $982a6ce6a133f292$var$wrap(' ', $982a6ce6a133f292$var$join(directives, ' '));
    }),
    InputValueDefinition: $982a6ce6a133f292$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $982a6ce6a133f292$var$join([
            name + ': ' + type,
            $982a6ce6a133f292$var$wrap('= ', defaultValue),
            $982a6ce6a133f292$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $982a6ce6a133f292$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $982a6ce6a133f292$var$join([
            'interface',
            name,
            $982a6ce6a133f292$var$wrap('implements ', $982a6ce6a133f292$var$join(interfaces, ' & ')),
            $982a6ce6a133f292$var$join(directives, ' '),
            $982a6ce6a133f292$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $982a6ce6a133f292$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $982a6ce6a133f292$var$join([
            'union',
            name,
            $982a6ce6a133f292$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $982a6ce6a133f292$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $982a6ce6a133f292$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $982a6ce6a133f292$var$join([
            'enum',
            name,
            $982a6ce6a133f292$var$join(directives, ' '),
            $982a6ce6a133f292$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $982a6ce6a133f292$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $982a6ce6a133f292$var$join([
            name,
            $982a6ce6a133f292$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $982a6ce6a133f292$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $982a6ce6a133f292$var$join([
            'input',
            name,
            $982a6ce6a133f292$var$join(directives, ' '),
            $982a6ce6a133f292$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $982a6ce6a133f292$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($982a6ce6a133f292$var$hasMultilineItems(args) ? $982a6ce6a133f292$var$wrap('(\n', $982a6ce6a133f292$var$indent($982a6ce6a133f292$var$join(args, '\n')), '\n)') : $982a6ce6a133f292$var$wrap('(', $982a6ce6a133f292$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $982a6ce6a133f292$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $982a6ce6a133f292$var$join([
            'extend schema',
            $982a6ce6a133f292$var$join(directives, ' '),
            $982a6ce6a133f292$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $982a6ce6a133f292$var$join([
            'extend scalar',
            name,
            $982a6ce6a133f292$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $982a6ce6a133f292$var$join([
            'extend type',
            name,
            $982a6ce6a133f292$var$wrap('implements ', $982a6ce6a133f292$var$join(interfaces, ' & ')),
            $982a6ce6a133f292$var$join(directives, ' '),
            $982a6ce6a133f292$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $982a6ce6a133f292$var$join([
            'extend interface',
            name,
            $982a6ce6a133f292$var$wrap('implements ', $982a6ce6a133f292$var$join(interfaces, ' & ')),
            $982a6ce6a133f292$var$join(directives, ' '),
            $982a6ce6a133f292$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $982a6ce6a133f292$var$join([
            'extend union',
            name,
            $982a6ce6a133f292$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $982a6ce6a133f292$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $982a6ce6a133f292$var$join([
            'extend enum',
            name,
            $982a6ce6a133f292$var$join(directives, ' '),
            $982a6ce6a133f292$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $982a6ce6a133f292$var$join([
            'extend input',
            name,
            $982a6ce6a133f292$var$join(directives, ' '),
            $982a6ce6a133f292$var$block(fields)
        ], ' ');
    }
};
function $982a6ce6a133f292$var$addDescription(cb) {
    return function(node) {
        return $982a6ce6a133f292$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $982a6ce6a133f292$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $982a6ce6a133f292$var$block(array) {
    return $982a6ce6a133f292$var$wrap('{\n', $982a6ce6a133f292$var$indent($982a6ce6a133f292$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $982a6ce6a133f292$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $982a6ce6a133f292$var$indent(str) {
    return $982a6ce6a133f292$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $982a6ce6a133f292$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $982a6ce6a133f292$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($982a6ce6a133f292$var$isMultiline);
}

});
parcelRegister("a2ftb", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringValue", function () { return $4627c8ce4467feea$export$fd88c0b652c46ccc; });
$parcel$export(module.exports, "printBlockString", function () { return $4627c8ce4467feea$export$adb6ca997eeb1f45; });
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $4627c8ce4467feea$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $4627c8ce4467feea$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $4627c8ce4467feea$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $4627c8ce4467feea$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $4627c8ce4467feea$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $4627c8ce4467feea$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $4627c8ce4467feea$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});



parcelRegister("f834I", function(module, exports) {

$parcel$export(module.exports, "checkFetcher", function () { return $b039fd03e6bbb829$export$8423f0cd3773115e; });

var $5TDOW = parcelRequire("5TDOW");
var $b039fd03e6bbb829$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') throw new (0, $5TDOW.InvariantError)(22);
};

});

parcelRegister("gY1Cc", function(module, exports) {

$parcel$export(module.exports, "createSignalIfSupported", function () { return $c5a380afd35bc8e6$export$f5853cd1fc39aea6; });
var $c5a380afd35bc8e6$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};

});

parcelRegister("32GkQ", function(module, exports) {

$parcel$export(module.exports, "selectURI", function () { return $237265e097a2ec55$export$63ccc2571850f81a; });
var $237265e097a2ec55$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});

parcelRegister("epBGJ", function(module, exports) {

$parcel$export(module.exports, "createHttpLink", function () { return $a7e0a299c9907700$export$95180a16573d6675; });

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("kYdsw");
var $8MgJN = parcelRequire("8MgJN");
parcelRequire("jDiDD");
var $9uTW6 = parcelRequire("9uTW6");

var $k2l47 = parcelRequire("k2l47");

var $32GkQ = parcelRequire("32GkQ");

var $hOnL2 = parcelRequire("hOnL2");

var $f834I = parcelRequire("f834I");

var $bQLyy = parcelRequire("bQLyy");

var $gY1Cc = parcelRequire("gY1Cc");

var $hTavZ = parcelRequire("hTavZ");
parcelRequire("dfrKo");
var $87ZGg = parcelRequire("87ZGg");
var $a7e0a299c9907700$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, requestOptions = (0, $fH1jI.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries"
    ]);
    (0, $f834I.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $8MgJN.ApolloLink)(function(operation) {
        var chosenURI = (0, $32GkQ.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $bQLyy.selectHttpOptionsAndBody)(operation, (0, $bQLyy.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $gY1Cc.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = (0, $hTavZ.rewriteURIForGET)(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $87ZGg.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $k2l47.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $87ZGg.fromError)(parseError);
        }
        return new (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6)))(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $hOnL2.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError') return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};

});
parcelRegister("hTavZ", function(module, exports) {

$parcel$export(module.exports, "rewriteURIForGET", function () { return $d05fbac498f7b104$export$fb82bb094b6f76b5; });

var $k2l47 = parcelRequire("k2l47");
function $d05fbac498f7b104$export$fb82bb094b6f76b5(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $k2l47.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $k2l47.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}

});


parcelRegister("laC1A", function(module, exports) {

$parcel$export(module.exports, "HttpLink", function () { return $f698070fd6244cb9$export$f4bbf1aec241cc1; });

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("kYdsw");
var $8MgJN = parcelRequire("8MgJN");

var $epBGJ = parcelRequire("epBGJ");
var $f698070fd6244cb9$export$f4bbf1aec241cc1 = function(_super) {
    (0, $fH1jI.__extends)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, (0, $epBGJ.createHttpLink)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}((0, $8MgJN.ApolloLink));

});


parcelRegister("1UeZA", function(module, exports) {

$parcel$export(module.exports, "QueryManager", function () { return $1636a6920c71bc8a$export$b986383a50b53ea4; });

var $fH1jI = parcelRequire("fH1jI");

var $5TDOW = parcelRequire("5TDOW");
parcelRequire("4NlT6");
parcelRequire("kYdsw");
var $cdPve = parcelRequire("cdPve");
parcelRequire("jDiDD");
var $jbN44 = parcelRequire("jbN44");
var $7hgpT = parcelRequire("7hgpT");
var $90NN7 = parcelRequire("90NN7");
var $8gQB0 = parcelRequire("8gQB0");
var $6dw5K = parcelRequire("6dw5K");
var $fNOO0 = parcelRequire("fNOO0");
var $h6MUv = parcelRequire("h6MUv");
var $9uTW6 = parcelRequire("9uTW6");
var $h5QgY = parcelRequire("h5QgY");

var $jWiaX = parcelRequire("jWiaX");

var $bPxnX = parcelRequire("bPxnX");

var $6AhEr = parcelRequire("6AhEr");

var $9c62d = parcelRequire("9c62d");

var $1AXPB = parcelRequire("1AXPB");

var $ecPgP = parcelRequire("ecPgP");
var $1636a6920c71bc8a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $1636a6920c71bc8a$export$b986383a50b53ea4 = function() {
    function QueryManager(_a) {
        var cache = _a.cache, link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new (0, $bPxnX.MutationStore)();
        this.clientAwareness = {};
        this.queries = new Map();
        this.fetchCancelFns = new Map();
        this.transformCache = new ((0, $7hgpT.canUseWeakMap) ? WeakMap : Map)();
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        this.inFlightLinkObservables = new Map();
        this.cache = cache;
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new (0, $1AXPB.LocalState)({
            cache: cache
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches(new (0, $5TDOW.InvariantError)(12));
    };
    QueryManager.prototype.cancelPendingFetches = function(error) {
        this.fetchCancelFns.forEach(function(cancel) {
            return cancel(error);
        });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, optimistic_1, self;
            var _this = this;
            return (0, $fH1jI.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $5TDOW.invariant)(mutation, 13);
                        (0, $5TDOW.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 14);
                        mutationId = this.generateMutationId();
                        mutation = this.transform(mutation).document;
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $1636a6920c71bc8a$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        queryInfo: _this.queries.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        if (optimisticResponse) {
                            optimistic_1 = typeof optimisticResponse === 'function' ? optimisticResponse(variables) : optimisticResponse;
                            this.cache.recordOptimisticTransaction(function(cache) {
                                try {
                                    $1636a6920c71bc8a$var$markMutationResult({
                                        mutationId: mutationId,
                                        result: {
                                            data: optimistic_1
                                        },
                                        document: mutation,
                                        variables: variables,
                                        errorPolicy: errorPolicy,
                                        queryUpdatersById: generateUpdateQueriesInfo(),
                                        update: updateWithProxyFn
                                    }, cache);
                                } catch (error) {}
                            }, mutationId);
                        }
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $6dw5K.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new (0, $jWiaX.ApolloError)({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') try {
                                            $1636a6920c71bc8a$var$markMutationResult({
                                                mutationId: mutationId,
                                                result: result,
                                                document: mutation,
                                                variables: variables,
                                                errorPolicy: errorPolicy,
                                                queryUpdatersById: generateUpdateQueriesInfo(),
                                                update: updateWithProxyFn
                                            }, self.cache);
                                        } catch (e) {
                                            error = new (0, $jWiaX.ApolloError)({
                                                networkError: e
                                            });
                                            return;
                                        }
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        if (optimisticResponse) self.cache.removeOptimistic(mutationId);
                                        self.broadcastQueries();
                                        reject(new (0, $jWiaX.ApolloError)({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        if (optimisticResponse) self.cache.removeOptimistic(mutationId);
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ((0, $h6MUv.isNonEmptyArray)(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            if (errorPolicy === 'ignore' && storeResult && (0, $6dw5K.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        }, reject);
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, networkStatus) {
        return this.fetchQueryObservable(queryId, options, networkStatus).promise;
    };
    QueryManager.prototype.getQueryStore = function() {
        var store = Object.create(null);
        this.queries.forEach(function(info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var transformed = this.cache.transformDocument(document);
            var forLink = (0, $h5QgY.removeConnectionDirectiveFromDocument)(this.cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = forLink && this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $fNOO0.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $8gQB0.getDefaultValues)((0, $8gQB0.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options) {
        options = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, options), {
            variables: this.getVariables(options.query, options.variables)
        });
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var queryInfo = new (0, $ecPgP.QueryInfo)(this.cache);
        var observable = new (0, $6AhEr.ObservableQuery)({
            queryManager: this,
            queryInfo: queryInfo,
            options: options
        });
        this.queries.set(observable.queryId, queryInfo);
        queryInfo.init({
            document: options.query,
            observableQuery: observable,
            variables: options.variables
        });
        return observable;
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $5TDOW.invariant)(options.query, 15);
        (0, $5TDOW.invariant)(options.query.kind === 'Document', 16);
        (0, $5TDOW.invariant)(!options.returnPartialData, 17);
        (0, $5TDOW.invariant)(!options.pollInterval, 18);
        var queryId = this.generateQueryId();
        return this.fetchQuery(queryId, options).finally(function() {
            return _this.stopQuery(queryId);
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function() {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function() {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function() {
        this.cancelPendingFetches(new (0, $5TDOW.InvariantError)(19));
        this.queries.forEach(function(queryInfo) {
            if (queryInfo.observableQuery) queryInfo.networkStatus = (0, $9c62d.NetworkStatus).loading;
            else queryInfo.stop();
        });
        this.mutationStore.reset();
        return this.cache.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery && observableQuery.hasObservers()) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.getQuery(queryId).setDiff(null);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function(observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, errorPolicy = _a.errorPolicy, variables = _a.variables, _b = _a.context, context = _b === void 0 ? {} : _b;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, context, variables, false).map(function(result) {
                if (fetchPolicy !== 'no-cache') {
                    if ((0, $ecPgP.shouldWriteResult)(result, errorPolicy)) _this.cache.write({
                        query: query,
                        result: result.data,
                        dataId: 'ROOT_SUBSCRIPTION',
                        variables: variables
                    });
                    _this.broadcastQueries();
                }
                if ((0, $6dw5K.graphQLResultHasError)(result)) throw new (0, $jWiaX.ApolloError)({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6)))(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchCancelFns.delete(queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.broadcastQueries = function() {
        this.onBroadcast();
        this.queries.forEach(function(info) {
            return info.notify();
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _b = this, inFlightLinkObservables_1 = _b.inFlightLinkObservables, link = _b.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $8gQB0.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    var concast = new (0, $90NN7.Concast)([
                        (0, $cdPve.execute)(link, operation)
                    ]);
                    byVariables_1.set(varJson_1, observable = concast);
                    concast.cleanup(function() {
                        if (byVariables_1.delete(varJson_1) && byVariables_1.size < 1) inFlightLinkObservables_1.delete(serverQuery);
                    });
                }
            } else observable = new (0, $90NN7.Concast)([
                (0, $cdPve.execute)(link, operation)
            ]);
        } else {
            observable = new (0, $90NN7.Concast)([
                (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6))).of({
                    data: {}
                })
            ]);
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = (0, $jbN44.asyncMap)(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function(queryInfo, allowCacheWrite, options) {
        var lastRequestId = queryInfo.lastRequestId;
        return (0, $jbN44.asyncMap)(this.getObservableFromLink(queryInfo.document, options.context, options.variables), function(result) {
            var hasErrors = (0, $h6MUv.isNonEmptyArray)(result.errors);
            if (lastRequestId >= queryInfo.lastRequestId) {
                if (hasErrors && options.errorPolicy === "none") throw queryInfo.markError(new (0, $jWiaX.ApolloError)({
                    graphQLErrors: result.errors
                }));
                queryInfo.markResult(result, options, allowCacheWrite);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: queryInfo.networkStatus || (0, $9c62d.NetworkStatus).ready
            };
            if (hasErrors && options.errorPolicy !== "ignore") aqr.errors = result.errors;
            return aqr;
        }, function(networkError) {
            var error = (0, $jWiaX.isApolloError)(networkError) ? networkError : new (0, $jWiaX.ApolloError)({
                networkError: networkError
            });
            if (lastRequestId >= queryInfo.lastRequestId) queryInfo.markError(error);
            throw error;
        });
    };
    QueryManager.prototype.fetchQueryObservable = function(queryId, options, networkStatus) {
        var _this = this;
        if (networkStatus === void 0) networkStatus = (0, $9c62d.NetworkStatus).loading;
        var query = this.transform(options.query).document;
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var oldNetworkStatus = queryInfo.networkStatus;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var mightUseNetwork = fetchPolicy === "cache-first" || fetchPolicy === "cache-and-network" || fetchPolicy === "network-only" || fetchPolicy === "no-cache";
        if (mightUseNetwork && notifyOnNetworkStatusChange && typeof oldNetworkStatus === "number" && oldNetworkStatus !== networkStatus && (0, $9c62d.isNetworkRequestInFlight)(networkStatus)) {
            if (fetchPolicy !== "cache-first") fetchPolicy = "cache-and-network";
            returnPartialData = true;
        }
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context
        });
        var fromVariables = function(variables) {
            normalized.variables = variables;
            return _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
        };
        this.fetchCancelFns.set(queryId, function(reason) {
            Promise.resolve().then(function() {
                return concast.cancel(reason);
            });
        });
        var concast = new (0, $90NN7.Concast)(this.transform(normalized.query).hasClientExports ? this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables) : fromVariables(normalized.variables));
        concast.cleanup(function() {
            _this.fetchCancelFns.delete(queryId);
            var nextFetchPolicy = options.nextFetchPolicy;
            if (nextFetchPolicy) {
                options.nextFetchPolicy = void 0;
                options.fetchPolicy = typeof nextFetchPolicy === "function" ? nextFetchPolicy.call(options, options.fetchPolicy || "cache-first") : nextFetchPolicy;
            }
        });
        return concast;
    };
    QueryManager.prototype.fetchQueryByPolicy = function(queryInfo, options, networkStatus) {
        var _this = this;
        var query = options.query, variables = options.variables, fetchPolicy = options.fetchPolicy, errorPolicy = options.errorPolicy, returnPartialData = options.returnPartialData, context = options.context;
        queryInfo.init({
            document: query,
            variables: variables,
            lastRequestId: this.generateRequestId(),
            networkStatus: networkStatus
        });
        var readCache = function() {
            return queryInfo.getDiff(variables);
        };
        var resultsFromCache = function(diff, networkStatus) {
            if (networkStatus === void 0) networkStatus = queryInfo.networkStatus || (0, $9c62d.NetworkStatus).loading;
            var data = diff.result;
            var fromData = function(data) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6))).of((0, $fH1jI.__assign)({
                    data: data,
                    loading: (0, $9c62d.isNetworkRequestInFlight)(networkStatus),
                    networkStatus: networkStatus
                }, diff.complete ? null : {
                    partial: true
                }));
            };
            if (_this.transform(query).hasForcedResolvers) return _this.localState.runResolvers({
                document: query,
                remoteResult: {
                    data: data
                },
                context: context,
                variables: variables,
                onlyRunForcedResolvers: true
            }).then(function(resolved) {
                return fromData(resolved.data);
            });
            return fromData(data);
        };
        var resultsFromLink = function(allowCacheWrite) {
            return _this.getResultsFromLink(queryInfo, allowCacheWrite, {
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy
            });
        };
        switch(fetchPolicy){
            default:
            case "cache-first":
                var diff = readCache();
                if (diff.complete) return [
                    resultsFromCache(diff, queryInfo.markReady())
                ];
                if (returnPartialData) return [
                    resultsFromCache(diff),
                    resultsFromLink(true)
                ];
                return [
                    resultsFromLink(true)
                ];
            case "cache-and-network":
                var diff = readCache();
                if (diff.complete || returnPartialData) return [
                    resultsFromCache(diff),
                    resultsFromLink(true)
                ];
                return [
                    resultsFromLink(true)
                ];
            case "cache-only":
                return [
                    resultsFromCache(readCache(), queryInfo.markReady())
                ];
            case "network-only":
                return [
                    resultsFromLink(true)
                ];
            case "no-cache":
                return [
                    resultsFromLink(false)
                ];
            case "standby":
                return [];
        }
    };
    QueryManager.prototype.getQuery = function(queryId) {
        if (queryId && !this.queries.has(queryId)) this.queries.set(queryId, new (0, $ecPgP.QueryInfo)(this.cache));
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    return QueryManager;
}();
function $1636a6920c71bc8a$var$markMutationResult(mutation, cache) {
    if ((0, $ecPgP.shouldWriteResult)(mutation.result, mutation.errorPolicy)) {
        var cacheWrites_1 = [
            {
                result: mutation.result.data,
                dataId: 'ROOT_MUTATION',
                query: mutation.document,
                variables: mutation.variables
            }
        ];
        var queryUpdatersById_1 = mutation.queryUpdatersById;
        if (queryUpdatersById_1) Object.keys(queryUpdatersById_1).forEach(function(id) {
            var _a = queryUpdatersById_1[id], updater = _a.updater, _b = _a.queryInfo, document = _b.document, variables = _b.variables;
            var _c = cache.diff({
                query: document,
                variables: variables,
                returnPartialData: true,
                optimistic: false
            }), currentQueryResult = _c.result, complete = _c.complete;
            if (complete && currentQueryResult) {
                var nextQueryResult = updater(currentQueryResult, {
                    mutationResult: mutation.result,
                    queryName: (0, $8gQB0.getOperationName)(document) || undefined,
                    queryVariables: variables
                });
                if (nextQueryResult) cacheWrites_1.push({
                    result: nextQueryResult,
                    dataId: 'ROOT_QUERY',
                    query: document,
                    variables: variables
                });
            }
        });
        cache.performTransaction(function(c) {
            cacheWrites_1.forEach(function(write) {
                return c.write(write);
            });
            var update = mutation.update;
            if (update) update(c, mutation.result);
        }, null);
    }
}

});
parcelRegister("4NlT6", function(module, exports) {

$parcel$export(module.exports, "equal", function () { return $37dcb77d03dd7d51$export$411ce8e5a71e3069; });
var $37dcb77d03dd7d51$var$_a = Object.prototype, $37dcb77d03dd7d51$var$toString = $37dcb77d03dd7d51$var$_a.toString, $37dcb77d03dd7d51$var$hasOwnProperty = $37dcb77d03dd7d51$var$_a.hasOwnProperty;
var $37dcb77d03dd7d51$var$fnToStr = Function.prototype.toString;
var $37dcb77d03dd7d51$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $37dcb77d03dd7d51$export$411ce8e5a71e3069(a, b) {
    try {
        return $37dcb77d03dd7d51$var$check(a, b);
    } finally{
        $37dcb77d03dd7d51$var$previousComparisons.clear();
    }
}
function $37dcb77d03dd7d51$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $37dcb77d03dd7d51$var$toString.call(a);
    var bTag = $37dcb77d03dd7d51$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($37dcb77d03dd7d51$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$37dcb77d03dd7d51$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$37dcb77d03dd7d51$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($37dcb77d03dd7d51$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$37dcb77d03dd7d51$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
        case '[object Function]':
            var aCode = $37dcb77d03dd7d51$var$fnToStr.call(a);
            if (aCode !== $37dcb77d03dd7d51$var$fnToStr.call(b)) return false;
            // We consider non-native functions equal if they have the same code
            // (native functions require === because their code is censored).
            // Note that this behavior is not entirely sound, since !== function
            // objects with the same code can behave differently depending on
            // their closure scope. However, any function can behave differently
            // depending on the values of its input arguments (including this)
            // and its calling context (including its closure scope), even
            // though the function object is === to itself; and it is entirely
            // possible for functions that are not === to behave exactly the
            // same under all conceivable circumstances. Because none of these
            // factors are statically decidable in JavaScript, JS function
            // equality is not well-defined. This ambiguity allows us to
            // consider the best possible heuristic among various imperfect
            // options, and equating non-native functions that have the same
            // code has enormous practical benefits, such as when comparing
            // functions that are repeatedly passed as fresh function
            // expressions within objects that are otherwise deeply equal. Since
            // any function created from the same syntactic expression (in the
            // same code location) will always stringify to the same code
            // according to fnToStr.call, we can reasonably expect these
            // repeatedly passed function expressions to have the same code, and
            // thus behave "the same" (with all the caveats mentioned above),
            // even though the runtime function objects are !== to one another.
            return !$37dcb77d03dd7d51$var$endsWith(aCode, $37dcb77d03dd7d51$var$nativeCodeSuffix);
    }
    // Otherwise the values are not equal.
    return false;
}
var $37dcb77d03dd7d51$var$nativeCodeSuffix = "{ [native code] }";
function $37dcb77d03dd7d51$var$endsWith(full, suffix) {
    var fromIndex = full.length - suffix.length;
    return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}
function $37dcb77d03dd7d51$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $37dcb77d03dd7d51$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $37dcb77d03dd7d51$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $37dcb77d03dd7d51$export$2e2bcd8739ae039 = $37dcb77d03dd7d51$export$411ce8e5a71e3069;

});

parcelRegister("jWiaX", function(module, exports) {

$parcel$export(module.exports, "isApolloError", function () { return $e8418869c92caf01$export$17f5e6bd290bb15d; });
$parcel$export(module.exports, "ApolloError", function () { return $e8418869c92caf01$export$26a337512320b8c6; });

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("jDiDD");
var $h6MUv = parcelRequire("h6MUv");
function $e8418869c92caf01$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $e8418869c92caf01$var$generateErrorMessage = function(err) {
    var message = '';
    if ((0, $h6MUv.isNonEmptyArray)(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += errorMessage + "\n";
    });
    if (err.networkError) message += err.networkError.message + "\n";
    message = message.replace(/\n$/, '');
    return message;
};
var $e8418869c92caf01$export$26a337512320b8c6 = function(_super) {
    (0, $fH1jI.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || $e8418869c92caf01$var$generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);

});

parcelRegister("bPxnX", function(module, exports) {

$parcel$export(module.exports, "MutationStore", function () { return $89ce5ac8db903aa6$export$501b0c7b0d628c80; });
var $89ce5ac8db903aa6$export$501b0c7b0d628c80 = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();

});

parcelRegister("6AhEr", function(module, exports) {

$parcel$export(module.exports, "ObservableQuery", function () { return $013cb4d6f8fc1315$export$6c1b56eac59c9584; });

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("5TDOW");

var $4NlT6 = parcelRequire("4NlT6");

var $9c62d = parcelRequire("9c62d");
parcelRequire("jDiDD");
var $UOoOK = parcelRequire("UOoOK");
var $8gQB0 = parcelRequire("8gQB0");
var $h6MUv = parcelRequire("h6MUv");
var $2eqyc = parcelRequire("2eqyc");
var $9uTW6 = parcelRequire("9uTW6");

var $hdkdw = parcelRequire("hdkdw");
var $013cb4d6f8fc1315$var$warnedAboutUpdateQuery = false;
var $013cb4d6f8fc1315$export$6c1b56eac59c9584 = function(_super) {
    (0, $fH1jI.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.observer = {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    _this.updateLastResult(result);
                    (0, $2eqyc.iterateObserversSafely)(_this.observers, 'next', result);
                }
            },
            error: function(error) {
                _this.updateLastResult((0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, _this.lastResult), {
                    error: error,
                    errors: error.graphQLErrors,
                    networkStatus: (0, $9c62d.NetworkStatus).error,
                    loading: false
                }));
                (0, $2eqyc.iterateObserversSafely)(_this.observers, 'error', _this.lastError = error);
            }
        };
        _this.isTornDown = false;
        _this.options = options;
        _this.queryId = queryManager.generateQueryId();
        var opDef = (0, $8gQB0.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        _this.queryInfo = queryInfo;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        get: function() {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.getCurrentResult = function(saveAsLastResult) {
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        var lastResult = this.lastResult;
        var networkStatus = this.queryInfo.networkStatus || lastResult && lastResult.networkStatus || (0, $9c62d.NetworkStatus).ready;
        var result = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, lastResult), {
            loading: (0, $9c62d.isNetworkRequestInFlight)(networkStatus),
            networkStatus: networkStatus
        });
        if (this.isTornDown) return result;
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? 'cache-first' : _a;
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') delete result.partial;
        else if (!result.data || !this.queryManager.transform(this.options.query).hasForcedResolvers) {
            var diff = this.queryInfo.getDiff();
            result.data = diff.complete || this.options.returnPartialData ? diff.result : void 0;
            if (diff.complete) {
                if (result.networkStatus === (0, $9c62d.NetworkStatus).loading && (fetchPolicy === 'cache-first' || fetchPolicy === 'cache-only')) {
                    result.networkStatus = (0, $9c62d.NetworkStatus).ready;
                    result.loading = false;
                }
                delete result.partial;
            } else result.partial = true;
        }
        if (saveAsLastResult) this.updateLastResult(result);
        return result;
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        return !(0, $4NlT6.equal)(this.lastResultSnapshot, newResult);
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        this.queryManager.resetErrors(this.queryId);
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var reobserveOptions = {
            pollInterval: 0
        };
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') {
            reobserveOptions.fetchPolicy = 'network-only';
            reobserveOptions.nextFetchPolicy = fetchPolicy || "cache-first";
        }
        if (variables && !(0, $4NlT6.equal)(this.options.variables, variables)) reobserveOptions.variables = this.options.variables = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, this.options.variables), variables);
        return this.newReobserver(false).reobserve(reobserveOptions, (0, $9c62d.NetworkStatus).refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $fH1jI.__assign)((0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, this.options.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: "no-cache"
        });
        var qid = this.queryManager.generateQueryId();
        if (combinedOptions.notifyOnNetworkStatusChange) {
            this.queryInfo.networkStatus = (0, $9c62d.NetworkStatus).fetchMore;
            this.observe();
        }
        return this.queryManager.fetchQuery(qid, combinedOptions, (0, $9c62d.NetworkStatus).fetchMore).then(function(fetchMoreResult) {
            var data = fetchMoreResult.data;
            var updateQuery = fetchMoreOptions.updateQuery;
            if (updateQuery) _this.updateQuery(function(previous) {
                return updateQuery(previous, {
                    fetchMoreResult: data,
                    variables: combinedOptions.variables
                });
            });
            else _this.queryManager.cache.writeQuery({
                query: combinedOptions.query,
                variables: combinedOptions.variables,
                data: data
            });
            return fetchMoreResult;
        }).finally(function() {
            _this.queryManager.stopQuery(qid);
            _this.reobserve();
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.setVariables = function(variables) {
        if ((0, $4NlT6.equal)(this.variables, variables)) return this.observers.size ? this.result() : Promise.resolve();
        this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? 'cache-first' : _a;
        var reobserveOptions = {
            fetchPolicy: fetchPolicy,
            variables: variables
        };
        if (fetchPolicy !== 'cache-first' && fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') {
            reobserveOptions.fetchPolicy = 'cache-and-network';
            reobserveOptions.nextFetchPolicy = fetchPolicy;
        }
        return this.reobserve(reobserveOptions, (0, $9c62d.NetworkStatus).setVariables);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var _a;
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            previousResult: (_a = this.lastResult) === null || _a === void 0 ? void 0 : _a.data,
            returnPartialData: true,
            optimistic: false
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables
            });
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        this.getReobserver().updateOptions({
            pollInterval: pollInterval
        });
    };
    ObservableQuery.prototype.stopPolling = function() {
        if (this.reobserver) this.reobserver.updateOptions({
            pollInterval: 0
        });
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $UOoOK.cloneDeep)(newResult);
        if (!(0, $h6MUv.isNonEmptyArray)(newResult.errors)) delete this.lastError;
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        if (observer === this.observer) return function() {};
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $013cb4d6f8fc1315$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (this.lastError) observer.error && observer.error(this.lastError);
        else if (this.lastResult) observer.next && observer.next(this.lastResult);
        if (first) this.reobserve().catch(function(_) {});
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.getReobserver = function() {
        return this.reobserver || (this.reobserver = this.newReobserver(true));
    };
    ObservableQuery.prototype.newReobserver = function(shareOptions) {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        queryManager.setObservableQuery(this);
        return new (0, $hdkdw.Reobserver)(this.observer, shareOptions ? this.options : (0, $fH1jI.__assign)({}, this.options), function(currentOptions, newNetworkStatus) {
            queryManager.setObservableQuery(_this);
            return queryManager.fetchQueryObservable(queryId, currentOptions, newNetworkStatus);
        }, !queryManager.ssrMode && function() {
            return !(0, $9c62d.isNetworkRequestInFlight)(_this.queryInfo.networkStatus);
        });
    };
    ObservableQuery.prototype.reobserve = function(newOptions, newNetworkStatus) {
        this.isTornDown = false;
        return this.getReobserver().reobserve(newOptions, newNetworkStatus);
    };
    ObservableQuery.prototype.observe = function() {
        this.observer.next(this.getCurrentResult(false));
    };
    ObservableQuery.prototype.hasObservers = function() {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        if (this.reobserver) {
            this.reobserver.stop();
            delete this.reobserver;
        }
        this.isTornDown = true;
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}((0, (/*@__PURE__*/$parcel$interopDefault($9uTW6))));
function $013cb4d6f8fc1315$var$defaultSubscriptionObserverErrorCallback(error) {}

});
parcelRegister("9c62d", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", function () { return $6b19ea6b4735d54b$export$bd096ddbd246c79c; });
$parcel$export(module.exports, "isNetworkRequestInFlight", function () { return $6b19ea6b4735d54b$export$37509604341a3464; });
var $6b19ea6b4735d54b$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($6b19ea6b4735d54b$export$bd096ddbd246c79c || ($6b19ea6b4735d54b$export$bd096ddbd246c79c = {}));
function $6b19ea6b4735d54b$export$37509604341a3464(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}

});

parcelRegister("hdkdw", function(module, exports) {

$parcel$export(module.exports, "Reobserver", function () { return $c883553ccbdf2261$export$300bd58938939860; });

var $9c62d = parcelRequire("9c62d");
parcelRequire("jDiDD");
var $bP5sr = parcelRequire("bP5sr");

var $5TDOW = parcelRequire("5TDOW");
var $c883553ccbdf2261$export$300bd58938939860 = function() {
    function Reobserver(observer, options, fetch, shouldFetch) {
        this.observer = observer;
        this.options = options;
        this.fetch = fetch;
        this.shouldFetch = shouldFetch;
    }
    Reobserver.prototype.reobserve = function(newOptions, newNetworkStatus) {
        if (newOptions) this.updateOptions(newOptions);
        else this.updatePolling();
        var concast = this.fetch(this.options, newNetworkStatus);
        if (this.concast) this.concast.removeObserver(this.observer, true);
        concast.addObserver(this.observer);
        return (this.concast = concast).promise;
    };
    Reobserver.prototype.updateOptions = function(newOptions) {
        Object.assign(this.options, (0, $bP5sr.compact)(newOptions));
        this.updatePolling();
        return this;
    };
    Reobserver.prototype.stop = function() {
        if (this.concast) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
        }
        if (this.pollingInfo) {
            clearTimeout(this.pollingInfo.timeout);
            this.options.pollInterval = 0;
            this.updatePolling();
        }
    };
    Reobserver.prototype.updatePolling = function() {
        var _this = this;
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo && pollingInfo.interval === pollInterval) return;
        (0, $5TDOW.invariant)(pollInterval, 20);
        if (this.shouldFetch === false) return;
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function() {
            if (_this.pollingInfo) {
                if (_this.shouldFetch && _this.shouldFetch()) _this.reobserve({
                    fetchPolicy: "network-only",
                    nextFetchPolicy: _this.options.fetchPolicy || "cache-first"
                }, (0, $9c62d.NetworkStatus).poll).then(poll, poll);
                else poll();
            }
        };
        var poll = function() {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    return Reobserver;
}();

});


parcelRegister("1AXPB", function(module, exports) {

$parcel$export(module.exports, "LocalState", function () { return $12979078a1923248$export$19901bcd339c3ded; });

var $fH1jI = parcelRequire("fH1jI");

var $aQEPU = parcelRequire("aQEPU");

var $5TDOW = parcelRequire("5TDOW");
parcelRequire("jDiDD");
var $29k5C = parcelRequire("29k5C");
var $h5QgY = parcelRequire("h5QgY");
var $7iEy8 = parcelRequire("7iEy8");
var $8gQB0 = parcelRequire("8gQB0");
var $fNOO0 = parcelRequire("fNOO0");
var $l33xE = parcelRequire("l33xE");
parcelRequire("zWgQZ");
var $hkds1 = parcelRequire("hkds1");
var $12979078a1923248$export$19901bcd339c3ded = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $l33xE.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $l33xE.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
            return (0, $fH1jI.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $fNOO0.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return (0, $h5QgY.removeClientSetsFromDocument)(document);
    };
    LocalState.prototype.prepareContext = function(context) {
        var cache = this.cache;
        return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                return cache.identify(obj);
            }
        });
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
            return (0, $fH1jI.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $fH1jI.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $aQEPU.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $aQEPU.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $h5QgY.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $fH1jI.__generator)(this, function(_b) {
                mainDefinition = (0, $8gQB0.getMainDefinition)(document);
                fragments = (0, $8gQB0.getFragmentDefinitions)(document);
                fragmentMap = (0, $7iEy8.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? definitionOperation.charAt(0).toUpperCase() + definitionOperation.slice(1) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $fH1jI.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $fH1jI.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $fH1jI.__generator)(this, function(_a) {
                            if (!(0, $fNOO0.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $29k5C.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $29k5C.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $29k5C.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $5TDOW.invariant)(fragment, 11);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $l33xE.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $fH1jI.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $29k5C.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve((0, $hkds1.cacheSlot).withValue(this.cache, resolve, [
                            rootValue,
                            (0, $29k5C.argumentsObjectFromField)(field, variables),
                            execContext.context,
                            {
                                field: field,
                                fragmentMap: execContext.fragmentMap
                            }
                        ]));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();

});
parcelRegister("zWgQZ", function(module, exports) {

$parcel$export(module.exports, "InMemoryCache", function () { return (parcelRequire("coVSr")).InMemoryCache; });
$parcel$export(module.exports, "cacheSlot", function () { return (parcelRequire("hkds1")).cacheSlot; });

var $iYbM9 = parcelRequire("iYbM9");

var $6XbPg = parcelRequire("6XbPg");

var $dntsQ = parcelRequire("dntsQ");
parcelRequire("jDiDD");
var $29k5C = parcelRequire("29k5C");

var $coVSr = parcelRequire("coVSr");

var $hkds1 = parcelRequire("hkds1");

var $533t4 = parcelRequire("533t4");

var $90Jyl = parcelRequire("90Jyl");
$parcel$exportWildcard(module.exports, $90Jyl);

});
parcelRegister("iYbM9", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", function () { return $dcf6f7014489da29$export$5fc74f25506aa9c; });

var $b6c9K = parcelRequire("b6c9K");
parcelRequire("jDiDD");
var $7iEy8 = parcelRequire("7iEy8");
var $dcf6f7014489da29$export$5fc74f25506aa9c = function() {
    function ApolloCache() {
        this.getFragmentDoc = (0, $b6c9K.wrap)((0, $7iEy8.getFragmentQueryDocument));
    }
    ApolloCache.prototype.recordOptimisticTransaction = function(transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.identify = function(object) {
        return;
    };
    ApolloCache.prototype.gc = function() {
        return [];
    };
    ApolloCache.prototype.modify = function(options) {
        return false;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            rootId: options.id || 'ROOT_QUERY',
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: this.getFragmentDoc(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        return this.write({
            dataId: options.id || 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables,
            broadcast: options.broadcast
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        return this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: this.getFragmentDoc(options.fragment, options.fragmentName),
            broadcast: options.broadcast
        });
    };
    return ApolloCache;
}();

});
parcelRegister("b6c9K", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", function () { return $8149af3eb31ef64b$export$6bd8d8299be3ac82; });
$parcel$export(module.exports, "dep", function () { return $8149af3eb31ef64b$export$c723b7eff9d8f870; });
$parcel$export(module.exports, "wrap", function () { return $8149af3eb31ef64b$export$4997ffc0176396a6; });

var $gbikD = parcelRequire("gbikD");
function $8149af3eb31ef64b$var$defaultDispose() {}
var $8149af3eb31ef64b$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $8149af3eb31ef64b$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $8149af3eb31ef64b$var$parentEntrySlot = new (0, $gbikD.Slot)();
function $8149af3eb31ef64b$var$maybeUnsubscribe(entryOrDep) {
    var unsubscribe = entryOrDep.unsubscribe;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}
var $8149af3eb31ef64b$var$emptySetPool = [];
var $8149af3eb31ef64b$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $8149af3eb31ef64b$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $8149af3eb31ef64b$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $8149af3eb31ef64b$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $8149af3eb31ef64b$var$valueCopy(value) {
    return value.slice(0);
}
var $8149af3eb31ef64b$var$Entry = /** @class */ function() {
    function Entry(fn) {
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++Entry.count;
    }
    Entry.prototype.peek = function() {
        if (this.value.length === 1 && !$8149af3eb31ef64b$var$mightBeDirty(this)) return this.value[0];
    };
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function(args) {
        $8149af3eb31ef64b$var$assert(!this.recomputing, "already recomputing");
        $8149af3eb31ef64b$var$rememberParent(this);
        return $8149af3eb31ef64b$var$mightBeDirty(this) ? $8149af3eb31ef64b$var$reallyRecompute(this, args) : $8149af3eb31ef64b$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $8149af3eb31ef64b$var$reportDirty(this);
        $8149af3eb31ef64b$var$forgetChildren(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $8149af3eb31ef64b$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $8149af3eb31ef64b$var$forgetChildren(this);
        $8149af3eb31ef64b$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $8149af3eb31ef64b$var$forgetChild(parent, _this);
        });
    };
    Entry.prototype.dependOn = function(dep) {
        dep.add(this);
        if (!this.deps) this.deps = $8149af3eb31ef64b$var$emptySetPool.pop() || new Set();
        this.deps.add(dep);
    };
    Entry.prototype.forgetDeps = function() {
        var _this = this;
        if (this.deps) {
            this.deps.forEach(function(dep) {
                return dep.delete(_this);
            });
            this.deps.clear();
            $8149af3eb31ef64b$var$emptySetPool.push(this.deps);
            this.deps = null;
        }
    };
    Entry.count = 0;
    return Entry;
}();
function $8149af3eb31ef64b$var$rememberParent(child) {
    var parent = $8149af3eb31ef64b$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($8149af3eb31ef64b$var$mightBeDirty(child)) $8149af3eb31ef64b$var$reportDirtyChild(parent, child);
        else $8149af3eb31ef64b$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $8149af3eb31ef64b$var$reallyRecompute(entry, args) {
    $8149af3eb31ef64b$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $8149af3eb31ef64b$var$parentEntrySlot.withValue(entry, $8149af3eb31ef64b$var$recomputeNewValue, [
        entry,
        args
    ]);
    if ($8149af3eb31ef64b$var$maybeSubscribe(entry, args)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $8149af3eb31ef64b$var$setClean(entry);
    return $8149af3eb31ef64b$var$valueGet(entry.value);
}
function $8149af3eb31ef64b$var$recomputeNewValue(entry, args) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $8149af3eb31ef64b$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $8149af3eb31ef64b$var$setClean(entry) {
    entry.dirty = false;
    if ($8149af3eb31ef64b$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $8149af3eb31ef64b$var$reportClean(entry);
}
function $8149af3eb31ef64b$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $8149af3eb31ef64b$var$reportDirtyChild(parent, child);
    });
}
function $8149af3eb31ef64b$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $8149af3eb31ef64b$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $8149af3eb31ef64b$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $8149af3eb31ef64b$var$assert(parent.childValues.has(child));
    $8149af3eb31ef64b$var$assert($8149af3eb31ef64b$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $8149af3eb31ef64b$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $8149af3eb31ef64b$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $8149af3eb31ef64b$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $8149af3eb31ef64b$var$assert(parent.childValues.has(child));
    $8149af3eb31ef64b$var$assert(!$8149af3eb31ef64b$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $8149af3eb31ef64b$var$valueCopy(child.value));
    else if (!$8149af3eb31ef64b$var$valueIs(childValue, child.value)) parent.setDirty();
    $8149af3eb31ef64b$var$removeDirtyChild(parent, child);
    if ($8149af3eb31ef64b$var$mightBeDirty(parent)) return;
    $8149af3eb31ef64b$var$reportClean(parent);
}
function $8149af3eb31ef64b$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($8149af3eb31ef64b$var$emptySetPool.length < $8149af3eb31ef64b$var$POOL_TARGET_SIZE) $8149af3eb31ef64b$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function $8149af3eb31ef64b$var$forgetChildren(parent) {
    if (parent.childValues.size > 0) parent.childValues.forEach(function(_value, child) {
        $8149af3eb31ef64b$var$forgetChild(parent, child);
    });
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $8149af3eb31ef64b$var$assert(parent.dirtyChildren === null);
}
function $8149af3eb31ef64b$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $8149af3eb31ef64b$var$removeDirtyChild(parent, child);
}
function $8149af3eb31ef64b$var$maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") try {
        $8149af3eb31ef64b$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// no-prototype Object.
var $8149af3eb31ef64b$var$defaultMakeData = function() {
    return Object.create(null);
};
// Useful for processing arguments objects as well as arrays.
var $8149af3eb31ef64b$var$_a = Array.prototype, $8149af3eb31ef64b$var$forEach = $8149af3eb31ef64b$var$_a.forEach, $8149af3eb31ef64b$var$slice = $8149af3eb31ef64b$var$_a.slice;
var $8149af3eb31ef64b$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness, makeData) {
        if (makeData === void 0) makeData = $8149af3eb31ef64b$var$defaultMakeData;
        this.weakness = weakness;
        this.makeData = makeData;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        $8149af3eb31ef64b$var$forEach.call(array, function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = this.makeData($8149af3eb31ef64b$var$slice.call(array)));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $8149af3eb31ef64b$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness, this.makeData));
        return child;
    };
    return KeyTrie;
}();
function $8149af3eb31ef64b$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
function $8149af3eb31ef64b$export$c723b7eff9d8f870(options) {
    var depsByKey = new Map();
    var subscribe = options && options.subscribe;
    function depend(key) {
        var parent = $8149af3eb31ef64b$var$parentEntrySlot.getValue();
        if (parent) {
            var dep_1 = depsByKey.get(key);
            if (!dep_1) depsByKey.set(key, dep_1 = new Set);
            parent.dependOn(dep_1);
            if (typeof subscribe === "function") {
                $8149af3eb31ef64b$var$maybeUnsubscribe(dep_1);
                dep_1.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key) {
        var dep = depsByKey.get(key);
        if (dep) {
            dep.forEach(function(entry) {
                return entry.setDirty();
            });
            depsByKey.delete(key);
            $8149af3eb31ef64b$var$maybeUnsubscribe(dep);
        }
    };
    return depend;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $8149af3eb31ef64b$var$keyTrie = new $8149af3eb31ef64b$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $8149af3eb31ef64b$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $8149af3eb31ef64b$var$keyTrie.lookupArray(args);
}
var $8149af3eb31ef64b$var$caches = new Set();
function $8149af3eb31ef64b$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $8149af3eb31ef64b$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var keyArgs = options.keyArgs || function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return args;
    };
    var makeCacheKey = options.makeCacheKey || $8149af3eb31ef64b$export$cd3144f8dd136006;
    function optimistic() {
        var key = makeCacheKey.apply(null, keyArgs.apply(null, arguments));
        if (key === void 0) return originalFunction.apply(null, arguments);
        var entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new $8149af3eb31ef64b$var$Entry(originalFunction));
            entry.subscribe = options.subscribe;
        }
        var value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $8149af3eb31ef64b$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$8149af3eb31ef64b$var$parentEntrySlot.hasValue()) {
            $8149af3eb31ef64b$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $8149af3eb31ef64b$var$caches.clear();
        }
        return value;
    }
    function lookup() {
        var key = makeCacheKey.apply(null, arguments);
        if (key !== void 0) return cache.get(key);
    }
    optimistic.dirty = function() {
        var entry = lookup.apply(null, arguments);
        if (entry) entry.setDirty();
    };
    optimistic.peek = function() {
        var entry = lookup.apply(null, arguments);
        if (entry) return entry.peek();
    };
    optimistic.forget = function() {
        var key = makeCacheKey.apply(null, arguments);
        return key !== void 0 && cache.delete(key);
    };
    return optimistic;
}

});
parcelRegister("gbikD", function(module, exports) {

$parcel$export(module.exports, "Slot", function () { return $bc7be4bc0e0dbf5c$export$8c6ed5c666ac1360; });
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $bc7be4bc0e0dbf5c$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $bc7be4bc0e0dbf5c$var$MISSING_VALUE = {};
var $bc7be4bc0e0dbf5c$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $bc7be4bc0e0dbf5c$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $bc7be4bc0e0dbf5c$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $bc7be4bc0e0dbf5c$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $bc7be4bc0e0dbf5c$var$MISSING_VALUE) break;
                if (context_1 !== $bc7be4bc0e0dbf5c$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $bc7be4bc0e0dbf5c$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($bc7be4bc0e0dbf5c$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $bc7be4bc0e0dbf5c$var$currentContext.slots[this.id] = $bc7be4bc0e0dbf5c$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $bc7be4bc0e0dbf5c$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $bc7be4bc0e0dbf5c$var$currentContext;
            $bc7be4bc0e0dbf5c$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $bc7be4bc0e0dbf5c$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $bc7be4bc0e0dbf5c$var$currentContext;
            return function() {
                var saved = $bc7be4bc0e0dbf5c$var$currentContext;
                try {
                    $bc7be4bc0e0dbf5c$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $bc7be4bc0e0dbf5c$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($bc7be4bc0e0dbf5c$var$currentContext) {
                var saved = $bc7be4bc0e0dbf5c$var$currentContext;
                try {
                    $bc7be4bc0e0dbf5c$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $bc7be4bc0e0dbf5c$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $bc7be4bc0e0dbf5c$var$globalKey = "@wry/context:Slot";
var $bc7be4bc0e0dbf5c$var$host = Array;
var $bc7be4bc0e0dbf5c$export$8c6ed5c666ac1360 = $bc7be4bc0e0dbf5c$var$host[$bc7be4bc0e0dbf5c$var$globalKey] || function() {
    var Slot = $bc7be4bc0e0dbf5c$var$makeSlotClass();
    try {
        Object.defineProperty($bc7be4bc0e0dbf5c$var$host, $bc7be4bc0e0dbf5c$var$globalKey, {
            value: $bc7be4bc0e0dbf5c$var$host[$bc7be4bc0e0dbf5c$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $bc7be4bc0e0dbf5c$export$2385a24977818dd0 = $bc7be4bc0e0dbf5c$export$8c6ed5c666ac1360.bind, $bc7be4bc0e0dbf5c$export$9fa6f2e300a97f8 = $bc7be4bc0e0dbf5c$export$8c6ed5c666ac1360.noContext;
function $bc7be4bc0e0dbf5c$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($bc7be4bc0e0dbf5c$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $bc7be4bc0e0dbf5c$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $bc7be4bc0e0dbf5c$export$2385a24977818dd0(gen.next);
        var boundThrow = $bc7be4bc0e0dbf5c$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($bc7be4bc0e0dbf5c$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $bc7be4bc0e0dbf5c$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $bc7be4bc0e0dbf5c$var$wrappedFibers = [];
function $bc7be4bc0e0dbf5c$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($bc7be4bc0e0dbf5c$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $bc7be4bc0e0dbf5c$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $bc7be4bc0e0dbf5c$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("6XbPg", function(module, exports) {
var $51016d253e559b08$export$94affb487e701bf2;
$51016d253e559b08$export$94affb487e701bf2 || ($51016d253e559b08$export$94affb487e701bf2 = {});

});

parcelRegister("dntsQ", function(module, exports) {

$parcel$export(module.exports, "MissingFieldError", function () { return $9bd44759188828f6$export$257c68286583b0f9; });
var $9bd44759188828f6$export$257c68286583b0f9 = function() {
    function MissingFieldError(message, path, query, clientOnly, variables) {
        this.message = message;
        this.path = path;
        this.query = query;
        this.clientOnly = clientOnly;
        this.variables = variables;
    }
    return MissingFieldError;
}();

});

parcelRegister("coVSr", function(module, exports) {

$parcel$export(module.exports, "InMemoryCache", function () { return $90749f1709b614b0$export$467265324939f47f; });

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("iPM2j");

var $b6c9K = parcelRequire("b6c9K");

var $iYbM9 = parcelRequire("iYbM9");
parcelRequire("jDiDD");
var $h5QgY = parcelRequire("h5QgY");
var $29k5C = parcelRequire("29k5C");

var $95vm4 = parcelRequire("95vm4");

var $hUeSK = parcelRequire("hUeSK");

var $4Jf2g = parcelRequire("4Jf2g");

var $hkds1 = parcelRequire("hkds1");

var $533t4 = parcelRequire("533t4");

var $efXDU = parcelRequire("efXDU");
var $90749f1709b614b0$var$defaultConfig = {
    dataIdFromObject: (0, $533t4.defaultDataIdFromObject),
    addTypename: true,
    resultCaching: true,
    typePolicies: {}
};
var $90749f1709b614b0$export$467265324939f47f = function(_super) {
    (0, $fH1jI.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.makeVar = (0, $hkds1.makeVar);
        _this.txCount = 0;
        _this.maybeBroadcastWatch = (0, $b6c9K.wrap)(function(c, fromOptimisticTransaction) {
            return _this.broadcastWatch.call(_this, c, !!fromOptimisticTransaction);
        }, {
            makeCacheKey: function(c) {
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if ((0, $4Jf2g.supportsResultCaching)(store)) {
                    var optimistic = c.optimistic, rootId = c.rootId, variables = c.variables;
                    return store.makeCacheKey(c.query, c.callback, JSON.stringify({
                        optimistic: optimistic,
                        rootId: rootId,
                        variables: variables
                    }));
                }
            }
        });
        _this.watchDep = (0, $b6c9K.dep)();
        _this.config = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, $90749f1709b614b0$var$defaultConfig), config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new (0, $533t4.Policies)({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies
        });
        _this.data = new (0, $4Jf2g.EntityStore).Root({
            policies: _this.policies,
            resultCaching: _this.config.resultCaching
        });
        _this.optimisticData = _this.data;
        _this.storeWriter = new (0, $hUeSK.StoreWriter)(_this, _this.storeReader = new (0, $95vm4.StoreReader)({
            cache: _this,
            addTypename: _this.addTypename
        }));
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        var store = options.optimistic ? this.optimisticData : this.data;
        if (typeof options.rootId === 'string' && !store.has(options.rootId)) return null;
        return this.storeReader.diffQueryAgainstStore({
            store: store,
            query: options.query,
            variables: options.variables,
            rootId: options.rootId,
            config: this.config,
            returnPartialData: false
        }).result || null;
    };
    InMemoryCache.prototype.write = function(options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore({
                store: this.data,
                query: options.query,
                result: options.result,
                dataId: options.dataId,
                variables: options.variables
            });
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.modify = function(options) {
        if ((0, $efXDU.hasOwn).call(options, "id") && !options.id) return false;
        var store = options.optimistic ? this.optimisticData : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.diff = function(options) {
        return this.storeReader.diffQueryAgainstStore({
            store: options.optimistic ? this.optimisticData : this.data,
            rootId: options.id || "ROOT_QUERY",
            query: options.query,
            variables: options.variables,
            returnPartialData: options.returnPartialData,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        if (watch.immediate) this.maybeBroadcastWatch(watch);
        return function() {
            _this.watches.delete(watch);
            _this.watchDep.dirty(watch);
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function() {
        return this.optimisticData.gc();
    };
    InMemoryCache.prototype.retain = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    InMemoryCache.prototype.release = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    InMemoryCache.prototype.identify = function(object) {
        return (0, $29k5C.isReference)(object) ? object.__ref : this.policies.identify(object)[0];
    };
    InMemoryCache.prototype.evict = function(options) {
        if (!options.id) {
            if ((0, $efXDU.hasOwn).call(options, "id")) return false;
            options = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, options), {
                id: "ROOT_QUERY"
            });
        }
        try {
            ++this.txCount;
            return this.optimisticData.evict(options);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.optimisticData = this.data;
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _this = this;
        var perform = function(layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) _this.data = _this.optimisticData = layer;
            try {
                transaction(_this);
            } finally{
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var fromOptimisticTransaction = false;
        if (typeof optimisticId === 'string') {
            this.optimisticData = this.optimisticData.addLayer(optimisticId, perform);
            fromOptimisticTransaction = true;
        } else if (optimisticId === null) perform(this.data);
        else perform();
        this.broadcastWatches(fromOptimisticTransaction);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $h5QgY.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function(fromOptimisticTransaction) {
        var _this = this;
        if (!this.txCount) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c, fromOptimisticTransaction);
        });
    };
    InMemoryCache.prototype.broadcastWatch = function(c, fromOptimisticTransaction) {
        this.watchDep.dirty(c);
        this.watchDep(c);
        var diff = this.diff({
            query: c.query,
            variables: c.variables,
            optimistic: c.optimistic
        });
        if (c.optimistic && fromOptimisticTransaction) diff.fromOptimisticTransaction = true;
        c.callback(diff);
    };
    return InMemoryCache;
}((0, $iYbM9.ApolloCache));

});
parcelRegister("iPM2j", function(module, exports) {

});

parcelRegister("95vm4", function(module, exports) {

$parcel$export(module.exports, "StoreReader", function () { return $69dce727bc384f75$export$628ef07ba8965f12; });

var $fH1jI = parcelRequire("fH1jI");

var $b6c9K = parcelRequire("b6c9K");

var $5TDOW = parcelRequire("5TDOW");
parcelRequire("jDiDD");
var $h5QgY = parcelRequire("h5QgY");
var $7iEy8 = parcelRequire("7iEy8");
var $8gQB0 = parcelRequire("8gQB0");
var $29k5C = parcelRequire("29k5C");
var $l33xE = parcelRequire("l33xE");
var $fNOO0 = parcelRequire("fNOO0");

var $4Jf2g = parcelRequire("4Jf2g");
parcelRequire("efXDU");

var $dntsQ = parcelRequire("dntsQ");
function $69dce727bc384f75$var$missingFromInvariant(err, context) {
    return new (0, $dntsQ.MissingFieldError)(err.message, context.path.slice(), context.query, context.clientOnly, context.variables);
}
var $69dce727bc384f75$export$628ef07ba8965f12 = function() {
    function StoreReader(config) {
        var _this = this;
        this.config = config;
        this.executeSelectionSet = (0, $b6c9K.wrap)(function(options) {
            return _this.execSelectionSetImpl(options);
        }, {
            keyArgs: function(options) {
                return [
                    options.selectionSet,
                    options.objectOrReference,
                    options.context
                ];
            },
            makeCacheKey: function(selectionSet, parent, context) {
                if ((0, $4Jf2g.supportsResultCaching)(context.store)) return context.store.makeCacheKey(selectionSet, (0, $29k5C.isReference)(parent) ? parent.__ref : parent, context.varString);
            }
        });
        this.knownResults = new WeakMap();
        this.executeSubSelectedArray = (0, $b6c9K.wrap)(function(options) {
            return _this.execSubSelectedArrayImpl(options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if ((0, $4Jf2g.supportsResultCaching)(context.store)) return context.store.makeCacheKey(field, array, context.varString);
            }
        });
        this.config = (0, $fH1jI.__assign)({
            addTypename: true
        }, config);
    }
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? 'ROOT_QUERY' : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c;
        var policies = this.config.cache.policies;
        variables = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, (0, $8gQB0.getDefaultValues)((0, $8gQB0.getQueryDefinition)(query))), variables);
        var execResult = this.executeSelectionSet({
            selectionSet: (0, $8gQB0.getMainDefinition)(query).selectionSet,
            objectOrReference: (0, $29k5C.makeReference)(rootId),
            context: {
                store: store,
                query: query,
                policies: policies,
                variables: variables,
                varString: JSON.stringify(variables),
                fragmentMap: (0, $7iEy8.createFragmentMap)((0, $8gQB0.getFragmentDefinitions)(query)),
                path: [],
                clientOnly: false
            }
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) throw execResult.missing[0];
        return {
            result: execResult.result,
            missing: execResult.missing,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.isFresh = function(result, parent, selectionSet, context) {
        if ((0, $4Jf2g.supportsResultCaching)(context.store) && this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context);
            if (latest && result === latest.result) return true;
        }
        return false;
    };
    StoreReader.prototype.execSelectionSetImpl = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, context = _a.context;
        if ((0, $29k5C.isReference)(objectOrReference) && !context.policies.rootTypenamesById[objectOrReference.__ref] && !context.store.has(objectOrReference.__ref)) return {
            result: {},
            missing: [
                $69dce727bc384f75$var$missingFromInvariant(new (0, $5TDOW.InvariantError)(4), context)
            ]
        };
        var variables = context.variables, policies = context.policies, store = context.store;
        var objectsToMerge = [];
        var finalResult = {
            result: null
        };
        var typename = store.getFieldValue(objectOrReference, "__typename");
        if (this.config.addTypename && typeof typename === "string" && !policies.rootIdsByTypename[typename]) objectsToMerge.push({
            __typename: typename
        });
        function getMissing() {
            return finalResult.missing || (finalResult.missing = []);
        }
        function handleMissing(result) {
            var _a;
            if (result.missing) (_a = getMissing()).push.apply(_a, result.missing);
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function(selection) {
            var _a;
            if (!(0, $fNOO0.shouldInclude)(selection, variables)) return;
            if ((0, $29k5C.isField)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference
                }, context);
                var resultName = (0, $29k5C.resultKeyNameFromField)(selection);
                context.path.push(resultName);
                var wasClientOnly = context.clientOnly;
                context.clientOnly = wasClientOnly || !!(selection.directives && selection.directives.some(function(d) {
                    return d.name.value === "client";
                }));
                if (fieldValue === void 0) {
                    if (!(0, $h5QgY.addTypenameToDocument).added(selection)) getMissing().push($69dce727bc384f75$var$missingFromInvariant(new (0, $5TDOW.InvariantError)(5), context));
                } else if (Array.isArray(fieldValue)) fieldValue = handleMissing(_this.executeSubSelectedArray({
                    field: selection,
                    array: fieldValue,
                    context: context
                }));
                else if (!selection.selectionSet) ;
                else if (fieldValue != null) fieldValue = handleMissing(_this.executeSelectionSet({
                    selectionSet: selection.selectionSet,
                    objectOrReference: fieldValue,
                    context: context
                }));
                if (fieldValue !== void 0) objectsToMerge.push((_a = {}, _a[resultName] = fieldValue, _a));
                context.clientOnly = wasClientOnly;
                (0, $5TDOW.invariant)(context.path.pop() === resultName);
            } else {
                var fragment = (0, $7iEy8.getFragmentFromSelection)(selection, context.fragmentMap);
                if (fragment && policies.fragmentMatches(fragment, typename)) fragment.selectionSet.selections.forEach(workSet.add, workSet);
            }
        });
        finalResult.result = (0, $l33xE.mergeDeepArray)(objectsToMerge);
        this.knownResults.set(finalResult.result, selectionSet);
        return finalResult;
    };
    StoreReader.prototype.execSubSelectedArrayImpl = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, context = _a.context;
        var missing;
        function handleMissing(childResult, i) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            (0, $5TDOW.invariant)(context.path.pop() === i);
            return childResult.result;
        }
        if (field.selectionSet) array = array.filter(context.store.canRead);
        array = array.map(function(item, i) {
            if (item === null) return null;
            context.path.push(i);
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                context: context
            }), i);
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                objectOrReference: item,
                context: context
            }), i);
            (0, $5TDOW.invariant)(context.path.pop() === i);
            return item;
        });
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $69dce727bc384f75$var$assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([
            fieldValue
        ]);
        workSet_1.forEach(function(value) {
            if (value && typeof value === "object") {
                (0, $5TDOW.invariant)(!(0, $29k5C.isReference)(value), 6);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}

});
parcelRegister("4Jf2g", function(module, exports) {

$parcel$export(module.exports, "EntityStore", function () { return $3717072152d102b6$export$cb507f57054c7321; });
$parcel$export(module.exports, "supportsResultCaching", function () { return $3717072152d102b6$export$488c0743feab3d61; });

var $fH1jI = parcelRequire("fH1jI");

var $b6c9K = parcelRequire("b6c9K");

var $4NlT6 = parcelRequire("4NlT6");
parcelRequire("jDiDD");
var $7hgpT = parcelRequire("7hgpT");
var $l33xE = parcelRequire("l33xE");
var $29k5C = parcelRequire("29k5C");
var $ezqAI = parcelRequire("ezqAI");

var $efXDU = parcelRequire("efXDU");
var $3717072152d102b6$var$DELETE = Object.create(null);
var $3717072152d102b6$var$delModifier = function() {
    return $3717072152d102b6$var$DELETE;
};
var $3717072152d102b6$var$INVALIDATE = Object.create(null);
var $3717072152d102b6$export$cb507f57054c7321 = function() {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        this.rootIds = Object.create(null);
        this.refs = Object.create(null);
        this.getFieldValue = function(objectOrReference, storeFieldName) {
            return (0, $ezqAI.maybeDeepFreeze)((0, $29k5C.isReference)(objectOrReference) ? _this.get(objectOrReference.__ref, storeFieldName) : objectOrReference && objectOrReference[storeFieldName]);
        };
        this.canRead = function(objOrRef) {
            return (0, $29k5C.isReference)(objOrRef) ? _this.has(objOrRef.__ref) : typeof objOrRef === "object";
        };
        this.toReference = function(objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") return (0, $29k5C.makeReference)(objOrIdOrRef);
            if ((0, $29k5C.isReference)(objOrIdOrRef)) return objOrIdOrRef;
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0, $29k5C.makeReference)(id);
                if (mergeIntoStore) _this.merge(id, objOrIdOrRef);
                return ref;
            }
        };
    }
    EntityStore.prototype.toObject = function() {
        return (0, $fH1jI.__assign)({}, this.data);
    };
    EntityStore.prototype.has = function(dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function(dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if ((0, $efXDU.hasOwn).call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && (0, $efXDU.hasOwn).call(storeObject, fieldName)) return storeObject[fieldName];
        }
        if (fieldName === "__typename" && (0, $efXDU.hasOwn).call(this.policies.rootTypenamesById, dataId)) return this.policies.rootTypenamesById[dataId];
        if (this instanceof $3717072152d102b6$var$Layer) return this.parent.get(dataId, fieldName);
    };
    EntityStore.prototype.lookup = function(dataId, dependOnExistence) {
        if (dependOnExistence) this.group.depend(dataId, "__exists");
        return (0, $efXDU.hasOwn).call(this.data, dataId) ? this.data[dataId] : this instanceof $3717072152d102b6$var$Layer ? this.parent.lookup(dataId, dependOnExistence) : void 0;
    };
    EntityStore.prototype.merge = function(dataId, incoming) {
        var _this = this;
        var existing = this.lookup(dataId);
        var merged = new (0, $l33xE.DeepMerger)($3717072152d102b6$var$storeObjectReconciler).merge(existing, incoming);
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                if (!existing) fieldsToDirty_1.__exists = 1;
                Object.keys(incoming).forEach(function(storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        fieldsToDirty_1[(0, $efXDU.fieldNameFromStoreName)(storeFieldName)] = 1;
                        if (merged[storeFieldName] === void 0 && !(_this instanceof $3717072152d102b6$var$Layer)) delete merged[storeFieldName];
                    }
                });
                Object.keys(fieldsToDirty_1).forEach(function(fieldName) {
                    return _this.group.dirty(dataId, fieldName);
                });
            }
        }
    };
    EntityStore.prototype.modify = function(dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: $3717072152d102b6$var$DELETE,
                INVALIDATE: $3717072152d102b6$var$INVALIDATE,
                isReference: (0, $29k5C.isReference),
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function(fieldNameOrOptions, from) {
                    return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                        fieldName: fieldNameOrOptions,
                        from: from || (0, $29k5C.makeReference)(dataId)
                    } : fieldNameOrOptions, {
                        store: _this
                    });
                }
            };
            Object.keys(storeObject).forEach(function(storeFieldName) {
                var fieldName = (0, $efXDU.fieldNameFromStoreName)(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0) return;
                var modify = typeof fields === "function" ? fields : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === $3717072152d102b6$var$delModifier ? $3717072152d102b6$var$DELETE : modify((0, $ezqAI.maybeDeepFreeze)(fieldValue), (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, sharedDetails_1), {
                        fieldName: fieldName,
                        storeFieldName: storeFieldName,
                        storage: _this.getStorage(dataId, storeFieldName)
                    }));
                    if (newValue === $3717072152d102b6$var$INVALIDATE) _this.group.dirty(dataId, storeFieldName);
                    else {
                        if (newValue === $3717072152d102b6$var$DELETE) newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                        }
                    }
                }
                if (fieldValue !== void 0) allDeleted_1 = false;
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof $3717072152d102b6$var$Layer) this.data[dataId] = void 0;
                    else delete this.data[dataId];
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    EntityStore.prototype.delete = function(dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args ? this.policies.getStoreFieldName({
                typename: typename,
                fieldName: fieldName,
                args: args
            }) : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {}, _a[storeFieldName] = $3717072152d102b6$var$delModifier, _a) : $3717072152d102b6$var$delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function(options) {
        var evicted = false;
        if (options.id) {
            if ((0, $efXDU.hasOwn).call(this.data, options.id)) evicted = this.delete(options.id, options.fieldName, options.args);
            if (this instanceof $3717072152d102b6$var$Layer) evicted = this.parent.evict(options) || evicted;
            if (options.fieldName || evicted) this.group.dirty(options.id, options.fieldName || "__exists");
        }
        return evicted;
    };
    EntityStore.prototype.clear = function() {
        this.replace(null);
    };
    EntityStore.prototype.replace = function(newData) {
        var _this = this;
        Object.keys(this.data).forEach(function(dataId) {
            if (!(newData && (0, $efXDU.hasOwn).call(newData, dataId))) _this.delete(dataId);
        });
        if (newData) Object.keys(newData).forEach(function(dataId) {
            _this.merge(dataId, newData[dataId]);
        });
    };
    EntityStore.prototype.retain = function(rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function(rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count) delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    EntityStore.prototype.getRootIdSet = function(ids) {
        if (ids === void 0) ids = new Set();
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof $3717072152d102b6$var$Layer) this.parent.getRootIdSet(ids);
        return ids;
    };
    EntityStore.prototype.gc = function() {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function(id) {
            if ((0, $efXDU.hasOwn).call(snapshot, id)) {
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while(root_1 instanceof $3717072152d102b6$var$Layer)root_1 = root_1.parent;
            idsToRemove.forEach(function(id) {
                return root_1.delete(id);
            });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function(dataId) {
        if (!(0, $efXDU.hasOwn).call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var workSet_1 = new Set([
                this.data[dataId]
            ]);
            var canTraverse_1 = function(obj) {
                return obj !== null && typeof obj === 'object';
            };
            workSet_1.forEach(function(obj) {
                if ((0, $29k5C.isReference)(obj)) found_1[obj.__ref] = true;
                else if (canTraverse_1(obj)) Object.values(obj).filter(canTraverse_1).forEach(workSet_1.add, workSet_1);
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return this.group.keyMaker.lookupArray(args);
    };
    return EntityStore;
}();
var $3717072152d102b6$var$CacheGroup = function() {
    function CacheGroup(caching) {
        this.caching = caching;
        this.d = null;
        this.keyMaker = new (0, $b6c9K.KeyTrie)((0, $7hgpT.canUseWeakMap));
        this.d = caching ? (0, $b6c9K.dep)() : null;
    }
    CacheGroup.prototype.depend = function(dataId, storeFieldName) {
        if (this.d) this.d($3717072152d102b6$var$makeDepKey(dataId, storeFieldName));
    };
    CacheGroup.prototype.dirty = function(dataId, storeFieldName) {
        if (this.d) this.d.dirty($3717072152d102b6$var$makeDepKey(dataId, storeFieldName));
    };
    return CacheGroup;
}();
function $3717072152d102b6$var$makeDepKey(dataId, storeFieldName) {
    return (0, $efXDU.fieldNameFromStoreName)(storeFieldName) + '#' + dataId;
}
(function(EntityStore) {
    var Root = function(_super) {
        (0, $fH1jI.__extends)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new $3717072152d102b6$var$CacheGroup(resultCaching)) || this;
            _this.storageTrie = new (0, $b6c9K.KeyTrie)((0, $7hgpT.canUseWeakMap));
            _this.sharedLayerGroup = new $3717072152d102b6$var$CacheGroup(resultCaching);
            if (seed) _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function(layerId, replay) {
            return new $3717072152d102b6$var$Layer(layerId, this, replay, this.sharedLayerGroup);
        };
        Root.prototype.removeLayer = function() {
            return this;
        };
        Root.prototype.getStorage = function(idOrObj, storeFieldName) {
            return this.storageTrie.lookup(idOrObj, storeFieldName);
        };
        return Root;
    }(EntityStore);
    EntityStore.Root = Root;
})($3717072152d102b6$export$cb507f57054c7321 || ($3717072152d102b6$export$cb507f57054c7321 = {}));
var $3717072152d102b6$var$Layer = function(_super) {
    (0, $fH1jI.__extends)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function(layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function(layerId) {
        var _this = this;
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) Object.keys(this.data).forEach(function(dataId) {
                if (_this.data[dataId] !== parent.lookup(dataId)) _this.delete(dataId);
            });
            return parent;
        }
        if (parent === this.parent) return this;
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function() {
        return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function(dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return (0, $efXDU.hasOwn).call(this.data, dataId) ? (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function(idOrObj, storeFieldName) {
        return this.parent.getStorage(idOrObj, storeFieldName);
    };
    return Layer;
}($3717072152d102b6$export$cb507f57054c7321);
function $3717072152d102b6$var$storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    return (0, $4NlT6.equal)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function $3717072152d102b6$export$488c0743feab3d61(store) {
    return !!(store instanceof $3717072152d102b6$export$cb507f57054c7321 && store.group.caching);
}

});
parcelRegister("efXDU", function(module, exports) {

$parcel$export(module.exports, "hasOwn", function () { return $a610bb39bfd7b62f$export$b5a638e9b3fff9f3; });
$parcel$export(module.exports, "TypeOrFieldNameRegExp", function () { return $a610bb39bfd7b62f$export$6ed54d4784f1ce28; });
$parcel$export(module.exports, "fieldNameFromStoreName", function () { return $a610bb39bfd7b62f$export$37874422037b6029; });
$parcel$export(module.exports, "selectionSetMatchesResult", function () { return $a610bb39bfd7b62f$export$60bd1cbb09c1a4a2; });
$parcel$export(module.exports, "storeValueIsStoreObject", function () { return $a610bb39bfd7b62f$export$4f39afca21bd938e; });
$parcel$export(module.exports, "isFieldValueToBeMerged", function () { return $a610bb39bfd7b62f$export$b9bba4172816f327; });
$parcel$export(module.exports, "makeProcessedFieldsMerger", function () { return $a610bb39bfd7b62f$export$b874a818f7a2fa6d; });
parcelRequire("jDiDD");
var $l33xE = parcelRequire("l33xE");
var $29k5C = parcelRequire("29k5C");
var $fNOO0 = parcelRequire("fNOO0");
var $a610bb39bfd7b62f$export$b5a638e9b3fff9f3 = Object.prototype.hasOwnProperty;
function $a610bb39bfd7b62f$export$fdef206c83ff2c09(store, objectOrReference) {
    return (0, $29k5C.isReference)(objectOrReference) ? store.get(objectOrReference.__ref, "__typename") : objectOrReference && objectOrReference.__typename;
}
var $a610bb39bfd7b62f$export$6ed54d4784f1ce28 = /^[_a-z][_0-9a-z]*/i;
function $a610bb39bfd7b62f$export$37874422037b6029(storeFieldName) {
    var match = storeFieldName.match($a610bb39bfd7b62f$export$6ed54d4784f1ce28);
    return match ? match[0] : storeFieldName;
}
function $a610bb39bfd7b62f$export$60bd1cbb09c1a4a2(selectionSet, result, variables) {
    if (result && typeof result === "object") return Array.isArray(result) ? result.every(function(item) {
        return $a610bb39bfd7b62f$export$60bd1cbb09c1a4a2(selectionSet, item, variables);
    }) : selectionSet.selections.every(function(field) {
        if ((0, $29k5C.isField)(field) && (0, $fNOO0.shouldInclude)(field, variables)) {
            var key = (0, $29k5C.resultKeyNameFromField)(field);
            return $a610bb39bfd7b62f$export$b5a638e9b3fff9f3.call(result, key) && (!field.selectionSet || $a610bb39bfd7b62f$export$60bd1cbb09c1a4a2(field.selectionSet, result[key], variables));
        }
        return true;
    });
    return false;
}
function $a610bb39bfd7b62f$export$4f39afca21bd938e(value) {
    return value !== null && typeof value === "object" && !(0, $29k5C.isReference)(value) && !Array.isArray(value);
}
function $a610bb39bfd7b62f$export$b9bba4172816f327(value) {
    var field = value && value.__field;
    return field && (0, $29k5C.isField)(field);
}
function $a610bb39bfd7b62f$export$b874a818f7a2fa6d() {
    return new (0, $l33xE.DeepMerger)($a610bb39bfd7b62f$var$reconcileProcessedFields);
}
var $a610bb39bfd7b62f$var$reconcileProcessedFields = function(existingObject, incomingObject, property) {
    var existing = existingObject[property];
    var incoming = incomingObject[property];
    if ($a610bb39bfd7b62f$export$b9bba4172816f327(existing)) {
        existing.__value = this.merge(existing.__value, $a610bb39bfd7b62f$export$b9bba4172816f327(incoming) ? incoming.__value : incoming);
        return existing;
    }
    if ($a610bb39bfd7b62f$export$b9bba4172816f327(incoming)) {
        incoming.__value = this.merge(existing, incoming.__value);
        return incoming;
    }
    return this.merge(existing, incoming);
};

});



parcelRegister("hUeSK", function(module, exports) {

$parcel$export(module.exports, "StoreWriter", function () { return $d09335de90436beb$export$eb8361c5d132fb8f; });

var $fH1jI = parcelRequire("fH1jI");

var $5TDOW = parcelRequire("5TDOW");

var $4NlT6 = parcelRequire("4NlT6");
parcelRequire("jDiDD");
var $7iEy8 = parcelRequire("7iEy8");
var $8gQB0 = parcelRequire("8gQB0");
var $29k5C = parcelRequire("29k5C");
var $fNOO0 = parcelRequire("fNOO0");

var $efXDU = parcelRequire("efXDU");
var $d09335de90436beb$export$eb8361c5d132fb8f = function() {
    function StoreWriter(cache, reader) {
        this.cache = cache;
        this.reader = reader;
    }
    StoreWriter.prototype.writeToStore = function(_a) {
        var query = _a.query, result = _a.result, dataId = _a.dataId, store = _a.store, variables = _a.variables;
        var operationDefinition = (0, $8gQB0.getOperationDefinition)(query);
        var merger = (0, $efXDU.makeProcessedFieldsMerger)();
        variables = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, (0, $8gQB0.getDefaultValues)(operationDefinition)), variables);
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            context: {
                store: store,
                written: Object.create(null),
                merge: function(existing, incoming) {
                    return merger.merge(existing, incoming);
                },
                variables: variables,
                varString: JSON.stringify(variables),
                fragmentMap: (0, $7iEy8.createFragmentMap)((0, $8gQB0.getFragmentDefinitions)(query))
            }
        });
        if (!(0, $29k5C.isReference)(ref)) throw new (0, $5TDOW.InvariantError)(7);
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function(_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, _b = _a.out, out = _b === void 0 ? {
            shouldApplyMerges: false
        } : _b;
        var policies = this.cache.policies;
        var _c = policies.identify(result, selectionSet, context.fragmentMap), id = _c[0], keyObject = _c[1];
        dataId = dataId || id;
        if ("string" === typeof dataId) {
            var sets = context.written[dataId] || (context.written[dataId] = []);
            var ref = (0, $29k5C.makeReference)(dataId);
            if (sets.indexOf(selectionSet) >= 0) return ref;
            sets.push(selectionSet);
            if (this.reader && this.reader.isFresh(result, ref, selectionSet, context)) return ref;
        }
        var mergedFields = Object.create(null);
        if (keyObject) mergedFields = context.merge(mergedFields, keyObject);
        var typename = dataId && policies.rootTypenamesById[dataId] || (0, $29k5C.getTypenameFromResult)(result, selectionSet, context.fragmentMap) || dataId && context.store.get(dataId, "__typename");
        if ("string" === typeof typename) mergedFields.__typename = typename;
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function(selection) {
            var _a;
            if (!(0, $fNOO0.shouldInclude)(selection, context.variables)) return;
            if ((0, $29k5C.isField)(selection)) {
                var resultFieldKey = (0, $29k5C.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') {
                    var storeFieldName = policies.getStoreFieldName({
                        typename: typename,
                        fieldName: selection.name.value,
                        field: selection,
                        variables: context.variables
                    });
                    var incomingValue = _this.processFieldValue(value, selection, context, out);
                    if (policies.hasMergeFunction(typename, selection.name.value)) {
                        incomingValue = {
                            __field: selection,
                            __typename: typename,
                            __value: incomingValue
                        };
                        out.shouldApplyMerges = true;
                    }
                    mergedFields = context.merge(mergedFields, (_a = {}, _a[storeFieldName] = incomingValue, _a));
                } else if (policies.usingPossibleTypes && !(0, $fNOO0.hasDirectives)([
                    "defer",
                    "client"
                ], selection)) throw new (0, $5TDOW.InvariantError)(8);
            } else {
                var fragment = (0, $7iEy8.getFragmentFromSelection)(selection, context.fragmentMap);
                if (fragment && policies.fragmentMatches(fragment, typename, result, context.variables)) fragment.selectionSet.selections.forEach(workSet.add, workSet);
            }
        });
        if ("string" === typeof dataId) {
            var entityRef_1 = (0, $29k5C.makeReference)(dataId);
            if (out.shouldApplyMerges) mergedFields = policies.applyMerges(entityRef_1, mergedFields, context);
            context.store.merge(dataId, mergedFields);
            return entityRef_1;
        }
        return mergedFields;
    };
    StoreWriter.prototype.processFieldValue = function(value, field, context, out) {
        var _this = this;
        if (!field.selectionSet || value === null) return value;
        if (Array.isArray(value)) return value.map(function(item) {
            return _this.processFieldValue(item, field, context, out);
        });
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            out: out
        });
    };
    return StoreWriter;
}();
var $d09335de90436beb$var$warnings = new Set();
function $d09335de90436beb$var$warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function(objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing) return;
    var incoming = getChild(incomingObj);
    if (!incoming) return;
    if ((0, $29k5C.isReference)(existing)) return;
    if ((0, $4NlT6.equal)(existing, incoming)) return;
    if (Object.keys(existing).every(function(key) {
        return store.getFieldValue(incoming, key) !== void 0;
    })) return;
    var parentType = store.getFieldValue(existingRef, "__typename") || store.getFieldValue(incomingObj, "__typename");
    var fieldName = (0, $efXDU.fieldNameFromStoreName)(storeFieldName);
    var typeDotName = parentType + "." + fieldName;
    if ($d09335de90436beb$var$warnings.has(typeDotName)) return;
    $d09335de90436beb$var$warnings.add(typeDotName);
    var childTypenames = [];
    if (!Array.isArray(existing) && !Array.isArray(incoming)) [
        existing,
        incoming
    ].forEach(function(child) {
        var typename = store.getFieldValue(child, "__typename");
        if (typeof typename === "string" && !childTypenames.includes(typename)) childTypenames.push(typename);
    });
}

});

parcelRegister("hkds1", function(module, exports) {

$parcel$export(module.exports, "cacheSlot", function () { return $c9cebd0559d6ad4f$export$ac9723609f5c76c2; });
$parcel$export(module.exports, "makeVar", function () { return $c9cebd0559d6ad4f$export$5345c8ac69b4a9db; });

var $gbikD = parcelRequire("gbikD");

var $b6c9K = parcelRequire("b6c9K");
var $c9cebd0559d6ad4f$var$varDep = (0, $b6c9K.dep)();
var $c9cebd0559d6ad4f$export$ac9723609f5c76c2 = new (0, $gbikD.Slot)();
function $c9cebd0559d6ad4f$var$consumeAndIterate(set, callback) {
    var items = [];
    set.forEach(function(item) {
        return items.push(item);
    });
    set.clear();
    items.forEach(callback);
}
function $c9cebd0559d6ad4f$export$5345c8ac69b4a9db(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function(newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                $c9cebd0559d6ad4f$var$varDep.dirty(rv);
                caches.forEach($c9cebd0559d6ad4f$var$broadcast);
                $c9cebd0559d6ad4f$var$consumeAndIterate(listeners, function(listener) {
                    return listener(value);
                });
            }
        } else {
            var cache = $c9cebd0559d6ad4f$export$ac9723609f5c76c2.getValue();
            if (cache) caches.add(cache);
            $c9cebd0559d6ad4f$var$varDep(rv);
        }
        return value;
    };
    rv.onNextChange = function(listener) {
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
        };
    };
    return rv;
}
function $c9cebd0559d6ad4f$var$broadcast(cache) {
    if (cache.broadcastWatches) cache.broadcastWatches();
}

});

parcelRegister("533t4", function(module, exports) {

$parcel$export(module.exports, "defaultDataIdFromObject", function () { return $3acfec3b5892fdcb$export$bd03c5a9c99d6bce; });
$parcel$export(module.exports, "Policies", function () { return $3acfec3b5892fdcb$export$e9859ad90648930b; });

var $fH1jI = parcelRequire("fH1jI");

var $b6c9K = parcelRequire("b6c9K");

var $5TDOW = parcelRequire("5TDOW");
parcelRequire("jDiDD");
var $29k5C = parcelRequire("29k5C");
var $7hgpT = parcelRequire("7hgpT");
var $7iEy8 = parcelRequire("7iEy8");

var $efXDU = parcelRequire("efXDU");

var $hkds1 = parcelRequire("hkds1");
function $3acfec3b5892fdcb$var$argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args : spec.field ? (0, $29k5C.argumentsObjectFromField)(spec.field, spec.variables) : null;
}
var $3acfec3b5892fdcb$export$bd03c5a9c99d6bce = function(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) context.keyObject = id !== void 0 ? {
            id: id
        } : _id !== void 0 ? {
            _id: _id
        } : void 0;
        if (id === void 0) id = _id;
        if (id !== void 0) return __typename + ":" + (typeof id === "number" || typeof id === "string" ? id : JSON.stringify(id));
    }
};
var $3acfec3b5892fdcb$var$nullKeyFieldsFn = function() {
    return void 0;
};
var $3acfec3b5892fdcb$var$simpleKeyArgsFn = function(_args, context) {
    return context.fieldName;
};
var $3acfec3b5892fdcb$var$mergeTrueFn = function(existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var $3acfec3b5892fdcb$var$mergeFalseFn = function(_, incoming) {
    return incoming;
};
var $3acfec3b5892fdcb$export$e9859ad90648930b = function() {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.supertypeMap = new Map();
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0, $fH1jI.__assign)({
            dataIdFromObject: $3acfec3b5892fdcb$export$bd03c5a9c99d6bce
        }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) this.addPossibleTypes(config.possibleTypes);
        if (config.typePolicies) this.addTypePolicies(config.typePolicies);
    }
    Policies.prototype.identify = function(object, selectionSet, fragmentMap) {
        var typename = selectionSet && fragmentMap ? (0, $29k5C.getTypenameFromResult)(object, selectionSet, fragmentMap) : object.__typename;
        if (typename === this.rootTypenamesById.ROOT_QUERY) return [
            "ROOT_QUERY"
        ];
        var context = {
            typename: typename,
            selectionSet: selectionSet,
            fragmentMap: fragmentMap
        };
        var id;
        var policy = this.getTypePolicy(typename, false);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        while(keyFn){
            var specifierOrId = keyFn(object, context);
            if (Array.isArray(specifierOrId)) keyFn = $3acfec3b5892fdcb$var$keyFieldsFnFromSpecifier(specifierOrId);
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id && String(id);
        return context.keyObject ? [
            id,
            context.keyObject
        ] : [
            id
        ];
    };
    Policies.prototype.addTypePolicies = function(typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function(typename) {
            var existing = _this.getTypePolicy(typename, true);
            var incoming = typePolicies[typename];
            var keyFields = incoming.keyFields, fields = incoming.fields;
            if (incoming.queryType) _this.setRootTypename("Query", typename);
            if (incoming.mutationType) _this.setRootTypename("Mutation", typename);
            if (incoming.subscriptionType) _this.setRootTypename("Subscription", typename);
            existing.keyFn = keyFields === false ? $3acfec3b5892fdcb$var$nullKeyFieldsFn : Array.isArray(keyFields) ? $3acfec3b5892fdcb$var$keyFieldsFnFromSpecifier(keyFields) : typeof keyFields === "function" ? keyFields : existing.keyFn;
            if (fields) Object.keys(fields).forEach(function(fieldName) {
                var existing = _this.getFieldPolicy(typename, fieldName, true);
                var incoming = fields[fieldName];
                if (typeof incoming === "function") existing.read = incoming;
                else {
                    var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                    existing.keyFn = keyArgs === false ? $3acfec3b5892fdcb$var$simpleKeyArgsFn : Array.isArray(keyArgs) ? $3acfec3b5892fdcb$var$keyArgsFnFromSpecifier(keyArgs) : typeof keyArgs === "function" ? keyArgs : existing.keyFn;
                    if (typeof read === "function") existing.read = read;
                    existing.merge = typeof merge === "function" ? merge : merge === true ? $3acfec3b5892fdcb$var$mergeTrueFn : merge === false ? $3acfec3b5892fdcb$var$mergeFalseFn : existing.merge;
                }
                if (existing.read && existing.merge) existing.keyFn = existing.keyFn || $3acfec3b5892fdcb$var$simpleKeyArgsFn;
            });
        });
    };
    Policies.prototype.setRootTypename = function(which, typename) {
        if (typename === void 0) typename = which;
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            (0, $5TDOW.invariant)(!old || old === which, 1);
            if (old) delete this.rootIdsByTypename[old];
            this.rootIdsByTypename[typename] = rootId;
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function(possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function(supertype) {
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function(subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match((0, $efXDU.TypeOrFieldNameRegExp));
                if (!match || match[0] !== subtype) _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
            });
        });
    };
    Policies.prototype.getTypePolicy = function(typename, createIfMissing) {
        if (typename) return this.typePolicies[typename] || createIfMissing && (this.typePolicies[typename] = Object.create(null));
    };
    Policies.prototype.getFieldPolicy = function(typename, fieldName, createIfMissing) {
        var typePolicy = this.getTypePolicy(typename, createIfMissing);
        if (typePolicy) {
            var fieldPolicies = typePolicy.fields || createIfMissing && (typePolicy.fields = Object.create(null));
            if (fieldPolicies) return fieldPolicies[fieldName] || createIfMissing && (fieldPolicies[fieldName] = Object.create(null));
        }
    };
    Policies.prototype.getSupertypeSet = function(subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) this.supertypeMap.set(subtype, supertypeSet = new Set());
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function(fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition) return true;
        if (!typename) return false;
        var supertype = fragment.typeCondition.name.value;
        if (typename === supertype) return true;
        if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [
                typenameSupertypeSet
            ];
            var maybeEnqueue_1 = function(subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet && supertypeSet.size && workQueue_1.indexOf(supertypeSet) < 0) workQueue_1.push(supertypeSet);
            };
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            for(var i = 0; i < workQueue_1.length; ++i){
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        checkingFuzzySubtypes;
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes && i === workQueue_1.length - 1 && (0, $efXDU.selectionSetMatchesResult)(fragment.selectionSet, result, variables)) {
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    this.fuzzySubtypes.forEach(function(regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) maybeEnqueue_1(fuzzyString);
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.getStoreFieldName = function(fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables
            };
            var args = $3acfec3b5892fdcb$var$argsFromFieldSpecifier(fieldSpec);
            while(keyFn){
                var specifierOrString = keyFn(args, context);
                if (Array.isArray(specifierOrString)) keyFn = $3acfec3b5892fdcb$var$keyArgsFnFromSpecifier(specifierOrString);
                else {
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) storeFieldName = fieldSpec.field ? (0, $29k5C.storeKeyNameFromField)(fieldSpec.field, fieldSpec.variables) : (0, $29k5C.getStoreKeyName)(fieldName, $3acfec3b5892fdcb$var$argsFromFieldSpecifier(fieldSpec));
        return fieldName === (0, $efXDU.fieldNameFromStoreName)(storeFieldName) ? storeFieldName : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function(options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference) return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField) return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename) options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = (0, $efXDU.fieldNameFromStoreName)(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = $3acfec3b5892fdcb$var$makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0, $29k5C.isReference)(objectOrReference) ? objectOrReference.__ref : objectOrReference, storeFieldName));
            return (0, $hkds1.cacheSlot).withValue(this.cache, read, [
                existing,
                readOptions
            ]);
        }
        return existing;
    };
    Policies.prototype.hasMergeFunction = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.merge);
    };
    Policies.prototype.applyMerges = function(existing, incoming, context, storageKeys) {
        var _a;
        var _this = this;
        if ((0, $efXDU.isFieldValueToBeMerged)(incoming)) {
            var field = incoming.__field;
            var fieldName = field.name.value;
            var merge = this.getFieldPolicy(incoming.__typename, fieldName, false).merge;
            incoming = merge(existing, incoming.__value, $3acfec3b5892fdcb$var$makeFieldFunctionOptions(this, void 0, {
                typename: incoming.__typename,
                fieldName: fieldName,
                field: field,
                variables: context.variables
            }, context, storageKeys ? (_a = context.store).getStorage.apply(_a, storageKeys) : Object.create(null)));
        }
        if (Array.isArray(incoming)) return incoming.map(function(item) {
            return _this.applyMerges(void 0, item, context);
        });
        if ((0, $efXDU.storeValueIsStoreObject)(incoming)) {
            var e_1 = existing;
            var i_1 = incoming;
            var firstStorageKey_1 = (0, $29k5C.isReference)(e_1) ? e_1.__ref : typeof e_1 === "object" && e_1;
            var newFields_1;
            Object.keys(i_1).forEach(function(storeFieldName) {
                var incomingValue = i_1[storeFieldName];
                var appliedValue = _this.applyMerges(context.store.getFieldValue(e_1, storeFieldName), incomingValue, context, firstStorageKey_1 ? [
                    firstStorageKey_1,
                    storeFieldName
                ] : void 0);
                if (appliedValue !== incomingValue) {
                    newFields_1 = newFields_1 || Object.create(null);
                    newFields_1[storeFieldName] = appliedValue;
                }
            });
            if (newFields_1) return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, i_1), newFields_1);
        }
        return incoming;
    };
    return Policies;
}();
function $3acfec3b5892fdcb$var$makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = (0, $efXDU.fieldNameFromStoreName)(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, getFieldValue = _a.getFieldValue, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: $3acfec3b5892fdcb$var$argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: (0, $29k5C.isReference),
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function(fieldNameOrOptions, from) {
            var options = typeof fieldNameOrOptions === "string" ? {
                fieldName: fieldNameOrOptions,
                from: from
            } : (0, $fH1jI.__assign)({}, fieldNameOrOptions);
            if (void 0 === options.from) options.from = objectOrReference;
            if (void 0 === options.variables) options.variables = variables;
            return policies.readField(options, context);
        },
        mergeObjects: function(existing, incoming) {
            if (Array.isArray(existing) || Array.isArray(incoming)) throw new (0, $5TDOW.InvariantError)(2);
            if (existing && typeof existing === "object" && incoming && typeof incoming === "object") {
                var eType = getFieldValue(existing, "__typename");
                var iType = getFieldValue(incoming, "__typename");
                var typesDiffer = eType && iType && eType !== iType;
                var applied = policies.applyMerges(typesDiffer ? void 0 : existing, incoming, context);
                if (typesDiffer || !(0, $efXDU.storeValueIsStoreObject)(existing) || !(0, $efXDU.storeValueIsStoreObject)(applied)) return applied;
                return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, existing), applied);
            }
            return incoming;
        }
    };
}
function $3acfec3b5892fdcb$var$keyArgsFnFromSpecifier(specifier) {
    return function(args, context) {
        return args ? context.fieldName + ":" + JSON.stringify($3acfec3b5892fdcb$var$computeKeyObject(args, specifier)) : context.fieldName;
    };
}
function $3acfec3b5892fdcb$var$keyFieldsFnFromSpecifier(specifier) {
    var trie = new (0, $b6c9K.KeyTrie)((0, $7hgpT.canUseWeakMap));
    return function(object, context) {
        var aliasMap;
        if (context.selectionSet && context.fragmentMap) {
            var info = trie.lookupArray([
                context.selectionSet,
                context.fragmentMap
            ]);
            aliasMap = info.aliasMap || (info.aliasMap = $3acfec3b5892fdcb$var$makeAliasMap(context.selectionSet, context.fragmentMap));
        }
        var keyObject = context.keyObject = $3acfec3b5892fdcb$var$computeKeyObject(object, specifier, aliasMap);
        return context.typename + ":" + JSON.stringify(keyObject);
    };
}
function $3acfec3b5892fdcb$var$makeAliasMap(selectionSet, fragmentMap) {
    var map = Object.create(null);
    var workQueue = new Set([
        selectionSet
    ]);
    workQueue.forEach(function(selectionSet) {
        selectionSet.selections.forEach(function(selection) {
            if ((0, $29k5C.isField)(selection)) {
                if (selection.alias) {
                    var responseKey = selection.alias.value;
                    var storeKey = selection.name.value;
                    if (storeKey !== responseKey) {
                        var aliases = map.aliases || (map.aliases = Object.create(null));
                        aliases[storeKey] = responseKey;
                    }
                }
                if (selection.selectionSet) {
                    var subsets = map.subsets || (map.subsets = Object.create(null));
                    subsets[selection.name.value] = $3acfec3b5892fdcb$var$makeAliasMap(selection.selectionSet, fragmentMap);
                }
            } else {
                var fragment = (0, $7iEy8.getFragmentFromSelection)(selection, fragmentMap);
                if (fragment) workQueue.add(fragment.selectionSet);
            }
        });
    });
    return map;
}
function $3acfec3b5892fdcb$var$computeKeyObject(response, specifier, aliasMap) {
    var keyObj = Object.create(null);
    var prevKey;
    specifier.forEach(function(s) {
        if (Array.isArray(s)) {
            if (typeof prevKey === "string") {
                var subsets = aliasMap && aliasMap.subsets;
                var subset = subsets && subsets[prevKey];
                keyObj[prevKey] = $3acfec3b5892fdcb$var$computeKeyObject(response[prevKey], s, subset);
            }
        } else {
            var aliases = aliasMap && aliasMap.aliases;
            var responseName = aliases && aliases[s] || s;
            (0, $5TDOW.invariant)((0, $efXDU.hasOwn).call(response, responseName), 3);
            keyObj[prevKey = s] = response[responseName];
        }
    });
    return keyObj;
}

});


parcelRegister("90Jyl", function(module, exports) {

});



parcelRegister("ecPgP", function(module, exports) {

$parcel$export(module.exports, "QueryInfo", function () { return $a579f4eeb5aa7d63$export$79a6120a39c90b6a; });
$parcel$export(module.exports, "shouldWriteResult", function () { return $a579f4eeb5aa7d63$export$5f47a9fb9a521654; });

var $4NlT6 = parcelRequire("4NlT6");
parcelRequire("jDiDD");
var $7hgpT = parcelRequire("7hgpT");
var $6dw5K = parcelRequire("6dw5K");
var $h6MUv = parcelRequire("h6MUv");

var $9c62d = parcelRequire("9c62d");
var $a579f4eeb5aa7d63$var$destructiveMethodCounts = new ((0, $7hgpT.canUseWeakMap) ? WeakMap : Map)();
function $a579f4eeb5aa7d63$var$wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") cache[methodName] = function() {
        $a579f4eeb5aa7d63$var$destructiveMethodCounts.set(cache, ($a579f4eeb5aa7d63$var$destructiveMethodCounts.get(cache) + 1) % 1e15);
        return original.apply(this, arguments);
    };
}
var $a579f4eeb5aa7d63$export$79a6120a39c90b6a = function() {
    function QueryInfo(cache) {
        this.cache = cache;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.subscriptions = new Set();
        this.dirty = false;
        this.diff = null;
        this.observableQuery = null;
        if (!$a579f4eeb5aa7d63$var$destructiveMethodCounts.has(cache)) {
            $a579f4eeb5aa7d63$var$destructiveMethodCounts.set(cache, 0);
            $a579f4eeb5aa7d63$var$wrapDestructiveCacheMethod(cache, "evict");
            $a579f4eeb5aa7d63$var$wrapDestructiveCacheMethod(cache, "modify");
            $a579f4eeb5aa7d63$var$wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function(query) {
        var networkStatus = query.networkStatus || (0, $9c62d.NetworkStatus).loading;
        if (this.variables && this.networkStatus !== (0, $9c62d.NetworkStatus).loading && !(0, $4NlT6.equal)(this.variables, query.variables)) networkStatus = (0, $9c62d.NetworkStatus).setVariables;
        if (!(0, $4NlT6.equal)(query.variables, this.variables)) this.diff = null;
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus
        });
        if (query.observableQuery) this.setObservableQuery(query.observableQuery);
        if (query.lastRequestId) this.lastRequestId = query.lastRequestId;
        return this;
    };
    QueryInfo.prototype.getDiff = function(variables) {
        if (variables === void 0) variables = this.variables;
        if (this.diff && (0, $4NlT6.equal)(variables, this.variables)) return this.diff;
        this.updateWatch(this.variables = variables);
        return this.diff = this.cache.diff({
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true
        });
    };
    QueryInfo.prototype.setDiff = function(diff) {
        var _this = this;
        var oldDiff = this.diff;
        this.diff = diff;
        if (!this.dirty && (diff && diff.result) !== (oldDiff && oldDiff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) this.notifyTimeout = setTimeout(function() {
                return _this.notify();
            }, 0);
        }
    };
    QueryInfo.prototype.setObservableQuery = function(oq) {
        var _this = this;
        if (oq === this.observableQuery) return;
        if (this.oqListener) this.listeners.delete(this.oqListener);
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add(this.oqListener = function() {
                if (_this.getDiff().fromOptimisticTransaction) oq["observe"]();
                else oq.reobserve();
            });
        } else delete this.oqListener;
    };
    QueryInfo.prototype.notify = function() {
        var _this = this;
        if (this.notifyTimeout) {
            clearTimeout(this.notifyTimeout);
            this.notifyTimeout = void 0;
        }
        if (this.shouldNotify()) this.listeners.forEach(function(listener) {
            return listener(_this);
        });
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function() {
        if (!this.dirty || !this.listeners.size) return false;
        if ((0, $9c62d.isNetworkRequestInFlight)(this.networkStatus) && this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" && fetchPolicy !== "cache-and-network") return false;
        }
        return true;
    };
    QueryInfo.prototype.stop = function() {
        this.cancel();
        delete this.cancel;
        var oq = this.observableQuery;
        if (oq) oq.stopPolling();
    };
    QueryInfo.prototype.cancel = function() {};
    QueryInfo.prototype.updateWatch = function(variables) {
        var _this = this;
        if (variables === void 0) variables = this.variables;
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return;
        if (!this.lastWatch || this.lastWatch.query !== this.document || !(0, $4NlT6.equal)(variables, this.lastWatch.variables)) {
            this.cancel();
            this.cancel = this.cache.watch(this.lastWatch = {
                query: this.document,
                variables: variables,
                optimistic: true,
                callback: function(diff) {
                    return _this.setDiff(diff);
                }
            });
        }
    };
    QueryInfo.prototype.shouldWrite = function(result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite && lastWrite.dmCount === $a579f4eeb5aa7d63$var$destructiveMethodCounts.get(this.cache) && (0, $4NlT6.equal)(variables, lastWrite.variables) && (0, $4NlT6.equal)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function(result, options, allowCacheWrite) {
        var _this = this;
        this.graphQLErrors = (0, $h6MUv.isNonEmptyArray)(result.errors) ? result.errors : [];
        if (options.fetchPolicy === 'no-cache') this.diff = {
            result: result.data,
            complete: true
        };
        else if (allowCacheWrite) {
            if ($a579f4eeb5aa7d63$export$5f47a9fb9a521654(result, options.errorPolicy)) this.cache.performTransaction(function(cache) {
                if (_this.shouldWrite(result, options.variables)) {
                    cache.writeQuery({
                        query: _this.document,
                        data: result.data,
                        variables: options.variables
                    });
                    _this.lastWrite = {
                        result: result,
                        variables: options.variables,
                        dmCount: $a579f4eeb5aa7d63$var$destructiveMethodCounts.get(_this.cache)
                    };
                } else if (_this.diff && _this.diff.complete) {
                    result.data = _this.diff.result;
                    return;
                }
                var diff = cache.diff({
                    query: _this.document,
                    variables: options.variables,
                    returnPartialData: true,
                    optimistic: true
                });
                _this.updateWatch(options.variables);
                _this.diff = diff;
                if (diff.complete) result.data = diff.result;
            });
            else this.lastWrite = void 0;
        }
    };
    QueryInfo.prototype.markReady = function() {
        this.networkError = null;
        return this.networkStatus = (0, $9c62d.NetworkStatus).ready;
    };
    QueryInfo.prototype.markError = function(error) {
        this.networkStatus = (0, $9c62d.NetworkStatus).error;
        this.lastWrite = void 0;
        if (error.graphQLErrors) this.graphQLErrors = error.graphQLErrors;
        if (error.networkError) this.networkError = error.networkError;
        return error;
    };
    return QueryInfo;
}();
function $a579f4eeb5aa7d63$export$5f47a9fb9a521654(result, errorPolicy) {
    if (errorPolicy === void 0) errorPolicy = "none";
    var ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    var writeWithErrors = !(0, $6dw5K.graphQLResultHasError)(result);
    if (!writeWithErrors && ignoreErrors && result.data) writeWithErrors = true;
    return writeWithErrors;
}

});



parcelRegister("iWkOU", function(module, exports) {

});

parcelRegister("3EDHG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a93e7cd53b74e8a$export$2e2bcd8739ae039; });

var $dSAUf = parcelRequire("dSAUf");

var $golSW = parcelRequire("golSW");
var $2a93e7cd53b74e8a$var$docCache = new Map();
var $2a93e7cd53b74e8a$var$fragmentSourceMap = new Map();
var $2a93e7cd53b74e8a$var$printFragmentWarnings = true;
var $2a93e7cd53b74e8a$var$experimentalFragmentVariables = false;
function $2a93e7cd53b74e8a$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $2a93e7cd53b74e8a$var$cacheKeyFromLoc(loc) {
    return $2a93e7cd53b74e8a$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $2a93e7cd53b74e8a$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $2a93e7cd53b74e8a$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $2a93e7cd53b74e8a$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($2a93e7cd53b74e8a$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $2a93e7cd53b74e8a$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $dSAUf.__assign)((0, $dSAUf.__assign)({}, ast), {
        definitions: definitions
    });
}
function $2a93e7cd53b74e8a$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $2a93e7cd53b74e8a$var$parseDocument(source) {
    var cacheKey = $2a93e7cd53b74e8a$var$normalize(source);
    if (!$2a93e7cd53b74e8a$var$docCache.has(cacheKey)) {
        var parsed = (0, $golSW.parse)(source, {
            experimentalFragmentVariables: $2a93e7cd53b74e8a$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $2a93e7cd53b74e8a$var$experimentalFragmentVariables,
            experimentalFragmentArguments: $2a93e7cd53b74e8a$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $2a93e7cd53b74e8a$var$docCache.set(cacheKey, $2a93e7cd53b74e8a$var$stripLoc($2a93e7cd53b74e8a$var$processFragments(parsed)));
    }
    return $2a93e7cd53b74e8a$var$docCache.get(cacheKey);
}
function $2a93e7cd53b74e8a$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $2a93e7cd53b74e8a$var$parseDocument(result);
}
function $2a93e7cd53b74e8a$export$657554ef4dc7ac2d() {
    $2a93e7cd53b74e8a$var$docCache.clear();
    $2a93e7cd53b74e8a$var$fragmentSourceMap.clear();
}
function $2a93e7cd53b74e8a$export$e4294e638636c6ab() {
    $2a93e7cd53b74e8a$var$printFragmentWarnings = false;
}
function $2a93e7cd53b74e8a$export$78cf889af350c840() {
    $2a93e7cd53b74e8a$var$experimentalFragmentVariables = true;
}
function $2a93e7cd53b74e8a$export$5290df9bbbd3cfa() {
    $2a93e7cd53b74e8a$var$experimentalFragmentVariables = false;
}
var $2a93e7cd53b74e8a$var$extras = {
    gql: $2a93e7cd53b74e8a$export$72e4926bf8358653,
    resetCaches: $2a93e7cd53b74e8a$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $2a93e7cd53b74e8a$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $2a93e7cd53b74e8a$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $2a93e7cd53b74e8a$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $2a93e7cd53b74e8a$var$extras.gql, gql_1.resetCaches = $2a93e7cd53b74e8a$var$extras.resetCaches, gql_1.disableFragmentWarnings = $2a93e7cd53b74e8a$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $2a93e7cd53b74e8a$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $2a93e7cd53b74e8a$var$extras.disableExperimentalFragmentVariables;
})($2a93e7cd53b74e8a$export$72e4926bf8358653 || ($2a93e7cd53b74e8a$export$72e4926bf8358653 = {}));
$2a93e7cd53b74e8a$export$72e4926bf8358653["default"] = $2a93e7cd53b74e8a$export$72e4926bf8358653;
var $2a93e7cd53b74e8a$export$2e2bcd8739ae039 = $2a93e7cd53b74e8a$export$72e4926bf8358653;

});
parcelRegister("dSAUf", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $a1acf2507b9566bb$export$18ce0697a983be9b; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $a1acf2507b9566bb$var$extendStatics = function(d, b) {
    $a1acf2507b9566bb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a1acf2507b9566bb$var$extendStatics(d, b);
};
function $a1acf2507b9566bb$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a1acf2507b9566bb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a1acf2507b9566bb$export$18ce0697a983be9b = function() {
    $a1acf2507b9566bb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a1acf2507b9566bb$export$18ce0697a983be9b.apply(this, arguments);
};
function $a1acf2507b9566bb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a1acf2507b9566bb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a1acf2507b9566bb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a1acf2507b9566bb$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $a1acf2507b9566bb$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $a1acf2507b9566bb$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $a1acf2507b9566bb$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $a1acf2507b9566bb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a1acf2507b9566bb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a1acf2507b9566bb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a1acf2507b9566bb$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a1acf2507b9566bb$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a1acf2507b9566bb$export$45d3717a4c69092e(o, m, p);
}
function $a1acf2507b9566bb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a1acf2507b9566bb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a1acf2507b9566bb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a1acf2507b9566bb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a1acf2507b9566bb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a1acf2507b9566bb$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a1acf2507b9566bb$export$10c90e4f7922046c(v) {
    return this instanceof $a1acf2507b9566bb$export$10c90e4f7922046c ? (this.v = v, this) : new $a1acf2507b9566bb$export$10c90e4f7922046c(v);
}
function $a1acf2507b9566bb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a1acf2507b9566bb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a1acf2507b9566bb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a1acf2507b9566bb$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $a1acf2507b9566bb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a1acf2507b9566bb$export$19a8beecd37a4c45 === "function" ? $a1acf2507b9566bb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a1acf2507b9566bb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a1acf2507b9566bb$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $a1acf2507b9566bb$var$ownKeys = function(o) {
    $a1acf2507b9566bb$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $a1acf2507b9566bb$var$ownKeys(o);
};
function $a1acf2507b9566bb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $a1acf2507b9566bb$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $a1acf2507b9566bb$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $a1acf2507b9566bb$var$__setModuleDefault(result, mod);
    return result;
}
function $a1acf2507b9566bb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a1acf2507b9566bb$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a1acf2507b9566bb$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a1acf2507b9566bb$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $a1acf2507b9566bb$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $a1acf2507b9566bb$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $a1acf2507b9566bb$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $a1acf2507b9566bb$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $a1acf2507b9566bb$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $a1acf2507b9566bb$export$2e2bcd8739ae039 = {
    __extends: $a1acf2507b9566bb$export$a8ba968b8961cb8a,
    __assign: $a1acf2507b9566bb$export$18ce0697a983be9b,
    __rest: $a1acf2507b9566bb$export$3c9a16f847548506,
    __decorate: $a1acf2507b9566bb$export$29e00dfd3077644b,
    __param: $a1acf2507b9566bb$export$d5ad3fd78186038f,
    __esDecorate: $a1acf2507b9566bb$export$3a84e1ae4e97e9b0,
    __runInitializers: $a1acf2507b9566bb$export$d831c04e792af3d,
    __propKey: $a1acf2507b9566bb$export$6a2a36740a146cb8,
    __setFunctionName: $a1acf2507b9566bb$export$d1a06452d3489bc7,
    __metadata: $a1acf2507b9566bb$export$f1db080c865becb9,
    __awaiter: $a1acf2507b9566bb$export$1050f835b63b671e,
    __generator: $a1acf2507b9566bb$export$67ebef60e6f28a6,
    __createBinding: $a1acf2507b9566bb$export$45d3717a4c69092e,
    __exportStar: $a1acf2507b9566bb$export$f33643c0debef087,
    __values: $a1acf2507b9566bb$export$19a8beecd37a4c45,
    __read: $a1acf2507b9566bb$export$8d051b38c9118094,
    __spread: $a1acf2507b9566bb$export$afc72e2116322959,
    __spreadArrays: $a1acf2507b9566bb$export$6388937ca91ccae8,
    __spreadArray: $a1acf2507b9566bb$export$1216008129fb82ed,
    __await: $a1acf2507b9566bb$export$10c90e4f7922046c,
    __asyncGenerator: $a1acf2507b9566bb$export$e427f37a30a4de9b,
    __asyncDelegator: $a1acf2507b9566bb$export$bbd80228419bb833,
    __asyncValues: $a1acf2507b9566bb$export$e3b29a3d6162315f,
    __makeTemplateObject: $a1acf2507b9566bb$export$4fb47efe1390b86f,
    __importStar: $a1acf2507b9566bb$export$c21735bcef00d192,
    __importDefault: $a1acf2507b9566bb$export$da59b14a69baef04,
    __classPrivateFieldGet: $a1acf2507b9566bb$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $a1acf2507b9566bb$export$d40a35129aaff81f,
    __classPrivateFieldIn: $a1acf2507b9566bb$export$81fdc39f203e4e04,
    __addDisposableResource: $a1acf2507b9566bb$export$88ac25d8e944e405,
    __disposeResources: $a1acf2507b9566bb$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $a1acf2507b9566bb$export$889dfb5d17574b0b
};

});

parcelRegister("golSW", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $d4ead71780bcd809$export$98e6a39c04603d36; });

var $dkfvm = parcelRequire("dkfvm");

var $21U35 = parcelRequire("21U35");

var $6JaJ0 = parcelRequire("6JaJ0");

var $byW4y = parcelRequire("byW4y");

var $9Hsg1 = parcelRequire("9Hsg1");

var $8rDhO = parcelRequire("8rDhO");

var $6mjQY = parcelRequire("6mjQY");
function $d4ead71780bcd809$export$98e6a39c04603d36(source, options) {
    var parser = new $d4ead71780bcd809$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $d4ead71780bcd809$export$5303528d1070ff6f(source, options) {
    var parser = new $d4ead71780bcd809$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $byW4y.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $byW4y.TokenKind).EOF);
    return value;
}
function $d4ead71780bcd809$export$28b8f402ccc88182(source, options) {
    var parser = new $d4ead71780bcd809$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $byW4y.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $byW4y.TokenKind).EOF);
    return type;
}
var $d4ead71780bcd809$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $9Hsg1.isSource)(source) ? source : new (0, $9Hsg1.Source)(source);
        this._lexer = new (0, $6mjQY.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $byW4y.TokenKind).NAME);
        return {
            kind: (0, $21U35.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
    ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $21U35.Kind).DOCUMENT,
            definitions: this.many((0, $byW4y.TokenKind).SOF, this.parseDefinition, (0, $byW4y.TokenKind).EOF),
            loc: this.loc(start)
        };
    };
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $byW4y.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $byW4y.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
    ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $byW4y.TokenKind).BRACE_L)) return {
            kind: (0, $21U35.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $byW4y.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $21U35.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $byW4y.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    };
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $byW4y.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $byW4y.TokenKind).PAREN_R);
    };
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $21U35.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $byW4y.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $byW4y.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    };
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $byW4y.TokenKind).DOLLAR);
        return {
            kind: (0, $21U35.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    };
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $21U35.Kind).SELECTION_SET,
            selections: this.many((0, $byW4y.TokenKind).BRACE_L, this.parseSelection, (0, $byW4y.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    };
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $byW4y.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    };
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $byW4y.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $21U35.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $byW4y.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    };
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $byW4y.TokenKind).PAREN_L, item, (0, $byW4y.TokenKind).PAREN_R);
    };
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $byW4y.TokenKind).COLON);
        return {
            kind: (0, $21U35.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $21U35.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $byW4y.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
    ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $byW4y.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $byW4y.TokenKind).NAME)) return {
            kind: (0, $21U35.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $21U35.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $21U35.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $21U35.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
    ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $byW4y.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $byW4y.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $byW4y.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $21U35.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $byW4y.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $21U35.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $byW4y.TokenKind).STRING:
            case (0, $byW4y.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $byW4y.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $21U35.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $21U35.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $21U35.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $21U35.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $byW4y.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $21U35.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $byW4y.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    };
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $21U35.Kind).LIST,
            values: this.any((0, $byW4y.TokenKind).BRACKET_L, item, (0, $byW4y.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    };
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $21U35.Kind).OBJECT,
            fields: this.any((0, $byW4y.TokenKind).BRACE_L, item, (0, $byW4y.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    };
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $byW4y.TokenKind).COLON);
        return {
            kind: (0, $21U35.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
    ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $byW4y.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    };
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $byW4y.TokenKind).AT);
        return {
            kind: (0, $21U35.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
    ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $byW4y.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $byW4y.TokenKind).BRACKET_R);
            type = {
                kind: (0, $21U35.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $byW4y.TokenKind).BANG)) return {
            kind: (0, $21U35.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    };
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $21U35.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
    ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $byW4y.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $byW4y.TokenKind).STRING) || this.peek((0, $byW4y.TokenKind).BLOCK_STRING);
    };
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    };
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $byW4y.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $byW4y.TokenKind).BRACE_R);
        return {
            kind: (0, $21U35.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    };
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $byW4y.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $21U35.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    };
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $21U35.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $21U35.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $byW4y.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $byW4y.TokenKind).AMP) || this.peek((0, $byW4y.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $byW4y.TokenKind).AMP, this.parseNamedType);
    };
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $byW4y.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $byW4y.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $byW4y.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $byW4y.TokenKind).BRACE_R);
    };
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $byW4y.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $21U35.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $byW4y.TokenKind).PAREN_L, this.parseInputValueDef, (0, $byW4y.TokenKind).PAREN_R);
    };
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $byW4y.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $byW4y.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $21U35.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $21U35.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $21U35.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $byW4y.TokenKind).EQUALS) ? this.delimitedMany((0, $byW4y.TokenKind).PIPE, this.parseNamedType) : [];
    };
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $21U35.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    };
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $byW4y.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $byW4y.TokenKind).BRACE_R);
    };
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $21U35.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $21U35.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $byW4y.TokenKind).BRACE_L, this.parseInputValueDef, (0, $byW4y.TokenKind).BRACE_R);
    };
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $byW4y.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $byW4y.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $byW4y.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $21U35.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    };
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $21U35.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $21U35.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $21U35.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $21U35.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    };
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $21U35.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    };
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $21U35.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $byW4y.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $21U35.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    };
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $byW4y.TokenKind).PIPE, this.parseDirectiveLocation);
    };
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $8rDhO.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
    ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $6JaJ0.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    };
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    };
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $dkfvm.syntaxError)(this._lexer.source, token.start, "Expected ".concat($d4ead71780bcd809$var$getTokenKindDesc(kind), ", found ").concat($d4ead71780bcd809$var$getTokenDesc(token), "."));
    };
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    };
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $byW4y.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $dkfvm.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($d4ead71780bcd809$var$getTokenDesc(token), "."));
    };
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $byW4y.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    };
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $dkfvm.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($d4ead71780bcd809$var$getTokenDesc(token), "."));
    };
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    };
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    };
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    };
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $d4ead71780bcd809$var$getTokenDesc(token) {
    var value = token.value;
    return $d4ead71780bcd809$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $d4ead71780bcd809$var$getTokenKindDesc(kind) {
    return (0, $6mjQY.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}

});
parcelRegister("dkfvm", function(module, exports) {

$parcel$export(module.exports, "syntaxError", function () { return $9a00dc677f2f3519$export$bbee0c6176c019d4; });

var $1wSRS = parcelRequire("1wSRS");
function $9a00dc677f2f3519$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $1wSRS.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("1wSRS", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", function () { return $78c5e0be203300c3$export$92d6ed0888e7cb7f; });

var $ieSTN = parcelRequire("ieSTN");

var $85Rit = parcelRequire("85Rit");

var $5FFxU = parcelRequire("5FFxU");

var $5McRy = parcelRequire("5McRy");

var $kE41u = parcelRequire("kE41u");
function $78c5e0be203300c3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $78c5e0be203300c3$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $78c5e0be203300c3$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $78c5e0be203300c3$var$_typeof(obj);
}
function $78c5e0be203300c3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $78c5e0be203300c3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $78c5e0be203300c3$var$ownKeys(Object(source), true).forEach(function(key) {
            $78c5e0be203300c3$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $78c5e0be203300c3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $78c5e0be203300c3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $78c5e0be203300c3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $78c5e0be203300c3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $78c5e0be203300c3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $78c5e0be203300c3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $78c5e0be203300c3$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $78c5e0be203300c3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $78c5e0be203300c3$var$_setPrototypeOf(subClass, superClass);
}
function $78c5e0be203300c3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $78c5e0be203300c3$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $78c5e0be203300c3$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $78c5e0be203300c3$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $78c5e0be203300c3$var$_possibleConstructorReturn(this, result);
    };
}
function $78c5e0be203300c3$var$_possibleConstructorReturn(self, call) {
    if (call && ($78c5e0be203300c3$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $78c5e0be203300c3$var$_assertThisInitialized(self);
}
function $78c5e0be203300c3$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $78c5e0be203300c3$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $78c5e0be203300c3$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$78c5e0be203300c3$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $78c5e0be203300c3$var$_construct(Class, arguments, $78c5e0be203300c3$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $78c5e0be203300c3$var$_setPrototypeOf(Wrapper, Class);
    };
    return $78c5e0be203300c3$var$_wrapNativeSuper(Class);
}
function $78c5e0be203300c3$var$_construct(Parent, args, Class) {
    if ($78c5e0be203300c3$var$_isNativeReflectConstruct()) $78c5e0be203300c3$var$_construct = Reflect.construct;
    else $78c5e0be203300c3$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $78c5e0be203300c3$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $78c5e0be203300c3$var$_construct.apply(null, arguments);
}
function $78c5e0be203300c3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $78c5e0be203300c3$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $78c5e0be203300c3$var$_setPrototypeOf(o, p) {
    $78c5e0be203300c3$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $78c5e0be203300c3$var$_setPrototypeOf(o, p);
}
function $78c5e0be203300c3$var$_getPrototypeOf(o) {
    $78c5e0be203300c3$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $78c5e0be203300c3$var$_getPrototypeOf(o);
}
var $78c5e0be203300c3$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $78c5e0be203300c3$var$_inherits(GraphQLError, _Error);
    var _super = $78c5e0be203300c3$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $78c5e0be203300c3$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $78c5e0be203300c3$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $78c5e0be203300c3$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $5McRy.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $5McRy.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $85Rit.default)(originalExtensions)) _this.extensions = $78c5e0be203300c3$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($78c5e0be203300c3$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($78c5e0be203300c3$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $78c5e0be203300c3$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($78c5e0be203300c3$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($78c5e0be203300c3$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $78c5e0be203300c3$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $78c5e0be203300c3$export$55ee1551a3f962e6(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return $78c5e0be203300c3$export$7b5b869ee98c16ab(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $5FFxU.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $78c5e0be203300c3$var$_wrapNativeSuper(Error));
function $78c5e0be203300c3$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $78c5e0be203300c3$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $kE41u.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $kE41u.printSourceLocation)(error.source, location);
    }
    return output;
}
function $78c5e0be203300c3$export$7b5b869ee98c16ab(error) {
    var _error$message;
    error || (0, $ieSTN.default)(0, 'Received null or undefined error.');
    var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : 'An unknown error occurred.';
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions && Object.keys(extensions).length > 0 ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
} /**
 * @see https://github.com/graphql/graphql-spec/blob/master/spec/Section%207%20--%20Response.md#errors
 */ 

});
parcelRegister("ieSTN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7dde38f6740852f$export$2e2bcd8739ae039; });
function $d7dde38f6740852f$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("85Rit", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $160e400b60ff3e10$export$2e2bcd8739ae039; });
function $160e400b60ff3e10$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $160e400b60ff3e10$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $160e400b60ff3e10$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $160e400b60ff3e10$var$_typeof(obj);
}
function $160e400b60ff3e10$export$2e2bcd8739ae039(value) {
    return $160e400b60ff3e10$var$_typeof(value) == 'object' && value !== null;
}

});

parcelRegister("5FFxU", function(module, exports) {

$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", function () { return $5b790b4a406573fd$export$5deadc579ccc7c9c; });
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $5b790b4a406573fd$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $5b790b4a406573fd$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $5b790b4a406573fd$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

});

parcelRegister("5McRy", function(module, exports) {

$parcel$export(module.exports, "getLocation", function () { return $04ae08a900566cf7$export$e7fd20fad3cf4b5f; });
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $04ae08a900566cf7$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("kE41u", function(module, exports) {

$parcel$export(module.exports, "printLocation", function () { return $db86f86a3496a323$export$96a9681e539deed; });
$parcel$export(module.exports, "printSourceLocation", function () { return $db86f86a3496a323$export$867940333fd9f869; });

var $5McRy = parcelRequire("5McRy");
function $db86f86a3496a323$export$96a9681e539deed(location) {
    return $db86f86a3496a323$export$867940333fd9f869(location.source, (0, $5McRy.getLocation)(location.source, location.start));
}
function $db86f86a3496a323$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $db86f86a3496a323$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $db86f86a3496a323$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $db86f86a3496a323$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $db86f86a3496a323$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $db86f86a3496a323$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $db86f86a3496a323$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $db86f86a3496a323$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $db86f86a3496a323$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $db86f86a3496a323$var$leftPad(len, str) {
    return $db86f86a3496a323$var$whitespace(len - str.length) + str;
}

});



parcelRegister("21U35", function(module, exports) {

$parcel$export(module.exports, "Kind", function () { return $0ec8bbc3e2986bcc$export$a84bdc57c5122798; });
/**
 * The set of allowed kind values for AST nodes.
 */ var $0ec8bbc3e2986bcc$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("byW4y", function(module, exports) {

$parcel$export(module.exports, "TokenKind", function () { return $ea0b6831961b7dea$export$8b9d26ab11394711; });
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $ea0b6831961b7dea$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("9Hsg1", function(module, exports) {

$parcel$export(module.exports, "Source", function () { return $0d139b9757ac8c38$export$1d2df86270c81ecb; });
$parcel$export(module.exports, "isSource", function () { return $0d139b9757ac8c38$export$75135ee9ed6e435b; });

var $5FFxU = parcelRequire("5FFxU");

var $gLOVM = parcelRequire("gLOVM");

var $ieSTN = parcelRequire("ieSTN");

var $5JLTH = parcelRequire("5JLTH");
function $0d139b9757ac8c38$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0d139b9757ac8c38$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0d139b9757ac8c38$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0d139b9757ac8c38$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $0d139b9757ac8c38$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $ieSTN.default)(0, "Body must be a string. Received: ".concat((0, $gLOVM.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $ieSTN.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $ieSTN.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $0d139b9757ac8c38$var$_createClass(Source, [
        {
            key: (0, $5FFxU.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $0d139b9757ac8c38$export$75135ee9ed6e435b(source) {
    return (0, $5JLTH.default)(source, $0d139b9757ac8c38$export$1d2df86270c81ecb);
}

});
parcelRegister("5JLTH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $768a13334e315579$export$2e2bcd8739ae039; });

function $768a13334e315579$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $768a13334e315579$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $768a13334e315579$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $768a13334e315579$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$768a13334e315579$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});


parcelRegister("8rDhO", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", function () { return $74eeeb4a137ee017$export$b45ffd2948484c41; });
/**
 * The set of allowed directive location values.
 */ var $74eeeb4a137ee017$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("6mjQY", function(module, exports) {

$parcel$export(module.exports, "Lexer", function () { return $5d7c3aab2d0b5b00$export$6168dc8908a6c652; });
$parcel$export(module.exports, "isPunctuatorTokenKind", function () { return $5d7c3aab2d0b5b00$export$59ac0f4da287406a; });

var $dkfvm = parcelRequire("dkfvm");

var $6JaJ0 = parcelRequire("6JaJ0");

var $byW4y = parcelRequire("byW4y");

var $a2ftb = parcelRequire("a2ftb");
var $5d7c3aab2d0b5b00$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $6JaJ0.Token)((0, $byW4y.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    };
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $byW4y.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $5d7c3aab2d0b5b00$var$readToken(this, token);
        }while (token.kind === (0, $byW4y.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $5d7c3aab2d0b5b00$export$59ac0f4da287406a(kind) {
    return kind === (0, $byW4y.TokenKind).BANG || kind === (0, $byW4y.TokenKind).DOLLAR || kind === (0, $byW4y.TokenKind).AMP || kind === (0, $byW4y.TokenKind).PAREN_L || kind === (0, $byW4y.TokenKind).PAREN_R || kind === (0, $byW4y.TokenKind).SPREAD || kind === (0, $byW4y.TokenKind).COLON || kind === (0, $byW4y.TokenKind).EQUALS || kind === (0, $byW4y.TokenKind).AT || kind === (0, $byW4y.TokenKind).BRACKET_L || kind === (0, $byW4y.TokenKind).BRACKET_R || kind === (0, $byW4y.TokenKind).BRACE_L || kind === (0, $byW4y.TokenKind).PIPE || kind === (0, $byW4y.TokenKind).BRACE_R;
}
function $5d7c3aab2d0b5b00$var$printCharCode(code) {
    return isNaN(code) ? (0, $byW4y.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $5d7c3aab2d0b5b00$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $6JaJ0.Token)((0, $byW4y.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $5d7c3aab2d0b5b00$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $6JaJ0.Token)((0, $byW4y.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $6JaJ0.Token)((0, $byW4y.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $6JaJ0.Token)((0, $byW4y.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $6JaJ0.Token)((0, $byW4y.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $6JaJ0.Token)((0, $byW4y.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $6JaJ0.Token)((0, $byW4y.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $6JaJ0.Token)((0, $byW4y.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $6JaJ0.Token)((0, $byW4y.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $6JaJ0.Token)((0, $byW4y.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $6JaJ0.Token)((0, $byW4y.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $6JaJ0.Token)((0, $byW4y.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $6JaJ0.Token)((0, $byW4y.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $6JaJ0.Token)((0, $byW4y.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $5d7c3aab2d0b5b00$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $5d7c3aab2d0b5b00$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $5d7c3aab2d0b5b00$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $5d7c3aab2d0b5b00$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $dkfvm.syntaxError)(source, pos, $5d7c3aab2d0b5b00$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $6JaJ0.Token)((0, $byW4y.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $5d7c3aab2d0b5b00$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($5d7c3aab2d0b5b00$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($5d7c3aab2d0b5b00$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $5d7c3aab2d0b5b00$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $6JaJ0.Token)((0, $byW4y.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $5d7c3aab2d0b5b00$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $dkfvm.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($5d7c3aab2d0b5b00$var$printCharCode(code), "."));
    } else {
        position = $5d7c3aab2d0b5b00$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $5d7c3aab2d0b5b00$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $5d7c3aab2d0b5b00$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $5d7c3aab2d0b5b00$var$isNameStart(code)) throw (0, $dkfvm.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($5d7c3aab2d0b5b00$var$printCharCode(code), "."));
    return new (0, $6JaJ0.Token)(isFloat ? (0, $byW4y.TokenKind).FLOAT : (0, $byW4y.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $5d7c3aab2d0b5b00$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $dkfvm.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($5d7c3aab2d0b5b00$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $5d7c3aab2d0b5b00$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $6JaJ0.Token)((0, $byW4y.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $dkfvm.syntaxError)(source, position, "Invalid character within String: ".concat($5d7c3aab2d0b5b00$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $5d7c3aab2d0b5b00$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $dkfvm.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $dkfvm.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $dkfvm.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $5d7c3aab2d0b5b00$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $6JaJ0.Token)((0, $byW4y.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $a2ftb.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $dkfvm.syntaxError)(source, position, "Invalid character within String: ".concat($5d7c3aab2d0b5b00$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $dkfvm.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $5d7c3aab2d0b5b00$var$uniCharCode(a, b, c, d) {
    return $5d7c3aab2d0b5b00$var$char2hex(a) << 12 | $5d7c3aab2d0b5b00$var$char2hex(b) << 8 | $5d7c3aab2d0b5b00$var$char2hex(c) << 4 | $5d7c3aab2d0b5b00$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $5d7c3aab2d0b5b00$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $5d7c3aab2d0b5b00$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $6JaJ0.Token)((0, $byW4y.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $5d7c3aab2d0b5b00$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});




parcelRegister("33zXx", function(module, exports) {
$parcel$export(module.exports, "useApolloClient", function () { return (parcelRequire("c6uN4")).useApolloClient; });
$parcel$export(module.exports, "useMutation", function () { return (parcelRequire("byqzn")).useMutation; });
$parcel$export(module.exports, "useQuery", function () { return (parcelRequire("eBKZl")).useQuery; });

$parcel$export(module.exports, "ApolloProvider", function () { return (parcelRequire("6I6uN")).ApolloProvider; });
parcelRequire("fm3AG");
var $6I6uN = parcelRequire("6I6uN");
parcelRequire("5DP39");

var $kJd2f = parcelRequire("kJd2f");

var $kDlcA = parcelRequire("kDlcA");
$parcel$exportWildcard(module.exports, $kDlcA);

});
parcelRegister("fm3AG", function(module, exports) {
$parcel$export(module.exports, "getApolloContext", function () { return (parcelRequire("fvGUb")).getApolloContext; });
$parcel$export(module.exports, "ApolloProvider", function () { return (parcelRequire("6I6uN")).ApolloProvider; });
parcelRequire("hKnpB");
parcelRequire("fvGUb");
parcelRequire("6I6uN");

});
parcelRegister("hKnpB", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");

var $5TDOW = parcelRequire("5TDOW");

var $fvGUb = parcelRequire("fvGUb");
var $ceb8e4aebbc7ed6f$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = (0, $fvGUb.getApolloContext)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $5TDOW.invariant)(context && context.client, 27);
        return props.children(context.client);
    });
};

});
parcelRegister("fvGUb", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", function () { return $b4ab0852ecefb17c$export$a47505d961ee3a1; });

var $a5EUy = parcelRequire("a5EUy");
var $b4ab0852ecefb17c$var$contextSymbol = typeof Symbol === 'function' && Symbol.for ? Symbol.for('__APOLLO_CONTEXT__') : '__APOLLO_CONTEXT__';
function $b4ab0852ecefb17c$export$c2ee824bcc89ca6a() {
    Object.defineProperty((0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))), $b4ab0852ecefb17c$var$contextSymbol, {
        value: (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createContext({}),
        enumerable: false,
        configurable: true,
        writable: false
    });
}
function $b4ab0852ecefb17c$export$a47505d961ee3a1() {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($a5EUy)))[$b4ab0852ecefb17c$var$contextSymbol]) $b4ab0852ecefb17c$export$c2ee824bcc89ca6a();
    return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy)))[$b4ab0852ecefb17c$var$contextSymbol];
}

});


parcelRegister("6I6uN", function(module, exports) {

$parcel$export(module.exports, "ApolloProvider", function () { return $4e2be41220ae9793$export$c16b04c8a9956446; });

var $a5EUy = parcelRequire("a5EUy");

var $5TDOW = parcelRequire("5TDOW");

var $fvGUb = parcelRequire("fvGUb");
var $4e2be41220ae9793$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0, $fvGUb.getApolloContext)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $5TDOW.invariant)(context.client, 28);
        return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};

});


parcelRegister("5DP39", function(module, exports) {
$parcel$export(module.exports, "useApolloClient", function () { return (parcelRequire("c6uN4")).useApolloClient; });
$parcel$export(module.exports, "useMutation", function () { return (parcelRequire("byqzn")).useMutation; });
$parcel$export(module.exports, "useQuery", function () { return (parcelRequire("eBKZl")).useQuery; });
parcelRequire("c6uN4");
parcelRequire("fLdBX");
parcelRequire("byqzn");
parcelRequire("eBKZl");
parcelRequire("iWlMV");
parcelRequire("igxnA");

});
parcelRegister("c6uN4", function(module, exports) {

$parcel$export(module.exports, "useApolloClient", function () { return $8cfdedeb4b8f5d0c$export$eb9a56e7a29e494; });

var $a5EUy = parcelRequire("a5EUy");

var $5TDOW = parcelRequire("5TDOW");
parcelRequire("fm3AG");
var $fvGUb = parcelRequire("fvGUb");
function $8cfdedeb4b8f5d0c$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).useContext((0, $fvGUb.getApolloContext)()).client;
    (0, $5TDOW.invariant)(client, 33);
    return client;
}

});

parcelRegister("fLdBX", function(module, exports) {

var $6p2wD = parcelRequire("6p2wD");
function $b795cdba68b1c797$export$fd83eea6ecd2d8fa(query, options) {
    return (0, $6p2wD.useBaseQuery)(query, options, true);
}

});
parcelRegister("6p2wD", function(module, exports) {

$parcel$export(module.exports, "useBaseQuery", function () { return $4a97096041ca067f$export$fff0865807e996c5; });

var $fH1jI = parcelRequire("fH1jI");

var $a5EUy = parcelRequire("a5EUy");
parcelRequire("g3DRj");
var $7mbmK = parcelRequire("7mbmK");

var $8jy5k = parcelRequire("8jy5k");
parcelRequire("fm3AG");
var $fvGUb = parcelRequire("fvGUb");
function $4a97096041ca067f$export$fff0865807e996c5(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $a5EUy.useContext)((0, $fvGUb.getApolloContext)());
    var _a = (0, $a5EUy.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $a5EUy.useRef)();
    var queryData = queryDataRef.current || new (0, $7mbmK.QueryData)({
        options: updatedOptions,
        context: context,
        onNewData: function() {
            if (!queryData.ssrInitiated()) Promise.resolve().then(forceUpdate);
            else forceUpdate();
        }
    });
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    if (queryData.ssrInitiated() && !queryDataRef.current) queryDataRef.current = queryData;
    var memo = {
        options: (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = (0, $8jy5k.useDeepMemo)(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $a5EUy.useEffect)(function() {
        if (!queryDataRef.current) queryDataRef.current = queryData;
        return function() {
            return queryData.cleanup();
        };
    }, []);
    (0, $a5EUy.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    return result;
}

});
parcelRegister("g3DRj", function(module, exports) {

$parcel$export(module.exports, "SubscriptionData", function () { return (parcelRequire("cRPrI")).SubscriptionData; });
$parcel$export(module.exports, "MutationData", function () { return (parcelRequire("c7DrE")).MutationData; });
$parcel$export(module.exports, "QueryData", function () { return (parcelRequire("7mbmK")).QueryData; });

var $cRPrI = parcelRequire("cRPrI");

var $dZVOz = parcelRequire("dZVOz");

var $c7DrE = parcelRequire("c7DrE");

var $7mbmK = parcelRequire("7mbmK");

});
parcelRegister("cRPrI", function(module, exports) {

$parcel$export(module.exports, "SubscriptionData", function () { return $95e2576483e36e71$export$ae4ab90ed0fb78ce; });

var $fH1jI = parcelRequire("fH1jI");

var $4NlT6 = parcelRequire("4NlT6");

var $dZVOz = parcelRequire("dZVOz");
var $95e2576483e36e71$export$ae4ab90ed0fb78ce = function(_super) {
    (0, $fH1jI.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $4NlT6.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}((0, $dZVOz.OperationData));

});
parcelRegister("dZVOz", function(module, exports) {

$parcel$export(module.exports, "OperationData", function () { return $a30dd1a3c0554795$export$43795b6fdc114bf6; });

var $4NlT6 = parcelRequire("4NlT6");

var $5TDOW = parcelRequire("5TDOW");

var $kJd2f = parcelRequire("kJd2f");
var $a30dd1a3c0554795$export$43795b6fdc114bf6 = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $4NlT6.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $5TDOW.invariant)(!!client, 29);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $kJd2f.parser)(document);
        var requiredOperationName = (0, $kJd2f.operationName)(type);
        var usedOperationName = (0, $kJd2f.operationName)(operation.type);
        (0, $5TDOW.invariant)(operation.type === type, 30);
    };
    return OperationData;
}();

});
parcelRegister("kJd2f", function(module, exports) {

$parcel$export(module.exports, "DocumentType", function () { return $f1721f2505cb9825$export$d1d99cf900472499; });
$parcel$export(module.exports, "operationName", function () { return $f1721f2505cb9825$export$5db520940cf00715; });
$parcel$export(module.exports, "parser", function () { return $f1721f2505cb9825$export$8f49e4af10703ce3; });

var $5TDOW = parcelRequire("5TDOW");
var $f1721f2505cb9825$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($f1721f2505cb9825$export$d1d99cf900472499 || ($f1721f2505cb9825$export$d1d99cf900472499 = {}));
var $f1721f2505cb9825$var$cache = new Map();
function $f1721f2505cb9825$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $f1721f2505cb9825$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $f1721f2505cb9825$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $f1721f2505cb9825$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $f1721f2505cb9825$export$8f49e4af10703ce3(document) {
    var cached = $f1721f2505cb9825$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $5TDOW.invariant)(!!document && !!document.kind, 34);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $5TDOW.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 35);
    (0, $5TDOW.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 36);
    type = queries.length ? $f1721f2505cb9825$export$d1d99cf900472499.Query : $f1721f2505cb9825$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $f1721f2505cb9825$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $5TDOW.invariant)(definitions.length === 1, 37);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $f1721f2505cb9825$var$cache.set(document, payload);
    return payload;
}

});



parcelRegister("c7DrE", function(module, exports) {

$parcel$export(module.exports, "MutationData", function () { return $8d34bc733ee1fd87$export$1197ada6fead761a; });

var $fH1jI = parcelRequire("fH1jI");

var $4NlT6 = parcelRequire("4NlT6");

var $kJd2f = parcelRequire("kJd2f");

var $jWiaX = parcelRequire("jWiaX");

var $dZVOz = parcelRequire("dZVOz");
parcelRequire("jDiDD");
var $bP5sr = parcelRequire("bP5sr");
var $8d34bc733ee1fd87$export$1197ada6fead761a = function(_super) {
    (0, $fH1jI.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $kJd2f.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $kJd2f.DocumentType).Mutation);
        return [
            this.runMutation,
            (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, result), {
                client: this.refreshClient().client
            })
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        return this.refreshClient().client.mutate((0, $bP5sr.compact)(this.getOptions(), mutationFunctionOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $jWiaX.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $4NlT6.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}((0, $dZVOz.OperationData));

});

parcelRegister("7mbmK", function(module, exports) {

$parcel$export(module.exports, "QueryData", function () { return $55b36781da60150f$export$baa8865f9b235420; });

var $fH1jI = parcelRequire("fH1jI");

var $4NlT6 = parcelRequire("4NlT6");

var $jWiaX = parcelRequire("jWiaX");
parcelRequire("aJi19");
var $9c62d = parcelRequire("9c62d");

var $kJd2f = parcelRequire("kJd2f");

var $dZVOz = parcelRequire("dZVOz");
var $55b36781da60150f$export$baa8865f9b235420 = function(_super) {
    (0, $fH1jI.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, onNewData = _a.onNewData;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.onNewData();
        };
        _this.getQueryResult = function() {
            var result = _this.observableQueryFields();
            var options = _this.getOptions();
            if (options.skip) result = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, result), {
                data: undefined,
                error: undefined,
                loading: false,
                called: true
            });
            else if (_this.currentObservable) {
                var currentResult = _this.currentObservable.getCurrentResult();
                var data = currentResult.data, loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
                var error = currentResult.error;
                if (errors && errors.length > 0) error = new (0, $jWiaX.ApolloError)({
                    graphQLErrors: errors
                });
                result = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, result), {
                    data: data,
                    loading: loading,
                    networkStatus: networkStatus,
                    error: error,
                    called: true
                });
                if (loading) ;
                else if (error) Object.assign(result, {
                    data: (_this.currentObservable.getLastResult() || {}).data
                });
                else {
                    var fetchPolicy = _this.currentObservable.options.fetchPolicy;
                    var partialRefetch = options.partialRefetch;
                    if (partialRefetch && partial && (!data || Object.keys(data).length === 0) && fetchPolicy !== 'cache-only') {
                        Object.assign(result, {
                            loading: true,
                            networkStatus: (0, $9c62d.NetworkStatus).loading
                        });
                        result.refetch();
                        return result;
                    }
                }
            }
            result.client = _this.client;
            _this.setOptions(options, true);
            _this.previousData.loading = _this.previousData.result && _this.previousData.result.loading || false;
            _this.previousData.result = result;
            _this.currentObservable && _this.currentObservable.resetQueryStoreErrors();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            var _a;
            (_a = _this.currentObservable) === null || _a === void 0 || _a.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            var _a;
            (_a = _this.currentObservable) === null || _a === void 0 || _a.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.subscribeToMore(options);
        };
        _this.onNewData = onNewData;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $9c62d.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var _this = this;
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        return new Promise(function(resolve) {
            return _this.startQuerySubscription(resolve);
        });
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) this.handleErrorOrCompleted();
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.ssrInitiated = function() {
        return this.context && this.context.renderPromises;
    };
    QueryData.prototype.getExecuteResult = function() {
        var result = this.getQueryResult();
        this.startQuerySubscription();
        return result;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = (0, $fH1jI.__assign)({
            loading: true,
            networkStatus: (0, $9c62d.NetworkStatus).loading,
            called: true,
            data: undefined,
            stale: false,
            client: this.client
        }, this.observableQueryFields());
        if (ssrDisabled && (this.ssrInitiated() || fetchDisabled)) {
            this.previousData.result = ssrLoading;
            return ssrLoading;
        }
        var result;
        if (this.ssrInitiated()) result = this.context.renderPromises.addQueryPromise(this, this.getQueryResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $kJd2f.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.ssrInitiated() && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, options), {
            displayName: displayName,
            context: options.context
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.ssrInitiated()) this.currentObservable = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable = this.refreshClient().client.watchQuery((0, $fH1jI.__assign)({}, observableQueryOptions));
            if (this.ssrInitiated()) this.context.renderPromises.registerSSRObservable(this.currentObservable, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable) {
            this.initializeObservableQuery();
            return;
        }
        if (this.getOptions().skip) return;
        var newObservableQueryOptions = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $4NlT6.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function(onNewData) {
        var _this = this;
        if (onNewData === void 0) onNewData = this.onNewData;
        if (this.currentSubscription || this.getOptions().skip) return;
        this.currentSubscription = this.currentObservable.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $4NlT6.equal)(previousResult.data, data)) return;
                onNewData();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $4NlT6.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    onNewData();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var currentObservable = this.currentObservable;
        if (currentObservable) {
            var lastError = currentObservable.getLastError();
            var lastResult = currentObservable.getLastResult();
            currentObservable.resetLastResults();
            this.startQuerySubscription();
            Object.assign(currentObservable, {
                lastError: lastError,
                lastResult: lastResult
            });
        }
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        if (!this.currentObservable || !this.previousData.result) return;
        var _a = this.previousData.result, data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError, skip = _b.skip;
            if (this.previousOptions && !this.previousData.loading && (0, $4NlT6.equal)(this.previousOptions.query, query) && (0, $4NlT6.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error && !skip) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentSubscription) {
            this.currentSubscription.unsubscribe();
            delete this.currentSubscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var _a;
        return {
            variables: (_a = this.currentObservable) === null || _a === void 0 ? void 0 : _a.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}((0, $dZVOz.OperationData));

});


parcelRegister("8jy5k", function(module, exports) {

$parcel$export(module.exports, "useDeepMemo", function () { return $60da89a2225860fd$export$722debc0e56fea39; });

var $a5EUy = parcelRequire("a5EUy");

var $4NlT6 = parcelRequire("4NlT6");
function $60da89a2225860fd$export$722debc0e56fea39(memoFn, key) {
    var ref = (0, $a5EUy.useRef)();
    if (!ref.current || !(0, $4NlT6.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}

});



parcelRegister("byqzn", function(module, exports) {

$parcel$export(module.exports, "useMutation", function () { return $86977ad43323295d$export$609860bf8b0084c; });

var $fH1jI = parcelRequire("fH1jI");

var $a5EUy = parcelRequire("a5EUy");
parcelRequire("g3DRj");
var $c7DrE = parcelRequire("c7DrE");
parcelRequire("fm3AG");
var $fvGUb = parcelRequire("fvGUb");
function $86977ad43323295d$export$609860bf8b0084c(mutation, options) {
    var context = (0, $a5EUy.useContext)((0, $fvGUb.getApolloContext)());
    var _a = (0, $a5EUy.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $a5EUy.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new (0, $c7DrE.MutationData)({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $a5EUy.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}

});

parcelRegister("eBKZl", function(module, exports) {

$parcel$export(module.exports, "useQuery", function () { return $aa28f85681203b91$export$dd0a697e1782aedd; });

var $6p2wD = parcelRequire("6p2wD");
function $aa28f85681203b91$export$dd0a697e1782aedd(query, options) {
    return (0, $6p2wD.useBaseQuery)(query, options, false);
}

});

parcelRegister("iWlMV", function(module, exports) {

var $fH1jI = parcelRequire("fH1jI");

var $a5EUy = parcelRequire("a5EUy");
parcelRequire("g3DRj");
var $cRPrI = parcelRequire("cRPrI");
parcelRequire("fm3AG");
var $fvGUb = parcelRequire("fvGUb");
function $dc9e8b745126992f$export$368b4214baeb914c(subscription, options) {
    var context = (0, $a5EUy.useContext)((0, $fvGUb.getApolloContext)());
    var updatedOptions = options ? (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $a5EUy.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $a5EUy.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new (0, $cRPrI.SubscriptionData)({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $a5EUy.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $a5EUy.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}

});

parcelRegister("igxnA", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
function $d4c39d16eb57c9e6$export$b10e3d92c03f6472(rv) {
    var value = rv();
    var mute = rv.onNextChange((0, $a5EUy.useState)(value)[1]);
    (0, $a5EUy.useEffect)(function() {
        return mute;
    }, []);
    return value;
}

});


parcelRegister("kDlcA", function(module, exports) {

});



parcelRegister("cPiPb", function(module, exports) {

$parcel$export(module.exports, "OverlayPortal", function () { return $9568d99bd91d4c55$export$2765eed43ca49790; });

var $df8fE = parcelRequire("df8fE");

var $a5EUy = parcelRequire("a5EUy");

var $jUibk = parcelRequire("jUibk");

var $3yJBl = parcelRequire("3yJBl");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
const $9568d99bd91d4c55$var$overlayPortalStyle = (0, $1lyZZ.css)({
    position: 'absolute',
    height: '80%',
    width: '100%',
    marginTop: 80,
    background: (0, $8JWbY.colors).neutralColors.white
});
const $9568d99bd91d4c55$export$2765eed43ca49790 = ({ children: children })=>{
    const overlayPortalRootDiv = document.getElementById('overlay');
    const overlayElement = document.createElement('div');
    (0, $a5EUy.useEffect)(()=>{
        if (overlayPortalRootDiv && overlayElement) overlayPortalRootDiv.appendChild(overlayElement);
        return ()=>{
            if (overlayElement) overlayPortalRootDiv.removeChild(overlayElement);
        };
    }, [
        overlayElement,
        overlayPortalRootDiv
    ]);
    return /*#__PURE__*/ (0, $jUibk.createPortal)(/*#__PURE__*/ (0, $df8fE.jsx)("div", {
        css: $9568d99bd91d4c55$var$overlayPortalStyle,
        children: children
    }), overlayElement);
};
$9568d99bd91d4c55$export$2765eed43ca49790.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).node.isRequired
};

});
parcelRegister("jUibk", function(module, exports) {
'use strict';
function $e7e159c5d6381a51$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($e7e159c5d6381a51$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$e7e159c5d6381a51$var$checkDCE();

module.exports = (parcelRequire("1XnXK"));

});

parcelRegister("1lyZZ", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $0fb2e6a3f8640dee$export$dbf350e5966cf602; });

var $b5eff = parcelRequire("b5eff");

var $a5EUy = parcelRequire("a5EUy");

var $kvAyz = parcelRequire("kvAyz");

var $1ersq = parcelRequire("1ersq");

var $f72sm = parcelRequire("f72sm");
parcelRequire("eXbSj");
parcelRequire("jLDbU");
parcelRequire("4lqHf");

parcelRequire("jxrUX");
var $0fb2e6a3f8640dee$var$pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $0fb2e6a3f8640dee$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $b5eff.h).call(props, 'css')) // $FlowFixMe
    return $a5EUy.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $b5eff.E);
    createElementArgArray[1] = (0, $b5eff.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $a5EUy.createElement.apply(null, createElementArgArray);
};
var $0fb2e6a3f8640dee$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $0fb2e6a3f8640dee$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $b5eff.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $f72sm.serializeStyles)([
        styles
    ], undefined, $a5EUy.useContext((0, $b5eff.T)));
    if (!(0, $b5eff.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $a5EUy.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $a5EUy.useRef();
    (0, $1ersq.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $1ersq.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $kvAyz.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $0fb2e6a3f8640dee$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $f72sm.serializeStyles)(args);
}
var $0fb2e6a3f8640dee$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $0fb2e6a3f8640dee$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $0fb2e6a3f8640dee$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $0fb2e6a3f8640dee$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $kvAyz.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $0fb2e6a3f8640dee$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $1ersq.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $kvAyz.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $0fb2e6a3f8640dee$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $b5eff.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $f72sm.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $kvAyz.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $0fb2e6a3f8640dee$var$merge(cache.registered, css, $0fb2e6a3f8640dee$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $a5EUy.useContext((0, $b5eff.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $a5EUy.createElement($a5EUy.Fragment, null, /*#__PURE__*/ $a5EUy.createElement($0fb2e6a3f8640dee$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $0fb2e6a3f8640dee$var$isBrowser, $0fb2e6a3f8640dee$var$isTestEnv, $0fb2e6a3f8640dee$var$globalContext, $0fb2e6a3f8640dee$var$globalKey;

});

parcelRegister("1OfTO", function(module, exports) {

$parcel$export(module.exports, "font", function () { return (parcelRequire("jahGf")).font; });
$parcel$export(module.exports, "media", function () { return (parcelRequire("4AJXw")).media; });
$parcel$export(module.exports, "spacing", function () { return (parcelRequire("cbxDY")).spacing; });
$parcel$export(module.exports, "baseUnit", function () { return (parcelRequire("cbxDY")).baseUnit; });
$parcel$export(module.exports, "padding", function () { return (parcelRequire("xIzHg")).padding; });
$parcel$export(module.exports, "colors", function () { return (parcelRequire("8JWbY")).colors; });
$parcel$export(module.exports, "featureFlags", function () { return (parcelRequire("e200k")).featureFlags; });
// All variables are taken from the Klik UI Library - https://brand.lego.com/

var $jahGf = parcelRequire("jahGf");

var $4AJXw = parcelRequire("4AJXw");

var $cbxDY = parcelRequire("cbxDY");

var $xIzHg = parcelRequire("xIzHg");

var $8JWbY = parcelRequire("8JWbY");

var $e200k = parcelRequire("e200k");

});
parcelRegister("jahGf", function(module, exports) {

$parcel$export(module.exports, "font", function () { return $df3caa71ce52d11f$export$a74e2025f5286b02; });
const $df3caa71ce52d11f$export$a74e2025f5286b02 = {
    size: {
        size7: '5.9375rem',
        size6: '3.8125rem',
        size5: '3.0625rem',
        size4: '2.4375rem',
        size3: '1.9375rem',
        size2: '1.5625rem',
        size1: '1.25rem',
        size05: '1.125rem',
        size0: '1rem',
        sizeM1: '0.875rem',
        sizeM2: '0.6875rem'
    },
    weight: {
        regular: 400,
        medium: 500,
        bold: 700
    },
    lineHeight: {
        l: 1.5,
        m: 1.375,
        s: 1.25,
        xs: 1.125
    },
    letterSpacing: {
        xxl: '0.1em',
        xl: '0.0825em',
        l: '0.075em',
        m: '0.05em',
        s: '0.0375em',
        xs: '0.025em',
        xxs: '0.0125em'
    }
};

});

parcelRegister("4AJXw", function(module, exports) {

$parcel$export(module.exports, "media", function () { return $357e2cbeb939ea42$export$987d49ffe1b0900f; });
const $357e2cbeb939ea42$var$mediaSizes = {
    medium: 592,
    large: 1024,
    xLarge: 1440,
    fullWidth: 1632
};
const $357e2cbeb939ea42$export$987d49ffe1b0900f = {
    medium: `@media (min-width: ${$357e2cbeb939ea42$var$mediaSizes.medium}px)`,
    large: `@media (min-width: ${$357e2cbeb939ea42$var$mediaSizes.large}px)`,
    xLarge: `@media (min-width: ${$357e2cbeb939ea42$var$mediaSizes.xLarge}px)`
};

});

parcelRegister("cbxDY", function(module, exports) {

$parcel$export(module.exports, "baseUnit", function () { return $8df09c095e11b905$export$4738d597a47e577d; });
$parcel$export(module.exports, "spacing", function () { return $8df09c095e11b905$export$5458b64234d1333c; });
const $8df09c095e11b905$export$4738d597a47e577d = 4;
const $8df09c095e11b905$var$spacingFactor = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    16,
    32
];
const $8df09c095e11b905$export$5458b64234d1333c = $8df09c095e11b905$var$spacingFactor.reduce((acc, next)=>{
    acc[`size${next}`] = next * $8df09c095e11b905$export$4738d597a47e577d;
    return acc;
}, {});

});

parcelRegister("xIzHg", function(module, exports) {

$parcel$export(module.exports, "padding", function () { return $0655a8ccb2159f0d$export$6f98e8eaf0be1996; });

var $cbxDY = parcelRequire("cbxDY");
const $0655a8ccb2159f0d$export$6f98e8eaf0be1996 = {
    small: (0, $cbxDY.baseUnit) * 2,
    medium: (0, $cbxDY.baseUnit) * 4,
    large: (0, $cbxDY.baseUnit) * 6,
    xLarge: (0, $cbxDY.baseUnit) * 8
};

});

parcelRegister("8JWbY", function(module, exports) {

$parcel$export(module.exports, "colors", function () { return $65cfaa7358e7d5d8$export$8f45430ccf837300; });
const $65cfaa7358e7d5d8$export$8f45430ccf837300 = {
    neutralColors: {
        white: '#ffffff',
        black: '#141414',
        slate02: '#fcfcfc',
        slate05: '#f8f8f8',
        slate10: '#f1f1f1',
        slate20: '#e4e4e3',
        slate30: '#d6d6d5',
        slate40: '#c8c8c7',
        slate50: '#adadac',
        slate60: '#919190',
        slateBase: '#767674',
        slate90: '#474746',
        slate100: '#2f2f2e',
        slate900: '#292928'
    },
    boldColors: {
        lightBlue: {
            ligthBlue10: '#e9f2f8',
            ligthBlue20: '#d4e5f2',
            lightBlue30: '#bed7eb',
            lightBlue50: '#7db0d8',
            base: '#277bbe',
            lightBlue80: '#1f6298',
            lightBlue90: '#174a72',
            lightBlue100: '#10314c'
        },
        darkBlue: {
            base: '#0248a4',
            darkBlue80: '#013a87'
        }
    },
    accentColors: {
        gold: {
            base: '#fdb100'
        }
    },
    utilityColors: {
        information: {
            base: '#009bd7',
            information400: '#179FE3',
            information50: '#E6F5FC'
        },
        success: {
            base: '#22a317',
            dark: '#138b09',
            success400: '#1CB20C'
        },
        warning: {
            base: '#ffc900',
            warning100: '#ffc90096',
            warning400: '#F2A705'
        },
        error: {
            base: '#e3000b',
            error500: '#DB1F1F',
            error600: '#B20707'
        }
    }
};

});

parcelRegister("e200k", function(module, exports) {

$parcel$export(module.exports, "featureFlags", function () { return $a3714177d0fdb89b$export$e62953d023125748; });
const $a3714177d0fdb89b$export$e62953d023125748 = {
    requiredProof: {
        startYear: 2024
    }
};

});



parcelRegister("302dL", function(module, exports) {

$parcel$export(module.exports, "Spinner", function () { return $22f318340c30ab52$export$7f7cbe89f1eacd2; });

var $df8fE = parcelRequire("df8fE");

var $dGX7M = parcelRequire("dGX7M");
const $22f318340c30ab52$export$7f7cbe89f1eacd2 = ()=>{
    return /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
        css: (0, $dGX7M.loaderContainerStyle),
        role: "progressbar",
        "aria-busy": "true",
        children: [
            /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                css: (0, $dGX7M.circlesContainerStyle),
                children: [
                    /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                        css: (0, $dGX7M.circle1Style)
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                        css: (0, $dGX7M.circle2Style)
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                        css: (0, $dGX7M.circle3Style)
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                        css: (0, $dGX7M.circle4Style)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                css: (0, $dGX7M.heartContainerStyle),
                children: [
                    /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                        css: (0, $dGX7M.heartBottomPieceStyle)
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                        css: (0, $dGX7M.heartTopLeftPieceStyle)
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                        css: (0, $dGX7M.heartTopRightPieceStyle)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                css: (0, $dGX7M.headContainerStyle),
                children: [
                    /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                        css: (0, $dGX7M.headTopPieceStyle)
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                        css: (0, $dGX7M.headCenterPieceStyle),
                        children: [
                            /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                                css: (0, $dGX7M.eye1Style)
                            }),
                            /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                                css: (0, $dGX7M.eye2Style)
                            }),
                            /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                                css: (0, $dGX7M.headSmileStyle)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                        css: (0, $dGX7M.headBottomPieceStyle)
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("dGX7M", function(module, exports) {

$parcel$export(module.exports, "loaderContainerStyle", function () { return $9f7d0f84dd168036$export$1207849e90acaff2; });
$parcel$export(module.exports, "circlesContainerStyle", function () { return $9f7d0f84dd168036$export$fe1bdb9b45429a59; });
$parcel$export(module.exports, "circle1Style", function () { return $9f7d0f84dd168036$export$3cc0e757c9496f3d; });
$parcel$export(module.exports, "circle2Style", function () { return $9f7d0f84dd168036$export$d774207aca4af861; });
$parcel$export(module.exports, "circle3Style", function () { return $9f7d0f84dd168036$export$bef12586d2f0a092; });
$parcel$export(module.exports, "circle4Style", function () { return $9f7d0f84dd168036$export$111bb31ab3dc8cb1; });
$parcel$export(module.exports, "heartContainerStyle", function () { return $9f7d0f84dd168036$export$decef80e1c8cbc76; });
$parcel$export(module.exports, "heartBottomPieceStyle", function () { return $9f7d0f84dd168036$export$85575e3b99b1c5c; });
$parcel$export(module.exports, "heartTopLeftPieceStyle", function () { return $9f7d0f84dd168036$export$62b5797474f9bfc5; });
$parcel$export(module.exports, "heartTopRightPieceStyle", function () { return $9f7d0f84dd168036$export$ba5140f6e6c007dd; });
$parcel$export(module.exports, "headContainerStyle", function () { return $9f7d0f84dd168036$export$5d928225ddb5beff; });
$parcel$export(module.exports, "headTopPieceStyle", function () { return $9f7d0f84dd168036$export$257631f13bf5ae46; });
$parcel$export(module.exports, "headCenterPieceStyle", function () { return $9f7d0f84dd168036$export$6d51069bdefb697f; });
$parcel$export(module.exports, "headBottomPieceStyle", function () { return $9f7d0f84dd168036$export$73e3b6e07391b4e9; });
$parcel$export(module.exports, "headSmileStyle", function () { return $9f7d0f84dd168036$export$23ba3bb1531a31d6; });
$parcel$export(module.exports, "eye1Style", function () { return $9f7d0f84dd168036$export$582c8c6777f090cb; });
$parcel$export(module.exports, "eye2Style", function () { return $9f7d0f84dd168036$export$3d98df5e586f7b0d; });
parcelRequire("aaf2d");
var $2WWDJ = parcelRequire("2WWDJ");
var $aaf2d = parcelRequire("aaf2d");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
// Variables
const $9f7d0f84dd168036$var$animationDuration = '5s';
const $9f7d0f84dd168036$var$spinnerColor = (0, $8JWbY.colors).utilityColors.warning.base;
// Animations
const $9f7d0f84dd168036$var$circlesAnimation = (0, $aaf2d.keyframes)`
  100% {
    transform: rotate(1080deg);
  }
  20%,
  45%,
  70%,
  95% {
    width: 40px;
    height: 40px;
    margin-left: -20px;
    margin-top: -20px;
    opacity: 0;
  }

  0%,
  15%,
  50%,
  65%,
  100% {
    width: 100px;
    height: 100px;
    margin-left: -50px;
    margin-top: -50px;
    opacity: 1;
  }
`;
const $9f7d0f84dd168036$var$heartAnimation = (0, $aaf2d.keyframes)`
  70% {
    transform: scale(0) rotate(-40deg);
  }
  75%,
  90% {
    transform: scale(1) rotate(0deg);
  }
  95% {
    transform: scale(0) rotate(40deg);
  }
`;
const $9f7d0f84dd168036$var$headAnimation = (0, $aaf2d.keyframes)`
  20% {
    transform: scale(0) rotate(-40deg);
  }
  25%,
  40% {
    transform: scale(1) rotate(0deg);
  }
  45% {
    transform: scale(0) rotate(40deg);
  }
`;
const $9f7d0f84dd168036$var$generalCircleStyle = {
    width: 40,
    height: 40,
    borderRadius: 20,
    position: 'absolute',
    background: $9f7d0f84dd168036$var$spinnerColor
};
const $9f7d0f84dd168036$var$generalHeartTopPieceStyle = {
    width: 30,
    height: 30,
    background: $9f7d0f84dd168036$var$spinnerColor,
    borderRadius: 15,
    left: '50%',
    top: '50%',
    position: 'absolute'
};
const $9f7d0f84dd168036$var$generalEyeStyle = {
    position: 'absolute',
    background: 'black',
    width: 6,
    height: 6,
    borderRadius: 3,
    top: 14
};
const $9f7d0f84dd168036$export$1207849e90acaff2 = (0, $2WWDJ.default)({
    position: 'relative',
    left: '50%',
    top: '50%',
    width: 300,
    height: 300,
    margin: '-150px auto auto -150px',
    transform: 'scale(0.5)'
});
const $9f7d0f84dd168036$export$fe1bdb9b45429a59 = (0, $2WWDJ.default)({
    animationName: $9f7d0f84dd168036$var$circlesAnimation,
    animationDuration: $9f7d0f84dd168036$var$animationDuration,
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear',
    width: 120,
    height: 120,
    position: 'absolute',
    left: '50%',
    top: '50%',
    margin: '-60px auto auto -60px'
});
const $9f7d0f84dd168036$export$3cc0e757c9496f3d = (0, $2WWDJ.default)({
    ...$9f7d0f84dd168036$var$generalCircleStyle,
    top: 0,
    left: 0
});
const $9f7d0f84dd168036$export$d774207aca4af861 = (0, $2WWDJ.default)({
    ...$9f7d0f84dd168036$var$generalCircleStyle,
    top: 0,
    right: 0
});
const $9f7d0f84dd168036$export$bef12586d2f0a092 = (0, $2WWDJ.default)({
    ...$9f7d0f84dd168036$var$generalCircleStyle,
    bottom: 0,
    right: 0
});
const $9f7d0f84dd168036$export$111bb31ab3dc8cb1 = (0, $2WWDJ.default)({
    ...$9f7d0f84dd168036$var$generalCircleStyle,
    bottom: 0,
    left: 0
});
const $9f7d0f84dd168036$export$decef80e1c8cbc76 = (0, $2WWDJ.default)({
    animationName: $9f7d0f84dd168036$var$heartAnimation,
    animationDuration: $9f7d0f84dd168036$var$animationDuration,
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease-in-out',
    transform: 'scale(0)',
    position: 'absolute',
    width: 100,
    height: 100,
    left: '50%',
    top: '50%',
    margin: '-45px auto auto -50px'
});
const $9f7d0f84dd168036$export$85575e3b99b1c5c = (0, $2WWDJ.default)({
    position: 'absolute',
    width: 30,
    height: 30,
    background: $9f7d0f84dd168036$var$spinnerColor,
    transform: 'rotate(45deg)',
    left: '50%',
    top: '50%',
    margin: '-15px 0 0 -15px',
    borderRadius: '0 0 4px 0'
});
const $9f7d0f84dd168036$export$62b5797474f9bfc5 = (0, $2WWDJ.default)({
    ...$9f7d0f84dd168036$var$generalHeartTopPieceStyle,
    margin: '-26px auto auto -26px',
    background: $9f7d0f84dd168036$var$spinnerColor
});
const $9f7d0f84dd168036$export$ba5140f6e6c007dd = (0, $2WWDJ.default)({
    ...$9f7d0f84dd168036$var$generalHeartTopPieceStyle,
    margin: '-26px auto auto -4px',
    background: $9f7d0f84dd168036$var$spinnerColor
});
const $9f7d0f84dd168036$export$5d928225ddb5beff = (0, $2WWDJ.default)({
    transform: 'scale(0)',
    animationName: $9f7d0f84dd168036$var$headAnimation,
    animationDuration: $9f7d0f84dd168036$var$animationDuration,
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease-in-out',
    position: 'absolute',
    width: 52,
    height: 52,
    left: '50%',
    top: '50%',
    margin: '-26px auto auto -26px'
});
const $9f7d0f84dd168036$export$257631f13bf5ae46 = (0, $2WWDJ.default)({
    position: 'absolute',
    width: 26,
    height: 12,
    background: $9f7d0f84dd168036$var$spinnerColor,
    left: '50%',
    marginLeft: -13,
    borderRadius: '2px 2px 0 0'
});
const $9f7d0f84dd168036$export$6d51069bdefb697f = (0, $2WWDJ.default)({
    position: 'absolute',
    width: 48,
    height: 39,
    background: $9f7d0f84dd168036$var$spinnerColor,
    borderRadius: 9,
    left: 2,
    top: 8
});
const $9f7d0f84dd168036$export$73e3b6e07391b4e9 = (0, $2WWDJ.default)({
    position: 'absolute',
    width: 30,
    height: 7,
    left: '50%',
    marginLeft: -15,
    bottom: 0,
    background: $9f7d0f84dd168036$var$spinnerColor
});
const $9f7d0f84dd168036$export$23ba3bb1531a31d6 = (0, $2WWDJ.default)({
    position: 'absolute',
    width: 18,
    height: 7,
    background: 'transparent',
    left: '50%',
    top: 24,
    marginLeft: -9,
    borderRadius: '0 0 50% 50%',
    borderBottom: '2px solid black',
    boxSizing: 'border-box'
});
const $9f7d0f84dd168036$export$582c8c6777f090cb = (0, $2WWDJ.default)({
    ...$9f7d0f84dd168036$var$generalEyeStyle,
    left: 14
});
const $9f7d0f84dd168036$export$3d98df5e586f7b0d = (0, $2WWDJ.default)({
    ...$9f7d0f84dd168036$var$generalEyeStyle,
    right: 14
});

});
parcelRegister("aaf2d", function(module, exports) {

$parcel$export(module.exports, "jsx", function () { return $766680255ea244ce$export$34b9dba7ce09269b; });
$parcel$export(module.exports, "keyframes", function () { return $766680255ea244ce$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("2WWDJ")).default; });

var $7c1WO = parcelRequire("7c1WO");

var $a5EUy = parcelRequire("a5EUy");

var $9015J = parcelRequire("9015J");

var $kdmAy = parcelRequire("kdmAy");

var $2EV1U = parcelRequire("2EV1U");

var $eXRD4 = parcelRequire("eXRD4");

var $2WWDJ = parcelRequire("2WWDJ");
var $766680255ea244ce$var$EmotionCacheContext = (0, $a5EUy.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? (0, $9015J.default)() : null);
var $766680255ea244ce$export$2c657da244d00bd6 = (0, $a5EUy.createContext)({});
var $766680255ea244ce$export$8b61c863970f2dd2 = $766680255ea244ce$var$EmotionCacheContext.Provider;
var $766680255ea244ce$export$f78961b537b140b1 = function withEmotionCache(func) {
    var render = function render(props, ref) {
        return (0, $a5EUy.createElement)($766680255ea244ce$var$EmotionCacheContext.Consumer, null, function(cache) {
            return func(props, cache, ref);
        });
    }; // $FlowFixMe
    return (0, $a5EUy.forwardRef)(render);
};
// thus we only need to replace what is a valid character for JS, but not for CSS
var $766680255ea244ce$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $766680255ea244ce$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $766680255ea244ce$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $766680255ea244ce$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $766680255ea244ce$var$render = function render(cache, props, theme, ref) {
    var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$766680255ea244ce$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $kdmAy.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $2EV1U.serializeStyles)(registeredStyles);
    var labelFromStack;
    var rules = (0, $kdmAy.insertStyles)(cache, serialized, typeof type === 'string');
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($766680255ea244ce$var$hasOwnProperty.call(props, key) && key !== 'css' && key !== $766680255ea244ce$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = (0, $a5EUy.createElement)(type, newProps);
    return ele;
};
var $766680255ea244ce$var$Emotion = /* #__PURE__ */ $766680255ea244ce$export$f78961b537b140b1(function(props, cache, ref) {
    // use Context.read for the theme when it's stable
    if (typeof props.css === 'function') return (0, $a5EUy.createElement)($766680255ea244ce$export$2c657da244d00bd6.Consumer, null, function(theme) {
        return $766680255ea244ce$var$render(cache, props, theme, ref);
    });
    return $766680255ea244ce$var$render(cache, props, null, ref);
});
var $766680255ea244ce$export$34b9dba7ce09269b = function jsx(type, props) {
    var args = arguments;
    if (props == null || !$766680255ea244ce$var$hasOwnProperty.call(props, 'css')) // $FlowFixMe
    return (0, $a5EUy.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = $766680255ea244ce$var$Emotion;
    var newProps = {};
    for(var key in props)if ($766680255ea244ce$var$hasOwnProperty.call(props, key)) newProps[key] = props[key];
    newProps[$766680255ea244ce$var$typePropName] = type;
    var error, match;
    createElementArgArray[1] = newProps;
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $a5EUy.createElement).apply(null, createElementArgArray);
};
var $766680255ea244ce$var$warnedAboutCssPropForGlobal = false;
var $766680255ea244ce$export$98f03c5d19621d70 = /* #__PURE__ */ $766680255ea244ce$export$f78961b537b140b1(function(props, cache) {
    var styles = props.styles;
    if (typeof styles === 'function') return (0, $a5EUy.createElement)($766680255ea244ce$export$2c657da244d00bd6.Consumer, null, function(theme) {
        var serialized = (0, $2EV1U.serializeStyles)([
            styles(theme)
        ]);
        return (0, $a5EUy.createElement)($766680255ea244ce$var$InnerGlobal, {
            serialized: serialized,
            cache: cache
        });
    });
    var serialized = (0, $2EV1U.serializeStyles)([
        styles
    ]);
    return (0, $a5EUy.createElement)($766680255ea244ce$var$InnerGlobal, {
        serialized: serialized,
        cache: cache
    });
});
// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $766680255ea244ce$var$InnerGlobal = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($7c1WO)))(InnerGlobal, _React$Component);
    function InnerGlobal(props, context, updater) {
        return _React$Component.call(this, props, context, updater) || this;
    }
    var _proto = InnerGlobal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.sheet = new (0, $eXRD4.StyleSheet)({
            key: this.props.cache.key + "-global",
            nonce: this.props.cache.sheet.nonce,
            container: this.props.cache.sheet.container
        }); // $FlowFixMe
        var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
        if (node !== null) this.sheet.tags.push(node);
        if (this.props.cache.sheet.tags.length) this.sheet.before = this.props.cache.sheet.tags[0];
        this.insertStyles();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.serialized.name !== this.props.serialized.name) this.insertStyles();
    };
    _proto.insertStyles = function insertStyles$1() {
        if (this.props.serialized.next !== undefined) // insert keyframes
        (0, $kdmAy.insertStyles)(this.props.cache, this.props.serialized.next, true);
        if (this.sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
            this.sheet.before = element;
            this.sheet.flush();
        }
        this.props.cache.insert("", this.props.serialized, this.sheet, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.sheet.flush();
    };
    _proto.render = function render() {
        return null;
    };
    return InnerGlobal;
}((0, $a5EUy.Component));
var $766680255ea244ce$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = (0, $2WWDJ.default).apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $766680255ea244ce$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $766680255ea244ce$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $kdmAy.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $766680255ea244ce$export$9b9c0f9d9f3552b8 = $766680255ea244ce$export$f78961b537b140b1(function(props, context) {
    return (0, $a5EUy.createElement)($766680255ea244ce$export$2c657da244d00bd6.Consumer, null, function(theme) {
        var hasRendered = false;
        var css = function css() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var serialized = (0, $2EV1U.serializeStyles)(args, context.registered);
            (0, $kdmAy.insertStyles)(context, serialized, false);
            return context.key + "-" + serialized.name;
        };
        var cx = function cx() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return $766680255ea244ce$var$merge(context.registered, css, $766680255ea244ce$var$classnames(args));
        };
        var content = {
            css: css,
            cx: cx,
            theme: theme
        };
        var ele = props.children(content);
        hasRendered = true;
        return ele;
    });
});

});
parcelRegister("7c1WO", function(module, exports) {

var $kfcIU = parcelRequire("kfcIU");
function $53cb2a23f1eda857$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $kfcIU(t, o);
}
module.exports = $53cb2a23f1eda857$var$_inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kfcIU", function(module, exports) {
function $ebcf13f22b5396eb$var$_setPrototypeOf(t, e) {
    return module.exports = $ebcf13f22b5396eb$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $ebcf13f22b5396eb$var$_setPrototypeOf(t, e);
}
module.exports = $ebcf13f22b5396eb$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9015J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68d4f5dbf4894f2a$export$2e2bcd8739ae039; });

var $eXRD4 = parcelRequire("eXRD4");

var $bF86J = parcelRequire("bF86J");
parcelRequire("gniKh");
// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $68d4f5dbf4894f2a$var$delimiter = '/*|*/';
var $68d4f5dbf4894f2a$var$needle = $68d4f5dbf4894f2a$var$delimiter + '}';
function $68d4f5dbf4894f2a$var$toSheet(block) {
    if (block) $68d4f5dbf4894f2a$var$Sheet.current.insert(block + '}');
}
var $68d4f5dbf4894f2a$var$Sheet = {
    current: null
};
var $68d4f5dbf4894f2a$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $68d4f5dbf4894f2a$var$Sheet.current.insert(content + ';');
                    return '';
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return '';
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $68d4f5dbf4894f2a$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $68d4f5dbf4894f2a$var$Sheet.current.insert(selectors[0] + content);
                    return '';
                default:
                    return content + (at === 0 ? $68d4f5dbf4894f2a$var$delimiter : '');
            }
        case -2:
            content.split($68d4f5dbf4894f2a$var$needle).forEach($68d4f5dbf4894f2a$var$toSheet);
    }
};
var $68d4f5dbf4894f2a$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || 'css';
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $bF86J.default)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(' ').forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($68d4f5dbf4894f2a$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $68d4f5dbf4894f2a$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $eXRD4.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $68d4f5dbf4894f2a$export$2e2bcd8739ae039 = $68d4f5dbf4894f2a$var$createCache;

});
parcelRegister("eXRD4", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $ae502d093012093b$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $ae502d093012093b$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $ae502d093012093b$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    return tag;
}
var $ae502d093012093b$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = $ae502d093012093b$var$createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $ae502d093012093b$var$sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("bF86J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87d9d00bcb20822b$export$2e2bcd8739ae039; });
function $87d9d00bcb20822b$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $87d9d00bcb20822b$export$2e2bcd8739ae039 = $87d9d00bcb20822b$var$stylis_min;

});

parcelRegister("gniKh", function(module, exports) {
var $031391e6655522b3$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $031391e6655522b3$export$2e2bcd8739ae039 = $031391e6655522b3$var$weakMemoize;

});


parcelRegister("kdmAy", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $eb768b2d102c22a6$export$95d99596f328fd52; });
$parcel$export(module.exports, "insertStyles", function () { return $eb768b2d102c22a6$export$6f077d94b33a01aa; });
var $eb768b2d102c22a6$var$isBrowser = true;
function $eb768b2d102c22a6$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className]);
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $eb768b2d102c22a6$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $eb768b2d102c22a6$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("2EV1U", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $1efb8e245c1b8466$export$6321afa313b251b5; });

var $1MtlA = parcelRequire("1MtlA");

var $7tNMj = parcelRequire("7tNMj");

var $cY7di = parcelRequire("cY7di");
var $1efb8e245c1b8466$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $1efb8e245c1b8466$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $1efb8e245c1b8466$var$hyphenateRegex = /[A-Z]|^ms/g;
var $1efb8e245c1b8466$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $1efb8e245c1b8466$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $1efb8e245c1b8466$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $1efb8e245c1b8466$var$processStyleName = (0, $cY7di.default)(function(styleName) {
    return $1efb8e245c1b8466$var$isCustomProperty(styleName) ? styleName : styleName.replace($1efb8e245c1b8466$var$hyphenateRegex, '-$&').toLowerCase();
});
var $1efb8e245c1b8466$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($1efb8e245c1b8466$var$animationRegex, function(match, p1, p2) {
                $1efb8e245c1b8466$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $1efb8e245c1b8466$var$cursor
                };
                return p1;
            });
    }
    if ((0, $7tNMj.default)[key] !== 1 && !$1efb8e245c1b8466$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $1efb8e245c1b8466$var$contentValuePattern, $1efb8e245c1b8466$var$contentValues, $1efb8e245c1b8466$var$oldProcessStyleValue, $1efb8e245c1b8466$var$msPattern, $1efb8e245c1b8466$var$hyphenPattern, $1efb8e245c1b8466$var$hyphenatedCache;
var $1efb8e245c1b8466$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $1efb8e245c1b8466$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $1efb8e245c1b8466$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $1efb8e245c1b8466$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $1efb8e245c1b8466$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $1efb8e245c1b8466$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $1efb8e245c1b8466$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $1efb8e245c1b8466$var$cursor;
                var result = interpolation(mergedProps);
                $1efb8e245c1b8466$var$cursor = previousCursor;
                return $1efb8e245c1b8466$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $1efb8e245c1b8466$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $1efb8e245c1b8466$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($1efb8e245c1b8466$var$isProcessableValue(value)) string += $1efb8e245c1b8466$var$processStyleName(_key) + ":" + $1efb8e245c1b8466$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($1efb8e245c1b8466$var$isProcessableValue(value[_i])) string += $1efb8e245c1b8466$var$processStyleName(_key) + ":" + $1efb8e245c1b8466$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $1efb8e245c1b8466$var$handleInterpolation(mergedProps, registered, value, false);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $1efb8e245c1b8466$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $1efb8e245c1b8466$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $1efb8e245c1b8466$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $1efb8e245c1b8466$var$cursor;
var $1efb8e245c1b8466$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $1efb8e245c1b8466$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $1efb8e245c1b8466$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $1efb8e245c1b8466$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $1efb8e245c1b8466$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $1efb8e245c1b8466$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $1MtlA.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $1efb8e245c1b8466$var$cursor
    };
};

});
parcelRegister("1MtlA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14c109dbfdc6a1a3$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $14c109dbfdc6a1a3$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $14c109dbfdc6a1a3$export$2e2bcd8739ae039 = $14c109dbfdc6a1a3$var$murmur2;

});

parcelRegister("7tNMj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5721dac45c8ed638$export$2e2bcd8739ae039; });
var $5721dac45c8ed638$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $5721dac45c8ed638$export$2e2bcd8739ae039 = $5721dac45c8ed638$var$unitlessKeys;

});

parcelRegister("cY7di", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9710af17899fc667$export$2e2bcd8739ae039; });
function $9710af17899fc667$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $9710af17899fc667$export$2e2bcd8739ae039 = $9710af17899fc667$var$memoize;

});


parcelRegister("2WWDJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $225e7c2d3f6efae7$export$2e2bcd8739ae039; });

var $2EV1U = parcelRequire("2EV1U");
function $225e7c2d3f6efae7$var$css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $2EV1U.serializeStyles)(args);
}
var $225e7c2d3f6efae7$export$2e2bcd8739ae039 = $225e7c2d3f6efae7$var$css;

});




parcelRegister("oMBXq", function(module, exports) {

$parcel$export(module.exports, "GET_SURVEY_PAGE", function () { return $04a7f32e4cf1a906$export$a967ad3018fbe213; });
$parcel$export(module.exports, "GET_SURVEY_LIST", function () { return $04a7f32e4cf1a906$export$6362868df983f979; });
$parcel$export(module.exports, "GET_COMPLETE_PAGE_DATA", function () { return $04a7f32e4cf1a906$export$c99b09d55436be15; });
$parcel$export(module.exports, "UPDATE_ANSWER", function () { return $04a7f32e4cf1a906$export$665446046e211b61; });
$parcel$export(module.exports, "UPDATE_ALL_ANSWERS", function () { return $04a7f32e4cf1a906$export$9565ea37c098d66; });
$parcel$export(module.exports, "FINISH_SURVEY", function () { return $04a7f32e4cf1a906$export$42d41fcb8525466c; });
$parcel$export(module.exports, "RESET", function () { return $04a7f32e4cf1a906$export$4a991c87e640ef77; });
parcelRequire("2UBc8");
var $3EDHG = parcelRequire("3EDHG");
const $04a7f32e4cf1a906$export$a967ad3018fbe213 = (0, $3EDHG.default)`
  query GetSurveyPage($customerId: String!, $year: Int!, $version: Int!) {
    getAnswers(customerId: $customerId, year: $year, version: $version) {
      questionId
      isValid
      isComplete
      selectedAnswer
      comment
      images
    }
    getSurvey(customerId: $customerId, year: $year, version: $version) {
      surveyId
      questionId
      headline
      subHeader
      questionType
      conditions
      explanation
      answerOptions {
        answerId
        text
        score
        subAnswerHeader
        minimumSubAnswers
        subAnswerOptions {
          answerId
          text
        }
      }
      answersExemptFromAttachments {
        answerId
      }
      furtherDetails
      commentsInTextBox
      commentsTextBox
      uploadHeadline
      upload
    }
    getSurveyInfo(customerId: $customerId, year: $year, version: $version) {
      uploadId
      surveyState {
        isComplete
        isEditable
        score
      }
    }
  }
`;
const $04a7f32e4cf1a906$export$6362868df983f979 = (0, $3EDHG.default)`
  query GetSurveyList($customerId: String!) {
    getSurveyList(customerId: $customerId) {
      year
      version
      uploadId
      active
      surveyState {
        isComplete
        isEditable
        status
      }
    }
  }
`;
const $04a7f32e4cf1a906$export$c99b09d55436be15 = (0, $3EDHG.default)`
  query getCompletePageData($customerId: String!, $year: Int!, $version: Int!) {
    getSurvey(customerId: $customerId, year: $year, version: $version) {
      headline
      questionId
      questionType
      commentsTextBox
      upload
      answersExemptFromAttachments {
        answerId
      }
    }
    getAnswers(customerId: $customerId, year: $year, version: $version) {
      questionId
      isComplete
      selectedAnswer
      comment
      images
    }
    getSurveyState(customerId: $customerId, year: $year, version: $version) {
      isComplete
      isEditable
      score
    }
  }
`;
const $04a7f32e4cf1a906$export$665446046e211b61 = (0, $3EDHG.default)`
  mutation UpdateAnswer(
    $customerId: String!
    $answer: AnswerInput!
    $year: Int!
    $version: Int!
  ) {
    updateAnswer(
      customerId: $customerId
      answer: $answer
      year: $year
      version: $version
    ) {
      questionId
    }
  }
`;
const $04a7f32e4cf1a906$export$9565ea37c098d66 = (0, $3EDHG.default)`
  mutation UpdateAllAnswers(
    $customerId: String!
    $answers: [AnswerInput!]!
    $year: Int!
    $version: Int!
  ) {
    updateAllAnswers(
      customerId: $customerId
      answers: $answers
      year: $year
      version: $version
    )
  }
`;
const $04a7f32e4cf1a906$export$42d41fcb8525466c = (0, $3EDHG.default)`
  mutation FinishSurvey($customerId: String!, $year: Int!, $version: Int!) {
    finishSurvey(customerId: $customerId, year: $year, version: $version)
  }
`;
const $04a7f32e4cf1a906$export$4a991c87e640ef77 = (0, $3EDHG.default)`
  mutation Reset($customerId: String!, $year: Int!, $version: Int!) {
    reset(customerId: $customerId, year: $year, version: $version)
  }
`;

});

parcelRegister("dSPjH", function(module, exports) {

$parcel$export(module.exports, "UserProvider", function () { return $a1b81ff1fe22a92d$export$88f24fd8fcfab6ca; });
$parcel$export(module.exports, "useUser", function () { return $a1b81ff1fe22a92d$export$23bbbc4533528f03; });

var $df8fE = parcelRequire("df8fE");

var $a5EUy = parcelRequire("a5EUy");
parcelRequire("3XIEi");
var $bzHnt = parcelRequire("bzHnt");
parcelRequire("2UBc8");
var $eBKZl = parcelRequire("eBKZl");

var $3yJBl = parcelRequire("3yJBl");

var $9AErM = parcelRequire("9AErM");

var $4zZNZ = parcelRequire("4zZNZ");

var $3rEbh = parcelRequire("3rEbh");

var $iSOfh = parcelRequire("iSOfh");

var $7eF6Y = parcelRequire("7eF6Y");

var $gFRU1 = parcelRequire("gFRU1");

var $6tz0u = parcelRequire("6tz0u");

var $e5XFO = parcelRequire("e5XFO");
parcelRequire("dntWt");
var $fHgS9 = parcelRequire("fHgS9");
var $gAOhP = parcelRequire("gAOhP");
const $a1b81ff1fe22a92d$export$38ee920e59704589 = /*#__PURE__*/ (0, $a5EUy.createContext)();
const $a1b81ff1fe22a92d$export$ff8267b11443f854 = 'ci';
const $a1b81ff1fe22a92d$export$68467daca2272b45 = 'cn';
const $a1b81ff1fe22a92d$export$79313f931383b45b = 'lce';
const $a1b81ff1fe22a92d$var$userHasSurveyAccess = (cognitoUser)=>{
    return cognitoUser?.signInUserSession?.idToken?.payload?.['custom:roles']?.includes('MCPSurveyUser');
};
const $a1b81ff1fe22a92d$export$88f24fd8fcfab6ca = ({ children: children })=>{
    const [user, setUser] = (0, $a5EUy.useState)(null);
    const [isUserLoading, setIsUserLoading] = (0, $a5EUy.useState)(true);
    const [selectedCustomer, updateSelectedCustomer] = (0, $a5EUy.useState)({
        id: window.localStorage.getItem($a1b81ff1fe22a92d$export$ff8267b11443f854) || null,
        name: window.localStorage.getItem($a1b81ff1fe22a92d$export$68467daca2272b45) || null,
        hasAcceptedTerms: null,
        isLoading: true,
        legoContactEmail: ''
    });
    const didInit = (0, $a5EUy.useRef)(false);
    async function signOut() {
        (0, $gFRU1.addDefaultBreadcrumb)('User signing out', 'UserProvder.signOut');
        try {
            await (0, $bzHnt.Auth).signOut();
        } catch (error) {
            const { svy_snackbar_error_header: svy_snackbar_error_header, svy_snackbar_error_default_text: svy_snackbar_error_default_text } = (0, $iSOfh.labelTranslationsFallback);
            (0, $7eF6Y.generalApiErrorHandler)({
                error: error,
                snackbarHeader: svy_snackbar_error_header,
                snackbarMessage: svy_snackbar_error_default_text
            });
        }
    }
    (0, $a5EUy.useEffect)(()=>{
        async function getUser() {
            let user = {};
            try {
                user = await (0, $bzHnt.Auth).currentAuthenticatedUser();
                (0, $gFRU1.addDefaultBreadcrumb)('Current user confirmed', 'UserProvider.getUser');
                if ((0, $e5XFO.isLoggedInWithWrongIdentityProvider)(user)) {
                    (0, $bzHnt.Auth).federatedSignIn({
                        customProvider: "partner-idp-survey"
                    });
                    return;
                }
                if (!$a1b81ff1fe22a92d$var$userHasSurveyAccess(user)) {
                    (0, $fHgS9.addSnackbar)({
                        type: (0, $gAOhP.snackbarTypes).ERROR,
                        header: 'No Access',
                        text: 'This user does not have access to MCP'
                    });
                    // Wait for 2 seconds before signing out to allow the snackbar to be displayed
                    await new Promise((resolve)=>setTimeout(resolve, 2000));
                    await signOut();
                    return;
                }
                setUser(user);
            } catch (error) {
                (0, $gFRU1.addDefaultBreadcrumb)('Failed to set user', 'UserProvider.getUser');
                const customerId = window.localStorage.getItem($a1b81ff1fe22a92d$export$ff8267b11443f854);
                window.localStorage.removeItem(`${(0, $3rEbh.cookieBannerLocalStorageKeyPrefix)}${customerId}`);
                window.localStorage.removeItem($a1b81ff1fe22a92d$export$ff8267b11443f854);
                window.localStorage.removeItem($a1b81ff1fe22a92d$export$68467daca2272b45);
                window.localStorage.removeItem($a1b81ff1fe22a92d$export$79313f931383b45b);
                if (error !== 'The user is not authenticated') (0, $4zZNZ.logger).logError(error);
            }
            if (!didInit.current) didInit.current = true;
            if (isUserLoading) setIsUserLoading(false);
            if (selectedCustomer.isLoading) updateSelectedCustomer((prevState)=>({
                    ...prevState,
                    isLoading: false
                }));
        }
        if (!user && !didInit.current) getUser();
    }, [
        user,
        isUserLoading,
        selectedCustomer
    ]);
    const { loading: getUserInfoLoading, error: getUserInfoError } = (0, $eBKZl.useQuery)((0, $9AErM.GET_USER_INFO), {
        variables: {
            customerId: selectedCustomer.id,
            year: new Date().getFullYear(),
            version: 1
        },
        skip: isUserLoading || !user || !selectedCustomer.id,
        fetchPolicy: 'network-only',
        onCompleted: handleTermsStateResponse
    });
    function handleTermsStateResponse(response) {
        (0, $gFRU1.addDefaultBreadcrumb)('User information query completed', 'UserProvider.handleTermsStateResponse');
        window.localStorage.setItem($a1b81ff1fe22a92d$export$79313f931383b45b, response.getCustomerAssignments.perform);
        updateSelectedCustomer((prevState)=>({
                ...prevState,
                hasAcceptedTerms: response.getTermsState?.accepted || false,
                isLoading: false,
                legoContactEmail: response.getCustomerAssignments.perform || ''
            }));
    }
    function handleSelectedCustomerUpdate(updateObject) {
        if (Object.prototype.hasOwnProperty.call(updateObject, 'id')) {
            (0, $gFRU1.addCustomBreadcrumb)({
                message: 'Updating selected customer',
                category: 'UserProvider.handleSelectedCustomerUpdate',
                data: {
                    id: updateObject.id
                }
            });
            window.localStorage.setItem($a1b81ff1fe22a92d$export$ff8267b11443f854, updateObject.id);
            window.localStorage.setItem($a1b81ff1fe22a92d$export$68467daca2272b45, updateObject.name);
        }
        updateSelectedCustomer((prevState)=>({
                ...prevState,
                ...updateObject
            }));
    }
    if (getUserInfoError) {
        window.localStorage.removeItem($a1b81ff1fe22a92d$export$ff8267b11443f854);
        window.localStorage.removeItem($a1b81ff1fe22a92d$export$68467daca2272b45);
        window.localStorage.removeItem($a1b81ff1fe22a92d$export$79313f931383b45b);
        (0, $gFRU1.throwErrorWithTransactionName)(getUserInfoError, 'UserProvider');
    }
    function staticUserVariables(additionalVariables) {
        const staticVariablesObject = {
            customerId: selectedCustomer.id
        };
        return {
            ...staticVariablesObject,
            ...additionalVariables
        };
    }
    if (user) {
        (0, $6tz0u.apmBase)?.setUserContext({
            id: user?.id || '',
            username: user.username
        });
        (0, $6tz0u.apmBase)?.setCustomContext({
            customerId: selectedCustomer.id,
            customerName: selectedCustomer.name
        });
    }
    return /*#__PURE__*/ (0, $df8fE.jsx)($a1b81ff1fe22a92d$export$38ee920e59704589.Provider, {
        value: {
            isUserLoading: isUserLoading || getUserInfoLoading || selectedCustomer.isLoading,
            cognitoData: user || {},
            isLoggedIn: !!user,
            selectedCustomer: selectedCustomer,
            handleSelectedCustomerUpdate: handleSelectedCustomerUpdate,
            staticUserVariables: staticUserVariables,
            signOut: signOut
        },
        children: children
    });
};
const $a1b81ff1fe22a92d$export$23bbbc4533528f03 = ()=>{
    const context = (0, $a5EUy.useContext)($a1b81ff1fe22a92d$export$38ee920e59704589);
    if (context === undefined) throw new Error('useUser must be used within a UserProvider');
    return context;
};
$a1b81ff1fe22a92d$export$88f24fd8fcfab6ca.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).node
};

});
parcelRegister("3XIEi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e298427e096fe33$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Auth", function () { return (parcelRequire("bzHnt")).Auth; });
/*
 * Copyright 2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("dRac8");
var $9QDF4 = parcelRequire("9QDF4");
var $kOCH0 = parcelRequire("kOCH0");
parcelRequire("407kk");
var $bzHnt = parcelRequire("bzHnt");

var $3kSIa = parcelRequire("3kSIa");


var $jfKIU = parcelRequire("jfKIU");





var $b46Jf = parcelRequire("b46Jf");



/** Always importing Auth when users import Amplify such that
    for unauthenticated access (no sign in and sign up),
    users don't have to import Auth explicitly **/ (0, $9QDF4.Amplify).Auth = (0, $bzHnt.Auth);
(0, $9QDF4.Amplify).Cache = (0, $3kSIa.default);
(0, $9QDF4.Amplify).ServiceWorker = (0, $kOCH0.ServiceWorkerClass);
var /**
 * @deprecated use named import
 */ $2e298427e096fe33$export$2e2bcd8739ae039 = (0, $9QDF4.Amplify);
$parcel$exportWildcard(module.exports, $b46Jf);

});
parcelRegister("dRac8", function(module, exports) {
$parcel$export(module.exports, "browserOrNode", function () { return (parcelRequire("7HFvj")).browserOrNode; });
$parcel$export(module.exports, "filenameToContentType", function () { return (parcelRequire("7HFvj")).filenameToContentType; });
$parcel$export(module.exports, "isEmpty", function () { return (parcelRequire("7HFvj")).isEmpty; });
$parcel$export(module.exports, "isTextFile", function () { return (parcelRequire("7HFvj")).isTextFile; });
$parcel$export(module.exports, "isWebWorker", function () { return (parcelRequire("7HFvj")).isWebWorker; });
$parcel$export(module.exports, "JS", function () { return (parcelRequire("7HFvj")).JS; });
$parcel$export(module.exports, "objectLessAttributes", function () { return (parcelRequire("7HFvj")).objectLessAttributes; });
$parcel$export(module.exports, "sortByField", function () { return (parcelRequire("7HFvj")).sortByField; });
$parcel$export(module.exports, "Parser", function () { return (parcelRequire("hmdQp")).Parser; });
$parcel$export(module.exports, "INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER", function () { return (parcelRequire("gKydS")).INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER; });
$parcel$export(module.exports, "INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER", function () { return (parcelRequire("gKydS")).INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER; });
$parcel$export(module.exports, "USER_AGENT_HEADER", function () { return (parcelRequire("gKydS")).USER_AGENT_HEADER; });
$parcel$export(module.exports, "DateUtils", function () { return (parcelRequire("8tDDB")).DateUtils; });
$parcel$export(module.exports, "jitteredExponentialRetry", function () { return (parcelRequire("69J7B")).jitteredExponentialRetry; });
$parcel$export(module.exports, "NonRetryableError", function () { return (parcelRequire("69J7B")).NonRetryableError; });
$parcel$export(module.exports, "urlSafeDecode", function () { return (parcelRequire("lpLq9")).urlSafeDecode; });
$parcel$export(module.exports, "urlSafeEncode", function () { return (parcelRequire("lpLq9")).urlSafeEncode; });

$parcel$export(module.exports, "Constants", function () { return $a1682214ac4b15bc$export$a002182e51710d39; });
$parcel$export(module.exports, "Platform", function () { return (parcelRequire("ku8BJ")).Platform; });
$parcel$export(module.exports, "Amplify", function () { return (parcelRequire("9QDF4")).Amplify; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $9QDF4 = parcelRequire("9QDF4");

var $ku8BJ = parcelRequire("ku8BJ");

var $6dNwJ = parcelRequire("6dNwJ");

var $l7cio = parcelRequire("l7cio");


var $hPjfU = parcelRequire("hPjfU");

var $5xGJg = parcelRequire("5xGJg");
parcelRequire("7HFvj");

var $jsbD1 = parcelRequire("jsbD1");
parcelRequire("hmdQp");



var $ddXoz = parcelRequire("ddXoz");

var $kOCH0 = parcelRequire("kOCH0");

var $lpqOV = parcelRequire("lpqOV");

var $8noHm = parcelRequire("8noHm");
parcelRequire("gKydS");
parcelRequire("8tDDB");parcelRequire("69J7B");
var $7KcGx = parcelRequire("7KcGx");
var $aPgXC = parcelRequire("aPgXC");parcelRequire("lpLq9");
var $a1682214ac4b15bc$export$a002182e51710d39 = {
    userAgent: (0, $ku8BJ.Platform).userAgent
};
var /**
 * @deprecated use named import
 */ $a1682214ac4b15bc$export$2e2bcd8739ae039 = (0, $9QDF4.Amplify);

});
parcelRegister("9QDF4", function(module, exports) {

$parcel$export(module.exports, "Amplify", function () { return $72b7bc4f3d352006$export$a3858a9a153cffc7; });

var $l7cio = parcelRequire("l7cio");
var $72b7bc4f3d352006$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $72b7bc4f3d352006$var$logger = new (0, $l7cio.ConsoleLogger)('Amplify');
var $72b7bc4f3d352006$export$b412d755cfa0136 = /** @class */ function() {
    function AmplifyClass() {
        // Everything that is `register`ed is tracked here
        this._components = [];
        this._config = {};
        // All modules (with `getModuleName()`) are stored here for dependency injection
        this._modules = {};
        // for backward compatibility to avoid breaking change
        // if someone is using like Amplify.Auth
        this.Auth = null;
        this.Analytics = null;
        this.API = null;
        this.Credentials = null;
        this.Storage = null;
        this.I18n = null;
        this.Cache = null;
        this.PubSub = null;
        this.Interactions = null;
        this.Pushnotification = null;
        this.UI = null;
        this.XR = null;
        this.Predictions = null;
        this.DataStore = null;
        this.Logger = (0, $l7cio.ConsoleLogger);
        this.ServiceWorker = null;
    }
    AmplifyClass.prototype.register = function(comp) {
        $72b7bc4f3d352006$var$logger.debug('component registered in amplify', comp);
        this._components.push(comp);
        if (typeof comp.getModuleName === 'function') {
            this._modules[comp.getModuleName()] = comp;
            this[comp.getModuleName()] = comp;
        } else $72b7bc4f3d352006$var$logger.debug('no getModuleName method for component', comp);
        // Finally configure this new component(category) loaded
        // With the new modularization changes in Amplify V3, all the Amplify
        // component are not loaded/registered right away but when they are
        // imported (and hence instantiated) in the client's app. This ensures
        // that all new components imported get correctly configured with the
        // configuration that Amplify.configure() was called with.
        comp.configure(this._config);
    };
    AmplifyClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config;
        this._config = Object.assign(this._config, config);
        $72b7bc4f3d352006$var$logger.debug('amplify config', this._config);
        // Dependency Injection via property-setting.
        // This avoids introducing a public method/interface/setter that's difficult to remove later.
        // Plus, it reduces `if` statements within the `constructor` and `configure` of each module
        Object.entries(this._modules).forEach(function(_a) {
            var _b = $72b7bc4f3d352006$var$__read(_a, 2), Name = _b[0], comp = _b[1];
            // e.g. Auth.*
            Object.keys(comp).forEach(function(property) {
                // e.g. Auth["Credentials"] = this._modules["Credentials"] when set
                if (_this._modules[property]) comp[property] = _this._modules[property];
            });
        });
        this._components.map(function(comp) {
            comp.configure(_this._config);
        });
        return this._config;
    };
    AmplifyClass.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable['getCategory'] && typeof pluggable['getCategory'] === 'function') this._components.map(function(comp) {
            if (comp['addPluggable'] && typeof comp['addPluggable'] === 'function') comp.addPluggable(pluggable);
        });
    };
    return AmplifyClass;
}();
var $72b7bc4f3d352006$export$a3858a9a153cffc7 = new $72b7bc4f3d352006$export$b412d755cfa0136();
var /**
 * @deprecated use named import
 */ $72b7bc4f3d352006$export$2e2bcd8739ae039 = $72b7bc4f3d352006$export$a3858a9a153cffc7;

});
parcelRegister("l7cio", function(module, exports) {

$parcel$export(module.exports, "ConsoleLogger", function () { return $f5f3ca1227916628$export$ba6a9c7ac8291f7f; });
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $f5f3ca1227916628$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $f5f3ca1227916628$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f5f3ca1227916628$var$__read(arguments[i]));
    return ar;
};
var $f5f3ca1227916628$var$LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5
};
/**
 * Write logs
 * @class Logger
 */ var $f5f3ca1227916628$export$ba6a9c7ac8291f7f = /** @class */ function() {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ function ConsoleLogger(name, level) {
        if (level === void 0) level = 'WARN';
        this.name = name;
        this.level = level;
    }
    ConsoleLogger.prototype._padding = function(n) {
        return n < 10 ? '0' + n : '' + n;
    };
    ConsoleLogger.prototype._ts = function() {
        var dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(':') + '.' + dt.getMilliseconds();
    };
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype._log = function(type) {
        var msg = [];
        for(var _i = 1; _i < arguments.length; _i++)msg[_i - 1] = arguments[_i];
        var logger_level_name = this.level;
        if (ConsoleLogger.LOG_LEVEL) logger_level_name = ConsoleLogger.LOG_LEVEL;
        if (typeof window !== 'undefined' && window.LOG_LEVEL) logger_level_name = window.LOG_LEVEL;
        var logger_level = $f5f3ca1227916628$var$LOG_LEVELS[logger_level_name];
        var type_level = $f5f3ca1227916628$var$LOG_LEVELS[type];
        if (!(type_level >= logger_level)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        var log = console.log.bind(console);
        if (type === 'ERROR' && console.error) log = console.error.bind(console);
        if (type === 'WARN' && console.warn) log = console.warn.bind(console);
        var prefix = "[" + type + "] " + this._ts() + " " + this.name;
        if (msg.length === 1 && typeof msg[0] === 'string') log(prefix + " - " + msg[0]);
        else if (msg.length === 1) log(prefix, msg[0]);
        else if (typeof msg[0] === 'string') {
            var obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            log(prefix + " - " + msg[0], obj);
        } else log(prefix, msg);
    };
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.log = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $f5f3ca1227916628$var$__spread([
            'INFO'
        ], msg));
    };
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.info = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $f5f3ca1227916628$var$__spread([
            'INFO'
        ], msg));
    };
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.warn = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $f5f3ca1227916628$var$__spread([
            'WARN'
        ], msg));
    };
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.error = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $f5f3ca1227916628$var$__spread([
            'ERROR'
        ], msg));
    };
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.debug = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $f5f3ca1227916628$var$__spread([
            'DEBUG'
        ], msg));
    };
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.verbose = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $f5f3ca1227916628$var$__spread([
            'VERBOSE'
        ], msg));
    };
    ConsoleLogger.LOG_LEVEL = null;
    return ConsoleLogger;
}();

});


parcelRegister("ku8BJ", function(module, exports) {

$parcel$export(module.exports, "Platform", function () { return $ee9d494a54065bc7$export$2dffd0b5373a4389; });
$parcel$export(module.exports, "getAmplifyUserAgent", function () { return $ee9d494a54065bc7$export$ede38edb26c0bfdf; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $5zgkv = parcelRequire("5zgkv");
var $ee9d494a54065bc7$var$BASE_USER_AGENT = "aws-amplify/" + (0, $5zgkv.version);
var $ee9d494a54065bc7$export$2dffd0b5373a4389 = {
    userAgent: $ee9d494a54065bc7$var$BASE_USER_AGENT + " js",
    product: '',
    navigator: null,
    isReactNative: false
};
if (typeof navigator !== 'undefined' && navigator.product) {
    $ee9d494a54065bc7$export$2dffd0b5373a4389.product = navigator.product || '';
    $ee9d494a54065bc7$export$2dffd0b5373a4389.navigator = navigator || null;
    switch(navigator.product){
        case 'ReactNative':
            $ee9d494a54065bc7$export$2dffd0b5373a4389.userAgent = $ee9d494a54065bc7$var$BASE_USER_AGENT + " react-native";
            $ee9d494a54065bc7$export$2dffd0b5373a4389.isReactNative = true;
            break;
        default:
            $ee9d494a54065bc7$export$2dffd0b5373a4389.userAgent = $ee9d494a54065bc7$var$BASE_USER_AGENT + " js";
            $ee9d494a54065bc7$export$2dffd0b5373a4389.isReactNative = false;
            break;
    }
}
var $ee9d494a54065bc7$export$ede38edb26c0bfdf = function() {
    return $ee9d494a54065bc7$export$2dffd0b5373a4389.userAgent;
};
var /**
 * @deprecated use named import
 */ $ee9d494a54065bc7$export$2e2bcd8739ae039 = $ee9d494a54065bc7$export$2dffd0b5373a4389;

});
parcelRegister("5zgkv", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $40dce3631410c926$export$83d89fbfd8236492; });
// generated by genversion
var $40dce3631410c926$export$83d89fbfd8236492 = '3.8.6';

});


parcelRegister("6dNwJ", function(module, exports) {

$parcel$export(module.exports, "ClientDevice", function () { return $487a5ff763e1af13$export$11b7ab1da2ac1804; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $8kLT6 = parcelRequire("8kLT6");
var $487a5ff763e1af13$export$11b7ab1da2ac1804 = /** @class */ function() {
    function ClientDevice() {}
    ClientDevice.clientInfo = function() {
        return (0, $8kLT6.clientInfo)();
    };
    ClientDevice.dimension = function() {
        return (0, $8kLT6.dimension)();
    };
    return ClientDevice;
}();
var /**
 * @deprecated use named import
 */ $487a5ff763e1af13$export$2e2bcd8739ae039 = $487a5ff763e1af13$export$11b7ab1da2ac1804;

});
parcelRegister("8kLT6", function(module, exports) {

$parcel$export(module.exports, "clientInfo", function () { return $61155681fa45b963$export$a2e6d3a753e91268; });
$parcel$export(module.exports, "dimension", function () { return $61155681fa45b963$export$edcd89beb969619a; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $l7cio = parcelRequire("l7cio");
var $61155681fa45b963$var$logger = new (0, $l7cio.ConsoleLogger)('ClientDevice_Browser');
function $61155681fa45b963$export$a2e6d3a753e91268() {
    if (typeof window === 'undefined') return {};
    return $61155681fa45b963$var$browserClientInfo();
}
function $61155681fa45b963$var$browserClientInfo() {
    if (typeof window === 'undefined') {
        $61155681fa45b963$var$logger.warn('No window object available to get browser client info');
        return {};
    }
    var nav = window.navigator;
    if (!nav) {
        $61155681fa45b963$var$logger.warn('No navigator object available to get browser client info');
        return {};
    }
    var platform = nav.platform, product = nav.product, vendor = nav.vendor, userAgent = nav.userAgent, language = nav.language;
    var type = $61155681fa45b963$var$browserType(userAgent);
    var timezone = $61155681fa45b963$var$browserTimezone();
    return {
        platform: platform,
        make: product || vendor,
        model: type.type,
        version: type.version,
        appVersion: [
            type.type,
            type.version
        ].join('/'),
        language: language,
        timezone: timezone
    };
}
function $61155681fa45b963$export$edcd89beb969619a() {
    if (typeof window === 'undefined') {
        $61155681fa45b963$var$logger.warn('No window object available to get browser client info');
        return {
            width: 320,
            height: 320
        };
    }
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}
function $61155681fa45b963$var$browserTimezone() {
    var tzMatch = /\(([A-Za-z\s].*)\)/.exec(new Date().toString());
    return tzMatch ? tzMatch[1] || '' : '';
}
function $61155681fa45b963$var$browserType(userAgent) {
    var operaMatch = /.+(Opera[\s[A-Z]*|OPR[\sA-Z]*)\/([0-9\.]+).*/i.exec(userAgent);
    if (operaMatch) return {
        type: operaMatch[1],
        version: operaMatch[2]
    };
    var ieMatch = /.+(Trident|Edge)\/([0-9\.]+).*/i.exec(userAgent);
    if (ieMatch) return {
        type: ieMatch[1],
        version: ieMatch[2]
    };
    var cfMatch = /.+(Chrome|Firefox|FxiOS)\/([0-9\.]+).*/i.exec(userAgent);
    if (cfMatch) return {
        type: cfMatch[1],
        version: cfMatch[2]
    };
    var sMatch = /.+(Safari)\/([0-9\.]+).*/i.exec(userAgent);
    if (sMatch) return {
        type: sMatch[1],
        version: sMatch[2]
    };
    var awkMatch = /.+(AppleWebKit)\/([0-9\.]+).*/i.exec(userAgent);
    if (awkMatch) return {
        type: awkMatch[1],
        version: awkMatch[2]
    };
    var anyMatch = /.*([A-Z]+)\/([0-9\.]+).*/i.exec(userAgent);
    if (anyMatch) return {
        type: anyMatch[1],
        version: anyMatch[2]
    };
    return {
        type: '',
        version: ''
    };
}

});


parcelRegister("hPjfU", function(module, exports) {

$parcel$export(module.exports, "Hub", function () { return $cfa622de9ffd1268$export$8c41bb232f1008b1; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $l7cio = parcelRequire("l7cio");
var $cfa622de9ffd1268$var$__assign = undefined && undefined.__assign || function() {
    $cfa622de9ffd1268$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cfa622de9ffd1268$var$__assign.apply(this, arguments);
};
var $cfa622de9ffd1268$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $cfa622de9ffd1268$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($cfa622de9ffd1268$var$__read(arguments[i]));
    return ar;
};
var $cfa622de9ffd1268$var$logger = new (0, $l7cio.ConsoleLogger)('Hub');
var $cfa622de9ffd1268$var$AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
function $cfa622de9ffd1268$var$isLegacyCallback(callback) {
    return callback.onHubCapsule !== undefined;
}
var $cfa622de9ffd1268$export$6b38ef2be9abbbb9 = /** @class */ function() {
    function HubClass(name) {
        this.listeners = [];
        this.patterns = [];
        this.protectedChannels = [
            'core',
            'auth',
            'api',
            'analytics',
            'interactions',
            'pubsub',
            'storage',
            'xr'
        ];
        this.name = name;
    }
    // Note - Need to pass channel as a reference for removal to work and not anonymous function
    HubClass.prototype.remove = function(channel, listener) {
        if (channel instanceof RegExp) {
            var pattern_1 = this.patterns.find(function(_a) {
                var pattern = _a.pattern;
                return pattern.source === channel.source;
            });
            if (!pattern_1) {
                $cfa622de9ffd1268$var$logger.warn("No listeners for " + channel);
                return;
            }
            this.patterns = $cfa622de9ffd1268$var$__spread(this.patterns.filter(function(x) {
                return x !== pattern_1;
            }));
        } else {
            var holder = this.listeners[channel];
            if (!holder) {
                $cfa622de9ffd1268$var$logger.warn("No listeners for " + channel);
                return;
            }
            this.listeners[channel] = $cfa622de9ffd1268$var$__spread(holder.filter(function(_a) {
                var callback = _a.callback;
                return callback !== listener;
            }));
        }
    };
    HubClass.prototype.dispatch = function(channel, payload, source, ampSymbol) {
        if (source === void 0) source = '';
        if (this.protectedChannels.indexOf(channel) > -1) {
            var hasAccess = ampSymbol === $cfa622de9ffd1268$var$AMPLIFY_SYMBOL;
            if (!hasAccess) $cfa622de9ffd1268$var$logger.warn("WARNING: " + channel + " is protected and dispatching on it can have unintended consequences");
        }
        var capsule = {
            channel: channel,
            payload: $cfa622de9ffd1268$var$__assign({}, payload),
            source: source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            $cfa622de9ffd1268$var$logger.error(e);
        }
    };
    HubClass.prototype.listen = function(channel, callback, listenerName) {
        var _this = this;
        if (listenerName === void 0) listenerName = 'noname';
        var cb;
        // Check for legacy onHubCapsule callback for backwards compatability
        if ($cfa622de9ffd1268$var$isLegacyCallback(callback)) {
            $cfa622de9ffd1268$var$logger.warn("WARNING onHubCapsule is Deprecated. Please pass in a callback.");
            cb = callback.onHubCapsule.bind(callback);
        } else if (typeof callback !== 'function') throw new Error('No callback supplied to Hub');
        else cb = callback;
        if (channel instanceof RegExp) this.patterns.push({
            pattern: channel,
            callback: cb
        });
        else {
            var holder = this.listeners[channel];
            if (!holder) {
                holder = [];
                this.listeners[channel] = holder;
            }
            holder.push({
                name: listenerName,
                callback: cb
            });
        }
        return function() {
            _this.remove(channel, cb);
        };
    };
    HubClass.prototype._toListeners = function(capsule) {
        var channel = capsule.channel, payload = capsule.payload;
        var holder = this.listeners[channel];
        if (holder) holder.forEach(function(listener) {
            $cfa622de9ffd1268$var$logger.debug("Dispatching to " + channel + " with ", payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                $cfa622de9ffd1268$var$logger.error(e);
            }
        });
        if (this.patterns.length > 0) {
            if (!payload.message) {
                $cfa622de9ffd1268$var$logger.warn("Cannot perform pattern matching without a message key");
                return;
            }
            var payloadStr_1 = payload.message;
            this.patterns.forEach(function(pattern) {
                var match = payloadStr_1.match(pattern.pattern);
                if (match) {
                    var _a = $cfa622de9ffd1268$var$__read(match), groups = _a.slice(1);
                    var dispatchingCapsule = $cfa622de9ffd1268$var$__assign($cfa622de9ffd1268$var$__assign({}, capsule), {
                        patternInfo: groups
                    });
                    try {
                        pattern.callback(dispatchingCapsule);
                    } catch (e) {
                        $cfa622de9ffd1268$var$logger.error(e);
                    }
                }
            });
        }
    };
    return HubClass;
}();
var $cfa622de9ffd1268$export$8c41bb232f1008b1 = new $cfa622de9ffd1268$export$6b38ef2be9abbbb9('__default__');
var /**
 * @deprecated use named import
 */ $cfa622de9ffd1268$export$2e2bcd8739ae039 = $cfa622de9ffd1268$export$8c41bb232f1008b1;

});

parcelRegister("5xGJg", function(module, exports) {

$parcel$export(module.exports, "I18n", function () { return $40912def39f99c89$export$dbe3113d60765c1a; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $4V9FM = parcelRequire("4V9FM");

var $l7cio = parcelRequire("l7cio");

var $9QDF4 = parcelRequire("9QDF4");
var $40912def39f99c89$var$logger = new (0, $l7cio.ConsoleLogger)('I18n');
var $40912def39f99c89$var$_config = null;
var $40912def39f99c89$var$_i18n = null;
/**
 * Export I18n APIs
 */ var $40912def39f99c89$export$dbe3113d60765c1a = /** @class */ function() {
    function I18n() {}
    /**
     * @static
     * @method
     * Configure I18n part
     * @param {Object} config - Configuration of the I18n
     */ I18n.configure = function(config) {
        $40912def39f99c89$var$logger.debug('configure I18n');
        if (!config) return $40912def39f99c89$var$_config;
        $40912def39f99c89$var$_config = Object.assign({}, $40912def39f99c89$var$_config, config.I18n || config);
        I18n.createInstance();
        return $40912def39f99c89$var$_config;
    };
    I18n.getModuleName = function() {
        return 'I18n';
    };
    /**
     * @static
     * @method
     * Create an instance of I18n for the library
     */ I18n.createInstance = function() {
        $40912def39f99c89$var$logger.debug('create I18n instance');
        if ($40912def39f99c89$var$_i18n) return;
        $40912def39f99c89$var$_i18n = new (0, $4V9FM.I18n)($40912def39f99c89$var$_config);
    };
    /**
     * @static @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.setLanguage = function(lang) {
        I18n.checkConfig();
        return $40912def39f99c89$var$_i18n.setLanguage(lang);
    };
    /**
     * @static @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.get = function(key, defVal) {
        if (!I18n.checkConfig()) return typeof defVal === 'undefined' ? key : defVal;
        return $40912def39f99c89$var$_i18n.get(key, defVal);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {String} langurage - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.putVocabulariesForLanguage = function(language, vocabularies) {
        I18n.checkConfig();
        return $40912def39f99c89$var$_i18n.putVocabulariesForLanguage(language, vocabularies);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.putVocabularies = function(vocabularies) {
        I18n.checkConfig();
        return $40912def39f99c89$var$_i18n.putVocabularies(vocabularies);
    };
    I18n.checkConfig = function() {
        if (!$40912def39f99c89$var$_i18n) $40912def39f99c89$var$_i18n = new (0, $4V9FM.I18n)($40912def39f99c89$var$_config);
        return true;
    };
    return I18n;
}();
(0, $9QDF4.Amplify).register($40912def39f99c89$export$dbe3113d60765c1a);
var /**
 * @deprecated use named import
 */ $40912def39f99c89$export$2e2bcd8739ae039 = $40912def39f99c89$export$dbe3113d60765c1a;

});
parcelRegister("4V9FM", function(module, exports) {

$parcel$export(module.exports, "I18n", function () { return $3953fd26913b41d4$export$dbe3113d60765c1a; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $l7cio = parcelRequire("l7cio");
var $3953fd26913b41d4$var$logger = new (0, $l7cio.ConsoleLogger)('I18n');
/**
 * Language transition class
 */ var $3953fd26913b41d4$export$dbe3113d60765c1a = /** @class */ function() {
    /**
     * @constructor
     * Initialize with configurations
     * @param {Object} options
     */ function I18n(options) {
        /**
         * @private
         */ this._options = null;
        /**
         * @private
         */ this._lang = null;
        /**
         * @private
         */ this._dict = {};
        this._options = Object.assign({}, options);
        this._lang = this._options.language;
        if (!this._lang && typeof window !== 'undefined' && window && window.navigator) this._lang = window.navigator.language;
        $3953fd26913b41d4$var$logger.debug(this._lang);
    }
    /**
     * @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.prototype.setLanguage = function(lang) {
        this._lang = lang;
    };
    /**
     * @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.prototype.get = function(key, defVal) {
        if (defVal === void 0) defVal = undefined;
        if (!this._lang) return typeof defVal !== 'undefined' ? defVal : key;
        var lang = this._lang;
        var val = this.getByLanguage(key, lang);
        if (val) return val;
        if (lang.indexOf('-') > 0) val = this.getByLanguage(key, lang.split('-')[0]);
        if (val) return val;
        return typeof defVal !== 'undefined' ? defVal : key;
    };
    /**
     * @method
     * Get value according to specified language
     * @param {String} key
     * @param {String} language - Specified langurage to be used
     * @param {String} defVal - Default value
     */ I18n.prototype.getByLanguage = function(key, language, defVal) {
        if (defVal === void 0) defVal = null;
        if (!language) return defVal;
        var lang_dict = this._dict[language];
        if (!lang_dict) return defVal;
        return lang_dict[key];
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {String} language - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.prototype.putVocabulariesForLanguage = function(language, vocabularies) {
        var lang_dict = this._dict[language];
        if (!lang_dict) lang_dict = this._dict[language] = {};
        Object.assign(lang_dict, vocabularies);
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.prototype.putVocabularies = function(vocabularies) {
        var _this = this;
        Object.keys(vocabularies).map(function(key) {
            _this.putVocabulariesForLanguage(key, vocabularies[key]);
        });
    };
    return I18n;
}();

});


parcelRegister("7HFvj", function(module, exports) {

$parcel$export(module.exports, "isEmpty", function () { return $59bcbe60433ec2cb$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "sortByField", function () { return $59bcbe60433ec2cb$export$756e1e7707954007; });
$parcel$export(module.exports, "objectLessAttributes", function () { return $59bcbe60433ec2cb$export$5e10ed067f63a9ea; });
$parcel$export(module.exports, "filenameToContentType", function () { return $59bcbe60433ec2cb$export$49cecb876bed446d; });
$parcel$export(module.exports, "isTextFile", function () { return $59bcbe60433ec2cb$export$689bea3eece53c0e; });
$parcel$export(module.exports, "makeQuerablePromise", function () { return $59bcbe60433ec2cb$export$8f33cb495ca11832; });
$parcel$export(module.exports, "isWebWorker", function () { return $59bcbe60433ec2cb$export$97b87b8868ff7a3c; });
$parcel$export(module.exports, "browserOrNode", function () { return $59bcbe60433ec2cb$export$a2708fdb45cd35f; });
$parcel$export(module.exports, "JS", function () { return $59bcbe60433ec2cb$export$174a40858393256b; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $59bcbe60433ec2cb$var$MIME_MAP = [
    {
        type: 'text/plain',
        ext: 'txt'
    },
    {
        type: 'text/html',
        ext: 'html'
    },
    {
        type: 'text/javascript',
        ext: 'js'
    },
    {
        type: 'text/css',
        ext: 'css'
    },
    {
        type: 'text/csv',
        ext: 'csv'
    },
    {
        type: 'text/yaml',
        ext: 'yml'
    },
    {
        type: 'text/yaml',
        ext: 'yaml'
    },
    {
        type: 'text/calendar',
        ext: 'ics'
    },
    {
        type: 'text/calendar',
        ext: 'ical'
    },
    {
        type: 'image/apng',
        ext: 'apng'
    },
    {
        type: 'image/bmp',
        ext: 'bmp'
    },
    {
        type: 'image/gif',
        ext: 'gif'
    },
    {
        type: 'image/x-icon',
        ext: 'ico'
    },
    {
        type: 'image/x-icon',
        ext: 'cur'
    },
    {
        type: 'image/jpeg',
        ext: 'jpg'
    },
    {
        type: 'image/jpeg',
        ext: 'jpeg'
    },
    {
        type: 'image/jpeg',
        ext: 'jfif'
    },
    {
        type: 'image/jpeg',
        ext: 'pjp'
    },
    {
        type: 'image/jpeg',
        ext: 'pjpeg'
    },
    {
        type: 'image/png',
        ext: 'png'
    },
    {
        type: 'image/svg+xml',
        ext: 'svg'
    },
    {
        type: 'image/tiff',
        ext: 'tif'
    },
    {
        type: 'image/tiff',
        ext: 'tiff'
    },
    {
        type: 'image/webp',
        ext: 'webp'
    },
    {
        type: 'application/json',
        ext: 'json'
    },
    {
        type: 'application/xml',
        ext: 'xml'
    },
    {
        type: 'application/x-sh',
        ext: 'sh'
    },
    {
        type: 'application/zip',
        ext: 'zip'
    },
    {
        type: 'application/x-rar-compressed',
        ext: 'rar'
    },
    {
        type: 'application/x-tar',
        ext: 'tar'
    },
    {
        type: 'application/x-bzip',
        ext: 'bz'
    },
    {
        type: 'application/x-bzip2',
        ext: 'bz2'
    },
    {
        type: 'application/pdf',
        ext: 'pdf'
    },
    {
        type: 'application/java-archive',
        ext: 'jar'
    },
    {
        type: 'application/msword',
        ext: 'doc'
    },
    {
        type: 'application/vnd.ms-excel',
        ext: 'xls'
    },
    {
        type: 'application/vnd.ms-excel',
        ext: 'xlsx'
    },
    {
        type: 'message/rfc822',
        ext: 'eml'
    }
];
var $59bcbe60433ec2cb$export$dd1bc94b04021eeb = function(obj) {
    if (obj === void 0) obj = {};
    return Object.keys(obj).length === 0;
};
var $59bcbe60433ec2cb$export$756e1e7707954007 = function(list, field, dir) {
    if (!list || !list.sort) return false;
    var dirX = dir && dir === 'desc' ? -1 : 1;
    list.sort(function(a, b) {
        var a_val = a[field];
        var b_val = b[field];
        if (typeof b_val === 'undefined') return typeof a_val === 'undefined' ? 0 : 1 * dirX;
        if (typeof a_val === 'undefined') return -1 * dirX;
        if (a_val < b_val) return -1 * dirX;
        if (a_val > b_val) return 1 * dirX;
        return 0;
    });
    return true;
};
var $59bcbe60433ec2cb$export$5e10ed067f63a9ea = function(obj, less) {
    var ret = Object.assign({}, obj);
    if (less) {
        if (typeof less === 'string') delete ret[less];
        else less.forEach(function(attr) {
            delete ret[attr];
        });
    }
    return ret;
};
var $59bcbe60433ec2cb$export$49cecb876bed446d = function(filename, defVal) {
    if (defVal === void 0) defVal = 'application/octet-stream';
    var name = filename.toLowerCase();
    var filtered = $59bcbe60433ec2cb$var$MIME_MAP.filter(function(mime) {
        return name.endsWith('.' + mime.ext);
    });
    return filtered.length > 0 ? filtered[0].type : defVal;
};
var $59bcbe60433ec2cb$export$689bea3eece53c0e = function(contentType) {
    var type = contentType.toLowerCase();
    if (type.startsWith('text/')) return true;
    return 'application/json' === type || 'application/xml' === type || 'application/sh' === type;
};
var $59bcbe60433ec2cb$export$9e15fb06e64c4810 = function() {
    var result = '';
    var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(var i = 32; i > 0; i -= 1)result += chars[Math.floor(Math.random() * chars.length)];
    return result;
};
var $59bcbe60433ec2cb$export$8f33cb495ca11832 = function(promise) {
    if (promise.isResolved) return promise;
    var isPending = true;
    var isRejected = false;
    var isFullfilled = false;
    var result = promise.then(function(data) {
        isFullfilled = true;
        isPending = false;
        return data;
    }, function(e) {
        isRejected = true;
        isPending = false;
        throw e;
    });
    result.isFullfilled = function() {
        return isFullfilled;
    };
    result.isPending = function() {
        return isPending;
    };
    result.isRejected = function() {
        return isRejected;
    };
    return result;
};
var $59bcbe60433ec2cb$export$97b87b8868ff7a3c = function() {
    if (typeof self === 'undefined') return false;
    var selfContext = self;
    return typeof selfContext.WorkerGlobalScope !== 'undefined' && self instanceof selfContext.WorkerGlobalScope;
};
var $59bcbe60433ec2cb$export$a2708fdb45cd35f = function() {
    var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
    var isNode = false;
    return {
        isBrowser: isBrowser,
        isNode: isNode
    };
};
var $59bcbe60433ec2cb$export$6281ea8cfc59a49c = function(obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) whiteListForItself = [];
    if (whiteListForChildren === void 0) whiteListForChildren = [];
    if (!$59bcbe60433ec2cb$export$250974ab4f95003c(obj)) return obj;
    var ret = {};
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var transferedKey = whiteListForItself.includes(key) ? key : key[0].toLowerCase() + key.slice(1);
        ret[transferedKey] = whiteListForChildren.includes(key) ? obj[key] : $59bcbe60433ec2cb$export$6281ea8cfc59a49c(obj[key], whiteListForItself, whiteListForChildren);
    }
    return ret;
};
var $59bcbe60433ec2cb$export$f8790a3d3d35829c = function(obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) whiteListForItself = [];
    if (whiteListForChildren === void 0) whiteListForChildren = [];
    if (!$59bcbe60433ec2cb$export$250974ab4f95003c(obj)) return obj;
    var ret = {};
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var transferredKey = whiteListForItself.includes(key) ? key : key[0].toUpperCase() + key.slice(1);
        ret[transferredKey] = whiteListForChildren.includes(key) ? obj[key] : $59bcbe60433ec2cb$export$f8790a3d3d35829c(obj[key], whiteListForItself, whiteListForChildren);
    }
    return ret;
};
var $59bcbe60433ec2cb$export$250974ab4f95003c = function(obj) {
    return obj instanceof Object && !(obj instanceof Array) && !(obj instanceof Function) && !(obj instanceof Number) && !(obj instanceof String) && !(obj instanceof Boolean);
};
/**
 * @deprecated use per-function imports
 */ var $59bcbe60433ec2cb$export$174a40858393256b = /** @class */ function() {
    function JS() {}
    JS.isEmpty = $59bcbe60433ec2cb$export$dd1bc94b04021eeb;
    JS.sortByField = $59bcbe60433ec2cb$export$756e1e7707954007;
    JS.objectLessAttributes = $59bcbe60433ec2cb$export$5e10ed067f63a9ea;
    JS.filenameToContentType = $59bcbe60433ec2cb$export$49cecb876bed446d;
    JS.isTextFile = $59bcbe60433ec2cb$export$689bea3eece53c0e;
    JS.generateRandomString = $59bcbe60433ec2cb$export$9e15fb06e64c4810;
    JS.makeQuerablePromise = $59bcbe60433ec2cb$export$8f33cb495ca11832;
    JS.isWebWorker = $59bcbe60433ec2cb$export$97b87b8868ff7a3c;
    JS.browserOrNode = $59bcbe60433ec2cb$export$a2708fdb45cd35f;
    JS.transferKeyToLowerCase = $59bcbe60433ec2cb$export$6281ea8cfc59a49c;
    JS.transferKeyToUpperCase = $59bcbe60433ec2cb$export$f8790a3d3d35829c;
    JS.isStrictObject = $59bcbe60433ec2cb$export$250974ab4f95003c;
    return JS;
}();
var /**
 * @deprecated use per-function imports
 */ $59bcbe60433ec2cb$export$2e2bcd8739ae039 = $59bcbe60433ec2cb$export$174a40858393256b;

});

parcelRegister("jsbD1", function(module, exports) {

$parcel$export(module.exports, "Signer", function () { return $e299a6fe392e4c1c$export$fdf54fdde81cc9f0; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $l7cio = parcelRequire("l7cio");

var $7rgJH = parcelRequire("7rgJH");

var $6bdTj = parcelRequire("6bdTj");

var $2qlBa = parcelRequire("2qlBa");

var $8tDDB = parcelRequire("8tDDB");
var $e299a6fe392e4c1c$var$__assign = undefined && undefined.__assign || function() {
    $e299a6fe392e4c1c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e299a6fe392e4c1c$var$__assign.apply(this, arguments);
};
var $e299a6fe392e4c1c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e299a6fe392e4c1c$var$logger = new (0, $l7cio.ConsoleLogger)('Signer');
var $e299a6fe392e4c1c$var$DEFAULT_ALGORITHM = 'AWS4-HMAC-SHA256';
var $e299a6fe392e4c1c$var$IOT_SERVICE_NAME = 'iotdevicegateway';
var $e299a6fe392e4c1c$var$encrypt = function(key, src) {
    var hash = new (0, $7rgJH.Sha256)(key);
    hash.update(src);
    return hash.digestSync();
};
var $e299a6fe392e4c1c$var$hash = function(src) {
    var arg = src || '';
    var hash = new (0, $7rgJH.Sha256)();
    hash.update(arg);
    return (0, $6bdTj.toHex)(hash.digestSync());
};
/**
 * @private
 * RFC 3986 compliant version of encodeURIComponent
 */ var $e299a6fe392e4c1c$var$escape_RFC3986 = function(component) {
    return component.replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};
/**
 * @private
 * Create canonical query string
 *
 */ var $e299a6fe392e4c1c$var$canonical_query = function(query) {
    if (!query || query.length === 0) return '';
    return query.split('&').map(function(e) {
        var key_val = e.split('=');
        if (key_val.length === 1) return e;
        else {
            var reencoded_val = $e299a6fe392e4c1c$var$escape_RFC3986(key_val[1]);
            return key_val[0] + '=' + reencoded_val;
        }
    }).sort(function(a, b) {
        var key_a = a.split('=')[0];
        var key_b = b.split('=')[0];
        if (key_a === key_b) return a < b ? -1 : 1;
        else return key_a < key_b ? -1 : 1;
    }).join('&');
};
/**
* @private
* Create canonical headers
*
<pre>
CanonicalHeaders =
    CanonicalHeadersEntry0 + CanonicalHeadersEntry1 + ... + CanonicalHeadersEntryN
CanonicalHeadersEntry =
    Lowercase(HeaderName) + ':' + Trimall(HeaderValue) + '\n'
</pre>
*/ var $e299a6fe392e4c1c$var$canonical_headers = function(headers) {
    if (!headers || Object.keys(headers).length === 0) return '';
    return Object.keys(headers).map(function(key) {
        return {
            key: key.toLowerCase(),
            value: headers[key] ? headers[key].trim().replace(/\s+/g, ' ') : ''
        };
    }).sort(function(a, b) {
        return a.key < b.key ? -1 : 1;
    }).map(function(item) {
        return item.key + ':' + item.value;
    }).join('\n') + '\n';
};
/**
 * List of header keys included in the canonical headers.
 * @access private
 */ var $e299a6fe392e4c1c$var$signed_headers = function(headers) {
    return Object.keys(headers).map(function(key) {
        return key.toLowerCase();
    }).sort().join(';');
};
/**
* @private
* Create canonical request
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-canonical-request.html|Create a Canonical Request}
*
<pre>
CanonicalRequest =
    HTTPRequestMethod + '\n' +
    CanonicalURI + '\n' +
    CanonicalQueryString + '\n' +
    CanonicalHeaders + '\n' +
    SignedHeaders + '\n' +
    HexEncode(Hash(RequestPayload))
</pre>
*/ var $e299a6fe392e4c1c$var$canonical_request = function(request) {
    var url_info = (0, $2qlBa.parse)(request.url);
    return [
        request.method || '/',
        encodeURIComponent(url_info.pathname).replace(/%2F/gi, '/'),
        $e299a6fe392e4c1c$var$canonical_query(url_info.query),
        $e299a6fe392e4c1c$var$canonical_headers(request.headers),
        $e299a6fe392e4c1c$var$signed_headers(request.headers),
        $e299a6fe392e4c1c$var$hash(request.data)
    ].join('\n');
};
var $e299a6fe392e4c1c$var$parse_service_info = function(request) {
    var url_info = (0, $2qlBa.parse)(request.url), host = url_info.host;
    var matched = host.match(/([^\.]+)\.(?:([^\.]*)\.)?amazonaws\.com$/);
    var parsed = (matched || []).slice(1, 3);
    if (parsed[1] === 'es') // Elastic Search
    parsed = parsed.reverse();
    return {
        service: request.service || parsed[0],
        region: request.region || parsed[1]
    };
};
var $e299a6fe392e4c1c$var$credential_scope = function(d_str, region, service) {
    return [
        d_str,
        region,
        service,
        'aws4_request'
    ].join('/');
};
/**
* @private
* Create a string to sign
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-string-to-sign.html|Create String to Sign}
*
<pre>
StringToSign =
    Algorithm + \n +
    RequestDateTime + \n +
    CredentialScope + \n +
    HashedCanonicalRequest
</pre>
*/ var $e299a6fe392e4c1c$var$string_to_sign = function(algorithm, canonical_request, dt_str, scope) {
    return [
        algorithm,
        dt_str,
        scope,
        $e299a6fe392e4c1c$var$hash(canonical_request)
    ].join('\n');
};
/**
* @private
* Create signing key
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-calculate-signature.html|Calculate Signature}
*
<pre>
kSecret = your secret access key
kDate = HMAC("AWS4" + kSecret, Date)
kRegion = HMAC(kDate, Region)
kService = HMAC(kRegion, Service)
kSigning = HMAC(kService, "aws4_request")
</pre>
*/ var $e299a6fe392e4c1c$var$get_signing_key = function(secret_key, d_str, service_info) {
    $e299a6fe392e4c1c$var$logger.debug(service_info);
    var k = 'AWS4' + secret_key, k_date = $e299a6fe392e4c1c$var$encrypt(k, d_str), k_region = $e299a6fe392e4c1c$var$encrypt(k_date, service_info.region), k_service = $e299a6fe392e4c1c$var$encrypt(k_region, service_info.service), k_signing = $e299a6fe392e4c1c$var$encrypt(k_service, 'aws4_request');
    return k_signing;
};
var $e299a6fe392e4c1c$var$get_signature = function(signing_key, str_to_sign) {
    return (0, $6bdTj.toHex)($e299a6fe392e4c1c$var$encrypt(signing_key, str_to_sign));
};
/**
 * @private
 * Create authorization header
 * Refer to
 * {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html|Add the Signing Information}
 */ var $e299a6fe392e4c1c$var$get_authorization_header = function(algorithm, access_key, scope, signed_headers, signature) {
    return [
        algorithm + ' ' + 'Credential=' + access_key + '/' + scope,
        'SignedHeaders=' + signed_headers,
        'Signature=' + signature
    ].join(', ');
};
var $e299a6fe392e4c1c$export$fdf54fdde81cc9f0 = /** @class */ function() {
    function Signer() {}
    /**
    * Sign a HTTP request, add 'Authorization' header to request param
    * @method sign
    * @memberof Signer
    * @static
    *
    * @param {object} request - HTTP request object
    <pre>
    request: {
        method: GET | POST | PUT ...
        url: ...,
        headers: {
            header1: ...
        },
        data: data
    }
    </pre>
    * @param {object} access_info - AWS access credential info
    <pre>
    access_info: {
        access_key: ...,
        secret_key: ...,
        session_token: ...
    }
    </pre>
    * @param {object} [service_info] - AWS service type and region, optional,
    *                                  if not provided then parse out from url
    <pre>
    service_info: {
        service: ...,
        region: ...
    }
    </pre>
    *
    * @returns {object} Signed HTTP request
    */ Signer.sign = function(request, access_info, service_info) {
        if (service_info === void 0) service_info = null;
        request.headers = request.headers || {};
        // datetime string and date string
        var dt = (0, $8tDDB.DateUtils).getDateWithClockOffset(), dt_str = dt.toISOString().replace(/[:\-]|\.\d{3}/g, ''), d_str = dt_str.substr(0, 8);
        var url_info = (0, $2qlBa.parse)(request.url);
        request.headers['host'] = url_info.host;
        request.headers['x-amz-date'] = dt_str;
        if (access_info.session_token) request.headers['X-Amz-Security-Token'] = access_info.session_token;
        // Task 1: Create a Canonical Request
        var request_str = $e299a6fe392e4c1c$var$canonical_request(request);
        $e299a6fe392e4c1c$var$logger.debug(request_str);
        // Task 2: Create a String to Sign
        var serviceInfo = service_info || $e299a6fe392e4c1c$var$parse_service_info(request), scope = $e299a6fe392e4c1c$var$credential_scope(d_str, serviceInfo.region, serviceInfo.service), str_to_sign = $e299a6fe392e4c1c$var$string_to_sign($e299a6fe392e4c1c$var$DEFAULT_ALGORITHM, request_str, dt_str, scope);
        // Task 3: Calculate the Signature
        var signing_key = $e299a6fe392e4c1c$var$get_signing_key(access_info.secret_key, d_str, serviceInfo), signature = $e299a6fe392e4c1c$var$get_signature(signing_key, str_to_sign);
        // Task 4: Adding the Signing information to the Request
        var authorization_header = $e299a6fe392e4c1c$var$get_authorization_header($e299a6fe392e4c1c$var$DEFAULT_ALGORITHM, access_info.access_key, scope, $e299a6fe392e4c1c$var$signed_headers(request.headers), signature);
        request.headers['Authorization'] = authorization_header;
        return request;
    };
    Signer.signUrl = function(urlOrRequest, accessInfo, serviceInfo, expiration) {
        var urlToSign = typeof urlOrRequest === 'object' ? urlOrRequest.url : urlOrRequest;
        var method = typeof urlOrRequest === 'object' ? urlOrRequest.method : 'GET';
        var body = typeof urlOrRequest === 'object' ? urlOrRequest.body : undefined;
        var now = (0, $8tDDB.DateUtils).getDateWithClockOffset().toISOString().replace(/[:\-]|\.\d{3}/g, '');
        var today = now.substr(0, 8);
        // Intentionally discarding search
        var _a = (0, $2qlBa.parse)(urlToSign, true, true), search = _a.search, parsedUrl = $e299a6fe392e4c1c$var$__rest(_a, [
            "search"
        ]);
        var host = parsedUrl.host;
        var signedHeaders = {
            host: host
        };
        var _b = serviceInfo || $e299a6fe392e4c1c$var$parse_service_info({
            url: (0, $2qlBa.format)(parsedUrl)
        }), region = _b.region, service = _b.service;
        var credentialScope = $e299a6fe392e4c1c$var$credential_scope(today, region, service);
        // IoT service does not allow the session token in the canonical request
        // https://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html
        var sessionTokenRequired = accessInfo.session_token && service !== $e299a6fe392e4c1c$var$IOT_SERVICE_NAME;
        var queryParams = $e299a6fe392e4c1c$var$__assign($e299a6fe392e4c1c$var$__assign($e299a6fe392e4c1c$var$__assign({
            'X-Amz-Algorithm': $e299a6fe392e4c1c$var$DEFAULT_ALGORITHM,
            'X-Amz-Credential': [
                accessInfo.access_key,
                credentialScope
            ].join('/'),
            'X-Amz-Date': now.substr(0, 16)
        }, sessionTokenRequired ? {
            'X-Amz-Security-Token': "" + accessInfo.session_token
        } : {}), expiration ? {
            'X-Amz-Expires': "" + expiration
        } : {}), {
            'X-Amz-SignedHeaders': Object.keys(signedHeaders).join(',')
        });
        var canonicalRequest = $e299a6fe392e4c1c$var$canonical_request({
            method: method,
            url: (0, $2qlBa.format)($e299a6fe392e4c1c$var$__assign($e299a6fe392e4c1c$var$__assign({}, parsedUrl), {
                query: $e299a6fe392e4c1c$var$__assign($e299a6fe392e4c1c$var$__assign({}, parsedUrl.query), queryParams)
            })),
            headers: signedHeaders,
            data: body
        });
        var stringToSign = $e299a6fe392e4c1c$var$string_to_sign($e299a6fe392e4c1c$var$DEFAULT_ALGORITHM, canonicalRequest, now, credentialScope);
        var signing_key = $e299a6fe392e4c1c$var$get_signing_key(accessInfo.secret_key, today, {
            region: region,
            service: service
        });
        var signature = $e299a6fe392e4c1c$var$get_signature(signing_key, stringToSign);
        var additionalQueryParams = $e299a6fe392e4c1c$var$__assign({
            'X-Amz-Signature': signature
        }, accessInfo.session_token && {
            'X-Amz-Security-Token': accessInfo.session_token
        });
        var result = (0, $2qlBa.format)({
            protocol: parsedUrl.protocol,
            slashes: true,
            hostname: parsedUrl.hostname,
            port: parsedUrl.port,
            pathname: parsedUrl.pathname,
            query: $e299a6fe392e4c1c$var$__assign($e299a6fe392e4c1c$var$__assign($e299a6fe392e4c1c$var$__assign({}, parsedUrl.query), queryParams), additionalQueryParams)
        });
        return result;
    };
    return Signer;
}();
var /**
 * @deprecated use per-function import
 */ $e299a6fe392e4c1c$export$2e2bcd8739ae039 = $e299a6fe392e4c1c$export$fdf54fdde81cc9f0;

});
parcelRegister("7rgJH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fH1jI = parcelRequire("fH1jI");

$fH1jI.__exportStar((parcelRequire("k6CB6")), module.exports);

});

parcelRegister("6bdTj", function(module, exports) {

$parcel$export(module.exports, "fromHex", function () { return $47fe8ba0e21f61ba$export$1a8ceedbd5845648; });
$parcel$export(module.exports, "toHex", function () { return $47fe8ba0e21f61ba$export$7ea66e3774a60b67; });
var $47fe8ba0e21f61ba$var$SHORT_TO_HEX = {};
var $47fe8ba0e21f61ba$var$HEX_TO_SHORT = {};
for(var $47fe8ba0e21f61ba$var$i = 0; $47fe8ba0e21f61ba$var$i < 256; $47fe8ba0e21f61ba$var$i++){
    var $47fe8ba0e21f61ba$var$encodedByte = $47fe8ba0e21f61ba$var$i.toString(16).toLowerCase();
    if ($47fe8ba0e21f61ba$var$encodedByte.length === 1) $47fe8ba0e21f61ba$var$encodedByte = "0" + $47fe8ba0e21f61ba$var$encodedByte;
    $47fe8ba0e21f61ba$var$SHORT_TO_HEX[$47fe8ba0e21f61ba$var$i] = $47fe8ba0e21f61ba$var$encodedByte;
    $47fe8ba0e21f61ba$var$HEX_TO_SHORT[$47fe8ba0e21f61ba$var$encodedByte] = $47fe8ba0e21f61ba$var$i;
}
function $47fe8ba0e21f61ba$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    var out = new Uint8Array(encoded.length / 2);
    for(var i = 0; i < encoded.length; i += 2){
        var encodedByte = encoded.substr(i, 2).toLowerCase();
        if (encodedByte in $47fe8ba0e21f61ba$var$HEX_TO_SHORT) out[i / 2] = $47fe8ba0e21f61ba$var$HEX_TO_SHORT[encodedByte];
        else throw new Error("Cannot decode unrecognized sequence " + encodedByte + " as hexadecimal");
    }
    return out;
}
function $47fe8ba0e21f61ba$export$7ea66e3774a60b67(bytes) {
    var out = "";
    for(var i = 0; i < bytes.byteLength; i++)out += $47fe8ba0e21f61ba$var$SHORT_TO_HEX[bytes[i]];
    return out;
}

});

parcelRegister("8tDDB", function(module, exports) {

$parcel$export(module.exports, "DateUtils", function () { return $62bfc768dbb3ebb2$export$3e048df13f4eb60b; });
/**
 * Date & time utility functions to abstract the `aws-sdk` away from users.
 * (v2 => v3 modularization is a breaking change)
 *
 * @see https://github.com/aws/aws-sdk-js/blob/6edf586dcc1de7fe8fbfbbd9a0d2b1847921e6e1/lib/util.js#L262
 */ var $62bfc768dbb3ebb2$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $62bfc768dbb3ebb2$var$FIVE_MINUTES_IN_MS = 300000;
var $62bfc768dbb3ebb2$export$3e048df13f4eb60b = {
    /**
     * Milliseconds to offset the date to compensate for clock skew between device & services
     */ clockOffset: 0,
    getDateWithClockOffset: function() {
        if ($62bfc768dbb3ebb2$export$3e048df13f4eb60b.clockOffset) return new Date(new Date().getTime() + $62bfc768dbb3ebb2$export$3e048df13f4eb60b.clockOffset);
        else return new Date();
    },
    /**
     * @returns {number} Clock offset in milliseconds
     */ getClockOffset: function() {
        return $62bfc768dbb3ebb2$export$3e048df13f4eb60b.clockOffset;
    },
    getHeaderStringFromDate: function(date) {
        if (date === void 0) date = $62bfc768dbb3ebb2$export$3e048df13f4eb60b.getDateWithClockOffset();
        return date.toISOString().replace(/[:\-]|\.\d{3}/g, '');
    },
    getDateFromHeaderString: function(header) {
        var _a = $62bfc768dbb3ebb2$var$__read(header.match(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2}).+/), 7), year = _a[1], month = _a[2], day = _a[3], hour = _a[4], minute = _a[5], second = _a[6];
        return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second)));
    },
    isClockSkewed: function(serverDate) {
        // API gateway permits client calls that are off by no more than ±5 minutes
        return Math.abs(serverDate.getTime() - $62bfc768dbb3ebb2$export$3e048df13f4eb60b.getDateWithClockOffset().getTime()) >= $62bfc768dbb3ebb2$var$FIVE_MINUTES_IN_MS;
    },
    isClockSkewError: function(error) {
        if (!error.response || !error.response.headers) return false;
        var headers = error.response.headers;
        return Boolean(headers['x-amzn-errortype'] === 'BadRequestException' && (headers.date || headers.Date));
    },
    /**
     * @param {number} offset Clock offset in milliseconds
     */ setClockOffset: function(offset) {
        $62bfc768dbb3ebb2$export$3e048df13f4eb60b.clockOffset = offset;
    }
};

});


parcelRegister("hmdQp", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $ca2f3af03e3fb9e1$export$7acfa6ed01010e37; });

var $l7cio = parcelRequire("l7cio");
var $ca2f3af03e3fb9e1$var$logger = new (0, $l7cio.ConsoleLogger)('Parser');
var $ca2f3af03e3fb9e1$export$33f4f68299e2efa8 = function(config) {
    var amplifyConfig = {};
    // Analytics
    if (config['aws_mobile_analytics_app_id']) {
        var Analytics = {
            AWSPinpoint: {
                appId: config['aws_mobile_analytics_app_id'],
                region: config['aws_mobile_analytics_app_region']
            }
        };
        amplifyConfig.Analytics = Analytics;
    }
    // Auth
    if (config['aws_cognito_identity_pool_id'] || config['aws_user_pools_id']) amplifyConfig.Auth = {
        userPoolId: config['aws_user_pools_id'],
        userPoolWebClientId: config['aws_user_pools_web_client_id'],
        region: config['aws_cognito_region'],
        identityPoolId: config['aws_cognito_identity_pool_id'],
        identityPoolRegion: config['aws_cognito_region'],
        mandatorySignIn: config['aws_mandatory_sign_in'] === 'enable'
    };
    // Storage
    var storageConfig;
    if (config['aws_user_files_s3_bucket']) storageConfig = {
        AWSS3: {
            bucket: config['aws_user_files_s3_bucket'],
            region: config['aws_user_files_s3_bucket_region'],
            dangerouslyConnectToHttpEndpointForTesting: config['aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing']
        }
    };
    else storageConfig = config ? config.Storage || config : {};
    amplifyConfig.Analytics = Object.assign({}, amplifyConfig.Analytics, config.Analytics);
    amplifyConfig.Auth = Object.assign({}, amplifyConfig.Auth, config.Auth);
    amplifyConfig.Storage = Object.assign({}, storageConfig);
    $ca2f3af03e3fb9e1$var$logger.debug('parse config', config, 'to amplifyconfig', amplifyConfig);
    return amplifyConfig;
};
/**
 * @deprecated use per-function export
 */ var $ca2f3af03e3fb9e1$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser() {}
    Parser.parseMobilehubConfig = $ca2f3af03e3fb9e1$export$33f4f68299e2efa8;
    return Parser;
}();
var /**
 * @deprecated use per-function export
 */ $ca2f3af03e3fb9e1$export$2e2bcd8739ae039 = $ca2f3af03e3fb9e1$export$7acfa6ed01010e37;

});

parcelRegister("ddXoz", function(module, exports) {

$parcel$export(module.exports, "Credentials", function () { return $9a0a8feba8dfacf9$export$a9627919734faa48; });

var $l7cio = parcelRequire("l7cio");

var $lpqOV = parcelRequire("lpqOV");

var $7HFvj = parcelRequire("7HFvj");

var $hZ847 = parcelRequire("hZ847");

var $69J7B = parcelRequire("69J7B");

var $ku8BJ = parcelRequire("ku8BJ");

var $9QDF4 = parcelRequire("9QDF4");

var $210G3 = parcelRequire("210G3");
var $hiUze = parcelRequire("hiUze");

var $aYSbN = parcelRequire("aYSbN");
var $eYPaE = parcelRequire("eYPaE");
var $9a0a8feba8dfacf9$var$__assign = undefined && undefined.__assign || function() {
    $9a0a8feba8dfacf9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9a0a8feba8dfacf9$var$__assign.apply(this, arguments);
};
var $9a0a8feba8dfacf9$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9a0a8feba8dfacf9$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $9a0a8feba8dfacf9$var$logger = new (0, $l7cio.ConsoleLogger)('Credentials');
var $9a0a8feba8dfacf9$var$CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
var $9a0a8feba8dfacf9$export$9be509043bd0c09a = /** @class */ function() {
    function CredentialsClass(config) {
        this._gettingCredPromise = null;
        this._refreshHandlers = {};
        // Allow `Auth` to be injected for SSR, but Auth isn't a required dependency for Credentials
        this.Auth = undefined;
        this.configure(config);
        this._refreshHandlers['google'] = (0, $hZ847.GoogleOAuth).refreshGoogleToken;
        this._refreshHandlers['facebook'] = (0, $hZ847.FacebookOAuth).refreshFacebookToken;
    }
    CredentialsClass.prototype.getModuleName = function() {
        return 'Credentials';
    };
    CredentialsClass.prototype.getCredSource = function() {
        return this._credentials_source;
    };
    CredentialsClass.prototype.configure = function(config) {
        if (!config) return this._config || {};
        this._config = Object.assign({}, this._config, config);
        var refreshHandlers = this._config.refreshHandlers;
        // If the developer has provided an object of refresh handlers,
        // then we can merge the provided handlers with the current handlers.
        if (refreshHandlers) this._refreshHandlers = $9a0a8feba8dfacf9$var$__assign($9a0a8feba8dfacf9$var$__assign({}, this._refreshHandlers), refreshHandlers);
        this._storage = this._config.storage;
        if (!this._storage) this._storage = new (0, $lpqOV.StorageHelper)().getStorage();
        this._storageSync = Promise.resolve();
        if (typeof this._storage['sync'] === 'function') this._storageSync = this._storage['sync']();
        return this._config;
    };
    CredentialsClass.prototype.get = function() {
        $9a0a8feba8dfacf9$var$logger.debug('getting credentials');
        return this._pickupCredentials();
    };
    CredentialsClass.prototype._pickupCredentials = function() {
        $9a0a8feba8dfacf9$var$logger.debug('picking up credentials');
        if (!this._gettingCredPromise || !this._gettingCredPromise.isPending()) {
            $9a0a8feba8dfacf9$var$logger.debug('getting new cred promise');
            this._gettingCredPromise = (0, $7HFvj.makeQuerablePromise)(this._keepAlive());
        } else $9a0a8feba8dfacf9$var$logger.debug('getting old cred promise');
        return this._gettingCredPromise;
    };
    CredentialsClass.prototype._keepAlive = function() {
        return $9a0a8feba8dfacf9$var$__awaiter(this, void 0, void 0, function() {
            var cred, _a, Auth, user_1, session, refreshToken_1, refreshRequest, err_1;
            return $9a0a8feba8dfacf9$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $9a0a8feba8dfacf9$var$logger.debug('checking if credentials exists and not expired');
                        cred = this._credentials;
                        if (cred && !this._isExpired(cred) && !this._isPastTTL()) {
                            $9a0a8feba8dfacf9$var$logger.debug('credentials not changed and not expired, directly return');
                            return [
                                2 /*return*/ ,
                                Promise.resolve(cred)
                            ];
                        }
                        $9a0a8feba8dfacf9$var$logger.debug('need to get a new credential or refresh the existing one');
                        _a = this.Auth, Auth = _a === void 0 ? (0, $9QDF4.Amplify).Auth : _a;
                        if (!Auth || typeof Auth.currentUserCredentials !== 'function') return [
                            2 /*return*/ ,
                            Promise.reject('No Auth module registered in Amplify')
                        ];
                        if (!(!this._isExpired(cred) && this._isPastTTL())) return [
                            3 /*break*/ ,
                            6
                        ];
                        $9a0a8feba8dfacf9$var$logger.debug('ttl has passed but token is not yet expired');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            Auth.currentUserPoolUser()
                        ];
                    case 2:
                        user_1 = _b.sent();
                        return [
                            4 /*yield*/ ,
                            Auth.currentSession()
                        ];
                    case 3:
                        session = _b.sent();
                        refreshToken_1 = session.refreshToken;
                        refreshRequest = new Promise(function(res, rej) {
                            user_1.refreshSession(refreshToken_1, function(err, data) {
                                return err ? rej(err) : res(data);
                            });
                        });
                        return [
                            4 /*yield*/ ,
                            refreshRequest
                        ];
                    case 4:
                        _b.sent(); // note that rejections will be caught and handled in the catch block.
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        err_1 = _b.sent();
                        // should not throw because user might just be on guest access or is authenticated through federation
                        $9a0a8feba8dfacf9$var$logger.debug('Error attempting to refreshing the session', err_1);
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            Auth.currentUserCredentials()
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype.refreshFederatedToken = function(federatedInfo) {
        $9a0a8feba8dfacf9$var$logger.debug('Getting federated credentials');
        var provider = federatedInfo.provider, user = federatedInfo.user, token = federatedInfo.token, identity_id = federatedInfo.identity_id;
        var expires_at = federatedInfo.expires_at;
        // Make sure expires_at is in millis
        expires_at = new Date(expires_at).getFullYear() === 1970 ? expires_at * 1000 : expires_at;
        var that = this;
        $9a0a8feba8dfacf9$var$logger.debug('checking if federated jwt token expired');
        if (expires_at > new Date().getTime()) {
            // if not expired
            $9a0a8feba8dfacf9$var$logger.debug('token not expired');
            return this._setCredentialsFromFederation({
                provider: provider,
                token: token,
                user: user,
                identity_id: identity_id,
                expires_at: expires_at
            });
        } else // if refresh handler exists
        if (that._refreshHandlers[provider] && typeof that._refreshHandlers[provider] === 'function') {
            $9a0a8feba8dfacf9$var$logger.debug('getting refreshed jwt token from federation provider');
            return this._providerRefreshWithRetry({
                refreshHandler: that._refreshHandlers[provider],
                provider: provider,
                user: user
            });
        } else {
            $9a0a8feba8dfacf9$var$logger.debug('no refresh handler for provider:', provider);
            this.clear();
            return Promise.reject('no refresh handler for provider');
        }
    };
    CredentialsClass.prototype._providerRefreshWithRetry = function(_a) {
        var _this = this;
        var refreshHandler = _a.refreshHandler, provider = _a.provider, user = _a.user;
        var MAX_DELAY_MS = 10000;
        // refreshHandler will retry network errors, otherwise it will
        // return NonRetryableError to break out of jitteredExponentialRetry
        return (0, $69J7B.jitteredExponentialRetry)(refreshHandler, [], MAX_DELAY_MS).then(function(data) {
            $9a0a8feba8dfacf9$var$logger.debug('refresh federated token sucessfully', data);
            return _this._setCredentialsFromFederation({
                provider: provider,
                token: data.token,
                user: user,
                identity_id: data.identity_id,
                expires_at: data.expires_at
            });
        }).catch(function(e) {
            var isNetworkError = typeof e === 'string' && e.toLowerCase().lastIndexOf('network error', e.length) === 0;
            if (!isNetworkError) _this.clear();
            $9a0a8feba8dfacf9$var$logger.debug('refresh federated token failed', e);
            return Promise.reject('refreshing federation token failed: ' + e);
        });
    };
    CredentialsClass.prototype._isExpired = function(credentials) {
        if (!credentials) {
            $9a0a8feba8dfacf9$var$logger.debug('no credentials for expiration check');
            return true;
        }
        $9a0a8feba8dfacf9$var$logger.debug('are these credentials expired?', credentials);
        var ts = Date.now();
        /* returns date object.
            https://github.com/aws/aws-sdk-js-v3/blob/v1.0.0-beta.1/packages/types/src/credentials.ts#L26
        */ var expiration = credentials.expiration;
        return expiration.getTime() <= ts;
    };
    CredentialsClass.prototype._isPastTTL = function() {
        return this._nextCredentialsRefresh <= Date.now();
    };
    CredentialsClass.prototype._setCredentialsForGuest = function() {
        return $9a0a8feba8dfacf9$var$__awaiter(this, void 0, void 0, function() {
            var _a, identityPoolId, region, mandatorySignIn, identityId, e_1, cognitoClient, credentials, cognitoIdentityParams, credentialsProvider;
            var _this = this;
            return $9a0a8feba8dfacf9$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $9a0a8feba8dfacf9$var$logger.debug('setting credentials for guest');
                        _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region, mandatorySignIn = _a.mandatorySignIn;
                        if (mandatorySignIn) return [
                            2 /*return*/ ,
                            Promise.reject('cannot get guest credentials when mandatory signin enabled')
                        ];
                        if (!identityPoolId) {
                            $9a0a8feba8dfacf9$var$logger.debug('No Cognito Identity pool provided for unauthenticated access');
                            return [
                                2 /*return*/ ,
                                Promise.reject('No Cognito Identity pool provided for unauthenticated access')
                            ];
                        }
                        if (!region) {
                            $9a0a8feba8dfacf9$var$logger.debug('region is not configured for getting the credentials');
                            return [
                                2 /*return*/ ,
                                Promise.reject('region is not configured for getting the credentials')
                            ];
                        }
                        identityId = undefined;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _b.sent();
                        identityId = this._storage.getItem('CognitoIdentityId-' + identityPoolId);
                        this._identityId = identityId;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _b.sent();
                        $9a0a8feba8dfacf9$var$logger.debug('Failed to get the cached identityId', e_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        cognitoClient = new (0, $aYSbN.CognitoIdentityClient)({
                            region: region,
                            customUserAgent: (0, $ku8BJ.getAmplifyUserAgent)()
                        });
                        credentials = undefined;
                        if (identityId) {
                            cognitoIdentityParams = {
                                identityId: identityId,
                                client: cognitoClient
                            };
                            credentials = (0, $210G3.fromCognitoIdentity)(cognitoIdentityParams)();
                        } else {
                            credentialsProvider = function() {
                                return $9a0a8feba8dfacf9$var$__awaiter(_this, void 0, void 0, function() {
                                    var IdentityId, cognitoIdentityParams, credentialsFromCognitoIdentity;
                                    return $9a0a8feba8dfacf9$var$__generator(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    cognitoClient.send(new (0, $eYPaE.GetIdCommand)({
                                                        IdentityPoolId: identityPoolId
                                                    }))
                                                ];
                                            case 1:
                                                IdentityId = _a.sent().IdentityId;
                                                this._identityId = IdentityId;
                                                cognitoIdentityParams = {
                                                    client: cognitoClient,
                                                    identityId: IdentityId
                                                };
                                                credentialsFromCognitoIdentity = (0, $210G3.fromCognitoIdentity)(cognitoIdentityParams);
                                                return [
                                                    2 /*return*/ ,
                                                    credentialsFromCognitoIdentity()
                                                ];
                                        }
                                    });
                                });
                            };
                            credentials = credentialsProvider().catch(function(err) {
                                return $9a0a8feba8dfacf9$var$__awaiter(_this, void 0, void 0, function() {
                                    return $9a0a8feba8dfacf9$var$__generator(this, function(_a) {
                                        throw err;
                                    });
                                });
                            });
                        }
                        return [
                            2 /*return*/ ,
                            this._loadCredentials(credentials, 'guest', false, null).then(function(res) {
                                return res;
                            }).catch(function(e) {
                                return $9a0a8feba8dfacf9$var$__awaiter(_this, void 0, void 0, function() {
                                    var credentialsProvider;
                                    var _this = this;
                                    return $9a0a8feba8dfacf9$var$__generator(this, function(_a) {
                                        // If identity id is deleted in the console, we make one attempt to recreate it
                                        // and remove existing id from cache.
                                        if (e.name === 'ResourceNotFoundException' && e.message === "Identity '" + identityId + "' not found.") {
                                            $9a0a8feba8dfacf9$var$logger.debug('Failed to load guest credentials');
                                            this._storage.removeItem('CognitoIdentityId-' + identityPoolId);
                                            credentialsProvider = function() {
                                                return $9a0a8feba8dfacf9$var$__awaiter(_this, void 0, void 0, function() {
                                                    var IdentityId, cognitoIdentityParams, credentialsFromCognitoIdentity;
                                                    return $9a0a8feba8dfacf9$var$__generator(this, function(_a) {
                                                        switch(_a.label){
                                                            case 0:
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    cognitoClient.send(new (0, $eYPaE.GetIdCommand)({
                                                                        IdentityPoolId: identityPoolId
                                                                    }))
                                                                ];
                                                            case 1:
                                                                IdentityId = _a.sent().IdentityId;
                                                                this._identityId = IdentityId;
                                                                cognitoIdentityParams = {
                                                                    client: cognitoClient,
                                                                    identityId: IdentityId
                                                                };
                                                                credentialsFromCognitoIdentity = (0, $210G3.fromCognitoIdentity)(cognitoIdentityParams);
                                                                return [
                                                                    2 /*return*/ ,
                                                                    credentialsFromCognitoIdentity()
                                                                ];
                                                        }
                                                    });
                                                });
                                            };
                                            credentials = credentialsProvider().catch(function(err) {
                                                return $9a0a8feba8dfacf9$var$__awaiter(_this, void 0, void 0, function() {
                                                    return $9a0a8feba8dfacf9$var$__generator(this, function(_a) {
                                                        throw err;
                                                    });
                                                });
                                            });
                                            return [
                                                2 /*return*/ ,
                                                this._loadCredentials(credentials, 'guest', false, null)
                                            ];
                                        } else return [
                                            2 /*return*/ ,
                                            e
                                        ];
                                        return [
                                            2 /*return*/ 
                                        ];
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._setCredentialsFromFederation = function(params) {
        var provider = params.provider, token = params.token, identity_id = params.identity_id;
        var domains = {
            google: 'accounts.google.com',
            facebook: 'graph.facebook.com',
            amazon: 'www.amazon.com',
            developer: 'cognito-identity.amazonaws.com'
        };
        // Use custom provider url instead of the predefined ones
        var domain = domains[provider] || provider;
        if (!domain) return Promise.reject('You must specify a federated provider');
        var logins = {};
        logins[domain] = token;
        var _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region;
        if (!identityPoolId) {
            $9a0a8feba8dfacf9$var$logger.debug('No Cognito Federated Identity pool provided');
            return Promise.reject('No Cognito Federated Identity pool provided');
        }
        if (!region) {
            $9a0a8feba8dfacf9$var$logger.debug('region is not configured for getting the credentials');
            return Promise.reject('region is not configured for getting the credentials');
        }
        var cognitoClient = new (0, $aYSbN.CognitoIdentityClient)({
            region: region,
            customUserAgent: (0, $ku8BJ.getAmplifyUserAgent)()
        });
        var credentials = undefined;
        if (identity_id) {
            var cognitoIdentityParams = {
                identityId: identity_id,
                logins: logins,
                client: cognitoClient
            };
            credentials = (0, $210G3.fromCognitoIdentity)(cognitoIdentityParams)();
        } else {
            var cognitoIdentityParams = {
                logins: logins,
                identityPoolId: identityPoolId,
                client: cognitoClient
            };
            credentials = (0, $hiUze.fromCognitoIdentityPool)(cognitoIdentityParams)();
        }
        return this._loadCredentials(credentials, 'federated', true, params);
    };
    CredentialsClass.prototype._setCredentialsFromSession = function(session) {
        var _this = this;
        $9a0a8feba8dfacf9$var$logger.debug('set credentials from session');
        var idToken = session.getIdToken().getJwtToken();
        var _a = this._config, region = _a.region, userPoolId = _a.userPoolId, identityPoolId = _a.identityPoolId;
        if (!identityPoolId) {
            $9a0a8feba8dfacf9$var$logger.debug('No Cognito Federated Identity pool provided');
            return Promise.reject('No Cognito Federated Identity pool provided');
        }
        if (!region) {
            $9a0a8feba8dfacf9$var$logger.debug('region is not configured for getting the credentials');
            return Promise.reject('region is not configured for getting the credentials');
        }
        var key = 'cognito-idp.' + region + '.amazonaws.com/' + userPoolId;
        var logins = {};
        logins[key] = idToken;
        var cognitoClient = new (0, $aYSbN.CognitoIdentityClient)({
            region: region,
            customUserAgent: (0, $ku8BJ.getAmplifyUserAgent)()
        });
        /*
            Retreiving identityId with GetIdCommand to mimic the behavior in the following code in aws-sdk-v3:
            https://git.io/JeDxU

            Note: Retreive identityId from CredentialsProvider once aws-sdk-js v3 supports this.
        */ var credentialsProvider = function() {
            return $9a0a8feba8dfacf9$var$__awaiter(_this, void 0, void 0, function() {
                var IdentityId, cognitoIdentityParams, credentialsFromCognitoIdentity;
                return $9a0a8feba8dfacf9$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                cognitoClient.send(new (0, $eYPaE.GetIdCommand)({
                                    IdentityPoolId: identityPoolId,
                                    Logins: logins
                                }))
                            ];
                        case 1:
                            IdentityId = _a.sent().IdentityId;
                            this._identityId = IdentityId;
                            cognitoIdentityParams = {
                                client: cognitoClient,
                                logins: logins,
                                identityId: IdentityId
                            };
                            credentialsFromCognitoIdentity = (0, $210G3.fromCognitoIdentity)(cognitoIdentityParams);
                            return [
                                2 /*return*/ ,
                                credentialsFromCognitoIdentity()
                            ];
                    }
                });
            });
        };
        var credentials = credentialsProvider().catch(function(err) {
            return $9a0a8feba8dfacf9$var$__awaiter(_this, void 0, void 0, function() {
                return $9a0a8feba8dfacf9$var$__generator(this, function(_a) {
                    throw err;
                });
            });
        });
        return this._loadCredentials(credentials, 'userPool', true, null);
    };
    CredentialsClass.prototype._loadCredentials = function(credentials, source, authenticated, info) {
        var _this = this;
        var that = this;
        var identityPoolId = this._config.identityPoolId;
        return new Promise(function(res, rej) {
            credentials.then(function(credentials) {
                return $9a0a8feba8dfacf9$var$__awaiter(_this, void 0, void 0, function() {
                    var user, provider, token, expires_at, identity_id, e_2;
                    return $9a0a8feba8dfacf9$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                $9a0a8feba8dfacf9$var$logger.debug('Load credentials successfully', credentials);
                                if (this._identityId && !credentials.identityId) credentials['identityId'] = this._identityId;
                                that._credentials = credentials;
                                that._credentials.authenticated = authenticated;
                                that._credentials_source = source;
                                that._nextCredentialsRefresh = new Date().getTime() + $9a0a8feba8dfacf9$var$CREDENTIALS_TTL;
                                if (source === 'federated') {
                                    user = Object.assign({
                                        id: this._credentials.identityId
                                    }, info.user);
                                    provider = info.provider, token = info.token, expires_at = info.expires_at, identity_id = info.identity_id;
                                    try {
                                        this._storage.setItem('aws-amplify-federatedInfo', JSON.stringify({
                                            provider: provider,
                                            token: token,
                                            user: user,
                                            expires_at: expires_at,
                                            identity_id: identity_id
                                        }));
                                    } catch (e) {
                                        $9a0a8feba8dfacf9$var$logger.debug('Failed to put federated info into auth storage', e);
                                    }
                                }
                                if (!(source === 'guest')) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this._storageSync
                                ];
                            case 2:
                                _a.sent();
                                this._storage.setItem('CognitoIdentityId-' + identityPoolId, credentials.identityId // TODO: IdentityId is currently not returned by fromCognitoIdentityPool()
                                );
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                e_2 = _a.sent();
                                $9a0a8feba8dfacf9$var$logger.debug('Failed to cache identityId', e_2);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                res(that._credentials);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(err) {
                if (err) {
                    $9a0a8feba8dfacf9$var$logger.debug('Failed to load credentials', credentials);
                    $9a0a8feba8dfacf9$var$logger.debug('Error loading credentials', err);
                    rej(err);
                    return;
                }
            });
        });
    };
    CredentialsClass.prototype.set = function(params, source) {
        if (source === 'session') return this._setCredentialsFromSession(params);
        else if (source === 'federation') return this._setCredentialsFromFederation(params);
        else if (source === 'guest') return this._setCredentialsForGuest();
        else {
            $9a0a8feba8dfacf9$var$logger.debug('no source specified for setting credentials');
            return Promise.reject('invalid source');
        }
    };
    CredentialsClass.prototype.clear = function() {
        return $9a0a8feba8dfacf9$var$__awaiter(this, void 0, void 0, function() {
            return $9a0a8feba8dfacf9$var$__generator(this, function(_a) {
                this._credentials = null;
                this._credentials_source = null;
                $9a0a8feba8dfacf9$var$logger.debug('removing aws-amplify-federatedInfo from storage');
                this._storage.removeItem('aws-amplify-federatedInfo');
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ CredentialsClass.prototype.shear = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    return CredentialsClass;
}();
var $9a0a8feba8dfacf9$export$a9627919734faa48 = new $9a0a8feba8dfacf9$export$9be509043bd0c09a(null);
(0, $9QDF4.Amplify).register($9a0a8feba8dfacf9$export$a9627919734faa48);
var /**
 * @deprecated use named import
 */ $9a0a8feba8dfacf9$export$2e2bcd8739ae039 = $9a0a8feba8dfacf9$export$a9627919734faa48;

});
parcelRegister("lpqOV", function(module, exports) {

$parcel$export(module.exports, "StorageHelper", function () { return $f960bcb78942ac7a$export$a2bd19c49e4760e8; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $f960bcb78942ac7a$var$dataMemory = {};
/** @class */ var $f960bcb78942ac7a$export$d7392285c701ecf5 = /** @class */ function() {
    function MemoryStorage() {}
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ MemoryStorage.setItem = function(key, value) {
        $f960bcb78942ac7a$var$dataMemory[key] = value;
        return $f960bcb78942ac7a$var$dataMemory[key];
    };
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ MemoryStorage.getItem = function(key) {
        return Object.prototype.hasOwnProperty.call($f960bcb78942ac7a$var$dataMemory, key) ? $f960bcb78942ac7a$var$dataMemory[key] : undefined;
    };
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ MemoryStorage.removeItem = function(key) {
        return delete $f960bcb78942ac7a$var$dataMemory[key];
    };
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ MemoryStorage.clear = function() {
        $f960bcb78942ac7a$var$dataMemory = {};
        return $f960bcb78942ac7a$var$dataMemory;
    };
    return MemoryStorage;
}();
var $f960bcb78942ac7a$export$a2bd19c49e4760e8 = /** @class */ function() {
    /**
     * This is used to get a storage object
     * @returns {object} the storage
     */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem('aws.amplify.test-ls', 1);
            this.storageWindow.removeItem('aws.amplify.test-ls');
        } catch (exception) {
            this.storageWindow = $f960bcb78942ac7a$export$d7392285c701ecf5;
        }
    }
    /**
     * This is used to return the storage
     * @returns {object} the storage
     */ StorageHelper.prototype.getStorage = function() {
        return this.storageWindow;
    };
    return StorageHelper;
}();
var /**
 * @deprecated use named import
 */ $f960bcb78942ac7a$export$2e2bcd8739ae039 = $f960bcb78942ac7a$export$a2bd19c49e4760e8;

});

parcelRegister("hZ847", function(module, exports) {

$parcel$export(module.exports, "GoogleOAuth", function () { return $0361019c0a97d63f$export$75ace714083c1340; });
$parcel$export(module.exports, "FacebookOAuth", function () { return $0361019c0a97d63f$export$1b6b8b5328e38349; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $1wjOU = parcelRequire("1wjOU");

var $8BZdn = parcelRequire("8BZdn");
var $0361019c0a97d63f$export$75ace714083c1340 = new (0, $1wjOU.GoogleOAuth)();
var $0361019c0a97d63f$export$1b6b8b5328e38349 = new (0, $8BZdn.FacebookOAuth)();

});
parcelRegister("1wjOU", function(module, exports) {

$parcel$export(module.exports, "GoogleOAuth", function () { return $11b827714dbc66f3$export$75ace714083c1340; });

var $l7cio = parcelRequire("l7cio");

var $7HFvj = parcelRequire("7HFvj");

var $69J7B = parcelRequire("69J7B");
var $11b827714dbc66f3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $11b827714dbc66f3$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $11b827714dbc66f3$var$logger = new (0, $l7cio.ConsoleLogger)('CognitoCredentials');
var $11b827714dbc66f3$var$waitForInit = new Promise(function(res, rej) {
    if (!(0, $7HFvj.browserOrNode)().isBrowser) {
        $11b827714dbc66f3$var$logger.debug('not in the browser, directly resolved');
        return res();
    }
    var ga = window['gapi'] && window['gapi'].auth2 ? window['gapi'].auth2 : null;
    if (ga) {
        $11b827714dbc66f3$var$logger.debug('google api already loaded');
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var $11b827714dbc66f3$export$75ace714083c1340 = /** @class */ function() {
    function GoogleOAuth() {
        this.initialized = false;
        this.refreshGoogleToken = this.refreshGoogleToken.bind(this);
        this._refreshGoogleTokenImpl = this._refreshGoogleTokenImpl.bind(this);
    }
    GoogleOAuth.prototype.refreshGoogleToken = function() {
        return $11b827714dbc66f3$var$__awaiter(this, void 0, void 0, function() {
            return $11b827714dbc66f3$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        $11b827714dbc66f3$var$logger.debug('need to wait for the Google SDK loaded');
                        return [
                            4 /*yield*/ ,
                            $11b827714dbc66f3$var$waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        $11b827714dbc66f3$var$logger.debug('finish waiting');
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshGoogleTokenImpl()
                        ];
                }
            });
        });
    };
    GoogleOAuth.prototype._refreshGoogleTokenImpl = function() {
        var ga = null;
        if ((0, $7HFvj.browserOrNode)().isBrowser) ga = window['gapi'] && window['gapi'].auth2 ? window['gapi'].auth2 : null;
        if (!ga) {
            $11b827714dbc66f3$var$logger.debug('no gapi auth2 available');
            return Promise.reject('no gapi auth2 available');
        }
        return new Promise(function(res, rej) {
            ga.getAuthInstance().then(function(googleAuth) {
                if (!googleAuth) {
                    $11b827714dbc66f3$var$logger.debug('google Auth undefined');
                    rej(new (0, $69J7B.NonRetryableError)('google Auth undefined'));
                }
                var googleUser = googleAuth.currentUser.get();
                // refresh the token
                if (googleUser.isSignedIn()) {
                    $11b827714dbc66f3$var$logger.debug('refreshing the google access token');
                    googleUser.reloadAuthResponse().then(function(authResponse) {
                        var id_token = authResponse.id_token, expires_at = authResponse.expires_at;
                        res({
                            token: id_token,
                            expires_at: expires_at
                        });
                    }).catch(function(err) {
                        if (err && err.error === 'network_error') // Not using NonRetryableError so handler will be retried
                        rej('Network error reloading google auth response');
                        else rej(new (0, $69J7B.NonRetryableError)('Failed to reload google auth response'));
                    });
                } else rej(new (0, $69J7B.NonRetryableError)('User is not signed in with Google'));
            }).catch(function(err) {
                $11b827714dbc66f3$var$logger.debug('Failed to refresh google token', err);
                rej(new (0, $69J7B.NonRetryableError)('Failed to refresh google token'));
            });
        });
    };
    return GoogleOAuth;
}();
var /**
 * @deprecated use named import
 */ $11b827714dbc66f3$export$2e2bcd8739ae039 = $11b827714dbc66f3$export$75ace714083c1340;

});
parcelRegister("69J7B", function(module, exports) {

$parcel$export(module.exports, "NonRetryableError", function () { return $47b6958e8089b2b8$export$1e38badc838ad384; });
$parcel$export(module.exports, "jitteredExponentialRetry", function () { return $47b6958e8089b2b8$export$a24aa7705df9cf44; });

var $l7cio = parcelRequire("l7cio");
var $47b6958e8089b2b8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $47b6958e8089b2b8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $47b6958e8089b2b8$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $47b6958e8089b2b8$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $47b6958e8089b2b8$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($47b6958e8089b2b8$var$__read(arguments[i]));
    return ar;
};
var $47b6958e8089b2b8$var$logger = new (0, $l7cio.ConsoleLogger)('Util');
var $47b6958e8089b2b8$export$1e38badc838ad384 = /** @class */ function(_super) {
    $47b6958e8089b2b8$var$__extends(NonRetryableError, _super);
    function NonRetryableError(message) {
        var _this = _super.call(this, message) || this;
        _this.nonRetryable = true;
        return _this;
    }
    return NonRetryableError;
}(Error);
var $47b6958e8089b2b8$var$isNonRetryableError = function(obj) {
    var key = 'nonRetryable';
    return obj && obj[key];
};
function $47b6958e8089b2b8$export$9369b12211e1fce4(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) attempt = 1;
    return $47b6958e8089b2b8$var$__awaiter(this, void 0, void 0, function() {
        var err_1, retryIn_1;
        return $47b6958e8089b2b8$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (typeof functionToRetry !== 'function') throw Error('functionToRetry must be a function');
                    $47b6958e8089b2b8$var$logger.debug(functionToRetry.name + " attempt #" + attempt + " with this vars: " + JSON.stringify(args));
                    _a.label = 1;
                case 1:
                    _a.trys.push([
                        1,
                        3,
                        ,
                        8
                    ]);
                    return [
                        4 /*yield*/ ,
                        functionToRetry.apply(void 0, $47b6958e8089b2b8$var$__spread(args))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
                case 3:
                    err_1 = _a.sent();
                    $47b6958e8089b2b8$var$logger.debug("error on " + functionToRetry.name, err_1);
                    if ($47b6958e8089b2b8$var$isNonRetryableError(err_1)) {
                        $47b6958e8089b2b8$var$logger.debug(functionToRetry.name + " non retryable error", err_1);
                        throw err_1;
                    }
                    retryIn_1 = delayFn(attempt, args, err_1);
                    $47b6958e8089b2b8$var$logger.debug(functionToRetry.name + " retrying in " + retryIn_1 + " ms");
                    if (!(retryIn_1 !== false)) return [
                        3 /*break*/ ,
                        6
                    ];
                    return [
                        4 /*yield*/ ,
                        new Promise(function(res) {
                            return setTimeout(res, retryIn_1);
                        })
                    ];
                case 4:
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        $47b6958e8089b2b8$export$9369b12211e1fce4(functionToRetry, args, delayFn, attempt + 1)
                    ];
                case 5:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
                case 6:
                    throw err_1;
                case 7:
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 8:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
var $47b6958e8089b2b8$var$MAX_DELAY_MS = 300000;
function $47b6958e8089b2b8$var$jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var $47b6958e8089b2b8$export$a24aa7705df9cf44 = function(functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $47b6958e8089b2b8$var$MAX_DELAY_MS;
    return $47b6958e8089b2b8$export$9369b12211e1fce4(functionToRetry, args, $47b6958e8089b2b8$var$jitteredBackoff(maxDelayMs));
};

});


parcelRegister("8BZdn", function(module, exports) {

$parcel$export(module.exports, "FacebookOAuth", function () { return $64514365becb1e91$export$1b6b8b5328e38349; });

var $l7cio = parcelRequire("l7cio");

var $7HFvj = parcelRequire("7HFvj");

var $69J7B = parcelRequire("69J7B");
var $64514365becb1e91$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $64514365becb1e91$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $64514365becb1e91$var$logger = new (0, $l7cio.ConsoleLogger)('CognitoCredentials');
var $64514365becb1e91$var$waitForInit = new Promise(function(res, rej) {
    if (!(0, $7HFvj.browserOrNode)().isBrowser) {
        $64514365becb1e91$var$logger.debug('not in the browser, directly resolved');
        return res();
    }
    var fb = window['FB'];
    if (fb) {
        $64514365becb1e91$var$logger.debug('FB SDK already loaded');
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var $64514365becb1e91$export$1b6b8b5328e38349 = /** @class */ function() {
    function FacebookOAuth() {
        this.initialized = false;
        this.refreshFacebookToken = this.refreshFacebookToken.bind(this);
        this._refreshFacebookTokenImpl = this._refreshFacebookTokenImpl.bind(this);
    }
    FacebookOAuth.prototype.refreshFacebookToken = function() {
        return $64514365becb1e91$var$__awaiter(this, void 0, void 0, function() {
            return $64514365becb1e91$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        $64514365becb1e91$var$logger.debug('need to wait for the Facebook SDK loaded');
                        return [
                            4 /*yield*/ ,
                            $64514365becb1e91$var$waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        $64514365becb1e91$var$logger.debug('finish waiting');
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshFacebookTokenImpl()
                        ];
                }
            });
        });
    };
    FacebookOAuth.prototype._refreshFacebookTokenImpl = function() {
        var fb = null;
        if ((0, $7HFvj.browserOrNode)().isBrowser) fb = window['FB'];
        if (!fb) {
            var errorMessage = 'no fb sdk available';
            $64514365becb1e91$var$logger.debug(errorMessage);
            return Promise.reject(new (0, $69J7B.NonRetryableError)(errorMessage));
        }
        return new Promise(function(res, rej) {
            fb.getLoginStatus(function(fbResponse) {
                if (!fbResponse || !fbResponse.authResponse) {
                    var errorMessage = 'no response from facebook when refreshing the jwt token';
                    $64514365becb1e91$var$logger.debug(errorMessage);
                    // There is no definitive indication for a network error in
                    // fbResponse, so we are treating it as an invalid token.
                    rej(new (0, $69J7B.NonRetryableError)(errorMessage));
                } else {
                    var response = fbResponse.authResponse;
                    var accessToken = response.accessToken, expiresIn = response.expiresIn;
                    var date = new Date();
                    var expires_at = expiresIn * 1000 + date.getTime();
                    if (!accessToken) {
                        var errorMessage = 'the jwtToken is undefined';
                        $64514365becb1e91$var$logger.debug(errorMessage);
                        rej(new (0, $69J7B.NonRetryableError)(errorMessage));
                    }
                    res({
                        token: accessToken,
                        expires_at: expires_at
                    });
                }
            }, {
                scope: 'public_profile,email'
            });
        });
    };
    return FacebookOAuth;
}();
var /**
 * @deprecated use named import
 */ $64514365becb1e91$export$2e2bcd8739ae039 = $64514365becb1e91$export$1b6b8b5328e38349;

});


parcelRegister("210G3", function(module, exports) {

$parcel$export(module.exports, "fromCognitoIdentity", function () { return $177c333ff69403c8$export$4d624d71eb462130; });

var $fH1jI = parcelRequire("fH1jI");

var $hQ9Vy = parcelRequire("hQ9Vy");
parcelRequire("hbAuD");
var $4qhnW = parcelRequire("4qhnW");

var $k0iBr = parcelRequire("k0iBr");
function $177c333ff69403c8$export$4d624d71eb462130(parameters) {
    var _this = this;
    return function() {
        return (0, $fH1jI.__awaiter)(_this, void 0, void 0, function() {
            var _a, _b, _c, AccessKeyId, Expiration, _d, SecretKey, SessionToken, _e, _f, _g, _h;
            var _j;
            return (0, $fH1jI.__generator)(this, function(_k) {
                switch(_k.label){
                    case 0:
                        _f = (_e = parameters.client).send;
                        _g = (0, $hQ9Vy.GetCredentialsForIdentityCommand).bind;
                        _j = {
                            CustomRoleArn: parameters.customRoleArn,
                            IdentityId: parameters.identityId
                        };
                        if (!parameters.logins) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $k0iBr.resolveLogins)(parameters.logins)
                        ];
                    case 1:
                        _h = _k.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _h = undefined;
                        _k.label = 3;
                    case 3:
                        return [
                            4 /*yield*/ ,
                            _f.apply(_e, [
                                new (_g.apply((0, $hQ9Vy.GetCredentialsForIdentityCommand), [
                                    void 0,
                                    (_j.Logins = _h, _j)
                                ]))()
                            ])
                        ];
                    case 4:
                        _a = _k.sent().Credentials, _b = _a === void 0 ? $177c333ff69403c8$var$throwOnMissingCredentials() : _a, _c = _b.AccessKeyId, AccessKeyId = _c === void 0 ? $177c333ff69403c8$var$throwOnMissingAccessKeyId() : _c, Expiration = _b.Expiration, _d = _b.SecretKey, SecretKey = _d === void 0 ? $177c333ff69403c8$var$throwOnMissingSecretKey() : _d, SessionToken = _b.SessionToken;
                        return [
                            2 /*return*/ ,
                            {
                                identityId: parameters.identityId,
                                accessKeyId: AccessKeyId,
                                secretAccessKey: SecretKey,
                                sessionToken: SessionToken,
                                expiration: Expiration
                            }
                        ];
                }
            });
        });
    };
}
function $177c333ff69403c8$var$throwOnMissingAccessKeyId() {
    throw new (0, $4qhnW.ProviderError)("Response from Amazon Cognito contained no access key ID");
}
function $177c333ff69403c8$var$throwOnMissingCredentials() {
    throw new (0, $4qhnW.ProviderError)("Response from Amazon Cognito contained no credentials");
}
function $177c333ff69403c8$var$throwOnMissingSecretKey() {
    throw new (0, $4qhnW.ProviderError)("Response from Amazon Cognito contained no secret key");
}

});
parcelRegister("hQ9Vy", function(module, exports) {

$parcel$export(module.exports, "GetCredentialsForIdentityCommand", function () { return $cfcefe5f48f73aca$export$e08b3308c36761ec; });

var $lUfmm = parcelRequire("lUfmm");

var $dtL6g = parcelRequire("dtL6g");

var $37z13 = parcelRequire("37z13");
parcelRequire("5Wom8");
var $jU8uG = parcelRequire("jU8uG");
parcelRequire("fF6iB");
var $koeHb = parcelRequire("koeHb");
var $cfcefe5f48f73aca$export$e08b3308c36761ec = /** @class */ function(_super) {
    (0, $lUfmm.__extends)(GetCredentialsForIdentityCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetCredentialsForIdentityCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    GetCredentialsForIdentityCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $jU8uG.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "GetCredentialsForIdentityCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $dtL6g.GetCredentialsForIdentityInput).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $dtL6g.GetCredentialsForIdentityResponse).filterSensitiveLog
        };
        if (typeof logger.info === "function") logger.info({
            clientName: clientName,
            commandName: commandName
        });
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetCredentialsForIdentityCommand.prototype.serialize = function(input, context) {
        return (0, $37z13.serializeAws_json1_1GetCredentialsForIdentityCommand)(input, context);
    };
    GetCredentialsForIdentityCommand.prototype.deserialize = function(output, context) {
        return (0, $37z13.deserializeAws_json1_1GetCredentialsForIdentityCommand)(output, context);
    };
    return GetCredentialsForIdentityCommand;
}((0, $koeHb.Command));

});
parcelRegister("lUfmm", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $ff2abe0c5e164221$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $ff2abe0c5e164221$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__awaiter", function () { return $ff2abe0c5e164221$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $ff2abe0c5e164221$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__read", function () { return $ff2abe0c5e164221$export$8d051b38c9118094; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $ff2abe0c5e164221$var$extendStatics = function(d, b) {
    $ff2abe0c5e164221$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $ff2abe0c5e164221$var$extendStatics(d, b);
};
function $ff2abe0c5e164221$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $ff2abe0c5e164221$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ff2abe0c5e164221$export$18ce0697a983be9b = function() {
    $ff2abe0c5e164221$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ff2abe0c5e164221$export$18ce0697a983be9b.apply(this, arguments);
};
function $ff2abe0c5e164221$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ff2abe0c5e164221$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ff2abe0c5e164221$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ff2abe0c5e164221$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $ff2abe0c5e164221$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $ff2abe0c5e164221$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $ff2abe0c5e164221$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $ff2abe0c5e164221$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ff2abe0c5e164221$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ff2abe0c5e164221$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $ff2abe0c5e164221$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $ff2abe0c5e164221$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $ff2abe0c5e164221$export$45d3717a4c69092e(o, m, p);
}
function $ff2abe0c5e164221$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ff2abe0c5e164221$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ff2abe0c5e164221$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ff2abe0c5e164221$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ff2abe0c5e164221$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ff2abe0c5e164221$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $ff2abe0c5e164221$export$10c90e4f7922046c(v) {
    return this instanceof $ff2abe0c5e164221$export$10c90e4f7922046c ? (this.v = v, this) : new $ff2abe0c5e164221$export$10c90e4f7922046c(v);
}
function $ff2abe0c5e164221$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ff2abe0c5e164221$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ff2abe0c5e164221$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ff2abe0c5e164221$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $ff2abe0c5e164221$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ff2abe0c5e164221$export$19a8beecd37a4c45 === "function" ? $ff2abe0c5e164221$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ff2abe0c5e164221$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $ff2abe0c5e164221$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $ff2abe0c5e164221$var$ownKeys = function(o) {
    $ff2abe0c5e164221$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $ff2abe0c5e164221$var$ownKeys(o);
};
function $ff2abe0c5e164221$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $ff2abe0c5e164221$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $ff2abe0c5e164221$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $ff2abe0c5e164221$var$__setModuleDefault(result, mod);
    return result;
}
function $ff2abe0c5e164221$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ff2abe0c5e164221$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $ff2abe0c5e164221$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $ff2abe0c5e164221$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $ff2abe0c5e164221$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $ff2abe0c5e164221$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $ff2abe0c5e164221$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $ff2abe0c5e164221$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $ff2abe0c5e164221$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $ff2abe0c5e164221$export$2e2bcd8739ae039 = {
    __extends: $ff2abe0c5e164221$export$a8ba968b8961cb8a,
    __assign: $ff2abe0c5e164221$export$18ce0697a983be9b,
    __rest: $ff2abe0c5e164221$export$3c9a16f847548506,
    __decorate: $ff2abe0c5e164221$export$29e00dfd3077644b,
    __param: $ff2abe0c5e164221$export$d5ad3fd78186038f,
    __esDecorate: $ff2abe0c5e164221$export$3a84e1ae4e97e9b0,
    __runInitializers: $ff2abe0c5e164221$export$d831c04e792af3d,
    __propKey: $ff2abe0c5e164221$export$6a2a36740a146cb8,
    __setFunctionName: $ff2abe0c5e164221$export$d1a06452d3489bc7,
    __metadata: $ff2abe0c5e164221$export$f1db080c865becb9,
    __awaiter: $ff2abe0c5e164221$export$1050f835b63b671e,
    __generator: $ff2abe0c5e164221$export$67ebef60e6f28a6,
    __createBinding: $ff2abe0c5e164221$export$45d3717a4c69092e,
    __exportStar: $ff2abe0c5e164221$export$f33643c0debef087,
    __values: $ff2abe0c5e164221$export$19a8beecd37a4c45,
    __read: $ff2abe0c5e164221$export$8d051b38c9118094,
    __spread: $ff2abe0c5e164221$export$afc72e2116322959,
    __spreadArrays: $ff2abe0c5e164221$export$6388937ca91ccae8,
    __spreadArray: $ff2abe0c5e164221$export$1216008129fb82ed,
    __await: $ff2abe0c5e164221$export$10c90e4f7922046c,
    __asyncGenerator: $ff2abe0c5e164221$export$e427f37a30a4de9b,
    __asyncDelegator: $ff2abe0c5e164221$export$bbd80228419bb833,
    __asyncValues: $ff2abe0c5e164221$export$e3b29a3d6162315f,
    __makeTemplateObject: $ff2abe0c5e164221$export$4fb47efe1390b86f,
    __importStar: $ff2abe0c5e164221$export$c21735bcef00d192,
    __importDefault: $ff2abe0c5e164221$export$da59b14a69baef04,
    __classPrivateFieldGet: $ff2abe0c5e164221$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $ff2abe0c5e164221$export$d40a35129aaff81f,
    __classPrivateFieldIn: $ff2abe0c5e164221$export$81fdc39f203e4e04,
    __addDisposableResource: $ff2abe0c5e164221$export$88ac25d8e944e405,
    __disposeResources: $ff2abe0c5e164221$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $ff2abe0c5e164221$export$889dfb5d17574b0b
};

});

parcelRegister("dtL6g", function(module, exports) {

$parcel$export(module.exports, "GetCredentialsForIdentityInput", function () { return $9d0284e6054e1982$export$bb51e43959182308; });
$parcel$export(module.exports, "GetCredentialsForIdentityResponse", function () { return $9d0284e6054e1982$export$ba56c4cb277a72f9; });
$parcel$export(module.exports, "GetIdInput", function () { return $9d0284e6054e1982$export$badc3094716a9faa; });
$parcel$export(module.exports, "GetIdResponse", function () { return $9d0284e6054e1982$export$c3ec238968a6e7ac; });

var $lUfmm = parcelRequire("lUfmm");
var $9d0284e6054e1982$export$dc00db384271fff6;
(function(AmbiguousRoleResolutionType) {
    AmbiguousRoleResolutionType["AUTHENTICATED_ROLE"] = "AuthenticatedRole";
    AmbiguousRoleResolutionType["DENY"] = "Deny";
})($9d0284e6054e1982$export$dc00db384271fff6 || ($9d0284e6054e1982$export$dc00db384271fff6 = {}));
var $9d0284e6054e1982$export$8a7902a72d4cb6dd;
(function(CognitoIdentityProvider) {
    CognitoIdentityProvider.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$8a7902a72d4cb6dd || ($9d0284e6054e1982$export$8a7902a72d4cb6dd = {}));
var $9d0284e6054e1982$export$2d7512435854af72;
(function(CreateIdentityPoolInput) {
    CreateIdentityPoolInput.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$2d7512435854af72 || ($9d0284e6054e1982$export$2d7512435854af72 = {}));
var $9d0284e6054e1982$export$8d556ce24d00472;
(function(IdentityPool) {
    IdentityPool.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$8d556ce24d00472 || ($9d0284e6054e1982$export$8d556ce24d00472 = {}));
var $9d0284e6054e1982$export$8b0f706f4df56c63;
(function(InternalErrorException) {
    InternalErrorException.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$8b0f706f4df56c63 || ($9d0284e6054e1982$export$8b0f706f4df56c63 = {}));
var $9d0284e6054e1982$export$fa781b52e13bf866;
(function(InvalidParameterException) {
    InvalidParameterException.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$fa781b52e13bf866 || ($9d0284e6054e1982$export$fa781b52e13bf866 = {}));
var $9d0284e6054e1982$export$cd419aa7f32ec382;
(function(LimitExceededException) {
    LimitExceededException.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$cd419aa7f32ec382 || ($9d0284e6054e1982$export$cd419aa7f32ec382 = {}));
var $9d0284e6054e1982$export$82cff5e5a0a874dd;
(function(NotAuthorizedException) {
    NotAuthorizedException.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$82cff5e5a0a874dd || ($9d0284e6054e1982$export$82cff5e5a0a874dd = {}));
var $9d0284e6054e1982$export$cbdaf31887dd0603;
(function(ResourceConflictException) {
    ResourceConflictException.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$cbdaf31887dd0603 || ($9d0284e6054e1982$export$cbdaf31887dd0603 = {}));
var $9d0284e6054e1982$export$4a67805ad445f61;
(function(TooManyRequestsException) {
    TooManyRequestsException.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$4a67805ad445f61 || ($9d0284e6054e1982$export$4a67805ad445f61 = {}));
var $9d0284e6054e1982$export$6ce299b58e0ab8fe;
(function(DeleteIdentitiesInput) {
    DeleteIdentitiesInput.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$6ce299b58e0ab8fe || ($9d0284e6054e1982$export$6ce299b58e0ab8fe = {}));
var $9d0284e6054e1982$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ErrorCode["ACCESS_DENIED"] = "AccessDenied";
    ErrorCode["INTERNAL_SERVER_ERROR"] = "InternalServerError";
})($9d0284e6054e1982$export$d4e71bc0b80dc0fb || ($9d0284e6054e1982$export$d4e71bc0b80dc0fb = {}));
var $9d0284e6054e1982$export$7235a8ee19d2bee3;
(function(UnprocessedIdentityId) {
    UnprocessedIdentityId.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$7235a8ee19d2bee3 || ($9d0284e6054e1982$export$7235a8ee19d2bee3 = {}));
var $9d0284e6054e1982$export$2b5603236acc81d9;
(function(DeleteIdentitiesResponse) {
    DeleteIdentitiesResponse.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$2b5603236acc81d9 || ($9d0284e6054e1982$export$2b5603236acc81d9 = {}));
var $9d0284e6054e1982$export$cb6981b8f9a703c2;
(function(DeleteIdentityPoolInput) {
    DeleteIdentityPoolInput.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$cb6981b8f9a703c2 || ($9d0284e6054e1982$export$cb6981b8f9a703c2 = {}));
var $9d0284e6054e1982$export$ecba565262f8bb2;
(function(ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$ecba565262f8bb2 || ($9d0284e6054e1982$export$ecba565262f8bb2 = {}));
var $9d0284e6054e1982$export$46587acc7855d6e2;
(function(DescribeIdentityInput) {
    DescribeIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$46587acc7855d6e2 || ($9d0284e6054e1982$export$46587acc7855d6e2 = {}));
var $9d0284e6054e1982$export$16e1ea20d4f13fa7;
(function(IdentityDescription) {
    IdentityDescription.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$16e1ea20d4f13fa7 || ($9d0284e6054e1982$export$16e1ea20d4f13fa7 = {}));
var $9d0284e6054e1982$export$4b5909fe2abc147d;
(function(DescribeIdentityPoolInput) {
    DescribeIdentityPoolInput.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$4b5909fe2abc147d || ($9d0284e6054e1982$export$4b5909fe2abc147d = {}));
var $9d0284e6054e1982$export$cb77a58cb7dbb17;
(function(ExternalServiceException) {
    ExternalServiceException.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$cb77a58cb7dbb17 || ($9d0284e6054e1982$export$cb77a58cb7dbb17 = {}));
var $9d0284e6054e1982$export$bb51e43959182308;
(function(GetCredentialsForIdentityInput) {
    GetCredentialsForIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$bb51e43959182308 || ($9d0284e6054e1982$export$bb51e43959182308 = {}));
var $9d0284e6054e1982$export$a9627919734faa48;
(function(Credentials) {
    Credentials.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$a9627919734faa48 || ($9d0284e6054e1982$export$a9627919734faa48 = {}));
var $9d0284e6054e1982$export$ba56c4cb277a72f9;
(function(GetCredentialsForIdentityResponse) {
    GetCredentialsForIdentityResponse.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$ba56c4cb277a72f9 || ($9d0284e6054e1982$export$ba56c4cb277a72f9 = {}));
var $9d0284e6054e1982$export$90d12448d3766cda;
(function(InvalidIdentityPoolConfigurationException) {
    InvalidIdentityPoolConfigurationException.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$90d12448d3766cda || ($9d0284e6054e1982$export$90d12448d3766cda = {}));
var $9d0284e6054e1982$export$badc3094716a9faa;
(function(GetIdInput) {
    GetIdInput.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$badc3094716a9faa || ($9d0284e6054e1982$export$badc3094716a9faa = {}));
var $9d0284e6054e1982$export$c3ec238968a6e7ac;
(function(GetIdResponse) {
    GetIdResponse.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$c3ec238968a6e7ac || ($9d0284e6054e1982$export$c3ec238968a6e7ac = {}));
var $9d0284e6054e1982$export$f5f529c0b4e5eb30;
(function(GetIdentityPoolRolesInput) {
    GetIdentityPoolRolesInput.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$f5f529c0b4e5eb30 || ($9d0284e6054e1982$export$f5f529c0b4e5eb30 = {}));
var $9d0284e6054e1982$export$819b5ceb37e06be;
(function(MappingRuleMatchType) {
    MappingRuleMatchType["CONTAINS"] = "Contains";
    MappingRuleMatchType["EQUALS"] = "Equals";
    MappingRuleMatchType["NOT_EQUAL"] = "NotEqual";
    MappingRuleMatchType["STARTS_WITH"] = "StartsWith";
})($9d0284e6054e1982$export$819b5ceb37e06be || ($9d0284e6054e1982$export$819b5ceb37e06be = {}));
var $9d0284e6054e1982$export$3f8398961535c3a;
(function(MappingRule) {
    MappingRule.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$3f8398961535c3a || ($9d0284e6054e1982$export$3f8398961535c3a = {}));
var $9d0284e6054e1982$export$269dcf2519324984;
(function(RulesConfigurationType) {
    RulesConfigurationType.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$269dcf2519324984 || ($9d0284e6054e1982$export$269dcf2519324984 = {}));
var $9d0284e6054e1982$export$c726ef784882c23e;
(function(RoleMappingType) {
    RoleMappingType["RULES"] = "Rules";
    RoleMappingType["TOKEN"] = "Token";
})($9d0284e6054e1982$export$c726ef784882c23e || ($9d0284e6054e1982$export$c726ef784882c23e = {}));
var $9d0284e6054e1982$export$c8be61b857de8364;
(function(RoleMapping) {
    RoleMapping.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$c8be61b857de8364 || ($9d0284e6054e1982$export$c8be61b857de8364 = {}));
var $9d0284e6054e1982$export$69a6cbc1a215fcdf;
(function(GetIdentityPoolRolesResponse) {
    GetIdentityPoolRolesResponse.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$69a6cbc1a215fcdf || ($9d0284e6054e1982$export$69a6cbc1a215fcdf = {}));
var $9d0284e6054e1982$export$e31993063e9290fd;
(function(GetOpenIdTokenInput) {
    GetOpenIdTokenInput.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$e31993063e9290fd || ($9d0284e6054e1982$export$e31993063e9290fd = {}));
var $9d0284e6054e1982$export$c2cdb3ad9240cf7d;
(function(GetOpenIdTokenResponse) {
    GetOpenIdTokenResponse.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$c2cdb3ad9240cf7d || ($9d0284e6054e1982$export$c2cdb3ad9240cf7d = {}));
var $9d0284e6054e1982$export$f9e8c5d2069aeea4;
(function(DeveloperUserAlreadyRegisteredException) {
    DeveloperUserAlreadyRegisteredException.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$f9e8c5d2069aeea4 || ($9d0284e6054e1982$export$f9e8c5d2069aeea4 = {}));
var $9d0284e6054e1982$export$b30c26022c4ccb98;
(function(GetOpenIdTokenForDeveloperIdentityInput) {
    GetOpenIdTokenForDeveloperIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$b30c26022c4ccb98 || ($9d0284e6054e1982$export$b30c26022c4ccb98 = {}));
var $9d0284e6054e1982$export$39b050249a579e7b;
(function(GetOpenIdTokenForDeveloperIdentityResponse) {
    GetOpenIdTokenForDeveloperIdentityResponse.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$39b050249a579e7b || ($9d0284e6054e1982$export$39b050249a579e7b = {}));
var $9d0284e6054e1982$export$8c1e5f4b8dc33aa1;
(function(ListIdentitiesInput) {
    ListIdentitiesInput.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$8c1e5f4b8dc33aa1 || ($9d0284e6054e1982$export$8c1e5f4b8dc33aa1 = {}));
var $9d0284e6054e1982$export$5270c3e17502575a;
(function(ListIdentitiesResponse) {
    ListIdentitiesResponse.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$5270c3e17502575a || ($9d0284e6054e1982$export$5270c3e17502575a = {}));
var $9d0284e6054e1982$export$1d38161f8b62ad;
(function(ListIdentityPoolsInput) {
    ListIdentityPoolsInput.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$1d38161f8b62ad || ($9d0284e6054e1982$export$1d38161f8b62ad = {}));
var $9d0284e6054e1982$export$5a7a0c97755dcf8e;
(function(IdentityPoolShortDescription) {
    IdentityPoolShortDescription.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$5a7a0c97755dcf8e || ($9d0284e6054e1982$export$5a7a0c97755dcf8e = {}));
var $9d0284e6054e1982$export$f862a07a4a7c6250;
(function(ListIdentityPoolsResponse) {
    ListIdentityPoolsResponse.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$f862a07a4a7c6250 || ($9d0284e6054e1982$export$f862a07a4a7c6250 = {}));
var $9d0284e6054e1982$export$8eb1e3f42ea35fee;
(function(ListTagsForResourceInput) {
    ListTagsForResourceInput.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$8eb1e3f42ea35fee || ($9d0284e6054e1982$export$8eb1e3f42ea35fee = {}));
var $9d0284e6054e1982$export$6db0c8c0f26e7fec;
(function(ListTagsForResourceResponse) {
    ListTagsForResourceResponse.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$6db0c8c0f26e7fec || ($9d0284e6054e1982$export$6db0c8c0f26e7fec = {}));
var $9d0284e6054e1982$export$1624698866821668;
(function(LookupDeveloperIdentityInput) {
    LookupDeveloperIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$1624698866821668 || ($9d0284e6054e1982$export$1624698866821668 = {}));
var $9d0284e6054e1982$export$fb0cf3531245501b;
(function(LookupDeveloperIdentityResponse) {
    LookupDeveloperIdentityResponse.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$fb0cf3531245501b || ($9d0284e6054e1982$export$fb0cf3531245501b = {}));
var $9d0284e6054e1982$export$8f282934b0cfbc4a;
(function(MergeDeveloperIdentitiesInput) {
    MergeDeveloperIdentitiesInput.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$8f282934b0cfbc4a || ($9d0284e6054e1982$export$8f282934b0cfbc4a = {}));
var $9d0284e6054e1982$export$13aa23992eef667b;
(function(MergeDeveloperIdentitiesResponse) {
    MergeDeveloperIdentitiesResponse.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$13aa23992eef667b || ($9d0284e6054e1982$export$13aa23992eef667b = {}));
var $9d0284e6054e1982$export$21f15e80c2bbca09;
(function(ConcurrentModificationException) {
    ConcurrentModificationException.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$21f15e80c2bbca09 || ($9d0284e6054e1982$export$21f15e80c2bbca09 = {}));
var $9d0284e6054e1982$export$20f43a93eb8d3b02;
(function(SetIdentityPoolRolesInput) {
    SetIdentityPoolRolesInput.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$20f43a93eb8d3b02 || ($9d0284e6054e1982$export$20f43a93eb8d3b02 = {}));
var $9d0284e6054e1982$export$a5e7dff780e8dcb0;
(function(TagResourceInput) {
    TagResourceInput.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$a5e7dff780e8dcb0 || ($9d0284e6054e1982$export$a5e7dff780e8dcb0 = {}));
var $9d0284e6054e1982$export$2d5279802486e8b0;
(function(TagResourceResponse) {
    TagResourceResponse.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$2d5279802486e8b0 || ($9d0284e6054e1982$export$2d5279802486e8b0 = {}));
var $9d0284e6054e1982$export$b977eb1c8f754bfa;
(function(UnlinkDeveloperIdentityInput) {
    UnlinkDeveloperIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$b977eb1c8f754bfa || ($9d0284e6054e1982$export$b977eb1c8f754bfa = {}));
var $9d0284e6054e1982$export$2415026a66f5e70b;
(function(UnlinkIdentityInput) {
    UnlinkIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$2415026a66f5e70b || ($9d0284e6054e1982$export$2415026a66f5e70b = {}));
var $9d0284e6054e1982$export$4dbbd8ede80c9c36;
(function(UntagResourceInput) {
    UntagResourceInput.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$4dbbd8ede80c9c36 || ($9d0284e6054e1982$export$4dbbd8ede80c9c36 = {}));
var $9d0284e6054e1982$export$2128f49a7cd2e47f;
(function(UntagResourceResponse) {
    UntagResourceResponse.filterSensitiveLog = function(obj) {
        return (0, $lUfmm.__assign)({}, obj);
    };
})($9d0284e6054e1982$export$2128f49a7cd2e47f || ($9d0284e6054e1982$export$2128f49a7cd2e47f = {}));

});

parcelRegister("37z13", function(module, exports) {

$parcel$export(module.exports, "serializeAws_json1_1GetCredentialsForIdentityCommand", function () { return $245d2ffed0d14e08$export$88af91ae17f8527c; });
$parcel$export(module.exports, "serializeAws_json1_1GetIdCommand", function () { return $245d2ffed0d14e08$export$83083ba13837129b; });
$parcel$export(module.exports, "deserializeAws_json1_1GetCredentialsForIdentityCommand", function () { return $245d2ffed0d14e08$export$ebea9103431f9a50; });
$parcel$export(module.exports, "deserializeAws_json1_1GetIdCommand", function () { return $245d2ffed0d14e08$export$9f5769abdc93f0b4; });

var $lUfmm = parcelRequire("lUfmm");
parcelRequire("1J0sw");
var $jmMP9 = parcelRequire("jmMP9");
var $245d2ffed0d14e08$export$44d8caf684388429 = function(input, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $lUfmm.__generator)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.CreateIdentityPool"
            };
            body = JSON.stringify($245d2ffed0d14e08$var$serializeAws_json1_1CreateIdentityPoolInput(input, context));
            return [
                2 /*return*/ ,
                $245d2ffed0d14e08$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $245d2ffed0d14e08$export$2f9133f6d812a2b4 = function(input, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $lUfmm.__generator)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.DeleteIdentities"
            };
            body = JSON.stringify($245d2ffed0d14e08$var$serializeAws_json1_1DeleteIdentitiesInput(input, context));
            return [
                2 /*return*/ ,
                $245d2ffed0d14e08$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $245d2ffed0d14e08$export$900e66311faca63a = function(input, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $lUfmm.__generator)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.DeleteIdentityPool"
            };
            body = JSON.stringify($245d2ffed0d14e08$var$serializeAws_json1_1DeleteIdentityPoolInput(input, context));
            return [
                2 /*return*/ ,
                $245d2ffed0d14e08$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $245d2ffed0d14e08$export$f0f695bb22170112 = function(input, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $lUfmm.__generator)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.DescribeIdentity"
            };
            body = JSON.stringify($245d2ffed0d14e08$var$serializeAws_json1_1DescribeIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $245d2ffed0d14e08$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $245d2ffed0d14e08$export$24669e6016ff61f7 = function(input, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $lUfmm.__generator)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.DescribeIdentityPool"
            };
            body = JSON.stringify($245d2ffed0d14e08$var$serializeAws_json1_1DescribeIdentityPoolInput(input, context));
            return [
                2 /*return*/ ,
                $245d2ffed0d14e08$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $245d2ffed0d14e08$export$88af91ae17f8527c = function(input, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $lUfmm.__generator)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.GetCredentialsForIdentity"
            };
            body = JSON.stringify($245d2ffed0d14e08$var$serializeAws_json1_1GetCredentialsForIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $245d2ffed0d14e08$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $245d2ffed0d14e08$export$83083ba13837129b = function(input, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $lUfmm.__generator)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.GetId"
            };
            body = JSON.stringify($245d2ffed0d14e08$var$serializeAws_json1_1GetIdInput(input, context));
            return [
                2 /*return*/ ,
                $245d2ffed0d14e08$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $245d2ffed0d14e08$export$291166950901964 = function(input, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $lUfmm.__generator)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.GetIdentityPoolRoles"
            };
            body = JSON.stringify($245d2ffed0d14e08$var$serializeAws_json1_1GetIdentityPoolRolesInput(input, context));
            return [
                2 /*return*/ ,
                $245d2ffed0d14e08$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $245d2ffed0d14e08$export$32ecbc22cb6e2bd8 = function(input, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $lUfmm.__generator)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.GetOpenIdToken"
            };
            body = JSON.stringify($245d2ffed0d14e08$var$serializeAws_json1_1GetOpenIdTokenInput(input, context));
            return [
                2 /*return*/ ,
                $245d2ffed0d14e08$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $245d2ffed0d14e08$export$ace1f9f6edceb0aa = function(input, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $lUfmm.__generator)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.GetOpenIdTokenForDeveloperIdentity"
            };
            body = JSON.stringify($245d2ffed0d14e08$var$serializeAws_json1_1GetOpenIdTokenForDeveloperIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $245d2ffed0d14e08$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $245d2ffed0d14e08$export$dcc2b10f333c963c = function(input, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $lUfmm.__generator)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.ListIdentities"
            };
            body = JSON.stringify($245d2ffed0d14e08$var$serializeAws_json1_1ListIdentitiesInput(input, context));
            return [
                2 /*return*/ ,
                $245d2ffed0d14e08$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $245d2ffed0d14e08$export$dfc0836148ba7f7b = function(input, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $lUfmm.__generator)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.ListIdentityPools"
            };
            body = JSON.stringify($245d2ffed0d14e08$var$serializeAws_json1_1ListIdentityPoolsInput(input, context));
            return [
                2 /*return*/ ,
                $245d2ffed0d14e08$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $245d2ffed0d14e08$export$aea8c8426f72de9a = function(input, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $lUfmm.__generator)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.ListTagsForResource"
            };
            body = JSON.stringify($245d2ffed0d14e08$var$serializeAws_json1_1ListTagsForResourceInput(input, context));
            return [
                2 /*return*/ ,
                $245d2ffed0d14e08$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $245d2ffed0d14e08$export$3ddf979554ffe001 = function(input, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $lUfmm.__generator)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.LookupDeveloperIdentity"
            };
            body = JSON.stringify($245d2ffed0d14e08$var$serializeAws_json1_1LookupDeveloperIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $245d2ffed0d14e08$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $245d2ffed0d14e08$export$5d3f7522269fe239 = function(input, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $lUfmm.__generator)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.MergeDeveloperIdentities"
            };
            body = JSON.stringify($245d2ffed0d14e08$var$serializeAws_json1_1MergeDeveloperIdentitiesInput(input, context));
            return [
                2 /*return*/ ,
                $245d2ffed0d14e08$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $245d2ffed0d14e08$export$50298d3eb327ab40 = function(input, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $lUfmm.__generator)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.SetIdentityPoolRoles"
            };
            body = JSON.stringify($245d2ffed0d14e08$var$serializeAws_json1_1SetIdentityPoolRolesInput(input, context));
            return [
                2 /*return*/ ,
                $245d2ffed0d14e08$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $245d2ffed0d14e08$export$be03555111349623 = function(input, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $lUfmm.__generator)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.TagResource"
            };
            body = JSON.stringify($245d2ffed0d14e08$var$serializeAws_json1_1TagResourceInput(input, context));
            return [
                2 /*return*/ ,
                $245d2ffed0d14e08$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $245d2ffed0d14e08$export$43e326e2b54f124a = function(input, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $lUfmm.__generator)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.UnlinkDeveloperIdentity"
            };
            body = JSON.stringify($245d2ffed0d14e08$var$serializeAws_json1_1UnlinkDeveloperIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $245d2ffed0d14e08$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $245d2ffed0d14e08$export$4ee03f1a7a9d5800 = function(input, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $lUfmm.__generator)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.UnlinkIdentity"
            };
            body = JSON.stringify($245d2ffed0d14e08$var$serializeAws_json1_1UnlinkIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $245d2ffed0d14e08$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $245d2ffed0d14e08$export$3f5f89d1d8515037 = function(input, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $lUfmm.__generator)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.UntagResource"
            };
            body = JSON.stringify($245d2ffed0d14e08$var$serializeAws_json1_1UntagResourceInput(input, context));
            return [
                2 /*return*/ ,
                $245d2ffed0d14e08$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $245d2ffed0d14e08$export$7a962066e209647 = function(input, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $lUfmm.__generator)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.UpdateIdentityPool"
            };
            body = JSON.stringify($245d2ffed0d14e08$var$serializeAws_json1_1IdentityPool(input, context));
            return [
                2 /*return*/ ,
                $245d2ffed0d14e08$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $245d2ffed0d14e08$export$2065e670c73ee068 = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $lUfmm.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1CreateIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $245d2ffed0d14e08$var$deserializeAws_json1_1IdentityPool(data, context);
                    response = (0, $lUfmm.__assign)({
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1CreateIdentityPoolCommandError = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $lUfmm.__generator)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $lUfmm.__assign)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $lUfmm.__assign).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$export$a14663734e0f26e7 = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $lUfmm.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1DeleteIdentitiesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $245d2ffed0d14e08$var$deserializeAws_json1_1DeleteIdentitiesResponse(data, context);
                    response = (0, $lUfmm.__assign)({
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1DeleteIdentitiesCommandError = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, $lUfmm.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, $lUfmm.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $lUfmm.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$export$77baf36526f7cd7e = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, $lUfmm.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1DeleteIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1DeleteIdentityPoolCommandError = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $lUfmm.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $lUfmm.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $lUfmm.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$export$1863cd4cff27fb2f = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $lUfmm.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1DescribeIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $245d2ffed0d14e08$var$deserializeAws_json1_1IdentityDescription(data, context);
                    response = (0, $lUfmm.__assign)({
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1DescribeIdentityCommandError = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $lUfmm.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $lUfmm.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $lUfmm.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$export$1457f79b69c648d1 = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $lUfmm.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1DescribeIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $245d2ffed0d14e08$var$deserializeAws_json1_1IdentityPool(data, context);
                    response = (0, $lUfmm.__assign)({
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1DescribeIdentityPoolCommandError = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $lUfmm.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $lUfmm.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $lUfmm.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$export$ebea9103431f9a50 = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $lUfmm.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1GetCredentialsForIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $245d2ffed0d14e08$var$deserializeAws_json1_1GetCredentialsForIdentityResponse(data, context);
                    response = (0, $lUfmm.__assign)({
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1GetCredentialsForIdentityCommandError = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, _j, _k, parsedBody, message;
        var _l;
        return (0, $lUfmm.__generator)(this, function(_m) {
            switch(_m.label){
                case 0:
                    _a = [
                        (0, $lUfmm.__assign)({}, output)
                    ];
                    _l = {};
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $lUfmm.__assign).apply(void 0, _a.concat([
                        (_l.body = _m.sent(), _l)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidIdentityPoolConfigurationException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidIdentityPoolConfigurationException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _c.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _d.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _e.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _f.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _g.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _h.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _j.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _k.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 18:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    });
                    _m.label = 19;
                case 19:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$export$9f5769abdc93f0b4 = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $lUfmm.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1GetIdCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $245d2ffed0d14e08$var$deserializeAws_json1_1GetIdResponse(data, context);
                    response = (0, $lUfmm.__assign)({
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1GetIdCommandError = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, _j, _k, parsedBody, message;
        var _l;
        return (0, $lUfmm.__generator)(this, function(_m) {
            switch(_m.label){
                case 0:
                    _a = [
                        (0, $lUfmm.__assign)({}, output)
                    ];
                    _l = {};
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $lUfmm.__assign).apply(void 0, _a.concat([
                        (_l.body = _m.sent(), _l)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _c.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _d.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _e.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _f.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _g.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _h.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _j.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _k.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 18:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    });
                    _m.label = 19;
                case 19:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$export$731e618e28a38bab = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $lUfmm.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1GetIdentityPoolRolesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $245d2ffed0d14e08$var$deserializeAws_json1_1GetIdentityPoolRolesResponse(data, context);
                    response = (0, $lUfmm.__assign)({
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1GetIdentityPoolRolesCommandError = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $lUfmm.__generator)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $lUfmm.__assign)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $lUfmm.__assign).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$export$ccfef68aa75a7c47 = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $lUfmm.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1GetOpenIdTokenCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $245d2ffed0d14e08$var$deserializeAws_json1_1GetOpenIdTokenResponse(data, context);
                    response = (0, $lUfmm.__assign)({
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1GetOpenIdTokenCommandError = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $lUfmm.__generator)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $lUfmm.__assign)({}, output)
                    ];
                    _k = {};
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $lUfmm.__assign).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$export$c7916ef0d543f5e3 = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $lUfmm.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $245d2ffed0d14e08$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityResponse(data, context);
                    response = (0, $lUfmm.__assign)({
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommandError = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $lUfmm.__generator)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $lUfmm.__assign)({}, output)
                    ];
                    _k = {};
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $lUfmm.__assign).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "DeveloperUserAlreadyRegisteredException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#DeveloperUserAlreadyRegisteredException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$export$a2439911ac8089ba = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $lUfmm.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ListIdentitiesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $245d2ffed0d14e08$var$deserializeAws_json1_1ListIdentitiesResponse(data, context);
                    response = (0, $lUfmm.__assign)({
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1ListIdentitiesCommandError = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $lUfmm.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $lUfmm.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $lUfmm.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$export$36b32c966a7eefbd = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $lUfmm.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ListIdentityPoolsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $245d2ffed0d14e08$var$deserializeAws_json1_1ListIdentityPoolsResponse(data, context);
                    response = (0, $lUfmm.__assign)({
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1ListIdentityPoolsCommandError = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $lUfmm.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $lUfmm.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $lUfmm.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$export$efb57976dadbc12b = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $lUfmm.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ListTagsForResourceCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $245d2ffed0d14e08$var$deserializeAws_json1_1ListTagsForResourceResponse(data, context);
                    response = (0, $lUfmm.__assign)({
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1ListTagsForResourceCommandError = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $lUfmm.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $lUfmm.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $lUfmm.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$export$6476ab94d95217ab = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $lUfmm.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1LookupDeveloperIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $245d2ffed0d14e08$var$deserializeAws_json1_1LookupDeveloperIdentityResponse(data, context);
                    response = (0, $lUfmm.__assign)({
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1LookupDeveloperIdentityCommandError = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $lUfmm.__generator)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $lUfmm.__assign)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $lUfmm.__assign).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$export$73edba62ad60e9b9 = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $lUfmm.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1MergeDeveloperIdentitiesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $245d2ffed0d14e08$var$deserializeAws_json1_1MergeDeveloperIdentitiesResponse(data, context);
                    response = (0, $lUfmm.__assign)({
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1MergeDeveloperIdentitiesCommandError = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $lUfmm.__generator)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $lUfmm.__assign)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $lUfmm.__assign).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$export$4d01436d85148f27 = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, $lUfmm.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1SetIdentityPoolRolesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1SetIdentityPoolRolesCommandError = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $lUfmm.__generator)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $lUfmm.__assign)({}, output)
                    ];
                    _k = {};
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $lUfmm.__assign).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ConcurrentModificationExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$export$2bbf6fe70d6779a6 = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $lUfmm.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1TagResourceCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $245d2ffed0d14e08$var$deserializeAws_json1_1TagResourceResponse(data, context);
                    response = (0, $lUfmm.__assign)({
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1TagResourceCommandError = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $lUfmm.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $lUfmm.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $lUfmm.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$export$d8ee329529310a85 = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, $lUfmm.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1UnlinkDeveloperIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1UnlinkDeveloperIdentityCommandError = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $lUfmm.__generator)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $lUfmm.__assign)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $lUfmm.__assign).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$export$b3b4038b9cc6cf0c = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, $lUfmm.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1UnlinkIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1UnlinkIdentityCommandError = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $lUfmm.__generator)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $lUfmm.__assign)({}, output)
                    ];
                    _k = {};
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $lUfmm.__assign).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$export$4e56caf614610ee8 = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $lUfmm.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1UntagResourceCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $245d2ffed0d14e08$var$deserializeAws_json1_1UntagResourceResponse(data, context);
                    response = (0, $lUfmm.__assign)({
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1UntagResourceCommandError = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $lUfmm.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $lUfmm.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $lUfmm.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$export$e9cc2af0cb85eeaa = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $lUfmm.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1UpdateIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $245d2ffed0d14e08$var$deserializeAws_json1_1IdentityPool(data, context);
                    response = (0, $lUfmm.__assign)({
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1UpdateIdentityPoolCommandError = function(output, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, _j, _k, parsedBody, message;
        var _l;
        return (0, $lUfmm.__generator)(this, function(_m) {
            switch(_m.label){
                case 0:
                    _a = [
                        (0, $lUfmm.__assign)({}, output)
                    ];
                    _l = {};
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $lUfmm.__assign).apply(void 0, _a.concat([
                        (_l.body = _m.sent(), _l)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ConcurrentModificationExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _c.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _d.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _e.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _f.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _g.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _h.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _j.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, $lUfmm.__assign).apply(void 0, [
                        (0, $lUfmm.__assign).apply(void 0, _k.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 18:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $245d2ffed0d14e08$var$deserializeMetadata(output)
                    });
                    _m.label = 19;
                case 19:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1ConcurrentModificationExceptionResponse = function(parsedOutput, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $lUfmm.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $245d2ffed0d14e08$var$deserializeAws_json1_1ConcurrentModificationException(body, context);
            contents = (0, $lUfmm.__assign)({
                name: "ConcurrentModificationException",
                $fault: "client",
                $metadata: $245d2ffed0d14e08$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredExceptionResponse = function(parsedOutput, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $lUfmm.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $245d2ffed0d14e08$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredException(body, context);
            contents = (0, $lUfmm.__assign)({
                name: "DeveloperUserAlreadyRegisteredException",
                $fault: "client",
                $metadata: $245d2ffed0d14e08$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1ExternalServiceExceptionResponse = function(parsedOutput, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $lUfmm.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $245d2ffed0d14e08$var$deserializeAws_json1_1ExternalServiceException(body, context);
            contents = (0, $lUfmm.__assign)({
                name: "ExternalServiceException",
                $fault: "client",
                $metadata: $245d2ffed0d14e08$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorExceptionResponse = function(parsedOutput, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $lUfmm.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorException(body, context);
            contents = (0, $lUfmm.__assign)({
                name: "InternalErrorException",
                $fault: "server",
                $metadata: $245d2ffed0d14e08$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationExceptionResponse = function(parsedOutput, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $lUfmm.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationException(body, context);
            contents = (0, $lUfmm.__assign)({
                name: "InvalidIdentityPoolConfigurationException",
                $fault: "client",
                $metadata: $245d2ffed0d14e08$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterExceptionResponse = function(parsedOutput, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $lUfmm.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterException(body, context);
            contents = (0, $lUfmm.__assign)({
                name: "InvalidParameterException",
                $fault: "client",
                $metadata: $245d2ffed0d14e08$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1LimitExceededExceptionResponse = function(parsedOutput, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $lUfmm.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $245d2ffed0d14e08$var$deserializeAws_json1_1LimitExceededException(body, context);
            contents = (0, $lUfmm.__assign)({
                name: "LimitExceededException",
                $fault: "client",
                $metadata: $245d2ffed0d14e08$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedExceptionResponse = function(parsedOutput, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $lUfmm.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedException(body, context);
            contents = (0, $lUfmm.__assign)({
                name: "NotAuthorizedException",
                $fault: "client",
                $metadata: $245d2ffed0d14e08$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceConflictExceptionResponse = function(parsedOutput, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $lUfmm.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceConflictException(body, context);
            contents = (0, $lUfmm.__assign)({
                name: "ResourceConflictException",
                $fault: "client",
                $metadata: $245d2ffed0d14e08$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $lUfmm.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceNotFoundException(body, context);
            contents = (0, $lUfmm.__assign)({
                name: "ResourceNotFoundException",
                $fault: "client",
                $metadata: $245d2ffed0d14e08$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsExceptionResponse = function(parsedOutput, context) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $lUfmm.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsException(body, context);
            contents = (0, $lUfmm.__assign)({
                name: "TooManyRequestsException",
                $fault: "client",
                $metadata: $245d2ffed0d14e08$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1CognitoIdentityProvider = function(input, context) {
    return (0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, input.ClientId !== undefined && {
        ClientId: input.ClientId
    }), input.ProviderName !== undefined && {
        ProviderName: input.ProviderName
    }), input.ServerSideTokenCheck !== undefined && {
        ServerSideTokenCheck: input.ServerSideTokenCheck
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1CognitoIdentityProviderList = function(input, context) {
    return input.map(function(entry) {
        return $245d2ffed0d14e08$var$serializeAws_json1_1CognitoIdentityProvider(entry, context);
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1CreateIdentityPoolInput = function(input, context) {
    return (0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, input.AllowClassicFlow !== undefined && {
        AllowClassicFlow: input.AllowClassicFlow
    }), input.AllowUnauthenticatedIdentities !== undefined && {
        AllowUnauthenticatedIdentities: input.AllowUnauthenticatedIdentities
    }), input.CognitoIdentityProviders !== undefined && {
        CognitoIdentityProviders: $245d2ffed0d14e08$var$serializeAws_json1_1CognitoIdentityProviderList(input.CognitoIdentityProviders, context)
    }), input.DeveloperProviderName !== undefined && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.IdentityPoolName !== undefined && {
        IdentityPoolName: input.IdentityPoolName
    }), input.IdentityPoolTags !== undefined && {
        IdentityPoolTags: $245d2ffed0d14e08$var$serializeAws_json1_1IdentityPoolTagsType(input.IdentityPoolTags, context)
    }), input.OpenIdConnectProviderARNs !== undefined && {
        OpenIdConnectProviderARNs: $245d2ffed0d14e08$var$serializeAws_json1_1OIDCProviderList(input.OpenIdConnectProviderARNs, context)
    }), input.SamlProviderARNs !== undefined && {
        SamlProviderARNs: $245d2ffed0d14e08$var$serializeAws_json1_1SAMLProviderList(input.SamlProviderARNs, context)
    }), input.SupportedLoginProviders !== undefined && {
        SupportedLoginProviders: $245d2ffed0d14e08$var$serializeAws_json1_1IdentityProviders(input.SupportedLoginProviders, context)
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1DeleteIdentitiesInput = function(input, context) {
    return (0, $lUfmm.__assign)({}, input.IdentityIdsToDelete !== undefined && {
        IdentityIdsToDelete: $245d2ffed0d14e08$var$serializeAws_json1_1IdentityIdList(input.IdentityIdsToDelete, context)
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1DeleteIdentityPoolInput = function(input, context) {
    return (0, $lUfmm.__assign)({}, input.IdentityPoolId !== undefined && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1DescribeIdentityInput = function(input, context) {
    return (0, $lUfmm.__assign)({}, input.IdentityId !== undefined && {
        IdentityId: input.IdentityId
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1DescribeIdentityPoolInput = function(input, context) {
    return (0, $lUfmm.__assign)({}, input.IdentityPoolId !== undefined && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1GetCredentialsForIdentityInput = function(input, context) {
    return (0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, input.CustomRoleArn !== undefined && {
        CustomRoleArn: input.CustomRoleArn
    }), input.IdentityId !== undefined && {
        IdentityId: input.IdentityId
    }), input.Logins !== undefined && {
        Logins: $245d2ffed0d14e08$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1GetIdentityPoolRolesInput = function(input, context) {
    return (0, $lUfmm.__assign)({}, input.IdentityPoolId !== undefined && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1GetIdInput = function(input, context) {
    return (0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, input.AccountId !== undefined && {
        AccountId: input.AccountId
    }), input.IdentityPoolId !== undefined && {
        IdentityPoolId: input.IdentityPoolId
    }), input.Logins !== undefined && {
        Logins: $245d2ffed0d14e08$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1GetOpenIdTokenForDeveloperIdentityInput = function(input, context) {
    return (0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, input.IdentityId !== undefined && {
        IdentityId: input.IdentityId
    }), input.IdentityPoolId !== undefined && {
        IdentityPoolId: input.IdentityPoolId
    }), input.Logins !== undefined && {
        Logins: $245d2ffed0d14e08$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    }), input.TokenDuration !== undefined && {
        TokenDuration: input.TokenDuration
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1GetOpenIdTokenInput = function(input, context) {
    return (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, input.IdentityId !== undefined && {
        IdentityId: input.IdentityId
    }), input.Logins !== undefined && {
        Logins: $245d2ffed0d14e08$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1IdentityIdList = function(input, context) {
    return input.map(function(entry) {
        return entry;
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1IdentityPool = function(input, context) {
    return (0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, input.AllowClassicFlow !== undefined && {
        AllowClassicFlow: input.AllowClassicFlow
    }), input.AllowUnauthenticatedIdentities !== undefined && {
        AllowUnauthenticatedIdentities: input.AllowUnauthenticatedIdentities
    }), input.CognitoIdentityProviders !== undefined && {
        CognitoIdentityProviders: $245d2ffed0d14e08$var$serializeAws_json1_1CognitoIdentityProviderList(input.CognitoIdentityProviders, context)
    }), input.DeveloperProviderName !== undefined && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.IdentityPoolId !== undefined && {
        IdentityPoolId: input.IdentityPoolId
    }), input.IdentityPoolName !== undefined && {
        IdentityPoolName: input.IdentityPoolName
    }), input.IdentityPoolTags !== undefined && {
        IdentityPoolTags: $245d2ffed0d14e08$var$serializeAws_json1_1IdentityPoolTagsType(input.IdentityPoolTags, context)
    }), input.OpenIdConnectProviderARNs !== undefined && {
        OpenIdConnectProviderARNs: $245d2ffed0d14e08$var$serializeAws_json1_1OIDCProviderList(input.OpenIdConnectProviderARNs, context)
    }), input.SamlProviderARNs !== undefined && {
        SamlProviderARNs: $245d2ffed0d14e08$var$serializeAws_json1_1SAMLProviderList(input.SamlProviderARNs, context)
    }), input.SupportedLoginProviders !== undefined && {
        SupportedLoginProviders: $245d2ffed0d14e08$var$serializeAws_json1_1IdentityProviders(input.SupportedLoginProviders, context)
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1IdentityPoolTagsListType = function(input, context) {
    return input.map(function(entry) {
        return entry;
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1IdentityPoolTagsType = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $lUfmm.__read)(_a, 2), key = _c[0], value = _c[1];
        return (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $245d2ffed0d14e08$var$serializeAws_json1_1IdentityProviders = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $lUfmm.__read)(_a, 2), key = _c[0], value = _c[1];
        return (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $245d2ffed0d14e08$var$serializeAws_json1_1ListIdentitiesInput = function(input, context) {
    return (0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, input.HideDisabled !== undefined && {
        HideDisabled: input.HideDisabled
    }), input.IdentityPoolId !== undefined && {
        IdentityPoolId: input.IdentityPoolId
    }), input.MaxResults !== undefined && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && {
        NextToken: input.NextToken
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1ListIdentityPoolsInput = function(input, context) {
    return (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, input.MaxResults !== undefined && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && {
        NextToken: input.NextToken
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1ListTagsForResourceInput = function(input, context) {
    return (0, $lUfmm.__assign)({}, input.ResourceArn !== undefined && {
        ResourceArn: input.ResourceArn
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1LoginsList = function(input, context) {
    return input.map(function(entry) {
        return entry;
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1LoginsMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $lUfmm.__read)(_a, 2), key = _c[0], value = _c[1];
        return (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $245d2ffed0d14e08$var$serializeAws_json1_1LookupDeveloperIdentityInput = function(input, context) {
    return (0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, input.DeveloperUserIdentifier !== undefined && {
        DeveloperUserIdentifier: input.DeveloperUserIdentifier
    }), input.IdentityId !== undefined && {
        IdentityId: input.IdentityId
    }), input.IdentityPoolId !== undefined && {
        IdentityPoolId: input.IdentityPoolId
    }), input.MaxResults !== undefined && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && {
        NextToken: input.NextToken
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1MappingRule = function(input, context) {
    return (0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, input.Claim !== undefined && {
        Claim: input.Claim
    }), input.MatchType !== undefined && {
        MatchType: input.MatchType
    }), input.RoleARN !== undefined && {
        RoleARN: input.RoleARN
    }), input.Value !== undefined && {
        Value: input.Value
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1MappingRulesList = function(input, context) {
    return input.map(function(entry) {
        return $245d2ffed0d14e08$var$serializeAws_json1_1MappingRule(entry, context);
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1MergeDeveloperIdentitiesInput = function(input, context) {
    return (0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, input.DestinationUserIdentifier !== undefined && {
        DestinationUserIdentifier: input.DestinationUserIdentifier
    }), input.DeveloperProviderName !== undefined && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.IdentityPoolId !== undefined && {
        IdentityPoolId: input.IdentityPoolId
    }), input.SourceUserIdentifier !== undefined && {
        SourceUserIdentifier: input.SourceUserIdentifier
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1OIDCProviderList = function(input, context) {
    return input.map(function(entry) {
        return entry;
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1RoleMapping = function(input, context) {
    return (0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, input.AmbiguousRoleResolution !== undefined && {
        AmbiguousRoleResolution: input.AmbiguousRoleResolution
    }), input.RulesConfiguration !== undefined && {
        RulesConfiguration: $245d2ffed0d14e08$var$serializeAws_json1_1RulesConfigurationType(input.RulesConfiguration, context)
    }), input.Type !== undefined && {
        Type: input.Type
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1RoleMappingMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $lUfmm.__read)(_a, 2), key = _c[0], value = _c[1];
        return (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, acc), (_b = {}, _b[key] = $245d2ffed0d14e08$var$serializeAws_json1_1RoleMapping(value, context), _b));
    }, {});
};
var $245d2ffed0d14e08$var$serializeAws_json1_1RolesMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $lUfmm.__read)(_a, 2), key = _c[0], value = _c[1];
        return (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $245d2ffed0d14e08$var$serializeAws_json1_1RulesConfigurationType = function(input, context) {
    return (0, $lUfmm.__assign)({}, input.Rules !== undefined && {
        Rules: $245d2ffed0d14e08$var$serializeAws_json1_1MappingRulesList(input.Rules, context)
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1SAMLProviderList = function(input, context) {
    return input.map(function(entry) {
        return entry;
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1SetIdentityPoolRolesInput = function(input, context) {
    return (0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, input.IdentityPoolId !== undefined && {
        IdentityPoolId: input.IdentityPoolId
    }), input.RoleMappings !== undefined && {
        RoleMappings: $245d2ffed0d14e08$var$serializeAws_json1_1RoleMappingMap(input.RoleMappings, context)
    }), input.Roles !== undefined && {
        Roles: $245d2ffed0d14e08$var$serializeAws_json1_1RolesMap(input.Roles, context)
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1TagResourceInput = function(input, context) {
    return (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, input.ResourceArn !== undefined && {
        ResourceArn: input.ResourceArn
    }), input.Tags !== undefined && {
        Tags: $245d2ffed0d14e08$var$serializeAws_json1_1IdentityPoolTagsType(input.Tags, context)
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1UnlinkDeveloperIdentityInput = function(input, context) {
    return (0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, input.DeveloperProviderName !== undefined && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.DeveloperUserIdentifier !== undefined && {
        DeveloperUserIdentifier: input.DeveloperUserIdentifier
    }), input.IdentityId !== undefined && {
        IdentityId: input.IdentityId
    }), input.IdentityPoolId !== undefined && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1UnlinkIdentityInput = function(input, context) {
    return (0, $lUfmm.__assign)((0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, input.IdentityId !== undefined && {
        IdentityId: input.IdentityId
    }), input.Logins !== undefined && {
        Logins: $245d2ffed0d14e08$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    }), input.LoginsToRemove !== undefined && {
        LoginsToRemove: $245d2ffed0d14e08$var$serializeAws_json1_1LoginsList(input.LoginsToRemove, context)
    });
};
var $245d2ffed0d14e08$var$serializeAws_json1_1UntagResourceInput = function(input, context) {
    return (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, input.ResourceArn !== undefined && {
        ResourceArn: input.ResourceArn
    }), input.TagKeys !== undefined && {
        TagKeys: $245d2ffed0d14e08$var$serializeAws_json1_1IdentityPoolTagsListType(input.TagKeys, context)
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1CognitoIdentityProvider = function(output, context) {
    return {
        ClientId: output.ClientId !== undefined && output.ClientId !== null ? output.ClientId : undefined,
        ProviderName: output.ProviderName !== undefined && output.ProviderName !== null ? output.ProviderName : undefined,
        ServerSideTokenCheck: output.ServerSideTokenCheck !== undefined && output.ServerSideTokenCheck !== null ? output.ServerSideTokenCheck : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1CognitoIdentityProviderList = function(output, context) {
    return (output || []).map(function(entry) {
        return $245d2ffed0d14e08$var$deserializeAws_json1_1CognitoIdentityProvider(entry, context);
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1ConcurrentModificationException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1Credentials = function(output, context) {
    return {
        AccessKeyId: output.AccessKeyId !== undefined && output.AccessKeyId !== null ? output.AccessKeyId : undefined,
        Expiration: output.Expiration !== undefined && output.Expiration !== null ? new Date(Math.round(output.Expiration * 1000)) : undefined,
        SecretKey: output.SecretKey !== undefined && output.SecretKey !== null ? output.SecretKey : undefined,
        SessionToken: output.SessionToken !== undefined && output.SessionToken !== null ? output.SessionToken : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1DeleteIdentitiesResponse = function(output, context) {
    return {
        UnprocessedIdentityIds: output.UnprocessedIdentityIds !== undefined && output.UnprocessedIdentityIds !== null ? $245d2ffed0d14e08$var$deserializeAws_json1_1UnprocessedIdentityIdList(output.UnprocessedIdentityIds, context) : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1DeveloperUserIdentifierList = function(output, context) {
    return (output || []).map(function(entry) {
        return entry;
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1ExternalServiceException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1GetCredentialsForIdentityResponse = function(output, context) {
    return {
        Credentials: output.Credentials !== undefined && output.Credentials !== null ? $245d2ffed0d14e08$var$deserializeAws_json1_1Credentials(output.Credentials, context) : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1GetIdentityPoolRolesResponse = function(output, context) {
    return {
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        RoleMappings: output.RoleMappings !== undefined && output.RoleMappings !== null ? $245d2ffed0d14e08$var$deserializeAws_json1_1RoleMappingMap(output.RoleMappings, context) : undefined,
        Roles: output.Roles !== undefined && output.Roles !== null ? $245d2ffed0d14e08$var$deserializeAws_json1_1RolesMap(output.Roles, context) : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1GetIdResponse = function(output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityResponse = function(output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        Token: output.Token !== undefined && output.Token !== null ? output.Token : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1GetOpenIdTokenResponse = function(output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        Token: output.Token !== undefined && output.Token !== null ? output.Token : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1IdentitiesList = function(output, context) {
    return (output || []).map(function(entry) {
        return $245d2ffed0d14e08$var$deserializeAws_json1_1IdentityDescription(entry, context);
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1IdentityDescription = function(output, context) {
    return {
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null ? new Date(Math.round(output.CreationDate * 1000)) : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null ? new Date(Math.round(output.LastModifiedDate * 1000)) : undefined,
        Logins: output.Logins !== undefined && output.Logins !== null ? $245d2ffed0d14e08$var$deserializeAws_json1_1LoginsList(output.Logins, context) : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1IdentityPool = function(output, context) {
    return {
        AllowClassicFlow: output.AllowClassicFlow !== undefined && output.AllowClassicFlow !== null ? output.AllowClassicFlow : undefined,
        AllowUnauthenticatedIdentities: output.AllowUnauthenticatedIdentities !== undefined && output.AllowUnauthenticatedIdentities !== null ? output.AllowUnauthenticatedIdentities : undefined,
        CognitoIdentityProviders: output.CognitoIdentityProviders !== undefined && output.CognitoIdentityProviders !== null ? $245d2ffed0d14e08$var$deserializeAws_json1_1CognitoIdentityProviderList(output.CognitoIdentityProviders, context) : undefined,
        DeveloperProviderName: output.DeveloperProviderName !== undefined && output.DeveloperProviderName !== null ? output.DeveloperProviderName : undefined,
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        IdentityPoolName: output.IdentityPoolName !== undefined && output.IdentityPoolName !== null ? output.IdentityPoolName : undefined,
        IdentityPoolTags: output.IdentityPoolTags !== undefined && output.IdentityPoolTags !== null ? $245d2ffed0d14e08$var$deserializeAws_json1_1IdentityPoolTagsType(output.IdentityPoolTags, context) : undefined,
        OpenIdConnectProviderARNs: output.OpenIdConnectProviderARNs !== undefined && output.OpenIdConnectProviderARNs !== null ? $245d2ffed0d14e08$var$deserializeAws_json1_1OIDCProviderList(output.OpenIdConnectProviderARNs, context) : undefined,
        SamlProviderARNs: output.SamlProviderARNs !== undefined && output.SamlProviderARNs !== null ? $245d2ffed0d14e08$var$deserializeAws_json1_1SAMLProviderList(output.SamlProviderARNs, context) : undefined,
        SupportedLoginProviders: output.SupportedLoginProviders !== undefined && output.SupportedLoginProviders !== null ? $245d2ffed0d14e08$var$deserializeAws_json1_1IdentityProviders(output.SupportedLoginProviders, context) : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1IdentityPoolShortDescription = function(output, context) {
    return {
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        IdentityPoolName: output.IdentityPoolName !== undefined && output.IdentityPoolName !== null ? output.IdentityPoolName : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1IdentityPoolsList = function(output, context) {
    return (output || []).map(function(entry) {
        return $245d2ffed0d14e08$var$deserializeAws_json1_1IdentityPoolShortDescription(entry, context);
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1IdentityPoolTagsType = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $lUfmm.__read)(_a, 2), key = _c[0], value = _c[1];
        return (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1IdentityProviders = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $lUfmm.__read)(_a, 2), key = _c[0], value = _c[1];
        return (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1InternalErrorException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1InvalidParameterException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1LimitExceededException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1ListIdentitiesResponse = function(output, context) {
    return {
        Identities: output.Identities !== undefined && output.Identities !== null ? $245d2ffed0d14e08$var$deserializeAws_json1_1IdentitiesList(output.Identities, context) : undefined,
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1ListIdentityPoolsResponse = function(output, context) {
    return {
        IdentityPools: output.IdentityPools !== undefined && output.IdentityPools !== null ? $245d2ffed0d14e08$var$deserializeAws_json1_1IdentityPoolsList(output.IdentityPools, context) : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1ListTagsForResourceResponse = function(output, context) {
    return {
        Tags: output.Tags !== undefined && output.Tags !== null ? $245d2ffed0d14e08$var$deserializeAws_json1_1IdentityPoolTagsType(output.Tags, context) : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1LoginsList = function(output, context) {
    return (output || []).map(function(entry) {
        return entry;
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1LookupDeveloperIdentityResponse = function(output, context) {
    return {
        DeveloperUserIdentifierList: output.DeveloperUserIdentifierList !== undefined && output.DeveloperUserIdentifierList !== null ? $245d2ffed0d14e08$var$deserializeAws_json1_1DeveloperUserIdentifierList(output.DeveloperUserIdentifierList, context) : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1MappingRule = function(output, context) {
    return {
        Claim: output.Claim !== undefined && output.Claim !== null ? output.Claim : undefined,
        MatchType: output.MatchType !== undefined && output.MatchType !== null ? output.MatchType : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        Value: output.Value !== undefined && output.Value !== null ? output.Value : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1MappingRulesList = function(output, context) {
    return (output || []).map(function(entry) {
        return $245d2ffed0d14e08$var$deserializeAws_json1_1MappingRule(entry, context);
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1MergeDeveloperIdentitiesResponse = function(output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1NotAuthorizedException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1OIDCProviderList = function(output, context) {
    return (output || []).map(function(entry) {
        return entry;
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceConflictException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1ResourceNotFoundException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1RoleMapping = function(output, context) {
    return {
        AmbiguousRoleResolution: output.AmbiguousRoleResolution !== undefined && output.AmbiguousRoleResolution !== null ? output.AmbiguousRoleResolution : undefined,
        RulesConfiguration: output.RulesConfiguration !== undefined && output.RulesConfiguration !== null ? $245d2ffed0d14e08$var$deserializeAws_json1_1RulesConfigurationType(output.RulesConfiguration, context) : undefined,
        Type: output.Type !== undefined && output.Type !== null ? output.Type : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1RoleMappingMap = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $lUfmm.__read)(_a, 2), key = _c[0], value = _c[1];
        return (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, acc), (_b = {}, _b[key] = $245d2ffed0d14e08$var$deserializeAws_json1_1RoleMapping(value, context), _b));
    }, {});
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1RolesMap = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $lUfmm.__read)(_a, 2), key = _c[0], value = _c[1];
        return (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1RulesConfigurationType = function(output, context) {
    return {
        Rules: output.Rules !== undefined && output.Rules !== null ? $245d2ffed0d14e08$var$deserializeAws_json1_1MappingRulesList(output.Rules, context) : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1SAMLProviderList = function(output, context) {
    return (output || []).map(function(entry) {
        return entry;
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1TagResourceResponse = function(output, context) {
    return {};
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1TooManyRequestsException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1UnprocessedIdentityId = function(output, context) {
    return {
        ErrorCode: output.ErrorCode !== undefined && output.ErrorCode !== null ? output.ErrorCode : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined
    };
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1UnprocessedIdentityIdList = function(output, context) {
    return (output || []).map(function(entry) {
        return $245d2ffed0d14e08$var$deserializeAws_json1_1UnprocessedIdentityId(entry, context);
    });
};
var $245d2ffed0d14e08$var$deserializeAws_json1_1UntagResourceResponse = function(output, context) {
    return {};
};
var $245d2ffed0d14e08$var$deserializeMetadata = function(output) {
    return {
        httpStatusCode: output.statusCode,
        httpHeaders: output.headers,
        requestId: output.headers["x-amzn-requestid"]
    };
};
// Collect low-level response body stream to Uint8Array.
var $245d2ffed0d14e08$var$collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var $245d2ffed0d14e08$var$collectBodyString = function(streamBody, context) {
    return $245d2ffed0d14e08$var$collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var $245d2ffed0d14e08$var$buildHttpRpcRequest = function(context, headers, path, resolvedHostname, body) {
    return (0, $lUfmm.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, contents;
        return (0, $lUfmm.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    contents = {
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        path: path,
                        headers: headers
                    };
                    if (resolvedHostname !== undefined) contents.hostname = resolvedHostname;
                    if (body !== undefined) contents.body = body;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)(contents)
                    ];
            }
        });
    });
};
var $245d2ffed0d14e08$var$parseBody = function(streamBody, context) {
    return $245d2ffed0d14e08$var$collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};

});
parcelRegister("1J0sw", function(module, exports) {
$parcel$export(module.exports, "HttpResponse", function () { return (parcelRequire("cC0dr")).HttpResponse; });
$parcel$export(module.exports, "HttpRequest", function () { return (parcelRequire("jmMP9")).HttpRequest; });
parcelRequire("cC0dr");
parcelRequire("jmMP9");
parcelRequire("vM1w4");
parcelRequire("8Jwxc");

});
parcelRegister("cC0dr", function(module, exports) {

$parcel$export(module.exports, "HttpResponse", function () { return $92e9337e22eb406f$export$1d94dfe0d9d1f1e7; });
var $92e9337e22eb406f$export$1d94dfe0d9d1f1e7 = /** @class */ function() {
    function HttpResponse(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    HttpResponse.isInstance = function(response) {
        //determine if response is a valid HttpResponse
        if (!response) return false;
        var resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    };
    return HttpResponse;
}();

});

parcelRegister("jmMP9", function(module, exports) {

$parcel$export(module.exports, "HttpRequest", function () { return $e195f1d5c2e542c5$export$7587955500404ec3; });

var $fH1jI = parcelRequire("fH1jI");
var $e195f1d5c2e542c5$export$7587955500404ec3 = /** @class */ function() {
    function HttpRequest(options) {
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.substr(-1) !== ":" ? options.protocol + ":" : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? "/" + options.path : options.path : "/";
    }
    HttpRequest.isInstance = function(request) {
        //determine if request is a valid httpRequest
        if (!request) return false;
        var req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    };
    HttpRequest.prototype.clone = function() {
        var cloned = new HttpRequest((0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, this), {
            headers: (0, $fH1jI.__assign)({}, this.headers)
        }));
        if (cloned.query) cloned.query = $e195f1d5c2e542c5$var$cloneQuery(cloned.query);
        return cloned;
    };
    return HttpRequest;
}();
function $e195f1d5c2e542c5$var$cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, $fH1jI.__spread)(param) : param, _a));
    }, {});
}

});

parcelRegister("vM1w4", function(module, exports) {

});

parcelRegister("8Jwxc", function(module, exports) {
function $65bbc3618ae0007f$export$e024c793399bdd01(hostname) {
    var hostPattern = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
    return hostPattern.test(hostname);
}

});



parcelRegister("5Wom8", function(module, exports) {
$parcel$export(module.exports, "getSerdePlugin", function () { return (parcelRequire("jU8uG")).getSerdePlugin; });
parcelRequire("bgoD0");
parcelRequire("8i3cX");
parcelRequire("jU8uG");

});
parcelRegister("bgoD0", function(module, exports) {

$parcel$export(module.exports, "deserializerMiddleware", function () { return $83344af942a979ec$export$d10196e291075f95; });

var $fH1jI = parcelRequire("fH1jI");
var $83344af942a979ec$export$d10196e291075f95 = function(options, deserializer) {
    return function(next, context) {
        return function(args) {
            return (0, $fH1jI.__awaiter)(void 0, void 0, void 0, function() {
                var logger, outputFilterSensitiveLog, response, parsed, $metadata, outputWithoutMetadata;
                return (0, $fH1jI.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            logger = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            response = _a.sent().response;
                            if (typeof (logger === null || logger === void 0 ? void 0 : logger.debug) === "function") logger.debug({
                                httpResponse: response
                            });
                            return [
                                4 /*yield*/ ,
                                deserializer(response, options)
                            ];
                        case 2:
                            parsed = _a.sent();
                            $metadata = parsed.$metadata, outputWithoutMetadata = (0, $fH1jI.__rest)(parsed, [
                                "$metadata"
                            ]);
                            if (typeof (logger === null || logger === void 0 ? void 0 : logger.info) === "function") logger.info({
                                output: outputFilterSensitiveLog(outputWithoutMetadata)
                            });
                            return [
                                2 /*return*/ ,
                                {
                                    response: response,
                                    output: parsed
                                }
                            ];
                    }
                });
            });
        };
    };
};

});

parcelRegister("8i3cX", function(module, exports) {

$parcel$export(module.exports, "serializerMiddleware", function () { return $60927e3974a38d0f$export$125a23d36094c5de; });

var $fH1jI = parcelRequire("fH1jI");
var $60927e3974a38d0f$export$125a23d36094c5de = function(options, serializer) {
    return function(next, context) {
        return function(args) {
            return (0, $fH1jI.__awaiter)(void 0, void 0, void 0, function() {
                var logger, inputFilterSensitiveLog, request;
                return (0, $fH1jI.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            logger = context.logger, inputFilterSensitiveLog = context.inputFilterSensitiveLog;
                            if (typeof (logger === null || logger === void 0 ? void 0 : logger.info) === "function") logger.info({
                                input: inputFilterSensitiveLog(args.input)
                            });
                            return [
                                4 /*yield*/ ,
                                serializer(args.input, options)
                            ];
                        case 1:
                            request = _a.sent();
                            if (typeof (logger === null || logger === void 0 ? void 0 : logger.debug) === "function") logger.debug({
                                httpRequest: request
                            });
                            return [
                                2 /*return*/ ,
                                next((0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};

});

parcelRegister("jU8uG", function(module, exports) {

$parcel$export(module.exports, "getSerdePlugin", function () { return $e7d9d5f9c645577e$export$53fdc69654553fd4; });

var $bgoD0 = parcelRequire("bgoD0");

var $8i3cX = parcelRequire("8i3cX");
var $e7d9d5f9c645577e$export$f5d82b333b4f39c9 = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ]
};
var $e7d9d5f9c645577e$export$1bd449976e9c484d = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ]
};
function $e7d9d5f9c645577e$export$53fdc69654553fd4(config, serializer, deserializer) {
    return {
        applyToStack: function(commandStack) {
            commandStack.add((0, $bgoD0.deserializerMiddleware)(config, deserializer), $e7d9d5f9c645577e$export$f5d82b333b4f39c9);
            commandStack.add((0, $8i3cX.serializerMiddleware)(config, serializer), $e7d9d5f9c645577e$export$1bd449976e9c484d);
        }
    };
}

});


parcelRegister("fF6iB", function(module, exports) {
$parcel$export(module.exports, "Client", function () { return (parcelRequire("gQUrx")).Client; });
$parcel$export(module.exports, "Command", function () { return (parcelRequire("koeHb")).Command; });
$parcel$export(module.exports, "extendedEncodeURIComponent", function () { return (parcelRequire("15E4b")).extendedEncodeURIComponent; });
$parcel$export(module.exports, "getArrayIfSingleItem", function () { return (parcelRequire("3aFL9")).getArrayIfSingleItem; });
$parcel$export(module.exports, "getValueFromTextNode", function () { return (parcelRequire("3Ggxn")).getValueFromTextNode; });
$parcel$export(module.exports, "LazyJsonString", function () { return (parcelRequire("kwXpX")).LazyJsonString; });
$parcel$export(module.exports, "dateToUtcString", function () { return (parcelRequire("ksXvj")).dateToUtcString; });
$parcel$export(module.exports, "SENSITIVE_STRING", function () { return (parcelRequire("gouPX")).SENSITIVE_STRING; });
parcelRequire("gQUrx");
parcelRequire("koeHb");
parcelRequire("8Z1xC");
parcelRequire("bRokE");
parcelRequire("15E4b");
parcelRequire("3aFL9");
parcelRequire("3Ggxn");
parcelRequire("kwXpX");
parcelRequire("ksXvj");
parcelRequire("yYh4i");
parcelRequire("gouPX");
parcelRequire("jg9JP");
parcelRequire("knPJ3");

});
parcelRegister("gQUrx", function(module, exports) {

$parcel$export(module.exports, "Client", function () { return $c44d4919ceeceda9$export$1f2bb630327ac4b6; });
parcelRequire("b7NKe");
var $lDdEv = parcelRequire("lDdEv");
var $c44d4919ceeceda9$export$1f2bb630327ac4b6 = /** @class */ function() {
    function Client(config) {
        this.middlewareStack = (0, $lDdEv.constructStack)();
        this.config = config;
    }
    Client.prototype.send = function(command, optionsOrCb, cb) {
        var options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        var handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        if (callback) handler(command).then(function(result) {
            return callback(null, result.output);
        }, function(err) {
            return callback(err);
        }).catch(// prevent any errors thrown in the callback from triggering an
        // unhandled promise rejection
        function() {});
        else return handler(command).then(function(result) {
            return result.output;
        });
    };
    Client.prototype.destroy = function() {
        if (this.config.requestHandler.destroy) this.config.requestHandler.destroy();
    };
    return Client;
}();

});
parcelRegister("b7NKe", function(module, exports) {
$parcel$export(module.exports, "constructStack", function () { return (parcelRequire("lDdEv")).constructStack; });
parcelRequire("lDdEv");

});
parcelRegister("lDdEv", function(module, exports) {

$parcel$export(module.exports, "constructStack", function () { return $fbf7d49222fcf168$export$73604a93307363d8; });

var $fH1jI = parcelRequire("fH1jI");
var $fbf7d49222fcf168$export$73604a93307363d8 = function() {
    var absoluteEntries = [];
    var relativeEntries = [];
    var entriesNameSet = new Set();
    var sort = function(entries) {
        return entries.sort(function(a, b) {
            return $fbf7d49222fcf168$var$stepWeights[b.step] - $fbf7d49222fcf168$var$stepWeights[a.step] || $fbf7d49222fcf168$var$priorityWeights[b.priority || "normal"] - $fbf7d49222fcf168$var$priorityWeights[a.priority || "normal"];
        });
    };
    var removeByName = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.name && entry.name === toRemove) {
                isRemoved = true;
                entriesNameSet.delete(toRemove);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var removeByReference = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.middleware === toRemove) {
                isRemoved = true;
                if (entry.name) entriesNameSet.delete(entry.name);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var cloneTo = function(toStack) {
        absoluteEntries.forEach(function(entry) {
            //@ts-ignore
            toStack.add(entry.middleware, (0, $fH1jI.__assign)({}, entry));
        });
        relativeEntries.forEach(function(entry) {
            //@ts-ignore
            toStack.addRelativeTo(entry.middleware, (0, $fH1jI.__assign)({}, entry));
        });
        return toStack;
    };
    var expandRelativeMiddlewareList = function(from) {
        var expandedMiddlewareList = [];
        from.before.forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, $fH1jI.__spread)(expandRelativeMiddlewareList(entry)));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, $fH1jI.__spread)(expandRelativeMiddlewareList(entry)));
        });
        return expandedMiddlewareList;
    };
    /**
     * Get a final list of middleware in the order of being executed in the resolved handler.
     */ var getMiddlewareList = function() {
        var normalizedAbsoluteEntries = [];
        var normalizedRelativeEntries = [];
        var normalizedEntriesNameMap = {};
        absoluteEntries.forEach(function(entry) {
            var normalizedEntry = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach(function(entry) {
            var normalizedEntry = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach(function(entry) {
            if (entry.toMiddleware) {
                var toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) throw new Error(entry.toMiddleware + " is not found when adding " + (entry.name || "anonymous") + " middleware " + entry.relation + " " + entry.toMiddleware);
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        var mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce(function(wholeList, expendedMiddlewareList) {
            // TODO: Replace it with Array.flat();
            wholeList.push.apply(wholeList, (0, $fH1jI.__spread)(expendedMiddlewareList));
            return wholeList;
        }, []);
        return mainChain.map(function(entry) {
            return entry.middleware;
        });
    };
    var stack = {
        add: function(middleware, options) {
            if (options === void 0) options = {};
            var name = options.name;
            var entry = (0, $fH1jI.__assign)({
                step: "initialize",
                priority: "normal",
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) throw new Error("Duplicate middleware name '" + name + "'");
                entriesNameSet.add(name);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: function(middleware, options) {
            var name = options.name;
            var entry = (0, $fH1jI.__assign)({
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) throw new Error("Duplicated middleware name '" + name + "'");
                entriesNameSet.add(name);
            }
            relativeEntries.push(entry);
        },
        clone: function() {
            return cloneTo($fbf7d49222fcf168$export$73604a93307363d8());
        },
        use: function(plugin) {
            plugin.applyToStack(stack);
        },
        remove: function(toRemove) {
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: function(toRemove) {
            var isRemoved = false;
            var filterCb = function(entry) {
                var tags = entry.tags, name = entry.name;
                if (tags && tags.includes(toRemove)) {
                    if (name) entriesNameSet.delete(name);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: function(from) {
            var cloned = cloneTo($fbf7d49222fcf168$export$73604a93307363d8());
            cloned.use(from);
            return cloned;
        },
        applyToStack: cloneTo,
        resolve: function(handler, context) {
            var e_1, _a;
            try {
                for(var _b = (0, $fH1jI.__values)(getMiddlewareList().reverse()), _c = _b.next(); !_c.done; _c = _b.next()){
                    var middleware = _c.value;
                    handler = middleware(handler, context);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return handler;
        }
    };
    return stack;
};
var $fbf7d49222fcf168$var$stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
var $fbf7d49222fcf168$var$priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};

});



parcelRegister("koeHb", function(module, exports) {

$parcel$export(module.exports, "Command", function () { return $ed8172bfc3c8d8b9$export$cc7e12c76513e857; });
parcelRequire("b7NKe");
var $lDdEv = parcelRequire("lDdEv");
var $ed8172bfc3c8d8b9$export$cc7e12c76513e857 = /** @class */ function() {
    function Command() {
        this.middlewareStack = (0, $lDdEv.constructStack)();
    }
    return Command;
}();

});

parcelRegister("8Z1xC", function(module, exports) {

});

parcelRegister("bRokE", function(module, exports) {

});

parcelRegister("15E4b", function(module, exports) {

$parcel$export(module.exports, "extendedEncodeURIComponent", function () { return $0cb5567419fae295$export$7640f3c16fe7f54b; });
/**
 * Function that wraps encodeURIComponent to encode additional characters
 * to fully adhere to RFC 3986.
 */ function $0cb5567419fae295$export$7640f3c16fe7f54b(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16);
    });
}

});

parcelRegister("3aFL9", function(module, exports) {

$parcel$export(module.exports, "getArrayIfSingleItem", function () { return $24f2b2d827ad3122$export$52272e038712c64e; });
/**
 * The XML parser will set one K:V for a member that could
 * return multiple entries but only has one.
 */ var $24f2b2d827ad3122$export$52272e038712c64e = function(mayBeArray) {
    return Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];
};

});

parcelRegister("3Ggxn", function(module, exports) {

$parcel$export(module.exports, "getValueFromTextNode", function () { return $2ae21f535eda5529$export$113d90026b452881; });
/**
 * Recursively parses object and populates value is node from
 * "#text" key if it's available
 */ var $2ae21f535eda5529$export$113d90026b452881 = function(obj) {
    var textNodeName = "#text";
    for(var key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if (typeof obj[key] === "object" && obj[key] !== null) obj[key] = $2ae21f535eda5529$export$113d90026b452881(obj[key]);
    }
    return obj;
};

});

parcelRegister("kwXpX", function(module, exports) {

$parcel$export(module.exports, "LazyJsonString", function () { return $ef24e2e8553f5d7b$export$494ed5148690ecaf; });
/**
 * Lazy String holder for JSON typed contents.
 */ 
var $fH1jI = parcelRequire("fH1jI");
var $ef24e2e8553f5d7b$export$40e2db4f1ce24b10 = function() {
    //@ts-ignore 'this' cannot be assigned to any, but Object.getPrototypeOf accepts any
    var Class = Object.getPrototypeOf(this).constructor;
    var Constructor = Function.bind.apply(String, (0, $fH1jI.__spread)([
        null
    ], arguments));
    //@ts-ignore Call wrapped String constructor directly, don't bother typing it.
    var instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
$ef24e2e8553f5d7b$export$40e2db4f1ce24b10.prototype = Object.create(String.prototype, {
    constructor: {
        value: $ef24e2e8553f5d7b$export$40e2db4f1ce24b10,
        enumerable: false,
        writable: true,
        configurable: true
    }
});
Object.setPrototypeOf($ef24e2e8553f5d7b$export$40e2db4f1ce24b10, String);
var $ef24e2e8553f5d7b$export$494ed5148690ecaf = /** @class */ function(_super) {
    (0, $fH1jI.__extends)(LazyJsonString, _super);
    function LazyJsonString() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LazyJsonString.prototype.deserializeJSON = function() {
        return JSON.parse(_super.prototype.toString.call(this));
    };
    LazyJsonString.prototype.toJSON = function() {
        return _super.prototype.toString.call(this);
    };
    LazyJsonString.fromObject = function(object) {
        if (object instanceof LazyJsonString) return object;
        else if (object instanceof String || typeof object === "string") return new LazyJsonString(object);
        return new LazyJsonString(JSON.stringify(object));
    };
    return LazyJsonString;
}($ef24e2e8553f5d7b$export$40e2db4f1ce24b10);

});

parcelRegister("ksXvj", function(module, exports) {

$parcel$export(module.exports, "dateToUtcString", function () { return $ee64946ccb7ddd9c$export$5b50865171ed23a9; });
/**
 * Builds a proper UTC HttpDate timestamp from a Date object
 * since not all environments will have this as the expected
 * format.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toUTCString
 * > Prior to ECMAScript 2018, the format of the return value
 * > varied according to the platform. The most common return
 * > value was an RFC-1123 formatted date stamp, which is a
 * > slightly updated version of RFC-822 date stamps.
 */ // Build indexes outside so we allocate them once.
var $ee64946ccb7ddd9c$var$days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
// prettier-ignore
var $ee64946ccb7ddd9c$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function $ee64946ccb7ddd9c$export$5b50865171ed23a9(date) {
    var year = date.getUTCFullYear();
    var month = date.getUTCMonth();
    var dayOfWeek = date.getUTCDay();
    var dayOfMonthInt = date.getUTCDate();
    var hoursInt = date.getUTCHours();
    var minutesInt = date.getUTCMinutes();
    var secondsInt = date.getUTCSeconds();
    // Build 0 prefixed strings for contents that need to be
    // two digits and where we get an integer back.
    var dayOfMonthString = dayOfMonthInt < 10 ? "0" + dayOfMonthInt : "" + dayOfMonthInt;
    var hoursString = hoursInt < 10 ? "0" + hoursInt : "" + hoursInt;
    var minutesString = minutesInt < 10 ? "0" + minutesInt : "" + minutesInt;
    var secondsString = secondsInt < 10 ? "0" + secondsInt : "" + secondsInt;
    return $ee64946ccb7ddd9c$var$days[dayOfWeek] + ", " + dayOfMonthString + " " + $ee64946ccb7ddd9c$var$months[month] + " " + year + " " + hoursString + ":" + minutesString + ":" + secondsString + " GMT";
}

});

parcelRegister("yYh4i", function(module, exports) {
/**
 * Given an input string, splits based on the delimiter after a given
 * number of delimiters has been encountered.
 *
 * @param value The input string to split.
 * @param delimiter The delimiter to split on.
 * @param numDelimiters The number of delimiters to have encountered to split.
 */ function $0691ee4f78c6a797$export$b0cd0cd33296db41(value, delimiter, numDelimiters) {
    // Fail if we don't have a clear number to split on.
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    var segments = value.split(delimiter);
    // Short circuit extra logic for the simple case.
    if (numDelimiters === 1) return segments;
    var compoundSegments = [];
    var currentSegment = "";
    for(var i = 0; i < segments.length; i++){
        if (currentSegment === "") // Start a new segment.
        currentSegment = segments[i];
        else // Compound the current segment with the delimiter.
        currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            // We encountered the right number of delimiters, so add the entry.
            compoundSegments.push(currentSegment);
            // And reset the current segment.
            currentSegment = "";
        }
    }
    // Handle any leftover segment portion.
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}

});

parcelRegister("gouPX", function(module, exports) {

$parcel$export(module.exports, "SENSITIVE_STRING", function () { return $bef6ced0728953d7$export$17127055dc9ac067; });
var $bef6ced0728953d7$export$17127055dc9ac067 = "***SensitiveInformation***";

});

parcelRegister("jg9JP", function(module, exports) {

});

parcelRegister("knPJ3", function(module, exports) {

});



parcelRegister("hbAuD", function(module, exports) {
$parcel$export(module.exports, "ProviderError", function () { return (parcelRequire("4qhnW")).ProviderError; });
parcelRequire("2GlDM");
parcelRequire("4QIdb");
parcelRequire("hrKGv");
parcelRequire("4qhnW");

});
parcelRegister("2GlDM", function(module, exports) {

var $fH1jI = parcelRequire("fH1jI");

var $4qhnW = parcelRequire("4qhnW");
function $1f404a5d8f552851$export$e08e3b67e392101e() {
    var providers = [];
    for(var _i = 0; _i < arguments.length; _i++)providers[_i] = arguments[_i];
    return function() {
        var e_1, _a;
        var promise = Promise.reject(new (0, $4qhnW.ProviderError)("No providers in chain"));
        var _loop_1 = function(provider) {
            promise = promise.catch(function(err) {
                if (err === null || err === void 0 ? void 0 : err.tryNextLink) return provider();
                throw err;
            });
        };
        try {
            for(var providers_1 = (0, $fH1jI.__values)(providers), providers_1_1 = providers_1.next(); !providers_1_1.done; providers_1_1 = providers_1.next()){
                var provider = providers_1_1.value;
                _loop_1(provider);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (providers_1_1 && !providers_1_1.done && (_a = providers_1.return)) _a.call(providers_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return promise;
    };
}

});
parcelRegister("4qhnW", function(module, exports) {

$parcel$export(module.exports, "ProviderError", function () { return $3387136f8b4ae685$export$478ec1fdae99aa79; });

var $fH1jI = parcelRequire("fH1jI");
/**
 * An error representing a failure of an individual credential provider.
 *
 * This error class has special meaning to the {@link chain} method. If a
 * provider in the chain is rejected with an error, the chain will only proceed
 * to the next provider if the value of the `tryNextLink` property on the error
 * is truthy. This allows individual providers to halt the chain and also
 * ensures the chain will stop if an entirely unexpected error is encountered.
 */ var $3387136f8b4ae685$export$478ec1fdae99aa79 = /** @class */ function(_super) {
    (0, $fH1jI.__extends)(ProviderError, _super);
    function ProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message) || this;
        _this.tryNextLink = tryNextLink;
        return _this;
    }
    return ProviderError;
}(Error);

});


parcelRegister("4QIdb", function(module, exports) {
var $387e50482f9068c1$export$294ab423a8f4a426 = function(staticValue) {
    return function() {
        return Promise.resolve(staticValue);
    };
};

});

parcelRegister("hrKGv", function(module, exports) {

var $fH1jI = parcelRequire("fH1jI");
var $cb392bde035901a1$export$fc10aeed3a532e2a = function(provider, isExpired, requiresRefresh) {
    var result;
    var hasResult;
    if (isExpired === undefined) // This is a static memoization; no need to incorporate refreshing
    return function() {
        if (!hasResult) {
            result = provider();
            hasResult = true;
        }
        return result;
    };
    var isConstant = false;
    return function() {
        return (0, $fH1jI.__awaiter)(void 0, void 0, void 0, function() {
            var resolved;
            return (0, $fH1jI.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!hasResult) {
                            result = provider();
                            hasResult = true;
                        }
                        if (isConstant) return [
                            2 /*return*/ ,
                            result
                        ];
                        return [
                            4 /*yield*/ ,
                            result
                        ];
                    case 1:
                        resolved = _a.sent();
                        if (requiresRefresh && !requiresRefresh(resolved)) {
                            isConstant = true;
                            return [
                                2 /*return*/ ,
                                resolved
                            ];
                        }
                        if (isExpired(resolved)) return [
                            2 /*return*/ ,
                            result = provider()
                        ];
                        return [
                            2 /*return*/ ,
                            resolved
                        ];
                }
            });
        });
    };
};

});


parcelRegister("k0iBr", function(module, exports) {

$parcel$export(module.exports, "resolveLogins", function () { return $e9023ce72b605686$export$fb1e896f6704b6a6; });

var $fH1jI = parcelRequire("fH1jI");
function $e9023ce72b605686$export$fb1e896f6704b6a6(logins) {
    return Promise.all(Object.keys(logins).reduce(function(arr, name) {
        var tokenOrProvider = logins[name];
        if (typeof tokenOrProvider === "string") arr.push([
            name,
            tokenOrProvider
        ]);
        else arr.push(tokenOrProvider().then(function(token) {
            return [
                name,
                token
            ];
        }));
        return arr;
    }, [])).then(function(resolvedPairs) {
        return resolvedPairs.reduce(function(logins, _a) {
            var _b = (0, $fH1jI.__read)(_a, 2), key = _b[0], value = _b[1];
            logins[key] = value;
            return logins;
        }, {});
    });
}

});


parcelRegister("hiUze", function(module, exports) {

$parcel$export(module.exports, "fromCognitoIdentityPool", function () { return $c98fff35ae5ceccb$export$6c7d622e9507a2e; });

var $fH1jI = parcelRequire("fH1jI");

var $eYPaE = parcelRequire("eYPaE");
parcelRequire("hbAuD");
var $4qhnW = parcelRequire("4qhnW");

var $210G3 = parcelRequire("210G3");

var $3hg6F = parcelRequire("3hg6F");

var $k0iBr = parcelRequire("k0iBr");
function $c98fff35ae5ceccb$export$6c7d622e9507a2e(_a) {
    var _this = this;
    var accountId = _a.accountId, _b = _a.cache, cache = _b === void 0 ? (0, $3hg6F.localStorage)() : _b, client = _a.client, customRoleArn = _a.customRoleArn, identityPoolId = _a.identityPoolId, logins = _a.logins, _c = _a.userIdentifier, userIdentifier = _c === void 0 ? !logins || Object.keys(logins).length === 0 ? "ANONYMOUS" : undefined : _c;
    var cacheKey = userIdentifier ? "aws:cognito-identity-credentials:" + identityPoolId + ":" + userIdentifier : undefined;
    var provider = function() {
        return (0, $fH1jI.__awaiter)(_this, void 0, void 0, function() {
            var identityId, _a, _b, IdentityId, _c, _d, _e, _f;
            var _g;
            return (0, $fH1jI.__generator)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        _a = cacheKey;
                        if (!_a) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            cache.getItem(cacheKey)
                        ];
                    case 1:
                        _a = _h.sent();
                        _h.label = 2;
                    case 2:
                        identityId = _a;
                        if (!!identityId) return [
                            3 /*break*/ ,
                            7
                        ];
                        _d = (_c = client).send;
                        _e = (0, $eYPaE.GetIdCommand).bind;
                        _g = {
                            AccountId: accountId,
                            IdentityPoolId: identityPoolId
                        };
                        if (!logins) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $k0iBr.resolveLogins)(logins)
                        ];
                    case 3:
                        _f = _h.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        _f = undefined;
                        _h.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _d.apply(_c, [
                                new (_e.apply((0, $eYPaE.GetIdCommand), [
                                    void 0,
                                    (_g.Logins = _f, _g)
                                ]))()
                            ])
                        ];
                    case 6:
                        _b = _h.sent().IdentityId, IdentityId = _b === void 0 ? $c98fff35ae5ceccb$var$throwOnMissingId() : _b;
                        identityId = IdentityId;
                        if (cacheKey) Promise.resolve(cache.setItem(cacheKey, identityId)).catch(function() {});
                        _h.label = 7;
                    case 7:
                        provider = (0, $210G3.fromCognitoIdentity)({
                            client: client,
                            customRoleArn: customRoleArn,
                            logins: logins,
                            identityId: identityId
                        });
                        return [
                            2 /*return*/ ,
                            provider()
                        ];
                }
            });
        });
    };
    return function() {
        return provider().catch(function(err) {
            return (0, $fH1jI.__awaiter)(_this, void 0, void 0, function() {
                return (0, $fH1jI.__generator)(this, function(_a) {
                    if (cacheKey) Promise.resolve(cache.removeItem(cacheKey)).catch(function() {});
                    throw err;
                });
            });
        });
    };
}
function $c98fff35ae5ceccb$var$throwOnMissingId() {
    throw new (0, $4qhnW.ProviderError)("Response from Amazon Cognito contained no identity ID");
}

});
parcelRegister("eYPaE", function(module, exports) {

$parcel$export(module.exports, "GetIdCommand", function () { return $ae7e5cbf18caf1bc$export$41ceb4ced4f97a44; });

var $lUfmm = parcelRequire("lUfmm");

var $dtL6g = parcelRequire("dtL6g");

var $37z13 = parcelRequire("37z13");
parcelRequire("5Wom8");
var $jU8uG = parcelRequire("jU8uG");
parcelRequire("fF6iB");
var $koeHb = parcelRequire("koeHb");
var $ae7e5cbf18caf1bc$export$41ceb4ced4f97a44 = /** @class */ function(_super) {
    (0, $lUfmm.__extends)(GetIdCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetIdCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    GetIdCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $jU8uG.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "GetIdCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $dtL6g.GetIdInput).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $dtL6g.GetIdResponse).filterSensitiveLog
        };
        if (typeof logger.info === "function") logger.info({
            clientName: clientName,
            commandName: commandName
        });
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetIdCommand.prototype.serialize = function(input, context) {
        return (0, $37z13.serializeAws_json1_1GetIdCommand)(input, context);
    };
    GetIdCommand.prototype.deserialize = function(output, context) {
        return (0, $37z13.deserializeAws_json1_1GetIdCommand)(output, context);
    };
    return GetIdCommand;
}((0, $koeHb.Command));

});

parcelRegister("3hg6F", function(module, exports) {

$parcel$export(module.exports, "localStorage", function () { return $262f74109ed9f6e3$export$c2ed3351cac403d1; });

var $ffILX = parcelRequire("ffILX");

var $fvqbb = parcelRequire("fvqbb");
var $262f74109ed9f6e3$var$inMemoryStorage = new (0, $fvqbb.InMemoryStorage)();
function $262f74109ed9f6e3$export$c2ed3351cac403d1() {
    if (typeof self === "object" && self.indexedDB) return new (0, $ffILX.IndexedDbStorage)();
    if (typeof window === "object" && window.localStorage) return window.localStorage;
    return $262f74109ed9f6e3$var$inMemoryStorage;
}

});
parcelRegister("ffILX", function(module, exports) {

$parcel$export(module.exports, "IndexedDbStorage", function () { return $b1aafca05f998c68$export$55d38e5384f402; });
var $b1aafca05f998c68$var$STORE_NAME = "IdentityIds";
var $b1aafca05f998c68$export$55d38e5384f402 = /** @class */ function() {
    function IndexedDbStorage(dbName) {
        if (dbName === void 0) dbName = "aws:cognito-identity-ids";
        this.dbName = dbName;
    }
    IndexedDbStorage.prototype.getItem = function(key) {
        return this.withObjectStore("readonly", function(store) {
            var req = store.get(key);
            return new Promise(function(resolve) {
                req.onerror = function() {
                    return resolve(null);
                };
                req.onsuccess = function() {
                    return resolve(req.result ? req.result.value : null);
                };
            });
        }).catch(function() {
            return null;
        });
    };
    IndexedDbStorage.prototype.removeItem = function(key) {
        return this.withObjectStore("readwrite", function(store) {
            var req = store.delete(key);
            return new Promise(function(resolve, reject) {
                req.onerror = function() {
                    return reject(req.error);
                };
                req.onsuccess = function() {
                    return resolve();
                };
            });
        });
    };
    IndexedDbStorage.prototype.setItem = function(id, value) {
        return this.withObjectStore("readwrite", function(store) {
            var req = store.put({
                id: id,
                value: value
            });
            return new Promise(function(resolve, reject) {
                req.onerror = function() {
                    return reject(req.error);
                };
                req.onsuccess = function() {
                    return resolve();
                };
            });
        });
    };
    IndexedDbStorage.prototype.getDb = function() {
        var openDbRequest = self.indexedDB.open(this.dbName, 1);
        return new Promise(function(resolve, reject) {
            openDbRequest.onsuccess = function() {
                resolve(openDbRequest.result);
            };
            openDbRequest.onerror = function() {
                reject(openDbRequest.error);
            };
            openDbRequest.onblocked = function() {
                reject(new Error("Unable to access DB"));
            };
            openDbRequest.onupgradeneeded = function() {
                var db = openDbRequest.result;
                db.onerror = function() {
                    reject(new Error("Failed to create object store"));
                };
                db.createObjectStore($b1aafca05f998c68$var$STORE_NAME, {
                    keyPath: "id"
                });
            };
        });
    };
    IndexedDbStorage.prototype.withObjectStore = function(mode, action) {
        return this.getDb().then(function(db) {
            var tx = db.transaction($b1aafca05f998c68$var$STORE_NAME, mode);
            tx.oncomplete = function() {
                return db.close();
            };
            return new Promise(function(resolve, reject) {
                tx.onerror = function() {
                    return reject(tx.error);
                };
                resolve(action(tx.objectStore($b1aafca05f998c68$var$STORE_NAME)));
            }).catch(function(err) {
                db.close();
                throw err;
            });
        });
    };
    return IndexedDbStorage;
}();

});

parcelRegister("fvqbb", function(module, exports) {

$parcel$export(module.exports, "InMemoryStorage", function () { return $b49e0eef2efd3524$export$e4315e25b840a0ea; });
var $b49e0eef2efd3524$export$e4315e25b840a0ea = /** @class */ function() {
    function InMemoryStorage(store) {
        if (store === void 0) store = {};
        this.store = store;
    }
    InMemoryStorage.prototype.getItem = function(key) {
        if (key in this.store) return this.store[key];
        return null;
    };
    InMemoryStorage.prototype.removeItem = function(key) {
        delete this.store[key];
    };
    InMemoryStorage.prototype.setItem = function(key, value) {
        this.store[key] = value;
    };
    return InMemoryStorage;
}();

});



parcelRegister("aYSbN", function(module, exports) {

$parcel$export(module.exports, "CognitoIdentityClient", function () { return $7fe98ad9fbbaad82$export$e576def690e850f7; });

var $lUfmm = parcelRequire("lUfmm");

var $5LSTU = parcelRequire("5LSTU");
parcelRequire("eKUPO");
var $8dzJz = parcelRequire("8dzJz");
var $auJcL = parcelRequire("auJcL");

var $d0jvP = parcelRequire("d0jvP");

var $8rZ2X = parcelRequire("8rZ2X");
parcelRequire("jyqb9");
var $7Gq7f = parcelRequire("7Gq7f");
parcelRequire("diPxB");
var $6Dcus = parcelRequire("6Dcus");
var $bprgV = parcelRequire("bprgV");
parcelRequire("fGFVS");
var $gcXH0 = parcelRequire("gcXH0");
parcelRequire("ezV12");
var $gzcdq = parcelRequire("gzcdq");
var $koCCo = parcelRequire("koCCo");
parcelRequire("fF6iB");
var $gQUrx = parcelRequire("gQUrx");
/**
 * <fullname>Amazon Cognito Federated Identities</fullname>
 *          <p>Amazon Cognito Federated Identities is a web service that delivers scoped temporary
 *          credentials to mobile devices and other untrusted environments. It uniquely identifies a
 *          device and supplies the user with a consistent identity over the lifetime of an
 *          application.</p>
 *          <p>Using Amazon Cognito Federated Identities, you can enable authentication with one or
 *          more third-party identity providers (Facebook, Google, or Login with Amazon) or an Amazon
 *          Cognito user pool, and you can also choose to support unauthenticated access from your app.
 *          Cognito delivers a unique identifier for each user and acts as an OpenID token provider
 *          trusted by AWS Security Token Service (STS) to access temporary, limited-privilege AWS
 *          credentials.</p>
 *          <p>For a description of the authentication flow from the Amazon Cognito Developer Guide
 *          see <a href="https://docs.aws.amazon.com/cognito/latest/developerguide/authentication-flow.html">Authentication Flow</a>.</p>
 *          <p>For more information see <a href="https://docs.aws.amazon.com/cognito/latest/developerguide/cognito-identity.html">Amazon Cognito Federated Identities</a>.</p>
 */ var $7fe98ad9fbbaad82$export$e576def690e850f7 = /** @class */ function(_super) {
    (0, $lUfmm.__extends)(CognitoIdentityClient, _super);
    function CognitoIdentityClient(configuration) {
        var _this = this;
        var _config_0 = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, (0, $5LSTU.ClientDefaultValues)), configuration);
        var _config_1 = (0, $auJcL.resolveRegionConfig)(_config_0);
        var _config_2 = (0, $8dzJz.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, $gcXH0.resolveAwsAuthConfig)(_config_2);
        var _config_4 = (0, $bprgV.resolveRetryConfig)(_config_3);
        var _config_5 = (0, $koCCo.resolveUserAgentConfig)(_config_4);
        var _config_6 = (0, $8rZ2X.resolveHostHeaderConfig)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, $6Dcus.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, $gzcdq.getUserAgentPlugin)(_this.config));
        _this.middlewareStack.use((0, $d0jvP.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, $8rZ2X.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, $7Gq7f.getLoggerPlugin)(_this.config));
        return _this;
    }
    CognitoIdentityClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return CognitoIdentityClient;
}((0, $gQUrx.Client));

});
parcelRegister("5LSTU", function(module, exports) {

$parcel$export(module.exports, "ClientDefaultValues", function () { return $433bedb3f26458d0$export$b1f2d721b555a243; });

var $lUfmm = parcelRequire("lUfmm");

var $3jaRU = parcelRequire("3jaRU");

var $bVSDk = parcelRequire("bVSDk");
parcelRequire("2NxHI");
var $h2woU = parcelRequire("h2woU");
var $gGhUY = parcelRequire("gGhUY");

var $61J1X = parcelRequire("61J1X");
parcelRequire("diPxB");
var $hxaUp = parcelRequire("hxaUp");

var $b3bpS = parcelRequire("b3bpS");

var $f4uPV = parcelRequire("f4uPV");

var $6AFBv = parcelRequire("6AFBv");

var $jc6bn = parcelRequire("jc6bn");

var $12JSh = parcelRequire("12JSh");

var $giq9Q = parcelRequire("giq9Q");
var $433bedb3f26458d0$export$b1f2d721b555a243 = (0, $lUfmm.__assign)((0, $lUfmm.__assign)({}, (0, $giq9Q.ClientSharedValues)), {
    runtime: "browser",
    base64Decoder: (0, $f4uPV.fromBase64),
    base64Encoder: (0, $f4uPV.toBase64),
    bodyLengthChecker: (0, $6AFBv.calculateBodyLength),
    credentialDefaultProvider: function() {},
    defaultUserAgent: (0, $jc6bn.defaultUserAgent)((0, (/*@__PURE__*/$parcel$interopDefault($3jaRU))).name, (0, (/*@__PURE__*/$parcel$interopDefault($3jaRU))).version),
    maxAttempts: (0, $hxaUp.DEFAULT_MAX_ATTEMPTS),
    region: (0, $61J1X.invalidFunction)("Region is missing"),
    requestHandler: new (0, $h2woU.FetchHttpHandler)(),
    sha256: (0, $bVSDk.Sha256),
    streamCollector: (0, $gGhUY.streamCollector),
    urlParser: (0, $b3bpS.parseUrl),
    utf8Decoder: (0, $12JSh.fromUtf8),
    utf8Encoder: (0, $12JSh.toUtf8)
});

});
parcelRegister("3jaRU", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"@aws-sdk/client-cognito-identity\",\"description\":\"AWS SDK for JavaScript Cognito Identity Client for Node.js, Browser and React Native\",\"version\":\"1.0.0-rc.4\",\"scripts\":{\"clean\":\"npm run remove-definitions && npm run remove-dist\",\"build-documentation\":\"npm run clean && typedoc ./\",\"prepublishOnly\":\"yarn build\",\"pretest\":\"yarn build:cjs\",\"remove-definitions\":\"rimraf ./types\",\"remove-dist\":\"rimraf ./dist\",\"remove-documentation\":\"rimraf ./docs\",\"test:unit\":\"mocha **/cjs/**/*.spec.js\",\"test:e2e\":\"mocha **/cjs/**/*.ispec.js && karma start karma.conf.js\",\"test\":\"yarn test:unit\",\"build:cjs\":\"tsc -p tsconfig.json\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build\":\"yarn build:cjs && yarn build:es\"},\"main\":\"./dist/cjs/index.js\",\"types\":\"./types/index.d.ts\",\"module\":\"./dist/es/index.js\",\"browser\":{\"./runtimeConfig\":\"./runtimeConfig.browser\"},\"react-native\":{\"./runtimeConfig\":\"./runtimeConfig.native\"},\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha256-browser\":\"^1.0.0\",\"@aws-crypto/sha256-js\":\"^1.0.0\",\"@aws-sdk/config-resolver\":\"1.0.0-rc.3\",\"@aws-sdk/credential-provider-node\":\"1.0.0-rc.3\",\"@aws-sdk/fetch-http-handler\":\"1.0.0-rc.3\",\"@aws-sdk/hash-node\":\"1.0.0-rc.3\",\"@aws-sdk/invalid-dependency\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-content-length\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-host-header\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-logger\":\"1.0.0-rc.4\",\"@aws-sdk/middleware-retry\":\"1.0.0-rc.4\",\"@aws-sdk/middleware-serde\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-signing\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-stack\":\"1.0.0-rc.4\",\"@aws-sdk/middleware-user-agent\":\"1.0.0-rc.3\",\"@aws-sdk/node-config-provider\":\"1.0.0-rc.3\",\"@aws-sdk/node-http-handler\":\"1.0.0-rc.3\",\"@aws-sdk/protocol-http\":\"1.0.0-rc.3\",\"@aws-sdk/smithy-client\":\"1.0.0-rc.4\",\"@aws-sdk/types\":\"1.0.0-rc.3\",\"@aws-sdk/url-parser-browser\":\"1.0.0-rc.3\",\"@aws-sdk/url-parser-node\":\"1.0.0-rc.3\",\"@aws-sdk/util-base64-browser\":\"1.0.0-rc.3\",\"@aws-sdk/util-base64-node\":\"1.0.0-rc.3\",\"@aws-sdk/util-body-length-browser\":\"1.0.0-rc.3\",\"@aws-sdk/util-body-length-node\":\"1.0.0-rc.3\",\"@aws-sdk/util-user-agent-browser\":\"1.0.0-rc.3\",\"@aws-sdk/util-user-agent-node\":\"1.0.0-rc.3\",\"@aws-sdk/util-utf8-browser\":\"1.0.0-rc.3\",\"@aws-sdk/util-utf8-node\":\"1.0.0-rc.3\",\"tslib\":\"^2.0.0\"},\"devDependencies\":{\"@aws-sdk/client-documentation-generator\":\"1.0.0-rc.3\",\"@aws-sdk/client-iam\":\"1.0.0-rc.4\",\"@types/chai\":\"^4.2.11\",\"@types/mocha\":\"^7.0.2\",\"@types/node\":\"^12.7.5\",\"jest\":\"^26.1.0\",\"rimraf\":\"^3.0.0\",\"typedoc\":\"^0.17.8\",\"typescript\":\"~4.0.2\"},\"engines\":{\"node\":\">=10.0.0\"},\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/master/clients/client-cognito-identity\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-cognito-identity\"}}");

});

parcelRegister("bVSDk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebCryptoSha256 = module.exports.Ie11Sha256 = void 0;

var $fH1jI = parcelRequire("fH1jI");

(0, $fH1jI.__exportStar)((parcelRequire("ahb1S")), module.exports);

var $7UTi7 = parcelRequire("7UTi7");
Object.defineProperty(module.exports, "Ie11Sha256", {
    enumerable: true,
    get: function() {
        return $7UTi7.Sha256;
    }
});

var $68gnH = parcelRequire("68gnH");
Object.defineProperty(module.exports, "WebCryptoSha256", {
    enumerable: true,
    get: function() {
        return $68gnH.Sha256;
    }
});

});

parcelRegister("2NxHI", function(module, exports) {
$parcel$export(module.exports, "FetchHttpHandler", function () { return (parcelRequire("h2woU")).FetchHttpHandler; });
$parcel$export(module.exports, "streamCollector", function () { return (parcelRequire("gGhUY")).streamCollector; });
parcelRequire("h2woU");
parcelRequire("gGhUY");

});
parcelRegister("h2woU", function(module, exports) {

$parcel$export(module.exports, "FetchHttpHandler", function () { return $c67bc1b0fd2c015d$export$83588b87edbfa7e0; });

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("1J0sw");
var $cC0dr = parcelRequire("cC0dr");

var $z0zEw = parcelRequire("z0zEw");

var $dlUfl = parcelRequire("dlUfl");
var $c67bc1b0fd2c015d$export$83588b87edbfa7e0 = /** @class */ function() {
    function FetchHttpHandler(httpOptions) {
        if (httpOptions === void 0) httpOptions = {};
        this.httpOptions = httpOptions;
    }
    FetchHttpHandler.prototype.destroy = function() {
    // Do nothing. TLS and HTTP/2 connection pooling is handled by the
    // browser.
    };
    FetchHttpHandler.prototype.handle = function(request, options) {
        var abortSignal = options === null || options === void 0 ? void 0 : options.abortSignal;
        var requestTimeoutInMs = this.httpOptions.requestTimeout;
        // if the request was already aborted, prevent doing extra work
        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
            var abortError = new Error("Request aborted");
            abortError.name = "AbortError";
            return Promise.reject(abortError);
        }
        var path = request.path;
        if (request.query) {
            var queryString = (0, $z0zEw.buildQueryString)(request.query);
            if (queryString) path += "?" + queryString;
        }
        var port = request.port;
        var url = request.protocol + "//" + request.hostname + (port ? ":" + port : "") + path;
        var requestOptions = {
            body: request.body,
            headers: new Headers(request.headers),
            method: request.method
        };
        // some browsers support abort signal
        if (typeof AbortController !== "undefined") requestOptions["signal"] = abortSignal;
        var fetchRequest = new Request(url, requestOptions);
        var raceOfPromises = [
            fetch(fetchRequest).then(function(response) {
                var e_1, _a;
                var fetchHeaders = response.headers;
                var transformedHeaders = {};
                try {
                    for(var _b = (0, $fH1jI.__values)(fetchHeaders.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                        var pair = _c.value;
                        transformedHeaders[pair[0]] = pair[1];
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                var hasReadableStream = response.body !== undefined;
                // Return the response with buffered body
                if (!hasReadableStream) return response.blob().then(function(body) {
                    return {
                        response: new (0, $cC0dr.HttpResponse)({
                            headers: transformedHeaders,
                            statusCode: response.status,
                            body: body
                        })
                    };
                });
                // Return the response with streaming body
                return {
                    response: new (0, $cC0dr.HttpResponse)({
                        headers: transformedHeaders,
                        statusCode: response.status,
                        body: response.body
                    })
                };
            }),
            (0, $dlUfl.requestTimeout)(requestTimeoutInMs)
        ];
        if (abortSignal) raceOfPromises.push(new Promise(function(resolve, reject) {
            abortSignal.onabort = function() {
                var abortError = new Error("Request aborted");
                abortError.name = "AbortError";
                reject(abortError);
            };
        }));
        return Promise.race(raceOfPromises);
    };
    return FetchHttpHandler;
}();

});
parcelRegister("z0zEw", function(module, exports) {

$parcel$export(module.exports, "buildQueryString", function () { return $0693b6fdd609d716$export$6b17a39e52c8ee53; });

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("0ORaJ");
var $2Tq8U = parcelRequire("2Tq8U");
function $0693b6fdd609d716$export$6b17a39e52c8ee53(query) {
    var e_1, _a;
    var parts = [];
    try {
        for(var _b = (0, $fH1jI.__values)(Object.keys(query).sort()), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var value = query[key];
            key = (0, $2Tq8U.escapeUri)(key);
            if (Array.isArray(value)) for(var i = 0, iLen = value.length; i < iLen; i++)parts.push(key + "=" + (0, $2Tq8U.escapeUri)(value[i]));
            else {
                var qsEntry = key;
                if (value || typeof value === "string") qsEntry += "=" + (0, $2Tq8U.escapeUri)(value);
                parts.push(qsEntry);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return parts.join("&");
}

});
parcelRegister("0ORaJ", function(module, exports) {
$parcel$export(module.exports, "escapeUri", function () { return (parcelRequire("2Tq8U")).escapeUri; });
parcelRequire("2Tq8U");
parcelRequire("2B29d");

});
parcelRegister("2Tq8U", function(module, exports) {

$parcel$export(module.exports, "escapeUri", function () { return $21b4ff3eaabad154$export$c3b4775ad75a73db; });
var $21b4ff3eaabad154$export$c3b4775ad75a73db = function(uri) {
    // AWS percent-encodes some extra non-standard characters in a URI
    return encodeURIComponent(uri).replace(/[!'()*]/g, $21b4ff3eaabad154$var$hexEncode);
};
var $21b4ff3eaabad154$var$hexEncode = function(c) {
    return "%" + c.charCodeAt(0).toString(16).toUpperCase();
};

});

parcelRegister("2B29d", function(module, exports) {

var $2Tq8U = parcelRequire("2Tq8U");
var $1e40b3f7f1de8522$export$547c045505a754ef = function(uri) {
    return uri.split("/").map((0, $2Tq8U.escapeUri)).join("/");
};

});



parcelRegister("dlUfl", function(module, exports) {

$parcel$export(module.exports, "requestTimeout", function () { return $9b88ddeecd3281f4$export$363ac302bdbd807b; });
function $9b88ddeecd3281f4$export$363ac302bdbd807b(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within " + timeoutInMs + " ms");
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}

});


parcelRegister("gGhUY", function(module, exports) {

$parcel$export(module.exports, "streamCollector", function () { return $c24e77b758290cf6$export$17bf97b72e307d52; });

var $fH1jI = parcelRequire("fH1jI");

var $f4uPV = parcelRequire("f4uPV");
var $c24e77b758290cf6$export$17bf97b72e307d52 = function(stream) {
    if (typeof Blob === "function" && stream instanceof Blob) return $c24e77b758290cf6$var$collectBlob(stream);
    return $c24e77b758290cf6$var$collectStream(stream);
};
function $c24e77b758290cf6$var$collectBlob(blob) {
    return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
        var base64, arrayBuffer;
        return (0, $fH1jI.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $c24e77b758290cf6$var$readToBase64(blob)
                    ];
                case 1:
                    base64 = _a.sent();
                    arrayBuffer = (0, $f4uPV.fromBase64)(base64);
                    return [
                        2 /*return*/ ,
                        new Uint8Array(arrayBuffer)
                    ];
            }
        });
    });
}
function $c24e77b758290cf6$var$collectStream(stream) {
    return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
        var res, reader, isDone, _a, done, value, prior;
        return (0, $fH1jI.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    res = new Uint8Array(0);
                    reader = stream.getReader();
                    isDone = false;
                    _b.label = 1;
                case 1:
                    if (!!isDone) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        reader.read()
                    ];
                case 2:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (value) {
                        prior = res;
                        res = new Uint8Array(prior.length + value.length);
                        res.set(prior);
                        res.set(value, prior.length);
                    }
                    isDone = done;
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        res
                    ];
            }
        });
    });
}
function $c24e77b758290cf6$var$readToBase64(blob) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function() {
            var _a;
            // reference: https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
            // response from readAsDataURL is always prepended with "data:*/*;base64,"
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            var result = (_a = reader.result) !== null && _a !== void 0 ? _a : "";
            // Response can include only 'data:' for empty blob, return empty string in this case.
            // Otherwise, return the string after ','
            var commaIndex = result.indexOf(",");
            var dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = function() {
            return reject(new Error("Read aborted"));
        };
        reader.onerror = function() {
            return reject(reader.error);
        };
        // reader.readAsArrayBuffer is not always available
        reader.readAsDataURL(blob);
    });
}

});
parcelRegister("f4uPV", function(module, exports) {

$parcel$export(module.exports, "fromBase64", function () { return $af8f263f8a769afb$export$c537b38001c583b7; });
$parcel$export(module.exports, "toBase64", function () { return $af8f263f8a769afb$export$37cc283d8fbd3462; });
var $af8f263f8a769afb$var$alphabetByEncoding = {};
var $af8f263f8a769afb$var$alphabetByValue = new Array(64);
for(var $af8f263f8a769afb$var$i = 0, $af8f263f8a769afb$var$start = "A".charCodeAt(0), $af8f263f8a769afb$var$limit = "Z".charCodeAt(0); $af8f263f8a769afb$var$i + $af8f263f8a769afb$var$start <= $af8f263f8a769afb$var$limit; $af8f263f8a769afb$var$i++){
    var $af8f263f8a769afb$var$char = String.fromCharCode($af8f263f8a769afb$var$i + $af8f263f8a769afb$var$start);
    $af8f263f8a769afb$var$alphabetByEncoding[$af8f263f8a769afb$var$char] = $af8f263f8a769afb$var$i;
    $af8f263f8a769afb$var$alphabetByValue[$af8f263f8a769afb$var$i] = $af8f263f8a769afb$var$char;
}
for(var $af8f263f8a769afb$var$i = 0, $af8f263f8a769afb$var$start = "a".charCodeAt(0), $af8f263f8a769afb$var$limit = "z".charCodeAt(0); $af8f263f8a769afb$var$i + $af8f263f8a769afb$var$start <= $af8f263f8a769afb$var$limit; $af8f263f8a769afb$var$i++){
    var $af8f263f8a769afb$var$char = String.fromCharCode($af8f263f8a769afb$var$i + $af8f263f8a769afb$var$start);
    var $af8f263f8a769afb$var$index = $af8f263f8a769afb$var$i + 26;
    $af8f263f8a769afb$var$alphabetByEncoding[$af8f263f8a769afb$var$char] = $af8f263f8a769afb$var$index;
    $af8f263f8a769afb$var$alphabetByValue[$af8f263f8a769afb$var$index] = $af8f263f8a769afb$var$char;
}
for(var $af8f263f8a769afb$var$i = 0; $af8f263f8a769afb$var$i < 10; $af8f263f8a769afb$var$i++){
    $af8f263f8a769afb$var$alphabetByEncoding[$af8f263f8a769afb$var$i.toString(10)] = $af8f263f8a769afb$var$i + 52;
    var $af8f263f8a769afb$var$char = $af8f263f8a769afb$var$i.toString(10);
    var $af8f263f8a769afb$var$index = $af8f263f8a769afb$var$i + 52;
    $af8f263f8a769afb$var$alphabetByEncoding[$af8f263f8a769afb$var$char] = $af8f263f8a769afb$var$index;
    $af8f263f8a769afb$var$alphabetByValue[$af8f263f8a769afb$var$index] = $af8f263f8a769afb$var$char;
}
$af8f263f8a769afb$var$alphabetByEncoding["+"] = 62;
$af8f263f8a769afb$var$alphabetByValue[62] = "+";
$af8f263f8a769afb$var$alphabetByEncoding["/"] = 63;
$af8f263f8a769afb$var$alphabetByValue[63] = "/";
var $af8f263f8a769afb$var$bitsPerLetter = 6;
var $af8f263f8a769afb$var$bitsPerByte = 8;
var $af8f263f8a769afb$var$maxLetterValue = 63;
function $af8f263f8a769afb$export$c537b38001c583b7(input) {
    var totalByteLength = input.length / 4 * 3;
    if (input.substr(-2) === "==") totalByteLength -= 2;
    else if (input.substr(-1) === "=") totalByteLength--;
    var out = new ArrayBuffer(totalByteLength);
    var dataView = new DataView(out);
    for(var i = 0; i < input.length; i += 4){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            bits |= $af8f263f8a769afb$var$alphabetByEncoding[input[j]] << (limit - j) * $af8f263f8a769afb$var$bitsPerLetter;
            bitLength += $af8f263f8a769afb$var$bitsPerLetter;
        } else bits >>= $af8f263f8a769afb$var$bitsPerLetter;
        var chunkOffset = i / 4 * 3;
        bits >>= bitLength % $af8f263f8a769afb$var$bitsPerByte;
        var byteLength = Math.floor(bitLength / $af8f263f8a769afb$var$bitsPerByte);
        for(var k = 0; k < byteLength; k++){
            var offset = (byteLength - k - 1) * $af8f263f8a769afb$var$bitsPerByte;
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
}
function $af8f263f8a769afb$export$37cc283d8fbd3462(input) {
    var str = "";
    for(var i = 0; i < input.length; i += 3){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * $af8f263f8a769afb$var$bitsPerByte;
            bitLength += $af8f263f8a769afb$var$bitsPerByte;
        }
        var bitClusterCount = Math.ceil(bitLength / $af8f263f8a769afb$var$bitsPerLetter);
        bits <<= bitClusterCount * $af8f263f8a769afb$var$bitsPerLetter - bitLength;
        for(var k = 1; k <= bitClusterCount; k++){
            var offset = (bitClusterCount - k) * $af8f263f8a769afb$var$bitsPerLetter;
            str += $af8f263f8a769afb$var$alphabetByValue[(bits & $af8f263f8a769afb$var$maxLetterValue << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}

});



parcelRegister("61J1X", function(module, exports) {

$parcel$export(module.exports, "invalidFunction", function () { return $4635c439422788dd$export$8b6362171c4dfa64; });
var $4635c439422788dd$export$8b6362171c4dfa64 = function(message) {
    return function() {
        throw new Error(message);
    };
};

});

parcelRegister("diPxB", function(module, exports) {
$parcel$export(module.exports, "getRetryPlugin", function () { return (parcelRequire("6Dcus")).getRetryPlugin; });
$parcel$export(module.exports, "DEFAULT_MAX_ATTEMPTS", function () { return (parcelRequire("hxaUp")).DEFAULT_MAX_ATTEMPTS; });
$parcel$export(module.exports, "resolveRetryConfig", function () { return (parcelRequire("bprgV")).resolveRetryConfig; });
parcelRequire("6Dcus");
parcelRequire("hxaUp");
parcelRequire("bprgV");
parcelRequire("63tv9");
parcelRequire("hBiBz");

});
parcelRegister("6Dcus", function(module, exports) {

$parcel$export(module.exports, "getRetryPlugin", function () { return $4d4012e008fcf18c$export$c73199e2b1df9340; });

var $fH1jI = parcelRequire("fH1jI");
var $4d4012e008fcf18c$export$a3922aa5f87bae85 = function(options) {
    return function(next) {
        return function(args) {
            return (0, $fH1jI.__awaiter)(void 0, void 0, void 0, function() {
                return (0, $fH1jI.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        options.retryStrategy.retry(next, args)
                    ];
                });
            });
        };
    };
};
var $4d4012e008fcf18c$export$44d3d03587957ce9 = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high"
};
var $4d4012e008fcf18c$export$c73199e2b1df9340 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($4d4012e008fcf18c$export$a3922aa5f87bae85(options), $4d4012e008fcf18c$export$44d3d03587957ce9);
        }
    };
};

});

parcelRegister("hxaUp", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_MAX_ATTEMPTS", function () { return $cc3dfb061c860471$export$2c7e51f38ba5a406; });
$parcel$export(module.exports, "DEFAULT_RETRY_MODE", function () { return $cc3dfb061c860471$export$41315747b7c5d042; });
$parcel$export(module.exports, "StandardRetryStrategy", function () { return $cc3dfb061c860471$export$64af437cce00eae8; });

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("1J0sw");
var $jmMP9 = parcelRequire("jmMP9");

var $7FTSs = parcelRequire("7FTSs");

var $l6YtW = parcelRequire("l6YtW");

var $cqVIR = parcelRequire("cqVIR");

var $eUXj4 = parcelRequire("eUXj4");

var $63tv9 = parcelRequire("63tv9");

var $hBiBz = parcelRequire("hBiBz");
var $cc3dfb061c860471$export$2c7e51f38ba5a406 = 3;
var $cc3dfb061c860471$export$41315747b7c5d042 = "standard";
var $cc3dfb061c860471$export$64af437cce00eae8 = /** @class */ function() {
    function StandardRetryStrategy(maxAttemptsProvider, options) {
        var _a, _b, _c;
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.retryDecider = (_a = options === null || options === void 0 ? void 0 : options.retryDecider) !== null && _a !== void 0 ? _a : (0, $hBiBz.defaultRetryDecider);
        this.delayDecider = (_b = options === null || options === void 0 ? void 0 : options.delayDecider) !== null && _b !== void 0 ? _b : (0, $63tv9.defaultDelayDecider);
        this.retryQuota = (_c = options === null || options === void 0 ? void 0 : options.retryQuota) !== null && _c !== void 0 ? _c : (0, $eUXj4.getDefaultRetryQuota)((0, $cqVIR.INITIAL_RETRY_TOKENS));
    }
    StandardRetryStrategy.prototype.shouldRetry = function(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    };
    StandardRetryStrategy.prototype.getMaxAttempts = function() {
        return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
            var maxAttempts, error_1;
            return (0, $fH1jI.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.maxAttemptsProvider()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_1 = _a.sent();
                        maxAttempts = $cc3dfb061c860471$export$2c7e51f38ba5a406;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            maxAttempts
                        ];
                }
            });
        });
    };
    StandardRetryStrategy.prototype.retry = function(next, args) {
        return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
            var retryTokenAmount, attempts, totalDelay, maxAttempts, request, _loop_1, this_1, state_1;
            return (0, $fH1jI.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        attempts = 0;
                        totalDelay = 0;
                        return [
                            4 /*yield*/ ,
                            this.getMaxAttempts()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        request = args.request;
                        if ((0, $jmMP9.HttpRequest).isInstance(request)) request.headers["amz-sdk-invocation-id"] = (0, $l6YtW.v4)();
                        _loop_1 = function() {
                            var _a, response, output, err_1, delay_1;
                            return (0, $fH1jI.__generator)(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        _b.trys.push([
                                            0,
                                            2,
                                            ,
                                            5
                                        ]);
                                        if ((0, $jmMP9.HttpRequest).isInstance(request)) request.headers["amz-sdk-request"] = "attempt=" + (attempts + 1) + "; max=" + maxAttempts;
                                        return [
                                            4 /*yield*/ ,
                                            next(args)
                                        ];
                                    case 1:
                                        _a = _b.sent(), response = _a.response, output = _a.output;
                                        this_1.retryQuota.releaseRetryTokens(retryTokenAmount);
                                        output.$metadata.attempts = attempts + 1;
                                        output.$metadata.totalRetryDelay = totalDelay;
                                        return [
                                            2 /*return*/ ,
                                            {
                                                value: {
                                                    response: response,
                                                    output: output
                                                }
                                            }
                                        ];
                                    case 2:
                                        err_1 = _b.sent();
                                        attempts++;
                                        if (!this_1.shouldRetry(err_1, attempts, maxAttempts)) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        retryTokenAmount = this_1.retryQuota.retrieveRetryTokens(err_1);
                                        delay_1 = this_1.delayDecider((0, $7FTSs.isThrottlingError)(err_1) ? (0, $cqVIR.THROTTLING_RETRY_DELAY_BASE) : (0, $cqVIR.DEFAULT_RETRY_DELAY_BASE), attempts);
                                        totalDelay += delay_1;
                                        return [
                                            4 /*yield*/ ,
                                            new Promise(function(resolve) {
                                                return setTimeout(resolve, delay_1);
                                            })
                                        ];
                                    case 3:
                                        _b.sent();
                                        return [
                                            2 /*return*/ ,
                                            "continue"
                                        ];
                                    case 4:
                                        if (!err_1.$metadata) err_1.$metadata = {};
                                        err_1.$metadata.attempts = attempts;
                                        err_1.$metadata.totalRetryDelay = totalDelay;
                                        throw err_1;
                                    case 5:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 2;
                    case 2:
                        return [
                            5 /*yield**/ ,
                            _loop_1()
                        ];
                    case 3:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object") return [
                            2 /*return*/ ,
                            state_1.value
                        ];
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return StandardRetryStrategy;
}();

});
parcelRegister("7FTSs", function(module, exports) {

$parcel$export(module.exports, "isRetryableByTrait", function () { return $5967b4d2081fd6b2$export$46428803f4bd8a0c; });
$parcel$export(module.exports, "isClockSkewError", function () { return $5967b4d2081fd6b2$export$7b87435661177a94; });
$parcel$export(module.exports, "isThrottlingError", function () { return $5967b4d2081fd6b2$export$cbecb89f6256ccc8; });
$parcel$export(module.exports, "isTransientError", function () { return $5967b4d2081fd6b2$export$31778435da988512; });

var $d5kUc = parcelRequire("d5kUc");
var $5967b4d2081fd6b2$export$46428803f4bd8a0c = function(error) {
    return error.$retryable !== undefined;
};
var $5967b4d2081fd6b2$export$7b87435661177a94 = function(error) {
    return (0, $d5kUc.CLOCK_SKEW_ERROR_CODES).includes(error.name);
};
var $5967b4d2081fd6b2$export$cbecb89f6256ccc8 = function(error) {
    var _a;
    return (0, $d5kUc.THROTTLING_ERROR_CODES).includes(error.name) || ((_a = error.$retryable) === null || _a === void 0 ? void 0 : _a.throttling) == true;
};
var $5967b4d2081fd6b2$export$31778435da988512 = function(error) {
    var _a;
    return (0, $d5kUc.TRANSIENT_ERROR_CODES).includes(error.name) || (0, $d5kUc.TRANSIENT_ERROR_STATUS_CODES).includes(((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) || 0);
};

});
parcelRegister("d5kUc", function(module, exports) {

$parcel$export(module.exports, "CLOCK_SKEW_ERROR_CODES", function () { return $986bf55cb0ff4567$export$9fde012b8b2a10ca; });
$parcel$export(module.exports, "THROTTLING_ERROR_CODES", function () { return $986bf55cb0ff4567$export$89cd1b0ccfcb99d; });
$parcel$export(module.exports, "TRANSIENT_ERROR_CODES", function () { return $986bf55cb0ff4567$export$18bd3bfe89ded398; });
$parcel$export(module.exports, "TRANSIENT_ERROR_STATUS_CODES", function () { return $986bf55cb0ff4567$export$38bf589d26009e4f; });
/**
 * Errors encountered when the client clock and server clock cannot agree on the
 * current time.
 *
 * These errors are retryable, assuming the SDK has enabled clock skew
 * correction.
 */ var $986bf55cb0ff4567$export$9fde012b8b2a10ca = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
var $986bf55cb0ff4567$export$89cd1b0ccfcb99d = [
    "Throttling",
    "ThrottlingException",
    "ThrottledException",
    "RequestThrottledException",
    "TooManyRequestsException",
    "ProvisionedThroughputExceededException",
    "TransactionInProgressException",
    "RequestLimitExceeded",
    "BandwidthLimitExceeded",
    "LimitExceededException",
    "RequestThrottled",
    "SlowDown",
    "PriorRequestNotComplete",
    "EC2ThrottledException"
];
var $986bf55cb0ff4567$export$18bd3bfe89ded398 = [
    "AbortError",
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
var $986bf55cb0ff4567$export$38bf589d26009e4f = [
    500,
    502,
    503,
    504
];

});


parcelRegister("l6YtW", function(module, exports) {

var $7iClT = parcelRequire("7iClT");

var $lgotL = parcelRequire("lgotL");
var $f5e912f004354eb1$var$uuid = $lgotL;
$f5e912f004354eb1$var$uuid.v1 = $7iClT;
$f5e912f004354eb1$var$uuid.v4 = $lgotL;
module.exports = $f5e912f004354eb1$var$uuid;

});
parcelRegister("7iClT", function(module, exports) {

var $kd8ff = parcelRequire("kd8ff");

var $5cVf4 = parcelRequire("5cVf4");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $5507f6c87dc64f25$var$_nodeId;
var $5507f6c87dc64f25$var$_clockseq;
// Previous uuid creation time
var $5507f6c87dc64f25$var$_lastMSecs = 0;
var $5507f6c87dc64f25$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $5507f6c87dc64f25$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $5507f6c87dc64f25$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $5507f6c87dc64f25$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $kd8ff();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $5507f6c87dc64f25$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $5507f6c87dc64f25$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $5507f6c87dc64f25$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $5507f6c87dc64f25$var$_lastMSecs + (nsecs - $5507f6c87dc64f25$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $5507f6c87dc64f25$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $5507f6c87dc64f25$var$_lastMSecs = msecs;
    $5507f6c87dc64f25$var$_lastNSecs = nsecs;
    $5507f6c87dc64f25$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $5cVf4(b);
}
module.exports = $5507f6c87dc64f25$var$v1;

});
parcelRegister("kd8ff", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $eb6b6acc71fc1b63$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($eb6b6acc71fc1b63$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $eb6b6acc71fc1b63$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $eb6b6acc71fc1b63$var$getRandomValues($eb6b6acc71fc1b63$var$rnds8);
        return $eb6b6acc71fc1b63$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $eb6b6acc71fc1b63$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $eb6b6acc71fc1b63$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $eb6b6acc71fc1b63$var$rnds;
    };
}

});

parcelRegister("5cVf4", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $3caa79d7907288b8$var$byteToHex = [];
for(var $3caa79d7907288b8$var$i = 0; $3caa79d7907288b8$var$i < 256; ++$3caa79d7907288b8$var$i)$3caa79d7907288b8$var$byteToHex[$3caa79d7907288b8$var$i] = ($3caa79d7907288b8$var$i + 0x100).toString(16).substr(1);
function $3caa79d7907288b8$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $3caa79d7907288b8$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $3caa79d7907288b8$var$bytesToUuid;

});


parcelRegister("lgotL", function(module, exports) {

var $kd8ff = parcelRequire("kd8ff");

var $5cVf4 = parcelRequire("5cVf4");
function $f7ae14a534451384$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $kd8ff)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $5cVf4(rnds);
}
module.exports = $f7ae14a534451384$var$v4;

});


parcelRegister("cqVIR", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RETRY_DELAY_BASE", function () { return $90d4b03940d9151d$export$7067ba90effbd789; });
$parcel$export(module.exports, "MAXIMUM_RETRY_DELAY", function () { return $90d4b03940d9151d$export$2412c80d04e902c6; });
$parcel$export(module.exports, "THROTTLING_RETRY_DELAY_BASE", function () { return $90d4b03940d9151d$export$4af31f8250b48e23; });
$parcel$export(module.exports, "INITIAL_RETRY_TOKENS", function () { return $90d4b03940d9151d$export$f8c3d11675a1153; });
$parcel$export(module.exports, "RETRY_COST", function () { return $90d4b03940d9151d$export$797febae1136bc84; });
$parcel$export(module.exports, "TIMEOUT_RETRY_COST", function () { return $90d4b03940d9151d$export$b643545eaf9af837; });
$parcel$export(module.exports, "NO_RETRY_INCREMENT", function () { return $90d4b03940d9151d$export$a25da3406dc148e4; });
/**
 * The base number of milliseconds to use in calculating a suitable cool-down
 * time when a retryable error is encountered.
 */ var $90d4b03940d9151d$export$7067ba90effbd789 = 100;
var $90d4b03940d9151d$export$2412c80d04e902c6 = 20000;
var $90d4b03940d9151d$export$4af31f8250b48e23 = 500;
var $90d4b03940d9151d$export$f8c3d11675a1153 = 500;
var $90d4b03940d9151d$export$797febae1136bc84 = 5;
var $90d4b03940d9151d$export$b643545eaf9af837 = 10;
var $90d4b03940d9151d$export$a25da3406dc148e4 = 1;

});

parcelRegister("eUXj4", function(module, exports) {

$parcel$export(module.exports, "getDefaultRetryQuota", function () { return $adc44cb15cabae0e$export$2ebe7988802fc284; });

var $cqVIR = parcelRequire("cqVIR");
var $adc44cb15cabae0e$export$2ebe7988802fc284 = function(initialRetryTokens) {
    var MAX_CAPACITY = initialRetryTokens;
    var availableCapacity = initialRetryTokens;
    var getCapacityAmount = function(error) {
        return error.name === "TimeoutError" ? (0, $cqVIR.TIMEOUT_RETRY_COST) : (0, $cqVIR.RETRY_COST);
    };
    var hasRetryTokens = function(error) {
        return getCapacityAmount(error) <= availableCapacity;
    };
    var retrieveRetryTokens = function(error) {
        if (!hasRetryTokens(error)) // retryStrategy should stop retrying, and return last error
        throw new Error("No retry token available");
        var capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    var releaseRetryTokens = function(capacityReleaseAmount) {
        availableCapacity += capacityReleaseAmount !== null && capacityReleaseAmount !== void 0 ? capacityReleaseAmount : (0, $cqVIR.NO_RETRY_INCREMENT);
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};

});

parcelRegister("63tv9", function(module, exports) {

$parcel$export(module.exports, "defaultDelayDecider", function () { return $4689e848060e96f5$export$1cddd42598a3b1f6; });

var $cqVIR = parcelRequire("cqVIR");
var $4689e848060e96f5$export$1cddd42598a3b1f6 = function(delayBase, attempts) {
    return Math.floor(Math.min((0, $cqVIR.MAXIMUM_RETRY_DELAY), Math.random() * Math.pow(2, attempts) * delayBase));
};

});

parcelRegister("hBiBz", function(module, exports) {

$parcel$export(module.exports, "defaultRetryDecider", function () { return $cd0452ea669ba8ed$export$3839fd261f89ec2; });

var $7FTSs = parcelRequire("7FTSs");
var $cd0452ea669ba8ed$export$3839fd261f89ec2 = function(error) {
    if (!error) return false;
    return (0, $7FTSs.isRetryableByTrait)(error) || (0, $7FTSs.isClockSkewError)(error) || (0, $7FTSs.isThrottlingError)(error) || (0, $7FTSs.isTransientError)(error);
};

});


parcelRegister("bprgV", function(module, exports) {

$parcel$export(module.exports, "resolveRetryConfig", function () { return $84e72f2466a56711$export$ca7f6138f2c98476; });

var $fH1jI = parcelRequire("fH1jI");

var $hxaUp = parcelRequire("hxaUp");
var $84e72f2466a56711$export$a19952f9e421517c = "AWS_MAX_ATTEMPTS";
var $84e72f2466a56711$export$9ae8a04532f798bc = "max_attempts";
var $84e72f2466a56711$export$8023fdddb2ca30e0 = {
    environmentVariableSelector: function(env) {
        var value = env[$84e72f2466a56711$export$a19952f9e421517c];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Environment variable " + $84e72f2466a56711$export$a19952f9e421517c + " mast be a number, got \"" + value + "\"");
        return maxAttempt;
    },
    configFileSelector: function(profile) {
        var value = profile[$84e72f2466a56711$export$9ae8a04532f798bc];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Shared config file entry " + $84e72f2466a56711$export$9ae8a04532f798bc + " mast be a number, got \"" + value + "\"");
        return maxAttempt;
    },
    default: (0, $hxaUp.DEFAULT_MAX_ATTEMPTS)
};
var $84e72f2466a56711$export$ca7f6138f2c98476 = function(input) {
    var maxAttempts = $84e72f2466a56711$var$normalizeMaxAttempts(input.maxAttempts);
    return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, input), {
        maxAttempts: maxAttempts,
        retryStrategy: input.retryStrategy || new (0, $hxaUp.StandardRetryStrategy)(maxAttempts)
    });
};
var $84e72f2466a56711$var$normalizeMaxAttempts = function(maxAttempts) {
    if (maxAttempts === void 0) maxAttempts = (0, $hxaUp.DEFAULT_MAX_ATTEMPTS);
    if (typeof maxAttempts === "number") {
        var promisified_1 = Promise.resolve(maxAttempts);
        return function() {
            return promisified_1;
        };
    }
    return maxAttempts;
};
var $84e72f2466a56711$export$4728af91ff39ef3b = "AWS_RETRY_MODE";
var $84e72f2466a56711$export$c5c0171a17765aea = "retry_mode";
var $84e72f2466a56711$export$972bf2bb01959ff5 = {
    environmentVariableSelector: function(env) {
        return env[$84e72f2466a56711$export$4728af91ff39ef3b];
    },
    configFileSelector: function(profile) {
        return profile[$84e72f2466a56711$export$c5c0171a17765aea];
    },
    default: (0, $hxaUp.DEFAULT_RETRY_MODE)
};

});


parcelRegister("b3bpS", function(module, exports) {

$parcel$export(module.exports, "parseUrl", function () { return $80b8d48f6a15a0e7$export$7a5253c0f62e0150; });

var $c34CS = parcelRequire("c34CS");
var $80b8d48f6a15a0e7$export$7a5253c0f62e0150 = function(url) {
    var _a = new URL(url), hostname = _a.hostname, pathname = _a.pathname, port = _a.port, protocol = _a.protocol, search = _a.search;
    var query;
    if (search) query = (0, $c34CS.parseQueryString)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};

});
parcelRegister("c34CS", function(module, exports) {

$parcel$export(module.exports, "parseQueryString", function () { return $8c595a804e4cc451$export$66256f83798e5415; });

var $fH1jI = parcelRequire("fH1jI");
function $8c595a804e4cc451$export$66256f83798e5415(querystring) {
    var e_1, _a;
    var query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) try {
        for(var _b = (0, $fH1jI.__values)(querystring.split("&")), _c = _b.next(); !_c.done; _c = _b.next()){
            var pair = _c.value;
            var _d = (0, $fH1jI.__read)(pair.split("="), 2), key = _d[0], _e = _d[1], value = _e === void 0 ? null : _e;
            key = decodeURIComponent(key);
            if (value) value = decodeURIComponent(value);
            if (!(key in query)) query[key] = value;
            else if (Array.isArray(query[key])) query[key].push(value);
            else query[key] = [
                query[key],
                value
            ];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return query;
}

});


parcelRegister("6AFBv", function(module, exports) {

$parcel$export(module.exports, "calculateBodyLength", function () { return $4cc6608a891b548f$export$967f3527bf233bc0; });
function $4cc6608a891b548f$export$967f3527bf233bc0(body) {
    if (typeof body === "string") {
        var len = body.length;
        for(var i = len - 1; i >= 0; i--){
            var code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
        }
        return len;
    } else if (typeof body.byteLength === "number") // handles Uint8Array, ArrayBuffer, Buffer, and ArrayBufferView
    return body.byteLength;
    else if (typeof body.size === "number") // handles browser File object
    return body.size;
}

});

parcelRegister("jc6bn", function(module, exports) {

$parcel$export(module.exports, "defaultUserAgent", function () { return $039b290452c36caf$export$69d579f32876892f; });
function $039b290452c36caf$export$69d579f32876892f(packageName, packageVersion) {
    var originUserAgent = typeof navigator !== "undefined" && typeof navigator.userAgent === "string" ? navigator.userAgent : "";
    return "aws-sdk-js-v3-" + packageName + "/" + packageVersion + " " + originUserAgent;
}

});

parcelRegister("giq9Q", function(module, exports) {

$parcel$export(module.exports, "ClientSharedValues", function () { return $bdd29e2e15bd87ac$export$608864383388f904; });

var $aALFb = parcelRequire("aALFb");
var $bdd29e2e15bd87ac$export$608864383388f904 = {
    apiVersion: "2014-06-30",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: (0, $aALFb.defaultRegionInfoProvider),
    signingName: "cognito-identity"
};

});
parcelRegister("aALFb", function(module, exports) {

$parcel$export(module.exports, "defaultRegionInfoProvider", function () { return $7b623d14f9894040$export$2e4318bf13462aa2; });
// Partition default templates
var $7b623d14f9894040$var$AWS_TEMPLATE = "cognito-identity.{region}.amazonaws.com";
var $7b623d14f9894040$var$AWS_CN_TEMPLATE = "cognito-identity.{region}.amazonaws.com.cn";
var $7b623d14f9894040$var$AWS_ISO_TEMPLATE = "cognito-identity.{region}.c2s.ic.gov";
var $7b623d14f9894040$var$AWS_ISO_B_TEMPLATE = "cognito-identity.{region}.sc2s.sgov.gov";
var $7b623d14f9894040$var$AWS_US_GOV_TEMPLATE = "cognito-identity.{region}.amazonaws.com";
// Partition regions
var $7b623d14f9894040$var$AWS_REGIONS = new Set([
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2"
]);
var $7b623d14f9894040$var$AWS_CN_REGIONS = new Set([
    "cn-north-1",
    "cn-northwest-1"
]);
var $7b623d14f9894040$var$AWS_ISO_REGIONS = new Set([
    "us-iso-east-1"
]);
var $7b623d14f9894040$var$AWS_ISO_B_REGIONS = new Set([
    "us-isob-east-1"
]);
var $7b623d14f9894040$var$AWS_US_GOV_REGIONS = new Set([
    "us-gov-east-1",
    "us-gov-west-1"
]);
var $7b623d14f9894040$export$2e4318bf13462aa2 = function(region, options) {
    var regionInfo = undefined;
    switch(region){
        // First, try to match exact region names.
        case "ap-northeast-1":
            regionInfo = {
                hostname: "cognito-identity.ap-northeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-2":
            regionInfo = {
                hostname: "cognito-identity.ap-northeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-south-1":
            regionInfo = {
                hostname: "cognito-identity.ap-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-1":
            regionInfo = {
                hostname: "cognito-identity.ap-southeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-2":
            regionInfo = {
                hostname: "cognito-identity.ap-southeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ca-central-1":
            regionInfo = {
                hostname: "cognito-identity.ca-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "cn-north-1":
            regionInfo = {
                hostname: "cognito-identity.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "eu-central-1":
            regionInfo = {
                hostname: "cognito-identity.eu-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-1":
            regionInfo = {
                hostname: "cognito-identity.eu-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-2":
            regionInfo = {
                hostname: "cognito-identity.eu-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-1":
            regionInfo = {
                hostname: "cognito-identity.us-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-2":
            regionInfo = {
                hostname: "cognito-identity.us-east-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-west-2":
            regionInfo = {
                hostname: "cognito-identity.us-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        // Next, try to match partition endpoints.
        default:
            if ($7b623d14f9894040$var$AWS_REGIONS.has(region)) regionInfo = {
                hostname: $7b623d14f9894040$var$AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
            if ($7b623d14f9894040$var$AWS_CN_REGIONS.has(region)) regionInfo = {
                hostname: $7b623d14f9894040$var$AWS_CN_TEMPLATE.replace("{region}", region),
                partition: "aws-cn"
            };
            if ($7b623d14f9894040$var$AWS_ISO_REGIONS.has(region)) regionInfo = {
                hostname: $7b623d14f9894040$var$AWS_ISO_TEMPLATE.replace("{region}", region),
                partition: "aws-iso"
            };
            if ($7b623d14f9894040$var$AWS_ISO_B_REGIONS.has(region)) regionInfo = {
                hostname: $7b623d14f9894040$var$AWS_ISO_B_TEMPLATE.replace("{region}", region),
                partition: "aws-iso-b"
            };
            if ($7b623d14f9894040$var$AWS_US_GOV_REGIONS.has(region)) regionInfo = {
                hostname: $7b623d14f9894040$var$AWS_US_GOV_TEMPLATE.replace("{region}", region),
                partition: "aws-us-gov"
            };
            // Finally, assume it's an AWS partition endpoint.
            if (regionInfo === undefined) regionInfo = {
                hostname: $7b623d14f9894040$var$AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
    }
    return Promise.resolve(regionInfo);
};

});



parcelRegister("eKUPO", function(module, exports) {
$parcel$export(module.exports, "resolveEndpointsConfig", function () { return (parcelRequire("8dzJz")).resolveEndpointsConfig; });
$parcel$export(module.exports, "resolveRegionConfig", function () { return (parcelRequire("auJcL")).resolveRegionConfig; });
parcelRequire("8dzJz");
parcelRequire("auJcL");

});
parcelRegister("8dzJz", function(module, exports) {

$parcel$export(module.exports, "resolveEndpointsConfig", function () { return $5fbb41ae82042af7$export$24f352b1bd1e2f8b; });

var $fH1jI = parcelRequire("fH1jI");
var $5fbb41ae82042af7$export$24f352b1bd1e2f8b = function(input) {
    var _a;
    return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: input.endpoint ? $5fbb41ae82042af7$var$normalizeEndpoint(input) : function() {
            return $5fbb41ae82042af7$var$getEndPointFromRegion(input);
        },
        isCustomEndpoint: input.endpoint ? true : false
    });
};
var $5fbb41ae82042af7$var$normalizeEndpoint = function(input) {
    var endpoint = input.endpoint, urlParser = input.urlParser;
    if (typeof endpoint === "string") {
        var promisified_1 = Promise.resolve(urlParser(endpoint));
        return function() {
            return promisified_1;
        };
    } else if (typeof endpoint === "object") {
        var promisified_2 = Promise.resolve(endpoint);
        return function() {
            return promisified_2;
        };
    }
    return endpoint;
};
var $5fbb41ae82042af7$var$getEndPointFromRegion = function(input) {
    return (0, $fH1jI.__awaiter)(void 0, void 0, void 0, function() {
        var _a, tls, region, dnsHostRegex, hostname;
        var _b;
        return (0, $fH1jI.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = input.tls, tls = _a === void 0 ? true : _a;
                    return [
                        4 /*yield*/ ,
                        input.region()
                    ];
                case 1:
                    region = _c.sent();
                    dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
                    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
                    return [
                        4 /*yield*/ ,
                        input.regionInfoProvider(region)
                    ];
                case 2:
                    hostname = ((_b = _c.sent()) !== null && _b !== void 0 ? _b : {}).hostname;
                    if (!hostname) throw new Error("Cannot resolve hostname from client config");
                    return [
                        2 /*return*/ ,
                        input.urlParser((tls ? "https:" : "http:") + "//" + hostname)
                    ];
            }
        });
    });
};

});

parcelRegister("auJcL", function(module, exports) {

$parcel$export(module.exports, "resolveRegionConfig", function () { return $7a3fc57a360335d7$export$7696ef37558bd0ec; });

var $fH1jI = parcelRequire("fH1jI");
var $7a3fc57a360335d7$export$26513716e2900bad = "AWS_REGION";
var $7a3fc57a360335d7$export$8afb1c306a7d01b = "region";
var $7a3fc57a360335d7$export$1509d3ea54119a08 = {
    environmentVariableSelector: function(env) {
        return env[$7a3fc57a360335d7$export$26513716e2900bad];
    },
    configFileSelector: function(profile) {
        return profile[$7a3fc57a360335d7$export$8afb1c306a7d01b];
    },
    default: function() {
        throw new Error("Region is missing");
    }
};
var $7a3fc57a360335d7$export$9a37503ca194454d = {
    preferredFile: "credentials"
};
var $7a3fc57a360335d7$export$7696ef37558bd0ec = function(input) {
    if (!input.region) throw new Error("Region is missing");
    return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, input), {
        region: $7a3fc57a360335d7$var$normalizeRegion(input.region)
    });
};
var $7a3fc57a360335d7$var$normalizeRegion = function(region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function() {
            return promisified_1;
        };
    }
    return region;
};

});


parcelRegister("d0jvP", function(module, exports) {

$parcel$export(module.exports, "getContentLengthPlugin", function () { return $977a6933623ed034$export$7e6ddf9365a30fe9; });

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("1J0sw");
var $jmMP9 = parcelRequire("jmMP9");
var $977a6933623ed034$var$CONTENT_LENGTH_HEADER = "content-length";
function $977a6933623ed034$export$940b29eb2788b975(bodyLengthChecker) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, $fH1jI.__awaiter)(_this, void 0, void 0, function() {
                var request, body, headers, length;
                var _a;
                return (0, $fH1jI.__generator)(this, function(_b) {
                    request = args.request;
                    if ((0, $jmMP9.HttpRequest).isInstance(request)) {
                        body = request.body, headers = request.headers;
                        if (body && Object.keys(headers).map(function(str) {
                            return str.toLowerCase();
                        }).indexOf($977a6933623ed034$var$CONTENT_LENGTH_HEADER) === -1) {
                            length = bodyLengthChecker(body);
                            if (length !== undefined) request.headers = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, request.headers), (_a = {}, _a[$977a6933623ed034$var$CONTENT_LENGTH_HEADER] = String(length), _a));
                        }
                    }
                    return [
                        2 /*return*/ ,
                        next((0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
}
var $977a6933623ed034$export$1f7816f8f350b2f5 = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware"
};
var $977a6933623ed034$export$7e6ddf9365a30fe9 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($977a6933623ed034$export$940b29eb2788b975(options.bodyLengthChecker), $977a6933623ed034$export$1f7816f8f350b2f5);
        }
    };
};

});

parcelRegister("8rZ2X", function(module, exports) {

$parcel$export(module.exports, "resolveHostHeaderConfig", function () { return $627032f236cb6442$export$c1625bf0b32b4481; });
$parcel$export(module.exports, "getHostHeaderPlugin", function () { return $627032f236cb6442$export$23d3b647211be53a; });

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("1J0sw");
var $jmMP9 = parcelRequire("jmMP9");
function $627032f236cb6442$export$c1625bf0b32b4481(input) {
    return input;
}
var $627032f236cb6442$export$858685d7aeef192d = function(options) {
    return function(next) {
        return function(args) {
            return (0, $fH1jI.__awaiter)(void 0, void 0, void 0, function() {
                var request, _a, handlerProtocol;
                return (0, $fH1jI.__generator)(this, function(_b) {
                    if (!(0, $jmMP9.HttpRequest).isInstance(args.request)) return [
                        2 /*return*/ ,
                        next(args)
                    ];
                    request = args.request;
                    _a = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a === void 0 ? "" : _a;
                    //For H2 request, remove 'host' header and use ':authority' header instead
                    //reference: https://nodejs.org/dist/latest-v13.x/docs/api/errors.html#ERR_HTTP2_INVALID_CONNECTION_HEADERS
                    if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                        delete request.headers["host"];
                        request.headers[":authority"] = "";
                    //non-H2 request and 'host' header is not set, set the 'host' header to request's hostname.
                    } else if (!request.headers["host"]) request.headers["host"] = request.hostname;
                    return [
                        2 /*return*/ ,
                        next(args)
                    ];
                });
            });
        };
    };
};
var $627032f236cb6442$export$696d244ba96181e8 = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ]
};
var $627032f236cb6442$export$23d3b647211be53a = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($627032f236cb6442$export$858685d7aeef192d(options), $627032f236cb6442$export$696d244ba96181e8);
        }
    };
};

});

parcelRegister("jyqb9", function(module, exports) {
$parcel$export(module.exports, "getLoggerPlugin", function () { return (parcelRequire("7Gq7f")).getLoggerPlugin; });
parcelRequire("7Gq7f");

});
parcelRegister("7Gq7f", function(module, exports) {

$parcel$export(module.exports, "getLoggerPlugin", function () { return $5980b6b59b5d280a$export$f6ef65d7766fc255; });

var $fH1jI = parcelRequire("fH1jI");
var $5980b6b59b5d280a$export$fe0e777ee4f58cde = function() {
    return function(next, context) {
        return function(args) {
            return (0, $fH1jI.__awaiter)(void 0, void 0, void 0, function() {
                var logger, response, httpResponse;
                var _a;
                return (0, $fH1jI.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            logger = context.logger;
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            response = _b.sent();
                            if (!logger) return [
                                2 /*return*/ ,
                                response
                            ];
                            httpResponse = response.response;
                            if (typeof logger.info === "function") logger.info({
                                metadata: {
                                    statusCode: httpResponse.statusCode,
                                    requestId: (_a = httpResponse.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : httpResponse.headers["x-amzn-request-id"],
                                    extendedRequestId: httpResponse.headers["x-amz-id-2"],
                                    cfId: httpResponse.headers["x-amz-cf-id"]
                                }
                            });
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var $5980b6b59b5d280a$export$877c148ab4ad0722 = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize"
};
var $5980b6b59b5d280a$export$f6ef65d7766fc255 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($5980b6b59b5d280a$export$fe0e777ee4f58cde(), $5980b6b59b5d280a$export$877c148ab4ad0722);
        }
    };
};

});


parcelRegister("fGFVS", function(module, exports) {
$parcel$export(module.exports, "resolveAwsAuthConfig", function () { return (parcelRequire("gcXH0")).resolveAwsAuthConfig; });
$parcel$export(module.exports, "getAwsAuthPlugin", function () { return (parcelRequire("1TJTS")).getAwsAuthPlugin; });
parcelRequire("gcXH0");
parcelRequire("1TJTS");

});
parcelRegister("gcXH0", function(module, exports) {

$parcel$export(module.exports, "resolveAwsAuthConfig", function () { return $bccc120f4939c1ce$export$1dd62920de1feabb; });

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("c5yxD");
var $djgro = parcelRequire("djgro");
function $bccc120f4939c1ce$export$1dd62920de1feabb(input) {
    var _this = this;
    var credentials = input.credentials || input.credentialDefaultProvider(input);
    var normalizedCreds = $bccc120f4939c1ce$var$normalizeProvider(credentials);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) //if signer is supplied by user, normalize it to a function returning a promise for signer.
    signer = $bccc120f4939c1ce$var$normalizeProvider(input.signer);
    else //construct a provider inferring signing from region.
    signer = function() {
        return $bccc120f4939c1ce$var$normalizeProvider(input.region)().then(function(region) {
            return (0, $fH1jI.__awaiter)(_this, void 0, void 0, function() {
                return (0, $fH1jI.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                input.regionInfoProvider(region)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                [
                                    _a.sent() || {},
                                    region
                                ]
                            ];
                    }
                });
            });
        }).then(function(_a) {
            var _b = (0, $fH1jI.__read)(_a, 2), regionInfo = _b[0], region = _b[1];
            var _c = regionInfo.signingRegion, signingRegion = _c === void 0 ? input.signingRegion : _c, _d = regionInfo.signingService, signingService = _d === void 0 ? input.signingName : _d;
            //update client's singing region and signing service config if they are resolved.
            //signing region resolving order: user supplied signingRegion -> endpoints.json inferred region -> client region
            input.signingRegion = input.signingRegion || signingRegion || region;
            input.signingName = input.signingName || signingService;
            return new (0, $djgro.SignatureV4)({
                credentials: normalizedCreds,
                region: input.signingRegion,
                service: input.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            });
        });
    };
    return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
}
function $bccc120f4939c1ce$var$normalizeProvider(input) {
    if (typeof input === "object") {
        var promisified_1 = Promise.resolve(input);
        return function() {
            return promisified_1;
        };
    }
    return input;
}

});
parcelRegister("c5yxD", function(module, exports) {
$parcel$export(module.exports, "SignatureV4", function () { return (parcelRequire("djgro")).SignatureV4; });
parcelRequire("3Tj8T");
parcelRequire("djgro");

});
parcelRegister("3Tj8T", function(module, exports) {

$parcel$export(module.exports, "createScope", function () { return $2d555b7534ccdc56$export$41a9651decfe2bde; });
$parcel$export(module.exports, "getSigningKey", function () { return $2d555b7534ccdc56$export$8b95a069d16dd783; });

var $fH1jI = parcelRequire("fH1jI");

var $eLZSV = parcelRequire("eLZSV");
var $2d555b7534ccdc56$var$signingKeyCache = {};
var $2d555b7534ccdc56$var$cacheQueue = [];
function $2d555b7534ccdc56$export$41a9651decfe2bde(shortDate, region, service) {
    return shortDate + "/" + region + "/" + service + "/" + (0, $eLZSV.KEY_TYPE_IDENTIFIER);
}
function $2d555b7534ccdc56$export$8b95a069d16dd783(sha256Constructor, credentials, shortDate, region, service) {
    var cacheKey = shortDate + ":" + region + ":" + service + ":" + (credentials.accessKeyId + ":" + credentials.sessionToken);
    if (cacheKey in $2d555b7534ccdc56$var$signingKeyCache) return $2d555b7534ccdc56$var$signingKeyCache[cacheKey];
    $2d555b7534ccdc56$var$cacheQueue.push(cacheKey);
    while($2d555b7534ccdc56$var$cacheQueue.length > (0, $eLZSV.MAX_CACHE_SIZE))delete $2d555b7534ccdc56$var$signingKeyCache[$2d555b7534ccdc56$var$cacheQueue.shift()];
    return $2d555b7534ccdc56$var$signingKeyCache[cacheKey] = new Promise(function(resolve, reject) {
        var e_1, _a;
        var keyPromise = Promise.resolve("AWS4" + credentials.secretAccessKey);
        var _loop_1 = function(signable) {
            keyPromise = keyPromise.then(function(intermediateKey) {
                return $2d555b7534ccdc56$var$hmac(sha256Constructor, intermediateKey, signable);
            });
            keyPromise.catch(function() {});
        };
        try {
            for(var _b = (0, $fH1jI.__values)([
                shortDate,
                region,
                service,
                (0, $eLZSV.KEY_TYPE_IDENTIFIER)
            ]), _c = _b.next(); !_c.done; _c = _b.next()){
                var signable = _c.value;
                _loop_1(signable);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        keyPromise.then(resolve, function(reason) {
            delete $2d555b7534ccdc56$var$signingKeyCache[cacheKey];
            reject(reason);
        });
    });
}
function $2d555b7534ccdc56$export$a31b95746ea0a30a() {
    $2d555b7534ccdc56$var$cacheQueue.length = 0;
    Object.keys($2d555b7534ccdc56$var$signingKeyCache).forEach(function(cacheKey) {
        delete $2d555b7534ccdc56$var$signingKeyCache[cacheKey];
    });
}
function $2d555b7534ccdc56$var$hmac(ctor, secret, data) {
    var hash = new ctor(secret);
    hash.update(data);
    return hash.digest();
}

});
parcelRegister("eLZSV", function(module, exports) {

$parcel$export(module.exports, "ALGORITHM_QUERY_PARAM", function () { return $ac15758ae24cb55e$export$186cd8495ba0377d; });
$parcel$export(module.exports, "CREDENTIAL_QUERY_PARAM", function () { return $ac15758ae24cb55e$export$5c8e6dd7758f59d6; });
$parcel$export(module.exports, "AMZ_DATE_QUERY_PARAM", function () { return $ac15758ae24cb55e$export$6e114beec37430d7; });
$parcel$export(module.exports, "SIGNED_HEADERS_QUERY_PARAM", function () { return $ac15758ae24cb55e$export$2dcbb254f883c238; });
$parcel$export(module.exports, "EXPIRES_QUERY_PARAM", function () { return $ac15758ae24cb55e$export$a0afe6f3bbfaf76e; });
$parcel$export(module.exports, "SIGNATURE_QUERY_PARAM", function () { return $ac15758ae24cb55e$export$41ae838dc1e0f082; });
$parcel$export(module.exports, "TOKEN_QUERY_PARAM", function () { return $ac15758ae24cb55e$export$8e1383b7eea7bee; });
$parcel$export(module.exports, "AUTH_HEADER", function () { return $ac15758ae24cb55e$export$9924a64a4b8b0d58; });
$parcel$export(module.exports, "AMZ_DATE_HEADER", function () { return $ac15758ae24cb55e$export$acf4b8bdf24aab34; });
$parcel$export(module.exports, "GENERATED_HEADERS", function () { return $ac15758ae24cb55e$export$20d6a73fd0b10982; });
$parcel$export(module.exports, "SIGNATURE_HEADER", function () { return $ac15758ae24cb55e$export$29961f34c719157e; });
$parcel$export(module.exports, "SHA256_HEADER", function () { return $ac15758ae24cb55e$export$eaef12179141669a; });
$parcel$export(module.exports, "TOKEN_HEADER", function () { return $ac15758ae24cb55e$export$fdc81b663012a8d2; });
$parcel$export(module.exports, "ALWAYS_UNSIGNABLE_HEADERS", function () { return $ac15758ae24cb55e$export$8ffdcd58c4092560; });
$parcel$export(module.exports, "PROXY_HEADER_PATTERN", function () { return $ac15758ae24cb55e$export$8085db98abbe0597; });
$parcel$export(module.exports, "SEC_HEADER_PATTERN", function () { return $ac15758ae24cb55e$export$758380400526c39; });
$parcel$export(module.exports, "ALGORITHM_IDENTIFIER", function () { return $ac15758ae24cb55e$export$863a63fba5b2ddf5; });
$parcel$export(module.exports, "EVENT_ALGORITHM_IDENTIFIER", function () { return $ac15758ae24cb55e$export$9a1f6cf06ac56167; });
$parcel$export(module.exports, "UNSIGNED_PAYLOAD", function () { return $ac15758ae24cb55e$export$91f7321b40d9fd07; });
$parcel$export(module.exports, "MAX_CACHE_SIZE", function () { return $ac15758ae24cb55e$export$bf665777b4a1722f; });
$parcel$export(module.exports, "KEY_TYPE_IDENTIFIER", function () { return $ac15758ae24cb55e$export$c4bf0942098f6bb; });
$parcel$export(module.exports, "MAX_PRESIGNED_TTL", function () { return $ac15758ae24cb55e$export$274df788bdcca184; });
var $ac15758ae24cb55e$export$186cd8495ba0377d = "X-Amz-Algorithm";
var $ac15758ae24cb55e$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
var $ac15758ae24cb55e$export$6e114beec37430d7 = "X-Amz-Date";
var $ac15758ae24cb55e$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
var $ac15758ae24cb55e$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
var $ac15758ae24cb55e$export$41ae838dc1e0f082 = "X-Amz-Signature";
var $ac15758ae24cb55e$export$8e1383b7eea7bee = "X-Amz-Security-Token";
var $ac15758ae24cb55e$export$9924a64a4b8b0d58 = "authorization";
var $ac15758ae24cb55e$export$acf4b8bdf24aab34 = $ac15758ae24cb55e$export$6e114beec37430d7.toLowerCase();
var $ac15758ae24cb55e$export$c65c8c9f514da472 = "date";
var $ac15758ae24cb55e$export$20d6a73fd0b10982 = [
    $ac15758ae24cb55e$export$9924a64a4b8b0d58,
    $ac15758ae24cb55e$export$acf4b8bdf24aab34,
    $ac15758ae24cb55e$export$c65c8c9f514da472
];
var $ac15758ae24cb55e$export$29961f34c719157e = $ac15758ae24cb55e$export$41ae838dc1e0f082.toLowerCase();
var $ac15758ae24cb55e$export$eaef12179141669a = "x-amz-content-sha256";
var $ac15758ae24cb55e$export$fdc81b663012a8d2 = $ac15758ae24cb55e$export$8e1383b7eea7bee.toLowerCase();
var $ac15758ae24cb55e$export$96307741595055fc = "host";
var $ac15758ae24cb55e$export$8ffdcd58c4092560 = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
var $ac15758ae24cb55e$export$8085db98abbe0597 = /^proxy-/;
var $ac15758ae24cb55e$export$758380400526c39 = /^sec-/;
var $ac15758ae24cb55e$export$94e2b626bfa803e0 = [
    /^proxy-/i,
    /^sec-/i
];
var $ac15758ae24cb55e$export$863a63fba5b2ddf5 = "AWS4-HMAC-SHA256";
var $ac15758ae24cb55e$export$9a1f6cf06ac56167 = "AWS4-HMAC-SHA256-PAYLOAD";
var $ac15758ae24cb55e$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";
var $ac15758ae24cb55e$export$bf665777b4a1722f = 50;
var $ac15758ae24cb55e$export$c4bf0942098f6bb = "aws4_request";
var $ac15758ae24cb55e$export$274df788bdcca184 = 604800;

});


parcelRegister("djgro", function(module, exports) {

$parcel$export(module.exports, "SignatureV4", function () { return $9b09cd886d100e10$export$20baf4d3f65eb30c; });

var $fH1jI = parcelRequire("fH1jI");

var $6bdTj = parcelRequire("6bdTj");

var $eLZSV = parcelRequire("eLZSV");

var $3Tj8T = parcelRequire("3Tj8T");

var $bSJct = parcelRequire("bSJct");

var $hT594 = parcelRequire("hT594");

var $3nDC5 = parcelRequire("3nDC5");

var $9CjQ6 = parcelRequire("9CjQ6");

var $j2VQN = parcelRequire("j2VQN");

var $hqmIG = parcelRequire("hqmIG");

var $ad3xN = parcelRequire("ad3xN");
var $9b09cd886d100e10$export$20baf4d3f65eb30c = /** @class */ function() {
    function SignatureV4(_a) {
        var applyChecksum = _a.applyChecksum, credentials = _a.credentials, region = _a.region, service = _a.service, sha256 = _a.sha256, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        // default to true if applyChecksum isn't set
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = $9b09cd886d100e10$var$normalizeRegionProvider(region);
        this.credentialProvider = $9b09cd886d100e10$var$normalizeCredentialsProvider(credentials);
    }
    SignatureV4.prototype.presign = function(originalRequest, options) {
        if (options === void 0) options = {};
        return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
            var _a, signingDate, _b, expiresIn, unsignableHeaders, signableHeaders, signingRegion, signingService, credentials, region, _c, _d, longDate, shortDate, scope, request, canonicalHeaders, _e, _f, _g, _h, _j, _k;
            return (0, $fH1jI.__generator)(this, function(_l) {
                switch(_l.label){
                    case 0:
                        _a = options.signingDate, signingDate = _a === void 0 ? new Date() : _a, _b = options.expiresIn, expiresIn = _b === void 0 ? 3600 : _b, unsignableHeaders = options.unsignableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _l.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _c = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _c = _l.sent();
                        _l.label = 4;
                    case 4:
                        region = _c;
                        _d = $9b09cd886d100e10$var$formatDate(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
                        if (expiresIn > (0, $eLZSV.MAX_PRESIGNED_TTL)) return [
                            2 /*return*/ ,
                            Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future")
                        ];
                        scope = (0, $3Tj8T.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request = (0, $j2VQN.moveHeadersToQuery)((0, $hqmIG.prepareRequest)(originalRequest));
                        if (credentials.sessionToken) request.query[0, $eLZSV.TOKEN_QUERY_PARAM] = credentials.sessionToken;
                        request.query[0, $eLZSV.ALGORITHM_QUERY_PARAM] = (0, $eLZSV.ALGORITHM_IDENTIFIER);
                        request.query[0, $eLZSV.CREDENTIAL_QUERY_PARAM] = credentials.accessKeyId + "/" + scope;
                        request.query[0, $eLZSV.AMZ_DATE_QUERY_PARAM] = longDate;
                        request.query[0, $eLZSV.EXPIRES_QUERY_PARAM] = expiresIn.toString(10);
                        canonicalHeaders = (0, $bSJct.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        request.query[0, $eLZSV.SIGNED_HEADERS_QUERY_PARAM] = $9b09cd886d100e10$var$getCanonicalHeaderList(canonicalHeaders);
                        _e = request.query;
                        _f = (0, $eLZSV.SIGNATURE_QUERY_PARAM);
                        _g = this.getSignature;
                        _h = [
                            longDate,
                            scope,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                        _j = this.createCanonicalRequest;
                        _k = [
                            request,
                            canonicalHeaders
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $3nDC5.getPayloadHash)(originalRequest, this.sha256)
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _g.apply(this, _h.concat([
                                _j.apply(this, _k.concat([
                                    _l.sent()
                                ]))
                            ]))
                        ];
                    case 6:
                        _e[_f] = _l.sent();
                        return [
                            2 /*return*/ ,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.sign = function(toSign, options) {
        return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
            return (0, $fH1jI.__generator)(this, function(_a) {
                if (typeof toSign === "string") return [
                    2 /*return*/ ,
                    this.signString(toSign, options)
                ];
                else if (toSign.headers && toSign.payload) return [
                    2 /*return*/ ,
                    this.signEvent(toSign, options)
                ];
                else return [
                    2 /*return*/ ,
                    this.signRequest(toSign, options)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    SignatureV4.prototype.signEvent = function(_a, _b) {
        var headers = _a.headers, payload = _a.payload;
        var _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, priorSignature = _b.priorSignature, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
            var region, _d, _e, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, _f, stringToSign;
            return (0, $fH1jI.__generator)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 2:
                        _d = _g.sent();
                        _g.label = 3;
                    case 3:
                        region = _d;
                        _e = $9b09cd886d100e10$var$formatDate(signingDate), shortDate = _e.shortDate, longDate = _e.longDate;
                        scope = (0, $3Tj8T.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        return [
                            4 /*yield*/ ,
                            (0, $3nDC5.getPayloadHash)({
                                headers: {},
                                body: payload
                            }, this.sha256)
                        ];
                    case 4:
                        hashedPayload = _g.sent();
                        hash = new this.sha256();
                        hash.update(headers);
                        _f = (0, $6bdTj.toHex);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 5:
                        hashedHeaders = _f.apply(void 0, [
                            _g.sent()
                        ]);
                        stringToSign = [
                            (0, $eLZSV.EVENT_ALGORITHM_IDENTIFIER),
                            longDate,
                            scope,
                            priorSignature,
                            hashedHeaders,
                            hashedPayload
                        ].join("\n");
                        return [
                            2 /*return*/ ,
                            this.signString(stringToSign, {
                                signingDate: signingDate,
                                signingRegion: region,
                                signingService: signingService
                            })
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signString = function(stringToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, shortDate, hash, _e, _f, _g;
            return (0, $fH1jI.__generator)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _h.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _h.sent();
                        _h.label = 4;
                    case 4:
                        region = _d;
                        shortDate = $9b09cd886d100e10$var$formatDate(signingDate).shortDate;
                        _f = (_e = this.sha256).bind;
                        return [
                            4 /*yield*/ ,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                    case 5:
                        hash = new (_f.apply(_e, [
                            void 0,
                            _h.sent()
                        ]))();
                        hash.update(stringToSign);
                        _g = (0, $6bdTj.toHex);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            _g.apply(void 0, [
                                _h.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signRequest = function(requestToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signableHeaders = _b.signableHeaders, unsignableHeaders = _b.unsignableHeaders, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, request, _e, longDate, shortDate, scope, payloadHash, canonicalHeaders, signature;
            return (0, $fH1jI.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _f.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _f.sent();
                        _f.label = 4;
                    case 4:
                        region = _d;
                        request = (0, $hqmIG.prepareRequest)(requestToSign);
                        _e = $9b09cd886d100e10$var$formatDate(signingDate), longDate = _e.longDate, shortDate = _e.shortDate;
                        scope = (0, $3Tj8T.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request.headers[0, $eLZSV.AMZ_DATE_HEADER] = longDate;
                        if (credentials.sessionToken) request.headers[0, $eLZSV.TOKEN_HEADER] = credentials.sessionToken;
                        return [
                            4 /*yield*/ ,
                            (0, $3nDC5.getPayloadHash)(request, this.sha256)
                        ];
                    case 5:
                        payloadHash = _f.sent();
                        if (!(0, $9CjQ6.hasHeader)((0, $eLZSV.SHA256_HEADER), request.headers) && this.applyChecksum) request.headers[0, $eLZSV.SHA256_HEADER] = payloadHash;
                        canonicalHeaders = (0, $bSJct.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        return [
                            4 /*yield*/ ,
                            this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash))
                        ];
                    case 6:
                        signature = _f.sent();
                        request.headers[0, $eLZSV.AUTH_HEADER] = (0, $eLZSV.ALGORITHM_IDENTIFIER) + " " + ("Credential=" + credentials.accessKeyId + "/" + scope + ", ") + ("SignedHeaders=" + $9b09cd886d100e10$var$getCanonicalHeaderList(canonicalHeaders) + ", ") + ("Signature=" + signature);
                        return [
                            2 /*return*/ ,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.createCanonicalRequest = function(request, canonicalHeaders, payloadHash) {
        var sortedHeaders = Object.keys(canonicalHeaders).sort();
        return request.method + "\n" + this.getCanonicalPath(request) + "\n" + (0, $hT594.getCanonicalQuery)(request) + "\n" + sortedHeaders.map(function(name) {
            return name + ":" + canonicalHeaders[name];
        }).join("\n") + "\n\n" + sortedHeaders.join(";") + "\n" + payloadHash;
    };
    SignatureV4.prototype.createStringToSign = function(longDate, credentialScope, canonicalRequest) {
        return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
            var hash, hashedRequest;
            return (0, $fH1jI.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        hash = new this.sha256();
                        hash.update(canonicalRequest);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 1:
                        hashedRequest = _a.sent();
                        return [
                            2 /*return*/ ,
                            (0, $eLZSV.ALGORITHM_IDENTIFIER) + "\n" + longDate + "\n" + credentialScope + "\n" + (0, $6bdTj.toHex)(hashedRequest)
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getCanonicalPath = function(_a) {
        var path = _a.path;
        if (this.uriEscapePath) {
            var doubleEncoded = encodeURIComponent(path.replace(/^\//, ""));
            return "/" + doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    };
    SignatureV4.prototype.getSignature = function(longDate, credentialScope, keyPromise, canonicalRequest) {
        return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
            var stringToSign, hash, _a, _b, _c;
            return (0, $fH1jI.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.createStringToSign(longDate, credentialScope, canonicalRequest)
                        ];
                    case 1:
                        stringToSign = _d.sent();
                        _b = (_a = this.sha256).bind;
                        return [
                            4 /*yield*/ ,
                            keyPromise
                        ];
                    case 2:
                        hash = new (_b.apply(_a, [
                            void 0,
                            _d.sent()
                        ]))();
                        hash.update(stringToSign);
                        _c = (0, $6bdTj.toHex);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _c.apply(void 0, [
                                _d.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getSigningKey = function(credentials, region, shortDate, service) {
        return (0, $3Tj8T.getSigningKey)(this.sha256, credentials, shortDate, region, service || this.service);
    };
    return SignatureV4;
}();
var $9b09cd886d100e10$var$formatDate = function(now) {
    var longDate = (0, $ad3xN.iso8601)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.substr(0, 8)
    };
};
var $9b09cd886d100e10$var$getCanonicalHeaderList = function(headers) {
    return Object.keys(headers).sort().join(";");
};
var $9b09cd886d100e10$var$normalizeRegionProvider = function(region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function() {
            return promisified_1;
        };
    } else return region;
};
var $9b09cd886d100e10$var$normalizeCredentialsProvider = function(credentials) {
    if (typeof credentials === "object") {
        var promisified_2 = Promise.resolve(credentials);
        return function() {
            return promisified_2;
        };
    } else return credentials;
};

});
parcelRegister("bSJct", function(module, exports) {

$parcel$export(module.exports, "getCanonicalHeaders", function () { return $8a67ccabc7b1f87a$export$859d7f1bb55e2914; });

var $fH1jI = parcelRequire("fH1jI");

var $eLZSV = parcelRequire("eLZSV");
function $8a67ccabc7b1f87a$export$859d7f1bb55e2914(_a, unsignableHeaders, signableHeaders) {
    var e_1, _b;
    var headers = _a.headers;
    var canonical = {};
    try {
        for(var _c = (0, $fH1jI.__values)(Object.keys(headers).sort()), _d = _c.next(); !_d.done; _d = _c.next()){
            var headerName = _d.value;
            var canonicalHeaderName = headerName.toLowerCase();
            if (canonicalHeaderName in (0, $eLZSV.ALWAYS_UNSIGNABLE_HEADERS) || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || (0, $eLZSV.PROXY_HEADER_PATTERN).test(canonicalHeaderName) || (0, $eLZSV.SEC_HEADER_PATTERN).test(canonicalHeaderName)) {
                if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
            }
            canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return canonical;
}

});

parcelRegister("hT594", function(module, exports) {

$parcel$export(module.exports, "getCanonicalQuery", function () { return $d05b9073a58eccb5$export$8fea7e63ecd1ddbb; });

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("0ORaJ");
var $2Tq8U = parcelRequire("2Tq8U");

var $eLZSV = parcelRequire("eLZSV");
function $d05b9073a58eccb5$export$8fea7e63ecd1ddbb(_a) {
    var e_1, _b;
    var _c = _a.query, query = _c === void 0 ? {} : _c;
    var keys = [];
    var serialized = {};
    var _loop_1 = function(key) {
        if (key.toLowerCase() === (0, $eLZSV.SIGNATURE_HEADER)) return "continue";
        keys.push(key);
        var value = query[key];
        if (typeof value === "string") serialized[key] = (0, $2Tq8U.escapeUri)(key) + "=" + (0, $2Tq8U.escapeUri)(value);
        else if (Array.isArray(value)) serialized[key] = value.slice(0).sort().reduce(function(encoded, value) {
            return encoded.concat([
                (0, $2Tq8U.escapeUri)(key) + "=" + (0, $2Tq8U.escapeUri)(value)
            ]);
        }, []).join("&");
    };
    try {
        for(var _d = (0, $fH1jI.__values)(Object.keys(query).sort()), _e = _d.next(); !_e.done; _e = _d.next()){
            var key = _e.value;
            _loop_1(key);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return keys.map(function(key) {
        return serialized[key];
    }).filter(function(serialized) {
        return serialized;
    }) // omit any falsy values
    .join("&");
}

});

parcelRegister("3nDC5", function(module, exports) {

$parcel$export(module.exports, "getPayloadHash", function () { return $27623f721863f85e$export$a46a74202b0efd71; });

var $fH1jI = parcelRequire("fH1jI");

var $75rXL = parcelRequire("75rXL");

var $6bdTj = parcelRequire("6bdTj");

var $eLZSV = parcelRequire("eLZSV");
function $27623f721863f85e$export$a46a74202b0efd71(_a, hashConstructor) {
    var headers = _a.headers, body = _a.body;
    return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
        var _b, _c, headerName, hashCtor, _d;
        var e_1, _e;
        return (0, $fH1jI.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    try {
                        for(_b = (0, $fH1jI.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
                            headerName = _c.value;
                            if (headerName.toLowerCase() === (0, $eLZSV.SHA256_HEADER)) return [
                                2 /*return*/ ,
                                headers[headerName]
                            ];
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    if (!(body == undefined)) return [
                        3 /*break*/ ,
                        1
                    ];
                    return [
                        2 /*return*/ ,
                        "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"
                    ];
                case 1:
                    if (!(typeof body === "string" || ArrayBuffer.isView(body) || (0, $75rXL.isArrayBuffer)(body))) return [
                        3 /*break*/ ,
                        3
                    ];
                    hashCtor = new hashConstructor();
                    hashCtor.update(body);
                    _d = (0, $6bdTj.toHex);
                    return [
                        4 /*yield*/ ,
                        hashCtor.digest()
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        _d.apply(void 0, [
                            _f.sent()
                        ])
                    ];
                case 3:
                    // As any defined body that is not a string or binary data is a stream, this
                    // body is unsignable. Attempt to send the request with an unsigned payload,
                    // which may or may not be accepted by the service.
                    return [
                        2 /*return*/ ,
                        (0, $eLZSV.UNSIGNED_PAYLOAD)
                    ];
            }
        });
    });
}

});
parcelRegister("75rXL", function(module, exports) {

$parcel$export(module.exports, "isArrayBuffer", function () { return $528eb0ea497df63b$export$9dd3754ae86f0017; });
var $528eb0ea497df63b$export$9dd3754ae86f0017 = function(arg) {
    return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};

});


parcelRegister("9CjQ6", function(module, exports) {

$parcel$export(module.exports, "hasHeader", function () { return $70070d5d8c001c76$export$17944590be865217; });

var $fH1jI = parcelRequire("fH1jI");
function $70070d5d8c001c76$export$17944590be865217(soughtHeader, headers) {
    var e_1, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, $fH1jI.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
}

});

parcelRegister("j2VQN", function(module, exports) {

$parcel$export(module.exports, "moveHeadersToQuery", function () { return $dddb1422f442069d$export$bfc08a76d4bd60f6; });

var $fH1jI = parcelRequire("fH1jI");

var $hgkey = parcelRequire("hgkey");
function $dddb1422f442069d$export$bfc08a76d4bd60f6(request) {
    var e_1, _a;
    var _b = typeof request.clone === "function" ? request.clone() : (0, $hgkey.cloneRequest)(request), headers = _b.headers, _c = _b.query, query = _c === void 0 ? {} : _c;
    try {
        for(var _d = (0, $fH1jI.__values)(Object.keys(headers)), _e = _d.next(); !_e.done; _e = _d.next()){
            var name = _e.value;
            var lname = name.toLowerCase();
            if (lname.substr(0, 6) === "x-amz-") {
                query[name] = headers[name];
                delete headers[name];
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, request), {
        headers: headers,
        query: query
    });
}

});
parcelRegister("hgkey", function(module, exports) {

$parcel$export(module.exports, "cloneRequest", function () { return $c913a04440c5eba8$export$d043aa0bf7223286; });

var $fH1jI = parcelRequire("fH1jI");
function $c913a04440c5eba8$export$d043aa0bf7223286(_a) {
    var headers = _a.headers, query = _a.query, rest = (0, $fH1jI.__rest)(_a, [
        "headers",
        "query"
    ]);
    return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, rest), {
        headers: (0, $fH1jI.__assign)({}, headers),
        query: query ? $c913a04440c5eba8$var$cloneQuery(query) : undefined
    });
}
function $c913a04440c5eba8$var$cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, $fH1jI.__spread)(param) : param, _a));
    }, {});
}

});


parcelRegister("hqmIG", function(module, exports) {

$parcel$export(module.exports, "prepareRequest", function () { return $caf67d09057d9f83$export$a7cfe9131aa06be4; });

var $fH1jI = parcelRequire("fH1jI");

var $hgkey = parcelRequire("hgkey");

var $eLZSV = parcelRequire("eLZSV");
function $caf67d09057d9f83$export$a7cfe9131aa06be4(request) {
    var e_1, _a;
    // Create a clone of the request object that does not clone the body
    request = typeof request.clone === "function" ? request.clone() : (0, $hgkey.cloneRequest)(request);
    try {
        for(var _b = (0, $fH1jI.__values)(Object.keys(request.headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if ((0, $eLZSV.GENERATED_HEADERS).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return request;
}

});

parcelRegister("ad3xN", function(module, exports) {

$parcel$export(module.exports, "iso8601", function () { return $76edde15f91e8328$export$b65d57190c224ef2; });
function $76edde15f91e8328$export$b65d57190c224ef2(time) {
    return $76edde15f91e8328$export$e67a095c620b86fe(time).toISOString().replace(/\.\d{3}Z$/, "Z");
}
function $76edde15f91e8328$export$e67a095c620b86fe(time) {
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
}

});




parcelRegister("1TJTS", function(module, exports) {

$parcel$export(module.exports, "getAwsAuthPlugin", function () { return $161e8850918f7fd2$export$59c2b7ad30ed4046; });

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("1J0sw");
var $jmMP9 = parcelRequire("jmMP9");
var $161e8850918f7fd2$var$isClockSkewed = function(newServerTime, systemClockOffset) {
    return Math.abs($161e8850918f7fd2$var$getSkewCorrectedDate(systemClockOffset).getTime() - newServerTime) >= 300000;
};
var $161e8850918f7fd2$var$getSkewCorrectedDate = function(systemClockOffset) {
    return new Date(Date.now() + systemClockOffset);
};
function $161e8850918f7fd2$export$78af9708f8cf3422(options) {
    return function(next, context) {
        return function(args) {
            return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
                var signer, _a, output, _b, _c, headers, dateHeader, serverTime;
                var _d;
                return (0, $fH1jI.__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            if (!(0, $jmMP9.HttpRequest).isInstance(args.request)) return [
                                2 /*return*/ ,
                                next(args)
                            ];
                            if (!(typeof options.signer === "function")) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                options.signer()
                            ];
                        case 1:
                            _a = _e.sent();
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 2:
                            _a = options.signer;
                            _e.label = 3;
                        case 3:
                            signer = _a;
                            _b = next;
                            _c = [
                                (0, $fH1jI.__assign)({}, args)
                            ];
                            _d = {};
                            return [
                                4 /*yield*/ ,
                                signer.sign(args.request, {
                                    signingDate: new Date(Date.now() + options.systemClockOffset),
                                    signingRegion: context["signing_region"],
                                    signingService: context["signing_service"]
                                })
                            ];
                        case 4:
                            return [
                                4 /*yield*/ ,
                                _b.apply(void 0, [
                                    (0, $fH1jI.__assign).apply(void 0, _c.concat([
                                        (_d.request = _e.sent(), _d)
                                    ]))
                                ])
                            ];
                        case 5:
                            output = _e.sent();
                            headers = output.response.headers;
                            dateHeader = headers && (headers.date || headers.Date);
                            if (dateHeader) {
                                serverTime = Date.parse(dateHeader);
                                if ($161e8850918f7fd2$var$isClockSkewed(serverTime, options.systemClockOffset)) options.systemClockOffset = serverTime - Date.now();
                            }
                            return [
                                2 /*return*/ ,
                                output
                            ];
                    }
                });
            });
        };
    };
}
var $161e8850918f7fd2$export$29f4b3a6e94017d3 = {
    name: "awsAuthMiddleware",
    tags: [
        "SIGNATURE",
        "AWSAUTH"
    ],
    relation: "after",
    toMiddleware: "retryMiddleware"
};
var $161e8850918f7fd2$export$59c2b7ad30ed4046 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo($161e8850918f7fd2$export$78af9708f8cf3422(options), $161e8850918f7fd2$export$29f4b3a6e94017d3);
        }
    };
};

});


parcelRegister("ezV12", function(module, exports) {
$parcel$export(module.exports, "resolveUserAgentConfig", function () { return (parcelRequire("koCCo")).resolveUserAgentConfig; });
$parcel$export(module.exports, "getUserAgentPlugin", function () { return (parcelRequire("gzcdq")).getUserAgentPlugin; });
parcelRequire("koCCo");
parcelRequire("gzcdq");

});
parcelRegister("koCCo", function(module, exports) {

$parcel$export(module.exports, "resolveUserAgentConfig", function () { return $ed94015343efb12c$export$ec9a2d5663958cb; });
function $ed94015343efb12c$export$ec9a2d5663958cb(input) {
    return input;
}

});

parcelRegister("gzcdq", function(module, exports) {

$parcel$export(module.exports, "getUserAgentPlugin", function () { return $c0f963f45c8613a2$export$5393c0d2d7f4f5f0; });

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("1J0sw");
var $jmMP9 = parcelRequire("jmMP9");
function $c0f963f45c8613a2$export$62c460923941c0b0(options) {
    return function(next) {
        return function(args) {
            var request = args.request;
            if (!(0, $jmMP9.HttpRequest).isInstance(request)) return next(args);
            var headers = request.headers;
            var userAgentHeader = options.runtime === "node" ? "user-agent" : "x-amz-user-agent";
            if (!headers[userAgentHeader]) headers[userAgentHeader] = "" + options.defaultUserAgent;
            else headers[userAgentHeader] += " " + options.defaultUserAgent;
            if (options.customUserAgent) headers[userAgentHeader] += " " + options.customUserAgent;
            return next((0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, args), {
                request: request
            }));
        };
    };
}
var $c0f963f45c8613a2$export$29eb04da6afef73f = {
    name: "getUserAgentMiddleware",
    step: "build",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ]
};
var $c0f963f45c8613a2$export$5393c0d2d7f4f5f0 = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($c0f963f45c8613a2$export$62c460923941c0b0(config), $c0f963f45c8613a2$export$29eb04da6afef73f);
        }
    };
};

});




parcelRegister("kOCH0", function(module, exports) {

$parcel$export(module.exports, "ServiceWorkerClass", function () { return $f2767db365d03189$export$efa87b877bb98f58; });
/**
 * Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $l7cio = parcelRequire("l7cio");

var $7HFvj = parcelRequire("7HFvj");

var $9QDF4 = parcelRequire("9QDF4");
/**
 * Provides a means to registering a service worker in the browser
 * and communicating with it via postMessage events.
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API/
 *
 * postMessage events are currently not supported in all browsers. See:
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API
 *
 * At the minmum this class will register the service worker and listen
 * and attempt to dispatch messages on state change and record analytics
 * events based on the service worker lifecycle.
 */ var $f2767db365d03189$export$efa87b877bb98f58 = /** @class */ function() {
    function ServiceWorkerClass() {
        // The AWS Amplify logger
        this._logger = new (0, $l7cio.ConsoleLogger)('ServiceWorker');
    }
    Object.defineProperty(ServiceWorkerClass.prototype, "serviceWorker", {
        /**
         * Get the currently active service worker
         */ get: function() {
            return this._serviceWorker;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Register the service-worker.js file in the browser
     * Make sure the service-worker.js is part of the build
     * for example with Angular, modify the angular-cli.json file
     * and add to "assets" array "service-worker.js"
     * @param {string} - (optional) Service worker file. Defaults to "/service-worker.js"
     * @param {string} - (optional) The service worker scope. Defaults to "/"
     *  - API Doc: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register
     * @returns {Promise}
     *	- resolve(ServiceWorkerRegistration)
     *	- reject(Error)
     **/ ServiceWorkerClass.prototype.register = function(filePath, scope) {
        var _this = this;
        if (filePath === void 0) filePath = '/service-worker.js';
        if (scope === void 0) scope = '/';
        this._logger.debug("registering " + filePath);
        this._logger.debug("registering service worker with scope " + scope);
        return new Promise(function(resolve, reject) {
            if (navigator && 'serviceWorker' in navigator) navigator.serviceWorker.register(filePath, {
                scope: scope
            }).then(function(registration) {
                if (registration.installing) _this._serviceWorker = registration.installing;
                else if (registration.waiting) _this._serviceWorker = registration.waiting;
                else if (registration.active) _this._serviceWorker = registration.active;
                _this._registration = registration;
                _this._setupListeners();
                _this._logger.debug("Service Worker Registration Success: " + registration);
                return resolve(registration);
            }).catch(function(error) {
                _this._logger.debug("Service Worker Registration Failed " + error);
                return reject(error);
            });
            else return reject(new Error('Service Worker not available'));
        });
    };
    /**
     * Enable web push notifications. If not subscribed, a new subscription will
     * be created and registered.
     * 	Test Push Server: https://web-push-codelab.glitch.me/
     * 	Push Server Libraries: https://github.com/web-push-libs/
     * 	API Doc: https://developers.google.com/web/fundamentals/codelabs/push-notifications/
     * @param publicKey
     * @returns {Promise}
     * 	- resolve(PushSubscription)
     *  - reject(Error)
     */ ServiceWorkerClass.prototype.enablePush = function(publicKey) {
        var _this = this;
        if (!this._registration) throw new Error('Service Worker not registered');
        this._publicKey = publicKey;
        return new Promise(function(resolve, reject) {
            if ((0, $7HFvj.browserOrNode)().isBrowser) _this._registration.pushManager.getSubscription().then(function(subscription) {
                if (subscription) {
                    _this._subscription = subscription;
                    _this._logger.debug("User is subscribed to push: " + JSON.stringify(subscription));
                    resolve(subscription);
                } else {
                    _this._logger.debug("User is NOT subscribed to push");
                    return _this._registration.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: _this._urlB64ToUint8Array(publicKey)
                    }).then(function(subscription) {
                        _this._subscription = subscription;
                        _this._logger.debug("User subscribed: " + JSON.stringify(subscription));
                        resolve(subscription);
                    }).catch(function(error) {
                        _this._logger.error(error);
                    });
                }
            });
            else return reject(new Error('Service Worker not available'));
        });
    };
    /**
     * Convert a base64 encoded string to a Uint8 array for the push server key
     * @param base64String
     */ ServiceWorkerClass.prototype._urlB64ToUint8Array = function(base64String) {
        var padding = '='.repeat((4 - base64String.length % 4) % 4);
        var base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
        var rawData = window.atob(base64);
        var outputArray = new Uint8Array(rawData.length);
        for(var i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
        return outputArray;
    };
    /**
     * Send a message to the service worker. The service worker needs
     * to implement `self.addEventListener('message') to handle the
     * message. This ***currently*** does not work in Safari or IE.
     * @param {object | string} - An arbitrary JSON object or string message to send to the service worker
     *	- see: https://developer.mozilla.org/en-US/docs/Web/API/Transferable
     * @returns {Promise}
     **/ ServiceWorkerClass.prototype.send = function(message) {
        if (this._serviceWorker) this._serviceWorker.postMessage(typeof message === 'object' ? JSON.stringify(message) : message);
    };
    /**
     * Listen for service worker state change and message events
     * https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorker/state
     **/ ServiceWorkerClass.prototype._setupListeners = function() {
        var _this = this;
        this._serviceWorker.addEventListener('statechange', function(event) {
            var currentState = _this._serviceWorker.state;
            _this._logger.debug("ServiceWorker statechange: " + currentState);
            if ((0, $9QDF4.Amplify).Analytics && typeof (0, $9QDF4.Amplify).Analytics.record === 'function') (0, $9QDF4.Amplify).Analytics.record({
                name: 'ServiceWorker',
                attributes: {
                    state: currentState
                }
            });
        });
        this._serviceWorker.addEventListener('message', function(event) {
            _this._logger.debug("ServiceWorker message event: " + event);
        });
    };
    return ServiceWorkerClass;
}();
var /**
 * @deprecated use named import
 */ $f2767db365d03189$export$2e2bcd8739ae039 = $f2767db365d03189$export$efa87b877bb98f58;

});

parcelRegister("8noHm", function(module, exports) {

$parcel$export(module.exports, "UniversalStorage", function () { return $6193a1472031429b$export$ded9c57084144144; });

var $44PPk = parcelRequire("44PPk");

var $7HFvj = parcelRequire("7HFvj");
var $6193a1472031429b$var$isBrowser = (0, $7HFvj.browserOrNode)().isBrowser;
var $6193a1472031429b$export$ded9c57084144144 = /** @class */ function() {
    function UniversalStorage(context) {
        if (context === void 0) context = {};
        this.cookies = new (0, $44PPk.default)();
        this.store = $6193a1472031429b$var$isBrowser ? window.localStorage : Object.create(null);
        this.cookies = context.req ? new (0, $44PPk.default)(context.req.headers.cookie) : new (0, $44PPk.default)();
        Object.assign(this.store, this.cookies.getAll());
    }
    Object.defineProperty(UniversalStorage.prototype, "length", {
        get: function() {
            return Object.entries(this.store).length;
        },
        enumerable: true,
        configurable: true
    });
    UniversalStorage.prototype.clear = function() {
        var _this = this;
        Array.from(new Array(this.length)).map(function(_, i) {
            return _this.key(i);
        }).forEach(function(key) {
            return _this.removeItem(key);
        });
    };
    UniversalStorage.prototype.getItem = function(key) {
        return this.getLocalItem(key);
    };
    UniversalStorage.prototype.getLocalItem = function(key) {
        return Object.prototype.hasOwnProperty.call(this.store, key) ? this.store[key] : null;
    };
    UniversalStorage.prototype.getUniversalItem = function(key) {
        return this.cookies.get(key);
    };
    UniversalStorage.prototype.key = function(index) {
        return Object.keys(this.store)[index];
    };
    UniversalStorage.prototype.removeItem = function(key) {
        this.removeLocalItem(key);
        this.removeUniversalItem(key);
    };
    UniversalStorage.prototype.removeLocalItem = function(key) {
        delete this.store[key];
    };
    UniversalStorage.prototype.removeUniversalItem = function(key) {
        this.cookies.remove(key, {
            path: '/'
        });
    };
    UniversalStorage.prototype.setItem = function(key, value) {
        this.setLocalItem(key, value);
        // keys take the shape:
        //  1. `${ProviderPrefix}.${userPoolClientId}.${username}.${tokenType}
        //  2. `${ProviderPrefix}.${userPoolClientId}.LastAuthUser
        var tokenType = key.split('.').pop();
        switch(tokenType){
            // LastAuthUser is needed for computing other key names
            case 'LastAuthUser':
            // accessToken is required for CognitoUserSession
            case 'accessToken':
            // Required for CognitoUserSession
            case 'idToken':
                this.setUniversalItem(key, value);
        }
    };
    UniversalStorage.prototype.setLocalItem = function(key, value) {
        this.store[key] = value;
    };
    UniversalStorage.prototype.setUniversalItem = function(key, value) {
        this.cookies.set(key, value, {
            path: '/',
            // `httpOnly` cannot be set via JavaScript: https://developer.mozilla.org/en-US/docs/Web/HTTP/Cookies#JavaScript_access_using_Document.cookie
            sameSite: true,
            // Allow unsecure requests to http://localhost:3000/ when in development.
            secure: window.location.hostname === 'localhost' ? false : true
        });
    };
    return UniversalStorage;
}();

});
parcelRegister("44PPk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f7fbce5addbc3a9$export$2e2bcd8739ae039; });

var $a8RZK = parcelRequire("a8RZK");
var $2f7fbce5addbc3a9$export$2e2bcd8739ae039 = (0, $a8RZK.default);

});
parcelRegister("a8RZK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76248902bf3626ba$export$2e2bcd8739ae039; });

var $bfNDr = parcelRequire("bfNDr");

var $9oEI8 = parcelRequire("9oEI8");
var $76248902bf3626ba$var$__assign = undefined && undefined.__assign || function() {
    $76248902bf3626ba$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $76248902bf3626ba$var$__assign.apply(this, arguments);
};
var $76248902bf3626ba$var$Cookies = /** @class */ function() {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = (0, $9oEI8.parseCookies)(cookies, options);
        new Promise(function() {
            _this.HAS_DOCUMENT_COOKIE = (0, $9oEI8.hasDocumentCookie)();
        }).catch(function() {});
    }
    Cookies.prototype._updateBrowserValues = function(parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) return;
        this.cookies = $bfNDr.parse(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function(params) {
        for(var i = 0; i < this.changeListeners.length; ++i)this.changeListeners[i](params);
    };
    Cookies.prototype.get = function(name, options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        return (0, $9oEI8.readCookie)(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function(options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        var result = {};
        for(var name_1 in this.cookies)result[name_1] = (0, $9oEI8.readCookie)(this.cookies[name_1], options);
        return result;
    };
    Cookies.prototype.set = function(name, value, options) {
        var _a;
        if (typeof value === 'object') value = JSON.stringify(value);
        this.cookies = $76248902bf3626ba$var$__assign($76248902bf3626ba$var$__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $bfNDr.serialize(name, value, options);
        this._emitChange({
            name: name,
            value: value,
            options: options
        });
    };
    Cookies.prototype.remove = function(name, options) {
        var finalOptions = options = $76248902bf3626ba$var$__assign($76248902bf3626ba$var$__assign({}, options), {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        });
        this.cookies = $76248902bf3626ba$var$__assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $bfNDr.serialize(name, '', finalOptions);
        this._emitChange({
            name: name,
            value: undefined,
            options: options
        });
    };
    Cookies.prototype.addChangeListener = function(callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function(callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) this.changeListeners.splice(idx, 1);
    };
    return Cookies;
}();
var $76248902bf3626ba$export$2e2bcd8739ae039 = $76248902bf3626ba$var$Cookies;

});
parcelRegister("bfNDr", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $831798f24b66d975$export$98e6a39c04603d36; }, function (v) { return $831798f24b66d975$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "serialize", function () { return $831798f24b66d975$export$dfdc1655ccc5b9cb; }, function (v) { return $831798f24b66d975$export$dfdc1655ccc5b9cb = v; });
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $831798f24b66d975$export$98e6a39c04603d36;
var $831798f24b66d975$export$dfdc1655ccc5b9cb;
'use strict';
$831798f24b66d975$export$98e6a39c04603d36 = $831798f24b66d975$var$parse;
$831798f24b66d975$export$dfdc1655ccc5b9cb = $831798f24b66d975$var$serialize;
/**
 * Module variables.
 * @private
 */ var $831798f24b66d975$var$decode = decodeURIComponent;
var $831798f24b66d975$var$encode = encodeURIComponent;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var $831798f24b66d975$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function $831798f24b66d975$var$parse(str, options) {
    if (typeof str !== 'string') throw new TypeError('argument str must be a string');
    var obj = {};
    var opt = options || {};
    var pairs = str.split(';');
    var dec = opt.decode || $831798f24b66d975$var$decode;
    for(var i = 0; i < pairs.length; i++){
        var pair = pairs[i];
        var index = pair.indexOf('=');
        // skip things that don't look like key=value
        if (index < 0) continue;
        var key = pair.substring(0, index).trim();
        // only assign once
        if (undefined == obj[key]) {
            var val = pair.substring(index + 1, pair.length).trim();
            // quoted values
            if (val[0] === '"') val = val.slice(1, -1);
            obj[key] = $831798f24b66d975$var$tryDecode(val, dec);
        }
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function $831798f24b66d975$var$serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || $831798f24b66d975$var$encode;
    if (typeof enc !== 'function') throw new TypeError('option encode is invalid');
    if (!$831798f24b66d975$var$fieldContentRegExp.test(name)) throw new TypeError('argument name is invalid');
    var value = enc(val);
    if (value && !$831798f24b66d975$var$fieldContentRegExp.test(value)) throw new TypeError('argument val is invalid');
    var str = name + '=' + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) throw new TypeError('option maxAge is invalid');
        str += '; Max-Age=' + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$831798f24b66d975$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += '; Domain=' + opt.domain;
    }
    if (opt.path) {
        if (!$831798f24b66d975$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += '; Path=' + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += '; Expires=' + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function $831798f24b66d975$var$tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}

});

parcelRegister("9oEI8", function(module, exports) {

$parcel$export(module.exports, "hasDocumentCookie", function () { return $6d75ef40aa11fb66$export$56232575010ba89; });
$parcel$export(module.exports, "parseCookies", function () { return $6d75ef40aa11fb66$export$d2e637738f5e6ae8; });
$parcel$export(module.exports, "readCookie", function () { return $6d75ef40aa11fb66$export$bead674655ff515d; });

var $bfNDr = parcelRequire("bfNDr");
function $6d75ef40aa11fb66$export$56232575010ba89() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function $6d75ef40aa11fb66$export$bfce569af136abdc() {
    document.cookie.split(';').forEach(function(c) {
        document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function $6d75ef40aa11fb66$export$d2e637738f5e6ae8(cookies, options) {
    if (typeof cookies === 'string') return $bfNDr.parse(cookies, options);
    else if (typeof cookies === 'object' && cookies !== null) return cookies;
    else return {};
}
function $6d75ef40aa11fb66$export$9f55e081dbb22cd9(value, doNotParse) {
    if (typeof doNotParse === 'undefined') // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
    return !doNotParse;
}
function $6d75ef40aa11fb66$export$bead674655ff515d(value, options) {
    if (options === void 0) options = {};
    var cleanValue = $6d75ef40aa11fb66$var$cleanupCookieValue(value);
    if ($6d75ef40aa11fb66$export$9f55e081dbb22cd9(cleanValue, options.doNotParse)) try {
        return JSON.parse(cleanValue);
    } catch (e) {
    // At least we tried
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function $6d75ef40aa11fb66$var$cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') return value.substr(2);
    return value;
}

});




parcelRegister("gKydS", function(module, exports) {

$parcel$export(module.exports, "INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER", function () { return $c31b7d2d8a45bfa0$export$36df2663cc7faf97; });
$parcel$export(module.exports, "INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER", function () { return $c31b7d2d8a45bfa0$export$ea26e09ecef8d08d; });
$parcel$export(module.exports, "USER_AGENT_HEADER", function () { return $c31b7d2d8a45bfa0$export$16032fc466434892; });
/*
 * Copyright 2018-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /**
 * This Symbol is used to reference an internal-only PubSub provider that
 * is used for AppSync/GraphQL subscriptions in the API category.
 */ var $c31b7d2d8a45bfa0$var$hasSymbol = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function';
var $c31b7d2d8a45bfa0$export$36df2663cc7faf97 = $c31b7d2d8a45bfa0$var$hasSymbol ? Symbol.for('INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER') : '@@INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER';
var $c31b7d2d8a45bfa0$export$ea26e09ecef8d08d = $c31b7d2d8a45bfa0$var$hasSymbol ? Symbol.for('INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER') : '@@INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER';
var $c31b7d2d8a45bfa0$export$16032fc466434892 = 'x-amz-user-agent';

});

parcelRegister("7KcGx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a36ab4b854fb7d0$export$2e2bcd8739ae039; });
/*!
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Christian Speckner <cnspeckn@googlemail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $5a36ab4b854fb7d0$var$Mutex = /** @class */ function() {
    function Mutex() {
        this._queue = [];
        this._pending = false;
    }
    Mutex.prototype.isLocked = function() {
        return this._pending;
    };
    Mutex.prototype.acquire = function() {
        var _this = this;
        var ticket = new Promise(function(resolve) {
            return _this._queue.push(resolve);
        });
        if (!this._pending) this._dispatchNext();
        return ticket;
    };
    Mutex.prototype.runExclusive = function(callback) {
        return this.acquire().then(function(release) {
            var result;
            try {
                result = callback();
            } catch (e) {
                release();
                throw e;
            }
            return Promise.resolve(result).then(function(x) {
                return release(), x;
            }, function(e) {
                release();
                throw e;
            });
        });
    };
    Mutex.prototype._dispatchNext = function() {
        if (this._queue.length > 0) {
            this._pending = true;
            this._queue.shift()(this._dispatchNext.bind(this));
        } else this._pending = false;
    };
    return Mutex;
}();
var $5a36ab4b854fb7d0$export$2e2bcd8739ae039 = $5a36ab4b854fb7d0$var$Mutex;

});

parcelRegister("aPgXC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e1bd2cc4eec7900$export$2e2bcd8739ae039; });

var $7HFvj = parcelRequire("7HFvj");

var $6zWeC = parcelRequire("6zWeC");
var $7e1bd2cc4eec7900$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $7e1bd2cc4eec7900$var$ReachabilityNavigator = /** @class */ function() {
    function ReachabilityNavigator() {}
    ReachabilityNavigator.prototype.networkMonitor = function(netInfo) {
        if ((0, $7HFvj.browserOrNode)().isNode) return (0, $6zWeC.default).from([
            {
                online: true
            }
        ]);
        var globalObj = (0, $7HFvj.isWebWorker)() ? self : window;
        return new (0, $6zWeC.default)(function(observer) {
            observer.next({
                online: globalObj.navigator.onLine
            });
            var notifyOnline = function() {
                return observer.next({
                    online: true
                });
            };
            var notifyOffline = function() {
                return observer.next({
                    online: false
                });
            };
            globalObj.addEventListener('online', notifyOnline);
            globalObj.addEventListener('offline', notifyOffline);
            ReachabilityNavigator._observers.push(observer);
            return function() {
                globalObj.removeEventListener('online', notifyOnline);
                globalObj.removeEventListener('offline', notifyOffline);
                ReachabilityNavigator._observers = ReachabilityNavigator._observers.filter(function(_observer) {
                    return _observer !== observer;
                });
            };
        });
    };
    // expose observers to simulate offline mode for integration testing
    ReachabilityNavigator._observerOverride = function(status) {
        var e_1, _a;
        var _loop_1 = function(observer) {
            if (observer.closed) {
                ReachabilityNavigator._observers = ReachabilityNavigator._observers.filter(function(_observer) {
                    return _observer !== observer;
                });
                return "continue";
            }
            observer.next(status);
        };
        try {
            for(var _b = $7e1bd2cc4eec7900$var$__values(ReachabilityNavigator._observers), _c = _b.next(); !_c.done; _c = _b.next()){
                var observer = _c.value;
                _loop_1(observer);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    ReachabilityNavigator._observers = [];
    return ReachabilityNavigator;
}();
var $7e1bd2cc4eec7900$export$2e2bcd8739ae039 = $7e1bd2cc4eec7900$var$ReachabilityNavigator;

});
parcelRegister("6zWeC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ca32f294cedd21f$export$2e2bcd8739ae039; });

var $9uTW6 = parcelRequire("9uTW6");
var $4ca32f294cedd21f$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6)));
var $4ca32f294cedd21f$export$2e2bcd8739ae039 = $4ca32f294cedd21f$export$77cea355fa80b5f4;

});


parcelRegister("lpLq9", function(module, exports) {

$parcel$export(module.exports, "urlSafeEncode", function () { return $f970b7933bfba64f$export$b855308a44508212; });
$parcel$export(module.exports, "urlSafeDecode", function () { return $f970b7933bfba64f$export$a7ea17e93539f9a5; });
function $f970b7933bfba64f$export$b855308a44508212(str) {
    return str.split('').map(function(char) {
        return char.charCodeAt(0).toString(16).padStart(2, '0');
    }).join('');
}
function $f970b7933bfba64f$export$a7ea17e93539f9a5(hex) {
    return hex.match(/.{2}/g).map(function(char) {
        return String.fromCharCode(parseInt(char, 16));
    }).join('');
}

});


parcelRegister("407kk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e9cd878d77f78eb$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Auth", function () { return (parcelRequire("bzHnt")).Auth; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $bzHnt = parcelRequire("bzHnt");

parcelRequire("yHOl4");
var $7VU9U = parcelRequire("7VU9U");
var $j3bXS = parcelRequire("j3bXS");
var $cfxLo = parcelRequire("cfxLo");

var /**
 * @deprecated use named import
 */ $2e9cd878d77f78eb$export$2e2bcd8739ae039 = (0, $bzHnt.Auth);

});
parcelRegister("bzHnt", function(module, exports) {

$parcel$export(module.exports, "Auth", function () { return $86d49c7b4ba54a97$export$334c29725a78c21d; });
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *	 http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $cCguc = parcelRequire("cCguc");
parcelRequire("dRac8");
var $9QDF4 = parcelRequire("9QDF4");
var $l7cio = parcelRequire("l7cio");
var $ddXoz = parcelRequire("ddXoz");
var $hPjfU = parcelRequire("hPjfU");
var $7HFvj = parcelRequire("7HFvj");
var $hmdQp = parcelRequire("hmdQp");
var $lpqOV = parcelRequire("lpqOV");
var $8noHm = parcelRequire("8noHm");
var $lpLq9 = parcelRequire("lpLq9");
parcelRequire("yHOl4");
var $gQJHs = parcelRequire("gQJHs");
var $eqVzU = parcelRequire("eqVzU");
var $a6o5Y = parcelRequire("a6o5Y");
var $5Ra9u = parcelRequire("5Ra9u");
var $7VU9U = parcelRequire("7VU9U");
var $frEzb = parcelRequire("frEzb");
var $bbkkz = parcelRequire("bbkkz");
var $1rQ96 = parcelRequire("1rQ96");
var $j3bXS = parcelRequire("j3bXS");

var $2qlBa = parcelRequire("2qlBa");

var $bKd6N = parcelRequire("bKd6N");

var $3amhM = parcelRequire("3amhM");

var $7Rn4k = parcelRequire("7Rn4k");

var $cCguc = parcelRequire("cCguc");
var $86d49c7b4ba54a97$var$__assign = undefined && undefined.__assign || function() {
    $86d49c7b4ba54a97$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $86d49c7b4ba54a97$var$__assign.apply(this, arguments);
};
var $86d49c7b4ba54a97$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $86d49c7b4ba54a97$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $86d49c7b4ba54a97$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $86d49c7b4ba54a97$var$logger = new (0, $l7cio.ConsoleLogger)('AuthClass');
var $86d49c7b4ba54a97$var$USER_ADMIN_SCOPE = 'aws.cognito.signin.user.admin';
// 10 sec, following this guide https://www.nngroup.com/articles/response-times-3-important-limits/
var $86d49c7b4ba54a97$var$OAUTH_FLOW_MS_TIMEOUT = 10000;
var $86d49c7b4ba54a97$var$AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
var $86d49c7b4ba54a97$var$dispatchAuthEvent = function(event, data, message) {
    (0, $hPjfU.Hub).dispatch('auth', {
        event: event,
        data: data,
        message: message
    }, 'Auth', $86d49c7b4ba54a97$var$AMPLIFY_SYMBOL);
};
/**
 * Provide authentication steps
 */ var $86d49c7b4ba54a97$export$eeff9d1a8b8c057b = /** @class */ function() {
    /**
     * Initialize Auth with AWS configurations
     * @param {Object} config - Configuration of the Auth
     */ function AuthClass(config) {
        var _this = this;
        this.userPool = null;
        this.user = null;
        this.oAuthFlowInProgress = false;
        this.Credentials = (0, $ddXoz.Credentials);
        this.wrapRefreshSessionCallback = function(callback) {
            var wrapped = function(error, data) {
                if (data) $86d49c7b4ba54a97$var$dispatchAuthEvent('tokenRefresh', undefined, "New token retrieved");
                else $86d49c7b4ba54a97$var$dispatchAuthEvent('tokenRefresh_failure', error, "Failed to retrieve new token");
                return callback(error, data);
            };
            return wrapped;
        }; // prettier-ignore
        this.configure(config);
        this.currentCredentials = this.currentCredentials.bind(this);
        this.currentUserCredentials = this.currentUserCredentials.bind(this);
        (0, $hPjfU.Hub).listen('auth', function(_a) {
            var payload = _a.payload;
            var event = payload.event;
            switch(event){
                case 'signIn':
                    _this._storage.setItem('amplify-signin-with-hostedUI', 'false');
                    break;
                case 'signOut':
                    _this._storage.removeItem('amplify-signin-with-hostedUI');
                    break;
                case 'cognitoHostedUI':
                    _this._storage.setItem('amplify-signin-with-hostedUI', 'true');
                    break;
            }
        });
    }
    AuthClass.prototype.getModuleName = function() {
        return 'Auth';
    };
    AuthClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config || {};
        $86d49c7b4ba54a97$var$logger.debug('configure Auth');
        var conf = Object.assign({}, this._config, (0, $hmdQp.Parser).parseMobilehubConfig(config).Auth, config);
        this._config = conf;
        var _a = this._config, userPoolId = _a.userPoolId, userPoolWebClientId = _a.userPoolWebClientId, cookieStorage = _a.cookieStorage, oauth = _a.oauth, region = _a.region, identityPoolId = _a.identityPoolId, mandatorySignIn = _a.mandatorySignIn, refreshHandlers = _a.refreshHandlers, identityPoolRegion = _a.identityPoolRegion, clientMetadata = _a.clientMetadata, endpoint = _a.endpoint;
        if (!this._config.storage) {
            // backward compatability
            if (cookieStorage) this._storage = new (0, $j3bXS.default)(cookieStorage);
            else this._storage = config.ssr ? new (0, $8noHm.UniversalStorage)() : new (0, $lpqOV.StorageHelper)().getStorage();
        } else {
            if (!this._isValidAuthStorage(this._config.storage)) {
                $86d49c7b4ba54a97$var$logger.error('The storage in the Auth config is not valid!');
                throw new Error('Empty storage object');
            }
            this._storage = this._config.storage;
        }
        this._storageSync = Promise.resolve();
        if (typeof this._storage['sync'] === 'function') this._storageSync = this._storage['sync']();
        if (userPoolId) {
            var userPoolData = {
                UserPoolId: userPoolId,
                ClientId: userPoolWebClientId,
                endpoint: endpoint
            };
            userPoolData.Storage = this._storage;
            this.userPool = new (0, $bbkkz.default)(userPoolData, this.wrapRefreshSessionCallback);
        }
        this.Credentials.configure({
            mandatorySignIn: mandatorySignIn,
            region: identityPoolRegion || region,
            userPoolId: userPoolId,
            identityPoolId: identityPoolId,
            refreshHandlers: refreshHandlers,
            storage: this._storage
        });
        // initiailize cognitoauth client if hosted ui options provided
        // to keep backward compatibility:
        var cognitoHostedUIConfig = oauth ? (0, $cCguc.isCognitoHostedOpts)(this._config.oauth) ? oauth : oauth.awsCognito : undefined;
        if (cognitoHostedUIConfig) {
            var cognitoAuthParams = Object.assign({
                cognitoClientId: userPoolWebClientId,
                UserPoolId: userPoolId,
                domain: cognitoHostedUIConfig['domain'],
                scopes: cognitoHostedUIConfig['scope'],
                redirectSignIn: cognitoHostedUIConfig['redirectSignIn'],
                redirectSignOut: cognitoHostedUIConfig['redirectSignOut'],
                responseType: cognitoHostedUIConfig['responseType'],
                Storage: this._storage,
                urlOpener: cognitoHostedUIConfig['urlOpener'],
                clientMetadata: clientMetadata
            }, cognitoHostedUIConfig['options']);
            this._oAuthHandler = new (0, $bKd6N.default)({
                scopes: cognitoAuthParams.scopes,
                config: cognitoAuthParams,
                cognitoClientId: cognitoAuthParams.cognitoClientId
            });
            // **NOTE** - Remove this in a future major release as it is a breaking change
            // Prevents _handleAuthResponse from being called multiple times in Expo
            // See https://github.com/aws-amplify/amplify-js/issues/4388
            var usedResponseUrls_1 = {};
            (0, $3amhM.default)(function(_a) {
                var url = _a.url;
                if (usedResponseUrls_1[url]) return;
                usedResponseUrls_1[url] = true;
                _this._handleAuthResponse(url);
            });
        }
        $86d49c7b4ba54a97$var$dispatchAuthEvent('configured', null, "The Auth category has been configured successfully");
        return this._config;
    };
    /**
     * Sign up with username, password and other attributes like phone, email
     * @param {String | object} params - The user attributes used for signin
     * @param {String[]} restOfAttrs - for the backward compatability
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.signUp = function(params) {
        var _this = this;
        var restOfAttrs = [];
        for(var _i = 1; _i < arguments.length; _i++)restOfAttrs[_i - 1] = arguments[_i];
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var attributes = [];
        var validationData = null;
        var clientMetadata;
        if (params && typeof params === 'string') {
            username = params;
            password = restOfAttrs ? restOfAttrs[0] : null;
            var email = restOfAttrs ? restOfAttrs[1] : null;
            var phone_number = restOfAttrs ? restOfAttrs[2] : null;
            if (email) attributes.push({
                Name: 'email',
                Value: email
            });
            if (phone_number) attributes.push({
                Name: 'phone_number',
                Value: phone_number
            });
        } else if (params && typeof params === 'object') {
            username = params['username'];
            password = params['password'];
            if (params && params.clientMetadata) clientMetadata = params.clientMetadata;
            else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
            var attrs_1 = params['attributes'];
            if (attrs_1) Object.keys(attrs_1).map(function(key) {
                var ele = {
                    Name: key,
                    Value: attrs_1[key]
                };
                attributes.push(ele);
            });
            validationData = params['validationData'] || null;
        } else return this.rejectAuthError((0, $cCguc.AuthErrorTypes).SignUpError);
        if (!username) return this.rejectAuthError((0, $cCguc.AuthErrorTypes).EmptyUsername);
        if (!password) return this.rejectAuthError((0, $cCguc.AuthErrorTypes).EmptyPassword);
        $86d49c7b4ba54a97$var$logger.debug('signUp attrs:', attributes);
        $86d49c7b4ba54a97$var$logger.debug('signUp validation data:', validationData);
        return new Promise(function(resolve, reject) {
            _this.userPool.signUp(username, password, attributes, validationData, function(err, data) {
                if (err) {
                    $86d49c7b4ba54a97$var$dispatchAuthEvent('signUp_failure', err, username + " failed to signup");
                    reject(err);
                } else {
                    $86d49c7b4ba54a97$var$dispatchAuthEvent('signUp', data, username + " has signed up successfully");
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    /**
     * Send the verfication code to confirm sign up
     * @param {String} username - The username to be confirmed
     * @param {String} code - The verification code
     * @param {ConfirmSignUpOptions} options - other options for confirm signup
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.confirmSignUp = function(username, code, options) {
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $cCguc.AuthErrorTypes).EmptyUsername);
        if (!code) return this.rejectAuthError((0, $cCguc.AuthErrorTypes).EmptyCode);
        var user = this.createCognitoUser(username);
        var forceAliasCreation = options && typeof options.forceAliasCreation === 'boolean' ? options.forceAliasCreation : true;
        var clientMetadata;
        if (options && options.clientMetadata) clientMetadata = options.clientMetadata;
        else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.confirmRegistration(code, forceAliasCreation, function(err, data) {
                if (err) reject(err);
                else resolve(data);
            }, clientMetadata);
        });
    };
    /**
     * Resend the verification code
     * @param {String} username - The username to be confirmed
     * @param {ClientMetadata} clientMetadata - Metadata to be passed to Cognito Lambda triggers
     * @return - A promise resolves code delivery details if successful
     */ AuthClass.prototype.resendSignUp = function(username, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $cCguc.AuthErrorTypes).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.resendConfirmationCode(function(err, data) {
                if (err) reject(err);
                else resolve(data);
            }, clientMetadata);
        });
    };
    /**
     * Sign in
     * @param {String | SignInOpts} usernameOrSignInOpts - The username to be signed in or the sign in options
     * @param {String} password - The password of the username
     * @return - A promise resolves the CognitoUser
     */ AuthClass.prototype.signIn = function(usernameOrSignInOpts, pw, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var validationData = {};
        // for backward compatibility
        if (typeof usernameOrSignInOpts === 'string') {
            username = usernameOrSignInOpts;
            password = pw;
        } else if ((0, $cCguc.isUsernamePasswordOpts)(usernameOrSignInOpts)) {
            if (typeof pw !== 'undefined') $86d49c7b4ba54a97$var$logger.warn('The password should be defined under the first parameter object!');
            username = usernameOrSignInOpts.username;
            password = usernameOrSignInOpts.password;
            validationData = usernameOrSignInOpts.validationData;
        } else return this.rejectAuthError((0, $cCguc.AuthErrorTypes).InvalidUsername);
        if (!username) return this.rejectAuthError((0, $cCguc.AuthErrorTypes).EmptyUsername);
        var authDetails = new (0, $gQJHs.default)({
            Username: username,
            Password: password,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        });
        if (password) return this.signInWithPassword(authDetails);
        else return this.signInWithoutPassword(authDetails);
    };
    /**
     * Return an object with the authentication callbacks
     * @param {CognitoUser} user - the cognito user object
     * @param {} resolve - function called when resolving the current step
     * @param {} reject - function called when rejecting the current step
     * @return - an object with the callback methods for user authentication
     */ AuthClass.prototype.authCallbacks = function(user, resolve, reject) {
        var _this = this;
        var that = this;
        return {
            onSuccess: function(session) {
                return $86d49c7b4ba54a97$var$__awaiter(_this, void 0, void 0, function() {
                    var cred, e_1, currentUser, e_2;
                    return $86d49c7b4ba54a97$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                $86d49c7b4ba54a97$var$logger.debug(session);
                                delete user['challengeName'];
                                delete user['challengeParam'];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    4,
                                    5,
                                    9
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.clear()
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.set(session, 'session')
                                ];
                            case 3:
                                cred = _a.sent();
                                $86d49c7b4ba54a97$var$logger.debug('succeed to get cognito credentials', cred);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 4:
                                e_1 = _a.sent();
                                $86d49c7b4ba54a97$var$logger.debug('cannot get cognito credentials', e_1);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 5:
                                _a.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.currentUserPoolUser()
                                ];
                            case 6:
                                currentUser = _a.sent();
                                that.user = currentUser;
                                $86d49c7b4ba54a97$var$dispatchAuthEvent('signIn', currentUser, "A user " + user.getUsername() + " has been signed in");
                                resolve(currentUser);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 7:
                                e_2 = _a.sent();
                                $86d49c7b4ba54a97$var$logger.error('Failed to get the signed in user', e_2);
                                reject(e_2);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 8:
                                return [
                                    7 /*endfinally*/ 
                                ];
                            case 9:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            },
            onFailure: function(err) {
                $86d49c7b4ba54a97$var$logger.debug('signIn failure', err);
                $86d49c7b4ba54a97$var$dispatchAuthEvent('signIn_failure', err, user.getUsername() + " failed to signin");
                reject(err);
            },
            customChallenge: function(challengeParam) {
                $86d49c7b4ba54a97$var$logger.debug('signIn custom challenge answer required');
                user['challengeName'] = 'CUSTOM_CHALLENGE';
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            mfaRequired: function(challengeName, challengeParam) {
                $86d49c7b4ba54a97$var$logger.debug('signIn MFA required');
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            mfaSetup: function(challengeName, challengeParam) {
                $86d49c7b4ba54a97$var$logger.debug('signIn mfa setup', challengeName);
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            newPasswordRequired: function(userAttributes, requiredAttributes) {
                $86d49c7b4ba54a97$var$logger.debug('signIn new password');
                user['challengeName'] = 'NEW_PASSWORD_REQUIRED';
                user['challengeParam'] = {
                    userAttributes: userAttributes,
                    requiredAttributes: requiredAttributes
                };
                resolve(user);
            },
            totpRequired: function(challengeName, challengeParam) {
                $86d49c7b4ba54a97$var$logger.debug('signIn totpRequired');
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            selectMFAType: function(challengeName, challengeParam) {
                $86d49c7b4ba54a97$var$logger.debug('signIn selectMFAType', challengeName);
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            }
        };
    };
    /**
     * Sign in with a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ AuthClass.prototype.signInWithPassword = function(authDetails) {
        var _this = this;
        if (this.pendingSignIn) throw new Error('Pending sign-in attempt already in progress');
        var user = this.createCognitoUser(authDetails.getUsername());
        this.pendingSignIn = new Promise(function(resolve, reject) {
            user.authenticateUser(authDetails, _this.authCallbacks(user, function(value) {
                _this.pendingSignIn = null;
                resolve(value);
            }, function(error) {
                _this.pendingSignIn = null;
                reject(error);
            }));
        });
        return this.pendingSignIn;
    };
    /**
     * Sign in without a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ AuthClass.prototype.signInWithoutPassword = function(authDetails) {
        var _this = this;
        var user = this.createCognitoUser(authDetails.getUsername());
        user.setAuthenticationFlowType('CUSTOM_AUTH');
        return new Promise(function(resolve, reject) {
            user.initiateAuth(authDetails, _this.authCallbacks(user, resolve, reject));
        });
    };
    /**
     * get user current preferred mfa option
     * this method doesn't work with totp, we need to deprecate it.
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves the current preferred mfa option if success
     */ AuthClass.prototype.getMFAOptions = function(user) {
        return new Promise(function(res, rej) {
            user.getMFAOptions(function(err, mfaOptions) {
                if (err) {
                    $86d49c7b4ba54a97$var$logger.debug('get MFA Options failed', err);
                    rej(err);
                    return;
                }
                $86d49c7b4ba54a97$var$logger.debug('get MFA options success', mfaOptions);
                res(mfaOptions);
                return;
            });
        });
    };
    /**
     * get preferred mfa method
     * @param {CognitoUser} user - the current cognito user
     * @param {GetPreferredMFAOpts} params - options for getting the current user preferred MFA
     */ AuthClass.prototype.getPreferredMFA = function(user, params) {
        var that = this;
        return new Promise(function(res, rej) {
            var bypassCache = params ? params.bypassCache : false;
            user.getUserData(function(err, data) {
                if (err) {
                    $86d49c7b4ba54a97$var$logger.debug('getting preferred mfa failed', err);
                    rej(err);
                    return;
                }
                var mfaType = that._getMfaTypeFromUserData(data);
                if (!mfaType) {
                    rej('invalid MFA Type');
                    return;
                } else {
                    res(mfaType);
                    return;
                }
            }, {
                bypassCache: bypassCache
            });
        });
    };
    AuthClass.prototype._getMfaTypeFromUserData = function(data) {
        var ret = null;
        var preferredMFA = data.PreferredMfaSetting;
        // if the user has used Auth.setPreferredMFA() to setup the mfa type
        // then the "PreferredMfaSetting" would exist in the response
        if (preferredMFA) ret = preferredMFA;
        else {
            // if mfaList exists but empty, then its noMFA
            var mfaList = data.UserMFASettingList;
            if (!mfaList) {
                // if SMS was enabled by using Auth.enableSMS(),
                // the response would contain MFAOptions
                // as for now Cognito only supports for SMS, so we will say it is 'SMS_MFA'
                // if it does not exist, then it should be NOMFA
                var MFAOptions = data.MFAOptions;
                if (MFAOptions) ret = 'SMS_MFA';
                else ret = 'NOMFA';
            } else if (mfaList.length === 0) ret = 'NOMFA';
            else $86d49c7b4ba54a97$var$logger.debug('invalid case for getPreferredMFA', data);
        }
        return ret;
    };
    AuthClass.prototype._getUserData = function(user, params) {
        return new Promise(function(res, rej) {
            user.getUserData(function(err, data) {
                if (err) {
                    $86d49c7b4ba54a97$var$logger.debug('getting user data failed', err);
                    rej(err);
                    return;
                } else {
                    res(data);
                    return;
                }
            }, params);
        });
    };
    /**
     * set preferred MFA method
     * @param {CognitoUser} user - the current Cognito user
     * @param {string} mfaMethod - preferred mfa method
     * @return - A promise resolve if success
     */ AuthClass.prototype.setPreferredMFA = function(user, mfaMethod) {
        return $86d49c7b4ba54a97$var$__awaiter(this, void 0, void 0, function() {
            var userData, smsMfaSettings, totpMfaSettings, _a, mfaList, currentMFAType, that;
            return $86d49c7b4ba54a97$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._getUserData(user, {
                                bypassCache: true
                            })
                        ];
                    case 1:
                        userData = _b.sent();
                        smsMfaSettings = null;
                        totpMfaSettings = null;
                        _a = mfaMethod;
                        switch(_a){
                            case 'TOTP':
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case 'SMS':
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 'NOMFA':
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 2:
                        totpMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 3:
                        smsMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 4:
                        mfaList = userData['UserMFASettingList'];
                        return [
                            4 /*yield*/ ,
                            this._getMfaTypeFromUserData(userData)
                        ];
                    case 5:
                        currentMFAType = _b.sent();
                        if (currentMFAType === 'NOMFA') return [
                            2 /*return*/ ,
                            Promise.resolve('No change for mfa type')
                        ];
                        else if (currentMFAType === 'SMS_MFA') smsMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else if (currentMFAType === 'SOFTWARE_TOKEN_MFA') totpMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, $cCguc.AuthErrorTypes).InvalidMFA)
                        ];
                        // if there is a UserMFASettingList in the response
                        // we need to disable every mfa type in that list
                        if (mfaList && mfaList.length !== 0) // to disable SMS or TOTP if exists in that list
                        mfaList.forEach(function(mfaType) {
                            if (mfaType === 'SMS_MFA') smsMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                            else if (mfaType === 'SOFTWARE_TOKEN_MFA') totpMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                        });
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        $86d49c7b4ba54a97$var$logger.debug('no validmfa method provided');
                        return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, $cCguc.AuthErrorTypes).NoMFA)
                        ];
                    case 7:
                        that = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                user.setUserMfaPreference(smsMfaSettings, totpMfaSettings, function(err, result) {
                                    if (err) {
                                        $86d49c7b4ba54a97$var$logger.debug('Set user mfa preference error', err);
                                        return rej(err);
                                    }
                                    $86d49c7b4ba54a97$var$logger.debug('Set user mfa success', result);
                                    $86d49c7b4ba54a97$var$logger.debug('Caching the latest user data into local');
                                    // cache the latest result into user data
                                    user.getUserData(function(err, data) {
                                        if (err) {
                                            $86d49c7b4ba54a97$var$logger.debug('getting user data failed', err);
                                            return rej(err);
                                        } else return res(result);
                                    }, {
                                        bypassCache: true
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * diable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.disableSMS = function(user) {
        return new Promise(function(res, rej) {
            user.disableMFA(function(err, data) {
                if (err) {
                    $86d49c7b4ba54a97$var$logger.debug('disable mfa failed', err);
                    rej(err);
                    return;
                }
                $86d49c7b4ba54a97$var$logger.debug('disable mfa succeed', data);
                res(data);
                return;
            });
        });
    };
    /**
     * enable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.enableSMS = function(user) {
        return new Promise(function(res, rej) {
            user.enableMFA(function(err, data) {
                if (err) {
                    $86d49c7b4ba54a97$var$logger.debug('enable mfa failed', err);
                    rej(err);
                    return;
                }
                $86d49c7b4ba54a97$var$logger.debug('enable mfa succeed', data);
                res(data);
                return;
            });
        });
    };
    /**
     * Setup TOTP
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves with the secret code if success
     */ AuthClass.prototype.setupTOTP = function(user) {
        return new Promise(function(res, rej) {
            user.associateSoftwareToken({
                onFailure: function(err) {
                    $86d49c7b4ba54a97$var$logger.debug('associateSoftwareToken failed', err);
                    rej(err);
                    return;
                },
                associateSecretCode: function(secretCode) {
                    $86d49c7b4ba54a97$var$logger.debug('associateSoftwareToken sucess', secretCode);
                    res(secretCode);
                    return;
                }
            });
        });
    };
    /**
     * verify TOTP setup
     * @param {CognitoUser} user - the current user
     * @param {string} challengeAnswer - challenge answer
     * @return - A promise resolves is success
     */ AuthClass.prototype.verifyTotpToken = function(user, challengeAnswer) {
        $86d49c7b4ba54a97$var$logger.debug('verfication totp token', user, challengeAnswer);
        return new Promise(function(res, rej) {
            user.verifySoftwareToken(challengeAnswer, 'My TOTP device', {
                onFailure: function(err) {
                    $86d49c7b4ba54a97$var$logger.debug('verifyTotpToken failed', err);
                    rej(err);
                    return;
                },
                onSuccess: function(data) {
                    $86d49c7b4ba54a97$var$dispatchAuthEvent('signIn', user, "A user " + user.getUsername() + " has been signed in");
                    $86d49c7b4ba54a97$var$logger.debug('verifyTotpToken success', data);
                    res(data);
                    return;
                }
            });
        });
    };
    /**
     * Send MFA code to confirm sign in
     * @param {Object} user - The CognitoUser object
     * @param {String} code - The confirmation code
     */ AuthClass.prototype.confirmSignIn = function(user, code, mfaType, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!code) return this.rejectAuthError((0, $cCguc.AuthErrorTypes).EmptyCode);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendMFACode(code, {
                onSuccess: function(session) {
                    return $86d49c7b4ba54a97$var$__awaiter(_this, void 0, void 0, function() {
                        var cred, e_3;
                        return $86d49c7b4ba54a97$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    $86d49c7b4ba54a97$var$logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        6
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.set(session, 'session')
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    $86d49c7b4ba54a97$var$logger.debug('succeed to get cognito credentials', cred);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 4:
                                    e_3 = _a.sent();
                                    $86d49c7b4ba54a97$var$logger.debug('cannot get cognito credentials', e_3);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 5:
                                    that.user = user;
                                    $86d49c7b4ba54a97$var$dispatchAuthEvent('signIn', user, "A user " + user.getUsername() + " has been signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 6:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function(err) {
                    $86d49c7b4ba54a97$var$logger.debug('confirm signIn failure', err);
                    reject(err);
                }
            }, mfaType, clientMetadata);
        });
    };
    AuthClass.prototype.completeNewPassword = function(user, password, requiredAttributes, clientMetadata) {
        var _this = this;
        if (requiredAttributes === void 0) requiredAttributes = {};
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!password) return this.rejectAuthError((0, $cCguc.AuthErrorTypes).EmptyPassword);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.completeNewPasswordChallenge(password, requiredAttributes, {
                onSuccess: function(session) {
                    return $86d49c7b4ba54a97$var$__awaiter(_this, void 0, void 0, function() {
                        var cred, e_4;
                        return $86d49c7b4ba54a97$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    $86d49c7b4ba54a97$var$logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        6
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.set(session, 'session')
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    $86d49c7b4ba54a97$var$logger.debug('succeed to get cognito credentials', cred);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 4:
                                    e_4 = _a.sent();
                                    $86d49c7b4ba54a97$var$logger.debug('cannot get cognito credentials', e_4);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 5:
                                    that.user = user;
                                    $86d49c7b4ba54a97$var$dispatchAuthEvent('signIn', user, "A user " + user.getUsername() + " has been signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 6:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function(err) {
                    $86d49c7b4ba54a97$var$logger.debug('completeNewPassword failure', err);
                    $86d49c7b4ba54a97$var$dispatchAuthEvent('completeNewPassword_failure', err, _this.user + " failed to complete the new password flow");
                    reject(err);
                },
                mfaRequired: function(challengeName, challengeParam) {
                    $86d49c7b4ba54a97$var$logger.debug('signIn MFA required');
                    user['challengeName'] = challengeName;
                    user['challengeParam'] = challengeParam;
                    resolve(user);
                },
                mfaSetup: function(challengeName, challengeParam) {
                    $86d49c7b4ba54a97$var$logger.debug('signIn mfa setup', challengeName);
                    user['challengeName'] = challengeName;
                    user['challengeParam'] = challengeParam;
                    resolve(user);
                },
                totpRequired: function(challengeName, challengeParam) {
                    $86d49c7b4ba54a97$var$logger.debug('signIn mfa setup', challengeName);
                    user['challengeName'] = challengeName;
                    user['challengeParam'] = challengeParam;
                    resolve(user);
                }
            }, clientMetadata);
        });
    };
    /**
     * Send the answer to a custom challenge
     * @param {CognitoUser} user - The CognitoUser object
     * @param {String} challengeResponses - The confirmation code
     */ AuthClass.prototype.sendCustomChallengeAnswer = function(user, challengeResponses, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!challengeResponses) return this.rejectAuthError((0, $cCguc.AuthErrorTypes).EmptyChallengeResponse);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendCustomChallengeAnswer(challengeResponses, _this.authCallbacks(user, resolve, reject), clientMetadata);
        });
    };
    /**
     * Update an authenticated users' attributes
     * @param {CognitoUser} - The currently logged in user object
     * @return {Promise}
     **/ AuthClass.prototype.updateUserAttributes = function(user, attributes, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        var attributeList = [];
        var that = this;
        return new Promise(function(resolve, reject) {
            that.userSession(user).then(function(session) {
                for(var key in attributes)if (key !== 'sub' && key.indexOf('_verified') < 0) {
                    var attr = {
                        Name: key,
                        Value: attributes[key]
                    };
                    attributeList.push(attr);
                }
                user.updateAttributes(attributeList, function(err, result) {
                    if (err) return reject(err);
                    else return resolve(result);
                }, clientMetadata);
            });
        });
    };
    /**
     * Return user attributes
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to user attributes if success
     */ AuthClass.prototype.userAttributes = function(user) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.getUserAttributes(function(err, attributes) {
                    if (err) reject(err);
                    else resolve(attributes);
                });
            });
        });
    };
    AuthClass.prototype.verifiedContact = function(user) {
        var that = this;
        return this.userAttributes(user).then(function(attributes) {
            var attrs = that.attributesToObject(attributes);
            var unverified = {};
            var verified = {};
            if (attrs['email']) {
                if (attrs['email_verified']) verified['email'] = attrs['email'];
                else unverified['email'] = attrs['email'];
            }
            if (attrs['phone_number']) {
                if (attrs['phone_number_verified']) verified['phone_number'] = attrs['phone_number'];
                else unverified['phone_number'] = attrs['phone_number'];
            }
            return {
                verified: verified,
                unverified: unverified
            };
        });
    };
    /**
     * Get current authenticated user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentUserPoolUser = function(params) {
        var _this = this;
        if (!this.userPool) return this.rejectNoUserPool();
        return new Promise(function(res, rej) {
            _this._storageSync.then(function() {
                return $86d49c7b4ba54a97$var$__awaiter(_this, void 0, void 0, function() {
                    var user;
                    var _this = this;
                    return $86d49c7b4ba54a97$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!this.isOAuthInProgress()) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                $86d49c7b4ba54a97$var$logger.debug('OAuth signIn in progress, waiting for resolution...');
                                return [
                                    4 /*yield*/ ,
                                    new Promise(function(res) {
                                        var timeoutId = setTimeout(function() {
                                            $86d49c7b4ba54a97$var$logger.debug('OAuth signIn in progress timeout');
                                            (0, $hPjfU.Hub).remove('auth', hostedUISignCallback);
                                            res();
                                        }, $86d49c7b4ba54a97$var$OAUTH_FLOW_MS_TIMEOUT);
                                        (0, $hPjfU.Hub).listen('auth', hostedUISignCallback);
                                        function hostedUISignCallback(_a) {
                                            var payload = _a.payload;
                                            var event = payload.event;
                                            if (event === 'cognitoHostedUI' || event === 'cognitoHostedUI_failure') {
                                                $86d49c7b4ba54a97$var$logger.debug("OAuth signIn resolved: " + event);
                                                clearTimeout(timeoutId);
                                                (0, $hPjfU.Hub).remove('auth', hostedUISignCallback);
                                                res();
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                user = this.userPool.getCurrentUser();
                                if (!user) {
                                    $86d49c7b4ba54a97$var$logger.debug('Failed to get user from user pool');
                                    rej('No current user');
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                // refresh the session if the session expired.
                                user.getSession(function(err, session) {
                                    return $86d49c7b4ba54a97$var$__awaiter(_this, void 0, void 0, function() {
                                        var bypassCache, _a, scope;
                                        var _this = this;
                                        return $86d49c7b4ba54a97$var$__generator(this, function(_b) {
                                            switch(_b.label){
                                                case 0:
                                                    if (err) {
                                                        $86d49c7b4ba54a97$var$logger.debug('Failed to get the user session', err);
                                                        rej(err);
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                    }
                                                    bypassCache = params ? params.bypassCache : false;
                                                    if (!bypassCache) return [
                                                        3 /*break*/ ,
                                                        2
                                                    ];
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.Credentials.clear()
                                                    ];
                                                case 1:
                                                    _b.sent();
                                                    _b.label = 2;
                                                case 2:
                                                    _a = session.getAccessToken().decodePayload().scope, scope = _a === void 0 ? '' : _a;
                                                    if (scope.split(' ').includes($86d49c7b4ba54a97$var$USER_ADMIN_SCOPE)) user.getUserData(function(err, data) {
                                                        if (err) {
                                                            $86d49c7b4ba54a97$var$logger.debug('getting user data failed', err);
                                                            // Make sure the user is still valid
                                                            if (err.message === 'User is disabled.' || err.message === 'User does not exist.' || err.message === 'Access Token has been revoked' // Session revoked by another app
                                                            ) rej(err);
                                                            else // the error may also be thrown when lack of permissions to get user info etc
                                                            // in that case we just bypass the error
                                                            res(user);
                                                            return;
                                                        }
                                                        var preferredMFA = data.PreferredMfaSetting || 'NOMFA';
                                                        var attributeList = [];
                                                        for(var i = 0; i < data.UserAttributes.length; i++){
                                                            var attribute = {
                                                                Name: data.UserAttributes[i].Name,
                                                                Value: data.UserAttributes[i].Value
                                                            };
                                                            var userAttribute = new (0, $frEzb.default)(attribute);
                                                            attributeList.push(userAttribute);
                                                        }
                                                        var attributes = _this.attributesToObject(attributeList);
                                                        Object.assign(user, {
                                                            attributes: attributes,
                                                            preferredMFA: preferredMFA
                                                        });
                                                        return res(user);
                                                    }, {
                                                        bypassCache: bypassCache
                                                    });
                                                    else {
                                                        $86d49c7b4ba54a97$var$logger.debug("Unable to get the user data because the " + $86d49c7b4ba54a97$var$USER_ADMIN_SCOPE + " " + "is not in the scopes of the access token");
                                                        return [
                                                            2 /*return*/ ,
                                                            res(user)
                                                        ];
                                                    }
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    });
                                });
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(e) {
                $86d49c7b4ba54a97$var$logger.debug('Failed to sync cache info into memory', e);
                return rej(e);
            });
        });
    };
    AuthClass.prototype.isOAuthInProgress = function() {
        return this.oAuthFlowInProgress;
    };
    /**
     * Get current authenticated user
     * @param {CurrentUserOpts} - options for getting the current user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentAuthenticatedUser = function(params) {
        return $86d49c7b4ba54a97$var$__awaiter(this, void 0, void 0, function() {
            var federatedUser, e_5, federatedInfo, user, e_6;
            return $86d49c7b4ba54a97$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $86d49c7b4ba54a97$var$logger.debug('getting current authenticated user');
                        federatedUser = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_5 = _a.sent();
                        $86d49c7b4ba54a97$var$logger.debug('Failed to sync cache info into memory', e_5);
                        throw e_5;
                    case 4:
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem('aws-amplify-federatedInfo'));
                            if (federatedInfo) federatedUser = $86d49c7b4ba54a97$var$__assign($86d49c7b4ba54a97$var$__assign({}, federatedInfo.user), {
                                token: federatedInfo.token
                            });
                        } catch (e) {
                            $86d49c7b4ba54a97$var$logger.debug('cannot load federated user from auth storage');
                        }
                        if (!federatedUser) return [
                            3 /*break*/ ,
                            5
                        ];
                        this.user = federatedUser;
                        $86d49c7b4ba54a97$var$logger.debug('get current authenticated federated user', this.user);
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                    case 5:
                        $86d49c7b4ba54a97$var$logger.debug('get current authenticated userpool user');
                        user = null;
                        _a.label = 6;
                    case 6:
                        _a.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser(params)
                        ];
                    case 7:
                        user = _a.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        e_6 = _a.sent();
                        if (e_6 === 'No userPool') $86d49c7b4ba54a97$var$logger.error("Cannot get the current user because the user pool is missing. Please make sure the Auth module is configured with a valid Cognito User Pool ID");
                        $86d49c7b4ba54a97$var$logger.debug('The user is not authenticated by the error', e_6);
                        return [
                            2 /*return*/ ,
                            Promise.reject('The user is not authenticated')
                        ];
                    case 9:
                        this.user = user;
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                }
            });
        });
    };
    /**
     * Get current user's session
     * @return - A promise resolves to session object if success
     */ AuthClass.prototype.currentSession = function() {
        var that = this;
        $86d49c7b4ba54a97$var$logger.debug('Getting current session');
        // Purposely not calling the reject method here because we don't need a console error
        if (!this.userPool) return Promise.reject();
        return new Promise(function(res, rej) {
            that.currentUserPoolUser().then(function(user) {
                that.userSession(user).then(function(session) {
                    res(session);
                    return;
                }).catch(function(e) {
                    $86d49c7b4ba54a97$var$logger.debug('Failed to get the current session', e);
                    rej(e);
                    return;
                });
            }).catch(function(e) {
                $86d49c7b4ba54a97$var$logger.debug('Failed to get the current user', e);
                rej(e);
                return;
            });
        });
    };
    /**
     * Get the corresponding user session
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to the session
     */ AuthClass.prototype.userSession = function(user) {
        if (!user) {
            $86d49c7b4ba54a97$var$logger.debug('the user is null');
            return this.rejectAuthError((0, $cCguc.AuthErrorTypes).NoUserSession);
        }
        return new Promise(function(resolve, reject) {
            $86d49c7b4ba54a97$var$logger.debug('Getting the session from this user:', user);
            user.getSession(function(err, session) {
                if (err) {
                    $86d49c7b4ba54a97$var$logger.debug('Failed to get the session from user', user);
                    reject(err);
                    return;
                } else {
                    $86d49c7b4ba54a97$var$logger.debug('Succeed to get the user session', session);
                    resolve(session);
                    return;
                }
            });
        });
    };
    /**
     * Get authenticated credentials of current user.
     * @return - A promise resolves to be current user's credentials
     */ AuthClass.prototype.currentUserCredentials = function() {
        return $86d49c7b4ba54a97$var$__awaiter(this, void 0, void 0, function() {
            var e_7, federatedInfo;
            var _this = this;
            return $86d49c7b4ba54a97$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $86d49c7b4ba54a97$var$logger.debug('Getting current user credentials');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_7 = _a.sent();
                        $86d49c7b4ba54a97$var$logger.debug('Failed to sync cache info into memory', e_7);
                        throw e_7;
                    case 4:
                        federatedInfo = null;
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem('aws-amplify-federatedInfo'));
                        } catch (e) {
                            $86d49c7b4ba54a97$var$logger.debug('failed to get or parse item aws-amplify-federatedInfo', e);
                        }
                        if (federatedInfo) // refresh the jwt token here if necessary
                        return [
                            2 /*return*/ ,
                            this.Credentials.refreshFederatedToken(federatedInfo)
                        ];
                        else return [
                            2 /*return*/ ,
                            this.currentSession().then(function(session) {
                                $86d49c7b4ba54a97$var$logger.debug('getting session success', session);
                                return _this.Credentials.set(session, 'session');
                            }).catch(function(error) {
                                $86d49c7b4ba54a97$var$logger.debug('getting session failed', error);
                                return _this.Credentials.set(null, 'guest');
                            })
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.currentCredentials = function() {
        $86d49c7b4ba54a97$var$logger.debug('getting current credentials');
        return this.Credentials.get();
    };
    /**
     * Initiate an attribute confirmation request
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attributes to be verified
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttribute = function(user, attr, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.getAttributeVerificationCode(attr, {
                onSuccess: function() {
                    return resolve();
                },
                onFailure: function(err) {
                    return reject(err);
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm an attribute using a confirmation code
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttributeSubmit = function(user, attr, code) {
        if (!code) return this.rejectAuthError((0, $cCguc.AuthErrorTypes).EmptyCode);
        return new Promise(function(resolve, reject) {
            user.verifyAttribute(attr, code, {
                onSuccess: function(data) {
                    resolve(data);
                    return;
                },
                onFailure: function(err) {
                    reject(err);
                    return;
                }
            });
        });
    };
    AuthClass.prototype.verifyCurrentUserAttribute = function(attr) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttribute(user, attr);
        });
    };
    /**
     * Confirm current user's attribute using a confirmation code
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyCurrentUserAttributeSubmit = function(attr, code) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttributeSubmit(user, attr, code);
        });
    };
    AuthClass.prototype.cognitoIdentitySignOut = function(opts, user) {
        return $86d49c7b4ba54a97$var$__awaiter(this, void 0, void 0, function() {
            var e_8, isSignedInHostedUI;
            var _this = this;
            return $86d49c7b4ba54a97$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_8 = _a.sent();
                        $86d49c7b4ba54a97$var$logger.debug('Failed to sync cache info into memory', e_8);
                        throw e_8;
                    case 3:
                        isSignedInHostedUI = this._oAuthHandler && this._storage.getItem('amplify-signin-with-hostedUI') === 'true';
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                if (opts && opts.global) {
                                    $86d49c7b4ba54a97$var$logger.debug('user global sign out', user);
                                    // in order to use global signout
                                    // we must validate the user as an authenticated user by using getSession
                                    user.getSession(function(err, result) {
                                        if (err) {
                                            $86d49c7b4ba54a97$var$logger.debug('failed to get the user session', err);
                                            return rej(err);
                                        }
                                        user.globalSignOut({
                                            onSuccess: function(data) {
                                                $86d49c7b4ba54a97$var$logger.debug('global sign out success');
                                                if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                                else return res();
                                            },
                                            onFailure: function(err) {
                                                $86d49c7b4ba54a97$var$logger.debug('global sign out failed', err);
                                                return rej(err);
                                            }
                                        });
                                    });
                                } else {
                                    $86d49c7b4ba54a97$var$logger.debug('user sign out', user);
                                    user.signOut();
                                    if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                    else return res();
                                }
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.oAuthSignOutRedirect = function(resolve, reject) {
        var isBrowser = (0, $7HFvj.JS).browserOrNode().isBrowser;
        if (isBrowser) this.oAuthSignOutRedirectOrReject(reject);
        else this.oAuthSignOutAndResolve(resolve);
    };
    AuthClass.prototype.oAuthSignOutAndResolve = function(resolve) {
        this._oAuthHandler.signOut();
        resolve();
    };
    AuthClass.prototype.oAuthSignOutRedirectOrReject = function(reject) {
        this._oAuthHandler.signOut(); // this method redirects url
        // App should be redirected to another url otherwise it will reject
        setTimeout(function() {
            return reject('Signout timeout fail');
        }, 3000);
    };
    /**
     * Sign out method
     * @
     * @return - A promise resolved if success
     */ AuthClass.prototype.signOut = function(opts) {
        return $86d49c7b4ba54a97$var$__awaiter(this, void 0, void 0, function() {
            var e_9, user;
            return $86d49c7b4ba54a97$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanCachedItems()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_9 = _a.sent();
                        $86d49c7b4ba54a97$var$logger.debug('failed to clear cached items');
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        if (!this.userPool) return [
                            3 /*break*/ ,
                            7
                        ];
                        user = this.userPool.getCurrentUser();
                        if (!user) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.cognitoIdentitySignOut(opts, user)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        $86d49c7b4ba54a97$var$logger.debug('no current Cognito user');
                        _a.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        $86d49c7b4ba54a97$var$logger.debug('no Congito User pool');
                        _a.label = 8;
                    case 8:
                        /**
                         * Note for future refactor - no reliable way to get username with
                         * Cognito User Pools vs Identity when federating with Social Providers
                         * This is why we need a well structured session object that can be inspected
                         * and information passed back in the message below for Hub dispatch
                         */ $86d49c7b4ba54a97$var$dispatchAuthEvent('signOut', this.user, "A user has been signed out");
                        this.user = null;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.cleanCachedItems = function() {
        return $86d49c7b4ba54a97$var$__awaiter(this, void 0, void 0, function() {
            return $86d49c7b4ba54a97$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // clear cognito cached item
                        return [
                            4 /*yield*/ ,
                            this.Credentials.clear()
                        ];
                    case 1:
                        // clear cognito cached item
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Change a password for an authenticated user
     * @param {Object} user - The CognitoUser object
     * @param {String} oldPassword - the current password
     * @param {String} newPassword - the requested new password
     * @return - A promise resolves if success
     */ AuthClass.prototype.changePassword = function(user, oldPassword, newPassword, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.changePassword(oldPassword, newPassword, function(err, data) {
                    if (err) {
                        $86d49c7b4ba54a97$var$logger.debug('change password failure', err);
                        return reject(err);
                    } else return resolve(data);
                }, clientMetadata);
            });
        });
    };
    /**
     * Initiate a forgot password request
     * @param {String} username - the username to change password
     * @return - A promise resolves if success
     */ AuthClass.prototype.forgotPassword = function(username, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $cCguc.AuthErrorTypes).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.forgotPassword({
                onSuccess: function() {
                    resolve();
                    return;
                },
                onFailure: function(err) {
                    $86d49c7b4ba54a97$var$logger.debug('forgot password failure', err);
                    $86d49c7b4ba54a97$var$dispatchAuthEvent('forgotPassword_failure', err, username + " forgotPassword failed");
                    reject(err);
                    return;
                },
                inputVerificationCode: function(data) {
                    $86d49c7b4ba54a97$var$dispatchAuthEvent('forgotPassword', user, username + " has initiated forgot password flow");
                    resolve(data);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm a new password using a confirmation Code
     * @param {String} username - The username
     * @param {String} code - The confirmation code
     * @param {String} password - The new password
     * @return - A promise that resolves if success
     */ AuthClass.prototype.forgotPasswordSubmit = function(username, code, password, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $cCguc.AuthErrorTypes).EmptyUsername);
        if (!code) return this.rejectAuthError((0, $cCguc.AuthErrorTypes).EmptyCode);
        if (!password) return this.rejectAuthError((0, $cCguc.AuthErrorTypes).EmptyPassword);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.confirmPassword(code, password, {
                onSuccess: function() {
                    $86d49c7b4ba54a97$var$dispatchAuthEvent('forgotPasswordSubmit', user, username + " forgotPasswordSubmit successful");
                    resolve();
                    return;
                },
                onFailure: function(err) {
                    $86d49c7b4ba54a97$var$dispatchAuthEvent('forgotPasswordSubmit_failure', err, username + " forgotPasswordSubmit failed");
                    reject(err);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Get user information
     * @async
     * @return {Object }- current User's information
     */ AuthClass.prototype.currentUserInfo = function() {
        return $86d49c7b4ba54a97$var$__awaiter(this, void 0, void 0, function() {
            var source, user, attributes, userAttrs, credentials, e_10, info, err_1, user;
            return $86d49c7b4ba54a97$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        source = this.Credentials.getCredSource();
                        if (!(!source || source === 'aws' || source === 'userPool')) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser().catch(function(err) {
                                return $86d49c7b4ba54a97$var$logger.debug(err);
                            })
                        ];
                    case 1:
                        user = _a.sent();
                        if (!user) return [
                            2 /*return*/ ,
                            null
                        ];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.userAttributes(user)
                        ];
                    case 3:
                        attributes = _a.sent();
                        userAttrs = this.attributesToObject(attributes);
                        credentials = null;
                        _a.label = 4;
                    case 4:
                        _a.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentCredentials()
                        ];
                    case 5:
                        credentials = _a.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        e_10 = _a.sent();
                        $86d49c7b4ba54a97$var$logger.debug('Failed to retrieve credentials while getting current user info', e_10);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        info = {
                            id: credentials ? credentials.identityId : undefined,
                            username: user.getUsername(),
                            attributes: userAttrs
                        };
                        return [
                            2 /*return*/ ,
                            info
                        ];
                    case 8:
                        err_1 = _a.sent();
                        $86d49c7b4ba54a97$var$logger.debug('currentUserInfo error', err_1);
                        return [
                            2 /*return*/ ,
                            {}
                        ];
                    case 9:
                        if (source === 'federated') {
                            user = this.user;
                            return [
                                2 /*return*/ ,
                                user ? user : {}
                            ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.federatedSignIn = function(providerOrOptions, response, user) {
        return $86d49c7b4ba54a97$var$__awaiter(this, void 0, void 0, function() {
            var options, provider, customState, client_id, redirect_uri, provider, loggedInUser, token, identity_id, expires_at, credentials, currentUser;
            return $86d49c7b4ba54a97$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation requires either a User Pool or Identity Pool in config");
                        // Ensure backwards compatability
                        if (typeof providerOrOptions === 'undefined') {
                            if (this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation with Identity Pools requires tokens passed as arguments");
                        }
                        if (!((0, $cCguc.isFederatedSignInOptions)(providerOrOptions) || (0, $cCguc.isFederatedSignInOptionsCustom)(providerOrOptions) || (0, $cCguc.hasCustomState)(providerOrOptions) || typeof providerOrOptions === 'undefined')) return [
                            3 /*break*/ ,
                            1
                        ];
                        options = providerOrOptions || {
                            provider: (0, $cCguc.CognitoHostedUIIdentityProvider).Cognito
                        };
                        provider = (0, $cCguc.isFederatedSignInOptions)(options) ? options.provider : options.customProvider;
                        customState = (0, $cCguc.isFederatedSignInOptions)(options) ? options.customState : options.customState;
                        if (this._config.userPoolId) {
                            client_id = (0, $cCguc.isCognitoHostedOpts)(this._config.oauth) ? this._config.userPoolWebClientId : this._config.oauth.clientID;
                            redirect_uri = (0, $cCguc.isCognitoHostedOpts)(this._config.oauth) ? this._config.oauth.redirectSignIn : this._config.oauth.redirectUri;
                            this._oAuthHandler.oauthSignIn(this._config.oauth.responseType, this._config.oauth.domain, redirect_uri, client_id, provider, customState);
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 1:
                        provider = providerOrOptions;
                        // To check if the user is already logged in
                        try {
                            loggedInUser = JSON.stringify(JSON.parse(this._storage.getItem('aws-amplify-federatedInfo')).user);
                            if (loggedInUser) $86d49c7b4ba54a97$var$logger.warn("There is already a signed in user: " + loggedInUser + " in your app.\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tYou should not call Auth.federatedSignIn method again as it may cause unexpected behavior.");
                        } catch (e) {}
                        token = response.token, identity_id = response.identity_id, expires_at = response.expires_at;
                        return [
                            4 /*yield*/ ,
                            this.Credentials.set({
                                provider: provider,
                                token: token,
                                identity_id: identity_id,
                                user: user,
                                expires_at: expires_at
                            }, 'federation')
                        ];
                    case 2:
                        credentials = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.currentAuthenticatedUser()
                        ];
                    case 3:
                        currentUser = _a.sent();
                        $86d49c7b4ba54a97$var$dispatchAuthEvent('signIn', currentUser, "A user " + currentUser.username + " has been signed in");
                        $86d49c7b4ba54a97$var$logger.debug('federated sign in credentials', credentials);
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Used to complete the OAuth flow with or without the Cognito Hosted UI
     * @param {String} URL - optional parameter for customers to pass in the response URL
     */ AuthClass.prototype._handleAuthResponse = function(URL) {
        return $86d49c7b4ba54a97$var$__awaiter(this, void 0, void 0, function() {
            var currentUrl, hasCodeOrError, hasTokenOrError, _a, accessToken, idToken, refreshToken, state, session, credentials, isCustomStateIncluded, currentUser, customState, err_2;
            return $86d49c7b4ba54a97$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (this.oAuthFlowInProgress) {
                            $86d49c7b4ba54a97$var$logger.debug("Skipping URL " + URL + " current flow in progress");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            8,
                            9
                        ]);
                        this.oAuthFlowInProgress = true;
                        if (!this._config.userPoolId) throw new Error("OAuth responses require a User Pool defined in config");
                        $86d49c7b4ba54a97$var$dispatchAuthEvent('parsingCallbackUrl', {
                            url: URL
                        }, "The callback url is being parsed");
                        currentUrl = URL || ((0, $7HFvj.JS).browserOrNode().isBrowser ? window.location.href : '');
                        hasCodeOrError = !!((0, $2qlBa.parse)(currentUrl).query || '').split('&').map(function(entry) {
                            return entry.split('=');
                        }).find(function(_a) {
                            var _b = $86d49c7b4ba54a97$var$__read(_a, 1), k = _b[0];
                            return k === 'code' || k === 'error';
                        });
                        hasTokenOrError = !!((0, $2qlBa.parse)(currentUrl).hash || '#').substr(1).split('&').map(function(entry) {
                            return entry.split('=');
                        }).find(function(_a) {
                            var _b = $86d49c7b4ba54a97$var$__read(_a, 1), k = _b[0];
                            return k === 'access_token' || k === 'error';
                        });
                        if (!(hasCodeOrError || hasTokenOrError)) return [
                            3 /*break*/ ,
                            7
                        ];
                        this._storage.setItem('amplify-redirected-from-hosted-ui', 'true');
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._oAuthHandler.handleAuthResponse(currentUrl)
                        ];
                    case 3:
                        _a = _b.sent(), accessToken = _a.accessToken, idToken = _a.idToken, refreshToken = _a.refreshToken, state = _a.state;
                        session = new (0, $1rQ96.default)({
                            IdToken: new (0, $a6o5Y.default)({
                                IdToken: idToken
                            }),
                            RefreshToken: new (0, $5Ra9u.default)({
                                RefreshToken: refreshToken
                            }),
                            AccessToken: new (0, $eqVzU.default)({
                                AccessToken: accessToken
                            })
                        });
                        credentials = void 0;
                        if (!this._config.identityPoolId) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.Credentials.set(session, 'session')
                        ];
                    case 4:
                        credentials = _b.sent();
                        $86d49c7b4ba54a97$var$logger.debug('AWS credentials', credentials);
                        _b.label = 5;
                    case 5:
                        isCustomStateIncluded = /-/.test(state);
                        currentUser = this.createCognitoUser(session.getIdToken().decodePayload()['cognito:username']);
                        // This calls cacheTokens() in Cognito SDK
                        currentUser.setSignInUserSession(session);
                        if (window && typeof window.history !== 'undefined') window.history.replaceState({}, null, this._config.oauth.redirectSignIn);
                        $86d49c7b4ba54a97$var$dispatchAuthEvent('signIn', currentUser, "A user " + currentUser.getUsername() + " has been signed in");
                        $86d49c7b4ba54a97$var$dispatchAuthEvent('cognitoHostedUI', currentUser, "A user " + currentUser.getUsername() + " has been signed in via Cognito Hosted UI");
                        if (isCustomStateIncluded) {
                            customState = state.split('-').splice(1).join('-');
                            $86d49c7b4ba54a97$var$dispatchAuthEvent('customOAuthState', (0, $lpLq9.urlSafeDecode)(customState), "State for user " + currentUser.getUsername());
                        }
                        //#endregion
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 6:
                        err_2 = _b.sent();
                        $86d49c7b4ba54a97$var$logger.debug('Error in cognito hosted auth response', err_2);
                        $86d49c7b4ba54a97$var$dispatchAuthEvent('signIn_failure', err_2, "The OAuth response flow failed");
                        $86d49c7b4ba54a97$var$dispatchAuthEvent('cognitoHostedUI_failure', err_2, "A failure occurred when returning to the Cognito Hosted UI");
                        $86d49c7b4ba54a97$var$dispatchAuthEvent('customState_failure', err_2, "A failure occurred when returning state");
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        this.oAuthFlowInProgress = false;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ AuthClass.prototype.essentialCredentials = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    AuthClass.prototype.attributesToObject = function(attributes) {
        var obj = {};
        if (attributes) attributes.map(function(attribute) {
            if (attribute.Name === 'email_verified' || attribute.Name === 'phone_number_verified') obj[attribute.Name] = attribute.Value === 'true' || attribute.Value === true;
            else obj[attribute.Name] = attribute.Value;
        });
        return obj;
    };
    AuthClass.prototype.createCognitoUser = function(username) {
        var userData = {
            Username: username,
            Pool: this.userPool
        };
        userData.Storage = this._storage;
        var authenticationFlowType = this._config.authenticationFlowType;
        var user = new (0, $7VU9U.default)(userData);
        if (authenticationFlowType) user.setAuthenticationFlowType(authenticationFlowType);
        return user;
    };
    AuthClass.prototype._isValidAuthStorage = function(obj) {
        // We need to check if the obj has the functions of Storage
        return !!obj && typeof obj.getItem === 'function' && typeof obj.setItem === 'function' && typeof obj.removeItem === 'function' && typeof obj.clear === 'function';
    };
    AuthClass.prototype.noUserPoolErrorHandler = function(config) {
        if (config) {
            if (!config.userPoolId || !config.identityPoolId) return (0, $cCguc.AuthErrorTypes).MissingAuthConfig;
        }
        return (0, $cCguc.AuthErrorTypes).NoConfig;
    };
    AuthClass.prototype.rejectAuthError = function(type) {
        return Promise.reject(new (0, $7Rn4k.AuthError)(type));
    };
    AuthClass.prototype.rejectNoUserPool = function() {
        var type = this.noUserPoolErrorHandler(this._config);
        return Promise.reject(new (0, $7Rn4k.NoUserPoolError)(type));
    };
    return AuthClass;
}();
var $86d49c7b4ba54a97$export$334c29725a78c21d = new $86d49c7b4ba54a97$export$eeff9d1a8b8c057b(null);
(0, $9QDF4.Amplify).register($86d49c7b4ba54a97$export$334c29725a78c21d);

});
parcelRegister("cCguc", function(module, exports) {

$parcel$export(module.exports, "CognitoHostedUIIdentityProvider", function () { return $92f5d27351c3dcbe$export$eeb013770cb92342; });
$parcel$export(module.exports, "isFederatedSignInOptions", function () { return $92f5d27351c3dcbe$export$9b905d6895bdc426; });
$parcel$export(module.exports, "isFederatedSignInOptionsCustom", function () { return $92f5d27351c3dcbe$export$828f8efbdf71714b; });
$parcel$export(module.exports, "hasCustomState", function () { return $92f5d27351c3dcbe$export$6bae5520ca265d22; });
$parcel$export(module.exports, "isCognitoHostedOpts", function () { return $92f5d27351c3dcbe$export$b380f8ec78ef17c8; });
$parcel$export(module.exports, "AuthErrorTypes", function () { return $92f5d27351c3dcbe$export$edb367c0a140d3db; });
$parcel$export(module.exports, "isUsernamePasswordOpts", function () { return $92f5d27351c3dcbe$export$ad34f09783c4cb16; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $92f5d27351c3dcbe$export$eeb013770cb92342;
(function(CognitoHostedUIIdentityProvider) {
    CognitoHostedUIIdentityProvider["Cognito"] = "COGNITO";
    CognitoHostedUIIdentityProvider["Google"] = "Google";
    CognitoHostedUIIdentityProvider["Facebook"] = "Facebook";
    CognitoHostedUIIdentityProvider["Amazon"] = "LoginWithAmazon";
    CognitoHostedUIIdentityProvider["Apple"] = "SignInWithApple";
})($92f5d27351c3dcbe$export$eeb013770cb92342 || ($92f5d27351c3dcbe$export$eeb013770cb92342 = {}));
function $92f5d27351c3dcbe$export$9b905d6895bdc426(obj) {
    var keys = [
        'provider'
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $92f5d27351c3dcbe$export$828f8efbdf71714b(obj) {
    var keys = [
        'customProvider'
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $92f5d27351c3dcbe$export$6bae5520ca265d22(obj) {
    var keys = [
        'customState'
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $92f5d27351c3dcbe$export$b380f8ec78ef17c8(oauth) {
    return oauth.redirectSignIn !== undefined;
}
var $92f5d27351c3dcbe$export$edb367c0a140d3db;
(function(AuthErrorTypes) {
    AuthErrorTypes["NoConfig"] = "noConfig";
    AuthErrorTypes["MissingAuthConfig"] = "missingAuthConfig";
    AuthErrorTypes["EmptyUsername"] = "emptyUsername";
    AuthErrorTypes["InvalidUsername"] = "invalidUsername";
    AuthErrorTypes["EmptyPassword"] = "emptyPassword";
    AuthErrorTypes["EmptyCode"] = "emptyCode";
    AuthErrorTypes["SignUpError"] = "signUpError";
    AuthErrorTypes["NoMFA"] = "noMFA";
    AuthErrorTypes["InvalidMFA"] = "invalidMFA";
    AuthErrorTypes["EmptyChallengeResponse"] = "emptyChallengeResponse";
    AuthErrorTypes["NoUserSession"] = "noUserSession";
    AuthErrorTypes["Default"] = "default";
})($92f5d27351c3dcbe$export$edb367c0a140d3db || ($92f5d27351c3dcbe$export$edb367c0a140d3db = {}));
function $92f5d27351c3dcbe$export$ad34f09783c4cb16(obj) {
    return !!obj.username;
}

});

parcelRegister("yHOl4", function(module, exports) {

$parcel$export(module.exports, "AuthenticationDetails", function () { return (parcelRequire("gQJHs")).default; });
$parcel$export(module.exports, "CognitoAccessToken", function () { return (parcelRequire("eqVzU")).default; });
$parcel$export(module.exports, "CognitoIdToken", function () { return (parcelRequire("a6o5Y")).default; });
$parcel$export(module.exports, "CognitoRefreshToken", function () { return (parcelRequire("5Ra9u")).default; });
$parcel$export(module.exports, "CognitoUser", function () { return (parcelRequire("7VU9U")).default; });
$parcel$export(module.exports, "CognitoUserAttribute", function () { return (parcelRequire("frEzb")).default; });
$parcel$export(module.exports, "CognitoUserPool", function () { return (parcelRequire("bbkkz")).default; });
$parcel$export(module.exports, "CognitoUserSession", function () { return (parcelRequire("1rQ96")).default; });
$parcel$export(module.exports, "CookieStorage", function () { return (parcelRequire("j3bXS")).default; });
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gQJHs = parcelRequire("gQJHs");

var $gBu9Y = parcelRequire("gBu9Y");

var $eqVzU = parcelRequire("eqVzU");

var $a6o5Y = parcelRequire("a6o5Y");

var $5Ra9u = parcelRequire("5Ra9u");

var $7VU9U = parcelRequire("7VU9U");

var $frEzb = parcelRequire("frEzb");

var $bbkkz = parcelRequire("bbkkz");

var $1rQ96 = parcelRequire("1rQ96");

var $j3bXS = parcelRequire("j3bXS");

var $2RtQ2 = parcelRequire("2RtQ2");

var $cfxLo = parcelRequire("cfxLo");

});
parcelRegister("gQJHs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c444f3b3106c423b$export$2e2bcd8739ae039; });
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ /** @class */ var $c444f3b3106c423b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationDetails object
   * @param {object=} data Creation options.
   * @param {string} data.Username User being authenticated.
   * @param {string} data.Password Plain-text password to authenticate with.
   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
   */ function AuthenticationDetails(data) {
        var _ref = data || {}, ValidationData = _ref.ValidationData, Username = _ref.Username, Password = _ref.Password, AuthParameters = _ref.AuthParameters, ClientMetadata = _ref.ClientMetadata;
        this.validationData = ValidationData || {};
        this.authParameters = AuthParameters || {};
        this.clientMetadata = ClientMetadata || {};
        this.username = Username;
        this.password = Password;
    }
    /**
   * @returns {string} the record's username
   */ var _proto = AuthenticationDetails.prototype;
    _proto.getUsername = function getUsername() {
        return this.username;
    };
    _proto.getPassword = function getPassword() {
        return this.password;
    };
    _proto.getValidationData = function getValidationData() {
        return this.validationData;
    };
    _proto.getAuthParameters = function getAuthParameters() {
        return this.authParameters;
    };
    _proto.getClientMetadata = function getClientMetadata() {
        return this.clientMetadata;
    };
    return AuthenticationDetails;
}();

});

parcelRegister("gBu9Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1677f305997fc20$export$2e2bcd8739ae039; });
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ 
var $a5OKa = parcelRequire("a5OKa");

var $9LFT6 = parcelRequire("9LFT6");
parcelRequire("Fuwoa");

var $1HHSs = parcelRequire("1HHSs");

var $2qAwF = parcelRequire("2qAwF");

var $3u6uB = parcelRequire("3u6uB");

var $dAjLU = parcelRequire("dAjLU");
var $c1677f305997fc20$var$randomBytes = function randomBytes(nBytes) {
    return (0, $a5OKa.Buffer).from(new (0, $3u6uB.default)().random(nBytes).toString(), 'hex');
};
var $c1677f305997fc20$var$initN = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
var $c1677f305997fc20$var$newPasswordRequiredChallengeUserAttributePrefix = 'userAttributes.';
/** @class */ var $c1677f305997fc20$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationHelper object
   * @param {string} PoolName Cognito user pool name.
   */ function AuthenticationHelper(PoolName) {
        this.N = new (0, $dAjLU.default)($c1677f305997fc20$var$initN, 16);
        this.g = new (0, $dAjLU.default)('2', 16);
        this.k = new (0, $dAjLU.default)(this.hexHash("00" + this.N.toString(16) + "0" + this.g.toString(16)), 16);
        this.smallAValue = this.generateRandomSmallA();
        this.getLargeAValue(function() {});
        this.infoBits = (0, $a5OKa.Buffer).from('Caldera Derived Key', 'utf8');
        this.poolName = PoolName;
    }
    /**
   * @returns {BigInteger} small A, a random number
   */ var _proto = AuthenticationHelper.prototype;
    _proto.getSmallAValue = function getSmallAValue() {
        return this.smallAValue;
    };
    _proto.getLargeAValue = function getLargeAValue(callback) {
        var _this = this;
        if (this.largeAValue) callback(null, this.largeAValue);
        else this.calculateA(this.smallAValue, function(err, largeAValue) {
            if (err) callback(err, null);
            _this.largeAValue = largeAValue;
            callback(null, _this.largeAValue);
        });
    };
    _proto.generateRandomSmallA = function generateRandomSmallA() {
        var hexRandom = $c1677f305997fc20$var$randomBytes(128).toString('hex');
        var randomBigInt = new (0, $dAjLU.default)(hexRandom, 16);
        var smallABigInt = randomBigInt.mod(this.N);
        return smallABigInt;
    };
    _proto.generateRandomString = function generateRandomString() {
        return $c1677f305997fc20$var$randomBytes(40).toString('base64');
    };
    _proto.getRandomPassword = function getRandomPassword() {
        return this.randomPassword;
    };
    _proto.getSaltDevices = function getSaltDevices() {
        return this.SaltToHashDevices;
    };
    _proto.getVerifierDevices = function getVerifierDevices() {
        return this.verifierDevices;
    };
    _proto.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
        var _this2 = this;
        this.randomPassword = this.generateRandomString();
        var combinedString = "" + deviceGroupKey + username + ":" + this.randomPassword;
        var hashedString = this.hash(combinedString);
        var hexRandom = $c1677f305997fc20$var$randomBytes(16).toString('hex');
        this.SaltToHashDevices = this.padHex(new (0, $dAjLU.default)(hexRandom, 16));
        this.g.modPow(new (0, $dAjLU.default)(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function(err, verifierDevicesNotPadded) {
            if (err) callback(err, null);
            _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
            callback(null, null);
        });
    };
    _proto.calculateA = function calculateA(a, callback) {
        var _this3 = this;
        this.g.modPow(a, this.N, function(err, A) {
            if (err) callback(err, null);
            if (A.mod(_this3.N).equals((0, $dAjLU.default).ZERO)) callback(new Error('Illegal paramater. A mod N cannot be 0.'), null);
            callback(null, A);
        });
    };
    _proto.calculateU = function calculateU(A, B) {
        this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
        var finalU = new (0, $dAjLU.default)(this.UHexHash, 16);
        return finalU;
    };
    _proto.hash = function hash(buf) {
        var str = buf instanceof (0, $a5OKa.Buffer) ? (0, (/*@__PURE__*/$parcel$interopDefault($9LFT6))).lib.WordArray.create(buf) : buf;
        var hashHex = (0, (/*@__PURE__*/$parcel$interopDefault($1HHSs)))(str).toString();
        return new Array(64 - hashHex.length).join('0') + hashHex;
    };
    _proto.hexHash = function hexHash(hexStr) {
        return this.hash((0, $a5OKa.Buffer).from(hexStr, 'hex'));
    };
    _proto.computehkdf = function computehkdf(ikm, salt) {
        var infoBitsWordArray = (0, (/*@__PURE__*/$parcel$interopDefault($9LFT6))).lib.WordArray.create((0, $a5OKa.Buffer).concat([
            this.infoBits,
            (0, $a5OKa.Buffer).from(String.fromCharCode(1), 'utf8')
        ]));
        var ikmWordArray = ikm instanceof (0, $a5OKa.Buffer) ? (0, (/*@__PURE__*/$parcel$interopDefault($9LFT6))).lib.WordArray.create(ikm) : ikm;
        var saltWordArray = salt instanceof (0, $a5OKa.Buffer) ? (0, (/*@__PURE__*/$parcel$interopDefault($9LFT6))).lib.WordArray.create(salt) : salt;
        var prk = (0, (/*@__PURE__*/$parcel$interopDefault($2qAwF)))(ikmWordArray, saltWordArray);
        var hmac = (0, (/*@__PURE__*/$parcel$interopDefault($2qAwF)))(infoBitsWordArray, prk);
        return (0, $a5OKa.Buffer).from(hmac.toString(), 'hex').slice(0, 16);
    };
    _proto.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
        var _this4 = this;
        if (serverBValue.mod(this.N).equals((0, $dAjLU.default).ZERO)) throw new Error('B cannot be zero.');
        this.UValue = this.calculateU(this.largeAValue, serverBValue);
        if (this.UValue.equals((0, $dAjLU.default).ZERO)) throw new Error('U cannot be zero.');
        var usernamePassword = "" + this.poolName + username + ":" + password;
        var usernamePasswordHash = this.hash(usernamePassword);
        var xValue = new (0, $dAjLU.default)(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
        this.calculateS(xValue, serverBValue, function(err, sValue) {
            if (err) callback(err, null);
            var hkdf = _this4.computehkdf((0, $a5OKa.Buffer).from(_this4.padHex(sValue), 'hex'), (0, $a5OKa.Buffer).from(_this4.padHex(_this4.UValue.toString(16)), 'hex'));
            callback(null, hkdf);
        });
    };
    _proto.calculateS = function calculateS(xValue, serverBValue, callback) {
        var _this5 = this;
        this.g.modPow(xValue, this.N, function(err, gModPowXN) {
            if (err) callback(err, null);
            var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
            intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function(err2, result) {
                if (err2) callback(err2, null);
                callback(null, result.mod(_this5.N));
            });
        });
    };
    _proto.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
        return $c1677f305997fc20$var$newPasswordRequiredChallengeUserAttributePrefix;
    };
    _proto.padHex = function padHex(bigInt) {
        var hashStr = bigInt.toString(16);
        if (hashStr.length % 2 === 1) hashStr = "0" + hashStr;
        else if ('89ABCDEFabcdef'.indexOf(hashStr[0]) !== -1) hashStr = "00" + hashStr;
        return hashStr;
    };
    return AuthenticationHelper;
}();

});
parcelRegister("a5OKa", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $7591bba1aafad6af$export$a143d493d941bafc; }, function (v) { return $7591bba1aafad6af$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $7591bba1aafad6af$export$f99ded8fe4b79145; }, function (v) { return $7591bba1aafad6af$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $7591bba1aafad6af$export$a143d493d941bafc;
var $7591bba1aafad6af$export$e4cf37d7f6fb9e0a;
var $7591bba1aafad6af$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $7591bba1aafad6af$export$599f31c3813fae4d;
'use strict';

var $9lqm0 = parcelRequire("9lqm0");

var $4WZRW = parcelRequire("4WZRW");

var $g9AEB = parcelRequire("g9AEB");
$7591bba1aafad6af$export$a143d493d941bafc = $7591bba1aafad6af$var$Buffer;
$7591bba1aafad6af$export$e4cf37d7f6fb9e0a = $7591bba1aafad6af$var$SlowBuffer;
$7591bba1aafad6af$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $7591bba1aafad6af$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $7591bba1aafad6af$var$typedArraySupport();
$7591bba1aafad6af$export$599f31c3813fae4d = $7591bba1aafad6af$var$kMaxLength();
function $7591bba1aafad6af$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $7591bba1aafad6af$var$kMaxLength() {
    return $7591bba1aafad6af$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $7591bba1aafad6af$var$createBuffer(that, length) {
    if ($7591bba1aafad6af$var$kMaxLength() < length) throw new RangeError('Invalid typed array length');
    if ($7591bba1aafad6af$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $7591bba1aafad6af$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $7591bba1aafad6af$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $7591bba1aafad6af$var$Buffer(arg, encodingOrOffset, length) {
    if (!$7591bba1aafad6af$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $7591bba1aafad6af$var$Buffer)) return new $7591bba1aafad6af$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new Error('If encoding is specified then the first argument must be a string');
        return $7591bba1aafad6af$var$allocUnsafe(this, arg);
    }
    return $7591bba1aafad6af$var$from(this, arg, encodingOrOffset, length);
}
$7591bba1aafad6af$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$7591bba1aafad6af$var$Buffer._augment = function(arr) {
    arr.__proto__ = $7591bba1aafad6af$var$Buffer.prototype;
    return arr;
};
function $7591bba1aafad6af$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === 'number') throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) return $7591bba1aafad6af$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === 'string') return $7591bba1aafad6af$var$fromString(that, value, encodingOrOffset);
    return $7591bba1aafad6af$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $7591bba1aafad6af$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $7591bba1aafad6af$var$from(null, value, encodingOrOffset, length);
};
if ($7591bba1aafad6af$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $7591bba1aafad6af$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $7591bba1aafad6af$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== 'undefined' && Symbol.species && $7591bba1aafad6af$var$Buffer[Symbol.species] === $7591bba1aafad6af$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($7591bba1aafad6af$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $7591bba1aafad6af$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $7591bba1aafad6af$var$alloc(that, size, fill, encoding) {
    $7591bba1aafad6af$var$assertSize(size);
    if (size <= 0) return $7591bba1aafad6af$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? $7591bba1aafad6af$var$createBuffer(that, size).fill(fill, encoding) : $7591bba1aafad6af$var$createBuffer(that, size).fill(fill);
    return $7591bba1aafad6af$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $7591bba1aafad6af$var$Buffer.alloc = function(size, fill, encoding) {
    return $7591bba1aafad6af$var$alloc(null, size, fill, encoding);
};
function $7591bba1aafad6af$var$allocUnsafe(that, size) {
    $7591bba1aafad6af$var$assertSize(size);
    that = $7591bba1aafad6af$var$createBuffer(that, size < 0 ? 0 : $7591bba1aafad6af$var$checked(size) | 0);
    if (!$7591bba1aafad6af$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $7591bba1aafad6af$var$Buffer.allocUnsafe = function(size) {
    return $7591bba1aafad6af$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $7591bba1aafad6af$var$Buffer.allocUnsafeSlow = function(size) {
    return $7591bba1aafad6af$var$allocUnsafe(null, size);
};
function $7591bba1aafad6af$var$fromString(that, string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$7591bba1aafad6af$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $7591bba1aafad6af$var$byteLength(string, encoding) | 0;
    that = $7591bba1aafad6af$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $7591bba1aafad6af$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $7591bba1aafad6af$var$checked(array.length) | 0;
    that = $7591bba1aafad6af$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $7591bba1aafad6af$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('\'offset\' is out of bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('\'length\' is out of bounds');
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($7591bba1aafad6af$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $7591bba1aafad6af$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $7591bba1aafad6af$var$fromArrayLike(that, array);
    return that;
}
function $7591bba1aafad6af$var$fromObject(that, obj) {
    if ($7591bba1aafad6af$var$Buffer.isBuffer(obj)) {
        var len = $7591bba1aafad6af$var$checked(obj.length) | 0;
        that = $7591bba1aafad6af$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
            if (typeof obj.length !== 'number' || $7591bba1aafad6af$var$isnan(obj.length)) return $7591bba1aafad6af$var$createBuffer(that, 0);
            return $7591bba1aafad6af$var$fromArrayLike(that, obj);
        }
        if (obj.type === 'Buffer' && $g9AEB(obj.data)) return $7591bba1aafad6af$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
}
function $7591bba1aafad6af$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $7591bba1aafad6af$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $7591bba1aafad6af$var$kMaxLength().toString(16) + ' bytes');
    return length | 0;
}
function $7591bba1aafad6af$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $7591bba1aafad6af$var$Buffer.alloc(+length);
}
$7591bba1aafad6af$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$7591bba1aafad6af$var$Buffer.compare = function compare(a, b) {
    if (!$7591bba1aafad6af$var$Buffer.isBuffer(a) || !$7591bba1aafad6af$var$Buffer.isBuffer(b)) throw new TypeError('Arguments must be Buffers');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$7591bba1aafad6af$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$7591bba1aafad6af$var$Buffer.concat = function concat(list, length) {
    if (!$g9AEB(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $7591bba1aafad6af$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $7591bba1aafad6af$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$7591bba1aafad6af$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $7591bba1aafad6af$var$byteLength(string, encoding) {
    if ($7591bba1aafad6af$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') string = '' + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
        case undefined:
            return $7591bba1aafad6af$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $7591bba1aafad6af$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $7591bba1aafad6af$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$7591bba1aafad6af$var$Buffer.byteLength = $7591bba1aafad6af$var$byteLength;
function $7591bba1aafad6af$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $7591bba1aafad6af$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $7591bba1aafad6af$var$utf8Slice(this, start, end);
        case 'ascii':
            return $7591bba1aafad6af$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $7591bba1aafad6af$var$latin1Slice(this, start, end);
        case 'base64':
            return $7591bba1aafad6af$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $7591bba1aafad6af$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$7591bba1aafad6af$var$Buffer.prototype._isBuffer = true;
function $7591bba1aafad6af$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$7591bba1aafad6af$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$7591bba1aafad6af$var$swap(this, i, i + 1);
    return this;
};
$7591bba1aafad6af$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $7591bba1aafad6af$var$swap(this, i, i + 3);
        $7591bba1aafad6af$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$7591bba1aafad6af$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $7591bba1aafad6af$var$swap(this, i, i + 7);
        $7591bba1aafad6af$var$swap(this, i + 1, i + 6);
        $7591bba1aafad6af$var$swap(this, i + 2, i + 5);
        $7591bba1aafad6af$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$7591bba1aafad6af$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return '';
    if (arguments.length === 0) return $7591bba1aafad6af$var$utf8Slice(this, 0, length);
    return $7591bba1aafad6af$var$slowToString.apply(this, arguments);
};
$7591bba1aafad6af$var$Buffer.prototype.equals = function equals(b) {
    if (!$7591bba1aafad6af$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $7591bba1aafad6af$var$Buffer.compare(this, b) === 0;
};
$7591bba1aafad6af$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $7591bba1aafad6af$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
        if (this.length > max) str += ' ... ';
    }
    return '<Buffer ' + str + '>';
};
$7591bba1aafad6af$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$7591bba1aafad6af$var$Buffer.isBuffer(target)) throw new TypeError('Argument must be a Buffer');
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $7591bba1aafad6af$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $7591bba1aafad6af$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($7591bba1aafad6af$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $7591bba1aafad6af$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($7591bba1aafad6af$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $7591bba1aafad6af$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $7591bba1aafad6af$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$7591bba1aafad6af$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$7591bba1aafad6af$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $7591bba1aafad6af$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$7591bba1aafad6af$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $7591bba1aafad6af$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $7591bba1aafad6af$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $7591bba1aafad6af$var$utf8Write(buf, string, offset, length) {
    return $7591bba1aafad6af$var$blitBuffer($7591bba1aafad6af$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $7591bba1aafad6af$var$asciiWrite(buf, string, offset, length) {
    return $7591bba1aafad6af$var$blitBuffer($7591bba1aafad6af$var$asciiToBytes(string), buf, offset, length);
}
function $7591bba1aafad6af$var$latin1Write(buf, string, offset, length) {
    return $7591bba1aafad6af$var$asciiWrite(buf, string, offset, length);
}
function $7591bba1aafad6af$var$base64Write(buf, string, offset, length) {
    return $7591bba1aafad6af$var$blitBuffer($7591bba1aafad6af$var$base64ToBytes(string), buf, offset, length);
}
function $7591bba1aafad6af$var$ucs2Write(buf, string, offset, length) {
    return $7591bba1aafad6af$var$blitBuffer($7591bba1aafad6af$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$7591bba1aafad6af$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $7591bba1aafad6af$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $7591bba1aafad6af$var$utf8Write(this, string, offset, length);
        case 'ascii':
            return $7591bba1aafad6af$var$asciiWrite(this, string, offset, length);
        case 'latin1':
        case 'binary':
            return $7591bba1aafad6af$var$latin1Write(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $7591bba1aafad6af$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $7591bba1aafad6af$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$7591bba1aafad6af$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $7591bba1aafad6af$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $9lqm0.fromByteArray(buf);
    else return $9lqm0.fromByteArray(buf.slice(start, end));
}
function $7591bba1aafad6af$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $7591bba1aafad6af$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $7591bba1aafad6af$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $7591bba1aafad6af$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $7591bba1aafad6af$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $7591bba1aafad6af$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $7591bba1aafad6af$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $7591bba1aafad6af$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $7591bba1aafad6af$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $7591bba1aafad6af$var$toHex(buf[i]);
    return out;
}
function $7591bba1aafad6af$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$7591bba1aafad6af$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($7591bba1aafad6af$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $7591bba1aafad6af$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $7591bba1aafad6af$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $7591bba1aafad6af$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$7591bba1aafad6af$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7591bba1aafad6af$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$7591bba1aafad6af$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7591bba1aafad6af$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$7591bba1aafad6af$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $7591bba1aafad6af$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$7591bba1aafad6af$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $7591bba1aafad6af$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$7591bba1aafad6af$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $7591bba1aafad6af$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$7591bba1aafad6af$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $7591bba1aafad6af$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$7591bba1aafad6af$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $7591bba1aafad6af$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$7591bba1aafad6af$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7591bba1aafad6af$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$7591bba1aafad6af$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7591bba1aafad6af$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$7591bba1aafad6af$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $7591bba1aafad6af$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$7591bba1aafad6af$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $7591bba1aafad6af$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$7591bba1aafad6af$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $7591bba1aafad6af$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$7591bba1aafad6af$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $7591bba1aafad6af$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$7591bba1aafad6af$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $7591bba1aafad6af$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$7591bba1aafad6af$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $7591bba1aafad6af$var$checkOffset(offset, 4, this.length);
    return $4WZRW.read(this, offset, true, 23, 4);
};
$7591bba1aafad6af$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $7591bba1aafad6af$var$checkOffset(offset, 4, this.length);
    return $4WZRW.read(this, offset, false, 23, 4);
};
$7591bba1aafad6af$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $7591bba1aafad6af$var$checkOffset(offset, 8, this.length);
    return $4WZRW.read(this, offset, true, 52, 8);
};
$7591bba1aafad6af$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $7591bba1aafad6af$var$checkOffset(offset, 8, this.length);
    return $4WZRW.read(this, offset, false, 52, 8);
};
function $7591bba1aafad6af$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$7591bba1aafad6af$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$7591bba1aafad6af$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $7591bba1aafad6af$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$7591bba1aafad6af$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $7591bba1aafad6af$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$7591bba1aafad6af$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7591bba1aafad6af$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$7591bba1aafad6af$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $7591bba1aafad6af$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$7591bba1aafad6af$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7591bba1aafad6af$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($7591bba1aafad6af$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $7591bba1aafad6af$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$7591bba1aafad6af$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7591bba1aafad6af$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($7591bba1aafad6af$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $7591bba1aafad6af$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $7591bba1aafad6af$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$7591bba1aafad6af$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7591bba1aafad6af$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($7591bba1aafad6af$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $7591bba1aafad6af$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$7591bba1aafad6af$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7591bba1aafad6af$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($7591bba1aafad6af$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $7591bba1aafad6af$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$7591bba1aafad6af$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $7591bba1aafad6af$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$7591bba1aafad6af$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $7591bba1aafad6af$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$7591bba1aafad6af$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7591bba1aafad6af$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$7591bba1aafad6af$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$7591bba1aafad6af$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7591bba1aafad6af$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($7591bba1aafad6af$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $7591bba1aafad6af$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$7591bba1aafad6af$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7591bba1aafad6af$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($7591bba1aafad6af$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $7591bba1aafad6af$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$7591bba1aafad6af$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7591bba1aafad6af$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($7591bba1aafad6af$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $7591bba1aafad6af$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$7591bba1aafad6af$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7591bba1aafad6af$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($7591bba1aafad6af$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $7591bba1aafad6af$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $7591bba1aafad6af$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $7591bba1aafad6af$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $7591bba1aafad6af$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $4WZRW.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$7591bba1aafad6af$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $7591bba1aafad6af$var$writeFloat(this, value, offset, true, noAssert);
};
$7591bba1aafad6af$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $7591bba1aafad6af$var$writeFloat(this, value, offset, false, noAssert);
};
function $7591bba1aafad6af$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $7591bba1aafad6af$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $4WZRW.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$7591bba1aafad6af$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $7591bba1aafad6af$var$writeDouble(this, value, offset, true, noAssert);
};
$7591bba1aafad6af$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $7591bba1aafad6af$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$7591bba1aafad6af$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$7591bba1aafad6af$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$7591bba1aafad6af$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$7591bba1aafad6af$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    } else if (typeof val === 'number') val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $7591bba1aafad6af$var$Buffer.isBuffer(val) ? val : $7591bba1aafad6af$var$utf8ToBytes(new $7591bba1aafad6af$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $7591bba1aafad6af$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $7591bba1aafad6af$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $7591bba1aafad6af$var$stringtrim(str).replace($7591bba1aafad6af$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $7591bba1aafad6af$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, '');
}
function $7591bba1aafad6af$var$toHex(n) {
    if (n < 16) return '0' + n.toString(16);
    return n.toString(16);
}
function $7591bba1aafad6af$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $7591bba1aafad6af$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $7591bba1aafad6af$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $7591bba1aafad6af$var$base64ToBytes(str) {
    return $9lqm0.toByteArray($7591bba1aafad6af$var$base64clean(str));
}
function $7591bba1aafad6af$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $7591bba1aafad6af$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}

});
parcelRegister("g9AEB", function(module, exports) {
var $bc29eb4ded9c9bdc$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $bc29eb4ded9c9bdc$var$toString.call(arr) == '[object Array]';
};

});


parcelRegister("3u6uB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $289935bc0f64464d$export$2e2bcd8739ae039; });

var $gfw8p = parcelRequire("gfw8p");
/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $289935bc0f64464d$var$hexStringify(wordArray) {
    // Shortcuts
    var words = wordArray.words;
    var sigBytes = wordArray.sigBytes; // Convert
    var hexChars = [];
    for(var i = 0; i < sigBytes; i++){
        var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join('');
}
var $289935bc0f64464d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WordArray(words, sigBytes) {
        words = this.words = words || [];
        if (sigBytes != undefined) this.sigBytes = sigBytes;
        else this.sigBytes = words.length * 4;
    }
    var _proto = WordArray.prototype;
    _proto.random = function random(nBytes) {
        var words = [];
        for(var i = 0; i < nBytes; i += 4)words.push((0, $gfw8p.default)());
        return new WordArray(words, nBytes);
    };
    _proto.toString = function toString() {
        return $289935bc0f64464d$var$hexStringify(this);
    };
    return WordArray;
}();

});
parcelRegister("gfw8p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd46f9556f0945f6$export$2e2bcd8739ae039; });
var $bd46f9556f0945f6$var$crypto; // Native crypto from window (Browser)
if (typeof window !== 'undefined' && window.crypto) $bd46f9556f0945f6$var$crypto = window.crypto;
 // Native (experimental IE 11) crypto from window (Browser)
if (!$bd46f9556f0945f6$var$crypto && typeof window !== 'undefined' && window.msCrypto) $bd46f9556f0945f6$var$crypto = window.msCrypto;
 // Native crypto from global (NodeJS)
if (!$bd46f9556f0945f6$var$crypto && typeof $parcel$global !== 'undefined' && $parcel$global.crypto) $bd46f9556f0945f6$var$crypto = $parcel$global.crypto;
 // Native crypto import via require (NodeJS)

if (!$bd46f9556f0945f6$var$crypto && true) try {
    $bd46f9556f0945f6$var$crypto = (parcelRequire("1J3fK"));
} catch (err) {}
function $bd46f9556f0945f6$export$2e2bcd8739ae039() {
    if ($bd46f9556f0945f6$var$crypto) {
        // Use getRandomValues method (Browser)
        if (typeof $bd46f9556f0945f6$var$crypto.getRandomValues === 'function') try {
            return $bd46f9556f0945f6$var$crypto.getRandomValues(new Uint32Array(1))[0];
        } catch (err) {}
         // Use randomBytes method (NodeJS)
        if (typeof $bd46f9556f0945f6$var$crypto.randomBytes === 'function') try {
            return $bd46f9556f0945f6$var$crypto.randomBytes(4).readInt32LE();
        } catch (err) {}
    }
    throw new Error('Native crypto module could not be used to get secure random number.');
}

});


parcelRegister("dAjLU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e3df962b84e6181$export$2e2bcd8739ae039; });
// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
var $9e3df962b84e6181$export$2e2bcd8739ae039 = $9e3df962b84e6181$var$BigInteger;
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $9e3df962b84e6181$var$BigInteger(a, b) {
    if (a != null) this.fromString(a, b);
} // return new, unset BigInteger
function $9e3df962b84e6181$var$nbi() {
    return new $9e3df962b84e6181$var$BigInteger(null);
} // Bits per digit
var $9e3df962b84e6181$var$dbits; // JavaScript engine analysis
var $9e3df962b84e6181$var$canary = 0xdeadbeefcafe;
var $9e3df962b84e6181$var$j_lm = ($9e3df962b84e6181$var$canary & 0xffffff) == 0xefcafe; // am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $9e3df962b84e6181$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
} // am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $9e3df962b84e6181$var$am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
} // Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $9e3df962b84e6181$var$am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
var $9e3df962b84e6181$var$inBrowser = typeof navigator !== 'undefined';
if ($9e3df962b84e6181$var$inBrowser && $9e3df962b84e6181$var$j_lm && navigator.appName == 'Microsoft Internet Explorer') {
    $9e3df962b84e6181$var$BigInteger.prototype.am = $9e3df962b84e6181$var$am2;
    $9e3df962b84e6181$var$dbits = 30;
} else if ($9e3df962b84e6181$var$inBrowser && $9e3df962b84e6181$var$j_lm && navigator.appName != 'Netscape') {
    $9e3df962b84e6181$var$BigInteger.prototype.am = $9e3df962b84e6181$var$am1;
    $9e3df962b84e6181$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $9e3df962b84e6181$var$BigInteger.prototype.am = $9e3df962b84e6181$var$am3;
    $9e3df962b84e6181$var$dbits = 28;
}
$9e3df962b84e6181$var$BigInteger.prototype.DB = $9e3df962b84e6181$var$dbits;
$9e3df962b84e6181$var$BigInteger.prototype.DM = (1 << $9e3df962b84e6181$var$dbits) - 1;
$9e3df962b84e6181$var$BigInteger.prototype.DV = 1 << $9e3df962b84e6181$var$dbits;
var $9e3df962b84e6181$var$BI_FP = 52;
$9e3df962b84e6181$var$BigInteger.prototype.FV = Math.pow(2, $9e3df962b84e6181$var$BI_FP);
$9e3df962b84e6181$var$BigInteger.prototype.F1 = $9e3df962b84e6181$var$BI_FP - $9e3df962b84e6181$var$dbits;
$9e3df962b84e6181$var$BigInteger.prototype.F2 = 2 * $9e3df962b84e6181$var$dbits - $9e3df962b84e6181$var$BI_FP; // Digit conversions
var $9e3df962b84e6181$var$BI_RM = '0123456789abcdefghijklmnopqrstuvwxyz';
var $9e3df962b84e6181$var$BI_RC = new Array();
var $9e3df962b84e6181$var$rr, $9e3df962b84e6181$var$vv;
$9e3df962b84e6181$var$rr = '0'.charCodeAt(0);
for($9e3df962b84e6181$var$vv = 0; $9e3df962b84e6181$var$vv <= 9; ++$9e3df962b84e6181$var$vv)$9e3df962b84e6181$var$BI_RC[$9e3df962b84e6181$var$rr++] = $9e3df962b84e6181$var$vv;
$9e3df962b84e6181$var$rr = 'a'.charCodeAt(0);
for($9e3df962b84e6181$var$vv = 10; $9e3df962b84e6181$var$vv < 36; ++$9e3df962b84e6181$var$vv)$9e3df962b84e6181$var$BI_RC[$9e3df962b84e6181$var$rr++] = $9e3df962b84e6181$var$vv;
$9e3df962b84e6181$var$rr = 'A'.charCodeAt(0);
for($9e3df962b84e6181$var$vv = 10; $9e3df962b84e6181$var$vv < 36; ++$9e3df962b84e6181$var$vv)$9e3df962b84e6181$var$BI_RC[$9e3df962b84e6181$var$rr++] = $9e3df962b84e6181$var$vv;
function $9e3df962b84e6181$var$int2char(n) {
    return $9e3df962b84e6181$var$BI_RM.charAt(n);
}
function $9e3df962b84e6181$var$intAt(s, i) {
    var c = $9e3df962b84e6181$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
} // (protected) copy this to r
function $9e3df962b84e6181$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
} // (protected) set from integer value x, -DV <= x < DV
function $9e3df962b84e6181$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
} // return bigint initialized to value
function $9e3df962b84e6181$var$nbv(i) {
    var r = $9e3df962b84e6181$var$nbi();
    r.fromInt(i);
    return r;
} // (protected) set from string and radix
function $9e3df962b84e6181$var$bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error('Only radix 2, 4, 8, 16, 32 are supported');
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = $9e3df962b84e6181$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == '-') mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $9e3df962b84e6181$var$BigInteger.ZERO.subTo(this, this);
} // (protected) clamp off excess high words
function $9e3df962b84e6181$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
} // (public) return string representation in given radix
function $9e3df962b84e6181$var$bnToString(b) {
    if (this.s < 0) return '-' + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error('Only radix 2, 4, 8, 16, 32 are supported');
    var km = (1 << k) - 1, d, m = false, r = '', i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $9e3df962b84e6181$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $9e3df962b84e6181$var$int2char(d);
        }
    }
    return m ? r : '0';
} // (public) -this
function $9e3df962b84e6181$var$bnNegate() {
    var r = $9e3df962b84e6181$var$nbi();
    $9e3df962b84e6181$var$BigInteger.ZERO.subTo(this, r);
    return r;
} // (public) |this|
function $9e3df962b84e6181$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
} // (public) return + if this > a, - if this < a, 0 if equal
function $9e3df962b84e6181$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0){
        if ((r = this[i] - a[i]) != 0) return r;
    }
    return 0;
} // returns bit length of the integer x
function $9e3df962b84e6181$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
} // (public) return the number of bits in "this"
function $9e3df962b84e6181$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $9e3df962b84e6181$var$nbits(this[this.t - 1] ^ this.s & this.DM);
} // (protected) r = this << n*DB
function $9e3df962b84e6181$var$bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
} // (protected) r = this >> n*DB
function $9e3df962b84e6181$var$bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
} // (protected) r = this << n
function $9e3df962b84e6181$var$bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
} // (protected) r = this >> n
function $9e3df962b84e6181$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
} // (protected) r = this - a
function $9e3df962b84e6181$var$bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
} // (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $9e3df962b84e6181$var$bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) $9e3df962b84e6181$var$BigInteger.ZERO.subTo(r, r);
} // (protected) r = this^2, r != this (HAC 14.16)
function $9e3df962b84e6181$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
} // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $9e3df962b84e6181$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = $9e3df962b84e6181$var$nbi();
    var y = $9e3df962b84e6181$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $9e3df962b84e6181$var$nbits(pm[pm.t - 1]); // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? $9e3df962b84e6181$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $9e3df962b84e6181$var$BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y); // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) $9e3df962b84e6181$var$BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
    if (ts < 0) $9e3df962b84e6181$var$BigInteger.ZERO.subTo(r, r);
} // (public) this mod a
function $9e3df962b84e6181$var$bnMod(a) {
    var r = $9e3df962b84e6181$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($9e3df962b84e6181$var$BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
} // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $9e3df962b84e6181$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3; // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $9e3df962b84e6181$var$bnEquals(a) {
    return this.compareTo(a) == 0;
} // (protected) r = this + a
function $9e3df962b84e6181$var$bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
} // (public) this + a
function $9e3df962b84e6181$var$bnAdd(a) {
    var r = $9e3df962b84e6181$var$nbi();
    this.addTo(a, r);
    return r;
} // (public) this - a
function $9e3df962b84e6181$var$bnSubtract(a) {
    var r = $9e3df962b84e6181$var$nbi();
    this.subTo(a, r);
    return r;
} // (public) this * a
function $9e3df962b84e6181$var$bnMultiply(a) {
    var r = $9e3df962b84e6181$var$nbi();
    this.multiplyTo(a, r);
    return r;
} // (public) this / a
function $9e3df962b84e6181$var$bnDivide(a) {
    var r = $9e3df962b84e6181$var$nbi();
    this.divRemTo(a, r, null);
    return r;
} // Montgomery reduction
function $9e3df962b84e6181$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
} // xR mod m
function $9e3df962b84e6181$var$montConvert(x) {
    var r = $9e3df962b84e6181$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($9e3df962b84e6181$var$BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
} // x/R mod m
function $9e3df962b84e6181$var$montRevert(x) {
    var r = $9e3df962b84e6181$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
} // x = x/R mod m (HAC 14.32)
function $9e3df962b84e6181$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM; // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t); // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
} // r = "x^2/R mod m"; x != r
function $9e3df962b84e6181$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
} // r = "xy/R mod m"; x,y != r
function $9e3df962b84e6181$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$9e3df962b84e6181$var$Montgomery.prototype.convert = $9e3df962b84e6181$var$montConvert;
$9e3df962b84e6181$var$Montgomery.prototype.revert = $9e3df962b84e6181$var$montRevert;
$9e3df962b84e6181$var$Montgomery.prototype.reduce = $9e3df962b84e6181$var$montReduce;
$9e3df962b84e6181$var$Montgomery.prototype.mulTo = $9e3df962b84e6181$var$montMulTo;
$9e3df962b84e6181$var$Montgomery.prototype.sqrTo = $9e3df962b84e6181$var$montSqrTo; // (public) this^e % m (HAC 14.85)
function $9e3df962b84e6181$var$bnModPow(e, m, callback) {
    var i = e.bitLength(), k, r = $9e3df962b84e6181$var$nbv(1), z = new $9e3df962b84e6181$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6; // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = $9e3df962b84e6181$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $9e3df962b84e6181$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = $9e3df962b84e6181$var$nbi(), t;
    i = $9e3df962b84e6181$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    var result = z.revert(r);
    callback(null, result);
    return result;
} // protected
$9e3df962b84e6181$var$BigInteger.prototype.copyTo = $9e3df962b84e6181$var$bnpCopyTo;
$9e3df962b84e6181$var$BigInteger.prototype.fromInt = $9e3df962b84e6181$var$bnpFromInt;
$9e3df962b84e6181$var$BigInteger.prototype.fromString = $9e3df962b84e6181$var$bnpFromString;
$9e3df962b84e6181$var$BigInteger.prototype.clamp = $9e3df962b84e6181$var$bnpClamp;
$9e3df962b84e6181$var$BigInteger.prototype.dlShiftTo = $9e3df962b84e6181$var$bnpDLShiftTo;
$9e3df962b84e6181$var$BigInteger.prototype.drShiftTo = $9e3df962b84e6181$var$bnpDRShiftTo;
$9e3df962b84e6181$var$BigInteger.prototype.lShiftTo = $9e3df962b84e6181$var$bnpLShiftTo;
$9e3df962b84e6181$var$BigInteger.prototype.rShiftTo = $9e3df962b84e6181$var$bnpRShiftTo;
$9e3df962b84e6181$var$BigInteger.prototype.subTo = $9e3df962b84e6181$var$bnpSubTo;
$9e3df962b84e6181$var$BigInteger.prototype.multiplyTo = $9e3df962b84e6181$var$bnpMultiplyTo;
$9e3df962b84e6181$var$BigInteger.prototype.squareTo = $9e3df962b84e6181$var$bnpSquareTo;
$9e3df962b84e6181$var$BigInteger.prototype.divRemTo = $9e3df962b84e6181$var$bnpDivRemTo;
$9e3df962b84e6181$var$BigInteger.prototype.invDigit = $9e3df962b84e6181$var$bnpInvDigit;
$9e3df962b84e6181$var$BigInteger.prototype.addTo = $9e3df962b84e6181$var$bnpAddTo; // public
$9e3df962b84e6181$var$BigInteger.prototype.toString = $9e3df962b84e6181$var$bnToString;
$9e3df962b84e6181$var$BigInteger.prototype.negate = $9e3df962b84e6181$var$bnNegate;
$9e3df962b84e6181$var$BigInteger.prototype.abs = $9e3df962b84e6181$var$bnAbs;
$9e3df962b84e6181$var$BigInteger.prototype.compareTo = $9e3df962b84e6181$var$bnCompareTo;
$9e3df962b84e6181$var$BigInteger.prototype.bitLength = $9e3df962b84e6181$var$bnBitLength;
$9e3df962b84e6181$var$BigInteger.prototype.mod = $9e3df962b84e6181$var$bnMod;
$9e3df962b84e6181$var$BigInteger.prototype.equals = $9e3df962b84e6181$var$bnEquals;
$9e3df962b84e6181$var$BigInteger.prototype.add = $9e3df962b84e6181$var$bnAdd;
$9e3df962b84e6181$var$BigInteger.prototype.subtract = $9e3df962b84e6181$var$bnSubtract;
$9e3df962b84e6181$var$BigInteger.prototype.multiply = $9e3df962b84e6181$var$bnMultiply;
$9e3df962b84e6181$var$BigInteger.prototype.divide = $9e3df962b84e6181$var$bnDivide;
$9e3df962b84e6181$var$BigInteger.prototype.modPow = $9e3df962b84e6181$var$bnModPow; // "constants"
$9e3df962b84e6181$var$BigInteger.ZERO = $9e3df962b84e6181$var$nbv(0);
$9e3df962b84e6181$var$BigInteger.ONE = $9e3df962b84e6181$var$nbv(1);

});


parcelRegister("eqVzU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a820283449531f52$export$2e2bcd8739ae039; });

var $5Slsi = parcelRequire("5Slsi");
function $a820283449531f52$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/** @class */ var $a820283449531f52$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $a820283449531f52$var$_inheritsLoose(CognitoAccessToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */ function CognitoAccessToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, AccessToken = _ref.AccessToken;
        return _CognitoJwtToken.call(this, AccessToken || '') || this;
    }
    return CognitoAccessToken;
}((0, $5Slsi.default));

});
parcelRegister("5Slsi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4472a378250f8b3e$export$2e2bcd8739ae039; });
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ 
var $a5OKa = parcelRequire("a5OKa");
/** @class */ var $4472a378250f8b3e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoJwtToken object
   * @param {string=} token The JWT token.
   */ function CognitoJwtToken(token) {
        // Assign object
        this.jwtToken = token || '';
        this.payload = this.decodePayload();
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoJwtToken.prototype;
    _proto.getJwtToken = function getJwtToken() {
        return this.jwtToken;
    };
    _proto.getExpiration = function getExpiration() {
        return this.payload.exp;
    };
    _proto.getIssuedAt = function getIssuedAt() {
        return this.payload.iat;
    };
    _proto.decodePayload = function decodePayload() {
        var payload = this.jwtToken.split('.')[1];
        try {
            return JSON.parse((0, $a5OKa.Buffer).from(payload, 'base64').toString('utf8'));
        } catch (err) {
            return {};
        }
    };
    return CognitoJwtToken;
}();

});


parcelRegister("a6o5Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75ad27c6fec27f68$export$2e2bcd8739ae039; });

var $5Slsi = parcelRequire("5Slsi");
function $75ad27c6fec27f68$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/** @class */ var $75ad27c6fec27f68$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $75ad27c6fec27f68$var$_inheritsLoose(CognitoIdToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */ function CognitoIdToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken;
        return _CognitoJwtToken.call(this, IdToken || '') || this;
    }
    return CognitoIdToken;
}((0, $5Slsi.default));

});

parcelRegister("5Ra9u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4439c6f5963a4f1b$export$2e2bcd8739ae039; });
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ /** @class */ var $4439c6f5963a4f1b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */ function CognitoRefreshToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, RefreshToken = _ref.RefreshToken;
        // Assign object
        this.token = RefreshToken || '';
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoRefreshToken.prototype;
    _proto.getToken = function getToken() {
        return this.token;
    };
    return CognitoRefreshToken;
}();

});

parcelRegister("7VU9U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c696b406a27bc36$export$2e2bcd8739ae039; });
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ 
var $a5OKa = parcelRequire("a5OKa");

var $9LFT6 = parcelRequire("9LFT6");
parcelRequire("Fuwoa");

var $cWvYf = parcelRequire("cWvYf");

var $2qAwF = parcelRequire("2qAwF");

var $dAjLU = parcelRequire("dAjLU");

var $gBu9Y = parcelRequire("gBu9Y");

var $eqVzU = parcelRequire("eqVzU");

var $a6o5Y = parcelRequire("a6o5Y");

var $5Ra9u = parcelRequire("5Ra9u");

var $1rQ96 = parcelRequire("1rQ96");

var $2RtQ2 = parcelRequire("2RtQ2");

var $frEzb = parcelRequire("frEzb");

var $bGNG0 = parcelRequire("bGNG0");
/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */ /**
 * @callback onFailure
 * @param {*} err Failure reason.
 */ /**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */ /**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */ /**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */ /**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */ /**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */ var $5c696b406a27bc36$var$isBrowser = typeof navigator !== 'undefined';
var $5c696b406a27bc36$var$userAgent = $5c696b406a27bc36$var$isBrowser ? navigator.userAgent : 'nodejs';
/** @class */ var $5c696b406a27bc36$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUser object
   * @param {object} data Creation options
   * @param {string} data.Username The user's username.
   * @param {CognitoUserPool} data.Pool Pool containing the user.
   * @param {object} data.Storage Optional storage object.
   */ function CognitoUser(data) {
        if (data == null || data.Username == null || data.Pool == null) throw new Error('Username and Pool information are required.');
        this.username = data.Username || '';
        this.pool = data.Pool;
        this.Session = null;
        this.client = data.Pool.client;
        this.signInUserSession = null;
        this.authenticationFlowType = 'USER_SRP_AUTH';
        this.storage = data.Storage || new (0, $bGNG0.default)().getStorage();
        this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
    }
    /**
   * Sets the session for this user
   * @param {CognitoUserSession} signInUserSession the session
   * @returns {void}
   */ var _proto = CognitoUser.prototype;
    _proto.setSignInUserSession = function setSignInUserSession(signInUserSession) {
        this.clearCachedUserData();
        this.signInUserSession = signInUserSession;
        this.cacheTokens();
    };
    _proto.getSignInUserSession = function getSignInUserSession() {
        return this.signInUserSession;
    };
    _proto.getUsername = function getUsername() {
        return this.username;
    };
    _proto.getAuthenticationFlowType = function getAuthenticationFlowType() {
        return this.authenticationFlowType;
    };
    _proto.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
        this.authenticationFlowType = authenticationFlowType;
    };
    _proto.initiateAuth = function initiateAuth(authDetails, callback) {
        var _this = this;
        var authParameters = authDetails.getAuthParameters();
        authParameters.USERNAME = this.username;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: 'CUSTOM_AUTH',
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('InitiateAuth', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            var challengeName = data.ChallengeName;
            var challengeParameters = data.ChallengeParameters;
            if (challengeName === 'CUSTOM_CHALLENGE') {
                _this.Session = data.Session;
                return callback.customChallenge(challengeParameters);
            }
            _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
            _this.cacheTokens();
            return callback.onSuccess(_this.signInUserSession);
        });
    };
    _proto.authenticateUser = function authenticateUser(authDetails, callback) {
        if (this.authenticationFlowType === 'USER_PASSWORD_AUTH') return this.authenticateUserPlainUsernamePassword(authDetails, callback);
        else if (this.authenticationFlowType === 'USER_SRP_AUTH' || this.authenticationFlowType === 'CUSTOM_AUTH') return this.authenticateUserDefaultAuth(authDetails, callback);
        return callback.onFailure(new Error('Authentication flow type is invalid.'));
    };
    _proto.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
        var _this2 = this;
        var authenticationHelper = new (0, $gBu9Y.default)(this.pool.getUserPoolId().split('_')[1]);
        var dateHelper = new (0, $2RtQ2.default)();
        var serverBValue;
        var salt;
        var authParameters = {};
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        authParameters.USERNAME = this.username;
        authenticationHelper.getLargeAValue(function(errOnAValue, aValue) {
            // getLargeAValue callback start
            if (errOnAValue) callback.onFailure(errOnAValue);
            authParameters.SRP_A = aValue.toString(16);
            if (_this2.authenticationFlowType === 'CUSTOM_AUTH') authParameters.CHALLENGE_NAME = 'SRP_A';
            var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
            var jsonReq = {
                AuthFlow: _this2.authenticationFlowType,
                ClientId: _this2.pool.getClientId(),
                AuthParameters: authParameters,
                ClientMetadata: clientMetaData
            };
            if (_this2.getUserContextData(_this2.username)) jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
            _this2.client.request('InitiateAuth', jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                _this2.username = challengeParameters.USER_ID_FOR_SRP;
                serverBValue = new (0, $dAjLU.default)(challengeParameters.SRP_B, 16);
                salt = new (0, $dAjLU.default)(challengeParameters.SALT, 16);
                _this2.getCachedDeviceKeyAndPassword();
                authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function(errOnHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errOnHkdf) callback.onFailure(errOnHkdf);
                    var dateNow = dateHelper.getNowString();
                    var message = (0, (/*@__PURE__*/$parcel$interopDefault($9LFT6))).lib.WordArray.create((0, $a5OKa.Buffer).concat([
                        (0, $a5OKa.Buffer).from(_this2.pool.getUserPoolId().split('_')[1], 'utf8'),
                        (0, $a5OKa.Buffer).from(_this2.username, 'utf8'),
                        (0, $a5OKa.Buffer).from(challengeParameters.SECRET_BLOCK, 'base64'),
                        (0, $a5OKa.Buffer).from(dateNow, 'utf8')
                    ]));
                    var key = (0, (/*@__PURE__*/$parcel$interopDefault($9LFT6))).lib.WordArray.create(hkdf);
                    var signatureString = (0, (/*@__PURE__*/$parcel$interopDefault($cWvYf))).stringify((0, (/*@__PURE__*/$parcel$interopDefault($2qAwF)))(message, key));
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this2.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    if (_this2.deviceKey != null) challengeResponses.DEVICE_KEY = _this2.deviceKey;
                    var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
                        return _this2.client.request('RespondToAuthChallenge', challenge, function(errChallenge, dataChallenge) {
                            if (errChallenge && errChallenge.code === 'ResourceNotFoundException' && errChallenge.message.toLowerCase().indexOf('device') !== -1) {
                                challengeResponses.DEVICE_KEY = null;
                                _this2.deviceKey = null;
                                _this2.randomPassword = null;
                                _this2.deviceGroupKey = null;
                                _this2.clearCachedDeviceKeyAndPassword();
                                return respondToAuthChallenge(challenge, challengeCallback);
                            }
                            return challengeCallback(errChallenge, dataChallenge);
                        });
                    };
                    var jsonReqResp = {
                        ChallengeName: 'PASSWORD_VERIFIER',
                        ClientId: _this2.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session,
                        ClientMetadata: clientMetaData
                    };
                    if (_this2.getUserContextData()) jsonReqResp.UserContextData = _this2.getUserContextData();
                    respondToAuthChallenge(jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
                    });
                    return undefined; // getPasswordAuthenticationKey callback end
                });
                return undefined;
            }); // getLargeAValue callback end
        });
    };
    _proto.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
        var _this3 = this;
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.PASSWORD = authDetails.getPassword();
        if (!authParameters.PASSWORD) {
            callback.onFailure(new Error('PASSWORD parameter is required'));
            return;
        }
        var authenticationHelper = new (0, $gBu9Y.default)(this.pool.getUserPoolId().split('_')[1]);
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: 'USER_PASSWORD_AUTH',
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData(this.username)) jsonReq.UserContextData = this.getUserContextData(this.username);
         // USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
        // Cognito UserPools verifies password and returns tokens.
        this.client.request('InitiateAuth', jsonReq, function(err, authResult) {
            if (err) return callback.onFailure(err);
            return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
        });
    };
    _proto.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
        var _this4 = this;
        var challengeName = dataAuthenticate.ChallengeName;
        var challengeParameters = dataAuthenticate.ChallengeParameters;
        if (challengeName === 'SMS_MFA') {
            this.Session = dataAuthenticate.Session;
            return callback.mfaRequired(challengeName, challengeParameters);
        }
        if (challengeName === 'SELECT_MFA_TYPE') {
            this.Session = dataAuthenticate.Session;
            return callback.selectMFAType(challengeName, challengeParameters);
        }
        if (challengeName === 'MFA_SETUP') {
            this.Session = dataAuthenticate.Session;
            return callback.mfaSetup(challengeName, challengeParameters);
        }
        if (challengeName === 'SOFTWARE_TOKEN_MFA') {
            this.Session = dataAuthenticate.Session;
            return callback.totpRequired(challengeName, challengeParameters);
        }
        if (challengeName === 'CUSTOM_CHALLENGE') {
            this.Session = dataAuthenticate.Session;
            return callback.customChallenge(challengeParameters);
        }
        if (challengeName === 'NEW_PASSWORD_REQUIRED') {
            this.Session = dataAuthenticate.Session;
            var userAttributes = null;
            var rawRequiredAttributes = null;
            var requiredAttributes = [];
            var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
            if (challengeParameters) {
                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
            }
            if (rawRequiredAttributes) for(var i = 0; i < rawRequiredAttributes.length; i++)requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
            return callback.newPasswordRequired(userAttributes, requiredAttributes);
        }
        if (challengeName === 'DEVICE_SRP_AUTH') {
            this.getDeviceResponse(callback);
            return undefined;
        }
        this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
        this.challengeName = challengeName;
        this.cacheTokens();
        var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
        if (newDeviceMetadata == null) return callback.onSuccess(this.signInUserSession);
        authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
            if (errGenHash) return callback.onFailure(errGenHash);
            var deviceSecretVerifierConfig = {
                Salt: (0, $a5OKa.Buffer).from(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
                PasswordVerifier: (0, $a5OKa.Buffer).from(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
            };
            _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
            _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
            _this4.randomPassword = authenticationHelper.getRandomPassword();
            _this4.client.request('ConfirmDevice', {
                DeviceKey: newDeviceMetadata.DeviceKey,
                AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
                DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                DeviceName: $5c696b406a27bc36$var$userAgent
            }, function(errConfirm, dataConfirm) {
                if (errConfirm) return callback.onFailure(errConfirm);
                _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                _this4.cacheDeviceKeyAndPassword();
                if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
                return callback.onSuccess(_this4.signInUserSession);
            });
            return undefined;
        });
        return undefined;
    };
    _proto.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
        var _this5 = this;
        if (!newPassword) return callback.onFailure(new Error('New password is required.'));
        var authenticationHelper = new (0, $gBu9Y.default)(this.pool.getUserPoolId().split('_')[1]);
        var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
        var finalUserAttributes = {};
        if (requiredAttributeData) Object.keys(requiredAttributeData).forEach(function(key) {
            finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
        });
        finalUserAttributes.NEW_PASSWORD = newPassword;
        finalUserAttributes.USERNAME = this.username;
        var jsonReq = {
            ChallengeName: 'NEW_PASSWORD_REQUIRED',
            ClientId: this.pool.getClientId(),
            ChallengeResponses: finalUserAttributes,
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) return callback.onFailure(errAuthenticate);
            return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
        });
        return undefined;
    };
    _proto.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
        var _this6 = this;
        var authenticationHelper = new (0, $gBu9Y.default)(this.deviceGroupKey);
        var dateHelper = new (0, $2RtQ2.default)();
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.DEVICE_KEY = this.deviceKey;
        authenticationHelper.getLargeAValue(function(errAValue, aValue) {
            // getLargeAValue callback start
            if (errAValue) callback.onFailure(errAValue);
            authParameters.SRP_A = aValue.toString(16);
            var jsonReq = {
                ChallengeName: 'DEVICE_SRP_AUTH',
                ClientId: _this6.pool.getClientId(),
                ChallengeResponses: authParameters,
                ClientMetadata: clientMetadata
            };
            if (_this6.getUserContextData()) jsonReq.UserContextData = _this6.getUserContextData();
            _this6.client.request('RespondToAuthChallenge', jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                var serverBValue = new (0, $dAjLU.default)(challengeParameters.SRP_B, 16);
                var salt = new (0, $dAjLU.default)(challengeParameters.SALT, 16);
                authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function(errHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errHkdf) return callback.onFailure(errHkdf);
                    var dateNow = dateHelper.getNowString();
                    var message = (0, (/*@__PURE__*/$parcel$interopDefault($9LFT6))).lib.WordArray.create((0, $a5OKa.Buffer).concat([
                        (0, $a5OKa.Buffer).from(_this6.deviceGroupKey, 'utf8'),
                        (0, $a5OKa.Buffer).from(_this6.deviceKey, 'utf8'),
                        (0, $a5OKa.Buffer).from(challengeParameters.SECRET_BLOCK, 'base64'),
                        (0, $a5OKa.Buffer).from(dateNow, 'utf8')
                    ]));
                    var key = (0, (/*@__PURE__*/$parcel$interopDefault($9LFT6))).lib.WordArray.create(hkdf);
                    var signatureString = (0, (/*@__PURE__*/$parcel$interopDefault($cWvYf))).stringify((0, (/*@__PURE__*/$parcel$interopDefault($2qAwF)))(message, key));
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this6.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    challengeResponses.DEVICE_KEY = _this6.deviceKey;
                    var jsonReqResp = {
                        ChallengeName: 'DEVICE_PASSWORD_VERIFIER',
                        ClientId: _this6.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session
                    };
                    if (_this6.getUserContextData()) jsonReqResp.UserContextData = _this6.getUserContextData();
                    _this6.client.request('RespondToAuthChallenge', jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
                        _this6.cacheTokens();
                        return callback.onSuccess(_this6.signInUserSession);
                    });
                    return undefined; // getPasswordAuthenticationKey callback end
                });
                return undefined;
            }); // getLargeAValue callback end
        });
    };
    _proto.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            ConfirmationCode: confirmationCode,
            Username: this.username,
            ForceAliasCreation: forceAliasCreation,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('ConfirmSignUp', jsonReq, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
    };
    _proto.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
        var _this7 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var authenticationHelper = new (0, $gBu9Y.default)(this.pool.getUserPoolId().split('_')[1]);
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: 'CUSTOM_CHALLENGE',
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            return _this7.authenticateUserInternal(data, authenticationHelper, callback);
        });
    };
    _proto.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
        var _this8 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.SMS_MFA_CODE = confirmationCode;
        var mfaTypeSelection = mfaType || 'SMS_MFA';
        if (mfaTypeSelection === 'SOFTWARE_TOKEN_MFA') challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: mfaTypeSelection,
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(err, dataAuthenticate) {
            if (err) return callback.onFailure(err);
            var challengeName = dataAuthenticate.ChallengeName;
            if (challengeName === 'DEVICE_SRP_AUTH') {
                _this8.getDeviceResponse(callback);
                return undefined;
            }
            _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this8.cacheTokens();
            if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) return callback.onSuccess(_this8.signInUserSession);
            var authenticationHelper = new (0, $gBu9Y.default)(_this8.pool.getUserPoolId().split('_')[1]);
            authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
                if (errGenHash) return callback.onFailure(errGenHash);
                var deviceSecretVerifierConfig = {
                    Salt: (0, $a5OKa.Buffer).from(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
                    PasswordVerifier: (0, $a5OKa.Buffer).from(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
                };
                _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
                _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
                _this8.randomPassword = authenticationHelper.getRandomPassword();
                _this8.client.request('ConfirmDevice', {
                    DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
                    AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
                    DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                    DeviceName: $5c696b406a27bc36$var$userAgent
                }, function(errConfirm, dataConfirm) {
                    if (errConfirm) return callback.onFailure(errConfirm);
                    _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                    _this8.cacheDeviceKeyAndPassword();
                    if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
                    return callback.onSuccess(_this8.signInUserSession);
                });
                return undefined;
            });
            return undefined;
        });
    };
    _proto.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('ChangePassword', {
            PreviousPassword: oldUserPassword,
            ProposedPassword: newUserPassword,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.enableMFA = function enableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        var mfaOptions = [];
        var mfaEnabled = {
            DeliveryMedium: 'SMS',
            AttributeName: 'phone_number'
        };
        mfaOptions.push(mfaEnabled);
        this.client.request('SetUserSettings', {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        this.client.request('SetUserMFAPreference', {
            SMSMfaSettings: smsMfaSettings,
            SoftwareTokenMfaSettings: softwareTokenMfaSettings,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.disableMFA = function disableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        var mfaOptions = [];
        this.client.request('SetUserSettings', {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.deleteUser = function deleteUser(callback, clientMetadata) {
        var _this9 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        this.client.request('DeleteUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            _this9.clearCachedUser();
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
        var _this10 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        this.client.request('UpdateUserAttributes', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserAttributes: attributes,
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
             // update cached user
            return _this10.getUserData(function() {
                return callback(null, 'SUCCESS');
            }, {
                bypassCache: true
            });
        });
        return undefined;
    };
    _proto.getUserAttributes = function getUserAttributes(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('GetUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            var attributeList = [];
            for(var i = 0; i < userData.UserAttributes.length; i++){
                var attribute = {
                    Name: userData.UserAttributes[i].Name,
                    Value: userData.UserAttributes[i].Value
                };
                var userAttribute = new (0, $frEzb.default)(attribute);
                attributeList.push(userAttribute);
            }
            return callback(null, attributeList);
        });
        return undefined;
    };
    _proto.getMFAOptions = function getMFAOptions(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('GetUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            return callback(null, userData.MFAOptions);
        });
        return undefined;
    };
    _proto.createGetUserRequest = function createGetUserRequest() {
        return this.client.promisifyRequest('GetUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        });
    };
    _proto.refreshSessionIfPossible = function refreshSessionIfPossible() {
        var _this11 = this;
        // best effort, if not possible
        return new Promise(function(resolve) {
            var refresh = _this11.signInUserSession.getRefreshToken();
            if (refresh && refresh.getToken()) _this11.refreshSession(refresh, resolve);
            else resolve();
        });
    };
    _proto.getUserData = function getUserData(callback, params) {
        var _this12 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
            this.clearCachedUserData();
            return callback(new Error('User is not authenticated'), null);
        }
        var userData = this.getUserDataFromCache();
        if (!userData) {
            this.fetchUserData().then(function(data) {
                callback(null, data);
            })["catch"](callback);
            return;
        }
        if (this.isFetchUserDataAndTokenRequired(params)) {
            this.fetchUserData().then(function(data) {
                return _this12.refreshSessionIfPossible().then(function() {
                    return data;
                });
            }).then(function(data) {
                return callback(null, data);
            })["catch"](callback);
            return;
        }
        try {
            callback(null, JSON.parse(userData));
            return;
        } catch (err) {
            this.clearCachedUserData();
            callback(err, null);
            return;
        }
    };
    _proto.getUserDataFromCache = function getUserDataFromCache() {
        var userData = this.storage.getItem(this.userDataKey);
        return userData;
    };
    _proto.isFetchUserDataAndTokenRequired = function isFetchUserDataAndTokenRequired(params) {
        var _ref = params || {}, _ref$bypassCache = _ref.bypassCache, bypassCache = _ref$bypassCache === void 0 ? false : _ref$bypassCache;
        return bypassCache;
    };
    _proto.fetchUserData = function fetchUserData() {
        var _this13 = this;
        return this.createGetUserRequest().then(function(data) {
            _this13.cacheUserData(data);
            return data;
        });
    };
    _proto.deleteAttributes = function deleteAttributes(attributeList, callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('DeleteUserAttributes', {
            UserAttributeNames: attributeList,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        this.client.request('ResendConfirmationCode', jsonReq, function(err, result) {
            if (err) return callback(err, null);
            return callback(null, result);
        });
    };
    _proto.getSession = function getSession(callback) {
        if (this.username == null) return callback(new Error('Username is null. Cannot retrieve a new session'), null);
        if (this.signInUserSession != null && this.signInUserSession.isValid()) return callback(null, this.signInUserSession);
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var idTokenKey = keyPrefix + ".idToken";
        var accessTokenKey = keyPrefix + ".accessToken";
        var refreshTokenKey = keyPrefix + ".refreshToken";
        var clockDriftKey = keyPrefix + ".clockDrift";
        if (this.storage.getItem(idTokenKey)) {
            var idToken = new (0, $a6o5Y.default)({
                IdToken: this.storage.getItem(idTokenKey)
            });
            var accessToken = new (0, $eqVzU.default)({
                AccessToken: this.storage.getItem(accessTokenKey)
            });
            var refreshToken = new (0, $5Ra9u.default)({
                RefreshToken: this.storage.getItem(refreshTokenKey)
            });
            var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
            var sessionData = {
                IdToken: idToken,
                AccessToken: accessToken,
                RefreshToken: refreshToken,
                ClockDrift: clockDrift
            };
            var cachedSession = new (0, $1rQ96.default)(sessionData);
            if (cachedSession.isValid()) {
                this.signInUserSession = cachedSession;
                return callback(null, this.signInUserSession);
            }
            if (!refreshToken.getToken()) return callback(new Error('Cannot retrieve a new session. Please authenticate.'), null);
            this.refreshSession(refreshToken, callback);
        } else callback(new Error('Local storage is missing an ID Token, Please authenticate'), null);
        return undefined;
    };
    _proto.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
        var _this14 = this;
        var wrappedCallback = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(callback) : callback;
        var authParameters = {};
        authParameters.REFRESH_TOKEN = refreshToken.getToken();
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var lastUserKey = keyPrefix + ".LastAuthUser";
        if (this.storage.getItem(lastUserKey)) {
            this.username = this.storage.getItem(lastUserKey);
            var deviceKeyKey = keyPrefix + "." + this.username + ".deviceKey";
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            authParameters.DEVICE_KEY = this.deviceKey;
        }
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            AuthFlow: 'REFRESH_TOKEN_AUTH',
            AuthParameters: authParameters,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('InitiateAuth', jsonReq, function(err, authResult) {
            if (err) {
                if (err.code === 'NotAuthorizedException') _this14.clearCachedUser();
                return wrappedCallback(err, null);
            }
            if (authResult) {
                var authenticationResult = authResult.AuthenticationResult;
                if (!Object.prototype.hasOwnProperty.call(authenticationResult, 'RefreshToken')) authenticationResult.RefreshToken = refreshToken.getToken();
                _this14.signInUserSession = _this14.getCognitoUserSession(authenticationResult);
                _this14.cacheTokens();
                return wrappedCallback(null, _this14.signInUserSession);
            }
            return undefined;
        });
    };
    _proto.cacheTokens = function cacheTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
        this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
        this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
        this.storage.setItem(clockDriftKey, "" + this.signInUserSession.getClockDrift());
        this.storage.setItem(lastUserKey, this.username);
    };
    _proto.cacheUserData = function cacheUserData(userData) {
        this.storage.setItem(this.userDataKey, JSON.stringify(userData));
    };
    _proto.clearCachedUserData = function clearCachedUserData() {
        this.storage.removeItem(this.userDataKey);
    };
    _proto.clearCachedUser = function clearCachedUser() {
        this.clearCachedTokens();
        this.clearCachedUserData();
    };
    _proto.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.setItem(deviceKeyKey, this.deviceKey);
        this.storage.setItem(randomPasswordKey, this.randomPassword);
        this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
    };
    _proto.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        if (this.storage.getItem(deviceKeyKey)) {
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            this.randomPassword = this.storage.getItem(randomPasswordKey);
            this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
        }
    };
    _proto.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.removeItem(deviceKeyKey);
        this.storage.removeItem(randomPasswordKey);
        this.storage.removeItem(deviceGroupKeyKey);
    };
    _proto.clearCachedTokens = function clearCachedTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        this.storage.removeItem(idTokenKey);
        this.storage.removeItem(accessTokenKey);
        this.storage.removeItem(refreshTokenKey);
        this.storage.removeItem(lastUserKey);
        this.storage.removeItem(clockDriftKey);
    };
    _proto.getCognitoUserSession = function getCognitoUserSession(authResult) {
        var idToken = new (0, $a6o5Y.default)(authResult);
        var accessToken = new (0, $eqVzU.default)(authResult);
        var refreshToken = new (0, $5Ra9u.default)(authResult);
        var sessionData = {
            IdToken: idToken,
            AccessToken: accessToken,
            RefreshToken: refreshToken
        };
        return new (0, $1rQ96.default)(sessionData);
    };
    _proto.forgotPassword = function forgotPassword(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('ForgotPassword', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === 'function') return callback.inputVerificationCode(data);
            return callback.onSuccess(data);
        });
    };
    _proto.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ConfirmationCode: confirmationCode,
            Password: newPassword,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('ConfirmForgotPassword', jsonReq, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess();
        });
    };
    _proto.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('GetUserAttributeVerificationCode', {
            AttributeName: attributeName,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === 'function') return callback.inputVerificationCode(data);
            return callback.onSuccess();
        });
        return undefined;
    };
    _proto.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('VerifyUserAttribute', {
            AttributeName: attributeName,
            Code: confirmationCode,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    };
    _proto.getDevice = function getDevice(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('GetDevice', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    };
    _proto.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('ForgetDevice', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: deviceKey
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    };
    _proto.forgetDevice = function forgetDevice(callback) {
        var _this15 = this;
        this.forgetSpecificDevice(this.deviceKey, {
            onFailure: callback.onFailure,
            onSuccess: function onSuccess(result) {
                _this15.deviceKey = null;
                _this15.deviceGroupKey = null;
                _this15.randomPassword = null;
                _this15.clearCachedDeviceKeyAndPassword();
                return callback.onSuccess(result);
            }
        });
    };
    _proto.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('UpdateDeviceStatus', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: 'remembered'
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    };
    _proto.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('UpdateDeviceStatus', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: 'not_remembered'
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    };
    _proto.listDevices = function listDevices(limit, paginationToken, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        var requestParams = {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            Limit: limit
        };
        if (paginationToken) requestParams.PaginationToken = paginationToken;
        this.client.request('ListDevices', requestParams, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    };
    _proto.globalSignOut = function globalSignOut(callback) {
        var _this16 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('GlobalSignOut', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            _this16.clearCachedUser();
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    };
    _proto.signOut = function signOut() {
        this.signInUserSession = null;
        this.clearCachedUser();
    };
    _proto.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
        var _this17 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var jsonReq = {
            ChallengeName: 'SELECT_MFA_TYPE',
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            _this17.Session = data.Session;
            if (answerChallenge === 'SMS_MFA') return callback.mfaRequired(data.ChallengeName, data.ChallengeParameters);
            if (answerChallenge === 'SOFTWARE_TOKEN_MFA') return callback.totpRequired(data.ChallengeName, data.ChallengeParameters);
            return undefined;
        });
    };
    _proto.getUserContextData = function getUserContextData() {
        var pool = this.pool;
        return pool.getUserContextData(this.username);
    };
    _proto.associateSoftwareToken = function associateSoftwareToken(callback) {
        var _this18 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request('AssociateSoftwareToken', {
            Session: this.Session
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this18.Session = data.Session;
            return callback.associateSecretCode(data.SecretCode);
        });
        else this.client.request('AssociateSoftwareToken', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.associateSecretCode(data.SecretCode);
        });
    };
    _proto.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
        var _this19 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request('VerifySoftwareToken', {
            Session: this.Session,
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this19.Session = data.Session;
            var challengeResponses = {};
            challengeResponses.USERNAME = _this19.username;
            var jsonReq = {
                ChallengeName: 'MFA_SETUP',
                ClientId: _this19.pool.getClientId(),
                ChallengeResponses: challengeResponses,
                Session: _this19.Session
            };
            if (_this19.getUserContextData()) jsonReq.UserContextData = _this19.getUserContextData();
            _this19.client.request('RespondToAuthChallenge', jsonReq, function(errRespond, dataRespond) {
                if (errRespond) return callback.onFailure(errRespond);
                _this19.signInUserSession = _this19.getCognitoUserSession(dataRespond.AuthenticationResult);
                _this19.cacheTokens();
                return callback.onSuccess(_this19.signInUserSession);
            });
            return undefined;
        });
        else this.client.request('VerifySoftwareToken', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
    };
    return CognitoUser;
}();

});
parcelRegister("1rQ96", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10e0c3236c30eb0e$export$2e2bcd8739ae039; });
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ /** @class */ var $10e0c3236c30eb0e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
   */ function CognitoUserSession(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken, RefreshToken = _ref.RefreshToken, AccessToken = _ref.AccessToken, ClockDrift = _ref.ClockDrift;
        if (AccessToken == null || IdToken == null) throw new Error('Id token and Access Token must be present.');
        this.idToken = IdToken;
        this.refreshToken = RefreshToken;
        this.accessToken = AccessToken;
        this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
    }
    /**
   * @returns {CognitoIdToken} the session's Id token
   */ var _proto = CognitoUserSession.prototype;
    _proto.getIdToken = function getIdToken() {
        return this.idToken;
    };
    _proto.getRefreshToken = function getRefreshToken() {
        return this.refreshToken;
    };
    _proto.getAccessToken = function getAccessToken() {
        return this.accessToken;
    };
    _proto.getClockDrift = function getClockDrift() {
        return this.clockDrift;
    };
    _proto.calculateClockDrift = function calculateClockDrift() {
        var now = Math.floor(new Date() / 1000);
        var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
        return now - iat;
    };
    _proto.isValid = function isValid() {
        var now = Math.floor(new Date() / 1000);
        var adjusted = now - this.clockDrift;
        return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
    };
    return CognitoUserSession;
}();

});

parcelRegister("2RtQ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2157ad49df52d6e8$export$2e2bcd8739ae039; });
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ var $2157ad49df52d6e8$var$monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
var $2157ad49df52d6e8$var$weekNames = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat'
];
/** @class */ var $2157ad49df52d6e8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function DateHelper() {}
    var _proto = DateHelper.prototype;
    /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */ _proto.getNowString = function getNowString() {
        var now = new Date();
        var weekDay = $2157ad49df52d6e8$var$weekNames[now.getUTCDay()];
        var month = $2157ad49df52d6e8$var$monthNames[now.getUTCMonth()];
        var day = now.getUTCDate();
        var hours = now.getUTCHours();
        if (hours < 10) hours = "0" + hours;
        var minutes = now.getUTCMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = now.getUTCSeconds();
        if (seconds < 10) seconds = "0" + seconds;
        var year = now.getUTCFullYear(); // ddd MMM D HH:mm:ss UTC YYYY
        var dateNow = weekDay + " " + month + " " + day + " " + hours + ":" + minutes + ":" + seconds + " UTC " + year;
        return dateNow;
    };
    return DateHelper;
}();

});

parcelRegister("frEzb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3e8d84c6ec3565d$export$2e2bcd8739ae039; });
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ /** @class */ var $b3e8d84c6ec3565d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserAttribute object
   * @param {string=} Name The record's name
   * @param {string=} Value The record's value
   */ function CognitoUserAttribute(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, Name = _ref.Name, Value = _ref.Value;
        this.Name = Name || '';
        this.Value = Value || '';
    }
    /**
   * @returns {string} the record's value.
   */ var _proto = CognitoUserAttribute.prototype;
    _proto.getValue = function getValue() {
        return this.Value;
    };
    _proto.setValue = function setValue(value) {
        this.Value = value;
        return this;
    };
    _proto.getName = function getName() {
        return this.Name;
    };
    _proto.setName = function setName(name) {
        this.Name = name;
        return this;
    };
    _proto.toString = function toString() {
        return JSON.stringify(this);
    };
    _proto.toJSON = function toJSON() {
        return {
            Name: this.Name,
            Value: this.Value
        };
    };
    return CognitoUserAttribute;
}();

});

parcelRegister("bGNG0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $882a26b14055ef25$export$2e2bcd8739ae039; });
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ var $882a26b14055ef25$var$dataMemory = {};
/** @class */ var $882a26b14055ef25$var$MemoryStorage = /*#__PURE__*/ function() {
    function MemoryStorage() {}
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ MemoryStorage.setItem = function setItem(key, value) {
        $882a26b14055ef25$var$dataMemory[key] = value;
        return $882a26b14055ef25$var$dataMemory[key];
    };
    MemoryStorage.getItem = function getItem(key) {
        return Object.prototype.hasOwnProperty.call($882a26b14055ef25$var$dataMemory, key) ? $882a26b14055ef25$var$dataMemory[key] : undefined;
    };
    MemoryStorage.removeItem = function removeItem(key) {
        return delete $882a26b14055ef25$var$dataMemory[key];
    };
    MemoryStorage.clear = function clear() {
        $882a26b14055ef25$var$dataMemory = {};
        return $882a26b14055ef25$var$dataMemory;
    };
    return MemoryStorage;
}();
/** @class */ var $882a26b14055ef25$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * This is used to get a storage object
   * @returns {object} the storage
   */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem('aws.cognito.test-ls', 1);
            this.storageWindow.removeItem('aws.cognito.test-ls');
        } catch (exception) {
            this.storageWindow = $882a26b14055ef25$var$MemoryStorage;
        }
    }
    /**
   * This is used to return the storage
   * @returns {object} the storage
   */ var _proto = StorageHelper.prototype;
    _proto.getStorage = function getStorage() {
        return this.storageWindow;
    };
    return StorageHelper;
}();

});


parcelRegister("bbkkz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82407e0d065579d6$export$2e2bcd8739ae039; });
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ 
var $eNNiy = parcelRequire("eNNiy");

var $7VU9U = parcelRequire("7VU9U");

var $bGNG0 = parcelRequire("bGNG0");
/** @class */ var $82407e0d065579d6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserPool object
   * @param {object} data Creation options.
   * @param {string} data.UserPoolId Cognito user pool id.
   * @param {string} data.ClientId User pool application client id.
   * @param {string} data.endpoint Optional custom service endpoint.
   * @param {object} data.fetchOptions Optional options for fetch API.
   *        (only credentials option is supported)
   * @param {object} data.Storage Optional storage object.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
   *        boolean flag indicating if the data collection is enabled
   *        to support cognito advanced security features. By default, this
   *        flag is set to true.
   */ function CognitoUserPool(data, wrapRefreshSessionCallback) {
        var _ref = data || {}, UserPoolId = _ref.UserPoolId, ClientId = _ref.ClientId, endpoint = _ref.endpoint, fetchOptions = _ref.fetchOptions, AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;
        if (!UserPoolId || !ClientId) throw new Error('Both UserPoolId and ClientId are required.');
        if (!/^[\w-]+_.+$/.test(UserPoolId)) throw new Error('Invalid UserPoolId format.');
        var region = UserPoolId.split('_')[0];
        this.userPoolId = UserPoolId;
        this.clientId = ClientId;
        this.client = new (0, $eNNiy.default)(region, endpoint, fetchOptions);
        /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true,
     * if no input value is provided.
     */ this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
        this.storage = data.Storage || new (0, $bGNG0.default)().getStorage();
        if (wrapRefreshSessionCallback) this.wrapRefreshSessionCallback = wrapRefreshSessionCallback;
    }
    /**
   * @returns {string} the user pool id
   */ var _proto = CognitoUserPool.prototype;
    _proto.getUserPoolId = function getUserPoolId() {
        return this.userPoolId;
    };
    _proto.getClientId = function getClientId() {
        return this.clientId;
    };
    _proto.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
        var _this = this;
        var jsonReq = {
            ClientId: this.clientId,
            Username: username,
            Password: password,
            UserAttributes: userAttributes,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData(username)) jsonReq.UserContextData = this.getUserContextData(username);
        this.client.request('SignUp', jsonReq, function(err, data) {
            if (err) return callback(err, null);
            var cognitoUser = {
                Username: username,
                Pool: _this,
                Storage: _this.storage
            };
            var returnData = {
                user: new (0, $7VU9U.default)(cognitoUser),
                userConfirmed: data.UserConfirmed,
                userSub: data.UserSub,
                codeDeliveryDetails: data.CodeDeliveryDetails
            };
            return callback(null, returnData);
        });
    };
    _proto.getCurrentUser = function getCurrentUser() {
        var lastUserKey = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser";
        var lastAuthUser = this.storage.getItem(lastUserKey);
        if (lastAuthUser) {
            var cognitoUser = {
                Username: lastAuthUser,
                Pool: this,
                Storage: this.storage
            };
            return new (0, $7VU9U.default)(cognitoUser);
        }
        return null;
    };
    _proto.getUserContextData = function getUserContextData(username) {
        if (typeof AmazonCognitoAdvancedSecurityData === 'undefined') return undefined;
        /* eslint-disable */ var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
        /* eslint-enable */ if (this.advancedSecurityDataCollectionFlag) {
            var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
            if (advancedSecurityData) {
                var userContextData = {
                    EncodedData: advancedSecurityData
                };
                return userContextData;
            }
        }
        return {};
    };
    return CognitoUserPool;
}();

});
parcelRegister("eNNiy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac6be1e7b3a3f47d$export$2e2bcd8739ae039; });
parcelRequire("8uGLe");

var $cfxLo = parcelRequire("cfxLo");
function $ac6be1e7b3a3f47d$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $ac6be1e7b3a3f47d$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $ac6be1e7b3a3f47d$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$ac6be1e7b3a3f47d$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $ac6be1e7b3a3f47d$var$_construct(Class, arguments, $ac6be1e7b3a3f47d$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $ac6be1e7b3a3f47d$var$_setPrototypeOf(Wrapper, Class);
    };
    return $ac6be1e7b3a3f47d$var$_wrapNativeSuper(Class);
}
function $ac6be1e7b3a3f47d$var$_construct(Parent, args, Class) {
    if ($ac6be1e7b3a3f47d$var$_isNativeReflectConstruct()) $ac6be1e7b3a3f47d$var$_construct = Reflect.construct;
    else $ac6be1e7b3a3f47d$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $ac6be1e7b3a3f47d$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $ac6be1e7b3a3f47d$var$_construct.apply(null, arguments);
}
function $ac6be1e7b3a3f47d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ac6be1e7b3a3f47d$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $ac6be1e7b3a3f47d$var$_setPrototypeOf(o, p) {
    $ac6be1e7b3a3f47d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ac6be1e7b3a3f47d$var$_setPrototypeOf(o, p);
}
function $ac6be1e7b3a3f47d$var$_getPrototypeOf(o) {
    $ac6be1e7b3a3f47d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ac6be1e7b3a3f47d$var$_getPrototypeOf(o);
}
var $ac6be1e7b3a3f47d$var$CognitoError = /*#__PURE__*/ function(_Error) {
    $ac6be1e7b3a3f47d$var$_inheritsLoose(CognitoError, _Error);
    function CognitoError(message, code, name, statusCode) {
        var _this;
        _this = _Error.call(this, message) || this;
        _this.code = code;
        _this.name = name;
        _this.statusCode = statusCode;
        return _this;
    }
    return CognitoError;
}(/*#__PURE__*/ $ac6be1e7b3a3f47d$var$_wrapNativeSuper(Error));
/** @class */ var $ac6be1e7b3a3f47d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AWS Cognito Identity Provider client object
   * @param {string} region AWS region
   * @param {string} endpoint endpoint
   * @param {object} fetchOptions options for fetch API (only credentials is supported)
   */ function Client(region, endpoint, fetchOptions) {
        this.endpoint = endpoint || "https://cognito-idp." + region + ".amazonaws.com/";
        var _ref = fetchOptions || {}, credentials = _ref.credentials;
        this.fetchOptions = credentials ? {
            credentials: credentials
        } : {};
    }
    /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @returns Promise<object>
   */ var _proto = Client.prototype;
    _proto.promisifyRequest = function promisifyRequest(operation, params) {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.request(operation, params, function(err, data) {
                if (err) reject(new $ac6be1e7b3a3f47d$var$CognitoError(err.message, err.code, err.name, err.statusCode));
                else resolve(data);
            });
        });
    };
    _proto.request = function request(operation, params, callback) {
        var headers = {
            'Content-Type': 'application/x-amz-json-1.1',
            'X-Amz-Target': "AWSCognitoIdentityProviderService." + operation,
            'X-Amz-User-Agent': (0, $cfxLo.default).prototype.userAgent
        };
        var options = Object.assign({}, this.fetchOptions, {
            headers: headers,
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            body: JSON.stringify(params)
        });
        var response;
        var responseJsonData;
        fetch(this.endpoint, options).then(function(resp) {
            response = resp;
            return resp;
        }, function(err) {
            // If error happens here, the request failed
            // if it is TypeError throw network error
            if (err instanceof TypeError) throw new Error('Network error');
            throw err;
        }).then(function(resp) {
            return resp.json()["catch"](function() {
                return {};
            });
        }).then(function(data) {
            // return parsed body stream
            if (response.ok) return callback(null, data);
            responseJsonData = data; // Taken from aws-sdk-js/lib/protocol/json.js
            // eslint-disable-next-line no-underscore-dangle
            var code = (data.__type || data.code).split('#').pop();
            var error = {
                code: code,
                name: code,
                message: data.message || data.Message || null
            };
            return callback(error);
        })["catch"](function(err) {
            // first check if we have a service error
            if (response && response.headers && response.headers.get('x-amzn-errortype')) try {
                var code = response.headers.get('x-amzn-errortype').split(':')[0];
                var error = {
                    code: code,
                    name: code,
                    statusCode: response.status,
                    message: response.status ? response.status.toString() : null
                };
                return callback(error);
            } catch (ex) {
                return callback(err);
            } // otherwise check if error is Network error
            else if (err instanceof Error && err.message === 'Network error') {
                var _error = {
                    code: 'NetworkError',
                    name: err.name,
                    message: err.message
                };
                return callback(_error);
            } else return callback(err);
        });
    };
    return Client;
}();

});
parcelRegister("8uGLe", function(module, exports) {


module.exports = self.fetch || (self.fetch = (parcelRequire("5DZ9Z")).default || (parcelRequire("5DZ9Z")));

});

parcelRegister("cfxLo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8eb11374587cfba9$export$2e2bcd8739ae039; });
// constructor
function $8eb11374587cfba9$var$UserAgent() {} // public
$8eb11374587cfba9$var$UserAgent.prototype.userAgent = 'aws-amplify/0.1.x js';
var $8eb11374587cfba9$export$ad34c5a3baecdb02 = function appendToCognitoUserAgent(content) {
    if (!content) return;
    if ($8eb11374587cfba9$var$UserAgent.prototype.userAgent && !$8eb11374587cfba9$var$UserAgent.prototype.userAgent.includes(content)) $8eb11374587cfba9$var$UserAgent.prototype.userAgent = $8eb11374587cfba9$var$UserAgent.prototype.userAgent.concat(' ', content);
    if (!$8eb11374587cfba9$var$UserAgent.prototype.userAgent || $8eb11374587cfba9$var$UserAgent.prototype.userAgent === '') $8eb11374587cfba9$var$UserAgent.prototype.userAgent = content;
}; // class for defining the amzn user-agent
var $8eb11374587cfba9$export$2e2bcd8739ae039 = $8eb11374587cfba9$var$UserAgent;

});



parcelRegister("j3bXS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dde7941a021c9376$export$2e2bcd8739ae039; });

var $irnwm = parcelRequire("irnwm");
/** @class */ var $dde7941a021c9376$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (mandatory).
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   * @param {string} data.sameSite Cookie request behaviour (default: null)
   */ function CookieStorage(data) {
        if (data.domain) this.domain = data.domain;
        else throw new Error('The domain of cookieStorage can not be undefined.');
        if (data.path) this.path = data.path;
        else this.path = '/';
        if (Object.prototype.hasOwnProperty.call(data, 'expires')) this.expires = data.expires;
        else this.expires = 365;
        if (Object.prototype.hasOwnProperty.call(data, 'secure')) this.secure = data.secure;
        else this.secure = true;
        if (Object.prototype.hasOwnProperty.call(data, 'sameSite')) {
            if (![
                'strict',
                'lax',
                'none'
            ].includes(data.sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (data.sameSite === 'none' && !this.secure) throw new Error('sameSite = None requires the Secure attribute in latest browser versions.');
            this.sameSite = data.sameSite;
        } else this.sameSite = null;
    }
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ var _proto = CookieStorage.prototype;
    _proto.setItem = function setItem(key, value) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        $irnwm.set(key, value, options);
        return $irnwm.get(key);
    };
    _proto.getItem = function getItem(key) {
        return $irnwm.get(key);
    };
    _proto.removeItem = function removeItem(key) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        return $irnwm.remove(key, options);
    };
    _proto.clear = function clear() {
        var cookies = $irnwm.get();
        var index;
        for(index = 0; index < cookies.length; ++index)$irnwm.remove(cookies[index]);
        return {};
    };
    return CookieStorage;
}();

});
parcelRegister("irnwm", function(module, exports) {
/*! js-cookie v3.0.8 | MIT */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (key === '__proto__') continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    if (!(found in jar)) jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (_e) {
                // Do nothing...
                }
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    return api;
});

});



parcelRegister("bKd6N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88ce28acf067b138$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $2qlBa = parcelRequire("2qlBa");

var $91B79 = parcelRequire("91B79");

var $4f05o = parcelRequire("4f05o");

var $cCguc = parcelRequire("cCguc");

var $l7cio = parcelRequire("l7cio");
var $hPjfU = parcelRequire("hPjfU");
var $lpLq9 = parcelRequire("lpLq9");

var $1HHSs = parcelRequire("1HHSs");

var $cWvYf = parcelRequire("cWvYf");
var $88ce28acf067b138$var$__assign = undefined && undefined.__assign || function() {
    $88ce28acf067b138$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $88ce28acf067b138$var$__assign.apply(this, arguments);
};
var $88ce28acf067b138$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $88ce28acf067b138$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $88ce28acf067b138$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $88ce28acf067b138$var$AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
var $88ce28acf067b138$var$dispatchAuthEvent = function(event, data, message) {
    (0, $hPjfU.Hub).dispatch('auth', {
        event: event,
        data: data,
        message: message
    }, 'Auth', $88ce28acf067b138$var$AMPLIFY_SYMBOL);
};
var $88ce28acf067b138$var$logger = new (0, $l7cio.ConsoleLogger)('OAuth');
var $88ce28acf067b138$var$OAuth = /** @class */ function() {
    function OAuth(_a) {
        var config = _a.config, cognitoClientId = _a.cognitoClientId, _b = _a.scopes, scopes = _b === void 0 ? [] : _b;
        this._urlOpener = config.urlOpener || (0, $91B79.launchUri);
        this._config = config;
        this._cognitoClientId = cognitoClientId;
        if (!this.isValidScopes(scopes)) throw Error('scopes must be a String Array');
        this._scopes = scopes;
    }
    OAuth.prototype.isValidScopes = function(scopes) {
        return Array.isArray(scopes) && scopes.every(function(scope) {
            return typeof scope === 'string';
        });
    };
    OAuth.prototype.oauthSignIn = function(responseType, domain, redirectSignIn, clientId, provider, customState) {
        if (responseType === void 0) responseType = 'code';
        if (provider === void 0) provider = (0, $cCguc.CognitoHostedUIIdentityProvider).Cognito;
        var generatedState = this._generateState(32);
        /* encodeURIComponent is not URL safe, use urlSafeEncode instead. Cognito
        single-encodes/decodes url on first sign in and double-encodes/decodes url
        when user already signed in. Using encodeURIComponent, Base32, Base64 add
        characters % or = which on further encoding becomes unsafe. '=' create issue
        for parsing query params.
        Refer: https://github.com/aws-amplify/amplify-js/issues/5218 */ var state = customState ? generatedState + "-" + (0, $lpLq9.urlSafeEncode)(customState) : generatedState;
        $4f05o.setState(state);
        var pkce_key = this._generateRandom(128);
        $4f05o.setPKCE(pkce_key);
        var code_challenge = this._generateChallenge(pkce_key);
        var code_challenge_method = 'S256';
        var scopesString = this._scopes.join(' ');
        var queryString = Object.entries($88ce28acf067b138$var$__assign($88ce28acf067b138$var$__assign({
            redirect_uri: redirectSignIn,
            response_type: responseType,
            client_id: clientId,
            identity_provider: provider,
            scope: scopesString,
            state: state
        }, responseType === 'code' ? {
            code_challenge: code_challenge
        } : {}), responseType === 'code' ? {
            code_challenge_method: code_challenge_method
        } : {})).map(function(_a) {
            var _b = $88ce28acf067b138$var$__read(_a, 2), k = _b[0], v = _b[1];
            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
        }).join('&');
        var URL = "https://" + domain + "/oauth2/authorize?" + queryString;
        $88ce28acf067b138$var$logger.debug("Redirecting to " + URL);
        this._urlOpener(URL, redirectSignIn);
    };
    OAuth.prototype._handleCodeFlow = function(currentUrl) {
        return $88ce28acf067b138$var$__awaiter(this, void 0, void 0, function() {
            var code, oAuthTokenEndpoint, client_id, redirect_uri, code_verifier, oAuthTokenBody, body, _a, access_token, refresh_token, id_token, error;
            return $88ce28acf067b138$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        code = ((0, $2qlBa.parse)(currentUrl).query || '').split('&').map(function(pairings) {
                            return pairings.split('=');
                        }).reduce(function(accum, _a) {
                            var _b;
                            var _c = $88ce28acf067b138$var$__read(_a, 2), k = _c[0], v = _c[1];
                            return $88ce28acf067b138$var$__assign($88ce28acf067b138$var$__assign({}, accum), (_b = {}, _b[k] = v, _b));
                        }, {
                            code: undefined
                        }).code;
                        if (!code || (0, $2qlBa.parse)(currentUrl).pathname !== (0, $2qlBa.parse)(this._config.redirectSignIn).pathname) return [
                            2 /*return*/ 
                        ];
                        oAuthTokenEndpoint = 'https://' + this._config.domain + '/oauth2/token';
                        $88ce28acf067b138$var$dispatchAuthEvent('codeFlow', {}, "Retrieving tokens from " + oAuthTokenEndpoint);
                        client_id = (0, $cCguc.isCognitoHostedOpts)(this._config) ? this._cognitoClientId : this._config.clientID;
                        redirect_uri = (0, $cCguc.isCognitoHostedOpts)(this._config) ? this._config.redirectSignIn : this._config.redirectUri;
                        code_verifier = $4f05o.getPKCE();
                        oAuthTokenBody = $88ce28acf067b138$var$__assign({
                            grant_type: 'authorization_code',
                            code: code,
                            client_id: client_id,
                            redirect_uri: redirect_uri
                        }, code_verifier ? {
                            code_verifier: code_verifier
                        } : {});
                        $88ce28acf067b138$var$logger.debug("Calling token endpoint: " + oAuthTokenEndpoint + " with", oAuthTokenBody);
                        body = Object.entries(oAuthTokenBody).map(function(_a) {
                            var _b = $88ce28acf067b138$var$__read(_a, 2), k = _b[0], v = _b[1];
                            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
                        }).join('&');
                        return [
                            4 /*yield*/ ,
                            fetch(oAuthTokenEndpoint, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                },
                                body: body
                            })
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _b.sent().json()
                        ];
                    case 2:
                        _a = _b.sent(), access_token = _a.access_token, refresh_token = _a.refresh_token, id_token = _a.id_token, error = _a.error;
                        if (error) throw new Error(error);
                        return [
                            2 /*return*/ ,
                            {
                                accessToken: access_token,
                                refreshToken: refresh_token,
                                idToken: id_token
                            }
                        ];
                }
            });
        });
    };
    OAuth.prototype._handleImplicitFlow = function(currentUrl) {
        return $88ce28acf067b138$var$__awaiter(this, void 0, void 0, function() {
            var _a, id_token, access_token;
            return $88ce28acf067b138$var$__generator(this, function(_b) {
                _a = ((0, $2qlBa.parse)(currentUrl).hash || '#').substr(1) // Remove # from returned code
                .split('&').map(function(pairings) {
                    return pairings.split('=');
                }).reduce(function(accum, _a) {
                    var _b;
                    var _c = $88ce28acf067b138$var$__read(_a, 2), k = _c[0], v = _c[1];
                    return $88ce28acf067b138$var$__assign($88ce28acf067b138$var$__assign({}, accum), (_b = {}, _b[k] = v, _b));
                }, {
                    id_token: undefined,
                    access_token: undefined
                }), id_token = _a.id_token, access_token = _a.access_token;
                $88ce28acf067b138$var$dispatchAuthEvent('implicitFlow', {}, "Got tokens from " + currentUrl);
                $88ce28acf067b138$var$logger.debug("Retrieving implicit tokens from " + currentUrl + " with");
                return [
                    2 /*return*/ ,
                    {
                        accessToken: access_token,
                        idToken: id_token,
                        refreshToken: null
                    }
                ];
            });
        });
    };
    OAuth.prototype.handleAuthResponse = function(currentUrl) {
        return $88ce28acf067b138$var$__awaiter(this, void 0, void 0, function() {
            var urlParams, error, error_description, state, _a, _b, e_1;
            return $88ce28acf067b138$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        urlParams = currentUrl ? $88ce28acf067b138$var$__assign($88ce28acf067b138$var$__assign({}, ((0, $2qlBa.parse)(currentUrl).hash || '#').substr(1).split('&').map(function(entry) {
                            return entry.split('=');
                        }).reduce(function(acc, _a) {
                            var _b = $88ce28acf067b138$var$__read(_a, 2), k = _b[0], v = _b[1];
                            return acc[k] = v, acc;
                        }, {})), ((0, $2qlBa.parse)(currentUrl).query || '').split('&').map(function(entry) {
                            return entry.split('=');
                        }).reduce(function(acc, _a) {
                            var _b = $88ce28acf067b138$var$__read(_a, 2), k = _b[0], v = _b[1];
                            return acc[k] = v, acc;
                        }, {})) : {};
                        error = urlParams.error, error_description = urlParams.error_description;
                        if (error) throw new Error(error_description);
                        state = this._validateState(urlParams);
                        $88ce28acf067b138$var$logger.debug("Starting " + this._config.responseType + " flow with " + currentUrl);
                        if (!(this._config.responseType === 'code')) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleCodeFlow(currentUrl)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            $88ce28acf067b138$var$__assign.apply(void 0, [
                                $88ce28acf067b138$var$__assign.apply(void 0, _a.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 2:
                        _b = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleImplicitFlow(currentUrl)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            $88ce28acf067b138$var$__assign.apply(void 0, [
                                $88ce28acf067b138$var$__assign.apply(void 0, _b.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 4:
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        e_1 = _c.sent();
                        $88ce28acf067b138$var$logger.error("Error handling auth response.", e_1);
                        throw e_1;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    OAuth.prototype._validateState = function(urlParams) {
        if (!urlParams) return;
        var savedState = $4f05o.getState();
        var returnedState = urlParams.state;
        // This is because savedState only exists if the flow was initiated by Amplify
        if (savedState && savedState !== returnedState) throw new Error('Invalid state in OAuth flow');
        return returnedState;
    };
    OAuth.prototype.signOut = function() {
        return $88ce28acf067b138$var$__awaiter(this, void 0, void 0, function() {
            var oAuthLogoutEndpoint, client_id, signout_uri;
            return $88ce28acf067b138$var$__generator(this, function(_a) {
                oAuthLogoutEndpoint = 'https://' + this._config.domain + '/logout?';
                client_id = (0, $cCguc.isCognitoHostedOpts)(this._config) ? this._cognitoClientId : this._config.oauth.clientID;
                signout_uri = (0, $cCguc.isCognitoHostedOpts)(this._config) ? this._config.redirectSignOut : this._config.returnTo;
                oAuthLogoutEndpoint += Object.entries({
                    client_id: client_id,
                    logout_uri: encodeURIComponent(signout_uri)
                }).map(function(_a) {
                    var _b = $88ce28acf067b138$var$__read(_a, 2), k = _b[0], v = _b[1];
                    return k + "=" + v;
                }).join('&');
                $88ce28acf067b138$var$dispatchAuthEvent('oAuthSignOut', {
                    oAuth: 'signOut'
                }, "Signing out from " + oAuthLogoutEndpoint);
                $88ce28acf067b138$var$logger.debug("Signing out from " + oAuthLogoutEndpoint);
                return [
                    2 /*return*/ ,
                    this._urlOpener(oAuthLogoutEndpoint)
                ];
            });
        });
    };
    OAuth.prototype._generateState = function(length) {
        var result = '';
        var i = length;
        var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        for(; i > 0; --i)result += chars[Math.round(Math.random() * (chars.length - 1))];
        return result;
    };
    OAuth.prototype._generateChallenge = function(code) {
        return this._base64URL((0, (/*@__PURE__*/$parcel$interopDefault($1HHSs)))(code));
    };
    OAuth.prototype._base64URL = function(string) {
        return string.toString((0, (/*@__PURE__*/$parcel$interopDefault($cWvYf)))).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
    };
    OAuth.prototype._generateRandom = function(size) {
        var CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        var buffer = new Uint8Array(size);
        if (typeof window !== 'undefined' && !!window.crypto) window.crypto.getRandomValues(buffer);
        else for(var i = 0; i < size; i += 1)buffer[i] = Math.random() * CHARSET.length | 0;
        return this._bufferToString(buffer);
    };
    OAuth.prototype._bufferToString = function(buffer) {
        var CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var state = [];
        for(var i = 0; i < buffer.byteLength; i += 1){
            var index = buffer[i] % CHARSET.length;
            state.push(CHARSET[index]);
        }
        return state.join('');
    };
    return OAuth;
}();
var $88ce28acf067b138$export$2e2bcd8739ae039 = $88ce28acf067b138$var$OAuth;

});
parcelRegister("91B79", function(module, exports) {

$parcel$export(module.exports, "launchUri", function () { return $01b214a1b898c4e3$export$9b38228bd9928080; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $01b214a1b898c4e3$var$SELF = '_self';
var $01b214a1b898c4e3$export$9b38228bd9928080 = function(url) {
    var windowProxy = window.open(url, $01b214a1b898c4e3$var$SELF);
    if (windowProxy) return Promise.resolve(windowProxy);
    else return Promise.reject();
};

});

parcelRegister("4f05o", function(module, exports) {

$parcel$export(module.exports, "setState", function () { return $3168a1308bd3cc88$export$42fffed799c298bb; });
$parcel$export(module.exports, "getState", function () { return $3168a1308bd3cc88$export$50fdfeece43146fd; });
$parcel$export(module.exports, "setPKCE", function () { return $3168a1308bd3cc88$export$14934cb45d589fa1; });
$parcel$export(module.exports, "getPKCE", function () { return $3168a1308bd3cc88$export$742ac7ded61fbfce; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $3168a1308bd3cc88$export$42fffed799c298bb = function(state) {
    window.sessionStorage.setItem('oauth_state', state);
};
var $3168a1308bd3cc88$export$50fdfeece43146fd = function() {
    var oauth_state = window.sessionStorage.getItem('oauth_state');
    window.sessionStorage.removeItem('oauth_state');
    return oauth_state;
};
var $3168a1308bd3cc88$export$14934cb45d589fa1 = function(private_key) {
    window.sessionStorage.setItem('ouath_pkce_key', private_key);
};
var $3168a1308bd3cc88$export$742ac7ded61fbfce = function() {
    var ouath_pkce_key = window.sessionStorage.getItem('ouath_pkce_key');
    window.sessionStorage.removeItem('ouath_pkce_key');
    return ouath_pkce_key;
};
var $3168a1308bd3cc88$export$1042faa6df30c26 = function() {
    window.sessionStorage.removeItem('ouath_pkce_key');
    window.sessionStorage.removeItem('oauth_state');
};

});


parcelRegister("3amhM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24e397c349f0e9d3$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $7HFvj = parcelRequire("7HFvj");
var $24e397c349f0e9d3$export$2e2bcd8739ae039 = function(callback) {
    if ((0, $7HFvj.JS).browserOrNode().isBrowser && window.location) {
        var url = window.location.href;
        callback({
            url: url
        });
    } else if ((0, $7HFvj.JS).browserOrNode().isNode) ;
    else throw new Error('Not supported');
};

});

parcelRegister("7Rn4k", function(module, exports) {

$parcel$export(module.exports, "AuthError", function () { return $5b8f60a68f7f3f4d$export$145273558d58e0ac; });
$parcel$export(module.exports, "NoUserPoolError", function () { return $5b8f60a68f7f3f4d$export$71192787e041818c; });
/*
 * Copyright 2019-2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $l7cio = parcelRequire("l7cio");

var $gJjJr = parcelRequire("gJjJr");
var $5b8f60a68f7f3f4d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5b8f60a68f7f3f4d$var$logger = new (0, $l7cio.ConsoleLogger)('AuthError');
var $5b8f60a68f7f3f4d$export$145273558d58e0ac = /** @class */ function(_super) {
    $5b8f60a68f7f3f4d$var$__extends(AuthError, _super);
    function AuthError(type) {
        var _this = this;
        var _a = $5b8f60a68f7f3f4d$export$d8113b8d790509a4[type], message = _a.message, log = _a.log;
        _this = _super.call(this, message) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = AuthError;
        Object.setPrototypeOf(_this, AuthError.prototype);
        _this.name = 'AuthError';
        _this.log = log || message;
        $5b8f60a68f7f3f4d$var$logger.error(_this.log);
        return _this;
    }
    return AuthError;
}(Error);
var $5b8f60a68f7f3f4d$export$71192787e041818c = /** @class */ function(_super) {
    $5b8f60a68f7f3f4d$var$__extends(NoUserPoolError, _super);
    function NoUserPoolError(type) {
        var _this = _super.call(this, type) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = NoUserPoolError;
        Object.setPrototypeOf(_this, NoUserPoolError.prototype);
        _this.name = 'NoUserPoolError';
        return _this;
    }
    return NoUserPoolError;
}($5b8f60a68f7f3f4d$export$145273558d58e0ac);
var $5b8f60a68f7f3f4d$export$d8113b8d790509a4 = {
    noConfig: {
        message: (0, $gJjJr.AuthErrorStrings).DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly.\n            This error is typically caused by one of the following scenarios:\n\n            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point\n                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information\n            \n            2. There might be multiple conflicting versions of aws-amplify or amplify packages in your node_modules.\n                Try deleting your node_modules folder and reinstalling the dependencies with `yarn install`\n        "
    },
    missingAuthConfig: {
        message: (0, $gJjJr.AuthErrorStrings).DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly. \n            The configuration object is missing required auth properties. \n            Did you run `amplify push` after adding auth via `amplify add auth`?\n            See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information\n        "
    },
    emptyUsername: {
        message: (0, $gJjJr.AuthErrorStrings).EMPTY_USERNAME
    },
    // TODO: should include a list of valid sign-in types
    invalidUsername: {
        message: (0, $gJjJr.AuthErrorStrings).INVALID_USERNAME
    },
    emptyPassword: {
        message: (0, $gJjJr.AuthErrorStrings).EMPTY_PASSWORD
    },
    emptyCode: {
        message: (0, $gJjJr.AuthErrorStrings).EMPTY_CODE
    },
    signUpError: {
        message: (0, $gJjJr.AuthErrorStrings).SIGN_UP_ERROR,
        log: 'The first parameter should either be non-null string or object'
    },
    noMFA: {
        message: (0, $gJjJr.AuthErrorStrings).NO_MFA
    },
    invalidMFA: {
        message: (0, $gJjJr.AuthErrorStrings).INVALID_MFA
    },
    emptyChallengeResponse: {
        message: (0, $gJjJr.AuthErrorStrings).EMPTY_CHALLENGE
    },
    noUserSession: {
        message: (0, $gJjJr.AuthErrorStrings).NO_USER_SESSION
    },
    default: {
        message: (0, $gJjJr.AuthErrorStrings).DEFAULT_MSG
    }
};

});
parcelRegister("gJjJr", function(module, exports) {

$parcel$export(module.exports, "AuthErrorStrings", function () { return $c2e027a71c5987a8$export$c3070468b9d65120; });
var $c2e027a71c5987a8$export$c3070468b9d65120;
(function(AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
})($c2e027a71c5987a8$export$c3070468b9d65120 || ($c2e027a71c5987a8$export$c3070468b9d65120 = {}));

});




parcelRegister("3kSIa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26ddade3c6372a26$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("dRac8");
var $9QDF4 = parcelRequire("9QDF4");

var $iyDAn = parcelRequire("iyDAn");

var /**
 * @deprecated use named import
 */ $26ddade3c6372a26$export$2e2bcd8739ae039 = (0, $iyDAn.BrowserStorageCache);
(0, $9QDF4.Amplify).register((0, $iyDAn.BrowserStorageCache));

});
parcelRegister("iyDAn", function(module, exports) {

$parcel$export(module.exports, "BrowserStorageCache", function () { return $d82a1bdc3cd6d37d$export$2a9787695d97e2c4; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $GVKgj = parcelRequire("GVKgj");

var $ah1SF = parcelRequire("ah1SF");

var $l7cio = parcelRequire("l7cio");
var $d82a1bdc3cd6d37d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d82a1bdc3cd6d37d$var$logger = new (0, $l7cio.ConsoleLogger)('Cache');
/**
 * Customized storage based on the SessionStorage or LocalStorage with LRU implemented
 */ var $d82a1bdc3cd6d37d$export$e6fda0405fa98d6d = /** @class */ function(_super) {
    $d82a1bdc3cd6d37d$var$__extends(BrowserStorageCacheClass, _super);
    /**
     * initialize the cache
     * @param config - the configuration of the cache
     */ function BrowserStorageCacheClass(config) {
        var _this = this;
        var cacheConfig = config ? Object.assign({}, (0, $GVKgj.defaultConfig), config) : (0, $GVKgj.defaultConfig);
        _this = _super.call(this, cacheConfig) || this;
        _this.config.storage = cacheConfig.storage;
        _this.getItem = _this.getItem.bind(_this);
        _this.setItem = _this.setItem.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);
        return _this;
    }
    /**
     * decrease current size of the cache
     *
     * @private
     * @param amount - the amount of the cache size which needs to be decreased
     */ BrowserStorageCacheClass.prototype._decreaseCurSizeInBytes = function(amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize - amount).toString());
    };
    /**
     * increase current size of the cache
     *
     * @private
     * @param amount - the amount of the cache szie which need to be increased
     */ BrowserStorageCacheClass.prototype._increaseCurSizeInBytes = function(amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize + amount).toString());
    };
    /**
     * update the visited time if item has been visited
     *
     * @private
     * @param item - the item which need to be refreshed
     * @param prefixedKey - the key of the item
     *
     * @return the refreshed item
     */ BrowserStorageCacheClass.prototype._refreshItem = function(item, prefixedKey) {
        item.visitedTime = (0, $GVKgj.getCurrTime)();
        this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        return item;
    };
    /**
     * check wether item is expired
     *
     * @private
     * @param key - the key of the item
     *
     * @return true if the item is expired.
     */ BrowserStorageCacheClass.prototype._isExpired = function(key) {
        var text = this.config.storage.getItem(key);
        var item = JSON.parse(text);
        if ((0, $GVKgj.getCurrTime)() >= item.expires) return true;
        return false;
    };
    /**
     * delete item from cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param size - optional, the byte size of the item
     */ BrowserStorageCacheClass.prototype._removeItem = function(prefixedKey, size) {
        var itemSize = size ? size : JSON.parse(this.config.storage.getItem(prefixedKey)).byteSize;
        this._decreaseCurSizeInBytes(itemSize);
        // remove the cache item
        this.config.storage.removeItem(prefixedKey);
    };
    /**
     * put item into cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param itemData - the value of the item
     * @param itemSizeInBytes - the byte size of the item
     */ BrowserStorageCacheClass.prototype._setItem = function(prefixedKey, item) {
        // update the cache size
        this._increaseCurSizeInBytes(item.byteSize);
        try {
            this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        } catch (setItemErr) {
            // if failed, we need to rollback the cache size
            this._decreaseCurSizeInBytes(item.byteSize);
            $d82a1bdc3cd6d37d$var$logger.error("Failed to set item " + setItemErr);
        }
    };
    /**
     * total space needed when poping out items
     *
     * @private
     * @param itemSize
     *
     * @return total space needed
     */ BrowserStorageCacheClass.prototype._sizeToPop = function(itemSize) {
        var spaceItemNeed = this.getCacheCurSize() + itemSize - this.config.capacityInBytes;
        var cacheThresholdSpace = (1 - this.config.warningThreshold) * this.config.capacityInBytes;
        return spaceItemNeed > cacheThresholdSpace ? spaceItemNeed : cacheThresholdSpace;
    };
    /**
     * see whether cache is full
     *
     * @private
     * @param itemSize
     *
     * @return true if cache is full
     */ BrowserStorageCacheClass.prototype._isCacheFull = function(itemSize) {
        return itemSize + this.getCacheCurSize() > this.config.capacityInBytes;
    };
    /**
     * scan the storage and find out all the keys owned by this cache
     * also clean the expired keys while scanning
     *
     * @private
     *
     * @return array of keys
     */ BrowserStorageCacheClass.prototype._findValidKeys = function() {
        var keys = [];
        var keyInCache = [];
        // get all keys in Storage
        for(var i = 0; i < this.config.storage.length; i += 1)keyInCache.push(this.config.storage.key(i));
        // find those items which belong to our cache and also clean those expired items
        for(var i = 0; i < keyInCache.length; i += 1){
            var key = keyInCache[i];
            if (key.indexOf(this.config.keyPrefix) === 0 && key !== this.cacheCurSizeKey) {
                if (this._isExpired(key)) this._removeItem(key);
                else keys.push(key);
            }
        }
        return keys;
    };
    /**
     * get all the items we have, sort them by their priority,
     * if priority is same, sort them by their last visited time
     * pop out items from the low priority (5 is the lowest)
     *
     * @private
     * @param keys - all the keys in this cache
     * @param sizeToPop - the total size of the items which needed to be poped out
     */ BrowserStorageCacheClass.prototype._popOutItems = function(keys, sizeToPop) {
        var items = [];
        var remainedSize = sizeToPop;
        // get the items from Storage
        for(var i = 0; i < keys.length; i += 1){
            var val = this.config.storage.getItem(keys[i]);
            if (val != null) {
                var item = JSON.parse(val);
                items.push(item);
            }
        }
        // first compare priority
        // then compare visited time
        items.sort(function(a, b) {
            if (a.priority > b.priority) return -1;
            else if (a.priority < b.priority) return 1;
            else {
                if (a.visitedTime < b.visitedTime) return -1;
                else return 1;
            }
        });
        for(var i = 0; i < items.length; i += 1){
            // pop out items until we have enough room for new item
            this._removeItem(items[i].key, items[i].byteSize);
            remainedSize -= items[i].byteSize;
            if (remainedSize <= 0) return;
        }
    };
    /**
     * Set item into cache. You can put number, string, boolean or object.
     * The cache will first check whether has the same key.
     * If it has, it will delete the old item and then put the new item in
     * The cache will pop out items if it is full
     * You can specify the cache item options. The cache will abort and output a warning:
     * If the key is invalid
     * If the size of the item exceeds itemMaxSize.
     * If the value is undefined
     * If incorrect cache item configuration
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param value - the value of the item
     * @param {Object} [options] - optional, the specified meta-data
     */ BrowserStorageCacheClass.prototype.setItem = function(key, value, options) {
        $d82a1bdc3cd6d37d$var$logger.log("Set item: key is " + key + ", value is " + value + " with options: " + options);
        var prefixedKey = this.config.keyPrefix + key;
        // invalid keys
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
            $d82a1bdc3cd6d37d$var$logger.warn("Invalid key: should not be empty or 'CurSize'");
            return;
        }
        if (typeof value === 'undefined') {
            $d82a1bdc3cd6d37d$var$logger.warn("The value of item should not be undefined!");
            return;
        }
        var cacheItemOptions = {
            priority: options && options.priority !== undefined ? options.priority : this.config.defaultPriority,
            expires: options && options.expires !== undefined ? options.expires : this.config.defaultTTL + (0, $GVKgj.getCurrTime)()
        };
        if (cacheItemOptions.priority < 1 || cacheItemOptions.priority > 5) {
            $d82a1bdc3cd6d37d$var$logger.warn("Invalid parameter: priority due to out or range. It should be within 1 and 5.");
            return;
        }
        var item = this.fillCacheItem(prefixedKey, value, cacheItemOptions);
        // check wether this item is too big;
        if (item.byteSize > this.config.itemMaxSize) {
            $d82a1bdc3cd6d37d$var$logger.warn("Item with key: " + key + " you are trying to put into is too big!");
            return;
        }
        try {
            // first look into the storage, if it exists, delete it.
            var val = this.config.storage.getItem(prefixedKey);
            if (val) this._removeItem(prefixedKey, JSON.parse(val).byteSize);
            // check whether the cache is full
            if (this._isCacheFull(item.byteSize)) {
                var validKeys = this._findValidKeys();
                // check again and then pop out items
                if (this._isCacheFull(item.byteSize)) {
                    var sizeToPop = this._sizeToPop(item.byteSize);
                    this._popOutItems(validKeys, sizeToPop);
                }
            }
            // put item in the cache
            // may failed due to storage full
            this._setItem(prefixedKey, item);
        } catch (e) {
            $d82a1bdc3cd6d37d$var$logger.warn("setItem failed! " + e);
        }
    };
    /**
     * Get item from cache. It will return null if item doesn’t exist or it has been expired.
     * If you specified callback function in the options,
     * then the function will be executed if no such item in the cache
     * and finally put the return value into cache.
     * Please make sure the callback function will return the value you want to put into the cache.
     * The cache will abort output a warning:
     * If the key is invalid
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param {Object} [options] - the options of callback function
     *
     * @return - return the value of the item
     */ BrowserStorageCacheClass.prototype.getItem = function(key, options) {
        $d82a1bdc3cd6d37d$var$logger.log("Get item: key is " + key + " with options " + options);
        var ret = null;
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
            $d82a1bdc3cd6d37d$var$logger.warn("Invalid key: should not be empty or 'CurSize'");
            return null;
        }
        try {
            ret = this.config.storage.getItem(prefixedKey);
            if (ret != null) {
                if (this._isExpired(prefixedKey)) {
                    // if expired, remove that item and return null
                    this._removeItem(prefixedKey, JSON.parse(ret).byteSize);
                    ret = null;
                } else {
                    // if not expired, great, return the value and refresh it
                    var item = JSON.parse(ret);
                    item = this._refreshItem(item, prefixedKey);
                    return item.data;
                }
            }
            if (options && options.callback !== undefined) {
                var val = options.callback();
                if (val !== null) this.setItem(key, val, options);
                return val;
            }
            return null;
        } catch (e) {
            $d82a1bdc3cd6d37d$var$logger.warn("getItem failed! " + e);
            return null;
        }
    };
    /**
     * remove item from the cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     * @param key - the key of the item
     */ BrowserStorageCacheClass.prototype.removeItem = function(key) {
        $d82a1bdc3cd6d37d$var$logger.log("Remove item: key is " + key);
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) return;
        try {
            var val = this.config.storage.getItem(prefixedKey);
            if (val) this._removeItem(prefixedKey, JSON.parse(val).byteSize);
        } catch (e) {
            $d82a1bdc3cd6d37d$var$logger.warn("removeItem failed! " + e);
        }
    };
    /**
     * clear the entire cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     */ BrowserStorageCacheClass.prototype.clear = function() {
        $d82a1bdc3cd6d37d$var$logger.log("Clear Cache");
        var keysToRemove = [];
        for(var i = 0; i < this.config.storage.length; i += 1){
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0) keysToRemove.push(key);
        }
        try {
            for(var i = 0; i < keysToRemove.length; i += 1)this.config.storage.removeItem(keysToRemove[i]);
        } catch (e) {
            $d82a1bdc3cd6d37d$var$logger.warn("clear failed! " + e);
        }
    };
    /**
     * Return all the keys in the cache.
     *
     * @return - all keys in the cache
     */ BrowserStorageCacheClass.prototype.getAllKeys = function() {
        var keys = [];
        for(var i = 0; i < this.config.storage.length; i += 1){
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0 && key !== this.cacheCurSizeKey) keys.push(key.substring(this.config.keyPrefix.length));
        }
        return keys;
    };
    /**
     * return the current size of the cache
     *
     * @return - current size of the cache
     */ BrowserStorageCacheClass.prototype.getCacheCurSize = function() {
        var ret = this.config.storage.getItem(this.cacheCurSizeKey);
        if (!ret) {
            this.config.storage.setItem(this.cacheCurSizeKey, '0');
            ret = '0';
        }
        return Number(ret);
    };
    /**
     * Return a new instance of cache with customized configuration.
     * @param config - the customized configuration
     *
     * @return - new instance of Cache
     */ BrowserStorageCacheClass.prototype.createInstance = function(config) {
        if (!config.keyPrefix || config.keyPrefix === (0, $GVKgj.defaultConfig).keyPrefix) {
            $d82a1bdc3cd6d37d$var$logger.error('invalid keyPrefix, setting keyPrefix with timeStamp');
            config.keyPrefix = (0, $GVKgj.getCurrTime).toString();
        }
        return new BrowserStorageCacheClass(config);
    };
    return BrowserStorageCacheClass;
}((0, $ah1SF.StorageCache));
var $d82a1bdc3cd6d37d$export$2a9787695d97e2c4 = new $d82a1bdc3cd6d37d$export$e6fda0405fa98d6d();
var /**
 * @deprecated use named import
 */ $d82a1bdc3cd6d37d$export$2e2bcd8739ae039 = $d82a1bdc3cd6d37d$export$2a9787695d97e2c4;

});
parcelRegister("GVKgj", function(module, exports) {

$parcel$export(module.exports, "defaultConfig", function () { return $0810b7584ceec3a1$export$f84bd70098573c5c; });
$parcel$export(module.exports, "getByteLength", function () { return $0810b7584ceec3a1$export$cc8c3b705bb8e6e2; });
$parcel$export(module.exports, "getCurrTime", function () { return $0810b7584ceec3a1$export$dd144842d7b22d3a; });
$parcel$export(module.exports, "isInteger", function () { return $0810b7584ceec3a1$export$a287f47fed4544b8; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $lpqOV = parcelRequire("lpqOV");
var $0810b7584ceec3a1$export$f84bd70098573c5c = {
    keyPrefix: 'aws-amplify-cache',
    capacityInBytes: 1048576,
    itemMaxSize: 210000,
    defaultTTL: 259200000,
    defaultPriority: 5,
    warningThreshold: 0.8,
    // the storage helper will check if localStorage exists,
    // if not, will use a in-memory object instead
    storage: new (0, $lpqOV.StorageHelper)().getStorage()
};
function $0810b7584ceec3a1$export$cc8c3b705bb8e6e2(str) {
    var ret = 0;
    ret = str.length;
    for(var i = str.length; i >= 0; i -= 1){
        var charCode = str.charCodeAt(i);
        if (charCode > 0x7f && charCode <= 0x7ff) ret += 1;
        else if (charCode > 0x7ff && charCode <= 0xffff) ret += 2;
        // trail surrogate
        if (charCode >= 0xdc00 && charCode <= 0xdfff) i -= 1;
    }
    return ret;
}
function $0810b7584ceec3a1$export$dd144842d7b22d3a() {
    var currTime = new Date();
    return currTime.getTime();
}
function $0810b7584ceec3a1$export$a287f47fed4544b8(value) {
    if (Number.isInteger) return Number.isInteger(value);
    return $0810b7584ceec3a1$var$_isInteger(value);
}
function $0810b7584ceec3a1$var$_isInteger(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
/**
 * provide an object as the in-memory cache
 */ var $0810b7584ceec3a1$var$store = {};
var $0810b7584ceec3a1$export$2dd5b9e5ba192a1a = /** @class */ function() {
    function CacheObject() {}
    CacheObject.clear = function() {
        $0810b7584ceec3a1$var$store = {};
    };
    CacheObject.getItem = function(key) {
        return $0810b7584ceec3a1$var$store[key] || null;
    };
    CacheObject.setItem = function(key, value) {
        $0810b7584ceec3a1$var$store[key] = value;
    };
    CacheObject.removeItem = function(key) {
        delete $0810b7584ceec3a1$var$store[key];
    };
    return CacheObject;
}();

});

parcelRegister("ah1SF", function(module, exports) {

$parcel$export(module.exports, "StorageCache", function () { return $77acf36421ac2171$export$947ed1997bd112b4; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $GVKgj = parcelRequire("GVKgj");

var $l7cio = parcelRequire("l7cio");
var $77acf36421ac2171$var$logger = new (0, $l7cio.ConsoleLogger)('StorageCache');
/**
 * Initialization of the cache
 *
 */ var $77acf36421ac2171$export$947ed1997bd112b4 = /** @class */ function() {
    /**
     * Initialize the cache
     * @param config - the configuration of the cache
     */ function StorageCache(config) {
        this.config = Object.assign({}, config);
        this.cacheCurSizeKey = this.config.keyPrefix + 'CurSize';
        this.checkConfig();
    }
    StorageCache.prototype.getModuleName = function() {
        return 'Cache';
    };
    StorageCache.prototype.checkConfig = function() {
        // check configuration
        if (!(0, $GVKgj.isInteger)(this.config.capacityInBytes)) {
            $77acf36421ac2171$var$logger.error('Invalid parameter: capacityInBytes. It should be an Integer. Setting back to default.');
            this.config.capacityInBytes = (0, $GVKgj.defaultConfig).capacityInBytes;
        }
        if (!(0, $GVKgj.isInteger)(this.config.itemMaxSize)) {
            $77acf36421ac2171$var$logger.error('Invalid parameter: itemMaxSize. It should be an Integer. Setting back to default.');
            this.config.itemMaxSize = (0, $GVKgj.defaultConfig).itemMaxSize;
        }
        if (!(0, $GVKgj.isInteger)(this.config.defaultTTL)) {
            $77acf36421ac2171$var$logger.error('Invalid parameter: defaultTTL. It should be an Integer. Setting back to default.');
            this.config.defaultTTL = (0, $GVKgj.defaultConfig).defaultTTL;
        }
        if (!(0, $GVKgj.isInteger)(this.config.defaultPriority)) {
            $77acf36421ac2171$var$logger.error('Invalid parameter: defaultPriority. It should be an Integer. Setting back to default.');
            this.config.defaultPriority = (0, $GVKgj.defaultConfig).defaultPriority;
        }
        if (this.config.itemMaxSize > this.config.capacityInBytes) {
            $77acf36421ac2171$var$logger.error('Invalid parameter: itemMaxSize. It should be smaller than capacityInBytes. Setting back to default.');
            this.config.itemMaxSize = (0, $GVKgj.defaultConfig).itemMaxSize;
        }
        if (this.config.defaultPriority > 5 || this.config.defaultPriority < 1) {
            $77acf36421ac2171$var$logger.error('Invalid parameter: defaultPriority. It should be between 1 and 5. Setting back to default.');
            this.config.defaultPriority = (0, $GVKgj.defaultConfig).defaultPriority;
        }
        if (Number(this.config.warningThreshold) > 1 || Number(this.config.warningThreshold) < 0) {
            $77acf36421ac2171$var$logger.error('Invalid parameter: warningThreshold. It should be between 0 and 1. Setting back to default.');
            this.config.warningThreshold = (0, $GVKgj.defaultConfig).warningThreshold;
        }
        // set 5MB limit
        var cacheLimit = 5242880;
        if (this.config.capacityInBytes > cacheLimit) {
            $77acf36421ac2171$var$logger.error('Cache Capacity should be less than 5MB. Setting back to default. Setting back to default.');
            this.config.capacityInBytes = (0, $GVKgj.defaultConfig).capacityInBytes;
        }
    };
    /**
     * produce a JSON object with meta-data and data value
     * @param value - the value of the item
     * @param options - optional, the specified meta-data
     *
     * @return - the item which has the meta-data and the value
     */ StorageCache.prototype.fillCacheItem = function(key, value, options) {
        var ret = {
            key: key,
            data: value,
            timestamp: (0, $GVKgj.getCurrTime)(),
            visitedTime: (0, $GVKgj.getCurrTime)(),
            priority: options.priority,
            expires: options.expires,
            type: typeof value,
            byteSize: 0
        };
        ret.byteSize = (0, $GVKgj.getByteLength)(JSON.stringify(ret));
        // for accurate size
        ret.byteSize = (0, $GVKgj.getByteLength)(JSON.stringify(ret));
        return ret;
    };
    /**
     * set cache with customized configuration
     * @param config - customized configuration
     *
     * @return - the current configuration
     */ StorageCache.prototype.configure = function(config) {
        if (!config) return this.config;
        if (config.keyPrefix) $77acf36421ac2171$var$logger.warn("Don't try to configure keyPrefix!");
        this.config = Object.assign({}, this.config, config, config.Cache);
        this.checkConfig();
        return this.config;
    };
    return StorageCache;
}();
var /**
 * @deprecated use named import
 */ $77acf36421ac2171$export$2e2bcd8739ae039 = $77acf36421ac2171$export$947ed1997bd112b4;

});



parcelRegister("jfKIU", function(module, exports) {

$parcel$export(module.exports, "Storage", function () { return $e043a94beb31b378$export$bf2a15d34f3c441c; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $8Q2P4 = parcelRequire("8Q2P4");
parcelRequire("dRac8");
var $9QDF4 = parcelRequire("9QDF4");
var $l7cio = parcelRequire("l7cio");

var $e043a94beb31b378$var$__assign = undefined && undefined.__assign || function() {
    $e043a94beb31b378$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e043a94beb31b378$var$__assign.apply(this, arguments);
};
var $e043a94beb31b378$var$logger = new (0, $l7cio.ConsoleLogger)('Storage');
var $e043a94beb31b378$var$_instance = null;
var $e043a94beb31b378$var$getInstance = function() {
    if ($e043a94beb31b378$var$_instance) return $e043a94beb31b378$var$_instance;
    $e043a94beb31b378$var$logger.debug('Create Storage Instance, debug');
    $e043a94beb31b378$var$_instance = new (0, $8Q2P4.Storage)();
    $e043a94beb31b378$var$_instance.vault = new (0, $8Q2P4.Storage)();
    var old_configure = $e043a94beb31b378$var$_instance.configure;
    $e043a94beb31b378$var$_instance.configure = function(options) {
        $e043a94beb31b378$var$logger.debug('storage configure called');
        var vaultConfig = $e043a94beb31b378$var$__assign({}, old_configure.call($e043a94beb31b378$var$_instance, options));
        // set level private for each provider for the vault
        Object.keys(vaultConfig).forEach(function(providerName) {
            if (typeof vaultConfig[providerName] !== 'string') vaultConfig[providerName] = $e043a94beb31b378$var$__assign($e043a94beb31b378$var$__assign({}, vaultConfig[providerName]), {
                level: 'private'
            });
        });
        $e043a94beb31b378$var$logger.debug('storage vault configure called');
        $e043a94beb31b378$var$_instance.vault.configure(vaultConfig);
    };
    return $e043a94beb31b378$var$_instance;
};
var $e043a94beb31b378$export$bf2a15d34f3c441c = $e043a94beb31b378$var$getInstance();
(0, $9QDF4.Amplify).register($e043a94beb31b378$export$bf2a15d34f3c441c);
var /**
 * @deprecated use named import
 */ $e043a94beb31b378$export$2e2bcd8739ae039 = $e043a94beb31b378$export$bf2a15d34f3c441c;

});
parcelRegister("8Q2P4", function(module, exports) {

$parcel$export(module.exports, "Storage", function () { return $66f55e913f4b52e3$export$bf2a15d34f3c441c; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $l7cio = parcelRequire("l7cio");
var $hmdQp = parcelRequire("hmdQp");

var $au5ft = parcelRequire("au5ft");
var $66f55e913f4b52e3$var$__assign = undefined && undefined.__assign || function() {
    $66f55e913f4b52e3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $66f55e913f4b52e3$var$__assign.apply(this, arguments);
};
var $66f55e913f4b52e3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $66f55e913f4b52e3$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $66f55e913f4b52e3$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $66f55e913f4b52e3$var$logger = new (0, $l7cio.ConsoleLogger)('StorageClass');
var $66f55e913f4b52e3$var$DEFAULT_PROVIDER = 'AWSS3';
/**
 * Provide storage methods to use AWS S3
 */ var $66f55e913f4b52e3$export$bf2a15d34f3c441c = /** @class */ function() {
    /**
     * Initialize Storage
     * @param {Object} config - Configuration object for storage
     */ function Storage() {
        this._config = {};
        this._pluggables = [];
        $66f55e913f4b52e3$var$logger.debug('Storage Options', this._config);
        this.get = this.get.bind(this);
        this.put = this.put.bind(this);
        this.remove = this.remove.bind(this);
        this.list = this.list.bind(this);
    }
    Storage.prototype.getModuleName = function() {
        return 'Storage';
    };
    /**
     * add plugin into Storage category
     * @param {Object} pluggable - an instance of the plugin
     */ Storage.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategory() === 'Storage') {
            this._pluggables.push(pluggable);
            var config = {};
            config = pluggable.configure(this._config[pluggable.getProviderName()]);
            return config;
        }
    };
    /**
     * Get the plugin object
     * @param providerName - the name of the plugin
     */ Storage.prototype.getPluggable = function(providerName) {
        var pluggable = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
        if (pluggable === undefined) {
            $66f55e913f4b52e3$var$logger.debug('No plugin found with providerName', providerName);
            return null;
        } else return pluggable;
    };
    /**
     * Remove the plugin object
     * @param providerName - the name of the plugin
     */ Storage.prototype.removePluggable = function(providerName) {
        this._pluggables = this._pluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        return;
    };
    /**
     * Configure Storage
     * @param {Object} config - Configuration object for storage
     * @return {Object} - Current configuration
     */ Storage.prototype.configure = function(config) {
        var _this = this;
        $66f55e913f4b52e3$var$logger.debug('configure Storage');
        if (!config) return this._config;
        var amplifyConfig = (0, $hmdQp.Parser).parseMobilehubConfig(config);
        var storageKeysFromConfig = Object.keys(amplifyConfig.Storage);
        var storageArrayKeys = [
            'bucket',
            'region',
            'level',
            'track',
            'customPrefix',
            'serverSideEncryption',
            'SSECustomerAlgorithm',
            'SSECustomerKey',
            'SSECustomerKeyMD5',
            'SSEKMSKeyId'
        ];
        var isInStorageArrayKeys = function(k) {
            return storageArrayKeys.some(function(x) {
                return x === k;
            });
        };
        var checkConfigKeysFromArray = function(k) {
            return k.find(function(k) {
                return isInStorageArrayKeys(k);
            });
        };
        if (storageKeysFromConfig && checkConfigKeysFromArray(storageKeysFromConfig) && !amplifyConfig.Storage[$66f55e913f4b52e3$var$DEFAULT_PROVIDER]) amplifyConfig.Storage[$66f55e913f4b52e3$var$DEFAULT_PROVIDER] = {};
        Object.entries(amplifyConfig.Storage).map(function(_a) {
            var _b = $66f55e913f4b52e3$var$__read(_a, 2), key = _b[0], value = _b[1];
            if (key && isInStorageArrayKeys(key) && value !== undefined) {
                amplifyConfig.Storage[$66f55e913f4b52e3$var$DEFAULT_PROVIDER][key] = value;
                delete amplifyConfig.Storage[key];
            }
        });
        // only update new values for each provider
        Object.keys(amplifyConfig.Storage).forEach(function(providerName) {
            if (typeof amplifyConfig.Storage[providerName] !== 'string') _this._config[providerName] = $66f55e913f4b52e3$var$__assign($66f55e913f4b52e3$var$__assign({}, _this._config[providerName]), amplifyConfig.Storage[providerName]);
        });
        this._pluggables.forEach(function(pluggable) {
            pluggable.configure(_this._config[pluggable.getProviderName()]);
        });
        if (this._pluggables.length === 0) this.addPluggable(new (0, $au5ft.AWSS3Provider)());
        return this._config;
    };
    /**
     * Get a presigned URL of the file or the object data when download:true
     *
     * @param {string} key - key of the object
     * @param {Object} [config] - { level : private|protected|public, download: true|false }
     * @return - A promise resolves to either a presigned url or the object
     */ Storage.prototype.get = function(key, config) {
        return $66f55e913f4b52e3$var$__awaiter(this, void 0, void 0, function() {
            var _a, provider, prov;
            return $66f55e913f4b52e3$var$__generator(this, function(_b) {
                _a = (config || {}).provider, provider = _a === void 0 ? $66f55e913f4b52e3$var$DEFAULT_PROVIDER : _a;
                prov = this._pluggables.find(function(pluggable) {
                    return pluggable.getProviderName() === provider;
                });
                if (prov === undefined) {
                    $66f55e913f4b52e3$var$logger.debug('No plugin found with providerName', provider);
                    Promise.reject('No plugin found in Storage for the provider');
                }
                return [
                    2 /*return*/ ,
                    prov.get(key, config)
                ];
            });
        });
    };
    /**
     * Put a file in storage bucket specified to configure method
     * @param {string} key - key of the object
     * @param {Object} object - File to be put in bucket
     * @param {Object} [config] - { level : private|protected|public, contentType: MIME Types,
     *  progressCallback: function }
     * @return - promise resolves to object on success
     */ Storage.prototype.put = function(key, object, config) {
        return $66f55e913f4b52e3$var$__awaiter(this, void 0, void 0, function() {
            var _a, provider, prov;
            return $66f55e913f4b52e3$var$__generator(this, function(_b) {
                _a = (config || {}).provider, provider = _a === void 0 ? $66f55e913f4b52e3$var$DEFAULT_PROVIDER : _a;
                prov = this._pluggables.find(function(pluggable) {
                    return pluggable.getProviderName() === provider;
                });
                if (prov === undefined) {
                    $66f55e913f4b52e3$var$logger.debug('No plugin found with providerName', provider);
                    Promise.reject('No plugin found in Storage for the provider');
                }
                return [
                    2 /*return*/ ,
                    prov.put(key, object, config)
                ];
            });
        });
    };
    /**
     * Remove the object for specified key
     * @param {string} key - key of the object
     * @param {Object} [config] - { level : private|protected|public }
     * @return - Promise resolves upon successful removal of the object
     */ Storage.prototype.remove = function(key, config) {
        return $66f55e913f4b52e3$var$__awaiter(this, void 0, void 0, function() {
            var _a, provider, prov;
            return $66f55e913f4b52e3$var$__generator(this, function(_b) {
                _a = (config || {}).provider, provider = _a === void 0 ? $66f55e913f4b52e3$var$DEFAULT_PROVIDER : _a;
                prov = this._pluggables.find(function(pluggable) {
                    return pluggable.getProviderName() === provider;
                });
                if (prov === undefined) {
                    $66f55e913f4b52e3$var$logger.debug('No plugin found with providerName', provider);
                    Promise.reject('No plugin found in Storage for the provider');
                }
                return [
                    2 /*return*/ ,
                    prov.remove(key, config)
                ];
            });
        });
    };
    /**
     * List bucket objects relative to the level and prefix specified
     * @param {String} path - the path that contains objects
     * @param {Object} [config] - { level : private|protected|public, maxKeys: NUMBER }
     * @return - Promise resolves to list of keys for all objects in path
     */ Storage.prototype.list = function(path, config) {
        return $66f55e913f4b52e3$var$__awaiter(this, void 0, void 0, function() {
            var _a, provider, prov;
            return $66f55e913f4b52e3$var$__generator(this, function(_b) {
                _a = (config || {}).provider, provider = _a === void 0 ? $66f55e913f4b52e3$var$DEFAULT_PROVIDER : _a;
                prov = this._pluggables.find(function(pluggable) {
                    return pluggable.getProviderName() === provider;
                });
                if (prov === undefined) {
                    $66f55e913f4b52e3$var$logger.debug('No plugin found with providerName', provider);
                    Promise.reject('No plugin found in Storage for the provider');
                }
                return [
                    2 /*return*/ ,
                    prov.list(path, config)
                ];
            });
        });
    };
    return Storage;
}();
var /**
 * @deprecated use named import
 */ $66f55e913f4b52e3$export$2e2bcd8739ae039 = $66f55e913f4b52e3$export$bf2a15d34f3c441c;

});
parcelRegister("au5ft", function(module, exports) {

$parcel$export(module.exports, "AWSS3Provider", function () { return $7a20c6fcaff3c814$export$a8628d9eb315b139; });

var $l7cio = parcelRequire("l7cio");
var $ddXoz = parcelRequire("ddXoz");
var $ku8BJ = parcelRequire("ku8BJ");
var $hPjfU = parcelRequire("hPjfU");
var $hmdQp = parcelRequire("hmdQp");

var $1QM7d = parcelRequire("1QM7d");
var $aT9AQ = parcelRequire("aT9AQ");
var $lXAOX = parcelRequire("lXAOX");
var $1UQgc = parcelRequire("1UQgc");

var $32CUT = parcelRequire("32CUT");

var $kyYaq = parcelRequire("kyYaq");
parcelRequire("f1iF4");
var $bhivG = parcelRequire("bhivG");

var $bLBrm = parcelRequire("bLBrm");

var $fpddR = parcelRequire("fpddR");

var $9A2Mr = parcelRequire("9A2Mr");
var $7a20c6fcaff3c814$var$__assign = undefined && undefined.__assign || function() {
    $7a20c6fcaff3c814$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7a20c6fcaff3c814$var$__assign.apply(this, arguments);
};
var $7a20c6fcaff3c814$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7a20c6fcaff3c814$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $7a20c6fcaff3c814$var$logger = new (0, $l7cio.ConsoleLogger)('AWSS3Provider');
var $7a20c6fcaff3c814$var$AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
var $7a20c6fcaff3c814$var$dispatchStorageEvent = function(track, event, attrs, metrics, message) {
    if (track) {
        var data = {
            attrs: attrs
        };
        if (metrics) data['metrics'] = metrics;
        (0, $hPjfU.Hub).dispatch('storage', {
            event: event,
            data: data,
            message: message
        }, 'Storage', $7a20c6fcaff3c814$var$AMPLIFY_SYMBOL);
    }
};
var $7a20c6fcaff3c814$var$localTestingStorageEndpoint = 'http://localhost:20005';
/**
 * Provide storage methods to use AWS S3
 */ var $7a20c6fcaff3c814$export$a8628d9eb315b139 = /** @class */ function() {
    /**
     * Initialize Storage with AWS configurations
     * @param {Object} config - Configuration object for storage
     */ function AWSS3Provider(config) {
        this._config = config ? config : {};
        $7a20c6fcaff3c814$var$logger.debug('Storage Options', this._config);
    }
    /**
     * get the category of the plugin
     */ AWSS3Provider.prototype.getCategory = function() {
        return AWSS3Provider.CATEGORY;
    };
    /**
     * get provider name of the plugin
     */ AWSS3Provider.prototype.getProviderName = function() {
        return AWSS3Provider.PROVIDER_NAME;
    };
    /**
     * Configure Storage part with aws configuration
     * @param {Object} config - Configuration of the Storage
     * @return {Object} - Current configuration
     */ AWSS3Provider.prototype.configure = function(config) {
        $7a20c6fcaff3c814$var$logger.debug('configure Storage', config);
        if (!config) return this._config;
        var amplifyConfig = (0, $hmdQp.Parser).parseMobilehubConfig(config);
        this._config = Object.assign({}, this._config, amplifyConfig.Storage);
        if (!this._config.bucket) $7a20c6fcaff3c814$var$logger.debug('Do not have bucket yet');
        return this._config;
    };
    /**
     * Get a presigned URL of the file or the object data when download:true
     *
     * @param {string} key - key of the object
     * @param {Object} [config] - { level : private|protected|public, download: true|false }
     * @return - A promise resolves to Amazon S3 presigned URL on success
     */ AWSS3Provider.prototype.get = function(key, config) {
        return $7a20c6fcaff3c814$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, download, cacheControl, contentDisposition, contentEncoding, contentLanguage, contentType, expires, track, prefix, final_key, s3, params, getObjectCommand, response, error_1, signer, request, url, _a, error_2;
            return $7a20c6fcaff3c814$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _b.sent();
                        if (!credentialsOK) return [
                            2 /*return*/ ,
                            Promise.reject('No credentials')
                        ];
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, download = opt.download, cacheControl = opt.cacheControl, contentDisposition = opt.contentDisposition, contentEncoding = opt.contentEncoding, contentLanguage = opt.contentLanguage, contentType = opt.contentType, expires = opt.expires, track = opt.track;
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        s3 = this._createNewS3Client(opt);
                        $7a20c6fcaff3c814$var$logger.debug('get ' + key + ' from ' + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        // See: https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/S3.html#getObject-property
                        if (cacheControl) params.ResponseCacheControl = cacheControl;
                        if (contentDisposition) params.ResponseContentDisposition = contentDisposition;
                        if (contentEncoding) params.ResponseContentEncoding = contentEncoding;
                        if (contentLanguage) params.ResponseContentLanguage = contentLanguage;
                        if (contentType) params.ResponseContentType = contentType;
                        if (!(download === true)) return [
                            3 /*break*/ ,
                            5
                        ];
                        getObjectCommand = new (0, $aT9AQ.GetObjectCommand)(params);
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            s3.send(getObjectCommand)
                        ];
                    case 3:
                        response = _b.sent();
                        $7a20c6fcaff3c814$var$dispatchStorageEvent(track, 'download', {
                            method: 'get',
                            result: 'success'
                        }, {
                            fileSize: Number(response.Body['size'] || response.Body['length'])
                        }, "Download success for " + key);
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 4:
                        error_1 = _b.sent();
                        $7a20c6fcaff3c814$var$dispatchStorageEvent(track, 'download', {
                            method: 'get',
                            result: 'failed'
                        }, null, "Download failed with " + error_1.message);
                        throw error_1;
                    case 5:
                        params.Expires = expires || 900; // Default is 15 mins as defined in V2 AWS SDK
                        _b.label = 6;
                    case 6:
                        _b.trys.push([
                            6,
                            9,
                            ,
                            10
                        ]);
                        signer = new (0, $bhivG.S3RequestPresigner)($7a20c6fcaff3c814$var$__assign({}, s3.config));
                        return [
                            4 /*yield*/ ,
                            (0, $kyYaq.createRequest)(s3, new (0, $aT9AQ.GetObjectCommand)(params))
                        ];
                    case 7:
                        request = _b.sent();
                        _a = (0, $32CUT.formatUrl);
                        return [
                            4 /*yield*/ ,
                            signer.presign(request, {
                                expiresIn: params.Expires
                            })
                        ];
                    case 8:
                        url = _a.apply(void 0, [
                            _b.sent()
                        ]);
                        $7a20c6fcaff3c814$var$dispatchStorageEvent(track, 'getSignedUrl', {
                            method: 'get',
                            result: 'success'
                        }, null, "Signed URL: " + url);
                        return [
                            2 /*return*/ ,
                            url
                        ];
                    case 9:
                        error_2 = _b.sent();
                        $7a20c6fcaff3c814$var$logger.warn('get signed url error', error_2);
                        $7a20c6fcaff3c814$var$dispatchStorageEvent(track, 'getSignedUrl', {
                            method: 'get',
                            result: 'failed'
                        }, null, "Could not get a signed URL for " + key);
                        throw error_2;
                    case 10:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Put a file in S3 bucket specified to configure method
     * @param {string} key - key of the object
     * @param {Object} object - File to be put in Amazon S3 bucket
     * @param {Object} [config] - { level : private|protected|public, contentType: MIME Types,
     *  progressCallback: function }
     * @return - promise resolves to object on success
     */ AWSS3Provider.prototype.put = function(key, object, config) {
        return $7a20c6fcaff3c814$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, progressCallback, contentType, contentDisposition, cacheControl, expires, metadata, tagging, acl, serverSideEncryption, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, SSEKMSKeyId, type, prefix, final_key, params, emitter, uploader, response, error_3;
            return $7a20c6fcaff3c814$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) return [
                            2 /*return*/ ,
                            Promise.reject('No credentials')
                        ];
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track, progressCallback = opt.progressCallback;
                        contentType = opt.contentType, contentDisposition = opt.contentDisposition, cacheControl = opt.cacheControl, expires = opt.expires, metadata = opt.metadata, tagging = opt.tagging, acl = opt.acl;
                        serverSideEncryption = opt.serverSideEncryption, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, SSEKMSKeyId = opt.SSEKMSKeyId;
                        type = contentType ? contentType : 'binary/octet-stream';
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        $7a20c6fcaff3c814$var$logger.debug('put ' + key + ' to ' + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key,
                            Body: object,
                            ContentType: type
                        };
                        if (cacheControl) params.CacheControl = cacheControl;
                        if (contentDisposition) params.ContentDisposition = contentDisposition;
                        if (expires) params.Expires = expires;
                        if (metadata) params.Metadata = metadata;
                        if (tagging) params.Tagging = tagging;
                        if (serverSideEncryption) {
                            params.ServerSideEncryption = serverSideEncryption;
                            if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
                            if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
                            if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
                            if (SSEKMSKeyId) params.SSEKMSKeyId = SSEKMSKeyId;
                        }
                        emitter = new $9A2Mr.EventEmitter();
                        uploader = new (0, $fpddR.AWSS3ProviderManagedUpload)(params, opt, emitter);
                        if (acl) params.ACL = acl;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        emitter.on('sendProgress', function(progress) {
                            if (progressCallback) {
                                if (typeof progressCallback === 'function') progressCallback(progress);
                                else $7a20c6fcaff3c814$var$logger.warn('progressCallback should be a function, not a ' + typeof progressCallback);
                            }
                        });
                        return [
                            4 /*yield*/ ,
                            uploader.upload()
                        ];
                    case 3:
                        response = _a.sent();
                        $7a20c6fcaff3c814$var$logger.debug('upload result', response);
                        $7a20c6fcaff3c814$var$dispatchStorageEvent(track, 'upload', {
                            method: 'put',
                            result: 'success'
                        }, null, "Upload success for " + key);
                        return [
                            2 /*return*/ ,
                            {
                                key: key
                            }
                        ];
                    case 4:
                        error_3 = _a.sent();
                        $7a20c6fcaff3c814$var$logger.warn('error uploading', error_3);
                        $7a20c6fcaff3c814$var$dispatchStorageEvent(track, 'upload', {
                            method: 'put',
                            result: 'failed'
                        }, null, "Error uploading " + key);
                        throw error_3;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Remove the object for specified key
     * @param {string} key - key of the object
     * @param {Object} [config] - { level : private|protected|public }
     * @return - Promise resolves upon successful removal of the object
     */ AWSS3Provider.prototype.remove = function(key, config) {
        return $7a20c6fcaff3c814$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, prefix, final_key, s3, params, deleteObjectCommand, response, error_4;
            return $7a20c6fcaff3c814$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) return [
                            2 /*return*/ ,
                            Promise.reject('No credentials')
                        ];
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track;
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        s3 = this._createNewS3Client(opt);
                        $7a20c6fcaff3c814$var$logger.debug('remove ' + key + ' from ' + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        deleteObjectCommand = new (0, $1QM7d.DeleteObjectCommand)(params);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            s3.send(deleteObjectCommand)
                        ];
                    case 3:
                        response = _a.sent();
                        $7a20c6fcaff3c814$var$dispatchStorageEvent(track, 'delete', {
                            method: 'remove',
                            result: 'success'
                        }, null, "Deleted " + key + " successfully");
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 4:
                        error_4 = _a.sent();
                        $7a20c6fcaff3c814$var$dispatchStorageEvent(track, 'delete', {
                            method: 'remove',
                            result: 'failed'
                        }, null, "Deletion of " + key + " failed with " + error_4);
                        throw error_4;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * List bucket objects relative to the level and prefix specified
     * @param {string} path - the path that contains objects
     * @param {Object} [config] - { level : private|protected|public }
     * @return - Promise resolves to list of keys for all objects in path
     */ AWSS3Provider.prototype.list = function(path, config) {
        return $7a20c6fcaff3c814$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, maxKeys, prefix, final_path, s3, params, listObjectsCommand, response, list, error_5;
            return $7a20c6fcaff3c814$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) return [
                            2 /*return*/ ,
                            Promise.reject('No credentials')
                        ];
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track, maxKeys = opt.maxKeys;
                        prefix = this._prefix(opt);
                        final_path = prefix + path;
                        s3 = this._createNewS3Client(opt);
                        $7a20c6fcaff3c814$var$logger.debug('list ' + path + ' from ' + final_path);
                        params = {
                            Bucket: bucket,
                            Prefix: final_path,
                            MaxKeys: maxKeys
                        };
                        listObjectsCommand = new (0, $lXAOX.ListObjectsCommand)(params);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            s3.send(listObjectsCommand)
                        ];
                    case 3:
                        response = _a.sent();
                        list = [];
                        if (response && response.Contents) list = response.Contents.map(function(item) {
                            return {
                                key: item.Key.substr(prefix.length),
                                eTag: item.ETag,
                                lastModified: item.LastModified,
                                size: item.Size
                            };
                        });
                        $7a20c6fcaff3c814$var$dispatchStorageEvent(track, 'list', {
                            method: 'list',
                            result: 'success'
                        }, null, list.length + " items returned from list operation");
                        $7a20c6fcaff3c814$var$logger.debug('list', list);
                        return [
                            2 /*return*/ ,
                            list
                        ];
                    case 4:
                        error_5 = _a.sent();
                        $7a20c6fcaff3c814$var$logger.warn('list error', error_5);
                        $7a20c6fcaff3c814$var$dispatchStorageEvent(track, 'list', {
                            method: 'list',
                            result: 'failed'
                        }, null, "Listing items failed: " + error_5.message);
                        throw error_5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * @private
     */ AWSS3Provider.prototype._ensureCredentials = function() {
        var _this = this;
        return (0, $ddXoz.Credentials).get().then(function(credentials) {
            if (!credentials) return false;
            var cred = (0, $ddXoz.Credentials).shear(credentials);
            $7a20c6fcaff3c814$var$logger.debug('set credentials for storage', cred);
            _this._config.credentials = cred;
            return true;
        }).catch(function(error) {
            $7a20c6fcaff3c814$var$logger.warn('ensure credentials error', error);
            return false;
        });
    };
    /**
     * @private
     */ AWSS3Provider.prototype._prefix = function(config) {
        var credentials = config.credentials, level = config.level;
        var customPrefix = config.customPrefix || {};
        var identityId = config.identityId || credentials.identityId;
        var privatePath = (customPrefix.private !== undefined ? customPrefix.private : 'private/') + identityId + '/';
        var protectedPath = (customPrefix.protected !== undefined ? customPrefix.protected : 'protected/') + identityId + '/';
        var publicPath = customPrefix.public !== undefined ? customPrefix.public : 'public/';
        switch(level){
            case 'private':
                return privatePath;
            case 'protected':
                return protectedPath;
            default:
                return publicPath;
        }
    };
    /**
     * @private creates an S3 client with new V3 aws sdk
     */ AWSS3Provider.prototype._createNewS3Client = function(config, emitter) {
        var region = config.region, credentials = config.credentials, dangerouslyConnectToHttpEndpointForTesting = config.dangerouslyConnectToHttpEndpointForTesting;
        var localTestingConfig = {};
        if (dangerouslyConnectToHttpEndpointForTesting) localTestingConfig = {
            endpoint: $7a20c6fcaff3c814$var$localTestingStorageEndpoint,
            tls: false,
            bucketEndpoint: false,
            forcePathStyle: true
        };
        var s3client = new (0, $1UQgc.S3Client)($7a20c6fcaff3c814$var$__assign($7a20c6fcaff3c814$var$__assign({
            region: region,
            credentials: credentials,
            customUserAgent: (0, $ku8BJ.getAmplifyUserAgent)()
        }, localTestingConfig), {
            requestHandler: new (0, $bLBrm.AxiosHttpHandler)({}, emitter)
        }));
        return s3client;
    };
    AWSS3Provider.CATEGORY = 'Storage';
    AWSS3Provider.PROVIDER_NAME = 'AWSS3';
    return AWSS3Provider;
}();
var /**
 * @deprecated use named import
 */ $7a20c6fcaff3c814$export$2e2bcd8739ae039 = $7a20c6fcaff3c814$export$a8628d9eb315b139;

});
parcelRegister("1QM7d", function(module, exports) {

$parcel$export(module.exports, "DeleteObjectCommand", function () { return $158ff87cef4c3390$export$d60592d05571c4ef; });

var $9OyH6 = parcelRequire("9OyH6");

var $lLFWX = parcelRequire("lLFWX");

var $6RHn6 = parcelRequire("6RHn6");
parcelRequire("238LE");
var $1yBqn = parcelRequire("1yBqn");
parcelRequire("5Wom8");
var $jU8uG = parcelRequire("jU8uG");
parcelRequire("fF6iB");
var $koeHb = parcelRequire("koeHb");
var $158ff87cef4c3390$export$d60592d05571c4ef = /** @class */ function(_super) {
    (0, $9OyH6.__extends)(DeleteObjectCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteObjectCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    DeleteObjectCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $jU8uG.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $1yBqn.getBucketEndpointPlugin)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "DeleteObjectCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $lLFWX.DeleteObjectRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $lLFWX.DeleteObjectOutput).filterSensitiveLog
        };
        if (typeof logger.info === "function") logger.info({
            clientName: clientName,
            commandName: commandName
        });
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteObjectCommand.prototype.serialize = function(input, context) {
        return (0, $6RHn6.serializeAws_restXmlDeleteObjectCommand)(input, context);
    };
    DeleteObjectCommand.prototype.deserialize = function(output, context) {
        return (0, $6RHn6.deserializeAws_restXmlDeleteObjectCommand)(output, context);
    };
    return DeleteObjectCommand;
}((0, $koeHb.Command));

});
parcelRegister("9OyH6", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $7253b21be442db11$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $7253b21be442db11$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__awaiter", function () { return $7253b21be442db11$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $7253b21be442db11$export$67ebef60e6f28a6; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $7253b21be442db11$var$extendStatics = function(d, b) {
    $7253b21be442db11$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $7253b21be442db11$var$extendStatics(d, b);
};
function $7253b21be442db11$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $7253b21be442db11$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $7253b21be442db11$export$18ce0697a983be9b = function() {
    $7253b21be442db11$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7253b21be442db11$export$18ce0697a983be9b.apply(this, arguments);
};
function $7253b21be442db11$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $7253b21be442db11$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $7253b21be442db11$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $7253b21be442db11$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $7253b21be442db11$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $7253b21be442db11$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $7253b21be442db11$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $7253b21be442db11$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $7253b21be442db11$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $7253b21be442db11$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $7253b21be442db11$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $7253b21be442db11$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $7253b21be442db11$export$45d3717a4c69092e(o, m, p);
}
function $7253b21be442db11$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $7253b21be442db11$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $7253b21be442db11$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($7253b21be442db11$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $7253b21be442db11$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $7253b21be442db11$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $7253b21be442db11$export$10c90e4f7922046c(v) {
    return this instanceof $7253b21be442db11$export$10c90e4f7922046c ? (this.v = v, this) : new $7253b21be442db11$export$10c90e4f7922046c(v);
}
function $7253b21be442db11$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $7253b21be442db11$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $7253b21be442db11$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $7253b21be442db11$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $7253b21be442db11$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $7253b21be442db11$export$19a8beecd37a4c45 === "function" ? $7253b21be442db11$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $7253b21be442db11$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $7253b21be442db11$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $7253b21be442db11$var$ownKeys = function(o) {
    $7253b21be442db11$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $7253b21be442db11$var$ownKeys(o);
};
function $7253b21be442db11$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $7253b21be442db11$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $7253b21be442db11$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $7253b21be442db11$var$__setModuleDefault(result, mod);
    return result;
}
function $7253b21be442db11$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $7253b21be442db11$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $7253b21be442db11$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $7253b21be442db11$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $7253b21be442db11$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $7253b21be442db11$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $7253b21be442db11$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $7253b21be442db11$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $7253b21be442db11$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $7253b21be442db11$export$2e2bcd8739ae039 = {
    __extends: $7253b21be442db11$export$a8ba968b8961cb8a,
    __assign: $7253b21be442db11$export$18ce0697a983be9b,
    __rest: $7253b21be442db11$export$3c9a16f847548506,
    __decorate: $7253b21be442db11$export$29e00dfd3077644b,
    __param: $7253b21be442db11$export$d5ad3fd78186038f,
    __esDecorate: $7253b21be442db11$export$3a84e1ae4e97e9b0,
    __runInitializers: $7253b21be442db11$export$d831c04e792af3d,
    __propKey: $7253b21be442db11$export$6a2a36740a146cb8,
    __setFunctionName: $7253b21be442db11$export$d1a06452d3489bc7,
    __metadata: $7253b21be442db11$export$f1db080c865becb9,
    __awaiter: $7253b21be442db11$export$1050f835b63b671e,
    __generator: $7253b21be442db11$export$67ebef60e6f28a6,
    __createBinding: $7253b21be442db11$export$45d3717a4c69092e,
    __exportStar: $7253b21be442db11$export$f33643c0debef087,
    __values: $7253b21be442db11$export$19a8beecd37a4c45,
    __read: $7253b21be442db11$export$8d051b38c9118094,
    __spread: $7253b21be442db11$export$afc72e2116322959,
    __spreadArrays: $7253b21be442db11$export$6388937ca91ccae8,
    __spreadArray: $7253b21be442db11$export$1216008129fb82ed,
    __await: $7253b21be442db11$export$10c90e4f7922046c,
    __asyncGenerator: $7253b21be442db11$export$e427f37a30a4de9b,
    __asyncDelegator: $7253b21be442db11$export$bbd80228419bb833,
    __asyncValues: $7253b21be442db11$export$e3b29a3d6162315f,
    __makeTemplateObject: $7253b21be442db11$export$4fb47efe1390b86f,
    __importStar: $7253b21be442db11$export$c21735bcef00d192,
    __importDefault: $7253b21be442db11$export$da59b14a69baef04,
    __classPrivateFieldGet: $7253b21be442db11$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $7253b21be442db11$export$d40a35129aaff81f,
    __classPrivateFieldIn: $7253b21be442db11$export$81fdc39f203e4e04,
    __addDisposableResource: $7253b21be442db11$export$88ac25d8e944e405,
    __disposeResources: $7253b21be442db11$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $7253b21be442db11$export$889dfb5d17574b0b
};

});

parcelRegister("lLFWX", function(module, exports) {

$parcel$export(module.exports, "AbortMultipartUploadOutput", function () { return $fd8e87282214b013$export$80a5621784397e06; });
$parcel$export(module.exports, "AbortMultipartUploadRequest", function () { return $fd8e87282214b013$export$2509116d04cdd782; });
$parcel$export(module.exports, "CompleteMultipartUploadOutput", function () { return $fd8e87282214b013$export$edcc5df28126c9bc; });
$parcel$export(module.exports, "CompleteMultipartUploadRequest", function () { return $fd8e87282214b013$export$2998881f143b41ec; });
$parcel$export(module.exports, "CreateMultipartUploadOutput", function () { return $fd8e87282214b013$export$196bb0482ff68428; });
$parcel$export(module.exports, "CreateMultipartUploadRequest", function () { return $fd8e87282214b013$export$f65faae2a46e45c2; });
$parcel$export(module.exports, "DeleteObjectOutput", function () { return $fd8e87282214b013$export$64d4f4fac943bc25; });
$parcel$export(module.exports, "DeleteObjectRequest", function () { return $fd8e87282214b013$export$7d123f24a24f15cf; });
$parcel$export(module.exports, "GetObjectOutput", function () { return $fd8e87282214b013$export$9fb6bec1a5c954d6; });
$parcel$export(module.exports, "GetObjectRequest", function () { return $fd8e87282214b013$export$3373ea9743883feb; });
$parcel$export(module.exports, "ListObjectsOutput", function () { return $fd8e87282214b013$export$bd5de99c03e50bdf; });
$parcel$export(module.exports, "ListObjectsRequest", function () { return $fd8e87282214b013$export$b17e2bd91a04aa76; });
$parcel$export(module.exports, "ListPartsOutput", function () { return $fd8e87282214b013$export$8c83b46649a5c089; });
$parcel$export(module.exports, "ListPartsRequest", function () { return $fd8e87282214b013$export$756cf37efa2403e6; });
$parcel$export(module.exports, "PutObjectOutput", function () { return $fd8e87282214b013$export$792cedced515bdbd; });
$parcel$export(module.exports, "PutObjectRequest", function () { return $fd8e87282214b013$export$90c5c1bf0f634d21; });
$parcel$export(module.exports, "OutputLocation", function () { return $fd8e87282214b013$export$cc3fbbd78713fc6c; });

var $9OyH6 = parcelRequire("9OyH6");
parcelRequire("fF6iB");
var $gouPX = parcelRequire("gouPX");
var $fd8e87282214b013$export$ff1e75b1e93a2588;
(function(AbortIncompleteMultipartUpload) {
    AbortIncompleteMultipartUpload.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$ff1e75b1e93a2588 || ($fd8e87282214b013$export$ff1e75b1e93a2588 = {}));
var $fd8e87282214b013$export$80a5621784397e06;
(function(AbortMultipartUploadOutput) {
    AbortMultipartUploadOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$80a5621784397e06 || ($fd8e87282214b013$export$80a5621784397e06 = {}));
var $fd8e87282214b013$export$2509116d04cdd782;
(function(AbortMultipartUploadRequest) {
    AbortMultipartUploadRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$2509116d04cdd782 || ($fd8e87282214b013$export$2509116d04cdd782 = {}));
var $fd8e87282214b013$export$1de06065cff890a8;
(function(NoSuchUpload) {
    NoSuchUpload.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$1de06065cff890a8 || ($fd8e87282214b013$export$1de06065cff890a8 = {}));
var $fd8e87282214b013$export$b73224f1e3e6ea55;
(function(AccelerateConfiguration) {
    AccelerateConfiguration.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$b73224f1e3e6ea55 || ($fd8e87282214b013$export$b73224f1e3e6ea55 = {}));
var $fd8e87282214b013$export$4882adf346b33e1a;
(function(Grantee) {
    Grantee.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$4882adf346b33e1a || ($fd8e87282214b013$export$4882adf346b33e1a = {}));
var $fd8e87282214b013$export$16844950929e022f;
(function(Grant) {
    Grant.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$16844950929e022f || ($fd8e87282214b013$export$16844950929e022f = {}));
var $fd8e87282214b013$export$25fb39c3824c9c44;
(function(Owner) {
    Owner.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$25fb39c3824c9c44 || ($fd8e87282214b013$export$25fb39c3824c9c44 = {}));
var $fd8e87282214b013$export$6a42fa102a072c77;
(function(AccessControlPolicy) {
    AccessControlPolicy.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$6a42fa102a072c77 || ($fd8e87282214b013$export$6a42fa102a072c77 = {}));
var $fd8e87282214b013$export$3db5322b6b5badd4;
(function(AccessControlTranslation) {
    AccessControlTranslation.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$3db5322b6b5badd4 || ($fd8e87282214b013$export$3db5322b6b5badd4 = {}));
var $fd8e87282214b013$export$edcc5df28126c9bc;
(function(CompleteMultipartUploadOutput) {
    CompleteMultipartUploadOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $gouPX.SENSITIVE_STRING)
        });
    };
})($fd8e87282214b013$export$edcc5df28126c9bc || ($fd8e87282214b013$export$edcc5df28126c9bc = {}));
var $fd8e87282214b013$export$76f56660c9039ec5;
(function(CompletedPart) {
    CompletedPart.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$76f56660c9039ec5 || ($fd8e87282214b013$export$76f56660c9039ec5 = {}));
var $fd8e87282214b013$export$394f3a16361c2a83;
(function(CompletedMultipartUpload) {
    CompletedMultipartUpload.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$394f3a16361c2a83 || ($fd8e87282214b013$export$394f3a16361c2a83 = {}));
var $fd8e87282214b013$export$2998881f143b41ec;
(function(CompleteMultipartUploadRequest) {
    CompleteMultipartUploadRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$2998881f143b41ec || ($fd8e87282214b013$export$2998881f143b41ec = {}));
var $fd8e87282214b013$export$32f1916074d2607f;
(function(CopyObjectResult) {
    CopyObjectResult.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$32f1916074d2607f || ($fd8e87282214b013$export$32f1916074d2607f = {}));
var $fd8e87282214b013$export$a9f99871811ebc49;
(function(CopyObjectOutput) {
    CopyObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $gouPX.SENSITIVE_STRING)
        }), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $gouPX.SENSITIVE_STRING)
        });
    };
})($fd8e87282214b013$export$a9f99871811ebc49 || ($fd8e87282214b013$export$a9f99871811ebc49 = {}));
var $fd8e87282214b013$export$e84f0e76c8b259eb;
(function(CopyObjectRequest) {
    CopyObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $gouPX.SENSITIVE_STRING)
        }), obj.SSECustomerKey && {
            SSECustomerKey: (0, $gouPX.SENSITIVE_STRING)
        }), obj.CopySourceSSECustomerKey && {
            CopySourceSSECustomerKey: (0, $gouPX.SENSITIVE_STRING)
        }), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $gouPX.SENSITIVE_STRING)
        });
    };
})($fd8e87282214b013$export$e84f0e76c8b259eb || ($fd8e87282214b013$export$e84f0e76c8b259eb = {}));
var $fd8e87282214b013$export$77615b2f7cde9dd7;
(function(ObjectNotInActiveTierError) {
    ObjectNotInActiveTierError.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$77615b2f7cde9dd7 || ($fd8e87282214b013$export$77615b2f7cde9dd7 = {}));
var $fd8e87282214b013$export$b6b374c2bfd60422;
(function(BucketAlreadyExists) {
    BucketAlreadyExists.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$b6b374c2bfd60422 || ($fd8e87282214b013$export$b6b374c2bfd60422 = {}));
var $fd8e87282214b013$export$3d44152d602e5b07;
(function(BucketAlreadyOwnedByYou) {
    BucketAlreadyOwnedByYou.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$3d44152d602e5b07 || ($fd8e87282214b013$export$3d44152d602e5b07 = {}));
var $fd8e87282214b013$export$b9395efd4905ea2f;
(function(CreateBucketOutput) {
    CreateBucketOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$b9395efd4905ea2f || ($fd8e87282214b013$export$b9395efd4905ea2f = {}));
var $fd8e87282214b013$export$80fb9034e13a84f5;
(function(CreateBucketConfiguration) {
    CreateBucketConfiguration.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$80fb9034e13a84f5 || ($fd8e87282214b013$export$80fb9034e13a84f5 = {}));
var $fd8e87282214b013$export$8aca1806c1d8d130;
(function(CreateBucketRequest) {
    CreateBucketRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$8aca1806c1d8d130 || ($fd8e87282214b013$export$8aca1806c1d8d130 = {}));
var $fd8e87282214b013$export$196bb0482ff68428;
(function(CreateMultipartUploadOutput) {
    CreateMultipartUploadOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $gouPX.SENSITIVE_STRING)
        }), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $gouPX.SENSITIVE_STRING)
        });
    };
})($fd8e87282214b013$export$196bb0482ff68428 || ($fd8e87282214b013$export$196bb0482ff68428 = {}));
var $fd8e87282214b013$export$f65faae2a46e45c2;
(function(CreateMultipartUploadRequest) {
    CreateMultipartUploadRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $gouPX.SENSITIVE_STRING)
        }), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $gouPX.SENSITIVE_STRING)
        }), obj.SSECustomerKey && {
            SSECustomerKey: (0, $gouPX.SENSITIVE_STRING)
        });
    };
})($fd8e87282214b013$export$f65faae2a46e45c2 || ($fd8e87282214b013$export$f65faae2a46e45c2 = {}));
var $fd8e87282214b013$export$8b74a2c46a921740;
(function(DeleteBucketRequest) {
    DeleteBucketRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$8b74a2c46a921740 || ($fd8e87282214b013$export$8b74a2c46a921740 = {}));
var $fd8e87282214b013$export$c5ab088f35618173;
(function(DeleteBucketAnalyticsConfigurationRequest) {
    DeleteBucketAnalyticsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$c5ab088f35618173 || ($fd8e87282214b013$export$c5ab088f35618173 = {}));
var $fd8e87282214b013$export$eedf1d80102f9cff;
(function(DeleteBucketCorsRequest) {
    DeleteBucketCorsRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$eedf1d80102f9cff || ($fd8e87282214b013$export$eedf1d80102f9cff = {}));
var $fd8e87282214b013$export$67cbcb88080a155a;
(function(DeleteBucketEncryptionRequest) {
    DeleteBucketEncryptionRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$67cbcb88080a155a || ($fd8e87282214b013$export$67cbcb88080a155a = {}));
var $fd8e87282214b013$export$3603c2e1b3558471;
(function(DeleteBucketInventoryConfigurationRequest) {
    DeleteBucketInventoryConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$3603c2e1b3558471 || ($fd8e87282214b013$export$3603c2e1b3558471 = {}));
var $fd8e87282214b013$export$6c38b78c3c77b60c;
(function(DeleteBucketLifecycleRequest) {
    DeleteBucketLifecycleRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$6c38b78c3c77b60c || ($fd8e87282214b013$export$6c38b78c3c77b60c = {}));
var $fd8e87282214b013$export$ff4b8fc3fb36fbd;
(function(DeleteBucketMetricsConfigurationRequest) {
    DeleteBucketMetricsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$ff4b8fc3fb36fbd || ($fd8e87282214b013$export$ff4b8fc3fb36fbd = {}));
var $fd8e87282214b013$export$4c49e000fa5b0b86;
(function(DeleteBucketOwnershipControlsRequest) {
    DeleteBucketOwnershipControlsRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$4c49e000fa5b0b86 || ($fd8e87282214b013$export$4c49e000fa5b0b86 = {}));
var $fd8e87282214b013$export$cce16146386a1316;
(function(DeleteBucketPolicyRequest) {
    DeleteBucketPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$cce16146386a1316 || ($fd8e87282214b013$export$cce16146386a1316 = {}));
var $fd8e87282214b013$export$238256546e65e80f;
(function(DeleteBucketReplicationRequest) {
    DeleteBucketReplicationRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$238256546e65e80f || ($fd8e87282214b013$export$238256546e65e80f = {}));
var $fd8e87282214b013$export$e9cefd124b305be3;
(function(DeleteBucketTaggingRequest) {
    DeleteBucketTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$e9cefd124b305be3 || ($fd8e87282214b013$export$e9cefd124b305be3 = {}));
var $fd8e87282214b013$export$15e654f934b26a7b;
(function(DeleteBucketWebsiteRequest) {
    DeleteBucketWebsiteRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$15e654f934b26a7b || ($fd8e87282214b013$export$15e654f934b26a7b = {}));
var $fd8e87282214b013$export$64d4f4fac943bc25;
(function(DeleteObjectOutput) {
    DeleteObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$64d4f4fac943bc25 || ($fd8e87282214b013$export$64d4f4fac943bc25 = {}));
var $fd8e87282214b013$export$7d123f24a24f15cf;
(function(DeleteObjectRequest) {
    DeleteObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$7d123f24a24f15cf || ($fd8e87282214b013$export$7d123f24a24f15cf = {}));
var $fd8e87282214b013$export$d17347461b0f9a2b;
(function(DeletedObject) {
    DeletedObject.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$d17347461b0f9a2b || ($fd8e87282214b013$export$d17347461b0f9a2b = {}));
var $fd8e87282214b013$export$afd90478dc782af0;
(function(_Error) {
    _Error.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$afd90478dc782af0 || ($fd8e87282214b013$export$afd90478dc782af0 = {}));
var $fd8e87282214b013$export$e1c86a39185a896f;
(function(DeleteObjectsOutput) {
    DeleteObjectsOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$e1c86a39185a896f || ($fd8e87282214b013$export$e1c86a39185a896f = {}));
var $fd8e87282214b013$export$84d9d258efc6700d;
(function(ObjectIdentifier) {
    ObjectIdentifier.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$84d9d258efc6700d || ($fd8e87282214b013$export$84d9d258efc6700d = {}));
var $fd8e87282214b013$export$bfadae053a633538;
(function(Delete) {
    Delete.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$bfadae053a633538 || ($fd8e87282214b013$export$bfadae053a633538 = {}));
var $fd8e87282214b013$export$c19f81fd3ccd8fc2;
(function(DeleteObjectsRequest) {
    DeleteObjectsRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$c19f81fd3ccd8fc2 || ($fd8e87282214b013$export$c19f81fd3ccd8fc2 = {}));
var $fd8e87282214b013$export$4d816bf2553d6082;
(function(DeleteObjectTaggingOutput) {
    DeleteObjectTaggingOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$4d816bf2553d6082 || ($fd8e87282214b013$export$4d816bf2553d6082 = {}));
var $fd8e87282214b013$export$2d561b57455087e8;
(function(DeleteObjectTaggingRequest) {
    DeleteObjectTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$2d561b57455087e8 || ($fd8e87282214b013$export$2d561b57455087e8 = {}));
var $fd8e87282214b013$export$cac29ea1b5d93b5d;
(function(DeletePublicAccessBlockRequest) {
    DeletePublicAccessBlockRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$cac29ea1b5d93b5d || ($fd8e87282214b013$export$cac29ea1b5d93b5d = {}));
var $fd8e87282214b013$export$d592399f8c69d061;
(function(GetBucketAccelerateConfigurationOutput) {
    GetBucketAccelerateConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$d592399f8c69d061 || ($fd8e87282214b013$export$d592399f8c69d061 = {}));
var $fd8e87282214b013$export$c2ed0589b585987a;
(function(GetBucketAccelerateConfigurationRequest) {
    GetBucketAccelerateConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$c2ed0589b585987a || ($fd8e87282214b013$export$c2ed0589b585987a = {}));
var $fd8e87282214b013$export$1e656ec1fa0dbccd;
(function(GetBucketAclOutput) {
    GetBucketAclOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$1e656ec1fa0dbccd || ($fd8e87282214b013$export$1e656ec1fa0dbccd = {}));
var $fd8e87282214b013$export$5543bf3f517c214;
(function(GetBucketAclRequest) {
    GetBucketAclRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$5543bf3f517c214 || ($fd8e87282214b013$export$5543bf3f517c214 = {}));
var $fd8e87282214b013$export$3288d34c523a1192;
(function(Tag) {
    Tag.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$3288d34c523a1192 || ($fd8e87282214b013$export$3288d34c523a1192 = {}));
var $fd8e87282214b013$export$b9ae9bceb2811d5d;
(function(AnalyticsAndOperator) {
    AnalyticsAndOperator.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$b9ae9bceb2811d5d || ($fd8e87282214b013$export$b9ae9bceb2811d5d = {}));
var $fd8e87282214b013$export$c9ec61557dcb764a;
(function(AnalyticsFilter) {
    AnalyticsFilter.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$c9ec61557dcb764a || ($fd8e87282214b013$export$c9ec61557dcb764a = {}));
var $fd8e87282214b013$export$fc566d9f8f854701;
(function(AnalyticsS3BucketDestination) {
    AnalyticsS3BucketDestination.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$fc566d9f8f854701 || ($fd8e87282214b013$export$fc566d9f8f854701 = {}));
var $fd8e87282214b013$export$20f751b8dcd24833;
(function(AnalyticsExportDestination) {
    AnalyticsExportDestination.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$20f751b8dcd24833 || ($fd8e87282214b013$export$20f751b8dcd24833 = {}));
var $fd8e87282214b013$export$a14156deb587d512;
(function(StorageClassAnalysisDataExport) {
    StorageClassAnalysisDataExport.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$a14156deb587d512 || ($fd8e87282214b013$export$a14156deb587d512 = {}));
var $fd8e87282214b013$export$13f5184561469c95;
(function(StorageClassAnalysis) {
    StorageClassAnalysis.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$13f5184561469c95 || ($fd8e87282214b013$export$13f5184561469c95 = {}));
var $fd8e87282214b013$export$15f94404a081a771;
(function(AnalyticsConfiguration) {
    AnalyticsConfiguration.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$15f94404a081a771 || ($fd8e87282214b013$export$15f94404a081a771 = {}));
var $fd8e87282214b013$export$32ac99bb59e9ea35;
(function(GetBucketAnalyticsConfigurationOutput) {
    GetBucketAnalyticsConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$32ac99bb59e9ea35 || ($fd8e87282214b013$export$32ac99bb59e9ea35 = {}));
var $fd8e87282214b013$export$a4b635f541d39c02;
(function(GetBucketAnalyticsConfigurationRequest) {
    GetBucketAnalyticsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$a4b635f541d39c02 || ($fd8e87282214b013$export$a4b635f541d39c02 = {}));
var $fd8e87282214b013$export$483798435237259b;
(function(CORSRule) {
    CORSRule.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$483798435237259b || ($fd8e87282214b013$export$483798435237259b = {}));
var $fd8e87282214b013$export$3ff8c9c489aa7ab5;
(function(GetBucketCorsOutput) {
    GetBucketCorsOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$3ff8c9c489aa7ab5 || ($fd8e87282214b013$export$3ff8c9c489aa7ab5 = {}));
var $fd8e87282214b013$export$cdc36c4a20d66833;
(function(GetBucketCorsRequest) {
    GetBucketCorsRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$cdc36c4a20d66833 || ($fd8e87282214b013$export$cdc36c4a20d66833 = {}));
var $fd8e87282214b013$export$5e055b8b357210fd;
(function(ServerSideEncryptionByDefault) {
    ServerSideEncryptionByDefault.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.KMSMasterKeyID && {
            KMSMasterKeyID: (0, $gouPX.SENSITIVE_STRING)
        });
    };
})($fd8e87282214b013$export$5e055b8b357210fd || ($fd8e87282214b013$export$5e055b8b357210fd = {}));
var $fd8e87282214b013$export$614e3b57594b8702;
(function(ServerSideEncryptionRule) {
    ServerSideEncryptionRule.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.ApplyServerSideEncryptionByDefault && {
            ApplyServerSideEncryptionByDefault: $fd8e87282214b013$export$5e055b8b357210fd.filterSensitiveLog(obj.ApplyServerSideEncryptionByDefault)
        });
    };
})($fd8e87282214b013$export$614e3b57594b8702 || ($fd8e87282214b013$export$614e3b57594b8702 = {}));
var $fd8e87282214b013$export$d53e5f9e3c3507bf;
(function(ServerSideEncryptionConfiguration) {
    ServerSideEncryptionConfiguration.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.Rules && {
            Rules: obj.Rules.map(function(item) {
                return $fd8e87282214b013$export$614e3b57594b8702.filterSensitiveLog(item);
            })
        });
    };
})($fd8e87282214b013$export$d53e5f9e3c3507bf || ($fd8e87282214b013$export$d53e5f9e3c3507bf = {}));
var $fd8e87282214b013$export$a5d815db4065bb4e;
(function(GetBucketEncryptionOutput) {
    GetBucketEncryptionOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.ServerSideEncryptionConfiguration && {
            ServerSideEncryptionConfiguration: $fd8e87282214b013$export$d53e5f9e3c3507bf.filterSensitiveLog(obj.ServerSideEncryptionConfiguration)
        });
    };
})($fd8e87282214b013$export$a5d815db4065bb4e || ($fd8e87282214b013$export$a5d815db4065bb4e = {}));
var $fd8e87282214b013$export$3871e35cee114580;
(function(GetBucketEncryptionRequest) {
    GetBucketEncryptionRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$3871e35cee114580 || ($fd8e87282214b013$export$3871e35cee114580 = {}));
var $fd8e87282214b013$export$51ca0161a096cac2;
(function(SSEKMS) {
    SSEKMS.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.KeyId && {
            KeyId: (0, $gouPX.SENSITIVE_STRING)
        });
    };
})($fd8e87282214b013$export$51ca0161a096cac2 || ($fd8e87282214b013$export$51ca0161a096cac2 = {}));
var $fd8e87282214b013$export$e6fda754462bc5e9;
(function(SSES3) {
    SSES3.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$e6fda754462bc5e9 || ($fd8e87282214b013$export$e6fda754462bc5e9 = {}));
var $fd8e87282214b013$export$4507106f7965dad8;
(function(InventoryEncryption) {
    InventoryEncryption.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.SSEKMS && {
            SSEKMS: $fd8e87282214b013$export$51ca0161a096cac2.filterSensitiveLog(obj.SSEKMS)
        });
    };
})($fd8e87282214b013$export$4507106f7965dad8 || ($fd8e87282214b013$export$4507106f7965dad8 = {}));
var $fd8e87282214b013$export$dbf61758afa382d2;
(function(InventoryS3BucketDestination) {
    InventoryS3BucketDestination.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.Encryption && {
            Encryption: $fd8e87282214b013$export$4507106f7965dad8.filterSensitiveLog(obj.Encryption)
        });
    };
})($fd8e87282214b013$export$dbf61758afa382d2 || ($fd8e87282214b013$export$dbf61758afa382d2 = {}));
var $fd8e87282214b013$export$95a07687ea92cc86;
(function(InventoryDestination) {
    InventoryDestination.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.S3BucketDestination && {
            S3BucketDestination: $fd8e87282214b013$export$dbf61758afa382d2.filterSensitiveLog(obj.S3BucketDestination)
        });
    };
})($fd8e87282214b013$export$95a07687ea92cc86 || ($fd8e87282214b013$export$95a07687ea92cc86 = {}));
var $fd8e87282214b013$export$9cab1f8eb4898ac3;
(function(InventoryFilter) {
    InventoryFilter.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$9cab1f8eb4898ac3 || ($fd8e87282214b013$export$9cab1f8eb4898ac3 = {}));
var $fd8e87282214b013$export$80a40dd3d0e79f33;
(function(InventorySchedule) {
    InventorySchedule.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$80a40dd3d0e79f33 || ($fd8e87282214b013$export$80a40dd3d0e79f33 = {}));
var $fd8e87282214b013$export$e13e8ea2fe7b5717;
(function(InventoryConfiguration) {
    InventoryConfiguration.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.Destination && {
            Destination: $fd8e87282214b013$export$95a07687ea92cc86.filterSensitiveLog(obj.Destination)
        });
    };
})($fd8e87282214b013$export$e13e8ea2fe7b5717 || ($fd8e87282214b013$export$e13e8ea2fe7b5717 = {}));
var $fd8e87282214b013$export$4b7c0b968f94593a;
(function(GetBucketInventoryConfigurationOutput) {
    GetBucketInventoryConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.InventoryConfiguration && {
            InventoryConfiguration: $fd8e87282214b013$export$e13e8ea2fe7b5717.filterSensitiveLog(obj.InventoryConfiguration)
        });
    };
})($fd8e87282214b013$export$4b7c0b968f94593a || ($fd8e87282214b013$export$4b7c0b968f94593a = {}));
var $fd8e87282214b013$export$2bcb6519092e8dbf;
(function(GetBucketInventoryConfigurationRequest) {
    GetBucketInventoryConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$2bcb6519092e8dbf || ($fd8e87282214b013$export$2bcb6519092e8dbf = {}));
var $fd8e87282214b013$export$87e69778058ef73d;
(function(LifecycleExpiration) {
    LifecycleExpiration.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$87e69778058ef73d || ($fd8e87282214b013$export$87e69778058ef73d = {}));
var $fd8e87282214b013$export$70a8e907770d2a36;
(function(LifecycleRuleAndOperator) {
    LifecycleRuleAndOperator.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$70a8e907770d2a36 || ($fd8e87282214b013$export$70a8e907770d2a36 = {}));
var $fd8e87282214b013$export$4338dba1e93ddaf4;
(function(LifecycleRuleFilter) {
    LifecycleRuleFilter.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$4338dba1e93ddaf4 || ($fd8e87282214b013$export$4338dba1e93ddaf4 = {}));
var $fd8e87282214b013$export$a99742a437d0fdf9;
(function(NoncurrentVersionExpiration) {
    NoncurrentVersionExpiration.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$a99742a437d0fdf9 || ($fd8e87282214b013$export$a99742a437d0fdf9 = {}));
var $fd8e87282214b013$export$9250e73c985ce931;
(function(NoncurrentVersionTransition) {
    NoncurrentVersionTransition.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$9250e73c985ce931 || ($fd8e87282214b013$export$9250e73c985ce931 = {}));
var $fd8e87282214b013$export$be58926105124dd4;
(function(Transition) {
    Transition.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$be58926105124dd4 || ($fd8e87282214b013$export$be58926105124dd4 = {}));
var $fd8e87282214b013$export$1ac30bbe41f1f9ef;
(function(LifecycleRule) {
    LifecycleRule.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$1ac30bbe41f1f9ef || ($fd8e87282214b013$export$1ac30bbe41f1f9ef = {}));
var $fd8e87282214b013$export$f2f23f80c8c1c7c4;
(function(GetBucketLifecycleConfigurationOutput) {
    GetBucketLifecycleConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$f2f23f80c8c1c7c4 || ($fd8e87282214b013$export$f2f23f80c8c1c7c4 = {}));
var $fd8e87282214b013$export$86e3489ab08ca98d;
(function(GetBucketLifecycleConfigurationRequest) {
    GetBucketLifecycleConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$86e3489ab08ca98d || ($fd8e87282214b013$export$86e3489ab08ca98d = {}));
var $fd8e87282214b013$export$ed9828a2500d585f;
(function(GetBucketLocationOutput) {
    GetBucketLocationOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$ed9828a2500d585f || ($fd8e87282214b013$export$ed9828a2500d585f = {}));
var $fd8e87282214b013$export$4109a69a89893a5d;
(function(GetBucketLocationRequest) {
    GetBucketLocationRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$4109a69a89893a5d || ($fd8e87282214b013$export$4109a69a89893a5d = {}));
var $fd8e87282214b013$export$cf4abd6ae8fde913;
(function(TargetGrant) {
    TargetGrant.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$cf4abd6ae8fde913 || ($fd8e87282214b013$export$cf4abd6ae8fde913 = {}));
var $fd8e87282214b013$export$a1484d354b9c56b2;
(function(LoggingEnabled) {
    LoggingEnabled.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$a1484d354b9c56b2 || ($fd8e87282214b013$export$a1484d354b9c56b2 = {}));
var $fd8e87282214b013$export$f9d2a0e32a2aa91f;
(function(GetBucketLoggingOutput) {
    GetBucketLoggingOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$f9d2a0e32a2aa91f || ($fd8e87282214b013$export$f9d2a0e32a2aa91f = {}));
var $fd8e87282214b013$export$182d23383f8b69bd;
(function(GetBucketLoggingRequest) {
    GetBucketLoggingRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$182d23383f8b69bd || ($fd8e87282214b013$export$182d23383f8b69bd = {}));
var $fd8e87282214b013$export$4774797e6eda832;
(function(MetricsAndOperator) {
    MetricsAndOperator.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$4774797e6eda832 || ($fd8e87282214b013$export$4774797e6eda832 = {}));
var $fd8e87282214b013$export$564a1f9c338cae45;
(function(MetricsFilter) {
    MetricsFilter.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$564a1f9c338cae45 || ($fd8e87282214b013$export$564a1f9c338cae45 = {}));
var $fd8e87282214b013$export$908bafa154008a5e;
(function(MetricsConfiguration) {
    MetricsConfiguration.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$908bafa154008a5e || ($fd8e87282214b013$export$908bafa154008a5e = {}));
var $fd8e87282214b013$export$a52baffc56d738d2;
(function(GetBucketMetricsConfigurationOutput) {
    GetBucketMetricsConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$a52baffc56d738d2 || ($fd8e87282214b013$export$a52baffc56d738d2 = {}));
var $fd8e87282214b013$export$af907f7627ae4ae9;
(function(GetBucketMetricsConfigurationRequest) {
    GetBucketMetricsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$af907f7627ae4ae9 || ($fd8e87282214b013$export$af907f7627ae4ae9 = {}));
var $fd8e87282214b013$export$f00ac87a35076252;
(function(GetBucketNotificationConfigurationRequest) {
    GetBucketNotificationConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$f00ac87a35076252 || ($fd8e87282214b013$export$f00ac87a35076252 = {}));
var $fd8e87282214b013$export$74fc6120f048b9bc;
(function(FilterRule) {
    FilterRule.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$74fc6120f048b9bc || ($fd8e87282214b013$export$74fc6120f048b9bc = {}));
var $fd8e87282214b013$export$46101b74c47ec83a;
(function(S3KeyFilter) {
    S3KeyFilter.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$46101b74c47ec83a || ($fd8e87282214b013$export$46101b74c47ec83a = {}));
var $fd8e87282214b013$export$c3d4fc0e09105ced;
(function(NotificationConfigurationFilter) {
    NotificationConfigurationFilter.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$c3d4fc0e09105ced || ($fd8e87282214b013$export$c3d4fc0e09105ced = {}));
var $fd8e87282214b013$export$4916e52bc544d4ef;
(function(LambdaFunctionConfiguration) {
    LambdaFunctionConfiguration.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$4916e52bc544d4ef || ($fd8e87282214b013$export$4916e52bc544d4ef = {}));
var $fd8e87282214b013$export$b48f9efe98802c25;
(function(QueueConfiguration) {
    QueueConfiguration.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$b48f9efe98802c25 || ($fd8e87282214b013$export$b48f9efe98802c25 = {}));
var $fd8e87282214b013$export$c98b07f3d2e31343;
(function(TopicConfiguration) {
    TopicConfiguration.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$c98b07f3d2e31343 || ($fd8e87282214b013$export$c98b07f3d2e31343 = {}));
var $fd8e87282214b013$export$165cf006a6abc4b3;
(function(NotificationConfiguration) {
    NotificationConfiguration.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$165cf006a6abc4b3 || ($fd8e87282214b013$export$165cf006a6abc4b3 = {}));
var $fd8e87282214b013$export$403b2dc6ec5b8d13;
(function(OwnershipControlsRule) {
    OwnershipControlsRule.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$403b2dc6ec5b8d13 || ($fd8e87282214b013$export$403b2dc6ec5b8d13 = {}));
var $fd8e87282214b013$export$ae516ccf061cd7d1;
(function(OwnershipControls) {
    OwnershipControls.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$ae516ccf061cd7d1 || ($fd8e87282214b013$export$ae516ccf061cd7d1 = {}));
var $fd8e87282214b013$export$bb1e71315d618124;
(function(GetBucketOwnershipControlsOutput) {
    GetBucketOwnershipControlsOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$bb1e71315d618124 || ($fd8e87282214b013$export$bb1e71315d618124 = {}));
var $fd8e87282214b013$export$55fbc6554b27a2f6;
(function(GetBucketOwnershipControlsRequest) {
    GetBucketOwnershipControlsRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$55fbc6554b27a2f6 || ($fd8e87282214b013$export$55fbc6554b27a2f6 = {}));
var $fd8e87282214b013$export$29a8c95926d10996;
(function(GetBucketPolicyOutput) {
    GetBucketPolicyOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$29a8c95926d10996 || ($fd8e87282214b013$export$29a8c95926d10996 = {}));
var $fd8e87282214b013$export$fde59d57a80f46c6;
(function(GetBucketPolicyRequest) {
    GetBucketPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$fde59d57a80f46c6 || ($fd8e87282214b013$export$fde59d57a80f46c6 = {}));
var $fd8e87282214b013$export$77c4d21e3fd2b633;
(function(PolicyStatus) {
    PolicyStatus.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$77c4d21e3fd2b633 || ($fd8e87282214b013$export$77c4d21e3fd2b633 = {}));
var $fd8e87282214b013$export$c9cb93f92e1c4228;
(function(GetBucketPolicyStatusOutput) {
    GetBucketPolicyStatusOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$c9cb93f92e1c4228 || ($fd8e87282214b013$export$c9cb93f92e1c4228 = {}));
var $fd8e87282214b013$export$2e3b292047386a35;
(function(GetBucketPolicyStatusRequest) {
    GetBucketPolicyStatusRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$2e3b292047386a35 || ($fd8e87282214b013$export$2e3b292047386a35 = {}));
var $fd8e87282214b013$export$594f35c535ed76a3;
(function(DeleteMarkerReplication) {
    DeleteMarkerReplication.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$594f35c535ed76a3 || ($fd8e87282214b013$export$594f35c535ed76a3 = {}));
var $fd8e87282214b013$export$949641a4ad7f11d4;
(function(EncryptionConfiguration) {
    EncryptionConfiguration.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$949641a4ad7f11d4 || ($fd8e87282214b013$export$949641a4ad7f11d4 = {}));
var $fd8e87282214b013$export$d9823a04d7ef0d38;
(function(ReplicationTimeValue) {
    ReplicationTimeValue.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$d9823a04d7ef0d38 || ($fd8e87282214b013$export$d9823a04d7ef0d38 = {}));
var $fd8e87282214b013$export$ed9166ec0f465b5e;
(function(Metrics) {
    Metrics.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$ed9166ec0f465b5e || ($fd8e87282214b013$export$ed9166ec0f465b5e = {}));
var $fd8e87282214b013$export$666325b7ed44b812;
(function(ReplicationTime) {
    ReplicationTime.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$666325b7ed44b812 || ($fd8e87282214b013$export$666325b7ed44b812 = {}));
var $fd8e87282214b013$export$5c4bdf44e1e9cea1;
(function(Destination) {
    Destination.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$5c4bdf44e1e9cea1 || ($fd8e87282214b013$export$5c4bdf44e1e9cea1 = {}));
var $fd8e87282214b013$export$18e0c6d9cc0aaef5;
(function(ExistingObjectReplication) {
    ExistingObjectReplication.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$18e0c6d9cc0aaef5 || ($fd8e87282214b013$export$18e0c6d9cc0aaef5 = {}));
var $fd8e87282214b013$export$f149404143b7fc4f;
(function(ReplicationRuleAndOperator) {
    ReplicationRuleAndOperator.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$f149404143b7fc4f || ($fd8e87282214b013$export$f149404143b7fc4f = {}));
var $fd8e87282214b013$export$c5652b893758d9eb;
(function(ReplicationRuleFilter) {
    ReplicationRuleFilter.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$c5652b893758d9eb || ($fd8e87282214b013$export$c5652b893758d9eb = {}));
var $fd8e87282214b013$export$d6dbaa0624096385;
(function(SseKmsEncryptedObjects) {
    SseKmsEncryptedObjects.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$d6dbaa0624096385 || ($fd8e87282214b013$export$d6dbaa0624096385 = {}));
var $fd8e87282214b013$export$8f4bdf07a780e3ac;
(function(SourceSelectionCriteria) {
    SourceSelectionCriteria.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$8f4bdf07a780e3ac || ($fd8e87282214b013$export$8f4bdf07a780e3ac = {}));
var $fd8e87282214b013$export$4ef0a2a837294f64;
(function(ReplicationRule) {
    ReplicationRule.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$4ef0a2a837294f64 || ($fd8e87282214b013$export$4ef0a2a837294f64 = {}));
var $fd8e87282214b013$export$74f8efd37d5209b2;
(function(ReplicationConfiguration) {
    ReplicationConfiguration.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$74f8efd37d5209b2 || ($fd8e87282214b013$export$74f8efd37d5209b2 = {}));
var $fd8e87282214b013$export$8ec47a87cc54e339;
(function(GetBucketReplicationOutput) {
    GetBucketReplicationOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$8ec47a87cc54e339 || ($fd8e87282214b013$export$8ec47a87cc54e339 = {}));
var $fd8e87282214b013$export$e8f64af8ca33bbfd;
(function(GetBucketReplicationRequest) {
    GetBucketReplicationRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$e8f64af8ca33bbfd || ($fd8e87282214b013$export$e8f64af8ca33bbfd = {}));
var $fd8e87282214b013$export$8b846c4a43a75e9e;
(function(GetBucketRequestPaymentOutput) {
    GetBucketRequestPaymentOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$8b846c4a43a75e9e || ($fd8e87282214b013$export$8b846c4a43a75e9e = {}));
var $fd8e87282214b013$export$a3b6600fe888f873;
(function(GetBucketRequestPaymentRequest) {
    GetBucketRequestPaymentRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$a3b6600fe888f873 || ($fd8e87282214b013$export$a3b6600fe888f873 = {}));
var $fd8e87282214b013$export$b794c693046ccc37;
(function(GetBucketTaggingOutput) {
    GetBucketTaggingOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$b794c693046ccc37 || ($fd8e87282214b013$export$b794c693046ccc37 = {}));
var $fd8e87282214b013$export$4cb4643c20453b75;
(function(GetBucketTaggingRequest) {
    GetBucketTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$4cb4643c20453b75 || ($fd8e87282214b013$export$4cb4643c20453b75 = {}));
var $fd8e87282214b013$export$6f458e80d9a168b;
(function(GetBucketVersioningOutput) {
    GetBucketVersioningOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$6f458e80d9a168b || ($fd8e87282214b013$export$6f458e80d9a168b = {}));
var $fd8e87282214b013$export$199936fd6251213c;
(function(GetBucketVersioningRequest) {
    GetBucketVersioningRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$199936fd6251213c || ($fd8e87282214b013$export$199936fd6251213c = {}));
var $fd8e87282214b013$export$4afca95d558fb444;
(function(ErrorDocument) {
    ErrorDocument.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$4afca95d558fb444 || ($fd8e87282214b013$export$4afca95d558fb444 = {}));
var $fd8e87282214b013$export$c07750ef20ad8d6c;
(function(IndexDocument) {
    IndexDocument.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$c07750ef20ad8d6c || ($fd8e87282214b013$export$c07750ef20ad8d6c = {}));
var $fd8e87282214b013$export$98dc4d8bbaac5b7c;
(function(RedirectAllRequestsTo) {
    RedirectAllRequestsTo.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$98dc4d8bbaac5b7c || ($fd8e87282214b013$export$98dc4d8bbaac5b7c = {}));
var $fd8e87282214b013$export$fcea0b2db26e6b18;
(function(Condition) {
    Condition.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$fcea0b2db26e6b18 || ($fd8e87282214b013$export$fcea0b2db26e6b18 = {}));
var $fd8e87282214b013$export$2d8d895a0a0f636e;
(function(Redirect) {
    Redirect.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$2d8d895a0a0f636e || ($fd8e87282214b013$export$2d8d895a0a0f636e = {}));
var $fd8e87282214b013$export$6464c2c4399038e2;
(function(RoutingRule) {
    RoutingRule.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$6464c2c4399038e2 || ($fd8e87282214b013$export$6464c2c4399038e2 = {}));
var $fd8e87282214b013$export$4632dcd1018fd6bd;
(function(GetBucketWebsiteOutput) {
    GetBucketWebsiteOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$4632dcd1018fd6bd || ($fd8e87282214b013$export$4632dcd1018fd6bd = {}));
var $fd8e87282214b013$export$b51e2df1df27d690;
(function(GetBucketWebsiteRequest) {
    GetBucketWebsiteRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$b51e2df1df27d690 || ($fd8e87282214b013$export$b51e2df1df27d690 = {}));
var $fd8e87282214b013$export$9fb6bec1a5c954d6;
(function(GetObjectOutput) {
    GetObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $gouPX.SENSITIVE_STRING)
        });
    };
})($fd8e87282214b013$export$9fb6bec1a5c954d6 || ($fd8e87282214b013$export$9fb6bec1a5c954d6 = {}));
var $fd8e87282214b013$export$3373ea9743883feb;
(function(GetObjectRequest) {
    GetObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $gouPX.SENSITIVE_STRING)
        });
    };
})($fd8e87282214b013$export$3373ea9743883feb || ($fd8e87282214b013$export$3373ea9743883feb = {}));
var $fd8e87282214b013$export$1f6f8c73c651f3ca;
(function(NoSuchKey) {
    NoSuchKey.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$1f6f8c73c651f3ca || ($fd8e87282214b013$export$1f6f8c73c651f3ca = {}));
var $fd8e87282214b013$export$7c40a2227fecdc12;
(function(GetObjectAclOutput) {
    GetObjectAclOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$7c40a2227fecdc12 || ($fd8e87282214b013$export$7c40a2227fecdc12 = {}));
var $fd8e87282214b013$export$cb1a4ad2e0f38f95;
(function(GetObjectAclRequest) {
    GetObjectAclRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$cb1a4ad2e0f38f95 || ($fd8e87282214b013$export$cb1a4ad2e0f38f95 = {}));
var $fd8e87282214b013$export$f3dff23941310d9;
(function(ObjectLockLegalHold) {
    ObjectLockLegalHold.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$f3dff23941310d9 || ($fd8e87282214b013$export$f3dff23941310d9 = {}));
var $fd8e87282214b013$export$9939dc80bbea1acd;
(function(GetObjectLegalHoldOutput) {
    GetObjectLegalHoldOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$9939dc80bbea1acd || ($fd8e87282214b013$export$9939dc80bbea1acd = {}));
var $fd8e87282214b013$export$5f8862ba76850511;
(function(GetObjectLegalHoldRequest) {
    GetObjectLegalHoldRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$5f8862ba76850511 || ($fd8e87282214b013$export$5f8862ba76850511 = {}));
var $fd8e87282214b013$export$705dac3c9e25f673;
(function(DefaultRetention) {
    DefaultRetention.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$705dac3c9e25f673 || ($fd8e87282214b013$export$705dac3c9e25f673 = {}));
var $fd8e87282214b013$export$62ac1d02f31163e0;
(function(ObjectLockRule) {
    ObjectLockRule.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$62ac1d02f31163e0 || ($fd8e87282214b013$export$62ac1d02f31163e0 = {}));
var $fd8e87282214b013$export$262d239426342c96;
(function(ObjectLockConfiguration) {
    ObjectLockConfiguration.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$262d239426342c96 || ($fd8e87282214b013$export$262d239426342c96 = {}));
var $fd8e87282214b013$export$486dc804d3714e8e;
(function(GetObjectLockConfigurationOutput) {
    GetObjectLockConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$486dc804d3714e8e || ($fd8e87282214b013$export$486dc804d3714e8e = {}));
var $fd8e87282214b013$export$43efa1cb9cbd5c84;
(function(GetObjectLockConfigurationRequest) {
    GetObjectLockConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$43efa1cb9cbd5c84 || ($fd8e87282214b013$export$43efa1cb9cbd5c84 = {}));
var $fd8e87282214b013$export$a0bcf720e4ebfa6b;
(function(ObjectLockRetention) {
    ObjectLockRetention.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$a0bcf720e4ebfa6b || ($fd8e87282214b013$export$a0bcf720e4ebfa6b = {}));
var $fd8e87282214b013$export$5a061f69fa492eee;
(function(GetObjectRetentionOutput) {
    GetObjectRetentionOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$5a061f69fa492eee || ($fd8e87282214b013$export$5a061f69fa492eee = {}));
var $fd8e87282214b013$export$bd618fd4d0be1150;
(function(GetObjectRetentionRequest) {
    GetObjectRetentionRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$bd618fd4d0be1150 || ($fd8e87282214b013$export$bd618fd4d0be1150 = {}));
var $fd8e87282214b013$export$21e84ade4ffc813f;
(function(GetObjectTaggingOutput) {
    GetObjectTaggingOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$21e84ade4ffc813f || ($fd8e87282214b013$export$21e84ade4ffc813f = {}));
var $fd8e87282214b013$export$e8c3f2a82ba22432;
(function(GetObjectTaggingRequest) {
    GetObjectTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$e8c3f2a82ba22432 || ($fd8e87282214b013$export$e8c3f2a82ba22432 = {}));
var $fd8e87282214b013$export$c7be7807f0a3eea;
(function(GetObjectTorrentOutput) {
    GetObjectTorrentOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$c7be7807f0a3eea || ($fd8e87282214b013$export$c7be7807f0a3eea = {}));
var $fd8e87282214b013$export$93e32e1b0e5460eb;
(function(GetObjectTorrentRequest) {
    GetObjectTorrentRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$93e32e1b0e5460eb || ($fd8e87282214b013$export$93e32e1b0e5460eb = {}));
var $fd8e87282214b013$export$d5abbb05d727be20;
(function(PublicAccessBlockConfiguration) {
    PublicAccessBlockConfiguration.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$d5abbb05d727be20 || ($fd8e87282214b013$export$d5abbb05d727be20 = {}));
var $fd8e87282214b013$export$3606af58a9ffe87;
(function(GetPublicAccessBlockOutput) {
    GetPublicAccessBlockOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$3606af58a9ffe87 || ($fd8e87282214b013$export$3606af58a9ffe87 = {}));
var $fd8e87282214b013$export$f768b28d574460bb;
(function(GetPublicAccessBlockRequest) {
    GetPublicAccessBlockRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$f768b28d574460bb || ($fd8e87282214b013$export$f768b28d574460bb = {}));
var $fd8e87282214b013$export$ce473fe6d5e62bdd;
(function(HeadBucketRequest) {
    HeadBucketRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$ce473fe6d5e62bdd || ($fd8e87282214b013$export$ce473fe6d5e62bdd = {}));
var $fd8e87282214b013$export$bbe89283205bd874;
(function(NoSuchBucket) {
    NoSuchBucket.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$bbe89283205bd874 || ($fd8e87282214b013$export$bbe89283205bd874 = {}));
var $fd8e87282214b013$export$fd185f7330520684;
(function(HeadObjectOutput) {
    HeadObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $gouPX.SENSITIVE_STRING)
        });
    };
})($fd8e87282214b013$export$fd185f7330520684 || ($fd8e87282214b013$export$fd185f7330520684 = {}));
var $fd8e87282214b013$export$e9eaca65791fc4c;
(function(HeadObjectRequest) {
    HeadObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $gouPX.SENSITIVE_STRING)
        });
    };
})($fd8e87282214b013$export$e9eaca65791fc4c || ($fd8e87282214b013$export$e9eaca65791fc4c = {}));
var $fd8e87282214b013$export$cccced7f72820034;
(function(ListBucketAnalyticsConfigurationsOutput) {
    ListBucketAnalyticsConfigurationsOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$cccced7f72820034 || ($fd8e87282214b013$export$cccced7f72820034 = {}));
var $fd8e87282214b013$export$397b8f33cb9cfc07;
(function(ListBucketAnalyticsConfigurationsRequest) {
    ListBucketAnalyticsConfigurationsRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$397b8f33cb9cfc07 || ($fd8e87282214b013$export$397b8f33cb9cfc07 = {}));
var $fd8e87282214b013$export$9e6dae27db161fe4;
(function(ListBucketInventoryConfigurationsOutput) {
    ListBucketInventoryConfigurationsOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.InventoryConfigurationList && {
            InventoryConfigurationList: obj.InventoryConfigurationList.map(function(item) {
                return $fd8e87282214b013$export$e13e8ea2fe7b5717.filterSensitiveLog(item);
            })
        });
    };
})($fd8e87282214b013$export$9e6dae27db161fe4 || ($fd8e87282214b013$export$9e6dae27db161fe4 = {}));
var $fd8e87282214b013$export$443f8cd22179a9b7;
(function(ListBucketInventoryConfigurationsRequest) {
    ListBucketInventoryConfigurationsRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$443f8cd22179a9b7 || ($fd8e87282214b013$export$443f8cd22179a9b7 = {}));
var $fd8e87282214b013$export$a94e91ae224bc393;
(function(ListBucketMetricsConfigurationsOutput) {
    ListBucketMetricsConfigurationsOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$a94e91ae224bc393 || ($fd8e87282214b013$export$a94e91ae224bc393 = {}));
var $fd8e87282214b013$export$18bea5a661e91351;
(function(ListBucketMetricsConfigurationsRequest) {
    ListBucketMetricsConfigurationsRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$18bea5a661e91351 || ($fd8e87282214b013$export$18bea5a661e91351 = {}));
var $fd8e87282214b013$export$356eb44c374cfc19;
(function(Bucket) {
    Bucket.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$356eb44c374cfc19 || ($fd8e87282214b013$export$356eb44c374cfc19 = {}));
var $fd8e87282214b013$export$fb68aea51fc1aaa8;
(function(ListBucketsOutput) {
    ListBucketsOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$fb68aea51fc1aaa8 || ($fd8e87282214b013$export$fb68aea51fc1aaa8 = {}));
var $fd8e87282214b013$export$70a8419756bd30c7;
(function(CommonPrefix) {
    CommonPrefix.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$70a8419756bd30c7 || ($fd8e87282214b013$export$70a8419756bd30c7 = {}));
var $fd8e87282214b013$export$f2cea2a27584e4aa;
(function(Initiator) {
    Initiator.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$f2cea2a27584e4aa || ($fd8e87282214b013$export$f2cea2a27584e4aa = {}));
var $fd8e87282214b013$export$60e639cfe2512bff;
(function(MultipartUpload) {
    MultipartUpload.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$60e639cfe2512bff || ($fd8e87282214b013$export$60e639cfe2512bff = {}));
var $fd8e87282214b013$export$ed83d15740b9f76d;
(function(ListMultipartUploadsOutput) {
    ListMultipartUploadsOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$ed83d15740b9f76d || ($fd8e87282214b013$export$ed83d15740b9f76d = {}));
var $fd8e87282214b013$export$d96c3e2cf9803f5e;
(function(ListMultipartUploadsRequest) {
    ListMultipartUploadsRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$d96c3e2cf9803f5e || ($fd8e87282214b013$export$d96c3e2cf9803f5e = {}));
var $fd8e87282214b013$export$dcacc4a8f6015c36;
(function(_Object) {
    _Object.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$dcacc4a8f6015c36 || ($fd8e87282214b013$export$dcacc4a8f6015c36 = {}));
var $fd8e87282214b013$export$bd5de99c03e50bdf;
(function(ListObjectsOutput) {
    ListObjectsOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$bd5de99c03e50bdf || ($fd8e87282214b013$export$bd5de99c03e50bdf = {}));
var $fd8e87282214b013$export$b17e2bd91a04aa76;
(function(ListObjectsRequest) {
    ListObjectsRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$b17e2bd91a04aa76 || ($fd8e87282214b013$export$b17e2bd91a04aa76 = {}));
var $fd8e87282214b013$export$6fb2827b4fe28be3;
(function(ListObjectsV2Output) {
    ListObjectsV2Output.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$6fb2827b4fe28be3 || ($fd8e87282214b013$export$6fb2827b4fe28be3 = {}));
var $fd8e87282214b013$export$32fa6adfa8e5165a;
(function(ListObjectsV2Request) {
    ListObjectsV2Request.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$32fa6adfa8e5165a || ($fd8e87282214b013$export$32fa6adfa8e5165a = {}));
var $fd8e87282214b013$export$a834fe68df71f671;
(function(DeleteMarkerEntry) {
    DeleteMarkerEntry.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$a834fe68df71f671 || ($fd8e87282214b013$export$a834fe68df71f671 = {}));
var $fd8e87282214b013$export$3288b5b55ddbb34f;
(function(ObjectVersion) {
    ObjectVersion.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$3288b5b55ddbb34f || ($fd8e87282214b013$export$3288b5b55ddbb34f = {}));
var $fd8e87282214b013$export$4037923dade2a143;
(function(ListObjectVersionsOutput) {
    ListObjectVersionsOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$4037923dade2a143 || ($fd8e87282214b013$export$4037923dade2a143 = {}));
var $fd8e87282214b013$export$7420470087543a24;
(function(ListObjectVersionsRequest) {
    ListObjectVersionsRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$7420470087543a24 || ($fd8e87282214b013$export$7420470087543a24 = {}));
var $fd8e87282214b013$export$7b5bf7981d51054e;
(function(Part) {
    Part.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$7b5bf7981d51054e || ($fd8e87282214b013$export$7b5bf7981d51054e = {}));
var $fd8e87282214b013$export$8c83b46649a5c089;
(function(ListPartsOutput) {
    ListPartsOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$8c83b46649a5c089 || ($fd8e87282214b013$export$8c83b46649a5c089 = {}));
var $fd8e87282214b013$export$756cf37efa2403e6;
(function(ListPartsRequest) {
    ListPartsRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$756cf37efa2403e6 || ($fd8e87282214b013$export$756cf37efa2403e6 = {}));
var $fd8e87282214b013$export$95f02e50cfd87383;
(function(PutBucketAccelerateConfigurationRequest) {
    PutBucketAccelerateConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$95f02e50cfd87383 || ($fd8e87282214b013$export$95f02e50cfd87383 = {}));
var $fd8e87282214b013$export$15919ea85d7751db;
(function(PutBucketAclRequest) {
    PutBucketAclRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$15919ea85d7751db || ($fd8e87282214b013$export$15919ea85d7751db = {}));
var $fd8e87282214b013$export$b29e71de1c43092d;
(function(PutBucketAnalyticsConfigurationRequest) {
    PutBucketAnalyticsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$b29e71de1c43092d || ($fd8e87282214b013$export$b29e71de1c43092d = {}));
var $fd8e87282214b013$export$4efc44a8f577c4c6;
(function(CORSConfiguration) {
    CORSConfiguration.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$4efc44a8f577c4c6 || ($fd8e87282214b013$export$4efc44a8f577c4c6 = {}));
var $fd8e87282214b013$export$48388c72802bf3b4;
(function(PutBucketCorsRequest) {
    PutBucketCorsRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$48388c72802bf3b4 || ($fd8e87282214b013$export$48388c72802bf3b4 = {}));
var $fd8e87282214b013$export$b9464fee92783639;
(function(PutBucketEncryptionRequest) {
    PutBucketEncryptionRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.ServerSideEncryptionConfiguration && {
            ServerSideEncryptionConfiguration: $fd8e87282214b013$export$d53e5f9e3c3507bf.filterSensitiveLog(obj.ServerSideEncryptionConfiguration)
        });
    };
})($fd8e87282214b013$export$b9464fee92783639 || ($fd8e87282214b013$export$b9464fee92783639 = {}));
var $fd8e87282214b013$export$7bce979f7abe4f73;
(function(PutBucketInventoryConfigurationRequest) {
    PutBucketInventoryConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.InventoryConfiguration && {
            InventoryConfiguration: $fd8e87282214b013$export$e13e8ea2fe7b5717.filterSensitiveLog(obj.InventoryConfiguration)
        });
    };
})($fd8e87282214b013$export$7bce979f7abe4f73 || ($fd8e87282214b013$export$7bce979f7abe4f73 = {}));
var $fd8e87282214b013$export$2bad5a8856023522;
(function(BucketLifecycleConfiguration) {
    BucketLifecycleConfiguration.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$2bad5a8856023522 || ($fd8e87282214b013$export$2bad5a8856023522 = {}));
var $fd8e87282214b013$export$b1f1a3c5136805f6;
(function(PutBucketLifecycleConfigurationRequest) {
    PutBucketLifecycleConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$b1f1a3c5136805f6 || ($fd8e87282214b013$export$b1f1a3c5136805f6 = {}));
var $fd8e87282214b013$export$c183b06f38322f46;
(function(BucketLoggingStatus) {
    BucketLoggingStatus.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$c183b06f38322f46 || ($fd8e87282214b013$export$c183b06f38322f46 = {}));
var $fd8e87282214b013$export$b7513dc0595a23bf;
(function(PutBucketLoggingRequest) {
    PutBucketLoggingRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$b7513dc0595a23bf || ($fd8e87282214b013$export$b7513dc0595a23bf = {}));
var $fd8e87282214b013$export$848d3e19e2b6526f;
(function(PutBucketMetricsConfigurationRequest) {
    PutBucketMetricsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$848d3e19e2b6526f || ($fd8e87282214b013$export$848d3e19e2b6526f = {}));
var $fd8e87282214b013$export$832249f88bdec051;
(function(PutBucketNotificationConfigurationRequest) {
    PutBucketNotificationConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$832249f88bdec051 || ($fd8e87282214b013$export$832249f88bdec051 = {}));
var $fd8e87282214b013$export$dd5b80748bfa876c;
(function(PutBucketOwnershipControlsRequest) {
    PutBucketOwnershipControlsRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$dd5b80748bfa876c || ($fd8e87282214b013$export$dd5b80748bfa876c = {}));
var $fd8e87282214b013$export$a3745e522d5251e6;
(function(PutBucketPolicyRequest) {
    PutBucketPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$a3745e522d5251e6 || ($fd8e87282214b013$export$a3745e522d5251e6 = {}));
var $fd8e87282214b013$export$80d3d606687bccbe;
(function(PutBucketReplicationRequest) {
    PutBucketReplicationRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$80d3d606687bccbe || ($fd8e87282214b013$export$80d3d606687bccbe = {}));
var $fd8e87282214b013$export$5b5564785205c8b6;
(function(RequestPaymentConfiguration) {
    RequestPaymentConfiguration.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$5b5564785205c8b6 || ($fd8e87282214b013$export$5b5564785205c8b6 = {}));
var $fd8e87282214b013$export$efe882c45e4d54c5;
(function(PutBucketRequestPaymentRequest) {
    PutBucketRequestPaymentRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$efe882c45e4d54c5 || ($fd8e87282214b013$export$efe882c45e4d54c5 = {}));
var $fd8e87282214b013$export$2c6436847badca04;
(function(Tagging) {
    Tagging.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$2c6436847badca04 || ($fd8e87282214b013$export$2c6436847badca04 = {}));
var $fd8e87282214b013$export$907025fe881c3d35;
(function(PutBucketTaggingRequest) {
    PutBucketTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$907025fe881c3d35 || ($fd8e87282214b013$export$907025fe881c3d35 = {}));
var $fd8e87282214b013$export$12496b4e466310a9;
(function(VersioningConfiguration) {
    VersioningConfiguration.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$12496b4e466310a9 || ($fd8e87282214b013$export$12496b4e466310a9 = {}));
var $fd8e87282214b013$export$b342a4ff3cacc8f6;
(function(PutBucketVersioningRequest) {
    PutBucketVersioningRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$b342a4ff3cacc8f6 || ($fd8e87282214b013$export$b342a4ff3cacc8f6 = {}));
var $fd8e87282214b013$export$aec172fe960d640d;
(function(WebsiteConfiguration) {
    WebsiteConfiguration.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$aec172fe960d640d || ($fd8e87282214b013$export$aec172fe960d640d = {}));
var $fd8e87282214b013$export$98e48334698c13d8;
(function(PutBucketWebsiteRequest) {
    PutBucketWebsiteRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$98e48334698c13d8 || ($fd8e87282214b013$export$98e48334698c13d8 = {}));
var $fd8e87282214b013$export$792cedced515bdbd;
(function(PutObjectOutput) {
    PutObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $gouPX.SENSITIVE_STRING)
        }), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $gouPX.SENSITIVE_STRING)
        });
    };
})($fd8e87282214b013$export$792cedced515bdbd || ($fd8e87282214b013$export$792cedced515bdbd = {}));
var $fd8e87282214b013$export$90c5c1bf0f634d21;
(function(PutObjectRequest) {
    PutObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $gouPX.SENSITIVE_STRING)
        }), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $gouPX.SENSITIVE_STRING)
        }), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $gouPX.SENSITIVE_STRING)
        });
    };
})($fd8e87282214b013$export$90c5c1bf0f634d21 || ($fd8e87282214b013$export$90c5c1bf0f634d21 = {}));
var $fd8e87282214b013$export$e533775617728d56;
(function(PutObjectAclOutput) {
    PutObjectAclOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$e533775617728d56 || ($fd8e87282214b013$export$e533775617728d56 = {}));
var $fd8e87282214b013$export$3dc01ad48475bf08;
(function(PutObjectAclRequest) {
    PutObjectAclRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$3dc01ad48475bf08 || ($fd8e87282214b013$export$3dc01ad48475bf08 = {}));
var $fd8e87282214b013$export$d9144478e705d522;
(function(PutObjectLegalHoldOutput) {
    PutObjectLegalHoldOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$d9144478e705d522 || ($fd8e87282214b013$export$d9144478e705d522 = {}));
var $fd8e87282214b013$export$71c3c7a041df44ca;
(function(PutObjectLegalHoldRequest) {
    PutObjectLegalHoldRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$71c3c7a041df44ca || ($fd8e87282214b013$export$71c3c7a041df44ca = {}));
var $fd8e87282214b013$export$93f296cba8bc1760;
(function(PutObjectLockConfigurationOutput) {
    PutObjectLockConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$93f296cba8bc1760 || ($fd8e87282214b013$export$93f296cba8bc1760 = {}));
var $fd8e87282214b013$export$693145724507a617;
(function(PutObjectLockConfigurationRequest) {
    PutObjectLockConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$693145724507a617 || ($fd8e87282214b013$export$693145724507a617 = {}));
var $fd8e87282214b013$export$edd40f596f5fa31e;
(function(PutObjectRetentionOutput) {
    PutObjectRetentionOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$edd40f596f5fa31e || ($fd8e87282214b013$export$edd40f596f5fa31e = {}));
var $fd8e87282214b013$export$117e9cab66df5006;
(function(PutObjectRetentionRequest) {
    PutObjectRetentionRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$117e9cab66df5006 || ($fd8e87282214b013$export$117e9cab66df5006 = {}));
var $fd8e87282214b013$export$d9e3a7e4f51c31d5;
(function(PutObjectTaggingOutput) {
    PutObjectTaggingOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$d9e3a7e4f51c31d5 || ($fd8e87282214b013$export$d9e3a7e4f51c31d5 = {}));
var $fd8e87282214b013$export$f5517f211c9a0baf;
(function(PutObjectTaggingRequest) {
    PutObjectTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$f5517f211c9a0baf || ($fd8e87282214b013$export$f5517f211c9a0baf = {}));
var $fd8e87282214b013$export$11868106b24a9ab0;
(function(PutPublicAccessBlockRequest) {
    PutPublicAccessBlockRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$11868106b24a9ab0 || ($fd8e87282214b013$export$11868106b24a9ab0 = {}));
var $fd8e87282214b013$export$a97e3c65be291319;
(function(ObjectAlreadyInActiveTierError) {
    ObjectAlreadyInActiveTierError.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$a97e3c65be291319 || ($fd8e87282214b013$export$a97e3c65be291319 = {}));
var $fd8e87282214b013$export$ee3cf9307c2a87ae;
(function(RestoreObjectOutput) {
    RestoreObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$ee3cf9307c2a87ae || ($fd8e87282214b013$export$ee3cf9307c2a87ae = {}));
var $fd8e87282214b013$export$e9e40009732846c;
(function(GlacierJobParameters) {
    GlacierJobParameters.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$e9e40009732846c || ($fd8e87282214b013$export$e9e40009732846c = {}));
var $fd8e87282214b013$export$d60a27d0da10cee5;
(function(Encryption) {
    Encryption.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.KMSKeyId && {
            KMSKeyId: (0, $gouPX.SENSITIVE_STRING)
        });
    };
})($fd8e87282214b013$export$d60a27d0da10cee5 || ($fd8e87282214b013$export$d60a27d0da10cee5 = {}));
var $fd8e87282214b013$export$9c5e83992d724a63;
(function(MetadataEntry) {
    MetadataEntry.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$9c5e83992d724a63 || ($fd8e87282214b013$export$9c5e83992d724a63 = {}));
var $fd8e87282214b013$export$7bb542410b46ffb9;
(function(S3Location) {
    S3Location.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.Encryption && {
            Encryption: $fd8e87282214b013$export$d60a27d0da10cee5.filterSensitiveLog(obj.Encryption)
        });
    };
})($fd8e87282214b013$export$7bb542410b46ffb9 || ($fd8e87282214b013$export$7bb542410b46ffb9 = {}));
var $fd8e87282214b013$export$cc3fbbd78713fc6c;
(function(OutputLocation) {
    OutputLocation.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.S3 && {
            S3: $fd8e87282214b013$export$7bb542410b46ffb9.filterSensitiveLog(obj.S3)
        });
    };
})($fd8e87282214b013$export$cc3fbbd78713fc6c || ($fd8e87282214b013$export$cc3fbbd78713fc6c = {}));
var $fd8e87282214b013$export$e0a8b40ee8e7958f;
(function(FileHeaderInfo) {
    FileHeaderInfo["IGNORE"] = "IGNORE";
    FileHeaderInfo["NONE"] = "NONE";
    FileHeaderInfo["USE"] = "USE";
})($fd8e87282214b013$export$e0a8b40ee8e7958f || ($fd8e87282214b013$export$e0a8b40ee8e7958f = {}));
var $fd8e87282214b013$export$cd4a4cfd0598253e;
(function(CSVInput) {
    CSVInput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$cd4a4cfd0598253e || ($fd8e87282214b013$export$cd4a4cfd0598253e = {}));
var $fd8e87282214b013$export$b8d04dd3765058e2;
(function(JSONType) {
    JSONType["DOCUMENT"] = "DOCUMENT";
    JSONType["LINES"] = "LINES";
})($fd8e87282214b013$export$b8d04dd3765058e2 || ($fd8e87282214b013$export$b8d04dd3765058e2 = {}));
var $fd8e87282214b013$export$1bc8a3cf179ad9c;
(function(JSONInput) {
    JSONInput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$1bc8a3cf179ad9c || ($fd8e87282214b013$export$1bc8a3cf179ad9c = {}));
var $fd8e87282214b013$export$a457f185006c756f;
(function(ParquetInput) {
    ParquetInput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$a457f185006c756f || ($fd8e87282214b013$export$a457f185006c756f = {}));
var $fd8e87282214b013$export$71ed8fe19d426eb7;
(function(InputSerialization) {
    InputSerialization.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$71ed8fe19d426eb7 || ($fd8e87282214b013$export$71ed8fe19d426eb7 = {}));
var $fd8e87282214b013$export$b4890521754421ba;
(function(QuoteFields) {
    QuoteFields["ALWAYS"] = "ALWAYS";
    QuoteFields["ASNEEDED"] = "ASNEEDED";
})($fd8e87282214b013$export$b4890521754421ba || ($fd8e87282214b013$export$b4890521754421ba = {}));
var $fd8e87282214b013$export$623bc581753795b3;
(function(CSVOutput) {
    CSVOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$623bc581753795b3 || ($fd8e87282214b013$export$623bc581753795b3 = {}));
var $fd8e87282214b013$export$403a844dcc531976;
(function(JSONOutput) {
    JSONOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$403a844dcc531976 || ($fd8e87282214b013$export$403a844dcc531976 = {}));
var $fd8e87282214b013$export$cb22c2d1ef9f03c1;
(function(OutputSerialization) {
    OutputSerialization.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$cb22c2d1ef9f03c1 || ($fd8e87282214b013$export$cb22c2d1ef9f03c1 = {}));
var $fd8e87282214b013$export$722dd036ddb6b3f;
(function(SelectParameters) {
    SelectParameters.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($fd8e87282214b013$export$722dd036ddb6b3f || ($fd8e87282214b013$export$722dd036ddb6b3f = {}));

});

parcelRegister("6RHn6", function(module, exports) {

$parcel$export(module.exports, "serializeAws_restXmlAbortMultipartUploadCommand", function () { return $4ff95607e2fba8c2$export$a7d2d025c66f9235; });
$parcel$export(module.exports, "serializeAws_restXmlCompleteMultipartUploadCommand", function () { return $4ff95607e2fba8c2$export$2a09fb9495f08c55; });
$parcel$export(module.exports, "serializeAws_restXmlCreateMultipartUploadCommand", function () { return $4ff95607e2fba8c2$export$4730de34492fdc2; });
$parcel$export(module.exports, "serializeAws_restXmlDeleteObjectCommand", function () { return $4ff95607e2fba8c2$export$400c19cbac9616f7; });
$parcel$export(module.exports, "serializeAws_restXmlGetObjectCommand", function () { return $4ff95607e2fba8c2$export$713ae52666bf2204; });
$parcel$export(module.exports, "serializeAws_restXmlListObjectsCommand", function () { return $4ff95607e2fba8c2$export$acd8b176cbc51cb9; });
$parcel$export(module.exports, "serializeAws_restXmlListPartsCommand", function () { return $4ff95607e2fba8c2$export$b2b39cf3937e8c76; });
$parcel$export(module.exports, "serializeAws_restXmlPutObjectCommand", function () { return $4ff95607e2fba8c2$export$6c3f9d82bec72a8d; });
$parcel$export(module.exports, "serializeAws_restXmlUploadPartCommand", function () { return $4ff95607e2fba8c2$export$6dfc42032d3f37d4; });
$parcel$export(module.exports, "deserializeAws_restXmlAbortMultipartUploadCommand", function () { return $4ff95607e2fba8c2$export$87447564e9ee4b69; });
$parcel$export(module.exports, "deserializeAws_restXmlCompleteMultipartUploadCommand", function () { return $4ff95607e2fba8c2$export$ee5aaa25931389ce; });
$parcel$export(module.exports, "deserializeAws_restXmlCreateMultipartUploadCommand", function () { return $4ff95607e2fba8c2$export$95cf7bc6357ae5a8; });
$parcel$export(module.exports, "deserializeAws_restXmlDeleteObjectCommand", function () { return $4ff95607e2fba8c2$export$987b292ae9f16665; });
$parcel$export(module.exports, "deserializeAws_restXmlGetObjectCommand", function () { return $4ff95607e2fba8c2$export$c8faba1b7abd4024; });
$parcel$export(module.exports, "deserializeAws_restXmlListObjectsCommand", function () { return $4ff95607e2fba8c2$export$f8d39cd754f5521d; });
$parcel$export(module.exports, "deserializeAws_restXmlListPartsCommand", function () { return $4ff95607e2fba8c2$export$584d994fd27ec2bb; });
$parcel$export(module.exports, "deserializeAws_restXmlPutObjectCommand", function () { return $4ff95607e2fba8c2$export$45bbdbf5181c3607; });
$parcel$export(module.exports, "deserializeAws_restXmlUploadPartCommand", function () { return $4ff95607e2fba8c2$export$176ef954f1bec178; });

var $9OyH6 = parcelRequire("9OyH6");
parcelRequire("1J0sw");
var $jmMP9 = parcelRequire("jmMP9");
parcelRequire("fF6iB");
var $ksXvj = parcelRequire("ksXvj");
var $15E4b = parcelRequire("15E4b");
var $3aFL9 = parcelRequire("3aFL9");
var $3Ggxn = parcelRequire("3Ggxn");
parcelRequire("ae0gO");
var $dfLaw = parcelRequire("dfLaw");
var $doQBX = parcelRequire("doQBX");

var $boTui = parcelRequire("boTui");
var $4ff95607e2fba8c2$export$a7d2d025c66f9235 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)({
                        "x-id": "AbortMultipartUpload"
                    }, input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$2a09fb9495f08c55 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)({}, input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    });
                    if (input.MultipartUpload !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlCompletedMultipartUpload(input.MultipartUpload, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$3fa883360ffbe82d = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.Tagging) && {
                        "x-amz-tagging": input.Tagging
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSEKMSEncryptionContext) && {
                        "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.Expires) && {
                        Expires: (0, $ksXvj.dateToUtcString)(input.Expires).toString()
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.CopySourceIfModifiedSince) && {
                        "x-amz-copy-source-if-modified-since": (0, $ksXvj.dateToUtcString)(input.CopySourceIfModifiedSince).toString()
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentDisposition) && {
                        "Content-Disposition": input.ContentDisposition
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.WebsiteRedirectLocation) && {
                        "x-amz-website-redirect-location": input.WebsiteRedirectLocation
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ObjectLockRetainUntilDate) && {
                        "x-amz-object-lock-retain-until-date": (input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentLanguage) && {
                        "Content-Language": input.ContentLanguage
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ObjectLockLegalHoldStatus) && {
                        "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.CopySource) && {
                        "x-amz-copy-source": input.CopySource
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.CopySourceSSECustomerAlgorithm) && {
                        "x-amz-copy-source-server-side-encryption-customer-algorithm": input.CopySourceSSECustomerAlgorithm
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.CopySourceSSECustomerKey) && {
                        "x-amz-copy-source-server-side-encryption-customer-key": input.CopySourceSSECustomerKey
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.CopySourceSSECustomerKeyMD5) && {
                        "x-amz-copy-source-server-side-encryption-customer-key-MD5": input.CopySourceSSECustomerKeyMD5
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.CacheControl) && {
                        "Cache-Control": input.CacheControl
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.TaggingDirective) && {
                        "x-amz-tagging-directive": input.TaggingDirective
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentEncoding) && {
                        "Content-Encoding": input.ContentEncoding
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.CopySourceIfUnmodifiedSince) && {
                        "x-amz-copy-source-if-unmodified-since": (0, $ksXvj.dateToUtcString)(input.CopySourceIfUnmodifiedSince).toString()
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentType) && {
                        "Content-Type": input.ContentType
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.CopySourceIfMatch) && {
                        "x-amz-copy-source-if-match": input.CopySourceIfMatch
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ObjectLockMode) && {
                        "x-amz-object-lock-mode": input.ObjectLockMode
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSEKMSKeyId) && {
                        "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedSourceBucketOwner) && {
                        "x-amz-source-expected-bucket-owner": input.ExpectedSourceBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ServerSideEncryption) && {
                        "x-amz-server-side-encryption": input.ServerSideEncryption
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.MetadataDirective) && {
                        "x-amz-metadata-directive": input.MetadataDirective
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.CopySourceIfNoneMatch) && {
                        "x-amz-copy-source-if-none-match": input.CopySourceIfNoneMatch
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.StorageClass) && {
                        "x-amz-storage-class": input.StorageClass
                    }), input.Metadata !== undefined && Object.keys(input.Metadata).reduce(function(acc, suffix) {
                        acc["x-amz-meta-" + suffix] = input.Metadata[suffix];
                        return acc;
                    }, {}));
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        "x-id": "CopyObject"
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$ff9b8bd3304a2cc2 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantWrite) && {
                        "x-amz-grant-write": input.GrantWrite
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ObjectLockEnabledForBucket) && {
                        "x-amz-bucket-object-lock-enabled": input.ObjectLockEnabledForBucket.toString()
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.CreateBucketConfiguration !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlCreateBucketConfiguration(input.CreateBucketConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$4730de34492fdc2 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSEKMSKeyId) && {
                        "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ObjectLockLegalHoldStatus) && {
                        "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.WebsiteRedirectLocation) && {
                        "x-amz-website-redirect-location": input.WebsiteRedirectLocation
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentType) && {
                        "Content-Type": input.ContentType
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentLanguage) && {
                        "Content-Language": input.ContentLanguage
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.CacheControl) && {
                        "Cache-Control": input.CacheControl
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.Tagging) && {
                        "x-amz-tagging": input.Tagging
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSEKMSEncryptionContext) && {
                        "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.Expires) && {
                        Expires: (0, $ksXvj.dateToUtcString)(input.Expires).toString()
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ObjectLockRetainUntilDate) && {
                        "x-amz-object-lock-retain-until-date": (input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ServerSideEncryption) && {
                        "x-amz-server-side-encryption": input.ServerSideEncryption
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentDisposition) && {
                        "Content-Disposition": input.ContentDisposition
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ObjectLockMode) && {
                        "x-amz-object-lock-mode": input.ObjectLockMode
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.StorageClass) && {
                        "x-amz-storage-class": input.StorageClass
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentEncoding) && {
                        "Content-Encoding": input.ContentEncoding
                    }), input.Metadata !== undefined && Object.keys(input.Metadata).reduce(function(acc, suffix) {
                        acc["x-amz-meta-" + suffix] = input.Metadata[suffix];
                        return acc;
                    }, {}));
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = {
                        uploads: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$4c739e7bdecdc09e = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$1599103c79e9cc48 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)({
                        analytics: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$328eda7443168fa1 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        cors: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$a935f4341563a8e5 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        encryption: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$ea4a1894e3000c1a = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)({
                        inventory: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$ff5be01ded2fe32 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        lifecycle: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$f050fc1ef4eb3607 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)({
                        metrics: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$9809275ad1405c95 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        ownershipControls: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$d35e7f7cfb4671a8 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        policy: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$9a7bb1ffbd4a4abf = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        replication: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$898454ff9153710a = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        tagging: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$55003dd0346cc6e0 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        website: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$400c19cbac9616f7 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.MFA) && {
                        "x-amz-mfa": input.MFA
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.BypassGovernanceRetention) && {
                        "x-amz-bypass-governance-retention": input.BypassGovernanceRetention.toString()
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $9OyH6.__assign)({
                        "x-id": "DeleteObject"
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$6867c23377cf4e18 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.MFA) && {
                        "x-amz-mfa": input.MFA
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.BypassGovernanceRetention) && {
                        "x-amz-bypass-governance-retention": input.BypassGovernanceRetention.toString()
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        delete: ""
                    };
                    if (input.Delete !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlDelete(input.Delete, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$c5216ce889528f85 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $9OyH6.__assign)({
                        tagging: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$6e75832e2b10791c = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        publicAccessBlock: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$401fbb1296db6719 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        accelerate: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$36598b1e884464d4 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        acl: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$4d648e59e03d69d2 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)({
                        analytics: "",
                        "x-id": "GetBucketAnalyticsConfiguration"
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$c50cfec8b08a5bc7 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        cors: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$59a2b88153b9bcd3 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        encryption: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$27733aaa6f8bdfce = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)({
                        inventory: "",
                        "x-id": "GetBucketInventoryConfiguration"
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$a45e301366f2d4b7 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        lifecycle: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$57578b49828da279 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        location: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$fba64f4839ba2759 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        logging: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$55cedf3b8782e93a = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)({
                        metrics: "",
                        "x-id": "GetBucketMetricsConfiguration"
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$28aa3066de46a217 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        notification: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$8ff61553a991ad45 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        ownershipControls: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$9c4ddc2418c2498a = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        policy: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$5cc8b1c7c38eaa70 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        policyStatus: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$7bfb07297b27feda = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        replication: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$c40582f35b41168f = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        requestPayment: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$7fe7f3d9e83c1258 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        tagging: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$33bb47afa1d36b = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        versioning: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$86d6bcc10cc7214f = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        website: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$713ae52666bf2204 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.IfUnmodifiedSince) && {
                        "If-Unmodified-Since": (0, $ksXvj.dateToUtcString)(input.IfUnmodifiedSince).toString()
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.IfModifiedSince) && {
                        "If-Modified-Since": (0, $ksXvj.dateToUtcString)(input.IfModifiedSince).toString()
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.IfNoneMatch) && {
                        "If-None-Match": input.IfNoneMatch
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.IfMatch) && {
                        "If-Match": input.IfMatch
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.Range) && {
                        Range: input.Range
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "x-id": "GetObject"
                    }, input.ResponseContentEncoding !== undefined && {
                        "response-content-encoding": input.ResponseContentEncoding
                    }), input.ResponseCacheControl !== undefined && {
                        "response-cache-control": input.ResponseCacheControl
                    }), input.ResponseContentLanguage !== undefined && {
                        "response-content-language": input.ResponseContentLanguage
                    }), input.ResponseContentDisposition !== undefined && {
                        "response-content-disposition": input.ResponseContentDisposition
                    }), input.PartNumber !== undefined && {
                        partNumber: input.PartNumber.toString()
                    }), input.VersionId !== undefined && {
                        versionId: input.VersionId
                    }), input.ResponseExpires !== undefined && {
                        "response-expires": (input.ResponseExpires.toISOString().split(".")[0] + "Z").toString()
                    }), input.ResponseContentType !== undefined && {
                        "response-content-type": input.ResponseContentType
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$915aba65107b1e0b = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)({
                        acl: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$9c08e676bdd74a0 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)({
                        "legal-hold": ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$6b8bcfdbd9049617 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        "object-lock": ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$73761af73f60c98c = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)({
                        retention: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$9eb633d3ed47ffa4 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $9OyH6.__assign)({
                        tagging: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$19b09331a932f5f6 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = {
                        torrent: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$96bfd3c7dd0a4d0a = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        publicAccessBlock: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$33042663db00ac59 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "HEAD",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$7d02887d047f6825 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.Range) && {
                        Range: input.Range
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.IfNoneMatch) && {
                        "If-None-Match": input.IfNoneMatch
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.IfUnmodifiedSince) && {
                        "If-Unmodified-Since": (0, $ksXvj.dateToUtcString)(input.IfUnmodifiedSince).toString()
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.IfModifiedSince) && {
                        "If-Modified-Since": (0, $ksXvj.dateToUtcString)(input.IfModifiedSince).toString()
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.IfMatch) && {
                        "If-Match": input.IfMatch
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, input.PartNumber !== undefined && {
                        partNumber: input.PartNumber.toString()
                    }), input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "HEAD",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$1af1bbf8ced1a360 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)({
                        analytics: "",
                        "x-id": "ListBucketAnalyticsConfigurations"
                    }, input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$84049d82728011d8 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)({
                        inventory: "",
                        "x-id": "ListBucketInventoryConfigurations"
                    }, input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$4386fb1e1f56eefe = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)({
                        metrics: "",
                        "x-id": "ListBucketMetricsConfigurations"
                    }, input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$94ca891f34564e01 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {
                        "Content-Type": ""
                    };
                    resolvedPath = "/";
                    body = "";
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$67092c8b2bd6afb9 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        uploads: ""
                    }, input.UploadIdMarker !== undefined && {
                        "upload-id-marker": input.UploadIdMarker
                    }), input.Prefix !== undefined && {
                        prefix: input.Prefix
                    }), input.Delimiter !== undefined && {
                        delimiter: input.Delimiter
                    }), input.MaxUploads !== undefined && {
                        "max-uploads": input.MaxUploads.toString()
                    }), input.KeyMarker !== undefined && {
                        "key-marker": input.KeyMarker
                    }), input.EncodingType !== undefined && {
                        "encoding-type": input.EncodingType
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$acd8b176cbc51cb9 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, input.MaxKeys !== undefined && {
                        "max-keys": input.MaxKeys.toString()
                    }), input.Marker !== undefined && {
                        marker: input.Marker
                    }), input.Prefix !== undefined && {
                        prefix: input.Prefix
                    }), input.Delimiter !== undefined && {
                        delimiter: input.Delimiter
                    }), input.EncodingType !== undefined && {
                        "encoding-type": input.EncodingType
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$ea6ee77e40f86bd9 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "list-type": "2"
                    }, input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    }), input.FetchOwner !== undefined && {
                        "fetch-owner": input.FetchOwner.toString()
                    }), input.EncodingType !== undefined && {
                        "encoding-type": input.EncodingType
                    }), input.Prefix !== undefined && {
                        prefix: input.Prefix
                    }), input.StartAfter !== undefined && {
                        "start-after": input.StartAfter
                    }), input.Delimiter !== undefined && {
                        delimiter: input.Delimiter
                    }), input.MaxKeys !== undefined && {
                        "max-keys": input.MaxKeys.toString()
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$e9deb593aaba1069 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        versions: ""
                    }, input.KeyMarker !== undefined && {
                        "key-marker": input.KeyMarker
                    }), input.MaxKeys !== undefined && {
                        "max-keys": input.MaxKeys.toString()
                    }), input.Delimiter !== undefined && {
                        delimiter: input.Delimiter
                    }), input.VersionIdMarker !== undefined && {
                        "version-id-marker": input.VersionIdMarker
                    }), input.Prefix !== undefined && {
                        prefix: input.Prefix
                    }), input.EncodingType !== undefined && {
                        "encoding-type": input.EncodingType
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$b2b39cf3937e8c76 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "x-id": "ListParts"
                    }, input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    }), input.MaxParts !== undefined && {
                        "max-parts": input.MaxParts.toString()
                    }), input.PartNumberMarker !== undefined && {
                        "part-number-marker": input.PartNumberMarker.toString()
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$4d770bb452c6d670 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        accelerate: ""
                    };
                    if (input.AccelerateConfiguration !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlAccelerateConfiguration(input.AccelerateConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$415e832013d5f94b = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantWrite) && {
                        "x-amz-grant-write": input.GrantWrite
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        acl: ""
                    };
                    if (input.AccessControlPolicy !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlAccessControlPolicy(input.AccessControlPolicy, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$82791d7115b07b04 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)({
                        analytics: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    if (input.AnalyticsConfiguration !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlAnalyticsConfiguration(input.AnalyticsConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$c86e5c4d1766d14 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        cors: ""
                    };
                    if (input.CORSConfiguration !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlCORSConfiguration(input.CORSConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$c279f7b43c9bb310 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        encryption: ""
                    };
                    if (input.ServerSideEncryptionConfiguration !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlServerSideEncryptionConfiguration(input.ServerSideEncryptionConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$6d95946d99f43eaa = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)({
                        inventory: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    if (input.InventoryConfiguration !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlInventoryConfiguration(input.InventoryConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$70f4fe83400d730d = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        lifecycle: ""
                    };
                    if (input.LifecycleConfiguration !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlBucketLifecycleConfiguration(input.LifecycleConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$2426ada7dacc12b9 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        logging: ""
                    };
                    if (input.BucketLoggingStatus !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlBucketLoggingStatus(input.BucketLoggingStatus, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$dd9ccb6c86dc9b75 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)({
                        metrics: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    if (input.MetricsConfiguration !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlMetricsConfiguration(input.MetricsConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$cc9aba63382b97f4 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        notification: ""
                    };
                    if (input.NotificationConfiguration !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlNotificationConfiguration(input.NotificationConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$cd645fbb22474aad = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        ownershipControls: ""
                    };
                    if (input.OwnershipControls !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlOwnershipControls(input.OwnershipControls, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$46f7931bb495aaa = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, bodyNode, node, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ConfirmRemoveSelfBucketAccess) && {
                        "x-amz-confirm-remove-self-bucket-access": input.ConfirmRemoveSelfBucketAccess.toString()
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        policy: ""
                    };
                    body = '<?xml version="1.0" encoding="UTF-8"?>';
                    bodyNode = new (0, $dfLaw.XmlNode)("PutBucketPolicyRequest");
                    bodyNode.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                    if (input.Policy !== undefined) {
                        node = new (0, $dfLaw.XmlNode)("Policy").addChildNode(new (0, $doQBX.XmlText)(input.Policy)).withName("Policy");
                        bodyNode.addChildNode(node);
                    }
                    body += bodyNode.toString();
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$bc85604c47270690 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.Token) && {
                        "x-amz-bucket-object-lock-token": input.Token
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        replication: ""
                    };
                    if (input.ReplicationConfiguration !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlReplicationConfiguration(input.ReplicationConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$d688e45835bb412b = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        requestPayment: ""
                    };
                    if (input.RequestPaymentConfiguration !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlRequestPaymentConfiguration(input.RequestPaymentConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$fb33aa4addeb7925 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        tagging: ""
                    };
                    if (input.Tagging !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlTagging(input.Tagging, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$b2b33319a5c1fa1b = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.MFA) && {
                        "x-amz-mfa": input.MFA
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        versioning: ""
                    };
                    if (input.VersioningConfiguration !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlVersioningConfiguration(input.VersioningConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$3684a013c739abf7 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        website: ""
                    };
                    if (input.WebsiteConfiguration !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlWebsiteConfiguration(input.WebsiteConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$6c3f9d82bec72a8d = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/octet-stream"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentEncoding) && {
                        "Content-Encoding": input.ContentEncoding
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.CacheControl) && {
                        "Cache-Control": input.CacheControl
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.WebsiteRedirectLocation) && {
                        "x-amz-website-redirect-location": input.WebsiteRedirectLocation
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ObjectLockLegalHoldStatus) && {
                        "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentLength) && {
                        "Content-Length": input.ContentLength.toString()
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ObjectLockRetainUntilDate) && {
                        "x-amz-object-lock-retain-until-date": (input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentDisposition) && {
                        "Content-Disposition": input.ContentDisposition
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSEKMSEncryptionContext) && {
                        "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.Tagging) && {
                        "x-amz-tagging": input.Tagging
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.Expires) && {
                        Expires: (0, $ksXvj.dateToUtcString)(input.Expires).toString()
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.StorageClass) && {
                        "x-amz-storage-class": input.StorageClass
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ServerSideEncryption) && {
                        "x-amz-server-side-encryption": input.ServerSideEncryption
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ObjectLockMode) && {
                        "x-amz-object-lock-mode": input.ObjectLockMode
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSEKMSKeyId) && {
                        "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentLanguage) && {
                        "Content-Language": input.ContentLanguage
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentType) && {
                        "Content-Type": input.ContentType
                    }), input.Metadata !== undefined && Object.keys(input.Metadata).reduce(function(acc, suffix) {
                        acc["x-amz-meta-" + suffix] = input.Metadata[suffix];
                        return acc;
                    }, {}));
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = {
                        "x-id": "PutObject"
                    };
                    if (input.Body !== undefined) {
                        contents = input.Body;
                        body = contents;
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$c5f7c1bb4a245310 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantWrite) && {
                        "x-amz-grant-write": input.GrantWrite
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)({
                        acl: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.AccessControlPolicy !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlAccessControlPolicy(input.AccessControlPolicy, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$3cae5f4de1f7d8e0 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $9OyH6.__assign)({
                        "legal-hold": ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.LegalHold !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlObjectLockLegalHold(input.LegalHold, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$e85a5935e0b9ebcf = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.Token) && {
                        "x-amz-bucket-object-lock-token": input.Token
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        "object-lock": ""
                    };
                    if (input.ObjectLockConfiguration !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlObjectLockConfiguration(input.ObjectLockConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$401e449dfbceed84 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.BypassGovernanceRetention) && {
                        "x-amz-bypass-governance-retention": input.BypassGovernanceRetention.toString()
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)({
                        retention: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.Retention !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlObjectLockRetention(input.Retention, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$c73061b6e5d6a95a = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $9OyH6.__assign)({
                        tagging: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.Tagging !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlTagging(input.Tagging, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$9f1c307a4d5bd5b3 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        publicAccessBlock: ""
                    };
                    if (input.PublicAccessBlockConfiguration !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlPublicAccessBlockConfiguration(input.PublicAccessBlockConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$99a912d071900c76 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $9OyH6.__assign)({
                        restore: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.RestoreRequest !== undefined) {
                        contents = $4ff95607e2fba8c2$var$serializeAws_restXmlRestoreRequest(input.RestoreRequest, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$47ebf91740d2ce6f = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, bodyNode, node, node, node, node, node, node, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/xml"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        select: "",
                        "select-type": "2"
                    };
                    body = '<?xml version="1.0" encoding="UTF-8"?>';
                    bodyNode = new (0, $dfLaw.XmlNode)("SelectObjectContentRequest");
                    bodyNode.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                    if (input.Expression !== undefined) {
                        node = new (0, $dfLaw.XmlNode)("Expression").addChildNode(new (0, $doQBX.XmlText)(input.Expression)).withName("Expression");
                        bodyNode.addChildNode(node);
                    }
                    if (input.ExpressionType !== undefined) {
                        node = new (0, $dfLaw.XmlNode)("ExpressionType").addChildNode(new (0, $doQBX.XmlText)(input.ExpressionType)).withName("ExpressionType");
                        bodyNode.addChildNode(node);
                    }
                    if (input.InputSerialization !== undefined) {
                        node = $4ff95607e2fba8c2$var$serializeAws_restXmlInputSerialization(input.InputSerialization, context).withName("InputSerialization");
                        bodyNode.addChildNode(node);
                    }
                    if (input.OutputSerialization !== undefined) {
                        node = $4ff95607e2fba8c2$var$serializeAws_restXmlOutputSerialization(input.OutputSerialization, context).withName("OutputSerialization");
                        bodyNode.addChildNode(node);
                    }
                    if (input.RequestProgress !== undefined) {
                        node = $4ff95607e2fba8c2$var$serializeAws_restXmlRequestProgress(input.RequestProgress, context).withName("RequestProgress");
                        bodyNode.addChildNode(node);
                    }
                    if (input.ScanRange !== undefined) {
                        node = $4ff95607e2fba8c2$var$serializeAws_restXmlScanRange(input.ScanRange, context).withName("ScanRange");
                        bodyNode.addChildNode(node);
                    }
                    body += bodyNode.toString();
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$6dfc42032d3f37d4 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": "application/octet-stream"
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentLength) && {
                        "Content-Length": input.ContentLength.toString()
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "x-id": "UploadPart"
                    }, input.PartNumber !== undefined && {
                        partNumber: input.PartNumber.toString()
                    }), input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    });
                    if (input.Body !== undefined) {
                        contents = input.Body;
                        body = contents;
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$90763da135bbc5f9 = function(input, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "Content-Type": ""
                    }, $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.CopySourceRange) && {
                        "x-amz-copy-source-range": input.CopySourceRange
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.CopySourceIfMatch) && {
                        "x-amz-copy-source-if-match": input.CopySourceIfMatch
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.CopySourceSSECustomerKey) && {
                        "x-amz-copy-source-server-side-encryption-customer-key": input.CopySourceSSECustomerKey
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.CopySource) && {
                        "x-amz-copy-source": input.CopySource
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.CopySourceIfModifiedSince) && {
                        "x-amz-copy-source-if-modified-since": (0, $ksXvj.dateToUtcString)(input.CopySourceIfModifiedSince).toString()
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.CopySourceSSECustomerAlgorithm) && {
                        "x-amz-copy-source-server-side-encryption-customer-algorithm": input.CopySourceSSECustomerAlgorithm
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.CopySourceIfUnmodifiedSince) && {
                        "x-amz-copy-source-if-unmodified-since": (0, $ksXvj.dateToUtcString)(input.CopySourceIfUnmodifiedSince).toString()
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.ExpectedSourceBucketOwner) && {
                        "x-amz-source-expected-bucket-owner": input.ExpectedSourceBucketOwner
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.CopySourceIfNoneMatch) && {
                        "x-amz-copy-source-if-none-match": input.CopySourceIfNoneMatch
                    }), $4ff95607e2fba8c2$var$isSerializableHeaderValue(input.CopySourceSSECustomerKeyMD5) && {
                        "x-amz-copy-source-server-side-encryption-customer-key-MD5": input.CopySourceSSECustomerKeyMD5
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $15E4b.extendedEncodeURIComponent)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $15E4b.extendedEncodeURIComponent)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({
                        "x-id": "UploadPartCopy"
                    }, input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    }), input.PartNumber !== undefined && {
                        partNumber: input.PartNumber.toString()
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $jmMP9.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$87447564e9ee4b69 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlAbortMultipartUploadCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlAbortMultipartUploadCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $9OyH6.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchUpload":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchUpload":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlNoSuchUploadResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $9OyH6.__assign).apply(void 0, [
                        (0, $9OyH6.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$ee5aaa25931389ce = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlCompleteMultipartUploadCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        Bucket: undefined,
                        ETag: undefined,
                        Expiration: undefined,
                        Key: undefined,
                        Location: undefined,
                        RequestCharged: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Bucket"] !== undefined) contents.Bucket = data["Bucket"];
                    if (data["ETag"] !== undefined) contents.ETag = data["ETag"];
                    if (data["Key"] !== undefined) contents.Key = data["Key"];
                    if (data["Location"] !== undefined) contents.Location = data["Location"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlCompleteMultipartUploadCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$a5d77c8b6651b993 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlCopyObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        CopyObjectResult: undefined,
                        CopySourceVersionId: undefined,
                        Expiration: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSEncryptionContext: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-copy-source-version-id"] !== undefined) contents.CopySourceVersionId = output.headers["x-amz-copy-source-version-id"];
                    if (output.headers["x-amz-server-side-encryption-context"] !== undefined) contents.SSEKMSEncryptionContext = output.headers["x-amz-server-side-encryption-context"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.CopyObjectResult = $4ff95607e2fba8c2$var$deserializeAws_restXmlCopyObjectResult(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlCopyObjectCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $9OyH6.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ObjectNotInActiveTierError":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#ObjectNotInActiveTierError":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlObjectNotInActiveTierErrorResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $9OyH6.__assign).apply(void 0, [
                        (0, $9OyH6.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$b4e8f8f452bdb204 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlCreateBucketCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        Location: undefined
                    };
                    if (output.headers["location"] !== undefined) contents.Location = output.headers["location"];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlCreateBucketCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, $9OyH6.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "BucketAlreadyExists":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#BucketAlreadyExists":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "BucketAlreadyOwnedByYou":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.s3#BucketAlreadyOwnedByYou":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlBucketAlreadyExistsResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $9OyH6.__assign).apply(void 0, [
                        (0, $9OyH6.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlBucketAlreadyOwnedByYouResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $9OyH6.__assign).apply(void 0, [
                        (0, $9OyH6.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$95cf7bc6357ae5a8 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlCreateMultipartUploadCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        AbortDate: undefined,
                        AbortRuleId: undefined,
                        Bucket: undefined,
                        Key: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSEncryptionContext: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        UploadId: undefined
                    };
                    if (output.headers["x-amz-server-side-encryption-context"] !== undefined) contents.SSEKMSEncryptionContext = output.headers["x-amz-server-side-encryption-context"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["x-amz-abort-date"] !== undefined) contents.AbortDate = new Date(output.headers["x-amz-abort-date"]);
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-abort-rule-id"] !== undefined) contents.AbortRuleId = output.headers["x-amz-abort-rule-id"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Bucket"] !== undefined) contents.Bucket = data["Bucket"];
                    if (data["Key"] !== undefined) contents.Key = data["Key"];
                    if (data["UploadId"] !== undefined) contents.UploadId = data["UploadId"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlCreateMultipartUploadCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$c5d62536e1c56e82 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$820ce8b5969d2c78 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketAnalyticsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketAnalyticsConfigurationCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$dea26f8b4dad38ea = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketCorsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketCorsCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$48d65b1878f8cb7f = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketEncryptionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketEncryptionCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$dc33768e2651b6cb = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketInventoryConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketInventoryConfigurationCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$1660bb2bbec5b369 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketLifecycleCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketLifecycleCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$ea7eb03b8f77dc6a = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketMetricsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketMetricsConfigurationCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$649e1231e4f3b774 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketOwnershipControlsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketOwnershipControlsCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$470e22ed3eb8b871 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketPolicyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketPolicyCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$a8348308c83bfe9d = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketReplicationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketReplicationCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$8f5814a38b853d38 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketTaggingCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$bc95350311fac763 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketWebsiteCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteBucketWebsiteCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$987b292ae9f16665 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        DeleteMarker: undefined,
                        RequestCharged: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-delete-marker"] !== undefined) contents.DeleteMarker = output.headers["x-amz-delete-marker"] === "true";
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteObjectCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$ebb9378c7c531fa5 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteObjectsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        Deleted: undefined,
                        Errors: undefined,
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.Deleted === "") contents.Deleted = [];
                    if (data["Deleted"] !== undefined) contents.Deleted = $4ff95607e2fba8c2$var$deserializeAws_restXmlDeletedObjects((0, $3aFL9.getArrayIfSingleItem)(data["Deleted"]), context);
                    if (data.Error === "") contents.Errors = [];
                    if (data["Error"] !== undefined) contents.Errors = $4ff95607e2fba8c2$var$deserializeAws_restXmlErrors((0, $3aFL9.getArrayIfSingleItem)(data["Error"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteObjectsCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$7021ac5189f9792d = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteObjectTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteObjectTaggingCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$4cf24390776e8eb6 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlDeletePublicAccessBlockCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDeletePublicAccessBlockCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$30393acaf6414a50 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketAccelerateConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        Status: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Status"] !== undefined) contents.Status = data["Status"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketAccelerateConfigurationCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$56e18e7cfcb102eb = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketAclCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        Grants: undefined,
                        Owner: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.AccessControlList === "") contents.Grants = [];
                    if (data["AccessControlList"] !== undefined && data["AccessControlList"]["Grant"] !== undefined) contents.Grants = $4ff95607e2fba8c2$var$deserializeAws_restXmlGrants((0, $3aFL9.getArrayIfSingleItem)(data["AccessControlList"]["Grant"]), context);
                    if (data["Owner"] !== undefined) contents.Owner = $4ff95607e2fba8c2$var$deserializeAws_restXmlOwner(data["Owner"], context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketAclCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$8103ef82db64a4aa = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketAnalyticsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        AnalyticsConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.AnalyticsConfiguration = $4ff95607e2fba8c2$var$deserializeAws_restXmlAnalyticsConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketAnalyticsConfigurationCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$472fdec99155a887 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketCorsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        CORSRules: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CORSRule === "") contents.CORSRules = [];
                    if (data["CORSRule"] !== undefined) contents.CORSRules = $4ff95607e2fba8c2$var$deserializeAws_restXmlCORSRules((0, $3aFL9.getArrayIfSingleItem)(data["CORSRule"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketCorsCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$d83d67d0bf5676cb = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketEncryptionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        ServerSideEncryptionConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.ServerSideEncryptionConfiguration = $4ff95607e2fba8c2$var$deserializeAws_restXmlServerSideEncryptionConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketEncryptionCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$cd1101fd9c222af8 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketInventoryConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        InventoryConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.InventoryConfiguration = $4ff95607e2fba8c2$var$deserializeAws_restXmlInventoryConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketInventoryConfigurationCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$b85a74c7951988c1 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketLifecycleConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        Rules: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.Rule === "") contents.Rules = [];
                    if (data["Rule"] !== undefined) contents.Rules = $4ff95607e2fba8c2$var$deserializeAws_restXmlLifecycleRules((0, $3aFL9.getArrayIfSingleItem)(data["Rule"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketLifecycleConfigurationCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$d332d0a204c1f2de = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketLocationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        LocationConstraint: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["LocationConstraint"] !== undefined) contents.LocationConstraint = data["LocationConstraint"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketLocationCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$99325a82aa21e152 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketLoggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        LoggingEnabled: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["LoggingEnabled"] !== undefined) contents.LoggingEnabled = $4ff95607e2fba8c2$var$deserializeAws_restXmlLoggingEnabled(data["LoggingEnabled"], context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketLoggingCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$33f849a042e960f2 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketMetricsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        MetricsConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.MetricsConfiguration = $4ff95607e2fba8c2$var$deserializeAws_restXmlMetricsConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketMetricsConfigurationCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$f7ea4be33406a0a0 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketNotificationConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        LambdaFunctionConfigurations: undefined,
                        QueueConfigurations: undefined,
                        TopicConfigurations: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CloudFunctionConfiguration === "") contents.LambdaFunctionConfigurations = [];
                    if (data["CloudFunctionConfiguration"] !== undefined) contents.LambdaFunctionConfigurations = $4ff95607e2fba8c2$var$deserializeAws_restXmlLambdaFunctionConfigurationList((0, $3aFL9.getArrayIfSingleItem)(data["CloudFunctionConfiguration"]), context);
                    if (data.QueueConfiguration === "") contents.QueueConfigurations = [];
                    if (data["QueueConfiguration"] !== undefined) contents.QueueConfigurations = $4ff95607e2fba8c2$var$deserializeAws_restXmlQueueConfigurationList((0, $3aFL9.getArrayIfSingleItem)(data["QueueConfiguration"]), context);
                    if (data.TopicConfiguration === "") contents.TopicConfigurations = [];
                    if (data["TopicConfiguration"] !== undefined) contents.TopicConfigurations = $4ff95607e2fba8c2$var$deserializeAws_restXmlTopicConfigurationList((0, $3aFL9.getArrayIfSingleItem)(data["TopicConfiguration"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketNotificationConfigurationCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$e51b6b0868913b77 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketOwnershipControlsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        OwnershipControls: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.OwnershipControls = $4ff95607e2fba8c2$var$deserializeAws_restXmlOwnershipControls(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketOwnershipControlsCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$74beb134589fee09 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketPolicyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        Policy: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Policy"] !== undefined) contents.Policy = data["Policy"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketPolicyCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$bb27e87cf2face4 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketPolicyStatusCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        PolicyStatus: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.PolicyStatus = $4ff95607e2fba8c2$var$deserializeAws_restXmlPolicyStatus(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketPolicyStatusCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$640745a275665c3f = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketReplicationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        ReplicationConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.ReplicationConfiguration = $4ff95607e2fba8c2$var$deserializeAws_restXmlReplicationConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketReplicationCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$95dd746113207b99 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketRequestPaymentCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        Payer: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Payer"] !== undefined) contents.Payer = data["Payer"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketRequestPaymentCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$e91d7dc8d3f2bb37 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        TagSet: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.TagSet === "") contents.TagSet = [];
                    if (data["TagSet"] !== undefined && data["TagSet"]["Tag"] !== undefined) contents.TagSet = $4ff95607e2fba8c2$var$deserializeAws_restXmlTagSet((0, $3aFL9.getArrayIfSingleItem)(data["TagSet"]["Tag"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketTaggingCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$87fb664bdbc56c8d = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketVersioningCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        MFADelete: undefined,
                        Status: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["MfaDelete"] !== undefined) contents.MFADelete = data["MfaDelete"];
                    if (data["Status"] !== undefined) contents.Status = data["Status"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketVersioningCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$e9648c335e4af37a = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketWebsiteCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        ErrorDocument: undefined,
                        IndexDocument: undefined,
                        RedirectAllRequestsTo: undefined,
                        RoutingRules: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["ErrorDocument"] !== undefined) contents.ErrorDocument = $4ff95607e2fba8c2$var$deserializeAws_restXmlErrorDocument(data["ErrorDocument"], context);
                    if (data["IndexDocument"] !== undefined) contents.IndexDocument = $4ff95607e2fba8c2$var$deserializeAws_restXmlIndexDocument(data["IndexDocument"], context);
                    if (data["RedirectAllRequestsTo"] !== undefined) contents.RedirectAllRequestsTo = $4ff95607e2fba8c2$var$deserializeAws_restXmlRedirectAllRequestsTo(data["RedirectAllRequestsTo"], context);
                    if (data.RoutingRules === "") contents.RoutingRules = [];
                    if (data["RoutingRules"] !== undefined && data["RoutingRules"]["RoutingRule"] !== undefined) contents.RoutingRules = $4ff95607e2fba8c2$var$deserializeAws_restXmlRoutingRules((0, $3aFL9.getArrayIfSingleItem)(data["RoutingRules"]["RoutingRule"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetBucketWebsiteCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$c8faba1b7abd4024 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2 /*return*/ ,
                $4ff95607e2fba8c2$var$deserializeAws_restXmlGetObjectCommandError(output, context)
            ];
            contents = {
                $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                AcceptRanges: undefined,
                Body: undefined,
                CacheControl: undefined,
                ContentDisposition: undefined,
                ContentEncoding: undefined,
                ContentLanguage: undefined,
                ContentLength: undefined,
                ContentRange: undefined,
                ContentType: undefined,
                DeleteMarker: undefined,
                ETag: undefined,
                Expiration: undefined,
                Expires: undefined,
                LastModified: undefined,
                Metadata: undefined,
                MissingMeta: undefined,
                ObjectLockLegalHoldStatus: undefined,
                ObjectLockMode: undefined,
                ObjectLockRetainUntilDate: undefined,
                PartsCount: undefined,
                ReplicationStatus: undefined,
                RequestCharged: undefined,
                Restore: undefined,
                SSECustomerAlgorithm: undefined,
                SSECustomerKeyMD5: undefined,
                SSEKMSKeyId: undefined,
                ServerSideEncryption: undefined,
                StorageClass: undefined,
                TagCount: undefined,
                VersionId: undefined,
                WebsiteRedirectLocation: undefined
            };
            if (output.headers["x-amz-object-lock-mode"] !== undefined) contents.ObjectLockMode = output.headers["x-amz-object-lock-mode"];
            if (output.headers["content-language"] !== undefined) contents.ContentLanguage = output.headers["content-language"];
            if (output.headers["content-disposition"] !== undefined) contents.ContentDisposition = output.headers["content-disposition"];
            if (output.headers["cache-control"] !== undefined) contents.CacheControl = output.headers["cache-control"];
            if (output.headers["content-type"] !== undefined) contents.ContentType = output.headers["content-type"];
            if (output.headers["content-range"] !== undefined) contents.ContentRange = output.headers["content-range"];
            if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
            if (output.headers["content-length"] !== undefined) contents.ContentLength = parseInt(output.headers["content-length"], 10);
            if (output.headers["x-amz-object-lock-retain-until-date"] !== undefined) contents.ObjectLockRetainUntilDate = new Date(output.headers["x-amz-object-lock-retain-until-date"]);
            if (output.headers["x-amz-object-lock-legal-hold"] !== undefined) contents.ObjectLockLegalHoldStatus = output.headers["x-amz-object-lock-legal-hold"];
            if (output.headers["x-amz-delete-marker"] !== undefined) contents.DeleteMarker = output.headers["x-amz-delete-marker"] === "true";
            if (output.headers["x-amz-storage-class"] !== undefined) contents.StorageClass = output.headers["x-amz-storage-class"];
            if (output.headers["content-encoding"] !== undefined) contents.ContentEncoding = output.headers["content-encoding"];
            if (output.headers["x-amz-restore"] !== undefined) contents.Restore = output.headers["x-amz-restore"];
            if (output.headers["x-amz-website-redirect-location"] !== undefined) contents.WebsiteRedirectLocation = output.headers["x-amz-website-redirect-location"];
            if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
            if (output.headers["x-amz-mp-parts-count"] !== undefined) contents.PartsCount = parseInt(output.headers["x-amz-mp-parts-count"], 10);
            if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
            if (output.headers["accept-ranges"] !== undefined) contents.AcceptRanges = output.headers["accept-ranges"];
            if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
            if (output.headers["expires"] !== undefined) contents.Expires = new Date(output.headers["expires"]);
            if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
            if (output.headers["x-amz-missing-meta"] !== undefined) contents.MissingMeta = parseInt(output.headers["x-amz-missing-meta"], 10);
            if (output.headers["x-amz-replication-status"] !== undefined) contents.ReplicationStatus = output.headers["x-amz-replication-status"];
            if (output.headers["x-amz-tagging-count"] !== undefined) contents.TagCount = parseInt(output.headers["x-amz-tagging-count"], 10);
            if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
            if (output.headers["last-modified"] !== undefined) contents.LastModified = new Date(output.headers["last-modified"]);
            if (output.headers["etag"] !== undefined) contents.ETag = output.headers["etag"];
            if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
            Object.keys(output.headers).forEach(function(header) {
                if (contents.Metadata === undefined) contents.Metadata = {};
                if (header.startsWith("x-amz-meta-")) contents.Metadata[header.substring(11)] = output.headers[header];
            });
            data = output.body;
            contents.Body = data;
            return [
                2 /*return*/ ,
                Promise.resolve(contents)
            ];
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetObjectCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $9OyH6.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $9OyH6.__assign).apply(void 0, [
                        (0, $9OyH6.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$7334ba1348400806 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetObjectAclCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        Grants: undefined,
                        Owner: undefined,
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.AccessControlList === "") contents.Grants = [];
                    if (data["AccessControlList"] !== undefined && data["AccessControlList"]["Grant"] !== undefined) contents.Grants = $4ff95607e2fba8c2$var$deserializeAws_restXmlGrants((0, $3aFL9.getArrayIfSingleItem)(data["AccessControlList"]["Grant"]), context);
                    if (data["Owner"] !== undefined) contents.Owner = $4ff95607e2fba8c2$var$deserializeAws_restXmlOwner(data["Owner"], context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetObjectAclCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $9OyH6.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $9OyH6.__assign).apply(void 0, [
                        (0, $9OyH6.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$3fe12927f071d9c2 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetObjectLegalHoldCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        LegalHold: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.LegalHold = $4ff95607e2fba8c2$var$deserializeAws_restXmlObjectLockLegalHold(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetObjectLegalHoldCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$8a6b0973efae922a = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetObjectLockConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        ObjectLockConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.ObjectLockConfiguration = $4ff95607e2fba8c2$var$deserializeAws_restXmlObjectLockConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetObjectLockConfigurationCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$e8bb8c760a500abf = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetObjectRetentionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        Retention: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.Retention = $4ff95607e2fba8c2$var$deserializeAws_restXmlObjectLockRetention(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetObjectRetentionCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$b55a093fbe745f1a = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetObjectTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        TagSet: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.TagSet === "") contents.TagSet = [];
                    if (data["TagSet"] !== undefined && data["TagSet"]["Tag"] !== undefined) contents.TagSet = $4ff95607e2fba8c2$var$deserializeAws_restXmlTagSet((0, $3aFL9.getArrayIfSingleItem)(data["TagSet"]["Tag"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetObjectTaggingCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$77cab76edb05348f = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2 /*return*/ ,
                $4ff95607e2fba8c2$var$deserializeAws_restXmlGetObjectTorrentCommandError(output, context)
            ];
            contents = {
                $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                Body: undefined,
                RequestCharged: undefined
            };
            if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
            data = output.body;
            contents.Body = data;
            return [
                2 /*return*/ ,
                Promise.resolve(contents)
            ];
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetObjectTorrentCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$ca2eb582f189d59e = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlGetPublicAccessBlockCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        PublicAccessBlockConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.PublicAccessBlockConfiguration = $4ff95607e2fba8c2$var$deserializeAws_restXmlPublicAccessBlockConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGetPublicAccessBlockCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$7da61a6d1be4855c = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlHeadBucketCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlHeadBucketCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $9OyH6.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlNoSuchBucketResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $9OyH6.__assign).apply(void 0, [
                        (0, $9OyH6.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$6facb3b50649bd07 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlHeadObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        AcceptRanges: undefined,
                        CacheControl: undefined,
                        ContentDisposition: undefined,
                        ContentEncoding: undefined,
                        ContentLanguage: undefined,
                        ContentLength: undefined,
                        ContentType: undefined,
                        DeleteMarker: undefined,
                        ETag: undefined,
                        Expiration: undefined,
                        Expires: undefined,
                        LastModified: undefined,
                        Metadata: undefined,
                        MissingMeta: undefined,
                        ObjectLockLegalHoldStatus: undefined,
                        ObjectLockMode: undefined,
                        ObjectLockRetainUntilDate: undefined,
                        PartsCount: undefined,
                        ReplicationStatus: undefined,
                        RequestCharged: undefined,
                        Restore: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        StorageClass: undefined,
                        VersionId: undefined,
                        WebsiteRedirectLocation: undefined
                    };
                    if (output.headers["cache-control"] !== undefined) contents.CacheControl = output.headers["cache-control"];
                    if (output.headers["content-length"] !== undefined) contents.ContentLength = parseInt(output.headers["content-length"], 10);
                    if (output.headers["x-amz-object-lock-retain-until-date"] !== undefined) contents.ObjectLockRetainUntilDate = new Date(output.headers["x-amz-object-lock-retain-until-date"]);
                    if (output.headers["content-type"] !== undefined) contents.ContentType = output.headers["content-type"];
                    if (output.headers["etag"] !== undefined) contents.ETag = output.headers["etag"];
                    if (output.headers["content-disposition"] !== undefined) contents.ContentDisposition = output.headers["content-disposition"];
                    if (output.headers["content-language"] !== undefined) contents.ContentLanguage = output.headers["content-language"];
                    if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
                    if (output.headers["expires"] !== undefined) contents.Expires = new Date(output.headers["expires"]);
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-replication-status"] !== undefined) contents.ReplicationStatus = output.headers["x-amz-replication-status"];
                    if (output.headers["x-amz-object-lock-legal-hold"] !== undefined) contents.ObjectLockLegalHoldStatus = output.headers["x-amz-object-lock-legal-hold"];
                    if (output.headers["x-amz-website-redirect-location"] !== undefined) contents.WebsiteRedirectLocation = output.headers["x-amz-website-redirect-location"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-mp-parts-count"] !== undefined) contents.PartsCount = parseInt(output.headers["x-amz-mp-parts-count"], 10);
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["last-modified"] !== undefined) contents.LastModified = new Date(output.headers["last-modified"]);
                    if (output.headers["x-amz-missing-meta"] !== undefined) contents.MissingMeta = parseInt(output.headers["x-amz-missing-meta"], 10);
                    if (output.headers["x-amz-restore"] !== undefined) contents.Restore = output.headers["x-amz-restore"];
                    if (output.headers["content-encoding"] !== undefined) contents.ContentEncoding = output.headers["content-encoding"];
                    if (output.headers["x-amz-storage-class"] !== undefined) contents.StorageClass = output.headers["x-amz-storage-class"];
                    if (output.headers["x-amz-delete-marker"] !== undefined) contents.DeleteMarker = output.headers["x-amz-delete-marker"] === "true";
                    if (output.headers["x-amz-object-lock-mode"] !== undefined) contents.ObjectLockMode = output.headers["x-amz-object-lock-mode"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["accept-ranges"] !== undefined) contents.AcceptRanges = output.headers["accept-ranges"];
                    Object.keys(output.headers).forEach(function(header) {
                        if (contents.Metadata === undefined) contents.Metadata = {};
                        if (header.startsWith("x-amz-meta-")) contents.Metadata[header.substring(11)] = output.headers[header];
                    });
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlHeadObjectCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $9OyH6.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $9OyH6.__assign).apply(void 0, [
                        (0, $9OyH6.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$7c3a4eeaff09f66a = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlListBucketAnalyticsConfigurationsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        AnalyticsConfigurationList: undefined,
                        ContinuationToken: undefined,
                        IsTruncated: undefined,
                        NextContinuationToken: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.AnalyticsConfiguration === "") contents.AnalyticsConfigurationList = [];
                    if (data["AnalyticsConfiguration"] !== undefined) contents.AnalyticsConfigurationList = $4ff95607e2fba8c2$var$deserializeAws_restXmlAnalyticsConfigurationList((0, $3aFL9.getArrayIfSingleItem)(data["AnalyticsConfiguration"]), context);
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlListBucketAnalyticsConfigurationsCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$690ef4b20b3078b6 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlListBucketInventoryConfigurationsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        ContinuationToken: undefined,
                        InventoryConfigurationList: undefined,
                        IsTruncated: undefined,
                        NextContinuationToken: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data.InventoryConfiguration === "") contents.InventoryConfigurationList = [];
                    if (data["InventoryConfiguration"] !== undefined) contents.InventoryConfigurationList = $4ff95607e2fba8c2$var$deserializeAws_restXmlInventoryConfigurationList((0, $3aFL9.getArrayIfSingleItem)(data["InventoryConfiguration"]), context);
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlListBucketInventoryConfigurationsCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$906cb5e8f067f67 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlListBucketMetricsConfigurationsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        ContinuationToken: undefined,
                        IsTruncated: undefined,
                        MetricsConfigurationList: undefined,
                        NextContinuationToken: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data.MetricsConfiguration === "") contents.MetricsConfigurationList = [];
                    if (data["MetricsConfiguration"] !== undefined) contents.MetricsConfigurationList = $4ff95607e2fba8c2$var$deserializeAws_restXmlMetricsConfigurationList((0, $3aFL9.getArrayIfSingleItem)(data["MetricsConfiguration"]), context);
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlListBucketMetricsConfigurationsCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$63be43683e761a25 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlListBucketsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        Buckets: undefined,
                        Owner: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.Buckets === "") contents.Buckets = [];
                    if (data["Buckets"] !== undefined && data["Buckets"]["Bucket"] !== undefined) contents.Buckets = $4ff95607e2fba8c2$var$deserializeAws_restXmlBuckets((0, $3aFL9.getArrayIfSingleItem)(data["Buckets"]["Bucket"]), context);
                    if (data["Owner"] !== undefined) contents.Owner = $4ff95607e2fba8c2$var$deserializeAws_restXmlOwner(data["Owner"], context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlListBucketsCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$8da47d46285c7a0 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlListMultipartUploadsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        Bucket: undefined,
                        CommonPrefixes: undefined,
                        Delimiter: undefined,
                        EncodingType: undefined,
                        IsTruncated: undefined,
                        KeyMarker: undefined,
                        MaxUploads: undefined,
                        NextKeyMarker: undefined,
                        NextUploadIdMarker: undefined,
                        Prefix: undefined,
                        UploadIdMarker: undefined,
                        Uploads: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Bucket"] !== undefined) contents.Bucket = data["Bucket"];
                    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
                    if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $4ff95607e2fba8c2$var$deserializeAws_restXmlCommonPrefixList((0, $3aFL9.getArrayIfSingleItem)(data["CommonPrefixes"]), context);
                    if (data["Delimiter"] !== undefined) contents.Delimiter = data["Delimiter"];
                    if (data["EncodingType"] !== undefined) contents.EncodingType = data["EncodingType"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["KeyMarker"] !== undefined) contents.KeyMarker = data["KeyMarker"];
                    if (data["MaxUploads"] !== undefined) contents.MaxUploads = parseInt(data["MaxUploads"]);
                    if (data["NextKeyMarker"] !== undefined) contents.NextKeyMarker = data["NextKeyMarker"];
                    if (data["NextUploadIdMarker"] !== undefined) contents.NextUploadIdMarker = data["NextUploadIdMarker"];
                    if (data["Prefix"] !== undefined) contents.Prefix = data["Prefix"];
                    if (data["UploadIdMarker"] !== undefined) contents.UploadIdMarker = data["UploadIdMarker"];
                    if (data.Upload === "") contents.Uploads = [];
                    if (data["Upload"] !== undefined) contents.Uploads = $4ff95607e2fba8c2$var$deserializeAws_restXmlMultipartUploadList((0, $3aFL9.getArrayIfSingleItem)(data["Upload"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlListMultipartUploadsCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$f8d39cd754f5521d = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlListObjectsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        CommonPrefixes: undefined,
                        Contents: undefined,
                        Delimiter: undefined,
                        EncodingType: undefined,
                        IsTruncated: undefined,
                        Marker: undefined,
                        MaxKeys: undefined,
                        Name: undefined,
                        NextMarker: undefined,
                        Prefix: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
                    if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $4ff95607e2fba8c2$var$deserializeAws_restXmlCommonPrefixList((0, $3aFL9.getArrayIfSingleItem)(data["CommonPrefixes"]), context);
                    if (data.Contents === "") contents.Contents = [];
                    if (data["Contents"] !== undefined) contents.Contents = $4ff95607e2fba8c2$var$deserializeAws_restXmlObjectList((0, $3aFL9.getArrayIfSingleItem)(data["Contents"]), context);
                    if (data["Delimiter"] !== undefined) contents.Delimiter = data["Delimiter"];
                    if (data["EncodingType"] !== undefined) contents.EncodingType = data["EncodingType"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["Marker"] !== undefined) contents.Marker = data["Marker"];
                    if (data["MaxKeys"] !== undefined) contents.MaxKeys = parseInt(data["MaxKeys"]);
                    if (data["Name"] !== undefined) contents.Name = data["Name"];
                    if (data["NextMarker"] !== undefined) contents.NextMarker = data["NextMarker"];
                    if (data["Prefix"] !== undefined) contents.Prefix = data["Prefix"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlListObjectsCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $9OyH6.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlNoSuchBucketResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $9OyH6.__assign).apply(void 0, [
                        (0, $9OyH6.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$2b371fcdd686ba8b = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlListObjectsV2CommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        CommonPrefixes: undefined,
                        Contents: undefined,
                        ContinuationToken: undefined,
                        Delimiter: undefined,
                        EncodingType: undefined,
                        IsTruncated: undefined,
                        KeyCount: undefined,
                        MaxKeys: undefined,
                        Name: undefined,
                        NextContinuationToken: undefined,
                        Prefix: undefined,
                        StartAfter: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
                    if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $4ff95607e2fba8c2$var$deserializeAws_restXmlCommonPrefixList((0, $3aFL9.getArrayIfSingleItem)(data["CommonPrefixes"]), context);
                    if (data.Contents === "") contents.Contents = [];
                    if (data["Contents"] !== undefined) contents.Contents = $4ff95607e2fba8c2$var$deserializeAws_restXmlObjectList((0, $3aFL9.getArrayIfSingleItem)(data["Contents"]), context);
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data["Delimiter"] !== undefined) contents.Delimiter = data["Delimiter"];
                    if (data["EncodingType"] !== undefined) contents.EncodingType = data["EncodingType"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["KeyCount"] !== undefined) contents.KeyCount = parseInt(data["KeyCount"]);
                    if (data["MaxKeys"] !== undefined) contents.MaxKeys = parseInt(data["MaxKeys"]);
                    if (data["Name"] !== undefined) contents.Name = data["Name"];
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    if (data["Prefix"] !== undefined) contents.Prefix = data["Prefix"];
                    if (data["StartAfter"] !== undefined) contents.StartAfter = data["StartAfter"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlListObjectsV2CommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $9OyH6.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlNoSuchBucketResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $9OyH6.__assign).apply(void 0, [
                        (0, $9OyH6.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$637e7cd668cf8615 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlListObjectVersionsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        CommonPrefixes: undefined,
                        DeleteMarkers: undefined,
                        Delimiter: undefined,
                        EncodingType: undefined,
                        IsTruncated: undefined,
                        KeyMarker: undefined,
                        MaxKeys: undefined,
                        Name: undefined,
                        NextKeyMarker: undefined,
                        NextVersionIdMarker: undefined,
                        Prefix: undefined,
                        VersionIdMarker: undefined,
                        Versions: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
                    if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $4ff95607e2fba8c2$var$deserializeAws_restXmlCommonPrefixList((0, $3aFL9.getArrayIfSingleItem)(data["CommonPrefixes"]), context);
                    if (data.DeleteMarker === "") contents.DeleteMarkers = [];
                    if (data["DeleteMarker"] !== undefined) contents.DeleteMarkers = $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteMarkers((0, $3aFL9.getArrayIfSingleItem)(data["DeleteMarker"]), context);
                    if (data["Delimiter"] !== undefined) contents.Delimiter = data["Delimiter"];
                    if (data["EncodingType"] !== undefined) contents.EncodingType = data["EncodingType"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["KeyMarker"] !== undefined) contents.KeyMarker = data["KeyMarker"];
                    if (data["MaxKeys"] !== undefined) contents.MaxKeys = parseInt(data["MaxKeys"]);
                    if (data["Name"] !== undefined) contents.Name = data["Name"];
                    if (data["NextKeyMarker"] !== undefined) contents.NextKeyMarker = data["NextKeyMarker"];
                    if (data["NextVersionIdMarker"] !== undefined) contents.NextVersionIdMarker = data["NextVersionIdMarker"];
                    if (data["Prefix"] !== undefined) contents.Prefix = data["Prefix"];
                    if (data["VersionIdMarker"] !== undefined) contents.VersionIdMarker = data["VersionIdMarker"];
                    if (data.Version === "") contents.Versions = [];
                    if (data["Version"] !== undefined) contents.Versions = $4ff95607e2fba8c2$var$deserializeAws_restXmlObjectVersionList((0, $3aFL9.getArrayIfSingleItem)(data["Version"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlListObjectVersionsCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$584d994fd27ec2bb = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlListPartsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        AbortDate: undefined,
                        AbortRuleId: undefined,
                        Bucket: undefined,
                        Initiator: undefined,
                        IsTruncated: undefined,
                        Key: undefined,
                        MaxParts: undefined,
                        NextPartNumberMarker: undefined,
                        Owner: undefined,
                        PartNumberMarker: undefined,
                        Parts: undefined,
                        RequestCharged: undefined,
                        StorageClass: undefined,
                        UploadId: undefined
                    };
                    if (output.headers["x-amz-abort-rule-id"] !== undefined) contents.AbortRuleId = output.headers["x-amz-abort-rule-id"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["x-amz-abort-date"] !== undefined) contents.AbortDate = new Date(output.headers["x-amz-abort-date"]);
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Bucket"] !== undefined) contents.Bucket = data["Bucket"];
                    if (data["Initiator"] !== undefined) contents.Initiator = $4ff95607e2fba8c2$var$deserializeAws_restXmlInitiator(data["Initiator"], context);
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["Key"] !== undefined) contents.Key = data["Key"];
                    if (data["MaxParts"] !== undefined) contents.MaxParts = parseInt(data["MaxParts"]);
                    if (data["NextPartNumberMarker"] !== undefined) contents.NextPartNumberMarker = parseInt(data["NextPartNumberMarker"]);
                    if (data["Owner"] !== undefined) contents.Owner = $4ff95607e2fba8c2$var$deserializeAws_restXmlOwner(data["Owner"], context);
                    if (data["PartNumberMarker"] !== undefined) contents.PartNumberMarker = parseInt(data["PartNumberMarker"]);
                    if (data.Part === "") contents.Parts = [];
                    if (data["Part"] !== undefined) contents.Parts = $4ff95607e2fba8c2$var$deserializeAws_restXmlParts((0, $3aFL9.getArrayIfSingleItem)(data["Part"]), context);
                    if (data["StorageClass"] !== undefined) contents.StorageClass = data["StorageClass"];
                    if (data["UploadId"] !== undefined) contents.UploadId = data["UploadId"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlListPartsCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$e654cd63b770e3c4 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketAccelerateConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketAccelerateConfigurationCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$468a83c548434951 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketAclCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketAclCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$488c2e199ebb898d = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketAnalyticsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketAnalyticsConfigurationCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$3eb4d44bdf561f91 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketCorsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketCorsCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$d0f1e0a2cb4f5db6 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketEncryptionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketEncryptionCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$a7487a3c5377a809 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketInventoryConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketInventoryConfigurationCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$9e27fb99395eb8b3 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketLifecycleConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketLifecycleConfigurationCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$9e24aeee62aeef65 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketLoggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketLoggingCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$3a85a94ca87604e2 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketMetricsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketMetricsConfigurationCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$ec8129277a63ef1e = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketNotificationConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketNotificationConfigurationCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$8d1d3805e977d457 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketOwnershipControlsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketOwnershipControlsCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$2b7b6f0e8b2cc8a1 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketPolicyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketPolicyCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$8ea9e7fadc7c189a = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketReplicationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketReplicationCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$12b0ab2c5846a509 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketRequestPaymentCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketRequestPaymentCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$5bf4de3b4501436e = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketTaggingCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$ef405e59c399a368 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketVersioningCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketVersioningCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$514d37c55d4fb4b5 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketWebsiteCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutBucketWebsiteCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$45bbdbf5181c3607 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        ETag: undefined,
                        Expiration: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSEncryptionContext: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-server-side-encryption-context"] !== undefined) contents.SSEKMSEncryptionContext = output.headers["x-amz-server-side-encryption-context"];
                    if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["etag"] !== undefined) contents.ETag = output.headers["etag"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutObjectCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$e0d1dc79dd7bc4d6 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutObjectAclCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutObjectAclCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $9OyH6.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $9OyH6.__assign).apply(void 0, [
                        (0, $9OyH6.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$a32f5469ffeef979 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutObjectLegalHoldCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutObjectLegalHoldCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$470735cd3fe9e5b5 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutObjectLockConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutObjectLockConfigurationCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$5377eccfb6cedf8b = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutObjectRetentionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutObjectRetentionCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$cecf7bb838bf1182 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutObjectTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutObjectTaggingCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$7a1b291f9ae3d668 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlPutPublicAccessBlockCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPutPublicAccessBlockCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$317606d55789efe9 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlRestoreObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        RequestCharged: undefined,
                        RestoreOutputPath: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["x-amz-restore-output-path"] !== undefined) contents.RestoreOutputPath = output.headers["x-amz-restore-output-path"];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlRestoreObjectCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $9OyH6.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ObjectAlreadyInActiveTierError":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#ObjectAlreadyInActiveTierError":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlObjectAlreadyInActiveTierErrorResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $9OyH6.__assign).apply(void 0, [
                        (0, $9OyH6.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$285881e5f25758a3 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2 /*return*/ ,
                $4ff95607e2fba8c2$var$deserializeAws_restXmlSelectObjectContentCommandError(output, context)
            ];
            contents = {
                $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                Payload: undefined
            };
            data = context.eventStreamMarshaller.deserialize(output.body, function(event) {
                return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
                    var eventName, eventHeaders, eventMessage, parsedEvent;
                    var _a;
                    return (0, $9OyH6.__generator)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                eventName = Object.keys(event)[0];
                                eventHeaders = Object.entries(event[eventName].headers).reduce(function(accummulator, curr) {
                                    accummulator[curr[0]] = curr[1].value;
                                    return accummulator;
                                }, {});
                                eventMessage = {
                                    headers: eventHeaders,
                                    body: event[eventName].body
                                };
                                parsedEvent = (_a = {}, _a[eventName] = eventMessage, _a);
                                return [
                                    4 /*yield*/ ,
                                    $4ff95607e2fba8c2$var$deserializeAws_restXmlSelectObjectContentEventStream_event(parsedEvent, context)
                                ];
                            case 1:
                                return [
                                    2 /*return*/ ,
                                    _b.sent()
                                ];
                        }
                    });
                });
            });
            contents.Payload = data;
            return [
                2 /*return*/ ,
                Promise.resolve(contents)
            ];
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlSelectObjectContentCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$176ef954f1bec178 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlUploadPartCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        ETag: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined
                    };
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["etag"] !== undefined) contents.ETag = output.headers["etag"];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlUploadPartCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$export$460d1831a8acdf23 = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlUploadPartCopyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output),
                        CopyPartResult: undefined,
                        CopySourceVersionId: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined
                    };
                    if (output.headers["x-amz-copy-source-version-id"] !== undefined) contents.CopySourceVersionId = output.headers["x-amz-copy-source-version-id"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.CopyPartResult = $4ff95607e2fba8c2$var$deserializeAws_restXmlCopyPartResult(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlUploadPartCopyCommandError = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $9OyH6.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $9OyH6.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $9OyH6.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $4ff95607e2fba8c2$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlSelectObjectContentEventStream_event = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var _a, _b, _c, _d, _e;
        return (0, $9OyH6.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    if (!(output["Cont"] !== undefined)) return [
                        3 /*break*/ ,
                        2
                    ];
                    _a = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlContinuationEvent_event(output["Cont"], context)
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        (_a.Cont = _f.sent(), _a)
                    ];
                case 2:
                    if (!(output["Progress"] !== undefined)) return [
                        3 /*break*/ ,
                        4
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlProgressEvent_event(output["Progress"], context)
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        (_b.Progress = _f.sent(), _b)
                    ];
                case 4:
                    if (!(output["Stats"] !== undefined)) return [
                        3 /*break*/ ,
                        6
                    ];
                    _c = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlStatsEvent_event(output["Stats"], context)
                    ];
                case 5:
                    return [
                        2 /*return*/ ,
                        (_c.Stats = _f.sent(), _c)
                    ];
                case 6:
                    if (!(output["End"] !== undefined)) return [
                        3 /*break*/ ,
                        8
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlEndEvent_event(output["End"], context)
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        (_d.End = _f.sent(), _d)
                    ];
                case 8:
                    if (!(output["Records"] !== undefined)) return [
                        3 /*break*/ ,
                        10
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$deserializeAws_restXmlRecordsEvent_event(output["Records"], context)
                    ];
                case 9:
                    return [
                        2 /*return*/ ,
                        (_e.Records = _f.sent(), _e)
                    ];
                case 10:
                    return [
                        2 /*return*/ ,
                        {
                            $unknown: output
                        }
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlContinuationEvent_event = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            contents = {};
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlEndEvent_event = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            contents = {};
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlProgressEvent_event = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, _a;
        return (0, $9OyH6.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    contents = {};
                    _a = contents;
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    _a.Details = _b.sent();
                    return [
                        2 /*return*/ ,
                        contents
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlRecordsEvent_event = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $9OyH6.__generator)(this, function(_a) {
            contents = {};
            contents.Payload = output.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlStatsEvent_event = function(output, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, _a;
        return (0, $9OyH6.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    contents = {};
                    _a = contents;
                    return [
                        4 /*yield*/ ,
                        $4ff95607e2fba8c2$var$parseBody(output.body, context)
                    ];
                case 1:
                    _a.Details = _b.sent();
                    return [
                        2 /*return*/ ,
                        contents
                    ];
            }
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlBucketAlreadyExistsResponse = function(parsedOutput, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            contents = {
                name: "BucketAlreadyExists",
                $fault: "client",
                $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlBucketAlreadyOwnedByYouResponse = function(parsedOutput, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            contents = {
                name: "BucketAlreadyOwnedByYou",
                $fault: "client",
                $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlNoSuchBucketResponse = function(parsedOutput, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            contents = {
                name: "NoSuchBucket",
                $fault: "client",
                $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlNoSuchKeyResponse = function(parsedOutput, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            contents = {
                name: "NoSuchKey",
                $fault: "client",
                $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlNoSuchUploadResponse = function(parsedOutput, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            contents = {
                name: "NoSuchUpload",
                $fault: "client",
                $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlObjectAlreadyInActiveTierErrorResponse = function(parsedOutput, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            contents = {
                name: "ObjectAlreadyInActiveTierError",
                $fault: "client",
                $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlObjectNotInActiveTierErrorResponse = function(parsedOutput, context) {
    return (0, $9OyH6.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $9OyH6.__generator)(this, function(_a) {
            contents = {
                name: "ObjectNotInActiveTierError",
                $fault: "client",
                $metadata: $4ff95607e2fba8c2$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlAbortIncompleteMultipartUpload = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("AbortIncompleteMultipartUpload");
    if (input.DaysAfterInitiation !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("DaysAfterInitiation").addChildNode(new (0, $doQBX.XmlText)(String(input.DaysAfterInitiation))).withName("DaysAfterInitiation");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlAccelerateConfiguration = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("AccelerateConfiguration");
    if (input.Status !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("BucketAccelerateStatus").addChildNode(new (0, $doQBX.XmlText)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlAccessControlPolicy = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("AccessControlPolicy");
    if (input.Grants !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlGrants(input.Grants, context);
        var containerNode_1 = new (0, $dfLaw.XmlNode)("AccessControlList");
        nodes.map(function(node) {
            containerNode_1.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_1);
    }
    if (input.Owner !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlOwner(input.Owner, context).withName("Owner");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlAccessControlTranslation = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("AccessControlTranslation");
    if (input.Owner !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("OwnerOverride").addChildNode(new (0, $doQBX.XmlText)(input.Owner)).withName("Owner");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlAllowedHeaders = function(input, context) {
    return input.map(function(entry) {
        var node = new (0, $dfLaw.XmlNode)("AllowedHeader").addChildNode(new (0, $doQBX.XmlText)(entry));
        return node.withName("member");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlAllowedMethods = function(input, context) {
    return input.map(function(entry) {
        var node = new (0, $dfLaw.XmlNode)("AllowedMethod").addChildNode(new (0, $doQBX.XmlText)(entry));
        return node.withName("member");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlAllowedOrigins = function(input, context) {
    return input.map(function(entry) {
        var node = new (0, $dfLaw.XmlNode)("AllowedOrigin").addChildNode(new (0, $doQBX.XmlText)(entry));
        return node.withName("member");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlAnalyticsAndOperator = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("AnalyticsAndOperator");
    if (input.Prefix !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Prefix").addChildNode(new (0, $doQBX.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlAnalyticsConfiguration = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("AnalyticsConfiguration");
    if (input.StorageClassAnalysis !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlStorageClassAnalysis(input.StorageClassAnalysis, context).withName("StorageClassAnalysis");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlAnalyticsFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.Id !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("AnalyticsId").addChildNode(new (0, $doQBX.XmlText)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlAnalyticsExportDestination = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("AnalyticsExportDestination");
    if (input.S3BucketDestination !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlAnalyticsS3BucketDestination(input.S3BucketDestination, context).withName("S3BucketDestination");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlAnalyticsFilter = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("AnalyticsFilter");
    if (input.Prefix !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Prefix").addChildNode(new (0, $doQBX.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tag !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlTag(input.Tag, context).withName("Tag");
        bodyNode.addChildNode(node);
    }
    if (input.And !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlAnalyticsAndOperator(input.And, context).withName("And");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlAnalyticsS3BucketDestination = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("AnalyticsS3BucketDestination");
    if (input.Prefix !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Prefix").addChildNode(new (0, $doQBX.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.BucketAccountId !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("AccountId").addChildNode(new (0, $doQBX.XmlText)(input.BucketAccountId)).withName("BucketAccountId");
        bodyNode.addChildNode(node);
    }
    if (input.Bucket !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("BucketName").addChildNode(new (0, $doQBX.XmlText)(input.Bucket)).withName("Bucket");
        bodyNode.addChildNode(node);
    }
    if (input.Format !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("AnalyticsS3ExportFileFormat").addChildNode(new (0, $doQBX.XmlText)(input.Format)).withName("Format");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlBucketLifecycleConfiguration = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("BucketLifecycleConfiguration");
    if (input.Rules !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlLifecycleRules(input.Rules, context);
        nodes.map(function(node) {
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlBucketLoggingStatus = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("BucketLoggingStatus");
    if (input.LoggingEnabled !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlLoggingEnabled(input.LoggingEnabled, context).withName("LoggingEnabled");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlCompletedMultipartUpload = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("CompletedMultipartUpload");
    if (input.Parts !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlCompletedPartList(input.Parts, context);
        nodes.map(function(node) {
            node = node.withName("Part");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlCompletedPart = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("CompletedPart");
    if (input.ETag !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ETag").addChildNode(new (0, $doQBX.XmlText)(input.ETag)).withName("ETag");
        bodyNode.addChildNode(node);
    }
    if (input.PartNumber !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("PartNumber").addChildNode(new (0, $doQBX.XmlText)(String(input.PartNumber))).withName("PartNumber");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlCompletedPartList = function(input, context) {
    return input.map(function(entry) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlCompletedPart(entry, context);
        return node.withName("member");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlCondition = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("Condition");
    if (input.KeyPrefixEquals !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("KeyPrefixEquals").addChildNode(new (0, $doQBX.XmlText)(input.KeyPrefixEquals)).withName("KeyPrefixEquals");
        bodyNode.addChildNode(node);
    }
    if (input.HttpErrorCodeReturnedEquals !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("HttpErrorCodeReturnedEquals").addChildNode(new (0, $doQBX.XmlText)(input.HttpErrorCodeReturnedEquals)).withName("HttpErrorCodeReturnedEquals");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlCORSConfiguration = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("CORSConfiguration");
    if (input.CORSRules !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlCORSRules(input.CORSRules, context);
        nodes.map(function(node) {
            node = node.withName("CORSRule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlCORSRule = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("CORSRule");
    if (input.AllowedHeaders !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlAllowedHeaders(input.AllowedHeaders, context);
        nodes.map(function(node) {
            node = node.withName("AllowedHeader");
            bodyNode.addChildNode(node);
        });
    }
    if (input.AllowedOrigins !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlAllowedOrigins(input.AllowedOrigins, context);
        nodes.map(function(node) {
            node = node.withName("AllowedOrigin");
            bodyNode.addChildNode(node);
        });
    }
    if (input.MaxAgeSeconds !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("MaxAgeSeconds").addChildNode(new (0, $doQBX.XmlText)(String(input.MaxAgeSeconds))).withName("MaxAgeSeconds");
        bodyNode.addChildNode(node);
    }
    if (input.ExposeHeaders !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlExposeHeaders(input.ExposeHeaders, context);
        nodes.map(function(node) {
            node = node.withName("ExposeHeader");
            bodyNode.addChildNode(node);
        });
    }
    if (input.AllowedMethods !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlAllowedMethods(input.AllowedMethods, context);
        nodes.map(function(node) {
            node = node.withName("AllowedMethod");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlCORSRules = function(input, context) {
    return input.map(function(entry) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlCORSRule(entry, context);
        return node.withName("member");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlCreateBucketConfiguration = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("CreateBucketConfiguration");
    if (input.LocationConstraint !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("BucketLocationConstraint").addChildNode(new (0, $doQBX.XmlText)(input.LocationConstraint)).withName("LocationConstraint");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlCSVInput = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("CSVInput");
    if (input.FieldDelimiter !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("FieldDelimiter").addChildNode(new (0, $doQBX.XmlText)(input.FieldDelimiter)).withName("FieldDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.AllowQuotedRecordDelimiter !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("AllowQuotedRecordDelimiter").addChildNode(new (0, $doQBX.XmlText)(String(input.AllowQuotedRecordDelimiter))).withName("AllowQuotedRecordDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.FileHeaderInfo !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("FileHeaderInfo").addChildNode(new (0, $doQBX.XmlText)(input.FileHeaderInfo)).withName("FileHeaderInfo");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteCharacter !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("QuoteCharacter").addChildNode(new (0, $doQBX.XmlText)(input.QuoteCharacter)).withName("QuoteCharacter");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteEscapeCharacter !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("QuoteEscapeCharacter").addChildNode(new (0, $doQBX.XmlText)(input.QuoteEscapeCharacter)).withName("QuoteEscapeCharacter");
        bodyNode.addChildNode(node);
    }
    if (input.RecordDelimiter !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("RecordDelimiter").addChildNode(new (0, $doQBX.XmlText)(input.RecordDelimiter)).withName("RecordDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.Comments !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Comments").addChildNode(new (0, $doQBX.XmlText)(input.Comments)).withName("Comments");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlCSVOutput = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("CSVOutput");
    if (input.FieldDelimiter !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("FieldDelimiter").addChildNode(new (0, $doQBX.XmlText)(input.FieldDelimiter)).withName("FieldDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteFields !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("QuoteFields").addChildNode(new (0, $doQBX.XmlText)(input.QuoteFields)).withName("QuoteFields");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteCharacter !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("QuoteCharacter").addChildNode(new (0, $doQBX.XmlText)(input.QuoteCharacter)).withName("QuoteCharacter");
        bodyNode.addChildNode(node);
    }
    if (input.RecordDelimiter !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("RecordDelimiter").addChildNode(new (0, $doQBX.XmlText)(input.RecordDelimiter)).withName("RecordDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteEscapeCharacter !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("QuoteEscapeCharacter").addChildNode(new (0, $doQBX.XmlText)(input.QuoteEscapeCharacter)).withName("QuoteEscapeCharacter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlDefaultRetention = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("DefaultRetention");
    if (input.Days !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Days").addChildNode(new (0, $doQBX.XmlText)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.Mode !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ObjectLockRetentionMode").addChildNode(new (0, $doQBX.XmlText)(input.Mode)).withName("Mode");
        bodyNode.addChildNode(node);
    }
    if (input.Years !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Years").addChildNode(new (0, $doQBX.XmlText)(String(input.Years))).withName("Years");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlDelete = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("Delete");
    if (input.Objects !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlObjectIdentifierList(input.Objects, context);
        nodes.map(function(node) {
            node = node.withName("Object");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Quiet !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Quiet").addChildNode(new (0, $doQBX.XmlText)(String(input.Quiet))).withName("Quiet");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlDeleteMarkerReplication = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("DeleteMarkerReplication");
    if (input.Status !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("DeleteMarkerReplicationStatus").addChildNode(new (0, $doQBX.XmlText)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlDestination = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("Destination");
    if (input.EncryptionConfiguration !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlEncryptionConfiguration(input.EncryptionConfiguration, context).withName("EncryptionConfiguration");
        bodyNode.addChildNode(node);
    }
    if (input.Bucket !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("BucketName").addChildNode(new (0, $doQBX.XmlText)(input.Bucket)).withName("Bucket");
        bodyNode.addChildNode(node);
    }
    if (input.Account !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("AccountId").addChildNode(new (0, $doQBX.XmlText)(input.Account)).withName("Account");
        bodyNode.addChildNode(node);
    }
    if (input.StorageClass !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("StorageClass").addChildNode(new (0, $doQBX.XmlText)(input.StorageClass)).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    if (input.Metrics !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlMetrics(input.Metrics, context).withName("Metrics");
        bodyNode.addChildNode(node);
    }
    if (input.AccessControlTranslation !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlAccessControlTranslation(input.AccessControlTranslation, context).withName("AccessControlTranslation");
        bodyNode.addChildNode(node);
    }
    if (input.ReplicationTime !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlReplicationTime(input.ReplicationTime, context).withName("ReplicationTime");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlEncryption = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("Encryption");
    if (input.KMSKeyId !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("SSEKMSKeyId").addChildNode(new (0, $doQBX.XmlText)(input.KMSKeyId)).withName("KMSKeyId");
        bodyNode.addChildNode(node);
    }
    if (input.KMSContext !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("KMSContext").addChildNode(new (0, $doQBX.XmlText)(input.KMSContext)).withName("KMSContext");
        bodyNode.addChildNode(node);
    }
    if (input.EncryptionType !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ServerSideEncryption").addChildNode(new (0, $doQBX.XmlText)(input.EncryptionType)).withName("EncryptionType");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlEncryptionConfiguration = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("EncryptionConfiguration");
    if (input.ReplicaKmsKeyID !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ReplicaKmsKeyID").addChildNode(new (0, $doQBX.XmlText)(input.ReplicaKmsKeyID)).withName("ReplicaKmsKeyID");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlErrorDocument = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("ErrorDocument");
    if (input.Key !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ObjectKey").addChildNode(new (0, $doQBX.XmlText)(input.Key)).withName("Key");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlEventList = function(input, context) {
    return input.map(function(entry) {
        var node = new (0, $dfLaw.XmlNode)("Event").addChildNode(new (0, $doQBX.XmlText)(entry));
        return node.withName("member");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlExistingObjectReplication = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("ExistingObjectReplication");
    if (input.Status !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ExistingObjectReplicationStatus").addChildNode(new (0, $doQBX.XmlText)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlExposeHeaders = function(input, context) {
    return input.map(function(entry) {
        var node = new (0, $dfLaw.XmlNode)("ExposeHeader").addChildNode(new (0, $doQBX.XmlText)(entry));
        return node.withName("member");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlFilterRule = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("FilterRule");
    if (input.Name !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("FilterRuleName").addChildNode(new (0, $doQBX.XmlText)(input.Name)).withName("Name");
        bodyNode.addChildNode(node);
    }
    if (input.Value !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("FilterRuleValue").addChildNode(new (0, $doQBX.XmlText)(input.Value)).withName("Value");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlFilterRuleList = function(input, context) {
    return input.map(function(entry) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlFilterRule(entry, context);
        return node.withName("member");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlGlacierJobParameters = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("GlacierJobParameters");
    if (input.Tier !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Tier").addChildNode(new (0, $doQBX.XmlText)(input.Tier)).withName("Tier");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlGrant = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("Grant");
    if (input.Grantee !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlGrantee(input.Grantee, context).withName("Grantee");
        bodyNode.addChildNode(node);
    }
    if (input.Permission !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Permission").addChildNode(new (0, $doQBX.XmlText)(input.Permission)).withName("Permission");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlGrantee = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("Grantee");
    if (input.EmailAddress !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("EmailAddress").addChildNode(new (0, $doQBX.XmlText)(input.EmailAddress)).withName("EmailAddress");
        bodyNode.addChildNode(node);
    }
    if (input.DisplayName !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("DisplayName").addChildNode(new (0, $doQBX.XmlText)(input.DisplayName)).withName("DisplayName");
        bodyNode.addChildNode(node);
    }
    if (input.URI !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("URI").addChildNode(new (0, $doQBX.XmlText)(input.URI)).withName("URI");
        bodyNode.addChildNode(node);
    }
    if (input.ID !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ID").addChildNode(new (0, $doQBX.XmlText)(input.ID)).withName("ID");
        bodyNode.addChildNode(node);
    }
    if (input.Type !== undefined) bodyNode.addAttribute("xsi:type", input.Type);
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlGrants = function(input, context) {
    return input.map(function(entry) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlGrant(entry, context);
        return node.withName("Grant");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlIndexDocument = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("IndexDocument");
    if (input.Suffix !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Suffix").addChildNode(new (0, $doQBX.XmlText)(input.Suffix)).withName("Suffix");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlInputSerialization = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("InputSerialization");
    if (input.JSON !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlJSONInput(input.JSON, context).withName("JSON");
        bodyNode.addChildNode(node);
    }
    if (input.CompressionType !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("CompressionType").addChildNode(new (0, $doQBX.XmlText)(input.CompressionType)).withName("CompressionType");
        bodyNode.addChildNode(node);
    }
    if (input.Parquet !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlParquetInput(input.Parquet, context).withName("Parquet");
        bodyNode.addChildNode(node);
    }
    if (input.CSV !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlCSVInput(input.CSV, context).withName("CSV");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlInventoryConfiguration = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("InventoryConfiguration");
    if (input.IncludedObjectVersions !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("InventoryIncludedObjectVersions").addChildNode(new (0, $doQBX.XmlText)(input.IncludedObjectVersions)).withName("IncludedObjectVersions");
        bodyNode.addChildNode(node);
    }
    if (input.IsEnabled !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("IsEnabled").addChildNode(new (0, $doQBX.XmlText)(String(input.IsEnabled))).withName("IsEnabled");
        bodyNode.addChildNode(node);
    }
    if (input.Schedule !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlInventorySchedule(input.Schedule, context).withName("Schedule");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlInventoryFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.OptionalFields !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlInventoryOptionalFields(input.OptionalFields, context);
        var containerNode_2 = new (0, $dfLaw.XmlNode)("OptionalFields");
        nodes.map(function(node) {
            containerNode_2.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_2);
    }
    if (input.Destination !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlInventoryDestination(input.Destination, context).withName("Destination");
        bodyNode.addChildNode(node);
    }
    if (input.Id !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("InventoryId").addChildNode(new (0, $doQBX.XmlText)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlInventoryDestination = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("InventoryDestination");
    if (input.S3BucketDestination !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlInventoryS3BucketDestination(input.S3BucketDestination, context).withName("S3BucketDestination");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlInventoryEncryption = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("InventoryEncryption");
    if (input.SSEKMS !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlSSEKMS(input.SSEKMS, context).withName("SSE-KMS");
        bodyNode.addChildNode(node);
    }
    if (input.SSES3 !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlSSES3(input.SSES3, context).withName("SSE-S3");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlInventoryFilter = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("InventoryFilter");
    if (input.Prefix !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Prefix").addChildNode(new (0, $doQBX.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlInventoryOptionalFields = function(input, context) {
    return input.map(function(entry) {
        var node = new (0, $dfLaw.XmlNode)("InventoryOptionalField").addChildNode(new (0, $doQBX.XmlText)(entry));
        return node.withName("Field");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlInventoryS3BucketDestination = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("InventoryS3BucketDestination");
    if (input.Format !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("InventoryFormat").addChildNode(new (0, $doQBX.XmlText)(input.Format)).withName("Format");
        bodyNode.addChildNode(node);
    }
    if (input.Encryption !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlInventoryEncryption(input.Encryption, context).withName("Encryption");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Prefix").addChildNode(new (0, $doQBX.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Bucket !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("BucketName").addChildNode(new (0, $doQBX.XmlText)(input.Bucket)).withName("Bucket");
        bodyNode.addChildNode(node);
    }
    if (input.AccountId !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("AccountId").addChildNode(new (0, $doQBX.XmlText)(input.AccountId)).withName("AccountId");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlInventorySchedule = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("InventorySchedule");
    if (input.Frequency !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("InventoryFrequency").addChildNode(new (0, $doQBX.XmlText)(input.Frequency)).withName("Frequency");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlJSONInput = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("JSONInput");
    if (input.Type !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("JSONType").addChildNode(new (0, $doQBX.XmlText)(input.Type)).withName("Type");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlJSONOutput = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("JSONOutput");
    if (input.RecordDelimiter !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("RecordDelimiter").addChildNode(new (0, $doQBX.XmlText)(input.RecordDelimiter)).withName("RecordDelimiter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlLambdaFunctionConfiguration = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("LambdaFunctionConfiguration");
    if (input.Events !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlEventList(input.Events, context);
        nodes.map(function(node) {
            node = node.withName("Event");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Filter !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlNotificationConfigurationFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.LambdaFunctionArn !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("LambdaFunctionArn").addChildNode(new (0, $doQBX.XmlText)(input.LambdaFunctionArn)).withName("CloudFunction");
        bodyNode.addChildNode(node);
    }
    if (input.Id !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("NotificationId").addChildNode(new (0, $doQBX.XmlText)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlLambdaFunctionConfigurationList = function(input, context) {
    return input.map(function(entry) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlLambdaFunctionConfiguration(entry, context);
        return node.withName("member");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlLifecycleExpiration = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("LifecycleExpiration");
    if (input.Days !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Days").addChildNode(new (0, $doQBX.XmlText)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.ExpiredObjectDeleteMarker !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ExpiredObjectDeleteMarker").addChildNode(new (0, $doQBX.XmlText)(String(input.ExpiredObjectDeleteMarker))).withName("ExpiredObjectDeleteMarker");
        bodyNode.addChildNode(node);
    }
    if (input.Date !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Date").addChildNode(new (0, $doQBX.XmlText)(input.Date.toISOString().split(".")[0] + "Z")).withName("Date");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlLifecycleRule = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("LifecycleRule");
    if (input.NoncurrentVersionTransitions !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlNoncurrentVersionTransitionList(input.NoncurrentVersionTransitions, context);
        nodes.map(function(node) {
            node = node.withName("NoncurrentVersionTransition");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Expiration !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlLifecycleExpiration(input.Expiration, context).withName("Expiration");
        bodyNode.addChildNode(node);
    }
    if (input.ID !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ID").addChildNode(new (0, $doQBX.XmlText)(input.ID)).withName("ID");
        bodyNode.addChildNode(node);
    }
    if (input.Transitions !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlTransitionList(input.Transitions, context);
        nodes.map(function(node) {
            node = node.withName("Transition");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Prefix !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Prefix").addChildNode(new (0, $doQBX.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.NoncurrentVersionExpiration !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlNoncurrentVersionExpiration(input.NoncurrentVersionExpiration, context).withName("NoncurrentVersionExpiration");
        bodyNode.addChildNode(node);
    }
    if (input.AbortIncompleteMultipartUpload !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlAbortIncompleteMultipartUpload(input.AbortIncompleteMultipartUpload, context).withName("AbortIncompleteMultipartUpload");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlLifecycleRuleFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.Status !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ExpirationStatus").addChildNode(new (0, $doQBX.XmlText)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlLifecycleRuleAndOperator = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("LifecycleRuleAndOperator");
    if (input.Prefix !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Prefix").addChildNode(new (0, $doQBX.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlLifecycleRuleFilter = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("LifecycleRuleFilter");
    if (input.And !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlLifecycleRuleAndOperator(input.And, context).withName("And");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Prefix").addChildNode(new (0, $doQBX.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tag !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlTag(input.Tag, context).withName("Tag");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlLifecycleRules = function(input, context) {
    return input.map(function(entry) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlLifecycleRule(entry, context);
        return node.withName("member");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlLoggingEnabled = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("LoggingEnabled");
    if (input.TargetGrants !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlTargetGrants(input.TargetGrants, context);
        var containerNode_3 = new (0, $dfLaw.XmlNode)("TargetGrants");
        nodes.map(function(node) {
            containerNode_3.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_3);
    }
    if (input.TargetBucket !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("TargetBucket").addChildNode(new (0, $doQBX.XmlText)(input.TargetBucket)).withName("TargetBucket");
        bodyNode.addChildNode(node);
    }
    if (input.TargetPrefix !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("TargetPrefix").addChildNode(new (0, $doQBX.XmlText)(input.TargetPrefix)).withName("TargetPrefix");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlMetadataEntry = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("MetadataEntry");
    if (input.Value !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("MetadataValue").addChildNode(new (0, $doQBX.XmlText)(input.Value)).withName("Value");
        bodyNode.addChildNode(node);
    }
    if (input.Name !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("MetadataKey").addChildNode(new (0, $doQBX.XmlText)(input.Name)).withName("Name");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlMetrics = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("Metrics");
    if (input.Status !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("MetricsStatus").addChildNode(new (0, $doQBX.XmlText)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.EventThreshold !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlReplicationTimeValue(input.EventThreshold, context).withName("EventThreshold");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlMetricsAndOperator = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("MetricsAndOperator");
    if (input.Prefix !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Prefix").addChildNode(new (0, $doQBX.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlMetricsConfiguration = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("MetricsConfiguration");
    if (input.Id !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("MetricsId").addChildNode(new (0, $doQBX.XmlText)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlMetricsFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlMetricsFilter = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("MetricsFilter");
    if (input.And !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlMetricsAndOperator(input.And, context).withName("And");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Prefix").addChildNode(new (0, $doQBX.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tag !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlTag(input.Tag, context).withName("Tag");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlNoncurrentVersionExpiration = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("NoncurrentVersionExpiration");
    if (input.NoncurrentDays !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Days").addChildNode(new (0, $doQBX.XmlText)(String(input.NoncurrentDays))).withName("NoncurrentDays");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlNoncurrentVersionTransition = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("NoncurrentVersionTransition");
    if (input.StorageClass !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("TransitionStorageClass").addChildNode(new (0, $doQBX.XmlText)(input.StorageClass)).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    if (input.NoncurrentDays !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Days").addChildNode(new (0, $doQBX.XmlText)(String(input.NoncurrentDays))).withName("NoncurrentDays");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlNoncurrentVersionTransitionList = function(input, context) {
    return input.map(function(entry) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlNoncurrentVersionTransition(entry, context);
        return node.withName("member");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlNotificationConfiguration = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("NotificationConfiguration");
    if (input.TopicConfigurations !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlTopicConfigurationList(input.TopicConfigurations, context);
        nodes.map(function(node) {
            node = node.withName("TopicConfiguration");
            bodyNode.addChildNode(node);
        });
    }
    if (input.QueueConfigurations !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlQueueConfigurationList(input.QueueConfigurations, context);
        nodes.map(function(node) {
            node = node.withName("QueueConfiguration");
            bodyNode.addChildNode(node);
        });
    }
    if (input.LambdaFunctionConfigurations !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlLambdaFunctionConfigurationList(input.LambdaFunctionConfigurations, context);
        nodes.map(function(node) {
            node = node.withName("CloudFunctionConfiguration");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlNotificationConfigurationFilter = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("NotificationConfigurationFilter");
    if (input.Key !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlS3KeyFilter(input.Key, context).withName("S3Key");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlObjectIdentifier = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("ObjectIdentifier");
    if (input.Key !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ObjectKey").addChildNode(new (0, $doQBX.XmlText)(input.Key)).withName("Key");
        bodyNode.addChildNode(node);
    }
    if (input.VersionId !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ObjectVersionId").addChildNode(new (0, $doQBX.XmlText)(input.VersionId)).withName("VersionId");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlObjectIdentifierList = function(input, context) {
    return input.map(function(entry) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlObjectIdentifier(entry, context);
        return node.withName("member");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlObjectLockConfiguration = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("ObjectLockConfiguration");
    if (input.ObjectLockEnabled !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ObjectLockEnabled").addChildNode(new (0, $doQBX.XmlText)(input.ObjectLockEnabled)).withName("ObjectLockEnabled");
        bodyNode.addChildNode(node);
    }
    if (input.Rule !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlObjectLockRule(input.Rule, context).withName("Rule");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlObjectLockLegalHold = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("ObjectLockLegalHold");
    if (input.Status !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ObjectLockLegalHoldStatus").addChildNode(new (0, $doQBX.XmlText)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlObjectLockRetention = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("ObjectLockRetention");
    if (input.Mode !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ObjectLockRetentionMode").addChildNode(new (0, $doQBX.XmlText)(input.Mode)).withName("Mode");
        bodyNode.addChildNode(node);
    }
    if (input.RetainUntilDate !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Date").addChildNode(new (0, $doQBX.XmlText)(input.RetainUntilDate.toISOString().split(".")[0] + "Z")).withName("RetainUntilDate");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlObjectLockRule = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("ObjectLockRule");
    if (input.DefaultRetention !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlDefaultRetention(input.DefaultRetention, context).withName("DefaultRetention");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlOutputLocation = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("OutputLocation");
    if (input.S3 !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlS3Location(input.S3, context).withName("S3");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlOutputSerialization = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("OutputSerialization");
    if (input.JSON !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlJSONOutput(input.JSON, context).withName("JSON");
        bodyNode.addChildNode(node);
    }
    if (input.CSV !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlCSVOutput(input.CSV, context).withName("CSV");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlOwner = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("Owner");
    if (input.DisplayName !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("DisplayName").addChildNode(new (0, $doQBX.XmlText)(input.DisplayName)).withName("DisplayName");
        bodyNode.addChildNode(node);
    }
    if (input.ID !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ID").addChildNode(new (0, $doQBX.XmlText)(input.ID)).withName("ID");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlOwnershipControls = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("OwnershipControls");
    if (input.Rules !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlOwnershipControlsRules(input.Rules, context);
        nodes.map(function(node) {
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlOwnershipControlsRule = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("OwnershipControlsRule");
    if (input.ObjectOwnership !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ObjectOwnership").addChildNode(new (0, $doQBX.XmlText)(input.ObjectOwnership)).withName("ObjectOwnership");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlOwnershipControlsRules = function(input, context) {
    return input.map(function(entry) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlOwnershipControlsRule(entry, context);
        return node.withName("member");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlParquetInput = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("ParquetInput");
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlPublicAccessBlockConfiguration = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("PublicAccessBlockConfiguration");
    if (input.BlockPublicPolicy !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Setting").addChildNode(new (0, $doQBX.XmlText)(String(input.BlockPublicPolicy))).withName("BlockPublicPolicy");
        bodyNode.addChildNode(node);
    }
    if (input.BlockPublicAcls !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Setting").addChildNode(new (0, $doQBX.XmlText)(String(input.BlockPublicAcls))).withName("BlockPublicAcls");
        bodyNode.addChildNode(node);
    }
    if (input.RestrictPublicBuckets !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Setting").addChildNode(new (0, $doQBX.XmlText)(String(input.RestrictPublicBuckets))).withName("RestrictPublicBuckets");
        bodyNode.addChildNode(node);
    }
    if (input.IgnorePublicAcls !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Setting").addChildNode(new (0, $doQBX.XmlText)(String(input.IgnorePublicAcls))).withName("IgnorePublicAcls");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlQueueConfiguration = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("QueueConfiguration");
    if (input.Events !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlEventList(input.Events, context);
        nodes.map(function(node) {
            node = node.withName("Event");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Id !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("NotificationId").addChildNode(new (0, $doQBX.XmlText)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlNotificationConfigurationFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.QueueArn !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("QueueArn").addChildNode(new (0, $doQBX.XmlText)(input.QueueArn)).withName("Queue");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlQueueConfigurationList = function(input, context) {
    return input.map(function(entry) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlQueueConfiguration(entry, context);
        return node.withName("member");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlRedirect = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("Redirect");
    if (input.HttpRedirectCode !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("HttpRedirectCode").addChildNode(new (0, $doQBX.XmlText)(input.HttpRedirectCode)).withName("HttpRedirectCode");
        bodyNode.addChildNode(node);
    }
    if (input.ReplaceKeyPrefixWith !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ReplaceKeyPrefixWith").addChildNode(new (0, $doQBX.XmlText)(input.ReplaceKeyPrefixWith)).withName("ReplaceKeyPrefixWith");
        bodyNode.addChildNode(node);
    }
    if (input.Protocol !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Protocol").addChildNode(new (0, $doQBX.XmlText)(input.Protocol)).withName("Protocol");
        bodyNode.addChildNode(node);
    }
    if (input.HostName !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("HostName").addChildNode(new (0, $doQBX.XmlText)(input.HostName)).withName("HostName");
        bodyNode.addChildNode(node);
    }
    if (input.ReplaceKeyWith !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ReplaceKeyWith").addChildNode(new (0, $doQBX.XmlText)(input.ReplaceKeyWith)).withName("ReplaceKeyWith");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlRedirectAllRequestsTo = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("RedirectAllRequestsTo");
    if (input.Protocol !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Protocol").addChildNode(new (0, $doQBX.XmlText)(input.Protocol)).withName("Protocol");
        bodyNode.addChildNode(node);
    }
    if (input.HostName !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("HostName").addChildNode(new (0, $doQBX.XmlText)(input.HostName)).withName("HostName");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlReplicationConfiguration = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("ReplicationConfiguration");
    if (input.Role !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Role").addChildNode(new (0, $doQBX.XmlText)(input.Role)).withName("Role");
        bodyNode.addChildNode(node);
    }
    if (input.Rules !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlReplicationRules(input.Rules, context);
        nodes.map(function(node) {
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlReplicationRule = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("ReplicationRule");
    if (input.Prefix !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Prefix").addChildNode(new (0, $doQBX.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.ID !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ID").addChildNode(new (0, $doQBX.XmlText)(input.ID)).withName("ID");
        bodyNode.addChildNode(node);
    }
    if (input.SourceSelectionCriteria !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlSourceSelectionCriteria(input.SourceSelectionCriteria, context).withName("SourceSelectionCriteria");
        bodyNode.addChildNode(node);
    }
    if (input.DeleteMarkerReplication !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlDeleteMarkerReplication(input.DeleteMarkerReplication, context).withName("DeleteMarkerReplication");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlReplicationRuleFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.Priority !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Priority").addChildNode(new (0, $doQBX.XmlText)(String(input.Priority))).withName("Priority");
        bodyNode.addChildNode(node);
    }
    if (input.Status !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ReplicationRuleStatus").addChildNode(new (0, $doQBX.XmlText)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.ExistingObjectReplication !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlExistingObjectReplication(input.ExistingObjectReplication, context).withName("ExistingObjectReplication");
        bodyNode.addChildNode(node);
    }
    if (input.Destination !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlDestination(input.Destination, context).withName("Destination");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlReplicationRuleAndOperator = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("ReplicationRuleAndOperator");
    if (input.Prefix !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Prefix").addChildNode(new (0, $doQBX.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlReplicationRuleFilter = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("ReplicationRuleFilter");
    if (input.Tag !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlTag(input.Tag, context).withName("Tag");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Prefix").addChildNode(new (0, $doQBX.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.And !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlReplicationRuleAndOperator(input.And, context).withName("And");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlReplicationRules = function(input, context) {
    return input.map(function(entry) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlReplicationRule(entry, context);
        return node.withName("member");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlReplicationTime = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("ReplicationTime");
    if (input.Time !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlReplicationTimeValue(input.Time, context).withName("Time");
        bodyNode.addChildNode(node);
    }
    if (input.Status !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ReplicationTimeStatus").addChildNode(new (0, $doQBX.XmlText)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlReplicationTimeValue = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("ReplicationTimeValue");
    if (input.Minutes !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Minutes").addChildNode(new (0, $doQBX.XmlText)(String(input.Minutes))).withName("Minutes");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlRequestPaymentConfiguration = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("RequestPaymentConfiguration");
    if (input.Payer !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Payer").addChildNode(new (0, $doQBX.XmlText)(input.Payer)).withName("Payer");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlRequestProgress = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("RequestProgress");
    if (input.Enabled !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("EnableRequestProgress").addChildNode(new (0, $doQBX.XmlText)(String(input.Enabled))).withName("Enabled");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlRestoreRequest = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("RestoreRequest");
    if (input.GlacierJobParameters !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlGlacierJobParameters(input.GlacierJobParameters, context).withName("GlacierJobParameters");
        bodyNode.addChildNode(node);
    }
    if (input.Days !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Days").addChildNode(new (0, $doQBX.XmlText)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.OutputLocation !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlOutputLocation(input.OutputLocation, context).withName("OutputLocation");
        bodyNode.addChildNode(node);
    }
    if (input.SelectParameters !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlSelectParameters(input.SelectParameters, context).withName("SelectParameters");
        bodyNode.addChildNode(node);
    }
    if (input.Tier !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Tier").addChildNode(new (0, $doQBX.XmlText)(input.Tier)).withName("Tier");
        bodyNode.addChildNode(node);
    }
    if (input.Description !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Description").addChildNode(new (0, $doQBX.XmlText)(input.Description)).withName("Description");
        bodyNode.addChildNode(node);
    }
    if (input.Type !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("RestoreRequestType").addChildNode(new (0, $doQBX.XmlText)(input.Type)).withName("Type");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlRoutingRule = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("RoutingRule");
    if (input.Redirect !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlRedirect(input.Redirect, context).withName("Redirect");
        bodyNode.addChildNode(node);
    }
    if (input.Condition !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlCondition(input.Condition, context).withName("Condition");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlRoutingRules = function(input, context) {
    return input.map(function(entry) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlRoutingRule(entry, context);
        return node.withName("RoutingRule");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlS3KeyFilter = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("S3KeyFilter");
    if (input.FilterRules !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlFilterRuleList(input.FilterRules, context);
        nodes.map(function(node) {
            node = node.withName("FilterRule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlS3Location = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("S3Location");
    if (input.BucketName !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("BucketName").addChildNode(new (0, $doQBX.XmlText)(input.BucketName)).withName("BucketName");
        bodyNode.addChildNode(node);
    }
    if (input.StorageClass !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("StorageClass").addChildNode(new (0, $doQBX.XmlText)(input.StorageClass)).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    if (input.CannedACL !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ObjectCannedACL").addChildNode(new (0, $doQBX.XmlText)(input.CannedACL)).withName("CannedACL");
        bodyNode.addChildNode(node);
    }
    if (input.UserMetadata !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlUserMetadata(input.UserMetadata, context);
        var containerNode_4 = new (0, $dfLaw.XmlNode)("UserMetadata");
        nodes.map(function(node) {
            containerNode_4.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_4);
    }
    if (input.Prefix !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("LocationPrefix").addChildNode(new (0, $doQBX.XmlText)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tagging !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlTagging(input.Tagging, context).withName("Tagging");
        bodyNode.addChildNode(node);
    }
    if (input.Encryption !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlEncryption(input.Encryption, context).withName("Encryption");
        bodyNode.addChildNode(node);
    }
    if (input.AccessControlList !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlGrants(input.AccessControlList, context);
        var containerNode_5 = new (0, $dfLaw.XmlNode)("AccessControlList");
        nodes.map(function(node) {
            containerNode_5.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_5);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlScanRange = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("ScanRange");
    if (input.End !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("End").addChildNode(new (0, $doQBX.XmlText)(String(input.End))).withName("End");
        bodyNode.addChildNode(node);
    }
    if (input.Start !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Start").addChildNode(new (0, $doQBX.XmlText)(String(input.Start))).withName("Start");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlSelectParameters = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("SelectParameters");
    if (input.ExpressionType !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ExpressionType").addChildNode(new (0, $doQBX.XmlText)(input.ExpressionType)).withName("ExpressionType");
        bodyNode.addChildNode(node);
    }
    if (input.OutputSerialization !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlOutputSerialization(input.OutputSerialization, context).withName("OutputSerialization");
        bodyNode.addChildNode(node);
    }
    if (input.Expression !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Expression").addChildNode(new (0, $doQBX.XmlText)(input.Expression)).withName("Expression");
        bodyNode.addChildNode(node);
    }
    if (input.InputSerialization !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlInputSerialization(input.InputSerialization, context).withName("InputSerialization");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlServerSideEncryptionByDefault = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("ServerSideEncryptionByDefault");
    if (input.SSEAlgorithm !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ServerSideEncryption").addChildNode(new (0, $doQBX.XmlText)(input.SSEAlgorithm)).withName("SSEAlgorithm");
        bodyNode.addChildNode(node);
    }
    if (input.KMSMasterKeyID !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("SSEKMSKeyId").addChildNode(new (0, $doQBX.XmlText)(input.KMSMasterKeyID)).withName("KMSMasterKeyID");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlServerSideEncryptionConfiguration = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("ServerSideEncryptionConfiguration");
    if (input.Rules !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlServerSideEncryptionRules(input.Rules, context);
        nodes.map(function(node) {
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlServerSideEncryptionRule = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("ServerSideEncryptionRule");
    if (input.ApplyServerSideEncryptionByDefault !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlServerSideEncryptionByDefault(input.ApplyServerSideEncryptionByDefault, context).withName("ApplyServerSideEncryptionByDefault");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlServerSideEncryptionRules = function(input, context) {
    return input.map(function(entry) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlServerSideEncryptionRule(entry, context);
        return node.withName("member");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlSourceSelectionCriteria = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("SourceSelectionCriteria");
    if (input.SseKmsEncryptedObjects !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlSseKmsEncryptedObjects(input.SseKmsEncryptedObjects, context).withName("SseKmsEncryptedObjects");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlSSEKMS = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("SSE-KMS");
    if (input.KeyId !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("SSEKMSKeyId").addChildNode(new (0, $doQBX.XmlText)(input.KeyId)).withName("KeyId");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlSseKmsEncryptedObjects = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("SseKmsEncryptedObjects");
    if (input.Status !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("SseKmsEncryptedObjectsStatus").addChildNode(new (0, $doQBX.XmlText)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlSSES3 = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("SSE-S3");
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlStorageClassAnalysis = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("StorageClassAnalysis");
    if (input.DataExport !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlStorageClassAnalysisDataExport(input.DataExport, context).withName("DataExport");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlStorageClassAnalysisDataExport = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("StorageClassAnalysisDataExport");
    if (input.OutputSchemaVersion !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("StorageClassAnalysisSchemaVersion").addChildNode(new (0, $doQBX.XmlText)(input.OutputSchemaVersion)).withName("OutputSchemaVersion");
        bodyNode.addChildNode(node);
    }
    if (input.Destination !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlAnalyticsExportDestination(input.Destination, context).withName("Destination");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlTag = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("Tag");
    if (input.Value !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Value").addChildNode(new (0, $doQBX.XmlText)(input.Value)).withName("Value");
        bodyNode.addChildNode(node);
    }
    if (input.Key !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("ObjectKey").addChildNode(new (0, $doQBX.XmlText)(input.Key)).withName("Key");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlTagging = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("Tagging");
    if (input.TagSet !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlTagSet(input.TagSet, context);
        var containerNode_6 = new (0, $dfLaw.XmlNode)("TagSet");
        nodes.map(function(node) {
            containerNode_6.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_6);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlTagSet = function(input, context) {
    return input.map(function(entry) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlTag(entry, context);
        return node.withName("Tag");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlTargetGrant = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("TargetGrant");
    if (input.Grantee !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlGrantee(input.Grantee, context).withName("Grantee");
        bodyNode.addChildNode(node);
    }
    if (input.Permission !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("BucketLogsPermission").addChildNode(new (0, $doQBX.XmlText)(input.Permission)).withName("Permission");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlTargetGrants = function(input, context) {
    return input.map(function(entry) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlTargetGrant(entry, context);
        return node.withName("Grant");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlTopicConfiguration = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("TopicConfiguration");
    if (input.Events !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlEventList(input.Events, context);
        nodes.map(function(node) {
            node = node.withName("Event");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Filter !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlNotificationConfigurationFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.TopicArn !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("TopicArn").addChildNode(new (0, $doQBX.XmlText)(input.TopicArn)).withName("Topic");
        bodyNode.addChildNode(node);
    }
    if (input.Id !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("NotificationId").addChildNode(new (0, $doQBX.XmlText)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlTopicConfigurationList = function(input, context) {
    return input.map(function(entry) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlTopicConfiguration(entry, context);
        return node.withName("member");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlTransition = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("Transition");
    if (input.Days !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Days").addChildNode(new (0, $doQBX.XmlText)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.Date !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("Date").addChildNode(new (0, $doQBX.XmlText)(input.Date.toISOString().split(".")[0] + "Z")).withName("Date");
        bodyNode.addChildNode(node);
    }
    if (input.StorageClass !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("TransitionStorageClass").addChildNode(new (0, $doQBX.XmlText)(input.StorageClass)).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlTransitionList = function(input, context) {
    return input.map(function(entry) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlTransition(entry, context);
        return node.withName("member");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlUserMetadata = function(input, context) {
    return input.map(function(entry) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlMetadataEntry(entry, context);
        return node.withName("MetadataEntry");
    });
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlVersioningConfiguration = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("VersioningConfiguration");
    if (input.Status !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("BucketVersioningStatus").addChildNode(new (0, $doQBX.XmlText)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.MFADelete !== undefined) {
        var node = new (0, $dfLaw.XmlNode)("MFADelete").addChildNode(new (0, $doQBX.XmlText)(input.MFADelete)).withName("MfaDelete");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$serializeAws_restXmlWebsiteConfiguration = function(input, context) {
    var bodyNode = new (0, $dfLaw.XmlNode)("WebsiteConfiguration");
    if (input.ErrorDocument !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlErrorDocument(input.ErrorDocument, context).withName("ErrorDocument");
        bodyNode.addChildNode(node);
    }
    if (input.RedirectAllRequestsTo !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlRedirectAllRequestsTo(input.RedirectAllRequestsTo, context).withName("RedirectAllRequestsTo");
        bodyNode.addChildNode(node);
    }
    if (input.IndexDocument !== undefined) {
        var node = $4ff95607e2fba8c2$var$serializeAws_restXmlIndexDocument(input.IndexDocument, context).withName("IndexDocument");
        bodyNode.addChildNode(node);
    }
    if (input.RoutingRules !== undefined) {
        var nodes = $4ff95607e2fba8c2$var$serializeAws_restXmlRoutingRules(input.RoutingRules, context);
        var containerNode_7 = new (0, $dfLaw.XmlNode)("RoutingRules");
        nodes.map(function(node) {
            containerNode_7.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_7);
    }
    return bodyNode;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlAbortIncompleteMultipartUpload = function(output, context) {
    var contents = {
        DaysAfterInitiation: undefined
    };
    if (output["DaysAfterInitiation"] !== undefined) contents.DaysAfterInitiation = parseInt(output["DaysAfterInitiation"]);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlAccessControlTranslation = function(output, context) {
    var contents = {
        Owner: undefined
    };
    if (output["Owner"] !== undefined) contents.Owner = output["Owner"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlAllowedHeaders = function(output, context) {
    return (output || []).map(function(entry) {
        return entry;
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlAllowedMethods = function(output, context) {
    return (output || []).map(function(entry) {
        return entry;
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlAllowedOrigins = function(output, context) {
    return (output || []).map(function(entry) {
        return entry;
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlAnalyticsAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $4ff95607e2fba8c2$var$deserializeAws_restXmlTagSet((0, $3aFL9.getArrayIfSingleItem)(output["Tag"]), context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlAnalyticsConfiguration = function(output, context) {
    var contents = {
        StorageClassAnalysis: undefined,
        Filter: undefined,
        Id: undefined
    };
    if (output["StorageClassAnalysis"] !== undefined) contents.StorageClassAnalysis = $4ff95607e2fba8c2$var$deserializeAws_restXmlStorageClassAnalysis(output["StorageClassAnalysis"], context);
    if (output["Filter"] !== undefined) contents.Filter = $4ff95607e2fba8c2$var$deserializeAws_restXmlAnalyticsFilter(output["Filter"], context);
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlAnalyticsConfigurationList = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlAnalyticsConfiguration(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlAnalyticsExportDestination = function(output, context) {
    var contents = {
        S3BucketDestination: undefined
    };
    if (output["S3BucketDestination"] !== undefined) contents.S3BucketDestination = $4ff95607e2fba8c2$var$deserializeAws_restXmlAnalyticsS3BucketDestination(output["S3BucketDestination"], context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlAnalyticsFilter = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tag: undefined,
        And: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["Tag"] !== undefined) contents.Tag = $4ff95607e2fba8c2$var$deserializeAws_restXmlTag(output["Tag"], context);
    if (output["And"] !== undefined) contents.And = $4ff95607e2fba8c2$var$deserializeAws_restXmlAnalyticsAndOperator(output["And"], context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlAnalyticsS3BucketDestination = function(output, context) {
    var contents = {
        Prefix: undefined,
        BucketAccountId: undefined,
        Bucket: undefined,
        Format: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["BucketAccountId"] !== undefined) contents.BucketAccountId = output["BucketAccountId"];
    if (output["Bucket"] !== undefined) contents.Bucket = output["Bucket"];
    if (output["Format"] !== undefined) contents.Format = output["Format"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlBucket = function(output, context) {
    var contents = {
        CreationDate: undefined,
        Name: undefined
    };
    if (output["CreationDate"] !== undefined) contents.CreationDate = new Date(output["CreationDate"]);
    if (output["Name"] !== undefined) contents.Name = output["Name"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlBuckets = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlBucket(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlCommonPrefix = function(output, context) {
    var contents = {
        Prefix: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlCommonPrefixList = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlCommonPrefix(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlCondition = function(output, context) {
    var contents = {
        KeyPrefixEquals: undefined,
        HttpErrorCodeReturnedEquals: undefined
    };
    if (output["KeyPrefixEquals"] !== undefined) contents.KeyPrefixEquals = output["KeyPrefixEquals"];
    if (output["HttpErrorCodeReturnedEquals"] !== undefined) contents.HttpErrorCodeReturnedEquals = output["HttpErrorCodeReturnedEquals"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlCopyObjectResult = function(output, context) {
    var contents = {
        ETag: undefined,
        LastModified: undefined
    };
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlCopyPartResult = function(output, context) {
    var contents = {
        ETag: undefined,
        LastModified: undefined
    };
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlCORSRule = function(output, context) {
    var contents = {
        AllowedHeaders: undefined,
        AllowedOrigins: undefined,
        MaxAgeSeconds: undefined,
        ExposeHeaders: undefined,
        AllowedMethods: undefined
    };
    if (output.AllowedHeader === "") contents.AllowedHeaders = [];
    if (output["AllowedHeader"] !== undefined) contents.AllowedHeaders = $4ff95607e2fba8c2$var$deserializeAws_restXmlAllowedHeaders((0, $3aFL9.getArrayIfSingleItem)(output["AllowedHeader"]), context);
    if (output.AllowedOrigin === "") contents.AllowedOrigins = [];
    if (output["AllowedOrigin"] !== undefined) contents.AllowedOrigins = $4ff95607e2fba8c2$var$deserializeAws_restXmlAllowedOrigins((0, $3aFL9.getArrayIfSingleItem)(output["AllowedOrigin"]), context);
    if (output["MaxAgeSeconds"] !== undefined) contents.MaxAgeSeconds = parseInt(output["MaxAgeSeconds"]);
    if (output.ExposeHeader === "") contents.ExposeHeaders = [];
    if (output["ExposeHeader"] !== undefined) contents.ExposeHeaders = $4ff95607e2fba8c2$var$deserializeAws_restXmlExposeHeaders((0, $3aFL9.getArrayIfSingleItem)(output["ExposeHeader"]), context);
    if (output.AllowedMethod === "") contents.AllowedMethods = [];
    if (output["AllowedMethod"] !== undefined) contents.AllowedMethods = $4ff95607e2fba8c2$var$deserializeAws_restXmlAllowedMethods((0, $3aFL9.getArrayIfSingleItem)(output["AllowedMethod"]), context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlCORSRules = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlCORSRule(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDefaultRetention = function(output, context) {
    var contents = {
        Days: undefined,
        Mode: undefined,
        Years: undefined
    };
    if (output["Days"] !== undefined) contents.Days = parseInt(output["Days"]);
    if (output["Mode"] !== undefined) contents.Mode = output["Mode"];
    if (output["Years"] !== undefined) contents.Years = parseInt(output["Years"]);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDeletedObject = function(output, context) {
    var contents = {
        DeleteMarker: undefined,
        Key: undefined,
        VersionId: undefined,
        DeleteMarkerVersionId: undefined
    };
    if (output["DeleteMarker"] !== undefined) contents.DeleteMarker = output["DeleteMarker"] == "true";
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["VersionId"] !== undefined) contents.VersionId = output["VersionId"];
    if (output["DeleteMarkerVersionId"] !== undefined) contents.DeleteMarkerVersionId = output["DeleteMarkerVersionId"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDeletedObjects = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlDeletedObject(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteMarkerEntry = function(output, context) {
    var contents = {
        VersionId: undefined,
        LastModified: undefined,
        Key: undefined,
        IsLatest: undefined,
        Owner: undefined
    };
    if (output["VersionId"] !== undefined) contents.VersionId = output["VersionId"];
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["IsLatest"] !== undefined) contents.IsLatest = output["IsLatest"] == "true";
    if (output["Owner"] !== undefined) contents.Owner = $4ff95607e2fba8c2$var$deserializeAws_restXmlOwner(output["Owner"], context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteMarkerReplication = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteMarkers = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteMarkerEntry(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlDestination = function(output, context) {
    var contents = {
        EncryptionConfiguration: undefined,
        Bucket: undefined,
        Account: undefined,
        StorageClass: undefined,
        Metrics: undefined,
        AccessControlTranslation: undefined,
        ReplicationTime: undefined
    };
    if (output["EncryptionConfiguration"] !== undefined) contents.EncryptionConfiguration = $4ff95607e2fba8c2$var$deserializeAws_restXmlEncryptionConfiguration(output["EncryptionConfiguration"], context);
    if (output["Bucket"] !== undefined) contents.Bucket = output["Bucket"];
    if (output["Account"] !== undefined) contents.Account = output["Account"];
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    if (output["Metrics"] !== undefined) contents.Metrics = $4ff95607e2fba8c2$var$deserializeAws_restXmlMetrics(output["Metrics"], context);
    if (output["AccessControlTranslation"] !== undefined) contents.AccessControlTranslation = $4ff95607e2fba8c2$var$deserializeAws_restXmlAccessControlTranslation(output["AccessControlTranslation"], context);
    if (output["ReplicationTime"] !== undefined) contents.ReplicationTime = $4ff95607e2fba8c2$var$deserializeAws_restXmlReplicationTime(output["ReplicationTime"], context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlEncryptionConfiguration = function(output, context) {
    var contents = {
        ReplicaKmsKeyID: undefined
    };
    if (output["ReplicaKmsKeyID"] !== undefined) contents.ReplicaKmsKeyID = output["ReplicaKmsKeyID"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXml_Error = function(output, context) {
    var contents = {
        Message: undefined,
        Code: undefined,
        Key: undefined,
        VersionId: undefined
    };
    if (output["Message"] !== undefined) contents.Message = output["Message"];
    if (output["Code"] !== undefined) contents.Code = output["Code"];
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["VersionId"] !== undefined) contents.VersionId = output["VersionId"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlErrorDocument = function(output, context) {
    var contents = {
        Key: undefined
    };
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlErrors = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXml_Error(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlEventList = function(output, context) {
    return (output || []).map(function(entry) {
        return entry;
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlExistingObjectReplication = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlExposeHeaders = function(output, context) {
    return (output || []).map(function(entry) {
        return entry;
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlFilterRule = function(output, context) {
    var contents = {
        Name: undefined,
        Value: undefined
    };
    if (output["Name"] !== undefined) contents.Name = output["Name"];
    if (output["Value"] !== undefined) contents.Value = output["Value"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlFilterRuleList = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlFilterRule(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGrant = function(output, context) {
    var contents = {
        Grantee: undefined,
        Permission: undefined
    };
    if (output["Grantee"] !== undefined) contents.Grantee = $4ff95607e2fba8c2$var$deserializeAws_restXmlGrantee(output["Grantee"], context);
    if (output["Permission"] !== undefined) contents.Permission = output["Permission"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGrantee = function(output, context) {
    var contents = {
        EmailAddress: undefined,
        DisplayName: undefined,
        URI: undefined,
        ID: undefined,
        Type: undefined
    };
    if (output["EmailAddress"] !== undefined) contents.EmailAddress = output["EmailAddress"];
    if (output["DisplayName"] !== undefined) contents.DisplayName = output["DisplayName"];
    if (output["URI"] !== undefined) contents.URI = output["URI"];
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    if (output["xsi:type"] !== undefined) contents.Type = output["xsi:type"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlGrants = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlGrant(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlIndexDocument = function(output, context) {
    var contents = {
        Suffix: undefined
    };
    if (output["Suffix"] !== undefined) contents.Suffix = output["Suffix"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlInitiator = function(output, context) {
    var contents = {
        ID: undefined,
        DisplayName: undefined
    };
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    if (output["DisplayName"] !== undefined) contents.DisplayName = output["DisplayName"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlInventoryConfiguration = function(output, context) {
    var contents = {
        IncludedObjectVersions: undefined,
        IsEnabled: undefined,
        Schedule: undefined,
        Filter: undefined,
        OptionalFields: undefined,
        Destination: undefined,
        Id: undefined
    };
    if (output["IncludedObjectVersions"] !== undefined) contents.IncludedObjectVersions = output["IncludedObjectVersions"];
    if (output["IsEnabled"] !== undefined) contents.IsEnabled = output["IsEnabled"] == "true";
    if (output["Schedule"] !== undefined) contents.Schedule = $4ff95607e2fba8c2$var$deserializeAws_restXmlInventorySchedule(output["Schedule"], context);
    if (output["Filter"] !== undefined) contents.Filter = $4ff95607e2fba8c2$var$deserializeAws_restXmlInventoryFilter(output["Filter"], context);
    if (output.OptionalFields === "") contents.OptionalFields = [];
    if (output["OptionalFields"] !== undefined && output["OptionalFields"]["Field"] !== undefined) contents.OptionalFields = $4ff95607e2fba8c2$var$deserializeAws_restXmlInventoryOptionalFields((0, $3aFL9.getArrayIfSingleItem)(output["OptionalFields"]["Field"]), context);
    if (output["Destination"] !== undefined) contents.Destination = $4ff95607e2fba8c2$var$deserializeAws_restXmlInventoryDestination(output["Destination"], context);
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlInventoryConfigurationList = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlInventoryConfiguration(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlInventoryDestination = function(output, context) {
    var contents = {
        S3BucketDestination: undefined
    };
    if (output["S3BucketDestination"] !== undefined) contents.S3BucketDestination = $4ff95607e2fba8c2$var$deserializeAws_restXmlInventoryS3BucketDestination(output["S3BucketDestination"], context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlInventoryEncryption = function(output, context) {
    var contents = {
        SSEKMS: undefined,
        SSES3: undefined
    };
    if (output["SSE-KMS"] !== undefined) contents.SSEKMS = $4ff95607e2fba8c2$var$deserializeAws_restXmlSSEKMS(output["SSE-KMS"], context);
    if (output["SSE-S3"] !== undefined) contents.SSES3 = $4ff95607e2fba8c2$var$deserializeAws_restXmlSSES3(output["SSE-S3"], context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlInventoryFilter = function(output, context) {
    var contents = {
        Prefix: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlInventoryOptionalFields = function(output, context) {
    return (output || []).map(function(entry) {
        return entry;
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlInventoryS3BucketDestination = function(output, context) {
    var contents = {
        Format: undefined,
        Encryption: undefined,
        Prefix: undefined,
        Bucket: undefined,
        AccountId: undefined
    };
    if (output["Format"] !== undefined) contents.Format = output["Format"];
    if (output["Encryption"] !== undefined) contents.Encryption = $4ff95607e2fba8c2$var$deserializeAws_restXmlInventoryEncryption(output["Encryption"], context);
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["Bucket"] !== undefined) contents.Bucket = output["Bucket"];
    if (output["AccountId"] !== undefined) contents.AccountId = output["AccountId"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlInventorySchedule = function(output, context) {
    var contents = {
        Frequency: undefined
    };
    if (output["Frequency"] !== undefined) contents.Frequency = output["Frequency"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlLambdaFunctionConfiguration = function(output, context) {
    var contents = {
        Events: undefined,
        Filter: undefined,
        LambdaFunctionArn: undefined,
        Id: undefined
    };
    if (output.Event === "") contents.Events = [];
    if (output["Event"] !== undefined) contents.Events = $4ff95607e2fba8c2$var$deserializeAws_restXmlEventList((0, $3aFL9.getArrayIfSingleItem)(output["Event"]), context);
    if (output["Filter"] !== undefined) contents.Filter = $4ff95607e2fba8c2$var$deserializeAws_restXmlNotificationConfigurationFilter(output["Filter"], context);
    if (output["CloudFunction"] !== undefined) contents.LambdaFunctionArn = output["CloudFunction"];
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlLambdaFunctionConfigurationList = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlLambdaFunctionConfiguration(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlLifecycleExpiration = function(output, context) {
    var contents = {
        Days: undefined,
        ExpiredObjectDeleteMarker: undefined,
        Date: undefined
    };
    if (output["Days"] !== undefined) contents.Days = parseInt(output["Days"]);
    if (output["ExpiredObjectDeleteMarker"] !== undefined) contents.ExpiredObjectDeleteMarker = output["ExpiredObjectDeleteMarker"] == "true";
    if (output["Date"] !== undefined) contents.Date = new Date(output["Date"]);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlLifecycleRule = function(output, context) {
    var contents = {
        NoncurrentVersionTransitions: undefined,
        Expiration: undefined,
        ID: undefined,
        Transitions: undefined,
        Prefix: undefined,
        NoncurrentVersionExpiration: undefined,
        AbortIncompleteMultipartUpload: undefined,
        Filter: undefined,
        Status: undefined
    };
    if (output.NoncurrentVersionTransition === "") contents.NoncurrentVersionTransitions = [];
    if (output["NoncurrentVersionTransition"] !== undefined) contents.NoncurrentVersionTransitions = $4ff95607e2fba8c2$var$deserializeAws_restXmlNoncurrentVersionTransitionList((0, $3aFL9.getArrayIfSingleItem)(output["NoncurrentVersionTransition"]), context);
    if (output["Expiration"] !== undefined) contents.Expiration = $4ff95607e2fba8c2$var$deserializeAws_restXmlLifecycleExpiration(output["Expiration"], context);
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    if (output.Transition === "") contents.Transitions = [];
    if (output["Transition"] !== undefined) contents.Transitions = $4ff95607e2fba8c2$var$deserializeAws_restXmlTransitionList((0, $3aFL9.getArrayIfSingleItem)(output["Transition"]), context);
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["NoncurrentVersionExpiration"] !== undefined) contents.NoncurrentVersionExpiration = $4ff95607e2fba8c2$var$deserializeAws_restXmlNoncurrentVersionExpiration(output["NoncurrentVersionExpiration"], context);
    if (output["AbortIncompleteMultipartUpload"] !== undefined) contents.AbortIncompleteMultipartUpload = $4ff95607e2fba8c2$var$deserializeAws_restXmlAbortIncompleteMultipartUpload(output["AbortIncompleteMultipartUpload"], context);
    if (output["Filter"] !== undefined) contents.Filter = $4ff95607e2fba8c2$var$deserializeAws_restXmlLifecycleRuleFilter(output["Filter"], context);
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlLifecycleRuleAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $4ff95607e2fba8c2$var$deserializeAws_restXmlTagSet((0, $3aFL9.getArrayIfSingleItem)(output["Tag"]), context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlLifecycleRuleFilter = function(output, context) {
    var contents = {
        And: undefined,
        Prefix: undefined,
        Tag: undefined
    };
    if (output["And"] !== undefined) contents.And = $4ff95607e2fba8c2$var$deserializeAws_restXmlLifecycleRuleAndOperator(output["And"], context);
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["Tag"] !== undefined) contents.Tag = $4ff95607e2fba8c2$var$deserializeAws_restXmlTag(output["Tag"], context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlLifecycleRules = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlLifecycleRule(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlLoggingEnabled = function(output, context) {
    var contents = {
        TargetGrants: undefined,
        TargetBucket: undefined,
        TargetPrefix: undefined
    };
    if (output.TargetGrants === "") contents.TargetGrants = [];
    if (output["TargetGrants"] !== undefined && output["TargetGrants"]["Grant"] !== undefined) contents.TargetGrants = $4ff95607e2fba8c2$var$deserializeAws_restXmlTargetGrants((0, $3aFL9.getArrayIfSingleItem)(output["TargetGrants"]["Grant"]), context);
    if (output["TargetBucket"] !== undefined) contents.TargetBucket = output["TargetBucket"];
    if (output["TargetPrefix"] !== undefined) contents.TargetPrefix = output["TargetPrefix"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlMetrics = function(output, context) {
    var contents = {
        Status: undefined,
        EventThreshold: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    if (output["EventThreshold"] !== undefined) contents.EventThreshold = $4ff95607e2fba8c2$var$deserializeAws_restXmlReplicationTimeValue(output["EventThreshold"], context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlMetricsAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $4ff95607e2fba8c2$var$deserializeAws_restXmlTagSet((0, $3aFL9.getArrayIfSingleItem)(output["Tag"]), context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlMetricsConfiguration = function(output, context) {
    var contents = {
        Id: undefined,
        Filter: undefined
    };
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["Filter"] !== undefined) contents.Filter = $4ff95607e2fba8c2$var$deserializeAws_restXmlMetricsFilter(output["Filter"], context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlMetricsConfigurationList = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlMetricsConfiguration(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlMetricsFilter = function(output, context) {
    var contents = {
        And: undefined,
        Prefix: undefined,
        Tag: undefined
    };
    if (output["And"] !== undefined) contents.And = $4ff95607e2fba8c2$var$deserializeAws_restXmlMetricsAndOperator(output["And"], context);
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["Tag"] !== undefined) contents.Tag = $4ff95607e2fba8c2$var$deserializeAws_restXmlTag(output["Tag"], context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlMultipartUpload = function(output, context) {
    var contents = {
        Initiator: undefined,
        UploadId: undefined,
        Key: undefined,
        Owner: undefined,
        StorageClass: undefined,
        Initiated: undefined
    };
    if (output["Initiator"] !== undefined) contents.Initiator = $4ff95607e2fba8c2$var$deserializeAws_restXmlInitiator(output["Initiator"], context);
    if (output["UploadId"] !== undefined) contents.UploadId = output["UploadId"];
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["Owner"] !== undefined) contents.Owner = $4ff95607e2fba8c2$var$deserializeAws_restXmlOwner(output["Owner"], context);
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    if (output["Initiated"] !== undefined) contents.Initiated = new Date(output["Initiated"]);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlMultipartUploadList = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlMultipartUpload(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlNoncurrentVersionExpiration = function(output, context) {
    var contents = {
        NoncurrentDays: undefined
    };
    if (output["NoncurrentDays"] !== undefined) contents.NoncurrentDays = parseInt(output["NoncurrentDays"]);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlNoncurrentVersionTransition = function(output, context) {
    var contents = {
        StorageClass: undefined,
        NoncurrentDays: undefined
    };
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    if (output["NoncurrentDays"] !== undefined) contents.NoncurrentDays = parseInt(output["NoncurrentDays"]);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlNoncurrentVersionTransitionList = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlNoncurrentVersionTransition(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlNotificationConfigurationFilter = function(output, context) {
    var contents = {
        Key: undefined
    };
    if (output["S3Key"] !== undefined) contents.Key = $4ff95607e2fba8c2$var$deserializeAws_restXmlS3KeyFilter(output["S3Key"], context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXml_Object = function(output, context) {
    var contents = {
        Size: undefined,
        ETag: undefined,
        Owner: undefined,
        StorageClass: undefined,
        Key: undefined,
        LastModified: undefined
    };
    if (output["Size"] !== undefined) contents.Size = parseInt(output["Size"]);
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["Owner"] !== undefined) contents.Owner = $4ff95607e2fba8c2$var$deserializeAws_restXmlOwner(output["Owner"], context);
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlObjectList = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXml_Object(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlObjectLockConfiguration = function(output, context) {
    var contents = {
        ObjectLockEnabled: undefined,
        Rule: undefined
    };
    if (output["ObjectLockEnabled"] !== undefined) contents.ObjectLockEnabled = output["ObjectLockEnabled"];
    if (output["Rule"] !== undefined) contents.Rule = $4ff95607e2fba8c2$var$deserializeAws_restXmlObjectLockRule(output["Rule"], context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlObjectLockLegalHold = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlObjectLockRetention = function(output, context) {
    var contents = {
        Mode: undefined,
        RetainUntilDate: undefined
    };
    if (output["Mode"] !== undefined) contents.Mode = output["Mode"];
    if (output["RetainUntilDate"] !== undefined) contents.RetainUntilDate = new Date(output["RetainUntilDate"]);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlObjectLockRule = function(output, context) {
    var contents = {
        DefaultRetention: undefined
    };
    if (output["DefaultRetention"] !== undefined) contents.DefaultRetention = $4ff95607e2fba8c2$var$deserializeAws_restXmlDefaultRetention(output["DefaultRetention"], context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlObjectVersion = function(output, context) {
    var contents = {
        Size: undefined,
        Key: undefined,
        StorageClass: undefined,
        Owner: undefined,
        IsLatest: undefined,
        ETag: undefined,
        LastModified: undefined,
        VersionId: undefined
    };
    if (output["Size"] !== undefined) contents.Size = parseInt(output["Size"]);
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    if (output["Owner"] !== undefined) contents.Owner = $4ff95607e2fba8c2$var$deserializeAws_restXmlOwner(output["Owner"], context);
    if (output["IsLatest"] !== undefined) contents.IsLatest = output["IsLatest"] == "true";
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    if (output["VersionId"] !== undefined) contents.VersionId = output["VersionId"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlObjectVersionList = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlObjectVersion(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlOwner = function(output, context) {
    var contents = {
        DisplayName: undefined,
        ID: undefined
    };
    if (output["DisplayName"] !== undefined) contents.DisplayName = output["DisplayName"];
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlOwnershipControls = function(output, context) {
    var contents = {
        Rules: undefined
    };
    if (output.Rule === "") contents.Rules = [];
    if (output["Rule"] !== undefined) contents.Rules = $4ff95607e2fba8c2$var$deserializeAws_restXmlOwnershipControlsRules((0, $3aFL9.getArrayIfSingleItem)(output["Rule"]), context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlOwnershipControlsRule = function(output, context) {
    var contents = {
        ObjectOwnership: undefined
    };
    if (output["ObjectOwnership"] !== undefined) contents.ObjectOwnership = output["ObjectOwnership"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlOwnershipControlsRules = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlOwnershipControlsRule(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPart = function(output, context) {
    var contents = {
        Size: undefined,
        LastModified: undefined,
        PartNumber: undefined,
        ETag: undefined
    };
    if (output["Size"] !== undefined) contents.Size = parseInt(output["Size"]);
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    if (output["PartNumber"] !== undefined) contents.PartNumber = parseInt(output["PartNumber"]);
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlParts = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlPart(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPolicyStatus = function(output, context) {
    var contents = {
        IsPublic: undefined
    };
    if (output["IsPublic"] !== undefined) contents.IsPublic = output["IsPublic"] == "true";
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlPublicAccessBlockConfiguration = function(output, context) {
    var contents = {
        BlockPublicPolicy: undefined,
        BlockPublicAcls: undefined,
        RestrictPublicBuckets: undefined,
        IgnorePublicAcls: undefined
    };
    if (output["BlockPublicPolicy"] !== undefined) contents.BlockPublicPolicy = output["BlockPublicPolicy"] == "true";
    if (output["BlockPublicAcls"] !== undefined) contents.BlockPublicAcls = output["BlockPublicAcls"] == "true";
    if (output["RestrictPublicBuckets"] !== undefined) contents.RestrictPublicBuckets = output["RestrictPublicBuckets"] == "true";
    if (output["IgnorePublicAcls"] !== undefined) contents.IgnorePublicAcls = output["IgnorePublicAcls"] == "true";
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlQueueConfiguration = function(output, context) {
    var contents = {
        Events: undefined,
        Id: undefined,
        Filter: undefined,
        QueueArn: undefined
    };
    if (output.Event === "") contents.Events = [];
    if (output["Event"] !== undefined) contents.Events = $4ff95607e2fba8c2$var$deserializeAws_restXmlEventList((0, $3aFL9.getArrayIfSingleItem)(output["Event"]), context);
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["Filter"] !== undefined) contents.Filter = $4ff95607e2fba8c2$var$deserializeAws_restXmlNotificationConfigurationFilter(output["Filter"], context);
    if (output["Queue"] !== undefined) contents.QueueArn = output["Queue"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlQueueConfigurationList = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlQueueConfiguration(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlRedirect = function(output, context) {
    var contents = {
        HttpRedirectCode: undefined,
        ReplaceKeyPrefixWith: undefined,
        Protocol: undefined,
        HostName: undefined,
        ReplaceKeyWith: undefined
    };
    if (output["HttpRedirectCode"] !== undefined) contents.HttpRedirectCode = output["HttpRedirectCode"];
    if (output["ReplaceKeyPrefixWith"] !== undefined) contents.ReplaceKeyPrefixWith = output["ReplaceKeyPrefixWith"];
    if (output["Protocol"] !== undefined) contents.Protocol = output["Protocol"];
    if (output["HostName"] !== undefined) contents.HostName = output["HostName"];
    if (output["ReplaceKeyWith"] !== undefined) contents.ReplaceKeyWith = output["ReplaceKeyWith"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlRedirectAllRequestsTo = function(output, context) {
    var contents = {
        Protocol: undefined,
        HostName: undefined
    };
    if (output["Protocol"] !== undefined) contents.Protocol = output["Protocol"];
    if (output["HostName"] !== undefined) contents.HostName = output["HostName"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlReplicationConfiguration = function(output, context) {
    var contents = {
        Role: undefined,
        Rules: undefined
    };
    if (output["Role"] !== undefined) contents.Role = output["Role"];
    if (output.Rule === "") contents.Rules = [];
    if (output["Rule"] !== undefined) contents.Rules = $4ff95607e2fba8c2$var$deserializeAws_restXmlReplicationRules((0, $3aFL9.getArrayIfSingleItem)(output["Rule"]), context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlReplicationRule = function(output, context) {
    var contents = {
        Prefix: undefined,
        ID: undefined,
        SourceSelectionCriteria: undefined,
        DeleteMarkerReplication: undefined,
        Filter: undefined,
        Priority: undefined,
        Status: undefined,
        ExistingObjectReplication: undefined,
        Destination: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    if (output["SourceSelectionCriteria"] !== undefined) contents.SourceSelectionCriteria = $4ff95607e2fba8c2$var$deserializeAws_restXmlSourceSelectionCriteria(output["SourceSelectionCriteria"], context);
    if (output["DeleteMarkerReplication"] !== undefined) contents.DeleteMarkerReplication = $4ff95607e2fba8c2$var$deserializeAws_restXmlDeleteMarkerReplication(output["DeleteMarkerReplication"], context);
    if (output["Filter"] !== undefined) contents.Filter = $4ff95607e2fba8c2$var$deserializeAws_restXmlReplicationRuleFilter(output["Filter"], context);
    if (output["Priority"] !== undefined) contents.Priority = parseInt(output["Priority"]);
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    if (output["ExistingObjectReplication"] !== undefined) contents.ExistingObjectReplication = $4ff95607e2fba8c2$var$deserializeAws_restXmlExistingObjectReplication(output["ExistingObjectReplication"], context);
    if (output["Destination"] !== undefined) contents.Destination = $4ff95607e2fba8c2$var$deserializeAws_restXmlDestination(output["Destination"], context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlReplicationRuleAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $4ff95607e2fba8c2$var$deserializeAws_restXmlTagSet((0, $3aFL9.getArrayIfSingleItem)(output["Tag"]), context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlReplicationRuleFilter = function(output, context) {
    var contents = {
        Tag: undefined,
        Prefix: undefined,
        And: undefined
    };
    if (output["Tag"] !== undefined) contents.Tag = $4ff95607e2fba8c2$var$deserializeAws_restXmlTag(output["Tag"], context);
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["And"] !== undefined) contents.And = $4ff95607e2fba8c2$var$deserializeAws_restXmlReplicationRuleAndOperator(output["And"], context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlReplicationRules = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlReplicationRule(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlReplicationTime = function(output, context) {
    var contents = {
        Time: undefined,
        Status: undefined
    };
    if (output["Time"] !== undefined) contents.Time = $4ff95607e2fba8c2$var$deserializeAws_restXmlReplicationTimeValue(output["Time"], context);
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlReplicationTimeValue = function(output, context) {
    var contents = {
        Minutes: undefined
    };
    if (output["Minutes"] !== undefined) contents.Minutes = parseInt(output["Minutes"]);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlRoutingRule = function(output, context) {
    var contents = {
        Redirect: undefined,
        Condition: undefined
    };
    if (output["Redirect"] !== undefined) contents.Redirect = $4ff95607e2fba8c2$var$deserializeAws_restXmlRedirect(output["Redirect"], context);
    if (output["Condition"] !== undefined) contents.Condition = $4ff95607e2fba8c2$var$deserializeAws_restXmlCondition(output["Condition"], context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlRoutingRules = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlRoutingRule(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlS3KeyFilter = function(output, context) {
    var contents = {
        FilterRules: undefined
    };
    if (output.FilterRule === "") contents.FilterRules = [];
    if (output["FilterRule"] !== undefined) contents.FilterRules = $4ff95607e2fba8c2$var$deserializeAws_restXmlFilterRuleList((0, $3aFL9.getArrayIfSingleItem)(output["FilterRule"]), context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlServerSideEncryptionByDefault = function(output, context) {
    var contents = {
        SSEAlgorithm: undefined,
        KMSMasterKeyID: undefined
    };
    if (output["SSEAlgorithm"] !== undefined) contents.SSEAlgorithm = output["SSEAlgorithm"];
    if (output["KMSMasterKeyID"] !== undefined) contents.KMSMasterKeyID = output["KMSMasterKeyID"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlServerSideEncryptionConfiguration = function(output, context) {
    var contents = {
        Rules: undefined
    };
    if (output.Rule === "") contents.Rules = [];
    if (output["Rule"] !== undefined) contents.Rules = $4ff95607e2fba8c2$var$deserializeAws_restXmlServerSideEncryptionRules((0, $3aFL9.getArrayIfSingleItem)(output["Rule"]), context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlServerSideEncryptionRule = function(output, context) {
    var contents = {
        ApplyServerSideEncryptionByDefault: undefined
    };
    if (output["ApplyServerSideEncryptionByDefault"] !== undefined) contents.ApplyServerSideEncryptionByDefault = $4ff95607e2fba8c2$var$deserializeAws_restXmlServerSideEncryptionByDefault(output["ApplyServerSideEncryptionByDefault"], context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlServerSideEncryptionRules = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlServerSideEncryptionRule(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlSourceSelectionCriteria = function(output, context) {
    var contents = {
        SseKmsEncryptedObjects: undefined
    };
    if (output["SseKmsEncryptedObjects"] !== undefined) contents.SseKmsEncryptedObjects = $4ff95607e2fba8c2$var$deserializeAws_restXmlSseKmsEncryptedObjects(output["SseKmsEncryptedObjects"], context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlSSEKMS = function(output, context) {
    var contents = {
        KeyId: undefined
    };
    if (output["KeyId"] !== undefined) contents.KeyId = output["KeyId"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlSseKmsEncryptedObjects = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlSSES3 = function(output, context) {
    var contents = {};
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlStorageClassAnalysis = function(output, context) {
    var contents = {
        DataExport: undefined
    };
    if (output["DataExport"] !== undefined) contents.DataExport = $4ff95607e2fba8c2$var$deserializeAws_restXmlStorageClassAnalysisDataExport(output["DataExport"], context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlStorageClassAnalysisDataExport = function(output, context) {
    var contents = {
        OutputSchemaVersion: undefined,
        Destination: undefined
    };
    if (output["OutputSchemaVersion"] !== undefined) contents.OutputSchemaVersion = output["OutputSchemaVersion"];
    if (output["Destination"] !== undefined) contents.Destination = $4ff95607e2fba8c2$var$deserializeAws_restXmlAnalyticsExportDestination(output["Destination"], context);
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlTag = function(output, context) {
    var contents = {
        Value: undefined,
        Key: undefined
    };
    if (output["Value"] !== undefined) contents.Value = output["Value"];
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlTagSet = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlTag(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlTargetGrant = function(output, context) {
    var contents = {
        Grantee: undefined,
        Permission: undefined
    };
    if (output["Grantee"] !== undefined) contents.Grantee = $4ff95607e2fba8c2$var$deserializeAws_restXmlGrantee(output["Grantee"], context);
    if (output["Permission"] !== undefined) contents.Permission = output["Permission"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlTargetGrants = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlTargetGrant(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlTopicConfiguration = function(output, context) {
    var contents = {
        Events: undefined,
        Filter: undefined,
        TopicArn: undefined,
        Id: undefined
    };
    if (output.Event === "") contents.Events = [];
    if (output["Event"] !== undefined) contents.Events = $4ff95607e2fba8c2$var$deserializeAws_restXmlEventList((0, $3aFL9.getArrayIfSingleItem)(output["Event"]), context);
    if (output["Filter"] !== undefined) contents.Filter = $4ff95607e2fba8c2$var$deserializeAws_restXmlNotificationConfigurationFilter(output["Filter"], context);
    if (output["Topic"] !== undefined) contents.TopicArn = output["Topic"];
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlTopicConfigurationList = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlTopicConfiguration(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlTransition = function(output, context) {
    var contents = {
        Days: undefined,
        Date: undefined,
        StorageClass: undefined
    };
    if (output["Days"] !== undefined) contents.Days = parseInt(output["Days"]);
    if (output["Date"] !== undefined) contents.Date = new Date(output["Date"]);
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    return contents;
};
var $4ff95607e2fba8c2$var$deserializeAws_restXmlTransitionList = function(output, context) {
    return (output || []).map(function(entry) {
        return $4ff95607e2fba8c2$var$deserializeAws_restXmlTransition(entry, context);
    });
};
var $4ff95607e2fba8c2$var$deserializeMetadata = function(output) {
    return {
        httpStatusCode: output.statusCode,
        httpHeaders: output.headers,
        requestId: output.headers["x-amzn-requestid"]
    };
};
// Collect low-level response body stream to Uint8Array.
var $4ff95607e2fba8c2$var$collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var $4ff95607e2fba8c2$var$collectBodyString = function(streamBody, context) {
    return $4ff95607e2fba8c2$var$collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var $4ff95607e2fba8c2$var$isSerializableHeaderValue = function(value) {
    return value !== undefined && value !== "" && (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) && (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
};
var $4ff95607e2fba8c2$var$decodeEscapedXML = function(str) {
    return str.replace(/&amp;/g, "&").replace(/&apos;/g, "'").replace(/&quot;/g, '"').replace(/&gt;/g, ">").replace(/&lt;/g, "<");
};
var $4ff95607e2fba8c2$var$parseBody = function(streamBody, context) {
    return $4ff95607e2fba8c2$var$collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) {
            var parsedObj = (0, $boTui.parse)(encoded, {
                attributeNamePrefix: "",
                ignoreAttributes: false,
                parseNodeValue: false,
                tagValueProcessor: function(val, tagName) {
                    return $4ff95607e2fba8c2$var$decodeEscapedXML(val);
                }
            });
            var textNodeName = "#text";
            var key = Object.keys(parsedObj)[0];
            var parsedObjToReturn = parsedObj[key];
            if (parsedObjToReturn[textNodeName]) {
                parsedObjToReturn[key] = parsedObjToReturn[textNodeName];
                delete parsedObjToReturn[textNodeName];
            }
            return (0, $3Ggxn.getValueFromTextNode)(parsedObjToReturn);
        }
        return {};
    });
};
var $4ff95607e2fba8c2$var$loadRestXmlErrorCode = function(output, data) {
    if (data.Code !== undefined) return data.Code;
    if (output.statusCode == 404) return "NotFound";
    return "";
};

});
parcelRegister("ae0gO", function(module, exports) {
$parcel$export(module.exports, "XmlNode", function () { return (parcelRequire("dfLaw")).XmlNode; });
$parcel$export(module.exports, "XmlText", function () { return (parcelRequire("doQBX")).XmlText; });
parcelRequire("dfLaw");
parcelRequire("doQBX");

});
parcelRegister("dfLaw", function(module, exports) {

$parcel$export(module.exports, "XmlNode", function () { return $9a6143d11f5a7d4d$export$e775a15d806cbddc; });

var $fH1jI = parcelRequire("fH1jI");

var $eRd2B = parcelRequire("eRd2B");
/**
 * Represents an XML node.
 */ var $9a6143d11f5a7d4d$export$e775a15d806cbddc = /** @class */ function() {
    function XmlNode(name, children) {
        if (children === void 0) children = [];
        this.name = name;
        this.children = children;
        this.attributes = {};
    }
    XmlNode.prototype.withName = function(name) {
        this.name = name;
        return this;
    };
    XmlNode.prototype.addAttribute = function(name, value) {
        this.attributes[name] = value;
        return this;
    };
    XmlNode.prototype.addChildNode = function(child) {
        this.children.push(child);
        return this;
    };
    XmlNode.prototype.removeAttribute = function(name) {
        delete this.attributes[name];
        return this;
    };
    XmlNode.prototype.toString = function() {
        var e_1, _a;
        var hasChildren = Boolean(this.children.length);
        var xmlText = "<" + this.name;
        // add attributes
        var attributes = this.attributes;
        try {
            for(var _b = (0, $fH1jI.__values)(Object.keys(attributes)), _c = _b.next(); !_c.done; _c = _b.next()){
                var attributeName = _c.value;
                var attribute = attributes[attributeName];
                if (typeof attribute !== "undefined" && attribute !== null) xmlText += " " + attributeName + "=\"" + (0, $eRd2B.escapeAttribute)("" + attribute) + "\"";
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return xmlText += !hasChildren ? "/>" : ">" + this.children.map(function(c) {
            return c.toString();
        }).join("") + "</" + this.name + ">";
    };
    return XmlNode;
}();

});
parcelRegister("eRd2B", function(module, exports) {

$parcel$export(module.exports, "escapeAttribute", function () { return $ad10219ce6aae117$export$30330f3d5eb70e11; });
/**
 * Escapes characters that can not be in an XML attribute.
 */ function $ad10219ce6aae117$export$30330f3d5eb70e11(value) {
    return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}

});


parcelRegister("doQBX", function(module, exports) {

$parcel$export(module.exports, "XmlText", function () { return $9c1653c27dfb427a$export$b35b8f45887823df; });

var $3VnLo = parcelRequire("3VnLo");
/**
 * Represents an XML text value.
 */ var $9c1653c27dfb427a$export$b35b8f45887823df = /** @class */ function() {
    function XmlText(value) {
        this.value = value;
    }
    XmlText.prototype.toString = function() {
        return (0, $3VnLo.escapeElement)("" + this.value);
    };
    return XmlText;
}();

});
parcelRegister("3VnLo", function(module, exports) {

$parcel$export(module.exports, "escapeElement", function () { return $2db920e00cb49902$export$e5104ffd394b43ec; });
/**
 * Escapes characters that can not be in an XML element.
 */ function $2db920e00cb49902$export$e5104ffd394b43ec(value) {
    return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

});



parcelRegister("boTui", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $84ccfa4708686644$export$98e6a39c04603d36; }, function (v) { return $84ccfa4708686644$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "convertTonimn", function () { return $84ccfa4708686644$export$e4f0b40d01c251ab; }, function (v) { return $84ccfa4708686644$export$e4f0b40d01c251ab = v; });
$parcel$export(module.exports, "getTraversalObj", function () { return $84ccfa4708686644$export$2ca3eb0a2f8a693a; }, function (v) { return $84ccfa4708686644$export$2ca3eb0a2f8a693a = v; });
var $84ccfa4708686644$export$98e6a39c04603d36;
var $84ccfa4708686644$export$e4f0b40d01c251ab;
var $84ccfa4708686644$export$2ca3eb0a2f8a693a;
var $84ccfa4708686644$export$e31c2b05678acf26;
var $84ccfa4708686644$export$54ffaacfc0931fb0;
var $84ccfa4708686644$export$a22775fa5e2eebd9;
var $84ccfa4708686644$export$30384b60aedf98a5;
var $84ccfa4708686644$export$3a5cfc971f52ee31;
'use strict';

var $ja250 = parcelRequire("ja250");

var $5SpIl = parcelRequire("5SpIl");

var $5SpIl = parcelRequire("5SpIl");

var $eUZ0B = parcelRequire("eUZ0B");
var $84ccfa4708686644$require$buildOptions = $eUZ0B.buildOptions;

var $bnnRs = parcelRequire("bnnRs");
$84ccfa4708686644$export$98e6a39c04603d36 = function(xmlData, givenOptions = {}, validationOption) {
    if (validationOption) {
        if (validationOption === true) validationOption = {};
        const result = $bnnRs.validate(xmlData, validationOption);
        if (result !== true) throw Error(result.err.msg);
    }
    if (givenOptions.parseTrueNumberOnly && givenOptions.parseNodeValue !== false && !givenOptions.numParseOptions) givenOptions.numParseOptions = {
        leadingZeros: false
    };
    let options = $84ccfa4708686644$require$buildOptions(givenOptions, $5SpIl.defaultOptions, $5SpIl.props);
    const traversableObj = $5SpIl.getTraversalObj(xmlData, options);
    //print(traversableObj, "  ");
    return $ja250.convertToJson(traversableObj, options);
};

$84ccfa4708686644$export$e4f0b40d01c251ab = (parcelRequire("4GZYp")).convert2nimn;
$84ccfa4708686644$export$2ca3eb0a2f8a693a = $5SpIl.getTraversalObj;
$84ccfa4708686644$export$e31c2b05678acf26 = $ja250.convertToJson;

$84ccfa4708686644$export$54ffaacfc0931fb0 = (parcelRequire("4FAO3")).convertToJsonString;
$84ccfa4708686644$export$a22775fa5e2eebd9 = $bnnRs.validate;

$84ccfa4708686644$export$30384b60aedf98a5 = (parcelRequire("132i0"));
$84ccfa4708686644$export$3a5cfc971f52ee31 = function(xmlData, schema, options) {
    return $84ccfa4708686644$export$e4f0b40d01c251ab($84ccfa4708686644$export$2ca3eb0a2f8a693a(xmlData, options), schema, options);
};
function $84ccfa4708686644$var$print(xmlNode, indentation) {
    if (xmlNode) {
        console.log(indentation + "{");
        console.log(indentation + "  \"tagName\": \"" + xmlNode.tagname + "\", ");
        if (xmlNode.parent) console.log(indentation + "  \"parent\": \"" + xmlNode.parent.tagname + "\", ");
        console.log(indentation + "  \"val\": \"" + xmlNode.val + "\", ");
        console.log(indentation + "  \"attrs\": " + JSON.stringify(xmlNode.attrsMap, null, 4) + ", ");
        if (xmlNode.child) {
            console.log(indentation + "\"child\": {");
            const indentation2 = indentation + indentation;
            Object.keys(xmlNode.child).forEach(function(key) {
                const node = xmlNode.child[key];
                if (Array.isArray(node)) {
                    console.log(indentation + "\"" + key + "\" :[");
                    node.forEach(function(item, index) {
                        //console.log(indentation + " \""+index+"\" : [")
                        $84ccfa4708686644$var$print(item, indentation2);
                    });
                    console.log(indentation + "],");
                } else {
                    console.log(indentation + " \"" + key + "\" : {");
                    $84ccfa4708686644$var$print(node, indentation2);
                    console.log(indentation + "},");
                }
            });
            console.log(indentation + "},");
        }
        console.log(indentation + "},");
    }
}

});
parcelRegister("ja250", function(module, exports) {

$parcel$export(module.exports, "convertToJson", function () { return $df309076c2d347ec$export$e31c2b05678acf26; }, function (v) { return $df309076c2d347ec$export$e31c2b05678acf26 = v; });
var $df309076c2d347ec$export$e31c2b05678acf26;
'use strict';

var $eUZ0B = parcelRequire("eUZ0B");
const $df309076c2d347ec$var$convertToJson = function(node, options, parentTagName) {
    const jObj = {};
    // when no child node or attr is present
    if (!options.alwaysCreateTextNode && (!node.child || $eUZ0B.isEmptyObject(node.child)) && (!node.attrsMap || $eUZ0B.isEmptyObject(node.attrsMap))) return $eUZ0B.isExist(node.val) ? node.val : '';
    // otherwise create a textnode if node has some text
    if ($eUZ0B.isExist(node.val) && !(typeof node.val === 'string' && (node.val === '' || node.val === options.cdataPositionChar))) {
        const asArray = $eUZ0B.isTagNameInArrayMode(node.tagname, options.arrayMode, parentTagName);
        jObj[options.textNodeName] = asArray ? [
            node.val
        ] : node.val;
    }
    $eUZ0B.merge(jObj, node.attrsMap, options.arrayMode);
    const keys = Object.keys(node.child);
    for(let index = 0; index < keys.length; index++){
        const tagName = keys[index];
        if (node.child[tagName] && node.child[tagName].length > 1) {
            jObj[tagName] = [];
            for(let tag in node.child[tagName])if (node.child[tagName].hasOwnProperty(tag)) jObj[tagName].push($df309076c2d347ec$var$convertToJson(node.child[tagName][tag], options, tagName));
        } else {
            const result = $df309076c2d347ec$var$convertToJson(node.child[tagName][0], options, tagName);
            const asArray = options.arrayMode === true && typeof result === 'object' || $eUZ0B.isTagNameInArrayMode(tagName, options.arrayMode, parentTagName);
            jObj[tagName] = asArray ? [
                result
            ] : result;
        }
    }
    //add value
    return jObj;
};
$df309076c2d347ec$export$e31c2b05678acf26 = $df309076c2d347ec$var$convertToJson;

});

parcelRegister("bnnRs", function(module, exports) {

$parcel$export(module.exports, "validate", function () { return $84845a0d049af20f$export$a22775fa5e2eebd9; }, function (v) { return $84845a0d049af20f$export$a22775fa5e2eebd9 = v; });
//const tagsPattern = new RegExp("<\\/?([\\w:\\-_\.]+)\\s*\/?>","g");
var $84845a0d049af20f$export$a22775fa5e2eebd9;
'use strict';

var $eUZ0B = parcelRequire("eUZ0B");
const $84845a0d049af20f$var$defaultOptions = {
    allowBooleanAttributes: false
};
const $84845a0d049af20f$var$props = [
    'allowBooleanAttributes'
];
$84845a0d049af20f$export$a22775fa5e2eebd9 = function(xmlData, options) {
    options = $eUZ0B.buildOptions(options, $84845a0d049af20f$var$defaultOptions, $84845a0d049af20f$var$props);
    //xmlData = xmlData.replace(/(\r\n|\n|\r)/gm,"");//make it single line
    //xmlData = xmlData.replace(/(^\s*<\?xml.*?\?>)/g,"");//Remove XML starting tag
    //xmlData = xmlData.replace(/(<!DOCTYPE[\s\w\"\.\/\-\:]+(\[.*\])*\s*>)/g,"");//Remove DOCTYPE
    const tags = [];
    let tagFound = false;
    //indicates that the root tag has been closed (aka. depth 0 has been reached)
    let reachedRoot = false;
    if (xmlData[0] === '\ufeff') // check for byte order mark (BOM)
    xmlData = xmlData.substr(1);
    for(let i = 0; i < xmlData.length; i++){
        if (xmlData[i] === '<' && xmlData[i + 1] === '?') {
            i += 2;
            i = $84845a0d049af20f$var$readPI(xmlData, i);
            if (i.err) return i;
        } else if (xmlData[i] === '<') {
            //starting of tag
            //read until you reach to '>' avoiding any '>' in attribute value
            let tagStartPos = i;
            i++;
            if (xmlData[i] === '!') {
                i = $84845a0d049af20f$var$readCommentAndCDATA(xmlData, i);
                continue;
            } else {
                let closingTag = false;
                if (xmlData[i] === '/') {
                    //closing tag
                    closingTag = true;
                    i++;
                }
                //read tagname
                let tagName = '';
                for(; i < xmlData.length && xmlData[i] !== '>' && xmlData[i] !== ' ' && xmlData[i] !== '\t' && xmlData[i] !== '\n' && xmlData[i] !== '\r'; i++)tagName += xmlData[i];
                tagName = tagName.trim();
                //console.log(tagName);
                if (tagName[tagName.length - 1] === '/') {
                    //self closing tag without attributes
                    tagName = tagName.substring(0, tagName.length - 1);
                    //continue;
                    i--;
                }
                if (!$84845a0d049af20f$var$validateTagName(tagName)) {
                    let msg;
                    if (tagName.trim().length === 0) msg = "Invalid space after '<'.";
                    else msg = "Tag '" + tagName + "' is an invalid name.";
                    return $84845a0d049af20f$var$getErrorObject('InvalidTag', msg, $84845a0d049af20f$var$getLineNumberForPosition(xmlData, i));
                }
                const result = $84845a0d049af20f$var$readAttributeStr(xmlData, i);
                if (result === false) return $84845a0d049af20f$var$getErrorObject('InvalidAttr', "Attributes for '" + tagName + "' have open quote.", $84845a0d049af20f$var$getLineNumberForPosition(xmlData, i));
                let attrStr = result.value;
                i = result.index;
                if (attrStr[attrStr.length - 1] === '/') {
                    //self closing tag
                    const attrStrStart = i - attrStr.length;
                    attrStr = attrStr.substring(0, attrStr.length - 1);
                    const isValid = $84845a0d049af20f$var$validateAttributeString(attrStr, options);
                    if (isValid === true) tagFound = true;
                    else //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $84845a0d049af20f$var$getErrorObject(isValid.err.code, isValid.err.msg, $84845a0d049af20f$var$getLineNumberForPosition(xmlData, attrStrStart + isValid.err.line));
                } else if (closingTag) {
                    if (!result.tagClosed) return $84845a0d049af20f$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' doesn't have proper closing.", $84845a0d049af20f$var$getLineNumberForPosition(xmlData, i));
                    else if (attrStr.trim().length > 0) return $84845a0d049af20f$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' can't have attributes or invalid starting.", $84845a0d049af20f$var$getLineNumberForPosition(xmlData, tagStartPos));
                    else {
                        const otg = tags.pop();
                        if (tagName !== otg.tagName) {
                            let openPos = $84845a0d049af20f$var$getLineNumberForPosition(xmlData, otg.tagStartPos);
                            return $84845a0d049af20f$var$getErrorObject('InvalidTag', "Expected closing tag '" + otg.tagName + "' (opened in line " + openPos.line + ", col " + openPos.col + ") instead of closing tag '" + tagName + "'.", $84845a0d049af20f$var$getLineNumberForPosition(xmlData, tagStartPos));
                        }
                        //when there are no more tags, we reached the root level.
                        if (tags.length == 0) reachedRoot = true;
                    }
                } else {
                    const isValid = $84845a0d049af20f$var$validateAttributeString(attrStr, options);
                    if (isValid !== true) //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $84845a0d049af20f$var$getErrorObject(isValid.err.code, isValid.err.msg, $84845a0d049af20f$var$getLineNumberForPosition(xmlData, i - attrStr.length + isValid.err.line));
                    //if the root level has been reached before ...
                    if (reachedRoot === true) return $84845a0d049af20f$var$getErrorObject('InvalidXml', 'Multiple possible root nodes found.', $84845a0d049af20f$var$getLineNumberForPosition(xmlData, i));
                    else tags.push({
                        tagName: tagName,
                        tagStartPos: tagStartPos
                    });
                    tagFound = true;
                }
                //skip tag text value
                //It may include comments and CDATA value
                for(i++; i < xmlData.length; i++){
                    if (xmlData[i] === '<') {
                        if (xmlData[i + 1] === '!') {
                            //comment or CADATA
                            i++;
                            i = $84845a0d049af20f$var$readCommentAndCDATA(xmlData, i);
                            continue;
                        } else if (xmlData[i + 1] === '?') {
                            i = $84845a0d049af20f$var$readPI(xmlData, ++i);
                            if (i.err) return i;
                        } else break;
                    } else if (xmlData[i] === '&') {
                        const afterAmp = $84845a0d049af20f$var$validateAmpersand(xmlData, i);
                        if (afterAmp == -1) return $84845a0d049af20f$var$getErrorObject('InvalidChar', "char '&' is not expected.", $84845a0d049af20f$var$getLineNumberForPosition(xmlData, i));
                        i = afterAmp;
                    }
                } //end of reading tag text value
                if (xmlData[i] === '<') i--;
            }
        } else {
            if (xmlData[i] === ' ' || xmlData[i] === '\t' || xmlData[i] === '\n' || xmlData[i] === '\r') continue;
            return $84845a0d049af20f$var$getErrorObject('InvalidChar', "char '" + xmlData[i] + "' is not expected.", $84845a0d049af20f$var$getLineNumberForPosition(xmlData, i));
        }
    }
    if (!tagFound) return $84845a0d049af20f$var$getErrorObject('InvalidXml', 'Start tag expected.', 1);
    else if (tags.length == 1) return $84845a0d049af20f$var$getErrorObject('InvalidTag', "Unclosed tag '" + tags[0].tagName + "'.", $84845a0d049af20f$var$getLineNumberForPosition(xmlData, tags[0].tagStartPos));
    else if (tags.length > 0) return $84845a0d049af20f$var$getErrorObject('InvalidXml', "Invalid '" + JSON.stringify(tags.map((t)=>t.tagName), null, 4).replace(/\r?\n/g, '') + "' found.", {
        line: 1,
        col: 1
    });
    return true;
};
/**
 * Read Processing insstructions and skip
 * @param {*} xmlData
 * @param {*} i
 */ function $84845a0d049af20f$var$readPI(xmlData, i) {
    const start = i;
    for(; i < xmlData.length; i++)if (xmlData[i] == '?' || xmlData[i] == ' ') {
        //tagname
        const tagname = xmlData.substr(start, i - start);
        if (i > 5 && tagname === 'xml') return $84845a0d049af20f$var$getErrorObject('InvalidXml', 'XML declaration allowed only at the start of the document.', $84845a0d049af20f$var$getLineNumberForPosition(xmlData, i));
        else if (xmlData[i] == '?' && xmlData[i + 1] == '>') {
            //check if valid attribut string
            i++;
            break;
        } else continue;
    }
    return i;
}
function $84845a0d049af20f$var$readCommentAndCDATA(xmlData, i) {
    if (xmlData.length > i + 5 && xmlData[i + 1] === '-' && xmlData[i + 2] === '-') {
        //comment
        for(i += 3; i < xmlData.length; i++)if (xmlData[i] === '-' && xmlData[i + 1] === '-' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    } else if (xmlData.length > i + 8 && xmlData[i + 1] === 'D' && xmlData[i + 2] === 'O' && xmlData[i + 3] === 'C' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'Y' && xmlData[i + 6] === 'P' && xmlData[i + 7] === 'E') {
        let angleBracketsCount = 1;
        for(i += 8; i < xmlData.length; i++){
            if (xmlData[i] === '<') angleBracketsCount++;
            else if (xmlData[i] === '>') {
                angleBracketsCount--;
                if (angleBracketsCount === 0) break;
            }
        }
    } else if (xmlData.length > i + 9 && xmlData[i + 1] === '[' && xmlData[i + 2] === 'C' && xmlData[i + 3] === 'D' && xmlData[i + 4] === 'A' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'A' && xmlData[i + 7] === '[') {
        for(i += 8; i < xmlData.length; i++)if (xmlData[i] === ']' && xmlData[i + 1] === ']' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    }
    return i;
}
const $84845a0d049af20f$var$doubleQuote = '"';
const $84845a0d049af20f$var$singleQuote = "'";
/**
 * Keep reading xmlData until '<' is found outside the attribute value.
 * @param {string} xmlData
 * @param {number} i
 */ function $84845a0d049af20f$var$readAttributeStr(xmlData, i) {
    let attrStr = '';
    let startChar = '';
    let tagClosed = false;
    for(; i < xmlData.length; i++){
        if (xmlData[i] === $84845a0d049af20f$var$doubleQuote || xmlData[i] === $84845a0d049af20f$var$singleQuote) {
            if (startChar === '') startChar = xmlData[i];
            else if (startChar !== xmlData[i]) ;
            else startChar = '';
        } else if (xmlData[i] === '>') {
            if (startChar === '') {
                tagClosed = true;
                break;
            }
        }
        attrStr += xmlData[i];
    }
    if (startChar !== '') return false;
    return {
        value: attrStr,
        index: i,
        tagClosed: tagClosed
    };
}
/**
 * Select all the attributes whether valid or invalid.
 */ const $84845a0d049af20f$var$validAttrStrRegxp = new RegExp('(\\s*)([^\\s=]+)(\\s*=)?(\\s*([\'"])(([\\s\\S])*?)\\5)?', 'g');
//attr, ="sd", a="amit's", a="sd"b="saf", ab  cd=""
function $84845a0d049af20f$var$validateAttributeString(attrStr, options) {
    //console.log("start:"+attrStr+":end");
    //if(attrStr.trim().length === 0) return true; //empty string
    const matches = $eUZ0B.getAllMatches(attrStr, $84845a0d049af20f$var$validAttrStrRegxp);
    const attrNames = {};
    for(let i = 0; i < matches.length; i++){
        if (matches[i][1].length === 0) //nospace before attribute name: a="sd"b="saf"
        return $84845a0d049af20f$var$getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' has no space in starting.", $84845a0d049af20f$var$getPositionFromMatch(matches[i]));
        else if (matches[i][3] === undefined && !options.allowBooleanAttributes) //independent attribute: ab
        return $84845a0d049af20f$var$getErrorObject('InvalidAttr', "boolean attribute '" + matches[i][2] + "' is not allowed.", $84845a0d049af20f$var$getPositionFromMatch(matches[i]));
        /* else if(matches[i][6] === undefined){//attribute without value: ab=
                    return { err: { code:"InvalidAttr",msg:"attribute " + matches[i][2] + " has no value assigned."}};
                } */ const attrName = matches[i][2];
        if (!$84845a0d049af20f$var$validateAttrName(attrName)) return $84845a0d049af20f$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is an invalid name.", $84845a0d049af20f$var$getPositionFromMatch(matches[i]));
        if (!attrNames.hasOwnProperty(attrName)) //check for duplicate attribute.
        attrNames[attrName] = 1;
        else return $84845a0d049af20f$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is repeated.", $84845a0d049af20f$var$getPositionFromMatch(matches[i]));
    }
    return true;
}
function $84845a0d049af20f$var$validateNumberAmpersand(xmlData, i) {
    let re = /\d/;
    if (xmlData[i] === 'x') {
        i++;
        re = /[\da-fA-F]/;
    }
    for(; i < xmlData.length; i++){
        if (xmlData[i] === ';') return i;
        if (!xmlData[i].match(re)) break;
    }
    return -1;
}
function $84845a0d049af20f$var$validateAmpersand(xmlData, i) {
    // https://www.w3.org/TR/xml/#dt-charref
    i++;
    if (xmlData[i] === ';') return -1;
    if (xmlData[i] === '#') {
        i++;
        return $84845a0d049af20f$var$validateNumberAmpersand(xmlData, i);
    }
    let count = 0;
    for(; i < xmlData.length; i++, count++){
        if (xmlData[i].match(/\w/) && count < 20) continue;
        if (xmlData[i] === ';') break;
        return -1;
    }
    return i;
}
function $84845a0d049af20f$var$getErrorObject(code, message, lineNumber) {
    return {
        err: {
            code: code,
            msg: message,
            line: lineNumber.line || lineNumber,
            col: lineNumber.col
        }
    };
}
function $84845a0d049af20f$var$validateAttrName(attrName) {
    return $eUZ0B.isName(attrName);
}
// const startsWithXML = /^xml/i;
function $84845a0d049af20f$var$validateTagName(tagname) {
    return $eUZ0B.isName(tagname) /* && !tagname.match(startsWithXML) */ ;
}
//this function returns the line number for the character at the given index
function $84845a0d049af20f$var$getLineNumberForPosition(xmlData, index) {
    const lines = xmlData.substring(0, index).split(/\r?\n/);
    return {
        line: lines.length,
        // column number is last line's length + 1, because column numbering starts at 1:
        col: lines[lines.length - 1].length + 1
    };
}
//this function returns the position of the first character of match within attrStr
function $84845a0d049af20f$var$getPositionFromMatch(match) {
    return match.startIndex + match[1].length;
}

});



parcelRegister("238LE", function(module, exports) {
$parcel$export(module.exports, "getBucketEndpointPlugin", function () { return (parcelRequire("1yBqn")).getBucketEndpointPlugin; });
$parcel$export(module.exports, "resolveBucketEndpointConfig", function () { return (parcelRequire("jvqtz")).resolveBucketEndpointConfig; });
parcelRequire("1yBqn");
parcelRequire("5L3OZ");
parcelRequire("jvqtz");

var $lj20A = parcelRequire("lj20A");

});
parcelRegister("1yBqn", function(module, exports) {

$parcel$export(module.exports, "getBucketEndpointPlugin", function () { return $1225ff1cfae3b282$export$6b750e866330f2fe; });

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("1J0sw");
var $jmMP9 = parcelRequire("jmMP9");

var $2xhHn = parcelRequire("2xhHn");

var $5L3OZ = parcelRequire("5L3OZ");

var $lj20A = parcelRequire("lj20A");
var $1225ff1cfae3b282$export$f49f3b47ec112939 = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, $fH1jI.__awaiter)(void 0, void 0, void 0, function() {
                var bucketName, replaceBucketInPath, request, bucketArn, clientRegion, _a, _b, partition, _c, signingRegion, useArnRegion, _d, hostname, bucketEndpoint, modifiedSigningRegion, signingService, _e, hostname, bucketEndpoint;
                return (0, $fH1jI.__generator)(this, function(_f) {
                    switch(_f.label){
                        case 0:
                            bucketName = args.input.Bucket;
                            replaceBucketInPath = options.bucketEndpoint;
                            request = args.request;
                            if (!(0, $jmMP9.HttpRequest).isInstance(request)) return [
                                3 /*break*/ ,
                                7
                            ];
                            if (!options.bucketEndpoint) return [
                                3 /*break*/ ,
                                1
                            ];
                            request.hostname = bucketName;
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 1:
                            if (!(0, $2xhHn.validate)(bucketName)) return [
                                3 /*break*/ ,
                                5
                            ];
                            bucketArn = (0, $2xhHn.parse)(bucketName);
                            _a = (0, $lj20A.getPseudoRegion);
                            return [
                                4 /*yield*/ ,
                                options.region()
                            ];
                        case 2:
                            clientRegion = _a.apply(void 0, [
                                _f.sent()
                            ]);
                            return [
                                4 /*yield*/ ,
                                options.regionInfoProvider(clientRegion)
                            ];
                        case 3:
                            _b = _f.sent() || {}, partition = _b.partition, _c = _b.signingRegion, signingRegion = _c === void 0 ? clientRegion : _c;
                            return [
                                4 /*yield*/ ,
                                options.useArnRegion()
                            ];
                        case 4:
                            useArnRegion = _f.sent();
                            _d = (0, $5L3OZ.bucketHostname)({
                                bucketName: bucketArn,
                                baseHostname: request.hostname,
                                accelerateEndpoint: options.useAccelerateEndpoint,
                                dualstackEndpoint: options.useDualstackEndpoint,
                                pathStyleEndpoint: options.forcePathStyle,
                                tlsCompatible: request.protocol === "https:",
                                useArnRegion: useArnRegion,
                                clientPartition: partition,
                                clientSigningRegion: signingRegion
                            }), hostname = _d.hostname, bucketEndpoint = _d.bucketEndpoint, modifiedSigningRegion = _d.signingRegion, signingService = _d.signingService;
                            // If the request needs to use a region or service name inferred from ARN that different from client region, we
                            // need to set them in the handler context so the signer will use them
                            if (modifiedSigningRegion && modifiedSigningRegion !== signingRegion) context["signing_region"] = modifiedSigningRegion;
                            if (signingService && signingService !== "s3") context["signing_service"] = signingService;
                            request.hostname = hostname;
                            replaceBucketInPath = bucketEndpoint;
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 5:
                            _e = (0, $5L3OZ.bucketHostname)({
                                bucketName: bucketName,
                                baseHostname: request.hostname,
                                accelerateEndpoint: options.useAccelerateEndpoint,
                                dualstackEndpoint: options.useDualstackEndpoint,
                                pathStyleEndpoint: options.forcePathStyle,
                                tlsCompatible: request.protocol === "https:"
                            }), hostname = _e.hostname, bucketEndpoint = _e.bucketEndpoint;
                            request.hostname = hostname;
                            replaceBucketInPath = bucketEndpoint;
                            _f.label = 6;
                        case 6:
                            if (replaceBucketInPath) {
                                request.path = request.path.replace(/^(\/)?[^\/]+/, "");
                                if (request.path === "") request.path = "/";
                            }
                            _f.label = 7;
                        case 7:
                            return [
                                2 /*return*/ ,
                                next((0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
var $1225ff1cfae3b282$export$3912e6e4bed18209 = {
    tags: [
        "BUCKET_ENDPOINT"
    ],
    name: "bucketEndpointMiddleware",
    relation: "before",
    toMiddleware: "hostHeaderMiddleware"
};
var $1225ff1cfae3b282$export$6b750e866330f2fe = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo($1225ff1cfae3b282$export$f49f3b47ec112939(options), $1225ff1cfae3b282$export$3912e6e4bed18209);
        }
    };
};

});
parcelRegister("2xhHn", function(module, exports) {

$parcel$export(module.exports, "validate", function () { return $1d8c646afdea8421$export$a22775fa5e2eebd9; });
$parcel$export(module.exports, "parse", function () { return $1d8c646afdea8421$export$98e6a39c04603d36; });

var $fH1jI = parcelRequire("fH1jI");
var $1d8c646afdea8421$export$a22775fa5e2eebd9 = function(str) {
    return typeof str === "string" && str.indexOf("arn:") === 0 && str.split(":").length >= 6;
};
var $1d8c646afdea8421$export$98e6a39c04603d36 = function(arn) {
    var segments = arn.split(":");
    if (segments.length < 6 || segments[0] !== "arn") throw new Error("Malformed ARN");
    var _a = (0, $fH1jI.__read)(segments), //Skip "arn" literal
    partition = _a[1], service = _a[2], region = _a[3], accountId = _a[4], resource = _a.slice(5);
    return {
        partition: partition,
        service: service,
        region: region,
        accountId: accountId,
        resource: resource.join(":")
    };
};
var $1d8c646afdea8421$export$3f8fe6489e95757d = function(arnObject) {
    var _a = arnObject.partition, partition = _a === void 0 ? "aws" : _a, service = arnObject.service, region = arnObject.region, accountId = arnObject.accountId, resource = arnObject.resource;
    if ([
        service,
        region,
        accountId,
        resource
    ].some(function(segment) {
        return typeof segment !== "string";
    })) throw new Error("Input ARN object is invalid");
    return "arn:" + partition + ":" + service + ":" + region + ":" + accountId + ":" + resource;
};

});

parcelRegister("5L3OZ", function(module, exports) {

$parcel$export(module.exports, "bucketHostname", function () { return $43144e642a294bee$export$92dc36ff3a4794f7; });

var $fH1jI = parcelRequire("fH1jI");

var $lj20A = parcelRequire("lj20A");
var $43144e642a294bee$export$92dc36ff3a4794f7 = function(options) {
    var baseHostname = options.baseHostname;
    if (!(0, $lj20A.S3_HOSTNAME_PATTERN).test(baseHostname)) return {
        bucketEndpoint: false,
        hostname: baseHostname
    };
    return (0, $lj20A.isBucketNameOptions)(options) ? $43144e642a294bee$var$getEndpointFromBucketName(options) : $43144e642a294bee$var$getEndpointFromArn(options);
};
var $43144e642a294bee$var$getEndpointFromArn = function(options) {
    // Infer client region and hostname suffix from hostname from endpoints.json, like `s3.us-west-2.amazonaws.com`
    var _a = (0, $fH1jI.__read)((0, $lj20A.getSuffixForArnEndpoint)(options.baseHostname), 2), clientRegion = _a[0], hostnameSuffix = _a[1];
    var pathStyleEndpoint = options.pathStyleEndpoint, _b = options.dualstackEndpoint, dualstackEndpoint = _b === void 0 ? false : _b, _c = options.accelerateEndpoint, accelerateEndpoint = _c === void 0 ? false : _c, _d = options.tlsCompatible, tlsCompatible = _d === void 0 ? true : _d, useArnRegion = options.useArnRegion, bucketName = options.bucketName, _e = options.clientPartition, clientPartition = _e === void 0 ? "aws" : _e, _f = options.clientSigningRegion, clientSigningRegion = _f === void 0 ? clientRegion : _f;
    (0, $lj20A.validateArnEndpointOptions)({
        pathStyleEndpoint: pathStyleEndpoint,
        accelerateEndpoint: accelerateEndpoint,
        tlsCompatible: tlsCompatible
    });
    // Validate and parse the ARN supplied as a bucket name
    var service = bucketName.service, partition = bucketName.partition, accountId = bucketName.accountId, region = bucketName.region, resource = bucketName.resource;
    (0, $lj20A.validateService)(service);
    (0, $lj20A.validatePartition)(partition, {
        clientPartition: clientPartition
    });
    (0, $lj20A.validateAccountId)(accountId);
    (0, $lj20A.validateRegion)(region, {
        useArnRegion: useArnRegion,
        clientRegion: clientRegion,
        clientSigningRegion: clientSigningRegion
    });
    var _g = (0, $lj20A.getArnResources)(resource), accesspointName = _g.accesspointName, outpostId = _g.outpostId;
    (0, $lj20A.validateDNSHostLabel)(accesspointName + "-" + accountId, {
        tlsCompatible: tlsCompatible
    });
    var endpointRegion = useArnRegion ? region : clientRegion;
    var signingRegion = useArnRegion ? region : clientSigningRegion;
    if (outpostId) {
        // if this is an Outpost ARN
        (0, $lj20A.validateOutpostService)(service);
        (0, $lj20A.validateDNSHostLabel)(outpostId, {
            tlsCompatible: tlsCompatible
        });
        (0, $lj20A.validateNoDualstack)(dualstackEndpoint);
        (0, $lj20A.validateNoFIPS)(endpointRegion);
        return {
            bucketEndpoint: true,
            hostname: accesspointName + "-" + accountId + "." + outpostId + ".s3-outposts." + endpointRegion + "." + hostnameSuffix,
            signingRegion: signingRegion,
            signingService: "s3-outposts"
        };
    }
    // construct endpoint from Accesspoint ARN
    (0, $lj20A.validateS3Service)(service);
    return {
        bucketEndpoint: true,
        hostname: accesspointName + "-" + accountId + ".s3-accesspoint" + (dualstackEndpoint ? ".dualstack" : "") + "." + endpointRegion + "." + hostnameSuffix,
        signingRegion: signingRegion
    };
};
var $43144e642a294bee$var$getEndpointFromBucketName = function(_a) {
    var _b = _a.accelerateEndpoint, accelerateEndpoint = _b === void 0 ? false : _b, baseHostname = _a.baseHostname, bucketName = _a.bucketName, _c = _a.dualstackEndpoint, dualstackEndpoint = _c === void 0 ? false : _c, _d = _a.pathStyleEndpoint, pathStyleEndpoint = _d === void 0 ? false : _d, _e = _a.tlsCompatible, tlsCompatible = _e === void 0 ? true : _e;
    var _f = (0, $fH1jI.__read)((0, $lj20A.getSuffix)(baseHostname), 2), clientRegion = _f[0], hostnameSuffix = _f[1];
    if (pathStyleEndpoint || !(0, $lj20A.isDnsCompatibleBucketName)(bucketName) || tlsCompatible && (0, $lj20A.DOT_PATTERN).test(bucketName)) return {
        bucketEndpoint: false,
        hostname: dualstackEndpoint ? "s3.dualstack." + clientRegion + "." + hostnameSuffix : baseHostname
    };
    if (accelerateEndpoint) baseHostname = "s3-accelerate" + (dualstackEndpoint ? ".dualstack" : "") + "." + hostnameSuffix;
    else if (dualstackEndpoint) baseHostname = "s3.dualstack." + clientRegion + "." + hostnameSuffix;
    return {
        bucketEndpoint: true,
        hostname: bucketName + "." + baseHostname
    };
};

});
parcelRegister("lj20A", function(module, exports) {

$parcel$export(module.exports, "DOT_PATTERN", function () { return $f82cee28bfa5d17d$export$b0b24e5455be29b0; });
$parcel$export(module.exports, "S3_HOSTNAME_PATTERN", function () { return $f82cee28bfa5d17d$export$43f53815580748f; });
$parcel$export(module.exports, "isBucketNameOptions", function () { return $f82cee28bfa5d17d$export$5b522ec9d0d23583; });
$parcel$export(module.exports, "getPseudoRegion", function () { return $f82cee28bfa5d17d$export$2041e7d2db741fc6; });
$parcel$export(module.exports, "isDnsCompatibleBucketName", function () { return $f82cee28bfa5d17d$export$360a1e07839d0d27; });
$parcel$export(module.exports, "getSuffix", function () { return $f82cee28bfa5d17d$export$661d620f7edbf69d; });
$parcel$export(module.exports, "getSuffixForArnEndpoint", function () { return $f82cee28bfa5d17d$export$9822f1db281a24ef; });
$parcel$export(module.exports, "validateArnEndpointOptions", function () { return $f82cee28bfa5d17d$export$9d570635889bea10; });
$parcel$export(module.exports, "validateService", function () { return $f82cee28bfa5d17d$export$56395344d8f6da92; });
$parcel$export(module.exports, "validateS3Service", function () { return $f82cee28bfa5d17d$export$ee796dc843960f7e; });
$parcel$export(module.exports, "validateOutpostService", function () { return $f82cee28bfa5d17d$export$32ff3a9330dbd031; });
$parcel$export(module.exports, "validatePartition", function () { return $f82cee28bfa5d17d$export$2514cb957fb286b; });
$parcel$export(module.exports, "validateRegion", function () { return $f82cee28bfa5d17d$export$6cc2fb0ca7159d47; });
$parcel$export(module.exports, "validateAccountId", function () { return $f82cee28bfa5d17d$export$311f0c1e79834f5a; });
$parcel$export(module.exports, "validateDNSHostLabel", function () { return $f82cee28bfa5d17d$export$eab3c0a6ee9b0457; });
$parcel$export(module.exports, "getArnResources", function () { return $f82cee28bfa5d17d$export$6b274ce9ea6c3c3a; });
$parcel$export(module.exports, "validateNoDualstack", function () { return $f82cee28bfa5d17d$export$76b09f028141bdfc; });
$parcel$export(module.exports, "validateNoFIPS", function () { return $f82cee28bfa5d17d$export$8b4c0cb10287799f; });

var $fH1jI = parcelRequire("fH1jI");
var $f82cee28bfa5d17d$var$DOMAIN_PATTERN = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
var $f82cee28bfa5d17d$var$IP_ADDRESS_PATTERN = /(\d+\.){3}\d+/;
var $f82cee28bfa5d17d$var$DOTS_PATTERN = /\.\./;
var $f82cee28bfa5d17d$export$b0b24e5455be29b0 = /\./;
var $f82cee28bfa5d17d$export$43f53815580748f = /^(.+\.)?s3[.-]([a-z0-9-]+)\./;
var $f82cee28bfa5d17d$var$S3_US_EAST_1_ALTNAME_PATTERN = /^s3(-external-1)?\.amazonaws\.com$/;
var $f82cee28bfa5d17d$var$AWS_PARTITION_SUFFIX = "amazonaws.com";
var $f82cee28bfa5d17d$export$5b522ec9d0d23583 = function(options) {
    return typeof options.bucketName === "string";
};
var $f82cee28bfa5d17d$export$2041e7d2db741fc6 = function(region) {
    return $f82cee28bfa5d17d$var$isFipsRegion(region) ? region.replace(/fips-|-fips/, "") : region;
};
var $f82cee28bfa5d17d$export$360a1e07839d0d27 = function(bucketName) {
    return $f82cee28bfa5d17d$var$DOMAIN_PATTERN.test(bucketName) && !$f82cee28bfa5d17d$var$IP_ADDRESS_PATTERN.test(bucketName) && !$f82cee28bfa5d17d$var$DOTS_PATTERN.test(bucketName);
};
var $f82cee28bfa5d17d$var$getRegionalSuffix = function(hostname) {
    var parts = hostname.match($f82cee28bfa5d17d$export$43f53815580748f);
    return [
        parts[2],
        hostname.replace(new RegExp("^" + parts[0]), "")
    ];
};
var $f82cee28bfa5d17d$export$661d620f7edbf69d = function(hostname) {
    return $f82cee28bfa5d17d$var$S3_US_EAST_1_ALTNAME_PATTERN.test(hostname) ? [
        "us-east-1",
        $f82cee28bfa5d17d$var$AWS_PARTITION_SUFFIX
    ] : $f82cee28bfa5d17d$var$getRegionalSuffix(hostname);
};
var $f82cee28bfa5d17d$export$9822f1db281a24ef = function(hostname) {
    return $f82cee28bfa5d17d$var$S3_US_EAST_1_ALTNAME_PATTERN.test(hostname) ? [
        hostname.replace("." + $f82cee28bfa5d17d$var$AWS_PARTITION_SUFFIX, ""),
        $f82cee28bfa5d17d$var$AWS_PARTITION_SUFFIX
    ] : $f82cee28bfa5d17d$var$getRegionalSuffix(hostname);
};
var $f82cee28bfa5d17d$export$9d570635889bea10 = function(options) {
    if (options.pathStyleEndpoint) throw new Error("Path-style S3 endpoint is not supported when bucket is an ARN");
    if (options.accelerateEndpoint) throw new Error("Accelerate endpoint is not supported when bucket is an ARN");
    if (!options.tlsCompatible) throw new Error("HTTPS is required when bucket is an ARN");
};
var $f82cee28bfa5d17d$export$56395344d8f6da92 = function(service) {
    if (service !== "s3" && service !== "s3-outposts") throw new Error("Expect 's3' or 's3-outposts' in ARN service component");
};
var $f82cee28bfa5d17d$export$ee796dc843960f7e = function(service) {
    if (service !== "s3") throw new Error("Expect 's3' in Accesspoint ARN service component");
};
var $f82cee28bfa5d17d$export$32ff3a9330dbd031 = function(service) {
    if (service !== "s3-outposts") throw new Error("Expect 's3-posts' in Outpost ARN service component");
};
var $f82cee28bfa5d17d$export$2514cb957fb286b = function(partition, options) {
    if (partition !== options.clientPartition) throw new Error("Partition in ARN is incompatible, got \"" + partition + "\" but expected \"" + options.clientPartition + "\"");
};
var $f82cee28bfa5d17d$export$6cc2fb0ca7159d47 = function(region, options) {
    if (region === "") throw new Error("ARN region is empty");
    if (!options.useArnRegion && !$f82cee28bfa5d17d$var$isEqualRegions(region, options.clientRegion) && !$f82cee28bfa5d17d$var$isEqualRegions(region, options.clientSigningRegion)) throw new Error("Region in ARN is incompatible, got " + region + " but expected " + options.clientRegion);
    if (options.useArnRegion && $f82cee28bfa5d17d$var$isFipsRegion(region)) throw new Error("Endpoint does not support FIPS region");
};
var $f82cee28bfa5d17d$var$isFipsRegion = function(region) {
    return region.startsWith("fips-") || region.endsWith("-fips");
};
var $f82cee28bfa5d17d$var$isEqualRegions = function(regionA, regionB) {
    return regionA === regionB || $f82cee28bfa5d17d$export$2041e7d2db741fc6(regionA) === regionB || regionA === $f82cee28bfa5d17d$export$2041e7d2db741fc6(regionB);
};
var $f82cee28bfa5d17d$export$311f0c1e79834f5a = function(accountId) {
    if (!/[0-9]{12}/.exec(accountId)) throw new Error("Access point ARN accountID does not match regex '[0-9]{12}'");
};
var $f82cee28bfa5d17d$export$eab3c0a6ee9b0457 = function(label, options) {
    if (options === void 0) options = {
        tlsCompatible: true
    };
    // reference: https://tools.ietf.org/html/rfc3986#section-3.2.2
    if (label.length >= 64 || !/^[a-z0-9][a-z0-9.-]+[a-z0-9]$/.test(label) || /(\d+\.){3}\d+/.test(label) || /[.-]{2}/.test(label) || (options === null || options === void 0 ? void 0 : options.tlsCompatible) && $f82cee28bfa5d17d$export$b0b24e5455be29b0.test(label)) throw new Error("Invalid DNS label " + label);
};
var $f82cee28bfa5d17d$export$6b274ce9ea6c3c3a = function(resource) {
    var delimiter = resource.includes(":") ? ":" : "/";
    var _a = (0, $fH1jI.__read)(resource.split(delimiter)), resourceType = _a[0], rest = _a.slice(1);
    if (resourceType === "accesspoint") {
        // Parse accesspoint ARN
        if (rest.length !== 1 || rest[0] === "") throw new Error("Access Point ARN should have one resource accesspoint" + delimiter + "{accesspointname}");
        return {
            accesspointName: rest[0]
        };
    } else if (resourceType === "outpost") {
        // Parse outpost ARN
        if (!rest[0] || rest[1] !== "accesspoint" || !rest[2] || rest.length !== 3) throw new Error("Outpost ARN should have resource outpost" + delimiter + "{outpostId}" + delimiter + "accesspoint" + delimiter + "{accesspointName}");
        var _b = (0, $fH1jI.__read)(rest, 3), outpostId = _b[0], _ = _b[1], accesspointName = _b[2];
        return {
            outpostId: outpostId,
            accesspointName: accesspointName
        };
    } else throw new Error("ARN resource should begin with 'accesspoint" + delimiter + "' or 'outpost" + delimiter + "'");
};
var $f82cee28bfa5d17d$export$76b09f028141bdfc = function(dualstackEndpoint) {
    if (dualstackEndpoint) throw new Error("Dualstack endpoint is not supported with Outpost");
};
var $f82cee28bfa5d17d$export$8b4c0cb10287799f = function(region) {
    if ($f82cee28bfa5d17d$var$isFipsRegion(region !== null && region !== void 0 ? region : "")) throw new Error("FIPS region is not supported with Outpost, got " + region);
};

});



parcelRegister("jvqtz", function(module, exports) {

$parcel$export(module.exports, "resolveBucketEndpointConfig", function () { return $e33573209b236781$export$9810f1a949e3136; });

var $fH1jI = parcelRequire("fH1jI");
function $e33573209b236781$export$9810f1a949e3136(input) {
    var _a = input.bucketEndpoint, bucketEndpoint = _a === void 0 ? false : _a, _b = input.forcePathStyle, forcePathStyle = _b === void 0 ? false : _b, _c = input.useAccelerateEndpoint, useAccelerateEndpoint = _c === void 0 ? false : _c, _d = input.useDualstackEndpoint, useDualstackEndpoint = _d === void 0 ? false : _d, _e = input.useArnRegion, useArnRegion = _e === void 0 ? false : _e;
    return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, input), {
        bucketEndpoint: bucketEndpoint,
        forcePathStyle: forcePathStyle,
        useAccelerateEndpoint: useAccelerateEndpoint,
        useDualstackEndpoint: useDualstackEndpoint,
        useArnRegion: typeof useArnRegion === "function" ? useArnRegion : function() {
            return Promise.resolve(useArnRegion);
        }
    });
}
var $e33573209b236781$export$7eb281bbdddd5d12 = "AWS_S3_USE_ARN_REGION";
var $e33573209b236781$export$812c693bf225d32a = "s3_use_arn_region";
var $e33573209b236781$export$bac037ab69dc2bd4 = {
    environmentVariableSelector: function(env) {
        if (!Object.prototype.hasOwnProperty.call(env, $e33573209b236781$export$7eb281bbdddd5d12)) return undefined;
        if (env[$e33573209b236781$export$7eb281bbdddd5d12] === "true") return true;
        if (env[$e33573209b236781$export$7eb281bbdddd5d12] === "false") return false;
        throw new Error("Cannot load env " + $e33573209b236781$export$7eb281bbdddd5d12 + ". Expected \"true\" or \"false\", got " + env[$e33573209b236781$export$7eb281bbdddd5d12] + ".");
    },
    configFileSelector: function(profile) {
        if (!Object.prototype.hasOwnProperty.call(profile, $e33573209b236781$export$812c693bf225d32a)) return undefined;
        if (profile[$e33573209b236781$export$812c693bf225d32a] === "true") return true;
        if (profile[$e33573209b236781$export$812c693bf225d32a] === "false") return false;
        throw new Error("Cannot load shared config entry " + $e33573209b236781$export$812c693bf225d32a + ". Expected \"true\" or \"false\", got " + profile[$e33573209b236781$export$812c693bf225d32a] + ".");
    },
    default: false
};

});



parcelRegister("aT9AQ", function(module, exports) {

$parcel$export(module.exports, "GetObjectCommand", function () { return $7ed67b710af9b358$export$25364b3fa12a4666; });

var $9OyH6 = parcelRequire("9OyH6");

var $lLFWX = parcelRequire("lLFWX");

var $6RHn6 = parcelRequire("6RHn6");
parcelRequire("238LE");
var $1yBqn = parcelRequire("1yBqn");
parcelRequire("5Wom8");
var $jU8uG = parcelRequire("jU8uG");

var $5SKvi = parcelRequire("5SKvi");
parcelRequire("fF6iB");
var $koeHb = parcelRequire("koeHb");
var $7ed67b710af9b358$export$25364b3fa12a4666 = /** @class */ function(_super) {
    (0, $9OyH6.__extends)(GetObjectCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetObjectCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    GetObjectCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $jU8uG.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $5SKvi.getSsecPlugin)(configuration));
        this.middlewareStack.use((0, $1yBqn.getBucketEndpointPlugin)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "GetObjectCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $lLFWX.GetObjectRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $lLFWX.GetObjectOutput).filterSensitiveLog
        };
        if (typeof logger.info === "function") logger.info({
            clientName: clientName,
            commandName: commandName
        });
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetObjectCommand.prototype.serialize = function(input, context) {
        return (0, $6RHn6.serializeAws_restXmlGetObjectCommand)(input, context);
    };
    GetObjectCommand.prototype.deserialize = function(output, context) {
        return (0, $6RHn6.deserializeAws_restXmlGetObjectCommand)(output, context);
    };
    return GetObjectCommand;
}((0, $koeHb.Command));

});
parcelRegister("5SKvi", function(module, exports) {

$parcel$export(module.exports, "getSsecPlugin", function () { return $4486118fb6a13381$export$baf25e0187b0946b; });

var $fH1jI = parcelRequire("fH1jI");
function $4486118fb6a13381$export$16515ae394ee1bc8(options) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, $fH1jI.__awaiter)(_this, void 0, void 0, function() {
                var input, properties, properties_1, properties_1_1, prop, value, valueView, encoded, hash, _a, _b, _c, _d, e_1_1;
                var e_1, _e, _f;
                return (0, $fH1jI.__generator)(this, function(_g) {
                    switch(_g.label){
                        case 0:
                            input = (0, $fH1jI.__assign)({}, args.input);
                            properties = [
                                {
                                    target: "SSECustomerKey",
                                    hash: "SSECustomerKeyMD5"
                                },
                                {
                                    target: "CopySourceSSECustomerKey",
                                    hash: "CopySourceSSECustomerKeyMD5"
                                }
                            ];
                            _g.label = 1;
                        case 1:
                            _g.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            properties_1 = (0, $fH1jI.__values)(properties), properties_1_1 = properties_1.next();
                            _g.label = 2;
                        case 2:
                            if (!!properties_1_1.done) return [
                                3 /*break*/ ,
                                5
                            ];
                            prop = properties_1_1.value;
                            value = input[prop.target];
                            if (!value) return [
                                3 /*break*/ ,
                                4
                            ];
                            valueView = ArrayBuffer.isView(value) ? new Uint8Array(value.buffer, value.byteOffset, value.byteLength) : typeof value === "string" ? options.utf8Decoder(value) : new Uint8Array(value);
                            encoded = options.base64Encoder(valueView);
                            hash = new options.md5();
                            hash.update(valueView);
                            _a = [
                                (0, $fH1jI.__assign)({}, input)
                            ];
                            _f = {}, _f[prop.target] = encoded;
                            _b = prop.hash;
                            _d = (_c = options).base64Encoder;
                            return [
                                4 /*yield*/ ,
                                hash.digest()
                            ];
                        case 3:
                            input = (0, $fH1jI.__assign).apply(void 0, _a.concat([
                                (_f[_b] = _d.apply(_c, [
                                    _g.sent()
                                ]), _f)
                            ]));
                            _g.label = 4;
                        case 4:
                            properties_1_1 = properties_1.next();
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 6:
                            e_1_1 = _g.sent();
                            e_1 = {
                                error: e_1_1
                            };
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            try {
                                if (properties_1_1 && !properties_1_1.done && (_e = properties_1.return)) _e.call(properties_1);
                            } finally{
                                if (e_1) throw e_1.error;
                            }
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 8:
                            return [
                                2 /*return*/ ,
                                next((0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, args), {
                                    input: input
                                }))
                            ];
                    }
                });
            });
        };
    };
}
var $4486118fb6a13381$export$bd3ed071b8ca05b3 = {
    name: "ssecMiddleware",
    step: "initialize",
    tags: [
        "SSE"
    ]
};
var $4486118fb6a13381$export$baf25e0187b0946b = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($4486118fb6a13381$export$16515ae394ee1bc8(config), $4486118fb6a13381$export$bd3ed071b8ca05b3);
        }
    };
};

});


parcelRegister("lXAOX", function(module, exports) {

$parcel$export(module.exports, "ListObjectsCommand", function () { return $ffcbab83506e5c7c$export$918ee8a533502438; });

var $9OyH6 = parcelRequire("9OyH6");

var $lLFWX = parcelRequire("lLFWX");

var $6RHn6 = parcelRequire("6RHn6");
parcelRequire("238LE");
var $1yBqn = parcelRequire("1yBqn");
parcelRequire("5Wom8");
var $jU8uG = parcelRequire("jU8uG");
parcelRequire("fF6iB");
var $koeHb = parcelRequire("koeHb");
var $ffcbab83506e5c7c$export$918ee8a533502438 = /** @class */ function(_super) {
    (0, $9OyH6.__extends)(ListObjectsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListObjectsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    ListObjectsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $jU8uG.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $1yBqn.getBucketEndpointPlugin)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "ListObjectsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $lLFWX.ListObjectsRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $lLFWX.ListObjectsOutput).filterSensitiveLog
        };
        if (typeof logger.info === "function") logger.info({
            clientName: clientName,
            commandName: commandName
        });
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListObjectsCommand.prototype.serialize = function(input, context) {
        return (0, $6RHn6.serializeAws_restXmlListObjectsCommand)(input, context);
    };
    ListObjectsCommand.prototype.deserialize = function(output, context) {
        return (0, $6RHn6.deserializeAws_restXmlListObjectsCommand)(output, context);
    };
    return ListObjectsCommand;
}((0, $koeHb.Command));

});

parcelRegister("1UQgc", function(module, exports) {

$parcel$export(module.exports, "S3Client", function () { return $16538f3b4207cb1a$export$b5be36c66bc46237; });

var $9OyH6 = parcelRequire("9OyH6");

var $9MLXx = parcelRequire("9MLXx");
parcelRequire("eKUPO");
var $8dzJz = parcelRequire("8dzJz");
var $auJcL = parcelRequire("auJcL");
parcelRequire("g0GMS");
var $eiAgf = parcelRequire("eiAgf");
parcelRequire("238LE");
var $jvqtz = parcelRequire("jvqtz");

var $d0jvP = parcelRequire("d0jvP");

var $k68qi = parcelRequire("k68qi");

var $8rZ2X = parcelRequire("8rZ2X");
parcelRequire("jyqb9");
var $7Gq7f = parcelRequire("7Gq7f");
parcelRequire("diPxB");
var $6Dcus = parcelRequire("6Dcus");
var $bprgV = parcelRequire("bprgV");
parcelRequire("2cwKX");
var $5jJuE = parcelRequire("5jJuE");
var $d4vIJ = parcelRequire("d4vIJ");
parcelRequire("fGFVS");
var $1TJTS = parcelRequire("1TJTS");
var $gcXH0 = parcelRequire("gcXH0");
parcelRequire("ezV12");
var $gzcdq = parcelRequire("gzcdq");
var $koCCo = parcelRequire("koCCo");
parcelRequire("fF6iB");
var $gQUrx = parcelRequire("gQUrx");
/**
 * <p></p>
 */ var $16538f3b4207cb1a$export$b5be36c66bc46237 = /** @class */ function(_super) {
    (0, $9OyH6.__extends)(S3Client, _super);
    function S3Client(configuration) {
        var _this = this;
        var _config_0 = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, (0, $9MLXx.ClientDefaultValues)), configuration);
        var _config_1 = (0, $auJcL.resolveRegionConfig)(_config_0);
        var _config_2 = (0, $8dzJz.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, $gcXH0.resolveAwsAuthConfig)(_config_2);
        var _config_4 = (0, $bprgV.resolveRetryConfig)(_config_3);
        var _config_5 = (0, $koCCo.resolveUserAgentConfig)(_config_4);
        var _config_6 = (0, $jvqtz.resolveBucketEndpointConfig)(_config_5);
        var _config_7 = (0, $8rZ2X.resolveHostHeaderConfig)(_config_6);
        var _config_8 = (0, $eiAgf.resolveEventStreamSerdeConfig)(_config_7);
        _this = _super.call(this, _config_8) || this;
        _this.config = _config_8;
        _this.middlewareStack.use((0, $1TJTS.getAwsAuthPlugin)(_this.config));
        _this.middlewareStack.use((0, $6Dcus.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, $gzcdq.getUserAgentPlugin)(_this.config));
        _this.middlewareStack.use((0, $d0jvP.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, $d4vIJ.getValidateBucketNamePlugin)(_this.config));
        _this.middlewareStack.use((0, $5jJuE.getUseRegionalEndpointPlugin)(_this.config));
        _this.middlewareStack.use((0, $k68qi.getAddExpectContinuePlugin)(_this.config));
        _this.middlewareStack.use((0, $8rZ2X.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, $7Gq7f.getLoggerPlugin)(_this.config));
        return _this;
    }
    S3Client.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return S3Client;
}((0, $gQUrx.Client));

});
parcelRegister("9MLXx", function(module, exports) {

$parcel$export(module.exports, "ClientDefaultValues", function () { return $71fdcc75f22bf996$export$b1f2d721b555a243; });

var $9OyH6 = parcelRequire("9OyH6");

var $d86uS = parcelRequire("d86uS");

var $bVSDk = parcelRequire("bVSDk");
parcelRequire("lUUFq");
var $1465y = parcelRequire("1465y");
parcelRequire("2NxHI");
var $h2woU = parcelRequire("h2woU");
var $gGhUY = parcelRequire("gGhUY");

var $iKjeu = parcelRequire("iKjeu");

var $61J1X = parcelRequire("61J1X");

var $in1KN = parcelRequire("in1KN");
parcelRequire("diPxB");
var $hxaUp = parcelRequire("hxaUp");

var $b3bpS = parcelRequire("b3bpS");

var $f4uPV = parcelRequire("f4uPV");

var $6AFBv = parcelRequire("6AFBv");

var $jc6bn = parcelRequire("jc6bn");

var $12JSh = parcelRequire("12JSh");

var $dAv28 = parcelRequire("dAv28");
var $71fdcc75f22bf996$export$b1f2d721b555a243 = (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, (0, $dAv28.ClientSharedValues)), {
    runtime: "browser",
    base64Decoder: (0, $f4uPV.fromBase64),
    base64Encoder: (0, $f4uPV.toBase64),
    bodyLengthChecker: (0, $6AFBv.calculateBodyLength),
    credentialDefaultProvider: (0, $61J1X.invalidFunction)("Credential is missing"),
    defaultUserAgent: (0, $jc6bn.defaultUserAgent)((0, (/*@__PURE__*/$parcel$interopDefault($d86uS))).name, (0, (/*@__PURE__*/$parcel$interopDefault($d86uS))).version),
    eventStreamSerdeProvider: (0, $1465y.eventStreamSerdeProvider),
    maxAttempts: (0, $hxaUp.DEFAULT_MAX_ATTEMPTS),
    md5: (0, $in1KN.Md5),
    region: (0, $61J1X.invalidFunction)("Region is missing"),
    requestHandler: new (0, $h2woU.FetchHttpHandler)(),
    sha256: (0, $bVSDk.Sha256),
    streamCollector: (0, $gGhUY.streamCollector),
    streamHasher: (0, $iKjeu.blobHasher),
    urlParser: (0, $b3bpS.parseUrl),
    utf8Decoder: (0, $12JSh.fromUtf8),
    utf8Encoder: (0, $12JSh.toUtf8)
});

});
parcelRegister("d86uS", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"@aws-sdk/client-s3\",\"description\":\"AWS SDK for JavaScript S3 Client for Node.js, Browser and React Native\",\"version\":\"1.0.0-rc.4\",\"scripts\":{\"clean\":\"npm run remove-definitions && npm run remove-dist\",\"build-documentation\":\"npm run clean && typedoc ./\",\"prepublishOnly\":\"yarn build\",\"pretest\":\"yarn build:cjs\",\"remove-definitions\":\"rimraf ./types\",\"remove-dist\":\"rimraf ./dist\",\"remove-documentation\":\"rimraf ./docs\",\"test:unit\":\"mocha **/cjs/**/*.spec.js\",\"test:e2e\":\"mocha **/cjs/**/*.ispec.js && karma start karma.conf.js\",\"test\":\"yarn test:unit\",\"build:cjs\":\"tsc -p tsconfig.json\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build\":\"yarn build:cjs && yarn build:es\"},\"main\":\"./dist/cjs/index.js\",\"types\":\"./types/index.d.ts\",\"module\":\"./dist/es/index.js\",\"browser\":{\"./runtimeConfig\":\"./runtimeConfig.browser\"},\"react-native\":{\"./runtimeConfig\":\"./runtimeConfig.native\"},\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha256-browser\":\"^1.0.0\",\"@aws-crypto/sha256-js\":\"^1.0.0\",\"@aws-sdk/config-resolver\":\"1.0.0-rc.3\",\"@aws-sdk/credential-provider-node\":\"1.0.0-rc.3\",\"@aws-sdk/eventstream-serde-browser\":\"1.0.0-rc.3\",\"@aws-sdk/eventstream-serde-config-resolver\":\"1.0.0-rc.3\",\"@aws-sdk/eventstream-serde-node\":\"1.0.0-rc.3\",\"@aws-sdk/fetch-http-handler\":\"1.0.0-rc.3\",\"@aws-sdk/hash-blob-browser\":\"1.0.0-rc.3\",\"@aws-sdk/hash-node\":\"1.0.0-rc.3\",\"@aws-sdk/hash-stream-node\":\"1.0.0-rc.3\",\"@aws-sdk/invalid-dependency\":\"1.0.0-rc.3\",\"@aws-sdk/md5-js\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-apply-body-checksum\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-bucket-endpoint\":\"1.0.0-rc.4\",\"@aws-sdk/middleware-content-length\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-expect-continue\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-host-header\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-location-constraint\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-logger\":\"1.0.0-rc.4\",\"@aws-sdk/middleware-retry\":\"1.0.0-rc.4\",\"@aws-sdk/middleware-sdk-s3\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-serde\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-signing\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-ssec\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-stack\":\"1.0.0-rc.4\",\"@aws-sdk/middleware-user-agent\":\"1.0.0-rc.3\",\"@aws-sdk/node-config-provider\":\"1.0.0-rc.3\",\"@aws-sdk/node-http-handler\":\"1.0.0-rc.3\",\"@aws-sdk/protocol-http\":\"1.0.0-rc.3\",\"@aws-sdk/smithy-client\":\"1.0.0-rc.4\",\"@aws-sdk/types\":\"1.0.0-rc.3\",\"@aws-sdk/url-parser-browser\":\"1.0.0-rc.3\",\"@aws-sdk/url-parser-node\":\"1.0.0-rc.3\",\"@aws-sdk/util-base64-browser\":\"1.0.0-rc.3\",\"@aws-sdk/util-base64-node\":\"1.0.0-rc.3\",\"@aws-sdk/util-body-length-browser\":\"1.0.0-rc.3\",\"@aws-sdk/util-body-length-node\":\"1.0.0-rc.3\",\"@aws-sdk/util-user-agent-browser\":\"1.0.0-rc.3\",\"@aws-sdk/util-user-agent-node\":\"1.0.0-rc.3\",\"@aws-sdk/util-utf8-browser\":\"1.0.0-rc.3\",\"@aws-sdk/util-utf8-node\":\"1.0.0-rc.3\",\"@aws-sdk/xml-builder\":\"1.0.0-rc.3\",\"fast-xml-parser\":\"^3.16.0\",\"tslib\":\"^2.0.0\"},\"devDependencies\":{\"@aws-sdk/client-documentation-generator\":\"1.0.0-rc.3\",\"@types/chai\":\"^4.2.11\",\"@types/mocha\":\"^7.0.2\",\"@types/node\":\"^12.7.5\",\"jest\":\"^26.1.0\",\"rimraf\":\"^3.0.0\",\"typedoc\":\"^0.17.8\",\"typescript\":\"~4.0.2\"},\"engines\":{\"node\":\">=10.0.0\"},\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/master/clients/client-s3\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-s3\"}}");

});

parcelRegister("lUUFq", function(module, exports) {
$parcel$export(module.exports, "eventStreamSerdeProvider", function () { return (parcelRequire("1465y")).eventStreamSerdeProvider; });
parcelRequire("1465y");
parcelRequire("4PiGl");
parcelRequire("h7qa7");

});
parcelRegister("1465y", function(module, exports) {

$parcel$export(module.exports, "eventStreamSerdeProvider", function () { return $0c6ae33efd4c4b7f$export$9d23a885702ebafb; });

var $4PiGl = parcelRequire("4PiGl");
var $0c6ae33efd4c4b7f$export$9d23a885702ebafb = function(options) {
    return new (0, $4PiGl.EventStreamMarshaller)(options);
};

});
parcelRegister("4PiGl", function(module, exports) {

$parcel$export(module.exports, "EventStreamMarshaller", function () { return $383a6ab5ef68b6d7$export$b64afa0aa6ce60e2; });
parcelRequire("5AQc6");
var $dLxrs = parcelRequire("dLxrs");
parcelRequire("kliSL");
var $f5MGE = parcelRequire("f5MGE");

var $h7qa7 = parcelRequire("h7qa7");
/**
 * Utility class used to serialize and deserialize event streams in
 * browsers and ReactNative.
 *
 * In browsers where ReadableStream API is available:
 * * deserialize from ReadableStream to an async iterable of output structure
 * * serialize from async iterable of input structure to ReadableStream
 * In ReactNative where only async iterable API is available:
 * * deserialize from async iterable of binaries to async iterable of output structure
 * * serialize from async iterable of input structure to async iterable of binaries
 *
 * We use ReadableStream API in browsers because of the consistency with other
 * streaming operations, where ReadableStream API is used to denote streaming data.
 * Whereas in ReactNative, ReadableStream API is not available, we use async iterable
 * for streaming data although it has lower throughput.
 */ var $383a6ab5ef68b6d7$export$b64afa0aa6ce60e2 = /** @class */ function() {
    function EventStreamMarshaller(_a) {
        var utf8Encoder = _a.utf8Encoder, utf8Decoder = _a.utf8Decoder;
        this.eventMarshaller = new (0, $dLxrs.EventStreamMarshaller)(utf8Encoder, utf8Decoder);
        this.universalMarshaller = new (0, $f5MGE.EventStreamMarshaller)({
            utf8Decoder: utf8Decoder,
            utf8Encoder: utf8Encoder
        });
    }
    EventStreamMarshaller.prototype.deserialize = function(body, deserializer) {
        var bodyIterable = $383a6ab5ef68b6d7$var$isReadableStream(body) ? (0, $h7qa7.readableStreamtoIterable)(body) : body;
        return this.universalMarshaller.deserialize(bodyIterable, deserializer);
    };
    /**
     * Generate a stream that serialize events into stream of binary chunks;
     *
     * Caveat is that streaming request payload doesn't work on browser with native
     * xhr or fetch handler currently because they don't support upload streaming.
     * reference:
     * * https://bugs.chromium.org/p/chromium/issues/detail?id=688906
     * * https://bugzilla.mozilla.org/show_bug.cgi?id=1387483
     *
     */ EventStreamMarshaller.prototype.serialize = function(input, serializer) {
        var serialziedIterable = this.universalMarshaller.serialize(input, serializer);
        return typeof ReadableStream === "function" ? (0, $h7qa7.iterableToReadableStream)(serialziedIterable) : serialziedIterable;
    };
    return EventStreamMarshaller;
}();
var $383a6ab5ef68b6d7$var$isReadableStream = function(body) {
    return typeof ReadableStream === "function" && body instanceof ReadableStream;
};

});
parcelRegister("5AQc6", function(module, exports) {
$parcel$export(module.exports, "EventStreamMarshaller", function () { return (parcelRequire("dLxrs")).EventStreamMarshaller; });
parcelRequire("dLxrs");
parcelRequire("h7QvZ");
parcelRequire("elzOk");

});
parcelRegister("dLxrs", function(module, exports) {

$parcel$export(module.exports, "EventStreamMarshaller", function () { return $a0599b04b8c17082$export$b64afa0aa6ce60e2; });

var $2E6PK = parcelRequire("2E6PK");

var $fAucy = parcelRequire("fAucy");

var $j6Z81 = parcelRequire("j6Z81");
/**
 * A marshaller that can convert binary-packed event stream messages into
 * JavaScript objects and back again into their binary format.
 */ var $a0599b04b8c17082$export$b64afa0aa6ce60e2 = /** @class */ function() {
    function EventStreamMarshaller(toUtf8, fromUtf8) {
        this.headerMarshaller = new (0, $fAucy.HeaderMarshaller)(toUtf8, fromUtf8);
    }
    /**
     * Convert a structured JavaScript object with tagged headers into a binary
     * event stream message.
     */ EventStreamMarshaller.prototype.marshall = function(_a) {
        var rawHeaders = _a.headers, body = _a.body;
        var headers = this.headerMarshaller.format(rawHeaders);
        var length = headers.byteLength + body.byteLength + 16;
        var out = new Uint8Array(length);
        var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
        var checksum = new (0, $2E6PK.Crc32)();
        // Format message
        view.setUint32(0, length, false);
        view.setUint32(4, headers.byteLength, false);
        view.setUint32(8, checksum.update(out.subarray(0, 8)).digest(), false);
        out.set(headers, 12);
        out.set(body, headers.byteLength + 12);
        // Write trailing message checksum
        view.setUint32(length - 4, checksum.update(out.subarray(8, length - 4)).digest(), false);
        return out;
    };
    /**
     * Convert a binary event stream message into a JavaScript object with an
     * opaque, binary body and tagged, parsed headers.
     */ EventStreamMarshaller.prototype.unmarshall = function(message) {
        var _a = (0, $j6Z81.splitMessage)(message), headers = _a.headers, body = _a.body;
        return {
            headers: this.headerMarshaller.parse(headers),
            body: body
        };
    };
    /**
     * Convert a structured JavaScript object with tagged headers into a binary
     * event stream message header.
     */ EventStreamMarshaller.prototype.formatHeaders = function(rawHeaders) {
        return this.headerMarshaller.format(rawHeaders);
    };
    return EventStreamMarshaller;
}();

});
parcelRegister("2E6PK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AwsCrc32 = module.exports.Crc32 = module.exports.crc32 = void 0;

var $fH1jI = parcelRequire("fH1jI");

var $iUHWq = parcelRequire("iUHWq");
function $1ed49e36ed4d23b9$var$crc32(data) {
    return new $1ed49e36ed4d23b9$var$Crc32().update(data).digest();
}
module.exports.crc32 = $1ed49e36ed4d23b9$var$crc32;
var $1ed49e36ed4d23b9$var$Crc32 = /** @class */ function() {
    function Crc32() {
        this.checksum = 0xffffffff;
    }
    Crc32.prototype.update = function(data) {
        var e_1, _a;
        try {
            for(var data_1 = (0, $fH1jI.__values)(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()){
                var byte = data_1_1.value;
                this.checksum = this.checksum >>> 8 ^ $1ed49e36ed4d23b9$var$lookupTable[(this.checksum ^ byte) & 0xff];
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    Crc32.prototype.digest = function() {
        return (this.checksum ^ 0xffffffff) >>> 0;
    };
    return Crc32;
}();
module.exports.Crc32 = $1ed49e36ed4d23b9$var$Crc32;
// prettier-ignore
var $1ed49e36ed4d23b9$var$a_lookUpTable = [
    0x00000000,
    0x77073096,
    0xEE0E612C,
    0x990951BA,
    0x076DC419,
    0x706AF48F,
    0xE963A535,
    0x9E6495A3,
    0x0EDB8832,
    0x79DCB8A4,
    0xE0D5E91E,
    0x97D2D988,
    0x09B64C2B,
    0x7EB17CBD,
    0xE7B82D07,
    0x90BF1D91,
    0x1DB71064,
    0x6AB020F2,
    0xF3B97148,
    0x84BE41DE,
    0x1ADAD47D,
    0x6DDDE4EB,
    0xF4D4B551,
    0x83D385C7,
    0x136C9856,
    0x646BA8C0,
    0xFD62F97A,
    0x8A65C9EC,
    0x14015C4F,
    0x63066CD9,
    0xFA0F3D63,
    0x8D080DF5,
    0x3B6E20C8,
    0x4C69105E,
    0xD56041E4,
    0xA2677172,
    0x3C03E4D1,
    0x4B04D447,
    0xD20D85FD,
    0xA50AB56B,
    0x35B5A8FA,
    0x42B2986C,
    0xDBBBC9D6,
    0xACBCF940,
    0x32D86CE3,
    0x45DF5C75,
    0xDCD60DCF,
    0xABD13D59,
    0x26D930AC,
    0x51DE003A,
    0xC8D75180,
    0xBFD06116,
    0x21B4F4B5,
    0x56B3C423,
    0xCFBA9599,
    0xB8BDA50F,
    0x2802B89E,
    0x5F058808,
    0xC60CD9B2,
    0xB10BE924,
    0x2F6F7C87,
    0x58684C11,
    0xC1611DAB,
    0xB6662D3D,
    0x76DC4190,
    0x01DB7106,
    0x98D220BC,
    0xEFD5102A,
    0x71B18589,
    0x06B6B51F,
    0x9FBFE4A5,
    0xE8B8D433,
    0x7807C9A2,
    0x0F00F934,
    0x9609A88E,
    0xE10E9818,
    0x7F6A0DBB,
    0x086D3D2D,
    0x91646C97,
    0xE6635C01,
    0x6B6B51F4,
    0x1C6C6162,
    0x856530D8,
    0xF262004E,
    0x6C0695ED,
    0x1B01A57B,
    0x8208F4C1,
    0xF50FC457,
    0x65B0D9C6,
    0x12B7E950,
    0x8BBEB8EA,
    0xFCB9887C,
    0x62DD1DDF,
    0x15DA2D49,
    0x8CD37CF3,
    0xFBD44C65,
    0x4DB26158,
    0x3AB551CE,
    0xA3BC0074,
    0xD4BB30E2,
    0x4ADFA541,
    0x3DD895D7,
    0xA4D1C46D,
    0xD3D6F4FB,
    0x4369E96A,
    0x346ED9FC,
    0xAD678846,
    0xDA60B8D0,
    0x44042D73,
    0x33031DE5,
    0xAA0A4C5F,
    0xDD0D7CC9,
    0x5005713C,
    0x270241AA,
    0xBE0B1010,
    0xC90C2086,
    0x5768B525,
    0x206F85B3,
    0xB966D409,
    0xCE61E49F,
    0x5EDEF90E,
    0x29D9C998,
    0xB0D09822,
    0xC7D7A8B4,
    0x59B33D17,
    0x2EB40D81,
    0xB7BD5C3B,
    0xC0BA6CAD,
    0xEDB88320,
    0x9ABFB3B6,
    0x03B6E20C,
    0x74B1D29A,
    0xEAD54739,
    0x9DD277AF,
    0x04DB2615,
    0x73DC1683,
    0xE3630B12,
    0x94643B84,
    0x0D6D6A3E,
    0x7A6A5AA8,
    0xE40ECF0B,
    0x9309FF9D,
    0x0A00AE27,
    0x7D079EB1,
    0xF00F9344,
    0x8708A3D2,
    0x1E01F268,
    0x6906C2FE,
    0xF762575D,
    0x806567CB,
    0x196C3671,
    0x6E6B06E7,
    0xFED41B76,
    0x89D32BE0,
    0x10DA7A5A,
    0x67DD4ACC,
    0xF9B9DF6F,
    0x8EBEEFF9,
    0x17B7BE43,
    0x60B08ED5,
    0xD6D6A3E8,
    0xA1D1937E,
    0x38D8C2C4,
    0x4FDFF252,
    0xD1BB67F1,
    0xA6BC5767,
    0x3FB506DD,
    0x48B2364B,
    0xD80D2BDA,
    0xAF0A1B4C,
    0x36034AF6,
    0x41047A60,
    0xDF60EFC3,
    0xA867DF55,
    0x316E8EEF,
    0x4669BE79,
    0xCB61B38C,
    0xBC66831A,
    0x256FD2A0,
    0x5268E236,
    0xCC0C7795,
    0xBB0B4703,
    0x220216B9,
    0x5505262F,
    0xC5BA3BBE,
    0xB2BD0B28,
    0x2BB45A92,
    0x5CB36A04,
    0xC2D7FFA7,
    0xB5D0CF31,
    0x2CD99E8B,
    0x5BDEAE1D,
    0x9B64C2B0,
    0xEC63F226,
    0x756AA39C,
    0x026D930A,
    0x9C0906A9,
    0xEB0E363F,
    0x72076785,
    0x05005713,
    0x95BF4A82,
    0xE2B87A14,
    0x7BB12BAE,
    0x0CB61B38,
    0x92D28E9B,
    0xE5D5BE0D,
    0x7CDCEFB7,
    0x0BDBDF21,
    0x86D3D2D4,
    0xF1D4E242,
    0x68DDB3F8,
    0x1FDA836E,
    0x81BE16CD,
    0xF6B9265B,
    0x6FB077E1,
    0x18B74777,
    0x88085AE6,
    0xFF0F6A70,
    0x66063BCA,
    0x11010B5C,
    0x8F659EFF,
    0xF862AE69,
    0x616BFFD3,
    0x166CCF45,
    0xA00AE278,
    0xD70DD2EE,
    0x4E048354,
    0x3903B3C2,
    0xA7672661,
    0xD06016F7,
    0x4969474D,
    0x3E6E77DB,
    0xAED16A4A,
    0xD9D65ADC,
    0x40DF0B66,
    0x37D83BF0,
    0xA9BCAE53,
    0xDEBB9EC5,
    0x47B2CF7F,
    0x30B5FFE9,
    0xBDBDF21C,
    0xCABAC28A,
    0x53B39330,
    0x24B4A3A6,
    0xBAD03605,
    0xCDD70693,
    0x54DE5729,
    0x23D967BF,
    0xB3667A2E,
    0xC4614AB8,
    0x5D681B02,
    0x2A6F2B94,
    0xB40BBE37,
    0xC30C8EA1,
    0x5A05DF1B,
    0x2D02EF8D
];
var $1ed49e36ed4d23b9$var$lookupTable = (0, $iUHWq.uint32ArrayFrom)($1ed49e36ed4d23b9$var$a_lookUpTable);

var $lCCQh = parcelRequire("lCCQh");
Object.defineProperty(module.exports, "AwsCrc32", {
    enumerable: true,
    get: function() {
        return $lCCQh.AwsCrc32;
    }
});

});
parcelRegister("lCCQh", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AwsCrc32 = void 0;

var $fH1jI = parcelRequire("fH1jI");

var $iUHWq = parcelRequire("iUHWq");

var $2E6PK = parcelRequire("2E6PK");
var $fbdb46d8635bc875$var$AwsCrc32 = /** @class */ function() {
    function AwsCrc32() {
        this.crc32 = new $2E6PK.Crc32();
    }
    AwsCrc32.prototype.update = function(toHash) {
        if ((0, $iUHWq.isEmptyData)(toHash)) return;
        this.crc32.update((0, $iUHWq.convertToBuffer)(toHash));
    };
    AwsCrc32.prototype.digest = function() {
        return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
            return (0, $fH1jI.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, $iUHWq.numToUint8)(this.crc32.digest())
                ];
            });
        });
    };
    return AwsCrc32;
}();
module.exports.AwsCrc32 = $fbdb46d8635bc875$var$AwsCrc32;

});


parcelRegister("fAucy", function(module, exports) {

$parcel$export(module.exports, "HeaderMarshaller", function () { return $b591a533090802e7$export$74fd41a85c5dcec9; });

var $fH1jI = parcelRequire("fH1jI");

var $6bdTj = parcelRequire("6bdTj");

var $h7QvZ = parcelRequire("h7QvZ");
/**
 * @internal
 */ var $b591a533090802e7$export$74fd41a85c5dcec9 = /** @class */ function() {
    function HeaderMarshaller(toUtf8, fromUtf8) {
        this.toUtf8 = toUtf8;
        this.fromUtf8 = fromUtf8;
    }
    HeaderMarshaller.prototype.format = function(headers) {
        var e_1, _a, e_2, _b;
        var chunks = [];
        try {
            for(var _c = (0, $fH1jI.__values)(Object.keys(headers)), _d = _c.next(); !_d.done; _d = _c.next()){
                var headerName = _d.value;
                var bytes = this.fromUtf8(headerName);
                chunks.push(Uint8Array.from([
                    bytes.byteLength
                ]), bytes, this.formatHeaderValue(headers[headerName]));
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var out = new Uint8Array(chunks.reduce(function(carry, bytes) {
            return carry + bytes.byteLength;
        }, 0));
        var position = 0;
        try {
            for(var chunks_1 = (0, $fH1jI.__values)(chunks), chunks_1_1 = chunks_1.next(); !chunks_1_1.done; chunks_1_1 = chunks_1.next()){
                var chunk = chunks_1_1.value;
                out.set(chunk, position);
                position += chunk.byteLength;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (chunks_1_1 && !chunks_1_1.done && (_b = chunks_1.return)) _b.call(chunks_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return out;
    };
    HeaderMarshaller.prototype.formatHeaderValue = function(header) {
        switch(header.type){
            case "boolean":
                return Uint8Array.from([
                    header.value ? 0 /* boolTrue */  : 1 /* boolFalse */ 
                ]);
            case "byte":
                return Uint8Array.from([
                    2 /* byte */ ,
                    header.value
                ]);
            case "short":
                var shortView = new DataView(new ArrayBuffer(3));
                shortView.setUint8(0, 3 /* short */ );
                shortView.setInt16(1, header.value, false);
                return new Uint8Array(shortView.buffer);
            case "integer":
                var intView = new DataView(new ArrayBuffer(5));
                intView.setUint8(0, 4 /* integer */ );
                intView.setInt32(1, header.value, false);
                return new Uint8Array(intView.buffer);
            case "long":
                var longBytes = new Uint8Array(9);
                longBytes[0] = 5 /* long */ ;
                longBytes.set(header.value.bytes, 1);
                return longBytes;
            case "binary":
                var binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
                binView.setUint8(0, 6 /* byteArray */ );
                binView.setUint16(1, header.value.byteLength, false);
                var binBytes = new Uint8Array(binView.buffer);
                binBytes.set(header.value, 3);
                return binBytes;
            case "string":
                var utf8Bytes = this.fromUtf8(header.value);
                var strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
                strView.setUint8(0, 7 /* string */ );
                strView.setUint16(1, utf8Bytes.byteLength, false);
                var strBytes = new Uint8Array(strView.buffer);
                strBytes.set(utf8Bytes, 3);
                return strBytes;
            case "timestamp":
                var tsBytes = new Uint8Array(9);
                tsBytes[0] = 8 /* timestamp */ ;
                tsBytes.set((0, $h7QvZ.Int64).fromNumber(header.value.valueOf()).bytes, 1);
                return tsBytes;
            case "uuid":
                if (!$b591a533090802e7$var$UUID_PATTERN.test(header.value)) throw new Error("Invalid UUID received: " + header.value);
                var uuidBytes = new Uint8Array(17);
                uuidBytes[0] = 9 /* uuid */ ;
                uuidBytes.set((0, $6bdTj.fromHex)(header.value.replace(/\-/g, "")), 1);
                return uuidBytes;
        }
    };
    HeaderMarshaller.prototype.parse = function(headers) {
        var out = {};
        var position = 0;
        while(position < headers.byteLength){
            var nameLength = headers.getUint8(position++);
            var name = this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, nameLength));
            position += nameLength;
            switch(headers.getUint8(position++)){
                case 0 /* boolTrue */ :
                    out[name] = {
                        type: $b591a533090802e7$var$BOOLEAN_TAG,
                        value: true
                    };
                    break;
                case 1 /* boolFalse */ :
                    out[name] = {
                        type: $b591a533090802e7$var$BOOLEAN_TAG,
                        value: false
                    };
                    break;
                case 2 /* byte */ :
                    out[name] = {
                        type: $b591a533090802e7$var$BYTE_TAG,
                        value: headers.getInt8(position++)
                    };
                    break;
                case 3 /* short */ :
                    out[name] = {
                        type: $b591a533090802e7$var$SHORT_TAG,
                        value: headers.getInt16(position, false)
                    };
                    position += 2;
                    break;
                case 4 /* integer */ :
                    out[name] = {
                        type: $b591a533090802e7$var$INT_TAG,
                        value: headers.getInt32(position, false)
                    };
                    position += 4;
                    break;
                case 5 /* long */ :
                    out[name] = {
                        type: $b591a533090802e7$var$LONG_TAG,
                        value: new (0, $h7QvZ.Int64)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8))
                    };
                    position += 8;
                    break;
                case 6 /* byteArray */ :
                    var binaryLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $b591a533090802e7$var$BINARY_TAG,
                        value: new Uint8Array(headers.buffer, headers.byteOffset + position, binaryLength)
                    };
                    position += binaryLength;
                    break;
                case 7 /* string */ :
                    var stringLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $b591a533090802e7$var$STRING_TAG,
                        value: this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, stringLength))
                    };
                    position += stringLength;
                    break;
                case 8 /* timestamp */ :
                    out[name] = {
                        type: $b591a533090802e7$var$TIMESTAMP_TAG,
                        value: new Date(new (0, $h7QvZ.Int64)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8)).valueOf())
                    };
                    position += 8;
                    break;
                case 9 /* uuid */ :
                    var uuidBytes = new Uint8Array(headers.buffer, headers.byteOffset + position, 16);
                    position += 16;
                    out[name] = {
                        type: $b591a533090802e7$var$UUID_TAG,
                        value: (0, $6bdTj.toHex)(uuidBytes.subarray(0, 4)) + "-" + (0, $6bdTj.toHex)(uuidBytes.subarray(4, 6)) + "-" + (0, $6bdTj.toHex)(uuidBytes.subarray(6, 8)) + "-" + (0, $6bdTj.toHex)(uuidBytes.subarray(8, 10)) + "-" + (0, $6bdTj.toHex)(uuidBytes.subarray(10))
                    };
                    break;
                default:
                    throw new Error("Unrecognized header type tag");
            }
        }
        return out;
    };
    return HeaderMarshaller;
}();
var $b591a533090802e7$var$HEADER_VALUE_TYPE;
(function(HEADER_VALUE_TYPE) {
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolTrue"] = 0] = "boolTrue";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolFalse"] = 1] = "boolFalse";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byte"] = 2] = "byte";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["short"] = 3] = "short";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["integer"] = 4] = "integer";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["long"] = 5] = "long";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byteArray"] = 6] = "byteArray";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["string"] = 7] = "string";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["timestamp"] = 8] = "timestamp";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["uuid"] = 9] = "uuid";
})($b591a533090802e7$var$HEADER_VALUE_TYPE || ($b591a533090802e7$var$HEADER_VALUE_TYPE = {}));
var $b591a533090802e7$var$BOOLEAN_TAG = "boolean";
var $b591a533090802e7$var$BYTE_TAG = "byte";
var $b591a533090802e7$var$SHORT_TAG = "short";
var $b591a533090802e7$var$INT_TAG = "integer";
var $b591a533090802e7$var$LONG_TAG = "long";
var $b591a533090802e7$var$BINARY_TAG = "binary";
var $b591a533090802e7$var$STRING_TAG = "string";
var $b591a533090802e7$var$TIMESTAMP_TAG = "timestamp";
var $b591a533090802e7$var$UUID_TAG = "uuid";
var $b591a533090802e7$var$UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;

});
parcelRegister("h7QvZ", function(module, exports) {

$parcel$export(module.exports, "Int64", function () { return $c77bd37b8fd7e217$export$8a5e19712a0a5deb; });

var $6bdTj = parcelRequire("6bdTj");
/**
 * A lossless representation of a signed, 64-bit integer. Instances of this
 * class may be used in arithmetic expressions as if they were numeric
 * primitives, but the binary representation will be preserved unchanged as the
 * `bytes` property of the object. The bytes should be encoded as big-endian,
 * two's complement integers.
 */ var $c77bd37b8fd7e217$export$8a5e19712a0a5deb = /** @class */ function() {
    function Int64(bytes) {
        this.bytes = bytes;
        if (bytes.byteLength !== 8) throw new Error("Int64 buffers must be exactly 8 bytes");
    }
    Int64.fromNumber = function(number) {
        if (number > 9223372036854775807 || number < -9223372036854776000) throw new Error(number + " is too large (or, if negative, too small) to represent as an Int64");
        var bytes = new Uint8Array(8);
        for(var i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
        if (number < 0) $c77bd37b8fd7e217$var$negate(bytes);
        return new Int64(bytes);
    };
    /**
     * Called implicitly by infix arithmetic operators.
     */ Int64.prototype.valueOf = function() {
        var bytes = this.bytes.slice(0);
        var negative = bytes[0] & 128;
        if (negative) $c77bd37b8fd7e217$var$negate(bytes);
        return parseInt((0, $6bdTj.toHex)(bytes), 16) * (negative ? -1 : 1);
    };
    Int64.prototype.toString = function() {
        return String(this.valueOf());
    };
    return Int64;
}();
function $c77bd37b8fd7e217$var$negate(bytes) {
    for(var i = 0; i < 8; i++)bytes[i] ^= 0xff;
    for(var i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}

});


parcelRegister("j6Z81", function(module, exports) {

$parcel$export(module.exports, "splitMessage", function () { return $de9dfeb424d3d0c4$export$546b6bc432bd9a53; });

var $2E6PK = parcelRequire("2E6PK");
// All prelude components are unsigned, 32-bit integers
var $de9dfeb424d3d0c4$var$PRELUDE_MEMBER_LENGTH = 4;
// The prelude consists of two components
var $de9dfeb424d3d0c4$var$PRELUDE_LENGTH = $de9dfeb424d3d0c4$var$PRELUDE_MEMBER_LENGTH * 2;
// Checksums are always CRC32 hashes.
var $de9dfeb424d3d0c4$var$CHECKSUM_LENGTH = 4;
// Messages must include a full prelude, a prelude checksum, and a message checksum
var $de9dfeb424d3d0c4$var$MINIMUM_MESSAGE_LENGTH = $de9dfeb424d3d0c4$var$PRELUDE_LENGTH + $de9dfeb424d3d0c4$var$CHECKSUM_LENGTH * 2;
function $de9dfeb424d3d0c4$export$546b6bc432bd9a53(_a) {
    var byteLength = _a.byteLength, byteOffset = _a.byteOffset, buffer = _a.buffer;
    if (byteLength < $de9dfeb424d3d0c4$var$MINIMUM_MESSAGE_LENGTH) throw new Error("Provided message too short to accommodate event stream message overhead");
    var view = new DataView(buffer, byteOffset, byteLength);
    var messageLength = view.getUint32(0, false);
    if (byteLength !== messageLength) throw new Error("Reported message length does not match received message length");
    var headerLength = view.getUint32($de9dfeb424d3d0c4$var$PRELUDE_MEMBER_LENGTH, false);
    var expectedPreludeChecksum = view.getUint32($de9dfeb424d3d0c4$var$PRELUDE_LENGTH, false);
    var expectedMessageChecksum = view.getUint32(byteLength - $de9dfeb424d3d0c4$var$CHECKSUM_LENGTH, false);
    var checksummer = new (0, $2E6PK.Crc32)().update(new Uint8Array(buffer, byteOffset, $de9dfeb424d3d0c4$var$PRELUDE_LENGTH));
    if (expectedPreludeChecksum !== checksummer.digest()) throw new Error("The prelude checksum specified in the message (" + expectedPreludeChecksum + ") does not match the calculated CRC32 checksum (" + checksummer.digest() + ")");
    checksummer.update(new Uint8Array(buffer, byteOffset + $de9dfeb424d3d0c4$var$PRELUDE_LENGTH, byteLength - ($de9dfeb424d3d0c4$var$PRELUDE_LENGTH + $de9dfeb424d3d0c4$var$CHECKSUM_LENGTH)));
    if (expectedMessageChecksum !== checksummer.digest()) throw new Error("The message checksum (" + checksummer.digest() + ") did not match the expected value of " + expectedMessageChecksum);
    return {
        headers: new DataView(buffer, byteOffset + $de9dfeb424d3d0c4$var$PRELUDE_LENGTH + $de9dfeb424d3d0c4$var$CHECKSUM_LENGTH, headerLength),
        body: new Uint8Array(buffer, byteOffset + $de9dfeb424d3d0c4$var$PRELUDE_LENGTH + $de9dfeb424d3d0c4$var$CHECKSUM_LENGTH + headerLength, messageLength - headerLength - ($de9dfeb424d3d0c4$var$PRELUDE_LENGTH + $de9dfeb424d3d0c4$var$CHECKSUM_LENGTH + $de9dfeb424d3d0c4$var$CHECKSUM_LENGTH))
    };
}

});


parcelRegister("elzOk", function(module, exports) {

});


parcelRegister("kliSL", function(module, exports) {
$parcel$export(module.exports, "EventStreamMarshaller", function () { return (parcelRequire("f5MGE")).EventStreamMarshaller; });
parcelRequire("f58cx");
parcelRequire("f5MGE");

});
parcelRegister("f58cx", function(module, exports) {

var $f5MGE = parcelRequire("f5MGE");
var $afadaf3ad1ce391a$export$9d23a885702ebafb = function(options) {
    return new (0, $f5MGE.EventStreamMarshaller)(options);
};

});
parcelRegister("f5MGE", function(module, exports) {

$parcel$export(module.exports, "EventStreamMarshaller", function () { return $afcd16dbb739a310$export$b64afa0aa6ce60e2; });

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("5AQc6");
var $dLxrs = parcelRequire("dLxrs");

var $csidV = parcelRequire("csidV");

var $gQDhK = parcelRequire("gQDhK");
var $afcd16dbb739a310$export$b64afa0aa6ce60e2 = /** @class */ function() {
    function EventStreamMarshaller(_a) {
        var utf8Encoder = _a.utf8Encoder, utf8Decoder = _a.utf8Decoder;
        this.eventMarshaller = new (0, $dLxrs.EventStreamMarshaller)(utf8Encoder, utf8Decoder);
        this.utfEncoder = utf8Encoder;
    }
    EventStreamMarshaller.prototype.deserialize = function(body, deserializer) {
        var chunkedStream = (0, $csidV.getChunkedStream)(body);
        var unmarshalledStream = (0, $gQDhK.getUnmarshalledStream)(chunkedStream, {
            eventMarshaller: this.eventMarshaller,
            deserializer: deserializer,
            toUtf8: this.utfEncoder
        });
        return unmarshalledStream;
    };
    EventStreamMarshaller.prototype.serialize = function(input, serializer) {
        var _a;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var self = this;
        var serializedIterator = function() {
            return (0, $fH1jI.__asyncGenerator)(this, arguments, function() {
                var input_1, input_1_1, chunk, payloadBuf, e_1_1;
                var e_1, _a;
                return (0, $fH1jI.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            _b.trys.push([
                                0,
                                7,
                                8,
                                13
                            ]);
                            input_1 = (0, $fH1jI.__asyncValues)(input);
                            _b.label = 1;
                        case 1:
                            return [
                                4 /*yield*/ ,
                                (0, $fH1jI.__await)(input_1.next())
                            ];
                        case 2:
                            if (!(input_1_1 = _b.sent(), !input_1_1.done)) return [
                                3 /*break*/ ,
                                6
                            ];
                            chunk = input_1_1.value;
                            payloadBuf = self.eventMarshaller.marshall(serializer(chunk));
                            return [
                                4 /*yield*/ ,
                                (0, $fH1jI.__await)(payloadBuf)
                            ];
                        case 3:
                            return [
                                4 /*yield*/ ,
                                _b.sent()
                            ];
                        case 4:
                            _b.sent();
                            _b.label = 5;
                        case 5:
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 6:
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 7:
                            e_1_1 = _b.sent();
                            e_1 = {
                                error: e_1_1
                            };
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 8:
                            _b.trys.push([
                                8,
                                ,
                                11,
                                12
                            ]);
                            if (!(input_1_1 && !input_1_1.done && (_a = input_1.return))) return [
                                3 /*break*/ ,
                                10
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, $fH1jI.__await)(_a.call(input_1))
                            ];
                        case 9:
                            _b.sent();
                            _b.label = 10;
                        case 10:
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            if (e_1) throw e_1.error;
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 12:
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 13:
                            return [
                                4 /*yield*/ ,
                                (0, $fH1jI.__await)(new Uint8Array(0))
                            ];
                        case 14:
                            // Ending frame
                            return [
                                4 /*yield*/ ,
                                _b.sent()
                            ];
                        case 15:
                            // Ending frame
                            _b.sent();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        return _a = {}, _a[Symbol.asyncIterator] = serializedIterator, _a;
    };
    return EventStreamMarshaller;
}();

});
parcelRegister("csidV", function(module, exports) {

$parcel$export(module.exports, "getChunkedStream", function () { return $91163c65c2efec6e$export$3071cd8be9cd01e0; });

var $fH1jI = parcelRequire("fH1jI");
function $91163c65c2efec6e$export$3071cd8be9cd01e0(source) {
    var _a;
    var currentMessageTotalLength = 0;
    var currentMessagePendingLength = 0;
    var currentMessage = null;
    var messageLengthBuffer = null;
    var allocateMessage = function(size) {
        if (typeof size !== "number") throw new Error("Attempted to allocate an event message where size was not a number: " + size);
        currentMessageTotalLength = size;
        currentMessagePendingLength = 4;
        currentMessage = new Uint8Array(size);
        var currentMessageView = new DataView(currentMessage.buffer);
        currentMessageView.setUint32(0, size, false); //set big-endian Uint32 to 0~3 bytes
    };
    var iterator = function() {
        return (0, $fH1jI.__asyncGenerator)(this, arguments, function() {
            var sourceIterator, _a, value, done, chunkLength, currentOffset, bytesRemaining, numBytesForTotal, numBytesToWrite;
            return (0, $fH1jI.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        sourceIterator = source[Symbol.asyncIterator]();
                        _b.label = 1;
                    case 1:
                        return [
                            4 /*yield*/ ,
                            (0, $fH1jI.__await)(sourceIterator.next())
                        ];
                    case 2:
                        _a = _b.sent(), value = _a.value, done = _a.done;
                        if (!done) return [
                            3 /*break*/ ,
                            10
                        ];
                        if (!!currentMessageTotalLength) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $fH1jI.__await)(void 0)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 4:
                        if (!(currentMessageTotalLength === currentMessagePendingLength)) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $fH1jI.__await)(currentMessage)
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 6:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        throw new Error("Truncated event message received.");
                    case 8:
                        return [
                            4 /*yield*/ ,
                            (0, $fH1jI.__await)(void 0)
                        ];
                    case 9:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 10:
                        chunkLength = value.length;
                        currentOffset = 0;
                        _b.label = 11;
                    case 11:
                        if (!(currentOffset < chunkLength)) return [
                            3 /*break*/ ,
                            15
                        ];
                        // create new message if necessary
                        if (!currentMessage) {
                            bytesRemaining = chunkLength - currentOffset;
                            // prevent edge case where total length spans 2 chunks
                            if (!messageLengthBuffer) messageLengthBuffer = new Uint8Array(4);
                            numBytesForTotal = Math.min(4 - currentMessagePendingLength, bytesRemaining // bytes left in chunk
                            );
                            messageLengthBuffer.set(// @ts-ignore error TS2532: Object is possibly 'undefined' for value
                            value.slice(currentOffset, currentOffset + numBytesForTotal), currentMessagePendingLength);
                            currentMessagePendingLength += numBytesForTotal;
                            currentOffset += numBytesForTotal;
                            if (currentMessagePendingLength < 4) // not enough information to create the current message
                            return [
                                3 /*break*/ ,
                                15
                            ];
                            allocateMessage(new DataView(messageLengthBuffer.buffer).getUint32(0, false));
                            messageLengthBuffer = null;
                        }
                        numBytesToWrite = Math.min(currentMessageTotalLength - currentMessagePendingLength, chunkLength - currentOffset // number of bytes left in the original chunk
                        );
                        currentMessage.set(// @ts-ignore error TS2532: Object is possibly 'undefined' for value
                        value.slice(currentOffset, currentOffset + numBytesToWrite), currentMessagePendingLength);
                        currentMessagePendingLength += numBytesToWrite;
                        currentOffset += numBytesToWrite;
                        if (!(currentMessageTotalLength && currentMessageTotalLength === currentMessagePendingLength)) return [
                            3 /*break*/ ,
                            14
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $fH1jI.__await)(currentMessage)
                        ];
                    case 12:
                        // push out the message
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 13:
                        // push out the message
                        _b.sent();
                        // cleanup
                        currentMessage = null;
                        currentMessageTotalLength = 0;
                        currentMessagePendingLength = 0;
                        _b.label = 14;
                    case 14:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 15:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 16:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return _a = {}, _a[Symbol.asyncIterator] = iterator, _a;
}

});

parcelRegister("gQDhK", function(module, exports) {

$parcel$export(module.exports, "getUnmarshalledStream", function () { return $c43ff9e54d8e62ce$export$a1a364c5c6ddc1b4; });

var $fH1jI = parcelRequire("fH1jI");
function $c43ff9e54d8e62ce$export$a1a364c5c6ddc1b4(source, options) {
    var _a;
    return _a = {}, _a[Symbol.asyncIterator] = function() {
        return (0, $fH1jI.__asyncGenerator)(this, arguments, function() {
            var source_1, source_1_1, chunk, message, messageType, unmodeledError, code, exception, deserializedException, error, event, deserialized, e_1_1;
            var _a, _b;
            var e_1, _c;
            return (0, $fH1jI.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _d.trys.push([
                            0,
                            12,
                            13,
                            18
                        ]);
                        source_1 = (0, $fH1jI.__asyncValues)(source);
                        _d.label = 1;
                    case 1:
                        return [
                            4 /*yield*/ ,
                            (0, $fH1jI.__await)(source_1.next())
                        ];
                    case 2:
                        if (!(source_1_1 = _d.sent(), !source_1_1.done)) return [
                            3 /*break*/ ,
                            11
                        ];
                        chunk = source_1_1.value;
                        message = options.eventMarshaller.unmarshall(chunk);
                        messageType = message.headers[":message-type"].value;
                        if (!(messageType === "error")) return [
                            3 /*break*/ ,
                            3
                        ];
                        unmodeledError = new Error(message.headers[":error-message"].value || "UnknownError");
                        unmodeledError.name = message.headers[":error-code"].value;
                        throw unmodeledError;
                    case 3:
                        if (!(messageType === "exception")) return [
                            3 /*break*/ ,
                            5
                        ];
                        code = message.headers[":exception-type"].value;
                        exception = (_a = {}, _a[code] = message, _a);
                        return [
                            4 /*yield*/ ,
                            (0, $fH1jI.__await)(options.deserializer(exception))
                        ];
                    case 4:
                        deserializedException = _d.sent();
                        if (deserializedException.$unknown) {
                            error = new Error(options.toUtf8(message.body));
                            error.name = code;
                            throw error;
                        }
                        throw deserializedException[code];
                    case 5:
                        if (!(messageType === "event")) return [
                            3 /*break*/ ,
                            9
                        ];
                        event = (_b = {}, _b[message.headers[":event-type"].value] = message, _b);
                        return [
                            4 /*yield*/ ,
                            (0, $fH1jI.__await)(options.deserializer(event))
                        ];
                    case 6:
                        deserialized = _d.sent();
                        if (deserialized.$unknown) return [
                            3 /*break*/ ,
                            10
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $fH1jI.__await)(deserialized)
                        ];
                    case 7:
                        return [
                            4 /*yield*/ ,
                            _d.sent()
                        ];
                    case 8:
                        _d.sent();
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        throw Error("Unrecognizable event type: " + message.headers[":event-type"].value);
                    case 10:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 11:
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 12:
                        e_1_1 = _d.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 13:
                        _d.trys.push([
                            13,
                            ,
                            16,
                            17
                        ]);
                        if (!(source_1_1 && !source_1_1.done && (_c = source_1.return))) return [
                            3 /*break*/ ,
                            15
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $fH1jI.__await)(_c.call(source_1))
                        ];
                    case 14:
                        _d.sent();
                        _d.label = 15;
                    case 15:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 16:
                        if (e_1) throw e_1.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 17:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 18:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, _a;
}

});




parcelRegister("h7qa7", function(module, exports) {

$parcel$export(module.exports, "readableStreamtoIterable", function () { return $c7676268a1086818$export$2346526b0991dd88; });
$parcel$export(module.exports, "iterableToReadableStream", function () { return $c7676268a1086818$export$92326f9d37f111f; });

var $fH1jI = parcelRequire("fH1jI");
var $c7676268a1086818$export$2346526b0991dd88 = function(readableStream) {
    var _a;
    return _a = {}, _a[Symbol.asyncIterator] = function() {
        return (0, $fH1jI.__asyncGenerator)(this, arguments, function() {
            var reader, _a, done, value;
            return (0, $fH1jI.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        reader = readableStream.getReader();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            9,
                            10
                        ]);
                        _b.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            (0, $fH1jI.__await)(reader.read())
                        ];
                    case 3:
                        _a = _b.sent(), done = _a.done, value = _a.value;
                        if (!done) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $fH1jI.__await)(void 0)
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            (0, $fH1jI.__await)(value)
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 7:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        reader.releaseLock();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 10:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, _a;
};
var $c7676268a1086818$export$92326f9d37f111f = function(asyncIterable) {
    var iterator = asyncIterable[Symbol.asyncIterator]();
    return new ReadableStream({
        pull: function(controller) {
            return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
                var _a, done, value;
                return (0, $fH1jI.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                iterator.next()
                            ];
                        case 1:
                            _a = _b.sent(), done = _a.done, value = _a.value;
                            if (done) return [
                                2 /*return*/ ,
                                controller.close()
                            ];
                            controller.enqueue(value);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }
    });
};

});




parcelRegister("iKjeu", function(module, exports) {

$parcel$export(module.exports, "blobHasher", function () { return $da5b711add242b00$export$ea66e9c498b7933c; });

var $fH1jI = parcelRequire("fH1jI");

var $jSzw6 = parcelRequire("jSzw6");
var $da5b711add242b00$export$ea66e9c498b7933c = function blobHasher(hashCtor, blob) {
    return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
        var hash;
        return (0, $fH1jI.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    hash = new hashCtor();
                    return [
                        4 /*yield*/ ,
                        (0, $jSzw6.blobReader)(blob, function(chunk) {
                            hash.update(chunk);
                        })
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        hash.digest()
                    ];
            }
        });
    });
};

});
parcelRegister("jSzw6", function(module, exports) {

$parcel$export(module.exports, "blobReader", function () { return $03bc1b4bcd75f1a3$export$7541dba16c2127c8; });
function $03bc1b4bcd75f1a3$export$7541dba16c2127c8(blob, onChunk, chunkSize) {
    if (chunkSize === void 0) chunkSize = 1048576;
    return new Promise(function(resolve, reject) {
        var fileReader = new FileReader();
        fileReader.addEventListener("error", reject);
        fileReader.addEventListener("abort", reject);
        var size = blob.size;
        var totalBytesRead = 0;
        function read() {
            if (totalBytesRead >= size) {
                resolve();
                return;
            }
            fileReader.readAsArrayBuffer(blob.slice(totalBytesRead, Math.min(size, totalBytesRead + chunkSize)));
        }
        fileReader.addEventListener("load", function(event) {
            var result = event.target.result;
            onChunk(new Uint8Array(result));
            totalBytesRead += result.byteLength;
            // read the next block
            read();
        });
        // kick off the read
        read();
    });
}

});


parcelRegister("in1KN", function(module, exports) {

$parcel$export(module.exports, "Md5", function () { return $d5fbbc37e3c67ae3$export$9f5a3dfc7a9f5dd; });

var $fH1jI = parcelRequire("fH1jI");

var $12JSh = parcelRequire("12JSh");

var $cp0mr = parcelRequire("cp0mr");
var $d5fbbc37e3c67ae3$export$9f5a3dfc7a9f5dd = /** @class */ function() {
    function Md5() {
        this.state = Uint32Array.from((0, $cp0mr.INIT));
        this.buffer = new DataView(new ArrayBuffer((0, $cp0mr.BLOCK_SIZE)));
        this.bufferLength = 0;
        this.bytesHashed = 0;
        this.finished = false;
    }
    Md5.prototype.update = function(sourceData) {
        if ($d5fbbc37e3c67ae3$var$isEmptyData(sourceData)) return;
        else if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var data = $d5fbbc37e3c67ae3$var$convertToBuffer(sourceData);
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        while(byteLength > 0){
            this.buffer.setUint8(this.bufferLength++, data[position++]);
            byteLength--;
            if (this.bufferLength === (0, $cp0mr.BLOCK_SIZE)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    Md5.prototype.digest = function() {
        return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
            var _a, buffer, undecoratedLength, bytesHashed, bitsHashed, i, i, out, i;
            return (0, $fH1jI.__generator)(this, function(_b) {
                if (!this.finished) {
                    _a = this, buffer = _a.buffer, undecoratedLength = _a.bufferLength, bytesHashed = _a.bytesHashed;
                    bitsHashed = bytesHashed * 8;
                    buffer.setUint8(this.bufferLength++, 128);
                    // Ensure the final block has enough room for the hashed length
                    if (undecoratedLength % (0, $cp0mr.BLOCK_SIZE) >= (0, $cp0mr.BLOCK_SIZE) - 8) {
                        for(i = this.bufferLength; i < (0, $cp0mr.BLOCK_SIZE); i++)buffer.setUint8(i, 0);
                        this.hashBuffer();
                        this.bufferLength = 0;
                    }
                    for(i = this.bufferLength; i < (0, $cp0mr.BLOCK_SIZE) - 8; i++)buffer.setUint8(i, 0);
                    buffer.setUint32((0, $cp0mr.BLOCK_SIZE) - 8, bitsHashed >>> 0, true);
                    buffer.setUint32((0, $cp0mr.BLOCK_SIZE) - 4, Math.floor(bitsHashed / 0x100000000), true);
                    this.hashBuffer();
                    this.finished = true;
                }
                out = new DataView(new ArrayBuffer((0, $cp0mr.DIGEST_LENGTH)));
                for(i = 0; i < 4; i++)out.setUint32(i * 4, this.state[i], true);
                return [
                    2 /*return*/ ,
                    new Uint8Array(out.buffer, out.byteOffset, out.byteLength)
                ];
            });
        });
    };
    Md5.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var a = state[0], b = state[1], c = state[2], d = state[3];
        a = $d5fbbc37e3c67ae3$var$ff(a, b, c, d, buffer.getUint32(0, true), 7, 0xd76aa478);
        d = $d5fbbc37e3c67ae3$var$ff(d, a, b, c, buffer.getUint32(4, true), 12, 0xe8c7b756);
        c = $d5fbbc37e3c67ae3$var$ff(c, d, a, b, buffer.getUint32(8, true), 17, 0x242070db);
        b = $d5fbbc37e3c67ae3$var$ff(b, c, d, a, buffer.getUint32(12, true), 22, 0xc1bdceee);
        a = $d5fbbc37e3c67ae3$var$ff(a, b, c, d, buffer.getUint32(16, true), 7, 0xf57c0faf);
        d = $d5fbbc37e3c67ae3$var$ff(d, a, b, c, buffer.getUint32(20, true), 12, 0x4787c62a);
        c = $d5fbbc37e3c67ae3$var$ff(c, d, a, b, buffer.getUint32(24, true), 17, 0xa8304613);
        b = $d5fbbc37e3c67ae3$var$ff(b, c, d, a, buffer.getUint32(28, true), 22, 0xfd469501);
        a = $d5fbbc37e3c67ae3$var$ff(a, b, c, d, buffer.getUint32(32, true), 7, 0x698098d8);
        d = $d5fbbc37e3c67ae3$var$ff(d, a, b, c, buffer.getUint32(36, true), 12, 0x8b44f7af);
        c = $d5fbbc37e3c67ae3$var$ff(c, d, a, b, buffer.getUint32(40, true), 17, 0xffff5bb1);
        b = $d5fbbc37e3c67ae3$var$ff(b, c, d, a, buffer.getUint32(44, true), 22, 0x895cd7be);
        a = $d5fbbc37e3c67ae3$var$ff(a, b, c, d, buffer.getUint32(48, true), 7, 0x6b901122);
        d = $d5fbbc37e3c67ae3$var$ff(d, a, b, c, buffer.getUint32(52, true), 12, 0xfd987193);
        c = $d5fbbc37e3c67ae3$var$ff(c, d, a, b, buffer.getUint32(56, true), 17, 0xa679438e);
        b = $d5fbbc37e3c67ae3$var$ff(b, c, d, a, buffer.getUint32(60, true), 22, 0x49b40821);
        a = $d5fbbc37e3c67ae3$var$gg(a, b, c, d, buffer.getUint32(4, true), 5, 0xf61e2562);
        d = $d5fbbc37e3c67ae3$var$gg(d, a, b, c, buffer.getUint32(24, true), 9, 0xc040b340);
        c = $d5fbbc37e3c67ae3$var$gg(c, d, a, b, buffer.getUint32(44, true), 14, 0x265e5a51);
        b = $d5fbbc37e3c67ae3$var$gg(b, c, d, a, buffer.getUint32(0, true), 20, 0xe9b6c7aa);
        a = $d5fbbc37e3c67ae3$var$gg(a, b, c, d, buffer.getUint32(20, true), 5, 0xd62f105d);
        d = $d5fbbc37e3c67ae3$var$gg(d, a, b, c, buffer.getUint32(40, true), 9, 0x02441453);
        c = $d5fbbc37e3c67ae3$var$gg(c, d, a, b, buffer.getUint32(60, true), 14, 0xd8a1e681);
        b = $d5fbbc37e3c67ae3$var$gg(b, c, d, a, buffer.getUint32(16, true), 20, 0xe7d3fbc8);
        a = $d5fbbc37e3c67ae3$var$gg(a, b, c, d, buffer.getUint32(36, true), 5, 0x21e1cde6);
        d = $d5fbbc37e3c67ae3$var$gg(d, a, b, c, buffer.getUint32(56, true), 9, 0xc33707d6);
        c = $d5fbbc37e3c67ae3$var$gg(c, d, a, b, buffer.getUint32(12, true), 14, 0xf4d50d87);
        b = $d5fbbc37e3c67ae3$var$gg(b, c, d, a, buffer.getUint32(32, true), 20, 0x455a14ed);
        a = $d5fbbc37e3c67ae3$var$gg(a, b, c, d, buffer.getUint32(52, true), 5, 0xa9e3e905);
        d = $d5fbbc37e3c67ae3$var$gg(d, a, b, c, buffer.getUint32(8, true), 9, 0xfcefa3f8);
        c = $d5fbbc37e3c67ae3$var$gg(c, d, a, b, buffer.getUint32(28, true), 14, 0x676f02d9);
        b = $d5fbbc37e3c67ae3$var$gg(b, c, d, a, buffer.getUint32(48, true), 20, 0x8d2a4c8a);
        a = $d5fbbc37e3c67ae3$var$hh(a, b, c, d, buffer.getUint32(20, true), 4, 0xfffa3942);
        d = $d5fbbc37e3c67ae3$var$hh(d, a, b, c, buffer.getUint32(32, true), 11, 0x8771f681);
        c = $d5fbbc37e3c67ae3$var$hh(c, d, a, b, buffer.getUint32(44, true), 16, 0x6d9d6122);
        b = $d5fbbc37e3c67ae3$var$hh(b, c, d, a, buffer.getUint32(56, true), 23, 0xfde5380c);
        a = $d5fbbc37e3c67ae3$var$hh(a, b, c, d, buffer.getUint32(4, true), 4, 0xa4beea44);
        d = $d5fbbc37e3c67ae3$var$hh(d, a, b, c, buffer.getUint32(16, true), 11, 0x4bdecfa9);
        c = $d5fbbc37e3c67ae3$var$hh(c, d, a, b, buffer.getUint32(28, true), 16, 0xf6bb4b60);
        b = $d5fbbc37e3c67ae3$var$hh(b, c, d, a, buffer.getUint32(40, true), 23, 0xbebfbc70);
        a = $d5fbbc37e3c67ae3$var$hh(a, b, c, d, buffer.getUint32(52, true), 4, 0x289b7ec6);
        d = $d5fbbc37e3c67ae3$var$hh(d, a, b, c, buffer.getUint32(0, true), 11, 0xeaa127fa);
        c = $d5fbbc37e3c67ae3$var$hh(c, d, a, b, buffer.getUint32(12, true), 16, 0xd4ef3085);
        b = $d5fbbc37e3c67ae3$var$hh(b, c, d, a, buffer.getUint32(24, true), 23, 0x04881d05);
        a = $d5fbbc37e3c67ae3$var$hh(a, b, c, d, buffer.getUint32(36, true), 4, 0xd9d4d039);
        d = $d5fbbc37e3c67ae3$var$hh(d, a, b, c, buffer.getUint32(48, true), 11, 0xe6db99e5);
        c = $d5fbbc37e3c67ae3$var$hh(c, d, a, b, buffer.getUint32(60, true), 16, 0x1fa27cf8);
        b = $d5fbbc37e3c67ae3$var$hh(b, c, d, a, buffer.getUint32(8, true), 23, 0xc4ac5665);
        a = $d5fbbc37e3c67ae3$var$ii(a, b, c, d, buffer.getUint32(0, true), 6, 0xf4292244);
        d = $d5fbbc37e3c67ae3$var$ii(d, a, b, c, buffer.getUint32(28, true), 10, 0x432aff97);
        c = $d5fbbc37e3c67ae3$var$ii(c, d, a, b, buffer.getUint32(56, true), 15, 0xab9423a7);
        b = $d5fbbc37e3c67ae3$var$ii(b, c, d, a, buffer.getUint32(20, true), 21, 0xfc93a039);
        a = $d5fbbc37e3c67ae3$var$ii(a, b, c, d, buffer.getUint32(48, true), 6, 0x655b59c3);
        d = $d5fbbc37e3c67ae3$var$ii(d, a, b, c, buffer.getUint32(12, true), 10, 0x8f0ccc92);
        c = $d5fbbc37e3c67ae3$var$ii(c, d, a, b, buffer.getUint32(40, true), 15, 0xffeff47d);
        b = $d5fbbc37e3c67ae3$var$ii(b, c, d, a, buffer.getUint32(4, true), 21, 0x85845dd1);
        a = $d5fbbc37e3c67ae3$var$ii(a, b, c, d, buffer.getUint32(32, true), 6, 0x6fa87e4f);
        d = $d5fbbc37e3c67ae3$var$ii(d, a, b, c, buffer.getUint32(60, true), 10, 0xfe2ce6e0);
        c = $d5fbbc37e3c67ae3$var$ii(c, d, a, b, buffer.getUint32(24, true), 15, 0xa3014314);
        b = $d5fbbc37e3c67ae3$var$ii(b, c, d, a, buffer.getUint32(52, true), 21, 0x4e0811a1);
        a = $d5fbbc37e3c67ae3$var$ii(a, b, c, d, buffer.getUint32(16, true), 6, 0xf7537e82);
        d = $d5fbbc37e3c67ae3$var$ii(d, a, b, c, buffer.getUint32(44, true), 10, 0xbd3af235);
        c = $d5fbbc37e3c67ae3$var$ii(c, d, a, b, buffer.getUint32(8, true), 15, 0x2ad7d2bb);
        b = $d5fbbc37e3c67ae3$var$ii(b, c, d, a, buffer.getUint32(36, true), 21, 0xeb86d391);
        state[0] = a + state[0] & 0xffffffff;
        state[1] = b + state[1] & 0xffffffff;
        state[2] = c + state[2] & 0xffffffff;
        state[3] = d + state[3] & 0xffffffff;
    };
    return Md5;
}();
function $d5fbbc37e3c67ae3$var$cmn(q, a, b, x, s, t) {
    a = (a + q & 0xffffffff) + (x + t & 0xffffffff) & 0xffffffff;
    return (a << s | a >>> 32 - s) + b & 0xffffffff;
}
function $d5fbbc37e3c67ae3$var$ff(a, b, c, d, x, s, t) {
    return $d5fbbc37e3c67ae3$var$cmn(b & c | ~b & d, a, b, x, s, t);
}
function $d5fbbc37e3c67ae3$var$gg(a, b, c, d, x, s, t) {
    return $d5fbbc37e3c67ae3$var$cmn(b & d | c & ~d, a, b, x, s, t);
}
function $d5fbbc37e3c67ae3$var$hh(a, b, c, d, x, s, t) {
    return $d5fbbc37e3c67ae3$var$cmn(b ^ c ^ d, a, b, x, s, t);
}
function $d5fbbc37e3c67ae3$var$ii(a, b, c, d, x, s, t) {
    return $d5fbbc37e3c67ae3$var$cmn(c ^ (b | ~d), a, b, x, s, t);
}
function $d5fbbc37e3c67ae3$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
function $d5fbbc37e3c67ae3$var$convertToBuffer(data) {
    if (typeof data === "string") return (0, $12JSh.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

});
parcelRegister("cp0mr", function(module, exports) {

$parcel$export(module.exports, "BLOCK_SIZE", function () { return $90781980c9f13fba$export$b2e3d6d444266a5c; });
$parcel$export(module.exports, "DIGEST_LENGTH", function () { return $90781980c9f13fba$export$d7bd469488748c5f; });
$parcel$export(module.exports, "INIT", function () { return $90781980c9f13fba$export$d788bc089976c004; });
/**
 * @internal
 */ var $90781980c9f13fba$export$b2e3d6d444266a5c = 64;
var $90781980c9f13fba$export$d7bd469488748c5f = 16;
var $90781980c9f13fba$export$d788bc089976c004 = [
    0x67452301,
    0xefcdab89,
    0x98badcfe,
    0x10325476
];

});


parcelRegister("dAv28", function(module, exports) {

$parcel$export(module.exports, "ClientSharedValues", function () { return $9e46b5c60083868b$export$608864383388f904; });

var $9Vmkk = parcelRequire("9Vmkk");
var $9e46b5c60083868b$export$608864383388f904 = {
    apiVersion: "2006-03-01",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: (0, $9Vmkk.defaultRegionInfoProvider),
    signingEscapePath: false,
    signingName: "s3",
    useArnRegion: false
};

});
parcelRegister("9Vmkk", function(module, exports) {

$parcel$export(module.exports, "defaultRegionInfoProvider", function () { return $739ac18e72a187bf$export$2e4318bf13462aa2; });
// Partition default templates
var $739ac18e72a187bf$var$AWS_TEMPLATE = "s3.{region}.amazonaws.com";
var $739ac18e72a187bf$var$AWS_CN_TEMPLATE = "s3.{region}.amazonaws.com.cn";
var $739ac18e72a187bf$var$AWS_ISO_TEMPLATE = "s3.{region}.c2s.ic.gov";
var $739ac18e72a187bf$var$AWS_ISO_B_TEMPLATE = "s3.{region}.sc2s.sgov.gov";
var $739ac18e72a187bf$var$AWS_US_GOV_TEMPLATE = "s3.{region}.amazonaws.com";
// Partition regions
var $739ac18e72a187bf$var$AWS_REGIONS = new Set([
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2"
]);
var $739ac18e72a187bf$var$AWS_CN_REGIONS = new Set([
    "cn-north-1",
    "cn-northwest-1"
]);
var $739ac18e72a187bf$var$AWS_ISO_REGIONS = new Set([
    "us-iso-east-1"
]);
var $739ac18e72a187bf$var$AWS_ISO_B_REGIONS = new Set([
    "us-isob-east-1"
]);
var $739ac18e72a187bf$var$AWS_US_GOV_REGIONS = new Set([
    "us-gov-east-1",
    "us-gov-west-1"
]);
var $739ac18e72a187bf$export$2e4318bf13462aa2 = function(region, options) {
    var regionInfo = undefined;
    switch(region){
        // First, try to match exact region names.
        case "ap-east-1":
            regionInfo = {
                hostname: "s3.ap-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-1":
            regionInfo = {
                hostname: "s3.ap-northeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-2":
            regionInfo = {
                hostname: "s3.ap-northeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-south-1":
            regionInfo = {
                hostname: "s3.ap-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-1":
            regionInfo = {
                hostname: "s3.ap-southeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-2":
            regionInfo = {
                hostname: "s3.ap-southeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ca-central-1":
            regionInfo = {
                hostname: "s3.ca-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "cn-north-1":
            regionInfo = {
                hostname: "s3.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "cn-northwest-1":
            regionInfo = {
                hostname: "s3.cn-northwest-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "eu-central-1":
            regionInfo = {
                hostname: "s3.eu-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-north-1":
            regionInfo = {
                hostname: "s3.eu-north-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-1":
            regionInfo = {
                hostname: "s3.eu-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-2":
            regionInfo = {
                hostname: "s3.eu-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-3":
            regionInfo = {
                hostname: "s3.eu-west-3.amazonaws.com",
                partition: "aws"
            };
            break;
        case "fips-us-gov-west-1":
            regionInfo = {
                hostname: "s3-fips-us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-west-1"
            };
            break;
        case "me-south-1":
            regionInfo = {
                hostname: "s3.me-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "s3-external-1":
            regionInfo = {
                hostname: "s3-external-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1"
            };
            break;
        case "sa-east-1":
            regionInfo = {
                hostname: "s3.sa-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-1":
            regionInfo = {
                hostname: "s3.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-2":
            regionInfo = {
                hostname: "s3.us-east-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-gov-east-1":
            regionInfo = {
                hostname: "s3.us-gov-east-1.amazonaws.com",
                partition: "aws-us-gov"
            };
            break;
        case "us-gov-west-1":
            regionInfo = {
                hostname: "s3.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov"
            };
            break;
        case "us-iso-east-1":
            regionInfo = {
                hostname: "s3.us-iso-east-1.c2s.ic.gov",
                partition: "aws-iso"
            };
            break;
        case "us-isob-east-1":
            regionInfo = {
                hostname: "s3.us-isob-east-1.sc2s.sgov.gov",
                partition: "aws-iso-b"
            };
            break;
        case "us-west-1":
            regionInfo = {
                hostname: "s3.us-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-west-2":
            regionInfo = {
                hostname: "s3.us-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        // Next, try to match partition endpoints.
        default:
            if ($739ac18e72a187bf$var$AWS_REGIONS.has(region)) regionInfo = {
                hostname: $739ac18e72a187bf$var$AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
            if ($739ac18e72a187bf$var$AWS_CN_REGIONS.has(region)) regionInfo = {
                hostname: $739ac18e72a187bf$var$AWS_CN_TEMPLATE.replace("{region}", region),
                partition: "aws-cn"
            };
            if ($739ac18e72a187bf$var$AWS_ISO_REGIONS.has(region)) regionInfo = {
                hostname: $739ac18e72a187bf$var$AWS_ISO_TEMPLATE.replace("{region}", region),
                partition: "aws-iso"
            };
            if ($739ac18e72a187bf$var$AWS_ISO_B_REGIONS.has(region)) regionInfo = {
                hostname: $739ac18e72a187bf$var$AWS_ISO_B_TEMPLATE.replace("{region}", region),
                partition: "aws-iso-b"
            };
            if ($739ac18e72a187bf$var$AWS_US_GOV_REGIONS.has(region)) regionInfo = {
                hostname: $739ac18e72a187bf$var$AWS_US_GOV_TEMPLATE.replace("{region}", region),
                partition: "aws-us-gov"
            };
            // Finally, assume it's an AWS partition endpoint.
            if (regionInfo === undefined) regionInfo = {
                hostname: $739ac18e72a187bf$var$AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
    }
    return Promise.resolve(regionInfo);
};

});



parcelRegister("g0GMS", function(module, exports) {
$parcel$export(module.exports, "resolveEventStreamSerdeConfig", function () { return (parcelRequire("eiAgf")).resolveEventStreamSerdeConfig; });
parcelRequire("eiAgf");

});
parcelRegister("eiAgf", function(module, exports) {

$parcel$export(module.exports, "resolveEventStreamSerdeConfig", function () { return $a68edfd4dcfc9382$export$5e2ae00bf65442f0; });

var $fH1jI = parcelRequire("fH1jI");
var $a68edfd4dcfc9382$export$5e2ae00bf65442f0 = function(input) {
    return (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, input), {
        eventStreamMarshaller: input.eventStreamSerdeProvider(input)
    });
};

});


parcelRegister("k68qi", function(module, exports) {

$parcel$export(module.exports, "getAddExpectContinuePlugin", function () { return $ea1ae6d7f5fb9c74$export$7692e5e7214e5cd1; });

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("1J0sw");
var $jmMP9 = parcelRequire("jmMP9");
function $ea1ae6d7f5fb9c74$export$ea55ca13ab589d75(options) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, $fH1jI.__awaiter)(_this, void 0, void 0, function() {
                var request;
                return (0, $fH1jI.__generator)(this, function(_a) {
                    request = args.request;
                    if ((0, $jmMP9.HttpRequest).isInstance(request) && request.body && options.runtime === "node") request.headers = (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, request.headers), {
                        Expect: "100-continue"
                    });
                    return [
                        2 /*return*/ ,
                        next((0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
}
var $ea1ae6d7f5fb9c74$export$582010bfa3126ad3 = {
    step: "build",
    tags: [
        "SET_EXPECT_HEADER",
        "EXPECT_HEADER"
    ],
    name: "addExpectContinueMiddleware"
};
var $ea1ae6d7f5fb9c74$export$7692e5e7214e5cd1 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($ea1ae6d7f5fb9c74$export$ea55ca13ab589d75(options), $ea1ae6d7f5fb9c74$export$582010bfa3126ad3);
        }
    };
};

});

parcelRegister("2cwKX", function(module, exports) {
$parcel$export(module.exports, "getValidateBucketNamePlugin", function () { return (parcelRequire("d4vIJ")).getValidateBucketNamePlugin; });
$parcel$export(module.exports, "getUseRegionalEndpointPlugin", function () { return (parcelRequire("5jJuE")).getUseRegionalEndpointPlugin; });
parcelRequire("d4vIJ");
parcelRequire("5jJuE");

});
parcelRegister("d4vIJ", function(module, exports) {

$parcel$export(module.exports, "getValidateBucketNamePlugin", function () { return $984441167541ed4f$export$c30d61978fbb3ad8; });

var $fH1jI = parcelRequire("fH1jI");

var $2xhHn = parcelRequire("2xhHn");
function $984441167541ed4f$export$97e70cdcaaace32a() {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, $fH1jI.__awaiter)(_this, void 0, void 0, function() {
                var Bucket, err;
                return (0, $fH1jI.__generator)(this, function(_a) {
                    Bucket = args.input.Bucket;
                    if (typeof Bucket === "string" && !(0, $2xhHn.validate)(Bucket) && Bucket.indexOf("/") >= 0) {
                        err = new Error("Bucket name shouldn't contain '/', received '" + Bucket + "'");
                        err.name = "InvalidBucketName";
                        throw err;
                    }
                    return [
                        2 /*return*/ ,
                        next((0, $fH1jI.__assign)({}, args))
                    ];
                });
            });
        };
    };
}
var $984441167541ed4f$export$db8005617bec77bd = {
    step: "initialize",
    tags: [
        "VALIDATE_BUCKET_NAME"
    ],
    name: "validateBucketNameMiddleware"
};
var $984441167541ed4f$export$c30d61978fbb3ad8 = function(unused) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($984441167541ed4f$export$97e70cdcaaace32a(), $984441167541ed4f$export$db8005617bec77bd);
        }
    };
};

});

parcelRegister("5jJuE", function(module, exports) {

$parcel$export(module.exports, "getUseRegionalEndpointPlugin", function () { return $3df204255f0fa79e$export$8512187c26b3935b; });

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("1J0sw");
var $jmMP9 = parcelRequire("jmMP9");
var $3df204255f0fa79e$export$47830883dba0cb3a = function(config) {
    return function(next) {
        return function(args) {
            return (0, $fH1jI.__awaiter)(void 0, void 0, void 0, function() {
                var request, _a;
                return (0, $fH1jI.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            request = args.request;
                            if (!(0, $jmMP9.HttpRequest).isInstance(request) || config.isCustomEndpoint) return [
                                2 /*return*/ ,
                                next((0, $fH1jI.__assign)({}, args))
                            ];
                            if (!(request.hostname === "s3.amazonaws.com")) return [
                                3 /*break*/ ,
                                1
                            ];
                            request.hostname = "s3.us-east-1.amazonaws.com";
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 1:
                            _a = "aws-global";
                            return [
                                4 /*yield*/ ,
                                config.region()
                            ];
                        case 2:
                            if (_a === _b.sent()) request.hostname = "s3.amazonaws.com";
                            _b.label = 3;
                        case 3:
                            return [
                                2 /*return*/ ,
                                next((0, $fH1jI.__assign)({}, args))
                            ];
                    }
                });
            });
        };
    };
};
var $3df204255f0fa79e$export$984fdb6c4de63240 = {
    step: "build",
    tags: [
        "USE_REGIONAL_ENDPOINT",
        "S3"
    ],
    name: "useRegionalEndpointMiddleware"
};
var $3df204255f0fa79e$export$8512187c26b3935b = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($3df204255f0fa79e$export$47830883dba0cb3a(config), $3df204255f0fa79e$export$984fdb6c4de63240);
        }
    };
};

});



parcelRegister("32CUT", function(module, exports) {

$parcel$export(module.exports, "formatUrl", function () { return $236fbf08bf876b04$export$75025487296cba38; });

var $z0zEw = parcelRequire("z0zEw");
function $236fbf08bf876b04$export$75025487296cba38(request) {
    var port = request.port, query = request.query;
    var protocol = request.protocol, path = request.path, hostname = request.hostname;
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    if (port) hostname += ":" + port;
    if (path && path.charAt(0) !== "/") path = "/" + path;
    var queryString = query ? (0, $z0zEw.buildQueryString)(query) : "";
    if (queryString && queryString[0] !== "?") queryString = "?" + queryString;
    return protocol + "//" + hostname + path + queryString;
}

});

parcelRegister("kyYaq", function(module, exports) {

$parcel$export(module.exports, "createRequest", function () { return $ef85a78b32d3ee25$export$72e3afa9ac8966be; });

var $fH1jI = parcelRequire("fH1jI");
function $ef85a78b32d3ee25$export$72e3afa9ac8966be(client, command) {
    return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
        var interceptMiddleware, clientStack, handler;
        var _this = this;
        return (0, $fH1jI.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    interceptMiddleware = function(next) {
                        return function(args) {
                            return (0, $fH1jI.__awaiter)(_this, void 0, void 0, function() {
                                return (0, $fH1jI.__generator)(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            output: {
                                                request: args.request
                                            },
                                            response: undefined
                                        }
                                    ];
                                });
                            });
                        };
                    };
                    clientStack = client.middlewareStack.clone();
                    // @ts-ignore: add middleware to the last of 'build' step
                    clientStack.add(interceptMiddleware, {
                        step: "build",
                        priority: "low"
                    });
                    handler = command.resolveMiddleware(clientStack, client.config, undefined);
                    return [
                        4 /*yield*/ ,
                        handler(command).then(function(output) {
                            return output.output.request;
                        })
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
            }
        });
    });
}

});

parcelRegister("f1iF4", function(module, exports) {
$parcel$export(module.exports, "S3RequestPresigner", function () { return (parcelRequire("bhivG")).S3RequestPresigner; });
parcelRequire("bhivG");
parcelRequire("3UHGI");

});
parcelRegister("bhivG", function(module, exports) {

$parcel$export(module.exports, "S3RequestPresigner", function () { return $835fa3ee134b5948$export$a1673011a6b3560f; });

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("c5yxD");
var $djgro = parcelRequire("djgro");

var $5ZZim = parcelRequire("5ZZim");
var $835fa3ee134b5948$export$a1673011a6b3560f = /** @class */ function() {
    function S3RequestPresigner(options) {
        var resolvedOptions = (0, $fH1jI.__assign)({
            // Allow `signingName` because we want to support usecase of supply client's resolved config
            // directly. Where service equals signingName.
            service: options.signingName || options.service || "s3",
            uriEscapePath: options.uriEscapePath || false
        }, options);
        this.signer = new (0, $djgro.SignatureV4)(resolvedOptions);
    }
    S3RequestPresigner.prototype.presign = function(requestToSign, _a) {
        if (_a === void 0) _a = {};
        var _b = _a.unsignableHeaders, unsignableHeaders = _b === void 0 ? new Set() : _b, options = (0, $fH1jI.__rest)(_a, [
            "unsignableHeaders"
        ]);
        return (0, $fH1jI.__awaiter)(this, void 0, void 0, function() {
            return (0, $fH1jI.__generator)(this, function(_c) {
                unsignableHeaders.add("content-type");
                requestToSign.headers[0, $5ZZim.SHA256_HEADER] = (0, $5ZZim.UNSIGNED_PAYLOAD);
                return [
                    2 /*return*/ ,
                    this.signer.presign(requestToSign, (0, $fH1jI.__assign)({
                        expiresIn: 900,
                        unsignableHeaders: unsignableHeaders
                    }, options))
                ];
            });
        });
    };
    return S3RequestPresigner;
}();

});
parcelRegister("5ZZim", function(module, exports) {

$parcel$export(module.exports, "UNSIGNED_PAYLOAD", function () { return $45e23235ed2e8243$export$91f7321b40d9fd07; });
$parcel$export(module.exports, "SHA256_HEADER", function () { return $45e23235ed2e8243$export$eaef12179141669a; });
var $45e23235ed2e8243$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";
var $45e23235ed2e8243$export$eaef12179141669a = "X-Amz-Content-Sha256";
var $45e23235ed2e8243$export$186cd8495ba0377d = "X-Amz-Algorithm";
var $45e23235ed2e8243$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
var $45e23235ed2e8243$export$6e114beec37430d7 = "X-Amz-Date";
var $45e23235ed2e8243$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
var $45e23235ed2e8243$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
var $45e23235ed2e8243$export$96307741595055fc = "host";
var $45e23235ed2e8243$export$863a63fba5b2ddf5 = "AWS4-HMAC-SHA256";

});


parcelRegister("3UHGI", function(module, exports) {

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("1J0sw");
var $jmMP9 = parcelRequire("jmMP9");

var $32CUT = parcelRequire("32CUT");

var $bhivG = parcelRequire("bhivG");
var $2d987d91e30dc38c$export$d6e65e470b2c127c = function(client, command, options) {
    if (options === void 0) options = {};
    return (0, $fH1jI.__awaiter)(void 0, void 0, void 0, function() {
        var s3Presigner, presignInterceptMiddleware, presigned, output;
        return (0, $fH1jI.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    s3Presigner = new (0, $bhivG.S3RequestPresigner)((0, $fH1jI.__assign)({}, client.config));
                    presignInterceptMiddleware = function(next, context) {
                        return function(args) {
                            return (0, $fH1jI.__awaiter)(void 0, void 0, void 0, function() {
                                var request, presigned;
                                var _a, _b;
                                return (0, $fH1jI.__generator)(this, function(_c) {
                                    switch(_c.label){
                                        case 0:
                                            request = args.request;
                                            if (!(0, $jmMP9.HttpRequest).isInstance(request)) throw new Error("Request to be presigned is not an valid HTTP request.");
                                            // Retry information headers are not meaningful in presigned URLs
                                            delete request.headers["amz-sdk-invocation-id"];
                                            delete request.headers["amz-sdk-request"];
                                            return [
                                                4 /*yield*/ ,
                                                s3Presigner.presign(request, (0, $fH1jI.__assign)((0, $fH1jI.__assign)({}, options), {
                                                    signingRegion: (_a = options.signingRegion) !== null && _a !== void 0 ? _a : context["signing_region"],
                                                    signingService: (_b = options.signingService) !== null && _b !== void 0 ? _b : context["signing_service"]
                                                }))
                                            ];
                                        case 1:
                                            presigned = _c.sent();
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    // Intercept the middleware stack by returning fake response
                                                    response: {},
                                                    output: {
                                                        $metadata: {
                                                            httpStatusCode: 200
                                                        },
                                                        presigned: presigned
                                                    }
                                                }
                                            ];
                                    }
                                });
                            });
                        };
                    };
                    client.middlewareStack.addRelativeTo(presignInterceptMiddleware, {
                        name: "presignInterceptMiddleware",
                        relation: "before",
                        toMiddleware: "awsAuthMiddleware"
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([
                        1,
                        ,
                        3,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        client.send(command)
                    ];
                case 2:
                    output = _a.sent();
                    //@ts-ignore the output is faked, so it's not actually OutputType
                    presigned = output.presigned;
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    client.middlewareStack.remove("presignInterceptMiddleware");
                    return [
                        7 /*endfinally*/ 
                    ];
                case 4:
                    return [
                        2 /*return*/ ,
                        (0, $32CUT.formatUrl)(presigned)
                    ];
            }
        });
    });
};

});


parcelRegister("bLBrm", function(module, exports) {

$parcel$export(module.exports, "SEND_PROGRESS_EVENT", function () { return $8911206154513afd$export$67c09327664a588d; });
$parcel$export(module.exports, "AxiosHttpHandler", function () { return $8911206154513afd$export$43af02f23afacda3; });
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("1J0sw");
var $cC0dr = parcelRequire("cC0dr");

var $z0zEw = parcelRequire("z0zEw");

var $3aLTy = parcelRequire("3aLTy");

var $l7cio = parcelRequire("l7cio");
var $8911206154513afd$var$logger = new (0, $l7cio.ConsoleLogger)('axios-http-handler');
var $8911206154513afd$export$67c09327664a588d = 'sendProgress';
var $8911206154513afd$export$43af02f23afacda3 = /** @class */ function() {
    function AxiosHttpHandler(httpOptions, emitter) {
        if (httpOptions === void 0) httpOptions = {};
        this.httpOptions = httpOptions;
        this.emitter = emitter;
    }
    AxiosHttpHandler.prototype.destroy = function() {
    // Do nothing. TLS and HTTP/2 connection pooling is handled by the
    // browser.
    };
    AxiosHttpHandler.prototype.handle = function(request, options) {
        var requestTimeoutInMs = this.httpOptions.requestTimeout;
        var emitter = this.emitter;
        var path = request.path;
        if (request.query) {
            var queryString = (0, $z0zEw.buildQueryString)(request.query);
            if (queryString) path += "?" + queryString;
        }
        var port = request.port;
        var url = request.protocol + "//" + request.hostname + (port ? ":" + port : '') + path;
        var axiosRequest = {};
        axiosRequest.url = url;
        axiosRequest.method = request.method;
        axiosRequest.headers = request.headers;
        // The host header is automatically added by the browser and adding it explicitly in the
        // axios request throws an error https://github.com/aws-amplify/amplify-js/issues/5376
        // This is because the host header is a forbidden header for the http client to set
        // see https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name and
        // https://fetch.spec.whatwg.org/#forbidden-header-name
        // The reason we are removing this header here instead of in the aws-sdk's client
        // middleware is that the host header is required to be in the request signature and if
        // we remove it from the middlewares, then the request fails because the header is added
        // by the browser but is absent from the signature.
        delete axiosRequest.headers['host'];
        if (request.body) axiosRequest.data = request.body;
        else // Fix for https://github.com/aws-amplify/amplify-js/issues/5432
        // If the POST request body is empty but content-type header is set, axios is forcibly removing it
        // See https://github.com/axios/axios/issues/1535 and refusing to fix it https://github.com/axios/axios/issues/755
        // This change is a workaround to set the data as null (instead of undefined) to prevent axios from
        // removing the content-type header. Link for the source code
        // https://github.com/axios/axios/blob/dc4bc49673943e35280e5df831f5c3d0347a9393/lib/adapters/xhr.js#L121-L123
        if (axiosRequest.headers['Content-Type']) axiosRequest.data = null;
        if (emitter) axiosRequest.onUploadProgress = function(event) {
            emitter.emit($8911206154513afd$export$67c09327664a588d, event);
            $8911206154513afd$var$logger.debug(event);
        };
        // From gamma release, aws-sdk now expects all response type to be of blob or streams
        axiosRequest.responseType = 'blob';
        var raceOfPromises = [
            (0, (/*@__PURE__*/$parcel$interopDefault($3aLTy))).request(axiosRequest).then(function(response) {
                return {
                    response: new (0, $cC0dr.HttpResponse)({
                        headers: response.headers,
                        statusCode: response.status,
                        body: response.data
                    })
                };
            }).catch(function(error) {
                // Error
                $8911206154513afd$var$logger.error(error);
                throw error;
            }),
            $8911206154513afd$var$requestTimeout(requestTimeoutInMs)
        ];
        return Promise.race(raceOfPromises);
    };
    return AxiosHttpHandler;
}();
function $8911206154513afd$var$requestTimeout(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within " + timeoutInMs + " ms");
            timeoutError.name = 'TimeoutError';
            reject(timeoutError);
        }, timeoutInMs);
    });
}

});
parcelRegister("3aLTy", function(module, exports) {

module.exports = (parcelRequire("9mpS6"));

});


parcelRegister("fpddR", function(module, exports) {

$parcel$export(module.exports, "AWSS3ProviderManagedUpload", function () { return $b373728817f92503$export$da75ae8ad0285104; });
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $l7cio = parcelRequire("l7cio");
var $ddXoz = parcelRequire("ddXoz");
var $ku8BJ = parcelRequire("ku8BJ");parcelRequire("dRac8");
var $ku8BJ = parcelRequire("ku8BJ");

var $9qSbW = parcelRequire("9qSbW");
var $3qDEM = parcelRequire("3qDEM");
var $fKK9L = parcelRequire("fKK9L");
var $1LN3D = parcelRequire("1LN3D");
var $c0H5c = parcelRequire("c0H5c");
var $1UQgc = parcelRequire("1UQgc");
var $9h99V = parcelRequire("9h99V");

var $bLBrm = parcelRequire("bLBrm");

var $9A2Mr = parcelRequire("9A2Mr");

var $d5UKP = parcelRequire("d5UKP");
parcelRequire("2NxHI");
var $gGhUY = parcelRequire("gGhUY");
var $b373728817f92503$var$__assign = undefined && undefined.__assign || function() {
    $b373728817f92503$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b373728817f92503$var$__assign.apply(this, arguments);
};
var $b373728817f92503$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b373728817f92503$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $b373728817f92503$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $b373728817f92503$var$logger = new (0, $l7cio.ConsoleLogger)('AWSS3ProviderManagedUpload');
var $b373728817f92503$var$localTestingStorageEndpoint = 'http://localhost:20005';
var $b373728817f92503$var$SET_CONTENT_LENGTH_HEADER = 'contentLengthMiddleware';
var $b373728817f92503$export$da75ae8ad0285104 = /** @class */ function() {
    function AWSS3ProviderManagedUpload(params, opts, emitter) {
        // Defaults
        this.minPartSize = 5242880; // in MB
        this.queueSize = 4;
        // Data for current upload
        this.body = null;
        this.params = null;
        this.opts = null;
        this.multiPartMap = [];
        this.cancel = false;
        // Progress reporting
        this.bytesUploaded = 0;
        this.totalBytesToUpload = 0;
        this.emitter = null;
        this.params = params;
        this.opts = opts;
        this.emitter = emitter;
    }
    AWSS3ProviderManagedUpload.prototype.upload = function() {
        return $b373728817f92503$var$__awaiter(this, void 0, void 0, function() {
            var _a, putObjectCommand, s3, uploadId, numberOfPartsToUpload, start, parts;
            return $b373728817f92503$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            this.validateAndSanitizeBody(this.params.Body)
                        ];
                    case 1:
                        _a.body = _b.sent();
                        this.totalBytesToUpload = this.byteLength(this.body);
                        if (!(this.totalBytesToUpload <= this.minPartSize)) return [
                            3 /*break*/ ,
                            3
                        ];
                        // Multipart upload is not required. Upload the sanitized body as is
                        this.params.Body = this.body;
                        putObjectCommand = new (0, $c0H5c.PutObjectCommand)(this.params);
                        return [
                            4 /*yield*/ ,
                            this._createNewS3Client(this.opts, this.emitter)
                        ];
                    case 2:
                        s3 = _b.sent();
                        return [
                            2 /*return*/ ,
                            s3.send(putObjectCommand)
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            this.createMultiPartUpload()
                        ];
                    case 4:
                        uploadId = _b.sent();
                        numberOfPartsToUpload = Math.ceil(this.totalBytesToUpload / this.minPartSize);
                        start = 0;
                        _b.label = 5;
                    case 5:
                        if (!(start < numberOfPartsToUpload)) return [
                            3 /*break*/ ,
                            10
                        ];
                        /** This first block will try to cancel the upload if the cancel
                         *	request came before any parts uploads have started.
                         **/ return [
                            4 /*yield*/ ,
                            this.checkIfUploadCancelled(uploadId)
                        ];
                    case 6:
                        /** This first block will try to cancel the upload if the cancel
                         *	request came before any parts uploads have started.
                         **/ _b.sent();
                        parts = this.createParts(start);
                        return [
                            4 /*yield*/ ,
                            this.uploadParts(uploadId, parts)
                        ];
                    case 7:
                        _b.sent();
                        /** Call cleanup a second time in case there were part upload requests
                         *  in flight. This is to ensure that all parts are cleaned up.
                         */ return [
                            4 /*yield*/ ,
                            this.checkIfUploadCancelled(uploadId)
                        ];
                    case 8:
                        /** Call cleanup a second time in case there were part upload requests
                         *  in flight. This is to ensure that all parts are cleaned up.
                         */ _b.sent();
                        _b.label = 9;
                    case 9:
                        start += this.queueSize;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 10:
                        return [
                            4 /*yield*/ ,
                            this.finishMultiPartUpload(uploadId)
                        ];
                    case 11:
                        // Step 3: Finalize the upload such that S3 can recreate the file
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.createParts = function(startPartNumber) {
        var parts = [];
        var partNumber = startPartNumber;
        for(var bodyStart = startPartNumber * this.minPartSize; bodyStart < this.totalBytesToUpload && parts.length < this.queueSize;){
            var bodyEnd = Math.min(bodyStart + this.minPartSize, this.totalBytesToUpload);
            parts.push({
                bodyPart: this.body.slice(bodyStart, bodyEnd),
                partNumber: ++partNumber,
                emitter: new $9A2Mr.EventEmitter(),
                _lastUploadedBytes: 0
            });
            bodyStart += this.minPartSize;
        }
        return parts;
    };
    AWSS3ProviderManagedUpload.prototype.createMultiPartUpload = function() {
        return $b373728817f92503$var$__awaiter(this, void 0, void 0, function() {
            var createMultiPartUploadCommand, s3, response;
            return $b373728817f92503$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        createMultiPartUploadCommand = new (0, $fKK9L.CreateMultipartUploadCommand)(this.params);
                        return [
                            4 /*yield*/ ,
                            this._createNewS3Client(this.opts)
                        ];
                    case 1:
                        s3 = _a.sent();
                        return [
                            4 /*yield*/ ,
                            s3.send(createMultiPartUploadCommand)
                        ];
                    case 2:
                        response = _a.sent();
                        $b373728817f92503$var$logger.debug(response.UploadId);
                        return [
                            2 /*return*/ ,
                            response.UploadId
                        ];
                }
            });
        });
    };
    /**
     * @private Not to be extended outside of tests
     * @VisibleFotTesting
     */ AWSS3ProviderManagedUpload.prototype.uploadParts = function(uploadId, parts) {
        return $b373728817f92503$var$__awaiter(this, void 0, void 0, function() {
            var promises, parts_1, parts_1_1, part, uploadPartCommandInput, uploadPartCommand, s3, e_1_1, allResults, i, error_1;
            var e_1, _a;
            return $b373728817f92503$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        promises = [];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        parts_1 = $b373728817f92503$var$__values(parts), parts_1_1 = parts_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!parts_1_1.done) return [
                            3 /*break*/ ,
                            5
                        ];
                        part = parts_1_1.value;
                        this.setupEventListener(part);
                        uploadPartCommandInput = {
                            PartNumber: part.partNumber,
                            Body: part.bodyPart,
                            UploadId: uploadId,
                            Key: this.params.Key,
                            Bucket: this.params.Bucket
                        };
                        uploadPartCommand = new (0, $9h99V.UploadPartCommand)(uploadPartCommandInput);
                        return [
                            4 /*yield*/ ,
                            this._createNewS3Client(this.opts, part.emitter)
                        ];
                    case 3:
                        s3 = _b.sent();
                        promises.push(s3.send(uploadPartCommand));
                        _b.label = 4;
                    case 4:
                        parts_1_1 = parts_1.next();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        e_1_1 = _b.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        try {
                            if (parts_1_1 && !parts_1_1.done && (_a = parts_1.return)) _a.call(parts_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 8:
                        _b.trys.push([
                            8,
                            10,
                            ,
                            11
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.all(promises)
                        ];
                    case 9:
                        allResults = _b.sent();
                        // The order of resolved promises is the same as input promise order.
                        for(i = 0; i < allResults.length; i++)this.multiPartMap.push({
                            PartNumber: parts[i].partNumber,
                            ETag: allResults[i].ETag
                        });
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        error_1 = _b.sent();
                        $b373728817f92503$var$logger.error('error happened while uploading a part. Cancelling the multipart upload', error_1);
                        this.cancelUpload();
                        return [
                            2 /*return*/ 
                        ];
                    case 11:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.finishMultiPartUpload = function(uploadId) {
        return $b373728817f92503$var$__awaiter(this, void 0, void 0, function() {
            var input, completeUploadCommand, s3, data, error_2;
            return $b373728817f92503$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        input = {
                            Bucket: this.params.Bucket,
                            Key: this.params.Key,
                            UploadId: uploadId,
                            MultipartUpload: {
                                Parts: this.multiPartMap
                            }
                        };
                        completeUploadCommand = new (0, $3qDEM.CompleteMultipartUploadCommand)(input);
                        return [
                            4 /*yield*/ ,
                            this._createNewS3Client(this.opts)
                        ];
                    case 1:
                        s3 = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            s3.send(completeUploadCommand)
                        ];
                    case 3:
                        data = _a.sent();
                        return [
                            2 /*return*/ ,
                            data.Key
                        ];
                    case 4:
                        error_2 = _a.sent();
                        $b373728817f92503$var$logger.error('error happened while finishing the upload. Cancelling the multipart upload', error_2);
                        this.cancelUpload();
                        return [
                            2 /*return*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.checkIfUploadCancelled = function(uploadId) {
        return $b373728817f92503$var$__awaiter(this, void 0, void 0, function() {
            var errorMessage, error_3;
            return $b373728817f92503$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.cancel) return [
                            3 /*break*/ ,
                            5
                        ];
                        errorMessage = 'Upload was cancelled.';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanup(uploadId)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_3 = _a.sent();
                        errorMessage += error_3.errorMessage;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        throw new Error(errorMessage);
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.cancelUpload = function() {
        this.cancel = true;
    };
    AWSS3ProviderManagedUpload.prototype.cleanup = function(uploadId) {
        return $b373728817f92503$var$__awaiter(this, void 0, void 0, function() {
            var input, s3, data;
            return $b373728817f92503$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // Reset this's state
                        this.body = null;
                        this.multiPartMap = [];
                        this.bytesUploaded = 0;
                        this.totalBytesToUpload = 0;
                        input = {
                            Bucket: this.params.Bucket,
                            Key: this.params.Key,
                            UploadId: uploadId
                        };
                        return [
                            4 /*yield*/ ,
                            this._createNewS3Client(this.opts)
                        ];
                    case 1:
                        s3 = _a.sent();
                        return [
                            4 /*yield*/ ,
                            s3.send(new (0, $9qSbW.AbortMultipartUploadCommand)(input))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            s3.send(new (0, $1LN3D.ListPartsCommand)(input))
                        ];
                    case 3:
                        data = _a.sent();
                        if (data && data.Parts && data.Parts.length > 0) throw new Error('Multi Part upload clean up failed');
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.setupEventListener = function(part) {
        var _this = this;
        part.emitter.on((0, $bLBrm.SEND_PROGRESS_EVENT), function(progress) {
            _this.progressChanged(part.partNumber, progress.loaded - part._lastUploadedBytes);
            part._lastUploadedBytes = progress.loaded;
        });
    };
    AWSS3ProviderManagedUpload.prototype.progressChanged = function(partNumber, incrementalUpdate) {
        this.bytesUploaded += incrementalUpdate;
        this.emitter.emit((0, $bLBrm.SEND_PROGRESS_EVENT), {
            loaded: this.bytesUploaded,
            total: this.totalBytesToUpload,
            part: partNumber,
            key: this.params.Key
        });
    };
    AWSS3ProviderManagedUpload.prototype.byteLength = function(input) {
        if (input === null || input === undefined) return 0;
        if (typeof input.byteLength === 'number') return input.byteLength;
        else if (typeof input.length === 'number') return input.length;
        else if (typeof input.size === 'number') return input.size;
        else if (typeof input.path === 'string') ;
        else throw new Error('Cannot determine length of ' + input);
    };
    AWSS3ProviderManagedUpload.prototype.validateAndSanitizeBody = function(body) {
        return $b373728817f92503$var$__awaiter(this, void 0, void 0, function() {
            return $b373728817f92503$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.isGenericObject(body)) return [
                            3 /*break*/ ,
                            1
                        ];
                        // Any javascript object
                        return [
                            2 /*return*/ ,
                            JSON.stringify(body)
                        ];
                    case 1:
                        if (!this.isBlob(body)) return [
                            3 /*break*/ ,
                            4
                        ];
                        if (!(0, $ku8BJ.Platform).isReactNative) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $gGhUY.streamCollector)(body)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            body
                        ];
                    case 4:
                        // Files, arrayBuffer etc
                        return [
                            2 /*return*/ ,
                            body
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.isBlob = function(body) {
        return typeof Blob !== 'undefined' && body instanceof Blob;
    };
    AWSS3ProviderManagedUpload.prototype.isGenericObject = function(body) {
        if (body !== null && typeof body === 'object') try {
            return !(this.byteLength(body) >= 0);
        } catch (error) {
            // If we cannot determine the length of the body, consider it
            // as a generic object and upload a stringified version of it
            return true;
        }
        return false;
    };
    /**
     * @private
     * creates an S3 client with new V3 aws sdk
     */ AWSS3ProviderManagedUpload.prototype._createNewS3Client = function(config, emitter) {
        return $b373728817f92503$var$__awaiter(this, void 0, void 0, function() {
            var credentials, region, dangerouslyConnectToHttpEndpointForTesting, localTestingConfig, client;
            return $b373728817f92503$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._getCredentials()
                        ];
                    case 1:
                        credentials = _a.sent();
                        region = config.region, dangerouslyConnectToHttpEndpointForTesting = config.dangerouslyConnectToHttpEndpointForTesting;
                        localTestingConfig = {};
                        if (dangerouslyConnectToHttpEndpointForTesting) localTestingConfig = {
                            endpoint: $b373728817f92503$var$localTestingStorageEndpoint,
                            tls: false,
                            bucketEndpoint: false,
                            forcePathStyle: true
                        };
                        client = new (0, $1UQgc.S3Client)($b373728817f92503$var$__assign($b373728817f92503$var$__assign({
                            region: region,
                            credentials: credentials
                        }, localTestingConfig), {
                            requestHandler: new (0, $bLBrm.AxiosHttpHandler)({}, emitter),
                            customUserAgent: (0, $ku8BJ.getAmplifyUserAgent)(),
                            urlParser: (0, $d5UKP.parseUrl)
                        }));
                        client.middlewareStack.remove($b373728817f92503$var$SET_CONTENT_LENGTH_HEADER);
                        return [
                            2 /*return*/ ,
                            client
                        ];
                }
            });
        });
    };
    /**
     * @private
     */ AWSS3ProviderManagedUpload.prototype._getCredentials = function() {
        return (0, $ddXoz.Credentials).get().then(function(credentials) {
            if (!credentials) return false;
            var cred = (0, $ddXoz.Credentials).shear(credentials);
            $b373728817f92503$var$logger.debug('set credentials for storage', cred);
            return cred;
        }).catch(function(error) {
            $b373728817f92503$var$logger.warn('ensure credentials error', error);
            return false;
        });
    };
    return AWSS3ProviderManagedUpload;
}();

});
parcelRegister("9qSbW", function(module, exports) {

$parcel$export(module.exports, "AbortMultipartUploadCommand", function () { return $6de09415d986a9af$export$87d2388f8662d995; });

var $9OyH6 = parcelRequire("9OyH6");

var $lLFWX = parcelRequire("lLFWX");

var $6RHn6 = parcelRequire("6RHn6");
parcelRequire("238LE");
var $1yBqn = parcelRequire("1yBqn");
parcelRequire("5Wom8");
var $jU8uG = parcelRequire("jU8uG");
parcelRequire("fF6iB");
var $koeHb = parcelRequire("koeHb");
var $6de09415d986a9af$export$87d2388f8662d995 = /** @class */ function(_super) {
    (0, $9OyH6.__extends)(AbortMultipartUploadCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function AbortMultipartUploadCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    AbortMultipartUploadCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $jU8uG.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $1yBqn.getBucketEndpointPlugin)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "AbortMultipartUploadCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $lLFWX.AbortMultipartUploadRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $lLFWX.AbortMultipartUploadOutput).filterSensitiveLog
        };
        if (typeof logger.info === "function") logger.info({
            clientName: clientName,
            commandName: commandName
        });
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    AbortMultipartUploadCommand.prototype.serialize = function(input, context) {
        return (0, $6RHn6.serializeAws_restXmlAbortMultipartUploadCommand)(input, context);
    };
    AbortMultipartUploadCommand.prototype.deserialize = function(output, context) {
        return (0, $6RHn6.deserializeAws_restXmlAbortMultipartUploadCommand)(output, context);
    };
    return AbortMultipartUploadCommand;
}((0, $koeHb.Command));

});

parcelRegister("3qDEM", function(module, exports) {

$parcel$export(module.exports, "CompleteMultipartUploadCommand", function () { return $27f28fd46ca90e8c$export$f827ea0301b4eeff; });

var $9OyH6 = parcelRequire("9OyH6");

var $lLFWX = parcelRequire("lLFWX");

var $6RHn6 = parcelRequire("6RHn6");
parcelRequire("238LE");
var $1yBqn = parcelRequire("1yBqn");
parcelRequire("5Wom8");
var $jU8uG = parcelRequire("jU8uG");
parcelRequire("fF6iB");
var $koeHb = parcelRequire("koeHb");
var $27f28fd46ca90e8c$export$f827ea0301b4eeff = /** @class */ function(_super) {
    (0, $9OyH6.__extends)(CompleteMultipartUploadCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CompleteMultipartUploadCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    CompleteMultipartUploadCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $jU8uG.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $1yBqn.getBucketEndpointPlugin)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "CompleteMultipartUploadCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $lLFWX.CompleteMultipartUploadRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $lLFWX.CompleteMultipartUploadOutput).filterSensitiveLog
        };
        if (typeof logger.info === "function") logger.info({
            clientName: clientName,
            commandName: commandName
        });
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CompleteMultipartUploadCommand.prototype.serialize = function(input, context) {
        return (0, $6RHn6.serializeAws_restXmlCompleteMultipartUploadCommand)(input, context);
    };
    CompleteMultipartUploadCommand.prototype.deserialize = function(output, context) {
        return (0, $6RHn6.deserializeAws_restXmlCompleteMultipartUploadCommand)(output, context);
    };
    return CompleteMultipartUploadCommand;
}((0, $koeHb.Command));

});

parcelRegister("fKK9L", function(module, exports) {

$parcel$export(module.exports, "CreateMultipartUploadCommand", function () { return $b77ef49eb54d59c3$export$76155123c96043b8; });

var $9OyH6 = parcelRequire("9OyH6");

var $lLFWX = parcelRequire("lLFWX");

var $6RHn6 = parcelRequire("6RHn6");
parcelRequire("238LE");
var $1yBqn = parcelRequire("1yBqn");
parcelRequire("5Wom8");
var $jU8uG = parcelRequire("jU8uG");

var $5SKvi = parcelRequire("5SKvi");
parcelRequire("fF6iB");
var $koeHb = parcelRequire("koeHb");
var $b77ef49eb54d59c3$export$76155123c96043b8 = /** @class */ function(_super) {
    (0, $9OyH6.__extends)(CreateMultipartUploadCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateMultipartUploadCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    CreateMultipartUploadCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $jU8uG.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $5SKvi.getSsecPlugin)(configuration));
        this.middlewareStack.use((0, $1yBqn.getBucketEndpointPlugin)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "CreateMultipartUploadCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $lLFWX.CreateMultipartUploadRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $lLFWX.CreateMultipartUploadOutput).filterSensitiveLog
        };
        if (typeof logger.info === "function") logger.info({
            clientName: clientName,
            commandName: commandName
        });
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateMultipartUploadCommand.prototype.serialize = function(input, context) {
        return (0, $6RHn6.serializeAws_restXmlCreateMultipartUploadCommand)(input, context);
    };
    CreateMultipartUploadCommand.prototype.deserialize = function(output, context) {
        return (0, $6RHn6.deserializeAws_restXmlCreateMultipartUploadCommand)(output, context);
    };
    return CreateMultipartUploadCommand;
}((0, $koeHb.Command));

});

parcelRegister("1LN3D", function(module, exports) {

$parcel$export(module.exports, "ListPartsCommand", function () { return $14a03c10a79f7556$export$17fb27d830090508; });

var $9OyH6 = parcelRequire("9OyH6");

var $lLFWX = parcelRequire("lLFWX");

var $6RHn6 = parcelRequire("6RHn6");
parcelRequire("238LE");
var $1yBqn = parcelRequire("1yBqn");
parcelRequire("5Wom8");
var $jU8uG = parcelRequire("jU8uG");
parcelRequire("fF6iB");
var $koeHb = parcelRequire("koeHb");
var $14a03c10a79f7556$export$17fb27d830090508 = /** @class */ function(_super) {
    (0, $9OyH6.__extends)(ListPartsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListPartsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    ListPartsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $jU8uG.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $1yBqn.getBucketEndpointPlugin)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "ListPartsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $lLFWX.ListPartsRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $lLFWX.ListPartsOutput).filterSensitiveLog
        };
        if (typeof logger.info === "function") logger.info({
            clientName: clientName,
            commandName: commandName
        });
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListPartsCommand.prototype.serialize = function(input, context) {
        return (0, $6RHn6.serializeAws_restXmlListPartsCommand)(input, context);
    };
    ListPartsCommand.prototype.deserialize = function(output, context) {
        return (0, $6RHn6.deserializeAws_restXmlListPartsCommand)(output, context);
    };
    return ListPartsCommand;
}((0, $koeHb.Command));

});

parcelRegister("c0H5c", function(module, exports) {

$parcel$export(module.exports, "PutObjectCommand", function () { return $8be6e77dd88e51d2$export$4afa2352f8871c26; });

var $9OyH6 = parcelRequire("9OyH6");

var $lLFWX = parcelRequire("lLFWX");

var $6RHn6 = parcelRequire("6RHn6");
parcelRequire("238LE");
var $1yBqn = parcelRequire("1yBqn");
parcelRequire("5Wom8");
var $jU8uG = parcelRequire("jU8uG");

var $5SKvi = parcelRequire("5SKvi");
parcelRequire("fF6iB");
var $koeHb = parcelRequire("koeHb");
var $8be6e77dd88e51d2$export$4afa2352f8871c26 = /** @class */ function(_super) {
    (0, $9OyH6.__extends)(PutObjectCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutObjectCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    PutObjectCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $jU8uG.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $5SKvi.getSsecPlugin)(configuration));
        this.middlewareStack.use((0, $1yBqn.getBucketEndpointPlugin)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "PutObjectCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $lLFWX.PutObjectRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $lLFWX.PutObjectOutput).filterSensitiveLog
        };
        if (typeof logger.info === "function") logger.info({
            clientName: clientName,
            commandName: commandName
        });
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutObjectCommand.prototype.serialize = function(input, context) {
        return (0, $6RHn6.serializeAws_restXmlPutObjectCommand)(input, context);
    };
    PutObjectCommand.prototype.deserialize = function(output, context) {
        return (0, $6RHn6.deserializeAws_restXmlPutObjectCommand)(output, context);
    };
    return PutObjectCommand;
}((0, $koeHb.Command));

});

parcelRegister("9h99V", function(module, exports) {

$parcel$export(module.exports, "UploadPartCommand", function () { return $6c0cce5dadd6aa91$export$20fd13f6cebe56f0; });

var $9OyH6 = parcelRequire("9OyH6");

var $g0DrM = parcelRequire("g0DrM");

var $6RHn6 = parcelRequire("6RHn6");
parcelRequire("238LE");
var $1yBqn = parcelRequire("1yBqn");
parcelRequire("5Wom8");
var $jU8uG = parcelRequire("jU8uG");

var $5SKvi = parcelRequire("5SKvi");
parcelRequire("fF6iB");
var $koeHb = parcelRequire("koeHb");
var $6c0cce5dadd6aa91$export$20fd13f6cebe56f0 = /** @class */ function(_super) {
    (0, $9OyH6.__extends)(UploadPartCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UploadPartCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    UploadPartCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $jU8uG.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $5SKvi.getSsecPlugin)(configuration));
        this.middlewareStack.use((0, $1yBqn.getBucketEndpointPlugin)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "UploadPartCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $g0DrM.UploadPartRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $g0DrM.UploadPartOutput).filterSensitiveLog
        };
        if (typeof logger.info === "function") logger.info({
            clientName: clientName,
            commandName: commandName
        });
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UploadPartCommand.prototype.serialize = function(input, context) {
        return (0, $6RHn6.serializeAws_restXmlUploadPartCommand)(input, context);
    };
    UploadPartCommand.prototype.deserialize = function(output, context) {
        return (0, $6RHn6.deserializeAws_restXmlUploadPartCommand)(output, context);
    };
    return UploadPartCommand;
}((0, $koeHb.Command));

});
parcelRegister("g0DrM", function(module, exports) {

$parcel$export(module.exports, "UploadPartOutput", function () { return $ba7b3eca28611f18$export$1e083fd90afa2f51; });
$parcel$export(module.exports, "UploadPartRequest", function () { return $ba7b3eca28611f18$export$ecf841796ea7b1f0; });

var $9OyH6 = parcelRequire("9OyH6");

var $lLFWX = parcelRequire("lLFWX");
parcelRequire("fF6iB");
var $gouPX = parcelRequire("gouPX");
var $ba7b3eca28611f18$export$ee855080cc4fa5a8;
(function(RestoreRequestType) {
    RestoreRequestType["SELECT"] = "SELECT";
})($ba7b3eca28611f18$export$ee855080cc4fa5a8 || ($ba7b3eca28611f18$export$ee855080cc4fa5a8 = {}));
var $ba7b3eca28611f18$export$116b002a1c4d25c0;
(function(RestoreRequest) {
    RestoreRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.OutputLocation && {
            OutputLocation: (0, $lLFWX.OutputLocation).filterSensitiveLog(obj.OutputLocation)
        });
    };
})($ba7b3eca28611f18$export$116b002a1c4d25c0 || ($ba7b3eca28611f18$export$116b002a1c4d25c0 = {}));
var $ba7b3eca28611f18$export$bd1b29d0f94512e7;
(function(RestoreObjectRequest) {
    RestoreObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.RestoreRequest && {
            RestoreRequest: $ba7b3eca28611f18$export$116b002a1c4d25c0.filterSensitiveLog(obj.RestoreRequest)
        });
    };
})($ba7b3eca28611f18$export$bd1b29d0f94512e7 || ($ba7b3eca28611f18$export$bd1b29d0f94512e7 = {}));
var $ba7b3eca28611f18$export$d20e6aaa08a7363f;
(function(ContinuationEvent) {
    ContinuationEvent.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($ba7b3eca28611f18$export$d20e6aaa08a7363f || ($ba7b3eca28611f18$export$d20e6aaa08a7363f = {}));
var $ba7b3eca28611f18$export$2066b1507471daea;
(function(EndEvent) {
    EndEvent.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($ba7b3eca28611f18$export$2066b1507471daea || ($ba7b3eca28611f18$export$2066b1507471daea = {}));
var $ba7b3eca28611f18$export$b25a304ec7d746bb;
(function(Progress) {
    Progress.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($ba7b3eca28611f18$export$b25a304ec7d746bb || ($ba7b3eca28611f18$export$b25a304ec7d746bb = {}));
var $ba7b3eca28611f18$export$863d066dc35784fb;
(function(ProgressEvent) {
    ProgressEvent.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($ba7b3eca28611f18$export$863d066dc35784fb || ($ba7b3eca28611f18$export$863d066dc35784fb = {}));
var $ba7b3eca28611f18$export$bb48554e89f06bf8;
(function(RecordsEvent) {
    RecordsEvent.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($ba7b3eca28611f18$export$bb48554e89f06bf8 || ($ba7b3eca28611f18$export$bb48554e89f06bf8 = {}));
var $ba7b3eca28611f18$export$3cdec2bba15e3523;
(function(Stats) {
    Stats.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($ba7b3eca28611f18$export$3cdec2bba15e3523 || ($ba7b3eca28611f18$export$3cdec2bba15e3523 = {}));
var $ba7b3eca28611f18$export$72935df6390a4cde;
(function(StatsEvent) {
    StatsEvent.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($ba7b3eca28611f18$export$72935df6390a4cde || ($ba7b3eca28611f18$export$72935df6390a4cde = {}));
var $ba7b3eca28611f18$export$4c951f3462fad8ac;
(function(SelectObjectContentEventStream) {
    SelectObjectContentEventStream.visit = function(value, visitor) {
        if (value.Cont !== undefined) return visitor.Cont(value.Cont);
        if (value.Progress !== undefined) return visitor.Progress(value.Progress);
        if (value.Stats !== undefined) return visitor.Stats(value.Stats);
        if (value.End !== undefined) return visitor.End(value.End);
        if (value.Records !== undefined) return visitor.Records(value.Records);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
    SelectObjectContentEventStream.filterSensitiveLog = function(obj) {
        var _a;
        if (obj.Cont !== undefined) return {
            Cont: $ba7b3eca28611f18$export$d20e6aaa08a7363f.filterSensitiveLog(obj.Cont)
        };
        if (obj.Progress !== undefined) return {
            Progress: $ba7b3eca28611f18$export$863d066dc35784fb.filterSensitiveLog(obj.Progress)
        };
        if (obj.Stats !== undefined) return {
            Stats: $ba7b3eca28611f18$export$72935df6390a4cde.filterSensitiveLog(obj.Stats)
        };
        if (obj.End !== undefined) return {
            End: $ba7b3eca28611f18$export$2066b1507471daea.filterSensitiveLog(obj.End)
        };
        if (obj.Records !== undefined) return {
            Records: $ba7b3eca28611f18$export$bb48554e89f06bf8.filterSensitiveLog(obj.Records)
        };
        if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
    };
})($ba7b3eca28611f18$export$4c951f3462fad8ac || ($ba7b3eca28611f18$export$4c951f3462fad8ac = {}));
var $ba7b3eca28611f18$export$5bf8ed4e571234e3;
(function(SelectObjectContentOutput) {
    SelectObjectContentOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.Payload && {
            Payload: "STREAMING_CONTENT"
        });
    };
})($ba7b3eca28611f18$export$5bf8ed4e571234e3 || ($ba7b3eca28611f18$export$5bf8ed4e571234e3 = {}));
var $ba7b3eca28611f18$export$b8081f25e3a7bfbd;
(function(RequestProgress) {
    RequestProgress.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($ba7b3eca28611f18$export$b8081f25e3a7bfbd || ($ba7b3eca28611f18$export$b8081f25e3a7bfbd = {}));
var $ba7b3eca28611f18$export$33f7c3433c085364;
(function(ScanRange) {
    ScanRange.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($ba7b3eca28611f18$export$33f7c3433c085364 || ($ba7b3eca28611f18$export$33f7c3433c085364 = {}));
var $ba7b3eca28611f18$export$852c159401aad03e;
(function(SelectObjectContentRequest) {
    SelectObjectContentRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $gouPX.SENSITIVE_STRING)
        });
    };
})($ba7b3eca28611f18$export$852c159401aad03e || ($ba7b3eca28611f18$export$852c159401aad03e = {}));
var $ba7b3eca28611f18$export$1e083fd90afa2f51;
(function(UploadPartOutput) {
    UploadPartOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $gouPX.SENSITIVE_STRING)
        });
    };
})($ba7b3eca28611f18$export$1e083fd90afa2f51 || ($ba7b3eca28611f18$export$1e083fd90afa2f51 = {}));
var $ba7b3eca28611f18$export$ecf841796ea7b1f0;
(function(UploadPartRequest) {
    UploadPartRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $gouPX.SENSITIVE_STRING)
        });
    };
})($ba7b3eca28611f18$export$ecf841796ea7b1f0 || ($ba7b3eca28611f18$export$ecf841796ea7b1f0 = {}));
var $ba7b3eca28611f18$export$ff4e5952953c0084;
(function(CopyPartResult) {
    CopyPartResult.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)({}, obj);
    };
})($ba7b3eca28611f18$export$ff4e5952953c0084 || ($ba7b3eca28611f18$export$ff4e5952953c0084 = {}));
var $ba7b3eca28611f18$export$d6a8bd15a4edcee7;
(function(UploadPartCopyOutput) {
    UploadPartCopyOutput.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $gouPX.SENSITIVE_STRING)
        });
    };
})($ba7b3eca28611f18$export$d6a8bd15a4edcee7 || ($ba7b3eca28611f18$export$d6a8bd15a4edcee7 = {}));
var $ba7b3eca28611f18$export$b68c35e4811b33e;
(function(UploadPartCopyRequest) {
    UploadPartCopyRequest.filterSensitiveLog = function(obj) {
        return (0, $9OyH6.__assign)((0, $9OyH6.__assign)((0, $9OyH6.__assign)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $gouPX.SENSITIVE_STRING)
        }), obj.CopySourceSSECustomerKey && {
            CopySourceSSECustomerKey: (0, $gouPX.SENSITIVE_STRING)
        });
    };
})($ba7b3eca28611f18$export$b68c35e4811b33e || ($ba7b3eca28611f18$export$b68c35e4811b33e = {}));

});


parcelRegister("d5UKP", function(module, exports) {

$parcel$export(module.exports, "parseUrl", function () { return $9887c4351c8f26d2$export$7a5253c0f62e0150; });

var $c34CS = parcelRequire("c34CS");

var $2qlBa = parcelRequire("2qlBa");
var $9887c4351c8f26d2$export$7a5253c0f62e0150 = function(url) {
    var _a = (0, $2qlBa.parse)(url), _b = _a.hostname, hostname = _b === void 0 ? "localhost" : _b, _c = _a.pathname, pathname = _c === void 0 ? "/" : _c, port = _a.port, _d = _a.protocol, protocol = _d === void 0 ? "https:" : _d, search = _a.search;
    var query;
    if (search) query = (0, $c34CS.parseQueryString)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};

});





parcelRegister("b46Jf", function(module, exports) {
!function(t, _) {
    module.exports = _();
}(module.exports, function() {
    return function(t) {
        var _ = {};
        function n(o) {
            if (_[o]) return _[o].exports;
            var e = _[o] = {
                i: o,
                l: !1,
                exports: {}
            };
            return t[o].call(e.exports, e, e.exports, n), e.l = !0, e.exports;
        }
        return n.m = t, n.c = _, n.d = function(t, _, o) {
            n.o(t, _) || Object.defineProperty(t, _, {
                enumerable: !0,
                get: o
            });
        }, n.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, n.t = function(t, _) {
            if (1 & _ && (t = n(t)), 8 & _) return t;
            if (4 & _ && "object" == typeof t && t && t.__esModule) return t;
            var o = Object.create(null);
            if (n.r(o), Object.defineProperty(o, "default", {
                enumerable: !0,
                value: t
            }), 2 & _ && "string" != typeof t) for(var e in t)n.d(o, e, (function(_) {
                return t[_];
            }).bind(null, e));
            return o;
        }, n.n = function(t) {
            var _ = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return n.d(_, "a", _), _;
        }, n.o = function(t, _) {
            return Object.prototype.hasOwnProperty.call(t, _);
        }, n.p = "", n(n.s = 0);
    }([
        function(t, _, n) {
            "use strict";
            function o(t) {
                for(var n in t)_.hasOwnProperty(n) || (_[n] = t[n]);
            }
            Object.defineProperty(_, "__esModule", {
                value: !0
            }), o(n(1)), o(n(2)), o(n(3)), o(n(4)), o(n(5)), o(n(6)), o(n(7)), o(n(8)), o(n(9)), o(n(10)), o(n(11)), o(n(12)), o(n(13));
        },
        function(t, _, n) {
            t.exports = {
                a: "Anchor__a___1_Iz8"
            };
        },
        function(t, _, n) {
            t.exports = {
                button: "Button__button___vS7Mv",
                signInButton: "Button__signInButton___3bUH-",
                googleSignInButton: "Button__googleSignInButton___1YiCu",
                signInButtonIcon: "Button__signInButtonIcon___ihN75",
                auth0SignInButton: "Button__auth0SignInButton___znnCj",
                facebookSignInButton: "Button__facebookSignInButton___34Txh",
                amazonSignInButton: "Button__amazonSignInButton___2EMtl",
                oAuthSignInButton: "Button__oAuthSignInButton___3UGOl",
                signInButtonContent: "Button__signInButtonContent___xqTXJ"
            };
        },
        function(t, _, n) {
            t.exports = {
                formContainer: "Form__formContainer___1GA3x",
                formSection: "Form__formSection___1PPvW",
                formField: "Form__formField___38Ikl",
                formRow: "Form__formRow___2mwRs"
            };
        },
        function(t, _, n) {
            t.exports = {
                hint: "Hint__hint___2XngB"
            };
        },
        function(t, _, n) {
            t.exports = {
                input: "Input__input___3e_bf",
                inputLabel: "Input__inputLabel___3VF0S",
                label: "Input__label___23sO8",
                radio: "Input__radio___2hllK"
            };
        },
        function(t, _, n) {
            t.exports = {
                navBar: "Nav__navBar___xtCFA",
                navRight: "Nav__navRight___1QG2J",
                nav: "Nav__nav___2Dx2Y",
                navItem: "Nav__navItem___1LtFQ"
            };
        },
        function(t, _, n) {
            t.exports = {
                photoPickerButton: "PhotoPicker__photoPickerButton___2XdVn",
                photoPlaceholder: "PhotoPicker__photoPlaceholder___2JXO4",
                photoPlaceholderIcon: "PhotoPicker__photoPlaceholderIcon___3Et71"
            };
        },
        function(t, _, n) {
            t.exports = {
                container: "Section__container___3YYTG",
                actionRow: "Section__actionRow___2LWSU",
                sectionHeader: "Section__sectionHeader___2djyg",
                sectionHeaderHint: "Section__sectionHeaderHint___3Wxdc",
                sectionBody: "Section__sectionBody___ihqqd",
                sectionHeaderContent: "Section__sectionHeaderContent___1UCqa",
                sectionFooter: "Section__sectionFooter___1T54C",
                sectionFooterPrimaryContent: "Section__sectionFooterPrimaryContent___2r9ZX",
                sectionFooterSecondaryContent: "Section__sectionFooterSecondaryContent___Nj41Q"
            };
        },
        function(t, _, n) {
            t.exports = {
                selectInput: "SelectInput__selectInput___3efO4"
            };
        },
        function(t, _, n) {
            t.exports = {
                strike: "Strike__strike___1XV1b",
                strikeContent: "Strike__strikeContent___10gLb"
            };
        },
        function(t, _, n) {
            t.exports = {
                toast: "Toast__toast___XXr3v",
                toastClose: "Toast__toastClose___18lU4"
            };
        },
        function(t, _, n) {
            t.exports = {
                totpQrcode: "Totp__totpQrcode___1crLx"
            };
        },
        function(t, _, n) {
            t.exports = {
                sumerianSceneContainer: "XR__sumerianSceneContainer___3nVMt",
                sumerianScene: "XR__sumerianScene___2Tt7-",
                loadingOverlay: "XR__loadingOverlay___IbqcI",
                loadingContainer: "XR__loadingContainer___2Itxb",
                loadingLogo: "XR__loadingLogo___Ub7xQ",
                loadingSceneName: "XR__loadingSceneName___3__ne",
                loadingBar: "XR__loadingBar___2vcke",
                loadingBarFill: "XR__loadingBarFill___3M-D9",
                sceneErrorText: "XR__sceneErrorText___2y0tp",
                sceneBar: "XR__sceneBar___2ShrP",
                sceneName: "XR__sceneName___1ApHr",
                sceneActions: "XR__sceneActions___7plGs",
                actionButton: "XR__actionButton___2poIM",
                tooltip: "XR__tooltip___UYyhn",
                actionIcon: "XR__actionIcon___2qnd2",
                autoShowTooltip: "XR__autoShowTooltip___V1QH7"
            };
        }
    ]);
});

});


parcelRegister("9AErM", function(module, exports) {

$parcel$export(module.exports, "GET_CUSTOMERS", function () { return $6fb6d9d18b595723$export$937aab212842efd7; });
$parcel$export(module.exports, "ACCEPT_TERMS", function () { return $6fb6d9d18b595723$export$29cf195ad2826beb; });
$parcel$export(module.exports, "GET_USER_INFO", function () { return $6fb6d9d18b595723$export$3ffbfad93dfcf6b0; });
parcelRequire("2UBc8");
var $3EDHG = parcelRequire("3EDHG");
const $6fb6d9d18b595723$export$937aab212842efd7 = (0, $3EDHG.default)`
  query GetCustomers {
    getCustomers {
      id
      name
    }
  }
`;
const $6fb6d9d18b595723$export$29cf195ad2826beb = (0, $3EDHG.default)`
  mutation AcceptTerms($customerId: String!) {
    acceptTerms(customerId: $customerId)
  }
`;
const $6fb6d9d18b595723$export$3ffbfad93dfcf6b0 = (0, $3EDHG.default)`
  query GetUserInfo($customerId: String!) {
    getTermsState(customerId: $customerId) {
      accepted
    }
    getCustomerAssignments(customerId: $customerId) {
      perform
    }
  }
`;

});

parcelRegister("4zZNZ", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $355a5f925842ac4b$export$af88d00dbe7f521; });

var $6tz0u = parcelRequire("6tz0u");
const $355a5f925842ac4b$export$af88d00dbe7f521 = {
    init: ()=>{
        (0, $6tz0u.init)({
            serviceName: 'mcp-survey-ui',
            serverUrl: 'https://partner-operations.apm.ece.legogroup.io',
            environment: "production",
            propagateTracestate: true,
            breakdownMetrics: true,
            distributedTracingOrigins: [
                "https://3t3czji6fnhvvpbebm5c4nmok4.appsync-api.eu-west-1.amazonaws.com/graphql"
            ],
            serviceVersion: "161d45fec3d2ef456543a9d7342dbef25d1bc425"
        });
    },
    logError: (error)=>{
        // eslint-disable-next-line no-console
        console.error(`AN ERROR OCCURRED: ${JSON.stringify(error)}`);
        (0, $6tz0u.apmBase).captureError(error);
    }
};

});
parcelRegister("6tz0u", function(module, exports) {

$parcel$export(module.exports, "apmBase", function () { return $4b709b245494fbbb$export$66cd81c234b843ce; });
$parcel$export(module.exports, "init", function () { return $4b709b245494fbbb$export$2cd8252107eb640b; });

var $1Ip47 = parcelRequire("1Ip47");
var $44gVE = parcelRequire("44gVE");
var $iCHUu = parcelRequire("iCHUu");

var $5uQ7h = parcelRequire("5uQ7h");
function $4b709b245494fbbb$var$getApmBase() {
    if ((0, $iCHUu.isBrowser) && window.elasticApm) return window.elasticApm;
    var enabled = (0, $1Ip47.bootstrap)();
    var serviceFactory = (0, $44gVE.createServiceFactory)();
    var apmBase = new (0, $5uQ7h.default)(serviceFactory, !enabled);
    if (0, $iCHUu.isBrowser) window.elasticApm = apmBase;
    return apmBase;
}
var $4b709b245494fbbb$export$66cd81c234b843ce = $4b709b245494fbbb$var$getApmBase();
var $4b709b245494fbbb$export$2cd8252107eb640b = $4b709b245494fbbb$export$66cd81c234b843ce.init.bind($4b709b245494fbbb$export$66cd81c234b843ce);
var $4b709b245494fbbb$export$2e2bcd8739ae039 = $4b709b245494fbbb$export$2cd8252107eb640b;

});
parcelRegister("1Ip47", function(module, exports) {

$parcel$export(module.exports, "bootstrap", function () { return $13fd57fb9a220d9d$export$36aff1fbb4f5dfc6; });

var $iCHUu = parcelRequire("iCHUu");

var $lQDSK = parcelRequire("lQDSK");

var $h1jmT = parcelRequire("h1jmT");
var $13fd57fb9a220d9d$var$enabled = false;
function $13fd57fb9a220d9d$export$36aff1fbb4f5dfc6() {
    if ((0, $iCHUu.isPlatformSupported)()) {
        (0, $lQDSK.patchAll)();
        (0, $h1jmT.state).bootstrapTime = (0, $iCHUu.now)();
        $13fd57fb9a220d9d$var$enabled = true;
    } else if (0, $iCHUu.isBrowser) console.log('[Elastic APM] platform is not supported!');
    return $13fd57fb9a220d9d$var$enabled;
}

});
parcelRegister("iCHUu", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $d8edd63e864156f9$export$4e09c449d6c407f7; });
$parcel$export(module.exports, "PERF", function () { return $d8edd63e864156f9$export$20dfe5c0db9ba10; });
$parcel$export(module.exports, "generateRandomId", function () { return $d8edd63e864156f9$export$59b2544ec352d56; });
$parcel$export(module.exports, "getDtHeaderValue", function () { return $d8edd63e864156f9$export$312052e2a8d615c6; });
$parcel$export(module.exports, "parseDtHeaderValue", function () { return $d8edd63e864156f9$export$86a08f9fd706a6b8; });
$parcel$export(module.exports, "isDtHeaderValid", function () { return $d8edd63e864156f9$export$a6f4cb80c241b86f; });
$parcel$export(module.exports, "getTSHeaderValue", function () { return $d8edd63e864156f9$export$6fbffd43bfec7ed8; });
$parcel$export(module.exports, "setRequestHeader", function () { return $d8edd63e864156f9$export$4a0dedceb084213c; });
$parcel$export(module.exports, "checkSameOrigin", function () { return $d8edd63e864156f9$export$8731073ee4364c34; });
$parcel$export(module.exports, "isPlatformSupported", function () { return $d8edd63e864156f9$export$69a8fd7b83cf9f89; });
$parcel$export(module.exports, "setLabel", function () { return $d8edd63e864156f9$export$4f65e594f6031297; });
$parcel$export(module.exports, "removeInvalidChars", function () { return $d8edd63e864156f9$export$fbffb0ac2c2ec159; });
$parcel$export(module.exports, "getServerTimingInfo", function () { return $d8edd63e864156f9$export$11b3928e177dda19; });
$parcel$export(module.exports, "stripQueryStringFromUrl", function () { return $d8edd63e864156f9$export$b3289ee923920b2a; });
$parcel$export(module.exports, "getCurrentScript", function () { return $d8edd63e864156f9$export$8fc24885882b6ead; });
$parcel$export(module.exports, "extend", function () { return $d8edd63e864156f9$export$8b58be045bf06082; });
$parcel$export(module.exports, "merge", function () { return $d8edd63e864156f9$export$4950aa0f605343fb; });
$parcel$export(module.exports, "isUndefined", function () { return $d8edd63e864156f9$export$fce6876652108ab; });
$parcel$export(module.exports, "noop", function () { return $d8edd63e864156f9$export$8793edee2d425525; });
$parcel$export(module.exports, "getLatestNonXHRSpan", function () { return $d8edd63e864156f9$export$4066158e069099c5; });
$parcel$export(module.exports, "getLatestXHRSpan", function () { return $d8edd63e864156f9$export$9db886af3c22d167; });
$parcel$export(module.exports, "getEarliestSpan", function () { return $d8edd63e864156f9$export$26335e41fd84043b; });
$parcel$export(module.exports, "now", function () { return $d8edd63e864156f9$export$461939dd4422153; });
$parcel$export(module.exports, "getTime", function () { return $d8edd63e864156f9$export$1428f42a7de81803; });
$parcel$export(module.exports, "getDuration", function () { return $d8edd63e864156f9$export$75bba95db5c3e753; });
$parcel$export(module.exports, "scheduleMicroTask", function () { return $d8edd63e864156f9$export$3262a5e6cc4c389e; });
$parcel$export(module.exports, "isPerfTimelineSupported", function () { return $d8edd63e864156f9$export$475e1d086d647d28; });
$parcel$export(module.exports, "isPerfTypeSupported", function () { return $d8edd63e864156f9$export$c043ff66aa95c00c; });
$parcel$export(module.exports, "isPerfInteractionCountSupported", function () { return $d8edd63e864156f9$export$759b2c522265ced; });
$parcel$export(module.exports, "isBeaconInspectionEnabled", function () { return $d8edd63e864156f9$export$7aca418b79512736; });
$parcel$export(module.exports, "isRedirectInfoAvailable", function () { return $d8edd63e864156f9$export$ffcb82e8b0e258ec; });

var $g76Dc = parcelRequire("g76Dc");
var $d8edd63e864156f9$var$slice = [].slice;
var $d8edd63e864156f9$export$4e09c449d6c407f7 = typeof window !== 'undefined';
var $d8edd63e864156f9$export$20dfe5c0db9ba10 = $d8edd63e864156f9$export$4e09c449d6c407f7 && typeof performance !== 'undefined' ? performance : {};
function $d8edd63e864156f9$export$98d4a615201428ae() {
    var xhr = new window.XMLHttpRequest();
    return 'withCredentials' in xhr;
}
var $d8edd63e864156f9$var$byteToHex = [];
for(var $d8edd63e864156f9$var$i = 0; $d8edd63e864156f9$var$i < 256; ++$d8edd63e864156f9$var$i)$d8edd63e864156f9$var$byteToHex[$d8edd63e864156f9$var$i] = ($d8edd63e864156f9$var$i + 0x100).toString(16).substr(1);
function $d8edd63e864156f9$export$58b867e287a802c8(buffer) {
    var hexOctets = [];
    for(var _i = 0; _i < buffer.length; _i++)hexOctets.push($d8edd63e864156f9$var$byteToHex[buffer[_i]]);
    return hexOctets.join('');
}
var $d8edd63e864156f9$var$destination = new Uint8Array(16);
function $d8edd63e864156f9$export$cd94982b18c6332c() {
    if (typeof crypto != 'undefined' && typeof crypto.getRandomValues == 'function') return crypto.getRandomValues($d8edd63e864156f9$var$destination);
    else if (typeof msCrypto != 'undefined' && typeof msCrypto.getRandomValues == 'function') return msCrypto.getRandomValues($d8edd63e864156f9$var$destination);
    return $d8edd63e864156f9$var$destination;
}
function $d8edd63e864156f9$export$59b2544ec352d56(length) {
    var id = $d8edd63e864156f9$export$58b867e287a802c8($d8edd63e864156f9$export$cd94982b18c6332c());
    return id.substr(0, length);
}
function $d8edd63e864156f9$export$312052e2a8d615c6(span) {
    var dtVersion = '00';
    var dtUnSampledFlags = '00';
    var dtSampledFlags = '01';
    if (span && span.traceId && span.id && span.parentId) {
        var flags = span.sampled ? dtSampledFlags : dtUnSampledFlags;
        var id = span.sampled ? span.id : span.parentId;
        return dtVersion + '-' + span.traceId + '-' + id + '-' + flags;
    }
}
function $d8edd63e864156f9$export$86a08f9fd706a6b8(value) {
    var parsed = /^([\da-f]{2})-([\da-f]{32})-([\da-f]{16})-([\da-f]{2})$/.exec(value);
    if (parsed) {
        var flags = parsed[4];
        var sampled = flags !== '00';
        return {
            traceId: parsed[2],
            id: parsed[3],
            sampled: sampled
        };
    }
}
function $d8edd63e864156f9$export$a6f4cb80c241b86f(header) {
    return /^[\da-f]{2}-[\da-f]{32}-[\da-f]{16}-[\da-f]{2}$/.test(header) && header.slice(3, 35) !== '00000000000000000000000000000000' && header.slice(36, 52) !== '0000000000000000';
}
function $d8edd63e864156f9$export$6fbffd43bfec7ed8(_ref) {
    var sampleRate = _ref.sampleRate;
    if (typeof sampleRate !== 'number' || String(sampleRate).length > 256) return;
    var NAMESPACE = 'es';
    var SEPARATOR = '=';
    return "" + NAMESPACE + SEPARATOR + "s:" + sampleRate;
}
function $d8edd63e864156f9$export$4a0dedceb084213c(target, name, value) {
    if (typeof target.setRequestHeader === 'function') target.setRequestHeader(name, value);
    else if (target.headers && typeof target.headers.append === 'function') target.headers.append(name, value);
    else target[name] = value;
}
function $d8edd63e864156f9$export$8731073ee4364c34(source, target) {
    var isSame = false;
    if (typeof target === 'string') isSame = source === target;
    else if (target && typeof target.test === 'function') isSame = target.test(source);
    else if (Array.isArray(target)) target.forEach(function(t) {
        if (!isSame) isSame = $d8edd63e864156f9$export$8731073ee4364c34(source, t);
    });
    return isSame;
}
function $d8edd63e864156f9$export$69a8fd7b83cf9f89() {
    return $d8edd63e864156f9$export$4e09c449d6c407f7 && typeof Set === 'function' && typeof JSON.stringify === 'function' && $d8edd63e864156f9$export$20dfe5c0db9ba10 && typeof $d8edd63e864156f9$export$20dfe5c0db9ba10.now === 'function' && $d8edd63e864156f9$export$98d4a615201428ae();
}
function $d8edd63e864156f9$export$4f65e594f6031297(key, value, obj) {
    if (!obj || !key) return;
    var skey = $d8edd63e864156f9$export$fbffb0ac2c2ec159(key);
    var valueType = typeof value;
    if (value != undefined && valueType !== 'boolean' && valueType !== 'number') value = String(value);
    obj[skey] = value;
    return obj;
}
function $d8edd63e864156f9$export$11b3928e177dda19(serverTimingEntries) {
    if (serverTimingEntries === void 0) serverTimingEntries = [];
    var serverTimingInfo = [];
    var entrySeparator = ', ';
    var valueSeparator = ';';
    for(var _i2 = 0; _i2 < serverTimingEntries.length; _i2++){
        var _serverTimingEntries$ = serverTimingEntries[_i2], name = _serverTimingEntries$.name, duration = _serverTimingEntries$.duration, description = _serverTimingEntries$.description;
        var timingValue = name;
        if (description) timingValue += valueSeparator + 'desc=' + description;
        if (duration) timingValue += valueSeparator + 'dur=' + duration;
        serverTimingInfo.push(timingValue);
    }
    return serverTimingInfo.join(entrySeparator);
}
function $d8edd63e864156f9$export$e752b05e58096a2f() {
    return $d8edd63e864156f9$export$20dfe5c0db9ba10.timing.fetchStart;
}
function $d8edd63e864156f9$export$b3289ee923920b2a(url) {
    return url && url.split('?')[0];
}
function $d8edd63e864156f9$export$a6cdc56e425d0d0a(value) {
    return value !== null && typeof value === 'object';
}
function $d8edd63e864156f9$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $d8edd63e864156f9$export$bf6cb145536e8bab(dst, objs, deep) {
    for(var i = 0, ii = objs.length; i < ii; ++i){
        var obj = objs[i];
        if (!$d8edd63e864156f9$export$a6cdc56e425d0d0a(obj) && !$d8edd63e864156f9$export$f6e2535fb5126e54(obj)) continue;
        var keys = Object.keys(obj);
        for(var j = 0, jj = keys.length; j < jj; j++){
            var key = keys[j];
            var src = obj[key];
            if (deep && $d8edd63e864156f9$export$a6cdc56e425d0d0a(src)) {
                if (!$d8edd63e864156f9$export$a6cdc56e425d0d0a(dst[key])) dst[key] = Array.isArray(src) ? [] : {};
                $d8edd63e864156f9$export$bf6cb145536e8bab(dst[key], [
                    src
                ], false);
            } else dst[key] = src;
        }
    }
    return dst;
}
function $d8edd63e864156f9$export$bf6fdd3c8902f077() {
    if (typeof document !== 'undefined') {
        var scripts = document.getElementsByTagName('script');
        for(var i = 0, l = scripts.length; i < l; i++){
            var sc = scripts[i];
            if (sc.src.indexOf('elastic') > 0) return sc;
        }
    }
}
function $d8edd63e864156f9$export$8fc24885882b6ead() {
    if (typeof document !== 'undefined') {
        var currentScript = document.currentScript;
        if (!currentScript) return $d8edd63e864156f9$export$bf6fdd3c8902f077();
        return currentScript;
    }
}
function $d8edd63e864156f9$export$8b58be045bf06082() {
    return $d8edd63e864156f9$export$bf6cb145536e8bab(Object.create(null), $d8edd63e864156f9$var$slice.call(arguments), false);
}
function $d8edd63e864156f9$export$4950aa0f605343fb() {
    return $d8edd63e864156f9$export$bf6cb145536e8bab(Object.create(null), $d8edd63e864156f9$var$slice.call(arguments), true);
}
function $d8edd63e864156f9$export$fce6876652108ab(obj) {
    return typeof obj === 'undefined';
}
function $d8edd63e864156f9$export$8793edee2d425525() {}
function $d8edd63e864156f9$export$71aa6c912b956294(array, predicate, thisArg) {
    if (array == null) throw new TypeError('array is null or not defined');
    var o = Object(array);
    var len = o.length >>> 0;
    if (typeof predicate !== 'function') throw new TypeError('predicate must be a function');
    var k = 0;
    while(k < len){
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) return kValue;
        k++;
    }
    return undefined;
}
function $d8edd63e864156f9$export$fbffb0ac2c2ec159(key) {
    return key.replace(/[.*"]/g, '_');
}
function $d8edd63e864156f9$var$getLatestSpan(spans, typeFilter) {
    var latestSpan = null;
    for(var _i3 = 0; _i3 < spans.length; _i3++){
        var span = spans[_i3];
        if (typeFilter && typeFilter(span.type) && (!latestSpan || latestSpan._end < span._end)) latestSpan = span;
    }
    return latestSpan;
}
function $d8edd63e864156f9$export$4066158e069099c5(spans) {
    return $d8edd63e864156f9$var$getLatestSpan(spans, function(type) {
        return String(type).indexOf('external') === -1;
    });
}
function $d8edd63e864156f9$export$9db886af3c22d167(spans) {
    return $d8edd63e864156f9$var$getLatestSpan(spans, function(type) {
        return String(type).indexOf('external') !== -1;
    });
}
function $d8edd63e864156f9$export$26335e41fd84043b(spans) {
    var earliestSpan = spans[0];
    for(var _i4 = 1; _i4 < spans.length; _i4++){
        var span = spans[_i4];
        if (earliestSpan._start > span._start) earliestSpan = span;
    }
    return earliestSpan;
}
function $d8edd63e864156f9$export$461939dd4422153() {
    return $d8edd63e864156f9$export$20dfe5c0db9ba10.now();
}
function $d8edd63e864156f9$export$1428f42a7de81803(time) {
    return typeof time === 'number' && time >= 0 ? time : $d8edd63e864156f9$export$461939dd4422153();
}
function $d8edd63e864156f9$export$75bba95db5c3e753(start, end) {
    if ($d8edd63e864156f9$export$fce6876652108ab(end) || $d8edd63e864156f9$export$fce6876652108ab(start)) return null;
    return parseInt(end - start);
}
function $d8edd63e864156f9$export$fbacb21386347f76(callback) {
    setTimeout(callback, 0);
}
function $d8edd63e864156f9$export$3262a5e6cc4c389e(callback) {
    (0, $g76Dc.Promise).resolve().then(callback);
}
function $d8edd63e864156f9$export$475e1d086d647d28() {
    return typeof $d8edd63e864156f9$export$20dfe5c0db9ba10.getEntriesByType === 'function';
}
function $d8edd63e864156f9$export$c043ff66aa95c00c(type) {
    return typeof PerformanceObserver !== 'undefined' && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.indexOf(type) >= 0;
}
function $d8edd63e864156f9$export$759b2c522265ced() {
    return 'interactionCount' in performance;
}
function $d8edd63e864156f9$export$7aca418b79512736() {
    var flagName = '_elastic_inspect_beacon_';
    if (sessionStorage.getItem(flagName) != null) return true;
    if (!window.URL || !window.URLSearchParams) return false;
    try {
        var parsedUrl = new URL(window.location.href);
        var isFlagSet = parsedUrl.searchParams.has(flagName);
        if (isFlagSet) sessionStorage.setItem(flagName, true);
        return isFlagSet;
    } catch (e) {}
    return false;
}
function $d8edd63e864156f9$export$ffcb82e8b0e258ec(timing) {
    return timing.redirectStart > 0;
}

});
parcelRegister("g76Dc", function(module, exports) {

$parcel$export(module.exports, "Promise", function () { return $bbb2719fb7886a63$export$775f0de60169233c; });

var $aszFm = parcelRequire("aszFm");

var $iCHUu = parcelRequire("iCHUu");
var $bbb2719fb7886a63$var$local = {};
if (0, $iCHUu.isBrowser) $bbb2719fb7886a63$var$local = window;
else if (typeof self !== 'undefined') $bbb2719fb7886a63$var$local = self;
var $bbb2719fb7886a63$export$775f0de60169233c = 'Promise' in $bbb2719fb7886a63$var$local ? $bbb2719fb7886a63$var$local.Promise : (0, $aszFm.default);

});
parcelRegister("aszFm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79d82f77ddb50303$export$2e2bcd8739ae039; });

var $873xc = parcelRequire("873xc");

var $ghCzG = parcelRequire("ghCzG");

var $g3IN6 = parcelRequire("g3IN6");
// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var $79d82f77ddb50303$var$setTimeoutFunc = setTimeout;
function $79d82f77ddb50303$var$isArray(x) {
    return Boolean(x && typeof x.length !== 'undefined');
}
function $79d82f77ddb50303$var$noop() {}
// Polyfill for Function.prototype.bind
function $79d82f77ddb50303$var$bind(fn, thisArg) {
    return function() {
        fn.apply(thisArg, arguments);
    };
}
/**
 * @constructor
 * @param {Function} fn
 */ function $79d82f77ddb50303$var$Promise(fn) {
    if (!(this instanceof $79d82f77ddb50303$var$Promise)) throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    /** @type {!number} */ this._state = 0;
    /** @type {!boolean} */ this._handled = false;
    /** @type {Promise|undefined} */ this._value = undefined;
    /** @type {!Array<!Function>} */ this._deferreds = [];
    $79d82f77ddb50303$var$doResolve(fn, this);
}
function $79d82f77ddb50303$var$handle(self, deferred) {
    while(self._state === 3)self = self._value;
    if (self._state === 0) {
        self._deferreds.push(deferred);
        return;
    }
    self._handled = true;
    $79d82f77ddb50303$var$Promise._immediateFn(function() {
        var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
        if (cb === null) {
            (self._state === 1 ? $79d82f77ddb50303$var$resolve : $79d82f77ddb50303$var$reject)(deferred.promise, self._value);
            return;
        }
        var ret;
        try {
            ret = cb(self._value);
        } catch (e) {
            $79d82f77ddb50303$var$reject(deferred.promise, e);
            return;
        }
        $79d82f77ddb50303$var$resolve(deferred.promise, ret);
    });
}
function $79d82f77ddb50303$var$resolve(self, newValue) {
    try {
        // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
        if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
        if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
            var then = newValue.then;
            if (newValue instanceof $79d82f77ddb50303$var$Promise) {
                self._state = 3;
                self._value = newValue;
                $79d82f77ddb50303$var$finale(self);
                return;
            } else if (typeof then === 'function') {
                $79d82f77ddb50303$var$doResolve($79d82f77ddb50303$var$bind(then, newValue), self);
                return;
            }
        }
        self._state = 1;
        self._value = newValue;
        $79d82f77ddb50303$var$finale(self);
    } catch (e) {
        $79d82f77ddb50303$var$reject(self, e);
    }
}
function $79d82f77ddb50303$var$reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    $79d82f77ddb50303$var$finale(self);
}
function $79d82f77ddb50303$var$finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) $79d82f77ddb50303$var$Promise._immediateFn(function() {
        if (!self._handled) $79d82f77ddb50303$var$Promise._unhandledRejectionFn(self._value);
    });
    for(var i = 0, len = self._deferreds.length; i < len; i++)$79d82f77ddb50303$var$handle(self, self._deferreds[i]);
    self._deferreds = null;
}
/**
 * @constructor
 */ function $79d82f77ddb50303$var$Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
}
/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */ function $79d82f77ddb50303$var$doResolve(fn, self) {
    var done = false;
    try {
        fn(function(value) {
            if (done) return;
            done = true;
            $79d82f77ddb50303$var$resolve(self, value);
        }, function(reason) {
            if (done) return;
            done = true;
            $79d82f77ddb50303$var$reject(self, reason);
        });
    } catch (ex) {
        if (done) return;
        done = true;
        $79d82f77ddb50303$var$reject(self, ex);
    }
}
$79d82f77ddb50303$var$Promise.prototype['catch'] = function(onRejected) {
    return this.then(null, onRejected);
};
$79d82f77ddb50303$var$Promise.prototype.then = function(onFulfilled, onRejected) {
    // @ts-ignore
    var prom = new this.constructor($79d82f77ddb50303$var$noop);
    $79d82f77ddb50303$var$handle(this, new $79d82f77ddb50303$var$Handler(onFulfilled, onRejected, prom));
    return prom;
};
$79d82f77ddb50303$var$Promise.prototype['finally'] = (0, $873xc.default);
$79d82f77ddb50303$var$Promise.all = function(arr) {
    return new $79d82f77ddb50303$var$Promise(function(resolve, reject) {
        if (!$79d82f77ddb50303$var$isArray(arr)) return reject(new TypeError('Promise.all accepts an array'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            try {
                if (val && (typeof val === 'object' || typeof val === 'function')) {
                    var then = val.then;
                    if (typeof then === 'function') {
                        then.call(val, function(val) {
                            res(i, val);
                        }, reject);
                        return;
                    }
                }
                args[i] = val;
                if (--remaining === 0) resolve(args);
            } catch (ex) {
                reject(ex);
            }
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
};
$79d82f77ddb50303$var$Promise.any = (0, $g3IN6.default);
$79d82f77ddb50303$var$Promise.allSettled = (0, $ghCzG.default);
$79d82f77ddb50303$var$Promise.resolve = function(value) {
    if (value && typeof value === 'object' && value.constructor === $79d82f77ddb50303$var$Promise) return value;
    return new $79d82f77ddb50303$var$Promise(function(resolve) {
        resolve(value);
    });
};
$79d82f77ddb50303$var$Promise.reject = function(value) {
    return new $79d82f77ddb50303$var$Promise(function(resolve, reject) {
        reject(value);
    });
};
$79d82f77ddb50303$var$Promise.race = function(arr) {
    return new $79d82f77ddb50303$var$Promise(function(resolve, reject) {
        if (!$79d82f77ddb50303$var$isArray(arr)) return reject(new TypeError('Promise.race accepts an array'));
        for(var i = 0, len = arr.length; i < len; i++)$79d82f77ddb50303$var$Promise.resolve(arr[i]).then(resolve, reject);
    });
};
// Use polyfill for setImmediate for performance gains
$79d82f77ddb50303$var$Promise._immediateFn = // @ts-ignore
typeof setImmediate === 'function' && function(fn) {
    // @ts-ignore
    setImmediate(fn);
} || function(fn) {
    $79d82f77ddb50303$var$setTimeoutFunc(fn, 0);
};
$79d82f77ddb50303$var$Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
};
var $79d82f77ddb50303$export$2e2bcd8739ae039 = $79d82f77ddb50303$var$Promise;

});
parcelRegister("873xc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e81b80afb8d55b3$export$2e2bcd8739ae039; });
/**
 * @this {Promise}
 */ function $5e81b80afb8d55b3$var$finallyConstructor(callback) {
    var constructor = this.constructor;
    return this.then(function(value) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            return value;
        });
    }, function(reason) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            // @ts-ignore
            return constructor.reject(reason);
        });
    });
}
var $5e81b80afb8d55b3$export$2e2bcd8739ae039 = $5e81b80afb8d55b3$var$finallyConstructor;

});

parcelRegister("ghCzG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdac27fe3f18c854$export$2e2bcd8739ae039; });
function $bdac27fe3f18c854$var$allSettled(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== 'undefined')) return reject(new TypeError(typeof arr + ' ' + arr + ' is not iterable(cannot read property Symbol(Symbol.iterator))'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            if (val && (typeof val === 'object' || typeof val === 'function')) {
                var then = val.then;
                if (typeof then === 'function') {
                    then.call(val, function(val) {
                        res(i, val);
                    }, function(e) {
                        args[i] = {
                            status: 'rejected',
                            reason: e
                        };
                        if (--remaining === 0) resolve(args);
                    });
                    return;
                }
            }
            args[i] = {
                status: 'fulfilled',
                value: val
            };
            if (--remaining === 0) resolve(args);
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
}
var $bdac27fe3f18c854$export$2e2bcd8739ae039 = $bdac27fe3f18c854$var$allSettled;

});

parcelRegister("g3IN6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb0fabb1ded9f4f2$export$2e2bcd8739ae039; });
/**
 * @constructor
 */ function $bb0fabb1ded9f4f2$var$AggregateError(errors, message) {
    this.name = 'AggregateError', this.errors = errors;
    this.message = message || '';
}
$bb0fabb1ded9f4f2$var$AggregateError.prototype = Error.prototype;
function $bb0fabb1ded9f4f2$var$any(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== 'undefined')) return reject(new TypeError('Promise.any accepts an array'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return reject();
        var rejectionReasons = [];
        for(var i = 0; i < args.length; i++)try {
            P.resolve(args[i]).then(resolve).catch(function(error) {
                rejectionReasons.push(error);
                if (rejectionReasons.length === args.length) reject(new $bb0fabb1ded9f4f2$var$AggregateError(rejectionReasons, 'All promises were rejected'));
            });
        } catch (ex) {
            reject(ex);
        }
    });
}
var $bb0fabb1ded9f4f2$export$2e2bcd8739ae039 = $bb0fabb1ded9f4f2$var$any;

});




parcelRegister("lQDSK", function(module, exports) {

$parcel$export(module.exports, "patchEventHandler", function () { return $fe7d640b9746a948$export$602cc6306ec009d8; });
$parcel$export(module.exports, "patchAll", function () { return $fe7d640b9746a948$export$94da54533f7f9289; });

var $bEDZV = parcelRequire("bEDZV");

var $3IMro = parcelRequire("3IMro");

var $5i4dt = parcelRequire("5i4dt");

var $hgvs9 = parcelRequire("hgvs9");

var $5YGG1 = parcelRequire("5YGG1");
var $fe7d640b9746a948$export$602cc6306ec009d8 = new (0, $hgvs9.default)();
var $fe7d640b9746a948$var$alreadyPatched = false;
function $fe7d640b9746a948$export$94da54533f7f9289() {
    if (!$fe7d640b9746a948$var$alreadyPatched) {
        $fe7d640b9746a948$var$alreadyPatched = true;
        (0, $bEDZV.patchXMLHttpRequest)(function(event, task) {
            $fe7d640b9746a948$export$602cc6306ec009d8.send((0, $5YGG1.XMLHTTPREQUEST), [
                event,
                task
            ]);
        });
        (0, $3IMro.patchFetch)(function(event, task) {
            $fe7d640b9746a948$export$602cc6306ec009d8.send((0, $5YGG1.FETCH), [
                event,
                task
            ]);
        });
        (0, $5i4dt.patchHistory)(function(event, task) {
            $fe7d640b9746a948$export$602cc6306ec009d8.send((0, $5YGG1.HISTORY), [
                event,
                task
            ]);
        });
    }
    return $fe7d640b9746a948$export$602cc6306ec009d8;
}

});
parcelRegister("bEDZV", function(module, exports) {

$parcel$export(module.exports, "patchXMLHttpRequest", function () { return $87c274ded62a4e01$export$41ed32b4ed20742; });

var $hfucu = parcelRequire("hfucu");

var $5YGG1 = parcelRequire("5YGG1");
function $87c274ded62a4e01$export$41ed32b4ed20742(callback) {
    var XMLHttpRequestPrototype = XMLHttpRequest.prototype;
    if (!XMLHttpRequestPrototype || !XMLHttpRequestPrototype[0, $5YGG1.ADD_EVENT_LISTENER_STR]) return;
    var READY_STATE_CHANGE = 'readystatechange';
    var LOAD = 'load';
    var ERROR = 'error';
    var TIMEOUT = 'timeout';
    var ABORT = 'abort';
    function invokeTask(task, status) {
        if (task.state !== (0, $5YGG1.INVOKE)) {
            task.state = (0, $5YGG1.INVOKE);
            task.data.status = status;
            callback((0, $5YGG1.INVOKE), task);
        }
    }
    function scheduleTask(task) {
        if (task.state === (0, $5YGG1.SCHEDULE)) return;
        task.state = (0, $5YGG1.SCHEDULE);
        callback((0, $5YGG1.SCHEDULE), task);
        var target = task.data.target;
        function addListener(name) {
            target[0, $5YGG1.ADD_EVENT_LISTENER_STR](name, function(_ref) {
                var type = _ref.type;
                if (type === READY_STATE_CHANGE) {
                    if (target.readyState === 4 && target.status !== 0) invokeTask(task, 'success');
                } else {
                    var status = type === LOAD ? 'success' : type;
                    invokeTask(task, status);
                }
            });
        }
        addListener(READY_STATE_CHANGE);
        addListener(LOAD);
        addListener(TIMEOUT);
        addListener(ERROR);
        addListener(ABORT);
    }
    var openNative = (0, $hfucu.patchMethod)(XMLHttpRequestPrototype, 'open', function() {
        return function(self, args) {
            if (!self[0, $hfucu.XHR_IGNORE]) {
                self[0, $hfucu.XHR_METHOD] = args[0];
                self[0, $hfucu.XHR_URL] = (args[1] || '').toString();
                self[0, $hfucu.XHR_SYNC] = args[2] === false;
            }
            return openNative.apply(self, args);
        };
    });
    var sendNative = (0, $hfucu.patchMethod)(XMLHttpRequestPrototype, 'send', function() {
        return function(self, args) {
            if (self[0, $hfucu.XHR_IGNORE]) return sendNative.apply(self, args);
            var task = {
                source: (0, $5YGG1.XMLHTTPREQUEST),
                state: '',
                type: 'macroTask',
                data: {
                    target: self,
                    method: self[0, $hfucu.XHR_METHOD],
                    sync: self[0, $hfucu.XHR_SYNC],
                    url: self[0, $hfucu.XHR_URL],
                    status: ''
                }
            };
            try {
                scheduleTask(task);
                return sendNative.apply(self, args);
            } catch (e) {
                invokeTask(task, ERROR);
                throw e;
            }
        };
    });
}

});
parcelRegister("hfucu", function(module, exports) {

$parcel$export(module.exports, "globalState", function () { return $c8eb4393e06ca519$export$8e769ad4338a911e; });
$parcel$export(module.exports, "patchMethod", function () { return $c8eb4393e06ca519$export$27a263d91197d790; });
$parcel$export(module.exports, "XHR_IGNORE", function () { return $c8eb4393e06ca519$export$1d2facecfc1955cc; });
$parcel$export(module.exports, "XHR_SYNC", function () { return $c8eb4393e06ca519$export$bda265647bf75488; });
$parcel$export(module.exports, "XHR_URL", function () { return $c8eb4393e06ca519$export$9a7ca3b2c2e97bd9; });
$parcel$export(module.exports, "XHR_METHOD", function () { return $c8eb4393e06ca519$export$90db053605542d02; });
var $c8eb4393e06ca519$export$8e769ad4338a911e = {
    fetchInProgress: false
};
function $c8eb4393e06ca519$export$652b0f25a523f48f(name) {
    return '__apm_symbol__' + name;
}
function $c8eb4393e06ca519$var$isPropertyWritable(propertyDesc) {
    if (!propertyDesc) return true;
    if (propertyDesc.writable === false) return false;
    return !(typeof propertyDesc.get === 'function' && typeof propertyDesc.set === 'undefined');
}
function $c8eb4393e06ca519$var$attachOriginToPatched(patched, original) {
    patched[$c8eb4393e06ca519$export$652b0f25a523f48f('OriginalDelegate')] = original;
}
function $c8eb4393e06ca519$export$27a263d91197d790(target, name, patchFn) {
    var proto = target;
    while(proto && !proto.hasOwnProperty(name))proto = Object.getPrototypeOf(proto);
    if (!proto && target[name]) proto = target;
    var delegateName = $c8eb4393e06ca519$export$652b0f25a523f48f(name);
    var delegate;
    if (proto && !(delegate = proto[delegateName])) {
        delegate = proto[delegateName] = proto[name];
        var desc = proto && Object.getOwnPropertyDescriptor(proto, name);
        if ($c8eb4393e06ca519$var$isPropertyWritable(desc)) {
            var patchDelegate = patchFn(delegate, delegateName, name);
            proto[name] = function() {
                return patchDelegate(this, arguments);
            };
            $c8eb4393e06ca519$var$attachOriginToPatched(proto[name], delegate);
        }
    }
    return delegate;
}
var $c8eb4393e06ca519$export$1d2facecfc1955cc = $c8eb4393e06ca519$export$652b0f25a523f48f('xhrIgnore');
var $c8eb4393e06ca519$export$bda265647bf75488 = $c8eb4393e06ca519$export$652b0f25a523f48f('xhrSync');
var $c8eb4393e06ca519$export$9a7ca3b2c2e97bd9 = $c8eb4393e06ca519$export$652b0f25a523f48f('xhrURL');
var $c8eb4393e06ca519$export$90db053605542d02 = $c8eb4393e06ca519$export$652b0f25a523f48f('xhrMethod');

});

parcelRegister("5YGG1", function(module, exports) {

$parcel$export(module.exports, "SCHEDULE", function () { return $45a3a90c21f36ab9$export$2cb68534ade458e0; });
$parcel$export(module.exports, "INVOKE", function () { return $45a3a90c21f36ab9$export$156c69d71663cf9e; });
$parcel$export(module.exports, "ADD_EVENT_LISTENER_STR", function () { return $45a3a90c21f36ab9$export$19be37673fbac3e8; });
$parcel$export(module.exports, "RESOURCE_INITIATOR_TYPES", function () { return $45a3a90c21f36ab9$export$fcac77ffb8211a1f; });
$parcel$export(module.exports, "REUSABILITY_THRESHOLD", function () { return $45a3a90c21f36ab9$export$1307ffda4f2726e8; });
$parcel$export(module.exports, "MAX_SPAN_DURATION", function () { return $45a3a90c21f36ab9$export$92d7cb2c71942fbd; });
$parcel$export(module.exports, "PAGE_LOAD_DELAY", function () { return $45a3a90c21f36ab9$export$b78d68e75d8e9dad; });
$parcel$export(module.exports, "PAGE_LOAD", function () { return $45a3a90c21f36ab9$export$1502f4f8c48fa539; });
$parcel$export(module.exports, "TYPE_CUSTOM", function () { return $45a3a90c21f36ab9$export$dd0e4c11f1ad6f76; });
$parcel$export(module.exports, "USER_INTERACTION", function () { return $45a3a90c21f36ab9$export$ca341a703d5e2151; });
$parcel$export(module.exports, "HTTP_REQUEST_TYPE", function () { return $45a3a90c21f36ab9$export$c774c31b4c31da8; });
$parcel$export(module.exports, "TEMPORARY_TYPE", function () { return $45a3a90c21f36ab9$export$c757be00d1bf3ef5; });
$parcel$export(module.exports, "NAME_UNKNOWN", function () { return $45a3a90c21f36ab9$export$f0eae82cd3ba085f; });
$parcel$export(module.exports, "PAGE_EXIT", function () { return $45a3a90c21f36ab9$export$2f2f0ccc41f2d4f6; });
$parcel$export(module.exports, "TRANSACTION_TYPE_ORDER", function () { return $45a3a90c21f36ab9$export$38ee95dde3859fb7; });
$parcel$export(module.exports, "OUTCOME_SUCCESS", function () { return $45a3a90c21f36ab9$export$ffae20858202e0de; });
$parcel$export(module.exports, "OUTCOME_FAILURE", function () { return $45a3a90c21f36ab9$export$a1656598af524751; });
$parcel$export(module.exports, "OUTCOME_UNKNOWN", function () { return $45a3a90c21f36ab9$export$f46af96a885f2c9b; });
$parcel$export(module.exports, "USER_TIMING_THRESHOLD", function () { return $45a3a90c21f36ab9$export$833fd3a4a36bef5e; });
$parcel$export(module.exports, "TRANSACTION_START", function () { return $45a3a90c21f36ab9$export$53ee6f7d651aa888; });
$parcel$export(module.exports, "TRANSACTION_END", function () { return $45a3a90c21f36ab9$export$3583e51eacab0340; });
$parcel$export(module.exports, "CONFIG_CHANGE", function () { return $45a3a90c21f36ab9$export$36257f40a0d30563; });
$parcel$export(module.exports, "QUEUE_FLUSH", function () { return $45a3a90c21f36ab9$export$19245af82a094556; });
$parcel$export(module.exports, "QUEUE_ADD_TRANSACTION", function () { return $45a3a90c21f36ab9$export$c11a56b9bfcb1d0f; });
$parcel$export(module.exports, "TRANSACTION_IGNORE", function () { return $45a3a90c21f36ab9$export$543fdf328f404af7; });
$parcel$export(module.exports, "XMLHTTPREQUEST", function () { return $45a3a90c21f36ab9$export$942b1c2707517311; });
$parcel$export(module.exports, "FETCH", function () { return $45a3a90c21f36ab9$export$4a07cffb9c3bc884; });
$parcel$export(module.exports, "HISTORY", function () { return $45a3a90c21f36ab9$export$149eb684a26496a2; });
$parcel$export(module.exports, "EVENT_TARGET", function () { return $45a3a90c21f36ab9$export$2c4d7da089dce968; });
$parcel$export(module.exports, "CLICK", function () { return $45a3a90c21f36ab9$export$cb5542418ddbb7ed; });
$parcel$export(module.exports, "ERROR", function () { return $45a3a90c21f36ab9$export$103bedf43ba882db; });
$parcel$export(module.exports, "BEFORE_EVENT", function () { return $45a3a90c21f36ab9$export$d75a03bca9277b83; });
$parcel$export(module.exports, "AFTER_EVENT", function () { return $45a3a90c21f36ab9$export$eeaba87877acb280; });
$parcel$export(module.exports, "LOCAL_CONFIG_KEY", function () { return $45a3a90c21f36ab9$export$f1f46202fdd81911; });
$parcel$export(module.exports, "LONG_TASK", function () { return $45a3a90c21f36ab9$export$fd2c36a5e8e50e04; });
$parcel$export(module.exports, "PAINT", function () { return $45a3a90c21f36ab9$export$ef5de76f1655b5ca; });
$parcel$export(module.exports, "MEASURE", function () { return $45a3a90c21f36ab9$export$20471946a1148a1b; });
$parcel$export(module.exports, "NAVIGATION", function () { return $45a3a90c21f36ab9$export$f52dcf7131a7f04; });
$parcel$export(module.exports, "RESOURCE", function () { return $45a3a90c21f36ab9$export$84ba8fa7099b85b; });
$parcel$export(module.exports, "FIRST_CONTENTFUL_PAINT", function () { return $45a3a90c21f36ab9$export$c2572a516b804ad3; });
$parcel$export(module.exports, "LARGEST_CONTENTFUL_PAINT", function () { return $45a3a90c21f36ab9$export$6de1676190bd73c4; });
$parcel$export(module.exports, "FIRST_INPUT", function () { return $45a3a90c21f36ab9$export$98085453dd812392; });
$parcel$export(module.exports, "LAYOUT_SHIFT", function () { return $45a3a90c21f36ab9$export$fc5ce9a4261f08e8; });
$parcel$export(module.exports, "EVENT", function () { return $45a3a90c21f36ab9$export$e39a34cfd532e15; });
$parcel$export(module.exports, "ERRORS", function () { return $45a3a90c21f36ab9$export$4fd720569787ab6f; });
$parcel$export(module.exports, "TRANSACTIONS", function () { return $45a3a90c21f36ab9$export$33e749855cc8f893; });
$parcel$export(module.exports, "CONFIG_SERVICE", function () { return $45a3a90c21f36ab9$export$11170dadd5705a7b; });
$parcel$export(module.exports, "LOGGING_SERVICE", function () { return $45a3a90c21f36ab9$export$7d973190a36b8246; });
$parcel$export(module.exports, "TRANSACTION_SERVICE", function () { return $45a3a90c21f36ab9$export$ab6389d1a16bebfe; });
$parcel$export(module.exports, "APM_SERVER", function () { return $45a3a90c21f36ab9$export$8f8a420bfb2d7e37; });
$parcel$export(module.exports, "PERFORMANCE_MONITORING", function () { return $45a3a90c21f36ab9$export$6a0f49a7699bafca; });
$parcel$export(module.exports, "ERROR_LOGGING", function () { return $45a3a90c21f36ab9$export$3bb4e88cf5c5fd65; });
$parcel$export(module.exports, "TRUNCATED_TYPE", function () { return $45a3a90c21f36ab9$export$58a4ef0ce68953f5; });
$parcel$export(module.exports, "KEYWORD_LIMIT", function () { return $45a3a90c21f36ab9$export$1ef49423f809800e; });
$parcel$export(module.exports, "SESSION_TIMEOUT", function () { return $45a3a90c21f36ab9$export$c74ee24a01db1ae5; });
$parcel$export(module.exports, "HTTP_REQUEST_TIMEOUT", function () { return $45a3a90c21f36ab9$export$304f7f334b3888b0; });
var $45a3a90c21f36ab9$export$2cb68534ade458e0 = 'schedule';
var $45a3a90c21f36ab9$export$156c69d71663cf9e = 'invoke';
var $45a3a90c21f36ab9$export$19be37673fbac3e8 = 'addEventListener';
var $45a3a90c21f36ab9$export$2d40f446af293d52 = 'removeEventListener';
var $45a3a90c21f36ab9$export$fcac77ffb8211a1f = [
    'link',
    'css',
    'script',
    'img',
    'xmlhttprequest',
    'fetch',
    'beacon',
    'iframe'
];
var $45a3a90c21f36ab9$export$1307ffda4f2726e8 = 5000;
var $45a3a90c21f36ab9$export$92d7cb2c71942fbd = 300000;
var $45a3a90c21f36ab9$export$b78d68e75d8e9dad = 1000;
var $45a3a90c21f36ab9$export$1502f4f8c48fa539 = 'page-load';
var $45a3a90c21f36ab9$export$e9e58a8c189b78b1 = 'route-change';
var $45a3a90c21f36ab9$export$dd0e4c11f1ad6f76 = 'custom';
var $45a3a90c21f36ab9$export$ca341a703d5e2151 = 'user-interaction';
var $45a3a90c21f36ab9$export$c774c31b4c31da8 = 'http-request';
var $45a3a90c21f36ab9$export$c757be00d1bf3ef5 = 'temporary';
var $45a3a90c21f36ab9$export$f0eae82cd3ba085f = 'Unknown';
var $45a3a90c21f36ab9$export$2f2f0ccc41f2d4f6 = 'page-exit';
var $45a3a90c21f36ab9$export$38ee95dde3859fb7 = [
    $45a3a90c21f36ab9$export$1502f4f8c48fa539,
    $45a3a90c21f36ab9$export$e9e58a8c189b78b1,
    $45a3a90c21f36ab9$export$ca341a703d5e2151,
    $45a3a90c21f36ab9$export$c774c31b4c31da8,
    $45a3a90c21f36ab9$export$dd0e4c11f1ad6f76,
    $45a3a90c21f36ab9$export$c757be00d1bf3ef5
];
var $45a3a90c21f36ab9$export$ffae20858202e0de = 'success';
var $45a3a90c21f36ab9$export$a1656598af524751 = 'failure';
var $45a3a90c21f36ab9$export$f46af96a885f2c9b = 'unknown';
var $45a3a90c21f36ab9$export$833fd3a4a36bef5e = 60;
var $45a3a90c21f36ab9$export$53ee6f7d651aa888 = 'transaction:start';
var $45a3a90c21f36ab9$export$3583e51eacab0340 = 'transaction:end';
var $45a3a90c21f36ab9$export$36257f40a0d30563 = 'config:change';
var $45a3a90c21f36ab9$export$19245af82a094556 = 'queue:flush';
var $45a3a90c21f36ab9$export$c11a56b9bfcb1d0f = 'queue:add_transaction';
var $45a3a90c21f36ab9$export$543fdf328f404af7 = 'transaction:ignore';
var $45a3a90c21f36ab9$export$942b1c2707517311 = 'xmlhttprequest';
var $45a3a90c21f36ab9$export$4a07cffb9c3bc884 = 'fetch';
var $45a3a90c21f36ab9$export$149eb684a26496a2 = 'history';
var $45a3a90c21f36ab9$export$2c4d7da089dce968 = 'eventtarget';
var $45a3a90c21f36ab9$export$cb5542418ddbb7ed = 'click';
var $45a3a90c21f36ab9$export$103bedf43ba882db = 'error';
var $45a3a90c21f36ab9$export$d75a03bca9277b83 = ':before';
var $45a3a90c21f36ab9$export$eeaba87877acb280 = ':after';
var $45a3a90c21f36ab9$export$f1f46202fdd81911 = 'elastic_apm_config';
var $45a3a90c21f36ab9$export$fd2c36a5e8e50e04 = 'longtask';
var $45a3a90c21f36ab9$export$ef5de76f1655b5ca = 'paint';
var $45a3a90c21f36ab9$export$20471946a1148a1b = 'measure';
var $45a3a90c21f36ab9$export$f52dcf7131a7f04 = 'navigation';
var $45a3a90c21f36ab9$export$84ba8fa7099b85b = 'resource';
var $45a3a90c21f36ab9$export$c2572a516b804ad3 = 'first-contentful-paint';
var $45a3a90c21f36ab9$export$6de1676190bd73c4 = 'largest-contentful-paint';
var $45a3a90c21f36ab9$export$98085453dd812392 = 'first-input';
var $45a3a90c21f36ab9$export$fc5ce9a4261f08e8 = 'layout-shift';
var $45a3a90c21f36ab9$export$e39a34cfd532e15 = 'event';
var $45a3a90c21f36ab9$export$4fd720569787ab6f = 'errors';
var $45a3a90c21f36ab9$export$33e749855cc8f893 = 'transactions';
var $45a3a90c21f36ab9$export$11170dadd5705a7b = 'ConfigService';
var $45a3a90c21f36ab9$export$7d973190a36b8246 = 'LoggingService';
var $45a3a90c21f36ab9$export$ab6389d1a16bebfe = 'TransactionService';
var $45a3a90c21f36ab9$export$8f8a420bfb2d7e37 = 'ApmServer';
var $45a3a90c21f36ab9$export$6a0f49a7699bafca = 'PerformanceMonitoring';
var $45a3a90c21f36ab9$export$3bb4e88cf5c5fd65 = 'ErrorLogging';
var $45a3a90c21f36ab9$export$58a4ef0ce68953f5 = '.truncated';
var $45a3a90c21f36ab9$export$1ef49423f809800e = 1024;
var $45a3a90c21f36ab9$export$c74ee24a01db1ae5 = 1800000;
var $45a3a90c21f36ab9$export$304f7f334b3888b0 = 10000;

});


parcelRegister("3IMro", function(module, exports) {

$parcel$export(module.exports, "patchFetch", function () { return $2b5b0e8476c18656$export$28f71c1f202028d4; });

var $g76Dc = parcelRequire("g76Dc");

var $hfucu = parcelRequire("hfucu");

var $5YGG1 = parcelRequire("5YGG1");

var $iCHUu = parcelRequire("iCHUu");

var $9Vat7 = parcelRequire("9Vat7");
function $2b5b0e8476c18656$export$28f71c1f202028d4(callback) {
    if (!(0, $9Vat7.isFetchSupported)()) return;
    function scheduleTask(task) {
        task.state = (0, $5YGG1.SCHEDULE);
        callback((0, $5YGG1.SCHEDULE), task);
    }
    function invokeTask(task) {
        task.state = (0, $5YGG1.INVOKE);
        callback((0, $5YGG1.INVOKE), task);
    }
    function handleResponseError(task, error) {
        task.data.aborted = $2b5b0e8476c18656$var$isAbortError(error);
        task.data.error = error;
        invokeTask(task);
    }
    function readStream(stream, task) {
        var reader = stream.getReader();
        var _read = function read() {
            reader.read().then(function(_ref) {
                var done = _ref.done;
                if (done) invokeTask(task);
                else _read();
            }, function(error) {
                handleResponseError(task, error);
            });
        };
        _read();
    }
    var nativeFetch = window.fetch;
    window.fetch = function(input, init) {
        var fetchSelf = this;
        var args = arguments;
        var request, url;
        var isURL = input instanceof URL;
        if (typeof input === 'string' || isURL) {
            request = new Request(input, init);
            if (isURL) url = request.url;
            else url = input;
        } else if (input) {
            request = new Request(input, init);
            url = request.url;
        } else return nativeFetch.apply(fetchSelf, args);
        var task = {
            source: (0, $5YGG1.FETCH),
            state: '',
            type: 'macroTask',
            data: {
                target: request,
                method: request.method,
                url: url,
                aborted: false
            }
        };
        return new (0, $g76Dc.Promise)(function(resolve, reject) {
            (0, $hfucu.globalState).fetchInProgress = true;
            scheduleTask(task);
            var promise;
            try {
                promise = nativeFetch.apply(fetchSelf, [
                    request
                ]);
            } catch (error) {
                reject(error);
                task.data.error = error;
                invokeTask(task);
                (0, $hfucu.globalState).fetchInProgress = false;
                return;
            }
            promise.then(function(response) {
                var clonedResponse = response.clone ? response.clone() : {};
                resolve(response);
                (0, $iCHUu.scheduleMicroTask)(function() {
                    task.data.response = response;
                    var body = clonedResponse.body;
                    if (body) readStream(body, task);
                    else invokeTask(task);
                });
            }, function(error) {
                reject(error);
                (0, $iCHUu.scheduleMicroTask)(function() {
                    handleResponseError(task, error);
                });
            });
            (0, $hfucu.globalState).fetchInProgress = false;
        });
    };
}
function $2b5b0e8476c18656$var$isAbortError(error) {
    return error && error.name === 'AbortError';
}

});
parcelRegister("9Vat7", function(module, exports) {

$parcel$export(module.exports, "shouldUseFetchWithKeepAlive", function () { return $73918ec67e431545$export$7671e9773d28088a; });
$parcel$export(module.exports, "isFetchSupported", function () { return $73918ec67e431545$export$f8c1c61350d9749; });
$parcel$export(module.exports, "sendFetchRequest", function () { return $73918ec67e431545$export$de4ef9c2599856d6; });

var $5YGG1 = parcelRequire("5YGG1");

var $2Q2VM = parcelRequire("2Q2VM");
function $73918ec67e431545$var$_extends() {
    return $73918ec67e431545$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $73918ec67e431545$var$_extends.apply(null, arguments);
}
var $73918ec67e431545$export$1080ec02d04a92c0 = 60000;
function $73918ec67e431545$export$7671e9773d28088a(method, payload) {
    if (!$73918ec67e431545$export$f8c1c61350d9749()) return false;
    var isKeepAliveSupported = 'keepalive' in new Request('');
    if (!isKeepAliveSupported) return false;
    var size = $73918ec67e431545$var$calculateSize(payload);
    return method === 'POST' && size < $73918ec67e431545$export$1080ec02d04a92c0;
}
function $73918ec67e431545$export$de4ef9c2599856d6(method, url, _ref) {
    var _ref$keepalive = _ref.keepalive, keepalive = _ref$keepalive === void 0 ? false : _ref$keepalive, _ref$timeout = _ref.timeout, timeout = _ref$timeout === void 0 ? (0, $5YGG1.HTTP_REQUEST_TIMEOUT) : _ref$timeout, payload = _ref.payload, headers = _ref.headers, sendCredentials = _ref.sendCredentials;
    var timeoutConfig = {};
    if (typeof AbortController === 'function') {
        var controller = new AbortController();
        timeoutConfig.signal = controller.signal;
        setTimeout(function() {
            return controller.abort();
        }, timeout);
    }
    var fetchResponse;
    return window.fetch(url, $73918ec67e431545$var$_extends({
        body: payload,
        headers: headers,
        method: method,
        keepalive: keepalive,
        credentials: sendCredentials ? 'include' : 'omit'
    }, timeoutConfig)).then(function(response) {
        fetchResponse = response;
        return fetchResponse.text();
    }).then(function(responseText) {
        var bodyResponse = {
            url: url,
            status: fetchResponse.status,
            responseText: responseText
        };
        if (!(0, $2Q2VM.isResponseSuccessful)(fetchResponse.status)) throw bodyResponse;
        return bodyResponse;
    });
}
function $73918ec67e431545$export$f8c1c61350d9749() {
    return typeof window.fetch === 'function' && typeof window.Request === 'function';
}
function $73918ec67e431545$var$calculateSize(payload) {
    if (!payload) return 0;
    if (payload instanceof Blob) return payload.size;
    return new Blob([
        payload
    ]).size;
}

});
parcelRegister("2Q2VM", function(module, exports) {

$parcel$export(module.exports, "isResponseSuccessful", function () { return $2112b61b6b9bb9e6$export$1f29f0bf55f6a59e; });
function $2112b61b6b9bb9e6$export$1f29f0bf55f6a59e(status) {
    if (status === 0 || status > 399 && status < 600) return false;
    return true;
}

});



parcelRegister("5i4dt", function(module, exports) {

$parcel$export(module.exports, "patchHistory", function () { return $3da1e77391325cef$export$1c3c71cac9d1d555; });

var $5YGG1 = parcelRequire("5YGG1");
function $3da1e77391325cef$export$1c3c71cac9d1d555(callback) {
    if (!window.history) return;
    var nativePushState = history.pushState;
    if (typeof nativePushState === 'function') history.pushState = function(state, title, url) {
        var task = {
            source: (0, $5YGG1.HISTORY),
            data: {
                state: state,
                title: title,
                url: url
            }
        };
        callback((0, $5YGG1.INVOKE), task);
        nativePushState.apply(this, arguments);
    };
}

});

parcelRegister("hgvs9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c91c5439f152647f$export$2e2bcd8739ae039; });

var $5YGG1 = parcelRequire("5YGG1");
var $c91c5439f152647f$var$EventHandler = function() {
    function EventHandler() {
        this.observers = {};
    }
    var _proto = EventHandler.prototype;
    _proto.observe = function observe(name, fn) {
        var _this = this;
        if (typeof fn === 'function') {
            if (!this.observers[name]) this.observers[name] = [];
            this.observers[name].push(fn);
            return function() {
                var index = _this.observers[name].indexOf(fn);
                if (index > -1) _this.observers[name].splice(index, 1);
            };
        }
    };
    _proto.sendOnly = function sendOnly(name, args) {
        var obs = this.observers[name];
        if (obs) obs.forEach(function(fn) {
            try {
                fn.apply(undefined, args);
            } catch (error) {
                console.log(error, error.stack);
            }
        });
    };
    _proto.send = function send(name, args) {
        this.sendOnly(name + (0, $5YGG1.BEFORE_EVENT), args);
        this.sendOnly(name, args);
        this.sendOnly(name + (0, $5YGG1.AFTER_EVENT), args);
    };
    return EventHandler;
}();
var $c91c5439f152647f$export$2e2bcd8739ae039 = $c91c5439f152647f$var$EventHandler;

});


parcelRegister("h1jmT", function(module, exports) {

$parcel$export(module.exports, "__DEV__", function () { return $c6418dcad09e88df$export$a866f231438cc228; });
$parcel$export(module.exports, "state", function () { return $c6418dcad09e88df$export$ca000e230c0caa3e; });
var $c6418dcad09e88df$export$a866f231438cc228 = false;
var $c6418dcad09e88df$export$ca000e230c0caa3e = {
    bootstrapTime: null,
    lastHiddenStart: Number.MIN_SAFE_INTEGER
};

});


parcelRegister("44gVE", function(module, exports) {

$parcel$export(module.exports, "createServiceFactory", function () { return $2f64aae18f449827$export$791d8bdb130abda4; });

var $6HFHC = parcelRequire("6HFHC");

var $kTzau = parcelRequire("kTzau");
var $aJXxB = parcelRequire("aJXxB");

var $feGtA = parcelRequire("feGtA");

var $iCHUu = parcelRequire("iCHUu");


var $aDuuy = parcelRequire("aDuuy");
var $fixS9 = parcelRequire("fixS9");

var $5YGG1 = parcelRequire("5YGG1");

var $g6EEc = parcelRequire("g6EEc");

var $arZea = parcelRequire("arZea");

var $1Ip47 = parcelRequire("1Ip47");

function $2f64aae18f449827$export$791d8bdb130abda4() {
    (0, $aJXxB.registerServices)();
    (0, $6HFHC.registerServices)();
    var serviceFactory = new (0, $feGtA.ServiceFactory)();
    return serviceFactory;
}

});
parcelRegister("6HFHC", function(module, exports) {

$parcel$export(module.exports, "registerServices", function () { return $4e171b7b876dbc43$export$174fd5f90dd8a5db; });

var $eM1WW = parcelRequire("eM1WW");

var $5YGG1 = parcelRequire("5YGG1");

var $feGtA = parcelRequire("feGtA");
function $4e171b7b876dbc43$export$174fd5f90dd8a5db() {
    (0, $feGtA.serviceCreators)[0, $5YGG1.ERROR_LOGGING] = function(serviceFactory) {
        var _serviceFactory$getSe = serviceFactory.getService([
            (0, $5YGG1.APM_SERVER),
            (0, $5YGG1.CONFIG_SERVICE),
            (0, $5YGG1.TRANSACTION_SERVICE)
        ]), apmServer = _serviceFactory$getSe[0], configService = _serviceFactory$getSe[1], transactionService = _serviceFactory$getSe[2];
        return new (0, $eM1WW.default)(apmServer, configService, transactionService);
    };
}

});
parcelRegister("eM1WW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac170f90aa179736$export$2e2bcd8739ae039; });

var $8v2TQ = parcelRequire("8v2TQ");

var $iCHUu = parcelRequire("iCHUu");

var $4E03a = parcelRequire("4E03a");

var $jyXJ6 = parcelRequire("jyXJ6");

var $exbHh = parcelRequire("exbHh");
var $ac170f90aa179736$var$_excluded = [
    "tags"
];
function $ac170f90aa179736$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $ac170f90aa179736$var$IGNORE_KEYS = [
    'stack',
    'message'
];
var $ac170f90aa179736$var$PROMISE_REJECTION_PREFIX = 'Unhandled promise rejection: ';
function $ac170f90aa179736$var$getErrorProperties(error) {
    var propertyFound = false;
    var properties = {};
    Object.keys(error).forEach(function(key) {
        if ($ac170f90aa179736$var$IGNORE_KEYS.indexOf(key) >= 0) return;
        var val = error[key];
        if (val == null || typeof val === 'function') return;
        if (typeof val === 'object') {
            if (typeof val.toISOString !== 'function') return;
            val = val.toISOString();
        }
        properties[key] = val;
        propertyFound = true;
    });
    if (propertyFound) return properties;
}
var $ac170f90aa179736$var$ErrorLogging = function() {
    function ErrorLogging(apmServer, configService, transactionService) {
        this._apmServer = apmServer;
        this._configService = configService;
        this._transactionService = transactionService;
    }
    var _proto = ErrorLogging.prototype;
    _proto.createErrorDataModel = function createErrorDataModel(errorEvent, opts) {
        var frames = (0, $8v2TQ.createStackTraces)((0, (/*@__PURE__*/$parcel$interopDefault($exbHh))), errorEvent);
        var filteredFrames = (0, $8v2TQ.filterInvalidFrames)(frames);
        var culprit = '(inline script)';
        var lastFrame = filteredFrames[filteredFrames.length - 1];
        if (lastFrame && lastFrame.filename) culprit = lastFrame.filename;
        var message = errorEvent.message, error = errorEvent.error;
        var errorMessage = message;
        var errorType = '';
        var errorContext = {};
        if (error && typeof error === 'object') {
            errorMessage = errorMessage || error.message;
            errorType = error.name;
            var customProperties = $ac170f90aa179736$var$getErrorProperties(error);
            if (customProperties) errorContext.custom = customProperties;
        }
        if (opts && opts.labels) {
            var keys = Object.keys(opts.labels);
            errorContext.tags = {};
            keys.forEach(function(k) {
                return (0, $iCHUu.setLabel)(k, opts.labels[k], errorContext.tags);
            });
        }
        if (!errorType) {
            if (errorMessage && errorMessage.indexOf(':') > -1) errorType = errorMessage.split(':')[0];
        }
        var currentTransaction = this._transactionService.getCurrentTransaction();
        var transactionContext = currentTransaction ? currentTransaction.context : {};
        var _this$_configService$ = this._configService.get('context'), tags = _this$_configService$.tags, configContext = $ac170f90aa179736$var$_objectWithoutPropertiesLoose(_this$_configService$, $ac170f90aa179736$var$_excluded);
        var pageContext = (0, $4E03a.getPageContext)();
        var context = (0, $iCHUu.merge)({}, pageContext, transactionContext, configContext, errorContext);
        var errorObject = {
            id: (0, $iCHUu.generateRandomId)(),
            culprit: culprit,
            exception: {
                message: errorMessage,
                stacktrace: filteredFrames,
                type: errorType
            },
            context: context
        };
        if (currentTransaction) errorObject = (0, $iCHUu.extend)(errorObject, {
            trace_id: currentTransaction.traceId,
            parent_id: currentTransaction.id,
            transaction_id: currentTransaction.id,
            transaction: {
                type: currentTransaction.type,
                sampled: currentTransaction.sampled
            }
        });
        return (0, $jyXJ6.truncateModel)((0, $jyXJ6.ERROR_MODEL), errorObject);
    };
    _proto.logErrorEvent = function logErrorEvent(errorEvent, opts) {
        if (typeof errorEvent === 'undefined') return;
        var errorObject = this.createErrorDataModel(errorEvent, opts);
        if (typeof errorObject.exception.message === 'undefined') return;
        this._apmServer.addError(errorObject);
    };
    _proto.registerListeners = function registerListeners() {
        var _this = this;
        window.addEventListener('error', function(errorEvent) {
            return _this.logErrorEvent(errorEvent);
        });
        window.addEventListener('unhandledrejection', function(promiseRejectionEvent) {
            return _this.logPromiseEvent(promiseRejectionEvent);
        });
    };
    _proto.logPromiseEvent = function logPromiseEvent(promiseRejectionEvent) {
        var reason = promiseRejectionEvent.reason;
        if (reason == null) reason = '<no reason specified>';
        var errorEvent;
        if (typeof reason.message === 'string') {
            var name = reason.name ? reason.name + ': ' : '';
            errorEvent = {
                error: reason,
                message: $ac170f90aa179736$var$PROMISE_REJECTION_PREFIX + name + reason.message
            };
        } else errorEvent = this._parseRejectReason(reason);
        this.logErrorEvent(errorEvent);
    };
    _proto.logError = function logError(messageOrError, opts) {
        var errorEvent = {};
        if (typeof messageOrError === 'string') errorEvent.message = messageOrError;
        else errorEvent.error = messageOrError;
        return this.logErrorEvent(errorEvent, opts);
    };
    _proto._parseRejectReason = function _parseRejectReason(reason) {
        var errorEvent = {
            message: $ac170f90aa179736$var$PROMISE_REJECTION_PREFIX
        };
        if (Array.isArray(reason)) errorEvent.message += '<object>';
        else if (typeof reason === 'object') try {
            errorEvent.message += JSON.stringify(reason);
            errorEvent.error = reason;
        } catch (error) {
            errorEvent.message += '<object>';
        }
        else if (typeof reason === 'function') errorEvent.message += '<function>';
        else errorEvent.message += reason;
        return errorEvent;
    };
    return ErrorLogging;
}();
var $ac170f90aa179736$export$2e2bcd8739ae039 = $ac170f90aa179736$var$ErrorLogging;

});
parcelRegister("8v2TQ", function(module, exports) {

$parcel$export(module.exports, "createStackTraces", function () { return $630377cdb2a7c67d$export$8c8855196b9f04f8; });
$parcel$export(module.exports, "filterInvalidFrames", function () { return $630377cdb2a7c67d$export$388e43ae04f18461; });
function $630377cdb2a7c67d$var$filePathToFileName(fileUrl) {
    var origin = window.location.origin || window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    if (fileUrl.indexOf(origin) > -1) fileUrl = fileUrl.replace(origin + '/', '');
    return fileUrl;
}
function $630377cdb2a7c67d$var$cleanFilePath(filePath) {
    if (filePath === void 0) filePath = '';
    if (filePath === '<anonymous>') filePath = '';
    return filePath;
}
function $630377cdb2a7c67d$var$isFileInline(fileUrl) {
    if (fileUrl) return window.location.href.indexOf(fileUrl) === 0;
    return false;
}
function $630377cdb2a7c67d$var$normalizeStackFrames(stackFrames) {
    return stackFrames.map(function(frame) {
        if (frame.functionName) frame.functionName = $630377cdb2a7c67d$var$normalizeFunctionName(frame.functionName);
        return frame;
    });
}
function $630377cdb2a7c67d$var$normalizeFunctionName(fnName) {
    var parts = fnName.split('/');
    if (parts.length > 1) fnName = [
        'Object',
        parts[parts.length - 1]
    ].join('.');
    else fnName = parts[0];
    fnName = fnName.replace(/.<$/gi, '.<anonymous>');
    fnName = fnName.replace(/^Anonymous function$/, '<anonymous>');
    parts = fnName.split('.');
    if (parts.length > 1) fnName = parts[parts.length - 1];
    else fnName = parts[0];
    return fnName;
}
function $630377cdb2a7c67d$var$isValidStackTrace(stackTraces) {
    if (stackTraces.length === 0) return false;
    if (stackTraces.length === 1) {
        var stackTrace = stackTraces[0];
        return 'lineNumber' in stackTrace;
    }
    return true;
}
function $630377cdb2a7c67d$export$8c8855196b9f04f8(stackParser, errorEvent) {
    var error = errorEvent.error, filename = errorEvent.filename, lineno = errorEvent.lineno, colno = errorEvent.colno;
    var stackTraces = [];
    if (error) try {
        stackTraces = stackParser.parse(error);
    } catch (e) {}
    if (!$630377cdb2a7c67d$var$isValidStackTrace(stackTraces)) stackTraces = [
        {
            fileName: filename,
            lineNumber: lineno,
            columnNumber: colno
        }
    ];
    var normalizedStackTraces = $630377cdb2a7c67d$var$normalizeStackFrames(stackTraces);
    return normalizedStackTraces.map(function(stack) {
        var fileName = stack.fileName, lineNumber = stack.lineNumber, columnNumber = stack.columnNumber, _stack$functionName = stack.functionName, functionName = _stack$functionName === void 0 ? '<anonymous>' : _stack$functionName;
        if (!fileName && !lineNumber) return {};
        if (!columnNumber && !lineNumber) return {};
        var filePath = $630377cdb2a7c67d$var$cleanFilePath(fileName);
        var cleanedFileName = $630377cdb2a7c67d$var$filePathToFileName(filePath);
        if ($630377cdb2a7c67d$var$isFileInline(filePath)) cleanedFileName = '(inline script)';
        return {
            abs_path: fileName,
            filename: cleanedFileName,
            function: functionName,
            lineno: lineNumber,
            colno: columnNumber
        };
    });
}
function $630377cdb2a7c67d$export$388e43ae04f18461(frames) {
    return frames.filter(function(_ref) {
        var filename = _ref.filename, lineno = _ref.lineno;
        return typeof filename !== 'undefined' && typeof lineno !== 'undefined';
    });
}

});

parcelRegister("4E03a", function(module, exports) {

$parcel$export(module.exports, "getPageContext", function () { return $361aefca053dd6e4$export$1303843c2f44065a; });
$parcel$export(module.exports, "addSpanContext", function () { return $361aefca053dd6e4$export$ed109afa225aed5b; });
$parcel$export(module.exports, "addTransactionContext", function () { return $361aefca053dd6e4$export$d10ae57e760667a5; });

var $g7QM3 = parcelRequire("g7QM3");

var $5YGG1 = parcelRequire("5YGG1");

var $iCHUu = parcelRequire("iCHUu");
var $361aefca053dd6e4$var$_excluded = [
    "tags"
];
function $361aefca053dd6e4$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $361aefca053dd6e4$var$LEFT_SQUARE_BRACKET = 91;
var $361aefca053dd6e4$var$RIGHT_SQUARE_BRACKET = 93;
var $361aefca053dd6e4$var$EXTERNAL = 'external';
var $361aefca053dd6e4$var$RESOURCE = 'resource';
var $361aefca053dd6e4$var$HARD_NAVIGATION = 'hard-navigation';
function $361aefca053dd6e4$var$getPortNumber(port, protocol) {
    if (port === '') port = protocol === 'http:' ? '80' : protocol === 'https:' ? '443' : '';
    return port;
}
function $361aefca053dd6e4$var$getResponseContext(perfTimingEntry) {
    var transferSize = perfTimingEntry.transferSize, encodedBodySize = perfTimingEntry.encodedBodySize, decodedBodySize = perfTimingEntry.decodedBodySize, serverTiming = perfTimingEntry.serverTiming;
    var respContext = {
        transfer_size: transferSize,
        encoded_body_size: encodedBodySize,
        decoded_body_size: decodedBodySize
    };
    var serverTimingStr = (0, $iCHUu.getServerTimingInfo)(serverTiming);
    if (serverTimingStr) respContext.headers = {
        'server-timing': serverTimingStr
    };
    return respContext;
}
function $361aefca053dd6e4$var$getDestination(parsedUrl) {
    var port = parsedUrl.port, protocol = parsedUrl.protocol, hostname = parsedUrl.hostname;
    var portNumber = $361aefca053dd6e4$var$getPortNumber(port, protocol);
    var ipv6Hostname = hostname.charCodeAt(0) === $361aefca053dd6e4$var$LEFT_SQUARE_BRACKET && hostname.charCodeAt(hostname.length - 1) === $361aefca053dd6e4$var$RIGHT_SQUARE_BRACKET;
    var address = hostname;
    if (ipv6Hostname) address = hostname.slice(1, -1);
    return {
        service: {
            resource: hostname + ':' + portNumber,
            name: '',
            type: ''
        },
        address: address,
        port: Number(portNumber)
    };
}
function $361aefca053dd6e4$var$getResourceContext(data) {
    var entry = data.entry, url = data.url;
    var parsedUrl = new (0, $g7QM3.Url)(url);
    var destination = $361aefca053dd6e4$var$getDestination(parsedUrl);
    return {
        http: {
            url: url,
            response: $361aefca053dd6e4$var$getResponseContext(entry)
        },
        destination: destination
    };
}
function $361aefca053dd6e4$var$getExternalContext(data) {
    var url = data.url, method = data.method, target = data.target, response = data.response;
    var parsedUrl = new (0, $g7QM3.Url)(url);
    var destination = $361aefca053dd6e4$var$getDestination(parsedUrl);
    var context = {
        http: {
            method: method,
            url: parsedUrl.href
        },
        destination: destination
    };
    var statusCode;
    if (target && typeof target.status !== 'undefined') statusCode = target.status;
    else if (response) statusCode = response.status;
    context.http.status_code = statusCode;
    return context;
}
function $361aefca053dd6e4$var$getNavigationContext(data) {
    var url = data.url;
    var parsedUrl = new (0, $g7QM3.Url)(url);
    var destination = $361aefca053dd6e4$var$getDestination(parsedUrl);
    return {
        destination: destination
    };
}
function $361aefca053dd6e4$export$1303843c2f44065a() {
    return {
        page: {
            referer: document.referrer,
            url: location.href
        }
    };
}
function $361aefca053dd6e4$export$ed109afa225aed5b(span, data) {
    if (!data) return;
    var type = span.type;
    var context;
    switch(type){
        case $361aefca053dd6e4$var$EXTERNAL:
            context = $361aefca053dd6e4$var$getExternalContext(data);
            break;
        case $361aefca053dd6e4$var$RESOURCE:
            context = $361aefca053dd6e4$var$getResourceContext(data);
            break;
        case $361aefca053dd6e4$var$HARD_NAVIGATION:
            context = $361aefca053dd6e4$var$getNavigationContext(data);
            break;
    }
    span.addContext(context);
}
function $361aefca053dd6e4$export$d10ae57e760667a5(transaction, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, tags = _ref.tags, configContext = $361aefca053dd6e4$var$_objectWithoutPropertiesLoose(_ref, $361aefca053dd6e4$var$_excluded);
    var pageContext = $361aefca053dd6e4$export$1303843c2f44065a();
    var responseContext = {};
    if (transaction.type === (0, $5YGG1.PAGE_EXIT)) {
        transaction.ensureContext();
        if (transaction.context.page && transaction.context.page.url) pageContext.page.url = transaction.context.page.url;
    } else if (transaction.type === (0, $5YGG1.PAGE_LOAD) && (0, $iCHUu.isPerfTimelineSupported)()) {
        var entries = (0, $iCHUu.PERF).getEntriesByType((0, $5YGG1.NAVIGATION));
        if (entries && entries.length > 0) responseContext = {
            response: $361aefca053dd6e4$var$getResponseContext(entries[0])
        };
    }
    transaction.addContext(pageContext, responseContext, configContext);
}

});
parcelRegister("g7QM3", function(module, exports) {

$parcel$export(module.exports, "Url", function () { return $bbd63ca370fae56f$export$59d795186a5d3f58; });
$parcel$export(module.exports, "slugifyUrl", function () { return $bbd63ca370fae56f$export$456a5af62e4119f6; });

var $iCHUu = parcelRequire("iCHUu");
function $bbd63ca370fae56f$var$isDefaultPort(port, protocol) {
    switch(protocol){
        case 'http:':
            return port === '80';
        case 'https:':
            return port === '443';
    }
    return true;
}
var $bbd63ca370fae56f$var$RULES = [
    [
        '#',
        'hash'
    ],
    [
        '?',
        'query'
    ],
    [
        '/',
        'path'
    ],
    [
        '@',
        'auth',
        1
    ],
    [
        NaN,
        'host',
        undefined,
        1
    ]
];
var $bbd63ca370fae56f$var$PROTOCOL_REGEX = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i;
var $bbd63ca370fae56f$export$59d795186a5d3f58 = function() {
    function Url(url) {
        var _this$extractProtocol = this.extractProtocol(url || ''), protocol = _this$extractProtocol.protocol, address = _this$extractProtocol.address, slashes = _this$extractProtocol.slashes;
        var relative = !protocol && !slashes;
        var location = this.getLocation();
        var instructions = $bbd63ca370fae56f$var$RULES.slice();
        address = address.replace('\\', '/');
        if (!slashes) instructions[2] = [
            NaN,
            'path'
        ];
        var index;
        for(var i = 0; i < instructions.length; i++){
            var instruction = instructions[i];
            var parse = instruction[0];
            var key = instruction[1];
            if (typeof parse === 'string') {
                index = address.indexOf(parse);
                if (~index) {
                    var instLength = instruction[2];
                    if (instLength) {
                        var newIndex = address.lastIndexOf(parse);
                        index = Math.max(index, newIndex);
                        this[key] = address.slice(0, index);
                        address = address.slice(index + instLength);
                    } else {
                        this[key] = address.slice(index);
                        address = address.slice(0, index);
                    }
                }
            } else {
                this[key] = address;
                address = '';
            }
            this[key] = this[key] || (relative && instruction[3] ? location[key] || '' : '');
            if (instruction[3]) this[key] = this[key].toLowerCase();
        }
        if (relative && this.path.charAt(0) !== '/') this.path = '/' + this.path;
        this.relative = relative;
        this.protocol = protocol || location.protocol;
        this.hostname = this.host;
        this.port = '';
        if (/:\d+$/.test(this.host)) {
            var value = this.host.split(':');
            var port = value.pop();
            var hostname = value.join(':');
            if ($bbd63ca370fae56f$var$isDefaultPort(port, this.protocol)) this.host = hostname;
            else this.port = port;
            this.hostname = hostname;
        }
        this.origin = this.protocol && this.host && this.protocol !== 'file:' ? this.protocol + '//' + this.host : 'null';
        this.href = this.toString();
    }
    var _proto = Url.prototype;
    _proto.toString = function toString() {
        var result = this.protocol;
        result += '//';
        if (this.auth) {
            var REDACTED = '[REDACTED]';
            var userpass = this.auth.split(':');
            var username = userpass[0] ? REDACTED : '';
            var password = userpass[1] ? ':' + REDACTED : '';
            result += username + password + '@';
        }
        result += this.host;
        result += this.path;
        result += this.query;
        result += this.hash;
        return result;
    };
    _proto.getLocation = function getLocation() {
        var globalVar = {};
        if (0, $iCHUu.isBrowser) globalVar = window;
        return globalVar.location;
    };
    _proto.extractProtocol = function extractProtocol(url) {
        var match = $bbd63ca370fae56f$var$PROTOCOL_REGEX.exec(url);
        return {
            protocol: match[1] ? match[1].toLowerCase() : '',
            slashes: !!match[2],
            address: match[3]
        };
    };
    return Url;
}();
function $bbd63ca370fae56f$export$456a5af62e4119f6(urlStr, depth) {
    if (depth === void 0) depth = 2;
    var parsedUrl = new $bbd63ca370fae56f$export$59d795186a5d3f58(urlStr);
    var query = parsedUrl.query, path = parsedUrl.path;
    var pathParts = path.substring(1).split('/');
    var redactString = ':id';
    var wildcard = '*';
    var specialCharsRegex = /\W|_/g;
    var digitsRegex = /[0-9]/g;
    var lowerCaseRegex = /[a-z]/g;
    var upperCaseRegex = /[A-Z]/g;
    var redactedParts = [];
    var redactedBefore = false;
    for(var index = 0; index < pathParts.length; index++){
        var part = pathParts[index];
        if (redactedBefore || index > depth - 1) {
            if (part) redactedParts.push(wildcard);
            break;
        }
        var numberOfSpecialChars = (part.match(specialCharsRegex) || []).length;
        if (numberOfSpecialChars >= 2) {
            redactedParts.push(redactString);
            redactedBefore = true;
            continue;
        }
        var numberOfDigits = (part.match(digitsRegex) || []).length;
        if (numberOfDigits > 3 || part.length > 3 && numberOfDigits / part.length >= 0.3) {
            redactedParts.push(redactString);
            redactedBefore = true;
            continue;
        }
        var numberofUpperCase = (part.match(upperCaseRegex) || []).length;
        var numberofLowerCase = (part.match(lowerCaseRegex) || []).length;
        var lowerCaseRate = numberofLowerCase / part.length;
        var upperCaseRate = numberofUpperCase / part.length;
        if (part.length > 5 && (upperCaseRate > 0.3 && upperCaseRate < 0.6 || lowerCaseRate > 0.3 && lowerCaseRate < 0.6)) {
            redactedParts.push(redactString);
            redactedBefore = true;
            continue;
        }
        part && redactedParts.push(part);
    }
    var redacted = '/' + (redactedParts.length >= 2 ? redactedParts.join('/') : redactedParts.join('')) + (query ? '?{query}' : '');
    return redacted;
}

});


parcelRegister("jyXJ6", function(module, exports) {

$parcel$export(module.exports, "METADATA_MODEL", function () { return $e3df85b50226ad29$export$cddc53a868778b3a; });
$parcel$export(module.exports, "SPAN_MODEL", function () { return $e3df85b50226ad29$export$41c959b800170f79; });
$parcel$export(module.exports, "TRANSACTION_MODEL", function () { return $e3df85b50226ad29$export$d887b343e3ec3a69; });
$parcel$export(module.exports, "ERROR_MODEL", function () { return $e3df85b50226ad29$export$fdad63db1c0e037c; });
$parcel$export(module.exports, "truncateModel", function () { return $e3df85b50226ad29$export$488247de36c98c6b; });

var $5YGG1 = parcelRequire("5YGG1");
var $e3df85b50226ad29$export$cddc53a868778b3a = {
    service: {
        name: [
            (0, $5YGG1.KEYWORD_LIMIT),
            true
        ],
        version: true,
        agent: {
            version: [
                (0, $5YGG1.KEYWORD_LIMIT),
                true
            ]
        },
        environment: true
    },
    labels: {
        '*': true
    }
};
var $e3df85b50226ad29$export$a92fd7a0c1236a31 = {
    '*': true,
    headers: {
        '*': true
    }
};
var $e3df85b50226ad29$var$DESTINATION_MODEL = {
    address: [
        (0, $5YGG1.KEYWORD_LIMIT)
    ],
    service: {
        '*': [
            (0, $5YGG1.KEYWORD_LIMIT),
            true
        ]
    }
};
var $e3df85b50226ad29$var$CONTEXT_MODEL = {
    user: {
        id: true,
        email: true,
        username: true
    },
    tags: {
        '*': true
    },
    http: {
        response: $e3df85b50226ad29$export$a92fd7a0c1236a31
    },
    destination: $e3df85b50226ad29$var$DESTINATION_MODEL,
    response: $e3df85b50226ad29$export$a92fd7a0c1236a31
};
var $e3df85b50226ad29$export$41c959b800170f79 = {
    name: [
        (0, $5YGG1.KEYWORD_LIMIT),
        true
    ],
    type: [
        (0, $5YGG1.KEYWORD_LIMIT),
        true
    ],
    id: [
        (0, $5YGG1.KEYWORD_LIMIT),
        true
    ],
    trace_id: [
        (0, $5YGG1.KEYWORD_LIMIT),
        true
    ],
    parent_id: [
        (0, $5YGG1.KEYWORD_LIMIT),
        true
    ],
    transaction_id: [
        (0, $5YGG1.KEYWORD_LIMIT),
        true
    ],
    subtype: true,
    action: true,
    context: $e3df85b50226ad29$var$CONTEXT_MODEL
};
var $e3df85b50226ad29$export$d887b343e3ec3a69 = {
    name: true,
    parent_id: true,
    type: [
        (0, $5YGG1.KEYWORD_LIMIT),
        true
    ],
    id: [
        (0, $5YGG1.KEYWORD_LIMIT),
        true
    ],
    trace_id: [
        (0, $5YGG1.KEYWORD_LIMIT),
        true
    ],
    span_count: {
        started: [
            (0, $5YGG1.KEYWORD_LIMIT),
            true
        ]
    },
    context: $e3df85b50226ad29$var$CONTEXT_MODEL
};
var $e3df85b50226ad29$export$fdad63db1c0e037c = {
    id: [
        (0, $5YGG1.KEYWORD_LIMIT),
        true
    ],
    trace_id: true,
    transaction_id: true,
    parent_id: true,
    culprit: true,
    exception: {
        type: true
    },
    transaction: {
        type: true
    },
    context: $e3df85b50226ad29$var$CONTEXT_MODEL
};
function $e3df85b50226ad29$export$6a506b36fdea397d(value, limit, required, placeholder) {
    if (limit === void 0) limit = (0, $5YGG1.KEYWORD_LIMIT);
    if (required === void 0) required = false;
    if (placeholder === void 0) placeholder = 'N/A';
    if (required && $e3df85b50226ad29$var$isEmpty(value)) value = placeholder;
    if (typeof value === 'string') return value.substring(0, limit);
    return value;
}
function $e3df85b50226ad29$var$isEmpty(value) {
    return value == null || value === '' || typeof value === 'undefined';
}
function $e3df85b50226ad29$var$replaceValue(target, key, currModel) {
    var value = $e3df85b50226ad29$export$6a506b36fdea397d(target[key], currModel[0], currModel[1]);
    if ($e3df85b50226ad29$var$isEmpty(value)) {
        delete target[key];
        return;
    }
    target[key] = value;
}
function $e3df85b50226ad29$export$488247de36c98c6b(model, target, childTarget) {
    if (model === void 0) model = {};
    if (childTarget === void 0) childTarget = target;
    var keys = Object.keys(model);
    var emptyArr = [];
    var _loop = function _loop() {
        var currKey = keys[i];
        var currModel = model[currKey] === true ? emptyArr : model[currKey];
        if (!Array.isArray(currModel)) $e3df85b50226ad29$export$488247de36c98c6b(currModel, target, childTarget[currKey]);
        else if (currKey === '*') Object.keys(childTarget).forEach(function(key) {
            return $e3df85b50226ad29$var$replaceValue(childTarget, key, currModel);
        });
        else $e3df85b50226ad29$var$replaceValue(childTarget, currKey, currModel);
    };
    for(var i = 0; i < keys.length; i++)_loop();
    return target;
}

});

parcelRegister("exbHh", function(module, exports) {

(function(root, factory) {
    'use strict';
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === 'function' && define.amd) define('error-stack-parser', [
        'stackframe'
    ], factory);
    else module.exports = factory((parcelRequire("clJna")));
})(module.exports, function ErrorStackParser(StackFrame) {
    'use strict';
    var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+\:\d+/;
    var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+\:\d+|\(native\))/m;
    var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;
    function _map(array, fn, thisArg) {
        if (typeof Array.prototype.map === 'function') return array.map(fn, thisArg);
        else {
            var output = new Array(array.length);
            for(var i = 0; i < array.length; i++)output[i] = fn.call(thisArg, array[i]);
            return output;
        }
    }
    function _filter(array, fn, thisArg) {
        if (typeof Array.prototype.filter === 'function') return array.filter(fn, thisArg);
        else {
            var output = [];
            for(var i = 0; i < array.length; i++)if (fn.call(thisArg, array[i])) output.push(array[i]);
            return output;
        }
    }
    function _indexOf(array, target) {
        if (typeof Array.prototype.indexOf === 'function') return array.indexOf(target);
        else {
            for(var i = 0; i < array.length; i++){
                if (array[i] === target) return i;
            }
            return -1;
        }
    }
    return {
        /**
         * Given an Error object, extract the most information from it.
         *
         * @param {Error} error object
         * @return {Array} of StackFrames
         */ parse: function ErrorStackParser$$parse(error) {
            if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') return this.parseOpera(error);
            else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) return this.parseV8OrIE(error);
            else if (error.stack) return this.parseFFOrSafari(error);
            else throw new Error('Cannot parse given Error object');
        },
        // Separate line and column numbers from a string of the form: (URI:Line:Column)
        extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
            // Fail-fast but return locations like "(native)"
            if (urlLike.indexOf(':') === -1) return [
                urlLike
            ];
            var regExp = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/;
            var parts = regExp.exec(urlLike.replace(/[\(\)]/g, ''));
            return [
                parts[1],
                parts[2] || undefined,
                parts[3] || undefined
            ];
        },
        parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
            var filtered = _filter(error.stack.split('\n'), function(line) {
                return !!line.match(CHROME_IE_STACK_REGEXP);
            }, this);
            return _map(filtered, function(line) {
                if (line.indexOf('(eval ') > -1) // Throw away eval information until we implement stacktrace.js/stackframe#8
                line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, '');
                var tokens = line.replace(/^\s+/, '').replace(/\(eval code/g, '(').split(/\s+/).slice(1);
                var locationParts = this.extractLocation(tokens.pop());
                var functionName = tokens.join(' ') || undefined;
                var fileName = _indexOf([
                    'eval',
                    '<anonymous>'
                ], locationParts[0]) > -1 ? undefined : locationParts[0];
                return new StackFrame(functionName, undefined, fileName, locationParts[1], locationParts[2], line);
            }, this);
        },
        parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
            var filtered = _filter(error.stack.split('\n'), function(line) {
                return !line.match(SAFARI_NATIVE_CODE_REGEXP);
            }, this);
            return _map(filtered, function(line) {
                // Throw away eval information until we implement stacktrace.js/stackframe#8
                if (line.indexOf(' > eval') > -1) line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ':$1');
                if (line.indexOf('@') === -1 && line.indexOf(':') === -1) // Safari eval frames only have function names and nothing else
                return new StackFrame(line);
                else {
                    var tokens = line.split('@');
                    var locationParts = this.extractLocation(tokens.pop());
                    var functionName = tokens.join('@') || undefined;
                    return new StackFrame(functionName, undefined, locationParts[0], locationParts[1], locationParts[2], line);
                }
            }, this);
        },
        parseOpera: function ErrorStackParser$$parseOpera(e) {
            if (!e.stacktrace || e.message.indexOf('\n') > -1 && e.message.split('\n').length > e.stacktrace.split('\n').length) return this.parseOpera9(e);
            else if (!e.stack) return this.parseOpera10(e);
            else return this.parseOpera11(e);
        },
        parseOpera9: function ErrorStackParser$$parseOpera9(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
            var lines = e.message.split('\n');
            var result = [];
            for(var i = 2, len = lines.length; i < len; i += 2){
                var match = lineRE.exec(lines[i]);
                if (match) result.push(new StackFrame(undefined, undefined, match[2], match[1], undefined, lines[i]));
            }
            return result;
        },
        parseOpera10: function ErrorStackParser$$parseOpera10(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
            var lines = e.stacktrace.split('\n');
            var result = [];
            for(var i = 0, len = lines.length; i < len; i += 2){
                var match = lineRE.exec(lines[i]);
                if (match) result.push(new StackFrame(match[3] || undefined, undefined, match[2], match[1], undefined, lines[i]));
            }
            return result;
        },
        // Opera 10.65+ Error.stack very similar to FF/Safari
        parseOpera11: function ErrorStackParser$$parseOpera11(error) {
            var filtered = _filter(error.stack.split('\n'), function(line) {
                return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
            }, this);
            return _map(filtered, function(line) {
                var tokens = line.split('@');
                var locationParts = this.extractLocation(tokens.pop());
                var functionCall = tokens.shift() || '';
                var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, '$2').replace(/\([^\)]*\)/g, '') || undefined;
                var argsRaw;
                if (functionCall.match(/\(([^\)]*)\)/)) argsRaw = functionCall.replace(/^[^\(]+\(([^\)]*)\)$/, '$1');
                var args = argsRaw === undefined || argsRaw === '[arguments not available]' ? undefined : argsRaw.split(',');
                return new StackFrame(functionName, args, locationParts[0], locationParts[1], locationParts[2], line);
            }, this);
        }
    };
});

});


parcelRegister("feGtA", function(module, exports) {

$parcel$export(module.exports, "serviceCreators", function () { return $b1791cb7298e2209$export$a7d9bc765837b75c; });
$parcel$export(module.exports, "ServiceFactory", function () { return $b1791cb7298e2209$export$654036ce31f352db; });

var $gYdYf = parcelRequire("gYdYf");

var $jaW2Z = parcelRequire("jaW2Z");

var $kSc1y = parcelRequire("kSc1y");

var $5YGG1 = parcelRequire("5YGG1");

var $h1jmT = parcelRequire("h1jmT");
var $b1791cb7298e2209$var$_serviceCreators;
var $b1791cb7298e2209$export$a7d9bc765837b75c = ($b1791cb7298e2209$var$_serviceCreators = {}, $b1791cb7298e2209$var$_serviceCreators[0, $5YGG1.CONFIG_SERVICE] = function() {
    return new (0, $jaW2Z.default)();
}, $b1791cb7298e2209$var$_serviceCreators[0, $5YGG1.LOGGING_SERVICE] = function() {
    return new (0, $kSc1y.default)({
        prefix: '[Elastic APM] '
    });
}, $b1791cb7298e2209$var$_serviceCreators[0, $5YGG1.APM_SERVER] = function(factory) {
    var _factory$getService = factory.getService([
        (0, $5YGG1.CONFIG_SERVICE),
        (0, $5YGG1.LOGGING_SERVICE)
    ]), configService = _factory$getService[0], loggingService = _factory$getService[1];
    return new (0, $gYdYf.default)(configService, loggingService);
}, $b1791cb7298e2209$var$_serviceCreators);
var $b1791cb7298e2209$export$654036ce31f352db = function() {
    function ServiceFactory() {
        this.instances = {};
        this.initialized = false;
    }
    var _proto = ServiceFactory.prototype;
    _proto.init = function init() {
        if (this.initialized) return;
        this.initialized = true;
        var configService = this.getService((0, $5YGG1.CONFIG_SERVICE));
        configService.init();
        var _this$getService = this.getService([
            (0, $5YGG1.LOGGING_SERVICE),
            (0, $5YGG1.APM_SERVER)
        ]), loggingService = _this$getService[0], apmServer = _this$getService[1];
        configService.events.observe((0, $5YGG1.CONFIG_CHANGE), function() {
            var logLevel = configService.get('logLevel');
            loggingService.setLevel(logLevel);
        });
        apmServer.init();
    };
    _proto.getService = function getService(name) {
        var _this = this;
        if (typeof name === 'string') {
            if (!this.instances[name]) {
                if (typeof $b1791cb7298e2209$export$a7d9bc765837b75c[name] === 'function') this.instances[name] = $b1791cb7298e2209$export$a7d9bc765837b75c[name](this);
                else if (0, $h1jmT.__DEV__) console.log('Cannot get service, No creator for: ' + name);
            }
            return this.instances[name];
        } else if (Array.isArray(name)) return name.map(function(n) {
            return _this.getService(n);
        });
    };
    return ServiceFactory;
}();

});
parcelRegister("gYdYf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5ad163ddf6cf220$export$2e2bcd8739ae039; });

var $cPDAO = parcelRequire("cPDAO");

var $dj2b7 = parcelRequire("dj2b7");

var $3Jyfe = parcelRequire("3Jyfe");

var $jyXJ6 = parcelRequire("jyXJ6");

var $5YGG1 = parcelRequire("5YGG1");

var $iCHUu = parcelRequire("iCHUu");

var $g76Dc = parcelRequire("g76Dc");

var $gdIgY = parcelRequire("gdIgY");

var $h1jmT = parcelRequire("h1jmT");

var $9Vat7 = parcelRequire("9Vat7");

var $7ZZgg = parcelRequire("7ZZgg");
var $c5ad163ddf6cf220$var$THROTTLE_INTERVAL = 60000;
var $c5ad163ddf6cf220$var$ApmServer = function() {
    function ApmServer(configService, loggingService) {
        this._configService = configService;
        this._loggingService = loggingService;
        this.queue = undefined;
        this.throttleEvents = (0, $iCHUu.noop);
    }
    var _proto = ApmServer.prototype;
    _proto.init = function init() {
        var _this = this;
        var queueLimit = this._configService.get('queueLimit');
        var flushInterval = this._configService.get('flushInterval');
        var limit = this._configService.get('eventsLimit');
        var onFlush = function onFlush(events) {
            var promise = _this.sendEvents(events);
            if (promise) promise.catch(function(reason) {
                _this._loggingService.warn('Failed sending events!', _this._constructError(reason));
            });
        };
        this.queue = new (0, $cPDAO.default)(onFlush, {
            queueLimit: queueLimit,
            flushInterval: flushInterval
        });
        this.throttleEvents = (0, $dj2b7.default)(this.queue.add.bind(this.queue), function() {
            return _this._loggingService.warn('Dropped events due to throttling!');
        }, {
            limit: limit,
            interval: $c5ad163ddf6cf220$var$THROTTLE_INTERVAL
        });
        this._configService.observeEvent((0, $5YGG1.QUEUE_FLUSH), function() {
            _this.queue.flush();
        });
    };
    _proto._postJson = function _postJson(endPoint, payload) {
        var _this2 = this;
        var headers = {
            'Content-Type': 'application/x-ndjson'
        };
        var apmRequest = this._configService.get('apmRequest');
        var params = {
            payload: payload,
            headers: headers,
            beforeSend: apmRequest
        };
        return (0, $gdIgY.compressPayload)(params).catch(function(error) {
            if (0, $h1jmT.__DEV__) _this2._loggingService.debug('Compressing the payload using CompressionStream API failed', error.message);
            return params;
        }).then(function(result) {
            return _this2._makeHttpRequest('POST', endPoint, result);
        }).then(function(_ref) {
            var responseText = _ref.responseText;
            return responseText;
        });
    };
    _proto._constructError = function _constructError(reason) {
        var url = reason.url, status = reason.status, responseText = reason.responseText;
        if (typeof status == 'undefined') return reason;
        var message = url + ' HTTP status: ' + status;
        if ((0, $h1jmT.__DEV__) && responseText) try {
            var serverErrors = [];
            var response = JSON.parse(responseText);
            if (response.errors && response.errors.length > 0) {
                response.errors.forEach(function(err) {
                    return serverErrors.push(err.message);
                });
                message += ' ' + serverErrors.join(',');
            }
        } catch (e) {
            this._loggingService.debug('Error parsing response from APM server', e);
        }
        return new Error(message);
    };
    _proto._makeHttpRequest = function _makeHttpRequest(method, url, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$timeout = _ref2.timeout, timeout = _ref2$timeout === void 0 ? (0, $5YGG1.HTTP_REQUEST_TIMEOUT) : _ref2$timeout, payload = _ref2.payload, headers = _ref2.headers, beforeSend = _ref2.beforeSend;
        var sendCredentials = this._configService.get('sendCredentials');
        if (!beforeSend && (0, $9Vat7.shouldUseFetchWithKeepAlive)(method, payload)) return (0, $9Vat7.sendFetchRequest)(method, url, {
            keepalive: true,
            timeout: timeout,
            payload: payload,
            headers: headers,
            sendCredentials: sendCredentials
        }).catch(function(reason) {
            if (reason instanceof TypeError) return (0, $7ZZgg.sendXHR)(method, url, {
                timeout: timeout,
                payload: payload,
                headers: headers,
                beforeSend: beforeSend,
                sendCredentials: sendCredentials
            });
            throw reason;
        });
        return (0, $7ZZgg.sendXHR)(method, url, {
            timeout: timeout,
            payload: payload,
            headers: headers,
            beforeSend: beforeSend,
            sendCredentials: sendCredentials
        });
    };
    _proto.fetchConfig = function fetchConfig(serviceName, environment) {
        var _this3 = this;
        var _this$getEndpoints = this.getEndpoints(), configEndpoint = _this$getEndpoints.configEndpoint;
        if (!serviceName) return (0, $g76Dc.Promise).reject('serviceName is required for fetching central config.');
        configEndpoint += "?service.name=" + serviceName;
        if (environment) configEndpoint += "&service.environment=" + environment;
        var localConfig = this._configService.getLocalConfig();
        if (localConfig) configEndpoint += "&ifnonematch=" + localConfig.etag;
        var apmRequest = this._configService.get('apmRequest');
        return this._makeHttpRequest('GET', configEndpoint, {
            timeout: 5000,
            beforeSend: apmRequest
        }).then(function(xhr) {
            var status = xhr.status, responseText = xhr.responseText;
            if (status === 304) return localConfig;
            else {
                var remoteConfig = JSON.parse(responseText);
                var etag = xhr.getResponseHeader('etag');
                if (etag) {
                    remoteConfig.etag = etag.replace(/["]/g, '');
                    _this3._configService.setLocalConfig(remoteConfig, true);
                }
                return remoteConfig;
            }
        }).catch(function(reason) {
            var error = _this3._constructError(reason);
            return (0, $g76Dc.Promise).reject(error);
        });
    };
    _proto.createMetaData = function createMetaData() {
        var cfg = this._configService;
        var metadata = {
            service: {
                name: cfg.get('serviceName'),
                version: cfg.get('serviceVersion'),
                agent: {
                    name: 'rum-js',
                    version: cfg.version
                },
                language: {
                    name: 'javascript'
                },
                environment: cfg.get('environment')
            },
            labels: cfg.get('context.tags')
        };
        return (0, $jyXJ6.truncateModel)((0, $jyXJ6.METADATA_MODEL), metadata);
    };
    _proto.addError = function addError(error) {
        var _this$throttleEvents;
        this.throttleEvents((_this$throttleEvents = {}, _this$throttleEvents[0, $5YGG1.ERRORS] = error, _this$throttleEvents));
    };
    _proto.addTransaction = function addTransaction(transaction) {
        var _this$throttleEvents2;
        this.throttleEvents((_this$throttleEvents2 = {}, _this$throttleEvents2[0, $5YGG1.TRANSACTIONS] = transaction, _this$throttleEvents2));
    };
    _proto.ndjsonErrors = function ndjsonErrors(errors, compress) {
        var key = compress ? 'e' : 'error';
        return errors.map(function(error) {
            var _NDJSON$stringify;
            return (0, $3Jyfe.default).stringify((_NDJSON$stringify = {}, _NDJSON$stringify[key] = compress ? (0, $gdIgY.compressError)(error) : error, _NDJSON$stringify));
        });
    };
    _proto.ndjsonMetricsets = function ndjsonMetricsets(metricsets) {
        return metricsets.map(function(metricset) {
            return (0, $3Jyfe.default).stringify({
                metricset: metricset
            });
        }).join('');
    };
    _proto.ndjsonTransactions = function ndjsonTransactions(transactions, compress) {
        var _this4 = this;
        var key = compress ? 'x' : 'transaction';
        return transactions.map(function(tr) {
            var _NDJSON$stringify2;
            var spans = '', breakdowns = '';
            if (!compress) {
                if (tr.spans) {
                    spans = tr.spans.map(function(span) {
                        return (0, $3Jyfe.default).stringify({
                            span: span
                        });
                    }).join('');
                    delete tr.spans;
                }
                if (tr.breakdown) {
                    breakdowns = _this4.ndjsonMetricsets(tr.breakdown);
                    delete tr.breakdown;
                }
            }
            return (0, $3Jyfe.default).stringify((_NDJSON$stringify2 = {}, _NDJSON$stringify2[key] = compress ? (0, $gdIgY.compressTransaction)(tr) : tr, _NDJSON$stringify2)) + spans + breakdowns;
        });
    };
    _proto.sendEvents = function sendEvents(events) {
        var _payload, _NDJSON$stringify3;
        if (events.length === 0) return;
        var transactions = [];
        var errors = [];
        for(var i = 0; i < events.length; i++){
            var event = events[i];
            if (event[0, $5YGG1.TRANSACTIONS]) transactions.push(event[0, $5YGG1.TRANSACTIONS]);
            if (event[0, $5YGG1.ERRORS]) errors.push(event[0, $5YGG1.ERRORS]);
        }
        if (transactions.length === 0 && errors.length === 0) return;
        var cfg = this._configService;
        var payload = (_payload = {}, _payload[0, $5YGG1.TRANSACTIONS] = transactions, _payload[0, $5YGG1.ERRORS] = errors, _payload);
        var filteredPayload = cfg.applyFilters(payload);
        if (!filteredPayload) {
            this._loggingService.warn('Dropped payload due to filtering!');
            return;
        }
        var apiVersion = cfg.get('apiVersion');
        var compress = apiVersion > 2;
        var ndjson = [];
        var metadata = this.createMetaData();
        var metadataKey = compress ? 'm' : 'metadata';
        ndjson.push((0, $3Jyfe.default).stringify((_NDJSON$stringify3 = {}, _NDJSON$stringify3[metadataKey] = compress ? (0, $gdIgY.compressMetadata)(metadata) : metadata, _NDJSON$stringify3)));
        ndjson = ndjson.concat(this.ndjsonErrors(filteredPayload[0, $5YGG1.ERRORS], compress), this.ndjsonTransactions(filteredPayload[0, $5YGG1.TRANSACTIONS], compress));
        var ndjsonPayload = ndjson.join('');
        var _this$getEndpoints2 = this.getEndpoints(), intakeEndpoint = _this$getEndpoints2.intakeEndpoint;
        return this._postJson(intakeEndpoint, ndjsonPayload);
    };
    _proto.getEndpoints = function getEndpoints() {
        var serverUrl = this._configService.get('serverUrl');
        var apiVersion = this._configService.get('apiVersion');
        var serverUrlPrefix = this._configService.get('serverUrlPrefix') || "/intake/v" + apiVersion + "/rum/events";
        var intakeEndpoint = serverUrl + serverUrlPrefix;
        var configEndpoint = serverUrl + "/config/v1/rum/agents";
        return {
            intakeEndpoint: intakeEndpoint,
            configEndpoint: configEndpoint
        };
    };
    return ApmServer;
}();
var $c5ad163ddf6cf220$export$2e2bcd8739ae039 = $c5ad163ddf6cf220$var$ApmServer;

});
parcelRegister("cPDAO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9578f5b9df6d6b55$export$2e2bcd8739ae039; });
var $9578f5b9df6d6b55$var$Queue = function() {
    function Queue(onFlush, opts) {
        if (opts === void 0) opts = {};
        this.onFlush = onFlush;
        this.items = [];
        this.queueLimit = opts.queueLimit || -1;
        this.flushInterval = opts.flushInterval || 0;
        this.timeoutId = undefined;
    }
    var _proto = Queue.prototype;
    _proto._setTimer = function _setTimer() {
        var _this = this;
        this.timeoutId = setTimeout(function() {
            return _this.flush();
        }, this.flushInterval);
    };
    _proto._clear = function _clear() {
        if (typeof this.timeoutId !== 'undefined') {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
        }
        this.items = [];
    };
    _proto.flush = function flush() {
        this.onFlush(this.items);
        this._clear();
    };
    _proto.add = function add(item) {
        this.items.push(item);
        if (this.queueLimit !== -1 && this.items.length >= this.queueLimit) this.flush();
        else if (typeof this.timeoutId === 'undefined') this._setTimer();
    };
    return Queue;
}();
var $9578f5b9df6d6b55$export$2e2bcd8739ae039 = $9578f5b9df6d6b55$var$Queue;

});

parcelRegister("dj2b7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9afebd43d74fb243$export$2e2bcd8739ae039; });
function $9afebd43d74fb243$export$2e2bcd8739ae039(fn, onThrottle, opts) {
    var context = this;
    var limit = opts.limit;
    var interval = opts.interval;
    var counter = 0;
    var timeoutId;
    return function() {
        counter++;
        if (typeof timeoutId === 'undefined') timeoutId = setTimeout(function() {
            counter = 0;
            timeoutId = undefined;
        }, interval);
        if (counter > limit && typeof onThrottle === 'function') return onThrottle.apply(context, arguments);
        else return fn.apply(context, arguments);
    };
}

});

parcelRegister("3Jyfe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b80235ecd4987f9$export$2e2bcd8739ae039; });
var $2b80235ecd4987f9$var$NDJSON = function() {
    function NDJSON() {}
    NDJSON.stringify = function stringify(object) {
        return JSON.stringify(object) + '\n';
    };
    return NDJSON;
}();
var $2b80235ecd4987f9$export$2e2bcd8739ae039 = $2b80235ecd4987f9$var$NDJSON;

});

parcelRegister("gdIgY", function(module, exports) {

$parcel$export(module.exports, "compressMetadata", function () { return $bcf033e260a839e3$export$12b7560e2fabea9; });
$parcel$export(module.exports, "compressTransaction", function () { return $bcf033e260a839e3$export$2113d87e265597f0; });
$parcel$export(module.exports, "compressError", function () { return $bcf033e260a839e3$export$c8289256501a337d; });
$parcel$export(module.exports, "compressPayload", function () { return $bcf033e260a839e3$export$5569fdd03c217956; });

var $g76Dc = parcelRequire("g76Dc");

var $PSJt9 = parcelRequire("PSJt9");

var $iCHUu = parcelRequire("iCHUu");
function $bcf033e260a839e3$var$compressStackFrames(frames) {
    return frames.map(function(frame) {
        return {
            ap: frame.abs_path,
            f: frame.filename,
            fn: frame.function,
            li: frame.lineno,
            co: frame.colno
        };
    });
}
function $bcf033e260a839e3$var$compressResponse(response) {
    return {
        ts: response.transfer_size,
        ebs: response.encoded_body_size,
        dbs: response.decoded_body_size
    };
}
function $bcf033e260a839e3$var$compressHTTP(http) {
    var compressed = {};
    var method = http.method, status_code = http.status_code, url = http.url, response = http.response;
    compressed.url = url;
    if (method) compressed.mt = method;
    if (status_code) compressed.sc = status_code;
    if (response) compressed.r = $bcf033e260a839e3$var$compressResponse(response);
    return compressed;
}
function $bcf033e260a839e3$var$compressContext(context) {
    if (!context) return null;
    var compressed = {};
    var page = context.page, http = context.http, response = context.response, destination = context.destination, user = context.user, custom = context.custom, tags = context.tags;
    if (page) compressed.p = {
        rf: page.referer,
        url: page.url
    };
    if (http) compressed.h = $bcf033e260a839e3$var$compressHTTP(http);
    if (response) compressed.r = $bcf033e260a839e3$var$compressResponse(response);
    if (destination) {
        var service = destination.service;
        compressed.dt = {
            se: {
                n: service.name,
                t: service.type,
                rc: service.resource
            },
            ad: destination.address,
            po: destination.port
        };
    }
    if (user) compressed.u = {
        id: user.id,
        un: user.username,
        em: user.email
    };
    if (custom) compressed.cu = custom;
    if (tags) compressed.g = tags;
    return compressed;
}
function $bcf033e260a839e3$var$compressMarks(marks) {
    if (!marks) return null;
    var compressedNtMarks = $bcf033e260a839e3$var$compressNavigationTimingMarks(marks.navigationTiming);
    var compressed = {
        nt: compressedNtMarks,
        a: $bcf033e260a839e3$var$compressAgentMarks(compressedNtMarks, marks.agent)
    };
    return compressed;
}
function $bcf033e260a839e3$var$compressNavigationTimingMarks(ntMarks) {
    if (!ntMarks) return null;
    var compressed = {};
    (0, $PSJt9.COMPRESSED_NAV_TIMING_MARKS).forEach(function(mark, index) {
        var mapping = (0, $PSJt9.NAVIGATION_TIMING_MARKS)[index];
        compressed[mark] = ntMarks[mapping];
    });
    return compressed;
}
function $bcf033e260a839e3$var$compressAgentMarks(compressedNtMarks, agentMarks) {
    var compressed = {};
    if (compressedNtMarks) compressed = {
        fb: compressedNtMarks.rs,
        di: compressedNtMarks.di,
        dc: compressedNtMarks.dc
    };
    if (agentMarks) {
        var fp = agentMarks.firstContentfulPaint;
        var lp = agentMarks.largestContentfulPaint;
        if (fp) compressed.fp = fp;
        if (lp) compressed.lp = lp;
    }
    if (Object.keys(compressed).length === 0) return null;
    return compressed;
}
function $bcf033e260a839e3$export$12b7560e2fabea9(metadata) {
    var service = metadata.service, labels = metadata.labels;
    var agent = service.agent, language = service.language;
    return {
        se: {
            n: service.name,
            ve: service.version,
            a: {
                n: agent.name,
                ve: agent.version
            },
            la: {
                n: language.name
            },
            en: service.environment
        },
        l: labels
    };
}
function $bcf033e260a839e3$export$2113d87e265597f0(transaction) {
    var spans = transaction.spans.map(function(span) {
        var spanData = {
            id: span.id,
            n: span.name,
            t: span.type,
            s: span.start,
            d: span.duration,
            c: $bcf033e260a839e3$var$compressContext(span.context),
            o: span.outcome,
            sr: span.sample_rate
        };
        if (span.parent_id !== transaction.id) spanData.pid = span.parent_id;
        if (span.sync === true) spanData.sy = true;
        if (span.subtype) spanData.su = span.subtype;
        if (span.action) spanData.ac = span.action;
        return spanData;
    });
    var tr = {
        id: transaction.id,
        pid: transaction.parent_id,
        tid: transaction.trace_id,
        n: transaction.name,
        t: transaction.type,
        d: transaction.duration,
        c: $bcf033e260a839e3$var$compressContext(transaction.context),
        k: $bcf033e260a839e3$var$compressMarks(transaction.marks),
        me: $bcf033e260a839e3$export$9327fccd6912fe3c(transaction.breakdown),
        y: spans,
        yc: {
            sd: spans.length
        },
        sm: transaction.sampled,
        sr: transaction.sample_rate,
        o: transaction.outcome
    };
    if (transaction.experience) {
        var _transaction$experien = transaction.experience, cls = _transaction$experien.cls, fid = _transaction$experien.fid, tbt = _transaction$experien.tbt, longtask = _transaction$experien.longtask;
        tr.exp = {
            cls: cls,
            fid: fid,
            tbt: tbt,
            lt: longtask
        };
    }
    if (transaction.session) {
        var _transaction$session = transaction.session, id = _transaction$session.id, sequence = _transaction$session.sequence;
        tr.ses = {
            id: id,
            seq: sequence
        };
    }
    return tr;
}
function $bcf033e260a839e3$export$c8289256501a337d(error) {
    var exception = error.exception;
    var compressed = {
        id: error.id,
        cl: error.culprit,
        ex: {
            mg: exception.message,
            st: $bcf033e260a839e3$var$compressStackFrames(exception.stacktrace),
            t: error.type
        },
        c: $bcf033e260a839e3$var$compressContext(error.context)
    };
    var transaction = error.transaction;
    if (transaction) {
        compressed.tid = error.trace_id;
        compressed.pid = error.parent_id;
        compressed.xid = error.transaction_id;
        compressed.x = {
            t: transaction.type,
            sm: transaction.sampled
        };
    }
    return compressed;
}
function $bcf033e260a839e3$export$9327fccd6912fe3c(breakdowns) {
    return breakdowns.map(function(_ref) {
        var span = _ref.span, samples = _ref.samples;
        return {
            y: {
                t: span.type
            },
            sa: {
                ysc: {
                    v: samples['span.self_time.count'].value
                },
                yss: {
                    v: samples['span.self_time.sum.us'].value
                }
            }
        };
    });
}
function $bcf033e260a839e3$export$5569fdd03c217956(params, type) {
    if (type === void 0) type = 'gzip';
    var isCompressionStreamSupported = typeof CompressionStream === 'function';
    return new (0, $g76Dc.Promise)(function(resolve) {
        if (!isCompressionStreamSupported) return resolve(params);
        if ((0, $iCHUu.isBeaconInspectionEnabled)()) return resolve(params);
        var payload = params.payload, headers = params.headers, beforeSend = params.beforeSend;
        var payloadStream = new Blob([
            payload
        ]).stream();
        var compressedStream = payloadStream.pipeThrough(new CompressionStream(type));
        return new Response(compressedStream).blob().then(function(payload) {
            headers['Content-Encoding'] = type;
            return resolve({
                payload: payload,
                headers: headers,
                beforeSend: beforeSend
            });
        });
    });
}

});
parcelRegister("PSJt9", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_TIMING_MARKS", function () { return $09bf383e8a52b510$export$76056912abddbcc9; });
$parcel$export(module.exports, "COMPRESSED_NAV_TIMING_MARKS", function () { return $09bf383e8a52b510$export$82a807639806d09d; });
$parcel$export(module.exports, "getPageLoadMarks", function () { return $09bf383e8a52b510$export$f010c0904d0d2983; });

var $iCHUu = parcelRequire("iCHUu");
var $09bf383e8a52b510$export$76056912abddbcc9 = [
    'fetchStart',
    'domainLookupStart',
    'domainLookupEnd',
    'connectStart',
    'connectEnd',
    'requestStart',
    'responseStart',
    'responseEnd',
    'domLoading',
    'domInteractive',
    'domContentLoadedEventStart',
    'domContentLoadedEventEnd',
    'domComplete',
    'loadEventStart',
    'loadEventEnd'
];
var $09bf383e8a52b510$export$82a807639806d09d = [
    'fs',
    'ls',
    'le',
    'cs',
    'ce',
    'qs',
    'rs',
    're',
    'dl',
    'di',
    'ds',
    'de',
    'dc',
    'es',
    'ee'
];
function $09bf383e8a52b510$export$f010c0904d0d2983(timing) {
    var marks = $09bf383e8a52b510$var$getNavigationTimingMarks(timing);
    if (marks == null) return null;
    return {
        navigationTiming: marks,
        agent: {
            timeToFirstByte: marks.responseStart,
            domInteractive: marks.domInteractive,
            domComplete: marks.domComplete
        }
    };
}
function $09bf383e8a52b510$var$getNavigationTimingMarks(timing) {
    var redirectStart = timing.redirectStart, fetchStart = timing.fetchStart, navigationStart = timing.navigationStart, responseStart = timing.responseStart, responseEnd = timing.responseEnd;
    if (fetchStart >= navigationStart && responseStart >= fetchStart && responseEnd >= responseStart) {
        var marks = {};
        $09bf383e8a52b510$export$76056912abddbcc9.forEach(function(timingKey) {
            var m = timing[timingKey];
            if (m && m >= fetchStart) {
                if ((0, $iCHUu.isRedirectInfoAvailable)(timing)) marks[timingKey] = parseInt(m - redirectStart);
                else marks[timingKey] = parseInt(m - fetchStart);
            }
        });
        return marks;
    }
    return null;
}

});


parcelRegister("7ZZgg", function(module, exports) {

$parcel$export(module.exports, "sendXHR", function () { return $5d2dc01bcbfab7f2$export$998d51f5856d10f5; });

var $hfucu = parcelRequire("hfucu");

var $2Q2VM = parcelRequire("2Q2VM");

var $g76Dc = parcelRequire("g76Dc");
function $5d2dc01bcbfab7f2$export$998d51f5856d10f5(method, url, _ref) {
    var _ref$timeout = _ref.timeout, timeout = _ref$timeout === void 0 ? HTTP_REQUEST_TIMEOUT : _ref$timeout, payload = _ref.payload, headers = _ref.headers, beforeSend = _ref.beforeSend, sendCredentials = _ref.sendCredentials;
    return new (0, $g76Dc.Promise)(function(resolve, reject) {
        var xhr = new window.XMLHttpRequest();
        xhr[0, $hfucu.XHR_IGNORE] = true;
        xhr.open(method, url, true);
        xhr.timeout = timeout;
        xhr.withCredentials = sendCredentials;
        if (headers) {
            for(var header in headers)if (headers.hasOwnProperty(header)) xhr.setRequestHeader(header, headers[header]);
        }
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) {
                var status = xhr.status, responseText = xhr.responseText;
                if ((0, $2Q2VM.isResponseSuccessful)(status)) resolve(xhr);
                else reject({
                    url: url,
                    status: status,
                    responseText: responseText
                });
            }
        };
        xhr.onerror = function() {
            var status = xhr.status, responseText = xhr.responseText;
            reject({
                url: url,
                status: status,
                responseText: responseText
            });
        };
        var canSend = true;
        if (typeof beforeSend === 'function') canSend = beforeSend({
            url: url,
            method: method,
            headers: headers,
            payload: payload,
            xhr: xhr
        });
        if (canSend) xhr.send(payload);
        else reject({
            url: url,
            status: 0,
            responseText: 'Request rejected by user configuration.'
        });
    });
}

});


parcelRegister("jaW2Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df5bfa7aca585540$export$2e2bcd8739ae039; });

var $iCHUu = parcelRequire("iCHUu");

var $hgvs9 = parcelRequire("hgvs9");

var $5YGG1 = parcelRequire("5YGG1");

var $h1jmT = parcelRequire("h1jmT");
function $df5bfa7aca585540$var$_extends() {
    return $df5bfa7aca585540$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $df5bfa7aca585540$var$_extends.apply(null, arguments);
}
function $df5bfa7aca585540$var$getConfigFromScript() {
    var script = (0, $iCHUu.getCurrentScript)();
    var config = $df5bfa7aca585540$var$getDataAttributesFromNode(script);
    return config;
}
function $df5bfa7aca585540$var$getDataAttributesFromNode(node) {
    if (!node) return {};
    var dataAttrs = {};
    var dataRegex = /^data-([\w-]+)$/;
    var attrs = node.attributes;
    for(var i = 0; i < attrs.length; i++){
        var attr = attrs[i];
        if (dataRegex.test(attr.nodeName)) {
            var key = attr.nodeName.match(dataRegex)[1];
            var camelCasedkey = key.split('-').map(function(value, index) {
                return index > 0 ? value.charAt(0).toUpperCase() + value.substring(1) : value;
            }).join('');
            dataAttrs[camelCasedkey] = attr.value || attr.nodeValue;
        }
    }
    return dataAttrs;
}
var $df5bfa7aca585540$var$Config = function() {
    function Config() {
        this.config = {
            serviceName: '',
            serviceVersion: '',
            environment: '',
            serverUrl: 'http://localhost:8200',
            serverUrlPrefix: '',
            active: true,
            instrument: true,
            disableInstrumentations: [],
            logLevel: 'warn',
            breakdownMetrics: false,
            ignoreTransactions: [],
            eventsLimit: 80,
            queueLimit: -1,
            flushInterval: 500,
            distributedTracing: true,
            distributedTracingOrigins: [],
            distributedTracingHeaderName: 'traceparent',
            pageLoadTraceId: '',
            pageLoadSpanId: '',
            pageLoadSampled: false,
            pageLoadParentId: '',
            pageLoadTransactionName: '',
            propagateTracestate: false,
            transactionSampleRate: 1.0,
            centralConfig: false,
            monitorLongtasks: true,
            apiVersion: 2,
            context: {},
            session: false,
            apmRequest: null,
            sendCredentials: false,
            reportTransactionsWithoutSpans: false
        };
        this.events = new (0, $hgvs9.default)();
        this.filters = [];
        this.version = '';
    }
    var _proto = Config.prototype;
    _proto.init = function init() {
        var scriptData = $df5bfa7aca585540$var$getConfigFromScript();
        this.setConfig(scriptData);
    };
    _proto.setVersion = function setVersion(version) {
        this.version = version;
    };
    _proto.addFilter = function addFilter(cb) {
        if (typeof cb !== 'function') throw new Error('Argument to must be function');
        this.filters.push(cb);
    };
    _proto.applyFilters = function applyFilters(data) {
        try {
            for(var i = 0; i < this.filters.length; i++){
                data = this.filters[i](data);
                if (!data) return;
            }
            data.transactions = data.transactions.filter(function(t) {
                return t;
            });
            data.errors = data.errors.filter(function(e) {
                return e;
            });
            if (data.transactions.length === 0 && data.errors.length === 0) return;
        } catch (e) {
            if (0, $h1jmT.__DEV__) console.log('[Elastic APM] Error applying filters for RUM payload', e);
            return;
        }
        return data;
    };
    _proto.get = function get(key) {
        return key.split('.').reduce(function(obj, objKey) {
            return obj && obj[objKey];
        }, this.config);
    };
    _proto.setUserContext = function setUserContext(userContext) {
        if (userContext === void 0) userContext = {};
        var context = {};
        var _userContext = userContext, id = _userContext.id, username = _userContext.username, email = _userContext.email;
        if (typeof id === 'number' || typeof id === 'string') context.id = id;
        if (typeof username === 'string') context.username = username;
        if (typeof email === 'string') context.email = email;
        this.config.context.user = (0, $iCHUu.extend)(this.config.context.user || {}, context);
    };
    _proto.setCustomContext = function setCustomContext(customContext) {
        if (customContext === void 0) customContext = {};
        this.config.context.custom = (0, $iCHUu.extend)(this.config.context.custom || {}, customContext);
    };
    _proto.addLabels = function addLabels(tags) {
        var _this = this;
        if (!this.config.context.tags) this.config.context.tags = {};
        var keys = Object.keys(tags);
        keys.forEach(function(k) {
            return (0, $iCHUu.setLabel)(k, tags[k], _this.config.context.tags);
        });
    };
    _proto.setConfig = function setConfig(properties) {
        if (properties === void 0) properties = {};
        var _properties = properties, transactionSampleRate = _properties.transactionSampleRate, serverUrl = _properties.serverUrl;
        if (serverUrl) properties.serverUrl = serverUrl.replace(/\/+$/, '');
        if (!(0, $iCHUu.isUndefined)(transactionSampleRate)) {
            if (transactionSampleRate < 0.0001 && transactionSampleRate > 0) transactionSampleRate = 0.0001;
            properties.transactionSampleRate = Math.round(transactionSampleRate * 10000) / 10000;
        }
        this.config = (0, $iCHUu.merge)(this.config, properties);
        this.events.send((0, $5YGG1.CONFIG_CHANGE), [
            this.config
        ]);
    };
    _proto.validate = function validate(properties) {
        if (properties === void 0) properties = {};
        var requiredKeys = [
            'serviceName',
            'serverUrl'
        ];
        var allKeys = Object.keys(this.config);
        var errors = {
            missing: [],
            invalid: [],
            unknown: []
        };
        Object.keys(properties).forEach(function(key) {
            if (requiredKeys.indexOf(key) !== -1 && !properties[key]) errors.missing.push(key);
            if (allKeys.indexOf(key) === -1) errors.unknown.push(key);
        });
        if (properties.serviceName && !/^[a-zA-Z0-9 _-]+$/.test(properties.serviceName)) errors.invalid.push({
            key: 'serviceName',
            value: properties.serviceName,
            allowed: 'a-z, A-Z, 0-9, _, -, <space>'
        });
        var sampleRate = properties.transactionSampleRate;
        if (typeof sampleRate !== 'undefined' && (typeof sampleRate !== 'number' || isNaN(sampleRate) || sampleRate < 0 || sampleRate > 1)) errors.invalid.push({
            key: 'transactionSampleRate',
            value: sampleRate,
            allowed: 'Number between 0 and 1'
        });
        return errors;
    };
    _proto.getLocalConfig = function getLocalConfig() {
        var storage = sessionStorage;
        if (this.config.session) storage = localStorage;
        var config = storage.getItem((0, $5YGG1.LOCAL_CONFIG_KEY));
        if (config) return JSON.parse(config);
    };
    _proto.setLocalConfig = function setLocalConfig(config, merge) {
        if (config) {
            if (merge) {
                var prevConfig = this.getLocalConfig();
                config = $df5bfa7aca585540$var$_extends({}, prevConfig, config);
            }
            var storage = sessionStorage;
            if (this.config.session) storage = localStorage;
            storage.setItem((0, $5YGG1.LOCAL_CONFIG_KEY), JSON.stringify(config));
        }
    };
    _proto.dispatchEvent = function dispatchEvent(name, args) {
        this.events.send(name, args);
    };
    _proto.observeEvent = function observeEvent(name, fn) {
        return this.events.observe(name, fn);
    };
    return Config;
}();
var $df5bfa7aca585540$export$2e2bcd8739ae039 = $df5bfa7aca585540$var$Config;

});

parcelRegister("kSc1y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3222d83dc922544$export$2e2bcd8739ae039; });

var $iCHUu = parcelRequire("iCHUu");
var $f3222d83dc922544$var$LoggingService = function() {
    function LoggingService(spec) {
        if (spec === void 0) spec = {};
        this.levels = [
            'trace',
            'debug',
            'info',
            'warn',
            'error'
        ];
        this.level = spec.level || 'warn';
        this.prefix = spec.prefix || '';
        this.resetLogMethods();
    }
    var _proto = LoggingService.prototype;
    _proto.shouldLog = function shouldLog(level) {
        return this.levels.indexOf(level) >= this.levels.indexOf(this.level);
    };
    _proto.setLevel = function setLevel(level) {
        if (level === this.level) return;
        this.level = level;
        this.resetLogMethods();
    };
    _proto.resetLogMethods = function resetLogMethods() {
        var _this = this;
        this.levels.forEach(function(level) {
            _this[level] = _this.shouldLog(level) ? log : (0, $iCHUu.noop);
            function log() {
                var normalizedLevel = level;
                if (level === 'trace' || level === 'debug') normalizedLevel = 'info';
                var args = arguments;
                args[0] = this.prefix + args[0];
                if (console) {
                    var realMethod = console[normalizedLevel] || console.log;
                    if (typeof realMethod === 'function') realMethod.apply(console, args);
                }
            }
        });
    };
    return LoggingService;
}();
var $f3222d83dc922544$export$2e2bcd8739ae039 = $f3222d83dc922544$var$LoggingService;

});



parcelRegister("kTzau", function(module, exports) {

$parcel$export(module.exports, "observeUserInteractions", function () { return $f364396593e5083a$export$57066f288181694e; });
$parcel$export(module.exports, "calculateInp", function () { return $f364396593e5083a$export$5ec729e92b081a59; });
$parcel$export(module.exports, "restoreINPState", function () { return $f364396593e5083a$export$8101508a6abf9c5c; });

var $5YGG1 = parcelRequire("5YGG1");

var $iCHUu = parcelRequire("iCHUu");

var $ksDDq = parcelRequire("ksDDq");
var $f364396593e5083a$var$INP_THRESHOLD = 40;
var $f364396593e5083a$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
var $f364396593e5083a$export$ce4caaf0f98f57c6 = {
    minInteractionId: Infinity,
    maxInteractionId: 0,
    interactionCount: 0,
    longestInteractions: []
};
function $f364396593e5083a$export$57066f288181694e(recorder) {
    if (recorder === void 0) recorder = new (0, $ksDDq.PerfEntryRecorder)($f364396593e5083a$export$c902b4a33027abbf);
    var isPerfCountSupported = (0, $iCHUu.isPerfInteractionCountSupported)();
    var durationThreshold = isPerfCountSupported ? $f364396593e5083a$var$INP_THRESHOLD : 16;
    recorder.start((0, $5YGG1.EVENT), {
        buffered: true,
        durationThreshold: durationThreshold
    });
    if (!isPerfCountSupported) recorder.start((0, $5YGG1.FIRST_INPUT));
}
function $f364396593e5083a$export$c902b4a33027abbf(list) {
    var entries = list.getEntries();
    entries.forEach(function(entry) {
        if (!entry.interactionId) return;
        $f364396593e5083a$var$updateInteractionCount(entry);
        if (entry.duration < $f364396593e5083a$var$INP_THRESHOLD) return;
        $f364396593e5083a$var$storeUserInteraction(entry);
    });
}
function $f364396593e5083a$export$5ec729e92b081a59() {
    if ($f364396593e5083a$export$ce4caaf0f98f57c6.longestInteractions.length === 0) {
        if ($f364396593e5083a$export$434fd613d1a3899c() > 0) return 0;
        return;
    }
    var interactionIndex = Math.min($f364396593e5083a$export$ce4caaf0f98f57c6.longestInteractions.length - 1, Math.floor($f364396593e5083a$export$434fd613d1a3899c() / 50));
    var inp = $f364396593e5083a$export$ce4caaf0f98f57c6.longestInteractions[interactionIndex].duration;
    return inp;
}
function $f364396593e5083a$export$434fd613d1a3899c() {
    return performance.interactionCount || $f364396593e5083a$export$ce4caaf0f98f57c6.interactionCount;
}
function $f364396593e5083a$export$8101508a6abf9c5c() {
    $f364396593e5083a$export$ce4caaf0f98f57c6.minInteractionId = Infinity;
    $f364396593e5083a$export$ce4caaf0f98f57c6.maxInteractionId = 0;
    $f364396593e5083a$export$ce4caaf0f98f57c6.interactionCount = 0;
    $f364396593e5083a$export$ce4caaf0f98f57c6.longestInteractions = [];
}
function $f364396593e5083a$var$storeUserInteraction(entry) {
    var leastSlow = $f364396593e5083a$export$ce4caaf0f98f57c6.longestInteractions[$f364396593e5083a$export$ce4caaf0f98f57c6.longestInteractions.length - 1];
    if (typeof leastSlow !== 'undefined' && entry.duration <= leastSlow.duration && entry.interactionId != leastSlow.id) return;
    var filteredInteraction = $f364396593e5083a$export$ce4caaf0f98f57c6.longestInteractions.filter(function(interaction) {
        return interaction.id === entry.interactionId;
    });
    if (filteredInteraction.length > 0) {
        var foundInteraction = filteredInteraction[0];
        foundInteraction.duration = Math.max(foundInteraction.duration, entry.duration);
    } else $f364396593e5083a$export$ce4caaf0f98f57c6.longestInteractions.push({
        id: entry.interactionId,
        duration: entry.duration
    });
    $f364396593e5083a$export$ce4caaf0f98f57c6.longestInteractions.sort(function(a, b) {
        return b.duration - a.duration;
    });
    $f364396593e5083a$export$ce4caaf0f98f57c6.longestInteractions.splice($f364396593e5083a$var$MAX_INTERACTIONS_TO_CONSIDER);
}
function $f364396593e5083a$var$updateInteractionCount(entry) {
    if ((0, $iCHUu.isPerfInteractionCountSupported)()) return;
    $f364396593e5083a$export$ce4caaf0f98f57c6.minInteractionId = Math.min($f364396593e5083a$export$ce4caaf0f98f57c6.minInteractionId, entry.interactionId);
    $f364396593e5083a$export$ce4caaf0f98f57c6.maxInteractionId = Math.max($f364396593e5083a$export$ce4caaf0f98f57c6.maxInteractionId, entry.interactionId);
    $f364396593e5083a$export$ce4caaf0f98f57c6.interactionCount = ($f364396593e5083a$export$ce4caaf0f98f57c6.maxInteractionId - $f364396593e5083a$export$ce4caaf0f98f57c6.minInteractionId) / 7 + 1;
}

});
parcelRegister("ksDDq", function(module, exports) {

$parcel$export(module.exports, "metrics", function () { return $ee552ad3c4cddd73$export$b0c5c2fac8144e54; });
$parcel$export(module.exports, "createTotalBlockingTimeSpan", function () { return $ee552ad3c4cddd73$export$4f167c0032dd3716; });
$parcel$export(module.exports, "captureObserverEntries", function () { return $ee552ad3c4cddd73$export$9042c3a3f5ee2ee; });
$parcel$export(module.exports, "PerfEntryRecorder", function () { return $ee552ad3c4cddd73$export$e105e1823c980668; });

var $5YGG1 = parcelRequire("5YGG1");

var $iCHUu = parcelRequire("iCHUu");

var $inqaX = parcelRequire("inqaX");
function $ee552ad3c4cddd73$var$_extends() {
    return $ee552ad3c4cddd73$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ee552ad3c4cddd73$var$_extends.apply(null, arguments);
}
var $ee552ad3c4cddd73$export$b0c5c2fac8144e54 = {
    fid: 0,
    fcp: 0,
    tbt: {
        start: Infinity,
        duration: 0
    },
    cls: {
        score: 0,
        firstEntryTime: Number.NEGATIVE_INFINITY,
        prevEntryTime: Number.NEGATIVE_INFINITY,
        currentSessionScore: 0
    },
    longtask: {
        count: 0,
        duration: 0,
        max: 0
    }
};
var $ee552ad3c4cddd73$var$LONG_TASK_THRESHOLD = 50;
function $ee552ad3c4cddd73$export$2bed7abe701121db(longtasks, agg) {
    var spans = [];
    for(var i = 0; i < longtasks.length; i++){
        var _longtasks$i = longtasks[i], name = _longtasks$i.name, startTime = _longtasks$i.startTime, duration = _longtasks$i.duration, attribution = _longtasks$i.attribution;
        var end = startTime + duration;
        var span = new (0, $inqaX.default)("Longtask(" + name + ")", (0, $5YGG1.LONG_TASK), {
            startTime: startTime
        });
        agg.count++;
        agg.duration += duration;
        agg.max = Math.max(duration, agg.max);
        if (attribution.length > 0) {
            var _attribution$ = attribution[0], _name = _attribution$.name, containerType = _attribution$.containerType, containerName = _attribution$.containerName, containerId = _attribution$.containerId;
            var customContext = {
                attribution: _name,
                type: containerType
            };
            if (containerName) customContext.name = containerName;
            if (containerId) customContext.id = containerId;
            span.addContext({
                custom: customContext
            });
        }
        span.end(end);
        spans.push(span);
    }
    return spans;
}
function $ee552ad3c4cddd73$export$dbb9abd64c7ad2de(fidEntries) {
    var firstInput = fidEntries[0];
    if (firstInput) {
        var startTime = firstInput.startTime, processingStart = firstInput.processingStart;
        var span = new (0, $inqaX.default)('First Input Delay', (0, $5YGG1.FIRST_INPUT), {
            startTime: startTime
        });
        span.end(processingStart);
        return span;
    }
}
function $ee552ad3c4cddd73$export$4f167c0032dd3716(tbtObject) {
    var start = tbtObject.start, duration = tbtObject.duration;
    var tbtSpan = new (0, $inqaX.default)('Total Blocking Time', (0, $5YGG1.LONG_TASK), {
        startTime: start
    });
    tbtSpan.end(start + duration);
    return tbtSpan;
}
function $ee552ad3c4cddd73$export$cdc3b71aeb75f979(longtaskEntries) {
    longtaskEntries.forEach(function(entry) {
        var name = entry.name, startTime = entry.startTime, duration = entry.duration;
        if (startTime < $ee552ad3c4cddd73$export$b0c5c2fac8144e54.fcp) return;
        if (name !== 'self' && name.indexOf('same-origin') === -1) return;
        $ee552ad3c4cddd73$export$b0c5c2fac8144e54.tbt.start = Math.min($ee552ad3c4cddd73$export$b0c5c2fac8144e54.tbt.start, startTime);
        var blockingTime = duration - $ee552ad3c4cddd73$var$LONG_TASK_THRESHOLD;
        if (blockingTime > 0) $ee552ad3c4cddd73$export$b0c5c2fac8144e54.tbt.duration += blockingTime;
    });
}
function $ee552ad3c4cddd73$export$1ee9edc2f05fc2c0(clsEntries) {
    clsEntries.forEach(function(entry) {
        if (!entry.hadRecentInput && entry.value) {
            var shouldCreateNewSession = entry.startTime - $ee552ad3c4cddd73$export$b0c5c2fac8144e54.cls.firstEntryTime > 5000 || entry.startTime - $ee552ad3c4cddd73$export$b0c5c2fac8144e54.cls.prevEntryTime > 1000;
            if (shouldCreateNewSession) {
                $ee552ad3c4cddd73$export$b0c5c2fac8144e54.cls.firstEntryTime = entry.startTime;
                $ee552ad3c4cddd73$export$b0c5c2fac8144e54.cls.currentSessionScore = 0;
            }
            $ee552ad3c4cddd73$export$b0c5c2fac8144e54.cls.prevEntryTime = entry.startTime;
            $ee552ad3c4cddd73$export$b0c5c2fac8144e54.cls.currentSessionScore += entry.value;
            $ee552ad3c4cddd73$export$b0c5c2fac8144e54.cls.score = Math.max($ee552ad3c4cddd73$export$b0c5c2fac8144e54.cls.score, $ee552ad3c4cddd73$export$b0c5c2fac8144e54.cls.currentSessionScore);
        }
    });
}
function $ee552ad3c4cddd73$export$9042c3a3f5ee2ee(list, _ref) {
    var isHardNavigation = _ref.isHardNavigation, trStart = _ref.trStart;
    var longtaskEntries = list.getEntriesByType((0, $5YGG1.LONG_TASK)).filter(function(entry) {
        return entry.startTime >= trStart;
    });
    var longTaskSpans = $ee552ad3c4cddd73$export$2bed7abe701121db(longtaskEntries, $ee552ad3c4cddd73$export$b0c5c2fac8144e54.longtask);
    var result = {
        spans: longTaskSpans,
        marks: {}
    };
    if (!isHardNavigation) return result;
    var lcpEntries = list.getEntriesByType((0, $5YGG1.LARGEST_CONTENTFUL_PAINT));
    var lastLcpEntry = lcpEntries[lcpEntries.length - 1];
    if (lastLcpEntry) {
        var lcp = parseInt(lastLcpEntry.startTime);
        $ee552ad3c4cddd73$export$b0c5c2fac8144e54.lcp = lcp;
        result.marks.largestContentfulPaint = lcp;
    }
    var timing = (0, $iCHUu.PERF).timing;
    var unloadDiff = timing.fetchStart - timing.navigationStart;
    if ((0, $iCHUu.isRedirectInfoAvailable)(timing)) unloadDiff = 0;
    var fcpEntry = list.getEntriesByName((0, $5YGG1.FIRST_CONTENTFUL_PAINT))[0];
    if (fcpEntry) {
        var fcp = parseInt(unloadDiff >= 0 ? fcpEntry.startTime - unloadDiff : fcpEntry.startTime);
        $ee552ad3c4cddd73$export$b0c5c2fac8144e54.fcp = fcp;
        result.marks.firstContentfulPaint = fcp;
    }
    var fidEntries = list.getEntriesByType((0, $5YGG1.FIRST_INPUT));
    var fidSpan = $ee552ad3c4cddd73$export$dbb9abd64c7ad2de(fidEntries);
    if (fidSpan) {
        $ee552ad3c4cddd73$export$b0c5c2fac8144e54.fid = fidSpan.duration();
        result.spans.push(fidSpan);
    }
    $ee552ad3c4cddd73$export$cdc3b71aeb75f979(longtaskEntries);
    var clsEntries = list.getEntriesByType((0, $5YGG1.LAYOUT_SHIFT));
    $ee552ad3c4cddd73$export$1ee9edc2f05fc2c0(clsEntries);
    return result;
}
var $ee552ad3c4cddd73$export$e105e1823c980668 = function() {
    function PerfEntryRecorder(callback) {
        this.po = {
            observe: (0, $iCHUu.noop),
            disconnect: (0, $iCHUu.noop)
        };
        if (window.PerformanceObserver) this.po = new PerformanceObserver(callback);
    }
    var _proto = PerfEntryRecorder.prototype;
    _proto.start = function start(type, options) {
        if (options === void 0) options = {
            buffered: true
        };
        try {
            if (!(0, $iCHUu.isPerfTypeSupported)(type)) return;
            this.po.observe($ee552ad3c4cddd73$var$_extends({
                type: type
            }, options));
        } catch (_) {}
    };
    _proto.stop = function stop() {
        this.po.disconnect();
    };
    return PerfEntryRecorder;
}();

});
parcelRegister("inqaX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d60eade900f6660a$export$2e2bcd8739ae039; });

var $feoe5 = parcelRequire("feoe5");

var $4E03a = parcelRequire("4E03a");
function $d60eade900f6660a$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $d60eade900f6660a$var$_setPrototypeOf(t, o);
}
function $d60eade900f6660a$var$_setPrototypeOf(t, e) {
    return $d60eade900f6660a$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $d60eade900f6660a$var$_setPrototypeOf(t, e);
}
var $d60eade900f6660a$var$Span = function(_SpanBase) {
    function Span(name, type, options) {
        var _this;
        _this = _SpanBase.call(this, name, type, options) || this;
        _this.parentId = _this.options.parentId;
        _this.subtype = undefined;
        _this.action = undefined;
        if (_this.type.indexOf('.') !== -1) {
            var fields = _this.type.split('.', 3);
            _this.type = fields[0];
            _this.subtype = fields[1];
            _this.action = fields[2];
        }
        _this.sync = _this.options.sync;
        return _this;
    }
    $d60eade900f6660a$var$_inheritsLoose(Span, _SpanBase);
    var _proto = Span.prototype;
    _proto.end = function end(endTime, data) {
        _SpanBase.prototype.end.call(this, endTime);
        (0, $4E03a.addSpanContext)(this, data);
    };
    return Span;
}((0, $feoe5.default));
var $d60eade900f6660a$export$2e2bcd8739ae039 = $d60eade900f6660a$var$Span;

});
parcelRegister("feoe5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b16af4a78852c50f$export$2e2bcd8739ae039; });

var $iCHUu = parcelRequire("iCHUu");

var $5YGG1 = parcelRequire("5YGG1");
var $b16af4a78852c50f$var$SpanBase = function() {
    function SpanBase(name, type, options) {
        if (options === void 0) options = {};
        if (!name) name = (0, $5YGG1.NAME_UNKNOWN);
        if (!type) type = (0, $5YGG1.TYPE_CUSTOM);
        this.name = name;
        this.type = type;
        this.options = options;
        this.id = options.id || (0, $iCHUu.generateRandomId)(16);
        this.traceId = options.traceId;
        this.sampled = options.sampled;
        this.sampleRate = options.sampleRate;
        this.timestamp = options.timestamp;
        this._start = (0, $iCHUu.getTime)(options.startTime);
        this._end = undefined;
        this.ended = false;
        this.outcome = undefined;
        this.onEnd = options.onEnd;
    }
    var _proto = SpanBase.prototype;
    _proto.ensureContext = function ensureContext() {
        if (!this.context) this.context = {};
    };
    _proto.addLabels = function addLabels(tags) {
        this.ensureContext();
        var ctx = this.context;
        if (!ctx.tags) ctx.tags = {};
        var keys = Object.keys(tags);
        keys.forEach(function(k) {
            return (0, $iCHUu.setLabel)(k, tags[k], ctx.tags);
        });
    };
    _proto.addContext = function addContext() {
        for(var _len = arguments.length, context = new Array(_len), _key = 0; _key < _len; _key++)context[_key] = arguments[_key];
        if (context.length === 0) return;
        this.ensureContext();
        this.context = (0, $iCHUu.merge).apply(void 0, [
            this.context
        ].concat(context));
    };
    _proto.end = function end(endTime) {
        if (this.ended) return;
        this.ended = true;
        this._end = (0, $iCHUu.getTime)(endTime);
        this.callOnEnd();
    };
    _proto.callOnEnd = function callOnEnd() {
        if (typeof this.onEnd === 'function') this.onEnd(this);
    };
    _proto.duration = function duration() {
        return (0, $iCHUu.getDuration)(this._start, this._end);
    };
    return SpanBase;
}();
var $b16af4a78852c50f$export$2e2bcd8739ae039 = $b16af4a78852c50f$var$SpanBase;

});




parcelRegister("aJXxB", function(module, exports) {

$parcel$export(module.exports, "registerServices", function () { return $7d1c4af5d47b0595$export$174fd5f90dd8a5db; });

var $bMGMV = parcelRequire("bMGMV");

var $jf87T = parcelRequire("jf87T");

var $5YGG1 = parcelRequire("5YGG1");

var $feGtA = parcelRequire("feGtA");

var $kTzau = parcelRequire("kTzau");

function $7d1c4af5d47b0595$export$174fd5f90dd8a5db() {
    (0, $feGtA.serviceCreators)[0, $5YGG1.TRANSACTION_SERVICE] = function(serviceFactory) {
        var _serviceFactory$getSe = serviceFactory.getService([
            (0, $5YGG1.LOGGING_SERVICE),
            (0, $5YGG1.CONFIG_SERVICE)
        ]), loggingService = _serviceFactory$getSe[0], configService = _serviceFactory$getSe[1];
        return new (0, $jf87T.default)(loggingService, configService);
    };
    (0, $feGtA.serviceCreators)[0, $5YGG1.PERFORMANCE_MONITORING] = function(serviceFactory) {
        var _serviceFactory$getSe2 = serviceFactory.getService([
            (0, $5YGG1.APM_SERVER),
            (0, $5YGG1.CONFIG_SERVICE),
            (0, $5YGG1.LOGGING_SERVICE),
            (0, $5YGG1.TRANSACTION_SERVICE)
        ]), apmServer = _serviceFactory$getSe2[0], configService = _serviceFactory$getSe2[1], loggingService = _serviceFactory$getSe2[2], transactionService = _serviceFactory$getSe2[3];
        return new (0, $bMGMV.default)(apmServer, configService, loggingService, transactionService);
    };
}

});
parcelRegister("bMGMV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89455e3f3123d649$export$2e2bcd8739ae039; });

var $iCHUu = parcelRequire("iCHUu");

var $g7QM3 = parcelRequire("g7QM3");

var $lQDSK = parcelRequire("lQDSK");

var $hfucu = parcelRequire("hfucu");

var $5YGG1 = parcelRequire("5YGG1");

var $jyXJ6 = parcelRequire("jyXJ6");

var $h1jmT = parcelRequire("h1jmT");
var $89455e3f3123d649$var$SIMILAR_SPAN_TO_TRANSACTION_RATIO = 0.05;
var $89455e3f3123d649$var$TRANSACTION_DURATION_THRESHOLD = 60000;
function $89455e3f3123d649$export$82a182639eda9ace(originalSpans, transDuration, threshold) {
    originalSpans.sort(function(spanA, spanB) {
        return spanA._start - spanB._start;
    });
    var spans = [];
    var lastCount = 1;
    originalSpans.forEach(function(span, index) {
        if (spans.length === 0) spans.push(span);
        else {
            var lastSpan = spans[spans.length - 1];
            var isContinuouslySimilar = lastSpan.type === span.type && lastSpan.subtype === span.subtype && lastSpan.action === span.action && lastSpan.name === span.name && span.duration() / transDuration < threshold && (span._start - lastSpan._end) / transDuration < threshold;
            var isLastSpan = originalSpans.length === index + 1;
            if (isContinuouslySimilar) {
                lastCount++;
                lastSpan._end = span._end;
            }
            if (lastCount > 1 && (!isContinuouslySimilar || isLastSpan)) {
                lastSpan.name = lastCount + 'x ' + lastSpan.name;
                lastCount = 1;
            }
            if (!isContinuouslySimilar) spans.push(span);
        }
    });
    return spans;
}
function $89455e3f3123d649$export$e5fabcf37bedf526(transaction) {
    if (transaction.sampled) {
        var filterdSpans = transaction.spans.filter(function(span) {
            return span.duration() > 0 && span._start >= transaction._start && span._end <= transaction._end;
        });
        if (transaction.isManaged()) {
            var duration = transaction.duration();
            var similarSpans = $89455e3f3123d649$export$82a182639eda9ace(filterdSpans, duration, $89455e3f3123d649$var$SIMILAR_SPAN_TO_TRANSACTION_RATIO);
            transaction.spans = similarSpans;
        } else transaction.spans = filterdSpans;
    } else transaction.resetFields();
    return transaction;
}
var $89455e3f3123d649$export$2e2bcd8739ae039 = function() {
    function PerformanceMonitoring(apmServer, configService, loggingService, transactionService) {
        this._apmServer = apmServer;
        this._configService = configService;
        this._logginService = loggingService;
        this._transactionService = transactionService;
    }
    var _proto = PerformanceMonitoring.prototype;
    _proto.init = function init(flags) {
        var _this = this;
        if (flags === void 0) flags = {};
        this._configService.events.observe((0, $5YGG1.TRANSACTION_END) + (0, $5YGG1.AFTER_EVENT), function(tr) {
            var payload = _this.createTransactionPayload(tr);
            if (payload) {
                _this._apmServer.addTransaction(payload);
                _this._configService.dispatchEvent((0, $5YGG1.QUEUE_ADD_TRANSACTION));
            }
        });
        if (flags[0, $5YGG1.HISTORY]) (0, $lQDSK.patchEventHandler).observe((0, $5YGG1.HISTORY), this.getHistorySub());
        if (flags[0, $5YGG1.XMLHTTPREQUEST]) (0, $lQDSK.patchEventHandler).observe((0, $5YGG1.XMLHTTPREQUEST), this.getXHRSub());
        if (flags[0, $5YGG1.FETCH]) (0, $lQDSK.patchEventHandler).observe((0, $5YGG1.FETCH), this.getFetchSub());
    };
    _proto.getHistorySub = function getHistorySub() {
        var transactionService = this._transactionService;
        return function(event, task) {
            if (task.source === (0, $5YGG1.HISTORY) && event === (0, $5YGG1.INVOKE)) transactionService.startTransaction(task.data.title, 'route-change', {
                managed: true,
                canReuse: true
            });
        };
    };
    _proto.getXHRSub = function getXHRSub() {
        var _this2 = this;
        return function(event, task) {
            if (task.source === (0, $5YGG1.XMLHTTPREQUEST) && !(0, $hfucu.globalState).fetchInProgress) _this2.processAPICalls(event, task);
        };
    };
    _proto.getFetchSub = function getFetchSub() {
        var _this3 = this;
        return function(event, task) {
            if (task.source === (0, $5YGG1.FETCH)) _this3.processAPICalls(event, task);
        };
    };
    _proto.processAPICalls = function processAPICalls(event, task) {
        var configService = this._configService;
        var transactionService = this._transactionService;
        if (task.data && task.data.url) {
            var endpoints = this._apmServer.getEndpoints();
            var isOwnEndpoint = Object.keys(endpoints).some(function(endpoint) {
                return task.data.url.indexOf(endpoints[endpoint]) !== -1;
            });
            if (isOwnEndpoint) return;
        }
        if (event === (0, $5YGG1.SCHEDULE) && task.data) {
            var data = task.data;
            var requestUrl = new (0, $g7QM3.Url)(data.url);
            var spanName = data.method + ' ' + (requestUrl.relative ? requestUrl.path : (0, $iCHUu.stripQueryStringFromUrl)(requestUrl.href));
            if (!transactionService.getCurrentTransaction()) transactionService.startTransaction(spanName, (0, $5YGG1.HTTP_REQUEST_TYPE), {
                managed: true
            });
            var span = transactionService.startSpan(spanName, 'external.http', {
                blocking: true
            });
            if (!span) return;
            var isDtEnabled = configService.get('distributedTracing');
            var dtOrigins = configService.get('distributedTracingOrigins');
            var currentUrl = new (0, $g7QM3.Url)(window.location.href);
            var isSameOrigin = (0, $iCHUu.checkSameOrigin)(requestUrl.origin, currentUrl.origin) || (0, $iCHUu.checkSameOrigin)(requestUrl.origin, dtOrigins);
            var target = data.target;
            if (isDtEnabled && isSameOrigin && target) {
                this.injectDtHeader(span, target);
                var propagateTracestate = configService.get('propagateTracestate');
                if (propagateTracestate) this.injectTSHeader(span, target);
            } else if (0, $h1jmT.__DEV__) this._logginService.debug("Could not inject distributed tracing header to the request origin ('" + requestUrl.origin + "') from the current origin ('" + currentUrl.origin + "')");
            if (data.sync) span.sync = data.sync;
            data.span = span;
        } else if (event === (0, $5YGG1.INVOKE)) {
            var _data = task.data;
            if (_data && _data.span) {
                var _span = _data.span, response = _data.response, _target = _data.target;
                var status;
                if (response) status = response.status;
                else status = _target.status;
                var outcome;
                if (_data.status != 'abort' && !_data.aborted) {
                    if (status >= 400 || status == 0) outcome = (0, $5YGG1.OUTCOME_FAILURE);
                    else outcome = (0, $5YGG1.OUTCOME_SUCCESS);
                } else outcome = (0, $5YGG1.OUTCOME_UNKNOWN);
                _span.outcome = outcome;
                var tr = transactionService.getCurrentTransaction();
                if (tr && tr.type === (0, $5YGG1.HTTP_REQUEST_TYPE)) tr.outcome = outcome;
                transactionService.endSpan(_span, _data);
            }
        }
    };
    _proto.injectDtHeader = function injectDtHeader(span, target) {
        var headerName = this._configService.get('distributedTracingHeaderName');
        var headerValue = (0, $iCHUu.getDtHeaderValue)(span);
        var isHeaderValid = (0, $iCHUu.isDtHeaderValid)(headerValue);
        if (isHeaderValid && headerValue && headerName) (0, $iCHUu.setRequestHeader)(target, headerName, headerValue);
    };
    _proto.injectTSHeader = function injectTSHeader(span, target) {
        var headerValue = (0, $iCHUu.getTSHeaderValue)(span);
        if (headerValue) (0, $iCHUu.setRequestHeader)(target, 'tracestate', headerValue);
    };
    _proto.extractDtHeader = function extractDtHeader(target) {
        var configService = this._configService;
        var headerName = configService.get('distributedTracingHeaderName');
        if (target) return (0, $iCHUu.parseDtHeaderValue)(target[headerName]);
    };
    _proto.filterTransaction = function filterTransaction(tr) {
        var duration = tr.duration();
        if (!duration) {
            if (0, $h1jmT.__DEV__) {
                var message = "transaction(" + tr.id + ", " + tr.name + ") was discarded! ";
                if (duration === 0) message += "Transaction duration is 0";
                else message += "Transaction wasn't ended";
                this._logginService.debug(message);
            }
            return false;
        }
        if (tr.isManaged()) {
            if (duration > $89455e3f3123d649$var$TRANSACTION_DURATION_THRESHOLD) {
                if (0, $h1jmT.__DEV__) this._logginService.debug("transaction(" + tr.id + ", " + tr.name + ") was discarded! Transaction duration (" + duration + ") is greater than managed transaction threshold (" + $89455e3f3123d649$var$TRANSACTION_DURATION_THRESHOLD + ")");
                return false;
            }
            var recordEmpty = this._configService.get('reportTransactionsWithoutSpans');
            if (tr.sampled && tr.spans.length === 0 && !recordEmpty) {
                if (0, $h1jmT.__DEV__) this._logginService.debug("transaction(" + tr.id + ", " + tr.name + ") was discarded! Transaction does not have any spans");
                return false;
            }
        }
        return true;
    };
    _proto.createTransactionDataModel = function createTransactionDataModel(transaction) {
        var transactionStart = transaction._start;
        var spans = transaction.spans.map(function(span) {
            var spanData = {
                id: span.id,
                transaction_id: transaction.id,
                parent_id: span.parentId || transaction.id,
                trace_id: transaction.traceId,
                name: span.name,
                type: span.type,
                subtype: span.subtype,
                action: span.action,
                sync: span.sync,
                start: parseInt(span._start - transactionStart),
                duration: span.duration(),
                context: span.context,
                outcome: span.outcome,
                sample_rate: span.sampleRate
            };
            return (0, $jyXJ6.truncateModel)((0, $jyXJ6.SPAN_MODEL), spanData);
        });
        var transactionData = {
            id: transaction.id,
            parent_id: transaction.parentId,
            trace_id: transaction.traceId,
            session: transaction.session,
            name: transaction.name,
            type: transaction.type,
            duration: transaction.duration(),
            spans: spans,
            context: transaction.context,
            marks: transaction.marks,
            breakdown: transaction.breakdownTimings,
            span_count: {
                started: spans.length
            },
            sampled: transaction.sampled,
            sample_rate: transaction.sampleRate,
            experience: transaction.experience,
            outcome: transaction.outcome
        };
        return (0, $jyXJ6.truncateModel)((0, $jyXJ6.TRANSACTION_MODEL), transactionData);
    };
    _proto.createTransactionPayload = function createTransactionPayload(transaction) {
        var adjustedTransaction = $89455e3f3123d649$export$e5fabcf37bedf526(transaction);
        var filtered = this.filterTransaction(adjustedTransaction);
        if (filtered) return this.createTransactionDataModel(transaction);
        this._configService.dispatchEvent((0, $5YGG1.TRANSACTION_IGNORE));
    };
    return PerformanceMonitoring;
}();

});

parcelRegister("jf87T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e025b8c198d51242$export$2e2bcd8739ae039; });

var $g76Dc = parcelRequire("g76Dc");

var $bqNbE = parcelRequire("bqNbE");

var $ksDDq = parcelRequire("ksDDq");

var $iCHUu = parcelRequire("iCHUu");

var $4LDCS = parcelRequire("4LDCS");

var $5YGG1 = parcelRequire("5YGG1");

var $4E03a = parcelRequire("4E03a");

var $h1jmT = parcelRequire("h1jmT");

var $g7QM3 = parcelRequire("g7QM3");
var $e025b8c198d51242$var$TransactionService = function() {
    function TransactionService(logger, config) {
        var _this = this;
        this._config = config;
        this._logger = logger;
        this.currentTransaction = undefined;
        this.respIntervalId = undefined;
        this.recorder = new (0, $ksDDq.PerfEntryRecorder)(function(list) {
            var tr = _this.getCurrentTransaction();
            if (tr && tr.captureTimings) {
                var _tr$spans;
                var isHardNavigation = tr.type === (0, $5YGG1.PAGE_LOAD);
                var _captureObserverEntri = (0, $ksDDq.captureObserverEntries)(list, {
                    isHardNavigation: isHardNavigation,
                    trStart: isHardNavigation ? 0 : tr._start
                }), spans = _captureObserverEntri.spans, marks = _captureObserverEntri.marks;
                (_tr$spans = tr.spans).push.apply(_tr$spans, spans);
                tr.addMarks({
                    agent: marks
                });
            }
        });
    }
    var _proto = TransactionService.prototype;
    _proto.createCurrentTransaction = function createCurrentTransaction(name, type, options) {
        var tr = new (0, $bqNbE.default)(name, type, options);
        this.currentTransaction = tr;
        return tr;
    };
    _proto.getCurrentTransaction = function getCurrentTransaction() {
        if (this.currentTransaction && !this.currentTransaction.ended) return this.currentTransaction;
    };
    _proto.createOptions = function createOptions(options) {
        var config = this._config.config;
        var presetOptions = {
            transactionSampleRate: config.transactionSampleRate
        };
        var perfOptions = (0, $iCHUu.extend)(presetOptions, options);
        if (perfOptions.managed) perfOptions = (0, $iCHUu.extend)({
            pageLoadTraceId: config.pageLoadTraceId,
            pageLoadSampled: config.pageLoadSampled,
            pageLoadSpanId: config.pageLoadSpanId,
            pageLoadTransactionName: config.pageLoadTransactionName,
            pageLoadParentId: config.pageLoadParentId
        }, perfOptions);
        return perfOptions;
    };
    _proto.startManagedTransaction = function startManagedTransaction(name, type, perfOptions) {
        var tr = this.getCurrentTransaction();
        var isRedefined = false;
        if (!tr) tr = this.createCurrentTransaction(name, type, perfOptions);
        else if (tr.canReuse() && perfOptions.canReuse) {
            var redefineType = tr.type;
            var currentTypeOrder = (0, $5YGG1.TRANSACTION_TYPE_ORDER).indexOf(tr.type);
            var redefineTypeOrder = (0, $5YGG1.TRANSACTION_TYPE_ORDER).indexOf(type);
            if (currentTypeOrder >= 0 && redefineTypeOrder < currentTypeOrder) redefineType = type;
            if (0, $h1jmT.__DEV__) this._logger.debug("redefining transaction(" + tr.id + ", " + tr.name + ", " + tr.type + ")", 'to', "(" + (name || tr.name) + ", " + redefineType + ")", tr);
            tr.redefine(name, redefineType, perfOptions);
            isRedefined = true;
        } else {
            if (0, $h1jmT.__DEV__) this._logger.debug("ending previous transaction(" + tr.id + ", " + tr.name + ")", tr);
            tr.end();
            tr = this.createCurrentTransaction(name, type, perfOptions);
        }
        if (tr.type === (0, $5YGG1.PAGE_LOAD)) {
            if (!isRedefined) {
                this.recorder.start((0, $5YGG1.LARGEST_CONTENTFUL_PAINT));
                this.recorder.start((0, $5YGG1.PAINT));
                this.recorder.start((0, $5YGG1.FIRST_INPUT));
                this.recorder.start((0, $5YGG1.LAYOUT_SHIFT));
            }
            if (perfOptions.pageLoadTraceId) tr.traceId = perfOptions.pageLoadTraceId;
            if (perfOptions.pageLoadSampled) tr.sampled = perfOptions.pageLoadSampled;
            if (tr.name === (0, $5YGG1.NAME_UNKNOWN) && perfOptions.pageLoadTransactionName) tr.name = perfOptions.pageLoadTransactionName;
        }
        if (!isRedefined && this._config.get('monitorLongtasks')) this.recorder.start((0, $5YGG1.LONG_TASK));
        if (tr.sampled) tr.captureTimings = true;
        return tr;
    };
    _proto.startTransaction = function startTransaction(name, type, options) {
        var _this2 = this;
        var perfOptions = this.createOptions(options);
        var tr;
        var fireOnstartHook = true;
        if (perfOptions.managed) {
            var current = this.currentTransaction;
            tr = this.startManagedTransaction(name, type, perfOptions);
            if (current === tr) fireOnstartHook = false;
        } else tr = new (0, $bqNbE.default)(name, type, perfOptions);
        tr.onEnd = function() {
            return _this2.handleTransactionEnd(tr);
        };
        if (fireOnstartHook) {
            if (0, $h1jmT.__DEV__) this._logger.debug("startTransaction(" + tr.id + ", " + tr.name + ", " + tr.type + ")");
            this._config.events.send((0, $5YGG1.TRANSACTION_START), [
                tr
            ]);
        }
        return tr;
    };
    _proto.handleTransactionEnd = function handleTransactionEnd(tr) {
        var _this3 = this;
        this.recorder.stop();
        var currentUrl = window.location.href;
        return (0, $g76Dc.Promise).resolve().then(function() {
            var name = tr.name, type = tr.type;
            var lastHiddenStart = (0, $h1jmT.state).lastHiddenStart;
            if (lastHiddenStart >= tr._start) {
                if (0, $h1jmT.__DEV__) _this3._logger.debug("transaction(" + tr.id + ", " + name + ", " + type + ") was discarded! The page was hidden during the transaction!");
                _this3._config.dispatchEvent((0, $5YGG1.TRANSACTION_IGNORE));
                return;
            }
            if (_this3.shouldIgnoreTransaction(name) || type === (0, $5YGG1.TEMPORARY_TYPE)) {
                if (0, $h1jmT.__DEV__) _this3._logger.debug("transaction(" + tr.id + ", " + name + ", " + type + ") is ignored");
                _this3._config.dispatchEvent((0, $5YGG1.TRANSACTION_IGNORE));
                return;
            }
            if (type === (0, $5YGG1.PAGE_LOAD)) {
                var pageLoadTransactionName = _this3._config.get('pageLoadTransactionName');
                if (name === (0, $5YGG1.NAME_UNKNOWN) && pageLoadTransactionName) tr.name = pageLoadTransactionName;
                if (tr.captureTimings) {
                    var cls = (0, $ksDDq.metrics).cls, fid = (0, $ksDDq.metrics).fid, tbt = (0, $ksDDq.metrics).tbt, longtask = (0, $ksDDq.metrics).longtask;
                    if (tbt.duration > 0) tr.spans.push((0, $ksDDq.createTotalBlockingTimeSpan)(tbt));
                    tr.experience = {};
                    if ((0, $iCHUu.isPerfTypeSupported)((0, $5YGG1.LONG_TASK))) tr.experience.tbt = tbt.duration;
                    if ((0, $iCHUu.isPerfTypeSupported)((0, $5YGG1.LAYOUT_SHIFT))) tr.experience.cls = cls.score;
                    if (fid > 0) tr.experience.fid = fid;
                    if (longtask.count > 0) tr.experience.longtask = {
                        count: longtask.count,
                        sum: longtask.duration,
                        max: longtask.max
                    };
                }
                _this3.setSession(tr);
            }
            if (tr.name === (0, $5YGG1.NAME_UNKNOWN)) tr.name = (0, $g7QM3.slugifyUrl)(currentUrl);
            (0, $4LDCS.captureNavigation)(tr);
            _this3.adjustTransactionTime(tr);
            var breakdownMetrics = _this3._config.get('breakdownMetrics');
            if (breakdownMetrics) tr.captureBreakdown();
            var configContext = _this3._config.get('context');
            (0, $4E03a.addTransactionContext)(tr, configContext);
            _this3._config.events.send((0, $5YGG1.TRANSACTION_END), [
                tr
            ]);
            if (0, $h1jmT.__DEV__) _this3._logger.debug("end transaction(" + tr.id + ", " + tr.name + ", " + tr.type + ")", tr);
        }, function(err) {
            if (0, $h1jmT.__DEV__) _this3._logger.debug("error ending transaction(" + tr.id + ", " + tr.name + ")", err);
        });
    };
    _proto.setSession = function setSession(tr) {
        var session = this._config.get('session');
        if (session) {
            if (typeof session == 'boolean') tr.session = {
                id: (0, $iCHUu.generateRandomId)(16),
                sequence: 1
            };
            else if (session.timestamp && Date.now() - session.timestamp > (0, $5YGG1.SESSION_TIMEOUT)) tr.session = {
                id: (0, $iCHUu.generateRandomId)(16),
                sequence: 1
            };
            else tr.session = {
                id: session.id,
                sequence: session.sequence ? session.sequence + 1 : 1
            };
            var sessionConfig = {
                session: {
                    id: tr.session.id,
                    sequence: tr.session.sequence,
                    timestamp: Date.now()
                }
            };
            this._config.setConfig(sessionConfig);
            this._config.setLocalConfig(sessionConfig, true);
        }
    };
    _proto.adjustTransactionTime = function adjustTransactionTime(transaction) {
        var spans = transaction.spans;
        var earliestSpan = (0, $iCHUu.getEarliestSpan)(spans);
        if (earliestSpan && earliestSpan._start < transaction._start) transaction._start = earliestSpan._start;
        var latestSpan = (0, $iCHUu.getLatestNonXHRSpan)(spans) || {};
        var latestSpanEnd = latestSpan._end || 0;
        if (transaction.type === (0, $5YGG1.PAGE_LOAD)) {
            var transactionEndWithoutDelay = transaction._end - (0, $5YGG1.PAGE_LOAD_DELAY);
            var lcp = (0, $ksDDq.metrics).lcp || 0;
            var latestXHRSpan = (0, $iCHUu.getLatestXHRSpan)(spans) || {};
            var latestXHRSpanEnd = latestXHRSpan._end || 0;
            transaction._end = Math.max(latestSpanEnd, latestXHRSpanEnd, lcp, transactionEndWithoutDelay);
        } else if (latestSpanEnd > transaction._end) transaction._end = latestSpanEnd;
        this.truncateSpans(spans, transaction._end);
    };
    _proto.truncateSpans = function truncateSpans(spans, transactionEnd) {
        for(var i = 0; i < spans.length; i++){
            var span = spans[i];
            if (span._end > transactionEnd) {
                span._end = transactionEnd;
                span.type += (0, $5YGG1.TRUNCATED_TYPE);
            }
            if (span._start > transactionEnd) span._start = transactionEnd;
        }
    };
    _proto.shouldIgnoreTransaction = function shouldIgnoreTransaction(transactionName) {
        var ignoreList = this._config.get('ignoreTransactions');
        if (ignoreList && ignoreList.length) for(var i = 0; i < ignoreList.length; i++){
            var element = ignoreList[i];
            if (typeof element.test === 'function') {
                if (element.test(transactionName)) return true;
            } else if (element === transactionName) return true;
        }
        return false;
    };
    _proto.startSpan = function startSpan(name, type, options) {
        var tr = this.getCurrentTransaction();
        if (!tr) tr = this.createCurrentTransaction(undefined, (0, $5YGG1.TEMPORARY_TYPE), this.createOptions({
            canReuse: true,
            managed: true
        }));
        var span = tr.startSpan(name, type, options);
        if (0, $h1jmT.__DEV__) this._logger.debug("startSpan(" + name + ", " + span.type + ")", "on transaction(" + tr.id + ", " + tr.name + ")");
        return span;
    };
    _proto.endSpan = function endSpan(span, context) {
        if (!span) return;
        if (0, $h1jmT.__DEV__) {
            var tr = this.getCurrentTransaction();
            tr && this._logger.debug("endSpan(" + span.name + ", " + span.type + ")", "on transaction(" + tr.id + ", " + tr.name + ")");
        }
        span.end(null, context);
    };
    return TransactionService;
}();
var $e025b8c198d51242$export$2e2bcd8739ae039 = $e025b8c198d51242$var$TransactionService;

});
parcelRegister("bqNbE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $852846e4117f597b$export$2e2bcd8739ae039; });

var $inqaX = parcelRequire("inqaX");

var $feoe5 = parcelRequire("feoe5");

var $iCHUu = parcelRequire("iCHUu");

var $5YGG1 = parcelRequire("5YGG1");

var $hdQ8C = parcelRequire("hdQ8C");
function $852846e4117f597b$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $852846e4117f597b$var$_setPrototypeOf(t, o);
}
function $852846e4117f597b$var$_setPrototypeOf(t, e) {
    return $852846e4117f597b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $852846e4117f597b$var$_setPrototypeOf(t, e);
}
var $852846e4117f597b$var$Transaction = function(_SpanBase) {
    function Transaction(name, type, options) {
        var _this;
        _this = _SpanBase.call(this, name, type, options) || this;
        _this.traceId = (0, $iCHUu.generateRandomId)();
        _this.marks = undefined;
        _this.spans = [];
        _this._activeSpans = {};
        _this._activeTasks = new Set();
        _this.blocked = false;
        _this.captureTimings = false;
        _this.breakdownTimings = [];
        _this.sampleRate = _this.options.transactionSampleRate;
        _this.sampled = Math.random() <= _this.sampleRate;
        return _this;
    }
    $852846e4117f597b$var$_inheritsLoose(Transaction, _SpanBase);
    var _proto = Transaction.prototype;
    _proto.addMarks = function addMarks(obj) {
        this.marks = (0, $iCHUu.merge)(this.marks || {}, obj);
    };
    _proto.mark = function mark(key) {
        var skey = (0, $iCHUu.removeInvalidChars)(key);
        var markTime = (0, $iCHUu.now)() - this._start;
        var custom = {};
        custom[skey] = markTime;
        this.addMarks({
            custom: custom
        });
    };
    _proto.canReuse = function canReuse() {
        var threshold = this.options.reuseThreshold || (0, $5YGG1.REUSABILITY_THRESHOLD);
        return !!this.options.canReuse && !this.ended && (0, $iCHUu.now)() - this._start < threshold;
    };
    _proto.redefine = function redefine(name, type, options) {
        if (name) this.name = name;
        if (type) this.type = type;
        if (options) {
            this.options.reuseThreshold = options.reuseThreshold;
            this.options = (0, $iCHUu.extend)(this.options, options);
        }
    };
    _proto.startSpan = function startSpan(name, type, options) {
        var _this2 = this;
        if (this.ended) return;
        var opts = (0, $iCHUu.extend)({}, options);
        opts.onEnd = function(trc) {
            _this2._onSpanEnd(trc);
        };
        opts.traceId = this.traceId;
        opts.sampled = this.sampled;
        opts.sampleRate = this.sampleRate;
        if (!opts.parentId) opts.parentId = this.id;
        var span = new (0, $inqaX.default)(name, type, opts);
        this._activeSpans[span.id] = span;
        if (opts.blocking) this.addTask(span.id);
        return span;
    };
    _proto.isFinished = function isFinished() {
        return !this.blocked && this._activeTasks.size === 0;
    };
    _proto.detectFinish = function detectFinish() {
        if (this.isFinished()) this.end();
    };
    _proto.end = function end(endTime) {
        if (this.ended) return;
        this.ended = true;
        this._end = (0, $iCHUu.getTime)(endTime);
        for(var sid in this._activeSpans){
            var span = this._activeSpans[sid];
            span.type = span.type + (0, $5YGG1.TRUNCATED_TYPE);
            span.end(endTime);
        }
        this.callOnEnd();
    };
    _proto.captureBreakdown = function captureBreakdown() {
        this.breakdownTimings = (0, $hdQ8C.captureBreakdown)(this);
    };
    _proto.block = function block(flag) {
        this.blocked = flag;
        if (!this.blocked) this.detectFinish();
    };
    _proto.addTask = function addTask(taskId) {
        if (!taskId) taskId = 'task-' + (0, $iCHUu.generateRandomId)(16);
        this._activeTasks.add(taskId);
        return taskId;
    };
    _proto.removeTask = function removeTask(taskId) {
        var deleted = this._activeTasks.delete(taskId);
        deleted && this.detectFinish();
    };
    _proto.resetFields = function resetFields() {
        this.spans = [];
        this.sampleRate = 0;
    };
    _proto._onSpanEnd = function _onSpanEnd(span) {
        this.spans.push(span);
        delete this._activeSpans[span.id];
        this.removeTask(span.id);
    };
    _proto.isManaged = function isManaged() {
        return !!this.options.managed;
    };
    return Transaction;
}((0, $feoe5.default));
var $852846e4117f597b$export$2e2bcd8739ae039 = $852846e4117f597b$var$Transaction;

});
parcelRegister("hdQ8C", function(module, exports) {

$parcel$export(module.exports, "captureBreakdown", function () { return $c89c181704e07118$export$f29e26af65381f57; });

var $iCHUu = parcelRequire("iCHUu");

var $5YGG1 = parcelRequire("5YGG1");
var $c89c181704e07118$var$pageLoadBreakdowns = [
    [
        'domainLookupStart',
        'domainLookupEnd',
        'DNS'
    ],
    [
        'connectStart',
        'connectEnd',
        'TCP'
    ],
    [
        'requestStart',
        'responseStart',
        'Request'
    ],
    [
        'responseStart',
        'responseEnd',
        'Response'
    ],
    [
        'domLoading',
        'domComplete',
        'Processing'
    ],
    [
        'loadEventStart',
        'loadEventEnd',
        'Load'
    ]
];
function $c89c181704e07118$var$getValue(value) {
    return {
        value: value
    };
}
function $c89c181704e07118$var$calculateSelfTime(transaction) {
    var spans = transaction.spans, _start = transaction._start, _end = transaction._end;
    if (spans.length === 0) return transaction.duration();
    spans.sort(function(span1, span2) {
        return span1._start - span2._start;
    });
    var span = spans[0];
    var spanEnd = span._end;
    var spanStart = span._start;
    var lastContinuousEnd = spanEnd;
    var selfTime = spanStart - _start;
    for(var i = 1; i < spans.length; i++){
        span = spans[i];
        spanStart = span._start;
        spanEnd = span._end;
        if (spanStart > lastContinuousEnd) {
            selfTime += spanStart - lastContinuousEnd;
            lastContinuousEnd = spanEnd;
        } else if (spanEnd > lastContinuousEnd) lastContinuousEnd = spanEnd;
    }
    if (lastContinuousEnd < _end) selfTime += _end - lastContinuousEnd;
    return selfTime;
}
function $c89c181704e07118$var$groupSpans(transaction) {
    var spanMap = {};
    var transactionSelfTime = $c89c181704e07118$var$calculateSelfTime(transaction);
    spanMap['app'] = {
        count: 1,
        duration: transactionSelfTime
    };
    var spans = transaction.spans;
    for(var i = 0; i < spans.length; i++){
        var span = spans[i];
        var duration = span.duration();
        if (duration === 0 || duration == null) continue;
        var type = span.type, subtype = span.subtype;
        var key = type.replace((0, $5YGG1.TRUNCATED_TYPE), '');
        if (subtype) key += '.' + subtype;
        if (!spanMap[key]) spanMap[key] = {
            duration: 0,
            count: 0
        };
        spanMap[key].count++;
        spanMap[key].duration += duration;
    }
    return spanMap;
}
function $c89c181704e07118$var$getSpanBreakdown(transactionDetails, _ref) {
    var details = _ref.details, _ref$count = _ref.count, count = _ref$count === void 0 ? 1 : _ref$count, duration = _ref.duration;
    return {
        transaction: transactionDetails,
        span: details,
        samples: {
            'span.self_time.count': $c89c181704e07118$var$getValue(count),
            'span.self_time.sum.us': $c89c181704e07118$var$getValue(duration * 1000)
        }
    };
}
function $c89c181704e07118$export$f29e26af65381f57(transaction, timings) {
    if (timings === void 0) timings = (0, $iCHUu.PERF).timing;
    var breakdowns = [];
    var name = transaction.name, type = transaction.type, sampled = transaction.sampled;
    var transactionDetails = {
        name: name,
        type: type
    };
    if (!sampled) return breakdowns;
    if (type === (0, $5YGG1.PAGE_LOAD) && timings) for(var i = 0; i < $c89c181704e07118$var$pageLoadBreakdowns.length; i++){
        var current = $c89c181704e07118$var$pageLoadBreakdowns[i];
        var start = timings[current[0]];
        var end = timings[current[1]];
        var duration = (0, $iCHUu.getDuration)(start, end);
        if (duration === 0 || duration == null) continue;
        breakdowns.push($c89c181704e07118$var$getSpanBreakdown(transactionDetails, {
            details: {
                type: current[2]
            },
            duration: duration
        }));
    }
    else {
        var spanMap = $c89c181704e07118$var$groupSpans(transaction);
        Object.keys(spanMap).forEach(function(key) {
            var _key$split = key.split('.'), type = _key$split[0], subtype = _key$split[1];
            var _spanMap$key = spanMap[key], duration = _spanMap$key.duration, count = _spanMap$key.count;
            breakdowns.push($c89c181704e07118$var$getSpanBreakdown(transactionDetails, {
                details: {
                    type: type,
                    subtype: subtype
                },
                duration: duration,
                count: count
            }));
        });
    }
    return breakdowns;
}

});


parcelRegister("4LDCS", function(module, exports) {

$parcel$export(module.exports, "captureNavigation", function () { return $378a4a227f2ebceb$export$ffbf565d212a6a74; });

var $iCHUu = parcelRequire("iCHUu");

var $5YGG1 = parcelRequire("5YGG1");

var $h1jmT = parcelRequire("h1jmT");

var $jfgyU = parcelRequire("jfgyU");

var $j9MrU = parcelRequire("j9MrU");

var $hJ4Qu = parcelRequire("hJ4Qu");

var $PSJt9 = parcelRequire("PSJt9");
function $378a4a227f2ebceb$export$ffbf565d212a6a74(transaction) {
    if (!transaction.captureTimings) {
        if (transaction.type === (0, $5YGG1.PAGE_LOAD)) transaction._start = 0;
        return;
    }
    var trEnd = transaction._end;
    if (transaction.type === (0, $5YGG1.PAGE_LOAD)) {
        if (transaction.marks && transaction.marks.custom) {
            var customMarks = transaction.marks.custom;
            Object.keys(customMarks).forEach(function(key) {
                customMarks[key] += transaction._start;
            });
        }
        var trStart = 0;
        transaction._start = trStart;
        var timings = (0, $iCHUu.PERF).timing;
        var baseTime = (0, $iCHUu.isRedirectInfoAvailable)(timings) ? timings.redirectStart : timings.fetchStart;
        (0, $jfgyU.createNavigationTimingSpans)(timings, baseTime, trStart, trEnd).forEach(function(span) {
            span.traceId = transaction.traceId;
            span.sampled = transaction.sampled;
            if (span.pageResponse && transaction.options.pageLoadSpanId) span.id = transaction.options.pageLoadSpanId;
            transaction.spans.push(span);
        });
        if (transaction.options.pageLoadParentId) transaction.parentId = transaction.options.pageLoadParentId;
        transaction.addMarks((0, $PSJt9.getPageLoadMarks)(timings));
    }
    if ((0, $iCHUu.isPerfTimelineSupported)()) {
        var _trStart = transaction._start;
        var resourceEntries = (0, $iCHUu.PERF).getEntriesByType((0, $5YGG1.RESOURCE));
        (0, $hJ4Qu.createResourceTimingSpans)(resourceEntries, (0, $h1jmT.state).bootstrapTime, _trStart, trEnd).forEach(function(span) {
            return transaction.spans.push(span);
        });
        var userEntries = (0, $iCHUu.PERF).getEntriesByType((0, $5YGG1.MEASURE));
        (0, $j9MrU.createUserTimingSpans)(userEntries, _trStart, trEnd).forEach(function(span) {
            return transaction.spans.push(span);
        });
    }
}

});
parcelRegister("jfgyU", function(module, exports) {

$parcel$export(module.exports, "createNavigationTimingSpans", function () { return $e02c43e4da233b6d$export$3f88cb87ead13585; });

var $40uGr = parcelRequire("40uGr");

var $inqaX = parcelRequire("inqaX");
var $e02c43e4da233b6d$var$eventPairs = [
    [
        'redirectStart',
        'redirectEnd',
        'Redirect'
    ],
    [
        'domainLookupStart',
        'domainLookupEnd',
        'Domain lookup'
    ],
    [
        'connectStart',
        'connectEnd',
        'Making a connection to the server'
    ],
    [
        'requestStart',
        'responseEnd',
        'Requesting and receiving the document'
    ],
    [
        'domLoading',
        'domInteractive',
        'Parsing the document, executing sync. scripts'
    ],
    [
        'domContentLoadedEventStart',
        'domContentLoadedEventEnd',
        'Fire "DOMContentLoaded" event'
    ],
    [
        'loadEventStart',
        'loadEventEnd',
        'Fire "load" event'
    ]
];
function $e02c43e4da233b6d$export$3f88cb87ead13585(timings, baseTime, trStart, trEnd) {
    var spans = [];
    for(var i = 0; i < $e02c43e4da233b6d$var$eventPairs.length; i++){
        var start = timings[$e02c43e4da233b6d$var$eventPairs[i][0]];
        var end = timings[$e02c43e4da233b6d$var$eventPairs[i][1]];
        if (!(0, $40uGr.shouldCreateSpan)(start, end, trStart, trEnd, baseTime)) continue;
        var span = new (0, $inqaX.default)($e02c43e4da233b6d$var$eventPairs[i][2], 'hard-navigation.browser-timing');
        var data = null;
        if ($e02c43e4da233b6d$var$eventPairs[i][0] === 'requestStart') {
            span.pageResponse = true;
            data = {
                url: location.origin
            };
        }
        span._start = start - baseTime;
        span.end(end - baseTime, data);
        spans.push(span);
    }
    return spans;
}

});
parcelRegister("40uGr", function(module, exports) {

$parcel$export(module.exports, "shouldCreateSpan", function () { return $2eaef6a0a242a99e$export$ee8bd369faf2c186; });

var $5YGG1 = parcelRequire("5YGG1");
function $2eaef6a0a242a99e$export$ee8bd369faf2c186(start, end, trStart, trEnd, baseTime) {
    if (baseTime === void 0) baseTime = 0;
    return typeof start === 'number' && typeof end === 'number' && start >= baseTime && end > start && start - baseTime >= trStart && end - baseTime <= trEnd && end - start < (0, $5YGG1.MAX_SPAN_DURATION) && start - baseTime < (0, $5YGG1.MAX_SPAN_DURATION) && end - baseTime < (0, $5YGG1.MAX_SPAN_DURATION);
}

});


parcelRegister("j9MrU", function(module, exports) {

$parcel$export(module.exports, "createUserTimingSpans", function () { return $df2470940cad4b15$export$d31d86bf4b796a11; });

var $5YGG1 = parcelRequire("5YGG1");

var $40uGr = parcelRequire("40uGr");

var $inqaX = parcelRequire("inqaX");
function $df2470940cad4b15$export$d31d86bf4b796a11(entries, trStart, trEnd) {
    var userTimingSpans = [];
    for(var i = 0; i < entries.length; i++){
        var _entries$i = entries[i], name = _entries$i.name, startTime = _entries$i.startTime, duration = _entries$i.duration;
        var end = startTime + duration;
        if (duration <= (0, $5YGG1.USER_TIMING_THRESHOLD) || !(0, $40uGr.shouldCreateSpan)(startTime, end, trStart, trEnd)) continue;
        var kind = 'app';
        var span = new (0, $inqaX.default)(name, kind);
        span._start = startTime;
        span.end(end);
        userTimingSpans.push(span);
    }
    return userTimingSpans;
}

});

parcelRegister("hJ4Qu", function(module, exports) {

$parcel$export(module.exports, "createResourceTimingSpans", function () { return $ce7a65df15e84fb8$export$c7038f2b5602881b; });

var $iCHUu = parcelRequire("iCHUu");

var $40uGr = parcelRequire("40uGr");

var $5YGG1 = parcelRequire("5YGG1");

var $inqaX = parcelRequire("inqaX");
function $ce7a65df15e84fb8$var$createResourceTimingSpan(resourceTimingEntry) {
    var name = resourceTimingEntry.name, initiatorType = resourceTimingEntry.initiatorType, startTime = resourceTimingEntry.startTime, responseEnd = resourceTimingEntry.responseEnd;
    var kind = 'resource';
    if (initiatorType) kind += '.' + initiatorType;
    var spanName = (0, $iCHUu.stripQueryStringFromUrl)(name);
    var span = new (0, $inqaX.default)(spanName, kind);
    span._start = startTime;
    span.end(responseEnd, {
        url: name,
        entry: resourceTimingEntry
    });
    return span;
}
function $ce7a65df15e84fb8$var$isCapturedByPatching(resourceStartTime, requestPatchTime) {
    return requestPatchTime != null && resourceStartTime > requestPatchTime;
}
function $ce7a65df15e84fb8$var$isIntakeAPIEndpoint(url) {
    return /intake\/v\d+\/rum\/events/.test(url);
}
function $ce7a65df15e84fb8$export$c7038f2b5602881b(entries, requestPatchTime, trStart, trEnd) {
    var spans = [];
    for(var i = 0; i < entries.length; i++){
        var _entries$i = entries[i], initiatorType = _entries$i.initiatorType, name = _entries$i.name, startTime = _entries$i.startTime, responseEnd = _entries$i.responseEnd;
        if ((0, $5YGG1.RESOURCE_INITIATOR_TYPES).indexOf(initiatorType) === -1 || name == null) continue;
        if ((initiatorType === 'xmlhttprequest' || initiatorType === 'fetch') && ($ce7a65df15e84fb8$var$isIntakeAPIEndpoint(name) || $ce7a65df15e84fb8$var$isCapturedByPatching(startTime, requestPatchTime))) continue;
        if ((0, $40uGr.shouldCreateSpan)(startTime, responseEnd, trStart, trEnd)) spans.push($ce7a65df15e84fb8$var$createResourceTimingSpan(entries[i]));
    }
    return spans;
}

});




parcelRegister("aDuuy", function(module, exports) {

$parcel$export(module.exports, "observePageClicks", function () { return $7be532f4b4d45f80$export$1f926008e0357783; });

var $5YGG1 = parcelRequire("5YGG1");
var $7be532f4b4d45f80$var$INTERACTIVE_SELECTOR = 'a[data-transaction-name], button[data-transaction-name]';
function $7be532f4b4d45f80$export$1f926008e0357783(transactionService) {
    var clickHandler = function clickHandler(event) {
        if (event.target instanceof Element) $7be532f4b4d45f80$var$createUserInteractionTransaction(transactionService, event.target);
    };
    var eventName = 'click';
    var useCapture = true;
    window.addEventListener(eventName, clickHandler, useCapture);
    return function() {
        window.removeEventListener(eventName, clickHandler, useCapture);
    };
}
function $7be532f4b4d45f80$var$createUserInteractionTransaction(transactionService, target) {
    var _getTransactionMetada = $7be532f4b4d45f80$var$getTransactionMetadata(target), transactionName = _getTransactionMetada.transactionName, context = _getTransactionMetada.context;
    var tr = transactionService.startTransaction("Click - " + transactionName, (0, $5YGG1.USER_INTERACTION), {
        managed: true,
        canReuse: true,
        reuseThreshold: 300
    });
    if (tr && context) tr.addContext(context);
}
function $7be532f4b4d45f80$var$getTransactionMetadata(target) {
    var metadata = {
        transactionName: null,
        context: null
    };
    metadata.transactionName = $7be532f4b4d45f80$var$buildTransactionName(target);
    var classes = target.getAttribute('class');
    if (classes) metadata.context = {
        custom: {
            classes: classes
        }
    };
    return metadata;
}
function $7be532f4b4d45f80$var$buildTransactionName(target) {
    var dtName = $7be532f4b4d45f80$var$findCustomTransactionName(target);
    if (dtName) return dtName;
    var tagName = target.tagName.toLowerCase();
    var name = target.getAttribute('name');
    if (!!name) return tagName + "[\"" + name + "\"]";
    return tagName;
}
function $7be532f4b4d45f80$var$findCustomTransactionName(target) {
    var trCustomNameAttribute = 'data-transaction-name';
    var fallbackName = target.getAttribute(trCustomNameAttribute);
    if (target.closest) {
        var element = target.closest($7be532f4b4d45f80$var$INTERACTIVE_SELECTOR);
        return element ? element.getAttribute(trCustomNameAttribute) : fallbackName;
    }
    return fallbackName;
}

});

parcelRegister("fixS9", function(module, exports) {

$parcel$export(module.exports, "observePageVisibility", function () { return $b232cfd34f5ee4c3$export$469e44f8217c68b6; });

var $5YGG1 = parcelRequire("5YGG1");

var $h1jmT = parcelRequire("h1jmT");

var $iCHUu = parcelRequire("iCHUu");

var $9rpQl = parcelRequire("9rpQl");
function $b232cfd34f5ee4c3$export$469e44f8217c68b6(configService, transactionService) {
    if (document.visibilityState === 'hidden') (0, $h1jmT.state).lastHiddenStart = 0;
    var visibilityChangeHandler = function visibilityChangeHandler() {
        if (document.visibilityState === 'hidden') $b232cfd34f5ee4c3$var$onPageHidden(configService, transactionService);
    };
    var pageHideHandler = function pageHideHandler() {
        return $b232cfd34f5ee4c3$var$onPageHidden(configService, transactionService);
    };
    var useCapture = true;
    window.addEventListener('visibilitychange', visibilityChangeHandler, useCapture);
    window.addEventListener('pagehide', pageHideHandler, useCapture);
    return function() {
        window.removeEventListener('visibilitychange', visibilityChangeHandler, useCapture);
        window.removeEventListener('pagehide', pageHideHandler, useCapture);
    };
}
function $b232cfd34f5ee4c3$var$onPageHidden(configService, transactionService) {
    var inpTr = (0, $9rpQl.reportInp)(transactionService);
    if (inpTr) var unobserve = configService.observeEvent((0, $5YGG1.QUEUE_ADD_TRANSACTION), function() {
        $b232cfd34f5ee4c3$var$endManagedTransaction(configService, transactionService);
        unobserve();
    });
    else $b232cfd34f5ee4c3$var$endManagedTransaction(configService, transactionService);
}
function $b232cfd34f5ee4c3$var$endManagedTransaction(configService, transactionService) {
    var tr = transactionService.getCurrentTransaction();
    if (tr) {
        var unobserveDiscard = configService.observeEvent((0, $5YGG1.TRANSACTION_IGNORE), function() {
            (0, $h1jmT.state).lastHiddenStart = (0, $iCHUu.now)();
            unobserveDiscard();
            unobserveQueueAdd();
        });
        var unobserveQueueAdd = configService.observeEvent((0, $5YGG1.QUEUE_ADD_TRANSACTION), function() {
            configService.dispatchEvent((0, $5YGG1.QUEUE_FLUSH));
            (0, $h1jmT.state).lastHiddenStart = (0, $iCHUu.now)();
            unobserveQueueAdd();
            unobserveDiscard();
        });
        tr.end();
    } else {
        configService.dispatchEvent((0, $5YGG1.QUEUE_FLUSH));
        (0, $h1jmT.state).lastHiddenStart = (0, $iCHUu.now)();
    }
}

});
parcelRegister("9rpQl", function(module, exports) {

$parcel$export(module.exports, "reportInp", function () { return $6dfaae9bd09b5c5e$export$2eecdd2f9bb703f5; });

var $kTzau = parcelRequire("kTzau");

var $iCHUu = parcelRequire("iCHUu");

var $5YGG1 = parcelRequire("5YGG1");
function $6dfaae9bd09b5c5e$export$2eecdd2f9bb703f5(transactionService) {
    var inp = (0, $kTzau.calculateInp)();
    if (inp >= 0) {
        var startTime = (0, $iCHUu.now)();
        var inpTr = transactionService.startTransaction((0, $5YGG1.PAGE_EXIT), (0, $5YGG1.PAGE_EXIT), {
            startTime: startTime
        });
        var navigations = performance.getEntriesByType('navigation');
        if (navigations.length > 0) {
            var hardNavigationUrl = navigations[0].name;
            inpTr.addContext({
                page: {
                    url: hardNavigationUrl
                }
            });
        }
        inpTr.addLabels({
            inp_value: inp
        });
        var endTime = startTime + inp + 1;
        inpTr.end(endTime);
        (0, $kTzau.restoreINPState)();
        return inpTr;
    }
}

});


parcelRegister("g6EEc", function(module, exports) {

$parcel$export(module.exports, "getInstrumentationFlags", function () { return $bb9cbc9f27ad9720$export$7852da8de47c1ce0; });

var $5YGG1 = parcelRequire("5YGG1");
function $bb9cbc9f27ad9720$export$7852da8de47c1ce0(instrument, disabledInstrumentations) {
    var _flags;
    var flags = (_flags = {}, _flags[0, $5YGG1.XMLHTTPREQUEST] = false, _flags[0, $5YGG1.FETCH] = false, _flags[0, $5YGG1.HISTORY] = false, _flags[0, $5YGG1.PAGE_LOAD] = false, _flags[0, $5YGG1.ERROR] = false, _flags[0, $5YGG1.EVENT_TARGET] = false, _flags[0, $5YGG1.CLICK] = false, _flags);
    if (!instrument) return flags;
    Object.keys(flags).forEach(function(key) {
        if (disabledInstrumentations.indexOf(key) === -1) flags[key] = true;
    });
    return flags;
}

});

parcelRegister("arZea", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79bbeb820a6300d1$export$2e2bcd8739ae039; });
var $79bbeb820a6300d1$var$RAF_TIMEOUT = 100;
function $79bbeb820a6300d1$export$2e2bcd8739ae039(callback) {
    var handler = function handler() {
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        setTimeout(callback);
    };
    var timeout = setTimeout(handler, $79bbeb820a6300d1$var$RAF_TIMEOUT);
    var raf = requestAnimationFrame(handler);
}

});


parcelRegister("5uQ7h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40082e55b987810c$export$2e2bcd8739ae039; });

var $5YGG1 = parcelRequire("5YGG1");
var $g6EEc = parcelRequire("g6EEc");
var $aDuuy = parcelRequire("aDuuy");
var $fixS9 = parcelRequire("fixS9");
var $kTzau = parcelRequire("kTzau");
var $40082e55b987810c$export$2e2bcd8739ae039 = function() {
    function ApmBase(serviceFactory, disable) {
        this._disable = disable;
        this.serviceFactory = serviceFactory;
        this._initialized = false;
    }
    var _proto = ApmBase.prototype;
    _proto.isEnabled = function isEnabled() {
        return !this._disable;
    };
    _proto.isActive = function isActive() {
        var configService = this.serviceFactory.getService((0, $5YGG1.CONFIG_SERVICE));
        return this.isEnabled() && this._initialized && configService.get('active');
    };
    _proto.init = function init(config) {
        var _this = this;
        if (this.isEnabled() && !this._initialized) {
            this._initialized = true;
            var _this$serviceFactory$ = this.serviceFactory.getService([
                (0, $5YGG1.CONFIG_SERVICE),
                (0, $5YGG1.LOGGING_SERVICE),
                (0, $5YGG1.TRANSACTION_SERVICE)
            ]), configService = _this$serviceFactory$[0], loggingService = _this$serviceFactory$[1], transactionService = _this$serviceFactory$[2];
            configService.setVersion('5.16.0');
            this.config(config);
            var logLevel = configService.get('logLevel');
            loggingService.setLevel(logLevel);
            var isConfigActive = configService.get('active');
            if (isConfigActive) {
                this.serviceFactory.init();
                var flags = (0, $g6EEc.getInstrumentationFlags)(configService.get('instrument'), configService.get('disableInstrumentations'));
                var performanceMonitoring = this.serviceFactory.getService((0, $5YGG1.PERFORMANCE_MONITORING));
                performanceMonitoring.init(flags);
                if (flags[0, $5YGG1.ERROR]) {
                    var errorLogging = this.serviceFactory.getService((0, $5YGG1.ERROR_LOGGING));
                    errorLogging.registerListeners();
                }
                if (configService.get('session')) {
                    var localConfig = configService.getLocalConfig();
                    if (localConfig && localConfig.session) configService.setConfig({
                        session: localConfig.session
                    });
                }
                var sendPageLoad = function sendPageLoad() {
                    return flags[0, $5YGG1.PAGE_LOAD] && _this._sendPageLoadMetrics();
                };
                if (configService.get('centralConfig')) this.fetchCentralConfig().then(sendPageLoad);
                else sendPageLoad();
                (0, $fixS9.observePageVisibility)(configService, transactionService);
                if (flags[0, $5YGG1.EVENT_TARGET] && flags[0, $5YGG1.CLICK]) (0, $aDuuy.observePageClicks)(transactionService);
                (0, $kTzau.observeUserInteractions)();
            } else {
                this._disable = true;
                loggingService.warn('RUM agent is inactive');
            }
        }
        return this;
    };
    _proto.fetchCentralConfig = function fetchCentralConfig() {
        var _this$serviceFactory$2 = this.serviceFactory.getService([
            (0, $5YGG1.APM_SERVER),
            (0, $5YGG1.LOGGING_SERVICE),
            (0, $5YGG1.CONFIG_SERVICE)
        ]), apmServer = _this$serviceFactory$2[0], loggingService = _this$serviceFactory$2[1], configService = _this$serviceFactory$2[2];
        return apmServer.fetchConfig(configService.get('serviceName'), configService.get('environment')).then(function(config) {
            var transactionSampleRate = config['transaction_sample_rate'];
            if (transactionSampleRate) {
                transactionSampleRate = Number(transactionSampleRate);
                var _config2 = {
                    transactionSampleRate: transactionSampleRate
                };
                var _configService$valida = configService.validate(_config2), invalid = _configService$valida.invalid;
                if (invalid.length === 0) configService.setConfig(_config2);
                else {
                    var _invalid$ = invalid[0], key = _invalid$.key, value = _invalid$.value, allowed = _invalid$.allowed;
                    loggingService.warn("invalid value \"" + value + "\" for " + key + ". Allowed: " + allowed + ".");
                }
            }
            return config;
        }).catch(function(error) {
            loggingService.warn('failed fetching config:', error);
        });
    };
    _proto._sendPageLoadMetrics = function _sendPageLoadMetrics() {
        var tr = this.startTransaction(undefined, (0, $5YGG1.PAGE_LOAD), {
            managed: true,
            canReuse: true
        });
        if (!tr) return;
        tr.addTask((0, $5YGG1.PAGE_LOAD));
        var sendPageLoadMetrics = function sendPageLoadMetrics() {
            setTimeout(function() {
                return tr.removeTask((0, $5YGG1.PAGE_LOAD));
            }, (0, $5YGG1.PAGE_LOAD_DELAY));
        };
        if (document.readyState === 'complete') sendPageLoadMetrics();
        else window.addEventListener('load', sendPageLoadMetrics);
    };
    _proto.observe = function observe(name, fn) {
        var configService = this.serviceFactory.getService((0, $5YGG1.CONFIG_SERVICE));
        configService.events.observe(name, fn);
    };
    _proto.config = function config(_config) {
        var _this$serviceFactory$3 = this.serviceFactory.getService([
            (0, $5YGG1.CONFIG_SERVICE),
            (0, $5YGG1.LOGGING_SERVICE)
        ]), configService = _this$serviceFactory$3[0], loggingService = _this$serviceFactory$3[1];
        var _configService$valida2 = configService.validate(_config), missing = _configService$valida2.missing, invalid = _configService$valida2.invalid, unknown = _configService$valida2.unknown;
        if (unknown.length > 0) {
            var message = 'Unknown config options are specified for RUM agent: ' + unknown.join(', ');
            loggingService.warn(message);
        }
        if (missing.length === 0 && invalid.length === 0) configService.setConfig(_config);
        else {
            var separator = ', ';
            var _message = "RUM agent isn't correctly configured. ";
            if (missing.length > 0) {
                _message += missing.join(separator) + ' is missing';
                if (invalid.length > 0) _message += separator;
            }
            invalid.forEach(function(_ref, index) {
                var key = _ref.key, value = _ref.value, allowed = _ref.allowed;
                _message += key + " \"" + value + "\" contains invalid characters! (allowed: " + allowed + ")" + (index !== invalid.length - 1 ? separator : '');
            });
            loggingService.error(_message);
            configService.setConfig({
                active: false
            });
        }
    };
    _proto.setUserContext = function setUserContext(userContext) {
        var configService = this.serviceFactory.getService((0, $5YGG1.CONFIG_SERVICE));
        configService.setUserContext(userContext);
    };
    _proto.setCustomContext = function setCustomContext(customContext) {
        var configService = this.serviceFactory.getService((0, $5YGG1.CONFIG_SERVICE));
        configService.setCustomContext(customContext);
    };
    _proto.addLabels = function addLabels(labels) {
        var configService = this.serviceFactory.getService((0, $5YGG1.CONFIG_SERVICE));
        configService.addLabels(labels);
    };
    _proto.setInitialPageLoadName = function setInitialPageLoadName(name) {
        var configService = this.serviceFactory.getService((0, $5YGG1.CONFIG_SERVICE));
        configService.setConfig({
            pageLoadTransactionName: name
        });
    };
    _proto.startTransaction = function startTransaction(name, type, options) {
        if (this.isEnabled()) {
            var transactionService = this.serviceFactory.getService((0, $5YGG1.TRANSACTION_SERVICE));
            return transactionService.startTransaction(name, type, options);
        }
    };
    _proto.startSpan = function startSpan(name, type, options) {
        if (this.isEnabled()) {
            var transactionService = this.serviceFactory.getService((0, $5YGG1.TRANSACTION_SERVICE));
            return transactionService.startSpan(name, type, options);
        }
    };
    _proto.getCurrentTransaction = function getCurrentTransaction() {
        if (this.isEnabled()) {
            var transactionService = this.serviceFactory.getService((0, $5YGG1.TRANSACTION_SERVICE));
            return transactionService.getCurrentTransaction();
        }
    };
    _proto.captureError = function captureError(error) {
        if (this.isEnabled()) {
            var errorLogging = this.serviceFactory.getService((0, $5YGG1.ERROR_LOGGING));
            return errorLogging.logError(error);
        }
    };
    _proto.addFilter = function addFilter(fn) {
        var configService = this.serviceFactory.getService((0, $5YGG1.CONFIG_SERVICE));
        configService.addFilter(fn);
    };
    return ApmBase;
}();

});



parcelRegister("3rEbh", function(module, exports) {

$parcel$export(module.exports, "cookieBannerLocalStorageKeyPrefix", function () { return $28230fcf17508717$export$ee75b90e63031ccd; });
$parcel$export(module.exports, "HomePage", function () { return $28230fcf17508717$export$36d69433c4f81145; });

var $df8fE = parcelRequire("df8fE");

var $a5EUy = parcelRequire("a5EUy");
parcelRequire("2UBc8");
var $eBKZl = parcelRequire("eBKZl");

var $1lyZZ = parcelRequire("1lyZZ");

var $cRlsu = parcelRequire("cRlsu");

var $dSPjH = parcelRequire("dSPjH");
parcelRequire("1OfTO");
var $cbxDY = parcelRequire("cbxDY");

var $cPiPb = parcelRequire("cPiPb");

var $302dL = parcelRequire("302dL");

var $oMBXq = parcelRequire("oMBXq");

var $ig7wp = parcelRequire("ig7wp");

var $l35Y2 = parcelRequire("l35Y2");

var $c0lKT = parcelRequire("c0lKT");

var $6aHgi = parcelRequire("6aHgi");

var $dyrOw = parcelRequire("dyrOw");

var $gFRU1 = parcelRequire("gFRU1");
const $28230fcf17508717$var$contactEmailPlaceholder = 'LEGOBUCONTACT@LEGO.COM';
const $28230fcf17508717$export$ee75b90e63031ccd = 'cookieBannerSeen';
const $28230fcf17508717$var$contentWrapperStyle = (0, $1lyZZ.css)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 554,
    margin: '0 auto'
});
const $28230fcf17508717$var$bodyTextStyle = (0, $1lyZZ.css)({
    marginTop: (0, $cbxDY.spacing).size4,
    marginBottom: (0, $cbxDY.spacing).size10
});
const $28230fcf17508717$export$36d69433c4f81145 = ()=>{
    const { labelsLoading: labelsLoading, labels: { svy_intro_headline: svy_intro_headline, svy_cookie_banner_header: svy_cookie_banner_header, svy_cookie_banner_body_text: svy_cookie_banner_body_text }, richTextLabels: { svy_welcome_text_on_homepage: svy_welcome_text_on_homepage } } = (0, $cRlsu.useLabels)();
    const { staticUserVariables: staticUserVariables, selectedCustomer: selectedCustomer } = (0, $dSPjH.useUser)();
    const hasCookieBannerBeenSeen = localStorage.getItem(`${$28230fcf17508717$export$ee75b90e63031ccd}${selectedCustomer.id}`);
    const [isCookieBannerVisible, setIsCookieBannerVisible] = (0, $a5EUy.useState)(!hasCookieBannerBeenSeen);
    const { data: surveyListData, loading: isSurveyListLoading, error: surveyListError } = (0, $eBKZl.useQuery)((0, $oMBXq.GET_SURVEY_LIST), {
        variables: staticUserVariables(),
        fetchPolicy: 'network-only'
    });
    const handleCookieBannerOnClose = ()=>{
        localStorage.setItem(`${$28230fcf17508717$export$ee75b90e63031ccd}${selectedCustomer.id}`, true);
        setIsCookieBannerVisible(false);
    };
    // Error boundary catches this error
    if (surveyListError) (0, $gFRU1.throwErrorWithTransactionName)(surveyListError, 'HomePage');
    if (isSurveyListLoading || !surveyListData || labelsLoading) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $cPiPb.OverlayPortal), {
        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $302dL.Spinner), {})
    });
    // Sold-tos without an active assessment are filtered out before reaching this page
    const surveyList = surveyListData.getSurveyList ?? [];
    return /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
        css: $28230fcf17508717$var$contentWrapperStyle,
        children: [
            /*#__PURE__*/ (0, $df8fE.jsx)((0, $6aHgi.Heading), {
                type: "h1",
                text: svy_intro_headline
            }),
            /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                css: $28230fcf17508717$var$bodyTextStyle,
                dangerouslySetInnerHTML: {
                    __html: (0, $dyrOw.replaceContactEmail)(svy_welcome_text_on_homepage, $28230fcf17508717$var$contactEmailPlaceholder, selectedCustomer.legoContactEmail)
                }
            }),
            /*#__PURE__*/ (0, $df8fE.jsx)((0, $ig7wp.HomePageTable), {
                surveyListdata: surveyList
            }),
            isCookieBannerVisible && /*#__PURE__*/ (0, $df8fE.jsx)((0, $l35Y2.Banner), {
                "aria-label": "Cookie info banner",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($c0lKT))),
                header: svy_cookie_banner_header,
                text: svy_cookie_banner_body_text,
                onClose: handleCookieBannerOnClose
            })
        ]
    });
};

});
parcelRegister("cRlsu", function(module, exports) {

$parcel$export(module.exports, "labelsReducer", function () { return $95cb147850f213ac$export$48c49e900ccf02e5; });
$parcel$export(module.exports, "LabelsProvider", function () { return $95cb147850f213ac$export$4e1eba7703cdfb1f; });
$parcel$export(module.exports, "useLabels", function () { return $95cb147850f213ac$export$d6875122194c7b44; });

var $df8fE = parcelRequire("df8fE");

var $a5EUy = parcelRequire("a5EUy");
parcelRequire("2UBc8");
var $eBKZl = parcelRequire("eBKZl");

var $3yJBl = parcelRequire("3yJBl");

var $7sO2A = parcelRequire("7sO2A");

var $dSPjH = parcelRequire("dSPjH");

var $iSOfh = parcelRequire("iSOfh");

var $7eF6Y = parcelRequire("7eF6Y");

var $gFRU1 = parcelRequire("gFRU1");
const $95cb147850f213ac$export$90358f03cf62037c = /*#__PURE__*/ (0, $a5EUy.createContext)();
const $95cb147850f213ac$export$48c49e900ccf02e5 = (labelsObject)=>{
    if (!labelsObject) return {};
    (0, $gFRU1.addDefaultBreadcrumb)('Reducing labels', 'LabelsProvider.reducer');
    return Object.keys(labelsObject).reduce((acc, next)=>{
        acc[next] = labelsObject[next].reduce((acc, next)=>{
            acc[next.id] = next.text;
            return acc;
        }, {});
        return acc;
    }, {});
};
const $95cb147850f213ac$export$4e1eba7703cdfb1f = ({ children: children })=>{
    const { isUserLoading: isUserLoading, isLoggedIn: isLoggedIn } = (0, $dSPjH.useUser)();
    const { data: labelsData, loading: labelsLoading, error: labelsError } = (0, $eBKZl.useQuery)((0, $7sO2A.LABELS), {
        skip: isUserLoading || !isLoggedIn
    });
    let labelsReduced = (0, $a5EUy.useMemo)(()=>$95cb147850f213ac$export$48c49e900ccf02e5(labelsData), [
        labelsData
    ]);
    if (labelsError) {
        const { labels: { svy_snackbar_error_header: svy_snackbar_error_header } } = (0, $iSOfh.labelTranslationsFallback);
        (0, $7eF6Y.generalApiErrorHandler)({
            error: labelsError,
            snackbarHeader: svy_snackbar_error_header,
            snackbarMessage: 'Only English labels are currently available'
        });
    }
    return /*#__PURE__*/ (0, $df8fE.jsx)($95cb147850f213ac$export$90358f03cf62037c.Provider, {
        value: {
            labelsLoading: labelsLoading,
            labels: labelsReduced.getLabels || (0, $iSOfh.labelTranslationsFallback).labels,
            richTextLabels: labelsReduced.getRichTextLabels || (0, $iSOfh.labelTranslationsFallback).richTextLabels
        },
        children: children
    });
};
const $95cb147850f213ac$export$d6875122194c7b44 = ()=>{
    const context = (0, $a5EUy.useContext)($95cb147850f213ac$export$90358f03cf62037c);
    if (context === undefined) throw new Error('useLabels must be used within a LabelsProvider');
    return context;
};
$95cb147850f213ac$export$4e1eba7703cdfb1f.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).node
};

});
parcelRegister("7sO2A", function(module, exports) {

$parcel$export(module.exports, "LABELS", function () { return $56f1f6f736fa7357$export$79b91d4669dcadcb; });
$parcel$export(module.exports, "PUBLIC_LABELS", function () { return $56f1f6f736fa7357$export$9d432c972298b124; });
parcelRequire("2UBc8");
var $3EDHG = parcelRequire("3EDHG");
const $56f1f6f736fa7357$export$79b91d4669dcadcb = (0, $3EDHG.default)`
  query Labels {
    getLabels {
      id
      text
    }
    getRichTextLabels {
      id
      text
    }
  }
`;
const $56f1f6f736fa7357$export$9d432c972298b124 = (0, $3EDHG.default)`
  query PublicLabels {
    getPublicLabels {
      id
      text
    }
    getPublicRichTextLabels {
      id
      text
    }
  }
`;

});

parcelRegister("iSOfh", function(module, exports) {

$parcel$export(module.exports, "labelTranslationsFallback", function () { return $dbf43ed53f036edb$export$e29a1f4958059c; });
const $dbf43ed53f036edb$export$e29a1f4958059c = {
    labelsLoading: false,
    labels: {
        svy_status_in_lego_review: "In LEGO\xae review",
        svy_loginpage_welcome_text: "Welcome to the LEGO\xae Functional Discount Self-Assessment",
        svy_intro_details: "The answers and justification you provide in the self-assessment need to be true and accurate and shall not be untruthful or misleading. The LEGO\xae Group reserves the right to perform sample checks to verify the accuracy of the information provided. Any submission of incorrect information may result in a reduction of future functional discount. Your answers and justification will only be shared with relevant stakeholders within the LEGO\xae Group, shall be stored and handled in compliance with applicable laws and will under no circumstances be shared with any third party. The assessment questionnaire is confidential and you are not permitted to share the content further.",
        svy_end_thanks_details: 'Your answers will be reviewed. We expect to approve your self-assessment within the near future. We will contact you directly in case we have any questions regarding your answers or justifications.',
        svy_complete_page_total_discount_text: 'Your provisional functional discount percentage based on your self-assessment is:',
        svy_status_changes_required: 'Changes required',
        svy_start_button: 'Start Assessment',
        svy_end_edit: 'Edit Assessment',
        svy_end_complete: 'Complete assessment',
        svy_cookie_banner_body_text: 'We only use necessary cookies that enable core site functionality and are therefore always enabled.',
        svy_cookie_banner_header: 'Cookies are used to run this application.',
        svy_additional_comments_placeholder_text: 'Write here',
        svy_end_thanks_headline: 'Thank you for your submission',
        svy_end_finish: 'Finish Assessment',
        svy_review_headline: 'Review Assessment Form',
        svy_end_headline: 'Complete Assessment Form',
        svy_additional_comments: 'Justification',
        svy_multi_customer_login_heading: 'Choose a user to log in with',
        svy_intro_headline: 'Functional discount terms and conditions',
        svy_terms_accept_button_text: 'Accept',
        svy_error_page_body_text: "A server issue might have caused an error. Try to refresh the site or wait a couple of minutes and try again. If that does not work please contact your LEGO\xae representative to find a solution.",
        svy_error_page_header: "Somethings's gone missing.",
        svy_no_assessments_header: 'No further action needed.',
        svy_access_granted: 'Access granted.',
        svy_404_page_text: 'That link may be broken or the page may have been moved. If the problem persists, please contact your LEGO representative:',
        svy_top_logo: "LEGO\xae Functional Discount Self-Assessment",
        svy_footer_contact: 'Contact Details',
        svy_footer_cookie_policy_link: 'Cookie policy',
        svy_sign_in_button: 'Sign in',
        svy_cancel_button: 'Cancel',
        svy_back_button: 'Back',
        svy_next_button: 'Next',
        svy_delete_button: 'Delete',
        svy_delete_image_confirmation_modal_header: 'Delete file?',
        svy_delete_image_confirmation_modal_body: 'Are you sure you want to delete the file?',
        svy_max_number_of_images: 'Max. 5 files',
        svy_end_review: 'Review',
        svy_uploading_image_text: 'Uploading file, please wait ...',
        svy_done_editing: 'Done',
        svy_attachments: 'Attachments',
        svy_sign_out: 'Sign out',
        svy_back_to_homepage: 'Back to homepage',
        svy_display_button: 'Display',
        svy_status_not_submitted: 'Not submitted',
        svy_status_rescoring_required: 'Re-scoring required',
        svy_status_completed: 'Completed',
        svy_table_header_status: 'Status',
        svy_table_header_year_of_evaluation: 'Year of evaluation',
        svy_snackbar_error_default_text: 'We could not complete your request. We are working on it. Please try again later.',
        svy_snackbar_error_uploaded_images_not_available: 'Uploaded files are currently not available.',
        svy_snackbar_error_header: 'Something went wrong',
        svy_snackbar_success_header: 'Success',
        svy_snackbar_error_user_has_no_customers: 'No customers matching this user. You were automatically logged out.',
        svy_snackbar_error_upload_invalid_file_type: 'Invalid file type. Only images and PDFs are allowed.',
        svy_snackbar_error_upload_too_many_files: 'Too many files. Please upload files one by one.',
        svy_snackbar_error_upload_image_too_large: 'File is too large. Max size is 10 MB.',
        svy_tooltip_back_to_frontpage: 'Back to frontpage',
        svy_tooltip_customer_name: 'Customer Name',
        svy_tooltip_accept_terms_first: 'Accept the terms first',
        svy_tooltip_question_see_more_info: 'Click to see more info',
        svy_tooltip_question_choose_answer_first: 'Choose an answer first',
        svy_sub_answers_reduced_discount: 'Discounts reduced due to minimum options not selected'
    },
    richTextLabels: {
        svy_no_assessments_content: "<p>We'll email you as soon as the assessment it opens.</p> <p>&nbsp;</p> <p><strong>Feel free to close this tab.</strong></p>",
        svy_welcome_text_on_homepage: '<p><strong>*In&nbsp;Danish*&nbsp;Welcome to the LEGO functional discount self-assessment\n</strong><br><br>From this site you will be able to perform a self-assessment and upload necessary justification linked to functional discount. The purpose of this self-assessment is to determine your functional discount for next year.&nbsp;<br><br>The assessment is based on your actual activities within the last 12 months and the impact of the assessment will be January 1st next year. The maximum discount to be obtained is 13%. <br><br>The self-assessment is completed by answering a questionnaire and uploading the required justification. The questionnaire is based on questions such as "Yes / No" or simple "Multiple choice". The justification required for individual questions are clarified with "Optional" or "Mandatory" guidance and include written descriptions of your activities and images for further elaboration.\n<br><br>In case of questions or if you would like to perform a re-scoring please reach out to LEGOBUCONTACT@LEGO.COM\n<br><br>Note: You are able to see previous performance in the overview below.\n<br><br>Best regards,\n<br><strong>The LEGO Group</strong></p>',
        svy_intro_policies: 'By starting this survey, I hereby consent to the <a href="https://www.lego.com/en-us/legal/notices-and-policies/privacy-policy" target="_blank">privacy policy</a> and agree to its terms.',
        svy_loginpage_privacy_cookie_policy_line: 'Please refer to our <a href="http://www.lego.com/en-us/legal/legal-notice/privacy-policy-full" tabindex="-1" target="_blank">Privacy Policy</a> & <a href="http://www.lego.com/en-us/legal/cookieinfo" tabindex="-1" target="_blank">Cookie Policy</a>',
        svy_footer_text: "<p>LEGO Company Limited, 33 Bath Road, Slough, Berks SL1 3UF, UK.</p>\n<p>LEGO and the LEGO logo are trademarks and copyrights of the LEGO Group.<br>\n\xa92020 The LEGO Group. All rights reserved. Use of this site signifies your agreement to the terms of use.</p>\n",
        svy_footer_privacy_policy_link: '<a href="https://www.lego.com/en-gb/legal/legal-notice/privacy-policy-full" tabindex="-1" target="_blank">Privacy policy</a>',
        svy_footer_legal_notice_link: '<a href="https://www.lego.com/en-gb/legal/legal-notice" tabindex="-1" target="_blank">Legal notice</a>',
        svy_upload_text_in_box: 'Drag and drop image files here,<br>or click to select from disk.'
    },
    getPublicLabels: {
        svy_top_logo: "LEGO\xae Functional Discount Self-Assessment",
        svy_loginpage_welcome_text: "Welcome to the LEGO\xae Functional Discount Self-Assessment",
        svy_sign_in_button: 'Sign in',
        svy_snackbar_error_header: 'Something went wrong',
        svy_snackbar_success_header: 'Success',
        svy_snackbar_error_user_has_no_customers: 'No customers matching this user. You were automatically logged out.'
    },
    getPublicRichTextLabels: {
        svy_loginpage_privacy_cookie_policy_line: 'Please refer to our <a href="http://www.lego.com/en-us/legal/legal-notice/privacy-policy-full" tabindex="-1" target="_blank">Privacy Policy</a> & <a href="http://www.lego.com/en-us/legal/cookieinfo" tabindex="-1" target="_blank">Cookie Policy</a>'
    }
};

});

parcelRegister("7eF6Y", function(module, exports) {

$parcel$export(module.exports, "generalApiErrorHandler", function () { return $5449bb1b1da316de$export$8d89fee11b80c3f9; });

var $4zZNZ = parcelRequire("4zZNZ");
parcelRequire("dntWt");
var $fHgS9 = parcelRequire("fHgS9");
var $gAOhP = parcelRequire("gAOhP");

var $iSOfh = parcelRequire("iSOfh");
const { svy_snackbar_error_header: $5449bb1b1da316de$var$svy_snackbar_error_header, svy_snackbar_error_default_text: $5449bb1b1da316de$var$svy_snackbar_error_default_text } = (0, $iSOfh.labelTranslationsFallback);
const $5449bb1b1da316de$export$8d89fee11b80c3f9 = ({ error: error, snackbarHeader: snackbarHeader = $5449bb1b1da316de$var$svy_snackbar_error_header, snackbarMessage: snackbarMessage = $5449bb1b1da316de$var$svy_snackbar_error_default_text })=>{
    (0, $fHgS9.addSnackbar)({
        header: snackbarHeader,
        text: snackbarMessage,
        type: (0, $gAOhP.snackbarTypes).ERROR
    });
    (0, $4zZNZ.logger).logError(error);
};

});
parcelRegister("dntWt", function(module, exports) {

$parcel$export(module.exports, "snackbarConfig", function () { return (parcelRequire("g92G0")).snackbarConfig; });
$parcel$export(module.exports, "addSnackbar", function () { return (parcelRequire("fHgS9")).addSnackbar; });
$parcel$export(module.exports, "snackbarTypes", function () { return (parcelRequire("gAOhP")).snackbarTypes; });



var $g92G0 = parcelRequire("g92G0");

var $fHgS9 = parcelRequire("fHgS9");

var $gAOhP = parcelRequire("gAOhP");

});
parcelRegister("g92G0", function(module, exports) {

$parcel$export(module.exports, "snackbarConfig", function () { return $bc0f9020c9d2da45$export$d27e4189c1f0e8f4; });
const $bc0f9020c9d2da45$export$d27e4189c1f0e8f4 = {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    closeButton: false
};

});

parcelRegister("fHgS9", function(module, exports) {

$parcel$export(module.exports, "addSnackbar", function () { return $b6d7f5aef3fdb69a$export$2791228263505492; });

var $df8fE = parcelRequire("df8fE");

var $fUUwV = parcelRequire("fUUwV");
parcelRequire("hi8ts");
var $bWBwj = parcelRequire("bWBwj");
var $6yLT8 = parcelRequire("6yLT8");

var $5Qjz0 = parcelRequire("5Qjz0");

var $gAOhP = parcelRequire("gAOhP");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
const $b6d7f5aef3fdb69a$var$getIconColor = (snackbarType)=>{
    if (snackbarType === (0, $gAOhP.snackbarTypes).SUCCESS) return (0, $8JWbY.colors).utilityColors.success.success400;
    if (snackbarType === (0, $gAOhP.snackbarTypes).INFO) return (0, $8JWbY.colors).utilityColors.information.information400;
    if (snackbarType === (0, $gAOhP.snackbarTypes).WARNING) return (0, $8JWbY.colors).utilityColors.warning.warning400;
    if (snackbarType === (0, $gAOhP.snackbarTypes).ERROR) return (0, $8JWbY.colors).utilityColors.error.error500;
    return (0, $8JWbY.colors).neutralColors.slate90;
};
const $b6d7f5aef3fdb69a$export$2791228263505492 = ({ header: header, text: text, type: type })=>{
    const Icon = type === (0, $gAOhP.snackbarTypes).SUCCESS ? (0, $bWBwj.StatusSuccessBold) : (0, $6yLT8.StatusWarningBold);
    const getContent = ()=>/*#__PURE__*/ (0, $df8fE.jsx)((0, $5Qjz0.SnackbarContent), {
            icon: /*#__PURE__*/ (0, $df8fE.jsx)(Icon, {
                css: {
                    color: $b6d7f5aef3fdb69a$var$getIconColor(type)
                }
            }),
            header: header,
            text: text
        });
    if (!type) return (0, $fUUwV.toast)(getContent());
    return (0, $fUUwV.toast)[type](getContent());
};

});
parcelRegister("fUUwV", function(module, exports) {

$parcel$export(module.exports, "ToastContainer", function () { return $b967efa6cd5dde02$export$f2815235e76a62b9; });
$parcel$export(module.exports, "toast", function () { return $b967efa6cd5dde02$export$b410431fab84fa58; });

var $a5EUy = parcelRequire("a5EUy");

var $4Izwm = parcelRequire("4Izwm");

var $jUibk = parcelRequire("jUibk");
function $b967efa6cd5dde02$var$_extends() {
    $b967efa6cd5dde02$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b967efa6cd5dde02$var$_extends.apply(this, arguments);
}
function $b967efa6cd5dde02$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b967efa6cd5dde02$var$isNum(v) {
    return typeof v === 'number' && !isNaN(v);
}
function $b967efa6cd5dde02$var$isBool(v) {
    return typeof v === 'boolean';
}
function $b967efa6cd5dde02$var$isStr(v) {
    return typeof v === 'string';
}
function $b967efa6cd5dde02$var$isFn(v) {
    return typeof v === 'function';
}
function $b967efa6cd5dde02$var$parseClassName(v) {
    return $b967efa6cd5dde02$var$isStr(v) || $b967efa6cd5dde02$var$isFn(v) ? v : null;
}
function $b967efa6cd5dde02$var$isToastIdValid(toastId) {
    return toastId === 0 || toastId;
}
function $b967efa6cd5dde02$var$getAutoCloseDelay(toastAutoClose, containerAutoClose) {
    return toastAutoClose === false || $b967efa6cd5dde02$var$isNum(toastAutoClose) && toastAutoClose > 0 ? toastAutoClose : containerAutoClose;
}
var $b967efa6cd5dde02$var$canUseDom = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $b967efa6cd5dde02$var$canBeRendered(content) {
    return (0, $a5EUy.isValidElement)(content) || $b967efa6cd5dde02$var$isStr(content) || $b967efa6cd5dde02$var$isFn(content) || $b967efa6cd5dde02$var$isNum(content);
}
var $b967efa6cd5dde02$var$POSITION = {
    TOP_LEFT: 'top-left',
    TOP_RIGHT: 'top-right',
    TOP_CENTER: 'top-center',
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_RIGHT: 'bottom-right',
    BOTTOM_CENTER: 'bottom-center'
};
var $b967efa6cd5dde02$var$TYPE = {
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    DEFAULT: 'default',
    DARK: 'dark'
};
/**
 * Used to collapse toast after exit animation
 */ function $b967efa6cd5dde02$export$184cca501f1aed7f(node, done, duration) {
    if (duration === void 0) duration = 300;
    var height = node.scrollHeight;
    var style = node.style;
    requestAnimationFrame(function() {
        style.minHeight = 'initial';
        style.height = height + 'px';
        style.transition = "all " + duration + "ms";
        requestAnimationFrame(function() {
            style.height = '0';
            style.padding = '0';
            style.margin = '0';
            setTimeout(done, duration);
        });
    });
}
/**
 * Css animation that just work.
 * You could use animate.css for instance
 *
 *
 * ```
 * cssTransition({
 *   enter: "animate__animated animate__bounceIn",
 *   exit: "animate__animated animate__bounceOut"
 * })
 * ```
 *
 */ function $b967efa6cd5dde02$export$3ff7dc44d332d222(_ref) {
    var enter = _ref.enter, exit = _ref.exit, _ref$appendPosition = _ref.appendPosition, appendPosition = _ref$appendPosition === void 0 ? false : _ref$appendPosition, _ref$collapse = _ref.collapse, collapse = _ref$collapse === void 0 ? true : _ref$collapse, _ref$collapseDuration = _ref.collapseDuration, collapseDuration = _ref$collapseDuration === void 0 ? 300 : _ref$collapseDuration;
    return function ToastTransition(_ref2) {
        var children = _ref2.children, position = _ref2.position, preventExitTransition = _ref2.preventExitTransition, done = _ref2.done, nodeRef = _ref2.nodeRef, isIn = _ref2.isIn;
        var enterClassName = appendPosition ? enter + "--" + position : enter;
        var exitClassName = appendPosition ? exit + "--" + position : exit;
        var baseClassName = (0, $a5EUy.useRef)();
        var animationStep = (0, $a5EUy.useRef)(0);
        (0, $a5EUy.useLayoutEffect)(function() {
            onEnter();
        }, []);
        (0, $a5EUy.useEffect)(function() {
            if (!isIn) preventExitTransition ? onExited() : onExit();
        }, [
            isIn
        ]);
        function onEnter() {
            var node = nodeRef.current;
            baseClassName.current = node.className;
            node.className += " " + enterClassName;
            node.addEventListener('animationend', onEntered);
        }
        function onEntered() {
            var node = nodeRef.current;
            node.removeEventListener('animationend', onEntered);
            if (animationStep.current === 0) node.className = baseClassName.current;
        }
        function onExit() {
            animationStep.current = 1;
            var node = nodeRef.current;
            node.className += " " + exitClassName;
            node.addEventListener('animationend', onExited);
        }
        function onExited() {
            var node = nodeRef.current;
            node.removeEventListener('animationend', onExited);
            collapse ? $b967efa6cd5dde02$export$184cca501f1aed7f(node, done, collapseDuration) : done();
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).Fragment, null, children);
    };
}
var $b967efa6cd5dde02$var$eventManager = {
    list: /*#__PURE__*/ new Map(),
    emitQueue: /*#__PURE__*/ new Map(),
    on: function on(event, callback) {
        this.list.has(event) || this.list.set(event, []);
        this.list.get(event).push(callback);
        return this;
    },
    off: function off(event, callback) {
        if (callback) {
            var cb = this.list.get(event).filter(function(cb) {
                return cb !== callback;
            });
            this.list.set(event, cb);
            return this;
        }
        this.list["delete"](event);
        return this;
    },
    cancelEmit: function cancelEmit(event) {
        var timers = this.emitQueue.get(event);
        if (timers) {
            timers.forEach(clearTimeout);
            this.emitQueue["delete"](event);
        }
        return this;
    },
    /**
   * Enqueue the event at the end of the call stack
   * Doing so let the user call toast as follow:
   * toast('1')
   * toast('2')
   * toast('3')
   * Without setTimemout the code above will not work
   */ emit: function emit(event) {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        this.list.has(event) && this.list.get(event).forEach(function(callback) {
            var timer = setTimeout(function() {
                // @ts-ignore
                callback.apply(void 0, args);
            }, 0);
            _this.emitQueue.has(event) || _this.emitQueue.set(event, []);
            _this.emitQueue.get(event).push(timer);
        });
    }
};
/**
 * `useKeeper` is a helper around `useRef`.
 *
 * You don't need to access the `.current`property to get the value
 * If refresh is set to true. The ref will be updated every render
 */ function $b967efa6cd5dde02$var$useKeeper(arg, refresh) {
    if (refresh === void 0) refresh = false;
    var ref = (0, $a5EUy.useRef)(arg);
    (0, $a5EUy.useEffect)(function() {
        if (refresh) ref.current = arg;
    });
    return ref.current;
}
function $b967efa6cd5dde02$var$reducer(state, action) {
    switch(action.type){
        case 0:
            return [].concat(state, [
                action.toastId
            ]).filter(function(id) {
                return id !== action.staleId;
            });
        case 1:
            return $b967efa6cd5dde02$var$isToastIdValid(action.toastId) ? state.filter(function(id) {
                return id !== action.toastId;
            }) : [];
    }
}
function $b967efa6cd5dde02$export$b262e13ca2dd2381(props) {
    var _useReducer = (0, $a5EUy.useReducer)(function(x) {
        return x + 1;
    }, 0), forceUpdate = _useReducer[1];
    var _useReducer2 = (0, $a5EUy.useReducer)($b967efa6cd5dde02$var$reducer, []), toast = _useReducer2[0], dispatch = _useReducer2[1];
    var containerRef = (0, $a5EUy.useRef)(null);
    var toastCount = $b967efa6cd5dde02$var$useKeeper(0);
    var queue = $b967efa6cd5dde02$var$useKeeper([]);
    var collection = $b967efa6cd5dde02$var$useKeeper({});
    var instance = $b967efa6cd5dde02$var$useKeeper({
        toastKey: 1,
        displayedToast: 0,
        props: props,
        containerId: null,
        isToastActive: isToastActive,
        getToast: function getToast(id) {
            return collection[id] || null;
        }
    });
    (0, $a5EUy.useEffect)(function() {
        instance.containerId = props.containerId;
        $b967efa6cd5dde02$var$eventManager.cancelEmit(3).on(0, buildToast).on(1, function(toastId) {
            return containerRef.current && removeToast(toastId);
        }).on(5, clearWaitingQueue).emit(2, instance);
        return function() {
            return $b967efa6cd5dde02$var$eventManager.emit(3, instance);
        };
    }, []);
    (0, $a5EUy.useEffect)(function() {
        instance.isToastActive = isToastActive;
        instance.displayedToast = toast.length;
        $b967efa6cd5dde02$var$eventManager.emit(4, toast.length, props.containerId);
    }, [
        toast
    ]);
    (0, $a5EUy.useEffect)(function() {
        instance.props = props;
    });
    function isToastActive(id) {
        return toast.indexOf(id) !== -1;
    }
    function clearWaitingQueue(_ref) {
        var containerId = _ref.containerId;
        var limit = instance.props.limit;
        if (limit && (!containerId || instance.containerId === containerId)) {
            toastCount -= queue.length;
            queue = [];
        }
    }
    function removeToast(toastId) {
        dispatch({
            type: 1,
            toastId: toastId
        });
    }
    function dequeueToast() {
        var _queue$shift = queue.shift(), toastContent = _queue$shift.toastContent, toastProps = _queue$shift.toastProps, staleId = _queue$shift.staleId;
        appendToast(toastContent, toastProps, staleId);
    }
    /**
   * check if a container is attached to the dom
   * check for multi-container, build only if associated
   * check for duplicate toastId if no update
   */ function isNotValid(_ref2) {
        var containerId = _ref2.containerId, toastId = _ref2.toastId, updateId = _ref2.updateId;
        return !containerRef.current || instance.props.enableMultiContainer && containerId !== instance.props.containerId || collection[toastId] && updateId == null ? true : false;
    } // this function and all the function called inside needs to rely on ref(`useKeeper`)
    function buildToast(content, _ref3) {
        var delay = _ref3.delay, staleId = _ref3.staleId, options = $b967efa6cd5dde02$var$_objectWithoutPropertiesLoose(_ref3, [
            "delay",
            "staleId"
        ]);
        if (!$b967efa6cd5dde02$var$canBeRendered(content) || isNotValid(options)) return;
        var toastId = options.toastId, updateId = options.updateId;
        var props = instance.props;
        var closeToast = function closeToast() {
            return removeToast(toastId);
        };
        var isNotAnUpdate = options.updateId == null;
        if (isNotAnUpdate) toastCount++;
        var toastProps = {
            toastId: toastId,
            updateId: updateId,
            isIn: false,
            key: options.key || instance.toastKey++,
            type: options.type,
            closeToast: closeToast,
            closeButton: options.closeButton,
            rtl: props.rtl,
            position: options.position || props.position,
            transition: options.transition || props.transition,
            className: $b967efa6cd5dde02$var$parseClassName(options.className || props.toastClassName),
            bodyClassName: $b967efa6cd5dde02$var$parseClassName(options.bodyClassName || props.bodyClassName),
            style: options.style || props.toastStyle,
            bodyStyle: options.bodyStyle || props.bodyStyle,
            onClick: options.onClick || props.onClick,
            pauseOnHover: $b967efa6cd5dde02$var$isBool(options.pauseOnHover) ? options.pauseOnHover : props.pauseOnHover,
            pauseOnFocusLoss: $b967efa6cd5dde02$var$isBool(options.pauseOnFocusLoss) ? options.pauseOnFocusLoss : props.pauseOnFocusLoss,
            draggable: $b967efa6cd5dde02$var$isBool(options.draggable) ? options.draggable : props.draggable,
            draggablePercent: $b967efa6cd5dde02$var$isNum(options.draggablePercent) ? options.draggablePercent : props.draggablePercent,
            draggableDirection: options.draggableDirection || props.draggableDirection,
            closeOnClick: $b967efa6cd5dde02$var$isBool(options.closeOnClick) ? options.closeOnClick : props.closeOnClick,
            progressClassName: $b967efa6cd5dde02$var$parseClassName(options.progressClassName || props.progressClassName),
            progressStyle: options.progressStyle || props.progressStyle,
            autoClose: $b967efa6cd5dde02$var$getAutoCloseDelay(options.autoClose, props.autoClose),
            hideProgressBar: $b967efa6cd5dde02$var$isBool(options.hideProgressBar) ? options.hideProgressBar : props.hideProgressBar,
            progress: options.progress,
            role: $b967efa6cd5dde02$var$isStr(options.role) ? options.role : props.role,
            deleteToast: function deleteToast() {
                removeFromCollection(toastId);
            }
        };
        if ($b967efa6cd5dde02$var$isFn(options.onOpen)) toastProps.onOpen = options.onOpen;
        if ($b967efa6cd5dde02$var$isFn(options.onClose)) toastProps.onClose = options.onClose; //  tweak for vertical dragging
        if (toastProps.draggableDirection === "y" && toastProps.draggablePercent === 80) toastProps.draggablePercent *= 1.5;
        var closeButton = props.closeButton;
        if (options.closeButton === false || $b967efa6cd5dde02$var$canBeRendered(options.closeButton)) closeButton = options.closeButton;
        else if (options.closeButton === true) closeButton = $b967efa6cd5dde02$var$canBeRendered(props.closeButton) ? props.closeButton : true;
        toastProps.closeButton = closeButton;
        var toastContent = content;
        if ((0, $a5EUy.isValidElement)(content) && !$b967efa6cd5dde02$var$isStr(content.type)) toastContent = (0, $a5EUy.cloneElement)(content, {
            closeToast: closeToast,
            toastProps: toastProps
        });
        else if ($b967efa6cd5dde02$var$isFn(content)) toastContent = content({
            closeToast: closeToast,
            toastProps: toastProps
        });
         // not handling limit + delay by design. Waiting for user feedback first
        if (props.limit && props.limit > 0 && toastCount > props.limit && isNotAnUpdate) queue.push({
            toastContent: toastContent,
            toastProps: toastProps,
            staleId: staleId
        });
        else if ($b967efa6cd5dde02$var$isNum(delay) && delay > 0) setTimeout(function() {
            appendToast(toastContent, toastProps, staleId);
        }, delay);
        else appendToast(toastContent, toastProps, staleId);
    }
    function appendToast(content, toastProps, staleId) {
        var toastId = toastProps.toastId;
        if (staleId) delete collection[staleId];
        collection[toastId] = {
            content: content,
            props: toastProps
        };
        dispatch({
            type: 0,
            toastId: toastId,
            staleId: staleId
        });
    }
    function removeFromCollection(toastId) {
        delete collection[toastId];
        var queueLen = queue.length;
        toastCount = $b967efa6cd5dde02$var$isToastIdValid(toastId) ? toastCount - 1 : toastCount - instance.displayedToast;
        if (toastCount < 0) toastCount = 0;
        if (queueLen > 0) {
            var freeSlot = $b967efa6cd5dde02$var$isToastIdValid(toastId) ? 1 : instance.props.limit;
            if (queueLen === 1 || freeSlot === 1) {
                instance.displayedToast++;
                dequeueToast();
            } else {
                var toDequeue = freeSlot > queueLen ? queueLen : freeSlot;
                instance.displayedToast = toDequeue;
                for(var i = 0; i < toDequeue; i++)dequeueToast();
            }
        } else forceUpdate();
    }
    function getToastToRender(cb) {
        var toastToRender = {};
        var toastList = props.newestOnTop ? Object.keys(collection).reverse() : Object.keys(collection);
        for(var i = 0; i < toastList.length; i++){
            var _toast = collection[toastList[i]];
            var position = _toast.props.position;
            toastToRender[position] || (toastToRender[position] = []);
            toastToRender[position].push(_toast);
        }
        return Object.keys(toastToRender).map(function(p) {
            return cb(p, toastToRender[p]);
        });
    }
    return {
        getToastToRender: getToastToRender,
        collection: collection,
        containerRef: containerRef,
        isToastActive: isToastActive
    };
}
function $b967efa6cd5dde02$var$getX(e) {
    return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}
function $b967efa6cd5dde02$var$getY(e) {
    return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}
function $b967efa6cd5dde02$export$a407b657d3044108(props) {
    var _useState = (0, $a5EUy.useState)(true), isRunning = _useState[0], setIsRunning = _useState[1];
    var _useState2 = (0, $a5EUy.useState)(false), preventExitTransition = _useState2[0], setPreventExitTransition = _useState2[1];
    var toastRef = (0, $a5EUy.useRef)(null);
    var drag = $b967efa6cd5dde02$var$useKeeper({
        start: 0,
        x: 0,
        y: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: true,
        canDrag: false,
        boundingRect: null
    });
    var syncProps = $b967efa6cd5dde02$var$useKeeper(props, true);
    var autoClose = props.autoClose, pauseOnHover = props.pauseOnHover, closeToast = props.closeToast, onClick = props.onClick, closeOnClick = props.closeOnClick;
    (0, $a5EUy.useEffect)(function() {
        if ($b967efa6cd5dde02$var$isFn(props.onOpen)) props.onOpen((0, $a5EUy.isValidElement)(props.children) && props.children.props);
        return function() {
            if ($b967efa6cd5dde02$var$isFn(syncProps.onClose)) syncProps.onClose((0, $a5EUy.isValidElement)(syncProps.children) && syncProps.children.props);
        };
    }, []);
    (0, $a5EUy.useEffect)(function() {
        props.draggable && bindDragEvents();
        return function() {
            props.draggable && unbindDragEvents();
        };
    }, [
        props.draggable
    ]);
    (0, $a5EUy.useEffect)(function() {
        props.pauseOnFocusLoss && bindFocusEvents();
        return function() {
            props.pauseOnFocusLoss && unbindFocusEvents();
        };
    }, [
        props.pauseOnFocusLoss
    ]);
    function onDragStart(e) {
        if (props.draggable) {
            var toast = toastRef.current;
            drag.canCloseOnClick = true;
            drag.canDrag = true;
            drag.boundingRect = toast.getBoundingClientRect();
            toast.style.transition = '';
            drag.x = $b967efa6cd5dde02$var$getX(e.nativeEvent);
            drag.y = $b967efa6cd5dde02$var$getY(e.nativeEvent);
            if (props.draggableDirection === "x") {
                drag.start = drag.x;
                drag.removalDistance = toast.offsetWidth * (props.draggablePercent / 100);
            } else {
                drag.start = drag.y;
                drag.removalDistance = toast.offsetHeight * (props.draggablePercent / 100);
            }
        }
    }
    function onDragTransitionEnd() {
        if (drag.boundingRect) {
            var _drag$boundingRect = drag.boundingRect, top = _drag$boundingRect.top, bottom = _drag$boundingRect.bottom, left = _drag$boundingRect.left, right = _drag$boundingRect.right;
            if (props.pauseOnHover && drag.x >= left && drag.x <= right && drag.y >= top && drag.y <= bottom) pauseToast();
            else playToast();
        }
    }
    function playToast() {
        setIsRunning(true);
    }
    function pauseToast() {
        setIsRunning(false);
    }
    function bindFocusEvents() {
        if (!document.hasFocus()) pauseToast();
        window.addEventListener('focus', playToast);
        window.addEventListener('blur', pauseToast);
    }
    function unbindFocusEvents() {
        window.removeEventListener('focus', playToast);
        window.removeEventListener('blur', pauseToast);
    }
    function bindDragEvents() {
        document.addEventListener('mousemove', onDragMove);
        document.addEventListener('mouseup', onDragEnd);
        document.addEventListener('touchmove', onDragMove);
        document.addEventListener('touchend', onDragEnd);
    }
    function unbindDragEvents() {
        document.removeEventListener('mousemove', onDragMove);
        document.removeEventListener('mouseup', onDragEnd);
        document.removeEventListener('touchmove', onDragMove);
        document.removeEventListener('touchend', onDragEnd);
    }
    function onDragMove(e) {
        if (drag.canDrag) {
            e.preventDefault();
            var toast = toastRef.current;
            if (isRunning) pauseToast();
            drag.x = $b967efa6cd5dde02$var$getX(e);
            drag.y = $b967efa6cd5dde02$var$getY(e);
            if (props.draggableDirection === "x") drag.delta = drag.x - drag.start;
            else drag.delta = drag.y - drag.start;
             // prevent false positif during a toast click
            if (drag.start !== drag.x) drag.canCloseOnClick = false;
            toast.style.transform = "translate" + props.draggableDirection + "(" + drag.delta + "px)";
            toast.style.opacity = "" + (1 - Math.abs(drag.delta / drag.removalDistance));
        }
    }
    function onDragEnd() {
        var toast = toastRef.current;
        if (drag.canDrag) {
            drag.canDrag = false;
            if (Math.abs(drag.delta) > drag.removalDistance) {
                setPreventExitTransition(true);
                props.closeToast();
                return;
            }
            toast.style.transition = 'transform 0.2s, opacity 0.2s';
            toast.style.transform = "translate" + props.draggableDirection + "(0)";
            toast.style.opacity = '1';
        }
    }
    var eventHandlers = {
        onMouseDown: onDragStart,
        onTouchStart: onDragStart,
        onMouseUp: onDragTransitionEnd,
        onTouchEnd: onDragTransitionEnd
    };
    if (autoClose && pauseOnHover) {
        eventHandlers.onMouseEnter = pauseToast;
        eventHandlers.onMouseLeave = playToast;
    } // prevent toast from closing when user drags the toast
    if (closeOnClick) eventHandlers.onClick = function(e) {
        onClick && onClick(e);
        drag.canCloseOnClick && closeToast();
    };
    return {
        playToast: playToast,
        pauseToast: pauseToast,
        isRunning: isRunning,
        preventExitTransition: preventExitTransition,
        toastRef: toastRef,
        eventHandlers: eventHandlers
    };
}
function $b967efa6cd5dde02$var$CloseButton(_ref) {
    var closeToast = _ref.closeToast, type = _ref.type, _ref$ariaLabel = _ref.ariaLabel, ariaLabel = _ref$ariaLabel === void 0 ? 'close' : _ref$ariaLabel;
    return (0, $a5EUy.createElement)("button", {
        className: "Toastify__close-button Toastify__close-button--" + type,
        type: "button",
        onClick: function onClick(e) {
            e.stopPropagation();
            closeToast(e);
        },
        "aria-label": ariaLabel
    }, (0, $a5EUy.createElement)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, $a5EUy.createElement)("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $b967efa6cd5dde02$var$ProgressBar(_ref) {
    var _cx, _animationEvent;
    var delay = _ref.delay, isRunning = _ref.isRunning, closeToast = _ref.closeToast, type = _ref.type, hide = _ref.hide, className = _ref.className, userStyle = _ref.style, controlledProgress = _ref.controlledProgress, progress = _ref.progress, rtl = _ref.rtl, isIn = _ref.isIn;
    var style = $b967efa6cd5dde02$var$_extends({}, userStyle, {
        animationDuration: delay + "ms",
        animationPlayState: isRunning ? 'running' : 'paused',
        opacity: hide ? 0 : 1
    });
    if (controlledProgress) style.transform = "scaleX(" + progress + ")";
    var defaultClassName = (0, $4Izwm.default)("Toastify__progress-bar", controlledProgress ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", "Toastify__progress-bar--" + type, (_cx = {}, _cx["Toastify__progress-bar--rtl"] = rtl, _cx));
    var classNames = $b967efa6cd5dde02$var$isFn(className) ? className({
        rtl: rtl,
        type: type,
        defaultClassName: defaultClassName
    }) : (0, $4Izwm.default)(defaultClassName, className); // 🧐 controlledProgress is derived from progress
    // so if controlledProgress is set
    // it means that this is also the case for progress
    var animationEvent = (_animationEvent = {}, _animationEvent[controlledProgress && progress >= 1 ? 'onTransitionEnd' : 'onAnimationEnd'] = controlledProgress && progress < 1 ? null : function() {
        isIn && closeToast();
    }, _animationEvent); // TODO: add aria-valuenow, aria-valuemax, aria-valuemin
    return (0, $a5EUy.createElement)("div", Object.assign({
        role: "progressbar",
        "aria-hidden": hide ? 'true' : 'false',
        "aria-label": "notification timer",
        className: classNames,
        style: style
    }, animationEvent));
}
$b967efa6cd5dde02$var$ProgressBar.defaultProps = {
    type: $b967efa6cd5dde02$var$TYPE.DEFAULT,
    hide: false
};
var $b967efa6cd5dde02$var$Toast = function Toast(props) {
    var _cx;
    var _useToast = $b967efa6cd5dde02$export$a407b657d3044108(props), isRunning = _useToast.isRunning, preventExitTransition = _useToast.preventExitTransition, toastRef = _useToast.toastRef, eventHandlers = _useToast.eventHandlers;
    var closeButton = props.closeButton, children = props.children, autoClose = props.autoClose, onClick = props.onClick, type = props.type, hideProgressBar = props.hideProgressBar, closeToast = props.closeToast, Transition = props.transition, position = props.position, className = props.className, style = props.style, bodyClassName = props.bodyClassName, bodyStyle = props.bodyStyle, progressClassName = props.progressClassName, progressStyle = props.progressStyle, updateId = props.updateId, role = props.role, progress = props.progress, rtl = props.rtl, toastId = props.toastId, deleteToast = props.deleteToast, isIn = props.isIn;
    var defaultClassName = (0, $4Izwm.default)("Toastify__toast", "Toastify__toast--" + type, (_cx = {}, _cx["Toastify__toast--rtl"] = rtl, _cx));
    var cssClasses = $b967efa6cd5dde02$var$isFn(className) ? className({
        rtl: rtl,
        position: position,
        type: type,
        defaultClassName: defaultClassName
    }) : (0, $4Izwm.default)(defaultClassName, className);
    var isProgressControlled = !!progress;
    function renderCloseButton(closeButton) {
        if (!closeButton) return;
        var props = {
            closeToast: closeToast,
            type: type
        };
        if ($b967efa6cd5dde02$var$isFn(closeButton)) return closeButton(props);
        if ((0, $a5EUy.isValidElement)(closeButton)) return (0, $a5EUy.cloneElement)(closeButton, props);
    }
    return (0, $a5EUy.createElement)(Transition, {
        isIn: isIn,
        done: deleteToast,
        position: position,
        preventExitTransition: preventExitTransition,
        nodeRef: toastRef
    }, (0, $a5EUy.createElement)("div", Object.assign({
        id: toastId,
        onClick: onClick,
        className: cssClasses
    }, eventHandlers, {
        style: style,
        ref: toastRef
    }), (0, $a5EUy.createElement)("div", Object.assign({}, isIn && {
        role: role
    }, {
        className: $b967efa6cd5dde02$var$isFn(bodyClassName) ? bodyClassName({
            type: type
        }) : (0, $4Izwm.default)("Toastify__toast-body", bodyClassName),
        style: bodyStyle
    }), children), renderCloseButton(closeButton), (autoClose || isProgressControlled) && (0, $a5EUy.createElement)($b967efa6cd5dde02$var$ProgressBar, Object.assign({}, updateId && !isProgressControlled ? {
        key: "pb-" + updateId
    } : {}, {
        rtl: rtl,
        delay: autoClose,
        isRunning: isRunning,
        isIn: isIn,
        closeToast: closeToast,
        hide: hideProgressBar,
        type: type,
        style: progressStyle,
        className: progressClassName,
        controlledProgress: isProgressControlled,
        progress: progress
    }))));
};
var $b967efa6cd5dde02$export$d20e79fdc3899e95 = /*#__PURE__*/ $b967efa6cd5dde02$export$3ff7dc44d332d222({
    enter: "Toastify--animate Toastify__bounce-enter",
    exit: "Toastify--animate Toastify__bounce-exit",
    appendPosition: true
});
var $b967efa6cd5dde02$export$d8dc01b5c85a37b9 = /*#__PURE__*/ $b967efa6cd5dde02$export$3ff7dc44d332d222({
    enter: "Toastify--animate Toastify__slide-enter",
    exit: "Toastify--animate Toastify__slide-exit",
    appendPosition: true
});
var $b967efa6cd5dde02$export$65cfd44a2050f99 = /*#__PURE__*/ $b967efa6cd5dde02$export$3ff7dc44d332d222({
    enter: "Toastify--animate Toastify__zoom-enter",
    exit: "Toastify--animate Toastify__zoom-exit"
});
var $b967efa6cd5dde02$export$4d2fae537bd90431 = /*#__PURE__*/ $b967efa6cd5dde02$export$3ff7dc44d332d222({
    enter: "Toastify--animate Toastify__flip-enter",
    exit: "Toastify--animate Toastify__flip-exit"
});
var $b967efa6cd5dde02$export$f2815235e76a62b9 = function ToastContainer(props) {
    var _useToastContainer = $b967efa6cd5dde02$export$b262e13ca2dd2381(props), getToastToRender = _useToastContainer.getToastToRender, containerRef = _useToastContainer.containerRef, isToastActive = _useToastContainer.isToastActive;
    var className = props.className, style = props.style, rtl = props.rtl, containerId = props.containerId;
    function getClassName(position) {
        var _cx;
        var defaultClassName = (0, $4Izwm.default)("Toastify__toast-container", "Toastify__toast-container--" + position, (_cx = {}, _cx["Toastify__toast-container--rtl"] = rtl, _cx));
        return $b967efa6cd5dde02$var$isFn(className) ? className({
            position: position,
            rtl: rtl,
            defaultClassName: defaultClassName
        }) : (0, $4Izwm.default)(defaultClassName, $b967efa6cd5dde02$var$parseClassName(className));
    }
    return (0, $a5EUy.createElement)("div", {
        ref: containerRef,
        className: "Toastify",
        id: containerId
    }, getToastToRender(function(position, toastList) {
        var containerStyle = toastList.length === 0 ? $b967efa6cd5dde02$var$_extends({}, style, {
            pointerEvents: 'none'
        }) : $b967efa6cd5dde02$var$_extends({}, style);
        return (0, $a5EUy.createElement)("div", {
            className: getClassName(position),
            style: containerStyle,
            key: "container-" + position
        }, toastList.map(function(_ref) {
            var content = _ref.content, toastProps = _ref.props;
            return (0, $a5EUy.createElement)($b967efa6cd5dde02$var$Toast, Object.assign({}, toastProps, {
                isIn: isToastActive(toastProps.toastId),
                key: "toast-" + toastProps.key,
                closeButton: toastProps.closeButton === true ? $b967efa6cd5dde02$var$CloseButton : toastProps.closeButton
            }), content);
        }));
    }));
};
$b967efa6cd5dde02$export$f2815235e76a62b9.defaultProps = {
    position: $b967efa6cd5dde02$var$POSITION.TOP_RIGHT,
    transition: $b967efa6cd5dde02$export$d20e79fdc3899e95,
    rtl: false,
    autoClose: 5000,
    hideProgressBar: false,
    closeButton: $b967efa6cd5dde02$var$CloseButton,
    pauseOnHover: true,
    pauseOnFocusLoss: true,
    closeOnClick: true,
    newestOnTop: false,
    draggable: true,
    draggablePercent: 80,
    draggableDirection: "x",
    role: 'alert'
};
var $b967efa6cd5dde02$var$containers = /*#__PURE__*/ new Map();
var $b967efa6cd5dde02$var$latestInstance;
var $b967efa6cd5dde02$var$containerDomNode;
var $b967efa6cd5dde02$var$containerConfig;
var $b967efa6cd5dde02$var$queue = [];
var $b967efa6cd5dde02$var$lazy = false;
/**
 * Check whether any container is currently mounted in the DOM
 */ function $b967efa6cd5dde02$var$isAnyContainerMounted() {
    return $b967efa6cd5dde02$var$containers.size > 0;
}
/**
 * Get the toast by id, given it's in the DOM, otherwise returns null
 */ function $b967efa6cd5dde02$var$getToast(toastId, _ref) {
    var containerId = _ref.containerId;
    var container = $b967efa6cd5dde02$var$containers.get(containerId || $b967efa6cd5dde02$var$latestInstance);
    if (!container) return null;
    return container.getToast(toastId);
}
/**
 * Generate a random toastId
 */ function $b967efa6cd5dde02$var$generateToastId() {
    return Math.random().toString(36).substr(2, 9);
}
/**
 * Generate a toastId or use the one provided
 */ function $b967efa6cd5dde02$var$getToastId(options) {
    if (options && ($b967efa6cd5dde02$var$isStr(options.toastId) || $b967efa6cd5dde02$var$isNum(options.toastId))) return options.toastId;
    return $b967efa6cd5dde02$var$generateToastId();
}
/**
 * If the container is not mounted, the toast is enqueued and
 * the container lazy mounted
 */ function $b967efa6cd5dde02$var$dispatchToast(content, options) {
    if ($b967efa6cd5dde02$var$isAnyContainerMounted()) $b967efa6cd5dde02$var$eventManager.emit(0, content, options);
    else {
        $b967efa6cd5dde02$var$queue.push({
            content: content,
            options: options
        });
        if ($b967efa6cd5dde02$var$lazy && $b967efa6cd5dde02$var$canUseDom) {
            $b967efa6cd5dde02$var$lazy = false;
            $b967efa6cd5dde02$var$containerDomNode = document.createElement('div');
            document.body.appendChild($b967efa6cd5dde02$var$containerDomNode);
            (0, $jUibk.render)((0, $a5EUy.createElement)($b967efa6cd5dde02$export$f2815235e76a62b9, Object.assign({}, $b967efa6cd5dde02$var$containerConfig)), $b967efa6cd5dde02$var$containerDomNode);
        }
    }
    return options.toastId;
}
/**
 * Merge provided options with the defaults settings and generate the toastId
 */ function $b967efa6cd5dde02$var$mergeOptions(type, options) {
    return $b967efa6cd5dde02$var$_extends({}, options, {
        type: options && options.type || type,
        toastId: $b967efa6cd5dde02$var$getToastId(options)
    });
}
var $b967efa6cd5dde02$var$createToastByType = function createToastByType(type) {
    return function(content, options) {
        return $b967efa6cd5dde02$var$dispatchToast(content, $b967efa6cd5dde02$var$mergeOptions(type, options));
    };
};
var $b967efa6cd5dde02$export$b410431fab84fa58 = function toast(content, options) {
    return $b967efa6cd5dde02$var$dispatchToast(content, $b967efa6cd5dde02$var$mergeOptions($b967efa6cd5dde02$var$TYPE.DEFAULT, options));
};
$b967efa6cd5dde02$export$b410431fab84fa58.success = /*#__PURE__*/ $b967efa6cd5dde02$var$createToastByType($b967efa6cd5dde02$var$TYPE.SUCCESS);
$b967efa6cd5dde02$export$b410431fab84fa58.info = /*#__PURE__*/ $b967efa6cd5dde02$var$createToastByType($b967efa6cd5dde02$var$TYPE.INFO);
$b967efa6cd5dde02$export$b410431fab84fa58.error = /*#__PURE__*/ $b967efa6cd5dde02$var$createToastByType($b967efa6cd5dde02$var$TYPE.ERROR);
$b967efa6cd5dde02$export$b410431fab84fa58.warning = /*#__PURE__*/ $b967efa6cd5dde02$var$createToastByType($b967efa6cd5dde02$var$TYPE.WARNING);
$b967efa6cd5dde02$export$b410431fab84fa58.dark = /*#__PURE__*/ $b967efa6cd5dde02$var$createToastByType($b967efa6cd5dde02$var$TYPE.DARK);
$b967efa6cd5dde02$export$b410431fab84fa58.warn = $b967efa6cd5dde02$export$b410431fab84fa58.warning;
/**
 * Remove toast programmaticaly
 */ $b967efa6cd5dde02$export$b410431fab84fa58.dismiss = function(id) {
    return $b967efa6cd5dde02$var$eventManager.emit(1, id);
};
/**
 * Clear waiting queue when limit is used
 */ $b967efa6cd5dde02$export$b410431fab84fa58.clearWaitingQueue = function(params) {
    if (params === void 0) params = {};
    return $b967efa6cd5dde02$var$eventManager.emit(5, params);
};
/**
 * return true if one container is displaying the toast
 */ $b967efa6cd5dde02$export$b410431fab84fa58.isActive = function(id) {
    var isToastActive = false;
    $b967efa6cd5dde02$var$containers.forEach(function(container) {
        if (container.isToastActive && container.isToastActive(id)) isToastActive = true;
    });
    return isToastActive;
};
$b967efa6cd5dde02$export$b410431fab84fa58.update = function(toastId, options) {
    if (options === void 0) options = {};
    // if you call toast and toast.update directly nothing will be displayed
    // this is why I defered the update
    setTimeout(function() {
        var toast = $b967efa6cd5dde02$var$getToast(toastId, options);
        if (toast) {
            var oldOptions = toast.props, oldContent = toast.content;
            var nextOptions = $b967efa6cd5dde02$var$_extends({}, oldOptions, options, {
                toastId: options.toastId || toastId,
                updateId: $b967efa6cd5dde02$var$generateToastId()
            });
            if (nextOptions.toastId !== toastId) nextOptions.staleId = toastId;
            var content = nextOptions.render || oldContent;
            delete nextOptions.render;
            $b967efa6cd5dde02$var$dispatchToast(content, nextOptions);
        }
    }, 0);
};
/**
 * Used for controlled progress bar.
 */ $b967efa6cd5dde02$export$b410431fab84fa58.done = function(id) {
    $b967efa6cd5dde02$export$b410431fab84fa58.update(id, {
        progress: 1
    });
};
/**
 * Track changes. The callback get the number of toast displayed
 *
 */ $b967efa6cd5dde02$export$b410431fab84fa58.onChange = function(callback) {
    if ($b967efa6cd5dde02$var$isFn(callback)) $b967efa6cd5dde02$var$eventManager.on(4, callback);
    return function() {
        $b967efa6cd5dde02$var$isFn(callback) && $b967efa6cd5dde02$var$eventManager.off(4, callback);
    };
};
/**
 * Configure the ToastContainer when lazy mounted
 */ $b967efa6cd5dde02$export$b410431fab84fa58.configure = function(config) {
    if (config === void 0) config = {};
    $b967efa6cd5dde02$var$lazy = true;
    $b967efa6cd5dde02$var$containerConfig = config;
};
$b967efa6cd5dde02$export$b410431fab84fa58.POSITION = $b967efa6cd5dde02$var$POSITION;
$b967efa6cd5dde02$export$b410431fab84fa58.TYPE = $b967efa6cd5dde02$var$TYPE;
/**
 * Wait until the ToastContainer is mounted to dispatch the toast
 * and attach isActive method
 */ $b967efa6cd5dde02$var$eventManager.on(2, function(containerInstance) {
    $b967efa6cd5dde02$var$latestInstance = containerInstance.containerId || containerInstance;
    $b967efa6cd5dde02$var$containers.set($b967efa6cd5dde02$var$latestInstance, containerInstance);
    $b967efa6cd5dde02$var$queue.forEach(function(item) {
        $b967efa6cd5dde02$var$eventManager.emit(0, item.content, item.options);
    });
    $b967efa6cd5dde02$var$queue = [];
}).on(3, function(containerInstance) {
    $b967efa6cd5dde02$var$containers["delete"](containerInstance.containerId || containerInstance);
    if ($b967efa6cd5dde02$var$containers.size === 0) $b967efa6cd5dde02$var$eventManager.off(0).off(1).off(5);
    if ($b967efa6cd5dde02$var$canUseDom && $b967efa6cd5dde02$var$containerDomNode) document.body.removeChild($b967efa6cd5dde02$var$containerDomNode);
});

});
parcelRegister("4Izwm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36f6d336ae55c023$export$2e2bcd8739ae039; });
function $36f6d336ae55c023$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $36f6d336ae55c023$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $36f6d336ae55c023$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $36f6d336ae55c023$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $36f6d336ae55c023$export$2e2bcd8739ae039 = $36f6d336ae55c023$export$4f5d2d50c9deca37;

});


parcelRegister("hi8ts", function(module, exports) {

$parcel$export(module.exports, "Attach", function () { return (parcelRequire("cTeyJ")).Attach; });
$parcel$export(module.exports, "CheckTickBold", function () { return (parcelRequire("bwcHG")).CheckTickBold; });
$parcel$export(module.exports, "CloudUpload", function () { return (parcelRequire("8gxGP")).CloudUpload; });
$parcel$export(module.exports, "Cross", function () { return (parcelRequire("gJq8e")).Cross; });
$parcel$export(module.exports, "Delete", function () { return (parcelRequire("7PgDK")).Delete; });
$parcel$export(module.exports, "ExpandBold", function () { return (parcelRequire("h4u5Z")).ExpandBold; });
$parcel$export(module.exports, "FilesPdf", function () { return (parcelRequire("gZ892")).FilesPdf; });
$parcel$export(module.exports, "HomeBold", function () { return (parcelRequire("eFIEm")).HomeBold; });
$parcel$export(module.exports, "LogOutBold", function () { return (parcelRequire("442h0")).LogOutBold; });
$parcel$export(module.exports, "MinusBold", function () { return (parcelRequire("jNIIb")).MinusBold; });
$parcel$export(module.exports, "StatusInformationBold", function () { return (parcelRequire("5NEgo")).StatusInformationBold; });
$parcel$export(module.exports, "StatusSuccessBold", function () { return (parcelRequire("bWBwj")).StatusSuccessBold; });
$parcel$export(module.exports, "StatusWarningBold", function () { return (parcelRequire("6yLT8")).StatusWarningBold; });

var $60Vli = parcelRequire("60Vli");

var $fJpVe = parcelRequire("fJpVe");

var $SF58U = parcelRequire("SF58U");

var $4GJJf = parcelRequire("4GJJf");

var $kGD7Y = parcelRequire("kGD7Y");

var $3l7lP = parcelRequire("3l7lP");

var $eH5NY = parcelRequire("eH5NY");

var $kLEc6 = parcelRequire("kLEc6");

var $9mMjg = parcelRequire("9mMjg");

var $3sqfs = parcelRequire("3sqfs");

var $op8dM = parcelRequire("op8dM");

var $2MZLO = parcelRequire("2MZLO");

var $dSdNC = parcelRequire("dSdNC");

var $fx9ci = parcelRequire("fx9ci");

var $fSqSZ = parcelRequire("fSqSZ");

var $jmfnS = parcelRequire("jmfnS");

var $dyeR0 = parcelRequire("dyeR0");

var $gTqPq = parcelRequire("gTqPq");

var $h91SI = parcelRequire("h91SI");

var $eh7Pr = parcelRequire("eh7Pr");

var $e32pT = parcelRequire("e32pT");

var $dztlP = parcelRequire("dztlP");

var $51qSw = parcelRequire("51qSw");

var $3s1V0 = parcelRequire("3s1V0");

var $cOAMW = parcelRequire("cOAMW");

var $cTeyJ = parcelRequire("cTeyJ");

var $gw9Cm = parcelRequire("gw9Cm");

var $3WMht = parcelRequire("3WMht");

var $hCI3V = parcelRequire("hCI3V");

var $7Hn21 = parcelRequire("7Hn21");

var $cnT5U = parcelRequire("cnT5U");

var $asC42 = parcelRequire("asC42");

var $bIJqo = parcelRequire("bIJqo");

var $ldxgF = parcelRequire("ldxgF");

var $lf2Jy = parcelRequire("lf2Jy");

var $cgDv8 = parcelRequire("cgDv8");

var $bwcHG = parcelRequire("bwcHG");

var $kDE7F = parcelRequire("kDE7F");

var $cPn98 = parcelRequire("cPn98");

var $7ZO3U = parcelRequire("7ZO3U");

var $21H6K = parcelRequire("21H6K");

var $8gxGP = parcelRequire("8gxGP");

var $inUxV = parcelRequire("inUxV");

var $5PM1x = parcelRequire("5PM1x");

var $bCFiV = parcelRequire("bCFiV");

var $fO6tC = parcelRequire("fO6tC");

var $j9jwW = parcelRequire("j9jwW");

var $gJq8e = parcelRequire("gJq8e");

var $9T8uK = parcelRequire("9T8uK");

var $5ByWn = parcelRequire("5ByWn");

var $884Qk = parcelRequire("884Qk");

var $1bVk3 = parcelRequire("1bVk3");

var $hK8TE = parcelRequire("hK8TE");

var $huICd = parcelRequire("huICd");

var $kPhzk = parcelRequire("kPhzk");

var $7PgDK = parcelRequire("7PgDK");

var $lj9dA = parcelRequire("lj9dA");

var $6MU2q = parcelRequire("6MU2q");

var $463aN = parcelRequire("463aN");

var $4ugFB = parcelRequire("4ugFB");

var $49gqP = parcelRequire("49gqP");

var $jVN0j = parcelRequire("jVN0j");

var $iNkPT = parcelRequire("iNkPT");

var $hq5MN = parcelRequire("hq5MN");

var $4fBbc = parcelRequire("4fBbc");

var $FiuGu = parcelRequire("FiuGu");

var $jXBD2 = parcelRequire("jXBD2");

var $7JPkW = parcelRequire("7JPkW");

var $fw6bS = parcelRequire("fw6bS");

var $jde0j = parcelRequire("jde0j");

var $2pZF5 = parcelRequire("2pZF5");

var $bslby = parcelRequire("bslby");

var $8xC9g = parcelRequire("8xC9g");

var $3npvX = parcelRequire("3npvX");

var $5eLsd = parcelRequire("5eLsd");

var $3w177 = parcelRequire("3w177");

var $lcNYd = parcelRequire("lcNYd");

var $h4u5Z = parcelRequire("h4u5Z");

var $9Ie5Z = parcelRequire("9Ie5Z");

var $gWb4A = parcelRequire("gWb4A");

var $APNu3 = parcelRequire("APNu3");

var $fTslh = parcelRequire("fTslh");

var $jSPYz = parcelRequire("jSPYz");

var $aLUNI = parcelRequire("aLUNI");

var $izgdK = parcelRequire("izgdK");

var $gZ892 = parcelRequire("gZ892");

var $1m5O6 = parcelRequire("1m5O6");

var $7Ei12 = parcelRequire("7Ei12");

var $SFBS5 = parcelRequire("SFBS5");

var $e3pzM = parcelRequire("e3pzM");

var $kUQJ5 = parcelRequire("kUQJ5");

var $7Rpng = parcelRequire("7Rpng");

var $lFVYP = parcelRequire("lFVYP");

var $1k6wg = parcelRequire("1k6wg");

var $a1vPt = parcelRequire("a1vPt");

var $lLVPy = parcelRequire("lLVPy");

var $k72wy = parcelRequire("k72wy");

var $39dP1 = parcelRequire("39dP1");

var $eFIEm = parcelRequire("eFIEm");

var $gZ3ah = parcelRequire("gZ3ah");

var $jpvOM = parcelRequire("jpvOM");

var $6qMOO = parcelRequire("6qMOO");

var $46TEO = parcelRequire("46TEO");

var $dD7mz = parcelRequire("dD7mz");

var $1U9Sh = parcelRequire("1U9Sh");

var $fi8Pj = parcelRequire("fi8Pj");

var $jY6It = parcelRequire("jY6It");

var $juG9J = parcelRequire("juG9J");

var $e7RhV = parcelRequire("e7RhV");

var $6AChK = parcelRequire("6AChK");

var $a05Lj = parcelRequire("a05Lj");

var $hBbA3 = parcelRequire("hBbA3");

var $ad6zA = parcelRequire("ad6zA");

var $9OcZA = parcelRequire("9OcZA");

var $hezql = parcelRequire("hezql");

var $3vBbk = parcelRequire("3vBbk");

var $32fPG = parcelRequire("32fPG");

var $3HEUC = parcelRequire("3HEUC");

var $hYF28 = parcelRequire("hYF28");

var $i3pPH = parcelRequire("i3pPH");

var $cSPeX = parcelRequire("cSPeX");

var $bBxEC = parcelRequire("bBxEC");

var $cZ9oF = parcelRequire("cZ9oF");

var $3L24I = parcelRequire("3L24I");

var $9fV8w = parcelRequire("9fV8w");

var $amnFV = parcelRequire("amnFV");

var $lVgvD = parcelRequire("lVgvD");

var $442h0 = parcelRequire("442h0");

var $586iM = parcelRequire("586iM");

var $6bKks = parcelRequire("6bKks");

var $9PUm8 = parcelRequire("9PUm8");

var $kHr1J = parcelRequire("kHr1J");

var $inuXG = parcelRequire("inuXG");

var $jNIIb = parcelRequire("jNIIb");

var $ayy3Z = parcelRequire("ayy3Z");

var $ciQzL = parcelRequire("ciQzL");

var $3NklM = parcelRequire("3NklM");

var $3Fmvz = parcelRequire("3Fmvz");

var $t3odn = parcelRequire("t3odn");

var $bmc5Q = parcelRequire("bmc5Q");

var $7MH2k = parcelRequire("7MH2k");

var $hMzPw = parcelRequire("hMzPw");

var $iHsdG = parcelRequire("iHsdG");

var $1ZhSq = parcelRequire("1ZhSq");

var $lUNyI = parcelRequire("lUNyI");

var $f6HYG = parcelRequire("f6HYG");

var $fGQFd = parcelRequire("fGQFd");

var $eUTxF = parcelRequire("eUTxF");

var $8ytUa = parcelRequire("8ytUa");

var $eWhmm = parcelRequire("eWhmm");

var $6HNJw = parcelRequire("6HNJw");

var $l4SQC = parcelRequire("l4SQC");

var $ayR8x = parcelRequire("ayR8x");

var $1hPCc = parcelRequire("1hPCc");

var $74pOs = parcelRequire("74pOs");

var $dgu55 = parcelRequire("dgu55");

var $aLath = parcelRequire("aLath");

var $h7jKy = parcelRequire("h7jKy");

var $777QQ = parcelRequire("777QQ");

var $3Z7fX = parcelRequire("3Z7fX");

var $53Mb3 = parcelRequire("53Mb3");

var $gXIQ9 = parcelRequire("gXIQ9");

var $l7qsC = parcelRequire("l7qsC");

var $4TbYF = parcelRequire("4TbYF");

var $66yKP = parcelRequire("66yKP");

var $4byhk = parcelRequire("4byhk");

var $7yyM1 = parcelRequire("7yyM1");

var $qKomK = parcelRequire("qKomK");

var $1Bu7D = parcelRequire("1Bu7D");

var $9bZFF = parcelRequire("9bZFF");

var $9USAO = parcelRequire("9USAO");

var $aklsT = parcelRequire("aklsT");

var $gZu9w = parcelRequire("gZu9w");

var $5kyd5 = parcelRequire("5kyd5");

var $7MzzB = parcelRequire("7MzzB");

var $3ILQb = parcelRequire("3ILQb");

var $gSIgl = parcelRequire("gSIgl");

var $3NDHP = parcelRequire("3NDHP");

var $5LE6s = parcelRequire("5LE6s");

var $h9huQ = parcelRequire("h9huQ");

var $9F2Ce = parcelRequire("9F2Ce");

var $5NEgo = parcelRequire("5NEgo");

var $9Y2zh = parcelRequire("9Y2zh");

var $bWBwj = parcelRequire("bWBwj");

var $jJtdA = parcelRequire("jJtdA");

var $6yLT8 = parcelRequire("6yLT8");

var $9TLO0 = parcelRequire("9TLO0");

var $frXCm = parcelRequire("frXCm");

var $gBcpo = parcelRequire("gBcpo");

var $rB8RG = parcelRequire("rB8RG");

var $1bZNG = parcelRequire("1bZNG");

var $a0n27 = parcelRequire("a0n27");

var $9ErvD = parcelRequire("9ErvD");

var $4hM42 = parcelRequire("4hM42");

var $7hlam = parcelRequire("7hlam");

var $4i2tC = parcelRequire("4i2tC");

var $i6MgI = parcelRequire("i6MgI");

var $3qdRt = parcelRequire("3qdRt");

var $dJUxe = parcelRequire("dJUxe");

var $gJclC = parcelRequire("gJclC");

var $6UgYF = parcelRequire("6UgYF");

var $3RqjR = parcelRequire("3RqjR");

var $bPZGS = parcelRequire("bPZGS");

var $geUMU = parcelRequire("geUMU");

var $3Uinh = parcelRequire("3Uinh");

var $lHQvY = parcelRequire("lHQvY");

var $SxCX5 = parcelRequire("SxCX5");

var $lBdrV = parcelRequire("lBdrV");

var $d1GWS = parcelRequire("d1GWS");

var $4wrDA = parcelRequire("4wrDA");

var $bAfz4 = parcelRequire("bAfz4");

var $c4GNT = parcelRequire("c4GNT");

var $7k5FS = parcelRequire("7k5FS");

var $bPrr9 = parcelRequire("bPrr9");

var $hIU8s = parcelRequire("hIU8s");

var $9rCnX = parcelRequire("9rCnX");

var $hjUMD = parcelRequire("hjUMD");

var $fuD4A = parcelRequire("fuD4A");

var $gef6F = parcelRequire("gef6F");

var $ajWj5 = parcelRequire("ajWj5");

});
parcelRegister("60Vli", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $460f392ef3cf7aa1$var$__assign = undefined && undefined.__assign || function() {
    $460f392ef3cf7aa1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $460f392ef3cf7aa1$var$__assign.apply(this, arguments);
};
var $460f392ef3cf7aa1$export$761e6d83b3265241 = $a5EUy.forwardRef(function AccountingDocument(props, svgRef) {
    return $a5EUy.createElement("svg", $460f392ef3cf7aa1$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M7.597 7.03a1.471 1.471 0 011.226.58.75.75 0 101.194-.908 2.97 2.97 0 00-1.705-1.099V5.25a.75.75 0 10-1.5 0v.363c-.43.095-.828.273-1.158.52-.515.387-.904.978-.904 1.695 0 .716.389 1.308.904 1.694.515.387 1.192.604 1.908.604.422 0 .775.13 1.006.303.23.172.303.354.303.493 0 .138-.073.32-.304.494-.232.173-.586.303-1.009.303h-.03a1.475 1.475 0 01-1.231-.58.75.75 0 10-1.194.91 2.974 2.974 0 001.709 1.098v.353a.75.75 0 001.5 0v-.363c.43-.097.825-.274 1.155-.521.515-.387.904-.978.904-1.694 0-.715-.388-1.306-.902-1.693-.515-.386-1.191-.603-1.907-.603-.422 0-.776-.13-1.008-.303-.23-.174-.304-.356-.304-.495 0-.138.073-.32.304-.494.231-.173.585-.303 1.006-.303h.037zM10.75 15a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75zm-4.5 3.75a.75.75 0 000 1.5H17.5a.75.75 0 000-1.5H6.25z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M22 21.75V8.12a2.25 2.25 0 00-.659-1.59L15.47.659A2.25 2.25 0 0013.88 0H3.25A2.25 2.25 0 001 2.25v19.5A2.25 2.25 0 003.25 24h16.5A2.25 2.25 0 0022 21.75zM3.25 1.5a.75.75 0 00-.75.75v19.5a.75.75 0 00.75.75h16.5a.75.75 0 00.75-.75V9h-5.25A2.25 2.25 0 0113 6.75V1.5H3.25zm12 6h4.94L14.5 1.81v4.94a.75.75 0 00.75.75z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("fJpVe", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $b73f2a8fba5400da$var$__assign = undefined && undefined.__assign || function() {
    $b73f2a8fba5400da$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b73f2a8fba5400da$var$__assign.apply(this, arguments);
};
var $b73f2a8fba5400da$export$36f90dd5c5d5cc11 = $a5EUy.forwardRef(function AccountingDocumentBold(props, svgRef) {
    return $a5EUy.createElement("svg", $b73f2a8fba5400da$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M21.561 5.854L16.146.439A1.511 1.511 0 0015.086 0H3.5A1.5 1.5 0 002 1.5v21A1.5 1.5 0 003.5 24h18a.5.5 0 00.5-.5V6.914a1.49 1.49 0 00-.439-1.06zM9.817 11.183l-3.37-1.26A2.55 2.55 0 015 7.455 2.529 2.529 0 017.289 4.92a.249.249 0 00.211-.247V4a1 1 0 012 0v.625c0 .138.112.25.25.25H11a1 1 0 110 2H7.875C7 6.875 7 7.311 7 7.455a.9.9 0 00.183.612l3.37 1.26A2.55 2.55 0 0112 11.8a2.53 2.53 0 01-2.289 2.53.249.249 0 00-.211.247v.673a1 1 0 11-2 0v-.625a.25.25 0 00-.25-.25H6a1 1 0 110-2h3.125c.875 0 .875-.436.875-.58a.9.9 0 00-.183-.612zM19.25 15.5a.75.75 0 00-.75-.75h-5a.75.75 0 000 1.5h5a.75.75 0 00.75-.75zm-4.5-4.5a.75.75 0 01.75-.75h3a.75.75 0 010 1.5h-3a.75.75 0 01-.75-.75zm4.5 9a.75.75 0 00-.75-.75h-10a.75.75 0 000 1.5h10a.75.75 0 00.75-.75z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("SF58U", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $0a44e9478348c396$var$__assign = undefined && undefined.__assign || function() {
    $0a44e9478348c396$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0a44e9478348c396$var$__assign.apply(this, arguments);
};
var $0a44e9478348c396$export$4c2b5ab87db1a6be = $a5EUy.forwardRef(function AdvertisingMegaphone(props, svgRef) {
    return $a5EUy.createElement("svg", $0a44e9478348c396$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("g", {
        clipPath: "url(#advertising-megaphone_svg__advertising-megaphone_svg__clip0)"
    }, $a5EUy.createElement("path", {
        d: "M11.808.371a1.678 1.678 0 011.98-.092l.127.092 2.063 1.665 2.647-.131a1.678 1.678 0 011.659 1.097l.044.14.691 2.558 2.22 1.449c.617.403.894 1.155.7 1.853l-.049.149-.944 2.476.944 2.477a1.68 1.68 0 01-.525 1.912l-.127.092-2.219 1.444-.695 2.557a1.677 1.677 0 01-1.556 1.24h-.147l-2.648-.133-2.063 1.662a.75.75 0 01-.978-.032l-.076-.082a.75.75 0 01.033-.978l.08-.076 2.287-1.841a.75.75 0 01.398-.163l.11-.002 2.932.146a.177.177 0 00.161-.087l.02-.046.77-2.835a.75.75 0 01.228-.365l.087-.067 2.457-1.599a.18.18 0 00.08-.165l-.01-.048-1.046-2.743a.75.75 0 01-.031-.429l.031-.105 1.045-2.744a.178.178 0 00-.032-.18l-.037-.032L19.961 6.8a.75.75 0 01-.277-.329l-.037-.103-.767-2.834a.178.178 0 00-.132-.127l-.049-.004-2.932.146a.75.75 0 01-.418-.103l-.09-.062-2.286-1.845a.178.178 0 00-.17-.03l-.053.03-2.286 1.845a.75.75 0 01-.399.163l-.11.002L7.024 3.4a.178.178 0 00-.162.086l-.019.045-.767 2.834a.75.75 0 01-.227.365l-.087.067-2.457 1.605a.18.18 0 00-.08.164l.01.048 1.046 2.744a.75.75 0 01.031.43l-.031.104-.448 1.175A.75.75 0 012.4 12.63l.03-.097.346-.908-.944-2.478a1.68 1.68 0 01.524-1.91l.127-.091 2.22-1.449.691-2.558A1.678 1.678 0 016.952 1.9l.147.001 2.646.133L11.808.371z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M.348 19.136a.75.75 0 01.724-.045l8.25-10.469-.047-.073a.75.75 0 011.2-.893l.066.09 5.963 9.393.011.018.32.504a.75.75 0 01-1.2.893l-.066-.09-.023-.035-5.19 1.623a3.013 3.013 0 01-1.09 3.448 2.79 2.79 0 01-3.86-.665l-.668-1.025-1.585.496a.75.75 0 01-1.314.563l-.066-.09-.32-.503-.011-.017-.994-1.566-.01-.018-.321-.504a.75.75 0 01.231-1.035zm4.498 1.068a.87.87 0 00-.027.008L2.4 20.97l-.4-.631 8.173-10.374 4.54 7.153-5.653 1.769a.653.653 0 00-.043.013l-4.171 1.305zm1.379 1.14l.347.535a1.291 1.291 0 001.828.396 1.51 1.51 0 00.526-1.775l-2.701.845z",
        fillRule: "evenodd"
    })), $a5EUy.createElement("defs", null, $a5EUy.createElement("clipPath", {
        id: "advertising-megaphone_svg__advertising-megaphone_svg__clip0"
    }, $a5EUy.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});

});

parcelRegister("4GJJf", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $369e8e6e441e758e$var$__assign = undefined && undefined.__assign || function() {
    $369e8e6e441e758e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $369e8e6e441e758e$var$__assign.apply(this, arguments);
};
var $369e8e6e441e758e$export$93d05658c51f49eb = $a5EUy.forwardRef(function AdvertisingMegaphoneBold(props, svgRef) {
    return $a5EUy.createElement("svg", $369e8e6e441e758e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M23.86 14.293l-2.077-3.561a.258.258 0 01-.033-.149l.32-4.154c.038-.49-.27-.936-.73-1.052l-3.885-.987a.242.242 0 01-.126-.081l-2.592-3.174a.934.934 0 00-1.23-.206l-3.418 2.163a.23.23 0 01-.144.035l-3.988-.334a.989.989 0 00-1.01.76L3.907 8c-.126.537.19 1.078.705 1.209.515.13 1.035-.198 1.16-.735l.798-3.407a.241.241 0 01.253-.189l3.36.281a.952.952 0 00.576-.143l2.88-1.82a.232.232 0 01.307.052l2.172 2.666c.131.16.307.273.503.323l3.271.831a.25.25 0 01.183.263l-.27 3.5c-.017.21.031.42.136.6l1.748 3a.26.26 0 01-.05.32l-2.564 2.263c-.154.137-.262.32-.31.525l-.798 3.406a.241.241 0 01-.252.19l-3.355-.281c-.529-.044-.992.366-1.034.917-.043.55.351 1.033.88 1.077l4.374.366h.079a.968.968 0 00.93-.762l.95-4.049a.25.25 0 01.077-.131l3.046-2.7a1.03 1.03 0 00.198-1.279z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M1.04 19.826a.517.517 0 01.03-.6L9.017 9.093a.257.257 0 00.015-.3l-.069-.106a.77.77 0 01.202-1.04.703.703 0 01.998.21l6.124 9.607a.77.77 0 01-.201 1.04.693.693 0 01-.398.125.715.715 0 01-.6-.335l-.076-.117a.234.234 0 00-.252-.1l-4.122.964a.24.24 0 00-.157.121.258.258 0 00-.018.203c.458 1.37-.136 2.88-1.386 3.52-1.25.64-2.761.208-3.522-1.006l-.576-.91a.234.234 0 00-.27-.1l-2.166.675a.47.47 0 01-.537-.2l-.967-1.518zm5.722 1.222a1.288 1.288 0 001.83.385c.532-.37.732-1.084.476-1.694a.238.238 0 00-.288-.139l-2.144.67a.246.246 0 00-.156.155.26.26 0 00.025.223l.257.4z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("kGD7Y", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $f0f614ce689f56db$var$__assign = undefined && undefined.__assign || function() {
    $f0f614ce689f56db$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f0f614ce689f56db$var$__assign.apply(this, arguments);
};
var $f0f614ce689f56db$export$267633f7675997a1 = $a5EUy.forwardRef(function Agreement(props, svgRef) {
    return $a5EUy.createElement("svg", $f0f614ce689f56db$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M23.23 14.455h-2.022a.223.223 0 01-.223-.189V7.894a.223.223 0 01.223-.189h2.038A.76.76 0 0024 6.951c0-.41-.36-.753-.77-.753h-1.988a1.68 1.68 0 00-1.336.582l-4.368-1.593a3.12 3.12 0 00-2.45.137L10.672 6.54s-.017 0-.017-.017a2.863 2.863 0 00-1.696-.548c-.36 0-.72.069-1.062.206L4.454 7.568a1.708 1.708 0 00-1.679-1.353H.754A.735.735 0 000 6.95a.76.76 0 00.754.754h2.021c.103 0 .206.086.223.189v6.355a.243.243 0 00-.034.103.232.232 0 01-.189.103H.754a.76.76 0 00-.754.753.76.76 0 00.754.754h2.038c.531 0 1.028-.257 1.336-.65H5.79l3.272 3.665c.36.428.874.685 1.422.72h.154c.497 0 .977-.172 1.37-.514a2.14 2.14 0 00.703-1.268c.976.017 1.918-.548 2.295-1.508.018-.05.035-.102.052-.154h.051c.052 0 .086 0 .137-.017l4.66-.89c.308.36.77.582 1.285.582h2.038a.76.76 0 00.754-.754c0-.411-.343-.72-.754-.72zM13.755 6.66a1.56 1.56 0 011.268-.068l4.454 1.627v5.705l-2.365.445c.018-.103.035-.223.035-.325 0-.48-.154-.943-.446-1.337l-2.5-3.169.428-.137a.756.756 0 00.48-.942.756.756 0 00-.943-.48l-3.46 1.13c-.189.07-.412-.033-.497-.222a.406.406 0 01.188-.548l3.358-1.679zm-1.32 9.696l-.033-.017-.874-.874a.755.755 0 00-1.062 0 .755.755 0 000 1.063l.754.753v.309a.553.553 0 01-.206.445.564.564 0 01-.428.137.634.634 0 01-.411-.206L6.68 14.043a.764.764 0 00-.565-.256H4.488V9.16L8.48 7.568c.154-.068.325-.103.496-.103.052 0 .103 0 .155.017a1.9 1.9 0 001.456 3.135c.205 0 .394-.034.6-.102l1.524-.497 2.81 3.597c.085.12.136.274.136.428a.725.725 0 01-.205.514.697.697 0 01-.514.206h-.171l-1.25-1.25a.755.755 0 00-1.063 0 .755.755 0 000 1.062l1.2 1.199c0 .017-.018.051-.018.068-.206.48-.72.703-1.2.514z"
    }));
});

});

parcelRegister("3l7lP", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $26e9090a9b939c04$var$__assign = undefined && undefined.__assign || function() {
    $26e9090a9b939c04$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $26e9090a9b939c04$var$__assign.apply(this, arguments);
};
var $26e9090a9b939c04$export$dfd6c0dab96dd991 = $a5EUy.forwardRef(function AgreementBold(props, svgRef) {
    return $a5EUy.createElement("svg", $26e9090a9b939c04$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M1 16.25h1.667a1.861 1.861 0 001.784-1.5c.033-.146.05-.295.049-.444V14a.25.25 0 01.25-.25H6a.5.5 0 01.373.167l3.59 4.023a.87.87 0 001.537-.561v-.318a.249.249 0 00-.073-.177l-.781-.78a.5.5 0 01.708-.708l.927.928.083.033a1.192 1.192 0 001.585-.764.249.249 0 00-.062-.249L12.646 14.1a.5.5 0 01.708-.708l1.28 1.281c.047.047.11.073.177.073H15a1 1 0 00.8-1.6l-2.874-3.678a.251.251 0 00-.276-.083l-1.56.515a1.686 1.686 0 01-1.8-2.712.251.251 0 00-.154-.413 1.668 1.668 0 00-.838.1L4.843 8.252A.25.25 0 014.5 8.02v-.326c0-.124-.011-.247-.034-.369a1.867 1.867 0 00-1.8-1.575H1a1 1 0 00-1 1v8.5a1 1 0 001 1z"
    }), $a5EUy.createElement("path", {
        d: "M14.656 8.726l-.49.161a.25.25 0 00-.166.164.248.248 0 00.043.226l2.557 3.266a2.027 2.027 0 01.374 1.526.25.25 0 00.294.286l1.935-.368a.255.255 0 01.206.053.249.249 0 01.091.193v.073c0 .212.035.423.1.625.23.77.931 1.303 1.735 1.319H23a1 1 0 001-1v-8.5a1 1 0 00-1-1h-1.667a1.794 1.794 0 00-1.442.747 1.969 1.969 0 00-.319.659.252.252 0 01-.327.17l-4.015-1.46a1.95 1.95 0 00-1.518.087l-3.455 1.728a.686.686 0 00.52 1.265l3.567-1.171a.5.5 0 01.312.951z"
    }));
});

});

parcelRegister("eH5NY", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $ab29959db003f90e$var$__assign = undefined && undefined.__assign || function() {
    $ab29959db003f90e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ab29959db003f90e$var$__assign.apply(this, arguments);
};
var $ab29959db003f90e$export$caec2af78bcc877f = $a5EUy.forwardRef(function Alert(props, svgRef) {
    return $a5EUy.createElement("svg", $ab29959db003f90e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M13.934 21.021a.73.73 0 00-.924.514 1.34 1.34 0 01-.908.907 1.297 1.297 0 01-1.01-.102 1.265 1.265 0 01-.633-.788.764.764 0 00-.924-.514.764.764 0 00-.514.925c.205.719.702 1.318 1.352 1.695.428.222.89.342 1.353.342.274 0 .53-.034.804-.12a2.836 2.836 0 001.918-1.917.76.76 0 00-.514-.942zm7.258-2.858c-.137-.172-1.232-1.73-1.232-7.67 0-4.296-3.304-7.823-7.498-8.2V.754A.76.76 0 0011.709 0a.76.76 0 00-.754.753v1.54c-4.176.395-7.463 3.921-7.463 8.2 0 5.872-1.335 7.772-1.335 7.772a.769.769 0 00-.086.788c.12.257.394.428.668.428h17.974c.342 0 .668-.189.753-.514.086-.308 0-.616-.274-.804zM3.937 17.99c.48-1.232 1.044-3.543 1.044-7.497 0-3.715 3.03-6.745 6.745-6.745 3.714 0 6.744 3.03 6.744 6.745 0 4.04.497 6.282.959 7.497H3.937z"
    }));
});

});

parcelRegister("kLEc6", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $f1e76023e8874d62$var$__assign = undefined && undefined.__assign || function() {
    $f1e76023e8874d62$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f1e76023e8874d62$var$__assign.apply(this, arguments);
};
var $f1e76023e8874d62$export$b064d7839e1e373e = $a5EUy.forwardRef(function AlertBold(props, svgRef) {
    return $a5EUy.createElement("svg", $f1e76023e8874d62$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M20.229 10.491c0-4.032-2.907-7.387-6.73-8.103V1.5a1.5 1.5 0 10-3 0v.879c-3.838.703-6.762 4.073-6.762 8.112 0 5.88-1.337 7.783-1.337 7.783a.77.77 0 00-.086.789c.12.257.394.428.669.428h18c.343 0 .668-.188.754-.514.086-.308 0-.617-.274-.806-.137-.171-1.235-1.731-1.235-7.68zM9.25 21.78c0-.326.21-.629.539-.729l4.405-.017c.395.12.635.532.515.943 0 0-.209 2.023-2.709 2.023s-2.726-2.023-2.726-2.023a.77.77 0 01-.025-.196z"
    }));
});

});

parcelRegister("9mMjg", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $6d1ba46ef6fc9606$var$__assign = undefined && undefined.__assign || function() {
    $6d1ba46ef6fc9606$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6d1ba46ef6fc9606$var$__assign.apply(this, arguments);
};
var $6d1ba46ef6fc9606$export$2b3af6baec22bd98 = $a5EUy.forwardRef(function Analytics(props, svgRef) {
    return $a5EUy.createElement("svg", $6d1ba46ef6fc9606$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M.75 0a.75.75 0 01.75.75v9.175l4.545-2.727a2.25 2.25 0 114.448-.272l2.873 1.276.043-.043a2.25 2.25 0 012.33-.534l3.836-4.796a2.25 2.25 0 11.9 1.276L16.91 8.56a2.25 2.25 0 11-4.153 1.012L9.884 8.296a2.25 2.25 0 01-3.067.188L1.5 11.674v7.362l3.017-1.509A2.25 2.25 0 018.871 16.5h3.257a2.248 2.248 0 013.611-.936l3.76-2.089a2.25 2.25 0 11.5 1.439l-3.531 1.961a2.253 2.253 0 01-.627 1.966 2.25 2.25 0 01-3.713-.84H8.871a2.25 2.25 0 01-3.683.869L1.5 20.713v1.786h21.75a.75.75 0 010 1.5H.75a.75.75 0 01-.75-.75V.75A.75.75 0 01.75 0zM7.5 17.25a.75.75 0 10-1.5 0 .75.75 0 001.5 0zM21.08 2.59l.017.03a.749.749 0 001.401-.37.75.75 0 10-1.418.34zM7.607 7.137l.003.006a.75.75 0 10-.007-.012l.004.006zm6.112 10.644a.75.75 0 111.06-1.06.75.75 0 01-1.06 1.06zm7.309-4.077a.75.75 0 101.444-.408.75.75 0 00-1.444.409zM14.469 9.22a.75.75 0 111.061 1.062.75.75 0 01-1.06-1.062z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("3sqfs", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $28485902c1d031ac$var$__assign = undefined && undefined.__assign || function() {
    $28485902c1d031ac$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $28485902c1d031ac$var$__assign.apply(this, arguments);
};
var $28485902c1d031ac$export$c994623dcd067c12 = $a5EUy.forwardRef(function Announcement(props, svgRef) {
    return $a5EUy.createElement("svg", $28485902c1d031ac$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M21 3.75a.75.75 0 00-1.166-.624l-1.134.756A21.55 21.55 0 016.751 7.5H4.5a4.5 4.5 0 000 9h1.535a7.988 7.988 0 002.448 5.043.75.75 0 101.034-1.086 6.49 6.49 0 01-1.972-3.942A21.55 21.55 0 0118.7 20.118l1.134.756A.75.75 0 0021 20.25V3.75zM7.5 15.012a23.05 23.05 0 0112 3.837V5.15a23.05 23.05 0 01-12 3.837v6.024zM6 9H4.5a3 3 0 100 6H6V9z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M23.25 9.75a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0v-3a.75.75 0 01.75-.75z"
    }));
});

});

parcelRegister("op8dM", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $0495bc9e28306123$var$__assign = undefined && undefined.__assign || function() {
    $0495bc9e28306123$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0495bc9e28306123$var$__assign.apply(this, arguments);
};
var $0495bc9e28306123$export$4c30be745f22bee4 = $a5EUy.forwardRef(function AnnouncementBold(props, svgRef) {
    return $a5EUy.createElement("svg", $0495bc9e28306123$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M20.604 2.589A.75.75 0 0121 3.25v16.5a.75.75 0 01-1.166.624l-1.134-.756a21.55 21.55 0 00-11.155-3.603 6.49 6.49 0 001.972 3.942.75.75 0 11-1.034 1.086A7.988 7.988 0 016.035 16V7h.716c4.253 0 8.41-1.26 11.95-3.618l1.133-.756a.75.75 0 01.77-.037zM1.318 8.318A4.5 4.5 0 014.5 7v9a4.5 4.5 0 01-3.182-7.682zm21.432.557c-.621 0-1.125.504-1.125 1.125v3a1.125 1.125 0 002.25 0v-3c0-.621-.504-1.125-1.125-1.125z"
    }));
});

});

parcelRegister("2MZLO", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $207ffabf5c67b40c$var$__assign = undefined && undefined.__assign || function() {
    $207ffabf5c67b40c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $207ffabf5c67b40c$var$__assign.apply(this, arguments);
};
var $207ffabf5c67b40c$export$1fa5a43af950a186 = $a5EUy.forwardRef(function ArrowDown(props, svgRef) {
    return $a5EUy.createElement("svg", $207ffabf5c67b40c$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M.445 6.495a.75.75 0 011.06-.05L12 15.986l10.495-9.541a.75.75 0 011.01 1.11l-11 10a.75.75 0 01-1.01 0l-11-10a.75.75 0 01-.05-1.06z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("dSdNC", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $a19b05c5d48b63b9$var$__assign = undefined && undefined.__assign || function() {
    $a19b05c5d48b63b9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a19b05c5d48b63b9$var$__assign.apply(this, arguments);
};
var $a19b05c5d48b63b9$export$2fbb36af09846aa0 = $a5EUy.forwardRef(function ArrowDownBold(props, svgRef) {
    return $a5EUy.createElement("svg", $a19b05c5d48b63b9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M2.506 6.388A1.5 1.5 0 00.494 8.612l10.5 9.5a1.5 1.5 0 002.012 0l10.5-9.5a1.5 1.5 0 00-2.012-2.224L12 14.978l-9.494-8.59z"
    }));
});

});

parcelRegister("fx9ci", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $b4f112791935252b$var$__assign = undefined && undefined.__assign || function() {
    $b4f112791935252b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b4f112791935252b$var$__assign.apply(this, arguments);
};
var $b4f112791935252b$export$e4c291d45fea4cd0 = $a5EUy.forwardRef(function ArrowLeft(props, svgRef) {
    return $a5EUy.createElement("svg", $b4f112791935252b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M17.505.445a.75.75 0 01.05 1.06L8.014 12l9.541 10.495a.75.75 0 01-1.11 1.01l-10-11a.75.75 0 010-1.01l10-11a.75.75 0 011.06-.05z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("fSqSZ", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $b8f0c122fc0260bf$var$__assign = undefined && undefined.__assign || function() {
    $b8f0c122fc0260bf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b8f0c122fc0260bf$var$__assign.apply(this, arguments);
};
var $b8f0c122fc0260bf$export$ea9a5c7ec18f8eaf = $a5EUy.forwardRef(function ArrowLeftBold(props, svgRef) {
    return $a5EUy.createElement("svg", $b8f0c122fc0260bf$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M17.506.388a1.5 1.5 0 01.106 2.118L9.022 12l8.59 9.494a1.5 1.5 0 01-2.224 2.012l-9.5-10.5a1.5 1.5 0 010-2.012l9.5-10.5a1.5 1.5 0 012.118-.106z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("jmfnS", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $e17c0161fb28a140$var$__assign = undefined && undefined.__assign || function() {
    $e17c0161fb28a140$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e17c0161fb28a140$var$__assign.apply(this, arguments);
};
var $e17c0161fb28a140$export$fb2824d245253d9b = $a5EUy.forwardRef(function ArrowLongDown(props, svgRef) {
    return $a5EUy.createElement("svg", $e17c0161fb28a140$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M12 .75a.75.75 0 01.75.75v19.305l6.747-6.132a.75.75 0 011.009 1.11l-8.002 7.272a.75.75 0 01-1.008 0l-8-7.27a.75.75 0 111.008-1.11l6.746 6.13V1.5A.75.75 0 0112 .75z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("dyeR0", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $9dd9f903d371784e$var$__assign = undefined && undefined.__assign || function() {
    $9dd9f903d371784e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9dd9f903d371784e$var$__assign.apply(this, arguments);
};
var $9dd9f903d371784e$export$a2ec4c6969a7d302 = $a5EUy.forwardRef(function ArrowLongDownBold(props, svgRef) {
    return $a5EUy.createElement("svg", $9dd9f903d371784e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M12 0a1.5 1.5 0 011.5 1.5v17.61l5.493-4.992a1.5 1.5 0 012.017 2.22l-8 7.272a1.5 1.5 0 01-2.018 0l-8-7.27a1.5 1.5 0 012.018-2.22l5.491 4.99V1.5A1.5 1.5 0 0112 0z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("gTqPq", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $c4c697f302452c6a$var$__assign = undefined && undefined.__assign || function() {
    $c4c697f302452c6a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c4c697f302452c6a$var$__assign.apply(this, arguments);
};
var $c4c697f302452c6a$export$5e0a9a0faf09e20c = $a5EUy.forwardRef(function ArrowLongUp(props, svgRef) {
    return $a5EUy.createElement("svg", $c4c697f302452c6a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M11.496.945a.75.75 0 011.008 0l8.002 7.272a.75.75 0 11-1.009 1.11L12.75 3.195V22.5a.75.75 0 01-1.5 0V3.195l-6.746 6.13a.75.75 0 01-1.008-1.11l8-7.27z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("h91SI", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $c7b4bc9090152957$var$__assign = undefined && undefined.__assign || function() {
    $c7b4bc9090152957$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c7b4bc9090152957$var$__assign.apply(this, arguments);
};
var $c7b4bc9090152957$export$469287007f7d4034 = $a5EUy.forwardRef(function ArrowLongUpBold(props, svgRef) {
    return $a5EUy.createElement("svg", $c7b4bc9090152957$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M10.991.39a1.5 1.5 0 012.018 0l8.001 7.272a1.5 1.5 0 01-2.017 2.22L13.5 4.89V22.5a1.5 1.5 0 01-3 0V4.89L5.009 9.88A1.5 1.5 0 012.99 7.66l8-7.27z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("eh7Pr", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $a648b9da6abebe7f$var$__assign = undefined && undefined.__assign || function() {
    $a648b9da6abebe7f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a648b9da6abebe7f$var$__assign.apply(this, arguments);
};
var $a648b9da6abebe7f$export$acad20503ad73ac1 = $a5EUy.forwardRef(function ArrowRight(props, svgRef) {
    return $a5EUy.createElement("svg", $a648b9da6abebe7f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M6.495.445a.75.75 0 011.06.05l10 11a.75.75 0 010 1.01l-10 11a.75.75 0 11-1.11-1.01L15.986 12 6.445 1.505a.75.75 0 01.05-1.06z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("e32pT", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $a3a338651c91effc$var$__assign = undefined && undefined.__assign || function() {
    $a3a338651c91effc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a3a338651c91effc$var$__assign.apply(this, arguments);
};
var $a3a338651c91effc$export$d6d021d74f4bac76 = $a5EUy.forwardRef(function ArrowRightBold(props, svgRef) {
    return $a5EUy.createElement("svg", $a3a338651c91effc$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M8.612.494a1.5 1.5 0 00-2.224 2.012L14.978 12l-8.59 9.494a1.5 1.5 0 002.224 2.012l9.5-10.5a1.5 1.5 0 000-2.012l-9.5-10.5z"
    }));
});

});

parcelRegister("dztlP", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $9e154fbebffd1488$var$__assign = undefined && undefined.__assign || function() {
    $9e154fbebffd1488$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9e154fbebffd1488$var$__assign.apply(this, arguments);
};
var $9e154fbebffd1488$export$2624c5890f1bbcf7 = $a5EUy.forwardRef(function ArrowUp(props, svgRef) {
    return $a5EUy.createElement("svg", $9e154fbebffd1488$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M11.495 6.445a.75.75 0 011.01 0l11 10a.75.75 0 01-1.01 1.11L12 8.014 1.505 17.555a.75.75 0 01-1.01-1.11l11-10z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("51qSw", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $3a81e53963d2f383$var$__assign = undefined && undefined.__assign || function() {
    $3a81e53963d2f383$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3a81e53963d2f383$var$__assign.apply(this, arguments);
};
var $3a81e53963d2f383$export$b524ae00c198b715 = $a5EUy.forwardRef(function ArrowUpAndDown(props, svgRef) {
    return $a5EUy.createElement("svg", $3a81e53963d2f383$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M12.526 1.466a.75.75 0 00-1.052 0l-6.6 6.5a.75.75 0 101.052 1.068L12 3.053l6.074 5.981a.75.75 0 101.052-1.068l-6.6-6.5zm-6.6 13.5a.75.75 0 00-1.052 1.068l6.6 6.5a.75.75 0 001.052 0l6.6-6.5a.75.75 0 00-1.052-1.068L12 20.947l-6.074-5.981z"
    }));
});

});

parcelRegister("3s1V0", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $283579976e4322e5$var$__assign = undefined && undefined.__assign || function() {
    $283579976e4322e5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $283579976e4322e5$var$__assign.apply(this, arguments);
};
var $283579976e4322e5$export$61bdb2a1da0ccc8a = $a5EUy.forwardRef(function ArrowUpAndDownBold(props, svgRef) {
    return $a5EUy.createElement("svg", $283579976e4322e5$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M13.053.931a1.5 1.5 0 00-2.106 0l-6.6 6.5A1.5 1.5 0 006.453 9.57L12 4.105l5.547 5.464a1.5 1.5 0 102.106-2.138l-6.6-6.5zm-6.6 13.5a1.5 1.5 0 10-2.106 2.138l6.6 6.5a1.5 1.5 0 002.106 0l6.6-6.5a1.5 1.5 0 00-2.105-2.138L12 19.895 6.453 14.43z"
    }));
});

});

parcelRegister("cOAMW", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $9546b0ef41dc2d62$var$__assign = undefined && undefined.__assign || function() {
    $9546b0ef41dc2d62$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9546b0ef41dc2d62$var$__assign.apply(this, arguments);
};
var $9546b0ef41dc2d62$export$928b9ecbfcbe86f4 = $a5EUy.forwardRef(function ArrowUpBold(props, svgRef) {
    return $a5EUy.createElement("svg", $9546b0ef41dc2d62$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M10.994 5.888a1.5 1.5 0 012.012 0l10.5 9.5a1.5 1.5 0 01-2.012 2.224L12 9.022l-9.494 8.59a1.5 1.5 0 11-2.012-2.224l10.5-9.5z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("cTeyJ", function(module, exports) {

$parcel$export(module.exports, "Attach", function () { return $9625ea3bd12db4bc$export$650e18e4b9cea8d1; });

var $a5EUy = parcelRequire("a5EUy");
var $9625ea3bd12db4bc$var$__assign = undefined && undefined.__assign || function() {
    $9625ea3bd12db4bc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9625ea3bd12db4bc$var$__assign.apply(this, arguments);
};
var $9625ea3bd12db4bc$export$650e18e4b9cea8d1 = $a5EUy.forwardRef(function Attach(props, svgRef) {
    return $a5EUy.createElement("svg", $9625ea3bd12db4bc$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M15.323 2.525c-.985.11-1.817.55-2.177.91l-8 8c-1.78 1.78-2.567 5.373 0 7.94 2.566 2.566 6.158 1.78 7.939 0l8-8a.75.75 0 011.06 1.06l-8 8c-2.22 2.22-6.771 3.289-10.06 0-3.29-3.29-2.22-7.841 0-10.06l8-8c.64-.64 1.807-1.2 3.072-1.34 1.296-.145 2.791.142 3.989 1.34 1.197 1.196 1.484 2.692 1.34 3.987-.141 1.265-.7 2.433-1.34 3.073l-8 8a3.07 3.07 0 01-1.722.824c-.755.098-1.61-.096-2.34-.824-.734-.735-.913-1.603-.811-2.356.097-.715.448-1.34.812-1.705l8-8a.75.75 0 111.06 1.06l-8 8c-.135.137-.333.462-.386.847-.047.348.023.73.387 1.093.369.37.748.441 1.085.397.374-.048.7-.242.854-.397l8-8c.36-.36.8-1.193.91-2.177.106-.955-.107-1.96-.91-2.762-.803-.803-1.807-1.016-2.762-.91z"
    }));
});

});

parcelRegister("gw9Cm", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $c067185d993117df$var$__assign = undefined && undefined.__assign || function() {
    $c067185d993117df$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c067185d993117df$var$__assign.apply(this, arguments);
};
var $c067185d993117df$export$50809d59c9e8104e = $a5EUy.forwardRef(function AttachBold(props, svgRef) {
    return $a5EUy.createElement("svg", $c067185d993117df$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M15.157 3.02c-.845.094-1.51.474-1.73.695l-8 8c-1.56 1.56-2.205 4.673 0 6.879 2.206 2.205 5.318 1.56 6.879 0l8-8a1.5 1.5 0 012.121 2.12l-8 8c-2.44 2.44-7.471 3.651-11.121 0-3.65-3.65-2.44-8.681 0-11.12l8-8c.779-.78 2.114-1.4 3.52-1.556 1.466-.162 3.207.161 4.601 1.556 1.394 1.394 1.718 3.135 1.555 4.6-.156 1.406-.776 2.742-1.555 3.521l-8 8a3.818 3.818 0 01-2.155 1.038c-.965.125-2.059-.13-2.966-1.038-.92-.92-1.155-2.032-1.025-2.987.12-.88.546-1.656 1.025-2.134l8-8a1.5 1.5 0 112.121 2.12l-8 8v.002a.93.93 0 00-.173.416.504.504 0 00.012.219.59.59 0 00.161.243.63.63 0 00.253.169.468.468 0 00.206.014.861.861 0 00.42-.183l8-8c.22-.221.6-.886.694-1.73.088-.785-.089-1.543-.694-2.15-.606-.605-1.365-.781-2.149-.694z"
    }));
});

});

parcelRegister("3WMht", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $2dfc3d714c5a59c8$var$__assign = undefined && undefined.__assign || function() {
    $2dfc3d714c5a59c8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2dfc3d714c5a59c8$var$__assign.apply(this, arguments);
};
var $2dfc3d714c5a59c8$export$67e8020d92d2196d = $a5EUy.forwardRef(function BarGraph(props, svgRef) {
    return $a5EUy.createElement("svg", $2dfc3d714c5a59c8$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M9.44 1.94a1.5 1.5 0 011.06-.44h3A1.5 1.5 0 0115 3v18h1.5V7.5A1.5 1.5 0 0118 6h3a1.5 1.5 0 011.5 1.5V21h.75a.75.75 0 010 1.5H.75a.75.75 0 010-1.5h.75v-9A1.5 1.5 0 013 10.5h3A1.5 1.5 0 017.5 12v9H9V3c0-.398.158-.78.44-1.06zM21 21V7.5h-3V21h3zM10.5 3h3v18h-3V3zM6 21v-9H3v9h3z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("hCI3V", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $cd482a232ebcd824$var$__assign = undefined && undefined.__assign || function() {
    $cd482a232ebcd824$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cd482a232ebcd824$var$__assign.apply(this, arguments);
};
var $cd482a232ebcd824$export$3f015ab66c3e5653 = $a5EUy.forwardRef(function Bluetooth(props, svgRef) {
    return $a5EUy.createElement("svg", $cd482a232ebcd824$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M11.287.076a.75.75 0 01.79.082l6.75 5.25a.75.75 0 01.054 1.138l-5.982 5.63 5.964 5.262a.75.75 0 01-.036 1.154l-6.75 5.25a.75.75 0 01-1.21-.592v-9.161L6.13 18.546a.75.75 0 11-1.028-1.092l5.57-5.243L5.12 7.312a.75.75 0 11.993-1.124l4.754 4.194V.75a.75.75 0 01.42-.674zm1.08 13.63l4.825 4.258-4.825 3.753v-8.01zm0-3.089V2.283l4.848 3.771-4.848 4.563z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("7Hn21", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $59ae6a2193fa9282$var$__assign = undefined && undefined.__assign || function() {
    $59ae6a2193fa9282$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $59ae6a2193fa9282$var$__assign.apply(this, arguments);
};
var $59ae6a2193fa9282$export$acd2cbead02af9c1 = $a5EUy.forwardRef(function BookmarkFavourite(props, svgRef) {
    return $a5EUy.createElement("svg", $59ae6a2193fa9282$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M18.75 0A2.25 2.25 0 0121 2.25v20.252a1.5 1.5 0 01-2.382 1.21L12.44 19.22a.75.75 0 00-.882 0l-6.177 4.492A1.5 1.5 0 013 22.5V2.25A2.25 2.25 0 015.25 0h13.5zm0 1.5H5.25a.75.75 0 00-.75.75v20.248l6.177-4.492a2.25 2.25 0 012.646 0l6.177 4.492V2.25a.75.75 0 00-.75-.75z"
    }));
});

});

parcelRegister("cnT5U", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $90425e96279da338$var$__assign = undefined && undefined.__assign || function() {
    $90425e96279da338$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $90425e96279da338$var$__assign.apply(this, arguments);
};
var $90425e96279da338$export$cea5fccc97fad67f = $a5EUy.forwardRef(function BookmarkFavouriteBold(props, svgRef) {
    return $a5EUy.createElement("svg", $90425e96279da338$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M18.75 0A2.25 2.25 0 0121 2.25v20.252a1.5 1.5 0 01-2.382 1.21L12.44 19.22a.75.75 0 00-.882 0l-6.177 4.492A1.5 1.5 0 013 22.5V2.25A2.25 2.25 0 015.25 0h13.5z"
    }));
});

});

parcelRegister("asC42", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $79da0ba5cc356079$var$__assign = undefined && undefined.__assign || function() {
    $79da0ba5cc356079$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $79da0ba5cc356079$var$__assign.apply(this, arguments);
};
var $79da0ba5cc356079$export$142047257e111cb6 = $a5EUy.forwardRef(function BookmarkFavouriteStar(props, svgRef) {
    return $a5EUy.createElement("svg", $79da0ba5cc356079$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M18.75 0A2.25 2.25 0 0121 2.25v20.252a1.5 1.5 0 01-2.382 1.21L12.44 19.22a.75.75 0 00-.882 0l-6.177 4.492A1.5 1.5 0 013 22.5V2.25A2.25 2.25 0 015.25 0h13.5zm0 1.5H5.25a.75.75 0 00-.75.75v20.248l6.177-4.492a2.25 2.25 0 012.646 0l6.177 4.492V2.25a.75.75 0 00-.75-.75zM12 4.715c.507 0 .97.285 1.199.736l1.039 2.047 1.65.001c.502-.012.965.26 1.202.694l.059.123a1.33 1.33 0 01-.298 1.468l-1.586 1.56.88 2.022a1.34 1.34 0 01-.249 1.424l-.102.1c-.432.38-1.058.44-1.548.156L12 13.778l-2.237 1.26a1.339 1.339 0 01-1.445-.064l-.111-.088a1.342 1.342 0 01-.348-1.533l.876-2.013-1.58-1.556a1.332 1.332 0 01-.349-1.344l.046-.128c.212-.506.713-.83 1.243-.817l1.667-.001 1.04-2.042c.208-.41.61-.684 1.062-.73L12 4.715zm-.001 1.688l-1.11 2.182a.75.75 0 01-.668.41L8.49 8.994l1.664 1.638a.75.75 0 01.2.726l-.038.108-.889 2.038 2.205-1.24a.75.75 0 01.636-.047l.1.048 2.203 1.242-.887-2.037a.75.75 0 01.086-.747l.076-.087 1.664-1.638-1.731.001a.75.75 0 01-.615-.32l-.054-.09L12 6.403z"
    }));
});

});

parcelRegister("bIJqo", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $88870a2cc4f66787$var$__assign = undefined && undefined.__assign || function() {
    $88870a2cc4f66787$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $88870a2cc4f66787$var$__assign.apply(this, arguments);
};
var $88870a2cc4f66787$export$848b7e76934f1777 = $a5EUy.forwardRef(function BookmarkFavouriteStarBold(props, svgRef) {
    return $a5EUy.createElement("svg", $88870a2cc4f66787$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M21 2.25A2.25 2.25 0 0018.75 0H5.25A2.25 2.25 0 003 2.25V22.5a1.5 1.5 0 002.382 1.212l6.177-4.492a.75.75 0 01.882 0l6.177 4.492A1.5 1.5 0 0021 22.502V2.25zm-9.737 4.005c.232-.714 1.242-.714 1.474 0l.652 2.008c.004.01.013.017.024.017h2.111c.751 0 1.063.96.456 1.402l-1.708 1.24a.025.025 0 00-.01.029l.653 2.007c.232.714-.585 1.308-1.192.867l-1.708-1.241a.025.025 0 00-.03 0l-1.707 1.24c-.608.442-1.425-.152-1.193-.866l.652-2.007a.025.025 0 00-.009-.028L8.02 9.682c-.607-.441-.295-1.402.456-1.402h2.11a.026.026 0 00.025-.017l.652-2.008z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("ldxgF", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $f7249e31a8610bf3$var$__assign = undefined && undefined.__assign || function() {
    $f7249e31a8610bf3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f7249e31a8610bf3$var$__assign.apply(this, arguments);
};
var $f7249e31a8610bf3$export$6262ca71fb4fada9 = $a5EUy.forwardRef(function BusinessDeal(props, svgRef) {
    return $a5EUy.createElement("svg", $f7249e31a8610bf3$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("g", {
        clipPath: "url(#business-deal_svg__business-deal_svg__clip0)"
    }, $a5EUy.createElement("path", {
        d: "M4.626 14.25a3.375 3.375 0 100 6.75 3.375 3.375 0 000-6.75zm0 1.5a1.875 1.875 0 110 3.75 1.875 1.875 0 010-3.75z"
    }), $a5EUy.createElement("path", {
        d: "M4.624 20.25a5.214 5.214 0 014.527 2.628.75.75 0 01-1.302.744 3.714 3.714 0 00-6.45 0 .75.75 0 01-1.302-.744 5.214 5.214 0 014.527-2.628zm14.75-6a3.375 3.375 0 100 6.75 3.375 3.375 0 000-6.75zm0 1.5a1.875 1.875 0 110 3.75 1.875 1.875 0 010-3.75z"
    }), $a5EUy.createElement("path", {
        d: "M19.374 20.25a5.214 5.214 0 014.527 2.628.75.75 0 01-1.302.744 3.714 3.714 0 00-6.45 0 .75.75 0 01-1.302-.744 5.214 5.214 0 014.527-2.628zM14.625 1.5a.75.75 0 01.102 1.493L14.625 3h-2.627c-.284 0-.528.2-.582.479a.602.602 0 00.24.606l.067.036 2.71.845a2.092 2.092 0 01-.612 4.028L13.655 9H10.5a.75.75 0 01-.102-1.493L10.5 7.5h3.156c.284 0 .528-.2.582-.48a.603.603 0 00-.239-.606l-.066-.036-2.71-.844a2.091 2.091 0 01.611-4.028L12 1.5h2.625z"
    }), $a5EUy.createElement("path", {
        d: "M12.75 0a.75.75 0 01.743.648L13.5.75v1.5a.75.75 0 01-1.493.102L12 2.25V.75a.75.75 0 01.75-.75zm0 7.5a.75.75 0 01.743.648l.007.102v1.5a.75.75 0 01-1.493.102L12 9.75v-1.5a.75.75 0 01.75-.75z"
    }), $a5EUy.createElement("path", {
        d: "M8.25 0a.75.75 0 01.102 1.493L8.25 1.5h-3a.75.75 0 00-.743.648L4.5 2.25v8.25c0 .38.282.694.648.743l.102.007h6a.75.75 0 01.743.648L12 12v2.688l3.22-3.218a.75.75 0 01.412-.21l.118-.01h4.5a.75.75 0 00.743-.648L21 10.5V2.25a.75.75 0 00-.648-.743L20.25 1.5H18a.75.75 0 01-.102-1.493L18 0h2.25a2.25 2.25 0 012.245 2.096l.005.154v8.25a2.25 2.25 0 01-2.096 2.245l-.154.005h-4.19l-4.28 4.28a.75.75 0 01-1.273-.427L10.5 16.5v-3.75H5.25a2.25 2.25 0 01-2.245-2.096L3 10.5V2.25A2.25 2.25 0 015.096.005L5.25 0h3z"
    })), $a5EUy.createElement("defs", null, $a5EUy.createElement("clipPath", {
        id: "business-deal_svg__business-deal_svg__clip0"
    }, $a5EUy.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});

});

parcelRegister("lf2Jy", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $f76d1e8dfe9c429a$var$__assign = undefined && undefined.__assign || function() {
    $f76d1e8dfe9c429a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f76d1e8dfe9c429a$var$__assign.apply(this, arguments);
};
var $f76d1e8dfe9c429a$export$1c86741c3cec44d4 = $a5EUy.forwardRef(function BusinessDealBold(props, svgRef) {
    return $a5EUy.createElement("svg", $f76d1e8dfe9c429a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M7.63 16.08c0 1.458-1.231 2.64-2.75 2.64s-2.75-1.182-2.75-2.64c0-1.458 1.231-2.64 2.75-2.64s2.75 1.182 2.75 2.64zM.586 22.73a.232.232 0 00.039.213.254.254 0 00.201.097h8.108c.08 0 .154-.036.201-.097a.232.232 0 00.038-.213c-.577-1.812-2.32-3.05-4.293-3.05-1.974 0-3.716 1.238-4.294 3.05zm21.284-6.65c0 1.458-1.231 2.64-2.75 2.64s-2.75-1.182-2.75-2.64c0-1.458 1.231-2.64 2.75-2.64s2.75 1.182 2.75 2.64zm1.506 6.864a.231.231 0 00.038-.212c-.577-1.812-2.32-3.05-4.293-3.05-1.974 0-3.716 1.238-4.294 3.05a.233.233 0 00.038.213.254.254 0 00.201.097h8.11a.25.25 0 00.2-.098z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M3.5 10.08V1.44C3.5.645 4.172 0 5 0h14c.828 0 1.5.645 1.5 1.44v8.64c0 .795-.672 1.44-1.5 1.44h-3.689a.255.255 0 00-.177.067l-2.78 2.673a.51.51 0 01-.545.104.48.48 0 01-.309-.444v-2.16a.245.245 0 00-.25-.24H5c-.828 0-1.5-.645-1.5-1.44zm5.583-5.44c0 .934.777 1.698 1.75 1.72h2.334c.3 0 .542.233.542.52 0 .288-.243.52-.542.52h-3.5a.613.613 0 00-.625.6c0 .332.28.6.625.6h1.458c.066 0 .13.026.177.07a.234.234 0 01.073.17v.28c0 .331.28.6.625.6a.613.613 0 00.625-.6v-.28c0-.063.026-.124.073-.17a.255.255 0 01.177-.07h.292c.99 0 1.792-.77 1.792-1.72s-.802-1.72-1.792-1.72h-2.334a.53.53 0 01-.519-.52.53.53 0 01.52-.52h3.5a.613.613 0 00.624-.6c0-.331-.28-.6-.625-.6h-1.458a.245.245 0 01-.25-.24V2.4c0-.331-.28-.6-.625-.6a.613.613 0 00-.625.6v.28c0 .133-.112.24-.25.24h-.292c-.973.022-1.75.786-1.75 1.72z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("cgDv8", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $8ee59ec3cf88f32f$var$__assign = undefined && undefined.__assign || function() {
    $8ee59ec3cf88f32f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8ee59ec3cf88f32f$var$__assign.apply(this, arguments);
};
var $8ee59ec3cf88f32f$export$77cdf53c363a3886 = $a5EUy.forwardRef(function CheckTick(props, svgRef) {
    return $a5EUy.createElement("svg", $8ee59ec3cf88f32f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M22.03 4.97a.75.75 0 010 1.06l-13 13a.75.75 0 01-1.06 0l-6-6a.75.75 0 111.06-1.06l5.47 5.47L20.97 4.97a.75.75 0 011.06 0z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("bwcHG", function(module, exports) {

$parcel$export(module.exports, "CheckTickBold", function () { return $862c898a7676d946$export$add807e002afa321; });

var $a5EUy = parcelRequire("a5EUy");
var $862c898a7676d946$var$__assign = undefined && undefined.__assign || function() {
    $862c898a7676d946$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $862c898a7676d946$var$__assign.apply(this, arguments);
};
var $862c898a7676d946$export$add807e002afa321 = $a5EUy.forwardRef(function CheckTickBold(props, svgRef) {
    return $a5EUy.createElement("svg", $862c898a7676d946$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M22.56 4.44a1.5 1.5 0 010 2.12l-13 13a1.5 1.5 0 01-2.12 0l-6-6a1.5 1.5 0 012.12-2.12l4.94 4.939 11.94-11.94a1.5 1.5 0 012.12 0z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("kDE7F", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $f06692b545997e86$var$__assign = undefined && undefined.__assign || function() {
    $f06692b545997e86$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f06692b545997e86$var$__assign.apply(this, arguments);
};
var $f06692b545997e86$export$105b96a34d430ab0 = $a5EUy.forwardRef(function CloudAvailable(props, svgRef) {
    return $a5EUy.createElement("svg", $f06692b545997e86$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M17.03 19.502H4.52c-1.5-.11-4.34-1.06-4.5-3.88a4.42 4.42 0 011.33-3.61 4.36 4.36 0 013-1.07 7.13 7.13 0 016.71-5.93c4.34-.21 6.31 2.34 6.88 3.75a5.77 5.77 0 013.36 1.32 5.25 5.25 0 011.72 4.18 4.849 4.849 0 01-1.7 3.66 6.25 6.25 0 01-4.29 1.58zm-11.51-7.23a.839.839 0 01-.69.21 3.605 3.605 0 00-.54 0 2.8 2.8 0 00-1.9.68 2.91 2.91 0 00-.87 2.38c.13 2.2 3 2.46 3.1 2.47h12.41a4.76 4.76 0 003.25-1.19 3.37 3.37 0 001.24-2.57 3.85 3.85 0 00-1.15-3 4.35 4.35 0 00-2.75-1 .9.9 0 01-1-.69s-1-3.28-5.49-3.06c-4.85.25-5.36 5.06-5.36 5.11a1.06 1.06 0 01-.25.66z"
    }));
});

});

parcelRegister("cPn98", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $956c33d3b6c18f01$var$__assign = undefined && undefined.__assign || function() {
    $956c33d3b6c18f01$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $956c33d3b6c18f01$var$__assign.apply(this, arguments);
};
var $956c33d3b6c18f01$export$3a083cd204da2316 = $a5EUy.forwardRef(function CloudDownload(props, svgRef) {
    return $a5EUy.createElement("svg", $956c33d3b6c18f01$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M12.254 11.808a.75.75 0 01.75.75v7.18l2.47-2.47a.75.75 0 011.06 1.06l-3.75 3.71a.75.75 0 01-.52.22.75.75 0 01-.49-.22l-3.8-3.71a.764.764 0 011.1-1.06l2.47 2.47v-7.18a.75.75 0 01.71-.75z"
    }), $a5EUy.createElement("path", {
        d: "M18.754 15.888a.75.75 0 01-.22-1.47c.13 0 3.14-1 3.14-4a4 4 0 00-3.48-4.12 1 1 0 01-.88-.65 5.22 5.22 0 00-5.49-3.16c-4.06.23-5 4-5.28 5.26a1.06 1.06 0 01-1 .86 2.79 2.79 0 00-3 2.74 2.54 2.54 0 00.58 2 3.82 3.82 0 002.42 1 .75.75 0 01.73.77.8.8 0 01-.76.73 5.31 5.31 0 01-3.49-1.47 4 4 0 01-1-3.11 4.21 4.21 0 014.13-4.09c1.29-4.84 4.28-6 6.58-6.14a6.79 6.79 0 016.85 3.84 5.48 5.48 0 014.58 5.58 5.86 5.86 0 01-4.21 5.39.731.731 0 01-.2.04z"
    }));
});

});

parcelRegister("7ZO3U", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $5d25102b9e3fb36f$var$__assign = undefined && undefined.__assign || function() {
    $5d25102b9e3fb36f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5d25102b9e3fb36f$var$__assign.apply(this, arguments);
};
var $5d25102b9e3fb36f$export$a41884c08973b4dc = $a5EUy.forwardRef(function CloudFolder(props, svgRef) {
    return $a5EUy.createElement("svg", $5d25102b9e3fb36f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M21.098 15.882a.69.69 0 00-.53-.25h-2.06v-2a.68.68 0 00-.69-.68h-5.48v-.68a.68.68 0 00-.69-.68h-4.79a.678.678 0 00-.69.68v8.45c0 .409.15.803.42 1.11a1.73 1.73 0 001.38.59h10.54c.399.002.787-.132 1.1-.38a1.73 1.73 0 00.61-1l1-4.61a.68.68 0 00-.12-.55zm-13 5.13a.35.35 0 01-.15.05h-.11a.35.35 0 01-.21-.11.34.34 0 01-.08-.22v-7.82h3.43v.68a.68.68 0 00.69.68h5.48v1.36h-6.87a.68.68 0 00-.66.49l-1.4 4.7a.34.34 0 01-.15.19h.03zm10.81-.24a.37.37 0 01-.37.29h-8.97l1.22-4.08h8.92l-.8 3.79z"
    }), $a5EUy.createElement("path", {
        d: "M4.598 15.522a.76.76 0 01-.25 0 4.82 4.82 0 01-3.33-5c.25-2 1.77-3.34 4.08-3.58.41-1.67 1.49-5.56 6.32-5.91a6.61 6.61 0 016.62 3.74 6.13 6.13 0 015.09 4.48 4.89 4.89 0 01-2.62 5.37.776.776 0 01-.71-1.38c.09 0 2.38-1.27 1.82-3.63a4.57 4.57 0 00-3.71-3.29 1.28 1.28 0 01-1.17-.75 5 5 0 00-5.17-3c-3.85.28-4.66 3.29-4.98 4.74a1.45 1.45 0 01-1.28 1.1c-1.15.1-2.55.58-2.76 2.23-.3 2.42 2.19 3.33 2.3 3.37a.78.78 0 01-.25 1.51z"
    }));
});

});

parcelRegister("21H6K", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $179d1d10a4ef22f0$var$__assign = undefined && undefined.__assign || function() {
    $179d1d10a4ef22f0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $179d1d10a4ef22f0$var$__assign.apply(this, arguments);
};
var $179d1d10a4ef22f0$export$c984feb5da8d9e3b = $a5EUy.forwardRef(function CloudUnavailable(props, svgRef) {
    return $a5EUy.createElement("svg", $179d1d10a4ef22f0$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M22.29 23.574a.748.748 0 01-.54-.23L1.21 2.144a.75.75 0 011.08-1l20.54 21.16a.75.75 0 01-.54 1.27zM6.1 19.294a6 6 0 01-3.8-1.27 3.8 3.8 0 01-1.28-2.8 4.11 4.11 0 011.12-3.25 4.87 4.87 0 013-1.24v-.36a.72.72 0 01.88-.7.75.75 0 01.72.78l-.06 1.1a1 1 0 01-.83.7 3.83 3.83 0 00-2.57.83 2.68 2.68 0 00-.71 2.14 2.33 2.33 0 00.74 1.72 4.71 4.71 0 003 .88h7.67a.75.75 0 010 1.5H6.1v-.03zm14.92-1.57a.74.74 0 01-.41-.12.75.75 0 01-.22-1s1.39-2.15.92-3.8a3.81 3.81 0 00-3.61-2.76h-.26a.849.849 0 01-.62-.5 5.13 5.13 0 00-6.86-3 .751.751 0 11-.57-1.39 6.54 6.54 0 018.63 3.37 5.16 5.16 0 014.71 3.82c.67 2.32-1 4.93-1.11 5a.75.75 0 01-.6.38z"
    }));
});

});

parcelRegister("8gxGP", function(module, exports) {

$parcel$export(module.exports, "CloudUpload", function () { return $6049f36b1112ac02$export$613a29ed35edc9c6; });

var $a5EUy = parcelRequire("a5EUy");
var $6049f36b1112ac02$var$__assign = undefined && undefined.__assign || function() {
    $6049f36b1112ac02$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6049f36b1112ac02$var$__assign.apply(this, arguments);
};
var $6049f36b1112ac02$export$613a29ed35edc9c6 = $a5EUy.forwardRef(function CloudUpload(props, svgRef) {
    return $a5EUy.createElement("svg", $6049f36b1112ac02$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M12.254 22.298a.75.75 0 00.75-.75v-7.19l2.47 2.47a.75.75 0 001.06-1.06l-3.75-3.73a.75.75 0 00-.52-.22.75.75 0 00-.49.22l-3.8 3.73a.764.764 0 101.1 1.06l2.47-2.47v7.18a.75.75 0 00.71.76z"
    }), $a5EUy.createElement("path", {
        d: "M18.754 15.888a.75.75 0 01-.22-1.47c.13 0 3.14-1 3.14-4a4 4 0 00-3.48-4.12 1 1 0 01-.88-.65 5.22 5.22 0 00-5.49-3.16c-4.06.23-5 4-5.28 5.26a1.06 1.06 0 01-1 .86 2.79 2.79 0 00-3 2.74 2.54 2.54 0 00.58 2 3.82 3.82 0 002.42 1 .75.75 0 01.73.77.8.8 0 01-.76.73 5.31 5.31 0 01-3.49-1.47 4 4 0 01-1-3.11 4.21 4.21 0 014.13-4.09c1.29-4.84 4.28-6 6.58-6.14a6.79 6.79 0 016.85 3.84 5.48 5.48 0 014.58 5.58 5.86 5.86 0 01-4.21 5.39.731.731 0 01-.2.04z"
    }));
});

});

parcelRegister("inUxV", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $d6263cd8c30d51f0$var$__assign = undefined && undefined.__assign || function() {
    $d6263cd8c30d51f0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d6263cd8c30d51f0$var$__assign.apply(this, arguments);
};
var $d6263cd8c30d51f0$export$163fa6932802c5a0 = $a5EUy.forwardRef(function CloudUploadDownload(props, svgRef) {
    return $a5EUy.createElement("svg", $d6263cd8c30d51f0$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M9.11 13.46v8.18a.71.71 0 101.41 0v-8.18l1.62 1.62a.71.71 0 101-1l-2.82-2.82a.7.7 0 00-.5-.26.7.7 0 00-.49.2L6.5 14.08a.71.71 0 001 1l1.61-1.62zm6.41-2.01a.71.71 0 01.71.71v8.18l1.62-1.62a.711.711 0 111 1L16 22.54a.7.7 0 01-.46.21.7.7 0 01-.49-.21l-2.82-2.82a.71.71 0 011-1l1.62 1.62v-8.18a.71.71 0 01.67-.71z"
    }), $a5EUy.createElement("path", {
        d: "M4.66 16.41h-.2C3.07 16 .58 14.52 1.14 11.58A4.34 4.34 0 015.13 8a7.73 7.73 0 012.46-4.45 6.84 6.84 0 018-.51 7.16 7.16 0 012.6 2.69 5.38 5.38 0 014.68 4.75A5.86 5.86 0 0120.1 16a.75.75 0 11-.77-1.29 4.36 4.36 0 002-4.06 4 4 0 00-3.66-3.48.94.94 0 01-.76-.55 5.49 5.49 0 00-2.14-2.31 5.41 5.41 0 00-6.22.36 6.35 6.35 0 00-2 4 .88.88 0 01-.86.78 3 3 0 00-3.07 2.39c-.43 2.26 2 3 2.25 3.07a.75.75 0 01-.2 1.47l-.01.03z"
    }));
});

});

parcelRegister("5PM1x", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $43f6f7b2f470e08a$var$__assign = undefined && undefined.__assign || function() {
    $43f6f7b2f470e08a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $43f6f7b2f470e08a$var$__assign.apply(this, arguments);
};
var $43f6f7b2f470e08a$export$52f0f02147b12c03 = $a5EUy.forwardRef(function Code(props, svgRef) {
    return $a5EUy.createElement("svg", $43f6f7b2f470e08a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M21.06 22.03H2.44A2.44 2.44 0 010 19.6V3.47A2.44 2.44 0 012.44 1h18.62a2.44 2.44 0 012.44 2.47V19.6a2.44 2.44 0 01-2.44 2.44v-.01zM2.44 2.47a.94.94 0 00-.94 1V19.6a.94.94 0 00.94.94h18.62a.939.939 0 00.94-.94V3.47a.94.94 0 00-.94-1H2.44z"
    }), $a5EUy.createElement("path", {
        d: "M22.75 5.63h-22v1.5h22v-1.5zM10.44 17.28a.75.75 0 01-.67-1.08l2.72-5.51a.751.751 0 011.35.66l-2.72 5.51a.75.75 0 01-.68.42zM7.28 17a.75.75 0 01-.5-.19l-2.26-2a1.74 1.74 0 010-2.44l2-2a.778.778 0 111.1 1.1l-2 2a.22.22 0 000 .31l2.2 1.93a.75.75 0 01-.5 1.31L7.28 17zm9.08.19a.75.75 0 01-.5-1.31l2.26-2a.291.291 0 00-.08-.25l-2-2a.75.75 0 011.05-1.07l2 2a1.73 1.73 0 01.08 2.37l-2.33 2.06a.75.75 0 01-.48.2z"
    }));
});

});

parcelRegister("bCFiV", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $87634877dfd43c36$var$__assign = undefined && undefined.__assign || function() {
    $87634877dfd43c36$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $87634877dfd43c36$var$__assign.apply(this, arguments);
};
var $87634877dfd43c36$export$6d7e986e2641be95 = $a5EUy.forwardRef(function CodeBold(props, svgRef) {
    return $a5EUy.createElement("svg", $87634877dfd43c36$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("g", {
        clipPath: "url(#code-bold_svg__code-bold_svg__clip0)"
    }, $a5EUy.createElement("path", {
        d: "M21.39 23.28H2.76a2.69 2.69 0 01-2.68-2.69V4.44a2.69 2.69 0 012.68-2.69h18.63a2.69 2.69 0 012.69 2.69v16.15a2.69 2.69 0 01-2.69 2.69zM2.76 3.75a.68.68 0 00-.69.68v16.16a.69.69 0 00.69.69h18.63a.69.69 0 00.69-.69V4.44a.69.69 0 00-.69-.69H2.76z"
    }), $a5EUy.createElement("path", {
        d: "M1.08 7.38L1 22.28h22.08V7.38h-22zm7.28 10.53a1 1 0 01-1.41.09L4.6 15.92a2 2 0 01.09-2.72l2-2a1 1 0 011.628 1.096 1 1 0 01-.218.324l-2 2 2.15 1.9a1 1 0 01.11 1.39zm6-5.46L11.66 18a1 1 0 01-1.79-.88l2.72-5.51a1 1 0 111.79.88l-.02-.04zm5.32 3.65l-.09.09-2.26 2a1.003 1.003 0 01-1.33-1.5l2.17-1.92-2-2a1 1 0 011.41-1.42l2 2a2 2 0 01.12 2.76l-.02-.01z"
    })), $a5EUy.createElement("defs", null, $a5EUy.createElement("clipPath", {
        id: "code-bold_svg__code-bold_svg__clip0"
    }, $a5EUy.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});

});

parcelRegister("fO6tC", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $b8208ca9268353aa$var$__assign = undefined && undefined.__assign || function() {
    $b8208ca9268353aa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b8208ca9268353aa$var$__assign.apply(this, arguments);
};
var $b8208ca9268353aa$export$c7c44baae9d9f25f = $a5EUy.forwardRef(function Controls(props, svgRef) {
    return $a5EUy.createElement("svg", $b8208ca9268353aa$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M23.246 0H.754A.761.761 0 000 .754v22.492c0 .411.343.754.754.754h22.492a.761.761 0 00.754-.754V.754A.761.761 0 0023.246 0zM1.509 22.491V1.51h21v20.98h-21z"
    }), $a5EUy.createElement("path", {
        d: "M5.246 16.491h2.348c.343 1.286 1.509 2.246 2.897 2.246a3 3 0 002.898-2.246h5.348a.76.76 0 00.754-.754.76.76 0 00-.754-.754h-5.331a2.919 2.919 0 00-.789-1.372 2.981 2.981 0 00-2.126-.874 3 3 0 00-2.897 2.246H5.246a.76.76 0 00-.755.754.76.76 0 00.755.754zm5.245-2.245c.395 0 .772.154 1.063.445.292.292.446.652.446 1.063a1.51 1.51 0 01-1.509 1.509 1.5 1.5 0 01-1.508-1.509c.017-.823.686-1.508 1.508-1.508zM5.246 9h8.348c.343 1.286 1.509 2.246 2.897 2.246 1.646 0 3-1.337 3-3 0-1.646-1.354-3-3-3a3 3 0 00-2.897 2.245H5.246a.761.761 0 00-.755.755c0 .411.343.754.755.754zM16.49 6.754c.823 0 1.509.669 1.509 1.492a1.51 1.51 0 01-1.509 1.508A1.496 1.496 0 0115 8.246c0-.823.669-1.492 1.491-1.492z"
    }));
});

});

parcelRegister("j9jwW", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $df0e01e963d1d2b7$var$__assign = undefined && undefined.__assign || function() {
    $df0e01e963d1d2b7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $df0e01e963d1d2b7$var$__assign.apply(this, arguments);
};
var $df0e01e963d1d2b7$export$281a0dedb095a201 = $a5EUy.forwardRef(function ControlsBold(props, svgRef) {
    return $a5EUy.createElement("svg", $df0e01e963d1d2b7$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M.754 0h22.492c.411 0 .754.343.754.754v22.492a.761.761 0 01-.754.754H.754A.761.761 0 010 23.246V.754C0 .343.343 0 .754 0zm12.652 7.241a3.25 3.25 0 013.085-2.245 3.264 3.264 0 013.25 3.25 3.253 3.253 0 01-3.25 3.25c-1.439 0-2.654-.95-3.083-2.246H5.246c-.55 0-1.005-.455-1.005-1.004 0-.55.455-1.005 1.005-1.005h8.16zm-6 7.492a3.25 3.25 0 013.085-2.246c.87 0 1.688.334 2.3.946.383.366.645.818.801 1.3h5.145c.55 0 1.004.455 1.004 1.004a1.01 1.01 0 01-1.004 1.004h-5.16a3.25 3.25 0 01-3.086 2.246c-1.439 0-2.654-.95-3.083-2.246H5.246c-.55 0-1.005-.454-1.005-1.004s.455-1.004 1.005-1.004h2.16z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("gJq8e", function(module, exports) {

$parcel$export(module.exports, "Cross", function () { return $c2e51e89f9da10d2$export$3c877bb842c36952; });

var $a5EUy = parcelRequire("a5EUy");
var $c2e51e89f9da10d2$var$__assign = undefined && undefined.__assign || function() {
    $c2e51e89f9da10d2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c2e51e89f9da10d2$var$__assign.apply(this, arguments);
};
var $c2e51e89f9da10d2$export$3c877bb842c36952 = $a5EUy.forwardRef(function Cross(props, svgRef) {
    return $a5EUy.createElement("svg", $c2e51e89f9da10d2$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M2.53 1.47a.75.75 0 00-1.06 1.06L10.94 12l-9.47 9.47a.75.75 0 101.06 1.06L12 13.06l9.47 9.47a.75.75 0 101.06-1.06L13.06 12l9.47-9.47a.75.75 0 00-1.06-1.06L12 10.94 2.53 1.47z"
    }));
});

});

parcelRegister("9T8uK", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $732fd702166f02aa$var$__assign = undefined && undefined.__assign || function() {
    $732fd702166f02aa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $732fd702166f02aa$var$__assign.apply(this, arguments);
};
var $732fd702166f02aa$export$44fbda67c66d275 = $a5EUy.forwardRef(function CrossBold(props, svgRef) {
    return $a5EUy.createElement("svg", $732fd702166f02aa$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M3.06.94A1.5 1.5 0 10.94 3.06L9.878 12l-8.94 8.94a1.5 1.5 0 002.122 2.12L12 14.122l8.94 8.94a1.5 1.5 0 002.12-2.122L14.122 12l8.94-8.94A1.5 1.5 0 0020.939.94L12 9.878 3.06.939z"
    }));
});

});

parcelRegister("5ByWn", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $414b82f022b793f2$var$__assign = undefined && undefined.__assign || function() {
    $414b82f022b793f2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $414b82f022b793f2$var$__assign.apply(this, arguments);
};
var $414b82f022b793f2$export$fe82a520fc33e5f4 = $a5EUy.forwardRef(function Dashboard(props, svgRef) {
    return $a5EUy.createElement("svg", $414b82f022b793f2$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M11 12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h7a2 2 0 012 2v10zm-2 .5H2a.5.5 0 01-.5-.5V2a.5.5 0 01.5-.5h7a.5.5 0 01.5.5v10a.5.5 0 01-.5.5zm4-.5a2 2 0 012-2h7a2 2 0 012 2v10a2 2 0 01-2 2h-7a2 2 0 01-2-2V12zm2-.5h7a.5.5 0 01.5.5v10a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5V12a.5.5 0 01.5-.5zM15 0a2 2 0 00-2 2v4a2 2 0 002 2h7a2 2 0 002-2V2a2 2 0 00-2-2h-7zm7 1.5h-7a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h7a.5.5 0 00.5-.5V2a.5.5 0 00-.5-.5zM11 22a2 2 0 01-2 2H2a2 2 0 01-2-2v-4a2 2 0 012-2h7a2 2 0 012 2v4zm-2 .5H2a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h7a.5.5 0 01.5.5v4a.5.5 0 01-.5.5z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("884Qk", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $5eb2d3ced6732864$var$__assign = undefined && undefined.__assign || function() {
    $5eb2d3ced6732864$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5eb2d3ced6732864$var$__assign.apply(this, arguments);
};
var $5eb2d3ced6732864$export$735b4219f406972d = $a5EUy.forwardRef(function DashboardBold(props, svgRef) {
    return $a5EUy.createElement("svg", $5eb2d3ced6732864$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M11 12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h7a2 2 0 012 2v10zm2 0a2 2 0 012-2h7a2 2 0 012 2v10a2 2 0 01-2 2h-7a2 2 0 01-2-2V12zm2-12a2 2 0 00-2 2v4a2 2 0 002 2h7a2 2 0 002-2V2a2 2 0 00-2-2h-7zm-4 22a2 2 0 01-2 2H2a2 2 0 01-2-2v-4a2 2 0 012-2h7a2 2 0 012 2v4z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("1bVk3", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $0de348942e9f28d4$var$__assign = undefined && undefined.__assign || function() {
    $0de348942e9f28d4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0de348942e9f28d4$var$__assign.apply(this, arguments);
};
var $0de348942e9f28d4$export$6feb5ea51a7b0b47 = $a5EUy.forwardRef(function Database(props, svgRef) {
    return $a5EUy.createElement("svg", $0de348942e9f28d4$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M3.767 1.373C5.987.484 8.949 0 12 0c3.05 0 6.012.483 8.233 1.372 1.11.444 2.029.986 2.682 1.616C23.569 3.62 24 4.388 24 5.25v13.5c0 .894-.456 1.67-1.119 2.296-.66.626-1.577 1.154-2.648 1.582C18.09 23.486 15.177 24 12 24c-3.178 0-6.089-.514-8.233-1.372-1.07-.428-1.987-.956-2.648-1.582C.456 20.42 0 19.644 0 18.75V5.251c0-.863.43-1.63 1.085-2.262.653-.63 1.571-1.172 2.682-1.616zM1.5 14.625v4.125c0 .349.174.756.65 1.206.477.452 1.208.893 2.174 1.28C6.25 22.005 8.964 22.5 12 22.5c3.036 0 5.75-.494 7.676-1.265.966-.386 1.697-.827 2.175-1.279.476-.45.649-.857.649-1.206v-4.125c-.615.484-1.389.903-2.267 1.254-2.144.857-5.056 1.371-8.233 1.371-3.178 0-6.089-.514-8.233-1.372-.878-.35-1.652-.77-2.267-1.253zM1.5 12V7.874c.606.478 1.374.898 2.267 1.255 2.22.889 5.182 1.372 8.233 1.372 3.05 0 6.012-.483 8.233-1.372.893-.357 1.661-.777 2.267-1.255V12c0 .349-.174.757-.65 1.207-.477.451-1.208.893-2.174 1.279-1.927.77-4.64 1.264-7.676 1.264-3.035 0-5.75-.494-7.676-1.264-.966-.387-1.697-.828-2.175-1.28-.475-.45-.649-.857-.649-1.206zm.627-5.566c-.465-.45-.627-.852-.627-1.183 0-.33.162-.733.627-1.183.468-.451 1.197-.903 2.197-1.303C6.322 1.966 9.084 1.501 12 1.501c2.917 0 5.678.465 7.676 1.264 1 .4 1.73.852 2.197 1.303.465.45.627.852.627 1.183 0 .33-.162.733-.627 1.183-.468.45-1.197.903-2.197 1.303C17.678 8.536 14.916 9 12 9c-2.917 0-5.678-.465-7.676-1.264-1-.4-1.73-.852-2.197-1.303z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("hK8TE", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $ceada2389744e24d$var$__assign = undefined && undefined.__assign || function() {
    $ceada2389744e24d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ceada2389744e24d$var$__assign.apply(this, arguments);
};
var $ceada2389744e24d$export$e457f953b131f785 = $a5EUy.forwardRef(function DatabaseBold(props, svgRef) {
    return $a5EUy.createElement("svg", $ceada2389744e24d$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M21.5 17.034a.25.25 0 00-.408-.194C19.155 18.417 15.5 19.25 12 19.25c-3.5 0-7.156-.833-9.093-2.41a.249.249 0 00-.407.194v1.716c0 2.21 4.254 4 9.5 4s9.5-1.79 9.5-4v-1.716z"
    }), $a5EUy.createElement("path", {
        d: "M2.5 14.25c0 2.21 4.254 4 9.5 4s9.5-1.79 9.5-4v-1.716a.25.25 0 00-.408-.194C19.155 13.917 15.5 14.75 12 14.75c-3.5 0-7.156-.833-9.093-2.41a.249.249 0 00-.407.194v1.716z"
    }), $a5EUy.createElement("path", {
        d: "M12 10.25c-3.5 0-7.156-.833-9.093-2.411a.249.249 0 00-.407.194V9.75c0 2.21 4.254 4 9.5 4s9.5-1.79 9.5-4V8.034a.25.25 0 00-.408-.193C19.154 9.418 15.5 10.25 12 10.25z"
    }), $a5EUy.createElement("path", {
        d: "M21.5 5.25c0 2.21-4.253 4-9.5 4s-9.5-1.79-9.5-4 4.253-4 9.5-4 9.5 1.79 9.5 4z"
    }));
});

});

parcelRegister("huICd", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $cbc7d8ad09480057$var$__assign = undefined && undefined.__assign || function() {
    $cbc7d8ad09480057$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cbc7d8ad09480057$var$__assign.apply(this, arguments);
};
var $cbc7d8ad09480057$export$6341f9a885713487 = $a5EUy.forwardRef(function Date(props, svgRef) {
    return $a5EUy.createElement("svg", $cbc7d8ad09480057$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M21.427 3.813h-3.552V1.707A.713.713 0 0017.168 1a.713.713 0 00-.707.707v2.106H8.039V1.707A.713.713 0 007.332 1a.713.713 0 00-.707.707v2.106H3.073A2.078 2.078 0 001 5.886v15.557c0 1.14.932 2.073 2.073 2.073h18.354a2.078 2.078 0 002.073-2.073V5.886a2.078 2.078 0 00-2.073-2.074zM3.073 5.21h3.552v1.414c0 .386.321.707.707.707a.713.713 0 00.707-.707V5.211h8.438v1.414c0 .386.321.707.707.707a.713.713 0 00.707-.707V5.211h3.552c.37 0 .659.305.659.659v3.55H2.414V5.886c0-.37.29-.675.66-.675zm18.354 16.875H3.073a.662.662 0 01-.659-.66v-10.59h19.688v10.59a.676.676 0 01-.675.66z"
    }), $a5EUy.createElement("path", {
        d: "M6.271 15.063a1.06 1.06 0 100-2.122 1.06 1.06 0 000 2.121zm.049 2.812h-.097a1.066 1.066 0 00-.996 1.045c0 .578.466 1.06 1.06 1.06a1.05 1.05 0 001.061-1.06 1.084 1.084 0 00-1.028-1.045zm5.93-2.812a1.06 1.06 0 100-2.122 1.06 1.06 0 000 2.121zm.048 2.812h-.112a1.066 1.066 0 00-.997 1.045 1.06 1.06 0 102.122 0c0-.563-.45-1.013-1.013-1.045zm5.995-4.918h-.097a1.058 1.058 0 00-1.012 1.045c0 .578.466 1.06 1.06 1.06a1.05 1.05 0 001.061-1.06 1.081 1.081 0 00-1.012-1.045zm-.064 4.918h-.017c-.578 0-1.044.482-1.044 1.06 0 .58.466 1.061 1.06 1.061a1.05 1.05 0 001.061-1.06 1.07 1.07 0 00-1.06-1.061z"
    }));
});

});

parcelRegister("kPhzk", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $f29632df9a4295a9$var$__assign = undefined && undefined.__assign || function() {
    $f29632df9a4295a9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f29632df9a4295a9$var$__assign.apply(this, arguments);
};
var $f29632df9a4295a9$export$6cbcb5cd862c2b93 = $a5EUy.forwardRef(function DateBold(props, svgRef) {
    return $a5EUy.createElement("svg", $f29632df9a4295a9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M6.271 12.566a1.436 1.436 0 100 2.871 1.436 1.436 0 000-2.871zm5.979 0a1.436 1.436 0 100 2.871 1.436 1.436 0 000-2.871zm6.054.016h-.128c-.75.043-1.367.646-1.367 1.42 0 .782.63 1.435 1.436 1.435.801 0 1.435-.634 1.435-1.435v-.011a1.456 1.456 0 00-1.365-1.408h-.011zM6.33 17.5h-.128c-.74.044-1.35.67-1.35 1.42 0 .781.63 1.435 1.436 1.435.801 0 1.435-.634 1.435-1.436v-.01A1.459 1.459 0 006.341 17.5h-.01zm5.979 0h-.145c-.74.044-1.35.67-1.35 1.42a1.435 1.435 0 102.872 0c0-.774-.618-1.377-1.366-1.42h-.011zm5.903 0c-.793 0-1.42.657-1.42 1.436 0 .782.631 1.435 1.437 1.435.801 0 1.435-.634 1.435-1.435 0-.786-.65-1.436-1.435-1.436h-.017z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M7.332.625c-.593 0-1.082.49-1.082 1.082v1.73H3.073A2.453 2.453 0 00.625 5.886v15.557c0 1.348 1.1 2.448 2.448 2.448h18.354c1.348 0 2.448-1.1 2.448-2.448V5.886c0-1.348-1.1-2.449-2.448-2.449H18.25v-1.73c0-.593-.49-1.082-1.082-1.082-.593 0-1.082.49-1.082 1.082v1.73H8.414v-1.73c0-.593-.489-1.082-1.082-1.082zM2.79 21.427V11.21h18.938v10.206a.3.3 0 01-.3.294H3.073a.287.287 0 01-.284-.284z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("7PgDK", function(module, exports) {

$parcel$export(module.exports, "Delete", function () { return $5b2a343083c4243e$export$bfadae053a633538; });

var $a5EUy = parcelRequire("a5EUy");
var $5b2a343083c4243e$var$__assign = undefined && undefined.__assign || function() {
    $5b2a343083c4243e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5b2a343083c4243e$var$__assign.apply(this, arguments);
};
var $5b2a343083c4243e$export$bfadae053a633538 = $a5EUy.forwardRef(function Delete(props, svgRef) {
    return $a5EUy.createElement("svg", $5b2a343083c4243e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M9.827 10.077a.75.75 0 01.75.75v6.461a.75.75 0 01-1.5 0v-6.461a.75.75 0 01.75-.75zm5.596.75a.75.75 0 00-1.5 0v6.461a.75.75 0 001.5 0v-6.461z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M9.827 2A2.365 2.365 0 007.46 4.365v.866H1.75a.75.75 0 000 1.5h2.481v13.788a2.365 2.365 0 002.365 2.366h11.308a2.365 2.365 0 002.365-2.366V6.731h2.481a.75.75 0 000-1.5h-5.712v-.866A2.365 2.365 0 0014.673 2H9.827zM8.198 6.73h8.09a.74.74 0 00.014 0h2.467v13.79a.866.866 0 01-.865.864H6.596a.865.865 0 01-.865-.865V6.731h2.467zm7.34-1.5v-.865a.865.865 0 00-.865-.865H9.827a.865.865 0 00-.866.865v.866h6.577z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("lj9dA", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $f83285ddd09d9cbd$var$__assign = undefined && undefined.__assign || function() {
    $f83285ddd09d9cbd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f83285ddd09d9cbd$var$__assign.apply(this, arguments);
};
var $f83285ddd09d9cbd$export$8d5b5b936cb45ab2 = $a5EUy.forwardRef(function DeleteBold(props, svgRef) {
    return $a5EUy.createElement("svg", $f83285ddd09d9cbd$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M9.577 1A3.115 3.115 0 006.46 4.115v.116H1.5a1.5 1.5 0 000 3h1.731v13.038a3.116 3.116 0 003.115 3.116h11.308a3.115 3.115 0 003.115-3.116V7.231H22.5a1.5 1.5 0 000-3h-4.962v-.116A3.116 3.116 0 0014.423 1H9.577zm0 8.077a1.5 1.5 0 011.5 1.5v6.461a1.5 1.5 0 01-3 0v-6.461a1.5 1.5 0 011.5-1.5zm6.346 1.5a1.5 1.5 0 10-3 0v6.461a1.5 1.5 0 003 0v-6.461z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("6MU2q", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $4f12b1c74410fda1$var$__assign = undefined && undefined.__assign || function() {
    $4f12b1c74410fda1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4f12b1c74410fda1$var$__assign.apply(this, arguments);
};
var $4f12b1c74410fda1$export$92da3e5df6c76b76 = $a5EUy.forwardRef(function DevicesExternalScreen(props, svgRef) {
    return $a5EUy.createElement("svg", $4f12b1c74410fda1$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M.746 2A.746.746 0 000 2.746v14.92c0 .413.334.747.746.747h5.853a10.296 10.296 0 00-2.703 2.375.746.746 0 001.166.932 8.804 8.804 0 016.715-3.307h.325a8.802 8.802 0 016.715 3.307.746.746 0 101.166-.932 10.296 10.296 0 00-2.703-2.375h5.847a.746.746 0 00.746-.746V2.746A.746.746 0 0023.127 2H.746zm11.37 14.92H22.38V3.493H1.492v13.429h10.272a10.291 10.291 0 01.351 0z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("463aN", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $2fba2f1714415cbc$var$__assign = undefined && undefined.__assign || function() {
    $2fba2f1714415cbc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2fba2f1714415cbc$var$__assign.apply(this, arguments);
};
var $2fba2f1714415cbc$export$2ab1c2ba66a64865 = $a5EUy.forwardRef(function DevicesLaptop(props, svgRef) {
    return $a5EUy.createElement("svg", $2fba2f1714415cbc$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M23.211 18.925l-2.005-4.378V5.19a2.197 2.197 0 00-2.19-2.189H4.396a2.2 2.2 0 00-2.206 2.19v9.34L.184 18.91a2.48 2.48 0 00-.184.902c0 .585.234 1.136.635 1.554.401.418.97.635 1.554.635h19.017c.3 0 .601-.067.886-.184a2.124 2.124 0 001.152-1.22 2.15 2.15 0 00-.033-1.67zM3.66 5.19c0-.401.334-.735.735-.735h14.622c.4 0 .735.334.735.735v8.773H3.66V5.19zm18.23 14.89a.653.653 0 01-.383.4c-.1.034-.2.067-.301.067H2.189a.733.733 0 01-.518-.217.733.733 0 01-.217-.518c0-.1.017-.2.067-.284l1.871-4.094h16.61l1.872 4.094a.78.78 0 01.017.551z"
    }), $a5EUy.createElement("path", {
        d: "M13.168 17.622h-2.924a.742.742 0 00-.736.735c0 .401.335.735.736.735h2.924a.742.742 0 00.735-.735.742.742 0 00-.735-.735z"
    }));
});

});

parcelRegister("4ugFB", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $3446e5117e4fe091$var$__assign = undefined && undefined.__assign || function() {
    $3446e5117e4fe091$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3446e5117e4fe091$var$__assign.apply(this, arguments);
};
var $3446e5117e4fe091$export$13ffd9e444ebb4d9 = $a5EUy.forwardRef(function DevicesResponsiveWebSite(props, svgRef) {
    return $a5EUy.createElement("svg", $3446e5117e4fe091$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .75A.75.75 0 01.75 0h7.5A.75.75 0 019 .75v12a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-12zm1.5 9.75V12h6v-1.5h-6zm6-1.5h-6V1.5h6V9z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M10.5 5.25a.75.75 0 01.75-.75h10.5A2.25 2.25 0 0124 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-5.115l.5 3h1.615a.75.75 0 010 1.5H8.25a.75.75 0 010-1.5h1.615l.5-3H5.25A2.25 2.25 0 013 17.25v-1.5a.75.75 0 01.75-.75H22.5V6.75a.75.75 0 00-.75-.75h-10.5a.75.75 0 01-.75-.75zm12 11.25h-18v.75a.75.75 0 00.75.75h16.5a.75.75 0 00.75-.75v-.75zm-10.615 3h3.23l.5 3h-4.23l.5-3z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("49gqP", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $3054bfaea36d98f8$var$__assign = undefined && undefined.__assign || function() {
    $3054bfaea36d98f8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3054bfaea36d98f8$var$__assign.apply(this, arguments);
};
var $3054bfaea36d98f8$export$9924e86c6f4ee998 = $a5EUy.forwardRef(function DevicesSmartWatch(props, svgRef) {
    return $a5EUy.createElement("svg", $3054bfaea36d98f8$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M18.373 4.488h-.994l-.428-2.62A2.26 2.26 0 0014.724 0H9.773a2.23 2.23 0 00-2.21 1.867l-.428 2.621H6.14c-1.18 0-2.14.96-2.14 2.124V17.37c0 1.165.96 2.125 2.124 2.125h.994l.428 2.62A2.242 2.242 0 009.756 24h4.95a2.229 2.229 0 002.21-1.884l.429-2.621h.993c1.165 0 2.124-.96 2.124-2.125V6.612a2.095 2.095 0 00-2.09-2.124zM9.019 2.124a.752.752 0 01.737-.617h4.95c.36 0 .686.257.737.617l.394 2.381H8.625l.394-2.38zM15.46 21.86a.766.766 0 01-.736.633H9.773a.738.738 0 01-.737-.633l-.41-2.364h7.228l-.394 2.364zm3.53-4.489a.614.614 0 01-.617.617H6.124a.614.614 0 01-.617-.617V6.612c0-.342.275-.616.617-.616h12.249c.342 0 .616.274.616.616V17.37z"
    }), $a5EUy.createElement("path", {
        d: "M12.24 13.122a1.508 1.508 0 100-3.015 1.508 1.508 0 000 3.015zm-1.867-2.998a1.13 1.13 0 001.13-1.13c0-.634-.497-1.131-1.13-1.131-.634 0-1.131.497-1.131 1.13a1.13 1.13 0 001.13 1.131zm-.377 1.867a1.13 1.13 0 00-1.13-1.13 1.12 1.12 0 00-1.132 1.13 1.13 1.13 0 102.262 0zm5.619-1.131a1.13 1.13 0 100 2.262c.633 0 1.13-.497 1.13-1.13a1.14 1.14 0 00-1.13-1.131zm-1.491-.736a1.13 1.13 0 001.13-1.13c0-.634-.496-1.131-1.13-1.131-.634 0-1.13.497-1.13 1.13 0 .634.496 1.131 1.13 1.131zm-3.751 3.735a1.13 1.13 0 00-1.131 1.13c0 .634.497 1.13 1.13 1.13.634 0 1.131-.496 1.131-1.13a1.13 1.13 0 00-1.13-1.13zm3.751 0a1.13 1.13 0 00-1.13 1.13c0 .634.496 1.13 1.13 1.13.634 0 1.13-.496 1.13-1.13a1.13 1.13 0 00-1.13-1.13z"
    }));
});

});

parcelRegister("jVN0j", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $e8295a6412d5d621$var$__assign = undefined && undefined.__assign || function() {
    $e8295a6412d5d621$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e8295a6412d5d621$var$__assign.apply(this, arguments);
};
var $e8295a6412d5d621$export$dd6647a8feb33032 = $a5EUy.forwardRef(function DevicesSmileyBold(props, svgRef) {
    return $a5EUy.createElement("svg", $e8295a6412d5d621$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M23.53 20l-2-5H2.27L.45 19.85a2.29 2.29 0 002.13 3.26h19A2.19 2.19 0 0023.53 20zm-9.45 0h-3.92a1 1 0 110-2h3.92a1 1 0 110 2z"
    }), $a5EUy.createElement("path", {
        d: "M21.65 15.37H2.27V3.46A2.66 2.66 0 015 .89h13.92a2.66 2.66 0 012.74 2.58l-.01 11.9zM4.09 13.66h15.75V3.46a.9.9 0 00-.93-.87H5a.9.9 0 00-.93.87l.02 10.2z"
    }), $a5EUy.createElement("path", {
        d: "M9.7 7.52a1 1 0 01-1-1V5.24a1 1 0 112 0v1.28a1 1 0 01-1 1zm4.38 0a1 1 0 01-1-1V5.24a1 1 0 012 0v1.28a1 1 0 01-1 1zM11.5 12c-1.66-.1-2.846-.62-4.25-1.51a1 1 0 011.09-1.66A8.23 8.23 0 0012 10a8.16 8.16 0 003.59-1.2 1.001 1.001 0 011.09 1.68c-1.41.885-2.518 1.407-4.18 1.52h-1z"
    }));
});

});

parcelRegister("iNkPT", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $daecf7317df41af6$var$__assign = undefined && undefined.__assign || function() {
    $daecf7317df41af6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $daecf7317df41af6$var$__assign.apply(this, arguments);
};
var $daecf7317df41af6$export$86ae6e8ac17a67c6 = $a5EUy.forwardRef(function Directions(props, svgRef) {
    return $a5EUy.createElement("svg", $daecf7317df41af6$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M23.28 4.183l-2.47-2.469a.752.752 0 00-.531-.223h-8.246V.754A.761.761 0 0011.28 0a.761.761 0 00-.754.754v.755H3.788a.761.761 0 00-.754.754v6c0 .411.343.754.754.754h6.755v1.509H3.788a.752.752 0 00-.53.223l-2.47 2.434a1.493 1.493 0 000 2.126l2.47 2.468a.752.752 0 00.53.223h6.755v5.246c0 .411.343.754.754.754a.761.761 0 00.754-.754V18h8.246a.761.761 0 00.754-.754v-6a.761.761 0 00-.754-.755h-8.263V8.983h8.246a.752.752 0 00.531-.223l2.469-2.469c.583-.565.583-1.525 0-2.108zM19.526 16.49H4.097l-2.246-2.245L4.097 12h15.446v4.491h-.017zm2.691-11.245L19.971 7.49H4.526V3H19.97l2.246 2.246z"
    }));
});

});

parcelRegister("hq5MN", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $cae95a5add821478$var$__assign = undefined && undefined.__assign || function() {
    $cae95a5add821478$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cae95a5add821478$var$__assign.apply(this, arguments);
};
var $cae95a5add821478$export$8871f210e34a6755 = $a5EUy.forwardRef(function DirectionsBold(props, svgRef) {
    return $a5EUy.createElement("svg", $cae95a5add821478$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M20.811 1.714l2.469 2.469c.583.583.583 1.543 0 2.108L20.81 8.76a.752.752 0 01-.531.223h-7.53v1.508h7.547a.76.76 0 01.754.755v6a.761.761 0 01-.754.754H12.75v4.5a1.5 1.5 0 01-3 0V18H3.788a.752.752 0 01-.53-.223L.787 15.31a1.493 1.493 0 010-2.126l2.47-2.434a.752.752 0 01.53-.223H9.75v-1.51H3.788a.761.761 0 01-.754-.754v-6a.76.76 0 01.754-.754H9.75V1.5a1.5 1.5 0 013-.009h7.53c.206 0 .394.086.531.223z"
    }));
});

});

parcelRegister("4fBbc", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $3185673e35ede4f6$var$__assign = undefined && undefined.__assign || function() {
    $3185673e35ede4f6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3185673e35ede4f6$var$__assign.apply(this, arguments);
};
var $3185673e35ede4f6$export$5f0fddd75cd8dcd7 = $a5EUy.forwardRef(function Discount(props, svgRef) {
    return $a5EUy.createElement("svg", $3185673e35ede4f6$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M5 1.25a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zm0 1.5a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zm13.5 12a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zm0 1.5a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zm3.226-14.03a.75.75 0 00-1.06 0L1.22 21.312l-.067.076a.75.75 0 001.127.984L21.726 3.28l.067-.076a.75.75 0 00-.067-.984z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("FiuGu", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $07c22cf47982fb13$var$__assign = undefined && undefined.__assign || function() {
    $07c22cf47982fb13$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $07c22cf47982fb13$var$__assign.apply(this, arguments);
};
var $07c22cf47982fb13$export$f4dcdf7799f12754 = $a5EUy.forwardRef(function DiscountBold(props, svgRef) {
    return $a5EUy.createElement("svg", $07c22cf47982fb13$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M22.255 1.973a1.75 1.75 0 00-2.475-.035l-18 17.5a1.75 1.75 0 002.44 2.509l18-17.5a1.75 1.75 0 00.035-2.474zM5 8.558a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm17.5 10.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("jXBD2", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $e880b744bf330855$var$__assign = undefined && undefined.__assign || function() {
    $e880b744bf330855$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e880b744bf330855$var$__assign.apply(this, arguments);
};
var $e880b744bf330855$export$a7aaed3e118dd255 = $a5EUy.forwardRef(function Download(props, svgRef) {
    return $a5EUy.createElement("svg", $e880b744bf330855$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M12 3a.75.75 0 01.75.75v10.189l3.22-3.22a.75.75 0 011.06 1.06l-4.5 4.5a.747.747 0 01-1.052.008l-.005-.004-.003-.003-4.5-4.5a.75.75 0 011.061-1.06l3.22 3.219V3.749A.75.75 0 0112 3z"
    }), $a5EUy.createElement("path", {
        d: "M1.5 15.75a.75.75 0 10-1.499 0v1.5A3.75 3.75 0 003.751 21h16.5A3.75 3.75 0 0024 17.25v-1.5a.75.75 0 00-1.5 0v1.5a2.25 2.25 0 01-2.25 2.25H3.75a2.25 2.25 0 01-2.25-2.25v-1.5z"
    }));
});

});

parcelRegister("7JPkW", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $5a248eca4cda084d$var$__assign = undefined && undefined.__assign || function() {
    $5a248eca4cda084d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5a248eca4cda084d$var$__assign.apply(this, arguments);
};
var $5a248eca4cda084d$export$81d26d25f3637d53 = $a5EUy.forwardRef(function DownwardTrend(props, svgRef) {
    return $a5EUy.createElement("svg", $5a248eca4cda084d$var$__assign({
        fill: "currentColor",
        height: 25,
        ref: svgRef,
        viewBox: "0 0 24 25",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M3.817.44A.75.75 0 014.81.067l14.42 6.549-.558-1.486a.75.75 0 111.404-.527l1.194 3.18.012.033a.747.747 0 01-.45.933L17.65 9.943a.75.75 0 11-.527-1.404l1.485-.558L4.19 1.433A.75.75 0 013.818.44z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M3 9a1.5 1.5 0 00-1.5 1.5v12H.75a.75.75 0 000 1.5h22.5a.75.75 0 000-1.5h-.75V18a1.5 1.5 0 00-1.5-1.5h-3a1.5 1.5 0 00-1.5 1.5v4.5H15v-9a1.5 1.5 0 00-1.5-1.5h-3A1.5 1.5 0 009 13.5v9H7.5v-12A1.5 1.5 0 006 9H3zm3 13.5v-12H3v12h3zm7.5-9v9h-3v-9h3zm7.5 9V18h-3v4.5h3z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("fw6bS", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $b4bea57ec30bf163$var$__assign = undefined && undefined.__assign || function() {
    $b4bea57ec30bf163$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b4bea57ec30bf163$var$__assign.apply(this, arguments);
};
var $b4bea57ec30bf163$export$4a82481d9e63c9e1 = $a5EUy.forwardRef(function Duplicate(props, svgRef) {
    return $a5EUy.createElement("svg", $b4bea57ec30bf163$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M2 4.251A2.251 2.251 0 014.25 2H16.5a2 2 0 012 2A.75.75 0 0117 4a.5.5 0 00-.5-.5H4.25a.751.751 0 00-.75.751V16.5a.5.5 0 00.5.5.75.75 0 010 1.5 2 2 0 01-2-2V4.251z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M20 7.5H8a.5.5 0 00-.5.5v12a.5.5 0 00.5.5h12a.5.5 0 00.5-.5V8a.5.5 0 00-.5-.5zM8 6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2H8z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M14 10.45a.75.75 0 01.75.75v2.05h2.05a.75.75 0 010 1.5h-2.05v2.05a.75.75 0 11-1.5 0v-2.05H11.2a.75.75 0 110-1.5h2.05V11.2a.75.75 0 01.75-.75z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("jde0j", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $dfca181cd71375f0$var$__assign = undefined && undefined.__assign || function() {
    $dfca181cd71375f0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dfca181cd71375f0$var$__assign.apply(this, arguments);
};
var $dfca181cd71375f0$export$7791901baee658a0 = $a5EUy.forwardRef(function DuplicateBold(props, svgRef) {
    return $a5EUy.createElement("svg", $dfca181cd71375f0$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M1.25 4.251a3.001 3.001 0 013-3.001H16.5A2.75 2.75 0 0119.25 4a1.5 1.5 0 01-2.98.25H4.25v12.021A1.5 1.5 0 014 19.25a2.75 2.75 0 01-2.75-2.75V4.251z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M8.5 6.5a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-12a2 2 0 00-2-2h-12zm7 5.2a1 1 0 00-2 0v1.8h-1.8a1 1 0 000 2h1.8v1.8a1 1 0 102 0v-1.8h1.8a1 1 0 100-2h-1.8v-1.8z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("2pZF5", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $1c2dbf48480e2b48$var$__assign = undefined && undefined.__assign || function() {
    $1c2dbf48480e2b48$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1c2dbf48480e2b48$var$__assign.apply(this, arguments);
};
var $1c2dbf48480e2b48$export$6ed0965c9443aaa6 = $a5EUy.forwardRef(function Edit(props, svgRef) {
    return $a5EUy.createElement("svg", $1c2dbf48480e2b48$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M19.592 0a4.39 4.39 0 013.128 1.28l.002.002a4.386 4.386 0 01-.04 6.231l-.41.411-.001.001-14.08 14.08-.005.005a.75.75 0 01-.344.196l-6.906 1.77a.75.75 0 01-.912-.913l1.77-6.904a.75.75 0 01.196-.344v-.001L16.486 1.318A4.388 4.388 0 0119.592 0zM2.921 17.802l-1.13 4.406 4.41-1.13-3.28-3.276zm4.738 2.612l-4.077-4.07L16.605 3.32l4.074 4.074-13.02 13.02zM22.27 5.507a2.85 2.85 0 01-.531.825l-4.07-4.07a2.89 2.89 0 013.991.079 2.887 2.887 0 01.61 3.166z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("bslby", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $8572be3040d97ccd$var$__assign = undefined && undefined.__assign || function() {
    $8572be3040d97ccd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8572be3040d97ccd$var$__assign.apply(this, arguments);
};
var $8572be3040d97ccd$export$680fa2622ca83bb7 = $a5EUy.forwardRef(function EditBold(props, svgRef) {
    return $a5EUy.createElement("svg", $8572be3040d97ccd$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M19.592 0a4.39 4.39 0 013.128 1.28l.002.002a4.386 4.386 0 01.076 6.115 1.017 1.017 0 00-.09-.103l-6-6a1.014 1.014 0 00-.104-.09A4.388 4.388 0 0119.593 0zm1.701 8.707a.962.962 0 00.103.09L9.304 20.89 3.11 14.695 15.201 2.603a.993.993 0 00.092.104l6 6zm-19.509 7.49l-1.76 6.866a.75.75 0 00.912.913l6.865-1.76-6.017-6.019z"
    }));
});

});

parcelRegister("8xC9g", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $637eff4ded1a468a$var$__assign = undefined && undefined.__assign || function() {
    $637eff4ded1a468a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $637eff4ded1a468a$var$__assign.apply(this, arguments);
};
var $637eff4ded1a468a$export$4c6ac753363de59f = $a5EUy.forwardRef(function EditFile(props, svgRef) {
    return $a5EUy.createElement("svg", $637eff4ded1a468a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M13.755 14.775l7.904-7.904a.812.812 0 00.032-.031l.974-.975a2.852 2.852 0 00-.924-4.648 2.85 2.85 0 00-3.107.618l-8.91 8.91a.75.75 0 00-.211.424l-.495 3.465a.75.75 0 00.849.849l3.464-.496a.75.75 0 00.424-.212zM20.65 2.5a1.35 1.35 0 00-.955.395l-.46.46 1.91 1.91.46-.46A1.35 1.35 0 0020.65 2.5zm-9.688 9.128l7.213-7.212 1.909 1.909-7.213 7.213-2.227.318.318-2.228z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M2.69 6.892a.65.65 0 01.46-.19h7a.75.75 0 000-1.5h-7A2.15 2.15 0 001 7.351v14a2.15 2.15 0 002.15 2.15h14a2.15 2.15 0 002.15-2.15v-7a.75.75 0 00-1.5 0v7a.65.65 0 01-.65.65h-14a.65.65 0 01-.65-.65v-14a.65.65 0 01.19-.46z"
    }));
});

});

parcelRegister("3npvX", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $27574fb6a2af0730$var$__assign = undefined && undefined.__assign || function() {
    $27574fb6a2af0730$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $27574fb6a2af0730$var$__assign.apply(this, arguments);
};
var $27574fb6a2af0730$export$b78ec286cc721c36 = $a5EUy.forwardRef(function EditFileBold(props, svgRef) {
    return $a5EUy.createElement("svg", $27574fb6a2af0730$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M3 6.451h6.9a1.5 1.5 0 100-3h-7a2.9 2.9 0 00-2.9 2.9v14a2.9 2.9 0 002.9 2.9h14a2.9 2.9 0 002.9-2.9v-7a1.5 1.5 0 10-3 0v6.9H3v-13.8z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M21.722 5.558a.772.772 0 00-.015-.015l-4.015-4.015.692-.693a2.85 2.85 0 014.031 4.03l-.693.693zm-1.414 1.414a1.652 1.652 0 01-.015-.015l-4.015-4.015-6.803 6.802a.75.75 0 00-.212.425l-.495 3.465a.75.75 0 00.849.849l3.464-.496a.75.75 0 00.424-.212l6.803-6.803z"
    }));
});

});

parcelRegister("5eLsd", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $3d0311f97c25597e$var$__assign = undefined && undefined.__assign || function() {
    $3d0311f97c25597e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3d0311f97c25597e$var$__assign.apply(this, arguments);
};
var $3d0311f97c25597e$export$65259f2909ebaca1 = $a5EUy.forwardRef(function EmailUnread(props, svgRef) {
    return $a5EUy.createElement("svg", $3d0311f97c25597e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("g", {
        clipPath: "url(#email-unread_svg__email-unread_svg__clip0)"
    }, $a5EUy.createElement("path", {
        d: "M21.6 4H2.4A2.4 2.4 0 000 6.4v12.8a2.4 2.4 0 002.4 2.4h19.2a2.4 2.4 0 002.4-2.4V6.4A2.4 2.4 0 0021.6 4zM2.4 5.6h19.2a.8.8 0 01.8.8v12.8a.8.8 0 01-.8.8H2.4a.8.8 0 01-.8-.8V6.4a.8.8 0 01.8-.8z"
    }), $a5EUy.createElement("path", {
        d: "M22.35 4.753a.8.8 0 011.065 1.189l-.089.079-8.687 6.681a4.329 4.329 0 01-5.089.138l-.19-.138L.675 6.021a.8.8 0 01.876-1.334l.1.066 8.686 6.681a2.729 2.729 0 003.16.119l.168-.119 8.687-6.681z"
    })), $a5EUy.createElement("defs", null, $a5EUy.createElement("clipPath", {
        id: "email-unread_svg__email-unread_svg__clip0"
    }, $a5EUy.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});

});

parcelRegister("3w177", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $28f539702ac6fd04$var$__assign = undefined && undefined.__assign || function() {
    $28f539702ac6fd04$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $28f539702ac6fd04$var$__assign.apply(this, arguments);
};
var $28f539702ac6fd04$export$7814126f72106a6c = $a5EUy.forwardRef(function EmailUnreadBold(props, svgRef) {
    return $a5EUy.createElement("svg", $28f539702ac6fd04$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("g", {
        clipPath: "url(#email-unread-bold_svg__email-unread-bold_svg__clip0)"
    }, $a5EUy.createElement("path", {
        d: "M23.888 5.832a.182.182 0 00-.2.039l-9.747 9.745a2.75 2.75 0 01-3.888 0L.31 5.871A.182.182 0 000 6v12a2 2 0 002 2h20a2 2 0 002-2V6a.181.181 0 00-.112-.168z"
    }), $a5EUy.createElement("path", {
        d: "M11.115 14.556c.489.487 1.28.487 1.768 0l9.686-9.686a.5.5 0 00.121-.511C22.58 4.03 22.274 4 22 4H2c-.275 0-.583.03-.691.359a.5.5 0 00.121.511l9.685 9.686z"
    })), $a5EUy.createElement("defs", null, $a5EUy.createElement("clipPath", {
        id: "email-unread-bold_svg__email-unread-bold_svg__clip0"
    }, $a5EUy.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});

});

parcelRegister("lcNYd", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $f7017afd724ebfd0$var$__assign = undefined && undefined.__assign || function() {
    $f7017afd724ebfd0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f7017afd724ebfd0$var$__assign.apply(this, arguments);
};
var $f7017afd724ebfd0$export$49bd1dfb0ad29c40 = $a5EUy.forwardRef(function Expand(props, svgRef) {
    return $a5EUy.createElement("svg", $f7017afd724ebfd0$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M21.746 3.806v4.69a.75.75 0 001.5 0v-6.5a.747.747 0 00-.75-.75h-6.5a.75.75 0 000 1.5h4.69l-7.22 7.22a.75.75 0 101.06 1.06l7.22-7.22zM1.996 14.974a.75.75 0 01.75.75v4.689l7.22-7.22a.75.75 0 011.06 1.061l-7.22 7.22h4.69a.75.75 0 110 1.5h-6.5a.746.746 0 01-.679-.43.747.747 0 01-.071-.32v-6.5a.75.75 0 01.75-.75z"
    }));
});

});

parcelRegister("h4u5Z", function(module, exports) {

$parcel$export(module.exports, "ExpandBold", function () { return $c6da27c54569c764$export$6b5ba4345fea866a; });

var $a5EUy = parcelRequire("a5EUy");
var $c6da27c54569c764$var$__assign = undefined && undefined.__assign || function() {
    $c6da27c54569c764$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c6da27c54569c764$var$__assign.apply(this, arguments);
};
var $c6da27c54569c764$export$6b5ba4345fea866a = $a5EUy.forwardRef(function ExpandBold(props, svgRef) {
    return $a5EUy.createElement("svg", $c6da27c54569c764$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M20.996 8.496a1.5 1.5 0 003 0v-6.5a1.496 1.496 0 00-1.5-1.5h-6.5a1.5 1.5 0 000 3h2.879l-5.94 5.94a1.5 1.5 0 102.121 2.12l5.94-5.939v2.879zm-19 5.728a1.5 1.5 0 011.5 1.5v2.878l5.94-5.939a1.5 1.5 0 112.12 2.121l-5.939 5.94h2.879a1.5 1.5 0 110 3h-6.5a1.494 1.494 0 01-1.374-.897 1.495 1.495 0 01-.126-.603v-6.5a1.5 1.5 0 011.5-1.5z"
    }));
});

});

parcelRegister("9Ie5Z", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $71232832f293c1ca$var$__assign = undefined && undefined.__assign || function() {
    $71232832f293c1ca$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $71232832f293c1ca$var$__assign.apply(this, arguments);
};
var $71232832f293c1ca$export$7562e752e5ef1fad = $a5EUy.forwardRef(function Faq(props, svgRef) {
    return $a5EUy.createElement("svg", $71232832f293c1ca$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M2.25 1.5a.75.75 0 00-.75.75v15a.75.75 0 00.75.75h3a.75.75 0 01.75.75v3l4.8-3.6a.75.75 0 01.45-.15h10.5a.75.75 0 00.75-.75v-15a.75.75 0 00-.75-.75H2.25zM.659.659A2.25 2.25 0 012.25 0h19.5A2.25 2.25 0 0124 2.25v15a2.25 2.25 0 01-2.25 2.25H11.5l-5.8 4.35a.75.75 0 01-1.2-.6V19.5H2.25A2.25 2.25 0 010 17.25v-15C0 1.653.237 1.081.659.659z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M11.325 11.46h1.227c-.037-.166-.091-.367-.091-.587 0-.659.494-1.117 1.3-1.85 1.025-.915 1.739-1.738 1.739-2.965C15.5 4.263 14.053 3 12.277 3c-1.61 0-2.8.934-3.277 2.563l1.19.495c.366-1.172 1.117-1.758 2.05-1.758.99 0 1.795.75 1.795 1.85 0 .896-.512 1.39-1.428 2.251-.787.696-1.465 1.337-1.465 2.252 0 .293.074.586.183.806zm.696 4.027c.641 0 1.172-.476 1.172-1.153 0-.678-.531-1.154-1.172-1.154-.604 0-1.153.476-1.153 1.154 0 .677.549 1.153 1.153 1.153z"
    }));
});

});

parcelRegister("gWb4A", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $c54aa6fa3394294c$var$__assign = undefined && undefined.__assign || function() {
    $c54aa6fa3394294c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c54aa6fa3394294c$var$__assign.apply(this, arguments);
};
var $c54aa6fa3394294c$export$b995d600f3ba41d6 = $a5EUy.forwardRef(function FaqBold(props, svgRef) {
    return $a5EUy.createElement("svg", $c54aa6fa3394294c$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M2.25 0A2.25 2.25 0 000 2.25v15a2.25 2.25 0 002.25 2.25H4.5v3.75a.75.75 0 001.2.6l5.8-4.35h10.25A2.25 2.25 0 0024 17.25v-15A2.25 2.25 0 0021.75 0H2.25zm10.759 11.094h-1.88a1.996 1.996 0 01-.182-.792c0-.66.495-1.22 1.303-1.864.676-.561.973-.858.973-1.386 0-.594-.462-1.006-1.039-1.006-.61 0-1.056.429-1.37 1.253L9 6.508C9.478 4.825 10.7 4 12.25 4c1.798 0 3.25 1.138 3.25 2.887 0 .973-.462 1.617-1.37 2.409l-.176.153c-.57.495-.978.849-.978 1.299 0 .131.016.247.033.346zm.66 2.656c0 .874-.66 1.534-1.535 1.534-.89 0-1.55-.66-1.55-1.534 0-.858.66-1.534 1.55-1.534a1.51 1.51 0 011.535 1.534z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("APNu3", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $06eb8abcdf20adb7$var$__assign = undefined && undefined.__assign || function() {
    $06eb8abcdf20adb7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $06eb8abcdf20adb7$var$__assign.apply(this, arguments);
};
var $06eb8abcdf20adb7$export$f07d42f183ae8811 = $a5EUy.forwardRef(function FeedScroll(props, svgRef) {
    return $a5EUy.createElement("svg", $06eb8abcdf20adb7$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M2.2 2.467a.733.733 0 00-.733.733v13.2a.733.733 0 00.733.733h5.136a.733.733 0 110 1.467H2.2A2.2 2.2 0 010 16.4V3.2A2.2 2.2 0 012.2 1h19.067a2.2 2.2 0 012.2 2.2v11.733a.733.733 0 11-1.467 0V3.2a.733.733 0 00-.733-.733h-2.2v8.066a.733.733 0 01-1.467 0V2.467H2.2z"
    }), $a5EUy.createElement("path", {
        d: "M5.133 5.4a.733.733 0 000 1.467h7.334a.733.733 0 000-1.467H5.133zm9.018 6.815a.733.733 0 011.252.518v2.934c0 .358.26.664.613.723l1.949.325a2.2 2.2 0 011.838 2.17v3.382a.733.733 0 101.467 0v-3.383a3.667 3.667 0 00-3.064-3.616l-1.336-.223v-2.312a2.2 2.2 0 00-4.4 0v3.95l-.092-.046a2.334 2.334 0 00-3.309 1.521v.002a2.334 2.334 0 00.813 2.388l.001.001 2.862 2.29a.733.733 0 10.916-1.145l-2.864-2.292-.002-.002a.867.867 0 01-.129-1.23.866.866 0 011.056-.222l1.154.575a.733.733 0 001.06-.656v-5.134c0-.194.078-.38.215-.518zM4.4 9.067c0-.405.328-.734.733-.734h7.334a.733.733 0 010 1.467H5.133a.733.733 0 01-.733-.733zm.733 2.2a.733.733 0 100 1.466H8.8a.733.733 0 100-1.466H5.133z"
    }));
});

});

parcelRegister("fTslh", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $b921fa433e410cc7$var$__assign = undefined && undefined.__assign || function() {
    $b921fa433e410cc7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b921fa433e410cc7$var$__assign.apply(this, arguments);
};
var $b921fa433e410cc7$export$51369d9fa2a33304 = $a5EUy.forwardRef(function FeedScrollBold(props, svgRef) {
    return $a5EUy.createElement("svg", $b921fa433e410cc7$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M5.92 16.823a.253.253 0 00-.041-.219.248.248 0 00-.2-.1H5.5a1 1 0 01-1-1v-12a1 1 0 011-1h14a1 1 0 011 1v10.678c0 .117.08.218.194.244 1.084.25 2.08.787 2.884 1.555A.25.25 0 0024 15.8V2.505a2.5 2.5 0 00-2.5-2.5h-19a2.5 2.5 0 00-2.5 2.5v14a2.5 2.5 0 002.5 2.5h3.152a.251.251 0 00.242-.312 3.6 3.6 0 01.026-1.87z"
    }), $a5EUy.createElement("path", {
        d: "M23 24a.75.75 0 00.75-.75v-3A4.756 4.756 0 0019 15.5h-2a.25.25 0 01-.25-.25v-5.5a2.25 2.25 0 00-4.5 0v7.06a.25.25 0 01-.442.16l-.578-.7a2.25 2.25 0 00-3.46 2.877l3.806 4.579c.143.172.354.27.577.271L23 24z"
    }));
});

});

parcelRegister("jSPYz", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $e79b60cd274415eb$var$__assign = undefined && undefined.__assign || function() {
    $e79b60cd274415eb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e79b60cd274415eb$var$__assign.apply(this, arguments);
};
var $e79b60cd274415eb$export$2f3ad13cc6e1f36d = $a5EUy.forwardRef(function FilesAnalytics(props, svgRef) {
    return $a5EUy.createElement("svg", $e79b60cd274415eb$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M21.35 6.59L15.47.71A2.25 2.25 0 0013.88 0H3.25A2.25 2.25 0 001 2.3v19.4A2.25 2.25 0 003.25 24h16.5A2.25 2.25 0 0022 21.75V8.18a2.25 2.25 0 00-.65-1.59zM14.5 1.86l5.69 5.69h-4.94a.75.75 0 01-.75-.75V1.86zm6 19.84a.75.75 0 01-.75.75H3.25a.75.75 0 01-.75-.75V2.3a.75.75 0 01.75-.75H13v5.26a2.25 2.25 0 002.25 2.25h5.25V21.7z"
    }), $a5EUy.createElement("path", {
        d: "M6.37 8.6a.64.64 0 01.64.64v5.58l1.8-1.68a2.33 2.33 0 013.13 0l.62.58a1 1 0 00.82.26 1 1 0 00.71-.43l1.34-2.09a.64.64 0 011.08.69l-1.34 2.1a2.261 2.261 0 01-1.64 1 2.32 2.32 0 01-1.83-.59l-.62-.58a1 1 0 00-1.4 0l-2.67 2.49v1.65h9.62a.64.64 0 110 1.28H6.37a.64.64 0 01-.64-.64V9.24a.64.64 0 01.64-.64z"
    }));
});

});

parcelRegister("aLUNI", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $7d7a5aa31b8dfa0e$var$__assign = undefined && undefined.__assign || function() {
    $7d7a5aa31b8dfa0e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7d7a5aa31b8dfa0e$var$__assign.apply(this, arguments);
};
var $7d7a5aa31b8dfa0e$export$2da06534dde49690 = $a5EUy.forwardRef(function FilesCode(props, svgRef) {
    return $a5EUy.createElement("svg", $7d7a5aa31b8dfa0e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M21.34 6.59L15.5.71A2.25 2.25 0 0013.88 0H3.25A2.25 2.25 0 001 2.3v19.4A2.25 2.25 0 003.25 24h16.5A2.25 2.25 0 0022 21.7V8.18a2.25 2.25 0 00-.66-1.59zM14.5 1.86l5.69 5.69h-4.94a.75.75 0 01-.75-.74V1.86zm6 19.84a.75.75 0 01-.75.75H3.25a.75.75 0 01-.75-.75V2.3a.75.75 0 01.75-.75H13v5.26a2.25 2.25 0 002.25 2.25h5.25V21.7z"
    }), $a5EUy.createElement("path", {
        d: "M13.5 10.32a.68.68 0 000 1l2.91 2.91-2.91 2.87a.68.68 0 000 1 .67.67 0 001 0l3.39-3.39a.681.681 0 000-1l-3.39-3.39a.68.68 0 00-1 0zm-3.12 0a.68.68 0 00-1 0l-3.35 3.39a.68.68 0 000 1l3.39 3.39a.67.67 0 001 0 .681.681 0 000-1L7.5 14.19l2.91-2.91a.68.68 0 00-.03-.96z"
    }));
});

});

parcelRegister("izgdK", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $d84813fdb585ab1a$var$__assign = undefined && undefined.__assign || function() {
    $d84813fdb585ab1a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d84813fdb585ab1a$var$__assign.apply(this, arguments);
};
var $d84813fdb585ab1a$export$e3f95c4e98f5bc36 = $a5EUy.forwardRef(function FilesDatabase(props, svgRef) {
    return $a5EUy.createElement("svg", $d84813fdb585ab1a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M11.25 9.81a10 10 0 00-3.38.53 3.62 3.62 0 00-1.16.66 1.45 1.45 0 00-.53 1.06v4.5a1.45 1.45 0 00.54 1.08c.34.28.725.497 1.14.64a10 10 0 003.38.53 9.975 9.975 0 003.38-.53c.416-.143.802-.36 1.14-.64a1.45 1.45 0 00.54-1.08v-4.5a1.451 1.451 0 00-.51-1.06 3.62 3.62 0 00-1.16-.66 10 10 0 00-3.38-.53zm3.94 6.75s0 .1-.16.24a2.582 2.582 0 01-.79.43 8.86 8.86 0 01-3 .46 8.86 8.86 0 01-3-.46 2.58 2.58 0 01-.79-.43c-.16-.14-.16-.22-.16-.24v-.78c.182.095.369.179.56.25a10 10 0 003.38.53 10 10 0 003.4-.56 4.8 4.8 0 00.56-.25v.81zm0-2.25s0 .1-.16.24a2.58 2.58 0 01-.78.45 8.86 8.86 0 01-3 .46 8.86 8.86 0 01-3-.46 2.58 2.58 0 01-.79-.43c-.16-.14-.16-.22-.16-.24v-.78c.182.095.369.179.56.25a10 10 0 003.38.53 9.975 9.975 0 003.38-.53 4.76 4.76 0 00.56-.25l.01.76zm0-2.25s0 .09-.16.23a2.53 2.53 0 01-.8.44 8.909 8.909 0 01-3 .46 8.909 8.909 0 01-3-.46 2.528 2.528 0 01-.8-.44c-.15-.14-.16-.22-.16-.23 0-.01 0-.09.16-.23a2.53 2.53 0 01.82-.43 8.909 8.909 0 013-.46 8.909 8.909 0 013 .46c.292.097.563.246.8.44.14.16.14.21.14.22z"
    }), $a5EUy.createElement("path", {
        d: "M21.35 6.59L15.47.71A2.25 2.25 0 0013.88 0H3.25A2.25 2.25 0 001 2.3v19.4A2.25 2.25 0 003.25 24h16.5A2.25 2.25 0 0022 21.75V8.18a2.25 2.25 0 00-.65-1.59zM14.5 1.86l5.69 5.69h-4.94a.75.75 0 01-.75-.75V1.86zm6 19.84a.75.75 0 01-.75.75H3.25a.75.75 0 01-.75-.75V2.3a.75.75 0 01.75-.75H13v5.26a2.25 2.25 0 002.25 2.25h5.25V21.7z"
    }));
});

});

parcelRegister("gZ892", function(module, exports) {

$parcel$export(module.exports, "FilesPdf", function () { return $c5d8a9386779c45b$export$c1715d484b9fa172; });

var $a5EUy = parcelRequire("a5EUy");
var $c5d8a9386779c45b$var$__assign = undefined && undefined.__assign || function() {
    $c5d8a9386779c45b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c5d8a9386779c45b$var$__assign.apply(this, arguments);
};
var $c5d8a9386779c45b$export$c1715d484b9fa172 = $a5EUy.forwardRef(function FilesPdf(props, svgRef) {
    return $a5EUy.createElement("svg", $c5d8a9386779c45b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M2.25 1.494a.752.752 0 00-.75.747v19.418a.745.745 0 00.75.747h3c.414 0 .75.335.75.747a.748.748 0 01-.75.747h-3a2.255 2.255 0 01-1.591-.656A2.236 2.236 0 010 21.659V2.241C0 1.646.237 1.076.659.656 1.081.236 1.653 0 2.25 0h10.629a2.26 2.26 0 011.592.657l5.87 5.847A2.24 2.24 0 0121 8.088v4.609a.748.748 0 01-.75.747.748.748 0 01-.75-.747V8.963h-5.25a2.255 2.255 0 01-1.591-.657A2.236 2.236 0 0112 6.722V1.494H2.25zM13.5 6.722V1.803l5.69 5.666h-4.94a.751.751 0 01-.75-.747z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M8.25 14.935a.748.748 0 00-.75.747v7.47c0 .412.336.746.75.746s.75-.334.75-.747v-2.24h.004c.796 0 1.559-.315 2.121-.876a2.981 2.981 0 000-4.225 3.006 3.006 0 00-2.121-.875H8.25zM9 16.43v2.988h.004a1.5 1.5 0 001.06-.438 1.49 1.49 0 000-2.112 1.503 1.503 0 00-1.06-.438H9zm5.25-1.495a.748.748 0 00-.75.747v7.47a.745.745 0 00.75.746c.995 0 1.948-.393 2.652-1.094A3.727 3.727 0 0018 20.164V18.67c0-.99-.395-1.94-1.098-2.64a3.758 3.758 0 00-2.652-1.095zm.75 7.341v-5.719a2.25 2.25 0 011.5 2.113v1.494a2.236 2.236 0 01-1.5 2.112z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M21.75 16.43a.751.751 0 00-.75.746v2.24h1.5a.748.748 0 110 1.494H21v2.241a.748.748 0 01-.75.747.748.748 0 01-.75-.747v-5.975c0-.594.237-1.164.659-1.584.422-.42.994-.657 1.591-.657h1.5c.414 0 .75.335.75.747a.748.748 0 01-.75.747h-1.5z"
    }));
});

});

parcelRegister("1m5O6", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $0fcc59b392f13413$var$__assign = undefined && undefined.__assign || function() {
    $0fcc59b392f13413$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0fcc59b392f13413$var$__assign.apply(this, arguments);
};
var $0fcc59b392f13413$export$5787518a8920ddc6 = $a5EUy.forwardRef(function FilesPtt(props, svgRef) {
    return $a5EUy.createElement("svg", $0fcc59b392f13413$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M1.72 1.712a.752.752 0 01.53-.218H12v5.228c0 .594.237 1.164.659 1.584.422.42.994.657 1.591.657h5.25v3.734a.749.749 0 001.5 0V8.088a2.233 2.233 0 00-.659-1.584L14.471.657A2.251 2.251 0 0012.879 0H2.25C1.653 0 1.081.236.659.656.237 1.076 0 1.646 0 2.241v19.418c0 .595.237 1.165.659 1.585.422.42.994.656 1.591.656h3c.414 0 .75-.334.75-.747a.748.748 0 00-.75-.747h-3a.751.751 0 01-.75-.747V2.241c0-.198.079-.388.22-.529zm11.78.091v4.919a.745.745 0 00.75.747h4.94L13.5 1.803z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M7.499 15.748a.75.75 0 01.75-.75H9a3 3 0 010 6h-.001v2.25a.75.75 0 01-1.5 0v-7.5zm1.5 3.75v-3H9a1.5 1.5 0 110 3h-.001zm5.25-4.5H15a3 3 0 010 6h-.001v2.25a.75.75 0 01-1.5 0v-7.5a.75.75 0 01.75-.75zm.75 1.5H15a1.5 1.5 0 110 3h-.001v-3z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M23.249 16.498h-.75v6.75a.75.75 0 01-1.5 0v-6.75h-.75a.75.75 0 010-1.5h3a.75.75 0 010 1.5z"
    }));
});

});

parcelRegister("7Ei12", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $591a3e67fec606d8$var$__assign = undefined && undefined.__assign || function() {
    $591a3e67fec606d8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $591a3e67fec606d8$var$__assign.apply(this, arguments);
};
var $591a3e67fec606d8$export$4f1e1e7a399aeb90 = $a5EUy.forwardRef(function FilesQueryFile(props, svgRef) {
    return $a5EUy.createElement("svg", $591a3e67fec606d8$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M22.34 6.59L16.47.71A2.25 2.25 0 0014.88 0H4.22A2.25 2.25 0 002 2.3v19.4A2.25 2.25 0 004.22 24h16.5a2.25 2.25 0 002.25-2.25V8.18a2.25 2.25 0 00-.63-1.59zM15.5 1.86l5.72 5.7h-5a.75.75 0 01-.75-.75l.03-4.95zm6 19.84a.75.75 0 01-.75.75H4.22a.75.75 0 01-.75-.75V2.3a.75.75 0 01.75-.75h9.75v5.26a2.25 2.25 0 002.25 2.25h5.25l.03 12.64z"
    }), $a5EUy.createElement("path", {
        d: "M16.34 11.75a1.84 1.84 0 00-1.93-1.69h-.61a.64.64 0 100 1.28h.69a.58.58 0 01.6.5v1.05a1.73 1.73 0 00.89 1.46l.38.22-.39.2a1.7 1.7 0 00-.89 1.46v1.05a.57.57 0 01-.6.5h-.69a.64.64 0 100 1.28h.72a1.83 1.83 0 001.82-1.69v-1.09a.42.42 0 01.23-.36l1.34-.77a.63.63 0 00.32-.55.61.61 0 00-.31-.57l-1.34-.77a.46.46 0 01-.23-.37v-1.14zm-8.238-.057a1.84 1.84 0 011.93-1.69h.61a.64.64 0 110 1.28h-.69a.58.58 0 00-.6.5v1.05a1.73 1.73 0 01-.89 1.46l-.38.22.39.2a1.7 1.7 0 01.89 1.46v1.05a.57.57 0 00.6.5h.69a.64.64 0 110 1.28h-.72a1.83 1.83 0 01-1.82-1.69v-1.09a.42.42 0 00-.23-.36l-1.34-.77a.63.63 0 01-.32-.55.61.61 0 01.31-.57l1.34-.77a.46.46 0 00.23-.37v-1.14z"
    }));
});

});

parcelRegister("SFBS5", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $0a45521afe6c31e3$var$__assign = undefined && undefined.__assign || function() {
    $0a45521afe6c31e3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0a45521afe6c31e3$var$__assign.apply(this, arguments);
};
var $0a45521afe6c31e3$export$7eb16584d50da272 = $a5EUy.forwardRef(function FilesToDo(props, svgRef) {
    return $a5EUy.createElement("svg", $0a45521afe6c31e3$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M10.12 9.027a.75.75 0 01.149 1.05l-2.132 2.845a1.5 1.5 0 01-2.26.16L4.72 11.927a.751.751 0 011.06-1.062l1.157 1.157L9.07 9.177a.75.75 0 011.05-.15zm.149 7.806a.751.751 0 00-1.2-.9l-2.132 2.844-1.157-1.158a.75.75 0 10-1.06 1.061l1.157 1.158a1.5 1.5 0 002.26-.16l2.132-2.845zM12 12.772a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75zm.75 5.254a.75.75 0 000 1.502h4.5a.75.75 0 000-1.502h-4.5z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M22.5 21.66a2.253 2.253 0 01-2.25 2.251H3.75a2.25 2.25 0 01-2.25-2.252V2.263A2.253 2.253 0 013.75.01h10.629a2.25 2.25 0 011.59.659l5.873 5.877c.421.423.658.995.658 1.592v13.52zM3.22 1.731a.75.75 0 01.53-.22h9.75v5.255a2.253 2.253 0 002.25 2.252H21v12.64a.75.75 0 01-.75.75H3.75a.75.75 0 01-.75-.75V2.263c0-.2.079-.39.22-.53zm17.47 5.785h-4.94a.75.75 0 01-.75-.75V1.823l5.69 5.694z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("e3pzM", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $a3b52f5e0c6c9116$var$__assign = undefined && undefined.__assign || function() {
    $a3b52f5e0c6c9116$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a3b52f5e0c6c9116$var$__assign.apply(this, arguments);
};
var $a3b52f5e0c6c9116$export$10b5cda80b0293f5 = $a5EUy.forwardRef(function FilesWord(props, svgRef) {
    return $a5EUy.createElement("svg", $a3b52f5e0c6c9116$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M1.72 1.712a.752.752 0 01.53-.218H12v5.228c0 .594.237 1.164.659 1.584.422.42.994.657 1.591.657h5.25v3.734a.749.749 0 001.5 0V8.088a2.233 2.233 0 00-.659-1.584L14.471.657A2.251 2.251 0 0012.879 0H2.25C1.653 0 1.081.236.659.656.237 1.076 0 1.646 0 2.241v19.418c0 .595.237 1.165.659 1.585.422.42.994.656 1.591.656h3c.414 0 .75-.334.75-.747a.748.748 0 00-.75-.747h-3a.751.751 0 01-.75-.747V2.241c0-.198.079-.388.22-.529zm11.78.091v4.919a.745.745 0 00.75.747h4.94L13.5 1.803z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M8.247 14.998a.75.75 0 00-.75.75v7.5a.75.75 0 00.75.75 3.75 3.75 0 003.75-3.75v-1.5a3.75 3.75 0 00-3.75-3.75zm.75 7.371v-5.742a2.249 2.249 0 011.5 2.121v1.5a2.25 2.25 0 01-1.5 2.121zm5.159-6.712a2.25 2.25 0 013.841 1.591v4.5a2.25 2.25 0 01-4.5 0v-4.5c0-.597.237-1.169.66-1.591zm1.591.841a.75.75 0 00-.75.75v4.5a.75.75 0 101.5 0v-4.5a.75.75 0 00-.75-.75z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M20.595 16.096a3.75 3.75 0 012.652-1.098.75.75 0 010 1.5 2.25 2.25 0 00-2.25 2.25v1.5a2.25 2.25 0 002.25 2.25.75.75 0 010 1.5 3.75 3.75 0 01-3.75-3.75v-1.5a3.75 3.75 0 011.098-2.652z"
    }));
});

});

parcelRegister("kUQJ5", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $f3a1efee17076f46$var$__assign = undefined && undefined.__assign || function() {
    $f3a1efee17076f46$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f3a1efee17076f46$var$__assign.apply(this, arguments);
};
var $f3a1efee17076f46$export$7a3d1a91ed30f8c1 = $a5EUy.forwardRef(function FilesXls(props, svgRef) {
    return $a5EUy.createElement("svg", $f3a1efee17076f46$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M1.72 1.712a.752.752 0 01.53-.218H12v5.228c0 .594.237 1.164.659 1.584.422.42.994.657 1.591.657h5.25v3.734a.749.749 0 001.5 0V8.088a2.233 2.233 0 00-.659-1.584L14.471.657A2.251 2.251 0 0012.879 0H2.25C1.653 0 1.081.236.659.656.237 1.076 0 1.646 0 2.241v19.418c0 .595.237 1.165.659 1.585.422.42.994.656 1.591.656h3c.414 0 .75-.334.75-.747a.748.748 0 00-.75-.747h-3a.751.751 0 01-.75-.747V2.241c0-.198.079-.388.22-.529zm11.78.091v4.919a.745.745 0 00.75.747h4.94L13.5 1.803z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M16.74 22.491h-1.51a.761.761 0 01-.754-.754v-6a.761.761 0 00-.755-.754.761.761 0 00-.754.754v6a2.253 2.253 0 002.246 2.246h1.508a.76.76 0 00.755-.754.732.732 0 00-.737-.738zm-5.726-7.44a.758.758 0 00-.977.412l-.789 2.023-.805-2.006a.752.752 0 00-.978-.411.752.752 0 00-.411.977l1.389 3.463-1.389 3.462a.758.758 0 00.411.978.752.752 0 00.977-.429l.806-2.006.806 2.006a.76.76 0 00.977.429.752.752 0 00.412-.978l-1.389-3.462 1.389-3.463a.765.765 0 00-.429-.995zm9.48 2.195c0 .703.428 1.063 1.2 1.645l.038.03c.799.611 1.762 1.348 1.762 2.816a2.253 2.253 0 01-2.246 2.246H19.74a.761.761 0 01-.755-.754c0-.412.343-.755.755-.755h1.508a.761.761 0 00.755-.754c0-.703-.429-1.063-1.2-1.646l-.006-.004c-.805-.599-1.794-1.336-1.794-2.841a2.253 2.253 0 012.245-2.246h1.509c.411 0 .754.343.754.754a.76.76 0 01-.754.754h-1.509a.761.761 0 00-.754.755z"
    }));
});

});

parcelRegister("7Rpng", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $5b912a6e1fb116c3$var$__assign = undefined && undefined.__assign || function() {
    $5b912a6e1fb116c3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5b912a6e1fb116c3$var$__assign.apply(this, arguments);
};
var $5b912a6e1fb116c3$export$ec91da630f36d5ea = $a5EUy.forwardRef(function Filter(props, svgRef) {
    return $a5EUy.createElement("svg", $5b912a6e1fb116c3$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M23.571 1.029a1.495 1.495 0 00-1.028-.515H1.49C1.097.514.72.67.446.96A1.436 1.436 0 000 2.023v.103c.377 5.143 4.029 9.48 8.966 10.765v9.275c0 .394.154.771.445 1.063.292.291.652.445 1.063.445.343 0 .686-.12.96-.343l3-2.502c.343-.292.549-.703.549-1.149v-6.806c4.954-1.285 8.606-5.623 8.966-10.765a1.47 1.47 0 00-.378-1.08zm-9.497 10.525a.754.754 0 00-.6.737v7.372l-3 2.503V12.29a.754.754 0 00-.6-.737c-4.594-.943-8.04-4.868-8.383-9.531H22.44c-.326 4.663-3.771 8.588-8.366 9.531z"
    }));
});

});

parcelRegister("lFVYP", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $fc7a66ef911b02ab$var$__assign = undefined && undefined.__assign || function() {
    $fc7a66ef911b02ab$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fc7a66ef911b02ab$var$__assign.apply(this, arguments);
};
var $fc7a66ef911b02ab$export$12f6556880dd4f70 = $a5EUy.forwardRef(function FilterBold(props, svgRef) {
    return $a5EUy.createElement("svg", $fc7a66ef911b02ab$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M23.571 1.029a1.495 1.495 0 00-1.028-.515H1.49C1.097.514.72.67.446.96A1.436 1.436 0 000 2.023v.103c.377 5.143 4.029 9.48 8.966 10.765v9.275c0 .394.154.771.445 1.063.292.291.652.445 1.063.445.343 0 .686-.12.96-.343l3-2.502c.343-.292.549-.703.549-1.149v-6.806c4.954-1.285 8.606-5.623 8.966-10.765a1.47 1.47 0 00-.378-1.08z"
    }));
});

});

parcelRegister("1k6wg", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $0f6cb753b6fad1ee$var$__assign = undefined && undefined.__assign || function() {
    $0f6cb753b6fad1ee$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0f6cb753b6fad1ee$var$__assign.apply(this, arguments);
};
var $0f6cb753b6fad1ee$export$630b74b270eecb49 = $a5EUy.forwardRef(function GraphBar(props, svgRef) {
    return $a5EUy.createElement("svg", $0f6cb753b6fad1ee$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 25 24",
        width: 25
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M21.751 0a2.25 2.25 0 00-2.22 2.612L16.79 4.754a2.25 2.25 0 00-2.87.69l-3.42-.915v-.028a2.25 2.25 0 10-4.463.406l-3.384 3.38a2.25 2.25 0 101.336.786l2.835-2.832a2.25 2.25 0 003.154-.299l3.527.944a2.25 2.25 0 104.31-1.03l2.451-1.916A2.25 2.25 0 1021.751 0zM2.542 9.81l.032.015a.75.75 0 11-.032-.015zm18.679-8.09a.75.75 0 111.06 1.06.75.75 0 01-1.06-1.06zM7.564 4.804l.006.014a.75.75 0 10-.006-.014zM15.75 6a.75.75 0 100 1.5.75.75 0 000-1.5z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M9 22.5V10.25A1.25 1.25 0 0110.25 9h2.751a1.25 1.25 0 011.25 1.25V22.5h2.25v-7.75a1.25 1.25 0 011.247-1.25h2.754a1.25 1.25 0 011.25 1.25v7.75h.749a.75.75 0 010 1.5H.75a.75.75 0 010-1.5h.75v-3.25A1.25 1.25 0 012.75 18h2.751a1.25 1.25 0 011.25 1.25v3.25H9zm1.5 0v-12h2.251v12H10.5zm9.751 0h-2.25V15h2.25v7.5zM3 19.5v3h2.251v-3H3z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("a1vPt", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $74c2affc92a8f692$var$__assign = undefined && undefined.__assign || function() {
    $74c2affc92a8f692$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $74c2affc92a8f692$var$__assign.apply(this, arguments);
};
var $74c2affc92a8f692$export$357400b174a17c2b = $a5EUy.forwardRef(function HardDrive(props, svgRef) {
    return $a5EUy.createElement("svg", $74c2affc92a8f692$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M18.375 16.875a1.125 1.125 0 100 2.25 1.125 1.125 0 000-2.25zm.208 1.437a.378.378 0 01-.281.056.376.376 0 11.281-.056z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M5.25 17.25a.75.75 0 000 1.5H9a.75.75 0 000-1.5H5.25z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M6.878.75h10.245a3.75 3.75 0 013.65 2.894L23.85 16.75a5.249 5.249 0 01-5.099 6.5H5.25a5.25 5.25 0 01-5.1-6.5L3.228 3.645A3.75 3.75 0 016.878.75zm15.523 16.394l-.01-.042a3.75 3.75 0 00-3.641-2.852H5.25a3.75 3.75 0 00-3.64 2.852l-.01.042a3.75 3.75 0 003.65 4.606h13.5a3.75 3.75 0 003.655-4.589l-.004-.017zM19.313 3.986l2.248 9.58a5.25 5.25 0 00-2.811-.816H5.25a5.25 5.25 0 00-2.811.816l2.248-9.58A2.25 2.25 0 016.878 2.25h10.245a2.25 2.25 0 012.19 1.736z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("lLVPy", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $fd9ad8b1f734b348$var$__assign = undefined && undefined.__assign || function() {
    $fd9ad8b1f734b348$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fd9ad8b1f734b348$var$__assign.apply(this, arguments);
};
var $fd9ad8b1f734b348$export$84202caead5689ba = $a5EUy.forwardRef(function History(props, svgRef) {
    return $a5EUy.createElement("svg", $fd9ad8b1f734b348$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M17.987 10.535v-.788h1.508a.76.76 0 00.753-.753.76.76 0 00-.753-.754h-4.506a.76.76 0 00-.754.754.76.76 0 00.754.753h1.508v.788c-3.375.377-5.996 3.238-5.996 6.698 0 3.718 3.032 6.75 6.75 6.75 3.717 0 6.749-3.032 6.749-6.75a6.78 6.78 0 00-6.013-6.698zm-.754 11.94a5.242 5.242 0 110-10.484 5.242 5.242 0 010 10.484z"
    }), $a5EUy.createElement("path", {
        d: "M19.272 17.233h-1.285v-2.998a.76.76 0 00-.754-.753.76.76 0 00-.753.754v3.751a.76.76 0 00.753.754h2.039a.76.76 0 00.754-.754.76.76 0 00-.754-.754zM8.24 15.743H1.884a.38.38 0 01-.377-.377V5.242h17.234v.754a.76.76 0 00.754.753.76.76 0 00.753-.753V1.867C20.231.84 19.392 0 18.381 0H1.884A1.864 1.864 0 000 1.867v13.516a1.898 1.898 0 001.884 1.867h6.373a.76.76 0 00.754-.753c0-.411-.36-.754-.771-.754zM1.867 1.507h16.48c.205 0 .377.172.377.36v1.885H1.507V1.867c0-.205.155-.36.36-.36z"
    }));
});

});

parcelRegister("k72wy", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $ea466b51fad19fc9$var$__assign = undefined && undefined.__assign || function() {
    $ea466b51fad19fc9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ea466b51fad19fc9$var$__assign.apply(this, arguments);
};
var $ea466b51fad19fc9$export$e3e58178368f2952 = $a5EUy.forwardRef(function HistoryBold(props, svgRef) {
    return $a5EUy.createElement("svg", $ea466b51fad19fc9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M11.014 19.833A6.75 6.75 0 0017.25 24 6.758 6.758 0 0024 17.251a6.75 6.75 0 10-12.986 2.582zM12.5 17.25a4.75 4.75 0 119.5 0 4.75 4.75 0 01-9.5 0z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M19.25 18.251h-2a1 1 0 01-1-1v-2.5a1 1 0 112 0V16c0 .138.112.25.25.25h.75a1 1 0 110 2.001z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M8.3 18.5a.968.968 0 01.946.722l.004.022A1 1 0 018.3 20.5H3a3 3 0 01-3-3V3a3 3 0 013-3h18a3 3 0 013 3v7.049a.983.983 0 01-1.59.777l-.022-.018a1 1 0 01-.388-.777V5.25a.25.25 0 00-.25-.25H2.25a.25.25 0 00-.25.251V17.5a1 1 0 001 1h5.3zm2.2-17a.966.966 0 00-.846.5.969.969 0 00-.154.5c.005.178.058.35.154.5a.966.966 0 001.692 0 .972.972 0 00.154-.5.969.969 0 00-.154-.5.966.966 0 00-.846-.5zM6.154 2a.966.966 0 011.692 0A.97.97 0 018 2.5a.972.972 0 01-.154.5.966.966 0 01-1.692 0A.972.972 0 016 2.5a.969.969 0 01.154-.5zM3.5 1.5a1 1 0 00-.908.591.992.992 0 00-.092.409c.005.178.058.35.154.5a.966.966 0 001.692 0 .972.972 0 00.154-.5.97.97 0 00-.154-.5.983.983 0 00-.846-.5z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("39dP1", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $24acef1a8f29cfdf$var$__assign = undefined && undefined.__assign || function() {
    $24acef1a8f29cfdf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $24acef1a8f29cfdf$var$__assign.apply(this, arguments);
};
var $24acef1a8f29cfdf$export$b94310965bed44e6 = $a5EUy.forwardRef(function Home(props, svgRef) {
    return $a5EUy.createElement("svg", $24acef1a8f29cfdf$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M4.516 13.37c.388 0 .703.316.703.704v7.031h4.218v-4.922a2.11 2.11 0 012.11-2.11h1.406a2.11 2.11 0 012.11 2.11v4.922h4.218v-7.031a.703.703 0 011.407 0v7.734a.703.703 0 01-.704.703H14.36a.703.703 0 01-.703-.703v-5.625a.703.703 0 00-.703-.703h-1.406a.703.703 0 00-.703.703v5.625a.703.703 0 01-.703.703H4.516a.703.703 0 01-.704-.703v-7.734c0-.389.315-.703.704-.703z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M12.25 3.406a.703.703 0 00-.497.206L2.2 13.165a.703.703 0 11-.994-.995l9.552-9.552a2.11 2.11 0 012.984 0l9.552 9.552a.703.703 0 01-.994.995l-9.553-9.553a.703.703 0 00-.497-.206z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("eFIEm", function(module, exports) {

$parcel$export(module.exports, "HomeBold", function () { return $aae787931ac39e47$export$611e0072bc063769; });

var $a5EUy = parcelRequire("a5EUy");
var $aae787931ac39e47$var$__assign = undefined && undefined.__assign || function() {
    $aae787931ac39e47$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $aae787931ac39e47$var$__assign.apply(this, arguments);
};
var $aae787931ac39e47$export$611e0072bc063769 = $a5EUy.forwardRef(function HomeBold(props, svgRef) {
    return $a5EUy.createElement("svg", $aae787931ac39e47$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M22.933 11.288l-9.55-9.56a2.48 2.48 0 00-3.51 0l-9.56 9.56a1.08 1.08 0 00.76 1.84h1.73v8.06a1.08 1.08 0 001.08 1.08h4.63a1.08 1.08 0 001.11-1.08v-5.63a.33.33 0 01.33-.33h3.37a.33.33 0 01.33.33v5.63a1.08 1.08 0 001.08 1.08h4.63a1.08 1.08 0 001.08-1.08v-8.06h1.76a1.08 1.08 0 00.73-1.84z"
    }));
});

});

parcelRegister("gZ3ah", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $c5d4cc4bf7a2be24$var$__assign = undefined && undefined.__assign || function() {
    $c5d4cc4bf7a2be24$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c5d4cc4bf7a2be24$var$__assign.apply(this, arguments);
};
var $c5d4cc4bf7a2be24$export$25513f6e9c35561f = $a5EUy.forwardRef(function HumanResourcesOfferMan(props, svgRef) {
    return $a5EUy.createElement("svg", $c5d4cc4bf7a2be24$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("g", {
        clipPath: "url(#human-resources-offer-man_svg__human-resources-offer-man_svg__clip0)"
    }, $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M16.865 0a4.875 4.875 0 100 9.75 4.875 4.875 0 000-9.75zm0 1.5a3.375 3.375 0 110 6.75 3.375 3.375 0 010-6.75zM.749 13.5a.75.75 0 01.743.648l.007.102V15H6a3.752 3.752 0 013.624 2.784l.05.216h3.075a3.75 3.75 0 013.745 3.55l.005.2a.75.75 0 01-.648.743l-.102.007H1.499v.75a.75.75 0 01-1.493.102l-.007-.102v-9a.75.75 0 01.75-.75zm.75 7.5v-4.5H6l.154.005A2.252 2.252 0 018.122 18H5.999l-.102.007A.75.75 0 006 19.5h6.75l.154.005a2.251 2.251 0 011.92 1.37l.047.125H1.499z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M23.937 14.75a7.502 7.502 0 00-14.144 0 .75.75 0 001.414.5 6.002 6.002 0 0111.316 0 .75.75 0 001.414-.5z"
    })), $a5EUy.createElement("defs", null, $a5EUy.createElement("clipPath", {
        id: "human-resources-offer-man_svg__human-resources-offer-man_svg__clip0"
    }, $a5EUy.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});

});

parcelRegister("jpvOM", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $e219088197143740$var$__assign = undefined && undefined.__assign || function() {
    $e219088197143740$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e219088197143740$var$__assign.apply(this, arguments);
};
var $e219088197143740$export$a853083deadc2998 = $a5EUy.forwardRef(function HumanResourcesOfferManBold(props, svgRef) {
    return $a5EUy.createElement("svg", $e219088197143740$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M21.728 4.503c0 1.958-1.653 3.545-3.692 3.545-2.04 0-3.692-1.587-3.692-3.545 0-1.957 1.653-3.544 3.692-3.544s3.692 1.587 3.692 3.544zm-3.692 4.834c-2.695 0-5.062 1.717-5.8 4.205a.235.235 0 00.04.21c.048.06.122.096.2.096h11.118a.253.253 0 00.2-.096.232.232 0 00.04-.21c-.738-2.487-3.104-4.203-5.798-4.205zM1.156 15.12c-.553 0-1 .43-1 .96v6.96c0 .53.447.96 1 .96.552 0 1-.43 1-.96v-6.96c0-.53-.448-.96-1-.96zm14.5 4.56H6.53a.613.613 0 01-.625-.6c0-.331.28-.6.625-.6h2.526c.336 0 .65-.162.835-.431a.927.927 0 00.085-.907c-.352-.79-1.162-1.303-2.057-1.302H3.656a.49.49 0 00-.5.48v6.24c0 .265.224.48.5.48H14.42c1.234-.002 2.235-.962 2.236-2.148v-.252c0-.53-.448-.96-1-.96z"
    }));
});

});

parcelRegister("6qMOO", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $4aeb0a1dbf52c556$var$__assign = undefined && undefined.__assign || function() {
    $4aeb0a1dbf52c556$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4aeb0a1dbf52c556$var$__assign.apply(this, arguments);
};
var $4aeb0a1dbf52c556$export$ad52482257e413dd = $a5EUy.forwardRef(function Ideas(props, svgRef) {
    return $a5EUy.createElement("svg", $4aeb0a1dbf52c556$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M12.75.75a.75.75 0 00-1.5 0v1.5a.75.75 0 001.5 0V.75z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M5.578 15.171a7.35 7.35 0 002.672 2.576V19.5a2.25 2.25 0 002.25 2.25h.75v1.5a.75.75 0 001.5 0v-1.5h.75a2.25 2.25 0 002.25-2.25v-1.753a7.35 7.35 0 003.75-6.507v-.003a7.624 7.624 0 00-7.513-7.487A7.623 7.623 0 004.5 11.241v.003a7.35 7.35 0 001.078 3.928zM13.5 20.25a.75.75 0 00.75-.75V18h-4.5v1.5a.75.75 0 00.75.75h3zM9.097 16.5h2.153v-2.69l-2.03-2.03a.75.75 0 111.06-1.06L12 12.44l1.72-1.72a.75.75 0 111.06 1.06l-2.03 2.03v2.69h2.153A5.85 5.85 0 0018 11.262a6.123 6.123 0 00-6-6.012 6.123 6.123 0 00-6 6.015A5.85 5.85 0 009.097 16.5z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M.75 11.25a.75.75 0 01.75-.75H3A.75.75 0 013 12H1.5a.75.75 0 01-.75-.75zm3.52-8.04a.75.75 0 00-1.04 1.08l1.1 1.058a.75.75 0 001.04-1.082L4.27 3.21zm15.98 8.04a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5H21a.75.75 0 01-.75-.75zm.52-6.96a.75.75 0 10-1.04-1.08l-1.1 1.056a.75.75 0 001.04 1.082l1.1-1.057z"
    }));
});

});

parcelRegister("46TEO", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $2fe2e552b1d1db9f$var$__assign = undefined && undefined.__assign || function() {
    $2fe2e552b1d1db9f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2fe2e552b1d1db9f$var$__assign.apply(this, arguments);
};
var $2fe2e552b1d1db9f$export$f7545e2d7d9761e3 = $a5EUy.forwardRef(function IdeasBold(props, svgRef) {
    return $a5EUy.createElement("svg", $2fe2e552b1d1db9f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("g", {
        clipPath: "url(#ideas-bold_svg__ideas-bold_svg__clip0)"
    }, $a5EUy.createElement("path", {
        d: "M12 3.75a7.62 7.62 0 00-7.5 7.49 7.35 7.35 0 003.75 6.5h7.5a7.35 7.35 0 003.75-6.51A7.62 7.62 0 0012 3.75zm-.75 12.75v-2.62L9.53 12.1c-.39-.39-.76-1-.37-1.38.39-.38.83-.3 1.22.09L12 12.44l1.48-1.53c.39-.39.91-.58 1.3-.19.39.39.23.83-.16 1.22l-1.87 1.87v2.69h-1.5zm-3 1.99v1a2.25 2.25 0 002.25 2.25h.5V23a1 1 0 00.66.93.68.68 0 00.67 0A1 1 0 0013 23v-1.25h.5a2.25 2.25 0 002.25-2.25v-1h-1.5l-6-.01zM12 3.35a1 1 0 001-1V1a1 1 0 00-2 0v1.4a1 1 0 001 .95zm8.92-.25a1 1 0 00-1.41 0l-1 1a1 1 0 101.38 1.44l1-1a1 1 0 00.03-1.44zM5.53 5.45A1 1 0 005.5 4l-1-1a1.033 1.033 0 10-1.4 1.52l1 1a1 1 0 001.41 0l.02-.07zm16.87 4.67H21a1 1 0 000 2h1.4a1 1 0 000-2zm-20.85.13a1 1 0 000 2H3a1 1 0 000-2H1.55z"
    })), $a5EUy.createElement("defs", null, $a5EUy.createElement("clipPath", {
        id: "ideas-bold_svg__ideas-bold_svg__clip0"
    }, $a5EUy.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});

});

parcelRegister("dD7mz", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $9ec4a10d2713ad36$var$__assign = undefined && undefined.__assign || function() {
    $9ec4a10d2713ad36$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9ec4a10d2713ad36$var$__assign.apply(this, arguments);
};
var $9ec4a10d2713ad36$export$bf44615096563be0 = $a5EUy.forwardRef(function LaptopSmiley(props, svgRef) {
    return $a5EUy.createElement("svg", $9ec4a10d2713ad36$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("g", {
        clipPath: "url(#laptop-smiley_svg__laptop-smiley_svg__clip0)"
    }, $a5EUy.createElement("path", {
        d: "M10.5 5.5a.75.75 0 00-1.5 0V7a.75.75 0 001.5 0V5.5zM8.755 9.47a.75.75 0 00-1.01 1.108 6.318 6.318 0 008.51 0 .75.75 0 10-1.01-1.108 4.818 4.818 0 01-6.49 0zm5.495-4.72a.75.75 0 01.75.75V7a.75.75 0 01-1.5 0V5.5a.75.75 0 01.75-.75zM10.5 17.5a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M4.5 1a2.25 2.25 0 00-2.25 2.25v11.087L.197 18.829l-.003.008A2.25 2.25 0 002.25 22h19.5a2.25 2.25 0 002.057-3.163l-2.057-4.5V3.25A2.25 2.25 0 0019.5 1h-15zm15.75 12.75H3.75V3.25a.75.75 0 01.75-.75h15a.75.75 0 01.75.75v10.5zM1.563 19.448l1.92-4.198h17.035l1.92 4.198a.75.75 0 01-.688 1.052H2.25a.75.75 0 01-.687-1.052z",
        fillRule: "evenodd"
    })), $a5EUy.createElement("defs", null, $a5EUy.createElement("clipPath", {
        id: "laptop-smiley_svg__laptop-smiley_svg__clip0"
    }, $a5EUy.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});

});

parcelRegister("1U9Sh", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $1632ae40d7b44ddc$var$__assign = undefined && undefined.__assign || function() {
    $1632ae40d7b44ddc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1632ae40d7b44ddc$var$__assign.apply(this, arguments);
};
var $1632ae40d7b44ddc$export$4574c7fd55cd3f3 = $a5EUy.forwardRef(function LayoutDiagram(props, svgRef) {
    return $a5EUy.createElement("svg", $1632ae40d7b44ddc$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M7.5.75A.75.75 0 018.25 0h7.5a.75.75 0 01.75.75v7.5a.75.75 0 01-.75.75h-3v3H18a2.25 2.25 0 012.25 2.25V15h3a.75.75 0 01.75.75v7.5a.75.75 0 01-.75.75h-7.5a.75.75 0 01-.75-.75v-7.5a.75.75 0 01.75-.75h3v-.75a.75.75 0 00-.75-.75H6a.75.75 0 00-.75.75V15h3a.75.75 0 01.75.75v7.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-7.5A.75.75 0 01.75 15h3v-.75A2.25 2.25 0 016 12h5.25V9h-3a.75.75 0 01-.75-.75V.75zM15 7.5v-6H9v6h6zm-13.5 9h6v6h-6v-6zm15 6v-6h6v6h-6z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("fi8Pj", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $b21f62397add6406$var$__assign = undefined && undefined.__assign || function() {
    $b21f62397add6406$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b21f62397add6406$var$__assign.apply(this, arguments);
};
var $b21f62397add6406$export$24a3cfb04e7f826e = $a5EUy.forwardRef(function LayoutDiagramBold(props, svgRef) {
    return $a5EUy.createElement("svg", $b21f62397add6406$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M8.25 0a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h2.625v2.625H6a2.625 2.625 0 00-2.625 2.625V15H.75a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h7.5a.75.75 0 00.75-.75v-7.5a.75.75 0 00-.75-.75H5.625v-.75A.375.375 0 016 13.875h12a.375.375 0 01.375.375V15H15.75a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h7.5a.75.75 0 00.75-.75v-7.5a.75.75 0 00-.75-.75h-2.625v-.75A2.625 2.625 0 0018 11.625h-4.875V9h2.625a.75.75 0 00.75-.75V.75a.75.75 0 00-.75-.75h-7.5z"
    }));
});

});

parcelRegister("jY6It", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $e898d49f5b31b7ad$var$__assign = undefined && undefined.__assign || function() {
    $e898d49f5b31b7ad$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e898d49f5b31b7ad$var$__assign.apply(this, arguments);
};
var $e898d49f5b31b7ad$export$f90ad0f3c590b2cb = $a5EUy.forwardRef(function LayoutGridView(props, svgRef) {
    return $a5EUy.createElement("svg", $e898d49f5b31b7ad$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .75A.75.75 0 01.75 0h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9A.75.75 0 010 9.75v-9zm1.5.75V9H9V1.5H1.5zM0 14.25a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9zm1.5.75v7.5H9V15H1.5zM13.5.75a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9zm1.5.75V9h7.5V1.5H15zm-1.5 12.75a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9zM15 15v7.5h7.5V15H15z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("juG9J", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $e31184f3aeca5a4a$var$__assign = undefined && undefined.__assign || function() {
    $e31184f3aeca5a4a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e31184f3aeca5a4a$var$__assign.apply(this, arguments);
};
var $e31184f3aeca5a4a$export$3eb98c9b2991c13c = $a5EUy.forwardRef(function LayoutGridViewBold(props, svgRef) {
    return $a5EUy.createElement("svg", $e31184f3aeca5a4a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .773a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v8.974a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75V.773zm0 13.474a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9zM13.5.773a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v8.974a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75V.773zm0 13.474a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("e7RhV", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $a48b0e0d027b7ab6$var$__assign = undefined && undefined.__assign || function() {
    $a48b0e0d027b7ab6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a48b0e0d027b7ab6$var$__assign.apply(this, arguments);
};
var $a48b0e0d027b7ab6$export$b73dd58f0dc7b9ee = $a5EUy.forwardRef(function LayoutList(props, svgRef) {
    return $a5EUy.createElement("svg", $a48b0e0d027b7ab6$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M3.66 2a2.66 2.66 0 100 5.32 2.66 2.66 0 000-5.32zm-.482 1.496a1.26 1.26 0 11.964 2.328 1.26 1.26 0 01-.964-2.328zM3.66 9.84a2.66 2.66 0 100 5.318 2.66 2.66 0 000-5.318zm-.482 1.496a1.26 1.26 0 11.964 2.329 1.26 1.26 0 01-.964-2.33zm-.536 6.546a2.661 2.661 0 013.475 3.476 2.66 2.66 0 11-3.475-3.476zM3.66 19.08a1.258 1.258 0 00-.891 2.15 1.26 1.26 0 10.891-2.15z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M8.233 4.613a.7.7 0 100 1.4H21.3a.7.7 0 100-1.4H8.233zm-.7 8.54a.7.7 0 01.7-.7H21.3a.7.7 0 110 1.4H8.233a.7.7 0 01-.7-.7zm.7 7.14a.7.7 0 100 1.4H21.3a.7.7 0 100-1.4H8.233z"
    }));
});

});

parcelRegister("6AChK", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $4cc3cd83b8998c45$var$__assign = undefined && undefined.__assign || function() {
    $4cc3cd83b8998c45$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4cc3cd83b8998c45$var$__assign.apply(this, arguments);
};
var $4cc3cd83b8998c45$export$8c8aefe5a4ba5254 = $a5EUy.forwardRef(function LayoutListBold(props, svgRef) {
    return $a5EUy.createElement("svg", $4cc3cd83b8998c45$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M3.13 1a3.13 3.13 0 100 6.26 3.13 3.13 0 000-6.26zm0 8.018a3.13 3.13 0 100 6.26 3.13 3.13 0 000-6.26zm-1.198 8.256a3.13 3.13 0 013.41 5.105 3.13 3.13 0 11-3.41-5.105zM8.761 3.298a1.5 1.5 0 000 3h13.364a1.5 1.5 0 100-3H8.761zm-1.5 9.518a1.5 1.5 0 011.5-1.5h13.364a1.5 1.5 0 110 3H8.761a1.5 1.5 0 01-1.5-1.5zm1.5 6.518a1.5 1.5 0 000 3h13.364a1.5 1.5 0 100-3H8.761z"
    }));
});

});

parcelRegister("a05Lj", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $747e5faf9cb8e030$var$__assign = undefined && undefined.__assign || function() {
    $747e5faf9cb8e030$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $747e5faf9cb8e030$var$__assign.apply(this, arguments);
};
var $747e5faf9cb8e030$export$d57cd6dbf45f4bdf = $a5EUy.forwardRef(function LayoutListView(props, svgRef) {
    return $a5EUy.createElement("svg", $747e5faf9cb8e030$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .75A.75.75 0 01.75 0h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75A.75.75 0 010 5.25V.75zm1.5.75v3h21v-3h-21zM0 9.75A.75.75 0 01.75 9h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-4.5zm1.5.75v3h21v-3h-21zM0 18.75A.75.75 0 01.75 18h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-4.5zm1.5.75v3h21v-3h-21z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("hBbA3", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $ccfee00135c54368$var$__assign = undefined && undefined.__assign || function() {
    $ccfee00135c54368$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ccfee00135c54368$var$__assign.apply(this, arguments);
};
var $ccfee00135c54368$export$faa3c8ce2462319b = $a5EUy.forwardRef(function LayoutListViewBold(props, svgRef) {
    return $a5EUy.createElement("svg", $ccfee00135c54368$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .75A.75.75 0 01.75 0h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75A.75.75 0 010 5.25V.75zm0 9A.75.75 0 01.75 9h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-4.5zm0 9A.75.75 0 01.75 18h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-4.5z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("ad6zA", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $76f03785f370d78f$var$__assign = undefined && undefined.__assign || function() {
    $76f03785f370d78f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $76f03785f370d78f$var$__assign.apply(this, arguments);
};
var $76f03785f370d78f$export$3c505bfe7119a36a = $a5EUy.forwardRef(function LearningLibrary(props, svgRef) {
    return $a5EUy.createElement("svg", $76f03785f370d78f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("g", {
        clipPath: "url(#learning-library_svg__learning-library_svg__clip0)"
    }, $a5EUy.createElement("path", {
        d: "M2.213 2.273l.183.005c3.703.192 6.703 1.053 8.547 2.339a.75.75 0 11-.858 1.23C8.496 4.74 5.762 3.954 2.304 3.775a.75.75 0 00-.797.648l-.007.104v13.356a.747.747 0 00.69.753c5.618.253 9.792 2.08 10.525 4.388a.75.75 0 01-1.392.549l-.038-.095c-.486-1.532-4.106-3.116-9.174-3.345a2.25 2.25 0 01-2.107-2.101L0 17.878V4.528a2.25 2.25 0 012.213-2.255z"
    }), $a5EUy.createElement("path", {
        d: "M23.25 8.25a.75.75 0 01.743.648L24 9v8.873a2.253 2.253 0 01-2.123 2.261c-4.938.223-8.507 1.74-9.123 3.237l-.04.107a.75.75 0 11-1.429-.454c.733-2.308 4.907-4.135 10.512-4.388a.75.75 0 00.697-.659l.006-.099V9a.75.75 0 01.75-.75zM3.852 6.728c1.96.22 3.889.67 5.745 1.34a.75.75 0 11-.51 1.41 23.688 23.688 0 00-5.403-1.26.75.75 0 01.066-1.495l.102.005zm.002 3.815a25.71 25.71 0 015.74 1.339.75.75 0 11-.505 1.412 24.267 24.267 0 00-5.407-1.26.75.75 0 01.07-1.496l.102.005zM3.7 14.582l.101.005a26 26 0 015.792 1.338.75.75 0 01-.502 1.414 24.496 24.496 0 00-5.458-1.262.75.75 0 01.066-1.495z"
    }), $a5EUy.createElement("path", {
        d: "M12 9.751a.75.75 0 01.743.648l.007.102v12.75a.75.75 0 01-1.493.102l-.007-.102v-12.75a.75.75 0 01.75-.75zm5.25-9.75a.75.75 0 01.743.648L18 .751v1.5a.75.75 0 01-1.493.102L16.5 2.25V.75a.75.75 0 01.75-.75zM11.909 2.69a.75.75 0 01.976-.072l.084.073 1.061 1.06a.75.75 0 01-.976 1.134l-.084-.073-1.061-1.06a.75.75 0 010-1.061zm9.621 0a.75.75 0 011.134.977l-.073.084-1.06 1.061a.75.75 0 01-1.134-.976l.073-.084 1.06-1.061zm-4.28 9.311a.75.75 0 01.743.648l.007.102v1.5a.75.75 0 01-1.493.102l-.007-.102v-1.5a.75.75 0 01.75-.75z"
    }), $a5EUy.createElement("path", {
        d: "M13.664 7.14a3.75 3.75 0 001.218 4.005l.118.091v1.515c0 .414.336.75.75.75h3l.102-.007a.75.75 0 00.648-.743v-1.514l.164-.129a3.75 3.75 0 10-5.936-4.16l-.064.192zm3.984-1.118a2.25 2.25 0 01.729 4.162l-.094.065a.75.75 0 00-.283.586v1.166h-1.5v-1.166a.75.75 0 00-.375-.65 2.25 2.25 0 011.523-4.163z"
    })), $a5EUy.createElement("defs", null, $a5EUy.createElement("clipPath", {
        id: "learning-library_svg__learning-library_svg__clip0"
    }, $a5EUy.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});

});

parcelRegister("9OcZA", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $7242dc991b57a9b7$var$__assign = undefined && undefined.__assign || function() {
    $7242dc991b57a9b7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7242dc991b57a9b7$var$__assign.apply(this, arguments);
};
var $7242dc991b57a9b7$export$cccceed87933e06f = $a5EUy.forwardRef(function LearningLibraryBold(props, svgRef) {
    return $a5EUy.createElement("svg", $7242dc991b57a9b7$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("g", {
        clipPath: "url(#learning-library-bold_svg__learning-library-bold_svg__clip0)"
    }, $a5EUy.createElement("path", {
        d: "M17.39 3.09a1 1 0 001-1v-1a1 1 0 10-2 0v1a1 1 0 001 1zm3.86 1.11a1 1 0 00.75-.35l.65-.77a1 1 0 00-1.52-1.28l-.65.76a1 1 0 00.76 1.65l.01-.01zm-8.48-.35a1 1 0 001.53-1.29l-.64-.76a1 1 0 00-1.53 1.29l.64.76zM23 7.47a1 1 0 00-1 1v9.83a18.159 18.159 0 00-9 2.6V6.11A1.31 1.31 0 0012.37 5c-.95-.58-5.94-3.43-11.26-2.56A1.32 1.32 0 000 3.74v15a1.32 1.32 0 001.21 1.32c3.55.29 8.21 1.33 9.65 3.32a1.33 1.33 0 001 .55h.09a1.29 1.29 0 00.93-.4c.68-.71 3.39-3 9.83-3.29a1.32 1.32 0 001.29-1.3V8.47a1 1 0 00-1-1zm-12.87 5.48a.79.79 0 01-1 .52 20.926 20.926 0 00-5.17-1 .82.82 0 01-.71-.9.81.81 0 01.86-.74c1.874.127 3.725.486 5.51 1.07a.83.83 0 01.51 1.05zm0 4a.79.79 0 01-1 .52 20.926 20.926 0 00-5.17-1 .82.82 0 01-.71-.9.81.81 0 01.86-.74c1.878.159 3.73.552 5.51 1.17a.83.83 0 01.51 1v-.05zM9.9 9.26a.78.78 0 01-.78.16 20.88 20.88 0 00-5.17-1 .84.84 0 01-.43-1.46.77.77 0 01.59-.18 22.63 22.63 0 015.51 1.08.82.82 0 01.53.62.84.84 0 01-.25.78z"
    }), $a5EUy.createElement("path", {
        d: "M15.25 10.89v1.22a.75.75 0 00.75.75h.5v.67a1 1 0 002 0v-.67h.6a.75.75 0 00.65-.74v-1.2a4 4 0 10-4.5 0v-.03zm.3-3.24a2 2 0 11.15.758 2 2 0 01-.15-.768v.01z"
    })), $a5EUy.createElement("defs", null, $a5EUy.createElement("clipPath", {
        id: "learning-library-bold_svg__learning-library-bold_svg__clip0"
    }, $a5EUy.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});

});

parcelRegister("hezql", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $c8bf38e9504e6abc$var$__assign = undefined && undefined.__assign || function() {
    $c8bf38e9504e6abc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c8bf38e9504e6abc$var$__assign.apply(this, arguments);
};
var $c8bf38e9504e6abc$export$5047665d7d511e82 = $a5EUy.forwardRef(function LevelIndicator(props, svgRef) {
    return $a5EUy.createElement("svg", $c8bf38e9504e6abc$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M12 3.771a11.961 11.961 0 00-8.52 3.6A12.054 12.054 0 000 15.943v2.074a2.253 2.253 0 002.246 2.245h19.508A2.253 2.253 0 0024 18.017v-2.074c.05-6.653-5.332-12.12-12-12.173zm-.017 12.754h.034a2.25 2.25 0 012.229 2.246H9.754a2.25 2.25 0 012.229-2.246zm10.525 1.492a.761.761 0 01-.754.754h-6c0-1.714-1.166-3.171-2.76-3.617l1.972-5.897a.736.736 0 00-.48-.943.736.736 0 00-.943.48l-2.092 6.274a3.761 3.761 0 00-3.188 3.703h-6a.761.761 0 01-.754-.754v-2.074A10.535 10.535 0 014.56 8.434 10.389 10.389 0 0112 5.28c5.828.034 10.543 4.817 10.508 10.663v2.074z"
    }), $a5EUy.createElement("path", {
        d: "M4.869 16.525a1.131 1.131 0 100-2.262 1.131 1.131 0 000 2.262zm1.508-6a1.13 1.13 0 100 2.263 1.12 1.12 0 001.132-1.131 1.13 1.13 0 00-1.132-1.132zm12.754 6a1.131 1.131 0 100-2.263 1.131 1.131 0 000 2.263zm-.377-4.868c0-.6-.48-1.097-1.08-1.114h-.12a1.138 1.138 0 00-1.063 1.114 1.13 1.13 0 102.263 0zM9.429 7.526c-.018 0-.018 0 0 0h-.12A1.138 1.138 0 008.246 8.64a1.13 1.13 0 001.131 1.13 1.12 1.12 0 001.131-1.131c0-.6-.497-1.097-1.08-1.114z"
    }));
});

});

parcelRegister("3vBbk", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $28e11be18c8fa491$var$__assign = undefined && undefined.__assign || function() {
    $28e11be18c8fa491$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $28e11be18c8fa491$var$__assign.apply(this, arguments);
};
var $28e11be18c8fa491$export$b0288941685426f5 = $a5EUy.forwardRef(function LevelIndicatorBold(props, svgRef) {
    return $a5EUy.createElement("svg", $28e11be18c8fa491$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M12 4C8.8 4 5.7 5.3 3.5 7.6 1.2 9.9 0 12.9 0 16.2v2.1c0 1.2 1 2.2 2.2 2.2h5.6c.5 0 .4-1 .4-1.5 0-1.9 1.4-3.4 3.2-3.7L13.5 9c.1-.4.5-.6.9-.5.4.1.6.5.5.9l-2 5.9c1.4.4 2.4 1.5 2.7 2.9 0 .2.1.5.1.7 0 .5-.3 1.5.5 1.5h5.5c1.2 0 2.2-1 2.2-2.2v-2.1C24.1 9.5 18.7 4.1 12 4zm7 7.9c0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4 0-.7.6-1.3 1.3-1.4h.1c.8 0 1.4.7 1.4 1.4zm.1 5.1c-.8 0-1.4-.6-1.4-1.4 0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4 0 .8-.6 1.4-1.4 1.4zM7 13.1c-.2.1-.4.2-.6.2-.8 0-1.4-.7-1.4-1.4 0-.8.6-1.4 1.4-1.4.2 0 .4.1.6.2.4.2.8.7.8 1.2s-.3 1-.8 1.2zm-2.1 1.1c.8 0 1.4.6 1.4 1.4 0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4 0-.7.6-1.4 1.4-1.4zm4.5-4c-.8 0-1.4-.6-1.4-1.3 0-.2.1-.4.2-.6.2-.4.6-.7 1.1-.7h.1c.5 0 .9.3 1.2.7.1.2.2.4.2.6 0 .7-.7 1.3-1.4 1.3z"
    }));
});

});

parcelRegister("32fPG", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $235dd70989e7896f$var$__assign = undefined && undefined.__assign || function() {
    $235dd70989e7896f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $235dd70989e7896f$var$__assign.apply(this, arguments);
};
var $235dd70989e7896f$export$a6c7ac8248d6e38a = $a5EUy.forwardRef(function Link(props, svgRef) {
    return $a5EUy.createElement("svg", $235dd70989e7896f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M22.2 4.3c-.9-.9-2-1.3-3.2-1.3-1.2 0-2.4.5-3.2 1.3-.3.3-.3.8 0 1.1.3.3.8.3 1.1 0 1.2-1.2 3.2-1.2 4.4 0 .4.6.7 1.4.7 2.2 0 .8-.3 1.6-.9 2.2l-5.6 5.6c-.5.5-1.3.9-2.1.9s-1.5-.2-2.1-.7c-.6-.5-1-1.2-1.1-2 0-.8.2-1.6.6-2.2.2-.3.2-.8-.2-1-.3-.2-.8-.2-1 .2-.7.9-1 2.1-.8 3.2.1 1.1.7 2.2 1.6 2.9.8.7 1.9 1.1 3 1.1h.2c1.2 0 2.2-.5 3.1-1.3l5.6-5.6c.9-.9 1.3-2 1.3-3.2 0-1.2-.6-2.5-1.4-3.4z"
    }), $a5EUy.createElement("path", {
        d: "M7.8 17.8c-1.2 1.2-3.2 1.2-4.4 0-.6-.6-.9-1.4-.9-2.2 0-.8.3-1.6.9-2.2L9 7.8c.5-.5 1.3-.8 2-.9.8 0 1.5.2 2.1.7.6.5 1 1.2 1.1 2 .1.8-.1 1.5-.6 2.2-.2.3-.2.8.2 1 .3.2.8.2 1-.2.7-.9 1-2.1.8-3.2-.1-1.1-.7-2.2-1.6-2.9-.9-.8-2-1.1-3.2-1.1-1 .1-2.1.6-2.9 1.4l-5.6 5.6c-.9.9-1.3 2-1.3 3.2 0 1.2.5 2.4 1.3 3.2.9.9 2 1.3 3.2 1.3 1.2 0 2.4-.5 3.2-1.3.3-.3.3-.8 0-1.1-.3-.3-.6-.2-.9.1z"
    }));
});

});

parcelRegister("3HEUC", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $2b251f95e10aa780$var$__assign = undefined && undefined.__assign || function() {
    $2b251f95e10aa780$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2b251f95e10aa780$var$__assign.apply(this, arguments);
};
var $2b251f95e10aa780$export$6343830e6ea0f555 = $a5EUy.forwardRef(function LinkBold(props, svgRef) {
    return $a5EUy.createElement("svg", $2b251f95e10aa780$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M17.02 6.183a2.331 2.331 0 113.297 3.297l-5.588 5.588a2.332 2.332 0 01-3.536-3.018 1.5 1.5 0 00-2.426-1.764 5.332 5.332 0 008.085 6.902l5.586-5.586a5.331 5.331 0 10-7.54-7.54 1.5 1.5 0 102.122 2.12z"
    }), $a5EUy.createElement("path", {
        d: "M6.98 17.506a2.332 2.332 0 01-3.297-3.298L9.27 8.62a2.332 2.332 0 013.536 3.019 1.5 1.5 0 002.426 1.764A5.331 5.331 0 007.148 6.5l-5.586 5.587a5.332 5.332 0 007.54 7.54 1.5 1.5 0 10-2.122-2.121z"
    }));
});

});

parcelRegister("hYF28", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $d167dea2c100c5fb$var$__assign = undefined && undefined.__assign || function() {
    $d167dea2c100c5fb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d167dea2c100c5fb$var$__assign.apply(this, arguments);
};
var $d167dea2c100c5fb$export$633fe2b1e4202809 = $a5EUy.forwardRef(function ListSearch(props, svgRef) {
    return $a5EUy.createElement("svg", $d167dea2c100c5fb$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M2.356 0h19.267a2.369 2.369 0 012.363 2.361v8.133a.75.75 0 01-1.5 0V5.997H1.5v12.625a.87.87 0 00.866.867H6.76a.75.75 0 010 1.499h-4.4A2.369 2.369 0 010 18.625V2.353A2.36 2.36 0 012.353 0h.003zm-.857 4.497h20.988V2.365a.87.87 0 00-.867-.866H2.357a.862.862 0 00-.858.858v2.14z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M17.643 12.835a.75.75 0 010 1.06l-2.998 2.998a.75.75 0 01-1.06 0l-1.5-1.499a.75.75 0 111.06-1.06l.97.97 2.468-2.469a.75.75 0 011.06 0z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M12.331 8.749a6.62 6.62 0 017.714 10.236l3.735 3.735a.75.75 0 11-1.06 1.06l-3.735-3.735a6.621 6.621 0 01-10.236-2.648 6.62 6.62 0 013.582-8.648zm2.533.995a5.121 5.121 0 100 10.242 5.121 5.121 0 000-10.242z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("i3pPH", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $d24c8bac9ee83e58$var$__assign = undefined && undefined.__assign || function() {
    $d24c8bac9ee83e58$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d24c8bac9ee83e58$var$__assign.apply(this, arguments);
};
var $d24c8bac9ee83e58$export$21cdcd57c45bce1 = $a5EUy.forwardRef(function ListSearchBold(props, svgRef) {
    return $a5EUy.createElement("svg", $d24c8bac9ee83e58$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M3 16.8h6.25c.552 0 1 .43 1 .96s-.448.96-1 .96H3c-1.657 0-3-1.29-3-2.88V2.88C0 1.29 1.343 0 3 0h15.5c1.657 0 3 1.29 3 2.88v6.48c0 .53-.448.96-1 .96s-1-.43-1-.96V7.2a.49.49 0 00-.5-.48H2.5a.49.49 0 00-.5.48v8.64c0 .53.448.96 1 .96zm8-13.44c0-.53-.448-.96-1-.96s-1 .43-1 .96.448.96 1 .96 1-.43 1-.96zM7 2.4c.552 0 1 .43 1 .96s-.448.96-1 .96-1-.43-1-.96.448-.96 1-.96zm-2 .96c0-.53-.448-.96-1-.96s-1 .43-1 .96.448.96 1 .96 1-.43 1-.96z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M21.64 19.15a.233.233 0 00.034.3l2.033 1.951a.934.934 0 01.259.927.981.981 0 01-.707.68 1.03 1.03 0 01-.966-.248l-2.033-1.953a.259.259 0 00-.311-.032c-2.367 1.445-5.487.95-7.242-1.151-1.755-2.1-1.583-5.132.4-7.036 1.983-1.905 5.14-2.072 7.33-.388 2.188 1.683 2.707 4.678 1.203 6.95zm-8.14-2.83c0 1.855 1.567 3.36 3.5 3.36s3.5-1.505 3.5-3.36c0-1.856-1.567-3.36-3.5-3.36s-3.5 1.504-3.5 3.36z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M10.528 8.697l-3.41 3.415a.255.255 0 01-.361 0l-.535-.536a1.026 1.026 0 00-.969-.286.983.983 0 00-.731.673.934.934 0 00.256.941l1.438 1.44c.189.189.45.296.721.296.273 0 .533-.107.722-.296l4.313-4.32a.934.934 0 00.256-.941.983.983 0 00-.732-.673c-.353-.08-.723.03-.968.287z"
    }));
});

});

parcelRegister("cSPeX", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $961246692068567b$var$__assign = undefined && undefined.__assign || function() {
    $961246692068567b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $961246692068567b$var$__assign.apply(this, arguments);
};
var $961246692068567b$export$18a2be9195644f38 = $a5EUy.forwardRef(function Location(props, svgRef) {
    return $a5EUy.createElement("svg", $961246692068567b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("g", {
        clipPath: "url(#location_svg__location_svg__clip0)",
        clipRule: "evenodd",
        fillRule: "evenodd"
    }, $a5EUy.createElement("path", {
        d: "M8.818 5.068a4.5 4.5 0 116.364 6.364 4.5 4.5 0 01-6.364-6.364zM12 5.25a3 3 0 100 6 3 3 0 000-6z"
    }), $a5EUy.createElement("path", {
        d: "M12 1.5a6.75 6.75 0 00-6.75 6.75c0 .706.273 1.77.772 3.08.49 1.287 1.167 2.732 1.907 4.169 1.48 2.874 3.184 5.665 4.071 7.001.887-1.336 2.591-4.127 4.071-7.001.74-1.438 1.417-2.883 1.907-4.17.499-1.308.772-2.373.772-3.079A6.75 6.75 0 0012 1.5zM12 0a8.25 8.25 0 00-8.25 8.25c0 .997.361 2.278.87 3.614.518 1.358 1.222 2.857 1.975 4.321 1.508 2.928 3.24 5.766 4.155 7.145a1.5 1.5 0 002.5 0c.914-1.379 2.647-4.217 4.155-7.145.753-1.463 1.457-2.963 1.975-4.321.509-1.336.87-2.617.87-3.614A8.25 8.25 0 0012 0z"
    })), $a5EUy.createElement("defs", null, $a5EUy.createElement("clipPath", {
        id: "location_svg__location_svg__clip0"
    }, $a5EUy.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});

});

parcelRegister("bBxEC", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $872d41702deda25f$var$__assign = undefined && undefined.__assign || function() {
    $872d41702deda25f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $872d41702deda25f$var$__assign.apply(this, arguments);
};
var $872d41702deda25f$export$d63fce71f4dc7df5 = $a5EUy.forwardRef(function LocationBold(props, svgRef) {
    return $a5EUy.createElement("svg", $872d41702deda25f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("g", {
        clipPath: "url(#location-bold_svg__location-bold_svg__clip0)"
    }, $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M6.166 2.416A8.25 8.25 0 0120.25 8.25c0 .997-.361 2.278-.87 3.614-.518 1.358-1.222 2.857-1.975 4.321-1.508 2.928-3.24 5.766-4.155 7.145a1.5 1.5 0 01-2.5 0c-.914-1.379-2.647-4.217-4.155-7.145-.753-1.463-1.457-2.963-1.975-4.321-.509-1.336-.87-2.617-.87-3.614a8.25 8.25 0 012.416-5.834zm3.536 8.132a3.25 3.25 0 114.596-4.596 3.25 3.25 0 01-4.596 4.596z",
        fillRule: "evenodd"
    })), $a5EUy.createElement("defs", null, $a5EUy.createElement("clipPath", {
        id: "location-bold_svg__location-bold_svg__clip0"
    }, $a5EUy.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});

});

parcelRegister("cZ9oF", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $9742788fdf03bc14$var$__assign = undefined && undefined.__assign || function() {
    $9742788fdf03bc14$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9742788fdf03bc14$var$__assign.apply(this, arguments);
};
var $9742788fdf03bc14$export$5b9db7ce80343746 = $a5EUy.forwardRef(function Lock(props, svgRef) {
    return $a5EUy.createElement("svg", $9742788fdf03bc14$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M12.75 14a.75.75 0 00-1.5 0v3a.75.75 0 001.5 0v-3z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M6 6v2H3.75a.75.75 0 00-.75.75v13.5c0 .414.336.75.75.75h16.5a.75.75 0 00.75-.75V8.75a.75.75 0 00-.75-.75H18V6A6 6 0 106 6zm6-4.5A4.5 4.5 0 007.5 6v2h9V6A4.5 4.5 0 0012 1.5zm-7.5 8h15v12h-15v-12z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("3L24I", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $2bc75eee4030f934$var$__assign = undefined && undefined.__assign || function() {
    $2bc75eee4030f934$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2bc75eee4030f934$var$__assign.apply(this, arguments);
};
var $2bc75eee4030f934$export$4038de8e7cd615d7 = $a5EUy.forwardRef(function LockBold(props, svgRef) {
    return $a5EUy.createElement("svg", $2bc75eee4030f934$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M12 .625A6.375 6.375 0 005.625 7v2H3.75a.75.75 0 00-.75.75v13.5c0 .414.336.75.75.75h16.5a.75.75 0 00.75-.75V9.75a.75.75 0 00-.75-.75h-1.875V7A6.375 6.375 0 0012 .625zM16.125 7v2h-8.25V7a4.125 4.125 0 018.25 0zm-5.25 8a1.125 1.125 0 012.25 0v3a1.125 1.125 0 01-2.25 0v-3z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("9fV8w", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $6bd1d5e1d1b11d41$var$__assign = undefined && undefined.__assign || function() {
    $6bd1d5e1d1b11d41$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6bd1d5e1d1b11d41$var$__assign.apply(this, arguments);
};
var $6bd1d5e1d1b11d41$export$88195aaac9f90319 = $a5EUy.forwardRef(function LogIn(props, svgRef) {
    return $a5EUy.createElement("svg", $6bd1d5e1d1b11d41$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M20.727 1.393h.037a2.09 2.09 0 011.985 2.165v16.769a2.09 2.09 0 01-2.022 2.164H9.235a2.09 2.09 0 01-1.985-2.164v-4.185a.75.75 0 011.5 0v4.2l-.001.033a.591.591 0 00.546.616h11.409a.591.591 0 00.545-.65V3.509a.59.59 0 00-.545-.615H9.295a.591.591 0 00-.545.65v4.2a.75.75 0 01-1.5 0V3.557a2.091 2.091 0 012.023-2.165h11.454z"
    }), $a5EUy.createElement("path", {
        d: "M12.169 7.916a.75.75 0 000 1.06l2.22 2.22H1.5a.75.75 0 000 1.5h12.888l-2.22 2.22a.75.75 0 001.062 1.06l3.496-3.496a.754.754 0 00.17-.81.747.747 0 00-.167-.254l-3.5-3.5a.75.75 0 00-1.06 0z"
    }));
});

});

parcelRegister("amnFV", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $78ae52e02c4aeac7$var$__assign = undefined && undefined.__assign || function() {
    $78ae52e02c4aeac7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $78ae52e02c4aeac7$var$__assign.apply(this, arguments);
};
var $78ae52e02c4aeac7$export$c9b57264511cea21 = $a5EUy.forwardRef(function LogInBold(props, svgRef) {
    return $a5EUy.createElement("svg", $78ae52e02c4aeac7$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M20.727.5a2.84 2.84 0 012.772 2.928V20.17a2.841 2.841 0 01-2.772 2.928H9.273c-.025 0-.05 0-.075-.002A2.841 2.841 0 016.5 20.17V18a1.5 1.5 0 013 0v2.099h10.999V3.5h-11V6a1.5 1.5 0 11-3 0V3.427A2.841 2.841 0 019.274.5h11.454z"
    }), $a5EUy.createElement("path", {
        d: "M11.639 7.243a1.5 1.5 0 000 2.12l.939.94H1.5a1.5 1.5 0 100 3h11.078l-.94.94a1.5 1.5 0 102.122 2.12l3.495-3.494a1.495 1.495 0 00.334-1.631 1.496 1.496 0 00-.33-.496l-3.5-3.5a1.5 1.5 0 00-2.12 0z"
    }));
});

});

parcelRegister("lVgvD", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $ff5bba3fc6b4d7ed$var$__assign = undefined && undefined.__assign || function() {
    $ff5bba3fc6b4d7ed$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ff5bba3fc6b4d7ed$var$__assign.apply(this, arguments);
};
var $ff5bba3fc6b4d7ed$export$f292abd37582246c = $a5EUy.forwardRef(function LogOut(props, svgRef) {
    return $a5EUy.createElement("svg", $ff5bba3fc6b4d7ed$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M21.507 2h.037A2.058 2.058 0 0123.5 4.133V20.5a2.06 2.06 0 01-1.992 2.132h-11.22A2.059 2.059 0 018.333 20.5v-4.084a.75.75 0 011.5 0v4.1a.56.56 0 00.515.617h11.136a.559.559 0 00.515-.617V4.082a.558.558 0 00-.515-.582H10.348a.56.56 0 00-.515.617v4.1a.75.75 0 11-1.5 0V4.131A2.06 2.06 0 0110.326 2h11.18z"
    }), $a5EUy.createElement("path", {
        d: "M5.697 8.373a.75.75 0 00-1.06 0l-3.41 3.41a.748.748 0 000 1.075l3.41 3.408a.75.75 0 101.06-1.06L3.56 13.07h12.538a.75.75 0 100-1.5H3.561l2.136-2.136a.75.75 0 000-1.061z"
    }));
});

});

parcelRegister("442h0", function(module, exports) {

$parcel$export(module.exports, "LogOutBold", function () { return $2f594c986da1fa6b$export$e2c9b76f2918cc76; });

var $a5EUy = parcelRequire("a5EUy");
var $2f594c986da1fa6b$var$__assign = undefined && undefined.__assign || function() {
    $2f594c986da1fa6b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2f594c986da1fa6b$var$__assign.apply(this, arguments);
};
var $2f594c986da1fa6b$export$e2c9b76f2918cc76 = $a5EUy.forwardRef(function LogOutBold(props, svgRef) {
    return $a5EUy.createElement("svg", $2f594c986da1fa6b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M21.257.75a2.808 2.808 0 012.742 2.894v16.344a2.809 2.809 0 01-2.742 2.894H10.076c-.025 0-.05 0-.075-.002a2.81 2.81 0 01-2.668-2.892V18a1.5 1.5 0 113 0v1.882h10.666V3.75H10.333V5.5a1.5 1.5 0 01-3 0V3.644A2.81 2.81 0 0110.076.75h11.18z"
    }), $a5EUy.createElement("path", {
        d: "M5.977 7.343a1.5 1.5 0 00-2.121 0L.45 10.749a1.5 1.5 0 000 2.142l3.406 3.406a1.5 1.5 0 102.121-2.122l-.856-.855H15.85a1.5 1.5 0 000-3H5.121l.856-.856a1.5 1.5 0 000-2.121z"
    }));
});

});

parcelRegister("586iM", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $3bc29682243200d3$var$__assign = undefined && undefined.__assign || function() {
    $3bc29682243200d3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3bc29682243200d3$var$__assign.apply(this, arguments);
};
var $3bc29682243200d3$export$2a4143257785f953 = $a5EUy.forwardRef(function MenuNavigationHorizontal(props, svgRef) {
    return $a5EUy.createElement("svg", $3bc29682243200d3$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M5.5 12a2 2 0 11-4 0 2 2 0 014 0zm8.5 0a2 2 0 11-4 0 2 2 0 014 0zm6.5 2a2 2 0 100-4 2 2 0 000 4z"
    }));
});

});

parcelRegister("6bKks", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $4817b51c48f6e9fd$var$__assign = undefined && undefined.__assign || function() {
    $4817b51c48f6e9fd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4817b51c48f6e9fd$var$__assign.apply(this, arguments);
};
var $4817b51c48f6e9fd$export$e01a035729e5e1c1 = $a5EUy.forwardRef(function MenuNavigationHorizontalBold(props, svgRef) {
    return $a5EUy.createElement("svg", $4817b51c48f6e9fd$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M6.5 12a3 3 0 11-6 0 3 3 0 016 0zm8.5 0a3 3 0 11-6 0 3 3 0 016 0zm5.5 3a3 3 0 100-6 3 3 0 000 6z"
    }));
});

});

parcelRegister("9PUm8", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $7294979a1da2838e$var$__assign = undefined && undefined.__assign || function() {
    $7294979a1da2838e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7294979a1da2838e$var$__assign.apply(this, arguments);
};
var $7294979a1da2838e$export$56dbed97f074c6e4 = $a5EUy.forwardRef(function MenuNavigationVertical(props, svgRef) {
    return $a5EUy.createElement("svg", $7294979a1da2838e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M21.75 16.903a1.1 1.1 0 01.12 2.194l-.12.006H2.25a1.1 1.1 0 01-.12-2.194l.12-.006h19.5zm0-6a1.1 1.1 0 01.12 2.194l-.12.006H2.25a1.1 1.1 0 01-.12-2.194l.12-.006h19.5zm0-6a1.1 1.1 0 01.12 2.194l-.12.006H2.25a1.1 1.1 0 01-.12-2.194l.12-.006h19.5z"
    }));
});

});

parcelRegister("kHr1J", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $f11cc9cae50b9203$var$__assign = undefined && undefined.__assign || function() {
    $f11cc9cae50b9203$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f11cc9cae50b9203$var$__assign.apply(this, arguments);
};
var $f11cc9cae50b9203$export$e738f441fd7fb6d9 = $a5EUy.forwardRef(function MenuNavigationVerticalBold(props, svgRef) {
    return $a5EUy.createElement("svg", $f11cc9cae50b9203$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M1 6.5A1.5 1.5 0 012.5 5h19a1.5 1.5 0 010 3h-19A1.5 1.5 0 011 6.5zm0 6A1.5 1.5 0 012.5 11h19a1.5 1.5 0 010 3h-19A1.5 1.5 0 011 12.5zM2.5 17a1.5 1.5 0 000 3h19a1.5 1.5 0 000-3h-19z"
    }));
});

});

parcelRegister("inuXG", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $d612644be5a5b716$var$__assign = undefined && undefined.__assign || function() {
    $d612644be5a5b716$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d612644be5a5b716$var$__assign.apply(this, arguments);
};
var $d612644be5a5b716$export$da45d96ed490d127 = $a5EUy.forwardRef(function Minus(props, svgRef) {
    return $a5EUy.createElement("svg", $d612644be5a5b716$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M23.913 12a.75.75 0 01-.75.75H.837a.75.75 0 010-1.5h22.326a.75.75 0 01.75.75z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("jNIIb", function(module, exports) {

$parcel$export(module.exports, "MinusBold", function () { return $e6a546be0b7642b6$export$b7a01a7ec68fd5c0; });

var $a5EUy = parcelRequire("a5EUy");
var $e6a546be0b7642b6$var$__assign = undefined && undefined.__assign || function() {
    $e6a546be0b7642b6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e6a546be0b7642b6$var$__assign.apply(this, arguments);
};
var $e6a546be0b7642b6$export$b7a01a7ec68fd5c0 = $a5EUy.forwardRef(function MinusBold(props, svgRef) {
    return $a5EUy.createElement("svg", $e6a546be0b7642b6$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M23.935 12a1.5 1.5 0 01-1.5 1.5H1.565a1.5 1.5 0 010-3h20.87a1.5 1.5 0 011.5 1.5z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("ayy3Z", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $01fbbbe1a1ea7a4d$var$__assign = undefined && undefined.__assign || function() {
    $01fbbbe1a1ea7a4d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $01fbbbe1a1ea7a4d$var$__assign.apply(this, arguments);
};
var $01fbbbe1a1ea7a4d$export$e49a5ad3dd6df925 = $a5EUy.forwardRef(function Move(props, svgRef) {
    return $a5EUy.createElement("svg", $01fbbbe1a1ea7a4d$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M8.47 5.532a.75.75 0 010-1.06l3-3a.75.75 0 011.06 0l3 3a.75.75 0 01-1.06 1.06l-1.72-1.72v7.44h7.44l-1.72-1.72a.75.75 0 011.06-1.06l3 3a.75.75 0 010 1.06l-3 3a.75.75 0 11-1.06-1.06l1.72-1.72h-7.44v7.44l1.72-1.72a.75.75 0 111.06 1.06l-3 3a.75.75 0 01-1.06 0l-3-3a.75.75 0 111.06-1.06l1.72 1.72v-7.44H3.81l1.72 1.72a.75.75 0 11-1.06 1.06l-3-3a.75.75 0 010-1.06l3-3a.75.75 0 011.06 1.06l-1.72 1.72h7.44v-7.44l-1.72 1.72a.75.75 0 01-1.06 0z"
    }));
});

});

parcelRegister("ciQzL", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $8f4ff2f70ce19e0c$var$__assign = undefined && undefined.__assign || function() {
    $8f4ff2f70ce19e0c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8f4ff2f70ce19e0c$var$__assign.apply(this, arguments);
};
var $8f4ff2f70ce19e0c$export$a3c5fa6436f5d841 = $a5EUy.forwardRef(function MoveBold(props, svgRef) {
    return $a5EUy.createElement("svg", $8f4ff2f70ce19e0c$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M7.94 6.06a1.5 1.5 0 010-2.12l3-3a1.5 1.5 0 012.12 0l3 3a1.5 1.5 0 01-2.12 2.12l-.44-.439V10.5h4.879l-.44-.44a1.5 1.5 0 012.122-2.12l3 3a1.5 1.5 0 010 2.12l-3 3a1.5 1.5 0 01-2.122-2.12l.44-.44H13.5v4.879l.44-.44a1.5 1.5 0 012.12 2.122l-3 3a1.5 1.5 0 01-2.12 0l-3-3a1.5 1.5 0 012.12-2.122l.44.44V13.5H5.621l.44.44a1.5 1.5 0 01-2.122 2.12l-3-3a1.5 1.5 0 010-2.12l3-3a1.5 1.5 0 112.122 2.12l-.44.44H10.5V5.621l-.44.44a1.5 1.5 0 01-2.12 0z"
    }));
});

});

parcelRegister("3NklM", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $2c35bbd8e06c5732$var$__assign = undefined && undefined.__assign || function() {
    $2c35bbd8e06c5732$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2c35bbd8e06c5732$var$__assign.apply(this, arguments);
};
var $2c35bbd8e06c5732$export$814afb5995e98181 = $a5EUy.forwardRef(function NetworkMonitor(props, svgRef) {
    return $a5EUy.createElement("svg", $2c35bbd8e06c5732$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M7.125 0a.75.75 0 00-.75.75V7.5c0 .414.336.75.75.75h4.125v1.5H9.375a.75.75 0 000 1.5h5.25a.75.75 0 000-1.5H12.75v-1.5h4.125a.75.75 0 00.75-.75V.75a.75.75 0 00-.75-.75h-9.75zm9 6.75V1.5h-8.25v5.25h8.25zM0 13.5a.75.75 0 01.75-.75h9.75a.75.75 0 01.75.75v6.75a.75.75 0 01-.75.75H6.375v1.5H8.25a.75.75 0 010 1.5H3a.75.75 0 010-1.5h1.875V21H.75a.75.75 0 01-.75-.75V13.5zm9.75 6v-5.25H1.5v5.25h8.25zm3-6a.75.75 0 01.75-.75h9.75a.75.75 0 01.75.75v6.75a.75.75 0 01-.75.75h-4.125v1.5H21a.75.75 0 010 1.5h-5.25a.75.75 0 010-1.5h1.875V21H13.5a.75.75 0 01-.75-.75V13.5zm9.75 6h-8.25v-5.25h8.25v5.25z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("3Fmvz", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $2ab6a91743265f1d$var$__assign = undefined && undefined.__assign || function() {
    $2ab6a91743265f1d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2ab6a91743265f1d$var$__assign.apply(this, arguments);
};
var $2ab6a91743265f1d$export$aa45e342fa88404f = $a5EUy.forwardRef(function Newspaper(props, svgRef) {
    return $a5EUy.createElement("svg", $2ab6a91743265f1d$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M2.25 0h19.5A2.25 2.25 0 0124 2.25v19.5A2.25 2.25 0 0121.75 24H2.25A2.25 2.25 0 010 21.75V2.25A2.25 2.25 0 012.25 0zm19.5 1.5H2.25a.75.75 0 00-.75.75v19.5c0 .414.336.75.75.75h19.5a.75.75 0 00.75-.75V2.25a.75.75 0 00-.75-.75zm-1.5 12a.75.75 0 00-.75-.75h-6l-.102.007a.75.75 0 00.102 1.493h6l.102-.007a.75.75 0 00.648-.743zm-.75 2.25a.75.75 0 01.102 1.493l-.102.007h-6a.75.75 0 01-.102-1.493l.102-.007h6zM18 19.5a.75.75 0 00-.75-.75H13.5l-.102.007a.75.75 0 00.102 1.493h3.75l.102-.007A.75.75 0 0018 19.5zm-8.25-6.75a.75.75 0 01.102 1.493l-.102.007h-6a.75.75 0 01-.102-1.493l.102-.007h6zm.75 3.75a.75.75 0 00-.75-.75h-6l-.102.007a.75.75 0 00.102 1.493h6l.102-.007a.75.75 0 00.648-.743zm-3 2.25a.75.75 0 01.102 1.493l-.102.007H3.75a.75.75 0 01-.102-1.493l.102-.007H7.5zM4.5 3h15A1.5 1.5 0 0121 4.5V9a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 9V4.5A1.5 1.5 0 014.5 3zm15 1.5h-15V9h15V4.5z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("t3odn", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $057556a4f721a992$var$__assign = undefined && undefined.__assign || function() {
    $057556a4f721a992$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $057556a4f721a992$var$__assign.apply(this, arguments);
};
var $057556a4f721a992$export$b8dad214827a9937 = $a5EUy.forwardRef(function NewspaperBold(props, svgRef) {
    return $a5EUy.createElement("svg", $057556a4f721a992$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M22 0H2a2 2 0 00-2 2v20a2 2 0 002 2h20a2 2 0 002-2V2a2 2 0 00-2-2zm0 21.5a.5.5 0 01-.5.5h-19a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5h19a.5.5 0 01.5.5v19z"
    }), $a5EUy.createElement("path", {
        d: "M18.5 4h-13c-.69 0-1.25.56-1.25 1.25v2.5C4.25 8.44 4.81 9 5.5 9h13c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25zm-8 7H5a.75.75 0 00-.75.75v.5c0 .414.336.75.75.75h5.5a.75.75 0 00.75-.75v-.5a.75.75 0 00-.75-.75zm0 3.5H5a.75.75 0 00-.75.75v.5c0 .414.336.75.75.75h5.5a.75.75 0 00.75-.75v-.5a.75.75 0 00-.75-.75zm0 3.5H5a.75.75 0 00-.75.75v.5c0 .414.336.75.75.75h5.5a.75.75 0 00.75-.75v-.5a.75.75 0 00-.75-.75zm8.5 0h-5.5a.75.75 0 00-.75.75v.5c0 .414.336.75.75.75H19a.75.75 0 00.75-.75v-.5A.75.75 0 0019 18zm0-7h-5.5a.75.75 0 00-.75.75v.5c0 .414.336.75.75.75H19a.75.75 0 00.75-.75v-.5A.75.75 0 0019 11zm0 3.5h-5.5a.75.75 0 00-.75.75v.5c0 .414.336.75.75.75H19a.75.75 0 00.75-.75v-.5a.75.75 0 00-.75-.75z"
    }));
});

});

parcelRegister("bmc5Q", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $844b213ed44fc705$var$__assign = undefined && undefined.__assign || function() {
    $844b213ed44fc705$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $844b213ed44fc705$var$__assign.apply(this, arguments);
};
var $844b213ed44fc705$export$b99d3348f709c998 = $a5EUy.forwardRef(function PieChart(props, svgRef) {
    return $a5EUy.createElement("svg", $844b213ed44fc705$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M20.894 3.856A9.75 9.75 0 0014 1a.75.75 0 00-.75.75v9c0 .414.336.75.75.75h9a.75.75 0 00.75-.75 9.75 9.75 0 00-2.856-6.894zM14.75 2.534A8.249 8.249 0 0122.216 10H14.75V2.534z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M5.333 5.393A9.75 9.75 0 0110.75 3.75a.75.75 0 01.75.75v8.25h8.25a.75.75 0 01.75.75A9.75 9.75 0 115.333 5.393zM10 5.284a8.25 8.25 0 108.966 8.966H10.75a.75.75 0 01-.75-.75V5.284z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("7MH2k", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $5aae66467ec7d058$var$__assign = undefined && undefined.__assign || function() {
    $5aae66467ec7d058$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5aae66467ec7d058$var$__assign.apply(this, arguments);
};
var $5aae66467ec7d058$export$656559010049c8e = $a5EUy.forwardRef(function Pin(props, svgRef) {
    return $a5EUy.createElement("svg", $5aae66467ec7d058$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M16.307.125a2.203 2.203 0 00-2.589.895L9.922 6.986a8.1 8.1 0 00-5.446.98l.37.635-.372-.634a2.203 2.203 0 00-.441 3.46l3.5 3.5-7.318 7.318a.734.734 0 001.039 1.038l7.317-7.318 3.502 3.502a2.203 2.203 0 003.46-.44l.002-.003a8.1 8.1 0 00.979-5.445l5.965-3.797a2.204 2.204 0 00.376-3.416l-5.72-5.72a2.202 2.202 0 00-.828-.521zM4.976 9.463a.734.734 0 01.24-.228 6.63 6.63 0 014.882-.713.734.734 0 00.791-.32l4.068-6.393a.735.735 0 011.139-.125l5.72 5.72a.734.734 0 01-.125 1.139l-6.392 4.068a.734.734 0 00-.32.792 6.63 6.63 0 01-.713 4.881.734.734 0 01-1.153.146l-8.042-8.042a.735.735 0 01-.095-.925z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("hMzPw", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $cf22b672031bdd60$var$__assign = undefined && undefined.__assign || function() {
    $cf22b672031bdd60$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cf22b672031bdd60$var$__assign.apply(this, arguments);
};
var $cf22b672031bdd60$export$88393934ec04748c = $a5EUy.forwardRef(function PinBold(props, svgRef) {
    return $a5EUy.createElement("svg", $cf22b672031bdd60$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M15.336.013a2.203 2.203 0 011.798.632l5.721 5.721a2.203 2.203 0 01-.376 3.416l-5.965 3.797a8.099 8.099 0 01-.98 5.445v.002a2.203 2.203 0 01-3.46.441L9.09 16.485 2.507 23.07c-.398.399-.969.52-1.472.365a.734.734 0 01-.97-.972 1.468 1.468 0 01.365-1.47l6.584-6.584-2.981-2.981a2.203 2.203 0 01.44-3.46l.373.634-.37-.635a8.1 8.1 0 015.446-.98l3.796-5.966A2.203 2.203 0 0115.336.013z"
    }));
});

});

parcelRegister("iHsdG", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $d9d22200a861f209$var$__assign = undefined && undefined.__assign || function() {
    $d9d22200a861f209$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d9d22200a861f209$var$__assign.apply(this, arguments);
};
var $d9d22200a861f209$export$2d9ac7aa84f97a08 = $a5EUy.forwardRef(function Plus(props, svgRef) {
    return $a5EUy.createElement("svg", $d9d22200a861f209$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M12.75 1a.75.75 0 00-1.5 0v10.25H1a.75.75 0 000 1.5h10.25V23a.75.75 0 001.5 0V12.75H23a.75.75 0 000-1.5H12.75V1z"
    }));
});

});

parcelRegister("1ZhSq", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $17295aed0482070a$var$__assign = undefined && undefined.__assign || function() {
    $17295aed0482070a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $17295aed0482070a$var$__assign.apply(this, arguments);
};
var $17295aed0482070a$export$2ef3672ebfdfd8df = $a5EUy.forwardRef(function PlusBold(props, svgRef) {
    return $a5EUy.createElement("svg", $17295aed0482070a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M13.5 1.565a1.5 1.5 0 00-3 0V10.5H1.565a1.5 1.5 0 000 3H10.5v8.935a1.5 1.5 0 003 0V13.5h8.935a1.5 1.5 0 000-3H13.5V1.565z"
    }));
});

});

parcelRegister("lUNyI", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $ff4545484f232cd1$var$__assign = undefined && undefined.__assign || function() {
    $ff4545484f232cd1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ff4545484f232cd1$var$__assign.apply(this, arguments);
};
var $ff4545484f232cd1$export$531cef85654f2406 = $a5EUy.forwardRef(function Print(props, svgRef) {
    return $a5EUy.createElement("svg", $ff4545484f232cd1$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M3.75 9a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5h-1.5zm3.75 6.75a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM8.25 18a.75.75 0 000 1.5h5.25a.75.75 0 000-1.5H8.25z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M4.5 6V2.25A2.25 2.25 0 016.75 0h10.5a2.25 2.25 0 012.25 2.25V6h2.25A2.25 2.25 0 0124 8.25v7.5A2.25 2.25 0 0121.75 18H19.5v5.25a.75.75 0 01-.75.75H5.25a.75.75 0 01-.75-.75V18H2.25A2.25 2.25 0 010 15.75v-7.5A2.25 2.25 0 012.25 6H4.5zm1.72-4.28a.75.75 0 01.53-.22h10.5a.75.75 0 01.75.75V6H6V2.25a.75.75 0 01.22-.53zM2.25 7.5a.75.75 0 00-.75.75v7.5a.75.75 0 00.75.75H4.5v-3.75a.75.75 0 01.75-.75h13.5a.75.75 0 01.75.75v3.75h2.25a.75.75 0 00.75-.75v-7.5a.75.75 0 00-.75-.75H2.25zm15.75 6v9H6v-9h12z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("f6HYG", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $aff9879cba4f8e0b$var$__assign = undefined && undefined.__assign || function() {
    $aff9879cba4f8e0b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $aff9879cba4f8e0b$var$__assign.apply(this, arguments);
};
var $aff9879cba4f8e0b$export$3326d4c83d14f416 = $a5EUy.forwardRef(function PrintBold(props, svgRef) {
    return $a5EUy.createElement("svg", $aff9879cba4f8e0b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M4.5 2.25A2.25 2.25 0 016.75 0h10.5a2.25 2.25 0 012.25 2.25V6h2.25a2.25 2.25 0 012.249 2.25v7.5a2.25 2.25 0 01-2.25 2.25H19.5v5.25a.75.75 0 01-.75.749H5.25a.75.75 0 01-.75-.75V18H2.25A2.25 2.25 0 010 15.75v-7.5A2.25 2.25 0 012.25 6H4.5V2.25zm13 11.25h-11V22h11v-8.5zm0-8V2.25a.25.25 0 00-.25-.25H6.75a.25.25 0 00-.25.25V5.5h11zM2.75 9.75a1 1 0 011-1h1.5a1 1 0 010 2h-1.5a1 1 0 01-1-1z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M8.25 14.75a1 1 0 000 2h7.5a1 1 0 000-2h-7.5zm0 3a1 1 0 100 2h5.25a1 1 0 000-2H8.25z"
    }));
});

});

parcelRegister("fGQFd", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $b6c3a12a3d569a75$var$__assign = undefined && undefined.__assign || function() {
    $b6c3a12a3d569a75$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b6c3a12a3d569a75$var$__assign.apply(this, arguments);
};
var $b6c3a12a3d569a75$export$3b87754677f810a3 = $a5EUy.forwardRef(function ProfitAndLoss(props, svgRef) {
    return $a5EUy.createElement("svg", $b6c3a12a3d569a75$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M20 1.25a.75.75 0 01.743.648L20.75 2v7a.75.75 0 01-1.493.102L19.25 9V2a.75.75 0 01.75-.75z"
    }), $a5EUy.createElement("path", {
        d: "M19.47 1.47a.75.75 0 01.976-.073l.084.073 3 3a.75.75 0 01-.976 1.133l-.084-.073L20 3.061l-2.47 2.47a.75.75 0 01-.976.072l-.084-.073a.75.75 0 01-.073-.976l.073-.084 3-3zM4 22.75a.75.75 0 01-.743-.648L3.25 22v-7a.75.75 0 011.493-.102L4.75 15v7a.75.75 0 01-.75.75z"
    }), $a5EUy.createElement("path", {
        d: "M4.53 22.53a.75.75 0 01-.976.073l-.084-.073-3-3a.75.75 0 01.976-1.133l.084.073L4 20.939l2.47-2.47a.75.75 0 01.976-.072l.084.073a.75.75 0 01.073.976l-.073.084-3 3zM13.5 8.25a.75.75 0 01.102 1.493l-.102.007h-2.033a.592.592 0 00-.305 1.1l.083.04 2.065.826a2.092 2.092 0 01-.613 4.028l-.166.006H10.5a.75.75 0 01-.102-1.493l.102-.007h2.032a.592.592 0 00.304-1.1l-.083-.042-2.066-.825a2.092 2.092 0 01.614-4.026l.166-.007H13.5z"
    }), $a5EUy.createElement("path", {
        d: "M12 7.5a.75.75 0 01.743.648l.007.102V9a.75.75 0 01-1.493.102L11.25 9v-.75A.75.75 0 0112 7.5zm0 6.75a.75.75 0 01.743.648l.007.102v.75a.75.75 0 01-1.493.102l-.007-.102V15a.75.75 0 01.75-.75z"
    }), $a5EUy.createElement("path", {
        d: "M12 5.25a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zm0 1.5a5.25 5.25 0 110 10.5 5.25 5.25 0 010-10.5z"
    }));
});

});

parcelRegister("eUTxF", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $adc1612376c77852$var$__assign = undefined && undefined.__assign || function() {
    $adc1612376c77852$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $adc1612376c77852$var$__assign.apply(this, arguments);
};
var $adc1612376c77852$export$c09363a928487262 = $a5EUy.forwardRef(function ProfitAndLossBold(props, svgRef) {
    return $a5EUy.createElement("svg", $adc1612376c77852$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M20 1.25a.75.75 0 01.743.648L20.75 2v7a.75.75 0 01-1.493.102L19.25 9V2a.75.75 0 01.75-.75z"
    }), $a5EUy.createElement("path", {
        d: "M19.47 1.47a.75.75 0 01.976-.073l.084.073 3 3a.75.75 0 01-.976 1.133l-.084-.073L20 3.061l-2.47 2.47a.75.75 0 01-.976.072l-.084-.073a.75.75 0 01-.073-.976l.073-.084 3-3zM4 22.75a.75.75 0 01-.743-.648L3.25 22v-7a.75.75 0 011.493-.102L4.75 15v7a.75.75 0 01-.75.75z"
    }), $a5EUy.createElement("path", {
        d: "M4.53 22.53a.75.75 0 01-.976.073l-.084-.073-3-3a.75.75 0 01.976-1.133l.084.073L4 20.939l2.47-2.47a.75.75 0 01.976-.072l.084.073a.75.75 0 01.073.976l-.073.084-3 3zM5 11.5A6.5 6.5 0 1011.5 5 6.508 6.508 0 005 11.5zm5.592-3.697l-.006-.008a.19.19 0 00.165-.2v-.35a.75.75 0 011.5 0v.335a.17.17 0 00.169.165h.581a.75.75 0 010 1.5h-2.035a.592.592 0 00-.219 1.141l2.062.826a2.078 2.078 0 01-.417 3.989.184.184 0 00-.137.2v.353a.75.75 0 01-1.5 0v-.334a.17.17 0 00-.164-.166H10a.75.75 0 010-1.5h2.033a.592.592 0 00.22-1.141l-2.061-.83a2.079 2.079 0 01.4-3.98z"
    }));
});

});

parcelRegister("8ytUa", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $63a8b22e29976577$var$__assign = undefined && undefined.__assign || function() {
    $63a8b22e29976577$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $63a8b22e29976577$var$__assign.apply(this, arguments);
};
var $63a8b22e29976577$export$323217037b764dc5 = $a5EUy.forwardRef(function Programming(props, svgRef) {
    return $a5EUy.createElement("svg", $63a8b22e29976577$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M15.954 7.07a.75.75 0 10-1.06 1.061l2.404 2.405-2.404 2.405a.75.75 0 101.06 1.06l2.935-2.935a.75.75 0 000-1.06L15.954 7.07zm-6.848 0a.75.75 0 010 1.061l-2.404 2.405 2.404 2.405A.75.75 0 118.046 14L5.11 11.066a.75.75 0 010-1.06L8.046 7.07a.75.75 0 011.06 0zm4.584.768a.75.75 0 10-1.423-.474l-1.957 5.87a.75.75 0 101.423.474l1.957-5.87z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M.75.003a.75.75 0 01.75.75v1.392l2.184-.672a10.364 10.364 0 018.477 1.078 8.862 8.862 0 007.076.974l2.37-.677a1.876 1.876 0 012.389 1.802v12.87a1.874 1.874 0 01-1.36 1.803l-2.987.854a10.365 10.365 0 01-8.278-1.138 8.856 8.856 0 00-7.25-.922l-2.621.81v4.26a.75.75 0 01-1.5 0V.753a.75.75 0 01.75-.75zm.75 17.353V3.714l2.625-.807a8.864 8.864 0 017.25.922 10.36 10.36 0 008.274 1.138l2.368-.677a.377.377 0 01.479.361v12.87a.375.375 0 01-.272.36l-2.987.854a8.866 8.866 0 01-7.08-.974 10.357 10.357 0 00-8.478-1.078l-2.179.673z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("eWhmm", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $ae03f2bc36e38943$var$__assign = undefined && undefined.__assign || function() {
    $ae03f2bc36e38943$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ae03f2bc36e38943$var$__assign.apply(this, arguments);
};
var $ae03f2bc36e38943$export$d5f8ac158b287764 = $a5EUy.forwardRef(function ProgrammingBold(props, svgRef) {
    return $a5EUy.createElement("svg", $ae03f2bc36e38943$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M3 22.5a1.5 1.5 0 01-3 0v-21a1.5 1.5 0 013 0v.025a.25.25 0 00.335.236l.717-.261a9.779 9.779 0 018.226 1.067 9.36 9.36 0 007.45 1.025L21.9 2.9A1.652 1.652 0 0124 4.485v13.159a1.655 1.655 0 01-1.2 1.583L20 20.1a10.33 10.33 0 01-8.248-1.129A8.766 8.766 0 004.371 18l-1.206.435A.25.25 0 003 18.67v3.83zM15.005 7.297a.75.75 0 00.215.734l2.293 2.293a.252.252 0 010 .354l-2.293 2.293a.75.75 0 101.06 1.06l3-3a.75.75 0 000-1.06l-3-3a.75.75 0 00-1.275.326zm-3.992 6.916a.751.751 0 01-.475-.949l2-6a.75.75 0 011.424.474l-2 6a.751.751 0 01-.949.475zM5 10.501c0 .199.08.39.22.53l3 3a.75.75 0 101.06-1.06l-2.293-2.293a.252.252 0 010-.354L9.28 8.031a.75.75 0 00-1.06-1.06l-3 3a.749.749 0 00-.22.53z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("6HNJw", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $4e1d56344b10d6b6$var$__assign = undefined && undefined.__assign || function() {
    $4e1d56344b10d6b6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4e1d56344b10d6b6$var$__assign.apply(this, arguments);
};
var $4e1d56344b10d6b6$export$f93ec6528f706bfe = $a5EUy.forwardRef(function Refresh(props, svgRef) {
    return $a5EUy.createElement("svg", $4e1d56344b10d6b6$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M19.378 10.056a.746.746 0 00-.825.159l-2.667 2.667a.75.75 0 001.06 1.06l1.368-1.367a6.583 6.583 0 01-11.352 4.02.75.75 0 10-1.09 1.03 8.084 8.084 0 0013.948-5.082l1.4 1.4a.75.75 0 001.06-1.061l-2.664-2.664a.763.763 0 00-.238-.162zm-11.7.811a.776.776 0 00-1.092 0l-1.39 1.398v-.2c0-1.397.397-2.695 1.191-3.793.795-1.099 1.887-1.897 3.178-2.396 1.291-.5 2.681-.5 3.973-.2 1.29.4 2.482 1.098 3.277 2.196.298.3.695.4 1.092.1.298-.3.397-.699.1-1.098-1.093-1.298-2.483-2.196-4.072-2.596-1.59-.399-3.277-.399-4.866.2a8.206 8.206 0 00-3.873 2.995c-.993 1.398-1.49 2.995-1.49 4.592v.2l-1.39-1.398a.776.776 0 00-1.093 0 .786.786 0 000 1.098l2.682 2.696c.099.1.298.2.496.2.199 0 .397-.1.497-.2l2.681-2.695c.397-.3.397-.8.1-1.099z"
    }));
});

});

parcelRegister("l4SQC", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $f58484531d506fa9$var$__assign = undefined && undefined.__assign || function() {
    $f58484531d506fa9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f58484531d506fa9$var$__assign.apply(this, arguments);
};
var $f58484531d506fa9$export$af5e85d717d10540 = $a5EUy.forwardRef(function RefreshBold(props, svgRef) {
    return $a5EUy.createElement("svg", $f58484531d506fa9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M14.339 3.815a8.834 8.834 0 00-11.044 7.02l-.234-.234a1.5 1.5 0 10-2.122 2.122l2.617 2.616a1.496 1.496 0 002.224-.002l2.614-2.614a1.5 1.5 0 00-1.905-2.301 5.833 5.833 0 018.995-2.767 1.5 1.5 0 101.792-2.406 8.832 8.832 0 00-2.937-1.434zm5.625 5.819a1.495 1.495 0 00-1.157-.044 1.495 1.495 0 00-.534.345L15.606 12.6a1.5 1.5 0 001.534 2.485 5.825 5.825 0 01-2.986 2.663 5.833 5.833 0 01-5.336-.532 1.5 1.5 0 10-1.636 2.514 8.833 8.833 0 0013.41-5.355l.347.347a1.5 1.5 0 102.122-2.122l-2.656-2.655a1.495 1.495 0 00-.44-.312z"
    }));
});

});

parcelRegister("ayR8x", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $7b064c2f3f288ff5$var$__assign = undefined && undefined.__assign || function() {
    $7b064c2f3f288ff5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7b064c2f3f288ff5$var$__assign.apply(this, arguments);
};
var $7b064c2f3f288ff5$export$6d3b1b9014d6cc79 = $a5EUy.forwardRef(function Retract(props, svgRef) {
    return $a5EUy.createElement("svg", $7b064c2f3f288ff5$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M23.026 2.526a.75.75 0 10-1.06-1.06l-7.22 7.22v-4.69a.75.75 0 10-1.5 0v6.5a.747.747 0 00.75.75h6.5a.75.75 0 100-1.5h-4.69l7.22-7.22zm-12.53 18.448a.75.75 0 01-.75-.75v-4.69l-7.22 7.22a.75.75 0 11-1.06-1.06l7.22-7.22h-4.69a.75.75 0 010-1.5h6.5a.747.747 0 01.75.75v6.5a.75.75 0 01-.75.75z"
    }));
});

});

parcelRegister("1hPCc", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $0eff6aa3df6d5295$var$__assign = undefined && undefined.__assign || function() {
    $0eff6aa3df6d5295$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0eff6aa3df6d5295$var$__assign.apply(this, arguments);
};
var $0eff6aa3df6d5295$export$9515f4411b0668 = $a5EUy.forwardRef(function RetractBold(props, svgRef) {
    return $a5EUy.createElement("svg", $0eff6aa3df6d5295$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M23.56 3.06A1.5 1.5 0 0021.44.94L15.5 6.878V4a1.5 1.5 0 00-3 0v6.5a1.494 1.494 0 00.859 1.357c.194.092.412.143.641.143h6.5a1.5 1.5 0 000-3h-2.879l5.94-5.94zM10.5 21.728a1.5 1.5 0 01-1.5-1.5v-2.879l-5.94 5.94a1.5 1.5 0 11-2.12-2.122l5.939-5.939H4a1.5 1.5 0 010-3h6.5a1.494 1.494 0 011.374.896c.08.185.126.39.126.604v6.5a1.5 1.5 0 01-1.5 1.5z"
    }));
});

});

parcelRegister("74pOs", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $525cedfed435f718$var$__assign = undefined && undefined.__assign || function() {
    $525cedfed435f718$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $525cedfed435f718$var$__assign.apply(this, arguments);
};
var $525cedfed435f718$export$b204c8549f010cd = $a5EUy.forwardRef(function RotateLeft(props, svgRef) {
    return $a5EUy.createElement("svg", $525cedfed435f718$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M1 1.75a.75.75 0 011.5 0v4.714a10.997 10.997 0 119.497 16.53.75.75 0 010-1.5A9.497 9.497 0 103.47 7.832h5.11a.75.75 0 010 1.5h-6.2a.745.745 0 01-.077 0H1.75a.75.75 0 01-.75-.75V1.75z"
    }));
});

});

parcelRegister("dgu55", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $9a841a77fec66e17$var$__assign = undefined && undefined.__assign || function() {
    $9a841a77fec66e17$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9a841a77fec66e17$var$__assign.apply(this, arguments);
};
var $9a841a77fec66e17$export$7257def152302e45 = $a5EUy.forwardRef(function RotateLeftBold(props, svgRef) {
    return $a5EUy.createElement("svg", $9a841a77fec66e17$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M0 2a1.5 1.5 0 113 0v2.414a11.746 11.746 0 118.746 19.58 1.5 1.5 0 01.002-3 8.747 8.747 0 10-7.23-13.663h3.813a1.5 1.5 0 110 3H2.152a1.2 1.2 0 01-.12 0H1.5a1.5 1.5 0 01-1.5-1.5V2z"
    }));
});

});

parcelRegister("aLath", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $7d566a90b6b3f2d0$var$__assign = undefined && undefined.__assign || function() {
    $7d566a90b6b3f2d0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7d566a90b6b3f2d0$var$__assign.apply(this, arguments);
};
var $7d566a90b6b3f2d0$export$75099d76a78789f = $a5EUy.forwardRef(function RotateRight(props, svgRef) {
    return $a5EUy.createElement("svg", $7d566a90b6b3f2d0$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M23.257 2.002a.75.75 0 00-1.5 0v4.714a10.999 10.999 0 00-18.484-.813 10.997 10.997 0 008.987 17.343.75.75 0 100-1.5 9.496 9.496 0 118.528-13.663h-5.113a.75.75 0 000 1.5h6.2a.744.744 0 00.078 0h.554a.75.75 0 00.75-.75V2.002z"
    }));
});

});

parcelRegister("h7jKy", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $c7626907e2cea11c$var$__assign = undefined && undefined.__assign || function() {
    $c7626907e2cea11c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c7626907e2cea11c$var$__assign.apply(this, arguments);
};
var $c7626907e2cea11c$export$1d157cf51c63a935 = $a5EUy.forwardRef(function RotateRightBold(props, svgRef) {
    return $a5EUy.createElement("svg", $c7626907e2cea11c$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M24 2a1.5 1.5 0 00-3 0v2.414A11.75 11.75 0 007.576 1.47a11.747 11.747 0 004.678 22.525 1.5 1.5 0 00-.002-3 8.747 8.747 0 117.23-13.664h-3.813a1.5 1.5 0 000 3h6.179c.04.002.08.002.12 0h.532a1.5 1.5 0 001.5-1.5V2z"
    }));
});

});

parcelRegister("777QQ", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $52df46f2fdca089a$var$__assign = undefined && undefined.__assign || function() {
    $52df46f2fdca089a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $52df46f2fdca089a$var$__assign.apply(this, arguments);
};
var $52df46f2fdca089a$export$be11e187edb4cb0c = $a5EUy.forwardRef(function Save(props, svgRef) {
    return $a5EUy.createElement("svg", $52df46f2fdca089a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M7.5 15.75a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75zM8.25 18a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5h-7.5zm7.5-15a.75.75 0 01.75.75v1.5a.75.75 0 01-1.5 0v-1.5a.75.75 0 01.75-.75z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M2.25 24A2.25 2.25 0 010 21.75V7.243a3.75 3.75 0 011.099-2.651L4.59 1.099A3.75 3.75 0 017.243 0H21.75A2.25 2.25 0 0124 2.25v19.5A2.25 2.25 0 0121.75 24H2.25zM6.382 1.671a2.25 2.25 0 01.86-.171H7.5v5.25A2.25 2.25 0 009.75 9h7.5a2.25 2.25 0 002.25-2.25V1.5h2.25a.75.75 0 01.75.75v19.5a.75.75 0 01-.75.75H19.5v-8.25A2.25 2.25 0 0017.25 12H6.75a2.25 2.25 0 00-2.25 2.25v8.25H2.25a.75.75 0 01-.75-.75V7.243c0-.597.237-1.169.66-1.59l3.49-3.495a2.25 2.25 0 01.73-.488zM6 22.5h12v-8.25a.75.75 0 00-.75-.75H6.75a.75.75 0 00-.75.75v8.25zm12-21v5.25a.75.75 0 01-.75.75h-7.5A.75.75 0 019 6.75V1.5h9z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("3Z7fX", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $2e6cb290d0e0d7d6$var$__assign = undefined && undefined.__assign || function() {
    $2e6cb290d0e0d7d6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2e6cb290d0e0d7d6$var$__assign.apply(this, arguments);
};
var $2e6cb290d0e0d7d6$export$71dc135d99594e20 = $a5EUy.forwardRef(function SavingMoneyFlower(props, svgRef) {
    return $a5EUy.createElement("svg", $2e6cb290d0e0d7d6$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M11.946 0a6.75 6.75 0 01.75 13.459v7.211l.106-.13a18.234 18.234 0 012.328-2.325c-1.331-1.451-.836-3.25.846-4.494l.153-.11.098-.056a7.972 7.972 0 017.201.11.75.75 0 01.173 1.203 5.175 5.175 0 00-.69.82c-.247.364-.393.639-.66 1.24l-.286.656c-.393.887-.682 1.379-1.182 1.923-1.473 1.605-3.493 1.636-4.657-.376l.082.137c-1 .83-1.814 1.665-2.46 2.488a9.83 9.83 0 00-.887 1.32l-.103.197a3.164 3.164 0 00-.092.197l-.016.038-.004.011a.928.928 0 01-.015.037l-.005.01-.007.012-.01.023-.005.01a.689.689 0 01-.015.026l-.009.013-.014.022-.015.022-.011.014-.016.02-.014.016a.796.796 0 01-.053.055l-.017.015a.864.864 0 01-.058.047l-.014.01a.768.768 0 01-.071.042l-.012.006a.721.721 0 01-.071.032c-.004 0-.007.002-.01.003l-.017.006-.008.003a.632.632 0 01-.061.017l-.022.005a.794.794 0 01-.13.015h-.055a.735.735 0 01-.047-.004l-.02-.003-.038-.006a.85.85 0 01-.06-.014l-.039-.012a.708.708 0 01-.041-.015l-.012-.005-.036-.018-.023-.01a.76.76 0 01-.012-.007l-.007-.004a.656.656 0 01-.15-.11l-.013-.015a.472.472 0 01-.045-.049l-.016-.02-.007-.01a.486.486 0 01-.016-.02l-.017-.028a.983.983 0 01-.029-.05l-.005-.01a.77.77 0 01-.032-.07l-.073-.168a4.996 4.996 0 00-.086-.171l-.056-.105a9.755 9.755 0 00-.887-1.32c-.646-.823-1.46-1.658-2.46-2.488-1.141 1.816-3.018 1.808-4.444.377l-.132-.138c-.544-.594-.837-1.124-1.291-2.174l-.092-.212c-.32-.734-.468-1.025-.736-1.422a5.18 5.18 0 00-.697-.83.75.75 0 01.173-1.203 7.969 7.969 0 017.2-.11l.098.057c1.805 1.246 2.371 3.11 1 4.603a18.033 18.033 0 012.436 2.456l-.003-7.213A6.75 6.75 0 0111.946 0zM6.754 14.787a6.47 6.47 0 00-4.566-.224l-.135.046.18.25c.332.493.507.837.86 1.646l.101.233c.391.905.62 1.319 1.02 1.754.842.917 1.66.95 2.273-.145-.393-.287-.81-.57-1.252-.85a.75.75 0 01.806-1.266 27.22 27.22 0 011.536 1.051c.78-.793.465-1.654-.666-2.435l.045.033-.202-.093zm14.951-.225a6.472 6.472 0 00-4.821.341l.048-.022-.089.064c-1.017.755-1.275 1.577-.526 2.337.48-.354.991-.705 1.535-1.05a.75.75 0 01.806 1.265c-.442.28-.859.563-1.253.848.612 1.097 1.432 1.064 2.274.148.4-.436.629-.85 1.02-1.755l.194-.445c.296-.668.47-.996.776-1.446l.17-.239-.134-.046zM11.946 1.5a5.25 5.25 0 100 10.5 5.25 5.25 0 000-10.5zm0 .75a.75.75 0 01.743.648l.007.101.75.001a.75.75 0 01.102 1.493l-.102.007h-1.5l-.015-.001-.52.001a.591.591 0 00-.303 1.1l.084.04 2.064.827a2.092 2.092 0 01-.56 4.021v.012a.75.75 0 01-1.493.102l-.007-.102v-.001l-.75.001a.75.75 0 01-.102-1.493L10.446 9h2.03a.592.592 0 00.304-1.1l-.083-.04-2.061-.826a2.091 2.091 0 01.56-4.023V3a.75.75 0 01.75-.75z"
    }));
});

});

parcelRegister("53Mb3", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $3af29a919bb9d0e1$var$__assign = undefined && undefined.__assign || function() {
    $3af29a919bb9d0e1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3af29a919bb9d0e1$var$__assign.apply(this, arguments);
};
var $3af29a919bb9d0e1$export$3cb7ee0299df8f39 = $a5EUy.forwardRef(function SavingMoneyFlowerBold(props, svgRef) {
    return $a5EUy.createElement("svg", $3af29a919bb9d0e1$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M21.589 13.325a.475.475 0 00-.319-.255.493.493 0 00-.406.08c-.672.462-1.44.78-2.25.93-.714.14-1.397.4-2.017.767a2.37 2.37 0 00-1.234 1.902 1.68 1.68 0 00.096.57.225.225 0 01-.077.254 14.71 14.71 0 00-1.62 1.452.246.246 0 01-.264.058.231.231 0 01-.152-.215v-4.107c0-.113.085-.21.2-.228 3.631-.581 6.193-3.747 5.89-7.28C19.134 3.718 16.07 1 12.388 1c-3.68 0-6.746 2.72-7.049 6.252-.302 3.534 2.26 6.7 5.89 7.28.116.02.2.116.2.229v3.192a.23.23 0 01-.136.208.247.247 0 01-.254-.03 10.423 10.423 0 00-1.829-1.144.132.132 0 01-.076-.125 2.56 2.56 0 00-1.314-2.078 6.242 6.242 0 00-5.606.069.452.452 0 00-.068.716 5.012 5.012 0 011.18 1.817c.234.607.577 1.17 1.014 1.661.43.501 1.06.805 1.734.838.087 0 .173-.005.26-.018a2.08 2.08 0 001.513-1.178.24.24 0 01.08-.083l.034-.022a.246.246 0 01.24-.016 7.342 7.342 0 013.197 2.701.222.222 0 01.033.117v.846a1 1 0 00.794.903c.443.098.9-.096 1.123-.478A13.173 13.173 0 0116.606 19a.093.093 0 01.134.022c.304.56.848.96 1.487 1.1.118.021.238.032.358.032a3.14 3.14 0 002.153-1.033 6.111 6.111 0 00.85-5.796zm-10.925-1.384c-.463 0-.839-.362-.839-.808 0-.446.376-.808.839-.808h2.338c.338 0 .63-.23.693-.55a.674.674 0 00-.431-.759l-2.372-.907c-.987-.38-1.592-1.343-1.485-2.361.107-1.019.901-1.845 1.947-2.027a.233.233 0 00.197-.227v-.111c0-.446.376-.808.839-.808.463 0 .838.362.838.808v.069c0 .127.107.23.24.23h.647c.463 0 .838.362.838.808 0 .446-.375.808-.838.808h-2.339a.698.698 0 00-.69.55.674.674 0 00.429.758l2.374.914c.986.38 1.592 1.344 1.484 2.362-.107 1.018-.902 1.844-1.947 2.025a.234.234 0 00-.198.227v.11c0 .446-.375.808-.838.808-.463 0-.839-.362-.839-.808v-.069a.235.235 0 00-.24-.23l-.647-.004z"
    }));
});

});

parcelRegister("gXIQ9", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $c594f05e1bc31527$var$__assign = undefined && undefined.__assign || function() {
    $c594f05e1bc31527$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c594f05e1bc31527$var$__assign.apply(this, arguments);
};
var $c594f05e1bc31527$export$4b85d3515bd863a5 = $a5EUy.forwardRef(function Search(props, svgRef) {
    return $a5EUy.createElement("svg", $c594f05e1bc31527$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M10 1.25a8.75 8.75 0 105.634 15.445l5.836 5.835a.75.75 0 001.06-1.06l-5.835-5.836A8.75 8.75 0 0010 1.25zM2.75 10a7.25 7.25 0 1114.5 0 7.25 7.25 0 01-14.5 0z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("l7qsC", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $f5fec6f22700c4cd$var$__assign = undefined && undefined.__assign || function() {
    $f5fec6f22700c4cd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f5fec6f22700c4cd$var$__assign.apply(this, arguments);
};
var $f5fec6f22700c4cd$export$8278256c54fb93b2 = $a5EUy.forwardRef(function SearchBold(props, svgRef) {
    return $a5EUy.createElement("svg", $f5fec6f22700c4cd$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M10 .5a9.5 9.5 0 100 19c2.082 0 4.008-.67 5.573-1.806l5.366 5.367a1.5 1.5 0 002.122-2.122l-5.367-5.366A9.458 9.458 0 0019.5 10 9.5 9.5 0 0010 .5zM3.5 10a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("4TbYF", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $38f596f4ce4a1dbe$var$__assign = undefined && undefined.__assign || function() {
    $38f596f4ce4a1dbe$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $38f596f4ce4a1dbe$var$__assign.apply(this, arguments);
};
var $38f596f4ce4a1dbe$export$9fb697de7778c436 = $a5EUy.forwardRef(function Security(props, svgRef) {
    return $a5EUy.createElement("svg", $38f596f4ce4a1dbe$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M21.181 1.874A22.449 22.449 0 0012 .001 22.45 22.45 0 002.806 1.88 2.237 2.237 0 001.5 3.926v7.611A12.657 12.657 0 009.612 23.35l1.041.4a3.75 3.75 0 002.692 0l1.042-.4a12.656 12.656 0 008.112-11.813V3.926a2.238 2.238 0 00-1.318-2.052zM3 3.924v-.005a.737.737 0 01.425-.673 20.95 20.95 0 018.582-1.745 20.95 20.95 0 018.567 1.745.737.737 0 01.425.673v7.619a11.156 11.156 0 01-7.15 10.412l-1.042.4c-.52.2-1.095.2-1.615 0l-1.041-.4A11.156 11.156 0 013 11.538V3.923z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M12.745 12.917a.696.696 0 10-1.391 0V14.5a.696.696 0 001.391 0v-1.583z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M8.583 8.167v1.284h-.887a.696.696 0 00-.696.695v7.125c0 .384.311.696.696.696h8.707a.696.696 0 00.696-.696v-7.125a.696.696 0 00-.695-.695h-.888V8.167a3.467 3.467 0 10-6.933 0zm2-1.467a2.075 2.075 0 013.541 1.467v1.284h-4.15V8.167c0-.55.22-1.078.608-1.467zM8.39 16.575v-5.733h7.317v5.733H8.39z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("66yKP", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $471e431c791d5665$var$__assign = undefined && undefined.__assign || function() {
    $471e431c791d5665$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $471e431c791d5665$var$__assign.apply(this, arguments);
};
var $471e431c791d5665$export$ff3cf24dfc418321 = $a5EUy.forwardRef(function SecurityBold(props, svgRef) {
    return $a5EUy.createElement("svg", $471e431c791d5665$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("g", {
        clipPath: "url(#security-bold_svg__security-bold_svg__clip0)"
    }, $a5EUy.createElement("path", {
        d: "M22.15 2.8a2.24 2.24 0 00-1-.83A22.45 22.45 0 0012 .09 22.45 22.45 0 002.82 2 2.24 2.24 0 001.5 4v7.61a12.66 12.66 0 008.11 11.83l1 .4a3.75 3.75 0 002.69 0l1-.4a12.66 12.66 0 008.2-11.82V4a2.24 2.24 0 00-.35-1.2zm-5 13.56a.7.7 0 01-.7.7H7.7a.7.7 0 01-.7-.7V9.23a.7.7 0 01.7-.7h.89V7.25a3.47 3.47 0 116.93 0v1.29h.89a.7.7 0 01.7.7l.04 7.12z"
    }), $a5EUy.createElement("path", {
        d: "M14.13 7.25a2.08 2.08 0 00-4.15 0v1.29h4.15V7.25zm-5.74 8.41h7.32V9.93H8.39v5.73zm3-3.66a.7.7 0 111.39 0v1.58a.7.7 0 11-1.39 0V12z"
    })), $a5EUy.createElement("defs", null, $a5EUy.createElement("clipPath", {
        id: "security-bold_svg__security-bold_svg__clip0"
    }, $a5EUy.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});

});

parcelRegister("4byhk", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $30c2c77a6eb5d68d$var$__assign = undefined && undefined.__assign || function() {
    $30c2c77a6eb5d68d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $30c2c77a6eb5d68d$var$__assign.apply(this, arguments);
};
var $30c2c77a6eb5d68d$export$ef9b1a59e592288f = $a5EUy.forwardRef(function Select(props, svgRef) {
    return $a5EUy.createElement("svg", $30c2c77a6eb5d68d$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M18.608 24H9.983c-.191 0-.479-.096-.575-.288l-3.737-4.887c-.575-.767-.575-1.725-.096-2.492.67-.958 2.013-1.245 3.067-.575 0 0 .096 0 .096.096l.479.384v-8.05c0-1.15.958-2.109 2.204-2.109 1.246 0 2.204.958 2.204 2.109v5.175l3.45.766c1.725.383 2.97 2.013 2.78 3.833l-.48 5.367c0 .383-.383.671-.767.671zm-8.241-1.438h7.57l.384-4.695c.096-1.055-.671-2.109-1.725-2.3l-4.025-.863c-.288-.096-.575-.383-.575-.67v-5.75c0-.384-.288-.767-.671-.767-.287 0-.575.287-.575.67v9.296c0 .288-.192.48-.383.671-.288.096-.575.096-.767-.096l-1.63-1.245c-.382-.192-.766-.096-1.053.191-.192.288-.192.575 0 .863l3.45 4.695zm1.15-17.92a.756.756 0 01-.767-.767V1.767c0-.48.287-.767.767-.767.479 0 .766.288.766.767v2.108c-.095.383-.383.767-.766.767zm2.779.671a.732.732 0 01-.48-.192.752.752 0 010-1.054l1.438-1.438a.752.752 0 011.054 0 .752.752 0 010 1.054l-1.437 1.438c-.192.096-.383.191-.575.191zm-5.654 0a.732.732 0 01-.48-.192L6.63 3.683a.752.752 0 010-1.054.752.752 0 011.054 0l1.438 1.438a.752.752 0 010 1.054c-.192.096-.383.191-.48.191zm8.528 2.204h-2.108a.756.756 0 01-.766-.767c0-.48.287-.767.767-.767h2.108c.383 0 .767.288.767.767 0 .48-.288.767-.767.767zm-9.295 0H5.767A.756.756 0 015 6.75c0-.383.287-.767.767-.767h2.108c.383 0 .767.288.767.767 0 .48-.384.767-.767.767z"
    }));
});

});

parcelRegister("7yyM1", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $5806aeb10f6899fc$var$__assign = undefined && undefined.__assign || function() {
    $5806aeb10f6899fc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5806aeb10f6899fc$var$__assign.apply(this, arguments);
};
var $5806aeb10f6899fc$export$603458ca8a362063 = $a5EUy.forwardRef(function SelectBold(props, svgRef) {
    return $a5EUy.createElement("svg", $5806aeb10f6899fc$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M11.517.75c-.29 0-.551.088-.74.277-.19.189-.277.45-.277.74v2.108c0 .5.38 1.017 1.017 1.017.28 0 .51-.142.675-.321a1.49 1.49 0 00.334-.635l.007-.03v-2.14c0-.289-.088-.55-.276-.74-.19-.188-.45-.276-.74-.276zM7.86 2.452a1.002 1.002 0 00-1.408 0 1.002 1.002 0 000 1.408L7.99 5.3c.14.14.392.263.653.263a.56.56 0 00.16-.028c.047-.014.095-.033.142-.053.09-.038.192-.09.285-.136l.04-.02.029-.028a1.002 1.002 0 000-1.408L7.86 2.452zm7.217 0a1.002 1.002 0 011.408 0 1.002 1.002 0 010 1.408L15.02 5.326l-.058.03c-.175.087-.413.207-.665.207a.98.98 0 01-.656-.265 1.002 1.002 0 010-1.408l1.437-1.438zm-9.31 3.281c-.638 0-1.017.517-1.017 1.017 0 .5.38 1.017 1.017 1.017h2.108c.5 0 1.017-.38 1.017-1.017 0-.637-.517-1.017-1.017-1.017H5.767zm8.556.277c.189-.189.45-.277.74-.277h2.108c.5 0 1.017.38 1.017 1.017 0 .29-.088.55-.277.74-.19.189-.45.277-.74.277h-2.108c-.501 0-1.017-.38-1.017-1.017 0-.29.088-.55.277-.74zM9.983 24h8.625c.384 0 .767-.288.767-.67l.48-5.367c.19-1.821-1.055-3.45-2.78-3.834l-3.45-.766V8.188c0-1.15-.958-2.109-2.204-2.109-1.246 0-2.204.958-2.204 2.109v8.05l-.48-.384c0-.096-.095-.096-.095-.096-1.054-.67-2.396-.383-3.067.575-.48.767-.48 1.725.096 2.492l3.737 4.887c.096.192.384.288.575.288z"
    }));
});

});

parcelRegister("qKomK", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $05066a4ead5708b5$var$__assign = undefined && undefined.__assign || function() {
    $05066a4ead5708b5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $05066a4ead5708b5$var$__assign.apply(this, arguments);
};
var $05066a4ead5708b5$export$2b74fd7268b370b8 = $a5EUy.forwardRef(function SeoSearch(props, svgRef) {
    return $a5EUy.createElement("svg", $05066a4ead5708b5$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M18.875 2.5a2.375 2.375 0 100 4.75 2.375 2.375 0 000-4.75zM15 4.875a3.875 3.875 0 117.75 0 3.875 3.875 0 01-7.75 0z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M20.555 6.554a.75.75 0 011.06 0L23.78 8.72a.75.75 0 01-1.06 1.06l-2.165-2.166a.75.75 0 010-1.06zM2.5 3.75a.75.75 0 00-.75.75V6c0 .414.336.75.75.75H13a.75.75 0 010 1.5H2.5A2.25 2.25 0 01.25 6V4.5A2.25 2.25 0 012.5 2.25H13a.75.75 0 010 1.5H2.5zm-.75 7.875a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0zM5.5 12a.75.75 0 01.75-.75h12a.75.75 0 010 1.5h-12A.75.75 0 015.5 12zm-3.75 4.875a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0zm3.75.375a.75.75 0 01.75-.75h12a.75.75 0 010 1.5h-12a.75.75 0 01-.75-.75zm-3.75 4.875a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0zm3.75.375a.75.75 0 01.75-.75h12a.75.75 0 010 1.5h-12a.75.75 0 01-.75-.75z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("1Bu7D", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $12b09cc4fd417c44$var$__assign = undefined && undefined.__assign || function() {
    $12b09cc4fd417c44$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $12b09cc4fd417c44$var$__assign.apply(this, arguments);
};
var $12b09cc4fd417c44$export$f249f61886f02153 = $a5EUy.forwardRef(function SeoSearchBold(props, svgRef) {
    return $a5EUy.createElement("svg", $12b09cc4fd417c44$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M2.25 2.983H11a1 1 0 100-2H1.58C.73.963.024 1.633 0 2.483v3c.024.85.73 1.52 1.58 1.5H11a1 1 0 100-2H2.25a.25.25 0 01-.25-.25v-1.5a.25.25 0 01.25-.25z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M21.369 6.18a.249.249 0 00.043.3l2.297 2.3a1 1 0 01-1.414 1.414L20 7.894a.251.251 0 00-.3-.042 4.182 4.182 0 111.669-1.672zm-5.683-1.163a2.18 2.18 0 104.028-1.668 2.18 2.18 0 00-4.028 1.668z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M3 15.983a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm0 5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm11.5-6H5a1 1 0 100 2h9.5a1 1 0 100-2zm-11.5-4a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm11.5-1H5a1 1 0 100 2h9.5a1 1 0 100-2zm0 10H5a1 1 0 100 2h9.5a1 1 0 100-2z"
    }));
});

});

parcelRegister("9bZFF", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $6b14fabe193e4dd7$var$__assign = undefined && undefined.__assign || function() {
    $6b14fabe193e4dd7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6b14fabe193e4dd7$var$__assign.apply(this, arguments);
};
var $6b14fabe193e4dd7$export$d59771a2e9612de9 = $a5EUy.forwardRef(function Server(props, svgRef) {
    return $a5EUy.createElement("svg", $6b14fabe193e4dd7$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M13.509 9H12a.761.761 0 00-.754.754c0 .412.343.755.754.755h1.509a.761.761 0 00.754-.755.761.761 0 00-.754-.754zm6.737.754A.76.76 0 0019.49 9h-3a.761.761 0 00-.754.754c0 .412.343.755.754.755h3c.429-.018.755-.343.755-.755zM5.623 8.623c-.617 0-1.132.497-1.132 1.114 0 .617.498 1.132 1.115 1.132a1.13 1.13 0 001.131-1.132c.017-.6-.497-1.114-1.114-1.114zM13.509 18H12a.761.761 0 00-.754.754c0 .412.343.755.754.755h1.509a.761.761 0 00.754-.755.761.761 0 00-.754-.754zm6 0H16.49a.761.761 0 00-.754.754c0 .412.343.755.754.755h3a.761.761 0 00.755-.755.746.746 0 00-.737-.754z"
    }), $a5EUy.createElement("path", {
        d: "M21.446 14.246A5.235 5.235 0 0024 9.754a5.04 5.04 0 00-.497-2.211v-.017l-2.52-5.366A3.742 3.742 0 0017.589 0H6.41a3.76 3.76 0 00-3.394 2.16L.497 7.526v.017A5.04 5.04 0 000 9.754a5.235 5.235 0 002.554 4.492A5.264 5.264 0 000 18.754 5.246 5.246 0 005.246 24h13.508A5.246 5.246 0 0024 18.754c0-1.92-1.029-3.583-2.554-4.508zM4.37 2.794a2.27 2.27 0 012.04-1.303h11.195a2.27 2.27 0 012.04 1.303l.96 2.04a5.357 5.357 0 00-1.835-.325H5.246c-.652 0-1.269.12-1.835.325l.96-2.04zm-2.86 6.96A3.748 3.748 0 015.246 6h13.508a3.753 3.753 0 013.755 3.754 3.753 3.753 0 01-3.755 3.755H5.246c-2.057 0-3.737-1.698-3.737-3.755zm17.245 12.737H5.246a3.753 3.753 0 01-3.755-3.754 3.753 3.753 0 013.755-3.754h13.508a3.753 3.753 0 013.755 3.754 3.764 3.764 0 01-3.755 3.754z"
    }), $a5EUy.createElement("path", {
        d: "M5.623 17.623c-.617 0-1.132.497-1.132 1.114 0 .309.12.583.326.789a1.13 1.13 0 001.92-.806c.017-.583-.497-1.097-1.114-1.097z"
    }));
});

});

parcelRegister("9USAO", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $7383b0ffb638938b$var$__assign = undefined && undefined.__assign || function() {
    $7383b0ffb638938b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7383b0ffb638938b$var$__assign.apply(this, arguments);
};
var $7383b0ffb638938b$export$c72f6eaae7b9adff = $a5EUy.forwardRef(function Settings(props, svgRef) {
    return $a5EUy.createElement("svg", $7383b0ffb638938b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M12 7.25a4.75 4.75 0 100 9.5 4.75 4.75 0 000-9.5zM8.75 12a3.25 3.25 0 116.5 0 3.25 3.25 0 01-6.5 0z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M20.581 6.954l.611-.61a1.5 1.5 0 000-2.122l-1.415-1.413a1.5 1.5 0 00-2.121 0l-.612.612c-.418.417-1.059.498-1.604.272-.545-.227-.94-.736-.94-1.327V1.5A1.5 1.5 0 0013 0h-2a1.5 1.5 0 00-1.5 1.5v.866c0 .59-.395 1.1-.94 1.327-.546.227-1.187.145-1.605-.272l-.612-.612a1.5 1.5 0 00-2.121 0L2.807 4.223a1.5 1.5 0 000 2.122l.612.611c.418.418.499 1.059.272 1.604-.226.545-.735.94-1.325.94H1.5A1.5 1.5 0 000 11v2a1.5 1.5 0 001.5 1.5h.865c.59 0 1.1.395 1.327.94.226.546.145 1.187-.273 1.605l-.613.613a1.5 1.5 0 000 2.121l1.414 1.414a1.545 1.545 0 002.122 0l.611-.61c.419-.42 1.06-.5 1.606-.273.546.226.941.737.941 1.328v.862A1.5 1.5 0 0011 24h2a1.5 1.5 0 001.5-1.5v-.863c0-.59.395-1.1.94-1.327.546-.227 1.187-.145 1.605.272l.612.612a1.5 1.5 0 002.121 0l1.414-1.414a1.5 1.5 0 000-2.121l-.611-.611c-.418-.418-.5-1.059-.273-1.605.227-.546.737-.941 1.328-.941h.864A1.5 1.5 0 0024 13v-2a1.5 1.5 0 00-1.5-1.5h-.865c-.59 0-1.1-.395-1.327-.94-.226-.547-.145-1.188.273-1.606zM18.717 3.87l1.415 1.413-.61.61c-.914.913-1.02 2.224-.6 3.24C19.343 10.15 20.346 11 21.635 11h.865v2.002h-.864c-1.29 0-2.293.852-2.713 1.866-.421 1.016-.316 2.328.597 3.24l.611.611-1.413 1.414-.613-.612c-.913-.912-2.224-1.018-3.24-.597C13.85 19.346 13 20.348 13 21.637v.863h-2v-.863c0-1.289-.85-2.291-1.866-2.713-1.016-.422-2.328-.316-3.24.597l-.587.585a.045.045 0 01-.052 0l-1.388-1.388.613-.613c.913-.913 1.018-2.224.597-3.24C4.657 13.852 3.655 13 2.365 13H1.5v-2h.866c1.29 0 2.29-.85 2.71-1.865.422-1.015.317-2.327-.597-3.24l-.612-.611L5.282 3.87l.613.612c.912.912 2.224 1.018 3.24.597C10.15 4.657 11 3.655 11 2.366V1.5h2v.866c0 1.29.85 2.291 1.865 2.712 1.015.421 2.326.316 3.239-.596l.613-.612z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("aklsT", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $784c6c2a84e47842$var$__assign = undefined && undefined.__assign || function() {
    $784c6c2a84e47842$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $784c6c2a84e47842$var$__assign.apply(this, arguments);
};
var $784c6c2a84e47842$export$18e4ef42d74628e8 = $a5EUy.forwardRef(function SettingsBold(props, svgRef) {
    return $a5EUy.createElement("svg", $784c6c2a84e47842$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M20.581 6.954l.611-.61a1.5 1.5 0 000-2.122l-1.415-1.413a1.5 1.5 0 00-2.121 0l-.612.612c-.418.417-1.059.498-1.604.272-.545-.227-.94-.736-.94-1.327V1.5A1.5 1.5 0 0013 0h-2a1.5 1.5 0 00-1.5 1.5v.866c0 .59-.395 1.1-.94 1.327-.546.227-1.187.145-1.605-.272l-.612-.612a1.5 1.5 0 00-2.121 0L2.807 4.223a1.5 1.5 0 000 2.122l.612.611c.418.418.499 1.059.272 1.604-.226.545-.735.94-1.325.94H1.5A1.5 1.5 0 000 11v2a1.5 1.5 0 001.5 1.5h.865c.59 0 1.1.395 1.327.94.226.546.145 1.187-.273 1.605l-.613.613a1.5 1.5 0 000 2.121l1.414 1.414a1.545 1.545 0 002.122 0l.611-.61c.419-.42 1.06-.5 1.606-.273.546.226.941.737.941 1.328v.862A1.5 1.5 0 0011 24h2a1.5 1.5 0 001.5-1.5v-.863c0-.59.395-1.1.94-1.327.546-.227 1.187-.145 1.605.272l.612.612a1.5 1.5 0 002.121 0l1.414-1.414a1.5 1.5 0 000-2.121l-.611-.611c-.418-.418-.5-1.059-.273-1.605.227-.546.737-.941 1.328-.941h.864A1.5 1.5 0 0024 13v-2a1.5 1.5 0 00-1.5-1.5h-.865c-.59 0-1.1-.395-1.327-.94-.226-.547-.145-1.188.273-1.606zM12 16a4 4 0 100-8 4 4 0 000 8z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("gZu9w", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $c5e9bb88da3dca6b$var$__assign = undefined && undefined.__assign || function() {
    $c5e9bb88da3dca6b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c5e9bb88da3dca6b$var$__assign.apply(this, arguments);
};
var $c5e9bb88da3dca6b$export$c9915453de10000b = $a5EUy.forwardRef(function Share(props, svgRef) {
    return $a5EUy.createElement("svg", $c5e9bb88da3dca6b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M6.15 9.5a.65.65 0 00-.65.65v11.2a.65.65 0 00.65.65h12.6a.65.65 0 00.65-.65v-11.2a.65.65 0 00-.65-.65h-1.4a.75.75 0 010-1.5h1.4a2.15 2.15 0 012.15 2.15v11.2a2.15 2.15 0 01-2.15 2.15H6.15A2.15 2.15 0 014 21.35v-11.2A2.15 2.15 0 016.15 8h1.4a.75.75 0 010 1.5h-1.4z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M11.92 1.22a.748.748 0 011.06 0l3.5 3.5a.75.75 0 01-1.06 1.06L13.2 3.56v7.99a.75.75 0 01-1.5 0V3.56L9.48 5.78a.75.75 0 01-1.06-1.06l3.5-3.5z"
    }));
});

});

parcelRegister("5kyd5", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $3e195b6c38eadb10$var$__assign = undefined && undefined.__assign || function() {
    $3e195b6c38eadb10$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3e195b6c38eadb10$var$__assign.apply(this, arguments);
};
var $3e195b6c38eadb10$export$4781d373f2233cee = $a5EUy.forwardRef(function ShareBold(props, svgRef) {
    return $a5EUy.createElement("svg", $3e195b6c38eadb10$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M6 10h1.3a1.5 1.5 0 100-3H5.9A2.9 2.9 0 003 9.9v11.2A2.9 2.9 0 005.9 24h12.6a2.9 2.9 0 002.9-2.9V9.9A2.899 2.899 0 0018.5 7h-1.4a1.5 1.5 0 000 3h1.3v11H6V10z"
    }), $a5EUy.createElement("path", {
        d: "M11.19.43a1.4 1.4 0 012-.02l3.29 3.29a1.414 1.414 0 01-2 2l-.88-.88v5.8a1.41 1.41 0 01-2.82 0V4.81l-.88.88a1.414 1.414 0 01-2-2L11.19.43z"
    }));
});

});

parcelRegister("7MzzB", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $5aa89c366a99b150$var$__assign = undefined && undefined.__assign || function() {
    $5aa89c366a99b150$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5aa89c366a99b150$var$__assign.apply(this, arguments);
};
var $5aa89c366a99b150$export$8446584e1e5a8d07 = $a5EUy.forwardRef(function ShoppingBagEmpty(props, svgRef) {
    return $a5EUy.createElement("svg", $5aa89c366a99b150$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("g", {
        clipPath: "url(#shopping-bag-empty_svg__shopping-bag-empty_svg__clip0)"
    }, $a5EUy.createElement("path", {
        d: "M4.806 6H19.18a2.157 2.157 0 012.048 1.8l2.006 13.98c.033.6-.192 1.186-.618 1.61a2.077 2.077 0 01-1.567.61l-18.066-.001a2.107 2.107 0 01-1.612-.609c-.426-.424-.651-1.009-.612-1.675L2.76 7.777a2.15 2.15 0 012.206-1.776L4.807 6zM19.05 7.5H4.906a.645.645 0 00-.663.514L2.249 21.863a.607.607 0 00.178.463.642.642 0 00.51.174l18.157.001a.606.606 0 00.463-.175.608.608 0 00.185-.397L19.745 8.037c-.056-.321-.34-.55-.696-.537zM11.98 0a4.515 4.515 0 014.42 3.666.75.75 0 01-1.474.282A3.014 3.014 0 0011.98 1.5a3.013 3.013 0 00-2.943 2.432.75.75 0 01-1.472-.288A4.514 4.514 0 0111.98 0z"
    })), $a5EUy.createElement("defs", null, $a5EUy.createElement("clipPath", {
        id: "shopping-bag-empty_svg__shopping-bag-empty_svg__clip0"
    }, $a5EUy.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});

});

parcelRegister("3ILQb", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $2b5a974f81e84951$var$__assign = undefined && undefined.__assign || function() {
    $2b5a974f81e84951$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2b5a974f81e84951$var$__assign.apply(this, arguments);
};
var $2b5a974f81e84951$export$6bf565d591efd349 = $a5EUy.forwardRef(function ShoppingBagEmptyBold(props, svgRef) {
    return $a5EUy.createElement("svg", $2b5a974f81e84951$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("g", {
        clipPath: "url(#shopping-bag-empty-bold_svg__shopping-bag-empty-bold_svg__clip0)"
    }, $a5EUy.createElement("path", {
        d: "M4.967 6h14.212a2.157 2.157 0 012.048 1.8l2.006 13.98c.033.6-.192 1.186-.618 1.61a2.077 2.077 0 01-1.567.61l-18.066-.001a2.107 2.107 0 01-1.612-.609c-.426-.424-.651-1.009-.612-1.675L2.76 7.777a2.15 2.15 0 012.206-1.776zm7.012-6a4.515 4.515 0 014.42 3.666.75.75 0 01-1.474.282A3.014 3.014 0 0011.98 1.5a3.013 3.013 0 00-2.943 2.432.75.75 0 01-1.472-.288A4.514 4.514 0 0111.98 0z"
    })), $a5EUy.createElement("defs", null, $a5EUy.createElement("clipPath", {
        id: "shopping-bag-empty-bold_svg__shopping-bag-empty-bold_svg__clip0"
    }, $a5EUy.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});

});

parcelRegister("gSIgl", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $c4a40618e5298e10$var$__assign = undefined && undefined.__assign || function() {
    $c4a40618e5298e10$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c4a40618e5298e10$var$__assign.apply(this, arguments);
};
var $c4a40618e5298e10$export$4a37ae897f9e8014 = $a5EUy.forwardRef(function StatusError(props, svgRef) {
    return $a5EUy.createElement("svg", $c4a40618e5298e10$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M17.03 6.97a.75.75 0 010 1.06L13.06 12l3.97 3.97a.75.75 0 11-1.06 1.06L12 13.06l-3.97 3.97a.75.75 0 01-1.06-1.06L10.94 12 6.97 8.03a.75.75 0 011.06-1.06L12 10.94l3.97-3.97a.75.75 0 011.06 0z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-1.5 0c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("3NDHP", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $2c44bf7716a14028$var$__assign = undefined && undefined.__assign || function() {
    $2c44bf7716a14028$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2c44bf7716a14028$var$__assign.apply(this, arguments);
};
var $2c44bf7716a14028$export$750f42de29e1826b = $a5EUy.forwardRef(function StatusErrorBold(props, svgRef) {
    return $a5EUy.createElement("svg", $2c44bf7716a14028$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm5.56-17.56a1.5 1.5 0 010 2.12L14.122 12l3.44 3.44a1.5 1.5 0 01-2.122 2.12L12 14.122l-3.44 3.44a1.5 1.5 0 01-2.12-2.122L9.878 12l-3.44-3.44A1.5 1.5 0 118.56 6.44L12 9.878l3.44-3.44a1.5 1.5 0 012.12 0z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("5LE6s", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $43307335a54d1af1$var$__assign = undefined && undefined.__assign || function() {
    $43307335a54d1af1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $43307335a54d1af1$var$__assign.apply(this, arguments);
};
var $43307335a54d1af1$export$e0c13b137c9285c0 = $a5EUy.forwardRef(function StatusHelp(props, svgRef) {
    return $a5EUy.createElement("svg", $43307335a54d1af1$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M12.825 14.11h-1.32a2.008 2.008 0 01-.198-.868c0-.986.73-1.676 1.577-2.425.986-.927 1.538-1.46 1.538-2.425 0-1.184-.867-1.992-1.932-1.992-1.005 0-1.814.631-2.208 1.893L9 7.761C9.513 6.006 10.794 5 12.53 5 14.442 5 16 6.36 16 8.293c0 1.321-.769 2.208-1.873 3.194-.868.79-1.4 1.282-1.4 1.992 0 .203.043.391.08.552l.018.079zm.69 3.096c0 .73-.571 1.242-1.261 1.242a1.237 1.237 0 01-1.243-1.242c0-.73.592-1.243 1.243-1.243.69 0 1.261.513 1.261 1.243z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M0 12C0 5.383 5.383 0 12 0s12 5.383 12 12-5.383 12-12 12S0 18.617 0 12zm1.509 0c0 5.777 4.697 10.491 10.491 10.491S22.491 17.777 22.491 12c0-5.777-4.697-10.491-10.491-10.491S1.509 6.223 1.509 12z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("h9huQ", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $c7c0d95cd884cb4a$var$__assign = undefined && undefined.__assign || function() {
    $c7c0d95cd884cb4a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c7c0d95cd884cb4a$var$__assign.apply(this, arguments);
};
var $c7c0d95cd884cb4a$export$493d925eb43dfdfe = $a5EUy.forwardRef(function StatusHelpBold(props, svgRef) {
    return $a5EUy.createElement("svg", $c7c0d95cd884cb4a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M0 12C0 5.383 5.383 0 12 0s12 5.383 12 12-5.383 12-12 12S0 18.617 0 12zm12.934 1.731h-2.315a2.457 2.457 0 01-.223-.975c0-.812.61-1.502 1.604-2.294.832-.69 1.198-1.056 1.198-1.706 0-.73-.569-1.238-1.28-1.238-.75 0-1.299.528-1.684 1.543L8 8.086C8.589 6.016 10.091 5 12 5c2.213 0 4 1.401 4 3.553 0 1.198-.569 1.99-1.685 2.965l-.218.189c-.7.608-1.204 1.044-1.204 1.598 0 .162.02.304.041.426zM13.746 17c0 1.076-.812 1.888-1.888 1.888-1.097 0-1.909-.812-1.909-1.888 0-1.056.812-1.888 1.909-1.888A1.86 1.86 0 0113.746 17z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("9F2Ce", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $7089f8d2d5c361d3$var$__assign = undefined && undefined.__assign || function() {
    $7089f8d2d5c361d3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7089f8d2d5c361d3$var$__assign.apply(this, arguments);
};
var $7089f8d2d5c361d3$export$390e0440e6f2b300 = $a5EUy.forwardRef(function StatusInformation(props, svgRef) {
    return $a5EUy.createElement("svg", $7089f8d2d5c361d3$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M3.515 3.515a12 12 0 1116.97 16.97 12 12 0 01-16.97-16.97zM12 1.5a10.5 10.5 0 100 21 10.5 10.5 0 000-21z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M12.044 7.016a1.01 1.01 0 001.026-1.008C13.07 5.45 12.602 5 12.044 5 11.468 5 11 5.45 11 6.008c0 .576.468 1.008 1.044 1.008zm-.702 11.106h1.386V9.356h-1.386v8.766z"
    }));
});

});

parcelRegister("5NEgo", function(module, exports) {

$parcel$export(module.exports, "StatusInformationBold", function () { return $4390c2d16cf5aa2f$export$d8874184141c994a; });

var $a5EUy = parcelRequire("a5EUy");
var $4390c2d16cf5aa2f$var$__assign = undefined && undefined.__assign || function() {
    $4390c2d16cf5aa2f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4390c2d16cf5aa2f$var$__assign.apply(this, arguments);
};
var $4390c2d16cf5aa2f$export$d8874184141c994a = $a5EUy.forwardRef(function StatusInformationBold(props, svgRef) {
    return $a5EUy.createElement("svg", $4390c2d16cf5aa2f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M12 0a12 12 0 100 24 12 12 0 000-24zm1.57 6.008c0 .87-.71 1.508-1.526 1.508-.829 0-1.544-.633-1.544-1.508 0-.851.71-1.508 1.544-1.508.823 0 1.526.662 1.526 1.508zm-2.728 12.614V9.4h2.386v9.222h-2.386z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("9Y2zh", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $741bb5998a392220$var$__assign = undefined && undefined.__assign || function() {
    $741bb5998a392220$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $741bb5998a392220$var$__assign.apply(this, arguments);
};
var $741bb5998a392220$export$785e45f1d8c03432 = $a5EUy.forwardRef(function StatusSuccess(props, svgRef) {
    return $a5EUy.createElement("svg", $741bb5998a392220$var$__assign({
        fill: "currentColor",
        height: 25,
        ref: svgRef,
        viewBox: "0 0 24 25",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M18.53 8.531a.75.75 0 00-1.06-1.06L9 15.94l-3.47-3.47a.75.75 0 00-1.06 1.06l4 4a.75.75 0 001.06 0l9-9z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12 12-5.373 12-12zM1.5 12C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12 17.799 22.5 12 22.5 1.5 17.799 1.5 12z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("bWBwj", function(module, exports) {

$parcel$export(module.exports, "StatusSuccessBold", function () { return $8b223736331270bf$export$17e1460061865da; });

var $a5EUy = parcelRequire("a5EUy");
var $8b223736331270bf$var$__assign = undefined && undefined.__assign || function() {
    $8b223736331270bf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8b223736331270bf$var$__assign.apply(this, arguments);
};
var $8b223736331270bf$export$17e1460061865da = $a5EUy.forwardRef(function StatusSuccessBold(props, svgRef) {
    return $a5EUy.createElement("svg", $8b223736331270bf$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-4.94-2.94a1.5 1.5 0 00-2.12-2.12L9 14.878l-2.94-2.94a1.5 1.5 0 00-2.12 2.122l4 4a1.5 1.5 0 002.12 0l9-9z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("jJtdA", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $e5d8e263420c2951$var$__assign = undefined && undefined.__assign || function() {
    $e5d8e263420c2951$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e5d8e263420c2951$var$__assign.apply(this, arguments);
};
var $e5d8e263420c2951$export$a2518b5310db22ab = $a5EUy.forwardRef(function StatusWarning(props, svgRef) {
    return $a5EUy.createElement("svg", $e5d8e263420c2951$var$__assign({
        fill: "currentColor",
        height: 25,
        ref: svgRef,
        viewBox: "0 0 24 25",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M23.75 20.727L14.289 1.424C13.98.807 13.466.344 12.815.138a2.576 2.576 0 00-1.954.12 2.56 2.56 0 00-1.166 1.166L.23 20.727a2.272 2.272 0 001.028 3.034c.31.154.652.24.995.24H21.71a2.26 2.26 0 002.263-2.263 2.037 2.037 0 00-.223-1.011zm-1.49 1.543a.793.793 0 01-.55.223H2.255a.791.791 0 01-.703-1.114l9.497-19.287c.103-.205.274-.377.48-.48a1.14 1.14 0 01.463-.102c.394 0 .771.222.943.582l9.48 19.303a.781.781 0 01.085.343c-.017.206-.085.395-.24.532z"
    }), $a5EUy.createElement("path", {
        d: "M11.558 16.119h1.152l.252-8.118h-1.674l.27 8.118zm.576 3.96c.63 0 1.134-.468 1.134-1.134 0-.666-.504-1.134-1.134-1.134-.612 0-1.134.468-1.134 1.134 0 .666.522 1.134 1.134 1.134z"
    }));
});

});

parcelRegister("6yLT8", function(module, exports) {

$parcel$export(module.exports, "StatusWarningBold", function () { return $4c6b10a70c585b2f$export$f1b6053a528b50d9; });

var $a5EUy = parcelRequire("a5EUy");
var $4c6b10a70c585b2f$var$__assign = undefined && undefined.__assign || function() {
    $4c6b10a70c585b2f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4c6b10a70c585b2f$var$__assign.apply(this, arguments);
};
var $4c6b10a70c585b2f$export$f1b6053a528b50d9 = $a5EUy.forwardRef(function StatusWarningBold(props, svgRef) {
    return $a5EUy.createElement("svg", $4c6b10a70c585b2f$var$__assign({
        fill: "currentColor",
        height: 25,
        ref: svgRef,
        viewBox: "0 0 24 25",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M14.297 1.424l9.463 19.303c.154.308.24.651.223 1.011a2.26 2.26 0 01-2.263 2.263H2.263c-.343 0-.686-.086-.994-.24a2.272 2.272 0 01-1.03-3.034L9.704 1.424A2.56 2.56 0 0110.868.258a2.576 2.576 0 011.955-.12c.651.206 1.165.669 1.474 1.286zm-1.263 14.352h-2.046l-.483-7.775h2.994l-.465 7.775zm.726 2.995c0 .986-.744 1.73-1.711 1.73-1.024 0-1.749-.744-1.749-1.73 0-.967.725-1.73 1.749-1.73.967 0 1.71.763 1.71 1.73z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("9TLO0", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $734e5549312aad1a$var$__assign = undefined && undefined.__assign || function() {
    $734e5549312aad1a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $734e5549312aad1a$var$__assign.apply(this, arguments);
};
var $734e5549312aad1a$export$e16de4ea1abb52c8 = $a5EUy.forwardRef(function Stopwatch(props, svgRef) {
    return $a5EUy.createElement("svg", $734e5549312aad1a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M8.807 10.346a.75.75 0 00-1.114 1.006l3.75 4.15a.75.75 0 001.114-1.005l-3.75-4.15z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M14.25 1.5h-1.5v3.029a9.751 9.751 0 015.18 1.981l.907-.908a.75.75 0 011.193-.882l.375.375.375.375a.75.75 0 01-.882 1.193l-.85.85a9.75 9.75 0 11-7.798-2.984V1.5h-1.5a.75.75 0 010-1.5h4.5a.75.75 0 010 1.5zM12 6a8.25 8.25 0 100 16.5A8.25 8.25 0 0012 6z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("frXCm", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $b3f79f7196cb8b3a$var$__assign = undefined && undefined.__assign || function() {
    $b3f79f7196cb8b3a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b3f79f7196cb8b3a$var$__assign.apply(this, arguments);
};
var $b3f79f7196cb8b3a$export$da6e25dd6239a135 = $a5EUy.forwardRef(function StopwatchBold(props, svgRef) {
    return $a5EUy.createElement("svg", $b3f79f7196cb8b3a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M13.5 1.5h.75a.75.75 0 000-1.5h-4.5a.75.75 0 000 1.5h.75v3.116a9.75 9.75 0 108.901 3.287l1.32-1.319a.75.75 0 00.06-1.115l-.75-.75a.75.75 0 00-1.11.054l-1.424 1.424a9.755 9.755 0 00-3.997-1.58V1.5zM7.395 12.395l3.307 3.307c.484.484 1.351.402 1.937-.184.586-.586.668-1.453.184-1.938l-3.307-3.306c-.484-.484-1.351-.402-1.937.184-.586.586-.668 1.453-.184 1.937z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("gBcpo", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $c159ba1ef745db92$var$__assign = undefined && undefined.__assign || function() {
    $c159ba1ef745db92$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c159ba1ef745db92$var$__assign.apply(this, arguments);
};
var $c159ba1ef745db92$export$88a6666ae2487175 = $a5EUy.forwardRef(function Strategy(props, svgRef) {
    return $a5EUy.createElement("svg", $c159ba1ef745db92$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("g", {
        clipPath: "url(#strategy_svg__strategy_svg__clip0)"
    }, $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M10.879.618a1.303 1.303 0 012.25.013l2.343 4.154A1.304 1.304 0 0114.35 6.75h-1.6v9.743c1.066-1.557 2.696-2.712 4.875-3.515l-.73-1.753a1.305 1.305 0 011.384-1.789l4.6.647a1.303 1.303 0 01.862 2.076l-2.793 3.709a1.305 1.305 0 01-2.246-.288l-.502-1.215c-3.592 1.302-5.358 3.562-5.446 7.287l-.004.299v1.3a.75.75 0 01-1.493.102l-.007-.102v-1.305c-.002-3.901-1.764-6.245-5.45-7.581l-.502 1.216a1.305 1.305 0 01-2.247.285L.26 12.161a1.303 1.303 0 01.86-2.078l4.6-.647a1.305 1.305 0 011.383 1.793l-.729 1.75c2.18.802 3.809 1.957 4.875 3.514V6.75h-1.6a1.303 1.303 0 01-1.128-1.952l2.357-4.18zM12 5.25h2.012L12 1.682 9.988 5.25H12zm-7.187 7.579l.774-1.86-3.93.553 2.385 3.168.77-1.861zm17.529-1.307l-3.93-.553.776 1.861.768 1.859 2.386-3.167z",
        fillRule: "evenodd"
    })), $a5EUy.createElement("defs", null, $a5EUy.createElement("clipPath", {
        id: "strategy_svg__strategy_svg__clip0"
    }, $a5EUy.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});

});

parcelRegister("rB8RG", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $052f555af481c012$var$__assign = undefined && undefined.__assign || function() {
    $052f555af481c012$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $052f555af481c012$var$__assign.apply(this, arguments);
};
var $052f555af481c012$export$c058c71d1bbd656d = $a5EUy.forwardRef(function StrategyBold(props, svgRef) {
    return $a5EUy.createElement("svg", $052f555af481c012$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M12 24c.306 0 .6-.126.816-.352.216-.224.338-.53.338-.848v-.404c-.008-3.763 2.036-7.206 5.274-8.884a.225.225 0 01.184-.01c.06.024.108.072.133.133l.232.582a.929.929 0 00.854.593.91.91 0 00.739-.384l2.322-3.208a.992.992 0 00.116-.946.93.93 0 00-.725-.583l-3.827-.56a.907.907 0 00-.857.364.992.992 0 00-.123.955l.207.52a.244.244 0 01-.113.31 11.909 11.909 0 00-4.007 3.252.226.226 0 01-.256.072.24.24 0 01-.153-.225V6.923a.25.25 0 01.067-.17.225.225 0 01.164-.07h.745a.956.956 0 00.837-.503c.172-.312.17-.696-.007-1.006l-2.13-3.758A.993.993 0 0012 .958a.993.993 0 00-.83.458L9.04 5.174c-.175.31-.177.694-.005 1.006a.957.957 0 00.836.504h.745c.06 0 .12.024.163.07a.244.244 0 01.067.17v7.453a.24.24 0 01-.153.225.226.226 0 01-.256-.072 11.909 11.909 0 00-4.007-3.253.244.244 0 01-.112-.308l.206-.521a.992.992 0 00-.122-.955.906.906 0 00-.858-.363l-3.827.56a.93.93 0 00-.725.583.992.992 0 00.116.946l2.326 3.209a.911.911 0 00.855.376.929.929 0 00.738-.585l.232-.582a.239.239 0 01.133-.133.223.223 0 01.184.01c3.239 1.679 5.282 5.121 5.275 8.884v.404c0 .66.514 1.195 1.15 1.198z"
    }));
});

});

parcelRegister("1bZNG", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $0de6c1c455e86b10$var$__assign = undefined && undefined.__assign || function() {
    $0de6c1c455e86b10$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0de6c1c455e86b10$var$__assign.apply(this, arguments);
};
var $0de6c1c455e86b10$export$616b2c96b9b691e = $a5EUy.forwardRef(function SupportChat(props, svgRef) {
    return $a5EUy.createElement("svg", $0de6c1c455e86b10$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M12.5 2.438a7.188 7.188 0 00-7.152 6.469 1.438 1.438 0 011.402 1.437v7.187a1.438 1.438 0 01-1.438 1.438h-.718A3.594 3.594 0 011 15.375V12.5a3.594 3.594 0 012.9-3.526 8.625 8.625 0 0117.2 0A3.593 3.593 0 0124 12.5v2.875a3.594 3.594 0 01-2.875 3.521v.073a3.593 3.593 0 01-3.594 3.593h-1.56A2.156 2.156 0 0113.936 24H12.5a2.157 2.157 0 010-4.313h1.438a2.156 2.156 0 012.032 1.438h1.561a2.157 2.157 0 002.157-2.156 1.438 1.438 0 01-1.438-1.438v-7.187a1.438 1.438 0 011.401-1.437 7.187 7.187 0 00-7.151-6.47zm1.946 18.898a.719.719 0 01-.508 1.227H12.5a.719.719 0 110-1.438h1.438c.19 0 .373.076.508.21zm5.96-3.805a2.156 2.156 0 002.157-2.156V12.5a2.157 2.157 0 00-2.157-2.156h-.718v7.187h.718zM3.07 10.975a2.156 2.156 0 011.525-.631h.718v7.187h-.718a2.156 2.156 0 01-2.157-2.156V12.5c0-.572.228-1.12.632-1.525z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M10.11 15.267a.719.719 0 00-.97 1.063 4.987 4.987 0 006.72 0 .719.719 0 00-.97-1.063 3.55 3.55 0 01-4.78 0zM9.625 9.85a.72.72 0 01.719.719v1.257a.719.719 0 01-1.438 0V10.57a.72.72 0 01.719-.719zm6.469.719a.719.719 0 10-1.438 0v1.257a.719.719 0 001.438 0V10.57z"
    }));
});

});

parcelRegister("a0n27", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $748bc562e267b790$var$__assign = undefined && undefined.__assign || function() {
    $748bc562e267b790$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $748bc562e267b790$var$__assign.apply(this, arguments);
};
var $748bc562e267b790$export$9c6a6487c263eb9c = $a5EUy.forwardRef(function SupportChatBold(props, svgRef) {
    return $a5EUy.createElement("svg", $748bc562e267b790$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M10.986.044a9 9 0 019.838 8.002 3.969 3.969 0 012.926 3.829v2.875a3.969 3.969 0 01-2.881 3.817 3.969 3.969 0 01-3.963 3.745h-1.31a2.528 2.528 0 01-2.284 1.438h-1.437a2.531 2.531 0 010-5.063h1.438a2.531 2.531 0 012.282 1.438h1.311a1.782 1.782 0 001.75-1.452 1.813 1.813 0 01-1.406-1.767V9.72a1.813 1.813 0 011.358-1.755 6.813 6.813 0 00-13.466 0A1.812 1.812 0 016.5 9.72v7.187a1.812 1.812 0 01-1.813 1.813H3.97A3.969 3.969 0 010 14.75v-2.875a3.969 3.969 0 012.926-3.83 9 9 0 018.06-8.001z"
    }), $a5EUy.createElement("path", {
        d: "M13.656 9.944a1.094 1.094 0 012.188 0v1.257a1.094 1.094 0 11-2.188 0V9.944zm-5.464 4.493a1.094 1.094 0 011.545-.072 3.175 3.175 0 004.276 0 1.094 1.094 0 111.474 1.617 5.362 5.362 0 01-7.224 0 1.094 1.094 0 01-.071-1.545zM9 8.85c-.604 0-1.094.49-1.094 1.094v1.257a1.094 1.094 0 102.188 0V9.944c0-.604-.49-1.094-1.094-1.094z"
    }));
});

});

parcelRegister("9ErvD", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $706d30435318faa9$var$__assign = undefined && undefined.__assign || function() {
    $706d30435318faa9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $706d30435318faa9$var$__assign.apply(this, arguments);
};
var $706d30435318faa9$export$3288d34c523a1192 = $a5EUy.forwardRef(function Tag(props, svgRef) {
    return $a5EUy.createElement("svg", $706d30435318faa9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M18 3.75a2.25 2.25 0 110 4.499 2.25 2.25 0 010-4.499zm.287 1.557a.75.75 0 10-.574 1.386.75.75 0 00.574-1.386z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M21.75 0A2.25 2.25 0 0124 2.25v6.257a3.75 3.75 0 01-1.098 2.651L11.342 22.72a2.25 2.25 0 01-3.182 0l-6.88-6.88a2.25 2.25 0 010-3.181L12.843 1.097A3.75 3.75 0 0115.493 0h6.257zm.53 1.72a.75.75 0 00-.53-.22h-6.257a2.25 2.25 0 00-1.59.658L2.34 13.72a.75.75 0 000 1.06l6.88 6.88a.75.75 0 001.06 0l11.56-11.561a2.25 2.25 0 00.659-1.591V2.25a.75.75 0 00-.22-.53z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("4hM42", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $31ee087e03de2077$var$__assign = undefined && undefined.__assign || function() {
    $31ee087e03de2077$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $31ee087e03de2077$var$__assign.apply(this, arguments);
};
var $31ee087e03de2077$export$eb1b14be98724170 = $a5EUy.forwardRef(function TagBold(props, svgRef) {
    return $a5EUy.createElement("svg", $31ee087e03de2077$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M21.966.373a2.25 2.25 0 00-.527-.063h-6.257a3.752 3.752 0 00-2.65 1.098L.97 12.968a2.25 2.25 0 000 3.182l6.879 6.88a2.25 2.25 0 003.182 0l11.56-11.562a3.753 3.753 0 001.098-2.65V2.56A2.25 2.25 0 0021.966.373z"
    }));
});

});

parcelRegister("7hlam", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $54ca8a144dc4a4fb$var$__assign = undefined && undefined.__assign || function() {
    $54ca8a144dc4a4fb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $54ca8a144dc4a4fb$var$__assign.apply(this, arguments);
};
var $54ca8a144dc4a4fb$export$a51f2b8e6ae258ea = $a5EUy.forwardRef(function Target(props, svgRef) {
    return $a5EUy.createElement("svg", $54ca8a144dc4a4fb$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M19.735.61a.75.75 0 00-1.262-.395l-3.248 3.192a.75.75 0 00-.216.423l-.53 3.506-3.993 3.993a.75.75 0 101.06 1.06l3.993-3.992 3.506-.532a.75.75 0 00.423-.215l3.192-3.248a.75.75 0 00-.394-1.263l-2.124-.406-.407-2.124zm-3.658 6.188l.378-2.496 2.07-2.035.24 1.248a.75.75 0 00.595.596l1.248.238-2.035 2.07-2.496.379z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M12.538 3.046A9 9 0 006.68 19.518l.01.002.008.002a.746.746 0 01.4.255A8.999 8.999 0 0020.33 9.704a.75.75 0 111.45-.382 10.5 10.5 0 01-3.938 11.141l.651 2.605a.75.75 0 11-1.455.364l-.533-2.134a10.5 10.5 0 01-9.51.125l-.502 2.009a.75.75 0 11-1.455-.364l.61-2.437a10.492 10.492 0 01-4.245-6.24A10.5 10.5 0 0112.69 1.554a.75.75 0 11-.152 1.492z"
    }), $a5EUy.createElement("path", {
        d: "M11.622 7.5a.75.75 0 000-1.5 6.001 6.001 0 105.828 4.556.75.75 0 10-1.456.362A4.501 4.501 0 1111.622 7.5z"
    }));
});

});

parcelRegister("4i2tC", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $31fac3aa3e559a43$var$__assign = undefined && undefined.__assign || function() {
    $31fac3aa3e559a43$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $31fac3aa3e559a43$var$__assign.apply(this, arguments);
};
var $31fac3aa3e559a43$export$789133e8ec70b6e2 = $a5EUy.forwardRef(function TargetBold(props, svgRef) {
    return $a5EUy.createElement("svg", $31fac3aa3e559a43$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 23 24",
        width: 23
    }, props), $a5EUy.createElement("path", {
        d: "M21.98 3.811a.5.5 0 00-.462-.308h-2.752a.25.25 0 01-.25-.25V.5a.5.5 0 00-.854-.354l-2.416 2.416a2.486 2.486 0 00-.733 1.77v1.685a.25.25 0 01-.117.212.492.492 0 00-.09.069l-5.004 5.004a1 1 0 101.415 1.415l5.004-5.004a.464.464 0 00.07-.09.253.253 0 01.212-.117h1.684a2.485 2.485 0 001.77-.734l2.416-2.416a.5.5 0 00.108-.545z"
    }), $a5EUy.createElement("path", {
        d: "M10.01 8.006a1 1 0 000-2.001 6.005 6.005 0 106.004 6.005 1 1 0 00-2.002 0 4.003 4.003 0 11-4.003-4.004z"
    }), $a5EUy.createElement("path", {
        d: "M20.017 12.01a1 1 0 00-2.001 0 8.006 8.006 0 11-8.007-8.007 1 1 0 000-2.001 10 10 0 00-7.167 16.981.25.25 0 01.011.338l-2.61 3.047a1 1 0 001.52 1.301l2.664-3.107a.25.25 0 01.32-.05 9.948 9.948 0 0010.523 0 .25.25 0 01.323.05l2.664 3.107a1 1 0 001.52-1.3l-2.611-3.048a.25.25 0 01.01-.337 9.97 9.97 0 002.841-6.974z"
    }));
});

});

parcelRegister("i6MgI", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $d2ee3aa77913a039$var$__assign = undefined && undefined.__assign || function() {
    $d2ee3aa77913a039$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d2ee3aa77913a039$var$__assign.apply(this, arguments);
};
var $d2ee3aa77913a039$export$290b33259d59609 = $a5EUy.forwardRef(function ThreedPrinting(props, svgRef) {
    return $a5EUy.createElement("svg", $d2ee3aa77913a039$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M9.543 4.262l1.714-1.713v4.18a.76.76 0 00.754.754.76.76 0 00.754-.754V2.531l1.713 1.714a.74.74 0 00.531.223.755.755 0 00.531-1.285L12.542.2h-.017a.452.452 0 00-.103-.085c-.017-.017-.034-.017-.052-.035a.13.13 0 00-.068-.034C12.285.03 12.251.03 12.233.03c-.017 0-.034-.017-.068-.017a.832.832 0 00-.291 0c-.018 0-.035.017-.069.017s-.051.017-.086.017c-.017.017-.051.017-.068.034-.017.018-.034.018-.069.035A.452.452 0 0011.48.2h-.018l-2.98 3a.755.755 0 000 1.062.755.755 0 001.061 0zM5.106 17.815l-3.598 3.598V20.23a.76.76 0 00-.754-.754.76.76 0 00-.754.754v2.998c0 .051 0 .103.017.154 0 .017.017.035.017.069s.017.051.017.085c.018.018.018.052.035.069.017.017.017.034.034.068a.416.416 0 00.086.103v.017h.017a.455.455 0 00.103.086c.017.017.034.017.068.034.017.017.051.017.069.035.017.017.051.017.085.017.017 0 .035.017.069.017C.668 24 .72 24 .77 24h2.998a.76.76 0 00.754-.754.76.76 0 00-.754-.754H2.587l3.598-3.598a.755.755 0 000-1.062.76.76 0 00-1.08-.017z"
    }), $a5EUy.createElement("path", {
        d: "M16.277 19.7l-3.53 1.593V13.96l6.751-3.067v4.831a.76.76 0 00.754.754.76.76 0 00.754-.754V9.728c0-.035 0-.069-.017-.12v-.035a.23.23 0 00-.035-.102v-.017c-.017-.035-.034-.069-.05-.12 0-.018-.018-.018-.018-.035a.374.374 0 00-.069-.085v-.018c-.034-.034-.068-.05-.085-.085-.017 0-.017-.017-.034-.017l-.018-.017c-.034-.018-.051-.035-.085-.052l-5.277-2.364a.753.753 0 00-.994.377.753.753 0 00.377.993l3.752 1.697-6.442 2.912-6.443-2.912L9.321 8.03a.752.752 0 00-.617-1.37L3.46 9.042a.374.374 0 00-.086.052l-.017.017c-.017 0-.017.017-.034.017-.034.034-.069.051-.103.086a.358.358 0 00-.068.102c0 .018-.018.018-.018.035a.835.835 0 00-.05.12v.017c-.018.034-.018.068-.035.103v.034c0 .034-.017.068-.017.12v5.997a.76.76 0 00.754.753.76.76 0 00.753-.753v-4.85l6.751 3.068v7.35l-3.51-1.593a.753.753 0 00-.994.377.753.753 0 00.377.993l4.575 2.09c.051.018.085.035.137.052h.034a.38.38 0 00.137.017c.051 0 .086 0 .137-.017h.034c.052-.017.086-.017.137-.051l4.575-2.074a.753.753 0 00.377-.993c-.206-.412-.651-.583-1.028-.412z"
    }), $a5EUy.createElement("path", {
        d: "M23.901 23.572a.13.13 0 00.035-.069c.017-.017.017-.051.017-.068 0-.017.017-.052.017-.069a.376.376 0 00.017-.137v-2.998a.76.76 0 00-.754-.754.76.76 0 00-.754.754v1.182l-3.598-3.598a.755.755 0 00-1.062 0 .755.755 0 000 1.062l3.598 3.598h-1.182a.76.76 0 00-.754.754.76.76 0 00.754.754h2.998c.052 0 .103 0 .154-.017.018 0 .035-.017.069-.017s.051-.018.086-.018c.017-.017.051-.017.068-.034.017-.017.035-.017.069-.034s.068-.052.103-.086h.017v-.017a.453.453 0 00.085-.103c0-.051.017-.068.017-.085z"
    }));
});

});

parcelRegister("3qdRt", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $27de8d6c70f22371$var$__assign = undefined && undefined.__assign || function() {
    $27de8d6c70f22371$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $27de8d6c70f22371$var$__assign.apply(this, arguments);
};
var $27de8d6c70f22371$export$75745cda8b35a66 = $a5EUy.forwardRef(function ThreedPrintingBold(props, svgRef) {
    return $a5EUy.createElement("svg", $27de8d6c70f22371$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M10 3.312h.75a.25.25 0 01.25.25v1a1 1 0 102 0v-1a.25.25 0 01.25-.25H14a.75.75 0 00.473-1.332l-2-1.625a.752.752 0 00-.946 0l-2 1.625A.75.75 0 0010 3.312z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M15.04 16.531a2 2 0 00.546 1.945l1.154 1.155a.25.25 0 01-.076.406L12.2 21.99a.5.5 0 01-.4 0l-4.47-1.947a.251.251 0 01-.077-.406l1.161-1.161a2 2 0 10-2.828-2.828l-.659.659a.25.25 0 01-.427-.176v-5.975a.75.75 0 01.449-.687L11.7 6.516a.75.75 0 01.6 0l6.751 2.953c.273.12.449.39.449.687v5.975a.25.25 0 01-.427.176l-.659-.659a2 2 0 00-3.373.883zm1.465-6.375a.25.25 0 00-.15-.229L12.1 8.066a.249.249 0 00-.2 0L7.645 9.927a.25.25 0 000 .458l4.255 1.862a.257.257 0 00.2 0l4.255-1.862a.25.25 0 00.15-.229z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M7.707 17.769a1 1 0 10-1.414-1.414L2.5 20.148a.25.25 0 01-.354 0l-.616-.616a.75.75 0 00-1.28.53v3c0 .414.336.75.75.75h3a.75.75 0 00.53-1.28l-.616-.616a.25.25 0 010-.354l3.793-3.793zm16.043 5.293v-3a.75.75 0 00-1.28-.53l-.616.616a.25.25 0 01-.354 0l-3.793-3.793a1 1 0 10-1.414 1.414l3.793 3.793a.25.25 0 010 .354l-.616.616a.75.75 0 00.53 1.28h3a.75.75 0 00.75-.75z"
    }));
});

});

parcelRegister("dJUxe", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $a00b5502f9282866$var$__assign = undefined && undefined.__assign || function() {
    $a00b5502f9282866$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a00b5502f9282866$var$__assign.apply(this, arguments);
};
var $a00b5502f9282866$export$680ea196effce5f = $a5EUy.forwardRef(function Time(props, svgRef) {
    return $a5EUy.createElement("svg", $a00b5502f9282866$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M12 7.5a.75.75 0 01.75.75v3.44l4.467 4.468a.75.75 0 01-1.06 1.06L11.47 12.53a.748.748 0 01-.22-.53V8.25A.75.75 0 0112 7.5z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M4.045 4.045a11.25 11.25 0 1115.91 15.91 11.25 11.25 0 01-15.91-15.91zM12 2.25a9.75 9.75 0 100 19.5 9.75 9.75 0 000-19.5z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("gJclC", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $c2da6d490d2497d3$var$__assign = undefined && undefined.__assign || function() {
    $c2da6d490d2497d3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c2da6d490d2497d3$var$__assign.apply(this, arguments);
};
var $c2da6d490d2497d3$export$cef7b1bbd85670df = $a5EUy.forwardRef(function TimeBold(props, svgRef) {
    return $a5EUy.createElement("svg", $c2da6d490d2497d3$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M12 .75a11.25 11.25 0 100 22.5 11.25 11.25 0 000-22.5zM13.5 8a1.5 1.5 0 00-3 0v4.621l4.94 4.94a1.5 1.5 0 002.12-2.122l-4.06-4.06V8z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("6UgYF", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $5075246b04ef5c61$var$__assign = undefined && undefined.__assign || function() {
    $5075246b04ef5c61$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5075246b04ef5c61$var$__assign.apply(this, arguments);
};
var $5075246b04ef5c61$export$cec4f96e18e205ef = $a5EUy.forwardRef(function Transfer(props, svgRef) {
    return $a5EUy.createElement("svg", $5075246b04ef5c61$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M4.28 6.53a.75.75 0 00-1.06-1.06l-3 3-.003.002A.748.748 0 00.22 9.53l3 3a.75.75 0 001.06-1.06L2.56 9.75H13.5a.75.75 0 000-1.5H2.56l1.72-1.72zm16.5 4.94a.75.75 0 10-1.06 1.06l1.72 1.72H10.5a.75.75 0 000 1.5h10.94l-1.72 1.72a.75.75 0 101.06 1.06l3-3A.746.746 0 0024 15v-.008a.748.748 0 00-.22-.522l-3-3z"
    }));
});

});

parcelRegister("3RqjR", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $2cfabcc8b506a4d0$var$__assign = undefined && undefined.__assign || function() {
    $2cfabcc8b506a4d0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2cfabcc8b506a4d0$var$__assign.apply(this, arguments);
};
var $2cfabcc8b506a4d0$export$a818bbe058f189e = $a5EUy.forwardRef(function Unlock(props, svgRef) {
    return $a5EUy.createElement("svg", $2cfabcc8b506a4d0$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M15 14.25a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0v-3a.75.75 0 01.75-.75z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M3.818 3.818A4.5 4.5 0 0111.5 7v2H6.75a.75.75 0 00-.75.75v13.5c0 .414.336.75.75.75h16.5a.75.75 0 00.75-.75V9.75a.75.75 0 00-.75-.75H13V7A6 6 0 101 7v2.25a.75.75 0 001.5 0V7a4.5 4.5 0 011.318-3.182zM22.5 10.5h-15v12h15v-12z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("bPZGS", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $89e44f9c43cdcc60$var$__assign = undefined && undefined.__assign || function() {
    $89e44f9c43cdcc60$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $89e44f9c43cdcc60$var$__assign.apply(this, arguments);
};
var $89e44f9c43cdcc60$export$cc1b5dff9a340610 = $a5EUy.forwardRef(function UnlockBold(props, svgRef) {
    return $a5EUy.createElement("svg", $89e44f9c43cdcc60$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M1.917 1.917a6.545 6.545 0 0111.174 4.628V8.6H23.23a.77.77 0 01.77.77v13.86a.77.77 0 01-.77.771H6.289a.77.77 0 01-.77-.77V9.369a.77.77 0 01.77-.77h4.492V6.545a4.235 4.235 0 10-8.47 0v2.31a1.155 1.155 0 11-2.311 0v-2.31c0-1.736.69-3.4 1.917-4.628zM14.76 13.604c-.638 0-1.155.517-1.155 1.155v3.08a1.155 1.155 0 102.31 0v-3.08c0-.638-.517-1.155-1.155-1.155z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("geUMU", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $bd2a01045acea53b$var$__assign = undefined && undefined.__assign || function() {
    $bd2a01045acea53b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bd2a01045acea53b$var$__assign.apply(this, arguments);
};
var $bd2a01045acea53b$export$c58532f0fb5faa97 = $a5EUy.forwardRef(function Upload(props, svgRef) {
    return $a5EUy.createElement("svg", $bd2a01045acea53b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M12.52 3.21a.747.747 0 00-1.05.01l-4.5 4.5a.75.75 0 101.061 1.06l3.22-3.22v10.19a.75.75 0 001.5 0V5.56l3.219 3.22a.75.75 0 101.06-1.06l-4.5-4.5a.544.544 0 00-.01-.01z"
    }), $a5EUy.createElement("path", {
        d: "M1.5 15.75a.75.75 0 10-1.499 0v1.5A3.75 3.75 0 003.751 21h16.5A3.75 3.75 0 0024 17.25v-1.5a.75.75 0 00-1.5 0v1.5a2.25 2.25 0 01-2.25 2.25H3.75a2.25 2.25 0 01-2.25-2.25v-1.5z"
    }));
});

});

parcelRegister("3Uinh", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $2d84dad89c348b0e$var$__assign = undefined && undefined.__assign || function() {
    $2d84dad89c348b0e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2d84dad89c348b0e$var$__assign.apply(this, arguments);
};
var $2d84dad89c348b0e$export$1f42c19cf267f1bb = $a5EUy.forwardRef(function UpwardTrend(props, svgRef) {
    return $a5EUy.createElement("svg", $2d84dad89c348b0e$var$__assign({
        fill: "currentColor",
        height: 25,
        ref: svgRef,
        viewBox: "0 0 24 25",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M17.331.048a.75.75 0 00-.526 1.404l1.486.558-14.42 6.548a.75.75 0 10.621 1.366l14.42-6.548-.558 1.487a.75.75 0 001.404.527l1.194-3.182.002-.006a.747.747 0 00-.44-.96l-.003-.001L17.33.048z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M18 9a1.5 1.5 0 00-1.5 1.5v12H15v-9a1.5 1.5 0 00-1.5-1.5h-3A1.5 1.5 0 009 13.5v9H7.5V18A1.5 1.5 0 006 16.5H3A1.5 1.5 0 001.5 18v4.5H.75a.75.75 0 000 1.5h22.5a.75.75 0 000-1.5h-.75v-12A1.5 1.5 0 0021 9h-3zm3 1.5h-3v12h3v-12zm-10.5 3h3v9h-3v-9zm-4.5 9V18H3v4.5h3z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("lHQvY", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $fcd659778800c75a$var$__assign = undefined && undefined.__assign || function() {
    $fcd659778800c75a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fcd659778800c75a$var$__assign.apply(this, arguments);
};
var $fcd659778800c75a$export$d5ad65c4a4d4aa75 = $a5EUy.forwardRef(function UsbStick(props, svgRef) {
    return $a5EUy.createElement("svg", $fcd659778800c75a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M11.25 3a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5h-1.5z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M7.5.75A.75.75 0 018.25 0h7.5a.75.75 0 01.75.75v5.379A2.25 2.25 0 0118 8.25V18a6 6 0 11-12 0V8.25a2.25 2.25 0 011.5-2.121V.75zM9 1.5h6V6H9V1.5zM7.72 7.72a.75.75 0 01.53-.22h7.5a.75.75 0 01.75.75V18a4.5 4.5 0 11-9 0V8.25a.75.75 0 01.22-.53z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("SxCX5", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $0a3f20eee916d202$var$__assign = undefined && undefined.__assign || function() {
    $0a3f20eee916d202$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0a3f20eee916d202$var$__assign.apply(this, arguments);
};
var $0a3f20eee916d202$export$67fadca628676d83 = $a5EUy.forwardRef(function ViewHide(props, svgRef) {
    return $a5EUy.createElement("svg", $0a3f20eee916d202$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M22.072 2.23a.75.75 0 01-.021 1.061l-18.75 18a.75.75 0 11-1.039-1.082l18.75-18a.75.75 0 011.06.022zm-2.929 5.958a.75.75 0 011.047-.164c1.156.843 2.223 1.8 3.187 2.858l.003.003a2.413 2.413 0 010 3.23l-.003.002C20.758 17 16.412 20.07 11.995 20a10.734 10.734 0 01-3.255-.483.75.75 0 01.445-1.432 9.236 9.236 0 002.826.415c3.779.064 7.744-2.627 10.255-5.39a.914.914 0 000-1.22 19.816 19.816 0 00-2.96-2.654.75.75 0 01-.163-1.048zM12 5c.874-.009 1.745.093 2.592.304a.75.75 0 01-.362 1.456 8.799 8.799 0 00-2.244-.26c-3.713-.062-7.69 2.57-10.252 5.388a.913.913 0 000 1.22c.767.84 1.605 1.613 2.503 2.31a.75.75 0 01-.92 1.185 21.553 21.553 0 01-2.693-2.486l-.004-.004a2.413 2.413 0 010-3.23l.002-.002C3.3 7.935 7.655 4.932 12 5z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M11.998 9.5a3 3 0 00-3 3 .75.75 0 01-1.5 0 4.499 4.499 0 014.5-4.5.75.75 0 010 1.5zm3.75 2.249a.75.75 0 01.75.75 4.502 4.502 0 01-4.5 4.501.75.75 0 110-1.5 3 3 0 003-3 .75.75 0 01.75-.751z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("lBdrV", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $fb977c766d47cc97$var$__assign = undefined && undefined.__assign || function() {
    $fb977c766d47cc97$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fb977c766d47cc97$var$__assign.apply(this, arguments);
};
var $fb977c766d47cc97$export$639d2a0e5f6e1492 = $a5EUy.forwardRef(function ViewHideBold(props, svgRef) {
    return $a5EUy.createElement("svg", $fb977c766d47cc97$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M2.967 19.978a1.365 1.365 0 00-.028 1.83 1.145 1.145 0 001.702.027l3.342-3.485c1.275.553 2.57.873 3.827.9h.31c3.597.065 7.577-2.369 10.525-5.858a2.54 2.54 0 00.002-3.219 19.969 19.969 0 00-3.61-3.35l2.973-3.1c.477-.498.49-1.318.028-1.83a1.145 1.145 0 00-1.702-.027L2.967 19.978zm12.253-9.175l-4.118 4.294a3.03 3.03 0 001.007.171c1.79 0 3.24-1.56 3.24-3.485 0-.34-.045-.669-.13-.98z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M12.109 8.298c.304 0 .598.045.878.13l3.126-3.26c-1.231-.521-2.475-.822-3.677-.851l-.315-.001C8.529 4.25 4.527 6.677 1.576 10.17a2.54 2.54 0 00-.002 3.218 20.048 20.048 0 003.506 3.283l3.883-4.049a3.744 3.744 0 01-.095-.84c0-1.925 1.451-3.485 3.24-3.485z"
    }));
});

});

parcelRegister("d1GWS", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $97bcaf1461ff0dfa$var$__assign = undefined && undefined.__assign || function() {
    $97bcaf1461ff0dfa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $97bcaf1461ff0dfa$var$__assign.apply(this, arguments);
};
var $97bcaf1461ff0dfa$export$153f7030970dae8f = $a5EUy.forwardRef(function ViewShow(props, svgRef) {
    return $a5EUy.createElement("svg", $97bcaf1461ff0dfa$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M23.383 10.337c-2.606-2.863-6.909-5.88-11.246-5.88H12c-4.389-.068-8.76 3-11.383 5.88a2.435 2.435 0 000 3.24c2.589 2.863 6.892 5.88 11.229 5.88h.274c4.337 0 8.64-3.034 11.246-5.88.84-.926.84-2.314.017-3.24zm-1.114 2.229c-2.383 2.623-6.275 5.4-10.115 5.4H12c-3.891.051-7.851-2.743-10.251-5.383a.916.916 0 010-1.217c3.6-3.995 7.56-5.4 10.131-5.4h.137c2.554-.052 6.583 1.354 10.252 5.383a.916.916 0 010 1.217z"
    }), $a5EUy.createElement("path", {
        d: "M12 7.457c-2.486 0-4.509 2.023-4.509 4.492 0 1.2.463 2.331 1.32 3.188A4.444 4.444 0 0012 16.457c2.486 0 4.491-2.023 4.509-4.491 0-1.2-.463-2.332-1.32-3.189A4.474 4.474 0 0012 7.457zm3 4.509a2.981 2.981 0 01-3 3 2.981 2.981 0 01-3-3c0-1.646 1.354-3 3-3a2.981 2.981 0 013 3z"
    }));
});

});

parcelRegister("4wrDA", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $34af96d6a1567c61$var$__assign = undefined && undefined.__assign || function() {
    $34af96d6a1567c61$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $34af96d6a1567c61$var$__assign.apply(this, arguments);
};
var $34af96d6a1567c61$export$6d39d2f2d511d9a3 = $a5EUy.forwardRef(function ViewShowBold(props, svgRef) {
    return $a5EUy.createElement("svg", $34af96d6a1567c61$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M12.436 4.502h-.315c-3.592-.066-7.594 2.36-10.545 5.854a2.54 2.54 0 00-.002 3.219c2.863 3.392 6.7 5.786 10.236 5.86h.31c3.597.066 7.577-2.368 10.525-5.858a2.54 2.54 0 00.002-3.218C19.79 6.98 15.935 4.586 12.436 4.502zm-.327 10.952c1.79 0 3.24-1.56 3.24-3.485 0-1.925-1.45-3.486-3.24-3.486-1.79 0-3.24 1.56-3.24 3.486 0 1.925 1.45 3.485 3.24 3.485z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("bAfz4", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $86ef214c12e64f48$var$__assign = undefined && undefined.__assign || function() {
    $86ef214c12e64f48$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $86ef214c12e64f48$var$__assign.apply(this, arguments);
};
var $86ef214c12e64f48$export$b5e8fd97b49d7a6e = $a5EUy.forwardRef(function VirtualReality(props, svgRef) {
    return $a5EUy.createElement("svg", $86ef214c12e64f48$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M7.5 13.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M11.998.75A8.272 8.272 0 003.75 8.998v.019a4.125 4.125 0 00.375 8.233c.164 0 .326-.022.482-.063A2.25 2.25 0 006.75 18.75h3a.75.75 0 00.416-.126L12 17.401l1.833 1.223a.751.751 0 00.416.126h3a2.25 2.25 0 002.143-1.563c.156.041.318.063.483.063a4.125 4.125 0 00.375-8.233v-.019A8.272 8.272 0 0012.002.75h-.004zm6.232 9.225a1.875 1.875 0 01.52-.6v-.374A6.772 6.772 0 0012 2.25a6.772 6.772 0 00-6.75 6.751v.374a1.875 1.875 0 01.52.6 2.25 2.25 0 01.98-.225h10.5c.343 0 .677.079.98.225zM6 12v4.5a.75.75 0 00.75.75h2.773l2.061-1.374a.75.75 0 01.832 0l2.06 1.374h2.773a.75.75 0 00.75-.75V12a.75.75 0 00-.75-.75H6.75A.75.75 0 006 12zm-1.5-1.125a.375.375 0 00-.375-.375 2.625 2.625 0 000 5.25.375.375 0 00.375-.375v-4.5zm15.375-.375a.375.375 0 00-.375.375v4.5a.375.375 0 00.375.375 2.625 2.625 0 000-5.25z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M17.774 20.89a.75.75 0 00-1.05-1.072 6.75 6.75 0 01-8.774.582.75.75 0 10-.9 1.2 8.25 8.25 0 0010.724-.71z"
    }));
});

});

parcelRegister("c4GNT", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $8ca70faa8df73272$var$__assign = undefined && undefined.__assign || function() {
    $8ca70faa8df73272$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8ca70faa8df73272$var$__assign.apply(this, arguments);
};
var $8ca70faa8df73272$export$d1389198cb17768a = $a5EUy.forwardRef(function VirtualRealityBold(props, svgRef) {
    return $a5EUy.createElement("svg", $8ca70faa8df73272$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M18.53 20.81a9.54 9.54 0 01-6.19 2.92 9.42 9.42 0 01-6.5-2 1 1 0 01-.18-1.31.861.861 0 011.24-.22 7.71 7.71 0 005.32 1.66 7.81 7.81 0 005.06-2.39.858.858 0 011.26 0 1 1 0 01-.01 1.34zM3.75 9.19A8.22 8.22 0 0111.1 1a10 10 0 011.74 0 8.34 8.34 0 017.41 8.22 4.06 4.06 0 013.65 3.22 4.582 4.582 0 01-.06 2 4 4 0 01-4.45 2.94 2.2 2.2 0 01-2.14 1.56h-3s-.33.06-2.25-1.35l-1.83 1.22s-.19.24-3.42.13a2.32 2.32 0 01-2.14-1.56S1.53 18 .16 14.44a8.13 8.13 0 01-.07-2 4.21 4.21 0 013.66-3.25zm.19 2.09a1.92 1.92 0 00-2 1.55 2.06 2.06 0 002 2.63.3.3 0 00.3-.3V11.5a.33.33 0 00-.3-.22zm13.51 1a.65.65 0 00-.68-.64H7.18a.62.62 0 00-.68.64v3.77a.61.61 0 00.44.66c.916.048 1.834.048 2.75 0l2-1.24a.58.58 0 01.62.07c1.35.89 1.88 1.17 1.88 1.17h2.53a.629.629 0 00.68-.64l.05-3.79zM17.81 9a6.58 6.58 0 00-.63-3 6.101 6.101 0 00-1.75-2.09 6 6 0 00-2.9-1.14c-.5-.03-1-.03-1.5 0a5.88 5.88 0 00-2.94 1.41 6.06 6.06 0 00-1.55 2.07A6.41 6.41 0 006 9c.173.152.324.327.45.52 0 0 .12-.14.77-.2h9.08a2.16 2.16 0 011 .21 1.4 1.4 0 01.51-.53zm2 2.51v3.66a.3.3 0 00.3.3 2.06 2.06 0 002-2.63 1.92 1.92 0 00-2-1.55.331.331 0 00-.29.2l-.01.02z"
    }), $a5EUy.createElement("path", {
        d: "M18 11l-11.94-.1H6l.21 6.21h12L18 11zm-2.25 3.4h-7.5a.75.75 0 110-1.5h7.5a.75.75 0 010 1.5z"
    }));
});

});

parcelRegister("7k5FS", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $554ecd75f943681a$var$__assign = undefined && undefined.__assign || function() {
    $554ecd75f943681a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $554ecd75f943681a$var$__assign.apply(this, arguments);
};
var $554ecd75f943681a$export$6b41c506d6ea41ba = $a5EUy.forwardRef(function WifiOff(props, svgRef) {
    return $a5EUy.createElement("svg", $554ecd75f943681a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M23.78.22a.75.75 0 010 1.06l-22.5 22.5a.75.75 0 01-1.06-1.06L22.72.22a.75.75 0 011.06 0zM9.348 17.598a3.75 3.75 0 115.304 5.304 3.75 3.75 0 01-5.304-5.304zM12 18a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zm2.361-4.904a.75.75 0 01.99-.382c.924.41 1.765.988 2.48 1.703a.75.75 0 01-1.061 1.06 6.726 6.726 0 00-2.027-1.392.75.75 0 01-.382-.99zM12 8.227a.75.75 0 01-.703.795 11.2 11.2 0 00-7.25 3.272.75.75 0 11-1.063-1.058 12.7 12.7 0 018.221-3.712.75.75 0 01.795.703zm5.304 1.229a.75.75 0 011.024-.278 12.768 12.768 0 012.688 2.057.75.75 0 11-1.062 1.06 11.271 11.271 0 00-2.372-1.815.75.75 0 01-.278-1.024zM7.146 3.695a17.234 17.234 0 017.94-.417.75.75 0 11-.268 1.476A15.734 15.734 0 001.262 8.729.75.75 0 01.238 7.633a17.234 17.234 0 016.908-3.938zM20.178 5.9a.75.75 0 011.035-.234 17.212 17.212 0 012.549 1.967.75.75 0 01-1.024 1.096 15.711 15.711 0 00-2.327-1.795.75.75 0 01-.233-1.035z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("bPrr9", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $89c9bd8ddadb7e93$var$__assign = undefined && undefined.__assign || function() {
    $89c9bd8ddadb7e93$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $89c9bd8ddadb7e93$var$__assign.apply(this, arguments);
};
var $89c9bd8ddadb7e93$export$788829a381a1aca1 = $a5EUy.forwardRef(function WifiOn(props, svgRef) {
    return $a5EUy.createElement("svg", $89c9bd8ddadb7e93$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M9.348 16.098a3.75 3.75 0 115.304 5.304 3.75 3.75 0 01-5.304-5.304zM12 16.5a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zm-5.836-3.583a8.25 8.25 0 0111.666 0 .75.75 0 01-1.06 1.06 6.75 6.75 0 00-9.546 0 .75.75 0 11-1.06-1.06z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M2.985 9.735a12.75 12.75 0 0118.03 0 .75.75 0 01-1.06 1.06 11.25 11.25 0 00-15.91 0 .75.75 0 11-1.06-1.06z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M.239 6.132a17.25 17.25 0 0123.522 0A.75.75 0 1122.74 7.23a15.75 15.75 0 00-21.478 0A.75.75 0 01.24 6.132z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("hIU8s", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $ce72170c259d1840$var$__assign = undefined && undefined.__assign || function() {
    $ce72170c259d1840$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ce72170c259d1840$var$__assign.apply(this, arguments);
};
var $ce72170c259d1840$export$6e5f9bb1ece75cb9 = $a5EUy.forwardRef(function Workshop(props, svgRef) {
    return $a5EUy.createElement("svg", $ce72170c259d1840$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M12 3a.76.76 0 00.754-.754V.754A.76.76 0 0012 0a.761.761 0 00-.755.754v1.509c0 .394.343.737.755.737zM4.491 9h1.612a.761.761 0 00.754-.754.761.761 0 00-.754-.755H4.49a.761.761 0 00-.754.755c0 .411.343.754.754.754zm12.652-.754a.76.76 0 00.754.754h1.611a.761.761 0 00.755-.754.761.761 0 00-.755-.755h-1.611c-.412.018-.754.343-.754.755zm-10.492-3a.74.74 0 00.532.223.755.755 0 00.531-1.286L6.343 2.81a.755.755 0 00-1.063 0 .755.755 0 000 1.063l1.37 1.373zm10.166.223a.74.74 0 00.531-.223l1.372-1.372a.755.755 0 000-1.063.755.755 0 00-1.063 0l-1.372 1.372a.755.755 0 000 1.063.818.818 0 00.532.223zm-7.063 6.668v1.354c0 .412.343.755.754.755h3a.761.761 0 00.755-.755v-1.354a4.471 4.471 0 002.245-3.891 4.47 4.47 0 00-1.32-3.189A4.444 4.444 0 0012 3.737 4.496 4.496 0 007.508 8.23a4.444 4.444 0 002.246 3.908zm.12-6.017A2.981 2.981 0 0112 5.246a2.981 2.981 0 013 3 2.98 2.98 0 01-1.8 2.743.75.75 0 00-.446.685v1.063h-1.508v-1.063a.75.75 0 00-.446-.685 3.004 3.004 0 01-.926-4.869zM13.491 15h-3a.761.761 0 00-.754.754c0 .412.343.755.754.755h3a.761.761 0 00.755-.755.75.75 0 00-.755-.754zm10.474 8.006a5.182 5.182 0 00-2.657-2.983 7.906 7.906 0 00-.565-.24 3.373 3.373 0 00-1.697-6.292 3.373 3.373 0 00-3.378 3.378c0 1.234.669 2.314 1.68 2.914h-.017c-1.508.531-2.691 1.697-3.205 3.206a.752.752 0 00.462.96c.086.034.172.034.24.034.309 0 .6-.189.703-.497a3.725 3.725 0 012.297-2.297 3.65 3.65 0 012.846.171 3.693 3.693 0 011.903 2.126c.137.394.566.6.96.463.343-.12.549-.549.428-.943zM19.028 15c1.029 0 1.869.84 1.869 1.869 0 1.028-.84 1.868-1.869 1.868a1.877 1.877 0 01-1.885-1.868c0-1.046.84-1.869 1.885-1.869zM7.251 20.023a7.906 7.906 0 00-.565-.24 3.373 3.373 0 00-1.697-6.292c-1.87 0-3.395 1.526-3.395 3.378 0 1.234.669 2.331 1.68 2.914h-.017C1.748 20.314.566 21.48.051 22.989a.752.752 0 00.463.96.625.625 0 00.24.034c.309 0 .6-.189.703-.497a3.725 3.725 0 012.297-2.297 3.65 3.65 0 012.846.171 3.692 3.692 0 011.903 2.126c.137.394.565.6.96.463a.752.752 0 00.463-.96 5.29 5.29 0 00-2.675-2.966zM4.971 15C6 15 6.84 15.84 6.84 16.869c0 1.028-.84 1.885-1.869 1.885a1.873 1.873 0 01-1.868-1.868c0-1.029.84-1.886 1.868-1.886z"
    }));
});

});

parcelRegister("9rCnX", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $6e04693c69dce983$var$__assign = undefined && undefined.__assign || function() {
    $6e04693c69dce983$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6e04693c69dce983$var$__assign.apply(this, arguments);
};
var $6e04693c69dce983$export$7da4007fe4a3162 = $a5EUy.forwardRef(function WorkshopBold(props, svgRef) {
    return $a5EUy.createElement("svg", $6e04693c69dce983$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("g", {
        clipPath: "url(#workshop-bold_svg__workshop-bold_svg__clip0)"
    }, $a5EUy.createElement("path", {
        d: "M9.74 12.14v1.36a.76.76 0 00.75.75h3a.76.76 0 00.75-.75v-1.36a4.5 4.5 0 10-4.51 0h.01zM13.48 15h-3a.755.755 0 100 1.51h3a.76.76 0 00.696-1.04.75.75 0 00-.696-.47zM24 23a5.18 5.18 0 00-2.66-3 6.92 6.92 0 00-.57-.24 3.38 3.38 0 10-3.39 0A5.181 5.181 0 0014.12 23a.75.75 0 00.46 1 .578.578 0 00.23 0h8.25v-.05a.74.74 0 00.49 0A.77.77 0 0024 23zM7.24 20a6.92 6.92 0 00-.57-.24 3.39 3.39 0 10-3.41 0A5.181 5.181 0 000 23a.75.75 0 00.5 1c.08.016.16.016.24 0H9.1a.74.74 0 00.36 0 .75.75 0 00.46-1 5.29 5.29 0 00-2.68-3zM12 3.47a1 1 0 001-1V1a1 1 0 00-2 0v1.47a1 1 0 001 1zm5 2.07a1 1 0 00.69-.27l1.07-1a1.022 1.022 0 00-1.42-1.47l-1.07 1A1 1 0 0017 5.54zM5.28 4.26l1.07 1a1 1 0 001.38-1.45l-1.07-1a1 1 0 00-1.2-.12.73.73 0 00-.19.13 1 1 0 00-.14.22 1 1 0 00.15 1.22z"
    }), $a5EUy.createElement("path", {
        d: "M17 8.14a1 1 0 001 1h1.5a1 1 0 000-2H18a1 1 0 00-1 1zM6 9.26a1 1 0 000-2H4.49a1 1 0 000 2H6z"
    })), $a5EUy.createElement("defs", null, $a5EUy.createElement("clipPath", {
        id: "workshop-bold_svg__workshop-bold_svg__clip0"
    }, $a5EUy.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});

});

parcelRegister("hjUMD", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $c9c0420b4d4e0da7$var$__assign = undefined && undefined.__assign || function() {
    $c9c0420b4d4e0da7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c9c0420b4d4e0da7$var$__assign.apply(this, arguments);
};
var $c9c0420b4d4e0da7$export$d13069184bfa0730 = $a5EUy.forwardRef(function ZoomIn(props, svgRef) {
    return $a5EUy.createElement("svg", $c9c0420b4d4e0da7$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M10.056 1a9.056 9.056 0 017.072 14.713l5.58 5.58a1 1 0 01-1.321 1.498l-.094-.084-5.58-5.58A9.056 9.056 0 1110.056 1zm0 2a7.056 7.056 0 100 14.112 7.056 7.056 0 000-14.112z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M10 6.833c.368 0 .666.299.666.667v1.834H12.5a.666.666 0 110 1.332h-1.834V12.5a.666.666 0 11-1.332 0v-1.834H7.5a.666.666 0 110-1.332h1.834V7.5c0-.368.298-.667.666-.667z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("fuD4A", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $b477f770fb84e8fa$var$__assign = undefined && undefined.__assign || function() {
    $b477f770fb84e8fa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b477f770fb84e8fa$var$__assign.apply(this, arguments);
};
var $b477f770fb84e8fa$export$52a27ea68a20ff47 = $a5EUy.forwardRef(function ZoomInBold(props, svgRef) {
    return $a5EUy.createElement("svg", $b477f770fb84e8fa$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M10 .5a9.5 9.5 0 100 19c2.082 0 4.008-.67 5.573-1.806l5.366 5.367a1.5 1.5 0 002.122-2.122l-5.367-5.366A9.458 9.458 0 0019.5 10 9.5 9.5 0 0010 .5zM3.5 10a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        d: "M10 6.75a.916.916 0 00-.916.917V9.25H7.5a.916.916 0 100 1.833h1.584v1.583a.916.916 0 101.832 0v-1.583H12.5a.916.916 0 100-1.833h-1.584V7.667A.916.916 0 0010 6.75z"
    }));
});

});

parcelRegister("gef6F", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $bd09abfcadfc087a$var$__assign = undefined && undefined.__assign || function() {
    $bd09abfcadfc087a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bd09abfcadfc087a$var$__assign.apply(this, arguments);
};
var $bd09abfcadfc087a$export$adc4acb67269225 = $a5EUy.forwardRef(function ZoomOut(props, svgRef) {
    return $a5EUy.createElement("svg", $bd09abfcadfc087a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        d: "M7.5 9.334a.666.666 0 100 1.332h5a.666.666 0 100-1.332h-5z"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M19.112 10.056a9.056 9.056 0 10-3.399 7.072l5.58 5.58.094.083a1 1 0 001.32-1.498l-5.579-5.58a9.018 9.018 0 001.984-5.657zM3 10.056a7.056 7.056 0 1114.112 0 7.056 7.056 0 01-14.112 0z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("ajWj5", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $7838e83fbe010d90$var$__assign = undefined && undefined.__assign || function() {
    $7838e83fbe010d90$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7838e83fbe010d90$var$__assign.apply(this, arguments);
};
var $7838e83fbe010d90$export$d875a145579e27ff = $a5EUy.forwardRef(function ZoomOutBold(props, svgRef) {
    return $a5EUy.createElement("svg", $7838e83fbe010d90$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M10 .5a9.5 9.5 0 100 19c2.082 0 4.008-.67 5.573-1.806l5.366 5.367a1.5 1.5 0 002.122-2.122l-5.367-5.366A9.458 9.458 0 0019.5 10 9.5 9.5 0 0010 .5zM3.5 10a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M6.833 10c0-.368.299-.666.667-.666h5a.666.666 0 110 1.332h-5A.666.666 0 016.833 10z",
        fillRule: "evenodd"
    }), $a5EUy.createElement("path", {
        clipRule: "evenodd",
        d: "M6.583 10c0-.506.41-.916.917-.916h5a.916.916 0 110 1.832h-5A.916.916 0 016.583 10zm.917-.416a.416.416 0 100 .832h5a.417.417 0 000-.832h-5z",
        fillRule: "evenodd"
    }));
});

});


parcelRegister("5Qjz0", function(module, exports) {

$parcel$export(module.exports, "SnackbarContent", function () { return $4410fbfba28dcf47$export$860cef82710cac7; });

var $df8fE = parcelRequire("df8fE");

var $3yJBl = parcelRequire("3yJBl");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("hi8ts");
var $gJq8e = parcelRequire("gJq8e");
parcelRequire("i7Pqi");
var $gdpIa = parcelRequire("gdpIa");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $jahGf = parcelRequire("jahGf");
var $cbxDY = parcelRequire("cbxDY");
const $4410fbfba28dcf47$var$contentWrapperStyle = (0, $1lyZZ.css)({
    display: 'flex',
    justifyContent: 'space-between'
});
const $4410fbfba28dcf47$var$leftContainerStyle = (0, $1lyZZ.css)({
    display: 'flex',
    alignItems: 'flex-start'
});
const $4410fbfba28dcf47$var$iconStyle = (0, $1lyZZ.css)({
    marginRight: (0, $cbxDY.spacing).size3,
    '&:empty': {
        display: 'none'
    }
});
const $4410fbfba28dcf47$var$textWrapperStyle = (0, $1lyZZ.css)({
    marginRight: (0, $cbxDY.spacing).size2
});
const $4410fbfba28dcf47$var$headerTextStyle = (0, $1lyZZ.css)({
    fontWeight: (0, $jahGf.font).weight.medium
});
const $4410fbfba28dcf47$var$bodyTextStyle = (0, $1lyZZ.css)({
    fontSize: (0, $jahGf.font).size.sizeM1,
    lineHeight: 1.125
});
const $4410fbfba28dcf47$var$buttonWrapperStyle = (0, $1lyZZ.css)({
    flexShrink: 0,
    marginTop: -(0, $cbxDY.spacing).size1
});
const $4410fbfba28dcf47$var$closeIconStyle = (0, $1lyZZ.css)({
    color: (0, $8JWbY.colors).neutralColors.slate60
});
const $4410fbfba28dcf47$export$860cef82710cac7 = ({ icon: icon, header: header, text: text, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
        css: $4410fbfba28dcf47$var$contentWrapperStyle,
        children: [
            /*#__PURE__*/ (0, $df8fE.jsxs)("span", {
                css: $4410fbfba28dcf47$var$leftContainerStyle,
                children: [
                    /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                        css: $4410fbfba28dcf47$var$iconStyle,
                        children: icon
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                        css: $4410fbfba28dcf47$var$textWrapperStyle,
                        children: [
                            /*#__PURE__*/ (0, $df8fE.jsx)("h4", {
                                css: $4410fbfba28dcf47$var$headerTextStyle,
                                children: header
                            }),
                            /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                                css: $4410fbfba28dcf47$var$bodyTextStyle,
                                children: text
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                css: $4410fbfba28dcf47$var$buttonWrapperStyle,
                children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                    "data-transaction-name": "Close notification",
                    "aria-label": "Close notification button",
                    icon: /*#__PURE__*/ (0, $df8fE.jsx)((0, $gJq8e.Cross), {
                        css: $4410fbfba28dcf47$var$closeIconStyle
                    }),
                    variant: "ghost",
                    size: "small",
                    onClick: onClose
                })
            })
        ]
    });
};
$4410fbfba28dcf47$export$860cef82710cac7.propTypes = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).element,
    header: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string.isRequired,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func
};

});
parcelRegister("i7Pqi", function(module, exports) {
$parcel$export(module.exports, "KlikContextProvider", function () { return (parcelRequire("bnWnl")).KlikContextProvider; });
$parcel$export(module.exports, "useKlikContext", function () { return (parcelRequire("bnWnl")).useKlikContext; });
$parcel$export(module.exports, "Button", function () { return (parcelRequire("gdpIa")).Button; });
$parcel$export(module.exports, "Checkbox", function () { return (parcelRequire("7QTa8")).Checkbox; });
$parcel$export(module.exports, "Header", function () { return (parcelRequire("2Ei9L")).Header; });
$parcel$export(module.exports, "Modal", function () { return (parcelRequire("9BPY2")).Modal; });
$parcel$export(module.exports, "Overlay", function () { return (parcelRequire("gDChL")).Overlay; });
$parcel$export(module.exports, "Radio", function () { return (parcelRequire("bzTkH")).Radio; });
$parcel$export(module.exports, "TextArea", function () { return (parcelRequire("aIP73")).TextArea; });
parcelRequire("6LRCY");
parcelRequire("8DLm3");
parcelRequire("bHt1e");

});
parcelRegister("6LRCY", function(module, exports) {
$parcel$export(module.exports, "KlikContextProvider", function () { return (parcelRequire("bnWnl")).KlikContextProvider; });
$parcel$export(module.exports, "useKlikContext", function () { return (parcelRequire("bnWnl")).useKlikContext; });
parcelRequire("bnWnl");
parcelRequire("dMYAI");

});
parcelRegister("bnWnl", function(module, exports) {

$parcel$export(module.exports, "KlikContextProvider", function () { return $849f1fd567ff49f3$export$21c472c8a0d1544e; });
$parcel$export(module.exports, "useKlikContext", function () { return $849f1fd567ff49f3$export$d3be3afeac0548cc; });

var $a5EUy = parcelRequire("a5EUy");
var $849f1fd567ff49f3$var$KlikContext = $a5EUy.createContext(undefined);
var $849f1fd567ff49f3$export$21c472c8a0d1544e = function(_a) {
    var children = _a.children, _b = _a.frameworkPrefix, frameworkPrefix = _b === void 0 ? 'klik' : _b, _c = _a.theme, theme = _c === void 0 ? 'light-blue' : _c;
    return $a5EUy.createElement($849f1fd567ff49f3$var$KlikContext.Provider, {
        value: {
            frameworkPrefix: frameworkPrefix,
            theme: theme
        }
    }, children);
};
var $849f1fd567ff49f3$export$5f34505ed222b7a4 = $849f1fd567ff49f3$var$KlikContext.Consumer;
var $849f1fd567ff49f3$export$d3be3afeac0548cc = function() {
    var ctx = $a5EUy.useContext($849f1fd567ff49f3$var$KlikContext);
    if (!ctx) throw new Error('"useklikContext" can only be called inside of AppContext.Provider!');
    return ctx;
};

});

parcelRegister("dMYAI", function(module, exports) {

$parcel$export(module.exports, "NotificationContext", function () { return $a09ec231a18c5454$export$a6e93d8cb5d50678; });

var $a5EUy = parcelRequire("a5EUy");

var $jUibk = parcelRequire("jUibk");

var $9Qxx8 = parcelRequire("9Qxx8");

var $jvm3s = parcelRequire("jvm3s");
parcelRequire("bHt1e");
var $1225g = parcelRequire("1225g");
var $a09ec231a18c5454$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $a09ec231a18c5454$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a09ec231a18c5454$var$__read(arguments[i]));
    return ar;
};
var $a09ec231a18c5454$export$a6e93d8cb5d50678 = $a5EUy.createContext(undefined);
var $a09ec231a18c5454$export$363d05e3285e82a1 = function(_a) {
    var children = _a.children, _b = _a.autoDismiss, autoDismiss = _b === void 0 ? true : _b, _c = _a.autoDismissTimeout, autoDismissTimeout = _c === void 0 ? 3000 : _c;
    var _d = $a09ec231a18c5454$var$__read($a5EUy.useState([]), 2), toasts = _d[0], setToasts = _d[1];
    var _e = $a09ec231a18c5454$var$__read($a5EUy.useState(), 2), tobeCleaned = _e[0], scheduleClean = _e[1];
    var portalRoot = (0, $1225g.usePortalRoot)((0, $1225g.PortalRoots).TOAST).portalRoot;
    $a5EUy.useEffect(function() {
        setToasts(function(prevToasts) {
            return prevToasts.filter(function(toast) {
                return toast.key !== tobeCleaned;
            });
        });
    }, [
        tobeCleaned
    ]);
    var addToast = function(content, options) {
        var toast = $a5EUy.createElement((0, $9Qxx8.Toast), {
            key: Math.random(),
            status: options.status
        }, content);
        setToasts(function(prevToasts) {
            return $a09ec231a18c5454$var$__spread(prevToasts, [
                toast
            ]);
        });
        // TODO: the timeout must also be cleared otherwise they will continue to run even if the component is removed
        if (autoDismiss) setTimeout(function() {
            if (toast.key) scheduleClean(toast.key.toString());
        }, autoDismissTimeout);
    };
    var removeToast = function() {
        setToasts(function(prev) {
            return prev.filter(function(_, i) {
                return i;
            });
        });
    };
    var clearToasts = function() {
        setToasts([]);
    };
    return $a5EUy.createElement($a09ec231a18c5454$export$a6e93d8cb5d50678.Provider, {
        value: {
            addToast: addToast,
            clearToasts: clearToasts,
            removeToast: removeToast
        }
    }, children, !!toasts.length && $jUibk.createPortal($a5EUy.createElement((0, $jvm3s.ToastContainer), null, toasts), portalRoot));
};

});
parcelRegister("9Qxx8", function(module, exports) {

$parcel$export(module.exports, "Toast", function () { return $72b2fb6fd0257ac6$export$8d8dc7d5f743331b; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $3LsC9 = parcelRequire("3LsC9");

var $6eZ7w = parcelRequire("6eZ7w");
var $72b2fb6fd0257ac6$export$8d8dc7d5f743331b = function(_a) {
    var _b;
    var children = _a.children, _c = _a.status, status = _c === void 0 ? 'default' : _c;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var classNames = cn('toast', (_b = {
        'toast-status': status !== 'default'
    }, _b["status-" + status] = status !== 'default', _b));
    return $a5EUy.createElement("article", {
        "aria-labelledby": status + "-alert",
        className: classNames,
        role: "alert"
    }, children);
};
$72b2fb6fd0257ac6$export$8d8dc7d5f743331b.Body = (0, $3LsC9.ToastBody);
$72b2fb6fd0257ac6$export$8d8dc7d5f743331b.Heading = (0, $6eZ7w.ToastHeading);

});
parcelRegister("jLRsx", function(module, exports) {

$parcel$export(module.exports, "getValidChildren", function () { return $e64be006ba6abbbb$export$b2c43d7d050b2e63; });
$parcel$export(module.exports, "canUseDom", function () { return $e64be006ba6abbbb$export$c81b8d8584b2fbae; });
$parcel$export(module.exports, "useFrameworkClassnamePrefixer", function () { return $e64be006ba6abbbb$export$e3ab1274632d862; });
$parcel$export(module.exports, "chain", function () { return $e64be006ba6abbbb$export$e08e3b67e392101e; });

var $jGJNX = parcelRequire("jGJNX");

var $a5EUy = parcelRequire("a5EUy");
parcelRequire("i7Pqi");
var $bnWnl = parcelRequire("bnWnl");
var $e64be006ba6abbbb$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $e64be006ba6abbbb$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $e64be006ba6abbbb$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e64be006ba6abbbb$var$__read(arguments[i]));
    return ar;
};
var $e64be006ba6abbbb$export$bf3ce3de7ed5b595 = function(prefix) {
    return function() {
        var classes = [];
        for(var _i = 0; _i < arguments.length; _i++)classes[_i] = arguments[_i];
        return (0, $jGJNX.default)(classes).split(' ').map(function(cname) {
            var newStr = cname.replace(prefix + "-", '');
            return prefix + "-" + newStr;
        }).join(' ');
    };
};
var $e64be006ba6abbbb$export$b2c43d7d050b2e63 = function(children) {
    return $a5EUy.Children.toArray(children).filter(function(child) {
        return $a5EUy.isValidElement(child);
    });
};
var $e64be006ba6abbbb$export$c81b8d8584b2fbae = !!(typeof window !== 'undefined' && window.document.createElement);
var $e64be006ba6abbbb$export$92bd60949cc504a0 = function(arr, obj) {
    return arr.some(function(item) {
        return item.label === obj.label && item.value === obj.value;
    });
};
var $e64be006ba6abbbb$export$e3ab1274632d862 = function() {
    var frameworkPrefix = (0, $bnWnl.useKlikContext)().frameworkPrefix;
    return $e64be006ba6abbbb$export$bf3ce3de7ed5b595(frameworkPrefix);
};
var $e64be006ba6abbbb$export$e08e3b67e392101e = function() {
    var callbacks = [];
    for(var _i = 0; _i < arguments.length; _i++)callbacks[_i] = arguments[_i];
    return function() {
        var e_1, _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        try {
            for(var callbacks_1 = $e64be006ba6abbbb$var$__values(callbacks), callbacks_1_1 = callbacks_1.next(); !callbacks_1_1.done; callbacks_1_1 = callbacks_1.next()){
                var callback = callbacks_1_1.value;
                if (typeof callback === 'function') // eslint-disable-next-line node/callback-return
                callback.apply(void 0, $e64be006ba6abbbb$var$__spread(args));
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (callbacks_1_1 && !callbacks_1_1.done && (_a = callbacks_1.return)) _a.call(callbacks_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
};

});
parcelRegister("jGJNX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e555787557402009$export$2e2bcd8739ae039; });
function $e555787557402009$var$toVal(mix) {
    var k, y, str = '';
    if (typeof mix === 'string' || typeof mix === 'number') str += mix;
    else if (typeof mix === 'object') {
        if (Array.isArray(mix)) for(k = 0; k < mix.length; k++){
            if (mix[k]) {
                if (y = $e555787557402009$var$toVal(mix[k])) {
                    str && (str += ' ');
                    str += y;
                }
            }
        }
        else {
            for(k in mix)if (mix[k]) {
                str && (str += ' ');
                str += k;
            }
        }
    }
    return str;
}
function $e555787557402009$export$2e2bcd8739ae039() {
    var i = 0, tmp, x, str = '';
    while(i < arguments.length){
        if (tmp = arguments[i++]) {
            if (x = $e555787557402009$var$toVal(tmp)) {
                str && (str += ' ');
                str += x;
            }
        }
    }
    return str;
}

});


parcelRegister("3LsC9", function(module, exports) {

$parcel$export(module.exports, "ToastBody", function () { return $2bdbf51dd4003c2e$export$a2fc124486ff7b59; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $2bdbf51dd4003c2e$export$a2fc124486ff7b59 = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('toast-body')
    }, children);
};
$2bdbf51dd4003c2e$export$a2fc124486ff7b59.displayName = 'Toast.Body';

});

parcelRegister("6eZ7w", function(module, exports) {

$parcel$export(module.exports, "ToastHeading", function () { return $48b376209ac9204e$export$3c4e2c6b58120fe3; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $48b376209ac9204e$export$3c4e2c6b58120fe3 = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("p", {
        className: cn('toast-heading')
    }, children);
};
$48b376209ac9204e$export$3c4e2c6b58120fe3.displayName = 'Toast.Heading';

});


parcelRegister("jvm3s", function(module, exports) {

$parcel$export(module.exports, "ToastContainer", function () { return $e332052a98c1093b$export$f2815235e76a62b9; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $e332052a98c1093b$export$f2815235e76a62b9 = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('toasts')
    }, children);
};

});

parcelRegister("bHt1e", function(module, exports) {
$parcel$export(module.exports, "useClickOutside", function () { return (parcelRequire("gSNWl")).useClickOutside; });
$parcel$export(module.exports, "useFont", function () { return (parcelRequire("8wBe8")).useFont; });
$parcel$export(module.exports, "PortalRoots", function () { return (parcelRequire("1225g")).PortalRoots; });
$parcel$export(module.exports, "usePortalRoot", function () { return (parcelRequire("1225g")).usePortalRoot; });
$parcel$export(module.exports, "useShareForwardRef", function () { return (parcelRequire("iQCcD")).useShareForwardRef; });
parcelRequire("eNqGA");
parcelRequire("gSNWl");
parcelRequire("jC8LE");
parcelRequire("8wBe8");
parcelRequire("a8r6G");
parcelRequire("htBPl");
parcelRequire("1225g");
parcelRequire("36air");
parcelRequire("iQCcD");
parcelRequire("9wGfr");

});
parcelRegister("eNqGA", function(module, exports) {

$parcel$export(module.exports, "EMPTY_ARRAY", function () { return $ac5a578e24f8a276$export$2c66e96878bf4792; });
var $ac5a578e24f8a276$export$2c66e96878bf4792 = [];

});

parcelRegister("gSNWl", function(module, exports) {

$parcel$export(module.exports, "useClickOutside", function () { return $c4a86d8463d0a843$export$1896bab46732d207; });

var $a5EUy = parcelRequire("a5EUy");
var $c4a86d8463d0a843$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $c4a86d8463d0a843$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c4a86d8463d0a843$var$__read(arguments[i]));
    return ar;
};
var $c4a86d8463d0a843$var$ClickResult;
(function(ClickResult) {
    ClickResult[ClickResult["OutsideElement"] = 0] = "OutsideElement";
    ClickResult[ClickResult["InsideElement"] = 1] = "InsideElement";
})($c4a86d8463d0a843$var$ClickResult || ($c4a86d8463d0a843$var$ClickResult = {}));
var $c4a86d8463d0a843$export$1896bab46732d207 = function(focusedElement, clickOutsideCallback, deps) {
    // This function runs on every click-event, for every single menu.
    // be aware the cancelling the event propagation can impact monitoring tools
    var detectClickOutside = function(event) {
        if (Array.isArray(focusedElement)) {
            var res = focusedElement.map(function(elm) {
                if (elm.current) {
                    if (elm.current.contains(event.target)) return $c4a86d8463d0a843$var$ClickResult.InsideElement;
                }
                return $c4a86d8463d0a843$var$ClickResult.OutsideElement;
            });
            if (!res.includes($c4a86d8463d0a843$var$ClickResult.InsideElement)) clickOutsideCallback(event);
            return;
        }
        if (focusedElement.current) {
            if (!focusedElement.current.contains(event.target)) clickOutsideCallback(event);
        }
    };
    // Initialize the position of the dropdown.
    // TODO: document event listeners should be removed in the future.
    $a5EUy.useLayoutEffect(function() {
        document.addEventListener('mousedown', detectClickOutside);
        document.addEventListener('touchstart', detectClickOutside);
        return function() {
            document.removeEventListener('mousedown', detectClickOutside);
            document.removeEventListener('touchstart', detectClickOutside);
        };
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    }, $c4a86d8463d0a843$var$__spread([
        focusedElement
    ], deps ? deps : []));
};

});

parcelRegister("jC8LE", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $e4785df7e470e108$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $e4785df7e470e108$export$437db1325ef18dbd = function() {
    var _a = $e4785df7e470e108$var$__read($a5EUy.useState(false), 2), isMobile = _a[0], setMobile = _a[1];
    $a5EUy.useEffect(function() {
        var userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
        if (!userAgent) // eslint-disable-next-line no-console
        console.error('could not detect userAgent, are you using ssr');
        setMobile(/Mobi|Android/u.test(navigator.userAgent));
    }, []);
    return {
        isMobile: isMobile
    };
};

});

parcelRegister("8wBe8", function(module, exports) {

$parcel$export(module.exports, "useFont", function () { return $634e306528667ad3$export$26ca5b065308b0d1; });

var $a5EUy = parcelRequire("a5EUy");

var $bbMCh = parcelRequire("bbMCh");
var $634e306528667ad3$export$26ca5b065308b0d1 = function(fontSize) {
    var size = $a5EUy.useMemo(function() {
        if (!fontSize) return '';
        return "text-size-" + (0, $bbMCh.SIZE_MAP)[fontSize];
    }, [
        fontSize
    ]);
    return size;
};

});
parcelRegister("bbMCh", function(module, exports) {

$parcel$export(module.exports, "SIZE_MAP", function () { return $82566f054275f4ee$export$68604822a8cdca29; });
// TODO: Clean up these types. They should be moved out of consts and instead decorate components
// that have statusses, sizes etc. That way they are unified across all components, don't have variations.
var $82566f054275f4ee$export$c647cb0ee6e282fe = [
    'small',
    'medium',
    'large',
    'default'
];
var $82566f054275f4ee$export$68604822a8cdca29 = {
    xsmall: 'm2',
    small: 'm1',
    normal: '0',
    medium: '05',
    large: '1',
    xlarge: '2',
    x2large: '3',
    x3large: '4',
    x4large: '5',
    x5large: '6',
    x6large: '7'
};
var $82566f054275f4ee$export$e791e5b0f9f766b8 = {
    medium: 59,
    large: 1024,
    extraLarge: 1440,
    fullWidth: 1632
};

});


parcelRegister("a8r6G", function(module, exports) {
/* eslint-disable */ 
var $8Dkpi = parcelRequire("8Dkpi");
var $760fad944774f2ec$export$b0aeb07a3112de27 = function(_a) {
    var name = _a.name, warnings = _a.warnings, registerProp = _a.register, controlProp = _a.control, errorsProp = _a.errors, statusProp = _a.status;
    if (!name) throw new Error("useFormField: all form fields require the 'name' prop");
    var formContext = (0, $8Dkpi.useFormContext)();
    var errors = errorsProp !== null && errorsProp !== void 0 ? errorsProp : formContext === null || formContext === void 0 ? void 0 : formContext.errors;
    var register = registerProp !== null && registerProp !== void 0 ? registerProp : formContext === null || formContext === void 0 ? void 0 : formContext.register;
    var control = controlProp !== null && controlProp !== void 0 ? controlProp : formContext === null || formContext === void 0 ? void 0 : formContext.control;
    if (!((register || control) && errors)) throw new Error("useFormField '" + name + "': you need to pass ('register' or 'control') and 'errors' props from useForm, or alternatively wrap the form in a FormProvider");
    var fieldErrors = errors[name];
    var fieldWarnings = warnings === null || warnings === void 0 ? void 0 : warnings[name];
    var status = statusProp;
    var helperText;
    if (fieldErrors) {
        status = 'error';
        helperText = fieldErrors.message;
    } else if (fieldWarnings) {
        status = 'warning';
        helperText = fieldWarnings.message;
    }
    return {
        register: register,
        status: status,
        helperText: helperText,
        name: name,
        control: control,
        fieldErrors: fieldErrors,
        fieldWarnings: fieldWarnings,
        formState: formContext === null || formContext === void 0 ? void 0 : formContext.formState
    };
};

});
parcelRegister("8Dkpi", function(module, exports) {

$parcel$export(module.exports, "useFormContext", function () { return $6491cba65db8c121$export$4d957a5e1be13b03; });

var $a5EUy = parcelRequire("a5EUy");
var $6491cba65db8c121$var$isHTMLElement = (value)=>value instanceof HTMLElement;
const $6491cba65db8c121$var$EVENTS = {
    BLUR: 'blur',
    CHANGE: 'change',
    INPUT: 'input'
};
const $6491cba65db8c121$var$VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all'
};
const $6491cba65db8c121$var$VALUE = 'value';
const $6491cba65db8c121$var$SELECT = 'select';
const $6491cba65db8c121$var$UNDEFINED = 'undefined';
const $6491cba65db8c121$var$INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate'
};
function $6491cba65db8c121$var$attachEventListeners({ ref: ref }, shouldAttachChangeEvent, handleChange) {
    if ($6491cba65db8c121$var$isHTMLElement(ref) && handleChange) {
        ref.addEventListener(shouldAttachChangeEvent ? $6491cba65db8c121$var$EVENTS.CHANGE : $6491cba65db8c121$var$EVENTS.INPUT, handleChange);
        ref.addEventListener($6491cba65db8c121$var$EVENTS.BLUR, handleChange);
    }
}
var $6491cba65db8c121$var$isNullOrUndefined = (value)=>value == null;
const $6491cba65db8c121$var$isObjectType = (value)=>typeof value === 'object';
var $6491cba65db8c121$var$isObject = (value)=>!$6491cba65db8c121$var$isNullOrUndefined(value) && !Array.isArray(value) && $6491cba65db8c121$var$isObjectType(value) && !(value instanceof Date);
var $6491cba65db8c121$var$isKey = (value)=>!Array.isArray(value) && (/^\w*$/.test(value) || !/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/.test(value));
var $6491cba65db8c121$var$compact = (value)=>value.filter(Boolean);
var $6491cba65db8c121$var$stringToPath = (input)=>$6491cba65db8c121$var$compact(input.replace(/["|']/g, '').replace(/\[/g, '.').replace(/\]/g, '').split('.'));
function $6491cba65db8c121$var$set(object, path, value) {
    let index = -1;
    const tempPath = $6491cba65db8c121$var$isKey(path) ? [
        path
    ] : $6491cba65db8c121$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $6491cba65db8c121$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}
var $6491cba65db8c121$export$19bfedbbacd9b12a = (data, value = {})=>{
    for(const key in data)!$6491cba65db8c121$var$isKey(key) ? $6491cba65db8c121$var$set(value, key, data[key]) : value[key] = data[key];
    return value;
};
var $6491cba65db8c121$var$isUndefined = (val)=>val === undefined;
var $6491cba65db8c121$export$3988ae62b71be9a3 = (obj, path, defaultValue)=>{
    const result = $6491cba65db8c121$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$6491cba65db8c121$var$isNullOrUndefined(result) ? result : result[key], obj);
    return $6491cba65db8c121$var$isUndefined(result) || result === obj ? $6491cba65db8c121$var$isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};
var $6491cba65db8c121$var$focusOnErrorField = (fields, fieldErrors)=>{
    for(const key in fields)if ($6491cba65db8c121$export$3988ae62b71be9a3(fieldErrors, key)) {
        const field = fields[key];
        if (field) {
            if (field.ref.focus) {
                if ($6491cba65db8c121$var$isUndefined(field.ref.focus())) break;
            } else if (field.options) {
                field.options[0].ref.focus();
                break;
            }
        }
    }
};
var $6491cba65db8c121$var$removeAllEventListeners = (ref, validateWithStateUpdate)=>{
    if ($6491cba65db8c121$var$isHTMLElement(ref) && ref.removeEventListener) {
        ref.removeEventListener($6491cba65db8c121$var$EVENTS.INPUT, validateWithStateUpdate);
        ref.removeEventListener($6491cba65db8c121$var$EVENTS.CHANGE, validateWithStateUpdate);
        ref.removeEventListener($6491cba65db8c121$var$EVENTS.BLUR, validateWithStateUpdate);
    }
};
const $6491cba65db8c121$var$defaultReturn = {
    isValid: false,
    value: ''
};
var $6491cba65db8c121$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.ref.checked ? {
            isValid: true,
            value: option.ref.value
        } : previous, $6491cba65db8c121$var$defaultReturn) : $6491cba65db8c121$var$defaultReturn;
var $6491cba65db8c121$var$getMultipleSelectValue = (options)=>[
        ...options
    ].filter(({ selected: selected })=>selected).map(({ value: value })=>value);
var $6491cba65db8c121$var$isRadioInput = (element)=>element.type === 'radio';
var $6491cba65db8c121$var$isFileInput = (element)=>element.type === 'file';
var $6491cba65db8c121$var$isCheckBoxInput = (element)=>element.type === 'checkbox';
var $6491cba65db8c121$var$isMultipleSelect = (element)=>element.type === `${$6491cba65db8c121$var$SELECT}-multiple`;
const $6491cba65db8c121$var$defaultResult = {
    value: false,
    isValid: false
};
const $6491cba65db8c121$var$validResult = {
    value: true,
    isValid: true
};
var $6491cba65db8c121$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.ref.checked).map(({ ref: { value: value } })=>value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        const { checked: checked, value: value, attributes: attributes } = options[0].ref;
        return checked ? attributes && !$6491cba65db8c121$var$isUndefined(attributes.value) ? $6491cba65db8c121$var$isUndefined(value) || value === '' ? $6491cba65db8c121$var$validResult : {
            value: value,
            isValid: true
        } : $6491cba65db8c121$var$validResult : $6491cba65db8c121$var$defaultResult;
    }
    return $6491cba65db8c121$var$defaultResult;
};
function $6491cba65db8c121$var$getFieldValue(fieldsRef, name, shallowFieldsStateRef, excludeDisabled) {
    const field = fieldsRef.current[name];
    if (field) {
        const { ref: { value: value, disabled: disabled }, ref: ref } = field;
        if (disabled && excludeDisabled) return;
        if ($6491cba65db8c121$var$isFileInput(ref)) return ref.files;
        if ($6491cba65db8c121$var$isRadioInput(ref)) return $6491cba65db8c121$var$getRadioValue(field.options).value;
        if ($6491cba65db8c121$var$isMultipleSelect(ref)) return $6491cba65db8c121$var$getMultipleSelectValue(ref.options);
        if ($6491cba65db8c121$var$isCheckBoxInput(ref)) return $6491cba65db8c121$var$getCheckboxValue(field.options).value;
        return value;
    }
    if (shallowFieldsStateRef) return $6491cba65db8c121$export$3988ae62b71be9a3(shallowFieldsStateRef.current, name);
}
function $6491cba65db8c121$var$isDetached(element) {
    if (!element) return true;
    if (!(element instanceof HTMLElement) || element.nodeType === Node.DOCUMENT_NODE) return false;
    return $6491cba65db8c121$var$isDetached(element.parentNode);
}
var $6491cba65db8c121$var$isEmptyObject = (value)=>$6491cba65db8c121$var$isObject(value) && !Object.keys(value).length;
var $6491cba65db8c121$var$isBoolean = (value)=>typeof value === 'boolean';
function $6491cba65db8c121$var$baseGet(object, updatePath) {
    const path = updatePath.slice(0, -1);
    const length = path.length;
    let index = 0;
    while(index < length)object = $6491cba65db8c121$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $6491cba65db8c121$var$unset(object, path) {
    const updatePath = $6491cba65db8c121$var$isKey(path) ? [
        path
    ] : $6491cba65db8c121$var$stringToPath(path);
    const childObject = updatePath.length == 1 ? object : $6491cba65db8c121$var$baseGet(object, updatePath);
    const key = updatePath[updatePath.length - 1];
    let previousObjRef = undefined;
    if (childObject) delete childObject[key];
    for(let k = 0; k < updatePath.slice(0, -1).length; k++){
        let index = -1;
        let objectRef = undefined;
        const currentPaths = updatePath.slice(0, -(k + 1));
        const currentPathsLength = currentPaths.length - 1;
        if (k > 0) previousObjRef = object;
        while(++index < currentPaths.length){
            const item = currentPaths[index];
            objectRef = objectRef ? objectRef[item] : object[item];
            if (currentPathsLength === index && ($6491cba65db8c121$var$isObject(objectRef) && $6491cba65db8c121$var$isEmptyObject(objectRef) || Array.isArray(objectRef) && !objectRef.filter((data)=>$6491cba65db8c121$var$isObject(data) && !$6491cba65db8c121$var$isEmptyObject(data) || $6491cba65db8c121$var$isBoolean(data)).length)) previousObjRef ? delete previousObjRef[item] : delete object[item];
            previousObjRef = objectRef;
        }
    }
    return object;
}
const $6491cba65db8c121$var$isSameRef = (fieldValue, ref)=>fieldValue && fieldValue.ref === ref;
function $6491cba65db8c121$var$findRemovedFieldAndRemoveListener(fieldsRef, handleChange, field, shallowFieldsStateRef, shouldUnregister, forceDelete) {
    const { ref: ref, ref: { name: name, type: type } } = field;
    const fieldRef = fieldsRef.current[name];
    if (!shouldUnregister) {
        const value = $6491cba65db8c121$var$getFieldValue(fieldsRef, name, shallowFieldsStateRef);
        if (!$6491cba65db8c121$var$isUndefined(value)) $6491cba65db8c121$var$set(shallowFieldsStateRef.current, name, value);
    }
    if (!type) {
        delete fieldsRef.current[name];
        return;
    }
    if (($6491cba65db8c121$var$isRadioInput(ref) || $6491cba65db8c121$var$isCheckBoxInput(ref)) && fieldRef) {
        const { options: options } = fieldRef;
        if (Array.isArray(options) && options.length) {
            $6491cba65db8c121$var$compact(options).forEach((option, index)=>{
                const { ref: ref } = option;
                if (ref && $6491cba65db8c121$var$isDetached(ref) && $6491cba65db8c121$var$isSameRef(option, ref) || forceDelete) {
                    $6491cba65db8c121$var$removeAllEventListeners(ref, handleChange);
                    $6491cba65db8c121$var$unset(options, `[${index}]`);
                }
            });
            if (options && !$6491cba65db8c121$var$compact(options).length) delete fieldsRef.current[name];
        } else delete fieldsRef.current[name];
    } else if ($6491cba65db8c121$var$isDetached(ref) && $6491cba65db8c121$var$isSameRef(fieldRef, ref) || forceDelete) {
        $6491cba65db8c121$var$removeAllEventListeners(ref, handleChange);
        delete fieldsRef.current[name];
    }
}
function $6491cba65db8c121$var$setFieldArrayDirtyFields(values, defaultValues, dirtyFields, parentNode, parentName) {
    let index = -1;
    while(++index < values.length){
        for(const key in values[index])if (Array.isArray(values[index][key])) {
            !dirtyFields[index] && (dirtyFields[index] = {});
            dirtyFields[index][key] = [];
            $6491cba65db8c121$var$setFieldArrayDirtyFields(values[index][key], $6491cba65db8c121$export$3988ae62b71be9a3(defaultValues[index] || {}, key, []), dirtyFields[index][key], dirtyFields[index], key);
        } else $6491cba65db8c121$export$3988ae62b71be9a3(defaultValues[index] || {}, key) === values[index][key] ? $6491cba65db8c121$var$set(dirtyFields[index] || {}, key) : dirtyFields[index] = Object.assign(Object.assign({}, dirtyFields[index]), {
            [key]: true
        });
        !dirtyFields.length && parentNode && delete parentNode[parentName];
    }
    return dirtyFields.length ? dirtyFields : undefined;
}
var $6491cba65db8c121$var$isString = (value)=>typeof value === 'string';
var $6491cba65db8c121$var$isPrimitive = (value)=>$6491cba65db8c121$var$isNullOrUndefined(value) || !$6491cba65db8c121$var$isObjectType(value);
function $6491cba65db8c121$var$deepMerge(target, source) {
    if ($6491cba65db8c121$var$isPrimitive(target) || $6491cba65db8c121$var$isPrimitive(source)) return source;
    for(const key in source){
        const targetValue = target[key];
        const sourceValue = source[key];
        try {
            target[key] = $6491cba65db8c121$var$isObject(targetValue) && $6491cba65db8c121$var$isObject(sourceValue) || Array.isArray(targetValue) && Array.isArray(sourceValue) ? $6491cba65db8c121$var$deepMerge(targetValue, sourceValue) : sourceValue;
        } catch (_a) {}
    }
    return target;
}
var $6491cba65db8c121$var$getFieldsValues = (fieldsRef, shallowFieldsStateRef, excludeDisabled, search)=>{
    const output = {};
    for(const name in fieldsRef.current)if ($6491cba65db8c121$var$isUndefined(search) || ($6491cba65db8c121$var$isString(search) ? name.startsWith(search) : Array.isArray(search) && search.find((data)=>name.startsWith(data)))) output[name] = $6491cba65db8c121$var$getFieldValue(fieldsRef, name, undefined, excludeDisabled);
    return $6491cba65db8c121$var$deepMerge($6491cba65db8c121$export$19bfedbbacd9b12a(Object.assign({}, (shallowFieldsStateRef || {}).current || {})), $6491cba65db8c121$export$19bfedbbacd9b12a(output));
};
function $6491cba65db8c121$var$deepEqual(object1, object2, isErrorObject) {
    if ($6491cba65db8c121$var$isPrimitive(object1) || $6491cba65db8c121$var$isPrimitive(object2)) return object1 === object2;
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1)if (!(isErrorObject && [
        'ref',
        'context'
    ].includes(key))) {
        const val1 = object1[key];
        const val2 = object2[key];
        if (($6491cba65db8c121$var$isObject(val1) || Array.isArray(val1)) && ($6491cba65db8c121$var$isObject(val2) || Array.isArray(val2)) ? !$6491cba65db8c121$var$deepEqual(val1, val2, isErrorObject) : val1 !== val2) return false;
    }
    return true;
}
function $6491cba65db8c121$var$isErrorStateChanged({ errors: errors, name: name, error: error, validFields: validFields, fieldsWithValidation: fieldsWithValidation }) {
    const isValid = $6491cba65db8c121$var$isUndefined(error);
    const previousError = $6491cba65db8c121$export$3988ae62b71be9a3(errors, name);
    return isValid && !!previousError || !isValid && !$6491cba65db8c121$var$deepEqual(previousError, error, true) || isValid && $6491cba65db8c121$export$3988ae62b71be9a3(fieldsWithValidation, name) && !$6491cba65db8c121$export$3988ae62b71be9a3(validFields, name);
}
var $6491cba65db8c121$var$isRegex = (value)=>value instanceof RegExp;
const $6491cba65db8c121$var$isValueMessage = (value)=>$6491cba65db8c121$var$isObject(value) && !$6491cba65db8c121$var$isRegex(value);
var $6491cba65db8c121$var$getValueAndMessage = (validationData)=>$6491cba65db8c121$var$isValueMessage(validationData) ? validationData : {
        value: validationData,
        message: ''
    };
var $6491cba65db8c121$var$isFunction = (value)=>typeof value === 'function';
var $6491cba65db8c121$var$isMessage = (value)=>$6491cba65db8c121$var$isString(value) || $6491cba65db8c121$var$isObject(value) && (0, $a5EUy.isValidElement)(value);
function $6491cba65db8c121$var$getValidateError(result, ref, type = 'validate') {
    if ($6491cba65db8c121$var$isMessage(result) || $6491cba65db8c121$var$isBoolean(result) && !result) return {
        type: type,
        message: $6491cba65db8c121$var$isMessage(result) ? result : '',
        ref: ref
    };
}
var $6491cba65db8c121$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>{
    if (validateAllFieldCriteria) {
        const error = errors[name];
        return Object.assign(Object.assign({}, error), {
            types: Object.assign(Object.assign({}, error && error.types ? error.types : {}), {
                [type]: message || true
            })
        });
    }
    return {};
};
var $6491cba65db8c121$var$validateField = async (fieldsRef, validateAllFieldCriteria, { ref: ref, ref: { type: type, value: value }, options: options, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate }, shallowFieldsStateRef)=>{
    const fields = fieldsRef.current;
    const name = ref.name;
    const error = {};
    const isRadio = $6491cba65db8c121$var$isRadioInput(ref);
    const isCheckBox = $6491cba65db8c121$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = value === '';
    const appendErrorsCurry = $6491cba65db8c121$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $6491cba65db8c121$var$INPUT_VALIDATION_RULES.maxLength, minType = $6491cba65db8c121$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = Object.assign({
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref
        }, exceedMax ? appendErrorsCurry(maxType, message) : appendErrorsCurry(minType, message));
    };
    if (required && (!isRadio && !isCheckBox && (isEmpty || $6491cba65db8c121$var$isNullOrUndefined(value)) || $6491cba65db8c121$var$isBoolean(value) && !value || isCheckBox && !$6491cba65db8c121$var$getCheckboxValue(options).isValid || isRadio && !$6491cba65db8c121$var$getRadioValue(options).isValid)) {
        const { value: requiredValue, message: requiredMessage } = $6491cba65db8c121$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $6491cba65db8c121$var$getValueAndMessage(required);
        if (requiredValue) {
            error[name] = Object.assign({
                type: $6491cba65db8c121$var$INPUT_VALIDATION_RULES.required,
                message: requiredMessage,
                ref: isRadioOrCheckbox ? ((fields[name].options || [])[0] || {}).ref : ref
            }, appendErrorsCurry($6491cba65db8c121$var$INPUT_VALIDATION_RULES.required, requiredMessage));
            if (!validateAllFieldCriteria) return error;
        }
    }
    if (!$6491cba65db8c121$var$isNullOrUndefined(min) || !$6491cba65db8c121$var$isNullOrUndefined(max)) {
        let exceedMax;
        let exceedMin;
        const { value: maxValue, message: maxMessage } = $6491cba65db8c121$var$getValueAndMessage(max);
        const { value: minValue, message: minMessage } = $6491cba65db8c121$var$getValueAndMessage(min);
        if (type === 'number' || !type && !isNaN(value)) {
            const valueNumber = ref.valueAsNumber || parseFloat(value);
            if (!$6491cba65db8c121$var$isNullOrUndefined(maxValue)) exceedMax = valueNumber > maxValue;
            if (!$6491cba65db8c121$var$isNullOrUndefined(minValue)) exceedMin = valueNumber < minValue;
        } else {
            const valueDate = ref.valueAsDate || new Date(value);
            if ($6491cba65db8c121$var$isString(maxValue)) exceedMax = valueDate > new Date(maxValue);
            if ($6491cba65db8c121$var$isString(minValue)) exceedMin = valueDate < new Date(minValue);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxMessage, minMessage, $6491cba65db8c121$var$INPUT_VALIDATION_RULES.max, $6491cba65db8c121$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) return error;
        }
    }
    if ($6491cba65db8c121$var$isString(value) && !isEmpty && (maxLength || minLength)) {
        const { value: maxLengthValue, message: maxLengthMessage } = $6491cba65db8c121$var$getValueAndMessage(maxLength);
        const { value: minLengthValue, message: minLengthMessage } = $6491cba65db8c121$var$getValueAndMessage(minLength);
        const inputLength = value.toString().length;
        const exceedMax = !$6491cba65db8c121$var$isNullOrUndefined(maxLengthValue) && inputLength > maxLengthValue;
        const exceedMin = !$6491cba65db8c121$var$isNullOrUndefined(minLengthValue) && inputLength < minLengthValue;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxLengthMessage, minLengthMessage);
            if (!validateAllFieldCriteria) return error;
        }
    }
    if (pattern && !isEmpty) {
        const { value: patternValue, message: patternMessage } = $6491cba65db8c121$var$getValueAndMessage(pattern);
        if ($6491cba65db8c121$var$isRegex(patternValue) && !patternValue.test(value)) {
            error[name] = Object.assign({
                type: $6491cba65db8c121$var$INPUT_VALIDATION_RULES.pattern,
                message: patternMessage,
                ref: ref
            }, appendErrorsCurry($6491cba65db8c121$var$INPUT_VALIDATION_RULES.pattern, patternMessage));
            if (!validateAllFieldCriteria) return error;
        }
    }
    if (validate) {
        const fieldValue = $6491cba65db8c121$var$getFieldValue(fieldsRef, name, shallowFieldsStateRef);
        const validateRef = isRadioOrCheckbox && options ? options[0].ref : ref;
        if ($6491cba65db8c121$var$isFunction(validate)) {
            const result = await validate(fieldValue);
            const validateError = $6491cba65db8c121$var$getValidateError(result, validateRef);
            if (validateError) {
                error[name] = Object.assign(Object.assign({}, validateError), appendErrorsCurry($6491cba65db8c121$var$INPUT_VALIDATION_RULES.validate, validateError.message));
                if (!validateAllFieldCriteria) return error;
            }
        } else if ($6491cba65db8c121$var$isObject(validate)) {
            let validationResult = {};
            for (const [key, validateFunction] of Object.entries(validate)){
                if (!$6491cba65db8c121$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateResult = await validateFunction(fieldValue);
                const validateError = $6491cba65db8c121$var$getValidateError(validateResult, validateRef, key);
                if (validateError) {
                    validationResult = Object.assign(Object.assign({}, validateError), appendErrorsCurry(key, validateError.message));
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$6491cba65db8c121$var$isEmptyObject(validationResult)) {
                error[name] = Object.assign({
                    ref: validateRef
                }, validationResult);
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    return error;
};
const $6491cba65db8c121$var$getPath = (path, values)=>{
    const getInnerPath = (key, value, isObject)=>{
        const pathWithIndex = isObject ? `${path}.${key}` : `${path}[${key}]`;
        return $6491cba65db8c121$var$isPrimitive(value) ? pathWithIndex : $6491cba65db8c121$var$getPath(pathWithIndex, value);
    };
    return Object.entries(values).map(([key, value])=>getInnerPath(key, value, $6491cba65db8c121$var$isObject(values))).flat(Infinity);
};
var $6491cba65db8c121$var$assignWatchFields = (fieldValues, fieldName, watchFields, inputValue, isSingleField)=>{
    let value;
    watchFields.add(fieldName);
    if ($6491cba65db8c121$var$isEmptyObject(fieldValues)) value = undefined;
    else {
        value = $6491cba65db8c121$export$3988ae62b71be9a3(fieldValues, fieldName);
        if ($6491cba65db8c121$var$isObject(value) || Array.isArray(value)) $6491cba65db8c121$var$getPath(fieldName, value).forEach((name)=>watchFields.add(name));
    }
    return $6491cba65db8c121$var$isUndefined(value) ? isSingleField ? inputValue : $6491cba65db8c121$export$3988ae62b71be9a3(inputValue, fieldName) : value;
};
var $6491cba65db8c121$var$skipValidation = ({ isOnBlur: isOnBlur, isOnChange: isOnChange, isOnTouch: isOnTouch, isTouched: isTouched, isReValidateOnBlur: isReValidateOnBlur, isReValidateOnChange: isReValidateOnChange, isBlurEvent: isBlurEvent, isSubmitted: isSubmitted, isOnAll: isOnAll })=>{
    if (isOnAll) return false;
    else if (!isSubmitted && isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? isReValidateOnBlur : isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? isReValidateOnChange : isOnChange) return isBlurEvent;
    return true;
};
var $6491cba65db8c121$var$getFieldArrayParentName = (name)=>name.substring(0, name.indexOf('['));
const $6491cba65db8c121$var$isMatchFieldArrayName = (name, searchName)=>RegExp(`^${searchName}[\\d+]`.replace(/\[/g, '\\[').replace(/\]/g, '\\]')).test(name);
var $6491cba65db8c121$var$isNameInFieldArray = (names, name)=>[
        ...names
    ].some((current)=>$6491cba65db8c121$var$isMatchFieldArrayName(name, current));
var $6491cba65db8c121$var$isSelectInput = (element)=>element.type === `${$6491cba65db8c121$var$SELECT}-one`;
function $6491cba65db8c121$var$onDomRemove(fieldsRef, removeFieldEventListenerAndRef) {
    const observer = new MutationObserver(()=>{
        for (const field of Object.values(fieldsRef.current)){
            if (field && field.options) {
                for (const option of field.options)if (option && option.ref && $6491cba65db8c121$var$isDetached(option.ref)) removeFieldEventListenerAndRef(field);
            } else if (field && $6491cba65db8c121$var$isDetached(field.ref)) removeFieldEventListenerAndRef(field);
        }
    });
    observer.observe(window.document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $6491cba65db8c121$var$cloneObject(data, isWeb) {
    let copy;
    if ($6491cba65db8c121$var$isPrimitive(data) || isWeb && data instanceof File) return data;
    if (data instanceof Date) {
        copy = new Date(data.getTime());
        return copy;
    }
    if (data instanceof Set) {
        copy = new Set();
        for (const item of data)copy.add(item);
        return copy;
    }
    if (data instanceof Map) {
        copy = new Map();
        for (const key of data.keys())copy.set(key, $6491cba65db8c121$var$cloneObject(data.get(key), isWeb));
        return copy;
    }
    copy = Array.isArray(data) ? [] : {};
    for(const key in data)copy[key] = $6491cba65db8c121$var$cloneObject(data[key], isWeb);
    return copy;
}
var $6491cba65db8c121$var$modeChecker = (mode)=>({
        isOnSubmit: !mode || mode === $6491cba65db8c121$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $6491cba65db8c121$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $6491cba65db8c121$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $6491cba65db8c121$var$VALIDATION_MODE.all,
        isOnTouch: mode === $6491cba65db8c121$var$VALIDATION_MODE.onTouched
    });
var $6491cba65db8c121$var$isRadioOrCheckboxFunction = (ref)=>$6491cba65db8c121$var$isRadioInput(ref) || $6491cba65db8c121$var$isCheckBoxInput(ref);
const $6491cba65db8c121$var$isWindowUndefined = typeof window === $6491cba65db8c121$var$UNDEFINED;
const $6491cba65db8c121$var$isWeb = typeof document !== $6491cba65db8c121$var$UNDEFINED && !$6491cba65db8c121$var$isWindowUndefined && !$6491cba65db8c121$var$isUndefined(window.HTMLElement);
const $6491cba65db8c121$var$isProxyEnabled = $6491cba65db8c121$var$isWeb ? 'Proxy' in window : typeof Proxy !== $6491cba65db8c121$var$UNDEFINED;
function $6491cba65db8c121$export$87c0cf8eb5a167e0({ mode: mode = $6491cba65db8c121$var$VALIDATION_MODE.onSubmit, reValidateMode: reValidateMode = $6491cba65db8c121$var$VALIDATION_MODE.onChange, resolver: resolver, context: context, defaultValues: defaultValues = {}, shouldFocusError: shouldFocusError = true, shouldUnregister: shouldUnregister = true, criteriaMode: criteriaMode } = {}) {
    const fieldsRef = (0, $a5EUy.useRef)({});
    const fieldArrayDefaultValuesRef = (0, $a5EUy.useRef)({});
    const watchFieldsRef = (0, $a5EUy.useRef)(new Set());
    const useWatchFieldsRef = (0, $a5EUy.useRef)({});
    const useWatchRenderFunctionsRef = (0, $a5EUy.useRef)({});
    const fieldsWithValidationRef = (0, $a5EUy.useRef)({});
    const validFieldsRef = (0, $a5EUy.useRef)({});
    const defaultValuesRef = (0, $a5EUy.useRef)(defaultValues);
    const defaultValuesAtRenderRef = (0, $a5EUy.useRef)({});
    const isUnMount = (0, $a5EUy.useRef)(false);
    const isWatchAllRef = (0, $a5EUy.useRef)(false);
    const handleChangeRef = (0, $a5EUy.useRef)();
    const shallowFieldsStateRef = (0, $a5EUy.useRef)(shouldUnregister ? {} : $6491cba65db8c121$var$cloneObject(defaultValues, $6491cba65db8c121$var$isWeb));
    const resetFieldArrayFunctionRef = (0, $a5EUy.useRef)({});
    const contextRef = (0, $a5EUy.useRef)(context);
    const resolverRef = (0, $a5EUy.useRef)(resolver);
    const fieldArrayNamesRef = (0, $a5EUy.useRef)(new Set());
    const modeRef = (0, $a5EUy.useRef)($6491cba65db8c121$var$modeChecker(mode));
    const { isOnSubmit: isOnSubmit, isOnTouch: isOnTouch } = modeRef.current;
    const isValidateAllFieldCriteria = criteriaMode === $6491cba65db8c121$var$VALIDATION_MODE.all;
    const [formState, setFormState] = (0, $a5EUy.useState)({
        isDirty: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touched: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: !isOnSubmit,
        errors: {}
    });
    const readFormStateRef = (0, $a5EUy.useRef)({
        isDirty: !$6491cba65db8c121$var$isProxyEnabled,
        dirtyFields: !$6491cba65db8c121$var$isProxyEnabled,
        touched: !$6491cba65db8c121$var$isProxyEnabled || isOnTouch,
        isSubmitting: !$6491cba65db8c121$var$isProxyEnabled,
        isValid: !$6491cba65db8c121$var$isProxyEnabled
    });
    const formStateRef = (0, $a5EUy.useRef)(formState);
    const observerRef = (0, $a5EUy.useRef)();
    const { isOnBlur: isReValidateOnBlur, isOnChange: isReValidateOnChange } = (0, $a5EUy.useRef)($6491cba65db8c121$var$modeChecker(reValidateMode)).current;
    contextRef.current = context;
    resolverRef.current = resolver;
    formStateRef.current = formState;
    const updateFormState = (0, $a5EUy.useCallback)((state = {})=>!isUnMount.current && setFormState(Object.assign(Object.assign({}, formStateRef.current), state)), []);
    const shouldRenderBaseOnError = (0, $a5EUy.useCallback)((name, error, shouldRender = false, state = {}, isValid)=>{
        let shouldReRender = shouldRender || $6491cba65db8c121$var$isErrorStateChanged({
            errors: formStateRef.current.errors,
            error: error,
            name: name,
            validFields: validFieldsRef.current,
            fieldsWithValidation: fieldsWithValidationRef.current
        });
        const previousError = $6491cba65db8c121$export$3988ae62b71be9a3(formStateRef.current.errors, name);
        if (error) {
            $6491cba65db8c121$var$unset(validFieldsRef.current, name);
            shouldReRender = shouldReRender || !previousError || !$6491cba65db8c121$var$deepEqual(previousError, error, true);
            $6491cba65db8c121$var$set(formStateRef.current.errors, name, error);
        } else {
            if ($6491cba65db8c121$export$3988ae62b71be9a3(fieldsWithValidationRef.current, name) || resolverRef.current) {
                $6491cba65db8c121$var$set(validFieldsRef.current, name, true);
                shouldReRender = shouldReRender || previousError;
            }
            $6491cba65db8c121$var$unset(formStateRef.current.errors, name);
        }
        if (shouldReRender && !$6491cba65db8c121$var$isNullOrUndefined(shouldRender) || !$6491cba65db8c121$var$isEmptyObject(state)) updateFormState(Object.assign(Object.assign(Object.assign({}, state), {
            errors: formStateRef.current.errors
        }), resolverRef.current ? {
            isValid: !!isValid
        } : {}));
    }, []);
    const setFieldValue = (0, $a5EUy.useCallback)((name, rawValue)=>{
        const { ref: ref, options: options } = fieldsRef.current[name];
        const value = $6491cba65db8c121$var$isWeb && $6491cba65db8c121$var$isHTMLElement(ref) && $6491cba65db8c121$var$isNullOrUndefined(rawValue) ? '' : rawValue;
        if ($6491cba65db8c121$var$isRadioInput(ref) && options) options.forEach(({ ref: radioRef })=>radioRef.checked = radioRef.value === value);
        else if ($6491cba65db8c121$var$isFileInput(ref) && !$6491cba65db8c121$var$isString(value)) ref.files = value;
        else if ($6491cba65db8c121$var$isMultipleSelect(ref)) [
            ...ref.options
        ].forEach((selectRef)=>selectRef.selected = value.includes(selectRef.value));
        else if ($6491cba65db8c121$var$isCheckBoxInput(ref) && options) options.length > 1 ? options.forEach(({ ref: checkboxRef })=>checkboxRef.checked = Array.isArray(value) ? !!value.find((data)=>data === checkboxRef.value) : value === checkboxRef.value) : options[0].ref.checked = !!value;
        else ref.value = value;
    }, []);
    const isFormDirty = ()=>!$6491cba65db8c121$var$deepEqual(getValues(), $6491cba65db8c121$var$isEmptyObject(defaultValuesRef.current) ? defaultValuesAtRenderRef.current : defaultValuesRef.current) || !$6491cba65db8c121$var$isEmptyObject(formStateRef.current.dirtyFields);
    const updateAndGetDirtyState = (0, $a5EUy.useCallback)((name, shouldRender = true)=>{
        if (readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) {
            const isFieldDirty = !$6491cba65db8c121$var$deepEqual($6491cba65db8c121$export$3988ae62b71be9a3(defaultValuesAtRenderRef.current, name), $6491cba65db8c121$var$getFieldValue(fieldsRef, name, shallowFieldsStateRef));
            const isDirtyFieldExist = $6491cba65db8c121$export$3988ae62b71be9a3(formStateRef.current.dirtyFields, name);
            const previousIsDirty = formStateRef.current.isDirty;
            isFieldDirty ? $6491cba65db8c121$var$set(formStateRef.current.dirtyFields, name, true) : $6491cba65db8c121$var$unset(formStateRef.current.dirtyFields, name);
            const state = {
                isDirty: isFormDirty(),
                dirtyFields: formStateRef.current.dirtyFields
            };
            const isChanged = readFormStateRef.current.isDirty && previousIsDirty !== state.isDirty || readFormStateRef.current.dirtyFields && isDirtyFieldExist !== $6491cba65db8c121$export$3988ae62b71be9a3(formStateRef.current.dirtyFields, name);
            if (isChanged && shouldRender) {
                formStateRef.current = Object.assign(Object.assign({}, formStateRef.current), state);
                updateFormState(Object.assign({}, state));
            }
            return isChanged ? state : {};
        }
        return {};
    }, []);
    const executeValidation = (0, $a5EUy.useCallback)(async (name, skipReRender)=>{
        if (fieldsRef.current[name]) {
            const error = (await $6491cba65db8c121$var$validateField(fieldsRef, isValidateAllFieldCriteria, fieldsRef.current[name], shallowFieldsStateRef))[name];
            shouldRenderBaseOnError(name, error, skipReRender);
            return $6491cba65db8c121$var$isUndefined(error);
        }
        return false;
    }, [
        shouldRenderBaseOnError,
        isValidateAllFieldCriteria
    ]);
    const executeSchemaOrResolverValidation = (0, $a5EUy.useCallback)(async (names)=>{
        const { errors: errors } = await resolverRef.current(getValues(), contextRef.current, isValidateAllFieldCriteria);
        const previousFormIsValid = formStateRef.current.isValid;
        if (Array.isArray(names)) {
            const isInputsValid = names.map((name)=>{
                const error = $6491cba65db8c121$export$3988ae62b71be9a3(errors, name);
                error ? $6491cba65db8c121$var$set(formStateRef.current.errors, name, error) : $6491cba65db8c121$var$unset(formStateRef.current.errors, name);
                return !error;
            }).every(Boolean);
            updateFormState({
                isValid: $6491cba65db8c121$var$isEmptyObject(errors),
                errors: formStateRef.current.errors
            });
            return isInputsValid;
        } else {
            const error = $6491cba65db8c121$export$3988ae62b71be9a3(errors, names);
            shouldRenderBaseOnError(names, error, previousFormIsValid !== $6491cba65db8c121$var$isEmptyObject(errors), {}, $6491cba65db8c121$var$isEmptyObject(errors));
            return !error;
        }
    }, [
        shouldRenderBaseOnError,
        isValidateAllFieldCriteria
    ]);
    const trigger = (0, $a5EUy.useCallback)(async (name)=>{
        const fields = name || Object.keys(fieldsRef.current);
        if (resolverRef.current) return executeSchemaOrResolverValidation(fields);
        if (Array.isArray(fields)) {
            !name && (formStateRef.current.errors = {});
            const result = await Promise.all(fields.map(async (data)=>await executeValidation(data, null)));
            updateFormState();
            return result.every(Boolean);
        }
        return await executeValidation(fields, readFormStateRef.current.isValid);
    }, [
        executeSchemaOrResolverValidation,
        executeValidation
    ]);
    const setInternalValues = (0, $a5EUy.useCallback)((name, value, { shouldDirty: shouldDirty, shouldValidate: shouldValidate })=>{
        const data = {};
        $6491cba65db8c121$var$set(data, name, value);
        for (const fieldName of $6491cba65db8c121$var$getPath(name, value))if (fieldsRef.current[fieldName]) {
            setFieldValue(fieldName, $6491cba65db8c121$export$3988ae62b71be9a3(data, fieldName));
            shouldDirty && updateAndGetDirtyState(fieldName);
            shouldValidate && trigger(fieldName);
        }
    }, [
        trigger,
        setFieldValue,
        updateAndGetDirtyState
    ]);
    const setInternalValue = (0, $a5EUy.useCallback)((name, value, config = {})=>{
        if (fieldsRef.current[name]) {
            setFieldValue(name, value);
            config.shouldDirty && updateAndGetDirtyState(name);
        } else if (!$6491cba65db8c121$var$isPrimitive(value)) {
            setInternalValues(name, value, config);
            if (fieldArrayNamesRef.current.has(name)) {
                fieldArrayDefaultValuesRef.current[name] = value;
                resetFieldArrayFunctionRef.current[name]({
                    [name]: value
                });
                if ((readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) && config.shouldDirty) {
                    $6491cba65db8c121$var$set(formStateRef.current.dirtyFields, name, $6491cba65db8c121$var$setFieldArrayDirtyFields(value, $6491cba65db8c121$export$3988ae62b71be9a3(defaultValuesRef.current, name, []), $6491cba65db8c121$export$3988ae62b71be9a3(formStateRef.current.dirtyFields, name, [])));
                    updateFormState({
                        isDirty: !$6491cba65db8c121$var$deepEqual(Object.assign(Object.assign({}, getValues()), {
                            [name]: value
                        }), defaultValuesRef.current),
                        dirtyFields: formStateRef.current.dirtyFields
                    });
                }
            }
        }
        !shouldUnregister && $6491cba65db8c121$var$set(shallowFieldsStateRef.current, name, value);
    }, [
        updateAndGetDirtyState,
        setFieldValue,
        setInternalValues
    ]);
    const isFieldWatched = (name)=>isWatchAllRef.current || watchFieldsRef.current.has(name) || watchFieldsRef.current.has((name.match(/\w+/) || [])[0]);
    const renderWatchedInputs = (name, found = true)=>{
        if (!$6491cba65db8c121$var$isEmptyObject(useWatchFieldsRef.current)) {
            for(const key in useWatchFieldsRef.current)if (!name || !useWatchFieldsRef.current[key].size || useWatchFieldsRef.current[key].has(name) || useWatchFieldsRef.current[key].has($6491cba65db8c121$var$getFieldArrayParentName(name))) {
                useWatchRenderFunctionsRef.current[key]();
                found = false;
            }
        }
        return found;
    };
    function setValue(name, value, config) {
        setInternalValue(name, value, config);
        isFieldWatched(name) && updateFormState();
        renderWatchedInputs(name);
        (config || {}).shouldValidate && trigger(name);
    }
    handleChangeRef.current = handleChangeRef.current ? handleChangeRef.current : async ({ type: type, target: target })=>{
        let name = target.name;
        const field = fieldsRef.current[name];
        let error;
        let isValid;
        if (field) {
            const isBlurEvent = type === $6491cba65db8c121$var$EVENTS.BLUR;
            const shouldSkipValidation = $6491cba65db8c121$var$skipValidation(Object.assign({
                isBlurEvent: isBlurEvent,
                isReValidateOnChange: isReValidateOnChange,
                isReValidateOnBlur: isReValidateOnBlur,
                isTouched: !!$6491cba65db8c121$export$3988ae62b71be9a3(formStateRef.current.touched, name),
                isSubmitted: formStateRef.current.isSubmitted
            }, modeRef.current));
            let state = updateAndGetDirtyState(name, false);
            let shouldRender = !$6491cba65db8c121$var$isEmptyObject(state) || isFieldWatched(name);
            if (isBlurEvent && !$6491cba65db8c121$export$3988ae62b71be9a3(formStateRef.current.touched, name) && readFormStateRef.current.touched) {
                $6491cba65db8c121$var$set(formStateRef.current.touched, name, true);
                state = Object.assign(Object.assign({}, state), {
                    touched: formStateRef.current.touched
                });
            }
            if (shouldSkipValidation) {
                renderWatchedInputs(name);
                return (!$6491cba65db8c121$var$isEmptyObject(state) || shouldRender && $6491cba65db8c121$var$isEmptyObject(state)) && updateFormState(state);
            }
            if (resolverRef.current) {
                const { errors: errors } = await resolverRef.current(getValues(), contextRef.current, isValidateAllFieldCriteria);
                const previousFormIsValid = formStateRef.current.isValid;
                error = $6491cba65db8c121$export$3988ae62b71be9a3(errors, name);
                if (!error && resolverRef.current) {
                    const parentNodeName = name.substring(0, name.lastIndexOf('.') > name.lastIndexOf('[') ? name.lastIndexOf('.') : name.lastIndexOf('['));
                    const currentError = $6491cba65db8c121$export$3988ae62b71be9a3(errors, parentNodeName, {});
                    currentError.type && currentError.message && (error = currentError);
                    if (parentNodeName && (currentError || $6491cba65db8c121$export$3988ae62b71be9a3(formStateRef.current.errors, parentNodeName))) name = parentNodeName;
                }
                isValid = $6491cba65db8c121$var$isEmptyObject(errors);
                if (previousFormIsValid !== isValid) shouldRender = true;
            } else error = (await $6491cba65db8c121$var$validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef))[name];
            renderWatchedInputs(name);
            shouldRenderBaseOnError(name, error, shouldRender, state, isValid);
        }
    };
    function setFieldArrayDefaultValues(data) {
        if (!shouldUnregister) {
            let copy = $6491cba65db8c121$var$cloneObject(data, $6491cba65db8c121$var$isWeb);
            for (const value of fieldArrayNamesRef.current)if ($6491cba65db8c121$var$isKey(value) && !copy[value]) copy = Object.assign(Object.assign({}, copy), {
                [value]: []
            });
            return copy;
        }
        return data;
    }
    function getValues(payload) {
        if ($6491cba65db8c121$var$isString(payload)) return $6491cba65db8c121$var$getFieldValue(fieldsRef, payload, shallowFieldsStateRef);
        if (Array.isArray(payload)) {
            const data = {};
            for (const name of payload)$6491cba65db8c121$var$set(data, name, $6491cba65db8c121$var$getFieldValue(fieldsRef, name, shallowFieldsStateRef));
            return data;
        }
        return setFieldArrayDefaultValues($6491cba65db8c121$var$getFieldsValues(fieldsRef, shallowFieldsStateRef));
    }
    const validateResolver = (0, $a5EUy.useCallback)(async (values = {})=>{
        const { errors: errors } = await resolverRef.current(Object.assign(Object.assign(Object.assign({}, defaultValuesRef.current), getValues()), values), contextRef.current, isValidateAllFieldCriteria);
        const isValid = $6491cba65db8c121$var$isEmptyObject(errors);
        formStateRef.current.isValid !== isValid && updateFormState({
            isValid: isValid
        });
    }, [
        isValidateAllFieldCriteria
    ]);
    const removeFieldEventListener = (0, $a5EUy.useCallback)((field, forceDelete)=>$6491cba65db8c121$var$findRemovedFieldAndRemoveListener(fieldsRef, handleChangeRef.current, field, shallowFieldsStateRef, shouldUnregister, forceDelete), [
        shouldUnregister
    ]);
    const updateWatchedValue = (name)=>{
        if (isWatchAllRef.current) updateFormState();
        else if (watchFieldsRef) {
            let shouldRenderUseWatch = true;
            for (const watchField of watchFieldsRef.current)if (watchField.startsWith(name)) {
                updateFormState();
                shouldRenderUseWatch = false;
                break;
            }
            shouldRenderUseWatch && renderWatchedInputs(name);
        }
    };
    const removeFieldEventListenerAndRef = (0, $a5EUy.useCallback)((field, forceDelete)=>{
        if (field) {
            removeFieldEventListener(field, forceDelete);
            if (shouldUnregister && !$6491cba65db8c121$var$compact(field.options || []).length) {
                $6491cba65db8c121$var$unset(defaultValuesAtRenderRef.current, field.ref.name);
                $6491cba65db8c121$var$unset(validFieldsRef.current, field.ref.name);
                $6491cba65db8c121$var$unset(fieldsWithValidationRef.current, field.ref.name);
                $6491cba65db8c121$var$unset(formStateRef.current.errors, field.ref.name);
                $6491cba65db8c121$var$set(formStateRef.current.dirtyFields, field.ref.name, true);
                updateFormState({
                    errors: formStateRef.current.errors,
                    isDirty: isFormDirty(),
                    dirtyFields: formStateRef.current.dirtyFields
                });
                readFormStateRef.current.isValid && resolverRef.current && validateResolver();
                updateWatchedValue(field.ref.name);
            }
        }
    }, [
        validateResolver,
        removeFieldEventListener
    ]);
    function clearErrors(name) {
        name && (Array.isArray(name) ? name : [
            name
        ]).forEach((inputName)=>fieldsRef.current[inputName] ? $6491cba65db8c121$var$isKey(inputName) ? delete formStateRef.current.errors[inputName] : $6491cba65db8c121$var$set(formStateRef.current.errors, inputName, undefined) : $6491cba65db8c121$var$unset(formStateRef.current.errors, inputName));
        updateFormState({
            errors: name ? formStateRef.current.errors : {}
        });
    }
    function setError(name, error) {
        const ref = (fieldsRef.current[name] || {}).ref;
        $6491cba65db8c121$var$set(formStateRef.current.errors, name, Object.assign(Object.assign({}, error), {
            ref: ref
        }));
        updateFormState({
            isValid: false,
            errors: formStateRef.current.errors
        });
        error.shouldFocus && ref && ref.focus && ref.focus();
    }
    const watchInternal = (0, $a5EUy.useCallback)((fieldNames, defaultValue, watchId)=>{
        const watchFields = watchId ? useWatchFieldsRef.current[watchId] : watchFieldsRef.current;
        const combinedDefaultValues = $6491cba65db8c121$var$isUndefined(defaultValue) ? defaultValuesRef.current : defaultValue;
        const fieldValues = $6491cba65db8c121$var$getFieldsValues(fieldsRef, shallowFieldsStateRef, false, fieldNames);
        if ($6491cba65db8c121$var$isString(fieldNames)) return $6491cba65db8c121$var$assignWatchFields(fieldValues, fieldNames, watchFields, $6491cba65db8c121$var$isUndefined(defaultValue) ? $6491cba65db8c121$export$3988ae62b71be9a3(combinedDefaultValues, fieldNames) : defaultValue, true);
        if (Array.isArray(fieldNames)) return fieldNames.reduce((previous, name)=>Object.assign(Object.assign({}, previous), {
                [name]: $6491cba65db8c121$var$assignWatchFields(fieldValues, name, watchFields, combinedDefaultValues)
            }), {});
        isWatchAllRef.current = $6491cba65db8c121$var$isUndefined(watchId);
        return $6491cba65db8c121$export$19bfedbbacd9b12a(!$6491cba65db8c121$var$isEmptyObject(fieldValues) && fieldValues || combinedDefaultValues);
    }, []);
    function watch(fieldNames, defaultValue) {
        return watchInternal(fieldNames, defaultValue);
    }
    function unregister(name) {
        for (const fieldName of Array.isArray(name) ? name : [
            name
        ])removeFieldEventListenerAndRef(fieldsRef.current[fieldName], true);
    }
    function registerFieldRef(ref, validateOptions = {}) {
        const { name: name, type: type, value: value } = ref;
        const fieldRefAndValidationOptions = Object.assign({
            ref: ref
        }, validateOptions);
        const fields = fieldsRef.current;
        const isRadioOrCheckbox = $6491cba65db8c121$var$isRadioOrCheckboxFunction(ref);
        const isFieldArray = $6491cba65db8c121$var$isNameInFieldArray(fieldArrayNamesRef.current, name);
        const compareRef = (currentRef)=>$6491cba65db8c121$var$isWeb && (!$6491cba65db8c121$var$isHTMLElement(ref) || currentRef === ref);
        let field = fields[name];
        let isEmptyDefaultValue = true;
        let defaultValue;
        if (field && (isRadioOrCheckbox ? Array.isArray(field.options) && $6491cba65db8c121$var$compact(field.options).find((option)=>{
            return value === option.ref.value && compareRef(option.ref);
        }) : compareRef(field.ref))) {
            fields[name] = Object.assign(Object.assign({}, field), validateOptions);
            return;
        }
        if (type) field = isRadioOrCheckbox ? Object.assign({
            options: [
                ...$6491cba65db8c121$var$compact(field && field.options || []),
                {
                    ref: ref
                }
            ],
            ref: {
                type: type,
                name: name
            }
        }, validateOptions) : Object.assign({}, fieldRefAndValidationOptions);
        else field = fieldRefAndValidationOptions;
        fields[name] = field;
        const isEmptyUnmountFields = $6491cba65db8c121$var$isUndefined($6491cba65db8c121$export$3988ae62b71be9a3(shallowFieldsStateRef.current, name));
        if (!$6491cba65db8c121$var$isEmptyObject(defaultValuesRef.current) || !isEmptyUnmountFields) {
            defaultValue = $6491cba65db8c121$export$3988ae62b71be9a3(isEmptyUnmountFields ? defaultValuesRef.current : shallowFieldsStateRef.current, name);
            isEmptyDefaultValue = $6491cba65db8c121$var$isUndefined(defaultValue);
            if (!isEmptyDefaultValue && !isFieldArray) setFieldValue(name, defaultValue);
        }
        if (!$6491cba65db8c121$var$isEmptyObject(validateOptions)) {
            $6491cba65db8c121$var$set(fieldsWithValidationRef.current, name, true);
            if (!isOnSubmit && readFormStateRef.current.isValid) $6491cba65db8c121$var$validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef).then((error)=>{
                const previousFormIsValid = formStateRef.current.isValid;
                $6491cba65db8c121$var$isEmptyObject(error) ? $6491cba65db8c121$var$set(validFieldsRef.current, name, true) : $6491cba65db8c121$var$unset(validFieldsRef.current, name);
                if (previousFormIsValid !== $6491cba65db8c121$var$isEmptyObject(error)) updateFormState();
            });
        }
        if (!defaultValuesAtRenderRef.current[name] && !(isFieldArray && isEmptyDefaultValue)) {
            const fieldValue = $6491cba65db8c121$var$getFieldValue(fieldsRef, name, shallowFieldsStateRef);
            $6491cba65db8c121$var$set(defaultValuesAtRenderRef.current, name, isEmptyDefaultValue ? $6491cba65db8c121$var$isObject(fieldValue) ? Object.assign({}, fieldValue) : fieldValue : defaultValue);
            !isFieldArray && $6491cba65db8c121$var$unset(formStateRef.current.dirtyFields, name);
        }
        if (type) $6491cba65db8c121$var$attachEventListeners(isRadioOrCheckbox && field.options ? field.options[field.options.length - 1] : field, isRadioOrCheckbox || $6491cba65db8c121$var$isSelectInput(ref), handleChangeRef.current);
    }
    function register(refOrValidationOptions, rules) {
        if (!$6491cba65db8c121$var$isWindowUndefined) {
            if ($6491cba65db8c121$var$isString(refOrValidationOptions)) registerFieldRef({
                name: refOrValidationOptions
            }, rules);
            else if ($6491cba65db8c121$var$isObject(refOrValidationOptions) && 'name' in refOrValidationOptions) registerFieldRef(refOrValidationOptions, rules);
            else return (ref)=>ref && registerFieldRef(ref, refOrValidationOptions);
        }
    }
    const handleSubmit = (0, $a5EUy.useCallback)((onValid, onInvalid)=>async (e)=>{
            if (e && e.preventDefault) {
                e.preventDefault();
                e.persist();
            }
            let fieldErrors = {};
            let fieldValues = setFieldArrayDefaultValues($6491cba65db8c121$var$getFieldsValues(fieldsRef, shallowFieldsStateRef, true));
            readFormStateRef.current.isSubmitting && updateFormState({
                isSubmitting: true
            });
            try {
                if (resolverRef.current) {
                    const { errors: errors, values: values } = await resolverRef.current(fieldValues, contextRef.current, isValidateAllFieldCriteria);
                    formStateRef.current.errors = fieldErrors = errors;
                    fieldValues = values;
                } else {
                    for (const field of Object.values(fieldsRef.current))if (field) {
                        const { ref: { name: name } } = field;
                        const fieldError = await $6491cba65db8c121$var$validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef);
                        if (fieldError[name]) {
                            $6491cba65db8c121$var$set(fieldErrors, name, fieldError[name]);
                            $6491cba65db8c121$var$unset(validFieldsRef.current, name);
                        } else if ($6491cba65db8c121$export$3988ae62b71be9a3(fieldsWithValidationRef.current, name)) {
                            $6491cba65db8c121$var$unset(formStateRef.current.errors, name);
                            $6491cba65db8c121$var$set(validFieldsRef.current, name, true);
                        }
                    }
                }
                if ($6491cba65db8c121$var$isEmptyObject(fieldErrors) && Object.keys(formStateRef.current.errors).every((name)=>name in fieldsRef.current)) {
                    updateFormState({
                        errors: {},
                        isSubmitting: true
                    });
                    await onValid(fieldValues, e);
                } else {
                    formStateRef.current.errors = Object.assign(Object.assign({}, formStateRef.current.errors), fieldErrors);
                    onInvalid && await onInvalid(formStateRef.current.errors, e);
                    shouldFocusError && $6491cba65db8c121$var$focusOnErrorField(fieldsRef.current, formStateRef.current.errors);
                }
            } finally{
                updateFormState({
                    isSubmitted: true,
                    isSubmitting: false,
                    isSubmitSuccessful: $6491cba65db8c121$var$isEmptyObject(formStateRef.current.errors),
                    errors: formStateRef.current.errors,
                    submitCount: formStateRef.current.submitCount + 1
                });
            }
        }, [
        shouldFocusError,
        isValidateAllFieldCriteria
    ]);
    const resetRefs = ({ errors: errors, isDirty: isDirty, isSubmitted: isSubmitted, touched: touched, isValid: isValid, submitCount: submitCount, dirtyFields: dirtyFields })=>{
        if (!isValid) {
            validFieldsRef.current = {};
            fieldsWithValidationRef.current = {};
        }
        defaultValuesAtRenderRef.current = {};
        fieldArrayDefaultValuesRef.current = {};
        watchFieldsRef.current = new Set();
        isWatchAllRef.current = false;
        updateFormState({
            submitCount: submitCount ? formStateRef.current.submitCount : 0,
            isDirty: isDirty ? formStateRef.current.isDirty : false,
            isSubmitted: isSubmitted ? formStateRef.current.isSubmitted : false,
            isValid: isValid ? formStateRef.current.isValid : false,
            dirtyFields: dirtyFields ? formStateRef.current.dirtyFields : {},
            touched: touched ? formStateRef.current.touched : {},
            errors: errors ? formStateRef.current.errors : {},
            isSubmitting: false,
            isSubmitSuccessful: false
        });
    };
    const reset = (values, omitResetState = {})=>{
        if ($6491cba65db8c121$var$isWeb) {
            for (const field of Object.values(fieldsRef.current))if (field) {
                const { ref: ref, options: options } = field;
                const inputRef = $6491cba65db8c121$var$isRadioOrCheckboxFunction(ref) && Array.isArray(options) ? options[0].ref : ref;
                if ($6491cba65db8c121$var$isHTMLElement(inputRef)) try {
                    inputRef.closest('form').reset();
                    break;
                } catch (_a) {}
            }
        }
        fieldsRef.current = {};
        defaultValuesRef.current = $6491cba65db8c121$var$cloneObject(values || defaultValuesRef.current, $6491cba65db8c121$var$isWeb);
        values && renderWatchedInputs('');
        Object.values(resetFieldArrayFunctionRef.current).forEach((resetFieldArray)=>$6491cba65db8c121$var$isFunction(resetFieldArray) && resetFieldArray());
        shallowFieldsStateRef.current = shouldUnregister ? {} : $6491cba65db8c121$var$cloneObject(values, $6491cba65db8c121$var$isWeb) || {};
        resetRefs(omitResetState);
    };
    (0, $a5EUy.useEffect)(()=>{
        isUnMount.current = false;
        resolver && readFormStateRef.current.isValid && validateResolver();
        observerRef.current = observerRef.current || !$6491cba65db8c121$var$isWeb ? observerRef.current : $6491cba65db8c121$var$onDomRemove(fieldsRef, removeFieldEventListenerAndRef);
        return ()=>{
            isUnMount.current = true;
            observerRef.current && observerRef.current.disconnect();
            shallowFieldsStateRef.current = {};
            Object.values(fieldsRef.current).forEach((field)=>removeFieldEventListenerAndRef(field, true));
        };
    }, [
        removeFieldEventListenerAndRef
    ]);
    if (!resolver && readFormStateRef.current.isValid) formState.isValid = $6491cba65db8c121$var$deepEqual(validFieldsRef.current, fieldsWithValidationRef.current) && $6491cba65db8c121$var$isEmptyObject(formStateRef.current.errors);
    const commonProps = {
        trigger: trigger,
        setValue: (0, $a5EUy.useCallback)(setValue, [
            setInternalValue,
            trigger
        ]),
        getValues: (0, $a5EUy.useCallback)(getValues, []),
        register: (0, $a5EUy.useCallback)(register, [
            defaultValuesRef.current
        ]),
        unregister: (0, $a5EUy.useCallback)(unregister, [])
    };
    const control = Object.assign({
        updateWatchedValue: updateWatchedValue,
        shouldUnregister: shouldUnregister,
        removeFieldEventListener: removeFieldEventListener,
        watchInternal: watchInternal,
        mode: modeRef.current,
        reValidateMode: {
            isReValidateOnBlur: isReValidateOnBlur,
            isReValidateOnChange: isReValidateOnChange
        },
        fieldsRef: fieldsRef,
        resetFieldArrayFunctionRef: resetFieldArrayFunctionRef,
        useWatchFieldsRef: useWatchFieldsRef,
        useWatchRenderFunctionsRef: useWatchRenderFunctionsRef,
        fieldArrayDefaultValuesRef: fieldArrayDefaultValuesRef,
        validFieldsRef: validFieldsRef,
        fieldsWithValidationRef: fieldsWithValidationRef,
        fieldArrayNamesRef: fieldArrayNamesRef,
        readFormStateRef: readFormStateRef,
        formStateRef: formStateRef,
        defaultValuesRef: defaultValuesRef,
        shallowFieldsStateRef: shallowFieldsStateRef,
        updateFormState: updateFormState,
        validateResolver: resolver ? validateResolver : undefined
    }, commonProps);
    return Object.assign({
        watch: watch,
        control: control,
        formState: $6491cba65db8c121$var$isProxyEnabled ? new Proxy(formState, {
            get: (obj, prop)=>{
                if (prop in obj) {
                    readFormStateRef.current[prop] = true;
                    return obj[prop];
                }
                return undefined;
            }
        }) : formState,
        handleSubmit: handleSubmit,
        reset: (0, $a5EUy.useCallback)(reset, []),
        clearErrors: (0, $a5EUy.useCallback)(clearErrors, []),
        setError: (0, $a5EUy.useCallback)(setError, []),
        errors: formState.errors
    }, commonProps);
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $6491cba65db8c121$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
const $6491cba65db8c121$var$FormContext = (0, $a5EUy.createContext)(null);
$6491cba65db8c121$var$FormContext.displayName = 'RHFContext';
const $6491cba65db8c121$export$4d957a5e1be13b03 = ()=>(0, $a5EUy.useContext)($6491cba65db8c121$var$FormContext);
const $6491cba65db8c121$export$8ce1ff4f94d08846 = (_a)=>{
    var { children: children } = _a, props = $6491cba65db8c121$var$__rest(_a, [
        "children"
    ]);
    return (0, $a5EUy.createElement)($6491cba65db8c121$var$FormContext.Provider, {
        value: Object.assign({}, props)
    }, children);
};
var $6491cba65db8c121$var$generateId = ()=>{
    const d = typeof performance === $6491cba65db8c121$var$UNDEFINED ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
const $6491cba65db8c121$var$removeAt = (data, index)=>[
        ...data.slice(0, index),
        ...data.slice(index + 1)
    ];
function $6491cba65db8c121$var$removeAtIndexes(data, index) {
    let k = -1;
    while(++k < data.length)if (index.indexOf(k) >= 0) delete data[k];
    return $6491cba65db8c121$var$compact(data);
}
var $6491cba65db8c121$var$removeArrayAt = (data, index)=>$6491cba65db8c121$var$isUndefined(index) ? [] : Array.isArray(index) ? $6491cba65db8c121$var$removeAtIndexes(data, index) : $6491cba65db8c121$var$removeAt(data, index);
var $6491cba65db8c121$var$moveArrayAt = (data, from, to)=>{
    if (Array.isArray(data)) {
        if ($6491cba65db8c121$var$isUndefined(data[to])) data[to] = undefined;
        data.splice(to, 0, data.splice(from, 1)[0]);
        return data;
    }
    return [];
};
var $6491cba65db8c121$var$swapArrayAt = (data, indexA, indexB)=>{
    const temp = [
        data[indexB],
        data[indexA]
    ];
    data[indexA] = temp[0];
    data[indexB] = temp[1];
};
function $6491cba65db8c121$var$prepend(data, value) {
    return [
        ...Array.isArray(value) ? value : [
            value || undefined
        ],
        ...data
    ];
}
function $6491cba65db8c121$var$insert(data, index, value) {
    return [
        ...data.slice(0, index),
        ...Array.isArray(value) ? value : [
            value || undefined
        ],
        ...data.slice(index)
    ];
}
var $6491cba65db8c121$var$fillEmptyArray = (value)=>Array.isArray(value) ? Array(value.length).fill(undefined) : undefined;
function $6491cba65db8c121$var$mapValueToBoolean(value) {
    if ($6491cba65db8c121$var$isObject(value)) {
        const object = {};
        for(const key in value)object[key] = true;
        return [
            object
        ];
    }
    return [
        true
    ];
}
var $6491cba65db8c121$var$fillBooleanArray = (value)=>(Array.isArray(value) ? value : [
        value
    ]).map($6491cba65db8c121$var$mapValueToBoolean).flat();
const $6491cba65db8c121$var$mapIds = (values = [], keyName)=>{
    return values.map((value)=>Object.assign({
            [keyName]: $6491cba65db8c121$var$generateId()
        }, value));
};
const $6491cba65db8c121$export$310131896651d559 = ({ control: control, name: name, keyName: keyName = 'id' })=>{
    const methods = $6491cba65db8c121$export$4d957a5e1be13b03();
    const focusIndexRef = (0, $a5EUy.useRef)(-1);
    const { updateWatchedValue: updateWatchedValue, resetFieldArrayFunctionRef: resetFieldArrayFunctionRef, fieldArrayNamesRef: fieldArrayNamesRef, fieldsRef: fieldsRef, defaultValuesRef: defaultValuesRef, removeFieldEventListener: removeFieldEventListener, formStateRef: formStateRef, shallowFieldsStateRef: shallowFieldsStateRef, updateFormState: updateFormState, readFormStateRef: readFormStateRef, validFieldsRef: validFieldsRef, fieldsWithValidationRef: fieldsWithValidationRef, fieldArrayDefaultValuesRef: fieldArrayDefaultValuesRef, validateResolver: validateResolver, getValues: getValues, shouldUnregister: shouldUnregister } = control || methods.control;
    const fieldArrayParentName = $6491cba65db8c121$var$getFieldArrayParentName(name);
    const memoizedDefaultValues = (0, $a5EUy.useRef)([
        ...$6491cba65db8c121$export$3988ae62b71be9a3(fieldArrayDefaultValuesRef.current, fieldArrayParentName) ? $6491cba65db8c121$export$3988ae62b71be9a3(fieldArrayDefaultValuesRef.current, name, []) : $6491cba65db8c121$export$3988ae62b71be9a3(shouldUnregister ? defaultValuesRef.current : shallowFieldsStateRef.current, name, [])
    ]);
    const [fields, setFields] = (0, $a5EUy.useState)($6491cba65db8c121$var$mapIds(memoizedDefaultValues.current, keyName));
    const allFields = (0, $a5EUy.useRef)(fields);
    const getCurrentFieldsValues = ()=>$6491cba65db8c121$export$3988ae62b71be9a3(getValues(), name, allFields.current).map((item, index)=>Object.assign(Object.assign({}, allFields.current[index]), item));
    allFields.current = fields;
    fieldArrayNamesRef.current.add(name);
    if (!$6491cba65db8c121$export$3988ae62b71be9a3(fieldArrayDefaultValuesRef.current, fieldArrayParentName)) $6491cba65db8c121$var$set(fieldArrayDefaultValuesRef.current, fieldArrayParentName, $6491cba65db8c121$export$3988ae62b71be9a3(defaultValuesRef.current, fieldArrayParentName));
    const setFieldAndValidState = (fieldsValues)=>{
        setFields(fieldsValues);
        if (readFormStateRef.current.isValid && validateResolver) {
            const values = getValues();
            $6491cba65db8c121$var$set(values, name, fieldsValues);
            validateResolver(values);
        }
    };
    const getIsDirtyState = (flagOrFields)=>(readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) && ($6491cba65db8c121$var$isUndefined(flagOrFields) || !$6491cba65db8c121$var$deepEqual(flagOrFields.map((_a = {})=>{
            var _b = keyName, omitted = _a[_b], rest = $6491cba65db8c121$var$__rest(_a, [
                typeof _b === "symbol" ? _b : _b + ""
            ]);
            return rest;
        }), $6491cba65db8c121$export$3988ae62b71be9a3(defaultValuesRef.current, name, [])));
    const resetFields = ()=>{
        for(const key in fieldsRef.current)$6491cba65db8c121$var$isMatchFieldArrayName(key, name) && removeFieldEventListener(fieldsRef.current[key], true);
    };
    const cleanup = (ref)=>!$6491cba65db8c121$var$compact($6491cba65db8c121$export$3988ae62b71be9a3(ref, name, [])).length && $6491cba65db8c121$var$unset(ref, name);
    const updateDirtyFieldsWithDefaultValues = (updatedFieldArrayValues)=>{
        const defaultFieldArrayValues = $6491cba65db8c121$export$3988ae62b71be9a3(defaultValuesRef.current, name, []);
        const updateDirtyFieldsBaseOnDefaultValues = (base, target)=>{
            for(const key in base){
                for(const innerKey in base[key])if (innerKey !== keyName && (!target[key] || !base[key] || base[key][innerKey] !== target[key][innerKey])) $6491cba65db8c121$var$set(formStateRef.current.dirtyFields, `${name}[${key}]`, Object.assign(Object.assign({}, $6491cba65db8c121$export$3988ae62b71be9a3(formStateRef.current.dirtyFields, `${name}[${key}]`, {})), {
                    [innerKey]: true
                }));
            }
        };
        if (updatedFieldArrayValues) {
            updateDirtyFieldsBaseOnDefaultValues(defaultFieldArrayValues, updatedFieldArrayValues);
            updateDirtyFieldsBaseOnDefaultValues(updatedFieldArrayValues, defaultFieldArrayValues);
        }
    };
    const batchStateUpdate = (method, args, updatedFieldValues, isDirty = true, shouldSet = true, shouldUpdateValid = false)=>{
        if ($6491cba65db8c121$export$3988ae62b71be9a3(shallowFieldsStateRef.current, name)) {
            const output = method($6491cba65db8c121$export$3988ae62b71be9a3(shallowFieldsStateRef.current, name), args.argA, args.argB);
            shouldSet && $6491cba65db8c121$var$set(shallowFieldsStateRef.current, name, output);
        }
        if ($6491cba65db8c121$export$3988ae62b71be9a3(fieldArrayDefaultValuesRef.current, name)) {
            const output = method($6491cba65db8c121$export$3988ae62b71be9a3(fieldArrayDefaultValuesRef.current, name), args.argA, args.argB);
            shouldSet && $6491cba65db8c121$var$set(fieldArrayDefaultValuesRef.current, name, output);
            cleanup(fieldArrayDefaultValuesRef.current);
        }
        if (Array.isArray($6491cba65db8c121$export$3988ae62b71be9a3(formStateRef.current.errors, name))) {
            const output = method($6491cba65db8c121$export$3988ae62b71be9a3(formStateRef.current.errors, name), args.argA, args.argB);
            shouldSet && $6491cba65db8c121$var$set(formStateRef.current.errors, name, output);
            cleanup(formStateRef.current.errors);
        }
        if (readFormStateRef.current.touched && $6491cba65db8c121$export$3988ae62b71be9a3(formStateRef.current.touched, name)) {
            const output = method($6491cba65db8c121$export$3988ae62b71be9a3(formStateRef.current.touched, name), args.argA, args.argB);
            shouldSet && $6491cba65db8c121$var$set(formStateRef.current.touched, name, output);
            cleanup(formStateRef.current.touched);
        }
        if (readFormStateRef.current.dirtyFields || readFormStateRef.current.isDirty) {
            const output = method($6491cba65db8c121$export$3988ae62b71be9a3(formStateRef.current.dirtyFields, name, []), args.argC, args.argD);
            shouldSet && $6491cba65db8c121$var$set(formStateRef.current.dirtyFields, name, output);
            updateDirtyFieldsWithDefaultValues(updatedFieldValues);
            cleanup(formStateRef.current.dirtyFields);
        }
        if (shouldUpdateValid && readFormStateRef.current.isValid && !validateResolver) {
            $6491cba65db8c121$var$set(validFieldsRef.current, name, method($6491cba65db8c121$export$3988ae62b71be9a3(validFieldsRef.current, name, []), args.argA));
            cleanup(validFieldsRef.current);
            $6491cba65db8c121$var$set(fieldsWithValidationRef.current, name, method($6491cba65db8c121$export$3988ae62b71be9a3(fieldsWithValidationRef.current, name, []), args.argA));
            cleanup(fieldsWithValidationRef.current);
        }
        updateFormState({
            errors: formStateRef.current.errors,
            dirtyFields: formStateRef.current.dirtyFields,
            isDirty: isDirty,
            touched: formStateRef.current.touched
        });
    };
    const append = (value, shouldFocus = true)=>{
        const updateFormValues = [
            ...allFields.current,
            ...$6491cba65db8c121$var$mapIds(Array.isArray(value) ? value : [
                value
            ], keyName)
        ];
        setFieldAndValidState(updateFormValues);
        if (readFormStateRef.current.dirtyFields || readFormStateRef.current.isDirty) {
            updateDirtyFieldsWithDefaultValues(updateFormValues);
            updateFormState({
                isDirty: true,
                dirtyFields: formStateRef.current.dirtyFields
            });
        }
        !shouldUnregister && $6491cba65db8c121$var$set(shallowFieldsStateRef.current, name, [
            ...shallowFieldsStateRef.current[name] || [],
            value
        ]);
        focusIndexRef.current = shouldFocus ? allFields.current.length : -1;
    };
    const prepend$1 = (value, shouldFocus = true)=>{
        const emptyArray = $6491cba65db8c121$var$fillEmptyArray(value);
        const updatedFieldArrayValues = $6491cba65db8c121$var$prepend(getCurrentFieldsValues(), $6491cba65db8c121$var$mapIds(Array.isArray(value) ? value : [
            value
        ], keyName));
        setFieldAndValidState(updatedFieldArrayValues);
        resetFields();
        batchStateUpdate($6491cba65db8c121$var$prepend, {
            argA: emptyArray,
            argC: $6491cba65db8c121$var$fillBooleanArray(value)
        }, updatedFieldArrayValues);
        focusIndexRef.current = shouldFocus ? 0 : -1;
    };
    const remove = (index)=>{
        const fieldValues = getCurrentFieldsValues();
        const updatedFieldValues = $6491cba65db8c121$var$removeArrayAt(fieldValues, index);
        setFieldAndValidState(updatedFieldValues);
        resetFields();
        batchStateUpdate($6491cba65db8c121$var$removeArrayAt, {
            argA: index,
            argC: index
        }, updatedFieldValues, getIsDirtyState($6491cba65db8c121$var$removeArrayAt(fieldValues, index)), true, true);
    };
    const insert$1 = (index, value, shouldFocus = true)=>{
        const emptyArray = $6491cba65db8c121$var$fillEmptyArray(value);
        const fieldValues = getCurrentFieldsValues();
        const updatedFieldArrayValues = $6491cba65db8c121$var$insert(fieldValues, index, $6491cba65db8c121$var$mapIds(Array.isArray(value) ? value : [
            value
        ], keyName));
        setFieldAndValidState(updatedFieldArrayValues);
        resetFields();
        batchStateUpdate($6491cba65db8c121$var$insert, {
            argA: index,
            argB: emptyArray,
            argC: index,
            argD: $6491cba65db8c121$var$fillBooleanArray(value)
        }, updatedFieldArrayValues, getIsDirtyState($6491cba65db8c121$var$insert(fieldValues, index)));
        focusIndexRef.current = shouldFocus ? index : -1;
    };
    const swap = (indexA, indexB)=>{
        const fieldValues = getCurrentFieldsValues();
        $6491cba65db8c121$var$swapArrayAt(fieldValues, indexA, indexB);
        resetFields();
        setFieldAndValidState([
            ...fieldValues
        ]);
        batchStateUpdate($6491cba65db8c121$var$swapArrayAt, {
            argA: indexA,
            argB: indexB,
            argC: indexA,
            argD: indexB
        }, undefined, getIsDirtyState(fieldValues), false);
    };
    const move = (from, to)=>{
        const fieldValues = getCurrentFieldsValues();
        $6491cba65db8c121$var$moveArrayAt(fieldValues, from, to);
        resetFields();
        setFieldAndValidState([
            ...fieldValues
        ]);
        batchStateUpdate($6491cba65db8c121$var$moveArrayAt, {
            argA: from,
            argB: to,
            argC: from,
            argD: to
        }, undefined, getIsDirtyState(fieldValues), false);
    };
    const reset = (data)=>{
        resetFields();
        !data && $6491cba65db8c121$var$unset(fieldArrayDefaultValuesRef.current, name);
        $6491cba65db8c121$var$unset(shallowFieldsStateRef.current, name);
        memoizedDefaultValues.current = $6491cba65db8c121$export$3988ae62b71be9a3(data || defaultValuesRef.current, name);
        setFields($6491cba65db8c121$var$mapIds(memoizedDefaultValues.current, keyName));
    };
    (0, $a5EUy.useEffect)(()=>{
        const defaultValues = $6491cba65db8c121$export$3988ae62b71be9a3(fieldArrayDefaultValuesRef.current, name);
        if (defaultValues && fields.length < defaultValues.length) {
            defaultValues.pop();
            $6491cba65db8c121$var$set(fieldArrayDefaultValuesRef.current, name, defaultValues);
        }
        updateWatchedValue(name);
        if (focusIndexRef.current > -1) for(const key in fieldsRef.current){
            const field = fieldsRef.current[key];
            if (key.startsWith(`${name}[${focusIndexRef.current}]`) && field.ref.focus) {
                field.ref.focus();
                break;
            }
        }
        focusIndexRef.current = -1;
    }, [
        fields,
        name
    ]);
    (0, $a5EUy.useEffect)(()=>{
        const resetFunctions = resetFieldArrayFunctionRef.current;
        const fieldArrayNames = fieldArrayNamesRef.current;
        if (!$6491cba65db8c121$var$getFieldArrayParentName(name)) resetFunctions[name] = reset;
        return ()=>{
            resetFields();
            delete resetFunctions[name];
            fieldArrayNames.delete(name);
        };
    }, []);
    return {
        swap: (0, $a5EUy.useCallback)(swap, [
            name
        ]),
        move: (0, $a5EUy.useCallback)(move, [
            name
        ]),
        prepend: (0, $a5EUy.useCallback)(prepend$1, [
            name
        ]),
        append: (0, $a5EUy.useCallback)(append, [
            name
        ]),
        remove: (0, $a5EUy.useCallback)(remove, [
            name
        ]),
        insert: (0, $a5EUy.useCallback)(insert$1, [
            name
        ]),
        fields: fields
    };
};
function $6491cba65db8c121$export$3c773aa2b84f29e0({ control: control, name: name, defaultValue: defaultValue }) {
    const methods = $6491cba65db8c121$export$4d957a5e1be13b03();
    const { useWatchFieldsRef: useWatchFieldsRef, useWatchRenderFunctionsRef: useWatchRenderFunctionsRef, watchInternal: watchInternal, defaultValuesRef: defaultValuesRef } = control || methods.control;
    const [value, setValue] = (0, $a5EUy.useState)($6491cba65db8c121$var$isUndefined(defaultValue) ? $6491cba65db8c121$var$isString(name) ? $6491cba65db8c121$export$3988ae62b71be9a3(defaultValuesRef.current, name) : Array.isArray(name) ? name.reduce((previous, inputName)=>Object.assign(Object.assign({}, previous), {
            [inputName]: $6491cba65db8c121$export$3988ae62b71be9a3(defaultValuesRef.current, inputName)
        }), {}) : defaultValuesRef.current : defaultValue);
    const idRef = (0, $a5EUy.useRef)();
    const defaultValueRef = (0, $a5EUy.useRef)(defaultValue);
    const updateWatchValue = (0, $a5EUy.useCallback)(()=>{
        const value = watchInternal(name, defaultValueRef.current, idRef.current);
        setValue($6491cba65db8c121$var$isObject(value) ? Object.assign({}, value) : Array.isArray(value) ? [
            ...value
        ] : value);
    }, [
        setValue,
        watchInternal,
        defaultValueRef,
        name,
        idRef
    ]);
    (0, $a5EUy.useEffect)(()=>{
        const id = idRef.current = $6491cba65db8c121$var$generateId();
        const watchFieldsHookRender = useWatchRenderFunctionsRef.current;
        const watchFieldsHook = useWatchFieldsRef.current;
        watchFieldsHook[id] = new Set();
        watchFieldsHookRender[id] = updateWatchValue;
        watchInternal(name, defaultValueRef.current, id);
        return ()=>{
            delete watchFieldsHook[id];
            delete watchFieldsHookRender[id];
        };
    }, [
        name,
        updateWatchValue,
        useWatchRenderFunctionsRef,
        useWatchFieldsRef,
        watchInternal,
        defaultValueRef
    ]);
    return $6491cba65db8c121$var$isUndefined(value) ? defaultValue : value;
}
var $6491cba65db8c121$var$getInputValue = (event)=>$6491cba65db8c121$var$isPrimitive(event) || !$6491cba65db8c121$var$isObject(event.target) || $6491cba65db8c121$var$isObject(event.target) && !event.type ? event : $6491cba65db8c121$var$isUndefined(event.target.value) ? event.target.checked : event.target.value;
const $6491cba65db8c121$export$bd0bf19f25da8474 = (_a)=>{
    var { name: name, rules: rules, as: as, render: render, defaultValue: defaultValue, control: control, onFocus: onFocus } = _a, rest = $6491cba65db8c121$var$__rest(_a, [
        "name",
        "rules",
        "as",
        "render",
        "defaultValue",
        "control",
        "onFocus"
    ]);
    const methods = $6491cba65db8c121$export$4d957a5e1be13b03();
    const { defaultValuesRef: defaultValuesRef, setValue: setValue, register: register, unregister: unregister, trigger: trigger, mode: mode, reValidateMode: { isReValidateOnBlur: isReValidateOnBlur, isReValidateOnChange: isReValidateOnChange }, formStateRef: { current: { isSubmitted: isSubmitted, touched: touched } }, updateFormState: updateFormState, readFormStateRef: readFormStateRef, fieldsRef: fieldsRef, fieldArrayNamesRef: fieldArrayNamesRef, shallowFieldsStateRef: shallowFieldsStateRef } = control || methods.control;
    const isNotFieldArray = !$6491cba65db8c121$var$isNameInFieldArray(fieldArrayNamesRef.current, name);
    const getInitialValue = ()=>!$6491cba65db8c121$var$isUndefined($6491cba65db8c121$export$3988ae62b71be9a3(shallowFieldsStateRef.current, name)) && isNotFieldArray ? $6491cba65db8c121$export$3988ae62b71be9a3(shallowFieldsStateRef.current, name) : $6491cba65db8c121$var$isUndefined(defaultValue) ? $6491cba65db8c121$export$3988ae62b71be9a3(defaultValuesRef.current, name) : defaultValue;
    const [value, setInputStateValue] = (0, $a5EUy.useState)(getInitialValue());
    const valueRef = (0, $a5EUy.useRef)(value);
    const ref = (0, $a5EUy.useRef)({
        focus: ()=>null
    });
    const onFocusRef = (0, $a5EUy.useRef)(onFocus || (()=>ref.current.focus()));
    const shouldValidate = (isBlurEvent)=>!$6491cba65db8c121$var$skipValidation(Object.assign({
            isBlurEvent: isBlurEvent,
            isReValidateOnBlur: isReValidateOnBlur,
            isReValidateOnChange: isReValidateOnChange,
            isSubmitted: isSubmitted,
            isTouched: !!$6491cba65db8c121$export$3988ae62b71be9a3(touched, name)
        }, mode));
    const commonTask = ([event])=>{
        const data = $6491cba65db8c121$var$getInputValue(event);
        setInputStateValue(data);
        valueRef.current = data;
        return data;
    };
    const registerField = (0, $a5EUy.useCallback)(()=>{
        if (fieldsRef.current[name]) fieldsRef.current[name] = Object.assign({
            ref: fieldsRef.current[name].ref
        }, rules);
        else {
            register(Object.defineProperty({
                name: name,
                focus: onFocusRef.current
            }, $6491cba65db8c121$var$VALUE, {
                set (data) {
                    setInputStateValue(data);
                    valueRef.current = data;
                },
                get () {
                    return valueRef.current;
                }
            }), rules);
            if (isNotFieldArray && !$6491cba65db8c121$export$3988ae62b71be9a3(defaultValuesRef.current, name)) setInputStateValue(getInitialValue());
        }
    }, [
        rules,
        name,
        register
    ]);
    (0, $a5EUy.useEffect)(()=>()=>unregister(name), [
        unregister,
        name
    ]);
    (0, $a5EUy.useEffect)(()=>{
        registerField();
    }, [
        registerField
    ]);
    (0, $a5EUy.useEffect)(()=>{
        if (!fieldsRef.current[name]) {
            registerField();
            if (isNotFieldArray) setInputStateValue(getInitialValue());
        }
    });
    const onBlur = ()=>{
        if (readFormStateRef.current.touched && !$6491cba65db8c121$export$3988ae62b71be9a3(touched, name)) {
            $6491cba65db8c121$var$set(touched, name, true);
            updateFormState({
                touched: touched
            });
        }
        if (shouldValidate(true)) trigger(name);
    };
    const onChange = (...event)=>setValue(name, commonTask(event), {
            shouldValidate: shouldValidate(),
            shouldDirty: true
        });
    const commonProps = {
        onChange: onChange,
        onBlur: onBlur,
        name: name,
        value: value,
        ref: ref
    };
    const props = Object.assign(Object.assign({}, rest), commonProps);
    return as ? (0, $a5EUy.isValidElement)(as) ? (0, $a5EUy.cloneElement)(as, props) : (0, $a5EUy.createElement)(as, props) : render ? render(commonProps) : null;
};

});


parcelRegister("htBPl", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");

var $dMYAI = parcelRequire("dMYAI");
var $cb927cc4c5c77968$export$9949bd9c713ba425 = function() {
    var ctx = $a5EUy.useContext((0, $dMYAI.NotificationContext));
    if (!ctx) throw new Error('"useNotification" can only be called inside of NotificationContextProvider!');
    return ctx;
};

});

parcelRegister("1225g", function(module, exports) {

$parcel$export(module.exports, "PortalRoots", function () { return $0c0798266b7f1c84$export$673c0f2dc34a292b; });
$parcel$export(module.exports, "usePortalRoot", function () { return $0c0798266b7f1c84$export$6ecd3efa4eebe261; });

var $jLRsx = parcelRequire("jLRsx");
var $0c0798266b7f1c84$export$673c0f2dc34a292b;
(function(PortalRoots) {
    PortalRoots["TOAST"] = "toast";
    PortalRoots["POPOVER"] = "popover";
    PortalRoots["TOOLTIP"] = "tooltip";
    PortalRoots["DROPDOWN"] = "dropdown";
    PortalRoots["MODAL"] = "modal";
})($0c0798266b7f1c84$export$673c0f2dc34a292b || ($0c0798266b7f1c84$export$673c0f2dc34a292b = {}));
var $0c0798266b7f1c84$var$portalRenderRoots = {};
var $0c0798266b7f1c84$export$6ecd3efa4eebe261 = function(root) {
    if (!(0, $jLRsx.canUseDom)) throw new Error('dom not available');
    if (!$0c0798266b7f1c84$var$portalRenderRoots[root]) {
        var elm = document.createElement('div');
        elm.id = root;
        $0c0798266b7f1c84$var$portalRenderRoots[root] = elm;
        document.body.appendChild(elm);
    }
    return {
        portalRoot: $0c0798266b7f1c84$var$portalRenderRoots[root]
    };
};

});

parcelRegister("36air", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $2419eb464d2e2b15$export$45712eceda6fad21 = function(_a) {
    var onPress = _a.onPress, ref = _a.ref;
    $a5EUy.useEffect(function() {
        if (ref.current) // eslint-disable-next-line no-console
        console.log(onPress);
    });
    return {
        isPressed: true,
        pressProps: {}
    };
};

});

parcelRegister("iQCcD", function(module, exports) {

$parcel$export(module.exports, "useShareForwardRef", function () { return $db8ab79f65cf5433$export$38d56e9c4e5a652b; });

var $a5EUy = parcelRequire("a5EUy");
var $db8ab79f65cf5433$export$38d56e9c4e5a652b = function(forwardedRef) {
    // eslint-disable-next-line no-null/no-null
    var innerRef = $a5EUy.useRef(null);
    // Update the shared ref if the forwardedRef changes
    $a5EUy.useEffect(function() {
        if (!forwardedRef) return;
        if (typeof forwardedRef === 'function') {
            forwardedRef(innerRef.current);
            return;
        } else forwardedRef.current = innerRef.current;
    }, [
        forwardedRef
    ]);
    return innerRef;
};

});

parcelRegister("9wGfr", function(module, exports) {
/**
 * useSpace
 * Turn a spaceValue into a string
 * so it can be used as a className
 *
 * @param space SpaceValue
 * @memberof hooks
 * @author Jeremy Thomas
 */ var $6ef7dfd01c4fda38$export$450c36e0b0e62ccd = function(space) {
    if (!space) return '';
    return "" + space;
};

});




parcelRegister("8DLm3", function(module, exports) {
$parcel$export(module.exports, "Button", function () { return (parcelRequire("gdpIa")).Button; });
$parcel$export(module.exports, "Checkbox", function () { return (parcelRequire("7QTa8")).Checkbox; });
$parcel$export(module.exports, "Header", function () { return (parcelRequire("2Ei9L")).Header; });
$parcel$export(module.exports, "Modal", function () { return (parcelRequire("9BPY2")).Modal; });
$parcel$export(module.exports, "Overlay", function () { return (parcelRequire("gDChL")).Overlay; });
$parcel$export(module.exports, "Radio", function () { return (parcelRequire("bzTkH")).Radio; });
$parcel$export(module.exports, "TextArea", function () { return (parcelRequire("aIP73")).TextArea; });
parcelRequire("bKCc9");
parcelRequire("1D9yS");
parcelRequire("3nbTL");
parcelRequire("nFZzD");
parcelRequire("7ATQm");
parcelRequire("iT7xN");
parcelRequire("bmsv4");
parcelRequire("hz9sd");
parcelRequire("l6RU7");
parcelRequire("dzHea");
parcelRequire("6yhm4");
parcelRequire("5ieYE");
parcelRequire("h2IC8");
parcelRequire("h7J6o");
parcelRequire("7aaMk");
parcelRequire("kbxqT");
parcelRequire("ZEaLC");
parcelRequire("gywsm");
parcelRequire("gOQwe");
parcelRequire("46kjG");
parcelRequire("7elP5");
parcelRequire("6QA4z");
parcelRequire("f1RE8");
parcelRequire("8AgmX");
parcelRequire("j2NvO");
parcelRequire("c6XIG");
parcelRequire("aDAfa");
parcelRequire("27eN8");
parcelRequire("dIWFu");
parcelRequire("d3oA4");
parcelRequire("5RRwQ");
parcelRequire("dkAhj");
parcelRequire("ffOgG");
parcelRequire("h6b75");
parcelRequire("xXU0r");
parcelRequire("aFdt3");
parcelRequire("5Ro4X");
parcelRequire("aQ8nw");
parcelRequire("3lTu3");

});
parcelRegister("bKCc9", function(module, exports) {
parcelRequire("2xJtN");

});
parcelRegister("2xJtN", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $7qi99 = parcelRequire("7qi99");

var $koEHe = parcelRequire("koEHe");
var $1da1f127d0709d50$var$__assign = undefined && undefined.__assign || function() {
    $1da1f127d0709d50$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1da1f127d0709d50$var$__assign.apply(this, arguments);
};
var $1da1f127d0709d50$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1da1f127d0709d50$export$a766cd26d0d69044 = function(_a) {
    var children = _a.children, props = $1da1f127d0709d50$var$__rest(_a, [
        "children"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var id = (0, $7qi99.useID)('accordion');
    return(// TODO: accordion: allow for custom aria-label at top-level
    $a5EUy.createElement("div", $1da1f127d0709d50$var$__assign({
        "aria-label": "accordion",
        className: cn('accordion')
    }, props, {
        id: id
    }), $a5EUy.Children.map(children, function(child, index) {
        return $a5EUy.cloneElement(child, $1da1f127d0709d50$var$__assign({
            index: index,
            id: id
        }, child.props));
    })));
};
$1da1f127d0709d50$export$a766cd26d0d69044.Item = (0, $koEHe.AccordionItem);

});
parcelRegister("7qi99", function(module, exports) {

$parcel$export(module.exports, "useID", function () { return $567909a14c610298$export$3ec6e0c16b571c32; });
$parcel$export(module.exports, "makeTabId", function () { return $567909a14c610298$export$9178c5a458a4a458; });
$parcel$export(module.exports, "makeTabPanelId", function () { return $567909a14c610298$export$2c0ff9f06f6a462b; });

var $bq80E = parcelRequire("bq80E");
var $567909a14c610298$export$3ec6e0c16b571c32 = function(type) {
    var uid = (0, $bq80E.useUID)();
    return type + "-" + uid;
};
var $567909a14c610298$export$9178c5a458a4a458 = function(id, index) {
    return id + "-tab-" + index;
};
var $567909a14c610298$export$2c0ff9f06f6a462b = function(id, index) {
    return id + "-tabpanel-" + index;
};

});
parcelRegister("bq80E", function(module, exports) {

$parcel$export(module.exports, "useUID", function () { return $850855f240211ea8$export$87d05f07e65211f1; });

var $a5EUy = parcelRequire("a5EUy");

var $6kaPl = parcelRequire("6kaPl");
var $850855f240211ea8$var$generateUID = function(context) {
    var quartz = context || (0, $6kaPl.counter);
    var prefix = (0, $6kaPl.getPrefix)(quartz);
    var id = (0, $6kaPl.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $850855f240211ea8$var$useUIDState = function() {
    // @ts-ignore
    return $a5EUy.useState($850855f240211ea8$var$generateUID($a5EUy.useContext((0, $6kaPl.source))));
};
var $850855f240211ea8$export$87d05f07e65211f1 = function() {
    var uid = $850855f240211ea8$var$useUIDState()[0].uid;
    return uid;
};
var $850855f240211ea8$export$bb5ca5fba6fb4f1f = function() {
    var gen = $850855f240211ea8$var$useUIDState()[0].gen;
    return gen;
};

});
parcelRegister("6kaPl", function(module, exports) {

$parcel$export(module.exports, "counter", function () { return $49ad025eb6939a78$export$e575061ef2a070eb; });
$parcel$export(module.exports, "source", function () { return $49ad025eb6939a78$export$b4d5da5f34fb77ad; });
$parcel$export(module.exports, "getId", function () { return $49ad025eb6939a78$export$218c8c3169c024d2; });
$parcel$export(module.exports, "getPrefix", function () { return $49ad025eb6939a78$export$36e24695f02d4503; });

var $a5EUy = parcelRequire("a5EUy");

var $eYBHJ = parcelRequire("eYBHJ");
var $49ad025eb6939a78$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = '';
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $eYBHJ.generateUID)()
    };
};
var $49ad025eb6939a78$export$e575061ef2a070eb = $49ad025eb6939a78$export$1921362e86c73c88();
var $49ad025eb6939a78$export$b4d5da5f34fb77ad = $a5EUy.createContext($49ad025eb6939a78$export$1921362e86c73c88());
var $49ad025eb6939a78$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $49ad025eb6939a78$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : '';
};

});
parcelRegister("eYBHJ", function(module, exports) {

$parcel$export(module.exports, "generateUID", function () { return $ae73ea8f51281ddd$export$bdbb4cbb3078e58d; });
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $ae73ea8f51281ddd$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === 'number' || typeof item === 'string') return index ? "idx-" + index : "val-" + item;
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
var $ae73ea8f51281ddd$export$e2a22331486dcca0 = $ae73ea8f51281ddd$export$bdbb4cbb3078e58d();

});




parcelRegister("koEHe", function(module, exports) {

$parcel$export(module.exports, "AccordionItem", function () { return $ed959dfc7a5b087e$export$d99097c13d4dac9f; });
parcelRequire("2cnsK");
var $jtj7G = parcelRequire("jtj7G");

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $9IydS = parcelRequire("9IydS");
var $ed959dfc7a5b087e$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $ed959dfc7a5b087e$export$d99097c13d4dac9f = function(_a) {
    var children = _a.children, isDisabled = _a.isDisabled, _b = _a.isExpanded, isExpanded = _b === void 0 ? false : _b, label = _a.label, _c = _a.id, id = _c === void 0 ? 'accordion' : _c, _d = _a.index, index = _d === void 0 ? 0 : _d, onClick = _a.onClick;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var _e = $ed959dfc7a5b087e$var$__read($a5EUy.useState(isExpanded), 2), isOpen = _e[0], setOpen = _e[1];
    var handleClick = function(event) {
        onClick === null || onClick === void 0 || onClick(event);
        setOpen(!isOpen);
    };
    var headerId = (0, $9IydS.makeAccordionHeaderId)(id, index);
    var panelId = (0, $9IydS.makeAccordionPanelId)(id, index);
    return $a5EUy.createElement($a5EUy.Fragment, null, $a5EUy.createElement("button", {
        "aria-controls": panelId,
        "aria-disabled": isDisabled,
        "aria-expanded": isOpen,
        className: cn('accordion-trigger'),
        disabled: isDisabled,
        id: headerId,
        // eslint-disable-next-line react/jsx-no-bind
        onClick: handleClick
    }, $a5EUy.createElement("div", {
        className: cn('accordion-trigger-text')
    }, label), $a5EUy.createElement("span", {
        className: cn('icon')
    }, $a5EUy.createElement((0, $jtj7G.ArrowDownBold), null))), $a5EUy.createElement("div", {
        "aria-hidden": !isOpen,
        "aria-labelledby": headerId,
        className: cn('accordion-panel'),
        hidden: !isOpen,
        id: panelId
    }, children));
};
$ed959dfc7a5b087e$export$d99097c13d4dac9f.displayName = 'Accordion.Item';

});
parcelRegister("2cnsK", function(module, exports) {

$parcel$export(module.exports, "ArrowDown", function () { return (parcelRequire("bDBL7")).ArrowDown; });
$parcel$export(module.exports, "ArrowDownBold", function () { return (parcelRequire("jtj7G")).ArrowDownBold; });
$parcel$export(module.exports, "ArrowLeft", function () { return (parcelRequire("9ADun")).ArrowLeft; });
$parcel$export(module.exports, "ArrowLeftBold", function () { return (parcelRequire("bR1AW")).ArrowLeftBold; });
$parcel$export(module.exports, "ArrowRightBold", function () { return (parcelRequire("i7Ag6")).ArrowRightBold; });
$parcel$export(module.exports, "CheckTickBold", function () { return (parcelRequire("6pIUA")).CheckTickBold; });
$parcel$export(module.exports, "Cross", function () { return (parcelRequire("2U0D7")).Cross; });
$parcel$export(module.exports, "CrossBold", function () { return (parcelRequire("7gNMR")).CrossBold; });
$parcel$export(module.exports, "MenuNavigationVertical", function () { return (parcelRequire("bVq76")).MenuNavigationVertical; });
$parcel$export(module.exports, "MinusBold", function () { return (parcelRequire("93esl")).MinusBold; });

var $dg8Zs = parcelRequire("dg8Zs");

var $a9ybH = parcelRequire("a9ybH");

var $78kt4 = parcelRequire("78kt4");

var $73v0D = parcelRequire("73v0D");

var $bDBL7 = parcelRequire("bDBL7");

var $jtj7G = parcelRequire("jtj7G");

var $9ADun = parcelRequire("9ADun");

var $bR1AW = parcelRequire("bR1AW");

var $aLwKE = parcelRequire("aLwKE");

var $loqxv = parcelRequire("loqxv");

var $iHSW6 = parcelRequire("iHSW6");

var $dPRx1 = parcelRequire("dPRx1");

var $1jcux = parcelRequire("1jcux");

var $i7Ag6 = parcelRequire("i7Ag6");

var $6r1Ks = parcelRequire("6r1Ks");

var $6ym0P = parcelRequire("6ym0P");

var $aDI5r = parcelRequire("aDI5r");

var $1skgm = parcelRequire("1skgm");

var $cNDNy = parcelRequire("cNDNy");

var $cTzG8 = parcelRequire("cTzG8");

var $eypcp = parcelRequire("eypcp");

var $3qx5w = parcelRequire("3qx5w");

var $6x5rB = parcelRequire("6x5rB");

var $lmE8S = parcelRequire("lmE8S");

var $8iski = parcelRequire("8iski");

var $6pIUA = parcelRequire("6pIUA");

var $4IAnM = parcelRequire("4IAnM");

var $85n4d = parcelRequire("85n4d");

var $2U0D7 = parcelRequire("2U0D7");

var $7gNMR = parcelRequire("7gNMR");

var $c3MPS = parcelRequire("c3MPS");

var $cpnsw = parcelRequire("cpnsw");

var $8FGme = parcelRequire("8FGme");

var $3nmZg = parcelRequire("3nmZg");

var $7wwUx = parcelRequire("7wwUx");

var $iA5z4 = parcelRequire("iA5z4");

var $8QJ7p = parcelRequire("8QJ7p");

var $cqOSy = parcelRequire("cqOSy");

var $03lon = parcelRequire("03lon");

var $dlEzn = parcelRequire("dlEzn");

var $itoUL = parcelRequire("itoUL");

var $d3nLD = parcelRequire("d3nLD");

var $eJiH4 = parcelRequire("eJiH4");

var $77vTc = parcelRequire("77vTc");

var $jpaPf = parcelRequire("jpaPf");

var $fR2Qd = parcelRequire("fR2Qd");

var $ayNZC = parcelRequire("ayNZC");

var $gn6Og = parcelRequire("gn6Og");

var $fRPry = parcelRequire("fRPry");

var $7X8V7 = parcelRequire("7X8V7");

var $4mHoH = parcelRequire("4mHoH");

var $a8PJe = parcelRequire("a8PJe");

var $DaSJy = parcelRequire("DaSJy");

var $59vrA = parcelRequire("59vrA");

var $jpt3X = parcelRequire("jpt3X");

var $d22cu = parcelRequire("d22cu");

var $llLRf = parcelRequire("llLRf");

var $4DnzQ = parcelRequire("4DnzQ");

var $2FfDG = parcelRequire("2FfDG");

var $3QRDR = parcelRequire("3QRDR");

var $3nsc7 = parcelRequire("3nsc7");

var $91nyl = parcelRequire("91nyl");

var $3fgLQ = parcelRequire("3fgLQ");

var $fyNrD = parcelRequire("fyNrD");

var $7uHym = parcelRequire("7uHym");

var $hwpFj = parcelRequire("hwpFj");

var $lwuWU = parcelRequire("lwuWU");

var $7yZGb = parcelRequire("7yZGb");

var $jrwtc = parcelRequire("jrwtc");

var $lE3Ts = parcelRequire("lE3Ts");

var $bVq76 = parcelRequire("bVq76");

var $9D6lP = parcelRequire("9D6lP");

var $5lMDP = parcelRequire("5lMDP");

var $93esl = parcelRequire("93esl");

var $kJAGM = parcelRequire("kJAGM");

var $4KTno = parcelRequire("4KTno");

var $7GojM = parcelRequire("7GojM");

var $CkZC2 = parcelRequire("CkZC2");

var $5pS09 = parcelRequire("5pS09");

var $j7IF3 = parcelRequire("j7IF3");

var $8sr86 = parcelRequire("8sr86");

var $k6mE4 = parcelRequire("k6mE4");

var $8wETY = parcelRequire("8wETY");

var $15VHu = parcelRequire("15VHu");

var $krfIP = parcelRequire("krfIP");

var $28R9A = parcelRequire("28R9A");

var $17RmW = parcelRequire("17RmW");

var $awQrI = parcelRequire("awQrI");

var $aYdLh = parcelRequire("aYdLh");

var $eXfhl = parcelRequire("eXfhl");

var $7aUwF = parcelRequire("7aUwF");

var $3btuf = parcelRequire("3btuf");

var $5ZQ9I = parcelRequire("5ZQ9I");

var $3xjhl = parcelRequire("3xjhl");

var $it9Xk = parcelRequire("it9Xk");

var $h4beO = parcelRequire("h4beO");

var $jkAmp = parcelRequire("jkAmp");

var $4YedF = parcelRequire("4YedF");

var $cc6CS = parcelRequire("cc6CS");

var $hnDQe = parcelRequire("hnDQe");

var $gH1Me = parcelRequire("gH1Me");

var $10H68 = parcelRequire("10H68");

var $9HAvd = parcelRequire("9HAvd");

var $eQFwL = parcelRequire("eQFwL");

var $4UoNU = parcelRequire("4UoNU");

var $gzyMK = parcelRequire("gzyMK");

var $cRG1G = parcelRequire("cRG1G");

var $kT4Ic = parcelRequire("kT4Ic");

var $4HD4x = parcelRequire("4HD4x");

var $cjvGq = parcelRequire("cjvGq");

var $Y32oB = parcelRequire("Y32oB");

var $7PpVm = parcelRequire("7PpVm");

var $kuec5 = parcelRequire("kuec5");

var $f9sUo = parcelRequire("f9sUo");

var $eIP1V = parcelRequire("eIP1V");

var $88Soy = parcelRequire("88Soy");

var $7MRJh = parcelRequire("7MRJh");

var $8uuhf = parcelRequire("8uuhf");

var $iOUtg = parcelRequire("iOUtg");

var $2Oy1L = parcelRequire("2Oy1L");

var $3BoV0 = parcelRequire("3BoV0");

var $55SbO = parcelRequire("55SbO");

var $7VXdF = parcelRequire("7VXdF");

var $9X6UE = parcelRequire("9X6UE");

var $18WtU = parcelRequire("18WtU");

var $liH2S = parcelRequire("liH2S");

});
parcelRegister("dg8Zs", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $9a73be410ec8a719$var$__assign = undefined && undefined.__assign || function() {
    $9a73be410ec8a719$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9a73be410ec8a719$var$__assign.apply(this, arguments);
};
var $9a73be410ec8a719$export$caec2af78bcc877f = $6nuVc.forwardRef(function Alert(props, svgRef) {
    return $6nuVc.createElement("svg", $9a73be410ec8a719$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M13.934 21.021a.73.73 0 00-.924.514 1.34 1.34 0 01-.908.907 1.297 1.297 0 01-1.01-.102 1.265 1.265 0 01-.633-.788.764.764 0 00-.924-.514.764.764 0 00-.514.925c.205.719.702 1.318 1.352 1.695.428.222.89.342 1.353.342.274 0 .53-.034.804-.12a2.836 2.836 0 001.918-1.917.76.76 0 00-.514-.942zm7.258-2.858c-.137-.172-1.232-1.73-1.232-7.67 0-4.296-3.304-7.823-7.498-8.2V.754A.76.76 0 0011.709 0a.76.76 0 00-.754.753v1.54c-4.176.395-7.463 3.921-7.463 8.2 0 5.872-1.335 7.772-1.335 7.772a.769.769 0 00-.086.788c.12.257.394.428.668.428h17.974c.342 0 .668-.189.753-.514.086-.308 0-.616-.274-.804zM3.937 17.99c.48-1.232 1.044-3.543 1.044-7.497 0-3.715 3.03-6.745 6.745-6.745 3.714 0 6.744 3.03 6.744 6.745 0 4.04.497 6.282.959 7.497H3.937z"
    }));
});

});
parcelRegister("6nuVc", function(module, exports) {
'use strict';

module.exports = (parcelRequire("vGg9x"));

});


parcelRegister("a9ybH", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $7645439cf612a9e2$var$__assign = undefined && undefined.__assign || function() {
    $7645439cf612a9e2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7645439cf612a9e2$var$__assign.apply(this, arguments);
};
var $7645439cf612a9e2$export$b064d7839e1e373e = $6nuVc.forwardRef(function AlertBold(props, svgRef) {
    return $6nuVc.createElement("svg", $7645439cf612a9e2$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M20.229 10.491c0-4.032-2.907-7.387-6.73-8.103V1.5a1.5 1.5 0 10-3 0v.879c-3.838.703-6.762 4.073-6.762 8.112 0 5.88-1.337 7.783-1.337 7.783a.77.77 0 00-.086.789c.12.257.394.428.669.428h18c.343 0 .668-.188.754-.514.086-.308 0-.617-.274-.806-.137-.171-1.235-1.731-1.235-7.68zM9.25 21.78c0-.326.21-.629.539-.729l4.405-.017c.395.12.635.532.515.943 0 0-.209 2.023-2.709 2.023s-2.726-2.023-2.726-2.023a.77.77 0 01-.025-.196z"
    }));
});

});

parcelRegister("78kt4", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $5319283aa75d391d$var$__assign = undefined && undefined.__assign || function() {
    $5319283aa75d391d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5319283aa75d391d$var$__assign.apply(this, arguments);
};
var $5319283aa75d391d$export$c994623dcd067c12 = $6nuVc.forwardRef(function Announcement(props, svgRef) {
    return $6nuVc.createElement("svg", $5319283aa75d391d$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M21 3.75a.75.75 0 00-1.166-.624l-1.134.756A21.55 21.55 0 016.751 7.5H4.5a4.5 4.5 0 000 9h1.535a7.988 7.988 0 002.448 5.043.75.75 0 101.034-1.086 6.49 6.49 0 01-1.972-3.942A21.55 21.55 0 0118.7 20.118l1.134.756A.75.75 0 0021 20.25V3.75zM7.5 15.012a23.05 23.05 0 0112 3.837V5.15a23.05 23.05 0 01-12 3.837v6.024zM6 9H4.5a3 3 0 100 6H6V9z",
        fillRule: "evenodd"
    }), $6nuVc.createElement("path", {
        d: "M23.25 9.75a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0v-3a.75.75 0 01.75-.75z"
    }));
});

});

parcelRegister("73v0D", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $5230ddfe7c04bec4$var$__assign = undefined && undefined.__assign || function() {
    $5230ddfe7c04bec4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5230ddfe7c04bec4$var$__assign.apply(this, arguments);
};
var $5230ddfe7c04bec4$export$4c30be745f22bee4 = $6nuVc.forwardRef(function AnnouncementBold(props, svgRef) {
    return $6nuVc.createElement("svg", $5230ddfe7c04bec4$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M20.604 2.589A.75.75 0 0121 3.25v16.5a.75.75 0 01-1.166.624l-1.134-.756a21.55 21.55 0 00-11.155-3.603 6.49 6.49 0 001.972 3.942.75.75 0 11-1.034 1.086A7.988 7.988 0 016.035 16V7h.716c4.253 0 8.41-1.26 11.95-3.618l1.133-.756a.75.75 0 01.77-.037zM1.318 8.318A4.5 4.5 0 014.5 7v9a4.5 4.5 0 01-3.182-7.682zm21.432.557c-.621 0-1.125.504-1.125 1.125v3a1.125 1.125 0 002.25 0v-3c0-.621-.504-1.125-1.125-1.125z"
    }));
});

});

parcelRegister("bDBL7", function(module, exports) {

$parcel$export(module.exports, "ArrowDown", function () { return $8790a0654b02676f$export$1fa5a43af950a186; });

var $6nuVc = parcelRequire("6nuVc");
var $8790a0654b02676f$var$__assign = undefined && undefined.__assign || function() {
    $8790a0654b02676f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8790a0654b02676f$var$__assign.apply(this, arguments);
};
var $8790a0654b02676f$export$1fa5a43af950a186 = $6nuVc.forwardRef(function ArrowDown(props, svgRef) {
    return $6nuVc.createElement("svg", $8790a0654b02676f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M.445 6.495a.75.75 0 011.06-.05L12 15.986l10.495-9.541a.75.75 0 011.01 1.11l-11 10a.75.75 0 01-1.01 0l-11-10a.75.75 0 01-.05-1.06z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("jtj7G", function(module, exports) {

$parcel$export(module.exports, "ArrowDownBold", function () { return $e2cf8f2573194caf$export$2fbb36af09846aa0; });

var $6nuVc = parcelRequire("6nuVc");
var $e2cf8f2573194caf$var$__assign = undefined && undefined.__assign || function() {
    $e2cf8f2573194caf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e2cf8f2573194caf$var$__assign.apply(this, arguments);
};
var $e2cf8f2573194caf$export$2fbb36af09846aa0 = $6nuVc.forwardRef(function ArrowDownBold(props, svgRef) {
    return $6nuVc.createElement("svg", $e2cf8f2573194caf$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M2.506 6.388A1.5 1.5 0 00.494 8.612l10.5 9.5a1.5 1.5 0 002.012 0l10.5-9.5a1.5 1.5 0 00-2.012-2.224L12 14.978l-9.494-8.59z"
    }));
});

});

parcelRegister("9ADun", function(module, exports) {

$parcel$export(module.exports, "ArrowLeft", function () { return $6fb61b81eba5c2cc$export$e4c291d45fea4cd0; });

var $6nuVc = parcelRequire("6nuVc");
var $6fb61b81eba5c2cc$var$__assign = undefined && undefined.__assign || function() {
    $6fb61b81eba5c2cc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6fb61b81eba5c2cc$var$__assign.apply(this, arguments);
};
var $6fb61b81eba5c2cc$export$e4c291d45fea4cd0 = $6nuVc.forwardRef(function ArrowLeft(props, svgRef) {
    return $6nuVc.createElement("svg", $6fb61b81eba5c2cc$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M17.505.445a.75.75 0 01.05 1.06L8.014 12l9.541 10.495a.75.75 0 01-1.11 1.01l-10-11a.75.75 0 010-1.01l10-11a.75.75 0 011.06-.05z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("bR1AW", function(module, exports) {

$parcel$export(module.exports, "ArrowLeftBold", function () { return $8a15e1a5be9f56f6$export$ea9a5c7ec18f8eaf; });

var $6nuVc = parcelRequire("6nuVc");
var $8a15e1a5be9f56f6$var$__assign = undefined && undefined.__assign || function() {
    $8a15e1a5be9f56f6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8a15e1a5be9f56f6$var$__assign.apply(this, arguments);
};
var $8a15e1a5be9f56f6$export$ea9a5c7ec18f8eaf = $6nuVc.forwardRef(function ArrowLeftBold(props, svgRef) {
    return $6nuVc.createElement("svg", $8a15e1a5be9f56f6$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M17.506.388a1.5 1.5 0 01.106 2.118L9.022 12l8.59 9.494a1.5 1.5 0 01-2.224 2.012l-9.5-10.5a1.5 1.5 0 010-2.012l9.5-10.5a1.5 1.5 0 012.118-.106z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("aLwKE", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $7d67b2e7a35486d4$var$__assign = undefined && undefined.__assign || function() {
    $7d67b2e7a35486d4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7d67b2e7a35486d4$var$__assign.apply(this, arguments);
};
var $7d67b2e7a35486d4$export$fb2824d245253d9b = $6nuVc.forwardRef(function ArrowLongDown(props, svgRef) {
    return $6nuVc.createElement("svg", $7d67b2e7a35486d4$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M12 .75a.75.75 0 01.75.75v19.305l6.747-6.132a.75.75 0 011.009 1.11l-8.002 7.272a.75.75 0 01-1.008 0l-8-7.27a.75.75 0 111.008-1.11l6.746 6.13V1.5A.75.75 0 0112 .75z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("loqxv", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $f9306d0cc23c4933$var$__assign = undefined && undefined.__assign || function() {
    $f9306d0cc23c4933$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f9306d0cc23c4933$var$__assign.apply(this, arguments);
};
var $f9306d0cc23c4933$export$a2ec4c6969a7d302 = $6nuVc.forwardRef(function ArrowLongDownBold(props, svgRef) {
    return $6nuVc.createElement("svg", $f9306d0cc23c4933$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M12 0a1.5 1.5 0 011.5 1.5v17.61l5.493-4.992a1.5 1.5 0 012.017 2.22l-8 7.272a1.5 1.5 0 01-2.018 0l-8-7.27a1.5 1.5 0 012.018-2.22l5.491 4.99V1.5A1.5 1.5 0 0112 0z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("iHSW6", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $d9e6db575a3ae8fa$var$__assign = undefined && undefined.__assign || function() {
    $d9e6db575a3ae8fa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d9e6db575a3ae8fa$var$__assign.apply(this, arguments);
};
var $d9e6db575a3ae8fa$export$5e0a9a0faf09e20c = $6nuVc.forwardRef(function ArrowLongUp(props, svgRef) {
    return $6nuVc.createElement("svg", $d9e6db575a3ae8fa$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M11.496.945a.75.75 0 011.008 0l8.002 7.272a.75.75 0 11-1.009 1.11L12.75 3.195V22.5a.75.75 0 01-1.5 0V3.195l-6.746 6.13a.75.75 0 01-1.008-1.11l8-7.27z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("dPRx1", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $a129900a0cc0ff9a$var$__assign = undefined && undefined.__assign || function() {
    $a129900a0cc0ff9a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a129900a0cc0ff9a$var$__assign.apply(this, arguments);
};
var $a129900a0cc0ff9a$export$469287007f7d4034 = $6nuVc.forwardRef(function ArrowLongUpBold(props, svgRef) {
    return $6nuVc.createElement("svg", $a129900a0cc0ff9a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M10.991.39a1.5 1.5 0 012.018 0l8.001 7.272a1.5 1.5 0 01-2.017 2.22L13.5 4.89V22.5a1.5 1.5 0 01-3 0V4.89L5.009 9.88A1.5 1.5 0 012.99 7.66l8-7.27z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("1jcux", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $0f41415e5f0488f3$var$__assign = undefined && undefined.__assign || function() {
    $0f41415e5f0488f3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0f41415e5f0488f3$var$__assign.apply(this, arguments);
};
var $0f41415e5f0488f3$export$acad20503ad73ac1 = $6nuVc.forwardRef(function ArrowRight(props, svgRef) {
    return $6nuVc.createElement("svg", $0f41415e5f0488f3$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M6.495.445a.75.75 0 011.06.05l10 11a.75.75 0 010 1.01l-10 11a.75.75 0 11-1.11-1.01L15.986 12 6.445 1.505a.75.75 0 01.05-1.06z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("i7Ag6", function(module, exports) {

$parcel$export(module.exports, "ArrowRightBold", function () { return $d31501b06ab4226c$export$d6d021d74f4bac76; });

var $6nuVc = parcelRequire("6nuVc");
var $d31501b06ab4226c$var$__assign = undefined && undefined.__assign || function() {
    $d31501b06ab4226c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d31501b06ab4226c$var$__assign.apply(this, arguments);
};
var $d31501b06ab4226c$export$d6d021d74f4bac76 = $6nuVc.forwardRef(function ArrowRightBold(props, svgRef) {
    return $6nuVc.createElement("svg", $d31501b06ab4226c$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M8.612.494a1.5 1.5 0 00-2.224 2.012L14.978 12l-8.59 9.494a1.5 1.5 0 002.224 2.012l9.5-10.5a1.5 1.5 0 000-2.012l-9.5-10.5z"
    }));
});

});

parcelRegister("6r1Ks", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $4af69ee514f7421a$var$__assign = undefined && undefined.__assign || function() {
    $4af69ee514f7421a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4af69ee514f7421a$var$__assign.apply(this, arguments);
};
var $4af69ee514f7421a$export$2624c5890f1bbcf7 = $6nuVc.forwardRef(function ArrowUp(props, svgRef) {
    return $6nuVc.createElement("svg", $4af69ee514f7421a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M11.495 6.445a.75.75 0 011.01 0l11 10a.75.75 0 01-1.01 1.11L12 8.014 1.505 17.555a.75.75 0 01-1.01-1.11l11-10z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("6ym0P", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $4c56fe3cc96665f4$var$__assign = undefined && undefined.__assign || function() {
    $4c56fe3cc96665f4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4c56fe3cc96665f4$var$__assign.apply(this, arguments);
};
var $4c56fe3cc96665f4$export$b524ae00c198b715 = $6nuVc.forwardRef(function ArrowUpAndDown(props, svgRef) {
    return $6nuVc.createElement("svg", $4c56fe3cc96665f4$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M12.526 1.466a.75.75 0 00-1.052 0l-6.6 6.5a.75.75 0 101.052 1.068L12 3.053l6.074 5.981a.75.75 0 101.052-1.068l-6.6-6.5zm-6.6 13.5a.75.75 0 00-1.052 1.068l6.6 6.5a.75.75 0 001.052 0l6.6-6.5a.75.75 0 00-1.052-1.068L12 20.947l-6.074-5.981z"
    }));
});

});

parcelRegister("aDI5r", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $7befbe99843b797a$var$__assign = undefined && undefined.__assign || function() {
    $7befbe99843b797a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7befbe99843b797a$var$__assign.apply(this, arguments);
};
var $7befbe99843b797a$export$61bdb2a1da0ccc8a = $6nuVc.forwardRef(function ArrowUpAndDownBold(props, svgRef) {
    return $6nuVc.createElement("svg", $7befbe99843b797a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M13.053.931a1.5 1.5 0 00-2.106 0l-6.6 6.5A1.5 1.5 0 006.453 9.57L12 4.105l5.547 5.464a1.5 1.5 0 102.106-2.138l-6.6-6.5zm-6.6 13.5a1.5 1.5 0 10-2.106 2.138l6.6 6.5a1.5 1.5 0 002.106 0l6.6-6.5a1.5 1.5 0 00-2.105-2.138L12 19.895 6.453 14.43z"
    }));
});

});

parcelRegister("1skgm", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $10f81fbd8423c824$var$__assign = undefined && undefined.__assign || function() {
    $10f81fbd8423c824$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $10f81fbd8423c824$var$__assign.apply(this, arguments);
};
var $10f81fbd8423c824$export$928b9ecbfcbe86f4 = $6nuVc.forwardRef(function ArrowUpBold(props, svgRef) {
    return $6nuVc.createElement("svg", $10f81fbd8423c824$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M10.994 5.888a1.5 1.5 0 012.012 0l10.5 9.5a1.5 1.5 0 01-2.012 2.224L12 9.022l-9.494 8.59a1.5 1.5 0 11-2.012-2.224l10.5-9.5z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("cNDNy", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $9518eec140e7e8ad$var$__assign = undefined && undefined.__assign || function() {
    $9518eec140e7e8ad$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9518eec140e7e8ad$var$__assign.apply(this, arguments);
};
var $9518eec140e7e8ad$export$650e18e4b9cea8d1 = $6nuVc.forwardRef(function Attach(props, svgRef) {
    return $6nuVc.createElement("svg", $9518eec140e7e8ad$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M15.323 2.525c-.985.11-1.817.55-2.177.91l-8 8c-1.78 1.78-2.567 5.373 0 7.94 2.566 2.566 6.158 1.78 7.939 0l8-8a.75.75 0 011.06 1.06l-8 8c-2.22 2.22-6.771 3.289-10.06 0-3.29-3.29-2.22-7.841 0-10.06l8-8c.64-.64 1.807-1.2 3.072-1.34 1.296-.145 2.791.142 3.989 1.34 1.197 1.196 1.484 2.692 1.34 3.987-.141 1.265-.7 2.433-1.34 3.073l-8 8a3.07 3.07 0 01-1.722.824c-.755.098-1.61-.096-2.34-.824-.734-.735-.913-1.603-.811-2.356.097-.715.448-1.34.812-1.705l8-8a.75.75 0 111.06 1.06l-8 8c-.135.137-.333.462-.386.847-.047.348.023.73.387 1.093.369.37.748.441 1.085.397.374-.048.7-.242.854-.397l8-8c.36-.36.8-1.193.91-2.177.106-.955-.107-1.96-.91-2.762-.803-.803-1.807-1.016-2.762-.91z"
    }));
});

});

parcelRegister("cTzG8", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $96364c1ac5c4bfa7$var$__assign = undefined && undefined.__assign || function() {
    $96364c1ac5c4bfa7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $96364c1ac5c4bfa7$var$__assign.apply(this, arguments);
};
var $96364c1ac5c4bfa7$export$50809d59c9e8104e = $6nuVc.forwardRef(function AttachBold(props, svgRef) {
    return $6nuVc.createElement("svg", $96364c1ac5c4bfa7$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M15.157 3.02c-.845.094-1.51.474-1.73.695l-8 8c-1.56 1.56-2.205 4.673 0 6.879 2.206 2.205 5.318 1.56 6.879 0l8-8a1.5 1.5 0 012.121 2.12l-8 8c-2.44 2.44-7.471 3.651-11.121 0-3.65-3.65-2.44-8.681 0-11.12l8-8c.779-.78 2.114-1.4 3.52-1.556 1.466-.162 3.207.161 4.601 1.556 1.394 1.394 1.718 3.135 1.555 4.6-.156 1.406-.776 2.742-1.555 3.521l-8 8a3.818 3.818 0 01-2.155 1.038c-.965.125-2.059-.13-2.966-1.038-.92-.92-1.155-2.032-1.025-2.987.12-.88.546-1.656 1.025-2.134l8-8a1.5 1.5 0 112.121 2.12l-8 8v.002a.93.93 0 00-.173.416.504.504 0 00.012.219.59.59 0 00.161.243.63.63 0 00.253.169.468.468 0 00.206.014.861.861 0 00.42-.183l8-8c.22-.221.6-.886.694-1.73.088-.785-.089-1.543-.694-2.15-.606-.605-1.365-.781-2.149-.694z"
    }));
});

});

parcelRegister("eypcp", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $a987c9b10d08abff$var$__assign = undefined && undefined.__assign || function() {
    $a987c9b10d08abff$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a987c9b10d08abff$var$__assign.apply(this, arguments);
};
var $a987c9b10d08abff$export$acd2cbead02af9c1 = $6nuVc.forwardRef(function BookmarkFavourite(props, svgRef) {
    return $6nuVc.createElement("svg", $a987c9b10d08abff$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M18.75 0A2.25 2.25 0 0121 2.25v20.252a1.5 1.5 0 01-2.382 1.21L12.44 19.22a.75.75 0 00-.882 0l-6.177 4.492A1.5 1.5 0 013 22.5V2.25A2.25 2.25 0 015.25 0h13.5zm0 1.5H5.25a.75.75 0 00-.75.75v20.248l6.177-4.492a2.25 2.25 0 012.646 0l6.177 4.492V2.25a.75.75 0 00-.75-.75z"
    }));
});

});

parcelRegister("3qx5w", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $27ed776c41618fd8$var$__assign = undefined && undefined.__assign || function() {
    $27ed776c41618fd8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $27ed776c41618fd8$var$__assign.apply(this, arguments);
};
var $27ed776c41618fd8$export$cea5fccc97fad67f = $6nuVc.forwardRef(function BookmarkFavouriteBold(props, svgRef) {
    return $6nuVc.createElement("svg", $27ed776c41618fd8$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M18.75 0A2.25 2.25 0 0121 2.25v20.252a1.5 1.5 0 01-2.382 1.21L12.44 19.22a.75.75 0 00-.882 0l-6.177 4.492A1.5 1.5 0 013 22.5V2.25A2.25 2.25 0 015.25 0h13.5z"
    }));
});

});

parcelRegister("6x5rB", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $4c1a0c3f96867f0d$var$__assign = undefined && undefined.__assign || function() {
    $4c1a0c3f96867f0d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4c1a0c3f96867f0d$var$__assign.apply(this, arguments);
};
var $4c1a0c3f96867f0d$export$142047257e111cb6 = $6nuVc.forwardRef(function BookmarkFavouriteStar(props, svgRef) {
    return $6nuVc.createElement("svg", $4c1a0c3f96867f0d$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M18.75 0A2.25 2.25 0 0121 2.25v20.252a1.5 1.5 0 01-2.382 1.21L12.44 19.22a.75.75 0 00-.882 0l-6.177 4.492A1.5 1.5 0 013 22.5V2.25A2.25 2.25 0 015.25 0h13.5zm0 1.5H5.25a.75.75 0 00-.75.75v20.248l6.177-4.492a2.25 2.25 0 012.646 0l6.177 4.492V2.25a.75.75 0 00-.75-.75zM12 4.715c.507 0 .97.285 1.199.736l1.039 2.047 1.65.001c.502-.012.965.26 1.202.694l.059.123a1.33 1.33 0 01-.298 1.468l-1.586 1.56.88 2.022a1.34 1.34 0 01-.249 1.424l-.102.1c-.432.38-1.058.44-1.548.156L12 13.778l-2.237 1.26a1.339 1.339 0 01-1.445-.064l-.111-.088a1.342 1.342 0 01-.348-1.533l.876-2.013-1.58-1.556a1.332 1.332 0 01-.349-1.344l.046-.128c.212-.506.713-.83 1.243-.817l1.667-.001 1.04-2.042c.208-.41.61-.684 1.062-.73L12 4.715zm-.001 1.688l-1.11 2.182a.75.75 0 01-.668.41L8.49 8.994l1.664 1.638a.75.75 0 01.2.726l-.038.108-.889 2.038 2.205-1.24a.75.75 0 01.636-.047l.1.048 2.203 1.242-.887-2.037a.75.75 0 01.086-.747l.076-.087 1.664-1.638-1.731.001a.75.75 0 01-.615-.32l-.054-.09L12 6.403z"
    }));
});

});

parcelRegister("lmE8S", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $f8daca756fd9bb81$var$__assign = undefined && undefined.__assign || function() {
    $f8daca756fd9bb81$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f8daca756fd9bb81$var$__assign.apply(this, arguments);
};
var $f8daca756fd9bb81$export$848b7e76934f1777 = $6nuVc.forwardRef(function BookmarkFavouriteStarBold(props, svgRef) {
    return $6nuVc.createElement("svg", $f8daca756fd9bb81$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M21 2.25A2.25 2.25 0 0018.75 0H5.25A2.25 2.25 0 003 2.25V22.5a1.5 1.5 0 002.382 1.212l6.177-4.492a.75.75 0 01.882 0l6.177 4.492A1.5 1.5 0 0021 22.502V2.25zm-9.737 4.005c.232-.714 1.242-.714 1.474 0l.652 2.008c.004.01.013.017.024.017h2.111c.751 0 1.063.96.456 1.402l-1.708 1.24a.025.025 0 00-.01.029l.653 2.007c.232.714-.585 1.308-1.192.867l-1.708-1.241a.025.025 0 00-.03 0l-1.707 1.24c-.608.442-1.425-.152-1.193-.866l.652-2.007a.025.025 0 00-.009-.028L8.02 9.682c-.607-.441-.295-1.402.456-1.402h2.11a.026.026 0 00.025-.017l.652-2.008z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("8iski", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $60a5fa2e579c7615$var$__assign = undefined && undefined.__assign || function() {
    $60a5fa2e579c7615$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $60a5fa2e579c7615$var$__assign.apply(this, arguments);
};
var $60a5fa2e579c7615$export$77cdf53c363a3886 = $6nuVc.forwardRef(function CheckTick(props, svgRef) {
    return $6nuVc.createElement("svg", $60a5fa2e579c7615$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M22.03 4.97a.75.75 0 010 1.06l-13 13a.75.75 0 01-1.06 0l-6-6a.75.75 0 111.06-1.06l5.47 5.47L20.97 4.97a.75.75 0 011.06 0z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("6pIUA", function(module, exports) {

$parcel$export(module.exports, "CheckTickBold", function () { return $4ab7ea67019d6d29$export$add807e002afa321; });

var $6nuVc = parcelRequire("6nuVc");
var $4ab7ea67019d6d29$var$__assign = undefined && undefined.__assign || function() {
    $4ab7ea67019d6d29$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4ab7ea67019d6d29$var$__assign.apply(this, arguments);
};
var $4ab7ea67019d6d29$export$add807e002afa321 = $6nuVc.forwardRef(function CheckTickBold(props, svgRef) {
    return $6nuVc.createElement("svg", $4ab7ea67019d6d29$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M22.56 4.44a1.5 1.5 0 010 2.12l-13 13a1.5 1.5 0 01-2.12 0l-6-6a1.5 1.5 0 012.12-2.12l4.94 4.939 11.94-11.94a1.5 1.5 0 012.12 0z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("4IAnM", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $36f77e4f6adf1a3f$var$__assign = undefined && undefined.__assign || function() {
    $36f77e4f6adf1a3f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $36f77e4f6adf1a3f$var$__assign.apply(this, arguments);
};
var $36f77e4f6adf1a3f$export$c7c44baae9d9f25f = $6nuVc.forwardRef(function Controls(props, svgRef) {
    return $6nuVc.createElement("svg", $36f77e4f6adf1a3f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M23.246 0H.754A.761.761 0 000 .754v22.492c0 .411.343.754.754.754h22.492a.761.761 0 00.754-.754V.754A.761.761 0 0023.246 0zM1.509 22.491V1.51h21v20.98h-21z"
    }), $6nuVc.createElement("path", {
        d: "M5.246 16.491h2.348c.343 1.286 1.509 2.246 2.897 2.246a3 3 0 002.898-2.246h5.348a.76.76 0 00.754-.754.76.76 0 00-.754-.754h-5.331a2.919 2.919 0 00-.789-1.372 2.981 2.981 0 00-2.126-.874 3 3 0 00-2.897 2.246H5.246a.76.76 0 00-.755.754.76.76 0 00.755.754zm5.245-2.245c.395 0 .772.154 1.063.445.292.292.446.652.446 1.063a1.51 1.51 0 01-1.509 1.509 1.5 1.5 0 01-1.508-1.509c.017-.823.686-1.508 1.508-1.508zM5.246 9h8.348c.343 1.286 1.509 2.246 2.897 2.246 1.646 0 3-1.337 3-3 0-1.646-1.354-3-3-3a3 3 0 00-2.897 2.245H5.246a.761.761 0 00-.755.755c0 .411.343.754.755.754zM16.49 6.754c.823 0 1.509.669 1.509 1.492a1.51 1.51 0 01-1.509 1.508A1.496 1.496 0 0115 8.246c0-.823.669-1.492 1.491-1.492z"
    }));
});

});

parcelRegister("85n4d", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $5e30af01a6a440c6$var$__assign = undefined && undefined.__assign || function() {
    $5e30af01a6a440c6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5e30af01a6a440c6$var$__assign.apply(this, arguments);
};
var $5e30af01a6a440c6$export$281a0dedb095a201 = $6nuVc.forwardRef(function ControlsBold(props, svgRef) {
    return $6nuVc.createElement("svg", $5e30af01a6a440c6$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M.754 0h22.492c.411 0 .754.343.754.754v22.492a.761.761 0 01-.754.754H.754A.761.761 0 010 23.246V.754C0 .343.343 0 .754 0zm12.652 7.241a3.25 3.25 0 013.085-2.245 3.264 3.264 0 013.25 3.25 3.253 3.253 0 01-3.25 3.25c-1.439 0-2.654-.95-3.083-2.246H5.246c-.55 0-1.005-.455-1.005-1.004 0-.55.455-1.005 1.005-1.005h8.16zm-6 7.492a3.25 3.25 0 013.085-2.246c.87 0 1.688.334 2.3.946.383.366.645.818.801 1.3h5.145c.55 0 1.004.455 1.004 1.004a1.01 1.01 0 01-1.004 1.004h-5.16a3.25 3.25 0 01-3.086 2.246c-1.439 0-2.654-.95-3.083-2.246H5.246c-.55 0-1.005-.454-1.005-1.004s.455-1.004 1.005-1.004h2.16z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("2U0D7", function(module, exports) {

$parcel$export(module.exports, "Cross", function () { return $21d14cd64a4bfd1f$export$3c877bb842c36952; });

var $6nuVc = parcelRequire("6nuVc");
var $21d14cd64a4bfd1f$var$__assign = undefined && undefined.__assign || function() {
    $21d14cd64a4bfd1f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $21d14cd64a4bfd1f$var$__assign.apply(this, arguments);
};
var $21d14cd64a4bfd1f$export$3c877bb842c36952 = $6nuVc.forwardRef(function Cross(props, svgRef) {
    return $6nuVc.createElement("svg", $21d14cd64a4bfd1f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M2.53 1.47a.75.75 0 00-1.06 1.06L10.94 12l-9.47 9.47a.75.75 0 101.06 1.06L12 13.06l9.47 9.47a.75.75 0 101.06-1.06L13.06 12l9.47-9.47a.75.75 0 00-1.06-1.06L12 10.94 2.53 1.47z"
    }));
});

});

parcelRegister("7gNMR", function(module, exports) {

$parcel$export(module.exports, "CrossBold", function () { return $54b0a5b075ac4d7a$export$44fbda67c66d275; });

var $6nuVc = parcelRequire("6nuVc");
var $54b0a5b075ac4d7a$var$__assign = undefined && undefined.__assign || function() {
    $54b0a5b075ac4d7a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $54b0a5b075ac4d7a$var$__assign.apply(this, arguments);
};
var $54b0a5b075ac4d7a$export$44fbda67c66d275 = $6nuVc.forwardRef(function CrossBold(props, svgRef) {
    return $6nuVc.createElement("svg", $54b0a5b075ac4d7a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M3.06.94A1.5 1.5 0 10.94 3.06L9.878 12l-8.94 8.94a1.5 1.5 0 002.122 2.12L12 14.122l8.94 8.94a1.5 1.5 0 002.12-2.122L14.122 12l8.94-8.94A1.5 1.5 0 0020.939.94L12 9.878 3.06.939z"
    }));
});

});

parcelRegister("c3MPS", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $02440f0ef0fe180c$var$__assign = undefined && undefined.__assign || function() {
    $02440f0ef0fe180c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $02440f0ef0fe180c$var$__assign.apply(this, arguments);
};
var $02440f0ef0fe180c$export$fe82a520fc33e5f4 = $6nuVc.forwardRef(function Dashboard(props, svgRef) {
    return $6nuVc.createElement("svg", $02440f0ef0fe180c$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M11 12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h7a2 2 0 012 2v10zm-2 .5H2a.5.5 0 01-.5-.5V2a.5.5 0 01.5-.5h7a.5.5 0 01.5.5v10a.5.5 0 01-.5.5zm4-.5a2 2 0 012-2h7a2 2 0 012 2v10a2 2 0 01-2 2h-7a2 2 0 01-2-2V12zm2-.5h7a.5.5 0 01.5.5v10a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5V12a.5.5 0 01.5-.5zM15 0a2 2 0 00-2 2v4a2 2 0 002 2h7a2 2 0 002-2V2a2 2 0 00-2-2h-7zm7 1.5h-7a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h7a.5.5 0 00.5-.5V2a.5.5 0 00-.5-.5zM11 22a2 2 0 01-2 2H2a2 2 0 01-2-2v-4a2 2 0 012-2h7a2 2 0 012 2v4zm-2 .5H2a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h7a.5.5 0 01.5.5v4a.5.5 0 01-.5.5z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("cpnsw", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $908a044f88a48259$var$__assign = undefined && undefined.__assign || function() {
    $908a044f88a48259$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $908a044f88a48259$var$__assign.apply(this, arguments);
};
var $908a044f88a48259$export$735b4219f406972d = $6nuVc.forwardRef(function DashboardBold(props, svgRef) {
    return $6nuVc.createElement("svg", $908a044f88a48259$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M11 12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h7a2 2 0 012 2v10zm2 0a2 2 0 012-2h7a2 2 0 012 2v10a2 2 0 01-2 2h-7a2 2 0 01-2-2V12zm2-12a2 2 0 00-2 2v4a2 2 0 002 2h7a2 2 0 002-2V2a2 2 0 00-2-2h-7zm-4 22a2 2 0 01-2 2H2a2 2 0 01-2-2v-4a2 2 0 012-2h7a2 2 0 012 2v4z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("8FGme", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $650302650361263e$var$__assign = undefined && undefined.__assign || function() {
    $650302650361263e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $650302650361263e$var$__assign.apply(this, arguments);
};
var $650302650361263e$export$6341f9a885713487 = $6nuVc.forwardRef(function Date(props, svgRef) {
    return $6nuVc.createElement("svg", $650302650361263e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M21.427 3.813h-3.552V1.707A.713.713 0 0017.168 1a.713.713 0 00-.707.707v2.106H8.039V1.707A.713.713 0 007.332 1a.713.713 0 00-.707.707v2.106H3.073A2.078 2.078 0 001 5.886v15.557c0 1.14.932 2.073 2.073 2.073h18.354a2.078 2.078 0 002.073-2.073V5.886a2.078 2.078 0 00-2.073-2.074zM3.073 5.21h3.552v1.414c0 .386.321.707.707.707a.713.713 0 00.707-.707V5.211h8.438v1.414c0 .386.321.707.707.707a.713.713 0 00.707-.707V5.211h3.552c.37 0 .659.305.659.659v3.55H2.414V5.886c0-.37.29-.675.66-.675zm18.354 16.875H3.073a.662.662 0 01-.659-.66v-10.59h19.688v10.59a.676.676 0 01-.675.66z"
    }), $6nuVc.createElement("path", {
        d: "M6.271 15.063a1.06 1.06 0 100-2.122 1.06 1.06 0 000 2.121zm.049 2.812h-.097a1.066 1.066 0 00-.996 1.045c0 .578.466 1.06 1.06 1.06a1.05 1.05 0 001.061-1.06 1.084 1.084 0 00-1.028-1.045zm5.93-2.812a1.06 1.06 0 100-2.122 1.06 1.06 0 000 2.121zm.048 2.812h-.112a1.066 1.066 0 00-.997 1.045 1.06 1.06 0 102.122 0c0-.563-.45-1.013-1.013-1.045zm5.995-4.918h-.097a1.058 1.058 0 00-1.012 1.045c0 .578.466 1.06 1.06 1.06a1.05 1.05 0 001.061-1.06 1.081 1.081 0 00-1.012-1.045zm-.064 4.918h-.017c-.578 0-1.044.482-1.044 1.06 0 .58.466 1.061 1.06 1.061a1.05 1.05 0 001.061-1.06 1.07 1.07 0 00-1.06-1.061z"
    }));
});

});

parcelRegister("3nmZg", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $275559ddb20608ae$var$__assign = undefined && undefined.__assign || function() {
    $275559ddb20608ae$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $275559ddb20608ae$var$__assign.apply(this, arguments);
};
var $275559ddb20608ae$export$6cbcb5cd862c2b93 = $6nuVc.forwardRef(function DateBold(props, svgRef) {
    return $6nuVc.createElement("svg", $275559ddb20608ae$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M6.271 12.566a1.436 1.436 0 100 2.871 1.436 1.436 0 000-2.871zm5.979 0a1.436 1.436 0 100 2.871 1.436 1.436 0 000-2.871zm6.054.016h-.128c-.75.043-1.367.646-1.367 1.42 0 .782.63 1.435 1.436 1.435.801 0 1.435-.634 1.435-1.435v-.011a1.456 1.456 0 00-1.365-1.408h-.011zM6.33 17.5h-.128c-.74.044-1.35.67-1.35 1.42 0 .781.63 1.435 1.436 1.435.801 0 1.435-.634 1.435-1.436v-.01A1.459 1.459 0 006.341 17.5h-.01zm5.979 0h-.145c-.74.044-1.35.67-1.35 1.42a1.435 1.435 0 102.872 0c0-.774-.618-1.377-1.366-1.42h-.011zm5.903 0c-.793 0-1.42.657-1.42 1.436 0 .782.631 1.435 1.437 1.435.801 0 1.435-.634 1.435-1.435 0-.786-.65-1.436-1.435-1.436h-.017z"
    }), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M7.332.625c-.593 0-1.082.49-1.082 1.082v1.73H3.073A2.453 2.453 0 00.625 5.886v15.557c0 1.348 1.1 2.448 2.448 2.448h18.354c1.348 0 2.448-1.1 2.448-2.448V5.886c0-1.348-1.1-2.449-2.448-2.449H18.25v-1.73c0-.593-.49-1.082-1.082-1.082-.593 0-1.082.49-1.082 1.082v1.73H8.414v-1.73c0-.593-.489-1.082-1.082-1.082zM2.79 21.427V11.21h18.938v10.206a.3.3 0 01-.3.294H3.073a.287.287 0 01-.284-.284z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("7wwUx", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $57a50cfab1cbc074$var$__assign = undefined && undefined.__assign || function() {
    $57a50cfab1cbc074$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $57a50cfab1cbc074$var$__assign.apply(this, arguments);
};
var $57a50cfab1cbc074$export$bfadae053a633538 = $6nuVc.forwardRef(function Delete(props, svgRef) {
    return $6nuVc.createElement("svg", $57a50cfab1cbc074$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M9.827 10.077a.75.75 0 01.75.75v6.461a.75.75 0 01-1.5 0v-6.461a.75.75 0 01.75-.75zm5.596.75a.75.75 0 00-1.5 0v6.461a.75.75 0 001.5 0v-6.461z"
    }), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M9.827 2A2.365 2.365 0 007.46 4.365v.866H1.75a.75.75 0 000 1.5h2.481v13.788a2.365 2.365 0 002.365 2.366h11.308a2.365 2.365 0 002.365-2.366V6.731h2.481a.75.75 0 000-1.5h-5.712v-.866A2.365 2.365 0 0014.673 2H9.827zM8.198 6.73h8.09a.74.74 0 00.014 0h2.467v13.79a.866.866 0 01-.865.864H6.596a.865.865 0 01-.865-.865V6.731h2.467zm7.34-1.5v-.865a.865.865 0 00-.865-.865H9.827a.865.865 0 00-.866.865v.866h6.577z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("iA5z4", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $d86fe7d1d6697cab$var$__assign = undefined && undefined.__assign || function() {
    $d86fe7d1d6697cab$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d86fe7d1d6697cab$var$__assign.apply(this, arguments);
};
var $d86fe7d1d6697cab$export$8d5b5b936cb45ab2 = $6nuVc.forwardRef(function DeleteBold(props, svgRef) {
    return $6nuVc.createElement("svg", $d86fe7d1d6697cab$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M9.577 1A3.115 3.115 0 006.46 4.115v.116H1.5a1.5 1.5 0 000 3h1.731v13.038a3.116 3.116 0 003.115 3.116h11.308a3.115 3.115 0 003.115-3.116V7.231H22.5a1.5 1.5 0 000-3h-4.962v-.116A3.116 3.116 0 0014.423 1H9.577zm0 8.077a1.5 1.5 0 011.5 1.5v6.461a1.5 1.5 0 01-3 0v-6.461a1.5 1.5 0 011.5-1.5zm6.346 1.5a1.5 1.5 0 10-3 0v6.461a1.5 1.5 0 003 0v-6.461z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("8QJ7p", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $67162da8c5b470e6$var$__assign = undefined && undefined.__assign || function() {
    $67162da8c5b470e6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $67162da8c5b470e6$var$__assign.apply(this, arguments);
};
var $67162da8c5b470e6$export$4a82481d9e63c9e1 = $6nuVc.forwardRef(function Duplicate(props, svgRef) {
    return $6nuVc.createElement("svg", $67162da8c5b470e6$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M2 4.251A2.251 2.251 0 014.25 2H16.5a2 2 0 012 2A.75.75 0 0117 4a.5.5 0 00-.5-.5H4.25a.751.751 0 00-.75.751V16.5a.5.5 0 00.5.5.75.75 0 010 1.5 2 2 0 01-2-2V4.251z",
        fillRule: "evenodd"
    }), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M20 7.5H8a.5.5 0 00-.5.5v12a.5.5 0 00.5.5h12a.5.5 0 00.5-.5V8a.5.5 0 00-.5-.5zM8 6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2H8z",
        fillRule: "evenodd"
    }), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M14 10.45a.75.75 0 01.75.75v2.05h2.05a.75.75 0 010 1.5h-2.05v2.05a.75.75 0 11-1.5 0v-2.05H11.2a.75.75 0 110-1.5h2.05V11.2a.75.75 0 01.75-.75z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("cqOSy", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $90cf614082835325$var$__assign = undefined && undefined.__assign || function() {
    $90cf614082835325$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $90cf614082835325$var$__assign.apply(this, arguments);
};
var $90cf614082835325$export$7791901baee658a0 = $6nuVc.forwardRef(function DuplicateBold(props, svgRef) {
    return $6nuVc.createElement("svg", $90cf614082835325$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M1.25 4.251a3.001 3.001 0 013-3.001H16.5A2.75 2.75 0 0119.25 4a1.5 1.5 0 01-2.98.25H4.25v12.021A1.5 1.5 0 014 19.25a2.75 2.75 0 01-2.75-2.75V4.251z",
        fillRule: "evenodd"
    }), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M8.5 6.5a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-12a2 2 0 00-2-2h-12zm7 5.2a1 1 0 00-2 0v1.8h-1.8a1 1 0 000 2h1.8v1.8a1 1 0 102 0v-1.8h1.8a1 1 0 100-2h-1.8v-1.8z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("03lon", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $00a0dffcfb6560db$var$__assign = undefined && undefined.__assign || function() {
    $00a0dffcfb6560db$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $00a0dffcfb6560db$var$__assign.apply(this, arguments);
};
var $00a0dffcfb6560db$export$6ed0965c9443aaa6 = $6nuVc.forwardRef(function Edit(props, svgRef) {
    return $6nuVc.createElement("svg", $00a0dffcfb6560db$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M19.592 0a4.39 4.39 0 013.128 1.28l.002.002a4.386 4.386 0 01-.04 6.231l-.41.411-.001.001-14.08 14.08-.005.005a.75.75 0 01-.344.196l-6.906 1.77a.75.75 0 01-.912-.913l1.77-6.904a.75.75 0 01.196-.344v-.001L16.486 1.318A4.388 4.388 0 0119.592 0zM2.921 17.802l-1.13 4.406 4.41-1.13-3.28-3.276zm4.738 2.612l-4.077-4.07L16.605 3.32l4.074 4.074-13.02 13.02zM22.27 5.507a2.85 2.85 0 01-.531.825l-4.07-4.07a2.89 2.89 0 013.991.079 2.887 2.887 0 01.61 3.166z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("dlEzn", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $9b7cb4d2e62a6f59$var$__assign = undefined && undefined.__assign || function() {
    $9b7cb4d2e62a6f59$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9b7cb4d2e62a6f59$var$__assign.apply(this, arguments);
};
var $9b7cb4d2e62a6f59$export$680fa2622ca83bb7 = $6nuVc.forwardRef(function EditBold(props, svgRef) {
    return $6nuVc.createElement("svg", $9b7cb4d2e62a6f59$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M19.592 0a4.39 4.39 0 013.128 1.28l.002.002a4.386 4.386 0 01.076 6.115 1.017 1.017 0 00-.09-.103l-6-6a1.014 1.014 0 00-.104-.09A4.388 4.388 0 0119.593 0zm1.701 8.707a.962.962 0 00.103.09L9.304 20.89 3.11 14.695 15.201 2.603a.993.993 0 00.092.104l6 6zm-19.509 7.49l-1.76 6.866a.75.75 0 00.912.913l6.865-1.76-6.017-6.019z"
    }));
});

});

parcelRegister("itoUL", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $d72e42f6b7c6feeb$var$__assign = undefined && undefined.__assign || function() {
    $d72e42f6b7c6feeb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d72e42f6b7c6feeb$var$__assign.apply(this, arguments);
};
var $d72e42f6b7c6feeb$export$4c6ac753363de59f = $6nuVc.forwardRef(function EditFile(props, svgRef) {
    return $6nuVc.createElement("svg", $d72e42f6b7c6feeb$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M13.755 14.775l7.904-7.904a.812.812 0 00.032-.031l.974-.975a2.852 2.852 0 00-.924-4.648 2.85 2.85 0 00-3.107.618l-8.91 8.91a.75.75 0 00-.211.424l-.495 3.465a.75.75 0 00.849.849l3.464-.496a.75.75 0 00.424-.212zM20.65 2.5a1.35 1.35 0 00-.955.395l-.46.46 1.91 1.91.46-.46A1.35 1.35 0 0020.65 2.5zm-9.688 9.128l7.213-7.212 1.909 1.909-7.213 7.213-2.227.318.318-2.228z",
        fillRule: "evenodd"
    }), $6nuVc.createElement("path", {
        d: "M2.69 6.892a.65.65 0 01.46-.19h7a.75.75 0 000-1.5h-7A2.15 2.15 0 001 7.351v14a2.15 2.15 0 002.15 2.15h14a2.15 2.15 0 002.15-2.15v-7a.75.75 0 00-1.5 0v7a.65.65 0 01-.65.65h-14a.65.65 0 01-.65-.65v-14a.65.65 0 01.19-.46z"
    }));
});

});

parcelRegister("d3nLD", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $980dfddf175dc29a$var$__assign = undefined && undefined.__assign || function() {
    $980dfddf175dc29a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $980dfddf175dc29a$var$__assign.apply(this, arguments);
};
var $980dfddf175dc29a$export$b78ec286cc721c36 = $6nuVc.forwardRef(function EditFileBold(props, svgRef) {
    return $6nuVc.createElement("svg", $980dfddf175dc29a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M3 6.451h6.9a1.5 1.5 0 100-3h-7a2.9 2.9 0 00-2.9 2.9v14a2.9 2.9 0 002.9 2.9h14a2.9 2.9 0 002.9-2.9v-7a1.5 1.5 0 10-3 0v6.9H3v-13.8z",
        fillRule: "evenodd"
    }), $6nuVc.createElement("path", {
        d: "M21.722 5.558a.772.772 0 00-.015-.015l-4.015-4.015.692-.693a2.85 2.85 0 014.031 4.03l-.693.693zm-1.414 1.414a1.652 1.652 0 01-.015-.015l-4.015-4.015-6.803 6.802a.75.75 0 00-.212.425l-.495 3.465a.75.75 0 00.849.849l3.464-.496a.75.75 0 00.424-.212l6.803-6.803z"
    }));
});

});

parcelRegister("eJiH4", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $ab93c4cf8fb944ad$var$__assign = undefined && undefined.__assign || function() {
    $ab93c4cf8fb944ad$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ab93c4cf8fb944ad$var$__assign.apply(this, arguments);
};
var $ab93c4cf8fb944ad$export$49bd1dfb0ad29c40 = $6nuVc.forwardRef(function Expand(props, svgRef) {
    return $6nuVc.createElement("svg", $ab93c4cf8fb944ad$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M21.746 3.806v4.69a.75.75 0 001.5 0v-6.5a.747.747 0 00-.75-.75h-6.5a.75.75 0 000 1.5h4.69l-7.22 7.22a.75.75 0 101.06 1.06l7.22-7.22zM1.996 14.974a.75.75 0 01.75.75v4.689l7.22-7.22a.75.75 0 011.06 1.061l-7.22 7.22h4.69a.75.75 0 110 1.5h-6.5a.746.746 0 01-.679-.43.747.747 0 01-.071-.32v-6.5a.75.75 0 01.75-.75z"
    }));
});

});

parcelRegister("77vTc", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $52f1ec69434e8b05$var$__assign = undefined && undefined.__assign || function() {
    $52f1ec69434e8b05$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $52f1ec69434e8b05$var$__assign.apply(this, arguments);
};
var $52f1ec69434e8b05$export$6b5ba4345fea866a = $6nuVc.forwardRef(function ExpandBold(props, svgRef) {
    return $6nuVc.createElement("svg", $52f1ec69434e8b05$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M20.996 8.496a1.5 1.5 0 003 0v-6.5a1.496 1.496 0 00-1.5-1.5h-6.5a1.5 1.5 0 000 3h2.879l-5.94 5.94a1.5 1.5 0 102.121 2.12l5.94-5.939v2.879zm-19 5.728a1.5 1.5 0 011.5 1.5v2.878l5.94-5.939a1.5 1.5 0 112.12 2.121l-5.939 5.94h2.879a1.5 1.5 0 110 3h-6.5a1.494 1.494 0 01-1.374-.897 1.495 1.495 0 01-.126-.603v-6.5a1.5 1.5 0 011.5-1.5z"
    }));
});

});

parcelRegister("jpaPf", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $e208bfd70522ccfe$var$__assign = undefined && undefined.__assign || function() {
    $e208bfd70522ccfe$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e208bfd70522ccfe$var$__assign.apply(this, arguments);
};
var $e208bfd70522ccfe$export$7562e752e5ef1fad = $6nuVc.forwardRef(function Faq(props, svgRef) {
    return $6nuVc.createElement("svg", $e208bfd70522ccfe$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M2.25 1.5a.75.75 0 00-.75.75v15a.75.75 0 00.75.75h3a.75.75 0 01.75.75v3l4.8-3.6a.75.75 0 01.45-.15h10.5a.75.75 0 00.75-.75v-15a.75.75 0 00-.75-.75H2.25zM.659.659A2.25 2.25 0 012.25 0h19.5A2.25 2.25 0 0124 2.25v15a2.25 2.25 0 01-2.25 2.25H11.5l-5.8 4.35a.75.75 0 01-1.2-.6V19.5H2.25A2.25 2.25 0 010 17.25v-15C0 1.653.237 1.081.659.659z",
        fillRule: "evenodd"
    }), $6nuVc.createElement("path", {
        d: "M11.325 11.46h1.227c-.037-.166-.091-.367-.091-.587 0-.659.494-1.117 1.3-1.85 1.025-.915 1.739-1.738 1.739-2.965C15.5 4.263 14.053 3 12.277 3c-1.61 0-2.8.934-3.277 2.563l1.19.495c.366-1.172 1.117-1.758 2.05-1.758.99 0 1.795.75 1.795 1.85 0 .896-.512 1.39-1.428 2.251-.787.696-1.465 1.337-1.465 2.252 0 .293.074.586.183.806zm.696 4.027c.641 0 1.172-.476 1.172-1.153 0-.678-.531-1.154-1.172-1.154-.604 0-1.153.476-1.153 1.154 0 .677.549 1.153 1.153 1.153z"
    }));
});

});

parcelRegister("fR2Qd", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $b8ae0276135ebf5a$var$__assign = undefined && undefined.__assign || function() {
    $b8ae0276135ebf5a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b8ae0276135ebf5a$var$__assign.apply(this, arguments);
};
var $b8ae0276135ebf5a$export$b995d600f3ba41d6 = $6nuVc.forwardRef(function FaqBold(props, svgRef) {
    return $6nuVc.createElement("svg", $b8ae0276135ebf5a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M2.25 0A2.25 2.25 0 000 2.25v15a2.25 2.25 0 002.25 2.25H4.5v3.75a.75.75 0 001.2.6l5.8-4.35h10.25A2.25 2.25 0 0024 17.25v-15A2.25 2.25 0 0021.75 0H2.25zm10.759 11.094h-1.88a1.996 1.996 0 01-.182-.792c0-.66.495-1.22 1.303-1.864.676-.561.973-.858.973-1.386 0-.594-.462-1.006-1.039-1.006-.61 0-1.056.429-1.37 1.253L9 6.508C9.478 4.825 10.7 4 12.25 4c1.798 0 3.25 1.138 3.25 2.887 0 .973-.462 1.617-1.37 2.409l-.176.153c-.57.495-.978.849-.978 1.299 0 .131.016.247.033.346zm.66 2.656c0 .874-.66 1.534-1.535 1.534-.89 0-1.55-.66-1.55-1.534 0-.858.66-1.534 1.55-1.534a1.51 1.51 0 011.535 1.534z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("ayNZC", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $7b03dbec663d72d1$var$__assign = undefined && undefined.__assign || function() {
    $7b03dbec663d72d1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7b03dbec663d72d1$var$__assign.apply(this, arguments);
};
var $7b03dbec663d72d1$export$ec91da630f36d5ea = $6nuVc.forwardRef(function Filter(props, svgRef) {
    return $6nuVc.createElement("svg", $7b03dbec663d72d1$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M23.571 1.029a1.495 1.495 0 00-1.028-.515H1.49C1.097.514.72.67.446.96A1.436 1.436 0 000 2.023v.103c.377 5.143 4.029 9.48 8.966 10.765v9.275c0 .394.154.771.445 1.063.292.291.652.445 1.063.445.343 0 .686-.12.96-.343l3-2.502c.343-.292.549-.703.549-1.149v-6.806c4.954-1.285 8.606-5.623 8.966-10.765a1.47 1.47 0 00-.378-1.08zm-9.497 10.525a.754.754 0 00-.6.737v7.372l-3 2.503V12.29a.754.754 0 00-.6-.737c-4.594-.943-8.04-4.868-8.383-9.531H22.44c-.326 4.663-3.771 8.588-8.366 9.531z"
    }));
});

});

parcelRegister("gn6Og", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $beb41398431b0fa6$var$__assign = undefined && undefined.__assign || function() {
    $beb41398431b0fa6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $beb41398431b0fa6$var$__assign.apply(this, arguments);
};
var $beb41398431b0fa6$export$12f6556880dd4f70 = $6nuVc.forwardRef(function FilterBold(props, svgRef) {
    return $6nuVc.createElement("svg", $beb41398431b0fa6$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M23.571 1.029a1.495 1.495 0 00-1.028-.515H1.49C1.097.514.72.67.446.96A1.436 1.436 0 000 2.023v.103c.377 5.143 4.029 9.48 8.966 10.765v9.275c0 .394.154.771.445 1.063.292.291.652.445 1.063.445.343 0 .686-.12.96-.343l3-2.502c.343-.292.549-.703.549-1.149v-6.806c4.954-1.285 8.606-5.623 8.966-10.765a1.47 1.47 0 00-.378-1.08z"
    }));
});

});

parcelRegister("fRPry", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $b8d3b5d8de7eff1e$var$__assign = undefined && undefined.__assign || function() {
    $b8d3b5d8de7eff1e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b8d3b5d8de7eff1e$var$__assign.apply(this, arguments);
};
var $b8d3b5d8de7eff1e$export$b94310965bed44e6 = $6nuVc.forwardRef(function Home(props, svgRef) {
    return $6nuVc.createElement("svg", $b8d3b5d8de7eff1e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M4.516 13.37c.388 0 .703.316.703.704v7.031h4.218v-4.922a2.11 2.11 0 012.11-2.11h1.406a2.11 2.11 0 012.11 2.11v4.922h4.218v-7.031a.703.703 0 011.407 0v7.734a.703.703 0 01-.704.703H14.36a.703.703 0 01-.703-.703v-5.625a.703.703 0 00-.703-.703h-1.406a.703.703 0 00-.703.703v5.625a.703.703 0 01-.703.703H4.516a.703.703 0 01-.704-.703v-7.734c0-.389.315-.703.704-.703z",
        fillRule: "evenodd"
    }), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M12.25 3.406a.703.703 0 00-.497.206L2.2 13.165a.703.703 0 11-.994-.995l9.552-9.552a2.11 2.11 0 012.984 0l9.552 9.552a.703.703 0 01-.994.995l-9.553-9.553a.703.703 0 00-.497-.206z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("7X8V7", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $5ca4f675fd30f2a9$var$__assign = undefined && undefined.__assign || function() {
    $5ca4f675fd30f2a9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5ca4f675fd30f2a9$var$__assign.apply(this, arguments);
};
var $5ca4f675fd30f2a9$export$611e0072bc063769 = $6nuVc.forwardRef(function HomeBold(props, svgRef) {
    return $6nuVc.createElement("svg", $5ca4f675fd30f2a9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M12.25 1.625a2.484 2.484 0 00-1.757.728L.94 11.905a1.078 1.078 0 001.524 1.525l9.553-9.553a.329.329 0 01.464 0l9.553 9.553a1.078 1.078 0 001.524-1.525l-9.552-9.552a2.484 2.484 0 00-1.757-.728z"
    }), $6nuVc.createElement("path", {
        d: "M4.516 12.996c-.596 0-1.079.482-1.079 1.078v7.734c0 .596.483 1.078 1.079 1.078h5.625c.595 0 1.078-.482 1.078-1.078v-5.625a.328.328 0 01.328-.328h1.406a.328.328 0 01.328.328v5.625c0 .596.483 1.078 1.078 1.078h5.625c.596 0 1.078-.482 1.078-1.078v-7.734a1.078 1.078 0 10-2.156 0v6.656h-3.468v-4.547a2.484 2.484 0 00-2.485-2.484h-1.406a2.484 2.484 0 00-2.485 2.484v4.547H5.595v-6.656c0-.596-.483-1.078-1.078-1.078z"
    }));
});

});

parcelRegister("4mHoH", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $32dae1543a1dff49$var$__assign = undefined && undefined.__assign || function() {
    $32dae1543a1dff49$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $32dae1543a1dff49$var$__assign.apply(this, arguments);
};
var $32dae1543a1dff49$export$4574c7fd55cd3f3 = $6nuVc.forwardRef(function LayoutDiagram(props, svgRef) {
    return $6nuVc.createElement("svg", $32dae1543a1dff49$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M7.5.75A.75.75 0 018.25 0h7.5a.75.75 0 01.75.75v7.5a.75.75 0 01-.75.75h-3v3H18a2.25 2.25 0 012.25 2.25V15h3a.75.75 0 01.75.75v7.5a.75.75 0 01-.75.75h-7.5a.75.75 0 01-.75-.75v-7.5a.75.75 0 01.75-.75h3v-.75a.75.75 0 00-.75-.75H6a.75.75 0 00-.75.75V15h3a.75.75 0 01.75.75v7.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-7.5A.75.75 0 01.75 15h3v-.75A2.25 2.25 0 016 12h5.25V9h-3a.75.75 0 01-.75-.75V.75zM15 7.5v-6H9v6h6zm-13.5 9h6v6h-6v-6zm15 6v-6h6v6h-6z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("a8PJe", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $7622c6f6f8d73789$var$__assign = undefined && undefined.__assign || function() {
    $7622c6f6f8d73789$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7622c6f6f8d73789$var$__assign.apply(this, arguments);
};
var $7622c6f6f8d73789$export$24a3cfb04e7f826e = $6nuVc.forwardRef(function LayoutDiagramBold(props, svgRef) {
    return $6nuVc.createElement("svg", $7622c6f6f8d73789$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M8.25 0a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h2.625v2.625H6a2.625 2.625 0 00-2.625 2.625V15H.75a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h7.5a.75.75 0 00.75-.75v-7.5a.75.75 0 00-.75-.75H5.625v-.75A.375.375 0 016 13.875h12a.375.375 0 01.375.375V15H15.75a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h7.5a.75.75 0 00.75-.75v-7.5a.75.75 0 00-.75-.75h-2.625v-.75A2.625 2.625 0 0018 11.625h-4.875V9h2.625a.75.75 0 00.75-.75V.75a.75.75 0 00-.75-.75h-7.5z"
    }));
});

});

parcelRegister("DaSJy", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $075c15885d5a81f2$var$__assign = undefined && undefined.__assign || function() {
    $075c15885d5a81f2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $075c15885d5a81f2$var$__assign.apply(this, arguments);
};
var $075c15885d5a81f2$export$f90ad0f3c590b2cb = $6nuVc.forwardRef(function LayoutGridView(props, svgRef) {
    return $6nuVc.createElement("svg", $075c15885d5a81f2$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .75A.75.75 0 01.75 0h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9A.75.75 0 010 9.75v-9zm1.5.75V9H9V1.5H1.5zM0 14.25a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9zm1.5.75v7.5H9V15H1.5zM13.5.75a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9zm1.5.75V9h7.5V1.5H15zm-1.5 12.75a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9zM15 15v7.5h7.5V15H15z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("59vrA", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $3c062f1eb195ce7d$var$__assign = undefined && undefined.__assign || function() {
    $3c062f1eb195ce7d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3c062f1eb195ce7d$var$__assign.apply(this, arguments);
};
var $3c062f1eb195ce7d$export$3eb98c9b2991c13c = $6nuVc.forwardRef(function LayoutGridViewBold(props, svgRef) {
    return $6nuVc.createElement("svg", $3c062f1eb195ce7d$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .773a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v8.974a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75V.773zm0 13.474a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9zM13.5.773a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v8.974a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75V.773zm0 13.474a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("jpt3X", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $e216e5635e92c937$var$__assign = undefined && undefined.__assign || function() {
    $e216e5635e92c937$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e216e5635e92c937$var$__assign.apply(this, arguments);
};
var $e216e5635e92c937$export$b73dd58f0dc7b9ee = $6nuVc.forwardRef(function LayoutList(props, svgRef) {
    return $6nuVc.createElement("svg", $e216e5635e92c937$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M3.66 2a2.66 2.66 0 100 5.32 2.66 2.66 0 000-5.32zm-.482 1.496a1.26 1.26 0 11.964 2.328 1.26 1.26 0 01-.964-2.328zM3.66 9.84a2.66 2.66 0 100 5.318 2.66 2.66 0 000-5.318zm-.482 1.496a1.26 1.26 0 11.964 2.329 1.26 1.26 0 01-.964-2.33zm-.536 6.546a2.661 2.661 0 013.475 3.476 2.66 2.66 0 11-3.475-3.476zM3.66 19.08a1.258 1.258 0 00-.891 2.15 1.26 1.26 0 10.891-2.15z",
        fillRule: "evenodd"
    }), $6nuVc.createElement("path", {
        d: "M8.233 4.613a.7.7 0 100 1.4H21.3a.7.7 0 100-1.4H8.233zm-.7 8.54a.7.7 0 01.7-.7H21.3a.7.7 0 110 1.4H8.233a.7.7 0 01-.7-.7zm.7 7.14a.7.7 0 100 1.4H21.3a.7.7 0 100-1.4H8.233z"
    }));
});

});

parcelRegister("d22cu", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $97cd2b395a21bb53$var$__assign = undefined && undefined.__assign || function() {
    $97cd2b395a21bb53$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $97cd2b395a21bb53$var$__assign.apply(this, arguments);
};
var $97cd2b395a21bb53$export$8c8aefe5a4ba5254 = $6nuVc.forwardRef(function LayoutListBold(props, svgRef) {
    return $6nuVc.createElement("svg", $97cd2b395a21bb53$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M3.13 1a3.13 3.13 0 100 6.26 3.13 3.13 0 000-6.26zm0 8.018a3.13 3.13 0 100 6.26 3.13 3.13 0 000-6.26zm-1.198 8.256a3.13 3.13 0 013.41 5.105 3.13 3.13 0 11-3.41-5.105zM8.761 3.298a1.5 1.5 0 000 3h13.364a1.5 1.5 0 100-3H8.761zm-1.5 9.518a1.5 1.5 0 011.5-1.5h13.364a1.5 1.5 0 110 3H8.761a1.5 1.5 0 01-1.5-1.5zm1.5 6.518a1.5 1.5 0 000 3h13.364a1.5 1.5 0 100-3H8.761z"
    }));
});

});

parcelRegister("llLRf", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $f8b0aeaf04e2c3ce$var$__assign = undefined && undefined.__assign || function() {
    $f8b0aeaf04e2c3ce$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f8b0aeaf04e2c3ce$var$__assign.apply(this, arguments);
};
var $f8b0aeaf04e2c3ce$export$d57cd6dbf45f4bdf = $6nuVc.forwardRef(function LayoutListView(props, svgRef) {
    return $6nuVc.createElement("svg", $f8b0aeaf04e2c3ce$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .75A.75.75 0 01.75 0h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75A.75.75 0 010 5.25V.75zm1.5.75v3h21v-3h-21zM0 9.75A.75.75 0 01.75 9h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-4.5zm1.5.75v3h21v-3h-21zM0 18.75A.75.75 0 01.75 18h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-4.5zm1.5.75v3h21v-3h-21z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("4DnzQ", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $35fd17e24de602a1$var$__assign = undefined && undefined.__assign || function() {
    $35fd17e24de602a1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $35fd17e24de602a1$var$__assign.apply(this, arguments);
};
var $35fd17e24de602a1$export$faa3c8ce2462319b = $6nuVc.forwardRef(function LayoutListViewBold(props, svgRef) {
    return $6nuVc.createElement("svg", $35fd17e24de602a1$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .75A.75.75 0 01.75 0h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75A.75.75 0 010 5.25V.75zm0 9A.75.75 0 01.75 9h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-4.5zm0 9A.75.75 0 01.75 18h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-4.5z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("2FfDG", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $1f0b8ab813d163a4$var$__assign = undefined && undefined.__assign || function() {
    $1f0b8ab813d163a4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1f0b8ab813d163a4$var$__assign.apply(this, arguments);
};
var $1f0b8ab813d163a4$export$5047665d7d511e82 = $6nuVc.forwardRef(function LevelIndicator(props, svgRef) {
    return $6nuVc.createElement("svg", $1f0b8ab813d163a4$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M12 3.771a11.961 11.961 0 00-8.52 3.6A12.054 12.054 0 000 15.943v2.074a2.253 2.253 0 002.246 2.245h19.508A2.253 2.253 0 0024 18.017v-2.074c.05-6.653-5.332-12.12-12-12.173zm-.017 12.754h.034a2.25 2.25 0 012.229 2.246H9.754a2.25 2.25 0 012.229-2.246zm10.525 1.492a.761.761 0 01-.754.754h-6c0-1.714-1.166-3.171-2.76-3.617l1.972-5.897a.736.736 0 00-.48-.943.736.736 0 00-.943.48l-2.092 6.274a3.761 3.761 0 00-3.188 3.703h-6a.761.761 0 01-.754-.754v-2.074A10.535 10.535 0 014.56 8.434 10.389 10.389 0 0112 5.28c5.828.034 10.543 4.817 10.508 10.663v2.074z"
    }), $6nuVc.createElement("path", {
        d: "M4.869 16.525a1.131 1.131 0 100-2.262 1.131 1.131 0 000 2.262zm1.508-6a1.13 1.13 0 100 2.263 1.12 1.12 0 001.132-1.131 1.13 1.13 0 00-1.132-1.132zm12.754 6a1.131 1.131 0 100-2.263 1.131 1.131 0 000 2.263zm-.377-4.868c0-.6-.48-1.097-1.08-1.114h-.12a1.138 1.138 0 00-1.063 1.114 1.13 1.13 0 102.263 0zM9.429 7.526c-.018 0-.018 0 0 0h-.12A1.138 1.138 0 008.246 8.64a1.13 1.13 0 001.131 1.13 1.12 1.12 0 001.131-1.131c0-.6-.497-1.097-1.08-1.114z"
    }));
});

});

parcelRegister("3QRDR", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $2cdfd6967ae3ecc8$var$__assign = undefined && undefined.__assign || function() {
    $2cdfd6967ae3ecc8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2cdfd6967ae3ecc8$var$__assign.apply(this, arguments);
};
var $2cdfd6967ae3ecc8$export$b0288941685426f5 = $6nuVc.forwardRef(function LevelIndicatorBold(props, svgRef) {
    return $6nuVc.createElement("svg", $2cdfd6967ae3ecc8$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M12 4C8.8 4 5.7 5.3 3.5 7.6 1.2 9.9 0 12.9 0 16.2v2.1c0 1.2 1 2.2 2.2 2.2h5.6c.5 0 .4-1 .4-1.5 0-1.9 1.4-3.4 3.2-3.7L13.5 9c.1-.4.5-.6.9-.5.4.1.6.5.5.9l-2 5.9c1.4.4 2.4 1.5 2.7 2.9 0 .2.1.5.1.7 0 .5-.3 1.5.5 1.5h5.5c1.2 0 2.2-1 2.2-2.2v-2.1C24.1 9.5 18.7 4.1 12 4zm7 7.9c0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4 0-.7.6-1.3 1.3-1.4h.1c.8 0 1.4.7 1.4 1.4zm.1 5.1c-.8 0-1.4-.6-1.4-1.4 0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4 0 .8-.6 1.4-1.4 1.4zM7 13.1c-.2.1-.4.2-.6.2-.8 0-1.4-.7-1.4-1.4 0-.8.6-1.4 1.4-1.4.2 0 .4.1.6.2.4.2.8.7.8 1.2s-.3 1-.8 1.2zm-2.1 1.1c.8 0 1.4.6 1.4 1.4 0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4 0-.7.6-1.4 1.4-1.4zm4.5-4c-.8 0-1.4-.6-1.4-1.3 0-.2.1-.4.2-.6.2-.4.6-.7 1.1-.7h.1c.5 0 .9.3 1.2.7.1.2.2.4.2.6 0 .7-.7 1.3-1.4 1.3z"
    }));
});

});

parcelRegister("3nsc7", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $275963e7ccfb4755$var$__assign = undefined && undefined.__assign || function() {
    $275963e7ccfb4755$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $275963e7ccfb4755$var$__assign.apply(this, arguments);
};
var $275963e7ccfb4755$export$a6c7ac8248d6e38a = $6nuVc.forwardRef(function Link(props, svgRef) {
    return $6nuVc.createElement("svg", $275963e7ccfb4755$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M22.2 4.3c-.9-.9-2-1.3-3.2-1.3-1.2 0-2.4.5-3.2 1.3-.3.3-.3.8 0 1.1.3.3.8.3 1.1 0 1.2-1.2 3.2-1.2 4.4 0 .4.6.7 1.4.7 2.2 0 .8-.3 1.6-.9 2.2l-5.6 5.6c-.5.5-1.3.9-2.1.9s-1.5-.2-2.1-.7c-.6-.5-1-1.2-1.1-2 0-.8.2-1.6.6-2.2.2-.3.2-.8-.2-1-.3-.2-.8-.2-1 .2-.7.9-1 2.1-.8 3.2.1 1.1.7 2.2 1.6 2.9.8.7 1.9 1.1 3 1.1h.2c1.2 0 2.2-.5 3.1-1.3l5.6-5.6c.9-.9 1.3-2 1.3-3.2 0-1.2-.6-2.5-1.4-3.4z"
    }), $6nuVc.createElement("path", {
        d: "M7.8 17.8c-1.2 1.2-3.2 1.2-4.4 0-.6-.6-.9-1.4-.9-2.2 0-.8.3-1.6.9-2.2L9 7.8c.5-.5 1.3-.8 2-.9.8 0 1.5.2 2.1.7.6.5 1 1.2 1.1 2 .1.8-.1 1.5-.6 2.2-.2.3-.2.8.2 1 .3.2.8.2 1-.2.7-.9 1-2.1.8-3.2-.1-1.1-.7-2.2-1.6-2.9-.9-.8-2-1.1-3.2-1.1-1 .1-2.1.6-2.9 1.4l-5.6 5.6c-.9.9-1.3 2-1.3 3.2 0 1.2.5 2.4 1.3 3.2.9.9 2 1.3 3.2 1.3 1.2 0 2.4-.5 3.2-1.3.3-.3.3-.8 0-1.1-.3-.3-.6-.2-.9.1z"
    }));
});

});

parcelRegister("91nyl", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $01b1e93254bc4478$var$__assign = undefined && undefined.__assign || function() {
    $01b1e93254bc4478$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $01b1e93254bc4478$var$__assign.apply(this, arguments);
};
var $01b1e93254bc4478$export$6343830e6ea0f555 = $6nuVc.forwardRef(function LinkBold(props, svgRef) {
    return $6nuVc.createElement("svg", $01b1e93254bc4478$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M17.02 6.183a2.331 2.331 0 113.297 3.297l-5.588 5.588a2.332 2.332 0 01-3.536-3.018 1.5 1.5 0 00-2.426-1.764 5.332 5.332 0 008.085 6.902l5.586-5.586a5.331 5.331 0 10-7.54-7.54 1.5 1.5 0 102.122 2.12z"
    }), $6nuVc.createElement("path", {
        d: "M6.98 17.506a2.332 2.332 0 01-3.297-3.298L9.27 8.62a2.332 2.332 0 013.536 3.019 1.5 1.5 0 002.426 1.764A5.331 5.331 0 007.148 6.5l-5.586 5.587a5.332 5.332 0 007.54 7.54 1.5 1.5 0 10-2.122-2.121z"
    }));
});

});

parcelRegister("3fgLQ", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $25cfc8210bf28fcf$var$__assign = undefined && undefined.__assign || function() {
    $25cfc8210bf28fcf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $25cfc8210bf28fcf$var$__assign.apply(this, arguments);
};
var $25cfc8210bf28fcf$export$5b9db7ce80343746 = $6nuVc.forwardRef(function Lock(props, svgRef) {
    return $6nuVc.createElement("svg", $25cfc8210bf28fcf$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M12.75 14a.75.75 0 00-1.5 0v3a.75.75 0 001.5 0v-3z"
    }), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M6 6v2H3.75a.75.75 0 00-.75.75v13.5c0 .414.336.75.75.75h16.5a.75.75 0 00.75-.75V8.75a.75.75 0 00-.75-.75H18V6A6 6 0 106 6zm6-4.5A4.5 4.5 0 007.5 6v2h9V6A4.5 4.5 0 0012 1.5zm-7.5 8h15v12h-15v-12z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("fyNrD", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $b54062b1dbfc397c$var$__assign = undefined && undefined.__assign || function() {
    $b54062b1dbfc397c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b54062b1dbfc397c$var$__assign.apply(this, arguments);
};
var $b54062b1dbfc397c$export$4038de8e7cd615d7 = $6nuVc.forwardRef(function LockBold(props, svgRef) {
    return $6nuVc.createElement("svg", $b54062b1dbfc397c$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M12 .625A6.375 6.375 0 005.625 7v2H3.75a.75.75 0 00-.75.75v13.5c0 .414.336.75.75.75h16.5a.75.75 0 00.75-.75V9.75a.75.75 0 00-.75-.75h-1.875V7A6.375 6.375 0 0012 .625zM16.125 7v2h-8.25V7a4.125 4.125 0 018.25 0zm-5.25 8a1.125 1.125 0 012.25 0v3a1.125 1.125 0 01-2.25 0v-3z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("7uHym", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $574d1e7eac9c765f$var$__assign = undefined && undefined.__assign || function() {
    $574d1e7eac9c765f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $574d1e7eac9c765f$var$__assign.apply(this, arguments);
};
var $574d1e7eac9c765f$export$88195aaac9f90319 = $6nuVc.forwardRef(function LogIn(props, svgRef) {
    return $6nuVc.createElement("svg", $574d1e7eac9c765f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M20.727 1.393h.037a2.09 2.09 0 011.985 2.165v16.769a2.09 2.09 0 01-2.022 2.164H9.235a2.09 2.09 0 01-1.985-2.164v-4.185a.75.75 0 011.5 0v4.2l-.001.033a.591.591 0 00.546.616h11.409a.591.591 0 00.545-.65V3.509a.59.59 0 00-.545-.615H9.295a.591.591 0 00-.545.65v4.2a.75.75 0 01-1.5 0V3.557a2.091 2.091 0 012.023-2.165h11.454z"
    }), $6nuVc.createElement("path", {
        d: "M12.169 7.916a.75.75 0 000 1.06l2.22 2.22H1.5a.75.75 0 000 1.5h12.888l-2.22 2.22a.75.75 0 001.062 1.06l3.496-3.496a.754.754 0 00.17-.81.747.747 0 00-.167-.254l-3.5-3.5a.75.75 0 00-1.06 0z"
    }));
});

});

parcelRegister("hwpFj", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $cc1955683134817b$var$__assign = undefined && undefined.__assign || function() {
    $cc1955683134817b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cc1955683134817b$var$__assign.apply(this, arguments);
};
var $cc1955683134817b$export$c9b57264511cea21 = $6nuVc.forwardRef(function LogInBold(props, svgRef) {
    return $6nuVc.createElement("svg", $cc1955683134817b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M20.727.5a2.84 2.84 0 012.772 2.928V20.17a2.841 2.841 0 01-2.772 2.928H9.273c-.025 0-.05 0-.075-.002A2.841 2.841 0 016.5 20.17V18a1.5 1.5 0 013 0v2.099h10.999V3.5h-11V6a1.5 1.5 0 11-3 0V3.427A2.841 2.841 0 019.274.5h11.454z"
    }), $6nuVc.createElement("path", {
        d: "M11.639 7.243a1.5 1.5 0 000 2.12l.939.94H1.5a1.5 1.5 0 100 3h11.078l-.94.94a1.5 1.5 0 102.122 2.12l3.495-3.494a1.495 1.495 0 00.334-1.631 1.496 1.496 0 00-.33-.496l-3.5-3.5a1.5 1.5 0 00-2.12 0z"
    }));
});

});

parcelRegister("lwuWU", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $fab497fbf269edc0$var$__assign = undefined && undefined.__assign || function() {
    $fab497fbf269edc0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fab497fbf269edc0$var$__assign.apply(this, arguments);
};
var $fab497fbf269edc0$export$f292abd37582246c = $6nuVc.forwardRef(function LogOut(props, svgRef) {
    return $6nuVc.createElement("svg", $fab497fbf269edc0$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M21.507 2h.037A2.058 2.058 0 0123.5 4.133V20.5a2.06 2.06 0 01-1.992 2.132h-11.22A2.059 2.059 0 018.333 20.5v-4.084a.75.75 0 011.5 0v4.1a.56.56 0 00.515.617h11.136a.559.559 0 00.515-.617V4.082a.558.558 0 00-.515-.582H10.348a.56.56 0 00-.515.617v4.1a.75.75 0 11-1.5 0V4.131A2.06 2.06 0 0110.326 2h11.18z"
    }), $6nuVc.createElement("path", {
        d: "M5.697 8.373a.75.75 0 00-1.06 0l-3.41 3.41a.748.748 0 000 1.075l3.41 3.408a.75.75 0 101.06-1.06L3.56 13.07h12.538a.75.75 0 100-1.5H3.561l2.136-2.136a.75.75 0 000-1.061z"
    }));
});

});

parcelRegister("7yZGb", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $581b8da44d3ed2e7$var$__assign = undefined && undefined.__assign || function() {
    $581b8da44d3ed2e7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $581b8da44d3ed2e7$var$__assign.apply(this, arguments);
};
var $581b8da44d3ed2e7$export$e2c9b76f2918cc76 = $6nuVc.forwardRef(function LogOutBold(props, svgRef) {
    return $6nuVc.createElement("svg", $581b8da44d3ed2e7$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M21.257.75a2.808 2.808 0 012.742 2.894v16.344a2.809 2.809 0 01-2.742 2.894H10.076c-.025 0-.05 0-.075-.002a2.81 2.81 0 01-2.668-2.892V18a1.5 1.5 0 113 0v1.882h10.666V3.75H10.333V5.5a1.5 1.5 0 01-3 0V3.644A2.81 2.81 0 0110.076.75h11.18z"
    }), $6nuVc.createElement("path", {
        d: "M5.977 7.343a1.5 1.5 0 00-2.121 0L.45 10.749a1.5 1.5 0 000 2.142l3.406 3.406a1.5 1.5 0 102.121-2.122l-.856-.855H15.85a1.5 1.5 0 000-3H5.121l.856-.856a1.5 1.5 0 000-2.121z"
    }));
});

});

parcelRegister("jrwtc", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $e279b9cc042b7a6d$var$__assign = undefined && undefined.__assign || function() {
    $e279b9cc042b7a6d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e279b9cc042b7a6d$var$__assign.apply(this, arguments);
};
var $e279b9cc042b7a6d$export$2a4143257785f953 = $6nuVc.forwardRef(function MenuNavigationHorizontal(props, svgRef) {
    return $6nuVc.createElement("svg", $e279b9cc042b7a6d$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M5.5 12a2 2 0 11-4 0 2 2 0 014 0zm8.5 0a2 2 0 11-4 0 2 2 0 014 0zm6.5 2a2 2 0 100-4 2 2 0 000 4z"
    }));
});

});

parcelRegister("lE3Ts", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $fc205a8a46ba4d17$var$__assign = undefined && undefined.__assign || function() {
    $fc205a8a46ba4d17$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fc205a8a46ba4d17$var$__assign.apply(this, arguments);
};
var $fc205a8a46ba4d17$export$e01a035729e5e1c1 = $6nuVc.forwardRef(function MenuNavigationHorizontalBold(props, svgRef) {
    return $6nuVc.createElement("svg", $fc205a8a46ba4d17$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M6.5 12a3 3 0 11-6 0 3 3 0 016 0zm8.5 0a3 3 0 11-6 0 3 3 0 016 0zm5.5 3a3 3 0 100-6 3 3 0 000 6z"
    }));
});

});

parcelRegister("bVq76", function(module, exports) {

$parcel$export(module.exports, "MenuNavigationVertical", function () { return $8ae9462a0b2ff3ed$export$56dbed97f074c6e4; });

var $6nuVc = parcelRequire("6nuVc");
var $8ae9462a0b2ff3ed$var$__assign = undefined && undefined.__assign || function() {
    $8ae9462a0b2ff3ed$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8ae9462a0b2ff3ed$var$__assign.apply(this, arguments);
};
var $8ae9462a0b2ff3ed$export$56dbed97f074c6e4 = $6nuVc.forwardRef(function MenuNavigationVertical(props, svgRef) {
    return $6nuVc.createElement("svg", $8ae9462a0b2ff3ed$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M21.75 16.903a1.1 1.1 0 01.12 2.194l-.12.006H2.25a1.1 1.1 0 01-.12-2.194l.12-.006h19.5zm0-6a1.1 1.1 0 01.12 2.194l-.12.006H2.25a1.1 1.1 0 01-.12-2.194l.12-.006h19.5zm0-6a1.1 1.1 0 01.12 2.194l-.12.006H2.25a1.1 1.1 0 01-.12-2.194l.12-.006h19.5z"
    }));
});

});

parcelRegister("9D6lP", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $702caeca161db536$var$__assign = undefined && undefined.__assign || function() {
    $702caeca161db536$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $702caeca161db536$var$__assign.apply(this, arguments);
};
var $702caeca161db536$export$e738f441fd7fb6d9 = $6nuVc.forwardRef(function MenuNavigationVerticalBold(props, svgRef) {
    return $6nuVc.createElement("svg", $702caeca161db536$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M1 6.5A1.5 1.5 0 012.5 5h19a1.5 1.5 0 010 3h-19A1.5 1.5 0 011 6.5zm0 6A1.5 1.5 0 012.5 11h19a1.5 1.5 0 010 3h-19A1.5 1.5 0 011 12.5zM2.5 17a1.5 1.5 0 000 3h19a1.5 1.5 0 000-3h-19z"
    }));
});

});

parcelRegister("5lMDP", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $3e54a50fdd4f7a5d$var$__assign = undefined && undefined.__assign || function() {
    $3e54a50fdd4f7a5d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3e54a50fdd4f7a5d$var$__assign.apply(this, arguments);
};
var $3e54a50fdd4f7a5d$export$da45d96ed490d127 = $6nuVc.forwardRef(function Minus(props, svgRef) {
    return $6nuVc.createElement("svg", $3e54a50fdd4f7a5d$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M23.913 12a.75.75 0 01-.75.75H.837a.75.75 0 010-1.5h22.326a.75.75 0 01.75.75z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("93esl", function(module, exports) {

$parcel$export(module.exports, "MinusBold", function () { return $696f9b8d49da1f2d$export$b7a01a7ec68fd5c0; });

var $6nuVc = parcelRequire("6nuVc");
var $696f9b8d49da1f2d$var$__assign = undefined && undefined.__assign || function() {
    $696f9b8d49da1f2d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $696f9b8d49da1f2d$var$__assign.apply(this, arguments);
};
var $696f9b8d49da1f2d$export$b7a01a7ec68fd5c0 = $6nuVc.forwardRef(function MinusBold(props, svgRef) {
    return $6nuVc.createElement("svg", $696f9b8d49da1f2d$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M23.935 12a1.5 1.5 0 01-1.5 1.5H1.565a1.5 1.5 0 010-3h20.87a1.5 1.5 0 011.5 1.5z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("kJAGM", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $f1847846c7d2c869$var$__assign = undefined && undefined.__assign || function() {
    $f1847846c7d2c869$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f1847846c7d2c869$var$__assign.apply(this, arguments);
};
var $f1847846c7d2c869$export$e49a5ad3dd6df925 = $6nuVc.forwardRef(function Move(props, svgRef) {
    return $6nuVc.createElement("svg", $f1847846c7d2c869$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M8.47 5.532a.75.75 0 010-1.06l3-3a.75.75 0 011.06 0l3 3a.75.75 0 01-1.06 1.06l-1.72-1.72v7.44h7.44l-1.72-1.72a.75.75 0 011.06-1.06l3 3a.75.75 0 010 1.06l-3 3a.75.75 0 11-1.06-1.06l1.72-1.72h-7.44v7.44l1.72-1.72a.75.75 0 111.06 1.06l-3 3a.75.75 0 01-1.06 0l-3-3a.75.75 0 111.06-1.06l1.72 1.72v-7.44H3.81l1.72 1.72a.75.75 0 11-1.06 1.06l-3-3a.75.75 0 010-1.06l3-3a.75.75 0 011.06 1.06l-1.72 1.72h7.44v-7.44l-1.72 1.72a.75.75 0 01-1.06 0z"
    }));
});

});

parcelRegister("4KTno", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $376669dddf28ccec$var$__assign = undefined && undefined.__assign || function() {
    $376669dddf28ccec$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $376669dddf28ccec$var$__assign.apply(this, arguments);
};
var $376669dddf28ccec$export$a3c5fa6436f5d841 = $6nuVc.forwardRef(function MoveBold(props, svgRef) {
    return $6nuVc.createElement("svg", $376669dddf28ccec$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M7.94 6.06a1.5 1.5 0 010-2.12l3-3a1.5 1.5 0 012.12 0l3 3a1.5 1.5 0 01-2.12 2.12l-.44-.439V10.5h4.879l-.44-.44a1.5 1.5 0 012.122-2.12l3 3a1.5 1.5 0 010 2.12l-3 3a1.5 1.5 0 01-2.122-2.12l.44-.44H13.5v4.879l.44-.44a1.5 1.5 0 012.12 2.122l-3 3a1.5 1.5 0 01-2.12 0l-3-3a1.5 1.5 0 012.12-2.122l.44.44V13.5H5.621l.44.44a1.5 1.5 0 01-2.122 2.12l-3-3a1.5 1.5 0 010-2.12l3-3a1.5 1.5 0 112.122 2.12l-.44.44H10.5V5.621l-.44.44a1.5 1.5 0 01-2.12 0z"
    }));
});

});

parcelRegister("7GojM", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $597f51aeffa6ab85$var$__assign = undefined && undefined.__assign || function() {
    $597f51aeffa6ab85$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $597f51aeffa6ab85$var$__assign.apply(this, arguments);
};
var $597f51aeffa6ab85$export$656559010049c8e = $6nuVc.forwardRef(function Pin(props, svgRef) {
    return $6nuVc.createElement("svg", $597f51aeffa6ab85$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M16.307.125a2.203 2.203 0 00-2.589.895L9.922 6.986a8.1 8.1 0 00-5.446.98l.37.635-.372-.634a2.203 2.203 0 00-.441 3.46l3.5 3.5-7.318 7.318a.734.734 0 001.039 1.038l7.317-7.318 3.502 3.502a2.203 2.203 0 003.46-.44l.002-.003a8.1 8.1 0 00.979-5.445l5.965-3.797a2.204 2.204 0 00.376-3.416l-5.72-5.72a2.202 2.202 0 00-.828-.521zM4.976 9.463a.734.734 0 01.24-.228 6.63 6.63 0 014.882-.713.734.734 0 00.791-.32l4.068-6.393a.735.735 0 011.139-.125l5.72 5.72a.734.734 0 01-.125 1.139l-6.392 4.068a.734.734 0 00-.32.792 6.63 6.63 0 01-.713 4.881.734.734 0 01-1.153.146l-8.042-8.042a.735.735 0 01-.095-.925z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("CkZC2", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $0733d5728c71789b$var$__assign = undefined && undefined.__assign || function() {
    $0733d5728c71789b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0733d5728c71789b$var$__assign.apply(this, arguments);
};
var $0733d5728c71789b$export$88393934ec04748c = $6nuVc.forwardRef(function PinBold(props, svgRef) {
    return $6nuVc.createElement("svg", $0733d5728c71789b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M15.336.013a2.203 2.203 0 011.798.632l5.721 5.721a2.203 2.203 0 01-.376 3.416l-5.965 3.797a8.099 8.099 0 01-.98 5.445v.002a2.203 2.203 0 01-3.46.441L9.09 16.485 2.507 23.07c-.398.399-.969.52-1.472.365a.734.734 0 01-.97-.972 1.468 1.468 0 01.365-1.47l6.584-6.584-2.981-2.981a2.203 2.203 0 01.44-3.46l.373.634-.37-.635a8.1 8.1 0 015.446-.98l3.796-5.966A2.203 2.203 0 0115.336.013z"
    }));
});

});

parcelRegister("5pS09", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $3f192d1829d69957$var$__assign = undefined && undefined.__assign || function() {
    $3f192d1829d69957$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3f192d1829d69957$var$__assign.apply(this, arguments);
};
var $3f192d1829d69957$export$2d9ac7aa84f97a08 = $6nuVc.forwardRef(function Plus(props, svgRef) {
    return $6nuVc.createElement("svg", $3f192d1829d69957$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M12.75 1a.75.75 0 00-1.5 0v10.25H1a.75.75 0 000 1.5h10.25V23a.75.75 0 001.5 0V12.75H23a.75.75 0 000-1.5H12.75V1z"
    }));
});

});

parcelRegister("j7IF3", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $dec15091ba1cf400$var$__assign = undefined && undefined.__assign || function() {
    $dec15091ba1cf400$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dec15091ba1cf400$var$__assign.apply(this, arguments);
};
var $dec15091ba1cf400$export$2ef3672ebfdfd8df = $6nuVc.forwardRef(function PlusBold(props, svgRef) {
    return $6nuVc.createElement("svg", $dec15091ba1cf400$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M13.5 1.565a1.5 1.5 0 00-3 0V10.5H1.565a1.5 1.5 0 000 3H10.5v8.935a1.5 1.5 0 003 0V13.5h8.935a1.5 1.5 0 000-3H13.5V1.565z"
    }));
});

});

parcelRegister("8sr86", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $6285fb9ef5bc3e28$var$__assign = undefined && undefined.__assign || function() {
    $6285fb9ef5bc3e28$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6285fb9ef5bc3e28$var$__assign.apply(this, arguments);
};
var $6285fb9ef5bc3e28$export$531cef85654f2406 = $6nuVc.forwardRef(function Print(props, svgRef) {
    return $6nuVc.createElement("svg", $6285fb9ef5bc3e28$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M3.75 9a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5h-1.5zm3.75 6.75a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM8.25 18a.75.75 0 000 1.5h5.25a.75.75 0 000-1.5H8.25z"
    }), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M4.5 6V2.25A2.25 2.25 0 016.75 0h10.5a2.25 2.25 0 012.25 2.25V6h2.25A2.25 2.25 0 0124 8.25v7.5A2.25 2.25 0 0121.75 18H19.5v5.25a.75.75 0 01-.75.75H5.25a.75.75 0 01-.75-.75V18H2.25A2.25 2.25 0 010 15.75v-7.5A2.25 2.25 0 012.25 6H4.5zm1.72-4.28a.75.75 0 01.53-.22h10.5a.75.75 0 01.75.75V6H6V2.25a.75.75 0 01.22-.53zM2.25 7.5a.75.75 0 00-.75.75v7.5a.75.75 0 00.75.75H4.5v-3.75a.75.75 0 01.75-.75h13.5a.75.75 0 01.75.75v3.75h2.25a.75.75 0 00.75-.75v-7.5a.75.75 0 00-.75-.75H2.25zm15.75 6v9H6v-9h12z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("k6mE4", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $ea25ef117fafa7a5$var$__assign = undefined && undefined.__assign || function() {
    $ea25ef117fafa7a5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ea25ef117fafa7a5$var$__assign.apply(this, arguments);
};
var $ea25ef117fafa7a5$export$3326d4c83d14f416 = $6nuVc.forwardRef(function PrintBold(props, svgRef) {
    return $6nuVc.createElement("svg", $ea25ef117fafa7a5$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M4.5 2.25A2.25 2.25 0 016.75 0h10.5a2.25 2.25 0 012.25 2.25V6h2.25a2.25 2.25 0 012.249 2.25v7.5a2.25 2.25 0 01-2.25 2.25H19.5v5.25a.75.75 0 01-.75.749H5.25a.75.75 0 01-.75-.75V18H2.25A2.25 2.25 0 010 15.75v-7.5A2.25 2.25 0 012.25 6H4.5V2.25zm13 11.25h-11V22h11v-8.5zm0-8V2.25a.25.25 0 00-.25-.25H6.75a.25.25 0 00-.25.25V5.5h11zM2.75 9.75a1 1 0 011-1h1.5a1 1 0 010 2h-1.5a1 1 0 01-1-1z",
        fillRule: "evenodd"
    }), $6nuVc.createElement("path", {
        d: "M8.25 14.75a1 1 0 000 2h7.5a1 1 0 000-2h-7.5zm0 3a1 1 0 100 2h5.25a1 1 0 000-2H8.25z"
    }));
});

});

parcelRegister("8wETY", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $63510a23e2bfbc70$var$__assign = undefined && undefined.__assign || function() {
    $63510a23e2bfbc70$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $63510a23e2bfbc70$var$__assign.apply(this, arguments);
};
var $63510a23e2bfbc70$export$f93ec6528f706bfe = $6nuVc.forwardRef(function Refresh(props, svgRef) {
    return $6nuVc.createElement("svg", $63510a23e2bfbc70$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M19.378 10.056a.746.746 0 00-.825.159l-2.667 2.667a.75.75 0 001.06 1.06l1.368-1.367a6.583 6.583 0 01-11.352 4.02.75.75 0 10-1.09 1.03 8.084 8.084 0 0013.948-5.082l1.4 1.4a.75.75 0 001.06-1.061l-2.664-2.664a.763.763 0 00-.238-.162zm-11.7.811a.776.776 0 00-1.092 0l-1.39 1.398v-.2c0-1.397.397-2.695 1.191-3.793.795-1.099 1.887-1.897 3.178-2.396 1.291-.5 2.681-.5 3.973-.2 1.29.4 2.482 1.098 3.277 2.196.298.3.695.4 1.092.1.298-.3.397-.699.1-1.098-1.093-1.298-2.483-2.196-4.072-2.596-1.59-.399-3.277-.399-4.866.2a8.206 8.206 0 00-3.873 2.995c-.993 1.398-1.49 2.995-1.49 4.592v.2l-1.39-1.398a.776.776 0 00-1.093 0 .786.786 0 000 1.098l2.682 2.696c.099.1.298.2.496.2.199 0 .397-.1.497-.2l2.681-2.695c.397-.3.397-.8.1-1.099z"
    }));
});

});

parcelRegister("15VHu", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $0cc304333fcbeff5$var$__assign = undefined && undefined.__assign || function() {
    $0cc304333fcbeff5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0cc304333fcbeff5$var$__assign.apply(this, arguments);
};
var $0cc304333fcbeff5$export$af5e85d717d10540 = $6nuVc.forwardRef(function RefreshBold(props, svgRef) {
    return $6nuVc.createElement("svg", $0cc304333fcbeff5$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M14.339 3.815a8.834 8.834 0 00-11.044 7.02l-.234-.234a1.5 1.5 0 10-2.122 2.122l2.617 2.616a1.496 1.496 0 002.224-.002l2.614-2.614a1.5 1.5 0 00-1.905-2.301 5.833 5.833 0 018.995-2.767 1.5 1.5 0 101.792-2.406 8.832 8.832 0 00-2.937-1.434zm5.625 5.819a1.495 1.495 0 00-1.157-.044 1.495 1.495 0 00-.534.345L15.606 12.6a1.5 1.5 0 001.534 2.485 5.825 5.825 0 01-2.986 2.663 5.833 5.833 0 01-5.336-.532 1.5 1.5 0 10-1.636 2.514 8.833 8.833 0 0013.41-5.355l.347.347a1.5 1.5 0 102.122-2.122l-2.656-2.655a1.495 1.495 0 00-.44-.312z"
    }));
});

});

parcelRegister("krfIP", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $ee128651cbc9e05c$var$__assign = undefined && undefined.__assign || function() {
    $ee128651cbc9e05c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ee128651cbc9e05c$var$__assign.apply(this, arguments);
};
var $ee128651cbc9e05c$export$6d3b1b9014d6cc79 = $6nuVc.forwardRef(function Retract(props, svgRef) {
    return $6nuVc.createElement("svg", $ee128651cbc9e05c$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M23.026 2.526a.75.75 0 10-1.06-1.06l-7.22 7.22v-4.69a.75.75 0 10-1.5 0v6.5a.747.747 0 00.75.75h6.5a.75.75 0 100-1.5h-4.69l7.22-7.22zm-12.53 18.448a.75.75 0 01-.75-.75v-4.69l-7.22 7.22a.75.75 0 11-1.06-1.06l7.22-7.22h-4.69a.75.75 0 010-1.5h6.5a.747.747 0 01.75.75v6.5a.75.75 0 01-.75.75z"
    }));
});

});

parcelRegister("28R9A", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $18f58f56a1e2c7cb$var$__assign = undefined && undefined.__assign || function() {
    $18f58f56a1e2c7cb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $18f58f56a1e2c7cb$var$__assign.apply(this, arguments);
};
var $18f58f56a1e2c7cb$export$9515f4411b0668 = $6nuVc.forwardRef(function RetractBold(props, svgRef) {
    return $6nuVc.createElement("svg", $18f58f56a1e2c7cb$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M23.56 3.06A1.5 1.5 0 0021.44.94L15.5 6.878V4a1.5 1.5 0 00-3 0v6.5a1.494 1.494 0 00.859 1.357c.194.092.412.143.641.143h6.5a1.5 1.5 0 000-3h-2.879l5.94-5.94zM10.5 21.728a1.5 1.5 0 01-1.5-1.5v-2.879l-5.94 5.94a1.5 1.5 0 11-2.12-2.122l5.939-5.939H4a1.5 1.5 0 010-3h6.5a1.494 1.494 0 011.374.896c.08.185.126.39.126.604v6.5a1.5 1.5 0 01-1.5 1.5z"
    }));
});

});

parcelRegister("17RmW", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $0d1fd7da8588b07a$var$__assign = undefined && undefined.__assign || function() {
    $0d1fd7da8588b07a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0d1fd7da8588b07a$var$__assign.apply(this, arguments);
};
var $0d1fd7da8588b07a$export$b204c8549f010cd = $6nuVc.forwardRef(function RotateLeft(props, svgRef) {
    return $6nuVc.createElement("svg", $0d1fd7da8588b07a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M1 1.75a.75.75 0 011.5 0v4.714a10.997 10.997 0 119.497 16.53.75.75 0 010-1.5A9.497 9.497 0 103.47 7.832h5.11a.75.75 0 010 1.5h-6.2a.745.745 0 01-.077 0H1.75a.75.75 0 01-.75-.75V1.75z"
    }));
});

});

parcelRegister("awQrI", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $01fa69999fc3e840$var$__assign = undefined && undefined.__assign || function() {
    $01fa69999fc3e840$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $01fa69999fc3e840$var$__assign.apply(this, arguments);
};
var $01fa69999fc3e840$export$7257def152302e45 = $6nuVc.forwardRef(function RotateLeftBold(props, svgRef) {
    return $6nuVc.createElement("svg", $01fa69999fc3e840$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M0 2a1.5 1.5 0 113 0v2.414a11.746 11.746 0 118.746 19.58 1.5 1.5 0 01.002-3 8.747 8.747 0 10-7.23-13.663h3.813a1.5 1.5 0 110 3H2.152a1.2 1.2 0 01-.12 0H1.5a1.5 1.5 0 01-1.5-1.5V2z"
    }));
});

});

parcelRegister("aYdLh", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $7fca2ec44536a12a$var$__assign = undefined && undefined.__assign || function() {
    $7fca2ec44536a12a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7fca2ec44536a12a$var$__assign.apply(this, arguments);
};
var $7fca2ec44536a12a$export$75099d76a78789f = $6nuVc.forwardRef(function RotateRight(props, svgRef) {
    return $6nuVc.createElement("svg", $7fca2ec44536a12a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M23.257 2.002a.75.75 0 00-1.5 0v4.714a10.999 10.999 0 00-18.484-.813 10.997 10.997 0 008.987 17.343.75.75 0 100-1.5 9.496 9.496 0 118.528-13.663h-5.113a.75.75 0 000 1.5h6.2a.744.744 0 00.078 0h.554a.75.75 0 00.75-.75V2.002z"
    }));
});

});

parcelRegister("eXfhl", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $ae326d6af442818c$var$__assign = undefined && undefined.__assign || function() {
    $ae326d6af442818c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ae326d6af442818c$var$__assign.apply(this, arguments);
};
var $ae326d6af442818c$export$1d157cf51c63a935 = $6nuVc.forwardRef(function RotateRightBold(props, svgRef) {
    return $6nuVc.createElement("svg", $ae326d6af442818c$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M24 2a1.5 1.5 0 00-3 0v2.414A11.75 11.75 0 007.576 1.47a11.747 11.747 0 004.678 22.525 1.5 1.5 0 00-.002-3 8.747 8.747 0 117.23-13.664h-3.813a1.5 1.5 0 000 3h6.179c.04.002.08.002.12 0h.532a1.5 1.5 0 001.5-1.5V2z"
    }));
});

});

parcelRegister("7aUwF", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $5395506e5b1f5a45$var$__assign = undefined && undefined.__assign || function() {
    $5395506e5b1f5a45$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5395506e5b1f5a45$var$__assign.apply(this, arguments);
};
var $5395506e5b1f5a45$export$4b85d3515bd863a5 = $6nuVc.forwardRef(function Search(props, svgRef) {
    return $6nuVc.createElement("svg", $5395506e5b1f5a45$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M10 1.25a8.75 8.75 0 105.634 15.445l5.836 5.835a.75.75 0 001.06-1.06l-5.835-5.836A8.75 8.75 0 0010 1.25zM2.75 10a7.25 7.25 0 1114.5 0 7.25 7.25 0 01-14.5 0z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("3btuf", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $251945a58e82e14b$var$__assign = undefined && undefined.__assign || function() {
    $251945a58e82e14b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $251945a58e82e14b$var$__assign.apply(this, arguments);
};
var $251945a58e82e14b$export$8278256c54fb93b2 = $6nuVc.forwardRef(function SearchBold(props, svgRef) {
    return $6nuVc.createElement("svg", $251945a58e82e14b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M10 .5a9.5 9.5 0 100 19c2.082 0 4.008-.67 5.573-1.806l5.366 5.367a1.5 1.5 0 002.122-2.122l-5.367-5.366A9.458 9.458 0 0019.5 10 9.5 9.5 0 0010 .5zM3.5 10a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("5ZQ9I", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $45db1b4897b7068d$var$__assign = undefined && undefined.__assign || function() {
    $45db1b4897b7068d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $45db1b4897b7068d$var$__assign.apply(this, arguments);
};
var $45db1b4897b7068d$export$ef9b1a59e592288f = $6nuVc.forwardRef(function Select(props, svgRef) {
    return $6nuVc.createElement("svg", $45db1b4897b7068d$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M18.608 24H9.983c-.191 0-.479-.096-.575-.288l-3.737-4.887c-.575-.767-.575-1.725-.096-2.492.67-.958 2.013-1.245 3.067-.575 0 0 .096 0 .096.096l.479.384v-8.05c0-1.15.958-2.109 2.204-2.109 1.246 0 2.204.958 2.204 2.109v5.175l3.45.766c1.725.383 2.97 2.013 2.78 3.833l-.48 5.367c0 .383-.383.671-.767.671zm-8.241-1.438h7.57l.384-4.695c.096-1.055-.671-2.109-1.725-2.3l-4.025-.863c-.288-.096-.575-.383-.575-.67v-5.75c0-.384-.288-.767-.671-.767-.287 0-.575.287-.575.67v9.296c0 .288-.192.48-.383.671-.288.096-.575.096-.767-.096l-1.63-1.245c-.382-.192-.766-.096-1.053.191-.192.288-.192.575 0 .863l3.45 4.695zm1.15-17.92a.756.756 0 01-.767-.767V1.767c0-.48.287-.767.767-.767.479 0 .766.288.766.767v2.108c-.095.383-.383.767-.766.767zm2.779.671a.732.732 0 01-.48-.192.752.752 0 010-1.054l1.438-1.438a.752.752 0 011.054 0 .752.752 0 010 1.054l-1.437 1.438c-.192.096-.383.191-.575.191zm-5.654 0a.732.732 0 01-.48-.192L6.63 3.683a.752.752 0 010-1.054.752.752 0 011.054 0l1.438 1.438a.752.752 0 010 1.054c-.192.096-.383.191-.48.191zm8.528 2.204h-2.108a.756.756 0 01-.766-.767c0-.48.287-.767.767-.767h2.108c.383 0 .767.288.767.767 0 .48-.288.767-.767.767zm-9.295 0H5.767A.756.756 0 015 6.75c0-.383.287-.767.767-.767h2.108c.383 0 .767.288.767.767 0 .48-.384.767-.767.767z"
    }));
});

});

parcelRegister("3xjhl", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $293368827073cee3$var$__assign = undefined && undefined.__assign || function() {
    $293368827073cee3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $293368827073cee3$var$__assign.apply(this, arguments);
};
var $293368827073cee3$export$603458ca8a362063 = $6nuVc.forwardRef(function SelectBold(props, svgRef) {
    return $6nuVc.createElement("svg", $293368827073cee3$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M11.517.75c-.29 0-.551.088-.74.277-.19.189-.277.45-.277.74v2.108c0 .5.38 1.017 1.017 1.017.28 0 .51-.142.675-.321a1.49 1.49 0 00.334-.635l.007-.03v-2.14c0-.289-.088-.55-.276-.74-.19-.188-.45-.276-.74-.276zM7.86 2.452a1.002 1.002 0 00-1.408 0 1.002 1.002 0 000 1.408L7.99 5.3c.14.14.392.263.653.263a.56.56 0 00.16-.028c.047-.014.095-.033.142-.053.09-.038.192-.09.285-.136l.04-.02.029-.028a1.002 1.002 0 000-1.408L7.86 2.452zm7.217 0a1.002 1.002 0 011.408 0 1.002 1.002 0 010 1.408L15.02 5.326l-.058.03c-.175.087-.413.207-.665.207a.98.98 0 01-.656-.265 1.002 1.002 0 010-1.408l1.437-1.438zm-9.31 3.281c-.638 0-1.017.517-1.017 1.017 0 .5.38 1.017 1.017 1.017h2.108c.5 0 1.017-.38 1.017-1.017 0-.637-.517-1.017-1.017-1.017H5.767zm8.556.277c.189-.189.45-.277.74-.277h2.108c.5 0 1.017.38 1.017 1.017 0 .29-.088.55-.277.74-.19.189-.45.277-.74.277h-2.108c-.501 0-1.017-.38-1.017-1.017 0-.29.088-.55.277-.74zM9.983 24h8.625c.384 0 .767-.288.767-.67l.48-5.367c.19-1.821-1.055-3.45-2.78-3.834l-3.45-.766V8.188c0-1.15-.958-2.109-2.204-2.109-1.246 0-2.204.958-2.204 2.109v8.05l-.48-.384c0-.096-.095-.096-.095-.096-1.054-.67-2.396-.383-3.067.575-.48.767-.48 1.725.096 2.492l3.737 4.887c.096.192.384.288.575.288z"
    }));
});

});

parcelRegister("it9Xk", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $d722a873c5f1d5c6$var$__assign = undefined && undefined.__assign || function() {
    $d722a873c5f1d5c6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d722a873c5f1d5c6$var$__assign.apply(this, arguments);
};
var $d722a873c5f1d5c6$export$c72f6eaae7b9adff = $6nuVc.forwardRef(function Settings(props, svgRef) {
    return $6nuVc.createElement("svg", $d722a873c5f1d5c6$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M12 7.25a4.75 4.75 0 100 9.5 4.75 4.75 0 000-9.5zM8.75 12a3.25 3.25 0 116.5 0 3.25 3.25 0 01-6.5 0z",
        fillRule: "evenodd"
    }), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M20.581 6.954l.611-.61a1.5 1.5 0 000-2.122l-1.415-1.413a1.5 1.5 0 00-2.121 0l-.612.612c-.418.417-1.059.498-1.604.272-.545-.227-.94-.736-.94-1.327V1.5A1.5 1.5 0 0013 0h-2a1.5 1.5 0 00-1.5 1.5v.866c0 .59-.395 1.1-.94 1.327-.546.227-1.187.145-1.605-.272l-.612-.612a1.5 1.5 0 00-2.121 0L2.807 4.223a1.5 1.5 0 000 2.122l.612.611c.418.418.499 1.059.272 1.604-.226.545-.735.94-1.325.94H1.5A1.5 1.5 0 000 11v2a1.5 1.5 0 001.5 1.5h.865c.59 0 1.1.395 1.327.94.226.546.145 1.187-.273 1.605l-.613.613a1.5 1.5 0 000 2.121l1.414 1.414a1.545 1.545 0 002.122 0l.611-.61c.419-.42 1.06-.5 1.606-.273.546.226.941.737.941 1.328v.862A1.5 1.5 0 0011 24h2a1.5 1.5 0 001.5-1.5v-.863c0-.59.395-1.1.94-1.327.546-.227 1.187-.145 1.605.272l.612.612a1.5 1.5 0 002.121 0l1.414-1.414a1.5 1.5 0 000-2.121l-.611-.611c-.418-.418-.5-1.059-.273-1.605.227-.546.737-.941 1.328-.941h.864A1.5 1.5 0 0024 13v-2a1.5 1.5 0 00-1.5-1.5h-.865c-.59 0-1.1-.395-1.327-.94-.226-.547-.145-1.188.273-1.606zM18.717 3.87l1.415 1.413-.61.61c-.914.913-1.02 2.224-.6 3.24C19.343 10.15 20.346 11 21.635 11h.865v2.002h-.864c-1.29 0-2.293.852-2.713 1.866-.421 1.016-.316 2.328.597 3.24l.611.611-1.413 1.414-.613-.612c-.913-.912-2.224-1.018-3.24-.597C13.85 19.346 13 20.348 13 21.637v.863h-2v-.863c0-1.289-.85-2.291-1.866-2.713-1.016-.422-2.328-.316-3.24.597l-.587.585a.045.045 0 01-.052 0l-1.388-1.388.613-.613c.913-.913 1.018-2.224.597-3.24C4.657 13.852 3.655 13 2.365 13H1.5v-2h.866c1.29 0 2.29-.85 2.71-1.865.422-1.015.317-2.327-.597-3.24l-.612-.611L5.282 3.87l.613.612c.912.912 2.224 1.018 3.24.597C10.15 4.657 11 3.655 11 2.366V1.5h2v.866c0 1.29.85 2.291 1.865 2.712 1.015.421 2.326.316 3.239-.596l.613-.612z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("h4beO", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $c6cb87021fa02281$var$__assign = undefined && undefined.__assign || function() {
    $c6cb87021fa02281$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c6cb87021fa02281$var$__assign.apply(this, arguments);
};
var $c6cb87021fa02281$export$18e4ef42d74628e8 = $6nuVc.forwardRef(function SettingsBold(props, svgRef) {
    return $6nuVc.createElement("svg", $c6cb87021fa02281$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M20.581 6.954l.611-.61a1.5 1.5 0 000-2.122l-1.415-1.413a1.5 1.5 0 00-2.121 0l-.612.612c-.418.417-1.059.498-1.604.272-.545-.227-.94-.736-.94-1.327V1.5A1.5 1.5 0 0013 0h-2a1.5 1.5 0 00-1.5 1.5v.866c0 .59-.395 1.1-.94 1.327-.546.227-1.187.145-1.605-.272l-.612-.612a1.5 1.5 0 00-2.121 0L2.807 4.223a1.5 1.5 0 000 2.122l.612.611c.418.418.499 1.059.272 1.604-.226.545-.735.94-1.325.94H1.5A1.5 1.5 0 000 11v2a1.5 1.5 0 001.5 1.5h.865c.59 0 1.1.395 1.327.94.226.546.145 1.187-.273 1.605l-.613.613a1.5 1.5 0 000 2.121l1.414 1.414a1.545 1.545 0 002.122 0l.611-.61c.419-.42 1.06-.5 1.606-.273.546.226.941.737.941 1.328v.862A1.5 1.5 0 0011 24h2a1.5 1.5 0 001.5-1.5v-.863c0-.59.395-1.1.94-1.327.546-.227 1.187-.145 1.605.272l.612.612a1.5 1.5 0 002.121 0l1.414-1.414a1.5 1.5 0 000-2.121l-.611-.611c-.418-.418-.5-1.059-.273-1.605.227-.546.737-.941 1.328-.941h.864A1.5 1.5 0 0024 13v-2a1.5 1.5 0 00-1.5-1.5h-.865c-.59 0-1.1-.395-1.327-.94-.226-.547-.145-1.188.273-1.606zM12 16a4 4 0 100-8 4 4 0 000 8z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("jkAmp", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $e12c1700dc231d28$var$__assign = undefined && undefined.__assign || function() {
    $e12c1700dc231d28$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e12c1700dc231d28$var$__assign.apply(this, arguments);
};
var $e12c1700dc231d28$export$c9915453de10000b = $6nuVc.forwardRef(function Share(props, svgRef) {
    return $6nuVc.createElement("svg", $e12c1700dc231d28$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M6.15 9.5a.65.65 0 00-.65.65v11.2a.65.65 0 00.65.65h12.6a.65.65 0 00.65-.65v-11.2a.65.65 0 00-.65-.65h-1.4a.75.75 0 010-1.5h1.4a2.15 2.15 0 012.15 2.15v11.2a2.15 2.15 0 01-2.15 2.15H6.15A2.15 2.15 0 014 21.35v-11.2A2.15 2.15 0 016.15 8h1.4a.75.75 0 010 1.5h-1.4z",
        fillRule: "evenodd"
    }), $6nuVc.createElement("path", {
        d: "M11.92 1.22a.748.748 0 011.06 0l3.5 3.5a.75.75 0 01-1.06 1.06L13.2 3.56v7.99a.75.75 0 01-1.5 0V3.56L9.48 5.78a.75.75 0 01-1.06-1.06l3.5-3.5z"
    }));
});

});

parcelRegister("4YedF", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $39e7cbb434dc1de9$var$__assign = undefined && undefined.__assign || function() {
    $39e7cbb434dc1de9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $39e7cbb434dc1de9$var$__assign.apply(this, arguments);
};
var $39e7cbb434dc1de9$export$4781d373f2233cee = $6nuVc.forwardRef(function ShareBold(props, svgRef) {
    return $6nuVc.createElement("svg", $39e7cbb434dc1de9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M5.5 10h1.3a1.5 1.5 0 100-3H5.4a2.9 2.9 0 00-2.9 2.9v11.2A2.9 2.9 0 005.4 24H18a2.9 2.9 0 002.9-2.9V9.9A2.9 2.9 0 0018 7h-1.4a1.5 1.5 0 000 3h1.3v11H5.5V10z",
        fillRule: "evenodd"
    }), $6nuVc.createElement("path", {
        d: "M10.623.456a1.495 1.495 0 011.553-.379c.214.071.415.192.585.362l3.5 3.5a1.5 1.5 0 01-2.121 2.122l-.94-.94V11.3a1.5 1.5 0 01-3 0V5.122l-.94.939a1.5 1.5 0 01-2.12-2.122L10.623.456z"
    }));
});

});

parcelRegister("cc6CS", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $8e0bbece41c9f013$var$__assign = undefined && undefined.__assign || function() {
    $8e0bbece41c9f013$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8e0bbece41c9f013$var$__assign.apply(this, arguments);
};
var $8e0bbece41c9f013$export$4a37ae897f9e8014 = $6nuVc.forwardRef(function StatusError(props, svgRef) {
    return $6nuVc.createElement("svg", $8e0bbece41c9f013$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M17.03 6.97a.75.75 0 010 1.06L13.06 12l3.97 3.97a.75.75 0 11-1.06 1.06L12 13.06l-3.97 3.97a.75.75 0 01-1.06-1.06L10.94 12 6.97 8.03a.75.75 0 011.06-1.06L12 10.94l3.97-3.97a.75.75 0 011.06 0z"
    }), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-1.5 0c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("hnDQe", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $ca737d5020a194cb$var$__assign = undefined && undefined.__assign || function() {
    $ca737d5020a194cb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ca737d5020a194cb$var$__assign.apply(this, arguments);
};
var $ca737d5020a194cb$export$750f42de29e1826b = $6nuVc.forwardRef(function StatusErrorBold(props, svgRef) {
    return $6nuVc.createElement("svg", $ca737d5020a194cb$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm5.56-17.56a1.5 1.5 0 010 2.12L14.122 12l3.44 3.44a1.5 1.5 0 01-2.122 2.12L12 14.122l-3.44 3.44a1.5 1.5 0 01-2.12-2.122L9.878 12l-3.44-3.44A1.5 1.5 0 118.56 6.44L12 9.878l3.44-3.44a1.5 1.5 0 012.12 0z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("gH1Me", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $c2720a56118ceab0$var$__assign = undefined && undefined.__assign || function() {
    $c2720a56118ceab0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c2720a56118ceab0$var$__assign.apply(this, arguments);
};
var $c2720a56118ceab0$export$e0c13b137c9285c0 = $6nuVc.forwardRef(function StatusHelp(props, svgRef) {
    return $6nuVc.createElement("svg", $c2720a56118ceab0$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M12.825 14.11h-1.32a2.008 2.008 0 01-.198-.868c0-.986.73-1.676 1.577-2.425.986-.927 1.538-1.46 1.538-2.425 0-1.184-.867-1.992-1.932-1.992-1.005 0-1.814.631-2.208 1.893L9 7.761C9.513 6.006 10.794 5 12.53 5 14.442 5 16 6.36 16 8.293c0 1.321-.769 2.208-1.873 3.194-.868.79-1.4 1.282-1.4 1.992 0 .203.043.391.08.552l.018.079zm.69 3.096c0 .73-.571 1.242-1.261 1.242a1.237 1.237 0 01-1.243-1.242c0-.73.592-1.243 1.243-1.243.69 0 1.261.513 1.261 1.243z"
    }), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M0 12C0 5.383 5.383 0 12 0s12 5.383 12 12-5.383 12-12 12S0 18.617 0 12zm1.509 0c0 5.777 4.697 10.491 10.491 10.491S22.491 17.777 22.491 12c0-5.777-4.697-10.491-10.491-10.491S1.509 6.223 1.509 12z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("10H68", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $0bc738e61c89c949$var$__assign = undefined && undefined.__assign || function() {
    $0bc738e61c89c949$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0bc738e61c89c949$var$__assign.apply(this, arguments);
};
var $0bc738e61c89c949$export$493d925eb43dfdfe = $6nuVc.forwardRef(function StatusHelpBold(props, svgRef) {
    return $6nuVc.createElement("svg", $0bc738e61c89c949$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M0 12C0 5.383 5.383 0 12 0s12 5.383 12 12-5.383 12-12 12S0 18.617 0 12zm12.934 1.731h-2.315a2.457 2.457 0 01-.223-.975c0-.812.61-1.502 1.604-2.294.832-.69 1.198-1.056 1.198-1.706 0-.73-.569-1.238-1.28-1.238-.75 0-1.299.528-1.684 1.543L8 8.086C8.589 6.016 10.091 5 12 5c2.213 0 4 1.401 4 3.553 0 1.198-.569 1.99-1.685 2.965l-.218.189c-.7.608-1.204 1.044-1.204 1.598 0 .162.02.304.041.426zM13.746 17c0 1.076-.812 1.888-1.888 1.888-1.097 0-1.909-.812-1.909-1.888 0-1.056.812-1.888 1.909-1.888A1.86 1.86 0 0113.746 17z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("9HAvd", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $710471d200f3584a$var$__assign = undefined && undefined.__assign || function() {
    $710471d200f3584a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $710471d200f3584a$var$__assign.apply(this, arguments);
};
var $710471d200f3584a$export$390e0440e6f2b300 = $6nuVc.forwardRef(function StatusInformation(props, svgRef) {
    return $6nuVc.createElement("svg", $710471d200f3584a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M3.515 3.515a12 12 0 1116.97 16.97 12 12 0 01-16.97-16.97zM12 1.5a10.5 10.5 0 100 21 10.5 10.5 0 000-21z",
        fillRule: "evenodd"
    }), $6nuVc.createElement("path", {
        d: "M12.044 7.016a1.01 1.01 0 001.026-1.008C13.07 5.45 12.602 5 12.044 5 11.468 5 11 5.45 11 6.008c0 .576.468 1.008 1.044 1.008zm-.702 11.106h1.386V9.356h-1.386v8.766z"
    }));
});

});

parcelRegister("eQFwL", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $acf6227d0c3b9ac9$var$__assign = undefined && undefined.__assign || function() {
    $acf6227d0c3b9ac9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $acf6227d0c3b9ac9$var$__assign.apply(this, arguments);
};
var $acf6227d0c3b9ac9$export$d8874184141c994a = $6nuVc.forwardRef(function StatusInformationBold(props, svgRef) {
    return $6nuVc.createElement("svg", $acf6227d0c3b9ac9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M12 0a12 12 0 100 24 12 12 0 000-24zm1.57 6.008c0 .87-.71 1.508-1.526 1.508-.829 0-1.544-.633-1.544-1.508 0-.851.71-1.508 1.544-1.508.823 0 1.526.662 1.526 1.508zm-2.728 12.614V9.4h2.386v9.222h-2.386z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("4UoNU", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $392fa1eed7ebe4c5$var$__assign = undefined && undefined.__assign || function() {
    $392fa1eed7ebe4c5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $392fa1eed7ebe4c5$var$__assign.apply(this, arguments);
};
var $392fa1eed7ebe4c5$export$785e45f1d8c03432 = $6nuVc.forwardRef(function StatusSuccess(props, svgRef) {
    return $6nuVc.createElement("svg", $392fa1eed7ebe4c5$var$__assign({
        fill: "currentColor",
        height: 25,
        ref: svgRef,
        viewBox: "0 0 24 25",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M18.53 8.531a.75.75 0 00-1.06-1.06L9 15.94l-3.47-3.47a.75.75 0 00-1.06 1.06l4 4a.75.75 0 001.06 0l9-9z"
    }), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12 12-5.373 12-12zM1.5 12C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12 17.799 22.5 12 22.5 1.5 17.799 1.5 12z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("gzyMK", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $c10ae5da647174e1$var$__assign = undefined && undefined.__assign || function() {
    $c10ae5da647174e1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c10ae5da647174e1$var$__assign.apply(this, arguments);
};
var $c10ae5da647174e1$export$17e1460061865da = $6nuVc.forwardRef(function StatusSuccessBold(props, svgRef) {
    return $6nuVc.createElement("svg", $c10ae5da647174e1$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-4.94-2.94a1.5 1.5 0 00-2.12-2.12L9 14.878l-2.94-2.94a1.5 1.5 0 00-2.12 2.122l4 4a1.5 1.5 0 002.12 0l9-9z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("cRG1G", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $95db08cdd936be7f$var$__assign = undefined && undefined.__assign || function() {
    $95db08cdd936be7f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $95db08cdd936be7f$var$__assign.apply(this, arguments);
};
var $95db08cdd936be7f$export$a2518b5310db22ab = $6nuVc.forwardRef(function StatusWarning(props, svgRef) {
    return $6nuVc.createElement("svg", $95db08cdd936be7f$var$__assign({
        fill: "currentColor",
        height: 25,
        ref: svgRef,
        viewBox: "0 0 24 25",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M23.75 20.727L14.289 1.424C13.98.807 13.466.344 12.815.138a2.576 2.576 0 00-1.954.12 2.56 2.56 0 00-1.166 1.166L.23 20.727a2.272 2.272 0 001.028 3.034c.31.154.652.24.995.24H21.71a2.26 2.26 0 002.263-2.263 2.037 2.037 0 00-.223-1.011zm-1.49 1.543a.793.793 0 01-.55.223H2.255a.791.791 0 01-.703-1.114l9.497-19.287c.103-.205.274-.377.48-.48a1.14 1.14 0 01.463-.102c.394 0 .771.222.943.582l9.48 19.303a.781.781 0 01.085.343c-.017.206-.085.395-.24.532z"
    }), $6nuVc.createElement("path", {
        d: "M11.558 16.119h1.152l.252-8.118h-1.674l.27 8.118zm.576 3.96c.63 0 1.134-.468 1.134-1.134 0-.666-.504-1.134-1.134-1.134-.612 0-1.134.468-1.134 1.134 0 .666.522 1.134 1.134 1.134z"
    }));
});

});

parcelRegister("kT4Ic", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $f34c9961e5c31f5e$var$__assign = undefined && undefined.__assign || function() {
    $f34c9961e5c31f5e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f34c9961e5c31f5e$var$__assign.apply(this, arguments);
};
var $f34c9961e5c31f5e$export$f1b6053a528b50d9 = $6nuVc.forwardRef(function StatusWarningBold(props, svgRef) {
    return $6nuVc.createElement("svg", $f34c9961e5c31f5e$var$__assign({
        fill: "currentColor",
        height: 25,
        ref: svgRef,
        viewBox: "0 0 24 25",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M14.297 1.424l9.463 19.303c.154.308.24.651.223 1.011a2.26 2.26 0 01-2.263 2.263H2.263c-.343 0-.686-.086-.994-.24a2.272 2.272 0 01-1.03-3.034L9.704 1.424A2.56 2.56 0 0110.868.258a2.576 2.576 0 011.955-.12c.651.206 1.165.669 1.474 1.286zm-1.263 14.352h-2.046l-.483-7.775h2.994l-.465 7.775zm.726 2.995c0 .986-.744 1.73-1.711 1.73-1.024 0-1.749-.744-1.749-1.73 0-.967.725-1.73 1.749-1.73.967 0 1.71.763 1.71 1.73z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("4HD4x", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $36c97c7da7507525$var$__assign = undefined && undefined.__assign || function() {
    $36c97c7da7507525$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $36c97c7da7507525$var$__assign.apply(this, arguments);
};
var $36c97c7da7507525$export$e16de4ea1abb52c8 = $6nuVc.forwardRef(function Stopwatch(props, svgRef) {
    return $6nuVc.createElement("svg", $36c97c7da7507525$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M8.807 10.346a.75.75 0 00-1.114 1.006l3.75 4.15a.75.75 0 001.114-1.005l-3.75-4.15z"
    }), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M14.25 1.5h-1.5v3.029a9.751 9.751 0 015.18 1.981l.907-.908a.75.75 0 011.193-.882l.375.375.375.375a.75.75 0 01-.882 1.193l-.85.85a9.75 9.75 0 11-7.798-2.984V1.5h-1.5a.75.75 0 010-1.5h4.5a.75.75 0 010 1.5zM12 6a8.25 8.25 0 100 16.5A8.25 8.25 0 0012 6z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("cjvGq", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $8f6fd6081f953f2b$var$__assign = undefined && undefined.__assign || function() {
    $8f6fd6081f953f2b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8f6fd6081f953f2b$var$__assign.apply(this, arguments);
};
var $8f6fd6081f953f2b$export$da6e25dd6239a135 = $6nuVc.forwardRef(function StopwatchBold(props, svgRef) {
    return $6nuVc.createElement("svg", $8f6fd6081f953f2b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M13.5 1.5h.75a.75.75 0 000-1.5h-4.5a.75.75 0 000 1.5h.75v3.116a9.75 9.75 0 108.901 3.287l1.32-1.319a.75.75 0 00.06-1.115l-.75-.75a.75.75 0 00-1.11.054l-1.424 1.424a9.755 9.755 0 00-3.997-1.58V1.5zM7.395 12.395l3.307 3.307c.484.484 1.351.402 1.937-.184.586-.586.668-1.453.184-1.938l-3.307-3.306c-.484-.484-1.351-.402-1.937.184-.586.586-.668 1.453-.184 1.937z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("Y32oB", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $0b47f5ec7987c17a$var$__assign = undefined && undefined.__assign || function() {
    $0b47f5ec7987c17a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0b47f5ec7987c17a$var$__assign.apply(this, arguments);
};
var $0b47f5ec7987c17a$export$616b2c96b9b691e = $6nuVc.forwardRef(function SupportChat(props, svgRef) {
    return $6nuVc.createElement("svg", $0b47f5ec7987c17a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M12.5 2.438a7.188 7.188 0 00-7.152 6.469 1.438 1.438 0 011.402 1.437v7.187a1.438 1.438 0 01-1.438 1.438h-.718A3.594 3.594 0 011 15.375V12.5a3.594 3.594 0 012.9-3.526 8.625 8.625 0 0117.2 0A3.593 3.593 0 0124 12.5v2.875a3.594 3.594 0 01-2.875 3.521v.073a3.593 3.593 0 01-3.594 3.593h-1.56A2.156 2.156 0 0113.936 24H12.5a2.157 2.157 0 010-4.313h1.438a2.156 2.156 0 012.032 1.438h1.561a2.157 2.157 0 002.157-2.156 1.438 1.438 0 01-1.438-1.438v-7.187a1.438 1.438 0 011.401-1.437 7.187 7.187 0 00-7.151-6.47zm1.946 18.898a.719.719 0 01-.508 1.227H12.5a.719.719 0 110-1.438h1.438c.19 0 .373.076.508.21zm5.96-3.805a2.156 2.156 0 002.157-2.156V12.5a2.157 2.157 0 00-2.157-2.156h-.718v7.187h.718zM3.07 10.975a2.156 2.156 0 011.525-.631h.718v7.187h-.718a2.156 2.156 0 01-2.157-2.156V12.5c0-.572.228-1.12.632-1.525z",
        fillRule: "evenodd"
    }), $6nuVc.createElement("path", {
        d: "M10.11 15.267a.719.719 0 00-.97 1.063 4.987 4.987 0 006.72 0 .719.719 0 00-.97-1.063 3.55 3.55 0 01-4.78 0zM9.625 9.85a.72.72 0 01.719.719v1.257a.719.719 0 01-1.438 0V10.57a.72.72 0 01.719-.719zm6.469.719a.719.719 0 10-1.438 0v1.257a.719.719 0 001.438 0V10.57z"
    }));
});

});

parcelRegister("7PpVm", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $5b3167d2bd24d76f$var$__assign = undefined && undefined.__assign || function() {
    $5b3167d2bd24d76f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5b3167d2bd24d76f$var$__assign.apply(this, arguments);
};
var $5b3167d2bd24d76f$export$9c6a6487c263eb9c = $6nuVc.forwardRef(function SupportChatBold(props, svgRef) {
    return $6nuVc.createElement("svg", $5b3167d2bd24d76f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M10.986.044a9 9 0 019.838 8.002 3.969 3.969 0 012.926 3.829v2.875a3.969 3.969 0 01-2.881 3.817 3.969 3.969 0 01-3.963 3.745h-1.31a2.528 2.528 0 01-2.284 1.438h-1.437a2.531 2.531 0 010-5.063h1.438a2.531 2.531 0 012.282 1.438h1.311a1.782 1.782 0 001.75-1.452 1.813 1.813 0 01-1.406-1.767V9.72a1.813 1.813 0 011.358-1.755 6.813 6.813 0 00-13.466 0A1.812 1.812 0 016.5 9.72v7.187a1.812 1.812 0 01-1.813 1.813H3.97A3.969 3.969 0 010 14.75v-2.875a3.969 3.969 0 012.926-3.83 9 9 0 018.06-8.001z"
    }), $6nuVc.createElement("path", {
        d: "M13.656 9.944a1.094 1.094 0 012.188 0v1.257a1.094 1.094 0 11-2.188 0V9.944zm-5.464 4.493a1.094 1.094 0 011.545-.072 3.175 3.175 0 004.276 0 1.094 1.094 0 111.474 1.617 5.362 5.362 0 01-7.224 0 1.094 1.094 0 01-.071-1.545zM9 8.85c-.604 0-1.094.49-1.094 1.094v1.257a1.094 1.094 0 102.188 0V9.944c0-.604-.49-1.094-1.094-1.094z"
    }));
});

});

parcelRegister("kuec5", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $eea19e983be4f37f$var$__assign = undefined && undefined.__assign || function() {
    $eea19e983be4f37f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $eea19e983be4f37f$var$__assign.apply(this, arguments);
};
var $eea19e983be4f37f$export$3288d34c523a1192 = $6nuVc.forwardRef(function Tag(props, svgRef) {
    return $6nuVc.createElement("svg", $eea19e983be4f37f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M18 3.75a2.25 2.25 0 110 4.499 2.25 2.25 0 010-4.499zm.287 1.557a.75.75 0 10-.574 1.386.75.75 0 00.574-1.386z",
        fillRule: "evenodd"
    }), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M21.75 0A2.25 2.25 0 0124 2.25v6.257a3.75 3.75 0 01-1.098 2.651L11.342 22.72a2.25 2.25 0 01-3.182 0l-6.88-6.88a2.25 2.25 0 010-3.181L12.843 1.097A3.75 3.75 0 0115.493 0h6.257zm.53 1.72a.75.75 0 00-.53-.22h-6.257a2.25 2.25 0 00-1.59.658L2.34 13.72a.75.75 0 000 1.06l6.88 6.88a.75.75 0 001.06 0l11.56-11.561a2.25 2.25 0 00.659-1.591V2.25a.75.75 0 00-.22-.53z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("f9sUo", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $b07e1ee635a91b13$var$__assign = undefined && undefined.__assign || function() {
    $b07e1ee635a91b13$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b07e1ee635a91b13$var$__assign.apply(this, arguments);
};
var $b07e1ee635a91b13$export$eb1b14be98724170 = $6nuVc.forwardRef(function TagBold(props, svgRef) {
    return $6nuVc.createElement("svg", $b07e1ee635a91b13$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M21.966.373a2.25 2.25 0 00-.527-.063h-6.257a3.752 3.752 0 00-2.65 1.098L.97 12.968a2.25 2.25 0 000 3.182l6.879 6.88a2.25 2.25 0 003.182 0l11.56-11.562a3.753 3.753 0 001.098-2.65V2.56A2.25 2.25 0 0021.966.373z"
    }));
});

});

parcelRegister("eIP1V", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $ab7cc246c1c285be$var$__assign = undefined && undefined.__assign || function() {
    $ab7cc246c1c285be$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ab7cc246c1c285be$var$__assign.apply(this, arguments);
};
var $ab7cc246c1c285be$export$680ea196effce5f = $6nuVc.forwardRef(function Time(props, svgRef) {
    return $6nuVc.createElement("svg", $ab7cc246c1c285be$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M12 7.5a.75.75 0 01.75.75v3.44l4.467 4.468a.75.75 0 01-1.06 1.06L11.47 12.53a.748.748 0 01-.22-.53V8.25A.75.75 0 0112 7.5z"
    }), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M4.045 4.045a11.25 11.25 0 1115.91 15.91 11.25 11.25 0 01-15.91-15.91zM12 2.25a9.75 9.75 0 100 19.5 9.75 9.75 0 000-19.5z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("88Soy", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $5ed943ca67ea60e3$var$__assign = undefined && undefined.__assign || function() {
    $5ed943ca67ea60e3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5ed943ca67ea60e3$var$__assign.apply(this, arguments);
};
var $5ed943ca67ea60e3$export$cef7b1bbd85670df = $6nuVc.forwardRef(function TimeBold(props, svgRef) {
    return $6nuVc.createElement("svg", $5ed943ca67ea60e3$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M12 .75a11.25 11.25 0 100 22.5 11.25 11.25 0 000-22.5zM13.5 8a1.5 1.5 0 00-3 0v4.621l4.94 4.94a1.5 1.5 0 002.12-2.122l-4.06-4.06V8z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("7MRJh", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $5ab6b1a36be044f2$var$__assign = undefined && undefined.__assign || function() {
    $5ab6b1a36be044f2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5ab6b1a36be044f2$var$__assign.apply(this, arguments);
};
var $5ab6b1a36be044f2$export$a818bbe058f189e = $6nuVc.forwardRef(function Unlock(props, svgRef) {
    return $6nuVc.createElement("svg", $5ab6b1a36be044f2$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M15 14.25a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0v-3a.75.75 0 01.75-.75z"
    }), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M3.818 3.818A4.5 4.5 0 0111.5 7v2H6.75a.75.75 0 00-.75.75v13.5c0 .414.336.75.75.75h16.5a.75.75 0 00.75-.75V9.75a.75.75 0 00-.75-.75H13V7A6 6 0 101 7v2.25a.75.75 0 001.5 0V7a4.5 4.5 0 011.318-3.182zM22.5 10.5h-15v12h15v-12z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("8uuhf", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $62e89c83c822d350$var$__assign = undefined && undefined.__assign || function() {
    $62e89c83c822d350$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $62e89c83c822d350$var$__assign.apply(this, arguments);
};
var $62e89c83c822d350$export$cc1b5dff9a340610 = $6nuVc.forwardRef(function UnlockBold(props, svgRef) {
    return $6nuVc.createElement("svg", $62e89c83c822d350$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M2.492 2.492A6.375 6.375 0 0113.375 7v2h9.875a.75.75 0 01.75.75v13.5a.75.75 0 01-.75.75H6.75a.75.75 0 01-.75-.75V9.75A.75.75 0 016.75 9h4.375V7a4.125 4.125 0 00-8.25 0v2.25a1.125 1.125 0 01-2.25 0V7a6.38 6.38 0 011.867-4.508zM15 13.875c-.621 0-1.125.504-1.125 1.125v3a1.125 1.125 0 002.25 0v-3c0-.621-.504-1.125-1.125-1.125z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("iOUtg", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $db38b37a1797ae6c$var$__assign = undefined && undefined.__assign || function() {
    $db38b37a1797ae6c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $db38b37a1797ae6c$var$__assign.apply(this, arguments);
};
var $db38b37a1797ae6c$export$67fadca628676d83 = $6nuVc.forwardRef(function ViewHide(props, svgRef) {
    return $6nuVc.createElement("svg", $db38b37a1797ae6c$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M22.072 2.23a.75.75 0 01-.021 1.061l-18.75 18a.75.75 0 11-1.039-1.082l18.75-18a.75.75 0 011.06.022zm-2.929 5.958a.75.75 0 011.047-.164c1.156.843 2.223 1.8 3.187 2.858l.003.003a2.413 2.413 0 010 3.23l-.003.002C20.758 17 16.412 20.07 11.995 20a10.734 10.734 0 01-3.255-.483.75.75 0 01.445-1.432 9.236 9.236 0 002.826.415c3.779.064 7.744-2.627 10.255-5.39a.914.914 0 000-1.22 19.816 19.816 0 00-2.96-2.654.75.75 0 01-.163-1.048zM12 5c.874-.009 1.745.093 2.592.304a.75.75 0 01-.362 1.456 8.799 8.799 0 00-2.244-.26c-3.713-.062-7.69 2.57-10.252 5.388a.913.913 0 000 1.22c.767.84 1.605 1.613 2.503 2.31a.75.75 0 01-.92 1.185 21.553 21.553 0 01-2.693-2.486l-.004-.004a2.413 2.413 0 010-3.23l.002-.002C3.3 7.935 7.655 4.932 12 5z",
        fillRule: "evenodd"
    }), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M11.998 9.5a3 3 0 00-3 3 .75.75 0 01-1.5 0 4.499 4.499 0 014.5-4.5.75.75 0 010 1.5zm3.75 2.249a.75.75 0 01.75.75 4.502 4.502 0 01-4.5 4.501.75.75 0 110-1.5 3 3 0 003-3 .75.75 0 01.75-.751z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("2Oy1L", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $20caa56cfcce2e50$var$__assign = undefined && undefined.__assign || function() {
    $20caa56cfcce2e50$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $20caa56cfcce2e50$var$__assign.apply(this, arguments);
};
var $20caa56cfcce2e50$export$639d2a0e5f6e1492 = $6nuVc.forwardRef(function ViewHideBold(props, svgRef) {
    return $6nuVc.createElement("svg", $20caa56cfcce2e50$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M2.967 19.978a1.365 1.365 0 00-.028 1.83 1.145 1.145 0 001.702.027l3.342-3.485c1.275.553 2.57.873 3.827.9h.31c3.597.065 7.577-2.369 10.525-5.858a2.54 2.54 0 00.002-3.219 19.969 19.969 0 00-3.61-3.35l2.973-3.1c.477-.498.49-1.318.028-1.83a1.145 1.145 0 00-1.702-.027L2.967 19.978zm12.253-9.175l-4.118 4.294a3.03 3.03 0 001.007.171c1.79 0 3.24-1.56 3.24-3.485 0-.34-.045-.669-.13-.98z",
        fillRule: "evenodd"
    }), $6nuVc.createElement("path", {
        d: "M12.109 8.298c.304 0 .598.045.878.13l3.126-3.26c-1.231-.521-2.475-.822-3.677-.851l-.315-.001C8.529 4.25 4.527 6.677 1.576 10.17a2.54 2.54 0 00-.002 3.218 20.048 20.048 0 003.506 3.283l3.883-4.049a3.744 3.744 0 01-.095-.84c0-1.925 1.451-3.485 3.24-3.485z"
    }));
});

});

parcelRegister("3BoV0", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $29f8281384fd2efb$var$__assign = undefined && undefined.__assign || function() {
    $29f8281384fd2efb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $29f8281384fd2efb$var$__assign.apply(this, arguments);
};
var $29f8281384fd2efb$export$153f7030970dae8f = $6nuVc.forwardRef(function ViewShow(props, svgRef) {
    return $6nuVc.createElement("svg", $29f8281384fd2efb$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M23.383 10.337c-2.606-2.863-6.909-5.88-11.246-5.88H12c-4.389-.068-8.76 3-11.383 5.88a2.435 2.435 0 000 3.24c2.589 2.863 6.892 5.88 11.229 5.88h.274c4.337 0 8.64-3.034 11.246-5.88.84-.926.84-2.314.017-3.24zm-1.114 2.229c-2.383 2.623-6.275 5.4-10.115 5.4H12c-3.891.051-7.851-2.743-10.251-5.383a.916.916 0 010-1.217c3.6-3.995 7.56-5.4 10.131-5.4h.137c2.554-.052 6.583 1.354 10.252 5.383a.916.916 0 010 1.217z"
    }), $6nuVc.createElement("path", {
        d: "M12 7.457c-2.486 0-4.509 2.023-4.509 4.492 0 1.2.463 2.331 1.32 3.188A4.444 4.444 0 0012 16.457c2.486 0 4.491-2.023 4.509-4.491 0-1.2-.463-2.332-1.32-3.189A4.474 4.474 0 0012 7.457zm3 4.509a2.981 2.981 0 01-3 3 2.981 2.981 0 01-3-3c0-1.646 1.354-3 3-3a2.981 2.981 0 013 3z"
    }));
});

});

parcelRegister("55SbO", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $3b57744d6364a12b$var$__assign = undefined && undefined.__assign || function() {
    $3b57744d6364a12b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3b57744d6364a12b$var$__assign.apply(this, arguments);
};
var $3b57744d6364a12b$export$6d39d2f2d511d9a3 = $6nuVc.forwardRef(function ViewShowBold(props, svgRef) {
    return $6nuVc.createElement("svg", $3b57744d6364a12b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M12.436 4.502h-.315c-3.592-.066-7.594 2.36-10.545 5.854a2.54 2.54 0 00-.002 3.219c2.863 3.392 6.7 5.786 10.236 5.86h.31c3.597.066 7.577-2.368 10.525-5.858a2.54 2.54 0 00.002-3.218C19.79 6.98 15.935 4.586 12.436 4.502zm-.327 10.952c1.79 0 3.24-1.56 3.24-3.485 0-1.925-1.45-3.486-3.24-3.486-1.79 0-3.24 1.56-3.24 3.486 0 1.925 1.45 3.485 3.24 3.485z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("7VXdF", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $5c6bcb0165e56c99$var$__assign = undefined && undefined.__assign || function() {
    $5c6bcb0165e56c99$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c6bcb0165e56c99$var$__assign.apply(this, arguments);
};
var $5c6bcb0165e56c99$export$d13069184bfa0730 = $6nuVc.forwardRef(function ZoomIn(props, svgRef) {
    return $6nuVc.createElement("svg", $5c6bcb0165e56c99$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M10.056 1a9.056 9.056 0 017.072 14.713l5.58 5.58a1 1 0 01-1.321 1.498l-.094-.084-5.58-5.58A9.056 9.056 0 1110.056 1zm0 2a7.056 7.056 0 100 14.112 7.056 7.056 0 000-14.112z"
    }), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M10 6.833c.368 0 .666.299.666.667v1.834H12.5a.666.666 0 110 1.332h-1.834V12.5a.666.666 0 11-1.332 0v-1.834H7.5a.666.666 0 110-1.332h1.834V7.5c0-.368.298-.667.666-.667z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("9X6UE", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $73eefc7b35c90bf2$var$__assign = undefined && undefined.__assign || function() {
    $73eefc7b35c90bf2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $73eefc7b35c90bf2$var$__assign.apply(this, arguments);
};
var $73eefc7b35c90bf2$export$52a27ea68a20ff47 = $6nuVc.forwardRef(function ZoomInBold(props, svgRef) {
    return $6nuVc.createElement("svg", $73eefc7b35c90bf2$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M10 .5a9.5 9.5 0 100 19c2.082 0 4.008-.67 5.573-1.806l5.366 5.367a1.5 1.5 0 002.122-2.122l-5.367-5.366A9.458 9.458 0 0019.5 10 9.5 9.5 0 0010 .5zM3.5 10a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z",
        fillRule: "evenodd"
    }), $6nuVc.createElement("path", {
        d: "M10 6.75a.916.916 0 00-.916.917V9.25H7.5a.916.916 0 100 1.833h1.584v1.583a.916.916 0 101.832 0v-1.583H12.5a.916.916 0 100-1.833h-1.584V7.667A.916.916 0 0010 6.75z"
    }));
});

});

parcelRegister("18WtU", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $0d53e702bd5136c7$var$__assign = undefined && undefined.__assign || function() {
    $0d53e702bd5136c7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0d53e702bd5136c7$var$__assign.apply(this, arguments);
};
var $0d53e702bd5136c7$export$adc4acb67269225 = $6nuVc.forwardRef(function ZoomOut(props, svgRef) {
    return $6nuVc.createElement("svg", $0d53e702bd5136c7$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        d: "M7.5 9.334a.666.666 0 100 1.332h5a.666.666 0 100-1.332h-5z"
    }), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M19.112 10.056a9.056 9.056 0 10-3.399 7.072l5.58 5.58.094.083a1 1 0 001.32-1.498l-5.579-5.58a9.018 9.018 0 001.984-5.657zM3 10.056a7.056 7.056 0 1114.112 0 7.056 7.056 0 01-14.112 0z",
        fillRule: "evenodd"
    }));
});

});

parcelRegister("liH2S", function(module, exports) {

var $6nuVc = parcelRequire("6nuVc");
var $f81cab5493b4f51e$var$__assign = undefined && undefined.__assign || function() {
    $f81cab5493b4f51e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f81cab5493b4f51e$var$__assign.apply(this, arguments);
};
var $f81cab5493b4f51e$export$d875a145579e27ff = $6nuVc.forwardRef(function ZoomOutBold(props, svgRef) {
    return $6nuVc.createElement("svg", $f81cab5493b4f51e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M10 .5a9.5 9.5 0 100 19c2.082 0 4.008-.67 5.573-1.806l5.366 5.367a1.5 1.5 0 002.122-2.122l-5.367-5.366A9.458 9.458 0 0019.5 10 9.5 9.5 0 0010 .5zM3.5 10a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z",
        fillRule: "evenodd"
    }), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M6.833 10c0-.368.299-.666.667-.666h5a.666.666 0 110 1.332h-5A.666.666 0 016.833 10z",
        fillRule: "evenodd"
    }), $6nuVc.createElement("path", {
        clipRule: "evenodd",
        d: "M6.583 10c0-.506.41-.916.917-.916h5a.916.916 0 110 1.832h-5A.916.916 0 016.583 10zm.917-.416a.416.416 0 100 .832h5a.417.417 0 000-.832h-5z",
        fillRule: "evenodd"
    }));
});

});


parcelRegister("9IydS", function(module, exports) {

$parcel$export(module.exports, "makeAccordionHeaderId", function () { return $7132c50b25a3f931$export$8b88dfb72c256495; });
$parcel$export(module.exports, "makeAccordionPanelId", function () { return $7132c50b25a3f931$export$9df4f6ac67762779; });
var $7132c50b25a3f931$export$8b88dfb72c256495 = function(id, index) {
    return id + "-accordion-header-" + index;
};
var $7132c50b25a3f931$export$9df4f6ac67762779 = function(id, index) {
    return id + "-accordion-panel-" + index;
};

});




parcelRegister("1D9yS", function(module, exports) {
parcelRequire("1F5ta");

});
parcelRegister("1F5ta", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $9xnlp = parcelRequire("9xnlp");

var $jSjHZ = parcelRequire("jSjHZ");

var $cnj3u = parcelRequire("cnj3u");
var $135ddce370157531$var$__assign = undefined && undefined.__assign || function() {
    $135ddce370157531$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $135ddce370157531$var$__assign.apply(this, arguments);
};
var $135ddce370157531$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $135ddce370157531$export$dabcc1ec9dd9d1cc = function(_a) {
    var _b;
    var children = _a.children, _c = _a.size, size = _c === void 0 ? 'medium' : _c, props = $135ddce370157531$var$__rest(_a, [
        "children",
        "size"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    /**
     * TODO: Add automatic dropdown addition class to an item.
     * ! ASSUMPTION: a <Breadcrumb> element that contains 6 <Breadcrumb.Item> elements will collapse
     * ! the 3rd, 4th and 5th element in one cloned <Breadcrumb.Item> with `...` as text and a
     * ! dropdown generated from the 3rd, 4th and 5th item.
     * ? we need to know whether this should be with responsiveness
     * ? we need to know whether this is simple like f.ex pagination
     */ var className = cn('breadcrumb', (_b = {}, _b["is-" + size] = size, _b));
    var validChildren = (0, $jLRsx.getValidChildren)(children);
    var validChildrenCount = validChildren.length;
    return $a5EUy.createElement("nav", $135ddce370157531$var$__assign({
        "aria-label": "breadcrumb",
        className: className,
        role: "presentation"
    }, props), $a5EUy.createElement("ol", null, validChildren.map(function(child, index) {
        return $a5EUy.cloneElement(child, {
            isLastItem: validChildrenCount === index + 1
        });
    })));
};
$135ddce370157531$export$dabcc1ec9dd9d1cc.Item = (0, $9xnlp.BreadcrumbItem);
$135ddce370157531$export$dabcc1ec9dd9d1cc.Link = (0, $jSjHZ.BreadcrumbLink);
$135ddce370157531$export$dabcc1ec9dd9d1cc.Separator = (0, $cnj3u.BreadcrumbSeparator);

});
parcelRegister("9xnlp", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbItem", function () { return $6f194dcc4aa4bdba$export$c13f210c706eb549; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $cnj3u = parcelRequire("cnj3u");
var $6f194dcc4aa4bdba$var$__assign = undefined && undefined.__assign || function() {
    $6f194dcc4aa4bdba$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6f194dcc4aa4bdba$var$__assign.apply(this, arguments);
};
var $6f194dcc4aa4bdba$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6f194dcc4aa4bdba$export$c13f210c706eb549 = $a5EUy.forwardRef(function BreadcrumbItem(_a, ref) {
    var children = _a.children, hasDropdown = _a.hasDropdown, isActive = _a.isActive, isLastItem = _a.isLastItem, props = $6f194dcc4aa4bdba$var$__rest(_a, [
        "children",
        "hasDropdown",
        "isActive",
        "isLastItem"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var className = cn('breadcrumb-item', {
        'is-current': isActive,
        'has-dropdown': hasDropdown
    });
    var validChildren = (0, $jLRsx.getValidChildren)(children);
    var validChildrenCount = validChildren.length;
    return $a5EUy.createElement("li", $6f194dcc4aa4bdba$var$__assign({
        className: className,
        ref: ref
    }, props), validChildren.map(function(child, index) {
        return $a5EUy.cloneElement(child, {
            isActive: isActive,
            isLastChild: validChildrenCount === index + 1
        });
    }), !isLastItem && $a5EUy.createElement((0, $cnj3u.BreadcrumbSeparator), null));
});
$6f194dcc4aa4bdba$export$c13f210c706eb549.displayName = 'Breadcrumb.Item';

});
parcelRegister("cnj3u", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbSeparator", function () { return $90266a05cd864224$export$10bb7d797ee5079f; });
parcelRequire("2cnsK");
var $i7Ag6 = parcelRequire("i7Ag6");

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $90266a05cd864224$var$__assign = undefined && undefined.__assign || function() {
    $90266a05cd864224$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $90266a05cd864224$var$__assign.apply(this, arguments);
};
var $90266a05cd864224$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $90266a05cd864224$export$10bb7d797ee5079f = $a5EUy.forwardRef(function BreadcrumbSeparator(_a, ref) {
    var props = $90266a05cd864224$var$__rest(_a, []);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var className = cn('icon', 'breadcrumb-separator');
    return $a5EUy.createElement("span", $90266a05cd864224$var$__assign({
        className: className,
        ref: ref,
        role: "presentation"
    }, props), $a5EUy.createElement((0, $i7Ag6.ArrowRightBold), null));
});
$90266a05cd864224$export$10bb7d797ee5079f.displayName = 'Breadcrumb.Separator';

});


parcelRegister("jSjHZ", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbLink", function () { return $e782592a8dd6f037$export$ca871f5ef145e138; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $e782592a8dd6f037$var$__assign = undefined && undefined.__assign || function() {
    $e782592a8dd6f037$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e782592a8dd6f037$var$__assign.apply(this, arguments);
};
var $e782592a8dd6f037$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e782592a8dd6f037$export$ca871f5ef145e138 = $a5EUy.forwardRef(function BreadcrumbLink(_a, ref) {
    var children = _a.children, isActive = _a.isActive, props = $e782592a8dd6f037$var$__rest(_a, [
        "children",
        "isActive"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var className = cn('breadcrumb-link');
    var commonProps = $e782592a8dd6f037$var$__assign({
        ref: ref,
        className: className
    }, props);
    return $a5EUy.createElement("a", $e782592a8dd6f037$var$__assign({}, isActive ? {
        'aria-current': 'page'
    } : {}, {
        href: "#"
    }, commonProps), children);
});
$e782592a8dd6f037$export$ca871f5ef145e138.displayName = 'Breadcrumb.Link';

});



parcelRegister("3nbTL", function(module, exports) {
$parcel$export(module.exports, "Button", function () { return (parcelRequire("gdpIa")).Button; });
parcelRequire("gdpIa");
parcelRequire("eaDTl");

});
parcelRegister("gdpIa", function(module, exports) {

$parcel$export(module.exports, "Button", function () { return $bce1cdf9c002ab6c$export$353f5b6fc5456de1; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
parcelRequire("kbxqT");
var $70aOe = parcelRequire("70aOe");
parcelRequire("f1RE8");
var $5FQ7r = parcelRequire("5FQ7r");
var $fogwr = parcelRequire("fogwr");

var $eaDTl = parcelRequire("eaDTl");
var $bce1cdf9c002ab6c$var$__assign = undefined && undefined.__assign || function() {
    $bce1cdf9c002ab6c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bce1cdf9c002ab6c$var$__assign.apply(this, arguments);
};
var $bce1cdf9c002ab6c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bce1cdf9c002ab6c$export$353f5b6fc5456de1 = (0, $5FQ7r.forwardRefAs)(function(_a, ref) {
    var _b, _c;
    var _d = _a.as, as = _d === void 0 ? 'button' : _d, label = _a.label, iconPosition = _a.iconPosition, icon = _a.icon, isReverse = _a.isReverse, variant = _a.variant, size = _a.size, state = _a.state, props = $bce1cdf9c002ab6c$var$__rest(_a, [
        "as",
        "label",
        "iconPosition",
        "icon",
        "isReverse",
        "variant",
        "size",
        "state"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var aria = $bce1cdf9c002ab6c$var$__rest((0, $eaDTl.useButton)($bce1cdf9c002ab6c$var$__assign({
        as: as,
        label: label
    }, props)), []);
    var children = $a5EUy.useMemo(function() {
        if (!icon && label) return $a5EUy.createElement("span", null, label);
        var buttonIcon = $a5EUy.createElement((0, $70aOe.Icon), {
            "aria-hidden": true,
            icon: icon
        });
        if (!label && icon) return buttonIcon;
        return $a5EUy.createElement($a5EUy.Fragment, null, (!iconPosition || iconPosition === 'left') && buttonIcon, label !== null && label !== void 0 ? label : $a5EUy.createElement("span", null, label), iconPosition && iconPosition === 'right' && buttonIcon);
    }, [
        icon,
        label,
        iconPosition
    ]);
    var className = cn('button', $bce1cdf9c002ab6c$var$__assign((_b = {
        'is-reverse': isReverse,
        'is-icon-only': !label && icon ? true : false
    }, _b["is-" + (variant ? variant : '')] = variant, _b["is-" + size] = size, _b), state && (_c = {}, _c["is-" + state] = state, _c)));
    return $a5EUy.createElement((0, $fogwr.Polymorph), $bce1cdf9c002ab6c$var$__assign({
        as: as
    }, aria, {
        className: className,
        ref: ref
    }), children);
});

});
parcelRegister("kbxqT", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("70aOe")).Icon; });
parcelRequire("70aOe");

});
parcelRegister("70aOe", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $5190eafae50225f7$export$f04a61298a47a40f; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
parcelRequire("f1RE8");
var $5FQ7r = parcelRequire("5FQ7r");
var $fogwr = parcelRequire("fogwr");
var $5190eafae50225f7$var$__assign = undefined && undefined.__assign || function() {
    $5190eafae50225f7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5190eafae50225f7$var$__assign.apply(this, arguments);
};
var $5190eafae50225f7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5190eafae50225f7$export$f04a61298a47a40f = (0, $5FQ7r.forwardRefAs)(function Icon(_a, ref) {
    var _b;
    var icon = _a.icon, _c = _a.as, as = _c === void 0 ? 'span' : _c, _d = _a.parentClass, parentClass = _d === void 0 ? '' : _d, props = $5190eafae50225f7$var$__rest(_a, [
        "icon",
        "as",
        "parentClass"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement((0, $fogwr.Polymorph), $5190eafae50225f7$var$__assign({
        as: as
    }, props, {
        className: cn('icon', (_b = {}, _b[parentClass] = parentClass, _b)),
        ref: ref
    }), icon);
});

});
parcelRegister("f1RE8", function(module, exports) {
$parcel$export(module.exports, "forwardRefAs", function () { return (parcelRequire("5FQ7r")).forwardRefAs; });
$parcel$export(module.exports, "Polymorph", function () { return (parcelRequire("fogwr")).Polymorph; });
parcelRequire("5FQ7r");
parcelRequire("fogwr");
parcelRequire("5DO3l");

});
parcelRegister("5FQ7r", function(module, exports) {

$parcel$export(module.exports, "forwardRefAs", function () { return $421935d3f2552db9$export$8477fce780cb2224; });
/* eslint-disable @typescript-eslint/naming-convention */ /* eslint-disable func-style */ 
var $a5EUy = parcelRequire("a5EUy");
function $421935d3f2552db9$export$8477fce780cb2224(render) {
    var forward = $a5EUy.forwardRef(render);
    return forward;
}

});

parcelRegister("fogwr", function(module, exports) {

$parcel$export(module.exports, "Polymorph", function () { return $b345e9e79aeefeae$export$ed0c65eec41bee08; });

var $a5EUy = parcelRequire("a5EUy");

var $5FQ7r = parcelRequire("5FQ7r");
var $b345e9e79aeefeae$var$__assign = undefined && undefined.__assign || function() {
    $b345e9e79aeefeae$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b345e9e79aeefeae$var$__assign.apply(this, arguments);
};
var $b345e9e79aeefeae$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b345e9e79aeefeae$var$defaultElement = 'div';
var $b345e9e79aeefeae$export$ed0c65eec41bee08 = (0, $5FQ7r.forwardRefAs)(function(_a, ref) {
    var _b = _a.as, as = _b === void 0 ? $b345e9e79aeefeae$var$defaultElement : _b, children = _a.children, props = $b345e9e79aeefeae$var$__rest(_a, [
        "as",
        "children"
    ]);
    return $a5EUy.createElement(as, $b345e9e79aeefeae$var$__assign({
        ref: ref
    }, props), children);
});

});

parcelRegister("5DO3l", function(module, exports) {
// Utilities
// These types are relied upon by the forwardRefAs functin and Polymorph component
// NOTE: Please don't modify these types without asserting that the typying tests
// are still functioning
// parts of this code is based on https://github.com/kripod/react-polymorphic-box/blob/main/src/Box.tsx

});




parcelRegister("eaDTl", function(module, exports) {

$parcel$export(module.exports, "useButton", function () { return $02a990483b2df1d4$export$ea18c227d4417cc3; });

var $a5EUy = parcelRequire("a5EUy");
var $02a990483b2df1d4$var$__assign = undefined && undefined.__assign || function() {
    $02a990483b2df1d4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $02a990483b2df1d4$var$__assign.apply(this, arguments);
};
var $02a990483b2df1d4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $02a990483b2df1d4$var$ButtonElements = [
    'button',
    'input',
    'a'
];
var $02a990483b2df1d4$export$ea18c227d4417cc3 = function(_a) {
    var as = _a.as, isDisabled = _a.isDisabled, label = _a.label, props = $02a990483b2df1d4$var$__rest(_a, [
        "as",
        "isDisabled",
        "label"
    ]);
    $a5EUy.useEffect(function() {
        if ($02a990483b2df1d4$var$ButtonElements.indexOf(as)) throw Error("invalid component type " + $02a990483b2df1d4$var$ButtonElements.toString());
    }, [
        as
    ]);
    return $02a990483b2df1d4$var$__assign({
        role: 'button',
        tabIndex: isDisabled ? -1 : 0,
        'aria-disabled': isDisabled,
        'aria-label': label
    }, props);
};

});



parcelRegister("nFZzD", function(module, exports) {
parcelRequire("grt9U");

});
parcelRegister("grt9U", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $9i3GX = parcelRequire("9i3GX");
var $0316cd91bceb66d5$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $0316cd91bceb66d5$export$2bcaf2ecc9612e8f = function(_a) {
    var _b;
    var children = _a.children, _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.isFullWidth, isFullWidth = _d === void 0 ? false : _d, onChange = _a.onChange, initialActiveButton = _a.initialActiveButton;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var _e = $0316cd91bceb66d5$var$__read($a5EUy.useState(initialActiveButton), 2), activeButton = _e[0], setActiveButton = _e[1];
    var validChildren = (0, $jLRsx.getValidChildren)(children);
    var className = cn('button-toggle', (_b = {}, _b["is-" + size] = size, _b["is-fullwidth"] = isFullWidth, _b));
    return $a5EUy.createElement("div", {
        className: className
    }, validChildren.map(function(child, index) {
        return $a5EUy.cloneElement(child, {
            index: index,
            onClick: function() {
                setActiveButton(index);
                onChange === null || onChange === void 0 || onChange(index);
            },
            isSelected: index === activeButton
        });
    }));
};
$0316cd91bceb66d5$export$2bcaf2ecc9612e8f.Item = (0, $9i3GX.ButtonToggleItem);

});
parcelRegister("9i3GX", function(module, exports) {

$parcel$export(module.exports, "ButtonToggleItem", function () { return $6c38a89dcaa6b818$export$3e2eed2f68e1214c; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $6c38a89dcaa6b818$var$__assign = undefined && undefined.__assign || function() {
    $6c38a89dcaa6b818$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6c38a89dcaa6b818$var$__assign.apply(this, arguments);
};
var $6c38a89dcaa6b818$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6c38a89dcaa6b818$export$3e2eed2f68e1214c = $a5EUy.forwardRef(function ButtonToggleItem(_a, ref) {
    var _b;
    var isSelected = _a.isSelected, isFocus = _a.isFocus, isDisabled = _a.isDisabled, label = _a.label, icon = _a.icon, _c = _a.iconPosition, iconPosition = _c === void 0 ? 'left' : _c, _d = _a.iconSize, iconSize = _d === void 0 ? 'medium' : _d, props = $6c38a89dcaa6b818$var$__rest(_a, [
        "isSelected",
        "isFocus",
        "isDisabled",
        "label",
        "icon",
        "iconPosition",
        "iconSize"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var iconOnly = icon && !label;
    var iconElement = $a5EUy.createElement("span", {
        className: cn('icon')
    }, icon);
    var className = cn('button-toggle-item', (_b = {
        'is-selected': isSelected,
        'is-focus': isFocus,
        'is-disabled': isDisabled,
        'is-icon-only': iconOnly
    }, _b["is-icon-" + iconSize] = iconSize, _b));
    return $a5EUy.createElement("button", $6c38a89dcaa6b818$var$__assign({
        className: className,
        disabled: isDisabled,
        ref: ref
    }, props), // eslint-disable-next-line no-null/no-null
    icon ? iconPosition === 'left' && iconElement : null, label && $a5EUy.createElement("span", {
        className: cn('button-toggle-text')
    }, label), // eslint-disable-next-line no-null/no-null
    icon ? iconPosition === 'right' && iconElement : null);
});
$6c38a89dcaa6b818$export$3e2eed2f68e1214c.displayName = 'ButtonToggle.Item';

});



parcelRegister("7ATQm", function(module, exports) {
parcelRequire("8Kawo");

});
parcelRegister("8Kawo", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $gvAnh = parcelRequire("gvAnh");

var $ibxyf = parcelRequire("ibxyf");

var $29BJw = parcelRequire("29BJw");

var $hNn4O = parcelRequire("hNn4O");

var $1HBEk = parcelRequire("1HBEk");

var $jWOE4 = parcelRequire("jWOE4");

var $itHXC = parcelRequire("itHXC");

var $jP5MY = parcelRequire("jP5MY");

var $4yVeq = parcelRequire("4yVeq");

var $g0yjr = parcelRequire("g0yjr");

var $b3pDp = parcelRequire("b3pDp");

var $h20xF = parcelRequire("h20xF");

var $4DXtE = parcelRequire("4DXtE");

var $98s8j = parcelRequire("98s8j");
var $65dac7f6f07c9dac$export$60332b2344f7fe41 = function(_a) {
    var children = _a.children, isCompact = _a.isCompact, isLandscape = _a.isLandscape;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var className = cn('card', {
        'is-compact': isCompact,
        'is-landscape': isLandscape
    });
    return $a5EUy.createElement("div", {
        className: className
    }, children);
};
$65dac7f6f07c9dac$export$60332b2344f7fe41.Action = (0, $gvAnh.CardAction);
$65dac7f6f07c9dac$export$60332b2344f7fe41.Actions = (0, $ibxyf.CardActions);
$65dac7f6f07c9dac$export$60332b2344f7fe41.Body = (0, $29BJw.CardBody);
$65dac7f6f07c9dac$export$60332b2344f7fe41.Content = (0, $hNn4O.CardContent);
$65dac7f6f07c9dac$export$60332b2344f7fe41.Divider = (0, $1HBEk.CardDivider);
$65dac7f6f07c9dac$export$60332b2344f7fe41.Figure = (0, $jWOE4.CardFigure);
$65dac7f6f07c9dac$export$60332b2344f7fe41.Footer = (0, $itHXC.CardFooter);
$65dac7f6f07c9dac$export$60332b2344f7fe41.Header = (0, $jP5MY.CardHeader);
$65dac7f6f07c9dac$export$60332b2344f7fe41.Heading = (0, $4yVeq.CardHeading);
$65dac7f6f07c9dac$export$60332b2344f7fe41.Headings = (0, $g0yjr.CardHeadings);
$65dac7f6f07c9dac$export$60332b2344f7fe41.Image = (0, $b3pDp.CardImage);
$65dac7f6f07c9dac$export$60332b2344f7fe41.Item = (0, $h20xF.CardItem);
$65dac7f6f07c9dac$export$60332b2344f7fe41.Links = (0, $4DXtE.CardLinks);
$65dac7f6f07c9dac$export$60332b2344f7fe41.SubHeading = (0, $98s8j.CardSubHeading);

});
parcelRegister("gvAnh", function(module, exports) {

$parcel$export(module.exports, "CardAction", function () { return $c04bc1cdefdeebfb$export$f40b7e0b762b928b; });

var $a5EUy = parcelRequire("a5EUy");

var $70aOe = parcelRequire("70aOe");
var $c04bc1cdefdeebfb$export$f40b7e0b762b928b = function(_a) {
    var icon = _a.icon, _b = _a.ariaLabel, ariaLabel = _b === void 0 ? '' : _b;
    return $a5EUy.createElement((0, $70aOe.Icon), {
        "aria-label": ariaLabel,
        as: "button",
        icon: icon
    });
};
$c04bc1cdefdeebfb$export$f40b7e0b762b928b.displayName = 'Card.Action';

});

parcelRegister("ibxyf", function(module, exports) {

$parcel$export(module.exports, "CardActions", function () { return $d3d347b47c980ed9$export$9b6a647253f61c5f; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $d3d347b47c980ed9$export$9b6a647253f61c5f = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('card-actions')
    }, children);
};
$d3d347b47c980ed9$export$9b6a647253f61c5f.displayName = 'Card.Actions';

});

parcelRegister("29BJw", function(module, exports) {

$parcel$export(module.exports, "CardBody", function () { return $1919b117bf7cea29$export$851de33184ecdac4; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $1919b117bf7cea29$export$851de33184ecdac4 = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('card-body')
    }, children);
};
$1919b117bf7cea29$export$851de33184ecdac4.displayName = 'Card.Body';

});

parcelRegister("hNn4O", function(module, exports) {

$parcel$export(module.exports, "CardContent", function () { return $cf48e9c9c0fbd1ed$export$64ef9b8c11710c47; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $cf48e9c9c0fbd1ed$export$64ef9b8c11710c47 = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('card-content')
    }, children);
};
$cf48e9c9c0fbd1ed$export$64ef9b8c11710c47.displayName = 'Card.Content';

});

parcelRegister("1HBEk", function(module, exports) {

$parcel$export(module.exports, "CardDivider", function () { return $13d702fd5008aff2$export$ca04f93e3f5a6e48; });

var $a5EUy = parcelRequire("a5EUy");

var $a29lN = parcelRequire("a29lN");
var $13d702fd5008aff2$export$ca04f93e3f5a6e48 = function() {
    return $a5EUy.createElement((0, $a29lN.Divider), null);
};
$13d702fd5008aff2$export$ca04f93e3f5a6e48.displayName = 'Card.Divider';

});
parcelRegister("a29lN", function(module, exports) {

$parcel$export(module.exports, "Divider", function () { return $74e158230e43037d$export$2e0a83ec2e27ecbb; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $74e158230e43037d$export$2e0a83ec2e27ecbb = function(_a) {
    var _b = _a.isVertical, isVertical = _b === void 0 ? false : _b;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("hr", {
        className: cn('divider', {
            'is-vertical': isVertical
        })
    });
};

});


parcelRegister("jWOE4", function(module, exports) {

$parcel$export(module.exports, "CardFigure", function () { return $e85ab8377e716bc4$export$448e687a629d6c89; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $e85ab8377e716bc4$export$448e687a629d6c89 = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('card-figure')
    }, children);
};
$e85ab8377e716bc4$export$448e687a629d6c89.displayName = 'Card.Figure';

});

parcelRegister("itHXC", function(module, exports) {

$parcel$export(module.exports, "CardFooter", function () { return $d73d0913f0061ee6$export$e9897d434e0741ee; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $d73d0913f0061ee6$export$e9897d434e0741ee = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('card-footer')
    }, children);
};
$d73d0913f0061ee6$export$e9897d434e0741ee.displayName = 'Card.Footer';

});

parcelRegister("jP5MY", function(module, exports) {

$parcel$export(module.exports, "CardHeader", function () { return $e6e74545d812ed16$export$5665775b26e26c5d; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $e6e74545d812ed16$export$5665775b26e26c5d = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('card-header')
    }, children);
};
$e6e74545d812ed16$export$5665775b26e26c5d.displayName = 'Card.Header';

});

parcelRegister("4yVeq", function(module, exports) {

$parcel$export(module.exports, "CardHeading", function () { return $3526bb685c90d557$export$d7df4bcb9a53fba5; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $3526bb685c90d557$export$d7df4bcb9a53fba5 = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('card-heading')
    }, children);
};
$3526bb685c90d557$export$d7df4bcb9a53fba5.displayName = 'Card.Heading';

});

parcelRegister("g0yjr", function(module, exports) {

$parcel$export(module.exports, "CardHeadings", function () { return $ba7743324e31473d$export$93526684a821b474; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $ba7743324e31473d$export$93526684a821b474 = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('card-headings')
    }, children);
};
$ba7743324e31473d$export$93526684a821b474.displayName = 'Card.Headings';

});

parcelRegister("b3pDp", function(module, exports) {

$parcel$export(module.exports, "CardImage", function () { return $80c3dc085b5c1a00$export$8a8c015277a3d77a; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $80c3dc085b5c1a00$export$8a8c015277a3d77a = function(_a) {
    var _b;
    var children = _a.children, _c = _a.ratio, ratio = _c === void 0 ? '5by3' : _c, _d = _a.cover, cover = _d === void 0 ? false : _d;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var className = cn('card-image');
    var figureClassName = cn('card-image-figure', (_b = {}, _b["is-ratio-" + ratio] = ratio, _b["is-cover"] = cover, _b));
    return $a5EUy.createElement("div", {
        className: className
    }, $a5EUy.createElement("figure", {
        className: figureClassName
    }, children));
};
$80c3dc085b5c1a00$export$8a8c015277a3d77a.displayName = 'Card.Image';

});

parcelRegister("h20xF", function(module, exports) {

$parcel$export(module.exports, "CardItem", function () { return $c6630b2fb80479ae$export$d14d08fa0d83d69d; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $c6630b2fb80479ae$export$d14d08fa0d83d69d = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('card-item')
    }, children);
};
$c6630b2fb80479ae$export$d14d08fa0d83d69d.displayName = 'Card.Item';

});

parcelRegister("4DXtE", function(module, exports) {

$parcel$export(module.exports, "CardLinks", function () { return $3618f0e2050d60b4$export$955b33155a1e7657; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $3618f0e2050d60b4$export$955b33155a1e7657 = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('card-links')
    }, children);
};
$3618f0e2050d60b4$export$955b33155a1e7657.displayName = 'Card.Links';

});

parcelRegister("98s8j", function(module, exports) {

$parcel$export(module.exports, "CardSubHeading", function () { return $6a6aaf0fbe5537e2$export$d2d17d20ef6b7c77; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $6a6aaf0fbe5537e2$export$d2d17d20ef6b7c77 = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('card-subheading')
    }, children);
};
$6a6aaf0fbe5537e2$export$d2d17d20ef6b7c77.displayName = 'Card.SubHeading';

});



parcelRegister("iT7xN", function(module, exports) {
$parcel$export(module.exports, "Checkbox", function () { return (parcelRequire("7QTa8")).Checkbox; });
parcelRequire("7QTa8");
parcelRequire("hbDd1");

});
parcelRegister("7QTa8", function(module, exports) {

$parcel$export(module.exports, "Checkbox", function () { return $5b782dd828d5d822$export$48513f6b9f8ce62d; });
parcelRequire("2cnsK");
var $6pIUA = parcelRequire("6pIUA");
var $93esl = parcelRequire("93esl");

var $a5EUy = parcelRequire("a5EUy");
parcelRequire("bHt1e");
var $iQCcD = parcelRequire("iQCcD");

var $jLRsx = parcelRequire("jLRsx");
parcelRequire("kbxqT");
var $70aOe = parcelRequire("70aOe");

var $hbDd1 = parcelRequire("hbDd1");
var $5b782dd828d5d822$var$__assign = undefined && undefined.__assign || function() {
    $5b782dd828d5d822$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5b782dd828d5d822$var$__assign.apply(this, arguments);
};
var $5b782dd828d5d822$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5b782dd828d5d822$export$48513f6b9f8ce62d = $a5EUy.forwardRef(function(_a, ref) {
    var _b;
    var label = _a.label, labelLeft = _a.labelLeft, defaultChecked = _a.defaultChecked, _c = _a.status, status = _c === void 0 ? '' : _c, indeterminate = _a.indeterminate, props = $5b782dd828d5d822$var$__rest(_a, [
        "label",
        "labelLeft",
        "defaultChecked",
        "status",
        "indeterminate"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var inputRef = (0, $iQCcD.useShareForwardRef)(ref);
    var _d = (0, $hbDd1.useCheckbox)($5b782dd828d5d822$var$__assign({
        label: label,
        defaultChecked: defaultChecked
    }, props)), checkboxProps = _d.checkboxProps, labelProps = _d.labelProps;
    $a5EUy.useEffect(function() {
        if (inputRef.current) inputRef.current.indeterminate = !!indeterminate;
    }, [
        inputRef,
        indeterminate
    ]);
    var labelEl = label && $a5EUy.createElement("span", {
        className: cn('checkbox-text')
    }, label);
    var icon = indeterminate ? $a5EUy.createElement((0, $93esl.MinusBold), null) : $a5EUy.createElement((0, $6pIUA.CheckTickBold), null);
    return $a5EUy.createElement("div", {
        className: cn('checkbox', (_b = {}, _b["status-" + status] = status, _b))
    }, $a5EUy.createElement("label", $5b782dd828d5d822$var$__assign({
        className: cn('checkbox-label')
    }, labelProps), labelLeft && labelEl, $a5EUy.createElement("input", $5b782dd828d5d822$var$__assign({
        className: cn('checkbox-hidden')
    }, checkboxProps, props, {
        ref: inputRef
    })), $a5EUy.createElement("span", {
        className: cn('checkbox-shape')
    }, $a5EUy.createElement((0, $70aOe.Icon), {
        icon: icon
    })), !labelLeft && labelEl));
});

});
parcelRegister("hbDd1", function(module, exports) {

$parcel$export(module.exports, "useCheckbox", function () { return $c831e0d923db5a9c$export$e375f10ce42261c5; });

var $a5EUy = parcelRequire("a5EUy");

var $bq80E = parcelRequire("bq80E");
var $c831e0d923db5a9c$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $c831e0d923db5a9c$export$fe8da2af71b7fec6;
(function(CheckStates) {
    CheckStates["Checked"] = "checked";
    CheckStates["UnChecked"] = "unchecked";
    CheckStates["Indeterminate"] = "indeterminate";
})($c831e0d923db5a9c$export$fe8da2af71b7fec6 || ($c831e0d923db5a9c$export$fe8da2af71b7fec6 = {}));
var $c831e0d923db5a9c$export$e375f10ce42261c5 = function(_a) {
    var isRequired = _a.isRequired, _b = _a.defaultChecked, defaultChecked = _b === void 0 ? $c831e0d923db5a9c$export$fe8da2af71b7fec6.UnChecked : _b, _c = _a.isDisabled, isDisabled = _c === void 0 ? false : _c, label = _a.label, onChange = _a.onChange;
    var _d = $c831e0d923db5a9c$var$__read($a5EUy.useState(defaultChecked), 2), checkState = _d[0], setCheckState = _d[1];
    var uid = (0, $bq80E.useUID)();
    var onCheckedChange = $a5EUy.useCallback(function(e) {
        if (onChange) onChange(e);
        setCheckState(e.target.checked ? $c831e0d923db5a9c$export$fe8da2af71b7fec6.Checked : $c831e0d923db5a9c$export$fe8da2af71b7fec6.UnChecked);
    }, [
        onChange
    ]);
    var checkboxAria = $a5EUy.useMemo(function() {
        return {
            role: 'checkbox',
            'aria-disabled': isDisabled,
            'aria-checked': checkState === $c831e0d923db5a9c$export$fe8da2af71b7fec6.Indeterminate ? 'mixed' : checkState === $c831e0d923db5a9c$export$fe8da2af71b7fec6.Checked,
            'aria-labelledby': uid,
            type: 'checkbox',
            tabIndex: isDisabled ? -1 : 0,
            id: uid,
            disabled: isDisabled,
            required: isRequired,
            checked: checkState === $c831e0d923db5a9c$export$fe8da2af71b7fec6.Checked,
            onChange: onCheckedChange
        };
    }, [
        isRequired,
        isDisabled,
        checkState,
        onCheckedChange,
        defaultChecked
    ]);
    var labelAria = $a5EUy.useMemo(function() {
        return {
            htmlFor: uid,
            'aria-label': label
        };
    }, [
        label
    ]);
    return {
        checkboxProps: checkboxAria,
        labelProps: labelAria
    };
};

});



parcelRegister("bmsv4", function(module, exports) {
parcelRequire("j2HGU");

});
parcelRegister("j2HGU", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $iWcAY = parcelRequire("iWcAY");

var $hJBRQ = parcelRequire("hJBRQ");

var $km7GF = parcelRequire("km7GF");
var $ddd01859c07efed8$var$__assign = undefined && undefined.__assign || function() {
    $ddd01859c07efed8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ddd01859c07efed8$var$__assign.apply(this, arguments);
};
var $ddd01859c07efed8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ddd01859c07efed8$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $ddd01859c07efed8$export$e7cdf232acff13df = function(_a) {
    var _b;
    var children = _a.children, _c = _a.initialSelectedItem, initialSelectedItem = _c === void 0 ? 0 : _c, onSelectedItemChange = _a.onSelectedItemChange, isDisabled = _a.isDisabled, _d = _a.size, size = _d === void 0 ? 'default' : _d, props = $ddd01859c07efed8$var$__rest(_a, [
        "children",
        "initialSelectedItem",
        "onSelectedItemChange",
        "isDisabled",
        "size"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var _e = $ddd01859c07efed8$var$__read($a5EUy.useState(initialSelectedItem), 2), selectedItem = _e[0], setSelectedItem = _e[1];
    var _f = $ddd01859c07efed8$var$__read($a5EUy.useState(selectedItem), 2), focusedItem = _f[0], setFocusedItem = _f[1];
    $a5EUy.useEffect(function() {
        onSelectedItemChange === null || onSelectedItemChange === void 0 || onSelectedItemChange(selectedItem);
    }, [
        selectedItem,
        onSelectedItemChange
    ]);
    var id = (0, $km7GF.useID)('switcher');
    var className = cn('switcher', (_b = {}, _b["is-" + size] = size, _b["is-disabled"] = isDisabled, _b));
    var listClassName = cn('switcher-list');
    var contextValue = $a5EUy.useMemo(function() {
        return {
            id: id,
            selectedItem: selectedItem,
            setSelectedItem: setSelectedItem,
            focusedItem: focusedItem,
            setFocusedItem: setFocusedItem,
            onSelectedItemChange: onSelectedItemChange,
            isDisabled: isDisabled
        };
    }, [
        id,
        selectedItem,
        setSelectedItem,
        focusedItem,
        setFocusedItem,
        onSelectedItemChange,
        isDisabled
    ]);
    return $a5EUy.createElement((0, $iWcAY.ContentSwitcherContext).Provider, {
        value: contextValue
    }, $a5EUy.createElement("div", $ddd01859c07efed8$var$__assign({
        className: className
    }, props), $a5EUy.createElement("ul", {
        className: listClassName
    }, children)));
};
$ddd01859c07efed8$export$e7cdf232acff13df.Item = (0, $hJBRQ.ContentSwitcherItem);

});
parcelRegister("iWcAY", function(module, exports) {

$parcel$export(module.exports, "ContentSwitcherContext", function () { return $dc9769ed4a8bc935$export$cf7203ccc57043c5; });
$parcel$export(module.exports, "useContentSwitcherContext", function () { return $dc9769ed4a8bc935$export$1a82d72bf3dc6ae3; });

var $a5EUy = parcelRequire("a5EUy");
var $dc9769ed4a8bc935$export$cf7203ccc57043c5 = $a5EUy.createContext(undefined);
var $dc9769ed4a8bc935$export$1a82d72bf3dc6ae3 = function() {
    var context = $a5EUy.useContext($dc9769ed4a8bc935$export$cf7203ccc57043c5);
    if (context) return context;
    throw new Error("ContentSwitcherItem compound components can't be rendered outside ContentSwitcher component");
};

});

parcelRegister("hJBRQ", function(module, exports) {

$parcel$export(module.exports, "ContentSwitcherItem", function () { return $ce940350baa00cdf$export$24231bd1a3b914e5; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
parcelRequire("kbxqT");
var $70aOe = parcelRequire("70aOe");

var $iWcAY = parcelRequire("iWcAY");

var $km7GF = parcelRequire("km7GF");
var $ce940350baa00cdf$var$__assign = undefined && undefined.__assign || function() {
    $ce940350baa00cdf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ce940350baa00cdf$var$__assign.apply(this, arguments);
};
var $ce940350baa00cdf$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ce940350baa00cdf$export$24231bd1a3b914e5 = function(_a) {
    var label = _a.label, index = _a.index, icon = _a.icon, iconSelected = _a.iconSelected, iconBefore = _a.iconBefore, iconBeforeSelected = _a.iconBeforeSelected, iconAfter = _a.iconAfter, iconAfterSelected = _a.iconAfterSelected, _b = _a.disabled, disabled = _b === void 0 ? false : _b, props = $ce940350baa00cdf$var$__rest(_a, [
        "label",
        "index",
        "icon",
        "iconSelected",
        "iconBefore",
        "iconBeforeSelected",
        "iconAfter",
        "iconAfterSelected",
        "disabled"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var _c = (0, $iWcAY.useContentSwitcherContext)(), id = _c.id, selectedItem = _c.selectedItem, setSelectedItem = _c.setSelectedItem, focusedItem = _c.focusedItem, setFocusedItem = _c.setFocusedItem, isDisabled = _c.isDisabled;
    var isSelected = selectedItem === index;
    var className = cn('switcher-item', {
        'is-selected': isSelected,
        'is-focused': focusedItem === index,
        'is-disabled': disabled,
        'is-icon-only': icon
    });
    var iconBeforeEl = iconBefore && $a5EUy.createElement((0, $70aOe.Icon), {
        as: "span",
        icon: isSelected ? iconBeforeSelected !== null && iconBeforeSelected !== void 0 ? iconBeforeSelected : iconBefore : iconBefore,
        parentClass: "icon-before"
    });
    var iconAfterEl = iconAfter && $a5EUy.createElement((0, $70aOe.Icon), {
        as: "span",
        icon: isSelected ? iconAfterSelected !== null && iconAfterSelected !== void 0 ? iconAfterSelected : iconAfter : iconAfter,
        parentClass: "icon-after"
    });
    var attr = $ce940350baa00cdf$var$__assign({
        className: className,
        role: 'presentation',
        'aria-selected': isSelected ? true : undefined,
        id: (0, $km7GF.makeItemId)(id, index),
        // eslint-disable-next-line react/jsx-no-bind
        onClick: function() {
            setFocusedItem(index);
            setSelectedItem(index);
        },
        disabled: disabled || isDisabled
    }, props);
    if (icon) return $a5EUy.createElement("button", $ce940350baa00cdf$var$__assign({
        type: "button"
    }, attr), $a5EUy.createElement((0, $70aOe.Icon), {
        as: "span",
        icon: isSelected ? iconSelected !== null && iconSelected !== void 0 ? iconSelected : icon : icon
    }));
    return $a5EUy.createElement("button", $ce940350baa00cdf$var$__assign({
        type: "button"
    }, attr), iconBeforeEl, $a5EUy.createElement("span", null, label), iconAfterEl);
};
$ce940350baa00cdf$export$24231bd1a3b914e5.displayName = 'ContentSwitcher.Item';

});
parcelRegister("km7GF", function(module, exports) {

$parcel$export(module.exports, "useID", function () { return $ed1bd3412d4a7b8b$export$3ec6e0c16b571c32; });
$parcel$export(module.exports, "makeItemId", function () { return $ed1bd3412d4a7b8b$export$f44e27dc002af170; });

var $bq80E = parcelRequire("bq80E");
var $ed1bd3412d4a7b8b$export$3ec6e0c16b571c32 = function(type) {
    var uid = (0, $bq80E.useUID)();
    return type + "-" + uid;
};
var $ed1bd3412d4a7b8b$export$f44e27dc002af170 = function(id, index) {
    return id + "-item-" + index;
};

});




parcelRegister("hz9sd", function(module, exports) {
parcelRequire("9JccO");

});
parcelRegister("9JccO", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");

var $fAoG3 = parcelRequire("fAoG3");

var $1HT4t = parcelRequire("1HT4t");

var $7151c8d241491782$var$__assign = undefined && undefined.__assign || function() {
    $7151c8d241491782$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7151c8d241491782$var$__assign.apply(this, arguments);
};
var $7151c8d241491782$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
// adds an inner div to each day, so we can style it
var $7151c8d241491782$var$renderDay = function(date) {
    return $a5EUy.createElement("div", {
        className: "DayPicker-DayInner"
    }, date.getDate());
};
/**
 * Poor mans keyboard mask.
 * Adds a dash ('-') between the dates when the user enters dates,
 * if the input is at 'DD' or 'DD-MM' (to add a dash after DD or MM).
 * Except if the user deleted text using backspace or delete
 */ var $7151c8d241491782$var$maybeAddGuidingDash = function(inputRef) {
    return function(event) {
        if (!inputRef.current) return;
        if (event.key === 'Backspace' || event.key === 'Delete') return;
        var currentValue = inputRef.current.value;
        if (!/^\d\d(-\d\d)?$/gu.test(currentValue)) return;
        // hacky workaround to add the dash directly to the input field, without messing with the DayPicker's state
        inputRef.current.value = currentValue + "-";
    };
};
/**
 * formats a Date to a string on the format 'DD-MM-YY'
 */ var $7151c8d241491782$var$formatDate = function(date) {
    if (!(0, $fAoG3.DateUtils).isDate(date)) return '';
    var day = date.getUTCDate().toString().padStart(2, '0'); // 9 -> '09'
    var month = (date.getUTCMonth() + 1).toString().padStart(2, '0'); // 3 -> '04'
    var year = ("" + date.getUTCFullYear()).slice(2); // 2019 -> '19'
    return day + "-" + month + "-" + year;
};
/**
 * parses a date string from the format 'DD-MM-YY' to a Date
 * If it is invalid, it returns undefined
 */ var $7151c8d241491782$var$parseDate = function(string) {
    if (typeof string !== 'string') return undefined;
    if (string.length !== 8) return undefined;
    var split = string.split('-');
    if (split.length !== 3) return undefined;
    var dayString = split[0];
    var monthString = split[1];
    var yearString = split[2];
    var dayNumber = Number.parseInt(dayString, 10);
    var monthNumber = Number.parseInt(monthString, 10) - 1;
    var yearNumber = Number.parseInt(yearString, 10);
    if (Number.isNaN(yearNumber) || yearString.length !== 2 || Number.isNaN(dayNumber) || dayNumber < 1 || dayNumber > 31 || Number.isNaN(monthNumber) || monthNumber < 0 || monthNumber > 11) return undefined;
    return new Date("20" + yearString + "-" + monthString + "-" + dayString + "T12:00:00Z"); // always set noon to avoid time zone issues
};
var $7151c8d241491782$export$17334619f3ac2224 = function(_a) {
    var _b, _c;
    var onChange = _a.onChange, initialValue = _a.initialValue, _d = _a.startLabel, startLabel = _d === void 0 ? 'Start' : _d, _e = _a.endLabel, endLabel = _e === void 0 ? 'End' : _e, _f = _a.column, column = _f === void 0 ? false : _f, _g = _a.size, size = _g === void 0 ? 'medium' : _g, _h = _a.startStatus, startStatus = _h === void 0 ? 'default' : _h, _j = _a.endStatus, endStatus = _j === void 0 ? 'default' : _j, startInputProps = _a.startInputProps, endInputProps = _a.endInputProps, helperText = _a.helperText, _k = _a.disabled, disabled = _k === void 0 ? false : _k, _l = _a.disableAutoFocus, disableAutoFocus = _l === void 0 ? false : _l, _m = _a.numberOfMonths, numberOfMonths = _m === void 0 ? 2 : _m;
    var _o = $7151c8d241491782$var$__read((0, $a5EUy.useState)({
        start: undefined,
        end: undefined
    }), 2), range = _o[0], setRange = _o[1];
    var _p = $7151c8d241491782$var$__read((0, $a5EUy.useState)(), 2), hoveringToDate = _p[0], setHoveringToDate = _p[1];
    // which month to show in the first (left) calendar when the 'end' field is open
    var _q = $7151c8d241491782$var$__read((0, $a5EUy.useState)(), 2), firstMonthInToCalendar = _q[0], setFirstMonthInToCalendar = _q[1];
    var startInputRef = (0, $a5EUy.useRef)(null);
    var endInputRef = (0, $a5EUy.useRef)(null);
    var _r = $7151c8d241491782$var$__read((0, $a5EUy.useState)(false), 2), selectStart = _r[0], setStart = _r[1];
    var start = range.start, end = range.end;
    // set the internal range state whenever the initialValue prop changes, making this a controlled component
    $a5EUy.useEffect(function() {
        setRange(initialValue !== null && initialValue !== void 0 ? initialValue : {
            start: undefined,
            end: undefined
        });
    }, [
        initialValue
    ]);
    // is called whenever 'start' or 'end' is changed, either by typing or clicking
    var handleRangeChange = function(isStart) {
        return function(date) {
            setHoveringToDate(undefined);
            var nextRange = {
                start: isStart ? date : start,
                end: isStart ? end : date
            };
            setRange(nextRange);
            onChange(nextRange);
        };
    };
    var inputIds = {
        start: startLabel.replace(/\s/gu, '') + "-start",
        end: endLabel.replace(/\s/gu, '') + "-end"
    };
    var combinedStatus = 'default';
    if (startStatus === 'error' || endStatus === 'error') combinedStatus = 'error';
    else if (startStatus === 'warning' || endStatus === 'warning') combinedStatus = 'warning';
    $a5EUy.useEffect(function() {
        var _a;
        if (start && !disableAutoFocus && selectStart) {
            (_a = endInputRef.current) === null || _a === void 0 || _a.focus();
            setStart(false);
        }
        if (start && end) {
            if (start > end) setRange({
                start: start,
                end: undefined
            });
        }
    }, [
        start,
        disableAutoFocus,
        selectStart,
        end
    ]);
    return $a5EUy.createElement("fieldset", {
        className: "DateRangePicker " + size + " " + (column ? 'DateRangePicker-column' : '')
    }, $a5EUy.createElement("div", {
        className: "FieldsContainer"
    }, $a5EUy.createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column'
        }
    }, $a5EUy.createElement("label", {
        htmlFor: inputIds.start
    }, startLabel), $a5EUy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1HT4t))), {
        dayPickerProps: {
            selectedDays: {
                from: start,
                to: end
            },
            // focus the 'end' input when the user selects a date
            onDayClick: function() {
                if (!disableAutoFocus) setStart(true);
            },
            modifiers: {
                start: start,
                end: end
            },
            firstDayOfWeek: 1,
            numberOfMonths: numberOfMonths,
            showWeekNumbers: true,
            renderDay: $7151c8d241491782$var$renderDay
        },
        formatDate: $7151c8d241491782$var$formatDate,
        inputProps: $7151c8d241491782$var$__assign((_b = {
            ref: startInputRef,
            disabled: disabled === true || disabled === 'start',
            className: startStatus,
            // automatically add a dash to the input after 'DD' or 'DD-MM'
            onKeyUp: $7151c8d241491782$var$maybeAddGuidingDash(startInputRef),
            // select the whole text when the user focuses the input field
            onFocus: function(event) {
                event.target.select();
            },
            id: inputIds.start
        }, _b['aria-label'] = startLabel, _b.autoComplete = 'off', _b), startInputProps),
        onDayChange: handleRangeChange(true),
        parseDate: $7151c8d241491782$var$parseDate,
        placeholder: "DD-MM-YY",
        value: start
    })), $a5EUy.createElement("div", {
        style: {
            padding: '0.5rem'
        }
    }), $a5EUy.createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column'
        }
    }, $a5EUy.createElement("label", {
        htmlFor: inputIds.end
    }, endLabel), $a5EUy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1HT4t))), {
        dayPickerProps: {
            // set selected days to the current 'hoveringToDate', or the 'end' date as a fallback - this is used to style the dates in between
            selectedDays: [
                start,
                {
                    from: start,
                    to: hoveringToDate !== null && hoveringToDate !== void 0 ? hoveringToDate : end
                }
            ],
            onDayMouseEnter: function(date) {
                /*
                        If hovering over a date that is before 'start', we don't want to show it.
                          If 'end' have already been set, set hover to that, to highlight start-end
                          if 'end' have not yet been set, hover at 'start' to not highlight anything
                        */ if (start && start > date) {
                    if (end) setHoveringToDate(end);
                    else setHoveringToDate(start);
                } else setHoveringToDate(date);
            },
            // don't allow selecting a date that is before 'start'
            disabledDays: start ? {
                before: start
            } : undefined,
            modifiers: {
                start: start,
                end: hoveringToDate !== null && hoveringToDate !== void 0 ? hoveringToDate : end
            },
            firstDayOfWeek: 1,
            month: firstMonthInToCalendar,
            fromMonth: start,
            numberOfMonths: numberOfMonths,
            showWeekNumbers: true,
            renderDay: $7151c8d241491782$var$renderDay
        },
        formatDate: $7151c8d241491782$var$formatDate,
        inputProps: $7151c8d241491782$var$__assign((_c = {
            ref: endInputRef,
            disabled: disabled === true || disabled === 'end',
            className: endStatus,
            // automatically add a dash to the input after 'DD' or 'DD-MM'
            onKeyUp: $7151c8d241491782$var$maybeAddGuidingDash(endInputRef),
            onFocus: function(event) {
                event.target.select();
            },
            id: inputIds.end
        }, _c['aria-label'] = endLabel, _c.autoComplete = 'off', _c), endInputProps),
        onDayChange: handleRangeChange(false),
        onDayPickerHide: function() {
            // unset hover state when calendar disappears
            setHoveringToDate(undefined);
        },
        onDayPickerShow: function() {
            // when showing the 'end' picker, we want to ensure that the correct months are shown:
            // if no range is selected, let the 'start' month be the first shown
            // if a range within the same month is selected, let the 'start' month be the first shown
            // if a multi-month range is selected, make the 'end' date be in the RIGHT calendar, by setting the left calendar to be the month before 'end'
            var nextFirstMonthInToCalendar = start;
            if (start instanceof Date && end instanceof Date && !(0, $fAoG3.DateUtils).isSameMonth(start, end)) nextFirstMonthInToCalendar = (0, $fAoG3.DateUtils).addMonths(end, -1);
            setFirstMonthInToCalendar(nextFirstMonthInToCalendar);
        },
        parseDate: $7151c8d241491782$var$parseDate,
        placeholder: "DD-MM-YY",
        value: end
    }))), helperText && $a5EUy.createElement("div", {
        "aria-label": startLabel + " or " + endLabel,
        className: "HelperText " + combinedStatus,
        role: "alert"
    }, helperText));
};

});
parcelRegister("fAoG3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eDkDO = parcelRequire("eDkDO");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $b58d5c3a7cd96a37$var$_interopRequireDefault($eDkDO).default;
    }
});

var $3y50U = parcelRequire("3y50U");
Object.defineProperty(module.exports, 'DateUtils', {
    enumerable: true,
    get: function get() {
        return $b58d5c3a7cd96a37$var$_interopRequireDefault($3y50U).default;
    }
});

var $9FVG1 = parcelRequire("9FVG1");
Object.defineProperty(module.exports, 'LocaleUtils', {
    enumerable: true,
    get: function get() {
        return $b58d5c3a7cd96a37$var$_interopRequireDefault($9FVG1).default;
    }
});

var $1wsvb = parcelRequire("1wsvb");
Object.defineProperty(module.exports, 'ModifiersUtils', {
    enumerable: true,
    get: function get() {
        return $b58d5c3a7cd96a37$var$_interopRequireDefault($1wsvb).default;
    }
});
function $b58d5c3a7cd96a37$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});

parcelRegister("1HT4t", function(module, exports) {

module.exports = (parcelRequire("bPyzV"));

});



parcelRegister("l6RU7", function(module, exports) {
parcelRequire("a29lN");

});

parcelRegister("dzHea", function(module, exports) {
parcelRequire("4SgTs");

});
parcelRegister("4SgTs", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $38c94f46677da1dd$var$__assign = undefined && undefined.__assign || function() {
    $38c94f46677da1dd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $38c94f46677da1dd$var$__assign.apply(this, arguments);
};
var $38c94f46677da1dd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $38c94f46677da1dd$export$4071300121a182f5 = $a5EUy.forwardRef(function(_a, ref) {
    var children = _a.children, isOpen = _a.isOpen, _b = _a.mode, mode = _b === void 0 ? 'right' : _b, offset = _a.offset, props = $38c94f46677da1dd$var$__rest(_a, [
        "children",
        "isOpen",
        "mode",
        "offset"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var offsetStyles = {
        top: offset
    };
    return $a5EUy.createElement("div", {
        className: cn('drawer')
    }, $a5EUy.createElement("nav", $38c94f46677da1dd$var$__assign({
        className: cn('drawer-nav', {
            'is-open': isOpen,
            'from-left': mode === 'left',
            'from-right': mode === 'right',
            'is-fullscreen': mode === 'screen'
        }),
        style: offset ? offsetStyles : {}
    }, props, {
        ref: ref
    }), children));
});

});


parcelRegister("6yhm4", function(module, exports) {
$parcel$export(module.exports, "Dropdown", function () { return (parcelRequire("hd3cd")).Dropdown; });
$parcel$export(module.exports, "useDropdown", function () { return (parcelRequire("2u0dC")).useDropdown; });
parcelRequire("hd3cd");
parcelRequire("7CJHw");
parcelRequire("2u0dC");

});
parcelRegister("hd3cd", function(module, exports) {

$parcel$export(module.exports, "Dropdown", function () { return $c876213c1ad48156$export$931cbfb6bfb85fc; });

var $a5EUy = parcelRequire("a5EUy");

var $jUibk = parcelRequire("jUibk");
parcelRequire("bHt1e");
var $1225g = parcelRequire("1225g");
var $iQCcD = parcelRequire("iQCcD");

var $eNqGA = parcelRequire("eNqGA");

var $jLRsx = parcelRequire("jLRsx");

var $jCE8G = parcelRequire("jCE8G");
var $c876213c1ad48156$var$__assign = undefined && undefined.__assign || function() {
    $c876213c1ad48156$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c876213c1ad48156$var$__assign.apply(this, arguments);
};
var $c876213c1ad48156$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/**
 * isSelected helper function
 * @param current
 * @param controlledValues
 */ var $c876213c1ad48156$var$isSelected = function(current, controlledValues) {
    if (!current || !controlledValues) return false;
    if (Array.isArray(controlledValues)) {
        if (controlledValues.length < 1) return false;
        return controlledValues.some(function(item) {
            return item.value === current;
        });
    }
    return current === controlledValues.value;
};
var $c876213c1ad48156$export$931cbfb6bfb85fc = $a5EUy.forwardRef(function(_a, ref) {
    var onDropdownSelect = _a.onDropdownSelect, children = _a.children, value = _a.value, _b = _a.isClipped, isClipped = _b === void 0 ? false : _b, _c = _a.isNarrow, isNarrow = _c === void 0 ? false : _c, _d = _a._hasFocus, _hasFocus = _d === void 0 ? false : _d, props = $c876213c1ad48156$var$__rest(_a, [
        "onDropdownSelect",
        "children",
        "value",
        "isClipped",
        "isNarrow",
        "_hasFocus"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var shared = (0, $iQCcD.useShareForwardRef)(ref);
    var portalRoot = (0, $1225g.usePortalRoot)((0, $1225g.PortalRoots).DROPDOWN).portalRoot;
    var clickHandler = $a5EUy.useCallback(function(option) {
        if (onDropdownSelect) onDropdownSelect(option);
    }, (0, $eNqGA.EMPTY_ARRAY));
    var providedChildren = $a5EUy.useMemo(function() {
        return $a5EUy.Children.map(children, function(child) {
            return $a5EUy.cloneElement(child, $c876213c1ad48156$var$__assign({
                onClick: clickHandler,
                selected: $c876213c1ad48156$var$isSelected(child.props.value, value)
            }, child.props));
        });
    }, [
        children
    ]);
    return $jUibk.createPortal($a5EUy.createElement("div", $c876213c1ad48156$var$__assign({
        className: cn('dropdown', {
            'is-narrow': isNarrow,
            'is-clipped': isClipped
        }),
        ref: shared,
        role: "group"
    }, props), providedChildren), portalRoot);
});
$c876213c1ad48156$export$931cbfb6bfb85fc.Item = (0, $jCE8G.DropdownItem);

});
parcelRegister("jCE8G", function(module, exports) {

$parcel$export(module.exports, "DropdownItem", function () { return $e490b3b5c862b135$export$6648d5fa18559e7f; });
parcelRequire("2cnsK");
var $6pIUA = parcelRequire("6pIUA");

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
parcelRequire("kbxqT");
var $70aOe = parcelRequire("70aOe");
var $e490b3b5c862b135$export$6648d5fa18559e7f = function(_a) {
    var _b;
    var _c = _a.selected, selected = _c === void 0 ? false : _c, value = _a.value, label = _a.label, onClick = _a.onClick;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var clickHandler = $a5EUy.useCallback(function() {
        if (onClick) onClick({
            value: value,
            label: label
        });
    }, [
        value,
        label
    ]);
    return $a5EUy.createElement("div", {
        "aria-label": label,
        className: cn('dropdown-item', (_b = {}, _b['is-selected'] = selected, _b)),
        key: label,
        onClick: clickHandler,
        role: "button"
    }, $a5EUy.createElement("span", {
        className: cn('dropdown-item-content')
    }, label), selected && $a5EUy.createElement((0, $70aOe.Icon), {
        icon: $a5EUy.createElement((0, $6pIUA.CheckTickBold), null)
    }));
};
$e490b3b5c862b135$export$6648d5fa18559e7f.displayName = 'Dropdown.Item';

});


parcelRegister("7CJHw", function(module, exports) {

});

parcelRegister("2u0dC", function(module, exports) {

$parcel$export(module.exports, "useDropdown", function () { return $1cee8d877afc8be6$export$8c32fdb3462273b4; });

var $a5EUy = parcelRequire("a5EUy");
parcelRequire("bHt1e");
var $gSNWl = parcelRequire("gSNWl");
var $1cee8d877afc8be6$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $1cee8d877afc8be6$var$defaultOptions = {
    inheritWidth: false,
    closeOnClickOutside: true
};
var $1cee8d877afc8be6$var$DROPDOWN_OFFSET = 8;
var $1cee8d877afc8be6$export$8c32fdb3462273b4 = function(dropdown, target, options) {
    if (options === void 0) options = $1cee8d877afc8be6$var$defaultOptions;
    var _a = $1cee8d877afc8be6$var$__read($a5EUy.useState(), 2), rect = _a[0], setRect = _a[1];
    var _b = $1cee8d877afc8be6$var$__read($a5EUy.useState(false), 2), isOpen = _b[0], setVisible = _b[1];
    (0, $gSNWl.useClickOutside)(dropdown, function() {
        if (options.closeOnClickOutside) setVisible(false);
    }, [
        options.closeOnClickOutside
    ]);
    var toggleVisible = function() {
        return setVisible(function(prev) {
            return !prev;
        });
    };
    var setPosition = function(domRect) {
        if (dropdown.current && domRect) {
            var top_1 = domRect.top, left = domRect.left, height = domRect.height, width = domRect.width;
            dropdown.current.style.position = 'absolute';
            dropdown.current.style.top = top_1 + height + $1cee8d877afc8be6$var$DROPDOWN_OFFSET + "px";
            dropdown.current.style.left = left + "px";
            if (options.inheritWidth) dropdown.current.style.width = width + "px";
        }
    };
    var updateRect = function() {
        if (dropdown.current && target.current) setRect(target.current.getBoundingClientRect());
    };
    // Initialize the position of the dropdown.
    // TODO: document event listeners should be removed in the future.
    $a5EUy.useLayoutEffect(function() {
        if (dropdown.current && target.current) setRect(target.current.getBoundingClientRect());
        window.addEventListener('resize', updateRect);
        return function() {
            window.removeEventListener('resize', updateRect);
        };
    }, [
        target,
        dropdown
    ]);
    $a5EUy.useLayoutEffect(function() {
        setPosition(rect);
    }, [
        rect
    ]);
    $a5EUy.useEffect(function() {
        updateRect();
        if (dropdown.current) {
            if (isOpen) setPosition(rect);
            dropdown.current.style.display = isOpen ? '' : 'none';
        }
    }, [
        isOpen,
        dropdown
    ]);
    return {
        setVisible: setVisible,
        toggleVisible: toggleVisible,
        isOpen: isOpen
    };
};

});


parcelRegister("5ieYE", function(module, exports) {
parcelRequire("k1pN9");

});
parcelRegister("k1pN9", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
var $e937e856ecae8a2b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $e937e856ecae8a2b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/**
 * KlikErrorBoundary
 */ var $e937e856ecae8a2b$export$c0ae8bb4140c23c0 = /** @class */ function(_super) {
    $e937e856ecae8a2b$var$__extends(KlikErrorBoundary, _super);
    function KlikErrorBoundary(_a) {
        var component = _a.component, props = $e937e856ecae8a2b$var$__rest(_a, [
            "component"
        ]);
        var _this = _super.call(this, props) || this;
        _this.state = {
            hasError: false
        };
        _this.component = component;
        return _this;
    }
    KlikErrorBoundary.getDerivedStateFromError = function(_error) {
        return {
            hasError: true
        };
    };
    KlikErrorBoundary.prototype.componentDidCatch = function(_error, _errorInfo) {
    // TODO: log to sentry
    };
    KlikErrorBoundary.prototype.render = function() {
        var hasError = this.state.hasError;
        var children = this.props.children;
        if (hasError && this.component) return this.component;
        if (hasError) return $a5EUy.createElement("h1", null, "The App stepped on a brick and crashed");
        return children;
    };
    return KlikErrorBoundary;
}($a5EUy.Component);

});


parcelRegister("h2IC8", function(module, exports) {
parcelRequire("1ItMn");

});
parcelRegister("1ItMn", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
parcelRequire("7aaMk");
var $gVRzu = parcelRequire("gVRzu");
parcelRequire("ZEaLC");
var $3xjH4 = parcelRequire("3xjH4");
parcelRequire("h6b75");
var $aIP73 = parcelRequire("aIP73");
parcelRequire("xXU0r");
var $gJTu7 = parcelRequire("gJTu7");
var $1401000cbb387689$var$__assign = undefined && undefined.__assign || function() {
    $1401000cbb387689$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1401000cbb387689$var$__assign.apply(this, arguments);
};
var $1401000cbb387689$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1401000cbb387689$export$a7fed597f4b8afd8 = $a5EUy.forwardRef(function(_a, ref) {
    var children = _a.children, props = $1401000cbb387689$var$__rest(_a, [
        "children"
    ]);
    return $a5EUy.createElement("form", $1401000cbb387689$var$__assign({}, props, {
        ref: ref
    }), children);
});
$1401000cbb387689$export$a7fed597f4b8afd8.TextArea = (0, $aIP73.TextArea);
$1401000cbb387689$export$a7fed597f4b8afd8.TextField = (0, $gJTu7.TextField);
$1401000cbb387689$export$a7fed597f4b8afd8.Label = (0, $3xjH4.Label);
$1401000cbb387689$export$a7fed597f4b8afd8.HelpText = (0, $gVRzu.HelpText);

});
parcelRegister("7aaMk", function(module, exports) {
$parcel$export(module.exports, "HelpText", function () { return (parcelRequire("gVRzu")).HelpText; });
parcelRequire("gVRzu");

});
parcelRegister("gVRzu", function(module, exports) {

$parcel$export(module.exports, "HelpText", function () { return $c53b865c0601c884$export$a67c0bc59081311a; });

var $a5EUy = parcelRequire("a5EUy");
parcelRequire("bHt1e");
var $8wBe8 = parcelRequire("8wBe8");

var $jLRsx = parcelRequire("jLRsx");
var $c53b865c0601c884$var$__assign = undefined && undefined.__assign || function() {
    $c53b865c0601c884$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c53b865c0601c884$var$__assign.apply(this, arguments);
};
var $c53b865c0601c884$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c53b865c0601c884$export$a67c0bc59081311a = $a5EUy.forwardRef(function(_a, ref) {
    var label = _a.label, size = _a.size, props = $c53b865c0601c884$var$__rest(_a, [
        "label",
        "size"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var fontSize = (0, $8wBe8.useFont)(size);
    return $a5EUy.createElement("p", $c53b865c0601c884$var$__assign({
        ref: ref
    }, props, {
        className: cn('help', fontSize)
    }), label);
});

});


parcelRegister("ZEaLC", function(module, exports) {
$parcel$export(module.exports, "Label", function () { return (parcelRequire("3xjH4")).Label; });
parcelRequire("3xjH4");

});
parcelRegister("3xjH4", function(module, exports) {

$parcel$export(module.exports, "Label", function () { return $2933bae96750b493$export$b04be29aa201d4f5; });

var $a5EUy = parcelRequire("a5EUy");
parcelRequire("bHt1e");
var $8wBe8 = parcelRequire("8wBe8");

var $jLRsx = parcelRequire("jLRsx");
var $2933bae96750b493$var$__assign = undefined && undefined.__assign || function() {
    $2933bae96750b493$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2933bae96750b493$var$__assign.apply(this, arguments);
};
var $2933bae96750b493$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2933bae96750b493$export$b04be29aa201d4f5 = $a5EUy.forwardRef(function(_a, ref) {
    var label = _a.label, htmlFor = _a.htmlFor, form = _a.form, size = _a.size, props = $2933bae96750b493$var$__rest(_a, [
        "label",
        "htmlFor",
        "form",
        "size"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var fontSize = (0, $8wBe8.useFont)(size);
    return $a5EUy.createElement("div", $2933bae96750b493$var$__assign({
        className: cn('form-label', fontSize),
        ref: ref
    }, props), $a5EUy.createElement("label", {
        form: form,
        htmlFor: htmlFor
    }, label));
});

});


parcelRegister("h6b75", function(module, exports) {
$parcel$export(module.exports, "TextArea", function () { return (parcelRequire("aIP73")).TextArea; });
parcelRequire("aIP73");

});
parcelRegister("aIP73", function(module, exports) {

$parcel$export(module.exports, "TextArea", function () { return $7ce5a95f0c774b42$export$f5c9f3c2c4054eec; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $7ce5a95f0c774b42$var$__assign = undefined && undefined.__assign || function() {
    $7ce5a95f0c774b42$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7ce5a95f0c774b42$var$__assign.apply(this, arguments);
};
var $7ce5a95f0c774b42$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7ce5a95f0c774b42$export$f5c9f3c2c4054eec = $a5EUy.forwardRef(function Input(_a, ref) {
    var _b;
    var _c = _a.isDisabled, isDisabled = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? 'medium' : _d, isFlexible = _a.isFlexible, isRequired = _a.isRequired, _e = _a.validationStatus, validationStatus = _e === void 0 ? '' : _e, props = $7ce5a95f0c774b42$var$__rest(_a, [
        "isDisabled",
        "size",
        "isFlexible",
        "isRequired",
        "validationStatus"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("textarea", $7ce5a95f0c774b42$var$__assign({
        className: cn('input', (_b = {}, _b["is-" + size] = size, _b['is-flexible'] = isFlexible, _b["status-" + validationStatus] = validationStatus, _b["is-disabled"] = isDisabled, _b)),
        ref: ref,
        required: isRequired
    }, props));
});

});


parcelRegister("xXU0r", function(module, exports) {
$parcel$export(module.exports, "TextField", function () { return (parcelRequire("gJTu7")).TextField; });
parcelRequire("gJTu7");

});
parcelRegister("gJTu7", function(module, exports) {

$parcel$export(module.exports, "TextField", function () { return $c2fbe36c1d04d569$export$2c73285ae9390cec; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $c2fbe36c1d04d569$var$__assign = undefined && undefined.__assign || function() {
    $c2fbe36c1d04d569$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c2fbe36c1d04d569$var$__assign.apply(this, arguments);
};
var $c2fbe36c1d04d569$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c2fbe36c1d04d569$export$2c73285ae9390cec = $a5EUy.forwardRef(function Input(_a, ref) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = _a.isFlexible, isFlexible = _e === void 0 ? false : _e, _f = _a.isRequired, isRequired = _f === void 0 ? false : _f, _g = _a.validationStatus, validationStatus = _g === void 0 ? '' : _g, _h = _a.type, type = _h === void 0 ? 'text' : _h, props = $c2fbe36c1d04d569$var$__rest(_a, [
        "size",
        "isDisabled",
        "isFlexible",
        "isRequired",
        "validationStatus",
        "type"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("input", $c2fbe36c1d04d569$var$__assign({
        className: cn('input', (_b = {}, _b["is-" + size] = size, _b['is-flexible'] = isFlexible, _b["status-" + validationStatus] = validationStatus, _b["is-disabled"] = isDisabled, _b)),
        ref: ref,
        required: isRequired,
        type: type
    }, props));
});

});




parcelRegister("h7J6o", function(module, exports) {
$parcel$export(module.exports, "Header", function () { return (parcelRequire("2Ei9L")).Header; });
parcelRequire("2Ei9L");
parcelRequire("fF7dP");

});
parcelRegister("2Ei9L", function(module, exports) {

$parcel$export(module.exports, "Header", function () { return $1edd66b29aa73686$export$8b251419efc915eb; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $7PSIg = parcelRequire("7PSIg");

var $4GUCZ = parcelRequire("4GUCZ");

var $jsViq = parcelRequire("jsViq");

var $aB6Yl = parcelRequire("aB6Yl");

var $fgfJw = parcelRequire("fgfJw");
var $1edd66b29aa73686$var$__assign = undefined && undefined.__assign || function() {
    $1edd66b29aa73686$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1edd66b29aa73686$var$__assign.apply(this, arguments);
};
var $1edd66b29aa73686$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1edd66b29aa73686$export$8b251419efc915eb = $a5EUy.forwardRef(function Header(_a, ref) {
    var children = _a.children, props = $1edd66b29aa73686$var$__rest(_a, [
        "children"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("header", $1edd66b29aa73686$var$__assign({
        className: cn('header'),
        ref: ref
    }, props), $a5EUy.createElement("div", {
        className: cn('header-body')
    }, children));
});
$1edd66b29aa73686$export$8b251419efc915eb.Item = (0, $fgfJw.HeaderItem);
$1edd66b29aa73686$export$8b251419efc915eb.Brand = (0, $7PSIg.HeaderBrand);
$1edd66b29aa73686$export$8b251419efc915eb.Dropdown = (0, $4GUCZ.HeaderDropdown);
$1edd66b29aa73686$export$8b251419efc915eb.IconGroup = (0, $aB6Yl.HeaderIconGroup);
$1edd66b29aa73686$export$8b251419efc915eb.Group = (0, $jsViq.HeaderGroup);

});
parcelRegister("7PSIg", function(module, exports) {

$parcel$export(module.exports, "HeaderBrand", function () { return $5b47bcacfcadaf0a$export$7eeca4f9565066a1; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $5b47bcacfcadaf0a$export$7eeca4f9565066a1 = function(_a) {
    var label = _a.label, logo = _a.logo, href = _a.href, onClick = _a.onClick;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('header-brand')
    }, $a5EUy.createElement("a", {
        className: cn('header-logo'),
        href: href,
        onClick: onClick
    }, logo), $a5EUy.createElement("p", {
        className: cn('header-name')
    }, label));
};
$5b47bcacfcadaf0a$export$7eeca4f9565066a1.displayName = 'Header.Brand';

});

parcelRegister("4GUCZ", function(module, exports) {

$parcel$export(module.exports, "HeaderDropdown", function () { return $36a702ccfb2c1a1f$export$e93b0271171ef3a; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $fgfJw = parcelRequire("fgfJw");
var $36a702ccfb2c1a1f$var$__assign = undefined && undefined.__assign || function() {
    $36a702ccfb2c1a1f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $36a702ccfb2c1a1f$var$__assign.apply(this, arguments);
};
var $36a702ccfb2c1a1f$export$e93b0271171ef3a = function(_a) {
    var children = _a.children, isOpen = _a.isOpen;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('header-dropdown', {
            'is-open': isOpen
        })
    }, $a5EUy.createElement("ul", {
        className: cn('header-dropdown-menu')
    }, $a5EUy.Children.map(children, function(child) {
        if ($a5EUy.isValidElement(child)) return $a5EUy.createElement((0, $fgfJw.HeaderItem), $36a702ccfb2c1a1f$var$__assign({
            _context: "li"
        }, child.props));
        return child;
    })));
};
$36a702ccfb2c1a1f$export$e93b0271171ef3a.displayName = 'Header.Dropdown';

});
parcelRegister("fgfJw", function(module, exports) {

$parcel$export(module.exports, "HeaderItem", function () { return $b1c48deef32cfe72$export$874a25df02b6ade7; });
parcelRequire("2cnsK");
var $bDBL7 = parcelRequire("bDBL7");

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
parcelRequire("kbxqT");
var $70aOe = parcelRequire("70aOe");
var $b1c48deef32cfe72$var$__assign = undefined && undefined.__assign || function() {
    $b1c48deef32cfe72$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b1c48deef32cfe72$var$__assign.apply(this, arguments);
};
var $b1c48deef32cfe72$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $b1c48deef32cfe72$var$contextMap = {
    li: {
        wrapper: 'header-dropdown-item',
        element: 'header-dropdown-link'
    },
    div: {
        wrapper: 'header-nav-item',
        element: 'header-nav-item-trigger'
    }
};
var $b1c48deef32cfe72$export$874a25df02b6ade7 = function(_a) {
    var _b;
    var children = _a.children, active = _a.isActive, label = _a.label, _c = _a.behaviour, behaviour = _c === void 0 ? 'text' : _c, icon = _a.icon, _d = _a._context, _context = _d === void 0 ? 'div' : _d;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var _e = $b1c48deef32cfe72$var$__read($a5EUy.useState(false), 2), isOpen = _e[0], toggleIsOpen = _e[1];
    var Component = _context;
    var wrapperClasses = cn((_b = {}, _b[$b1c48deef32cfe72$var$contextMap[_context].wrapper] = true, _b['is-active'] = active, _b));
    var elementClasses = $b1c48deef32cfe72$var$contextMap[_context].element;
    if (icon) {
        var classes = cn('header-icon', {
            'is-active': active
        });
        return $a5EUy.createElement(Component, {
            className: classes
        }, $a5EUy.createElement((0, $70aOe.Icon), {
            as: "button",
            icon: icon
        }));
    }
    if (behaviour === 'dropdown') {
        var handleMenuExpand = function() {
            toggleIsOpen(function(prev) {
                return !prev;
            });
        };
        var dropDownChild = function() {
            if ($a5EUy.isValidElement(children)) return $a5EUy.cloneElement(children, $b1c48deef32cfe72$var$__assign({
                isOpen: isOpen
            }, children.props));
            return undefined;
        };
        return $a5EUy.createElement(Component, {
            className: wrapperClasses
        }, $a5EUy.createElement("button", {
            className: cn(elementClasses, {
                'is-open': isOpen
            }),
            onClick: handleMenuExpand
        }, label, $a5EUy.createElement((0, $70aOe.Icon), {
            as: "span",
            className: cn({
                'is-open': isOpen
            }),
            icon: $a5EUy.createElement((0, $bDBL7.ArrowDown), null)
        })), dropDownChild());
    }
    if (behaviour === 'link') return $a5EUy.createElement(Component, {
        className: wrapperClasses
    }, children);
    // FIX HREF ATTRIBUTE with a real path
    return $a5EUy.createElement(Component, {
        className: wrapperClasses
    }, $a5EUy.createElement("a", {
        className: cn(elementClasses),
        href: "/"
    }, children));
};
$b1c48deef32cfe72$export$874a25df02b6ade7.displayName = 'Header.Item';

});


parcelRegister("jsViq", function(module, exports) {

$parcel$export(module.exports, "HeaderGroup", function () { return $e2bd13b0345feb24$export$544c0cc1f2471d5c; });
/* eslint-disable react/jsx-no-bind */ 
var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $e2bd13b0345feb24$export$544c0cc1f2471d5c = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("nav", {
        className: cn('header-nav'),
        id: "headerNav"
    }, children);
};

});

parcelRegister("aB6Yl", function(module, exports) {

$parcel$export(module.exports, "HeaderIconGroup", function () { return $7b72c4a63b0a729e$export$55509f68abe8b44e; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $fF7dP = parcelRequire("fF7dP");

var $fgfJw = parcelRequire("fgfJw");
var $7b72c4a63b0a729e$var$__assign = undefined && undefined.__assign || function() {
    $7b72c4a63b0a729e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7b72c4a63b0a729e$var$__assign.apply(this, arguments);
};
var $7b72c4a63b0a729e$export$55509f68abe8b44e = function(_a) {
    var children = _a.children, onBurgerClickHandler = _a.onBurgerClickHandler;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("nav", {
        className: cn('header-icons')
    }, $a5EUy.Children.map(children, function(child) {
        if ($a5EUy.isValidElement(child)) return $a5EUy.createElement((0, $fgfJw.HeaderItem), $7b72c4a63b0a729e$var$__assign({
            behaviour: "icon"
        }, child.props));
        return child;
    }), $a5EUy.createElement((0, $fF7dP.HeaderBurgerItem), {
        onBurgerClickHandler: onBurgerClickHandler
    }));
};
$7b72c4a63b0a729e$export$55509f68abe8b44e.displayName = 'Header.IconGroup';

});
parcelRegister("fF7dP", function(module, exports) {

$parcel$export(module.exports, "HeaderBurgerItem", function () { return $b670497ceb693fd8$export$758743339b817716; });
/* eslint-disable react/jsx-no-bind */ parcelRequire("2cnsK");
var $bVq76 = parcelRequire("bVq76");

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
parcelRequire("kbxqT");
var $70aOe = parcelRequire("70aOe");
var $b670497ceb693fd8$export$92c1304de87d1a00 = function() {
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var toggle = function() {
        var navigation = document.getElementById('headerNav');
        var overlay = document.getElementById('headerNavOverlay');
        if (navigation && overlay) {
            navigation.classList.toggle(cn('is-open'));
            overlay.classList.toggle(cn('is-open'));
        }
    };
    return {
        toggle: toggle
    };
};
var $b670497ceb693fd8$export$758743339b817716 = function(_a) {
    var onBurgerClickHandler = _a.onBurgerClickHandler;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var toggle = $b670497ceb693fd8$export$92c1304de87d1a00().toggle;
    var classes = cn('header-icon', 'is-burger');
    var expandMenuClickHandler = function() {
        toggle();
        if (onBurgerClickHandler) onBurgerClickHandler();
    };
    // TODO: the icon should be an <Icon as="button" icon={MenuNavigationVertical}/>
    return $a5EUy.createElement("div", {
        className: classes
    }, $a5EUy.createElement((0, $70aOe.Icon), {
        as: "button",
        icon: $a5EUy.createElement((0, $bVq76.MenuNavigationVertical), null),
        onClick: expandMenuClickHandler
    }));
};
$b670497ceb693fd8$export$758743339b817716.displayName = 'Header.BurgerItem'; // /**
 //  * Overlay
 //  */
 // export const Overlay: React.FunctionComponent = () => {
 //   const cn = useFrameworkClassnamePrefixer();
 //   const { toggle } = useBurgerMenu();
 //   return <div className={cn('header-overlay')} id="headerNavOverlay" onClick={toggle} />;
 // };

});




parcelRegister("gywsm", function(module, exports) {
parcelRequire("lMh4k");

});
parcelRegister("lMh4k", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $17iQT = parcelRequire("17iQT");
var $fdab522af4b4e423$var$__assign = undefined && undefined.__assign || function() {
    $fdab522af4b4e423$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fdab522af4b4e423$var$__assign.apply(this, arguments);
};
var $fdab522af4b4e423$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fdab522af4b4e423$export$54c2e3dc7acea9f5 = function(_a) {
    var children = _a.children, isBorderless = _a.isBorderless, props = $fdab522af4b4e423$var$__rest(_a, [
        "children",
        "isBorderless"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var className = cn('list', {
        'is-borderless': isBorderless
    });
    return $a5EUy.createElement("div", $fdab522af4b4e423$var$__assign({
        className: className
    }, props), children);
};
$fdab522af4b4e423$export$54c2e3dc7acea9f5.ListItem = (0, $17iQT.ListItem);

});
parcelRegister("17iQT", function(module, exports) {

$parcel$export(module.exports, "ListItem", function () { return $0d051184c08aa524$export$a7b06bfba60a8a78; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
parcelRequire("f1RE8");
var $fogwr = parcelRequire("fogwr");
var $0d051184c08aa524$var$__assign = undefined && undefined.__assign || function() {
    $0d051184c08aa524$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0d051184c08aa524$var$__assign.apply(this, arguments);
};
var $0d051184c08aa524$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0d051184c08aa524$export$a7b06bfba60a8a78 = function(_a) {
    var _b = _a.as, as = _b === void 0 ? 'div' : _b, contentBefore = _a.contentBefore, contentAfter = _a.contentAfter, title = _a.title, content = _a.content, props = $0d051184c08aa524$var$__rest(_a, [
        "as",
        "contentBefore",
        "contentAfter",
        "title",
        "content"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement((0, $fogwr.Polymorph), $0d051184c08aa524$var$__assign({
        as: as
    }, props, {
        className: cn('list-item')
    }), // eslint-disable-next-line no-null/no-null
    contentBefore ? contentBefore : null, $a5EUy.createElement("div", {
        className: cn('list-item-content')
    }, $a5EUy.createElement("p", {
        className: cn('list-item-title')
    }, title), content && $a5EUy.createElement("div", {
        className: cn('list-item-body')
    }, content)), // eslint-disable-next-line no-null/no-null
    contentAfter ? contentAfter : null);
};
$0d051184c08aa524$export$a7b06bfba60a8a78.displayName = 'List.ListItem';

});



parcelRegister("gOQwe", function(module, exports) {
parcelRequire("4Z80e");

});
parcelRegister("4Z80e", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $l5qbS = parcelRequire("l5qbS");

var $c0orU = parcelRequire("c0orU");

var $l0YPh = parcelRequire("l0YPh");

var $be40O = parcelRequire("be40O");

var $lvhZo = parcelRequire("lvhZo");

var $dpGel = parcelRequire("dpGel");

var $dvy0R = parcelRequire("dvy0R");

var $iQe73 = parcelRequire("iQe73");
var $3a131114bd8ac657$export$d9b273488cd8ce6f = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('menu')
    }, children);
};
$3a131114bd8ac657$export$d9b273488cd8ce6f.Dropdown = (0, $c0orU.MenuDropdown);
$3a131114bd8ac657$export$d9b273488cd8ce6f.List = (0, $lvhZo.MenuList);
$3a131114bd8ac657$export$d9b273488cd8ce6f.Stack = (0, $dvy0R.MenuStack);
$3a131114bd8ac657$export$d9b273488cd8ce6f.Blocks = (0, $l5qbS.MenuBlocks);
$3a131114bd8ac657$export$d9b273488cd8ce6f.Icons = (0, $l0YPh.MenuIcons);
$3a131114bd8ac657$export$d9b273488cd8ce6f.Item = (0, $be40O.MenuItem);
$3a131114bd8ac657$export$d9b273488cd8ce6f.Trigger = (0, $iQe73.MenuTrigger);
$3a131114bd8ac657$export$d9b273488cd8ce6f.Pages = (0, $dpGel.MenuPages);

});
parcelRegister("l5qbS", function(module, exports) {

$parcel$export(module.exports, "MenuBlocks", function () { return $f59e6185523bd09f$export$9aa902172f77c978; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $f59e6185523bd09f$export$9aa902172f77c978 = function(_a) {
    var children = _a.children, isOpen = _a.isOpen;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var dropDownClasses = cn('menu-blocks', {
        'is-open': isOpen
    });
    return $a5EUy.createElement("div", {
        className: dropDownClasses
    }, children);
};
$f59e6185523bd09f$export$9aa902172f77c978.displayName = 'Menu.Blocks';

});

parcelRegister("c0orU", function(module, exports) {

$parcel$export(module.exports, "MenuDropdown", function () { return $8bd873357714ee22$export$c7794ca2de686af4; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $8bd873357714ee22$export$c7794ca2de686af4 = function(_a) {
    var children = _a.children, isOpen = _a.isOpen;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var dropDownClasses = cn('menu-dropdown', {
        'is-open': isOpen
    });
    return $a5EUy.createElement("div", {
        className: dropDownClasses
    }, children);
};
$8bd873357714ee22$export$c7794ca2de686af4.displayName = 'Menu.Dropdown';

});

parcelRegister("l0YPh", function(module, exports) {

$parcel$export(module.exports, "MenuIcons", function () { return $f4c8c7d579fee7b4$export$981fb8ff62be65c8; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $f4c8c7d579fee7b4$export$981fb8ff62be65c8 = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('menu-icons')
    }, children);
};
$f4c8c7d579fee7b4$export$981fb8ff62be65c8.displayName = 'Menu.Icons';

});

parcelRegister("be40O", function(module, exports) {

$parcel$export(module.exports, "MenuItem", function () { return $82c41d3c02a1b9c2$export$2ce376c2cc3355c8; });
/* eslint-disable react/jsx-no-bind */ 
var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $iQe73 = parcelRequire("iQe73");
var $82c41d3c02a1b9c2$var$contextMap = {
    li: {
        wrapper: 'menu-item',
        element: 'menu-trigger'
    },
    div: {
        wrapper: 'menu-item',
        element: 'menu-trigger'
    }
};
var $82c41d3c02a1b9c2$export$2ce376c2cc3355c8 = function(_a) {
    var _b;
    var children = _a.children, isActive = _a.isActive, _c = _a._context, _context = _c === void 0 ? 'div' : _c, isOpen = _a.isOpen;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var Component = _context;
    var wrapperClasses = cn((_b = {}, _b[$82c41d3c02a1b9c2$var$contextMap[_context].wrapper] = true, _b['is-active'] = isActive, _b['is-open'] = isOpen, _b));
    if (typeof children === 'string') return $a5EUy.createElement(Component, {
        className: wrapperClasses
    }, $a5EUy.createElement((0, $iQe73.MenuTrigger), null, children));
    return $a5EUy.createElement(Component, {
        className: wrapperClasses
    }, children);
};
$82c41d3c02a1b9c2$export$2ce376c2cc3355c8.displayName = 'Menu.Item';

});
parcelRegister("iQe73", function(module, exports) {

$parcel$export(module.exports, "MenuTrigger", function () { return $db7807cf57d7063d$export$27d2ad3c5815583e; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
parcelRequire("kbxqT");
var $70aOe = parcelRequire("70aOe");
parcelRequire("f1RE8");
var $fogwr = parcelRequire("fogwr");
var $db7807cf57d7063d$export$27d2ad3c5815583e = function(_a) {
    var _b;
    var _c = _a.as, as = _c === void 0 ? 'button' : _c, iconRight = _a.iconRight, iconCenter = _a.iconCenter, children = _a.children, onClick = _a.onClick, parentClass = _a.parentClass;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var className = cn('menu-trigger', (_b = {}, _b["" + parentClass] = parentClass, _b));
    if (iconCenter) {
        var textClasses = cn('text');
        return $a5EUy.createElement($db7807cf57d7063d$export$27d2ad3c5815583e, {
            parentClass: "is-icon"
        }, $a5EUy.createElement((0, $70aOe.Icon), {
            icon: iconCenter
        }), $a5EUy.createElement("div", {
            className: textClasses
        }, children));
    }
    return $a5EUy.createElement((0, $fogwr.Polymorph), {
        as: as,
        className: className,
        onClick: onClick
    }, children, iconRight && $a5EUy.createElement((0, $70aOe.Icon), {
        icon: iconRight
    }));
};
$db7807cf57d7063d$export$27d2ad3c5815583e.displayName = 'Menu.Trigger';

});


parcelRegister("lvhZo", function(module, exports) {

$parcel$export(module.exports, "MenuList", function () { return $fa7a72813bbbdafc$export$d4c4e98c5044dc8; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $be40O = parcelRequire("be40O");
var $fa7a72813bbbdafc$var$__assign = undefined && undefined.__assign || function() {
    $fa7a72813bbbdafc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fa7a72813bbbdafc$var$__assign.apply(this, arguments);
};
var $fa7a72813bbbdafc$export$d4c4e98c5044dc8 = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("ul", {
        className: cn('menu-list')
    }, $a5EUy.Children.map(children, function(child) {
        if ($a5EUy.isValidElement(child)) return $a5EUy.createElement((0, $be40O.MenuItem), $fa7a72813bbbdafc$var$__assign({
            _context: "li"
        }, child.props));
        return child;
    }));
};
$fa7a72813bbbdafc$export$d4c4e98c5044dc8.displayName = 'Menu.List';

});

parcelRegister("dpGel", function(module, exports) {

$parcel$export(module.exports, "MenuPages", function () { return $9c3e5e405ae858fe$export$c9ade7ad40f5ee0; });
parcelRequire("2cnsK");
var $9ADun = parcelRequire("9ADun");
var $7gNMR = parcelRequire("7gNMR");

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
parcelRequire("kbxqT");
var $70aOe = parcelRequire("70aOe");
var $9c3e5e405ae858fe$export$8ebf4bc57ff5021 = function(_a) {
    var label = _a.label, page = _a.page, onClick = _a.onClick;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    if (page === 0) // eslint-disable-next-line no-null/no-null
    return null;
    return $a5EUy.createElement("button", {
        className: cn('menu-pages-back'),
        onClick: onClick
    }, $a5EUy.createElement((0, $70aOe.Icon), {
        icon: $a5EUy.createElement((0, $9ADun.ArrowLeft), null)
    }), $a5EUy.createElement("span", null, label));
};
$9c3e5e405ae858fe$export$8ebf4bc57ff5021.displayName = 'MenuPages.PagesBack';
var $9c3e5e405ae858fe$export$68e46bfb56b31de9 = function(_a) {
    var onClick = _a.onClick;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("button", {
        className: cn('menu-pages-close'),
        onClick: onClick
    }, $a5EUy.createElement((0, $70aOe.Icon), {
        icon: $a5EUy.createElement((0, $7gNMR.CrossBold), null)
    }));
};
$9c3e5e405ae858fe$export$68e46bfb56b31de9.displayName = 'MenuPages.PagesClose';
var $9c3e5e405ae858fe$export$3d67f97c8ce1ce96 = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var dropDownClasses = cn('menu-pages-header');
    return $a5EUy.createElement("div", {
        className: dropDownClasses
    }, children);
};
$9c3e5e405ae858fe$export$3d67f97c8ce1ce96.displayName = 'MenuPages.PagesHeader';
var $9c3e5e405ae858fe$export$4e5528e8d9514c2e = function(_a) {
    var children = _a.children, page = _a.page;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var dropDownClasses = cn('menu-pages-list');
    return $a5EUy.createElement("div", {
        className: dropDownClasses
    }, $a5EUy.Children.map(children, function(child, index) {
        if (page === index) return child;
        // eslint-disable-next-line no-null/no-null
        return null;
    }));
};
$9c3e5e405ae858fe$export$4e5528e8d9514c2e.displayName = 'MenuPages.PagesList';
var $9c3e5e405ae858fe$export$1c7e879bbf33896c = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('menu-page')
    }, children);
};
$9c3e5e405ae858fe$export$1c7e879bbf33896c.displayName = 'MenuPages.Page';
var $9c3e5e405ae858fe$export$c9ade7ad40f5ee0 = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('menu-pages')
    }, children);
};
$9c3e5e405ae858fe$export$c9ade7ad40f5ee0.Header = $9c3e5e405ae858fe$export$3d67f97c8ce1ce96;
$9c3e5e405ae858fe$export$c9ade7ad40f5ee0.List = $9c3e5e405ae858fe$export$4e5528e8d9514c2e;
$9c3e5e405ae858fe$export$c9ade7ad40f5ee0.Back = $9c3e5e405ae858fe$export$8ebf4bc57ff5021;
$9c3e5e405ae858fe$export$c9ade7ad40f5ee0.Close = $9c3e5e405ae858fe$export$68e46bfb56b31de9;
$9c3e5e405ae858fe$export$c9ade7ad40f5ee0.Page = $9c3e5e405ae858fe$export$1c7e879bbf33896c;
$9c3e5e405ae858fe$export$c9ade7ad40f5ee0.displayName = 'Menu.Pages';

});

parcelRegister("dvy0R", function(module, exports) {

$parcel$export(module.exports, "MenuStack", function () { return $9d588dd7b575a0f7$export$5cef8db5139658fa; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $9d588dd7b575a0f7$export$5cef8db5139658fa = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('menu-stack')
    }, children);
};
$9d588dd7b575a0f7$export$5cef8db5139658fa.displayName = 'Menu.Stack';

});



parcelRegister("46kjG", function(module, exports) {
$parcel$export(module.exports, "Modal", function () { return (parcelRequire("9BPY2")).Modal; });
parcelRequire("9BPY2");

});
parcelRegister("9BPY2", function(module, exports) {

$parcel$export(module.exports, "Modal", function () { return $6fefe169f8a134d5$export$2b77a92f1a5ad772; });
parcelRequire("2cnsK");
var $7gNMR = parcelRequire("7gNMR");

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
parcelRequire("kbxqT");
var $70aOe = parcelRequire("70aOe");

var $7bTgK = parcelRequire("7bTgK");

var $eFEZ7 = parcelRequire("eFEZ7");

var $augp9 = parcelRequire("augp9");

var $he2Yi = parcelRequire("he2Yi");
var $6fefe169f8a134d5$var$__assign = undefined && undefined.__assign || function() {
    $6fefe169f8a134d5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6fefe169f8a134d5$var$__assign.apply(this, arguments);
};
var $6fefe169f8a134d5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6fefe169f8a134d5$export$2b77a92f1a5ad772 = $a5EUy.forwardRef(function(_a, ref) {
    var _b;
    var heading = _a.heading, body = _a.body, action = _a.action, icon = _a.icon, _c = _a.status, status = _c === void 0 ? '' : _c, exitClickHandler = _a.exitClickHandler, props = $6fefe169f8a134d5$var$__rest(_a, [
        "heading",
        "body",
        "action",
        "icon",
        "status",
        "exitClickHandler"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var statusClasses = (_b = {
        'toast-status': status
    }, _b["status-" + status] = status, _b);
    return $a5EUy.createElement("div", $6fefe169f8a134d5$var$__assign({
        className: cn('modal-container'),
        ref: ref
    }, props, {
        role: "dialog"
    }), $a5EUy.createElement("div", {
        className: cn('toast', statusClasses)
    }, $a5EUy.createElement("div", {
        className: cn('toast-main')
    }, icon && $a5EUy.createElement("div", {
        className: cn('toast-icon')
    }, icon), $a5EUy.createElement("div", {
        className: cn('toast-content')
    }, heading, body)), $a5EUy.createElement("button", {
        className: cn('toast-close'),
        onClick: exitClickHandler,
        tabIndex: 0
    }, $a5EUy.createElement((0, $70aOe.Icon), {
        "aria-label": "close",
        icon: $a5EUy.createElement((0, $7gNMR.CrossBold), null)
    })), action));
});
$6fefe169f8a134d5$export$2b77a92f1a5ad772.Heading = (0, $augp9.ModalHeading);
$6fefe169f8a134d5$export$2b77a92f1a5ad772.Body = (0, $eFEZ7.ModalBody);
$6fefe169f8a134d5$export$2b77a92f1a5ad772.Action = (0, $7bTgK.ModalAction);
$6fefe169f8a134d5$export$2b77a92f1a5ad772.Inset = (0, $he2Yi.ModalInset);

});
parcelRegister("7bTgK", function(module, exports) {

$parcel$export(module.exports, "ModalAction", function () { return $53c46ec880c4bdee$export$4772a6b0d09e1d41; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $53c46ec880c4bdee$var$__assign = undefined && undefined.__assign || function() {
    $53c46ec880c4bdee$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $53c46ec880c4bdee$var$__assign.apply(this, arguments);
};
var $53c46ec880c4bdee$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $53c46ec880c4bdee$export$4772a6b0d09e1d41 = $a5EUy.forwardRef(function(_a, ref) {
    var children = _a.children, props = $53c46ec880c4bdee$var$__rest(_a, [
        "children"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", $53c46ec880c4bdee$var$__assign({
        className: cn('toast-actions')
    }, props, {
        ref: ref
    }), $a5EUy.createElement("div", {
        className: cn('buttons', 'is-end')
    }, children));
});
$53c46ec880c4bdee$export$4772a6b0d09e1d41.displayName = 'Modal.Action';

});

parcelRegister("eFEZ7", function(module, exports) {

$parcel$export(module.exports, "ModalBody", function () { return $aae4afbb2b8afbda$export$cb540d8b0ef7906c; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $aae4afbb2b8afbda$var$__assign = undefined && undefined.__assign || function() {
    $aae4afbb2b8afbda$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $aae4afbb2b8afbda$var$__assign.apply(this, arguments);
};
var $aae4afbb2b8afbda$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $aae4afbb2b8afbda$export$cb540d8b0ef7906c = $a5EUy.forwardRef(function(_a, ref) {
    var children = _a.children, props = $aae4afbb2b8afbda$var$__rest(_a, [
        "children"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", $aae4afbb2b8afbda$var$__assign({
        className: cn('toast-body')
    }, props, {
        ref: ref
    }), children);
});
$aae4afbb2b8afbda$export$cb540d8b0ef7906c.displayName = 'Modal.Body';

});

parcelRegister("augp9", function(module, exports) {

$parcel$export(module.exports, "ModalHeading", function () { return $7a296e5ef0d295b3$export$9af27c346834c182; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $7a296e5ef0d295b3$var$__assign = undefined && undefined.__assign || function() {
    $7a296e5ef0d295b3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7a296e5ef0d295b3$var$__assign.apply(this, arguments);
};
var $7a296e5ef0d295b3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7a296e5ef0d295b3$export$9af27c346834c182 = $a5EUy.forwardRef(function(_a, ref) {
    var children = _a.children, props = $7a296e5ef0d295b3$var$__rest(_a, [
        "children"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", $7a296e5ef0d295b3$var$__assign({
        className: cn('toast-heading'),
        ref: ref
    }, props), children);
});
$7a296e5ef0d295b3$export$9af27c346834c182.displayName = 'Modal.Heading';

});

parcelRegister("he2Yi", function(module, exports) {

$parcel$export(module.exports, "ModalInset", function () { return $c8a60c88c030495d$export$3e66242728a15052; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $c8a60c88c030495d$var$__assign = undefined && undefined.__assign || function() {
    $c8a60c88c030495d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c8a60c88c030495d$var$__assign.apply(this, arguments);
};
var $c8a60c88c030495d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c8a60c88c030495d$export$3e66242728a15052 = $a5EUy.forwardRef(function(_a, ref) {
    var children = _a.children, props = $c8a60c88c030495d$var$__rest(_a, [
        "children"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", $c8a60c88c030495d$var$__assign({
        className: cn('toast-inset'),
        ref: ref
    }, props), children);
});
$c8a60c88c030495d$export$3e66242728a15052.displayName = 'Modal.Inset';

});



parcelRegister("7elP5", function(module, exports) {
$parcel$export(module.exports, "Overlay", function () { return (parcelRequire("gDChL")).Overlay; });
parcelRequire("gDChL");

});
parcelRegister("gDChL", function(module, exports) {

$parcel$export(module.exports, "Overlay", function () { return $c1cdfc96780be799$export$c6fdb837b070b4ff; });

var $a5EUy = parcelRequire("a5EUy");
parcelRequire("bHt1e");
var $iQCcD = parcelRequire("iQCcD");

var $jLRsx = parcelRequire("jLRsx");
var $c1cdfc96780be799$var$__assign = undefined && undefined.__assign || function() {
    $c1cdfc96780be799$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c1cdfc96780be799$var$__assign.apply(this, arguments);
};
var $c1cdfc96780be799$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c1cdfc96780be799$export$c055307528189a65;
(function(OverlayMode) {
    OverlayMode["Container"] = "container";
    OverlayMode["Page"] = "page";
})($c1cdfc96780be799$export$c055307528189a65 || ($c1cdfc96780be799$export$c055307528189a65 = {}));
var $c1cdfc96780be799$export$c6fdb837b070b4ff = $a5EUy.forwardRef(function(_a, ref) {
    var children = _a.children, _b = _a.mode, mode = _b === void 0 ? $c1cdfc96780be799$export$c055307528189a65.Page : _b, onClick = _a.onClick, isOpen = _a.isOpen, props = $c1cdfc96780be799$var$__rest(_a, [
        "children",
        "mode",
        "onClick",
        "isOpen"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var overlayRef = (0, $iQCcD.useShareForwardRef)(ref);
    var clickHandler = $a5EUy.useCallback(function(e) {
        if (overlayRef.current === e.target) {
            if (onClick) onClick();
        }
    }, [
        onClick
    ]);
    return $a5EUy.createElement("div", $c1cdfc96780be799$var$__assign({
        className: cn('overlay', "overlay-" + mode, {
            'is-open': isOpen
        }),
        onClick: clickHandler,
        ref: overlayRef,
        role: "presentation",
        tabIndex: -1
    }, props), children);
});

});


parcelRegister("6QA4z", function(module, exports) {
parcelRequire("3TvnI");

});
parcelRegister("3TvnI", function(module, exports) {
parcelRequire("2cnsK");
var $bR1AW = parcelRequire("bR1AW");
var $i7Ag6 = parcelRequire("i7Ag6");

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $3C8NY = parcelRequire("3C8NY");

var $fceIV = parcelRequire("fceIV");

var $1aQsQ = parcelRequire("1aQsQ");

var $3mxfg = parcelRequire("3mxfg");
var $2d5ed9db032b92ec$var$__assign = undefined && undefined.__assign || function() {
    $2d5ed9db032b92ec$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2d5ed9db032b92ec$var$__assign.apply(this, arguments);
};
var $2d5ed9db032b92ec$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2d5ed9db032b92ec$export$68f5e1453c188a82 = function(_a) {
    var _b = _a.isCentered, isCentered = _b === void 0 ? false : _b, _c = _a.isStacked, isStacked = _c === void 0 ? false : _c, showFirstLast = _a.showFirstLast, showPageSizeSelector = _a.showPageSizeSelector, onSizeChange = _a.onSizeChange, props = $2d5ed9db032b92ec$var$__rest(_a, [
        "isCentered",
        "isStacked",
        "showFirstLast",
        "showPageSizeSelector",
        "onSizeChange"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var _d = (0, $3mxfg.usePagination)($2d5ed9db032b92ec$var$__assign({}, props)), getPaginationItems = _d.getPaginationItems, getNavigation = _d.getNavigation;
    // eslint-disable-next-line no-null/no-null
    var sharedRef = $a5EUy.useRef(null);
    var onFocus = function() {
        var _a;
        (_a = sharedRef.current) === null || _a === void 0 || _a.focus();
    };
    return $a5EUy.createElement("nav", {
        "aria-label": "pagination navigation",
        className: cn('pagination', {
            'is-centered': isCentered,
            'is-stacked': isStacked
        }),
        // eslint-disable-next-line react/jsx-no-bind
        onFocus: onFocus,
        tabIndex: 0
    }, $a5EUy.createElement("ol", {
        className: cn('pagination-list')
    }, showFirstLast && $a5EUy.createElement((0, $3C8NY.PaginationButton), $2d5ed9db032b92ec$var$__assign({
        icon: $a5EUy.createElement((0, $bR1AW.ArrowLeftBold), null)
    }, getNavigation().first())), $a5EUy.createElement((0, $3C8NY.PaginationButton), $2d5ed9db032b92ec$var$__assign({
        icon: $a5EUy.createElement((0, $bR1AW.ArrowLeftBold), null)
    }, getNavigation().prev())), getPaginationItems().map(function(_a) {
        var key = _a.key, item = $2d5ed9db032b92ec$var$__rest(_a, [
            "key"
        ]);
        return $a5EUy.createElement((0, $fceIV.PaginationItem), $2d5ed9db032b92ec$var$__assign({
            key: key
        }, item));
    }), $a5EUy.createElement((0, $3C8NY.PaginationButton), $2d5ed9db032b92ec$var$__assign({
        icon: $a5EUy.createElement((0, $i7Ag6.ArrowRightBold), null)
    }, getNavigation().next())), showFirstLast && $a5EUy.createElement((0, $3C8NY.PaginationButton), $2d5ed9db032b92ec$var$__assign({
        icon: $a5EUy.createElement((0, $i7Ag6.ArrowRightBold), null)
    }, getNavigation().last()))), showPageSizeSelector && $a5EUy.createElement((0, $1aQsQ.PaginationResult), {
        onSizeChange: onSizeChange
    }));
};

});
parcelRegister("3C8NY", function(module, exports) {

$parcel$export(module.exports, "PaginationAction", function () { return $2a1bc02f2c1887e1$export$8302fb64fcdab778; });
$parcel$export(module.exports, "PaginationButton", function () { return $2a1bc02f2c1887e1$export$c3639e97caabff2c; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
parcelRequire("kbxqT");
var $70aOe = parcelRequire("70aOe");
var $2a1bc02f2c1887e1$export$8302fb64fcdab778;
(function(PaginationAction) {
    PaginationAction["Next"] = "Next";
    PaginationAction["Prev"] = "Prev";
    PaginationAction["First"] = "First";
    PaginationAction["Last"] = "Last";
})($2a1bc02f2c1887e1$export$8302fb64fcdab778 || ($2a1bc02f2c1887e1$export$8302fb64fcdab778 = {}));
var $2a1bc02f2c1887e1$export$c3639e97caabff2c = $a5EUy.forwardRef(function(_a, ref) {
    var label = _a.label, icon = _a.icon, withText = _a.withText, navAction = _a.navAction, _b = _a.iconPosition, iconPosition = _b === void 0 ? 'left' : _b, hasFocus = _a.hasFocus, onClick = _a.onClick;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    // eslint-disable-next-line no-null/no-null
    var sharedRef = $a5EUy.useRef(null);
    var onPaginationItemClick = $a5EUy.useCallback(function() {
        if (onClick && navAction !== undefined) onClick(navAction);
    }, []);
    $a5EUy.useEffect(function() {
        if (hasFocus) {
            if (sharedRef.current) sharedRef.current.focus();
        }
    }, [
        hasFocus,
        ref
    ]);
    var onKeyDown = $a5EUy.useCallback(function(e) {
        if (hasFocus) switch(e.key){
            case 'Enter':
                e.preventDefault();
                if (onClick && navAction !== undefined) onClick(navAction);
        }
    }, [
        hasFocus
    ]);
    return $a5EUy.createElement("li", {
        className: cn('pagination-item', 'is-icon')
    }, $a5EUy.createElement("button", {
        "data-text": label,
        onClick: onPaginationItemClick,
        onKeyDown: onKeyDown,
        ref: sharedRef,
        role: "button",
        tabIndex: !hasFocus ? -1 : 0
    }, iconPosition === 'right' || $a5EUy.createElement((0, $70aOe.Icon), {
        icon: icon
    }), withText !== null && withText !== void 0 ? withText : $a5EUy.createElement("span", {
        className: cn('pagination-item-text')
    }, label), iconPosition === 'left' || $a5EUy.createElement((0, $70aOe.Icon), {
        icon: icon
    })));
});

});

parcelRegister("fceIV", function(module, exports) {

$parcel$export(module.exports, "PaginationItem", function () { return $b10365cdf8fe5046$export$c82a077939f0464b; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $b10365cdf8fe5046$export$c82a077939f0464b = function(_a) {
    var page = _a.page, _b = _a.isSelected, isSelected = _b === void 0 ? false : _b, _c = _a.isEllipsis, isEllipsis = _c === void 0 ? false : _c, onClick = _a.onClick;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var onPaginationItemClick = $a5EUy.useCallback(function() {
        if (onClick) onClick(page);
    }, [
        page
    ]);
    var pagelabel = !isEllipsis ? page : '...';
    return $a5EUy.createElement("li", {
        className: cn('pagination-item', {
            'is-active': isSelected
        }),
        role: "presentation"
    }, $a5EUy.createElement("button", {
        "aria-label": "" + page,
        "data-text": pagelabel,
        onClick: onPaginationItemClick,
        tabIndex: -1
    }, $a5EUy.createElement("span", {
        className: cn('pagination-item-text')
    }, pagelabel)));
};

});

parcelRegister("1aQsQ", function(module, exports) {

$parcel$export(module.exports, "PaginationResult", function () { return $0daf6bee160488e3$export$f3c3b6eb4de78615; });
/* eslint-disable react/jsx-no-bind */ 
var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
parcelRequire("aDAfa");
var $6sugK = parcelRequire("6sugK");
var $0daf6bee160488e3$var$standardSelectionRange = [
    {
        label: '10',
        value: 10
    },
    {
        label: '20',
        value: 20
    },
    {
        label: '50',
        value: 50
    },
    {
        label: '100',
        value: 100
    }
];
var $0daf6bee160488e3$export$f3c3b6eb4de78615 = function(_a) {
    var _b = _a.description, description = _b === void 0 ? 'Results per page' : _b, _c = _a.sizeOptions, sizeOptions = _c === void 0 ? $0daf6bee160488e3$var$standardSelectionRange : _c, onSizeChange = _a.onSizeChange;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var onSelect = $a5EUy.useCallback(function(_a) {
        var value = _a.value;
        if (onSizeChange) onSizeChange(value);
    }, [
        sizeOptions
    ]);
    var options = $a5EUy.useMemo(function() {
        return sizeOptions.map(function(size) {
            return $a5EUy.createElement((0, $6sugK.Select).Option, {
                key: size.value,
                label: size.label,
                value: size.value
            });
        });
    }, [
        sizeOptions
    ]);
    return $a5EUy.createElement("div", {
        "aria-label": "pagination result",
        className: cn('pagination-results'),
        role: "presentation"
    }, $a5EUy.createElement("p", {
        className: cn('pagination-results-label')
    }, description), $a5EUy.createElement((0, $6sugK.Select), {
        onOptionSelect: onSelect,
        tabIndex: 0
    }, options));
};

});
parcelRegister("aDAfa", function(module, exports) {
$parcel$export(module.exports, "Select", function () { return (parcelRequire("6sugK")).Select; });
parcelRequire("6sugK");

});
parcelRegister("6sugK", function(module, exports) {

$parcel$export(module.exports, "Select", function () { return $4b3cd66dfbc2a65a$export$ef9b1a59e592288f; });
parcelRequire("2cnsK");
var $bDBL7 = parcelRequire("bDBL7");

var $a5EUy = parcelRequire("a5EUy");
parcelRequire("bHt1e");
var $gSNWl = parcelRequire("gSNWl");
var $iQCcD = parcelRequire("iQCcD");

var $jLRsx = parcelRequire("jLRsx");
parcelRequire("6yhm4");
var $hd3cd = parcelRequire("hd3cd");
var $2u0dC = parcelRequire("2u0dC");

var $jCE8G = parcelRequire("jCE8G");
parcelRequire("kbxqT");
var $70aOe = parcelRequire("70aOe");
parcelRequire("ffOgG");
var $k2qJY = parcelRequire("k2qJY");
var $2lRMk = parcelRequire("2lRMk");
var $4b3cd66dfbc2a65a$var$__assign = undefined && undefined.__assign || function() {
    $4b3cd66dfbc2a65a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4b3cd66dfbc2a65a$var$__assign.apply(this, arguments);
};
var $4b3cd66dfbc2a65a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4b3cd66dfbc2a65a$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $4b3cd66dfbc2a65a$export$ef9b1a59e592288f = $a5EUy.forwardRef(function(_a, ref) {
    var value = _a.value, name = _a.name, children = _a.children, onOptionSelect = _a.onOptionSelect, onOptionDelete = _a.onOptionDelete, _b = _a.isMultiSelect, isMultiSelect = _b === void 0 ? false : _b, props = $4b3cd66dfbc2a65a$var$__rest(_a, [
        "value",
        "name",
        "children",
        "onOptionSelect",
        "onOptionDelete",
        "isMultiSelect"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    // eslint-disable-next-line no-null/no-null
    var dropdown = $a5EUy.useRef(null);
    // eslint-disable-next-line no-null/no-null
    var input = $a5EUy.useRef(null);
    var select = (0, $iQCcD.useShareForwardRef)(ref);
    var _c = (0, $2u0dC.useDropdown)(dropdown, select, {
        inheritWidth: true
    }), toggleVisible = _c.toggleVisible, setVisible = _c.setVisible;
    var _d = $4b3cd66dfbc2a65a$var$__read($a5EUy.useState(false), 2), hasFocus = _d[0], setHasFocus = _d[1];
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var _e = $4b3cd66dfbc2a65a$var$__read($a5EUy.useState(false), 2), dropdownFocus = _e[0], setDropdownFocus = _e[1];
    (0, $gSNWl.useClickOutside)(dropdown, function() {
        setVisible(false);
    });
    var handleClick = $a5EUy.useCallback(function(event) {
        event.stopPropagation();
        setVisible(function(isOpen) {
            if (isOpen && isMultiSelect) return true;
            return !isOpen;
        });
    }, [
        input,
        isMultiSelect
    ]);
    var displayValue = $a5EUy.useMemo(function() {
        var _a;
        if (isMultiSelect) {
            var actualValue = value;
            if (actualValue.length > 0) {
                var tags = Array.from(actualValue).map(function(val) {
                    return $a5EUy.createElement((0, $k2qJY.Tag), {
                        key: val.label + val.value,
                        label: val.label,
                        onDelete: function() {
                            if (onOptionDelete) onOptionDelete(val);
                        },
                        showDelete: true
                    });
                });
                return $a5EUy.createElement((0, $2lRMk.Tags), null, tags);
            } else return 'Select one or more options';
        } else return (_a = value) === null || _a === void 0 ? void 0 : _a.label;
    }, [
        value
    ]);
    var onKeyDown = function(e) {
        if (hasFocus) switch(e.key){
            case ' ':
                e.preventDefault();
                toggleVisible();
                setDropdownFocus(true);
                return;
        }
    };
    return $a5EUy.createElement("div", $4b3cd66dfbc2a65a$var$__assign({}, props, {
        className: cn('input', 'is-select'),
        onClick: (0, $jLRsx.chain)(handleClick, props.onClick),
        onFocus: function() {
            return setHasFocus(true);
        },
        onKeyDown: (0, $jLRsx.chain)(onKeyDown, props.onKeyDown),
        ref: select,
        role: "input",
        tabIndex: hasFocus ? 0 : -1
    }), $a5EUy.createElement("span", {
        className: cn('input-content')
    }, displayValue), $a5EUy.createElement((0, $70aOe.Icon), {
        icon: $a5EUy.createElement((0, $bDBL7.ArrowDown), null)
    }), $a5EUy.createElement("input", {
        className: cn('input-hidden'),
        name: name,
        readOnly: true,
        ref: input,
        value: JSON.stringify(value)
    }), $a5EUy.createElement((0, $hd3cd.Dropdown), {
        _hasFocus: dropdownFocus,
        onDropdownSelect: onOptionSelect,
        ref: dropdown,
        value: value
    }, children));
});
$4b3cd66dfbc2a65a$export$ef9b1a59e592288f.Option = (0, $jCE8G.DropdownItem);

});
parcelRegister("ffOgG", function(module, exports) {
$parcel$export(module.exports, "Tag", function () { return (parcelRequire("k2qJY")).Tag; });
$parcel$export(module.exports, "Tags", function () { return (parcelRequire("2lRMk")).Tags; });
parcelRequire("k2qJY");
parcelRequire("2lRMk");

});
parcelRegister("k2qJY", function(module, exports) {

$parcel$export(module.exports, "Tag", function () { return $e968bca94ab5675a$export$3288d34c523a1192; });
parcelRequire("2cnsK");
var $7gNMR = parcelRequire("7gNMR");

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
parcelRequire("kbxqT");
var $70aOe = parcelRequire("70aOe");
parcelRequire("f1RE8");
var $fogwr = parcelRequire("fogwr");
var $e968bca94ab5675a$var$__assign = undefined && undefined.__assign || function() {
    $e968bca94ab5675a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e968bca94ab5675a$var$__assign.apply(this, arguments);
};
var $e968bca94ab5675a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e968bca94ab5675a$export$3288d34c523a1192 = $a5EUy.forwardRef(function(_a, ref) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, label = _a.label, isDisabled = _a.isDisabled, showDelete = _a.showDelete, isInteractive = _a.isInteractive, onDelete = _a.onDelete, onClick = _a.onClick, props = $e968bca94ab5675a$var$__rest(_a, [
        "size",
        "label",
        "isDisabled",
        "showDelete",
        "isInteractive",
        "onDelete",
        "onClick"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("span", $e968bca94ab5675a$var$__assign({
        className: cn('tag', "is-" + size, {
            'is-disabled': isDisabled
        }),
        ref: ref
    }, props), $a5EUy.createElement((0, $fogwr.Polymorph), {
        as: isInteractive ? 'button' : 'span',
        className: cn('tag-item'),
        onClick: isInteractive ? onClick : undefined
    }, label), showDelete && $a5EUy.createElement("button", {
        className: cn('tag-item', 'is-icon'),
        onClick: onDelete
    }, $a5EUy.createElement((0, $70aOe.Icon), {
        as: "span",
        icon: $a5EUy.createElement((0, $7gNMR.CrossBold), null)
    })));
});

});

parcelRegister("2lRMk", function(module, exports) {

$parcel$export(module.exports, "Tags", function () { return $1b67423c1fb40a31$export$b72686b556e29ca6; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $1b67423c1fb40a31$export$b72686b556e29ca6 = function(_a) {
    var _b;
    var children = _a.children, _c = _a.size, size = _c === void 0 ? 'medium' : _c;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var className = cn('tags', (_b = {}, _b["are-" + size] = size, _b));
    return $a5EUy.createElement("div", {
        className: className
    }, children);
};

});





parcelRegister("3mxfg", function(module, exports) {

$parcel$export(module.exports, "usePagination", function () { return $272d36f981f15a88$export$f80c710216eae131; });

var $a5EUy = parcelRequire("a5EUy");

var $3C8NY = parcelRequire("3C8NY");
var $272d36f981f15a88$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $272d36f981f15a88$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($272d36f981f15a88$var$__read(arguments[i]));
    return ar;
};
var $272d36f981f15a88$var$itemsAmout = 7;
var $272d36f981f15a88$var$startEndAmount = 4;
var $272d36f981f15a88$export$f80c710216eae131 = function(_a) {
    var page = _a.page, totalPages = _a.totalPages, _b = _a.nextLabel, nextLabel = _b === void 0 ? 'Next' : _b, _c = _a.prevLabel, prevLabel = _c === void 0 ? 'Previous' : _c, _d = _a.lastLabel, lastLabel = _d === void 0 ? 'Last' : _d, _e = _a.firstLabel, firstLabel = _e === void 0 ? 'First' : _e, _f = _a.showLabel, showLabel = _f === void 0 ? true : _f, onPageClick = _a.onPageClick;
    var _g = $272d36f981f15a88$var$__read($a5EUy.useState(page), 2), currentPage = _g[0], setCurrentPage = _g[1];
    var onClick = function(clickedPage) {
        setCurrentPage(clickedPage);
    };
    var onNavigationClick = function(action) {
        switch(action){
            case (0, $3C8NY.PaginationAction).First:
                setCurrentPage(1);
                break;
            case (0, $3C8NY.PaginationAction).Last:
                setCurrentPage(totalPages);
                break;
            case (0, $3C8NY.PaginationAction).Next:
                setCurrentPage(function(prev) {
                    return prev !== totalPages ? ++prev : prev;
                });
                break;
            case (0, $3C8NY.PaginationAction).Prev:
                setCurrentPage(function(prev) {
                    return prev !== 1 ? --prev : prev;
                });
                break;
        }
    };
    $a5EUy.useLayoutEffect(function() {
        if (onPageClick) onPageClick(currentPage);
    }, [
        currentPage
    ]);
    var fullLayout = function() {
        var items = [];
        for(var index = 1; index <= totalPages; index++)items = $272d36f981f15a88$var$__spread(items, [
            {
                key: index,
                onClick: onClick,
                page: index,
                isSelected: index === page
            }
        ]);
        return items;
    };
    var edgeLayout = function() {
        var items = [];
        if (page > totalPages - $272d36f981f15a88$var$startEndAmount) {
            items = $272d36f981f15a88$var$__spread(items, [
                {
                    key: 1,
                    onClick: onClick,
                    page: 1
                }
            ]);
            items = $272d36f981f15a88$var$__spread(items, [
                {
                    isEllipsis: true,
                    key: Math.random(),
                    page: 0
                }
            ]);
        }
        for(var index = 1; index <= 5; index++){
            var itemPage = page <= 4 ? index : totalPages - 5 + index;
            var isSelected = itemPage === page;
            items = $272d36f981f15a88$var$__spread(items, [
                {
                    key: itemPage,
                    onClick: onClick,
                    page: itemPage,
                    isSelected: isSelected
                }
            ]);
        }
        if (page <= $272d36f981f15a88$var$startEndAmount) {
            items = $272d36f981f15a88$var$__spread(items, [
                {
                    isEllipsis: true,
                    key: Math.random(),
                    page: 0
                }
            ]);
            items = $272d36f981f15a88$var$__spread(items, [
                {
                    key: totalPages,
                    onClick: onClick,
                    page: totalPages
                }
            ]);
        }
        return items;
    };
    var middleLayout = function() {
        var items = [];
        items = $272d36f981f15a88$var$__spread(items, [
            {
                key: 1,
                onClick: onClick,
                page: 1
            }
        ]);
        items = $272d36f981f15a88$var$__spread(items, [
            {
                isEllipsis: true,
                key: Math.random(),
                page: 0
            }
        ]);
        for(var index = page - 1; index < page + 2; index++)items = $272d36f981f15a88$var$__spread(items, [
            {
                key: index,
                onClick: onClick,
                page: index,
                isSelected: index === page
            }
        ]);
        items = $272d36f981f15a88$var$__spread(items, [
            {
                isEllipsis: true,
                key: Math.random(),
                page: 0
            }
        ]);
        items = $272d36f981f15a88$var$__spread(items, [
            {
                key: totalPages,
                onClick: onClick,
                page: totalPages
            }
        ]);
        return items;
    };
    var getPaginationItems = $a5EUy.useCallback(function() {
        if (totalPages <= $272d36f981f15a88$var$itemsAmout) return fullLayout();
        if (page > $272d36f981f15a88$var$startEndAmount && page <= totalPages - $272d36f981f15a88$var$startEndAmount) return middleLayout();
        return edgeLayout();
    }, [
        page,
        totalPages
    ]);
    var getNavigation = function() {
        return {
            prev: function() {
                return {
                    ariaLabel: prevLabel,
                    label: showLabel ? prevLabel : '',
                    navAction: (0, $3C8NY.PaginationAction).Prev,
                    onClick: onNavigationClick
                };
            },
            next: function() {
                return {
                    ariaLabel: nextLabel,
                    label: showLabel ? nextLabel : '',
                    iconPosition: 'right',
                    navAction: (0, $3C8NY.PaginationAction).Next,
                    onClick: onNavigationClick
                };
            },
            first: function() {
                return {
                    ariaLabel: firstLabel,
                    label: showLabel ? firstLabel : '',
                    navAction: (0, $3C8NY.PaginationAction).First,
                    onClick: onNavigationClick
                };
            },
            last: function() {
                return {
                    ariaLabel: lastLabel,
                    label: showLabel ? lastLabel : '',
                    iconPosition: 'right',
                    navAction: (0, $3C8NY.PaginationAction).Last,
                    onClick: onNavigationClick
                };
            }
        };
    };
    return {
        getPaginationItems: getPaginationItems,
        getNavigation: getNavigation
    };
};

});



parcelRegister("8AgmX", function(module, exports) {
parcelRequire("fGAjK");

});
parcelRegister("fGAjK", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");

var $jUibk = parcelRequire("jUibk");
parcelRequire("bHt1e");
var $1225g = parcelRequire("1225g");
var $gSNWl = parcelRequire("gSNWl");
parcelRequire("aQ8nw");
var $gzuHW = parcelRequire("gzuHW");

var $12gHN = parcelRequire("12gHN");
var $b6b6f32d49555641$var$__assign = undefined && undefined.__assign || function() {
    $b6b6f32d49555641$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b6b6f32d49555641$var$__assign.apply(this, arguments);
};
var $b6b6f32d49555641$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $b6b6f32d49555641$export$5b6b19405a83ff9d = function(_a) {
    var children = _a.children, content = _a.content, title = _a.title, _b = _a.popoverPosition, popoverPosition = _b === void 0 ? 'bottom' : _b;
    // eslint-disable-next-line no-null/no-null
    var _c = $b6b6f32d49555641$var$__read($a5EUy.useState(null), 2), referenceElement = _c[0], setReferenceElement = _c[1];
    // eslint-disable-next-line no-null/no-null
    var _d = $b6b6f32d49555641$var$__read($a5EUy.useState(null), 2), popperElement = _d[0], setPopperElement = _d[1];
    var _e = $b6b6f32d49555641$var$__read($a5EUy.useState(false), 2), isVisible = _e[0], setIsVisible = _e[1];
    var portalRoot = (0, $1225g.usePortalRoot)((0, $1225g.PortalRoots).POPOVER).portalRoot;
    var _f = (0, $gzuHW.useTooltipControl)(referenceElement, popperElement, popoverPosition), styles = _f.styles, attributes = _f.attributes, position = _f.position;
    var renderPopover = function() {
        if (isVisible) return $jUibk.createPortal($a5EUy.createElement((0, $12gHN.PopoverBody), $b6b6f32d49555641$var$__assign({
            "aria-label": title,
            // eslint-disable-next-line react/jsx-no-bind
            onExit: function() {
                return setIsVisible(false);
            },
            ref: setPopperElement,
            style: styles.popper
        }, attributes.popper, {
            content: content,
            position: position,
            title: title
        })), portalRoot);
        return undefined;
    };
    (0, $gSNWl.useClickOutside)([
        {
            current: popperElement
        },
        {
            current: referenceElement
        }
    ], function() {
        setIsVisible(false);
    });
    return $a5EUy.createElement($a5EUy.Fragment, null, $a5EUy.isValidElement(children) && $a5EUy.cloneElement(children, $b6b6f32d49555641$var$__assign({
        onClick: function() {
            return setIsVisible(true);
        },
        ref: function(node) {
            return setReferenceElement(node);
        }
    }, children.props)), renderPopover());
};

});
parcelRegister("aQ8nw", function(module, exports) {
$parcel$export(module.exports, "useTooltipControl", function () { return (parcelRequire("gzuHW")).useTooltipControl; });
parcelRequire("3lL2m");
parcelRequire("gzuHW");

});
parcelRegister("3lL2m", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");

var $jUibk = parcelRequire("jUibk");
parcelRequire("bHt1e");
var $1225g = parcelRequire("1225g");

var $ladul = parcelRequire("ladul");

var $gzuHW = parcelRequire("gzuHW");
var $2707d1da393a3384$var$__assign = undefined && undefined.__assign || function() {
    $2707d1da393a3384$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2707d1da393a3384$var$__assign.apply(this, arguments);
};
var $2707d1da393a3384$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $2707d1da393a3384$export$28c660c63b792dea = function(_a) {
    var children = _a.children, label = _a.label, _b = _a.tooltipPosition, tooltipPosition = _b === void 0 ? 'top' : _b;
    // eslint-disable-next-line no-null/no-null
    var _c = $2707d1da393a3384$var$__read($a5EUy.useState(null), 2), referenceElement = _c[0], setReferenceElement = _c[1];
    // eslint-disable-next-line no-null/no-null
    var _d = $2707d1da393a3384$var$__read($a5EUy.useState(null), 2), popperElement = _d[0], setPopperElement = _d[1];
    var _e = $2707d1da393a3384$var$__read($a5EUy.useState(false), 2), isVisible = _e[0], setIsVisible = _e[1];
    var portalRoot = (0, $1225g.usePortalRoot)((0, $1225g.PortalRoots).TOOLTIP).portalRoot;
    var _f = (0, $gzuHW.useTooltipControl)(referenceElement, popperElement, tooltipPosition), styles = _f.styles, attributes = _f.attributes, position = _f.position;
    var renderToolTip = function() {
        if (isVisible) return $jUibk.createPortal($a5EUy.createElement((0, $ladul.TooltipBox), $2707d1da393a3384$var$__assign({
            ref: setPopperElement,
            style: styles.popper
        }, attributes.popper, {
            arrowPosition: position,
            label: label
        })), portalRoot);
        return undefined;
    };
    return $a5EUy.createElement($a5EUy.Fragment, null, $a5EUy.isValidElement(children) && $a5EUy.cloneElement(children, $2707d1da393a3384$var$__assign({
        onMouseLeave: function() {
            return setIsVisible(false);
        },
        onMouseOver: function() {
            return setIsVisible(true);
        },
        ref: function(node) {
            return setReferenceElement(node);
        }
    }, children.props)), renderToolTip());
};

});
parcelRegister("ladul", function(module, exports) {

$parcel$export(module.exports, "TooltipBox", function () { return $f684fea7d85e31b7$export$e4d8dc88bb9cc931; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $f684fea7d85e31b7$var$__assign = undefined && undefined.__assign || function() {
    $f684fea7d85e31b7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f684fea7d85e31b7$var$__assign.apply(this, arguments);
};
var $f684fea7d85e31b7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f684fea7d85e31b7$export$e4d8dc88bb9cc931 = $a5EUy.forwardRef(function(_a, ref) {
    var label = _a.label, arrowPosition = _a.arrowPosition, props = $f684fea7d85e31b7$var$__rest(_a, [
        "label",
        "arrowPosition"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", $f684fea7d85e31b7$var$__assign({
        className: cn('toast', 'popover', 'tooltip', arrowPosition),
        ref: ref,
        tabIndex: -1
    }, props), $a5EUy.createElement("div", {
        className: cn('arrow-below')
    }), $a5EUy.createElement("div", {
        className: cn('arrow-above')
    }), $a5EUy.createElement("div", {
        className: cn('toast-main')
    }, $a5EUy.createElement("div", {
        className: cn('toast-content')
    }, $a5EUy.createElement("div", {
        className: cn('toast-body')
    }, $a5EUy.createElement("p", null, label)))));
});

});

parcelRegister("gzuHW", function(module, exports) {

$parcel$export(module.exports, "useTooltipControl", function () { return $c107bc29406052d9$export$1afc38dc718ba2c4; });

var $a5EUy = parcelRequire("a5EUy");

var $3pDZx = parcelRequire("3pDZx");
var $c107bc29406052d9$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
// eslint-disable-next-line complexity
var $c107bc29406052d9$var$getArrowPlacement = function(placement) {
    switch(placement){
        case 'bottom':
            return 'arrow-nn';
        case 'bottom-end':
            return 'arrow-nw';
        case 'bottom-start':
            return 'arrow-ne';
        case 'top':
            return 'arrow-ss';
        case 'top-end':
            return 'arrow-sw';
        case 'top-start':
            return 'arrow-se';
        case 'right':
            return 'arrow-ww';
        case 'right-end':
            return 'arrow-ws';
        case 'right-start':
            return 'arrow-wn';
        case 'left':
            return 'arrow-ee';
        case 'left-end':
            return 'arrow-es';
        case 'left-start':
            return 'arrow-en';
        default:
            return 'arrow-nn';
    }
};
var $c107bc29406052d9$export$1afc38dc718ba2c4 = function(refElement, popperElement, popperPlacement) {
    var _a = $c107bc29406052d9$var$__read($a5EUy.useState(''), 2), position = _a[0], setPosition = _a[1];
    var handlePosision = $a5EUy.useCallback(function(options) {
        var state = options.state;
        setPosition($c107bc29406052d9$var$getArrowPlacement(state.placement));
    }, []);
    var _b = $3pDZx.usePopper(refElement, popperElement, {
        placement: popperPlacement !== null && popperPlacement !== void 0 ? popperPlacement : 'auto',
        modifiers: [
            {
                name: 'arrow',
                fn: handlePosision
            },
            {
                name: 'offset',
                options: {
                    offset: [
                        2,
                        14
                    ]
                }
            }
        ]
    }), styles = _b.styles, attributes = _b.attributes;
    return {
        styles: styles,
        attributes: attributes,
        position: position
    };
};

});
parcelRegister("3pDZx", function(module, exports) {

$parcel$export(module.exports, "usePopper", function () { return $27c2ba68f5f95bbb$export$f4d5bf230a36dd6e; });

var $a5EUy = parcelRequire("a5EUy");

var $esigv = parcelRequire("esigv");

var $6g6Oi = parcelRequire("6g6Oi");

var $gmqja = parcelRequire("gmqja");
var $27c2ba68f5f95bbb$var$EMPTY_MODIFIERS = [];
var $27c2ba68f5f95bbb$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $a5EUy.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $27c2ba68f5f95bbb$var$EMPTY_MODIFIERS
    };
    var _React$useState = $a5EUy.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $a5EUy.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                setState({
                    styles: (0, $gmqja.fromEntries)(elements.map(function(element) {
                        return [
                            element,
                            state.styles[element] || {}
                        ];
                    })),
                    attributes: (0, $gmqja.fromEntries)(elements.map(function(element) {
                        return [
                            element,
                            state.attributes[element]
                        ];
                    }))
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $a5EUy.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6g6Oi)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $a5EUy.useRef();
    (0, $gmqja.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $gmqja.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $esigv.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("esigv", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $a861d94c2affc7b4$export$8f7491d57c8f97a9; });

var $bvmrL = parcelRequire("bvmrL");

var $kQafD = parcelRequire("kQafD");

var $3wipG = parcelRequire("3wipG");

var $jFLJS = parcelRequire("jFLJS");

var $7kDIu = parcelRequire("7kDIu");

var $jvi05 = parcelRequire("jvi05");

var $F5yDl = parcelRequire("F5yDl");

var $aQE8c = parcelRequire("aQE8c");

var $2iOnO = parcelRequire("2iOnO");

var $bMcMC = parcelRequire("bMcMC");


var $a861d94c2affc7b4$export$d34966752335dd47 = [
    (0, $kQafD.default),
    (0, $3wipG.default),
    (0, $jFLJS.default),
    (0, $7kDIu.default),
    (0, $jvi05.default),
    (0, $F5yDl.default),
    (0, $aQE8c.default),
    (0, $2iOnO.default),
    (0, $bMcMC.default)
];
var $a861d94c2affc7b4$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $bvmrL.popperGenerator)({
    defaultModifiers: $a861d94c2affc7b4$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("bvmrL", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $8604006d785cf406$export$ed5e13716264f202; });

var $5JRHT = parcelRequire("5JRHT");

var $fIFpI = parcelRequire("fIFpI");

var $iN8La = parcelRequire("iN8La");

var $jOyuJ = parcelRequire("jOyuJ");


var $c3ck4 = parcelRequire("c3ck4");

var $8WFjO = parcelRequire("8WFjO");




var $i1aLA = parcelRequire("i1aLA");


var $lAUkS = parcelRequire("lAUkS");

var $8604006d785cf406$var$INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var $8604006d785cf406$var$INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var $8604006d785cf406$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $8604006d785cf406$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $8604006d785cf406$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $8604006d785cf406$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign(Object.assign({}, $8604006d785cf406$var$DEFAULT_OPTIONS), defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(options) {
                cleanupModifierEffects();
                state.options = Object.assign(Object.assign(Object.assign({}, defaultOptions), state.options), options);
                state.scrollParents = {
                    reference: (0, $lAUkS.isElement)(reference) ? (0, $iN8La.default)(reference) : reference.contextElement ? (0, $iN8La.default)(reference.contextElement) : [],
                    popper: (0, $iN8La.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $c3ck4.default)((0, $i1aLA.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                }); // Validate the provided modifiers so that the consumer will get warned
                var modifiers, flipModifier, _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft;
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$8604006d785cf406$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $5JRHT.default)(reference, (0, $jOyuJ.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $fIFpI.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                var __debug_loops__ = 0;
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $8WFjO.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$8604006d785cf406$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref3) {
                var name = _ref3.name, _ref3$options = _ref3.options, options = _ref3$options === void 0 ? {} : _ref3$options, effect = _ref3.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $8604006d785cf406$export$8f7491d57c8f97a9 = /*#__PURE__*/ $8604006d785cf406$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("5JRHT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42dad0d058f004f9$export$2e2bcd8739ae039; });

var $3wr9Q = parcelRequire("3wr9Q");

var $hQBtF = parcelRequire("hQBtF");

var $ltVcn = parcelRequire("ltVcn");

var $lAUkS = parcelRequire("lAUkS");

var $1L1mh = parcelRequire("1L1mh");

var $3enc7 = parcelRequire("3enc7");

var $aJPGR = parcelRequire("aJPGR");
function $42dad0d058f004f9$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var documentElement = (0, $3enc7.default)(offsetParent);
    var rect = (0, $3wr9Q.default)(elementOrVirtualElement);
    var isOffsetParentAnElement = (0, $lAUkS.isHTMLElement)(offsetParent);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $ltVcn.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $aJPGR.default)(documentElement)) scroll = (0, $hQBtF.default)(offsetParent);
        if ((0, $lAUkS.isHTMLElement)(offsetParent)) {
            offsets = (0, $3wr9Q.default)(offsetParent);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $1L1mh.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("3wr9Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29096d3bdbbbb42f$export$2e2bcd8739ae039; });
function $29096d3bdbbbb42f$export$2e2bcd8739ae039(element) {
    var rect = element.getBoundingClientRect();
    return {
        width: rect.width,
        height: rect.height,
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        x: rect.left,
        y: rect.top
    };
}

});

parcelRegister("hQBtF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfe45d3ee414c84f$export$2e2bcd8739ae039; });

var $eZ8J6 = parcelRequire("eZ8J6");

var $cRJPp = parcelRequire("cRJPp");

var $lAUkS = parcelRequire("lAUkS");

var $7lWFe = parcelRequire("7lWFe");
function $cfe45d3ee414c84f$export$2e2bcd8739ae039(node) {
    if (node === (0, $cRJPp.default)(node) || !(0, $lAUkS.isHTMLElement)(node)) return (0, $eZ8J6.default)(node);
    else return (0, $7lWFe.default)(node);
}

});
parcelRegister("eZ8J6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae8d881c07942d7f$export$2e2bcd8739ae039; });

var $cRJPp = parcelRequire("cRJPp");
function $ae8d881c07942d7f$export$2e2bcd8739ae039(node) {
    var win = (0, $cRJPp.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});
parcelRegister("cRJPp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95ddfbc7c4bcd5f4$export$2e2bcd8739ae039; });
/*:: import type { Window } from '../types'; */ /*:: declare function getWindow(node: Node | Window): Window; */ function $95ddfbc7c4bcd5f4$export$2e2bcd8739ae039(node) {
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("lAUkS", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $fb88a8d937451b4e$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $fb88a8d937451b4e$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $fb88a8d937451b4e$export$af51f0f06c0f328a; });

var $cRJPp = parcelRequire("cRJPp");
/*:: declare function isElement(node: mixed): boolean %checks(node instanceof
  Element); */ function $fb88a8d937451b4e$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $cRJPp.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
/*:: declare function isHTMLElement(node: mixed): boolean %checks(node instanceof
  HTMLElement); */ function $fb88a8d937451b4e$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $cRJPp.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
/*:: declare function isShadowRoot(node: mixed): boolean %checks(node instanceof
  ShadowRoot); */ function $fb88a8d937451b4e$export$af51f0f06c0f328a(node) {
    var OwnElement = (0, $cRJPp.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});

parcelRegister("7lWFe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55a8000c1a7f6554$export$2e2bcd8739ae039; });
function $55a8000c1a7f6554$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("ltVcn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa38acd67b4f7f05$export$2e2bcd8739ae039; });
function $fa38acd67b4f7f05$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("1L1mh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $147b3bf372787c5e$export$2e2bcd8739ae039; });

var $3wr9Q = parcelRequire("3wr9Q");

var $3enc7 = parcelRequire("3enc7");

var $eZ8J6 = parcelRequire("eZ8J6");
function $147b3bf372787c5e$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $3wr9Q.default)((0, $3enc7.default)(element)).left + (0, $eZ8J6.default)(element).scrollLeft;
}

});
parcelRegister("3enc7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25a4abd8594c858a$export$2e2bcd8739ae039; });

var $lAUkS = parcelRequire("lAUkS");
function $25a4abd8594c858a$export$2e2bcd8739ae039(element) {
    // $FlowFixMe: assume body is always available
    return (((0, $lAUkS.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("aJPGR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d1633f688710b03$export$2e2bcd8739ae039; });

var $hu7dD = parcelRequire("hu7dD");
function $7d1633f688710b03$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $hu7dD.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("hu7dD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbaad68aa8baa0d8$export$2e2bcd8739ae039; });

var $cRJPp = parcelRequire("cRJPp");
function $cbaad68aa8baa0d8$export$2e2bcd8739ae039(element) {
    return (0, $cRJPp.default)(element).getComputedStyle(element);
}

});



parcelRegister("fIFpI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b71b16f93b9bd512$export$2e2bcd8739ae039; });
// Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.
function $b71b16f93b9bd512$export$2e2bcd8739ae039(element) {
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: element.offsetWidth,
        height: element.offsetHeight
    };
}

});

parcelRegister("iN8La", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dae39916e59e8abe$export$2e2bcd8739ae039; });

var $lwbGS = parcelRequire("lwbGS");

var $8C1fc = parcelRequire("8C1fc");

var $ltVcn = parcelRequire("ltVcn");

var $cRJPp = parcelRequire("cRJPp");

var $aJPGR = parcelRequire("aJPGR");
function $dae39916e59e8abe$export$2e2bcd8739ae039(element, list) {
    if (list === void 0) list = [];
    var scrollParent = (0, $lwbGS.default)(element);
    var isBody = (0, $ltVcn.default)(scrollParent) === 'body';
    var win = (0, $cRJPp.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $aJPGR.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($dae39916e59e8abe$export$2e2bcd8739ae039((0, $8C1fc.default)(target)));
}

});
parcelRegister("lwbGS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $faa5a7a85d185b08$export$2e2bcd8739ae039; });

var $8C1fc = parcelRequire("8C1fc");

var $aJPGR = parcelRequire("aJPGR");

var $ltVcn = parcelRequire("ltVcn");

var $lAUkS = parcelRequire("lAUkS");
function $faa5a7a85d185b08$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $ltVcn.default)(node)) >= 0) // $FlowFixMe: assume body is always available
    return node.ownerDocument.body;
    if ((0, $lAUkS.isHTMLElement)(node) && (0, $aJPGR.default)(node)) return node;
    return $faa5a7a85d185b08$export$2e2bcd8739ae039((0, $8C1fc.default)(node));
}

});
parcelRegister("8C1fc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6452d661bc3c60d4$export$2e2bcd8739ae039; });

var $ltVcn = parcelRequire("ltVcn");

var $3enc7 = parcelRequire("3enc7");
function $6452d661bc3c60d4$export$2e2bcd8739ae039(element) {
    if ((0, $ltVcn.default)(element) === 'html') return element;
    return element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || // DOM Element detected
    // $FlowFixMe: need a better way to handle this...
    element.host || // ShadowRoot detected
    // $FlowFixMe: HTMLElement is a Node
    (0, $3enc7.default)(element) // fallback
    ;
}

});



parcelRegister("jOyuJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6cd71c1ae77a638$export$2e2bcd8739ae039; });

var $cRJPp = parcelRequire("cRJPp");

var $ltVcn = parcelRequire("ltVcn");

var $hu7dD = parcelRequire("hu7dD");

var $lAUkS = parcelRequire("lAUkS");

var $15ur3 = parcelRequire("15ur3");

var $8C1fc = parcelRequire("8C1fc");

var $3enc7 = parcelRequire("3enc7");
function $e6cd71c1ae77a638$var$getTrueOffsetParent(element) {
    if (!(0, $lAUkS.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $hu7dD.default)(element).position === 'fixed') return null;
    var offsetParent = element.offsetParent;
    if (offsetParent) {
        var html = (0, $3enc7.default)(offsetParent);
        if ((0, $ltVcn.default)(offsetParent) === 'body' && (0, $hu7dD.default)(offsetParent).position === 'static' && (0, $hu7dD.default)(html).position !== 'static') return html;
    }
    return offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $e6cd71c1ae77a638$var$getContainingBlock(element) {
    var currentNode = (0, $8C1fc.default)(element);
    while((0, $lAUkS.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $ltVcn.default)(currentNode)) < 0){
        var css = (0, $hu7dD.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        if (css.transform !== 'none' || css.perspective !== 'none' || css.willChange && css.willChange !== 'auto') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $e6cd71c1ae77a638$export$2e2bcd8739ae039(element) {
    var window = (0, $cRJPp.default)(element);
    var offsetParent = $e6cd71c1ae77a638$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $15ur3.default)(offsetParent) && (0, $hu7dD.default)(offsetParent).position === 'static')offsetParent = $e6cd71c1ae77a638$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && (0, $ltVcn.default)(offsetParent) === 'body' && (0, $hu7dD.default)(offsetParent).position === 'static') return window;
    return offsetParent || $e6cd71c1ae77a638$var$getContainingBlock(element) || window;
}

});
parcelRegister("15ur3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0caddde55a68f5b1$export$2e2bcd8739ae039; });

var $ltVcn = parcelRequire("ltVcn");
function $0caddde55a68f5b1$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $ltVcn.default)(element)) >= 0;
}

});


parcelRegister("c3ck4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c5f52dee67f2df6$export$2e2bcd8739ae039; });

var $5t9r2 = parcelRequire("5t9r2");
function $8c5f52dee67f2df6$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $8c5f52dee67f2df6$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $8c5f52dee67f2df6$var$order(modifiers); // order based on phase
    return (0, $5t9r2.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("5t9r2", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $3fb6fac9e5e72197$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $3fb6fac9e5e72197$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $3fb6fac9e5e72197$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $3fb6fac9e5e72197$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $3fb6fac9e5e72197$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $3fb6fac9e5e72197$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $3fb6fac9e5e72197$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $3fb6fac9e5e72197$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $3fb6fac9e5e72197$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $3fb6fac9e5e72197$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $3fb6fac9e5e72197$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $3fb6fac9e5e72197$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $3fb6fac9e5e72197$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $3fb6fac9e5e72197$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $3fb6fac9e5e72197$export$d087d3878fdf71d5; });
var $3fb6fac9e5e72197$export$1e95b668f3b82d = 'top';
var $3fb6fac9e5e72197$export$40e543e69a8b3fbb = 'bottom';
var $3fb6fac9e5e72197$export$79ffe56a765070d2 = 'right';
var $3fb6fac9e5e72197$export$eabcd2c8791e7bf4 = 'left';
var $3fb6fac9e5e72197$export$dfb5619354ba860 = 'auto';
var $3fb6fac9e5e72197$export$aec2ce47c367b8c3 = [
    $3fb6fac9e5e72197$export$1e95b668f3b82d,
    $3fb6fac9e5e72197$export$40e543e69a8b3fbb,
    $3fb6fac9e5e72197$export$79ffe56a765070d2,
    $3fb6fac9e5e72197$export$eabcd2c8791e7bf4
];
var $3fb6fac9e5e72197$export$b3571188c770cc5a = 'start';
var $3fb6fac9e5e72197$export$bd5df0f255a350f8 = 'end';
var $3fb6fac9e5e72197$export$390fd549c5303b4d = 'clippingParents';
var $3fb6fac9e5e72197$export$d7b7311ec04a3e8f = 'viewport';
var $3fb6fac9e5e72197$export$ae5ab1c730825774 = 'popper';
var $3fb6fac9e5e72197$export$ca50aac9f3ba507f = 'reference';
var $3fb6fac9e5e72197$export$368f9a87e87fa4e1 = /*#__PURE__*/ $3fb6fac9e5e72197$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $3fb6fac9e5e72197$export$b3571188c770cc5a,
        placement + "-" + $3fb6fac9e5e72197$export$bd5df0f255a350f8
    ]);
}, []);
var $3fb6fac9e5e72197$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($3fb6fac9e5e72197$export$aec2ce47c367b8c3, [
    $3fb6fac9e5e72197$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $3fb6fac9e5e72197$export$b3571188c770cc5a,
        placement + "-" + $3fb6fac9e5e72197$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $3fb6fac9e5e72197$export$421679a7c3d56e = 'beforeRead';
var $3fb6fac9e5e72197$export$aafa59e2e03f2942 = 'read';
var $3fb6fac9e5e72197$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $3fb6fac9e5e72197$export$c65e99957a05207c = 'beforeMain';
var $3fb6fac9e5e72197$export$f22da7240b7add18 = 'main';
var $3fb6fac9e5e72197$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $3fb6fac9e5e72197$export$8d4d2d70e7d46032 = 'beforeWrite';
var $3fb6fac9e5e72197$export$68d8715fc104d294 = 'write';
var $3fb6fac9e5e72197$export$70a6e5159acce2e6 = 'afterWrite';
var $3fb6fac9e5e72197$export$d087d3878fdf71d5 = [
    $3fb6fac9e5e72197$export$421679a7c3d56e,
    $3fb6fac9e5e72197$export$aafa59e2e03f2942,
    $3fb6fac9e5e72197$export$6964f6c886723980,
    $3fb6fac9e5e72197$export$c65e99957a05207c,
    $3fb6fac9e5e72197$export$f22da7240b7add18,
    $3fb6fac9e5e72197$export$bab79516f2d662fe,
    $3fb6fac9e5e72197$export$8d4d2d70e7d46032,
    $3fb6fac9e5e72197$export$68d8715fc104d294,
    $3fb6fac9e5e72197$export$70a6e5159acce2e6
];

});


parcelRegister("8WFjO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6833ca832fdf0ed5$export$2e2bcd8739ae039; });
function $6833ca832fdf0ed5$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("i1aLA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1e0ac005b1484ad$export$2e2bcd8739ae039; });
function $d1e0ac005b1484ad$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign(Object.assign(Object.assign({}, existing), current), {}, {
            options: Object.assign(Object.assign({}, existing.options), current.options),
            data: Object.assign(Object.assign({}, existing.data), current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("kQafD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2c09da1adb1cb4c$export$2e2bcd8739ae039; });

var $cRJPp = parcelRequire("cRJPp");
var $f2c09da1adb1cb4c$var$passive = {
    passive: true
};
function $f2c09da1adb1cb4c$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $cRJPp.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $f2c09da1adb1cb4c$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $f2c09da1adb1cb4c$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $f2c09da1adb1cb4c$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $f2c09da1adb1cb4c$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $f2c09da1adb1cb4c$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $f2c09da1adb1cb4c$var$effect,
    data: {}
};

});

parcelRegister("3wipG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2902a4ba69631c34$export$2e2bcd8739ae039; });

var $hlTCI = parcelRequire("hlTCI");
function $2902a4ba69631c34$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $hlTCI.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $2902a4ba69631c34$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $2902a4ba69631c34$var$popperOffsets,
    data: {}
};

});
parcelRegister("hlTCI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca1f8b82a90cec29$export$2e2bcd8739ae039; });

var $dylAc = parcelRequire("dylAc");

var $esL8G = parcelRequire("esL8G");

var $7KLz5 = parcelRequire("7KLz5");

var $5t9r2 = parcelRequire("5t9r2");
function $ca1f8b82a90cec29$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $dylAc.default)(placement) : null;
    var variation = placement ? (0, $esL8G.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $5t9r2.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $5t9r2.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $5t9r2.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $5t9r2.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $7KLz5.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $5t9r2.start:
                offsets[mainAxis] = Math.floor(offsets[mainAxis]) - Math.floor(reference[len] / 2 - element[len] / 2);
                break;
            case 0, $5t9r2.end:
                offsets[mainAxis] = Math.floor(offsets[mainAxis]) + Math.ceil(reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("dylAc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ddf313f46b0e042$export$2e2bcd8739ae039; });

function $9ddf313f46b0e042$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("esL8G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8783f0a06ddca0a$export$2e2bcd8739ae039; });
function $a8783f0a06ddca0a$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("7KLz5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a51b9b17ee04d99$export$2e2bcd8739ae039; });
function $5a51b9b17ee04d99$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("jFLJS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e526e0996a990cfb$export$2e2bcd8739ae039; });

var $5t9r2 = parcelRequire("5t9r2");

var $jOyuJ = parcelRequire("jOyuJ");

var $cRJPp = parcelRequire("cRJPp");

var $3enc7 = parcelRequire("3enc7");


var $dylAc = parcelRequire("dylAc");
var $e526e0996a990cfb$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $e526e0996a990cfb$var$roundOffsets(_ref) {
    var x = _ref.x, y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: Math.round(x * dpr) / dpr || 0,
        y: Math.round(y * dpr) / dpr || 0
    };
}
function $e526e0996a990cfb$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive;
    var _roundOffsets = $e526e0996a990cfb$var$roundOffsets(offsets), x = _roundOffsets.x, y = _roundOffsets.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $5t9r2.left);
    var sideY = (0, $5t9r2.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $jOyuJ.default)(popper);
        if (offsetParent === (0, $cRJPp.default)(popper)) offsetParent = (0, $3enc7.default)(popper);
         // $FlowFixMe: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        /*:: offsetParent = (offsetParent: Element); */ if (placement === (0, $5t9r2.top)) {
            sideY = (0, $5t9r2.bottom);
            y -= offsetParent.clientHeight - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $5t9r2.left)) {
            sideX = (0, $5t9r2.right);
            x -= offsetParent.clientWidth - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $e526e0996a990cfb$var$unsetSides);
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign(Object.assign({}, commonStyles), {}, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) < 2 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign(Object.assign({}, commonStyles), {}, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $e526e0996a990cfb$var$computeStyles(_ref3) {
    var state = _ref3.state, options = _ref3.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive;
    var transitionProperty;
    var commonStyles = {
        placement: (0, $dylAc.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign(Object.assign({}, state.styles.popper), $e526e0996a990cfb$export$378fa78a8fea596f(Object.assign(Object.assign({}, commonStyles), {}, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign(Object.assign({}, state.styles.arrow), $e526e0996a990cfb$export$378fa78a8fea596f(Object.assign(Object.assign({}, commonStyles), {}, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false
    })));
    state.attributes.popper = Object.assign(Object.assign({}, state.attributes.popper), {}, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e526e0996a990cfb$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $e526e0996a990cfb$var$computeStyles,
    data: {}
};

});

parcelRegister("7kDIu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $556935908ed9c822$export$2e2bcd8739ae039; });

var $ltVcn = parcelRequire("ltVcn");

var $lAUkS = parcelRequire("lAUkS");
// and applies them to the HTMLElements such as popper and arrow
function $556935908ed9c822$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $lAUkS.isHTMLElement)(element) || !(0, $ltVcn.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $556935908ed9c822$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $lAUkS.isHTMLElement)(element) || !(0, $ltVcn.default)(element)) return;
             // Flow doesn't support to extend this property, but it's the most
            // effective way to apply styles to an HTMLElement
            // $FlowFixMe
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $556935908ed9c822$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $556935908ed9c822$var$applyStyles,
    effect: $556935908ed9c822$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("jvi05", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e32ee00e6f29f4e4$export$2e2bcd8739ae039; });

var $dylAc = parcelRequire("dylAc");

var $5t9r2 = parcelRequire("5t9r2");
function $e32ee00e6f29f4e4$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $dylAc.default)(placement);
    var invertDistance = [
        (0, $5t9r2.left),
        (0, $5t9r2.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign(Object.assign({}, rects), {}, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $5t9r2.left),
        (0, $5t9r2.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $e32ee00e6f29f4e4$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $5t9r2.placements).reduce(function(acc, placement) {
        acc[placement] = $e32ee00e6f29f4e4$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $e32ee00e6f29f4e4$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $e32ee00e6f29f4e4$var$offset
};

});

parcelRegister("F5yDl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07b824132c111a52$export$2e2bcd8739ae039; });

var $2SlPH = parcelRequire("2SlPH");

var $dylAc = parcelRequire("dylAc");

var $jWNbf = parcelRequire("jWNbf");

var $hJsdW = parcelRequire("hJsdW");

var $iSCYh = parcelRequire("iSCYh");

var $5t9r2 = parcelRequire("5t9r2");

var $esL8G = parcelRequire("esL8G");
function $07b824132c111a52$var$getExpandedFallbackPlacements(placement) {
    if ((0, $dylAc.default)(placement) === (0, $5t9r2.auto)) return [];
    var oppositePlacement = (0, $2SlPH.default)(placement);
    return [
        (0, $jWNbf.default)(placement),
        oppositePlacement,
        (0, $jWNbf.default)(oppositePlacement)
    ];
}
function $07b824132c111a52$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $dylAc.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $2SlPH.default)(preferredPlacement)
    ] : $07b824132c111a52$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $dylAc.default)(placement) === (0, $5t9r2.auto) ? (0, $iSCYh.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $dylAc.default)(placement);
        var isStartVariation = (0, $esL8G.default)(placement) === (0, $5t9r2.start);
        var isVertical = [
            (0, $5t9r2.top),
            (0, $5t9r2.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $hJsdW.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $5t9r2.right) : (0, $5t9r2.left) : isStartVariation ? (0, $5t9r2.bottom) : (0, $5t9r2.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $2SlPH.default)(mainVariationSide);
        var altVariationSide = (0, $2SlPH.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $07b824132c111a52$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $07b824132c111a52$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("2SlPH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21818f7e2d19dc33$export$2e2bcd8739ae039; });
var $21818f7e2d19dc33$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $21818f7e2d19dc33$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $21818f7e2d19dc33$var$hash[matched];
    });
}

});

parcelRegister("jWNbf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e859955423854b0d$export$2e2bcd8739ae039; });
var $e859955423854b0d$var$hash = {
    start: 'end',
    end: 'start'
};
function $e859955423854b0d$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $e859955423854b0d$var$hash[matched];
    });
}

});

parcelRegister("hJsdW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce8c884e0c226be5$export$2e2bcd8739ae039; });

var $3wr9Q = parcelRequire("3wr9Q");

var $8dpaP = parcelRequire("8dpaP");

var $3enc7 = parcelRequire("3enc7");

var $hlTCI = parcelRequire("hlTCI");

var $GFzid = parcelRequire("GFzid");

var $5t9r2 = parcelRequire("5t9r2");

var $lAUkS = parcelRequire("lAUkS");

var $ir4xn = parcelRequire("ir4xn");

var $e0gDQ = parcelRequire("e0gDQ");
function $ce8c884e0c226be5$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $5t9r2.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $5t9r2.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $5t9r2.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $ir4xn.default)(typeof padding !== 'number' ? padding : (0, $e0gDQ.default)(padding, (0, $5t9r2.basePlacements)));
    var altContext = elementContext === (0, $5t9r2.popper) ? (0, $5t9r2.reference) : (0, $5t9r2.popper);
    var referenceElement = state.elements.reference;
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $8dpaP.default)((0, $lAUkS.isElement)(element) ? element : element.contextElement || (0, $3enc7.default)(state.elements.popper), boundary, rootBoundary);
    var referenceClientRect = (0, $3wr9Q.default)(referenceElement);
    var popperOffsets = (0, $hlTCI.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $GFzid.default)(Object.assign(Object.assign({}, popperRect), popperOffsets));
    var elementClientRect = elementContext === (0, $5t9r2.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $5t9r2.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $5t9r2.right),
                (0, $5t9r2.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $5t9r2.top),
                (0, $5t9r2.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("8dpaP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fb3109bc30a9c48$export$2e2bcd8739ae039; });

var $5t9r2 = parcelRequire("5t9r2");

var $187Ee = parcelRequire("187Ee");

var $hIEAh = parcelRequire("hIEAh");

var $iN8La = parcelRequire("iN8La");

var $jOyuJ = parcelRequire("jOyuJ");

var $3enc7 = parcelRequire("3enc7");

var $hu7dD = parcelRequire("hu7dD");

var $lAUkS = parcelRequire("lAUkS");

var $3wr9Q = parcelRequire("3wr9Q");

var $8C1fc = parcelRequire("8C1fc");

var $2oHAh = parcelRequire("2oHAh");

var $ltVcn = parcelRequire("ltVcn");

var $GFzid = parcelRequire("GFzid");
function $5fb3109bc30a9c48$var$getInnerBoundingClientRect(element) {
    var rect = (0, $3wr9Q.default)(element);
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $5fb3109bc30a9c48$var$getClientRectFromMixedType(element, clippingParent) {
    return clippingParent === (0, $5t9r2.viewport) ? (0, $GFzid.default)((0, $187Ee.default)(element)) : (0, $lAUkS.isHTMLElement)(clippingParent) ? $5fb3109bc30a9c48$var$getInnerBoundingClientRect(clippingParent) : (0, $GFzid.default)((0, $hIEAh.default)((0, $3enc7.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $5fb3109bc30a9c48$var$getClippingParents(element) {
    var clippingParents = (0, $iN8La.default)((0, $8C1fc.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $hu7dD.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $lAUkS.isHTMLElement)(element) ? (0, $jOyuJ.default)(element) : element;
    if (!(0, $lAUkS.isElement)(clipperElement)) return [];
     // $FlowFixMe: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $lAUkS.isElement)(clippingParent) && (0, $2oHAh.default)(clippingParent, clipperElement) && (0, $ltVcn.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $5fb3109bc30a9c48$export$2e2bcd8739ae039(element, boundary, rootBoundary) {
    var mainClippingParents = boundary === 'clippingParents' ? $5fb3109bc30a9c48$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $5fb3109bc30a9c48$var$getClientRectFromMixedType(element, clippingParent);
        accRect.top = Math.max(rect.top, accRect.top);
        accRect.right = Math.min(rect.right, accRect.right);
        accRect.bottom = Math.min(rect.bottom, accRect.bottom);
        accRect.left = Math.max(rect.left, accRect.left);
        return accRect;
    }, $5fb3109bc30a9c48$var$getClientRectFromMixedType(element, firstClippingParent));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("187Ee", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d2c788648daed6e$export$2e2bcd8739ae039; });

var $cRJPp = parcelRequire("cRJPp");

var $3enc7 = parcelRequire("3enc7");

var $1L1mh = parcelRequire("1L1mh");
function $0d2c788648daed6e$export$2e2bcd8739ae039(element) {
    var win = (0, $cRJPp.default)(element);
    var html = (0, $3enc7.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
    // can be obscured underneath it.
    // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
    // if it isn't open, so if this isn't available, the popper will be detected
    // to overflow the bottom of the screen too early.
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
        // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
        // errors due to floating point numbers, so we need to check precision.
        // Safari returns a number <= 0, usually < -1 when pinch-zoomed
        // Feature detection fails in mobile emulation mode in Chrome.
        // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
        // 0.001
        // Fallback here: "Not Safari" userAgent
        if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $1L1mh.default)(element),
        y: y
    };
}

});

parcelRegister("hIEAh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce6606e55dfbf45f$export$2e2bcd8739ae039; });

var $3enc7 = parcelRequire("3enc7");

var $hu7dD = parcelRequire("hu7dD");

var $1L1mh = parcelRequire("1L1mh");

var $eZ8J6 = parcelRequire("eZ8J6");
function $ce6606e55dfbf45f$export$2e2bcd8739ae039(element) {
    var html = (0, $3enc7.default)(element);
    var winScroll = (0, $eZ8J6.default)(element);
    var body = element.ownerDocument.body;
    var width = Math.max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = Math.max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $1L1mh.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $hu7dD.default)(body || html).direction === 'rtl') x += Math.max(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("2oHAh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1befa18ef4f3545a$export$2e2bcd8739ae039; });

var $lAUkS = parcelRequire("lAUkS");
function $1befa18ef4f3545a$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $lAUkS.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("GFzid", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08042af1cdb75f74$export$2e2bcd8739ae039; });
function $08042af1cdb75f74$export$2e2bcd8739ae039(rect) {
    return Object.assign(Object.assign({}, rect), {}, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("ir4xn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6be44a25aa1fb75$export$2e2bcd8739ae039; });

var $1k0yY = parcelRequire("1k0yY");
function $d6be44a25aa1fb75$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign(Object.assign({}, (0, $1k0yY.default)()), paddingObject);
}

});
parcelRegister("1k0yY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f6818898d18f03d$export$2e2bcd8739ae039; });
function $0f6818898d18f03d$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("e0gDQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a31df9792c1741f4$export$2e2bcd8739ae039; });
function $a31df9792c1741f4$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("iSCYh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbeb8001f2eb1fef$export$2e2bcd8739ae039; });

var $esL8G = parcelRequire("esL8G");

var $5t9r2 = parcelRequire("5t9r2");

var $hJsdW = parcelRequire("hJsdW");

var $dylAc = parcelRequire("dylAc");
function $dbeb8001f2eb1fef$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $5t9r2.placements) : _options$allowedAutoP;
    var variation = (0, $esL8G.default)(placement);
    var placements = variation ? flipVariations ? (0, $5t9r2.variationPlacements) : (0, $5t9r2.variationPlacements).filter(function(placement) {
        return (0, $esL8G.default)(placement) === variation;
    }) : (0, $5t9r2.basePlacements); // $FlowFixMe
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $hJsdW.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $dylAc.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("aQE8c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e5de3f2f97a9307$export$2e2bcd8739ae039; });

var $5t9r2 = parcelRequire("5t9r2");

var $dylAc = parcelRequire("dylAc");

var $7KLz5 = parcelRequire("7KLz5");

var $a5R8r = parcelRequire("a5R8r");

var $k4TV4 = parcelRequire("k4TV4");

var $fIFpI = parcelRequire("fIFpI");

var $jOyuJ = parcelRequire("jOyuJ");

var $hJsdW = parcelRequire("hJsdW");

var $esL8G = parcelRequire("esL8G");

var $1k0yY = parcelRequire("1k0yY");
function $7e5de3f2f97a9307$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $hJsdW.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $dylAc.default)(state.placement);
    var variation = (0, $esL8G.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $7KLz5.default)(basePlacement);
    var altAxis = (0, $a5R8r.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign(Object.assign({}, state.rects), {}, {
        placement: state.placement
    })) : tetherOffset;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var mainSide = mainAxis === 'y' ? (0, $5t9r2.top) : (0, $5t9r2.left);
        var altSide = mainAxis === 'y' ? (0, $5t9r2.bottom) : (0, $5t9r2.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = popperOffsets[mainAxis] + overflow[mainSide];
        var max = popperOffsets[mainAxis] - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $5t9r2.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $5t9r2.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $fIFpI.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $1k0yY.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $k4TV4.default)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - tetherOffsetValue : minLen - arrowLen - arrowPaddingMin - tetherOffsetValue;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + tetherOffsetValue : maxLen + arrowLen + arrowPaddingMax + tetherOffsetValue;
        var arrowOffsetParent = state.elements.arrow && (0, $jOyuJ.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = state.modifiersData.offset ? state.modifiersData.offset[state.placement][mainAxis] : 0;
        var tetherMin = popperOffsets[mainAxis] + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = popperOffsets[mainAxis] + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $k4TV4.default)(tether ? Math.min(min, tetherMin) : min, offset, tether ? Math.max(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _mainSide = mainAxis === 'x' ? (0, $5t9r2.top) : (0, $5t9r2.left);
        var _altSide = mainAxis === 'x' ? (0, $5t9r2.bottom) : (0, $5t9r2.right);
        var _offset = popperOffsets[altAxis];
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var _preventedOffset = (0, $k4TV4.default)(_min, _offset, _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7e5de3f2f97a9307$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $7e5de3f2f97a9307$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("a5R8r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7593968f30749ab3$export$2e2bcd8739ae039; });
function $7593968f30749ab3$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("k4TV4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9df8ed05ed07831$export$2e2bcd8739ae039; });
function $e9df8ed05ed07831$export$2e2bcd8739ae039(min, value, max) {
    return Math.max(min, Math.min(value, max));
}

});


parcelRegister("2iOnO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ad4583b71954c0d$export$2e2bcd8739ae039; });

var $dylAc = parcelRequire("dylAc");

var $fIFpI = parcelRequire("fIFpI");

var $2oHAh = parcelRequire("2oHAh");

var $jOyuJ = parcelRequire("jOyuJ");

var $7KLz5 = parcelRequire("7KLz5");

var $k4TV4 = parcelRequire("k4TV4");

var $ir4xn = parcelRequire("ir4xn");

var $e0gDQ = parcelRequire("e0gDQ");

var $5t9r2 = parcelRequire("5t9r2");

function $1ad4583b71954c0d$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $dylAc.default)(state.placement);
    var axis = (0, $7KLz5.default)(basePlacement);
    var isVertical = [
        (0, $5t9r2.left),
        (0, $5t9r2.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = state.modifiersData[name + "#persistent"].padding;
    var arrowRect = (0, $fIFpI.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $5t9r2.top) : (0, $5t9r2.left);
    var maxProp = axis === 'y' ? (0, $5t9r2.bottom) : (0, $5t9r2.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $jOyuJ.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $k4TV4.default)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $1ad4583b71954c0d$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element, _options$padding = options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $2oHAh.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
    state.modifiersData[name + "#persistent"] = {
        padding: (0, $ir4xn.default)(typeof padding !== 'number' ? padding : (0, $e0gDQ.default)(padding, (0, $5t9r2.basePlacements)))
    };
} // eslint-disable-next-line import/no-unused-modules
var $1ad4583b71954c0d$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $1ad4583b71954c0d$var$arrow,
    effect: $1ad4583b71954c0d$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("bMcMC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $892e17e31e99afb5$export$2e2bcd8739ae039; });

var $5t9r2 = parcelRequire("5t9r2");

var $hJsdW = parcelRequire("hJsdW");
function $892e17e31e99afb5$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $892e17e31e99afb5$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $5t9r2.top),
        (0, $5t9r2.right),
        (0, $5t9r2.bottom),
        (0, $5t9r2.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $892e17e31e99afb5$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $hJsdW.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $hJsdW.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $892e17e31e99afb5$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $892e17e31e99afb5$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $892e17e31e99afb5$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $892e17e31e99afb5$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign(Object.assign({}, state.attributes.popper), {}, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $892e17e31e99afb5$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $892e17e31e99afb5$var$hide
};

});


parcelRegister("6g6Oi", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $48e98512aa406f74$var$hasElementType = typeof Element !== 'undefined';
var $48e98512aa406f74$var$hasMap = typeof Map === 'function';
var $48e98512aa406f74$var$hasSet = typeof Set === 'function';
var $48e98512aa406f74$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $48e98512aa406f74$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$48e98512aa406f74$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($48e98512aa406f74$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$48e98512aa406f74$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($48e98512aa406f74$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($48e98512aa406f74$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($48e98512aa406f74$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$48e98512aa406f74$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $48e98512aa406f74$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("gmqja", function(module, exports) {

$parcel$export(module.exports, "fromEntries", function () { return $be931ba5fb975617$export$5150077fc2e7c662; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $be931ba5fb975617$export$700979bc83e7db82; });

var $a5EUy = parcelRequire("a5EUy");
var $be931ba5fb975617$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $be931ba5fb975617$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $be931ba5fb975617$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $be931ba5fb975617$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $be931ba5fb975617$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $be931ba5fb975617$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $a5EUy.useLayoutEffect : $a5EUy.useEffect;

});





parcelRegister("12gHN", function(module, exports) {

$parcel$export(module.exports, "PopoverBody", function () { return $0c12efb6fad0db7c$export$472ec417bca1d382; });
parcelRequire("2cnsK");
var $2U0D7 = parcelRequire("2U0D7");

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
parcelRequire("kbxqT");
var $70aOe = parcelRequire("70aOe");
var $0c12efb6fad0db7c$var$__assign = undefined && undefined.__assign || function() {
    $0c12efb6fad0db7c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0c12efb6fad0db7c$var$__assign.apply(this, arguments);
};
var $0c12efb6fad0db7c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0c12efb6fad0db7c$export$472ec417bca1d382 = $a5EUy.forwardRef(function(_a, ref) {
    var content = _a.content, title = _a.title, onExit = _a.onExit, position = _a.position, props = $0c12efb6fad0db7c$var$__rest(_a, [
        "content",
        "title",
        "onExit",
        "position"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    // eslint-disable-next-line no-null/no-null
    var exitRef = $a5EUy.useRef(null);
    var onClickHandler = $a5EUy.useCallback(function() {
        if (onExit) onExit();
    }, [
        onExit
    ]);
    $a5EUy.useEffect(function() {
        var _a;
        // focus the exit button immediately
        (_a = exitRef.current) === null || _a === void 0 || _a.focus();
    }, []);
    return $a5EUy.createElement("div", $0c12efb6fad0db7c$var$__assign({
        className: cn('toast', 'popover', position),
        ref: ref,
        role: "presentation",
        tabIndex: -1
    }, props), $a5EUy.createElement("div", {
        className: cn('arrow-below')
    }), $a5EUy.createElement("div", {
        className: cn('arrow-above')
    }), $a5EUy.createElement("div", {
        className: cn('toast-main')
    }, $a5EUy.createElement("div", {
        className: cn('toast-content')
    }, $a5EUy.createElement("p", {
        className: cn('toast-heading')
    }, title), $a5EUy.createElement("div", {
        className: cn('toast-body')
    }, $a5EUy.createElement("p", null, content)))), $a5EUy.createElement("button", {
        className: cn('toast-close'),
        onClick: onClickHandler,
        ref: exitRef,
        tabIndex: 0
    }, $a5EUy.createElement((0, $70aOe.Icon), {
        as: "span",
        icon: $a5EUy.createElement((0, $2U0D7.Cross), null)
    })));
});

});



parcelRegister("j2NvO", function(module, exports) {
parcelRequire("ikT8r");
parcelRequire("aJGdV");

});
parcelRegister("ikT8r", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
parcelRequire("6LRCY");
var $bnWnl = parcelRequire("bnWnl");

var $jLRsx = parcelRequire("jLRsx");
var $d594dcf0e42d9d86$var$__assign = undefined && undefined.__assign || function() {
    $d594dcf0e42d9d86$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d594dcf0e42d9d86$var$__assign.apply(this, arguments);
};
var $d594dcf0e42d9d86$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d594dcf0e42d9d86$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $d594dcf0e42d9d86$export$9e72f56a493060bf = $a5EUy.forwardRef(function CircularProgress(_a, ref) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 'medium' : _c, value = _a.value, _d = _a.min, min = _d === void 0 ? 0 : _d, _e = _a.max, max = _e === void 0 ? 100 : _e, props = $d594dcf0e42d9d86$var$__rest(_a, [
        "size",
        "value",
        "min",
        "max"
    ]);
    var frameworkPrefix = (0, $bnWnl.useKlikContext)().frameworkPrefix;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    // eslint-disable-next-line no-null/no-null
    var innerRef = $a5EUy.useRef(null);
    var _f = $d594dcf0e42d9d86$var$__read($a5EUy.useState({
        width: 0,
        height: 0,
        strokeWidth: 0,
        radius: 0,
        center: 0
    }), 2), computedValues = _f[0], setComputedValues = _f[1];
    /**
     * useLayoutEffect because the values that are calculated are also the values that are used for
     * display, this allows us to calculate the values before the browser re-paints so there is no flicker
     *
     */ $a5EUy.useLayoutEffect(function() {
        if (innerRef.current) {
            if (value) innerRef.current.style.setProperty("--" + frameworkPrefix + "-circle-stroke-percentage", value.toString());
            var diameter = parseInt(getComputedStyle(innerRef.current).getPropertyValue("--" + frameworkPrefix + "-circle-full-diameter"), 10);
            var strokeWidth = parseInt(getComputedStyle(innerRef.current).getPropertyValue("--" + frameworkPrefix + "-circle-stroke-width"), 10);
            setComputedValues({
                width: diameter,
                height: diameter,
                strokeWidth: strokeWidth,
                radius: diameter / 2 - strokeWidth / 2,
                center: diameter / 2
            });
        }
    }, [
        value
    ]);
    var isIndeterminate = typeof value !== 'number';
    var accessibilityProps = {
        role: 'progressbar',
        'aria-valuemin': min,
        'aria-valuemax': max
    };
    if (!isIndeterminate) accessibilityProps['aria-valuenow'] = value;
    /**
     * svg height, width and viewbox values cannot use the `var(prop)` method
     * nor can it be used in cx, cy
     */ return $a5EUy.createElement("div", $d594dcf0e42d9d86$var$__assign({
        className: "klik-progress"
    }, accessibilityProps, {
        ref: ref
    }, props), $a5EUy.createElement("div", {
        className: cn('progress-ring', (_b = {}, _b["is-" + size] = size, _b)),
        ref: innerRef
    }, $a5EUy.createElement("svg", {
        className: cn('progress-ring-svg'),
        height: computedValues.height,
        viewBox: "0 0 " + computedValues.width + " " + computedValues.height,
        width: computedValues.width
    }, $a5EUy.createElement("circle", {
        className: cn('progress-ring-circle-border'),
        cx: computedValues.center,
        cy: computedValues.center,
        fill: "transparent",
        r: computedValues.radius,
        stroke: "var(--klik-circle-stroke-border)",
        strokeWidth: "var(--klik-circle-stroke-width)"
    }), $a5EUy.createElement("circle", {
        className: cn('progress-ring-circle'),
        cx: computedValues.center,
        cy: computedValues.center,
        fill: "transparent",
        r: computedValues.radius,
        stroke: "var(--klik-circle-stroke-color)",
        strokeDasharray: "var(--klik-circle-stroke-dasharray)",
        strokeDashoffset: "var(--klik-circle-stroke-dashoffset)",
        strokeWidth: "var(--klik-circle-stroke-width)"
    })), $a5EUy.createElement("p", {
        className: cn('progress-value')
    }, "50%")));
});

});

parcelRegister("aJGdV", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $7d0edc1994d421f4$var$__assign = undefined && undefined.__assign || function() {
    $7d0edc1994d421f4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7d0edc1994d421f4$var$__assign.apply(this, arguments);
};
var $7d0edc1994d421f4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7d0edc1994d421f4$export$11f983dff6f48944 = $a5EUy.forwardRef(function LinearProgress(_a, ref) {
    var value = _a.value, _b = _a.max, max = _b === void 0 ? 100 : _b, _c = _a.hasLabel, hasLabel = _c === void 0 ? false : _c, props = $7d0edc1994d421f4$var$__rest(_a, [
        "value",
        "max",
        "hasLabel"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    // eslint-disable-next-line no-null/no-null
    var innerRef = $a5EUy.useRef(null);
    var isIndeterminate = typeof value !== 'number';
    var accessibilityProps = {
        role: 'progressbar',
        'aria-valuemin': 0,
        'aria-valuemax': 100
    };
    if (!isIndeterminate) accessibilityProps['aria-valuenow'] = value;
    /**
     * svg height, width and viewbox values cannot use the `var(prop)` method
     * nor can it be used in cx, cy
     */ return $a5EUy.createElement("div", $7d0edc1994d421f4$var$__assign({
        className: cn('progress')
    }, accessibilityProps, {
        ref: ref
    }, props), hasLabel && $a5EUy.createElement("p", {
        className: cn('progress-value')
    }, value), $a5EUy.createElement("progress", {
        className: cn('progress-bar'),
        max: max,
        ref: innerRef,
        value: value
    }));
});

});


parcelRegister("c6XIG", function(module, exports) {
$parcel$export(module.exports, "Radio", function () { return (parcelRequire("bzTkH")).Radio; });
parcelRequire("bzTkH");

});
parcelRegister("bzTkH", function(module, exports) {

$parcel$export(module.exports, "Radio", function () { return $86dde28d6461f79a$export$d7b12c4107be0d61; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $4KWpp = parcelRequire("4KWpp");
var $86dde28d6461f79a$var$__assign = undefined && undefined.__assign || function() {
    $86dde28d6461f79a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $86dde28d6461f79a$var$__assign.apply(this, arguments);
};
var $86dde28d6461f79a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $86dde28d6461f79a$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $86dde28d6461f79a$export$d7b12c4107be0d61 = function(_a) {
    var children = _a.children, onChange = _a.onChange, name = _a.name, props = $86dde28d6461f79a$var$__rest(_a, [
        "children",
        "onChange",
        "name"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var _b = $86dde28d6461f79a$var$__read($a5EUy.useState(''), 2), selectedRadio = _b[0], setSelectedRadio = _b[1];
    var onRadioChange = $a5EUy.useCallback(function(e) {
        setSelectedRadio(e.currentTarget.value);
        if (onChange) onChange(e);
    }, [
        selectedRadio
    ]);
    var validChildren = (0, $jLRsx.getValidChildren)(children);
    return $a5EUy.createElement("div", $86dde28d6461f79a$var$__assign({
        className: cn('radios')
    }, props), validChildren.map(function(child) {
        return $a5EUy.cloneElement(child, {
            onChange: onRadioChange,
            name: name
        });
    }));
};
$86dde28d6461f79a$export$d7b12c4107be0d61.Button = (0, $4KWpp.RadioButton);

});
parcelRegister("4KWpp", function(module, exports) {

$parcel$export(module.exports, "RadioButton", function () { return $3768c4136528bc7f$export$f4422ae58352e179; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $7MCi3 = parcelRequire("7MCi3");
var $3768c4136528bc7f$var$__assign = undefined && undefined.__assign || function() {
    $3768c4136528bc7f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3768c4136528bc7f$var$__assign.apply(this, arguments);
};
var $3768c4136528bc7f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3768c4136528bc7f$export$f4422ae58352e179 = $a5EUy.forwardRef(function(_a, ref) {
    var _b;
    var label = _a.label, isError = _a.isError, isDisabled = _a.isDisabled, props = $3768c4136528bc7f$var$__rest(_a, [
        "label",
        "isError",
        "isDisabled"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var ariaRadio = $3768c4136528bc7f$var$__rest((0, $7MCi3.useRadio)($3768c4136528bc7f$var$__assign({
        label: label,
        isDisabled: isDisabled,
        isError: isError
    }, props)), []);
    return $a5EUy.createElement("div", {
        className: cn('radio', (_b = {}, _b["status-error"] = isError, _b))
    }, $a5EUy.createElement("label", {
        className: cn('radio-label')
    }, $a5EUy.createElement("input", $3768c4136528bc7f$var$__assign({
        className: cn('radio-hidden')
    }, props, {
        ref: ref
    }, ariaRadio)), $a5EUy.createElement("span", {
        className: cn('radio-shape')
    }), label && $a5EUy.createElement("span", {
        className: cn('radio-text')
    }, label)));
});
$3768c4136528bc7f$export$f4422ae58352e179.displayName = 'Radio.Button';

});
parcelRegister("7MCi3", function(module, exports) {

$parcel$export(module.exports, "useRadio", function () { return $5aaab7b5df98b913$export$37b0961d2f4751e2; });

var $a5EUy = parcelRequire("a5EUy");
var $5aaab7b5df98b913$export$37b0961d2f4751e2 = function(_a) {
    var label = _a.label, value = _a.value, isDisabled = _a.isDisabled, isError = _a.isError, name = _a.name;
    var shouldBeDisabled = isDisabled !== null && isDisabled !== void 0 ? isDisabled : isError;
    return $a5EUy.useMemo(function() {
        return {
            'aria-label': label,
            'aria-disabled': shouldBeDisabled,
            disabled: shouldBeDisabled,
            tabIndex: shouldBeDisabled ? -1 : 0,
            type: 'radio',
            name: name,
            value: value
        };
    }, [
        isDisabled,
        isError,
        label,
        value
    ]);
};

});




parcelRegister("27eN8", function(module, exports) {
parcelRequire("3rbkL");

});
parcelRegister("3rbkL", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $iMBm0 = parcelRequire("iMBm0");

var $9VRz9 = parcelRequire("9VRz9");

var $7rAzQ = parcelRequire("7rAzQ");
var $280caf62b430e17a$var$__assign = undefined && undefined.__assign || function() {
    $280caf62b430e17a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $280caf62b430e17a$var$__assign.apply(this, arguments);
};
var $280caf62b430e17a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $280caf62b430e17a$export$1ba59dacbcbf90fe = function(_a) {
    var children = _a.children, props = $280caf62b430e17a$var$__rest(_a, [
        "children"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("aside", $280caf62b430e17a$var$__assign({
        className: cn('sidebar')
    }, props), children);
};
$280caf62b430e17a$export$1ba59dacbcbf90fe.Group = (0, $9VRz9.SidebarGroup);
$280caf62b430e17a$export$1ba59dacbcbf90fe.Divider = (0, $9VRz9.SidebarDivider);
$280caf62b430e17a$export$1ba59dacbcbf90fe.Brand = (0, $iMBm0.SidebarBrand);
$280caf62b430e17a$export$1ba59dacbcbf90fe.Menu = (0, $7rAzQ.SidebarMenu);
$280caf62b430e17a$export$1ba59dacbcbf90fe.Link = (0, $7rAzQ.SidebarLink);

});
parcelRegister("iMBm0", function(module, exports) {

$parcel$export(module.exports, "SidebarBrand", function () { return $dac9af67ac966292$export$fb912d881d4e6ab8; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $dac9af67ac966292$export$fb912d881d4e6ab8 = function(_a) {
    var label = _a.label, logo = _a.logo, href = _a.href, onClick = _a.onClick;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('sidebar-brand')
    }, $a5EUy.createElement("a", {
        className: cn('sidebar-logo'),
        href: href,
        onClick: onClick
    }, logo), $a5EUy.createElement("p", {
        className: cn('sidebar-name')
    }, label));
};

});

parcelRegister("9VRz9", function(module, exports) {

$parcel$export(module.exports, "SidebarGroup", function () { return $73b2fd00f7ec2a48$export$879a7d62bcf41a75; });
$parcel$export(module.exports, "SidebarDivider", function () { return $73b2fd00f7ec2a48$export$37d56758a11353df; });
/* eslint-disable react/jsx-no-bind */ 
var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $73b2fd00f7ec2a48$export$879a7d62bcf41a75 = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('sidebar-group')
    }, children);
};
$73b2fd00f7ec2a48$export$879a7d62bcf41a75.displayName = 'Sidebar.Group';
var $73b2fd00f7ec2a48$export$37d56758a11353df = function() {
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("hr", {
        className: cn('sidebar-divider')
    });
};
$73b2fd00f7ec2a48$export$37d56758a11353df.displayName = 'Sidebar.Divider';

});

parcelRegister("7rAzQ", function(module, exports) {

$parcel$export(module.exports, "SidebarMenu", function () { return $56b76d772dd6d84e$export$a9f2769ca96a3d36; });
$parcel$export(module.exports, "SidebarLink", function () { return $56b76d772dd6d84e$export$ecfd54512feac3da; });
/* eslint-disable react/jsx-no-bind */ 
var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $56b76d772dd6d84e$export$a9f2769ca96a3d36 = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('sidebar-menu')
    }, children);
};
$56b76d772dd6d84e$export$a9f2769ca96a3d36.displayName = 'Sidebar.Menu';
var $56b76d772dd6d84e$export$ecfd54512feac3da = function(_a) {
    var children = _a.children;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", {
        className: cn('sidebar-link')
    }, children);
};
$56b76d772dd6d84e$export$ecfd54512feac3da.displayName = 'Sidebar.Link';

});



parcelRegister("dIWFu", function(module, exports) {
parcelRequire("vDmKQ");

});
parcelRegister("vDmKQ", function(module, exports) {
parcelRequire("2cnsK");
var $jtj7G = parcelRequire("jtj7G");

var $a5EUy = parcelRequire("a5EUy");
parcelRequire("bHt1e");
var $gSNWl = parcelRequire("gSNWl");
var $iQCcD = parcelRequire("iQCcD");

var $jLRsx = parcelRequire("jLRsx");
parcelRequire("6yhm4");
var $hd3cd = parcelRequire("hd3cd");
var $2u0dC = parcelRequire("2u0dC");

var $jCE8G = parcelRequire("jCE8G");
parcelRequire("kbxqT");
var $70aOe = parcelRequire("70aOe");
var $05f16ea27a85789b$var$__assign = undefined && undefined.__assign || function() {
    $05f16ea27a85789b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $05f16ea27a85789b$var$__assign.apply(this, arguments);
};
var $05f16ea27a85789b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $05f16ea27a85789b$export$651ad66661acd392 = $a5EUy.forwardRef(function(_a, ref) {
    var _b;
    var _c = _a.isDisabled, isDisabled = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? 'medium' : _d, label = _a.label, onDropdownSelect = _a.onDropdownSelect, isNarrow = _a.isNarrow, isClipped = _a.isClipped, children = _a.children, props = $05f16ea27a85789b$var$__rest(_a, [
        "isDisabled",
        "size",
        "label",
        "onDropdownSelect",
        "isNarrow",
        "isClipped",
        "children"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    // eslint-disable-next-line no-null/no-null
    var dropdown = $a5EUy.useRef(null);
    var reference = (0, $iQCcD.useShareForwardRef)(ref);
    // eslint-disable-next-line no-null/no-null
    var reff = $a5EUy.useRef(null);
    var _e = (0, $2u0dC.useDropdown)(dropdown, reference), toggleVisible = _e.toggleVisible, setVisible = _e.setVisible;
    var buttonClasses = (_b = {}, _b["button"] = true, _b["is-" + size] = size, _b["is-disabled"] = isDisabled, _b);
    (0, $gSNWl.useClickOutside)(dropdown, function() {
        setVisible(false);
    });
    return $a5EUy.createElement("div", {
        className: cn('split-button'),
        ref: reff,
        role: "button"
    }, $a5EUy.createElement("button", $05f16ea27a85789b$var$__assign({
        className: cn(buttonClasses),
        ref: ref
    }, props), label), $a5EUy.createElement("button", {
        className: cn('is-split-icon', buttonClasses),
        onClick: toggleVisible,
        ref: reference
    }, $a5EUy.createElement((0, $70aOe.Icon), {
        as: "span",
        icon: $a5EUy.createElement((0, $jtj7G.ArrowDownBold), null)
    })), $a5EUy.createElement((0, $hd3cd.Dropdown), {
        isClipped: isClipped,
        isNarrow: isNarrow,
        onDropdownSelect: (0, $jLRsx.chain)(toggleVisible, onDropdownSelect),
        ref: dropdown
    }, children));
});
$05f16ea27a85789b$export$651ad66661acd392.Action = (0, $jCE8G.DropdownItem);

});


parcelRegister("d3oA4", function(module, exports) {
parcelRequire("lxpag");

});
parcelRegister("lxpag", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $hA8Vb = parcelRequire("hA8Vb");
var $fae0333411460920$var$__assign = undefined && undefined.__assign || function() {
    $fae0333411460920$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fae0333411460920$var$__assign.apply(this, arguments);
};
var $fae0333411460920$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fae0333411460920$export$ed8ca599049e8881 = function(_a) {
    var _b;
    var children = _a.children, isVertical = _a.isVertical, _c = _a.alignment, alignment = _c === void 0 ? 'center' : _c, activeStep = _a.activeStep, completedSteps = _a.completedSteps, onChange = _a.onChange, props = $fae0333411460920$var$__rest(_a, [
        "children",
        "isVertical",
        "alignment",
        "activeStep",
        "completedSteps",
        "onChange"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var state = $a5EUy.useCallback(function(index) {
        if (index === activeStep) return 'active';
        return (completedSteps === null || completedSteps === void 0 ? void 0 : completedSteps.includes(index)) ? 'complete' : 'incomplete';
    }, [
        activeStep,
        completedSteps
    ]);
    return $a5EUy.createElement("ul", $fae0333411460920$var$__assign({
        className: cn('stepper', (_b = {
            'is-vertical': isVertical
        }, _b["is-" + alignment] = alignment, _b))
    }, props), $a5EUy.Children.map(children, function(child, index) {
        return $a5EUy.cloneElement(child, $fae0333411460920$var$__assign({
            index: index + 1,
            state: state(index + 1),
            onClick: function() {
                if (onChange && state(index + 1) === 'complete') onChange(index + 1);
            }
        }, child.props));
    }));
};
$fae0333411460920$export$ed8ca599049e8881.Item = (0, $hA8Vb.StepperItem);

});
parcelRegister("hA8Vb", function(module, exports) {

$parcel$export(module.exports, "StepperItem", function () { return $ccccb80a20c229cb$export$ee86eb81f202b5fe; });
parcelRequire("2cnsK");
var $6pIUA = parcelRequire("6pIUA");

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
parcelRequire("kbxqT");
var $70aOe = parcelRequire("70aOe");

var $7qi99 = parcelRequire("7qi99");
var $ccccb80a20c229cb$var$__assign = undefined && undefined.__assign || function() {
    $ccccb80a20c229cb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ccccb80a20c229cb$var$__assign.apply(this, arguments);
};
var $ccccb80a20c229cb$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ccccb80a20c229cb$export$ee86eb81f202b5fe = function(_a) {
    var label = _a.label, _b = _a.state, state = _b === void 0 ? 'incomplete' : _b, index = _a.index, props = $ccccb80a20c229cb$var$__rest(_a, [
        "label",
        "state",
        "index"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var uid = (0, $7qi99.useID)('stepper');
    var body = $a5EUy.useMemo(function() {
        if (state === 'complete') return $a5EUy.createElement((0, $70aOe.Icon), {
            icon: $a5EUy.createElement((0, $6pIUA.CheckTickBold), null)
        });
        return index;
    }, [
        index,
        state
    ]);
    return $a5EUy.createElement("li", {
        "aria-current": state === 'active',
        className: cn('stepper-item', "is-" + state),
        role: "presentation"
    }, $a5EUy.createElement("div", {
        className: cn('stepper-graph')
    }, $a5EUy.createElement("button", $ccccb80a20c229cb$var$__assign({
        className: cn('stepper-link'),
        id: uid
    }, props, {
        tabIndex: state === 'complete' ? 0 : -1
    }), body)), $a5EUy.createElement("label", {
        className: cn('stepper-label'),
        htmlFor: uid
    }, label));
};
$ccccb80a20c229cb$export$ee86eb81f202b5fe.displayName = 'Stepper.Item';

});



parcelRegister("5RRwQ", function(module, exports) {
parcelRequire("LStZO");

});
parcelRegister("LStZO", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $dRTVd = parcelRequire("dRTVd");
var $08fea70d181fab67$var$__assign = undefined && undefined.__assign || function() {
    $08fea70d181fab67$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $08fea70d181fab67$var$__assign.apply(this, arguments);
};
var $08fea70d181fab67$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $08fea70d181fab67$export$b5d5cf8927ab7262 = function(_a) {
    var isDisabled = _a.isDisabled, onSwitch = _a.onSwitch, props = $08fea70d181fab67$var$__rest(_a, [
        "isDisabled",
        "onSwitch"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var _b = (0, $dRTVd.useSwitch)($08fea70d181fab67$var$__assign({
        isDisabled: isDisabled
    }, props)), checked = _b.checked, onClick = _b.onClick, attars = $08fea70d181fab67$var$__rest(_b, [
        "checked",
        "onClick"
    ]);
    var onClickHandler = $a5EUy.useCallback(function(e) {
        if (onSwitch) onSwitch(!!checked);
    }, [
        onClick,
        checked
    ]);
    return $a5EUy.createElement("div", $08fea70d181fab67$var$__assign({
        className: cn('switch', {
            'is-active': checked,
            'is-disabled': isDisabled
        }),
        onClick: (0, $jLRsx.chain)(onClickHandler, onClick)
    }, attars, props), $a5EUy.createElement("div", {
        className: cn('switch-dot')
    }));
};

});
parcelRegister("dRTVd", function(module, exports) {

$parcel$export(module.exports, "useSwitch", function () { return $a18b9a850ace4eb8$export$d853f7095ae95f88; });

var $a5EUy = parcelRequire("a5EUy");
var $a18b9a850ace4eb8$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $a18b9a850ace4eb8$export$d853f7095ae95f88 = function(_a) {
    var isDisabled = _a.isDisabled, defaultChecked = _a.defaultChecked;
    var _b = $a18b9a850ace4eb8$var$__read($a5EUy.useState(!!defaultChecked), 2), isOn = _b[0], setIsOn = _b[1];
    var onKeyDown = function(e) {
        switch(e.key){
            case 'Enter':
            case ' ':
                e.preventDefault();
                setIsOn(function(prev) {
                    return !prev;
                });
                return;
        }
    };
    var onClick = $a5EUy.useCallback(function() {
        setIsOn(function(prev) {
            return !prev;
        });
    }, [
        isOn
    ]);
    return {
        checked: isOn,
        role: 'switch',
        tabIndex: isDisabled ? -1 : 0,
        'aria-checked': isOn,
        'aria-disabled': isDisabled,
        onClick: onClick,
        onKeyDown: onKeyDown
    };
};

});



parcelRegister("dkAhj", function(module, exports) {
parcelRequire("lfpEz");
parcelRequire("1O8k8");

});
parcelRegister("lfpEz", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $fSAoo = parcelRequire("fSAoo");

var $fqSvI = parcelRequire("fqSvI");

var $lQ7d3 = parcelRequire("lQ7d3");

var $5yrUm = parcelRequire("5yrUm");

var $1O8k8 = parcelRequire("1O8k8");

var $7qi99 = parcelRequire("7qi99");
var $f77ee5e86cfde483$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $f77ee5e86cfde483$export$b2539bed5023c21c = function(_a) {
    var children = _a.children, onActiveTabChange = _a.onActiveTabChange, _b = _a.initialActiveTab, initialActiveTab = _b === void 0 ? 0 : _b, _c = _a.selectionMode, selectionMode = _c === void 0 ? (0, $1O8k8.FocusSelectionMode).AUTOMATIC : _c;
    var _d = $f77ee5e86cfde483$var$__read($a5EUy.useState(initialActiveTab), 2), activeTab = _d[0], setActiveTab = _d[1];
    var _e = $f77ee5e86cfde483$var$__read($a5EUy.useState(activeTab), 2), focusedTab = _e[0], setFocusedTab = _e[1];
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    $a5EUy.useEffect(function() {
        onActiveTabChange === null || onActiveTabChange === void 0 || onActiveTabChange(activeTab);
    }, [
        activeTab,
        onActiveTabChange
    ]);
    var id = (0, $7qi99.useID)('tabs');
    var contextValue = $a5EUy.useMemo(function() {
        return {
            id: id,
            activeTab: activeTab,
            setActiveTab: setActiveTab,
            focusedTab: focusedTab,
            setFocusedTab: setFocusedTab,
            selectionMode: selectionMode,
            onActiveTabChange: onActiveTabChange
        };
    }, [
        id,
        activeTab,
        setActiveTab,
        focusedTab,
        setFocusedTab,
        onActiveTabChange,
        selectionMode
    ]);
    var className = cn('tabs');
    return $a5EUy.createElement((0, $1O8k8.TabsContext).Provider, {
        value: contextValue
    }, $a5EUy.createElement("div", {
        className: className,
        id: id
    }, children));
};
$f77ee5e86cfde483$export$b2539bed5023c21c.TabList = (0, $fqSvI.TabList);
$f77ee5e86cfde483$export$b2539bed5023c21c.Tab = (0, $fSAoo.Tab);
$f77ee5e86cfde483$export$b2539bed5023c21c.TabPanels = (0, $5yrUm.TabPanels);
$f77ee5e86cfde483$export$b2539bed5023c21c.TabPanel = (0, $lQ7d3.TabPanel);

});
parcelRegister("fSAoo", function(module, exports) {

$parcel$export(module.exports, "Tab", function () { return $b8f820ec140d10b5$export$3e41faf802a29e71; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $1O8k8 = parcelRequire("1O8k8");

var $7qi99 = parcelRequire("7qi99");
var $b8f820ec140d10b5$var$__assign = undefined && undefined.__assign || function() {
    $b8f820ec140d10b5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b8f820ec140d10b5$var$__assign.apply(this, arguments);
};
var $b8f820ec140d10b5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b8f820ec140d10b5$export$3e41faf802a29e71 = function(_a) {
    var children = _a.children, index = _a.index, _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b, props = $b8f820ec140d10b5$var$__rest(_a, [
        "children",
        "index",
        "isDisabled"
    ]);
    var _c = (0, $1O8k8.useTabsContext)(), id = _c.id, activeTab = _c.activeTab, setActiveTab = _c.setActiveTab, focusedTab = _c.focusedTab, setFocusedTab = _c.setFocusedTab;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    if (index === undefined) // eslint-disable-next-line no-null/no-null
    return null;
    var className = cn('tab', {
        'is-active': activeTab === index,
        'is-focused': focusedTab === index,
        'is-disabled': isDisabled
    });
    return $a5EUy.createElement("li", {
        className: className,
        role: "presentation"
    }, $a5EUy.createElement("button", $b8f820ec140d10b5$var$__assign({
        "aria-controls": activeTab === index ? (0, $7qi99.makeTabPanelId)(id, index) : undefined,
        "aria-selected": activeTab === index ? true : undefined,
        id: (0, $7qi99.makeTabId)(id, index),
        // eslint-disable-next-line react/jsx-no-bind
        onClick: function() {
            setFocusedTab(index);
            setActiveTab(index);
        },
        role: "tab",
        tabIndex: activeTab === index ? 0 : -1
    }, props), children));
};
$b8f820ec140d10b5$export$3e41faf802a29e71.displayName = 'Tabs.Tab';

});
parcelRegister("1O8k8", function(module, exports) {

$parcel$export(module.exports, "FocusSelectionMode", function () { return $1510eade56c298ac$export$b9d98644d6233b40; });
$parcel$export(module.exports, "TabsContext", function () { return $1510eade56c298ac$export$cfa7aa87c26e7d1f; });
$parcel$export(module.exports, "useTabsContext", function () { return $1510eade56c298ac$export$5c3d36c3adf0ba92; });

var $a5EUy = parcelRequire("a5EUy");
var $1510eade56c298ac$export$b9d98644d6233b40;
(function(FocusSelectionMode) {
    FocusSelectionMode["AUTOMATIC"] = "automatic";
    FocusSelectionMode["MANUAL"] = "manual";
})($1510eade56c298ac$export$b9d98644d6233b40 || ($1510eade56c298ac$export$b9d98644d6233b40 = {}));
var $1510eade56c298ac$export$cfa7aa87c26e7d1f = $a5EUy.createContext(undefined);
var $1510eade56c298ac$export$5c3d36c3adf0ba92 = function() {
    var context = $a5EUy.useContext($1510eade56c298ac$export$cfa7aa87c26e7d1f);
    if (context) return context;
    throw new Error("Tab compound components can't be rendered outside Tabs component");
};

});


parcelRegister("fqSvI", function(module, exports) {

$parcel$export(module.exports, "TabList", function () { return $b3c3916465d87f34$export$e51a686c67fdaa2d; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");

var $1O8k8 = parcelRequire("1O8k8");
var $b3c3916465d87f34$var$__assign = undefined && undefined.__assign || function() {
    $b3c3916465d87f34$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b3c3916465d87f34$var$__assign.apply(this, arguments);
};
var $b3c3916465d87f34$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
/**
 * Based on an existing array return the original index identifier
 *
 * example: current `activeTab` is 1 and children returns an array of [0, 1, 2, 3, 4] where the
 * 3rd and 4th element are disabled, so you get back [0, 1, 4] and acgiveTab is still 1 but the
 * enabledSelectedIndex is for the enabledIndexes array and is also 1
 *
 * however in the case of where `activeTab` is 4 in the original array, now `enabledSelectedIndex`
 * should return `2` as the `activeTab` is the last elemnt in the enabledIndexes
 *
 * note that we are mixing index positions and index values in an array to keep track of this.
 *
 */ var $b3c3916465d87f34$var$getAvailableTabIndexes = function(activeTab, children) {
    var enabledIndexes = $a5EUy.Children.map(children, function(child, index) {
        return child.props.isDisabled === true ? undefined : index;
    });
    var enabledSelectedIndex = enabledIndexes.indexOf(activeTab);
    return {
        enabledSelectedIndex: enabledSelectedIndex,
        enabledIndexes: enabledIndexes
    };
};
var $b3c3916465d87f34$var$getNextAvailableTab = function(activeTabIndex, availableTabIndexes) {
    return availableTabIndexes[(activeTabIndex + 1) % availableTabIndexes.length];
};
var $b3c3916465d87f34$var$getPrevAvailableTab = function(activeTabIndex, availableTabIndexes) {
    return availableTabIndexes[(activeTabIndex + availableTabIndexes.length - 1) % availableTabIndexes.length];
};
var $b3c3916465d87f34$var$getFirstAvailableTab = function(activeTabIndex, availableTabIndexes) {
    return availableTabIndexes[0];
};
var $b3c3916465d87f34$var$getLastAvailableTab = function(activeTabIndex, availableTabIndexes) {
    return availableTabIndexes[availableTabIndexes.length - 1];
};
var $b3c3916465d87f34$export$e51a686c67fdaa2d = function(_a) {
    var _b;
    var children = _a.children, size = _a.size;
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var _c = (0, $1O8k8.useTabsContext)(), activeTab = _c.activeTab, setActiveTab = _c.setActiveTab, focusedTab = _c.focusedTab, setFocusedTab = _c.setFocusedTab, selectionMode = _c.selectionMode;
    var _d = $b3c3916465d87f34$var$__read($a5EUy.useState(false), 2), hasFocus = _d[0], setHasFocus = _d[1];
    $a5EUy.useEffect(function() {
        if (!hasFocus) setFocusedTab(-1);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        hasFocus,
        setFocusedTab
    ]);
    var onFocus = function() {
        setHasFocus(true);
        setFocusedTab(activeTab);
    };
    // TODO: Think about this whole onKeyDown/OnFocus/hasFocus
    // in terms of a re-usable hook cause this is messy
    // we should also probably work with refs and prefer to use ref.current.focus(), but sadly we
    // have a design that seems to re-implement the default focus behavior
    // we need a broad discussion about focus traps and what consitutes the focus, because we are missing
    // focus behavior on the TabPanel component.
    // eslint-disable-next-line complexity
    var onKeyDown = function(e) {
        var _a = $b3c3916465d87f34$var$getAvailableTabIndexes(focusedTab, children), enabledSelectedIndex = _a.enabledSelectedIndex, enabledIndexes = _a.enabledIndexes;
        var newIndex;
        if (hasFocus) switch(e.key){
            case 'ArrowDown':
            case 'ArrowRight':
                e.preventDefault();
                newIndex = $b3c3916465d87f34$var$getNextAvailableTab(enabledSelectedIndex, enabledIndexes);
                if (selectionMode === (0, $1O8k8.FocusSelectionMode).AUTOMATIC) setActiveTab(newIndex);
                setFocusedTab(newIndex);
                return;
            case 'ArrowLeft':
            case 'ArrowUp':
                e.preventDefault();
                newIndex = $b3c3916465d87f34$var$getPrevAvailableTab(enabledSelectedIndex, enabledIndexes);
                if (selectionMode === (0, $1O8k8.FocusSelectionMode).AUTOMATIC) setActiveTab(newIndex);
                setFocusedTab(newIndex);
                return;
            case 'End':
                e.preventDefault();
                newIndex = $b3c3916465d87f34$var$getLastAvailableTab(enabledSelectedIndex, enabledIndexes);
                if (selectionMode === (0, $1O8k8.FocusSelectionMode).AUTOMATIC) setActiveTab(newIndex);
                setFocusedTab(newIndex);
                return;
            case 'Home':
                e.preventDefault();
                newIndex = $b3c3916465d87f34$var$getFirstAvailableTab(enabledSelectedIndex, enabledIndexes);
                if (selectionMode === (0, $1O8k8.FocusSelectionMode).AUTOMATIC) setActiveTab(newIndex);
                setFocusedTab(newIndex);
                return;
            case 'Enter':
            case ' ':
                e.preventDefault();
                setActiveTab(focusedTab);
                return;
        }
    };
    var className = cn('tablist', $b3c3916465d87f34$var$__assign({}, size && (_b = {}, _b["is-" + size] = true, _b)));
    return $a5EUy.createElement("ul", {
        className: className,
        role: "tablist"
    }, $a5EUy.Children.map(children, function(child, index) {
        return $a5EUy.cloneElement(child, $b3c3916465d87f34$var$__assign({
            index: index,
            onFocus: onFocus,
            onBlur: function() {
                // all we're doing here is making sure that we know we're in a focused mode.
                setHasFocus(false);
            },
            onKeyDown: onKeyDown
        }, child.props));
    }));
};
$b3c3916465d87f34$export$e51a686c67fdaa2d.displayName = 'Tabs.TabList';

});

parcelRegister("lQ7d3", function(module, exports) {

$parcel$export(module.exports, "TabPanel", function () { return $fe640bfed05a8c37$export$3d96ec278d3efce4; });

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $fe640bfed05a8c37$var$__assign = undefined && undefined.__assign || function() {
    $fe640bfed05a8c37$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fe640bfed05a8c37$var$__assign.apply(this, arguments);
};
var $fe640bfed05a8c37$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fe640bfed05a8c37$export$3d96ec278d3efce4 = function(_a) {
    var children = _a.children, props = $fe640bfed05a8c37$var$__rest(_a, [
        "children"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", $fe640bfed05a8c37$var$__assign({
        className: cn('tabpanel'),
        role: "tabpanel"
    }, props), children);
};
$fe640bfed05a8c37$export$3d96ec278d3efce4.displayName = 'Tabs.TabPanel';

});

parcelRegister("5yrUm", function(module, exports) {

$parcel$export(module.exports, "TabPanels", function () { return $40b5c6aeb5412939$export$5dae8d435677f210; });

var $a5EUy = parcelRequire("a5EUy");

var $lQ7d3 = parcelRequire("lQ7d3");

var $1O8k8 = parcelRequire("1O8k8");

var $7qi99 = parcelRequire("7qi99");
var $40b5c6aeb5412939$var$__assign = undefined && undefined.__assign || function() {
    $40b5c6aeb5412939$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $40b5c6aeb5412939$var$__assign.apply(this, arguments);
};
var $40b5c6aeb5412939$export$5dae8d435677f210 = function(_a) {
    var children = _a.children;
    var _b = (0, $1O8k8.useTabsContext)(), id = _b.id, activeTab = _b.activeTab;
    var activeChild = children[activeTab];
    if (!$a5EUy.isValidElement(activeChild)) activeChild = $a5EUy.createElement((0, $lQ7d3.TabPanel), null, "Make sure to associate a tab panel for this tab");
    return $a5EUy.cloneElement(activeChild, $40b5c6aeb5412939$var$__assign({
        tabIndex: 0,
        id: (0, $7qi99.makeTabPanelId)(id, activeTab),
        'aria-labelledby': (0, $7qi99.makeTabId)(id, activeTab)
    }, activeChild.props));
};
$40b5c6aeb5412939$export$5dae8d435677f210.displayName = 'Tabs.TabPanels';

});



parcelRegister("aFdt3", function(module, exports) {
parcelRequire("4mCrr");
parcelRequire("d4VQi");

});
parcelRegister("4mCrr", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $32d7092dac27b757$var$__assign = undefined && undefined.__assign || function() {
    $32d7092dac27b757$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $32d7092dac27b757$var$__assign.apply(this, arguments);
};
var $32d7092dac27b757$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $32d7092dac27b757$export$67efe7a6dccb9914 = $a5EUy.forwardRef(function(_a, ref) {
    var label = _a.label, _b = _a.size, size = _b === void 0 ? 'default' : _b, isDisabled = _a.isDisabled, props = $32d7092dac27b757$var$__rest(_a, [
        "label",
        "size",
        "isDisabled"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("a", $32d7092dac27b757$var$__assign({
        "aria-disabled": isDisabled,
        "aria-label": label,
        className: cn('text-link', "is-" + size),
        disabled: isDisabled
    }, props, {
        ref: ref
    }), label);
});

});

parcelRegister("d4VQi", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");

var $jLRsx = parcelRequire("jLRsx");
var $98588465356e23ae$var$__assign = undefined && undefined.__assign || function() {
    $98588465356e23ae$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $98588465356e23ae$var$__assign.apply(this, arguments);
};
var $98588465356e23ae$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $98588465356e23ae$export$9ce414e821e502ec = $a5EUy.forwardRef(function(_a, ref) {
    var children = _a.children, props = $98588465356e23ae$var$__rest(_a, [
        "children"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    return $a5EUy.createElement("div", $98588465356e23ae$var$__assign({
        className: cn('text-links'),
        ref: ref
    }, props), children);
});

});


parcelRegister("5Ro4X", function(module, exports) {
parcelRequire("9Qxx8");

});

parcelRegister("3lTu3", function(module, exports) {
parcelRequire("ixYhO");
parcelRequire("7V4DA");
parcelRequire("gPCvB");

});
parcelRegister("ixYhO", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
parcelRequire("f1RE8");
var $5FQ7r = parcelRequire("5FQ7r");

var $gPCvB = parcelRequire("gPCvB");
var $037c088f25579a86$var$__assign = undefined && undefined.__assign || function() {
    $037c088f25579a86$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $037c088f25579a86$var$__assign.apply(this, arguments);
};
var $037c088f25579a86$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $037c088f25579a86$export$a8a3e93435678ff9 = (0, $5FQ7r.forwardRefAs)(function(_a, ref) {
    var _b = _a.as, as = _b === void 0 ? 'h1' : _b, props = $037c088f25579a86$var$__rest(_a, [
        "as"
    ]);
    return $a5EUy.createElement((0, $gPCvB.Typography), $037c088f25579a86$var$__assign({
        as: as
    }, props, {
        ref: ref
    }));
});

});
parcelRegister("gPCvB", function(module, exports) {

$parcel$export(module.exports, "Typography", function () { return $c40f47c92604c099$export$1c6175f3aa4394b7; });

var $a5EUy = parcelRequire("a5EUy");
parcelRequire("bHt1e");
var $8wBe8 = parcelRequire("8wBe8");

var $jLRsx = parcelRequire("jLRsx");
parcelRequire("f1RE8");
var $5FQ7r = parcelRequire("5FQ7r");
var $fogwr = parcelRequire("fogwr");
var $c40f47c92604c099$var$__assign = undefined && undefined.__assign || function() {
    $c40f47c92604c099$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c40f47c92604c099$var$__assign.apply(this, arguments);
};
var $c40f47c92604c099$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c40f47c92604c099$export$1c6175f3aa4394b7 = (0, $5FQ7r.forwardRefAs)(function(_a, ref) {
    var _b = _a.as, as = _b === void 0 ? 'p' : _b, _c = _a.size, size = _c === void 0 ? 'normal' : _c, _d = _a.weight, weight = _d === void 0 ? 'default' : _d, props = $c40f47c92604c099$var$__rest(_a, [
        "as",
        "size",
        "weight"
    ]);
    var cn = (0, $jLRsx.useFrameworkClassnamePrefixer)();
    var fontSize = (0, $8wBe8.useFont)(size);
    return $a5EUy.createElement((0, $fogwr.Polymorph), $c40f47c92604c099$var$__assign({
        as: as,
        className: cn('text', "" + fontSize, "text-weight-" + weight),
        ref: ref
    }, props));
});

});


parcelRegister("7V4DA", function(module, exports) {

var $a5EUy = parcelRequire("a5EUy");
parcelRequire("f1RE8");
var $5FQ7r = parcelRequire("5FQ7r");

var $gPCvB = parcelRequire("gPCvB");
var $5c417432addb93d0$var$__assign = undefined && undefined.__assign || function() {
    $5c417432addb93d0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c417432addb93d0$var$__assign.apply(this, arguments);
};
var $5c417432addb93d0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5c417432addb93d0$export$358a232cca1ab2ac = (0, $5FQ7r.forwardRefAs)(function(_a, ref) {
    var _b = _a.as, as = _b === void 0 ? 'p' : _b, props = $5c417432addb93d0$var$__rest(_a, [
        "as"
    ]);
    return $a5EUy.createElement((0, $gPCvB.Typography), $5c417432addb93d0$var$__assign({
        as: as
    }, props, {
        ref: ref
    }));
});

});





parcelRegister("gAOhP", function(module, exports) {

$parcel$export(module.exports, "snackbarTypes", function () { return $c14703f9ddf73485$export$628738c5f3e0b7f2; });
const $c14703f9ddf73485$export$628738c5f3e0b7f2 = {
    INFO: 'info',
    WARNING: 'warn',
    SUCCESS: 'success',
    ERROR: 'error'
};

});




parcelRegister("gFRU1", function(module, exports) {

$parcel$export(module.exports, "throwErrorWithTransactionName", function () { return $c23a4995eb180ebd$export$d0df18f508b1ea7d; });
$parcel$export(module.exports, "addCustomBreadcrumb", function () { return $c23a4995eb180ebd$export$b5fbf978afbd2066; });
$parcel$export(module.exports, "addDefaultBreadcrumb", function () { return $c23a4995eb180ebd$export$fcbb0b4f9575850b; });

var $6tz0u = parcelRequire("6tz0u");
const $c23a4995eb180ebd$export$d0df18f508b1ea7d = (error, transactionName)=>{
    if (transactionName) (0, $6tz0u.apmBase)?.getCurrentTransaction()?.addLabels({
        transaction: transactionName
    });
    throw error;
};
const $c23a4995eb180ebd$var$breadCrumbKey = 'Breadcrumb';
const $c23a4995eb180ebd$export$b5fbf978afbd2066 = ({ message: message, category: category = 'console', data: data = {} })=>{
    if (data && Object.keys(data).length > 0) message = `${$c23a4995eb180ebd$var$breadCrumbKey}: ${message} ${JSON.stringify(data)}`;
    else message = `${$c23a4995eb180ebd$var$breadCrumbKey}: ${message}`;
    (0, $6tz0u.apmBase)?.getCurrentTransaction()?.startSpan(message, category);
};
const $c23a4995eb180ebd$export$fcbb0b4f9575850b = (message, category = 'console')=>{
    $c23a4995eb180ebd$export$b5fbf978afbd2066({
        message: message,
        category: category
    });
};

});


parcelRegister("ig7wp", function(module, exports) {

$parcel$export(module.exports, "HomePageTable", function () { return $d4af8e4a7b759c53$export$ab6b16e774866135; });

var $df8fE = parcelRequire("df8fE");

var $3yJBl = parcelRequire("3yJBl");

var $a5EUy = parcelRequire("a5EUy");

var $7qcWb = parcelRequire("7qcWb");

var $1lyZZ = parcelRequire("1lyZZ");

var $cRlsu = parcelRequire("cRlsu");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $jahGf = parcelRequire("jahGf");
var $cbxDY = parcelRequire("cbxDY");

var $b7eOs = parcelRequire("b7eOs");

var $bSyi6 = parcelRequire("bSyi6");
const $d4af8e4a7b759c53$var$tableStyle = (0, $1lyZZ.css)({
    width: '100%',
    borderCollapse: 'collapse'
});
const $d4af8e4a7b759c53$var$tableThStyle = (0, $1lyZZ.css)({
    textAlign: 'left',
    fontSize: (0, $jahGf.font).size.sizeM1,
    borderBottom: `2px solid ${(0, $8JWbY.colors).neutralColors.slate20}`,
    height: (0, $cbxDY.spacing).size10,
    '&:first-of-type': {
        paddingLeft: (0, $cbxDY.spacing).size5
    }
});
const $d4af8e4a7b759c53$var$tableTdStyle = (0, $1lyZZ.css)({
    fontSize: (0, $jahGf.font).size.sizeM1,
    borderBottom: `1px solid ${(0, $8JWbY.colors).neutralColors.slate20}`,
    padding: `${(0, $cbxDY.spacing).size1}px 0`,
    '&:first-of-type': {
        paddingLeft: (0, $cbxDY.spacing).size5
    }
});
const $d4af8e4a7b759c53$export$ab6b16e774866135 = ({ surveyListdata: surveyListdata })=>{
    const { labels: { svy_table_header_year_of_evaluation: svy_table_header_year_of_evaluation, svy_table_header_status: svy_table_header_status } } = (0, $cRlsu.useLabels)();
    const columns = (0, $a5EUy.useMemo)(()=>[
            {
                Header: svy_table_header_year_of_evaluation,
                accessor: 'year'
            },
            {
                Header: svy_table_header_status,
                accessor: 'surveyState.status',
                Cell: (0, $bSyi6.AssessmentStatusCell)
            },
            {
                accessor: 'surveyState',
                Cell: (0, $b7eOs.ActionButtonCell)
            },
            {
                accessor: 'version',
                hidden: true
            }
        ], [
        svy_table_header_year_of_evaluation,
        svy_table_header_status
    ]);
    // Use the state and functions returned from useTable to build your UI
    const { getTableProps: getTableProps, getTableBodyProps: getTableBodyProps, headerGroups: headerGroups, rows: rows, prepareRow: prepareRow } = (0, $7qcWb.useTable)({
        columns: columns,
        data: surveyListdata,
        initialState: {
            hiddenColumns: columns.filter((column)=>!!column.hidden).map((column)=>column.accessor)
        }
    });
    return /*#__PURE__*/ (0, $df8fE.jsxs)("table", {
        css: $d4af8e4a7b759c53$var$tableStyle,
        ...getTableProps(),
        children: [
            /*#__PURE__*/ (0, $df8fE.jsx)("thead", {
                children: headerGroups.map((headerGroup, index)=>/*#__PURE__*/ (0, $df8fE.jsx)("tr", {
                        ...headerGroup.getHeaderGroupProps(),
                        children: headerGroup.headers.map((column, index)=>/*#__PURE__*/ (0, $df8fE.jsx)("th", {
                                css: $d4af8e4a7b759c53$var$tableThStyle,
                                ...column.getHeaderProps(),
                                children: column.render('Header')
                            }, `tableheader${index}`))
                    }, `tableheadergroup${index}`))
            }),
            /*#__PURE__*/ (0, $df8fE.jsx)("tbody", {
                ...getTableBodyProps(),
                children: rows.map((row, i)=>{
                    prepareRow(row);
                    return /*#__PURE__*/ (0, $df8fE.jsx)("tr", {
                        ...row.getRowProps(),
                        children: row.cells.map((cell, index)=>{
                            return /*#__PURE__*/ (0, $df8fE.jsx)("td", {
                                css: $d4af8e4a7b759c53$var$tableTdStyle,
                                ...cell.getCellProps(),
                                children: cell.render('Cell')
                            }, `tablecell${index}`);
                        })
                    }, `tablerow${i}`);
                })
            })
        ]
    });
};
$d4af8e4a7b759c53$export$ab6b16e774866135.propTypes = {
    surveyListdata: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).object).isRequired
};

});
parcelRegister("7qcWb", function(module, exports) {

module.exports = (parcelRequire("hvPZl"));

});

parcelRegister("b7eOs", function(module, exports) {

$parcel$export(module.exports, "ActionButtonCell", function () { return $817bd6b0968caf87$export$af40c145ccbdf03c; });

var $df8fE = parcelRequire("df8fE");

var $3yJBl = parcelRequire("3yJBl");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("i7Pqi");
var $gdpIa = parcelRequire("gdpIa");

var $BeyzD = parcelRequire("BeyzD");

var $cRlsu = parcelRequire("cRlsu");

var $5wEm6 = parcelRequire("5wEm6");
parcelRequire("dnijQ");
var $fmWA7 = parcelRequire("fmWA7");
const $817bd6b0968caf87$var$actionButtonWrapperStyle = (0, $1lyZZ.css)({
    display: 'flex',
    justifyContent: 'center'
});
const $817bd6b0968caf87$export$af40c145ccbdf03c = ({ cell: cell })=>{
    const { labels: { svy_start_button: svy_start_button, svy_display_button: svy_display_button, svy_end_edit: svy_end_edit } } = (0, $cRlsu.useLabels)();
    const { value: { isEditable: isEditable, status: status }, row: { values: { year: year, version: version } } } = cell;
    const getActionButton = (isEditable, status)=>{
        if (isEditable && status === (0, $fmWA7.surveyStatus).NOT_SUBMITTED) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $BeyzD.Link), {
            to: `/${(0, $5wEm6.routes).survey}/${year}/${version}`,
            children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                "data-transaction-name": "Start Survey",
                label: svy_start_button,
                size: "small"
            })
        });
        if (isEditable && (status === (0, $fmWA7.surveyStatus).CHANGES_REQUIRED || status === (0, $fmWA7.surveyStatus).RESCORING_REQUIRED)) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $BeyzD.Link), {
            to: {
                pathname: `/${(0, $5wEm6.routes).survey}/${year}/${version}`,
                search: '?mode=edit'
            },
            children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                "data-transaction-name": "Edit Survey",
                label: svy_end_edit,
                size: "small"
            })
        });
        return /*#__PURE__*/ (0, $df8fE.jsx)((0, $BeyzD.Link), {
            to: `/${(0, $5wEm6.routes).review}/${year}/${version}`,
            children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                "data-transaction-name": "Review Survey",
                label: svy_display_button,
                size: "small",
                variant: "outline"
            })
        });
    };
    return /*#__PURE__*/ (0, $df8fE.jsx)("div", {
        css: $817bd6b0968caf87$var$actionButtonWrapperStyle,
        children: getActionButton(isEditable, status)
    });
};
$817bd6b0968caf87$export$af40c145ccbdf03c.propTypes = {
    cell: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).object.isRequired
};

});
parcelRegister("BeyzD", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", function () { return $06febf76502a2c6f$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $06febf76502a2c6f$export$a6c7ac8248d6e38a; });

var $glEgb = parcelRequire("glEgb");

var $6FBZf = parcelRequire("6FBZf");

var $a5EUy = parcelRequire("a5EUy");

var $b72c6 = parcelRequire("b72c6");



var $cCvyD = parcelRequire("cCvyD");

var $fhwFU = parcelRequire("fhwFU");

var $1ytAC = parcelRequire("1ytAC");
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $06febf76502a2c6f$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $6FBZf.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $b72c6.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement((0, $glEgb.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $06febf76502a2c6f$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $6FBZf.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $b72c6.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement((0, $glEgb.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).Component);
var $06febf76502a2c6f$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $06febf76502a2c6f$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $b72c6.createLocation)(to, null, null, currentLocation) : to;
};
var $06febf76502a2c6f$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $06febf76502a2c6f$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).forwardRef;
if (typeof $06febf76502a2c6f$var$forwardRef === "undefined") $06febf76502a2c6f$var$forwardRef = $06febf76502a2c6f$var$forwardRefShim;
function $06febf76502a2c6f$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $06febf76502a2c6f$var$LinkAnchor = $06febf76502a2c6f$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $fhwFU.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $cCvyD.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$06febf76502a2c6f$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($06febf76502a2c6f$var$forwardRefShim !== $06febf76502a2c6f$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $06febf76502a2c6f$export$a6c7ac8248d6e38a = $06febf76502a2c6f$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $06febf76502a2c6f$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $fhwFU.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement((0, $glEgb.__RouterContext).Consumer, null, function(context) {
        !context && (0, $1ytAC.default)(false);
        var history = context.history;
        var location = $06febf76502a2c6f$var$normalizeToLocation($06febf76502a2c6f$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $cCvyD.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $06febf76502a2c6f$var$resolveToLocation(to, context.location);
                var method = replace ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($06febf76502a2c6f$var$forwardRefShim !== $06febf76502a2c6f$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement(component, props);
    });
});
var $06febf76502a2c6f$var$toType, $06febf76502a2c6f$var$refType;
var $06febf76502a2c6f$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $06febf76502a2c6f$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).forwardRef;
if (typeof $06febf76502a2c6f$var$forwardRef$1 === "undefined") $06febf76502a2c6f$var$forwardRef$1 = $06febf76502a2c6f$var$forwardRefShim$1;
function $06febf76502a2c6f$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $06febf76502a2c6f$export$b0d92dbee9b5b60d = $06febf76502a2c6f$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $fhwFU.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement((0, $glEgb.__RouterContext).Consumer, null, function(context) {
        !context && (0, $1ytAC.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $06febf76502a2c6f$var$normalizeToLocation($06febf76502a2c6f$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $glEgb.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = isActive ? $06febf76502a2c6f$var$joinClassnames(classNameProp, activeClassName) : classNameProp;
        var style = isActive ? (0, $cCvyD.default)({}, styleProp, {}, activeStyle) : styleProp;
        var props = (0, $cCvyD.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($06febf76502a2c6f$var$forwardRefShim$1 !== $06febf76502a2c6f$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement($06febf76502a2c6f$export$a6c7ac8248d6e38a, props);
    });
});
var $06febf76502a2c6f$var$ariaCurrentType;

});

parcelRegister("5wEm6", function(module, exports) {

$parcel$export(module.exports, "routes", function () { return $405f3ea528fe5056$export$66b32f6f30eb4b4; });
$parcel$export(module.exports, "RouteHandler", function () { return $405f3ea528fe5056$export$22b81d23ee288e7e; });

var $df8fE = parcelRequire("df8fE");

var $glEgb = parcelRequire("glEgb");

var $dSPjH = parcelRequire("dSPjH");

var $cPiPb = parcelRequire("cPiPb");

var $302dL = parcelRequire("302dL");

var $klVUo = parcelRequire("klVUo");

var $3BwNb = parcelRequire("3BwNb");

var $sApkl = parcelRequire("sApkl");

var $3rEbh = parcelRequire("3rEbh");

var $5fqnd = parcelRequire("5fqnd");

var $2BLAK = parcelRequire("2BLAK");

var $7swS0 = parcelRequire("7swS0");

var $1y5wW = parcelRequire("1y5wW");

var $g11tg = parcelRequire("g11tg");

var $8DvcO = parcelRequire("8DvcO");

var $6cYmE = parcelRequire("6cYmE");

var $jQ6pt = parcelRequire("jQ6pt");

var $aLXfF = parcelRequire("aLXfF");

var $MNWHJ = parcelRequire("MNWHJ");

var $93HRk = parcelRequire("93HRk");

var $51Lyw = parcelRequire("51Lyw");
const $405f3ea528fe5056$var$devEnvs = [
    'development',
    'staging'
];
const $405f3ea528fe5056$var$isDevelopmentEnv = $405f3ea528fe5056$var$devEnvs.includes("production");
let $405f3ea528fe5056$var$Reset;

if ($405f3ea528fe5056$var$isDevelopmentEnv) $405f3ea528fe5056$var$Reset = (parcelRequire("1zQD3")).Reset;
const $405f3ea528fe5056$export$66b32f6f30eb4b4 = {
    login: 'login',
    customerLogin: 'customer-login',
    terms: 'terms',
    homepage: 'homepage',
    survey: 'survey',
    complete: 'complete',
    review: 'review',
    confirmation: 'confirmation',
    reset: 'reset',
    noAssessments: 'no-assessments'
};
const $405f3ea528fe5056$export$22b81d23ee288e7e = ()=>{
    const location = (0, $glEgb.useLocation)();
    const { isUserLoading: isUserLoading } = (0, $dSPjH.useUser)();
    if (isUserLoading) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $cPiPb.OverlayPortal), {
        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $302dL.Spinner), {})
    });
    return /*#__PURE__*/ (0, $df8fE.jsx)((0, $93HRk.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $df8fE.jsx)((0, $aLXfF.ErrorPage), {}),
        children: /*#__PURE__*/ (0, $df8fE.jsxs)((0, $glEgb.Switch), {
            children: [
                /*#__PURE__*/ (0, $df8fE.jsx)((0, $51Lyw.ApmRoute), {
                    exact: true,
                    path: "/",
                    component: (0, $3BwNb.RootPage)
                }),
                /*#__PURE__*/ (0, $df8fE.jsx)((0, $51Lyw.ApmRoute), {
                    exact: true,
                    path: `/${$405f3ea528fe5056$export$66b32f6f30eb4b4.login}`,
                    component: (0, $2BLAK.LoginPage)
                }),
                /*#__PURE__*/ (0, $df8fE.jsx)((0, $51Lyw.ApmRoute), {
                    exact: true,
                    path: `/${$405f3ea528fe5056$export$66b32f6f30eb4b4.customerLogin}`,
                    component: (0, $jQ6pt.MultiCustomerLoginPage)
                }),
                /*#__PURE__*/ (0, $df8fE.jsx)((0, $51Lyw.ApmRoute), {
                    exact: true,
                    path: `/${$405f3ea528fe5056$export$66b32f6f30eb4b4.terms}`,
                    component: (0, $sApkl.TermsPage)
                }),
                /*#__PURE__*/ (0, $df8fE.jsx)((0, $klVUo.AuthRoute), {
                    exact: true,
                    path: `/${$405f3ea528fe5056$export$66b32f6f30eb4b4.homepage}`,
                    component: (0, $6cYmE.withMainLayout)((0, $3rEbh.HomePage))
                }),
                /*#__PURE__*/ (0, $df8fE.jsx)((0, $klVUo.AuthRoute), {
                    exact: true,
                    path: `/${$405f3ea528fe5056$export$66b32f6f30eb4b4.survey}/:year/:version/`,
                    component: (0, $6cYmE.withMainLayout)((0, $5fqnd.SurveyPage))
                }),
                /*#__PURE__*/ (0, $df8fE.jsx)((0, $klVUo.AuthRoute), {
                    exact: true,
                    path: `/${$405f3ea528fe5056$export$66b32f6f30eb4b4.complete}/:year/:version/`,
                    component: (0, $6cYmE.withMainLayout)((0, $7swS0.CompletePage))
                }),
                /*#__PURE__*/ (0, $df8fE.jsx)((0, $klVUo.AuthRoute), {
                    exact: true,
                    path: `/${$405f3ea528fe5056$export$66b32f6f30eb4b4.review}/:year/:version/`,
                    component: (0, $6cYmE.withMainLayout)((0, $1y5wW.ReviewPage))
                }),
                /*#__PURE__*/ (0, $df8fE.jsx)((0, $klVUo.AuthRoute), {
                    exact: true,
                    path: `/${$405f3ea528fe5056$export$66b32f6f30eb4b4.confirmation}`,
                    component: (0, $6cYmE.withMainLayout)((0, $g11tg.ConfirmationPage))
                }),
                /*#__PURE__*/ (0, $df8fE.jsx)((0, $51Lyw.ApmRoute), {
                    exact: true,
                    path: `/${$405f3ea528fe5056$export$66b32f6f30eb4b4.noAssessments}`,
                    component: (0, $MNWHJ.NoAssessmentsPage)
                }),
                $405f3ea528fe5056$var$isDevelopmentEnv && /*#__PURE__*/ (0, $df8fE.jsx)((0, $klVUo.AuthRoute), {
                    exact: true,
                    path: `/${$405f3ea528fe5056$export$66b32f6f30eb4b4.reset}/:year/:version`,
                    component: $405f3ea528fe5056$var$Reset
                }),
                /*#__PURE__*/ (0, $df8fE.jsx)((0, $51Lyw.ApmRoute), {
                    path: "*",
                    component: (0, $8DvcO.PageNotFound)
                })
            ]
        })
    }, location.pathname);
};

});
parcelRegister("klVUo", function(module, exports) {

$parcel$export(module.exports, "AuthRoute", function () { return $ed12b040c74d2885$export$77480bcbce7650ac; });

var $df8fE = parcelRequire("df8fE");

var $3yJBl = parcelRequire("3yJBl");

var $glEgb = parcelRequire("glEgb");

var $dSPjH = parcelRequire("dSPjH");

var $5wEm6 = parcelRequire("5wEm6");
const $ed12b040c74d2885$export$77480bcbce7650ac = ({ component: Component, ...rest })=>{
    const { isLoggedIn: isLoggedIn, selectedCustomer: selectedCustomer } = (0, $dSPjH.useUser)();
    return /*#__PURE__*/ (0, $df8fE.jsx)((0, $glEgb.Route), {
        ...rest,
        render: (props)=>{
            if (!isLoggedIn) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $glEgb.Redirect), {
                to: `/${(0, $5wEm6.routes).login}`
            });
            if (!selectedCustomer.id) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $glEgb.Redirect), {
                to: `/${(0, $5wEm6.routes).customerLogin}`
            });
            if (selectedCustomer.hasAcceptedTerms === false) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $glEgb.Redirect), {
                to: `/${(0, $5wEm6.routes).terms}`
            });
            return /*#__PURE__*/ (0, $df8fE.jsx)(Component, {
                ...props
            });
        }
    });
};
$ed12b040c74d2885$export$77480bcbce7650ac.propTypes = {
    component: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).elementType.isRequired,
    rest: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).object
};

});

parcelRegister("3BwNb", function(module, exports) {

$parcel$export(module.exports, "RootPage", function () { return $29fe43a8b1b1051c$export$a3c1e96f0180d024; });

var $df8fE = parcelRequire("df8fE");

var $glEgb = parcelRequire("glEgb");

var $dSPjH = parcelRequire("dSPjH");

var $5wEm6 = parcelRequire("5wEm6");
const $29fe43a8b1b1051c$export$a3c1e96f0180d024 = ()=>{
    const { isLoggedIn: isLoggedIn, selectedCustomer: selectedCustomer } = (0, $dSPjH.useUser)();
    if (!isLoggedIn) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $glEgb.Redirect), {
        to: `/${(0, $5wEm6.routes).login}`
    });
    if (!selectedCustomer.id) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $glEgb.Redirect), {
        to: `/${(0, $5wEm6.routes).customerLogin}`
    });
    if (selectedCustomer.hasAcceptedTerms === false) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $glEgb.Redirect), {
        to: `/${(0, $5wEm6.routes).terms}`
    });
    return /*#__PURE__*/ (0, $df8fE.jsx)((0, $glEgb.Redirect), {
        to: `/${(0, $5wEm6.routes).homepage}`
    });
};

});

parcelRegister("sApkl", function(module, exports) {

$parcel$export(module.exports, "TermsPage", function () { return $055edb69401c40e6$export$da8a3d5194f851ed; });

var $df8fE = parcelRequire("df8fE");

var $a5EUy = parcelRequire("a5EUy");

var $glEgb = parcelRequire("glEgb");
parcelRequire("2UBc8");
var $byqzn = parcelRequire("byqzn");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("i7Pqi");
var $gdpIa = parcelRequire("gdpIa");
var $7QTa8 = parcelRequire("7QTa8");

var $dSPjH = parcelRequire("dSPjH");

var $iEM5H = parcelRequire("iEM5H");

var $3Hzl1 = parcelRequire("3Hzl1");

var $9AErM = parcelRequire("9AErM");

var $4CRs5 = parcelRequire("4CRs5");
parcelRequire("1OfTO");
var $jahGf = parcelRequire("jahGf");
var $4AJXw = parcelRequire("4AJXw");
var $cbxDY = parcelRequire("cbxDY");

var $cRlsu = parcelRequire("cRlsu");

var $cPiPb = parcelRequire("cPiPb");

var $302dL = parcelRequire("302dL");

var $5wEm6 = parcelRequire("5wEm6");

var $6aHgi = parcelRequire("6aHgi");

var $jBMnw = parcelRequire("jBMnw");

var $7eF6Y = parcelRequire("7eF6Y");
const $055edb69401c40e6$var$iconStyle = (0, $1lyZZ.css)({
    marginTop: (0, $cbxDY.spacing).size3,
    width: 92,
    [(0, $4AJXw.media).medium]: {
        width: 184,
        marginTop: 0
    }
});
const $055edb69401c40e6$var$termsTextStyle = (0, $1lyZZ.css)({
    fontSize: (0, $jahGf.font).size.size0,
    lineHeight: (0, $jahGf.font).lineHeight.m,
    marginBottom: (0, $cbxDY.spacing).size5
});
const $055edb69401c40e6$var$buttonWrapper = (0, $1lyZZ.css)({
    marginTop: (0, $cbxDY.spacing).size6,
    [(0, $4AJXw.media).medium]: {
        marginTop: (0, $cbxDY.spacing).size16
    }
});
const $055edb69401c40e6$export$da8a3d5194f851ed = ()=>{
    const { isLoggedIn: isLoggedIn, selectedCustomer: selectedCustomer, handleSelectedCustomerUpdate: handleSelectedCustomerUpdate } = (0, $dSPjH.useUser)();
    const { labelsLoading: labelsLoading, labels: { svy_intro_headline: svy_intro_headline, svy_intro_details: svy_intro_details, svy_terms_accept_button_text: svy_terms_accept_button_text, svy_snackbar_error_header: svy_snackbar_error_header, svy_snackbar_error_default_text: svy_snackbar_error_default_text, svy_tooltip_accept_terms_first: svy_tooltip_accept_terms_first }, richTextLabels: { svy_intro_policies: svy_intro_policies } } = (0, $cRlsu.useLabels)();
    const [termsAccepted, setTermsAccepted] = (0, $a5EUy.useState)(false);
    const [setAcceptance, { loading: isSetAcceptanceLoading }] = (0, $byqzn.useMutation)((0, $9AErM.ACCEPT_TERMS), {
        onCompleted: handleAcceptTermsResponse
    });
    function handleAcceptTermsResponse(response) {
        handleSelectedCustomerUpdate({
            hasAcceptedTerms: response?.acceptTerms || false
        });
    }
    const handleStartSurveyButtonClick = async ()=>{
        try {
            await setAcceptance({
                variables: {
                    customerId: selectedCustomer.id
                }
            });
        } catch (error) {
            (0, $7eF6Y.generalApiErrorHandler)({
                error: error,
                snackbarHeader: svy_snackbar_error_header,
                snackbarMessage: svy_snackbar_error_default_text
            });
        }
    };
    if (!isLoggedIn) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $glEgb.Redirect), {
        to: `/${(0, $5wEm6.routes).login}`
    });
    if (!selectedCustomer.id) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $glEgb.Redirect), {
        to: `/${(0, $5wEm6.routes).customerLogin}`
    });
    if (selectedCustomer.hasAcceptedTerms) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $glEgb.Redirect), {
        to: `/${(0, $5wEm6.routes).homepage}`
    });
    if (labelsLoading || isSetAcceptanceLoading) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $cPiPb.OverlayPortal), {
        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $302dL.Spinner), {})
    });
    return /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $df8fE.jsx)((0, $iEM5H.Header), {}),
            /*#__PURE__*/ (0, $df8fE.jsxs)((0, $3Hzl1.CenterContentWrapper), {
                children: [
                    /*#__PURE__*/ (0, $df8fE.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4CRs5))),
                        alt: "Big lego brick icon",
                        css: $055edb69401c40e6$var$iconStyle
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)((0, $6aHgi.Heading), {
                        type: "h1",
                        text: svy_intro_headline
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)("p", {
                        css: $055edb69401c40e6$var$termsTextStyle,
                        children: svy_intro_details
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)((0, $7QTa8.Checkbox), {
                        label: /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: svy_intro_policies
                            }
                        }),
                        checked: termsAccepted,
                        onChange: ()=>setTermsAccepted((prevState)=>!prevState)
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                        css: $055edb69401c40e6$var$buttonWrapper,
                        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $jBMnw.Tooltip), {
                            content: svy_tooltip_accept_terms_first,
                            disabled: termsAccepted,
                            children: /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                                css: {
                                    position: 'absolute'
                                },
                                children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                                    "data-transaction-name": "Accept Terms",
                                    "aria-label": "Accept survey terms",
                                    label: svy_terms_accept_button_text,
                                    disabled: !termsAccepted,
                                    isDisabled: !termsAccepted,
                                    onClick: ()=>handleStartSurveyButtonClick()
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("iEM5H", function(module, exports) {

$parcel$export(module.exports, "Header", function () { return $d9514442ff547a4e$export$8b251419efc915eb; });

var $df8fE = parcelRequire("df8fE");

var $a5EUy = parcelRequire("a5EUy");

var $glEgb = parcelRequire("glEgb");

var $dSPjH = parcelRequire("dSPjH");

var $cRlsu = parcelRequire("cRlsu");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("hi8ts");
var $442h0 = parcelRequire("442h0");
parcelRequire("i7Pqi");
var $gdpIa = parcelRequire("gdpIa");
var $2Ei9L = parcelRequire("2Ei9L");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $jahGf = parcelRequire("jahGf");
var $4AJXw = parcelRequire("4AJXw");
var $cbxDY = parcelRequire("cbxDY");

var $jy963 = parcelRequire("jy963");

var $5wEm6 = parcelRequire("5wEm6");

var $jBMnw = parcelRequire("jBMnw");
const $d9514442ff547a4e$var$logoWrapperStyle = (0, $1lyZZ.css)({
    cursor: 'pointer'
});
const $d9514442ff547a4e$var$logoutButtonStyle = (0, $1lyZZ.css)({
    position: 'absolute',
    right: 0,
    top: (0, $cbxDY.spacing).size2,
    [(0, $4AJXw.media).medium]: {
        top: (0, $cbxDY.spacing).size4
    },
    [(0, $4AJXw.media).large]: {
        right: (0, $cbxDY.spacing).size9
    }
});
const $d9514442ff547a4e$var$devMarkStyle = (0, $1lyZZ.css)({
    position: 'absolute',
    left: '42%',
    top: (0, $cbxDY.spacing).size1,
    fontSize: (0, $jahGf.font).size.sizeM2,
    color: (0, $8JWbY.colors).boldColors.lightBlue.lightBlue90,
    fontWeight: (0, $jahGf.font).weight.medium,
    [(0, $4AJXw.media).medium]: {
        fontSize: (0, $jahGf.font).size.size2,
        top: (0, $cbxDY.spacing).size5,
        left: '48%'
    }
});
const $d9514442ff547a4e$var$customerNameStyle = (0, $1lyZZ.css)({
    display: 'none',
    [(0, $4AJXw.media).medium]: {
        position: 'absolute',
        right: 60,
        top: 28,
        textAlign: 'right',
        color: (0, $8JWbY.colors).boldColors.lightBlue.lightBlue50,
        display: 'block',
        whiteSpace: 'nowrap',
        maxWidth: 280,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontWeight: (0, $jahGf.font).weight.medium
    },
    [(0, $4AJXw.media).large]: {
        right: 120,
        maxWidth: 580
    }
});
const $d9514442ff547a4e$var$mobileCustomerNameBarStyle = (0, $1lyZZ.css)({
    backgroundColor: (0, $8JWbY.colors).boldColors.lightBlue.lightBlue30,
    color: (0, $8JWbY.colors).boldColors.lightBlue.lightBlue100,
    fontWeight: (0, $jahGf.font).weight.bold,
    fontSize: (0, $jahGf.font).size.sizeM2,
    textAlign: 'right',
    padding: `${(0, $cbxDY.spacing).size2}px ${(0, $cbxDY.spacing).size4}px ${(0, $cbxDY.spacing).size1}px`,
    display: 'block',
    [(0, $4AJXw.media).medium]: {
        display: 'none'
    }
});
const $d9514442ff547a4e$export$8b251419efc915eb = ()=>{
    const history = (0, $glEgb.useHistory)();
    const { labels: { svy_top_logo: svy_top_logo, svy_sign_out: svy_sign_out, svy_tooltip_back_to_frontpage: svy_tooltip_back_to_frontpage, svy_tooltip_customer_name: svy_tooltip_customer_name } } = (0, $cRlsu.useLabels)();
    const { isLoggedIn: isLoggedIn, signOut: signOut, selectedCustomer: selectedCustomer } = (0, $dSPjH.useUser)();
    const handleLogoClick = ()=>history.push(`/${(0, $5wEm6.routes).homepage}`);
    return /*#__PURE__*/ (0, $df8fE.jsxs)((0, $a5EUy.Fragment), {
        children: [
            /*#__PURE__*/ (0, $df8fE.jsxs)((0, $2Ei9L.Header), {
                children: [
                    /*#__PURE__*/ (0, $df8fE.jsx)((0, $2Ei9L.Header).Brand, {
                        label: svy_top_logo,
                        logo: /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                            css: $d9514442ff547a4e$var$logoWrapperStyle,
                            children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $jBMnw.Tooltip), {
                                content: svy_tooltip_back_to_frontpage,
                                children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $jy963.Logo), {})
                            })
                        }),
                        onClick: handleLogoClick
                    }),
                    false,
                    isLoggedIn && selectedCustomer.name && /*#__PURE__*/ (0, $df8fE.jsx)((0, $jBMnw.Tooltip), {
                        content: svy_tooltip_customer_name,
                        children: /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                            css: $d9514442ff547a4e$var$customerNameStyle,
                            children: selectedCustomer.name
                        })
                    }),
                    isLoggedIn && /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                        css: $d9514442ff547a4e$var$logoutButtonStyle,
                        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $jBMnw.Tooltip), {
                            content: svy_sign_out,
                            children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                                "data-transaction-name": "Sign out",
                                "aria-label": "Sign out",
                                icon: /*#__PURE__*/ (0, $df8fE.jsx)((0, $442h0.LogOutBold), {
                                    css: {
                                        color: (0, $8JWbY.colors).neutralColors.white
                                    }
                                }),
                                variant: "ghost",
                                onClick: signOut
                            })
                        })
                    })
                ]
            }),
            isLoggedIn && selectedCustomer.name && /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                css: $d9514442ff547a4e$var$mobileCustomerNameBarStyle,
                children: selectedCustomer.name
            })
        ]
    });
};

});
parcelRegister("jy963", function(module, exports) {

$parcel$export(module.exports, "Logo", function () { return $e3b83faf053907c3$export$e6ff31bff12b7ff4; });

var $df8fE = parcelRequire("df8fE");

var $a5EUy = parcelRequire("a5EUy");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("1OfTO");
var $4AJXw = parcelRequire("4AJXw");

var $4YRrJ = parcelRequire("4YRrJ");
const $e3b83faf053907c3$var$logoStyle = (0, $1lyZZ.css)({
    width: 32,
    [(0, $4AJXw.media).medium]: {
        width: 40
    },
    [(0, $4AJXw.media).large]: {
        width: 48
    }
});
const $e3b83faf053907c3$export$e6ff31bff12b7ff4 = /*#__PURE__*/ (0, $a5EUy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $df8fE.jsx)("img", {
        ref: ref,
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4YRrJ))),
        alt: "Lego logo",
        css: $e3b83faf053907c3$var$logoStyle
    }));
$e3b83faf053907c3$export$e6ff31bff12b7ff4.displayName = 'Logo';

});
parcelRegister("4YRrJ", function(module, exports) {
module.exports = $parcel$resolve("87muW");

});


parcelRegister("jBMnw", function(module, exports) {

$parcel$export(module.exports, "Tooltip", function () { return $e466fff0c0d7988d$export$28c660c63b792dea; });

var $df8fE = parcelRequire("df8fE");

var $3yJBl = parcelRequire("3yJBl");

var $fpbLZ = parcelRequire("fpbLZ");

var $30dw7 = parcelRequire("30dw7");


const $e466fff0c0d7988d$export$28c660c63b792dea = ({ children: children, ...props })=>{
    const tooltipProps = {
        ...(0, $30dw7.tooltipSettings),
        ...props
    };
    return /*#__PURE__*/ (0, $df8fE.jsx)((0, $fpbLZ.default), {
        ...tooltipProps,
        children: children
    });
};
$e466fff0c0d7988d$export$28c660c63b792dea.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).node.isRequired,
    rest: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).object
};

});
parcelRegister("fpbLZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b37252b5605ae236$export$2e2bcd8739ae039; });

var $kapiU = parcelRequire("kapiU");

var $a5EUy = parcelRequire("a5EUy");

var $jUibk = parcelRequire("jUibk");
function $b37252b5605ae236$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b37252b5605ae236$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
function $b37252b5605ae236$var$preserveRef(ref, node) {
    if (ref) {
        if (typeof ref === 'function') ref(node);
        if (({}).hasOwnProperty.call(ref, 'current')) ref.current = node;
    }
}
function $b37252b5605ae236$var$ssrSafeCreateDiv() {
    return $b37252b5605ae236$var$isBrowser && document.createElement('div');
}
function $b37252b5605ae236$var$toDataAttributes(attrs) {
    var dataAttrs = {
        'data-placement': attrs.placement
    };
    if (attrs.referenceHidden) dataAttrs['data-reference-hidden'] = '';
    if (attrs.escaped) dataAttrs['data-escaped'] = '';
    return dataAttrs;
}
function $b37252b5605ae236$var$deepEqual(x, y) {
    if (x === y) return true;
    else if (typeof x === 'object' && x != null && typeof y === 'object' && y != null) {
        if (Object.keys(x).length !== Object.keys(y).length) return false;
        for(var prop in x){
            if (y.hasOwnProperty(prop)) {
                if (!$b37252b5605ae236$var$deepEqual(x[prop], y[prop])) return false;
            } else return false;
        }
        return true;
    } else return false;
}
function $b37252b5605ae236$var$uniqueByShape(arr) {
    var output = [];
    arr.forEach(function(item) {
        if (!output.find(function(outputItem) {
            return $b37252b5605ae236$var$deepEqual(item, outputItem);
        })) output.push(item);
    });
    return output;
}
function $b37252b5605ae236$var$deepPreserveProps(instanceProps, componentProps) {
    var _instanceProps$popper, _componentProps$poppe;
    return Object.assign({}, componentProps, {
        popperOptions: Object.assign({}, instanceProps.popperOptions, componentProps.popperOptions, {
            modifiers: $b37252b5605ae236$var$uniqueByShape([].concat(((_instanceProps$popper = instanceProps.popperOptions) == null ? void 0 : _instanceProps$popper.modifiers) || [], ((_componentProps$poppe = componentProps.popperOptions) == null ? void 0 : _componentProps$poppe.modifiers) || []))
        })
    });
}
var $b37252b5605ae236$var$useIsomorphicLayoutEffect = $b37252b5605ae236$var$isBrowser ? (0, $a5EUy.useLayoutEffect) : (0, $a5EUy.useEffect);
function $b37252b5605ae236$var$useMutableBox(initialValue) {
    // Using refs instead of state as it's recommended to not store imperative
    // values in state due to memory problems in React(?)
    var ref = (0, $a5EUy.useRef)();
    if (!ref.current) ref.current = typeof initialValue === 'function' ? initialValue() : initialValue;
    return ref.current;
}
function $b37252b5605ae236$var$updateClassName(box, action, classNames) {
    classNames.split(/\s+/).forEach(function(name) {
        if (name) box.classList[action](name);
    });
}
var $b37252b5605ae236$var$classNamePlugin = {
    name: 'className',
    defaultValue: '',
    fn: function fn(instance) {
        var box = instance.popper.firstElementChild;
        var isDefaultRenderFn = function isDefaultRenderFn() {
            var _instance$props$rende;
            return !!((_instance$props$rende = instance.props.render) == null ? void 0 : _instance$props$rende.$$tippy);
        };
        function add() {
            if (instance.props.className && !isDefaultRenderFn()) return;
            $b37252b5605ae236$var$updateClassName(box, 'add', instance.props.className);
        }
        function remove() {
            if (isDefaultRenderFn()) $b37252b5605ae236$var$updateClassName(box, 'remove', instance.props.className);
        }
        return {
            onCreate: add,
            onBeforeUpdate: remove,
            onAfterUpdate: add
        };
    }
};
function $b37252b5605ae236$var$TippyGenerator(tippy) {
    function Tippy(_ref) {
        var children = _ref.children, content = _ref.content, visible = _ref.visible, singleton = _ref.singleton, render = _ref.render, reference = _ref.reference, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$ignoreAttributes = _ref.ignoreAttributes, ignoreAttributes = _ref$ignoreAttributes === void 0 ? true : _ref$ignoreAttributes, __source = _ref.__source, __self = _ref.__self, restOfNativeProps = $b37252b5605ae236$var$_objectWithoutPropertiesLoose(_ref, [
            "children",
            "content",
            "visible",
            "singleton",
            "render",
            "reference",
            "disabled",
            "ignoreAttributes",
            "__source",
            "__self"
        ]);
        var isControlledMode = visible !== undefined;
        var isSingletonMode = singleton !== undefined;
        var _useState = (0, $a5EUy.useState)(false), mounted = _useState[0], setMounted = _useState[1];
        var _useState2 = (0, $a5EUy.useState)({}), attrs = _useState2[0], setAttrs = _useState2[1];
        var _useState3 = (0, $a5EUy.useState)(), singletonContent = _useState3[0], setSingletonContent = _useState3[1];
        var mutableBox = $b37252b5605ae236$var$useMutableBox(function() {
            return {
                container: $b37252b5605ae236$var$ssrSafeCreateDiv(),
                renders: 1
            };
        });
        var props = Object.assign({
            ignoreAttributes: ignoreAttributes
        }, restOfNativeProps, {
            content: mutableBox.container
        });
        if (isControlledMode) {
            props.trigger = 'manual';
            props.hideOnClick = false;
        }
        if (isSingletonMode) disabled = true;
        var computedProps = props;
        var plugins = props.plugins || [];
        if (render) computedProps = Object.assign({}, props, {
            plugins: isSingletonMode ? [].concat(plugins, [
                {
                    fn: function fn() {
                        return {
                            onTrigger: function onTrigger(_, event) {
                                var _singleton$data$child = singleton.data.children.find(function(_ref2) {
                                    var instance = _ref2.instance;
                                    return instance.reference === event.currentTarget;
                                }), content = _singleton$data$child.content;
                                setSingletonContent(content);
                            }
                        };
                    }
                }
            ]) : plugins,
            render: function render() {
                return {
                    popper: mutableBox.container
                };
            }
        });
        var deps = [
            reference
        ].concat(children ? [
            children.type
        ] : []); // CREATE
        $b37252b5605ae236$var$useIsomorphicLayoutEffect(function() {
            var element = reference;
            if (reference && reference.hasOwnProperty('current')) element = reference.current;
            var instance = tippy(element || mutableBox.ref || $b37252b5605ae236$var$ssrSafeCreateDiv(), Object.assign({}, computedProps, {
                plugins: [
                    $b37252b5605ae236$var$classNamePlugin
                ].concat(props.plugins || [])
            }));
            mutableBox.instance = instance;
            if (disabled) instance.disable();
            if (visible) instance.show();
            if (isSingletonMode) singleton.hook({
                instance: instance,
                content: content,
                props: computedProps
            });
            setMounted(true);
            return function() {
                instance.destroy();
                singleton == null || singleton.cleanup(instance);
            };
        }, deps); // UPDATE
        $b37252b5605ae236$var$useIsomorphicLayoutEffect(function() {
            var _instance$popperInsta;
            // Prevent this effect from running on 1st render
            if (mutableBox.renders === 1) {
                mutableBox.renders++;
                return;
            }
            var instance = mutableBox.instance;
            instance.setProps($b37252b5605ae236$var$deepPreserveProps(instance.props, computedProps)); // Fixes #264
            (_instance$popperInsta = instance.popperInstance) == null || _instance$popperInsta.forceUpdate();
            if (disabled) instance.disable();
            else instance.enable();
            if (isControlledMode) {
                if (visible) instance.show();
                else instance.hide();
            }
            if (isSingletonMode) singleton.hook({
                instance: instance,
                content: content,
                props: computedProps
            });
        });
        $b37252b5605ae236$var$useIsomorphicLayoutEffect(function() {
            var _instance$props$poppe;
            if (!render) return;
            var instance = mutableBox.instance;
            instance.setProps({
                popperOptions: Object.assign({}, instance.props.popperOptions, {
                    modifiers: [].concat((((_instance$props$poppe = instance.props.popperOptions) == null ? void 0 : _instance$props$poppe.modifiers) || []).filter(function(_ref3) {
                        var name = _ref3.name;
                        return name !== '$$tippyReact';
                    }), [
                        {
                            name: '$$tippyReact',
                            enabled: true,
                            phase: 'beforeWrite',
                            requires: [
                                'computeStyles'
                            ],
                            fn: function fn(_ref4) {
                                var _state$modifiersData;
                                var state = _ref4.state;
                                var hideData = (_state$modifiersData = state.modifiersData) == null ? void 0 : _state$modifiersData.hide; // WARNING: this is a high-risk path that can cause an infinite
                                // loop. This expression _must_ evaluate to false when required
                                if (attrs.placement !== state.placement || attrs.referenceHidden !== (hideData == null ? void 0 : hideData.isReferenceHidden) || attrs.escaped !== (hideData == null ? void 0 : hideData.hasPopperEscaped)) setAttrs({
                                    placement: state.placement,
                                    referenceHidden: hideData == null ? void 0 : hideData.isReferenceHidden,
                                    escaped: hideData == null ? void 0 : hideData.hasPopperEscaped
                                });
                                state.attributes.popper = {};
                            }
                        }
                    ])
                })
            });
        }, [
            attrs.placement,
            attrs.referenceHidden,
            attrs.escaped
        ].concat(deps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).Fragment, null, children ? /*#__PURE__*/ (0, $a5EUy.cloneElement)(children, {
            ref: function ref(node) {
                mutableBox.ref = node;
                $b37252b5605ae236$var$preserveRef(children.ref, node);
            }
        }) : null, mounted && /*#__PURE__*/ (0, $jUibk.createPortal)(render ? render($b37252b5605ae236$var$toDataAttributes(attrs), singletonContent, mutableBox.instance) : content, mutableBox.container));
    }
    return Tippy;
}
function $b37252b5605ae236$var$useSingletonGenerator(createSingleton) {
    return function useSingleton(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$overrides = _ref.overrides, overrides = _ref$overrides === void 0 ? [] : _ref$overrides;
        var _useState = (0, $a5EUy.useState)(false), mounted = _useState[0], setMounted = _useState[1];
        var mutableBox = $b37252b5605ae236$var$useMutableBox({
            children: [],
            renders: 1
        });
        $b37252b5605ae236$var$useIsomorphicLayoutEffect(function() {
            if (!mounted) {
                setMounted(true);
                return;
            }
            var children = mutableBox.children, sourceData = mutableBox.sourceData;
            if (!sourceData) return;
            var instance = createSingleton(children.map(function(child) {
                return child.instance;
            }), Object.assign({}, sourceData.props, {
                popperOptions: sourceData.instance.props.popperOptions,
                overrides: overrides,
                plugins: [
                    $b37252b5605ae236$var$classNamePlugin
                ].concat(sourceData.props.plugins || [])
            }));
            mutableBox.instance = instance;
            if (disabled) instance.disable();
            return function() {
                instance.destroy();
                mutableBox.children = children.filter(function(_ref2) {
                    var instance = _ref2.instance;
                    return !instance.state.isDestroyed;
                });
            };
        }, [
            mounted
        ]);
        $b37252b5605ae236$var$useIsomorphicLayoutEffect(function() {
            if (!mounted) return;
            if (mutableBox.renders === 1) {
                mutableBox.renders++;
                return;
            }
            var children = mutableBox.children, instance = mutableBox.instance, sourceData = mutableBox.sourceData;
            if (!(instance && sourceData)) return;
            var _sourceData$props = sourceData.props, content = _sourceData$props.content, props = $b37252b5605ae236$var$_objectWithoutPropertiesLoose(_sourceData$props, [
                "content"
            ]);
            instance.setProps($b37252b5605ae236$var$deepPreserveProps(instance.props, Object.assign({}, props, {
                overrides: overrides
            })));
            instance.setInstances(children.map(function(child) {
                return child.instance;
            }));
            if (disabled) instance.disable();
            else instance.enable();
        });
        return (0, $a5EUy.useMemo)(function() {
            var source = {
                data: mutableBox,
                hook: function hook(data) {
                    mutableBox.sourceData = data;
                },
                cleanup: function cleanup() {
                    mutableBox.sourceData = null;
                }
            };
            var target = {
                hook: function hook(data) {
                    if (!mutableBox.children.find(function(_ref3) {
                        var instance = _ref3.instance;
                        return data.instance === instance;
                    })) {
                        mutableBox.children.push(data);
                        if (mutableBox.instance && !mutableBox.instance.state.isDestroyed) mutableBox.instance.setInstances(mutableBox.children.map(function(child) {
                            return child.instance;
                        }));
                    }
                },
                cleanup: function cleanup(instance) {
                    mutableBox.children = mutableBox.children.filter(function(data) {
                        return data.instance !== instance;
                    });
                    if (mutableBox.instance && !mutableBox.instance.state.isDestroyed) mutableBox.instance.setInstances(mutableBox.children.map(function(child) {
                        return child.instance;
                    }));
                }
            };
            return [
                source,
                target
            ];
        }, []);
    };
}
var $b37252b5605ae236$var$forwardRef = function(Tippy, defaultProps) {
    return /*#__PURE__*/ (0, $a5EUy.forwardRef)(function TippyWrapper(_ref, _ref2) {
        var children = _ref.children, props = $b37252b5605ae236$var$_objectWithoutPropertiesLoose(_ref, [
            "children"
        ]);
        return(/*#__PURE__*/ // If I spread them separately here, Babel adds the _extends ponyfill for
        // some reason
        (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement(Tippy, Object.assign({}, defaultProps, props), children ? /*#__PURE__*/ (0, $a5EUy.cloneElement)(children, {
            ref: function ref(node) {
                $b37252b5605ae236$var$preserveRef(_ref2, node);
                $b37252b5605ae236$var$preserveRef(children.ref, node);
            }
        }) : null));
    });
};
var $b37252b5605ae236$export$abf4268d2dd55708 = /*#__PURE__*/ $b37252b5605ae236$var$useSingletonGenerator((0, $kapiU.createSingleton));
var $b37252b5605ae236$var$index = /*#__PURE__*/ $b37252b5605ae236$var$forwardRef(/*#__PURE__*/ $b37252b5605ae236$var$TippyGenerator((0, $kapiU.default)));
var $b37252b5605ae236$export$2e2bcd8739ae039 = $b37252b5605ae236$var$index;

});
parcelRegister("kapiU", function(module, exports) {

$parcel$export(module.exports, "createSingleton", function () { return $eae85eadba2ac4a9$export$374c483667c1ea9b; });
$parcel$export(module.exports, "default", function () { return $eae85eadba2ac4a9$export$2e2bcd8739ae039; });
/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ 
var $9iZAO = parcelRequire("9iZAO");
var $c35dn = parcelRequire("c35dn");
var $eae85eadba2ac4a9$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $eae85eadba2ac4a9$var$BOX_CLASS = "tippy-box";
var $eae85eadba2ac4a9$var$CONTENT_CLASS = "tippy-content";
var $eae85eadba2ac4a9$var$BACKDROP_CLASS = "tippy-backdrop";
var $eae85eadba2ac4a9$var$ARROW_CLASS = "tippy-arrow";
var $eae85eadba2ac4a9$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $eae85eadba2ac4a9$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $eae85eadba2ac4a9$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $eae85eadba2ac4a9$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $eae85eadba2ac4a9$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $eae85eadba2ac4a9$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function $eae85eadba2ac4a9$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function $eae85eadba2ac4a9$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $eae85eadba2ac4a9$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $eae85eadba2ac4a9$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $eae85eadba2ac4a9$var$normalizeToArray(value) {
    return [].concat(value);
}
function $eae85eadba2ac4a9$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $eae85eadba2ac4a9$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $eae85eadba2ac4a9$var$getBasePlacement(placement) {
    return placement.split('-')[0];
}
function $eae85eadba2ac4a9$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $eae85eadba2ac4a9$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $eae85eadba2ac4a9$var$div() {
    return document.createElement('div');
}
function $eae85eadba2ac4a9$var$isElement(value) {
    return [
        'Element',
        'Fragment'
    ].some(function(type) {
        return $eae85eadba2ac4a9$var$isType(value, type);
    });
}
function $eae85eadba2ac4a9$var$isNodeList(value) {
    return $eae85eadba2ac4a9$var$isType(value, 'NodeList');
}
function $eae85eadba2ac4a9$var$isMouseEvent(value) {
    return $eae85eadba2ac4a9$var$isType(value, 'MouseEvent');
}
function $eae85eadba2ac4a9$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $eae85eadba2ac4a9$var$getArrayOfElements(value) {
    if ($eae85eadba2ac4a9$var$isElement(value)) return [
        value
    ];
    if ($eae85eadba2ac4a9$var$isNodeList(value)) return $eae85eadba2ac4a9$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $eae85eadba2ac4a9$var$arrayFrom(document.querySelectorAll(value));
}
function $eae85eadba2ac4a9$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $eae85eadba2ac4a9$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute('data-state', state);
    });
}
function $eae85eadba2ac4a9$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $eae85eadba2ac4a9$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $eae85eadba2ac4a9$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $eae85eadba2ac4a9$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
        var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $eae85eadba2ac4a9$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        'transitionend',
        'webkitTransitionEnd'
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $eae85eadba2ac4a9$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $eae85eadba2ac4a9$var$currentInput = {
    isTouch: false
};
var $eae85eadba2ac4a9$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $eae85eadba2ac4a9$var$onDocumentTouchStart() {
    if ($eae85eadba2ac4a9$var$currentInput.isTouch) return;
    $eae85eadba2ac4a9$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener('mousemove', $eae85eadba2ac4a9$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $eae85eadba2ac4a9$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $eae85eadba2ac4a9$var$lastMouseMoveTime < 20) {
        $eae85eadba2ac4a9$var$currentInput.isTouch = false;
        document.removeEventListener('mousemove', $eae85eadba2ac4a9$var$onDocumentMouseMove);
    }
    $eae85eadba2ac4a9$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $eae85eadba2ac4a9$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($eae85eadba2ac4a9$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $eae85eadba2ac4a9$var$bindGlobalEventListeners() {
    document.addEventListener('touchstart', $eae85eadba2ac4a9$var$onDocumentTouchStart, $eae85eadba2ac4a9$var$TOUCH_OPTIONS);
    window.addEventListener('blur', $eae85eadba2ac4a9$var$onWindowBlur);
}
var $eae85eadba2ac4a9$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var $eae85eadba2ac4a9$var$isIE11 = $eae85eadba2ac4a9$var$isBrowser ? !!window.msCrypto : false;
function $eae85eadba2ac4a9$var$createMemoryLeakWarning(method) {
    var txt = method === 'destroy' ? 'n already-' : ' ';
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        'indicates a potential memory leak.'
    ].join(' ');
}
function $eae85eadba2ac4a9$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}
function $eae85eadba2ac4a9$var$getDevMessage(message) {
    return $eae85eadba2ac4a9$var$clean("\n  %ctippy.js\n\n  %c" + $eae85eadba2ac4a9$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $eae85eadba2ac4a9$var$getFormattedMessage(message) {
    return [
        $eae85eadba2ac4a9$var$getDevMessage(message),
        'color: #00C584; font-size: 1.3em; font-weight: bold;',
        'line-height: 1.5',
        'color: #a6a095;'
    ];
} // Assume warnings and errors never have the same message
var $eae85eadba2ac4a9$var$visitedMessages;
function $eae85eadba2ac4a9$var$resetVisitedMessages() {
    $eae85eadba2ac4a9$var$visitedMessages = new Set();
}
function $eae85eadba2ac4a9$var$warnWhen(condition, message) {
    if (condition && !$eae85eadba2ac4a9$var$visitedMessages.has(message)) {
        var _console;
        $eae85eadba2ac4a9$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $eae85eadba2ac4a9$var$getFormattedMessage(message));
    }
}
function $eae85eadba2ac4a9$var$errorWhen(condition, message) {
    if (condition && !$eae85eadba2ac4a9$var$visitedMessages.has(message)) {
        var _console2;
        $eae85eadba2ac4a9$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $eae85eadba2ac4a9$var$getFormattedMessage(message));
    }
}
function $eae85eadba2ac4a9$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
    $eae85eadba2ac4a9$var$errorWhen(didPassFalsyValue, [
        'tippy() was passed',
        '`' + String(targets) + '`',
        'as its targets (first) argument. Valid types are: String, Element,',
        'Element[], or NodeList.'
    ].join(' '));
    $eae85eadba2ac4a9$var$errorWhen(didPassPlainObject, [
        'tippy() was passed a plain object which is not supported as an argument',
        'for virtual positioning. Use props.getReferenceClientRect instead.'
    ].join(' '));
}
var $eae85eadba2ac4a9$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $eae85eadba2ac4a9$var$renderProps = {
    allowHTML: false,
    animation: 'fade',
    arrow: true,
    content: '',
    inertia: false,
    maxWidth: 350,
    role: 'tooltip',
    theme: '',
    zIndex: 9999
};
var $eae85eadba2ac4a9$var$defaultProps = Object.assign({
    appendTo: $eae85eadba2ac4a9$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: 'auto',
        expanded: 'auto'
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: '',
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: 'top',
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: 'mouseenter focus',
    triggerTarget: null
}, $eae85eadba2ac4a9$var$pluginProps, $eae85eadba2ac4a9$var$renderProps);
var $eae85eadba2ac4a9$var$defaultKeys = Object.keys($eae85eadba2ac4a9$var$defaultProps);
var $eae85eadba2ac4a9$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $eae85eadba2ac4a9$var$defaultProps[key] = partialProps[key];
    });
};
function $eae85eadba2ac4a9$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $eae85eadba2ac4a9$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $eae85eadba2ac4a9$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($eae85eadba2ac4a9$var$getExtendedPassedProps(Object.assign({}, $eae85eadba2ac4a9$var$defaultProps, {
        plugins: plugins
    }))) : $eae85eadba2ac4a9$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();
        if (!valueAsString) return acc;
        if (key === 'content') acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $eae85eadba2ac4a9$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $eae85eadba2ac4a9$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $eae85eadba2ac4a9$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $eae85eadba2ac4a9$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
        content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
    };
    return out;
}
function $eae85eadba2ac4a9$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $eae85eadba2ac4a9$var$removeProperties($eae85eadba2ac4a9$var$defaultProps, Object.keys($eae85eadba2ac4a9$var$pluginProps));
        var didPassUnknownProp = !$eae85eadba2ac4a9$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $eae85eadba2ac4a9$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            'a plugin, forgot to pass it in an array as props.plugins.',
            '\n\n',
            'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n',
            'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'
        ].join(' '));
    });
}
var $eae85eadba2ac4a9$var$innerHTML = function innerHTML() {
    return 'innerHTML';
};
function $eae85eadba2ac4a9$var$dangerouslySetInnerHTML(element, html) {
    element[$eae85eadba2ac4a9$var$innerHTML()] = html;
}
function $eae85eadba2ac4a9$var$createArrowElement(value) {
    var arrow = $eae85eadba2ac4a9$var$div();
    if (value === true) arrow.className = $eae85eadba2ac4a9$var$ARROW_CLASS;
    else {
        arrow.className = $eae85eadba2ac4a9$var$SVG_ARROW_CLASS;
        if ($eae85eadba2ac4a9$var$isElement(value)) arrow.appendChild(value);
        else $eae85eadba2ac4a9$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $eae85eadba2ac4a9$var$setContent(content, props) {
    if ($eae85eadba2ac4a9$var$isElement(props.content)) {
        $eae85eadba2ac4a9$var$dangerouslySetInnerHTML(content, '');
        content.appendChild(props.content);
    } else if (typeof props.content !== 'function') {
        if (props.allowHTML) $eae85eadba2ac4a9$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $eae85eadba2ac4a9$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $eae85eadba2ac4a9$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($eae85eadba2ac4a9$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($eae85eadba2ac4a9$var$ARROW_CLASS) || node.classList.contains($eae85eadba2ac4a9$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($eae85eadba2ac4a9$var$BACKDROP_CLASS);
        })
    };
}
function $eae85eadba2ac4a9$var$render(instance) {
    var popper = $eae85eadba2ac4a9$var$div();
    var box = $eae85eadba2ac4a9$var$div();
    box.className = $eae85eadba2ac4a9$var$BOX_CLASS;
    box.setAttribute('data-state', 'hidden');
    box.setAttribute('tabindex', '-1');
    var content = $eae85eadba2ac4a9$var$div();
    content.className = $eae85eadba2ac4a9$var$CONTENT_CLASS;
    content.setAttribute('data-state', 'hidden');
    $eae85eadba2ac4a9$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $eae85eadba2ac4a9$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute('data-theme', nextProps.theme);
        else box.removeAttribute('data-theme');
        if (typeof nextProps.animation === 'string') box.setAttribute('data-animation', nextProps.animation);
        else box.removeAttribute('data-animation');
        if (nextProps.inertia) box.setAttribute('data-inertia', '');
        else box.removeAttribute('data-inertia');
        box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute('role', nextProps.role);
        else box.removeAttribute('role');
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $eae85eadba2ac4a9$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($eae85eadba2ac4a9$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($eae85eadba2ac4a9$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$eae85eadba2ac4a9$var$render.$$tippy = true;
var $eae85eadba2ac4a9$var$idCounter = 1;
var $eae85eadba2ac4a9$var$mouseMoveListeners = []; // Used by `hideAll()`
var $eae85eadba2ac4a9$var$mountedInstances = [];
function $eae85eadba2ac4a9$var$createTippy(reference, passedProps) {
    var props = $eae85eadba2ac4a9$var$evaluateProps(reference, Object.assign({}, $eae85eadba2ac4a9$var$defaultProps, $eae85eadba2ac4a9$var$getExtendedPassedProps($eae85eadba2ac4a9$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $eae85eadba2ac4a9$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $eae85eadba2ac4a9$var$idCounter++;
    var popperInstance = null;
    var plugins = $eae85eadba2ac4a9$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $eae85eadba2ac4a9$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute('data-tippy-root', '');
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute('aria-expanded');
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook('onCreate', [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener('mouseenter', function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener('mouseleave', function() {
        if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === 'hold';
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $eae85eadba2ac4a9$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $eae85eadba2ac4a9$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $eae85eadba2ac4a9$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') return 0;
        return $eae85eadba2ac4a9$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $eae85eadba2ac4a9$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $eae85eadba2ac4a9$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, '').trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $eae85eadba2ac4a9$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
            else node.removeAttribute('aria-expanded');
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
        $eae85eadba2ac4a9$var$mouseMoveListeners = $eae85eadba2ac4a9$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($eae85eadba2ac4a9$var$currentInput.isTouch) {
            if (didTouchMove || event.type === 'mousedown') return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $eae85eadba2ac4a9$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($eae85eadba2ac4a9$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $eae85eadba2ac4a9$var$actualContains(el, actualTarget);
        })) {
            if ($eae85eadba2ac4a9$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) return;
        } else invokeHook('onClickOutside', [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener('mousedown', onDocumentPress, true);
        doc.addEventListener('touchend', onDocumentPress, $eae85eadba2ac4a9$var$TOUCH_OPTIONS);
        doc.addEventListener('touchstart', onTouchStart, $eae85eadba2ac4a9$var$TOUCH_OPTIONS);
        doc.addEventListener('touchmove', onTouchMove, $eae85eadba2ac4a9$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener('mousedown', onDocumentPress, true);
        doc.removeEventListener('touchend', onDocumentPress, $eae85eadba2ac4a9$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchstart', onTouchStart, $eae85eadba2ac4a9$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchmove', onTouchMove, $eae85eadba2ac4a9$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $eae85eadba2ac4a9$var$updateTransitionEndListener(box, 'remove', listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $eae85eadba2ac4a9$var$updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
        $eae85eadba2ac4a9$var$updateTransitionEndListener(box, 'add', listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $eae85eadba2ac4a9$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on('touchstart', onTrigger, {
                passive: true
            });
            on('touchend', onMouseLeave, {
                passive: true
            });
        }
        $eae85eadba2ac4a9$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === 'manual') return;
            on(eventType, onTrigger);
            switch(eventType){
                case 'mouseenter':
                    on('mouseleave', onMouseLeave);
                    break;
                case 'focus':
                    on($eae85eadba2ac4a9$var$isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
                    break;
                case 'focusin':
                    on('focusout', onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $eae85eadba2ac4a9$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $eae85eadba2ac4a9$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === 'click') isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($eae85eadba2ac4a9$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $eae85eadba2ac4a9$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $eae85eadba2ac4a9$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: '$$tippy',
            enabled: true,
            phase: 'beforeWrite',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        'placement',
                        'reference-hidden',
                        'escaped'
                    ].forEach(function(attr) {
                        if (attr === 'placement') box.setAttribute('data-placement', state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, '');
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: 'offset',
                options: {
                    offset: offset
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: 'flip',
                options: {
                    padding: 5
                }
            },
            {
                name: 'computeStyles',
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: 'arrow',
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $c35dn.createPopper)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $eae85eadba2ac4a9$var$TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') parentNode = node.parentNode;
        else parentNode = $eae85eadba2ac4a9$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $eae85eadba2ac4a9$var$arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook('onTrigger', [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($eae85eadba2ac4a9$var$currentInput.isTouch && touchValue === 'hold' && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook('onUntrigger', [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && [
            'mouseleave',
            'mousemove'
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook('onBeforeUpdate', [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $eae85eadba2ac4a9$var$evaluateProps(reference, Object.assign({}, prevProps, $eae85eadba2ac4a9$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $eae85eadba2ac4a9$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $eae85eadba2ac4a9$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute('aria-expanded');
        });
        else if (nextProps.triggerTarget) reference.removeAttribute('aria-expanded');
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook('onAfterUpdate', [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $eae85eadba2ac4a9$var$currentInput.isTouch && !instance.props.touch;
        var duration = $eae85eadba2ac4a9$var$getValueAtIndexOrReturn(instance.props.duration, 0, $eae85eadba2ac4a9$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute('disabled')) return;
        invokeHook('onShow', [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'visible';
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = 'none';
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $eae85eadba2ac4a9$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $eae85eadba2ac4a9$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $eae85eadba2ac4a9$var$setVisibilityState([
                    _box,
                    _content
                ], 'visible');
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $eae85eadba2ac4a9$var$pushIfUnique($eae85eadba2ac4a9$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook('onMount', [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook('onShown', [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $eae85eadba2ac4a9$var$getValueAtIndexOrReturn(instance.props.duration, 1, $eae85eadba2ac4a9$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook('onHide', [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'hidden';
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $eae85eadba2ac4a9$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $eae85eadba2ac4a9$var$setVisibilityState([
                    box,
                    content
                ], 'hidden');
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
        $eae85eadba2ac4a9$var$pushIfUnique($eae85eadba2ac4a9$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $eae85eadba2ac4a9$var$mountedInstances = $eae85eadba2ac4a9$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook('onHidden', [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook('onDestroy', [
            instance
        ]);
    }
}
function $eae85eadba2ac4a9$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $eae85eadba2ac4a9$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $eae85eadba2ac4a9$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $eae85eadba2ac4a9$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $eae85eadba2ac4a9$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $eae85eadba2ac4a9$var$isElement(targets) ? instances[0] : instances;
}
$eae85eadba2ac4a9$var$tippy.defaultProps = $eae85eadba2ac4a9$var$defaultProps;
$eae85eadba2ac4a9$var$tippy.setDefaultProps = $eae85eadba2ac4a9$var$setDefaultProps;
$eae85eadba2ac4a9$var$tippy.currentInput = $eae85eadba2ac4a9$var$currentInput;
var $eae85eadba2ac4a9$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $eae85eadba2ac4a9$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $eae85eadba2ac4a9$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $eae85eadba2ac4a9$var$applyStylesModifier = Object.assign({}, (0, $9iZAO.default), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $eae85eadba2ac4a9$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $eae85eadba2ac4a9$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat('content').reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $eae85eadba2ac4a9$var$tippy($eae85eadba2ac4a9$var$div(), Object.assign({}, $eae85eadba2ac4a9$var$removeProperties(optionalProps, [
        'overrides'
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $eae85eadba2ac4a9$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === 'number') return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $eae85eadba2ac4a9$var$BUBBLING_EVENTS_MAP = {
    mouseover: 'mouseenter',
    focusin: 'focus',
    click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $eae85eadba2ac4a9$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $eae85eadba2ac4a9$var$removeProperties(props, [
        'target'
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: 'manual',
        touch: false
    });
    var childProps = Object.assign({
        touch: $eae85eadba2ac4a9$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $eae85eadba2ac4a9$var$tippy(targets, parentProps);
    var normalizedReturnValue = $eae85eadba2ac4a9$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || $eae85eadba2ac4a9$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') return;
        if (event.type !== 'touchstart' && trigger.indexOf($eae85eadba2ac4a9$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $eae85eadba2ac4a9$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, 'touchstart', onTrigger, $eae85eadba2ac4a9$var$TOUCH_OPTIONS);
        on(reference, 'mouseover', onTrigger);
        on(reference, 'focusin', onTrigger);
        on(reference, 'click', onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $eae85eadba2ac4a9$export$dd8ded329c01db79 = {
    name: 'animateFill',
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $eae85eadba2ac4a9$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $eae85eadba2ac4a9$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute('data-animatefill', '');
                    box.style.overflow = 'hidden';
                    instance.setProps({
                        arrow: false,
                        animation: 'shift-away'
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $eae85eadba2ac4a9$var$setVisibilityState([
                        backdrop
                    ], 'visible');
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = '0ms';
            },
            onHide: function onHide() {
                if (backdrop) $eae85eadba2ac4a9$var$setVisibilityState([
                    backdrop
                ], 'hidden');
            }
        };
    }
};
function $eae85eadba2ac4a9$var$createBackdropElement() {
    var backdrop = $eae85eadba2ac4a9$var$div();
    backdrop.className = $eae85eadba2ac4a9$var$BACKDROP_CLASS;
    $eae85eadba2ac4a9$var$setVisibilityState([
        backdrop
    ], 'hidden');
    return backdrop;
}
var $eae85eadba2ac4a9$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $eae85eadba2ac4a9$var$activeInstances = [];
function $eae85eadba2ac4a9$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $eae85eadba2ac4a9$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $eae85eadba2ac4a9$var$addMouseCoordsListener(doc) {
    doc.addEventListener('mousemove', $eae85eadba2ac4a9$var$storeMouseCoords);
}
function $eae85eadba2ac4a9$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener('mousemove', $eae85eadba2ac4a9$var$storeMouseCoords);
}
var $eae85eadba2ac4a9$export$ac81526b64504ab6 = {
    name: 'followCursor',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $eae85eadba2ac4a9$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === 'initial' && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener('mousemove', onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener('mousemove', onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === 'initial') {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === 'horizontal' ? rect.top : y;
                    var right = followCursor === 'vertical' ? rect.right : x;
                    var bottom = followCursor === 'horizontal' ? rect.bottom : y;
                    var left = followCursor === 'vertical' ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $eae85eadba2ac4a9$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $eae85eadba2ac4a9$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $eae85eadba2ac4a9$var$activeInstances = $eae85eadba2ac4a9$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($eae85eadba2ac4a9$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $eae85eadba2ac4a9$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($eae85eadba2ac4a9$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($eae85eadba2ac4a9$var$isMouseEvent(event)) $eae85eadba2ac4a9$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === 'focus';
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $eae85eadba2ac4a9$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $eae85eadba2ac4a9$export$e2b668424a9c728 = {
    name: 'inlinePositioning',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: 'tippyInlinePositioning',
            enabled: true,
            phase: 'afterWrite',
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $eae85eadba2ac4a9$var$getInlineBoundingClientRect($eae85eadba2ac4a9$var$getBasePlacement(placement), reference.getBoundingClientRect(), $eae85eadba2ac4a9$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($eae85eadba2ac4a9$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($eae85eadba2ac4a9$var$isMouseEvent(event)) {
                    var rects = $eae85eadba2ac4a9$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $eae85eadba2ac4a9$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case 'top':
        case 'bottom':
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === 'top';
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case 'left':
        case 'right':
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $eae85eadba2ac4a9$export$4bd4b47501432316 = {
    name: 'sticky',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $eae85eadba2ac4a9$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $eae85eadba2ac4a9$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $eae85eadba2ac4a9$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$eae85eadba2ac4a9$var$tippy.setDefaultProps({
    render: $eae85eadba2ac4a9$var$render
});
var $eae85eadba2ac4a9$export$2e2bcd8739ae039 = $eae85eadba2ac4a9$var$tippy;

});
parcelRegister("9iZAO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c65928a6f52e551$export$2e2bcd8739ae039; });

var $20DJX = parcelRequire("20DJX");

var $jd4p1 = parcelRequire("jd4p1");
// and applies them to the HTMLElements such as popper and arrow
function $6c65928a6f52e551$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $jd4p1.isHTMLElement)(element) || !(0, $20DJX.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $6c65928a6f52e551$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $jd4p1.isHTMLElement)(element) || !(0, $20DJX.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $6c65928a6f52e551$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $6c65928a6f52e551$var$applyStyles,
    effect: $6c65928a6f52e551$var$effect,
    requires: [
        'computeStyles'
    ]
};

});
parcelRegister("20DJX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $176a686e218aef7c$export$2e2bcd8739ae039; });
function $176a686e218aef7c$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("jd4p1", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $dfc2a57a2d03ec66$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $dfc2a57a2d03ec66$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $dfc2a57a2d03ec66$export$af51f0f06c0f328a; });

var $fqi3Y = parcelRequire("fqi3Y");
function $dfc2a57a2d03ec66$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $fqi3Y.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $dfc2a57a2d03ec66$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $fqi3Y.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $dfc2a57a2d03ec66$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $fqi3Y.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("fqi3Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3a74baa31e5d495$export$2e2bcd8739ae039; });
function $b3a74baa31e5d495$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});



parcelRegister("c35dn", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $8c59cf67678b19ae$export$8f7491d57c8f97a9; });

var $38hNt = parcelRequire("38hNt");

var $gVpFV = parcelRequire("gVpFV");

var $1Hjje = parcelRequire("1Hjje");

var $lyyDB = parcelRequire("lyyDB");

var $9iZAO = parcelRequire("9iZAO");

var $6vJJN = parcelRequire("6vJJN");

var $69pye = parcelRequire("69pye");

var $lcRQ2 = parcelRequire("lcRQ2");

var $6Z77G = parcelRequire("6Z77G");

var $gIJyd = parcelRequire("gIJyd");


var $8c59cf67678b19ae$export$d34966752335dd47 = [
    (0, $gVpFV.default),
    (0, $1Hjje.default),
    (0, $lyyDB.default),
    (0, $9iZAO.default),
    (0, $6vJJN.default),
    (0, $69pye.default),
    (0, $lcRQ2.default),
    (0, $6Z77G.default),
    (0, $gIJyd.default)
];
var $8c59cf67678b19ae$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $38hNt.popperGenerator)({
    defaultModifiers: $8c59cf67678b19ae$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("38hNt", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $247fec8f055e041a$export$ed5e13716264f202; });

var $7aRxI = parcelRequire("7aRxI");

var $5vUMk = parcelRequire("5vUMk");

var $3FvnG = parcelRequire("3FvnG");

var $8eN81 = parcelRequire("8eN81");

var $gIjZk = parcelRequire("gIjZk");

var $67Hd6 = parcelRequire("67Hd6");

var $hy5L7 = parcelRequire("hy5L7");


var $jd4p1 = parcelRequire("jd4p1");
var $247fec8f055e041a$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $247fec8f055e041a$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $247fec8f055e041a$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $247fec8f055e041a$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $247fec8f055e041a$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $jd4p1.isElement)(reference) ? (0, $3FvnG.default)(reference) : reference.contextElement ? (0, $3FvnG.default)(reference.contextElement) : [],
                    popper: (0, $3FvnG.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $gIjZk.default)((0, $hy5L7.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$247fec8f055e041a$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $7aRxI.default)(reference, (0, $8eN81.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $5vUMk.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $67Hd6.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$247fec8f055e041a$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $247fec8f055e041a$export$8f7491d57c8f97a9 = /*#__PURE__*/ $247fec8f055e041a$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("7aRxI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $539300143d000276$export$2e2bcd8739ae039; });

var $7S5uJ = parcelRequire("7S5uJ");

var $eHDT9 = parcelRequire("eHDT9");

var $20DJX = parcelRequire("20DJX");

var $jd4p1 = parcelRequire("jd4p1");

var $j05xB = parcelRequire("j05xB");

var $l1SRY = parcelRequire("l1SRY");

var $k9zJq = parcelRequire("k9zJq");

var $i03N9 = parcelRequire("i03N9");
function $539300143d000276$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $i03N9.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $i03N9.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $539300143d000276$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $jd4p1.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $jd4p1.isHTMLElement)(offsetParent) && $539300143d000276$var$isElementScaled(offsetParent);
    var documentElement = (0, $l1SRY.default)(offsetParent);
    var rect = (0, $7S5uJ.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $20DJX.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $k9zJq.default)(documentElement)) scroll = (0, $eHDT9.default)(offsetParent);
        if ((0, $jd4p1.isHTMLElement)(offsetParent)) {
            offsets = (0, $7S5uJ.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $j05xB.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("7S5uJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bb1d6b3c59aff11$export$2e2bcd8739ae039; });

var $jd4p1 = parcelRequire("jd4p1");

var $i03N9 = parcelRequire("i03N9");

var $fqi3Y = parcelRequire("fqi3Y");

var $bEF6g = parcelRequire("bEF6g");
function $5bb1d6b3c59aff11$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $jd4p1.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $i03N9.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $i03N9.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $jd4p1.isElement)(element) ? (0, $fqi3Y.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bEF6g.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("i03N9", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $d1ab2b11ca2012bc$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $d1ab2b11ca2012bc$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $d1ab2b11ca2012bc$export$2077e0241d6afd3c; });
var $d1ab2b11ca2012bc$export$8960430cfd85939f = Math.max;
var $d1ab2b11ca2012bc$export$96ec731ed4dcb222 = Math.min;
var $d1ab2b11ca2012bc$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("bEF6g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87c34fb875c8e653$export$2e2bcd8739ae039; });

var $evrLa = parcelRequire("evrLa");
function $87c34fb875c8e653$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $evrLa.default)());
}

});
parcelRegister("evrLa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8f97e78d33bf7d0$export$2e2bcd8739ae039; });
function $a8f97e78d33bf7d0$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("eHDT9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab4405e46fce8dac$export$2e2bcd8739ae039; });

var $fAw19 = parcelRequire("fAw19");

var $fqi3Y = parcelRequire("fqi3Y");

var $jd4p1 = parcelRequire("jd4p1");

var $88jbS = parcelRequire("88jbS");
function $ab4405e46fce8dac$export$2e2bcd8739ae039(node) {
    if (node === (0, $fqi3Y.default)(node) || !(0, $jd4p1.isHTMLElement)(node)) return (0, $fAw19.default)(node);
    else return (0, $88jbS.default)(node);
}

});
parcelRegister("fAw19", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5930dcf38759347$export$2e2bcd8739ae039; });

var $fqi3Y = parcelRequire("fqi3Y");
function $b5930dcf38759347$export$2e2bcd8739ae039(node) {
    var win = (0, $fqi3Y.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("88jbS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ebdf4f26693525b$export$2e2bcd8739ae039; });
function $5ebdf4f26693525b$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("j05xB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd5250b746f559a3$export$2e2bcd8739ae039; });

var $7S5uJ = parcelRequire("7S5uJ");

var $l1SRY = parcelRequire("l1SRY");

var $fAw19 = parcelRequire("fAw19");
function $dd5250b746f559a3$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $7S5uJ.default)((0, $l1SRY.default)(element)).left + (0, $fAw19.default)(element).scrollLeft;
}

});
parcelRegister("l1SRY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4f440f13b574d91$export$2e2bcd8739ae039; });

var $jd4p1 = parcelRequire("jd4p1");
function $f4f440f13b574d91$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $jd4p1.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("k9zJq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eac05d7e64b2554e$export$2e2bcd8739ae039; });

var $iWa8Y = parcelRequire("iWa8Y");
function $eac05d7e64b2554e$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $iWa8Y.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("iWa8Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc95831a485225f5$export$2e2bcd8739ae039; });

var $fqi3Y = parcelRequire("fqi3Y");
function $dc95831a485225f5$export$2e2bcd8739ae039(element) {
    return (0, $fqi3Y.default)(element).getComputedStyle(element);
}

});



parcelRegister("5vUMk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $403be40ca4fd78da$export$2e2bcd8739ae039; });

var $7S5uJ = parcelRequire("7S5uJ");
function $403be40ca4fd78da$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $7S5uJ.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("3FvnG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2abd8b04bcd7fdd6$export$2e2bcd8739ae039; });

var $dahvO = parcelRequire("dahvO");

var $4JrR4 = parcelRequire("4JrR4");

var $fqi3Y = parcelRequire("fqi3Y");

var $k9zJq = parcelRequire("k9zJq");
function $2abd8b04bcd7fdd6$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $dahvO.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $fqi3Y.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $k9zJq.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($2abd8b04bcd7fdd6$export$2e2bcd8739ae039((0, $4JrR4.default)(target)));
}

});
parcelRegister("dahvO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9959cb130fe81766$export$2e2bcd8739ae039; });

var $4JrR4 = parcelRequire("4JrR4");

var $k9zJq = parcelRequire("k9zJq");

var $20DJX = parcelRequire("20DJX");

var $jd4p1 = parcelRequire("jd4p1");
function $9959cb130fe81766$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $20DJX.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $jd4p1.isHTMLElement)(node) && (0, $k9zJq.default)(node)) return node;
    return $9959cb130fe81766$export$2e2bcd8739ae039((0, $4JrR4.default)(node));
}

});
parcelRegister("4JrR4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3720f8d1ae3c347f$export$2e2bcd8739ae039; });

var $20DJX = parcelRequire("20DJX");

var $l1SRY = parcelRequire("l1SRY");

var $jd4p1 = parcelRequire("jd4p1");
function $3720f8d1ae3c347f$export$2e2bcd8739ae039(element) {
    if ((0, $20DJX.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $jd4p1.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $l1SRY.default)(element) // fallback
    );
}

});



parcelRegister("8eN81", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ff5bd6483f85b3e$export$2e2bcd8739ae039; });

var $fqi3Y = parcelRequire("fqi3Y");

var $20DJX = parcelRequire("20DJX");

var $iWa8Y = parcelRequire("iWa8Y");

var $jd4p1 = parcelRequire("jd4p1");

var $7B1Py = parcelRequire("7B1Py");

var $4JrR4 = parcelRequire("4JrR4");

var $evrLa = parcelRequire("evrLa");
function $5ff5bd6483f85b3e$var$getTrueOffsetParent(element) {
    if (!(0, $jd4p1.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $iWa8Y.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $5ff5bd6483f85b3e$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $evrLa.default)());
    var isIE = /Trident/i.test((0, $evrLa.default)());
    if (isIE && (0, $jd4p1.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $iWa8Y.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $4JrR4.default)(element);
    if ((0, $jd4p1.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $jd4p1.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $20DJX.default)(currentNode)) < 0){
        var css = (0, $iWa8Y.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $5ff5bd6483f85b3e$export$2e2bcd8739ae039(element) {
    var window = (0, $fqi3Y.default)(element);
    var offsetParent = $5ff5bd6483f85b3e$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $7B1Py.default)(offsetParent) && (0, $iWa8Y.default)(offsetParent).position === 'static')offsetParent = $5ff5bd6483f85b3e$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $20DJX.default)(offsetParent) === 'html' || (0, $20DJX.default)(offsetParent) === 'body' && (0, $iWa8Y.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $5ff5bd6483f85b3e$var$getContainingBlock(element) || window;
}

});
parcelRegister("7B1Py", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $587d68968e91f4a3$export$2e2bcd8739ae039; });

var $20DJX = parcelRequire("20DJX");
function $587d68968e91f4a3$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $20DJX.default)(element)) >= 0;
}

});


parcelRegister("gIjZk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2b042a03422cbbf$export$2e2bcd8739ae039; });

var $jYbHa = parcelRequire("jYbHa");
function $c2b042a03422cbbf$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $c2b042a03422cbbf$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $c2b042a03422cbbf$var$order(modifiers); // order based on phase
    return (0, $jYbHa.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("jYbHa", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $e89cb1576098d3bc$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $e89cb1576098d3bc$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $e89cb1576098d3bc$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $e89cb1576098d3bc$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $e89cb1576098d3bc$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $e89cb1576098d3bc$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $e89cb1576098d3bc$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $e89cb1576098d3bc$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $e89cb1576098d3bc$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $e89cb1576098d3bc$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $e89cb1576098d3bc$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $e89cb1576098d3bc$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $e89cb1576098d3bc$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $e89cb1576098d3bc$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $e89cb1576098d3bc$export$d087d3878fdf71d5; });
var $e89cb1576098d3bc$export$1e95b668f3b82d = 'top';
var $e89cb1576098d3bc$export$40e543e69a8b3fbb = 'bottom';
var $e89cb1576098d3bc$export$79ffe56a765070d2 = 'right';
var $e89cb1576098d3bc$export$eabcd2c8791e7bf4 = 'left';
var $e89cb1576098d3bc$export$dfb5619354ba860 = 'auto';
var $e89cb1576098d3bc$export$aec2ce47c367b8c3 = [
    $e89cb1576098d3bc$export$1e95b668f3b82d,
    $e89cb1576098d3bc$export$40e543e69a8b3fbb,
    $e89cb1576098d3bc$export$79ffe56a765070d2,
    $e89cb1576098d3bc$export$eabcd2c8791e7bf4
];
var $e89cb1576098d3bc$export$b3571188c770cc5a = 'start';
var $e89cb1576098d3bc$export$bd5df0f255a350f8 = 'end';
var $e89cb1576098d3bc$export$390fd549c5303b4d = 'clippingParents';
var $e89cb1576098d3bc$export$d7b7311ec04a3e8f = 'viewport';
var $e89cb1576098d3bc$export$ae5ab1c730825774 = 'popper';
var $e89cb1576098d3bc$export$ca50aac9f3ba507f = 'reference';
var $e89cb1576098d3bc$export$368f9a87e87fa4e1 = /*#__PURE__*/ $e89cb1576098d3bc$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $e89cb1576098d3bc$export$b3571188c770cc5a,
        placement + "-" + $e89cb1576098d3bc$export$bd5df0f255a350f8
    ]);
}, []);
var $e89cb1576098d3bc$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($e89cb1576098d3bc$export$aec2ce47c367b8c3, [
    $e89cb1576098d3bc$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $e89cb1576098d3bc$export$b3571188c770cc5a,
        placement + "-" + $e89cb1576098d3bc$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $e89cb1576098d3bc$export$421679a7c3d56e = 'beforeRead';
var $e89cb1576098d3bc$export$aafa59e2e03f2942 = 'read';
var $e89cb1576098d3bc$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $e89cb1576098d3bc$export$c65e99957a05207c = 'beforeMain';
var $e89cb1576098d3bc$export$f22da7240b7add18 = 'main';
var $e89cb1576098d3bc$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $e89cb1576098d3bc$export$8d4d2d70e7d46032 = 'beforeWrite';
var $e89cb1576098d3bc$export$68d8715fc104d294 = 'write';
var $e89cb1576098d3bc$export$70a6e5159acce2e6 = 'afterWrite';
var $e89cb1576098d3bc$export$d087d3878fdf71d5 = [
    $e89cb1576098d3bc$export$421679a7c3d56e,
    $e89cb1576098d3bc$export$aafa59e2e03f2942,
    $e89cb1576098d3bc$export$6964f6c886723980,
    $e89cb1576098d3bc$export$c65e99957a05207c,
    $e89cb1576098d3bc$export$f22da7240b7add18,
    $e89cb1576098d3bc$export$bab79516f2d662fe,
    $e89cb1576098d3bc$export$8d4d2d70e7d46032,
    $e89cb1576098d3bc$export$68d8715fc104d294,
    $e89cb1576098d3bc$export$70a6e5159acce2e6
];

});


parcelRegister("67Hd6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4754ea375324fe48$export$2e2bcd8739ae039; });
function $4754ea375324fe48$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("hy5L7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc6a143c4d937f7d$export$2e2bcd8739ae039; });
function $cc6a143c4d937f7d$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("gVpFV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c525e2c56820d859$export$2e2bcd8739ae039; });

var $fqi3Y = parcelRequire("fqi3Y");
var $c525e2c56820d859$var$passive = {
    passive: true
};
function $c525e2c56820d859$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $fqi3Y.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $c525e2c56820d859$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $c525e2c56820d859$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $c525e2c56820d859$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $c525e2c56820d859$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $c525e2c56820d859$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $c525e2c56820d859$var$effect,
    data: {}
};

});

parcelRegister("1Hjje", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13c8c901f67e971d$export$2e2bcd8739ae039; });

var $b1jeo = parcelRequire("b1jeo");
function $13c8c901f67e971d$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $b1jeo.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $13c8c901f67e971d$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $13c8c901f67e971d$var$popperOffsets,
    data: {}
};

});
parcelRegister("b1jeo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $805eb49f5773b990$export$2e2bcd8739ae039; });

var $7eg42 = parcelRequire("7eg42");

var $lx54f = parcelRequire("lx54f");

var $4RVrr = parcelRequire("4RVrr");

var $jYbHa = parcelRequire("jYbHa");
function $805eb49f5773b990$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $7eg42.default)(placement) : null;
    var variation = placement ? (0, $lx54f.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $jYbHa.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $jYbHa.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $jYbHa.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $jYbHa.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $4RVrr.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $jYbHa.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $jYbHa.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("7eg42", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54364d3b5f9bd9fd$export$2e2bcd8739ae039; });

function $54364d3b5f9bd9fd$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("lx54f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fad09c5387cb62ca$export$2e2bcd8739ae039; });
function $fad09c5387cb62ca$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("4RVrr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38b8ab5e53c89720$export$2e2bcd8739ae039; });
function $38b8ab5e53c89720$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("lyyDB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb17a44668041b0e$export$2e2bcd8739ae039; });

var $jYbHa = parcelRequire("jYbHa");

var $8eN81 = parcelRequire("8eN81");

var $fqi3Y = parcelRequire("fqi3Y");

var $l1SRY = parcelRequire("l1SRY");

var $iWa8Y = parcelRequire("iWa8Y");

var $7eg42 = parcelRequire("7eg42");

var $lx54f = parcelRequire("lx54f");

var $i03N9 = parcelRequire("i03N9");
var $fb17a44668041b0e$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $fb17a44668041b0e$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $i03N9.round)(x * dpr) / dpr || 0,
        y: (0, $i03N9.round)(y * dpr) / dpr || 0
    };
}
function $fb17a44668041b0e$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $jYbHa.left);
    var sideY = (0, $jYbHa.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $8eN81.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $fqi3Y.default)(popper)) {
            offsetParent = (0, $l1SRY.default)(popper);
            if ((0, $iWa8Y.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $jYbHa.top) || (placement === (0, $jYbHa.left) || placement === (0, $jYbHa.right)) && variation === (0, $jYbHa.end)) {
            sideY = (0, $jYbHa.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $jYbHa.left) || (placement === (0, $jYbHa.top) || placement === (0, $jYbHa.bottom)) && variation === (0, $jYbHa.end)) {
            sideX = (0, $jYbHa.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $fb17a44668041b0e$var$unsetSides);
    var _ref4 = roundOffsets === true ? $fb17a44668041b0e$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $fqi3Y.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $fb17a44668041b0e$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $7eg42.default)(state.placement),
        variation: (0, $lx54f.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $fb17a44668041b0e$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $fb17a44668041b0e$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $fb17a44668041b0e$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $fb17a44668041b0e$var$computeStyles,
    data: {}
};

});

parcelRegister("6vJJN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bd91de3ece8a348$export$2e2bcd8739ae039; });

var $7eg42 = parcelRequire("7eg42");

var $jYbHa = parcelRequire("jYbHa");
function $4bd91de3ece8a348$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $7eg42.default)(placement);
    var invertDistance = [
        (0, $jYbHa.left),
        (0, $jYbHa.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $jYbHa.left),
        (0, $jYbHa.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $4bd91de3ece8a348$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $jYbHa.placements).reduce(function(acc, placement) {
        acc[placement] = $4bd91de3ece8a348$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4bd91de3ece8a348$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $4bd91de3ece8a348$var$offset
};

});

parcelRegister("69pye", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47a76746f286f72d$export$2e2bcd8739ae039; });

var $kIlbl = parcelRequire("kIlbl");

var $7eg42 = parcelRequire("7eg42");

var $4zUVi = parcelRequire("4zUVi");

var $6EJOi = parcelRequire("6EJOi");

var $ftVlm = parcelRequire("ftVlm");

var $jYbHa = parcelRequire("jYbHa");

var $lx54f = parcelRequire("lx54f");
function $47a76746f286f72d$var$getExpandedFallbackPlacements(placement) {
    if ((0, $7eg42.default)(placement) === (0, $jYbHa.auto)) return [];
    var oppositePlacement = (0, $kIlbl.default)(placement);
    return [
        (0, $4zUVi.default)(placement),
        oppositePlacement,
        (0, $4zUVi.default)(oppositePlacement)
    ];
}
function $47a76746f286f72d$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $7eg42.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $kIlbl.default)(preferredPlacement)
    ] : $47a76746f286f72d$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $7eg42.default)(placement) === (0, $jYbHa.auto) ? (0, $ftVlm.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $7eg42.default)(placement);
        var isStartVariation = (0, $lx54f.default)(placement) === (0, $jYbHa.start);
        var isVertical = [
            (0, $jYbHa.top),
            (0, $jYbHa.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $6EJOi.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $jYbHa.right) : (0, $jYbHa.left) : isStartVariation ? (0, $jYbHa.bottom) : (0, $jYbHa.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $kIlbl.default)(mainVariationSide);
        var altVariationSide = (0, $kIlbl.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $47a76746f286f72d$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $47a76746f286f72d$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("kIlbl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1485905ac4f9c4b$export$2e2bcd8739ae039; });
var $f1485905ac4f9c4b$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $f1485905ac4f9c4b$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $f1485905ac4f9c4b$var$hash[matched];
    });
}

});

parcelRegister("4zUVi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3556961162a4ccd7$export$2e2bcd8739ae039; });
var $3556961162a4ccd7$var$hash = {
    start: 'end',
    end: 'start'
};
function $3556961162a4ccd7$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $3556961162a4ccd7$var$hash[matched];
    });
}

});

parcelRegister("6EJOi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d8a03782ad88235$export$2e2bcd8739ae039; });

var $i3v8v = parcelRequire("i3v8v");

var $l1SRY = parcelRequire("l1SRY");

var $7S5uJ = parcelRequire("7S5uJ");

var $b1jeo = parcelRequire("b1jeo");

var $itGrJ = parcelRequire("itGrJ");

var $jYbHa = parcelRequire("jYbHa");

var $jd4p1 = parcelRequire("jd4p1");

var $i2ZiG = parcelRequire("i2ZiG");

var $93iKA = parcelRequire("93iKA");
function $4d8a03782ad88235$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $jYbHa.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $jYbHa.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $jYbHa.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $i2ZiG.default)(typeof padding !== 'number' ? padding : (0, $93iKA.default)(padding, (0, $jYbHa.basePlacements)));
    var altContext = elementContext === (0, $jYbHa.popper) ? (0, $jYbHa.reference) : (0, $jYbHa.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $i3v8v.default)((0, $jd4p1.isElement)(element) ? element : element.contextElement || (0, $l1SRY.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $7S5uJ.default)(state.elements.reference);
    var popperOffsets = (0, $b1jeo.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $itGrJ.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $jYbHa.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $jYbHa.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $jYbHa.right),
                (0, $jYbHa.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $jYbHa.top),
                (0, $jYbHa.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("i3v8v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d250a8ce5e5c898a$export$2e2bcd8739ae039; });

var $jYbHa = parcelRequire("jYbHa");

var $bra0I = parcelRequire("bra0I");

var $5Em8l = parcelRequire("5Em8l");

var $3FvnG = parcelRequire("3FvnG");

var $8eN81 = parcelRequire("8eN81");

var $l1SRY = parcelRequire("l1SRY");

var $iWa8Y = parcelRequire("iWa8Y");

var $jd4p1 = parcelRequire("jd4p1");

var $7S5uJ = parcelRequire("7S5uJ");

var $4JrR4 = parcelRequire("4JrR4");

var $egzAh = parcelRequire("egzAh");

var $20DJX = parcelRequire("20DJX");

var $itGrJ = parcelRequire("itGrJ");

var $i03N9 = parcelRequire("i03N9");
function $d250a8ce5e5c898a$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $7S5uJ.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $d250a8ce5e5c898a$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $jYbHa.viewport) ? (0, $itGrJ.default)((0, $bra0I.default)(element, strategy)) : (0, $jd4p1.isElement)(clippingParent) ? $d250a8ce5e5c898a$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $itGrJ.default)((0, $5Em8l.default)((0, $l1SRY.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $d250a8ce5e5c898a$var$getClippingParents(element) {
    var clippingParents = (0, $3FvnG.default)((0, $4JrR4.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $iWa8Y.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $jd4p1.isHTMLElement)(element) ? (0, $8eN81.default)(element) : element;
    if (!(0, $jd4p1.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $jd4p1.isElement)(clippingParent) && (0, $egzAh.default)(clippingParent, clipperElement) && (0, $20DJX.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $d250a8ce5e5c898a$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $d250a8ce5e5c898a$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $d250a8ce5e5c898a$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $i03N9.max)(rect.top, accRect.top);
        accRect.right = (0, $i03N9.min)(rect.right, accRect.right);
        accRect.bottom = (0, $i03N9.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $i03N9.max)(rect.left, accRect.left);
        return accRect;
    }, $d250a8ce5e5c898a$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("bra0I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8539fb3b4698a0b2$export$2e2bcd8739ae039; });

var $fqi3Y = parcelRequire("fqi3Y");

var $l1SRY = parcelRequire("l1SRY");

var $j05xB = parcelRequire("j05xB");

var $bEF6g = parcelRequire("bEF6g");
function $8539fb3b4698a0b2$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $fqi3Y.default)(element);
    var html = (0, $l1SRY.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bEF6g.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $j05xB.default)(element),
        y: y
    };
}

});

parcelRegister("5Em8l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41d1db758ae38a68$export$2e2bcd8739ae039; });

var $l1SRY = parcelRequire("l1SRY");

var $iWa8Y = parcelRequire("iWa8Y");

var $j05xB = parcelRequire("j05xB");

var $fAw19 = parcelRequire("fAw19");

var $i03N9 = parcelRequire("i03N9");
function $41d1db758ae38a68$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $l1SRY.default)(element);
    var winScroll = (0, $fAw19.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $i03N9.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $i03N9.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $j05xB.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $iWa8Y.default)(body || html).direction === 'rtl') x += (0, $i03N9.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("egzAh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a62e2999a116efd3$export$2e2bcd8739ae039; });

var $jd4p1 = parcelRequire("jd4p1");
function $a62e2999a116efd3$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $jd4p1.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("itGrJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d73bdc63216db24c$export$2e2bcd8739ae039; });
function $d73bdc63216db24c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("i2ZiG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d237f6e451252463$export$2e2bcd8739ae039; });

var $22ssL = parcelRequire("22ssL");
function $d237f6e451252463$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $22ssL.default)(), paddingObject);
}

});
parcelRegister("22ssL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17c1d8d4d5b7cf2a$export$2e2bcd8739ae039; });
function $17c1d8d4d5b7cf2a$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("93iKA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6972f05279c61657$export$2e2bcd8739ae039; });
function $6972f05279c61657$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("ftVlm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4560bb1e7804fb1$export$2e2bcd8739ae039; });

var $lx54f = parcelRequire("lx54f");

var $jYbHa = parcelRequire("jYbHa");

var $6EJOi = parcelRequire("6EJOi");

var $7eg42 = parcelRequire("7eg42");
function $b4560bb1e7804fb1$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $jYbHa.placements) : _options$allowedAutoP;
    var variation = (0, $lx54f.default)(placement);
    var placements = variation ? flipVariations ? (0, $jYbHa.variationPlacements) : (0, $jYbHa.variationPlacements).filter(function(placement) {
        return (0, $lx54f.default)(placement) === variation;
    }) : (0, $jYbHa.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $6EJOi.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $7eg42.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("lcRQ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7047b227a7281a4$export$2e2bcd8739ae039; });

var $jYbHa = parcelRequire("jYbHa");

var $7eg42 = parcelRequire("7eg42");

var $4RVrr = parcelRequire("4RVrr");

var $1oXsd = parcelRequire("1oXsd");

var $bblKO = parcelRequire("bblKO");

var $5vUMk = parcelRequire("5vUMk");

var $8eN81 = parcelRequire("8eN81");

var $6EJOi = parcelRequire("6EJOi");

var $lx54f = parcelRequire("lx54f");

var $22ssL = parcelRequire("22ssL");

var $i03N9 = parcelRequire("i03N9");
function $f7047b227a7281a4$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $6EJOi.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $7eg42.default)(state.placement);
    var variation = (0, $lx54f.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $4RVrr.default)(basePlacement);
    var altAxis = (0, $1oXsd.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $jYbHa.top) : (0, $jYbHa.left);
        var altSide = mainAxis === 'y' ? (0, $jYbHa.bottom) : (0, $jYbHa.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $jYbHa.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $jYbHa.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $5vUMk.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $22ssL.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $bblKO.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $8eN81.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $bblKO.within)(tether ? (0, $i03N9.min)(min, tetherMin) : min, offset, tether ? (0, $i03N9.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $jYbHa.top) : (0, $jYbHa.left);
        var _altSide = mainAxis === 'x' ? (0, $jYbHa.bottom) : (0, $jYbHa.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $jYbHa.top),
            (0, $jYbHa.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $bblKO.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $bblKO.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $f7047b227a7281a4$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $f7047b227a7281a4$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("1oXsd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $105626b486a78cf4$export$2e2bcd8739ae039; });
function $105626b486a78cf4$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("bblKO", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $824198b4b75aaa1d$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $824198b4b75aaa1d$export$86c8af6d3ef0b4a; });

var $i03N9 = parcelRequire("i03N9");
function $824198b4b75aaa1d$export$f28d906d67a997f3(min, value, max) {
    return (0, $i03N9.max)(min, (0, $i03N9.min)(value, max));
}
function $824198b4b75aaa1d$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $824198b4b75aaa1d$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("6Z77G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $515df71088540ce8$export$2e2bcd8739ae039; });

var $7eg42 = parcelRequire("7eg42");

var $5vUMk = parcelRequire("5vUMk");

var $egzAh = parcelRequire("egzAh");

var $8eN81 = parcelRequire("8eN81");

var $4RVrr = parcelRequire("4RVrr");

var $bblKO = parcelRequire("bblKO");

var $i2ZiG = parcelRequire("i2ZiG");

var $93iKA = parcelRequire("93iKA");

var $jYbHa = parcelRequire("jYbHa");
var $515df71088540ce8$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $i2ZiG.default)(typeof padding !== 'number' ? padding : (0, $93iKA.default)(padding, (0, $jYbHa.basePlacements)));
};
function $515df71088540ce8$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $7eg42.default)(state.placement);
    var axis = (0, $4RVrr.default)(basePlacement);
    var isVertical = [
        (0, $jYbHa.left),
        (0, $jYbHa.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $515df71088540ce8$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $5vUMk.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $jYbHa.top) : (0, $jYbHa.left);
    var maxProp = axis === 'y' ? (0, $jYbHa.bottom) : (0, $jYbHa.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $8eN81.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $bblKO.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $515df71088540ce8$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $egzAh.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $515df71088540ce8$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $515df71088540ce8$var$arrow,
    effect: $515df71088540ce8$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("gIJyd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2c416d9d70d92f5$export$2e2bcd8739ae039; });

var $jYbHa = parcelRequire("jYbHa");

var $6EJOi = parcelRequire("6EJOi");
function $c2c416d9d70d92f5$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $c2c416d9d70d92f5$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $jYbHa.top),
        (0, $jYbHa.right),
        (0, $jYbHa.bottom),
        (0, $jYbHa.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $c2c416d9d70d92f5$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $6EJOi.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $6EJOi.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $c2c416d9d70d92f5$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $c2c416d9d70d92f5$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $c2c416d9d70d92f5$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $c2c416d9d70d92f5$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $c2c416d9d70d92f5$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $c2c416d9d70d92f5$var$hide
};

});




parcelRegister("30dw7", function(module, exports) {

$parcel$export(module.exports, "tooltipSettings", function () { return $22fbdb66a5ef6bf5$export$37fbedb22300720e; });
const $22fbdb66a5ef6bf5$export$37fbedb22300720e = {
    theme: 'klik',
    delay: 2000,
    placement: 'bottom'
};

});



parcelRegister("3Hzl1", function(module, exports) {

$parcel$export(module.exports, "CenterContentWrapper", function () { return $2b20cca98fee2ef8$export$3800cd9fda86dae1; });

var $df8fE = parcelRequire("df8fE");

var $3yJBl = parcelRequire("3yJBl");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("1OfTO");
var $4AJXw = parcelRequire("4AJXw");
var $xIzHg = parcelRequire("xIzHg");
var $cbxDY = parcelRequire("cbxDY");
const $2b20cca98fee2ef8$var$containerStyle = (0, $1lyZZ.css)({
    maxWidth: '768px',
    margin: 'auto',
    padding: `${(0, $cbxDY.spacing).size4}px ${(0, $xIzHg.padding).medium}px ${(0, $cbxDY.spacing).size10 * 2}px`,
    [(0, $4AJXw.media).medium]: {
        padding: `${(0, $cbxDY.spacing).size4}px ${(0, $xIzHg.padding).medium}px ${(0, $cbxDY.spacing).size10 * 4}px`
    }
});
const $2b20cca98fee2ef8$export$3800cd9fda86dae1 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $df8fE.jsx)("div", {
        css: $2b20cca98fee2ef8$var$containerStyle,
        children: children
    });
};
$2b20cca98fee2ef8$export$3800cd9fda86dae1.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).node.isRequired
};

});

parcelRegister("4CRs5", function(module, exports) {
module.exports = $parcel$resolve("cy9m2");

});

parcelRegister("6aHgi", function(module, exports) {

$parcel$export(module.exports, "Heading", function () { return $47e53c24be3abc91$export$a8a3e93435678ff9; });

var $3yJBl = parcelRequire("3yJBl");
parcelRequire("aaf2d");
var $2WWDJ = parcelRequire("2WWDJ");
var $aaf2d = parcelRequire("aaf2d");
parcelRequire("1OfTO");
var $jahGf = parcelRequire("jahGf");
var $4AJXw = parcelRequire("4AJXw");
var $cbxDY = parcelRequire("cbxDY");
const $47e53c24be3abc91$var$headingSizes = {
    h1: {
        fontSize: (0, $jahGf.font).size.size4,
        lineHeight: (0, $jahGf.font).lineHeight.s,
        margin: `${(0, $cbxDY.spacing).size16}px 0 ${(0, $cbxDY.spacing).size8}px`,
        mobile: {
            margin: `${(0, $cbxDY.spacing).size10}px 0 ${(0, $cbxDY.spacing).size6}px`,
            fontSize: (0, $jahGf.font).size.size3,
            lineHeight: (0, $jahGf.font).lineHeight.s
        }
    },
    h2: {
        fontSize: (0, $jahGf.font).size.size3,
        lineHeight: (0, $jahGf.font).lineHeight.s,
        margin: `${(0, $cbxDY.spacing).size10}px 0 ${(0, $cbxDY.spacing).size6}px`,
        mobile: {
            margin: `${(0, $cbxDY.spacing).size8}px 0 ${(0, $cbxDY.spacing).size4}px`,
            fontSize: (0, $jahGf.font).size.size2,
            lineHeight: (0, $jahGf.font).lineHeight.s
        }
    }
};
const $47e53c24be3abc91$var$defaultHeaderMargin = `${(0, $cbxDY.spacing).size10}px 0 ${(0, $cbxDY.spacing).size8}px`;
const $47e53c24be3abc91$var$headingStyle = (type, additionalStyles)=>(0, $2WWDJ.default)({
        fontWeight: (0, $jahGf.font).weight.medium,
        fontSize: $47e53c24be3abc91$var$headingSizes[type]?.mobile.fontSize || (0, $jahGf.font).size.size3,
        lineHeight: $47e53c24be3abc91$var$headingSizes[type]?.mobile.lineHeight || (0, $jahGf.font).lineHeight.s,
        margin: $47e53c24be3abc91$var$headingSizes[type]?.mobile.margin || $47e53c24be3abc91$var$defaultHeaderMargin,
        [(0, $4AJXw.media).medium]: {
            fontSize: $47e53c24be3abc91$var$headingSizes[type]?.fontSize || (0, $jahGf.font).size.size4,
            lineHeight: $47e53c24be3abc91$var$headingSizes[type]?.lineHeight || (0, $jahGf.font).lineHeight.s,
            margin: $47e53c24be3abc91$var$headingSizes[type]?.mobile.margin || $47e53c24be3abc91$var$defaultHeaderMargin
        }
    }, additionalStyles);
const $47e53c24be3abc91$export$a8a3e93435678ff9 = ({ type: type, text: text, additionalStyles: additionalStyles, ...props })=>{
    return (0, $aaf2d.jsx)(type, {
        css: $47e53c24be3abc91$var$headingStyle(type, additionalStyles),
        ...props
    }, text);
};
$47e53c24be3abc91$export$a8a3e93435678ff9.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string.isRequired,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string.isRequired,
    additionalStyles: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).object
};

});


parcelRegister("5fqnd", function(module, exports) {

$parcel$export(module.exports, "SurveyPage", function () { return $3d22cfa8ba37f0e0$export$4d4f764bf1e4e8a3; });

var $df8fE = parcelRequire("df8fE");

var $a5EUy = parcelRequire("a5EUy");

var $glEgb = parcelRequire("glEgb");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("2UBc8");
var $byqzn = parcelRequire("byqzn");
var $eBKZl = parcelRequire("eBKZl");
parcelRequire("i7Pqi");
var $gdpIa = parcelRequire("gdpIa");

var $cRlsu = parcelRequire("cRlsu");

var $dSPjH = parcelRequire("dSPjH");
parcelRequire("jDcek");
var $d3DgW = parcelRequire("d3DgW");
var $7AuHC = parcelRequire("7AuHC");
parcelRequire("1OfTO");
var $cbxDY = parcelRequire("cbxDY");

var $cByD8 = parcelRequire("cByD8");

var $4Qzkk = parcelRequire("4Qzkk");

var $oMBXq = parcelRequire("oMBXq");

var $6aHgi = parcelRequire("6aHgi");

var $cPiPb = parcelRequire("cPiPb");

var $302dL = parcelRequire("302dL");

var $lsDX7 = parcelRequire("lsDX7");

var $5wEm6 = parcelRequire("5wEm6");

var $jFBuu = parcelRequire("jFBuu");

var $7eF6Y = parcelRequire("7eF6Y");

var $gFRU1 = parcelRequire("gFRU1");

var $51Lyw = parcelRequire("51Lyw");
const $3d22cfa8ba37f0e0$var$doneEditingButtonWrapperStyle = (0, $1lyZZ.css)({
    display: 'flex',
    justifyContent: 'center',
    marginTop: (0, $cbxDY.spacing).size8
});
const $3d22cfa8ba37f0e0$var$Survey = ()=>{
    const location = (0, $glEgb.useLocation)();
    const history = (0, $glEgb.useHistory)();
    const { year: year, version: version } = (0, $glEgb.useParams)();
    const queryParams = new URLSearchParams(location.search);
    const { staticUserVariables: staticUserVariables } = (0, $dSPjH.useUser)();
    const isSurveyInEditMode = queryParams.get('mode') === 'edit';
    const { labels: { svy_end_headline: svy_end_headline, svy_done_editing: svy_done_editing, svy_snackbar_error_header: svy_snackbar_error_header, svy_snackbar_error_default_text: svy_snackbar_error_default_text } } = (0, $cRlsu.useLabels)();
    const [surveyReducerState, dispatch] = (0, $a5EUy.useReducer)((0, $4Qzkk.surveyReducer), {});
    const { loading: isSurveyPageLoading, error: getSurveyPageDataError } = (0, $eBKZl.useQuery)((0, $oMBXq.GET_SURVEY_PAGE), {
        variables: staticUserVariables({
            year: year,
            version: version
        }),
        skip: surveyReducerState?.answers,
        onCompleted: handleSurveyData,
        fetchPolicy: 'network-only'
    });
    const [updateAnswer, { loading: updateAnswerLoading }] = (0, $byqzn.useMutation)((0, $oMBXq.UPDATE_ANSWER), {
        onCompleted: handleAnswerUpdate
    });
    const [updateAllAnswers, { loading: updateAllAnswersLoading }] = (0, $byqzn.useMutation)((0, $oMBXq.UPDATE_ALL_ANSWERS), {
        onCompleted: handleAllAnswersUpdateCompleted
    });
    const shouldFetchImagesFromS3 = surveyReducerState.isSurveyEditable && !surveyReducerState.isSurveyComplete && !!surveyReducerState.uploadId || isSurveyInEditMode && !!surveyReducerState.uploadId;
    (0, $jFBuu.useFetchImagesFromS3)({
        uploadId: surveyReducerState?.uploadId,
        skip: isSurveyPageLoading || !shouldFetchImagesFromS3,
        onCompleted: (0, $a5EUy.useCallback)((uploadedImagesKeys)=>dispatch((0, $4Qzkk.setUploadedImages)(uploadedImagesKeys)), [])
    });
    // The normalization step ensures that when we save an answer, we are sending the correct data format to the backend,
    // Primarily needed to structure subAnswer data correctly.
    const normalizeAnswerWithQuestions = (answer)=>(0, $lsDX7.normalizeAnswer)(answer, surveyReducerState.questions);
    function handleAnswerUpdate(response) {
        const { updateAnswer: { questionId: questionId } } = response;
        dispatch((0, $4Qzkk.answerSavedAction)(questionId));
    }
    function handleSurveyData(response) {
        const { getSurveyInfo: { surveyState: surveyState } } = response;
        if (!surveyState.isEditable) return history.push(`/${(0, $5wEm6.routes).review}`);
        dispatch((0, $4Qzkk.resetAction)(response));
    }
    const handleAnswerSave = async (questionId)=>{
        const answerState = surveyReducerState.answers.find((answer)=>answer.questionId === questionId);
        const normalizedAnswer = normalizeAnswerWithQuestions(answerState);
        try {
            await updateAnswer({
                variables: staticUserVariables({
                    answer: normalizedAnswer,
                    year: year,
                    version: version
                })
            });
        } catch (error) {
            (0, $7eF6Y.generalApiErrorHandler)({
                error: error,
                snackbarHeader: svy_snackbar_error_header,
                snackbarMessage: svy_snackbar_error_default_text
            });
        }
    };
    const handleAllAnswersUpdate = async (answers)=>{
        const normalizedAnswers = answers.map(normalizeAnswerWithQuestions);
        try {
            await updateAllAnswers({
                variables: staticUserVariables({
                    answers: normalizedAnswers,
                    year: year,
                    version: version
                })
            });
        } catch (error) {
            (0, $7eF6Y.generalApiErrorHandler)({
                error: error,
                snackbarHeader: svy_snackbar_error_header,
                snackbarMessage: svy_snackbar_error_default_text
            });
        }
    };
    function handleAllAnswersUpdateCompleted(response) {
        if (response.updateAllAnswers) history.push(`/${(0, $5wEm6.routes).review}/${year}/${version}`);
    }
    // Error boundary catches this error
    if (getSurveyPageDataError) (0, $gFRU1.throwErrorWithTransactionName)(getSurveyPageDataError, 'SurveyPage');
    if (isSurveyPageLoading || !surveyReducerState.answers?.length || !surveyReducerState.questions?.length || surveyReducerState.isFetchingUploadedImages || updateAllAnswersLoading) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $cPiPb.OverlayPortal), {
        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $302dL.Spinner), {})
    });
    const isSurveyComplete = (0, $lsDX7.areAllAnswersComplete)(surveyReducerState.answers);
    if (isSurveyComplete && !isSurveyInEditMode) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $glEgb.Redirect), {
        to: `/${(0, $5wEm6.routes).complete}/${year}/${version}`
    });
    const surveyDetailsForFeatureFlag = {
        year: Number(year)
    };
    let enhancedQuestions = (0, $lsDX7.enhanceQuestionsWithAnswersAndProof)(surveyReducerState.questions, surveyReducerState.answers, surveyReducerState.uploadedImageKeys);
    enhancedQuestions = (0, $lsDX7.adjustAssessmentsBasedOnFeatureFlags)(enhancedQuestions, surveyDetailsForFeatureFlag);
    return /*#__PURE__*/ (0, $df8fE.jsxs)((0, $a5EUy.Fragment), {
        children: [
            /*#__PURE__*/ (0, $df8fE.jsx)((0, $6aHgi.Heading), {
                type: "h1",
                text: svy_end_headline
            }),
            /*#__PURE__*/ (0, $df8fE.jsxs)((0, $4Qzkk.SurveyContext).Provider, {
                value: {
                    dispatch: dispatch
                },
                children: [
                    /*#__PURE__*/ (0, $df8fE.jsx)((0, $7AuHC.Stepper), {
                        activeStep: surveyReducerState.activeStep,
                        stepperState: surveyReducerState,
                        shouldHideInactiveStepsContent: !isSurveyInEditMode,
                        children: enhancedQuestions.map((question, index)=>{
                            const { questionId: questionId, headline: headline, questionImageKeys: questionImageKeys, proofRequirement: proofRequirement } = question;
                            const questionState = surveyReducerState.answers.find((answer)=>answer.questionId === questionId);
                            return /*#__PURE__*/ (0, $df8fE.jsx)((0, $d3DgW.Step), {
                                stepId: questionId,
                                header: headline,
                                isValid: questionState.isValid,
                                isWarning: proofRequirement.isProofMissing,
                                isComplete: questionState.isComplete,
                                additionalHeight: questionImageKeys.length ? 100 : 0,
                                children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $cByD8.Question), {
                                    question: question,
                                    questionState: questionState,
                                    hasBackButton: index > 0,
                                    saveAnswer: handleAnswerSave,
                                    isSaving: updateAnswerLoading,
                                    isActive: surveyReducerState.activeStep === index + 1,
                                    uploadImageKeys: questionImageKeys,
                                    highlightProofRequirement: proofRequirement,
                                    hideActionButton: isSurveyInEditMode,
                                    uploadId: surveyReducerState.uploadId
                                })
                            }, questionId);
                        })
                    }),
                    isSurveyInEditMode && /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                        css: $3d22cfa8ba37f0e0$var$doneEditingButtonWrapperStyle,
                        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                            "data-transaction-name": "Update all answers",
                            label: svy_done_editing,
                            disabled: updateAllAnswersLoading,
                            isDisabled: updateAllAnswersLoading,
                            onClick: ()=>handleAllAnswersUpdate(surveyReducerState.answers)
                        })
                    })
                ]
            })
        ]
    });
};
const $3d22cfa8ba37f0e0$export$4d4f764bf1e4e8a3 = (0, $51Lyw.withTransaction)('SurveyPage', 'component')($3d22cfa8ba37f0e0$var$Survey);

});
parcelRegister("jDcek", function(module, exports) {

$parcel$export(module.exports, "Stepper", function () { return (parcelRequire("7AuHC")).Stepper; });
$parcel$export(module.exports, "Step", function () { return (parcelRequire("d3DgW")).Step; });

var $7AuHC = parcelRequire("7AuHC");

var $d3DgW = parcelRequire("d3DgW");

});
parcelRegister("7AuHC", function(module, exports) {

$parcel$export(module.exports, "Stepper", function () { return $5863b60e5d052358$export$ed8ca599049e8881; });

var $df8fE = parcelRequire("df8fE");

var $a5EUy = parcelRequire("a5EUy");

var $3yJBl = parcelRequire("3yJBl");
const $5863b60e5d052358$export$ed8ca599049e8881 = ({ activeColor: activeColor, activeStep: activeStep, shouldHideInactiveStepsContent: shouldHideInactiveStepsContent, children: children })=>{
    const childrenWithProps = (0, $a5EUy.Children).map(children, (child, index)=>{
        const stepNumber = index + 1;
        const props = {
            number: stepNumber,
            isActive: stepNumber === activeStep,
            isLast: index + 1 === children.length,
            activeColor: activeColor,
            shouldHideInactiveStepsContent: shouldHideInactiveStepsContent
        };
        return /*#__PURE__*/ (0, $a5EUy.cloneElement)(child, props);
    });
    return /*#__PURE__*/ (0, $df8fE.jsx)("ul", {
        children: childrenWithProps
    });
};
$5863b60e5d052358$export$ed8ca599049e8881.propTypes = {
    activeColor: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string,
    stepsCompleted: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).number,
    activeStep: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).number,
    shouldHideInactiveStepsContent: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).node.isRequired
};

});

parcelRegister("d3DgW", function(module, exports) {

$parcel$export(module.exports, "Step", function () { return $981a04d811c326d5$export$fd55ce593607084a; });

var $df8fE = parcelRequire("df8fE");

var $a5EUy = parcelRequire("a5EUy");

var $3yJBl = parcelRequire("3yJBl");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");

var $lbXo0 = parcelRequire("lbXo0");

var $4NhFR = parcelRequire("4NhFR");
const $981a04d811c326d5$export$fd55ce593607084a = ({ activeColor: activeColor = (0, $8JWbY.colors).boldColors.lightBlue.base, number: number, header: header, isLast: isLast, isActive: isActive, isValid: isValid, isComplete: isComplete, isWarning: isWarning, children: children, additionalHeight: additionalHeight, shouldHideInactiveStepsContent: shouldHideInactiveStepsContent })=>{
    // Ref to question so that we can scroll it into view if necessary
    const questionRef = (0, $a5EUy.useRef)(null);
    // Ref to question content wrapper so that we can measure height of content
    const questionContentRef = (0, $a5EUy.useRef)(null);
    // We need to get the actual height of each question in order to animate properly
    // We update the questionHeight state as soon as the question has been rendered to the DOM
    // and we can measure the height
    const [questionHeight, setQuestionHeight] = (0, $a5EUy.useState)(0);
    (0, $a5EUy.useEffect)(()=>{
        const el = questionContentRef.current;
        if (!el) return;
        const measure = ()=>setQuestionHeight(el.offsetHeight);
        measure();
        if (typeof ResizeObserver === 'undefined') return;
        const observer = new ResizeObserver(measure);
        observer.observe(el);
        return ()=>observer.disconnect();
    }, []);
    (0, $a5EUy.useEffect)(()=>{
        let timer;
        if (isActive) timer = setTimeout(()=>{
            const questionElement = questionRef?.current;
            if (typeof questionElement?.scrollIntoView === 'function') {
                questionElement.scrollIntoView({
                    block: 'nearest',
                    inline: 'nearest'
                });
                return;
            }
            if (typeof questionElement?.scrollIntoViewIfNeeded === 'function') questionElement.scrollIntoViewIfNeeded();
        }, 300);
        return ()=>clearTimeout(timer);
    }, [
        isActive
    ]);
    return /*#__PURE__*/ (0, $df8fE.jsxs)("li", {
        ref: questionRef,
        css: (0, $4NhFR.wrapperStyle),
        children: [
            /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                css: (0, $4NhFR.indicatorStyle)(activeColor, isLast, isValid, isComplete),
                children: /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                    css: (0, $4NhFR.numberStyle)(activeColor, isActive, isComplete, isValid, isWarning),
                    "data-testid": "stepNumber",
                    children: isComplete && !isActive ? /*#__PURE__*/ (0, $df8fE.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($lbXo0))),
                        alt: "Checkmark icon"
                    }) : number
                })
            }),
            /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                css: (0, $4NhFR.contentWrapperStyle),
                children: [
                    /*#__PURE__*/ (0, $df8fE.jsx)("h3", {
                        css: (0, $4NhFR.headerStyle)(activeColor, isActive, isValid, isWarning),
                        children: header
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                        css: shouldHideInactiveStepsContent && (0, $4NhFR.contentStyle)(isActive, questionHeight + additionalHeight),
                        children: /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                            ref: questionContentRef,
                            children: children
                        })
                    })
                ]
            })
        ]
    });
};
$981a04d811c326d5$export$fd55ce593607084a.propTypes = {
    activeColor: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string,
    number: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).number,
    header: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string.isRequired,
    isLast: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool,
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool,
    isValid: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool,
    isComplete: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool,
    isWarning: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).node,
    stepId: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string.isRequired,
    additionalHeight: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).number,
    shouldHideInactiveStepsContent: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool
};

});
parcelRegister("lbXo0", function(module, exports) {
module.exports = $parcel$resolve("iH9dE");

});

parcelRegister("4NhFR", function(module, exports) {

$parcel$export(module.exports, "wrapperStyle", function () { return $37d972bc3e7471cb$export$c4d4f06a25de97f; });
$parcel$export(module.exports, "indicatorStyle", function () { return $37d972bc3e7471cb$export$11aaee185e8cb4cf; });
$parcel$export(module.exports, "numberStyle", function () { return $37d972bc3e7471cb$export$6ab59c260daa2dd0; });
$parcel$export(module.exports, "contentWrapperStyle", function () { return $37d972bc3e7471cb$export$682f2e27922bf3a2; });
$parcel$export(module.exports, "headerStyle", function () { return $37d972bc3e7471cb$export$5939e41228734fb7; });
$parcel$export(module.exports, "contentStyle", function () { return $37d972bc3e7471cb$export$a6a87d3faf1ce385; });

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("1OfTO");
var $cbxDY = parcelRequire("cbxDY");
var $8JWbY = parcelRequire("8JWbY");
var $jahGf = parcelRequire("jahGf");
const $37d972bc3e7471cb$export$c4d4f06a25de97f = (0, $1lyZZ.css)({
    display: 'flex',
    alignItems: 'stretch',
    width: 'auto'
});
const $37d972bc3e7471cb$export$11aaee185e8cb4cf = (activeColor, isLast, isValid)=>(0, $1lyZZ.css)({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flexGrow: 0,
        flexShrink: 0,
        '&::after': !isLast && {
            margin: `${0, $cbxDY.baseUnit}px 0`,
            borderRadius: 2,
            width: (0, $cbxDY.baseUnit),
            backgroundColor: isValid ? activeColor : (0, $8JWbY.colors).neutralColors.slate20,
            content: `''`,
            display: 'block',
            flexGrow: 1,
            height: (0, $cbxDY.baseUnit)
        }
    });
const $37d972bc3e7471cb$export$6ab59c260daa2dd0 = (activeColor, isActive, isComplete, isValid, isWarning)=>{
    const numberSize = (0, $cbxDY.baseUnit) * 8;
    return (0, $1lyZZ.css)({
        alignItems: 'center',
        backgroundColor: $37d972bc3e7471cb$var$getBackgroundColor(activeColor, isActive, isComplete, isWarning),
        borderColor: $37d972bc3e7471cb$var$getBorderColor(activeColor, isActive, isValid, isWarning),
        borderRadius: numberSize / 2,
        borderWidth: 3,
        borderStyle: 'solid',
        color: $37d972bc3e7471cb$var$getNumberColor(activeColor, isActive, isComplete, isValid, isWarning),
        display: 'flex',
        flexGrow: 0,
        flexShrink: 0,
        fontSize: (0, $jahGf.font).size.size1,
        fontWeight: (0, $jahGf.font).weight.medium,
        height: numberSize,
        justifyContent: 'center',
        outline: 'none',
        textDecoration: 'none',
        width: numberSize
    });
};
const $37d972bc3e7471cb$export$682f2e27922bf3a2 = (0, $1lyZZ.css)({
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: (0, $cbxDY.spacing).size4,
    minHeight: (0, $cbxDY.spacing).size16
});
const $37d972bc3e7471cb$export$5939e41228734fb7 = (activeColor, isActive, isValid, isWarning)=>(0, $1lyZZ.css)({
        padding: `${(0, $cbxDY.baseUnit) / 2}px ${(0, $cbxDY.spacing).size4}px ${(0, $cbxDY.baseUnit) / 2}px 0`,
        fontSize: (0, $jahGf.font).size.size1,
        color: $37d972bc3e7471cb$var$getHeaderColor(activeColor, isActive, isValid, isWarning),
        fontWeight: !isActive ? (0, $jahGf.font).weight.regular : (0, $jahGf.font).weight.medium
    });
const $37d972bc3e7471cb$export$a6a87d3faf1ce385 = (isActive, questionHeight)=>(0, $1lyZZ.css)({
        display: 'block',
        overflow: 'hidden',
        visibility: isActive ? 'visible' : 'hidden',
        height: $37d972bc3e7471cb$var$getContentHeight(isActive, questionHeight),
        opacity: isActive ? 1 : 0,
        transition: 'height .5s ease, opacity .5s ease',
        paddingLeft: (0, $cbxDY.baseUnit) / 2
    });
// Helpers
function $37d972bc3e7471cb$var$getBackgroundColor(activeColor, isActive, isComplete, isWarning) {
    if (isWarning && !isActive) return (0, $8JWbY.colors).utilityColors.warning.warning400;
    return isComplete && !isActive ? activeColor : (0, $8JWbY.colors).neutralColors.white;
}
function $37d972bc3e7471cb$var$getBorderColor(activeColor, isActive, isValid, isWarning) {
    if (isWarning) return (0, $8JWbY.colors).utilityColors.warning.warning400;
    return !isActive && !isValid ? (0, $8JWbY.colors).neutralColors.slate20 : activeColor;
}
function $37d972bc3e7471cb$var$getHeaderColor(activeColor, isActive, isValid, isWarning) {
    if (isWarning) return (0, $8JWbY.colors).utilityColors.warning.warning400;
    !isActive && !isValid ? (0, $8JWbY.colors).neutralColors.slateBase : activeColor;
}
function $37d972bc3e7471cb$var$getNumberColor(activeColor, isActive, isComplete, isValid, isWarning) {
    if (isWarning) return (0, $8JWbY.colors).utilityColors.warning.warning400;
    if (isActive || isValid) return activeColor;
    if (isComplete) return (0, $8JWbY.colors).neutralColors.white;
    return (0, $8JWbY.colors).neutralColors.slateBase;
}
function $37d972bc3e7471cb$var$getContentHeight(isActive, questionHeight) {
    if (!questionHeight) return 'auto';
    if (questionHeight && isActive) return questionHeight;
    return 0;
}

});



parcelRegister("cByD8", function(module, exports) {

$parcel$export(module.exports, "Question", function () { return $92d3cd8fc90b30e2$export$38435c7d2fecd2f; });

var $df8fE = parcelRequire("df8fE");

var $a5EUy = parcelRequire("a5EUy");

var $3yJBl = parcelRequire("3yJBl");

var $1lyZZ = parcelRequire("1lyZZ");

var $jfKIU = parcelRequire("jfKIU");
parcelRequire("i7Pqi");
var $gdpIa = parcelRequire("gdpIa");
var $aIP73 = parcelRequire("aIP73");
parcelRequire("hi8ts");
var $5NEgo = parcelRequire("5NEgo");
parcelRequire("dnijQ");
var $4DCYn = parcelRequire("4DCYn");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $jahGf = parcelRequire("jahGf");
var $4AJXw = parcelRequire("4AJXw");
var $cbxDY = parcelRequire("cbxDY");

var $cRlsu = parcelRequire("cRlsu");

var $etnHH = parcelRequire("etnHH");

var $206kH = parcelRequire("206kH");

var $302dL = parcelRequire("302dL");

var $d9YJY = parcelRequire("d9YJY");
parcelRequire("9U1pE");
var $32O6s = parcelRequire("32O6s");
var $dnN3u = parcelRequire("dnN3u");
var $lx8xh = parcelRequire("lx8xh");

var $j8IpY = parcelRequire("j8IpY");

var $4Qzkk = parcelRequire("4Qzkk");

var $jBMnw = parcelRequire("jBMnw");

var $7eF6Y = parcelRequire("7eF6Y");

var $jkzLx = parcelRequire("jkzLx");
const $92d3cd8fc90b30e2$var$questionWrapperStyle = (0, $1lyZZ.css)({
    marginBottom: (0, $cbxDY.spacing).size10
});
const $92d3cd8fc90b30e2$var$buttonWrapperStyle = (0, $1lyZZ.css)({
    display: 'flex',
    margin: `${(0, $cbxDY.spacing).size10}px 0 ${(0, $cbxDY.spacing).size4}px`
});
const $92d3cd8fc90b30e2$var$headerWrapperStyle = (0, $1lyZZ.css)({
    display: 'flex'
});
const $92d3cd8fc90b30e2$var$infoButtonWrapperStyle = (0, $1lyZZ.css)({
    marginLeft: (0, $cbxDY.spacing).size3,
    verticalAlign: 'middle',
    cursor: 'pointer'
});
const $92d3cd8fc90b30e2$var$infoButtonStyle = (0, $1lyZZ.css)({
    color: (0, $8JWbY.colors).boldColors.lightBlue.base
});
const $92d3cd8fc90b30e2$var$headerStyle = (0, $1lyZZ.css)({
    fontSize: (0, $jahGf.font).size.size2,
    marginTop: (0, $cbxDY.spacing).size4,
    marginBottom: (0, $cbxDY.spacing).size2
});
const $92d3cd8fc90b30e2$var$additionalFieldsWrapperStyle = (0, $1lyZZ.css)({
    width: 'auto',
    marginTop: (0, $cbxDY.spacing).size10,
    [(0, $4AJXw.media).medium]: {
        width: 450
    }
});
const $92d3cd8fc90b30e2$var$justificationHelpTextColor = (isDisabled, shouldHighlight)=>{
    if (isDisabled) return (0, $8JWbY.colors).neutralColors.slate40;
    if (shouldHighlight) return (0, $8JWbY.colors).neutralColors.black;
    return (0, $8JWbY.colors).neutralColors.slateBase;
};
const $92d3cd8fc90b30e2$var$proofTitleStyle = (isDisabled, shouldHighlight)=>(0, $1lyZZ.css)({
        color: $92d3cd8fc90b30e2$var$justificationHelpTextColor(isDisabled, shouldHighlight),
        background: shouldHighlight ? (0, $8JWbY.colors).utilityColors.warning.warning100 : 'none',
        padding: shouldHighlight ? `${(0, $cbxDY.spacing).size1}px ${(0, $cbxDY.spacing).size2}px` : 'inherit',
        marginBottom: (0, $cbxDY.spacing).size2
    });
const $92d3cd8fc90b30e2$var$questionContentWrapperStyle = (0, $1lyZZ.css)({
    position: 'relative'
});
const $92d3cd8fc90b30e2$var$loadingOverlayStyle = (0, $1lyZZ.css)({
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: (0, $8JWbY.colors).neutralColors.white,
    opacity: 0.8,
    zIndex: 999999
});
const $92d3cd8fc90b30e2$var$additionalFieldsHeaderStyle = (isDisabled)=>(0, $1lyZZ.css)({
        fontWeight: (0, $jahGf.font).weight.medium,
        fontSize: (0, $jahGf.font).size.size1,
        marginBottom: (0, $cbxDY.spacing).size1,
        color: isDisabled ? (0, $8JWbY.colors).neutralColors.slate40 : (0, $8JWbY.colors).neutralColors.slate100
    });
const $92d3cd8fc90b30e2$var$additionalFieldWrapperStyle = (0, $1lyZZ.css)({
    marginBottom: (0, $cbxDY.spacing).size6
});
const $92d3cd8fc90b30e2$var$dropzoneHelpTextStyle = (isDisabled)=>(0, $1lyZZ.css)({
        fontSize: (0, $jahGf.font).size.sizeM1,
        marginTop: (0, $cbxDY.spacing).size1,
        display: 'block',
        color: isDisabled ? (0, $8JWbY.colors).neutralColors.slate40 : (0, $8JWbY.colors).neutralColors.slate90
    });
const $92d3cd8fc90b30e2$export$38435c7d2fecd2f = ({ question: question, questionState: questionState, hasBackButton: hasBackButton, saveAnswer: saveAnswer, isSaving: isSaving, isActive: isActive, uploadImageKeys: uploadImageKeys, highlightProofRequirement: highlightProofRequirement, hideActionButton: hideActionButton = false, uploadId: uploadId })=>{
    const { questionId: questionId, subHeader: subHeader, conditions: conditions, questionType: questionType, uploadHeadline: uploadHeadline, furtherDetails: furtherDetails, commentsInTextBox: commentsInTextBox, explanation: explanation } = question;
    const { labels: { svy_additional_comments: svy_additional_comments, svy_next_button: svy_next_button, svy_back_button: svy_back_button, svy_max_number_of_images: svy_max_number_of_images, svy_additional_comments_placeholder_text: svy_additional_comments_placeholder_text, svy_snackbar_error_header: svy_snackbar_error_header, svy_snackbar_error_default_text: svy_snackbar_error_default_text, svy_tooltip_question_see_more_info: svy_tooltip_question_see_more_info, svy_tooltip_question_choose_answer_first: svy_tooltip_question_choose_answer_first } } = (0, $cRlsu.useLabels)();
    const { dispatch: dispatch } = (0, $a5EUy.useContext)((0, $4Qzkk.SurveyContext));
    const [infoModalVisibility, setInfoModalVisibility] = (0, $a5EUy.useState)(false);
    const [deleteImageModal, setDeleteImageModal] = (0, $a5EUy.useState)({
        isOpen: false,
        imageId: ''
    });
    const [imageModal, setImageModal] = (0, $a5EUy.useState)({
        isOpen: false,
        imageId: ''
    });
    // Set multi select question to valid
    // as soon as it becomes active as no validation is needed for that question
    // but it looks weird if indicator is blue before reaching that question
    (0, $a5EUy.useEffect)(()=>{
        if (questionType === (0, $4DCYn.questionTypes).NON_BINARY_MULTI_CHOICE && !questionState.isComplete) {
            if (isActive && !questionState.isValid) dispatch((0, $4Qzkk.updateValidationAction)(questionId));
        }
    }, [
        isActive,
        questionType,
        questionState.isValid,
        questionState.isComplete,
        questionId,
        dispatch
    ]);
    const shouldDisableImageUpload = !questionState.isValid || uploadImageKeys.length >= 5;
    const closeImageModal = ()=>{
        setImageModal(()=>({
                ...imageModal,
                isOpen: false
            }));
    };
    const deleteImageHandler = async (imageKey)=>{
        try {
            await (0, $jfKIU.Storage).remove(imageKey);
            setDeleteImageModal((prevState)=>({
                    ...prevState,
                    isOpen: false
                }));
            dispatch((0, $4Qzkk.deleteUploadedImage)(imageKey));
        } catch (error) {
            (0, $7eF6Y.generalApiErrorHandler)({
                error: error,
                snackbarHeader: svy_snackbar_error_header,
                snackbarMessage: svy_snackbar_error_default_text
            });
        }
    };
    return /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
        css: $92d3cd8fc90b30e2$var$questionWrapperStyle,
        children: [
            deleteImageModal.isOpen && /*#__PURE__*/ (0, $df8fE.jsx)((0, $32O6s.DeleteImageModal), {
                imageId: deleteImageModal.imageId,
                deleteImageHandler: deleteImageHandler,
                closeDeleteImageModal: ()=>setDeleteImageModal((prevState)=>({
                            ...prevState,
                            isOpen: false
                        }))
            }),
            infoModalVisibility && /*#__PURE__*/ (0, $df8fE.jsx)((0, $lx8xh.InfoModal), {
                header: subHeader,
                body: furtherDetails,
                closeInfoModal: ()=>setInfoModalVisibility(!infoModalVisibility)
            }),
            imageModal.isOpen && /*#__PURE__*/ (0, $df8fE.jsx)((0, $dnN3u.ImageModal), {
                imageId: imageModal.imageId,
                closeImageModal: closeImageModal
            }),
            /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                css: $92d3cd8fc90b30e2$var$questionContentWrapperStyle,
                children: [
                    isSaving && /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                        css: $92d3cd8fc90b30e2$var$loadingOverlayStyle,
                        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $302dL.Spinner), {})
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                        css: $92d3cd8fc90b30e2$var$headerWrapperStyle,
                        children: /*#__PURE__*/ (0, $df8fE.jsxs)("h2", {
                            css: $92d3cd8fc90b30e2$var$headerStyle,
                            children: [
                                subHeader,
                                /*#__PURE__*/ (0, $df8fE.jsx)((0, $jBMnw.Tooltip), {
                                    content: svy_tooltip_question_see_more_info,
                                    children: /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                                        "data-testid": "questionInfoModalButton",
                                        onClick: ()=>setInfoModalVisibility(!infoModalVisibility),
                                        css: $92d3cd8fc90b30e2$var$infoButtonWrapperStyle,
                                        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $5NEgo.StatusInformationBold), {
                                            css: $92d3cd8fc90b30e2$var$infoButtonStyle
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)((0, $jkzLx.QuestionDescription), {
                        explanation: explanation,
                        conditions: conditions
                    }),
                    questionType === 'NON_BINARY_MULTI_CHOICE' ? /*#__PURE__*/ (0, $df8fE.jsx)((0, $etnHH.MultiChoice), {
                        question: question,
                        questionState: questionState
                    }) : /*#__PURE__*/ (0, $df8fE.jsx)((0, $206kH.SingleChoice), {
                        question: question,
                        questionState: questionState
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsxs)("section", {
                        css: $92d3cd8fc90b30e2$var$additionalFieldsWrapperStyle,
                        children: [
                            /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                                css: $92d3cd8fc90b30e2$var$additionalFieldWrapperStyle,
                                children: [
                                    /*#__PURE__*/ (0, $df8fE.jsx)("h3", {
                                        css: $92d3cd8fc90b30e2$var$additionalFieldsHeaderStyle(!questionState.isValid),
                                        children: svy_additional_comments
                                    }),
                                    /*#__PURE__*/ (0, $df8fE.jsx)("p", {
                                        css: $92d3cd8fc90b30e2$var$proofTitleStyle(shouldDisableImageUpload, highlightProofRequirement.isCommentMissing),
                                        children: commentsInTextBox
                                    }),
                                    /*#__PURE__*/ (0, $df8fE.jsx)((0, $aIP73.TextArea), {
                                        onChange: (event)=>dispatch((0, $4Qzkk.updateCommentAction)(questionId, event.target.value)),
                                        value: questionState.comment,
                                        disabled: !questionState.isValid,
                                        isDisabled: !questionState.isValid,
                                        validationStatus: highlightProofRequirement.isCommentMissing ? 'warning' : '',
                                        placeholder: svy_additional_comments_placeholder_text
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                                css: $92d3cd8fc90b30e2$var$additionalFieldWrapperStyle,
                                children: [
                                    /*#__PURE__*/ (0, $df8fE.jsx)("p", {
                                        css: $92d3cd8fc90b30e2$var$proofTitleStyle(shouldDisableImageUpload, highlightProofRequirement.isUploadMissing),
                                        children: uploadHeadline
                                    }),
                                    /*#__PURE__*/ (0, $df8fE.jsx)((0, $d9YJY.ImageUpload), {
                                        questionId: questionId,
                                        uploadId: uploadId,
                                        isDisabled: shouldDisableImageUpload,
                                        onSuccess: (imageKey)=>dispatch((0, $4Qzkk.addUploadedImage)(imageKey))
                                    }),
                                    /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                                        css: $92d3cd8fc90b30e2$var$dropzoneHelpTextStyle(shouldDisableImageUpload),
                                        children: svy_max_number_of_images
                                    }),
                                    !!uploadImageKeys.length && /*#__PURE__*/ (0, $df8fE.jsx)((0, $j8IpY.UploadedImageThumbnailList), {
                                        uploadImageKeys: uploadImageKeys,
                                        imageClickHandler: (imageId)=>setImageModal((prevState)=>({
                                                    ...prevState,
                                                    imageId: imageId,
                                                    isOpen: true
                                                })),
                                        imageDeleteClickHandler: (imageId)=>setDeleteImageModal((prevState)=>({
                                                    ...prevState,
                                                    isOpen: true,
                                                    imageId: imageId
                                                }))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !hideActionButton && /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                css: $92d3cd8fc90b30e2$var$buttonWrapperStyle,
                children: [
                    hasBackButton && /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                        disabled: isSaving,
                        isDisabled: isSaving,
                        "data-transaction-name": "Step back in question",
                        onClick: ()=>dispatch((0, $4Qzkk.stepBackAction)()),
                        label: svy_back_button,
                        variant: "outline",
                        style: {
                            marginRight: (0, $cbxDY.spacing).size4
                        }
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)((0, $jBMnw.Tooltip), {
                        content: svy_tooltip_question_choose_answer_first,
                        disabled: questionState.isValid,
                        children: /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                            children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                                label: svy_next_button,
                                disabled: !questionState.isValid || isSaving,
                                isDisabled: !questionState.isValid || isSaving,
                                "data-transaction-name": "Save answer",
                                onClick: ()=>saveAnswer(questionId)
                            })
                        })
                    })
                ]
            })
        ]
    });
};
$92d3cd8fc90b30e2$export$38435c7d2fecd2f.propTypes = {
    question: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).object.isRequired,
    questionState: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).object.isRequired,
    hasBackButton: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool.isRequired,
    saveAnswer: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func.isRequired,
    isSaving: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool.isRequired,
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool.isRequired,
    highlightProofRequirement: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).object.isRequired,
    hideActionButton: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool,
    uploadImageKeys: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string).isRequired,
    uploadId: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string.isRequired
};

});
parcelRegister("dnijQ", function(module, exports) {

$parcel$export(module.exports, "questionTypes", function () { return (parcelRequire("4DCYn")).questionTypes; });
$parcel$export(module.exports, "surveyStatus", function () { return (parcelRequire("fmWA7")).surveyStatus; });
$parcel$export(module.exports, "imageUploadErrorTypes", function () { return (parcelRequire("2w42B")).imageUploadErrorTypes; });

var $4DCYn = parcelRequire("4DCYn");

var $fmWA7 = parcelRequire("fmWA7");

var $2w42B = parcelRequire("2w42B");

});
parcelRegister("4DCYn", function(module, exports) {

$parcel$export(module.exports, "questionTypes", function () { return $3609091c954802eb$export$e50882b81c62e311; });
const $3609091c954802eb$export$e50882b81c62e311 = {
    BINARY_CHOICE: 'BINARY_CHOICE',
    NON_BINARY_SINGLE_CHOICE: 'NON_BINARY_SINGLE_CHOICE',
    NON_BINARY_MULTI_CHOICE: 'NON_BINARY_MULTI_CHOICE'
};

});

parcelRegister("fmWA7", function(module, exports) {

$parcel$export(module.exports, "surveyStatus", function () { return $b3065a2ca06ecfb3$export$91a9e3864063c972; });
const $b3065a2ca06ecfb3$export$91a9e3864063c972 = {
    NOT_SUBMITTED: 'NOT_SUBMITTED',
    CHANGES_REQUIRED: 'CHANGES_REQUIRED',
    RESCORING_REQUIRED: 'RESCORING_REQUIRED',
    IN_LEGO_REVIEW: 'IN_LEGO_REVIEW',
    COMPLETED: 'COMPLETED'
};

});

parcelRegister("2w42B", function(module, exports) {

$parcel$export(module.exports, "imageUploadErrorTypes", function () { return $1d51b45e88e26a82$export$22c0d1c4538a5951; });
const $1d51b45e88e26a82$export$22c0d1c4538a5951 = {
    FILE_INVALID_TYPE: 'file-invalid-type',
    TOO_MANY_FILES: 'too-many-files',
    FILE_TOO_LARGE: 'file-too-large'
};

});


parcelRegister("etnHH", function(module, exports) {

$parcel$export(module.exports, "MultiChoice", function () { return $a8962931fda81fac$export$70859b46811b52c1; });

var $df8fE = parcelRequire("df8fE");

var $a5EUy = parcelRequire("a5EUy");

var $3yJBl = parcelRequire("3yJBl");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("i7Pqi");
var $7QTa8 = parcelRequire("7QTa8");
parcelRequire("1OfTO");
var $cbxDY = parcelRequire("cbxDY");

var $4Qzkk = parcelRequire("4Qzkk");

var $8HnHg = parcelRequire("8HnHg");
const $a8962931fda81fac$var$multiChoiceWrapperStyle = (0, $1lyZZ.css)({
    marginTop: (0, $cbxDY.spacing).size8
});
const $a8962931fda81fac$export$70859b46811b52c1 = ({ question: question, questionState: questionState })=>{
    const { dispatch: dispatch } = (0, $a5EUy.useContext)((0, $4Qzkk.SurveyContext));
    const { questionId: questionId, questionType: questionType, answerOptions: answerOptions } = question;
    return /*#__PURE__*/ (0, $df8fE.jsx)("div", {
        children: answerOptions.map((answer, index)=>/*#__PURE__*/ (0, $df8fE.jsx)("div", {
                css: $a8962931fda81fac$var$multiChoiceWrapperStyle,
                children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $7QTa8.Checkbox), {
                    checked: questionState.selectedAnswer.includes(answer.answerId),
                    onChange: (event)=>dispatch((0, $4Qzkk.updateAnswerAction)(questionId, questionType, event.target.value)),
                    label: /*#__PURE__*/ (0, $df8fE.jsx)((0, $8HnHg.AnswerLabel), {
                        labelText: answer.text,
                        score: answer.score
                    }),
                    value: answer.answerId
                })
            }, index))
    });
};
$a8962931fda81fac$export$70859b46811b52c1.propTypes = {
    question: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).object.isRequired,
    questionState: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).object.isRequired
};

});
parcelRegister("4Qzkk", function(module, exports) {

$parcel$export(module.exports, "SurveyContext", function () { return $38776becb3d4acb9$export$663c2b064fc3c91e; });
$parcel$export(module.exports, "surveyReducer", function () { return $38776becb3d4acb9$export$62084e9522e5cab; });
$parcel$export(module.exports, "updateAnswerAction", function () { return $38776becb3d4acb9$export$a5aa18497ac2449; });
$parcel$export(module.exports, "updateCommentAction", function () { return $38776becb3d4acb9$export$b9fe65f7083ae815; });
$parcel$export(module.exports, "updateSubAnswerAction", function () { return $38776becb3d4acb9$export$5258cffe7b5660f2; });
$parcel$export(module.exports, "stepBackAction", function () { return $38776becb3d4acb9$export$9b541d9f1fcb7ba1; });
$parcel$export(module.exports, "updateValidationAction", function () { return $38776becb3d4acb9$export$5c6e90ccb78f1afd; });
$parcel$export(module.exports, "resetAction", function () { return $38776becb3d4acb9$export$2e78289a93d130a3; });
$parcel$export(module.exports, "answerSavedAction", function () { return $38776becb3d4acb9$export$3e8f578fc1f6d087; });
$parcel$export(module.exports, "setUploadedImages", function () { return $38776becb3d4acb9$export$5a9723c1c1c2936c; });
$parcel$export(module.exports, "addUploadedImage", function () { return $38776becb3d4acb9$export$584b5172b1334e18; });
$parcel$export(module.exports, "deleteUploadedImage", function () { return $38776becb3d4acb9$export$bbf1ccc913d6ed12; });

var $a5EUy = parcelRequire("a5EUy");

var $lsDX7 = parcelRequire("lsDX7");
parcelRequire("dnijQ");
var $4DCYn = parcelRequire("4DCYn");
const $38776becb3d4acb9$export$663c2b064fc3c91e = /*#__PURE__*/ (0, $a5EUy.createContext)();
const $38776becb3d4acb9$export$665446046e211b61 = 'UPDATE_ANSWER';
const $38776becb3d4acb9$export$424409e47882d57e = 'UPDATE_SUB_ANSWER';
const $38776becb3d4acb9$export$e4c3b88d3098e3ee = 'UPDATE_COMMENT';
const $38776becb3d4acb9$export$bffc53fdec94e058 = 'STEP_BACK';
const $38776becb3d4acb9$export$c8fc4598c519ec37 = 'UPDATE_VALIDATION';
const $38776becb3d4acb9$export$4a991c87e640ef77 = 'RESET';
const $38776becb3d4acb9$export$f22e29cd098f571f = 'ANSWER_SAVED';
const $38776becb3d4acb9$export$855a5c0ee315c6e1 = 'SET_UPLOADED_IMAGES';
const $38776becb3d4acb9$export$9e9067a66918a482 = 'ADD_UPLOADED_IMAGE';
const $38776becb3d4acb9$export$992126a0fde689ec = 'DELETE_UPLOADED_IMAGE';
function $38776becb3d4acb9$export$62084e9522e5cab(state, action) {
    switch(action.type){
        case $38776becb3d4acb9$export$665446046e211b61:
            {
                const { questionId: questionId, questionType: questionType, value: value } = action.payload;
                const isMultiSelect = questionType === (0, $4DCYn.questionTypes).NON_BINARY_MULTI_CHOICE;
                return {
                    ...state,
                    answers: state.answers.map((answer)=>{
                        if (answer.questionId !== questionId) return answer;
                        if (isMultiSelect) return {
                            ...answer,
                            isValid: (0, $lsDX7.questionValidator)(true, value),
                            selectedAnswer: (0, $lsDX7.getMultiSelectAnswers)(value, answer.selectedAnswer)
                        };
                        // For single choice: find which saved ID is the current main answer
                        // by cross-referencing against the question's answerOptions
                        const question = state.questions?.find((q)=>q.questionId === questionId);
                        const mainAnswerIds = question?.answerOptions?.map((opt)=>opt.answerId) ?? [];
                        const currentMainAnswerId = answer.selectedAnswer.find((id)=>mainAnswerIds.includes(id));
                        const isSameMainAnswer = currentMainAnswerId === value;
                        return {
                            ...answer,
                            isValid: (0, $lsDX7.questionValidator)(false, value),
                            // Preserve sub-answers when re-selecting the same main answer;
                            // clear them when switching to a different main answer
                            selectedAnswer: isSameMainAnswer ? answer.selectedAnswer : [
                                value
                            ]
                        };
                    })
                };
            }
        case $38776becb3d4acb9$export$424409e47882d57e:
            {
                const { questionId: questionId, subAnswerId: subAnswerId } = action.payload;
                return {
                    ...state,
                    answers: state.answers.map((answer)=>{
                        if (answer.questionId !== questionId) return answer;
                        const updated = answer.selectedAnswer.includes(subAnswerId) ? answer.selectedAnswer.filter((id)=>id !== subAnswerId) : [
                            ...answer.selectedAnswer,
                            subAnswerId
                        ];
                        return {
                            ...answer,
                            selectedAnswer: updated
                        };
                    })
                };
            }
        case $38776becb3d4acb9$export$e4c3b88d3098e3ee:
            {
                const { questionId: questionId, value: value } = action.payload;
                return {
                    ...state,
                    answers: state.answers.map((answer)=>{
                        if (answer.questionId !== questionId) return answer;
                        return {
                            ...answer,
                            comment: value
                        };
                    })
                };
            }
        case $38776becb3d4acb9$export$855a5c0ee315c6e1:
            {
                const { uploadedImages: uploadedImages } = action.payload;
                return {
                    ...state,
                    isFetchingUploadedImages: false,
                    uploadedImageKeys: uploadedImages
                };
            }
        case $38776becb3d4acb9$export$9e9067a66918a482:
            {
                const { imageKey: imageKey } = action.payload;
                return {
                    ...state,
                    uploadedImageKeys: [
                        ...state.uploadedImageKeys,
                        imageKey
                    ]
                };
            }
        case $38776becb3d4acb9$export$992126a0fde689ec:
            {
                const { imageKey: imageKey } = action.payload;
                return {
                    ...state,
                    uploadedImageKeys: state.uploadedImageKeys.filter((imageKeyFromState)=>imageKeyFromState !== imageKey)
                };
            }
        case $38776becb3d4acb9$export$bffc53fdec94e058:
            return {
                ...state,
                activeStep: state.activeStep - 1
            };
        case $38776becb3d4acb9$export$c8fc4598c519ec37:
            {
                const { questionId: questionId } = action.payload;
                return {
                    ...state,
                    answers: state.answers.map((answer)=>{
                        if (answer.questionId !== questionId) return answer;
                        return {
                            ...answer,
                            isValid: !answer.isValid
                        };
                    })
                };
            }
        case $38776becb3d4acb9$export$f22e29cd098f571f:
            {
                const { questionId: questionId } = action.payload;
                const updatedAnswersArray = state.answers.map((answer)=>{
                    if (answer.questionId !== questionId) return answer;
                    return {
                        ...answer,
                        isComplete: true
                    };
                });
                return {
                    ...state,
                    activeStep: state.activeStep + 1,
                    answers: updatedAnswersArray
                };
            }
        case $38776becb3d4acb9$export$4a991c87e640ef77:
            {
                const { surveyPageData: { getAnswers: getAnswers, getSurvey: getSurvey, getSurveyInfo: getSurveyInfo } } = action.payload;
                return {
                    activeStep: (0, $lsDX7.getActiveStep)(getAnswers),
                    isFetchingUploadedImages: false,
                    questions: getSurvey,
                    isSurveyComplete: getAnswers.every((answer)=>answer.isComplete),
                    isSurveyEditable: getSurveyInfo.surveyState.isEditable,
                    // Get rid of __typename property as it causes
                    // trouble when using the answer object for a mutation
                    answers: (0, $lsDX7.removeTypenameFromAllAnswers)(getAnswers),
                    uploadedImageKeys: [],
                    uploadId: getSurveyInfo.uploadId
                };
            }
        default:
            return state;
    }
}
function $38776becb3d4acb9$export$a5aa18497ac2449(questionId, questionType, value) {
    return {
        type: $38776becb3d4acb9$export$665446046e211b61,
        payload: {
            questionId: questionId,
            questionType: questionType,
            value: value
        }
    };
}
function $38776becb3d4acb9$export$b9fe65f7083ae815(questionId, value) {
    return {
        type: $38776becb3d4acb9$export$e4c3b88d3098e3ee,
        payload: {
            questionId: questionId,
            value: value
        }
    };
}
function $38776becb3d4acb9$export$5258cffe7b5660f2(questionId, subAnswerId) {
    return {
        type: $38776becb3d4acb9$export$424409e47882d57e,
        payload: {
            questionId: questionId,
            subAnswerId: subAnswerId
        }
    };
}
function $38776becb3d4acb9$export$9b541d9f1fcb7ba1() {
    return {
        type: $38776becb3d4acb9$export$bffc53fdec94e058
    };
}
function $38776becb3d4acb9$export$5c6e90ccb78f1afd(questionId) {
    return {
        type: $38776becb3d4acb9$export$c8fc4598c519ec37,
        payload: {
            questionId: questionId
        }
    };
}
function $38776becb3d4acb9$export$2e78289a93d130a3(surveyPageData) {
    return {
        type: $38776becb3d4acb9$export$4a991c87e640ef77,
        payload: {
            surveyPageData: surveyPageData
        }
    };
}
function $38776becb3d4acb9$export$3e8f578fc1f6d087(questionId) {
    return {
        type: $38776becb3d4acb9$export$f22e29cd098f571f,
        payload: {
            questionId: questionId
        }
    };
}
function $38776becb3d4acb9$export$5a9723c1c1c2936c(uploadedImages) {
    return {
        type: $38776becb3d4acb9$export$855a5c0ee315c6e1,
        payload: {
            uploadedImages: uploadedImages
        }
    };
}
function $38776becb3d4acb9$export$584b5172b1334e18(imageKey) {
    return {
        type: $38776becb3d4acb9$export$9e9067a66918a482,
        payload: {
            imageKey: imageKey
        }
    };
}
function $38776becb3d4acb9$export$bbf1ccc913d6ed12(imageKey) {
    return {
        type: $38776becb3d4acb9$export$992126a0fde689ec,
        payload: {
            imageKey: imageKey
        }
    };
}

});
parcelRegister("lsDX7", function(module, exports) {

$parcel$export(module.exports, "questionValidator", function () { return $f9fb343efbfa642e$export$1495774a44129127; });
$parcel$export(module.exports, "enhanceQuestionsWithAnswersAndProof", function () { return $f9fb343efbfa642e$export$3ac154c70d0babda; });
$parcel$export(module.exports, "adjustAssessmentsBasedOnFeatureFlags", function () { return $f9fb343efbfa642e$export$386fc8b17cd02a9b; });
$parcel$export(module.exports, "removeTypenameFromAllAnswers", function () { return $f9fb343efbfa642e$export$fc089f4bb21eb8e6; });
$parcel$export(module.exports, "getActiveStep", function () { return $f9fb343efbfa642e$export$88afa644e87a15dc; });
$parcel$export(module.exports, "getMultiSelectAnswers", function () { return $f9fb343efbfa642e$export$93d8e6a03e666d10; });
$parcel$export(module.exports, "areAllAnswersComplete", function () { return $f9fb343efbfa642e$export$ce968a13e2c6e586; });
$parcel$export(module.exports, "isAnyQuestionMissingProof", function () { return $f9fb343efbfa642e$export$3e14b0f9f411cc85; });
$parcel$export(module.exports, "normalizeAnswer", function () { return $f9fb343efbfa642e$export$9fee1bbbe4aa216c; });
$parcel$export(module.exports, "computeScore", function () { return $f9fb343efbfa642e$export$e09e94e4e42c547d; });
parcelRequire("1OfTO");
var $e200k = parcelRequire("e200k");

var $4DCYn = parcelRequire("4DCYn");
const $f9fb343efbfa642e$export$1495774a44129127 = (isMultiSelect, answerValue)=>{
    if (isMultiSelect) return true;
    if (answerValue) return true;
    return false;
};
const $f9fb343efbfa642e$export$ddb7e08df9f16f51 = (answer, question, nrOfUploadedImages)=>{
    // debugger;
    const requiresComment = question.commentsTextBox === 'Open Text shown';
    const requiresUpload = question.upload;
    const result = {
        isCommentMissing: false,
        isUploadMissing: false,
        isProofMissing: false
    };
    if (!answer || !answer.selectedAnswer || answer.selectedAnswer.length === 0 || !requiresComment && !requiresUpload) return result;
    const { selectedAnswer: selectedAnswersIds, comment: comment } = answer;
    const { answersExemptFromAttachments: answersExemptFromAttachments } = question;
    const answerIdsExemptFromAttachments = answersExemptFromAttachments?.map((ans)=>ans.answerId) ?? [];
    // NON_BINARY_SINGLE_CHOICE stores sub-answer IDs at index [1+] in selectedAnswer.
    // Sub-answer IDs are not main answer options and must not influence the exempt check.
    // All other question types only have main answer IDs in selectedAnswer so every() is correct.
    const idsToCheckForExemption = question.questionType === (0, $4DCYn.questionTypes).NON_BINARY_SINGLE_CHOICE ? selectedAnswersIds.slice(0, 1) : selectedAnswersIds;
    const allSelectedAreExempt = idsToCheckForExemption.every((answerId)=>answerIdsExemptFromAttachments.includes(answerId));
    if (allSelectedAreExempt) return result;
    const didComment = comment && comment.length > 0;
    const didUploadImages = nrOfUploadedImages > 0;
    result.isCommentMissing = requiresComment && !didComment;
    result.isUploadMissing = requiresUpload && !didUploadImages;
    result.isProofMissing = result.isCommentMissing || result.isUploadMissing;
    return result;
};
const $f9fb343efbfa642e$export$3ac154c70d0babda = (questions, answers, uploadedImagesKeys)=>{
    return questions.map((question)=>{
        const savedAnswer = answers.find((answer)=>answer.questionId === question.questionId);
        let questionImageKeys;
        if (uploadedImagesKeys) questionImageKeys = $f9fb343efbfa642e$export$32f77b04f5436dc4(uploadedImagesKeys, question.questionId);
        else questionImageKeys = savedAnswer?.images?.map((imageKey)=>imageKey.replace('public/', ''));
        const proofRequirement = $f9fb343efbfa642e$export$ddb7e08df9f16f51(savedAnswer, question, questionImageKeys?.length ?? 0);
        return {
            ...question,
            savedAnswer: savedAnswer,
            questionImageKeys: questionImageKeys,
            proofRequirement: proofRequirement
        };
    });
};
const $f9fb343efbfa642e$export$22ec2e08ed58da59 = (surveyData)=>{
    const { year: year } = surveyData;
    const { requiredProof: requiredProof } = (0, $e200k.featureFlags);
    const isYearCovered = year >= requiredProof.startYear;
    return isYearCovered;
};
const $f9fb343efbfa642e$export$386fc8b17cd02a9b = (enhancedQuestionData, surveyData)=>{
    const shouldBeCheckedForProof = $f9fb343efbfa642e$export$22ec2e08ed58da59(surveyData);
    if (!shouldBeCheckedForProof) return enhancedQuestionData.map((question)=>{
        question.proofRequirement = {
            isCommentMissing: false,
            isUploadMissing: false,
            isProofMissing: false
        };
        return question;
    });
    return enhancedQuestionData;
};
const $f9fb343efbfa642e$export$fc089f4bb21eb8e6 = (answerArr)=>{
    return answerArr.map((answer)=>{
        const answerCopy = {
            ...answer
        };
        delete answerCopy['__typename'];
        return answerCopy;
    });
};
const $f9fb343efbfa642e$export$88afa644e87a15dc = (answerArr)=>{
    const answersCompleted = answerArr.filter((answer)=>answer.isComplete);
    return answersCompleted.length + 1;
};
const $f9fb343efbfa642e$export$93d8e6a03e666d10 = (answerValue, currentAnswerState)=>{
    if (currentAnswerState.includes(answerValue)) return currentAnswerState.filter((answerId)=>answerId !== answerValue);
    if (answerValue) return [
        ...currentAnswerState,
        answerValue
    ];
    return currentAnswerState;
};
const $f9fb343efbfa642e$export$32f77b04f5436dc4 = (imageKeysArr, questionId)=>{
    if (!imageKeysArr) return [];
    const regex = new RegExp(`${questionId}`);
    return imageKeysArr.filter((imageKey)=>imageKey.match(regex));
};
const $f9fb343efbfa642e$export$ce968a13e2c6e586 = (answers)=>{
    if (!answers) return null;
    return answers.every((answer)=>answer.isComplete);
};
const $f9fb343efbfa642e$export$3e14b0f9f411cc85 = (questions)=>questions.some((question)=>question.proofRequirement.isProofMissing);
const $f9fb343efbfa642e$export$19e7665dc25a3a35 = (selectedAnswer, answerOptions)=>{
    const unique = [
        ...new Set(selectedAnswer)
    ];
    if (!answerOptions?.length) return unique;
    const mainAnswerIds = answerOptions.map((opt)=>opt.answerId);
    const mainId = unique.find((id)=>mainAnswerIds.includes(id));
    if (!mainId || unique[0] === mainId) return unique;
    // Ensure main answer is first, sub-answers follow
    return [
        mainId,
        ...unique.filter((id)=>id !== mainId)
    ];
};
const $f9fb343efbfa642e$export$9fee1bbbe4aa216c = (answer, questions)=>{
    const question = questions.find((q)=>q.questionId === answer.questionId);
    return {
        ...answer,
        selectedAnswer: $f9fb343efbfa642e$export$19e7665dc25a3a35(answer.selectedAnswer, question?.answerOptions)
    };
};
const $f9fb343efbfa642e$export$e09e94e4e42c547d = (answerOptions, selectedParentId, selectedSubIds)=>{
    const selectedOption = answerOptions.find((o)=>o.answerId === selectedParentId);
    if (selectedOption?.score == null) return 0;
    if (!selectedOption.subAnswerOptions?.length) return selectedOption.score;
    const subOptionIds = new Set(selectedOption.subAnswerOptions.map((s)=>s.answerId));
    const selectedSubCount = selectedSubIds.filter((id)=>subOptionIds.has(id)).length;
    if (selectedSubCount >= (selectedOption.minimumSubAnswers ?? 0)) return selectedOption.score;
    return answerOptions.filter((o)=>o.score != null).filter((o)=>selectedSubCount >= (o.minimumSubAnswers ?? 0)).reduce((best, o)=>Math.max(best, o.score), 0);
};

});


parcelRegister("8HnHg", function(module, exports) {

$parcel$export(module.exports, "AnswerLabel", function () { return $6554b896bb27a657$export$1be1c2a12d0f6cf8; });

var $df8fE = parcelRequire("df8fE");

var $3yJBl = parcelRequire("3yJBl");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $jahGf = parcelRequire("jahGf");
var $cbxDY = parcelRequire("cbxDY");
const $6554b896bb27a657$var$answerLabelWrapperStyle = (0, $1lyZZ.css)({
    display: 'flex',
    alignItems: 'baseline'
});
const $6554b896bb27a657$var$answerLabelTextStyle = (0, $1lyZZ.css)({
    fontSize: (0, $jahGf.font).size.size05,
    marginRight: (0, $cbxDY.spacing).size2,
    whiteSpace: 'pre-wrap'
});
const $6554b896bb27a657$var$answerLabelScoreStyle = (0, $1lyZZ.css)({
    fontWeight: (0, $jahGf.font).weight.bold,
    fontSize: (0, $jahGf.font).size.sizeM1,
    fontStyle: 'italic'
});
const $6554b896bb27a657$var$answerLabelScoreWarningStyle = (0, $1lyZZ.css)({
    fontWeight: (0, $jahGf.font).weight.bold,
    fontSize: (0, $jahGf.font).size.sizeM1,
    fontStyle: 'italic',
    backgroundColor: (0, $8JWbY.colors).utilityColors.warning.warning100,
    color: (0, $8JWbY.colors).neutralColors.black
});
const $6554b896bb27a657$export$1be1c2a12d0f6cf8 = ({ labelText: labelText, score: score, scoreWarning: scoreWarning })=>/*#__PURE__*/ (0, $df8fE.jsxs)("span", {
        css: $6554b896bb27a657$var$answerLabelWrapperStyle,
        children: [
            /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                css: $6554b896bb27a657$var$answerLabelTextStyle,
                children: labelText
            }),
            typeof score === 'number' && /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                css: scoreWarning ? $6554b896bb27a657$var$answerLabelScoreWarningStyle : $6554b896bb27a657$var$answerLabelScoreStyle,
                children: `(${score}%)`
            })
        ]
    });
$6554b896bb27a657$export$1be1c2a12d0f6cf8.propTypes = {
    labelText: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string.isRequired,
    score: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).number,
    scoreWarning: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool
};

});


parcelRegister("206kH", function(module, exports) {

$parcel$export(module.exports, "SingleChoice", function () { return $17507e6e2efcded8$export$518ee1f8a60ca514; });

var $df8fE = parcelRequire("df8fE");

var $a5EUy = parcelRequire("a5EUy");

var $3yJBl = parcelRequire("3yJBl");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("i7Pqi");
var $7QTa8 = parcelRequire("7QTa8");
var $bzTkH = parcelRequire("bzTkH");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $jahGf = parcelRequire("jahGf");
var $cbxDY = parcelRequire("cbxDY");

var $4Qzkk = parcelRequire("4Qzkk");

var $lsDX7 = parcelRequire("lsDX7");

var $8HnHg = parcelRequire("8HnHg");

var $cRlsu = parcelRequire("cRlsu");
const $17507e6e2efcded8$var$subAnswerWrapperStyle = (0, $1lyZZ.css)({
    marginTop: (0, $cbxDY.spacing).size4,
    marginLeft: (0, $cbxDY.spacing).size8
});
const $17507e6e2efcded8$var$subAnswerHeaderStyle = (0, $1lyZZ.css)({
    fontSize: (0, $jahGf.font).size.size05,
    fontWeight: (0, $jahGf.font).weight.regular,
    whiteSpace: 'pre-wrap',
    marginTop: 0,
    marginBottom: (0, $cbxDY.spacing).size4,
    marginLeft: 0,
    color: 'inherit'
});
const $17507e6e2efcded8$var$subAnswerItemStyle = (0, $1lyZZ.css)({
    marginTop: (0, $cbxDY.spacing).size4
});
const $17507e6e2efcded8$var$subAnswerWarningStyle = (0, $1lyZZ.css)({
    fontSize: (0, $jahGf.font).size.sizeM1,
    backgroundColor: (0, $8JWbY.colors).utilityColors.warning.warning100,
    padding: `${(0, $cbxDY.spacing).size1}px ${(0, $cbxDY.spacing).size2}px`,
    marginBottom: (0, $cbxDY.spacing).size4,
    marginLeft: 0,
    color: (0, $8JWbY.colors).neutralColors.black
});
const $17507e6e2efcded8$export$518ee1f8a60ca514 = ({ question: question, questionState: questionState })=>{
    const { dispatch: dispatch } = (0, $a5EUy.useContext)((0, $4Qzkk.SurveyContext));
    const { labels: { svy_sub_answers_reduced_discount: svy_sub_answers_reduced_discount } } = (0, $cRlsu.useLabels)();
    const { questionId: questionId, questionType: questionType, answerOptions: answerOptions } = question;
    const mainAnswerIds = answerOptions.map((o)=>o.answerId);
    const selectedSubIds = questionState.selectedAnswer.filter((id)=>!mainAnswerIds.includes(id));
    return /*#__PURE__*/ (0, $df8fE.jsx)("div", {
        children: answerOptions.map((answer)=>{
            const isSelected = questionState.selectedAnswer.includes(answer.answerId);
            const displayScore = isSelected && answer.subAnswerOptions?.length > 0 ? (0, $lsDX7.computeScore)(answerOptions, answer.answerId, selectedSubIds) : answer.score;
            // Score is reduced when computeScore returns less than the answer's full score.
            const scoreWarning = isSelected && answer.subAnswerOptions?.length > 0 && displayScore !== answer.score;
            return /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $df8fE.jsx)((0, $bzTkH.Radio), {
                        name: questionId,
                        onChange: (event)=>dispatch((0, $4Qzkk.updateAnswerAction)(questionId, questionType, event.target.value)),
                        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $bzTkH.Radio).Button, {
                            checked: isSelected ? 'checked' : false,
                            label: /*#__PURE__*/ (0, $df8fE.jsx)((0, $8HnHg.AnswerLabel), {
                                labelText: answer.text,
                                score: displayScore,
                                scoreWarning: scoreWarning
                            }),
                            value: answer.answerId
                        })
                    }),
                    isSelected && answer.subAnswerOptions?.length > 0 && /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                        css: $17507e6e2efcded8$var$subAnswerWrapperStyle,
                        children: [
                            answer.subAnswerHeader && /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                                css: $17507e6e2efcded8$var$subAnswerHeaderStyle,
                                children: answer.subAnswerHeader
                            }),
                            scoreWarning && /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                                css: $17507e6e2efcded8$var$subAnswerWarningStyle,
                                children: svy_sub_answers_reduced_discount
                            }),
                            answer.subAnswerOptions.map((subOption)=>/*#__PURE__*/ (0, $df8fE.jsx)("div", {
                                    css: $17507e6e2efcded8$var$subAnswerItemStyle,
                                    children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $7QTa8.Checkbox), {
                                        checked: questionState.selectedAnswer.includes(subOption.answerId),
                                        onChange: ()=>dispatch((0, $4Qzkk.updateSubAnswerAction)(questionId, subOption.answerId)),
                                        label: subOption.text,
                                        value: subOption.answerId
                                    })
                                }, subOption.answerId))
                        ]
                    })
                ]
            }, answer.answerId);
        })
    });
};
$17507e6e2efcded8$export$518ee1f8a60ca514.propTypes = {
    question: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).object.isRequired,
    questionState: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).object.isRequired
};

});

parcelRegister("d9YJY", function(module, exports) {

$parcel$export(module.exports, "ImageUpload", function () { return $994b3b6afee11d1b$export$6083e5dee0802eaa; });

var $df8fE = parcelRequire("df8fE");

var $a5EUy = parcelRequire("a5EUy");

var $3yJBl = parcelRequire("3yJBl");

var $bIL5B = parcelRequire("bIL5B");

var $jfKIU = parcelRequire("jfKIU");

var $cRlsu = parcelRequire("cRlsu");

var $dAuQ7 = parcelRequire("dAuQ7");
parcelRequire("dntWt");
var $fHgS9 = parcelRequire("fHgS9");
var $gAOhP = parcelRequire("gAOhP");
parcelRequire("dnijQ");
var $2w42B = parcelRequire("2w42B");

var $7eF6Y = parcelRequire("7eF6Y");

var $4zZNZ = parcelRequire("4zZNZ");
const $994b3b6afee11d1b$export$6083e5dee0802eaa = ({ onSuccess: onSuccess, isDisabled: isDisabled, questionId: questionId, uploadId: uploadId })=>{
    const acceptedFiles = [
        'image/*',
        'application/pdf'
    ];
    const [uploadProgress, setUploadProgress] = (0, $a5EUy.useState)(0);
    const { labels: { svy_snackbar_error_header: svy_snackbar_error_header, svy_snackbar_error_default_text: svy_snackbar_error_default_text, svy_snackbar_error_upload_invalid_file_type: svy_snackbar_error_upload_invalid_file_type, svy_snackbar_error_upload_too_many_files: svy_snackbar_error_upload_too_many_files, svy_snackbar_error_upload_image_too_large: svy_snackbar_error_upload_image_too_large } } = (0, $cRlsu.useLabels)();
    const imageUploadErrorHandler = (errorsArray)=>{
        if (!errorsArray.length || !errorsArray[0].errors.length) return false;
        const error = errorsArray[0].errors[0];
        let errorMessage;
        switch(error.code){
            case (0, $2w42B.imageUploadErrorTypes).FILE_INVALID_TYPE:
                errorMessage = svy_snackbar_error_upload_invalid_file_type;
                break;
            case (0, $2w42B.imageUploadErrorTypes).TOO_MANY_FILES:
                errorMessage = svy_snackbar_error_upload_too_many_files;
                break;
            case (0, $2w42B.imageUploadErrorTypes).FILE_TOO_LARGE:
                errorMessage = svy_snackbar_error_upload_image_too_large;
                break;
            default:
                errorMessage = svy_snackbar_error_default_text;
        }
        (0, $4zZNZ.logger).logError(error);
        return (0, $fHgS9.addSnackbar)({
            header: svy_snackbar_error_header,
            text: errorMessage,
            type: (0, $gAOhP.snackbarTypes).ERROR
        });
    };
    const uploadToS3 = async (file)=>{
        if (!file) return false;
        const uuid = (0, $bIL5B.default)();
        const filePath = `${uploadId}/qid-${questionId}/${uuid}/${file.path}`;
        try {
            await (0, $jfKIU.Storage).put(filePath, file, {
                contentType: file.type,
                progressCallback (progress) {
                    const uploadProgressInPercent = Math.round(progress.loaded / progress.total * 100);
                    setUploadProgress(uploadProgressInPercent);
                }
            });
            setUploadProgress(0);
            onSuccess(filePath);
        } catch (error) {
            (0, $7eF6Y.generalApiErrorHandler)({
                error: error,
                snackbarHeader: svy_snackbar_error_header,
                snackbarMessage: svy_snackbar_error_default_text
            });
        }
    };
    return /*#__PURE__*/ (0, $df8fE.jsx)((0, $dAuQ7.Dropzone), {
        acceptedFiles: acceptedFiles,
        uploadProgress: uploadProgress,
        onDrop: (acceptedFiles)=>uploadToS3(acceptedFiles[0]),
        onDropRejected: imageUploadErrorHandler,
        isDisabled: isDisabled || !!uploadProgress
    });
};
$994b3b6afee11d1b$export$6083e5dee0802eaa.propTypes = {
    onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool.isRequired,
    questionId: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string.isRequired,
    uploadId: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string.isRequired
};

});
parcelRegister("bIL5B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $888854ba03e23fe8$export$2e2bcd8739ae039; });

var $cZ4Nm = parcelRequire("cZ4Nm");

var $kOOD4 = parcelRequire("kOOD4");
function $888854ba03e23fe8$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $cZ4Nm.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $kOOD4.default)(rnds);
}
var $888854ba03e23fe8$export$2e2bcd8739ae039 = $888854ba03e23fe8$var$v4;

});
parcelRegister("cZ4Nm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $973ee6c2c704be11$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $973ee6c2c704be11$var$getRandomValues;
var $973ee6c2c704be11$var$rnds8 = new Uint8Array(16);
function $973ee6c2c704be11$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$973ee6c2c704be11$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $973ee6c2c704be11$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!$973ee6c2c704be11$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $973ee6c2c704be11$var$getRandomValues($973ee6c2c704be11$var$rnds8);
}

});

parcelRegister("kOOD4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f27fc0106f1ff95c$export$2e2bcd8739ae039; });

var $cznS2 = parcelRequire("cznS2");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $f27fc0106f1ff95c$var$byteToHex = [];
for(var $f27fc0106f1ff95c$var$i = 0; $f27fc0106f1ff95c$var$i < 256; ++$f27fc0106f1ff95c$var$i)$f27fc0106f1ff95c$var$byteToHex.push(($f27fc0106f1ff95c$var$i + 0x100).toString(16).substr(1));
function $f27fc0106f1ff95c$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($f27fc0106f1ff95c$var$byteToHex[arr[offset + 0]] + $f27fc0106f1ff95c$var$byteToHex[arr[offset + 1]] + $f27fc0106f1ff95c$var$byteToHex[arr[offset + 2]] + $f27fc0106f1ff95c$var$byteToHex[arr[offset + 3]] + '-' + $f27fc0106f1ff95c$var$byteToHex[arr[offset + 4]] + $f27fc0106f1ff95c$var$byteToHex[arr[offset + 5]] + '-' + $f27fc0106f1ff95c$var$byteToHex[arr[offset + 6]] + $f27fc0106f1ff95c$var$byteToHex[arr[offset + 7]] + '-' + $f27fc0106f1ff95c$var$byteToHex[arr[offset + 8]] + $f27fc0106f1ff95c$var$byteToHex[arr[offset + 9]] + '-' + $f27fc0106f1ff95c$var$byteToHex[arr[offset + 10]] + $f27fc0106f1ff95c$var$byteToHex[arr[offset + 11]] + $f27fc0106f1ff95c$var$byteToHex[arr[offset + 12]] + $f27fc0106f1ff95c$var$byteToHex[arr[offset + 13]] + $f27fc0106f1ff95c$var$byteToHex[arr[offset + 14]] + $f27fc0106f1ff95c$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $cznS2.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $f27fc0106f1ff95c$export$2e2bcd8739ae039 = $f27fc0106f1ff95c$var$stringify;

});
parcelRegister("cznS2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $926b451a76117857$export$2e2bcd8739ae039; });

var $dffsv = parcelRequire("dffsv");
function $926b451a76117857$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $dffsv.default).test(uuid);
}
var $926b451a76117857$export$2e2bcd8739ae039 = $926b451a76117857$var$validate;

});
parcelRegister("dffsv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a48aad7a6071901$export$2e2bcd8739ae039; });
var $9a48aad7a6071901$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("dAuQ7", function(module, exports) {

$parcel$export(module.exports, "Dropzone", function () { return $9e468f3eb6668bc7$export$47d4850b9fdf5af1; });

var $df8fE = parcelRequire("df8fE");

var $3yJBl = parcelRequire("3yJBl");

var $7V91z = parcelRequire("7V91z");

var $1lyZZ = parcelRequire("1lyZZ");

var $cRlsu = parcelRequire("cRlsu");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $jahGf = parcelRequire("jahGf");
var $cbxDY = parcelRequire("cbxDY");
parcelRequire("hi8ts");
var $8gxGP = parcelRequire("8gxGP");
const { neutralColors: { white: $9e468f3eb6668bc7$var$white, slate02: $9e468f3eb6668bc7$var$slate02, slate20: $9e468f3eb6668bc7$var$slate20, slate40: $9e468f3eb6668bc7$var$slate40, slate50: $9e468f3eb6668bc7$var$slate50, slate60: $9e468f3eb6668bc7$var$slate60 }, boldColors: { lightBlue: { ligthBlue20: $9e468f3eb6668bc7$var$ligthBlue20 } }, utilityColors: { information: $9e468f3eb6668bc7$var$information, success: $9e468f3eb6668bc7$var$success, error: $9e468f3eb6668bc7$var$error } } = (0, $8JWbY.colors);
const $9e468f3eb6668bc7$var$getColor = (isDisabled, isDragAccept, isDragActive, isDragReject)=>{
    if (isDragAccept) return $9e468f3eb6668bc7$var$success.base;
    if (isDragReject) return $9e468f3eb6668bc7$var$error.base;
    if (isDragActive) return $9e468f3eb6668bc7$var$information.base;
    if (isDisabled) return $9e468f3eb6668bc7$var$slate20;
    return $9e468f3eb6668bc7$var$slate60;
};
const $9e468f3eb6668bc7$var$DropzoneContainerStyle = (isDisabled, isDragAccept, isDragActive, isDragReject)=>(0, $1lyZZ.css)({
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        padding: 20,
        borderWidth: 2,
        borderRadius: 4,
        borderColor: $9e468f3eb6668bc7$var$getColor(isDisabled, isDragAccept, isDragActive, isDragReject),
        borderStyle: 'dashed',
        backgroundColor: isDisabled ? $9e468f3eb6668bc7$var$slate02 : $9e468f3eb6668bc7$var$white,
        color: isDisabled ? $9e468f3eb6668bc7$var$slate40 : $9e468f3eb6668bc7$var$slate60,
        outline: 'none',
        transition: 'border 0.24s ease-in-out',
        height: 120,
        position: 'relative'
    });
const $9e468f3eb6668bc7$var$UploadIconStyle = (0, $1lyZZ.css)({
    zIndex: 1,
    color: $9e468f3eb6668bc7$var$slate50
});
const $9e468f3eb6668bc7$var$UploadTextStyle = (0, $1lyZZ.css)({
    lineHeight: (0, $jahGf.font).lineHeight.s,
    marginTop: (0, $cbxDY.spacing).size1,
    color: $9e468f3eb6668bc7$var$slate50,
    zIndex: 1
});
const $9e468f3eb6668bc7$var$UploadProgressbarStyle = (uploadProgress)=>(0, $1lyZZ.css)({
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: $9e468f3eb6668bc7$var$ligthBlue20,
        width: `${uploadProgress}%`
    });
const $9e468f3eb6668bc7$export$47d4850b9fdf5af1 = ({ acceptedFiles: acceptedFiles, uploadProgress: uploadProgress, onDrop: onDrop, isDisabled: isDisabled, isMultipleFilesAllowed: isMultipleFilesAllowed = false, onDropRejected: onDropRejected })=>{
    const { labels: { svy_uploading_image_text: svy_uploading_image_text }, richTextLabels: { svy_upload_text_in_box: svy_upload_text_in_box } } = (0, $cRlsu.useLabels)();
    const { getRootProps: getRootProps, getInputProps: getInputProps, isDragActive: isDragActive, isDragAccept: isDragAccept, isDragReject: isDragReject } = (0, $7V91z.useDropzone)({
        accept: acceptedFiles,
        disabled: isDisabled,
        onDrop: onDrop,
        multiple: isMultipleFilesAllowed,
        maxSize: 10000000,
        onDropRejected: onDropRejected
    });
    return /*#__PURE__*/ (0, $df8fE.jsx)("section", {
        className: "container",
        children: /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
            "aria-label": "upload-drag-and-drop-area",
            css: $9e468f3eb6668bc7$var$DropzoneContainerStyle(isDisabled, isDragAccept, isDragActive, isDragReject),
            ...getRootProps({}),
            children: [
                /*#__PURE__*/ (0, $df8fE.jsx)("input", {
                    ...getInputProps()
                }),
                /*#__PURE__*/ (0, $df8fE.jsx)((0, $8gxGP.CloudUpload), {
                    css: $9e468f3eb6668bc7$var$UploadIconStyle
                }),
                /*#__PURE__*/ (0, $df8fE.jsx)("p", {
                    css: $9e468f3eb6668bc7$var$UploadTextStyle,
                    children: uploadProgress ? /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                        children: svy_uploading_image_text
                    }) : /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: svy_upload_text_in_box
                        }
                    })
                }),
                !!uploadProgress && /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                    css: $9e468f3eb6668bc7$var$UploadProgressbarStyle(uploadProgress)
                })
            ]
        })
    });
};
$9e468f3eb6668bc7$export$47d4850b9fdf5af1.propTypes = {
    acceptedFiles: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string),
    uploadProgress: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).number.isRequired,
    onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func.isRequired,
    onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func.isRequired,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool.isRequired,
    isMultipleFilesAllowed: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool
};

});
parcelRegister("7V91z", function(module, exports) {

$parcel$export(module.exports, "useDropzone", function () { return $5c44db4b3403e93f$export$cd49c0ecc5be9f36; });

var $a5EUy = parcelRequire("a5EUy");

var $3yJBl = parcelRequire("3yJBl");
parcelRequire("2cKXy");
var $4OCuO = parcelRequire("4OCuO");

var $ixLRV = parcelRequire("ixLRV");
function $5c44db4b3403e93f$var$_toConsumableArray(arr) {
    return $5c44db4b3403e93f$var$_arrayWithoutHoles(arr) || $5c44db4b3403e93f$var$_iterableToArray(arr) || $5c44db4b3403e93f$var$_unsupportedIterableToArray(arr) || $5c44db4b3403e93f$var$_nonIterableSpread();
}
function $5c44db4b3403e93f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5c44db4b3403e93f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $5c44db4b3403e93f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $5c44db4b3403e93f$var$_arrayLikeToArray(arr);
}
function $5c44db4b3403e93f$var$_slicedToArray(arr, i) {
    return $5c44db4b3403e93f$var$_arrayWithHoles(arr) || $5c44db4b3403e93f$var$_iterableToArrayLimit(arr, i) || $5c44db4b3403e93f$var$_unsupportedIterableToArray(arr, i) || $5c44db4b3403e93f$var$_nonIterableRest();
}
function $5c44db4b3403e93f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5c44db4b3403e93f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5c44db4b3403e93f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5c44db4b3403e93f$var$_arrayLikeToArray(o, minLen);
}
function $5c44db4b3403e93f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5c44db4b3403e93f$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $5c44db4b3403e93f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $5c44db4b3403e93f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5c44db4b3403e93f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5c44db4b3403e93f$var$ownKeys(Object(source), true).forEach(function(key) {
            $5c44db4b3403e93f$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5c44db4b3403e93f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5c44db4b3403e93f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5c44db4b3403e93f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5c44db4b3403e93f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5c44db4b3403e93f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $5c44db4b3403e93f$var$Dropzone = /*#__PURE__*/ (0, $a5EUy.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $5c44db4b3403e93f$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    var _useDropzone = $5c44db4b3403e93f$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $5c44db4b3403e93f$var$_objectWithoutProperties(_useDropzone, [
        "open"
    ]);
    (0, $a5EUy.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement((0, $a5EUy.Fragment), null, children($5c44db4b3403e93f$var$_objectSpread($5c44db4b3403e93f$var$_objectSpread({}, props), {}, {
        open: open
    })));
});
$5c44db4b3403e93f$var$Dropzone.displayName = 'Dropzone'; // Add default props for react-docgen
var $5c44db4b3403e93f$var$defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, $4OCuO.fromEvent),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false
};
$5c44db4b3403e93f$var$Dropzone.defaultProps = $5c44db4b3403e93f$var$defaultProps;
$5c44db4b3403e93f$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func,
    /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string)
    ]),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func
};
var $5c44db4b3403e93f$export$2e2bcd8739ae039 = $5c44db4b3403e93f$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ var $5c44db4b3403e93f$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    draggedFiles: [],
    acceptedFiles: [],
    fileRejections: []
};
function $5c44db4b3403e93f$export$cd49c0ecc5be9f36() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$options = $5c44db4b3403e93f$var$_objectSpread($5c44db4b3403e93f$var$_objectSpread({}, $5c44db4b3403e93f$var$defaultProps), options), accept = _defaultProps$options.accept, disabled = _defaultProps$options.disabled, getFilesFromEvent = _defaultProps$options.getFilesFromEvent, maxSize = _defaultProps$options.maxSize, minSize = _defaultProps$options.minSize, multiple = _defaultProps$options.multiple, maxFiles = _defaultProps$options.maxFiles, onDragEnter = _defaultProps$options.onDragEnter, onDragLeave = _defaultProps$options.onDragLeave, onDragOver = _defaultProps$options.onDragOver, onDrop = _defaultProps$options.onDrop, onDropAccepted = _defaultProps$options.onDropAccepted, onDropRejected = _defaultProps$options.onDropRejected, onFileDialogCancel = _defaultProps$options.onFileDialogCancel, preventDropOnDocument = _defaultProps$options.preventDropOnDocument, noClick = _defaultProps$options.noClick, noKeyboard = _defaultProps$options.noKeyboard, noDrag = _defaultProps$options.noDrag, noDragEventsBubbling = _defaultProps$options.noDragEventsBubbling;
    var rootRef = (0, $a5EUy.useRef)(null);
    var inputRef = (0, $a5EUy.useRef)(null);
    var _useReducer = (0, $a5EUy.useReducer)($5c44db4b3403e93f$var$reducer, $5c44db4b3403e93f$var$initialState), _useReducer2 = $5c44db4b3403e93f$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive, draggedFiles = state.draggedFiles; // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $a5EUy.useCallback)(function() {
        if (inputRef.current) {
            dispatch({
                type: 'openDialog'
            });
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch
    ]); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: 'closeDialog'
                    });
                    if (typeof onFileDialogCancel === 'function') onFileDialogCancel();
                }
            }
        }, 300);
    };
    (0, $a5EUy.useEffect)(function() {
        window.addEventListener('focus', onWindowFocus, false);
        return function() {
            window.removeEventListener('focus', onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancel
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $a5EUy.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        inputRef
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $a5EUy.useCallback)(function() {
        dispatch({
            type: 'focus'
        });
    }, []);
    var onBlurCb = (0, $a5EUy.useCallback)(function() {
        dispatch({
            type: 'blur'
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $a5EUy.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $ixLRV.isIeOrEdge)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        inputRef,
        noClick
    ]);
    var dragTargetsRef = (0, $a5EUy.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $a5EUy.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener('dragover', (0, $ixLRV.onDocumentDragOver), false);
            document.addEventListener('drop', onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener('dragover', (0, $ixLRV.onDocumentDragOver));
                document.removeEventListener('drop', onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]);
    var onDragEnterCb = (0, $a5EUy.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($5c44db4b3403e93f$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $ixLRV.isEvtWithFiles)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(draggedFiles) {
            if ((0, $ixLRV.isPropagationStopped)(event) && !noDragEventsBubbling) return;
            dispatch({
                draggedFiles: draggedFiles,
                isDragActive: true,
                type: 'setDraggedFiles'
            });
            if (onDragEnter) onDragEnter(event);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        noDragEventsBubbling
    ]);
    var onDragOverCb = (0, $a5EUy.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        if (event.dataTransfer) try {
            event.dataTransfer.dropEffect = 'copy';
        } catch (_unused) {}
        if ((0, $ixLRV.isEvtWithFiles)(event) && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $a5EUy.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            isDragActive: false,
            type: 'setDraggedFiles',
            draggedFiles: []
        });
        if ((0, $ixLRV.isEvtWithFiles)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var onDropCb = (0, $a5EUy.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $ixLRV.isEvtWithFiles)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $ixLRV.isPropagationStopped)(event) && !noDragEventsBubbling) return;
            var acceptedFiles = [];
            var fileRejections = [];
            files.forEach(function(file) {
                var _fileAccepted = (0, $ixLRV.fileAccepted)(file, accept), _fileAccepted2 = $5c44db4b3403e93f$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
                var _fileMatchSize = (0, $ixLRV.fileMatchSize)(file, minSize, maxSize), _fileMatchSize2 = $5c44db4b3403e93f$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
                if (accepted && sizeMatch) acceptedFiles.push(file);
                else {
                    var errors = [
                        acceptError,
                        sizeError
                    ].filter(function(e) {
                        return e;
                    });
                    fileRejections.push({
                        file: file,
                        errors: errors
                    });
                }
            });
            if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
                // Reject everything and empty accepted files
                acceptedFiles.forEach(function(file) {
                    fileRejections.push({
                        file: file,
                        errors: [
                            (0, $ixLRV.TOO_MANY_FILES_REJECTION)
                        ]
                    });
                });
                acceptedFiles.splice(0);
            }
            dispatch({
                acceptedFiles: acceptedFiles,
                fileRejections: fileRejections,
                type: 'setFiles'
            });
            if (onDrop) onDrop(acceptedFiles, fileRejections, event);
            if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
            if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
        });
        dispatch({
            type: 'reset'
        });
    }, [
        multiple,
        accept,
        minSize,
        maxSize,
        maxFiles,
        getFilesFromEvent,
        onDrop,
        onDropAccepted,
        onDropRejected,
        noDragEventsBubbling
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $a5EUy.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? 'ref' : _ref2$refKey, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = $5c44db4b3403e93f$var$_objectWithoutProperties(_ref2, [
                "refKey",
                "onKeyDown",
                "onFocus",
                "onBlur",
                "onClick",
                "onDragEnter",
                "onDragOver",
                "onDragLeave",
                "onDrop"
            ]);
            return $5c44db4b3403e93f$var$_objectSpread($5c44db4b3403e93f$var$_objectSpread($5c44db4b3403e93f$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $ixLRV.composeEventHandlers)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $ixLRV.composeEventHandlers)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $ixLRV.composeEventHandlers)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $ixLRV.composeEventHandlers)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $ixLRV.composeEventHandlers)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $ixLRV.composeEventHandlers)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $ixLRV.composeEventHandlers)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $ixLRV.composeEventHandlers)(onDrop, onDropCb))
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $a5EUy.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $a5EUy.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = $5c44db4b3403e93f$var$_objectWithoutProperties(_ref3, [
                "refKey",
                "onChange",
                "onClick"
            ]);
            var inputProps = $5c44db4b3403e93f$var$_defineProperty({
                accept: accept,
                multiple: multiple,
                type: 'file',
                style: {
                    display: 'none'
                },
                onChange: composeHandler((0, $ixLRV.composeEventHandlers)(onChange, onDropCb)),
                onClick: composeHandler((0, $ixLRV.composeEventHandlers)(onClick, onInputElementClick)),
                autoComplete: 'off',
                tabIndex: -1
            }, refKey, inputRef);
            return $5c44db4b3403e93f$var$_objectSpread($5c44db4b3403e93f$var$_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    var fileCount = draggedFiles.length;
    var isDragAccept = fileCount > 0 && (0, $ixLRV.allFilesAccepted)({
        files: draggedFiles,
        accept: accept,
        minSize: minSize,
        maxSize: maxSize,
        multiple: multiple,
        maxFiles: maxFiles
    });
    var isDragReject = fileCount > 0 && !isDragAccept;
    return $5c44db4b3403e93f$var$_objectSpread($5c44db4b3403e93f$var$_objectSpread({}, state), {}, {
        isDragAccept: isDragAccept,
        isDragReject: isDragReject,
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
function $5c44db4b3403e93f$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case 'focus':
            return $5c44db4b3403e93f$var$_objectSpread($5c44db4b3403e93f$var$_objectSpread({}, state), {}, {
                isFocused: true
            });
        case 'blur':
            return $5c44db4b3403e93f$var$_objectSpread($5c44db4b3403e93f$var$_objectSpread({}, state), {}, {
                isFocused: false
            });
        case 'openDialog':
            return $5c44db4b3403e93f$var$_objectSpread($5c44db4b3403e93f$var$_objectSpread({}, state), {}, {
                isFileDialogActive: true
            });
        case 'closeDialog':
            return $5c44db4b3403e93f$var$_objectSpread($5c44db4b3403e93f$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case 'setDraggedFiles':
            /* eslint no-case-declarations: 0 */ var isDragActive = action.isDragActive, draggedFiles = action.draggedFiles;
            return $5c44db4b3403e93f$var$_objectSpread($5c44db4b3403e93f$var$_objectSpread({}, state), {}, {
                draggedFiles: draggedFiles,
                isDragActive: isDragActive
            });
        case 'setFiles':
            return $5c44db4b3403e93f$var$_objectSpread($5c44db4b3403e93f$var$_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections
            });
        case 'reset':
            return $5c44db4b3403e93f$var$_objectSpread($5c44db4b3403e93f$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false,
                isDragActive: false,
                draggedFiles: [],
                acceptedFiles: [],
                fileRejections: []
            });
        default:
            return state;
    }
}

});
parcelRegister("2cKXy", function(module, exports) {

$parcel$export(module.exports, "fromEvent", function () { return (parcelRequire("4OCuO")).fromEvent; });

var $4OCuO = parcelRequire("4OCuO");

});
parcelRegister("4OCuO", function(module, exports) {

$parcel$export(module.exports, "fromEvent", function () { return $3819b16b27a97c7f$export$a36e16046ae8f1bb; });

var $dSGEd = parcelRequire("dSGEd");

var $ci8yG = parcelRequire("ci8yG");
var $3819b16b27a97c7f$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
function $3819b16b27a97c7f$export$a36e16046ae8f1bb(evt) {
    return (0, $dSGEd.__awaiter)(this, void 0, void 0, function() {
        return (0, $dSGEd.__generator)(this, function(_a) {
            return [
                2 /*return*/ ,
                $3819b16b27a97c7f$var$isDragEvt(evt) && evt.dataTransfer ? $3819b16b27a97c7f$var$getDataTransferFiles(evt.dataTransfer, evt.type) : $3819b16b27a97c7f$var$getInputFiles(evt)
            ];
        });
    });
}
function $3819b16b27a97c7f$var$isDragEvt(value) {
    return !!value.dataTransfer;
}
function $3819b16b27a97c7f$var$getInputFiles(evt) {
    var files = $3819b16b27a97c7f$var$isInput(evt.target) ? evt.target.files ? $3819b16b27a97c7f$var$fromList(evt.target.files) : [] : [];
    return files.map(function(file) {
        return (0, $ci8yG.toFileWithPath)(file);
    });
}
function $3819b16b27a97c7f$var$isInput(value) {
    return value !== null;
}
function $3819b16b27a97c7f$var$getDataTransferFiles(dt, type) {
    return (0, $dSGEd.__awaiter)(this, void 0, void 0, function() {
        var items, files;
        return (0, $dSGEd.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!dt.items) return [
                        3 /*break*/ ,
                        2
                    ];
                    items = $3819b16b27a97c7f$var$fromList(dt.items).filter(function(item) {
                        return item.kind === 'file';
                    });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') return [
                        2 /*return*/ ,
                        items
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(items.map($3819b16b27a97c7f$var$toFilePromises))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        $3819b16b27a97c7f$var$noIgnoredFiles($3819b16b27a97c7f$var$flatten(files))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        $3819b16b27a97c7f$var$noIgnoredFiles($3819b16b27a97c7f$var$fromList(dt.files).map(function(file) {
                            return (0, $ci8yG.toFileWithPath)(file);
                        }))
                    ];
            }
        });
    });
}
function $3819b16b27a97c7f$var$noIgnoredFiles(files) {
    return files.filter(function(file) {
        return $3819b16b27a97c7f$var$FILES_TO_IGNORE.indexOf(file.name) === -1;
    });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $3819b16b27a97c7f$var$fromList(items) {
    var files = [];
    // tslint:disable: prefer-for-of
    for(var i = 0; i < items.length; i++){
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $3819b16b27a97c7f$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') return $3819b16b27a97c7f$var$fromDataTransferItem(item);
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $3819b16b27a97c7f$var$fromDirEntry(entry);
    return $3819b16b27a97c7f$var$fromDataTransferItem(item);
}
function $3819b16b27a97c7f$var$flatten(items) {
    return items.reduce(function(acc, files) {
        return (0, $dSGEd.__spread)(acc, Array.isArray(files) ? $3819b16b27a97c7f$var$flatten(files) : [
            files
        ]);
    }, []);
}
function $3819b16b27a97c7f$var$fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) return Promise.reject(item + " is not a File");
    var fwp = (0, $ci8yG.toFileWithPath)(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $3819b16b27a97c7f$var$fromEntry(entry) {
    return (0, $dSGEd.__awaiter)(this, void 0, void 0, function() {
        return (0, $dSGEd.__generator)(this, function(_a) {
            return [
                2 /*return*/ ,
                entry.isDirectory ? $3819b16b27a97c7f$var$fromDirEntry(entry) : $3819b16b27a97c7f$var$fromFileEntry(entry)
            ];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $3819b16b27a97c7f$var$fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function(resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function(batch) {
                return (0, $dSGEd.__awaiter)(_this, void 0, void 0, function() {
                    var files, err_1, items;
                    return (0, $dSGEd.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!batch.length) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    Promise.all(entries)
                                ];
                            case 2:
                                files = _a.sent();
                                resolve(files);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                reject(err_1);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                items = Promise.all(batch.map($3819b16b27a97c7f$var$fromEntry));
                                entries.push(items);
                                // Continue reading
                                readEntries();
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, function(err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $3819b16b27a97c7f$var$fromFileEntry(entry) {
    return (0, $dSGEd.__awaiter)(this, void 0, void 0, function() {
        return (0, $dSGEd.__generator)(this, function(_a) {
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    entry.file(function(file) {
                        var fwp = (0, $ci8yG.toFileWithPath)(file, entry.fullPath);
                        resolve(fwp);
                    }, function(err) {
                        reject(err);
                    });
                })
            ];
        });
    });
}

});
parcelRegister("dSGEd", function(module, exports) {

$parcel$export(module.exports, "__awaiter", function () { return $a1b1667145439c02$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $a1b1667145439c02$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__spread", function () { return $a1b1667145439c02$export$afc72e2116322959; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $a1b1667145439c02$var$extendStatics = function(d, b) {
    $a1b1667145439c02$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a1b1667145439c02$var$extendStatics(d, b);
};
function $a1b1667145439c02$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a1b1667145439c02$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a1b1667145439c02$export$18ce0697a983be9b = function() {
    $a1b1667145439c02$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a1b1667145439c02$export$18ce0697a983be9b.apply(this, arguments);
};
function $a1b1667145439c02$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a1b1667145439c02$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a1b1667145439c02$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a1b1667145439c02$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $a1b1667145439c02$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $a1b1667145439c02$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $a1b1667145439c02$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $a1b1667145439c02$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a1b1667145439c02$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a1b1667145439c02$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a1b1667145439c02$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a1b1667145439c02$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a1b1667145439c02$export$45d3717a4c69092e(o, m, p);
}
function $a1b1667145439c02$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a1b1667145439c02$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a1b1667145439c02$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a1b1667145439c02$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a1b1667145439c02$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a1b1667145439c02$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a1b1667145439c02$export$10c90e4f7922046c(v) {
    return this instanceof $a1b1667145439c02$export$10c90e4f7922046c ? (this.v = v, this) : new $a1b1667145439c02$export$10c90e4f7922046c(v);
}
function $a1b1667145439c02$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a1b1667145439c02$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a1b1667145439c02$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a1b1667145439c02$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $a1b1667145439c02$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a1b1667145439c02$export$19a8beecd37a4c45 === "function" ? $a1b1667145439c02$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a1b1667145439c02$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a1b1667145439c02$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $a1b1667145439c02$var$ownKeys = function(o) {
    $a1b1667145439c02$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $a1b1667145439c02$var$ownKeys(o);
};
function $a1b1667145439c02$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $a1b1667145439c02$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $a1b1667145439c02$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $a1b1667145439c02$var$__setModuleDefault(result, mod);
    return result;
}
function $a1b1667145439c02$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a1b1667145439c02$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a1b1667145439c02$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a1b1667145439c02$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $a1b1667145439c02$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $a1b1667145439c02$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $a1b1667145439c02$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $a1b1667145439c02$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $a1b1667145439c02$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $a1b1667145439c02$export$2e2bcd8739ae039 = {
    __extends: $a1b1667145439c02$export$a8ba968b8961cb8a,
    __assign: $a1b1667145439c02$export$18ce0697a983be9b,
    __rest: $a1b1667145439c02$export$3c9a16f847548506,
    __decorate: $a1b1667145439c02$export$29e00dfd3077644b,
    __param: $a1b1667145439c02$export$d5ad3fd78186038f,
    __esDecorate: $a1b1667145439c02$export$3a84e1ae4e97e9b0,
    __runInitializers: $a1b1667145439c02$export$d831c04e792af3d,
    __propKey: $a1b1667145439c02$export$6a2a36740a146cb8,
    __setFunctionName: $a1b1667145439c02$export$d1a06452d3489bc7,
    __metadata: $a1b1667145439c02$export$f1db080c865becb9,
    __awaiter: $a1b1667145439c02$export$1050f835b63b671e,
    __generator: $a1b1667145439c02$export$67ebef60e6f28a6,
    __createBinding: $a1b1667145439c02$export$45d3717a4c69092e,
    __exportStar: $a1b1667145439c02$export$f33643c0debef087,
    __values: $a1b1667145439c02$export$19a8beecd37a4c45,
    __read: $a1b1667145439c02$export$8d051b38c9118094,
    __spread: $a1b1667145439c02$export$afc72e2116322959,
    __spreadArrays: $a1b1667145439c02$export$6388937ca91ccae8,
    __spreadArray: $a1b1667145439c02$export$1216008129fb82ed,
    __await: $a1b1667145439c02$export$10c90e4f7922046c,
    __asyncGenerator: $a1b1667145439c02$export$e427f37a30a4de9b,
    __asyncDelegator: $a1b1667145439c02$export$bbd80228419bb833,
    __asyncValues: $a1b1667145439c02$export$e3b29a3d6162315f,
    __makeTemplateObject: $a1b1667145439c02$export$4fb47efe1390b86f,
    __importStar: $a1b1667145439c02$export$c21735bcef00d192,
    __importDefault: $a1b1667145439c02$export$da59b14a69baef04,
    __classPrivateFieldGet: $a1b1667145439c02$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $a1b1667145439c02$export$d40a35129aaff81f,
    __classPrivateFieldIn: $a1b1667145439c02$export$81fdc39f203e4e04,
    __addDisposableResource: $a1b1667145439c02$export$88ac25d8e944e405,
    __disposeResources: $a1b1667145439c02$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $a1b1667145439c02$export$889dfb5d17574b0b
};

});

parcelRegister("ci8yG", function(module, exports) {

$parcel$export(module.exports, "toFileWithPath", function () { return $8f2dcdfbef1dd908$export$8cc09085015f0dc7; });
var $8f2dcdfbef1dd908$export$db0345794bfc14ed = new Map([
    [
        'avi',
        'video/avi'
    ],
    [
        'gif',
        'image/gif'
    ],
    [
        'ico',
        'image/x-icon'
    ],
    [
        'jpeg',
        'image/jpeg'
    ],
    [
        'jpg',
        'image/jpeg'
    ],
    [
        'mkv',
        'video/x-matroska'
    ],
    [
        'mov',
        'video/quicktime'
    ],
    [
        'mp4',
        'video/mp4'
    ],
    [
        'pdf',
        'application/pdf'
    ],
    [
        'png',
        'image/png'
    ],
    [
        'zip',
        'application/zip'
    ],
    [
        'doc',
        'application/msword'
    ],
    [
        'docx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ]
]);
function $8f2dcdfbef1dd908$export$8cc09085015f0dc7(file, path) {
    var f = $8f2dcdfbef1dd908$var$withMimeType(file);
    if (typeof f.path !== 'string') {
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string' ? path : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function $8f2dcdfbef1dd908$var$withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.').pop().toLowerCase();
        var type = $8f2dcdfbef1dd908$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, 'type', {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}

});



parcelRegister("ixLRV", function(module, exports) {

$parcel$export(module.exports, "TOO_MANY_FILES_REJECTION", function () { return $d80070c6e38fb8a3$export$1e1e1b6120329fe; });
$parcel$export(module.exports, "fileAccepted", function () { return $d80070c6e38fb8a3$export$b511db3632effe58; });
$parcel$export(module.exports, "fileMatchSize", function () { return $d80070c6e38fb8a3$export$860631d45ba43fd9; });
$parcel$export(module.exports, "allFilesAccepted", function () { return $d80070c6e38fb8a3$export$6a0bb4322c81a197; });
$parcel$export(module.exports, "isPropagationStopped", function () { return $d80070c6e38fb8a3$export$8d6d6472146de265; });
$parcel$export(module.exports, "isEvtWithFiles", function () { return $d80070c6e38fb8a3$export$52f1fc875a1e5986; });
$parcel$export(module.exports, "onDocumentDragOver", function () { return $d80070c6e38fb8a3$export$2ead263d6635cecc; });
$parcel$export(module.exports, "isIeOrEdge", function () { return $d80070c6e38fb8a3$export$d3498e653911f962; });
$parcel$export(module.exports, "composeEventHandlers", function () { return $d80070c6e38fb8a3$export$b9ecd428b558ff10; });

var $xqwKK = parcelRequire("xqwKK");
function $d80070c6e38fb8a3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d80070c6e38fb8a3$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d80070c6e38fb8a3$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d80070c6e38fb8a3$var$_typeof(obj);
}
function $d80070c6e38fb8a3$var$_slicedToArray(arr, i) {
    return $d80070c6e38fb8a3$var$_arrayWithHoles(arr) || $d80070c6e38fb8a3$var$_iterableToArrayLimit(arr, i) || $d80070c6e38fb8a3$var$_unsupportedIterableToArray(arr, i) || $d80070c6e38fb8a3$var$_nonIterableRest();
}
function $d80070c6e38fb8a3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d80070c6e38fb8a3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d80070c6e38fb8a3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d80070c6e38fb8a3$var$_arrayLikeToArray(o, minLen);
}
function $d80070c6e38fb8a3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d80070c6e38fb8a3$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $d80070c6e38fb8a3$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $d80070c6e38fb8a3$export$d2c35cc369247232 = 'file-invalid-type';
var $d80070c6e38fb8a3$export$d7bd1185abe1e87c = 'file-too-large';
var $d80070c6e38fb8a3$export$8bd5ec6ed990dc9 = 'file-too-small';
var $d80070c6e38fb8a3$export$3271ef1d2dd155f9 = 'too-many-files'; // File Errors
var $d80070c6e38fb8a3$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr(accept) {
    accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
    var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(', ')) : accept;
    return {
        code: $d80070c6e38fb8a3$export$d2c35cc369247232,
        message: "File type must be ".concat(messageSuffix)
    };
};
var $d80070c6e38fb8a3$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $d80070c6e38fb8a3$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " bytes")
    };
};
var $d80070c6e38fb8a3$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $d80070c6e38fb8a3$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " bytes")
    };
};
var $d80070c6e38fb8a3$export$1e1e1b6120329fe = {
    code: $d80070c6e38fb8a3$export$3271ef1d2dd155f9,
    message: 'Too many files'
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
function $d80070c6e38fb8a3$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === 'application/x-moz-file' || (0, $xqwKK.default)(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : $d80070c6e38fb8a3$export$bc0bbda045f09b5a(accept)
    ];
}
function $d80070c6e38fb8a3$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($d80070c6e38fb8a3$var$isDefined(file.size)) {
        if ($d80070c6e38fb8a3$var$isDefined(minSize) && $d80070c6e38fb8a3$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $d80070c6e38fb8a3$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $d80070c6e38fb8a3$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($d80070c6e38fb8a3$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $d80070c6e38fb8a3$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($d80070c6e38fb8a3$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $d80070c6e38fb8a3$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $d80070c6e38fb8a3$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $d80070c6e38fb8a3$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = $d80070c6e38fb8a3$export$b511db3632effe58(file, accept), _fileAccepted2 = $d80070c6e38fb8a3$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $d80070c6e38fb8a3$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $d80070c6e38fb8a3$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        return accepted && sizeMatch;
    });
} // React's synthetic events has event.isPropagationStopped,
function $d80070c6e38fb8a3$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === 'function') return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== 'undefined') return event.cancelBubble;
    return false;
}
function $d80070c6e38fb8a3$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === 'Files' || type === 'application/x-moz-file';
    });
}
function $d80070c6e38fb8a3$export$f9006bf02b243736(item) {
    return $d80070c6e38fb8a3$var$_typeof(item) === 'object' && item !== null && item.kind === 'file';
} // allow the entire document to be a drag target
function $d80070c6e38fb8a3$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $d80070c6e38fb8a3$var$isIe(userAgent) {
    return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}
function $d80070c6e38fb8a3$var$isEdge(userAgent) {
    return userAgent.indexOf('Edge/') !== -1;
}
function $d80070c6e38fb8a3$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $d80070c6e38fb8a3$var$isIe(userAgent) || $d80070c6e38fb8a3$var$isEdge(userAgent);
}
function $d80070c6e38fb8a3$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$d80070c6e38fb8a3$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $d80070c6e38fb8a3$export$8d6d6472146de265(event);
        });
    };
}

});
parcelRegister("xqwKK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0647a8f23d81e8a6$export$2e2bcd8739ae039; }, function (v) { return $0647a8f23d81e8a6$export$2e2bcd8739ae039 = v; });
var $0647a8f23d81e8a6$export$1e511d4a378977f5;
var $0647a8f23d81e8a6$export$2e2bcd8739ae039;
"use strict";
$0647a8f23d81e8a6$export$1e511d4a378977f5 = true;
$0647a8f23d81e8a6$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
        if (acceptedFilesArray.length === 0) return true;
        var fileName = file.name || '';
        var mimeType = (file.type || '').toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, '');
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === '.') return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith('/*')) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, '');
            return mimeType === validType;
        });
    }
    return true;
};

});





parcelRegister("9U1pE", function(module, exports) {

$parcel$export(module.exports, "ImageModal", function () { return (parcelRequire("dnN3u")).ImageModal; });
$parcel$export(module.exports, "InfoModal", function () { return (parcelRequire("lx8xh")).InfoModal; });
$parcel$export(module.exports, "DeleteImageModal", function () { return (parcelRequire("32O6s")).DeleteImageModal; });

var $dnN3u = parcelRequire("dnN3u");

var $lx8xh = parcelRequire("lx8xh");

var $32O6s = parcelRequire("32O6s");

});
parcelRegister("dnN3u", function(module, exports) {

$parcel$export(module.exports, "ImageModal", function () { return $9be379b2f70f4967$export$9e0b12df12385af6; });

var $df8fE = parcelRequire("df8fE");

var $a5EUy = parcelRequire("a5EUy");

var $3yJBl = parcelRequire("3yJBl");
parcelRequire("3XgLb");
var $ejDib = parcelRequire("ejDib");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("i7Pqi");
var $gDChL = parcelRequire("gDChL");
parcelRequire("hi8ts");
var $gJq8e = parcelRequire("gJq8e");

var $302dL = parcelRequire("302dL");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $cbxDY = parcelRequire("cbxDY");

var $l7nmB = parcelRequire("l7nmB");

var $jfKIU = parcelRequire("jfKIU");
const $9be379b2f70f4967$var$imageViewerImageStyle = (0, $1lyZZ.css)({
    height: 'auto',
    width: '100%',
    display: 'block'
});
const $9be379b2f70f4967$var$pdfViewerStyle = (0, $1lyZZ.css)({
    width: '100%',
    height: 'calc(100vh - 160px)',
    border: 'none',
    marginTop: '60px'
});
const $9be379b2f70f4967$var$imageViewerContainerStyle = (0, $1lyZZ.css)({
    maxWidth: 1200,
    position: 'relative',
    margin: '0 auto',
    padding: (0, $cbxDY.spacing).size4
});
const $9be379b2f70f4967$var$imageViewCloseButton = (0, $1lyZZ.css)({
    position: 'absolute',
    top: 30,
    right: 30,
    border: 'none',
    height: 40,
    width: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    cursor: 'pointer',
    zIndex: 1,
    backgroundColor: (0, $8JWbY.colors).neutralColors.slate10,
    '&:hover': {
        backgroundColor: (0, $8JWbY.colors).neutralColors.slate20
    }
});
const $9be379b2f70f4967$var$imageViewerCloseIconStyle = (0, $1lyZZ.css)({
    width: 16,
    height: 16
});
const $9be379b2f70f4967$var$spinnerWrapperStyle = ()=>(0, $1lyZZ.css)({
        position: 'absolute',
        zIndex: 1,
        left: 0,
        right: 0,
        top: '30%'
    });
const $9be379b2f70f4967$export$9e0b12df12385af6 = ({ imageId: imageId, closeImageModal: closeImageModal })=>{
    const fileCategory = (0, $l7nmB.getFileType)(imageId).category;
    const [isLoading, setIsLoading] = (0, $a5EUy.useState)(true);
    const [pdfUrl, setPdfUrl] = (0, $a5EUy.useState)(null);
    (0, $a5EUy.useEffect)(()=>{
        if (fileCategory === (0, $l7nmB.FileCategories).PDF && imageId) (0, $jfKIU.Storage).get(imageId, {
            level: 'public'
        }).then((url)=>{
            setPdfUrl(url);
            setIsLoading(false);
        }).catch(()=>{
            setIsLoading(false);
        });
    }, [
        imageId,
        fileCategory
    ]);
    const handleLoad = ()=>{
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $df8fE.jsx)((0, $gDChL.Overlay), {
        isOpen: true,
        onClick: closeImageModal,
        children: /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
            css: $9be379b2f70f4967$var$imageViewerContainerStyle,
            children: [
                /*#__PURE__*/ (0, $df8fE.jsx)("button", {
                    "data-transaction-name": "Close image modal",
                    "aria-label": "Close image modal",
                    css: $9be379b2f70f4967$var$imageViewCloseButton,
                    onClick: closeImageModal,
                    children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $gJq8e.Cross), {
                        css: $9be379b2f70f4967$var$imageViewerCloseIconStyle
                    })
                }),
                isLoading && /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                    css: $9be379b2f70f4967$var$spinnerWrapperStyle,
                    children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $302dL.Spinner), {})
                }),
                fileCategory === (0, $l7nmB.FileCategories).IMAGE && /*#__PURE__*/ (0, $df8fE.jsx)((0, $ejDib.S3Image), {
                    css: $9be379b2f70f4967$var$imageViewerImageStyle,
                    level: "public",
                    imgKey: imageId,
                    onLoad: handleLoad,
                    style: {
                        display: isLoading ? 'none' : 'block'
                    }
                }),
                fileCategory === (0, $l7nmB.FileCategories).PDF && /*#__PURE__*/ (0, $df8fE.jsx)("iframe", {
                    css: $9be379b2f70f4967$var$pdfViewerStyle,
                    src: pdfUrl,
                    title: "PDF Viewer",
                    onLoad: handleLoad,
                    style: {
                        display: isLoading ? 'none' : 'block'
                    }
                }),
                fileCategory === (0, $l7nmB.FileCategories).OTHER && /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                    children: "Unsuported file type."
                })
            ]
        })
    });
};
$9be379b2f70f4967$export$9e0b12df12385af6.propTypes = {
    imageId: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string.isRequired,
    closeImageModal: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func.isRequired
};

});
parcelRegister("3XgLb", function(module, exports) {
$parcel$export(module.exports, "S3Image", function () { return (parcelRequire("ejDib")).S3Image; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $5xGJg = parcelRequire("5xGJg");

var $c6cFz = parcelRequire("c6cFz");



parcelRequire("bYi6l");






(0, $5xGJg.I18n).putVocabularies((0, $c6cFz.dict));

});
parcelRegister("c6cFz", function(module, exports) {

$parcel$export(module.exports, "dict", function () { return $8cefdf75c20d607a$export$b7eef48498bbd53e; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $8cefdf75c20d607a$export$b7eef48498bbd53e = {
    de: {
        'Sign In': 'Anmelden',
        'Sign Up': 'Registrieren',
        'Sign Out': 'Abmelden',
        'Sign in to your account': 'Melden Sie sich mit Ihrem Account an',
        Username: 'Benutzername',
        Password: 'Passwort',
        'Enter your username': 'Geben Sie Ihren Benutzernamen ein',
        'Enter your password': 'Geben Sie Ihr Passwort ein',
        'No account? ': 'Kein Account? ',
        'Forgot your password? ': 'Passwort vergessen? ',
        'Reset password': "Passwort zur\xfccksetzen",
        'User does not exist': 'Dieser Benutzer existiert nicht',
        'User already exists': 'Dieser Benutzer existiert bereits',
        'Incorrect username or password': 'Falscher Benutzername oder falsches Passwort',
        'Invalid password format': "Ung\xfcltiges Passwort-Format",
        'Create account': 'Hier registrieren',
        'Forgot Password': 'Passwort vergessen',
        'Change Password': "Passwort \xe4ndern",
        'New Password': 'Neues Passwort',
        Email: 'Email',
        'Phone Number': 'Telefonnummer',
        'Confirm a Code': "Code best\xe4tigen",
        'Confirm Sign In': "Anmeldung best\xe4tigen",
        'Confirm Sign Up': "Registrierung best\xe4tigen",
        'Back to Sign In': "Zur\xfcck zur Anmeldung",
        'Send Code': 'Code senden',
        Confirm: "Best\xe4tigen",
        'Resend Code': 'Code erneut senden',
        Submit: 'Abschicken',
        Skip: "\xdcberspringen",
        Verify: 'Verifizieren',
        'Verify Contact': 'Kontakt verifizieren',
        Code: 'Code',
        'Confirmation Code': "Best\xe4tigungs-Code",
        'Lost your code? ': 'Code verloren? ',
        'Account recovery requires verified contact information': "Zur\xfccksetzen des Account ben\xf6tigt einen verifizierten Account",
        'Invalid phone number format': "Ung\u00FCltiges Telefonummern-Format.\n            Benutze eine Nummer im Format: +12345678900",
        'Create Account': 'Account erstellen',
        'Have an account? ': 'Schon registriert? ',
        'Sign in': 'Anmelden',
        'Create a new account': 'Erstelle einen neuen Account',
        'Reset your password': "Zur\xfccksetzen des Passworts",
        'An account with the given email already exists.': 'Ein Account mit dieser Email existiert bereits.',
        'Username cannot be empty': 'Benutzername darf nicht leer sein',
        'Password attempts exceeded': 'Die maximale Anzahl der fehlerhaften Anmeldeversuche wurde erreicht'
    },
    fr: {
        Hello: 'Bonjour',
        'Loading...': 'Chargement...',
        'Sign In': 'Se connecter',
        'Sign In with Amazon': 'Se connecter avec Amazon',
        'Sign In with Facebook': 'Se connecter avec Facebook',
        'Sign In with Google': 'Se connecter avec Google',
        'Sign in with AWS': 'Se connecter avec AWS',
        'Sign Up': "S'inscrire",
        'Sign Out': "D\xe9connexion",
        'Forgot Password': "Mot de passe oubli\xe9",
        Username: "Nom d'utilisateur",
        Password: 'Mot de passe',
        'Change Password': 'Modifier le mot de passe',
        Change: 'Modifier',
        'New Password': 'Nouveau mot de passe',
        Email: 'Email',
        'Phone Number': "Num\xe9ro de t\xe9l\xe9phone",
        'Confirm a Code': 'Confirmer un code',
        'Confirm Sign In': 'Confirmer la connexion',
        'Confirm Sign Up': "Confirmer l'inscription",
        'Back to Sign In': "Retour \xe0 la connexion",
        Send: 'Envoyer',
        'Send Code': "M'envoyer un code",
        Confirm: 'Confirmer',
        SMS: 'SMS',
        'Confirm SMS Code': 'Confirmer le code SMS',
        'Confirm TOTP Code': 'Confirmer le code TOTP',
        'Resend a Code': 'Renvoyer un code',
        Submit: 'Soumettre',
        Skip: 'Passer',
        Verify: "V\xe9rifier",
        'Verify Contact': "V\xe9rifier le contact",
        Code: 'Code',
        'Confirmation Code': 'Code de confirmation',
        'Account recovery requires verified contact information': "La r\xe9cup\xe9ration du compte n\xe9cessite des informations de contact v\xe9rifi\xe9es",
        'User does not exist': "L'utilisateur n'existe pas",
        'User already exists': "L'utilisateur existe d\xe9j\xe0",
        'Incorrect username or password': 'Identifiant ou mot de passe incorrect',
        'Invalid password format': 'Format de mot de passe invalide',
        'Invalid phone number format': "Format de num\u00E9ro de t\u00E9l\u00E9phone invalide. Veuillez utiliser un format +12345678900",
        'Username/client id combination not found.': "L'utilisateur n'existe pas",
        'Network error': "Erreur r\xe9seau",
        'Sign in to your account': "Connexion \xe0 votre compte",
        'Forgot your password? ': "Mot de passe oubli\xe9 ? ",
        'Reset password': "R\xe9initialisez votre mot de passe",
        'No account? ': 'Pas de compte ? ',
        'Create account': "Cr\xe9er un compte",
        'Create Account': "Cr\xe9er un compte",
        'Have an account? ': "D\xe9j\xe0 un compte ? ",
        'Sign in': 'Se connecter',
        'Create a new account': "Cr\xe9er un nouveau compte",
        'Reset your password': "R\xe9initialisez votre mot de passe",
        'Enter your username': "Saisissez votre nom d'utilisateur",
        'Enter your password': 'Saisissez votre mot de passe',
        'Enter your phone number': "Saisissez votre num\xe9ro de t\xe9l\xe9phone",
        'Enter your email': 'Saisissez votre adresse email',
        'Enter your code': 'Saisissez cotre code de confirmation',
        'Lost your code? ': 'Vous avez perdu votre code ? ',
        'Resend Code': 'Renvoyer le code',
        or: 'ou',
        'An account with the given email already exists.': "Un utilisateur avec cette adresse email existe d\xe9j\xe0.",
        'Username cannot be empty': "Le nom d'utilisateur doit \xeatre renseign\xe9"
    },
    es: {
        'Sign In': 'Registrarse',
        'Sign Up': "Reg\xedstrate",
        'Sign Out': 'Desconectar',
        'Forgot Password': "Se te olvid\xf3 tu contrase\xf1a",
        Username: 'Nombre de usuario',
        Password: "Contrase\xf1a",
        'Change Password': "Cambia la contrase\xf1a",
        'New Password': "Nueva contrase\xf1a",
        Email: 'Email',
        'Phone Number': "N\xfamero de tel\xe9fono",
        'Confirm a Code': "Confirmar un c\xf3digo",
        'Confirm Sign In': "Confirmar inicio de sesi\xf3n",
        'Confirm Sign Up': 'Confirmar Registrarse',
        'Back to Sign In': "Volver a Iniciar sesi\xf3n",
        'Send Code': "Enviar c\xf3digo",
        Confirm: 'Confirmar',
        'Resend a Code': "Reenviar un c\xf3digo",
        Submit: 'Enviar',
        Skip: 'Omitir',
        Verify: 'Verificar',
        'Verify Contact': 'Verificar contacto',
        Code: "C\xf3digo",
        'Account recovery requires verified contact information': "La recuperaci\xf3n de la cuenta requiere informaci\xf3n de contacto verificada",
        'User does not exist': 'el usuario no existe',
        'User already exists': 'El usuario ya existe',
        'Incorrect username or password': "Nombre de usuario o contrase\xf1a incorrecta",
        'Invalid password format': "Formato de contrase\xf1a inv\xe1lido",
        'Invalid phone number format': "Formato de n\u00FAmero de tel\u00E9fono inv\u00E1lido.\nUtilice el formato de n\u00FAmero de tel\u00E9fono +12345678900"
    },
    it: {
        'Account recovery requires verified contact information': 'Ripristino del conto richiede un account verificati',
        'An account with the given email already exists.': "Un account con questa email esiste gi\xe0.",
        'Back to Sign In': 'Torna alla Accesso',
        'Change Password': 'Cambia la password',
        Code: 'Codice',
        Confirm: 'Conferma',
        'Confirm Sign In': 'Conferma di applicazione',
        'Confirm Sign Up': 'Registrazione Conferma',
        'Confirm a Code': 'Codice Conferma',
        'Confirmation Code': 'Codice di verifica',
        'Create Account': 'Crea account',
        'Create a new account': 'Creare un nuovo account',
        'Create account': 'Registrati',
        Email: 'E-mail',
        'Enter your password': 'Inserire la password',
        'Enter your username': 'Inserisci il tuo nome utente',
        'Forgot your password?': 'Password dimenticata?',
        'Forgot Password': 'Password dimenticata',
        'Have an account? ': "Gi\xe0 registrato?",
        'Incorrect username or password': 'Nome utente o password errati',
        'Invalid password format': 'Formato della password non valido',
        'Invalid phone number format': 'Utilizzo non valido Telefonummern formattare un numero nel formato :. 12.345.678,9 mille',
        'Lost your code?': 'Perso codice?',
        'New Password': 'Nuova password',
        'No account? ': 'Nessun account?',
        Password: 'Password',
        'Password attempts exceeded': "Il numero massimo di tentativi di accesso falliti \xe8 stato raggiunto",
        'Phone Number': 'Numero di telefono',
        'Resend Code': 'Codice Rispedisci',
        'Reset password': 'Ripristina password',
        'Reset your password': 'Resetta password',
        'Send Code': 'Invia codice',
        'Sign In': 'Accesso',
        'Sign Out': 'Esci',
        'Sign Up': 'Iscriviti',
        'Sign in': 'Accesso',
        'Sign in to your account': 'Accedi con il tuo account a',
        Skip: 'Salta',
        Submit: 'Sottoscrivi',
        'User already exists': "Questo utente esiste gi\xe0",
        'User does not exist': 'Questo utente non esiste',
        Username: 'Nome utente',
        'Username cannot be empty': "Nome utente non pu\xf2 essere vuoto",
        Verify: 'Verifica',
        'Verify Contact': 'Contatto verifica'
    },
    zh: {
        'Sign In': "\u767B\u5F55",
        'Sign Up': "\u6CE8\u518C",
        'Sign Out': "\u9000\u51FA",
        'Forgot Password': "\u5FD8\u8BB0\u5BC6\u7801",
        Username: "\u7528\u6237\u540D",
        Password: "\u5BC6\u7801",
        'Change Password': "\u6539\u53D8\u5BC6\u7801",
        'New Password': "\u65B0\u5BC6\u7801",
        Email: "\u90AE\u7BB1",
        'Phone Number': "\u7535\u8BDD",
        'Confirm a Code': "\u786E\u8BA4\u7801",
        'Confirm Sign In': "\u786E\u8BA4\u767B\u5F55",
        'Confirm Sign Up': "\u786E\u8BA4\u6CE8\u518C",
        'Back to Sign In': "\u56DE\u5230\u767B\u5F55",
        'Send Code': "\u53D1\u9001\u786E\u8BA4\u7801",
        Confirm: "\u786E\u8BA4",
        'Resend a Code': "\u91CD\u53D1\u786E\u8BA4\u7801",
        Submit: "\u63D0\u4EA4",
        Skip: "\u8DF3\u8FC7",
        Verify: "\u9A8C\u8BC1",
        'Verify Contact': "\u9A8C\u8BC1\u8054\u7CFB\u65B9\u5F0F",
        Code: "\u786E\u8BA4\u7801",
        'Account recovery requires verified contact information': "\u8D26\u6237\u6062\u590D\u9700\u8981\u9A8C\u8BC1\u8FC7\u7684\u8054\u7CFB\u65B9\u5F0F",
        'User does not exist': "\u7528\u6237\u4E0D\u5B58\u5728",
        'User already exists': "\u7528\u6237\u5DF2\u7ECF\u5B58\u5728",
        'Incorrect username or password': "\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF",
        'Invalid password format': "\u5BC6\u7801\u683C\u5F0F\u9519\u8BEF",
        'Invalid phone number format': "\u7535\u8BDD\u683C\u5F0F\u9519\u8BEF\uFF0C\u8BF7\u4F7F\u7528\u683C\u5F0F +12345678900"
    },
    ja: {
        'Sign In': "\u30B5\u30A4\u30F3\u30A4\u30F3 ",
        'Sign Up': "\u767B\u9332 ",
        'Sign Out': "\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8 ",
        'Sign in to your account': "\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u30B5\u30A4\u30F3\u30A4\u30F3 ",
        Username: "\u30E6\u30FC\u30B6\u30FC\u540D ",
        Password: "\u30D1\u30B9\u30EF\u30FC\u30C9 ",
        'Enter your username': "\u30E6\u30FC\u30B6\u30FC\u540D\u3092\u5165\u529B ",
        'Enter your password': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B ",
        'No account? ': "\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u7121\u3044\u3068\u304D ",
        'Forgot your password? ': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u307E\u3057\u305F\u304B\uFF1F ",
        'Reset password': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8 ",
        'User does not exist': "\u30E6\u30FC\u30B6\u30FC\u304C\u5B58\u5728\u3057\u307E\u305B\u3093 ",
        'User already exists': "\u65E2\u306B\u30E6\u30FC\u30B6\u30FC\u304C\u5B58\u5728\u3057\u3066\u3044\u307E\u3059 ",
        'Incorrect username or password': "\u30E6\u30FC\u30B6\u30FC\u540D\u304B\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u7570\u306A\u308A\u307E\u3059 ",
        'Invalid password format': "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u5F62\u5F0F\u304C\u7121\u52B9\u3067\u3059 ",
        'Create account': "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B ",
        'Forgot Password': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u305F ",
        'Change Password': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u3048\u308B ",
        'New Password': "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9",
        Email: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
        'Phone Number': "\u96FB\u8A71\u756A\u53F7",
        'Confirm a Code': "\u30B3\u30FC\u30C9\u3092\u78BA\u8A8D",
        'Confirm Sign In': "\u30B5\u30A4\u30F3\u30A4\u30F3\u3059\u308B",
        'Confirm Sign Up': "\u767B\u9332\u3059\u308B",
        'Back to Sign In': "\u30B5\u30A4\u30F3\u30A4\u30F3\u306B\u623B\u308B",
        'Send Code': "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1",
        Confirm: "\u78BA\u5B9A",
        'Resend Code': "\u30B3\u30FC\u30C9\u3092\u518D\u9001\u4FE1",
        Submit: "\u9001\u4FE1",
        Skip: "\u30B9\u30AD\u30C3\u30D7",
        Verify: "\u78BA\u8A8D",
        'Verify Contact': "\u9023\u7D61\u5148\u3092\u78BA\u8A8D",
        Code: "\u30B3\u30FC\u30C9",
        'Confirmation Code': "\u78BA\u8A8D\u30B3\u30FC\u30C9",
        'Lost your code? ': "\u30B3\u30FC\u30C9\u3092\u5931\u304F\u3057\u307E\u3057\u305F\u304B\uFF1F",
        'Account recovery requires verified contact information': "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u5FA9\u65E7\u306B\u306F\u78BA\u8A8D\u6E08\u307F\u306E\u9023\u7D61\u5148\u304C\u5FC5\u8981\u3067\u3059",
        'Invalid phone number format': "\u4E0D\u6B63\u306A\u96FB\u8A71\u756A\u53F7\u306E\u5F62\u5F0F\u3067\u3059\u3002\n+12345678900 \u306E\u5F62\u5F0F\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        'Create Account': "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B",
        'Have an account? ': "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u6301\u3063\u3066\u3044\u307E\u3059\u304B\uFF1F",
        'Sign in': "\u30B5\u30A4\u30F3\u30A4\u30F3",
        'Create a new account': "\u65B0\u3057\u3044\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B",
        'Reset your password': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3059\u308B",
        'An account with the given email already exists.': "\u5165\u529B\u3055\u308C\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u65E2\u306B\u5B58\u5728\u3057\u307E\u3059",
        'Username cannot be empty': "\u30E6\u30FC\u30B6\u30FC\u540D\u306F\u5165\u529B\u5FC5\u9808\u3067\u3059",
        'Password attempts exceeded': "\u30B5\u30A4\u30F3\u30A4\u30F3\u306E\u8A66\u884C\u56DE\u6570\u304C\u4E0A\u9650\u306B\u9054\u3057\u307E\u3057\u305F",
        'Sign In with Google': "Google\u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
        'Sign In with Facebook': "Facebook\u3067\u30B5\u30A4\u30F3\u30A4\u30F3"
    }
};

});

parcelRegister("bYi6l", function(module, exports) {

$parcel$export(module.exports, "S3Image", function () { return (parcelRequire("ejDib")).S3Image; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $5lS2Y = parcelRequire("5lS2Y");

var $ejDib = parcelRequire("ejDib");


});
parcelRegister("5lS2Y", function(module, exports) {
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $a5EUy = parcelRequire("a5EUy");

var $l7cio = parcelRequire("l7cio");
var $7HFvj = parcelRequire("7HFvj");

var $jfKIU = parcelRequire("jfKIU");

var $5ELKA = parcelRequire("5ELKA");

var $iAT04 = parcelRequire("iAT04");

var $ejDib = parcelRequire("ejDib");

var $dybMW = parcelRequire("dybMW");
var $3e58d6881d987460$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3e58d6881d987460$var$logger = new (0, $l7cio.ConsoleLogger)('Storage.S3Album');
var $3e58d6881d987460$export$45095fab81dc21fc = /** @class */ function(_super) {
    $3e58d6881d987460$var$__extends(S3Album, _super);
    function S3Album(props) {
        var _this = _super.call(this, props) || this;
        _this._isMounted = false;
        _this.handlePick = _this.handlePick.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.list = _this.list.bind(_this);
        _this.marshal = _this.marshal.bind(_this);
        _this.state = {
            items: [],
            ts: new Date().getTime()
        };
        return _this;
    }
    S3Album.prototype.getKey = function(file) {
        var fileToKey = this.props.fileToKey;
        var name = file.name, size = file.size, type = file.type;
        var key = encodeURI(name);
        if (fileToKey) {
            var callback_type = typeof fileToKey;
            if (callback_type === 'string') key = fileToKey;
            else if (callback_type === 'function') key = fileToKey({
                name: name,
                size: size,
                type: type
            });
            else key = encodeURI(JSON.stringify(fileToKey));
            if (!key) {
                $3e58d6881d987460$var$logger.debug('key is empty');
                key = 'empty_key';
            }
        }
        return key.replace(/\s/g, '_');
    };
    S3Album.prototype.handlePick = function(data) {
        var _this = this;
        var _a = this.props, onPick = _a.onPick, onLoad = _a.onLoad, onError = _a.onError, track = _a.track, level = _a.level;
        if (onPick) onPick(data);
        var path = this.props.path || '';
        var file = data.file, name = data.name, size = data.size, type = data.type;
        var key = path + this.getKey(data);
        if (!(0, $jfKIU.Storage) || typeof (0, $jfKIU.Storage).put !== 'function') throw new Error('No Storage module found, please ensure @aws-amplify/storage is imported');
        (0, $jfKIU.Storage).put(key, file, {
            level: level ? level : 'public',
            contentType: type,
            track: track
        }).then(function(data) {
            $3e58d6881d987460$var$logger.debug('handle pick data', data);
            var items = _this.state.items;
            if (items.filter(function(item) {
                return item.key === key;
            }).length === 0) {
                var list = items.concat(data);
                _this.marshal(list);
            } else $3e58d6881d987460$var$logger.debug('update an item');
            if (onLoad) onLoad(data);
        }).catch(function(err) {
            $3e58d6881d987460$var$logger.debug('handle pick error', err);
            if (onError) onError(err);
        });
        if (this._isMounted) this.setState({
            ts: new Date().getTime()
        });
    };
    S3Album.prototype.handleClick = function(item) {
        var _a = this.props, onClickItem = _a.onClickItem, select = _a.select, onSelect = _a.onSelect;
        if (onClickItem) onClickItem(item);
        if (!select) return;
        item.selected = !item.selected;
        if (this._isMounted) this.setState({
            items: this.state.items.slice()
        });
        if (!onSelect) return;
        var selected_items = this.state.items.filter(function(item) {
            return item.selected;
        });
        onSelect(item, selected_items);
    };
    S3Album.prototype.componentDidMount = function() {
        this._isMounted = true;
        this.list();
    };
    S3Album.prototype.componentWillUnmount = function() {
        this._isMounted = false;
    };
    S3Album.prototype.componentDidUpdate = function(prevProps, prevState) {
        if (this.props.path === prevProps.path && this.props.ts === prevProps.ts && this.props.select === prevProps.select) return;
        if (!this.props.select) this.state.items.forEach(function(item) {
            return item.selected = false;
        });
        if (this.props.onSelect) this.props.onSelect(null, []);
        this.list();
    };
    S3Album.prototype.list = function() {
        var _this = this;
        var _a = this.props, path = _a.path, level = _a.level, track = _a.track, identityId = _a.identityId;
        $3e58d6881d987460$var$logger.debug('Album path: ' + path);
        if (!(0, $jfKIU.Storage) || typeof (0, $jfKIU.Storage).list !== 'function') throw new Error('No Storage module found, please ensure @aws-amplify/storage is imported');
        return (0, $jfKIU.Storage).list(path, {
            level: level ? level : 'public',
            track: track,
            identityId: identityId
        }).then(function(data) {
            $3e58d6881d987460$var$logger.debug('album list', data);
            _this.marshal(data);
        }).catch(function(err) {
            $3e58d6881d987460$var$logger.warn(err);
            return [];
        });
    };
    S3Album.prototype.contentType = function(item) {
        return (0, $7HFvj.filenameToContentType)(item.key, 'image/*');
    };
    S3Album.prototype.marshal = function(list) {
        var _this = this;
        var contentType = this.props.contentType || '';
        list.forEach(function(item) {
            if (item.contentType) return;
            var isString = typeof contentType === 'string';
            item.contentType = isString ? contentType : contentType(item);
            if (!item.contentType) item.contentType = _this.contentType(item);
        });
        var items = this.filter(list);
        items = this.sort(items);
        if (this._isMounted) this.setState({
            items: items
        });
    };
    S3Album.prototype.filter = function(list) {
        var filter = this.props.filter;
        return filter ? filter(list) : list;
    };
    S3Album.prototype.sort = function(list) {
        var sort = this.props.sort;
        var typeof_sort = typeof sort;
        if (typeof_sort === 'function') return sort(list);
        // @ts-ignore
        if ([
            'string',
            'undefined'
        ].includes(typeof_sort)) {
            var sort_str = sort ? sort : 'lastModified';
            var parts = sort_str.split(/\s+/);
            var field = parts[0];
            var dir = parts.length > 1 ? parts[1] : '';
            if (field === 'lastModified') dir = dir === 'asc' ? 'asc' : 'desc';
            else dir = dir === 'desc' ? 'desc' : 'asc';
            (0, $7HFvj.sortByField)(list, field, dir);
            return list;
        }
        $3e58d6881d987460$var$logger.warn('invalid sort. done nothing. should be a string or function');
        return list;
    };
    S3Album.prototype.render = function() {
        var _this = this;
        var _a = this.props, picker = _a.picker, translateItem = _a.translateItem, level = _a.level, identityId = _a.identityId;
        var _b = this.state, items = _b.items, ts = _b.ts;
        var pickerTitle = this.props.pickerTitle || 'Pick';
        var theme = this.props.theme || (0, $iAT04.default);
        var list = items.map(function(item) {
            var isText = item.contentType && (0, $7HFvj.isTextFile)(item.contentType);
            return isText ? $a5EUy.createElement((0, $dybMW.S3Text), {
                key: item.key,
                textKey: item.key,
                theme: theme,
                style: theme.albumText,
                selected: item.selected,
                translate: translateItem,
                level: level,
                identityId: identityId,
                onClick: function() {
                    return _this.handleClick(item);
                }
            }) : $a5EUy.createElement((0, $ejDib.S3Image), {
                key: item.key,
                imgKey: item.key,
                theme: theme,
                style: theme.albumPhoto,
                selected: item.selected,
                translate: translateItem,
                level: level,
                identityId: identityId,
                onClick: function() {
                    return _this.handleClick(item);
                }
            });
        });
        return $a5EUy.createElement("div", null, $a5EUy.createElement("div", {
            style: theme.album
        }, list), picker ? $a5EUy.createElement((0, $5ELKA.Picker), {
            key: ts,
            title: pickerTitle,
            accept: "image/*, text/*",
            onPick: this.handlePick,
            theme: theme
        }) : null);
    };
    return S3Album;
}($a5EUy.Component);
var /**
 * @deprecated use named import
 */ $3e58d6881d987460$export$2e2bcd8739ae039 = $3e58d6881d987460$export$45095fab81dc21fc;

});
parcelRegister("5ELKA", function(module, exports) {

$parcel$export(module.exports, "Picker", function () { return $41e5ba68f6c6734c$export$ba25329847403e11; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $a5EUy = parcelRequire("a5EUy");

var $l7cio = parcelRequire("l7cio");
var $5xGJg = parcelRequire("5xGJg");

var $kXxEu = parcelRequire("kXxEu");

var $iwzUF = parcelRequire("iwzUF");
var $41e5ba68f6c6734c$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $41e5ba68f6c6734c$var$PickerInput = {
    width: '100%',
    height: '100%',
    display: 'inline-block',
    position: 'absolute',
    left: 0,
    top: 0,
    opacity: 0,
    cursor: 'pointer'
};
var $41e5ba68f6c6734c$var$logger = new (0, $l7cio.ConsoleLogger)('Picker');
var $41e5ba68f6c6734c$export$ba25329847403e11 = /** @class */ function(_super) {
    $41e5ba68f6c6734c$var$__extends(Picker, _super);
    function Picker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Picker.prototype.handleInput = function(e) {
        var that = this;
        var file = e.target.files[0];
        if (!file) return;
        var name = file.name, size = file.size, type = file.type;
        $41e5ba68f6c6734c$var$logger.debug(file);
        var onPick = this.props.onPick;
        if (onPick) onPick({
            file: file,
            name: name,
            size: size,
            type: type
        });
    };
    Picker.prototype.render = function() {
        var _this = this;
        var title = this.props.title || 'Pick a File';
        var accept = this.props.accept || '*/*';
        var theme = this.props.theme || (0, $kXxEu.default);
        var pickerStyle = Object.assign({}, {
            position: 'relative'
        }, theme.pickerPicker);
        var inputStyle = Object.assign({}, $41e5ba68f6c6734c$var$PickerInput, theme.pickerInput);
        return $a5EUy.createElement("div", {
            style: pickerStyle
        }, $a5EUy.createElement((0, $iwzUF.PhotoPickerButton), {
            theme: theme
        }, (0, $5xGJg.I18n).get(title)), $a5EUy.createElement("input", {
            title: (0, $5xGJg.I18n).get(title),
            type: "file",
            accept: accept,
            style: inputStyle,
            onChange: function(e) {
                return _this.handleInput(e);
            }
        }));
    };
    return Picker;
}($a5EUy.Component);
var /**
 * @deprecated use named import
 */ $41e5ba68f6c6734c$export$2e2bcd8739ae039 = $41e5ba68f6c6734c$export$ba25329847403e11;

});
parcelRegister("kXxEu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4236bf17fc4a3f9$export$2e2bcd8739ae039; });
/*
 * Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $f4236bf17fc4a3f9$export$42a852a2b6b56249 = {};
var $f4236bf17fc4a3f9$export$f06621d9ad29af97 = {};
var $f4236bf17fc4a3f9$export$b5ff61ac8b0a660f = {};
var $f4236bf17fc4a3f9$export$56e87bf42978147a = {};
var $f4236bf17fc4a3f9$export$8adb256d999cd5a0 = {};
var $f4236bf17fc4a3f9$export$e7049d4e10b2bdab = {};
var $f4236bf17fc4a3f9$export$a8acabc71ea42c7b = {};
var $f4236bf17fc4a3f9$export$2db57ef01d117453 = {};
var $f4236bf17fc4a3f9$export$4ba18d57fa1c43bf = {};
var $f4236bf17fc4a3f9$export$f5b8910cec6cf069 = {};
var $f4236bf17fc4a3f9$export$353f5b6fc5456de1 = {};
var $f4236bf17fc4a3f9$export$aca09ff9e1db00bc = {};
var $f4236bf17fc4a3f9$export$6436834aeb5748e7 = {};
var $f4236bf17fc4a3f9$export$e4624626de9ce646 = {};
var $f4236bf17fc4a3f9$export$23087661e44b23b9 = {};
var $f4236bf17fc4a3f9$export$394d523ca5aad994 = {};
var $f4236bf17fc4a3f9$export$97176b8d51d2058f = {};
var $f4236bf17fc4a3f9$export$739e047b0f9d1090 = {};
var $f4236bf17fc4a3f9$export$549b91d6da945c97 = {};
var $f4236bf17fc4a3f9$export$b534bc812df080fd = {};
var $f4236bf17fc4a3f9$export$ebd11618f299a286 = {};
var $f4236bf17fc4a3f9$export$8d13340382210b65 = {};
var $f4236bf17fc4a3f9$export$d7b12c4107be0d61 = {};
var $f4236bf17fc4a3f9$export$b04be29aa201d4f5 = {};
var $f4236bf17fc4a3f9$export$76d3231fec538b73 = {};
var $f4236bf17fc4a3f9$export$fab7ef1f75f6339b = {};
var $f4236bf17fc4a3f9$export$ed60c62da1945f68 = {};
var $f4236bf17fc4a3f9$export$33f3f0a205996c11 = {};
var $f4236bf17fc4a3f9$export$9b7553f1599f739f = {};
var $f4236bf17fc4a3f9$export$8d8dc7d5f743331b = {};
var $f4236bf17fc4a3f9$export$ef8da11641c635de = {};
var $f4236bf17fc4a3f9$export$919d7ae8be750217 = {};
var $f4236bf17fc4a3f9$export$39140c7d8b0ba7b3 = {};
var $f4236bf17fc4a3f9$export$e3925dbaeffcc83f = {};
var $f4236bf17fc4a3f9$export$3b0a9d598f613fa = {};
var $f4236bf17fc4a3f9$var$AmplifyTheme = {
    container: $f4236bf17fc4a3f9$export$42a852a2b6b56249,
    formContainer: $f4236bf17fc4a3f9$export$f06621d9ad29af97,
    formSection: $f4236bf17fc4a3f9$export$b5ff61ac8b0a660f,
    formField: $f4236bf17fc4a3f9$export$56e87bf42978147a,
    sectionHeader: $f4236bf17fc4a3f9$export$8adb256d999cd5a0,
    sectionBody: $f4236bf17fc4a3f9$export$e7049d4e10b2bdab,
    sectionFooter: $f4236bf17fc4a3f9$export$a8acabc71ea42c7b,
    sectionFooterPrimaryContent: $f4236bf17fc4a3f9$export$2db57ef01d117453,
    sectionFooterSecondaryContent: $f4236bf17fc4a3f9$export$4ba18d57fa1c43bf,
    input: $f4236bf17fc4a3f9$export$f5b8910cec6cf069,
    button: $f4236bf17fc4a3f9$export$353f5b6fc5456de1,
    photoPickerButton: $f4236bf17fc4a3f9$export$aca09ff9e1db00bc,
    photoPlaceholder: $f4236bf17fc4a3f9$export$6436834aeb5748e7,
    signInButton: $f4236bf17fc4a3f9$export$e4624626de9ce646,
    signInButtonIcon: $f4236bf17fc4a3f9$export$23087661e44b23b9,
    signInButtonContent: $f4236bf17fc4a3f9$export$394d523ca5aad994,
    amazonSignInButton: $f4236bf17fc4a3f9$export$fab7ef1f75f6339b,
    facebookSignInButton: $f4236bf17fc4a3f9$export$ed60c62da1945f68,
    googleSignInButton: $f4236bf17fc4a3f9$export$33f3f0a205996c11,
    oAuthSignInButton: $f4236bf17fc4a3f9$export$9b7553f1599f739f,
    formRow: $f4236bf17fc4a3f9$export$b534bc812df080fd,
    strike: $f4236bf17fc4a3f9$export$97176b8d51d2058f,
    strikeContent: $f4236bf17fc4a3f9$export$739e047b0f9d1090,
    actionRow: $f4236bf17fc4a3f9$export$549b91d6da945c97,
    a: $f4236bf17fc4a3f9$export$ebd11618f299a286,
    hint: $f4236bf17fc4a3f9$export$8d13340382210b65,
    radio: $f4236bf17fc4a3f9$export$d7b12c4107be0d61,
    label: $f4236bf17fc4a3f9$export$b04be29aa201d4f5,
    inputLabel: $f4236bf17fc4a3f9$export$76d3231fec538b73,
    toast: $f4236bf17fc4a3f9$export$8d8dc7d5f743331b,
    navBar: $f4236bf17fc4a3f9$export$ef8da11641c635de,
    nav: $f4236bf17fc4a3f9$export$39140c7d8b0ba7b3,
    navRight: $f4236bf17fc4a3f9$export$919d7ae8be750217,
    navItem: $f4236bf17fc4a3f9$export$e3925dbaeffcc83f,
    navButton: $f4236bf17fc4a3f9$export$3b0a9d598f613fa
};
var $f4236bf17fc4a3f9$export$2e2bcd8739ae039 = $f4236bf17fc4a3f9$var$AmplifyTheme;

});

parcelRegister("iwzUF", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $d7c712bc1d0f8113$export$42a852a2b6b56249; });
$parcel$export(module.exports, "FormSection", function () { return $d7c712bc1d0f8113$export$b5ff61ac8b0a660f; });
$parcel$export(module.exports, "SectionHeader", function () { return $d7c712bc1d0f8113$export$8adb256d999cd5a0; });
$parcel$export(module.exports, "SectionFooter", function () { return $d7c712bc1d0f8113$export$a8acabc71ea42c7b; });
$parcel$export(module.exports, "SectionFooterPrimaryContent", function () { return $d7c712bc1d0f8113$export$2db57ef01d117453; });
$parcel$export(module.exports, "SectionFooterSecondaryContent", function () { return $d7c712bc1d0f8113$export$4ba18d57fa1c43bf; });
$parcel$export(module.exports, "SectionBody", function () { return $d7c712bc1d0f8113$export$e7049d4e10b2bdab; });
$parcel$export(module.exports, "Strike", function () { return $d7c712bc1d0f8113$export$97176b8d51d2058f; });
$parcel$export(module.exports, "RadioRow", function () { return $d7c712bc1d0f8113$export$a82e89996b85f9e6; });
$parcel$export(module.exports, "Input", function () { return $d7c712bc1d0f8113$export$f5b8910cec6cf069; });
$parcel$export(module.exports, "SelectInput", function () { return $d7c712bc1d0f8113$export$d6701e98ab1a6725; });
$parcel$export(module.exports, "FormField", function () { return $d7c712bc1d0f8113$export$56e87bf42978147a; });
$parcel$export(module.exports, "Button", function () { return $d7c712bc1d0f8113$export$353f5b6fc5456de1; });
$parcel$export(module.exports, "PhotoPickerButton", function () { return $d7c712bc1d0f8113$export$aca09ff9e1db00bc; });
$parcel$export(module.exports, "SignInButton", function () { return $d7c712bc1d0f8113$export$e4624626de9ce646; });
$parcel$export(module.exports, "SignInButtonIcon", function () { return $d7c712bc1d0f8113$export$23087661e44b23b9; });
$parcel$export(module.exports, "SignInButtonContent", function () { return $d7c712bc1d0f8113$export$394d523ca5aad994; });
$parcel$export(module.exports, "Link", function () { return $d7c712bc1d0f8113$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "Hint", function () { return $d7c712bc1d0f8113$export$8d13340382210b65; });
$parcel$export(module.exports, "InputLabel", function () { return $d7c712bc1d0f8113$export$76d3231fec538b73; });
$parcel$export(module.exports, "NavBar", function () { return $d7c712bc1d0f8113$export$ef8da11641c635de; });
$parcel$export(module.exports, "Nav", function () { return $d7c712bc1d0f8113$export$39140c7d8b0ba7b3; });
$parcel$export(module.exports, "NavRight", function () { return $d7c712bc1d0f8113$export$919d7ae8be750217; });
$parcel$export(module.exports, "NavItem", function () { return $d7c712bc1d0f8113$export$e3925dbaeffcc83f; });
$parcel$export(module.exports, "NavButton", function () { return $d7c712bc1d0f8113$export$3b0a9d598f613fa; });
$parcel$export(module.exports, "Toast", function () { return $d7c712bc1d0f8113$export$8d8dc7d5f743331b; });
$parcel$export(module.exports, "PhotoPlaceholder", function () { return $d7c712bc1d0f8113$export$6436834aeb5748e7; });

var $a5EUy = parcelRequire("a5EUy");

var $7HFvj = parcelRequire("7HFvj");

var $b46Jf = parcelRequire("b46Jf");

var $kXxEu = parcelRequire("kXxEu");
var $d7c712bc1d0f8113$var$__assign = undefined && undefined.__assign || function() {
    $d7c712bc1d0f8113$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d7c712bc1d0f8113$var$__assign.apply(this, arguments);
};
var $d7c712bc1d0f8113$export$42a852a2b6b56249 = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.container);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("div", $d7c712bc1d0f8113$var$__assign({}, p, {
        className: $b46Jf.container,
        style: style
    }), props.children));
};
var $d7c712bc1d0f8113$export$f06621d9ad29af97 = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("div", {
        className: $b46Jf.formContainer,
        style: theme.formContainer
    }, props.children));
};
var $d7c712bc1d0f8113$export$b5ff61ac8b0a660f = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.formSection);
    return $a5EUy.createElement($d7c712bc1d0f8113$export$f06621d9ad29af97, {
        theme: theme
    }, $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("div", {
        className: $b46Jf.formSection,
        style: style
    }, props.children)));
};
var $d7c712bc1d0f8113$export$8adb256d999cd5a0 = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.sectionHeader);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("div", $d7c712bc1d0f8113$var$__assign({}, p, {
        className: $b46Jf.sectionHeader,
        style: style
    }), $a5EUy.createElement($d7c712bc1d0f8113$export$3af67e6e31678076, {
        theme: theme
    }, props.children, props.hint && $a5EUy.createElement("div", {
        className: $b46Jf.sectionHeaderHint
    }, props.hint))));
};
var $d7c712bc1d0f8113$export$3af67e6e31678076 = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.sectionHeaderContent);
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("span", {
        className: $b46Jf.sectionHeaderContent,
        style: style
    }, props.children));
};
var $d7c712bc1d0f8113$export$a8acabc71ea42c7b = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.sectionFooter);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("div", $d7c712bc1d0f8113$var$__assign({}, p, {
        className: $b46Jf.sectionFooter,
        style: style
    }), props.children));
};
var $d7c712bc1d0f8113$export$2db57ef01d117453 = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.sectionFooterPrimaryContent);
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("span", {
        className: $b46Jf.sectionFooterPrimaryContent,
        style: style
    }, props.children));
};
var $d7c712bc1d0f8113$export$4ba18d57fa1c43bf = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.sectionFooterSecondaryContent);
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("span", {
        className: $b46Jf.sectionFooterSecondaryContent,
        style: style
    }, props.children));
};
var $d7c712bc1d0f8113$export$e7049d4e10b2bdab = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.sectionBody);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("div", $d7c712bc1d0f8113$var$__assign({}, p, {
        className: $b46Jf.sectionBody,
        style: style
    }), props.children));
};
var $d7c712bc1d0f8113$export$549b91d6da945c97 = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.actionRow);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("div", $d7c712bc1d0f8113$var$__assign({}, p, {
        className: "amplify-action-row",
        style: style
    }), props.children));
};
var $d7c712bc1d0f8113$export$97176b8d51d2058f = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.strike);
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("div", {
        className: $b46Jf.strike,
        style: style
    }, $a5EUy.createElement($d7c712bc1d0f8113$export$739e047b0f9d1090, {
        theme: theme
    }, props.children)));
};
var $d7c712bc1d0f8113$export$739e047b0f9d1090 = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("span", {
        className: $b46Jf.strikeContent,
        style: theme.strikeContent
    }, props.children));
};
var $d7c712bc1d0f8113$export$b534bc812df080fd = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.formRow);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("div", $d7c712bc1d0f8113$var$__assign({}, p, {
        className: $b46Jf.formRow,
        style: style
    }), props.children));
};
var $d7c712bc1d0f8113$export$a82e89996b85f9e6 = function(props) {
    var id = props.id || '_' + props.value;
    var theme = props.theme || (0, $kXxEu.default);
    return $a5EUy.createElement($d7c712bc1d0f8113$export$b534bc812df080fd, {
        theme: theme
    }, $a5EUy.createElement($d7c712bc1d0f8113$export$d7b12c4107be0d61, $d7c712bc1d0f8113$var$__assign({}, props, {
        id: id
    })), $a5EUy.createElement($d7c712bc1d0f8113$export$b04be29aa201d4f5, {
        htmlFor: id,
        theme: theme
    }, props.placeholder));
};
var $d7c712bc1d0f8113$export$d7b12c4107be0d61 = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.radio);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("input", $d7c712bc1d0f8113$var$__assign({}, p, {
        type: "radio",
        className: $b46Jf.radio,
        style: style
    })));
};
var $d7c712bc1d0f8113$export$2fe4f0576c8a371 = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.input);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $a5EUy.createElement($d7c712bc1d0f8113$export$b534bc812df080fd, {
        theme: theme
    }, $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("input", $d7c712bc1d0f8113$var$__assign({}, p, {
        className: $b46Jf.input,
        style: style
    }))));
};
var $d7c712bc1d0f8113$export$f5b8910cec6cf069 = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.input);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $a5EUy.createElement("input", $d7c712bc1d0f8113$var$__assign({}, p, {
        className: $b46Jf.input,
        style: style
    }));
};
var $d7c712bc1d0f8113$export$d6701e98ab1a6725 = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.selectInput);
    return $a5EUy.createElement("div", {
        className: $b46Jf.selectInput,
        style: style
    }, props.children);
};
var $d7c712bc1d0f8113$export$56e87bf42978147a = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.formField);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("div", $d7c712bc1d0f8113$var$__assign({}, p, {
        className: $b46Jf.formField,
        style: style
    }), props.children));
};
var $d7c712bc1d0f8113$export$353f5b6fc5456de1 = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.button);
    var disabled = props.disabled || false;
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("button", $d7c712bc1d0f8113$var$__assign({}, p, {
        className: $b46Jf.button,
        style: style,
        disabled: disabled
    }), props.children));
};
var $d7c712bc1d0f8113$export$aca09ff9e1db00bc = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.photoPickerButton);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $a5EUy.createElement("button", $d7c712bc1d0f8113$var$__assign({}, p, {
        className: [
            $b46Jf.photoPickerButton,
            $b46Jf.button
        ].join(' '),
        style: style
    }), props.children);
};
var $d7c712bc1d0f8113$export$e4624626de9ce646 = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var styles = Object.assign({}, theme.signInButton, theme[props.variant]);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("button", $d7c712bc1d0f8113$var$__assign({}, p, {
        className: $b46Jf.signInButton,
        style: styles
    }), props.children));
};
var $d7c712bc1d0f8113$export$23087661e44b23b9 = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.signInButtonIcon);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("span", $d7c712bc1d0f8113$var$__assign({}, p, {
        className: $b46Jf.signInButtonIcon,
        style: style
    }), props.children));
};
var $d7c712bc1d0f8113$export$394d523ca5aad994 = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.signInButtonContent);
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("span", {
        className: $b46Jf.signInButtonContent,
        style: style
    }, props.children));
};
var $d7c712bc1d0f8113$export$a6c7ac8248d6e38a = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.a);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("a", $d7c712bc1d0f8113$var$__assign({}, p, {
        className: $b46Jf.a,
        style: style
    }), props.children));
};
var $d7c712bc1d0f8113$export$b04be29aa201d4f5 = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.label);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("label", $d7c712bc1d0f8113$var$__assign({}, p, {
        className: $b46Jf.label,
        style: style
    }), props.children));
};
var $d7c712bc1d0f8113$export$8d13340382210b65 = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.hint);
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("div", {
        className: $b46Jf.hint,
        style: style
    }, props.children));
};
var $d7c712bc1d0f8113$export$76d3231fec538b73 = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.inputLabel);
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("div", {
        className: $b46Jf.inputLabel,
        style: style
    }, props.children));
};
var $d7c712bc1d0f8113$export$ef8da11641c635de = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.navBar);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("div", $d7c712bc1d0f8113$var$__assign({}, p, {
        className: $b46Jf.navBar,
        style: style
    }), props.children));
};
var $d7c712bc1d0f8113$export$39140c7d8b0ba7b3 = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.nav);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("div", $d7c712bc1d0f8113$var$__assign({}, p, {
        className: $b46Jf.nav,
        style: style
    }), props.children));
};
var $d7c712bc1d0f8113$export$919d7ae8be750217 = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.navRight);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("div", $d7c712bc1d0f8113$var$__assign({}, p, {
        className: $b46Jf.navRight,
        style: style
    }), props.children));
};
var $d7c712bc1d0f8113$export$e3925dbaeffcc83f = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.navItem);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("div", $d7c712bc1d0f8113$var$__assign({}, p, {
        className: $b46Jf.navItem,
        style: style
    }), props.children));
};
var $d7c712bc1d0f8113$export$3b0a9d598f613fa = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.navButton);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("button", $d7c712bc1d0f8113$var$__assign({}, p, {
        className: $b46Jf.button,
        style: style
    }), $d7c712bc1d0f8113$export$c730c7ea62823cdc($a5EUy.createElement("span", null, props.children))));
};
var $d7c712bc1d0f8113$export$8d8dc7d5f743331b = function(props) {
    var onClose = props.onClose;
    var theme = props.theme || (0, $kXxEu.default);
    return $a5EUy.createElement("div", $d7c712bc1d0f8113$var$__assign({}, props, {
        theme: theme,
        className: $b46Jf.toast,
        style: theme.toast
    }), $a5EUy.createElement("span", null, props.children), $a5EUy.createElement("a", {
        className: $b46Jf.toastClose,
        onClick: onClose
    }));
};
// @ts-ignore
$d7c712bc1d0f8113$export$8d8dc7d5f743331b.defaultProps = {
    onClose: function() {
        return void 0;
    }
};
var $d7c712bc1d0f8113$export$6436834aeb5748e7 = function(props) {
    var theme = props.theme || (0, $kXxEu.default);
    var style = $d7c712bc1d0f8113$export$3fef91f8d3f898a7(props, theme.photoPlaceholder);
    return $a5EUy.createElement("div", {
        className: $b46Jf.photoPlaceholder,
        style: style
    }, $a5EUy.createElement("div", {
        className: $b46Jf.photoPlaceholderIcon
    }, $a5EUy.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "64",
        height: "64",
        viewBox: "0 0 24 24"
    }, $a5EUy.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "3.2"
    }), $a5EUy.createElement("path", {
        d: "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
    }), $a5EUy.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }))));
};
var $d7c712bc1d0f8113$export$c730c7ea62823cdc = function(el) {
    var style = el.props.style || {};
    var before = style.before, after = style.after;
    if (!before && !after) return el;
    return $a5EUy.createElement("span", {
        style: {
            position: 'relative'
        }
    }, before ? $a5EUy.createElement("span", {
        style: before
    }, before.content) : null, el, after ? $a5EUy.createElement("span", {
        style: after
    }, after.content) : null);
};
var $d7c712bc1d0f8113$export$3fef91f8d3f898a7 = function(props, themeStyle) {
    var id = props.id, style = props.style;
    var styl = Object.assign({}, style, themeStyle);
    if (!id) return styl;
    var selector = '#' + id;
    Object.assign(styl, styl[selector]);
    return styl;
};

});


parcelRegister("iAT04", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d89640b178c71d36$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $d89640b178c71d36$export$42a852a2b6b56249 = {
    fontFamily: "-apple-system,\n                BlinkMacSystemFont,\n                \"Segoe UI\",\n                Roboto,\n                \"Helvetica Neue\",\n                Arial,\n                sans-serif,\n                \"Apple Color Emoji\",\n                \"Segoe UI Emoji\",\n                \"Segoe UI Symbol\"",
    fontWeight: '400',
    lineHeight: '1.5',
    color: '#212529',
    textAlign: 'left',
    paddingLeft: '15px',
    paddingRight: '15px'
};
var $d89640b178c71d36$export$ef8da11641c635de = {
    position: 'relative',
    border: '1px solid transparent',
    borderColor: '#e7e7e7'
};
var $d89640b178c71d36$export$919d7ae8be750217 = {
    textAlign: 'right'
};
var $d89640b178c71d36$export$39140c7d8b0ba7b3 = {
    margin: '7.5px'
};
var $d89640b178c71d36$export$e3925dbaeffcc83f = {
    display: 'inline-block',
    padding: '10px 5px',
    lineHeight: '20px'
};
var $d89640b178c71d36$export$3b0a9d598f613fa = {
    display: 'inline-block',
    padding: '6px 12px',
    marginTop: '8px',
    marginBottom: '8px',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '1.42857143',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    touchAction: 'manipulation',
    cursor: 'pointer',
    userSelect: 'none',
    backgroundImage: 'none',
    border: '1px solid transparent',
    borderRadius: '4px',
    color: '#333',
    backgroundColor: '#fff',
    borderColor: '#ccc'
};
var $d89640b178c71d36$export$f06621d9ad29af97 = {
    textAlign: 'center'
};
var $d89640b178c71d36$export$b5ff61ac8b0a660f = {
    marginBottom: '20px',
    backgroundColor: '#fff',
    border: '1px solid #ddd',
    borderRadius: '4px',
    textAlign: 'left',
    width: '400px',
    display: 'inline-block'
};
var $d89640b178c71d36$export$b0bceea2ea86179a = {
    marginBottom: '20px',
    color: '#fff',
    backgroundColor: '#f0ad4e',
    border: '1px solid #eea236',
    borderRadius: '4px',
    textAlign: 'left'
};
var $d89640b178c71d36$export$8adb256d999cd5a0 = {
    color: '#fff',
    backgroundColor: '#337ab7',
    borderColor: '#337ab7',
    padding: '10px 15px',
    borderBottom: '1px solid transparent',
    borderTopLeftRadius: '3px',
    borderTopRightRadius: '3px',
    textAlign: 'center'
};
var $d89640b178c71d36$export$a8acabc71ea42c7b = {
    color: '#333',
    backgroundColor: '#f5f5f5',
    padding: '10px 15px',
    borderTop: '1px solid #ddd',
    borderTopLeftRadius: '3px',
    borderTopRightRadius: '3px'
};
var $d89640b178c71d36$export$e7049d4e10b2bdab = {
    padding: '15px'
};
var $d89640b178c71d36$export$b534bc812df080fd = {
    marginBottom: '15px'
};
var $d89640b178c71d36$export$549b91d6da945c97 = {
    marginBottom: '15px'
};
var $d89640b178c71d36$export$f5b8910cec6cf069 = {
    display: 'block',
    width: '100%',
    height: '34px',
    padding: '6px 12px',
    fontSize: '14px',
    lineHeight: '1.42857143',
    color: '#555',
    backgroundColor: '#fff',
    backgroundImage: 'none',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxShadow: 'inset 0 1px 1px rgba(0,0,0,.075)',
    boxSizing: 'border-box',
    transition: 'border-color ease-in-out .15s,box-shadow ease-in-out .15s'
};
var $d89640b178c71d36$export$353f5b6fc5456de1 = {
    display: 'inline-block',
    padding: '6px 12px',
    marginBottom: '0',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '1.42857143',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    touchAction: 'manipulation',
    cursor: 'pointer',
    userSelect: 'none',
    backgroundImage: 'none',
    border: '1px solid transparent',
    borderRadius: '4px',
    color: '#333',
    backgroundColor: '#fff',
    borderColor: '#ccc'
};
var $d89640b178c71d36$export$e4624626de9ce646 = {
    position: 'relative',
    padding: '6px 12px 6px 44px',
    fontSize: '14px',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
    width: '100%',
    marginTop: '2px',
    '#google_signin_btn': {
        color: '#fff',
        backgroundColor: '#dd4b39',
        borderColor: 'rgba(0,0,0,0.2)'
    },
    '#facebook_signin_btn': {
        color: '#fff',
        backgroundColor: '#3b5998',
        borderColor: 'rgba(0,0,0,0.2)'
    }
};
var $d89640b178c71d36$export$eef1e68107c58ef2 = {
    display: 'inline-block',
    width: '20px'
};
var $d89640b178c71d36$export$ebd11618f299a286 = {
    color: '#007bff',
    cursor: 'pointer'
};
var $d89640b178c71d36$export$bba54bd7e8a0d398 = {
    overflow: 'auto',
    fontFamily: "Menlo,\n                Monaco,\n                Consolas,\n                \"Courier New\",\n                monospace",
    display: 'block',
    padding: '9.5px',
    margin: '0 0 10px',
    fontSize: '13px',
    lineHeight: '1.42857143',
    color: '#333',
    wordBreak: 'break-all',
    wordWrap: 'break-word',
    backgroundColor: '#f5f5f5',
    border: '1px solid #ccc',
    borderRadius: '4px'
};
var $d89640b178c71d36$export$4f22f48eb31142b4 = {
    display: 'inline-block',
    width: '8.33333333%'
};
var $d89640b178c71d36$export$91e0dcaa1775f500 = {
    display: 'inline-block',
    width: '16.66666667%'
};
var $d89640b178c71d36$export$74947a8e25d4c355 = {
    display: 'inline-block',
    width: '25%'
};
var $d89640b178c71d36$export$3f1319121e89c6e2 = {
    display: 'inline-block',
    width: '33.33333333%'
};
var $d89640b178c71d36$export$6eda199a9225028b = {
    display: 'inline-block',
    width: '41.66666667%'
};
var $d89640b178c71d36$export$f09604f8c820321f = {
    display: 'inline-block',
    width: '50%'
};
var $d89640b178c71d36$export$48878381c2fa2cad = {
    display: 'inline-block',
    width: '58.33333333%'
};
var $d89640b178c71d36$export$d1a6c81260d13f5 = {
    display: 'inline-block',
    width: '66.66666667%'
};
var $d89640b178c71d36$export$6b5338870615cec6 = {
    display: 'inline-block',
    width: '75%'
};
var $d89640b178c71d36$export$dfe03fd20cdc8e46 = {
    display: 'inline-block',
    width: '83.33333333%'
};
var $d89640b178c71d36$export$93e2edefce39c88c = {
    display: 'inline-block',
    width: '91.66666667%'
};
var $d89640b178c71d36$export$a48df6afa5564db7 = {
    display: 'inline-block',
    width: '100%'
};
var $d89640b178c71d36$export$8dc98ba7eadeaa56 = {
    display: 'none'
};
var $d89640b178c71d36$export$f6a06b563a614935 = {
    container: $d89640b178c71d36$export$42a852a2b6b56249,
    navBar: $d89640b178c71d36$export$ef8da11641c635de,
    nav: $d89640b178c71d36$export$39140c7d8b0ba7b3,
    navRight: $d89640b178c71d36$export$919d7ae8be750217,
    navItem: $d89640b178c71d36$export$e3925dbaeffcc83f,
    navButton: $d89640b178c71d36$export$3b0a9d598f613fa,
    formContainer: $d89640b178c71d36$export$f06621d9ad29af97,
    formSection: $d89640b178c71d36$export$b5ff61ac8b0a660f,
    errorSection: $d89640b178c71d36$export$b0bceea2ea86179a,
    sectionHeader: $d89640b178c71d36$export$8adb256d999cd5a0,
    sectionBody: $d89640b178c71d36$export$e7049d4e10b2bdab,
    sectionFooter: $d89640b178c71d36$export$a8acabc71ea42c7b,
    formRow: $d89640b178c71d36$export$b534bc812df080fd,
    actionRow: $d89640b178c71d36$export$549b91d6da945c97,
    space: $d89640b178c71d36$export$eef1e68107c58ef2,
    signInButton: $d89640b178c71d36$export$e4624626de9ce646,
    input: $d89640b178c71d36$export$f5b8910cec6cf069,
    button: $d89640b178c71d36$export$353f5b6fc5456de1,
    a: $d89640b178c71d36$export$ebd11618f299a286,
    pre: $d89640b178c71d36$export$bba54bd7e8a0d398,
    col1: $d89640b178c71d36$export$4f22f48eb31142b4,
    col2: $d89640b178c71d36$export$91e0dcaa1775f500,
    col3: $d89640b178c71d36$export$74947a8e25d4c355,
    col4: $d89640b178c71d36$export$3f1319121e89c6e2,
    col5: $d89640b178c71d36$export$6eda199a9225028b,
    col6: $d89640b178c71d36$export$f09604f8c820321f,
    col7: $d89640b178c71d36$export$48878381c2fa2cad,
    col8: $d89640b178c71d36$export$d1a6c81260d13f5,
    col9: $d89640b178c71d36$export$6b5338870615cec6,
    col10: $d89640b178c71d36$export$dfe03fd20cdc8e46,
    col11: $d89640b178c71d36$export$93e2edefce39c88c,
    col12: $d89640b178c71d36$export$a48df6afa5564db7,
    hidden: $d89640b178c71d36$export$8dc98ba7eadeaa56
};
var /**
 * @deprecated use named import
 */ $d89640b178c71d36$export$2e2bcd8739ae039 = $d89640b178c71d36$export$f6a06b563a614935;

});

parcelRegister("ejDib", function(module, exports) {

$parcel$export(module.exports, "S3Image", function () { return $a6c151a59f27bc79$export$6400234c4a9a250; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $a5EUy = parcelRequire("a5EUy");

var $l7cio = parcelRequire("l7cio");

var $jfKIU = parcelRequire("jfKIU");

var $iAT04 = parcelRequire("iAT04");

var $2EnBH = parcelRequire("2EnBH");

var $2ZawB = parcelRequire("2ZawB");

var $duDwp = parcelRequire("duDwp");
var $a6c151a59f27bc79$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a6c151a59f27bc79$var$logger = new (0, $l7cio.ConsoleLogger)('Storage.S3Image');
var $a6c151a59f27bc79$export$6400234c4a9a250 = /** @class */ function(_super) {
    $a6c151a59f27bc79$var$__extends(S3Image, _super);
    function S3Image(props) {
        var _this = _super.call(this, props) || this;
        _this._isMounted = false;
        _this.handleOnLoad = _this.handleOnLoad.bind(_this);
        _this.handleOnError = _this.handleOnError.bind(_this);
        _this.handlePick = _this.handlePick.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        var initSrc = _this.props.src || (0, $2EnBH.transparent1X1);
        _this.state = {
            src: initSrc
        };
        return _this;
    }
    S3Image.prototype.getImageSource = function(key, level, track, identityId) {
        var _this = this;
        if (!(0, $jfKIU.Storage) || typeof (0, $jfKIU.Storage).get !== 'function') throw new Error('No Storage module found, please ensure @aws-amplify/storage is imported');
        (0, $jfKIU.Storage).get(key, {
            level: level ? level : 'public',
            track: track,
            identityId: identityId
        }).then(function(url) {
            if (_this._isMounted) _this.setState({
                src: url
            });
        }).catch(function(err) {
            return $a6c151a59f27bc79$var$logger.debug(err);
        });
    };
    S3Image.prototype.load = function() {
        var _a = this.props, imgKey = _a.imgKey, path = _a.path, body = _a.body, contentType = _a.contentType, level = _a.level, track = _a.track, identityId = _a.identityId;
        if (!imgKey && !path) {
            $a6c151a59f27bc79$var$logger.debug('empty imgKey and path');
            return;
        }
        var that = this;
        var key = imgKey || path;
        $a6c151a59f27bc79$var$logger.debug('loading ' + key + '...');
        if (body) {
            var type = contentType || 'binary/octet-stream';
            if (!(0, $jfKIU.Storage) || typeof (0, $jfKIU.Storage).put !== 'function') throw new Error('No Storage module found, please ensure @aws-amplify/storage is imported');
            var ret = (0, $jfKIU.Storage).put(key, body, {
                contentType: type,
                level: level ? level : 'public',
                track: track
            });
            ret.then(function(data) {
                $a6c151a59f27bc79$var$logger.debug(data);
                that.getImageSource(key, level, track, identityId);
            }).catch(function(err) {
                return $a6c151a59f27bc79$var$logger.debug(err);
            });
        } else that.getImageSource(key, level, track, identityId);
    };
    S3Image.prototype.handleOnLoad = function(evt) {
        var onLoad = this.props.onLoad;
        if (onLoad) onLoad(this.state.src);
    };
    S3Image.prototype.handleOnError = function(evt) {
        var onError = this.props.onError;
        if (onError) onError(this.state.src);
    };
    S3Image.prototype.handlePick = function(data) {
        var that = this;
        var _a = this.props, imgKey = _a.imgKey, level = _a.level, fileToKey = _a.fileToKey, track = _a.track, identityId = _a.identityId, _b = _a.path, path = _b === void 0 ? '' : _b, onUploadSuccess = _a.onUploadSuccess;
        var file = data.file, type = data.type;
        var key = imgKey || path + (0, $duDwp.calcKey)(data, fileToKey);
        if (!(0, $jfKIU.Storage) || typeof (0, $jfKIU.Storage).put !== 'function') throw new Error('No Storage module found, please ensure @aws-amplify/storage is imported');
        (0, $jfKIU.Storage).put(key, file, {
            level: level ? level : 'public',
            contentType: type,
            track: track
        }).then(function(data) {
            $a6c151a59f27bc79$var$logger.debug('handle pick data', data);
            that.getImageSource(key, level, track, identityId);
            if (onUploadSuccess) onUploadSuccess();
        }).catch(function(err) {
            return $a6c151a59f27bc79$var$logger.debug('handle pick error', err);
        });
    };
    S3Image.prototype.handleClick = function(evt) {
        var onClick = this.props.onClick;
        if (onClick) onClick(evt);
    };
    S3Image.prototype.componentDidMount = function() {
        this._isMounted = true;
        this.load();
    };
    S3Image.prototype.componentWillUnmount = function() {
        this._isMounted = false;
    };
    S3Image.prototype.componentDidUpdate = function(prevProps) {
        var update = prevProps.path !== this.props.path || prevProps.imgKey !== this.props.imgKey || prevProps.body !== this.props.body || prevProps.level !== this.props.level;
        if (update) this.load();
    };
    S3Image.prototype.imageEl = function(src, theme) {
        if (!src) return null;
        var _a = this.props, className = _a.className, selected = _a.selected;
        var containerStyle = {
            position: 'relative'
        };
        return $a5EUy.createElement("div", {
            style: containerStyle,
            onClick: this.handleClick
        }, $a5EUy.createElement("img", {
            className: className,
            style: theme.photoImg,
            src: src,
            onLoad: this.handleOnLoad,
            onError: this.handleOnError
        }), $a5EUy.createElement("div", {
            style: selected ? theme.overlaySelected : theme.overlay
        }));
    };
    S3Image.prototype.render = function() {
        var _a = this.props, hidden = _a.hidden, style = _a.style, picker = _a.picker, translate = _a.translate, imgKey = _a.imgKey;
        var src = this.state.src;
        if (translate) src = typeof translate === 'string' ? translate : translate({
            type: 'image',
            key: imgKey,
            content: src
        });
        if (!src && !picker) return null;
        var theme = this.props.theme || (0, $iAT04.default);
        var photoStyle = hidden ? (0, $iAT04.default).hidden : Object.assign({}, theme.photo, style);
        return $a5EUy.createElement("div", {
            style: photoStyle
        }, photoStyle ? this.imageEl(src, theme) : null, picker ? $a5EUy.createElement("div", null, $a5EUy.createElement((0, $2ZawB.PhotoPicker), {
            key: "picker",
            onPick: this.handlePick,
            theme: theme
        })) : null);
    };
    return S3Image;
}($a5EUy.Component);
var /**
 * @deprecated use named import
 */ $a6c151a59f27bc79$export$2e2bcd8739ae039 = $a6c151a59f27bc79$export$6400234c4a9a250;

});
parcelRegister("2EnBH", function(module, exports) {

$parcel$export(module.exports, "transparent1X1", function () { return $1ee1a114716302bf$export$f1e6604bf31fa1a6; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $a5EUy = parcelRequire("a5EUy");

var $7HFvj = parcelRequire("7HFvj");

var $iAT04 = parcelRequire("iAT04");
var $1ee1a114716302bf$var$__assign = undefined && undefined.__assign || function() {
    $1ee1a114716302bf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1ee1a114716302bf$var$__assign.apply(this, arguments);
};
var $1ee1a114716302bf$export$42a852a2b6b56249 = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.container);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("div", $1ee1a114716302bf$var$__assign({}, p, {
        className: "amplify-container",
        style: style
    }), props.children));
};
var $1ee1a114716302bf$export$f06621d9ad29af97 = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.formContainer);
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("div", {
        className: "amplify-form-container",
        style: style
    }, props.children));
};
var $1ee1a114716302bf$export$b5ff61ac8b0a660f = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.formSection);
    return $a5EUy.createElement($1ee1a114716302bf$export$f06621d9ad29af97, {
        theme: theme
    }, $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("div", {
        className: "amplify-form-section",
        style: style
    }, props.children)));
};
var $1ee1a114716302bf$export$b0bceea2ea86179a = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.errorSection);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("div", $1ee1a114716302bf$var$__assign({}, p, {
        className: "amplify-error-section",
        style: style
    }), $a5EUy.createElement($1ee1a114716302bf$export$b51bd3844c500926, null, props.children)));
};
var $1ee1a114716302bf$export$b51bd3844c500926 = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.errorSectionContent);
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("span", {
        className: "amplify-error-section-content",
        style: style
    }, props.children));
};
var $1ee1a114716302bf$export$8adb256d999cd5a0 = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.sectionHeader);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("div", $1ee1a114716302bf$var$__assign({}, p, {
        className: "amplify-section-header",
        style: style
    }), $a5EUy.createElement($1ee1a114716302bf$export$3af67e6e31678076, {
        theme: theme
    }, props.children)));
};
var $1ee1a114716302bf$export$3af67e6e31678076 = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.sectionHeaderContent);
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("span", {
        className: "amplify-section-header-content",
        style: style
    }, props.children));
};
var $1ee1a114716302bf$export$a8acabc71ea42c7b = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.sectionFooter);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("div", $1ee1a114716302bf$var$__assign({}, p, {
        className: "amplify-section-footer",
        style: style
    }), $a5EUy.createElement($1ee1a114716302bf$export$8b3ad764eca5990d, {
        theme: theme
    }, props.children)));
};
var $1ee1a114716302bf$export$8b3ad764eca5990d = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.sectionFooterContent);
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("span", {
        className: "amplify-section-footer-content",
        style: style
    }, props.children));
};
var $1ee1a114716302bf$export$e7049d4e10b2bdab = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.sectionBody);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("div", $1ee1a114716302bf$var$__assign({}, p, {
        className: "amplify-section-body",
        style: style
    }), props.children));
};
var $1ee1a114716302bf$export$549b91d6da945c97 = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.actionRow);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("div", $1ee1a114716302bf$var$__assign({}, p, {
        className: "amplify-action-row",
        style: style
    }), props.children));
};
var $1ee1a114716302bf$export$b534bc812df080fd = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.formRow);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("div", $1ee1a114716302bf$var$__assign({}, p, {
        className: "amplify-form-row",
        style: style
    }), props.children));
};
var $1ee1a114716302bf$export$2fe4f0576c8a371 = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.input);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $a5EUy.createElement($1ee1a114716302bf$export$b534bc812df080fd, {
        theme: theme
    }, $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("input", $1ee1a114716302bf$var$__assign({}, p, {
        className: "amplify-input",
        style: style
    }))));
};
var $1ee1a114716302bf$export$a82e89996b85f9e6 = function(props) {
    var id = props.id || '_' + props.value;
    var theme = props.theme || (0, $iAT04.default);
    return $a5EUy.createElement($1ee1a114716302bf$export$b534bc812df080fd, {
        theme: theme
    }, $a5EUy.createElement($1ee1a114716302bf$export$d7b12c4107be0d61, $1ee1a114716302bf$var$__assign({}, props, {
        id: id
    })), $a5EUy.createElement($1ee1a114716302bf$export$b04be29aa201d4f5, {
        htmlFor: id,
        theme: theme
    }, props.placeholder));
};
var $1ee1a114716302bf$export$d7b12c4107be0d61 = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.radio);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("input", $1ee1a114716302bf$var$__assign({}, p, {
        type: "radio",
        className: "amplify-radio",
        style: style
    })));
};
var $1ee1a114716302bf$export$90573f604378c4e2 = function(props) {
    var id = props.id || '_' + props.name;
    var theme = props.theme || (0, $iAT04.default);
    return $a5EUy.createElement($1ee1a114716302bf$export$b534bc812df080fd, {
        theme: theme
    }, $a5EUy.createElement($1ee1a114716302bf$export$48513f6b9f8ce62d, $1ee1a114716302bf$var$__assign({}, props, {
        id: id
    })), $a5EUy.createElement($1ee1a114716302bf$export$b04be29aa201d4f5, {
        htmlFor: id,
        theme: theme
    }, props.placeholder));
};
var $1ee1a114716302bf$export$48513f6b9f8ce62d = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.checkbox);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("input", $1ee1a114716302bf$var$__assign({}, p, {
        type: "checkbox",
        className: "amplify-checkbox",
        style: style
    })));
};
var $1ee1a114716302bf$export$101e8bcd2ede0b61 = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    return $a5EUy.createElement($1ee1a114716302bf$export$b534bc812df080fd, {
        theme: theme
    }, $a5EUy.createElement($1ee1a114716302bf$export$2e323b58d6467594, {
        theme: theme
    }, props.children));
};
var $1ee1a114716302bf$export$2e323b58d6467594 = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("span", {
        className: "amplify-message-content",
        style: theme.messageContent
    }, props.children));
};
var $1ee1a114716302bf$export$564cbe3426fc093a = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("div", {
        className: "amplify-action-row",
        style: theme.actionRow
    }, $a5EUy.createElement($1ee1a114716302bf$export$353f5b6fc5456de1, $1ee1a114716302bf$var$__assign({}, props))));
};
var $1ee1a114716302bf$export$353f5b6fc5456de1 = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.button);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("button", $1ee1a114716302bf$var$__assign({}, p, {
        className: "amplify-button",
        style: style
    }), $a5EUy.createElement($1ee1a114716302bf$export$260bb228dedc7e4f, {
        theme: theme
    }, props.children)));
};
var $1ee1a114716302bf$export$260bb228dedc7e4f = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("span", {
        className: "amplify-button-content",
        style: theme.buttonContent
    }, props.children));
};
var $1ee1a114716302bf$export$e4624626de9ce646 = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.signInButton);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("button", $1ee1a114716302bf$var$__assign({}, p, {
        className: "amplify-signin-button",
        style: style
    }), props.children));
};
var $1ee1a114716302bf$export$a6c7ac8248d6e38a = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.a);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("a", $1ee1a114716302bf$var$__assign({}, p, {
        className: "amplify-a",
        style: style
    }), props.children));
};
var $1ee1a114716302bf$export$b04be29aa201d4f5 = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.label);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("label", $1ee1a114716302bf$var$__assign({}, p, {
        className: "amplify-label",
        style: style
    }), props.children));
};
var $1ee1a114716302bf$export$eef1e68107c58ef2 = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.space);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("span", $1ee1a114716302bf$var$__assign({}, p, {
        className: "amplify-space",
        style: style
    }), props.children));
};
var $1ee1a114716302bf$export$ef8da11641c635de = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.navBar);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("div", $1ee1a114716302bf$var$__assign({}, p, {
        className: "amplify-nav-bar",
        style: style
    }), props.children));
};
var $1ee1a114716302bf$export$39140c7d8b0ba7b3 = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.nav);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("div", $1ee1a114716302bf$var$__assign({}, p, {
        className: "amplify-nav",
        style: style
    }), props.children));
};
var $1ee1a114716302bf$export$919d7ae8be750217 = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.navRight);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("div", $1ee1a114716302bf$var$__assign({}, p, {
        className: "amplify-nav-right",
        style: style
    }), props.children));
};
var $1ee1a114716302bf$export$e3925dbaeffcc83f = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.navItem);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("div", $1ee1a114716302bf$var$__assign({}, p, {
        className: "amplify-nav-item",
        style: style
    }), props.children));
};
var $1ee1a114716302bf$export$3b0a9d598f613fa = function(props) {
    var theme = props.theme || (0, $iAT04.default);
    var style = $1ee1a114716302bf$export$3fef91f8d3f898a7(props, theme.navButton);
    var p = (0, $7HFvj.objectLessAttributes)(props, 'theme');
    return $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("button", $1ee1a114716302bf$var$__assign({}, p, {
        className: "amplify-nav-button",
        style: style
    }), $1ee1a114716302bf$export$c730c7ea62823cdc($a5EUy.createElement("span", {
        style: theme.navButtonContent
    }, props.children))));
};
var $1ee1a114716302bf$export$c730c7ea62823cdc = function(el) {
    var style = el.props.style || {};
    var before = style.before, after = style.after;
    if (!before && !after) return el;
    return $a5EUy.createElement("span", {
        style: {
            position: 'relative'
        }
    }, before ? $a5EUy.createElement("span", {
        style: before
    }, before.content) : null, el, after ? $a5EUy.createElement("span", {
        style: after
    }, after.content) : null);
};
var $1ee1a114716302bf$export$3fef91f8d3f898a7 = function(props, themeStyle) {
    var id = props.id, style = props.style;
    var styl = Object.assign({}, style, themeStyle);
    if (!id) return styl;
    var selector = '#' + id;
    Object.assign(styl, styl[selector]);
    return styl;
};
var $1ee1a114716302bf$export$f1e6604bf31fa1a6 = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
var $1ee1a114716302bf$export$b810853147c3ffeb = 'data:image/gif;base64,R0lGODlhAQABAIAAAP7//wAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';

});

parcelRegister("2ZawB", function(module, exports) {

$parcel$export(module.exports, "PhotoPicker", function () { return $22c97149b4051de7$export$3384892c047819d2; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $a5EUy = parcelRequire("a5EUy");

var $l7cio = parcelRequire("l7cio");
var $5xGJg = parcelRequire("5xGJg");

var $5ELKA = parcelRequire("5ELKA");

var $kXxEu = parcelRequire("kXxEu");

var $iwzUF = parcelRequire("iwzUF");
var $22c97149b4051de7$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $22c97149b4051de7$var$PickerPreview = {
    maxWidth: '100%'
};
var $22c97149b4051de7$var$logger = new (0, $l7cio.ConsoleLogger)('PhotoPicker');
var $22c97149b4051de7$export$3384892c047819d2 = /** @class */ function(_super) {
    $22c97149b4051de7$var$__extends(PhotoPicker, _super);
    function PhotoPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.handlePick = _this.handlePick.bind(_this);
        _this.state = {
            previewSrc: props.previewSrc
        };
        return _this;
    }
    PhotoPicker.prototype.handlePick = function(data) {
        var that = this;
        var file = data.file, name = data.name, size = data.size, type = data.type;
        var _a = this.props, preview = _a.preview, onPick = _a.onPick, onLoad = _a.onLoad;
        if (onPick) onPick(data);
        if (preview) {
            var reader = new FileReader();
            reader.onload = function(e) {
                var url = e.target.result;
                // @ts-ignore
                that.setState({
                    previewSrc: url
                });
                if (onLoad) onLoad(url);
            };
            reader.readAsDataURL(file);
        }
    };
    PhotoPicker.prototype.render = function() {
        var preview = this.props.preview;
        var previewSrc = this.state.previewSrc;
        var headerText = this.props.headerText || 'Photos';
        var headerHint = this.props.headerHint || 'Add your photos by clicking below';
        var title = this.props.title || 'Select a Photo';
        var theme = this.props.theme || (0, $kXxEu.default);
        var previewStyle = Object.assign({}, $22c97149b4051de7$var$PickerPreview, theme.pickerPreview);
        var previewHidden = !(preview && preview !== 'hidden');
        return $a5EUy.createElement((0, $iwzUF.FormSection), {
            theme: theme
        }, $a5EUy.createElement((0, $iwzUF.SectionHeader), {
            theme: theme,
            hint: headerHint
        }, (0, $5xGJg.I18n).get(headerText)), $a5EUy.createElement((0, $iwzUF.SectionBody), {
            theme: theme
        }, previewSrc ? previewHidden ? 'The image has been selected' : $a5EUy.createElement("img", {
            src: previewSrc,
            style: previewStyle
        }) : $a5EUy.createElement((0, $iwzUF.PhotoPlaceholder), {
            theme: theme
        })), $a5EUy.createElement((0, $5ELKA.Picker), {
            title: title,
            accept: "image/*",
            theme: theme,
            onPick: this.handlePick
        }));
    };
    return PhotoPicker;
}($a5EUy.Component);
var /**
 * @deprecated use named import
 */ $22c97149b4051de7$export$2e2bcd8739ae039 = $22c97149b4051de7$export$3384892c047819d2;

});

parcelRegister("duDwp", function(module, exports) {

$parcel$export(module.exports, "calcKey", function () { return $9d2cbbe391e952a3$export$5346f70488f1cd2; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ function $9d2cbbe391e952a3$export$5346f70488f1cd2(file, fileToKey) {
    var name = file.name, size = file.size, type = file.type;
    var key = encodeURI(name);
    if (fileToKey) {
        var callback_type = typeof fileToKey;
        if (callback_type === 'string') key = fileToKey;
        else if (callback_type === 'function') key = fileToKey({
            name: name,
            size: size,
            type: type
        });
        else key = encodeURI(JSON.stringify(fileToKey));
        if (!key) key = 'empty_key';
    }
    return key.replace(/\s/g, '_');
}

});


parcelRegister("dybMW", function(module, exports) {

$parcel$export(module.exports, "S3Text", function () { return $9dd79841e68109fb$export$1006e13b82d657a0; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $a5EUy = parcelRequire("a5EUy");

var $l7cio = parcelRequire("l7cio");

var $jfKIU = parcelRequire("jfKIU");

var $iAT04 = parcelRequire("iAT04");

var $dScTh = parcelRequire("dScTh");

var $duDwp = parcelRequire("duDwp");
var $9dd79841e68109fb$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9dd79841e68109fb$var$logger = new (0, $l7cio.ConsoleLogger)('Storage.S3Text');
var $9dd79841e68109fb$export$1006e13b82d657a0 = /** @class */ function(_super) {
    $9dd79841e68109fb$var$__extends(S3Text, _super);
    function S3Text(props) {
        var _this = _super.call(this, props) || this;
        _this._isMounted = false;
        _this.handleOnLoad = _this.handleOnLoad.bind(_this);
        _this.handleOnError = _this.handleOnError.bind(_this);
        _this.handlePick = _this.handlePick.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        var text = props.text, textKey = props.textKey;
        _this.state = {
            text: text || '',
            textKey: textKey || ''
        };
        return _this;
    }
    S3Text.prototype.getText = function(key, level, track, identityId) {
        var _this = this;
        if (!(0, $jfKIU.Storage) || typeof (0, $jfKIU.Storage).get !== 'function') throw new Error('No Storage module found, please ensure @aws-amplify/storage is imported');
        (0, $jfKIU.Storage).get(key, {
            download: true,
            level: level ? level : 'public',
            track: track,
            identityId: identityId
        }).then(function(data) {
            $9dd79841e68109fb$var$logger.debug(data);
            // @ts-ignore
            var text = data.Body.toString('utf8');
            if (_this._isMounted) _this.setState({
                text: text
            });
            _this.handleOnLoad(text);
        }).catch(function(err) {
            $9dd79841e68109fb$var$logger.debug(err);
            _this.handleOnError(err);
        });
    };
    S3Text.prototype.load = function() {
        var _a = this.props, path = _a.path, textKey = _a.textKey, body = _a.body, contentType = _a.contentType, level = _a.level, track = _a.track, identityId = _a.identityId;
        if (!textKey && !path) {
            $9dd79841e68109fb$var$logger.debug('empty textKey and path');
            return;
        }
        var that = this;
        var key = textKey || path;
        $9dd79841e68109fb$var$logger.debug('loading ' + key + '...');
        if (body) {
            var type = contentType || 'text/*';
            if (!(0, $jfKIU.Storage) || typeof (0, $jfKIU.Storage).put !== 'function') throw new Error('No Storage module found, please ensure @aws-amplify/storage is imported');
            var ret = (0, $jfKIU.Storage).put(key, body, {
                contentType: type,
                level: level ? level : 'public',
                track: track
            });
            ret.then(function(data) {
                $9dd79841e68109fb$var$logger.debug(data);
                that.getText(key, level, track, identityId);
            }).catch(function(err) {
                return $9dd79841e68109fb$var$logger.debug(err);
            });
        } else that.getText(key, level, track, identityId);
    };
    S3Text.prototype.handleOnLoad = function(text) {
        var onLoad = this.props.onLoad;
        if (onLoad) onLoad(text);
    };
    S3Text.prototype.handleOnError = function(err) {
        var onError = this.props.onError;
        if (onError) onError(err);
    };
    S3Text.prototype.handlePick = function(data) {
        var that = this;
        var path = this.props.path || '';
        var _a = this.props, textKey = _a.textKey, level = _a.level, fileToKey = _a.fileToKey, track = _a.track, identityId = _a.identityId;
        var file = data.file, name = data.name, size = data.size, type = data.type;
        var key = textKey || path + (0, $duDwp.calcKey)(data, fileToKey);
        if (!(0, $jfKIU.Storage) || typeof (0, $jfKIU.Storage).put !== 'function') throw new Error('No Storage module found, please ensure @aws-amplify/storage is imported');
        (0, $jfKIU.Storage).put(key, file, {
            level: level ? level : 'public',
            contentType: type,
            track: track
        }).then(function(data) {
            $9dd79841e68109fb$var$logger.debug('handle pick data', data);
            that.getText(key, level, track, identityId);
        }).catch(function(err) {
            return $9dd79841e68109fb$var$logger.debug('handle pick error', err);
        });
    };
    S3Text.prototype.handleClick = function(evt) {
        var onClick = this.props.onClick;
        if (onClick) onClick(evt);
    };
    S3Text.prototype.componentDidMount = function() {
        this._isMounted = true;
        this.load();
    };
    S3Text.prototype.componentWillUnmount = function() {
        this._isMounted = false;
    };
    S3Text.prototype.componentDidUpdate = function(prevProps) {
        var update = prevProps.path !== this.props.path || prevProps.textKey !== this.props.textKey || prevProps.body !== this.props.body;
        if (update) this.load();
    };
    S3Text.prototype.textEl = function(text, theme) {
        if (!text) return null;
        var selected = this.props.selected;
        var containerStyle = {
            position: 'relative'
        };
        return $a5EUy.createElement("div", {
            style: containerStyle,
            onClick: this.handleClick
        }, $a5EUy.createElement("pre", {
            style: theme.pre
        }, text), $a5EUy.createElement("div", {
            style: selected ? theme.overlaySelected : theme.overlay
        }));
    };
    S3Text.prototype.render = function() {
        var _a = this.props, hidden = _a.hidden, style = _a.style, picker = _a.picker, translate = _a.translate, textKey = _a.textKey;
        var text = this.state.text;
        if (translate) text = typeof translate === 'string' ? translate : translate({
            type: 'text',
            key: textKey,
            content: text
        });
        if (!text && !picker) return null;
        var theme = this.props.theme || (0, $iAT04.default);
        var textStyle = hidden ? (0, $iAT04.default).hidden : Object.assign({}, theme.text, style);
        return $a5EUy.createElement("div", {
            style: textStyle
        }, textStyle ? this.textEl(text, theme) : null, picker ? $a5EUy.createElement("div", null, $a5EUy.createElement((0, $dScTh.TextPicker), {
            key: "picker",
            onPick: this.handlePick,
            theme: theme
        })) : null);
    };
    return S3Text;
}($a5EUy.Component);
var /**
 * @deprecated use named import
 */ $9dd79841e68109fb$export$2e2bcd8739ae039 = $9dd79841e68109fb$export$1006e13b82d657a0;

});
parcelRegister("dScTh", function(module, exports) {

$parcel$export(module.exports, "TextPicker", function () { return $a19a514fb91ee1da$export$9300848523b4e1ae; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $a5EUy = parcelRequire("a5EUy");

var $l7cio = parcelRequire("l7cio");

var $iAT04 = parcelRequire("iAT04");

var $5ELKA = parcelRequire("5ELKA");
var $a19a514fb91ee1da$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a19a514fb91ee1da$var$Container = {};
var $a19a514fb91ee1da$var$PickerPreview = {
    maxWidth: '100%'
};
var $a19a514fb91ee1da$var$logger = new (0, $l7cio.ConsoleLogger)('TextPicker');
var $a19a514fb91ee1da$export$9300848523b4e1ae = /** @class */ function(_super) {
    $a19a514fb91ee1da$var$__extends(TextPicker, _super);
    function TextPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.handlePick = _this.handlePick.bind(_this);
        _this.state = {
            previewText: props.previewText
        };
        return _this;
    }
    TextPicker.prototype.handlePick = function(data) {
        var that = this;
        var file = data.file, name = data.name, size = data.size, type = data.type;
        var _a = this.props, preview = _a.preview, onPick = _a.onPick, onLoad = _a.onLoad;
        if (onPick) onPick(data);
        if (preview) {
            var reader = new FileReader();
            reader.onload = function(e) {
                var text = e.target.result;
                // @ts-ignore
                that.setState({
                    previewText: text
                });
                if (onLoad) onLoad(text);
            };
            reader.readAsText(file);
        }
    };
    TextPicker.prototype.render = function() {
        var preview = this.props.preview;
        var previewText = this.state.previewText;
        var title = this.props.title || 'Pick a File';
        var theme = this.props.theme || (0, $iAT04.default);
        var containerStyle = Object.assign({}, $a19a514fb91ee1da$var$Container, theme.picker);
        var previewStyle = Object.assign({}, $a19a514fb91ee1da$var$PickerPreview, theme.pickerPreview, theme.halfHeight, preview && preview !== 'hidden' ? {} : (0, $iAT04.default).hidden);
        return $a5EUy.createElement("div", {
            style: containerStyle
        }, previewText ? $a5EUy.createElement("div", {
            style: previewStyle
        }, $a5EUy.createElement("pre", {
            style: theme.pre
        }, previewText)) : null, $a5EUy.createElement((0, $5ELKA.Picker), {
            title: title,
            accept: "text/*",
            theme: theme,
            onPick: this.handlePick
        }));
    };
    return TextPicker;
}($a5EUy.Component);
var /**
 * @deprecated use named import
 */ $a19a514fb91ee1da$export$2e2bcd8739ae039 = $a19a514fb91ee1da$export$9300848523b4e1ae;

});





parcelRegister("l7nmB", function(module, exports) {

$parcel$export(module.exports, "FileCategories", function () { return $f5fc5ff4414b3010$export$647511e89ebff2a7; });
$parcel$export(module.exports, "getFileType", function () { return $f5fc5ff4414b3010$export$284e6e76ba5e79b9; });
/**
 * @typedef {'image' | 'pdf' | 'other'} FileCategory
 */ /**
 * Defines the possible file categories.
 * @enum {FileCategory}
 */ const $f5fc5ff4414b3010$export$647511e89ebff2a7 = {
    IMAGE: 'image',
    PDF: 'pdf',
    OTHER: 'other'
};
function $f5fc5ff4414b3010$export$284e6e76ba5e79b9(filename) {
    const lastDotIndex = filename.lastIndexOf('.');
    const ext = lastDotIndex === -1 || lastDotIndex === 0 ? '' : filename.substring(lastDotIndex + 1).toLowerCase();
    const imageExtensions = {
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        png: 'image/png',
        gif: 'image/gif',
        svg: 'image/svg+xml',
        webp: 'image/webp',
        bmp: 'image/bmp',
        ico: 'image/vnd.microsoft.icon',
        tif: 'image/tiff',
        tiff: 'image/tiff'
    };
    if (ext in imageExtensions) return {
        mimeType: imageExtensions[ext],
        category: $f5fc5ff4414b3010$export$647511e89ebff2a7.IMAGE
    };
    if (ext === 'pdf') return {
        mimeType: 'application/pdf',
        category: $f5fc5ff4414b3010$export$647511e89ebff2a7.PDF
    };
    // Generic fallback
    const mimeType = 'application/octet-stream';
    return {
        mimeType: mimeType,
        category: $f5fc5ff4414b3010$export$647511e89ebff2a7.OTHER
    };
}

});


parcelRegister("lx8xh", function(module, exports) {

$parcel$export(module.exports, "InfoModal", function () { return $fad34d0feca28c00$export$4994368e0bfca573; });

var $df8fE = parcelRequire("df8fE");

var $3yJBl = parcelRequire("3yJBl");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("i7Pqi");
var $9BPY2 = parcelRequire("9BPY2");
var $gDChL = parcelRequire("gDChL");
parcelRequire("1OfTO");
var $cbxDY = parcelRequire("cbxDY");
const $fad34d0feca28c00$var$bodyText = (0, $1lyZZ.css)({
    marginTop: (0, $cbxDY.spacing).size6,
    '& > p': {
        marginBottom: (0, $cbxDY.spacing).size4
    }
});
const $fad34d0feca28c00$export$4994368e0bfca573 = ({ header: header, body: body, closeInfoModal: closeInfoModal })=>/*#__PURE__*/ (0, $df8fE.jsx)((0, $gDChL.Overlay), {
        isOpen: true,
        onClick: closeInfoModal,
        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $9BPY2.Modal), {
            heading: /*#__PURE__*/ (0, $df8fE.jsx)((0, $9BPY2.Modal).Heading, {
                children: header
            }),
            body: /*#__PURE__*/ (0, $df8fE.jsx)((0, $9BPY2.Modal).Body, {
                children: /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                    css: $fad34d0feca28c00$var$bodyText,
                    dangerouslySetInnerHTML: {
                        __html: body
                    }
                })
            }),
            status: "information",
            exitClickHandler: closeInfoModal
        })
    });
$fad34d0feca28c00$export$4994368e0bfca573.propTypes = {
    header: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string.isRequired,
    body: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string.isRequired,
    closeInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func.isRequired
};

});

parcelRegister("32O6s", function(module, exports) {

$parcel$export(module.exports, "DeleteImageModal", function () { return $23786c702c5c053f$export$17bd6d70df17bc40; });

var $df8fE = parcelRequire("df8fE");

var $3yJBl = parcelRequire("3yJBl");
parcelRequire("i7Pqi");
var $gdpIa = parcelRequire("gdpIa");
var $9BPY2 = parcelRequire("9BPY2");
var $gDChL = parcelRequire("gDChL");
parcelRequire("hi8ts");
var $7PgDK = parcelRequire("7PgDK");

var $cRlsu = parcelRequire("cRlsu");
const $23786c702c5c053f$export$17bd6d70df17bc40 = ({ imageId: imageId, closeDeleteImageModal: closeDeleteImageModal, deleteImageHandler: deleteImageHandler })=>{
    const { labels: { svy_cancel_button: svy_cancel_button, svy_delete_button: svy_delete_button, svy_delete_image_confirmation_modal_header: svy_delete_image_confirmation_modal_header, svy_delete_image_confirmation_modal_body: svy_delete_image_confirmation_modal_body } } = (0, $cRlsu.useLabels)();
    return /*#__PURE__*/ (0, $df8fE.jsx)((0, $gDChL.Overlay), {
        isOpen: true,
        onClick: closeDeleteImageModal,
        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $9BPY2.Modal), {
            status: "error",
            icon: /*#__PURE__*/ (0, $df8fE.jsx)((0, $7PgDK.Delete), {}),
            heading: /*#__PURE__*/ (0, $df8fE.jsx)((0, $9BPY2.Modal).Heading, {
                children: svy_delete_image_confirmation_modal_header
            }),
            body: /*#__PURE__*/ (0, $df8fE.jsx)((0, $9BPY2.Modal).Body, {
                children: svy_delete_image_confirmation_modal_body
            }),
            action: /*#__PURE__*/ (0, $df8fE.jsxs)((0, $9BPY2.Modal).Action, {
                children: [
                    /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                        "data-transaction-name": "Confirm delete image",
                        "aria-label": "Confirm delete image button",
                        label: svy_delete_button,
                        onClick: ()=>deleteImageHandler(imageId)
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                        "data-transaction-name": "Cancel delete image",
                        label: svy_cancel_button,
                        variant: "outline",
                        onClick: closeDeleteImageModal
                    })
                ]
            }),
            exitClickHandler: closeDeleteImageModal
        })
    });
};
$23786c702c5c053f$export$17bd6d70df17bc40.propTypes = {
    imageId: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string.isRequired,
    closeDeleteImageModal: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func.isRequired,
    deleteImageHandler: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func.isRequired
};

});


parcelRegister("j8IpY", function(module, exports) {

$parcel$export(module.exports, "UploadedImageThumbnailList", function () { return $def1382aacde71d5$export$96b9b7524c25c919; });

var $df8fE = parcelRequire("df8fE");

var $3yJBl = parcelRequire("3yJBl");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("1OfTO");
var $cbxDY = parcelRequire("cbxDY");

var $rKclq = parcelRequire("rKclq");

var $l7nmB = parcelRequire("l7nmB");
const $def1382aacde71d5$var$listWrapperStyle = (0, $1lyZZ.css)({
    marginTop: (0, $cbxDY.spacing).size4,
    display: 'flex'
});
const $def1382aacde71d5$export$96b9b7524c25c919 = ({ uploadImageKeys: uploadImageKeys, imageClickHandler: imageClickHandler, imageDeleteClickHandler: imageDeleteClickHandler = ()=>{}, isEditable: isEditable = true })=>/*#__PURE__*/ (0, $df8fE.jsx)("div", {
        css: $def1382aacde71d5$var$listWrapperStyle,
        children: uploadImageKeys.map((imageId)=>/*#__PURE__*/ (0, $df8fE.jsx)((0, $rKclq.UploadedImageThumbnail), {
                imageId: imageId,
                isEditable: isEditable,
                fileCategory: (0, $l7nmB.getFileType)(imageId).category,
                imageClickHandler: ()=>imageClickHandler(imageId),
                imageDeleteClickHandler: ()=>imageDeleteClickHandler(imageId)
            }, imageId))
    });
$def1382aacde71d5$export$96b9b7524c25c919.propTypes = {
    uploadImageKeys: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string).isRequired,
    imageClickHandler: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func.isRequired,
    imageDeleteClickHandler: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func,
    fileCategory: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).oneOf(Object.values((0, $l7nmB.FileCategories))),
    isEditable: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool
};

});
parcelRegister("rKclq", function(module, exports) {

$parcel$export(module.exports, "UploadedImageThumbnail", function () { return $05365bb66903702f$export$94984c14ad3e5368; });

var $df8fE = parcelRequire("df8fE");

var $3yJBl = parcelRequire("3yJBl");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("3XgLb");
var $ejDib = parcelRequire("ejDib");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $cbxDY = parcelRequire("cbxDY");
parcelRequire("i7Pqi");
var $gdpIa = parcelRequire("gdpIa");
parcelRequire("hi8ts");
var $7PgDK = parcelRequire("7PgDK");
var $h4u5Z = parcelRequire("h4u5Z");
var $gZ892 = parcelRequire("gZ892");

var $l7nmB = parcelRequire("l7nmB");
const $05365bb66903702f$var$uploadImageExpandOverlayStyle = (0, $1lyZZ.css)({
    display: 'none',
    position: 'absolute',
    background: (0, $8JWbY.colors).neutralColors.white,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    opacity: 0.8
});
const $05365bb66903702f$var$uploadImageContainerStyle = (0, $1lyZZ.css)({
    backgroundColor: (0, $8JWbY.colors).neutralColors.slate10,
    position: 'relative',
    borderRadius: 4,
    overflow: 'hidden'
});
const $05365bb66903702f$var$uploadImageExpandIcon = (0, $1lyZZ.css)({
    color: (0, $8JWbY.colors).neutralColors.slate50,
    width: 22,
    height: 22
});
const $05365bb66903702f$var$uploadImageWrapperStyle = (0, $1lyZZ.css)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginRight: (0, $cbxDY.spacing).size4,
    '&:last-child': {
        marginRight: 0
    }
});
const $05365bb66903702f$var$uploadImageStyle = {
    display: 'block',
    width: 77,
    height: 50,
    cursor: 'pointer',
    borderRadius: 4,
    objectFit: 'contain'
};
const $05365bb66903702f$export$94984c14ad3e5368 = ({ imageId: imageId, imageClickHandler: imageClickHandler, imageDeleteClickHandler: imageDeleteClickHandler, fileCategory: fileCategory, isEditable: isEditable = true })=>/*#__PURE__*/ (0, $df8fE.jsxs)("div", {
        css: $05365bb66903702f$var$uploadImageWrapperStyle,
        children: [
            /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                css: $05365bb66903702f$var$uploadImageContainerStyle,
                onClick: imageClickHandler,
                children: [
                    /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                        css: $05365bb66903702f$var$uploadImageExpandOverlayStyle,
                        "data-css": "hover-overlay",
                        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $h4u5Z.ExpandBold), {
                            css: $05365bb66903702f$var$uploadImageExpandIcon
                        })
                    }),
                    fileCategory === (0, $l7nmB.FileCategories).IMAGE && /*#__PURE__*/ (0, $df8fE.jsx)((0, $ejDib.S3Image), {
                        css: $05365bb66903702f$var$uploadImageStyle,
                        level: "public",
                        imgKey: imageId
                    }),
                    (fileCategory === (0, $l7nmB.FileCategories).PDF || fileCategory === (0, $l7nmB.FileCategories).OTHER) && /*#__PURE__*/ (0, $df8fE.jsx)((0, $gZ892.FilesPdf), {
                        css: {
                            padding: 10,
                            ...$05365bb66903702f$var$uploadImageStyle
                        }
                    })
                ]
            }),
            isEditable && /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                "data-transaction-name": "Delete image",
                "aria-label": "Delete image bin icon button",
                icon: /*#__PURE__*/ (0, $df8fE.jsx)((0, $7PgDK.Delete), {}),
                variant: "ghost",
                onClick: imageDeleteClickHandler
            })
        ]
    });
$05365bb66903702f$export$94984c14ad3e5368.propTypes = {
    imageId: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string.isRequired,
    imageClickHandler: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func.isRequired,
    imageDeleteClickHandler: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func,
    fileCategory: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).oneOf(Object.values((0, $l7nmB.FileCategories))),
    isEditable: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool
};

});


parcelRegister("jkzLx", function(module, exports) {

$parcel$export(module.exports, "QuestionDescription", function () { return $e12ba0ee3af77753$export$7c0a16af240a6114; });

var $df8fE = parcelRequire("df8fE");

var $a5EUy = parcelRequire("a5EUy");

var $3yJBl = parcelRequire("3yJBl");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("1OfTO");
var $jahGf = parcelRequire("jahGf");
var $cbxDY = parcelRequire("cbxDY");
const $e12ba0ee3af77753$var$explanationFieldStyle = (0, $1lyZZ.css)({
    whiteSpace: 'pre-wrap',
    fontSize: (0, $jahGf.font).size.size1,
    fontWeight: (0, $jahGf.font).weight.medium,
    marginTop: (0, $cbxDY.spacing).size1,
    marginBottom: (0, $cbxDY.spacing).size4
});
const $e12ba0ee3af77753$var$conditionFieldStyle = (0, $1lyZZ.css)({
    fontSize: (0, $jahGf.font).size.size05,
    whiteSpace: 'pre-wrap'
});
const $e12ba0ee3af77753$export$7c0a16af240a6114 = ({ explanation: explanation, conditions: conditions })=>/*#__PURE__*/ (0, $df8fE.jsxs)((0, $a5EUy.Fragment), {
        children: [
            explanation && /*#__PURE__*/ (0, $df8fE.jsx)("p", {
                css: $e12ba0ee3af77753$var$explanationFieldStyle,
                children: explanation
            }),
            conditions && /*#__PURE__*/ (0, $df8fE.jsx)("p", {
                css: $e12ba0ee3af77753$var$conditionFieldStyle,
                children: conditions
            })
        ]
    });
$e12ba0ee3af77753$export$7c0a16af240a6114.propTypes = {
    explanation: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string,
    conditions: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string
};

});


parcelRegister("jFBuu", function(module, exports) {

$parcel$export(module.exports, "useFetchImagesFromS3", function () { return $e51eed86df811c93$export$7eed34e4e2038bc2; });

var $a5EUy = parcelRequire("a5EUy");

var $jfKIU = parcelRequire("jfKIU");

var $cRlsu = parcelRequire("cRlsu");

var $7eF6Y = parcelRequire("7eF6Y");
function $e51eed86df811c93$export$7eed34e4e2038bc2({ uploadId: uploadId, skip: skip, onCompleted: onCompleted }) {
    const [imagesAreLoading, setImagesAreLoading] = (0, $a5EUy.useState)(false);
    const [uploadedImagesKeys, setUploadedImagesKeys] = (0, $a5EUy.useState)(null);
    const [imagesFetchError, setImagesFetchError] = (0, $a5EUy.useState)(false);
    const { labels: { svy_snackbar_error_header: svy_snackbar_error_header, svy_snackbar_error_uploaded_images_not_available: svy_snackbar_error_uploaded_images_not_available } } = (0, $cRlsu.useLabels)();
    (0, $a5EUy.useEffect)(()=>{
        if (!uploadId || skip) return;
        async function fetchUploadedImages() {
            let uploadedImagesFromS3 = [];
            try {
                setImagesAreLoading(true);
                uploadedImagesFromS3 = await (0, $jfKIU.Storage).list(uploadId);
                const uploadedImageKeysFromS3 = uploadedImagesFromS3.map((imageObject)=>imageObject.key);
                setUploadedImagesKeys(uploadedImageKeysFromS3);
                setImagesAreLoading(false);
                onCompleted && typeof onCompleted === 'function' && onCompleted(uploadedImageKeysFromS3);
            } catch (error) {
                setImagesAreLoading(false);
                setImagesFetchError(error);
                setUploadedImagesKeys([]);
                (0, $7eF6Y.generalApiErrorHandler)({
                    error: error,
                    snackbarHeader: svy_snackbar_error_header,
                    snackbarMessage: svy_snackbar_error_uploaded_images_not_available
                });
            }
        }
        fetchUploadedImages();
    }, [
        uploadId,
        skip,
        onCompleted,
        svy_snackbar_error_header,
        svy_snackbar_error_uploaded_images_not_available
    ]);
    return {
        imagesAreLoading: imagesAreLoading,
        uploadedImagesKeys: uploadedImagesKeys,
        imagesFetchError: imagesFetchError
    };
}

});

parcelRegister("51Lyw", function(module, exports) {

$parcel$export(module.exports, "withTransaction", function () { return $3a91ef57ab55aa40$export$c0b5558aa11175d9; });
$parcel$export(module.exports, "ApmRoute", function () { return $3a91ef57ab55aa40$export$e950e0dbcf10755d; });

var $7OjtN = parcelRequire("7OjtN");

var $8e5QV = parcelRequire("8e5QV");

var $iGhpD = parcelRequire("iGhpD");
var $3a91ef57ab55aa40$export$c0b5558aa11175d9 = (0, $8e5QV.getWithTransaction)((0, $7OjtN.apm));
var $3a91ef57ab55aa40$export$e950e0dbcf10755d = (0, $iGhpD.getApmRoute)((0, $7OjtN.apm));

});
parcelRegister("7OjtN", function(module, exports) {

$parcel$export(module.exports, "apm", function () { return $5afc502911e01054$export$66cd81c234b843ce; });

var $1Ip47 = parcelRequire("1Ip47");
var $44gVE = parcelRequire("44gVE");
var $iCHUu = parcelRequire("iCHUu");

var $47qV0 = parcelRequire("47qV0");
function $5afc502911e01054$var$getApmBase() {
    if ((0, $iCHUu.isBrowser) && window.elasticApm) return window.elasticApm;
    var enabled = (0, $1Ip47.bootstrap)();
    var serviceFactory = (0, $44gVE.createServiceFactory)();
    var apmBase = new (0, $47qV0.default)(serviceFactory, !enabled);
    if (0, $iCHUu.isBrowser) window.elasticApm = apmBase;
    return apmBase;
}
var $5afc502911e01054$export$66cd81c234b843ce = $5afc502911e01054$var$getApmBase();
var $5afc502911e01054$export$2cd8252107eb640b = $5afc502911e01054$export$66cd81c234b843ce.init.bind($5afc502911e01054$export$66cd81c234b843ce);
var $5afc502911e01054$export$2e2bcd8739ae039 = $5afc502911e01054$export$2cd8252107eb640b;

});
parcelRegister("47qV0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ffcb252c694cdab$export$2e2bcd8739ae039; });

var $5YGG1 = parcelRequire("5YGG1");
var $g6EEc = parcelRequire("g6EEc");
var $aDuuy = parcelRequire("aDuuy");
var $fixS9 = parcelRequire("fixS9");
var $kTzau = parcelRequire("kTzau");
var $2ffcb252c694cdab$export$2e2bcd8739ae039 = function() {
    function ApmBase(serviceFactory, disable) {
        this._disable = disable;
        this.serviceFactory = serviceFactory;
        this._initialized = false;
    }
    var _proto = ApmBase.prototype;
    _proto.isEnabled = function isEnabled() {
        return !this._disable;
    };
    _proto.isActive = function isActive() {
        var configService = this.serviceFactory.getService((0, $5YGG1.CONFIG_SERVICE));
        return this.isEnabled() && this._initialized && configService.get('active');
    };
    _proto.init = function init(config) {
        var _this = this;
        if (this.isEnabled() && !this._initialized) {
            this._initialized = true;
            var _this$serviceFactory$ = this.serviceFactory.getService([
                (0, $5YGG1.CONFIG_SERVICE),
                (0, $5YGG1.LOGGING_SERVICE),
                (0, $5YGG1.TRANSACTION_SERVICE)
            ]), configService = _this$serviceFactory$[0], loggingService = _this$serviceFactory$[1], transactionService = _this$serviceFactory$[2];
            configService.setVersion('5.17.5');
            this.config(config);
            var logLevel = configService.get('logLevel');
            loggingService.setLevel(logLevel);
            var isConfigActive = configService.get('active');
            if (isConfigActive) {
                this.serviceFactory.init();
                var flags = (0, $g6EEc.getInstrumentationFlags)(configService.get('instrument'), configService.get('disableInstrumentations'));
                var performanceMonitoring = this.serviceFactory.getService((0, $5YGG1.PERFORMANCE_MONITORING));
                performanceMonitoring.init(flags);
                if (flags[0, $5YGG1.ERROR]) {
                    var errorLogging = this.serviceFactory.getService((0, $5YGG1.ERROR_LOGGING));
                    errorLogging.registerListeners();
                }
                if (configService.get('session')) {
                    var localConfig = configService.getLocalConfig();
                    if (localConfig && localConfig.session) configService.setConfig({
                        session: localConfig.session
                    });
                }
                var sendPageLoad = function sendPageLoad() {
                    return flags[0, $5YGG1.PAGE_LOAD] && _this._sendPageLoadMetrics();
                };
                if (configService.get('centralConfig')) this.fetchCentralConfig().then(sendPageLoad);
                else sendPageLoad();
                (0, $fixS9.observePageVisibility)(configService, transactionService);
                if (flags[0, $5YGG1.EVENT_TARGET] && flags[0, $5YGG1.CLICK]) (0, $aDuuy.observePageClicks)(transactionService);
                (0, $kTzau.observeUserInteractions)();
            } else {
                this._disable = true;
                loggingService.warn('RUM agent is inactive');
            }
        }
        return this;
    };
    _proto.fetchCentralConfig = function fetchCentralConfig() {
        var _this$serviceFactory$2 = this.serviceFactory.getService([
            (0, $5YGG1.APM_SERVER),
            (0, $5YGG1.LOGGING_SERVICE),
            (0, $5YGG1.CONFIG_SERVICE)
        ]), apmServer = _this$serviceFactory$2[0], loggingService = _this$serviceFactory$2[1], configService = _this$serviceFactory$2[2];
        return apmServer.fetchConfig(configService.get('serviceName'), configService.get('environment')).then(function(config) {
            var transactionSampleRate = config['transaction_sample_rate'];
            if (transactionSampleRate) {
                transactionSampleRate = Number(transactionSampleRate);
                var _config2 = {
                    transactionSampleRate: transactionSampleRate
                };
                var _configService$valida = configService.validate(_config2), invalid = _configService$valida.invalid;
                if (invalid.length === 0) configService.setConfig(_config2);
                else {
                    var _invalid$ = invalid[0], key = _invalid$.key, value = _invalid$.value, allowed = _invalid$.allowed;
                    loggingService.warn("invalid value \"" + value + "\" for " + key + ". Allowed: " + allowed + ".");
                }
            }
            return config;
        }).catch(function(error) {
            loggingService.warn('failed fetching config:', error);
        });
    };
    _proto._sendPageLoadMetrics = function _sendPageLoadMetrics() {
        var tr = this.startTransaction(undefined, (0, $5YGG1.PAGE_LOAD), {
            managed: true,
            canReuse: true
        });
        if (!tr) return;
        tr.addTask((0, $5YGG1.PAGE_LOAD));
        var sendPageLoadMetrics = function sendPageLoadMetrics() {
            setTimeout(function() {
                return tr.removeTask((0, $5YGG1.PAGE_LOAD));
            }, (0, $5YGG1.PAGE_LOAD_DELAY));
        };
        if (document.readyState === 'complete') sendPageLoadMetrics();
        else window.addEventListener('load', sendPageLoadMetrics);
    };
    _proto.observe = function observe(name, fn) {
        var configService = this.serviceFactory.getService((0, $5YGG1.CONFIG_SERVICE));
        configService.events.observe(name, fn);
    };
    _proto.config = function config(_config) {
        var _this$serviceFactory$3 = this.serviceFactory.getService([
            (0, $5YGG1.CONFIG_SERVICE),
            (0, $5YGG1.LOGGING_SERVICE)
        ]), configService = _this$serviceFactory$3[0], loggingService = _this$serviceFactory$3[1];
        var _configService$valida2 = configService.validate(_config), missing = _configService$valida2.missing, invalid = _configService$valida2.invalid, unknown = _configService$valida2.unknown;
        if (unknown.length > 0) {
            var message = 'Unknown config options are specified for RUM agent: ' + unknown.join(', ');
            loggingService.warn(message);
        }
        if (missing.length === 0 && invalid.length === 0) configService.setConfig(_config);
        else {
            var separator = ', ';
            var _message = "RUM agent isn't correctly configured. ";
            if (missing.length > 0) {
                _message += missing.join(separator) + ' is missing';
                if (invalid.length > 0) _message += separator;
            }
            invalid.forEach(function(_ref, index) {
                var key = _ref.key, value = _ref.value, allowed = _ref.allowed;
                _message += key + " \"" + value + "\" contains invalid characters! (allowed: " + allowed + ")" + (index !== invalid.length - 1 ? separator : '');
            });
            loggingService.error(_message);
            configService.setConfig({
                active: false
            });
        }
    };
    _proto.setUserContext = function setUserContext(userContext) {
        var configService = this.serviceFactory.getService((0, $5YGG1.CONFIG_SERVICE));
        configService.setUserContext(userContext);
    };
    _proto.setCustomContext = function setCustomContext(customContext) {
        var configService = this.serviceFactory.getService((0, $5YGG1.CONFIG_SERVICE));
        configService.setCustomContext(customContext);
    };
    _proto.addLabels = function addLabels(labels) {
        var configService = this.serviceFactory.getService((0, $5YGG1.CONFIG_SERVICE));
        configService.addLabels(labels);
    };
    _proto.setInitialPageLoadName = function setInitialPageLoadName(name) {
        var configService = this.serviceFactory.getService((0, $5YGG1.CONFIG_SERVICE));
        configService.setConfig({
            pageLoadTransactionName: name
        });
    };
    _proto.startTransaction = function startTransaction(name, type, options) {
        if (this.isEnabled()) {
            var transactionService = this.serviceFactory.getService((0, $5YGG1.TRANSACTION_SERVICE));
            return transactionService.startTransaction(name, type, options);
        }
    };
    _proto.startSpan = function startSpan(name, type, options) {
        if (this.isEnabled()) {
            var transactionService = this.serviceFactory.getService((0, $5YGG1.TRANSACTION_SERVICE));
            return transactionService.startSpan(name, type, options);
        }
    };
    _proto.getCurrentTransaction = function getCurrentTransaction() {
        if (this.isEnabled()) {
            var transactionService = this.serviceFactory.getService((0, $5YGG1.TRANSACTION_SERVICE));
            return transactionService.getCurrentTransaction();
        }
    };
    _proto.captureError = function captureError(error, opts) {
        if (this.isEnabled()) {
            var errorLogging = this.serviceFactory.getService((0, $5YGG1.ERROR_LOGGING));
            return errorLogging.logError(error, opts);
        }
    };
    _proto.addFilter = function addFilter(fn) {
        var configService = this.serviceFactory.getService((0, $5YGG1.CONFIG_SERVICE));
        configService.addFilter(fn);
    };
    return ApmBase;
}();

});


parcelRegister("8e5QV", function(module, exports) {

$parcel$export(module.exports, "getWithTransaction", function () { return $5fd42bbd43f0838d$export$8968e64b6e3c0a85; });

var $a5EUy = parcelRequire("a5EUy");

var $jxrUX = parcelRequire("jxrUX");

var $arZea = parcelRequire("arZea");
var $5YGG1 = parcelRequire("5YGG1");
function $5fd42bbd43f0838d$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $5fd42bbd43f0838d$var$_setPrototypeOf(subClass, superClass);
}
function $5fd42bbd43f0838d$var$_setPrototypeOf(o, p) {
    $5fd42bbd43f0838d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5fd42bbd43f0838d$var$_setPrototypeOf(o, p);
}
function $5fd42bbd43f0838d$var$_extends() {
    $5fd42bbd43f0838d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5fd42bbd43f0838d$var$_extends.apply(this, arguments);
}
function $5fd42bbd43f0838d$var$_slicedToArray(arr, i) {
    return $5fd42bbd43f0838d$var$_arrayWithHoles(arr) || $5fd42bbd43f0838d$var$_iterableToArrayLimit(arr, i) || $5fd42bbd43f0838d$var$_unsupportedIterableToArray(arr, i) || $5fd42bbd43f0838d$var$_nonIterableRest();
}
function $5fd42bbd43f0838d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5fd42bbd43f0838d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5fd42bbd43f0838d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5fd42bbd43f0838d$var$_arrayLikeToArray(o, minLen);
}
function $5fd42bbd43f0838d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5fd42bbd43f0838d$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $5fd42bbd43f0838d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $5fd42bbd43f0838d$var$isReactClassComponent(Component) {
    var prototype = Component.prototype;
    return !!(prototype && prototype.isReactComponent);
}
function $5fd42bbd43f0838d$export$8968e64b6e3c0a85(apm) {
    return function withTransaction(name, type, callback) {
        if (callback === void 0) callback = function callback() {};
        return function(Component) {
            if (!apm.isActive()) return Component;
            if (!Component) {
                var loggingService = apm.serviceFactory.getService((0, $5YGG1.LOGGING_SERVICE));
                loggingService.warn(name + " is not instrumented since component property is not provided");
                return Component;
            }
            var ApmComponent = null;
            if (!$5fd42bbd43f0838d$var$isReactClassComponent(Component) && typeof (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).useEffect === 'function' && typeof (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).useState === 'function') ApmComponent = function ApmComponent(props) {
                var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).useState(function() {
                    var tr = apm.startTransaction(name, type, {
                        managed: true,
                        canReuse: true
                    });
                    callback(tr, props);
                    return tr;
                }), _React$useState2 = $5fd42bbd43f0838d$var$_slicedToArray(_React$useState, 1), transaction = _React$useState2[0];
                (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).useEffect(function() {
                    (0, $arZea.default)(function() {
                        return transaction && transaction.detectFinish();
                    });
                    return function() {
                        transaction && transaction.detectFinish();
                    };
                }, []);
                return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement(Component, $5fd42bbd43f0838d$var$_extends({
                    transaction: transaction
                }, props));
            };
            else ApmComponent = function(_React$Component) {
                $5fd42bbd43f0838d$var$_inheritsLoose(ApmComponent, _React$Component);
                function ApmComponent(props) {
                    var _this;
                    _this = _React$Component.call(this, props) || this;
                    _this.transaction = apm.startTransaction(name, type, {
                        managed: true,
                        canReuse: true
                    });
                    callback(_this.transaction, props);
                    return _this;
                }
                var _proto = ApmComponent.prototype;
                _proto.componentDidMount = function componentDidMount() {
                    var _this2 = this;
                    (0, $arZea.default)(function() {
                        return _this2.transaction && _this2.transaction.detectFinish();
                    });
                };
                _proto.componentWillUnmount = function componentWillUnmount() {
                    if (this.transaction) this.transaction.detectFinish();
                };
                _proto.render = function render() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement(Component, $5fd42bbd43f0838d$var$_extends({
                        transaction: this.transaction
                    }, this.props));
                };
                return ApmComponent;
            }((0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).Component);
            ApmComponent.displayName = "withTransaction(" + (Component.displayName || Component.name) + ")";
            ApmComponent.WrappedComponent = Component;
            return (0, (/*@__PURE__*/$parcel$interopDefault($jxrUX)))(ApmComponent, Component);
        };
    };
}

});

parcelRegister("iGhpD", function(module, exports) {

$parcel$export(module.exports, "getApmRoute", function () { return $d999a7f91a486c78$export$a820eaa04880dd2b; });

var $a5EUy = parcelRequire("a5EUy");

var $glEgb = parcelRequire("glEgb");

var $8e5QV = parcelRequire("8e5QV");
function $d999a7f91a486c78$var$_extends() {
    $d999a7f91a486c78$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d999a7f91a486c78$var$_extends.apply(this, arguments);
}
function $d999a7f91a486c78$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $d999a7f91a486c78$var$_setPrototypeOf(subClass, superClass);
}
function $d999a7f91a486c78$var$_setPrototypeOf(o, p) {
    $d999a7f91a486c78$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d999a7f91a486c78$var$_setPrototypeOf(o, p);
}
function $d999a7f91a486c78$var$getTransactionName(name, props) {
    var _props$match = props.match, match = _props$match === void 0 ? {} : _props$match;
    if (Array.isArray(name) && match.path) return match.path;
    return name;
}
function $d999a7f91a486c78$export$a820eaa04880dd2b(apm) {
    var withTransaction = (0, $8e5QV.getWithTransaction)(apm);
    return function(_React$Component) {
        $d999a7f91a486c78$var$_inheritsLoose(ApmRoute, _React$Component);
        function ApmRoute(props) {
            var _this;
            _this = _React$Component.call(this, props) || this;
            _this.state = {};
            return _this;
        }
        ApmRoute.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var initial = prevState.apmComponent == null;
            var path = nextProps.path, component = nextProps.component;
            var pathChanged = path != prevState.path;
            if (initial || pathChanged) return {
                path: path,
                apmComponent: withTransaction(path, 'route-change', function(transaction, props) {
                    if (transaction) {
                        var name = $d999a7f91a486c78$var$getTransactionName(path, props);
                        name && (transaction.name = name);
                    }
                })(component)
            };
            return null;
        };
        var _proto = ApmRoute.prototype;
        _proto.render = function render() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createElement((0, $glEgb.Route), $d999a7f91a486c78$var$_extends({}, this.props, {
                component: this.state.apmComponent
            }));
        };
        return ApmRoute;
    }((0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).Component);
}

});



parcelRegister("2BLAK", function(module, exports) {

$parcel$export(module.exports, "LoginPage", function () { return $1e63f4381c7c0e54$export$f14c0e3f98d164c0; });

var $df8fE = parcelRequire("df8fE");

var $glEgb = parcelRequire("glEgb");
parcelRequire("3XIEi");
var $bzHnt = parcelRequire("bzHnt");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("2UBc8");
var $eBKZl = parcelRequire("eBKZl");

var $dSPjH = parcelRequire("dSPjH");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $jahGf = parcelRequire("jahGf");
var $cbxDY = parcelRequire("cbxDY");

var $7sO2A = parcelRequire("7sO2A");

var $cRlsu = parcelRequire("cRlsu");

var $cPiPb = parcelRequire("cPiPb");

var $302dL = parcelRequire("302dL");

var $5wEm6 = parcelRequire("5wEm6");

var $iSOfh = parcelRequire("iSOfh");

var $TbfMS = parcelRequire("TbfMS");

var $cynhR = parcelRequire("cynhR");

var $7eF6Y = parcelRequire("7eF6Y");

var $e5XFO = parcelRequire("e5XFO");
const $1e63f4381c7c0e54$var$buttonStyle = (0, $1lyZZ.css)({
    width: '100%',
    color: (0, $8JWbY.colors).neutralColors.white,
    fontSize: (0, $jahGf.font).size.medium,
    background: (0, $8JWbY.colors).boldColors.lightBlue.base,
    paddingTop: (0, $cbxDY.spacing).size4,
    paddingBottom: (0, $cbxDY.spacing).size4,
    marginBottom: (0, $cbxDY.spacing).size2,
    borderRadius: 4,
    border: 0,
    cursor: 'pointer',
    boxShadow: '0px 1px 0px rgba(1,4,16, .1), 0px -1px 0px rgba(0,0,0,.25) inset',
    '&:hover': {
        background: (0, $8JWbY.colors).boldColors.lightBlue.lightBlue80
    }
});
const $1e63f4381c7c0e54$var$privacyCookieTextStyle = (0, $1lyZZ.css)({
    color: (0, $8JWbY.colors).neutralColors.slate90,
    fontSize: (0, $jahGf.font).size.sizeM1,
    marginTop: (0, $cbxDY.spacing).size4,
    display: 'block'
});
const $1e63f4381c7c0e54$export$f14c0e3f98d164c0 = ()=>{
    const { isLoggedIn: isLoggedIn, selectedCustomer: selectedCustomer, cognitoData: cognitoData } = (0, $dSPjH.useUser)();
    const userHasNoCustomers = window.localStorage.getItem((0, $cynhR.userHasNoCustomersKey)) || false;
    const { data: publicLabelsData, loading: publicLabelsLoading, error: publicLabelsError } = (0, $eBKZl.useQuery)((0, $7sO2A.PUBLIC_LABELS));
    if (publicLabelsLoading) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $cPiPb.OverlayPortal), {
        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $302dL.Spinner), {})
    });
    let labels = (0, $cRlsu.labelsReducer)(publicLabelsData);
    if (publicLabelsError) {
        const { svy_snackbar_error_header: svy_snackbar_error_header } = (0, $iSOfh.labelTranslationsFallback);
        (0, $7eF6Y.generalApiErrorHandler)({
            error: publicLabelsError,
            snackbarHeader: svy_snackbar_error_header,
            snackbarMessage: 'Only English labels are currently available'
        });
        labels = (0, $iSOfh.labelTranslationsFallback);
    }
    const { getPublicLabels: { svy_loginpage_welcome_text: svy_loginpage_welcome_text, svy_sign_in_button: svy_sign_in_button }, getPublicRichTextLabels: { svy_loginpage_privacy_cookie_policy_line: svy_loginpage_privacy_cookie_policy_line } } = labels;
    if (isLoggedIn && (0, $e5XFO.isLoggedInWithWrongIdentityProvider)(cognitoData)) (0, $bzHnt.Auth).federatedSignIn({
        customProvider: "partner-idp-survey"
    });
    if (isLoggedIn && !selectedCustomer.id) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $glEgb.Redirect), {
        to: `/${(0, $5wEm6.routes).customerLogin}`
    });
    if (isLoggedIn && !selectedCustomer.hasAcceptedTerms) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $glEgb.Redirect), {
        to: `/${(0, $5wEm6.routes).terms}`
    });
    if (isLoggedIn && selectedCustomer.id) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $glEgb.Redirect), {
        to: `/${(0, $5wEm6.routes).homepage}`
    });
    if (JSON.parse(userHasNoCustomers)) {
        window.localStorage.removeItem((0, $cynhR.userHasNoCustomersKey));
        return /*#__PURE__*/ (0, $df8fE.jsx)((0, $glEgb.Redirect), {
            to: `/${(0, $5wEm6.routes).noAssessments}`
        });
    }
    const LoginFooter = ()=>/*#__PURE__*/ (0, $df8fE.jsx)("span", {
            css: $1e63f4381c7c0e54$var$privacyCookieTextStyle,
            dangerouslySetInnerHTML: {
                __html: svy_loginpage_privacy_cookie_policy_line
            }
        });
    return /*#__PURE__*/ (0, $df8fE.jsx)((0, $TbfMS.LoginLayout), {
        showImage: true,
        title: svy_loginpage_welcome_text,
        footer: /*#__PURE__*/ (0, $df8fE.jsx)(LoginFooter, {}),
        children: /*#__PURE__*/ (0, $df8fE.jsx)("button", {
            "data-transaction-name": "Sign in",
            "aria-label": "Sign in",
            css: $1e63f4381c7c0e54$var$buttonStyle,
            onClick: ()=>(0, $bzHnt.Auth).federatedSignIn({
                    customProvider: "partner-idp-survey"
                }),
            children: svy_sign_in_button
        })
    });
};

});
parcelRegister("TbfMS", function(module, exports) {

$parcel$export(module.exports, "LoginLayout", function () { return $0a5ddde809f32255$export$185ced06475b6ba0; });

var $df8fE = parcelRequire("df8fE");

var $3yJBl = parcelRequire("3yJBl");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $4AJXw = parcelRequire("4AJXw");
var $cbxDY = parcelRequire("cbxDY");

var $iEM5H = parcelRequire("iEM5H");

var $6aHgi = parcelRequire("6aHgi");

const $0a5ddde809f32255$var$backgroundStyle = (0, $1lyZZ.css)({
    width: '100%',
    height: 290,
    paddingLeft: (0, $cbxDY.spacing).size4,
    paddingRight: (0, $cbxDY.spacing).size4,
    background: `linear-gradient(${(0, $8JWbY.colors).boldColors.lightBlue.lightBlue100}, ${(0, $8JWbY.colors).boldColors.lightBlue.lightBlue90})`,
    [(0, $4AJXw.media).medium]: {
        height: 394
    }
});
const $0a5ddde809f32255$var$containerStyle = (0, $1lyZZ.css)({
    display: 'flex',
    justifyContent: 'center'
});
const $0a5ddde809f32255$var$signInContainerStyle = (0, $1lyZZ.css)({
    width: '100%',
    [(0, $4AJXw.media).medium]: {
        width: 580
    }
});
const $0a5ddde809f32255$var$signInBoxStyle = (0, $1lyZZ.css)({
    background: (0, $8JWbY.colors).neutralColors.white,
    paddingTop: (0, $cbxDY.spacing).size8,
    paddingRight: (0, $cbxDY.spacing).size4,
    paddingBottom: (0, $cbxDY.spacing).size6,
    paddingLeft: (0, $cbxDY.spacing).size4,
    borderRadius: 8,
    boxShadow: '0 2px 10px 0 rgba(0,0,0,0.2)'
});
const $0a5ddde809f32255$var$titleStyle = (0, $1lyZZ.css)({
    color: (0, $8JWbY.colors).neutralColors.white,
    paddingTop: (0, $cbxDY.spacing).size2,
    marginBottom: (0, $cbxDY.spacing).size6,
    marginTop: 130,
    [(0, $4AJXw.media).medium]: {
        marginBottom: (0, $cbxDY.spacing).size16,
        marginTop: 160
    }
});
const $0a5ddde809f32255$var$heroStyle = (0, $1lyZZ.css)({
    display: 'none',
    marginTop: 125,
    marginLeft: 80,
    [(0, $4AJXw.media).large]: {
        display: 'block'
    }
});
const $0a5ddde809f32255$export$185ced06475b6ba0 = ({ title: title = '', footer: footer, showImage: showImage = false, children: children })=>{
    return /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $df8fE.jsx)((0, $iEM5H.Header), {}),
            /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                css: $0a5ddde809f32255$var$backgroundStyle,
                children: /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                    css: $0a5ddde809f32255$var$containerStyle,
                    children: [
                        /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                            css: $0a5ddde809f32255$var$signInContainerStyle,
                            children: [
                                /*#__PURE__*/ (0, $df8fE.jsx)((0, $6aHgi.Heading), {
                                    type: "h1",
                                    additionalStyles: $0a5ddde809f32255$var$titleStyle,
                                    text: title
                                }),
                                /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                                    css: $0a5ddde809f32255$var$signInBoxStyle,
                                    children: children
                                }),
                                footer
                            ]
                        }),
                        showImage && /*#__PURE__*/ (0, $df8fE.jsx)("img", {
                            css: $0a5ddde809f32255$var$heroStyle,
                            src: (0, {}),
                            alt: "Lego hero figure"
                        })
                    ]
                })
            })
        ]
    });
};
$0a5ddde809f32255$export$185ced06475b6ba0.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string,
    footer: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).element,
    showImage: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).node.isRequired
};

});

parcelRegister("cynhR", function(module, exports) {

$parcel$export(module.exports, "userHasNoCustomersKey", function () { return $923ab9599ee5a8df$export$521ff8ad75839df; });
const $923ab9599ee5a8df$export$521ff8ad75839df = 'userHasNoCustomers';

});

parcelRegister("e5XFO", function(module, exports) {

$parcel$export(module.exports, "isLoggedInWithWrongIdentityProvider", function () { return $a42fd23958c60e69$export$2dde1b51458f985; });
const $a42fd23958c60e69$export$2dde1b51458f985 = (user = {})=>{
    const idTokenPayload = user?.signInUserSession?.idToken?.payload;
    const identityProvider = idTokenPayload?.identities?.[0]?.providerName;
    if (identityProvider !== "partner-idp-survey") return true;
    return false;
};

});


parcelRegister("7swS0", function(module, exports) {

$parcel$export(module.exports, "CompletePage", function () { return $56e4a53ea03f6be2$export$1b4d0e655b136998; });

var $df8fE = parcelRequire("df8fE");
parcelRequire("2UBc8");
var $byqzn = parcelRequire("byqzn");
var $eBKZl = parcelRequire("eBKZl");

var $BeyzD = parcelRequire("BeyzD");
var $glEgb = parcelRequire("glEgb");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("i7Pqi");
var $gdpIa = parcelRequire("gdpIa");
parcelRequire("jDcek");
var $d3DgW = parcelRequire("d3DgW");
var $7AuHC = parcelRequire("7AuHC");

var $cPiPb = parcelRequire("cPiPb");

var $302dL = parcelRequire("302dL");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $jahGf = parcelRequire("jahGf");
var $4AJXw = parcelRequire("4AJXw");
var $cbxDY = parcelRequire("cbxDY");

var $cRlsu = parcelRequire("cRlsu");

var $dSPjH = parcelRequire("dSPjH");

var $oMBXq = parcelRequire("oMBXq");

var $5wEm6 = parcelRequire("5wEm6");

var $6aHgi = parcelRequire("6aHgi");

var $7eF6Y = parcelRequire("7eF6Y");

var $gFRU1 = parcelRequire("gFRU1");

var $51Lyw = parcelRequire("51Lyw");

var $a5EUy = parcelRequire("a5EUy");

var $lsDX7 = parcelRequire("lsDX7");

var $iKqXb = parcelRequire("iKqXb");

var $kbh1j = parcelRequire("kbh1j");
const $56e4a53ea03f6be2$var$containerStyle = (0, $1lyZZ.css)({
    display: 'flex',
    flexDirection: 'column'
});
const $56e4a53ea03f6be2$var$scoreWrapperStyle = (0, $1lyZZ.css)({
    marginTop: (0, $cbxDY.spacing).size4
});
const $56e4a53ea03f6be2$var$missingProofWrapperStyle = (0, $1lyZZ.css)({
    marginTop: (0, $cbxDY.spacing).size8
});
const $56e4a53ea03f6be2$var$scoreTextStyle = (0, $1lyZZ.css)({
    fontSize: (0, $jahGf.font).size.size05,
    marginBottom: (0, $cbxDY.spacing).size4
});
const $56e4a53ea03f6be2$var$scoreStyle = (0, $1lyZZ.css)({
    fontSize: (0, $jahGf.font).size.size3,
    fontWeight: (0, $jahGf.font).weight.bold,
    color: (0, $8JWbY.colors).boldColors.lightBlue.base,
    backgroundColor: (0, $8JWbY.colors).boldColors.lightBlue.ligthBlue10,
    display: 'inline',
    borderRadius: 100,
    padding: `${(0, $cbxDY.spacing).size2}px ${(0, $cbxDY.spacing).size4}px`
});
const $56e4a53ea03f6be2$var$buttonWrapperStyle = (0, $1lyZZ.css)({
    width: 'auto',
    display: 'flex',
    marginTop: (0, $cbxDY.spacing).size16,
    [(0, $4AJXw.media).medium]: {
        width: '63%'
    }
});
const $56e4a53ea03f6be2$var$firstButtonStyle = (0, $1lyZZ.css)({
    marginRight: (0, $cbxDY.spacing).size8
});
const $56e4a53ea03f6be2$var$Complete = ()=>{
    const { year: year, version: version } = (0, $glEgb.useParams)();
    const history = (0, $glEgb.useHistory)();
    const { staticUserVariables: staticUserVariables } = (0, $dSPjH.useUser)();
    const [isProofWarningModalVisible, setIsProofWarningModalVisible] = (0, $a5EUy.useState)(false);
    const { labels: { svy_end_headline: svy_end_headline, svy_end_review: svy_end_review, svy_end_finish: svy_end_finish, svy_back_to_homepage: svy_back_to_homepage, svy_complete_page_total_discount_text: svy_complete_page_total_discount_text, svy_snackbar_error_header: svy_snackbar_error_header, svy_snackbar_error_default_text: svy_snackbar_error_default_text } } = (0, $cRlsu.useLabels)();
    const { data: getCompletePageData, loading: getCompletePageDataLoading, error: getCompletePageDataError } = (0, $eBKZl.useQuery)((0, $oMBXq.GET_COMPLETE_PAGE_DATA), {
        variables: staticUserVariables({
            year: year,
            version: version
        }),
        fetchPolicy: 'network-only'
    });
    const [finishSurvey, { loading: finishSurveyLoading }] = (0, $byqzn.useMutation)((0, $oMBXq.FINISH_SURVEY), {
        onCompleted: handleFinishSurveyResponse
    });
    if (getCompletePageDataLoading || finishSurveyLoading) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $cPiPb.OverlayPortal), {
        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $302dL.Spinner), {})
    });
    async function submitSurvey() {
        try {
            await finishSurvey({
                variables: staticUserVariables({
                    year: year,
                    version: version
                })
            });
        } catch (error) {
            (0, $7eF6Y.generalApiErrorHandler)({
                error: error,
                snackbarHeader: svy_snackbar_error_header,
                snackbarMessage: svy_snackbar_error_default_text
            });
        }
    }
    async function handleFinishSurvey() {
        if ((0, $lsDX7.isAnyQuestionMissingProof)(enhancedQuestions)) {
            setIsProofWarningModalVisible(true);
            return;
        }
        await submitSurvey();
    }
    function handleFinishSurveyResponse(response) {
        if (response.finishSurvey) history.push(`/${(0, $5wEm6.routes).confirmation}`);
    }
    // Error boundary catches this error
    if (getCompletePageDataError) (0, $gFRU1.throwErrorWithTransactionName)(getCompletePageDataError, 'CompletePage');
    const { getSurvey: questions, getAnswers: answers, getSurveyState: surveyState } = getCompletePageData;
    const areAllAnswersComplete = answers.every((answer)=>answer.isComplete);
    const surveyDetailsForFeatureFlag = {
        year: Number(year)
    };
    let enhancedQuestions = (0, $lsDX7.enhanceQuestionsWithAnswersAndProof)(questions, answers);
    enhancedQuestions = (0, $lsDX7.adjustAssessmentsBasedOnFeatureFlags)(enhancedQuestions, surveyDetailsForFeatureFlag);
    return /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
        css: $56e4a53ea03f6be2$var$containerStyle,
        children: [
            isProofWarningModalVisible && /*#__PURE__*/ (0, $df8fE.jsx)((0, $iKqXb.MissingProofWarningModal), {
                onClose: ()=>{
                    setIsProofWarningModalVisible(false);
                },
                onConfirm: ()=>{
                    setIsProofWarningModalVisible(false);
                    history.push(`/${(0, $5wEm6.routes).survey}/${year}/${version}?mode=edit`);
                }
            }),
            /*#__PURE__*/ (0, $df8fE.jsx)((0, $6aHgi.Heading), {
                type: "h1",
                text: svy_end_headline
            }),
            /*#__PURE__*/ (0, $df8fE.jsx)((0, $7AuHC.Stepper), {
                children: enhancedQuestions.map((question)=>{
                    return /*#__PURE__*/ (0, $df8fE.jsx)((0, $d3DgW.Step), {
                        stepId: question.questionId,
                        header: question.headline,
                        isValid: true,
                        isWarning: question.proofRequirement.isProofMissing,
                        isComplete: true
                    }, question.questionId);
                })
            }),
            /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                css: $56e4a53ea03f6be2$var$scoreWrapperStyle,
                children: [
                    /*#__PURE__*/ (0, $df8fE.jsx)("p", {
                        css: $56e4a53ea03f6be2$var$scoreTextStyle,
                        children: svy_complete_page_total_discount_text
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                        css: $56e4a53ea03f6be2$var$scoreStyle,
                        children: `${surveyState.score}%`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                css: $56e4a53ea03f6be2$var$missingProofWrapperStyle,
                children: (0, $lsDX7.isAnyQuestionMissingProof)(enhancedQuestions) && /*#__PURE__*/ (0, $df8fE.jsx)((0, $kbh1j.MissingProofExplainer), {})
            }),
            /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                css: $56e4a53ea03f6be2$var$buttonWrapperStyle,
                children: [
                    /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                        css: $56e4a53ea03f6be2$var$firstButtonStyle,
                        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $BeyzD.Link), {
                            to: `/${(0, $5wEm6.routes).review}/${year}/${version}`,
                            children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                                "data-transaction-name": "Review Survey",
                                label: svy_end_review,
                                variant: "outline",
                                css: $56e4a53ea03f6be2$var$firstButtonStyle
                            })
                        })
                    }),
                    areAllAnswersComplete && surveyState.isEditable ? /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                        "data-transaction-name": "Finish Survey",
                        label: svy_end_finish,
                        onClick: handleFinishSurvey
                    }) : /*#__PURE__*/ (0, $df8fE.jsx)((0, $BeyzD.Link), {
                        to: (0, $5wEm6.routes).homepage,
                        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                            "data-transaction-name": "Back to Homepage",
                            label: svy_back_to_homepage
                        })
                    })
                ]
            })
        ]
    });
};
const $56e4a53ea03f6be2$export$1b4d0e655b136998 = (0, $51Lyw.withTransaction)('CompletePage', 'component')($56e4a53ea03f6be2$var$Complete);

});
parcelRegister("iKqXb", function(module, exports) {

$parcel$export(module.exports, "MissingProofWarningModal", function () { return $da616e4b9d8bbdd5$export$1de3a04236fd9c26; });

var $df8fE = parcelRequire("df8fE");

var $3yJBl = parcelRequire("3yJBl");
parcelRequire("hi8ts");
var $cTeyJ = parcelRequire("cTeyJ");

var $eN5fv = parcelRequire("eN5fv");

var $cRlsu = parcelRequire("cRlsu");
const $da616e4b9d8bbdd5$export$1de3a04236fd9c26 = ({ onClose: onClose, onConfirm: onConfirm, onExitHandler: onExitHandler })=>{
    const { labels: { svy_attachment_missing: svy_attachment_missing, svy_end_edit: svy_end_edit, svy_cancel_button: svy_cancel_button }, richTextLabels: { svy_attachment_missing_explanation_prompt: svy_attachment_missing_explanation_prompt } } = (0, $cRlsu.useLabels)();
    return /*#__PURE__*/ (0, $df8fE.jsx)((0, $eN5fv.GenericConfirmationModal), {
        status: "warning",
        header: svy_attachment_missing,
        onConfirmText: svy_end_edit,
        onCloseText: svy_cancel_button,
        body: svy_attachment_missing_explanation_prompt,
        onClose: onClose,
        onConfirm: onConfirm,
        onExitHandler: onExitHandler,
        icon: /*#__PURE__*/ (0, $df8fE.jsx)((0, $cTeyJ.Attach), {})
    });
};
$da616e4b9d8bbdd5$export$1de3a04236fd9c26.propTypes = {
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func.isRequired,
    onConfirm: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func.isRequired,
    onExitHandler: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func
};

});
parcelRegister("eN5fv", function(module, exports) {

$parcel$export(module.exports, "GenericConfirmationModal", function () { return $ac49b6a84fd1740c$export$fde4214a1c5284d3; });

var $df8fE = parcelRequire("df8fE");

var $3yJBl = parcelRequire("3yJBl");
parcelRequire("aaf2d");
var $2WWDJ = parcelRequire("2WWDJ");
parcelRequire("i7Pqi");
var $gdpIa = parcelRequire("gdpIa");
var $9BPY2 = parcelRequire("9BPY2");
var $gDChL = parcelRequire("gDChL");
parcelRequire("1OfTO");
var $cbxDY = parcelRequire("cbxDY");
const $ac49b6a84fd1740c$var$bodyText = (0, $2WWDJ.default)({
    marginTop: (0, $cbxDY.spacing).size6,
    '& > p': {
        marginBottom: (0, $cbxDY.spacing).size4
    }
});
const $ac49b6a84fd1740c$export$fde4214a1c5284d3 = ({ header: header, body: body, onCloseText: onCloseText = 'Cancel', onConfirmText: onConfirmText = 'Yes, continue', onClose: onClose, onConfirm: onConfirm, onExitHandler: onExitHandler, status: status = 'information', icon: icon })=>/*#__PURE__*/ (0, $df8fE.jsx)((0, $gDChL.Overlay), {
        isOpen: true,
        onClick: onExitHandler ? onExitHandler : onClose,
        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $9BPY2.Modal), {
            status: status,
            icon: icon,
            heading: /*#__PURE__*/ (0, $df8fE.jsx)((0, $9BPY2.Modal).Heading, {
                children: header
            }),
            body: /*#__PURE__*/ (0, $df8fE.jsx)((0, $9BPY2.Modal).Body, {
                children: /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                    css: $ac49b6a84fd1740c$var$bodyText,
                    dangerouslySetInnerHTML: {
                        __html: body
                    }
                })
            }),
            action: /*#__PURE__*/ (0, $df8fE.jsxs)((0, $9BPY2.Modal).Action, {
                children: [
                    /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                        "aria-label": "Confirm action",
                        "data-transaction-name": header,
                        label: onConfirmText,
                        onClick: ()=>onConfirm()
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                        "aria-label": "Close modal",
                        label: onCloseText,
                        variant: "outline",
                        onClick: onClose
                    })
                ]
            }),
            exitClickHandler: onExitHandler ? onExitHandler : onClose
        })
    });
$ac49b6a84fd1740c$export$fde4214a1c5284d3.propTypes = {
    header: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string.isRequired,
    body: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string.isRequired,
    onCloseText: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string,
    onConfirmText: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func.isRequired,
    onConfirm: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func.isRequired,
    onExitHandler: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func,
    status: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).element
};

});


parcelRegister("kbh1j", function(module, exports) {

$parcel$export(module.exports, "MissingProofExplainer", function () { return $eb120999e903676e$export$f68959556d5a9913; });

var $df8fE = parcelRequire("df8fE");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");

var $cRlsu = parcelRequire("cRlsu");
parcelRequire("jDcek");
var $d3DgW = parcelRequire("d3DgW");
const $eb120999e903676e$export$f68959556d5a9913 = ()=>{
    const { labels: { svy_attachment_missing: svy_attachment_missing, svy_some_answers_missing_attachments: svy_some_answers_missing_attachments } } = (0, $cRlsu.useLabels)();
    return /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
        "data-testid": "missingProofExplainer",
        children: [
            /*#__PURE__*/ (0, $df8fE.jsx)((0, $d3DgW.Step), {
                header: `- ${svy_attachment_missing}`,
                stepId: "-1",
                isComplete: true,
                isLast: true,
                isWarning: true
            }),
            /*#__PURE__*/ (0, $df8fE.jsx)("h1", {
                css: {
                    color: (0, $8JWbY.colors).utilityColors.warning.warning400
                },
                children: svy_some_answers_missing_attachments
            })
        ]
    });
};

});


parcelRegister("1y5wW", function(module, exports) {

$parcel$export(module.exports, "ReviewPage", function () { return $120d41a039c57035$export$62181a247fdd9443; });

var $df8fE = parcelRequire("df8fE");

var $a5EUy = parcelRequire("a5EUy");
parcelRequire("2UBc8");
var $byqzn = parcelRequire("byqzn");
var $eBKZl = parcelRequire("eBKZl");

var $BeyzD = parcelRequire("BeyzD");
var $glEgb = parcelRequire("glEgb");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("i7Pqi");
var $gdpIa = parcelRequire("gdpIa");
parcelRequire("jDcek");
var $d3DgW = parcelRequire("d3DgW");
var $7AuHC = parcelRequire("7AuHC");

var $cPiPb = parcelRequire("cPiPb");

var $302dL = parcelRequire("302dL");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $cbxDY = parcelRequire("cbxDY");

var $cRlsu = parcelRequire("cRlsu");

var $dSPjH = parcelRequire("dSPjH");

var $lsDX7 = parcelRequire("lsDX7");

var $oMBXq = parcelRequire("oMBXq");

var $4ZY8U = parcelRequire("4ZY8U");

var $5wEm6 = parcelRequire("5wEm6");

var $6aHgi = parcelRequire("6aHgi");

var $jFBuu = parcelRequire("jFBuu");

var $7eF6Y = parcelRequire("7eF6Y");

var $gFRU1 = parcelRequire("gFRU1");

var $51Lyw = parcelRequire("51Lyw");

var $iKqXb = parcelRequire("iKqXb");

var $kbh1j = parcelRequire("kbh1j");
const $120d41a039c57035$var$containerStyle = (0, $1lyZZ.css)({
    display: 'flex',
    flexDirection: 'column'
});
const $120d41a039c57035$var$missingProofWrapperStyle = (0, $1lyZZ.css)({
    marginTop: (0, $cbxDY.spacing).size8
});
const $120d41a039c57035$var$buttonWrapperStyle = (0, $1lyZZ.css)({
    width: 'auto',
    display: 'flex',
    justifyContent: 'center',
    marginTop: (0, $cbxDY.spacing).size12
});
const $120d41a039c57035$var$firstButtonStyle = (0, $1lyZZ.css)({
    marginRight: (0, $cbxDY.spacing).size8
});
const $120d41a039c57035$var$Review = ()=>{
    const history = (0, $glEgb.useHistory)();
    const { staticUserVariables: staticUserVariables } = (0, $dSPjH.useUser)();
    const { year: year, version: version } = (0, $glEgb.useParams)();
    const [isProofWarningModalVisible, setIsProofWarningModalVisible] = (0, $a5EUy.useState)(false);
    const { labels: { svy_review_headline: svy_review_headline, svy_end_edit: svy_end_edit, svy_end_finish: svy_end_finish, svy_back_to_homepage: svy_back_to_homepage, svy_snackbar_error_header: svy_snackbar_error_header, svy_snackbar_error_default_text: svy_snackbar_error_default_text } } = (0, $cRlsu.useLabels)();
    const { data: reviewData, loading: isReviewPageLoading, error: reviewDataError } = (0, $eBKZl.useQuery)((0, $oMBXq.GET_SURVEY_PAGE), {
        variables: staticUserVariables({
            year: year,
            version: version
        }),
        fetchPolicy: 'network-only'
    });
    const [finishSurvey, { loading: finishSurveyLoading }] = (0, $byqzn.useMutation)((0, $oMBXq.FINISH_SURVEY), {
        onCompleted: handleFinishSurveyResponse
    });
    const { uploadedImagesKeys: uploadedImagesKeys } = (0, $jFBuu.useFetchImagesFromS3)({
        uploadId: reviewData?.getSurveyInfo?.uploadId,
        skip: !reviewData
    });
    async function submitSurvey() {
        try {
            await finishSurvey({
                variables: staticUserVariables({
                    year: year,
                    version: version
                })
            });
        } catch (error) {
            (0, $7eF6Y.generalApiErrorHandler)({
                error: error,
                snackbarHeader: svy_snackbar_error_header,
                snackbarMessage: svy_snackbar_error_default_text
            });
        }
    }
    async function handleFinishSurvey() {
        if ((0, $lsDX7.isAnyQuestionMissingProof)(enhancedQuestions)) {
            setIsProofWarningModalVisible(true);
            return;
        }
        await submitSurvey();
    }
    function handleFinishSurveyResponse(response) {
        if (response.finishSurvey) history.push(`/${(0, $5wEm6.routes).confirmation}`);
    }
    // Error boundary catches this error
    if (reviewDataError) (0, $gFRU1.throwErrorWithTransactionName)(reviewDataError, 'ReviewPage');
    if (isReviewPageLoading || finishSurveyLoading) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $cPiPb.OverlayPortal), {
        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $302dL.Spinner), {})
    });
    const { getAnswers: savedAnswers, getSurvey: questions, getSurveyInfo: { surveyState: surveyState } } = reviewData;
    const surveyDetailsForFeatureFlag = {
        year: Number(year)
    };
    let enhancedQuestions = (0, $lsDX7.enhanceQuestionsWithAnswersAndProof)(questions, savedAnswers, uploadedImagesKeys);
    enhancedQuestions = (0, $lsDX7.adjustAssessmentsBasedOnFeatureFlags)(enhancedQuestions, surveyDetailsForFeatureFlag);
    return /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
        css: $120d41a039c57035$var$containerStyle,
        children: [
            isProofWarningModalVisible && /*#__PURE__*/ (0, $df8fE.jsx)((0, $iKqXb.MissingProofWarningModal), {
                onClose: ()=>{
                    setIsProofWarningModalVisible(false);
                },
                onConfirm: ()=>{
                    setIsProofWarningModalVisible(false);
                    history.push(`/${(0, $5wEm6.routes).survey}/${year}/${version}?mode=edit`);
                }
            }),
            /*#__PURE__*/ (0, $df8fE.jsx)((0, $6aHgi.Heading), {
                type: "h1",
                text: svy_review_headline
            }),
            /*#__PURE__*/ (0, $df8fE.jsx)((0, $7AuHC.Stepper), {
                activeColor: (0, $8JWbY.colors).boldColors.lightBlue.lightBlue100,
                children: enhancedQuestions.map((question)=>{
                    const { questionId: questionId, headline: headline, savedAnswer: savedAnswer, questionImageKeys: questionImageKeys, proofRequirement: proofRequirement } = question;
                    return /*#__PURE__*/ (0, $df8fE.jsx)((0, $d3DgW.Step), {
                        stepId: questionId,
                        header: headline,
                        isValid: savedAnswer.isValid,
                        isWarning: proofRequirement.isProofMissing,
                        isComplete: savedAnswer.isComplete,
                        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $4ZY8U.QuestionReview), {
                            question: question,
                            answer: savedAnswer,
                            uploadImageKeys: questionImageKeys
                        })
                    }, questionId);
                })
            }),
            /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                css: $120d41a039c57035$var$missingProofWrapperStyle,
                children: (0, $lsDX7.isAnyQuestionMissingProof)(enhancedQuestions) && /*#__PURE__*/ (0, $df8fE.jsx)((0, $kbh1j.MissingProofExplainer), {})
            }),
            /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                css: $120d41a039c57035$var$buttonWrapperStyle,
                children: surveyState.isEditable ? /*#__PURE__*/ (0, $df8fE.jsxs)((0, $a5EUy.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                            css: $120d41a039c57035$var$firstButtonStyle,
                            children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $BeyzD.Link), {
                                to: {
                                    pathname: `/${(0, $5wEm6.routes).survey}/${year}/${version}`,
                                    search: '?mode=edit'
                                },
                                children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                                    "data-transaction-name": "Edit Survey",
                                    label: svy_end_edit,
                                    variant: "outline",
                                    css: $120d41a039c57035$var$firstButtonStyle
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                            "data-transaction-name": "Finish Survey",
                            label: svy_end_finish,
                            onClick: handleFinishSurvey
                        })
                    ]
                }) : /*#__PURE__*/ (0, $df8fE.jsx)((0, $BeyzD.Link), {
                    to: `/${(0, $5wEm6.routes).homepage}`,
                    children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                        "data-transaction-name": "Back to Homepage",
                        label: svy_back_to_homepage
                    })
                })
            })
        ]
    });
};
const $120d41a039c57035$export$62181a247fdd9443 = (0, $51Lyw.withTransaction)('ReviewPage', 'component')($120d41a039c57035$var$Review);

});
parcelRegister("4ZY8U", function(module, exports) {

$parcel$export(module.exports, "QuestionReview", function () { return $3a3b830673f2bc83$export$bbe70a48ee7ad0f5; });

var $df8fE = parcelRequire("df8fE");

var $a5EUy = parcelRequire("a5EUy");

var $3yJBl = parcelRequire("3yJBl");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("hi8ts");
var $bwcHG = parcelRequire("bwcHG");
var $jNIIb = parcelRequire("jNIIb");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $jahGf = parcelRequire("jahGf");
var $cbxDY = parcelRequire("cbxDY");

var $cRlsu = parcelRequire("cRlsu");
parcelRequire("9U1pE");
var $dnN3u = parcelRequire("dnN3u");

var $j8IpY = parcelRequire("j8IpY");

var $jkzLx = parcelRequire("jkzLx");

var $lsDX7 = parcelRequire("lsDX7");
const $3a3b830673f2bc83$var$questionContentWrapperStyle = (0, $1lyZZ.css)({
    position: 'relative',
    color: (0, $8JWbY.colors).neutralColors.slateBase,
    paddingBottom: (0, $cbxDY.spacing).size12
});
const $3a3b830673f2bc83$var$headerWrapperStyle = (0, $1lyZZ.css)({
    display: 'flex'
});
const $3a3b830673f2bc83$var$headerStyle = (0, $1lyZZ.css)({
    fontSize: (0, $jahGf.font).size.size2,
    marginTop: (0, $cbxDY.spacing).size4,
    marginBottom: (0, $cbxDY.spacing).size2
});
const $3a3b830673f2bc83$var$answerListStyle = (0, $1lyZZ.css)({
    listStyle: 'none',
    marginTop: (0, $cbxDY.spacing).size5,
    marginBottom: (0, $cbxDY.spacing).size8,
    paddingLeft: (0, $cbxDY.spacing).size6
});
const $3a3b830673f2bc83$var$additionalFieldWrapperStyle = (0, $1lyZZ.css)({
    marginBottom: (0, $cbxDY.spacing).size6
});
const $3a3b830673f2bc83$var$additionalFieldHeaderStyle = (0, $1lyZZ.css)({
    fontWeight: (0, $jahGf.font).weight.regular,
    fontSize: (0, $jahGf.font).size.size05
});
const $3a3b830673f2bc83$var$answerListItemIconStyle = (isSelected)=>(0, $1lyZZ.css)({
        width: 14,
        marginRight: (0, $cbxDY.spacing).size2,
        color: isSelected ? (0, $8JWbY.colors).utilityColors.success.base : (0, $8JWbY.colors).neutralColors.slateBase,
        flexShrink: 0
    });
const $3a3b830673f2bc83$var$answerListItemStyle = (isSelected)=>(0, $1lyZZ.css)({
        fontSize: (0, $jahGf.font).size.size0,
        display: 'flex',
        marginTop: (0, $cbxDY.spacing).size3,
        color: isSelected ? (0, $8JWbY.colors).neutralColors.slate900 : (0, $8JWbY.colors).neutralColors.slateBase,
        fontWeight: isSelected ? (0, $jahGf.font).weight.medium : (0, $jahGf.font).weight.regular,
        whiteSpace: 'pre-wrap'
    });
const $3a3b830673f2bc83$var$answerOptionScoreStyle = (0, $1lyZZ.css)({
    fontSize: (0, $jahGf.font).size.sizeM1,
    fontWeight: (0, $jahGf.font).weight.bold,
    marginLeft: (0, $cbxDY.spacing).size2
});
const $3a3b830673f2bc83$var$answerOptionScoreWarningStyle = (0, $1lyZZ.css)({
    fontSize: (0, $jahGf.font).size.sizeM1,
    fontWeight: (0, $jahGf.font).weight.bold,
    marginLeft: (0, $cbxDY.spacing).size2,
    backgroundColor: (0, $8JWbY.colors).utilityColors.warning.warning100,
    color: (0, $8JWbY.colors).neutralColors.black
});
const $3a3b830673f2bc83$var$subAnswerListStyle = (0, $1lyZZ.css)({
    listStyle: 'none',
    paddingLeft: (0, $cbxDY.spacing).size8,
    marginTop: (0, $cbxDY.spacing).size2,
    marginBottom: 0
});
const $3a3b830673f2bc83$var$commentStyle = (0, $1lyZZ.css)({
    display: 'block',
    fontSize: (0, $jahGf.font).size.size05,
    fontStyle: 'italic',
    color: (0, $8JWbY.colors).neutralColors.slateBase,
    padding: `0 ${(0, $cbxDY.spacing).size6}px`
});
const $3a3b830673f2bc83$export$bbe70a48ee7ad0f5 = ({ question: question, answer: answer, uploadImageKeys: uploadImageKeys })=>{
    const { subHeader: subHeader, conditions: conditions, answerOptions: answerOptions, explanation: explanation } = question;
    const { labels: { svy_additional_comments: svy_additional_comments, svy_attachments: svy_attachments } } = (0, $cRlsu.useLabels)();
    const mainAnswerIds = answerOptions.map((o)=>o.answerId);
    const selectedSubIds = answer.selectedAnswer.filter((id)=>!mainAnswerIds.includes(id));
    const [imageModal, setImageModal] = (0, $a5EUy.useState)({
        isOpen: false,
        imageId: ''
    });
    const closeImageModal = ()=>{
        setImageModal((prevState)=>({
                ...prevState,
                isOpen: false
            }));
    };
    return /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
        "data-testid": "questionReview",
        children: [
            imageModal.isOpen && /*#__PURE__*/ (0, $df8fE.jsx)((0, $dnN3u.ImageModal), {
                imageId: imageModal.imageId,
                closeImageModal: closeImageModal
            }),
            /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                css: $3a3b830673f2bc83$var$questionContentWrapperStyle,
                children: [
                    /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                        css: $3a3b830673f2bc83$var$headerWrapperStyle,
                        children: /*#__PURE__*/ (0, $df8fE.jsx)("h2", {
                            css: $3a3b830673f2bc83$var$headerStyle,
                            children: subHeader
                        })
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)((0, $jkzLx.QuestionDescription), {
                        explanation: explanation,
                        conditions: conditions
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $df8fE.jsx)("ul", {
                                css: $3a3b830673f2bc83$var$answerListStyle,
                                children: answerOptions.map((answerOption)=>{
                                    const isSelected = answer.selectedAnswer.includes(answerOption.answerId);
                                    const displayScore = isSelected && answerOption.subAnswerOptions?.length > 0 ? (0, $lsDX7.computeScore)(answerOptions, answerOption.answerId, selectedSubIds) : answerOption.score;
                                    const scoreWarning = isSelected && answerOption.subAnswerOptions?.length > 0 && displayScore !== answerOption.score;
                                    return /*#__PURE__*/ (0, $df8fE.jsxs)("li", {
                                        css: $3a3b830673f2bc83$var$answerListItemStyle(isSelected),
                                        children: [
                                            isSelected ? /*#__PURE__*/ (0, $df8fE.jsx)((0, $bwcHG.CheckTickBold), {
                                                css: $3a3b830673f2bc83$var$answerListItemIconStyle(isSelected)
                                            }) : /*#__PURE__*/ (0, $df8fE.jsx)((0, $jNIIb.MinusBold), {
                                                css: $3a3b830673f2bc83$var$answerListItemIconStyle(isSelected)
                                            }),
                                            /*#__PURE__*/ (0, $df8fE.jsxs)("span", {
                                                children: [
                                                    `${answerOption.text}`,
                                                    displayScore !== null && /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                                                        css: scoreWarning ? $3a3b830673f2bc83$var$answerOptionScoreWarningStyle : $3a3b830673f2bc83$var$answerOptionScoreStyle,
                                                        children: `(${displayScore}%)`
                                                    })
                                                ]
                                            }),
                                            isSelected && answerOption.subAnswerOptions?.length > 0 && /*#__PURE__*/ (0, $df8fE.jsx)("ul", {
                                                css: $3a3b830673f2bc83$var$subAnswerListStyle,
                                                children: answerOption.subAnswerOptions.map((subOption)=>{
                                                    const isSubSelected = answer.selectedAnswer.includes(subOption.answerId);
                                                    return /*#__PURE__*/ (0, $df8fE.jsxs)("li", {
                                                        css: $3a3b830673f2bc83$var$answerListItemStyle(isSubSelected),
                                                        children: [
                                                            isSubSelected ? /*#__PURE__*/ (0, $df8fE.jsx)((0, $bwcHG.CheckTickBold), {
                                                                css: $3a3b830673f2bc83$var$answerListItemIconStyle(isSubSelected)
                                                            }) : /*#__PURE__*/ (0, $df8fE.jsx)((0, $jNIIb.MinusBold), {
                                                                css: $3a3b830673f2bc83$var$answerListItemIconStyle(isSubSelected)
                                                            }),
                                                            /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                                                                children: subOption.text
                                                            })
                                                        ]
                                                    }, subOption.answerId);
                                                })
                                            })
                                        ]
                                    }, answerOption.answerId);
                                })
                            }),
                            answer.comment && /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                                css: $3a3b830673f2bc83$var$additionalFieldWrapperStyle,
                                children: [
                                    /*#__PURE__*/ (0, $df8fE.jsx)("h3", {
                                        css: $3a3b830673f2bc83$var$additionalFieldHeaderStyle,
                                        children: svy_additional_comments
                                    }),
                                    /*#__PURE__*/ (0, $df8fE.jsx)("q", {
                                        css: $3a3b830673f2bc83$var$commentStyle,
                                        children: answer.comment
                                    })
                                ]
                            }),
                            !!uploadImageKeys.length && /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                                css: $3a3b830673f2bc83$var$additionalFieldWrapperStyle,
                                children: [
                                    /*#__PURE__*/ (0, $df8fE.jsx)("h3", {
                                        css: $3a3b830673f2bc83$var$additionalFieldHeaderStyle,
                                        children: svy_attachments
                                    }),
                                    /*#__PURE__*/ (0, $df8fE.jsx)((0, $j8IpY.UploadedImageThumbnailList), {
                                        uploadImageKeys: uploadImageKeys,
                                        isEditable: false,
                                        imageClickHandler: (imageId)=>setImageModal((prevState)=>({
                                                    ...prevState,
                                                    imageId: imageId,
                                                    isOpen: true
                                                }))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$3a3b830673f2bc83$export$bbe70a48ee7ad0f5.propTypes = {
    question: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).object.isRequired,
    answer: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).object.isRequired,
    uploadImageKeys: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string).isRequired
};

});


parcelRegister("g11tg", function(module, exports) {

$parcel$export(module.exports, "ConfirmationPage", function () { return $ba8de172e28dfcc1$export$a822667bb1b64a01; });

var $df8fE = parcelRequire("df8fE");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("i7Pqi");
var $gdpIa = parcelRequire("gdpIa");

var $BeyzD = parcelRequire("BeyzD");
parcelRequire("hi8ts");
var $bWBwj = parcelRequire("bWBwj");

var $cRlsu = parcelRequire("cRlsu");

var $dSPjH = parcelRequire("dSPjH");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $4AJXw = parcelRequire("4AJXw");
var $cbxDY = parcelRequire("cbxDY");

var $5wEm6 = parcelRequire("5wEm6");

var $6aHgi = parcelRequire("6aHgi");

var $51Lyw = parcelRequire("51Lyw");
const $ba8de172e28dfcc1$var$contentWrapperStyle = (0, $1lyZZ.css)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 550,
    margin: '0 auto'
});
const $ba8de172e28dfcc1$var$iconStyle = (0, $1lyZZ.css)({
    color: (0, $8JWbY.colors).boldColors.lightBlue.lightBlue100,
    height: 80,
    width: 80,
    margin: `${(0, $cbxDY.spacing).size8}px 0 ${(0, $cbxDY.spacing).size6}px`,
    [(0, $4AJXw.media).medium]: {
        height: 130,
        width: 130,
        margin: `${(0, $cbxDY.spacing).size10}px 0 ${(0, $cbxDY.spacing).size16}px`
    }
});
const $ba8de172e28dfcc1$var$bodyTextStyle = (0, $1lyZZ.css)({
    textAlign: 'center'
});
const $ba8de172e28dfcc1$var$headingStyle = (0, $1lyZZ.css)({
    textAlign: 'center'
});
const $ba8de172e28dfcc1$var$buttonsWrapperStyle = (0, $1lyZZ.css)({
    display: 'flex',
    marginTop: (0, $cbxDY.spacing).size16
});
const $ba8de172e28dfcc1$var$firstButtonStyle = (0, $1lyZZ.css)({
    marginRight: (0, $cbxDY.spacing).size8
});
const $ba8de172e28dfcc1$var$Confirmation = ()=>{
    const { labels: { svy_end_thanks_headline: svy_end_thanks_headline, svy_end_thanks_details: svy_end_thanks_details, svy_sign_out: svy_sign_out, svy_back_to_homepage: svy_back_to_homepage } } = (0, $cRlsu.useLabels)();
    const { signOut: signOut } = (0, $dSPjH.useUser)();
    return /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
        css: $ba8de172e28dfcc1$var$contentWrapperStyle,
        children: [
            /*#__PURE__*/ (0, $df8fE.jsx)((0, $bWBwj.StatusSuccessBold), {
                css: $ba8de172e28dfcc1$var$iconStyle
            }),
            /*#__PURE__*/ (0, $df8fE.jsx)((0, $6aHgi.Heading), {
                type: "h2",
                additionalStyles: $ba8de172e28dfcc1$var$headingStyle,
                text: svy_end_thanks_headline
            }),
            /*#__PURE__*/ (0, $df8fE.jsx)("p", {
                css: $ba8de172e28dfcc1$var$bodyTextStyle,
                children: svy_end_thanks_details
            }),
            /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                css: $ba8de172e28dfcc1$var$buttonsWrapperStyle,
                children: [
                    /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                        css: $ba8de172e28dfcc1$var$firstButtonStyle,
                        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $BeyzD.Link), {
                            to: `/${(0, $5wEm6.routes).homepage}`,
                            children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                                "data-transaction-name": "Back to homepage",
                                label: svy_back_to_homepage,
                                css: $ba8de172e28dfcc1$var$firstButtonStyle,
                                variant: "ghost"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                        "data-transaction-name": "Sign out",
                        label: svy_sign_out,
                        onClick: signOut
                    })
                ]
            })
        ]
    });
};
const $ba8de172e28dfcc1$export$a822667bb1b64a01 = (0, $51Lyw.withTransaction)('ConfirmationPage', 'component')($ba8de172e28dfcc1$var$Confirmation);

});

parcelRegister("8DvcO", function(module, exports) {

$parcel$export(module.exports, "PageNotFound", function () { return $649a2c067a32f196$export$a65c2c055de52e1d; });

var $df8fE = parcelRequire("df8fE");

var $1lyZZ = parcelRequire("1lyZZ");

var $2zgbn = parcelRequire("2zgbn");

var $cRlsu = parcelRequire("cRlsu");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $jahGf = parcelRequire("jahGf");
var $4AJXw = parcelRequire("4AJXw");
var $cbxDY = parcelRequire("cbxDY");

var $adrqp = parcelRequire("adrqp");
const $649a2c067a32f196$var$containerStyle = (0, $1lyZZ.css)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'red',
    background: `linear-gradient(${(0, $8JWbY.colors).boldColors.darkBlue.darkBlue80}, ${(0, $8JWbY.colors).boldColors.darkBlue.base})`,
    color: (0, $8JWbY.colors).neutralColors.white,
    textAlign: 'center',
    paddingBottom: 120
});
const $649a2c067a32f196$var$svgStyle = (0, $1lyZZ.css)({
    width: 250,
    height: 250,
    alignSelf: 'flex-start',
    [(0, $4AJXw.media).medium]: {
        width: 500,
        height: 500
    },
    [(0, $4AJXw.media).large]: {
        width: 700,
        height: 700
    }
});
const $649a2c067a32f196$var$headerStyle = (0, $1lyZZ.css)({
    fontSize: (0, $jahGf.font).size.size5,
    fontWeight: (0, $jahGf.font).weight.medium,
    marginBottom: (0, $cbxDY.spacing).size7,
    marginTop: -60,
    [(0, $4AJXw.media).medium]: {
        marginTop: -100
    },
    [(0, $4AJXw.media).large]: {
        marginTop: -150
    }
});
const $649a2c067a32f196$var$bodyTextStyle = (0, $1lyZZ.css)({
    maxWidth: 500,
    lineHeight: (0, $jahGf.font).lineHeight.m,
    padding: `0 ${(0, $cbxDY.spacing).size2}px`
});
const $649a2c067a32f196$var$contactMailLinkStyle = (0, $1lyZZ.css)({
    marginTop: (0, $cbxDY.spacing).size6,
    marginBottom: (0, $cbxDY.spacing).size12,
    '&:link, &:hover, &:active, &:visited': {
        color: (0, $8JWbY.colors).neutralColors.white,
        textDecoration: 'underline'
    }
});
const $649a2c067a32f196$export$a65c2c055de52e1d = ()=>{
    const { labels: { svy_404_page_text: svy_404_page_text } } = (0, $cRlsu.useLabels)();
    return /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                css: $649a2c067a32f196$var$containerStyle,
                children: [
                    /*#__PURE__*/ (0, $df8fE.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($adrqp))),
                        css: $649a2c067a32f196$var$svgStyle
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)("h1", {
                        css: $649a2c067a32f196$var$headerStyle,
                        children: "404"
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)("p", {
                        css: $649a2c067a32f196$var$bodyTextStyle,
                        children: svy_404_page_text
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)("a", {
                        css: $649a2c067a32f196$var$contactMailLinkStyle,
                        href: "mailto:something@here",
                        children: "contact@person.lego.com"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $df8fE.jsx)((0, $2zgbn.Footer), {})
        ]
    });
};

});
parcelRegister("2zgbn", function(module, exports) {

$parcel$export(module.exports, "Footer", function () { return $1deb673029c5c0f9$export$a06f1c675e846f6f; });

var $df8fE = parcelRequire("df8fE");

var $cRlsu = parcelRequire("cRlsu");

var $dSPjH = parcelRequire("dSPjH");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $jahGf = parcelRequire("jahGf");
var $4AJXw = parcelRequire("4AJXw");
var $cbxDY = parcelRequire("cbxDY");

var $jy963 = parcelRequire("jy963");
const $1deb673029c5c0f9$var$wrapperStyle = (0, $1lyZZ.css)({
    backgroundColor: (0, $8JWbY.colors).neutralColors.slate05,
    padding: (0, $cbxDY.spacing).size4,
    [(0, $4AJXw.media).medium]: {
        padding: (0, $cbxDY.spacing).size12
    }
});
const $1deb673029c5c0f9$var$hrStyle = (0, $1lyZZ.css)({
    border: `1px solid ${(0, $8JWbY.colors).neutralColors.slate30}`
});
const $1deb673029c5c0f9$var$topSectionStyle = (0, $1lyZZ.css)({
    padding: `${(0, $cbxDY.spacing).size4}px ${(0, $cbxDY.spacing).size5}px ${(0, $cbxDY.spacing).size6}px`
});
const $1deb673029c5c0f9$var$contactDetailsTextStyle = (0, $1lyZZ.css)({
    fontWeight: (0, $jahGf.font).weight.medium,
    marginBottom: (0, $cbxDY.spacing).size1
});
const $1deb673029c5c0f9$var$contactEmailLinkStyle = (0, $1lyZZ.css)({
    marginBottom: (0, $cbxDY.spacing).size6,
    [(0, $4AJXw.media).medium]: {
        marginBottom: (0, $cbxDY.spacing).size2
    }
});
const $1deb673029c5c0f9$var$linksWrapperStyle = (0, $1lyZZ.css)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [(0, $4AJXw.media).medium]: {
        flexDirection: 'row'
    }
});
const $1deb673029c5c0f9$var$rightLinksWrapperStyle = (0, $1lyZZ.css)({
    display: 'flex',
    flexDirection: 'column',
    '& > *': {
        marginLeft: 0
    },
    [(0, $4AJXw.media).medium]: {
        flexDirection: 'row',
        '& > *': {
            marginLeft: (0, $cbxDY.spacing).size8
        }
    }
});
const $1deb673029c5c0f9$var$bottomSectionStyle = (0, $1lyZZ.css)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    padding: `${(0, $cbxDY.spacing).size8}px ${(0, $cbxDY.spacing).size5}px ${(0, $cbxDY.spacing).size6}px`,
    flexDirection: 'column',
    [(0, $4AJXw.media).medium]: {
        flexDirection: 'row'
    }
});
const $1deb673029c5c0f9$var$bodyTextStyle = (0, $1lyZZ.css)({
    paddingRight: (0, $cbxDY.spacing).size6,
    '& > p': {
        marginBottom: (0, $cbxDY.spacing).size4
    }
});
const $1deb673029c5c0f9$var$logoStyle = (0, $1lyZZ.css)({
    width: 48,
    height: 48
});
const $1deb673029c5c0f9$export$a06f1c675e846f6f = ()=>{
    const { selectedCustomer: selectedCustomer } = (0, $dSPjH.useUser)();
    const { labels: { svy_footer_contact: svy_footer_contact }, richTextLabels: { svy_footer_text: svy_footer_text, svy_footer_legal_notice_link: svy_footer_legal_notice_link, svy_footer_privacy_policy_link: svy_footer_privacy_policy_link } } = (0, $cRlsu.useLabels)();
    return /*#__PURE__*/ (0, $df8fE.jsxs)("footer", {
        css: $1deb673029c5c0f9$var$wrapperStyle,
        children: [
            /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                css: $1deb673029c5c0f9$var$topSectionStyle,
                children: [
                    /*#__PURE__*/ (0, $df8fE.jsx)("h4", {
                        css: $1deb673029c5c0f9$var$contactDetailsTextStyle,
                        children: svy_footer_contact
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                        css: $1deb673029c5c0f9$var$linksWrapperStyle,
                        children: [
                            selectedCustomer.legoContactEmail && /*#__PURE__*/ (0, $df8fE.jsx)("a", {
                                css: $1deb673029c5c0f9$var$contactEmailLinkStyle,
                                href: `mailto:${selectedCustomer.legoContactEmail}`,
                                children: selectedCustomer.legoContactEmail
                            }),
                            /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                                css: $1deb673029c5c0f9$var$rightLinksWrapperStyle,
                                children: [
                                    /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: svy_footer_legal_notice_link
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: svy_footer_privacy_policy_link
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $df8fE.jsx)("hr", {
                css: $1deb673029c5c0f9$var$hrStyle
            }),
            /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                css: $1deb673029c5c0f9$var$bottomSectionStyle,
                children: [
                    /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                        css: $1deb673029c5c0f9$var$bodyTextStyle,
                        dangerouslySetInnerHTML: {
                            __html: svy_footer_text
                        }
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)((0, $jy963.Logo), {
                        css: $1deb673029c5c0f9$var$logoStyle
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("adrqp", function(module, exports) {
module.exports = $parcel$resolve("bB4A6");

});


parcelRegister("6cYmE", function(module, exports) {

$parcel$export(module.exports, "withMainLayout", function () { return $4852b0272fe44ef4$export$5eefa8b5d1087514; });

var $df8fE = parcelRequire("df8fE");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");

var $3Hzl1 = parcelRequire("3Hzl1");

var $2zgbn = parcelRequire("2zgbn");

var $iEM5H = parcelRequire("iEM5H");
const $4852b0272fe44ef4$var$layoutWrapperStyle = (0, $1lyZZ.css)({
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
});
const $4852b0272fe44ef4$var$mainStyle = (0, $1lyZZ.css)({
    flexGrow: 1,
    minHeight: 700,
    backgroundColor: (0, $8JWbY.colors).neutralColors.white
});
function $4852b0272fe44ef4$export$5eefa8b5d1087514(Component) {
    function WithMainLayout({ ...props }) {
        return /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
            css: $4852b0272fe44ef4$var$layoutWrapperStyle,
            children: [
                /*#__PURE__*/ (0, $df8fE.jsx)((0, $iEM5H.Header), {}),
                /*#__PURE__*/ (0, $df8fE.jsx)("main", {
                    css: $4852b0272fe44ef4$var$mainStyle,
                    children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $3Hzl1.CenterContentWrapper), {
                        children: /*#__PURE__*/ (0, $df8fE.jsx)(Component, {
                            ...props
                        })
                    })
                }),
                /*#__PURE__*/ (0, $df8fE.jsx)((0, $2zgbn.Footer), {})
            ]
        });
    }
    WithMainLayout.displayName = `WithMainLayout(${Component.displayName || Component.name || 'Component'})`;
    return WithMainLayout;
}

});

parcelRegister("jQ6pt", function(module, exports) {

$parcel$export(module.exports, "MultiCustomerLoginPage", function () { return $e717d885d28255af$export$f9377213bb6b882c; });

var $df8fE = parcelRequire("df8fE");

var $a5EUy = parcelRequire("a5EUy");

var $glEgb = parcelRequire("glEgb");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("2UBc8");
var $c6uN4 = parcelRequire("c6uN4");
var $eBKZl = parcelRequire("eBKZl");

var $dSPjH = parcelRequire("dSPjH");

var $cRlsu = parcelRequire("cRlsu");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $cbxDY = parcelRequire("cbxDY");

var $cPiPb = parcelRequire("cPiPb");

var $302dL = parcelRequire("302dL");

var $5wEm6 = parcelRequire("5wEm6");

var $TbfMS = parcelRequire("TbfMS");

var $5coU3 = parcelRequire("5coU3");

var $9AErM = parcelRequire("9AErM");

var $oMBXq = parcelRequire("oMBXq");

var $cynhR = parcelRequire("cynhR");

var $gFRU1 = parcelRequire("gFRU1");
const $e717d885d28255af$var$listStyle = (0, $1lyZZ.css)({
    maxHeight: 320,
    overflow: 'hidden',
    overflowY: 'scroll',
    listStyle: 'none',
    paddingRight: (0, $cbxDY.spacing).size2
});
const $e717d885d28255af$var$listItemStyle = (0, $1lyZZ.css)({
    display: 'flex',
    alignItems: 'center',
    minHeight: 64,
    borderBottom: `2px solid ${(0, $8JWbY.colors).neutralColors.slate20}`,
    backgroundColor: (0, $8JWbY.colors).neutralColors.white,
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: (0, $8JWbY.colors).neutralColors.slate05
    }
});
const $e717d885d28255af$var$iconStyle = (0, $1lyZZ.css)({
    marginRight: (0, $cbxDY.spacing).size4
});
const $e717d885d28255af$var$textStyle = (0, $1lyZZ.css)({
    color: (0, $8JWbY.colors).boldColors.lightBlue.base
});
const $e717d885d28255af$export$f9377213bb6b882c = ()=>{
    (0, $gFRU1.addDefaultBreadcrumb)('Customers loading', 'CustomerLoginPage');
    const { selectedCustomer: selectedCustomer, handleSelectedCustomerUpdate: handleSelectedCustomerUpdate, signOut: signOut } = (0, $dSPjH.useUser)();
    const client = (0, $c6uN4.useApolloClient)();
    const { labels: { svy_multi_customer_login_heading: svy_multi_customer_login_heading } } = (0, $cRlsu.useLabels)();
    (0, $gFRU1.addDefaultBreadcrumb)('Query customers', 'CustomerLoginPage');
    const { data: customersData, loading: getCustomersLoading, error: getCustomersError } = (0, $eBKZl.useQuery)((0, $9AErM.GET_CUSTOMERS));
    // Sold-tos with at least one active assessment, resolved via GET_SURVEY_LIST; null while still checking
    const [activeCustomers, setActiveCustomers] = (0, $a5EUy.useState)(null);
    const [activeCustomersError, setActiveCustomersError] = (0, $a5EUy.useState)(null);
    const customerIds = customersData?.getCustomers?.map((customer)=>customer.id).join(',');
    (0, $a5EUy.useEffect)(()=>{
        const customers = customersData?.getCustomers;
        // Only reset when there's stale data to clear, to avoid an extra render pass
        if (activeCustomers !== null) setActiveCustomers(null);
        if (activeCustomersError !== null) setActiveCustomersError(null);
        if (!customers?.length) return undefined;
        let isCancelled = false;
        async function filterActiveCustomers() {
            try {
                const results = await Promise.all(customers.map((customer)=>client.query({
                        query: (0, $oMBXq.GET_SURVEY_LIST),
                        variables: {
                            customerId: customer.id
                        },
                        fetchPolicy: 'network-only'
                    })));
                if (isCancelled) return;
                setActiveCustomers(customers.filter((_, index)=>{
                    const surveyList = results[index].data?.getSurveyList ?? [];
                    return surveyList.some((survey)=>survey.active);
                }));
            } catch (error) {
                if (!isCancelled) setActiveCustomersError(error);
            }
        }
        filterActiveCustomers();
        return ()=>{
            isCancelled = true;
        };
    // customersData is represented by the stable customerIds key
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        client,
        customerIds
    ]);
    if (selectedCustomer.id) {
        (0, $gFRU1.addDefaultBreadcrumb)('Customer ID selected', 'CustomerLoginPage.selectedCustomer');
        return /*#__PURE__*/ (0, $df8fE.jsx)((0, $glEgb.Redirect), {
            to: `/${(0, $5wEm6.routes).terms}`
        });
    }
    if (getCustomersLoading) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $cPiPb.OverlayPortal), {
        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $302dL.Spinner), {})
    });
    // Error boundary catches this error
    if (getCustomersError) (0, $gFRU1.throwErrorWithTransactionName)(getCustomersError, 'MultiCustomerLoginPage');
    if (customersData && !customersData.getCustomers.length) {
        (0, $gFRU1.addDefaultBreadcrumb)('No customers found for user', 'CustomerLoginPage.customerData');
        window.localStorage.setItem((0, $cynhR.userHasNoCustomersKey), true);
        signOut();
        return /*#__PURE__*/ (0, $df8fE.jsx)((0, $cPiPb.OverlayPortal), {
            children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $302dL.Spinner), {})
        });
    }
    // Error boundary catches this error
    if (activeCustomersError) (0, $gFRU1.throwErrorWithTransactionName)(activeCustomersError, 'MultiCustomerLoginPage');
    if (activeCustomers === null) return /*#__PURE__*/ (0, $df8fE.jsx)((0, $cPiPb.OverlayPortal), {
        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $302dL.Spinner), {})
    });
    if (!activeCustomers.length) {
        (0, $gFRU1.addDefaultBreadcrumb)('No sold-to with an active assessment found for user', 'CustomerLoginPage.customerData');
        return /*#__PURE__*/ (0, $df8fE.jsx)((0, $glEgb.Redirect), {
            to: `/${(0, $5wEm6.routes).noAssessments}`
        });
    }
    if (activeCustomers.length === 1) {
        const theOnlyCustomer = activeCustomers[0];
        (0, $gFRU1.addCustomBreadcrumb)({
            message: 'Single active customer found for user',
            category: 'CustomerLoginPage.customerData',
            data: {
                id: theOnlyCustomer.id
            }
        });
        handleSelectedCustomerUpdate({
            id: theOnlyCustomer.id,
            name: theOnlyCustomer.name
        });
    }
    return /*#__PURE__*/ (0, $df8fE.jsx)((0, $TbfMS.LoginLayout), {
        title: svy_multi_customer_login_heading,
        children: /*#__PURE__*/ (0, $df8fE.jsx)("ul", {
            css: $e717d885d28255af$var$listStyle,
            children: activeCustomers.map((customer)=>/*#__PURE__*/ (0, $df8fE.jsxs)("li", {
                    css: $e717d885d28255af$var$listItemStyle,
                    onClick: ()=>handleSelectedCustomerUpdate({
                            id: customer.id,
                            name: customer.name
                        }),
                    children: [
                        /*#__PURE__*/ (0, $df8fE.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($5coU3))),
                            alt: "User icon",
                            css: $e717d885d28255af$var$iconStyle
                        }),
                        /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                            css: $e717d885d28255af$var$textStyle,
                            children: `${customer.id} - ${customer.name}`
                        })
                    ]
                }, `customer-${customer.id}`))
        })
    });
};

});
parcelRegister("5coU3", function(module, exports) {
module.exports = $parcel$resolve("9zcNC");

});


parcelRegister("aLXfF", function(module, exports) {

$parcel$export(module.exports, "ErrorPage", function () { return $7d7c415148f07575$export$c120a0e80fd44ca6; });

var $df8fE = parcelRequire("df8fE");

var $1lyZZ = parcelRequire("1lyZZ");

var $BeyzD = parcelRequire("BeyzD");

var $2zgbn = parcelRequire("2zgbn");

var $cRlsu = parcelRequire("cRlsu");

var $dSPjH = parcelRequire("dSPjH");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $jahGf = parcelRequire("jahGf");
var $4AJXw = parcelRequire("4AJXw");
var $cbxDY = parcelRequire("cbxDY");

var $jUVGJ = parcelRequire("jUVGJ");
parcelRequire("hi8ts");
var $eFIEm = parcelRequire("eFIEm");

var $e5XFO = parcelRequire("e5XFO");
parcelRequire("3XIEi");
var $bzHnt = parcelRequire("bzHnt");
const $7d7c415148f07575$var$containerStyle = (0, $1lyZZ.css)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'red',
    background: `linear-gradient(${(0, $8JWbY.colors).boldColors.darkBlue.darkBlue80}, ${(0, $8JWbY.colors).boldColors.darkBlue.base})`,
    color: (0, $8JWbY.colors).neutralColors.white,
    textAlign: 'center',
    paddingBottom: 120
});
const $7d7c415148f07575$var$imageWrapperStyle = (0, $1lyZZ.css)({
    display: 'flex',
    alignItems: 'flex-end',
    marginTop: 40,
    width: 200,
    [(0, $4AJXw.media).medium]: {
        marginTop: 80,
        width: 'auto'
    }
});
const $7d7c415148f07575$var$svgStyle = (0, $1lyZZ.css)({
    width: '100%',
    height: 'auto'
});
const $7d7c415148f07575$var$svgWrapperLeftStyle = (0, $1lyZZ.css)({
    width: 120,
    marginRight: (0, $cbxDY.spacing).size5,
    '& > img': {
        transform: 'matrix(-1, 0, 0, 1, 0, 0);'
    }
});
const $7d7c415148f07575$var$svgWrapperRightStyle = (0, $1lyZZ.css)({
    width: 220
});
const $7d7c415148f07575$var$headerStyle = (0, $1lyZZ.css)({
    fontWeight: (0, $jahGf.font).weight.medium,
    marginBottom: (0, $cbxDY.spacing).size7,
    marginTop: (0, $cbxDY.spacing).size12,
    fontSize: (0, $jahGf.font).size.size3,
    lineHeight: (0, $jahGf.font).lineHeight.s,
    padding: `0 ${(0, $cbxDY.spacing).size4}px`,
    [(0, $4AJXw.media).medium]: {
        fontSize: (0, $jahGf.font).size.size5
    }
});
const $7d7c415148f07575$var$bodyTextStyle = (0, $1lyZZ.css)({
    maxWidth: 500,
    lineHeight: (0, $jahGf.font).lineHeight.m,
    padding: `0 ${(0, $cbxDY.spacing).size4}px`
});
const $7d7c415148f07575$var$contactMailLinkStyle = (0, $1lyZZ.css)({
    marginTop: (0, $cbxDY.spacing).size6,
    marginBottom: (0, $cbxDY.spacing).size12,
    '&:link, &:hover, &:active, &:visited': {
        color: (0, $8JWbY.colors).neutralColors.white,
        textDecoration: 'underline'
    }
});
const $7d7c415148f07575$var$buttonStyle = (0, $1lyZZ.css)({
    marginTop: (0, $cbxDY.spacing).size6,
    padding: `${(0, $cbxDY.spacing).size2}px ${(0, $cbxDY.spacing).size4}px`,
    border: 'none',
    cursor: 'pointer',
    backgroundColor: (0, $8JWbY.colors).neutralColors.white,
    color: (0, $8JWbY.colors).boldColors.darkBlue.base,
    textDecoration: 'none',
    borderRadius: 4,
    fontWeight: (0, $jahGf.font).weight.medium,
    '&:hover': {
        backgroundColor: (0, $8JWbY.colors).neutralColors.slate05
    },
    display: 'flex',
    alignItems: 'center'
});
const $7d7c415148f07575$export$c120a0e80fd44ca6 = ()=>{
    const { labels: { svy_sign_in_button: svy_sign_in_button, svy_error_page_header: svy_error_page_header, svy_error_page_body_text: svy_error_page_body_text } } = (0, $cRlsu.useLabels)();
    const { legoContactEmail: legoContactEmail, cognitoData: cognitoData } = (0, $dSPjH.useUser)();
    const isLegacyUser = (0, $e5XFO.isLoggedInWithWrongIdentityProvider)(cognitoData);
    return /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                css: $7d7c415148f07575$var$containerStyle,
                children: [
                    /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                        css: $7d7c415148f07575$var$imageWrapperStyle,
                        children: [
                            /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                                css: $7d7c415148f07575$var$svgWrapperLeftStyle,
                                children: /*#__PURE__*/ (0, $df8fE.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($jUVGJ))),
                                    css: $7d7c415148f07575$var$svgStyle
                                })
                            }),
                            /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                                css: $7d7c415148f07575$var$svgWrapperRightStyle,
                                children: /*#__PURE__*/ (0, $df8fE.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($jUVGJ))),
                                    css: $7d7c415148f07575$var$svgStyle
                                })
                            })
                        ]
                    }),
                    isLegacyUser ? /*#__PURE__*/ (0, $df8fE.jsxs)("button", {
                        css: $7d7c415148f07575$var$buttonStyle,
                        "data-transaction-name": "Sign in",
                        "aria-label": "Sign in",
                        onClick: ()=>(0, $bzHnt.Auth).federatedSignIn({
                                customProvider: "partner-idp-survey"
                            }),
                        children: [
                            /*#__PURE__*/ (0, $df8fE.jsx)((0, $eFIEm.HomeBold), {
                                size: 24,
                                color: (0, $8JWbY.colors).boldColors.darkBlue.base
                            }),
                            /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                                css: (0, $1lyZZ.css)`
                margin-left: ${(0, $cbxDY.spacing).size2}px;
              `,
                                children: svy_sign_in_button
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $df8fE.jsxs)((0, $BeyzD.Link), {
                        to: "/",
                        css: $7d7c415148f07575$var$buttonStyle,
                        children: [
                            /*#__PURE__*/ (0, $df8fE.jsx)((0, $eFIEm.HomeBold), {
                                size: 24,
                                color: (0, $8JWbY.colors).boldColors.darkBlue.base
                            }),
                            /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                                css: (0, $1lyZZ.css)`
                margin-left: ${(0, $cbxDY.spacing).size2}px;
              `,
                                children: "Home"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)("h1", {
                        css: $7d7c415148f07575$var$headerStyle,
                        children: svy_error_page_header
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)("p", {
                        css: $7d7c415148f07575$var$bodyTextStyle,
                        children: svy_error_page_body_text
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsx)("a", {
                        css: $7d7c415148f07575$var$contactMailLinkStyle,
                        href: `mailto:${legoContactEmail}`,
                        children: legoContactEmail
                    })
                ]
            }),
            /*#__PURE__*/ (0, $df8fE.jsx)((0, $2zgbn.Footer), {})
        ]
    });
};

});
parcelRegister("jUVGJ", function(module, exports) {
module.exports = $parcel$resolve("jf4A8");

});


parcelRegister("MNWHJ", function(module, exports) {

$parcel$export(module.exports, "NoAssessmentsPage", function () { return $092b3a038bc64b29$export$df4a373ab2ee454d; });

var $df8fE = parcelRequire("df8fE");

var $1lyZZ = parcelRequire("1lyZZ");

var $2zgbn = parcelRequire("2zgbn");

var $cRlsu = parcelRequire("cRlsu");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $jahGf = parcelRequire("jahGf");
var $4AJXw = parcelRequire("4AJXw");
var $cbxDY = parcelRequire("cbxDY");

const $092b3a038bc64b29$var$containerStyle = (0, $1lyZZ.css)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: (0, $cbxDY.spacing).size8,
    minHeight: 'calc(100vh - 320px)',
    padding: `${(0, $cbxDY.spacing).size12}px ${(0, $cbxDY.spacing).size6}px`,
    [(0, $4AJXw.media).medium]: {
        flexDirection: 'row',
        gap: (0, $cbxDY.spacing).size12,
        padding: `${(0, $cbxDY.spacing).size16}px ${(0, $cbxDY.spacing).size8}px`
    },
    [(0, $4AJXw.media).large]: {
        gap: (0, $cbxDY.spacing).size16,
        minHeight: 'calc(100vh - 280px)'
    }
});
const $092b3a038bc64b29$var$imageStyle = (0, $1lyZZ.css)({
    width: 'min(32vw, 280px)',
    height: 'auto',
    [(0, $4AJXw.media).medium]: {
        width: 'min(30vw, 360px)'
    }
});
const $092b3a038bc64b29$var$contentStyle = (0, $1lyZZ.css)({
    maxWidth: 720,
    textAlign: 'left'
});
const $092b3a038bc64b29$var$accessGrantedStyle = (0, $1lyZZ.css)({
    margin: 0,
    fontSize: (0, $jahGf.font).size.size2,
    fontWeight: (0, $jahGf.font).weight.bold,
    lineHeight: (0, $jahGf.font).lineHeight.s
});
const $092b3a038bc64b29$var$headingStyle = (0, $1lyZZ.css)({
    margin: `${(0, $cbxDY.spacing).size5}px 0 ${(0, $cbxDY.spacing).size8}px`,
    color: (0, $8JWbY.colors).boldColors.lightBlue.lightBlue30,
    fontSize: 'clamp(2rem, 5vw, 5rem)',
    fontWeight: (0, $jahGf.font).weight.bold,
    lineHeight: 1.08
});
const $092b3a038bc64b29$var$bodyStyle = (0, $1lyZZ.css)({
    margin: 0,
    fontSize: (0, $jahGf.font).size.size05,
    lineHeight: (0, $jahGf.font).lineHeight.l,
    whiteSpace: 'pre-line'
});
const $092b3a038bc64b29$export$df4a373ab2ee454d = ()=>{
    const { labels: { svy_no_assessments_header: svy_no_assessments_header, svy_access_granted: svy_access_granted }, richTextLabels: { svy_no_assessments_content: svy_no_assessments_content } } = (0, $cRlsu.useLabels)();
    return /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $df8fE.jsxs)("main", {
                css: $092b3a038bc64b29$var$containerStyle,
                children: [
                    /*#__PURE__*/ (0, $df8fE.jsx)("img", {
                        src: (0, {}),
                        css: $092b3a038bc64b29$var$imageStyle,
                        alt: "",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                        css: $092b3a038bc64b29$var$contentStyle,
                        children: [
                            /*#__PURE__*/ (0, $df8fE.jsx)("p", {
                                css: $092b3a038bc64b29$var$accessGrantedStyle,
                                children: svy_access_granted
                            }),
                            /*#__PURE__*/ (0, $df8fE.jsx)("h1", {
                                css: $092b3a038bc64b29$var$headingStyle,
                                children: svy_no_assessments_header
                            }),
                            /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                                css: $092b3a038bc64b29$var$bodyStyle,
                                dangerouslySetInnerHTML: {
                                    __html: svy_no_assessments_content
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $df8fE.jsx)((0, $2zgbn.Footer), {})
        ]
    });
};

});

parcelRegister("93HRk", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", function () { return $69866a6644fa7103$export$e926676385687eaf; });

var $a5EUy = parcelRequire("a5EUy");
'use client';
const $69866a6644fa7103$export$b16d9fb1a22de840 = (0, $a5EUy.createContext)(null);
const $69866a6644fa7103$var$initialState = {
    didCatch: false,
    error: null
};
class $69866a6644fa7103$export$e926676385687eaf extends (0, $a5EUy.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $69866a6644fa7103$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($69866a6644fa7103$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $69866a6644fa7103$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($69866a6644fa7103$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $a5EUy.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $a5EUy.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $a5EUy.createElement)($69866a6644fa7103$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $69866a6644fa7103$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $69866a6644fa7103$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $69866a6644fa7103$export$c052f6604b7d51fe() {
    const context = (0, $a5EUy.useContext)($69866a6644fa7103$export$b16d9fb1a22de840);
    $69866a6644fa7103$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $a5EUy.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $a5EUy.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $69866a6644fa7103$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $a5EUy.forwardRef)((props, ref)=>(0, $a5EUy.createElement)($69866a6644fa7103$export$e926676385687eaf, errorBoundaryProps, (0, $a5EUy.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});



parcelRegister("bSyi6", function(module, exports) {

$parcel$export(module.exports, "AssessmentStatusCell", function () { return $8a5f565905fdf002$export$685ee1fb263cb50a; });

var $df8fE = parcelRequire("df8fE");

var $3yJBl = parcelRequire("3yJBl");

var $lBRzO = parcelRequire("lBRzO");
const $8a5f565905fdf002$export$685ee1fb263cb50a = ({ cell: { value: value } })=>/*#__PURE__*/ (0, $df8fE.jsx)((0, $lBRzO.AssessmentStatus), {
        status: value
    });
$8a5f565905fdf002$export$685ee1fb263cb50a.propTypes = {
    cell: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).object.isRequired
};

});
parcelRegister("lBRzO", function(module, exports) {

$parcel$export(module.exports, "AssessmentStatus", function () { return $fbb69ce1624972aa$export$839a5986ed18420; });

var $df8fE = parcelRequire("df8fE");

var $3yJBl = parcelRequire("3yJBl");

var $1lyZZ = parcelRequire("1lyZZ");

var $cRlsu = parcelRequire("cRlsu");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $cbxDY = parcelRequire("cbxDY");
parcelRequire("dnijQ");
var $fmWA7 = parcelRequire("fmWA7");
const $fbb69ce1624972aa$var$wrapperStyle = (0, $1lyZZ.css)({
    display: 'flex',
    alignItems: 'center'
});
const $fbb69ce1624972aa$var$colorStyle = (color)=>(0, $1lyZZ.css)({
        display: 'block',
        width: 12,
        height: 12,
        borderRadius: '50%',
        backgroundColor: color,
        marginRight: (0, $cbxDY.spacing).size2
    });
const $fbb69ce1624972aa$export$839a5986ed18420 = ({ status: status })=>{
    const { labels: { svy_status_not_submitted: svy_status_not_submitted, svy_status_changes_required: svy_status_changes_required, svy_status_rescoring_required: svy_status_rescoring_required, svy_status_in_lego_review: svy_status_in_lego_review, svy_status_completed: svy_status_completed } } = (0, $cRlsu.useLabels)();
    const assessmentStatuses = {
        [(0, $fmWA7.surveyStatus).NOT_SUBMITTED]: {
            text: svy_status_not_submitted,
            color: (0, $8JWbY.colors).accentColors.gold.base
        },
        [(0, $fmWA7.surveyStatus).CHANGES_REQUIRED]: {
            text: svy_status_changes_required,
            color: (0, $8JWbY.colors).utilityColors.error.error500
        },
        [(0, $fmWA7.surveyStatus).RESCORING_REQUIRED]: {
            text: svy_status_rescoring_required,
            color: (0, $8JWbY.colors).accentColors.gold.base
        },
        [(0, $fmWA7.surveyStatus).IN_LEGO_REVIEW]: {
            text: svy_status_in_lego_review,
            color: (0, $8JWbY.colors).neutralColors.slate40
        },
        [(0, $fmWA7.surveyStatus).COMPLETED]: {
            text: svy_status_completed,
            color: (0, $8JWbY.colors).utilityColors.success.dark
        }
    };
    const { text: text, color: color } = assessmentStatuses[status];
    return /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
        css: $fbb69ce1624972aa$var$wrapperStyle,
        children: [
            /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                css: $fbb69ce1624972aa$var$colorStyle(color)
            }),
            /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                children: text
            })
        ]
    });
};
$fbb69ce1624972aa$export$839a5986ed18420.propTypes = {
    status: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string.isRequired
};

});



parcelRegister("l35Y2", function(module, exports) {

$parcel$export(module.exports, "Banner", function () { return $f52e81c17687b35f$export$3b4e64e77073e307; });

var $df8fE = parcelRequire("df8fE");

var $3yJBl = parcelRequire("3yJBl");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("hi8ts");
var $gJq8e = parcelRequire("gJq8e");
parcelRequire("i7Pqi");
var $gdpIa = parcelRequire("gdpIa");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $jahGf = parcelRequire("jahGf");
var $4AJXw = parcelRequire("4AJXw");
var $cbxDY = parcelRequire("cbxDY");
const $f52e81c17687b35f$var$bannerContainerStyle = (position)=>(0, $1lyZZ.css)({
        display: 'flex',
        justifyContent: 'space-between',
        position: position === 'top' ? 'absolute' : 'fixed',
        left: (0, $cbxDY.spacing).size4,
        right: (0, $cbxDY.spacing).size4,
        bottom: position === 'bottom' ? (0, $cbxDY.spacing).size4 : 'auto',
        top: position === 'top' ? 108 : 'auto',
        border: `1px solid ${(0, $8JWbY.colors).utilityColors.information.information400}`,
        borderLeftWidth: 12,
        backgroundColor: (0, $8JWbY.colors).utilityColors.information.information50,
        borderRadius: 2,
        padding: (0, $cbxDY.spacing).size4,
        boxShadow: '0px 2px 0px rgba(0, 0, 0, 0.1)',
        [(0, $4AJXw.media).medium]: {
            left: (0, $cbxDY.spacing).size12,
            right: (0, $cbxDY.spacing).size12,
            bottom: position === 'bottom' ? (0, $cbxDY.spacing).size12 : 'auto',
            top: position === 'top' ? 96 : 'auto'
        }
    });
const $f52e81c17687b35f$var$leftContainerStyle = (0, $1lyZZ.css)({
    display: 'flex',
    alignItems: 'flex-start'
});
const $f52e81c17687b35f$var$iconStyle = (0, $1lyZZ.css)({
    marginRight: (0, $cbxDY.spacing).size3
});
const $f52e81c17687b35f$var$textWrapperStyle = (0, $1lyZZ.css)({
    marginRight: (0, $cbxDY.spacing).size2
});
const $f52e81c17687b35f$var$headerTextStyle = (0, $1lyZZ.css)({
    fontWeight: (0, $jahGf.font).weight.medium
});
const $f52e81c17687b35f$var$bodyTextStyle = (0, $1lyZZ.css)({
    fontSize: (0, $jahGf.font).size.sizeM1
});
const $f52e81c17687b35f$var$buttonWrapperStyle = (0, $1lyZZ.css)({
    flexShrink: 0,
    marginTop: -(0, $cbxDY.spacing).size2
});
const $f52e81c17687b35f$export$3b4e64e77073e307 = ({ icon: icon, header: header, text: text, position: position = 'bottom', onClose: onClose })=>{
    return /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
        css: $f52e81c17687b35f$var$bannerContainerStyle(position),
        role: "banner",
        children: [
            /*#__PURE__*/ (0, $df8fE.jsxs)("span", {
                css: $f52e81c17687b35f$var$leftContainerStyle,
                children: [
                    /*#__PURE__*/ (0, $df8fE.jsx)("img", {
                        src: icon,
                        css: $f52e81c17687b35f$var$iconStyle
                    }),
                    /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                        css: $f52e81c17687b35f$var$textWrapperStyle,
                        children: [
                            /*#__PURE__*/ (0, $df8fE.jsx)("h4", {
                                css: $f52e81c17687b35f$var$headerTextStyle,
                                children: header
                            }),
                            /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                                css: $f52e81c17687b35f$var$bodyTextStyle,
                                children: text
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $df8fE.jsx)("span", {
                css: $f52e81c17687b35f$var$buttonWrapperStyle,
                children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                    "data-transaction-name": "Close banner button",
                    "aria-label": "Close banner button",
                    icon: /*#__PURE__*/ (0, $df8fE.jsx)((0, $gJq8e.Cross), {}),
                    variant: "ghost",
                    size: "small",
                    onClick: onClose
                })
            })
        ]
    });
};
$f52e81c17687b35f$export$3b4e64e77073e307.propTypes = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string,
    header: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string.isRequired,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).string,
    position: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).oneOf([
        'top',
        'bottom'
    ]),
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).func
};

});

parcelRegister("c0lKT", function(module, exports) {
module.exports = $parcel$resolve("jYx7o");

});

parcelRegister("dyrOw", function(module, exports) {

$parcel$export(module.exports, "replaceContactEmail", function () { return $9de4069af348f868$export$91f809248d2a5c66; });
const $9de4069af348f868$export$91f809248d2a5c66 = (welcomeText, emailPlaceholder, contactEmail)=>{
    const emailPlaceholderPattern = new RegExp(`${emailPlaceholder}`, 'i');
    const replacedText = welcomeText.replace(emailPlaceholderPattern, `<a href="mailto:${contactEmail}">${contactEmail}</a>`);
    return replacedText;
};

});




var $973682f19952cb55$exports = {};
$parcel$extendImportMap({
    "87muW": "lego-web.4a42c8e3.svg",
    "cy9m2": "lego-brick.dedb30a9.svg",
    "iH9dE": "checkmark.6bfd9145.svg",
    "gYmi5": "hero_minifig.55c8124b.png",
    "bB4A6": "lego-404.8067b124.svg",
    "9zcNC": "lego_user.91b57819.svg",
    "jf4A8": "lego-error-page.50fe5bbf.svg",
    "4TREO": "brick_10_minifig.2384038b.png",
    "jYx7o": "lego-cookie.8386af8a.svg"
});


var $df8fE = parcelRequire("df8fE");

var $jUibk = parcelRequire("jUibk");

var $df8fE = parcelRequire("df8fE");

var $a5EUy = parcelRequire("a5EUy");

var $BeyzD = parcelRequire("BeyzD");

var $df8fE = parcelRequire("df8fE");

var $3yJBl = parcelRequire("3yJBl");
parcelRequire("3XIEi");
var $bzHnt = parcelRequire("bzHnt");
var $3XIEi = parcelRequire("3XIEi");
parcelRequire("2UBc8");
var $fbze5 = parcelRequire("fbze5");
var $8MgJN = parcelRequire("8MgJN");
var $6I6uN = parcelRequire("6I6uN");
var $laC1A = parcelRequire("laC1A");
var $coVSr = parcelRequire("coVSr");

var $6tz0u = parcelRequire("6tz0u");

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("kYdsw");
var $8MgJN = parcelRequire("8MgJN");
parcelRequire("jDiDD");
var $9uTW6 = parcelRequire("9uTW6");
function $edbdc4c5b34e0180$export$2288787135a8f66e(errorHandler) {
    return new (0, $8MgJN.ApolloLink)(function(operation, forward) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6)))(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $edbdc4c5b34e0180$export$d2c8415987899609 = function(_super) {
    (0, $fH1jI.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $edbdc4c5b34e0180$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $8MgJN.ApolloLink));


var $1410b8b3ffbaa4c0$exports = {};
"use strict";
Object.defineProperty($1410b8b3ffbaa4c0$exports, "__esModule", {
    value: true
});
var $dfd71476b1c3adef$exports = {};
"use strict";
var $dfd71476b1c3adef$var$__extends = $dfd71476b1c3adef$exports && $dfd71476b1c3adef$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $dfd71476b1c3adef$var$__assign = $dfd71476b1c3adef$exports && $dfd71476b1c3adef$exports.__assign || function() {
    $dfd71476b1c3adef$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dfd71476b1c3adef$var$__assign.apply(this, arguments);
};
var $dfd71476b1c3adef$var$__awaiter = $dfd71476b1c3adef$exports && $dfd71476b1c3adef$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $dfd71476b1c3adef$var$__generator = $dfd71476b1c3adef$exports && $dfd71476b1c3adef$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($dfd71476b1c3adef$exports, "__esModule", {
    value: true
});
parcelRequire("8tgyX");

var $71YrH = parcelRequire("71YrH");

var $iWkR3 = parcelRequire("iWkR3");


var $8tgyX = parcelRequire("8tgyX");
var $iWkR3 = parcelRequire("iWkR3");

var $8tgyX = parcelRequire("8tgyX");
var $iWkR3 = parcelRequire("iWkR3");

var $6am30 = parcelRequire("6am30");
var $a0caad76fc6ad03b$exports = {};
"use strict";
function $a0caad76fc6ad03b$var$__export(m) {
    for(var p in m)if (!$a0caad76fc6ad03b$exports.hasOwnProperty(p)) $a0caad76fc6ad03b$exports[p] = m[p];
}
Object.defineProperty($a0caad76fc6ad03b$exports, "__esModule", {
    value: true
});

/*!
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ $a0caad76fc6ad03b$var$__export((parcelRequire("3Akwr")));



var $2qlBa = parcelRequire("2qlBa");
var $6232778700d994a1$exports = {};
"use strict";
Object.defineProperty($6232778700d994a1$exports, "__esModule", {
    value: true
});
var $6232778700d994a1$var$userAgent = '';
$6232778700d994a1$exports.userAgent = $6232778700d994a1$var$userAgent;


var $be3780bd09076c70$exports = {};
$be3780bd09076c70$exports = JSON.parse("{\"name\":\"aws-appsync-auth-link\",\"version\":\"2.0.8\",\"main\":\"lib/index.js\",\"license\":\"Apache-2.0\",\"description\":\"AWS Mobile AppSync Auth Link for JavaScript\",\"author\":{\"name\":\"Amazon Web Services\",\"url\":\"https://aws.amazon.com/\"},\"homepage\":\"https://github.com/awslabs/aws-mobile-appsync-sdk-js.git\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/awslabs/aws-mobile-appsync-sdk-js.git\"},\"scripts\":{\"prepare\":\"tsc\",\"test\":\"jest --coverage --coverageReporters=text --passWithNoTests\",\"test-watch\":\"jest --watch\"},\"dependencies\":{\"@aws-crypto/sha256-js\":\"^1.2.0\",\"@aws-sdk/types\":\"^3.25.0\",\"@aws-sdk/util-hex-encoding\":\"^3.29.0\",\"apollo-link\":\"1.2.5\",\"debug\":\"2.6.9\"}}");


var $dfd71476b1c3adef$var$SERVICE = 'appsync';
$dfd71476b1c3adef$exports.USER_AGENT_HEADER = 'x-amz-user-agent';
$dfd71476b1c3adef$exports.USER_AGENT = "aws-amplify/" + $be3780bd09076c70$exports.version + ($6232778700d994a1$exports.userAgent && ' ') + $6232778700d994a1$exports.userAgent;
var $dfd71476b1c3adef$var$AUTH_TYPE;
(function(AUTH_TYPE) {
    AUTH_TYPE["NONE"] = "NONE";
    AUTH_TYPE["API_KEY"] = "API_KEY";
    AUTH_TYPE["AWS_IAM"] = "AWS_IAM";
    AUTH_TYPE["AMAZON_COGNITO_USER_POOLS"] = "AMAZON_COGNITO_USER_POOLS";
    AUTH_TYPE["OPENID_CONNECT"] = "OPENID_CONNECT";
    AUTH_TYPE["AWS_LAMBDA"] = "AWS_LAMBDA";
})($dfd71476b1c3adef$var$AUTH_TYPE = $dfd71476b1c3adef$exports.AUTH_TYPE || ($dfd71476b1c3adef$exports.AUTH_TYPE = {}));
var $dfd71476b1c3adef$var$AuthLink = /** @class */ function(_super) {
    $dfd71476b1c3adef$var$__extends(AuthLink, _super);
    /**
     *
     * @param {*} options
     */ function AuthLink(options) {
        var _this = _super.call(this) || this;
        _this.link = $dfd71476b1c3adef$exports.authLink(options);
        return _this;
    }
    AuthLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return AuthLink;
}($8tgyX.ApolloLink);
$dfd71476b1c3adef$exports.AuthLink = $dfd71476b1c3adef$var$AuthLink;
var $dfd71476b1c3adef$var$headerBasedAuth = function(_a, operation, forward) {
    var _b = _a === void 0 ? {
        header: '',
        value: ''
    } : _a, header = _b.header, value = _b.value;
    return $dfd71476b1c3adef$var$__awaiter(void 0, void 0, void 0, function() {
        var origContext, headers, headerValue, _c;
        var _d, _e;
        return $dfd71476b1c3adef$var$__generator(this, function(_f) {
            switch(_f.label){
                case 0:
                    origContext = operation.getContext();
                    headers = $dfd71476b1c3adef$var$__assign($dfd71476b1c3adef$var$__assign({}, origContext.headers), (_d = {}, _d[$dfd71476b1c3adef$exports.USER_AGENT_HEADER] = $dfd71476b1c3adef$exports.USER_AGENT, _d));
                    if (!(header && value)) return [
                        3 /*break*/ ,
                        5
                    ];
                    if (!(typeof value === 'function')) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        value.call(undefined)
                    ];
                case 1:
                    _c = _f.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    return [
                        4 /*yield*/ ,
                        value
                    ];
                case 3:
                    _c = _f.sent();
                    _f.label = 4;
                case 4:
                    headerValue = _c;
                    headers = $dfd71476b1c3adef$var$__assign((_e = {}, _e[header] = headerValue, _e), headers);
                    _f.label = 5;
                case 5:
                    operation.setContext($dfd71476b1c3adef$var$__assign($dfd71476b1c3adef$var$__assign({}, origContext), {
                        headers: headers
                    }));
                    return [
                        2 /*return*/ ,
                        forward(operation)
                    ];
            }
        });
    });
};
var $dfd71476b1c3adef$var$iamBasedAuth = function(_a, operation, forward) {
    var credentials = _a.credentials, region = _a.region, url = _a.url;
    return $dfd71476b1c3adef$var$__awaiter(void 0, void 0, void 0, function() {
        var service, origContext, creds, _b, accessKeyId, secretAccessKey, sessionToken, _c, host, path, formatted, headers;
        var _d;
        return $dfd71476b1c3adef$var$__generator(this, function(_e) {
            switch(_e.label){
                case 0:
                    service = $dfd71476b1c3adef$var$SERVICE;
                    origContext = operation.getContext();
                    creds = typeof credentials === 'function' ? credentials.call() : credentials || {};
                    if (!(creds && typeof creds.getPromise === 'function')) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        creds.getPromise()
                    ];
                case 1:
                    _e.sent();
                    _e.label = 2;
                case 2:
                    return [
                        4 /*yield*/ ,
                        creds
                    ];
                case 3:
                    _b = _e.sent(), accessKeyId = _b.accessKeyId, secretAccessKey = _b.secretAccessKey, sessionToken = _b.sessionToken;
                    _c = $2qlBa.parse(url), host = _c.host, path = _c.path;
                    formatted = $dfd71476b1c3adef$var$__assign($dfd71476b1c3adef$var$__assign({}, $dfd71476b1c3adef$var$formatAsRequest(operation, {})), {
                        service: service,
                        region: region,
                        url: url,
                        host: host,
                        path: path
                    });
                    headers = $a0caad76fc6ad03b$exports.Signer.sign(formatted, {
                        access_key: accessKeyId,
                        secret_key: secretAccessKey,
                        session_token: sessionToken
                    }).headers;
                    operation.setContext($dfd71476b1c3adef$var$__assign($dfd71476b1c3adef$var$__assign({}, origContext), {
                        headers: $dfd71476b1c3adef$var$__assign($dfd71476b1c3adef$var$__assign($dfd71476b1c3adef$var$__assign({}, origContext.headers), headers), (_d = {}, _d[$dfd71476b1c3adef$exports.USER_AGENT_HEADER] = $dfd71476b1c3adef$exports.USER_AGENT, _d))
                    }));
                    return [
                        2 /*return*/ ,
                        forward(operation)
                    ];
            }
        });
    });
};
$dfd71476b1c3adef$exports.authLink = function(_a) {
    var url = _a.url, region = _a.region, _b = _a.auth, type = (_b === void 0 ? {} : _b).type, auth = _a.auth;
    return new $8tgyX.ApolloLink(function(operation, forward) {
        return new $iWkR3.default(function(observer) {
            var handle;
            var promise;
            switch(type){
                case $dfd71476b1c3adef$var$AUTH_TYPE.NONE:
                    promise = $dfd71476b1c3adef$var$headerBasedAuth(undefined, operation, forward);
                    break;
                case $dfd71476b1c3adef$var$AUTH_TYPE.AWS_IAM:
                    var _a = auth.credentials, credentials = _a === void 0 ? {} : _a;
                    promise = $dfd71476b1c3adef$var$iamBasedAuth({
                        credentials: credentials,
                        region: region,
                        url: url
                    }, operation, forward);
                    break;
                case $dfd71476b1c3adef$var$AUTH_TYPE.API_KEY:
                    var _b = auth.apiKey, apiKey = _b === void 0 ? '' : _b;
                    promise = $dfd71476b1c3adef$var$headerBasedAuth({
                        header: 'X-Api-Key',
                        value: apiKey
                    }, operation, forward);
                    break;
                case $dfd71476b1c3adef$var$AUTH_TYPE.AMAZON_COGNITO_USER_POOLS:
                case $dfd71476b1c3adef$var$AUTH_TYPE.OPENID_CONNECT:
                    var _c = auth.jwtToken, jwtToken = _c === void 0 ? '' : _c;
                    promise = $dfd71476b1c3adef$var$headerBasedAuth({
                        header: 'Authorization',
                        value: jwtToken
                    }, operation, forward);
                    break;
                case $dfd71476b1c3adef$var$AUTH_TYPE.AWS_LAMBDA:
                    var _d = auth.token, token = _d === void 0 ? '' : _d;
                    promise = $dfd71476b1c3adef$var$headerBasedAuth({
                        header: 'Authorization',
                        value: token
                    }, operation, forward);
                    break;
                default:
                    var error = new Error("Invalid AUTH_TYPE: " + auth.type);
                    throw error;
            }
            promise.then(function(observable) {
                handle = observable.subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            });
            return function() {
                if (handle) handle.unsubscribe();
            };
        });
    });
};
var $dfd71476b1c3adef$var$formatAsRequest = function(_a, options) {
    var operationName = _a.operationName, variables = _a.variables, query = _a.query;
    var body = {
        operationName: operationName,
        variables: $dfd71476b1c3adef$var$removeTemporaryVariables(variables),
        query: $6am30.print(query)
    };
    return $dfd71476b1c3adef$var$__assign($dfd71476b1c3adef$var$__assign({
        body: JSON.stringify(body),
        method: 'POST'
    }, options), {
        headers: $dfd71476b1c3adef$var$__assign({
            accept: '*/*',
            'content-type': 'application/json; charset=UTF-8'
        }, options.headers)
    });
};
/**
 * Removes all temporary variables (starting with '@@') so that the signature matches the final request.
 */ var $dfd71476b1c3adef$var$removeTemporaryVariables = function(variables) {
    return Object.keys(variables).filter(function(key) {
        return !key.startsWith("@@");
    }).reduce(function(acc, key) {
        acc[key] = variables[key];
        return acc;
    }, {});
};


$1410b8b3ffbaa4c0$exports.AuthLink = $dfd71476b1c3adef$exports.AuthLink;
$1410b8b3ffbaa4c0$exports.AUTH_TYPE = $dfd71476b1c3adef$exports.AUTH_TYPE;
$1410b8b3ffbaa4c0$exports.USER_AGENT_HEADER = $dfd71476b1c3adef$exports.USER_AGENT_HEADER;
$1410b8b3ffbaa4c0$exports.USER_AGENT = $dfd71476b1c3adef$exports.USER_AGENT;
$1410b8b3ffbaa4c0$exports.createAuthLink = function(_a) {
    var url = _a.url, region = _a.region, auth = _a.auth;
    return new $dfd71476b1c3adef$exports.AuthLink({
        url: url,
        region: region,
        auth: auth
    });
};

$1410b8b3ffbaa4c0$exports.Signer = $a0caad76fc6ad03b$exports.Signer;


var $f102cb105c81b828$exports = {};
"use strict";
var $f102cb105c81b828$var$__rest = $f102cb105c81b828$exports && $f102cb105c81b828$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty($f102cb105c81b828$exports, "__esModule", {
    value: true
});
var $74a8a792cabd7b79$exports = {};
"use strict";
var $74a8a792cabd7b79$var$__extends = $74a8a792cabd7b79$exports && $74a8a792cabd7b79$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $74a8a792cabd7b79$var$__assign = $74a8a792cabd7b79$exports && $74a8a792cabd7b79$exports.__assign || function() {
    $74a8a792cabd7b79$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $74a8a792cabd7b79$var$__assign.apply(this, arguments);
};
var $74a8a792cabd7b79$var$__awaiter = $74a8a792cabd7b79$exports && $74a8a792cabd7b79$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $74a8a792cabd7b79$var$__generator = $74a8a792cabd7b79$exports && $74a8a792cabd7b79$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $74a8a792cabd7b79$var$__rest = $74a8a792cabd7b79$exports && $74a8a792cabd7b79$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty($74a8a792cabd7b79$exports, "__esModule", {
    value: true
});
parcelRequire("aJi19");
var $jWiaX = parcelRequire("jWiaX");
var $8MgJN = parcelRequire("8MgJN");
var $9uTW6 = parcelRequire("9uTW6");
var $79811f83b909f6d2$exports = {};
"use strict";
Object.defineProperty($79811f83b909f6d2$exports, "__esModule", {
    value: true
});
var $8ac9138cfb5143da$exports = {};
"use strict";
var $8ac9138cfb5143da$var$__spreadArrays = $8ac9138cfb5143da$exports && $8ac9138cfb5143da$exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty($8ac9138cfb5143da$exports, "__esModule", {
    value: true
});

var $i6Sec = parcelRequire("i6Sec");
var $8ac9138cfb5143da$var$debugLogger = $i6Sec.default('aws-appsync');
var $8ac9138cfb5143da$var$extend = function(category) {
    if (category === void 0) category = '';
    var newCategory = category ? $8ac9138cfb5143da$var$__spreadArrays(this.namespace.split(':'), [
        category
    ]).join(':') : this.namespace;
    var result = $i6Sec.default(newCategory);
    result.extend = $8ac9138cfb5143da$var$extend.bind(result);
    return result;
};
$8ac9138cfb5143da$var$debugLogger.extend = $8ac9138cfb5143da$var$extend.bind($8ac9138cfb5143da$var$debugLogger);
$8ac9138cfb5143da$exports.default = $8ac9138cfb5143da$var$debugLogger;


$79811f83b909f6d2$exports.rootLogger = $8ac9138cfb5143da$exports.default;


var $291e12ce1a4c3c7e$exports = {};
/*******************************************************************************
 * Copyright (c) 2013 IBM Corp.
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License v1.0
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *    http://www.eclipse.org/legal/epl-v10.html
 * and the Eclipse Distribution License is available at
 *   http://www.eclipse.org/org/documents/edl-v10.php.
 *
 * Contributors:
 *    Andrew Banks - initial API and implementation and initial documentation
 *******************************************************************************/ // Only expose a single object name in the global namespace.
// Everything must go through this module. Global Paho module
// only has a single public function, client, which returns
// a Paho client object given connection details.
/**
 * Send and receive messages using web browsers.
 * <p>
 * This programming interface lets a JavaScript client application use the MQTT V3.1 or
 * V3.1.1 protocol to connect to an MQTT-supporting messaging server.
 *
 * The function supported includes:
 * <ol>
 * <li>Connecting to and disconnecting from a server. The server is identified by its host name and port number.
 * <li>Specifying options that relate to the communications link with the server,
 * for example the frequency of keep-alive heartbeats, and whether SSL/TLS is required.
 * <li>Subscribing to and receiving messages from MQTT Topics.
 * <li>Publishing messages to MQTT Topics.
 * </ol>
 * <p>
 * The API consists of two main objects:
 * <dl>
 * <dt><b>{@link Paho.Client}</b></dt>
 * <dd>This contains methods that provide the functionality of the API,
 * including provision of callbacks that notify the application when a message
 * arrives from or is delivered to the messaging server,
 * or when the status of its connection to the messaging server changes.</dd>
 * <dt><b>{@link Paho.Message}</b></dt>
 * <dd>This encapsulates the payload of the message along with various attributes
 * associated with its delivery, in particular the destination to which it has
 * been (or is about to be) sent.</dd>
 * </dl>
 * <p>
 * The programming interface validates parameters passed to it, and will throw
 * an Error containing an error message intended for developer use, if it detects
 * an error with any parameter.
 * <p>
 * Example:
 *
 * <code><pre>
client = new Paho.Client(location.hostname, Number(location.port), "clientId");
client.onConnectionLost = onConnectionLost;
client.onMessageArrived = onMessageArrived;
client.connect({onSuccess:onConnect});

function onConnect() {
  // Once a connection has been made, make a subscription and send a message.
  console.log("onConnect");
  client.subscribe("/World");
  message = new Paho.Message("Hello");
  message.destinationName = "/World";
  client.send(message);
};
function onConnectionLost(responseObject) {
  if (responseObject.errorCode !== 0)
	console.log("onConnectionLost:"+responseObject.errorMessage);
};
function onMessageArrived(message) {
  console.log("onMessageArrived:"+message.payloadString);
  client.disconnect();
};
 * </pre></code>
 * @namespace Paho
 */ /* jshint shadow:true */ (function ExportLibrary(root, factory) {
    $291e12ce1a4c3c7e$exports = factory();
})($291e12ce1a4c3c7e$exports, function LibraryFactory() {
    var PahoMQTT = function(global1) {
        // Private variables below, these are only visible inside the function closure
        // which is used to define the module.
        var version = "@VERSION@-@BUILDLEVEL@";
        /**
	 * @private
	 */ var localStorage = global1.localStorage || function() {
            var data = {};
            return {
                setItem: function(key, item) {
                    data[key] = item;
                },
                getItem: function(key) {
                    return data[key];
                },
                removeItem: function(key) {
                    delete data[key];
                }
            };
        }();
        /**
	 * Unique message type identifiers, with associated
	 * associated integer values.
	 * @private
	 */ var MESSAGE_TYPE = {
            CONNECT: 1,
            CONNACK: 2,
            PUBLISH: 3,
            PUBACK: 4,
            PUBREC: 5,
            PUBREL: 6,
            PUBCOMP: 7,
            SUBSCRIBE: 8,
            SUBACK: 9,
            UNSUBSCRIBE: 10,
            UNSUBACK: 11,
            PINGREQ: 12,
            PINGRESP: 13,
            DISCONNECT: 14
        };
        // Collection of utility methods used to simplify module code
        // and promote the DRY pattern.
        /**
	 * Validate an object's parameter names to ensure they
	 * match a list of expected variables name for this option
	 * type. Used to ensure option object passed into the API don't
	 * contain erroneous parameters.
	 * @param {Object} obj - User options object
	 * @param {Object} keys - valid keys and types that may exist in obj.
	 * @throws {Error} Invalid option parameter found.
	 * @private
	 */ var validate = function(obj, keys) {
            for(var key in obj)if (obj.hasOwnProperty(key)) {
                if (keys.hasOwnProperty(key)) {
                    if (typeof obj[key] !== keys[key]) throw new Error(format(ERROR.INVALID_TYPE, [
                        typeof obj[key],
                        key
                    ]));
                } else {
                    var errorStr = "Unknown property, " + key + ". Valid properties are:";
                    for(var validKey in keys)if (keys.hasOwnProperty(validKey)) errorStr = errorStr + " " + validKey;
                    throw new Error(errorStr);
                }
            }
        };
        /**
	 * Return a new function which runs the user function bound
	 * to a fixed scope.
	 * @param {function} User function
	 * @param {object} Function scope
	 * @return {function} User function bound to another scope
	 * @private
	 */ var scope = function(f, scope) {
            return function() {
                return f.apply(scope, arguments);
            };
        };
        /**
	 * Unique message type identifiers, with associated
	 * associated integer values.
	 * @private
	 */ var ERROR = {
            OK: {
                code: 0,
                text: "AMQJSC0000I OK."
            },
            CONNECT_TIMEOUT: {
                code: 1,
                text: "AMQJSC0001E Connect timed out."
            },
            SUBSCRIBE_TIMEOUT: {
                code: 2,
                text: "AMQJS0002E Subscribe timed out."
            },
            UNSUBSCRIBE_TIMEOUT: {
                code: 3,
                text: "AMQJS0003E Unsubscribe timed out."
            },
            PING_TIMEOUT: {
                code: 4,
                text: "AMQJS0004E Ping timed out."
            },
            INTERNAL_ERROR: {
                code: 5,
                text: "AMQJS0005E Internal error. Error Message: {0}, Stack trace: {1}"
            },
            CONNACK_RETURNCODE: {
                code: 6,
                text: "AMQJS0006E Bad Connack return code:{0} {1}."
            },
            SOCKET_ERROR: {
                code: 7,
                text: "AMQJS0007E Socket error:{0}."
            },
            SOCKET_CLOSE: {
                code: 8,
                text: "AMQJS0008I Socket closed."
            },
            MALFORMED_UTF: {
                code: 9,
                text: "AMQJS0009E Malformed UTF data:{0} {1} {2}."
            },
            UNSUPPORTED: {
                code: 10,
                text: "AMQJS0010E {0} is not supported by this browser."
            },
            INVALID_STATE: {
                code: 11,
                text: "AMQJS0011E Invalid state {0}."
            },
            INVALID_TYPE: {
                code: 12,
                text: "AMQJS0012E Invalid type {0} for {1}."
            },
            INVALID_ARGUMENT: {
                code: 13,
                text: "AMQJS0013E Invalid argument {0} for {1}."
            },
            UNSUPPORTED_OPERATION: {
                code: 14,
                text: "AMQJS0014E Unsupported operation."
            },
            INVALID_STORED_DATA: {
                code: 15,
                text: "AMQJS0015E Invalid data in local storage key={0} value={1}."
            },
            INVALID_MQTT_MESSAGE_TYPE: {
                code: 16,
                text: "AMQJS0016E Invalid MQTT message type {0}."
            },
            MALFORMED_UNICODE: {
                code: 17,
                text: "AMQJS0017E Malformed Unicode string:{0} {1}."
            },
            BUFFER_FULL: {
                code: 18,
                text: "AMQJS0018E Message buffer is full, maximum buffer size: {0}."
            }
        };
        /** CONNACK RC Meaning. */ var CONNACK_RC = {
            0: "Connection Accepted",
            1: "Connection Refused: unacceptable protocol version",
            2: "Connection Refused: identifier rejected",
            3: "Connection Refused: server unavailable",
            4: "Connection Refused: bad user name or password",
            5: "Connection Refused: not authorized"
        };
        /**
	 * Format an error message text.
	 * @private
	 * @param {error} ERROR value above.
	 * @param {substitutions} [array] substituted into the text.
	 * @return the text with the substitutions made.
	 */ var format = function(error, substitutions) {
            var text = error.text;
            if (substitutions) {
                var field, start;
                for(var i = 0; i < substitutions.length; i++){
                    field = "{" + i + "}";
                    start = text.indexOf(field);
                    if (start > 0) {
                        var part1 = text.substring(0, start);
                        var part2 = text.substring(start + field.length);
                        text = part1 + substitutions[i] + part2;
                    }
                }
            }
            return text;
        };
        //MQTT protocol and version          6    M    Q    I    s    d    p    3
        var MqttProtoIdentifierv3 = [
            0x00,
            0x06,
            0x4d,
            0x51,
            0x49,
            0x73,
            0x64,
            0x70,
            0x03
        ];
        //MQTT proto/version for 311         4    M    Q    T    T    4
        var MqttProtoIdentifierv4 = [
            0x00,
            0x04,
            0x4d,
            0x51,
            0x54,
            0x54,
            0x04
        ];
        /**
	 * Construct an MQTT wire protocol message.
	 * @param type MQTT packet type.
	 * @param options optional wire message attributes.
	 *
	 * Optional properties
	 *
	 * messageIdentifier: message ID in the range [0..65535]
	 * payloadMessage:	Application Message - PUBLISH only
	 * connectStrings:	array of 0 or more Strings to be put into the CONNECT payload
	 * topics:			array of strings (SUBSCRIBE, UNSUBSCRIBE)
	 * requestQoS:		array of QoS values [0..2]
	 *
	 * "Flag" properties
	 * cleanSession:	true if present / false if absent (CONNECT)
	 * willMessage:  	true if present / false if absent (CONNECT)
	 * isRetained:		true if present / false if absent (CONNECT)
	 * userName:		true if present / false if absent (CONNECT)
	 * password:		true if present / false if absent (CONNECT)
	 * keepAliveInterval:	integer [0..65535]  (CONNECT)
	 *
	 * @private
	 * @ignore
	 */ var WireMessage = function(type, options) {
            this.type = type;
            for(var name in options)if (options.hasOwnProperty(name)) this[name] = options[name];
        };
        WireMessage.prototype.encode = function() {
            // Compute the first byte of the fixed header
            var first = (this.type & 0x0f) << 4;
            /*
		 * Now calculate the length of the variable header + payload by adding up the lengths
		 * of all the component parts
		 */ var remLength = 0;
            var topicStrLength = [];
            var destinationNameLength = 0;
            var willMessagePayloadBytes;
            // if the message contains a messageIdentifier then we need two bytes for that
            if (this.messageIdentifier !== undefined) remLength += 2;
            switch(this.type){
                // If this a Connect then we need to include 12 bytes for its header
                case MESSAGE_TYPE.CONNECT:
                    switch(this.mqttVersion){
                        case 3:
                            remLength += MqttProtoIdentifierv3.length + 3;
                            break;
                        case 4:
                            remLength += MqttProtoIdentifierv4.length + 3;
                            break;
                    }
                    remLength += UTF8Length(this.clientId) + 2;
                    if (this.willMessage !== undefined) {
                        remLength += UTF8Length(this.willMessage.destinationName) + 2;
                        // Will message is always a string, sent as UTF-8 characters with a preceding length.
                        willMessagePayloadBytes = this.willMessage.payloadBytes;
                        if (!(willMessagePayloadBytes instanceof Uint8Array)) willMessagePayloadBytes = new Uint8Array(payloadBytes);
                        remLength += willMessagePayloadBytes.byteLength + 2;
                    }
                    if (this.userName !== undefined) remLength += UTF8Length(this.userName) + 2;
                    if (this.password !== undefined) remLength += UTF8Length(this.password) + 2;
                    break;
                // Subscribe, Unsubscribe can both contain topic strings
                case MESSAGE_TYPE.SUBSCRIBE:
                    first |= 0x02; // Qos = 1;
                    for(var i = 0; i < this.topics.length; i++){
                        topicStrLength[i] = UTF8Length(this.topics[i]);
                        remLength += topicStrLength[i] + 2;
                    }
                    remLength += this.requestedQos.length; // 1 byte for each topic's Qos
                    break;
                case MESSAGE_TYPE.UNSUBSCRIBE:
                    first |= 0x02; // Qos = 1;
                    for(var i = 0; i < this.topics.length; i++){
                        topicStrLength[i] = UTF8Length(this.topics[i]);
                        remLength += topicStrLength[i] + 2;
                    }
                    break;
                case MESSAGE_TYPE.PUBREL:
                    first |= 0x02; // Qos = 1;
                    break;
                case MESSAGE_TYPE.PUBLISH:
                    if (this.payloadMessage.duplicate) first |= 0x08;
                    first = first |= this.payloadMessage.qos << 1;
                    if (this.payloadMessage.retained) first |= 0x01;
                    destinationNameLength = UTF8Length(this.payloadMessage.destinationName);
                    remLength += destinationNameLength + 2;
                    var payloadBytes = this.payloadMessage.payloadBytes;
                    remLength += payloadBytes.byteLength;
                    if (payloadBytes instanceof ArrayBuffer) payloadBytes = new Uint8Array(payloadBytes);
                    else if (!(payloadBytes instanceof Uint8Array)) payloadBytes = new Uint8Array(payloadBytes.buffer);
                    break;
                case MESSAGE_TYPE.DISCONNECT:
                    break;
                default:
                    break;
            }
            // Now we can allocate a buffer for the message
            var mbi = encodeMBI(remLength); // Convert the length to MQTT MBI format
            var pos = mbi.length + 1; // Offset of start of variable header
            var buffer = new ArrayBuffer(remLength + pos);
            var byteStream = new Uint8Array(buffer); // view it as a sequence of bytes
            //Write the fixed header into the buffer
            byteStream[0] = first;
            byteStream.set(mbi, 1);
            // If this is a PUBLISH then the variable header starts with a topic
            if (this.type == MESSAGE_TYPE.PUBLISH) pos = writeString(this.payloadMessage.destinationName, destinationNameLength, byteStream, pos);
            else if (this.type == MESSAGE_TYPE.CONNECT) {
                switch(this.mqttVersion){
                    case 3:
                        byteStream.set(MqttProtoIdentifierv3, pos);
                        pos += MqttProtoIdentifierv3.length;
                        break;
                    case 4:
                        byteStream.set(MqttProtoIdentifierv4, pos);
                        pos += MqttProtoIdentifierv4.length;
                        break;
                }
                var connectFlags = 0;
                if (this.cleanSession) connectFlags = 0x02;
                if (this.willMessage !== undefined) {
                    connectFlags |= 0x04;
                    connectFlags |= this.willMessage.qos << 3;
                    if (this.willMessage.retained) connectFlags |= 0x20;
                }
                if (this.userName !== undefined) connectFlags |= 0x80;
                if (this.password !== undefined) connectFlags |= 0x40;
                byteStream[pos++] = connectFlags;
                pos = writeUint16(this.keepAliveInterval, byteStream, pos);
            }
            // Output the messageIdentifier - if there is one
            if (this.messageIdentifier !== undefined) pos = writeUint16(this.messageIdentifier, byteStream, pos);
            switch(this.type){
                case MESSAGE_TYPE.CONNECT:
                    pos = writeString(this.clientId, UTF8Length(this.clientId), byteStream, pos);
                    if (this.willMessage !== undefined) {
                        pos = writeString(this.willMessage.destinationName, UTF8Length(this.willMessage.destinationName), byteStream, pos);
                        pos = writeUint16(willMessagePayloadBytes.byteLength, byteStream, pos);
                        byteStream.set(willMessagePayloadBytes, pos);
                        pos += willMessagePayloadBytes.byteLength;
                    }
                    if (this.userName !== undefined) pos = writeString(this.userName, UTF8Length(this.userName), byteStream, pos);
                    if (this.password !== undefined) pos = writeString(this.password, UTF8Length(this.password), byteStream, pos);
                    break;
                case MESSAGE_TYPE.PUBLISH:
                    // PUBLISH has a text or binary payload, if text do not add a 2 byte length field, just the UTF characters.
                    byteStream.set(payloadBytes, pos);
                    break;
                //    	    case MESSAGE_TYPE.PUBREC:
                //    	    case MESSAGE_TYPE.PUBREL:
                //    	    case MESSAGE_TYPE.PUBCOMP:
                //    	    	break;
                case MESSAGE_TYPE.SUBSCRIBE:
                    // SUBSCRIBE has a list of topic strings and request QoS
                    for(var i = 0; i < this.topics.length; i++){
                        pos = writeString(this.topics[i], topicStrLength[i], byteStream, pos);
                        byteStream[pos++] = this.requestedQos[i];
                    }
                    break;
                case MESSAGE_TYPE.UNSUBSCRIBE:
                    // UNSUBSCRIBE has a list of topic strings
                    for(var i = 0; i < this.topics.length; i++)pos = writeString(this.topics[i], topicStrLength[i], byteStream, pos);
                    break;
                default:
            }
            return buffer;
        };
        function decodeMessage(input, pos) {
            var startingPos = pos;
            var first = input[pos];
            var type = first >> 4;
            var messageInfo = first &= 0x0f;
            pos += 1;
            // Decode the remaining length (MBI format)
            var digit;
            var remLength = 0;
            var multiplier = 1;
            do {
                if (pos == input.length) return [
                    null,
                    startingPos
                ];
                digit = input[pos++];
                remLength += (digit & 0x7F) * multiplier;
                multiplier *= 128;
            }while ((digit & 0x80) !== 0);
            var endPos = pos + remLength;
            if (endPos > input.length) return [
                null,
                startingPos
            ];
            var wireMessage = new WireMessage(type);
            switch(type){
                case MESSAGE_TYPE.CONNACK:
                    var connectAcknowledgeFlags = input[pos++];
                    if (connectAcknowledgeFlags & 0x01) wireMessage.sessionPresent = true;
                    wireMessage.returnCode = input[pos++];
                    break;
                case MESSAGE_TYPE.PUBLISH:
                    var qos = messageInfo >> 1 & 0x03;
                    var len = readUint16(input, pos);
                    pos += 2;
                    var topicName = parseUTF8(input, pos, len);
                    pos += len;
                    // If QoS 1 or 2 there will be a messageIdentifier
                    if (qos > 0) {
                        wireMessage.messageIdentifier = readUint16(input, pos);
                        pos += 2;
                    }
                    var message = new PahoMQTT.Message(input.subarray(pos, endPos));
                    if ((messageInfo & 0x01) == 0x01) message.retained = true;
                    if ((messageInfo & 0x08) == 0x08) message.duplicate = true;
                    message.qos = qos;
                    message.destinationName = topicName;
                    wireMessage.payloadMessage = message;
                    break;
                case MESSAGE_TYPE.PUBACK:
                case MESSAGE_TYPE.PUBREC:
                case MESSAGE_TYPE.PUBREL:
                case MESSAGE_TYPE.PUBCOMP:
                case MESSAGE_TYPE.UNSUBACK:
                    wireMessage.messageIdentifier = readUint16(input, pos);
                    break;
                case MESSAGE_TYPE.SUBACK:
                    wireMessage.messageIdentifier = readUint16(input, pos);
                    pos += 2;
                    wireMessage.returnCode = input.subarray(pos, endPos);
                    break;
                default:
                    break;
            }
            return [
                wireMessage,
                endPos
            ];
        }
        function writeUint16(input, buffer, offset) {
            buffer[offset++] = input >> 8; //MSB
            buffer[offset++] = input % 256; //LSB
            return offset;
        }
        function writeString(input, utf8Length, buffer, offset) {
            offset = writeUint16(utf8Length, buffer, offset);
            stringToUTF8(input, buffer, offset);
            return offset + utf8Length;
        }
        function readUint16(buffer, offset) {
            return 256 * buffer[offset] + buffer[offset + 1];
        }
        /**
	 * Encodes an MQTT Multi-Byte Integer
	 * @private
	 */ function encodeMBI(number) {
            var output = new Array(1);
            var numBytes = 0;
            do {
                var digit = number % 128;
                number = number >> 7;
                if (number > 0) digit |= 0x80;
                output[numBytes++] = digit;
            }while (number > 0 && numBytes < 4);
            return output;
        }
        /**
	 * Takes a String and calculates its length in bytes when encoded in UTF8.
	 * @private
	 */ function UTF8Length(input) {
            var output = 0;
            for(var i = 0; i < input.length; i++){
                var charCode = input.charCodeAt(i);
                if (charCode > 0x7FF) {
                    // Surrogate pair means its a 4 byte character
                    if (0xD800 <= charCode && charCode <= 0xDBFF) {
                        i++;
                        output++;
                    }
                    output += 3;
                } else if (charCode > 0x7F) output += 2;
                else output++;
            }
            return output;
        }
        /**
	 * Takes a String and writes it into an array as UTF8 encoded bytes.
	 * @private
	 */ function stringToUTF8(input, output, start) {
            var pos = start;
            for(var i = 0; i < input.length; i++){
                var charCode = input.charCodeAt(i);
                // Check for a surrogate pair.
                if (0xD800 <= charCode && charCode <= 0xDBFF) {
                    var lowCharCode = input.charCodeAt(++i);
                    if (isNaN(lowCharCode)) throw new Error(format(ERROR.MALFORMED_UNICODE, [
                        charCode,
                        lowCharCode
                    ]));
                    charCode = (charCode - 0xD800 << 10) + (lowCharCode - 0xDC00) + 0x10000;
                }
                if (charCode <= 0x7F) output[pos++] = charCode;
                else if (charCode <= 0x7FF) {
                    output[pos++] = charCode >> 6 & 0x1F | 0xC0;
                    output[pos++] = charCode & 0x3F | 0x80;
                } else if (charCode <= 0xFFFF) {
                    output[pos++] = charCode >> 12 & 0x0F | 0xE0;
                    output[pos++] = charCode >> 6 & 0x3F | 0x80;
                    output[pos++] = charCode & 0x3F | 0x80;
                } else {
                    output[pos++] = charCode >> 18 & 0x07 | 0xF0;
                    output[pos++] = charCode >> 12 & 0x3F | 0x80;
                    output[pos++] = charCode >> 6 & 0x3F | 0x80;
                    output[pos++] = charCode & 0x3F | 0x80;
                }
            }
            return output;
        }
        function parseUTF8(input, offset, length) {
            var output = "";
            var utf16;
            var pos = offset;
            while(pos < offset + length){
                var byte1 = input[pos++];
                if (byte1 < 128) utf16 = byte1;
                else {
                    var byte2 = input[pos++] - 128;
                    if (byte2 < 0) throw new Error(format(ERROR.MALFORMED_UTF, [
                        byte1.toString(16),
                        byte2.toString(16),
                        ""
                    ]));
                    if (byte1 < 0xE0) utf16 = 64 * (byte1 - 0xC0) + byte2;
                    else {
                        var byte3 = input[pos++] - 128;
                        if (byte3 < 0) throw new Error(format(ERROR.MALFORMED_UTF, [
                            byte1.toString(16),
                            byte2.toString(16),
                            byte3.toString(16)
                        ]));
                        if (byte1 < 0xF0) utf16 = 4096 * (byte1 - 0xE0) + 64 * byte2 + byte3;
                        else {
                            var byte4 = input[pos++] - 128;
                            if (byte4 < 0) throw new Error(format(ERROR.MALFORMED_UTF, [
                                byte1.toString(16),
                                byte2.toString(16),
                                byte3.toString(16),
                                byte4.toString(16)
                            ]));
                            if (byte1 < 0xF8) utf16 = 262144 * (byte1 - 0xF0) + 4096 * byte2 + 64 * byte3 + byte4;
                            else throw new Error(format(ERROR.MALFORMED_UTF, [
                                byte1.toString(16),
                                byte2.toString(16),
                                byte3.toString(16),
                                byte4.toString(16)
                            ]));
                        }
                    }
                }
                if (utf16 > 0xFFFF) {
                    utf16 -= 0x10000;
                    output += String.fromCharCode(0xD800 + (utf16 >> 10)); // lead character
                    utf16 = 0xDC00 + (utf16 & 0x3FF); // trail character
                }
                output += String.fromCharCode(utf16);
            }
            return output;
        }
        /**
	 * Repeat keepalive requests, monitor responses.
	 * @ignore
	 */ var Pinger = function(client, keepAliveInterval) {
            this._client = client;
            this._keepAliveInterval = keepAliveInterval * 1000;
            this.isReset = false;
            var pingReq = new WireMessage(MESSAGE_TYPE.PINGREQ).encode();
            var doTimeout = function(pinger) {
                return function() {
                    return doPing.apply(pinger);
                };
            };
            /** @ignore */ var doPing = function() {
                if (!this.isReset) {
                    this._client._trace("Pinger.doPing", "Timed out");
                    this._client._disconnected(ERROR.PING_TIMEOUT.code, format(ERROR.PING_TIMEOUT));
                } else {
                    this.isReset = false;
                    this._client._trace("Pinger.doPing", "send PINGREQ");
                    this._client.socket.send(pingReq);
                    this.timeout = setTimeout(doTimeout(this), this._keepAliveInterval);
                }
            };
            this.reset = function() {
                this.isReset = true;
                clearTimeout(this.timeout);
                if (this._keepAliveInterval > 0) this.timeout = setTimeout(doTimeout(this), this._keepAliveInterval);
            };
            this.cancel = function() {
                clearTimeout(this.timeout);
            };
        };
        /**
	 * Monitor request completion.
	 * @ignore
	 */ var Timeout = function(client, timeoutSeconds, action, args) {
            if (!timeoutSeconds) timeoutSeconds = 30;
            var doTimeout = function(action, client, args) {
                return function() {
                    return action.apply(client, args);
                };
            };
            this.timeout = setTimeout(doTimeout(action, client, args), timeoutSeconds * 1000);
            this.cancel = function() {
                clearTimeout(this.timeout);
            };
        };
        /**
	 * Internal implementation of the Websockets MQTT V3.1 client.
	 *
	 * @name Paho.ClientImpl @constructor
	 * @param {String} host the DNS nameof the webSocket host.
	 * @param {Number} port the port number for that host.
	 * @param {String} clientId the MQ client identifier.
	 */ var ClientImpl = function(uri, host, port, path, clientId) {
            // Check dependencies are satisfied in this browser.
            if (!("WebSocket" in global1 && global1.WebSocket !== null)) throw new Error(format(ERROR.UNSUPPORTED, [
                "WebSocket"
            ]));
            if (!("ArrayBuffer" in global1 && global1.ArrayBuffer !== null)) throw new Error(format(ERROR.UNSUPPORTED, [
                "ArrayBuffer"
            ]));
            this._trace("Paho.Client", uri, host, port, path, clientId);
            this.host = host;
            this.port = port;
            this.path = path;
            this.uri = uri;
            this.clientId = clientId;
            this._wsuri = null;
            // Local storagekeys are qualified with the following string.
            // The conditional inclusion of path in the key is for backward
            // compatibility to when the path was not configurable and assumed to
            // be /mqtt
            this._localKey = host + ":" + port + (path != "/mqtt" ? ":" + path : "") + ":" + clientId + ":";
            // Create private instance-only message queue
            // Internal queue of messages to be sent, in sending order.
            this._msg_queue = [];
            this._buffered_msg_queue = [];
            // Messages we have sent and are expecting a response for, indexed by their respective message ids.
            this._sentMessages = {};
            // Messages we have received and acknowleged and are expecting a confirm message for
            // indexed by their respective message ids.
            this._receivedMessages = {};
            // Internal list of callbacks to be executed when messages
            // have been successfully sent over web socket, e.g. disconnect
            // when it doesn't have to wait for ACK, just message is dispatched.
            this._notify_msg_sent = {};
            // Unique identifier for SEND messages, incrementing
            // counter as messages are sent.
            this._message_identifier = 1;
            // Used to determine the transmission sequence of stored sent messages.
            this._sequence = 0;
            // Load the local state, if any, from the saved version, only restore state relevant to this client.
            for(var key in localStorage)if (key.indexOf("Sent:" + this._localKey) === 0 || key.indexOf("Received:" + this._localKey) === 0) this.restore(key);
        };
        // Messaging Client public instance members.
        ClientImpl.prototype.host = null;
        ClientImpl.prototype.port = null;
        ClientImpl.prototype.path = null;
        ClientImpl.prototype.uri = null;
        ClientImpl.prototype.clientId = null;
        // Messaging Client private instance members.
        ClientImpl.prototype.socket = null;
        /* true once we have received an acknowledgement to a CONNECT packet. */ ClientImpl.prototype.connected = false;
        /* The largest message identifier allowed, may not be larger than 2**16 but
		 * if set smaller reduces the maximum number of outbound messages allowed.
		 */ ClientImpl.prototype.maxMessageIdentifier = 65536;
        ClientImpl.prototype.connectOptions = null;
        ClientImpl.prototype.hostIndex = null;
        ClientImpl.prototype.onConnected = null;
        ClientImpl.prototype.onConnectionLost = null;
        ClientImpl.prototype.onMessageDelivered = null;
        ClientImpl.prototype.onMessageArrived = null;
        ClientImpl.prototype.traceFunction = null;
        ClientImpl.prototype._msg_queue = null;
        ClientImpl.prototype._buffered_msg_queue = null;
        ClientImpl.prototype._connectTimeout = null;
        /* The sendPinger monitors how long we allow before we send data to prove to the server that we are alive. */ ClientImpl.prototype.sendPinger = null;
        /* The receivePinger monitors how long we allow before we require evidence that the server is alive. */ ClientImpl.prototype.receivePinger = null;
        ClientImpl.prototype._reconnectInterval = 1; // Reconnect Delay, starts at 1 second
        ClientImpl.prototype._reconnecting = false;
        ClientImpl.prototype._reconnectTimeout = null;
        ClientImpl.prototype.disconnectedPublishing = false;
        ClientImpl.prototype.disconnectedBufferSize = 5000;
        ClientImpl.prototype.receiveBuffer = null;
        ClientImpl.prototype._traceBuffer = null;
        ClientImpl.prototype._MAX_TRACE_ENTRIES = 100;
        ClientImpl.prototype.connect = function(connectOptions) {
            var connectOptionsMasked = this._traceMask(connectOptions, "password");
            this._trace("Client.connect", connectOptionsMasked, this.socket, this.connected);
            if (this.connected) throw new Error(format(ERROR.INVALID_STATE, [
                "already connected"
            ]));
            if (this.socket) throw new Error(format(ERROR.INVALID_STATE, [
                "already connected"
            ]));
            if (this._reconnecting) {
                // connect() function is called while reconnect is in progress.
                // Terminate the auto reconnect process to use new connect options.
                this._reconnectTimeout.cancel();
                this._reconnectTimeout = null;
                this._reconnecting = false;
            }
            this.connectOptions = connectOptions;
            this._reconnectInterval = 1;
            this._reconnecting = false;
            if (connectOptions.uris) {
                this.hostIndex = 0;
                this._doConnect(connectOptions.uris[0]);
            } else this._doConnect(this.uri);
        };
        ClientImpl.prototype.subscribe = function(filter, subscribeOptions) {
            this._trace("Client.subscribe", filter, subscribeOptions);
            if (!this.connected) throw new Error(format(ERROR.INVALID_STATE, [
                "not connected"
            ]));
            var wireMessage = new WireMessage(MESSAGE_TYPE.SUBSCRIBE);
            wireMessage.topics = [
                filter
            ];
            if (subscribeOptions.qos !== undefined) wireMessage.requestedQos = [
                subscribeOptions.qos
            ];
            else wireMessage.requestedQos = [
                0
            ];
            if (subscribeOptions.onSuccess) wireMessage.onSuccess = function(grantedQos) {
                subscribeOptions.onSuccess({
                    invocationContext: subscribeOptions.invocationContext,
                    grantedQos: grantedQos
                });
            };
            if (subscribeOptions.onFailure) wireMessage.onFailure = function(errorCode) {
                subscribeOptions.onFailure({
                    invocationContext: subscribeOptions.invocationContext,
                    errorCode: errorCode,
                    errorMessage: format(errorCode)
                });
            };
            if (subscribeOptions.timeout) wireMessage.timeOut = new Timeout(this, subscribeOptions.timeout, subscribeOptions.onFailure, [
                {
                    invocationContext: subscribeOptions.invocationContext,
                    errorCode: ERROR.SUBSCRIBE_TIMEOUT.code,
                    errorMessage: format(ERROR.SUBSCRIBE_TIMEOUT)
                }
            ]);
            // All subscriptions return a SUBACK.
            this._requires_ack(wireMessage);
            this._schedule_message(wireMessage);
        };
        /** @ignore */ ClientImpl.prototype.unsubscribe = function(filter, unsubscribeOptions) {
            this._trace("Client.unsubscribe", filter, unsubscribeOptions);
            if (!this.connected) throw new Error(format(ERROR.INVALID_STATE, [
                "not connected"
            ]));
            var wireMessage = new WireMessage(MESSAGE_TYPE.UNSUBSCRIBE);
            wireMessage.topics = [
                filter
            ];
            if (unsubscribeOptions.onSuccess) wireMessage.callback = function() {
                unsubscribeOptions.onSuccess({
                    invocationContext: unsubscribeOptions.invocationContext
                });
            };
            if (unsubscribeOptions.timeout) wireMessage.timeOut = new Timeout(this, unsubscribeOptions.timeout, unsubscribeOptions.onFailure, [
                {
                    invocationContext: unsubscribeOptions.invocationContext,
                    errorCode: ERROR.UNSUBSCRIBE_TIMEOUT.code,
                    errorMessage: format(ERROR.UNSUBSCRIBE_TIMEOUT)
                }
            ]);
            // All unsubscribes return a SUBACK.
            this._requires_ack(wireMessage);
            this._schedule_message(wireMessage);
        };
        ClientImpl.prototype.send = function(message) {
            this._trace("Client.send", message);
            var wireMessage = new WireMessage(MESSAGE_TYPE.PUBLISH);
            wireMessage.payloadMessage = message;
            if (this.connected) {
                // Mark qos 1 & 2 message as "ACK required"
                // For qos 0 message, invoke onMessageDelivered callback if there is one.
                // Then schedule the message.
                if (message.qos > 0) this._requires_ack(wireMessage);
                else if (this.onMessageDelivered) this._notify_msg_sent[wireMessage] = this.onMessageDelivered(wireMessage.payloadMessage);
                this._schedule_message(wireMessage);
            } else {
                // Currently disconnected, will not schedule this message
                // Check if reconnecting is in progress and disconnected publish is enabled.
                if (this._reconnecting && this.disconnectedPublishing) {
                    // Check the limit which include the "required ACK" messages
                    var messageCount = Object.keys(this._sentMessages).length + this._buffered_msg_queue.length;
                    if (messageCount > this.disconnectedBufferSize) throw new Error(format(ERROR.BUFFER_FULL, [
                        this.disconnectedBufferSize
                    ]));
                    else if (message.qos > 0) // Mark this message as "ACK required"
                    this._requires_ack(wireMessage);
                    else {
                        wireMessage.sequence = ++this._sequence;
                        // Add messages in fifo order to array, by adding to start
                        this._buffered_msg_queue.unshift(wireMessage);
                    }
                } else throw new Error(format(ERROR.INVALID_STATE, [
                    "not connected"
                ]));
            }
        };
        ClientImpl.prototype.disconnect = function() {
            this._trace("Client.disconnect");
            if (this._reconnecting) {
                // disconnect() function is called while reconnect is in progress.
                // Terminate the auto reconnect process.
                this._reconnectTimeout.cancel();
                this._reconnectTimeout = null;
                this._reconnecting = false;
            }
            if (!this.socket) throw new Error(format(ERROR.INVALID_STATE, [
                "not connecting or connected"
            ]));
            var wireMessage = new WireMessage(MESSAGE_TYPE.DISCONNECT);
            // Run the disconnected call back as soon as the message has been sent,
            // in case of a failure later on in the disconnect processing.
            // as a consequence, the _disconected call back may be run several times.
            this._notify_msg_sent[wireMessage] = scope(this._disconnected, this);
            this._schedule_message(wireMessage);
        };
        ClientImpl.prototype.getTraceLog = function() {
            if (this._traceBuffer !== null) {
                this._trace("Client.getTraceLog", new Date());
                this._trace("Client.getTraceLog in flight messages", this._sentMessages.length);
                for(var key in this._sentMessages)this._trace("_sentMessages ", key, this._sentMessages[key]);
                for(var key in this._receivedMessages)this._trace("_receivedMessages ", key, this._receivedMessages[key]);
                return this._traceBuffer;
            }
        };
        ClientImpl.prototype.startTrace = function() {
            if (this._traceBuffer === null) this._traceBuffer = [];
            this._trace("Client.startTrace", new Date(), version);
        };
        ClientImpl.prototype.stopTrace = function() {
            delete this._traceBuffer;
        };
        ClientImpl.prototype._doConnect = function(wsurl) {
            // When the socket is open, this client will send the CONNECT WireMessage using the saved parameters.
            if (this.connectOptions.useSSL) {
                var uriParts = wsurl.split(":");
                uriParts[0] = "wss";
                wsurl = uriParts.join(":");
            }
            this._wsuri = wsurl;
            this.connected = false;
            if (this.connectOptions.mqttVersion < 4) this.socket = new WebSocket(wsurl, [
                "mqttv3.1"
            ]);
            else this.socket = new WebSocket(wsurl, [
                "mqtt"
            ]);
            this.socket.binaryType = "arraybuffer";
            this.socket.onopen = scope(this._on_socket_open, this);
            this.socket.onmessage = scope(this._on_socket_message, this);
            this.socket.onerror = scope(this._on_socket_error, this);
            this.socket.onclose = scope(this._on_socket_close, this);
            this.sendPinger = new Pinger(this, this.connectOptions.keepAliveInterval);
            this.receivePinger = new Pinger(this, this.connectOptions.keepAliveInterval);
            if (this._connectTimeout) {
                this._connectTimeout.cancel();
                this._connectTimeout = null;
            }
            this._connectTimeout = new Timeout(this, this.connectOptions.timeout, this._disconnected, [
                ERROR.CONNECT_TIMEOUT.code,
                format(ERROR.CONNECT_TIMEOUT)
            ]);
        };
        // Schedule a new message to be sent over the WebSockets
        // connection. CONNECT messages cause WebSocket connection
        // to be started. All other messages are queued internally
        // until this has happened. When WS connection starts, process
        // all outstanding messages.
        ClientImpl.prototype._schedule_message = function(message) {
            // Add messages in fifo order to array, by adding to start
            this._msg_queue.unshift(message);
            // Process outstanding messages in the queue if we have an  open socket, and have received CONNACK.
            if (this.connected) this._process_queue();
        };
        ClientImpl.prototype.store = function(prefix, wireMessage) {
            var storedMessage = {
                type: wireMessage.type,
                messageIdentifier: wireMessage.messageIdentifier,
                version: 1
            };
            switch(wireMessage.type){
                case MESSAGE_TYPE.PUBLISH:
                    if (wireMessage.pubRecReceived) storedMessage.pubRecReceived = true;
                    // Convert the payload to a hex string.
                    storedMessage.payloadMessage = {};
                    var hex = "";
                    var messageBytes = wireMessage.payloadMessage.payloadBytes;
                    for(var i = 0; i < messageBytes.length; i++)if (messageBytes[i] <= 0xF) hex = hex + "0" + messageBytes[i].toString(16);
                    else hex = hex + messageBytes[i].toString(16);
                    storedMessage.payloadMessage.payloadHex = hex;
                    storedMessage.payloadMessage.qos = wireMessage.payloadMessage.qos;
                    storedMessage.payloadMessage.destinationName = wireMessage.payloadMessage.destinationName;
                    if (wireMessage.payloadMessage.duplicate) storedMessage.payloadMessage.duplicate = true;
                    if (wireMessage.payloadMessage.retained) storedMessage.payloadMessage.retained = true;
                    // Add a sequence number to sent messages.
                    if (prefix.indexOf("Sent:") === 0) {
                        if (wireMessage.sequence === undefined) wireMessage.sequence = ++this._sequence;
                        storedMessage.sequence = wireMessage.sequence;
                    }
                    break;
                default:
                    throw Error(format(ERROR.INVALID_STORED_DATA, [
                        prefix + this._localKey + wireMessage.messageIdentifier,
                        storedMessage
                    ]));
            }
            localStorage.setItem(prefix + this._localKey + wireMessage.messageIdentifier, JSON.stringify(storedMessage));
        };
        ClientImpl.prototype.restore = function(key) {
            var value = localStorage.getItem(key);
            var storedMessage = JSON.parse(value);
            var wireMessage = new WireMessage(storedMessage.type, storedMessage);
            switch(storedMessage.type){
                case MESSAGE_TYPE.PUBLISH:
                    // Replace the payload message with a Message object.
                    var hex = storedMessage.payloadMessage.payloadHex;
                    var buffer = new ArrayBuffer(hex.length / 2);
                    var byteStream = new Uint8Array(buffer);
                    var i = 0;
                    while(hex.length >= 2){
                        var x = parseInt(hex.substring(0, 2), 16);
                        hex = hex.substring(2, hex.length);
                        byteStream[i++] = x;
                    }
                    var payloadMessage = new PahoMQTT.Message(byteStream);
                    payloadMessage.qos = storedMessage.payloadMessage.qos;
                    payloadMessage.destinationName = storedMessage.payloadMessage.destinationName;
                    if (storedMessage.payloadMessage.duplicate) payloadMessage.duplicate = true;
                    if (storedMessage.payloadMessage.retained) payloadMessage.retained = true;
                    wireMessage.payloadMessage = payloadMessage;
                    break;
                default:
                    throw Error(format(ERROR.INVALID_STORED_DATA, [
                        key,
                        value
                    ]));
            }
            if (key.indexOf("Sent:" + this._localKey) === 0) {
                wireMessage.payloadMessage.duplicate = true;
                this._sentMessages[wireMessage.messageIdentifier] = wireMessage;
            } else if (key.indexOf("Received:" + this._localKey) === 0) this._receivedMessages[wireMessage.messageIdentifier] = wireMessage;
        };
        ClientImpl.prototype._process_queue = function() {
            var message = null;
            // Send all queued messages down socket connection
            while(message = this._msg_queue.pop()){
                this._socket_send(message);
                // Notify listeners that message was successfully sent
                if (this._notify_msg_sent[message]) {
                    this._notify_msg_sent[message]();
                    delete this._notify_msg_sent[message];
                }
            }
        };
        /**
	 * Expect an ACK response for this message. Add message to the set of in progress
	 * messages and set an unused identifier in this message.
	 * @ignore
	 */ ClientImpl.prototype._requires_ack = function(wireMessage) {
            var messageCount = Object.keys(this._sentMessages).length;
            if (messageCount > this.maxMessageIdentifier) throw Error("Too many messages:" + messageCount);
            while(this._sentMessages[this._message_identifier] !== undefined)this._message_identifier++;
            wireMessage.messageIdentifier = this._message_identifier;
            this._sentMessages[wireMessage.messageIdentifier] = wireMessage;
            if (wireMessage.type === MESSAGE_TYPE.PUBLISH) this.store("Sent:", wireMessage);
            if (this._message_identifier === this.maxMessageIdentifier) this._message_identifier = 1;
        };
        /**
	 * Called when the underlying websocket has been opened.
	 * @ignore
	 */ ClientImpl.prototype._on_socket_open = function() {
            // Create the CONNECT message object.
            var wireMessage = new WireMessage(MESSAGE_TYPE.CONNECT, this.connectOptions);
            wireMessage.clientId = this.clientId;
            this._socket_send(wireMessage);
        };
        /**
	 * Called when the underlying websocket has received a complete packet.
	 * @ignore
	 */ ClientImpl.prototype._on_socket_message = function(event) {
            this._trace("Client._on_socket_message", event.data);
            var messages = this._deframeMessages(event.data);
            for(var i = 0; i < messages.length; i += 1)this._handleMessage(messages[i]);
        };
        ClientImpl.prototype._deframeMessages = function(data) {
            var byteArray = new Uint8Array(data);
            var messages = [];
            if (this.receiveBuffer) {
                var newData = new Uint8Array(this.receiveBuffer.length + byteArray.length);
                newData.set(this.receiveBuffer);
                newData.set(byteArray, this.receiveBuffer.length);
                byteArray = newData;
                delete this.receiveBuffer;
            }
            try {
                var offset = 0;
                while(offset < byteArray.length){
                    var result = decodeMessage(byteArray, offset);
                    var wireMessage = result[0];
                    offset = result[1];
                    if (wireMessage !== null) messages.push(wireMessage);
                    else break;
                }
                if (offset < byteArray.length) this.receiveBuffer = byteArray.subarray(offset);
            } catch (error) {
                var errorStack = error.hasOwnProperty("stack") == "undefined" ? error.stack.toString() : "No Error Stack Available";
                this._disconnected(ERROR.INTERNAL_ERROR.code, format(ERROR.INTERNAL_ERROR, [
                    error.message,
                    errorStack
                ]));
                return;
            }
            return messages;
        };
        ClientImpl.prototype._handleMessage = function(wireMessage) {
            this._trace("Client._handleMessage", wireMessage);
            try {
                switch(wireMessage.type){
                    case MESSAGE_TYPE.CONNACK:
                        this._connectTimeout.cancel();
                        if (this._reconnectTimeout) this._reconnectTimeout.cancel();
                        // If we have started using clean session then clear up the local state.
                        if (this.connectOptions.cleanSession) {
                            for(var key in this._sentMessages){
                                var sentMessage = this._sentMessages[key];
                                localStorage.removeItem("Sent:" + this._localKey + sentMessage.messageIdentifier);
                            }
                            this._sentMessages = {};
                            for(var key in this._receivedMessages){
                                var receivedMessage = this._receivedMessages[key];
                                localStorage.removeItem("Received:" + this._localKey + receivedMessage.messageIdentifier);
                            }
                            this._receivedMessages = {};
                        }
                        // Client connected and ready for business.
                        if (wireMessage.returnCode === 0) {
                            this.connected = true;
                            // Jump to the end of the list of uris and stop looking for a good host.
                            if (this.connectOptions.uris) this.hostIndex = this.connectOptions.uris.length;
                        } else {
                            this._disconnected(ERROR.CONNACK_RETURNCODE.code, format(ERROR.CONNACK_RETURNCODE, [
                                wireMessage.returnCode,
                                CONNACK_RC[wireMessage.returnCode]
                            ]));
                            break;
                        }
                        // Resend messages.
                        var sequencedMessages = [];
                        for(var msgId in this._sentMessages)if (this._sentMessages.hasOwnProperty(msgId)) sequencedMessages.push(this._sentMessages[msgId]);
                        // Also schedule qos 0 buffered messages if any
                        if (this._buffered_msg_queue.length > 0) {
                            var msg = null;
                            while(msg = this._buffered_msg_queue.pop()){
                                sequencedMessages.push(msg);
                                if (this.onMessageDelivered) this._notify_msg_sent[msg] = this.onMessageDelivered(msg.payloadMessage);
                            }
                        }
                        // Sort sentMessages into the original sent order.
                        var sequencedMessages = sequencedMessages.sort(function(a, b) {
                            return a.sequence - b.sequence;
                        });
                        for(var i = 0, len = sequencedMessages.length; i < len; i++){
                            var sentMessage = sequencedMessages[i];
                            if (sentMessage.type == MESSAGE_TYPE.PUBLISH && sentMessage.pubRecReceived) {
                                var pubRelMessage = new WireMessage(MESSAGE_TYPE.PUBREL, {
                                    messageIdentifier: sentMessage.messageIdentifier
                                });
                                this._schedule_message(pubRelMessage);
                            } else this._schedule_message(sentMessage);
                        }
                        // Execute the connectOptions.onSuccess callback if there is one.
                        // Will also now return if this connection was the result of an automatic
                        // reconnect and which URI was successfully connected to.
                        if (this.connectOptions.onSuccess) this.connectOptions.onSuccess({
                            invocationContext: this.connectOptions.invocationContext
                        });
                        var reconnected = false;
                        if (this._reconnecting) {
                            reconnected = true;
                            this._reconnectInterval = 1;
                            this._reconnecting = false;
                        }
                        // Execute the onConnected callback if there is one.
                        this._connected(reconnected, this._wsuri);
                        // Process all queued messages now that the connection is established.
                        this._process_queue();
                        break;
                    case MESSAGE_TYPE.PUBLISH:
                        this._receivePublish(wireMessage);
                        break;
                    case MESSAGE_TYPE.PUBACK:
                        var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
                        // If this is a re flow of a PUBACK after we have restarted receivedMessage will not exist.
                        if (sentMessage) {
                            delete this._sentMessages[wireMessage.messageIdentifier];
                            localStorage.removeItem("Sent:" + this._localKey + wireMessage.messageIdentifier);
                            if (this.onMessageDelivered) this.onMessageDelivered(sentMessage.payloadMessage);
                        }
                        break;
                    case MESSAGE_TYPE.PUBREC:
                        var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
                        // If this is a re flow of a PUBREC after we have restarted receivedMessage will not exist.
                        if (sentMessage) {
                            sentMessage.pubRecReceived = true;
                            var pubRelMessage = new WireMessage(MESSAGE_TYPE.PUBREL, {
                                messageIdentifier: wireMessage.messageIdentifier
                            });
                            this.store("Sent:", sentMessage);
                            this._schedule_message(pubRelMessage);
                        }
                        break;
                    case MESSAGE_TYPE.PUBREL:
                        var receivedMessage = this._receivedMessages[wireMessage.messageIdentifier];
                        localStorage.removeItem("Received:" + this._localKey + wireMessage.messageIdentifier);
                        // If this is a re flow of a PUBREL after we have restarted receivedMessage will not exist.
                        if (receivedMessage) {
                            this._receiveMessage(receivedMessage);
                            delete this._receivedMessages[wireMessage.messageIdentifier];
                        }
                        // Always flow PubComp, we may have previously flowed PubComp but the server lost it and restarted.
                        var pubCompMessage = new WireMessage(MESSAGE_TYPE.PUBCOMP, {
                            messageIdentifier: wireMessage.messageIdentifier
                        });
                        this._schedule_message(pubCompMessage);
                        break;
                    case MESSAGE_TYPE.PUBCOMP:
                        var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
                        delete this._sentMessages[wireMessage.messageIdentifier];
                        localStorage.removeItem("Sent:" + this._localKey + wireMessage.messageIdentifier);
                        if (this.onMessageDelivered) this.onMessageDelivered(sentMessage.payloadMessage);
                        break;
                    case MESSAGE_TYPE.SUBACK:
                        var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
                        if (sentMessage) {
                            if (sentMessage.timeOut) sentMessage.timeOut.cancel();
                            // This will need to be fixed when we add multiple topic support
                            if (wireMessage.returnCode[0] === 0x80) {
                                if (sentMessage.onFailure) sentMessage.onFailure(wireMessage.returnCode);
                            } else if (sentMessage.onSuccess) sentMessage.onSuccess(wireMessage.returnCode);
                            delete this._sentMessages[wireMessage.messageIdentifier];
                        }
                        break;
                    case MESSAGE_TYPE.UNSUBACK:
                        var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
                        if (sentMessage) {
                            if (sentMessage.timeOut) sentMessage.timeOut.cancel();
                            if (sentMessage.callback) sentMessage.callback();
                            delete this._sentMessages[wireMessage.messageIdentifier];
                        }
                        break;
                    case MESSAGE_TYPE.PINGRESP:
                        /* The sendPinger or receivePinger may have sent a ping, the receivePinger has already been reset. */ this.sendPinger.reset();
                        break;
                    case MESSAGE_TYPE.DISCONNECT:
                        // Clients do not expect to receive disconnect packets.
                        this._disconnected(ERROR.INVALID_MQTT_MESSAGE_TYPE.code, format(ERROR.INVALID_MQTT_MESSAGE_TYPE, [
                            wireMessage.type
                        ]));
                        break;
                    default:
                        this._disconnected(ERROR.INVALID_MQTT_MESSAGE_TYPE.code, format(ERROR.INVALID_MQTT_MESSAGE_TYPE, [
                            wireMessage.type
                        ]));
                }
            } catch (error) {
                var errorStack = error.hasOwnProperty("stack") == "undefined" ? error.stack.toString() : "No Error Stack Available";
                this._disconnected(ERROR.INTERNAL_ERROR.code, format(ERROR.INTERNAL_ERROR, [
                    error.message,
                    errorStack
                ]));
                return;
            }
        };
        /** @ignore */ ClientImpl.prototype._on_socket_error = function(error) {
            if (!this._reconnecting) this._disconnected(ERROR.SOCKET_ERROR.code, format(ERROR.SOCKET_ERROR, [
                error.data
            ]));
        };
        /** @ignore */ ClientImpl.prototype._on_socket_close = function() {
            if (!this._reconnecting) this._disconnected(ERROR.SOCKET_CLOSE.code, format(ERROR.SOCKET_CLOSE));
        };
        /** @ignore */ ClientImpl.prototype._socket_send = function(wireMessage) {
            if (wireMessage.type == 1) {
                var wireMessageMasked = this._traceMask(wireMessage, "password");
                this._trace("Client._socket_send", wireMessageMasked);
            } else this._trace("Client._socket_send", wireMessage);
            this.socket.send(wireMessage.encode());
            /* We have proved to the server we are alive. */ this.sendPinger.reset();
        };
        /** @ignore */ ClientImpl.prototype._receivePublish = function(wireMessage) {
            switch(wireMessage.payloadMessage.qos){
                case "undefined":
                case 0:
                    this._receiveMessage(wireMessage);
                    break;
                case 1:
                    var pubAckMessage = new WireMessage(MESSAGE_TYPE.PUBACK, {
                        messageIdentifier: wireMessage.messageIdentifier
                    });
                    this._schedule_message(pubAckMessage);
                    this._receiveMessage(wireMessage);
                    break;
                case 2:
                    this._receivedMessages[wireMessage.messageIdentifier] = wireMessage;
                    this.store("Received:", wireMessage);
                    var pubRecMessage = new WireMessage(MESSAGE_TYPE.PUBREC, {
                        messageIdentifier: wireMessage.messageIdentifier
                    });
                    this._schedule_message(pubRecMessage);
                    break;
                default:
                    throw Error("Invaild qos=" + wireMessage.payloadMessage.qos);
            }
        };
        /** @ignore */ ClientImpl.prototype._receiveMessage = function(wireMessage) {
            if (this.onMessageArrived) this.onMessageArrived(wireMessage.payloadMessage);
        };
        /**
	 * Client has connected.
	 * @param {reconnect} [boolean] indicate if this was a result of reconnect operation.
	 * @param {uri} [string] fully qualified WebSocket URI of the server.
	 */ ClientImpl.prototype._connected = function(reconnect, uri) {
            // Execute the onConnected callback if there is one.
            if (this.onConnected) this.onConnected(reconnect, uri);
        };
        /**
	 * Attempts to reconnect the client to the server.
   * For each reconnect attempt, will double the reconnect interval
   * up to 128 seconds.
	 */ ClientImpl.prototype._reconnect = function() {
            this._trace("Client._reconnect");
            if (!this.connected) {
                this._reconnecting = true;
                this.sendPinger.cancel();
                this.receivePinger.cancel();
                if (this._reconnectInterval < 128) this._reconnectInterval = this._reconnectInterval * 2;
                if (this.connectOptions.uris) {
                    this.hostIndex = 0;
                    this._doConnect(this.connectOptions.uris[0]);
                } else this._doConnect(this.uri);
            }
        };
        /**
	 * Client has disconnected either at its own request or because the server
	 * or network disconnected it. Remove all non-durable state.
	 * @param {errorCode} [number] the error number.
	 * @param {errorText} [string] the error text.
	 * @ignore
	 */ ClientImpl.prototype._disconnected = function(errorCode, errorText) {
            this._trace("Client._disconnected", errorCode, errorText);
            if (errorCode !== undefined && this._reconnecting) {
                //Continue automatic reconnect process
                this._reconnectTimeout = new Timeout(this, this._reconnectInterval, this._reconnect);
                return;
            }
            this.sendPinger.cancel();
            this.receivePinger.cancel();
            if (this._connectTimeout) {
                this._connectTimeout.cancel();
                this._connectTimeout = null;
            }
            // Clear message buffers.
            this._msg_queue = [];
            this._buffered_msg_queue = [];
            this._notify_msg_sent = {};
            if (this.socket) {
                // Cancel all socket callbacks so that they cannot be driven again by this socket.
                this.socket.onopen = null;
                this.socket.onmessage = null;
                this.socket.onerror = null;
                this.socket.onclose = null;
                if (this.socket.readyState === 1) this.socket.close();
                delete this.socket;
            }
            if (this.connectOptions.uris && this.hostIndex < this.connectOptions.uris.length - 1) {
                // Try the next host.
                this.hostIndex++;
                this._doConnect(this.connectOptions.uris[this.hostIndex]);
            } else {
                if (errorCode === undefined) {
                    errorCode = ERROR.OK.code;
                    errorText = format(ERROR.OK);
                }
                // Run any application callbacks last as they may attempt to reconnect and hence create a new socket.
                if (this.connected) {
                    this.connected = false;
                    // Execute the connectionLostCallback if there is one, and we were connected.
                    if (this.onConnectionLost) this.onConnectionLost({
                        errorCode: errorCode,
                        errorMessage: errorText,
                        reconnect: this.connectOptions.reconnect,
                        uri: this._wsuri
                    });
                    if (errorCode !== ERROR.OK.code && this.connectOptions.reconnect) {
                        // Start automatic reconnect process for the very first time since last successful connect.
                        this._reconnectInterval = 1;
                        this._reconnect();
                        return;
                    }
                } else {
                    // Otherwise we never had a connection, so indicate that the connect has failed.
                    if (this.connectOptions.mqttVersion === 4 && this.connectOptions.mqttVersionExplicit === false) {
                        this._trace("Failed to connect V4, dropping back to V3");
                        this.connectOptions.mqttVersion = 3;
                        if (this.connectOptions.uris) {
                            this.hostIndex = 0;
                            this._doConnect(this.connectOptions.uris[0]);
                        } else this._doConnect(this.uri);
                    } else if (this.connectOptions.onFailure) this.connectOptions.onFailure({
                        invocationContext: this.connectOptions.invocationContext,
                        errorCode: errorCode,
                        errorMessage: errorText
                    });
                }
            }
        };
        /** @ignore */ ClientImpl.prototype._trace = function() {
            // Pass trace message back to client's callback function
            if (this.traceFunction) {
                var args = Array.prototype.slice.call(arguments);
                for(var i in args)if (typeof args[i] !== "undefined") args.splice(i, 1, JSON.stringify(args[i]));
                var record = args.join("");
                this.traceFunction({
                    severity: "Debug",
                    message: record
                });
            }
            //buffer style trace
            if (this._traceBuffer !== null) for(var i = 0, max = arguments.length; i < max; i++){
                if (this._traceBuffer.length == this._MAX_TRACE_ENTRIES) this._traceBuffer.shift();
                if (i === 0) this._traceBuffer.push(arguments[i]);
                else if (typeof arguments[i] === "undefined") this._traceBuffer.push(arguments[i]);
                else this._traceBuffer.push("  " + JSON.stringify(arguments[i]));
            }
        };
        /** @ignore */ ClientImpl.prototype._traceMask = function(traceObject, masked) {
            var traceObjectMasked = {};
            for(var attr in traceObject)if (traceObject.hasOwnProperty(attr)) {
                if (attr == masked) traceObjectMasked[attr] = "******";
                else traceObjectMasked[attr] = traceObject[attr];
            }
            return traceObjectMasked;
        };
        // ------------------------------------------------------------------------
        // Public Programming interface.
        // ------------------------------------------------------------------------
        /**
	 * The JavaScript application communicates to the server using a {@link Paho.Client} object.
	 * <p>
	 * Most applications will create just one Client object and then call its connect() method,
	 * however applications can create more than one Client object if they wish.
	 * In this case the combination of host, port and clientId attributes must be different for each Client object.
	 * <p>
	 * The send, subscribe and unsubscribe methods are implemented as asynchronous JavaScript methods
	 * (even though the underlying protocol exchange might be synchronous in nature).
	 * This means they signal their completion by calling back to the application,
	 * via Success or Failure callback functions provided by the application on the method in question.
	 * Such callbacks are called at most once per method invocation and do not persist beyond the lifetime
	 * of the script that made the invocation.
	 * <p>
	 * In contrast there are some callback functions, most notably <i>onMessageArrived</i>,
	 * that are defined on the {@link Paho.Client} object.
	 * These may get called multiple times, and aren't directly related to specific method invocations made by the client.
	 *
	 * @name Paho.Client
	 *
	 * @constructor
	 *
	 * @param {string} host - the address of the messaging server, as a fully qualified WebSocket URI, as a DNS name or dotted decimal IP address.
	 * @param {number} port - the port number to connect to - only required if host is not a URI
	 * @param {string} path - the path on the host to connect to - only used if host is not a URI. Default: '/mqtt'.
	 * @param {string} clientId - the Messaging client identifier, between 1 and 23 characters in length.
	 *
	 * @property {string} host - <i>read only</i> the server's DNS hostname or dotted decimal IP address.
	 * @property {number} port - <i>read only</i> the server's port.
	 * @property {string} path - <i>read only</i> the server's path.
	 * @property {string} clientId - <i>read only</i> used when connecting to the server.
	 * @property {function} onConnectionLost - called when a connection has been lost.
	 *                            after a connect() method has succeeded.
	 *                            Establish the call back used when a connection has been lost. The connection may be
	 *                            lost because the client initiates a disconnect or because the server or network
	 *                            cause the client to be disconnected. The disconnect call back may be called without
	 *                            the connectionComplete call back being invoked if, for example the client fails to
	 *                            connect.
	 *                            A single response object parameter is passed to the onConnectionLost callback containing the following fields:
	 *                            <ol>
	 *                            <li>errorCode
	 *                            <li>errorMessage
	 *                            </ol>
	 * @property {function} onMessageDelivered - called when a message has been delivered.
	 *                            All processing that this Client will ever do has been completed. So, for example,
	 *                            in the case of a Qos=2 message sent by this client, the PubComp flow has been received from the server
	 *                            and the message has been removed from persistent storage before this callback is invoked.
	 *                            Parameters passed to the onMessageDelivered callback are:
	 *                            <ol>
	 *                            <li>{@link Paho.Message} that was delivered.
	 *                            </ol>
	 * @property {function} onMessageArrived - called when a message has arrived in this Paho.client.
	 *                            Parameters passed to the onMessageArrived callback are:
	 *                            <ol>
	 *                            <li>{@link Paho.Message} that has arrived.
	 *                            </ol>
	 * @property {function} onConnected - called when a connection is successfully made to the server.
	 *                                  after a connect() method.
	 *                                  Parameters passed to the onConnected callback are:
	 *                                  <ol>
	 *                                  <li>reconnect (boolean) - If true, the connection was the result of a reconnect.</li>
	 *                                  <li>URI (string) - The URI used to connect to the server.</li>
	 *                                  </ol>
	 * @property {boolean} disconnectedPublishing - if set, will enable disconnected publishing in
	 *                                            in the event that the connection to the server is lost.
	 * @property {number} disconnectedBufferSize - Used to set the maximum number of messages that the disconnected
	 *                                             buffer will hold before rejecting new messages. Default size: 5000 messages
	 * @property {function} trace - called whenever trace is called. TODO
	 */ var Client = function(host, port, path, clientId) {
            var uri;
            if (typeof host !== "string") throw new Error(format(ERROR.INVALID_TYPE, [
                typeof host,
                "host"
            ]));
            if (arguments.length == 2) {
                // host: must be full ws:// uri
                // port: clientId
                clientId = port;
                uri = host;
                var match = uri.match(/^(wss?):\/\/((\[(.+)\])|([^\/]+?))(:(\d+))?(\/.*)$/);
                if (match) {
                    host = match[4] || match[2];
                    port = parseInt(match[7]);
                    path = match[8];
                } else throw new Error(format(ERROR.INVALID_ARGUMENT, [
                    host,
                    "host"
                ]));
            } else {
                if (arguments.length == 3) {
                    clientId = path;
                    path = "/mqtt";
                }
                if (typeof port !== "number" || port < 0) throw new Error(format(ERROR.INVALID_TYPE, [
                    typeof port,
                    "port"
                ]));
                if (typeof path !== "string") throw new Error(format(ERROR.INVALID_TYPE, [
                    typeof path,
                    "path"
                ]));
                var ipv6AddSBracket = host.indexOf(":") !== -1 && host.slice(0, 1) !== "[" && host.slice(-1) !== "]";
                uri = "ws://" + (ipv6AddSBracket ? "[" + host + "]" : host) + ":" + port + path;
            }
            var clientIdLength = 0;
            for(var i = 0; i < clientId.length; i++){
                var charCode = clientId.charCodeAt(i);
                if (0xD800 <= charCode && charCode <= 0xDBFF) i++; // Surrogate pair.
                clientIdLength++;
            }
            if (typeof clientId !== "string" || clientIdLength > 65535) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                clientId,
                "clientId"
            ]));
            var client = new ClientImpl(uri, host, port, path, clientId);
            //Public Properties
            Object.defineProperties(this, {
                "host": {
                    get: function() {
                        return host;
                    },
                    set: function() {
                        throw new Error(format(ERROR.UNSUPPORTED_OPERATION));
                    }
                },
                "port": {
                    get: function() {
                        return port;
                    },
                    set: function() {
                        throw new Error(format(ERROR.UNSUPPORTED_OPERATION));
                    }
                },
                "path": {
                    get: function() {
                        return path;
                    },
                    set: function() {
                        throw new Error(format(ERROR.UNSUPPORTED_OPERATION));
                    }
                },
                "uri": {
                    get: function() {
                        return uri;
                    },
                    set: function() {
                        throw new Error(format(ERROR.UNSUPPORTED_OPERATION));
                    }
                },
                "clientId": {
                    get: function() {
                        return client.clientId;
                    },
                    set: function() {
                        throw new Error(format(ERROR.UNSUPPORTED_OPERATION));
                    }
                },
                "onConnected": {
                    get: function() {
                        return client.onConnected;
                    },
                    set: function(newOnConnected) {
                        if (typeof newOnConnected === "function") client.onConnected = newOnConnected;
                        else throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof newOnConnected,
                            "onConnected"
                        ]));
                    }
                },
                "disconnectedPublishing": {
                    get: function() {
                        return client.disconnectedPublishing;
                    },
                    set: function(newDisconnectedPublishing) {
                        client.disconnectedPublishing = newDisconnectedPublishing;
                    }
                },
                "disconnectedBufferSize": {
                    get: function() {
                        return client.disconnectedBufferSize;
                    },
                    set: function(newDisconnectedBufferSize) {
                        client.disconnectedBufferSize = newDisconnectedBufferSize;
                    }
                },
                "onConnectionLost": {
                    get: function() {
                        return client.onConnectionLost;
                    },
                    set: function(newOnConnectionLost) {
                        if (typeof newOnConnectionLost === "function") client.onConnectionLost = newOnConnectionLost;
                        else throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof newOnConnectionLost,
                            "onConnectionLost"
                        ]));
                    }
                },
                "onMessageDelivered": {
                    get: function() {
                        return client.onMessageDelivered;
                    },
                    set: function(newOnMessageDelivered) {
                        if (typeof newOnMessageDelivered === "function") client.onMessageDelivered = newOnMessageDelivered;
                        else throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof newOnMessageDelivered,
                            "onMessageDelivered"
                        ]));
                    }
                },
                "onMessageArrived": {
                    get: function() {
                        return client.onMessageArrived;
                    },
                    set: function(newOnMessageArrived) {
                        if (typeof newOnMessageArrived === "function") client.onMessageArrived = newOnMessageArrived;
                        else throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof newOnMessageArrived,
                            "onMessageArrived"
                        ]));
                    }
                },
                "trace": {
                    get: function() {
                        return client.traceFunction;
                    },
                    set: function(trace) {
                        if (typeof trace === "function") client.traceFunction = trace;
                        else throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof trace,
                            "onTrace"
                        ]));
                    }
                }
            });
            /**
		 * Connect this Messaging client to its server.
		 *
		 * @name Paho.Client#connect
		 * @function
		 * @param {object} connectOptions - Attributes used with the connection.
		 * @param {number} connectOptions.timeout - If the connect has not succeeded within this
		 *                    number of seconds, it is deemed to have failed.
		 *                    The default is 30 seconds.
		 * @param {string} connectOptions.userName - Authentication username for this connection.
		 * @param {string} connectOptions.password - Authentication password for this connection.
		 * @param {Paho.Message} connectOptions.willMessage - sent by the server when the client
		 *                    disconnects abnormally.
		 * @param {number} connectOptions.keepAliveInterval - the server disconnects this client if
		 *                    there is no activity for this number of seconds.
		 *                    The default value of 60 seconds is assumed if not set.
		 * @param {boolean} connectOptions.cleanSession - if true(default) the client and server
		 *                    persistent state is deleted on successful connect.
		 * @param {boolean} connectOptions.useSSL - if present and true, use an SSL Websocket connection.
		 * @param {object} connectOptions.invocationContext - passed to the onSuccess callback or onFailure callback.
		 * @param {function} connectOptions.onSuccess - called when the connect acknowledgement
		 *                    has been received from the server.
		 * A single response object parameter is passed to the onSuccess callback containing the following fields:
		 * <ol>
		 * <li>invocationContext as passed in to the onSuccess method in the connectOptions.
		 * </ol>
	 * @param {function} connectOptions.onFailure - called when the connect request has failed or timed out.
		 * A single response object parameter is passed to the onFailure callback containing the following fields:
		 * <ol>
		 * <li>invocationContext as passed in to the onFailure method in the connectOptions.
		 * <li>errorCode a number indicating the nature of the error.
		 * <li>errorMessage text describing the error.
		 * </ol>
	 * @param {array} connectOptions.hosts - If present this contains either a set of hostnames or fully qualified
		 * WebSocket URIs (ws://iot.eclipse.org:80/ws), that are tried in order in place
		 * of the host and port paramater on the construtor. The hosts are tried one at at time in order until
		 * one of then succeeds.
	 * @param {array} connectOptions.ports - If present the set of ports matching the hosts. If hosts contains URIs, this property
		 * is not used.
	 * @param {boolean} connectOptions.reconnect - Sets whether the client will automatically attempt to reconnect
	 * to the server if the connection is lost.
	 *<ul>
	 *<li>If set to false, the client will not attempt to automatically reconnect to the server in the event that the
	 * connection is lost.</li>
	 *<li>If set to true, in the event that the connection is lost, the client will attempt to reconnect to the server.
	 * It will initially wait 1 second before it attempts to reconnect, for every failed reconnect attempt, the delay
	 * will double until it is at 2 minutes at which point the delay will stay at 2 minutes.</li>
	 *</ul>
	 * @param {number} connectOptions.mqttVersion - The version of MQTT to use to connect to the MQTT Broker.
	 *<ul>
	 *<li>3 - MQTT V3.1</li>
	 *<li>4 - MQTT V3.1.1</li>
	 *</ul>
	 * @param {boolean} connectOptions.mqttVersionExplicit - If set to true, will force the connection to use the
	 * selected MQTT Version or will fail to connect.
	 * @param {array} connectOptions.uris - If present, should contain a list of fully qualified WebSocket uris
	 * (e.g. ws://iot.eclipse.org:80/ws), that are tried in order in place of the host and port parameter of the construtor.
	 * The uris are tried one at a time in order until one of them succeeds. Do not use this in conjunction with hosts as
	 * the hosts array will be converted to uris and will overwrite this property.
		 * @throws {InvalidState} If the client is not in disconnected state. The client must have received connectionLost
		 * or disconnected before calling connect for a second or subsequent time.
		 */ this.connect = function(connectOptions) {
                connectOptions = connectOptions || {};
                validate(connectOptions, {
                    timeout: "number",
                    userName: "string",
                    password: "string",
                    willMessage: "object",
                    keepAliveInterval: "number",
                    cleanSession: "boolean",
                    useSSL: "boolean",
                    invocationContext: "object",
                    onSuccess: "function",
                    onFailure: "function",
                    hosts: "object",
                    ports: "object",
                    reconnect: "boolean",
                    mqttVersion: "number",
                    mqttVersionExplicit: "boolean",
                    uris: "object"
                });
                // If no keep alive interval is set, assume 60 seconds.
                if (connectOptions.keepAliveInterval === undefined) connectOptions.keepAliveInterval = 60;
                if (connectOptions.mqttVersion > 4 || connectOptions.mqttVersion < 3) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                    connectOptions.mqttVersion,
                    "connectOptions.mqttVersion"
                ]));
                if (connectOptions.mqttVersion === undefined) {
                    connectOptions.mqttVersionExplicit = false;
                    connectOptions.mqttVersion = 4;
                } else connectOptions.mqttVersionExplicit = true;
                //Check that if password is set, so is username
                if (connectOptions.password !== undefined && connectOptions.userName === undefined) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                    connectOptions.password,
                    "connectOptions.password"
                ]));
                if (connectOptions.willMessage) {
                    if (!(connectOptions.willMessage instanceof Message)) throw new Error(format(ERROR.INVALID_TYPE, [
                        connectOptions.willMessage,
                        "connectOptions.willMessage"
                    ]));
                    // The will message must have a payload that can be represented as a string.
                    // Cause the willMessage to throw an exception if this is not the case.
                    connectOptions.willMessage.stringPayload = null;
                    if (typeof connectOptions.willMessage.destinationName === "undefined") throw new Error(format(ERROR.INVALID_TYPE, [
                        typeof connectOptions.willMessage.destinationName,
                        "connectOptions.willMessage.destinationName"
                    ]));
                }
                if (typeof connectOptions.cleanSession === "undefined") connectOptions.cleanSession = true;
                if (connectOptions.hosts) {
                    if (!(connectOptions.hosts instanceof Array)) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                        connectOptions.hosts,
                        "connectOptions.hosts"
                    ]));
                    if (connectOptions.hosts.length < 1) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                        connectOptions.hosts,
                        "connectOptions.hosts"
                    ]));
                    var usingURIs = false;
                    for(var i = 0; i < connectOptions.hosts.length; i++){
                        if (typeof connectOptions.hosts[i] !== "string") throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof connectOptions.hosts[i],
                            "connectOptions.hosts[" + i + "]"
                        ]));
                        if (/^(wss?):\/\/((\[(.+)\])|([^\/]+?))(:(\d+))?(\/.*)$/.test(connectOptions.hosts[i])) {
                            if (i === 0) usingURIs = true;
                            else if (!usingURIs) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                                connectOptions.hosts[i],
                                "connectOptions.hosts[" + i + "]"
                            ]));
                        } else if (usingURIs) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            connectOptions.hosts[i],
                            "connectOptions.hosts[" + i + "]"
                        ]));
                    }
                    if (!usingURIs) {
                        if (!connectOptions.ports) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            connectOptions.ports,
                            "connectOptions.ports"
                        ]));
                        if (!(connectOptions.ports instanceof Array)) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            connectOptions.ports,
                            "connectOptions.ports"
                        ]));
                        if (connectOptions.hosts.length !== connectOptions.ports.length) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            connectOptions.ports,
                            "connectOptions.ports"
                        ]));
                        connectOptions.uris = [];
                        for(var i = 0; i < connectOptions.hosts.length; i++){
                            if (typeof connectOptions.ports[i] !== "number" || connectOptions.ports[i] < 0) throw new Error(format(ERROR.INVALID_TYPE, [
                                typeof connectOptions.ports[i],
                                "connectOptions.ports[" + i + "]"
                            ]));
                            var host = connectOptions.hosts[i];
                            var port = connectOptions.ports[i];
                            var ipv6 = host.indexOf(":") !== -1;
                            uri = "ws://" + (ipv6 ? "[" + host + "]" : host) + ":" + port + path;
                            connectOptions.uris.push(uri);
                        }
                    } else connectOptions.uris = connectOptions.hosts;
                }
                client.connect(connectOptions);
            };
            /**
		 * Subscribe for messages, request receipt of a copy of messages sent to the destinations described by the filter.
		 *
		 * @name Paho.Client#subscribe
		 * @function
		 * @param {string} filter describing the destinations to receive messages from.
		 * <br>
		 * @param {object} subscribeOptions - used to control the subscription
		 *
		 * @param {number} subscribeOptions.qos - the maximum qos of any publications sent
		 *                                  as a result of making this subscription.
		 * @param {object} subscribeOptions.invocationContext - passed to the onSuccess callback
		 *                                  or onFailure callback.
		 * @param {function} subscribeOptions.onSuccess - called when the subscribe acknowledgement
		 *                                  has been received from the server.
		 *                                  A single response object parameter is passed to the onSuccess callback containing the following fields:
		 *                                  <ol>
		 *                                  <li>invocationContext if set in the subscribeOptions.
		 *                                  </ol>
		 * @param {function} subscribeOptions.onFailure - called when the subscribe request has failed or timed out.
		 *                                  A single response object parameter is passed to the onFailure callback containing the following fields:
		 *                                  <ol>
		 *                                  <li>invocationContext - if set in the subscribeOptions.
		 *                                  <li>errorCode - a number indicating the nature of the error.
		 *                                  <li>errorMessage - text describing the error.
		 *                                  </ol>
		 * @param {number} subscribeOptions.timeout - which, if present, determines the number of
		 *                                  seconds after which the onFailure calback is called.
		 *                                  The presence of a timeout does not prevent the onSuccess
		 *                                  callback from being called when the subscribe completes.
		 * @throws {InvalidState} if the client is not in connected state.
		 */ this.subscribe = function(filter, subscribeOptions) {
                if (typeof filter !== "string") throw new Error("Invalid argument:" + filter);
                subscribeOptions = subscribeOptions || {};
                validate(subscribeOptions, {
                    qos: "number",
                    invocationContext: "object",
                    onSuccess: "function",
                    onFailure: "function",
                    timeout: "number"
                });
                if (subscribeOptions.timeout && !subscribeOptions.onFailure) throw new Error("subscribeOptions.timeout specified with no onFailure callback.");
                if (typeof subscribeOptions.qos !== "undefined" && !(subscribeOptions.qos === 0 || subscribeOptions.qos === 1 || subscribeOptions.qos === 2)) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                    subscribeOptions.qos,
                    "subscribeOptions.qos"
                ]));
                client.subscribe(filter, subscribeOptions);
            };
            /**
		 * Unsubscribe for messages, stop receiving messages sent to destinations described by the filter.
		 *
		 * @name Paho.Client#unsubscribe
		 * @function
		 * @param {string} filter - describing the destinations to receive messages from.
		 * @param {object} unsubscribeOptions - used to control the subscription
		 * @param {object} unsubscribeOptions.invocationContext - passed to the onSuccess callback
											  or onFailure callback.
		 * @param {function} unsubscribeOptions.onSuccess - called when the unsubscribe acknowledgement has been received from the server.
		 *                                    A single response object parameter is passed to the
		 *                                    onSuccess callback containing the following fields:
		 *                                    <ol>
		 *                                    <li>invocationContext - if set in the unsubscribeOptions.
		 *                                    </ol>
		 * @param {function} unsubscribeOptions.onFailure called when the unsubscribe request has failed or timed out.
		 *                                    A single response object parameter is passed to the onFailure callback containing the following fields:
		 *                                    <ol>
		 *                                    <li>invocationContext - if set in the unsubscribeOptions.
		 *                                    <li>errorCode - a number indicating the nature of the error.
		 *                                    <li>errorMessage - text describing the error.
		 *                                    </ol>
		 * @param {number} unsubscribeOptions.timeout - which, if present, determines the number of seconds
		 *                                    after which the onFailure callback is called. The presence of
		 *                                    a timeout does not prevent the onSuccess callback from being
		 *                                    called when the unsubscribe completes
		 * @throws {InvalidState} if the client is not in connected state.
		 */ this.unsubscribe = function(filter, unsubscribeOptions) {
                if (typeof filter !== "string") throw new Error("Invalid argument:" + filter);
                unsubscribeOptions = unsubscribeOptions || {};
                validate(unsubscribeOptions, {
                    invocationContext: "object",
                    onSuccess: "function",
                    onFailure: "function",
                    timeout: "number"
                });
                if (unsubscribeOptions.timeout && !unsubscribeOptions.onFailure) throw new Error("unsubscribeOptions.timeout specified with no onFailure callback.");
                client.unsubscribe(filter, unsubscribeOptions);
            };
            /**
		 * Send a message to the consumers of the destination in the Message.
		 *
		 * @name Paho.Client#send
		 * @function
		 * @param {string|Paho.Message} topic - <b>mandatory</b> The name of the destination to which the message is to be sent.
		 * 					   - If it is the only parameter, used as Paho.Message object.
		 * @param {String|ArrayBuffer} payload - The message data to be sent.
		 * @param {number} qos The Quality of Service used to deliver the message.
		 * 		<dl>
		 * 			<dt>0 Best effort (default).
		 *     			<dt>1 At least once.
		 *     			<dt>2 Exactly once.
		 * 		</dl>
		 * @param {Boolean} retained If true, the message is to be retained by the server and delivered
		 *                     to both current and future subscriptions.
		 *                     If false the server only delivers the message to current subscribers, this is the default for new Messages.
		 *                     A received message has the retained boolean set to true if the message was published
		 *                     with the retained boolean set to true
		 *                     and the subscrption was made after the message has been published.
		 * @throws {InvalidState} if the client is not connected.
		 */ this.send = function(topic, payload, qos, retained) {
                var message;
                if (arguments.length === 0) throw new Error("Invalid argument.length");
                else if (arguments.length == 1) {
                    if (!(topic instanceof Message) && typeof topic !== "string") throw new Error("Invalid argument:" + typeof topic);
                    message = topic;
                    if (typeof message.destinationName === "undefined") throw new Error(format(ERROR.INVALID_ARGUMENT, [
                        message.destinationName,
                        "Message.destinationName"
                    ]));
                    client.send(message);
                } else {
                    //parameter checking in Message object
                    message = new Message(payload);
                    message.destinationName = topic;
                    if (arguments.length >= 3) message.qos = qos;
                    if (arguments.length >= 4) message.retained = retained;
                    client.send(message);
                }
            };
            /**
		 * Publish a message to the consumers of the destination in the Message.
		 * Synonym for Paho.Mqtt.Client#send
		 *
		 * @name Paho.Client#publish
		 * @function
		 * @param {string|Paho.Message} topic - <b>mandatory</b> The name of the topic to which the message is to be published.
		 * 					   - If it is the only parameter, used as Paho.Message object.
		 * @param {String|ArrayBuffer} payload - The message data to be published.
		 * @param {number} qos The Quality of Service used to deliver the message.
		 * 		<dl>
		 * 			<dt>0 Best effort (default).
		 *     			<dt>1 At least once.
		 *     			<dt>2 Exactly once.
		 * 		</dl>
		 * @param {Boolean} retained If true, the message is to be retained by the server and delivered
		 *                     to both current and future subscriptions.
		 *                     If false the server only delivers the message to current subscribers, this is the default for new Messages.
		 *                     A received message has the retained boolean set to true if the message was published
		 *                     with the retained boolean set to true
		 *                     and the subscrption was made after the message has been published.
		 * @throws {InvalidState} if the client is not connected.
		 */ this.publish = function(topic, payload, qos, retained) {
                var message;
                if (arguments.length === 0) throw new Error("Invalid argument.length");
                else if (arguments.length == 1) {
                    if (!(topic instanceof Message) && typeof topic !== "string") throw new Error("Invalid argument:" + typeof topic);
                    message = topic;
                    if (typeof message.destinationName === "undefined") throw new Error(format(ERROR.INVALID_ARGUMENT, [
                        message.destinationName,
                        "Message.destinationName"
                    ]));
                    client.send(message);
                } else {
                    //parameter checking in Message object
                    message = new Message(payload);
                    message.destinationName = topic;
                    if (arguments.length >= 3) message.qos = qos;
                    if (arguments.length >= 4) message.retained = retained;
                    client.send(message);
                }
            };
            /**
		 * Normal disconnect of this Messaging client from its server.
		 *
		 * @name Paho.Client#disconnect
		 * @function
		 * @throws {InvalidState} if the client is already disconnected.
		 */ this.disconnect = function() {
                client.disconnect();
            };
            /**
		 * Get the contents of the trace log.
		 *
		 * @name Paho.Client#getTraceLog
		 * @function
		 * @return {Object[]} tracebuffer containing the time ordered trace records.
		 */ this.getTraceLog = function() {
                return client.getTraceLog();
            };
            /**
		 * Start tracing.
		 *
		 * @name Paho.Client#startTrace
		 * @function
		 */ this.startTrace = function() {
                client.startTrace();
            };
            /**
		 * Stop tracing.
		 *
		 * @name Paho.Client#stopTrace
		 * @function
		 */ this.stopTrace = function() {
                client.stopTrace();
            };
            this.isConnected = function() {
                return client.connected;
            };
        };
        /**
	 * An application message, sent or received.
	 * <p>
	 * All attributes may be null, which implies the default values.
	 *
	 * @name Paho.Message
	 * @constructor
	 * @param {String|ArrayBuffer} payload The message data to be sent.
	 * <p>
	 * @property {string} payloadString <i>read only</i> The payload as a string if the payload consists of valid UTF-8 characters.
	 * @property {ArrayBuffer} payloadBytes <i>read only</i> The payload as an ArrayBuffer.
	 * <p>
	 * @property {string} destinationName <b>mandatory</b> The name of the destination to which the message is to be sent
	 *                    (for messages about to be sent) or the name of the destination from which the message has been received.
	 *                    (for messages received by the onMessage function).
	 * <p>
	 * @property {number} qos The Quality of Service used to deliver the message.
	 * <dl>
	 *     <dt>0 Best effort (default).
	 *     <dt>1 At least once.
	 *     <dt>2 Exactly once.
	 * </dl>
	 * <p>
	 * @property {Boolean} retained If true, the message is to be retained by the server and delivered
	 *                     to both current and future subscriptions.
	 *                     If false the server only delivers the message to current subscribers, this is the default for new Messages.
	 *                     A received message has the retained boolean set to true if the message was published
	 *                     with the retained boolean set to true
	 *                     and the subscrption was made after the message has been published.
	 * <p>
	 * @property {Boolean} duplicate <i>read only</i> If true, this message might be a duplicate of one which has already been received.
	 *                     This is only set on messages received from the server.
	 *
	 */ var Message = function(newPayload) {
            var payload;
            if (typeof newPayload === "string" || newPayload instanceof ArrayBuffer || ArrayBuffer.isView(newPayload) && !(newPayload instanceof DataView)) payload = newPayload;
            else throw format(ERROR.INVALID_ARGUMENT, [
                newPayload,
                "newPayload"
            ]);
            var destinationName;
            var qos = 0;
            var retained = false;
            var duplicate = false;
            Object.defineProperties(this, {
                "payloadString": {
                    enumerable: true,
                    get: function() {
                        if (typeof payload === "string") return payload;
                        else return parseUTF8(payload, 0, payload.length);
                    }
                },
                "payloadBytes": {
                    enumerable: true,
                    get: function() {
                        if (typeof payload === "string") {
                            var buffer = new ArrayBuffer(UTF8Length(payload));
                            var byteStream = new Uint8Array(buffer);
                            stringToUTF8(payload, byteStream, 0);
                            return byteStream;
                        } else return payload;
                    }
                },
                "destinationName": {
                    enumerable: true,
                    get: function() {
                        return destinationName;
                    },
                    set: function(newDestinationName) {
                        if (typeof newDestinationName === "string") destinationName = newDestinationName;
                        else throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            newDestinationName,
                            "newDestinationName"
                        ]));
                    }
                },
                "qos": {
                    enumerable: true,
                    get: function() {
                        return qos;
                    },
                    set: function(newQos) {
                        if (newQos === 0 || newQos === 1 || newQos === 2) qos = newQos;
                        else throw new Error("Invalid argument:" + newQos);
                    }
                },
                "retained": {
                    enumerable: true,
                    get: function() {
                        return retained;
                    },
                    set: function(newRetained) {
                        if (typeof newRetained === "boolean") retained = newRetained;
                        else throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            newRetained,
                            "newRetained"
                        ]));
                    }
                },
                "topic": {
                    enumerable: true,
                    get: function() {
                        return destinationName;
                    },
                    set: function(newTopic) {
                        destinationName = newTopic;
                    }
                },
                "duplicate": {
                    enumerable: true,
                    get: function() {
                        return duplicate;
                    },
                    set: function(newDuplicate) {
                        duplicate = newDuplicate;
                    }
                }
            });
        };
        // Module contents.
        return {
            Client: Client,
            Message: Message
        };
    // eslint-disable-next-line no-nested-ternary
    }(typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
    return PahoMQTT;
});


parcelRequire("jDiDD");
var $8gQB0 = parcelRequire("8gQB0");
var $74a8a792cabd7b79$var$logger = $79811f83b909f6d2$exports.rootLogger.extend('subscriptions');
var $74a8a792cabd7b79$var$mqttLogger = $74a8a792cabd7b79$var$logger.extend('mqtt');
$74a8a792cabd7b79$exports.CONTROL_EVENTS_KEY = '@@controlEvents';
var $74a8a792cabd7b79$var$SubscriptionHandshakeLink = /** @class */ function(_super) {
    $74a8a792cabd7b79$var$__extends(SubscriptionHandshakeLink, _super);
    function SubscriptionHandshakeLink(subsInfoContextKey) {
        var _this = _super.call(this) || this;
        _this.topicObservers = new Map();
        _this.clientObservers = new Map();
        _this.onMessage = function(topic, message, selectionNames) {
            var parsedMessage = JSON.parse(message);
            var observers = _this.topicObservers.get(topic);
            var data = selectionNames.reduce(function(acc, name) {
                return acc[name] = acc[name] || null, acc;
            }, parsedMessage.data || {});
            $74a8a792cabd7b79$var$logger('Message received', {
                data: data,
                topic: topic,
                observers: observers
            });
            observers.forEach(function(observer) {
                try {
                    observer.next($74a8a792cabd7b79$var$__assign($74a8a792cabd7b79$var$__assign({}, parsedMessage), {
                        data: data
                    }));
                } catch (err) {
                    $74a8a792cabd7b79$var$logger(err);
                }
            });
        };
        _this.subsInfoContextKey = subsInfoContextKey;
        return _this;
    }
    SubscriptionHandshakeLink.prototype.request = function(operation) {
        var _a;
        var _this = this;
        var _b = operation.getContext(), _c = this.subsInfoContextKey, subsInfo = _b[_c], _d = _b.controlMessages, _e = $74a8a792cabd7b79$exports.CONTROL_EVENTS_KEY, controlEvents = (_d === void 0 ? (_a = {}, _a[$74a8a792cabd7b79$exports.CONTROL_EVENTS_KEY] = undefined, _a) : _d)[_e];
        var _f = subsInfo.extensions, _g = (_f === void 0 ? {
            subscription: {
                newSubscriptions: {},
                mqttConnections: []
            }
        } : _f).subscription, newSubscriptions = _g.newSubscriptions, mqttConnections = _g.mqttConnections, _h = subsInfo.errors, errors = _h === void 0 ? [] : _h;
        if (errors && errors.length) return new $9uTW6.default(function(observer) {
            observer.error(new $jWiaX.ApolloError({
                errorMessage: 'Error during subscription handshake',
                extraInfo: {
                    errors: errors
                },
                graphQLErrors: errors
            }));
            return function() {};
        });
        var newSubscriptionTopics = Object.keys(newSubscriptions).map(function(subKey) {
            return newSubscriptions[subKey].topic;
        });
        var existingTopicsWithObserver = new Set(newSubscriptionTopics.filter(function(t) {
            return _this.topicObservers.has(t);
        }));
        var newTopics = new Set(newSubscriptionTopics.filter(function(t) {
            return !existingTopicsWithObserver.has(t);
        }));
        return new $9uTW6.default(function(observer) {
            existingTopicsWithObserver.forEach(function(t) {
                _this.topicObservers.get(t).add(observer);
                var anObserver = Array.from(_this.topicObservers.get(t)).find(function() {
                    return true;
                });
                var clientId = Array.from(_this.clientObservers).find(function(_a) {
                    var observers = _a[1].observers;
                    return observers.has(anObserver);
                })[0];
                _this.clientObservers.get(clientId).observers.add(observer);
            });
            var newTopicsConnectionInfo = mqttConnections.filter(function(c) {
                return c.topics.some(function(t) {
                    return newTopics.has(t);
                });
            }).map(function(_a) {
                var topics = _a.topics, rest = $74a8a792cabd7b79$var$__rest(_a, [
                    "topics"
                ]);
                return $74a8a792cabd7b79$var$__assign($74a8a792cabd7b79$var$__assign({}, rest), {
                    topics: topics.filter(function(t) {
                        return newTopics.has(t);
                    })
                });
            });
            _this.connectNewClients(newTopicsConnectionInfo, observer, operation);
            return function() {
                var clientsForCurrentObserver = Array.from(_this.clientObservers).filter(function(_a) {
                    var observers = _a[1].observers;
                    return observers.has(observer);
                });
                clientsForCurrentObserver.forEach(function(_a) {
                    var clientId = _a[0];
                    return _this.clientObservers.get(clientId).observers.delete(observer);
                });
                _this.clientObservers.forEach(function(_a) {
                    var observers = _a.observers, client = _a.client;
                    if (observers.size === 0) {
                        if (client.isConnected()) client.disconnect();
                        _this.clientObservers.delete(client.clientId);
                    }
                });
                _this.clientObservers = new Map(Array.from(_this.clientObservers).filter(function(_a) {
                    var observers = _a[1].observers;
                    return observers.size > 0;
                }));
                _this.topicObservers.forEach(function(observers) {
                    return observers.delete(observer);
                });
                _this.topicObservers = new Map(Array.from(_this.topicObservers).filter(function(_a) {
                    var observers = _a[1];
                    return observers.size > 0;
                }));
            };
        }).filter(function(data) {
            var _a = data.extensions, _b = (_a === void 0 ? {} : _a).controlMsgType, controlMsgType = _b === void 0 ? undefined : _b;
            var isControlMsg = typeof controlMsgType !== 'undefined';
            return controlEvents === true || !isControlMsg;
        });
    };
    SubscriptionHandshakeLink.prototype.connectNewClients = function(connectionInfo, observer, operation) {
        return $74a8a792cabd7b79$var$__awaiter(this, void 0, void 0, function() {
            var query, selectionNames, result, data;
            var _this = this;
            return $74a8a792cabd7b79$var$__generator(this, function(_a) {
                query = operation.query;
                selectionNames = $8gQB0.getMainDefinition(query).selectionSet.selections.map(function(_a) {
                    var value = _a.name.value;
                    return value;
                });
                result = Promise.all(connectionInfo.map(function(c) {
                    return _this.connectNewClient(c, observer, selectionNames);
                }));
                data = selectionNames.reduce(function(acc, name) {
                    return acc[name] = acc[name] || null, acc;
                }, {});
                observer.next({
                    data: data,
                    extensions: {
                        controlMsgType: 'CONNECTED',
                        controlMsgInfo: {
                            connectionInfo: connectionInfo
                        }
                    }
                });
                return [
                    2 /*return*/ ,
                    result
                ];
            });
        });
    };
    SubscriptionHandshakeLink.prototype.connectNewClient = function(connectionInfo, observer, selectionNames) {
        return $74a8a792cabd7b79$var$__awaiter(this, void 0, void 0, function() {
            var clientId, url, topics, client;
            var _this = this;
            return $74a8a792cabd7b79$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        clientId = connectionInfo.client, url = connectionInfo.url, topics = connectionInfo.topics;
                        client = new $291e12ce1a4c3c7e$exports.Client(url, clientId);
                        client.trace = $74a8a792cabd7b79$var$mqttLogger.bind(null, clientId);
                        client.onConnectionLost = function(_a) {
                            var errorCode = _a.errorCode, args = $74a8a792cabd7b79$var$__rest(_a, [
                                "errorCode"
                            ]);
                            if (errorCode !== 0) topics.forEach(function(t) {
                                if (_this.topicObservers.has(t)) _this.topicObservers.get(t).forEach(function(observer) {
                                    return observer.error($74a8a792cabd7b79$var$__assign($74a8a792cabd7b79$var$__assign({}, args), {
                                        permanent: true
                                    }));
                                });
                            });
                            topics.forEach(function(t) {
                                return _this.topicObservers.delete(t);
                            });
                        };
                        client.onMessageArrived = function(_a) {
                            var destinationName = _a.destinationName, payloadString = _a.payloadString;
                            return _this.onMessage(destinationName, payloadString, selectionNames);
                        };
                        return [
                            4 /*yield*/ ,
                            new Promise(function(resolve, reject) {
                                client.connect({
                                    useSSL: url.indexOf('wss://') === 0,
                                    mqttVersion: 3,
                                    onSuccess: function() {
                                        return resolve(client);
                                    },
                                    onFailure: reject
                                });
                            })
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.subscribeToTopics(client, topics, observer)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            client
                        ];
                }
            });
        });
    };
    SubscriptionHandshakeLink.prototype.subscribeToTopics = function(client, topics, observer) {
        var _this = this;
        return Promise.all(topics.map(function(topic) {
            return _this.subscribeToTopic(client, topic, observer);
        }));
    };
    SubscriptionHandshakeLink.prototype.subscribeToTopic = function(client, topic, observer) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            client.subscribe(topic, {
                onSuccess: function() {
                    if (!_this.topicObservers.has(topic)) _this.topicObservers.set(topic, new Set());
                    if (!_this.clientObservers.has(client.clientId)) _this.clientObservers.set(client.clientId, {
                        client: client,
                        observers: new Set()
                    });
                    _this.topicObservers.get(topic).add(observer);
                    _this.clientObservers.get(client.clientId).observers.add(observer);
                    resolve(topic);
                },
                onFailure: reject
            });
        });
    };
    return SubscriptionHandshakeLink;
}($8MgJN.ApolloLink);
$74a8a792cabd7b79$exports.SubscriptionHandshakeLink = $74a8a792cabd7b79$var$SubscriptionHandshakeLink;


$f102cb105c81b828$exports.CONTROL_EVENTS_KEY = $74a8a792cabd7b79$exports.CONTROL_EVENTS_KEY;
parcelRequire("aJi19");
var $8MgJN = parcelRequire("8MgJN");
var $9uTW6 = parcelRequire("9uTW6");
parcelRequire("2EHH1");
var $epBGJ = parcelRequire("epBGJ");
parcelRequire("jDiDD");
var $8gQB0 = parcelRequire("8gQB0");
var $37b13168f056e3b4$exports = {};
"use strict";
var $37b13168f056e3b4$var$__extends = $37b13168f056e3b4$exports && $37b13168f056e3b4$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $37b13168f056e3b4$var$__assign = $37b13168f056e3b4$exports && $37b13168f056e3b4$exports.__assign || function() {
    $37b13168f056e3b4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $37b13168f056e3b4$var$__assign.apply(this, arguments);
};
var $37b13168f056e3b4$var$__awaiter = $37b13168f056e3b4$exports && $37b13168f056e3b4$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $37b13168f056e3b4$var$__generator = $37b13168f056e3b4$exports && $37b13168f056e3b4$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($37b13168f056e3b4$exports, "__esModule", {
    value: true
});
parcelRequire("aJi19");
var $8MgJN = parcelRequire("8MgJN");

var $fH1jI = parcelRequire("fH1jI");
parcelRequire("kYdsw");
var $8MgJN = parcelRequire("8MgJN");
parcelRequire("jDiDD");
var $9uTW6 = parcelRequire("9uTW6");
function $6212838813df44e7$export$2f04de43fe27971a(setter) {
    return new (0, $8MgJN.ApolloLink)(function(operation, forward) {
        var request = (0, $fH1jI.__rest)(operation, []);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($9uTW6)))(function(observer) {
            var handle;
            Promise.resolve(request).then(function(req) {
                return setter(req, operation.getContext());
            }).then(operation.setContext).then(function() {
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            }).catch(observer.error.bind(observer));
            return function() {
                if (handle) handle.unsubscribe();
            };
        });
    });
}


var $37b13168f056e3b4$var$NonTerminatingLink = /** @class */ function(_super) {
    $37b13168f056e3b4$var$__extends(NonTerminatingLink, _super);
    function NonTerminatingLink(contextKey, _a) {
        var link = _a.link;
        var _this = _super.call(this) || this;
        _this.contextKey = contextKey;
        _this.link = link;
        return _this;
    }
    NonTerminatingLink.prototype.request = function(operation, forward) {
        var _this = this;
        return $6212838813df44e7$export$2f04de43fe27971a(function(_request, prevContext) {
            return $37b13168f056e3b4$var$__awaiter(_this, void 0, void 0, function() {
                var result;
                var _a;
                var _this = this;
                return $37b13168f056e3b4$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    _this.link.request(operation).subscribe({
                                        next: resolve,
                                        error: reject
                                    });
                                })
                            ];
                        case 1:
                            result = _b.sent();
                            return [
                                2 /*return*/ ,
                                $37b13168f056e3b4$var$__assign($37b13168f056e3b4$var$__assign({}, prevContext), (_a = {}, _a[this.contextKey] = result, _a))
                            ];
                    }
                });
            });
        }).request(operation, forward);
    };
    return NonTerminatingLink;
}($8MgJN.ApolloLink);
$37b13168f056e3b4$exports.NonTerminatingLink = $37b13168f056e3b4$var$NonTerminatingLink;


var $7791a9227f8587f3$exports = {};

var $81U8s = parcelRequire("81U8s");
var $7791a9227f8587f3$require$Buffer = $81U8s.Buffer;
"use strict";
var $7791a9227f8587f3$var$__extends = $7791a9227f8587f3$exports && $7791a9227f8587f3$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7791a9227f8587f3$var$__assign = $7791a9227f8587f3$exports && $7791a9227f8587f3$exports.__assign || function() {
    $7791a9227f8587f3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7791a9227f8587f3$var$__assign.apply(this, arguments);
};
var $7791a9227f8587f3$var$__awaiter = $7791a9227f8587f3$exports && $7791a9227f8587f3$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7791a9227f8587f3$var$__generator = $7791a9227f8587f3$exports && $7791a9227f8587f3$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($7791a9227f8587f3$exports, "__esModule", {
    value: true
});
parcelRequire("aJi19");
var $8MgJN = parcelRequire("8MgJN");
var $9uTW6 = parcelRequire("9uTW6");

var $336febb40790ed57$exports = {};
"use strict";
Object.defineProperty($336febb40790ed57$exports, "__esModule", {
    value: true
});
$336febb40790ed57$exports.Signer = $336febb40790ed57$exports.USER_AGENT = $336febb40790ed57$exports.USER_AGENT_HEADER = $336febb40790ed57$exports.AUTH_TYPE = $336febb40790ed57$exports.AuthLink = $336febb40790ed57$exports.createAuthLink = void 0;
var $d12e506f899a9609$exports = {};
"use strict";
var $d12e506f899a9609$var$__extends = $d12e506f899a9609$exports && $d12e506f899a9609$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d12e506f899a9609$var$__assign = $d12e506f899a9609$exports && $d12e506f899a9609$exports.__assign || function() {
    $d12e506f899a9609$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d12e506f899a9609$var$__assign.apply(this, arguments);
};
var $d12e506f899a9609$var$__awaiter = $d12e506f899a9609$exports && $d12e506f899a9609$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d12e506f899a9609$var$__generator = $d12e506f899a9609$exports && $d12e506f899a9609$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($d12e506f899a9609$exports, "__esModule", {
    value: true
});
$d12e506f899a9609$exports.authLink = $d12e506f899a9609$exports.AuthLink = $d12e506f899a9609$exports.AUTH_TYPE = $d12e506f899a9609$exports.USER_AGENT = $d12e506f899a9609$exports.USER_AGENT_HEADER = void 0;
parcelRequire("aJi19");
var $8MgJN = parcelRequire("8MgJN");
var $9uTW6 = parcelRequire("9uTW6");

var $6am30 = parcelRequire("6am30");
var $af29d5188071d034$exports = {};
"use strict";
var $af29d5188071d034$var$__createBinding = $af29d5188071d034$exports && $af29d5188071d034$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $af29d5188071d034$var$__exportStar = $af29d5188071d034$exports && $af29d5188071d034$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $af29d5188071d034$var$__createBinding(exports1, m, p);
};
Object.defineProperty($af29d5188071d034$exports, "__esModule", {
    value: true
});

/*!
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ $af29d5188071d034$var$__exportStar((parcelRequire("2fyRj")), $af29d5188071d034$exports);



var $2qlBa = parcelRequire("2qlBa");
var $4cac1f0475392c75$exports = {};
"use strict";
Object.defineProperty($4cac1f0475392c75$exports, "__esModule", {
    value: true
});
$4cac1f0475392c75$exports.userAgent = void 0;
var $4cac1f0475392c75$var$userAgent = '';
$4cac1f0475392c75$exports.userAgent = $4cac1f0475392c75$var$userAgent;


var $de25510dc633551c$exports = {};
$de25510dc633551c$exports = JSON.parse("{\"name\":\"aws-appsync-auth-link\",\"version\":\"3.0.8\",\"main\":\"lib/index.js\",\"files\":[\"lib\"],\"license\":\"Apache-2.0\",\"description\":\"AWS Mobile AppSync Auth Link for JavaScript\",\"author\":{\"name\":\"Amazon Web Services\",\"url\":\"https://aws.amazon.com/\"},\"homepage\":\"https://github.com/awslabs/aws-mobile-appsync-sdk-js.git\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/awslabs/aws-mobile-appsync-sdk-js.git\"},\"scripts\":{\"clean\":\"rm -rf lib\",\"prepare\":\"tsc\",\"test\":\"jest --coverage --coverageReporters=text --passWithNoTests\",\"test-watch\":\"jest --watch\"},\"dependencies\":{\"@aws-crypto/sha256-js\":\"^1.2.0\",\"@aws-sdk/types\":\"^3.25.0\",\"@aws-sdk/util-hex-encoding\":\"^3.29.0\",\"debug\":\"2.6.9\"},\"devDependencies\":{\"@apollo/client\":\"^3.2.0\"},\"peerDependencies\":{\"@apollo/client\":\"3.x\"}}");


var $d12e506f899a9609$var$SERVICE = 'appsync';
$d12e506f899a9609$exports.USER_AGENT_HEADER = 'x-amz-user-agent';
$d12e506f899a9609$exports.USER_AGENT = "aws-amplify/".concat($de25510dc633551c$exports.version).concat($4cac1f0475392c75$exports.userAgent && ' ').concat($4cac1f0475392c75$exports.userAgent);
var $d12e506f899a9609$var$AUTH_TYPE;
(function(AUTH_TYPE) {
    AUTH_TYPE["NONE"] = "NONE";
    AUTH_TYPE["API_KEY"] = "API_KEY";
    AUTH_TYPE["AWS_IAM"] = "AWS_IAM";
    AUTH_TYPE["AMAZON_COGNITO_USER_POOLS"] = "AMAZON_COGNITO_USER_POOLS";
    AUTH_TYPE["OPENID_CONNECT"] = "OPENID_CONNECT";
    AUTH_TYPE["AWS_LAMBDA"] = "AWS_LAMBDA";
})($d12e506f899a9609$var$AUTH_TYPE = $d12e506f899a9609$exports.AUTH_TYPE || ($d12e506f899a9609$exports.AUTH_TYPE = {}));
var $d12e506f899a9609$var$AuthLink = /** @class */ function(_super) {
    $d12e506f899a9609$var$__extends(AuthLink, _super);
    /**
     *
     * @param {*} options
     */ function AuthLink(options) {
        var _this = _super.call(this) || this;
        _this.link = (0, $d12e506f899a9609$exports.authLink)(options);
        return _this;
    }
    AuthLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return AuthLink;
}($8MgJN.ApolloLink);
$d12e506f899a9609$exports.AuthLink = $d12e506f899a9609$var$AuthLink;
var $d12e506f899a9609$var$headerBasedAuth = function(_a, operation, forward) {
    var _b = _a === void 0 ? {
        header: '',
        value: ''
    } : _a, header = _b.header, value = _b.value;
    return $d12e506f899a9609$var$__awaiter(void 0, void 0, void 0, function() {
        var origContext, headers, headerValue, _c;
        var _d, _e;
        return $d12e506f899a9609$var$__generator(this, function(_f) {
            switch(_f.label){
                case 0:
                    origContext = operation.getContext();
                    headers = $d12e506f899a9609$var$__assign($d12e506f899a9609$var$__assign({}, origContext.headers), (_d = {}, _d[$d12e506f899a9609$exports.USER_AGENT_HEADER] = $d12e506f899a9609$exports.USER_AGENT, _d));
                    if (!(header && value)) return [
                        3 /*break*/ ,
                        5
                    ];
                    if (!(typeof value === 'function')) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        value.call(undefined)
                    ];
                case 1:
                    _c = _f.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    return [
                        4 /*yield*/ ,
                        value
                    ];
                case 3:
                    _c = _f.sent();
                    _f.label = 4;
                case 4:
                    headerValue = _c;
                    headers = $d12e506f899a9609$var$__assign((_e = {}, _e[header] = headerValue, _e), headers);
                    _f.label = 5;
                case 5:
                    operation.setContext($d12e506f899a9609$var$__assign($d12e506f899a9609$var$__assign({}, origContext), {
                        headers: headers
                    }));
                    return [
                        2 /*return*/ ,
                        forward(operation)
                    ];
            }
        });
    });
};
var $d12e506f899a9609$var$iamBasedAuth = function(_a, operation, forward) {
    var credentials = _a.credentials, region = _a.region, url = _a.url;
    return $d12e506f899a9609$var$__awaiter(void 0, void 0, void 0, function() {
        var service, origContext, creds, _b, accessKeyId, secretAccessKey, sessionToken, _c, host, path, formatted, headers;
        var _d;
        return $d12e506f899a9609$var$__generator(this, function(_e) {
            switch(_e.label){
                case 0:
                    service = $d12e506f899a9609$var$SERVICE;
                    origContext = operation.getContext();
                    creds = typeof credentials === 'function' ? credentials.call() : credentials || {};
                    if (!(creds && typeof creds.getPromise === 'function')) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        creds.getPromise()
                    ];
                case 1:
                    _e.sent();
                    _e.label = 2;
                case 2:
                    return [
                        4 /*yield*/ ,
                        creds
                    ];
                case 3:
                    _b = _e.sent(), accessKeyId = _b.accessKeyId, secretAccessKey = _b.secretAccessKey, sessionToken = _b.sessionToken;
                    _c = $2qlBa.parse(url), host = _c.host, path = _c.path;
                    formatted = $d12e506f899a9609$var$__assign($d12e506f899a9609$var$__assign({}, $d12e506f899a9609$var$formatAsRequest(operation, {})), {
                        service: service,
                        region: region,
                        url: url,
                        host: host,
                        path: path
                    });
                    headers = $af29d5188071d034$exports.Signer.sign(formatted, {
                        access_key: accessKeyId,
                        secret_key: secretAccessKey,
                        session_token: sessionToken
                    }).headers;
                    operation.setContext($d12e506f899a9609$var$__assign($d12e506f899a9609$var$__assign({}, origContext), {
                        headers: $d12e506f899a9609$var$__assign($d12e506f899a9609$var$__assign($d12e506f899a9609$var$__assign({}, origContext.headers), headers), (_d = {}, _d[$d12e506f899a9609$exports.USER_AGENT_HEADER] = $d12e506f899a9609$exports.USER_AGENT, _d))
                    }));
                    return [
                        2 /*return*/ ,
                        forward(operation)
                    ];
            }
        });
    });
};
var $d12e506f899a9609$var$authLink = function(_a) {
    var url = _a.url, region = _a.region, _b = _a.auth, _c = _b === void 0 ? {} : _b, type = _c.type, auth = _a.auth;
    return new $8MgJN.ApolloLink(function(operation, forward) {
        return new $9uTW6.default(function(observer) {
            var handle;
            var promise;
            switch(type){
                case $d12e506f899a9609$var$AUTH_TYPE.NONE:
                    promise = $d12e506f899a9609$var$headerBasedAuth(undefined, operation, forward);
                    break;
                case $d12e506f899a9609$var$AUTH_TYPE.AWS_IAM:
                    var _a = auth.credentials, credentials = _a === void 0 ? {} : _a;
                    promise = $d12e506f899a9609$var$iamBasedAuth({
                        credentials: credentials,
                        region: region,
                        url: url
                    }, operation, forward);
                    break;
                case $d12e506f899a9609$var$AUTH_TYPE.API_KEY:
                    var _b = auth.apiKey, apiKey = _b === void 0 ? '' : _b;
                    promise = $d12e506f899a9609$var$headerBasedAuth({
                        header: 'X-Api-Key',
                        value: apiKey
                    }, operation, forward);
                    break;
                case $d12e506f899a9609$var$AUTH_TYPE.AMAZON_COGNITO_USER_POOLS:
                case $d12e506f899a9609$var$AUTH_TYPE.OPENID_CONNECT:
                    var _c = auth.jwtToken, jwtToken = _c === void 0 ? '' : _c;
                    promise = $d12e506f899a9609$var$headerBasedAuth({
                        header: 'Authorization',
                        value: jwtToken
                    }, operation, forward);
                    break;
                case $d12e506f899a9609$var$AUTH_TYPE.AWS_LAMBDA:
                    var _d = auth.token, token = _d === void 0 ? '' : _d;
                    promise = $d12e506f899a9609$var$headerBasedAuth({
                        header: 'Authorization',
                        value: token
                    }, operation, forward);
                    break;
                default:
                    var error = new Error("Invalid AUTH_TYPE: ".concat(auth.type));
                    throw error;
            }
            promise.then(function(observable) {
                handle = observable.subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            });
            return function() {
                if (handle) handle.unsubscribe();
            };
        });
    });
};
$d12e506f899a9609$exports.authLink = $d12e506f899a9609$var$authLink;
var $d12e506f899a9609$var$formatAsRequest = function(_a, options) {
    var operationName = _a.operationName, variables = _a.variables, query = _a.query;
    var body = {
        operationName: operationName,
        variables: $d12e506f899a9609$var$removeTemporaryVariables(variables),
        query: (0, $6am30.print)(query)
    };
    return $d12e506f899a9609$var$__assign($d12e506f899a9609$var$__assign({
        body: JSON.stringify(body),
        method: 'POST'
    }, options), {
        headers: $d12e506f899a9609$var$__assign({
            accept: '*/*',
            'content-type': 'application/json; charset=UTF-8'
        }, options.headers)
    });
};
/**
 * Removes all temporary variables (starting with '@@') so that the signature matches the final request.
 */ var $d12e506f899a9609$var$removeTemporaryVariables = function(variables) {
    return Object.keys(variables).filter(function(key) {
        return !key.startsWith("@@");
    }).reduce(function(acc, key) {
        acc[key] = variables[key];
        return acc;
    }, {});
};


Object.defineProperty($336febb40790ed57$exports, "AuthLink", {
    enumerable: true,
    get: function() {
        return $d12e506f899a9609$exports.AuthLink;
    }
});
Object.defineProperty($336febb40790ed57$exports, "AUTH_TYPE", {
    enumerable: true,
    get: function() {
        return $d12e506f899a9609$exports.AUTH_TYPE;
    }
});
Object.defineProperty($336febb40790ed57$exports, "USER_AGENT_HEADER", {
    enumerable: true,
    get: function() {
        return $d12e506f899a9609$exports.USER_AGENT_HEADER;
    }
});
Object.defineProperty($336febb40790ed57$exports, "USER_AGENT", {
    enumerable: true,
    get: function() {
        return $d12e506f899a9609$exports.USER_AGENT;
    }
});
var $336febb40790ed57$var$createAuthLink = function(_a) {
    var url = _a.url, region = _a.region, auth = _a.auth;
    return new $d12e506f899a9609$exports.AuthLink({
        url: url,
        region: region,
        auth: auth
    });
};
$336febb40790ed57$exports.createAuthLink = $336febb40790ed57$var$createAuthLink;

Object.defineProperty($336febb40790ed57$exports, "Signer", {
    enumerable: true,
    get: function() {
        return $af29d5188071d034$exports.Signer;
    }
});



var $1wSRS = parcelRequire("1wSRS");
var $ivpV0 = parcelRequire("ivpV0");

var $2qlBa = parcelRequire("2qlBa");

var $bIL5B = parcelRequire("bIL5B");
var $6c889d22fb2117d9$exports = {};
"use strict";
Object.defineProperty($6c889d22fb2117d9$exports, "__esModule", {
    value: true
});
//#region Subscription link enums
var $6c889d22fb2117d9$var$SUBSCRIPTION_STATUS;
(function(SUBSCRIPTION_STATUS) {
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["PENDING"] = 0] = "PENDING";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["CONNECTED"] = 1] = "CONNECTED";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["FAILED"] = 2] = "FAILED";
})($6c889d22fb2117d9$var$SUBSCRIPTION_STATUS = $6c889d22fb2117d9$exports.SUBSCRIPTION_STATUS || ($6c889d22fb2117d9$exports.SUBSCRIPTION_STATUS = {}));
var $6c889d22fb2117d9$var$SOCKET_STATUS;
(function(SOCKET_STATUS) {
    SOCKET_STATUS[SOCKET_STATUS["CLOSED"] = 0] = "CLOSED";
    SOCKET_STATUS[SOCKET_STATUS["READY"] = 1] = "READY";
    SOCKET_STATUS[SOCKET_STATUS["CONNECTING"] = 2] = "CONNECTING";
})($6c889d22fb2117d9$var$SOCKET_STATUS = $6c889d22fb2117d9$exports.SOCKET_STATUS || ($6c889d22fb2117d9$exports.SOCKET_STATUS = {}));
var $6c889d22fb2117d9$var$MESSAGE_TYPES;
(function(MESSAGE_TYPES) {
    /**
     * Client -> Server message.
     * This message type is the first message after handshake and this will initialize AWS AppSync RealTime communication
     */ MESSAGE_TYPES["GQL_CONNECTION_INIT"] = "connection_init";
    /**
     * Server -> Client message
     * This message type is in case there is an issue with AWS AppSync RealTime when establishing connection
     */ MESSAGE_TYPES["GQL_CONNECTION_ERROR"] = "connection_error";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_CONNECTION_INIT message
     */ MESSAGE_TYPES["GQL_CONNECTION_ACK"] = "connection_ack";
    /**
     * Client -> Server message.
     * This message type is for register subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_START"] = "start";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_START message
     */ MESSAGE_TYPES["GQL_START_ACK"] = "start_ack";
    /**
     * Server -> Client message.
     * This message type is for subscription message from AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_DATA"] = "data";
    /**
     * Server -> Client message.
     * This message type helps the client to know is still receiving messages from AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_CONNECTION_KEEP_ALIVE"] = "ka";
    /**
     * Client -> Server message.
     * This message type is for unregister subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_STOP"] = "stop";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_STOP message
     */ MESSAGE_TYPES["GQL_COMPLETE"] = "complete";
    /**
     * Server -> Client message.
     * This message type is for sending error messages from AWS AppSync RealTime to the client
     */ MESSAGE_TYPES["GQL_ERROR"] = "error"; // Server -> Client
})($6c889d22fb2117d9$var$MESSAGE_TYPES = $6c889d22fb2117d9$exports.MESSAGE_TYPES || ($6c889d22fb2117d9$exports.MESSAGE_TYPES = {}));
var $6c889d22fb2117d9$var$CONTROL_MSG;
(function(CONTROL_MSG) {
    CONTROL_MSG["CONNECTION_CLOSED"] = "Connection closed";
    CONTROL_MSG["TIMEOUT_DISCONNECT"] = "Timeout disconnect";
    CONTROL_MSG["SUBSCRIPTION_ACK"] = "Subscription ack";
})($6c889d22fb2117d9$var$CONTROL_MSG = $6c889d22fb2117d9$exports.CONTROL_MSG || ($6c889d22fb2117d9$exports.CONTROL_MSG = {})); //#endregion


var $eceb913e12f12f7a$exports = {};
"use strict";
var $eceb913e12f12f7a$var$__extends = $eceb913e12f12f7a$exports && $eceb913e12f12f7a$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $eceb913e12f12f7a$var$__awaiter = $eceb913e12f12f7a$exports && $eceb913e12f12f7a$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $eceb913e12f12f7a$var$__generator = $eceb913e12f12f7a$exports && $eceb913e12f12f7a$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($eceb913e12f12f7a$exports, "__esModule", {
    value: true
});

var $eceb913e12f12f7a$var$logger = $79811f83b909f6d2$exports.rootLogger.extend("retry");
var $eceb913e12f12f7a$var$MAX_DELAY_MS = 5000;
/**
 * Internal use of Subscription link
 * @private
 */ var $eceb913e12f12f7a$var$NonRetryableError = /** @class */ function(_super) {
    $eceb913e12f12f7a$var$__extends(NonRetryableError, _super);
    function NonRetryableError(message) {
        var _this = _super.call(this, message) || this;
        _this.nonRetryable = true;
        return _this;
    }
    return NonRetryableError;
}(Error);
$eceb913e12f12f7a$exports.NonRetryableError = $eceb913e12f12f7a$var$NonRetryableError;
var $eceb913e12f12f7a$var$isNonRetryableError = function(obj) {
    var key = "nonRetryable";
    return obj && obj[key];
};
/**
 * @private
 * Internal use of Subscription link
 */ function $eceb913e12f12f7a$var$retry(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) attempt = 1;
    return $eceb913e12f12f7a$var$__awaiter(this, void 0, void 0, function() {
        var err_1, retryIn_1;
        return $eceb913e12f12f7a$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    $eceb913e12f12f7a$var$logger("Attempt #" + attempt + " for this vars: " + JSON.stringify(args));
                    _a.label = 1;
                case 1:
                    _a.trys.push([
                        1,
                        3,
                        ,
                        8
                    ]);
                    return [
                        4 /*yield*/ ,
                        functionToRetry.apply(undefined, args)
                    ];
                case 2:
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 3:
                    err_1 = _a.sent();
                    $eceb913e12f12f7a$var$logger("error " + err_1);
                    if ($eceb913e12f12f7a$var$isNonRetryableError(err_1)) {
                        $eceb913e12f12f7a$var$logger("non retryable error");
                        throw err_1;
                    }
                    retryIn_1 = delayFn(attempt, args, err_1);
                    $eceb913e12f12f7a$var$logger("retryIn ", retryIn_1);
                    if (!(retryIn_1 !== false)) return [
                        3 /*break*/ ,
                        6
                    ];
                    return [
                        4 /*yield*/ ,
                        new Promise(function(res) {
                            return setTimeout(res, retryIn_1);
                        })
                    ];
                case 4:
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        $eceb913e12f12f7a$var$retry(functionToRetry, args, delayFn, attempt + 1)
                    ];
                case 5:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
                case 6:
                    throw err_1;
                case 7:
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 8:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
$eceb913e12f12f7a$exports.retry = $eceb913e12f12f7a$var$retry;
function $eceb913e12f12f7a$var$jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
/**
 * @private
 * Internal use of Subscription link
 */ $eceb913e12f12f7a$exports.jitteredExponentialRetry = function(functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $eceb913e12f12f7a$var$MAX_DELAY_MS;
    return $eceb913e12f12f7a$var$retry(functionToRetry, args, $eceb913e12f12f7a$var$jitteredBackoff(maxDelayMs));
};


var $7791a9227f8587f3$var$logger = $79811f83b909f6d2$exports.rootLogger.extend("subscriptions");
$7791a9227f8587f3$exports.CONTROL_EVENTS_KEY = "@@controlEvents";
var $7791a9227f8587f3$var$NON_RETRYABLE_CODES = [
    400,
    401,
    403
];
var $7791a9227f8587f3$var$SERVICE = "appsync";
var $7791a9227f8587f3$var$APPSYNC_REALTIME_HEADERS = {
    accept: 'application/json, text/javascript',
    'content-encoding': 'amz-1.0',
    'content-type': 'application/json; charset=UTF-8'
};
/**
 * Time in milliseconds to wait for GQL_CONNECTION_INIT message
 */ var $7791a9227f8587f3$var$CONNECTION_INIT_TIMEOUT = 15000;
/**
 * Time in milliseconds to wait for GQL_START_ACK message
 */ var $7791a9227f8587f3$var$START_ACK_TIMEOUT = 15000;
/**
 * Frequency in milliseconds in which the server sends GQL_CONNECTION_KEEP_ALIVE messages
 */ var $7791a9227f8587f3$var$SERVER_KEEP_ALIVE_TIMEOUT = 60000;
/**
 * Default Time in milliseconds to wait for GQL_CONNECTION_KEEP_ALIVE message
 */ var $7791a9227f8587f3$var$DEFAULT_KEEP_ALIVE_TIMEOUT = 300000;
var $7791a9227f8587f3$var$standardDomainPattern = /^https:\/\/\w{26}\.appsync\-api\.\w{2}(?:(?:\-\w{2,})+)\-\d\.amazonaws.com\/graphql$/i;
var $7791a9227f8587f3$var$customDomainPath = '/realtime';
var $7791a9227f8587f3$var$AppSyncRealTimeSubscriptionHandshakeLink = /** @class */ function(_super) {
    $7791a9227f8587f3$var$__extends(AppSyncRealTimeSubscriptionHandshakeLink, _super);
    function AppSyncRealTimeSubscriptionHandshakeLink(_a) {
        var theUrl = _a.url, theRegion = _a.region, theAuth = _a.auth, keepAliveTimeoutMs = _a.keepAliveTimeoutMs;
        var _this = _super.call(this) || this;
        _this.socketStatus = $6c889d22fb2117d9$exports.SOCKET_STATUS.CLOSED;
        _this.keepAliveTimeout = undefined;
        _this.subscriptionObserverMap = new Map();
        _this.promiseArray = [];
        _this.url = theUrl;
        _this.region = theRegion;
        _this.auth = theAuth;
        _this.keepAliveTimeout = keepAliveTimeoutMs;
        if (_this.keepAliveTimeout < $7791a9227f8587f3$var$SERVER_KEEP_ALIVE_TIMEOUT) {
            var configName = 'keepAliveTimeoutMs';
            throw new Error(configName + " must be greater than or equal to " + $7791a9227f8587f3$var$SERVER_KEEP_ALIVE_TIMEOUT + " (" + _this.keepAliveTimeout + " used).");
        }
        return _this;
    }
    // Check if url matches standard domain pattern
    AppSyncRealTimeSubscriptionHandshakeLink.prototype.isCustomDomain = function(url) {
        return url.match($7791a9227f8587f3$var$standardDomainPattern) === null;
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype.request = function(operation) {
        var _a;
        var _this = this;
        var query = operation.query, variables = operation.variables;
        var _b = operation.getContext(), _c = _b.controlMessages, _d = $7791a9227f8587f3$exports.CONTROL_EVENTS_KEY, controlEvents = (_c === void 0 ? (_a = {}, _a[$7791a9227f8587f3$exports.CONTROL_EVENTS_KEY] = undefined, _a) : _c)[_d], headers = _b.headers;
        return new $9uTW6.default(function(observer) {
            if (!_this.url) {
                observer.error({
                    errors: [
                        $7791a9227f8587f3$var$__assign({}, new $1wSRS.GraphQLError("Subscribe only available for AWS AppSync endpoint"))
                    ]
                });
                observer.complete();
            } else {
                var subscriptionId_1 = $bIL5B.default();
                var token = _this.auth.type === $336febb40790ed57$exports.AUTH_TYPE.AMAZON_COGNITO_USER_POOLS || _this.auth.type === $336febb40790ed57$exports.AUTH_TYPE.OPENID_CONNECT ? _this.auth.jwtToken : null;
                token = _this.auth.type === $336febb40790ed57$exports.AUTH_TYPE.AWS_LAMBDA ? _this.auth.token : token;
                var options = {
                    appSyncGraphqlEndpoint: _this.url,
                    authenticationType: _this.auth.type,
                    query: $ivpV0.print(query),
                    region: _this.region,
                    graphql_headers: function() {
                        return headers;
                    },
                    variables: variables,
                    apiKey: _this.auth.type === $336febb40790ed57$exports.AUTH_TYPE.API_KEY ? _this.auth.apiKey : "",
                    credentials: _this.auth.type === $336febb40790ed57$exports.AUTH_TYPE.AWS_IAM ? _this.auth.credentials : null,
                    token: token
                };
                _this._startSubscriptionWithAWSAppSyncRealTime({
                    options: options,
                    observer: observer,
                    subscriptionId: subscriptionId_1
                });
                return function() {
                    return $7791a9227f8587f3$var$__awaiter(_this, void 0, void 0, function() {
                        var subscriptionState;
                        return $7791a9227f8587f3$var$__generator(this, function(_a) {
                            // Cleanup after unsubscribing or observer.complete was called after _startSubscriptionWithAWSAppSyncRealTime
                            try {
                                this._verifySubscriptionAlreadyStarted(subscriptionId_1);
                                subscriptionState = this.subscriptionObserverMap.get(subscriptionId_1).subscriptionState;
                                if (subscriptionState === $6c889d22fb2117d9$exports.SUBSCRIPTION_STATUS.CONNECTED) this._sendUnsubscriptionMessage(subscriptionId_1);
                                else throw new Error("Subscription has failed, starting to remove subscription.");
                            } catch (err) {
                                this._removeSubscriptionObserver(subscriptionId_1);
                                return [
                                    2 /*return*/ 
                                ];
                            }
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                };
            }
        }).filter(function(data) {
            var _a = data.extensions, _b = (_a === void 0 ? {} : _a).controlMsgType, controlMsgType = _b === void 0 ? undefined : _b;
            var isControlMsg = typeof controlMsgType !== "undefined";
            return controlEvents === true || !isControlMsg;
        });
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._verifySubscriptionAlreadyStarted = function(subscriptionId) {
        return $7791a9227f8587f3$var$__awaiter(this, void 0, void 0, function() {
            var subscriptionState;
            var _this = this;
            return $7791a9227f8587f3$var$__generator(this, function(_a) {
                subscriptionState = this.subscriptionObserverMap.get(subscriptionId).subscriptionState;
                // This in case unsubscribe is invoked before sending start subscription message
                if (subscriptionState === $6c889d22fb2117d9$exports.SUBSCRIPTION_STATUS.PENDING) return [
                    2 /*return*/ ,
                    new Promise(function(res, rej) {
                        var _a = _this.subscriptionObserverMap.get(subscriptionId), observer = _a.observer, subscriptionState = _a.subscriptionState, variables = _a.variables, query = _a.query;
                        _this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            subscriptionState: subscriptionState,
                            variables: variables,
                            query: query,
                            subscriptionReadyCallback: res,
                            subscriptionFailedCallback: rej
                        });
                    })
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._sendUnsubscriptionMessage = function(subscriptionId) {
        try {
            if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN && this.socketStatus === $6c889d22fb2117d9$exports.SOCKET_STATUS.READY) {
                // Preparing unsubscribe message to stop receiving messages for that subscription
                var unsubscribeMessage = {
                    id: subscriptionId,
                    type: $6c889d22fb2117d9$exports.MESSAGE_TYPES.GQL_STOP
                };
                var stringToAWSRealTime = JSON.stringify(unsubscribeMessage);
                this.awsRealTimeSocket.send(stringToAWSRealTime);
                this._removeSubscriptionObserver(subscriptionId);
            }
        } catch (err) {
            // If GQL_STOP is not sent because of disconnection issue, then there is nothing the client can do
            $7791a9227f8587f3$var$logger({
                err: err
            });
        }
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._removeSubscriptionObserver = function(subscriptionId) {
        this.subscriptionObserverMap.delete(subscriptionId);
        // Verifying for 1000ms after removing subscription in case there are new subscriptions on mount / unmount
        setTimeout(this._closeSocketIfRequired.bind(this), 1000);
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._closeSocketIfRequired = function() {
        if (this.subscriptionObserverMap.size > 0) // There are active subscriptions on the WebSocket
        return;
        if (!this.awsRealTimeSocket) {
            this.socketStatus = $6c889d22fb2117d9$exports.SOCKET_STATUS.CLOSED;
            return;
        }
        if (this.awsRealTimeSocket.bufferedAmount > 0) // There is still data on the WebSocket
        setTimeout(this._closeSocketIfRequired.bind(this), 1000);
        else {
            $7791a9227f8587f3$var$logger("closing WebSocket...");
            clearTimeout(this.keepAliveTimeoutId);
            var tempSocket = this.awsRealTimeSocket;
            tempSocket.close(1000);
            this.awsRealTimeSocket = null;
            this.socketStatus = $6c889d22fb2117d9$exports.SOCKET_STATUS.CLOSED;
        }
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._startSubscriptionWithAWSAppSyncRealTime = function(_a) {
        var options = _a.options, observer = _a.observer, subscriptionId = _a.subscriptionId;
        return $7791a9227f8587f3$var$__awaiter(this, void 0, void 0, function() {
            var appSyncGraphqlEndpoint, authenticationType, query, variables, apiKey, region, _b, graphql_headers, credentials, token, subscriptionState, data, dataString, headerObj, _c, subscriptionMessage, stringToAWSRealTime, err_1, _d, message, subscriptionFailedCallback_1, _e, subscriptionFailedCallback, subscriptionReadyCallback;
            var _f;
            var _this = this;
            return $7791a9227f8587f3$var$__generator(this, function(_g) {
                switch(_g.label){
                    case 0:
                        appSyncGraphqlEndpoint = options.appSyncGraphqlEndpoint, authenticationType = options.authenticationType, query = options.query, variables = options.variables, apiKey = options.apiKey, region = options.region, _b = options.graphql_headers, graphql_headers = _b === void 0 ? function() {
                            return {};
                        } : _b, credentials = options.credentials, token = options.token;
                        subscriptionState = $6c889d22fb2117d9$exports.SUBSCRIPTION_STATUS.PENDING;
                        data = {
                            query: query,
                            variables: variables
                        };
                        // Having a subscription id map will make it simple to forward messages received
                        this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            query: query,
                            variables: variables,
                            subscriptionState: subscriptionState,
                            startAckTimeoutId: null
                        });
                        dataString = JSON.stringify(data);
                        _c = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._awsRealTimeHeaderBasedAuth({
                                apiKey: apiKey,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                authenticationType: authenticationType,
                                payload: dataString,
                                canonicalUri: "",
                                region: region,
                                credentials: credentials,
                                token: token,
                                graphql_headers: graphql_headers
                            })
                        ];
                    case 1:
                        headerObj = $7791a9227f8587f3$var$__assign.apply(void 0, [
                            $7791a9227f8587f3$var$__assign.apply(void 0, _c.concat([
                                _g.sent()
                            ])),
                            (_f = {}, _f[$336febb40790ed57$exports.USER_AGENT_HEADER] = $336febb40790ed57$exports.USER_AGENT, _f)
                        ]);
                        subscriptionMessage = {
                            id: subscriptionId,
                            payload: {
                                data: dataString,
                                extensions: {
                                    authorization: $7791a9227f8587f3$var$__assign({}, headerObj)
                                }
                            },
                            type: $6c889d22fb2117d9$exports.MESSAGE_TYPES.GQL_START
                        };
                        stringToAWSRealTime = JSON.stringify(subscriptionMessage);
                        _g.label = 2;
                    case 2:
                        _g.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._initializeWebSocketConnection({
                                apiKey: apiKey,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                authenticationType: authenticationType,
                                region: region,
                                credentials: credentials,
                                token: token
                            })
                        ];
                    case 3:
                        _g.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        err_1 = _g.sent();
                        _d = err_1.message, message = _d === void 0 ? "" : _d;
                        observer.error({
                            errors: [
                                $7791a9227f8587f3$var$__assign({}, new $1wSRS.GraphQLError("Connection failed: " + message))
                            ]
                        });
                        observer.complete();
                        subscriptionFailedCallback_1 = (this.subscriptionObserverMap.get(subscriptionId) || {}).subscriptionFailedCallback;
                        // Notify concurrent unsubscription
                        if (typeof subscriptionFailedCallback_1 === "function") subscriptionFailedCallback_1();
                        return [
                            2 /*return*/ 
                        ];
                    case 5:
                        _e = this.subscriptionObserverMap.get(subscriptionId) || {}, subscriptionFailedCallback = _e.subscriptionFailedCallback, subscriptionReadyCallback = _e.subscriptionReadyCallback;
                        // This must be done before sending the message in order to be listening immediately
                        this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            subscriptionState: subscriptionState,
                            variables: variables,
                            query: query,
                            subscriptionReadyCallback: subscriptionReadyCallback,
                            subscriptionFailedCallback: subscriptionFailedCallback,
                            startAckTimeoutId: setTimeout(function() {
                                _this._timeoutStartSubscriptionAck.call(_this, subscriptionId);
                            }, $7791a9227f8587f3$var$START_ACK_TIMEOUT)
                        });
                        if (this.awsRealTimeSocket) this.awsRealTimeSocket.send(stringToAWSRealTime);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._initializeWebSocketConnection = function(_a) {
        var _this = this;
        var appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, authenticationType = _a.authenticationType, apiKey = _a.apiKey, region = _a.region, credentials = _a.credentials, token = _a.token;
        if (this.socketStatus === $6c889d22fb2117d9$exports.SOCKET_STATUS.READY) return;
        return new Promise(function(res, rej) {
            return $7791a9227f8587f3$var$__awaiter(_this, void 0, void 0, function() {
                var payloadString, headerString, _a, _b, headerQs, payloadQs, discoverableEndpoint, awsRealTimeUrl, err_2;
                return $7791a9227f8587f3$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.promiseArray.push({
                                res: res,
                                rej: rej
                            });
                            if (!(this.socketStatus === $6c889d22fb2117d9$exports.SOCKET_STATUS.CLOSED)) return [
                                3 /*break*/ ,
                                5
                            ];
                            _c.label = 1;
                        case 1:
                            _c.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            this.socketStatus = $6c889d22fb2117d9$exports.SOCKET_STATUS.CONNECTING;
                            payloadString = "{}";
                            _b = (_a = JSON).stringify;
                            return [
                                4 /*yield*/ ,
                                this._awsRealTimeHeaderBasedAuth({
                                    authenticationType: authenticationType,
                                    payload: payloadString,
                                    canonicalUri: "/connect",
                                    apiKey: apiKey,
                                    appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                    region: region,
                                    credentials: credentials,
                                    token: token,
                                    graphql_headers: function() {}
                                })
                            ];
                        case 2:
                            headerString = _b.apply(_a, [
                                _c.sent()
                            ]);
                            headerQs = $7791a9227f8587f3$require$Buffer.from(headerString).toString("base64");
                            payloadQs = $7791a9227f8587f3$require$Buffer.from(payloadString).toString("base64");
                            discoverableEndpoint = appSyncGraphqlEndpoint;
                            if (this.isCustomDomain(discoverableEndpoint)) discoverableEndpoint = discoverableEndpoint.concat($7791a9227f8587f3$var$customDomainPath);
                            else discoverableEndpoint = discoverableEndpoint.replace('appsync-api', 'appsync-realtime-api').replace('gogi-beta', 'grt-beta');
                            discoverableEndpoint = discoverableEndpoint.replace("https://", "wss://").replace('http://', 'ws://');
                            awsRealTimeUrl = discoverableEndpoint + "?header=" + headerQs + "&payload=" + payloadQs;
                            return [
                                4 /*yield*/ ,
                                this._initializeRetryableHandshake({
                                    awsRealTimeUrl: awsRealTimeUrl
                                })
                            ];
                        case 3:
                            _c.sent();
                            this.promiseArray.forEach(function(_a) {
                                var res = _a.res;
                                $7791a9227f8587f3$var$logger("Notifying connection successful");
                                res();
                            });
                            this.socketStatus = $6c889d22fb2117d9$exports.SOCKET_STATUS.READY;
                            this.promiseArray = [];
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_2 = _c.sent();
                            this.promiseArray.forEach(function(_a) {
                                var rej = _a.rej;
                                return rej(err_2);
                            });
                            this.promiseArray = [];
                            if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN) this.awsRealTimeSocket.close(3001);
                            this.awsRealTimeSocket = null;
                            this.socketStatus = $6c889d22fb2117d9$exports.SOCKET_STATUS.CLOSED;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._awsRealTimeHeaderBasedAuth = function(_a) {
        var authenticationType = _a.authenticationType, payload = _a.payload, canonicalUri = _a.canonicalUri, appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, apiKey = _a.apiKey, region = _a.region, credentials = _a.credentials, token = _a.token, graphql_headers = _a.graphql_headers;
        return $7791a9227f8587f3$var$__awaiter(this, void 0, void 0, function() {
            var headerHandler, handler, host, result;
            return $7791a9227f8587f3$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        headerHandler = {
                            API_KEY: this._awsRealTimeApiKeyHeader.bind(this),
                            AWS_IAM: this._awsRealTimeIAMHeader.bind(this),
                            OPENID_CONNECT: this._awsRealTimeAuthorizationHeader.bind(this),
                            AMAZON_COGNITO_USER_POOLS: this._awsRealTimeAuthorizationHeader.bind(this),
                            AWS_LAMBDA: this._awsRealTimeAuthorizationHeader.bind(this)
                        };
                        handler = headerHandler[authenticationType];
                        if (typeof handler !== "function") {
                            $7791a9227f8587f3$var$logger("Authentication type " + authenticationType + " not supported");
                            return [
                                2 /*return*/ ,
                                {}
                            ];
                        }
                        host = $2qlBa.parse(appSyncGraphqlEndpoint).host;
                        return [
                            4 /*yield*/ ,
                            handler({
                                payload: payload,
                                canonicalUri: canonicalUri,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                apiKey: apiKey,
                                region: region,
                                host: host,
                                credentials: credentials,
                                token: token,
                                graphql_headers: graphql_headers
                            })
                        ];
                    case 1:
                        result = _b.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._awsRealTimeAuthorizationHeader = function(_a) {
        var host = _a.host, token = _a.token, graphql_headers = _a.graphql_headers;
        return $7791a9227f8587f3$var$__awaiter(this, void 0, void 0, function() {
            var _b, _c, _d;
            return $7791a9227f8587f3$var$__generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _b = {};
                        if (!(typeof token === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            token.call(undefined)
                        ];
                    case 1:
                        _c = _e.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            token
                        ];
                    case 3:
                        _c = _e.sent();
                        _e.label = 4;
                    case 4:
                        _d = [
                            (_b.Authorization = _c, _b.host = host, _b)
                        ];
                        return [
                            4 /*yield*/ ,
                            graphql_headers()
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            $7791a9227f8587f3$var$__assign.apply(void 0, _d.concat([
                                _e.sent()
                            ]))
                        ];
                }
            });
        });
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._awsRealTimeApiKeyHeader = function(_a) {
        var apiKey = _a.apiKey, host = _a.host, graphql_headers = _a.graphql_headers;
        return $7791a9227f8587f3$var$__awaiter(this, void 0, void 0, function() {
            var dt, dtStr, _b;
            return $7791a9227f8587f3$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        dt = new Date();
                        dtStr = dt.toISOString().replace(/[:\-]|\.\d{3}/g, "");
                        _b = [
                            {
                                host: host,
                                "x-amz-date": dtStr,
                                "x-api-key": apiKey
                            }
                        ];
                        return [
                            4 /*yield*/ ,
                            graphql_headers()
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            $7791a9227f8587f3$var$__assign.apply(void 0, _b.concat([
                                _c.sent()
                            ]))
                        ];
                }
            });
        });
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._awsRealTimeIAMHeader = function(_a) {
        var payload = _a.payload, canonicalUri = _a.canonicalUri, appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, region = _a.region, credentials = _a.credentials;
        return $7791a9227f8587f3$var$__awaiter(this, void 0, void 0, function() {
            var endpointInfo, creds, _b, accessKeyId, secretAccessKey, sessionToken, formattedCredentials, request, signed_params;
            return $7791a9227f8587f3$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        endpointInfo = {
                            region: region,
                            service: $7791a9227f8587f3$var$SERVICE
                        };
                        creds = typeof credentials === "function" ? credentials.call() : credentials || {};
                        if (!(creds && typeof creds.getPromise === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            creds.getPromise()
                        ];
                    case 1:
                        _c.sent();
                        _c.label = 2;
                    case 2:
                        if (!creds) throw new Error("No credentials");
                        return [
                            4 /*yield*/ ,
                            creds
                        ];
                    case 3:
                        _b = _c.sent(), accessKeyId = _b.accessKeyId, secretAccessKey = _b.secretAccessKey, sessionToken = _b.sessionToken;
                        formattedCredentials = {
                            access_key: accessKeyId,
                            secret_key: secretAccessKey,
                            session_token: sessionToken
                        };
                        request = {
                            url: "" + appSyncGraphqlEndpoint + canonicalUri,
                            body: payload,
                            method: "POST",
                            headers: $7791a9227f8587f3$var$__assign({}, $7791a9227f8587f3$var$APPSYNC_REALTIME_HEADERS)
                        };
                        signed_params = $336febb40790ed57$exports.Signer.sign(request, formattedCredentials, endpointInfo);
                        return [
                            2 /*return*/ ,
                            signed_params.headers
                        ];
                }
            });
        });
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._initializeRetryableHandshake = function(_a) {
        var awsRealTimeUrl = _a.awsRealTimeUrl;
        return $7791a9227f8587f3$var$__awaiter(this, void 0, void 0, function() {
            return $7791a9227f8587f3$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $7791a9227f8587f3$var$logger("Initializaling retryable Handshake");
                        return [
                            4 /*yield*/ ,
                            $eceb913e12f12f7a$exports.jitteredExponentialRetry(this._initializeHandshake.bind(this), [
                                {
                                    awsRealTimeUrl: awsRealTimeUrl
                                }
                            ])
                        ];
                    case 1:
                        _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._initializeHandshake = function(_a) {
        var awsRealTimeUrl = _a.awsRealTimeUrl;
        return $7791a9227f8587f3$var$__awaiter(this, void 0, void 0, function() {
            var err_3, errorType, errorCode;
            var _this = this;
            return $7791a9227f8587f3$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $7791a9227f8587f3$var$logger("Initializing handshake " + awsRealTimeUrl);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            function() {
                                return new Promise(function(res, rej) {
                                    var newSocket = AppSyncRealTimeSubscriptionHandshakeLink.createWebSocket(awsRealTimeUrl, "graphql-ws");
                                    newSocket.onerror = function() {
                                        $7791a9227f8587f3$var$logger("WebSocket connection error");
                                    };
                                    newSocket.onclose = function() {
                                        rej(new Error("Connection handshake error"));
                                    };
                                    newSocket.onopen = function() {
                                        _this.awsRealTimeSocket = newSocket;
                                        return res();
                                    };
                                });
                            }()
                        ];
                    case 2:
                        _b.sent();
                        // Step 2: wait for ack from AWS AppSyncReaTime after sending init
                        return [
                            4 /*yield*/ ,
                            function() {
                                return new Promise(function(res, rej) {
                                    var ackOk = false;
                                    _this.awsRealTimeSocket.onerror = function(error) {
                                        $7791a9227f8587f3$var$logger("WebSocket closed " + JSON.stringify(error));
                                    };
                                    _this.awsRealTimeSocket.onclose = function(event) {
                                        $7791a9227f8587f3$var$logger("WebSocket closed " + event.reason);
                                        rej(new Error(JSON.stringify(event)));
                                    };
                                    _this.awsRealTimeSocket.onmessage = function(message) {
                                        var _a;
                                        $7791a9227f8587f3$var$logger("subscription message from AWS AppSyncRealTime: " + message.data + " ");
                                        var data = JSON.parse(message.data);
                                        var type = data.type, _b = data.payload, _c = (_b === void 0 ? {} : _b).connectionTimeoutMs, connectionTimeoutMs = _c === void 0 ? $7791a9227f8587f3$var$DEFAULT_KEEP_ALIVE_TIMEOUT : _c;
                                        if (type === $6c889d22fb2117d9$exports.MESSAGE_TYPES.GQL_CONNECTION_ACK) {
                                            ackOk = true;
                                            _this.keepAliveTimeout = (_a = _this.keepAliveTimeout) !== null && _a !== void 0 ? _a : connectionTimeoutMs;
                                            _this.awsRealTimeSocket.onmessage = _this._handleIncomingSubscriptionMessage.bind(_this);
                                            _this.awsRealTimeSocket.onerror = function(err) {
                                                $7791a9227f8587f3$var$logger(err);
                                                _this._errorDisconnect($6c889d22fb2117d9$exports.CONTROL_MSG.CONNECTION_CLOSED);
                                            };
                                            _this.awsRealTimeSocket.onclose = function(event) {
                                                $7791a9227f8587f3$var$logger("WebSocket closed " + event.reason);
                                                _this._errorDisconnect($6c889d22fb2117d9$exports.CONTROL_MSG.CONNECTION_CLOSED);
                                            };
                                            res("Cool, connected to AWS AppSyncRealTime");
                                            return;
                                        }
                                        if (type === $6c889d22fb2117d9$exports.MESSAGE_TYPES.GQL_CONNECTION_ERROR) {
                                            var _d = data.payload, _e = (_d === void 0 ? {} : _d).errors, _f = (_e === void 0 ? [] : _e)[0], _g = _f === void 0 ? {} : _f, _h = _g.errorType, errorType = _h === void 0 ? "" : _h, _j = _g.errorCode, errorCode = _j === void 0 ? 0 : _j;
                                            rej({
                                                errorType: errorType,
                                                errorCode: errorCode
                                            });
                                        }
                                    };
                                    var gqlInit = {
                                        type: $6c889d22fb2117d9$exports.MESSAGE_TYPES.GQL_CONNECTION_INIT
                                    };
                                    _this.awsRealTimeSocket.send(JSON.stringify(gqlInit));
                                    function checkAckOk() {
                                        if (!ackOk) rej(new Error("Connection timeout: ack from AWSRealTime was not received on " + $7791a9227f8587f3$var$CONNECTION_INIT_TIMEOUT + " ms"));
                                    }
                                    setTimeout(checkAckOk.bind(_this), $7791a9227f8587f3$var$CONNECTION_INIT_TIMEOUT);
                                });
                            }()
                        ];
                    case 3:
                        // Step 2: wait for ack from AWS AppSyncReaTime after sending init
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        err_3 = _b.sent();
                        errorType = err_3.errorType, errorCode = err_3.errorCode;
                        if ($7791a9227f8587f3$var$NON_RETRYABLE_CODES.indexOf(errorCode) >= 0) throw new $eceb913e12f12f7a$exports.NonRetryableError(errorType);
                        else if (errorType) throw new Error(errorType);
                        else throw err_3;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._handleIncomingSubscriptionMessage = function(message) {
        $7791a9227f8587f3$var$logger("subscription message from AWS AppSync RealTime: " + message.data);
        var _a = JSON.parse(message.data), _b = _a.id, id = _b === void 0 ? "" : _b, payload = _a.payload, type = _a.type;
        var _c = this.subscriptionObserverMap.get(id) || {}, _d = _c.observer, observer = _d === void 0 ? null : _d, _e = _c.query, query = _e === void 0 ? "" : _e, _f = _c.variables, variables = _f === void 0 ? {} : _f, _g = _c.startAckTimeoutId, startAckTimeoutId = _g === void 0 ? 0 : _g, _h = _c.subscriptionReadyCallback, subscriptionReadyCallback = _h === void 0 ? null : _h, _j = _c.subscriptionFailedCallback, subscriptionFailedCallback = _j === void 0 ? null : _j;
        $7791a9227f8587f3$var$logger({
            id: id,
            observer: observer,
            query: query,
            variables: variables
        });
        if (type === $6c889d22fb2117d9$exports.MESSAGE_TYPES.GQL_DATA && payload && payload.data) {
            if (observer) observer.next(payload);
            else $7791a9227f8587f3$var$logger("observer not found for id: " + id);
            return;
        }
        if (type === $6c889d22fb2117d9$exports.MESSAGE_TYPES.GQL_START_ACK) {
            $7791a9227f8587f3$var$logger("subscription ready for " + JSON.stringify({
                query: query,
                variables: variables
            }));
            if (typeof subscriptionReadyCallback === "function") subscriptionReadyCallback();
            clearTimeout(startAckTimeoutId);
            if (observer) observer.next({
                data: payload,
                extensions: {
                    controlMsgType: "CONNECTED"
                }
            });
            else $7791a9227f8587f3$var$logger("observer not found for id: " + id);
            var subscriptionState = $6c889d22fb2117d9$exports.SUBSCRIPTION_STATUS.CONNECTED;
            this.subscriptionObserverMap.set(id, {
                observer: observer,
                query: query,
                variables: variables,
                startAckTimeoutId: null,
                subscriptionState: subscriptionState,
                subscriptionReadyCallback: subscriptionReadyCallback,
                subscriptionFailedCallback: subscriptionFailedCallback
            });
            return;
        }
        if (type === $6c889d22fb2117d9$exports.MESSAGE_TYPES.GQL_CONNECTION_KEEP_ALIVE) {
            clearTimeout(this.keepAliveTimeoutId);
            this.keepAliveTimeoutId = setTimeout(this._errorDisconnect.bind(this, $6c889d22fb2117d9$exports.CONTROL_MSG.TIMEOUT_DISCONNECT), this.keepAliveTimeout);
            return;
        }
        if (type === $6c889d22fb2117d9$exports.MESSAGE_TYPES.GQL_ERROR) {
            var subscriptionState = $6c889d22fb2117d9$exports.SUBSCRIPTION_STATUS.FAILED;
            this.subscriptionObserverMap.set(id, {
                observer: observer,
                query: query,
                variables: variables,
                startAckTimeoutId: startAckTimeoutId,
                subscriptionReadyCallback: subscriptionReadyCallback,
                subscriptionFailedCallback: subscriptionFailedCallback,
                subscriptionState: subscriptionState
            });
            clearTimeout(startAckTimeoutId);
            if (observer) {
                observer.error({
                    errors: [
                        $7791a9227f8587f3$var$__assign({}, new $1wSRS.GraphQLError("Connection failed: " + JSON.stringify(payload)))
                    ]
                });
                observer.complete();
            } else $7791a9227f8587f3$var$logger("observer not found for id: " + id);
            if (typeof subscriptionFailedCallback === "function") subscriptionFailedCallback();
        }
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._errorDisconnect = function(msg) {
        $7791a9227f8587f3$var$logger("Disconnect error: " + msg);
        this.subscriptionObserverMap.forEach(function(_a) {
            var observer = _a.observer;
            if (observer && !observer.closed) observer.error({
                errors: [
                    $7791a9227f8587f3$var$__assign({}, new $1wSRS.GraphQLError(msg))
                ]
            });
        });
        this.subscriptionObserverMap.clear();
        if (this.awsRealTimeSocket) this.awsRealTimeSocket.close();
        this.socketStatus = $6c889d22fb2117d9$exports.SOCKET_STATUS.CLOSED;
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._timeoutStartSubscriptionAck = function(subscriptionId) {
        var _a = this.subscriptionObserverMap.get(subscriptionId) || {}, observer = _a.observer, query = _a.query, variables = _a.variables;
        if (!observer) return;
        this.subscriptionObserverMap.set(subscriptionId, {
            observer: observer,
            query: query,
            variables: variables,
            subscriptionState: $6c889d22fb2117d9$exports.SUBSCRIPTION_STATUS.FAILED
        });
        if (observer && !observer.closed) {
            observer.error({
                errors: [
                    $7791a9227f8587f3$var$__assign({}, new $1wSRS.GraphQLError("Subscription timeout " + JSON.stringify({
                        query: query,
                        variables: variables
                    })))
                ]
            });
            // Cleanup will be automatically executed
            observer.complete();
        }
        $7791a9227f8587f3$var$logger("timeoutStartSubscription", JSON.stringify({
            query: query,
            variables: variables
        }));
    };
    AppSyncRealTimeSubscriptionHandshakeLink.createWebSocket = function(awsRealTimeUrl, protocol) {
        return new WebSocket(awsRealTimeUrl, protocol);
    };
    return AppSyncRealTimeSubscriptionHandshakeLink;
}($8MgJN.ApolloLink);
$7791a9227f8587f3$exports.AppSyncRealTimeSubscriptionHandshakeLink = $7791a9227f8587f3$var$AppSyncRealTimeSubscriptionHandshakeLink;


function $f102cb105c81b828$var$createSubscriptionHandshakeLink(infoOrUrl, theResultsFetcherLink) {
    var resultsFetcherLink, subscriptionLinks;
    if (typeof infoOrUrl === "string") {
        resultsFetcherLink = theResultsFetcherLink || $epBGJ.createHttpLink({
            uri: infoOrUrl
        });
        subscriptionLinks = $8MgJN.ApolloLink.from([
            new $37b13168f056e3b4$exports.NonTerminatingLink("controlMessages", {
                link: new $8MgJN.ApolloLink(function(operation, _forward) {
                    return new $9uTW6.default(function(observer) {
                        var _a;
                        var _b = operation, _c = _b.variables, _d = $74a8a792cabd7b79$exports.CONTROL_EVENTS_KEY, controlEvents = _c[_d], variables = $f102cb105c81b828$var$__rest(_c, [
                            typeof _d === "symbol" ? _d : _d + ""
                        ]);
                        if (typeof controlEvents !== "undefined") operation.variables = variables;
                        observer.next((_a = {}, _a[$74a8a792cabd7b79$exports.CONTROL_EVENTS_KEY] = controlEvents, _a));
                        return function() {};
                    });
                })
            }),
            new $37b13168f056e3b4$exports.NonTerminatingLink("subsInfo", {
                link: resultsFetcherLink
            }),
            new $74a8a792cabd7b79$exports.SubscriptionHandshakeLink("subsInfo")
        ]);
    } else {
        var url = infoOrUrl.url;
        resultsFetcherLink = theResultsFetcherLink || $epBGJ.createHttpLink({
            uri: url
        });
        subscriptionLinks = new $7791a9227f8587f3$exports.AppSyncRealTimeSubscriptionHandshakeLink(infoOrUrl);
    }
    return $8MgJN.ApolloLink.split(function(operation) {
        var query = operation.query;
        var _a = $8gQB0.getMainDefinition(query), kind = _a.kind, graphqlOperation = _a.operation;
        var isSubscription = kind === "OperationDefinition" && graphqlOperation === "subscription";
        return isSubscription;
    }, subscriptionLinks, resultsFetcherLink);
}
$f102cb105c81b828$exports.createSubscriptionHandshakeLink = $f102cb105c81b828$var$createSubscriptionHandshakeLink;


const $ba4a4c947a7bf0de$export$61087a22b18fbdb6 = {
    Auth: {
        region: "eu-west-1",
        identityPoolId: "eu-west-1:b18031a9-3612-4ec9-906e-ae477c9e3834",
        userPoolId: "eu-west-1_JkyWOt3v9",
        userPoolWebClientId: "3a6g74us8452id6dgls78rdpkk",
        mandatorySignIn: false,
        cookieStorage: {
            domain: "mcp.b2b.lego.com",
            secure: false,
            expires: 7
        },
        oauth: {
            domain: "auth.mcp.b2b.lego.com",
            scope: [
                'email',
                'profile',
                'openid'
            ],
            redirectSignIn: "https://survey.mcp.b2b.lego.com/",
            redirectSignOut: "https://survey.mcp.b2b.lego.com/",
            responseType: 'code'
        }
    },
    Storage: {
        AWSS3: {
            bucket: "prod-mcp-upload-bucket",
            region: "eu-west-1",
            level: 'public'
        }
    }
};



var $4zZNZ = parcelRequire("4zZNZ");
parcelRequire("dntWt");
var $fHgS9 = parcelRequire("fHgS9");
var $gAOhP = parcelRequire("gAOhP");
(0, $3XIEi.default).configure((0, $ba4a4c947a7bf0de$export$61087a22b18fbdb6));
const $99e29de9a13be7ff$var$appSyncLinkConfig = {
    url: "https://3t3czji6fnhvvpbebm5c4nmok4.appsync-api.eu-west-1.amazonaws.com/graphql",
    region: "eu-west-1",
    auth: {
        type: 'AWS_IAM',
        credentials: async ()=>{
            try {
                const credentials = await (0, $bzHnt.Auth).currentCredentials();
                return credentials;
            } catch (error) {
                (0, $4zZNZ.logger).logError(error);
            }
        }
    },
    disableOffline: true
};
const $99e29de9a13be7ff$var$errorLink = (0, $edbdc4c5b34e0180$export$2288787135a8f66e)(({ graphQLErrors: graphQLErrors, networkError: networkError })=>{
    if (graphQLErrors) {
        const currentTransaction = (0, $6tz0u.apmBase)?.getCurrentTransaction();
        graphQLErrors.forEach((graphQLError)=>{
            (0, $6tz0u.apmBase)?.captureError(graphQLError);
        });
        const filteredGraphQLErrors = graphQLErrors.filter((error)=>error?.extensions?.code !== 'VALIDATION_ERROR');
        if (filteredGraphQLErrors.length > 0) {
            const uniqueMessages = [
                ...new Set(filteredGraphQLErrors.map(({ message: message })=>message))
            ];
            let errorMessage = `${uniqueMessages.join('\n')}`;
            errorMessage += `\nTime: ${new Date().toLocaleString()}`;
            errorMessage += `\nID: ${currentTransaction?.id ?? 'Unknown'}`;
            (0, $fHgS9.addSnackbar)({
                header: 'Something went wrong',
                text: errorMessage,
                type: (0, $gAOhP.snackbarTypes).ERROR
            });
        }
        if (networkError) (0, $fHgS9.addSnackbar)({
            header: 'Network error',
            text: `${networkError.name}: ${networkError.message}`,
            type: (0, $gAOhP.snackbarTypes).ERROR
        });
    }
});
const $99e29de9a13be7ff$var$loggerLink = new (0, $8MgJN.ApolloLink)((operation, forward)=>{
    const currentTransaction = (0, $6tz0u.apmBase)?.getCurrentTransaction();
    const span = currentTransaction?.startSpan(`Call ${operation.operationName}`, 'graphql', {
        blocking: true,
        sync: false
    });
    // Add the request payload and name the context for debugging purpose
    (0, $6tz0u.apmBase)?.setCustomContext({
        operation: operation.operationName,
        variables: operation.variables
    });
    return forward(operation).map((data)=>{
        span?.end();
        return data;
    });
});
const $99e29de9a13be7ff$var$httpLink = new (0, $laC1A.HttpLink)({
    uri: "https://3t3czji6fnhvvpbebm5c4nmok4.appsync-api.eu-west-1.amazonaws.com/graphql"
});
// from https://github.com/awslabs/aws-mobile-appsync-sdk-js#using-authorization-and-subscription-links-with-apollo-client-no-offline-support
const $99e29de9a13be7ff$var$client = new (0, $fbze5.ApolloClient)({
    link: (0, $8MgJN.ApolloLink).from([
        $99e29de9a13be7ff$var$loggerLink,
        $99e29de9a13be7ff$var$errorLink,
        (0, $1410b8b3ffbaa4c0$exports.createAuthLink)($99e29de9a13be7ff$var$appSyncLinkConfig),
        (0, $f102cb105c81b828$exports.createSubscriptionHandshakeLink)($99e29de9a13be7ff$var$appSyncLinkConfig, $99e29de9a13be7ff$var$httpLink)
    ]),
    cache: new (0, $coVSr.InMemoryCache)()
});
const $99e29de9a13be7ff$export$8e363dbef886ff17 = ({ children: children })=>/*#__PURE__*/ (0, $df8fE.jsx)((0, $6I6uN.ApolloProvider), {
        client: $99e29de9a13be7ff$var$client,
        children: children
    });
$99e29de9a13be7ff$export$8e363dbef886ff17.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).node.isRequired
};


parcelRequire("i7Pqi");
var $bnWnl = parcelRequire("bnWnl");

var $fUUwV = parcelRequire("fUUwV");

var $dSPjH = parcelRequire("dSPjH");

var $cRlsu = parcelRequire("cRlsu");

var $5wEm6 = parcelRequire("5wEm6");

var $4zZNZ = parcelRequire("4zZNZ");

var $df8fE = parcelRequire("df8fE");

var $1lyZZ = parcelRequire("1lyZZ");
parcelRequire("1OfTO");
var $8JWbY = parcelRequire("8JWbY");
var $jahGf = parcelRequire("jahGf");
var $4AJXw = parcelRequire("4AJXw");
var $cbxDY = parcelRequire("cbxDY");

var $jUVGJ = parcelRequire("jUVGJ");
parcelRequire("i7Pqi");
var $gdpIa = parcelRequire("gdpIa");
const $67747e6dcc34e3a1$var$containerStyle = (0, $1lyZZ.css)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'red',
    background: `linear-gradient(${(0, $8JWbY.colors).boldColors.darkBlue.darkBlue80}, ${(0, $8JWbY.colors).boldColors.darkBlue.base})`,
    color: (0, $8JWbY.colors).neutralColors.white,
    textAlign: 'center',
    paddingBottom: 120,
    height: '100vh'
});
const $67747e6dcc34e3a1$var$imageWrapperStyle = (0, $1lyZZ.css)({
    display: 'flex',
    alignItems: 'flex-end',
    marginTop: 40,
    width: 200,
    [(0, $4AJXw.media).medium]: {
        marginTop: 80,
        width: 'auto'
    }
});
const $67747e6dcc34e3a1$var$svgStyle = (0, $1lyZZ.css)({
    width: '100%',
    height: 'auto'
});
const $67747e6dcc34e3a1$var$svgWrapperLeftStyle = (0, $1lyZZ.css)({
    width: 120,
    marginRight: (0, $cbxDY.spacing).size5,
    '& > img': {
        transform: 'matrix(-1, 0, 0, 1, 0, 0);'
    }
});
const $67747e6dcc34e3a1$var$svgWrapperRightStyle = (0, $1lyZZ.css)({
    width: 220
});
const $67747e6dcc34e3a1$var$headerStyle = (0, $1lyZZ.css)({
    fontWeight: (0, $jahGf.font).weight.medium,
    marginBottom: (0, $cbxDY.spacing).size7,
    marginTop: (0, $cbxDY.spacing).size12,
    fontSize: (0, $jahGf.font).size.size3,
    lineHeight: (0, $jahGf.font).lineHeight.s,
    padding: `0 ${(0, $cbxDY.spacing).size4}px`,
    [(0, $4AJXw.media).medium]: {
        fontSize: (0, $jahGf.font).size.size5
    }
});
const $67747e6dcc34e3a1$var$bodyTextStyle = (0, $1lyZZ.css)({
    maxWidth: 500,
    lineHeight: (0, $jahGf.font).lineHeight.m,
    padding: `0 ${(0, $cbxDY.spacing).size4}px`
});
const $67747e6dcc34e3a1$var$backButtonStyle = {
    marginTop: (0, $cbxDY.spacing).size4,
    color: (0, $8JWbY.colors).neutralColors.white,
    borderColor: (0, $8JWbY.colors).neutralColors.white
};
const $67747e6dcc34e3a1$export$facdbaea6c4a5d4e = ()=>/*#__PURE__*/ (0, $df8fE.jsx)("div", {
        children: /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
            css: $67747e6dcc34e3a1$var$containerStyle,
            children: [
                /*#__PURE__*/ (0, $df8fE.jsxs)("div", {
                    css: $67747e6dcc34e3a1$var$imageWrapperStyle,
                    children: [
                        /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                            css: $67747e6dcc34e3a1$var$svgWrapperLeftStyle,
                            children: /*#__PURE__*/ (0, $df8fE.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($jUVGJ))),
                                css: $67747e6dcc34e3a1$var$svgStyle
                            })
                        }),
                        /*#__PURE__*/ (0, $df8fE.jsx)("div", {
                            css: $67747e6dcc34e3a1$var$svgWrapperRightStyle,
                            children: /*#__PURE__*/ (0, $df8fE.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($jUVGJ))),
                                css: $67747e6dcc34e3a1$var$svgStyle
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $df8fE.jsx)("h1", {
                    css: $67747e6dcc34e3a1$var$headerStyle,
                    children: "Something went wrong"
                }),
                /*#__PURE__*/ (0, $df8fE.jsxs)("p", {
                    css: $67747e6dcc34e3a1$var$bodyTextStyle,
                    children: [
                        "The error has already been picked up by our monitoring service and we will fix the issue as soon as possible. ",
                        /*#__PURE__*/ (0, $df8fE.jsx)("br", {}),
                        " Please try again later."
                    ]
                }),
                /*#__PURE__*/ (0, $df8fE.jsx)((0, $gdpIa.Button), {
                    "data-transaction-name": "Go back",
                    onClick: ()=>window.history.go(-1),
                    label: "Go Back",
                    variant: "outline",
                    style: $67747e6dcc34e3a1$var$backButtonStyle
                })
            ]
        })
    });


parcelRequire("dntWt");
var $g92G0 = parcelRequire("g92G0");

var $93HRk = parcelRequire("93HRk");



var $df8fE = parcelRequire("df8fE");

var $a5EUy = parcelRequire("a5EUy");
function $8a968207a9cc8767$var$f() {
    return `usersnapCallback_${Math.random().toString().slice(2)}`;
}
function $8a968207a9cc8767$var$c(e, a, t) {
    return new Promise((n)=>{
        const o = $8a968207a9cc8767$var$f();
        if (e) {
            const d = t ? `&n=${t}` : "", w = `//widget.usersnap.com/${a}/load/${e}?onload=${o}${d}`;
            if (!window[o]) {
                window[o] = (l)=>(delete window[o], n(l));
                const r = document.createElement("script");
                r.defer = !0, r.nonce = t, r.onerror = ()=>{
                    throw new Error("Wrong api key or paused project");
                }, r.src = w, document.head.appendChild(r);
            }
        }
    });
}
const $8a968207a9cc8767$var$s = /* @__PURE__ */ new Map(), $8a968207a9cc8767$var$i = /* @__PURE__ */ new Map(), $8a968207a9cc8767$export$f7ac662e3dcd60ac = async (e, a)=>{
    if (!e) throw new Error("Missing api key");
    $8a968207a9cc8767$var$s.has(e) || $8a968207a9cc8767$var$s.set(e, $8a968207a9cc8767$var$c(e, "global", a));
    const t = await $8a968207a9cc8767$var$s.get(e);
    return {
        init: async (n)=>{
            await t.init(n);
        },
        logEvent: async (n)=>{
            await t.logEvent(n);
        },
        show: async (n)=>await t.show(n),
        hide: async (n)=>{
            await t.hide(n);
        },
        destroy: async ()=>{
            await t.destroy();
        },
        on: (n, o)=>{
            t.on(n, o);
        },
        off: (n, o)=>{
            t.off(n, o);
        }
    };
}, $8a968207a9cc8767$export$e699215886058999 = async (e, a)=>{
    if (!e) throw new Error("Missing api key");
    $8a968207a9cc8767$var$i.has(e) || $8a968207a9cc8767$var$i.set(e, $8a968207a9cc8767$var$c(e, "embed", a));
    const t = await $8a968207a9cc8767$var$i.get(e);
    return {
        init: async (n)=>{
            await t.init(n);
        },
        on: (n, o)=>{
            t.on(n, o);
        },
        off: (n, o)=>{
            t.off(n, o);
        }
    };
};



var $3yJBl = parcelRequire("3yJBl");

var $dSPjH = parcelRequire("dSPjH");
const $2f0dbbcbc1f3147d$var$USERSNAP_GLOBAL_API_KEY = "5157cfdb-7c51-4dfc-ad64-2edceffb08bd" ?? '';
const $2f0dbbcbc1f3147d$var$USERSNAP_LT_CONTACT_API_KEY = "a043b853-d932-4a21-824f-8eccde7b2a6c" ?? '';
const $2f0dbbcbc1f3147d$export$28b248b721cb7b23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a5EUy))).createContext(null);
const $2f0dbbcbc1f3147d$var$enrichInitParams = (initParams, locale, customerId, email)=>{
    return {
        ...initParams,
        locale: locale,
        customerId: customerId,
        email: email,
        visitor: email
    };
};
const $2f0dbbcbc1f3147d$var$doesHaveValidContact = (isLoggedIn, selectedCustomer)=>isLoggedIn && selectedCustomer?.legoContactEmail != '';
const $2f0dbbcbc1f3147d$export$472eaa5d961027f3 = ({ initParams: initParams, children: children })=>{
    const [usersnapApi, setUsersnapApi] = (0, $a5EUy.useState)(null);
    const { cognitoData: cognitoData, isLoggedIn: isLoggedIn, selectedCustomer: selectedCustomer } = (0, $dSPjH.useUser)();
    const hasValidContact = $2f0dbbcbc1f3147d$var$doesHaveValidContact(isLoggedIn, selectedCustomer);
    const { id: customerId, legoContactEmail: legoContactEmail } = selectedCustomer ?? {};
    let locale, email;
    if (isLoggedIn && cognitoData) {
        const payload = cognitoData?.signInUserSession?.idToken?.payload;
        locale = payload['locale']?.toLowerCase();
        email = payload['email'];
    }
    (0, $a5EUy.useEffect)(()=>{
        (0, $8a968207a9cc8767$export$f7ac662e3dcd60ac)($2f0dbbcbc1f3147d$var$USERSNAP_GLOBAL_API_KEY).then((api)=>{
            api.init($2f0dbbcbc1f3147d$var$enrichInitParams(initParams, locale, customerId, email));
            if (hasValidContact) api.show($2f0dbbcbc1f3147d$var$USERSNAP_LT_CONTACT_API_KEY);
            const handleWidgetBeforeSubmit = (event)=>{
                if (hasValidContact) event.api.setValue('custom', {
                    legoContactEmail: legoContactEmail
                });
            };
            api.on('beforeSubmit', handleWidgetBeforeSubmit);
            setUsersnapApi(api);
        });
    }, [
        hasValidContact,
        initParams,
        locale,
        email,
        customerId,
        legoContactEmail
    ]);
    return /*#__PURE__*/ (0, $df8fE.jsx)($2f0dbbcbc1f3147d$export$28b248b721cb7b23.Provider, {
        value: usersnapApi,
        children: children
    });
};
function $2f0dbbcbc1f3147d$export$52a275d2f63a445a() {
    return (0, $a5EUy.useContext)($2f0dbbcbc1f3147d$export$28b248b721cb7b23);
}
$2f0dbbcbc1f3147d$export$472eaa5d961027f3.propTypes = {
    initParams: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($3yJBl))).node
};


const $ab3202b2ecf956e3$export$86fbec116b87613f = ()=>{
    (0, $a5EUy.useEffect)(()=>{
        // Init error logging to Elastic APM
        (0, $4zZNZ.logger).init();
    }, []);
    return /*#__PURE__*/ (0, $df8fE.jsx)((0, $99e29de9a13be7ff$export$8e363dbef886ff17), {
        children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $bnWnl.KlikContextProvider), {
            children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $93HRk.ErrorBoundary), {
                fallback: /*#__PURE__*/ (0, $df8fE.jsx)((0, $67747e6dcc34e3a1$export$facdbaea6c4a5d4e), {}),
                children: /*#__PURE__*/ (0, $df8fE.jsxs)((0, $dSPjH.UserProvider), {
                    children: [
                        /*#__PURE__*/ (0, $df8fE.jsx)((0, $fUUwV.ToastContainer), {
                            ...(0, $g92G0.snackbarConfig)
                        }),
                        /*#__PURE__*/ (0, $df8fE.jsx)((0, $cRlsu.LabelsProvider), {
                            children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $2f0dbbcbc1f3147d$export$472eaa5d961027f3), {
                                children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $BeyzD.BrowserRouter), {
                                    children: /*#__PURE__*/ (0, $df8fE.jsx)((0, $5wEm6.RouteHandler), {})
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};


(0, $jUibk.render)(/*#__PURE__*/ (0, $df8fE.jsx)((0, $ab3202b2ecf956e3$export$86fbec116b87613f), {}), document.getElementById('root'));


//# sourceMappingURL=public.d192588d.js.map
